
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});


parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("9RYKL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});

parcelRegister("bilNr", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $839248794b2aa02f$export$2b8d127b894957b9, (v) => $839248794b2aa02f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $839248794b2aa02f$export$cea3a54a6425200c, (v) => $839248794b2aa02f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $839248794b2aa02f$export$a7c73072b1a182ae, (v) => $839248794b2aa02f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $839248794b2aa02f$export$9f27bc3417b4524d, (v) => $839248794b2aa02f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $839248794b2aa02f$export$db77ccec0bb4ccac, (v) => $839248794b2aa02f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $839248794b2aa02f$export$8392c0c9d3dcbd35, (v) => $839248794b2aa02f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $839248794b2aa02f$export$ffb0004e005737fa, (v) => $839248794b2aa02f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $839248794b2aa02f$export$b624eff549462981, (v) => $839248794b2aa02f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $839248794b2aa02f$export$7897aa7841a5380c, (v) => $839248794b2aa02f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $839248794b2aa02f$export$602eac185826482c, (v) => $839248794b2aa02f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $839248794b2aa02f$export$e2c29f18771995cb, (v) => $839248794b2aa02f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $839248794b2aa02f$export$5f8d39834fd61797, (v) => $839248794b2aa02f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $839248794b2aa02f$export$74bf444e3cd11ea5, (v) => $839248794b2aa02f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $839248794b2aa02f$export$92387174baf9b227, (v) => $839248794b2aa02f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $839248794b2aa02f$export$ec112efeb987d9c6, (v) => $839248794b2aa02f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $839248794b2aa02f$export$b706b080d889d2c9, (v) => $839248794b2aa02f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $839248794b2aa02f$export$5be5a87408f70ddc, (v) => $839248794b2aa02f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $839248794b2aa02f$export$45a5e7f76e0caa8d, (v) => $839248794b2aa02f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $839248794b2aa02f$export$455c2e768291efa6, (v) => $839248794b2aa02f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $839248794b2aa02f$export$9522e17588c12572, (v) => $839248794b2aa02f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $839248794b2aa02f$export$2110ac352bb060b9, (v) => $839248794b2aa02f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $839248794b2aa02f$export$56885ab8b9c456ab, (v) => $839248794b2aa02f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $839248794b2aa02f$export$d927fcb6adf8f9de, (v) => $839248794b2aa02f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $839248794b2aa02f$export$b82d16f27459e05a, (v) => $839248794b2aa02f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $839248794b2aa02f$export$522c17b4f5e123e8, (v) => $839248794b2aa02f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $839248794b2aa02f$export$1aabd8a0274ecfd6, (v) => $839248794b2aa02f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $839248794b2aa02f$export$9b621391a187a31a, (v) => $839248794b2aa02f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $839248794b2aa02f$export$f5bbd400c2f4426f, (v) => $839248794b2aa02f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839248794b2aa02f$export$2b8d127b894957b9;
var $839248794b2aa02f$export$cea3a54a6425200c;
var $839248794b2aa02f$export$a7c73072b1a182ae;
var $839248794b2aa02f$export$9f27bc3417b4524d;
var $839248794b2aa02f$export$db77ccec0bb4ccac;
var $839248794b2aa02f$export$8392c0c9d3dcbd35;
var $839248794b2aa02f$export$ffb0004e005737fa;
var $839248794b2aa02f$export$b624eff549462981;
var $839248794b2aa02f$export$7897aa7841a5380c;
var $839248794b2aa02f$export$602eac185826482c;
var $839248794b2aa02f$export$e2c29f18771995cb;
var $839248794b2aa02f$export$5f8d39834fd61797;
var $839248794b2aa02f$export$74bf444e3cd11ea5;
var $839248794b2aa02f$export$92387174baf9b227;
var $839248794b2aa02f$export$ec112efeb987d9c6;
var $839248794b2aa02f$export$b706b080d889d2c9;
var $839248794b2aa02f$export$5be5a87408f70ddc;
var $839248794b2aa02f$export$45a5e7f76e0caa8d;
var $839248794b2aa02f$export$455c2e768291efa6;
var $839248794b2aa02f$export$9522e17588c12572;
var $839248794b2aa02f$export$2110ac352bb060b9;
var $839248794b2aa02f$export$56885ab8b9c456ab;
var $839248794b2aa02f$export$d927fcb6adf8f9de;
var $839248794b2aa02f$export$b82d16f27459e05a;
var $839248794b2aa02f$export$522c17b4f5e123e8;
var $839248794b2aa02f$export$1aabd8a0274ecfd6;
var $839248794b2aa02f$export$9b621391a187a31a;
var $839248794b2aa02f$export$f5bbd400c2f4426f;
'use strict';
var $839248794b2aa02f$var$b = "function" === typeof Symbol && Symbol.for, $839248794b2aa02f$var$c = $839248794b2aa02f$var$b ? Symbol.for("react.element") : 60103, $839248794b2aa02f$var$d = $839248794b2aa02f$var$b ? Symbol.for("react.portal") : 60106, $839248794b2aa02f$var$e = $839248794b2aa02f$var$b ? Symbol.for("react.fragment") : 60107, $839248794b2aa02f$var$f = $839248794b2aa02f$var$b ? Symbol.for("react.strict_mode") : 60108, $839248794b2aa02f$var$g = $839248794b2aa02f$var$b ? Symbol.for("react.profiler") : 60114, $839248794b2aa02f$var$h = $839248794b2aa02f$var$b ? Symbol.for("react.provider") : 60109, $839248794b2aa02f$var$k = $839248794b2aa02f$var$b ? Symbol.for("react.context") : 60110, $839248794b2aa02f$var$l = $839248794b2aa02f$var$b ? Symbol.for("react.async_mode") : 60111, $839248794b2aa02f$var$m = $839248794b2aa02f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $839248794b2aa02f$var$n = $839248794b2aa02f$var$b ? Symbol.for("react.forward_ref") : 60112, $839248794b2aa02f$var$p = $839248794b2aa02f$var$b ? Symbol.for("react.suspense") : 60113, $839248794b2aa02f$var$q = $839248794b2aa02f$var$b ? Symbol.for("react.suspense_list") : 60120, $839248794b2aa02f$var$r = $839248794b2aa02f$var$b ? Symbol.for("react.memo") : 60115, $839248794b2aa02f$var$t = $839248794b2aa02f$var$b ? Symbol.for("react.lazy") : 60116, $839248794b2aa02f$var$v = $839248794b2aa02f$var$b ? Symbol.for("react.block") : 60121, $839248794b2aa02f$var$w = $839248794b2aa02f$var$b ? Symbol.for("react.fundamental") : 60117, $839248794b2aa02f$var$x = $839248794b2aa02f$var$b ? Symbol.for("react.responder") : 60118, $839248794b2aa02f$var$y = $839248794b2aa02f$var$b ? Symbol.for("react.scope") : 60119;
function $839248794b2aa02f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $839248794b2aa02f$var$c:
                switch(a = a.type, a){
                    case $839248794b2aa02f$var$l:
                    case $839248794b2aa02f$var$m:
                    case $839248794b2aa02f$var$e:
                    case $839248794b2aa02f$var$g:
                    case $839248794b2aa02f$var$f:
                    case $839248794b2aa02f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $839248794b2aa02f$var$k:
                            case $839248794b2aa02f$var$n:
                            case $839248794b2aa02f$var$t:
                            case $839248794b2aa02f$var$r:
                            case $839248794b2aa02f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $839248794b2aa02f$var$d:
                return u;
        }
    }
}
function $839248794b2aa02f$var$A(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$m;
}
$839248794b2aa02f$export$2b8d127b894957b9 = $839248794b2aa02f$var$l;
$839248794b2aa02f$export$cea3a54a6425200c = $839248794b2aa02f$var$m;
$839248794b2aa02f$export$a7c73072b1a182ae = $839248794b2aa02f$var$k;
$839248794b2aa02f$export$9f27bc3417b4524d = $839248794b2aa02f$var$h;
$839248794b2aa02f$export$db77ccec0bb4ccac = $839248794b2aa02f$var$c;
$839248794b2aa02f$export$8392c0c9d3dcbd35 = $839248794b2aa02f$var$n;
$839248794b2aa02f$export$ffb0004e005737fa = $839248794b2aa02f$var$e;
$839248794b2aa02f$export$b624eff549462981 = $839248794b2aa02f$var$t;
$839248794b2aa02f$export$7897aa7841a5380c = $839248794b2aa02f$var$r;
$839248794b2aa02f$export$602eac185826482c = $839248794b2aa02f$var$d;
$839248794b2aa02f$export$e2c29f18771995cb = $839248794b2aa02f$var$g;
$839248794b2aa02f$export$5f8d39834fd61797 = $839248794b2aa02f$var$f;
$839248794b2aa02f$export$74bf444e3cd11ea5 = $839248794b2aa02f$var$p;
$839248794b2aa02f$export$92387174baf9b227 = function(a) {
    return $839248794b2aa02f$var$A(a) || $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$l;
};
$839248794b2aa02f$export$ec112efeb987d9c6 = $839248794b2aa02f$var$A;
$839248794b2aa02f$export$b706b080d889d2c9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$k;
};
$839248794b2aa02f$export$5be5a87408f70ddc = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$h;
};
$839248794b2aa02f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $839248794b2aa02f$var$c;
};
$839248794b2aa02f$export$455c2e768291efa6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$n;
};
$839248794b2aa02f$export$9522e17588c12572 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$e;
};
$839248794b2aa02f$export$2110ac352bb060b9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$t;
};
$839248794b2aa02f$export$56885ab8b9c456ab = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$r;
};
$839248794b2aa02f$export$d927fcb6adf8f9de = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$d;
};
$839248794b2aa02f$export$b82d16f27459e05a = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$g;
};
$839248794b2aa02f$export$522c17b4f5e123e8 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$f;
};
$839248794b2aa02f$export$1aabd8a0274ecfd6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$p;
};
$839248794b2aa02f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $839248794b2aa02f$var$e || a === $839248794b2aa02f$var$m || a === $839248794b2aa02f$var$g || a === $839248794b2aa02f$var$f || a === $839248794b2aa02f$var$p || a === $839248794b2aa02f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $839248794b2aa02f$var$t || a.$$typeof === $839248794b2aa02f$var$r || a.$$typeof === $839248794b2aa02f$var$h || a.$$typeof === $839248794b2aa02f$var$k || a.$$typeof === $839248794b2aa02f$var$n || a.$$typeof === $839248794b2aa02f$var$w || a.$$typeof === $839248794b2aa02f$var$x || a.$$typeof === $839248794b2aa02f$var$y || a.$$typeof === $839248794b2aa02f$var$v);
};
$839248794b2aa02f$export$f5bbd400c2f4426f = $839248794b2aa02f$var$z;

});

parcelRegister("j32pS", function(module, exports) {
"use strict";
var $dde02bf91ba833f9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dde02bf91ba833f9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dde02bf91ba833f9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dde02bf91ba833f9$var$__createBinding(result, mod, k);
    }
    $dde02bf91ba833f9$var$__setModuleDefault(result, mod);
    return result;
};
var $dde02bf91ba833f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $dde02bf91ba833f9$var$amplitude = $dde02bf91ba833f9$var$__importStar((parcelRequire("dOups")));

var $6enPC = parcelRequire("6enPC");

const $dde02bf91ba833f9$var$uniqid_1 = $dde02bf91ba833f9$var$__importDefault((parcelRequire("gg3vl")));

var $2xAZO = parcelRequire("2xAZO");

var $aGgam = parcelRequire("aGgam");

const $dde02bf91ba833f9$var$get_is_bot_1 = $dde02bf91ba833f9$var$__importDefault((parcelRequire("2HqcI")));

var $jf6Ag = parcelRequire("jf6Ag");

var $itFsv = parcelRequire("itFsv");

const $dde02bf91ba833f9$var$get_proxy_url_1 = $dde02bf91ba833f9$var$__importDefault((parcelRequire("fnYpu")));

const $dde02bf91ba833f9$var$storage_1 = $dde02bf91ba833f9$var$__importDefault((parcelRequire("855hF")));
const $dde02bf91ba833f9$var$literal = (str)=>str;
const $dde02bf91ba833f9$var$CLICK = $dde02bf91ba833f9$var$literal('Click');
const $dde02bf91ba833f9$var$CUMULATIVE_LAYOUT_SHIFT = $dde02bf91ba833f9$var$literal('Cumulative Layout Shift');
const $dde02bf91ba833f9$var$ERROR = $dde02bf91ba833f9$var$literal('Error');
const $dde02bf91ba833f9$var$INTERACTION_TO_NEXT_PAINT = $dde02bf91ba833f9$var$literal('Interaction to Next Paint');
const $dde02bf91ba833f9$var$LARGEST_CONTENTFUL_PAINT = $dde02bf91ba833f9$var$literal('Largest Contentful Paint');
const $dde02bf91ba833f9$var$MEDIA_ENDED = $dde02bf91ba833f9$var$literal('Media Ended');
const $dde02bf91ba833f9$var$MEDIA_PAUSE = $dde02bf91ba833f9$var$literal('Media Pause');
const $dde02bf91ba833f9$var$MEDIA_LOAD_START = $dde02bf91ba833f9$var$literal('Media Load Start');
const $dde02bf91ba833f9$var$MEDIA_PLAY = $dde02bf91ba833f9$var$literal('Media Play');
const $dde02bf91ba833f9$var$MEDIA_SEEKED = $dde02bf91ba833f9$var$literal('Media Seeked');
const $dde02bf91ba833f9$var$PAGE_HIDE = $dde02bf91ba833f9$var$literal('Page Hide');
const $dde02bf91ba833f9$var$PAGE_SHOW = $dde02bf91ba833f9$var$literal('Page Show');
const $dde02bf91ba833f9$var$PAGE_VIEW = $dde02bf91ba833f9$var$literal('Page View');
const $dde02bf91ba833f9$var$PAGE_VIEW_REPLACE = $dde02bf91ba833f9$var$literal('Page View Replace');
function $dde02bf91ba833f9$var$track(_event, _options) {
// This will be implemented in the Amplitude class
}
const $dde02bf91ba833f9$var$debounce = (func, timeout)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>func(...args), timeout);
    };
};
const $dde02bf91ba833f9$var$memoizeToExecuteOnce = (func)=>{
    let hasRun = false;
    let result;
    return (...args)=>{
        if (hasRun) return result;
        hasRun = true;
        result = func(...args);
        return result;
    };
};
class $dde02bf91ba833f9$var$Amplitude {
    constructor({ apiKey: apiKey, defaultClickTracking: defaultClickTracking = false, internal: internal, locale: locale, anonymize: anonymize = true }){
        this.anonymize = false;
        this.defaultClickTracking = false;
        this.historyReplaceStateCalledInternally = false;
        this.initialized = false;
        this.internal = false;
        this.pageViewId = (0, $dde02bf91ba833f9$var$uniqid_1.default)();
        this.pageViewPercent = 0;
        this.pageVisible = true;
        this.queue = [];
        this.trackedCLS = false;
        this.trackedINP = false;
        this.trackedLCP = false;
        this.tracking = null;
        this.getOptionsMedia = (element)=>{
            return {
                'Media Autoplay': element.autoplay,
                'Media Duration': Math.round(element.duration),
                'Media Element': (element === null || element === void 0 ? void 0 : element.getAttribute('data-track')) || undefined,
                'Media Source': element.src || element.currentSrc,
                'Media Time': Math.round(element.currentTime)
            };
        };
        this.getOptionsPage = ()=>{
            var _a;
            const { hash: hash, hostname: hostname, href: href, origin: origin, pathname: pathname } = window.location;
            return {
                'Page Domain': hostname,
                'Page Hash': hash,
                'Page Locale': this.locale,
                'Page Location': origin + pathname,
                'Page Path': pathname,
                'Page Title': document.title,
                'Page URL': href,
                'Page View ID': this.pageViewId,
                'Screen Height': window.screen.height,
                'Screen Orientation': (_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type,
                'Screen Size': `${window.screen.width}x${window.screen.height}`,
                'Screen Width': window.screen.width,
                'Window Height': window.innerHeight,
                'Window Size': `${window.innerWidth}x${window.innerHeight}`,
                'Window Width': window.innerWidth
            };
        };
        this.getOptionsCampaign = $dde02bf91ba833f9$var$memoizeToExecuteOnce(()=>{
            const { pathname: pathname, hash: hash, search: search } = window.location;
            const searchParams = new URLSearchParams(search);
            const { attributes: attributes, search: searchAfter } = (0, $aGgam.getCampaignAttributes)(searchParams);
            let referrerDomain;
            let referrerLocation;
            let referrerPath;
            let referrerURL;
            try {
                if (!(0, $jf6Ag.getIsInIFrame)()) {
                    const { hostname: hostname, href: href, origin: origin, pathname: pathReferrer } = new URL(document.referrer);
                    referrerDomain = hostname;
                    referrerLocation = origin + pathReferrer;
                    referrerPath = pathReferrer;
                    referrerURL = href;
                }
            } catch  {
            // Do nothing
            }
            this.historyReplaceStateCalledInternally = true;
            window.history.replaceState({}, '', `${pathname}${searchAfter ? `?${searchAfter}` : ''}${hash ? hash : ''}`);
            this.historyReplaceStateCalledInternally = false;
            return {
                ...attributes,
                'Referrer Domain': referrerDomain,
                'Referrer Location': referrerLocation,
                'Referrer Path': referrerPath,
                'Referrer URL': referrerURL
            };
        });
        this.getOptionsUser = $dde02bf91ba833f9$var$memoizeToExecuteOnce(()=>{
            const browser = (0, $6enPC.detect)(window.navigator.userAgent);
            const campaign = this.getOptionsCampaign();
            return {
                ...campaign,
                'Browser Name': (browser === null || browser === void 0 ? void 0 : browser.name) ? browser.name : undefined,
                'Browser Version': (browser === null || browser === void 0 ? void 0 : browser.version) ? browser.version : undefined,
                Internal: this.internal ? true : undefined,
                'Moderna Library': undefined
            };
        });
        this.getPageViewedPercent = ()=>{
            const percentPrevious = this.pageViewPercent || 0;
            const scrollPosition = Math.max(window.scrollY, 0);
            const percentCurrent = Math.round((scrollPosition + window.innerHeight) / document.body.scrollHeight * 100);
            const percentCurrentBounded = Math.min(percentCurrent, 100);
            return percentCurrentBounded > percentPrevious ? percentCurrentBounded : percentPrevious;
        };
        this.handleVisibilityChange = ()=>{
            if (document.hidden && this.pageVisible) {
                this.pageVisible = false;
                this.track('Page Hide', {
                    'Page View Percent': this.getPageViewedPercent()
                });
            } else if (!this.pageVisible) {
                this.pageVisible = true;
                this.track('Page Show', {
                    'Page View Percent': this.getPageViewedPercent()
                });
            }
        };
        this.handleClick = (event)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            if (this.defaultClickTracking && event.target instanceof HTMLElement) {
                const target = event.target;
                const elementClickable = target === null || target === void 0 ? void 0 : target.closest('a, button');
                const elementAttributed = target === null || target === void 0 ? void 0 : target.closest('[data-track]');
                const elementShadow = target.shadowRoot ? (_a = target === null || target === void 0 ? void 0 : target.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a, button') : null;
                this.track('Click', {
                    'Click Element': (elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.getAttribute('data-track')) || undefined,
                    'Click Position': `${event.pageX}x${event.pageY}`,
                    'Click Text': ((_b = elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || ((_c = elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.getAttribute('aria-label')) === null || _c === void 0 ? void 0 : _c.trim()) || ((_d = elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.textContent) === null || _d === void 0 ? void 0 : _d.trim()) || ((_e = elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.getAttribute('aria-label')) === null || _e === void 0 ? void 0 : _e.trim()) || ((_f = elementShadow === null || elementShadow === void 0 ? void 0 : elementShadow.textContent) === null || _f === void 0 ? void 0 : _f.trim()) || ((_g = elementShadow === null || elementShadow === void 0 ? void 0 : elementShadow.getAttribute('aria-label')) === null || _g === void 0 ? void 0 : _g.trim()) || undefined,
                    'Click URL': (elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.getAttribute('href')) || undefined,
                    'Click X': event.pageX,
                    'Click Y': event.pageY
                });
            }
        };
        this.handleError = (event)=>{
            const error = event.error;
            const hasSource = (error === null || error === void 0 ? void 0 : error.filename) && (error === null || error === void 0 ? void 0 : error.lineno) && (error === null || error === void 0 ? void 0 : error.colno);
            this.track('Error', {
                'Error Message': error === null || error === void 0 ? void 0 : error.message,
                'Error Source': hasSource ? `${error === null || error === void 0 ? void 0 : error.filename} ${error === null || error === void 0 ? void 0 : error.lineno}:${error === null || error === void 0 ? void 0 : error.colno}` : undefined
            });
            return false;
        };
        this.handleHistoryChange = (method)=>{
            // Create a new unique Page View ID for each page view
            this.pageViewId = (0, $dde02bf91ba833f9$var$uniqid_1.default)();
            // Reset the page view percent
            this.pageViewPercent = 0;
            this.pageViewPercent = this.getPageViewedPercent();
            this.track('Page View', {
                'Page Load Method': method,
                'Page Load Type': 'Route Change'
            });
        };
        this.handleHistoryReplaceChange = ()=>{
            // Create a new unique Page View ID for each page view
            this.pageViewId = (0, $dde02bf91ba833f9$var$uniqid_1.default)();
            // Reset the page view percent
            this.pageViewPercent = 0;
            this.pageViewPercent = this.getPageViewedPercent();
            this.track('Page View Replace', {});
        };
        this.handleHistoryPopState = ()=>{
            return this.handleHistoryChange('Pop');
        };
        this.handleMediaLoadStart = (event)=>{
            this.track('Media Load Start', this.getOptionsMedia(event.target));
        };
        this.handleMediaPlay = (event)=>{
            this.track('Media Play', this.getOptionsMedia(event.target));
        };
        this.handleMediaPause = (event)=>{
            this.track('Media Pause', this.getOptionsMedia(event.target));
        };
        this.handleMediaSeeked = (event)=>{
            this.track('Media Seeked', this.getOptionsMedia(event.target));
        };
        this.handleMediaEnded = (event)=>{
            this.track('Media Ended', this.getOptionsMedia(event.target));
        };
        this.handleScroll = $dde02bf91ba833f9$var$debounce(()=>{
            this.pageViewPercent = this.getPageViewedPercent();
        }, 100);
        // Device ID is stored in a cookie for domain level tracking when using a proxy.
        this.setDeviceId = ()=>{
            // When anonymizing tracking data, the cookie expires after 45min. However it will
            // persist with the user until the current page closes since the deviceId is stored
            // during initialization of Amplitude.
            const cookieKey = this.anonymize ? 'MDRNA_AID' : 'MDRNA_DID';
            const cookieExpiry = this.anonymize ? 0.03125 : undefined;
            let deviceId = $dde02bf91ba833f9$var$storage_1.default.getItem(cookieKey);
            if (!deviceId) {
                try {
                    // There are some contexts in which randomUUID() may not exist
                    deviceId = crypto.randomUUID();
                } catch  {
                    deviceId = (0, $dde02bf91ba833f9$var$uniqid_1.default)();
                }
                $dde02bf91ba833f9$var$storage_1.default.setItem(cookieKey, deviceId, cookieExpiry);
            }
            $dde02bf91ba833f9$var$amplitude.setDeviceId(deviceId);
        };
        this.initAmplitude = (optingOut = false)=>{
            // We can't change the amplitude configuration after we've
            // initialized it. We also shouldn't track security scanners
            // or bots.
            if (this.initialized || (0, $dde02bf91ba833f9$var$get_is_bot_1.default)() || !this.apiKey) return;
            this.setDeviceId();
            $dde02bf91ba833f9$var$amplitude.add({
                execute: async (event)=>{
                    event.event_properties = {
                        ...event.event_properties,
                        ...this.getOptionsCampaign(),
                        ...this.getOptionsPage()
                    };
                    event.user_properties = {
                        ...event.user_properties,
                        ...this.getOptionsUser()
                    };
                    return event;
                }
            });
            $dde02bf91ba833f9$var$amplitude.init(this.apiKey, {
                defaultTracking: {
                    attribution: false,
                    fileDownloads: !optingOut,
                    formInteractions: !optingOut,
                    pageViews: false,
                    sessions: true
                },
                flushIntervalMillis: optingOut ? 100 : 1000,
                identityStorage: 'localStorage',
                optOut: false,
                transport: 'beacon',
                serverUrl: (0, $dde02bf91ba833f9$var$get_proxy_url_1.default)()
            });
            this.initialized = true;
        };
        this.tryTrack = (...args)=>{
            if (this.tracking === true) $dde02bf91ba833f9$var$amplitude.track(args[0], args[1]);
            else if (this.tracking === null) {
                this.queue.push([
                    args[0],
                    args[1]
                ]);
                // Don't queue more than 100 events to prevent an (unlikely) memory leak
                // before the user opts in or out
                this.queue.splice(100);
            }
        };
        this.setLocale = (locale)=>{
            this.locale = locale;
        };
        this.track = (...args)=>{
            this.tryTrack(args[0], args[1]);
        };
        this.trackCustom = (...args)=>{
            this.tryTrack(args[0], args[1]);
        };
        this.setUserId = (userId)=>{
            $dde02bf91ba833f9$var$amplitude.setUserId(userId);
        };
        this.apiKey = (0, $itFsv.getProductionApiKey)(apiKey);
        this.defaultClickTracking = defaultClickTracking;
        this.internal = internal;
        this.locale = locale;
        this.anonymize = anonymize;
    }
    addListenOnRouteChanges() {
        // There isn't a way to hook into the history push state, so
        // we need to wrap it up an proxy the original function. For
        // whatever reason, we can't use arrow functions either.
        const self = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.historyPushStateOriginal = window.history.pushState;
        history.pushState = function() {
            setTimeout(()=>self.handleHistoryChange('Push'));
            return self.historyPushStateOriginal && self.historyPushStateOriginal.apply(history, arguments);
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.historyReplaceStateOriginal = window.history.replaceState;
        history.replaceState = function() {
            if (!self.historyReplaceStateCalledInternally) setTimeout(()=>self.handleHistoryReplaceChange());
            return self.historyReplaceStateOriginal && self.historyReplaceStateOriginal.apply(history, arguments);
        };
    }
    removeListenOnRouteChanges() {
        if (this.historyPushStateOriginal) {
            window.history.pushState = this.historyPushStateOriginal.bind(window.history);
            delete this.historyPushStateOriginal;
        }
        if (this.historyReplaceStateOriginal) {
            window.history.replaceState = this.historyReplaceStateOriginal.bind(window.history);
            delete this.historyReplaceStateOriginal;
        }
    }
    destroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('click', this.handleClick);
        window.removeEventListener('ended', this.handleMediaEnded, true);
        window.removeEventListener('error', this.handleError);
        window.removeEventListener('loadstart', this.handleMediaLoadStart, true);
        window.removeEventListener('pause', this.handleMediaPause, true);
        window.removeEventListener('play', this.handleMediaPlay, true);
        window.removeEventListener('popstate', this.handleHistoryPopState);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('seeked', this.handleMediaSeeked, true);
        this.removeListenOnRouteChanges();
    }
    init() {
        const storedOptIn = $dde02bf91ba833f9$var$storage_1.default.getItem('MDRNA_AMPLITUDE');
        this.tracking = storedOptIn === null ? null : Boolean(storedOptIn);
        this.pageViewPercent = this.getPageViewedPercent();
        if (this.tracking) this.initAmplitude();
        this.track('Page View', {
            'Page Load Method': 'Initial',
            'Page Load Type': 'Initial Load'
        });
        (0, $2xAZO.onCLS)(({ value: value })=>{
            if (!this.trackedCLS) {
                this.trackedCLS = true;
                this.track('Cumulative Layout Shift', {
                    Percent: value * 100
                });
            }
        });
        (0, $2xAZO.onINP)(({ value: value })=>{
            if (!this.trackedINP) {
                this.trackedINP = true;
                this.track('Interaction to Next Paint', {
                    Milliseconds: value
                });
            }
        });
        (0, $2xAZO.onLCP)(({ value: value })=>{
            if (!this.trackedLCP) {
                this.trackedLCP = true;
                this.track('Largest Contentful Paint', {
                    Milliseconds: value
                });
            }
        });
        this.addListenOnRouteChanges();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('click', this.handleClick);
        window.addEventListener('ended', this.handleMediaEnded, true);
        window.addEventListener('error', this.handleError);
        window.addEventListener('loadstart', this.handleMediaLoadStart, true);
        window.addEventListener('pause', this.handleMediaPause, true);
        window.addEventListener('play', this.handleMediaPlay, true);
        window.addEventListener('popstate', this.handleHistoryPopState);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('seeked', this.handleMediaSeeked, true);
    }
    optIn(optInValue) {
        if (optInValue && !this.tracking) {
            this.tracking = true;
            $dde02bf91ba833f9$var$storage_1.default.setItem('MDRNA_AMPLITUDE', '1');
            $dde02bf91ba833f9$var$amplitude.setOptOut(false);
            this.initAmplitude();
            $dde02bf91ba833f9$var$amplitude.track('Opt In');
            this.queue.forEach((event)=>$dde02bf91ba833f9$var$amplitude.track(event[0], event[1]));
            this.queue = [];
        } else if (!optInValue && this.tracking !== false) {
            this.initAmplitude(true);
            $dde02bf91ba833f9$var$amplitude.track('Opt Out');
            $dde02bf91ba833f9$var$amplitude.flush();
            this.tracking = false;
            $dde02bf91ba833f9$var$storage_1.default.setItem('MDRNA_AMPLITUDE', '');
            // We need to delay configuring opt out until the opt out event
            // has sent, which can be up to a second or more from this moment
            // if the user originally opted in.
            setTimeout(()=>$dde02bf91ba833f9$var$amplitude.setOptOut(true), 2000);
            this.queue = [];
        }
    }
}
module.exports.default = $dde02bf91ba833f9$var$Amplitude;

});
parcelRegister("dOups", function(module, exports) {

$parcel$export(module.exports, "add", () => $a0e78894e4001614$export$e16d8520af44a096);
$parcel$export(module.exports, "extendSession", () => $a0e78894e4001614$export$d0caa90bfa1dd141);
$parcel$export(module.exports, "flush", () => $a0e78894e4001614$export$4909b86c8034bf73);
$parcel$export(module.exports, "getDeviceId", () => $a0e78894e4001614$export$be262d700bd1c696);
$parcel$export(module.exports, "getSessionId", () => $a0e78894e4001614$export$b3739caaf2580dd);
$parcel$export(module.exports, "getUserId", () => $a0e78894e4001614$export$1617268687ac763c);
$parcel$export(module.exports, "groupIdentify", () => $a0e78894e4001614$export$30c344c0d9bb2256);
$parcel$export(module.exports, "identify", () => $a0e78894e4001614$export$65e5b62a4c490288);
$parcel$export(module.exports, "init", () => $a0e78894e4001614$export$2cd8252107eb640b);
$parcel$export(module.exports, "logEvent", () => $a0e78894e4001614$export$5e9eec8001665ac5);
$parcel$export(module.exports, "remove", () => $a0e78894e4001614$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "reset", () => $a0e78894e4001614$export$aad8462122ac592b);
$parcel$export(module.exports, "revenue", () => $a0e78894e4001614$export$7ebe0b98fc7db7a6);
$parcel$export(module.exports, "setDeviceId", () => $a0e78894e4001614$export$674c05fa57e365a9);
$parcel$export(module.exports, "setGroup", () => $a0e78894e4001614$export$ba2d2608914eca73);
$parcel$export(module.exports, "setOptOut", () => $a0e78894e4001614$export$74da29a5c7fe4c);
$parcel$export(module.exports, "setSessionId", () => $a0e78894e4001614$export$f61b5f0b88be99b3);
$parcel$export(module.exports, "setTransport", () => $a0e78894e4001614$export$877a0c8f77379bff);
$parcel$export(module.exports, "setUserId", () => $a0e78894e4001614$export$7f5abdb7f5093137);
$parcel$export(module.exports, "track", () => $a0e78894e4001614$export$6b2a7d5132615086);
$parcel$export(module.exports, "createInstance", () => (parcelRequire("3Gh3r")).createInstance);
$parcel$export(module.exports, "runQueuedFunctions", () => (parcelRequire("lplbV")).runQueuedFunctions);
$parcel$export(module.exports, "Revenue", () => (parcelRequire("af0le")).Revenue);
$parcel$export(module.exports, "Identify", () => (parcelRequire("9ebM6")).Identify);
$parcel$export(module.exports, "Types", () => (parcelRequire("9jRb6")));
/* eslint-disable @typescript-eslint/unbound-method */ 
var $3Gh3r = parcelRequire("3Gh3r");

var $lplbV = parcelRequire("lplbV");

var $9ebM6 = parcelRequire("9ebM6");
var $af0le = parcelRequire("af0le");

var $9jRb6 = parcelRequire("9jRb6");
var $a0e78894e4001614$export$e16d8520af44a096 = (0, $3Gh3r.default).add, $a0e78894e4001614$export$d0caa90bfa1dd141 = (0, $3Gh3r.default).extendSession, $a0e78894e4001614$export$4909b86c8034bf73 = (0, $3Gh3r.default).flush, $a0e78894e4001614$export$be262d700bd1c696 = (0, $3Gh3r.default).getDeviceId, $a0e78894e4001614$export$b3739caaf2580dd = (0, $3Gh3r.default).getSessionId, $a0e78894e4001614$export$1617268687ac763c = (0, $3Gh3r.default).getUserId, $a0e78894e4001614$export$30c344c0d9bb2256 = (0, $3Gh3r.default).groupIdentify, $a0e78894e4001614$export$65e5b62a4c490288 = (0, $3Gh3r.default).identify, $a0e78894e4001614$export$2cd8252107eb640b = (0, $3Gh3r.default).init, $a0e78894e4001614$export$5e9eec8001665ac5 = (0, $3Gh3r.default).logEvent, $a0e78894e4001614$export$cd7f480d6b8286c3 = (0, $3Gh3r.default).remove, $a0e78894e4001614$export$aad8462122ac592b = (0, $3Gh3r.default).reset, $a0e78894e4001614$export$7ebe0b98fc7db7a6 = (0, $3Gh3r.default).revenue, $a0e78894e4001614$export$674c05fa57e365a9 = (0, $3Gh3r.default).setDeviceId, $a0e78894e4001614$export$ba2d2608914eca73 = (0, $3Gh3r.default).setGroup, $a0e78894e4001614$export$74da29a5c7fe4c = (0, $3Gh3r.default).setOptOut, $a0e78894e4001614$export$f61b5f0b88be99b3 = (0, $3Gh3r.default).setSessionId, $a0e78894e4001614$export$877a0c8f77379bff = (0, $3Gh3r.default).setTransport, $a0e78894e4001614$export$7f5abdb7f5093137 = (0, $3Gh3r.default).setUserId, $a0e78894e4001614$export$6b2a7d5132615086 = (0, $3Gh3r.default).track;

});
parcelRegister("3Gh3r", function(module, exports) {

$parcel$export(module.exports, "createInstance", () => $2ae285fe769d7ee9$export$99152e8d49ca4e7d);
$parcel$export(module.exports, "default", () => $2ae285fe769d7ee9$export$2e2bcd8739ae039);

var $ebDro = parcelRequire("ebDro");

var $ctLm4 = parcelRequire("ctLm4");
var $2ae285fe769d7ee9$export$99152e8d49ca4e7d = function() {
    var client = new (0, $ctLm4.AmplitudeBrowser)();
    return {
        init: (0, $ebDro.debugWrapper)(client.init.bind(client), 'init', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ])),
        add: (0, $ebDro.debugWrapper)(client.add.bind(client), 'add', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        remove: (0, $ebDro.debugWrapper)(client.remove.bind(client), 'remove', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        track: (0, $ebDro.debugWrapper)(client.track.bind(client), 'track', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        logEvent: (0, $ebDro.debugWrapper)(client.logEvent.bind(client), 'logEvent', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        identify: (0, $ebDro.debugWrapper)(client.identify.bind(client), 'identify', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        groupIdentify: (0, $ebDro.debugWrapper)(client.groupIdentify.bind(client), 'groupIdentify', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        setGroup: (0, $ebDro.debugWrapper)(client.setGroup.bind(client), 'setGroup', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        revenue: (0, $ebDro.debugWrapper)(client.revenue.bind(client), 'revenue', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        flush: (0, $ebDro.debugWrapper)(client.flush.bind(client), 'flush', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        getUserId: (0, $ebDro.debugWrapper)(client.getUserId.bind(client), 'getUserId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config',
            'config.userId'
        ])),
        setUserId: (0, $ebDro.debugWrapper)(client.setUserId.bind(client), 'setUserId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config',
            'config.userId'
        ])),
        getDeviceId: (0, $ebDro.debugWrapper)(client.getDeviceId.bind(client), 'getDeviceId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config',
            'config.deviceId'
        ])),
        setDeviceId: (0, $ebDro.debugWrapper)(client.setDeviceId.bind(client), 'setDeviceId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config',
            'config.deviceId'
        ])),
        reset: (0, $ebDro.debugWrapper)(client.reset.bind(client), 'reset', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config',
            'config.userId',
            'config.deviceId'
        ])),
        getSessionId: (0, $ebDro.debugWrapper)(client.getSessionId.bind(client), 'getSessionId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ])),
        setSessionId: (0, $ebDro.debugWrapper)(client.setSessionId.bind(client), 'setSessionId', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ])),
        extendSession: (0, $ebDro.debugWrapper)(client.extendSession.bind(client), 'extendSession', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ])),
        setOptOut: (0, $ebDro.debugWrapper)(client.setOptOut.bind(client), 'setOptOut', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ])),
        setTransport: (0, $ebDro.debugWrapper)(client.setTransport.bind(client), 'setTransport', (0, $ebDro.getClientLogConfig)(client), (0, $ebDro.getClientStates)(client, [
            'config'
        ]))
    };
};
var $2ae285fe769d7ee9$export$2e2bcd8739ae039 = $2ae285fe769d7ee9$export$99152e8d49ca4e7d();

});
parcelRegister("ebDro", function(module, exports) {

$parcel$export(module.exports, "getClientLogConfig", () => $a540afe84357ec1d$export$c24a266b7d0d4b26);
$parcel$export(module.exports, "getClientStates", () => $a540afe84357ec1d$export$f4ba9ca2e79d2ae9);
$parcel$export(module.exports, "debugWrapper", () => $a540afe84357ec1d$export$bd4b394e2747b144);

var $7WQrb = parcelRequire("7WQrb");

var $5pHkT = parcelRequire("5pHkT");
var $a540afe84357ec1d$export$da8ad5017022fc09 = function(ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 0;
    var trace = new Error().stack || '';
    return trace.split('\n').slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
    });
};
var $a540afe84357ec1d$export$c24a266b7d0d4b26 = function(client) {
    return function() {
        var _a = (0, $7WQrb.__assign)({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var $a540afe84357ec1d$export$a7dcfccadff29f0 = function(obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for(var _b = (0, $7WQrb.__values)(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()){
            var attr = _c.value;
            if (attr in obj) obj = obj[attr];
            else return;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return obj;
};
var $a540afe84357ec1d$export$f4ba9ca2e79d2ae9 = function(client, paths) {
    return function() {
        var e_2, _a;
        var res = {};
        try {
            for(var paths_1 = (0, $7WQrb.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var path = paths_1_1.value;
                res[path] = $a540afe84357ec1d$export$a7dcfccadff29f0(client, path);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return res;
    };
};
var $a540afe84357ec1d$export$bd4b394e2747b144 = function(fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) fnContext = null;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if (logLevel && logLevel < (0, $5pHkT.LogLevel).Debug || !logLevel || !logger) return fn.apply(fnContext, args);
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: $a540afe84357ec1d$export$da8ad5017022fc09(1),
            time: {
                start: new Date().toISOString()
            },
            states: {}
        };
        if (getStates && debugContext.states) debugContext.states.before = getStates();
        var result = fn.apply(fnContext, args);
        if (result && result.promise) // if result is a promise, add the callback
        result.promise.then(function() {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        });
        else {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
};

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $5c96a02c592fcff1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $5c96a02c592fcff1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $5c96a02c592fcff1$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("5pHkT", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $3f10e7274ac1eb08$export$243e62d78d3b544d);
var $3f10e7274ac1eb08$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})($3f10e7274ac1eb08$export$243e62d78d3b544d || ($3f10e7274ac1eb08$export$243e62d78d3b544d = {}));

});


parcelRegister("ctLm4", function(module, exports) {

$parcel$export(module.exports, "AmplitudeBrowser", () => $915ced3497438738$export$8cd30bdeabfe5a38);

var $7WQrb = parcelRequire("7WQrb");

var $21X17 = parcelRequire("21X17");
var $1hmhj = parcelRequire("1hmhj");
var $9ebM6 = parcelRequire("9ebM6");
var $5nqBH = parcelRequire("5nqBH");
var $af0le = parcelRequire("af0le");
var $dfxGV = parcelRequire("dfxGV");

var $f799f = parcelRequire("f799f");
var $fvrAC = parcelRequire("fvrAC");
var $lHjhy = parcelRequire("lHjhy");
var $b7HFt = parcelRequire("b7HFt");
var $5VhQP = parcelRequire("5VhQP");
var $aZhYg = parcelRequire("aZhYg");

var $6rHk0 = parcelRequire("6rHk0");

var $lplbV = parcelRequire("lplbV");

var $kdJza = parcelRequire("kdJza");

var $hqbIh = parcelRequire("hqbIh");

var $681up = parcelRequire("681up");

var $k3IGs = parcelRequire("k3IGs");

var $iEjoG = parcelRequire("iEjoG");

var $aV8mG = parcelRequire("aV8mG");

var $54dDS = parcelRequire("54dDS");

var $2s0rJ = parcelRequire("2s0rJ");

var $ay8KK = parcelRequire("ay8KK");

var $7IKiz = parcelRequire("7IKiz");
var $915ced3497438738$export$8cd30bdeabfe5a38 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(AmplitudeBrowser, _super);
    function AmplitudeBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmplitudeBrowser.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) apiKey = '';
        var userId;
        var options;
        if (arguments.length > 2) {
            userId = userIdOrOptions;
            options = maybeOptions;
        } else if (typeof userIdOrOptions === 'string') {
            userId = userIdOrOptions;
            options = undefined;
        } else {
            userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
            options = userIdOrOptions;
        }
        return (0, $5nqBH.returnWrapper)(this._init((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            userId: userId,
            apiKey: apiKey
        })));
    };
    AmplitudeBrowser.prototype._init = function(options) {
        var _a, _b, _c;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var browserOptions, joinedConfigGenerator, attributionTrackingOptions, queryParams, querySessionId, connector;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        // Step 1: Block concurrent initialization
                        if (this.initializing) return [
                            2 /*return*/ 
                        ];
                        this.initializing = true;
                        return [
                            4 /*yield*/ ,
                            (0, $hqbIh.useBrowserConfig)(options.apiKey, options, this)
                        ];
                    case 1:
                        browserOptions = _d.sent();
                        if (!options.fetchRemoteConfig) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ay8KK.createBrowserJoinedConfigGenerator)(browserOptions)
                        ];
                    case 2:
                        joinedConfigGenerator = _d.sent();
                        return [
                            4 /*yield*/ ,
                            joinedConfigGenerator.generateJoinedConfig()
                        ];
                    case 3:
                        browserOptions = _d.sent();
                        _d.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _super.prototype._init.call(this, browserOptions)
                        ];
                    case 5:
                        _d.sent();
                        this.logBrowserOptions(browserOptions);
                        if (!(0, $fvrAC.isAttributionTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            7
                        ];
                        attributionTrackingOptions = (0, $fvrAC.getAttributionTrackingConfig)(this.config);
                        this.webAttribution = new (0, $aZhYg.WebAttribution)(attributionTrackingOptions, this.config);
                        // Fetch the current campaign, check if need to track web attribution later
                        return [
                            4 /*yield*/ ,
                            this.webAttribution.init()
                        ];
                    case 6:
                        // Fetch the current campaign, check if need to track web attribution later
                        _d.sent();
                        _d.label = 7;
                    case 7:
                        queryParams = (0, $lHjhy.getQueryParams)();
                        querySessionId = Number.isNaN(Number(queryParams.ampSessionId)) ? undefined : Number(queryParams.ampSessionId);
                        this.setSessionId((_c = (_b = (_a = options.sessionId) !== null && _a !== void 0 ? _a : querySessionId) !== null && _b !== void 0 ? _b : this.config.sessionId) !== null && _c !== void 0 ? _c : Date.now());
                        connector = (0, $f799f.getAnalyticsConnector)(options.instanceName);
                        connector.identityStore.setIdentity({
                            userId: this.config.userId,
                            deviceId: this.config.deviceId
                        });
                        if (!(this.config.offline !== (0, $6rHk0.OfflineDisabled))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.add((0, $2s0rJ.networkConnectivityCheckerPlugin)()).promise
                        ];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9:
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $1hmhj.Destination)()).promise
                        ];
                    case 10:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $kdJza.Context)()).promise
                        ];
                    case 11:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, $b7HFt.IdentityEventSender)()).promise
                        ];
                    case 12:
                        _d.sent();
                        // Notify if DET is enabled
                        (0, $54dDS.detNotify)(this.config);
                        if (!(0, $fvrAC.isFileDownloadTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            14
                        ];
                        this.config.loggerProvider.debug('Adding file download tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $iEjoG.fileDownloadTracking)()).promise
                        ];
                    case 13:
                        _d.sent();
                        _d.label = 14;
                    case 14:
                        if (!(0, $fvrAC.isFormInteractionTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            16
                        ];
                        this.config.loggerProvider.debug('Adding form interaction plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $k3IGs.formInteractionTracking)()).promise
                        ];
                    case 15:
                        _d.sent();
                        _d.label = 16;
                    case 16:
                        if (!(0, $fvrAC.isPageViewTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            18
                        ];
                        this.config.loggerProvider.debug('Adding page view tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $681up.pageViewTrackingPlugin)((0, $fvrAC.getPageViewTrackingConfig)(this.config))).promise
                        ];
                    case 17:
                        _d.sent();
                        _d.label = 18;
                    case 18:
                        if (!(0, $fvrAC.isElementInteractionsEnabled)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            20
                        ];
                        this.config.loggerProvider.debug('Adding user interactions plugin (autocapture plugin)');
                        return [
                            4 /*yield*/ ,
                            this.add((0, $7IKiz.autocapturePlugin)((0, $fvrAC.getElementInteractionsConfig)(this.config))).promise
                        ];
                    case 19:
                        _d.sent();
                        _d.label = 20;
                    case 20:
                        this.initializing = false;
                        // Step 6: Run queued dispatch functions
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('dispatchQ')
                        ];
                    case 21:
                        // Step 6: Run queued dispatch functions
                        _d.sent();
                        // Step 7: Add the event receiver after running remaining queued functions.
                        connector.eventBridge.setEventReceiver(function(event) {
                            _this.track(event.eventType, event.eventProperties);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeBrowser.prototype.getUserId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
    };
    AmplitudeBrowser.prototype.setUserId = function(userId) {
        if (!this.config) {
            this.q.push(this.setUserId.bind(this, userId));
            return;
        }
        this.config.loggerProvider.debug('function setUserId: ', userId);
        if (userId !== this.config.userId || userId === undefined) {
            this.config.userId = userId;
            (0, $f799f.setConnectorUserId)(userId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    AmplitudeBrowser.prototype.setDeviceId = function(deviceId) {
        if (!this.config) {
            this.q.push(this.setDeviceId.bind(this, deviceId));
            return;
        }
        this.config.loggerProvider.debug('function setDeviceId: ', deviceId);
        this.config.deviceId = deviceId;
        (0, $f799f.setConnectorDeviceId)(deviceId, this.config.instanceName);
    };
    AmplitudeBrowser.prototype.reset = function() {
        this.setDeviceId((0, $dfxGV.UUID)());
        this.setUserId(undefined);
    };
    AmplitudeBrowser.prototype.getSessionId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    AmplitudeBrowser.prototype.setSessionId = function(sessionId) {
        var _a;
        var promises = [];
        if (!this.config) {
            this.q.push(this.setSessionId.bind(this, sessionId));
            return (0, $5nqBH.returnWrapper)(Promise.resolve());
        }
        // Prevents starting a new session with the same session ID
        if (sessionId === this.config.sessionId) return (0, $5nqBH.returnWrapper)(Promise.resolve());
        this.config.loggerProvider.debug('function setSessionId: ', sessionId);
        var previousSessionId = this.getSessionId();
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = undefined;
        this.config.pageCounter = 0;
        if ((0, $fvrAC.isSessionTrackingEnabled)(this.config.defaultTracking)) {
            if (previousSessionId && lastEventTime) promises.push(this.track((0, $aV8mG.DEFAULT_SESSION_END_EVENT), undefined, {
                device_id: this.previousSessionDeviceId,
                event_id: ++lastEventId,
                session_id: previousSessionId,
                time: lastEventTime + 1,
                user_id: this.previousSessionUserId
            }).promise);
            this.config.lastEventTime = this.config.sessionId;
        }
        // Fire web attribution event when enable webAttribution tracking
        // 1. has new campaign (call setSessionId from init function)
        // 2. or shouldTrackNewCampaign (call setSessionId from async process(event) when there has new campaign and resetSessionOnNewCampaign = true )
        var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
        if ((0, $fvrAC.isSessionTrackingEnabled)(this.config.defaultTracking)) promises.push(this.track((0, $aV8mG.DEFAULT_SESSION_START_EVENT), undefined, {
            event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
            session_id: this.config.sessionId,
            time: this.config.lastEventTime
        }).promise);
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
        return (0, $5nqBH.returnWrapper)(Promise.all(promises));
    };
    AmplitudeBrowser.prototype.extendSession = function() {
        if (!this.config) {
            this.q.push(this.extendSession.bind(this));
            return;
        }
        this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser.prototype.setTransport = function(transport) {
        if (!this.config) {
            this.q.push(this.setTransport.bind(this, transport));
            return;
        }
        this.config.transportProvider = (0, $hqbIh.createTransport)(transport);
    };
    AmplitudeBrowser.prototype.identify = function(identify, eventOptions) {
        if ((0, $lplbV.isInstanceProxy)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, $lplbV.convertProxyObjectToRealObject)(new (0, $9ebM6.Identify)(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) this.setUserId(eventOptions.user_id);
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) this.setDeviceId(eventOptions.device_id);
        return _super.prototype.identify.call(this, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        if ((0, $lplbV.isInstanceProxy)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, $lplbV.convertProxyObjectToRealObject)(new (0, $9ebM6.Identify)(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.revenue = function(revenue, eventOptions) {
        if ((0, $lplbV.isInstanceProxy)(revenue)) {
            var queue = revenue._q;
            revenue._q = [];
            revenue = (0, $lplbV.convertProxyObjectToRealObject)(new (0, $af0le.Revenue)(), queue);
        }
        return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
        if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) return false;
        var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
        if (promises) promises.push(this.track(campaignEvent).promise);
        else this.track(campaignEvent);
        this.config.loggerProvider.log('Tracking attribution.');
        return true;
    };
    AmplitudeBrowser.prototype.process = function(event) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
            return (0, $7WQrb.__generator)(this, function(_a) {
                currentTime = Date.now();
                isEventInNewSession = (0, $5VhQP.isNewSession)(this.config.sessionTimeout, this.config.lastEventTime);
                shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
                if (event.event_type !== (0, $aV8mG.DEFAULT_SESSION_START_EVENT) && event.event_type !== (0, $aV8mG.DEFAULT_SESSION_END_EVENT) && (!event.session_id || event.session_id === this.getSessionId())) {
                    if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
                        this.setSessionId(currentTime);
                        if (shouldSetSessionIdOnNewCampaign) this.config.loggerProvider.log('Created a new session for new campaign.');
                    } else if (!isEventInNewSession) // Web attribution should be tracked during the middle of a session
                    // if there has been a chance in the campaign information.
                    this.trackCampaignEventIfNeeded();
                }
                return [
                    2 /*return*/ ,
                    _super.prototype.process.call(this, event)
                ];
            });
        });
    };
    AmplitudeBrowser.prototype.logBrowserOptions = function(browserConfig) {
        try {
            var browserConfigCopy = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, browserConfig), {
                apiKey: browserConfig.apiKey.substring(0, 10) + '********'
            });
            this.config.loggerProvider.debug('Initialized Amplitude with BrowserConfig:', JSON.stringify(browserConfigCopy));
        } catch (e) {
            /* istanbul ignore next */ this.config.loggerProvider.error('Error logging browser config', e);
        }
    };
    return AmplitudeBrowser;
}((0, $21X17.AmplitudeCore));

});
parcelRegister("21X17", function(module, exports) {

$parcel$export(module.exports, "AmplitudeCore", () => $17a97450d0558020$export$ca16f9ebcb935ab8);

var $7WQrb = parcelRequire("7WQrb");

var $ag83X = parcelRequire("ag83X");

var $k8IOu = parcelRequire("k8IOu");

var $j018b = parcelRequire("j018b");

var $j51xD = parcelRequire("j51xD");

var $5nqBH = parcelRequire("5nqBH");
var $17a97450d0558020$export$ca16f9ebcb935ab8 = /** @class */ function() {
    function AmplitudeCore(name) {
        if (name === void 0) name = '$default';
        this.initializing = false;
        this.isReady = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new (0, $k8IOu.Timeline)(this);
        this.name = name;
    }
    AmplitudeCore.prototype._init = function(config) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.config = config;
                        this.timeline.reset(this);
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('q')
                        ];
                    case 1:
                        _a.sent();
                        this.isReady = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.runQueuedFunctions = function(queueName) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
            var e_1, _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        queuedFunctions = this[queueName];
                        this[queueName] = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        queuedFunctions_1 = (0, $7WQrb.__values)(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queuedFunctions_1_1.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        queuedFunction = queuedFunctions_1_1.value;
                        val = queuedFunction();
                        if (!(val && 'promise' in val)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            val.promise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            val
                        ];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        queuedFunctions_1_1 = queuedFunctions_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        if (!this[queueName].length) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions(queueName)
                        ];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.track = function(eventInput, eventProperties, eventOptions) {
        var event = (0, $j018b.createTrackEvent)(eventInput, eventProperties, eventOptions);
        return (0, $5nqBH.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.identify = function(identify, eventOptions) {
        var event = (0, $j018b.createIdentifyEvent)(identify, eventOptions);
        return (0, $5nqBH.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        var event = (0, $j018b.createGroupIdentifyEvent)(groupType, groupName, identify, eventOptions);
        return (0, $5nqBH.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.setGroup = function(groupType, groupName, eventOptions) {
        var event = (0, $j018b.createGroupEvent)(groupType, groupName, eventOptions);
        return (0, $5nqBH.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.revenue = function(revenue, eventOptions) {
        var event = (0, $j018b.createRevenueEvent)(revenue, eventOptions);
        return (0, $5nqBH.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.add = function(plugin) {
        if (!this.isReady) {
            this.q.push(this._addPlugin.bind(this, plugin));
            return (0, $5nqBH.returnWrapper)();
        }
        return this._addPlugin(plugin);
    };
    AmplitudeCore.prototype._addPlugin = function(plugin) {
        return (0, $5nqBH.returnWrapper)(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore.prototype.remove = function(pluginName) {
        if (!this.isReady) {
            this.q.push(this._removePlugin.bind(this, pluginName));
            return (0, $5nqBH.returnWrapper)();
        }
        return this._removePlugin(pluginName);
    };
    AmplitudeCore.prototype._removePlugin = function(pluginName) {
        return (0, $5nqBH.returnWrapper)(this.timeline.deregister(pluginName, this.config));
    };
    AmplitudeCore.prototype.dispatchWithCallback = function(event, callback) {
        if (!this.isReady) return callback((0, $j51xD.buildResult)(event, 0, (0, $ag83X.CLIENT_NOT_INITIALIZED)));
        this.process(event).then(callback);
    };
    AmplitudeCore.prototype.dispatch = function(event) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                if (!this.isReady) return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
                    })
                ];
                return [
                    2 /*return*/ ,
                    this.process(event)
                ];
            });
        });
    };
    AmplitudeCore.prototype.process = function(event) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var result, e_2, message, result;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // skip event processing if opt out
                        if (this.config.optOut) return [
                            2 /*return*/ ,
                            (0, $j51xD.buildResult)(event, 0, (0, $ag83X.OPT_OUT_MESSAGE))
                        ];
                        return [
                            4 /*yield*/ ,
                            this.timeline.push(event)
                        ];
                    case 1:
                        result = _a.sent();
                        result.code === 200 ? this.config.loggerProvider.log(result.message) : result.code === 100 ? this.config.loggerProvider.warn(result.message) : this.config.loggerProvider.error(result.message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 2:
                        e_2 = _a.sent();
                        message = String(e_2);
                        this.config.loggerProvider.error(message);
                        result = (0, $j51xD.buildResult)(event, 0, message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function(optOut) {
        if (!this.isReady) {
            this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
            return;
        }
        this._setOptOut(optOut);
    };
    AmplitudeCore.prototype._setOptOut = function(optOut) {
        this.config.optOut = Boolean(optOut);
    };
    AmplitudeCore.prototype.flush = function() {
        return (0, $5nqBH.returnWrapper)(this.timeline.flush());
    };
    return AmplitudeCore;
}();

});
parcelRegister("ag83X", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_MESSAGE", () => $7781a723ea66540c$export$5620dbefc1cb6f80);
$parcel$export(module.exports, "UNEXPECTED_ERROR_MESSAGE", () => $7781a723ea66540c$export$77be9b23e6f97080);
$parcel$export(module.exports, "MAX_RETRIES_EXCEEDED_MESSAGE", () => $7781a723ea66540c$export$db21e8e2aba60c7d);
$parcel$export(module.exports, "OPT_OUT_MESSAGE", () => $7781a723ea66540c$export$ce5d4f781e585e70);
$parcel$export(module.exports, "MISSING_API_KEY_MESSAGE", () => $7781a723ea66540c$export$9229755af3d7ecf1);
$parcel$export(module.exports, "INVALID_API_KEY", () => $7781a723ea66540c$export$c20466bf93fe12d8);
$parcel$export(module.exports, "CLIENT_NOT_INITIALIZED", () => $7781a723ea66540c$export$f9763d297affe1cc);
var $7781a723ea66540c$export$5620dbefc1cb6f80 = 'Event tracked successfully';
var $7781a723ea66540c$export$77be9b23e6f97080 = 'Unexpected error occurred';
var $7781a723ea66540c$export$db21e8e2aba60c7d = 'Event rejected due to exceeded retry count';
var $7781a723ea66540c$export$ce5d4f781e585e70 = 'Event skipped due to optOut config';
var $7781a723ea66540c$export$9229755af3d7ecf1 = 'Event rejected due to missing API key';
var $7781a723ea66540c$export$c20466bf93fe12d8 = 'Invalid API key';
var $7781a723ea66540c$export$f9763d297affe1cc = 'Client not initialized';

});

parcelRegister("k8IOu", function(module, exports) {

$parcel$export(module.exports, "Timeline", () => $ea975105dc1edaa6$export$e6a97ba2cae5bb94);

var $7WQrb = parcelRequire("7WQrb");

var $j51xD = parcelRequire("j51xD");

var $dfxGV = parcelRequire("dfxGV");
var $ea975105dc1edaa6$export$e6a97ba2cae5bb94 = /** @class */ function() {
    function Timeline(client) {
        this.client = client;
        this.queue = [];
        // Flag to guarantee one schedule apply is running
        this.applying = false;
        // Flag indicates whether timeline is ready to process event
        // Events collected before timeline is ready will stay in the queue to be processed later
        this.plugins = [];
    }
    Timeline.prototype.register = function(plugin, config) {
        var _a, _b;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.plugins.some(function(existingPlugin) {
                            return existingPlugin.name === plugin.name;
                        })) {
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            config.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (plugin.name === undefined) {
                            plugin.name = (0, $dfxGV.UUID)();
                            config.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
                        }
                        plugin.type = (_a = plugin.type) !== null && _a !== void 0 ? _a : 'enrichment';
                        return [
                            4 /*yield*/ ,
                            (_b = plugin.setup) === null || _b === void 0 ? void 0 : _b.call(plugin, config, this.client)
                        ];
                    case 1:
                        _c.sent();
                        this.plugins.push(plugin);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.deregister = function(pluginName, config) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var index, plugin;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        index = this.plugins.findIndex(function(plugin) {
                            return plugin.name === pluginName;
                        });
                        if (index === -1) {
                            config.loggerProvider.warn("Plugin with name ".concat(pluginName, " does not exist, skipping deregistration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        plugin = this.plugins[index];
                        this.plugins.splice(index, 1);
                        return [
                            4 /*yield*/ ,
                            (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.reset = function(client) {
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function(plugin) {
            var _a;
            return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin);
        });
        this.plugins = [];
        this.client = client;
    };
    Timeline.prototype.push = function(event) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.queue.push([
                event,
                resolve
            ]);
            _this.scheduleApply(0);
        });
    };
    Timeline.prototype.scheduleApply = function(timeout) {
        var _this = this;
        if (this.applying) return;
        this.applying = true;
        setTimeout(function() {
            _this.apply(_this.queue.shift()).then(function() {
                _this.applying = false;
                if (_this.queue.length > 0) _this.scheduleApply(0);
            });
        }, timeout);
    };
    Timeline.prototype.apply = function(item) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
            var e_1, _c, e_2, _d;
            return (0, $7WQrb.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!item) return [
                            2 /*return*/ 
                        ];
                        _a = (0, $7WQrb.__read)(item, 1), event = _a[0];
                        _b = (0, $7WQrb.__read)(item, 2), resolve = _b[1];
                        before = this.plugins.filter(function(plugin) {
                            return plugin.type === 'before';
                        });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        before_1 = (0, $7WQrb.__values)(before), before_1_1 = before_1.next();
                        _e.label = 2;
                    case 2:
                        if (!!before_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        plugin = before_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, $7WQrb.__assign)({}, event))
                        ];
                    case 3:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else event = e;
                        _e.label = 4;
                    case 4:
                        before_1_1 = before_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        enrichment = this.plugins.filter(function(plugin) {
                            return plugin.type === 'enrichment' || plugin.type === undefined;
                        });
                        _e.label = 9;
                    case 9:
                        _e.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        enrichment_1 = (0, $7WQrb.__values)(enrichment), enrichment_1_1 = enrichment_1.next();
                        _e.label = 10;
                    case 10:
                        if (!!enrichment_1_1.done) return [
                            3 /*break*/ ,
                            13
                        ];
                        plugin = enrichment_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, $7WQrb.__assign)({}, event))
                        ];
                    case 11:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else event = e;
                        _e.label = 12;
                    case 12:
                        enrichment_1_1 = enrichment_1.next();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        e_2_1 = _e.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        try {
                            if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            var eventClone = (0, $7WQrb.__assign)({}, event);
                            return plugin.execute(eventClone).catch(function(e) {
                                return (0, $j51xD.buildResult)(eventClone, 0, String(e));
                            });
                        });
                        Promise.all(executeDestinations).then(function(_a) {
                            var _b = (0, $7WQrb.__read)(_a, 1), result = _b[0];
                            var resolveResult = result || (0, $j51xD.buildResult)(event, 100, 'Event not tracked, no destination plugins on the instance');
                            resolve(resolveResult);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.flush = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var queue, destination, executeDestinations;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        queue = this.queue;
                        this.queue = [];
                        return [
                            4 /*yield*/ ,
                            Promise.all(queue.map(function(item) {
                                return _this.apply(item);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            return plugin.flush && plugin.flush();
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(executeDestinations)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return Timeline;
}();

});
parcelRegister("j51xD", function(module, exports) {

$parcel$export(module.exports, "buildResult", () => $de3fae1381d61394$export$db0956ffc926ab6b);

var $jmOoi = parcelRequire("jmOoi");
var $de3fae1381d61394$export$db0956ffc926ab6b = function(event, code, message) {
    if (code === void 0) code = 0;
    if (message === void 0) message = (0, $jmOoi.Status).Unknown;
    return {
        event: event,
        code: code,
        message: message
    };
};

});
parcelRegister("jmOoi", function(module, exports) {

$parcel$export(module.exports, "Status", () => $e19728ff9c3c20ee$export$96e9906d6d93a972);
/** The status of an event. */ var $e19728ff9c3c20ee$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})($e19728ff9c3c20ee$export$96e9906d6d93a972 || ($e19728ff9c3c20ee$export$96e9906d6d93a972 = {}));

});


parcelRegister("dfxGV", function(module, exports) {

$parcel$export(module.exports, "UUID", () => $9a56cf7a1dd4bb85$export$bc35efed93511c4b);
/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */ var $9a56cf7a1dd4bb85$export$bc35efed93511c4b = function(a) {
    return a // if the placeholder was passed, return
     ? (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
     : (String(1e7) + // 10000000 +
    String(-1000) + // -1000 +
    String(-4000) + // -4000 +
    String(-8000) + // -80000000 +
    String(-100000000000) // -100000000000,
    ).replace(// replacing
    /[018]/g, $9a56cf7a1dd4bb85$export$bc35efed93511c4b);
};

});


parcelRegister("j018b", function(module, exports) {

$parcel$export(module.exports, "createTrackEvent", () => $dd4ee4fc8a8b28c0$export$8b3ed29dabd23a5);
$parcel$export(module.exports, "createIdentifyEvent", () => $dd4ee4fc8a8b28c0$export$5de4f5c2c4d8645f);
$parcel$export(module.exports, "createGroupIdentifyEvent", () => $dd4ee4fc8a8b28c0$export$9e05e975377d0d22);
$parcel$export(module.exports, "createGroupEvent", () => $dd4ee4fc8a8b28c0$export$35c5433e5b45cb60);
$parcel$export(module.exports, "createRevenueEvent", () => $dd4ee4fc8a8b28c0$export$55f867c6c37376a8);

var $7WQrb = parcelRequire("7WQrb");

var $ayMRi = parcelRequire("ayMRi");

var $9ebM6 = parcelRequire("9ebM6");
var $dd4ee4fc8a8b28c0$export$8b3ed29dabd23a5 = function(eventInput, eventProperties, eventOptions) {
    var baseEvent = typeof eventInput === 'string' ? {
        event_type: eventInput
    } : eventInput;
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, baseEvent), eventOptions), eventProperties && {
        event_properties: eventProperties
    });
};
var $dd4ee4fc8a8b28c0$export$5de4f5c2c4d8645f = function(identify, eventOptions) {
    var identifyEvent = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, eventOptions), {
        event_type: (0, $ayMRi.SpecialEventType).IDENTIFY,
        user_properties: identify.getUserProperties()
    });
    return identifyEvent;
};
var $dd4ee4fc8a8b28c0$export$9e05e975377d0d22 = function(groupType, groupName, identify, eventOptions) {
    var _a;
    var groupIdentify = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, eventOptions), {
        event_type: (0, $ayMRi.SpecialEventType).GROUP_IDENTIFY,
        group_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupIdentify;
};
var $dd4ee4fc8a8b28c0$export$35c5433e5b45cb60 = function(groupType, groupName, eventOptions) {
    var _a;
    var identify = new (0, $9ebM6.Identify)();
    identify.set(groupType, groupName);
    var groupEvent = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, eventOptions), {
        event_type: (0, $ayMRi.SpecialEventType).IDENTIFY,
        user_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupEvent;
};
var $dd4ee4fc8a8b28c0$export$55f867c6c37376a8 = function(revenue, eventOptions) {
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, eventOptions), {
        event_type: (0, $ayMRi.SpecialEventType).REVENUE,
        event_properties: revenue.getEventProperties()
    });
};

});
parcelRegister("ayMRi", function(module, exports) {

$parcel$export(module.exports, "IdentifyOperation", () => $7b02faab19ee22c9$export$6df138c24303c801);
$parcel$export(module.exports, "RevenueProperty", () => $7b02faab19ee22c9$export$50116cceae2de93);
$parcel$export(module.exports, "SpecialEventType", () => $7b02faab19ee22c9$export$6221d17ecafe3bf9);
var $7b02faab19ee22c9$export$6df138c24303c801;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})($7b02faab19ee22c9$export$6df138c24303c801 || ($7b02faab19ee22c9$export$6df138c24303c801 = {}));
var $7b02faab19ee22c9$export$50116cceae2de93;
(function(RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE"] = "$revenue";
})($7b02faab19ee22c9$export$50116cceae2de93 || ($7b02faab19ee22c9$export$50116cceae2de93 = {}));
var $7b02faab19ee22c9$export$6221d17ecafe3bf9;
(function(SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})($7b02faab19ee22c9$export$6221d17ecafe3bf9 || ($7b02faab19ee22c9$export$6221d17ecafe3bf9 = {}));

});

parcelRegister("9ebM6", function(module, exports) {

$parcel$export(module.exports, "Identify", () => $6b7e8e1624d3d02f$export$e513146db6535bff);

var $7WQrb = parcelRequire("7WQrb");

var $ayMRi = parcelRequire("ayMRi");

var $gLIQ3 = parcelRequire("gLIQ3");

var $gQTtx = parcelRequire("gQTtx");
var $6b7e8e1624d3d02f$export$e513146db6535bff = /** @class */ function() {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function() {
        return (0, $7WQrb.__assign)({}, this._properties);
    };
    Identify.prototype.set = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function(property, value) {
        this._safeSet((0, $ayMRi.IdentifyOperation).ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function(property) {
        this._safeSet((0, $ayMRi.IdentifyOperation).UNSET, property, (0, $gLIQ3.UNSET_VALUE));
        return this;
    };
    Identify.prototype.clearAll = function() {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[(0, $ayMRi.IdentifyOperation).CLEAR_ALL] = (0, $gLIQ3.UNSET_VALUE);
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function(operation, property, value) {
        if (this._properties[(0, $ayMRi.IdentifyOperation).CLEAR_ALL] !== undefined) // clear all already set. Skipping operation;
        return false;
        if (this._propertySet.has(property)) // Property already used. Skipping operation
        return false;
        if (operation === (0, $ayMRi.IdentifyOperation).ADD) return typeof value === 'number';
        if (operation !== (0, $ayMRi.IdentifyOperation).UNSET && operation !== (0, $ayMRi.IdentifyOperation).REMOVE) return (0, $gQTtx.isValidProperties)(property, value);
        return true;
    };
    return Identify;
}();

});
parcelRegister("gLIQ3", function(module, exports) {

$parcel$export(module.exports, "UNSET_VALUE", () => $c353d11d0f6a2fd1$export$a3f337ba59dc3dca);
$parcel$export(module.exports, "AMPLITUDE_PREFIX", () => $c353d11d0f6a2fd1$export$34512634d73abf96);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $c353d11d0f6a2fd1$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "AMPLITUDE_SERVER_URL", () => $c353d11d0f6a2fd1$export$29e80e090bc2cfd4);
$parcel$export(module.exports, "EU_AMPLITUDE_SERVER_URL", () => $c353d11d0f6a2fd1$export$2fcb1c10f7306bcf);
$parcel$export(module.exports, "AMPLITUDE_BATCH_SERVER_URL", () => $c353d11d0f6a2fd1$export$c567544fea55e004);
$parcel$export(module.exports, "EU_AMPLITUDE_BATCH_SERVER_URL", () => $c353d11d0f6a2fd1$export$68967a892545fca0);
var $c353d11d0f6a2fd1$export$a3f337ba59dc3dca = '-';
var $c353d11d0f6a2fd1$export$34512634d73abf96 = 'AMP';
var $c353d11d0f6a2fd1$export$7cc65d02ca2e18ec = "".concat($c353d11d0f6a2fd1$export$34512634d73abf96, "_unsent");
var $c353d11d0f6a2fd1$export$29e80e090bc2cfd4 = 'https://api2.amplitude.com/2/httpapi';
var $c353d11d0f6a2fd1$export$2fcb1c10f7306bcf = 'https://api.eu.amplitude.com/2/httpapi';
var $c353d11d0f6a2fd1$export$c567544fea55e004 = 'https://api2.amplitude.com/batch';
var $c353d11d0f6a2fd1$export$68967a892545fca0 = 'https://api.eu.amplitude.com/batch';

});

parcelRegister("gQTtx", function(module, exports) {

$parcel$export(module.exports, "isValidObject", () => $c44c88eb25e506de$export$16a0268bc22b47b0);
$parcel$export(module.exports, "isValidProperties", () => $c44c88eb25e506de$export$194dd9a8a66065f3);

var $7WQrb = parcelRequire("7WQrb");
var $c44c88eb25e506de$var$MAX_PROPERTY_KEYS = 1000;
var $c44c88eb25e506de$export$16a0268bc22b47b0 = function(properties) {
    if (Object.keys(properties).length > $c44c88eb25e506de$var$MAX_PROPERTY_KEYS) return false;
    for(var key in properties){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!$c44c88eb25e506de$export$194dd9a8a66065f3(key, value)) return false;
    }
    return true;
};
var $c44c88eb25e506de$export$194dd9a8a66065f3 = function(property, value) {
    var e_1, _a;
    if (typeof property !== 'string') return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for(var value_1 = (0, $7WQrb.__values)(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()){
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) return false;
                else if (typeof valueElement === 'object') isValid = isValid && $c44c88eb25e506de$export$16a0268bc22b47b0(valueElement);
                else if (![
                    'number',
                    'string'
                ].includes(typeof valueElement)) return false;
                if (!isValid) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    } else if (value === null || value === undefined) return false;
    else if (typeof value === 'object') // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return $c44c88eb25e506de$export$16a0268bc22b47b0(value);
    else if (![
        'number',
        'string',
        'boolean'
    ].includes(typeof value)) return false;
    return true;
};

});



parcelRegister("5nqBH", function(module, exports) {

$parcel$export(module.exports, "returnWrapper", () => $3ea3bd5324095960$export$a2bf1b09e40c274a);
var $3ea3bd5324095960$export$a2bf1b09e40c274a = function(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
};

});


parcelRegister("1hmhj", function(module, exports) {

$parcel$export(module.exports, "Destination", () => $0ee8a8f1f9eff8e9$export$5c4bdf44e1e9cea1);

var $7WQrb = parcelRequire("7WQrb");

var $jmOoi = parcelRequire("jmOoi");

var $ag83X = parcelRequire("ag83X");

var $gLIQ3 = parcelRequire("gLIQ3");

var $dWCeL = parcelRequire("dWCeL");

var $j51xD = parcelRequire("j51xD");

var $dS5JL = parcelRequire("dS5JL");

var $dfxGV = parcelRequire("dfxGV");
function $0ee8a8f1f9eff8e9$var$getErrorMessage(error) {
    if (error instanceof Error) return error.message;
    return String(error);
}
function $0ee8a8f1f9eff8e9$export$dc54abaec16aa4c8(res) {
    var responseBodyString = '';
    try {
        if ('body' in res) responseBodyString = JSON.stringify(res.body, null, 2);
    } catch (_a) {
    // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
    }
    return responseBodyString;
}
var $0ee8a8f1f9eff8e9$export$5c4bdf44e1e9cea1 = /** @class */ function() {
    function Destination() {
        this.name = 'amplitude';
        this.type = 'destination';
        this.retryTimeout = 1000;
        this.throttleTimeout = 30000;
        this.storageKey = '';
        this.scheduled = null;
        this.queue = [];
    }
    Destination.prototype.setup = function(config) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var unsent;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.config = config;
                        this.storageKey = "".concat((0, $gLIQ3.STORAGE_PREFIX), "_").concat(this.config.apiKey.substring(0, 10));
                        return [
                            4 /*yield*/ ,
                            (_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey)
                        ];
                    case 1:
                        unsent = _b.sent();
                        if (unsent && unsent.length > 0) Promise.all(unsent.map(function(event) {
                            return _this.execute(event);
                        })).catch();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(undefined)
                        ];
                }
            });
        });
    };
    Destination.prototype.execute = function(event) {
        var _this = this;
        // Assign insert_id for dropping invalid event later
        if (!event.insert_id) event.insert_id = (0, $dfxGV.UUID)();
        return new Promise(function(resolve) {
            var context = {
                event: event,
                attempts: 0,
                callback: function(result) {
                    return resolve(result);
                },
                timeout: 0
            };
            _this.addToQueue(context);
        });
    };
    Destination.prototype.getTryableList = function(list) {
        var _this = this;
        return list.filter(function(context) {
            if (context.attempts < _this.config.flushMaxRetries) {
                context.attempts += 1;
                return true;
            }
            _this.fulfillRequest([
                context
            ], 500, (0, $ag83X.MAX_RETRIES_EXCEEDED_MESSAGE));
            return false;
        });
    };
    Destination.prototype.scheduleTryable = function(list, shouldAddToQueue) {
        var _this = this;
        if (shouldAddToQueue === void 0) shouldAddToQueue = false;
        list.forEach(function(context) {
            // Only need to concat the queue for the first time
            if (shouldAddToQueue) _this.queue = _this.queue.concat(context);
            if (context.timeout === 0) {
                _this.schedule(_this.config.flushIntervalMillis);
                return;
            }
            setTimeout(function() {
                context.timeout = 0;
                _this.schedule(0);
            }, context.timeout);
        });
    };
    Destination.prototype.addToQueue = function() {
        var list = [];
        for(var _i = 0; _i < arguments.length; _i++)list[_i] = arguments[_i];
        var tryable = this.getTryableList(list);
        this.scheduleTryable(tryable, true);
        this.saveEvents();
    };
    Destination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.scheduled || this.config.offline) return;
        this.scheduled = setTimeout(function() {
            _this.flush(true).then(function() {
                if (_this.queue.length > 0) _this.schedule(timeout);
            });
        }, timeout);
    };
    Destination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) useRetry = false;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var list, later, batches;
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Skip flush if offline
                        if (this.config.offline) {
                            this.config.loggerProvider.debug('Skipping flush while offline.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        if (this.scheduled) {
                            clearTimeout(this.scheduled);
                            this.scheduled = null;
                        }
                        batches = (0, $dWCeL.chunk)(list, this.config.flushQueueSize);
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        return [
                            4 /*yield*/ ,
                            batches.reduce(function(promise, batch) {
                                return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, $7WQrb.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    promise
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.send(batch, useRetry)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, Promise.resolve())
                        ];
                    case 1:
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        _a.sent();
                        this.scheduleTryable(later);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.send = function(list, useRetry) {
        if (useRetry === void 0) useRetry = true;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var payload, serverUrl, res, e_1, errorMessage;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.config.apiKey) return [
                            2 /*return*/ ,
                            this.fulfillRequest(list, 400, (0, $ag83X.MISSING_API_KEY_MESSAGE))
                        ];
                        payload = {
                            api_key: this.config.apiKey,
                            events: list.map(function(context) {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                var _a = context.event, extra = _a.extra, eventWithoutExtra = (0, $7WQrb.__rest)(_a, [
                                    "extra"
                                ]);
                                return eventWithoutExtra;
                            }),
                            options: {
                                min_id_length: this.config.minIdLength
                            },
                            client_upload_time: new Date().toISOString(),
                            request_metadata: this.config.requestMetadata
                        };
                        this.config.requestMetadata = new (0, $dS5JL.RequestMetadata)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        serverUrl = (0, $dS5JL.createServerConfig)(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                        return [
                            4 /*yield*/ ,
                            this.config.transportProvider.send(serverUrl, payload)
                        ];
                    case 2:
                        res = _a.sent();
                        if (res === null) {
                            this.fulfillRequest(list, 0, (0, $ag83X.UNEXPECTED_ERROR_MESSAGE));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            if ('body' in res) this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat($0ee8a8f1f9eff8e9$export$dc54abaec16aa4c8(res)));
                            else this.fulfillRequest(list, res.statusCode, res.status);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.handleResponse(res, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        errorMessage = $0ee8a8f1f9eff8e9$var$getErrorMessage(e_1);
                        this.config.loggerProvider.error(errorMessage);
                        this.handleResponse({
                            status: (0, $jmOoi.Status).Failed,
                            statusCode: 0
                        }, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.handleResponse = function(res, list) {
        var status = res.status;
        switch(status){
            case (0, $jmOoi.Status).Success:
                this.handleSuccessResponse(res, list);
                break;
            case (0, $jmOoi.Status).Invalid:
                this.handleInvalidResponse(res, list);
                break;
            case (0, $jmOoi.Status).PayloadTooLarge:
                this.handlePayloadTooLargeResponse(res, list);
                break;
            case (0, $jmOoi.Status).RateLimit:
                this.handleRateLimitResponse(res, list);
                break;
            default:
                // log intermediate event status before retry
                this.config.loggerProvider.warn("{code: 0, error: \"Status '".concat(status, "' provided for ").concat(list.length, " events\"}"));
                this.handleOtherResponse(list);
                break;
        }
    };
    Destination.prototype.handleSuccessResponse = function(res, list) {
        this.fulfillRequest(list, res.statusCode, (0, $ag83X.SUCCESS_MESSAGE));
    };
    Destination.prototype.handleInvalidResponse = function(res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith((0, $ag83X.INVALID_API_KEY))) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        var dropIndex = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(Object.values(res.body.eventsWithInvalidFields)), false), (0, $7WQrb.__read)(Object.values(res.body.eventsWithMissingFields)), false), (0, $7WQrb.__read)(Object.values(res.body.eventsWithInvalidIdLengths)), false), (0, $7WQrb.__read)(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function(context, index) {
            if (dropIndexSet.has(index)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn($0ee8a8f1f9eff8e9$export$dc54abaec16aa4c8(res));
        var tryable = this.getTryableList(retry);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handlePayloadTooLargeResponse = function(res, list) {
        if (list.length === 1) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        // log intermediate event status before retry
        this.config.loggerProvider.warn($0ee8a8f1f9eff8e9$export$dc54abaec16aa4c8(res));
        this.config.flushQueueSize /= 2;
        var tryable = this.getTryableList(list);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handleRateLimitResponse = function(res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function(context, index) {
            if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            if (throttledIndexSet.has(index)) context.timeout = _this.throttleTimeout;
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn($0ee8a8f1f9eff8e9$export$dc54abaec16aa4c8(res));
        var tryable = this.getTryableList(retry);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.handleOtherResponse = function(list) {
        var _this = this;
        var later = list.map(function(context) {
            context.timeout = context.attempts * _this.retryTimeout;
            return context;
        });
        var tryable = this.getTryableList(later);
        this.scheduleTryable(tryable);
    };
    Destination.prototype.fulfillRequest = function(list, code, message) {
        this.removeEvents(list);
        list.forEach(function(context) {
            return context.callback((0, $j51xD.buildResult)(context.event, code, message));
        });
    };
    /**
     * This is called on
     * 1) new events are added to queue; or
     * 2) response comes back for a request
     *
     * Update the event storage based on the queue
     */ Destination.prototype.saveEvents = function() {
        if (!this.config.storageProvider) return;
        var updatedEvents = this.queue.map(function(context) {
            return context.event;
        });
        this.config.storageProvider.set(this.storageKey, updatedEvents);
    };
    /**
     * This is called on response comes back for a request
     */ Destination.prototype.removeEvents = function(eventsToRemove) {
        this.queue = this.queue.filter(function(queuedContext) {
            return !eventsToRemove.some(function(context) {
                return context.event.insert_id === queuedContext.event.insert_id;
            });
        });
        this.saveEvents();
    };
    return Destination;
}();

});
parcelRegister("dWCeL", function(module, exports) {

$parcel$export(module.exports, "chunk", () => $a26e5a3a3abe6c15$export$5f7ec48d69707ddd);
// Creates an array of elements split into groups the length of size.
// If array can't be split evenly, the final chunk will be the remaining elements.
// Works similary as https://lodash.com/docs/4.17.15#chunk
var $a26e5a3a3abe6c15$export$5f7ec48d69707ddd = function(arr, size) {
    var chunkSize = Math.max(size, 1);
    return arr.reduce(function(chunks, element, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
        chunks[chunkIndex].push(element);
        return chunks;
    }, []);
};

});

parcelRegister("dS5JL", function(module, exports) {

$parcel$export(module.exports, "Config", () => $a194c4cb216a29ed$export$29cd7b75162a9425);
$parcel$export(module.exports, "createServerConfig", () => $a194c4cb216a29ed$export$9100f0789d5e1cf2);
$parcel$export(module.exports, "RequestMetadata", () => $a194c4cb216a29ed$export$f7a44070a14bece0);

var $5pHkT = parcelRequire("5pHkT");

var $gLIQ3 = parcelRequire("gLIQ3");

var $6rW2W = parcelRequire("6rW2W");
var $a194c4cb216a29ed$export$ed30944e0fe6ae5c = function() {
    return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 10000,
        instanceName: '$default_instance',
        logLevel: (0, $5pHkT.LogLevel).Warn,
        loggerProvider: new (0, $6rW2W.Logger)(),
        offline: false,
        optOut: false,
        serverUrl: (0, $gLIQ3.AMPLITUDE_SERVER_URL),
        serverZone: 'US',
        useBatch: false
    };
};
var $a194c4cb216a29ed$export$29cd7b75162a9425 = /** @class */ function() {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = $a194c4cb216a29ed$export$ed30944e0fe6ae5c();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = $a194c4cb216a29ed$export$9100f0789d5e1cf2(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();
var $a194c4cb216a29ed$export$3c14a5a58c5a65d4 = function(serverZone, useBatch) {
    if (serverZone === 'EU') return useBatch ? (0, $gLIQ3.EU_AMPLITUDE_BATCH_SERVER_URL) : (0, $gLIQ3.EU_AMPLITUDE_SERVER_URL);
    return useBatch ? (0, $gLIQ3.AMPLITUDE_BATCH_SERVER_URL) : (0, $gLIQ3.AMPLITUDE_SERVER_URL);
};
var $a194c4cb216a29ed$export$9100f0789d5e1cf2 = function(serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) serverUrl = '';
    if (serverZone === void 0) serverZone = $a194c4cb216a29ed$export$ed30944e0fe6ae5c().serverZone;
    if (useBatch === void 0) useBatch = $a194c4cb216a29ed$export$ed30944e0fe6ae5c().useBatch;
    if (serverUrl) return {
        serverUrl: serverUrl,
        serverZone: undefined
    };
    var _serverZone = [
        'US',
        'EU'
    ].includes(serverZone) ? serverZone : $a194c4cb216a29ed$export$ed30944e0fe6ae5c().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: $a194c4cb216a29ed$export$3c14a5a58c5a65d4(_serverZone, useBatch)
    };
};
var $a194c4cb216a29ed$export$f7a44070a14bece0 = /** @class */ function() {
    function RequestMetadata() {
        this.sdk = {
            metrics: {
                histogram: {}
            }
        };
    }
    RequestMetadata.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata;
}();
var $a194c4cb216a29ed$var$HistogramOptions = /** @class */ function() {
    function HistogramOptions() {}
    return HistogramOptions;
}();

});
parcelRegister("6rW2W", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $4b224a7be539149c$export$efa9a398d6368992);

var $5pHkT = parcelRequire("5pHkT");
var $4b224a7be539149c$var$PREFIX = 'Amplitude Logger ';
var $4b224a7be539149c$export$efa9a398d6368992 = /** @class */ function() {
    function Logger() {
        this.logLevel = (0, $5pHkT.LogLevel).None;
    }
    Logger.prototype.disable = function() {
        this.logLevel = (0, $5pHkT.LogLevel).None;
    };
    Logger.prototype.enable = function(logLevel) {
        if (logLevel === void 0) logLevel = (0, $5pHkT.LogLevel).Warn;
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $5pHkT.LogLevel).Verbose) return;
        console.log("".concat($4b224a7be539149c$var$PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $5pHkT.LogLevel).Warn) return;
        console.warn("".concat($4b224a7be539149c$var$PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $5pHkT.LogLevel).Error) return;
        console.error("".concat($4b224a7be539149c$var$PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $5pHkT.LogLevel).Debug) return;
        // console.debug output is hidden by default in chrome
        console.log("".concat($4b224a7be539149c$var$PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}();

});



parcelRegister("af0le", function(module, exports) {

$parcel$export(module.exports, "Revenue", () => $774b91e4fc49c814$export$5c685df9b6b94d82);

var $7WQrb = parcelRequire("7WQrb");

var $ayMRi = parcelRequire("ayMRi");

var $gQTtx = parcelRequire("gQTtx");
var $774b91e4fc49c814$export$5c685df9b6b94d82 = /** @class */ function() {
    function Revenue() {
        this.productId = '';
        this.quantity = 1;
        this.price = 0.0;
    }
    Revenue.prototype.setProductId = function(productId) {
        this.productId = productId;
        return this;
    };
    Revenue.prototype.setQuantity = function(quantity) {
        if (quantity > 0) this.quantity = quantity;
        return this;
    };
    Revenue.prototype.setPrice = function(price) {
        this.price = price;
        return this;
    };
    Revenue.prototype.setRevenueType = function(revenueType) {
        this.revenueType = revenueType;
        return this;
    };
    Revenue.prototype.setRevenue = function(revenue) {
        this.revenue = revenue;
        return this;
    };
    Revenue.prototype.setEventProperties = function(properties) {
        if ((0, $gQTtx.isValidObject)(properties)) this.properties = properties;
        return this;
    };
    Revenue.prototype.getEventProperties = function() {
        var eventProperties = this.properties ? (0, $7WQrb.__assign)({}, this.properties) : {};
        eventProperties[(0, $ayMRi.RevenueProperty).REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[(0, $ayMRi.RevenueProperty).REVENUE_QUANTITY] = this.quantity;
        eventProperties[(0, $ayMRi.RevenueProperty).REVENUE_PRICE] = this.price;
        eventProperties[(0, $ayMRi.RevenueProperty).REVENUE_TYPE] = this.revenueType;
        eventProperties[(0, $ayMRi.RevenueProperty).REVENUE] = this.revenue;
        return eventProperties;
    };
    return Revenue;
}();

});

parcelRegister("f799f", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsConnector", () => $b00e9b17ca0a1224$export$4e27b19f1b537bc2);
$parcel$export(module.exports, "setConnectorUserId", () => $b00e9b17ca0a1224$export$ae185dd9f76bc0ec);
$parcel$export(module.exports, "setConnectorDeviceId", () => $b00e9b17ca0a1224$export$2bf3e8de34602369);

var $kG6tI = parcelRequire("kG6tI");
var $b00e9b17ca0a1224$export$4e27b19f1b537bc2 = function(instanceName) {
    if (instanceName === void 0) instanceName = '$default_instance';
    return (0, $kG6tI.AnalyticsConnector).getInstance(instanceName);
};
var $b00e9b17ca0a1224$export$ae185dd9f76bc0ec = function(userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    $b00e9b17ca0a1224$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var $b00e9b17ca0a1224$export$2bf3e8de34602369 = function(deviceId, instanceName) {
    $b00e9b17ca0a1224$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};

});
parcelRegister("kG6tI", function(module, exports) {

$parcel$export(module.exports, "AnalyticsConnector", () => $f0dcc154f9f6f034$export$5af12d25e001b77c);
var $f0dcc154f9f6f034$var$ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: $f0dcc154f9f6f034$var$getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var $f0dcc154f9f6f034$var$getLanguage = function() {
    return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var $f0dcc154f9f6f034$var$EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) this.queue.push(event);
        } else this.receiver(event);
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $f0dcc154f9f6f034$var$__assign = function() {
    $f0dcc154f9f6f034$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0dcc154f9f6f034$var$__assign.apply(this, arguments);
};
function $f0dcc154f9f6f034$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f0dcc154f9f6f034$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $f0dcc154f9f6f034$var$isEqual = function(obj1, obj2) {
    var e_1, _a;
    var primitive = [
        'string',
        'number',
        'boolean',
        'undefined'
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) return false;
    try {
        for(var primitive_1 = $f0dcc154f9f6f034$var$__values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()){
            var p = primitive_1_1.value;
            if (p === typeA) return obj1 === obj2;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) return true;
    else if (obj1 == null || obj2 == null) return false;
    // if got here - objects
    if (obj1.length !== obj2.length) return false;
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) return false;
    if (isArrayA && isArrayB) //arrays
    for(var i = 0; i < obj1.length; i++){
        if (!$f0dcc154f9f6f034$var$isEqual(obj1[i], obj2[i])) return false;
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!$f0dcc154f9f6f034$var$isEqual(sorted1, sorted2)) return false;
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!$f0dcc154f9f6f034$var$isEqual(obj1[key], obj2[key])) result_1 = false;
        });
        return result_1;
    }
    return true;
};
var $f0dcc154f9f6f034$var$ID_OP_SET = '$set';
var $f0dcc154f9f6f034$var$ID_OP_UNSET = '$unset';
var $f0dcc154f9f6f034$var$ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while(i--)resArray[i] = [
        ownProps[i],
        obj[ownProps[i]]
    ];
    return resArray;
};
var $f0dcc154f9f6f034$var$IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self1 = this;
        var actingUserProperties = $f0dcc154f9f6f034$var$__assign({}, this.identity.userProperties);
        var actingIdentity = $f0dcc154f9f6f034$var$__assign($f0dcc154f9f6f034$var$__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function(optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function(actions) {
                var e_1, _a, e_2, _b, e_3, _c;
                var actingProperties = actingIdentity.userProperties || {};
                try {
                    for(var _d = $f0dcc154f9f6f034$var$__values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()){
                        var _f = $f0dcc154f9f6f034$var$__read(_e.value, 2), action = _f[0], properties = _f[1];
                        switch(action){
                            case $f0dcc154f9f6f034$var$ID_OP_SET:
                                try {
                                    for(var _g = (e_2 = void 0, $f0dcc154f9f6f034$var$__values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var _j = $f0dcc154f9f6f034$var$__read(_h.value, 2), key = _j[0], value = _j[1];
                                        actingProperties[key] = value;
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                break;
                            case $f0dcc154f9f6f034$var$ID_OP_UNSET:
                                try {
                                    for(var _k = (e_3 = void 0, $f0dcc154f9f6f034$var$__values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()){
                                        var key = _l.value;
                                        delete actingProperties[key];
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                break;
                            case $f0dcc154f9f6f034$var$ID_OP_CLEAR_ALL:
                                actingProperties = {};
                                break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function() {
                self1.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return $f0dcc154f9f6f034$var$__assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = $f0dcc154f9f6f034$var$__assign({}, this.identity);
        this.identity = $f0dcc154f9f6f034$var$__assign({}, identity);
        if (!$f0dcc154f9f6f034$var$isEqual(originalIdentity, this.identity)) this.listeners.forEach(function(listener) {
            listener(identity);
        });
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var $f0dcc154f9f6f034$var$safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof $parcel$global !== 'undefined' ? $parcel$global : self;
var $f0dcc154f9f6f034$export$5af12d25e001b77c = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new $f0dcc154f9f6f034$var$IdentityStoreImpl();
        this.eventBridge = new $f0dcc154f9f6f034$var$EventBridgeImpl();
        this.applicationContextProvider = new $f0dcc154f9f6f034$var$ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!$f0dcc154f9f6f034$var$safeGlobal['analyticsConnectorInstances']) $f0dcc154f9f6f034$var$safeGlobal['analyticsConnectorInstances'] = {};
        if (!$f0dcc154f9f6f034$var$safeGlobal['analyticsConnectorInstances'][instanceName]) $f0dcc154f9f6f034$var$safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
        return $f0dcc154f9f6f034$var$safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}();

});


parcelRegister("fvrAC", function(module, exports) {

$parcel$export(module.exports, "isAttributionTrackingEnabled", () => $b49f27042821adbc$export$d20b42d02fe617b9);
$parcel$export(module.exports, "isFileDownloadTrackingEnabled", () => $b49f27042821adbc$export$439965f940d78a9);
$parcel$export(module.exports, "isFormInteractionTrackingEnabled", () => $b49f27042821adbc$export$affa82d896586aa0);
$parcel$export(module.exports, "isPageViewTrackingEnabled", () => $b49f27042821adbc$export$b6f98464b3039a53);
$parcel$export(module.exports, "isSessionTrackingEnabled", () => $b49f27042821adbc$export$39cec01e4b71f7d6);
$parcel$export(module.exports, "isElementInteractionsEnabled", () => $b49f27042821adbc$export$61bfa9a947732d3c);
$parcel$export(module.exports, "getElementInteractionsConfig", () => $b49f27042821adbc$export$a6ad12940a2ffeac);
$parcel$export(module.exports, "getPageViewTrackingConfig", () => $b49f27042821adbc$export$12e70b7a43554816);
$parcel$export(module.exports, "getAttributionTrackingConfig", () => $b49f27042821adbc$export$4048df75bcf826ca);

var $7WQrb = parcelRequire("7WQrb");
/**
 * Returns false if autocapture === false or if autocapture[event],
 * otherwise returns true
 */ var $b49f27042821adbc$var$isTrackingEnabled = function(autocapture, event) {
    if (typeof autocapture === 'boolean') return autocapture;
    if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) return false;
    return true;
};
var $b49f27042821adbc$export$d20b42d02fe617b9 = function(autocapture) {
    return $b49f27042821adbc$var$isTrackingEnabled(autocapture, 'attribution');
};
var $b49f27042821adbc$export$439965f940d78a9 = function(autocapture) {
    return $b49f27042821adbc$var$isTrackingEnabled(autocapture, 'fileDownloads');
};
var $b49f27042821adbc$export$affa82d896586aa0 = function(autocapture) {
    return $b49f27042821adbc$var$isTrackingEnabled(autocapture, 'formInteractions');
};
var $b49f27042821adbc$export$b6f98464b3039a53 = function(autocapture) {
    return $b49f27042821adbc$var$isTrackingEnabled(autocapture, 'pageViews');
};
var $b49f27042821adbc$export$39cec01e4b71f7d6 = function(autocapture) {
    return $b49f27042821adbc$var$isTrackingEnabled(autocapture, 'sessions');
};
var $b49f27042821adbc$export$61bfa9a947732d3c = function(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === 'object')) return true;
    return false;
};
var $b49f27042821adbc$export$a6ad12940a2ffeac = function(config) {
    if ($b49f27042821adbc$export$61bfa9a947732d3c(config.autocapture) && typeof config.autocapture === 'object' && typeof config.autocapture.elementInteractions === 'object') return config.autocapture.elementInteractions;
    return undefined;
};
var $b49f27042821adbc$export$12e70b7a43554816 = function(config) {
    var trackOn = function() {
        return false;
    };
    var trackHistoryChanges = undefined;
    var eventType;
    var pageCounter = config.pageCounter;
    var isDefaultPageViewTrackingEnabled = $b49f27042821adbc$export$b6f98464b3039a53(config.defaultTracking);
    if (isDefaultPageViewTrackingEnabled) {
        trackOn = undefined;
        eventType = undefined;
        if (config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.pageViews && typeof config.defaultTracking.pageViews === 'object') {
            if ('trackOn' in config.defaultTracking.pageViews) trackOn = config.defaultTracking.pageViews.trackOn;
            if ('trackHistoryChanges' in config.defaultTracking.pageViews) trackHistoryChanges = config.defaultTracking.pageViews.trackHistoryChanges;
            if ('eventType' in config.defaultTracking.pageViews && config.defaultTracking.pageViews.eventType) eventType = config.defaultTracking.pageViews.eventType;
        }
    }
    return {
        trackOn: trackOn,
        trackHistoryChanges: trackHistoryChanges,
        eventType: eventType,
        pageCounter: pageCounter
    };
};
var $b49f27042821adbc$export$4048df75bcf826ca = function(config) {
    if ($b49f27042821adbc$export$d20b42d02fe617b9(config.defaultTracking) && config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.attribution && typeof config.defaultTracking.attribution === 'object') return (0, $7WQrb.__assign)({}, config.defaultTracking.attribution);
    return {};
};

});

parcelRegister("lHjhy", function(module, exports) {

$parcel$export(module.exports, "getQueryParams", () => $fcbc9221fa90d9bc$export$e2de15bbd9edf9c6);

var $aiiqn = parcelRequire("aiiqn");
var $fcbc9221fa90d9bc$export$e2de15bbd9edf9c6 = function() {
    var _a;
    var globalScope = (0, $aiiqn.getGlobalScope)();
    /* istanbul ignore if */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) return {};
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function(acc, curr) {
        var query = curr.split('=', 2);
        var key = $fcbc9221fa90d9bc$export$9c4c1f32e1ce3ceb(query[0]);
        var value = $fcbc9221fa90d9bc$export$9c4c1f32e1ce3ceb(query[1]);
        if (!value) return acc;
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var $fcbc9221fa90d9bc$export$9c4c1f32e1ce3ceb = function(value) {
    if (value === void 0) value = '';
    try {
        return decodeURIComponent(value);
    } catch (_a) {
        return '';
    }
};

});
parcelRegister("aiiqn", function(module, exports) {

$parcel$export(module.exports, "getGlobalScope", () => $77e9e0847f10f023$export$aa55d5ab8e05984f);
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var $77e9e0847f10f023$export$aa55d5ab8e05984f = function() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') return globalThis[ampIntegrationContextName];
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return undefined;
};

});


parcelRegister("b7HFt", function(module, exports) {

$parcel$export(module.exports, "IdentityEventSender", () => $819238acbc0b313a$export$1a68292eb68beee1);

var $7WQrb = parcelRequire("7WQrb");

var $f799f = parcelRequire("f799f");
var $819238acbc0b313a$export$1a68292eb68beee1 = /** @class */ function() {
    function IdentityEventSender() {
        this.name = 'identity';
        this.type = 'before';
        this.identityStore = (0, $f799f.getAnalyticsConnector)().identityStore;
    }
    IdentityEventSender.prototype.execute = function(context) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var userProperties;
            return (0, $7WQrb.__generator)(this, function(_a) {
                userProperties = context.user_properties;
                if (userProperties) this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
                return [
                    2 /*return*/ ,
                    context
                ];
            });
        });
    };
    IdentityEventSender.prototype.setup = function(config) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                if (config.instanceName) this.identityStore = (0, $f799f.getAnalyticsConnector)(config.instanceName).identityStore;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return IdentityEventSender;
}();

});

parcelRegister("5VhQP", function(module, exports) {

$parcel$export(module.exports, "isNewSession", () => $45001f7ad34d0d6d$export$cd75ee83e0e7704a);
var $45001f7ad34d0d6d$export$cd75ee83e0e7704a = function(sessionTimeout, lastEventTime) {
    if (lastEventTime === void 0) lastEventTime = Date.now();
    var currentTime = Date.now();
    var timeSinceLastEvent = currentTime - lastEventTime;
    return timeSinceLastEvent > sessionTimeout;
};

});

parcelRegister("aZhYg", function(module, exports) {

$parcel$export(module.exports, "WebAttribution", () => $7ffd8a8eb89cbea4$export$b96750d084925672);

var $7WQrb = parcelRequire("7WQrb");

var $9u39R = parcelRequire("9u39R");

var $ppH71 = parcelRequire("ppH71");

var $9BVYv = parcelRequire("9BVYv");

var $jSOSr = parcelRequire("jSOSr");

var $5VhQP = parcelRequire("5VhQP");
var $7ffd8a8eb89cbea4$export$b96750d084925672 = /** @class */ function() {
    function WebAttribution(options, config) {
        var _a;
        this.shouldTrackNewCampaign = false;
        this.options = (0, $7WQrb.__assign)({
            initialEmptyValue: 'EMPTY',
            resetSessionOnNewCampaign: false,
            excludeReferrers: (0, $9u39R.getDefaultExcludedReferrers)((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain)
        }, options);
        this.storage = config.cookieStorage;
        this.storageKey = (0, $ppH71.getStorageKey)(config.apiKey, 'MKTG');
        this.currentCampaign = (0, $jSOSr.BASE_CAMPAIGN);
        this.sessionTimeout = config.sessionTimeout;
        this.lastEventTime = config.lastEventTime;
        this.logger = config.loggerProvider;
        config.loggerProvider.log('Installing web attribution tracking.');
    }
    WebAttribution.prototype.init = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var isEventInNewSession;
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchCampaign()
                        ];
                    case 1:
                        _a = (0, $7WQrb.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), this.currentCampaign = _a[0], this.previousCampaign = _a[1];
                        isEventInNewSession = !this.lastEventTime ? true : (0, $5VhQP.isNewSession)(this.sessionTimeout, this.lastEventTime);
                        if (!(0, $9u39R.isNewCampaign)(this.currentCampaign, this.previousCampaign, this.options, this.logger, isEventInNewSession)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.shouldTrackNewCampaign = true;
                        return [
                            4 /*yield*/ ,
                            this.storage.set(this.storageKey, this.currentCampaign)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAttribution.prototype.fetchCampaign = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                new (0, $9BVYv.CampaignParser)().parse(),
                                this.storage.get(this.storageKey)
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * This can be called when enable web attribution and either
     * 1. set a new session
     * 2. has new campaign and enable resetSessionOnNewCampaign
     */ WebAttribution.prototype.generateCampaignEvent = function(event_id) {
        // Mark this campaign has been tracked
        this.shouldTrackNewCampaign = false;
        var campaignEvent = (0, $9u39R.createCampaignEvent)(this.currentCampaign, this.options);
        if (event_id) campaignEvent.event_id = event_id;
        return campaignEvent;
    };
    WebAttribution.prototype.shouldSetSessionIdOnNewCampaign = function() {
        return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    };
    return WebAttribution;
}();

});
parcelRegister("9u39R", function(module, exports) {

$parcel$export(module.exports, "isNewCampaign", () => $6e795d893e2dcdda$export$1c9a583701535c5);
$parcel$export(module.exports, "createCampaignEvent", () => $6e795d893e2dcdda$export$d146d450a8c839d2);
$parcel$export(module.exports, "getDefaultExcludedReferrers", () => $6e795d893e2dcdda$export$579a8d2534a703d9);

var $7WQrb = parcelRequire("7WQrb");

var $j018b = parcelRequire("j018b");
var $9ebM6 = parcelRequire("9ebM6");

var $jSOSr = parcelRequire("jSOSr");
var $6e795d893e2dcdda$var$domainWithoutSubdomain = function(domain) {
    var parts = domain.split('.');
    if (parts.length <= 2) return domain;
    return parts.slice(parts.length - 2, parts.length).join('.');
};
//Direct traffic mean no external referral, no UTMs, no click-ids, and no other customer identified marketing campaign url params.
var $6e795d893e2dcdda$var$isDirectTraffic = function(current) {
    return Object.values(current).every(function(value) {
        return !value;
    });
};
var $6e795d893e2dcdda$export$1c9a583701535c5 = function(current, previous, options, logger, isNewSession) {
    if (isNewSession === void 0) isNewSession = true;
    var referrer = current.referrer, referring_domain = current.referring_domain, currentCampaign = (0, $7WQrb.__rest)(current, [
        "referrer",
        "referring_domain"
    ]);
    var _a = previous || {}, _previous_referrer = _a.referrer, prevReferringDomain = _a.referring_domain, previousCampaign = (0, $7WQrb.__rest)(_a, [
        "referrer",
        "referring_domain"
    ]);
    if ($6e795d893e2dcdda$export$b8cc7c254fe2d3ec(options.excludeReferrers, current.referring_domain)) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        logger.debug("This is not a new campaign because ".concat(current.referring_domain, " is in the exclude referrer list."));
        return false;
    }
    //In the same session, direct traffic should not override or unset any persisting query params
    if (!isNewSession && $6e795d893e2dcdda$var$isDirectTraffic(current) && previous) {
        logger.debug('This is not a new campaign because this is a direct traffic in the same session.');
        return false;
    }
    var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
    var hasNewDomain = $6e795d893e2dcdda$var$domainWithoutSubdomain(referring_domain || '') !== $6e795d893e2dcdda$var$domainWithoutSubdomain(prevReferringDomain || '');
    var result = !previous || hasNewCampaign || hasNewDomain;
    if (!result) logger.debug("This is not a new campaign because it's the same as the previous one.");
    else logger.debug("This is a new campaign. An $identify event will be sent.");
    return result;
};
var $6e795d893e2dcdda$export$b8cc7c254fe2d3ec = function(excludeReferrers, referringDomain) {
    if (excludeReferrers === void 0) excludeReferrers = [];
    if (referringDomain === void 0) referringDomain = '';
    return excludeReferrers.some(function(value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
    });
};
var $6e795d893e2dcdda$export$d146d450a8c839d2 = function(campaign, options) {
    var campaignParameters = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $jSOSr.BASE_CAMPAIGN)), campaign);
    var identifyEvent = Object.entries(campaignParameters).reduce(function(identify, _a) {
        var _b;
        var _c = (0, $7WQrb.__read)(_a, 2), key = _c[0], value = _c[1];
        identify.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : 'EMPTY');
        if (value) return identify.set(key, value);
        return identify.unset(key);
    }, new (0, $9ebM6.Identify)());
    return (0, $j018b.createIdentifyEvent)(identifyEvent);
};
var $6e795d893e2dcdda$export$579a8d2534a703d9 = function(cookieDomain) {
    var domain = cookieDomain;
    if (domain) {
        if (domain.startsWith('.')) domain = domain.substring(1);
        return [
            new RegExp("".concat(domain.replace('.', '\\.'), "$"))
        ];
    }
    return [];
};

});
parcelRegister("jSOSr", function(module, exports) {

$parcel$export(module.exports, "UTM_CAMPAIGN", () => $e79a869f3f6f9f63$export$926599dcfe1d591d);
$parcel$export(module.exports, "UTM_CONTENT", () => $e79a869f3f6f9f63$export$76cba99ea272772);
$parcel$export(module.exports, "UTM_ID", () => $e79a869f3f6f9f63$export$5061a1cefb237161);
$parcel$export(module.exports, "UTM_MEDIUM", () => $e79a869f3f6f9f63$export$a6f5c6056c876f92);
$parcel$export(module.exports, "UTM_SOURCE", () => $e79a869f3f6f9f63$export$f7522a6e1839b3b9);
$parcel$export(module.exports, "UTM_TERM", () => $e79a869f3f6f9f63$export$74173cb2cd2c2b01);
$parcel$export(module.exports, "DCLID", () => $e79a869f3f6f9f63$export$d7046fa8a8c432a0);
$parcel$export(module.exports, "FBCLID", () => $e79a869f3f6f9f63$export$bee91738abba7f50);
$parcel$export(module.exports, "GBRAID", () => $e79a869f3f6f9f63$export$bba55cdc82bf1e23);
$parcel$export(module.exports, "GCLID", () => $e79a869f3f6f9f63$export$d72e6377dae42b4f);
$parcel$export(module.exports, "KO_CLICK_ID", () => $e79a869f3f6f9f63$export$9ed7c4aa246186b5);
$parcel$export(module.exports, "LI_FAT_ID", () => $e79a869f3f6f9f63$export$e495e049f5a59ccc);
$parcel$export(module.exports, "MSCLKID", () => $e79a869f3f6f9f63$export$f912492c0955f678);
$parcel$export(module.exports, "RDT_CID", () => $e79a869f3f6f9f63$export$f1d48c95a869863d);
$parcel$export(module.exports, "TTCLID", () => $e79a869f3f6f9f63$export$89d66d2933b92df);
$parcel$export(module.exports, "TWCLID", () => $e79a869f3f6f9f63$export$856b82f6063e22ef);
$parcel$export(module.exports, "WBRAID", () => $e79a869f3f6f9f63$export$b5b43be4e547ddd3);
$parcel$export(module.exports, "BASE_CAMPAIGN", () => $e79a869f3f6f9f63$export$ea7354d30dfda3a2);
var $e79a869f3f6f9f63$export$926599dcfe1d591d = 'utm_campaign';
var $e79a869f3f6f9f63$export$76cba99ea272772 = 'utm_content';
var $e79a869f3f6f9f63$export$5061a1cefb237161 = 'utm_id';
var $e79a869f3f6f9f63$export$a6f5c6056c876f92 = 'utm_medium';
var $e79a869f3f6f9f63$export$f7522a6e1839b3b9 = 'utm_source';
var $e79a869f3f6f9f63$export$74173cb2cd2c2b01 = 'utm_term';
var $e79a869f3f6f9f63$export$d7046fa8a8c432a0 = 'dclid';
var $e79a869f3f6f9f63$export$bee91738abba7f50 = 'fbclid';
var $e79a869f3f6f9f63$export$bba55cdc82bf1e23 = 'gbraid';
var $e79a869f3f6f9f63$export$d72e6377dae42b4f = 'gclid';
var $e79a869f3f6f9f63$export$9ed7c4aa246186b5 = 'ko_click_id';
var $e79a869f3f6f9f63$export$e495e049f5a59ccc = 'li_fat_id';
var $e79a869f3f6f9f63$export$f912492c0955f678 = 'msclkid';
var $e79a869f3f6f9f63$export$f1d48c95a869863d = 'rtd_cid';
var $e79a869f3f6f9f63$export$89d66d2933b92df = 'ttclid';
var $e79a869f3f6f9f63$export$856b82f6063e22ef = 'twclid';
var $e79a869f3f6f9f63$export$b5b43be4e547ddd3 = 'wbraid';
var $e79a869f3f6f9f63$export$4c723243179776e1 = 'EMPTY';
var $e79a869f3f6f9f63$export$ea7354d30dfda3a2 = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rtd_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var $e79a869f3f6f9f63$export$8ee5ccb4ef82a40e = 'MKTG';

});


parcelRegister("ppH71", function(module, exports) {

$parcel$export(module.exports, "getStorageKey", () => $04c6444740ae3cc6$export$902ba6ec74c93f9d);

var $gLIQ3 = parcelRequire("gLIQ3");
var $04c6444740ae3cc6$export$902ba6ec74c93f9d = function(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, $gLIQ3.AMPLITUDE_PREFIX),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};

});

parcelRegister("9BVYv", function(module, exports) {

$parcel$export(module.exports, "CampaignParser", () => $6ff48a622db30c02$export$6887fc37aa79947c);

var $7WQrb = parcelRequire("7WQrb");

var $lHjhy = parcelRequire("lHjhy");

var $jSOSr = parcelRequire("jSOSr");
var $6ff48a622db30c02$export$6887fc37aa79947c = /** @class */ function() {
    function CampaignParser() {}
    CampaignParser.prototype.parse = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $jSOSr.BASE_CAMPAIGN)), this.getUtmParam()), this.getReferrer()), this.getClickIds())
                ];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function() {
        var params = (0, $lHjhy.getQueryParams)();
        var utmCampaign = params[0, $jSOSr.UTM_CAMPAIGN];
        var utmContent = params[0, $jSOSr.UTM_CONTENT];
        var utmId = params[0, $jSOSr.UTM_ID];
        var utmMedium = params[0, $jSOSr.UTM_MEDIUM];
        var utmSource = params[0, $jSOSr.UTM_SOURCE];
        var utmTerm = params[0, $jSOSr.UTM_TERM];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm
        };
    };
    CampaignParser.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        } catch (_c) {
        // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function() {
        var _a;
        var params = (0, $lHjhy.getQueryParams)();
        return _a = {}, _a[0, $jSOSr.DCLID] = params[0, $jSOSr.DCLID], _a[0, $jSOSr.FBCLID] = params[0, $jSOSr.FBCLID], _a[0, $jSOSr.GBRAID] = params[0, $jSOSr.GBRAID], _a[0, $jSOSr.GCLID] = params[0, $jSOSr.GCLID], _a[0, $jSOSr.KO_CLICK_ID] = params[0, $jSOSr.KO_CLICK_ID], _a[0, $jSOSr.LI_FAT_ID] = params[0, $jSOSr.LI_FAT_ID], _a[0, $jSOSr.MSCLKID] = params[0, $jSOSr.MSCLKID], _a[0, $jSOSr.RDT_CID] = params[0, $jSOSr.RDT_CID], _a[0, $jSOSr.TTCLID] = params[0, $jSOSr.TTCLID], _a[0, $jSOSr.TWCLID] = params[0, $jSOSr.TWCLID], _a[0, $jSOSr.WBRAID] = params[0, $jSOSr.WBRAID], _a;
    };
    return CampaignParser;
}();

});


parcelRegister("6rHk0", function(module, exports) {

$parcel$export(module.exports, "OfflineDisabled", () => $4b16de7ac5082187$export$92e9c636606b8eed);
var $4b16de7ac5082187$export$92e9c636606b8eed = null;

});

parcelRegister("lplbV", function(module, exports) {

$parcel$export(module.exports, "runQueuedFunctions", () => $f95c5eeb3acf9d5c$export$73e72da30c1b0013);
$parcel$export(module.exports, "convertProxyObjectToRealObject", () => $f95c5eeb3acf9d5c$export$2804ceeb41243ddf);
$parcel$export(module.exports, "isInstanceProxy", () => $f95c5eeb3acf9d5c$export$cca5e90941913a5a);
/**
 * Applies the proxied functions on the proxied amplitude snippet to an instance of the real object.
 * @ignore
 */ var $f95c5eeb3acf9d5c$export$73e72da30c1b0013 = function(instance, queue) {
    $f95c5eeb3acf9d5c$export$2804ceeb41243ddf(instance, queue);
};
var $f95c5eeb3acf9d5c$export$2804ceeb41243ddf = function(instance, queue) {
    for(var i = 0; i < queue.length; i++){
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === 'function') {
            var result = fn.apply(instance, args);
            if (typeof resolve === 'function') resolve(result === null || result === void 0 ? void 0 : result.promise);
        }
    }
    return instance;
};
var $f95c5eeb3acf9d5c$export$cca5e90941913a5a = function(instance) {
    var instanceProxy = instance;
    return instanceProxy && instanceProxy._q !== undefined;
};

});

parcelRegister("kdJza", function(module, exports) {

$parcel$export(module.exports, "Context", () => $eb885e05deb36e90$export$841858b892ce1f4c);

var $7WQrb = parcelRequire("7WQrb");

var $dfxGV = parcelRequire("dfxGV");

var $jJFF7 = parcelRequire("jJFF7");

var $1Prms = parcelRequire("1Prms");

var $2enti = parcelRequire("2enti");
var $eb885e05deb36e90$var$BROWSER_PLATFORM = 'Web';
var $eb885e05deb36e90$var$IP_ADDRESS = '$remote';
var $eb885e05deb36e90$export$841858b892ce1f4c = /** @class */ function() {
    function Context() {
        this.name = '@amplitude/plugin-context-browser';
        this.type = 'before';
        this.library = "".concat((0, $2enti.LIBPREFIX), "/").concat((0, $1Prms.VERSION));
        /* istanbul ignore else */ if (typeof navigator !== 'undefined') this.userAgent = navigator.userAgent;
    }
    Context.prototype.setup = function(config) {
        this.config = config;
        return Promise.resolve(undefined);
    };
    Context.prototype.execute = function(context) {
        var _a, _b;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var time, lastEventId, nextEventId, event;
            return (0, $7WQrb.__generator)(this, function(_c) {
                time = new Date().getTime();
                lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
                nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
                this.config.lastEventId = nextEventId;
                if (!context.time) this.config.lastEventTime = time;
                event = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({
                    user_id: this.config.userId,
                    device_id: this.config.deviceId,
                    session_id: this.config.sessionId,
                    time: time
                }, this.config.appVersion && {
                    app_version: this.config.appVersion
                }), this.config.trackingOptions.platform && {
                    platform: $eb885e05deb36e90$var$BROWSER_PLATFORM
                }), this.config.trackingOptions.language && {
                    language: (0, $jJFF7.getLanguage)()
                }), this.config.trackingOptions.ipAddress && {
                    ip: $eb885e05deb36e90$var$IP_ADDRESS
                }), {
                    insert_id: (0, $dfxGV.UUID)(),
                    partner_id: this.config.partnerId,
                    plan: this.config.plan
                }), this.config.ingestionMetadata && {
                    ingestion_metadata: {
                        source_name: this.config.ingestionMetadata.sourceName,
                        source_version: this.config.ingestionMetadata.sourceVersion
                    }
                }), context), {
                    event_id: nextEventId,
                    library: this.library,
                    user_agent: this.userAgent
                });
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    return Context;
}();

});
parcelRegister("jJFF7", function(module, exports) {

$parcel$export(module.exports, "getLanguage", () => $e5e289873f46e05f$export$64783e31db14f0ba);
var $e5e289873f46e05f$export$64783e31db14f0ba = function() {
    var _a, _b, _c, _d;
    if (typeof navigator === 'undefined') return '';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var userLanguage = navigator.userLanguage;
    return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : '';
};

});

parcelRegister("1Prms", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $154fc740256abbec$export$a4ad2735b021c132);
var $154fc740256abbec$export$a4ad2735b021c132 = '2.11.12';

});

parcelRegister("2enti", function(module, exports) {

$parcel$export(module.exports, "LIBPREFIX", () => $19ff188e0b2e1e97$export$cf504a7bb41ef3ce);
var $19ff188e0b2e1e97$export$cf504a7bb41ef3ce = 'amplitude-ts';

});


parcelRegister("hqbIh", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $caedf364fcb33375$export$d09f50d9ab7f7b69);
$parcel$export(module.exports, "useBrowserConfig", () => $caedf364fcb33375$export$4e33c75a470874a8);

var $7WQrb = parcelRequire("7WQrb");

var $5pHkT = parcelRequire("5pHkT");

var $dS5JL = parcelRequire("dS5JL");
var $6rW2W = parcelRequire("6rW2W");
var $heo0o = parcelRequire("heo0o");
var $dfxGV = parcelRequire("dfxGV");

var $3435Q = parcelRequire("3435Q");
var $fN20k = parcelRequire("fN20k");
var $eEyxp = parcelRequire("eEyxp");
var $lHjhy = parcelRequire("lHjhy");

var $13B4I = parcelRequire("13B4I");

var $bDTvd = parcelRequire("bDTvd");

var $8fmyD = parcelRequire("8fmyD");

var $lsY5i = parcelRequire("lsY5i");

var $786ou = parcelRequire("786ou");

var $aV8mG = parcelRequire("aV8mG");
// Exported for testing purposes only. Do not expose to public interface.
var $caedf364fcb33375$export$d1ed917d271ca014 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(BrowserConfig, _super);
    function BrowserConfig(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled) {
        if (cookieStorage === void 0) cookieStorage = new (0, $heo0o.MemoryStorage)();
        if (cookieOptions === void 0) cookieOptions = {
            domain: '',
            expiration: 365,
            sameSite: 'Lax',
            secure: false,
            upgrade: true
        };
        if (flushIntervalMillis === void 0) flushIntervalMillis = 1000;
        if (flushMaxRetries === void 0) flushMaxRetries = 5;
        if (flushQueueSize === void 0) flushQueueSize = 30;
        if (identityStorage === void 0) identityStorage = (0, $aV8mG.DEFAULT_IDENTITY_STORAGE);
        if (loggerProvider === void 0) loggerProvider = new (0, $6rW2W.Logger)();
        if (logLevel === void 0) logLevel = (0, $5pHkT.LogLevel).Warn;
        if (offline === void 0) offline = false;
        if (optOut === void 0) optOut = false;
        if (serverUrl === void 0) serverUrl = '';
        if (serverZone === void 0) serverZone = (0, $aV8mG.DEFAULT_SERVER_ZONE);
        if (sessionTimeout === void 0) sessionTimeout = 1800000;
        if (storageProvider === void 0) storageProvider = new (0, $13B4I.LocalStorage)({
            loggerProvider: loggerProvider
        });
        if (trackingOptions === void 0) trackingOptions = {
            ipAddress: true,
            language: true,
            platform: true
        };
        if (transport === void 0) transport = 'fetch';
        if (useBatch === void 0) useBatch = false;
        if (fetchRemoteConfig === void 0) fetchRemoteConfig = false;
        var _this = _super.call(this, {
            apiKey: apiKey,
            storageProvider: storageProvider,
            transportProvider: $caedf364fcb33375$export$d09f50d9ab7f7b69(transport)
        }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.autocapture = autocapture;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this.fetchRemoteConfig = fetchRemoteConfig;
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.debugLogsEnabled = debugLogsEnabled;
        _this.loggerProvider.enable(debugLogsEnabled ? (0, $5pHkT.LogLevel).Debug : _this.logLevel);
        return _this;
    }
    Object.defineProperty(BrowserConfig.prototype, "cookieStorage", {
        get: function() {
            return this._cookieStorage;
        },
        set: function(cookieStorage) {
            if (this._cookieStorage !== cookieStorage) {
                this._cookieStorage = cookieStorage;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deviceId", {
        get: function() {
            return this._deviceId;
        },
        set: function(deviceId) {
            if (this._deviceId !== deviceId) {
                this._deviceId = deviceId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "userId", {
        get: function() {
            return this._userId;
        },
        set: function(userId) {
            if (this._userId !== userId) {
                this._userId = userId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "sessionId", {
        get: function() {
            return this._sessionId;
        },
        set: function(sessionId) {
            if (this._sessionId !== sessionId) {
                this._sessionId = sessionId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            if (this._optOut !== optOut) {
                this._optOut = optOut;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventTime", {
        get: function() {
            return this._lastEventTime;
        },
        set: function(lastEventTime) {
            if (this._lastEventTime !== lastEventTime) {
                this._lastEventTime = lastEventTime;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventId", {
        get: function() {
            return this._lastEventId;
        },
        set: function(lastEventId) {
            if (this._lastEventId !== lastEventId) {
                this._lastEventId = lastEventId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "pageCounter", {
        get: function() {
            return this._pageCounter;
        },
        set: function(pageCounter) {
            if (this._pageCounter !== pageCounter) {
                this._pageCounter = pageCounter;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "debugLogsEnabled", {
        set: function(debugLogsEnabled) {
            if (this._debugLogsEnabled !== debugLogsEnabled) {
                this._debugLogsEnabled = debugLogsEnabled;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    BrowserConfig.prototype.updateStorage = function() {
        var cache = {
            deviceId: this._deviceId,
            userId: this._userId,
            sessionId: this._sessionId,
            optOut: this._optOut,
            lastEventTime: this._lastEventTime,
            lastEventId: this._lastEventId,
            pageCounter: this._pageCounter,
            debugLogsEnabled: this._debugLogsEnabled
        };
        this.cookieStorage.set((0, $eEyxp.getCookieName)(this.apiKey), cache);
    };
    return BrowserConfig;
}((0, $dS5JL.Config));
var $caedf364fcb33375$export$4e33c75a470874a8 = function(apiKey, options, amplitudeInstance) {
    if (options === void 0) options = {};
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        var identityStorage, cookieOptions, _a, _b, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        return (0, $7WQrb.__generator)(this, function(_3) {
            switch(_3.label){
                case 0:
                    identityStorage = options.identityStorage || (0, $aV8mG.DEFAULT_IDENTITY_STORAGE);
                    _c = {};
                    if (!(identityStorage !== (0, $aV8mG.DEFAULT_IDENTITY_STORAGE))) return [
                        3 /*break*/ ,
                        1
                    ];
                    _a = '';
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 1:
                    if (!((_e = (_d = options.cookieOptions) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = _e;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $caedf364fcb33375$export$cf2a7e4ae2c1bb19()
                    ];
                case 3:
                    _b = _3.sent();
                    _3.label = 4;
                case 4:
                    _a = _b;
                    _3.label = 5;
                case 5:
                    cookieOptions = (0, $7WQrb.__assign).apply(void 0, [
                        (_c.domain = _a, _c.expiration = 365, _c.sameSite = 'Lax', _c.secure = false, _c.upgrade = true, _c),
                        options.cookieOptions
                    ]);
                    cookieStorage = $caedf364fcb33375$export$2fbfb3607a72373e(options.identityStorage, cookieOptions);
                    return [
                        4 /*yield*/ ,
                        (0, $786ou.parseLegacyCookies)(apiKey, cookieStorage, (_g = (_f = options.cookieOptions) === null || _f === void 0 ? void 0 : _f.upgrade) !== null && _g !== void 0 ? _g : true)
                    ];
                case 6:
                    legacyCookies = _3.sent();
                    return [
                        4 /*yield*/ ,
                        cookieStorage.get((0, $eEyxp.getCookieName)(apiKey))
                    ];
                case 7:
                    previousCookies = _3.sent();
                    queryParams = (0, $lHjhy.getQueryParams)();
                    deviceId = (_m = (_l = (_k = (_j = (_h = options.deviceId) !== null && _h !== void 0 ? _h : queryParams.ampDeviceId) !== null && _j !== void 0 ? _j : queryParams.deviceId) !== null && _k !== void 0 ? _k : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _l !== void 0 ? _l : legacyCookies.deviceId) !== null && _m !== void 0 ? _m : (0, $dfxGV.UUID)();
                    lastEventId = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _o !== void 0 ? _o : legacyCookies.lastEventId;
                    lastEventTime = (_p = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _p !== void 0 ? _p : legacyCookies.lastEventTime;
                    optOut = (_r = (_q = options.optOut) !== null && _q !== void 0 ? _q : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _r !== void 0 ? _r : legacyCookies.optOut;
                    sessionId = (_s = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _s !== void 0 ? _s : legacyCookies.sessionId;
                    userId = (_u = (_t = options.userId) !== null && _t !== void 0 ? _t : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _u !== void 0 ? _u : legacyCookies.userId;
                    amplitudeInstance.previousSessionDeviceId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _v !== void 0 ? _v : legacyCookies.deviceId;
                    amplitudeInstance.previousSessionUserId = (_w = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _w !== void 0 ? _w : legacyCookies.userId;
                    trackingOptions = {
                        ipAddress: (_y = (_x = options.trackingOptions) === null || _x === void 0 ? void 0 : _x.ipAddress) !== null && _y !== void 0 ? _y : true,
                        language: (_0 = (_z = options.trackingOptions) === null || _z === void 0 ? void 0 : _z.language) !== null && _0 !== void 0 ? _0 : true,
                        platform: (_2 = (_1 = options.trackingOptions) === null || _1 === void 0 ? void 0 : _1.platform) !== null && _2 !== void 0 ? _2 : true
                    };
                    pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
                    debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
                    // Override default tracking options if autocapture is set
                    if (options.autocapture !== undefined) options.defaultTracking = options.autocapture;
                    browserConfig = new $caedf364fcb33375$export$d1ed917d271ca014(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled);
                    return [
                        4 /*yield*/ ,
                        browserConfig.storageProvider.isEnabled()
                    ];
                case 8:
                    if (!_3.sent()) {
                        browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
                        browserConfig.storageProvider = new (0, $heo0o.MemoryStorage)();
                    }
                    return [
                        2 /*return*/ ,
                        browserConfig
                    ];
            }
        });
    });
};
var $caedf364fcb33375$export$2fbfb3607a72373e = function(identityStorage, cookieOptions) {
    if (identityStorage === void 0) identityStorage = (0, $aV8mG.DEFAULT_IDENTITY_STORAGE);
    if (cookieOptions === void 0) cookieOptions = {};
    switch(identityStorage){
        case 'localStorage':
            return new (0, $13B4I.LocalStorage)();
        case 'sessionStorage':
            return new (0, $bDTvd.SessionStorage)();
        case 'none':
            return new (0, $heo0o.MemoryStorage)();
        case 'cookie':
        default:
            return new (0, $3435Q.CookieStorage)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, cookieOptions), {
                expirationDays: cookieOptions.expiration
            }));
    }
};
var $caedf364fcb33375$export$d09f50d9ab7f7b69 = function(transport) {
    if (transport === 'xhr') return new (0, $8fmyD.XHRTransport)();
    if (transport === 'beacon') return new (0, $lsY5i.SendBeaconTransport)();
    return new (0, $fN20k.FetchTransport)();
};
var $caedf364fcb33375$export$cf2a7e4ae2c1bb19 = function(url) {
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        var host, parts, levels, storageKey, i, i, domain, options, storage, value;
        return (0, $7WQrb.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new (0, $3435Q.CookieStorage)().isEnabled()
                    ];
                case 1:
                    if (!_a.sent() || !url && (typeof location === 'undefined' || !location.hostname)) return [
                        2 /*return*/ ,
                        ''
                    ];
                    host = url !== null && url !== void 0 ? url : location.hostname;
                    parts = host.split('.');
                    levels = [];
                    storageKey = 'AMP_TLDTEST';
                    for(i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < levels.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    domain = levels[i];
                    options = {
                        domain: '.' + domain
                    };
                    storage = new (0, $3435Q.CookieStorage)(options);
                    return [
                        4 /*yield*/ ,
                        storage.set(storageKey, 1)
                    ];
                case 3:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        storage.get(storageKey)
                    ];
                case 4:
                    value = _a.sent();
                    if (!value) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        storage.remove(storageKey)
                    ];
                case 5:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        '.' + domain
                    ];
                case 6:
                    i++;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        ''
                    ];
            }
        });
    });
};

});
parcelRegister("heo0o", function(module, exports) {

$parcel$export(module.exports, "MemoryStorage", () => $c8b65d6cd3f2aa0c$export$d7392285c701ecf5);

var $7WQrb = parcelRequire("7WQrb");
var $c8b65d6cd3f2aa0c$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {
        this.memoryStorage = new Map();
    }
    MemoryStorage.prototype.isEnabled = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    MemoryStorage.prototype.get = function(key) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.memoryStorage.get(key)
                ];
            });
        });
    };
    MemoryStorage.prototype.getRaw = function(key) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var value;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.get(key)
                        ];
                    case 1:
                        value = _a.sent();
                        return [
                            2 /*return*/ ,
                            value ? JSON.stringify(value) : undefined
                        ];
                }
            });
        });
    };
    MemoryStorage.prototype.set = function(key, value) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                this.memoryStorage.set(key, value);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.remove = function(key) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                this.memoryStorage.delete(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.reset = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                this.memoryStorage.clear();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return MemoryStorage;
}();

});

parcelRegister("3435Q", function(module, exports) {

$parcel$export(module.exports, "CookieStorage", () => $23b42516b7a61caf$export$dae7d845015939d5);

var $7WQrb = parcelRequire("7WQrb");

var $aiiqn = parcelRequire("aiiqn");
var $23b42516b7a61caf$export$dae7d845015939d5 = /** @class */ function() {
    function CookieStorage(options) {
        this.options = (0, $7WQrb.__assign)({}, options);
    }
    CookieStorage.prototype.isEnabled = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var testStrorage, testKey, value, _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!(0, $aiiqn.getGlobalScope)()) return [
                            2 /*return*/ ,
                            false
                        ];
                        CookieStorage.testValue = String(Date.now());
                        testStrorage = new CookieStorage(this.options);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStrorage.set(testKey, CookieStorage.testValue)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStrorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === CookieStorage.testValue
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStrorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.get = function(key) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var value, decodedValue;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        try {
                            decodedValue = (_a = $23b42516b7a61caf$var$decodeCookiesAsDefault(value)) !== null && _a !== void 0 ? _a : $23b42516b7a61caf$var$decodeCookiesWithDoubleUrlEncoding(value);
                            if (decodedValue === undefined) {
                                console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                            return [
                                2 /*return*/ ,
                                JSON.parse(decodedValue)
                            ];
                        } catch (_c) {
                            console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.getRaw = function(key) {
        var _a, _b;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var globalScope, cookie, match;
            return (0, $7WQrb.__generator)(this, function(_c) {
                globalScope = (0, $aiiqn.getGlobalScope)();
                cookie = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split('; ')) !== null && _b !== void 0 ? _b : [];
                match = cookie.find(function(c) {
                    return c.indexOf(key + '=') === 0;
                });
                if (!match) return [
                    2 /*return*/ ,
                    undefined
                ];
                return [
                    2 /*return*/ ,
                    match.substring(key.length + 1)
                ];
            });
        });
    };
    CookieStorage.prototype.set = function(key, value) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var expirationDays, expires, expireDate, date, str, globalScope, errorMessage;
            return (0, $7WQrb.__generator)(this, function(_b) {
                try {
                    expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
                    expires = value !== null ? expirationDays : -1;
                    expireDate = undefined;
                    if (expires) {
                        date = new Date();
                        date.setTime(date.getTime() + expires * 86400000);
                        expireDate = date;
                    }
                    str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
                    if (expireDate) str += "; expires=".concat(expireDate.toUTCString());
                    str += '; path=/';
                    if (this.options.domain) str += "; domain=".concat(this.options.domain);
                    if (this.options.secure) str += '; Secure';
                    if (this.options.sameSite) str += "; SameSite=".concat(this.options.sameSite);
                    globalScope = (0, $aiiqn.getGlobalScope)();
                    if (globalScope) globalScope.document.cookie = str;
                } catch (error) {
                    errorMessage = error instanceof Error ? error.message : String(error);
                    console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CookieStorage.prototype.remove = function(key) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.set(key, null)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.reset = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return CookieStorage;
}();
var $23b42516b7a61caf$var$decodeCookiesAsDefault = function(value) {
    try {
        return decodeURIComponent(atob(value));
    } catch (_a) {
        return undefined;
    }
};
var $23b42516b7a61caf$var$decodeCookiesWithDoubleUrlEncoding = function(value) {
    // Modern Ruby (v7+) automatically encodes cookies with URL encoding by
    // https://api.rubyonrails.org/classes/ActionDispatch/Cookies.html
    try {
        return decodeURIComponent(atob(decodeURIComponent(value)));
    } catch (_a) {
        return undefined;
    }
};

});

parcelRegister("fN20k", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $b7ecfc9f7da0e237$export$2bdee3f9b92f4e82);

var $7WQrb = parcelRequire("7WQrb");

var $ehMAW = parcelRequire("ehMAW");
var $b7ecfc9f7da0e237$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport.prototype.send = function(serverUrl, payload) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var options, response, responseText;
            return (0, $7WQrb.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        /* istanbul ignore if */ if (typeof fetch === 'undefined') throw new Error('FetchTransport is not supported');
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*'
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        responseText = _a.sent();
                        try {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            return [
                                2 /*return*/ ,
                                this.buildResponse(JSON.parse(responseText))
                            ];
                        } catch (_b) {
                            return [
                                2 /*return*/ ,
                                this.buildResponse({
                                    code: response.status
                                })
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FetchTransport;
}((0, $ehMAW.BaseTransport));

});
parcelRegister("ehMAW", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $a668592448fbf4c7$export$74b99d619e90f481);
/* eslint-disable @typescript-eslint/no-unsafe-argument */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-call */ 
var $jmOoi = parcelRequire("jmOoi");
var $a668592448fbf4c7$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') return null;
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case (0, $jmOoi.Status).Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case (0, $jmOoi.Status).Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case (0, $jmOoi.Status).PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case (0, $jmOoi.Status).RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case (0, $jmOoi.Status).Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) return (0, $jmOoi.Status).Success;
        if (code === 429) return (0, $jmOoi.Status).RateLimit;
        if (code === 413) return (0, $jmOoi.Status).PayloadTooLarge;
        if (code === 408) return (0, $jmOoi.Status).Timeout;
        if (code >= 400 && code < 500) return (0, $jmOoi.Status).Invalid;
        if (code >= 500) return (0, $jmOoi.Status).Failed;
        return (0, $jmOoi.Status).Unknown;
    };
    return BaseTransport;
}();

});


parcelRegister("eEyxp", function(module, exports) {

$parcel$export(module.exports, "getCookieName", () => $aaaf979cba2fdb89$export$4820a8f23184d6a3);
$parcel$export(module.exports, "getOldCookieName", () => $aaaf979cba2fdb89$export$5689a36821966445);

var $gLIQ3 = parcelRequire("gLIQ3");
var $aaaf979cba2fdb89$export$4820a8f23184d6a3 = function(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, $gLIQ3.AMPLITUDE_PREFIX),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};
var $aaaf979cba2fdb89$export$5689a36821966445 = function(apiKey) {
    return "".concat((0, $gLIQ3.AMPLITUDE_PREFIX).toLowerCase(), "_").concat(apiKey.substring(0, 6));
};

});

parcelRegister("13B4I", function(module, exports) {

$parcel$export(module.exports, "LocalStorage", () => $0c52d49d352b6eba$export$19fffca37ef3e106);

var $7WQrb = parcelRequire("7WQrb");

var $aiiqn = parcelRequire("aiiqn");

var $aoqUM = parcelRequire("aoqUM");
var $0c52d49d352b6eba$var$MAX_ARRAY_LENGTH = 1000;
var $0c52d49d352b6eba$export$19fffca37ef3e106 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(LocalStorage, _super);
    function LocalStorage(config) {
        var _this = this;
        var _a;
        _this = _super.call(this, (_a = (0, $aiiqn.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.localStorage) || this;
        _this.loggerProvider = config === null || config === void 0 ? void 0 : config.loggerProvider;
        return _this;
    }
    LocalStorage.prototype.set = function(key, value) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var droppedEventsCount;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(Array.isArray(value) && value.length > $0c52d49d352b6eba$var$MAX_ARRAY_LENGTH)) return [
                            3 /*break*/ ,
                            2
                        ];
                        droppedEventsCount = value.length - $0c52d49d352b6eba$var$MAX_ARRAY_LENGTH;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value.slice(0, $0c52d49d352b6eba$var$MAX_ARRAY_LENGTH))
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.loggerProvider) === null || _a === void 0 || _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat($0c52d49d352b6eba$var$MAX_ARRAY_LENGTH, "."));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value)
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return LocalStorage;
}((0, $aoqUM.BrowserStorage));

});
parcelRegister("aoqUM", function(module, exports) {

$parcel$export(module.exports, "BrowserStorage", () => $7911060428fc5e33$export$2baa60fa09b100be);

var $7WQrb = parcelRequire("7WQrb");
var $7911060428fc5e33$export$2baa60fa09b100be = /** @class */ function() {
    function BrowserStorage(storage) {
        this.storage = storage;
    }
    BrowserStorage.prototype.isEnabled = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var random, testStorage, testKey, value, _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!this.storage) return [
                            2 /*return*/ ,
                            false
                        ];
                        random = String(Date.now());
                        testStorage = new BrowserStorage(this.storage);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStorage.set(testKey, random)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === random
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.get = function(key) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var value, _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [
                            2 /*return*/ ,
                            JSON.parse(value)
                        ];
                    case 2:
                        _a = _b.sent();
                        console.error("[Amplitude] Error: Could not get value from storage");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.getRaw = function(key) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || undefined
                ];
            });
        });
    };
    BrowserStorage.prototype.set = function(key, value) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.setItem(key, JSON.stringify(value));
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.remove = function(key) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.removeItem(key);
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.reset = function() {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.clear();
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return BrowserStorage;
}();

});


parcelRegister("bDTvd", function(module, exports) {

$parcel$export(module.exports, "SessionStorage", () => $879e63d940c7212d$export$2c4b17e1c2e0931);

var $7WQrb = parcelRequire("7WQrb");

var $aiiqn = parcelRequire("aiiqn");

var $aoqUM = parcelRequire("aoqUM");
var $879e63d940c7212d$export$2c4b17e1c2e0931 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(SessionStorage, _super);
    function SessionStorage() {
        var _a;
        return _super.call(this, (_a = (0, $aiiqn.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
    }
    return SessionStorage;
}((0, $aoqUM.BrowserStorage));

});

parcelRegister("8fmyD", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $601138ef32aac612$export$874a283af77e8e62);

var $7WQrb = parcelRequire("7WQrb");

var $ehMAW = parcelRequire("ehMAW");
var $601138ef32aac612$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            done: 4
        };
        return _this;
    }
    XHRTransport.prototype.send = function(serverUrl, payload) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        /* istanbul ignore if */ if (typeof XMLHttpRequest === 'undefined') reject(new Error('XHRTransport is not supported.'));
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', serverUrl, true);
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === _this.state.done) {
                                var responseText = xhr.responseText;
                                try {
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                                    resolve(_this.buildResponse(JSON.parse(responseText)));
                                } catch (_a) {
                                    resolve(_this.buildResponse({
                                        code: xhr.status
                                    }));
                                }
                            }
                        };
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.setRequestHeader('Accept', '*/*');
                        xhr.send(JSON.stringify(payload));
                    })
                ];
            });
        });
    };
    return XHRTransport;
}((0, $ehMAW.BaseTransport));

});

parcelRegister("lsY5i", function(module, exports) {

$parcel$export(module.exports, "SendBeaconTransport", () => $fa0ad2046dddeaf0$export$ee278d31d20f1075);

var $7WQrb = parcelRequire("7WQrb");

var $aiiqn = parcelRequire("aiiqn");

var $ehMAW = parcelRequire("ehMAW");
var $fa0ad2046dddeaf0$export$ee278d31d20f1075 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(SendBeaconTransport, _super);
    function SendBeaconTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendBeaconTransport.prototype.send = function(serverUrl, payload) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var globalScope = (0, $aiiqn.getGlobalScope)();
                        /* istanbul ignore if */ if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) throw new Error('SendBeaconTransport is not supported');
                        try {
                            var data = JSON.stringify(payload);
                            var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
                            if (success) return resolve(_this.buildResponse({
                                code: 200,
                                events_ingested: payload.events.length,
                                payload_size_bytes: data.length,
                                server_upload_time: Date.now()
                            }));
                            return resolve(_this.buildResponse({
                                code: 500
                            }));
                        } catch (e) {
                            reject(e);
                        }
                    })
                ];
            });
        });
    };
    return SendBeaconTransport;
}((0, $ehMAW.BaseTransport));

});

parcelRegister("786ou", function(module, exports) {

$parcel$export(module.exports, "parseLegacyCookies", () => $530e3d7b614e18b3$export$641739d2a35dd5dd);

var $7WQrb = parcelRequire("7WQrb");

var $eEyxp = parcelRequire("eEyxp");
var $530e3d7b614e18b3$export$641739d2a35dd5dd = function(apiKey, cookieStorage, deleteLegacyCookies) {
    if (deleteLegacyCookies === void 0) deleteLegacyCookies = true;
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    cookieName = (0, $eEyxp.getOldCookieName)(apiKey);
                    return [
                        4 /*yield*/ ,
                        cookieStorage.getRaw(cookieName)
                    ];
                case 1:
                    cookies = _b.sent();
                    if (!cookies) return [
                        2 /*return*/ ,
                        {
                            optOut: false
                        }
                    ];
                    if (!deleteLegacyCookies) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        cookieStorage.remove(cookieName)
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = (0, $7WQrb.__read)(cookies.split('.'), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
                    return [
                        2 /*return*/ ,
                        {
                            deviceId: deviceId,
                            userId: $530e3d7b614e18b3$export$2f872c0f2117be69(userId),
                            sessionId: $530e3d7b614e18b3$export$c9698ec7f05a07e1(sessionId),
                            lastEventId: $530e3d7b614e18b3$export$c9698ec7f05a07e1(lastEventId),
                            lastEventTime: $530e3d7b614e18b3$export$c9698ec7f05a07e1(lastEventTime),
                            optOut: Boolean(optOut)
                        }
                    ];
            }
        });
    });
};
var $530e3d7b614e18b3$export$c9698ec7f05a07e1 = function(num) {
    var integer = parseInt(num, 32);
    if (isNaN(integer)) return undefined;
    return integer;
};
var $530e3d7b614e18b3$export$2f872c0f2117be69 = function(value) {
    if (!atob || !escape || !value) return undefined;
    try {
        return decodeURIComponent(escape(atob(value)));
    } catch (_a) {
        return undefined;
    }
};

});

parcelRegister("aV8mG", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_START_EVENT", () => $020d40e470a67866$export$d1eb2ccafb450617);
$parcel$export(module.exports, "DEFAULT_FORM_SUBMIT_EVENT", () => $020d40e470a67866$export$8576ca1a5042bc32);
$parcel$export(module.exports, "DEFAULT_FILE_DOWNLOAD_EVENT", () => $020d40e470a67866$export$dd2608f2cca69490);
$parcel$export(module.exports, "DEFAULT_SESSION_START_EVENT", () => $020d40e470a67866$export$c7d032b40f04ffe5);
$parcel$export(module.exports, "DEFAULT_SESSION_END_EVENT", () => $020d40e470a67866$export$406b0196920039c5);
$parcel$export(module.exports, "FILE_EXTENSION", () => $020d40e470a67866$export$8cc480dee0a96fad);
$parcel$export(module.exports, "FILE_NAME", () => $020d40e470a67866$export$4b79612785fd8d50);
$parcel$export(module.exports, "LINK_ID", () => $020d40e470a67866$export$13cfab8db9b47f6d);
$parcel$export(module.exports, "LINK_TEXT", () => $020d40e470a67866$export$d089d67a4077bf08);
$parcel$export(module.exports, "LINK_URL", () => $020d40e470a67866$export$1ac552145aa3025b);
$parcel$export(module.exports, "FORM_ID", () => $020d40e470a67866$export$5f1ba54ed64fd212);
$parcel$export(module.exports, "FORM_NAME", () => $020d40e470a67866$export$bc6883368baba346);
$parcel$export(module.exports, "FORM_DESTINATION", () => $020d40e470a67866$export$d10a870b47f53964);
$parcel$export(module.exports, "DEFAULT_IDENTITY_STORAGE", () => $020d40e470a67866$export$a1811fbf689077b2);
$parcel$export(module.exports, "DEFAULT_SERVER_ZONE", () => $020d40e470a67866$export$a07dea27df63211a);
var $020d40e470a67866$export$6d3ea26de30f4823 = '[Amplitude]';
var $020d40e470a67866$export$e11a4b165d6c1798 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Page Viewed");
var $020d40e470a67866$export$d1eb2ccafb450617 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Form Started");
var $020d40e470a67866$export$8576ca1a5042bc32 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Form Submitted");
var $020d40e470a67866$export$dd2608f2cca69490 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " File Downloaded");
var $020d40e470a67866$export$c7d032b40f04ffe5 = 'session_start';
var $020d40e470a67866$export$406b0196920039c5 = 'session_end';
var $020d40e470a67866$export$8cc480dee0a96fad = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " File Extension");
var $020d40e470a67866$export$4b79612785fd8d50 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " File Name");
var $020d40e470a67866$export$13cfab8db9b47f6d = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Link ID");
var $020d40e470a67866$export$d089d67a4077bf08 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Link Text");
var $020d40e470a67866$export$1ac552145aa3025b = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Link URL");
var $020d40e470a67866$export$5f1ba54ed64fd212 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Form ID");
var $020d40e470a67866$export$bc6883368baba346 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Form Name");
var $020d40e470a67866$export$d10a870b47f53964 = "".concat($020d40e470a67866$export$6d3ea26de30f4823, " Form Destination");
var $020d40e470a67866$export$a1811fbf689077b2 = 'cookie';
var $020d40e470a67866$export$a07dea27df63211a = 'US';

});


parcelRegister("681up", function(module, exports) {

$parcel$export(module.exports, "pageViewTrackingPlugin", () => $4764a533cfb79591$export$a3128c6802358466);

var $7WQrb = parcelRequire("7WQrb");

var $jSOSr = parcelRequire("jSOSr");
var $9BVYv = parcelRequire("9BVYv");
var $aiiqn = parcelRequire("aiiqn");

var $ayMRi = parcelRequire("ayMRi");

var $1RL0F = parcelRequire("1RL0F");
var $4764a533cfb79591$export$5574584aeaaa1a29 = '[Amplitude] Page Viewed';
var $4764a533cfb79591$export$a3128c6802358466 = function(options) {
    if (options === void 0) options = {};
    var amplitude;
    var globalScope = (0, $aiiqn.getGlobalScope)();
    var loggerProvider = undefined;
    var pushState;
    var localConfig;
    var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a = options.eventType, eventType = _a === void 0 ? $4764a533cfb79591$export$5574584aeaaa1a29 : _a;
    var getDecodeURI = function(locationStr) {
        var decodedLocationStr = locationStr;
        try {
            decodedLocationStr = decodeURI(locationStr);
        } catch (e) {
            /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.error('Malformed URI sequence: ', e);
        }
        return decodedLocationStr;
    };
    var createPageViewEvent = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var locationHREF, _a;
            var _b;
            return (0, $7WQrb.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        locationHREF = getDecodeURI(typeof location !== 'undefined' && location.href || '');
                        _b = {
                            event_type: eventType
                        };
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            $4764a533cfb79591$var$getCampaignParams()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (_b.event_properties = (0, $7WQrb.__assign).apply(void 0, [
                                (0, $7WQrb.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    '[Amplitude] Page Domain': /* istanbul ignore next */ typeof location !== 'undefined' && location.hostname || '',
                                    '[Amplitude] Page Location': locationHREF,
                                    '[Amplitude] Page Path': /* istanbul ignore next */ typeof location !== 'undefined' && getDecodeURI(location.pathname) || '',
                                    '[Amplitude] Page Title': /* istanbul ignore next */ typeof document !== 'undefined' && document.title || '',
                                    '[Amplitude] Page URL': locationHREF.split('?')[0]
                                }
                            ]), _b)
                        ];
                }
            });
        });
    };
    var shouldTrackOnPageLoad = function() {
        return typeof trackOn === 'undefined' || typeof trackOn === 'function' && trackOn();
    };
    /* istanbul ignore next */ var previousURL = typeof location !== 'undefined' ? location.href : null;
    var trackHistoryPageView = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var newURL, shouldTrackPageView, _a, _b, _c;
            return (0, $7WQrb.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        newURL = location.href;
                        shouldTrackPageView = $4764a533cfb79591$export$aa1b813607a1c442(trackHistoryChanges, newURL, previousURL || '') && shouldTrackOnPageLoad();
                        // Note: Update `previousURL` in the same clock tick as `shouldTrackHistoryPageView()`
                        // This was previously done after `amplitude?.track(await createPageViewEvent());` and
                        // causes a concurrency issue where app triggers `pushState` twice with the same URL target
                        // but `previousURL` is only updated after the second `pushState` producing two page viewed events
                        previousURL = newURL;
                        if (!shouldTrackPageView) return [
                            3 /*break*/ ,
                            4
                        ];
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Tracking page view event');
                        if (!(amplitude === null || amplitude === void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = void 0;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        _c = (_b = amplitude).track;
                        return [
                            4 /*yield*/ ,
                            createPageViewEvent()
                        ];
                    case 2:
                        _a = _c.apply(_b, [
                            _d.sent()
                        ]);
                        _d.label = 3;
                    case 3:
                        _a;
                        _d.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /* istanbul ignore next */ var trackHistoryPageViewWrapper = function() {
        trackHistoryPageView();
    };
    var plugin = {
        name: '@amplitude/plugin-page-view-tracking-browser',
        type: 'enrichment',
        setup: function(config, client) {
            return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b;
                return (0, $7WQrb.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            amplitude = client;
                            localConfig = config;
                            loggerProvider = config.loggerProvider;
                            loggerProvider.log('Installing @amplitude/plugin-page-view-tracking-browser');
                            if (globalScope) {
                                globalScope.addEventListener('popstate', trackHistoryPageViewWrapper);
                                // Save reference to original push state, to be used in teardown
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                pushState = globalScope.history.pushState;
                                /* istanbul ignore next */ // There is no global browser listener for changes to history, so we have
                                // to modify pushState directly.
                                // https://stackoverflow.com/a/64927639
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                    apply: function(target, thisArg, _a) {
                                        var _b = (0, $7WQrb.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        trackHistoryPageView();
                                    }
                                });
                            }
                            if (!shouldTrackOnPageLoad()) return [
                                3 /*break*/ ,
                                2
                            ];
                            loggerProvider.log('Tracking page view event');
                            _b = (_a = amplitude).track;
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            _b.apply(_a, [
                                _c.sent()
                            ]);
                            _c.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function(event) {
            return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
                var pageViewEvent;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(trackOn === 'attribution' && $4764a533cfb79591$var$isCampaignEvent(event))) return [
                                3 /*break*/ ,
                                2
                            ];
                            /* istanbul ignore next */ // loggerProvider should be defined by the time execute is invoked
                            loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Enriching campaign event to page view event with campaign parameters');
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            pageViewEvent = _a.sent();
                            event.event_type = pageViewEvent.event_type;
                            event.event_properties = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, event.event_properties), pageViewEvent.event_properties);
                            _a.label = 2;
                        case 2:
                            // Update the pageCounter for the page view event
                            if (localConfig && event.event_type === eventType) {
                                localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                                event.event_properties = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, event.event_properties), {
                                    '[Amplitude] Page Counter': localConfig.pageCounter
                                });
                            }
                            return [
                                2 /*return*/ ,
                                event
                            ];
                    }
                });
            });
        },
        teardown: function() {
            return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
                return (0, $7WQrb.__generator)(this, function(_a) {
                    if (globalScope) {
                        globalScope.removeEventListener('popstate', trackHistoryPageViewWrapper);
                        if (pushState) globalScope.history.pushState = pushState;
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }
    };
    return plugin;
};
var $4764a533cfb79591$var$getCampaignParams = function() {
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        var _a;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $1RL0F.omitUndefined);
                    return [
                        4 /*yield*/ ,
                        new (0, $9BVYv.CampaignParser)().parse()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ])
                    ];
            }
        });
    });
};
var $4764a533cfb79591$var$isCampaignEvent = function(event) {
    if (event.event_type === '$identify' && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[(0, $ayMRi.IdentifyOperation).SET] || {};
        var $unset = properties[(0, $ayMRi.IdentifyOperation).UNSET] || {};
        var userProperties_1 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(Object.keys($set)), false), (0, $7WQrb.__read)(Object.keys($unset)), false);
        return Object.keys((0, $jSOSr.BASE_CAMPAIGN)).every(function(value) {
            return userProperties_1.includes(value);
        });
    }
    return false;
};
var $4764a533cfb79591$export$aa1b813607a1c442 = function(trackingOption, newURLStr, oldURLStr) {
    switch(trackingOption){
        case 'pathOnly':
            if (oldURLStr == '') return true;
            var newURL = new URL(newURLStr);
            var oldURL = new URL(oldURLStr);
            var newBaseStr = newURL.origin + newURL.pathname;
            var oldBaseStr = oldURL.origin + oldURL.pathname;
            return newBaseStr !== oldBaseStr;
        default:
            return newURLStr !== oldURLStr;
    }
};

});
parcelRegister("1RL0F", function(module, exports) {

$parcel$export(module.exports, "omitUndefined", () => $15bf34d365b9df0c$export$d8a2b83131ad9e60);
var $15bf34d365b9df0c$export$d8a2b83131ad9e60 = function(input) {
    var obj = {};
    for(var key in input){
        var val = input[key];
        if (val) obj[key] = val;
    }
    return obj;
};

});


parcelRegister("k3IGs", function(module, exports) {

$parcel$export(module.exports, "formInteractionTracking", () => $e9a6bfc0b2692465$export$9860fa124eec1ec4);

var $7WQrb = parcelRequire("7WQrb");

var $aV8mG = parcelRequire("aV8mG");

var $aiiqn = parcelRequire("aiiqn");
var $e9a6bfc0b2692465$export$9860fa124eec1ec4 = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-form-interaction-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                // The form interaction plugin observes changes in the dom. For this to work correctly, the observer can only be setup
                // after the body is built. When Amplitud gets initialized in a script tag, the body tag is still unavailable. So register this
                // only after the window is loaded
                /* istanbul ignore next */ (_a = (0, $aiiqn.getGlobalScope)()) === null || _a === void 0 || _a.addEventListener('load', function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addFormInteractionListener = function(form) {
                        var hasFormChanged = false;
                        addEventListener(form, 'change', function() {
                            var _a;
                            var formDestination = $e9a6bfc0b2692465$export$3906a216b8191dfd(form);
                            if (!hasFormChanged) amplitude.track((0, $aV8mG.DEFAULT_FORM_START_EVENT), (_a = {}, _a[0, $aV8mG.FORM_ID] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.id), _a[0, $aV8mG.FORM_NAME] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.name), _a[0, $aV8mG.FORM_DESTINATION] = formDestination, _a));
                            hasFormChanged = true;
                        });
                        addEventListener(form, 'submit', function() {
                            var _a, _b;
                            var formDestination = $e9a6bfc0b2692465$export$3906a216b8191dfd(form);
                            if (!hasFormChanged) amplitude.track((0, $aV8mG.DEFAULT_FORM_START_EVENT), (_a = {}, _a[0, $aV8mG.FORM_ID] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.id), _a[0, $aV8mG.FORM_NAME] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.name), _a[0, $aV8mG.FORM_DESTINATION] = formDestination, _a));
                            amplitude.track((0, $aV8mG.DEFAULT_FORM_SUBMIT_EVENT), (_b = {}, _b[0, $aV8mG.FORM_ID] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.id), _b[0, $aV8mG.FORM_NAME] = $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce(form.name), _b[0, $aV8mG.FORM_DESTINATION] = formDestination, _b));
                            hasFormChanged = false;
                        });
                    };
                    // Adds listener to existing anchor tags
                    var forms = Array.from(document.getElementsByTagName('form'));
                    forms.forEach(addFormInteractionListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'FORM') addFormInteractionListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('form')).map(addFormInteractionListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};
var $e9a6bfc0b2692465$export$fa9b0e03aaaa96ce = function(name) {
    /* istanbul ignore if */ if (typeof name !== 'string') // We found instances where the value of `name` is an Element and not a string.
    // Elements may have circular references and would throw an error when passed to `JSON.stringify(...)`.
    // If a non-string value is seen, assume there is no value.
    return undefined;
    return name;
};
var $e9a6bfc0b2692465$export$3906a216b8191dfd = function(form) {
    var formDestination = form.getAttribute('action');
    try {
        // eslint-disable-next-line no-restricted-globals
        formDestination = new URL(encodeURI(formDestination !== null && formDestination !== void 0 ? formDestination : ''), window.location.href).href;
    } catch (_a) {
    //
    }
    return formDestination;
};

});

parcelRegister("iEjoG", function(module, exports) {

$parcel$export(module.exports, "fileDownloadTracking", () => $d93b0247994c542e$export$25832376988a00f6);

var $7WQrb = parcelRequire("7WQrb");

var $aV8mG = parcelRequire("aV8mG");

var $aiiqn = parcelRequire("aiiqn");
var $d93b0247994c542e$export$25832376988a00f6 = function() {
    var observer;
    var eventListeners = [];
    var addEventListener = function(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-file-download-tracking-browser';
    var type = 'enrichment';
    var setup = function(config, amplitude) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                // The form interaction plugin observes changes in the dom. For this to work correctly, the observer can only be setup
                // after the body is built. When Amplitud gets initialized in a script tag, the body tag is still unavailable. So register this
                // only after the window is loaded
                /* istanbul ignore next */ (_a = (0, $aiiqn.getGlobalScope)()) === null || _a === void 0 || _a.addEventListener('load', function() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addFileDownloadListener = function(a) {
                        var url;
                        try {
                            // eslint-disable-next-line no-restricted-globals
                            url = new URL(a.href, window.location.href);
                        } catch (_a) {
                            /* istanbul ignore next */ return;
                        }
                        var result = ext.exec(url.href);
                        var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                        if (fileExtension) addEventListener(a, 'click', function() {
                            var _a;
                            if (fileExtension) amplitude.track((0, $aV8mG.DEFAULT_FILE_DOWNLOAD_EVENT), (_a = {}, _a[0, $aV8mG.FILE_EXTENSION] = fileExtension, _a[0, $aV8mG.FILE_NAME] = url.pathname, _a[0, $aV8mG.LINK_ID] = a.id, _a[0, $aV8mG.LINK_TEXT] = a.text, _a[0, $aV8mG.LINK_URL] = a.href, _a));
                        });
                    };
                    var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
                    // Adds listener to existing anchor tags
                    var links = Array.from(document.getElementsByTagName('a'));
                    links.forEach(addFileDownloadListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'A') addFileDownloadListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('a')).map(addFileDownloadListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};

});

parcelRegister("54dDS", function(module, exports) {

$parcel$export(module.exports, "detNotify", () => $3b07e88666590173$export$baa23c8b1e397239);
var $3b07e88666590173$var$notified = false;
var $3b07e88666590173$export$baa23c8b1e397239 = function(config) {
    if ($3b07e88666590173$var$notified || config.defaultTracking !== undefined) return;
    var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
    config.loggerProvider.warn(message);
    $3b07e88666590173$var$notified = true;
};
var $3b07e88666590173$export$6e4b3a224ceeea2a = function() {
    $3b07e88666590173$var$notified = false;
};

});

parcelRegister("2s0rJ", function(module, exports) {

$parcel$export(module.exports, "networkConnectivityCheckerPlugin", () => $1c8e8aea53eee367$export$20326a3f5f1d9791);

var $7WQrb = parcelRequire("7WQrb");

var $aiiqn = parcelRequire("aiiqn");
var $1c8e8aea53eee367$export$20326a3f5f1d9791 = function() {
    var name = '@amplitude/plugin-network-checker-browser';
    var type = 'before';
    var globalScope = (0, $aiiqn.getGlobalScope)();
    var eventListeners = [];
    var addNetworkListener = function(type, handler) {
        if (globalScope) {
            globalScope.addEventListener(type, handler);
            eventListeners.push({
                type: type,
                handler: handler
            });
        }
    };
    var removeNetworkListeners = function() {
        eventListeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            if (globalScope) globalScope.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var setup = function(config, amplitude) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                if (typeof navigator === 'undefined') {
                    config.loggerProvider.debug('Network connectivity checker plugin is disabled because navigator is not available.');
                    config.offline = false;
                    return [
                        2 /*return*/ 
                    ];
                }
                config.offline = !navigator.onLine;
                addNetworkListener('online', function() {
                    config.loggerProvider.debug('Network connectivity changed to online.');
                    config.offline = false;
                    // Flush immediately will cause ERR_NETWORK_CHANGED
                    setTimeout(function() {
                        amplitude.flush();
                    }, config.flushIntervalMillis);
                });
                addNetworkListener('offline', function() {
                    config.loggerProvider.debug('Network connectivity changed to offline.');
                    config.offline = true;
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                removeNetworkListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        teardown: teardown
    };
};

});

parcelRegister("ay8KK", function(module, exports) {

$parcel$export(module.exports, "createBrowserJoinedConfigGenerator", () => $7ae3de88777e932a$export$cbdcfbed9d0fad88);

var $7WQrb = parcelRequire("7WQrb");

var $9EMAG = parcelRequire("9EMAG");

var $dS5JL = parcelRequire("dS5JL");
var $7ae3de88777e932a$export$92897824b7f024e7 = /** @class */ function() {
    function BrowserJoinedConfigGenerator(localConfig) {
        this.config = localConfig;
        this.config.loggerProvider.debug('Local configuration before merging with remote config', JSON.stringify(this.config, null, 2));
    }
    BrowserJoinedConfigGenerator.prototype.initialize = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, $9EMAG.createRemoteConfigFetch)({
                                localConfig: this.config,
                                configKeys: [
                                    'analyticsSDK'
                                ]
                            })
                        ];
                    case 1:
                        _a.remoteConfigFetch = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserJoinedConfigGenerator.prototype.generateJoinedConfig = function() {
        var _a, _b, _c;
        var _d;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var remoteConfig, _e, e_1;
            return (0, $7WQrb.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _f.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _e = this.remoteConfigFetch;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('analyticsSDK', 'browserSDK', this.config.sessionId)
                        ];
                    case 1:
                        _e = _f.sent();
                        _f.label = 2;
                    case 2:
                        remoteConfig = _e;
                        this.config.loggerProvider.debug('Remote configuration:', JSON.stringify(remoteConfig, null, 2));
                        // merge remoteConfig.autocapture and this.config.autocapture
                        // if a field is in remoteConfig.autocapture, use that value
                        // if a field is not in remoteConfig.autocapture, use the value from this.config.autocapture
                        if (remoteConfig && 'autocapture' in remoteConfig) {
                            if (typeof remoteConfig.autocapture === 'boolean') this.config.autocapture = remoteConfig.autocapture;
                            if (typeof remoteConfig.autocapture === 'object') {
                                if (this.config.autocapture === undefined) this.config.autocapture = remoteConfig.autocapture;
                                if (typeof this.config.autocapture === 'boolean') this.config.autocapture = (0, $7WQrb.__assign)({
                                    attribution: this.config.autocapture,
                                    fileDownloads: this.config.autocapture,
                                    formInteractions: this.config.autocapture,
                                    pageViews: this.config.autocapture,
                                    sessions: this.config.autocapture,
                                    elementInteractions: this.config.autocapture
                                }, remoteConfig.autocapture);
                                if (typeof this.config.autocapture === 'object') this.config.autocapture = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.config.autocapture), remoteConfig.autocapture);
                            }
                            // Override default tracking options if autocapture is updated by remote config
                            this.config.defaultTracking = this.config.autocapture;
                        }
                        this.config.loggerProvider.debug('Joined configuration: ', JSON.stringify(this.config, null, 2));
                        (_a = (_d = this.config).requestMetadata) !== null && _a !== void 0 ? _a : _d.requestMetadata = new (0, $dS5JL.RequestMetadata)();
                        if ((_b = this.remoteConfigFetch) === null || _b === void 0 ? void 0 : _b.metrics.fetchTimeAPISuccess) this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_success', this.remoteConfigFetch.metrics.fetchTimeAPISuccess);
                        if ((_c = this.remoteConfigFetch) === null || _c === void 0 ? void 0 : _c.metrics.fetchTimeAPIFail) this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_fail', this.remoteConfigFetch.metrics.fetchTimeAPIFail);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _f.sent();
                        this.config.loggerProvider.error('Failed to fetch remote configuration because of error: ', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.config
                        ];
                }
            });
        });
    };
    return BrowserJoinedConfigGenerator;
}();
var $7ae3de88777e932a$export$cbdcfbed9d0fad88 = function(localConfig) {
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        var joinedConfigGenerator;
        return (0, $7WQrb.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    joinedConfigGenerator = new $7ae3de88777e932a$export$92897824b7f024e7(localConfig);
                    return [
                        4 /*yield*/ ,
                        joinedConfigGenerator.initialize()
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        joinedConfigGenerator
                    ];
            }
        });
    });
};

});
parcelRegister("9EMAG", function(module, exports) {

$parcel$export(module.exports, "createRemoteConfigFetch", () => $707d8a993189b5b0$export$7a3c00b7d3a9d561);

var $4wbTp = parcelRequire("4wbTp");
var $707d8a993189b5b0$export$7a3c00b7d3a9d561 = $4wbTp.createRemoteConfigFetch;

});
parcelRegister("4wbTp", function(module, exports) {

$parcel$export(module.exports, "createRemoteConfigFetch", () => $34a3603940661309$export$7a3c00b7d3a9d561);

var $7WQrb = parcelRequire("7WQrb");

var $ehMAW = parcelRequire("ehMAW");

var $4kagy = parcelRequire("4kagy");
var $jmOoi = parcelRequire("jmOoi");
var $34a3603940661309$var$UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, remote config fetch failed';
var $34a3603940661309$var$SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var $34a3603940661309$var$MAX_RETRIES_EXCEEDED_MESSAGE = 'Remote config fetch rejected due to exceeded retry count';
var $34a3603940661309$var$TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var $34a3603940661309$var$UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var $34a3603940661309$export$f176a68f93d1169b = 'https://sr-client-cfg.amplitude.com/config';
var $34a3603940661309$export$557cb299ba3f9edf = 'https://sr-client-cfg.stag2.amplitude.com/config';
var $34a3603940661309$export$4e157f75ce52a111 = 'https://sr-client-cfg.eu.amplitude.com/config';
var $34a3603940661309$export$91805d21bf5f9610 = /** @class */ function() {
    function RemoteConfigFetch(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1000;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
            return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                var fetchStartTime, configAPIResponse, remoteConfig;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fetchStartTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                this.fetchWithTimeout(sessionId)
                            ];
                        case 1:
                            configAPIResponse = _a.sent();
                            if (configAPIResponse) {
                                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                                if (remoteConfig) {
                                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                                    return [
                                        2 /*return*/ ,
                                        remoteConfig[key]
                                    ];
                                }
                            }
                            this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        this.fetchWithTimeout = function(sessionId) {
            return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                var controller, timeoutId, remoteConfig;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            controller = new AbortController();
                            timeoutId = setTimeout(function() {
                                return controller.abort();
                            }, 5000);
                            return [
                                4 /*yield*/ ,
                                this.fetchRemoteConfig(controller.signal, sessionId)
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            clearTimeout(timeoutId);
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
            return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                var urlParams, _a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
                var e_2, _c;
                var _d;
                return (0, $7WQrb.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $34a3603940661309$var$MAX_RETRIES_EXCEEDED_MESSAGE
                                })
                            ];
                            else if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $34a3603940661309$var$TIMEOUT_MESSAGE
                                })
                            ];
                            else if (sessionId !== this.lastFetchedSessionId) {
                                this.lastFetchedSessionId = sessionId;
                                this.attempts = 0;
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            urlParams = new URLSearchParams({
                                api_key: this.localConfig.apiKey
                            });
                            try {
                                for(_a = (0, $7WQrb.__values)(this.configKeys), _b = _a.next(); !_b.done; _b = _a.next()){
                                    configKey = _b.value;
                                    urlParams.append('config_keys', configKey);
                                }
                            } catch (e_2_1) {
                                e_2 = {
                                    error: e_2_1
                                };
                            } finally{
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                } finally{
                                    if (e_2) throw e_2.error;
                                }
                            }
                            if (sessionId) urlParams.set('session_id', String(sessionId));
                            options = {
                                headers: {
                                    Accept: '*/*'
                                },
                                method: 'GET'
                            };
                            serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                            this.attempts += 1;
                            return [
                                4 /*yield*/ ,
                                fetch(serverUrl, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
                                    signal: signal
                                }))
                            ];
                        case 2:
                            res = _e.sent();
                            if (res === null) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $34a3603940661309$var$UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                            parsedStatus = new (0, $ehMAW.BaseTransport)().buildStatus(res.status);
                            switch(parsedStatus){
                                case (0, $jmOoi.Status).Success:
                                    this.attempts = 0;
                                    return [
                                        2 /*return*/ ,
                                        this.parseAndStoreConfig(res)
                                    ];
                                case (0, $jmOoi.Status).Failed:
                                    return [
                                        2 /*return*/ ,
                                        this.retryFetch(signal, sessionId)
                                    ];
                                default:
                                    return [
                                        2 /*return*/ ,
                                        this.completeRequest({
                                            err: $34a3603940661309$var$UNEXPECTED_NETWORK_ERROR_MESSAGE
                                        })
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _e.sent();
                            knownError = e_1;
                            if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $34a3603940661309$var$TIMEOUT_MESSAGE
                                })
                            ];
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: (_d = knownError.message) !== null && _d !== void 0 ? _d : $34a3603940661309$var$UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.retryFetch = function(signal, sessionId) {
            return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, _this.attempts * _this.retryTimeout);
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.fetchRemoteConfig(signal, sessionId)
                            ];
                    }
                });
            });
        };
        this.parseAndStoreConfig = function(res) {
            return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                var remoteConfig;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                res.json()
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            this.completeRequest({
                                success: $34a3603940661309$var$SUCCESS_REMOTE_CONFIG
                            });
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
    }
    RemoteConfigFetch.prototype.getServerUrl = function() {
        if (this.localConfig.serverZone === (0, $4kagy.ServerZone).STAGING) return $34a3603940661309$export$557cb299ba3f9edf;
        if (this.localConfig.serverZone === (0, $4kagy.ServerZone).EU) return $34a3603940661309$export$4e157f75ce52a111;
        return $34a3603940661309$export$f176a68f93d1169b;
    };
    RemoteConfigFetch.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) throw new Error(err);
        else if (success) this.localConfig.loggerProvider.log(success);
    };
    return RemoteConfigFetch;
}();
var $34a3603940661309$export$7a3c00b7d3a9d561 = function(_a) {
    var localConfig = _a.localConfig, configKeys = _a.configKeys;
    return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
        return (0, $7WQrb.__generator)(this, function(_b) {
            return [
                2 /*return*/ ,
                new $34a3603940661309$export$91805d21bf5f9610({
                    localConfig: localConfig,
                    configKeys: configKeys
                })
            ];
        });
    });
};

});
parcelRegister("4kagy", function(module, exports) {

$parcel$export(module.exports, "ServerZone", () => $3260fe454d110d15$export$df0bb87b763999e2);
/**
 * @deprecated use ServerZoneType instead
 */ var $3260fe454d110d15$export$df0bb87b763999e2;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
})($3260fe454d110d15$export$df0bb87b763999e2 || ($3260fe454d110d15$export$df0bb87b763999e2 = {}));

});




parcelRegister("7IKiz", function(module, exports) {

$parcel$export(module.exports, "autocapturePlugin", () => $59f08e601f85d8ba$export$cd485554bb3f53da);

var $7WQrb = parcelRequire("7WQrb");

var $8pDub = parcelRequire("8pDub");

var $9BlWD = parcelRequire("9BlWD");

var $l9kJq = parcelRequire("l9kJq");
var $d4PzE = parcelRequire("d4PzE");
var $6OiYn = parcelRequire("6OiYn");

var $bak9G = parcelRequire("bak9G");

var $8q4Dc = parcelRequire("8q4Dc");

var $BO9iq = parcelRequire("BO9iq");

var $3wfZ5 = parcelRequire("3wfZ5");

var $150Qq = parcelRequire("150Qq");

var $7eLb2 = parcelRequire("7eLb2");
var $59f08e601f85d8ba$export$a217bf5378006153;
(function(ObservablesEnum) {
    ObservablesEnum["ClickObservable"] = "clickObservable";
    ObservablesEnum["ChangeObservable"] = "changeObservable";
    // ErrorObservable = 'errorObservable',
    ObservablesEnum["NavigateObservable"] = "navigateObservable";
    ObservablesEnum["MutationObservable"] = "mutationObservable";
})($59f08e601f85d8ba$export$a217bf5378006153 || ($59f08e601f85d8ba$export$a217bf5378006153 = {}));
function $59f08e601f85d8ba$export$e4f91743485e39de(event) {
    return event.type === 'click' || event.type === 'change';
}
var $59f08e601f85d8ba$export$cd485554bb3f53da = function(options) {
    var _a, _b, _c;
    if (options === void 0) options = {};
    var _d = options.dataAttributePrefix, dataAttributePrefix = _d === void 0 ? (0, $8pDub.DEFAULT_DATA_ATTRIBUTE_PREFIX) : _d, _e = options.visualTaggingOptions, visualTaggingOptions = _e === void 0 ? {
        enabled: true,
        messenger: new (0, $8q4Dc.WindowMessenger)()
    } : _e;
    options.cssSelectorAllowlist = (_a = options.cssSelectorAllowlist) !== null && _a !== void 0 ? _a : (0, $8pDub.DEFAULT_CSS_SELECTOR_ALLOWLIST);
    options.actionClickAllowlist = (_b = options.actionClickAllowlist) !== null && _b !== void 0 ? _b : (0, $8pDub.DEFAULT_ACTION_CLICK_ALLOWLIST);
    options.debounceTime = (_c = options.debounceTime) !== null && _c !== void 0 ? _c : 0; // TODO: update this when rage clicks are added to 1000ms
    var name = $9BlWD.PLUGIN_NAME;
    var type = 'enrichment';
    var subscriptions = [];
    var logger = undefined;
    // Create observables on events on the window
    var createObservables = function() {
        var _a;
        // Create Observables from direct user events
        var clickObservable = (0, $l9kJq.fromEvent)(document, 'click', {
            capture: true
        }).pipe((0, $d4PzE.map)(function(click) {
            return addAdditionalEventProperties(click, 'click');
        }));
        var changeObservable = (0, $l9kJq.fromEvent)(document, 'change', {
            capture: true
        }).pipe((0, $d4PzE.map)(function(change) {
            return addAdditionalEventProperties(change, 'change');
        }));
        // Create Observable from unhandled errors
        // const errorObservable = fromEvent<ErrorEvent>(window, 'error').pipe(
        //   map((error) => addAdditionalEventProperties(error, 'error')),
        // );
        // Create observable for URL changes
        var navigateObservable;
        /* istanbul ignore next */ if (window.navigation) navigateObservable = (0, $l9kJq.fromEvent)(window.navigation, 'navigate').pipe((0, $d4PzE.map)(function(navigate) {
            return addAdditionalEventProperties(navigate, 'navigate');
        }));
        // Track DOM Mutations
        var mutationObservable = new (0, $6OiYn.Observable)(function(observer) {
            var mutationObserver = new MutationObserver(function(mutations) {
                observer.next(mutations);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true
            });
            return function() {
                return mutationObserver.disconnect();
            };
        }).pipe((0, $d4PzE.map)(function(mutation) {
            return addAdditionalEventProperties(mutation, 'mutation');
        }));
        return _a = {}, _a[$59f08e601f85d8ba$export$a217bf5378006153.ClickObservable] = clickObservable, _a[$59f08e601f85d8ba$export$a217bf5378006153.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
        _a[$59f08e601f85d8ba$export$a217bf5378006153.NavigateObservable] = navigateObservable, _a[$59f08e601f85d8ba$export$a217bf5378006153.MutationObservable] = mutationObservable, _a;
    };
    // Returns the Amplitude event properties for the given element.
    var getEventProperties = function(actionType, element) {
        var _a;
        var _b, _c;
        /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
        /* istanbul ignore next */ var rect = typeof element.getBoundingClientRect === 'function' ? element.getBoundingClientRect() : {
            left: null,
            top: null
        };
        var ariaLabel = element.getAttribute('aria-label');
        var attributes = (0, $bak9G.getAttributesWithPrefix)(element, dataAttributePrefix);
        var nearestLabel = (0, $bak9G.getNearestLabel)(element);
        var selector = (0, $bak9G.getSelector)(element, logger);
        /* istanbul ignore next */ var properties = (_a = {}, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.getAttribute('id') || '', _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.getAttribute('class'), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = (0, $BO9iq.getHierarchy)(element), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = (0, $bak9G.getText)(element), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = rect.top == null ? null : Math.round(rect.top), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel, _a[$9BlWD.AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a[$9BlWD.AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document !== 'undefined' && document.title || '', _a[$9BlWD.AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, _a[$9BlWD.AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, _a);
        if (tag === 'a' && actionType === 'click' && element instanceof HTMLAnchorElement) properties[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
        return (0, $bak9G.removeEmptyProperties)(properties);
    };
    var addAdditionalEventProperties = function(event, type) {
        var baseEvent = {
            event: event,
            timestamp: Date.now(),
            type: type
        };
        if ($59f08e601f85d8ba$export$e4f91743485e39de(baseEvent) && baseEvent.event.target !== null) {
            // Retrieve additional event properties from the target element
            var closestTrackedAncestor = (0, $bak9G.getClosestElement)(baseEvent.event.target, options.cssSelectorAllowlist);
            if (closestTrackedAncestor) {
                baseEvent.closestTrackedAncestor = closestTrackedAncestor;
                baseEvent.targetElementProperties = getEventProperties(baseEvent.type, closestTrackedAncestor);
            }
            return baseEvent;
        }
        return baseEvent;
    };
    var setup = function(config, amplitude) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, allowlist, actionClickAllowlist;
            var _a, _b;
            return (0, $7WQrb.__generator)(this, function(_c) {
                logger = config.loggerProvider;
                /* istanbul ignore if */ if (typeof document === 'undefined') return [
                    2 /*return*/ 
                ];
                shouldTrackEvent = (0, $bak9G.createShouldTrackEvent)(options, options.cssSelectorAllowlist);
                shouldTrackActionClick = (0, $bak9G.createShouldTrackEvent)(options, options.actionClickAllowlist);
                allObservables = createObservables();
                clickTrackingSubscription = (0, $3wfZ5.trackClicks)({
                    allObservables: allObservables,
                    options: options,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(clickTrackingSubscription);
                changeSubscription = (0, $150Qq.trackChange)({
                    allObservables: allObservables,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(changeSubscription);
                actionClickSubscription = (0, $7eLb2.trackActionClick)({
                    allObservables: allObservables,
                    options: options,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    shouldTrackActionClick: shouldTrackActionClick
                });
                subscriptions.push(actionClickSubscription);
                /* istanbul ignore next */ (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 || _a.log("".concat(name, " has been successfully added."));
                // Setup visual tagging selector
                if (window.opener && visualTaggingOptions.enabled) {
                    allowlist = options.cssSelectorAllowlist;
                    actionClickAllowlist = options.actionClickAllowlist;
                    /* istanbul ignore next */ (_b = visualTaggingOptions.messenger) === null || _b === void 0 || _b.setup((0, $7WQrb.__assign)((0, $7WQrb.__assign)({
                        logger: config === null || config === void 0 ? void 0 : config.loggerProvider
                    }, (config === null || config === void 0 ? void 0 : config.serverZone) && {
                        endpoint: $9BlWD.AMPLITUDE_ORIGINS_MAP[config.serverZone]
                    }), {
                        isElementSelectable: (0, $bak9G.createShouldTrackEvent)(options, (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(allowlist), false), (0, $7WQrb.__read)(actionClickAllowlist), false)),
                        cssSelectorAllowlist: allowlist,
                        actionClickAllowlist: actionClickAllowlist
                    }));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function(event) {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function() {
        return (0, $7WQrb.__awaiter)(void 0, void 0, void 0, function() {
            var subscriptions_1, subscriptions_1_1, subscription;
            var e_1, _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                try {
                    for(subscriptions_1 = (0, $7WQrb.__values)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                        subscription = subscriptions_1_1.value;
                        subscription.unsubscribe();
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};

});
parcelRegister("8pDub", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", () => $61ff499655fdaaf4$export$b8b480c7efad756c);
$parcel$export(module.exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", () => $61ff499655fdaaf4$export$98ba2b432b1218a9);
$parcel$export(module.exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", () => $61ff499655fdaaf4$export$1546873d565d1ebf);
/**
 * Default CSS selectors to define which elements on the page to track.
 * Extend this list to include additional elements to track. For example:
 * ```
 * autocapturePlugin({
 *    cssSelectorAllowlist: [...DEFAULT_CSS_SELECTOR_ALLOWLIST, ".my-class"],
 * })
 * ```
 */ var $61ff499655fdaaf4$export$b8b480c7efad756c = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'video',
    'audio',
    '[contenteditable="true" i]',
    '[data-amp-default-track]',
    '.amp-default-track'
];
var $61ff499655fdaaf4$export$98ba2b432b1218a9 = 'data-amp-track-';
var $61ff499655fdaaf4$export$1546873d565d1ebf = [
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];

});

parcelRegister("9BlWD", function(module, exports) {

$parcel$export(module.exports, "PLUGIN_NAME", () => $6fd897833c9be364$export$3e69d3882a51f072);
$parcel$export(module.exports, "AMPLITUDE_ELEMENT_CLICKED_EVENT", () => $6fd897833c9be364$export$f3b4383d12baa476);
$parcel$export(module.exports, "AMPLITUDE_ELEMENT_CHANGED_EVENT", () => $6fd897833c9be364$export$85e9bc084297e396);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ID", () => $6fd897833c9be364$export$396cd5ad29ba6170);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_CLASS", () => $6fd897833c9be364$export$9ae6b2f9f20abf50);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_TAG", () => $6fd897833c9be364$export$ae8ed2ec3f47ca91);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_TEXT", () => $6fd897833c9be364$export$6f4405900e290a66);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY", () => $6fd897833c9be364$export$1703b32b7bd9766d);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_HREF", () => $6fd897833c9be364$export$253517022e31d52);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT", () => $6fd897833c9be364$export$9a82fc4a0d569f9f);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP", () => $6fd897833c9be364$export$41bd9356c6ad03b6);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL", () => $6fd897833c9be364$export$fe59f70315258b43);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES", () => $6fd897833c9be364$export$24fead99416f658b);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR", () => $6fd897833c9be364$export$9850e109ec502ba7);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL", () => $6fd897833c9be364$export$a458f4751a32ecbb);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_PAGE_URL", () => $6fd897833c9be364$export$af0bc70234f2db5c);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_PAGE_TITLE", () => $6fd897833c9be364$export$236baf0f9c4fa772);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT", () => $6fd897833c9be364$export$f87aa46d335ec78e);
$parcel$export(module.exports, "AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH", () => $6fd897833c9be364$export$624bc6029c85c6ab);
$parcel$export(module.exports, "AMPLITUDE_ORIGIN", () => $6fd897833c9be364$export$c50606b1594157ca);
$parcel$export(module.exports, "AMPLITUDE_ORIGINS_MAP", () => $6fd897833c9be364$export$89af84b5faccc270);
$parcel$export(module.exports, "AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL", () => $6fd897833c9be364$export$1b9b88568d382c42);
$parcel$export(module.exports, "AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS", () => $6fd897833c9be364$export$37613fce6e64ba0c);
var $6fd897833c9be364$export$3e69d3882a51f072 = '@amplitude/plugin-autocapture-browser';
var $6fd897833c9be364$export$f3b4383d12baa476 = '[Amplitude] Element Clicked';
var $6fd897833c9be364$export$85e9bc084297e396 = '[Amplitude] Element Changed';
var $6fd897833c9be364$export$396cd5ad29ba6170 = '[Amplitude] Element ID';
var $6fd897833c9be364$export$9ae6b2f9f20abf50 = '[Amplitude] Element Class';
var $6fd897833c9be364$export$ae8ed2ec3f47ca91 = '[Amplitude] Element Tag';
var $6fd897833c9be364$export$6f4405900e290a66 = '[Amplitude] Element Text';
var $6fd897833c9be364$export$1703b32b7bd9766d = '[Amplitude] Element Hierarchy';
var $6fd897833c9be364$export$253517022e31d52 = '[Amplitude] Element Href';
var $6fd897833c9be364$export$9a82fc4a0d569f9f = '[Amplitude] Element Position Left';
var $6fd897833c9be364$export$41bd9356c6ad03b6 = '[Amplitude] Element Position Top';
var $6fd897833c9be364$export$fe59f70315258b43 = '[Amplitude] Element Aria Label';
var $6fd897833c9be364$export$24fead99416f658b = '[Amplitude] Element Attributes';
var $6fd897833c9be364$export$9850e109ec502ba7 = '[Amplitude] Element Selector';
var $6fd897833c9be364$export$a458f4751a32ecbb = '[Amplitude] Element Parent Label';
var $6fd897833c9be364$export$af0bc70234f2db5c = '[Amplitude] Page URL';
var $6fd897833c9be364$export$236baf0f9c4fa772 = '[Amplitude] Page Title';
var $6fd897833c9be364$export$f87aa46d335ec78e = '[Amplitude] Viewport Height';
var $6fd897833c9be364$export$624bc6029c85c6ab = '[Amplitude] Viewport Width';
var $6fd897833c9be364$export$c50606b1594157ca = 'https://app.amplitude.com';
var $6fd897833c9be364$export$89cc575d7ddecf21 = 'https://app.eu.amplitude.com';
var $6fd897833c9be364$export$872be238b7ce36de = 'https://apps.stag2.amplitude.com';
var $6fd897833c9be364$export$89af84b5faccc270 = {
    US: $6fd897833c9be364$export$c50606b1594157ca,
    EU: $6fd897833c9be364$export$89cc575d7ddecf21,
    STAGING: $6fd897833c9be364$export$872be238b7ce36de
};
var $6fd897833c9be364$export$1b9b88568d382c42 = 'https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz';
var $6fd897833c9be364$export$37613fce6e64ba0c = 'amp-visual-tagging-selector-highlight';

});

parcelRegister("l9kJq", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $f65a851e0b190f66$export$a36e16046ae8f1bb);

var $7WQrb = parcelRequire("7WQrb");

var $2ypWW = parcelRequire("2ypWW");

var $6OiYn = parcelRequire("6OiYn");

var $63Jtj = parcelRequire("63Jtj");

var $bGCU7 = parcelRequire("bGCU7");

var $gCSeg = parcelRequire("gCSeg");

var $jOyqp = parcelRequire("jOyqp");
var $f65a851e0b190f66$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $f65a851e0b190f66$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $f65a851e0b190f66$var$jqueryMethods = [
    'on',
    'off'
];
function $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $gCSeg.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $jOyqp.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $7WQrb.__read)($f65a851e0b190f66$var$isEventTarget(target) ? $f65a851e0b190f66$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) ? $f65a851e0b190f66$var$nodeEventEmitterMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) ? $f65a851e0b190f66$var$jqueryMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $bGCU7.isArrayLike)(target)) return (0, $63Jtj.mergeMap)(function(subTarget) {
            return $f65a851e0b190f66$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $2ypWW.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) {
    return (0, $gCSeg.isFunction)(target.addListener) && (0, $gCSeg.isFunction)(target.removeListener);
}
function $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) {
    return (0, $gCSeg.isFunction)(target.on) && (0, $gCSeg.isFunction)(target.off);
}
function $f65a851e0b190f66$var$isEventTarget(target) {
    return (0, $gCSeg.isFunction)(target.addEventListener) && (0, $gCSeg.isFunction)(target.removeEventListener);
}

});
parcelRegister("2ypWW", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910);

var $7WQrb = parcelRequire("7WQrb");

var $bGCU7 = parcelRequire("bGCU7");

var $dy1jD = parcelRequire("dy1jD");

var $6OiYn = parcelRequire("6OiYn");

var $rOw2q = parcelRequire("rOw2q");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $fQMll = parcelRequire("fQMll");

var $7gZl2 = parcelRequire("7gZl2");

var $gCSeg = parcelRequire("gCSeg");

var $28DKm = parcelRequire("28DKm");

var $kaCww = parcelRequire("kaCww");
function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $6OiYn.Observable)) return input;
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $bGCU7.isArrayLike)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $dy1jD.isPromise)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $aGtFl.isAsyncIterable)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $fQMll.isIterable)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var obs = obj[0, $kaCww.observable]();
        if ((0, $gCSeg.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $28DKm.reportUnhandledError));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $7WQrb.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $7gZl2.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $7WQrb.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("bGCU7", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $8821cb8787de9fb5$export$1e2f57719e155213);
var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("dy1jD", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $9dcf7896928e75dd$export$4369c812aac99591);

var $gCSeg = parcelRequire("gCSeg");
function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $gCSeg.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});
parcelRegister("gCSeg", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $c1aa42b0603892d6$export$f6e2535fb5126e54);
function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}

});


parcelRegister("6OiYn", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $4f562137a990678a$export$77cea355fa80b5f4);

var $hOMJ7 = parcelRequire("hOMJ7");

var $bgI6x = parcelRequire("bgI6x");

var $kaCww = parcelRequire("kaCww");

var $1itL3 = parcelRequire("1itL3");

var $hmjgn = parcelRequire("hmjgn");

var $gCSeg = parcelRequire("gCSeg");

var $cxQqV = parcelRequire("cxQqV");
var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $hOMJ7.SafeSubscriber)(observerOrNext, error, complete);
        (0, $cxQqV.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $hOMJ7.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $kaCww.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $1itL3.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $hmjgn.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $gCSeg.isFunction)(value.next) && (0, $gCSeg.isFunction)(value.error) && (0, $gCSeg.isFunction)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $hOMJ7.Subscriber) || $4f562137a990678a$var$isObserver(value) && (0, $bgI6x.isSubscription)(value);
}

});
parcelRegister("hOMJ7", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $cf8ce74b80455e9f$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $cf8ce74b80455e9f$export$94eeb6a328cab6c7);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $bgI6x = parcelRequire("bgI6x");

var $hmjgn = parcelRequire("hmjgn");

var $28DKm = parcelRequire("28DKm");

var $75rFk = parcelRequire("75rFk");

var $ZT8xQ = parcelRequire("ZT8xQ");

var $gwzK1 = parcelRequire("gwzK1");

var $cxQqV = parcelRequire("cxQqV");
var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $7WQrb.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $bgI6x.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $bgI6x.Subscription));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $7WQrb.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $gCSeg.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $hmjgn.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) (0, $cxQqV.captureError)(error);
    else (0, $28DKm.reportUnhandledError)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $hmjgn.config).onStoppedNotification;
    onStoppedNotification && (0, $gwzK1.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $75rFk.noop),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $75rFk.noop)
};

});
parcelRegister("bgI6x", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $8343668acd7c4a9b$export$f55210826850c514);
$parcel$export(module.exports, "isSubscription", () => $8343668acd7c4a9b$export$4f9221cbada3c4fc);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $l4W4q = parcelRequire("l4W4q");

var $3JYOM = parcelRequire("3JYOM");
var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $7WQrb.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $gCSeg.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $l4W4q.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $7WQrb.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $l4W4q.UnsubscriptionError)) errors = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(errors)), (0, $7WQrb.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $l4W4q.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $3JYOM.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $3JYOM.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $gCSeg.isFunction)(value.remove) && (0, $gCSeg.isFunction)(value.add) && (0, $gCSeg.isFunction)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $gCSeg.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("l4W4q", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $f587043ffd615a90$export$c9648b76fd580c34);

var $kfFvr = parcelRequire("kfFvr");
var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("kfFvr", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $ebe567a061bc80f6$export$128a15b65d1b6041);
function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("3JYOM", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $2b94c03d07e501cc$export$dae3f38077fc36c0);
function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("hmjgn", function(module, exports) {

$parcel$export(module.exports, "config", () => $ca336efb1b4fb564$export$e506a1d27d1eaa20);
var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("28DKm", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $18eb28ff53cc4943$export$ebf645db02d3e99f);

var $hmjgn = parcelRequire("hmjgn");

var $gwzK1 = parcelRequire("gwzK1");
function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $gwzK1.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $hmjgn.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("gwzK1", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $c07b5bfa3b9d4401$export$365aa6bd3c788e3d);

var $7WQrb = parcelRequire("7WQrb");
var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
        return setTimeout.apply(void 0, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("75rFk", function(module, exports) {

$parcel$export(module.exports, "noop", () => $528e75db69787807$export$8793edee2d425525);
function $528e75db69787807$export$8793edee2d425525() {}

});

parcelRegister("ZT8xQ", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $0ba077a4cdfd9739$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $0ba077a4cdfd9739$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $0ba077a4cdfd9739$export$ff9346b0d1d30313);
var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("cxQqV", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $92213d3dd6a83b5d$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $92213d3dd6a83b5d$export$3e205fbb5df021e0);

var $hmjgn = parcelRequire("hmjgn");
var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}

});


parcelRegister("kaCww", function(module, exports) {

$parcel$export(module.exports, "observable", () => $eaf29fccbded6ed3$export$5ab46cbf6120b33a);
var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("1itL3", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $0f1e8e2d1fe93adf$export$71f88a61afaa14d7);

var $a4Ze1 = parcelRequire("a4Ze1");
function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $a4Ze1.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("a4Ze1", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7569c528cdd9d182$export$f0954fd7d5368655);
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("rOw2q", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $0539b51af1903d0a$export$48c0cddbc99c45c2);

var $kaCww = parcelRequire("kaCww");

var $gCSeg = parcelRequire("gCSeg");
function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $gCSeg.isFunction)(input[0, $kaCww.observable]);
}

});

parcelRegister("aGtFl", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $7c74d6a5e2273447$export$edb10ab8dd75a915);

var $gCSeg = parcelRequire("gCSeg");
function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("iolDb", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $d63b3f5b704e6de4$export$7cbe71b9fa263484);
function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("fQMll", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $b8a13650b96f19ab$export$9652023d9040757);

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");
function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $gCSeg.isFunction)(input === null || input === void 0 ? void 0 : input[0, $ZpNjd.iterator]);
}

});
parcelRegister("ZpNjd", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d);
function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();

});


parcelRegister("7gZl2", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $54b99b9095e84ce4$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $54b99b9095e84ce4$export$c088ffafdba7405f);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");
function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $7WQrb.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $7WQrb.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $7WQrb.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $7WQrb.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("63Jtj", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $46964ba1b403cbfc$export$6b9f6c0d32c093f9);

var $d4PzE = parcelRequire("d4PzE");

var $2ypWW = parcelRequire("2ypWW");

var $d9kQQ = parcelRequire("d9kQQ");

var $dshQu = parcelRequire("dshQu");

var $gCSeg = parcelRequire("gCSeg");
function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $gCSeg.isFunction)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $d4PzE.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $2ypWW.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        return (0, $dshQu.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("d4PzE", function(module, exports) {

$parcel$export(module.exports, "map", () => $9853a79d111e4e33$export$871de8747c9eaa88);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});
parcelRegister("d9kQQ", function(module, exports) {

$parcel$export(module.exports, "operate", () => $992c4a42843eb1d0$export$871731df685d7753);

var $gCSeg = parcelRequire("gCSeg");
function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $gCSeg.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

});

parcelRegister("4QgEI", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $3868f035248205c1$export$b9e075132cc6937f);

var $7WQrb = parcelRequire("7WQrb");

var $hOMJ7 = parcelRequire("hOMJ7");
function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $7WQrb.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $hOMJ7.Subscriber));

});


parcelRegister("dshQu", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $9cbbbba4f565a378$export$600918ebaa9e0a1b);

var $2ypWW = parcelRequire("2ypWW");

var $4yU8l = parcelRequire("4yU8l");

var $4QgEI = parcelRequire("4QgEI");
function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $2ypWW.innerFrom)(project(value, index++)).subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $4yU8l.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});
parcelRegister("4yU8l", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $3525e15e439f8b93$export$a2b7447487315232);
function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});



parcelRegister("jOyqp", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $e6cd63efe08c02de$export$559affaa48f4288d);

var $7WQrb = parcelRequire("7WQrb");

var $d4PzE = parcelRequire("d4PzE");
var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $d4PzE.map)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}

});


parcelRegister("bak9G", function(module, exports) {

$parcel$export(module.exports, "createShouldTrackEvent", () => $8210434268552b67$export$d41a31caec8ff08e);
$parcel$export(module.exports, "isNonSensitiveElement", () => $8210434268552b67$export$ba13c53ef9595524);
$parcel$export(module.exports, "getText", () => $8210434268552b67$export$c72d34660a162238);
$parcel$export(module.exports, "getSelector", () => $8210434268552b67$export$319b9bd79cec4634);
$parcel$export(module.exports, "getAttributesWithPrefix", () => $8210434268552b67$export$96dadf898968aa44);
$parcel$export(module.exports, "removeEmptyProperties", () => $8210434268552b67$export$b2489c11de31bff2);
$parcel$export(module.exports, "getNearestLabel", () => $8210434268552b67$export$f41b77b49e008607);
$parcel$export(module.exports, "getClosestElement", () => $8210434268552b67$export$6eaaca7dcffbc81f);
$parcel$export(module.exports, "getEventTagProps", () => $8210434268552b67$export$6388a9aeecbda4e1);
$parcel$export(module.exports, "asyncLoadScript", () => $8210434268552b67$export$bebc04ef1f521ce0);
$parcel$export(module.exports, "generateUniqueId", () => $8210434268552b67$export$48da330df5248c4c);
$parcel$export(module.exports, "filterOutNonTrackableEvents", () => $8210434268552b67$export$80a5e1fd8987729f);
/* eslint-disable no-restricted-globals */ 
var $d27vT = parcelRequire("d27vT");

var $9BlWD = parcelRequire("9BlWD");
var $8210434268552b67$var$SENSITIVE_TAGS = [
    'input',
    'select',
    'textarea'
];
var $8210434268552b67$export$d41a31caec8ff08e = function(autocaptureOptions, allowlist) {
    return function(actionType, element) {
        var _a, _b, _c;
        var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
        /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        // window, document, and Text nodes have no tag
        if (!tag) return false;
        if (shouldTrackEventResolver) return shouldTrackEventResolver(actionType, element);
        if (!$8210434268552b67$export$4b346a8466ef7a6f(window.location.href, pageUrlAllowlist)) return false;
        /* istanbul ignore next */ var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute('type')) || '';
        if (typeof elementType === 'string') switch(elementType.toLowerCase()){
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
        /* istanbul ignore if */ if (allowlist) {
            var hasMatchAnyAllowedSelector = allowlist.some(function(selector) {
                var _a;
                return !!((_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector));
            });
            if (!hasMatchAnyAllowedSelector) return false;
        }
        switch(tag){
            case 'input':
            case 'select':
            case 'textarea':
                return actionType === 'change' || actionType === 'click';
            default:
                /* istanbul ignore next */ var computedStyle = (_c = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _c === void 0 ? void 0 : _c.call(window, element);
                /* istanbul ignore next */ if (computedStyle && computedStyle.getPropertyValue('cursor') === 'pointer' && actionType === 'click') return true;
                return actionType === 'click';
        }
    };
};
var $8210434268552b67$export$1b79a1ae964a4ac6 = function(text) {
    if (text == null) return false;
    if (typeof text === 'string') {
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((text || '').replace(/[- ]/g, ''))) return false;
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(text)) return false;
    }
    return true;
};
var $8210434268552b67$export$ccbedd67ef6e9417 = function(node) {
    return !!node && node.nodeType === 3;
};
var $8210434268552b67$export$ba13c53ef9595524 = function(element) {
    var _a, _b, _c;
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    var isContentEditable = element instanceof HTMLElement ? ((_c = element.getAttribute('contenteditable')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true' : false;
    return !$8210434268552b67$var$SENSITIVE_TAGS.includes(tag) && !isContentEditable;
};
var $8210434268552b67$export$c72d34660a162238 = function(element) {
    var text = '';
    if ($8210434268552b67$export$ba13c53ef9595524(element) && element.childNodes && element.childNodes.length) element.childNodes.forEach(function(child) {
        var childText = '';
        if ($8210434268552b67$export$ccbedd67ef6e9417(child)) {
            if (child.textContent) childText = child.textContent;
        } else childText = $8210434268552b67$export$c72d34660a162238(child);
        text += childText.split(/(\s+)/).filter($8210434268552b67$export$1b79a1ae964a4ac6).join('').replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ').substring(0, 255);
    });
    return text;
};
var $8210434268552b67$export$319b9bd79cec4634 = function(element, logger) {
    var _a, _b;
    var selector = '';
    try {
        selector = (0, $d27vT.finder)(element, {
            className: function(name) {
                return name !== $9BlWD.AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
            },
            maxNumberOfTries: 1000
        });
        return selector;
    } catch (error) {
        if (logger) {
            var typedError = error;
            logger.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(typedError.toString()));
        }
    }
    // Fall back to use tag, id, and class name, if finder fails.
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (tag) selector = tag;
    var id = element.getAttribute('id');
    var className = element.getAttribute('class');
    if (id) selector = "#".concat(id);
    else if (className) {
        var classes = className.split(' ').filter(function(name) {
            return name !== $9BlWD.AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
        }).join('.');
        if (classes) selector = "".concat(selector, ".").concat(classes);
    }
    return selector;
};
var $8210434268552b67$export$4b346a8466ef7a6f = function(url, pageUrlAllowlist) {
    if (!pageUrlAllowlist || !pageUrlAllowlist.length) return true;
    return pageUrlAllowlist.some(function(allowedUrl) {
        if (typeof allowedUrl === 'string') return url === allowedUrl;
        return url.match(allowedUrl);
    });
};
var $8210434268552b67$export$96dadf898968aa44 = function(element, prefix) {
    return element.getAttributeNames().reduce(function(attributes, attributeName) {
        if (attributeName.startsWith(prefix)) {
            var attributeKey = attributeName.replace(prefix, '');
            var attributeValue = element.getAttribute(attributeName);
            if (attributeKey) attributes[attributeKey] = attributeValue || '';
        }
        return attributes;
    }, {});
};
var $8210434268552b67$export$dd1bc94b04021eeb = function(value) {
    return value === undefined || value === null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};
var $8210434268552b67$export$b2489c11de31bff2 = function(properties) {
    return Object.keys(properties).reduce(function(filteredProperties, key) {
        var value = properties[key];
        if (!$8210434268552b67$export$dd1bc94b04021eeb(value)) filteredProperties[key] = value;
        return filteredProperties;
    }, {});
};
var $8210434268552b67$export$f41b77b49e008607 = function(element) {
    var parent = element.parentElement;
    if (!parent) return '';
    var labelElement;
    try {
        labelElement = parent.querySelector(':scope>span,h1,h2,h3,h4,h5,h6');
    } catch (error) {
        labelElement = null;
    }
    if (labelElement) {
        /* istanbul ignore next */ var labelText = labelElement.textContent || '';
        return $8210434268552b67$export$1b79a1ae964a4ac6(labelText) ? labelText : '';
    }
    return $8210434268552b67$export$f41b77b49e008607(parent);
};
var $8210434268552b67$export$cf9227551c5a1597 = function(root, selectors) {
    if (root && 'querySelectorAll' in root && typeof root.querySelectorAll === 'function') {
        var elementSet = selectors.reduce(function(elements, selector) {
            if (selector) {
                var selectedElements = Array.from(root.querySelectorAll(selector));
                selectedElements.forEach(function(element) {
                    elements.add(element);
                });
            }
            return elements;
        }, new Set());
        return Array.from(elementSet);
    }
    return [];
};
var $8210434268552b67$export$6eaaca7dcffbc81f = function(element, selectors) {
    if (!element) return null;
    /* istanbul ignore next */ if (selectors.some(function(selector) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector);
    })) return element;
    /* istanbul ignore next */ return $8210434268552b67$export$6eaaca7dcffbc81f(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
};
var $8210434268552b67$export$6388a9aeecbda4e1 = function(element, logger) {
    var _a;
    var _b, _c;
    if (!element) return {};
    /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
    var selector = $8210434268552b67$export$319b9bd79cec4634(element, logger);
    var properties = (_a = {}, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = $8210434268552b67$export$c72d34660a162238(element), _a[$9BlWD.AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector, _a[$9BlWD.AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a);
    return $8210434268552b67$export$b2489c11de31bff2(properties);
};
var $8210434268552b67$export$bebc04ef1f521ce0 = function(url) {
    return new Promise(function(resolve, reject) {
        var _a;
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = url;
            scriptElement.addEventListener('load', function() {
                resolve({
                    status: true
                });
            }, {
                once: true
            });
            scriptElement.addEventListener('error', function() {
                reject({
                    status: false,
                    message: "Failed to load the script ".concat(url)
                });
            });
            /* istanbul ignore next */ (_a = document.head) === null || _a === void 0 || _a.appendChild(scriptElement);
        } catch (error) {
            /* istanbul ignore next */ reject(error);
        }
    });
};
function $8210434268552b67$export$48da330df5248c4c() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var $8210434268552b67$export$80a5e1fd8987729f = function(event) {
    // Filter out changeEvent events with no target
    // This could happen when change events are triggered programmatically
    if (event.event.target === null || !event.closestTrackedAncestor) return false;
    return true;
};

});
parcelRegister("d27vT", function(module, exports) {

$parcel$export(module.exports, "finder", () => $97d14a43be2c6ab9$export$ae58c3420da023e7);
/* istanbul ignore file */ 
var $7WQrb = parcelRequire("7WQrb");
var $97d14a43be2c6ab9$var$config;
var $97d14a43be2c6ab9$var$rootDocument;
function $97d14a43be2c6ab9$export$ae58c3420da023e7(input, options) {
    if (input.nodeType !== Node.ELEMENT_NODE) throw new Error("Can't generate CSS selector for non-element node type.");
    if ('html' === input.tagName.toLowerCase()) return 'html';
    var defaults = {
        root: document.body,
        idName: function(_name) {
            return true;
        },
        className: function(_name) {
            return true;
        },
        tagName: function(_name) {
            return true;
        },
        attr: function(_name, _value) {
            return false;
        },
        seedMinLength: 1,
        optimizedMinLength: 2,
        threshold: 1000,
        maxNumberOfTries: 10000
    };
    $97d14a43be2c6ab9$var$config = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, defaults), options);
    $97d14a43be2c6ab9$var$rootDocument = $97d14a43be2c6ab9$var$findRootDocument($97d14a43be2c6ab9$var$config.root, defaults);
    var path = $97d14a43be2c6ab9$var$bottomUpSearch(input, 'all', function() {
        return $97d14a43be2c6ab9$var$bottomUpSearch(input, 'two', function() {
            return $97d14a43be2c6ab9$var$bottomUpSearch(input, 'one', function() {
                return $97d14a43be2c6ab9$var$bottomUpSearch(input, 'none');
            });
        });
    });
    if (path) {
        var optimized = $97d14a43be2c6ab9$var$sort($97d14a43be2c6ab9$var$optimize(path, input));
        if (optimized.length > 0) path = optimized[0];
        return $97d14a43be2c6ab9$var$selector(path);
    } else throw new Error("Selector was not found.");
}
function $97d14a43be2c6ab9$var$findRootDocument(rootNode, defaults) {
    if (rootNode.nodeType === Node.DOCUMENT_NODE) return rootNode;
    if (rootNode === defaults.root) return rootNode.ownerDocument;
    return rootNode;
}
function $97d14a43be2c6ab9$var$bottomUpSearch(input, limit, fallback) {
    var path = null;
    var stack = [];
    var current = input;
    var i = 0;
    var _loop_1 = function() {
        var e_1, _a;
        var level = $97d14a43be2c6ab9$var$maybe($97d14a43be2c6ab9$var$id(current)) || $97d14a43be2c6ab9$var$maybe.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)($97d14a43be2c6ab9$var$attr(current)), false)) || $97d14a43be2c6ab9$var$maybe.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)($97d14a43be2c6ab9$var$classNames(current)), false)) || $97d14a43be2c6ab9$var$maybe($97d14a43be2c6ab9$var$tagName(current)) || [
            $97d14a43be2c6ab9$var$any()
        ];
        var nth = $97d14a43be2c6ab9$var$index(current);
        if (limit == 'all') {
            if (nth) level = level.concat(level.filter($97d14a43be2c6ab9$var$dispensableNth).map(function(node) {
                return $97d14a43be2c6ab9$var$nthChild(node, nth);
            }));
        } else if (limit == 'two') {
            level = level.slice(0, 1);
            if (nth) level = level.concat(level.filter($97d14a43be2c6ab9$var$dispensableNth).map(function(node) {
                return $97d14a43be2c6ab9$var$nthChild(node, nth);
            }));
        } else if (limit == 'one') {
            var _b = (0, $7WQrb.__read)(level = level.slice(0, 1), 1), node = _b[0];
            if (nth && $97d14a43be2c6ab9$var$dispensableNth(node)) level = [
                $97d14a43be2c6ab9$var$nthChild(node, nth)
            ];
        } else if (limit == 'none') {
            level = [
                $97d14a43be2c6ab9$var$any()
            ];
            if (nth) level = [
                $97d14a43be2c6ab9$var$nthChild(level[0], nth)
            ];
        }
        try {
            for(var level_1 = (e_1 = void 0, (0, $7WQrb.__values)(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()){
                var node = level_1_1.value;
                node.level = i;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        stack.push(level);
        if (stack.length >= $97d14a43be2c6ab9$var$config.seedMinLength) {
            path = $97d14a43be2c6ab9$var$findUniquePath(stack, fallback);
            if (path) return "break";
        }
        current = current.parentElement;
        i++;
    };
    while(current){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    if (!path) path = $97d14a43be2c6ab9$var$findUniquePath(stack, fallback);
    if (!path && fallback) return fallback();
    return path;
}
function $97d14a43be2c6ab9$var$findUniquePath(stack, fallback) {
    var e_2, _a;
    // Check first the total number of combinations first since generating the combinations can cause memory exhaustion
    var numCombinations = stack.reduce(function(acc, i) {
        return acc * i.length;
    }, 1);
    if (numCombinations > $97d14a43be2c6ab9$var$config.threshold) return fallback ? fallback() : null;
    var paths = $97d14a43be2c6ab9$var$sort($97d14a43be2c6ab9$var$combinations(stack));
    try {
        for(var paths_1 = (0, $7WQrb.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var candidate = paths_1_1.value;
            if ($97d14a43be2c6ab9$var$unique(candidate)) return candidate;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return null;
}
function $97d14a43be2c6ab9$var$selector(path) {
    var node = path[0];
    var query = node.name;
    for(var i = 1; i < path.length; i++){
        var level = path[i].level || 0;
        if (node.level === level - 1) query = "".concat(path[i].name, " > ").concat(query);
        else query = "".concat(path[i].name, " ").concat(query);
        node = path[i];
    }
    return query;
}
function $97d14a43be2c6ab9$var$penalty(path) {
    return path.map(function(node) {
        return node.penalty;
    }).reduce(function(acc, i) {
        return acc + i;
    }, 0);
}
function $97d14a43be2c6ab9$var$unique(path) {
    var css = $97d14a43be2c6ab9$var$selector(path);
    switch($97d14a43be2c6ab9$var$rootDocument.querySelectorAll(css).length){
        case 0:
            throw new Error("Can't select any node with this selector: ".concat(css));
        case 1:
            return true;
        default:
            return false;
    }
}
function $97d14a43be2c6ab9$var$id(input) {
    var elementId = input.getAttribute('id');
    if (elementId && $97d14a43be2c6ab9$var$config.idName(elementId)) return {
        name: '#' + CSS.escape(elementId),
        penalty: 0
    };
    return null;
}
function $97d14a43be2c6ab9$var$attr(input) {
    var attrs = Array.from(input.attributes).filter(function(attr) {
        return $97d14a43be2c6ab9$var$config.attr(attr.name, attr.value);
    });
    return attrs.map(function(attr) {
        return {
            name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
            penalty: 0.5
        };
    });
}
function $97d14a43be2c6ab9$var$classNames(input) {
    var names = Array.from(input.classList).filter($97d14a43be2c6ab9$var$config.className);
    return names.map(function(name) {
        return {
            name: '.' + CSS.escape(name),
            penalty: 1
        };
    });
}
function $97d14a43be2c6ab9$var$tagName(input) {
    var name = input.tagName.toLowerCase();
    if ($97d14a43be2c6ab9$var$config.tagName(name)) return {
        name: name,
        penalty: 2
    };
    return null;
}
function $97d14a43be2c6ab9$var$any() {
    return {
        name: '*',
        penalty: 3
    };
}
function $97d14a43be2c6ab9$var$index(input) {
    var parent = input.parentNode;
    if (!parent) return null;
    var child = parent.firstChild;
    if (!child) return null;
    var i = 0;
    while(child){
        if (child.nodeType === Node.ELEMENT_NODE) i++;
        if (child === input) break;
        child = child.nextSibling;
    }
    return i;
}
function $97d14a43be2c6ab9$var$nthChild(node, i) {
    return {
        name: node.name + ":nth-child(".concat(i, ")"),
        penalty: node.penalty + 1
    };
}
function $97d14a43be2c6ab9$var$dispensableNth(node) {
    return node.name !== 'html' && !node.name.startsWith('#');
}
function $97d14a43be2c6ab9$var$maybe() {
    var level = [];
    for(var _i = 0; _i < arguments.length; _i++)level[_i] = arguments[_i];
    var list = level.filter($97d14a43be2c6ab9$var$notEmpty);
    if (list.length > 0) return list;
    return null;
}
function $97d14a43be2c6ab9$var$notEmpty(value) {
    return value !== null && value !== undefined;
}
function $97d14a43be2c6ab9$var$combinations(stack, path) {
    var _a, _b, node, e_3_1;
    var e_3, _c;
    if (path === void 0) path = [];
    return (0, $7WQrb.__generator)(this, function(_d) {
        switch(_d.label){
            case 0:
                if (!(stack.length > 0)) return [
                    3 /*break*/ ,
                    9
                ];
                _d.label = 1;
            case 1:
                _d.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _a = (0, $7WQrb.__values)(stack[0]), _b = _a.next();
                _d.label = 2;
            case 2:
                if (!!_b.done) return [
                    3 /*break*/ ,
                    5
                ];
                node = _b.value;
                return [
                    5 /*yield**/ ,
                    (0, $7WQrb.__values)($97d14a43be2c6ab9$var$combinations(stack.slice(1, stack.length), path.concat(node)))
                ];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4:
                _b = _a.next();
                return [
                    3 /*break*/ ,
                    2
                ];
            case 5:
                return [
                    3 /*break*/ ,
                    8
                ];
            case 6:
                e_3_1 = _d.sent();
                e_3 = {
                    error: e_3_1
                };
                return [
                    3 /*break*/ ,
                    8
                ];
            case 7:
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                } finally{
                    if (e_3) throw e_3.error;
                }
                return [
                    7 /*endfinally*/ 
                ];
            case 8:
                return [
                    3 /*break*/ ,
                    11
                ];
            case 9:
                return [
                    4 /*yield*/ ,
                    path
                ];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function $97d14a43be2c6ab9$var$sort(paths) {
    return (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(paths), false).sort(function(a, b) {
        return $97d14a43be2c6ab9$var$penalty(a) - $97d14a43be2c6ab9$var$penalty(b);
    });
}
function $97d14a43be2c6ab9$var$optimize(path, input, scope) {
    var i, newPath, newPathKey;
    if (scope === void 0) scope = {
        counter: 0,
        visited: new Map()
    };
    return (0, $7WQrb.__generator)(this, function(_a) {
        switch(_a.label){
            case 0:
                if (!(path.length > 2 && path.length > $97d14a43be2c6ab9$var$config.optimizedMinLength)) return [
                    3 /*break*/ ,
                    5
                ];
                i = 1;
                _a.label = 1;
            case 1:
                if (!(i < path.length - 1)) return [
                    3 /*break*/ ,
                    5
                ];
                if (scope.counter > $97d14a43be2c6ab9$var$config.maxNumberOfTries) return [
                    2 /*return*/ 
                ]; // Okay At least I tried!
                scope.counter += 1;
                newPath = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(path), false);
                newPath.splice(i, 1);
                newPathKey = $97d14a43be2c6ab9$var$selector(newPath);
                if (scope.visited.has(newPathKey)) return [
                    2 /*return*/ 
                ];
                if (!($97d14a43be2c6ab9$var$unique(newPath) && $97d14a43be2c6ab9$var$same(newPath, input))) return [
                    3 /*break*/ ,
                    4
                ];
                return [
                    4 /*yield*/ ,
                    newPath
                ];
            case 2:
                _a.sent();
                scope.visited.set(newPathKey, true);
                return [
                    5 /*yield**/ ,
                    (0, $7WQrb.__values)($97d14a43be2c6ab9$var$optimize(newPath, input, scope))
                ];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [
                    3 /*break*/ ,
                    1
                ];
            case 5:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function $97d14a43be2c6ab9$var$same(path, input) {
    return $97d14a43be2c6ab9$var$rootDocument.querySelector($97d14a43be2c6ab9$var$selector(path)) === input;
}

});


parcelRegister("8q4Dc", function(module, exports) {

$parcel$export(module.exports, "WindowMessenger", () => $621458187588712f$export$a9edd53e76b2cf6);
/* istanbul ignore file */ /* eslint-disable no-restricted-globals */ 
var $9BlWD = parcelRequire("9BlWD");

var $bak9G = parcelRequire("bak9G");
// TODO: use MessageChannel instead of window.postMessage
var $621458187588712f$export$a9edd53e76b2cf6 = /** @class */ function() {
    function WindowMessenger(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.origin, origin = _c === void 0 ? (0, $9BlWD.AMPLITUDE_ORIGIN) : _c;
        var _this = this;
        this.endpoint = (0, $9BlWD.AMPLITUDE_ORIGIN);
        this.requestCallbacks = {};
        this.onSelect = function(data) {
            _this.notify({
                action: 'element-selected',
                data: data
            });
        };
        this.onTrack = function(type, properties) {
            if (type === 'selector-mode-changed') _this.notify({
                action: 'track-selector-mode-changed',
                data: properties
            });
            else if (type === 'selector-moved') _this.notify({
                action: 'track-selector-moved',
                data: properties
            });
        };
        this.endpoint = origin;
    }
    WindowMessenger.prototype.notify = function(message) {
        var _a, _b, _c, _d;
        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Message sent: ', JSON.stringify(message));
        (_d = (_c = window.opener) === null || _c === void 0 ? void 0 : _c.postMessage) === null || _d === void 0 || _d.call(_c, message, this.endpoint);
    };
    // Send an async request to the parent window
    WindowMessenger.prototype.sendRequest = function(action, args, options) {
        var _this = this;
        if (options === void 0) options = {
            timeout: 15000
        };
        // Create Request ID
        var id = (0, $bak9G.generateUniqueId)();
        var request = {
            id: id,
            action: action,
            args: args
        };
        // Create a Promise that will be resolved when the response is received
        var promise = new Promise(function(resolve, reject) {
            _this.requestCallbacks[id] = {
                resolve: resolve,
                reject: reject
            };
            // Send the request
            _this.notify(request);
            // Handle request timeouts
            if ((options === null || options === void 0 ? void 0 : options.timeout) > 0) setTimeout(function() {
                reject(new Error("".concat(action, " timed out (id: ").concat(id, ")")));
                delete _this.requestCallbacks[id];
            }, options.timeout);
        });
        return promise;
    };
    // Handle messages from the parent window
    WindowMessenger.prototype.handleResponse = function(response) {
        var _a;
        if (!this.requestCallbacks[response.id]) {
            (_a = this.logger) === null || _a === void 0 || _a.warn("No callback found for request id: ".concat(response.id));
            return;
        }
        this.requestCallbacks[response.id].resolve(response.responseData);
        delete this.requestCallbacks[response.id];
    };
    WindowMessenger.prototype.setup = function(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, logger = _b.logger, endpoint = _b.endpoint, isElementSelectable = _b.isElementSelectable, cssSelectorAllowlist = _b.cssSelectorAllowlist, actionClickAllowlist = _b.actionClickAllowlist;
        this.logger = logger;
        // If endpoint is customized, don't override it.
        if (endpoint && this.endpoint === (0, $9BlWD.AMPLITUDE_ORIGIN)) this.endpoint = endpoint;
        var amplitudeVisualTaggingSelectorInstance = null;
        // Attach Event Listener to listen for messages from the parent window
        window.addEventListener('message', function(event) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Message received: ', JSON.stringify(event));
            // Only accept messages from the specified origin
            if (_this.endpoint !== event.origin) return;
            var eventData = event === null || event === void 0 ? void 0 : event.data;
            var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
            // Ignore messages without action
            if (!action) return;
            // If id exists, handle responses to previous requests
            if ('id' in eventData) {
                (_d = (_c = _this.logger) === null || _c === void 0 ? void 0 : _c.debug) === null || _d === void 0 || _d.call(_c, 'Received Response to previous request: ', JSON.stringify(event));
                _this.handleResponse(eventData);
            // If action exists, handle the action using existing handlers
            } else {
                if (action === 'ping') _this.notify({
                    action: 'pong'
                });
                else if (action === 'initialize-visual-tagging-selector') {
                    var actionData_1 = eventData === null || eventData === void 0 ? void 0 : eventData.data;
                    (0, $bak9G.asyncLoadScript)((0, $9BlWD.AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL)).then(function() {
                        var _a;
                        // eslint-disable-next-line
                        amplitudeVisualTaggingSelectorInstance = (_a = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _a === void 0 ? void 0 : _a.call(window, {
                            getEventTagProps: (0, $bak9G.getEventTagProps),
                            isElementSelectable: function(element) {
                                if (isElementSelectable) return isElementSelectable((actionData_1 === null || actionData_1 === void 0 ? void 0 : actionData_1.actionType) || 'click', element);
                                return true;
                            },
                            onTrack: _this.onTrack,
                            onSelect: _this.onSelect,
                            visualHighlightClass: (0, $9BlWD.AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS),
                            messenger: _this,
                            cssSelectorAllowlist: cssSelectorAllowlist,
                            actionClickAllowlist: actionClickAllowlist
                        });
                        _this.notify({
                            action: 'selector-loaded'
                        });
                    }).catch(function() {
                        var _a;
                        (_a = _this.logger) === null || _a === void 0 || _a.warn('Failed to initialize visual tagging selector');
                    });
                } else if (action === 'close-visual-tagging-selector') // eslint-disable-next-line
                (_e = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _e === void 0 || _e.call(amplitudeVisualTaggingSelectorInstance);
            }
        });
        // Notify the parent window that the page has loaded
        this.notify({
            action: 'page-loaded'
        });
    };
    return WindowMessenger;
}();

});

parcelRegister("BO9iq", function(module, exports) {

$parcel$export(module.exports, "getHierarchy", () => $071a5b59cb5fcb4e$export$9447fd3d4b10cb5f);

var $7WQrb = parcelRequire("7WQrb");

var $bak9G = parcelRequire("bak9G");
var $071a5b59cb5fcb4e$var$BLOCKED_ATTRIBUTES = [
    // Already captured elsewhere in the hierarchy object
    'id',
    'class',
    // non-useful and potentially large attribute
    'style',
    // sensitive as prefilled form data may populate this attribute
    'value',
    // DOM events
    'onclick',
    'onchange',
    'oninput',
    'onblur',
    'onsubmit',
    'onfocus',
    'onkeydown',
    'onkeyup',
    'onkeypress',
    // React specific
    'data-reactid',
    'data-react-checksum',
    'data-reactroot'
];
var $071a5b59cb5fcb4e$var$SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = [
    'type'
];
var $071a5b59cb5fcb4e$var$SVG_TAGS = [
    'svg',
    'path',
    'g'
];
var $071a5b59cb5fcb4e$var$HIGHLY_SENSITIVE_INPUT_TYPES = [
    'password',
    'hidden'
];
var $071a5b59cb5fcb4e$var$MAX_ATTRIBUTE_LENGTH = 128;
var $071a5b59cb5fcb4e$var$MAX_HIERARCHY_LENGTH = 1024;
function $071a5b59cb5fcb4e$export$d693bc18648a5069(element) {
    var e_1, _a;
    var _b, _c, _d, _e;
    if (element === null) return null;
    var tagName = String(element.tagName).toLowerCase();
    var properties = {
        tag: tagName
    };
    var siblings = Array.from((_c = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
    if (siblings.length) {
        properties.index = siblings.indexOf(element);
        properties.indexOfType = siblings.filter(function(el) {
            return el.tagName === element.tagName;
        }).indexOf(element);
    }
    var prevSiblingTag = (_e = (_d = element.previousElementSibling) === null || _d === void 0 ? void 0 : _d.tagName) === null || _e === void 0 ? void 0 : _e.toLowerCase();
    if (prevSiblingTag) properties.prevSib = String(prevSiblingTag);
    var id = element.getAttribute('id');
    if (id) properties.id = String(id);
    var classes = Array.from(element.classList);
    if (classes.length) properties.classes = classes;
    var attributes = {};
    var attributesArray = Array.from(element.attributes);
    var filteredAttributes = attributesArray.filter(function(attr) {
        return !$071a5b59cb5fcb4e$var$BLOCKED_ATTRIBUTES.includes(attr.name);
    });
    var isSensitiveElement = !(0, $bak9G.isNonSensitiveElement)(element);
    // if input is hidden or password or for SVGs, skip attribute collection entirely
    if (!$071a5b59cb5fcb4e$var$HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute('type'))) && !$071a5b59cb5fcb4e$var$SVG_TAGS.includes(tagName)) try {
        for(var filteredAttributes_1 = (0, $7WQrb.__values)(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()){
            var attr = filteredAttributes_1_1.value;
            // If sensitive element, only allow certain attributes
            if (isSensitiveElement && !$071a5b59cb5fcb4e$var$SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr.name)) continue;
            // Finally cast attribute value to string and limit attribute value length
            attributes[attr.name] = String(attr.value).substring(0, $071a5b59cb5fcb4e$var$MAX_ATTRIBUTE_LENGTH);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a = filteredAttributes_1.return)) _a.call(filteredAttributes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    if (Object.keys(attributes).length) properties.attrs = attributes;
    return properties;
}
function $071a5b59cb5fcb4e$export$c6fd3ab3f44300d0(targetEl) {
    var ancestors = [];
    if (!targetEl) return ancestors;
    // Add self to the list of ancestors
    ancestors.push(targetEl);
    var current = targetEl.parentElement;
    while(current && current.tagName !== 'HTML'){
        ancestors.push(current);
        current = current.parentElement;
    }
    return ancestors;
}
var $071a5b59cb5fcb4e$export$9447fd3d4b10cb5f = function(element) {
    var hierarchy = [];
    if (!element) return [];
    // Get list of ancestors including itself and get properties at each level in the hierarchy
    var ancestors = $071a5b59cb5fcb4e$export$c6fd3ab3f44300d0(element);
    hierarchy = $071a5b59cb5fcb4e$export$e5b068f7308753f8(ancestors.map(function(el) {
        return $071a5b59cb5fcb4e$export$d693bc18648a5069(el);
    }), $071a5b59cb5fcb4e$var$MAX_HIERARCHY_LENGTH);
    return hierarchy;
};
function $071a5b59cb5fcb4e$export$e5b068f7308753f8(list, bytesLimit) {
    var numChars = 0;
    for(var i = 0; i < list.length; i++){
        var node = list[i];
        if (node === null) // simulate 'None' in python
        numChars += 4;
        else {
            var value = $071a5b59cb5fcb4e$export$75e8ba9babf43fde(node);
            // Using Array.from(string).length instead of string.length
            // to correctly count Unicode characters (including emojis)
            numChars += value ? Array.from(value).length : 4;
        }
        if (numChars > bytesLimit) return list.slice(0, i);
    }
    return list;
}
function $071a5b59cb5fcb4e$export$75e8ba9babf43fde(value, nested) {
    if (nested === void 0) nested = false;
    try {
        if (value == null) {
            // Handle null values
            if (nested) return 'None'; // Represent null as 'None' in Python when nested
            return null; // Return null for top-level null values
        } else if (typeof value === 'string') {
            if (nested) {
                // Escape special characters in nested strings
                value = value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r');
                // Handle quotes in the string
                if (value.includes('"')) return "'".concat(value, "'"); // Wrap in single quotes if it contains double quotes
                if (value.includes("'")) return "\"".concat(value.replace(/'/g, "\\'"), "\""); // Wrap in double quotes and escape single quotes
                return "'".concat(value, "'"); // Default to wrapping in single quotes
            }
            return value; // Return non-nested strings as-is
        } else if (typeof value === 'boolean') // Convert boolean to Python-style capitalized string
        return value ? 'True' : 'False';
        else if (Array.isArray(value)) {
            // Handle arrays by recursively converting each element
            var elements = value.map(function(o) {
                return $071a5b59cb5fcb4e$export$75e8ba9babf43fde(o, true);
            });
            return "[".concat(elements.join(', '), "]");
        } else if (typeof value === 'object') {
            // Handle objects (dictionaries in Python)
            var entries = Object.entries(value).filter(function(_a) {
                var _b = (0, $7WQrb.__read)(_a, 1), key = _b[0];
                return key != null;
            }) // Filter out null keys
            .map(function(_a) {
                var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], val = _b[1];
                return "".concat(String($071a5b59cb5fcb4e$export$75e8ba9babf43fde(key, true)), ": ").concat(String($071a5b59cb5fcb4e$export$75e8ba9babf43fde(val, true)));
            });
            var result = "{".concat(entries.join(', '), "}");
            // Handle single quotes in the resulting string
            if (result.includes("\\'")) result = result.replace(/'/g, "'").replace(/'/g, "\\'");
            return result;
        }
        // For any other types, return their string representation;
        return value.toString();
    } catch (e) {
        // Return null if any error occurs during the conversion
        return null;
    }
}

});

parcelRegister("3wfZ5", function(module, exports) {

$parcel$export(module.exports, "trackClicks", () => $2900c26359055864$export$9219358a81f9347a);

var $7WQrb = parcelRequire("7WQrb");

var $a1PcB = parcelRequire("a1PcB");
var $8E3bi = parcelRequire("8E3bi");
var $3AhZm = parcelRequire("3AhZm");
var $d6DLj = parcelRequire("d6DLj");
var $d4PzE = parcelRequire("d4PzE");
var $a6N5s = parcelRequire("a6N5s");
var $cL6LG = parcelRequire("cL6LG");

var $bak9G = parcelRequire("bak9G");

var $9BlWD = parcelRequire("9BlWD");
var $2900c26359055864$var$RAGE_CLICK_THRESHOLD = 5;
function $2900c26359055864$export$9219358a81f9347a(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, shouldTrackEvent = _a.shouldTrackEvent;
    var clickObservable = allObservables.clickObservable;
    // Trigger if the target of the click event has changed and position is different
    // Keeping track of position is important to avoid false positives when the user clicks on the same
    // element where certain frameworks could replace the element instance between rerenders
    var comparisonTrigger = clickObservable.pipe((0, $cL6LG.pairwise)(), (0, $d6DLj.filter)(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), prev = _b[0], current = _b[1];
        var targetChanged = prev.event.target !== current.event.target;
        /* istanbul ignore next */ var samePos = Math.abs(current.event.screenX - prev.event.screenX) <= 20 && Math.abs(current.event.screenY - prev.event.screenY) <= 20;
        return targetChanged && !samePos;
    }));
    // Trigger if there is no click event within 1 second
    var timeoutTrigger = clickObservable.pipe((0, $8E3bi.debounceTime)(options.debounceTime), (0, $d4PzE.map)(function() {
        return 'timeout';
    }));
    var triggers = (0, $a6N5s.merge)(comparisonTrigger, timeoutTrigger);
    // Get buffers of clicks, if the buffer length is over 5, it is rage click
    var bufferedClicks = clickObservable.pipe((0, $3AhZm.delay)(0), (0, $d6DLj.filter)((0, $bak9G.filterOutNonTrackableEvents)), (0, $d6DLj.filter)(function(click) {
        // Only track clicks on elements that should be tracked,
        return shouldTrackEvent('click', click.closestTrackedAncestor);
    }), (0, $a1PcB.buffer)(triggers));
    return bufferedClicks.subscribe(function(clicks) {
        var e_1, _a;
        // TODO: update this when rage clicks are added
        var clickType = clicks.length >= $2900c26359055864$var$RAGE_CLICK_THRESHOLD ? (0, $9BlWD.AMPLITUDE_ELEMENT_CLICKED_EVENT) : (0, $9BlWD.AMPLITUDE_ELEMENT_CLICKED_EVENT);
        try {
            for(var clicks_1 = (0, $7WQrb.__values)(clicks), clicks_1_1 = clicks_1.next(); !clicks_1_1.done; clicks_1_1 = clicks_1.next()){
                var click = clicks_1_1.value;
                /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track(clickType, click.targetElementProperties, {
                    time: click.timestamp
                });
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (clicks_1_1 && !clicks_1_1.done && (_a = clicks_1.return)) _a.call(clicks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    });
}

});
parcelRegister("a1PcB", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $74d1b7103b4ce3b6$export$ab1029bcae9ddb4a);

var $d9kQQ = parcelRequire("d9kQQ");

var $75rFk = parcelRequire("75rFk");

var $4QgEI = parcelRequire("4QgEI");

var $2ypWW = parcelRequire("2ypWW");
function $74d1b7103b4ce3b6$export$ab1029bcae9ddb4a(closingNotifier) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        (0, $2ypWW.innerFrom)(closingNotifier).subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, (0, $75rFk.noop)));
        return function() {
            currentBuffer = null;
        };
    });
}

});

parcelRegister("8E3bi", function(module, exports) {

$parcel$export(module.exports, "debounceTime", () => $64b486e22e2192ab$export$7843a4469d64c07e);

var $3HO0w = parcelRequire("3HO0w");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $64b486e22e2192ab$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $3HO0w.asyncScheduler);
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

});
parcelRegister("3HO0w", function(module, exports) {

$parcel$export(module.exports, "asyncScheduler", () => $2b2c2daf44a1044e$export$8d6b71a2b178fc32);
$parcel$export(module.exports, "async", () => $2b2c2daf44a1044e$export$12af436354f1a4f7);

var $iFETN = parcelRequire("iFETN");

var $7MuPU = parcelRequire("7MuPU");
var $2b2c2daf44a1044e$export$8d6b71a2b178fc32 = new (0, $7MuPU.AsyncScheduler)((0, $iFETN.AsyncAction));
var $2b2c2daf44a1044e$export$12af436354f1a4f7 = $2b2c2daf44a1044e$export$8d6b71a2b178fc32;

});
parcelRegister("iFETN", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $d97bc7fc19653fdc$export$b5369ffd7cb2211b);

var $7WQrb = parcelRequire("7WQrb");

var $3bGDU = parcelRequire("3bGDU");

var $9DcZD = parcelRequire("9DcZD");

var $3JYOM = parcelRequire("3JYOM");
var $d97bc7fc19653fdc$export$b5369ffd7cb2211b = function(_super) {
    (0, $7WQrb.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $9DcZD.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $9DcZD.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $3JYOM.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $3bGDU.Action));

});
parcelRegister("3bGDU", function(module, exports) {

$parcel$export(module.exports, "Action", () => $25237a26c7d2a6e0$export$e19cd5f9376f8cee);

var $7WQrb = parcelRequire("7WQrb");

var $bgI6x = parcelRequire("bgI6x");
var $25237a26c7d2a6e0$export$e19cd5f9376f8cee = function(_super) {
    (0, $7WQrb.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $bgI6x.Subscription));

});

parcelRegister("9DcZD", function(module, exports) {

$parcel$export(module.exports, "intervalProvider", () => $7031d5c115ea3033$export$f0ca5e16f6f68711);

var $7WQrb = parcelRequire("7WQrb");
var $7031d5c115ea3033$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
        return setInterval.apply(void 0, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("7MuPU", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $5aa4ef89729a15e9$export$4114a3ec92faa3c6);

var $7WQrb = parcelRequire("7WQrb");

var $4BLXl = parcelRequire("4BLXl");
var $5aa4ef89729a15e9$export$4114a3ec92faa3c6 = function(_super) {
    (0, $7WQrb.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $4BLXl.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $4BLXl.Scheduler));

});
parcelRegister("4BLXl", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $35afd13d3a3f6ae1$export$d3e54bb8584cda7c);

var $cLITg = parcelRequire("cLITg");
var $35afd13d3a3f6ae1$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $cLITg.dateTimestampProvider).now;
    return Scheduler;
}();

});
parcelRegister("cLITg", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $94bcb2181a19339b$export$c1895ea2d519a677);
var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});





parcelRegister("3AhZm", function(module, exports) {

$parcel$export(module.exports, "delay", () => $29c2b0166fc07efc$export$1391212d75b2ee65);

var $3HO0w = parcelRequire("3HO0w");

var $658pe = parcelRequire("658pe");

var $gdAa2 = parcelRequire("gdAa2");
function $29c2b0166fc07efc$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $3HO0w.asyncScheduler);
    var duration = (0, $gdAa2.timer)(due, scheduler);
    return (0, $658pe.delayWhen)(function() {
        return duration;
    });
}

});
parcelRegister("658pe", function(module, exports) {

$parcel$export(module.exports, "delayWhen", () => $46d9baf1d6b028a7$export$286ca829307725c9);

var $beVzk = parcelRequire("beVzk");

var $jGgch = parcelRequire("jGgch");

var $7jibP = parcelRequire("7jibP");

var $8Ydqd = parcelRequire("8Ydqd");

var $63Jtj = parcelRequire("63Jtj");

var $2ypWW = parcelRequire("2ypWW");
function $46d9baf1d6b028a7$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $beVzk.concat)(subscriptionDelay.pipe((0, $jGgch.take)(1), (0, $7jibP.ignoreElements)()), source.pipe($46d9baf1d6b028a7$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $63Jtj.mergeMap)(function(value, index) {
        return (0, $2ypWW.innerFrom)(delayDurationSelector(value, index)).pipe((0, $jGgch.take)(1), (0, $8Ydqd.mapTo)(value));
    });
}

});
parcelRegister("beVzk", function(module, exports) {

$parcel$export(module.exports, "concat", () => $82eda875fdd470db$export$ee1b3e54f0441b22);

var $50mg2 = parcelRequire("50mg2");

var $54Vhv = parcelRequire("54Vhv");

var $46Tqd = parcelRequire("46Tqd");
function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $50mg2.concatAll)()((0, $46Tqd.from)(args, (0, $54Vhv.popScheduler)(args)));
}

});
parcelRegister("50mg2", function(module, exports) {

$parcel$export(module.exports, "concatAll", () => $3a4e37c3b56570cb$export$b314777ae20abca9);

var $665rg = parcelRequire("665rg");
function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $665rg.mergeAll)(1);
}

});
parcelRegister("665rg", function(module, exports) {

$parcel$export(module.exports, "mergeAll", () => $4707859e785b3da6$export$18aef43295bbe906);

var $63Jtj = parcelRequire("63Jtj");

var $a4Ze1 = parcelRequire("a4Ze1");
function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $63Jtj.mergeMap)((0, $a4Ze1.identity), concurrent);
}

});


parcelRegister("54Vhv", function(module, exports) {

$parcel$export(module.exports, "popScheduler", () => $3b29c258456d9a89$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $3b29c258456d9a89$export$3de14b735070dcd5);

var $gCSeg = parcelRequire("gCSeg");

var $hEazg = parcelRequire("hEazg");
function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $gCSeg.isFunction)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $hEazg.isScheduler)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}

});
parcelRegister("hEazg", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $cd8e5ea142a386bd$export$187e35932e88c15c);

var $gCSeg = parcelRequire("gCSeg");
function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $gCSeg.isFunction)(value.schedule);
}

});


parcelRegister("46Tqd", function(module, exports) {

$parcel$export(module.exports, "from", () => $2fe2b696577919a5$export$6788812c4e6611e6);

var $ci5Ul = parcelRequire("ci5Ul");

var $2ypWW = parcelRequire("2ypWW");
function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $ci5Ul.scheduled)(input, scheduler) : (0, $2ypWW.innerFrom)(input);
}

});
parcelRegister("ci5Ul", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $8f2bbfa9b5105688$export$49c44dfc2bb21d70);

var $jxGcZ = parcelRequire("jxGcZ");

var $aS4Ip = parcelRequire("aS4Ip");

var $16Erw = parcelRequire("16Erw");

var $4ZsdA = parcelRequire("4ZsdA");

var $i3S70 = parcelRequire("i3S70");

var $rOw2q = parcelRequire("rOw2q");

var $dy1jD = parcelRequire("dy1jD");

var $bGCU7 = parcelRequire("bGCU7");

var $fQMll = parcelRequire("fQMll");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $7gZl2 = parcelRequire("7gZl2");

var $arhob = parcelRequire("arhob");
function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return (0, $jxGcZ.scheduleObservable)(input, scheduler);
        if ((0, $bGCU7.isArrayLike)(input)) return (0, $16Erw.scheduleArray)(input, scheduler);
        if ((0, $dy1jD.isPromise)(input)) return (0, $aS4Ip.schedulePromise)(input, scheduler);
        if ((0, $aGtFl.isAsyncIterable)(input)) return (0, $i3S70.scheduleAsyncIterable)(input, scheduler);
        if ((0, $fQMll.isIterable)(input)) return (0, $4ZsdA.scheduleIterable)(input, scheduler);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return (0, $arhob.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}

});
parcelRegister("jxGcZ", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $e3a1d71c442b5de9$export$ed8bd553a12b6a30);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});
parcelRegister("3blUb", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $25136415cad576bc$export$9007f49c319d1ac7);

var $4yU8l = parcelRequire("4yU8l");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});

parcelRegister("iNvbf", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $daf4fd612cb884aa$export$1eb44d8f5f64733b);

var $d9kQQ = parcelRequire("d9kQQ");
function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("aS4Ip", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $7ea29ae5d684fb04$export$fc9afd948577f0a8);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});

parcelRegister("16Erw", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $0ce5b91768be0a6d$export$b34673931371729a);

var $6OiYn = parcelRequire("6OiYn");
function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("4ZsdA", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $3a22bf76b9b6de63$export$2b75c58ab9b5b766);

var $6OiYn = parcelRequire("6OiYn");

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");

var $4yU8l = parcelRequire("4yU8l");
function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var iterator;
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $ZpNjd.iterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $gCSeg.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("i3S70", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $d2627b52a3f1ff1b$export$7c7f0979b56a32f3);

var $6OiYn = parcelRequire("6OiYn");

var $4yU8l = parcelRequire("4yU8l");
function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $6OiYn.Observable)(function(subscriber) {
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("arhob", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $7999ea1c5b71ad25$export$3385251aeecad28a);

var $i3S70 = parcelRequire("i3S70");

var $7gZl2 = parcelRequire("7gZl2");
function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $i3S70.scheduleAsyncIterable)((0, $7gZl2.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});




parcelRegister("jGgch", function(module, exports) {

$parcel$export(module.exports, "take", () => $e53e80f9042754be$export$b7df5d561049483a);

var $ckPFG = parcelRequire("ckPFG");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $ckPFG.EMPTY;
    } : (0, $d9kQQ.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("ckPFG", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $8faf6f2806f38bc2$export$ccb33e29d92c9a58);

var $6OiYn = parcelRequire("6OiYn");
var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $6OiYn.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("7jibP", function(module, exports) {

$parcel$export(module.exports, "ignoreElements", () => $55286ae00f8aa486$export$6953b97c7d866605);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");

var $75rFk = parcelRequire("75rFk");
function $55286ae00f8aa486$export$6953b97c7d866605() {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, (0, $75rFk.noop)));
    });
}

});

parcelRegister("8Ydqd", function(module, exports) {

$parcel$export(module.exports, "mapTo", () => $687e56a36053246d$export$e0eaf3a86c03b2ad);

var $d4PzE = parcelRequire("d4PzE");
function $687e56a36053246d$export$e0eaf3a86c03b2ad(value) {
    return (0, $d4PzE.map)(function() {
        return value;
    });
}

});


parcelRegister("gdAa2", function(module, exports) {

$parcel$export(module.exports, "timer", () => $bce9e90ba9895d75$export$9dc4ecf953986f04);

var $6OiYn = parcelRequire("6OiYn");

var $3HO0w = parcelRequire("3HO0w");

var $hEazg = parcelRequire("hEazg");

var $5qlGi = parcelRequire("5qlGi");
function $bce9e90ba9895d75$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $3HO0w.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $hEazg.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var due = (0, $5qlGi.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

});
parcelRegister("5qlGi", function(module, exports) {

$parcel$export(module.exports, "isValidDate", () => $3f3032e6ea410a39$export$c03bb0116ee09d4b);
function $3f3032e6ea410a39$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}

});



parcelRegister("d6DLj", function(module, exports) {

$parcel$export(module.exports, "filter", () => $98aaadcfa91e6727$export$3dea766d36a8935f);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("a6N5s", function(module, exports) {

$parcel$export(module.exports, "merge", () => $75c08a98094ca84a$export$4950aa0f605343fb);

var $665rg = parcelRequire("665rg");

var $2ypWW = parcelRequire("2ypWW");

var $ckPFG = parcelRequire("ckPFG");

var $54Vhv = parcelRequire("54Vhv");

var $46Tqd = parcelRequire("46Tqd");
function $75c08a98094ca84a$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $54Vhv.popScheduler)(args);
    var concurrent = (0, $54Vhv.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $ckPFG.EMPTY) : sources.length === 1 ? (0, $2ypWW.innerFrom)(sources[0]) : (0, $665rg.mergeAll)(concurrent)((0, $46Tqd.from)(sources, scheduler));
}

});

parcelRegister("cL6LG", function(module, exports) {

$parcel$export(module.exports, "pairwise", () => $949f1fd33ffd44b7$export$8f9d79d42bff1aac);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $949f1fd33ffd44b7$export$8f9d79d42bff1aac() {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}

});


parcelRegister("150Qq", function(module, exports) {

$parcel$export(module.exports, "trackChange", () => $0c96e9ce425b9860$export$706320a461885e7);

var $d6DLj = parcelRequire("d6DLj");

var $bak9G = parcelRequire("bak9G");

var $9BlWD = parcelRequire("9BlWD");
function $0c96e9ce425b9860$export$706320a461885e7(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent;
    var changeObservable = allObservables.changeObservable;
    var filteredChangeObservable = changeObservable.pipe((0, $d6DLj.filter)((0, $bak9G.filterOutNonTrackableEvents)), (0, $d6DLj.filter)(function(changeEvent) {
        // Only track change on elements that should be tracked,
        return shouldTrackEvent('change', changeEvent.closestTrackedAncestor);
    }));
    return filteredChangeObservable.subscribe(function(changeEvent) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $9BlWD.AMPLITUDE_ELEMENT_CHANGED_EVENT), getEventProperties('change', changeEvent.closestTrackedAncestor));
    });
}

});

parcelRegister("7eLb2", function(module, exports) {

$parcel$export(module.exports, "trackActionClick", () => $015c1a92e3f8bb76$export$c35243ecb650b344);

var $7WQrb = parcelRequire("7WQrb");

var $ckPFG = parcelRequire("ckPFG");
var $d6DLj = parcelRequire("d6DLj");
var $d4PzE = parcelRequire("d4PzE");
var $a6N5s = parcelRequire("a6N5s");
var $466t7 = parcelRequire("466t7");
var $jGgch = parcelRequire("jGgch");
var $cKPrq = parcelRequire("cKPrq");

var $bak9G = parcelRequire("bak9G");

var $9BlWD = parcelRequire("9BlWD");
function $015c1a92e3f8bb76$export$c35243ecb650b344(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, shouldTrackActionClick = _a.shouldTrackActionClick;
    var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
    var filteredClickObservable = clickObservable.pipe((0, $d6DLj.filter)(function(click) {
        // Filter out regularly tracked click events that are already handled in trackClicks
        return !shouldTrackEvent('click', click.closestTrackedAncestor);
    }), (0, $d4PzE.map)(function(click) {
        // overwrite the closestTrackedAncestor with the closest element that is on the actionClickAllowlist
        var closestActionClickEl = (0, $bak9G.getClosestElement)(click.event.target, options.actionClickAllowlist);
        click.closestTrackedAncestor = closestActionClickEl;
        // overwrite the targetElementProperties with the properties of the closestActionClickEl
        if (click.closestTrackedAncestor !== null) click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
        return click;
    }), (0, $d6DLj.filter)((0, $bak9G.filterOutNonTrackableEvents)), (0, $d6DLj.filter)(function(clickEvent) {
        // Only track change on elements that should be tracked
        return shouldTrackActionClick('click', clickEvent.closestTrackedAncestor);
    }));
    var changeObservables = [
        mutationObservable
    ];
    /* istanbul ignore next */ if (navigateObservable) changeObservables.push(navigateObservable);
    var mutationOrNavigate = (0, $a6N5s.merge).apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(changeObservables), false));
    var actionClicks = filteredClickObservable.pipe(// If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    (0, $466t7.switchMap)(function(click) {
        return mutationOrNavigate.pipe((0, $jGgch.take)(1), (0, $cKPrq.timeout)({
            first: 500,
            with: function() {
                return 0, $ckPFG.EMPTY;
            }
        }), (0, $d4PzE.map)(function() {
            return click;
        }));
    }));
    return actionClicks.subscribe(function(actionClick) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, $9BlWD.AMPLITUDE_ELEMENT_CLICKED_EVENT), getEventProperties('click', actionClick.closestTrackedAncestor), {
            time: actionClick.timestamp
        });
    });
}

});
parcelRegister("466t7", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $2fbcbd7f7704e649$export$9f6ea8e48bc26eab);

var $2ypWW = parcelRequire("2ypWW");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $2fbcbd7f7704e649$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $2ypWW.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $4QgEI.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});

parcelRegister("cKPrq", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $9491af11bb0ab327$export$83e74882c5df8fe1);

var $3HO0w = parcelRequire("3HO0w");

var $5qlGi = parcelRequire("5qlGi");

var $d9kQQ = parcelRequire("d9kQQ");

var $2ypWW = parcelRequire("2ypWW");

var $kfFvr = parcelRequire("kfFvr");

var $4QgEI = parcelRequire("4QgEI");

var $4yU8l = parcelRequire("4yU8l");
var $9491af11bb0ab327$export$66d311bf29d5c89c = (0, $kfFvr.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function $9491af11bb0ab327$export$83e74882c5df8fe1(config, schedulerArg) {
    var _a = (0, $5qlGi.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $9491af11bb0ab327$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, $3HO0w.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, $2ypWW.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function $9491af11bb0ab327$var$timeoutErrorFactory(info) {
    throw new $9491af11bb0ab327$export$66d311bf29d5c89c(info);
}

});





parcelRegister("9jRb6", function(module, exports) {

$parcel$export(module.exports, "SpecialEventType", () => (parcelRequire("ayMRi")).SpecialEventType);
$parcel$export(module.exports, "IdentifyOperation", () => (parcelRequire("ayMRi")).IdentifyOperation);
$parcel$export(module.exports, "RevenueProperty", () => (parcelRequire("ayMRi")).RevenueProperty);
$parcel$export(module.exports, "LogLevel", () => (parcelRequire("5pHkT")).LogLevel);
$parcel$export(module.exports, "ServerZone", () => (parcelRequire("4kagy")).ServerZone);
$parcel$export(module.exports, "Status", () => (parcelRequire("jmOoi")).Status);
$parcel$export(module.exports, "OfflineDisabled", () => (parcelRequire("6rHk0")).OfflineDisabled);
$parcel$export(module.exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", () => (parcelRequire("8pDub")).DEFAULT_CSS_SELECTOR_ALLOWLIST);
$parcel$export(module.exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", () => (parcelRequire("8pDub")).DEFAULT_DATA_ATTRIBUTE_PREFIX);
$parcel$export(module.exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", () => (parcelRequire("8pDub")).DEFAULT_ACTION_CLICK_ALLOWLIST);

var $ayMRi = parcelRequire("ayMRi");

var $5pHkT = parcelRequire("5pHkT");

var $4kagy = parcelRequire("4kagy");

var $jmOoi = parcelRequire("jmOoi");

var $6rHk0 = parcelRequire("6rHk0");

var $8pDub = parcelRequire("8pDub");

});


parcelRegister("6enPC", function(module, exports) {

$parcel$export(module.exports, "detect", () => $48968958eb8b72e8$export$17b446b869dad473);

var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        'aol',
        /AOLShield\/([0-9\._]+)/
    ],
    [
        'edge',
        /Edge\/([0-9\._]+)/
    ],
    [
        'edge-ios',
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        'yandexbrowser',
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        'kakaotalk',
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        'samsung',
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        'silk',
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        'miui',
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        'beaker',
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        'edge-chromium',
        /EdgA?\/([0-9\.]+)/
    ],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'chrome',
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'phantomjs',
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'crios',
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'firefox',
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'fxios',
        /FxiOS\/([0-9\.]+)/
    ],
    [
        'opera-mini',
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        'opera',
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'opera',
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'pie',
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        'pie',
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        'netfront',
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        'ie',
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        'ie',
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        'ie',
        /MSIE\s(7\.0)/
    ],
    [
        'bb10',
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        'android',
        /Android\s([0-9\.]+)/
    ],
    [
        'ios',
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        'safari',
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        'facebook',
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        'instagram',
        /Instagram\s([0-9\.]+)/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        'curl',
        /^curl\/([0-9\.]+)$/
    ],
    [
        'searchbot',
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        'iOS',
        /iP(hone|od|ad)/
    ],
    [
        'Android OS',
        /Android/
    ],
    [
        'BlackBerry OS',
        /BlackBerry|BB10/
    ],
    [
        'Windows Mobile',
        /IEMobile/
    ],
    [
        'Amazon OS',
        /Kindle/
    ],
    [
        'Windows 3.11',
        /Win16/
    ],
    [
        'Windows 95',
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        'Windows 98',
        /(Windows 98)|(Win98)/
    ],
    [
        'Windows 2000',
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        'Windows XP',
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        'Windows Server 2003',
        /(Windows NT 5.2)/
    ],
    [
        'Windows Vista',
        /(Windows NT 6.0)/
    ],
    [
        'Windows 7',
        /(Windows NT 6.1)/
    ],
    [
        'Windows 8',
        /(Windows NT 6.2)/
    ],
    [
        'Windows 8.1',
        /(Windows NT 6.3)/
    ],
    [
        'Windows 10',
        /(Windows NT 10.0)/
    ],
    [
        'Windows ME',
        /Windows ME/
    ],
    [
        'Windows CE',
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        'Open BSD',
        /OpenBSD/
    ],
    [
        'Sun OS',
        /SunOS/
    ],
    [
        'Chrome OS',
        /CrOS/
    ],
    [
        'Linux',
        /(Linux)|(X11)/
    ],
    [
        'Mac OS',
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        'QNX',
        /QNX/
    ],
    [
        'BeOS',
        /BeOS/
    ],
    [
        'OS/2',
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== 'undefined') return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join('.');
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $hPtJY !== 'undefined' && $hPtJY.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push('0');
    return output;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("gg3vl", function(module, exports) {
/* 
(The MIT License)
Copyright (c) 2014-2021 Halász Ádám <adam@aimform.com>
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ //  Unique Hexatridecimal ID Generator
// ================================================
//  Dependencies
// ================================================

var $hPtJY = parcelRequire("hPtJY");
var $bd60dbe7bfada5b5$var$pid = typeof $hPtJY !== 'undefined' && $hPtJY.pid ? $hPtJY.pid.toString(36) : '';
var $bd60dbe7bfada5b5$var$address = '';

if (typeof __webpack_require__ !== 'function' && true) {
    var $bd60dbe7bfada5b5$var$mac = '', $bd60dbe7bfada5b5$var$os = (parcelRequire("ccDAZ"));
    if ($bd60dbe7bfada5b5$var$os.networkInterfaces) var $bd60dbe7bfada5b5$var$networkInterfaces = $bd60dbe7bfada5b5$var$os.networkInterfaces();
    if ($bd60dbe7bfada5b5$var$networkInterfaces) {
        loop: for(let interface_key in $bd60dbe7bfada5b5$var$networkInterfaces){
            const networkInterface = $bd60dbe7bfada5b5$var$networkInterfaces[interface_key];
            const length = networkInterface.length;
            for(var $bd60dbe7bfada5b5$var$i = 0; $bd60dbe7bfada5b5$var$i < length; $bd60dbe7bfada5b5$var$i++)if (networkInterface[$bd60dbe7bfada5b5$var$i] !== undefined && networkInterface[$bd60dbe7bfada5b5$var$i].mac && networkInterface[$bd60dbe7bfada5b5$var$i].mac != '00:00:00:00:00:00') {
                $bd60dbe7bfada5b5$var$mac = networkInterface[$bd60dbe7bfada5b5$var$i].mac;
                break loop;
            }
        }
        $bd60dbe7bfada5b5$var$address = $bd60dbe7bfada5b5$var$mac ? parseInt($bd60dbe7bfada5b5$var$mac.replace(/\:|\D+/gi, '')).toString(36) : '';
    }
}
//  Exports
// ================================================
module.exports = module.exports.default = function(prefix, suffix) {
    return (prefix ? prefix : '') + $bd60dbe7bfada5b5$var$address + $bd60dbe7bfada5b5$var$pid + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : '');
};
module.exports.process = function(prefix, suffix) {
    return (prefix ? prefix : '') + $bd60dbe7bfada5b5$var$pid + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : '');
};
module.exports.time = function(prefix, suffix) {
    return (prefix ? prefix : '') + $bd60dbe7bfada5b5$var$now().toString(36) + (suffix ? suffix : '');
};
//  Helpers
// ================================================
function $bd60dbe7bfada5b5$var$now() {
    var time = Date.now();
    var last = $bd60dbe7bfada5b5$var$now.last || time;
    return $bd60dbe7bfada5b5$var$now.last = time > last ? time : last + 1;
}

});
parcelRegister("ccDAZ", function(module, exports) {

$parcel$export(module.exports, "endianness", () => $8e2551e033e95cb5$export$edf525f30916fbb8, (v) => $8e2551e033e95cb5$export$edf525f30916fbb8 = v);
$parcel$export(module.exports, "hostname", () => $8e2551e033e95cb5$export$640106f6dc7d2706, (v) => $8e2551e033e95cb5$export$640106f6dc7d2706 = v);
$parcel$export(module.exports, "loadavg", () => $8e2551e033e95cb5$export$3ea386628068cf62, (v) => $8e2551e033e95cb5$export$3ea386628068cf62 = v);
$parcel$export(module.exports, "uptime", () => $8e2551e033e95cb5$export$749d472264fad440, (v) => $8e2551e033e95cb5$export$749d472264fad440 = v);
$parcel$export(module.exports, "freemem", () => $8e2551e033e95cb5$export$8b931a48d9488767, (v) => $8e2551e033e95cb5$export$8b931a48d9488767 = v);
$parcel$export(module.exports, "totalmem", () => $8e2551e033e95cb5$export$9123f37609399513, (v) => $8e2551e033e95cb5$export$9123f37609399513 = v);
$parcel$export(module.exports, "cpus", () => $8e2551e033e95cb5$export$9b60beb643db4d69, (v) => $8e2551e033e95cb5$export$9b60beb643db4d69 = v);
$parcel$export(module.exports, "type", () => $8e2551e033e95cb5$export$bf9fb029d174d554, (v) => $8e2551e033e95cb5$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "release", () => $8e2551e033e95cb5$export$23d3fad09dc44362, (v) => $8e2551e033e95cb5$export$23d3fad09dc44362 = v);
$parcel$export(module.exports, "networkInterfaces", () => $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5, (v) => $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = v);
$parcel$export(module.exports, "getNetworkInterfaces", () => $8e2551e033e95cb5$export$3bf7c33313eba0fe, (v) => $8e2551e033e95cb5$export$3bf7c33313eba0fe = v);
$parcel$export(module.exports, "arch", () => $8e2551e033e95cb5$export$7925d89f138dad5b, (v) => $8e2551e033e95cb5$export$7925d89f138dad5b = v);
$parcel$export(module.exports, "platform", () => $8e2551e033e95cb5$export$722a64dea1b767dc, (v) => $8e2551e033e95cb5$export$722a64dea1b767dc = v);
$parcel$export(module.exports, "tmpdir", () => $8e2551e033e95cb5$export$9e6c06a7d47f9af7, (v) => $8e2551e033e95cb5$export$9e6c06a7d47f9af7 = v);
$parcel$export(module.exports, "tmpDir", () => $8e2551e033e95cb5$export$6b76988456c0292f, (v) => $8e2551e033e95cb5$export$6b76988456c0292f = v);
$parcel$export(module.exports, "EOL", () => $8e2551e033e95cb5$export$266d3b9babd1fc45, (v) => $8e2551e033e95cb5$export$266d3b9babd1fc45 = v);
$parcel$export(module.exports, "homedir", () => $8e2551e033e95cb5$export$c1d46b5ea6262c0b, (v) => $8e2551e033e95cb5$export$c1d46b5ea6262c0b = v);
var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return 'LE';
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== 'undefined') return location.hostname;
    else return '';
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return 'Browser';
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== 'undefined') return navigator.appVersion;
    return '';
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return 'javascript';
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return 'browser';
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return '/tmp';
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = '\n';
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return '/';
};

});


parcelRegister("2xAZO", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $1d9b5c75918107f9$export$fc6227831ee7c7);
$parcel$export(module.exports, "onINP", () => $1d9b5c75918107f9$export$6693a9916ea977ef);
$parcel$export(module.exports, "onLCP", () => $1d9b5c75918107f9$export$da982ced0ff8a670);
var $1d9b5c75918107f9$var$e, $1d9b5c75918107f9$var$n, $1d9b5c75918107f9$var$t, $1d9b5c75918107f9$var$i, $1d9b5c75918107f9$var$r, $1d9b5c75918107f9$var$a = -1, $1d9b5c75918107f9$var$o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($1d9b5c75918107f9$var$a = n.timeStamp, e(n));
    }, !0);
}, $1d9b5c75918107f9$var$c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, $1d9b5c75918107f9$var$u = function() {
    var e = $1d9b5c75918107f9$var$c();
    return e && e.activationStart || 0;
}, $1d9b5c75918107f9$var$f = function(e, n) {
    var t = $1d9b5c75918107f9$var$c(), i = "navigate";
    $1d9b5c75918107f9$var$a >= 0 ? i = "back-forward-cache" : t && (document.prerendering || $1d9b5c75918107f9$var$u() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : t.type && (i = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: i
    };
}, $1d9b5c75918107f9$var$s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var i = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return i.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), i;
        }
    } catch (e) {}
}, $1d9b5c75918107f9$var$d = function(e, n, t, i) {
    var r, a;
    return function(o) {
        n.value >= 0 && (o || i) && ((a = n.value - (r || 0)) || void 0 === r) && (r = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, $1d9b5c75918107f9$var$l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, $1d9b5c75918107f9$var$p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $1d9b5c75918107f9$var$v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, $1d9b5c75918107f9$var$m = -1, $1d9b5c75918107f9$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $1d9b5c75918107f9$var$g = function(e) {
    "hidden" === document.visibilityState && $1d9b5c75918107f9$var$m > -1 && ($1d9b5c75918107f9$var$m = "visibilitychange" === e.type ? e.timeStamp : 0, $1d9b5c75918107f9$var$T());
}, $1d9b5c75918107f9$var$y = function() {
    addEventListener("visibilitychange", $1d9b5c75918107f9$var$g, !0), addEventListener("prerenderingchange", $1d9b5c75918107f9$var$g, !0);
}, $1d9b5c75918107f9$var$T = function() {
    removeEventListener("visibilitychange", $1d9b5c75918107f9$var$g, !0), removeEventListener("prerenderingchange", $1d9b5c75918107f9$var$g, !0);
}, $1d9b5c75918107f9$var$E = function() {
    return $1d9b5c75918107f9$var$m < 0 && ($1d9b5c75918107f9$var$m = $1d9b5c75918107f9$var$h(), $1d9b5c75918107f9$var$y(), $1d9b5c75918107f9$var$o(function() {
        setTimeout(function() {
            $1d9b5c75918107f9$var$m = $1d9b5c75918107f9$var$h(), $1d9b5c75918107f9$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $1d9b5c75918107f9$var$m;
        }
    };
}, $1d9b5c75918107f9$var$C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, $1d9b5c75918107f9$export$e610c735b5510cec = [
    1800,
    3e3
], $1d9b5c75918107f9$export$52489892712e8192 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t, i = $1d9b5c75918107f9$var$E(), r = $1d9b5c75918107f9$var$f("FCP"), a = $1d9b5c75918107f9$var$s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < i.firstHiddenTime && (r.value = Math.max(e.startTime - $1d9b5c75918107f9$var$u(), 0), r.entries.push(e), t(!0)));
            });
        });
        a && (t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$e610c735b5510cec, n.reportAllChanges), $1d9b5c75918107f9$var$o(function(i) {
            r = $1d9b5c75918107f9$var$f("FCP"), t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$e610c735b5510cec, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                r.value = performance.now() - i.timeStamp, t(!0);
            });
        }));
    });
}, $1d9b5c75918107f9$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $1d9b5c75918107f9$export$fc6227831ee7c7 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$export$52489892712e8192($1d9b5c75918107f9$var$v(function() {
        var t, i = $1d9b5c75918107f9$var$f("CLS", 0), r = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    r && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (r += e.value, a.push(e)) : (r = e.value, a = [
                        e
                    ]);
                }
            }), r > i.value && (i.value = r, i.entries = a, t());
        }, u = $1d9b5c75918107f9$var$s("layout-shift", c);
        u && (t = $1d9b5c75918107f9$var$d(e, i, $1d9b5c75918107f9$export$3f20d8e089ac35b2, n.reportAllChanges), $1d9b5c75918107f9$var$p(function() {
            c(u.takeRecords()), t(!0);
        }), $1d9b5c75918107f9$var$o(function() {
            r = 0, i = $1d9b5c75918107f9$var$f("CLS", 0), t = $1d9b5c75918107f9$var$d(e, i, $1d9b5c75918107f9$export$3f20d8e089ac35b2, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, $1d9b5c75918107f9$var$A = {
    passive: !0,
    capture: !0
}, $1d9b5c75918107f9$var$I = new Date, $1d9b5c75918107f9$var$P = function(i, r) {
    $1d9b5c75918107f9$var$e || ($1d9b5c75918107f9$var$e = r, $1d9b5c75918107f9$var$n = i, $1d9b5c75918107f9$var$t = new Date, $1d9b5c75918107f9$var$k(removeEventListener), $1d9b5c75918107f9$var$F());
}, $1d9b5c75918107f9$var$F = function() {
    if ($1d9b5c75918107f9$var$n >= 0 && $1d9b5c75918107f9$var$n < $1d9b5c75918107f9$var$t - $1d9b5c75918107f9$var$I) {
        var r = {
            entryType: "first-input",
            name: $1d9b5c75918107f9$var$e.type,
            target: $1d9b5c75918107f9$var$e.target,
            cancelable: $1d9b5c75918107f9$var$e.cancelable,
            startTime: $1d9b5c75918107f9$var$e.timeStamp,
            processingStart: $1d9b5c75918107f9$var$e.timeStamp + $1d9b5c75918107f9$var$n
        };
        $1d9b5c75918107f9$var$i.forEach(function(e) {
            e(r);
        }), $1d9b5c75918107f9$var$i = [];
    }
}, $1d9b5c75918107f9$var$M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                $1d9b5c75918107f9$var$P(e, n), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", t, $1d9b5c75918107f9$var$A), removeEventListener("pointercancel", i, $1d9b5c75918107f9$var$A);
            };
            addEventListener("pointerup", t, $1d9b5c75918107f9$var$A), addEventListener("pointercancel", i, $1d9b5c75918107f9$var$A);
        }(n, e) : $1d9b5c75918107f9$var$P(n, e);
    }
}, $1d9b5c75918107f9$var$k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, $1d9b5c75918107f9$var$M, $1d9b5c75918107f9$var$A);
    });
}, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $1d9b5c75918107f9$export$134ed2977d320dfd = function(t, r) {
    r = r || {}, $1d9b5c75918107f9$var$C(function() {
        var a, c = $1d9b5c75918107f9$var$E(), u = $1d9b5c75918107f9$var$f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = $1d9b5c75918107f9$var$s("first-input", m);
        a = $1d9b5c75918107f9$var$d(t, u, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34, r.reportAllChanges), h && $1d9b5c75918107f9$var$p($1d9b5c75918107f9$var$v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && $1d9b5c75918107f9$var$o(function() {
            var o;
            u = $1d9b5c75918107f9$var$f("FID"), a = $1d9b5c75918107f9$var$d(t, u, $1d9b5c75918107f9$export$8f7f3c48ca6fbe34, r.reportAllChanges), $1d9b5c75918107f9$var$i = [], $1d9b5c75918107f9$var$n = -1, $1d9b5c75918107f9$var$e = null, $1d9b5c75918107f9$var$k(addEventListener), o = l, $1d9b5c75918107f9$var$i.push(o), $1d9b5c75918107f9$var$F();
        });
    });
}, $1d9b5c75918107f9$var$B = 0, $1d9b5c75918107f9$var$R = 1 / 0, $1d9b5c75918107f9$var$H = 0, $1d9b5c75918107f9$var$N = function(e) {
    e.forEach(function(e) {
        e.interactionId && ($1d9b5c75918107f9$var$R = Math.min($1d9b5c75918107f9$var$R, e.interactionId), $1d9b5c75918107f9$var$H = Math.max($1d9b5c75918107f9$var$H, e.interactionId), $1d9b5c75918107f9$var$B = $1d9b5c75918107f9$var$H ? ($1d9b5c75918107f9$var$H - $1d9b5c75918107f9$var$R) / 7 + 1 : 0);
    });
}, $1d9b5c75918107f9$var$O = function() {
    return $1d9b5c75918107f9$var$r ? $1d9b5c75918107f9$var$B : performance.interactionCount || 0;
}, $1d9b5c75918107f9$var$q = function() {
    "interactionCount" in performance || $1d9b5c75918107f9$var$r || ($1d9b5c75918107f9$var$r = $1d9b5c75918107f9$var$s("event", $1d9b5c75918107f9$var$N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $1d9b5c75918107f9$export$7f4cb060ded9173c = [
    200,
    500
], $1d9b5c75918107f9$var$_ = 0, $1d9b5c75918107f9$var$z = function() {
    return $1d9b5c75918107f9$var$O() - $1d9b5c75918107f9$var$_;
}, $1d9b5c75918107f9$var$G = [], $1d9b5c75918107f9$var$J = {}, $1d9b5c75918107f9$var$K = function(e) {
    var n = $1d9b5c75918107f9$var$G[$1d9b5c75918107f9$var$G.length - 1], t = $1d9b5c75918107f9$var$J[e.interactionId];
    if (t || $1d9b5c75918107f9$var$G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var i = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            $1d9b5c75918107f9$var$J[i.id] = i, $1d9b5c75918107f9$var$G.push(i);
        }
        $1d9b5c75918107f9$var$G.sort(function(e, n) {
            return n.latency - e.latency;
        }), $1d9b5c75918107f9$var$G.splice(10).forEach(function(e) {
            delete $1d9b5c75918107f9$var$J[e.id];
        });
    }
}, $1d9b5c75918107f9$export$6693a9916ea977ef = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t;
        $1d9b5c75918107f9$var$q();
        var i, r = $1d9b5c75918107f9$var$f("INP"), a = function(e) {
            e.forEach(function(e) {
                (e.interactionId && $1d9b5c75918107f9$var$K(e), "first-input" === e.entryType) && !$1d9b5c75918107f9$var$G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && $1d9b5c75918107f9$var$K(e);
            });
            var n, t = (n = Math.min($1d9b5c75918107f9$var$G.length - 1, Math.floor($1d9b5c75918107f9$var$z() / 50)), $1d9b5c75918107f9$var$G[n]);
            t && t.latency !== r.value && (r.value = t.latency, r.entries = t.entries, i());
        }, c = $1d9b5c75918107f9$var$s("event", a, {
            durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40
        });
        i = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$7f4cb060ded9173c, n.reportAllChanges), c && ("PerformanceEventTiming" in window && "interactionId" in PerformanceEventTiming.prototype && c.observe({
            type: "first-input",
            buffered: !0
        }), $1d9b5c75918107f9$var$p(function() {
            a(c.takeRecords()), r.value < 0 && $1d9b5c75918107f9$var$z() > 0 && (r.value = 0, r.entries = []), i(!0);
        }), $1d9b5c75918107f9$var$o(function() {
            $1d9b5c75918107f9$var$G = [], $1d9b5c75918107f9$var$_ = $1d9b5c75918107f9$var$O(), r = $1d9b5c75918107f9$var$f("INP"), i = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$7f4cb060ded9173c, n.reportAllChanges);
        }));
    });
}, $1d9b5c75918107f9$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $1d9b5c75918107f9$var$V = {}, $1d9b5c75918107f9$export$da982ced0ff8a670 = function(e, n) {
    n = n || {}, $1d9b5c75918107f9$var$C(function() {
        var t, i = $1d9b5c75918107f9$var$E(), r = $1d9b5c75918107f9$var$f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < i.firstHiddenTime && (r.value = Math.max(n.startTime - $1d9b5c75918107f9$var$u(), 0), r.entries = [
                n
            ], t());
        }, c = $1d9b5c75918107f9$var$s("largest-contentful-paint", a);
        if (c) {
            t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$948521ca5b0e1b17, n.reportAllChanges);
            var m = $1d9b5c75918107f9$var$v(function() {
                $1d9b5c75918107f9$var$V[r.id] || (a(c.takeRecords()), c.disconnect(), $1d9b5c75918107f9$var$V[r.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, function() {
                    return setTimeout(m, 0);
                }, !0);
            }), $1d9b5c75918107f9$var$p(m), $1d9b5c75918107f9$var$o(function(i) {
                r = $1d9b5c75918107f9$var$f("LCP"), t = $1d9b5c75918107f9$var$d(e, r, $1d9b5c75918107f9$export$948521ca5b0e1b17, n.reportAllChanges), $1d9b5c75918107f9$var$l(function() {
                    r.value = performance.now() - i.timeStamp, $1d9b5c75918107f9$var$V[r.id] = !0, t(!0);
                });
            });
        }
    });
}, $1d9b5c75918107f9$export$65c59ea8064668fc = [
    800,
    1800
], $1d9b5c75918107f9$var$Y = function e(n) {
    document.prerendering ? $1d9b5c75918107f9$var$C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, $1d9b5c75918107f9$export$6e8eea9a35032c92 = function(e, n) {
    n = n || {};
    var t = $1d9b5c75918107f9$var$f("TTFB"), i = $1d9b5c75918107f9$var$d(e, t, $1d9b5c75918107f9$export$65c59ea8064668fc, n.reportAllChanges);
    $1d9b5c75918107f9$var$Y(function() {
        var r = $1d9b5c75918107f9$var$c();
        if (r) {
            var a = r.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - $1d9b5c75918107f9$var$u(), 0), t.entries = [
                r
            ], i(!0), $1d9b5c75918107f9$var$o(function() {
                t = $1d9b5c75918107f9$var$f("TTFB", 0), (i = $1d9b5c75918107f9$var$d(e, t, $1d9b5c75918107f9$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
        }
    });
};

});

parcelRegister("aGgam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCampaignAttributes = module.exports.CampaignAttribute = void 0;
module.exports.CampaignAttribute = {
    'Campaign Tactic Code': 'tc',
    'Double Click ID': 'dclid',
    'Facebook Click ID': 'fbclid',
    'Google Braid': 'gbraid',
    'Google Click ID': 'gclid',
    'Google Click Source': 'gclsrc',
    'Microsoft Click ID': 'msclkid',
    'TikTok Click ID': 'ttclid',
    'UTM Campaign': 'utm_campaign',
    'UTM Content': 'utm_content',
    'UTM Medium': 'utm_medium',
    'UTM Source': 'utm_source',
    'UTM Term': 'utm_term',
    'Web Braid': 'wbraid'
};
const $7c6a5de41b7791e8$var$getCampaignAttributes = (searchParams)=>{
    const attributeEntries = Object.entries(module.exports.CampaignAttribute);
    const attributes = {};
    const searchParamsNext = new URLSearchParams();
    searchParams.forEach((searchParamValue, searchParamKey)=>{
        const searchParamLowerCase = searchParamKey.toLowerCase();
        const entry = attributeEntries.find(([_, searchParam])=>searchParam === searchParamLowerCase);
        if (entry) attributes[entry[0]] = searchParamValue;
        else searchParamsNext.set(searchParamKey, searchParamValue);
    });
    return {
        attributes: attributes,
        search: searchParamsNext.toString()
    };
};
module.exports.getCampaignAttributes = $7c6a5de41b7791e8$var$getCampaignAttributes;

});

parcelRegister("2HqcI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $1f73ec7fb1d02c7c$var$getIsBot = ()=>{
    const userAgent = window.navigator.userAgent;
    const agents = [
        'Applebot',
        'Bingbot',
        'Cypress',
        'Electron',
        'Googlebot',
        'HeadlessChrome',
        'PhantomJS',
        'Puppeteer',
        'RuxitSynthetic',
        'SemrushBot',
        'Tenable_WAS'
    ];
    return agents.some((agent)=>userAgent.includes(agent));
};
module.exports.default = $1f73ec7fb1d02c7c$var$getIsBot;

});

parcelRegister("jf6Ag", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIsInIFrame = void 0;
const $e024866fd43c0f9c$var$getIsInIFrame = ()=>typeof window !== 'undefined' && window.self !== window.top;
module.exports.getIsInIFrame = $e024866fd43c0f9c$var$getIsInIFrame;

});

parcelRegister("itFsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getProductionApiKey = void 0;

var $jzvZU = parcelRequire("jzvZU");
// If we are not running on a production domain, we shouldn't use the
// production API key
const $d73b1849214da515$var$getProductionApiKey = (amplitudeApiKey)=>{
    if (amplitudeApiKey === undefined) return undefined;
    else if ((0, $jzvZU.isProductionDomain)()) return amplitudeApiKey;
    else // If the integration is not occurring on a production domain, then we should
    // force it to use the developer project's Amplitude key.
    return '8fb30518a9a2181216cf32099b32dfe2';
};
module.exports.getProductionApiKey = $d73b1849214da515$var$getProductionApiKey;

});
parcelRegister("jzvZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProductionDomain = void 0;
function $e3fa1b4490a48b7e$var$isProductionDomain() {
    if (typeof window === 'undefined') return false;
    return [
        'app.livestorm.co',
        'atlas.modernatx.com',
        'bringyourbesttolife.com.sg',
        'coronataisaku-station.com',
        'caresportal.modernatx.com',
        'disease.education',
        'eua.modernatx.com',
        'event.leecy.org.tw',
        'gating.modernatx.com',
        'immunize.modernatx.com',
        'investors.modernatx.com',
        'moderna.kr',
        'moderna.qualtrics.com',
        'modernacovid19global.com',
        'modernadirect.ch',
        'modernadirect.com',
        'mrna-access.modernatx.com',
        'mrnabetterlife.com.hk',
        'news.modernatx.com',
        'nowiknowcmv.com',
        'pages.modernatx.com',
        'products.modernatx.com',
        'reimbursement.modernatx.com',
        'rst.atlas.modernatx.com',
        'spikevax.com',
        'static.modernatx.com',
        'tafm-mrna.com.tw',
        'takecarecovid19moderna.jp',
        'taxform.modernatx.com',
        'tools.modernamedinfo.com',
        'tools.modernatx.com',
        'trials.modernatx.com',
        'vaccines.modernatx.com',
        'vaccines.modernatx.nl',
        'vacunas.modernatx.com',
        'www.bivalent-boostern.de',
        'www.covid19-evidenz.de',
        'www.makeityourvaccine.com',
        'www.modernatx.com',
        'www.spikevax-bivalent.de',
        'www.spikevax-evidenz.de',
        'www.takecarecovid19moderna-eppv.jp'
    ].includes(window.location.host);
}
module.exports.isProductionDomain = $e3fa1b4490a48b7e$var$isProductionDomain;

});


parcelRegister("fnYpu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jzvZU = parcelRequire("jzvZU");
const $b337dd358a7f052d$var$SECOND_LEVEL_DOMAINS = new Set([
    'com.sg',
    'org.tw',
    'com.hk',
    'com.tw',
    'com.au'
]);
const $b337dd358a7f052d$var$FALLBACK_PROXY = 'https://metrics.modernatx.com';
const $b337dd358a7f052d$var$DEV_PROXY = 'https://dev.metrics.modernatx.com';
const $b337dd358a7f052d$var$PROXIES = {
    'disease.education': 'https://metrics.disease.education'
};
function $b337dd358a7f052d$var$getProxyUrl() {
    var _a;
    const domain = $b337dd358a7f052d$var$getDomainFromLocation();
    if ((0, $jzvZU.isProductionDomain)()) return $b337dd358a7f052d$var$PROXIES[domain] || $b337dd358a7f052d$var$FALLBACK_PROXY;
    if ($b337dd358a7f052d$var$isLocalhost(domain)) return (_a = undefined, _a !== void 0) ? _a : $b337dd358a7f052d$var$DEV_PROXY;
    return $b337dd358a7f052d$var$DEV_PROXY;
}
module.exports.default = $b337dd358a7f052d$var$getProxyUrl;
function $b337dd358a7f052d$var$getDomainFromLocation() {
    const url = new URL(window.location.href);
    const hostname = url.hostname;
    if ($b337dd358a7f052d$var$isLocalhost(hostname)) return hostname;
    // Split the hostname into parts
    const parts = hostname.split('.');
    // Determine the domain based on the parts and second-level domains
    let domain;
    if (parts.length > 2) {
        // Check if the domain ends with a known second-level domain
        const potentialSLD = `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
        if ($b337dd358a7f052d$var$SECOND_LEVEL_DOMAINS.has(potentialSLD)) domain = parts.slice(-3).join('.');
        else domain = parts.slice(-2).join('.');
    } else domain = hostname;
    return domain;
}
function $b337dd358a7f052d$var$isLocalhost(hostname) {
    return hostname === 'localhost' || hostname.startsWith('127.') || hostname === '[::1]' || /^[0-9]+(?:\.[0-9]+){3}$/.test(hostname) || // IPv4 address
    /(?:[a-f0-9]*:){7}[a-f0-9]+/.test(hostname) // IPv6 address
    ;
}

});

parcelRegister("855hF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $5e22e39e6385e5ef$var$Storage {
    constructor(){
        this.getCookie = (name)=>{
            var _a;
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                const partValue = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
                return partValue === undefined ? null : partValue;
            } else return null;
        };
    }
    getItem(key) {
        return this.getCookie(key);
    }
    setItem(key, value = '', expiryDays = 30) {
        const { host: host, port: port } = window.location;
        let domain = '';
        // If it is a .com.country domain
        if (/\.com\.[a-z]+$/i.test(host)) {
            const hostPieces = host.split('.').reverse();
            domain = !port && hostPieces.length >= 3 ? `; domain=.${hostPieces[2]}.${hostPieces[1]}.${hostPieces[0]}` : '';
        } else {
            const hostPieces = host.split('.').reverse();
            domain = !port && hostPieces.length >= 2 ? `; domain=.${hostPieces[1]}.${hostPieces[0]}` : '';
        }
        const date = new Date();
        date.setTime(date.getTime() + expiryDays * 86400000);
        document.cookie = `${key}=${value}; expires=${date.toUTCString()}${domain}; path=/`;
    }
}
module.exports.default = new $5e22e39e6385e5ef$var$Storage();

});


parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || type === $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});

parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bOOlK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $89ab6b9e702438b4$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("2BuCw")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("bBbjn")).default);
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $2BuCw = parcelRequire("2BuCw");

var $bBbjn = parcelRequire("bBbjn");
'use client';
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $e0f035ab0866fe47$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $acad92301ef10c3f$export$3b14a55fb2447963);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("2BuCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e56ca0825dc344f$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
let $1e56ca0825dc344f$var$cache;
if (typeof document === 'object') $1e56ca0825dc344f$var$cache = (0, $a9M6v.default)({
    key: 'css',
    prepend: true
});
function $1e56ca0825dc344f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $1e56ca0825dc344f$var$cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: $1e56ca0825dc344f$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});



parcelRegister("5QV4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6o2lr")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("dLM8u")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2UDLz")).default);

var $6o2lr = parcelRequire("6o2lr");

var $dLM8u = parcelRequire("dLM8u");

var $2UDLz = parcelRequire("2UDLz");

});
parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $dLM8u = parcelRequire("dLM8u");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $dLM8u.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $bVuw0.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("dLM8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06500f70819ed69$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $cKRCq.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("cKRCq", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $94935f79a2c44a85$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $94935f79a2c44a85$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $94935f79a2c44a85$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $94935f79a2c44a85$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $94935f79a2c44a85$export$6f98e8eaf0be1996);


var $3OJTQ = parcelRequire("3OJTQ");

var $k0igC = parcelRequire("k0igC");

var $aFh0N = parcelRequire("aFh0N");

var $hsAPr = parcelRequire("hsAPr");
const $94935f79a2c44a85$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $94935f79a2c44a85$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $hsAPr.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $94935f79a2c44a85$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$export$aab52a0dde05ad8a,
    ...$94935f79a2c44a85$export$f8397d44f03ab6ad
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $k0igC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aFh0N.default), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$aab52a0dde05ad8a);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$export$aab52a0dde05ad8a;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$f8397d44f03ab6ad);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$export$f8397d44f03ab6ad;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;

});
parcelRegister("3OJTQ", function(module, exports) {

$parcel$export(module.exports, "values", () => $2c79a5510dec9b08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $2c79a5510dec9b08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $2c79a5510dec9b08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $2c79a5510dec9b08$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $2c79a5510dec9b08$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $2c79a5510dec9b08$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");


var $3z1Ay = parcelRequire("3z1Ay");

var $aFh0N = parcelRequire("aFh0N");
const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aFh0N.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;

});
parcelRegister("aFh0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3aede628aa278f$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;

});


parcelRegister("k0igC", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e901fa2f27580273$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $e901fa2f27580273$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $e901fa2f27580273$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $3OJTQ = parcelRequire("3OJTQ");
function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;

});

parcelRegister("hsAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb619e97db430627$export$2e2bcd8739ae039);
function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $6b750d631801d296$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aFh0N = parcelRequire("aFh0N");

var $k0igC = parcelRequire("k0igC");

var $3OJTQ = parcelRequire("3OJTQ");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $k0igC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $k0igC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $k0igC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3OJTQ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3OJTQ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aFh0N.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");

var $jxD4j = parcelRequire("jxD4j");

var $nZvud = parcelRequire("nZvud");

var $8ru1G = parcelRequire("8ru1G");

var $imjyU = parcelRequire("imjyU");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $jxD4j.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $8ru1G.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $cKRCq.padding)
    },
    pt: {
        style: (0, $cKRCq.padding)
    },
    pr: {
        style: (0, $cKRCq.padding)
    },
    pb: {
        style: (0, $cKRCq.padding)
    },
    pl: {
        style: (0, $cKRCq.padding)
    },
    px: {
        style: (0, $cKRCq.padding)
    },
    py: {
        style: (0, $cKRCq.padding)
    },
    padding: {
        style: (0, $cKRCq.padding)
    },
    paddingTop: {
        style: (0, $cKRCq.padding)
    },
    paddingRight: {
        style: (0, $cKRCq.padding)
    },
    paddingBottom: {
        style: (0, $cKRCq.padding)
    },
    paddingLeft: {
        style: (0, $cKRCq.padding)
    },
    paddingX: {
        style: (0, $cKRCq.padding)
    },
    paddingY: {
        style: (0, $cKRCq.padding)
    },
    paddingInline: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineStart: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineEnd: {
        style: (0, $cKRCq.padding)
    },
    paddingBlock: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockStart: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockEnd: {
        style: (0, $cKRCq.padding)
    },
    m: {
        style: (0, $cKRCq.margin)
    },
    mt: {
        style: (0, $cKRCq.margin)
    },
    mr: {
        style: (0, $cKRCq.margin)
    },
    mb: {
        style: (0, $cKRCq.margin)
    },
    ml: {
        style: (0, $cKRCq.margin)
    },
    mx: {
        style: (0, $cKRCq.margin)
    },
    my: {
        style: (0, $cKRCq.margin)
    },
    margin: {
        style: (0, $cKRCq.margin)
    },
    marginTop: {
        style: (0, $cKRCq.margin)
    },
    marginRight: {
        style: (0, $cKRCq.margin)
    },
    marginBottom: {
        style: (0, $cKRCq.margin)
    },
    marginLeft: {
        style: (0, $cKRCq.margin)
    },
    marginX: {
        style: (0, $cKRCq.margin)
    },
    marginY: {
        style: (0, $cKRCq.margin)
    },
    marginInline: {
        style: (0, $cKRCq.margin)
    },
    marginInlineStart: {
        style: (0, $cKRCq.margin)
    },
    marginInlineEnd: {
        style: (0, $cKRCq.margin)
    },
    marginBlock: {
        style: (0, $cKRCq.margin)
    },
    marginBlockStart: {
        style: (0, $cKRCq.margin)
    },
    marginBlockEnd: {
        style: (0, $cKRCq.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $nZvud.gap)
    },
    rowGap: {
        style: (0, $nZvud.rowGap)
    },
    columnGap: {
        style: (0, $nZvud.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxWidth: {
        style: (0, $imjyU.maxWidth)
    },
    minWidth: {
        transform: (0, $imjyU.sizingTransform)
    },
    height: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    minHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("jxD4j", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $e39f6794db8cf9ac$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $e39f6794db8cf9ac$export$7a57f79000377ca2);


var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");
function $e39f6794db8cf9ac$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e39f6794db8cf9ac$var$createBorderStyle(prop, transform) {
    return (0, $k0igC.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = $e39f6794db8cf9ac$var$createBorderStyle('border', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = $e39f6794db8cf9ac$var$createBorderStyle('borderTop', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = $e39f6794db8cf9ac$var$createBorderStyle('borderRight', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = $e39f6794db8cf9ac$var$createBorderStyle('borderBottom', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$47658cca1a909427 = $e39f6794db8cf9ac$var$createBorderStyle('borderLeft', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = $e39f6794db8cf9ac$var$createBorderStyle('borderColor');
const $e39f6794db8cf9ac$export$126a92c968acdb85 = $e39f6794db8cf9ac$var$createBorderStyle('borderTopColor');
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = $e39f6794db8cf9ac$var$createBorderStyle('borderRightColor');
const $e39f6794db8cf9ac$export$340b0327727f6d1a = $e39f6794db8cf9ac$var$createBorderStyle('borderBottomColor');
const $e39f6794db8cf9ac$export$60beef91a985b4bf = $e39f6794db8cf9ac$var$createBorderStyle('borderLeftColor');
const $e39f6794db8cf9ac$export$f9258c55612cbed7 = $e39f6794db8cf9ac$var$createBorderStyle('outline', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$621fe586efeb64b9 = $e39f6794db8cf9ac$var$createBorderStyle('outlineColor');
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e39f6794db8cf9ac$var$borders = (0, $gojsU.default)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2, $e39f6794db8cf9ac$export$f9258c55612cbed7, $e39f6794db8cf9ac$export$621fe586efeb64b9);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;

});
parcelRegister("gojsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfc9d7e65f133$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");
function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aFh0N.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;

});


parcelRegister("nZvud", function(module, exports) {

$parcel$export(module.exports, "gap", () => $0481dc1348188242$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $0481dc1348188242$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $0481dc1348188242$export$8a833ffa5f5dbeda);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");

const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $k0igC.default)({
    prop: 'gridColumn'
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $k0igC.default)({
    prop: 'gridRow'
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $k0igC.default)({
    prop: 'gridAutoFlow'
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $k0igC.default)({
    prop: 'gridAutoColumns'
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $k0igC.default)({
    prop: 'gridAutoRows'
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $k0igC.default)({
    prop: 'gridTemplateColumns'
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $k0igC.default)({
    prop: 'gridTemplateRows'
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $k0igC.default)({
    prop: 'gridTemplateAreas'
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $k0igC.default)({
    prop: 'gridArea'
});
const $0481dc1348188242$var$grid = (0, $gojsU.default)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;

});

parcelRegister("8ru1G", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $625822e5d7cce21a$export$dbaffd4420ea0ac6);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
function $625822e5d7cce21a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $k0igC.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $k0igC.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $k0igC.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$var$palette = (0, $gojsU.default)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;

});

parcelRegister("imjyU", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $d5d974b5976c38ad$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $d5d974b5976c38ad$export$488fda99655ff65a);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $3OJTQ = parcelRequire("3OJTQ");
function $d5d974b5976c38ad$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $k0igC.default)({
    prop: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3OJTQ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $d5d974b5976c38ad$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $k0igC.default)({
    prop: 'minWidth',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $k0igC.default)({
    prop: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $k0igC.default)({
    prop: 'maxHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $k0igC.default)({
    prop: 'minHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $k0igC.default)({
    prop: 'boxSizing'
});
const $d5d974b5976c38ad$var$sizing = (0, $gojsU.default)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("2bwhi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9dZwz")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("9dZwz")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("hcz0Q")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("kOOck")).default);

var $9dZwz = parcelRequire("9dZwz");

var $hcz0Q = parcelRequire("hcz0Q");

var $kOOck = parcelRequire("kOOck");

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});

parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), (0, $8nd05.default)({}, props));
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});
parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $bpUvK = parcelRequire("bpUvK");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
'use client';
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($bpUvK)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("bpUvK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84fddd6da8624ed6$var$createStyled;
module.exports.shouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $84fddd6da8624ed6$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $84fddd6da8624ed6$var$_styledEngine = $84fddd6da8624ed6$var$_interopRequireWildcard((parcelRequire("bOOlK")));

var $3z1Ay = parcelRequire("3z1Ay");

var $84fddd6da8624ed6$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $84fddd6da8624ed6$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $84fddd6da8624ed6$var$_createTheme = $1jnue((parcelRequire("5QV4f")));

var $84fddd6da8624ed6$var$_styleFunctionSx = $1jnue((parcelRequire("2bwhi")));
const $84fddd6da8624ed6$var$_excluded = [
    "ownerState"
], $84fddd6da8624ed6$var$_excluded2 = [
    "variants"
], $84fddd6da8624ed6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $84fddd6da8624ed6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($84fddd6da8624ed6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $84fddd6da8624ed6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $84fddd6da8624ed6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $84fddd6da8624ed6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $84fddd6da8624ed6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $84fddd6da8624ed6$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $84fddd6da8624ed6$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $84fddd6da8624ed6$var$_createTheme.default)();
const $84fddd6da8624ed6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $84fddd6da8624ed6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $84fddd6da8624ed6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $84fddd6da8624ed6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $84fddd6da8624ed6$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(_ref, $84fddd6da8624ed6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $84fddd6da8624ed6$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$84fddd6da8624ed6$var$processStyleArg(resolvedStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $84fddd6da8624ed6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $84fddd6da8624ed6$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $84fddd6da8624ed6$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $84fddd6da8624ed6$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $84fddd6da8624ed6$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $84fddd6da8624ed6$var$_styleFunctionSx.default)((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
            theme: $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $84fddd6da8624ed6$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $84fddd6da8624ed6$var$defaultOverridesResolver($84fddd6da8624ed6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $84fddd6da8624ed6$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $84fddd6da8624ed6$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($84fddd6da8624ed6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $84fddd6da8624ed6$var$_styledEngine.default)(tag, (0, $84fddd6da8624ed6$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$84fddd6da8624ed6$var$processStyleArg(stylesArg, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: $84fddd6da8624ed6$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $84fddd6da8624ed6$var$processStyleArg(slotStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $84fddd6da8624ed6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $6o2lr = parcelRequire("6o2lr");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars) throw new Error((0, $cpmCj.default)(18));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $kSnzZ = parcelRequire("kSnzZ");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kSnzZ.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kSnzZ.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kSnzZ.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kSnzZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f32b24353f12f45a$var$alpha;
module.exports.blend = $f32b24353f12f45a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f32b24353f12f45a$var$darken;
module.exports.decomposeColor = $f32b24353f12f45a$var$decomposeColor;
module.exports.emphasize = $f32b24353f12f45a$var$emphasize;
module.exports.getContrastRatio = $f32b24353f12f45a$var$getContrastRatio;
module.exports.getLuminance = $f32b24353f12f45a$var$getLuminance;
module.exports.hexToRgb = $f32b24353f12f45a$var$hexToRgb;
module.exports.hslToRgb = $f32b24353f12f45a$var$hslToRgb;
module.exports.lighten = $f32b24353f12f45a$var$lighten;
module.exports.private_safeAlpha = $f32b24353f12f45a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f32b24353f12f45a$var$private_safeDarken;
module.exports.private_safeEmphasize = $f32b24353f12f45a$var$private_safeEmphasize;
module.exports.private_safeLighten = $f32b24353f12f45a$var$private_safeLighten;
module.exports.recomposeColor = $f32b24353f12f45a$var$recomposeColor;
module.exports.rgbToHex = $f32b24353f12f45a$var$rgbToHex;

var $f32b24353f12f45a$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f32b24353f12f45a$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f32b24353f12f45a$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f32b24353f12f45a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f32b24353f12f45a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f32b24353f12f45a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f32b24353f12f45a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f32b24353f12f45a$var$colorChannel = (color)=>{
    const decomposedColor = $f32b24353f12f45a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f32b24353f12f45a$var$colorChannel;
const $f32b24353f12f45a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f32b24353f12f45a$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f32b24353f12f45a$var$private_safeColorChannel;
function $f32b24353f12f45a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f32b24353f12f45a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f32b24353f12f45a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f32b24353f12f45a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f32b24353f12f45a$var$hslToRgb(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f32b24353f12f45a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f32b24353f12f45a$var$getLuminance(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f32b24353f12f45a$var$getContrastRatio(foreground, background) {
    const lumA = $f32b24353f12f45a$var$getLuminance(foreground);
    const lumB = $f32b24353f12f45a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$alpha(color, value) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    value = $f32b24353f12f45a$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeAlpha(color, value, warning) {
    try {
        return $f32b24353f12f45a$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$darken(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$lighten(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$emphasize(color, coefficient = 0.15) {
    return $f32b24353f12f45a$var$getLuminance(color) > 0.5 ? $f32b24353f12f45a$var$darken(color, coefficient) : $f32b24353f12f45a$var$lighten(color, coefficient);
}
function $f32b24353f12f45a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f32b24353f12f45a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f32b24353f12f45a$var$decomposeColor(background);
    const overlayColor = $f32b24353f12f45a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f32b24353f12f45a$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("jrcyy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("Uv4iZ").then(()=>parcelRequire('RDDAi'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("1BSOA", function(module, exports) {
"use strict";
var $12c3c43e40d8b514$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12c3c43e40d8b514$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $12c3c43e40d8b514$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$12c3c43e40d8b514$var$__exportStar((parcelRequire("4ustO")), module.exports);

$12c3c43e40d8b514$var$__exportStar((parcelRequire("2wkl1")), module.exports);

$12c3c43e40d8b514$var$__exportStar((parcelRequire("k4vgd")), module.exports);

});
parcelRegister("4ustO", function(module, exports) {
"use strict";
var $34500e41a993baa9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34500e41a993baa9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $34500e41a993baa9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$34500e41a993baa9$var$__exportStar((parcelRequire("kymdR")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("gxA3l")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("18S1g")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("26JUa")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("5A97x")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("6Jh06")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("b65sZ")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("cKNdE")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("01vI9")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("8G8Ct")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("fUrQV")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("MihZd")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("5PYyp")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("1XKP7")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("c4avu")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("7ZgD9")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("53ShT")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("avESx")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("gaUiF")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("giAOu")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("8NhPc")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("aJH8Q")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("fJI1A")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("bbm15")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("cXS49")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("e8Xf5")), module.exports);

$34500e41a993baa9$var$__exportStar((parcelRequire("akScr")), module.exports);

});
parcelRegister("kymdR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccordionItem = module.exports.AccordionContext = module.exports.Accordion = void 0;

var $6cabA = parcelRequire("6cabA");
Object.defineProperty(module.exports, "Accordion", {
    enumerable: true,
    get: function() {
        return $6cabA.Accordion;
    }
});
Object.defineProperty(module.exports, "AccordionContext", {
    enumerable: true,
    get: function() {
        return $6cabA.AccordionContext;
    }
});

var $lLDes = parcelRequire("lLDes");
Object.defineProperty(module.exports, "AccordionItem", {
    enumerable: true,
    get: function() {
        return $lLDes.AccordionItem;
    }
});

});
parcelRegister("6cabA", function(module, exports) {
"use client";
"use strict";
var $482bc3bf1981b654$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Accordion = module.exports.AccordionContext = void 0;

const $482bc3bf1981b654$var$react_1 = $482bc3bf1981b654$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
module.exports.AccordionContext = $482bc3bf1981b654$var$react_1.default.createContext({
    toggleItem: ()=>{},
    getIsExpanded: ()=>false,
    multiple: false
});
const $482bc3bf1981b654$var$Accordion = (props)=>{
    const { children: children, multiple: multiple = false } = props;
    const [expandedItems, setExpandedItems] = $482bc3bf1981b654$var$react_1.default.useState(new Set());
    const getIsExpanded = (itemId)=>expandedItems.has(itemId);
    const toggleItem = (itemId)=>{
        let nextExpandedItems = new Set(expandedItems);
        if (nextExpandedItems.has(itemId)) nextExpandedItems.delete(itemId);
        else if (multiple) nextExpandedItems.add(itemId);
        else nextExpandedItems = new Set([
            itemId
        ]);
        setExpandedItems(nextExpandedItems);
    };
    const context = {
        toggleItem: toggleItem,
        getIsExpanded: getIsExpanded,
        multiple: multiple || false
    };
    return $482bc3bf1981b654$var$react_1.default.createElement($2wkl1.Box, null, $482bc3bf1981b654$var$react_1.default.createElement(module.exports.AccordionContext.Provider, {
        value: context
    }, children));
};
module.exports.Accordion = $482bc3bf1981b654$var$Accordion;

});
parcelRegister("2wkl1", function(module, exports) {
"use strict";
var $1d5e58a2649b4ff6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d5e58a2649b4ff6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1d5e58a2649b4ff6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridContext = module.exports.GridColumn = module.exports.Grid = void 0;

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("hWTWV")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("eUjE3")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("f7Eru")), module.exports);

var $5Tsdw = parcelRequire("5Tsdw");
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $5Tsdw.Grid;
    }
});
Object.defineProperty(module.exports, "GridColumn", {
    enumerable: true,
    get: function() {
        return $5Tsdw.GridColumn;
    }
});
Object.defineProperty(module.exports, "GridContext", {
    enumerable: true,
    get: function() {
        return $5Tsdw.GridContext;
    }
});

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("lLL0E")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("lLL0E")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("bxZtt")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("dSStr")), module.exports);

$1d5e58a2649b4ff6$var$__exportStar((parcelRequire("hNuyC")), module.exports);

});
parcelRegister("hWTWV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Box = void 0;

var $4Qubq = parcelRequire("4Qubq");
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $4Qubq.Box;
    }
});

});
parcelRegister("4Qubq", function(module, exports) {
"use client";
"use strict";
var $38736e8815361b4f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $38736e8815361b4f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Box = void 0;

const $38736e8815361b4f$var$react_1 = $38736e8815361b4f$var$__importDefault((parcelRequire("acw62")));

var $8etk3 = parcelRequire("8etk3");

var $kjxh0 = parcelRequire("kjxh0");

var $dSStr = parcelRequire("dSStr");
const $38736e8815361b4f$var$getClassNameWithReset = (className)=>$dSStr.resetClassName + (className ? ` ${className}` : "");
module.exports.Box = $38736e8815361b4f$var$react_1.default.forwardRef((_a, ref)=>{
    var { className: className, sx: sxInitial } = _a, props = $38736e8815361b4f$var$__rest(_a, [
        "className",
        "sx"
    ]);
    const sx = Object.assign({
        fontFamily: "body"
    }, sxInitial);
    const { newInheritedStylesContext: newInheritedStylesContext, mergedSx: mergedSx } = (0, $kjxh0.useMergeStyles)(sx);
    return $38736e8815361b4f$var$react_1.default.createElement($kjxh0.InheritedStylesProvider, {
        styleContext: newInheritedStylesContext
    }, $38736e8815361b4f$var$react_1.default.createElement($8etk3.Box, Object.assign({
        className: $38736e8815361b4f$var$getClassNameWithReset(className),
        ref: ref,
        sx: mergedSx
    }, props)));
});
module.exports.Box.displayName = "Box";

});
parcelRegister("8etk3", function(module, exports) {

$parcel$export(module.exports, "Box", () => $5fe66056dab4553f$export$e71c4d32a2263218);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $ic7Fh = parcelRequire("ic7Fh");

var $9X3k8 = parcelRequire("9X3k8");
const $5fe66056dab4553f$var$boxSystemProps = [
    // space scale props (inherited from @styled-system/space)
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    // color props (inherited from @styled-system/color)
    'color',
    'backgroundColor',
    'bg',
    'opacity'
];
/**
 * @internal
 */ const $5fe66056dab4553f$export$fd49c9f89c379185 = (prop)=>$5fe66056dab4553f$var$boxSystemProps.includes(prop);
const $5fe66056dab4553f$var$pickSystemProps = (props)=>{
    const res = {};
    for (const key of $5fe66056dab4553f$var$boxSystemProps)res[key] = props[key];
    return res;
};
/**
 * Use the Box component as a layout primitive to add margin, padding, and colors to content.
 * @see https://theme-ui.com/components/box
 */ const $5fe66056dab4553f$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $acw62.forwardRef)(function Box(props, ref) {
    const theme = (0, $eP9YU.u)();
    const { __themeKey: __themeKey = 'variants', __css: __css, variant: variant, css: cssProp, sx: sx, as: Component = 'div', ...rest } = props;
    const baseStyles = {
        boxSizing: 'border-box',
        margin: 0,
        minWidth: 0
    };
    const __cssStyles = (0, $ic7Fh.css)(__css)(theme);
    const variantInTheme = (0, $ic7Fh.get)(theme, `${__themeKey}.${variant}`) || (0, $ic7Fh.get)(theme, variant);
    const variantStyles = variantInTheme && (0, $ic7Fh.css)(variantInTheme)(theme);
    const sxPropStyles = (0, $ic7Fh.css)(sx)(theme);
    const systemPropsStyles = (0, $ic7Fh.css)($5fe66056dab4553f$var$pickSystemProps(rest))(theme);
    const style = [
        baseStyles,
        __cssStyles,
        variantStyles,
        sxPropStyles,
        systemPropsStyles,
        cssProp
    ];
    $5fe66056dab4553f$var$boxSystemProps.forEach((name)=>{
        delete rest[name];
    });
    return (0, $9X3k8.jsx)(Component, {
        ref: ref,
        css: style,
        ...rest
    });
});
/**
 * Use the Flex component to create flexbox layouts.
 * @see https://theme-ui.com/components/flex
 */ const $5fe66056dab4553f$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Flex(props, ref) {
    const { sx: sx } = props;
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        ...props,
        sx: (theme)=>({
                display: 'flex',
                ...typeof sx === 'function' ? sx(theme) : sx
            })
    });
});
const $5fe66056dab4553f$var$getProps = (test)=>(props)=>{
        const next = {};
        for(const key in props)if (test(key || '')) next[key] = props[key];
        return next;
    };
const $5fe66056dab4553f$var$MRE = /^m[trblxy]?$/;
const $5fe66056dab4553f$var$getMargin = $5fe66056dab4553f$var$getProps((k)=>$5fe66056dab4553f$var$MRE.test(k));
const $5fe66056dab4553f$var$omitMargin = $5fe66056dab4553f$var$getProps((k)=>!$5fe66056dab4553f$var$MRE.test(k));
/** @internal */ function $5fe66056dab4553f$var$__internalProps(props) {
    return props;
}
/**
 * @internal Props used by Theme UI Components not intended for user code.
 */ const $5fe66056dab4553f$var$px = (n)=>typeof n === 'number' ? n + 'px' : n;
const $5fe66056dab4553f$var$singleWidthToColumns = (width, repeat)=>width ? `repeat(auto-${repeat}, minmax(${$5fe66056dab4553f$var$px(width)}, 1fr))` : null;
const $5fe66056dab4553f$var$widthToColumns = (width, repeat)=>Array.isArray(width) ? width.map((w)=>$5fe66056dab4553f$var$singleWidthToColumns(w, repeat)) : $5fe66056dab4553f$var$singleWidthToColumns(width, repeat);
const $5fe66056dab4553f$var$singleCountToColumns = (n)=>n ? typeof n === 'number' ? `repeat(${n}, 1fr)` : n : null;
const $5fe66056dab4553f$var$countToColumns = (n)=>Array.isArray(n) ? n.map($5fe66056dab4553f$var$singleCountToColumns) : $5fe66056dab4553f$var$singleCountToColumns(n);
/**
 * CSS grid layout component to arrange direct child elements in a tiled grid layout.
 * @see https://theme-ui.com/components/grid
 */ const $5fe66056dab4553f$export$ef2184bd89960b14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Grid({ width: width, columns: columns, gap: gap = 3, repeat: repeat = 'fit', ...props }, ref) {
    const gridTemplateColumns = !!width ? $5fe66056dab4553f$var$widthToColumns(width, repeat) : $5fe66056dab4553f$var$countToColumns(columns);
    const __css = {
        display: 'grid',
        gridGap: gap,
        gridTemplateColumns: gridTemplateColumns
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'grids',
            __css: __css
        })
    });
});
const $5fe66056dab4553f$var$Box = $5fe66056dab4553f$export$e71c4d32a2263218;
/**
 * Primitive button component with variants
 * @see https://theme-ui.com/components/button
 */ const $5fe66056dab4553f$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Button(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$var$Box, {
        ref: ref,
        as: "button",
        variant: "primary",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'buttons',
            __css: {
                appearance: 'none',
                display: props.hidden ? undefined : 'inline-block',
                textAlign: 'center',
                lineHeight: 'inherit',
                textDecoration: 'none',
                fontSize: 'inherit',
                px: 3,
                py: 2,
                color: 'white',
                bg: 'primary',
                border: 0,
                borderRadius: 4
            }
        })
    });
});
/**
 * Link variants can be defined in the `theme.links` object.
 * By default the Link component will use styles defined in `theme.styles.a`.
 * @see https://theme-ui.com/components/link
 */ const $5fe66056dab4553f$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Link(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "a",
        variant: "styles.a",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'links'
        })
    });
});
/**
 * Primitive typographic component.
 *
 * Text style variants can be defined in the theme.text object.
 * The Paragraph component uses theme.text.paragraph as its default variant style.
 * @see https://theme-ui.com/components/paragraph
 */ const $5fe66056dab4553f$export$358a232cca1ab2ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Paragraph(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "p",
        variant: "paragraph",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'text',
            __css: {
                fontFamily: 'body',
                fontWeight: 'body',
                lineHeight: 'body'
            }
        })
    });
});
/**
 * Primitive typographic component.
 *
 * Text style variants can be defined in the theme.text object.
 * @see https://theme-ui.com/components/text
 */ const $5fe66056dab4553f$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Text(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        as: "span",
        ref: ref,
        variant: "default",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'text'
        })
    });
});
/**
 * Primitive heading component, defaults to <h2>.
 *
 * Text style variants can be defined in the theme.text object.
 * The Heading component uses theme.text.heading as its default variant style.
 * @see https://theme-ui.com/components/heading
 */ const $5fe66056dab4553f$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Heading(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "h2",
        variant: "heading",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'text',
            __css: {
                fontFamily: 'heading',
                fontWeight: 'heading',
                lineHeight: 'heading'
            }
        })
    });
});
/**
 * Image style variants can be defined in the theme.images object.
 * @see https://theme-ui.com/components/image/
 */ const $5fe66056dab4553f$export$3e431a229df88919 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Image(props, ref) {
    const __outerCss = props.__css;
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "img",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'images',
            __css: {
                maxWidth: '100%',
                height: 'auto',
                ...__outerCss
            }
        })
    });
});
/**
 * Card style variants can be defined in the `theme.cards` object.
 * By default the Card component uses the `theme.cards.primary` variant.
 * @see https://theme-ui.com/components/card
 */ const $5fe66056dab4553f$export$60332b2344f7fe41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Card(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        variant: "primary",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'cards'
        })
    });
});
/**
 * Label variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.label` variant by default.
 * @see https://theme-ui.com/components/label/
 */ const $5fe66056dab4553f$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Label(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "label",
        variant: "label",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'forms',
            __css: {
                width: '100%',
                display: 'flex'
            }
        })
    });
});
const $5fe66056dab4553f$var$autofillStyles = {
    boxShadow: 'inset 0 0 0 1000px var(--theme-ui-input-autofill-bg)',
    fontSize: 'inherit',
    ':first-line': {
        fontSize: '1rem'
    }
};
const $5fe66056dab4553f$var$defaultInputStyles = {
    display: 'block',
    width: '100%',
    p: 2,
    appearance: 'none',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    border: '1px solid',
    borderRadius: 4,
    color: 'inherit',
    bg: 'transparent',
    ':autofill, :autofill:hover, :autofill:focus': $5fe66056dab4553f$var$autofillStyles,
    ':-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus': $5fe66056dab4553f$var$autofillStyles
};
/**
 * Input variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.input` variant by default.
 * @see https://theme-ui.com/components/input/
 */ const $5fe66056dab4553f$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Input({ sx: sx, autofillBackgroundColor: autofillBackgroundColor = 'background', ...rest }, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "input",
        variant: "input",
        sx: {
            '--theme-ui-input-autofill-bg': (theme)=>theme.colors && (0, $ic7Fh.get)(theme.colors, autofillBackgroundColor, null),
            ...sx
        },
        ...rest,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'forms',
            __css: $5fe66056dab4553f$var$defaultInputStyles
        })
    });
});
const $5fe66056dab4553f$var$SVG = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function SVG({ size: size = 24, ...rest }, ref) {
    const svgProps = {
        xmlns: 'http://www.w3.org/2000/svg',
        width: size,
        height: size,
        viewBox: '0 0 24 24',
        fill: 'currentcolor',
        ...rest
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "svg",
        ...svgProps
    });
});
$5fe66056dab4553f$var$SVG.displayName = 'SVG';
const $5fe66056dab4553f$var$DownArrow = (props)=>(0, $9X3k8.jsx)($5fe66056dab4553f$var$SVG, {
        ...props,
        children: (0, $9X3k8.jsx)("path", {
            d: "M7 10l5 5 5-5z"
        })
    });
/**
 * Select variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.select` variant by default.
 * @see https://theme-ui.com/components/select/
 */ const $5fe66056dab4553f$export$ef9b1a59e592288f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Select({ arrow: arrow, ...props }, ref) {
    const __css = {
        display: 'block',
        width: '100%',
        p: 2,
        paddingRight: 4,
        appearance: 'none',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        border: '1px solid',
        borderRadius: 4,
        color: 'inherit',
        backgroundColor: (theme)=>(0, $ic7Fh.get)(theme, 'colors.background', null)
    };
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ...$5fe66056dab4553f$var$getMargin(props),
        sx: {
            display: 'flex'
        },
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                ref: ref,
                as: "select",
                variant: "select",
                ...$5fe66056dab4553f$var$omitMargin(props),
                ...$5fe66056dab4553f$var$__internalProps({
                    __themeKey: 'forms',
                    __css: __css
                })
            }),
            arrow || (0, $9X3k8.jsx)($5fe66056dab4553f$var$DownArrow, {
                sx: {
                    ml: -28,
                    alignSelf: 'center',
                    pointerEvents: 'none'
                }
            })
        ]
    });
});
/**
 * Form textarea component
 *
 * Textarea variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.textarea` variant by default.
 * @see https://theme-ui.com/components/textarea/
 */ const $5fe66056dab4553f$export$379139ebc1c2b235 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Textarea(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "textarea",
        variant: "textarea",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'forms',
            __css: {
                display: 'block',
                width: '100%',
                p: 2,
                appearance: 'none',
                fontSize: 'inherit',
                lineHeight: 'inherit',
                border: '1px solid',
                borderRadius: 4,
                color: 'inherit',
                bg: 'transparent'
            }
        })
    });
});
const $5fe66056dab4553f$var$RadioChecked = (props)=>(0, $9X3k8.jsx)($5fe66056dab4553f$var$SVG, {
        ...props,
        children: (0, $9X3k8.jsx)("path", {
            d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        })
    });
const $5fe66056dab4553f$var$RadioUnchecked = (props)=>(0, $9X3k8.jsx)($5fe66056dab4553f$var$SVG, {
        ...props,
        children: (0, $9X3k8.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        })
    });
const $5fe66056dab4553f$var$RadioIcon = (props)=>(0, $9X3k8.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$var$RadioChecked, {
                ...props,
                ...$5fe66056dab4553f$var$__internalProps({
                    __css: {
                        display: 'none',
                        'input:checked ~ &': {
                            display: 'block'
                        }
                    }
                })
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$var$RadioUnchecked, {
                ...props,
                ...$5fe66056dab4553f$var$__internalProps({
                    __css: {
                        display: 'block',
                        'input:checked ~ &': {
                            display: 'none'
                        }
                    }
                })
            })
        ]
    });
/**
 * Form radio input component
 *
 * Radio variants can be defined in `theme.forms` and the
 * component uses the `theme.forms.radio variant` by default.
 * @see https://theme-ui.com/components/radio/
 */ const $5fe66056dab4553f$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Radio({ className: className, sx: sx, variant: variant = 'radio', ...props }, ref) {
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        sx: {
            minWidth: 'min-content'
        },
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                ref: ref,
                as: "input",
                type: "radio",
                ...props,
                sx: {
                    position: 'absolute',
                    opacity: 0,
                    zIndex: -1,
                    width: 1,
                    height: 1,
                    overflow: 'hidden'
                }
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                as: $5fe66056dab4553f$var$RadioIcon,
                "aria-hidden": "true",
                variant: variant,
                className: className,
                sx: sx,
                ...$5fe66056dab4553f$var$__internalProps({
                    __themeKey: 'forms',
                    __css: {
                        mr: 2,
                        borderRadius: 9999,
                        color: 'gray',
                        flexShrink: 0,
                        'input:checked ~ &': {
                            color: 'primary'
                        },
                        'input:focus ~ &': {
                            bg: 'highlight'
                        }
                    }
                })
            })
        ]
    });
});
const $5fe66056dab4553f$var$CheckboxChecked = (props)=>(0, $9X3k8.jsx)($5fe66056dab4553f$var$SVG, {
        ...props,
        children: (0, $9X3k8.jsx)("path", {
            d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        })
    });
const $5fe66056dab4553f$var$CheckboxUnchecked = (props)=>(0, $9X3k8.jsx)($5fe66056dab4553f$var$SVG, {
        ...props,
        children: (0, $9X3k8.jsx)("path", {
            d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
        })
    });
const $5fe66056dab4553f$var$CheckboxIcon = (props)=>(0, $9X3k8.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$var$CheckboxChecked, {
                ...props,
                ...$5fe66056dab4553f$var$__internalProps({
                    __css: {
                        display: 'none',
                        'input:checked ~ &': {
                            display: 'block'
                        }
                    }
                })
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$var$CheckboxUnchecked, {
                ...props,
                ...$5fe66056dab4553f$var$__internalProps({
                    __css: {
                        display: 'block',
                        'input:checked ~ &': {
                            display: 'none'
                        }
                    }
                })
            })
        ]
    });
/**
 * Form checkbox input component
 *
 * Checkbox variants can be defined in `theme.forms` and the
 * component uses the `theme.forms.checkbox` variant by default.
 * @see https://theme-ui.com/components/checkbox/
 */ const $5fe66056dab4553f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Checkbox({ className: className, sx: sx, variant: variant = 'checkbox', children: children, ...props }, ref) {
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        sx: {
            minWidth: 'min-content'
        },
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                ref: ref,
                as: "input",
                type: "checkbox",
                ...props,
                sx: {
                    position: 'absolute',
                    opacity: 0,
                    zIndex: -1,
                    width: 1,
                    height: 1,
                    overflow: 'hidden'
                }
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                as: $5fe66056dab4553f$var$CheckboxIcon,
                "aria-hidden": "true",
                variant: variant,
                className: className,
                sx: sx,
                ...$5fe66056dab4553f$var$__internalProps({
                    __themeKey: 'forms',
                    __css: {
                        mr: 2,
                        borderRadius: 4,
                        color: 'gray',
                        flexShrink: 0,
                        'input:checked ~ &': {
                            color: 'primary'
                        },
                        'input:focus ~ &': {
                            color: 'primary',
                            bg: 'highlight'
                        }
                    }
                })
            }),
            children
        ]
    });
});
const $5fe66056dab4553f$var$GUTTER = 2;
const $5fe66056dab4553f$var$SIZE = 18;
/**
 * Form switch component
 *
 * Switch variants can be defined in `theme.forms`
 * and the component uses the `theme.forms.switch` variant by default.
 */ const $5fe66056dab4553f$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Switch({ className: className, label: label, sx: sx, variant: variant = 'switch', ...rest }, ref) {
    const __css = {
        position: 'relative',
        flexShrink: 0,
        bg: 'gray',
        borderRadius: $5fe66056dab4553f$var$SIZE,
        height: $5fe66056dab4553f$var$SIZE + $5fe66056dab4553f$var$GUTTER * 2,
        width: $5fe66056dab4553f$var$SIZE * 2 + $5fe66056dab4553f$var$GUTTER * 2,
        mr: 2,
        'input:disabled ~ &': {
            opacity: 0.5,
            cursor: 'not-allowed'
        },
        '& > div': {
            display: 'flex',
            alignItems: 'center',
            borderRadius: '50%',
            height: $5fe66056dab4553f$var$SIZE,
            width: $5fe66056dab4553f$var$SIZE,
            bg: 'white',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            transform: 'translateX(0%)',
            transition: `transform 240ms cubic-bezier(0.165, 0.840, 0.440, 1.000)`
        },
        'input:checked ~ &': {
            bg: 'primary',
            '> div': {
                transform: 'translateX(100%)'
            }
        }
    };
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$b04be29aa201d4f5, {
        sx: {
            cursor: 'pointer'
        },
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                ref: ref,
                as: "input",
                type: "checkbox",
                "aria-label": label,
                ...rest,
                sx: {
                    position: 'absolute',
                    opacity: 0,
                    zIndex: -1,
                    width: 1,
                    height: 1,
                    overflow: 'hidden'
                },
                ...$5fe66056dab4553f$var$__internalProps({
                    __themeKey: 'forms'
                })
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                css: {
                    padding: $5fe66056dab4553f$var$GUTTER
                },
                variant: variant,
                className: className,
                sx: sx,
                ...$5fe66056dab4553f$var$__internalProps({
                    __themeKey: 'forms',
                    __css: __css
                }),
                children: (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {})
            }),
            (0, $9X3k8.jsx)("span", {
                children: label
            })
        ]
    });
});
const $5fe66056dab4553f$var$thumbStyle = {
    appearance: 'none',
    width: 16,
    height: 16,
    bg: 'currentcolor',
    border: 0,
    borderRadius: 9999,
    variant: 'forms.slider.thumb'
};
const $5fe66056dab4553f$var$sliderStyle = {
    display: 'block',
    width: '100%',
    height: 4,
    my: 2,
    cursor: 'pointer',
    appearance: 'none',
    borderRadius: 9999,
    color: 'inherit',
    bg: 'gray',
    ':focus': {
        outline: 'none',
        color: 'primary'
    },
    '&::-webkit-slider-thumb': $5fe66056dab4553f$var$thumbStyle,
    '&::-moz-range-thumb': $5fe66056dab4553f$var$thumbStyle,
    '&::-ms-thumb': $5fe66056dab4553f$var$thumbStyle
};
/**
 * Range input element
 *
 * Slider variants can be defined in the `theme.forms` object.
 * The Slider component uses `theme.forms.slider` as its default variant style.
 * @see https://theme-ui.com/components/slider/
 */ const $5fe66056dab4553f$export$472062a354075cee = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Slider(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "input",
        type: "range",
        variant: "slider",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'forms',
            __css: $5fe66056dab4553f$var$sliderStyle
        })
    });
});
const $5fe66056dab4553f$export$a455218a85c89869 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Field({ // if somebody specifies the generic parameter without passing `as` prop, they get Input anyway
as: Control = $5fe66056dab4553f$export$f5b8910cec6cf069, label: label, id: id, name: name, ...rest }, ref) {
    const fieldIdentifier = id || name;
    const controlProps = {
        ref: ref,
        name: name,
        id: fieldIdentifier,
        ...$5fe66056dab4553f$var$omitMargin(rest)
    };
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ...$5fe66056dab4553f$var$getMargin(rest),
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$b04be29aa201d4f5, {
                htmlFor: fieldIdentifier,
                children: label
            }),
            (0, $9X3k8.jsx)(Control, {
                ...controlProps
            })
        ]
    });
}); // Field is generic bcs of `as` prop, so we can't just use types from forwardRef
/**
 * Horizontal `<progress />` bar
 * @see https://theme-ui.com/components/progress/
 */ const $5fe66056dab4553f$export$b25a304ec7d746bb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Progress(props, ref) {
    const __css = {
        display: 'block',
        width: '100%',
        height: '4px',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        appearance: 'none',
        color: 'primary',
        bg: 'gray',
        borderRadius: 9999,
        border: 'none',
        '&::-webkit-progress-bar': {
            bg: 'transparent'
        },
        '&::-webkit-progress-value': {
            bg: 'currentcolor'
        },
        '&::-moz-progress-bar': {
            bg: 'currentcolor'
        }
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "progress",
        variant: "styles.progress",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: __css
        })
    });
});
/**
 * Single value SVG donut chart
 * @see https://theme-ui.com/components/donut/
 */ const $5fe66056dab4553f$export$b8fe54a0788b746d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Donut({ size: size = 128, strokeWidth: strokeWidth = 2, value: value = 0, min: min = 0, max: max = 1, title: title, ...props }, ref) {
    const r = 16 - (typeof strokeWidth === 'number' ? strokeWidth : parseFloat(strokeWidth));
    const C = 2 * r * Math.PI;
    const offset = C - (value - min) / (max - min) * C;
    const svgProps = {
        strokeWidth: strokeWidth,
        viewBox: '0 0 32 32',
        width: size,
        height: size,
        fill: 'none',
        stroke: 'currentcolor'
    };
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "svg",
        role: "img",
        "aria-valuenow": value,
        "aria-valuemin": min,
        "aria-valuemax": max,
        ...svgProps,
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: {
                color: 'primary'
            }
        }),
        children: [
            title && (0, $9X3k8.jsx)("title", {
                children: title
            }),
            (0, $9X3k8.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: r,
                opacity: 1 / 8
            }),
            (0, $9X3k8.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: r,
                strokeDasharray: C,
                strokeDashoffset: offset,
                transform: "rotate(-90 16 16)"
            })
        ]
    });
});
const $5fe66056dab4553f$export$7f7cbe89f1eacd2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Spinner({ size: size = 48, strokeWidth: strokeWidth = 4, max: max = 1, title: title = 'Loading', duration: duration = 750, ...props }, ref) {
    const __css = {
        color: 'primary',
        overflow: 'visible'
    };
    const svgProps = {
        strokeWidth: strokeWidth,
        viewBox: '0 0 32 32',
        width: size,
        height: size,
        fill: 'none',
        stroke: 'currentColor',
        role: 'img'
    };
    const circleProps = {
        strokeWidth: strokeWidth,
        r: 16 - strokeWidth,
        cx: 16,
        cy: 16,
        fill: 'none'
    };
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "svg",
        ...svgProps,
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: __css
        }),
        children: [
            (0, $9X3k8.jsx)("title", {
                children: title
            }),
            (0, $9X3k8.jsx)("circle", {
                ...circleProps,
                opacity: 1 / 8
            }),
            (0, $9X3k8.jsx)("circle", {
                ...circleProps,
                strokeDasharray: "20 110",
                children: (0, $9X3k8.jsx)("animateTransform", {
                    attributeName: "transform",
                    attributeType: "XML",
                    type: "rotate",
                    from: "0 16 16",
                    to: "360 16 16",
                    dur: `${duration}ms`,
                    repeatCount: "indefinite"
                })
            })
        ]
    });
});
const $5fe66056dab4553f$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Avatar({ size: size = 48, ...props }, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$3e431a229df88919, {
        ref: ref,
        width: size,
        height: size,
        variant: "avatar",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: {
                borderRadius: 9999
            }
        })
    });
});
const $5fe66056dab4553f$export$37acb3580601e69a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Badge(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        variant: "primary",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'badges',
            __css: {
                display: 'inline-block',
                verticalAlign: 'baseline',
                fontSize: 0,
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                px: 1,
                borderRadius: 2,
                color: 'white',
                bg: 'primary'
            }
        })
    });
});
/**
 * Transparent button for SVG icons
 *
 * IconButton variants can be defined in the `theme.buttons` object.
 * By default the IconButton component will use styles defined in `theme.buttons.icon`.
 *
 * @see https://theme-ui.com/components/icon-button
 */ const $5fe66056dab4553f$export$c25acd513dcc8062 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function IconButton({ size: size = 32, ...props }, ref) {
    const emotionCssLabel = props.__css?.label || 'IconButton';
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "button",
        variant: "icon",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'buttons',
            __css: {
                label: emotionCssLabel,
                appearance: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 1,
                width: size,
                height: size,
                color: 'inherit',
                bg: 'transparent',
                border: 'none',
                borderRadius: 4
            }
        })
    });
});
const $5fe66056dab4553f$export$cae179f078f4b4a4 = (0, $9X3k8.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: (0, $9X3k8.jsx)("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })
});
/**
 * Button with close (×) icon.
 *
 * The Close component renders as a <button> element by default.
 * Pass any button attributes as props to the component.
 *
 * Close component variants can be defined in the theme.buttons object.
 * The Close component uses theme.buttons.close as its default variant style.
 */ const $5fe66056dab4553f$export$f39c2d165cd861fe = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Close({ size: size = 32, ...props }, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$c25acd513dcc8062, {
        ref: ref,
        size: size,
        title: "Close",
        "aria-label": "Close",
        variant: "close",
        ...props,
        children: $5fe66056dab4553f$export$cae179f078f4b4a4
    });
});
/**
 * Component for displaying messages, notifications, or other application state.
 *
 * Alert variants can be defined in `theme.alerts`.
 * The Alert component uses `theme.alerts.primary` as its default variant.
 */ const $5fe66056dab4553f$export$caec2af78bcc877f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Alert(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        variant: "primary",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'alerts',
            __css: {
                display: 'flex',
                alignItems: 'center',
                px: 3,
                py: 2,
                fontWeight: 'bold',
                color: 'white',
                bg: 'primary',
                borderRadius: 4
            }
        })
    });
});
/**
 * The Divider component reuses styles from `theme.styles.hr` as its default variant.
 */ const $5fe66056dab4553f$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Divider(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        as: "hr",
        variant: "styles.hr",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: {
                color: 'gray',
                m: 0,
                my: 2,
                border: 0,
                borderBottom: '1px solid'
            }
        })
    });
});
const $5fe66056dab4553f$var$getContainerProps = $5fe66056dab4553f$var$getProps($5fe66056dab4553f$export$fd49c9f89c379185);
const $5fe66056dab4553f$var$getIframeProps = $5fe66056dab4553f$var$getProps((str)=>!$5fe66056dab4553f$export$fd49c9f89c379185(str));
/**
 * Responsive iframe for video embeds.
 *
 * Embed variants can be defined anywhere in the theme object.
 *
 * @see https://theme-ui.com/components/embed
 */ const $5fe66056dab4553f$export$a84540bc8b694b2d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Embed({ variant: variant, sx: sx, ratio: ratio = 16 / 9, src: src, frameBorder: frameBorder = 0, allowFullScreen: allowFullScreen = true, width: width = 560, height: height = 315, allow: allow, ...rest }, ref) {
    const iframeProps = {
        src: src,
        width: width,
        height: height,
        frameBorder: frameBorder,
        allowFullScreen: allowFullScreen,
        allow: allow,
        ...$5fe66056dab4553f$var$getIframeProps(rest)
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        variant: variant,
        sx: sx,
        ...$5fe66056dab4553f$var$getContainerProps(rest),
        ...$5fe66056dab4553f$var$__internalProps({
            __css: {
                width: '100%',
                height: 0,
                paddingBottom: 100 / ratio + '%',
                position: 'relative',
                overflow: 'hidden'
            }
        }),
        children: (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
            ref: ref,
            as: "iframe",
            ...iframeProps,
            ...$5fe66056dab4553f$var$__internalProps({
                __css: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    border: 0
                }
            })
        })
    });
});
/**
 * Component for maintaining a fluid-width aspect ratio
 * @see https://theme-ui.com/components/aspect-ratio
 */ const $5fe66056dab4553f$export$e840e8869344ca38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function AspectRatio({ ratio: ratio = 4 / 3, children: children, ...props }, ref) {
    return (0, $9X3k8.jsxs)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        sx: {
            position: 'relative',
            overflow: 'hidden'
        },
        children: [
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                sx: {
                    width: '100%',
                    height: 0,
                    paddingBottom: 100 / ratio + '%'
                }
            }),
            (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
                ...props,
                ...$5fe66056dab4553f$var$__internalProps({
                    __css: {
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }
                }),
                children: children
            })
        ]
    });
});
/**
 * Image component constrained by as aspect ratio.
 * @see https://theme-ui.com/components/aspect-image
 */ const $5fe66056dab4553f$export$89cf017e72fc5325 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function AspectImage({ ratio: ratio, ...props }, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e840e8869344ca38, {
        ratio: ratio,
        children: (0, $9X3k8.jsx)($5fe66056dab4553f$export$3e431a229df88919, {
            ref: ref,
            ...props,
            ...$5fe66056dab4553f$var$__internalProps({
                __css: {
                    objectFit: 'cover'
                }
            })
        })
    });
});
/**
 * Centered, max-width layout component
 *
 * Container variants can be defined in the `theme.layout` object.
 * The Container component uses `theme.layout.container` as its default variant style.
 * @see https://theme-ui.com/components/container
 */ const $5fe66056dab4553f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Container(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        variant: "container",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'layout',
            __css: {
                width: '100%',
                maxWidth: 'container',
                mx: 'auto'
            }
        })
    });
});
/**
 * Link component for use in navigation
 *
 * NavLink variants can be defined in the `theme.links` object.
 * By default the NavLink component will use styles defined in `theme.links.nav`.
 * @see https://theme-ui.com/components/nav-link
 */ const $5fe66056dab4553f$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function NavLink(props, ref) {
    const __css = {
        color: 'inherit',
        textDecoration: 'none',
        fontWeight: 'bold',
        display: 'inline-block',
        '&:hover, &:focus, &.active': {
            color: 'primary'
        }
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$a6c7ac8248d6e38a, {
        ref: ref,
        variant: "nav",
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __css: __css
        })
    });
});
/**
 * Styled Box component for callouts and inline messages
 *
 * Message variants can be defined in the theme.messages object.
 * @see https://theme-ui.com/components/message
 */ const $5fe66056dab4553f$export$f69c19e57285b83a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Message(props, ref) {
    const __css = {
        padding: 3,
        paddingLeft: (t)=>t.space && Number(t.space[3]) - Number(t.space[1]),
        borderLeftWidth: (t)=>t.space && Number(t.space[1]),
        borderLeftStyle: 'solid',
        borderLeftColor: 'primary',
        borderRadius: 4,
        bg: 'highlight'
    };
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$e71c4d32a2263218, {
        ref: ref,
        ...props,
        ...$5fe66056dab4553f$var$__internalProps({
            __themeKey: 'messages',
            __css: __css
        })
    });
});
const $5fe66056dab4553f$export$46e1d66043f363e6 = ({ size: size = 24 })=>{
    return (0, $9X3k8.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        fill: "currentColor",
        css: {
            display: 'block',
            margin: 0,
            boxSizing: 'border-box',
            minWidth: 0
        },
        children: (0, $9X3k8.jsx)("path", {
            d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
        })
    });
};
/**
 * MenuButton variants can be defined in the `theme.buttons` object.
 * By default the MenuButton component will use styles defined in `theme.buttons.menu`.
 *
 * @see https://theme-ui.com/components/menu-button
 */ const $5fe66056dab4553f$export$266a769812832828 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function MenuButton(props, ref) {
    return (0, $9X3k8.jsx)($5fe66056dab4553f$export$c25acd513dcc8062, {
        ref: ref,
        title: "Menu",
        "aria-label": "Toggle Menu",
        variant: "menu",
        ...props,
        children: (0, $9X3k8.jsx)($5fe66056dab4553f$export$46e1d66043f363e6, {})
    });
});

});
parcelRegister("ic7Fh", function(module, exports) {

$parcel$export(module.exports, "get", () => $d3ef4b0a22f4a592$export$3988ae62b71be9a3);
$parcel$export(module.exports, "css", () => $d3ef4b0a22f4a592$export$dbf350e5966cf602);
/**
 * Allows for nested scales with shorthand values
 * @example
 * {
 *   colors: {
 *     primary: { __default: '#00f', light: '#33f' }
 *   }
 * }
 * css({ color: 'primary' }); // { color: '#00f' }
 * css({ color: 'primary.light' }) // { color: '#33f' }
 */ const $d3ef4b0a22f4a592$export$30c0623aa74f65db = '__default';
const $d3ef4b0a22f4a592$var$hasDefault = (x)=>{
    return typeof x === 'object' && x !== null && $d3ef4b0a22f4a592$export$30c0623aa74f65db in x;
};
/**
 * Extracts value under path from a deeply nested object.
 * Used for Themes, variants and Theme UI style objects.
 * Given a path to object with `__default` key, returns the value under that key.
 *
 * @param obj a theme, variant or style object
 * @param path path separated with dots (`.`)
 * @param fallback default value returned if get(obj, path) is not found
 */ function $d3ef4b0a22f4a592$export$3988ae62b71be9a3(obj, path, fallback, p, undef) {
    const pathArray = path && typeof path === 'string' ? path.split('.') : [
        path
    ];
    for(p = 0; p < pathArray.length; p++)obj = obj ? obj[pathArray[p]] : undef;
    if (obj === undef) return fallback;
    return $d3ef4b0a22f4a592$var$hasDefault(obj) ? obj[$d3ef4b0a22f4a592$export$30c0623aa74f65db] : obj;
}
const $d3ef4b0a22f4a592$export$a1c80c3b5a33099b = (obj, theme)=>{
    if (obj && obj['variant']) {
        let result = {};
        for(const key in obj){
            const x = obj[key];
            if (key === 'variant') {
                const val = typeof x === 'function' ? x(theme) : x;
                const variant = $d3ef4b0a22f4a592$export$a1c80c3b5a33099b($d3ef4b0a22f4a592$export$3988ae62b71be9a3(theme, val), theme);
                result = {
                    ...result,
                    ...variant
                };
            } else result[key] = x;
        }
        return result;
    }
    return obj;
};
const $d3ef4b0a22f4a592$export$f44bcf56d375ea05 = [
    40,
    52,
    64
].map((n)=>n + 'em');
const $d3ef4b0a22f4a592$var$defaultTheme = {
    space: [
        0,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512
    ],
    fontSizes: [
        12,
        14,
        16,
        20,
        24,
        32,
        48,
        64,
        72
    ]
};
const $d3ef4b0a22f4a592$var$aliases = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
};
const $d3ef4b0a22f4a592$export$e898f75dd6e0945e = {
    marginX: [
        'marginLeft',
        'marginRight'
    ],
    marginY: [
        'marginTop',
        'marginBottom'
    ],
    paddingX: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingY: [
        'paddingTop',
        'paddingBottom'
    ],
    scrollMarginX: [
        'scrollMarginLeft',
        'scrollMarginRight'
    ],
    scrollMarginY: [
        'scrollMarginTop',
        'scrollMarginBottom'
    ],
    scrollPaddingX: [
        'scrollPaddingLeft',
        'scrollPaddingRight'
    ],
    scrollPaddingY: [
        'scrollPaddingTop',
        'scrollPaddingBottom'
    ],
    size: [
        'width',
        'height'
    ]
};
const $d3ef4b0a22f4a592$export$bcac1c16f1530ec2 = {
    color: 'colors',
    background: 'colors',
    accentColor: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    outlineColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
};
const $d3ef4b0a22f4a592$var$positiveOrNegative = (scale, value)=>{
    if (typeof value !== 'number' || value >= 0) {
        if (typeof value === 'string' && value.startsWith('-')) {
            const valueWithoutMinus = value.substring(1);
            const n = $d3ef4b0a22f4a592$export$3988ae62b71be9a3(scale, valueWithoutMinus, valueWithoutMinus);
            if (typeof n === 'number') return n * -1;
            return `-${n}`;
        }
        return $d3ef4b0a22f4a592$export$3988ae62b71be9a3(scale, value, value);
    }
    const absolute = Math.abs(value);
    const n = $d3ef4b0a22f4a592$export$3988ae62b71be9a3(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
};
const $d3ef4b0a22f4a592$var$transforms = [
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginBlock',
    'marginBlockEnd',
    'marginBlockStart',
    'marginInline',
    'marginInlineEnd',
    'marginInlineStart',
    'top',
    'bottom',
    'left',
    'right'
].reduce((acc, curr)=>({
        ...acc,
        [curr]: $d3ef4b0a22f4a592$var$positiveOrNegative
    }), {});
const $d3ef4b0a22f4a592$var$responsive = (styles)=>(theme)=>{
        const next = {};
        const breakpoints = theme && theme.breakpoints || $d3ef4b0a22f4a592$export$f44bcf56d375ea05;
        const mediaQueries = [
            null,
            ...breakpoints.map((n)=>n.includes('@media') ? n : `@media screen and (min-width: ${n})`)
        ];
        for(const k in styles){
            const key = k;
            let value = styles[key];
            if (typeof value === 'function') value = value(theme || {});
            if (value === false || value == null) continue;
            if (!Array.isArray(value)) {
                next[key] = value;
                continue;
            }
            for(let i = 0; i < value.slice(0, mediaQueries.length).length; i++){
                const media = mediaQueries[i];
                if (!media) {
                    next[key] = value[i];
                    continue;
                }
                next[media] = next[media] || {};
                if (value[i] == null) continue;
                next[media][key] = value[i];
            }
        }
        return next;
    };
const $d3ef4b0a22f4a592$export$dbf350e5966cf602 = (args = {})=>(props = {})=>{
        const theme = {
            ...$d3ef4b0a22f4a592$var$defaultTheme,
            ...'theme' in props ? props.theme : props
        };
        // insert variant props before responsive styles, so they can be merged
        // we need to maintain order of the style props, so if a variant is place in the middle
        // of other props, it will extends its props at that same location order.
        const obj = $d3ef4b0a22f4a592$export$a1c80c3b5a33099b(typeof args === 'function' ? args(theme) : args, theme);
        const styles = $d3ef4b0a22f4a592$var$responsive(obj)(theme);
        let result = {};
        for(const key in styles){
            const x = styles[key];
            const val = typeof x === 'function' ? x(theme) : x;
            if (val && typeof val === 'object') {
                if ($d3ef4b0a22f4a592$var$hasDefault(val)) {
                    result[key] = val[$d3ef4b0a22f4a592$export$30c0623aa74f65db];
                    continue;
                }
                // On type level, val can also be an array here,
                // but we transform all arrays in `responsive` function.
                result[key] = $d3ef4b0a22f4a592$export$dbf350e5966cf602(val)(theme);
                continue;
            }
            const prop = key in $d3ef4b0a22f4a592$var$aliases ? $d3ef4b0a22f4a592$var$aliases[key] : key;
            const scaleName = prop in $d3ef4b0a22f4a592$export$bcac1c16f1530ec2 ? $d3ef4b0a22f4a592$export$bcac1c16f1530ec2[prop] : undefined;
            const scale = scaleName ? theme?.[scaleName] : $d3ef4b0a22f4a592$export$3988ae62b71be9a3(theme, prop, {});
            const transform = $d3ef4b0a22f4a592$export$3988ae62b71be9a3($d3ef4b0a22f4a592$var$transforms, prop, $d3ef4b0a22f4a592$export$3988ae62b71be9a3);
            const value = transform(scale, val, val);
            if (prop in $d3ef4b0a22f4a592$export$e898f75dd6e0945e) {
                const dirs = $d3ef4b0a22f4a592$export$e898f75dd6e0945e[prop];
                for(let i = 0; i < dirs.length; i++)result[dirs[i]] = value;
            } else result[prop] = value;
        }
        return result;
    };

});

parcelRegister("9X3k8", function(module, exports) {

$parcel$export(module.exports, "jsx", () => $73ec33c5d5ff7358$export$34b9dba7ce09269b);
$parcel$export(module.exports, "jsxs", () => $73ec33c5d5ff7358$export$25062201e9e25d76);

var $8VacB = parcelRequire("8VacB");

var $gVW44 = parcelRequire("gVW44");

var $acw62 = parcelRequire("acw62");

const $73ec33c5d5ff7358$export$34b9dba7ce09269b = (type, props, key)=>(0, $8VacB.jsx)(type, (0, $gVW44.p)(props), key);
const $73ec33c5d5ff7358$export$25062201e9e25d76 = (type, props, key)=>(0, $8VacB.jsxs)(type, (0, $gVW44.p)(props), key);

});
parcelRegister("8VacB", function(module, exports) {

$parcel$export(module.exports, "jsx", () => $67eb8f8e9d5e3981$export$34b9dba7ce09269b);
$parcel$export(module.exports, "jsxs", () => $67eb8f8e9d5e3981$export$25062201e9e25d76);

var $ayMG0 = parcelRequire("ayMG0");

var $eP9YU = parcelRequire("eP9YU");
parcelRequire("acw62");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("2lACw");
var $67eb8f8e9d5e3981$export$ffb0004e005737fa = $ayMG0.Fragment;
var $67eb8f8e9d5e3981$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $eP9YU.h).call(props, 'css')) return $ayMG0.jsx(type, props, key);
    return $ayMG0.jsx((0, $eP9YU.E), (0, $eP9YU.c)(type, props), key);
};
var $67eb8f8e9d5e3981$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $eP9YU.h).call(props, 'css')) return $ayMG0.jsxs(type, props, key);
    return $ayMG0.jsxs((0, $eP9YU.E), (0, $eP9YU.c)(type, props), key);
};

});

parcelRegister("gVW44", function(module, exports) {

$parcel$export(module.exports, "p", () => $c53f02a60c68cd1c$export$ffb5f4729a158638);

var $ic7Fh = parcelRequire("ic7Fh");
const $c53f02a60c68cd1c$var$getCSS = (props)=>(theme)=>{
        const styles = (0, $ic7Fh.css)(props.sx)(theme);
        const raw = typeof props.css === 'function' ? props.css(theme) : props.css;
        return [
            styles,
            raw
        ];
    };
function $c53f02a60c68cd1c$export$ffb5f4729a158638(props) {
    if (!props || !props.sx && !props.css) return props;
    const next = {};
    for(let key in props){
        if (key === 'sx') continue;
        next[key] = props[key];
    }
    next.css = $c53f02a60c68cd1c$var$getCSS(props);
    return next;
}

});



parcelRegister("kjxh0", function(module, exports) {
"use client";
"use strict";
var $ec9f6460d0a35d37$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMergeStyles = module.exports.useInheritedStylesContext = module.exports.InheritedStylesProvider = void 0;

const $ec9f6460d0a35d37$var$react_1 = $ec9f6460d0a35d37$var$__importDefault((parcelRequire("acw62")));
const $ec9f6460d0a35d37$var$InheritedStylesContext = $ec9f6460d0a35d37$var$react_1.default.createContext({
    color: "text-default",
    fontFamily: "body",
    fontSize: "font-size-4",
    lineHeight: "leading-2",
    overflowWrap: "break-word"
});
const $ec9f6460d0a35d37$var$InheritedStylesProvider = ({ children: children, styleContext: styleContext })=>{
    return $ec9f6460d0a35d37$var$react_1.default.createElement($ec9f6460d0a35d37$var$InheritedStylesContext.Provider, {
        value: styleContext
    }, children);
};
module.exports.InheritedStylesProvider = $ec9f6460d0a35d37$var$InheritedStylesProvider;
const $ec9f6460d0a35d37$var$useInheritedStylesContext = ()=>$ec9f6460d0a35d37$var$react_1.default.useContext($ec9f6460d0a35d37$var$InheritedStylesContext);
module.exports.useInheritedStylesContext = $ec9f6460d0a35d37$var$useInheritedStylesContext;
/**
 * Hook to merge styles from sx object and inheritedStylesContext
 *
 * @param {BoxSx} sx - The styles to merge with the context styles.
 * @returns {MergeStylesResult} {newInheritedStylesContext: InheritedStylesContext, mergedSx: BoxSx}
 * @example
 *
 * const ExampleComponent = ({children, sx}) => {
 *  const { newInheritedStylesContext, mergedSx } = useMergeStyles(sx);
 *  return (
 *    <InheritedStylesProvider styleContext={newInheritedStylesContext}>
 *      <Box sx={mergedSx}>
 *       {children}
 *      </Box>
 *    </InheritedStylesProvider>
 *  )
 * }
 *
 */ const $ec9f6460d0a35d37$var$useMergeStyles = (sx)=>{
    const currentInheritedStylesContext = $ec9f6460d0a35d37$var$react_1.default.useContext($ec9f6460d0a35d37$var$InheritedStylesContext);
    const newInheritedStylesContext = $ec9f6460d0a35d37$var$react_1.default.useMemo(()=>{
        return {
            color: (sx === null || sx === void 0 ? void 0 : sx.color) || currentInheritedStylesContext.color,
            fontFamily: (sx === null || sx === void 0 ? void 0 : sx.fontFamily) || currentInheritedStylesContext.fontFamily,
            fontSize: (sx === null || sx === void 0 ? void 0 : sx.fontSize) || currentInheritedStylesContext.fontSize,
            fontWeight: (sx === null || sx === void 0 ? void 0 : sx.fontWeight) || currentInheritedStylesContext.fontWeight,
            lineHeight: (sx === null || sx === void 0 ? void 0 : sx.lineHeight) || currentInheritedStylesContext.lineHeight,
            letterSpacing: (sx === null || sx === void 0 ? void 0 : sx.letterSpacing) || currentInheritedStylesContext.letterSpacing,
            overflowWrap: (sx === null || sx === void 0 ? void 0 : sx.overflowWrap) || currentInheritedStylesContext.overflowWrap,
            textRendering: (sx === null || sx === void 0 ? void 0 : sx.textRendering) || currentInheritedStylesContext.textRendering
        };
    }, [
        currentInheritedStylesContext.color,
        currentInheritedStylesContext.fontFamily,
        currentInheritedStylesContext.fontSize,
        currentInheritedStylesContext.fontWeight,
        currentInheritedStylesContext.letterSpacing,
        currentInheritedStylesContext.lineHeight,
        currentInheritedStylesContext.overflowWrap,
        currentInheritedStylesContext.textRendering,
        sx === null || sx === void 0 ? void 0 : sx.color,
        sx === null || sx === void 0 ? void 0 : sx.fontFamily,
        sx === null || sx === void 0 ? void 0 : sx.fontSize,
        sx === null || sx === void 0 ? void 0 : sx.fontWeight,
        sx === null || sx === void 0 ? void 0 : sx.letterSpacing,
        sx === null || sx === void 0 ? void 0 : sx.lineHeight,
        sx === null || sx === void 0 ? void 0 : sx.overflowWrap,
        sx === null || sx === void 0 ? void 0 : sx.textRendering
    ]);
    // remove any inheritedProperties on the sx object that are explicly set to null or undeinfed - I.e. {fontFamily: undefined} - This will avoid breaking the style cascade
    $ec9f6460d0a35d37$var$cleanSx(sx);
    const mergedSx = Object.assign(Object.assign({}, newInheritedStylesContext), sx);
    return {
        newInheritedStylesContext: newInheritedStylesContext,
        mergedSx: mergedSx
    };
};
module.exports.useMergeStyles = $ec9f6460d0a35d37$var$useMergeStyles;
const $ec9f6460d0a35d37$var$cleanSx = (sx)=>{
    $ec9f6460d0a35d37$var$inheritedProperties.forEach((inheritedProperty)=>{
        if (sx.hasOwnProperty(inheritedProperty) && (sx[inheritedProperty] === undefined || sx[inheritedProperty] === null)) delete sx[inheritedProperty];
    });
};
const $ec9f6460d0a35d37$var$inheritedProperties = [
    "color",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "lineHeight",
    "letterSpacing",
    "textRendering",
    "overflowWrap"
];

});

parcelRegister("dSStr", function(module, exports) {
"use strict";
var $a1ba92e218c7f660$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a1ba92e218c7f660$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a1ba92e218c7f660$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useThemeWithoutTypes = module.exports.useTheme = module.exports.ThemeProvider = module.exports.resetClassName = void 0;

$a1ba92e218c7f660$var$__exportStar((parcelRequire("cSopo")), module.exports);

$a1ba92e218c7f660$var$__exportStar((parcelRequire("kh9gu")), module.exports);

$a1ba92e218c7f660$var$__exportStar((parcelRequire("j2gGJ")), module.exports);

$a1ba92e218c7f660$var$__exportStar((parcelRequire("aQ1W5")), module.exports);

var $ltnYE = parcelRequire("ltnYE");
Object.defineProperty(module.exports, "resetClassName", {
    enumerable: true,
    get: function() {
        return $ltnYE.resetClassName;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $ltnYE.ThemeProvider;
    }
});

$a1ba92e218c7f660$var$__exportStar((parcelRequire("kJsBZ")), module.exports);

$a1ba92e218c7f660$var$__exportStar((parcelRequire("4LNb4")), module.exports);

var $7DMIQ = parcelRequire("7DMIQ");
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7DMIQ.useTheme;
    }
});
Object.defineProperty(module.exports, "useThemeWithoutTypes", {
    enumerable: true,
    get: function() {
        return $7DMIQ.useThemeWithoutTypes;
    }
});

});
parcelRegister("cSopo", function(module, exports) {
"use strict";
var $95fd7637e7731924$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $95fd7637e7731924$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $95fd7637e7731924$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$95fd7637e7731924$var$__exportStar((parcelRequire("eYErC")), module.exports);

$95fd7637e7731924$var$__exportStar((parcelRequire("1Zh0B")), module.exports);

});
parcelRegister("eYErC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemColors = void 0;

var $dvtz2 = parcelRequire("dvtz2");
Object.defineProperty(module.exports, "SystemColors", {
    enumerable: true,
    get: function() {
        return $dvtz2.SystemColors;
    }
});

});
parcelRegister("dvtz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemColors = void 0;
module.exports.SystemColors = {
    // Black and White
    black: "#000000",
    white: "#FFFFFF",
    // Grays
    "color-system-gray-50": "#F5F5F6",
    "color-system-gray-100": "#E9E9E9",
    "color-system-gray-200": "#E0E0E0",
    "color-system-gray-300": "#AEB0B3",
    "color-system-gray-400": "#86888E",
    "color-system-gray-500": "#696B72",
    "color-system-gray-600": "#58595B",
    "color-system-gray-700": "#4C4E52",
    "color-system-gray-800": "#434447",
    "color-system-gray-900": "#3B3B3E",
    "color-system-gray-950": "#252627",
    // Reds
    "color-system-red-50": "#FEF2F2",
    "color-system-red-100": "#FDE3E2",
    "color-system-red-200": "#FCCCCC",
    "color-system-red-300": "#F9A9A8",
    "color-system-red-400": "#F58A8A",
    "color-system-red-500": "#E94A49",
    "color-system-red-600": "#D62C2B",
    "color-system-red-700": "#B22222",
    "color-system-red-800": "#951F1F",
    "color-system-red-900": "#7C1F20",
    "color-system-red-950": "#430D0B",
    // Yellows
    "color-system-yellow-50": "#FDFBEC",
    "color-system-yellow-100": "#FCF3C9",
    "color-system-yellow-200": "#F9E58D",
    "color-system-yellow-300": "#F7D252",
    "color-system-yellow-400": "#F5C131",
    "color-system-yellow-500": "#EF9E12",
    "color-system-yellow-600": "#D4780B",
    "color-system-yellow-700": "#AF560D",
    "color-system-yellow-800": "#8E4312",
    "color-system-yellow-900": "#753713",
    "color-system-yellow-950": "#431C05",
    // Greens
    "color-system-green-50": "#EDFBF2",
    "color-system-green-100": "#D5F6DF",
    "color-system-green-200": "#B0EBC6",
    "color-system-green-300": "#7BDAA6",
    "color-system-green-400": "#45C282",
    "color-system-green-500": "#22A767",
    "color-system-green-600": "#158A55",
    "color-system-green-700": "#106C45",
    "color-system-green-800": "#0E5638",
    "color-system-green-900": "#0E462F",
    "color-system-green-950": "#06281B",
    // Blues
    "color-system-blue-50": "#EFF7FF",
    "color-system-blue-100": "#DAEDFF",
    "color-system-blue-200": "#BEE1FF",
    "color-system-blue-300": "#91CFFF",
    "color-system-blue-400": "#5DB4FD",
    "color-system-blue-500": "#3893F9",
    "color-system-blue-600": "#2175EF",
    "color-system-blue-700": "#1858CD",
    "color-system-blue-800": "#184DB2",
    "color-system-blue-900": "#1C438C",
    "color-system-blue-950": "#162A55"
};

});


parcelRegister("1Zh0B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxBrand = module.exports.ModernaBrand = module.exports.MNexSpikeBrand = module.exports.EducationBrand = module.exports.CovidDiseaseEducationBrand = void 0;

var $9cZXp = parcelRequire("9cZXp");
Object.defineProperty(module.exports, "CovidDiseaseEducationBrand", {
    enumerable: true,
    get: function() {
        return $9cZXp.CovidDiseaseEducationBrand;
    }
});

var $1Vfpt = parcelRequire("1Vfpt");
Object.defineProperty(module.exports, "EducationBrand", {
    enumerable: true,
    get: function() {
        return $1Vfpt.EducationBrand;
    }
});

var $abmpb = parcelRequire("abmpb");
Object.defineProperty(module.exports, "MNexSpikeBrand", {
    enumerable: true,
    get: function() {
        return $abmpb.MNexSpikeBrand;
    }
});

var $66MH0 = parcelRequire("66MH0");
Object.defineProperty(module.exports, "ModernaBrand", {
    enumerable: true,
    get: function() {
        return $66MH0.ModernaBrand;
    }
});

var $4YafM = parcelRequire("4YafM");
Object.defineProperty(module.exports, "SpikevaxBrand", {
    enumerable: true,
    get: function() {
        return $4YafM.SpikevaxBrand;
    }
});

});
parcelRegister("9cZXp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CovidDiseaseEducationBrand = void 0;
module.exports.CovidDiseaseEducationBrand = {
    "color-brand-50": "#F2F2FB",
    "color-brand-100": "#E7E7F8",
    "color-brand-200": "#D4D3F2",
    "color-brand-300": "#B9B7EA",
    "color-brand-400": "#A39ADF",
    "color-brand-500": "#9081D3",
    "color-brand-600": "#8167C4",
    "color-brand-700": "#6F57AB",
    "color-brand-800": "#544381",
    "color-brand-900": "#3B2C6A",
    "color-brand-950": "#1E2846",
    "color-brand-secondary-50": "#F2F2FB",
    "color-brand-secondary-100": "#E7E7F8",
    "color-brand-secondary-200": "#D4D3F2",
    "color-brand-secondary-300": "#B9B7EA",
    "color-brand-secondary-400": "#A39ADF",
    "color-brand-secondary-500": "#9081D3",
    "color-brand-secondary-600": "#8167C4",
    "color-brand-secondary-700": "#6F57AB",
    "color-brand-secondary-800": "#544381",
    "color-brand-secondary-900": "#3B2C6A",
    "color-brand-secondary-950": "#1E2846"
};

});

parcelRegister("1Vfpt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EducationBrand = void 0;
module.exports.EducationBrand = {
    "color-brand-50": "#F9F2F9",
    "color-brand-100": "#F4E5F4",
    "color-brand-200": "#F2D8F6",
    "color-brand-300": "#DFB6E5",
    "color-brand-400": "#CD9CDA",
    "color-brand-500": "#B977C9",
    "color-brand-600": "#A652B8",
    "color-brand-700": "#9121A6",
    "color-brand-800": "#7A1D8E",
    "color-brand-900": "#671E71",
    "color-brand-950": "#42074B",
    "color-brand-secondary-50": "#F9F2F9",
    "color-brand-secondary-100": "#F4E5F4",
    "color-brand-secondary-200": "#F2D8F6",
    "color-brand-secondary-300": "#DFB6E5",
    "color-brand-secondary-400": "#CD9CDA",
    "color-brand-secondary-500": "#B977C9",
    "color-brand-secondary-600": "#A652B8",
    "color-brand-secondary-700": "#9121A6",
    "color-brand-secondary-800": "#7A1D8E",
    "color-brand-secondary-900": "#671E71",
    "color-brand-secondary-950": "#42074B"
};

});

parcelRegister("abmpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MNexSpikeBrand = void 0;
module.exports.MNexSpikeBrand = {
    "color-brand-50": "#E8F2F1",
    "color-brand-100": "#E0EEED",
    "color-brand-200": "#D1E5E4",
    "color-brand-300": "#A1CECB",
    "color-brand-400": "#7ABAB6",
    "color-brand-500": "#50A7A1",
    "color-brand-600": "#26928A",
    "color-brand-700": "#008077",
    "color-brand-800": "#026760",
    "color-brand-900": "#054F4A",
    "color-brand-950": "#003534",
    "color-brand-secondary-50": "#EFF4FB",
    "color-brand-secondary-100": "#DFE9F6",
    "color-brand-secondary-200": "#C7D8EF",
    "color-brand-secondary-300": "#86D2F3",
    "color-brand-secondary-400": "#62CDF8",
    "color-brand-secondary-500": "#2AACE2",
    "color-brand-secondary-600": "#1880B9",
    "color-brand-secondary-700": "#0E6896",
    "color-brand-secondary-800": "#10587C",
    "color-brand-secondary-900": "#134967",
    "color-brand-secondary-950": "#01283C"
};

});

parcelRegister("66MH0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModernaBrand = void 0;
module.exports.ModernaBrand = {
    "color-brand-50": "#F1F9FE",
    "color-brand-100": "#E2F2FC",
    "color-brand-200": "#BFE6F6",
    "color-brand-300": "#86D2F3",
    "color-brand-400": "#62CDF8",
    "color-brand-500": "#2AACE2",
    "color-brand-600": "#1880B9",
    "color-brand-700": "#0E6896",
    "color-brand-800": "#10587C",
    "color-brand-900": "#134967",
    "color-brand-950": "#01283C",
    "color-brand-secondary-100": "#FFE3E3",
    "color-brand-secondary-200": "#FFCCCF",
    "color-brand-secondary-300": "#FFA2A7",
    "color-brand-secondary-400": "#FE6E79",
    "color-brand-secondary-50": "#FFF1F1",
    "color-brand-secondary-500": "#F83B4E",
    "color-brand-secondary-600": "#E31837",
    "color-brand-secondary-700": "#C20E2E",
    "color-brand-secondary-800": "#A20F2D",
    "color-brand-secondary-900": "#8B102E",
    "color-brand-secondary-950": "#4E0313"
};

});

parcelRegister("4YafM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxBrand = void 0;
module.exports.SpikevaxBrand = {
    "color-brand-50": "#F5F8FA",
    "color-brand-100": "#EAF1F4",
    "color-brand-200": "#D0E1E7",
    "color-brand-300": "#B9D3DC",
    "color-brand-400": "#76A9BA",
    "color-brand-500": "#558FA2",
    "color-brand-600": "#427487",
    "color-brand-700": "#365E6E",
    "color-brand-800": "#30505C",
    "color-brand-900": "#2C444E",
    "color-brand-950": "#1D2D34",
    "color-brand-secondary-50": "#F5F8FA",
    "color-brand-secondary-100": "#EAF1F4",
    "color-brand-secondary-200": "#D0E1E7",
    "color-brand-secondary-300": "#B9D3DC",
    "color-brand-secondary-400": "#76A9BA",
    "color-brand-secondary-500": "#558FA2",
    "color-brand-secondary-600": "#427487",
    "color-brand-secondary-700": "#365E6E",
    "color-brand-secondary-800": "#30505C",
    "color-brand-secondary-900": "#2C444E",
    "color-brand-secondary-950": "#1D2D34"
};

});



parcelRegister("kh9gu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CornerRadii = void 0;

var $lBHRz = parcelRequire("lBHRz");
Object.defineProperty(module.exports, "CornerRadii", {
    enumerable: true,
    get: function() {
        return $lBHRz.CornerRadii;
    }
});

});
parcelRegister("lBHRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CornerRadii = void 0;
module.exports.CornerRadii = {
    "radius-1": "4px",
    "radius-2": "8px",
    "radius-3": "12px",
    "radius-4": "16px",
    "radius-round": "100px"
};

});


parcelRegister("j2gGJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Elevation = void 0;

var $jB9hJ = parcelRequire("jB9hJ");
Object.defineProperty(module.exports, "Elevation", {
    enumerable: true,
    get: function() {
        return $jB9hJ.Elevation;
    }
});

});
parcelRegister("jB9hJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Elevation = void 0;
module.exports.Elevation = {
    "shadow-none": "none",
    "shadow-100": "1px 2px 2px 0px rgba(0, 0, 0, 0.10)",
    "shadow-200": "1px 4px 4px 0px rgba(0, 0, 0, 0.10)",
    "shadow-300": "1px 8px 8px 0px rgba(0, 0, 0, 0.10)",
    "shadow-400": "1px 16px 16px 0px rgba(0, 0, 0, 0.10)",
    "shadow-500": "0px 24px 24px 0px rgba(0, 0, 0, 0.10)",
    "shadow-inset": "0px 4px 4px 0px rgba(0, 0, 0, 0.10) inset"
};

});


parcelRegister("aQ1W5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Space = void 0;

var $jzCY8 = parcelRequire("jzCY8");
Object.defineProperty(module.exports, "Space", {
    enumerable: true,
    get: function() {
        return $jzCY8.Space;
    }
});

});
parcelRegister("jzCY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Space = void 0;
module.exports.Space = {
    "spacing-none": "0px",
    "spacing-1": "2px",
    "spacing-2": "4px",
    "spacing-3": "8px",
    "spacing-4": "12px",
    "spacing-5": "16px",
    "spacing-6": "20px",
    "spacing-7": "24px",
    "spacing-8": "32px",
    "spacing-9": "40px",
    "spacing-10": "48px",
    "spacing-11": "56px",
    "spacing-12": "64px",
    "spacing-13": "72px",
    "spacing-14": "80px",
    "spacing-15": "96px",
    "spacing-16": "112px",
    "spacing-17": "128px"
};

});


parcelRegister("ltnYE", function(module, exports) {
"use client";
"use strict";
var $fa1ee7c5cf20e0b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThemeProvider = module.exports.getTheme = module.exports.resetClassName = void 0;

var $jjlaj = parcelRequire("jjlaj");

const $fa1ee7c5cf20e0b1$var$react_2 = $fa1ee7c5cf20e0b1$var$__importDefault((parcelRequire("acw62")));

var $6CTY6 = parcelRequire("6CTY6");
var $k1N3L = parcelRequire("k1N3L");

var $8kINY = parcelRequire("8kINY");

var $ifKCu = parcelRequire("ifKCu");

var $f7Eru = parcelRequire("f7Eru");

var $gz1Qr = parcelRequire("gz1Qr");

var $dSStr = parcelRequire("dSStr");

var $ka0jw = parcelRequire("ka0jw");

var $ef0oA = parcelRequire("ef0oA");
module.exports.resetClassName = "mdrna-reset";
const $fa1ee7c5cf20e0b1$var$ResetStyles = ()=>{
    const fontFacesDeclaration = $fa1ee7c5cf20e0b1$var$react_2.default.useMemo(()=>(0, $f7Eru.getFontFacesDeclaration)(), []);
    return $fa1ee7c5cf20e0b1$var$react_2.default.createElement($fa1ee7c5cf20e0b1$var$react_2.default.Fragment, null, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($6CTY6.default, {
        styles: {
            [`.${module.exports.resetClassName}`]: {
                all: "unset",
                cursor: "revert",
                display: "revert",
                verticalAlign: "baseline"
            },
            "*": {
                WebkitTapHighlightColor: "transparent"
            }
        }
    }), $fa1ee7c5cf20e0b1$var$react_2.default.createElement($jjlaj.Global, {
        styles: (0, $jjlaj.css)`
          ${fontFacesDeclaration}
        `
    }));
};
const $fa1ee7c5cf20e0b1$var$getTheme = (themeBranding, mode)=>{
    const space = new Array(192).fill(null).map((_value, i)=>i * 4);
    const spaceType = Object.assign(Object.assign({}, space), $dSStr.Space);
    return {
        breakpoints: [
            "720px",
            "1024px",
            "1440px",
            "1920px"
        ],
        colors: Object.assign(Object.assign({}, $dSStr.SystemColors), mode === "dark" ? (0, $ef0oA.setColorsForThemeDark)(themeBranding || $dSStr.ModernaBrand) : (0, $ef0oA.setColorsForTheme)(themeBranding || $dSStr.ModernaBrand)),
        space: spaceType,
        sizes: Object.assign(Object.assign({}, spaceType), {
            containerDesktopMargin: 64,
            containerDesktopMaxWidth: 1440,
            containerMobileMargin: 16,
            containerMobileMaxWidth: 748,
            containerTabletMargin: 40,
            containerTabletMaxWidth: 748,
            gridDesktopColumnGutter: 32,
            gridMobileColumnGutter: 16,
            gridTabletColumnGutter: 24
        }),
        shadows: $dSStr.Elevation,
        radii: $dSStr.CornerRadii,
        fontSizes: $dSStr.FontSize,
        fontWeights: $dSStr.FontWeight,
        lineHeights: $dSStr.LineHeight,
        letterSpacings: $dSStr.LetterSpacing,
        fonts: {
            // TODO: refactor?
            body: "Aeonik",
            code: "RobotoMono"
        },
        grid: {
            // TODO: refactor?
            gridDesktopColumnCount: 12,
            gridMobileColumnCount: 4,
            gridTabletColumnCount: 8
        },
        config: {
            useCustomProperties: false,
            useLocalStorage: false
        },
        transitions: {
            "transition-color-medium": "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, outline-color 100ms, text-decoration-color 100ms",
            "transition-color-slow": "background-color 300ms, border-color 300ms, color 300ms, opacity 300ms, box-shadow 300ms, outline-color 300ms, text-decoration-color 300ms",
            "transition-ease-out-fast": "background-color 100ms, border-color 100ms, color 100ms, opacity 100ms, box-shadow 100ms, text-decoration-color 100ms, transform 300ms cubic-bezier(0.4, 0, 0, 1)",
            "transition-ease-out-medium": "background-color 200ms, border-color 200ms, color 200ms, opacity 200ms, box-shadow 200ms, text-decoration-color 200ms, transform 400ms cubic-bezier(0.4, 0, 0.06, 1)",
            "transition-ease-out-slow": "background-color 400ms, border-color 400ms, color 400ms, opacity 400ms, box-shadow 400ms, text-decoration-color 400ms, transform 800ms cubic-bezier(0.4, 0, 0.06, 1)"
        },
        zIndices: {
            dropdown: 1200,
            modal: 1300,
            navbar: 1100,
            panel: 1150
        }
    };
};
module.exports.getTheme = $fa1ee7c5cf20e0b1$var$getTheme;
const $fa1ee7c5cf20e0b1$var$ThemeProvider = ({ children: children, mode: mode = "light", themeBranding: themeBranding = $dSStr.ModernaBrand, preCacheIcons: preCacheIcons = [] })=>{
    const { initialized: initialized } = $fa1ee7c5cf20e0b1$var$react_2.default.useContext($ka0jw.ThemeContext);
    const theme = (0, module.exports.getTheme)(themeBranding, mode);
    const themeContextNext = $fa1ee7c5cf20e0b1$var$react_2.default.useMemo(()=>({
            initialized: true,
            mode: mode,
            brand: themeBranding,
            themeInitial: Object.assign({}, theme)
        }), [
        mode,
        theme,
        themeBranding
    ]);
    return initialized ? $fa1ee7c5cf20e0b1$var$react_2.default.createElement($fa1ee7c5cf20e0b1$var$react_2.default.Fragment, null, children) : $fa1ee7c5cf20e0b1$var$react_2.default.createElement($8kINY.IdProvider, null, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($ifKCu.OverlayContextProvider, null, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($ka0jw.ThemeContext.Provider, {
        value: themeContextNext
    }, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($k1N3L.ThemeUIProvider, {
        theme: theme
    }, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($gz1Qr.IconProvider, {
        preCacheIcons: preCacheIcons
    }, $fa1ee7c5cf20e0b1$var$react_2.default.createElement($fa1ee7c5cf20e0b1$var$ResetStyles, null), children)))));
};
module.exports.ThemeProvider = $fa1ee7c5cf20e0b1$var$ThemeProvider;

});
parcelRegister("6CTY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31b4dc96326117$export$2e2bcd8739ae039);

var $8sxjx = parcelRequire("8sxjx");

var $ic7Fh = parcelRequire("ic7Fh");

var $jjlaj = parcelRequire("jjlaj");
const $4d31b4dc96326117$export$2e2bcd8739ae039 = ({ styles: styles })=>(0, $8sxjx.jsx)((0, $jjlaj.Global), {
        styles: (emotionTheme)=>{
            const theme = emotionTheme;
            return (0, $ic7Fh.css)(styles)(theme);
        }
    });

});
parcelRegister("8sxjx", function(module, exports) {

$parcel$export(module.exports, "jsx", () => $628ac7c5a150af60$export$34b9dba7ce09269b);
$parcel$export(module.exports, "__themeUiDefaultContextValue", () => $628ac7c5a150af60$export$11156139fe8e893);
$parcel$export(module.exports, "__ThemeUIContext", () => $628ac7c5a150af60$export$e6038f7a6685f474);
$parcel$export(module.exports, "useThemeUI", () => $628ac7c5a150af60$export$aca4d5a6bcdc6e5f);
$parcel$export(module.exports, "merge", () => $628ac7c5a150af60$export$4950aa0f605343fb);
$parcel$export(module.exports, "__ThemeUIInternalBaseThemeProvider", () => $628ac7c5a150af60$export$c9b649d8e8891698);
$parcel$export(module.exports, "ThemeProvider", () => $628ac7c5a150af60$export$d8964aec282183a3);

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $bc5yV = parcelRequire("bc5yV");

var $lAGRu = parcelRequire("lAGRu");

var $gVW44 = parcelRequire("gVW44");

const $628ac7c5a150af60$var$__EMOTION_VERSION__ = (0, (/*@__PURE__*/$parcel$interopDefault($lAGRu))).version;
const $628ac7c5a150af60$export$34b9dba7ce09269b = (type, props, ...children)=>(0, $jjlaj.jsx)(type, (0, $gVW44.p)(props), ...children);
/**
 * @internal for Babel JSX pragma
 * @see https://github.com/system-ui/theme-ui/issues/1603
 */ const $628ac7c5a150af60$export$c8a8987d4410bf2d = $628ac7c5a150af60$export$34b9dba7ce09269b;
/**
 * @internal
 */ const $628ac7c5a150af60$export$11156139fe8e893 = {
    __EMOTION_VERSION__: $628ac7c5a150af60$var$__EMOTION_VERSION__,
    theme: {}
};
/**
 * @internal
 */ const $628ac7c5a150af60$export$e6038f7a6685f474 = /*#__PURE__*/ $acw62.createContext($628ac7c5a150af60$export$11156139fe8e893);
const $628ac7c5a150af60$export$aca4d5a6bcdc6e5f = ()=>$acw62.useContext($628ac7c5a150af60$export$e6038f7a6685f474);
const $628ac7c5a150af60$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
const $628ac7c5a150af60$var$REACT_ELEMENT = $628ac7c5a150af60$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
const $628ac7c5a150af60$var$FORWARD_REF = $628ac7c5a150af60$var$canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7;
const $628ac7c5a150af60$var$deepmergeOptions = {
    isMergeableObject: (n)=>{
        return !!n && typeof n === 'object' && n.$$typeof !== $628ac7c5a150af60$var$REACT_ELEMENT && n.$$typeof !== $628ac7c5a150af60$var$FORWARD_REF;
    },
    arrayMerge: (_leftArray, rightArray)=>rightArray
};
/**
 * Deeply merge themes
 */ const $628ac7c5a150af60$export$4950aa0f605343fb = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($bc5yV)))(a, b, $628ac7c5a150af60$var$deepmergeOptions);
function $628ac7c5a150af60$var$mergeAll(...args) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bc5yV))).all(args, $628ac7c5a150af60$var$deepmergeOptions);
}
$628ac7c5a150af60$export$4950aa0f605343fb.all = $628ac7c5a150af60$var$mergeAll;
/**
 * @internal
 */ const $628ac7c5a150af60$export$c9b649d8e8891698 = ({ context: context, children: children })=>$628ac7c5a150af60$export$34b9dba7ce09269b((0, $eP9YU.T).Provider, {
        value: context.theme
    }, $628ac7c5a150af60$export$34b9dba7ce09269b($628ac7c5a150af60$export$e6038f7a6685f474.Provider, {
        value: context,
        children: children
    }));
function $628ac7c5a150af60$export$d8964aec282183a3({ theme: theme, children: children }) {
    const outer = $628ac7c5a150af60$export$aca4d5a6bcdc6e5f();
    const context = typeof theme === 'function' ? {
        ...outer,
        theme: theme(outer.theme)
    } : $628ac7c5a150af60$export$4950aa0f605343fb.all({}, outer, {
        theme: theme
    });
    return $628ac7c5a150af60$export$34b9dba7ce09269b($628ac7c5a150af60$export$c9b649d8e8891698, {
        context: context,
        children: children
    });
}

});
parcelRegister("bc5yV", function(module, exports) {
'use strict';
var $82652140c2d744c1$var$isMergeableObject = function isMergeableObject(value) {
    return $82652140c2d744c1$var$isNonNullObject(value) && !$82652140c2d744c1$var$isSpecial(value);
};
function $82652140c2d744c1$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $82652140c2d744c1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $82652140c2d744c1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $82652140c2d744c1$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $82652140c2d744c1$var$REACT_ELEMENT_TYPE = $82652140c2d744c1$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $82652140c2d744c1$var$isReactElement(value) {
    return value.$$typeof === $82652140c2d744c1$var$REACT_ELEMENT_TYPE;
}
function $82652140c2d744c1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $82652140c2d744c1$var$deepmerge($82652140c2d744c1$var$emptyTarget(value), value, options) : value;
}
function $82652140c2d744c1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $82652140c2d744c1$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $82652140c2d744c1$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $82652140c2d744c1$var$deepmerge;
}
function $82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $82652140c2d744c1$var$getKeys(target) {
    return Object.keys(target).concat($82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target));
}
function $82652140c2d744c1$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $82652140c2d744c1$var$propertyIsUnsafe(target, key) {
    return $82652140c2d744c1$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $82652140c2d744c1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $82652140c2d744c1$var$getKeys(target).forEach(function(key) {
        destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $82652140c2d744c1$var$getKeys(source).forEach(function(key) {
        if ($82652140c2d744c1$var$propertyIsUnsafe(target, key)) return;
        if ($82652140c2d744c1$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $82652140c2d744c1$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $82652140c2d744c1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $82652140c2d744c1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $82652140c2d744c1$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $82652140c2d744c1$var$mergeObject(target, source, options);
}
$82652140c2d744c1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $82652140c2d744c1$var$deepmerge(prev, next, options);
    }, {});
};
var $82652140c2d744c1$var$deepmerge_1 = $82652140c2d744c1$var$deepmerge;
module.exports = $82652140c2d744c1$var$deepmerge_1;

});

parcelRegister("lAGRu", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@emotion/react\",\"version\":\"11.14.0\",\"main\":\"dist/emotion-react.cjs.js\",\"module\":\"dist/emotion-react.esm.js\",\"types\":\"dist/emotion-react.cjs.d.ts\",\"exports\":{\".\":{\"types\":{\"import\":\"./dist/emotion-react.cjs.mjs\",\"default\":\"./dist/emotion-react.cjs.js\"},\"development\":{\"edge-light\":{\"module\":\"./dist/emotion-react.development.edge-light.esm.js\",\"import\":\"./dist/emotion-react.development.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.development.edge-light.cjs.js\"},\"worker\":{\"module\":\"./dist/emotion-react.development.edge-light.esm.js\",\"import\":\"./dist/emotion-react.development.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.development.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./dist/emotion-react.development.edge-light.esm.js\",\"import\":\"./dist/emotion-react.development.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.development.edge-light.cjs.js\"},\"browser\":{\"module\":\"./dist/emotion-react.browser.development.esm.js\",\"import\":\"./dist/emotion-react.browser.development.cjs.mjs\",\"default\":\"./dist/emotion-react.browser.development.cjs.js\"},\"module\":\"./dist/emotion-react.development.esm.js\",\"import\":\"./dist/emotion-react.development.cjs.mjs\",\"default\":\"./dist/emotion-react.development.cjs.js\"},\"edge-light\":{\"module\":\"./dist/emotion-react.edge-light.esm.js\",\"import\":\"./dist/emotion-react.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.edge-light.cjs.js\"},\"worker\":{\"module\":\"./dist/emotion-react.edge-light.esm.js\",\"import\":\"./dist/emotion-react.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./dist/emotion-react.edge-light.esm.js\",\"import\":\"./dist/emotion-react.edge-light.cjs.mjs\",\"default\":\"./dist/emotion-react.edge-light.cjs.js\"},\"browser\":{\"module\":\"./dist/emotion-react.browser.esm.js\",\"import\":\"./dist/emotion-react.browser.cjs.mjs\",\"default\":\"./dist/emotion-react.browser.cjs.js\"},\"module\":\"./dist/emotion-react.esm.js\",\"import\":\"./dist/emotion-react.cjs.mjs\",\"default\":\"./dist/emotion-react.cjs.js\"},\"./jsx-runtime\":{\"types\":{\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js\"},\"development\":{\"edge-light\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.js\"},\"worker\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.edge-light.cjs.js\"},\"browser\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.development.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.development.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.development.cjs.js\"},\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.development.cjs.js\"},\"edge-light\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.js\"},\"worker\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.edge-light.cjs.js\"},\"browser\":{\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.browser.cjs.js\"},\"module\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js\",\"import\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs\",\"default\":\"./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js\"},\"./_isolated-hnrs\":{\"types\":{\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js\"},\"development\":{\"edge-light\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.js\"},\"worker\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.edge-light.cjs.js\"},\"browser\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.development.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.development.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.development.cjs.js\"},\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.development.cjs.js\"},\"edge-light\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.js\"},\"worker\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.edge-light.cjs.js\"},\"browser\":{\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.cjs.js\"},\"module\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js\",\"import\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs\",\"default\":\"./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js\"},\"./jsx-dev-runtime\":{\"types\":{\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js\"},\"development\":{\"edge-light\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.js\"},\"worker\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.edge-light.cjs.js\"},\"browser\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.development.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.development.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.development.cjs.js\"},\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.development.cjs.js\"},\"edge-light\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.js\"},\"worker\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.js\"},\"workerd\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.edge-light.cjs.js\"},\"browser\":{\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.cjs.js\"},\"module\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js\",\"import\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs\",\"default\":\"./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js\"},\"./package.json\":\"./package.json\",\"./types/css-prop\":\"./types/css-prop.d.ts\",\"./macro\":{\"types\":{\"import\":\"./macro.d.mts\",\"default\":\"./macro.d.ts\"},\"default\":\"./macro.js\"}},\"imports\":{\"#is-development\":{\"development\":\"./src/conditions/true.ts\",\"default\":\"./src/conditions/false.ts\"},\"#is-browser\":{\"edge-light\":\"./src/conditions/false.ts\",\"workerd\":\"./src/conditions/false.ts\",\"worker\":\"./src/conditions/false.ts\",\"browser\":\"./src/conditions/true.ts\",\"default\":\"./src/conditions/is-browser.ts\"}},\"files\":[\"src\",\"dist\",\"jsx-runtime\",\"jsx-dev-runtime\",\"_isolated-hnrs\",\"types/css-prop.d.ts\",\"macro.*\"],\"sideEffects\":false,\"author\":\"Emotion Contributors\",\"license\":\"MIT\",\"scripts\":{\"test:typescript\":\"dtslint types\"},\"dependencies\":{\"@babel/runtime\":\"^7.18.3\",\"@emotion/babel-plugin\":\"^11.13.5\",\"@emotion/cache\":\"^11.14.0\",\"@emotion/serialize\":\"^1.3.3\",\"@emotion/use-insertion-effect-with-fallbacks\":\"^1.2.0\",\"@emotion/utils\":\"^1.4.2\",\"@emotion/weak-memoize\":\"^0.4.0\",\"hoist-non-react-statics\":\"^3.3.1\"},\"peerDependencies\":{\"react\":\">=16.8.0\"},\"peerDependenciesMeta\":{\"@types/react\":{\"optional\":true}},\"devDependencies\":{\"@definitelytyped/dtslint\":\"0.0.112\",\"@emotion/css\":\"11.13.5\",\"@emotion/css-prettifier\":\"1.2.0\",\"@emotion/server\":\"11.11.0\",\"@emotion/styled\":\"11.14.0\",\"@types/hoist-non-react-statics\":\"^3.3.5\",\"html-tag-names\":\"^1.1.2\",\"react\":\"16.14.0\",\"svg-tag-names\":\"^1.1.1\",\"typescript\":\"^5.4.5\"},\"repository\":\"https://github.com/emotion-js/emotion/tree/main/packages/react\",\"publishConfig\":{\"access\":\"public\"},\"umd:main\":\"dist/emotion-react.umd.min.js\",\"preconstruct\":{\"entrypoints\":[\"./index.ts\",\"./jsx-runtime.ts\",\"./jsx-dev-runtime.ts\",\"./_isolated-hnrs.ts\"],\"umdName\":\"emotionReact\",\"exports\":{\"extra\":{\"./types/css-prop\":\"./types/css-prop.d.ts\",\"./macro\":{\"types\":{\"import\":\"./macro.d.mts\",\"default\":\"./macro.d.ts\"},\"default\":\"./macro.js\"}}}}}");

});



parcelRegister("k1N3L", function(module, exports) {

$parcel$export(module.exports, "ThemeUIProvider", () => $e949f4e4547dc612$export$210f660b47146cb2);

var $acw62 = parcelRequire("acw62");

var $8sxjx = parcelRequire("8sxjx");

var $ic7Fh = parcelRequire("ic7Fh");

var $crWtd = parcelRequire("crWtd");

var $jjlaj = parcelRequire("jjlaj");

var $9X3k8 = parcelRequire("9X3k8");
const $e949f4e4547dc612$var$RootStyles = ()=>(0, $8sxjx.jsx)((0, $jjlaj.Global), {
        styles: (emotionTheme)=>{
            const theme = emotionTheme;
            const { useRootStyles: useRootStyles } = theme.config || theme;
            if (useRootStyles === false || theme.styles && !theme.styles.root) return null;
            const boxSizing = theme.config?.useBorderBox === false ? undefined : 'border-box';
            return (0, $ic7Fh.css)({
                '*': {
                    boxSizing: boxSizing
                },
                html: {
                    variant: 'styles.root'
                },
                body: {
                    margin: 0
                }
            })(theme);
        }
    });
const $e949f4e4547dc612$export$210f660b47146cb2 = ({ theme: theme, children: children })=>{
    const outer = (0, $8sxjx.useThemeUI)();
    const isTopLevel = outer === (0, $8sxjx.__themeUiDefaultContextValue);
    return (0, $9X3k8.jsx)((0, $8sxjx.ThemeProvider), {
        theme: theme,
        children: (0, $9X3k8.jsxs)((0, $crWtd.ColorModeProvider), {
            children: [
                isTopLevel && (0, $9X3k8.jsx)($e949f4e4547dc612$var$RootStyles, {}),
                children
            ]
        })
    });
};
/** @deprecated ThemeProvider is now called ThemeUIProvider to reduce confusion with Emotion */ const $e949f4e4547dc612$export$d8964aec282183a3 = ({ theme: theme, children: children })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{}, []);
    const outer = (0, $8sxjx.useThemeUI)();
    const isTopLevel = outer === (0, $8sxjx.__themeUiDefaultContextValue);
    return (0, $9X3k8.jsx)((0, $8sxjx.ThemeProvider), {
        theme: theme,
        children: (0, $9X3k8.jsxs)((0, $crWtd.ColorModeProvider), {
            children: [
                isTopLevel && (0, $9X3k8.jsx)($e949f4e4547dc612$var$RootStyles, {}),
                children
            ]
        })
    });
};

});
parcelRegister("crWtd", function(module, exports) {

$parcel$export(module.exports, "ColorModeProvider", () => $91055c9d2ef830b7$export$7a858aa3ff83dde7);

var $acw62 = parcelRequire("acw62");

var $8sxjx = parcelRequire("8sxjx");

var $ic7Fh = parcelRequire("ic7Fh");

var $jjlaj = parcelRequire("jjlaj");

var $9X3k8 = parcelRequire("9X3k8");
const $91055c9d2ef830b7$var$toVarName = (key)=>`--theme-ui-${key.replace('-__default', '')}`;
const $91055c9d2ef830b7$var$toVarValue = (key)=>`var(${$91055c9d2ef830b7$var$toVarName(key)})`;
const $91055c9d2ef830b7$var$join = (...args)=>args.filter(Boolean).join('-');
const $91055c9d2ef830b7$var$reservedKeys = new Set([
    'useCustomProperties',
    'initialColorModeName',
    'printColorModeName',
    'initialColorMode',
    'useLocalStorage',
    'config'
]);
// convert theme values to custom properties
const $91055c9d2ef830b7$var$toCustomProperties = (obj, parent)=>{
    const next = Array.isArray(obj) ? [] : {};
    for(let key in obj){
        const value = obj[key];
        const name = $91055c9d2ef830b7$var$join(parent, key);
        if (value && typeof value === 'object') {
            next[key] = $91055c9d2ef830b7$var$toCustomProperties(value, name);
            continue;
        }
        if ($91055c9d2ef830b7$var$reservedKeys.has(key)) {
            next[key] = value;
            continue;
        }
        next[key] = $91055c9d2ef830b7$var$toVarValue(name);
    }
    return next;
};
/**
 * @internal
 * Recursively transforms an object into CSS variables excluding "modes" key.
 */ const $91055c9d2ef830b7$var$__objectToVars = (parent, obj)=>{
    let vars = {};
    for(let key in obj){
        if (key === 'modes') continue;
        const name = $91055c9d2ef830b7$var$join(parent, key);
        const value = obj[key];
        if (value && typeof value === 'object') vars = {
            ...vars,
            ...$91055c9d2ef830b7$var$__objectToVars(name, value)
        };
        else vars[$91055c9d2ef830b7$var$toVarName(name)] = value;
    }
    return vars;
};
/**
 * @internal
 * Creates root styles for color modes.
 * - Transforms color scale into CSS variables.
 * - Sets background and text color.
 */ const $91055c9d2ef830b7$var$__createColorStyles = (theme = {})=>{
    const { useCustomProperties: useCustomProperties, initialColorModeName: initialColorModeName, printColorModeName: printColorModeName, useRootStyles: useRootStyles } = theme.config || theme || {};
    const colors = theme.rawColors || theme.colors;
    if (!colors) return {};
    const res = {};
    if (useRootStyles !== false) {
        if (useCustomProperties === false) {
            res.color = 'text';
            res.bg = 'background';
        } else {
            res.color = $91055c9d2ef830b7$var$toVarValue('colors-text');
            res.bg = $91055c9d2ef830b7$var$toVarValue('colors-background');
        }
    }
    if (useCustomProperties !== false) {
        const modes = colors.modes || {};
        const styles = $91055c9d2ef830b7$var$__createColorProperties(colors, modes);
        if (printColorModeName) {
            let printMode = modes[printColorModeName];
            if (!printMode && printColorModeName === initialColorModeName) printMode = colors;
            if (printMode) styles['@media print'] = $91055c9d2ef830b7$var$__objectToVars('colors', printMode);
            else console.error(`Theme UI \`printColorModeName\` was not found in colors scale`, {
                colors: colors,
                printColorModeName: printColorModeName
            });
        }
        Object.assign(res, styles);
    }
    return (0, $ic7Fh.css)(res)(theme);
};
/**
 * @internal
 * Returns an object with colors turned into Custom CSS Properties and
 * .theme-ui-<colormode> classes used for no-flash serverside rendering.
 */ function $91055c9d2ef830b7$var$__createColorProperties(colors, modes) {
    const styles = $91055c9d2ef830b7$var$__objectToVars('colors', colors);
    Object.keys(modes).forEach((mode)=>{
        const className = `.theme-ui-${mode}`;
        const key = `&${className}, ${className} &`;
        styles[key] = $91055c9d2ef830b7$var$__objectToVars('colors', modes[mode]);
    });
    return styles;
}
const $91055c9d2ef830b7$var$STORAGE_KEY = 'theme-ui-color-mode';
const $91055c9d2ef830b7$var$DARK_QUERY = '(prefers-color-scheme: dark)';
const $91055c9d2ef830b7$var$LIGHT_QUERY = '(prefers-color-scheme: light)';
const $91055c9d2ef830b7$var$storage = {
    get: ()=>{
        try {
            return window.localStorage.getItem($91055c9d2ef830b7$var$STORAGE_KEY);
        } catch (err) {
            console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
        }
    },
    set: (value)=>{
        try {
            window.localStorage.setItem($91055c9d2ef830b7$var$STORAGE_KEY, value);
        } catch (err) {
            console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
        }
    }
};
const $91055c9d2ef830b7$var$getPreferredColorScheme = ()=>{
    if (typeof window !== 'undefined' && window.matchMedia) {
        if (window.matchMedia($91055c9d2ef830b7$var$DARK_QUERY).matches) return 'dark';
        if (window.matchMedia($91055c9d2ef830b7$var$LIGHT_QUERY).matches) return 'light';
    }
    return null;
};
const $91055c9d2ef830b7$var$useClientsideEffect = typeof window === 'undefined' ? ()=>{} : (0, $acw62.useLayoutEffect);
const $91055c9d2ef830b7$var$TopLevelColorModeProvider = ({ outerCtx: outerCtx, children: children })=>{
    const outerTheme = outerCtx.theme || {};
    const { initialColorModeName: initialColorModeName, useColorSchemeMediaQuery: useColorSchemeMediaQuery, useLocalStorage: useLocalStorage } = outerTheme.config || outerTheme;
    let [colorMode, setColorMode] = (0, $acw62.useState)(()=>{
        const preferredMode = useColorSchemeMediaQuery !== false && $91055c9d2ef830b7$var$getPreferredColorScheme();
        return preferredMode || initialColorModeName;
    });
    // on first render, we read the color mode from localStorage and
    // clear the class on document element body
    $91055c9d2ef830b7$var$useClientsideEffect(()=>{
        const stored = useLocalStorage !== false && $91055c9d2ef830b7$var$storage.get();
        if (typeof document !== 'undefined') document.documentElement.classList.remove('theme-ui-' + stored);
        if (useColorSchemeMediaQuery !== 'system' && stored && stored !== colorMode) {
            colorMode = stored;
            setColorMode(stored);
        }
    }, []);
    // when mode changes, we save it to localStorage
    (0, $acw62.useEffect)(()=>{
        if (colorMode && useLocalStorage !== false) $91055c9d2ef830b7$var$storage.set(colorMode);
    }, [
        colorMode,
        useLocalStorage
    ]);
    const setPreferredColorScheme = (0, $acw62.useCallback)(()=>{
        const preferredColorScheme = $91055c9d2ef830b7$var$getPreferredColorScheme();
        setColorMode(preferredColorScheme || initialColorModeName);
    }, [
        initialColorModeName
    ]);
    (0, $acw62.useEffect)(()=>{
        if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
            // It doesn't matter if we add the listener only to the dark media query
            // Because in our callback function we'll check for both media queries (light and dark).
            const darkMQL = window.matchMedia($91055c9d2ef830b7$var$DARK_QUERY);
            if (typeof darkMQL.addEventListener === 'function') darkMQL.addEventListener('change', setPreferredColorScheme);
            else if (typeof darkMQL.addListener === 'function') darkMQL.addListener(setPreferredColorScheme);
        }
        return ()=>{
            if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
                const darkMQL = window.matchMedia($91055c9d2ef830b7$var$DARK_QUERY);
                if (typeof darkMQL.removeEventListener === 'function') darkMQL.removeEventListener('change', setPreferredColorScheme);
                else if (typeof darkMQL.removeListener === 'function') darkMQL.removeListener(setPreferredColorScheme);
            }
        };
    }, [
        useColorSchemeMediaQuery,
        setPreferredColorScheme
    ]);
    var color;
    const newTheme = $91055c9d2ef830b7$var$useThemeWithAppliedColorMode({
        colorMode: colorMode,
        outerTheme: outerTheme
    });
    const newCtx = {
        ...outerCtx,
        theme: newTheme,
        colorMode: colorMode,
        setColorMode: setColorMode
    };
    return (0, $9X3k8.jsxs)((0, $8sxjx.__ThemeUIInternalBaseThemeProvider), {
        context: newCtx,
        children: [
            (0, $9X3k8.jsx)($91055c9d2ef830b7$var$GlobalColorStyles, {
                theme: newTheme
            }),
            children
        ]
    });
};
function $91055c9d2ef830b7$export$20f3076712c8dfa() {
    const { colorMode: colorMode, setColorMode: setColorMode } = (0, $8sxjx.useThemeUI)();
    if (typeof setColorMode !== 'function') throw new Error(`[useColorMode] requires the ColorModeProvider component`);
    // We're allowing the user to specify a narrower type for its color mode name.
    return [
        colorMode,
        setColorMode
    ];
}
const $91055c9d2ef830b7$var$omitModes = (colors)=>{
    const res = {
        ...colors
    };
    delete res.modes;
    return res;
};
function $91055c9d2ef830b7$var$copyRawColors(colors, outerThemeRawColors) {
    for (const [key, value] of Object.entries(colors)){
        if (typeof value === 'string' && !value.startsWith('var(')) outerThemeRawColors[key] = value;
        else if (typeof value === 'object') {
            const newValue = {
                ...outerThemeRawColors[key]
            };
            $91055c9d2ef830b7$var$copyRawColors(value, newValue);
            outerThemeRawColors[key] = newValue;
        }
    }
}
function $91055c9d2ef830b7$var$useThemeWithAppliedColorMode({ outerTheme: outerTheme, colorMode: colorMode }) {
    const theme = (0, $acw62.useMemo)(()=>{
        const res = {
            ...outerTheme
        };
        const modes = (0, $ic7Fh.get)(res, 'colors.modes', {});
        const currentColorMode = (0, $ic7Fh.get)(modes, colorMode, {});
        if (colorMode) res.colors = {
            ...res.colors,
            ...currentColorMode
        };
        const { useCustomProperties: useCustomProperties, initialColorModeName: initialColorModeName = '__default' } = outerTheme.config || outerTheme;
        let outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};
        if (useCustomProperties !== false) {
            const alreadyHasRawColors = res.rawColors != null;
            const colors = res.colors || {};
            if (alreadyHasRawColors) {
                outerThemeRawColors = {
                    ...outerThemeRawColors
                };
                $91055c9d2ef830b7$var$copyRawColors(colors, outerThemeRawColors);
                if (outerThemeRawColors.modes) outerThemeRawColors.modes[initialColorModeName] = $91055c9d2ef830b7$var$omitModes(outerThemeRawColors);
                res.rawColors = outerThemeRawColors;
            } else if (!('modes' in outerThemeRawColors)) res.rawColors = colors;
            else {
                const modes = {
                    [initialColorModeName]: $91055c9d2ef830b7$var$omitModes(outerThemeRawColors),
                    ...outerThemeRawColors.modes
                };
                res.rawColors = {
                    ...colors,
                    modes: modes
                }; /* modes doesn't match index signature by design */ 
            }
            res.colors = $91055c9d2ef830b7$var$toCustomProperties($91055c9d2ef830b7$var$omitModes(outerThemeRawColors), 'colors');
        }
        return res;
    }, [
        colorMode,
        outerTheme
    ]);
    return theme;
}
function $91055c9d2ef830b7$var$GlobalColorStyles({ theme: theme }) {
    return (0, $8sxjx.jsx)((0, $jjlaj.Global), {
        styles: ()=>{
            return {
                html: $91055c9d2ef830b7$var$__createColorStyles(theme)
            };
        }
    });
}
function $91055c9d2ef830b7$var$NestedColorModeProvider({ outerCtx: outerCtx, children: children }) {
    const newTheme = $91055c9d2ef830b7$var$useThemeWithAppliedColorMode({
        outerTheme: outerCtx.theme,
        colorMode: outerCtx.colorMode
    });
    // Nested theme providers need to be rerendered after hydration for the correct
    // color mode to apply.
    const [needsRerender, setNeedsRerender] = (0, $acw62.useState)(// Note: we could also check some "ssr-enabled" flag as an optimization for
    // SPAs, as deeply nested theme providers will also pay a performance penalty
    // for this SSR bug fix
    ()=>newTheme.config?.useLocalStorage !== false);
    $91055c9d2ef830b7$var$useClientsideEffect(()=>void setNeedsRerender(false), []);
    const themeColors = newTheme.rawColors || newTheme.colors;
    const useCustomProperties = newTheme.config?.useCustomProperties;
    const colorVars = (0, $acw62.useMemo)(()=>{
        if (useCustomProperties === false) return {};
        const colors = themeColors || {};
        return (0, $ic7Fh.css)($91055c9d2ef830b7$var$__createColorProperties(colors, colors.modes || {}))(newTheme);
    }, [
        newTheme,
        themeColors,
        useCustomProperties
    ]);
    return (0, $9X3k8.jsx)((0, $8sxjx.__ThemeUIInternalBaseThemeProvider), {
        context: {
            ...outerCtx,
            theme: newTheme
        },
        children: (0, $8sxjx.jsx)('div', {
            'data-themeui-nested-provider': true,
            // the key here ensures that children will be rerendered after color
            // mode is read from localStorage
            key: Number(needsRerender),
            suppressHydrationWarning: true,
            css: colorVars,
            children: children
        })
    });
}
const $91055c9d2ef830b7$export$7a858aa3ff83dde7 = ({ children: children })=>{
    const outerCtx = (0, $8sxjx.useThemeUI)();
    const isTopLevelColorModeProvider = typeof outerCtx.setColorMode !== 'function';
    return isTopLevelColorModeProvider ? (0, $9X3k8.jsx)($91055c9d2ef830b7$var$TopLevelColorModeProvider, {
        outerCtx: outerCtx,
        children: children
    }) : (0, $9X3k8.jsx)($91055c9d2ef830b7$var$NestedColorModeProvider, {
        outerCtx: outerCtx,
        children: children
    });
};
const $91055c9d2ef830b7$var$noflash = `(function() { try {
  var mode = localStorage.getItem('theme-ui-color-mode');
  if (!mode) return
  document.documentElement.classList.add('theme-ui-' + mode);
} catch (e) {} })();`;
const $91055c9d2ef830b7$export$feac34581c18d7bc = ()=>(0, $8sxjx.jsx)('script', {
        key: 'theme-ui-no-flash',
        dangerouslySetInnerHTML: {
            __html: $91055c9d2ef830b7$var$noflash
        }
    });

});


parcelRegister("8kINY", function(module, exports) {
"use client";
"use strict";
var $6112f2522cac2b4a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useId = module.exports.IdProvider = void 0;

// The `useId` hook isn't availble until React 18,
// and we need to support 17 as well
// TODO: Delete in v5 or whenever we stop supporting React 17 apps
const $6112f2522cac2b4a$var$react_1 = $6112f2522cac2b4a$var$__importDefault((parcelRequire("acw62")));
let $6112f2522cac2b4a$var$idLocal = -1;
const $6112f2522cac2b4a$var$IdContext = $6112f2522cac2b4a$var$react_1.default.createContext({
    getId: ()=>{
        $6112f2522cac2b4a$var$idLocal = $6112f2522cac2b4a$var$idLocal + 1;
        return `r${$6112f2522cac2b4a$var$idLocal}`;
    }
});
const $6112f2522cac2b4a$var$IdProvider = ({ children: children })=>{
    const id = $6112f2522cac2b4a$var$react_1.default.useRef(0);
    const getId = $6112f2522cac2b4a$var$react_1.default.useCallback(()=>{
        id.current = id.current + 1;
        return `r${id.current}`;
    }, []);
    return $6112f2522cac2b4a$var$react_1.default.createElement($6112f2522cac2b4a$var$IdContext.Provider, {
        value: {
            getId: getId
        }
    }, children);
};
module.exports.IdProvider = $6112f2522cac2b4a$var$IdProvider;
const $6112f2522cac2b4a$var$useId = ()=>{
    const { getId: getId } = $6112f2522cac2b4a$var$react_1.default.useContext($6112f2522cac2b4a$var$IdContext);
    const id = $6112f2522cac2b4a$var$react_1.default.useMemo(()=>getId(), [
        getId
    ]);
    return id;
};
module.exports.useId = $6112f2522cac2b4a$var$useId;

});

parcelRegister("ifKCu", function(module, exports) {
"use client";
"use strict";
var $d49dca6b617419a8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOverlay = module.exports.OverlayContextProvider = module.exports.OverlayContext = void 0;

const $d49dca6b617419a8$var$react_1 = $d49dca6b617419a8$var$__importDefault((parcelRequire("acw62")));
const $d49dca6b617419a8$var$getScrollbarWidth = ()=>{
    if (!("document" in globalThis)) return 0;
    const body = document.body;
    const scrollDiv = document.createElement("div");
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-100px";
    scrollDiv.style.width = "50px";
    body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    body.removeChild(scrollDiv);
    return scrollbarWidth;
};
module.exports.OverlayContext = $d49dca6b617419a8$var$react_1.default.createContext({
    mountOverlay: ()=>0,
    unmountOverlay: ()=>{},
    getOverlayZIndex: ()=>1
});
const $d49dca6b617419a8$var$OverlayContextProvider = ({ children: children })=>{
    const [overlayStack, setOverlayStack] = $d49dca6b617419a8$var$react_1.default.useState([]);
    $d49dca6b617419a8$var$react_1.default.useEffect(()=>{
        if (overlayStack.length > 0) {
            if (overlayStack.length === 1) {
                const isDocumentScrollable = document.documentElement.scrollHeight > window.innerHeight;
                if (isDocumentScrollable) // Offset the scrollbar width so the page doesn't shift to the right
                document.body.style.paddingInlineEnd = `${$d49dca6b617419a8$var$getScrollbarWidth()}px`;
                document.body.style.overflow = "hidden";
            }
        } else {
            document.body.style.overflow = "";
            document.body.style.paddingInlineEnd = "";
        }
    }, [
        overlayStack
    ]);
    const mountOverlay = $d49dca6b617419a8$var$react_1.default.useCallback(()=>{
        const newOverlayId = Date.now();
        setOverlayStack((stack)=>[
                ...stack,
                newOverlayId
            ]);
        return newOverlayId;
    }, []);
    const unmountOverlay = $d49dca6b617419a8$var$react_1.default.useCallback((overlayId)=>{
        setOverlayStack((stack)=>stack.filter((id)=>id !== overlayId));
    }, []);
    const getOverlayZIndex = $d49dca6b617419a8$var$react_1.default.useCallback((overlayId)=>{
        return overlayStack.indexOf(overlayId) + 1;
    }, [
        overlayStack
    ]);
    return $d49dca6b617419a8$var$react_1.default.createElement(module.exports.OverlayContext.Provider, {
        value: {
            mountOverlay: mountOverlay,
            unmountOverlay: unmountOverlay,
            getOverlayZIndex: getOverlayZIndex
        }
    }, children);
};
module.exports.OverlayContextProvider = $d49dca6b617419a8$var$OverlayContextProvider;
const $d49dca6b617419a8$var$useOverlay = ()=>{
    return $d49dca6b617419a8$var$react_1.default.useContext(module.exports.OverlayContext);
};
module.exports.useOverlay = $d49dca6b617419a8$var$useOverlay;

});

parcelRegister("f7Eru", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFontFacesDeclaration = void 0;
const $b026e176c54761b4$var$getFontUrl = (fileName)=>`https://static.modernatx.com/fonts/${fileName}.woff2`;
const $b026e176c54761b4$var$getFontFace = (family, url, weight, italicized = false)=>`
      @font-face {
          font-family: "${family}";
          font-display: block;
          font-style: ${italicized ? "italic" : "normal"};
          font-weight: ${weight};
          src: url(${url}) format("woff2");
      }
  `;
const $b026e176c54761b4$var$getVariableFontFace = (family, url, italicized = false)=>`
      @font-face {
          font-family: "${family}";
          font-display: block;
          font-style: ${italicized ? "italic" : "normal"};
          font-weight: 100 1000;
          src: url(${url}) format("woff2 supports variations"), url(${url}) format("woff2-variations");
      }
  `;
const $b026e176c54761b4$var$getFontFacesDeclaration = ()=>{
    const fontFacesDeclaration = `
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-Black"), 600)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-BlackItalic"), 600, true)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-Bold"), 700)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-BoldItalic"), 700, true)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-Light"), 300)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-LightItalic"), 300, true)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-Medium"), 500)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-MediumItalic"), 500, true)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-Regular"), 400)}
  ${$b026e176c54761b4$var$getFontFace("Aeonik", $b026e176c54761b4$var$getFontUrl("Aeonik-RegularItalic"), 400, true)}
  ${$b026e176c54761b4$var$getVariableFontFace("NotoSans", $b026e176c54761b4$var$getFontUrl("NotoSans"), false)}
  ${$b026e176c54761b4$var$getVariableFontFace("NotoSans", $b026e176c54761b4$var$getFontUrl("NotoSansItalic"), true)}
  ${$b026e176c54761b4$var$getVariableFontFace("NotoSansJP", $b026e176c54761b4$var$getFontUrl("NotoSansJP"), false)}
  ${$b026e176c54761b4$var$getVariableFontFace("NotoSansKR", $b026e176c54761b4$var$getFontUrl("NotoSansKR"), false)}
  ${$b026e176c54761b4$var$getVariableFontFace("RobotoMono", $b026e176c54761b4$var$getFontUrl("RobotoMono"), false)}
  ${$b026e176c54761b4$var$getVariableFontFace("RobotoMono", $b026e176c54761b4$var$getFontUrl("RobotoMonoItalic"), true)}
`;
    return fontFacesDeclaration.replace(/[\n\s]+/g, " ");
};
module.exports.getFontFacesDeclaration = $b026e176c54761b4$var$getFontFacesDeclaration;

});

parcelRegister("gz1Qr", function(module, exports) {
"use client";
"use strict";
var $c0f15897f779d873$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIconCache = module.exports.IconProvider = module.exports.IconContext = module.exports.DEFAULT_PRECACHED_ICONS = void 0;

const $c0f15897f779d873$var$react_1 = $c0f15897f779d873$var$__importDefault((parcelRequire("acw62")));

var $lLL0E = parcelRequire("lLL0E");

var $iY3J9 = parcelRequire("iY3J9");
module.exports.DEFAULT_PRECACHED_ICONS = [
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-up",
    "check",
    "check-circle",
    "info",
    "link",
    "magnifying-glass",
    "share-fat",
    "warning-octagon",
    "x-circle",
    "x"
];
const $c0f15897f779d873$var$PreCachedIcons = ({ icons: icons })=>{
    // precaching icons avoids flickering when icons are loaded for the first time
    return $c0f15897f779d873$var$react_1.default.createElement("div", {
        style: {
            display: "none"
        }
    }, icons.map((icon)=>$c0f15897f779d873$var$react_1.default.createElement($lLL0E.Icon, {
            key: "precached-" + icon,
            icon: icon
        })));
};
const $c0f15897f779d873$var$defaultContext = {
    cacheIconComponent: ()=>()=>null,
    getIconComponent: ()=>()=>null,
    iconCacheRef: new Map()
};
module.exports.IconContext = $c0f15897f779d873$var$react_1.default.createContext(Object.assign({}, $c0f15897f779d873$var$defaultContext));
const $c0f15897f779d873$var$IconProvider = ({ preCacheIcons: preCacheIcons, children: children })=>{
    const iconCacheRef = $c0f15897f779d873$var$react_1.default.useRef(new Map());
    const mergedPreCacheIcons = $c0f15897f779d873$var$react_1.default.useMemo(()=>{
        return Array.from(new Set([
            ...module.exports.DEFAULT_PRECACHED_ICONS,
            ...preCacheIcons
        ]));
    }, [
        preCacheIcons
    ]);
    const getIconComponent = $c0f15897f779d873$var$react_1.default.useCallback((iconName)=>{
        if (iconCacheRef.current.has(iconName)) return iconCacheRef.current.get(iconName);
        const LazyComponent = (0, $iY3J9.loadIcon)(iconName);
        const IconComponent = (props)=>$c0f15897f779d873$var$react_1.default.createElement($c0f15897f779d873$var$react_1.default.Suspense, null, $c0f15897f779d873$var$react_1.default.createElement(LazyComponent, Object.assign({}, props)));
        IconComponent.displayName = iconName;
        return IconComponent;
    }, []);
    const cacheIconComponent = $c0f15897f779d873$var$react_1.default.useCallback((iconName, LazyComponent)=>{
        if (!iconCacheRef.current.has(iconName)) iconCacheRef.current.set(iconName, LazyComponent);
    }, []);
    const contextValue = $c0f15897f779d873$var$react_1.default.useMemo(()=>({
            getIconComponent: getIconComponent,
            cacheIconComponent: cacheIconComponent,
            iconCacheRef: iconCacheRef.current
        }), [
        getIconComponent,
        cacheIconComponent
    ]);
    return $c0f15897f779d873$var$react_1.default.createElement(module.exports.IconContext.Provider, {
        value: contextValue
    }, $c0f15897f779d873$var$react_1.default.createElement($c0f15897f779d873$var$PreCachedIcons, {
        icons: mergedPreCacheIcons
    }), children);
};
module.exports.IconProvider = $c0f15897f779d873$var$IconProvider;
const $c0f15897f779d873$var$useIconCache = ()=>{
    const context = $c0f15897f779d873$var$react_1.default.useContext(module.exports.IconContext);
    if (!context) throw new Error("useIconCache must be used within an IconCacheProvider");
    return context;
};
module.exports.useIconCache = $c0f15897f779d873$var$useIconCache;

});
parcelRegister("lLL0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IconContext = module.exports.IconName = module.exports.DEFAULT_ICONS = module.exports.Icon = void 0;

var $jxg79 = parcelRequire("jxg79");
Object.defineProperty(module.exports, "Icon", {
    enumerable: true,
    get: function() {
        return $jxg79.Icon;
    }
});

var $75EGn = parcelRequire("75EGn");
Object.defineProperty(module.exports, "DEFAULT_ICONS", {
    enumerable: true,
    get: function() {
        return $75EGn.DEFAULT_ICONS;
    }
});
Object.defineProperty(module.exports, "IconName", {
    enumerable: true,
    get: function() {
        return $75EGn.IconName;
    }
});

var $gz1Qr = parcelRequire("gz1Qr");
Object.defineProperty(module.exports, "IconContext", {
    enumerable: true,
    get: function() {
        return $gz1Qr.IconContext;
    }
});

});
parcelRegister("jxg79", function(module, exports) {
"use client";
"use strict";
var $e38d9958efc00996$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e38d9958efc00996$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Icon = void 0;

const $e38d9958efc00996$var$react_1 = $e38d9958efc00996$var$__importDefault((parcelRequire("acw62")));

var $8NABb = parcelRequire("8NABb");

var $2wkl1 = parcelRequire("2wkl1");

var $gz1Qr = parcelRequire("gz1Qr");
const $e38d9958efc00996$var$Icon = (_a)=>{
    var { size: size = "md", weight: weight = "regular", sx: sx, icon: icon, color: color } = _a, restProps = $e38d9958efc00996$var$__rest(_a, [
        "size",
        "weight",
        "sx",
        "icon",
        "color"
    ]);
    const { getIconComponent: getIconComponent, cacheIconComponent: cacheIconComponent } = (0, $gz1Qr.useIconCache)();
    const LazyIconVariant = getIconComponent(icon);
    $e38d9958efc00996$var$react_1.default.useEffect(()=>{
        cacheIconComponent(icon, LazyIconVariant);
    }, [
        icon,
        LazyIconVariant,
        cacheIconComponent
    ]);
    const iconSize = $e38d9958efc00996$var$react_1.default.useMemo(()=>(0, $8NABb.getResponsiveStyle)(size, (s)=>{
            switch(s){
                case "xxs":
                    return "spacing-5";
                case "xs":
                    return "spacing-6";
                case "sm":
                    return "spacing-7";
                case "lg":
                    return "spacing-9";
                case "xl":
                    return "spacing-10";
                default:
                    return "spacing-8";
            }
        }), [
        size
    ]);
    const fill = weight === "filled" ? "filled" : "none";
    return $e38d9958efc00996$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        as: "span",
        sx: Object.assign({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: color || "onSurface-brand-primary",
            height: iconSize,
            width: iconSize
        }, sx)
    }, restProps), $e38d9958efc00996$var$react_1.default.createElement(LazyIconVariant, {
        fill: fill
    }));
};
module.exports.Icon = $e38d9958efc00996$var$Icon;

});
parcelRegister("8NABb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getResponsiveStyle = void 0;
function $667f4a10f4f2eca9$var$getResponsiveStyle(styleValue, resolver) {
    if (Array.isArray(styleValue)) return styleValue.map((item)=>item !== null ? resolver(item) : null);
    else return resolver(styleValue);
}
module.exports.getResponsiveStyle = $667f4a10f4f2eca9$var$getResponsiveStyle;

});


parcelRegister("75EGn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_ICONS = module.exports.IconName = void 0;
var $52988eb5596b8f57$var$IconName;
(function(IconName) {
    IconName["AddressBook"] = "address-book";
    IconName["AirplaneInFlight"] = "airplane-in-flight";
    IconName["AirplaneLanding"] = "airplane-landing";
    IconName["AirplaneTakeoff"] = "airplane-takeoff";
    IconName["AirplaneTilt"] = "airplane-tilt";
    IconName["Alarm"] = "alarm";
    IconName["Anchor"] = "anchor";
    IconName["Archive"] = "archive";
    IconName["ArrowCircleDown"] = "arrow-circle-down";
    IconName["ArrowCircleDownLeft"] = "arrow-circle-down-left";
    IconName["ArrowCircleDownRight"] = "arrow-circle-down-right";
    IconName["ArrowCircleLeft"] = "arrow-circle-left";
    IconName["ArrowCircleRight"] = "arrow-circle-right";
    IconName["ArrowCircleUp"] = "arrow-circle-up";
    IconName["ArrowCircleUpLeft"] = "arrow-circle-up-left";
    IconName["ArrowCircleUpRight"] = "arrow-circle-up-right";
    IconName["ArrowCounterClockwise"] = "arrow-counter-clockwise";
    IconName["ArrowDown"] = "arrow-down";
    IconName["ArrowDownLeft"] = "arrow-down-left";
    IconName["ArrowDownRight"] = "arrow-down-right";
    IconName["ArrowFatDown"] = "arrow-fat-down";
    IconName["ArrowFatLeft"] = "arrow-fat-left";
    IconName["ArrowFatRight"] = "arrow-fat-right";
    IconName["ArrowFatUp"] = "arrow-fat-up";
    IconName["ArrowLeft"] = "arrow-left";
    IconName["ArrowLineDown"] = "arrow-line-down";
    IconName["ArrowLineLeft"] = "arrow-line-left";
    IconName["ArrowLineRight"] = "arrow-line-right";
    IconName["ArrowRight"] = "arrow-right";
    IconName["ArrowsClockwise"] = "arrows-clockwise";
    IconName["ArrowsDownUp"] = "arrows-down-up";
    IconName["ArrowsIn"] = "arrows-in";
    IconName["ArrowsInCardinal"] = "arrows-in-cardinal";
    IconName["ArrowsInLineVertical"] = "arrows-in-line-vertical";
    IconName["ArrowsInSimple"] = "arrows-in-simple";
    IconName["ArrowsOutCardinal"] = "arrows-out-cardinal";
    IconName["ArrowsOut"] = "arrows-out";
    IconName["ArrowsOutSimple"] = "arrows-out-simple";
    IconName["ArrowSquareIn"] = "arrow-square-in";
    IconName["ArrowSquareOut"] = "arrow-square-out";
    IconName["ArrowUp"] = "arrow-up";
    IconName["ArrowUpLeft"] = "arrow-up-left";
    IconName["ArrowUpRight"] = "arrow-up-right";
    IconName["Article"] = "article";
    IconName["Bell"] = "bell";
    IconName["BellRinging"] = "bell-ringing";
    IconName["BellSlash"] = "bell-slash";
    IconName["BellZ"] = "bell-z";
    IconName["Bookmark"] = "bookmark";
    IconName["Browser"] = "browser";
    IconName["Browsers"] = "browsers";
    IconName["Buildings"] = "buildings";
    IconName["ListBullets"] = "list-bullets";
    IconName["Calculator"] = "calculator";
    IconName["Calendar"] = "calendar";
    IconName["CalendarBlank"] = "calendar-blank";
    IconName["CalendarCheck"] = "calendar-check";
    IconName["CalendarPlus"] = "calendar-plus";
    IconName["CalendarX"] = "calendar-x";
    IconName["Camera"] = "camera";
    IconName["CameraPlus"] = "camera-plus";
    IconName["CameraSlash"] = "camera-slash";
    IconName["Cards"] = "cards";
    IconName["CaretCircleDown"] = "caret-circle-down";
    IconName["CaretCircleLeft"] = "caret-circle-left";
    IconName["CaretCircleRight"] = "caret-circle-right";
    IconName["CaretCircleUp"] = "caret-circle-up";
    IconName["CaretDoubleDown"] = "caret-double-down";
    IconName["CaretDoubleLeft"] = "caret-double-left";
    IconName["CaretDoubleRight"] = "caret-double-right";
    IconName["CaretDoubleUp"] = "caret-double-up";
    IconName["CaretDown"] = "caret-down";
    IconName["CaretLeft"] = "caret-left";
    IconName["CaretRight"] = "caret-right";
    IconName["CaretUp"] = "caret-up";
    IconName["CaretUpDown"] = "caret-up-down";
    IconName["ChartBar"] = "chart-bar";
    IconName["ChartBarHorizontal"] = "chart-bar-horizontal";
    IconName["ChartDonut"] = "chart-donut";
    IconName["ChartLine"] = "chart-line";
    IconName["ChartLineDown"] = "chart-line-down";
    IconName["ChartLineUp"] = "chart-line-up";
    IconName["ChartPie"] = "chart-pie";
    IconName["ChartPieSlice"] = "chart-pie-slice";
    IconName["ChatCircle"] = "chat-circle";
    IconName["ChatsCircle"] = "chats-circle";
    IconName["Check"] = "check";
    IconName["CheckCircle"] = "check-circle";
    IconName["CheckFat"] = "check-fat";
    IconName["Checks"] = "checks";
    IconName["CheckSquare"] = "check-square";
    IconName["CheckSquareOffset"] = "check-square-offset";
    IconName["Clock"] = "clock";
    IconName["ClockAfternoon"] = "clock-afternoon";
    IconName["ClockCounterClockwise"] = "clock-counter-clockwise";
    IconName["ClosedCaptioning"] = "closed-captioning";
    IconName["CloudArrowUp"] = "cloud-arrow-up";
    IconName["Code"] = "code";
    IconName["Coin"] = "coin";
    IconName["Coins"] = "coins";
    IconName["Copy"] = "copy";
    IconName["CreditCard"] = "credit-card";
    IconName["Cursor"] = "cursor";
    IconName["Dna"] = "dna";
    IconName["Dot"] = "dot";
    IconName["DotOutline"] = "dot-outline";
    IconName["DotsNine"] = "dots-nine";
    IconName["DotsThree"] = "dots-three";
    IconName["DotsThreeCircle"] = "dots-three-circle";
    IconName["DotsThreeCircleVertical"] = "dots-three-circle-vertical";
    IconName["DotsThreeOutline"] = "dots-three-outline";
    IconName["DotsThreeOutlineVertical"] = "dots-three-outline-vertical";
    IconName["DotsThreeVertical"] = "dots-three-vertical";
    IconName["DownloadSimple"] = "download-simple";
    IconName["EnvelopeSimple"] = "envelope-simple";
    IconName["EnvelopeSimpleOpen"] = "envelope-simple-open";
    IconName["Export"] = "export";
    IconName["Eye"] = "eye";
    IconName["EyeSlash"] = "eye-slash";
    IconName["FaceMask"] = "face-mask";
    IconName["Factory"] = "factory";
    IconName["File"] = "file";
    IconName["FileArrowDown"] = "file-arrow-down";
    IconName["FileImage"] = "file-image";
    IconName["FilePdf"] = "file-pdf";
    IconName["Files"] = "files";
    IconName["FileVideo"] = "file-video";
    IconName["FingerprintSimple"] = "fingerprint-simple";
    IconName["FirstAid"] = "first-aid";
    IconName["Flag"] = "flag";
    IconName["Flask"] = "flask";
    IconName["Folder"] = "folder";
    IconName["FolderOpen"] = "folder-open";
    IconName["Funnel"] = "funnel";
    IconName["Gear"] = "gear";
    IconName["Globe"] = "globe";
    IconName["GridFour"] = "grid-four";
    IconName["GridNine"] = "grid-nine";
    IconName["Hand"] = "hand";
    IconName["HandPointing"] = "hand-pointing";
    IconName["HardDrive"] = "hard-drive";
    IconName["HardDrives"] = "hard-drives";
    IconName["Headphones"] = "headphones";
    IconName["Headset"] = "headset";
    IconName["Heart"] = "heart";
    IconName["Hospital"] = "hospital";
    IconName["House"] = "house";
    IconName["IdentificationBadge"] = "identification-badge";
    IconName["IdentificationCard"] = "identification-card";
    IconName["Image"] = "image";
    IconName["Images"] = "images";
    IconName["Info"] = "info";
    IconName["Layout"] = "layout";
    IconName["Lightning"] = "lightning";
    IconName["Link"] = "link";
    IconName["LinkBreak"] = "link-break";
    IconName["List"] = "list";
    IconName["ListChecks"] = "list-checks";
    IconName["LockSimple"] = "lock-simple";
    IconName["LockSimpleOpen"] = "lock-simple-open";
    IconName["LogoApple"] = "logo-apple";
    IconName["LogoFacebook"] = "logo-facebook";
    IconName["LogoGoogle"] = "logo-google";
    IconName["LogoInstagram"] = "logo-instagram";
    IconName["LogoLinkedIn"] = "logo-linkedin";
    IconName["LogoMicrosoft"] = "logo-microsoft";
    IconName["LogoX"] = "logo-x";
    IconName["LogoYahoo"] = "logo-yahoo";
    IconName["MagnifyingGlass"] = "magnifying-glass";
    IconName["MagnifyingGlassMinus"] = "magnifying-glass-minus";
    IconName["MagnifyingGlassPlus"] = "magnifying-glass-plus";
    IconName["MapPin"] = "map-pin";
    IconName["MapTrifold"] = "map-trifold";
    IconName["Microphone"] = "microphone";
    IconName["MicrophoneSlash"] = "microphone-slash";
    IconName["Minus"] = "minus";
    IconName["MinusCircle"] = "minus-circle";
    IconName["NavigationArrow"] = "navigation-arrow";
    IconName["Note"] = "note";
    IconName["Paperclip"] = "paperclip";
    IconName["PaperPlaneRight"] = "paper-plane-right";
    IconName["PaperPlaneTilt"] = "paper-plane-tilt";
    IconName["Password"] = "password";
    IconName["Pause"] = "pause";
    IconName["PauseCircle"] = "pause-circle";
    IconName["PencilSimple"] = "pencil-simple";
    IconName["Phone"] = "phone";
    IconName["Play"] = "play";
    IconName["PlayCircle"] = "play-circle";
    IconName["Plus"] = "plus";
    IconName["PlusCircle"] = "plus-circle";
    IconName["Presentation"] = "presentation";
    IconName["Printer"] = "printer";
    IconName["Prohibit"] = "prohibit";
    IconName["PushPin"] = "push-pin";
    IconName["PushPinSimple"] = "push-pin-simple";
    IconName["PushPinSimpleSlash"] = "push-pin-simple-slash";
    IconName["PushPinSlash"] = "push-pin-slash";
    IconName["Question"] = "question";
    IconName["Repeat"] = "repeat";
    IconName["Robot"] = "robot";
    IconName["SealCheck"] = "seal-check";
    IconName["Share"] = "share";
    IconName["ShareFat"] = "share-fat";
    IconName["ShareNetwork"] = "share-network";
    IconName["ShoppingCartSimple"] = "shopping-cart-simple";
    IconName["Signature"] = "signature";
    IconName["Signout"] = "signout";
    IconName["Sliders"] = "sliders";
    IconName["SlidersHorizontal"] = "sliders-horizontal";
    IconName["SpeakerSimpleHigh"] = "speaker-simple-high";
    IconName["SpeakerSimpleLow"] = "speaker-simple-low";
    IconName["SpeakerSimpleNone"] = "speaker-simple-none";
    IconName["SpeakerSimpleSlash"] = "speaker-simple-slash";
    IconName["SpeakerSimpleX"] = "speaker-simple-x";
    IconName["Spinner"] = "spinner";
    IconName["Star"] = "star";
    IconName["Subtitles"] = "subtitles";
    IconName["Syringe"] = "syringe";
    IconName["TagSimple"] = "tag-simple";
    IconName["TestTube"] = "test-tube";
    IconName["TextAlignCenter"] = "text-align-center";
    IconName["TextAlignLeft"] = "text-align-left";
    IconName["TextAlignRight"] = "text-align-right";
    IconName["ThermometerCold"] = "thermometer-cold";
    IconName["ThermometerHot"] = "thermometer-hot";
    IconName["ThermometerSimple"] = "thermometer-simple";
    IconName["ThumbsDown"] = "thumbs-down";
    IconName["ThumbsUp"] = "thumbs-up";
    IconName["Timer"] = "timer";
    IconName["Translate"] = "translate";
    IconName["Trash"] = "trash";
    IconName["TreeStructure"] = "tree-structure";
    IconName["Truck"] = "truck";
    IconName["UploadSimple"] = "upload-simple";
    IconName["User"] = "user";
    IconName["UserCircle"] = "user-circle";
    IconName["UserGear"] = "user-gear";
    IconName["UserMinus"] = "user-minus";
    IconName["UserPlus"] = "user-plus";
    IconName["Users"] = "users";
    IconName["UsersFour"] = "users-four";
    IconName["UsersThree"] = "users-three";
    IconName["UserSwitch"] = "user-switch";
    IconName["Virus"] = "virus";
    IconName["Warehouse"] = "warehouse";
    IconName["Warning"] = "warning";
    IconName["WarningCircle"] = "warning-circle";
    IconName["WarningDiamond"] = "warning-diamond";
    IconName["WarningOctagon"] = "warning-octagon";
    IconName["Wrench"] = "wrench";
    IconName["X"] = "x";
    IconName["XCircle"] = "x-circle";
    IconName["XSquare"] = "x-square";
})($52988eb5596b8f57$var$IconName || (module.exports.IconName = $52988eb5596b8f57$var$IconName = {}));
module.exports.DEFAULT_ICONS = Object.values($52988eb5596b8f57$var$IconName).reduce((res, val)=>{
    res[val] = true;
    return res;
}, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});

});


parcelRegister("iY3J9", function(module, exports) {
"use client";
"use strict";
var $dcf0b8be7a1e0d8c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadIcon = module.exports.IconImports = void 0;

const $dcf0b8be7a1e0d8c$var$react_1 = $dcf0b8be7a1e0d8c$var$__importDefault((parcelRequire("acw62")));





























































































































































































































































































































































































































































































































module.exports.IconImports = {
    "address-book": ()=>(parcelRequire("aGHQm")),
    "airplane-in-flight": ()=>(parcelRequire("kDjy2")),
    "airplane-landing": ()=>(parcelRequire("iM0PT")),
    "airplane-takeoff": ()=>(parcelRequire("hu01t")),
    "airplane-tilt": ()=>(parcelRequire("goEJ3")),
    alarm: ()=>(parcelRequire("kTP6M")),
    anchor: ()=>(parcelRequire("htybp")),
    archive: ()=>(parcelRequire("9f8do")),
    "arrow-circle-down-left": ()=>(parcelRequire("5qh4Q")),
    "arrow-circle-down-right": ()=>(parcelRequire("b4RmA")),
    "arrow-circle-down": ()=>(parcelRequire("4zk3C")),
    "arrow-circle-left": ()=>(parcelRequire("1XIc8")),
    "arrow-circle-right": ()=>(parcelRequire("kzbFA")),
    "arrow-circle-up-left": ()=>(parcelRequire("chNjk")),
    "arrow-circle-up-right": ()=>(parcelRequire("25UQC")),
    "arrow-circle-up": ()=>(parcelRequire("1MC6W")),
    "arrow-counter-clockwise": ()=>(parcelRequire("04TDo")),
    "arrow-down-left": ()=>(parcelRequire("dT9s9")),
    "arrow-down-right": ()=>(parcelRequire("6yCWl")),
    "arrow-down": ()=>(parcelRequire("a56bI")),
    "arrow-fat-down": ()=>(parcelRequire("36zXE")),
    "arrow-fat-left": ()=>(parcelRequire("jNlge")),
    "arrow-fat-right": ()=>(parcelRequire("4uBpA")),
    "arrow-fat-up": ()=>(parcelRequire("cbzUS")),
    "arrow-left": ()=>(parcelRequire("47iwB")),
    "arrow-line-down": ()=>(parcelRequire("j5waz")),
    "arrow-line-left": ()=>(parcelRequire("fTtkG")),
    "arrow-line-right": ()=>(parcelRequire("40MyE")),
    "arrow-right": ()=>(parcelRequire("lOhB7")),
    "arrow-square-in": ()=>(parcelRequire("aKLOj")),
    "arrow-square-out": ()=>(parcelRequire("4249u")),
    "arrow-up-left": ()=>(parcelRequire("kz49L")),
    "arrow-up-right": ()=>(parcelRequire("2r6eq")),
    "arrow-up": ()=>(parcelRequire("lFkap")),
    "arrows-clockwise": ()=>(parcelRequire("hGhHY")),
    "arrows-down-up": ()=>(parcelRequire("ecjrl")),
    "arrows-in-cardinal": ()=>(parcelRequire("f1Brr")),
    "arrows-in-line-vertical": ()=>(parcelRequire("5mkpS")),
    "arrows-in-simple": ()=>(parcelRequire("e47uI")),
    "arrows-in": ()=>(parcelRequire("8t4Vw")),
    "arrows-out-cardinal": ()=>(parcelRequire("4KAHp")),
    "arrows-out-simple": ()=>(parcelRequire("6wxtm")),
    "arrows-out": ()=>(parcelRequire("ehwMF")),
    article: ()=>(parcelRequire("dszWJ")),
    "bell-ringing": ()=>(parcelRequire("b8fqO")),
    "bell-slash": ()=>(parcelRequire("c0Mlr")),
    "bell-z": ()=>(parcelRequire("2VUZA")),
    bell: ()=>(parcelRequire("esIgq")),
    bookmark: ()=>(parcelRequire("fyN01")),
    browser: ()=>(parcelRequire("hAABn")),
    browsers: ()=>(parcelRequire("enZ0w")),
    buildings: ()=>(parcelRequire("3gOLM")),
    calculator: ()=>(parcelRequire("XuQsJ")),
    "calendar-blank": ()=>(parcelRequire("dMtfy")),
    "calendar-check": ()=>(parcelRequire("iN8Sl")),
    "calendar-plus": ()=>(parcelRequire("iLu4p")),
    "calendar-x": ()=>(parcelRequire("ke2WQ")),
    calendar: ()=>(parcelRequire("7N5TK")),
    "camera-plus": ()=>(parcelRequire("fpp9N")),
    "camera-slash": ()=>(parcelRequire("fYvT3")),
    camera: ()=>(parcelRequire("6il5b")),
    cards: ()=>(parcelRequire("4u0z7")),
    "caret-circle-down": ()=>(parcelRequire("iiceA")),
    "caret-circle-left": ()=>(parcelRequire("jt3Da")),
    "caret-circle-right": ()=>(parcelRequire("6b0FC")),
    "caret-circle-up": ()=>(parcelRequire("f1ccV")),
    "caret-double-down": ()=>(parcelRequire("d1ae7")),
    "caret-double-left": ()=>(parcelRequire("2Chaq")),
    "caret-double-right": ()=>(parcelRequire("5D9Bt")),
    "caret-double-up": ()=>(parcelRequire("dkkPE")),
    "caret-down": ()=>(parcelRequire("i67Ss")),
    "caret-left": ()=>(parcelRequire("6JsXR")),
    "caret-right": ()=>(parcelRequire("hxB2c")),
    "caret-up-down": ()=>(parcelRequire("kIUSS")),
    "caret-up": ()=>(parcelRequire("7jkRh")),
    "chart-bar-horizontal": ()=>(parcelRequire("8Vyn3")),
    "chart-bar": ()=>(parcelRequire("e69oD")),
    "chart-donut": ()=>(parcelRequire("2s8QP")),
    "chart-line-down": ()=>(parcelRequire("f2OTJ")),
    "chart-line-up": ()=>(parcelRequire("ijSuv")),
    "chart-line": ()=>(parcelRequire("6Jkf2")),
    "chart-pie-slice": ()=>(parcelRequire("c0HjZ")),
    "chart-pie": ()=>(parcelRequire("fto03")),
    "chat-circle": ()=>(parcelRequire("dwUmZ")),
    "chats-circle": ()=>(parcelRequire("eeoTv")),
    "check-circle": ()=>(parcelRequire("jqjNF")),
    "check-fat": ()=>(parcelRequire("j6MWI")),
    "check-square-offset": ()=>(parcelRequire("db9od")),
    "check-square": ()=>(parcelRequire("kAjTu")),
    check: ()=>(parcelRequire("3qDwX")),
    checks: ()=>(parcelRequire("h06oE")),
    "clock-afternoon": ()=>(parcelRequire("53Q4Q")),
    "clock-counter-clockwise": ()=>(parcelRequire("86HLF")),
    clock: ()=>(parcelRequire("kyilV")),
    "closed-captioning": ()=>(parcelRequire("czi3M")),
    "cloud-arrow-up": ()=>(parcelRequire("av9nT")),
    code: ()=>(parcelRequire("kwyIT")),
    coin: ()=>(parcelRequire("4OfIF")),
    coins: ()=>(parcelRequire("fX9QM")),
    copy: ()=>(parcelRequire("40glH")),
    "credit-card": ()=>(parcelRequire("9enj5")),
    cursor: ()=>(parcelRequire("8Ptja")),
    dna: ()=>(parcelRequire("dxkZi")),
    "dot-outline": ()=>(parcelRequire("794ZU")),
    dot: ()=>(parcelRequire("2sEun")),
    "dots-nine": ()=>(parcelRequire("4l6BW")),
    "dots-three-circle-vertical": ()=>(parcelRequire("femYi")),
    "dots-three-circle": ()=>(parcelRequire("9XIPO")),
    "dots-three-outline-vertical": ()=>(parcelRequire("i7qJX")),
    "dots-three-outline": ()=>(parcelRequire("81Q7D")),
    "dots-three-vertical": ()=>(parcelRequire("fWA3D")),
    "dots-three": ()=>(parcelRequire("a5Xrf")),
    "download-simple": ()=>(parcelRequire("gHsAW")),
    "envelope-simple-open": ()=>(parcelRequire("inrIf")),
    "envelope-simple": ()=>(parcelRequire("gz3fj")),
    export: ()=>(parcelRequire("aFazs")),
    "eye-slash": ()=>(parcelRequire("81CT2")),
    eye: ()=>(parcelRequire("9kM9O")),
    "face-mask": ()=>(parcelRequire("dBXFL")),
    factory: ()=>(parcelRequire("czUC7")),
    "file-arrow-down": ()=>(parcelRequire("hdpT4")),
    "file-image": ()=>(parcelRequire("gdjz7")),
    "file-pdf": ()=>(parcelRequire("5I9Pd")),
    "file-video": ()=>(parcelRequire("32iVS")),
    file: ()=>(parcelRequire("gNtYp")),
    files: ()=>(parcelRequire("57mVy")),
    "fingerprint-simple": ()=>(parcelRequire("k670C")),
    "first-aid": ()=>(parcelRequire("9ImVv")),
    flag: ()=>(parcelRequire("cbGwP")),
    flask: ()=>(parcelRequire("y3imB")),
    "folder-open": ()=>(parcelRequire("eTCd4")),
    folder: ()=>(parcelRequire("6N3Ji")),
    funnel: ()=>(parcelRequire("jF06K")),
    gear: ()=>(parcelRequire("hPWjF")),
    globe: ()=>(parcelRequire("4ytPz")),
    "grid-four": ()=>(parcelRequire("ctf1j")),
    "grid-nine": ()=>(parcelRequire("brPrG")),
    "hand-pointing": ()=>(parcelRequire("dw0hO")),
    hand: ()=>(parcelRequire("h1LFU")),
    "hard-drive": ()=>(parcelRequire("jLrWq")),
    "hard-drives": ()=>(parcelRequire("3VJOv")),
    headphones: ()=>(parcelRequire("kga4n")),
    headset: ()=>(parcelRequire("geMf1")),
    heart: ()=>(parcelRequire("hkQ91")),
    hospital: ()=>(parcelRequire("6UHsZ")),
    house: ()=>(parcelRequire("3YyFx")),
    "identification-badge": ()=>(parcelRequire("5D8zV")),
    "identification-card": ()=>(parcelRequire("aUvyc")),
    image: ()=>(parcelRequire("hEYow")),
    images: ()=>(parcelRequire("aD1BJ")),
    info: ()=>(parcelRequire("g9Hzv")),
    layout: ()=>(parcelRequire("kHQlW")),
    lightning: ()=>(parcelRequire("jC4L9")),
    "link-break": ()=>(parcelRequire("gQw3Y")),
    link: ()=>(parcelRequire("dq8dP")),
    "list-bullets": ()=>(parcelRequire("kVPBR")),
    "list-checks": ()=>(parcelRequire("9WcLS")),
    list: ()=>(parcelRequire("hQeHW")),
    "lock-simple-open": ()=>(parcelRequire("a3spf")),
    "lock-simple": ()=>(parcelRequire("e16da")),
    "logo-apple": ()=>(parcelRequire("twpKt")),
    "logo-facebook": ()=>(parcelRequire("ecPl4")),
    "logo-google": ()=>(parcelRequire("kzqda")),
    "logo-instagram": ()=>(parcelRequire("4os5X")),
    "logo-linkedin": ()=>(parcelRequire("fLjM7")),
    "logo-microsoft": ()=>(parcelRequire("1hjaA")),
    "logo-x": ()=>(parcelRequire("6QRZT")),
    "logo-yahoo": ()=>(parcelRequire("6XgAN")),
    "magnifying-glass-minus": ()=>(parcelRequire("ky93O")),
    "magnifying-glass-plus": ()=>(parcelRequire("a4kNm")),
    "magnifying-glass": ()=>(parcelRequire("2HcKb")),
    "map-pin": ()=>(parcelRequire("l4jJW")),
    "map-trifold": ()=>(parcelRequire("eABHF")),
    "microphone-slash": ()=>(parcelRequire("3Lr8W")),
    microphone: ()=>(parcelRequire("9FQ85")),
    "minus-circle": ()=>(parcelRequire("hJgnD")),
    minus: ()=>(parcelRequire("7fOHH")),
    "navigation-arrow": ()=>(parcelRequire("8khjq")),
    note: ()=>(parcelRequire("3nTKm")),
    "paper-plane-right": ()=>(parcelRequire("e6FUt")),
    "paper-plane-tilt": ()=>(parcelRequire("g1dVE")),
    paperclip: ()=>(parcelRequire("6IAGY")),
    password: ()=>(parcelRequire("eo5ni")),
    "pause-circle": ()=>(parcelRequire("4XCJm")),
    pause: ()=>(parcelRequire("bPucJ")),
    "pencil-simple": ()=>(parcelRequire("6PzQn")),
    phone: ()=>(parcelRequire("daajt")),
    "play-circle": ()=>(parcelRequire("luSsW")),
    play: ()=>(parcelRequire("jfTS4")),
    "plus-circle": ()=>(parcelRequire("9QskI")),
    plus: ()=>(parcelRequire("hXslA")),
    presentation: ()=>(parcelRequire("i4BXV")),
    printer: ()=>(parcelRequire("jE45n")),
    prohibit: ()=>(parcelRequire("iOltd")),
    "push-pin-simple-slash": ()=>(parcelRequire("dTa8C")),
    "push-pin-simple": ()=>(parcelRequire("ews1n")),
    "push-pin-slash": ()=>(parcelRequire("4SRDZ")),
    "push-pin": ()=>(parcelRequire("jm0Ta")),
    question: ()=>(parcelRequire("gy1Yt")),
    repeat: ()=>(parcelRequire("cWI9Z")),
    robot: ()=>(parcelRequire("4lmJS")),
    "seal-check": ()=>(parcelRequire("7ivOI")),
    "share-fat": ()=>(parcelRequire("ilxvY")),
    "share-network": ()=>(parcelRequire("34yKd")),
    share: ()=>(parcelRequire("irkdw")),
    "shopping-cart-simple": ()=>(parcelRequire("1utEi")),
    signature: ()=>(parcelRequire("ikb1l")),
    signout: ()=>(parcelRequire("8p4Sm")),
    "sliders-horizontal": ()=>(parcelRequire("jioSw")),
    sliders: ()=>(parcelRequire("dA5ha")),
    "speaker-simple-high": ()=>(parcelRequire("b1aP2")),
    "speaker-simple-low": ()=>(parcelRequire("iWjqB")),
    "speaker-simple-none": ()=>(parcelRequire("ctZD9")),
    "speaker-simple-slash": ()=>(parcelRequire("4USDD")),
    "speaker-simple-x": ()=>(parcelRequire("7tFHb")),
    spinner: ()=>(parcelRequire("iIEY2")),
    star: ()=>(parcelRequire("8EbKR")),
    subtitles: ()=>(parcelRequire("kgJih")),
    syringe: ()=>(parcelRequire("bXqFN")),
    "tag-simple": ()=>(parcelRequire("9AmYx")),
    "test-tube": ()=>(parcelRequire("bz2HH")),
    "text-align-center": ()=>(parcelRequire("kSp4L")),
    "text-align-left": ()=>(parcelRequire("ermWF")),
    "text-align-right": ()=>(parcelRequire("16qVb")),
    "thermometer-cold": ()=>(parcelRequire("bflIU")),
    "thermometer-hot": ()=>(parcelRequire("9vrZ3")),
    "thermometer-simple": ()=>(parcelRequire("l9ClQ")),
    "thumbs-down": ()=>(parcelRequire("e2YNX")),
    "thumbs-up": ()=>(parcelRequire("cY8J4")),
    timer: ()=>(parcelRequire("ip4De")),
    translate: ()=>(parcelRequire("LnJ0d")),
    trash: ()=>(parcelRequire("fTMp8")),
    "tree-structure": ()=>(parcelRequire("biZpv")),
    truck: ()=>(parcelRequire("1Cz0I")),
    "upload-simple": ()=>(parcelRequire("7JEJh")),
    "user-circle": ()=>(parcelRequire("c3q5C")),
    "user-gear": ()=>(parcelRequire("3PuNt")),
    "user-minus": ()=>(parcelRequire("i1GqN")),
    "user-plus": ()=>(parcelRequire("1wn2Z")),
    "user-switch": ()=>(parcelRequire("kpOnN")),
    user: ()=>(parcelRequire("9YxWr")),
    "users-four": ()=>(parcelRequire("2L05j")),
    "users-three": ()=>(parcelRequire("9cGIo")),
    users: ()=>(parcelRequire("gYzgi")),
    virus: ()=>(parcelRequire("a1z0r")),
    warehouse: ()=>(parcelRequire("akqd8")),
    "warning-circle": ()=>(parcelRequire("lmwhb")),
    "warning-diamond": ()=>(parcelRequire("iA20J")),
    "warning-octagon": ()=>(parcelRequire("5vQbe")),
    warning: ()=>(parcelRequire("dNBTi")),
    wrench: ()=>(parcelRequire("cDTrs")),
    "x-circle": ()=>(parcelRequire("fohpc")),
    "x-square": ()=>(parcelRequire("c0gTv")),
    x: ()=>(parcelRequire("lelqp")),
    AD: ()=>(parcelRequire("flhwv")),
    AE: ()=>(parcelRequire("hx45m")),
    AF: ()=>(parcelRequire("8F6CO")),
    AG: ()=>(parcelRequire("lVPSw")),
    AI: ()=>(parcelRequire("iFrQU")),
    AL: ()=>(parcelRequire("l1TOG")),
    AM: ()=>(parcelRequire("8h0To")),
    AO: ()=>(parcelRequire("26eUK")),
    AR: ()=>(parcelRequire("67z9p")),
    AS: ()=>(parcelRequire("2T6mL")),
    AT: ()=>(parcelRequire("j11JM")),
    AU: ()=>(parcelRequire("lfWli")),
    AW: ()=>(parcelRequire("gB60T")),
    AX: ()=>(parcelRequire("7vWLc")),
    AZ: ()=>(parcelRequire("c1Vod")),
    BA: ()=>(parcelRequire("gifPQ")),
    BB: ()=>(parcelRequire("3Hb18")),
    BD: ()=>(parcelRequire("cpZen")),
    BE: ()=>(parcelRequire("8vsH2")),
    BF: ()=>(parcelRequire("2RSD6")),
    BG: ()=>(parcelRequire("7cHpW")),
    BH: ()=>(parcelRequire("3w3j0")),
    BI: ()=>(parcelRequire("i7rh7")),
    BJ: ()=>(parcelRequire("kBk1I")),
    BL: ()=>(parcelRequire("g4ouS")),
    BM: ()=>(parcelRequire("5VEoF")),
    BN: ()=>(parcelRequire("2BzDK")),
    BO: ()=>(parcelRequire("jlWyi")),
    BR: ()=>(parcelRequire("a4EKO")),
    BS: ()=>(parcelRequire("5EbdE")),
    BT: ()=>(parcelRequire("4QHH2")),
    BV: ()=>(parcelRequire("dd7Dx")),
    BW: ()=>(parcelRequire("9Jdkm")),
    BY: ()=>(parcelRequire("2tzFk")),
    BZ: ()=>(parcelRequire("dKccj")),
    CA: ()=>(parcelRequire("lcr5m")),
    CC: ()=>(parcelRequire("89zow")),
    CD: ()=>(parcelRequire("91xA2")),
    CF: ()=>(parcelRequire("b0CuE")),
    CG: ()=>(parcelRequire("a19p8")),
    CH: ()=>(parcelRequire("1cbgl")),
    CI: ()=>(parcelRequire("3BBWi")),
    CK: ()=>(parcelRequire("5kNVB")),
    CL: ()=>(parcelRequire("5NYsi")),
    CM: ()=>(parcelRequire("cjwap")),
    CN: ()=>(parcelRequire("5eluQ")),
    CO: ()=>(parcelRequire("lIrdf")),
    CR: ()=>(parcelRequire("kld7Q")),
    CU: ()=>(parcelRequire("407zZ")),
    CV: ()=>(parcelRequire("j9OS8")),
    CW: ()=>(parcelRequire("1F4pR")),
    CX: ()=>(parcelRequire("iB5Y1")),
    CY: ()=>(parcelRequire("cU2bk")),
    CZ: ()=>(parcelRequire("2HO0D")),
    DE: ()=>(parcelRequire("jIO7M")),
    DJ: ()=>(parcelRequire("4oWsZ")),
    DK: ()=>(parcelRequire("9V57f")),
    DM: ()=>(parcelRequire("8NufO")),
    DO: ()=>(parcelRequire("6zPJI")),
    DZ: ()=>(parcelRequire("8maqR")),
    EC: ()=>(parcelRequire("6e2gF")),
    EE: ()=>(parcelRequire("fOZA4")),
    EG: ()=>(parcelRequire("3hPIE")),
    ER: ()=>(parcelRequire("j7Kqh")),
    ES: ()=>(parcelRequire("hCu0U")),
    ET: ()=>(parcelRequire("3wqQv")),
    EU: ()=>(parcelRequire("3nFN3")),
    FI: ()=>(parcelRequire("4UkVF")),
    FJ: ()=>(parcelRequire("1Z7b3")),
    FK: ()=>(parcelRequire("3TKik")),
    FM: ()=>(parcelRequire("khqp8")),
    FO: ()=>(parcelRequire("cqHHa")),
    FR: ()=>(parcelRequire("itmYM")),
    GA: ()=>(parcelRequire("ldHYV")),
    "GB-ENG": ()=>(parcelRequire("2V6Gn")),
    "GB-NIR": ()=>(parcelRequire("eFJFv")),
    "GB-SCT": ()=>(parcelRequire("kNRTk")),
    "GB-WLS": ()=>(parcelRequire("db9xF")),
    "GB-ZET": ()=>(parcelRequire("ckfdB")),
    GB: ()=>(parcelRequire("ek6PV")),
    GD: ()=>(parcelRequire("60zre")),
    GE: ()=>(parcelRequire("9fv8i")),
    GF: ()=>(parcelRequire("aH0Lg")),
    GG: ()=>(parcelRequire("g4U8W")),
    GH: ()=>(parcelRequire("ai4n0")),
    GI: ()=>(parcelRequire("5xhXM")),
    GL: ()=>(parcelRequire("gNZb6")),
    GM: ()=>(parcelRequire("irmmb")),
    GN: ()=>(parcelRequire("2rE8X")),
    GP: ()=>(parcelRequire("4EY6d")),
    GQ: ()=>(parcelRequire("gb8I0")),
    GR: ()=>(parcelRequire("lGgwA")),
    GS: ()=>(parcelRequire("kmyME")),
    GT: ()=>(parcelRequire("7lxbD")),
    GU: ()=>(parcelRequire("fBGA6")),
    GW: ()=>(parcelRequire("gDcQE")),
    GY: ()=>(parcelRequire("3Q2zx")),
    HK: ()=>(parcelRequire("cl1KU")),
    HM: ()=>(parcelRequire("jFdJY")),
    HN: ()=>(parcelRequire("1P9p0")),
    HR: ()=>(parcelRequire("hTSUs")),
    HT: ()=>(parcelRequire("dWbXj")),
    HU: ()=>(parcelRequire("gVRgd")),
    ID: ()=>(parcelRequire("ebM6F")),
    IE: ()=>(parcelRequire("25Scx")),
    IL: ()=>(parcelRequire("fg7Ai")),
    IM: ()=>(parcelRequire("iAohh")),
    IN: ()=>(parcelRequire("1wgfN")),
    IO: ()=>(parcelRequire("drAdX")),
    IQ: ()=>(parcelRequire("2BQS5")),
    IR: ()=>(parcelRequire("ivUf0")),
    IS: ()=>(parcelRequire("frMFo")),
    IT: ()=>(parcelRequire("6fZgI")),
    JE: ()=>(parcelRequire("bRVog")),
    JM: ()=>(parcelRequire("EvrZk")),
    JO: ()=>(parcelRequire("5LzjS")),
    JP: ()=>(parcelRequire("1bFpO")),
    KE: ()=>(parcelRequire("lVp9N")),
    KG: ()=>(parcelRequire("gR4hw")),
    KH: ()=>(parcelRequire("30G1i")),
    KI: ()=>(parcelRequire("hh8b6")),
    KM: ()=>(parcelRequire("WUQKD")),
    KN: ()=>(parcelRequire("limqM")),
    KP: ()=>(parcelRequire("6TlId")),
    KR: ()=>(parcelRequire("3w9Jp")),
    KW: ()=>(parcelRequire("5mpD5")),
    KY: ()=>(parcelRequire("52de6")),
    KZ: ()=>(parcelRequire("gCXoh")),
    LA: ()=>(parcelRequire("hrnuM")),
    LB: ()=>(parcelRequire("8DhAc")),
    LC: ()=>(parcelRequire("fzdmh")),
    LGBT1: ()=>(parcelRequire("jOpQ4")),
    LI: ()=>(parcelRequire("eHcrM")),
    LK: ()=>(parcelRequire("c5buF")),
    LR: ()=>(parcelRequire("bTvAO")),
    LS: ()=>(parcelRequire("2Gzn3")),
    LT: ()=>(parcelRequire("bu44j")),
    LU: ()=>(parcelRequire("4vwKC")),
    LV: ()=>(parcelRequire("ijgre")),
    LY: ()=>(parcelRequire("kCwUd")),
    MA: ()=>(parcelRequire("guP4S")),
    MC: ()=>(parcelRequire("aK1yl")),
    MD: ()=>(parcelRequire("8CEFV")),
    ME: ()=>(parcelRequire("8fC6L")),
    MF: ()=>(parcelRequire("5InkV")),
    MG: ()=>(parcelRequire("2RF3S")),
    MH: ()=>(parcelRequire("c68pJ")),
    MK: ()=>(parcelRequire("8qX5Z")),
    ML: ()=>(parcelRequire("1DHpV")),
    MM: ()=>(parcelRequire("golnw")),
    MN: ()=>(parcelRequire("k4HdW")),
    MO: ()=>(parcelRequire("7nq1R")),
    MP: ()=>(parcelRequire("gCEnf")),
    MQ: ()=>(parcelRequire("3LZVv")),
    MR: ()=>(parcelRequire("37KTL")),
    MS: ()=>(parcelRequire("6zRf7")),
    MT: ()=>(parcelRequire("2keJj")),
    MU: ()=>(parcelRequire("dkxGM")),
    MV: ()=>(parcelRequire("3B0vJ")),
    MW: ()=>(parcelRequire("5IrBl")),
    MX: ()=>(parcelRequire("4sVjI")),
    MY: ()=>(parcelRequire("1mqww")),
    MZ: ()=>(parcelRequire("9wnFB")),
    NA: ()=>(parcelRequire("69mkb")),
    NC: ()=>(parcelRequire("d3olu")),
    NE: ()=>(parcelRequire("hUKx7")),
    NF: ()=>(parcelRequire("8kStj")),
    NG: ()=>(parcelRequire("9012W")),
    NI: ()=>(parcelRequire("iCHJq")),
    NL: ()=>(parcelRequire("tyYcD")),
    NO: ()=>(parcelRequire("lcWQv")),
    NP: ()=>(parcelRequire("bqtaB")),
    NR: ()=>(parcelRequire("lp7vt")),
    NU: ()=>(parcelRequire("4BQKS")),
    NZ: ()=>(parcelRequire("1Oq36")),
    OM: ()=>(parcelRequire("l2efD")),
    PA: ()=>(parcelRequire("bqGa9")),
    PE: ()=>(parcelRequire("hSLkm")),
    PF: ()=>(parcelRequire("f63m5")),
    PG: ()=>(parcelRequire("3ymkH")),
    PH: ()=>(parcelRequire("kgBG0")),
    PK: ()=>(parcelRequire("53xcC")),
    PL: ()=>(parcelRequire("hyV51")),
    PM: ()=>(parcelRequire("gWLpy")),
    PN: ()=>(parcelRequire("cn4dQ")),
    PR: ()=>(parcelRequire("cJSGi")),
    PS: ()=>(parcelRequire("kCA5q")),
    PT: ()=>(parcelRequire("iXCA2")),
    PW: ()=>(parcelRequire("cjqRQ")),
    PY: ()=>(parcelRequire("6NpEp")),
    QA: ()=>(parcelRequire("9bB0S")),
    RE: ()=>(parcelRequire("ht2L4")),
    RO: ()=>(parcelRequire("jTgoK")),
    RS: ()=>(parcelRequire("bgspi")),
    RU: ()=>(parcelRequire("1tjXo")),
    RW: ()=>(parcelRequire("5b0Z0")),
    SA: ()=>(parcelRequire("lxnsB")),
    SB: ()=>(parcelRequire("3CNwQ")),
    SC: ()=>(parcelRequire("1XBZb")),
    SD: ()=>(parcelRequire("4O6QU")),
    SE: ()=>(parcelRequire("b1KcQ")),
    SG: ()=>(parcelRequire("7cLqI")),
    SH: ()=>(parcelRequire("i4B91")),
    SI: ()=>(parcelRequire("35MsT")),
    SJ: ()=>(parcelRequire("cYoMZ")),
    SK: ()=>(parcelRequire("bKDV2")),
    SL: ()=>(parcelRequire("5relS")),
    SM: ()=>(parcelRequire("irF7d")),
    SN: ()=>(parcelRequire("fEb7A")),
    SO: ()=>(parcelRequire("luv1u")),
    SR: ()=>(parcelRequire("6pVQU")),
    SS: ()=>(parcelRequire("4wxhF")),
    ST: ()=>(parcelRequire("3dpt5")),
    SV: ()=>(parcelRequire("ey7tz")),
    SX: ()=>(parcelRequire("6fLty")),
    SY: ()=>(parcelRequire("dBN7n")),
    SZ: ()=>(parcelRequire("jLoqJ")),
    TC: ()=>(parcelRequire("1BBqi")),
    TD: ()=>(parcelRequire("cQB36")),
    TF: ()=>(parcelRequire("e6iuH")),
    TG: ()=>(parcelRequire("2dpni")),
    TH: ()=>(parcelRequire("lConb")),
    TJ: ()=>(parcelRequire("6kGdX")),
    TK: ()=>(parcelRequire("fbX1q")),
    TL: ()=>(parcelRequire("e5ie9")),
    TM: ()=>(parcelRequire("laGNM")),
    TN: ()=>(parcelRequire("9LU9L")),
    TO: ()=>(parcelRequire("4Ay2L")),
    TR: ()=>(parcelRequire("ltine")),
    TT: ()=>(parcelRequire("9YDGr")),
    TV: ()=>(parcelRequire("7kLV5")),
    TW: ()=>(parcelRequire("dY1d6")),
    TZ: ()=>(parcelRequire("1UXTd")),
    UA: ()=>(parcelRequire("k86tR")),
    UG: ()=>(parcelRequire("iBu0g")),
    UM: ()=>(parcelRequire("bq3GA")),
    US: ()=>(parcelRequire("8mqKf")),
    USCA: ()=>(parcelRequire("i1SMZ")),
    UY: ()=>(parcelRequire("48SNF")),
    UZ: ()=>(parcelRequire("hVMgn")),
    VA: ()=>(parcelRequire("fqp2w")),
    VC: ()=>(parcelRequire("lDyWk")),
    VE: ()=>(parcelRequire("apmFJ")),
    VG: ()=>(parcelRequire("iW20L")),
    VI: ()=>(parcelRequire("2HPoD")),
    VN: ()=>(parcelRequire("14IwX")),
    VU: ()=>(parcelRequire("1m2Cu")),
    WF: ()=>(parcelRequire("46yaT")),
    WS: ()=>(parcelRequire("duxlN")),
    XK: ()=>(parcelRequire("5EWCJ")),
    YE: ()=>(parcelRequire("aKY0a")),
    YT: ()=>(parcelRequire("fQDjk")),
    ZA: ()=>(parcelRequire("K3JOK")),
    ZM: ()=>(parcelRequire("eCNA3")),
    ZW: ()=>(parcelRequire("b7dfQ"))
};
const $dcf0b8be7a1e0d8c$var$loadIcon = (componentName)=>{
    return $dcf0b8be7a1e0d8c$var$react_1.default.lazy(()=>module.exports.IconImports[componentName]().then((module)=>({
                default: Object.values(module).at(0)
            })));
};
module.exports.loadIcon = $dcf0b8be7a1e0d8c$var$loadIcon;

});
parcelRegister("aGHQm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cQ4xT").then(()=>parcelRequire('fFPXt'));

});

parcelRegister("kDjy2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bwB7A").then(()=>parcelRequire('lvtGy'));

});

parcelRegister("iM0PT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("79Qsj").then(()=>parcelRequire('9Ym4f'));

});

parcelRegister("hu01t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a76vj").then(()=>parcelRequire('6tPKG'));

});

parcelRegister("goEJ3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f4L6h").then(()=>parcelRequire('4DgH7'));

});

parcelRegister("kTP6M", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a4HPO").then(()=>parcelRequire('17Mgd'));

});

parcelRegister("htybp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lAvt8").then(()=>parcelRequire('3Igkg'));

});

parcelRegister("9f8do", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2zNtn").then(()=>parcelRequire('53Ry6'));

});

parcelRegister("5qh4Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hCZ3D").then(()=>parcelRequire('95DSY'));

});

parcelRegister("b4RmA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8gw8E").then(()=>parcelRequire('7txeF'));

});

parcelRegister("4zk3C", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3ur17").then(()=>parcelRequire('dJXQM'));

});

parcelRegister("1XIc8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2SJs2").then(()=>parcelRequire('7ZqbQ'));

});

parcelRegister("kzbFA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("j43KR").then(()=>parcelRequire('eb6L0'));

});

parcelRegister("chNjk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1cko7").then(()=>parcelRequire('9ur0G'));

});

parcelRegister("25UQC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5ekqe").then(()=>parcelRequire('hVS8q'));

});

parcelRegister("1MC6W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b2Amm").then(()=>parcelRequire('lPKhX'));

});

parcelRegister("04TDo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hvqv9").then(()=>parcelRequire('jPdY5'));

});

parcelRegister("dT9s9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("2IopW")
]).then(()=>parcelRequire('6gpUy'));

});

parcelRegister("6yCWl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("2KedF")
]).then(()=>parcelRequire('65T6N'));

});

parcelRegister("a56bI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("eRAMU")
]).then(()=>parcelRequire('hLWBr'));

});

parcelRegister("36zXE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2z2Bt").then(()=>parcelRequire('eqNKS'));

});

parcelRegister("jNlge", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("56HVZ").then(()=>parcelRequire('cMftf'));

});

parcelRegister("4uBpA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("21wXE").then(()=>parcelRequire('kuBWZ'));

});

parcelRegister("cbzUS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cIGMV").then(()=>parcelRequire('2MDho'));

});

parcelRegister("47iwB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8SfJg").then(()=>parcelRequire('1To13'));

});

parcelRegister("j5waz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3nP2r").then(()=>parcelRequire('7ODPG'));

});

parcelRegister("fTtkG", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("3nP2r"),
    $Gr8vk("4zXIP")
]).then(()=>parcelRequire('fwOmV'));

});

parcelRegister("40MyE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("3nP2r"),
    $Gr8vk("13UzD")
]).then(()=>parcelRequire('aUJ5R'));

});

parcelRegister("lOhB7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("3UftB")
]).then(()=>parcelRequire('cW5we'));

});

parcelRegister("aKLOj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2SO81").then(()=>parcelRequire('kQTtp'));

});

parcelRegister("4249u", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eoz6y").then(()=>parcelRequire('hTSr2'));

});

parcelRegister("kz49L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("jjwWh")
]).then(()=>parcelRequire('fXUFk'));

});

parcelRegister("2r6eq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("491gh")
]).then(()=>parcelRequire('fpkZJ'));

});

parcelRegister("lFkap", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8SfJg"),
    $Gr8vk("jBH9p")
]).then(()=>parcelRequire('61aWz'));

});

parcelRegister("hGhHY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("czN9E").then(()=>parcelRequire('7yqEc'));

});

parcelRegister("ecjrl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("idlMP").then(()=>parcelRequire('ifEr5'));

});

parcelRegister("f1Brr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ilgHI").then(()=>parcelRequire('gNfQE'));

});

parcelRegister("5mkpS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2TDRK").then(()=>parcelRequire('bmUHI'));

});

parcelRegister("e47uI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("884bS").then(()=>parcelRequire('949ch'));

});

parcelRegister("8t4Vw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2jyg4").then(()=>parcelRequire('26JZ1'));

});

parcelRegister("4KAHp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aHFJA").then(()=>parcelRequire('9aTRg'));

});

parcelRegister("6wxtm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8BLAO").then(()=>parcelRequire('lh24O'));

});

parcelRegister("ehwMF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6cuoJ").then(()=>parcelRequire('49eUS'));

});

parcelRegister("dszWJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("vs85p").then(()=>parcelRequire('lzcA7'));

});

parcelRegister("b8fqO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2G9DO").then(()=>parcelRequire('cBWg9'));

});

parcelRegister("c0Mlr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cpZXQ").then(()=>parcelRequire('bPgP0'));

});

parcelRegister("2VUZA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eoB3R").then(()=>parcelRequire('712Kb'));

});

parcelRegister("esIgq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("519Rx").then(()=>parcelRequire('3yUR5'));

});

parcelRegister("fyN01", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hiouE").then(()=>parcelRequire('4tTYl'));

});

parcelRegister("hAABn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("exais").then(()=>parcelRequire('lJSQB'));

});

parcelRegister("enZ0w", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fhiVa").then(()=>parcelRequire('3pZPD'));

});

parcelRegister("3gOLM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lWd3k").then(()=>parcelRequire('7vQa2'));

});

parcelRegister("XuQsJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("57IcE").then(()=>parcelRequire('a8E8M'));

});

parcelRegister("dMtfy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jA7k5").then(()=>parcelRequire('jobyt'));

});

parcelRegister("iN8Sl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6EsIk").then(()=>parcelRequire('gF4ln'));

});

parcelRegister("iLu4p", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bMJyO").then(()=>parcelRequire('6IFLF'));

});

parcelRegister("ke2WQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cGTiN").then(()=>parcelRequire('k1Vyi'));

});

parcelRegister("7N5TK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("llkac").then(()=>parcelRequire('1sZeE'));

});

parcelRegister("fpp9N", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6hDzL").then(()=>parcelRequire('73diT'));

});

parcelRegister("fYvT3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("d8gEV").then(()=>parcelRequire('i85Gm'));

});

parcelRegister("6il5b", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("33jGh").then(()=>parcelRequire('hZbUO'));

});

parcelRegister("4u0z7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hmVy6").then(()=>parcelRequire('klQOR'));

});

parcelRegister("iiceA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hpQwu").then(()=>parcelRequire('h2m8w'));

});

parcelRegister("jt3Da", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kWLeI").then(()=>parcelRequire('ftUKh'));

});

parcelRegister("6b0FC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("agGio").then(()=>parcelRequire('dIR8D'));

});

parcelRegister("f1ccV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aa6RJ").then(()=>parcelRequire('5IEAM'));

});

parcelRegister("d1ae7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("d4TK7").then(()=>parcelRequire('kJaJa'));

});

parcelRegister("2Chaq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("d4TK7"),
    $Gr8vk("jUszp")
]).then(()=>parcelRequire('28GSw'));

});

parcelRegister("5D9Bt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("jUszp"),
    $Gr8vk("d4TK7"),
    $Gr8vk("8m9zE")
]).then(()=>parcelRequire('bDLzu'));

});

parcelRegister("dkkPE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("d4TK7"),
    $Gr8vk("5sYR6")
]).then(()=>parcelRequire('cJR35'));

});

parcelRegister("i67Ss", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4EGA8").then(()=>parcelRequire('drgA8'));

});

parcelRegister("6JsXR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("4EGA8"),
    $Gr8vk("jHEeI")
]).then(()=>parcelRequire('jYDii'));

});

parcelRegister("hxB2c", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("4EGA8"),
    $Gr8vk("dyqQe")
]).then(()=>parcelRequire('75rHT'));

});

parcelRegister("kIUSS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lxZ4v").then(()=>parcelRequire('5tUUr'));

});

parcelRegister("7jkRh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("4EGA8"),
    $Gr8vk("8YgNy")
]).then(()=>parcelRequire('grJFj'));

});

parcelRegister("8Vyn3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4L1Wq").then(()=>parcelRequire('b7tX1'));

});

parcelRegister("e69oD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bkJu7").then(()=>parcelRequire('a0fX9'));

});

parcelRegister("2s8QP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a1ghY").then(()=>parcelRequire('cnJZ0'));

});

parcelRegister("f2OTJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1s6pP").then(()=>parcelRequire('gOKkW'));

});

parcelRegister("ijSuv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jdPQC").then(()=>parcelRequire('1KCxC'));

});

parcelRegister("6Jkf2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4rupd").then(()=>parcelRequire('i9xKD'));

});

parcelRegister("c0HjZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3DMdr").then(()=>parcelRequire('a5K0A'));

});

parcelRegister("fto03", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7bOf2").then(()=>parcelRequire('8Px1E'));

});

parcelRegister("dwUmZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("90bzF").then(()=>parcelRequire('gRbhY'));

});

parcelRegister("eeoTv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9xJas").then(()=>parcelRequire('ht8AR'));

});

parcelRegister("jqjNF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1oDfk").then(()=>parcelRequire('iO5PP'));

});

parcelRegister("j6MWI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4n7UI").then(()=>parcelRequire('9dJ9U'));

});

parcelRegister("db9od", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2PMxh").then(()=>parcelRequire('1AivI'));

});

parcelRegister("kAjTu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7Ex3c").then(()=>parcelRequire('e4pzc'));

});

parcelRegister("3qDwX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8cwj2").then(()=>parcelRequire('fMc22'));

});

parcelRegister("h06oE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6ZWg4").then(()=>parcelRequire('hH8LA'));

});

parcelRegister("53Q4Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jh6ZA").then(()=>parcelRequire('kklbE'));

});

parcelRegister("86HLF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b21GP").then(()=>parcelRequire('GL1ct'));

});

parcelRegister("kyilV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9hieY").then(()=>parcelRequire('iqZep'));

});

parcelRegister("czi3M", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9fW0K").then(()=>parcelRequire('6KznR'));

});

parcelRegister("av9nT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4tVoE").then(()=>parcelRequire('3x13z'));

});

parcelRegister("kwyIT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kyOfl").then(()=>parcelRequire('jc77V'));

});

parcelRegister("4OfIF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k7bCY").then(()=>parcelRequire('bGS9a'));

});

parcelRegister("fX9QM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("agNg5").then(()=>parcelRequire('80jfC'));

});

parcelRegister("40glH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8261Z").then(()=>parcelRequire('8rgWk'));

});

parcelRegister("9enj5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gygFy").then(()=>parcelRequire('a0Dee'));

});

parcelRegister("8Ptja", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l7e0j").then(()=>parcelRequire('1FSYa'));

});

parcelRegister("dxkZi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fw2kg").then(()=>parcelRequire('4RWcD'));

});

parcelRegister("794ZU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kYn1C").then(()=>parcelRequire('7Oovy'));

});

parcelRegister("2sEun", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3VPYK").then(()=>parcelRequire('g0W0X'));

});

parcelRegister("4l6BW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bJz4P").then(()=>parcelRequire('iipfk'));

});

parcelRegister("femYi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ei4jq").then(()=>parcelRequire('je45L'));

});

parcelRegister("9XIPO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8bpFf").then(()=>parcelRequire('2FHlO'));

});

parcelRegister("i7qJX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aWnGR").then(()=>parcelRequire('9PIxA'));

});

parcelRegister("81Q7D", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hB9tq").then(()=>parcelRequire('k8typ'));

});

parcelRegister("fWA3D", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("rfxSh"),
    $Gr8vk("hfrBF")
]).then(()=>parcelRequire('axMVm'));

});

parcelRegister("a5Xrf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("rfxSh").then(()=>parcelRequire('3Qgue'));

});

parcelRegister("gHsAW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c0i2v").then(()=>parcelRequire('5gslH'));

});

parcelRegister("inrIf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3AP8a").then(()=>parcelRequire('59RMj'));

});

parcelRegister("gz3fj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("49pRz").then(()=>parcelRequire('dTorj'));

});

parcelRegister("aFazs", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9m4RU").then(()=>parcelRequire('17q2l'));

});

parcelRegister("81CT2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bPcWF").then(()=>parcelRequire('ju4yV'));

});

parcelRegister("9kM9O", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a5FFd").then(()=>parcelRequire('ZpsEz'));

});

parcelRegister("dBXFL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1hvXf").then(()=>parcelRequire('8VBOs'));

});

parcelRegister("czUC7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("89lE4").then(()=>parcelRequire('1XVe0'));

});

parcelRegister("hdpT4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dRqjk").then(()=>parcelRequire('gOGJ9'));

});

parcelRegister("gdjz7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aVsql").then(()=>parcelRequire('9V1ct'));

});

parcelRegister("5I9Pd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cWPQt").then(()=>parcelRequire('gHgFe'));

});

parcelRegister("32iVS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("76jL4").then(()=>parcelRequire('bmmCQ'));

});

parcelRegister("gNtYp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e45v5").then(()=>parcelRequire('aLss3'));

});

parcelRegister("57mVy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8vbJq").then(()=>parcelRequire('bYxEL'));

});

parcelRegister("k670C", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kS64H").then(()=>parcelRequire('kBlCn'));

});

parcelRegister("9ImVv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9GimB").then(()=>parcelRequire('bUhAq'));

});

parcelRegister("cbGwP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7tTBk").then(()=>parcelRequire('dAbbZ'));

});

parcelRegister("y3imB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gY8pL").then(()=>parcelRequire('6zUZZ'));

});

parcelRegister("eTCd4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4PCLG").then(()=>parcelRequire('iOvKh'));

});

parcelRegister("6N3Ji", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("33sru").then(()=>parcelRequire('9C1RW'));

});

parcelRegister("jF06K", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("it3T9").then(()=>parcelRequire('ebM8O'));

});

parcelRegister("hPWjF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b1peH").then(()=>parcelRequire('k3ezQ'));

});

parcelRegister("4ytPz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eIYq1").then(()=>parcelRequire('bPTFq'));

});

parcelRegister("ctf1j", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("d9B2D").then(()=>parcelRequire('zgR0q'));

});

parcelRegister("brPrG", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("22T1D").then(()=>parcelRequire('d3Qy7'));

});

parcelRegister("dw0hO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3WQ8a").then(()=>parcelRequire('izyFv'));

});

parcelRegister("h1LFU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("44xhE").then(()=>parcelRequire('iH83F'));

});

parcelRegister("jLrWq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fFA5O").then(()=>parcelRequire('duW6w'));

});

parcelRegister("3VJOv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("byksU").then(()=>parcelRequire('esS8A'));

});

parcelRegister("kga4n", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hURoS").then(()=>parcelRequire('eGdqK'));

});

parcelRegister("geMf1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9AXx7").then(()=>parcelRequire('2aZ05'));

});

parcelRegister("hkQ91", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ap1HX").then(()=>parcelRequire('cwxHh'));

});

parcelRegister("6UHsZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bn8nz").then(()=>parcelRequire('5KM5G'));

});

parcelRegister("3YyFx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gKJnj").then(()=>parcelRequire('bs4vv'));

});

parcelRegister("5D8zV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6JCNh").then(()=>parcelRequire('ktU7n'));

});

parcelRegister("aUvyc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9T8Sa").then(()=>parcelRequire('2kV4L'));

});

parcelRegister("hEYow", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2Dx79").then(()=>parcelRequire('gYSkz'));

});

parcelRegister("aD1BJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f5SbO").then(()=>parcelRequire('iSSKU'));

});

parcelRegister("g9Hzv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jl9UC").then(()=>parcelRequire('9TACc'));

});

parcelRegister("kHQlW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gnjtH").then(()=>parcelRequire('eWTZ4'));

});

parcelRegister("jC4L9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jwDBn").then(()=>parcelRequire('laW5M'));

});

parcelRegister("gQw3Y", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("47ntL").then(()=>parcelRequire('jFTBy'));

});

parcelRegister("dq8dP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jE6kW").then(()=>parcelRequire('5jb3z'));

});

parcelRegister("kVPBR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7YHIB").then(()=>parcelRequire('R9Txn'));

});

parcelRegister("9WcLS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("35ocU").then(()=>parcelRequire('ihlMD'));

});

parcelRegister("hQeHW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("H4Eoj").then(()=>parcelRequire('8IpUh'));

});

parcelRegister("a3spf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("98kli").then(()=>parcelRequire('6wdsl'));

});

parcelRegister("e16da", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iyHSn").then(()=>parcelRequire('jGuAa'));

});

parcelRegister("twpKt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1R9Fz").then(()=>parcelRequire('8cvu4'));

});

parcelRegister("ecPl4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5QIv7").then(()=>parcelRequire('2Cq9S'));

});

parcelRegister("kzqda", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fzlnd").then(()=>parcelRequire('79RWH'));

});

parcelRegister("4os5X", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k69Wn").then(()=>parcelRequire('2avrs'));

});

parcelRegister("fLjM7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bZegj").then(()=>parcelRequire('2yrFa'));

});

parcelRegister("1hjaA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2m3Ih").then(()=>parcelRequire('bQ3jr'));

});

parcelRegister("6QRZT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1eaae").then(()=>parcelRequire('lpJB4'));

});

parcelRegister("6XgAN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aJT6w").then(()=>parcelRequire('cNraW'));

});

parcelRegister("ky93O", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eyUqW").then(()=>parcelRequire('4N5kr'));

});

parcelRegister("a4kNm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8DjpP").then(()=>parcelRequire('eSIWM'));

});

parcelRegister("2HcKb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("26kXj").then(()=>parcelRequire('gWSP0'));

});

parcelRegister("l4jJW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7cn6g").then(()=>parcelRequire('4Pgxe'));

});

parcelRegister("eABHF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cmbjR").then(()=>parcelRequire('8MKEN'));

});

parcelRegister("3Lr8W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5NDXW").then(()=>parcelRequire('4ytiL'));

});

parcelRegister("9FQ85", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8DagP").then(()=>parcelRequire('gyuQT'));

});

parcelRegister("hJgnD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a7PjJ").then(()=>parcelRequire('kKNyy'));

});

parcelRegister("7fOHH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6ursU").then(()=>parcelRequire('eRFLa'));

});

parcelRegister("8khjq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h2i28").then(()=>parcelRequire('4cQoK'));

});

parcelRegister("3nTKm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7oBJy").then(()=>parcelRequire('dh6ab'));

});

parcelRegister("e6FUt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1eko0").then(()=>parcelRequire('6cE9P'));

});

parcelRegister("g1dVE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jEacK").then(()=>parcelRequire('2I9k1'));

});

parcelRegister("6IAGY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4whGs").then(()=>parcelRequire('3JkTI'));

});

parcelRegister("eo5ni", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("HCldz").then(()=>parcelRequire('2tKg9'));

});

parcelRegister("4XCJm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l10eK").then(()=>parcelRequire('j8HXy'));

});

parcelRegister("bPucJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k21xK").then(()=>parcelRequire('7HOPR'));

});

parcelRegister("6PzQn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("52uLx").then(()=>parcelRequire('dKIto'));

});

parcelRegister("daajt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8NsSO").then(()=>parcelRequire('9Me5B'));

});

parcelRegister("luSsW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("82aue").then(()=>parcelRequire('7R6m0'));

});

parcelRegister("jfTS4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7DcTB").then(()=>parcelRequire('eNKIv'));

});

parcelRegister("9QskI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dsETa").then(()=>parcelRequire('hZ3HY'));

});

parcelRegister("hXslA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kH6CG").then(()=>parcelRequire('83BGG'));

});

parcelRegister("i4BXV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k6D3a").then(()=>parcelRequire('8sdnF'));

});

parcelRegister("jE45n", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eeZ2y").then(()=>parcelRequire('hlNqp'));

});

parcelRegister("iOltd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jTmUr").then(()=>parcelRequire('i50A0'));

});

parcelRegister("dTa8C", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iXwud").then(()=>parcelRequire('i5tW5'));

});

parcelRegister("ews1n", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("X2zo2").then(()=>parcelRequire('ajstn'));

});

parcelRegister("4SRDZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1M7TX").then(()=>parcelRequire('dRo5p'));

});

parcelRegister("jm0Ta", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hte1i").then(()=>parcelRequire('3u1HI'));

});

parcelRegister("gy1Yt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Efkt").then(()=>parcelRequire('1Snp6'));

});

parcelRegister("cWI9Z", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b4jLH").then(()=>parcelRequire('k4UEy'));

});

parcelRegister("4lmJS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aUPeh").then(()=>parcelRequire('dzrP5'));

});

parcelRegister("7ivOI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1TWu4").then(()=>parcelRequire('iVYHj'));

});

parcelRegister("ilxvY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lORyF").then(()=>parcelRequire('9FkkO'));

});

parcelRegister("34yKd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("141vB").then(()=>parcelRequire('eGbQv'));

});

parcelRegister("irkdw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("FOU3Z").then(()=>parcelRequire('7bUfa'));

});

parcelRegister("1utEi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7C0ik").then(()=>parcelRequire('ltbTD'));

});

parcelRegister("ikb1l", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4NpOt").then(()=>parcelRequire('7xfio'));

});

parcelRegister("8p4Sm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iluJU").then(()=>parcelRequire('jMvSn'));

});

parcelRegister("jioSw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iAwnt").then(()=>parcelRequire('fwOgD'));

});

parcelRegister("dA5ha", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1nwIe").then(()=>parcelRequire('568WH'));

});

parcelRegister("b1aP2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4FkPB").then(()=>parcelRequire('lOE0A'));

});

parcelRegister("iWjqB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4L6xS").then(()=>parcelRequire('dP4CL'));

});

parcelRegister("ctZD9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5dYWe").then(()=>parcelRequire('bWdH8'));

});

parcelRegister("4USDD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kQZOl").then(()=>parcelRequire('e1fTP'));

});

parcelRegister("7tFHb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aoN05").then(()=>parcelRequire('iG8xA'));

});

parcelRegister("iIEY2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("erQkS").then(()=>parcelRequire('gyBfq'));

});

parcelRegister("8EbKR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lg6LG").then(()=>parcelRequire('7kF51'));

});

parcelRegister("kgJih", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ccFGR").then(()=>parcelRequire('cvoTY'));

});

parcelRegister("bXqFN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2RezH").then(()=>parcelRequire('iR1LA'));

});

parcelRegister("9AmYx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cYfTI").then(()=>parcelRequire('24r66'));

});

parcelRegister("bz2HH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6iiCX").then(()=>parcelRequire('4mY0S'));

});

parcelRegister("kSp4L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lpTtX").then(()=>parcelRequire('8FnLy'));

});

parcelRegister("ermWF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ehwmM").then(()=>parcelRequire('aGlHu'));

});

parcelRegister("16qVb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4fPW1").then(()=>parcelRequire('hIMmh'));

});

parcelRegister("bflIU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iNEVY").then(()=>parcelRequire('6jhWX'));

});

parcelRegister("9vrZ3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3HQNF").then(()=>parcelRequire('a7wfn'));

});

parcelRegister("l9ClQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8viuS").then(()=>parcelRequire('9TwRk'));

});

parcelRegister("e2YNX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kUhiW").then(()=>parcelRequire('eyDjM'));

});

parcelRegister("cY8J4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9Ntvl").then(()=>parcelRequire('dd7z8'));

});

parcelRegister("ip4De", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9Y0c0").then(()=>parcelRequire('UezvM'));

});

parcelRegister("LnJ0d", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cuDum").then(()=>parcelRequire('8L2Io'));

});

parcelRegister("fTMp8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("685sr").then(()=>parcelRequire('fSG02'));

});

parcelRegister("biZpv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cLm8U").then(()=>parcelRequire('ikXPj'));

});

parcelRegister("1Cz0I", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("IZk8T").then(()=>parcelRequire('3bweI'));

});

parcelRegister("7JEJh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l9GgF").then(()=>parcelRequire('4yHjL'));

});

parcelRegister("c3q5C", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("BgPQR").then(()=>parcelRequire('2hxUH'));

});

parcelRegister("3PuNt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jp1Bj").then(()=>parcelRequire('g9cxk'));

});

parcelRegister("i1GqN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("RGWSK").then(()=>parcelRequire('l1wwQ'));

});

parcelRegister("1wn2Z", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("86dtC").then(()=>parcelRequire('iLLxv'));

});

parcelRegister("kpOnN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4LK9P").then(()=>parcelRequire('9be9G'));

});

parcelRegister("9YxWr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h90rj").then(()=>parcelRequire('cZloi'));

});

parcelRegister("2L05j", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gz5HX").then(()=>parcelRequire('MMdt1'));

});

parcelRegister("9cGIo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lVvTT").then(()=>parcelRequire('dMGlf'));

});

parcelRegister("gYzgi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l8fiQ").then(()=>parcelRequire('kRaIZ'));

});

parcelRegister("a1z0r", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5iRNI").then(()=>parcelRequire('c1NGQ'));

});

parcelRegister("akqd8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3kk10").then(()=>parcelRequire('azveh'));

});

parcelRegister("lmwhb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cUIEV").then(()=>parcelRequire('kKD9x'));

});

parcelRegister("iA20J", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6jaie").then(()=>parcelRequire('8zsl4'));

});

parcelRegister("5vQbe", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2govi").then(()=>parcelRequire('66C0x'));

});

parcelRegister("dNBTi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c8BUx").then(()=>parcelRequire('1TyNQ'));

});

parcelRegister("cDTrs", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f3ued").then(()=>parcelRequire('9VX2Q'));

});

parcelRegister("fohpc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lDAI3").then(()=>parcelRequire('d3LNh'));

});

parcelRegister("c0gTv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4T1Sf").then(()=>parcelRequire('575q2'));

});

parcelRegister("lelqp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bnHla").then(()=>parcelRequire('88Dg0'));

});

parcelRegister("flhwv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8aU36").then(()=>parcelRequire('aW2an'));

});

parcelRegister("hx45m", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1WCxr").then(()=>parcelRequire('5A6DF'));

});

parcelRegister("8F6CO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("faTZD").then(()=>parcelRequire('eH2Xd'));

});

parcelRegister("lVPSw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bU1ts").then(()=>parcelRequire('eEO5X'));

});

parcelRegister("iFrQU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lFruU").then(()=>parcelRequire('5Wb0G'));

});

parcelRegister("l1TOG", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8aXN3").then(()=>parcelRequire('kUJDl'));

});

parcelRegister("8h0To", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2XcTB").then(()=>parcelRequire('isTp2'));

});

parcelRegister("26eUK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8tEOF").then(()=>parcelRequire('az5l4'));

});

parcelRegister("67z9p", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5aRBW").then(()=>parcelRequire('iLV2b'));

});

parcelRegister("2T6mL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kOgN1").then(()=>parcelRequire('4wSII'));

});

parcelRegister("j11JM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jWwfy").then(()=>parcelRequire('it57b'));

});

parcelRegister("lfWli", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gFDb6").then(()=>parcelRequire('kBjZr'));

});

parcelRegister("gB60T", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("70z38").then(()=>parcelRequire('iZXYV'));

});

parcelRegister("7vWLc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aktgP").then(()=>parcelRequire('bVNpX'));

});

parcelRegister("c1Vod", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3WnZS").then(()=>parcelRequire('aMVpY'));

});

parcelRegister("gifPQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jYzmO").then(()=>parcelRequire('cr36s'));

});

parcelRegister("3Hb18", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6uhsK").then(()=>parcelRequire('36PZF'));

});

parcelRegister("cpZen", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aV79j").then(()=>parcelRequire('jLkaB'));

});

parcelRegister("8vsH2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("BaONE").then(()=>parcelRequire('ghipu'));

});

parcelRegister("2RSD6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("deBU5").then(()=>parcelRequire('PPLnN'));

});

parcelRegister("7cHpW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9eTKF").then(()=>parcelRequire('faRkL'));

});

parcelRegister("3w3j0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bAm30").then(()=>parcelRequire('efil7'));

});

parcelRegister("i7rh7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("89AO5").then(()=>parcelRequire('kMtIZ'));

});

parcelRegister("kBk1I", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fpwbr").then(()=>parcelRequire('8D696'));

});

parcelRegister("g4ouS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5ENhO").then(()=>parcelRequire('hIXtS'));

});

parcelRegister("5VEoF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9712J").then(()=>parcelRequire('7dE1H'));

});

parcelRegister("2BzDK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bL1Mn").then(()=>parcelRequire('s9RXZ'));

});

parcelRegister("jlWyi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gJQ6R").then(()=>parcelRequire('a3bir'));

});

parcelRegister("a4EKO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dMHRu").then(()=>parcelRequire('kqDvw'));

});

parcelRegister("5EbdE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h91yQ").then(()=>parcelRequire('goH6N'));

});

parcelRegister("4QHH2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1kQNY").then(()=>parcelRequire('yh3Pu'));

});

parcelRegister("dd7Dx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fstH9").then(()=>parcelRequire('jjP5r'));

});

parcelRegister("9Jdkm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5CR2n").then(()=>parcelRequire('ejNWz'));

});

parcelRegister("2tzFk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iWlrr").then(()=>parcelRequire('crEll'));

});

parcelRegister("dKccj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4jzfQ").then(()=>parcelRequire('6CtoM'));

});

parcelRegister("lcr5m", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hLZRF").then(()=>parcelRequire('i55c2'));

});

parcelRegister("89zow", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Kntp").then(()=>parcelRequire('8QDeQ'));

});

parcelRegister("91xA2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aIXNN").then(()=>parcelRequire('a5Dti'));

});

parcelRegister("b0CuE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fRWOR").then(()=>parcelRequire('cV9qX'));

});

parcelRegister("a19p8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ad7wQ").then(()=>parcelRequire('aupA2'));

});

parcelRegister("1cbgl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("evViX").then(()=>parcelRequire('hWtKo'));

});

parcelRegister("3BBWi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4y5up").then(()=>parcelRequire('dbXO4'));

});

parcelRegister("5kNVB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hms7v").then(()=>parcelRequire('kCbH2'));

});

parcelRegister("5NYsi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4asth").then(()=>parcelRequire('2mguj'));

});

parcelRegister("cjwap", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a2rkg").then(()=>parcelRequire('93hr9'));

});

parcelRegister("5eluQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kKCzl").then(()=>parcelRequire('7YMfL'));

});

parcelRegister("lIrdf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("037iD").then(()=>parcelRequire('bHixa'));

});

parcelRegister("kld7Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("47xam").then(()=>parcelRequire('6TaVx'));

});

parcelRegister("407zZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Q1y5").then(()=>parcelRequire('bOf5w'));

});

parcelRegister("j9OS8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9hYLW").then(()=>parcelRequire('8dJQz'));

});

parcelRegister("1F4pR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iyFXH").then(()=>parcelRequire('fZhS0'));

});

parcelRegister("iB5Y1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bZzjB").then(()=>parcelRequire('fzETq'));

});

parcelRegister("cU2bk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4iIBY").then(()=>parcelRequire('1TY43'));

});

parcelRegister("2HO0D", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7vyuz").then(()=>parcelRequire('fjnUL'));

});

parcelRegister("jIO7M", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("axklB").then(()=>parcelRequire('9XlB5'));

});

parcelRegister("4oWsZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3CpXH").then(()=>parcelRequire('1rmnk'));

});

parcelRegister("9V57f", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3pwuH").then(()=>parcelRequire('9gdTE'));

});

parcelRegister("8NufO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ir7SO").then(()=>parcelRequire('aRYC4'));

});

parcelRegister("6zPJI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l8nBw").then(()=>parcelRequire('52JgE'));

});

parcelRegister("8maqR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k6Itm").then(()=>parcelRequire('bMdtb'));

});

parcelRegister("6e2gF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1uxPA").then(()=>parcelRequire('e5djS'));

});

parcelRegister("fOZA4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ilqC9").then(()=>parcelRequire('i29Cl'));

});

parcelRegister("3hPIE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ciMw4").then(()=>parcelRequire('kZ8bL'));

});

parcelRegister("j7Kqh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("MA3In").then(()=>parcelRequire('mJxgY'));

});

parcelRegister("hCu0U", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6mNjE").then(()=>parcelRequire('jZELb'));

});

parcelRegister("3wqQv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1FN9J").then(()=>parcelRequire('jqybh'));

});

parcelRegister("3nFN3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4OBND").then(()=>parcelRequire('2g7r6'));

});

parcelRegister("4UkVF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bpsyS").then(()=>parcelRequire('gQixp'));

});

parcelRegister("1Z7b3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a3Ruu").then(()=>parcelRequire('fuhaZ'));

});

parcelRegister("3TKik", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9mkMu").then(()=>parcelRequire('eJXQ4'));

});

parcelRegister("khqp8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6zBF5").then(()=>parcelRequire('iTFYy'));

});

parcelRegister("cqHHa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gZzT0").then(()=>parcelRequire('aSnUC'));

});

parcelRegister("itmYM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9MpHx").then(()=>parcelRequire('73par'));

});

parcelRegister("ldHYV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("76ND7").then(()=>parcelRequire('8GP4B'));

});

parcelRegister("2V6Gn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("j9XDt").then(()=>parcelRequire('d7AWc'));

});

parcelRegister("eFJFv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7lAgJ").then(()=>parcelRequire('3SO6v'));

});

parcelRegister("kNRTk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cU3Eu").then(()=>parcelRequire('1ci5e'));

});

parcelRegister("db9xF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fatry").then(()=>parcelRequire('1wzQD'));

});

parcelRegister("ckfdB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ezZOp").then(()=>parcelRequire('37eSJ'));

});

parcelRegister("ek6PV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8Qdot").then(()=>parcelRequire('ewOZ2'));

});

parcelRegister("60zre", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gOz0l").then(()=>parcelRequire('2k9vE'));

});

parcelRegister("9fv8i", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("JCywv").then(()=>parcelRequire('3HOqe'));

});

parcelRegister("aH0Lg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4j9Pf").then(()=>parcelRequire('iuzE1'));

});

parcelRegister("g4U8W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("itpuN").then(()=>parcelRequire('kW5hD'));

});

parcelRegister("ai4n0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9FoYg").then(()=>parcelRequire('iJXDw'));

});

parcelRegister("5xhXM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5mNJ6").then(()=>parcelRequire('ctDsM'));

});

parcelRegister("gNZb6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kUo4Q").then(()=>parcelRequire('lriTE'));

});

parcelRegister("irmmb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4d2UA").then(()=>parcelRequire('dTan5'));

});

parcelRegister("2rE8X", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jX3tn").then(()=>parcelRequire('gW96p'));

});

parcelRegister("4EY6d", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4Gcgx").then(()=>parcelRequire('6AFWB'));

});

parcelRegister("gb8I0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9d69B").then(()=>parcelRequire('cJhMR'));

});

parcelRegister("lGgwA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cDMom").then(()=>parcelRequire('6gdIb'));

});

parcelRegister("kmyME", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hSXpG").then(()=>parcelRequire('8s4aG'));

});

parcelRegister("7lxbD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5KDf2").then(()=>parcelRequire('9BfN5'));

});

parcelRegister("fBGA6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5Y60z").then(()=>parcelRequire('3KJmw'));

});

parcelRegister("gDcQE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("inPsH").then(()=>parcelRequire('264GM'));

});

parcelRegister("3Q2zx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aFtzw").then(()=>parcelRequire('lN38g'));

});

parcelRegister("cl1KU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a6MES").then(()=>parcelRequire('57ymB'));

});

parcelRegister("jFdJY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9KZ9t").then(()=>parcelRequire('8i70u'));

});

parcelRegister("1P9p0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("50kok").then(()=>parcelRequire('lV5Zh'));

});

parcelRegister("hTSUs", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9lUaA").then(()=>parcelRequire('fIfDI'));

});

parcelRegister("dWbXj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8v1wV").then(()=>parcelRequire('kM5PJ'));

});

parcelRegister("gVRgd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("95ORs").then(()=>parcelRequire('85xkg'));

});

parcelRegister("ebM6F", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l0aaK").then(()=>parcelRequire('5xrNp'));

});

parcelRegister("25Scx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kaDjC").then(()=>parcelRequire('5a59S'));

});

parcelRegister("fg7Ai", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fCzX9").then(()=>parcelRequire('39s2P'));

});

parcelRegister("iAohh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2knkc").then(()=>parcelRequire('2BlPs'));

});

parcelRegister("1wgfN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gQDpF").then(()=>parcelRequire('9d5W1'));

});

parcelRegister("drAdX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dRItd").then(()=>parcelRequire('bvmpS'));

});

parcelRegister("2BQS5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3KS83").then(()=>parcelRequire('kc9eL'));

});

parcelRegister("ivUf0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cKahR").then(()=>parcelRequire('dSk8j'));

});

parcelRegister("frMFo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9IZzm").then(()=>parcelRequire('gAIJ4'));

});

parcelRegister("6fZgI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8XbAI").then(()=>parcelRequire('g6H0x'));

});

parcelRegister("bRVog", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iYYP2").then(()=>parcelRequire('lnIIT'));

});

parcelRegister("EvrZk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ik0yG").then(()=>parcelRequire('50Z1W'));

});

parcelRegister("5LzjS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5t8uA").then(()=>parcelRequire('kTMk2'));

});

parcelRegister("1bFpO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ePPzp").then(()=>parcelRequire('kNa70'));

});

parcelRegister("lVp9N", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8yX6u").then(()=>parcelRequire('8jgtY'));

});

parcelRegister("gR4hw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9YoUf").then(()=>parcelRequire('hJJMl'));

});

parcelRegister("30G1i", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1eWLP").then(()=>parcelRequire('5C2v8'));

});

parcelRegister("hh8b6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gmCGG").then(()=>parcelRequire('apG2O'));

});

parcelRegister("WUQKD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("54lzz").then(()=>parcelRequire('bJWXO'));

});

parcelRegister("limqM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b0xCF").then(()=>parcelRequire('aEIxw'));

});

parcelRegister("6TlId", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aMrFH").then(()=>parcelRequire('emVdg'));

});

parcelRegister("3w9Jp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hXl9S").then(()=>parcelRequire('5jmVx'));

});

parcelRegister("5mpD5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jWd1k").then(()=>parcelRequire('7ikoH'));

});

parcelRegister("52de6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3t54e").then(()=>parcelRequire('gEbW9'));

});

parcelRegister("gCXoh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8Z9py").then(()=>parcelRequire('1ccuW'));

});

parcelRegister("hrnuM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("16855").then(()=>parcelRequire('10G5Z'));

});

parcelRegister("8DhAc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kDiT9").then(()=>parcelRequire('51twP'));

});

parcelRegister("fzdmh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("feXhj").then(()=>parcelRequire('hHm5z'));

});

parcelRegister("jOpQ4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iGWdR").then(()=>parcelRequire('kxzzq'));

});

parcelRegister("eHcrM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6gBe8").then(()=>parcelRequire('xzjtm'));

});

parcelRegister("c5buF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("AgCK2").then(()=>parcelRequire('incMq'));

});

parcelRegister("bTvAO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ie9sQ").then(()=>parcelRequire('f3Gjv'));

});

parcelRegister("2Gzn3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kHyvN").then(()=>parcelRequire('2iO9B'));

});

parcelRegister("bu44j", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jN42z").then(()=>parcelRequire('hKEfx'));

});

parcelRegister("4vwKC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("UfcEi").then(()=>parcelRequire('ay4bs'));

});

parcelRegister("ijgre", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4qidt").then(()=>parcelRequire('1Lsv6'));

});

parcelRegister("kCwUd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3RJJm").then(()=>parcelRequire('goits'));

});

parcelRegister("guP4S", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gg8wx").then(()=>parcelRequire('7oyCe'));

});

parcelRegister("aK1yl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kpa32").then(()=>parcelRequire('7pkuv'));

});

parcelRegister("8CEFV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("clILD").then(()=>parcelRequire('6BDr1'));

});

parcelRegister("8fC6L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cxP65").then(()=>parcelRequire('clCW7'));

});

parcelRegister("5InkV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("33Q7J").then(()=>parcelRequire('3VsgC'));

});

parcelRegister("2RF3S", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eLrLN").then(()=>parcelRequire('7DwQW'));

});

parcelRegister("c68pJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jJMB1").then(()=>parcelRequire('56wWL'));

});

parcelRegister("8qX5Z", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("d9mbq").then(()=>parcelRequire('lFnkS'));

});

parcelRegister("1DHpV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1k1Pg").then(()=>parcelRequire('j4FI7'));

});

parcelRegister("golnw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ewfVK").then(()=>parcelRequire('gejYb'));

});

parcelRegister("k4HdW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1yIEA").then(()=>parcelRequire('4DfRz'));

});

parcelRegister("7nq1R", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lXfkJ").then(()=>parcelRequire('9lbst'));

});

parcelRegister("gCEnf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2Uk7Z").then(()=>parcelRequire('kiDtb'));

});

parcelRegister("3LZVv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bzu16").then(()=>parcelRequire('eUVVs'));

});

parcelRegister("37KTL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h1tja").then(()=>parcelRequire('ixymW'));

});

parcelRegister("6zRf7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fKWvW").then(()=>parcelRequire('hzYp5'));

});

parcelRegister("2keJj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kR7G4").then(()=>parcelRequire('5Hodk'));

});

parcelRegister("dkxGM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9HQED").then(()=>parcelRequire('aLV2q'));

});

parcelRegister("3B0vJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eDfdq").then(()=>parcelRequire('hCKQP'));

});

parcelRegister("5IrBl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9nwXI").then(()=>parcelRequire('6wxy8'));

});

parcelRegister("4sVjI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gghWi").then(()=>parcelRequire('31uu7'));

});

parcelRegister("1mqww", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kXPDM").then(()=>parcelRequire('lbRzQ'));

});

parcelRegister("9wnFB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iZ6Ug").then(()=>parcelRequire('cjqZ0'));

});

parcelRegister("69mkb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aC2sG").then(()=>parcelRequire('lhUp9'));

});

parcelRegister("d3olu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iuUfW").then(()=>parcelRequire('6EYQc'));

});

parcelRegister("hUKx7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aHtPI").then(()=>parcelRequire('9KS5K'));

});

parcelRegister("8kStj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1RFu8").then(()=>parcelRequire('20faC'));

});

parcelRegister("9012W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4m1Wq").then(()=>parcelRequire('1LuhC'));

});

parcelRegister("iCHJq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jXdBY").then(()=>parcelRequire('dVCYb'));

});

parcelRegister("tyYcD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bX7gN").then(()=>parcelRequire('3Y6Tx'));

});

parcelRegister("lcWQv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bmfHr").then(()=>parcelRequire('7oUx9'));

});

parcelRegister("bqtaB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bhy2u").then(()=>parcelRequire('bA9tx'));

});

parcelRegister("lp7vt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3r449").then(()=>parcelRequire('ar1kM'));

});

parcelRegister("4BQKS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f0egQ").then(()=>parcelRequire('gVPtV'));

});

parcelRegister("1Oq36", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hDvyY").then(()=>parcelRequire('hVQt2'));

});

parcelRegister("l2efD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("033Eh").then(()=>parcelRequire('eFkVM'));

});

parcelRegister("bqGa9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3mf94").then(()=>parcelRequire('gmrJ1'));

});

parcelRegister("hSLkm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e06bh").then(()=>parcelRequire('ke5X5'));

});

parcelRegister("f63m5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8cPZK").then(()=>parcelRequire('9PlDr'));

});

parcelRegister("3ymkH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3I1Rt").then(()=>parcelRequire('hMeCw'));

});

parcelRegister("kgBG0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("j38yn").then(()=>parcelRequire('kZD9y'));

});

parcelRegister("53xcC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6epfm").then(()=>parcelRequire('fMTBD'));

});

parcelRegister("hyV51", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bceJy").then(()=>parcelRequire('8Qtcc'));

});

parcelRegister("gWLpy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7kfgJ").then(()=>parcelRequire('clT8n'));

});

parcelRegister("cn4dQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9PHOB").then(()=>parcelRequire('57pvg'));

});

parcelRegister("cJSGi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l28rc").then(()=>parcelRequire('7ByVn'));

});

parcelRegister("kCA5q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9Stds").then(()=>parcelRequire('4vk0m'));

});

parcelRegister("iXCA2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k1o9z").then(()=>parcelRequire('eQGww'));

});

parcelRegister("cjqRQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ga695").then(()=>parcelRequire('dsNCU'));

});

parcelRegister("6NpEp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eVqY5").then(()=>parcelRequire('lV00X'));

});

parcelRegister("9bB0S", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("la3hS").then(()=>parcelRequire('95vkk'));

});

parcelRegister("ht2L4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4fgMU").then(()=>parcelRequire('54rvL'));

});

parcelRegister("jTgoK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("agPTg").then(()=>parcelRequire('8238X'));

});

parcelRegister("bgspi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dQm6C").then(()=>parcelRequire('hW7sW'));

});

parcelRegister("1tjXo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aBjDI").then(()=>parcelRequire('ivqTo'));

});

parcelRegister("5b0Z0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("53wy6").then(()=>parcelRequire('7m80W'));

});

parcelRegister("lxnsB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3qmfc").then(()=>parcelRequire('5E8gq'));

});

parcelRegister("3CNwQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9GFAl").then(()=>parcelRequire('6dkO7'));

});

parcelRegister("1XBZb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fZNyF").then(()=>parcelRequire('X1EUP'));

});

parcelRegister("4O6QU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7fqPu").then(()=>parcelRequire('hW8Ux'));

});

parcelRegister("b1KcQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lsGA9").then(()=>parcelRequire('dgqN9'));

});

parcelRegister("7cLqI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("falrB").then(()=>parcelRequire('kERs9'));

});

parcelRegister("i4B91", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3SmbY").then(()=>parcelRequire('9uWGo'));

});

parcelRegister("35MsT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5gYhO").then(()=>parcelRequire('6Hw7W'));

});

parcelRegister("cYoMZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8I4Jp").then(()=>parcelRequire('5KhnX'));

});

parcelRegister("bKDV2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4G909").then(()=>parcelRequire('jdIsz'));

});

parcelRegister("5relS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ayf6C").then(()=>parcelRequire('jOV6R'));

});

parcelRegister("irF7d", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cpY4K").then(()=>parcelRequire('WOXRE'));

});

parcelRegister("fEb7A", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3qB3I").then(()=>parcelRequire('ldEEA'));

});

parcelRegister("luv1u", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("judy5").then(()=>parcelRequire('a57nh'));

});

parcelRegister("6pVQU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1tZEM").then(()=>parcelRequire('hEUw1'));

});

parcelRegister("4wxhF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1OCyF").then(()=>parcelRequire('iBxYs'));

});

parcelRegister("3dpt5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bMztD").then(()=>parcelRequire('k7LaU'));

});

parcelRegister("ey7tz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jaecP").then(()=>parcelRequire('6OrUT'));

});

parcelRegister("6fLty", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("khgds").then(()=>parcelRequire('3WpCo'));

});

parcelRegister("dBN7n", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kSeAX").then(()=>parcelRequire('3VsdB'));

});

parcelRegister("jLoqJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8aNYY").then(()=>parcelRequire('6Oatj'));

});

parcelRegister("1BBqi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("79XwZ").then(()=>parcelRequire('4CRvg'));

});

parcelRegister("cQB36", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bizZ0").then(()=>parcelRequire('9i26z'));

});

parcelRegister("e6iuH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8Eauw").then(()=>parcelRequire('75irR'));

});

parcelRegister("2dpni", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("k3Uxa").then(()=>parcelRequire('5vxDL'));

});

parcelRegister("lConb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dcCoM").then(()=>parcelRequire('7gkJJ'));

});

parcelRegister("6kGdX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4FB2I").then(()=>parcelRequire('kPN7o'));

});

parcelRegister("fbX1q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("amBWR").then(()=>parcelRequire('4NFwA'));

});

parcelRegister("e5ie9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Veh3").then(()=>parcelRequire('cqxS5'));

});

parcelRegister("laGNM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("86lqQ").then(()=>parcelRequire('aBtKp'));

});

parcelRegister("9LU9L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("btwyL").then(()=>parcelRequire('fd5dm'));

});

parcelRegister("4Ay2L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7X75R").then(()=>parcelRequire('lsZvO'));

});

parcelRegister("ltine", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bt780").then(()=>parcelRequire('db6nb'));

});

parcelRegister("9YDGr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ib9Wa").then(()=>parcelRequire('fbE1t'));

});

parcelRegister("7kLV5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l8Dh9").then(()=>parcelRequire('c7wCf'));

});

parcelRegister("dY1d6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ffjOT").then(()=>parcelRequire('bIL6U'));

});

parcelRegister("1UXTd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jynHh").then(()=>parcelRequire('8LF89'));

});

parcelRegister("k86tR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("larCI").then(()=>parcelRequire('iNfNc'));

});

parcelRegister("iBu0g", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eJC8K").then(()=>parcelRequire('k5wsG'));

});

parcelRegister("bq3GA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5708i").then(()=>parcelRequire('hKQIJ'));

});

parcelRegister("8mqKf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bNMym").then(()=>parcelRequire('8TCbl'));

});

parcelRegister("i1SMZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3JXB5").then(()=>parcelRequire('cGrrR'));

});

parcelRegister("48SNF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ee2TR").then(()=>parcelRequire('f4Crh'));

});

parcelRegister("hVMgn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6W7FG").then(()=>parcelRequire('fGUzg'));

});

parcelRegister("fqp2w", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7oGDF").then(()=>parcelRequire('apbZL'));

});

parcelRegister("lDyWk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1FUtj").then(()=>parcelRequire('8yHYn'));

});

parcelRegister("apmFJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("43Edd").then(()=>parcelRequire('k1SpV'));

});

parcelRegister("iW20L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bYUTf").then(()=>parcelRequire('fQxUI'));

});

parcelRegister("2HPoD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6pmYs").then(()=>parcelRequire('7bZz0'));

});

parcelRegister("14IwX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8EytT").then(()=>parcelRequire('ibshV'));

});

parcelRegister("1m2Cu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6V3FR").then(()=>parcelRequire('athTg'));

});

parcelRegister("46yaT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fPkQd").then(()=>parcelRequire('lJc7P'));

});

parcelRegister("duxlN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ioEEf").then(()=>parcelRequire('xpWrk'));

});

parcelRegister("5EWCJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4AeS3").then(()=>parcelRequire('afH56'));

});

parcelRegister("aKY0a", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("apGKJ").then(()=>parcelRequire('2thtH'));

});

parcelRegister("fQDjk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ezqia").then(()=>parcelRequire('lw9Ra'));

});

parcelRegister("K3JOK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hAcV1").then(()=>parcelRequire('iUNkl'));

});

parcelRegister("eCNA3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4OxGK").then(()=>parcelRequire('2qy2O'));

});

parcelRegister("b7dfQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("laHar").then(()=>parcelRequire('1sZI6'));

});



parcelRegister("ka0jw", function(module, exports) {
"use client";
"use strict";
var $ead4fc2a193de7ec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThemeContext = void 0;

const $ead4fc2a193de7ec$var$react_1 = $ead4fc2a193de7ec$var$__importDefault((parcelRequire("acw62")));

var $cSopo = parcelRequire("cSopo");
module.exports.ThemeContext = $ead4fc2a193de7ec$var$react_1.default.createContext({
    initialized: false,
    mode: "light",
    brand: $cSopo.ModernaBrand
});

});

parcelRegister("ef0oA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setColorsForThemeDark = module.exports.setColorsForTheme = void 0;

var $dSStr = parcelRequire("dSStr");
const $a5e2c5f548be5f5b$var$setColorsForTheme = (brandColors)=>{
    return {
        // Brand Tokens:
        "color-current-brand-50": brandColors[`color-brand-50`],
        "color-current-brand-100": brandColors[`color-brand-100`],
        "color-current-brand-200": brandColors[`color-brand-200`],
        "color-current-brand-300": brandColors[`color-brand-300`],
        "color-current-brand-400": brandColors[`color-brand-400`],
        "color-current-brand-500": brandColors[`color-brand-500`],
        "color-current-brand-600": brandColors[`color-brand-600`],
        "color-current-brand-700": brandColors[`color-brand-700`],
        "color-current-brand-800": brandColors[`color-brand-800`],
        "color-current-brand-900": brandColors[`color-brand-900`],
        "color-current-brand-950": brandColors[`color-brand-950`],
        "color-current-brand-secondary-50": brandColors[`color-brand-secondary-50`],
        "color-current-brand-secondary-100": brandColors[`color-brand-secondary-100`],
        "color-current-brand-secondary-200": brandColors[`color-brand-secondary-200`],
        "color-current-brand-secondary-300": brandColors[`color-brand-secondary-300`],
        "color-current-brand-secondary-400": brandColors[`color-brand-secondary-400`],
        "color-current-brand-secondary-500": brandColors[`color-brand-secondary-500`],
        "color-current-brand-secondary-600": brandColors[`color-brand-secondary-600`],
        "color-current-brand-secondary-700": brandColors[`color-brand-secondary-700`],
        "color-current-brand-secondary-800": brandColors[`color-brand-secondary-800`],
        "color-current-brand-secondary-900": brandColors[`color-brand-secondary-900`],
        "color-current-brand-secondary-950": brandColors[`color-brand-secondary-950`],
        // General Tokens:
        // Interactive
        focus: $dSStr.SystemColors["color-system-blue-500"],
        scrim: "#25262733",
        // Control Colors
        "control-enabled": $dSStr.SystemColors["color-system-gray-700"],
        "control-hover": $dSStr.SystemColors["color-system-gray-900"],
        "control-click": $dSStr.SystemColors["color-system-gray-950"],
        "control-disabled": $dSStr.SystemColors["color-system-gray-300"],
        // Surface Neutral
        "surface-neutral-default": $dSStr.SystemColors.white,
        "surface-neutral-secondary": $dSStr.SystemColors["color-system-gray-50"],
        "surface-neutral-tertiary": $dSStr.SystemColors["color-system-gray-100"],
        // Surface Brand
        "surface-brand": brandColors[`color-brand-50`],
        "surface-brand-secondary": brandColors[`color-brand-100`],
        "surface-brand-teriary": brandColors[`color-brand-200`],
        "onSurface-brand-primary": brandColors[`color-brand-700`],
        "onSurface-brand-primary-hover": brandColors[`color-brand-900`],
        "onSurface-brand-primary-click": brandColors[`color-brand-950`],
        // Stroke Neutral
        "stroke-neutral-default": $dSStr.SystemColors["color-system-gray-50"],
        "stroke-neutral-secondary": $dSStr.SystemColors["color-system-gray-100"],
        "stroke-neutral-tertiary": $dSStr.SystemColors["color-system-gray-200"],
        "stroke-neutral-emphasis": $dSStr.SystemColors["color-system-gray-300"],
        // Stroke brand
        "stroke-brand": brandColors[`color-brand-100`],
        "stroke-brand-secondary": brandColors[`color-brand-200`],
        "stroke-brand-tertiary": brandColors[`color-brand-300`],
        "stroke-brand-emphasis": brandColors[`color-brand-600`],
        // Text Colors
        "text-default": $dSStr.SystemColors["color-system-gray-950"],
        "text-secondary": $dSStr.SystemColors["color-system-gray-700"],
        "text-emphasis": brandColors[`color-brand-900`],
        "text-input-default": $dSStr.SystemColors["color-system-gray-900"],
        "text-input-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "text-incidental": $dSStr.SystemColors["color-system-gray-500"],
        "text-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "text-error": $dSStr.SystemColors["color-system-red-700"],
        // Link colors
        "text-link": brandColors[`color-brand-700`],
        "text-link-hover": brandColors[`color-brand-900`],
        "text-link-click": brandColors[`color-brand-950`],
        // Component Tokens:
        // Button
        "button-surface-filled-enabled": brandColors[`color-brand-700`],
        "button-surface-filled-hover": brandColors[`color-brand-900`],
        "button-surface-filled-click": brandColors[`color-brand-950`],
        "button-surface-filled-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "button-surface-filled-secondary-enabled": brandColors["color-brand-secondary-700"],
        "button-surface-filled-secondary-hover": brandColors["color-brand-secondary-900"],
        "button-surface-filled-secondary-click": brandColors["color-brand-secondary-950"],
        "button-onSurface-filled-primary": $dSStr.SystemColors.white,
        "button-onSurface-filled-secondary": $dSStr.SystemColors.white,
        "button-onSurface-filled-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "button-onSurface-outline-enabled": brandColors[`color-brand-700`],
        "button-onSurface-outline-hover": brandColors[`color-brand-900`],
        "button-onSurface-outline-click": brandColors[`color-brand-950`],
        "button-onSurface-outline-secondary-enabled": brandColors["color-brand-secondary-700"],
        "button-onSurface-outline-secondary-hover": brandColors["color-brand-secondary-900"],
        "button-onSurface-outline-secondary-click": brandColors["color-brand-secondary-950"],
        "button-onSurface-outline-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "button-surface-outline-primary": $dSStr.SystemColors.white,
        "button-surface-outline-secondary": $dSStr.SystemColors.white,
        "button-surface-outline-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "button-onSurface-subtle-enabled": brandColors[`color-brand-700`],
        "button-onSurface-subtle-hover": brandColors[`color-brand-900`],
        "button-onSurface-subtle-click": brandColors[`color-brand-950`],
        "button-onSurface-subtle-secondary-enabled": brandColors["color-brand-secondary-700"],
        "button-onSurface-subtle-secondary-hover": brandColors["color-brand-secondary-900"],
        "button-onSurface-subtle-secondary-click": brandColors["color-brand-secondary-950"],
        "button-onSurface-subtle-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "button-surface-critical-enabled": $dSStr.SystemColors["color-system-red-700"],
        "button-surface-critical-hover": $dSStr.SystemColors["color-system-red-900"],
        "button-surface-critical-click": $dSStr.SystemColors["color-system-red-950"],
        "button-surface-critical-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "button-onSurface-critical": $dSStr.SystemColors.white,
        "button-onSurface-critical-disabled": $dSStr.SystemColors["color-system-gray-50"],
        // badge
        "badge-surface-color-neutral": $dSStr.SystemColors["color-system-gray-600"],
        "badge-surface-color-critical": $dSStr.SystemColors["color-system-red-600"],
        "badge-surface-color-warning": $dSStr.SystemColors["color-system-yellow-600"],
        "badge-surface-color-success": $dSStr.SystemColors["color-system-green-600"],
        "badge-surface-color-info": $dSStr.SystemColors["color-system-blue-600"],
        "badge-onSurface": $dSStr.SystemColors.white,
        // chip
        "chip-surface-brand": brandColors["color-brand-50"],
        "chip-surface-neutral": $dSStr.SystemColors["color-system-gray-50"],
        "chip-onSurface-brand": brandColors["color-brand-700"],
        "chip-onSurface-brand-hover": brandColors["color-brand-900"],
        "chip-onSurface-brand-click": brandColors["color-brand-950"],
        "chip-onSurface-neutral": $dSStr.SystemColors["color-system-gray-700"],
        "chip-onSurface-neutral-hover": $dSStr.SystemColors["color-system-gray-900"],
        "chip-onSurface-neutral-click": $dSStr.SystemColors["color-system-gray-950"],
        // Field tokens
        // field components
        "field-surface": $dSStr.SystemColors.white,
        "field-surface-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "field-surface-error": $dSStr.SystemColors["color-system-red-50"],
        "field-surface-highlight": brandColors["color-brand-50"],
        "field-stroke": $dSStr.SystemColors["color-system-gray-300"],
        "field-stroke-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "field-stroke-error": $dSStr.SystemColors["color-system-red-700"],
        "field-onSurface": $dSStr.SystemColors["color-system-gray-700"],
        "field-onSurface-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "field-onSurface-highlight": brandColors["color-brand-700"],
        "field-text-primary": $dSStr.SystemColors["color-system-gray-950"],
        "field-text-label": $dSStr.SystemColors["color-system-gray-700"],
        "field-text-description": $dSStr.SystemColors["color-system-gray-700"],
        "field-text-error": $dSStr.SystemColors["color-system-red-700"],
        "field-text-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "field-text-read-only": $dSStr.SystemColors["color-system-gray-600"],
        // Input
        "input-onSurface": $dSStr.SystemColors.white,
        "input-onSurface-disabled": $dSStr.SystemColors["color-system-gray-200"],
        "input-text": $dSStr.SystemColors["color-system-gray-900"],
        "input-stroke-enabled": $dSStr.SystemColors["color-system-gray-300"],
        "input-surface-enabled": brandColors[`color-brand-700`],
        "input-stroke-hover": $dSStr.SystemColors["color-system-gray-500"],
        "input-surface-hover": brandColors[`color-brand-900`],
        "input-stroke-click": $dSStr.SystemColors["color-system-gray-600"],
        "input-surface-click": brandColors[`color-brand-950`],
        "input-text-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "input-surface-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "input-stroke-disabled": $dSStr.SystemColors["color-system-gray-200"],
        "input-surface-error": $dSStr.SystemColors["color-system-red-700"],
        "input-stroke-error": $dSStr.SystemColors["color-system-red-700"],
        // Feedback
        "feedback-surface-info": $dSStr.SystemColors["color-system-blue-50"],
        "feedback-surface-success": $dSStr.SystemColors["color-system-green-50"],
        "feedback-surface-warning": $dSStr.SystemColors["color-system-yellow-50"],
        "feedback-surface-critical": $dSStr.SystemColors["color-system-red-50"],
        "feedback-onSurface-text": $dSStr.SystemColors["color-system-gray-950"],
        "feedback-onSurface-incidental-info": $dSStr.SystemColors["color-system-blue-500"],
        "feedback-onSurface-incidental-success": $dSStr.SystemColors["color-system-green-500"],
        "feedback-onSurface-incidental-warning": $dSStr.SystemColors["color-system-yellow-500"],
        "feedback-onSurface-incidental-critical": $dSStr.SystemColors["color-system-red-500"],
        "feedback-surface-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "feedback-onSurface-critical": $dSStr.SystemColors["color-system-red-700"],
        "feedback-onSurface-critical-hover": $dSStr.SystemColors["color-system-red-900"],
        "feedback-onSurface-critical-click": $dSStr.SystemColors["color-system-red-950"],
        "feedback-onSurface-warning": $dSStr.SystemColors["color-system-yellow-700"],
        "feedback-onSurface-warning-hover": $dSStr.SystemColors["color-system-yellow-900"],
        "feedback-onSurface-warning-click": $dSStr.SystemColors["color-system-yellow-950"],
        "feedback-onSurface-success": $dSStr.SystemColors["color-system-green-700"],
        "feedback-onSurface-success-hover": $dSStr.SystemColors["color-system-green-900"],
        "feedback-onSurface-success-click": $dSStr.SystemColors["color-system-green-950"],
        "feedback-onSurface-info": $dSStr.SystemColors["color-system-blue-700"],
        "feedback-onSurface-info-hover": $dSStr.SystemColors["color-system-blue-900"],
        "feedback-onSurface-info-click": $dSStr.SystemColors["color-system-blue-950"],
        // Slider
        "slider-onsurface-notselected": $dSStr.SystemColors["color-system-gray-600"],
        "slider-onsurface-selected": brandColors[`color-brand-50`],
        "slider-onsurface-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "slider-surface-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "slider-surface-not-selected": $dSStr.SystemColors["color-system-gray-100"],
        "slider-surface-selected-click": brandColors[`color-brand-950`],
        "slider-surface-selected-enabled": brandColors[`color-brand-700`],
        "slider-surface-selected-hover": brandColors[`color-brand-900`],
        // Switch
        "switch-onsurface-color": $dSStr.SystemColors.white,
        "switch-surface-selected-enabled": brandColors[`color-brand-700`],
        "switch-surface-selected-hover": brandColors[`color-brand-900`],
        "switch-surface-selected-click": brandColors[`color-brand-950`],
        "switch-surface-notselected-enabled": $dSStr.SystemColors["color-system-gray-300"],
        "switch-surface-notselected-hover": $dSStr.SystemColors["color-system-gray-500"],
        "switch-surface-notselected-click": $dSStr.SystemColors["color-system-gray-600"],
        "switch-onsurface-color-disabled": $dSStr.SystemColors["color-system-gray-50"],
        "switch-surface-color-disabled": $dSStr.SystemColors["color-system-gray-200"],
        // Tab
        "tab-text-default": $dSStr.SystemColors["color-system-gray-700"],
        "tab-text-selected": brandColors[`color-brand-700`],
        "tab-stroke-selected": brandColors[`color-brand-700`],
        "tab-stroke-hover": $dSStr.SystemColors["color-system-gray-200"],
        "tab-stroke-click": $dSStr.SystemColors["color-system-gray-700"],
        "tab-text-disabled": $dSStr.SystemColors["color-system-gray-300"],
        // Tooltip
        "tooltip-surface": $dSStr.SystemColors.white
    };
};
module.exports.setColorsForTheme = $a5e2c5f548be5f5b$var$setColorsForTheme;
const $a5e2c5f548be5f5b$var$setColorsForThemeDark = (brandColors)=>{
    return {
        // Brand Tokens:
        "color-current-brand-50": brandColors[`color-brand-50`],
        "color-current-brand-100": brandColors[`color-brand-100`],
        "color-current-brand-200": brandColors[`color-brand-200`],
        "color-current-brand-300": brandColors[`color-brand-300`],
        "color-current-brand-400": brandColors[`color-brand-400`],
        "color-current-brand-500": brandColors[`color-brand-500`],
        "color-current-brand-600": brandColors[`color-brand-600`],
        "color-current-brand-700": brandColors[`color-brand-700`],
        "color-current-brand-800": brandColors[`color-brand-800`],
        "color-current-brand-900": brandColors[`color-brand-900`],
        "color-current-brand-950": brandColors[`color-brand-950`],
        "color-current-brand-secondary-50": brandColors[`color-brand-secondary-50`],
        "color-current-brand-secondary-100": brandColors[`color-brand-secondary-100`],
        "color-current-brand-secondary-200": brandColors[`color-brand-secondary-200`],
        "color-current-brand-secondary-300": brandColors[`color-brand-secondary-300`],
        "color-current-brand-secondary-400": brandColors[`color-brand-secondary-400`],
        "color-current-brand-secondary-500": brandColors[`color-brand-secondary-500`],
        "color-current-brand-secondary-600": brandColors[`color-brand-secondary-600`],
        "color-current-brand-secondary-700": brandColors[`color-brand-secondary-700`],
        "color-current-brand-secondary-800": brandColors[`color-brand-secondary-800`],
        "color-current-brand-secondary-900": brandColors[`color-brand-secondary-900`],
        "color-current-brand-secondary-950": brandColors[`color-brand-secondary-950`],
        // General Tokens:
        // Interactive
        focus: $dSStr.SystemColors["color-system-blue-500"],
        scrim: "#25262733",
        // Control Colors
        "control-enabled": $dSStr.SystemColors["color-system-gray-100"],
        "control-hover": $dSStr.SystemColors["color-system-gray-200"],
        "control-click": $dSStr.SystemColors["color-system-gray-300"],
        "control-disabled": $dSStr.SystemColors["color-system-gray-400"],
        // Surface Neutral
        "surface-neutral-default": $dSStr.SystemColors["color-system-gray-950"],
        "surface-neutral-secondary": $dSStr.SystemColors["color-system-gray-900"],
        "surface-neutral-tertiary": $dSStr.SystemColors["color-system-gray-800"],
        // Surface Brand
        "surface-brand": brandColors[`color-brand-950`],
        "surface-brand-secondary": brandColors[`color-brand-900`],
        "surface-brand-teriary": brandColors[`color-brand-800`],
        "onSurface-brand-primary": brandColors[`color-brand-200`],
        "onSurface-brand-primary-hover": brandColors[`color-brand-300`],
        "onSurface-brand-primary-click": brandColors[`color-brand-400`],
        // Stroke Neutral
        "stroke-neutral-default": $dSStr.SystemColors["color-system-gray-400"],
        "stroke-neutral-secondary": $dSStr.SystemColors["color-system-gray-300"],
        "stroke-neutral-tertiary": $dSStr.SystemColors["color-system-gray-200"],
        "stroke-neutral-emphasis": $dSStr.SystemColors["color-system-gray-100"],
        // Stroke brand
        "stroke-brand": brandColors[`color-brand-400`],
        "stroke-brand-secondary": brandColors[`color-brand-300`],
        "stroke-brand-tertiary": brandColors[`color-brand-200`],
        "stroke-brand-emphasis": brandColors[`color-brand-100`],
        // Text Colors
        "text-default": $dSStr.SystemColors.white,
        "text-secondary": $dSStr.SystemColors["color-system-gray-100"],
        "text-emphasis": brandColors[`color-brand-200`],
        "text-input-default": $dSStr.SystemColors["color-system-gray-900"],
        "text-input-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "text-incidental": $dSStr.SystemColors["color-system-gray-300"],
        "text-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "text-error": $dSStr.SystemColors["color-system-red-300"],
        // Link colors
        "text-link": brandColors[`color-brand-300`],
        "text-link-hover": brandColors[`color-brand-200`],
        "text-link-click": brandColors[`color-brand-100`],
        // Component Tokens:
        // Button
        "button-surface-filled-enabled": brandColors[`color-brand-200`],
        "button-surface-filled-hover": brandColors[`color-brand-300`],
        "button-surface-filled-click": brandColors[`color-brand-400`],
        "button-surface-filled-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "button-surface-filled-secondary-enabled": brandColors["color-brand-secondary-200"],
        "button-surface-filled-secondary-hover": brandColors["color-brand-secondary-300"],
        "button-surface-filled-secondary-click": brandColors["color-brand-secondary-400"],
        "button-onSurface-filled-primary": brandColors["color-brand-950"],
        "button-onSurface-filled-secondary": brandColors["color-brand-secondary-950"],
        "button-onSurface-filled-disabled": $dSStr.SystemColors["color-system-gray-900"],
        "button-onSurface-outline-enabled": brandColors[`color-brand-200`],
        "button-onSurface-outline-hover": brandColors[`color-brand-300`],
        "button-onSurface-outline-click": brandColors[`color-brand-400`],
        "button-onSurface-outline-secondary-enabled": brandColors["color-brand-secondary-200"],
        "button-onSurface-outline-secondary-hover": brandColors["color-brand-secondary-300"],
        "button-onSurface-outline-secondary-click": brandColors["color-brand-secondary-400"],
        "button-onSurface-outline-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "button-surface-outline-primary": brandColors["color-brand-950"],
        "button-surface-outline-secondary": brandColors["color-brand-secondary-950"],
        "button-surface-outline-disabled": $dSStr.SystemColors["color-system-gray-600"],
        "button-onSurface-subtle-enabled": brandColors[`color-brand-200`],
        "button-onSurface-subtle-hover": brandColors[`color-brand-300`],
        "button-onSurface-subtle-click": brandColors[`color-brand-400`],
        "button-onSurface-subtle-secondary-enabled": brandColors["color-brand-secondary-200"],
        "button-onSurface-subtle-secondary-hover": brandColors["color-brand-secondary-300"],
        "button-onSurface-subtle-secondary-click": brandColors["color-brand-secondary-400"],
        "button-onSurface-subtle-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "button-surface-critical-enabled": $dSStr.SystemColors["color-system-red-600"],
        "button-surface-critical-hover": $dSStr.SystemColors["color-system-red-700"],
        "button-surface-critical-click": $dSStr.SystemColors["color-system-red-800"],
        "button-surface-critical-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "button-onSurface-critical": $dSStr.SystemColors.white,
        "button-onSurface-critical-disabled": $dSStr.SystemColors["color-system-gray-900"],
        // badge
        "badge-surface-color-neutral": $dSStr.SystemColors["color-system-gray-300"],
        "badge-surface-color-critical": $dSStr.SystemColors["color-system-red-300"],
        "badge-surface-color-warning": $dSStr.SystemColors["color-system-yellow-300"],
        "badge-surface-color-success": $dSStr.SystemColors["color-system-green-300"],
        "badge-surface-color-info": $dSStr.SystemColors["color-system-blue-300"],
        "badge-onSurface": $dSStr.SystemColors["color-system-gray-950"],
        // chip
        "chip-surface-brand": brandColors["color-brand-200"],
        "chip-surface-neutral": $dSStr.SystemColors["color-system-gray-200"],
        "chip-onSurface-brand": brandColors["color-brand-800"],
        "chip-onSurface-brand-hover": brandColors["color-brand-900"],
        "chip-onSurface-brand-click": brandColors["color-brand-950"],
        "chip-onSurface-neutral": $dSStr.SystemColors["color-system-gray-800"],
        "chip-onSurface-neutral-hover": $dSStr.SystemColors["color-system-gray-900"],
        "chip-onSurface-neutral-click": $dSStr.SystemColors["color-system-gray-950"],
        // Input
        "input-onSurface": $dSStr.SystemColors["color-system-gray-950"],
        "input-onSurface-disabled": $dSStr.SystemColors["color-system-gray-900"],
        "input-text": $dSStr.SystemColors.white,
        "input-text-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "input-surface-enabled": brandColors[`color-brand-200`],
        "input-surface-hover": brandColors[`color-brand-300`],
        "input-surface-click": brandColors[`color-brand-400`],
        "input-surface-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "input-surface-error": $dSStr.SystemColors["color-system-red-400"],
        "input-stroke-enabled": $dSStr.SystemColors["color-system-gray-200"],
        "input-stroke-hover": $dSStr.SystemColors["color-system-gray-300"],
        "input-stroke-click": $dSStr.SystemColors["color-system-gray-400"],
        "input-stroke-disabled": $dSStr.SystemColors["color-system-gray-600"],
        "input-stroke-error": $dSStr.SystemColors["color-system-red-400"],
        // Feedback
        "feedback-surface-info": $dSStr.SystemColors["color-system-blue-200"],
        "feedback-surface-success": $dSStr.SystemColors["color-system-green-200"],
        "feedback-surface-warning": $dSStr.SystemColors["color-system-yellow-200"],
        "feedback-surface-critical": $dSStr.SystemColors["color-system-red-200"],
        "feedback-onSurface-text": $dSStr.SystemColors["color-system-gray-950"],
        "feedback-onSurface-incidental-info": $dSStr.SystemColors["color-system-blue-700"],
        "feedback-onSurface-incidental-success": $dSStr.SystemColors["color-system-green-700"],
        "feedback-onSurface-incidental-warning": $dSStr.SystemColors["color-system-yellow-700"],
        "feedback-onSurface-incidental-critical": $dSStr.SystemColors["color-system-red-700"],
        "feedback-surface-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "feedback-onSurface-critical": $dSStr.SystemColors["color-system-red-800"],
        "feedback-onSurface-critical-hover": $dSStr.SystemColors["color-system-red-900"],
        "feedback-onSurface-critical-click": $dSStr.SystemColors["color-system-red-950"],
        "feedback-onSurface-warning": $dSStr.SystemColors["color-system-yellow-800"],
        "feedback-onSurface-warning-hover": $dSStr.SystemColors["color-system-yellow-900"],
        "feedback-onSurface-warning-click": $dSStr.SystemColors["color-system-yellow-950"],
        "feedback-onSurface-success": $dSStr.SystemColors["color-system-green-800"],
        "feedback-onSurface-success-hover": $dSStr.SystemColors["color-system-green-900"],
        "feedback-onSurface-success-click": $dSStr.SystemColors["color-system-green-950"],
        "feedback-onSurface-info": $dSStr.SystemColors["color-system-blue-800"],
        "feedback-onSurface-info-hover": $dSStr.SystemColors["color-system-blue-900"],
        "feedback-onSurface-info-click": $dSStr.SystemColors["color-system-blue-950"],
        // field components
        "field-surface": $dSStr.SystemColors.white,
        "field-surface-disabled": $dSStr.SystemColors["color-system-gray-200"],
        "field-surface-error": $dSStr.SystemColors["color-system-red-100"],
        "field-surface-highlight": brandColors["color-brand-50"],
        "field-stroke": $dSStr.SystemColors["color-system-gray-300"],
        "field-stroke-disabled": $dSStr.SystemColors["color-system-gray-300"],
        "field-stroke-error": $dSStr.SystemColors["color-system-red-700"],
        "field-onSurface": $dSStr.SystemColors["color-system-gray-700"],
        "field-onSurface-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "field-onSurface-highlight": brandColors["color-brand-700"],
        "field-text-primary": $dSStr.SystemColors["color-system-gray-950"],
        "field-text-label": $dSStr.SystemColors["color-system-gray-700"],
        "field-text-description": $dSStr.SystemColors["color-system-gray-50"],
        "field-text-error": $dSStr.SystemColors["color-system-red-300"],
        "field-text-disabled": $dSStr.SystemColors["color-system-gray-400"],
        "field-text-read-only": $dSStr.SystemColors["color-system-gray-300"],
        // Slider
        "slider-onsurface-notselected": $dSStr.SystemColors["color-system-gray-300"],
        "slider-onsurface-selected": brandColors[`color-brand-900`],
        "slider-onsurface-disabled": $dSStr.SystemColors["color-system-gray-900"],
        "slider-surface-disabled": $dSStr.SystemColors["color-system-gray-600"],
        "slider-surface-not-selected": $dSStr.SystemColors["color-system-gray-700"],
        "slider-surface-selected-click": brandColors[`color-brand-400`],
        "slider-surface-selected-enabled": brandColors[`color-brand-200`],
        "slider-surface-selected-hover": brandColors[`color-brand-300`],
        // Switch
        "switch-onsurface-color": $dSStr.SystemColors["color-system-gray-950"],
        "switch-onsurface-color-disabled": $dSStr.SystemColors["color-system-gray-600"],
        "switch-surface-selected-enabled": brandColors[`color-brand-200`],
        "switch-surface-selected-hover": brandColors[`color-brand-300`],
        "switch-surface-selected-click": brandColors[`color-brand-400`],
        "switch-surface-notselected-enabled": $dSStr.SystemColors["color-system-gray-200"],
        "switch-surface-notselected-hover": $dSStr.SystemColors["color-system-gray-300"],
        "switch-surface-notselected-click": $dSStr.SystemColors["color-system-gray-400"],
        "switch-surface-color-disabled": $dSStr.SystemColors["color-system-gray-400"],
        // Tab
        "tab-text-default": $dSStr.SystemColors["color-system-gray-200"],
        "tab-text-selected": brandColors[`color-brand-200`],
        "tab-stroke-selected": brandColors[`color-brand-200`],
        "tab-stroke-hover": $dSStr.SystemColors["color-system-gray-300"],
        "tab-stroke-click": $dSStr.SystemColors["color-system-gray-400"],
        "tab-text-disabled": $dSStr.SystemColors["color-system-gray-400"],
        // Tooltip
        "tooltip-surface": $dSStr.SystemColors["color-system-gray-700"]
    };
};
module.exports.setColorsForThemeDark = $a5e2c5f548be5f5b$var$setColorsForThemeDark;

});


parcelRegister("kJsBZ", function(module, exports) {
"use client";
"use strict";
var $f17e344e6df5f0a3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f17e344e6df5f0a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ThemeOverride = void 0;

var $8sxjx = parcelRequire("8sxjx");

const $f17e344e6df5f0a3$var$react_1 = $f17e344e6df5f0a3$var$__importDefault((parcelRequire("acw62")));

var $ltnYE = parcelRequire("ltnYE");

var $ka0jw = parcelRequire("ka0jw");
const $f17e344e6df5f0a3$var$ThemeOverride = ({ children: children, mode: mode, themeBrand: themeBrand })=>{
    const _a = $f17e344e6df5f0a3$var$react_1.default.useContext($ka0jw.ThemeContext), { mode: modeInitial, brand: themeBrandInitial } = _a, other = $f17e344e6df5f0a3$var$__rest(_a, [
        "mode",
        "brand"
    ]);
    const modeMerged = mode || modeInitial;
    const brandMerged = themeBrand || themeBrandInitial;
    const theme = $f17e344e6df5f0a3$var$react_1.default.useMemo(()=>{
        return (0, $ltnYE.getTheme)(brandMerged, modeMerged);
    }, [
        brandMerged,
        modeMerged
    ]);
    const themeUIContext = $f17e344e6df5f0a3$var$react_1.default.useContext($8sxjx.__ThemeUIContext);
    return $f17e344e6df5f0a3$var$react_1.default.createElement($ka0jw.ThemeContext.Provider, {
        value: Object.assign(Object.assign({}, other), {
            mode: modeMerged,
            brand: brandMerged
        })
    }, $f17e344e6df5f0a3$var$react_1.default.createElement($8sxjx.__ThemeUIInternalBaseThemeProvider, {
        context: Object.assign(Object.assign({}, themeUIContext), {
            theme: theme
        })
    }, children));
};
module.exports.ThemeOverride = $f17e344e6df5f0a3$var$ThemeOverride;

});

parcelRegister("4LNb4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineHeight = module.exports.LetterSpacing = module.exports.FontWeight = module.exports.FontSize = void 0;

var $4ptlS = parcelRequire("4ptlS");
Object.defineProperty(module.exports, "FontSize", {
    enumerable: true,
    get: function() {
        return $4ptlS.FontSize;
    }
});

var $vKjg3 = parcelRequire("vKjg3");
Object.defineProperty(module.exports, "FontWeight", {
    enumerable: true,
    get: function() {
        return $vKjg3.FontWeight;
    }
});

var $dARKR = parcelRequire("dARKR");
Object.defineProperty(module.exports, "LetterSpacing", {
    enumerable: true,
    get: function() {
        return $dARKR.LetterSpacing;
    }
});

var $engM8 = parcelRequire("engM8");
Object.defineProperty(module.exports, "LineHeight", {
    enumerable: true,
    get: function() {
        return $engM8.LineHeight;
    }
});

});
parcelRegister("4ptlS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FontSize = void 0;
module.exports.FontSize = {
    "font-size-1": "10px",
    "font-size-2": "12px",
    "font-size-3": "14px",
    "font-size-4": "16px",
    "font-size-5": "18px",
    "font-size-6": "20px",
    "font-size-7": "24px",
    "font-size-8": "34px",
    "font-size-9": "48px",
    "font-size-10": "60px",
    "font-size-11": "96px",
    "font-size-12": "128px"
};

});

parcelRegister("vKjg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FontWeight = void 0;
module.exports.FontWeight = {
    "font-weight-light": 300,
    "font-weight-regular": 400,
    "font-weight-medium": 500,
    "font-weight-bold": 700
};

});

parcelRegister("dARKR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LetterSpacing = void 0;
module.exports.LetterSpacing = {
    "kerning-none": 0,
    "kerning-1": 0.15,
    "kerning-2": 0.25,
    "kerning-3": 0.5,
    "kerning-4": 1.25
};

});

parcelRegister("engM8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineHeight = void 0;
module.exports.LineHeight = {
    "leading-none": "1em",
    "leading-1": "1.2em",
    "leading-2": "1.5em"
};

});


parcelRegister("7DMIQ", function(module, exports) {
"use client";
"use strict";
var $5901f82a62ff8f37$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useThemeWithoutTypes = module.exports.useTheme = void 0;

const $5901f82a62ff8f37$var$react_1 = $5901f82a62ff8f37$var$__importDefault((parcelRequire("acw62")));

var $8sxjx = parcelRequire("8sxjx");

var $ka0jw = parcelRequire("ka0jw");
const $5901f82a62ff8f37$var$useTheme = ()=>{
    const { mode: mode } = $5901f82a62ff8f37$var$react_1.default.useContext($ka0jw.ThemeContext);
    return Object.assign(Object.assign({}, (0, $8sxjx.useThemeUI)().theme), {
        mode: mode
    });
};
module.exports.useTheme = $5901f82a62ff8f37$var$useTheme;
const $5901f82a62ff8f37$var$useThemeWithoutTypes = ()=>{
    return (0, $8sxjx.useThemeUI)().theme;
};
module.exports.useThemeWithoutTypes = $5901f82a62ff8f37$var$useThemeWithoutTypes;

});




parcelRegister("eUjE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlagIconName = module.exports.FLAG_ICONS = module.exports.FlagIcon = void 0;

var $5fexU = parcelRequire("5fexU");
Object.defineProperty(module.exports, "FlagIcon", {
    enumerable: true,
    get: function() {
        return $5fexU.FlagIcon;
    }
});

var $10bxS = parcelRequire("10bxS");
Object.defineProperty(module.exports, "FLAG_ICONS", {
    enumerable: true,
    get: function() {
        return $10bxS.FLAG_ICONS;
    }
});
Object.defineProperty(module.exports, "FlagIconName", {
    enumerable: true,
    get: function() {
        return $10bxS.FlagIconName;
    }
});

});
parcelRegister("5fexU", function(module, exports) {
"use client";
"use strict";
var $3d19a2f685bef4cd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3d19a2f685bef4cd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlagIcon = void 0;

const $3d19a2f685bef4cd$var$react_1 = $3d19a2f685bef4cd$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $gz1Qr = parcelRequire("gz1Qr");
const $3d19a2f685bef4cd$var$FlagIcon = (_a)=>{
    var { size: size = "md", sx: sx, flag: flag } = _a, restProps = $3d19a2f685bef4cd$var$__rest(_a, [
        "size",
        "sx",
        "flag"
    ]);
    const { getIconComponent: getIconComponent, cacheIconComponent: cacheIconComponent } = (0, $gz1Qr.useIconCache)();
    const FlagIconVariant = getIconComponent(flag);
    $3d19a2f685bef4cd$var$react_1.default.useEffect(()=>{
        cacheIconComponent(flag, FlagIconVariant);
    }, [
        flag,
        FlagIconVariant,
        cacheIconComponent
    ]);
    // @ts-ignore - for borderRadius values
    const iconStyle = $3d19a2f685bef4cd$var$react_1.default.useMemo(()=>{
        switch(size){
            case "xs":
                return {
                    width: "spacing-5",
                    height: "spacing-4",
                    borderRadius: ".75px"
                };
            case "sm":
                return {
                    width: "spacing-7",
                    height: "spacing-6",
                    borderRadius: "1px"
                };
            case "lg":
                return {
                    width: "spacing-9",
                    height: "spacing-8",
                    borderRadius: "2px"
                };
            case "xl":
                return {
                    width: "spacing-10",
                    height: "spacing-9",
                    borderRadius: "3px"
                };
            default:
                return {
                    width: "spacing-8",
                    height: "spacing-7",
                    borderRadius: "1.5px"
                };
        }
    }, [
        size
    ]);
    return $3d19a2f685bef4cd$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        as: "span",
        sx: Object.assign(Object.assign({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        }, iconStyle), sx)
    }, restProps), $3d19a2f685bef4cd$var$react_1.default.createElement(FlagIconVariant, null));
};
module.exports.FlagIcon = $3d19a2f685bef4cd$var$FlagIcon;

});

parcelRegister("10bxS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FLAG_ICONS = module.exports.FlagIconName = void 0;
var $0baebf39b96911e1$var$FlagIconName;
(function(FlagIconName) {
    FlagIconName["AD"] = "AD";
    FlagIconName["AE"] = "AE";
    FlagIconName["AF"] = "AF";
    FlagIconName["AG"] = "AG";
    FlagIconName["AI"] = "AI";
    FlagIconName["AL"] = "AL";
    FlagIconName["AM"] = "AM";
    FlagIconName["AO"] = "AO";
    FlagIconName["AR"] = "AR";
    FlagIconName["AS"] = "AS";
    FlagIconName["AT"] = "AT";
    FlagIconName["AU"] = "AU";
    FlagIconName["AW"] = "AW";
    FlagIconName["AX"] = "AX";
    FlagIconName["AZ"] = "AZ";
    FlagIconName["BA"] = "BA";
    FlagIconName["BB"] = "BB";
    FlagIconName["BD"] = "BD";
    FlagIconName["BE"] = "BE";
    FlagIconName["BF"] = "BF";
    FlagIconName["BG"] = "BG";
    FlagIconName["BH"] = "BH";
    FlagIconName["BI"] = "BI";
    FlagIconName["BJ"] = "BJ";
    FlagIconName["BL"] = "BL";
    FlagIconName["BM"] = "BM";
    FlagIconName["BN"] = "BN";
    FlagIconName["BO"] = "BO";
    FlagIconName["BR"] = "BR";
    FlagIconName["BS"] = "BS";
    FlagIconName["BT"] = "BT";
    FlagIconName["BV"] = "BV";
    FlagIconName["BW"] = "BW";
    FlagIconName["BY"] = "BY";
    FlagIconName["BZ"] = "BZ";
    FlagIconName["CA"] = "CA";
    FlagIconName["CC"] = "CC";
    FlagIconName["CD"] = "CD";
    FlagIconName["CF"] = "CF";
    FlagIconName["CG"] = "CG";
    FlagIconName["CH"] = "CH";
    FlagIconName["CI"] = "CI";
    FlagIconName["CK"] = "CK";
    FlagIconName["CL"] = "CL";
    FlagIconName["CM"] = "CM";
    FlagIconName["CN"] = "CN";
    FlagIconName["CO"] = "CO";
    FlagIconName["CR"] = "CR";
    FlagIconName["CU"] = "CU";
    FlagIconName["CV"] = "CV";
    FlagIconName["CW"] = "CW";
    FlagIconName["CX"] = "CX";
    FlagIconName["CY"] = "CY";
    FlagIconName["CZ"] = "CZ";
    FlagIconName["DE"] = "DE";
    FlagIconName["DJ"] = "DJ";
    FlagIconName["DK"] = "DK";
    FlagIconName["DM"] = "DM";
    FlagIconName["DO"] = "DO";
    FlagIconName["DZ"] = "DZ";
    FlagIconName["EC"] = "EC";
    FlagIconName["EE"] = "EE";
    FlagIconName["EG"] = "EG";
    FlagIconName["ER"] = "ER";
    FlagIconName["ES"] = "ES";
    FlagIconName["ET"] = "ET";
    FlagIconName["EU"] = "EU";
    FlagIconName["FI"] = "FI";
    FlagIconName["FJ"] = "FJ";
    FlagIconName["FK"] = "FK";
    FlagIconName["FM"] = "FM";
    FlagIconName["FO"] = "FO";
    FlagIconName["FR"] = "FR";
    FlagIconName["GA"] = "GA";
    FlagIconName["GB"] = "GB";
    FlagIconName["GBENG"] = "GB-ENG";
    FlagIconName["GBNIR"] = "GB-NIR";
    FlagIconName["GBSCT"] = "GB-SCT";
    FlagIconName["GBWLS"] = "GB-WLS";
    FlagIconName["GBZET"] = "GB-ZET";
    FlagIconName["GD"] = "GD";
    FlagIconName["GE"] = "GE";
    FlagIconName["GF"] = "GF";
    FlagIconName["GG"] = "GG";
    FlagIconName["GH"] = "GH";
    FlagIconName["GI"] = "GI";
    FlagIconName["GL"] = "GL";
    FlagIconName["GM"] = "GM";
    FlagIconName["GN"] = "GN";
    FlagIconName["GP"] = "GP";
    FlagIconName["GQ"] = "GQ";
    FlagIconName["GR"] = "GR";
    FlagIconName["GS"] = "GS";
    FlagIconName["GT"] = "GT";
    FlagIconName["GU"] = "GU";
    FlagIconName["GW"] = "GW";
    FlagIconName["GY"] = "GY";
    FlagIconName["HK"] = "HK";
    FlagIconName["HM"] = "HM";
    FlagIconName["HN"] = "HN";
    FlagIconName["HR"] = "HR";
    FlagIconName["HT"] = "HT";
    FlagIconName["HU"] = "HU";
    FlagIconName["ID"] = "ID";
    FlagIconName["IE"] = "IE";
    FlagIconName["IL"] = "IL";
    FlagIconName["IM"] = "IM";
    FlagIconName["IN"] = "IN";
    FlagIconName["IO"] = "IO";
    FlagIconName["IQ"] = "IQ";
    FlagIconName["IR"] = "IR";
    FlagIconName["IS"] = "IS";
    FlagIconName["IT"] = "IT";
    FlagIconName["JE"] = "JE";
    FlagIconName["JM"] = "JM";
    FlagIconName["JO"] = "JO";
    FlagIconName["JP"] = "JP";
    FlagIconName["KE"] = "KE";
    FlagIconName["KG"] = "KG";
    FlagIconName["KH"] = "KH";
    FlagIconName["KI"] = "KI";
    FlagIconName["KM"] = "KM";
    FlagIconName["KN"] = "KN";
    FlagIconName["KP"] = "KP";
    FlagIconName["KR"] = "KR";
    FlagIconName["KW"] = "KW";
    FlagIconName["KY"] = "KY";
    FlagIconName["KZ"] = "KZ";
    FlagIconName["LA"] = "LA";
    FlagIconName["LB"] = "LB";
    FlagIconName["LC"] = "LC";
    FlagIconName["LGBT1"] = "LGBT1";
    FlagIconName["LI"] = "LI";
    FlagIconName["LK"] = "LK";
    FlagIconName["LR"] = "LR";
    FlagIconName["LS"] = "LS";
    FlagIconName["LT"] = "LT";
    FlagIconName["LU"] = "LU";
    FlagIconName["LV"] = "LV";
    FlagIconName["LY"] = "LY";
    FlagIconName["MA"] = "MA";
    FlagIconName["MC"] = "MC";
    FlagIconName["MD"] = "MD";
    FlagIconName["ME"] = "ME";
    FlagIconName["MF"] = "MF";
    FlagIconName["MG"] = "MG";
    FlagIconName["MH"] = "MH";
    FlagIconName["MK"] = "MK";
    FlagIconName["ML"] = "ML";
    FlagIconName["MM"] = "MM";
    FlagIconName["MN"] = "MN";
    FlagIconName["MO"] = "MO";
    FlagIconName["MP"] = "MP";
    FlagIconName["MQ"] = "MQ";
    FlagIconName["MR"] = "MR";
    FlagIconName["MS"] = "MS";
    FlagIconName["MT"] = "MT";
    FlagIconName["MU"] = "MU";
    FlagIconName["MV"] = "MV";
    FlagIconName["MW"] = "MW";
    FlagIconName["MX"] = "MX";
    FlagIconName["MY"] = "MY";
    FlagIconName["MZ"] = "MZ";
    FlagIconName["NA"] = "NA";
    FlagIconName["NC"] = "NC";
    FlagIconName["NE"] = "NE";
    FlagIconName["NF"] = "NF";
    FlagIconName["NG"] = "NG";
    FlagIconName["NI"] = "NI";
    FlagIconName["NL"] = "NL";
    FlagIconName["NO"] = "NO";
    FlagIconName["NP"] = "NP";
    FlagIconName["NR"] = "NR";
    FlagIconName["NU"] = "NU";
    FlagIconName["NZ"] = "NZ";
    FlagIconName["OM"] = "OM";
    FlagIconName["PA"] = "PA";
    FlagIconName["PE"] = "PE";
    FlagIconName["PF"] = "PF";
    FlagIconName["PG"] = "PG";
    FlagIconName["PH"] = "PH";
    FlagIconName["PK"] = "PK";
    FlagIconName["PL"] = "PL";
    FlagIconName["PM"] = "PM";
    FlagIconName["PN"] = "PN";
    FlagIconName["PR"] = "PR";
    FlagIconName["PS"] = "PS";
    FlagIconName["PT"] = "PT";
    FlagIconName["PW"] = "PW";
    FlagIconName["PY"] = "PY";
    FlagIconName["QA"] = "QA";
    FlagIconName["RE"] = "RE";
    FlagIconName["RO"] = "RO";
    FlagIconName["RS"] = "RS";
    FlagIconName["RU"] = "RU";
    FlagIconName["RW"] = "RW";
    FlagIconName["SA"] = "SA";
    FlagIconName["SB"] = "SB";
    FlagIconName["SC"] = "SC";
    FlagIconName["SD"] = "SD";
    FlagIconName["SE"] = "SE";
    FlagIconName["SG"] = "SG";
    FlagIconName["SH"] = "SH";
    FlagIconName["SI"] = "SI";
    FlagIconName["SJ"] = "SJ";
    FlagIconName["SK"] = "SK";
    FlagIconName["SL"] = "SL";
    FlagIconName["SM"] = "SM";
    FlagIconName["SN"] = "SN";
    FlagIconName["SO"] = "SO";
    FlagIconName["SR"] = "SR";
    FlagIconName["SS"] = "SS";
    FlagIconName["ST"] = "ST";
    FlagIconName["SV"] = "SV";
    FlagIconName["SX"] = "SX";
    FlagIconName["SY"] = "SY";
    FlagIconName["SZ"] = "SZ";
    FlagIconName["TC"] = "TC";
    FlagIconName["TD"] = "TD";
    FlagIconName["TF"] = "TF";
    FlagIconName["TG"] = "TG";
    FlagIconName["TH"] = "TH";
    FlagIconName["TJ"] = "TJ";
    FlagIconName["TK"] = "TK";
    FlagIconName["TL"] = "TL";
    FlagIconName["TM"] = "TM";
    FlagIconName["TN"] = "TN";
    FlagIconName["TO"] = "TO";
    FlagIconName["TR"] = "TR";
    FlagIconName["TT"] = "TT";
    FlagIconName["TV"] = "TV";
    FlagIconName["TW"] = "TW";
    FlagIconName["TZ"] = "TZ";
    FlagIconName["UA"] = "UA";
    FlagIconName["UG"] = "UG";
    FlagIconName["UM"] = "UM";
    FlagIconName["US"] = "US";
    FlagIconName["USCA"] = "USCA";
    FlagIconName["UY"] = "UY";
    FlagIconName["UZ"] = "UZ";
    FlagIconName["VA"] = "VA";
    FlagIconName["VC"] = "VC";
    FlagIconName["VE"] = "VE";
    FlagIconName["VG"] = "VG";
    FlagIconName["VI"] = "VI";
    FlagIconName["VN"] = "VN";
    FlagIconName["VU"] = "VU";
    FlagIconName["WF"] = "WF";
    FlagIconName["WS"] = "WS";
    FlagIconName["XK"] = "XK";
    FlagIconName["YE"] = "YE";
    FlagIconName["YT"] = "YT";
    FlagIconName["ZA"] = "ZA";
    FlagIconName["ZM"] = "ZM";
    FlagIconName["ZW"] = "ZW";
})($0baebf39b96911e1$var$FlagIconName || (module.exports.FlagIconName = $0baebf39b96911e1$var$FlagIconName = {}));
module.exports.FLAG_ICONS = Object.values($0baebf39b96911e1$var$FlagIconName).reduce((res, val)=>{
    res[val] = true;
    return res;
}, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});

});


parcelRegister("5Tsdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridContext = module.exports.GridColumn = module.exports.Grid = void 0;

var $fI1VP = parcelRequire("fI1VP");
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $fI1VP.Grid;
    }
});
Object.defineProperty(module.exports, "GridColumn", {
    enumerable: true,
    get: function() {
        return $fI1VP.GridColumn;
    }
});
Object.defineProperty(module.exports, "GridContext", {
    enumerable: true,
    get: function() {
        return $fI1VP.GridContext;
    }
});

});
parcelRegister("fI1VP", function(module, exports) {
"use client";
"use strict";
var $b6fc76b11d25b163$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6fc76b11d25b163$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumn = module.exports.Grid = module.exports.GridLegacy = module.exports.GridContext = void 0;

var $8sxjx = parcelRequire("8sxjx");

const $b6fc76b11d25b163$var$react_1 = $b6fc76b11d25b163$var$__importDefault((parcelRequire("acw62")));

var $8sxjx = parcelRequire("8sxjx");

var $4PwOk = parcelRequire("4PwOk");

var $hWTWV = parcelRequire("hWTWV");

var $kPu91 = parcelRequire("kPu91");

var $c15h3 = parcelRequire("c15h3");
module.exports.GridContext = $b6fc76b11d25b163$var$react_1.default.createContext({
    fillGapEnd: false,
    fillGapStart: false,
    initial: true,
    size: [
        null,
        null,
        null
    ]
});
module.exports.GridLegacy = $b6fc76b11d25b163$var$react_1.default.forwardRef((_a, ref)=>{
    var { children: children, initial: initial, variant: variant = "primary", wrap: wrap = true } = _a, props = $b6fc76b11d25b163$var$__rest(_a, [
        "children",
        "initial",
        "variant",
        "wrap"
    ]);
    const currentContext = $b6fc76b11d25b163$var$react_1.default.useContext(module.exports.GridContext);
    const isInitial = initial !== undefined ? initial : currentContext.initial;
    const context = {
        fillGapEnd: false,
        fillGapStart: false,
        initial: isInitial,
        size: currentContext.size
    };
    return $b6fc76b11d25b163$var$react_1.default.createElement($c15h3.GridElement, Object.assign({
        fillGapEnd: !!currentContext.fillGapEnd,
        fillGapStart: !!currentContext.fillGapStart,
        initial: context.initial,
        variant: variant,
        wrap: wrap,
        ref: ref
    }, props), $b6fc76b11d25b163$var$react_1.default.createElement(module.exports.GridContext.Provider, {
        value: context
    }, children), wrap === false && isInitial && $b6fc76b11d25b163$var$react_1.default.createElement($hWTWV.Box, {
        sx: {
            flexShrink: 0,
            width: [
                "gridMobileColumnGutter",
                "gridTabletColumnGutter",
                "gridDesktopColumnGutter"
            ]
        }
    }));
});
module.exports.GridLegacy.displayName = "GridLegacy";
module.exports.Grid = $b6fc76b11d25b163$var$react_1.default.forwardRef((props, ref)=>{
    const themeUIContext = $b6fc76b11d25b163$var$react_1.default.useContext($8sxjx.__ThemeUIContext);
    const { theme: theme } = (0, $8sxjx.useThemeUI)();
    const { warnDeprecation: warnDeprecation } = (0, $4PwOk.useWarning)();
    const customOverrides = {
        breakpoints: [
            "768px",
            "1024px",
            "1440px",
            "1920px"
        ],
        grid: {
            gridDesktopColumnCount: 12,
            gridMobileColumnCount: 12,
            gridTabletColumnCount: 12
        },
        sizes: {
            containerDesktopMargin: 64,
            containerDesktopMaxWidth: 1440,
            containerMobileMargin: 16,
            containerMobileMaxWidth: 768,
            containerTabletMargin: 40,
            containerTabletMaxWidth: 1024,
            gridDesktopColumnGutter: 24,
            gridMobileColumnGutter: 16,
            gridTabletColumnGutter: 24
        }
    };
    const mergedTheme = (0, $8sxjx.merge)(theme, customOverrides);
    if (props.variant === "uniform-12") return $b6fc76b11d25b163$var$react_1.default.createElement($8sxjx.__ThemeUIInternalBaseThemeProvider, {
        context: Object.assign(Object.assign({}, themeUIContext), {
            theme: mergedTheme
        })
    }, $b6fc76b11d25b163$var$react_1.default.createElement(module.exports.GridLegacy, Object.assign({}, props, {
        ref: ref
    })));
    else {
        warnDeprecation("The legacy Grid is being deprecated in favor of a uniform 12-column Grid. Please use the 'uniform-12' variant prop to migrate.");
        return $b6fc76b11d25b163$var$react_1.default.createElement(module.exports.GridLegacy, Object.assign({}, props, {
            ref: ref
        }));
    }
});
module.exports.Grid.displayName = "Grid";
const $b6fc76b11d25b163$var$getGridArray = (size)=>{
    if (Array.isArray(size)) return size;
    else {
        const sizeForAll = size !== undefined ? size : null;
        return [
            sizeForAll,
            sizeForAll,
            sizeForAll
        ];
    }
};
module.exports.GridColumn = $b6fc76b11d25b163$var$react_1.default.forwardRef((_a, ref)=>{
    var { children: children, fillEnd: fillEnd, fillGap: fillGap, fillGapEnd: fillGapEnd, fillGapStart: fillGapStart, fillStart: fillStart, push: pushInitial, size: sizeInitial } = _a, props = $b6fc76b11d25b163$var$__rest(_a, [
        "children",
        "fillEnd",
        "fillGap",
        "fillGapEnd",
        "fillGapStart",
        "fillStart",
        "push",
        "size"
    ]);
    const { initial: initial, size: contextSize } = $b6fc76b11d25b163$var$react_1.default.useContext(module.exports.GridContext);
    const push = $b6fc76b11d25b163$var$react_1.default.useMemo(()=>$b6fc76b11d25b163$var$getGridArray(pushInitial), [
        pushInitial
    ]);
    const size = $b6fc76b11d25b163$var$react_1.default.useMemo(()=>$b6fc76b11d25b163$var$getGridArray(sizeInitial), [
        sizeInitial
    ]);
    const context = {
        fillGapEnd: !!fillGapEnd || fillGap || false,
        fillGapStart: fillGapStart || fillGap || false,
        initial: false,
        size: size || contextSize
    };
    return $b6fc76b11d25b163$var$react_1.default.createElement($kPu91.GridColumnElement, Object.assign({
        fillEnd: !!fillEnd,
        fillGapEnd: !!(fillGapEnd || fillGap),
        fillGapStart: !!(fillGapStart || fillGap),
        fillStart: !!fillStart,
        parentSize: !initial ? contextSize : [
            null,
            null,
            null
        ],
        push: push,
        ref: ref,
        size: context.size
    }, props), $b6fc76b11d25b163$var$react_1.default.createElement(module.exports.GridContext.Provider, {
        value: context
    }, children));
});
module.exports.GridColumn.displayName = "GridColumn";

});
parcelRegister("4PwOk", function(module, exports) {
"use strict";
var $3845605c99a01a9b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useWarning = module.exports.resetWarnings = void 0;

const $3845605c99a01a9b$var$react_1 = $3845605c99a01a9b$var$__importDefault((parcelRequire("acw62")));
let $3845605c99a01a9b$var$warnings = {};
const $3845605c99a01a9b$var$resetWarnings = ()=>{
    $3845605c99a01a9b$var$warnings = {};
};
module.exports.resetWarnings = $3845605c99a01a9b$var$resetWarnings;
const $3845605c99a01a9b$var$useWarning = ()=>{
    return $3845605c99a01a9b$var$react_1.default.useMemo(()=>{
        const warn = (warning)=>{
            $3845605c99a01a9b$var$warnings[warning];
        };
        return {
            warn: warn,
            warnDeprecation: warn
        };
    }, []);
};
module.exports.useWarning = $3845605c99a01a9b$var$useWarning;

});

parcelRegister("kPu91", function(module, exports) {
"use client";
"use strict";
var $f29ff42911a71a9c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f29ff42911a71a9c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnElement = module.exports.getDefinedSize = module.exports.getWidth = module.exports.getPadding = module.exports.getMarginInlineStart = module.exports.getMarginInlineEnd = module.exports.getWithoutZeroDecimal = void 0;

const $f29ff42911a71a9c$var$react_1 = $f29ff42911a71a9c$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $dSStr = parcelRequire("dSStr");
const $f29ff42911a71a9c$var$getWithoutZeroDecimal = (num)=>{
    return num.toFixed(6).replace(/0*$/, "").replace(/\.$/, "");
};
module.exports.getWithoutZeroDecimal = $f29ff42911a71a9c$var$getWithoutZeroDecimal;
const $f29ff42911a71a9c$var$getMarginInlineEnd = (maxWidth, gutterWidth, marginWidth, fillGapEnd = false, fill)=>{
    const extraGutterWidth = fillGapEnd ? -(gutterWidth / 2) : gutterWidth / 2;
    return fill ? `calc(min(-50vw + ${maxWidth / 2}px, ${-(marginWidth - gutterWidth)}px) + ${extraGutterWidth - gutterWidth}px)` : `${extraGutterWidth}px`;
};
module.exports.getMarginInlineEnd = $f29ff42911a71a9c$var$getMarginInlineEnd;
const $f29ff42911a71a9c$var$getMarginInlineStart = (maxWidth, columnCount, gutterWidth, marginWidth, push, fillGapStart = false, fill)=>{
    const baseGutterWidth = gutterWidth / 2;
    const extraGutterWidth = fillGapStart ? gutterWidth : 0;
    const pushWidth = push ? `${(0, module.exports.getWithoutZeroDecimal)(push / columnCount * 100)}% + ` : "";
    if (fill) return `calc(${pushWidth}min(-50vw + ${maxWidth / 2 + gutterWidth}px, -${marginWidth - gutterWidth}px) + ${-baseGutterWidth}px)`;
    return !push ? `${baseGutterWidth - extraGutterWidth}px` : `calc(${pushWidth}${baseGutterWidth - extraGutterWidth}px)`;
};
module.exports.getMarginInlineStart = $f29ff42911a71a9c$var$getMarginInlineStart;
const $f29ff42911a71a9c$var$getPadding = (maxWidth, gutterWidth, marginWidth, fillGap = false, fill)=>{
    return fill ? `calc(max(50vw - ${maxWidth / 2 + gutterWidth}px, ${marginWidth - gutterWidth}px) + ${gutterWidth - (fillGap ? gutterWidth : 0)}px)` : "0";
};
module.exports.getPadding = $f29ff42911a71a9c$var$getPadding;
const $f29ff42911a71a9c$var$getWidth = (columnCount, gutterWidth, size, fillGapStart = false, fillGapEnd = false)=>{
    const extraGutterWidth = -gutterWidth + (fillGapStart ? gutterWidth : 0) + (fillGapEnd ? gutterWidth : 0);
    return `calc(${(0, module.exports.getWithoutZeroDecimal)(Math.min(size / columnCount, 1) * 100)}%${extraGutterWidth === 0 ? "" : ` + ${extraGutterWidth}px`})`;
};
module.exports.getWidth = $f29ff42911a71a9c$var$getWidth;
const $f29ff42911a71a9c$var$getDefinedSize = (sizes, startSize, maxSize)=>{
    for(let i = startSize; i < sizes.length; i++){
        const sizeCurrent = sizes[i];
        if (sizeCurrent !== null && sizeCurrent !== undefined) return sizeCurrent;
    }
    return maxSize;
};
module.exports.getDefinedSize = $f29ff42911a71a9c$var$getDefinedSize;
module.exports.GridColumnElement = $f29ff42911a71a9c$var$react_1.default.forwardRef((_a, ref)=>{
    var { fillEnd: fillEnd, fillGapEnd: fillGapEnd, fillGapStart: fillGapStart, fillStart: fillStart, parentSize: parentSize, push: push, size: size, sx: sx } = _a, props = $f29ff42911a71a9c$var$__rest(_a, [
        "fillEnd",
        "fillGapEnd",
        "fillGapStart",
        "fillStart",
        "parentSize",
        "push",
        "size",
        "sx"
    ]);
    const theme = (0, $dSStr.useThemeWithoutTypes)();
    const styles = $f29ff42911a71a9c$var$react_1.default.useMemo(()=>({
            boxSizing: "initial",
            flexShrink: 0,
            marginInlineEnd: [
                (0, module.exports.getMarginInlineEnd)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapEnd, fillEnd),
                (0, module.exports.getMarginInlineEnd)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapEnd, fillEnd),
                (0, module.exports.getMarginInlineEnd)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapEnd, fillEnd)
            ],
            marginInlineStart: [
                (0, module.exports.getMarginInlineStart)(theme.sizes.containerMobileMaxWidth, parentSize[0] || theme.grid.gridMobileColumnCount, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, (0, module.exports.getDefinedSize)(push, 0, 0), fillGapStart, fillStart),
                (0, module.exports.getMarginInlineStart)(theme.sizes.containerTabletMaxWidth, parentSize[1] || theme.grid.gridTabletColumnCount, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, (0, module.exports.getDefinedSize)(push, 1, 0), fillGapStart, fillStart),
                (0, module.exports.getMarginInlineStart)(theme.sizes.containerDesktopMaxWidth, parentSize[2] || theme.grid.gridDesktopColumnCount, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, (0, module.exports.getDefinedSize)(push, 2, 0), fillGapStart, fillStart)
            ],
            paddingInlineEnd: [
                (0, module.exports.getPadding)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapEnd, fillEnd),
                (0, module.exports.getPadding)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapEnd, fillEnd),
                (0, module.exports.getPadding)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapEnd, fillEnd)
            ],
            paddingInlineStart: [
                (0, module.exports.getPadding)(theme.sizes.containerMobileMaxWidth, theme.sizes.gridMobileColumnGutter, theme.sizes.containerMobileMargin, fillGapStart, fillStart),
                (0, module.exports.getPadding)(theme.sizes.containerTabletMaxWidth, theme.sizes.gridTabletColumnGutter, theme.sizes.containerTabletMargin, fillGapStart, fillStart),
                (0, module.exports.getPadding)(theme.sizes.containerDesktopMaxWidth, theme.sizes.gridDesktopColumnGutter, theme.sizes.containerDesktopMargin, fillGapStart, fillStart)
            ],
            position: "relative",
            width: [
                (0, module.exports.getWidth)(parentSize[0] || theme.grid.gridMobileColumnCount, theme.sizes.gridMobileColumnGutter, (0, module.exports.getDefinedSize)(size, 0, theme.grid.gridMobileColumnCount), fillGapStart, fillGapEnd),
                (0, module.exports.getWidth)(parentSize[1] || theme.grid.gridTabletColumnCount, theme.sizes.gridTabletColumnGutter, (0, module.exports.getDefinedSize)(size, 1, theme.grid.gridTabletColumnCount), fillGapStart, fillGapEnd),
                (0, module.exports.getWidth)(parentSize[2] || theme.grid.gridDesktopColumnCount, theme.sizes.gridDesktopColumnGutter, (0, module.exports.getDefinedSize)(size, 2, theme.grid.gridDesktopColumnCount), fillGapStart, fillGapEnd)
            ]
        }), [
        fillEnd,
        fillGapEnd,
        fillGapStart,
        fillStart,
        parentSize,
        push,
        size,
        theme
    ]);
    return $f29ff42911a71a9c$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        ref: ref,
        sx: Object.assign(Object.assign({
            display: "flex",
            flexDirection: "column"
        }, sx), styles)
    }, props));
});
module.exports.GridColumnElement.displayName = "GridColumnElement";

});

parcelRegister("c15h3", function(module, exports) {
"use client";
"use strict";
var $8bf9ab5c84aa2e8e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8bf9ab5c84aa2e8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridElement = void 0;

const $8bf9ab5c84aa2e8e$var$react_1 = $8bf9ab5c84aa2e8e$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $dSStr = parcelRequire("dSStr");
const $8bf9ab5c84aa2e8e$var$getMarginInlineStyle = (gutter)=>{
    return `-${gutter / 2}px`;
};
const $8bf9ab5c84aa2e8e$var$getInitialMarginInlineEndStyle = (margin, gutter)=>{
    return `${margin - gutter / 2}px`;
};
const $8bf9ab5c84aa2e8e$var$getInitialMarginInlineStartStyle = (maxWidth, margin, gutter)=>{
    const gutterPadding = gutter / 2;
    return `max(50vw - (${gutterPadding + maxWidth / 2}px), ${margin - gutterPadding}px)`;
};
const $8bf9ab5c84aa2e8e$var$GridElement = (_a)=>{
    var { fillGapEnd: fillGapEnd, fillGapStart: fillGapStart, initial: initial, sx: sx, variant: variant, wrap: wrap } = _a, props = $8bf9ab5c84aa2e8e$var$__rest(_a, [
        "fillGapEnd",
        "fillGapStart",
        "initial",
        "sx",
        "variant",
        "wrap"
    ]);
    const theme = (0, $dSStr.useThemeWithoutTypes)();
    const styles = $8bf9ab5c84aa2e8e$var$react_1.default.useMemo(()=>{
        const { sizes: { containerDesktopMargin: containerDesktopMargin, containerDesktopMaxWidth: containerDesktopMaxWidth, containerMobileMargin: containerMobileMargin, containerMobileMaxWidth: containerMobileMaxWidth, containerTabletMargin: containerTabletMargin, containerTabletMaxWidth: containerTabletMaxWidth, gridDesktopColumnGutter: gridDesktopColumnGutter, gridMobileColumnGutter: gridMobileColumnGutter, gridTabletColumnGutter: gridTabletColumnGutter } } = theme;
        return {
            boxSizing: "border-box",
            display: "flex",
            flexGrow: 1,
            flexWrap: wrap ? "wrap" : "nowrap",
            justifyContent: "flex-start",
            marginInlineEnd: initial ? [
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineEndStyle(containerMobileMargin, gridMobileColumnGutter),
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineEndStyle(containerTabletMargin, gridTabletColumnGutter),
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineEndStyle(containerDesktopMargin, gridDesktopColumnGutter)
            ] : [
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridMobileColumnGutter),
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridTabletColumnGutter),
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridDesktopColumnGutter)
            ],
            marginInlineStart: initial ? [
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineStartStyle(containerMobileMaxWidth, containerMobileMargin, gridMobileColumnGutter),
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineStartStyle(containerTabletMaxWidth, containerTabletMargin, gridTabletColumnGutter),
                $8bf9ab5c84aa2e8e$var$getInitialMarginInlineStartStyle(containerDesktopMaxWidth, containerDesktopMargin, gridDesktopColumnGutter)
            ] : [
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridMobileColumnGutter),
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridTabletColumnGutter),
                $8bf9ab5c84aa2e8e$var$getMarginInlineStyle(gridDesktopColumnGutter)
            ],
            maxWidth: (variant === "primary" || variant === "uniform-12") && initial ? [
                `${containerMobileMaxWidth + gridMobileColumnGutter}px`,
                `${containerTabletMaxWidth + gridTabletColumnGutter}px`,
                `${containerDesktopMaxWidth + gridDesktopColumnGutter}px`
            ] : "none",
            paddingInlineEnd: [
                fillGapEnd ? `${theme.sizes.gridMobileColumnGutter}px` : 0,
                fillGapEnd ? `${theme.sizes.gridTabletColumnGutter}px` : 0,
                fillGapEnd ? `${theme.sizes.gridDesktopColumnGutter}px` : 0
            ],
            paddingInlineStart: [
                fillGapStart ? `${theme.sizes.gridMobileColumnGutter}px` : 0,
                fillGapStart ? `${theme.sizes.gridTabletColumnGutter}px` : 0,
                fillGapStart ? `${theme.sizes.gridDesktopColumnGutter}px` : 0
            ],
            // Hack so the grid renders well in the Storybook docs
            ".docs-story &": initial ? {
                marginInlineEnd: "auto",
                marginInlineStart: "auto"
            } : null
        };
    }, [
        fillGapEnd,
        fillGapStart,
        initial,
        theme,
        variant,
        wrap
    ]);
    return $8bf9ab5c84aa2e8e$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        sx: Object.assign(Object.assign({}, sx), styles)
    }, props));
};
module.exports.GridElement = $8bf9ab5c84aa2e8e$var$GridElement;

});



parcelRegister("bxZtt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetProvider = module.exports.Target = void 0;

var $51prO = parcelRequire("51prO");
Object.defineProperty(module.exports, "Target", {
    enumerable: true,
    get: function() {
        return $51prO.Target;
    }
});
Object.defineProperty(module.exports, "TargetProvider", {
    enumerable: true,
    get: function() {
        return $51prO.TargetProvider;
    }
});

});
parcelRegister("51prO", function(module, exports) {
"use client";
"use strict";
var $3a80c91870c8cdb6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a80c91870c8cdb6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Target = module.exports.TargetProvider = void 0;

const $3a80c91870c8cdb6$var$react_1 = $3a80c91870c8cdb6$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $3a80c91870c8cdb6$var$TargetContext = $3a80c91870c8cdb6$var$react_1.default.createContext({
    clickHandler: ()=>{}
});
const $3a80c91870c8cdb6$var$TargetProvider = ({ children: children, clickHandler: clickHandler, targetResolver: targetResolver })=>{
    return $3a80c91870c8cdb6$var$react_1.default.createElement($3a80c91870c8cdb6$var$TargetContext.Provider, {
        value: {
            clickHandler: clickHandler,
            targetResolver: targetResolver
        }
    }, children);
};
module.exports.TargetProvider = $3a80c91870c8cdb6$var$TargetProvider;
module.exports.Target = $3a80c91870c8cdb6$var$react_1.default.forwardRef((_a, ref)=>{
    var { children: children, disabled: disabled, onClick: onClick, sx: sx } = _a, props = $3a80c91870c8cdb6$var$__rest(_a, [
        "children",
        "disabled",
        "onClick",
        "sx"
    ]);
    const { clickHandler: clickHandler, targetResolver: targetResolver } = $3a80c91870c8cdb6$var$react_1.default.useContext($3a80c91870c8cdb6$var$TargetContext);
    const hrefResolved = $3a80c91870c8cdb6$var$react_1.default.useMemo(()=>{
        if ("href" in props) {
            const resolved = targetResolver === null || targetResolver === void 0 ? void 0 : targetResolver(props.href);
            if (typeof resolved === "object" && resolved !== null) return resolved.href;
            return props.href;
        }
        return undefined;
    }, [
        props,
        targetResolver
    ]);
    const targetResolved = $3a80c91870c8cdb6$var$react_1.default.useMemo(()=>{
        if (!targetResolver) {
            if ("target" in props) return props.target;
        } else if ("href" in props) {
            const resolved = targetResolver(props.href);
            if (typeof resolved === "string") return resolved;
            else if (typeof resolved === "object" && resolved !== null) return resolved.target;
        }
        return undefined;
    }, [
        props,
        targetResolver
    ]);
    const cursor = $3a80c91870c8cdb6$var$react_1.default.useMemo(()=>{
        if (sx === null || sx === void 0 ? void 0 : sx.cursor) return sx === null || sx === void 0 ? void 0 : sx.cursor;
        else if (disabled) return "not-allowed";
        else if ("href" in props || "type" in props && props.type === "submit" || onClick) return "pointer";
        else return "default";
    }, [
        disabled,
        onClick,
        props,
        sx === null || sx === void 0 ? void 0 : sx.cursor
    ]);
    const handleClick = $3a80c91870c8cdb6$var$react_1.default.useCallback((e)=>{
        if (disabled) e.preventDefault();
        else {
            onClick === null || onClick === void 0 || onClick(e);
            if (!e.defaultPrevented) clickHandler(e);
        }
    }, [
        clickHandler,
        disabled,
        onClick
    ]);
    if (hrefResolved) {
        const anchorProps = $3a80c91870c8cdb6$var$__rest(props, []);
        return $3a80c91870c8cdb6$var$react_1.default.createElement($2wkl1.Box, Object.assign({}, anchorProps, {
            as: "a",
            "aria-disabled": disabled,
            tabIndex: disabled ? -1 : undefined,
            href: hrefResolved,
            onClick: handleClick,
            sx: Object.assign(Object.assign({}, sx), {
                cursor: cursor
            }),
            ref: ref,
            target: targetResolved
        }), children);
    } else {
        const _b = props, { role: role = "button" } = _b, buttonProps = $3a80c91870c8cdb6$var$__rest(_b, [
            "role"
        ]);
        return $3a80c91870c8cdb6$var$react_1.default.createElement($2wkl1.Box, Object.assign({}, buttonProps, {
            as: "button",
            "aria-disabled": disabled,
            tabIndex: disabled ? -1 : undefined,
            role: role,
            sx: Object.assign(Object.assign({}, sx), {
                cursor: cursor
            }),
            onClick: handleClick,
            ref: ref
        }), children);
    }
});
module.exports.Target.displayName = "Target";

});


parcelRegister("hNuyC", function(module, exports) {
"use strict";
var $cf4eb74e95220c25$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cf4eb74e95220c25$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cf4eb74e95220c25$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cf4eb74e95220c25$var$__exportStar((parcelRequire("i5SnA")), module.exports);

});
parcelRegister("i5SnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Text = void 0;

var $bLhby = parcelRequire("bLhby");
Object.defineProperty(module.exports, "Text", {
    enumerable: true,
    get: function() {
        return $bLhby.Text;
    }
});

});
parcelRegister("bLhby", function(module, exports) {
"use client";
"use strict";
var $89016a2746695cd7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Text = void 0;

const $89016a2746695cd7$var$react_1 = $89016a2746695cd7$var$__importDefault((parcelRequire("acw62")));

var $kjxh0 = parcelRequire("kjxh0");

var $8NABb = parcelRequire("8NABb");

var $hWTWV = parcelRequire("hWTWV");

var $dXWTi = parcelRequire("dXWTi");
module.exports.Text = $89016a2746695cd7$var$react_1.default.forwardRef((props, ref)=>{
    const { className: className, children: children, as: as, weight: weight, size: size, lineHeight: lineHeight, letterSpacing: letterSpacing, variant: variant, sx: sx = {} } = props;
    const computedAs = $89016a2746695cd7$var$react_1.default.useMemo(()=>{
        switch(variant){
            case "h1":
            case "h1-light":
                return "h1";
            case "h2":
            case "h2-light":
                return "h2";
            case "h3":
            case "h3-light":
                return "h3";
            case "h4":
            case "h4-light":
                return "h4";
            case "h5":
            case "h5-light":
                return "h5";
            case "h6":
            case "h6-light":
                return "h6";
            default:
                return "span";
        }
    }, [
        variant
    ]);
    const { newInheritedStylesContext: newInheritedStylesContext, mergedSx: mergedSx } = (0, $kjxh0.useMergeStyles)(sx);
    /*
      Inheritance (high -> low):
      - component style: custom styles applied directly through props or sx
      - variant style: pre-set styles applied through the variant
      - inherited style: styles inherited from parent node
      - default style: base styles set in context or by browser
    */ const updatedStyleContext = $89016a2746695cd7$var$react_1.default.useMemo(()=>{
        const computedFontSize = size ? size : variant ? (0, $8NABb.getResponsiveStyle)(variant, (v)=>$dXWTi.TypographyVariants[v].fontSize) : newInheritedStylesContext.fontSize;
        const computedFontWeight = weight ? `font-weight-${weight}` : variant ? (0, $8NABb.getResponsiveStyle)(variant, (v)=>$dXWTi.TypographyVariants[v].fontWeight) : newInheritedStylesContext.fontWeight;
        const computedLineHeight = lineHeight ? lineHeight : variant ? (0, $8NABb.getResponsiveStyle)(variant, (v)=>$dXWTi.TypographyVariants[v].lineHeight) : newInheritedStylesContext.lineHeight;
        const computedLetterSpacing = letterSpacing ? letterSpacing : variant ? (0, $8NABb.getResponsiveStyle)(variant, (v)=>$dXWTi.TypographyVariants[v].letterSpacing) : newInheritedStylesContext.letterSpacing;
        return Object.assign(Object.assign({}, newInheritedStylesContext), {
            fontSize: computedFontSize || "font-size-4",
            fontWeight: computedFontWeight || "font-weight-regular",
            lineHeight: computedLineHeight || "leading-2",
            letterSpacing: computedLetterSpacing
        });
    }, [
        letterSpacing,
        lineHeight,
        newInheritedStylesContext,
        size,
        variant,
        weight
    ]);
    return $89016a2746695cd7$var$react_1.default.createElement($kjxh0.InheritedStylesProvider, {
        styleContext: updatedStyleContext
    }, $89016a2746695cd7$var$react_1.default.createElement($hWTWV.Box, {
        ref: ref,
        as: as || computedAs,
        className: className,
        sx: Object.assign(Object.assign(Object.assign({}, mergedSx), updatedStyleContext), {
            textTransform: variant === "overline" ? "uppercase" : "unset"
        })
    }, children));
});
module.exports.Text.displayName = "Text";

});
parcelRegister("dXWTi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypographyVariants = void 0;
module.exports.TypographyVariants = {
    display: {
        fontSize: "font-size-12",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "display-light": {
        fontSize: "font-size-12",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    h1: {
        fontSize: "font-size-11",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h1-light": {
        fontSize: "font-size-11",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h2: {
        fontSize: "font-size-10",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h2-light": {
        fontSize: "font-size-10",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h3: {
        fontSize: "font-size-9",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h3-light": {
        fontSize: "font-size-9",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h4: {
        fontSize: "font-size-8",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h4-light": {
        fontSize: "font-size-8",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h5: {
        fontSize: "font-size-7",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h5-light": {
        fontSize: "font-size-7",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    h6: {
        fontSize: "font-size-6",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "h6-light": {
        fontSize: "font-size-6",
        fontWeight: "font-weight-light",
        letterSpacing: "kerning-2",
        lineHeight: "leading-1"
    },
    "title-1-medium": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-1-regular": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-2-medium": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "title-2-regular": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-1",
        lineHeight: "leading-2"
    },
    "body-1-bold": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-1-medium": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-1-regular": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-bold": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-medium": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "body-2-regular": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    "button-xlarge": {
        fontSize: "font-size-5",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "button-large": {
        fontSize: "font-size-4",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "button-base": {
        fontSize: "font-size-3",
        fontWeight: "font-weight-medium",
        letterSpacing: "kerning-none",
        lineHeight: "leading-1"
    },
    "caption-bold": {
        fontSize: "font-size-2",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    caption: {
        fontSize: "font-size-2",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-none",
        lineHeight: "leading-2"
    },
    overline: {
        fontSize: "font-size-2",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-4",
        lineHeight: "leading-2"
    },
    "microtype-bold": {
        fontSize: "font-size-1",
        fontWeight: "font-weight-bold",
        letterSpacing: "kerning-2",
        lineHeight: "leading-2"
    },
    microtype: {
        fontSize: "font-size-1",
        fontWeight: "font-weight-regular",
        letterSpacing: "kerning-2",
        lineHeight: "leading-2"
    }
};

});






parcelRegister("lLDes", function(module, exports) {
"use client";
"use strict";
var $fd8c6b7a16908e7d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccordionItem = void 0;

const $fd8c6b7a16908e7d$var$react_1 = $fd8c6b7a16908e7d$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $jxg79 = parcelRequire("jxg79");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $4PwOk = parcelRequire("4PwOk");

var $6cabA = parcelRequire("6cabA");
const $fd8c6b7a16908e7d$var$AccordionItem = (props)=>{
    const { warn: warn } = (0, $4PwOk.useWarning)();
    const { body: body, children: children, title: title, defaultOpen: defaultOpen } = props;
    const { toggleItem: toggleItem, getIsExpanded: getIsExpanded } = $fd8c6b7a16908e7d$var$react_1.default.useContext($6cabA.AccordionContext);
    const itemId = (0, $8kINY.useId)();
    if (title === null) warn("The `title` prop of a AccordionItem component is null. Please pass either a string or ReactNode.");
    const isFirstRender = $fd8c6b7a16908e7d$var$react_1.default.useRef(true);
    if (isFirstRender.current && defaultOpen) {
        toggleItem(itemId);
        isFirstRender.current = false;
    }
    const isOpen = getIsExpanded(itemId) || false;
    const contentRef = $fd8c6b7a16908e7d$var$react_1.default.useRef(null);
    const targetSxProps = {
        fontWeight: "font-weight-medium",
        color: "text-default",
        px: "spacing-5",
        py: "spacing-4",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "stroke-neutral-tertiary",
        marginTop: "-1px",
        width: "100%",
        fontSize: "font-size-5",
        lineHeight: "leading-2"
    };
    if (contentRef.current) {
        if (isOpen) contentRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
        else contentRef.current.style.maxHeight = "0";
    }
    return $fd8c6b7a16908e7d$var$react_1.default.createElement($fd8c6b7a16908e7d$var$react_1.default.Fragment, null, $fd8c6b7a16908e7d$var$react_1.default.createElement($2wkl1.Target, {
        sx: Object.assign(Object.assign({}, targetSxProps), {
            cursor: children ? "pointer" : "default"
        }),
        onClick: ()=>toggleItem(itemId),
        "aria-expanded": isOpen,
        "aria-controls": `itemContent-${itemId}`
    }, $fd8c6b7a16908e7d$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between"
        }
    }, title, (children || body) && $fd8c6b7a16908e7d$var$react_1.default.createElement($jxg79.Icon, {
        size: "sm",
        icon: isOpen ? "caret-up" : "caret-down",
        sx: {
            color: "button-onSurface-subtle-enabled",
            minWidth: "spacing-6",
            paddingLeft: "spacing-2"
        }
    }))), $fd8c6b7a16908e7d$var$react_1.default.createElement($2wkl1.Box, {
        ref: contentRef,
        sx: {
            overflow: "hidden",
            transition: ()=>"max-height 300ms cubic-bezier(0.4, 0, 0, 1)",
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
            borderBottomColor: "stroke-neutral-tertiary",
            maxHeight: defaultOpen ? undefined : 0
        },
        id: `itemContent-${itemId}`
    }, body && $fd8c6b7a16908e7d$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            px: "spacing-5",
            pb: "spacing-4"
        }
    }, $fd8c6b7a16908e7d$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-1-regular"
    }, body)), children && $fd8c6b7a16908e7d$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            px: "spacing-5",
            pb: "spacing-4"
        }
    }, children)));
};
module.exports.AccordionItem = $fd8c6b7a16908e7d$var$AccordionItem;

});


parcelRegister("gxA3l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarGroup = module.exports.Avatar = void 0;

var $7I8Tu = parcelRequire("7I8Tu");
Object.defineProperty(module.exports, "Avatar", {
    enumerable: true,
    get: function() {
        return $7I8Tu.Avatar;
    }
});

var $51kPW = parcelRequire("51kPW");
Object.defineProperty(module.exports, "AvatarGroup", {
    enumerable: true,
    get: function() {
        return $51kPW.AvatarGroup;
    }
});

});
parcelRegister("7I8Tu", function(module, exports) {
"use client";
"use strict";
var $59d38a9c0d851f00$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $59d38a9c0d851f00$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Avatar = void 0;

const $59d38a9c0d851f00$var$react_1 = $59d38a9c0d851f00$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $4PwOk = parcelRequire("4PwOk");
const $59d38a9c0d851f00$var$sizeMap = {
    xs: {
        container: {
            width: "spacing-7",
            height: "spacing-7"
        },
        iconSize: "xxs",
        padding: "spacing-2",
        fontSize: "font-size-2"
    },
    sm: {
        container: {
            width: "spacing-8",
            height: "spacing-8"
        },
        iconSize: "xs",
        // @ts-ignore
        padding: "6px",
        fontSize: "font-size-3"
    },
    md: {
        container: {
            width: "spacing-9",
            height: "spacing-9"
        },
        iconSize: "sm",
        padding: "spacing-3",
        fontSize: "font-size-4"
    },
    lg: {
        container: {
            width: "spacing-10",
            height: "spacing-10"
        },
        iconSize: "md",
        // @ts-ignore
        padding: "10px",
        fontSize: "font-size-6"
    }
};
const $59d38a9c0d851f00$var$Avatar = (_a)=>{
    var { size: size = "md", outline: outline = false, icon: icon, src: src, alt: alt, children: children } = _a, props = $59d38a9c0d851f00$var$__rest(_a, [
        "size",
        "outline",
        "icon",
        "src",
        "alt",
        "children"
    ]);
    const { container: container, iconSize: iconSize, padding: padding, fontSize: fontSize } = $59d38a9c0d851f00$var$sizeMap[size];
    const { warn: warn } = (0, $4PwOk.useWarning)();
    const id = (0, $8kINY.useId)();
    if (src && !alt) warn("An alt property should be passed when using an image as Avatar content.");
    const role = !children ? "img" : undefined;
    const ariaLabel = !children ? alt || "User avatar" : undefined;
    const avatarIcon = icon ? icon : !children && !src ? "user" : undefined;
    const photoStyles = $59d38a9c0d851f00$var$react_1.default.useMemo(()=>({
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }), [
        src
    ]);
    const outlineStyles = $59d38a9c0d851f00$var$react_1.default.useMemo(()=>({
            outline: "1px solid",
            outlineColor: "stroke-neutral-default"
        }), []);
    const avatarStyles = $59d38a9c0d851f00$var$react_1.default.useMemo(()=>Object.assign(Object.assign(Object.assign(Object.assign({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            borderRadius: "radius-round"
        }, container), outline && Object.assign({}, outlineStyles)), src ? Object.assign({}, photoStyles) : {
            textAlign: "center",
            backgroundColor: "surface-neutral-tertiary",
            p: padding
        }), {
            ":focus-visible": {
                outline: "2px solid",
                outlineColor: "focus",
                outlineOffset: "2px"
            }
        }), [
        container,
        outline,
        outlineStyles,
        src,
        photoStyles,
        padding
    ]);
    return $59d38a9c0d851f00$var$react_1.default.createElement($2wkl1.Box, {
        id: props.id || id,
        role: role,
        "aria-label": ariaLabel,
        tabIndex: 0,
        sx: Object.assign({}, avatarStyles)
    }, !children && !src && $59d38a9c0d851f00$var$react_1.default.createElement($2wkl1.Icon, {
        icon: avatarIcon,
        size: iconSize,
        color: "control-enabled",
        sx: {
            display: "flex",
            alignItems: "center"
        }
    }), !icon && !!children && $59d38a9c0d851f00$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-2-medium",
        size: fontSize,
        sx: {
            color: "text-secondary"
        }
    }, children));
};
module.exports.Avatar = $59d38a9c0d851f00$var$Avatar;

});

parcelRegister("51kPW", function(module, exports) {
"use client";
"use strict";
var $3a7d35825ddbbfba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvatarGroup = void 0;

const $3a7d35825ddbbfba$var$react_1 = $3a7d35825ddbbfba$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $4PwOk = parcelRequire("4PwOk");

var $7I8Tu = parcelRequire("7I8Tu");
const $3a7d35825ddbbfba$var$AvatarGroup = ({ children: children, size: size = "md", max: max = children.length })=>{
    const { warn: warn } = (0, $4PwOk.useWarning)();
    if (max < 0) warn("AvatarGroup: `max` cannot be negative.");
    const displayedAvatars = children.slice(0, max);
    const overflowCount = children.length - max;
    const overlapMargin = $3a7d35825ddbbfba$var$react_1.default.useMemo(()=>({
            marginLeft: (theme)=>`calc(-1 * ${theme.space["spacing-3"]})`
        }), []);
    const groupStyles = $3a7d35825ddbbfba$var$react_1.default.useMemo(()=>({
            outline: "2px solid",
            outlineColor: "stroke-neutral-default",
            borderRadius: "radius-round"
        }), []);
    return $3a7d35825ddbbfba$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            alignItems: "center"
        }
    }, displayedAvatars.map((child, index)=>$3a7d35825ddbbfba$var$react_1.default.createElement($2wkl1.Box, {
            key: child.key || `avatar-${index}`,
            sx: Object.assign(Object.assign({}, index !== 0 && overlapMargin), groupStyles)
        }, $3a7d35825ddbbfba$var$react_1.default.createElement($7I8Tu.Avatar, Object.assign({}, child.props, {
            size: size
        })))), overflowCount > 0 && $3a7d35825ddbbfba$var$react_1.default.createElement($2wkl1.Box, {
        sx: Object.assign(Object.assign({}, overlapMargin), groupStyles)
    }, $3a7d35825ddbbfba$var$react_1.default.createElement($7I8Tu.Avatar, {
        key: `avatar-overflow-${overflowCount}`,
        size: size,
        alt: `${overflowCount} more Avatars`
    }, `+${overflowCount}`)));
};
module.exports.AvatarGroup = $3a7d35825ddbbfba$var$AvatarGroup;

});


parcelRegister("18S1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Badge = void 0;

var $fMQrS = parcelRequire("fMQrS");
Object.defineProperty(module.exports, "Badge", {
    enumerable: true,
    get: function() {
        return $fMQrS.Badge;
    }
});

});
parcelRegister("fMQrS", function(module, exports) {
"use client";
"use strict";
var $b7e405e7c64a8e4b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Badge = void 0;

const $b7e405e7c64a8e4b$var$react_1 = $b7e405e7c64a8e4b$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $4PwOk = parcelRequire("4PwOk");
const $b7e405e7c64a8e4b$var$BadgeColor = {
    critical: "badge-surface-color-critical",
    warning: "badge-surface-color-warning",
    success: "badge-surface-color-success",
    info: "badge-surface-color-info",
    neutral: "badge-surface-color-neutral"
};
const $b7e405e7c64a8e4b$var$Badge = (props)=>{
    const { numberLabel: numberLabel, variant: variant = "neutral" } = props;
    const { warn: warn } = (0, $4PwOk.useWarning)();
    if (numberLabel !== undefined && numberLabel < 0) warn("numberLabel is restricted to positive numeric values");
    const label = $b7e405e7c64a8e4b$var$react_1.default.useMemo(()=>{
        if (numberLabel !== undefined && numberLabel >= 0) {
            if (numberLabel > 999) {
                warn("numberLabel values that exceed 3 digits will be truncated with a + sign");
                return "999+";
            }
            return numberLabel.toString();
        }
        return undefined;
    }, [
        numberLabel,
        warn
    ]);
    const containerStyles = $b7e405e7c64a8e4b$var$react_1.default.useMemo(()=>{
        return {
            display: label ? "inline-flex" : "flex",
            flexShrink: 0,
            alignItems: "center",
            paddingTop: "spacing-1",
            paddingBottom: "spacing-1",
            paddingLeft: "spacing-2",
            paddingRight: "spacing-2",
            borderRadius: "radius-2",
            height: label ? "spacing-5" : "spacing-3",
            width: label ? "max-content" : "spacing-3",
            background: $b7e405e7c64a8e4b$var$BadgeColor[variant]
        };
    }, [
        label,
        variant
    ]);
    return $b7e405e7c64a8e4b$var$react_1.default.createElement($2wkl1.Box, {
        sx: Object.assign({}, containerStyles)
    }, label && $b7e405e7c64a8e4b$var$react_1.default.createElement($i5SnA.Text, {
        size: "font-size-1",
        weight: "medium",
        letterSpacing: "kerning-2",
        sx: {
            color: "badge-onSurface"
        }
    }, label));
};
module.exports.Badge = $b7e405e7c64a8e4b$var$Badge;

});


parcelRegister("26JUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Banner = void 0;

var $c9417 = parcelRequire("c9417");
Object.defineProperty(module.exports, "Banner", {
    enumerable: true,
    get: function() {
        return $c9417.Banner;
    }
});

});
parcelRegister("c9417", function(module, exports) {
"use client";
"use strict";
var $8d7971044665f3a0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Banner = module.exports.bannerColors = void 0;

const $8d7971044665f3a0$var$react_1 = $8d7971044665f3a0$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");
module.exports.bannerColors = {
    info: {
        backgroundColor: "feedback-surface-info",
        borderColor: "feedback-onSurface-incidental-info",
        icon: "info"
    },
    success: {
        backgroundColor: "feedback-surface-success",
        borderColor: "feedback-onSurface-incidental-success",
        icon: "check-circle"
    },
    warning: {
        backgroundColor: "feedback-surface-warning",
        borderColor: "feedback-onSurface-incidental-warning",
        icon: "warning-circle"
    },
    critical: {
        backgroundColor: "feedback-surface-critical",
        borderColor: "feedback-onSurface-incidental-critical",
        icon: "x-circle"
    }
};
const $8d7971044665f3a0$var$Banner = (props)=>{
    const { variant: variant, title: title, text: text, onDismiss: onDismiss } = props;
    const bannerStyles = module.exports.bannerColors[variant];
    return $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            backgroundColor: bannerStyles.backgroundColor,
            borderLeft: "4px solid",
            borderColor: bannerStyles.borderColor,
            paddingInlineStart: "spacing-5",
            width: "100%"
        }
    }, $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between"
        }
    }, $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "row",
            gap: "spacing-5",
            paddingTop: "spacing-4",
            paddingBottom: "spacing-4"
        }
    }, $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Icon, {
        sx: {
            color: bannerStyles.borderColor,
            flexShrink: 0
        },
        icon: bannerStyles.icon,
        size: "md"
    }), $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            color: "feedback-onSurface-text"
        }
    }, $8d7971044665f3a0$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-1-bold"
    }, title), $8d7971044665f3a0$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-1-regular"
    }, text))), onDismiss && $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Target, {
        "aria-label": "Dismiss message",
        onClick: onDismiss,
        sx: {
            display: "flex",
            flexShrink: 0,
            height: "spacing-10",
            width: "spacing-10",
            alignItems: "center",
            justifyContent: "center"
        }
    }, $8d7971044665f3a0$var$react_1.default.createElement($2wkl1.Icon, {
        color: "color-system-gray-700",
        icon: "x",
        size: "sm"
    }))));
};
module.exports.Banner = $8d7971044665f3a0$var$Banner;

});


parcelRegister("5A97x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Breadcrumb = void 0;

var $4iLF8 = parcelRequire("4iLF8");
Object.defineProperty(module.exports, "Breadcrumb", {
    enumerable: true,
    get: function() {
        return $4iLF8.Breadcrumb;
    }
});

});
parcelRegister("4iLF8", function(module, exports) {
"use client";
"use strict";
var $321dd0a1e3b2d39e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Breadcrumb = void 0;

const $321dd0a1e3b2d39e$var$react_1 = $321dd0a1e3b2d39e$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");
const $321dd0a1e3b2d39e$var$Breadcrumb = (props)=>{
    const colorClassName = `breadcrumb${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const { pages: pages, expand: expand, onClickPage: onClickPage } = props;
    const [showEllipses, setShowEllipses] = $321dd0a1e3b2d39e$var$react_1.default.useState(true);
    const onClickEllipses = $321dd0a1e3b2d39e$var$react_1.default.useCallback(()=>{
        setShowEllipses(false);
    }, []);
    const colorStyles = {
        [`.${colorClassName}`]: {
            color: "text-secondary",
            textDecoration: "underline",
            textDecorationColor: "transparent",
            transition: "transition-color-medium"
        },
        [`&:hover .${colorClassName}`]: {
            color: "text-link-hover",
            textDecorationColor: "currentColor"
        },
        [`&:active .${colorClassName}`]: {
            color: "text-link-click",
            textDecorationColor: "currentColor"
        }
    };
    const renderEllipses = ()=>{
        return $321dd0a1e3b2d39e$var$react_1.default.createElement($2wkl1.Target, {
            sx: expand ? colorStyles : {},
            onClick: expand ? onClickEllipses : undefined
        }, $321dd0a1e3b2d39e$var$react_1.default.createElement($i5SnA.Text, {
            className: colorClassName,
            sx: {
                paddingInlineEnd: "spacing-3"
            },
            variant: "title-2-regular",
            weight: "regular"
        }, "..."), $321dd0a1e3b2d39e$var$react_1.default.createElement($i5SnA.Text, {
            variant: "title-2-regular"
        }, "/"));
    };
    const totalPages = pages.length;
    const breadCrumb = pages.map((page, index)=>{
        if (showEllipses && totalPages > 3) {
            if (index === 0) return $321dd0a1e3b2d39e$var$react_1.default.createElement($321dd0a1e3b2d39e$var$react_1.default.Fragment, {
                key: "ellipsis"
            }, renderEllipses());
            if (index > 0 && index < totalPages - 3) return null;
        }
        const isFirst = index === 0;
        const isLast = index === totalPages - 1;
        const fontWeight = isLast ? "medium" : "regular";
        const onClickNav = ()=>{
            if (!isLast) onClickPage(page.pageId);
        };
        return $321dd0a1e3b2d39e$var$react_1.default.createElement($2wkl1.Target, {
            sx: Object.assign({
                display: "flex"
            }, colorStyles),
            key: page.pageId,
            onClick: isLast ? undefined : onClickNav
        }, $321dd0a1e3b2d39e$var$react_1.default.createElement($i5SnA.Text, {
            className: isLast ? undefined : colorClassName,
            sx: {
                color: "text-emphasis",
                paddingInlineStart: isFirst ? 0 : "spacing-3",
                paddingInlineEnd: "spacing-3"
            },
            variant: "title-2-regular",
            weight: fontWeight
        }, page.title), !isLast && $321dd0a1e3b2d39e$var$react_1.default.createElement($i5SnA.Text, {
            variant: "title-2-regular"
        }, "/"));
    });
    return $321dd0a1e3b2d39e$var$react_1.default.createElement($2wkl1.Box, {
        as: "nav",
        sx: {
            display: "flex",
            flexWrap: "wrap"
        }
    }, breadCrumb);
};
module.exports.Breadcrumb = $321dd0a1e3b2d39e$var$Breadcrumb;

});


parcelRegister("6Jh06", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = void 0;

var $1pNyk = parcelRequire("1pNyk");
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $1pNyk.Button;
    }
});

});
parcelRegister("1pNyk", function(module, exports) {
"use client";
"use strict";
var $107e9060e76bd5a7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $107e9060e76bd5a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Button = void 0;

const $107e9060e76bd5a7$var$react_1 = $107e9060e76bd5a7$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $jxg79 = parcelRequire("jxg79");

var $8NABb = parcelRequire("8NABb");
const $107e9060e76bd5a7$var$Button = (props)=>{
    const { variant: variant = "filled", brand: brand = "primary", size: size = "medium", icon: icon, iconPosition: iconPosition = "start", disabled: disabled = false, "aria-label": ariaLabel, children: children, sx: sx } = props, restProps = $107e9060e76bd5a7$var$__rest(props, [
        "variant",
        "brand",
        "size",
        "icon",
        "iconPosition",
        "disabled",
        "aria-label",
        "children",
        "sx"
    ]);
    const isIconButton = icon && !children;
    if (isIconButton && !ariaLabel) throw new Error("Accessibility error: Icon-only buttons must have an aria-label.");
    const iconButtonBaseStyles = {
        width: (0, $8NABb.getResponsiveStyle)(size, (s)=>s === "medium" ? "spacing-9" : s === "large" ? "spacing-10" : "spacing-12"),
        p: (0, $8NABb.getResponsiveStyle)(size, (s)=>s === "medium" ? "spacing-3" : "spacing-4")
    };
    const iconSize = (0, $8NABb.getResponsiveStyle)(size, (s)=>isIconButton ? s === "medium" ? "xs" : s === "large" ? "sm" : "md" : s === "medium" ? "xxs" : s === "large" ? "xs" : "sm");
    const buttonBaseStyles = {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        flexShrink: 0,
        height: (0, $8NABb.getResponsiveStyle)(size, (s)=>s === "medium" ? "spacing-9" : s === "large" ? "spacing-10" : "spacing-12"),
        borderRadius: "radius-2",
        px: "spacing-5",
        py: "spacing-4",
        gap: "spacing-2",
        fontSize: (0, $8NABb.getResponsiveStyle)(size, (s)=>s === "medium" ? "font-size-3" : s === "large" ? "font-size-4" : "font-size-5"),
        fontWeight: "font-weight-medium",
        lineHeight: "leading-none",
        letterSpacing: "kerning-none",
        transition: "transition-color-medium"
    };
    const buttonColorsFilled = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>({
            backgroundColor: disabled ? "button-surface-filled-disabled" : brand === "primary" ? "button-surface-filled-enabled" : "button-surface-filled-secondary-enabled",
            color: disabled ? "button-onSurface-filled-disabled" : brand === "primary" ? "button-onSurface-filled-primary" : "button-onSurface-filled-secondary",
            ":hover": disabled ? {} : {
                backgroundColor: brand === "primary" ? "button-surface-filled-hover" : "button-surface-filled-secondary-hover"
            },
            ":active": disabled ? {} : {
                backgroundColor: brand === "primary" ? "button-surface-filled-click" : "button-surface-filled-secondary-click"
            }
        }), [
        brand,
        disabled
    ]);
    const buttonColorsOutline = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>({
            backgroundColor: disabled ? "button-surface-outline-disabled" : brand === "primary" ? "button-surface-outline-primary" : "button-surface-outline-secondary",
            color: disabled ? "button-onSurface-outline-disabled" : brand === "primary" ? "button-onSurface-outline-enabled" : "button-onSurface-outline-secondary-enabled",
            border: "1px solid",
            borderColor: disabled ? "button-onSurface-outline-disabled" : brand === "primary" ? "button-onSurface-outline-enabled" : "button-onSurface-outline-secondary-enabled",
            ":hover": disabled ? {} : {
                color: brand === "primary" ? "button-onSurface-outline-hover" : "button-onSurface-outline-secondary-hover",
                borderColor: brand === "primary" ? "button-onSurface-outline-hover" : "button-onSurface-outline-secondary-hover"
            },
            ":active": disabled ? {} : {
                color: brand === "primary" ? "button-onSurface-outline-click" : "button-onSurface-outline-secondary-click",
                borderColor: brand === "primary" ? "button-onSurface-outline-click" : "button-onSurface-outline-secondary-click"
            }
        }), [
        brand,
        disabled
    ]);
    const buttonColorsSubtle = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>({
            color: disabled ? "button-onSurface-subtle-disabled" : brand === "primary" ? "button-onSurface-subtle-enabled" : "button-onSurface-subtle-secondary-enabled",
            ":hover": disabled ? {} : {
                color: brand === "primary" ? "button-onSurface-subtle-hover" : "button-onSurface-subtle-secondary-hover"
            },
            ":active": disabled ? {} : {
                color: brand === "primary" ? "button-onSurface-subtle-click" : "button-onSurface-subtle-secondary-click"
            }
        }), [
        brand,
        disabled
    ]);
    const buttonColorCritical = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>({
            backgroundColor: disabled ? "button-surface-critical-disabled" : "button-surface-critical-enabled",
            color: disabled ? "button-onSurface-critical-disabled" : "button-onSurface-critical",
            ":hover": disabled ? {} : {
                backgroundColor: "button-surface-critical-hover"
            },
            ":active": disabled ? {} : {
                backgroundColor: "button-surface-critical-click"
            }
        }), [
        disabled
    ]);
    const variantStyles = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>{
        switch(variant){
            case "filled":
                return buttonColorsFilled;
            case "outline":
                return buttonColorsOutline;
            case "subtle":
                return buttonColorsSubtle;
            case "critical":
                return buttonColorCritical;
        }
    }, [
        variant,
        buttonColorsFilled,
        buttonColorsOutline,
        buttonColorsSubtle,
        buttonColorCritical
    ]);
    const buttonFocusStyles = $107e9060e76bd5a7$var$react_1.default.useMemo(()=>({
            ":focus-visible": {
                outline: "2px solid",
                outlineColor: "focus",
                outlineOffset: "2px"
            }
        }), []);
    const renderIcon = ()=>{
        return $107e9060e76bd5a7$var$react_1.default.createElement($jxg79.Icon, {
            icon: icon,
            size: iconSize,
            color: "inherit",
            sx: {
                flexShrink: 0
            }
        });
    };
    return $107e9060e76bd5a7$var$react_1.default.createElement($2wkl1.Target, Object.assign({
        sx: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, buttonBaseStyles), isIconButton && iconButtonBaseStyles), variantStyles), buttonFocusStyles), sx),
        disabled: disabled,
        "aria-label": ariaLabel
    }, restProps), icon && iconPosition === "start" && renderIcon(), children, icon && iconPosition === "end" && renderIcon());
};
module.exports.Button = $107e9060e76bd5a7$var$Button;

});


parcelRegister("b65sZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Card = void 0;

var $4uLJm = parcelRequire("4uLJm");
Object.defineProperty(module.exports, "Card", {
    enumerable: true,
    get: function() {
        return $4uLJm.Card;
    }
});

});
parcelRegister("4uLJm", function(module, exports) {
"use strict";
var $345efd17bb630d66$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Card = void 0;

const $345efd17bb630d66$var$react_1 = $345efd17bb630d66$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $345efd17bb630d66$var$Card = ({ surfaceColor: surfaceColor, borderColor: borderColor, borderRadius: borderRadius, dropShadow: dropShadow, children: children })=>{
    return $345efd17bb630d66$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            backgroundColor: surfaceColor ? surfaceColor : "surface-neutral-default",
            border: "1px solid",
            borderColor: borderColor ? borderColor : "stroke-neutral-tertiary",
            borderRadius: borderRadius ? borderRadius : "radius-2",
            boxShadow: dropShadow ? dropShadow : "none",
            width: "fit-content"
        }
    }, children);
};
module.exports.Card = $345efd17bb630d66$var$Card;

});


parcelRegister("cKNdE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Checkbox = void 0;

var $5TXC5 = parcelRequire("5TXC5");
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $5TXC5.Checkbox;
    }
});

});
parcelRegister("5TXC5", function(module, exports) {
"use client";
"use strict";
var $44c054c2405596c8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Checkbox = void 0;

const $44c054c2405596c8$var$react_1 = $44c054c2405596c8$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $k4vgd = parcelRequire("k4vgd");

var $8kINY = parcelRequire("8kINY");

const $44c054c2405596c8$var$CustomCheckmarkIcon_1 = $44c054c2405596c8$var$__importDefault((parcelRequire("dSuj8")));

const $44c054c2405596c8$var$CustomIndeterminateIcon_1 = $44c054c2405596c8$var$__importDefault((parcelRequire("dlI8r")));
const $44c054c2405596c8$var$Checkbox = ({ label: label, value: value, onChange: onChange, onBlur: onBlur, indeterminate: indeterminate = false, error: error = false, disabled: disabled, required: required, id: id, ariaLabel: ariaLabel })=>{
    const base0Id = (0, $8kINY.useId)();
    const inputId = id !== null && id !== void 0 ? id : base0Id;
    const [isOutlineVisible, preventOutlineOnClick, handleFocus, handleBlur] = (0, $k4vgd.useFocusControls)(onBlur);
    const isFilled = value || indeterminate;
    const checkboxStyles = $44c054c2405596c8$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "spacing-6",
            minWidth: "spacing-6",
            height: "spacing-6",
            borderStyle: "solid",
            borderWidth: "2px",
            color: "input-onSurface",
            borderColor: error ? "input-stroke-error" : isFilled ? "input-surface-enabled" : "input-stroke-enabled",
            borderRadius: "radius-1",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "transition-color-medium",
            backgroundColor: isFilled ? error ? "input-surface-error" : "input-surface-enabled" : undefined
        }, error ? {} : {
            ":hover": {
                backgroundColor: isFilled ? "input-surface-hover" : undefined,
                borderColor: isFilled ? "input-surface-hover" : "input-stroke-hover"
            },
            ":active": {
                borderColor: "input-surface-click",
                backgroundColor: "input-surface-click"
            }
        }), isOutlineVisible && {
            outlineStyle: "solid",
            borderRadius: "radius-1",
            outlineColor: "focus",
            outlineWidth: "1px",
            outlineOffset: "1px"
        });
    }, [
        error,
        isFilled,
        disabled,
        isOutlineVisible
    ]);
    const labelStyles = $44c054c2405596c8$var$react_1.default.useMemo(()=>{
        return {
            display: "inline-flex",
            alignItems: "stretch",
            color: disabled ? "input-text-disabled" : "input-text",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? "0.5" : "1",
            fontSize: "font-size-1",
            transition: "transition-color-medium",
            userSelect: "none"
        };
    }, [
        disabled
    ]);
    const checkboxWrapperStyles = $44c054c2405596c8$var$react_1.default.useMemo(()=>{
        return {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "fit-content"
        };
    }, []);
    return $44c054c2405596c8$var$react_1.default.createElement($2wkl1.Box, {
        onMouseDown: preventOutlineOnClick,
        onMouseUp: preventOutlineOnClick,
        sx: checkboxWrapperStyles
    }, $44c054c2405596c8$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        htmlFor: inputId,
        id: `${inputId}-label`,
        sx: labelStyles
    }, $44c054c2405596c8$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: {
            display: "flex",
            flexShrink: 0,
            alignItems: "center"
        }
    }, $44c054c2405596c8$var$react_1.default.createElement($2wkl1.Box, {
        as: "input",
        type: "checkbox",
        id: inputId,
        checked: value,
        onChange: onChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        disabled: disabled,
        "aria-invalid": !!error,
        "aria-checked": value,
        "aria-disabled": disabled,
        "aria-required": required,
        "aria-label": ariaLabel
    }), $44c054c2405596c8$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: checkboxStyles
    }, value && $44c054c2405596c8$var$react_1.default.createElement($44c054c2405596c8$var$CustomCheckmarkIcon_1.default, null), !value && indeterminate && $44c054c2405596c8$var$react_1.default.createElement($44c054c2405596c8$var$CustomIndeterminateIcon_1.default, null))), label && $44c054c2405596c8$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-1-regular",
        as: "span",
        sx: Object.assign(Object.assign({}, labelStyles), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            ml: 2
        })
    }, label)));
};
module.exports.Checkbox = $44c054c2405596c8$var$Checkbox;

});
parcelRegister("k4vgd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOverlay = module.exports.useFocusControls = module.exports.useClickOutside = void 0;

var $jQue8 = parcelRequire("jQue8");
Object.defineProperty(module.exports, "useClickOutside", {
    enumerable: true,
    get: function() {
        return $jQue8.useClickOutside;
    }
});

var $eNuqh = parcelRequire("eNuqh");
Object.defineProperty(module.exports, "useFocusControls", {
    enumerable: true,
    get: function() {
        return $eNuqh.useFocusControls;
    }
});

var $ifKCu = parcelRequire("ifKCu");
Object.defineProperty(module.exports, "useOverlay", {
    enumerable: true,
    get: function() {
        return $ifKCu.useOverlay;
    }
});

});
parcelRegister("jQue8", function(module, exports) {
"use client";
"use strict";
var $e72a521dd9423af0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useClickOutside = void 0;

const $e72a521dd9423af0$var$react_1 = $e72a521dd9423af0$var$__importDefault((parcelRequire("acw62")));
/**
 * A React hook that fires a callback function whenever the user clicks on
 * outside of a given HTML element.
 * @param element React reference to the HTML element
 * @param onClickOutside the callback function fired when the user clicks
 * outside of the referenced HTML element
 * @example
 * const element = React.useRef<HTMLDivElement>(null);
 * const [hasClickedOutside, setHasClickedOutside] = React.useState(false);
 *
 * useClickOutside(element, () => setHasClickedOutside(true));
 *
 * <Box ref={element} />
 */ const $e72a521dd9423af0$var$useClickOutside = (element, onClickOutside)=>{
    $e72a521dd9423af0$var$react_1.default.useEffect(()=>{
        const handleClick = (e)=>{
            var _a;
            if (// Don't trigger if the target has been removed entirely
            document.contains(e.target) && !((_a = element.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) onClickOutside();
        };
        window.addEventListener("click", handleClick);
        return ()=>{
            window.removeEventListener("click", handleClick);
        };
    }, [
        element,
        onClickOutside
    ]);
};
module.exports.useClickOutside = $e72a521dd9423af0$var$useClickOutside;

});

parcelRegister("eNuqh", function(module, exports) {
"use client";
"use strict";
var $ac5d3da385bffdb3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFocusControls = void 0;

const $ac5d3da385bffdb3$var$react_1 = $ac5d3da385bffdb3$var$__importDefault((parcelRequire("acw62")));
/**
 * A react hook that provides functionality to control the styles provided
 * for the outline of a focused element.
 * @param onBlur the callback function fired when a user moves off of an element (optional)
 */ const $ac5d3da385bffdb3$var$useFocusControls = (onBlur)=>{
    const [isOutlineVisible, setIsOutlineVisible] = $ac5d3da385bffdb3$var$react_1.default.useState(false);
    const ignoreFocusRef = $ac5d3da385bffdb3$var$react_1.default.useRef(false);
    const preventOutlineOnClick = $ac5d3da385bffdb3$var$react_1.default.useCallback(()=>{
        ignoreFocusRef.current = true;
    }, []);
    const handleFocus = $ac5d3da385bffdb3$var$react_1.default.useCallback(()=>{
        if (!ignoreFocusRef.current) setIsOutlineVisible(true);
        ignoreFocusRef.current = false;
    }, []);
    const handleBlur = $ac5d3da385bffdb3$var$react_1.default.useCallback((event)=>{
        setIsOutlineVisible(false);
        if (onBlur) onBlur(event);
    }, [
        onBlur
    ]);
    return [
        isOutlineVisible,
        preventOutlineOnClick,
        handleFocus,
        handleBlur
    ];
};
module.exports.useFocusControls = $ac5d3da385bffdb3$var$useFocusControls;

});


parcelRegister("dSuj8", function(module, exports) {
"use strict";
var $a1a7d3fa140a9094$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a1a7d3fa140a9094$var$react_1 = $a1a7d3fa140a9094$var$__importDefault((parcelRequire("acw62")));
const $a1a7d3fa140a9094$var$CustomCheckmarkIcon = ()=>$a1a7d3fa140a9094$var$react_1.default.createElement("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a1a7d3fa140a9094$var$react_1.default.createElement("g", {
        id: "Check line"
    }, $a1a7d3fa140a9094$var$react_1.default.createElement("path", {
        id: "Line 1",
        d: "M1.36312 6.49928L4.11997 9.62085L9.92708 2.54203",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
module.exports.default = $a1a7d3fa140a9094$var$CustomCheckmarkIcon;

});

parcelRegister("dlI8r", function(module, exports) {
"use strict";
var $9b7f78d8e8cf494e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9b7f78d8e8cf494e$var$react_1 = $9b7f78d8e8cf494e$var$__importDefault((parcelRequire("acw62")));
const $9b7f78d8e8cf494e$var$CustomIndeterminateIcon = ()=>$9b7f78d8e8cf494e$var$react_1.default.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $9b7f78d8e8cf494e$var$react_1.default.createElement("g", {
        id: "Line"
    }, $9b7f78d8e8cf494e$var$react_1.default.createElement("path", {
        id: "Line 2",
        d: "M1 1H9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    })));
module.exports.default = $9b7f78d8e8cf494e$var$CustomIndeterminateIcon;

});



parcelRegister("01vI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chip = void 0;

var $aUjqv = parcelRequire("aUjqv");
Object.defineProperty(module.exports, "Chip", {
    enumerable: true,
    get: function() {
        return $aUjqv.Chip;
    }
});

});
parcelRegister("aUjqv", function(module, exports) {
"use client";
"use strict";
var $7f0e340a1c22dc02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chip = module.exports.chipColors = void 0;

const $7f0e340a1c22dc02$var$react_1 = $7f0e340a1c22dc02$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $jxg79 = parcelRequire("jxg79");

var $i5SnA = parcelRequire("i5SnA");
module.exports.chipColors = {
    neutral: {
        backgroundColor: "chip-surface-neutral",
        color: "chip-onSurface-neutral",
        ":hover": {
            backgroundColor: "chip-surface-neutral",
            color: "chip-onSurface-neutral-hover"
        },
        ":active": {
            backgroundColor: "chip-surface-neutral",
            color: "chip-onSurface-neutral-click"
        }
    },
    critical: {
        backgroundColor: "feedback-surface-critical",
        color: "feedback-onSurface-critical",
        ":hover": {
            backgroundColor: "feedback-surface-critical",
            color: "feedback-onSurface-critical-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-critical",
            color: "feedback-onSurface-critical-click"
        }
    },
    warning: {
        backgroundColor: "feedback-surface-warning",
        color: "feedback-onSurface-warning",
        ":hover": {
            backgroundColor: "feedback-surface-warning",
            color: "feedback-onSurface-warning-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-warning",
            color: "feedback-onSurface-warning-click"
        }
    },
    success: {
        backgroundColor: "feedback-surface-success",
        color: "feedback-onSurface-success",
        ":hover": {
            backgroundColor: "feedback-surface-success",
            color: "feedback-onSurface-success-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-success",
            color: "feedback-onSurface-success-click"
        }
    },
    info: {
        backgroundColor: "feedback-surface-info",
        color: "feedback-onSurface-info",
        ":hover": {
            backgroundColor: "feedback-surface-info",
            color: "feedback-onSurface-info-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-info",
            color: "feedback-onSurface-info-click"
        }
    },
    brand: {
        backgroundColor: "chip-surface-brand",
        color: "chip-onSurface-brand",
        ":hover": {
            backgroundColor: "chip-surface-brand",
            color: "chip-onSurface-brand-hover"
        },
        ":active": {
            backgroundColor: "chip-surface-brand",
            color: "chip-onSurface-brand-click"
        }
    }
};
const $7f0e340a1c22dc02$var$Chip = (props)=>{
    const { label: label, size: size = "large", variant: variant = "neutral", icon: icon, onDismiss: onDismiss, disabled: disabled = false } = props;
    const layoutStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "spacing-2",
        width: "max-content"
    };
    const appearanceStyles = $7f0e340a1c22dc02$var$react_1.default.useMemo(()=>({
            borderRadius: "radius-round",
            padding: size === "large" ? "spacing-3" : "spacing-2",
            height: size === "large" ? "spacing-8" : "spacing-7"
        }), [
        size
    ]);
    const textVariant = $7f0e340a1c22dc02$var$react_1.default.useMemo(()=>{
        return size === "large" ? "body-2-medium" : "caption";
    }, [
        size
    ]);
    const colorStyles = $7f0e340a1c22dc02$var$react_1.default.useMemo(()=>Object.assign(Object.assign({}, module.exports.chipColors[variant]), {
            transition: "transition-color-medium",
            ":focus-visible": {
                outline: "2px solid",
                outlineColor: "focus",
                outlineOffset: "2px"
            }
        }), [
        variant
    ]);
    const disabledStyles = $7f0e340a1c22dc02$var$react_1.default.useMemo(()=>{
        if (disabled) return {
            backgroundColor: "surface-neutral-secondary",
            color: "text-input-disabled",
            ":hover": {
                backgroundColor: "surface-neutral-secondary"
            },
            ":active": {
                backgroundColor: "surface-neutral-secondary"
            },
            ":focus-visible": {
                backgroundColor: "surface-neutral-secondary"
            }
        };
        return {};
    }, [
        disabled
    ]);
    return $7f0e340a1c22dc02$var$react_1.default.createElement($2wkl1.Box, {
        tabIndex: 0,
        sx: Object.assign(Object.assign(Object.assign(Object.assign({}, colorStyles), layoutStyles), disabledStyles), appearanceStyles),
        disabled: disabled
    }, icon && $7f0e340a1c22dc02$var$react_1.default.createElement($jxg79.Icon, {
        size: "xxs",
        color: "currentColor",
        icon: icon
    }), $7f0e340a1c22dc02$var$react_1.default.createElement($i5SnA.Text, {
        variant: textVariant,
        weight: "medium"
    }, label), onDismiss && $7f0e340a1c22dc02$var$react_1.default.createElement($2wkl1.Target, {
        sx: Object.assign(Object.assign({}, colorStyles), {
            marginTop: "spacing-2"
        }),
        "aria-label": "Dismiss",
        onClick: onDismiss
    }, $7f0e340a1c22dc02$var$react_1.default.createElement($jxg79.Icon, {
        color: "currentColor",
        size: "xxs",
        icon: "x"
    })));
};
module.exports.Chip = $7f0e340a1c22dc02$var$Chip;

});


parcelRegister("8G8Ct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Divider = void 0;

var $eANMx = parcelRequire("eANMx");
Object.defineProperty(module.exports, "Divider", {
    enumerable: true,
    get: function() {
        return $eANMx.Divider;
    }
});

});
parcelRegister("eANMx", function(module, exports) {
"use client";
"use strict";
var $a9fb0b1f98622d06$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Divider = void 0;

const $a9fb0b1f98622d06$var$react_1 = $a9fb0b1f98622d06$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $a9fb0b1f98622d06$var$dividerSizes = {
    small: "1px",
    medium: "2px",
    large: "4px"
};
const $a9fb0b1f98622d06$var$Divider = ({ color: color, direction: direction = "horizontal", size: size = "small", sx: sx })=>{
    const dividerStyles = Object.assign({
        borderColor: color ? color : "stroke-neutral-default",
        borderStyle: "solid",
        display: "block",
        transition: "transition-color-medium"
    }, direction === "horizontal" ? {
        borderWidth: `${$a9fb0b1f98622d06$var$dividerSizes[size]} 0 0 0`,
        width: "100%",
        height: "auto"
    } : {
        borderWidth: `0 0 0 ${$a9fb0b1f98622d06$var$dividerSizes[size]}`,
        height: "100%",
        width: "auto"
    });
    const computedAs = direction === "horizontal" ? "hr" : "div";
    return $a9fb0b1f98622d06$var$react_1.default.createElement($2wkl1.Box, {
        as: computedAs,
        sx: Object.assign(Object.assign({}, dividerStyles), sx)
    });
};
module.exports.Divider = $a9fb0b1f98622d06$var$Divider;

});


parcelRegister("fUrQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dropdown = void 0;

var $83YrA = parcelRequire("83YrA");
Object.defineProperty(module.exports, "Dropdown", {
    enumerable: true,
    get: function() {
        return $83YrA.Dropdown;
    }
});

});
parcelRegister("83YrA", function(module, exports) {
"use client";
"use strict";
var $5ded7d780358ca35$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5ded7d780358ca35$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dropdown = void 0;

const $5ded7d780358ca35$var$react_1 = $5ded7d780358ca35$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $k4vgd = parcelRequire("k4vgd");

var $5IW2I = parcelRequire("5IW2I");
const $5ded7d780358ca35$var$Dropdown = (_a)=>{
    var { defaultOption: defaultOption, description: description, disabled: disabled = false, displayValue: displayValue, dropdownOptions: dropdownOptions, error: error, label: label, noResultsMessage: noResultsMessage = "No results found", onBlur: onBlur, onSelectOption: onSelectOption, readOnly: readOnly = false, required: required = false, selectedOption: selectedOptionProp, showNoResults: showNoResults = false } = _a, rest = $5ded7d780358ca35$var$__rest(_a, [
        "defaultOption",
        "description",
        "disabled",
        "displayValue",
        "dropdownOptions",
        "error",
        "label",
        "noResultsMessage",
        "onBlur",
        "onSelectOption",
        "readOnly",
        "required",
        "selectedOption",
        "showNoResults"
    ]);
    const isControlled = $5ded7d780358ca35$var$react_1.default.useRef(!!selectedOptionProp);
    const dropdownRef = $5ded7d780358ca35$var$react_1.default.useRef(null);
    const dropdownButtonRef = $5ded7d780358ca35$var$react_1.default.useRef(null);
    const [isFocused, setIsFocused] = $5ded7d780358ca35$var$react_1.default.useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = $5ded7d780358ca35$var$react_1.default.useState(false);
    const [selectedOptionInternal, setSelectedOptionInternal] = $5ded7d780358ca35$var$react_1.default.useState(defaultOption);
    // If a selected option is ever passed, we should assume the user is only
    // using a controlled version of the Dropdown and ignore the internal state
    if (selectedOptionProp) isControlled.current = true;
    const selectedOption = isControlled.current ? selectedOptionProp : selectedOptionInternal;
    (0, $k4vgd.useClickOutside)(dropdownRef, ()=>setIsDropdownVisible(false));
    const handleOptionSelect = (option)=>{
        var _a;
        setSelectedOptionInternal(option);
        onSelectOption === null || onSelectOption === void 0 || onSelectOption(option);
        (_a = dropdownButtonRef.current) === null || _a === void 0 || _a.focus();
        setIsDropdownVisible(false);
    };
    const handleClick = $5ded7d780358ca35$var$react_1.default.useCallback(()=>{
        if (!disabled && !readOnly) setIsDropdownVisible((prev)=>!prev);
    }, [
        disabled,
        readOnly
    ]);
    const handleBlur = $5ded7d780358ca35$var$react_1.default.useCallback((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setIsDropdownVisible(false);
            setIsFocused(false);
            onBlur === null || onBlur === void 0 || onBlur(event);
        }
    }, [
        onBlur
    ]);
    const handleContainerKeyDown = (event)=>{
        switch(event.key){
            case "Enter":
                event.preventDefault();
                setIsDropdownVisible((prev)=>!prev);
                break;
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                setIsDropdownVisible(true);
                break;
            default:
                break;
        }
    };
    const handleDropdownMenuDismiss = ()=>{
        var _a;
        (_a = dropdownButtonRef.current) === null || _a === void 0 || _a.focus();
        setIsDropdownVisible(false);
    };
    const handleFocus = ()=>{
        if (!disabled && !readOnly) setIsFocused(true);
    };
    const shouldShowLabel = !!selectedOption || !!displayValue;
    const labelTextStyles = $5ded7d780358ca35$var$react_1.default.useMemo(()=>{
        const labelYPosition = shouldShowLabel ? "-24px" : "-50%";
        const labelScale = shouldShowLabel ? 0.66 : 1;
        return {
            position: "absolute",
            left: "spacing-4",
            top: "50%",
            transform: `translateY(${labelYPosition}) scale(${labelScale})`,
            transformOrigin: "left center",
            transition: "transition-ease-out-fast",
            pointerEvents: "none",
            fontSize: "font-size-1",
            lineHeight: "leading-2",
            letterSpacing: "kerning-2",
            color: disabled ? "field-text-disabled" : "field-text-label",
            whiteSpace: "nowrap",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            gap: "spacing-1"
        };
    }, [
        disabled,
        shouldShowLabel
    ]);
    const descriptionTextStyles = $5ded7d780358ca35$var$react_1.default.useMemo(()=>{
        return {
            mt: "spacing-2",
            color: disabled ? "field-text-disabled" : "field-text-description"
        };
    }, [
        disabled
    ]);
    const inputStyles = $5ded7d780358ca35$var$react_1.default.useMemo(()=>Object.assign(Object.assign({
            position: "relative",
            width: "100%",
            height: "spacing-10",
            px: "spacing-4",
            paddingTop: shouldShowLabel ? "spacing-7" : "spacing-5",
            paddingBottom: shouldShowLabel ? "spacing-3" : "spacing-5",
            borderRadius: "radius-2",
            cursor: disabled || readOnly ? "not-allowed" : "pointer"
        }, disabled && {
            pointerEvents: "none"
        }), {
            display: "flex",
            alignItems: "center",
            color: disabled ? "field-text-disabled" : readOnly ? "field-text-read-only" : "field-text-primary",
            transition: "transition-color-medium"
        }), [
        disabled,
        readOnly,
        shouldShowLabel
    ]);
    const dropdownBorderStyles = $5ded7d780358ca35$var$react_1.default.useMemo(()=>Object.assign(Object.assign(Object.assign(Object.assign({
            position: "relative",
            border: "1px solid",
            borderColor: "field-stroke",
            borderRadius: "radius-2",
            cursor: disabled || readOnly ? "not-allowed" : "pointer",
            backgroundColor: error ? "field-surface-error" : disabled || readOnly ? "field-surface-disabled" : "field-surface"
        }, readOnly && {
            borderWidth: "0 0 1px 0",
            borderRadius: "unset"
        }), {
            outline: "2px solid",
            outlineColor: error ? "field-stroke-error" : "transparent",
            outlineOffset: "-2px",
            transition: "transition-color-medium"
        }), (isDropdownVisible || isFocused) && {
            outlineColor: "focus",
            borderColor: "transparent"
        }), !(disabled || readOnly) && {
            ":focus-in": {
                outlineColor: "focus",
                borderColor: "transparent"
            }
        }), [
        error,
        isFocused,
        isDropdownVisible,
        disabled,
        readOnly
    ]);
    return $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        onBlur: handleBlur,
        onFocus: handleFocus,
        sx: {
            display: "flex",
            flexDirection: "column"
        }
    }, rest), $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, {
        ref: dropdownRef,
        sx: {
            position: "relative",
            userSelect: "none"
        }
    }, $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, {
        role: "button",
        ref: dropdownButtonRef,
        sx: dropdownBorderStyles,
        tabIndex: disabled || readOnly ? -1 : 0,
        "aria-disabled": disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": isDropdownVisible,
        onClick: handleClick,
        onKeyDown: handleContainerKeyDown
    }, $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        sx: labelTextStyles
    }, $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular"
    }, label), required && $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular",
        sx: {
            color: "feedback-onSurface-incidental-critical"
        }
    }, "*")), $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, {
        sx: inputStyles
    }, displayValue ? $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular"
    }, displayValue) : selectedOption && $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular"
    }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label), $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            position: "absolute",
            top: "50%",
            right: "spacing-4",
            transform: "translateY(-50%)",
            display: "flex"
        }
    }, $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Icon, {
        icon: isDropdownVisible ? "caret-up" : "caret-down",
        size: "xs",
        color: disabled || readOnly ? "control-disabled" : "field-onSurface"
    })))), $5ded7d780358ca35$var$react_1.default.createElement($5IW2I.DropdownMenu, {
        dropdownOptions: dropdownOptions,
        showNoResults: showNoResults,
        noResultsMessage: noResultsMessage,
        isOpen: isDropdownVisible,
        selectedOption: selectedOption,
        onOptionSelect: handleOptionSelect,
        onDismiss: handleDropdownMenuDismiss
    })), description && $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-2-regular",
        sx: Object.assign({}, descriptionTextStyles)
    }, description), error && $5ded7d780358ca35$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-2-regular",
        sx: {
            mt: "spacing-2",
            color: "field-text-error"
        }
    }, error));
};
module.exports.Dropdown = $5ded7d780358ca35$var$Dropdown;

});
parcelRegister("5IW2I", function(module, exports) {
"use client";
"use strict";
var $42ae15e7db4265d6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DropdownMenu = void 0;

const $42ae15e7db4265d6$var$react_1 = $42ae15e7db4265d6$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $42ae15e7db4265d6$var$DropdownMenu = ({ dropdownOptions: dropdownOptions, showNoResults: showNoResults = false, noResultsMessage: noResultsMessage = "No results found", isOpen: isOpen, selectedOption: selectedOption, onOptionSelect: onOptionSelect, onDismiss: onDismiss })=>{
    const [highlightedIndex, setHighlightedIndex] = $42ae15e7db4265d6$var$react_1.default.useState(-1);
    const optionRefs = $42ae15e7db4265d6$var$react_1.default.useRef([]);
    optionRefs.current = [];
    const menuRef = $42ae15e7db4265d6$var$react_1.default.useRef(null);
    // focus updated on open
    $42ae15e7db4265d6$var$react_1.default.useEffect(()=>{
        if (isOpen && highlightedIndex >= 0) {
            const option = optionRefs.current[highlightedIndex];
            option === null || option === void 0 || option.focus();
        }
    }, [
        highlightedIndex,
        isOpen
    ]);
    // focus updated when using keyboard nav
    $42ae15e7db4265d6$var$react_1.default.useEffect(()=>{
        var _a;
        if (isOpen) {
            const idx = dropdownOptions.findIndex((opt)=>opt.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value));
            setHighlightedIndex(idx >= 0 ? idx : -1);
            (_a = menuRef.current) === null || _a === void 0 || _a.focus();
        }
    }, [
        isOpen,
        dropdownOptions,
        selectedOption
    ]);
    if (!isOpen) return null;
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev < dropdownOptions.length - 1 ? prev + 1 : 0);
                break;
            case "ArrowUp":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev > 0 ? prev - 1 : dropdownOptions.length - 1);
                break;
            case "Enter":
                event.preventDefault();
                const dropdownOptionHighlighted = dropdownOptions[highlightedIndex];
                if (highlightedIndex !== -1 && dropdownOptionHighlighted) onOptionSelect(dropdownOptionHighlighted);
                break;
            case "Tab":
            case "Escape":
                event.preventDefault();
                onDismiss();
                break;
            default:
                break;
        }
    };
    const setOptionRef = (el, index)=>{
        if (el) optionRefs.current[index] = el;
    };
    const dropdownContainerStyles = {
        position: "absolute",
        top: "100%",
        left: 0,
        minWidth: "100%",
        mt: "spacing-1",
        width: "max-content",
        maxHeight: ()=>"250px",
        overflowY: "auto",
        border: "1px solid",
        borderColor: "field-stroke",
        borderRadius: "radius-2",
        backgroundColor: "field-surface",
        boxShadow: "shadow-100",
        zIndex: "dropdown",
        transition: "transition-color-medium"
    };
    const dropdownItemContainerStyles = {
        px: "spacing-5",
        py: "spacing-3",
        transition: "transition-color-medium",
        ":hover": {
            backgroundColor: "field-surface-highlight"
        }
    };
    const dropdownItemStyles = {
        borderBottomWidth: 0,
        borderColor: "transparent",
        borderInlineEndWidth: 0,
        borderInlineStartWidth: "3px",
        borderStyle: "solid",
        borderTopWidth: 0,
        cursor: "pointer",
        px: "spacing-4",
        py: "spacing-2",
        transition: "transition-color-medium"
    };
    return $42ae15e7db4265d6$var$react_1.default.createElement($2wkl1.Box, {
        sx: dropdownContainerStyles,
        role: "listbox",
        ref: menuRef,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, dropdownOptions.length > 0 ? dropdownOptions.map((option, index)=>{
        const isHighlighted = index === highlightedIndex;
        const isSelected = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value;
        return $42ae15e7db4265d6$var$react_1.default.createElement($2wkl1.Box, {
            key: option.value,
            role: "option",
            tabIndex: -1,
            "aria-selected": isHighlighted,
            ref: (el)=>setOptionRef(el, index),
            onClick: ()=>onOptionSelect(option),
            onMouseEnter: ()=>setHighlightedIndex(index),
            sx: Object.assign(Object.assign({}, dropdownItemContainerStyles), isHighlighted && {
                backgroundColor: "field-surface-highlight"
            })
        }, $42ae15e7db4265d6$var$react_1.default.createElement($2wkl1.Box, {
            sx: Object.assign(Object.assign({}, dropdownItemStyles), isSelected && {
                borderColor: "field-onSurface-highlight"
            })
        }, $42ae15e7db4265d6$var$react_1.default.createElement($2wkl1.Text, {
            variant: "body-1-regular",
            sx: {
                color: "field-text-primary"
            }
        }, option.label)));
    }) : showNoResults ? $42ae15e7db4265d6$var$react_1.default.createElement($2wkl1.Box, {
        role: "option",
        sx: {
            padding: "spacing-4",
            color: "text-incidental"
        }
    }, noResultsMessage) : null);
};
module.exports.DropdownMenu = $42ae15e7db4265d6$var$DropdownMenu;

});



parcelRegister("MihZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Link = void 0;

var $8JPFq = parcelRequire("8JPFq");
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function() {
        return $8JPFq.Link;
    }
});

});
parcelRegister("8JPFq", function(module, exports) {
"use client";
"use strict";
var $65ca9abdd093e265$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $65ca9abdd093e265$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Link = void 0;

const $65ca9abdd093e265$var$react_1 = $65ca9abdd093e265$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $65ca9abdd093e265$var$Link = (props)=>{
    const { icon: icon, iconPosition: iconPosition = "start", children: children, disabled: disabled = false, sx: sx } = props, restProps = $65ca9abdd093e265$var$__rest(props, [
        "icon",
        "iconPosition",
        "children",
        "disabled",
        "sx"
    ]);
    const linkStyles = Object.assign(Object.assign({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "spacing-2",
        color: disabled ? "text-disabled" : "text-link",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        textDecoration: "underline",
        textDecorationColor: "transparent",
        transition: "transition-color-medium"
    }, disabled ? {} : {
        "&:focus-visible": {
            borderColor: "link01",
            borderRadius: "medium",
            borderStyle: "solid",
            color: "cta02Text",
            paddingX: 1,
            paddingY: 0
        },
        "&:hover": {
            color: "text-link-hover",
            textDecorationColor: "currentColor"
        },
        "&:active": {
            color: "text-link-click",
            textDecorationColor: "currentColor"
        }
    }), sx);
    const renderIcon = ()=>{
        return(// override ts error for using em
        // setting to 1em auto scales the icon to match the size of the link text
        $65ca9abdd093e265$var$react_1.default.createElement($2wkl1.Icon, {
            icon: icon,
            sx: {
                // @ts-ignore
                size: "1em",
                flexShrink: 0
            },
            color: "inherit"
        }));
    };
    return $65ca9abdd093e265$var$react_1.default.createElement($2wkl1.Target, Object.assign({}, restProps, {
        sx: Object.assign({}, linkStyles),
        disabled: disabled
    }), icon && iconPosition === "start" && renderIcon(), children, icon && iconPosition === "end" && renderIcon());
};
module.exports.Link = $65ca9abdd093e265$var$Link;

});


parcelRegister("5PYyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logo = module.exports.BRAND_LOGOS = void 0;

var $7sSer = parcelRequire("7sSer");
Object.defineProperty(module.exports, "BRAND_LOGOS", {
    enumerable: true,
    get: function() {
        return $7sSer.BRAND_LOGOS;
    }
});

var $4eCZD = parcelRequire("4eCZD");
Object.defineProperty(module.exports, "Logo", {
    enumerable: true,
    get: function() {
        return $4eCZD.Logo;
    }
});

});
parcelRegister("7sSer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BRAND_LOGOS = void 0;

var $1xWUB = parcelRequire("1xWUB");

var $gMkoW = parcelRequire("gMkoW");
module.exports.BRAND_LOGOS = {
    "bench-2-practice": $1xWUB.Bench2Practice,
    "mnexspike-logo": $gMkoW.MNexSpikeLogo,
    "moderna-atlas": $1xWUB.ModernaAtlas,
    "moderna-logo-white": $1xWUB.ModernaLogoWhite,
    "moderna-logo": $1xWUB.ModernaLogo,
    "mresvia-logo": $1xWUB.MresviaLogo,
    "mrna-access": $1xWUB.MrnaAccess,
    "spikevax-elasomeran": $1xWUB.SpikevaxElasomeran,
    "spikevax-kr": $1xWUB.SpikevaxKr,
    "spikevax-moderna": $1xWUB.SpikevaxModerna,
    "spikevax-navbar": $1xWUB.SpikevaxNavbar,
    "spikevax-registered-french": $1xWUB.SpikevaxRegisteredFrench,
    "spikevax-registered": $1xWUB.SpikevaxRegistered,
    "spikevax": $1xWUB.Spikevax
};

});
parcelRegister("1xWUB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxNavbar = module.exports.SpikevaxKr = module.exports.SpikevaxRegisteredFrench = module.exports.SpikevaxRegistered = module.exports.SpikevaxModerna = module.exports.Spikevax = module.exports.SpikevaxElasomeran = module.exports.MrnaAccess = module.exports.MresviaLogo = module.exports.ModernaLogoWhite = module.exports.ModernaLogo = module.exports.ModernaAtlas = module.exports.MNexSpikeLogo = module.exports.Bench2Practice = void 0;

var $5eYBS = parcelRequire("5eYBS");
Object.defineProperty(module.exports, "Bench2Practice", {
    enumerable: true,
    get: function() {
        return $5eYBS.Bench2Practice;
    }
});

var $gMkoW = parcelRequire("gMkoW");
Object.defineProperty(module.exports, "MNexSpikeLogo", {
    enumerable: true,
    get: function() {
        return $gMkoW.MNexSpikeLogo;
    }
});

var $bMoTQ = parcelRequire("bMoTQ");
Object.defineProperty(module.exports, "ModernaAtlas", {
    enumerable: true,
    get: function() {
        return $bMoTQ.ModernaAtlas;
    }
});

var $37UcL = parcelRequire("37UcL");
Object.defineProperty(module.exports, "ModernaLogo", {
    enumerable: true,
    get: function() {
        return $37UcL.ModernaLogo;
    }
});

var $icrBo = parcelRequire("icrBo");
Object.defineProperty(module.exports, "ModernaLogoWhite", {
    enumerable: true,
    get: function() {
        return $icrBo.ModernaLogoWhite;
    }
});

var $hJJbI = parcelRequire("hJJbI");
Object.defineProperty(module.exports, "MresviaLogo", {
    enumerable: true,
    get: function() {
        return $hJJbI.MresviaLogo;
    }
});

var $2d3aB = parcelRequire("2d3aB");
Object.defineProperty(module.exports, "MrnaAccess", {
    enumerable: true,
    get: function() {
        return $2d3aB.MrnaAccess;
    }
});

var $4Cnhz = parcelRequire("4Cnhz");
Object.defineProperty(module.exports, "SpikevaxElasomeran", {
    enumerable: true,
    get: function() {
        return $4Cnhz.SpikevaxElasomeran;
    }
});

var $i2l8h = parcelRequire("i2l8h");
Object.defineProperty(module.exports, "Spikevax", {
    enumerable: true,
    get: function() {
        return $i2l8h.Spikevax;
    }
});

var $fbIXk = parcelRequire("fbIXk");
Object.defineProperty(module.exports, "SpikevaxModerna", {
    enumerable: true,
    get: function() {
        return $fbIXk.SpikevaxModerna;
    }
});

var $eYHh7 = parcelRequire("eYHh7");
Object.defineProperty(module.exports, "SpikevaxRegistered", {
    enumerable: true,
    get: function() {
        return $eYHh7.SpikevaxRegistered;
    }
});

var $kumwG = parcelRequire("kumwG");
Object.defineProperty(module.exports, "SpikevaxRegisteredFrench", {
    enumerable: true,
    get: function() {
        return $kumwG.SpikevaxRegisteredFrench;
    }
});

var $86T7q = parcelRequire("86T7q");
Object.defineProperty(module.exports, "SpikevaxKr", {
    enumerable: true,
    get: function() {
        return $86T7q.SpikevaxKr;
    }
});

var $8BGGv = parcelRequire("8BGGv");
Object.defineProperty(module.exports, "SpikevaxNavbar", {
    enumerable: true,
    get: function() {
        return $8BGGv.SpikevaxNavbar;
    }
});

});
parcelRegister("5eYBS", function(module, exports) {
"use strict";
var $3d0d466cb397a7ad$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bench2Practice = void 0;

const $3d0d466cb397a7ad$var$react_1 = $3d0d466cb397a7ad$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $3d0d466cb397a7ad$var$Bench2Practice = ({ sx: sx = {} })=>{
    return $3d0d466cb397a7ad$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 300 38",
        "aria-label": "Bench2Practice Logo"
    }, $3d0d466cb397a7ad$var$react_1.default.createElement("path", {
        fill: "#E31837",
        d: "M11.493 8.323c-3.3 0-6.16 1.393-8.46 4.173V.726H.331v29.258h2.703v-3.892c2.147 2.939 4.96 4.45 8.377 4.45a11.027 11.027 0 0 0 10.925-11.086c0-5.958-4.676-11.133-10.844-11.133Zm-.282 19.594c-4.767 0-8.377-3.734-8.377-8.622a8.253 8.253 0 0 1 8.012-8.495h.365c4.727 0 8.342 4.01 8.342 8.59 0 4.578-3.444 8.54-8.32 8.54zm25.751.107c-4.525 0-7.827-3.533-7.942-8.383h18.985c-.08-6.978-4.926-11.319-10.925-11.319-6.592 0-10.844 5.403-10.844 11.16 0 5.638 4.026 11.006 11.005 11.006 4.612 0 7.908-2.102 10.052-6.313l-2.262-1.192c-1.552 2.553-3.659 5.04-8.069 5.04Zm.158-17.082c3.662 0 6.794 1.946 7.908 6.313H29.296c1.232-4.295 4.05-6.308 7.822-6.308zm26.535-2.62c-3.095 0-5.72 1.468-7.905 4.333V8.88h-2.703v21.09h2.703v-8.858c0-3.339.239-5.4 1.822-7.467a6.76 6.76 0 0 1 5.564-2.832c4.091 0 5.637 2.738 5.637 7.704v11.466h2.7V18.146c.006-6.646-3.21-9.824-7.818-9.824m24.343 19.703c-5.441 0-8.947-4.01-8.947-8.618 0-4.531 3.533-8.458 8.898-8.458 3.178 0 5.76 1.192 7.626 3.658l2.185-1.342c-1.949-3.253-5.637-4.925-9.693-4.925-6.951 0-11.794 5.084-11.794 11.273 0 5.878 4.644 10.882 11.596 10.882 4.249 0 7.827-1.63 9.89-4.767l-2.17-1.415a9.35 9.35 0 0 1-7.591 3.712M174.461 8.13c-2.147 0-3.857 1.316-5.443 3.62V8.69h-2.848v21.102h2.848v-8.023c0-2.848.078-5.043.435-6.394.805-2.901 2.582-4.611 4.563-4.611.502.021.992.161 1.43.408l1.428-2.306a4.26 4.26 0 0 0-2.413-.735Zm23.078.567v3.852a9.97 9.97 0 0 0-8.42-4.421 10.98 10.98 0 0 0-10.884 11.045c0 6 4.648 11.123 10.803 11.123 3.299 0 6.198-1.342 8.498-4.133v3.618h2.663V8.697zm-8.2 19.143c-4.727 0-8.302-4.01-8.302-8.59a8.346 8.346 0 0 1 8.197-8.494h.145c4.727 0 8.377 3.693 8.377 8.589a8.32 8.32 0 0 1-8.125 8.498zm27.706.004c-5.443 0-8.949-4.01-8.949-8.62 0-4.525 3.535-8.457 8.895-8.457 3.181 0 5.761 1.192 7.626 3.659l2.185-1.342c-1.943-3.254-5.637-4.926-9.687-4.926-6.952 0-11.81 5.1-11.81 11.274 0 5.878 4.649 10.884 11.601 10.884 4.251 0 7.826-1.627 9.888-4.767l-2.185-1.393a9.35 9.35 0 0 1-7.564 3.688m20.09-19.146V.836h-2.7v7.862h-3.734v2.383h3.734V29.79h2.7V11.08h4.338V8.698zM246.43 0a2.22 2.22 0 0 0-2.054 1.365 2.253 2.253 0 0 0 2.054 3.114 2.29 2.29 0 0 0 2.266-2.265A2.26 2.26 0 0 0 246.43 0m-1.31 8.7v21.09h2.701V8.7zm19.023 19.144c-5.438 0-8.949-4.01-8.949-8.62 0-4.525 3.535-8.457 8.9-8.457 3.176 0 5.761 1.192 7.626 3.659l2.185-1.342c-1.949-3.254-5.637-4.926-9.692-4.926-6.952 0-11.811 5.1-11.811 11.274 0 5.878 4.647 10.884 11.599 10.884 4.248 0 7.824-1.627 9.891-4.767l-2.185-1.393a9.36 9.36 0 0 1-7.564 3.688m24.704 0c-4.525 0-7.821-3.532-7.942-8.377h18.985c-.075-6.979-4.926-11.324-10.919-11.324-6.595 0-10.844 5.405-10.844 11.166 0 5.636 4.01 11.005 11.005 11.005 4.609 0 7.902-2.108 10.047-6.319l-2.263-1.192c-1.552 2.54-3.659 5.041-8.069 5.041m.159-17.082c3.661 0 6.793 1.944 7.907 6.316h-15.715c1.229-4.295 4.053-6.31 7.821-6.31zm-167.942 3.992c-.904-4.27-3.739-6.442-7.48-6.442-3.135 0-5.72 1.468-7.902 4.332V.727h-2.711v29.257h2.711v-8.858c0-3.377.268-5.443 1.822-7.467a6.76 6.76 0 0 1 5.562-2.846c4.09 0 5.602 2.738 5.602 7.704v11.469h2.7V26.27a11.43 11.43 0 0 1-.304-11.515Zm30.202-6.623a9.97 9.97 0 0 0-8.382 4.41v-3.84h-2.7v4.55a11.43 11.43 0 0 1 0 14.005v10.24h2.7v-11.32c2.303 2.784 5.164 4.134 8.46 4.134 6.198 0 10.841-5.126 10.841-11.125A10.983 10.983 0 0 0 151.266 8.13Zm-.198 19.702a8.28 8.28 0 0 1-8.372-8.16v-.316c0-4.88 3.658-8.59 8.382-8.59a8.374 8.374 0 0 1 8.343 8.402v.096c-.011 4.609-3.669 8.579-8.353 8.579z"
    }), $3d0d466cb397a7ad$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M125.347 11.618a10.39 10.39 0 0 1 13.121 1.293 10.39 10.39 0 0 1 1.289 13.12 10.39 10.39 0 0 1-15.986 1.573 10.392 10.392 0 0 1 1.576-15.986m9.686 14.109V24.07h-4.953l1.243-1.301 1.219-1.305a14 14 0 0 0 1.709-2.118 4.1 4.1 0 0 0 .645-2.182 3.67 3.67 0 0 0-1.09-2.654 3.86 3.86 0 0 0-2.722-1.074 3.98 3.98 0 0 0-2.877 1.17 4.35 4.35 0 0 0-1.205 2.969v.276h1.624v-.247c.029-.691.29-1.353.74-1.878a2.2 2.2 0 0 1 1.656-.693 2.25 2.25 0 0 1 1.568.615 2.1 2.1 0 0 1 .639 1.51 2.77 2.77 0 0 1-.521 1.568 15 15 0 0 1-1.533 1.826l-2.402 2.587-2.416 2.588z"
    }), $3d0d466cb397a7ad$var$react_1.default.createElement("path", {
        fill: "#26A8E0",
        d: "M125.347 11.618a10.39 10.39 0 0 1 13.121 1.293 10.39 10.39 0 0 1 1.289 13.12 10.39 10.39 0 0 1-15.986 1.573 10.392 10.392 0 0 1 1.576-15.986m9.686 14.109V24.07h-4.953l1.243-1.301 1.219-1.305a14 14 0 0 0 1.709-2.118 4.1 4.1 0 0 0 .645-2.182 3.67 3.67 0 0 0-1.09-2.654 3.86 3.86 0 0 0-2.722-1.074 3.98 3.98 0 0 0-2.877 1.17 4.35 4.35 0 0 0-1.205 2.969v.276h1.624v-.247c.029-.691.29-1.353.74-1.878a2.2 2.2 0 0 1 1.656-.693 2.25 2.25 0 0 1 1.568.615 2.1 2.1 0 0 1 .639 1.51 2.77 2.77 0 0 1-.521 1.568 15 15 0 0 1-1.533 1.826l-2.402 2.587-2.416 2.588z"
    }));
};
module.exports.Bench2Practice = $3d0d466cb397a7ad$var$Bench2Practice;

});

parcelRegister("gMkoW", function(module, exports) {
"use strict";
var $c370f4503014e9fe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MNexSpikeLogo = void 0;

const $c370f4503014e9fe$var$react_1 = $c370f4503014e9fe$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $c370f4503014e9fe$var$MNexSpikeLogo = ({ sx: sx = {} })=>{
    return $c370f4503014e9fe$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 123 40",
        "aria-label": "mNEXSPIKE Logo"
    }, $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m45.52 17.362v4.8886h-1.8237v-4.872c0-1.5225-0.6245-2.3198-1.8071-2.3198-1.249 0-2.0448 0.9468-2.0448 2.5025v4.6893h-1.8402v-4.872c0-1.5225-0.6245-2.3198-1.8237-2.3198s-2.0282 1.0132-2.0282 2.5523v4.634h-1.8237v-8.6645h1.5861l0.2044 1.135c0.4919-0.6422 1.2324-1.218 2.5311-1.2346 1.1495 0 2.1608 0.4595 2.6692 1.5723 0.5748-0.9467 1.5529-1.5723 2.9898-1.5723 1.7242 0 3.2108 0.9799 3.2108 3.8754v0.0056z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m47.09 10.408h1.774l5.7585 8.3931v-8.3931h1.9066v11.842h-1.774l-5.7585-8.3931v8.3931h-1.9066v-11.842z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m65.57 10.408v1.7274h-5.7751v3.283h4.7637v1.6775h-4.7637v3.4326h5.9795v1.7274h-7.9192v-11.848h7.7203-0.0055z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m66.714 10.408h2.3156l2.7023 4.2132 2.7356-4.2132h2.1276l-3.7302 5.7855 3.9513 6.0568h-2.3487l-2.9234-4.4678-2.9401 4.4678h-2.111l3.9513-6.0568-3.7303-5.7855z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m78.215 18.397c0.0995 1.3897 1.1993 2.3198 2.8572 2.3198 1.4037 0 2.415-0.6256 2.415-1.7606 0-1.2512-1.2324-1.5225-3.1058-1.8602-1.9564-0.3377-3.8187-0.9633-3.8187-3.3163 0-2.0484 1.7242-3.4879 4.2055-3.4879 2.4814 0 4.3548 1.5391 4.4598 3.6706h-1.9066c-0.1382-1.2014-1.1329-2.0318-2.5532-2.0318-1.3374 0-2.2658 0.5924-2.2658 1.7107 0 1.218 1.2158 1.4727 3.0727 1.7938 1.9618 0.3543 3.8684 0.9799 3.8518 3.3163 0 2.0983-1.8237 3.6042-4.3768 3.6042-2.8572 0-4.6974-1.661-4.7472-3.9918l1.9066 0.0332h0.0055z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m90.947 10.408c2.4648 0 4.0895 1.4727 4.0895 3.7758s-1.6192 3.7758-4.0895 3.7758h-2.719v4.2963h-1.9397v-11.848h4.6642-0.0055zm-2.719 5.8575h2.5532c1.3871 0 2.2824-0.8139 2.2824-2.0817s-0.8787-2.0817-2.2658-2.0817h-2.5698v4.1634z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m97.954 10.408v11.842h-1.9398v-11.842h1.9398z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m101.22 10.408v6.1066l5.421-6.1066h2.366l-4.344 4.9385 4.664 6.9038h-2.348l-3.698-5.4146-2.061 2.3198v3.0948h-1.9396v-11.842h1.9396z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m117.94 10.408v1.7274h-5.775v3.283h4.764v1.6775h-4.764v3.4326h5.98v1.7274h-7.919v-11.848h7.72-6e-3z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m36.839 32.88c-0.0939 1.672-0.8621 2.6077-2.1719 2.6077-1.4976 0-2.3376-1.1627-2.3376-3.7925 0-2.6297 0.84-3.7924 2.3376-3.7924 1.4977 0 2.1001 1.0575 2.1001 2.2589h-0.6577c0-0.9966-0.5029-1.7052-1.4479-1.7052-1.0445 0-1.68 0.8636-1.68 3.2332s0.6355 3.2332 1.68 3.2332c0.9229 0 1.4479-0.7917 1.5198-2.0539h0.6576v0.011z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m39.823 27.909c1.4976 0 2.3376 1.1626 2.3376 3.7924s-0.84 3.7924-2.3376 3.7924-2.3376-1.1626-2.3376-3.7924 0.84-3.7924 2.3376-3.7924zm0 7.0256c1.0445 0 1.68-0.8636 1.68-3.2332s-0.6355-3.2332-1.68-3.2332-1.68 0.8636-1.68 3.2332 0.6355 3.2332 1.68 3.2332z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m42.393 28.03h0.6963l1.6303 6.6381h0.0221l1.6303-6.6381h0.6963l-1.9287 7.3357h-0.8179l-1.9287-7.3357z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m47.863 28.03h0.6576v7.3357h-0.6576v-7.3357z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m49.77 28.031h1.7629c2.1332 0 2.6582 1.2734 2.6582 3.6651s-0.525 3.6651-2.6582 3.6651h-1.7629v-7.3357 0.0055zm0.6521 6.7821h1.0666c1.4369 0 2.0392-0.7197 2.0392-3.1004 0-2.3806-0.6023-3.1225-2.0392-3.1225h-1.0666v6.2229z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m57.546 32.172v0.5536h-2.2271v-0.5536h2.2271z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m59.64 29.797h-1.6634v-0.454c1.2213-0.0111 1.7629-0.4927 1.8071-1.2512h0.4697v7.2748h-0.6134v-5.5696z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m62.36 33.783c0.0331 0.7086 0.431 1.1903 1.1495 1.1903 1.0058 0 1.4976-0.9024 1.5308-3.3052l-0.0221-0.0221c-0.2377 0.7474-0.7903 1.1903-1.5585 1.1903-1.26 0-1.9066-0.9246-1.9066-2.2589 0-1.3342 0.6245-2.4858 2.0227-2.4858 1.6413 0 2.1221 1.2125 2.1221 3.5045 0 2.2921-0.4697 3.8921-2.2161 3.8921-1.1494 0-1.7518-0.7087-1.7739-1.7052h0.6576-0.0055zm1.1992-1.4561c0.9947 0 1.354-0.9245 1.354-1.8602 0-0.9356-0.3593-1.8602-1.354-1.8602s-1.354 0.9246-1.354 1.8602c0 0.9357 0.3482 1.8602 1.354 1.8602z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m68.526 28.03h0.6963l1.6303 6.6381h0.0221l1.6302-6.6381h0.6964l-1.9287 7.3357h-0.8179l-1.9287-7.3357z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m73.235 31.535c0-1.1184 0.5305-1.744 1.68-1.744s1.5363 0.5869 1.5363 1.4505v3.2278c0 0.31 0.105 0.4539 0.3206 0.4539h0.1768v0.454c-0.1105 0.0388-0.2045 0.0609-0.2874 0.0609-0.4808 0-0.7902-0.1107-0.7902-0.6754v-0.1827h-0.0221c-0.2487 0.7197-0.8014 0.9246-1.4037 0.9246-0.9561 0-1.3816-0.598-1.3816-1.5392 0-0.7197 0.326-1.2955 1.0997-1.5114l1.1606-0.3266c0.431-0.1218 0.525-0.227 0.525-0.8637 0-0.6976-0.3924-0.9467-0.9451-0.9467-0.7294 0-1.0444 0.4429-1.0444 1.2346h-0.6135l-0.011-0.0166zm2.6029 0.7474h-0.0221c-0.0608 0.1827-0.409 0.299-0.6576 0.3599l-0.514 0.1328c-0.6134 0.1661-0.9339 0.4817-0.9339 1.1294 0 0.6478 0.326 1.0686 0.8621 1.0686 0.746 0 1.26-0.5647 1.26-1.5391v-1.1516h0.0055z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m80.828 33.561c-0.094 1.1626-0.7295 1.9322-1.7353 1.9322-1.1495 0-1.8237-0.8028-1.8237-2.8568 0-1.8879 0.6742-2.8457 1.879-2.8457 1.0279 0 1.6192 0.6256 1.68 1.744h-0.6134c-0.0719-0.8526-0.409-1.2346-1.0666-1.2346s-1.2213 0.4097-1.2213 2.3419c0 2.0539 0.5858 2.3308 1.1605 2.3308 0.6245 0 1.0279-0.4596 1.1274-1.4173h0.6134v0.0055z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m84.94 33.561c-0.0939 1.1626-0.7294 1.9322-1.7352 1.9322-1.1495 0-1.8237-0.8028-1.8237-2.8568 0-1.8879 0.6742-2.8457 1.8789-2.8457 1.0279 0 1.6192 0.6256 1.68 1.744h-0.6134c-0.0718-0.8526-0.4089-1.2346-1.0666-1.2346-0.6576 0-1.2213 0.4097-1.2213 2.3419 0 2.0539 0.5858 2.3308 1.1605 2.3308 0.6245 0 1.0279-0.4596 1.1274-1.4173h0.6134v0.0055z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m85.725 28.03h0.6134v1.0464h-0.6134v-1.0464zm0 1.8823h0.6134v5.4534h-0.6134v-5.4534z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m87.371 29.914h0.5526v0.7585h0.0221c0.3095-0.6035 0.84-0.8859 1.3927-0.8859 0.8289 0 1.3926 0.4319 1.3926 1.4561v4.1191h-0.6134v-3.9419c0-0.7474-0.3095-1.1184-0.934-1.1184-0.7184 0-1.1992 0.5537-1.1992 1.3952v3.6651h-0.6134v-5.4534 0.0056z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m95.142 33.561c-0.094 1.1626-0.7295 1.9322-1.7519 1.9322-1.1495 0-1.8237-0.8028-1.8237-2.8568 0-1.8879 0.6742-2.8457 1.879-2.8457 1.2047 0 1.7518 0.8305 1.7518 2.6519v0.227h-2.9732v0.2547c0 1.5723 0.5527 2.054 1.1606 2.054 0.6466 0 1.0445-0.4595 1.1495-1.4173h0.6134-0.0055zm-0.6024-1.4118c-0.0221-1.3564-0.3979-1.8491-1.1606-1.8491-0.7626 0-1.1384 0.4927-1.1605 1.8491h2.3211z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m96.175 34.32h0.6964v1.0464c0 0.6035-0.1216 1.1792-0.7571 1.4173v-0.4097c0.2652-0.1661 0.3481-0.454 0.3592-1.0076h-0.2985v-1.0464z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m100.81 29.914h0.552v0.7585h0.022c0.288-0.6035 0.78-0.8859 1.382-0.8859 0.658 0 1.056 0.3987 1.138 0.9578h0.023c0.248-0.6034 0.685-0.9578 1.381-0.9578 0.757 0 1.26 0.4319 1.26 1.4063v4.1689h-0.613v-4.0803c0-0.6478-0.299-0.9855-0.851-0.9855-0.614 0-1.106 0.5536-1.106 1.3951v3.6651h-0.613v-4.0803c0-0.6477-0.298-0.9855-0.851-0.9855-0.614 0-1.105 0.5537-1.105 1.3952v3.6651h-0.614v-5.4533l-5e-3 0.0166z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m107.52 28.03h2.182c1.222 0 1.896 0.6976 1.896 1.8381 0 0.8858-0.348 1.6719-1.321 1.8602v0.0221c0.912 0.0831 1.221 0.6035 1.249 1.7384l0.022 0.8028c0.011 0.3986 0.05 0.7917 0.31 1.0796h-0.768c-0.155-0.2547-0.183-0.6367-0.194-1.0298l-0.022-0.6145c-0.039-1.2955-0.276-1.7052-1.453-1.7052h-1.244v3.3495h-0.657v-7.3412zm0.657 3.4325h1.128c1.033 0 1.641-0.4706 1.641-1.4394 0-0.8914-0.381-1.4395-1.57-1.4395h-1.199v2.8789z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m112.74 28.03h0.885l2.801 6.389h0.022v-6.389h0.658v7.3357h-0.884l-2.802-6.389h-0.022v6.389h-0.658v-7.3357z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m120.02 28.03h0.818l2.166 7.3357h-0.696l-0.597-2.1371h-2.564l-0.597 2.1371h-0.696l2.166-7.3357zm1.553 4.645-1.128-4.1301h-0.022l-1.127 4.1301h2.277z",
        fill: "#505457"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m120.81 10.453c0.956 0 1.686 0.7198 1.686 1.6609 0 0.9412-0.724 1.6554-1.686 1.6554-0.961 0-1.674-0.7086-1.674-1.6443 0-0.9356 0.724-1.672 1.674-1.672zm0 0.3267c-0.757 0-1.315 0.5647-1.315 1.3453s0.558 1.3232 1.315 1.3232 1.321-0.5647 1.321-1.3287-0.558-1.3398-1.321-1.3398zm0.072 0.4152c0.437 0 0.708 0.2325 0.708 0.5813 0 0.2658-0.161 0.4595-0.426 0.5315l0.437 0.7253h-0.393l-0.387-0.6533h-0.281v0.6533h-0.354v-1.8381h0.702-6e-3zm-0.348 0.8914h0.332c0.199 0 0.353-0.1108 0.353-0.3045 0-0.1938-0.143-0.2824-0.353-0.2824h-0.332v0.5869z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m27.488 20.507c-0.0498 0-0.094-0.0111-0.1437-0.0277-0.0663-0.0276-0.1326-0.0609-0.2045-0.1162-0.6466-0.4817-1.4202-1.589-1.7629-2.4028-0.7184-1.6942-1.5363-3.6153-3.4761-3.6153-1.9397 0-2.7576 1.9211-3.476 3.6153-0.4808 1.1405-1.0832 2.5578-1.7629 2.5578-0.6798 0-1.2822-1.4173-1.7629-2.5578-0.7185-1.6942-1.5364-3.6153-3.4761-3.6153-1.9398 0-2.7577 1.9211-3.4761 3.6153-0.4808 1.1405-1.0832 2.5578-1.7629 2.5578s-1.2821-1.4173-1.7629-2.5578c-0.71842-1.6942-1.5087-3.6153-3.4761-3.6153-0.53053 0-0.91737 0.371-0.91737 0.8249 0 0.454 0.38684 0.825 0.91737 0.825 0.65211 0 1.2821 1.4173 1.7629 2.5578 0.71843 1.6941 1.5363 3.6152 3.4761 3.6152s2.7576-1.9211 3.4761-3.6152c0.48083-1.1405 1.0831-2.5578 1.7629-2.5578 0.6797 0 1.2821 1.4173 1.7629 2.5578 0.7184 1.6941 1.5363 3.6152 3.4761 3.6152 1.9397 0 2.7576-1.9211 3.476-3.6152 0.4808-1.1405 1.0832-2.5578 1.7629-2.5578 0.6798 0 1.2822 1.4173 1.7629 2.5578 0.7185 1.6941 1.879 3.5986 3.8188 3.5986 0.5305 0 0.9173-0.3709 0.9173-0.8249s-0.3868-0.8249-0.9173-0.8249l0.0055 0.0055z",
        fill: "#EA2744"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m26.858 8.532-11.163-6.4554c-0.9284-0.53703-2.0889-0.53703-3.0173 0l-11.169 6.4554c-0.92842 0.53702-1.5087 1.5391-1.5087 2.6187v1.2402c0 0.5038 0.40895 0.9135 0.91185 0.9135 0.5029 0 0.91185-0.4097 0.91185-0.9135v-1.2402c0-0.4263 0.2321-0.8249 0.59684-1.0408l10.859-6.2783v2.7571c0 0.49827 0.4034 0.90243 0.9008 0.90243s0.9008-0.40416 0.9008-0.90243v-2.7571l10.865 6.2838c0.3703 0.2159 0.5969 0.6146 0.5969 1.0409v1.2401c0 0.5038 0.4089 0.9135 0.9118 0.9135s0.9119-0.4097 0.9119-0.9135v-1.2401c0-1.0741-0.5803-2.0817-1.5087-2.6188v-0.00553z",
        fill: "#0B867D"
    }), $c370f4503014e9fe$var$react_1.default.createElement("path", {
        d: "m27.477 23.198c-0.5029 0-0.9118 0.4097-0.9118 0.9135v1.2402c0 0.4263-0.2321 0.8249-0.5969 1.0408l-10.865 6.2838v-2.7239c0-0.4983-0.4034-0.9024-0.9008-0.9024-0.4973 0-0.9008 0.4041-0.9008 0.9024v2.7295l-10.865-6.2838c-0.37026-0.216-0.59684-0.6146-0.59684-1.0409v-1.2401c0-0.5038-0.40895-0.9135-0.91185-0.9135-0.5029 0-0.91185 0.4097-0.91185 0.9135v1.2401c0 1.0741 0.58027 2.0817 1.5087 2.6187l11.163 6.4554c0.9285 0.5371 2.089 0.5371 3.0174 0l11.163-6.4554c0.9285-0.537 1.5087-1.5391 1.5087-2.6187v-1.2401c0-0.5038-0.4089-0.9135-0.9118-0.9135l0.011-0.0056z",
        fill: "#0B867D"
    }));
};
module.exports.MNexSpikeLogo = $c370f4503014e9fe$var$MNexSpikeLogo;

});

parcelRegister("bMoTQ", function(module, exports) {
"use strict";
var $89377dfc3a5ad398$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModernaAtlas = void 0;

const $89377dfc3a5ad398$var$react_1 = $89377dfc3a5ad398$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $89377dfc3a5ad398$var$ModernaAtlas = ({ sx: sx = {} })=>{
    return $89377dfc3a5ad398$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 163 24",
        "aria-label": "Moderna Atlas logo"
    }, $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M96.956 22.531h-1.499c-.34 0-.527.255-.527.748s.177.721.527.721h5.756c.367 0 .577-.255.577-.72 0-.466-.183-.749-.577-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#2AACE1",
        d: "M96.956 22.531h-1.499c-.34 0-.527.255-.527.748s.177.721.527.721h5.756c.367 0 .577-.255.577-.72 0-.466-.183-.749-.577-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M88.19 22.531h-1.497c-.34 0-.574.255-.574.748s.2.721.574.721h5.739c.36 0 .537-.255.537-.72 0-.466-.177-.749-.537-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#3EB4E4",
        d: "M88.19 22.531h-1.497c-.34 0-.574.255-.574.748s.2.721.574.721h5.739c.36 0 .537-.255.537-.72 0-.466-.177-.749-.537-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M79.827 22.531h-1.492c-.367 0-.53.255-.53.748s.163.721.53.721h5.738c.368 0 .578-.255.578-.72 0-.466-.183-.749-.578-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#4BB8E7",
        d: "M79.827 22.531h-1.492c-.367 0-.53.255-.53.748s.163.721.53.721h5.738c.368 0 .578-.255.578-.72 0-.466-.183-.749-.578-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M71.048 22.531h-1.483c-.367 0-.578.255-.578.748s.184.721.578.721h5.739c.367 0 .574-.255.574-.72 0-.466-.183-.749-.574-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#57BDE9",
        d: "M71.048 22.531h-1.483c-.367 0-.578.255-.578.748s.184.721.578.721h5.739c.367 0 .574-.255.574-.72 0-.466-.183-.749-.574-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M62.222 22.531h-1.489c-.36 0-.578.255-.578.748s.19.721.578.721h5.728c.368 0 .575-.255.575-.72 0-.466-.184-.749-.575-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#64C3EB",
        d: "M62.222 22.531h-1.489c-.36 0-.578.255-.578.748s.19.721.578.721h5.728c.368 0 .575-.255.575-.72 0-.466-.184-.749-.575-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M53.908 22.531h-1.496c-.367 0-.571.255-.571.748s.183.721.571.721h5.745c.367 0 .568-.255.568-.72 0-.466-.177-.749-.568-.749h-4.25Z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#71C7EB",
        d: "M53.908 22.531h-1.496c-.367 0-.571.255-.571.748s.183.721.571.721h5.745c.367 0 .568-.255.568-.72 0-.466-.177-.749-.568-.749h-4.25Z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M45.1 22.531h-1.482c-.367 0-.57.255-.57.748s.183.721.57.721h5.742c.38 0 .571-.255.571-.72 0-.466-.153-.749-.57-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#7ECDED",
        d: "M45.1 22.531h-1.482c-.367 0-.57.255-.57.748s.183.721.57.721h5.742c.38 0 .571-.255.571-.72 0-.466-.153-.749-.57-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M36.294 22.531h-1.486c-.367 0-.57.255-.57.748s.19.721.57.721h5.749c.34 0 .534-.255.534-.72 0-.466-.194-.749-.534-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#8BD2EF",
        d: "M36.294 22.531h-1.486c-.367 0-.57.255-.57.748s.19.721.57.721h5.749c.34 0 .534-.255.534-.72 0-.466-.194-.749-.534-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M27.978 22.531h-1.52c-.367 0-.577.255-.577.748s.183.721.577.721h5.739c.367 0 .575-.255.575-.72 0-.466-.184-.749-.575-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#97D6F0",
        d: "M27.978 22.531h-1.52c-.367 0-.577.255-.577.748s.183.721.577.721h5.739c.367 0 .575-.255.575-.72 0-.466-.184-.749-.575-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M19.139 22.531h-1.482c-.367 0-.571.255-.571.748s.183.721.57.721h5.746c.367 0 .571-.255.571-.72 0-.466-.183-.749-.57-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#A4DCF3",
        d: "M19.139 22.531h-1.482c-.367 0-.571.255-.571.748s.183.721.57.721h5.746c.367 0 .571-.255.571-.72 0-.466-.183-.749-.57-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M10.35 22.531H8.859c-.36 0-.544.255-.544.748s.184.721.544.721H14.6c.367 0 .544-.255.544-.72 0-.466-.177-.749-.544-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#B1E0F5",
        d: "M10.35 22.531H8.859c-.36 0-.544.255-.544.748s.184.721.544.721H14.6c.367 0 .544-.255.544-.72 0-.466-.177-.749-.544-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M2.026 22.531H.53c-.367 0-.53.255-.53.748S.163 24 .53 24h5.78c.363 0 .544-.255.544-.72 0-.466-.184-.749-.544-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#BEE6F6",
        d: "M2.026 22.531H.53c-.367 0-.53.255-.53.748S.163 24 .53 24h5.78c.363 0 .544-.255.544-.72 0-.466-.184-.749-.544-.749z"
    }), $89377dfc3a5ad398$var$react_1.default.createElement("path", {
        fill: "#E31837",
        d: "M0 4.732h1.54v2.162a5.8 5.8 0 0 1 1.659-1.72 4.8 4.8 0 0 1 2.478-.742 4.2 4.2 0 0 1 1.68.34 3.4 3.4 0 0 1 1.312.952c.392.501.687 1.07.87 1.68a6.16 6.16 0 0 1 1.969-2.224 4.57 4.57 0 0 1 2.515-.754 3.84 3.84 0 0 1 2.217.656 4 4 0 0 1 1.438 1.812c.35 1.113.506 2.278.459 3.444v6.82h-1.595v-6.8a9 9 0 0 0-.275-2.74 2.47 2.47 0 0 0-.959-1.2 2.74 2.74 0 0 0-1.597-.452 3.53 3.53 0 0 0-2.074.68 4 4 0 0 0-1.36 1.818 12.4 12.4 0 0 0-.425 3.808v4.885H8.261v-6.279a11.2 11.2 0 0 0-.262-3.06 2.65 2.65 0 0 0-.958-1.281 2.74 2.74 0 0 0-1.619-.483 3.37 3.37 0 0 0-2.019.656 3.9 3.9 0 0 0-1.394 1.788 10 10 0 0 0-.432 3.444v5.246H.01zm27.408 1.272a4.47 4.47 0 0 0-3.369 1.489 5.05 5.05 0 0 0-1.41 3.6c0 .89.226 1.766.655 2.546.394.75.99 1.374 1.72 1.802a4.76 4.76 0 0 0 4.78 0 4.45 4.45 0 0 0 1.717-1.802 5.26 5.26 0 0 0 .656-2.546 5.04 5.04 0 0 0-1.312-3.6 4.44 4.44 0 0 0-3.352-1.49zm0-1.584a6 6 0 0 1 4.65 2.087 6.854 6.854 0 0 1-.105 9.135 6.284 6.284 0 0 1-8.88.302 6 6 0 0 1-.299-.302 6.56 6.56 0 0 1-1.791-4.59 6.67 6.67 0 0 1 1.727-4.525 5.95 5.95 0 0 1 4.688-2.11zm15.249 1.618a4.64 4.64 0 0 0-2.434.656 4.85 4.85 0 0 0-1.765 1.866 5.15 5.15 0 0 0 0 5.038 5 5 0 0 0 1.765 1.87c.73.43 1.56.655 2.407.653.86 0 1.705-.225 2.45-.653a4.8 4.8 0 0 0 1.782-1.798 5.3 5.3 0 0 0 .571-2.563 4.92 4.92 0 0 0-1.404-3.614 4.48 4.48 0 0 0-3.376-1.455zM48.926.003v17.308h-1.547v-2.149a7.1 7.1 0 0 1-2.21 1.85 6.1 6.1 0 0 1-2.696.618 5.9 5.9 0 0 1-4.42-1.934 6.5 6.5 0 0 1-1.835-4.678 6.4 6.4 0 0 1 1.863-4.59 5.96 5.96 0 0 1 4.453-1.913 5.5 5.5 0 0 1 2.72.656A6 6 0 0 1 47.4 7.139V0zm13.92 9.739a5.5 5.5 0 0 0-.928-2.06 4.1 4.1 0 0 0-1.621-1.234 4.7 4.7 0 0 0-5.205.704 5.44 5.44 0 0 0-1.445 2.62l9.2-.03Zm0 3.383 1.313.727a7.3 7.3 0 0 1-1.51 2.111 6.2 6.2 0 0 1-1.965 1.241c-.78.29-1.608.431-2.44.418a5.86 5.86 0 0 1-4.716-2.005 6.87 6.87 0 0 1-1.724-4.56 6.7 6.7 0 0 1 1.435-4.259 5.87 5.87 0 0 1 4.899-2.38 6.05 6.05 0 0 1 5.055 2.414 6.92 6.92 0 0 1 1.36 4.3H53.49a5.16 5.16 0 0 0 1.36 3.584 4.36 4.36 0 0 0 3.278 1.407 5.2 5.2 0 0 0 1.822-.34c.555-.2 1.07-.5 1.516-.887a6.8 6.8 0 0 0 1.36-1.788zm4.187-8.394h1.642v1.822c.41-.631.94-1.176 1.56-1.604a2.87 2.87 0 0 1 3.155-.113l-.843 1.36a2.2 2.2 0 0 0-.846-.217 2.33 2.33 0 0 0-1.56.656c-.58.549-.98 1.26-1.15 2.04a18.8 18.8 0 0 0-.313 4.297v4.215h-1.645zm8.322 0h1.51v2.207a6.4 6.4 0 0 1 2.005-1.9 4.76 4.76 0 0 1 2.434-.657 4 4 0 0 1 2.322.68 4.2 4.2 0 0 1 1.513 1.904c.388 1.207.555 2.474.493 3.74v6.411h-1.517v-5.918a15.3 15.3 0 0 0-.17-2.873 3.15 3.15 0 0 0-1.02-1.856 3 3 0 0 0-1.964-.612 3.62 3.62 0 0 0-2.462.938 4.5 4.5 0 0 0-1.434 2.38 18 18 0 0 0-.218 3.376v4.592h-1.51zm19.66 1.234a4.7 4.7 0 0 0-2.434.657 4.8 4.8 0 0 0-1.758 1.88 5.15 5.15 0 0 0 0 5.055 4.85 4.85 0 0 0 1.772 1.897 4.65 4.65 0 0 0 2.4.656 4.85 4.85 0 0 0 2.45-.656 4.76 4.76 0 0 0 1.792-1.812c.4-.797.597-1.68.572-2.57a5.05 5.05 0 0 0-1.384-3.638 4.6 4.6 0 0 0-3.4-1.472zm6.276-1.227v12.579h-1.55v-2.17a7 7 0 0 1-2.21 1.877 6.1 6.1 0 0 1-2.7.62 5.85 5.85 0 0 1-4.419-1.97 6.6 6.6 0 0 1-1.843-4.7 6.48 6.48 0 0 1 1.86-4.635 5.9 5.9 0 0 1 4.46-1.924 5.6 5.6 0 0 1 2.72.656A6.1 6.1 0 0 1 99.75 7.04V4.738zm2.675 1.074h.197c.105 0 .17 0 .201-.037a.12.12 0 0 0 .068-.112.2.2 0 0 0 0-.086.13.13 0 0 0-.072-.064h-.367zm-.167.578V5.353h.34q.142-.01.282 0a.5.5 0 0 1 .136.126.27.27 0 0 1 .048.143.3.3 0 0 1-.078.204.46.46 0 0 1-.235.105c.055 0 .068.04.099.054.03.014.085.116.146.215l.136.204h-.19l-.085-.17a1 1 0 0 0-.184-.249l-.136-.04h-.098v.459zm.415-1.377a.8.8 0 0 0-.404.112.7.7 0 0 0-.296.31.8.8 0 0 0-.119.418.75.75 0 0 0 .119.408.67.67 0 0 0 .296.302.77.77 0 0 0 .404.116.75.75 0 0 0 .415-.116.68.68 0 0 0 .309-.302.83.83 0 0 0-.309-1.136.74.74 0 0 0-.415-.085zm0-.14c.167 0 .332.034.486.1a.99.99 0 0 1 .497.88 1 1 0 0 1-.109.49 1.3 1.3 0 0 1-.367.373 1.2 1.2 0 0 1-.507.113c-.167 0-.333-.038-.483-.113a1.14 1.14 0 0 1-.367-.374.9.9 0 0 1-.119-.49 1 1 0 0 1 .119-.506c.093-.15.218-.278.367-.374a1.2 1.2 0 0 1 .483-.098Zm19.337 10.487c-.56 0-.804-.17-.804-.828V9.099c0-2.899-1.827-4.482-4.994-4.482-2.996 0-4.97 1.437-5.262 3.873h1.998c.243-1.266 1.413-2.095 3.167-2.095 1.949 0 3.094.975 3.094 2.583v.852h-3.655c-3.264 0-4.994 1.389-4.994 3.874 0 2.265 1.852 3.63 4.58 3.63 2.144 0 3.386-.95 4.166-2.071.024 1.218.585 1.924 2.241 1.924h1.096V15.36zm-2.801-3.24c0 2.07-1.438 3.508-3.923 3.508-1.656 0-2.704-.828-2.704-2.046 0-1.413.999-2.07 2.777-2.07h3.85zm5.896 1.827c0 2.193.853 3.24 3.24 3.24h2.168V15.36h-1.973c-1.072 0-1.438-.39-1.438-1.437V6.59h3.216V4.763h-3.216V1.28h-1.997v3.484h-2.241V6.59h2.241zm7.139 3.24h1.998V.134h-1.998zm15.721-1.827c-.56 0-.804-.17-.804-.828V9.099c0-2.899-1.827-4.482-4.994-4.482-2.996 0-4.969 1.437-5.262 3.873h1.998c.243-1.266 1.413-2.095 3.167-2.095 1.949 0 3.094.975 3.094 2.583v.852h-3.655c-3.264 0-4.994 1.389-4.994 3.874 0 2.265 1.852 3.63 4.58 3.63 2.144 0 3.386-.95 4.166-2.071.024 1.218.585 1.924 2.241 1.924h1.097V15.36zm-2.801-3.24c0 2.07-1.438 3.508-3.923 3.508-1.656 0-2.704-.828-2.704-2.046 0-1.413.999-2.07 2.778-2.07h3.849zm4.459.975c.048 2.728 2.265 4.238 5.481 4.238 2.753 0 4.97-1.437 4.97-3.751 0-2.753-2.266-3.289-5.092-3.63-1.803-.22-3.118-.39-3.118-1.754 0-1.145 1.169-1.876 2.899-1.876 1.705 0 2.874.95 3.021 2.217h2.046c-.195-2.582-2.241-3.898-5.067-3.922-2.802-.024-4.872 1.462-4.872 3.727 0 2.582 2.216 3.143 4.994 3.484 1.851.22 3.215.34 3.215 1.9 0 1.145-1.242 1.9-2.996 1.9-2.071 0-3.362-1.072-3.435-2.533z"
    }));
};
module.exports.ModernaAtlas = $89377dfc3a5ad398$var$ModernaAtlas;

});

parcelRegister("37UcL", function(module, exports) {
"use strict";
var $246d9faad54f3bd7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModernaLogo = void 0;

const $246d9faad54f3bd7$var$react_1 = $246d9faad54f3bd7$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $246d9faad54f3bd7$var$ModernaLogo = ({ sx: sx = {} })=>{
    return $246d9faad54f3bd7$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 143 32",
        "aria-label": "Moderna Logo"
    }, $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#2AACE2",
        d: "M131.13 30.32h-2.089c-.499 0-.736.283-.736.851 0 .545.261.829.736.829h8.071c.498 0 .759-.284.759-.829s-.261-.852-.759-.852h-5.982Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#3FB4E5",
        d: "M119.783 30.32h-1.994c-.475 0-.736.283-.736.851 0 .545.261.829.736.829h7.691c.498 0 .736-.284.736-.829s-.238-.852-.736-.852h-5.697Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#4CB9E7",
        d: "M108.104 30.32h-1.994c-.499 0-.713.283-.713.851 0 .545.214.829.713.829h7.714c.499 0 .736-.284.736-.829s-.237-.852-.736-.852h-5.72Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#58BEE9",
        d: "M96.045 30.32H94.05c-.499 0-.736.283-.736.851 0 .545.237.829.736.829h7.691c.498 0 .736-.284.736-.829s-.238-.852-.736-.852h-5.697Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#65C3EB",
        d: "M84.39 30.32h-1.995c-.498 0-.736.283-.736.851 0 .545.238.829.736.829h7.691c.499 0 .736-.284.736-.829s-.237-.852-.736-.852H84.39Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#72C8EC",
        d: "M72.853 30.32h-2.09c-.498 0-.759.283-.759.851 0 .545.261.829.76.829h8.047c.498 0 .76-.284.76-.829s-.262-.852-.76-.852h-5.958Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#7FCDEE",
        d: "M61.054 30.32H59.06c-.498 0-.735.283-.735.851 0 .545.237.829.735.829h7.692c.498 0 .736-.284.736-.829s-.214-.852-.736-.852h-5.698Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#8CD2F0",
        d: "M49.4 30.32h-1.995c-.498 0-.736.283-.736.851 0 .545.238.829.736.829h7.715c.475 0 .712-.284.712-.829s-.237-.852-.712-.852h-5.721Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#98D7F1",
        d: "M37.744 30.32H35.75c-.499 0-.736.283-.736.851 0 .545.237.829.736.829h7.69c.498 0 .736-.284.736-.829s-.238-.852-.736-.852h-5.697Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#A5DCF3",
        d: "M26.065 30.32h-1.97c-.5 0-.736.283-.736.851 0 .545.237.829.735.829h7.692c.498 0 .736-.284.736-.829s-.238-.852-.736-.852h-5.721Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#B2E1F5",
        d: "M14.409 30.32h-1.994c-.499 0-.736.283-.736.851 0 .545.237.829.736.829h7.691c.498 0 .736-.284.736-.829s-.237-.852-.736-.852h-5.697Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#BFE6F6",
        d: "M2.73 30.32H.736c-.499 0-.712.283-.712.851 0 .545.213.829.712.829H8.45c.498 0 .736-.284.736-.829s-.238-.852-.736-.852H2.73Z"
    }), $246d9faad54f3bd7$var$react_1.default.createElement("path", {
        fill: "#E31837",
        d: "M.024 6.272h2.16V9.23c.736-1.088 1.52-1.87 2.303-2.39 1.091-.663 2.23-1.018 3.418-1.018a6.1 6.1 0 0 1 2.326.474c.712.307 1.33.757 1.78 1.301.452.521.855 1.302 1.187 2.296.713-1.325 1.615-2.343 2.683-3.053 1.092-.686 2.231-1.018 3.466-1.018 1.163 0 2.183.284 3.062.9.878.591 1.52 1.42 1.97 2.485.427 1.041.641 2.65.641 4.757v9.302h-2.184v-9.302c0-1.822-.142-3.077-.38-3.763a3.36 3.36 0 0 0-1.329-1.657c-.617-.402-1.353-.615-2.208-.615-1.044 0-1.97.331-2.848.946-.855.616-1.496 1.468-1.9 2.486-.38 1.065-.593 2.792-.593 5.23v6.651h-2.16v-8.71q0-3.088-.356-4.19c-.261-.733-.688-1.325-1.33-1.75a3.93 3.93 0 0 0-2.23-.663c-.998 0-1.924.307-2.802.923-.854.591-1.495 1.42-1.923 2.461-.403 1.042-.617 2.604-.617 4.734v7.219H0V6.272zm37.293-.45c2.516 0 4.605.97 6.266 2.84 1.52 1.728 2.28 3.764 2.28 6.154 0 2.367-.784 4.45-2.398 6.201-1.59 1.776-3.632 2.675-6.125 2.675-2.516 0-4.557-.9-6.148-2.675-1.614-1.751-2.397-3.834-2.397-6.2 0-2.368.76-4.403 2.278-6.131 1.615-1.893 3.704-2.864 6.244-2.864m0 2.154c-1.757 0-3.253.663-4.51 2.012-1.259 1.325-1.9 2.958-1.9 4.876a7.3 7.3 0 0 0 .855 3.431c.57 1.042 1.353 1.87 2.326 2.438a6.2 6.2 0 0 0 3.205.876 6.33 6.33 0 0 0 3.205-.876c.997-.568 1.756-1.396 2.326-2.438a7.3 7.3 0 0 0 .854-3.431c0-1.918-.64-3.55-1.899-4.876-1.234-1.35-2.73-2.012-4.462-2.012M66.657.024v23.242H64.52V20.38c-.902 1.112-1.922 1.917-3.038 2.485a8.5 8.5 0 0 1-3.703.828c-2.374 0-4.416-.852-6.077-2.603-1.686-1.728-2.54-3.81-2.54-6.296 0-2.39.854-4.473 2.563-6.201 1.686-1.728 3.727-2.58 6.125-2.58 1.377 0 2.635.284 3.727.876 1.14.591 2.113 1.467 2.943 2.65V0h2.137zm-8.617 8.07a6.7 6.7 0 0 0-3.347.876c-1.021.616-1.804 1.42-2.422 2.51-.593 1.064-.902 2.2-.902 3.36 0 1.207.309 2.32.902 3.385.618 1.089 1.425 1.917 2.446 2.532 1.044.592 2.136.9 3.3.9 1.186 0 2.302-.308 3.37-.9a6.46 6.46 0 0 0 2.445-2.414c.57-1.018.83-2.177.83-3.432 0-1.94-.64-3.574-1.922-4.852-1.258-1.302-2.849-1.964-4.7-1.964Zm27.512 9.516 1.78.994c-.57 1.16-1.281 2.13-2.04 2.864a8.8 8.8 0 0 1-2.612 1.68 9.3 9.3 0 0 1-3.276.568c-2.706 0-4.819-.923-6.338-2.722-1.52-1.822-2.279-3.857-2.279-6.153 0-2.178.617-4.095 1.923-5.752 1.662-2.154 3.846-3.219 6.575-3.219 2.802 0 5.057 1.089 6.766 3.29 1.21 1.562 1.804 3.48 1.828 5.799H72.995c.047 1.965.64 3.598 1.851 4.852 1.187 1.255 2.659 1.894 4.392 1.894.855 0 1.638-.166 2.445-.45A6.7 6.7 0 0 0 83.7 20.07c.617-.544 1.21-1.349 1.851-2.461Zm0-4.592c-.285-1.16-.712-2.083-1.234-2.793a5.7 5.7 0 0 0-2.16-1.657 6.5 6.5 0 0 0-2.801-.639c-1.638 0-3.015.521-4.202 1.61-.855.78-1.496 1.94-1.947 3.503h12.344zm5.27-6.746h2.255v2.485c.665-.97 1.4-1.704 2.137-2.201.76-.474 1.543-.734 2.35-.734.64 0 1.282.213 1.994.568l-1.163 1.846c-.475-.213-.855-.307-1.163-.307-.736 0-1.472.307-2.137.9-.712.59-1.21 1.537-1.59 2.792-.285.97-.428 2.935-.428 5.87v5.751h-2.255zm11.229 0h2.136v3.053c.855-1.16 1.828-2.035 2.872-2.603a7.04 7.04 0 0 1 3.395-.876c1.258 0 2.374.332 3.347.97a5.86 5.86 0 0 1 2.136 2.604c.475 1.089.689 2.793.689 5.136v8.734h-2.137v-8.095c0-1.964-.095-3.266-.261-3.929-.237-1.112-.712-1.964-1.448-2.532-.688-.545-1.614-.852-2.777-.852-1.282 0-2.469.426-3.49 1.301-1.044.9-1.709 1.965-2.017 3.243-.214.852-.309 2.414-.309 4.615v6.249h-2.136zm35.393.001v16.994h-2.065v-2.912c-.879 1.113-1.876 1.941-2.968 2.51a8.2 8.2 0 0 1-3.631.851c-2.327 0-4.321-.875-5.935-2.627-1.638-1.728-2.469-3.834-2.469-6.343 0-2.414.831-4.52 2.493-6.272 1.661-1.728 3.655-2.604 5.982-2.604 1.353 0 2.563.284 3.655.9 1.092.591 2.042 1.49 2.873 2.674V6.32h2.065zm-8.403 1.656c-1.164 0-2.255.308-3.276.9-.997.615-1.757 1.444-2.374 2.532a7.2 7.2 0 0 0-.878 3.409c0 1.207.308 2.367.878 3.432a6.74 6.74 0 0 0 2.398 2.556c1.02.591 2.065.923 3.228.923 1.139 0 2.255-.308 3.3-.923 1.02-.592 1.804-1.42 2.397-2.438.546-1.018.807-2.201.807-3.48 0-1.964-.617-3.62-1.851-4.922q-1.923-1.989-4.629-1.989m11.94-1.68c.238 0 .499.047.712.142.261.118.428.33.546.544.143.237.19.473.19.757 0 .26-.047.497-.166.734-.142.213-.332.426-.546.544a1.7 1.7 0 0 1-.736.166c-.261 0-.498-.047-.712-.166-.214-.118-.404-.33-.546-.544a1.5 1.5 0 0 1-.166-.734c0-.284.047-.52.166-.757.142-.213.332-.426.546-.544.237-.095.499-.142.712-.142m0 .189c-.213 0-.403.047-.593.166a.92.92 0 0 0-.451.45 1.2 1.2 0 0 0-.166.638c0 .213.047.403.166.592.095.19.237.355.451.45.19.118.403.165.593.165.214 0 .427-.047.617-.165a.92.92 0 0 0 .451-.45c.095-.213.167-.402.167-.592 0-.213-.072-.426-.167-.639a1.03 1.03 0 0 0-.451-.45 1.1 1.1 0 0 0-.617-.165m-.617 2.06V6.91h.522c.214 0 .333 0 .428.024a.6.6 0 0 1 .189.166.4.4 0 0 1 .072.213.45.45 0 0 1-.119.307.8.8 0 0 1-.356.142c.071.024.095.048.142.071.048.071.119.166.214.332l.214.307h-.333l-.118-.236c-.119-.19-.19-.332-.262-.379a.44.44 0 0 0-.189-.047h-.143v.686h-.261Zm.237-.9h.309c.142 0 .261 0 .309-.048.071-.047.095-.094.095-.165a.18.18 0 0 0-.048-.119.18.18 0 0 0-.095-.094c-.047 0-.142-.024-.285-.024h-.261v.45z"
    }));
};
module.exports.ModernaLogo = $246d9faad54f3bd7$var$ModernaLogo;

});

parcelRegister("icrBo", function(module, exports) {
"use strict";
var $d3fec2353d6a8d58$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModernaLogoWhite = void 0;

const $d3fec2353d6a8d58$var$react_1 = $d3fec2353d6a8d58$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $d3fec2353d6a8d58$var$ModernaLogoWhite = ({ sx: sx = {} })=>{
    return $d3fec2353d6a8d58$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 143 32",
        "aria-label": "Moderna Logo"
    }, $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M131.91 30.3259H129.885C129.393 30.3259 129.144 30.6052 129.144 31.1648C129.144 31.7245 129.393 32.0013 129.885 32.0013H137.689C138.185 32.0013 138.433 31.722 138.433 31.1648C138.433 30.6076 138.183 30.3272 137.689 30.3272H131.911L131.91 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M120.263 30.3259H118.236C117.741 30.3259 117.493 30.6052 117.493 31.1648C117.493 31.7245 117.742 32.0013 118.236 32.0013H126.041C126.536 32.0013 126.783 31.722 126.783 31.1648C126.783 30.6076 126.537 30.3272 126.041 30.3272H120.263V30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M108.611 30.3259H106.584C106.089 30.3259 105.843 30.6052 105.843 31.1648C105.843 31.7245 106.089 32.0013 106.584 32.0013H114.389C114.884 32.0013 115.132 31.722 115.132 31.1648C115.132 30.6076 114.884 30.3272 114.389 30.3272H108.612L108.611 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M96.6316 30.3259H94.6064C94.1112 30.3259 93.8643 30.6052 93.8643 31.1648C93.8643 31.7245 94.11 32.0013 94.6064 32.0013H102.411C102.906 32.0013 103.154 31.722 103.154 31.1648C103.154 30.6076 102.905 30.3272 102.411 30.3272H96.6329L96.6316 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M84.9803 30.3259H82.9538C82.4586 30.3259 82.2129 30.6052 82.2129 31.1648C82.2129 31.7245 82.4586 32.0013 82.9538 32.0013H90.7583C91.2535 32.0013 91.5017 31.722 91.5017 31.1648C91.5017 30.6076 91.2522 30.3272 90.7583 30.3272H84.9815L84.9803 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M73.3309 30.3259H71.3044C70.8092 30.3259 70.561 30.6052 70.561 31.1648C70.561 31.7245 70.8105 32.0013 71.3044 32.0013H79.1089C79.6041 32.0013 79.8498 31.722 79.8498 31.1648C79.8498 30.6076 79.6041 30.3272 79.1089 30.3272H73.3309V30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M61.3504 30.3259H59.3264C58.8287 30.3259 58.583 30.6052 58.583 31.1648C58.583 31.7245 58.8287 32.0013 59.3264 32.0013H67.1284C67.6261 32.0013 67.8718 31.722 67.8718 31.1648C67.8718 30.6076 67.6261 30.3272 67.1284 30.3272H61.3516L61.3504 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M49.7 30.3259H47.6735C47.1784 30.3259 46.9302 30.6052 46.9302 31.1648C46.9302 31.7245 47.1784 32.0013 47.6735 32.0013H55.4781C55.9732 32.0013 56.2189 31.722 56.2189 31.1648C56.2189 30.6076 55.9732 30.3272 55.4781 30.3272H49.7V30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M38.0487 30.3259H36.0222C35.527 30.3259 35.2788 30.6052 35.2788 31.1648C35.2788 31.7245 35.5282 32.0013 36.0222 32.0013H43.8267C44.3219 32.0013 44.5701 31.722 44.5701 31.1648C44.5701 30.6076 44.3219 30.3272 43.8267 30.3272H38.0499L38.0487 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M26.0679 30.3259H24.0451C23.55 30.3259 23.3018 30.6052 23.3018 31.1648C23.3018 31.7245 23.55 32.0013 24.0451 32.0013H31.8497C32.3448 32.0013 32.5905 31.722 32.5905 31.1648C32.5905 30.6076 32.3448 30.3272 31.8497 30.3272H26.0679V30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M14.419 30.3259H12.3937C11.8986 30.3259 11.6504 30.6052 11.6504 31.1648C11.6504 31.7245 11.8986 32.0013 12.3937 32.0013H20.1983C20.6934 32.0013 20.9416 31.722 20.9416 31.1648C20.9416 30.6076 20.6934 30.3272 20.1983 30.3272H14.4203L14.419 30.3259Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M2.76739 30.3259H0.740867C0.245715 30.3259 0 30.6039 0 31.1636C0 31.7233 0.245715 32 0.740867 32H8.54789C9.04057 32 9.28876 31.7208 9.28876 31.1636C9.28876 30.6064 9.04057 30.3259 8.54789 30.3259H2.76739Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M0.101562 6.45811H2.25467V9.34836C3.00298 8.28235 3.77239 7.50302 4.5629 7.01159C5.65124 6.35511 6.79419 6.02749 7.99546 6.02749C8.80706 6.02749 9.57647 6.18757 10.3049 6.50402C11.0334 6.82296 11.6291 7.24489 12.0907 7.77231C12.5524 8.30097 12.9532 9.05797 13.2895 10.0421C14.008 8.73035 14.9015 7.7326 15.9737 7.04882C17.0497 6.36876 18.205 6.02625 19.4398 6.02625C20.5976 6.02625 21.6165 6.31912 22.5001 6.90362C23.3874 7.48812 24.0414 8.30221 24.472 9.34836C24.9026 10.3945 25.1173 11.9631 25.1173 14.0542V23.1866H22.917V14.0542C22.917 12.2597 22.7905 11.0274 22.5361 10.356C22.2804 9.6859 21.8411 9.1436 21.2243 8.73283C20.6051 8.32331 19.8667 8.11854 19.0092 8.11854C17.968 8.11854 17.0149 8.42507 16.1512 9.04059C15.2862 9.65612 14.6571 10.4764 14.2599 11.5002C13.8603 12.5265 13.6605 14.2378 13.6605 16.6367V23.1853H11.5074V14.6213C11.5074 12.6022 11.3833 11.2309 11.1314 10.5087C10.8795 9.78518 10.4414 9.20813 9.81474 8.7713C9.19053 8.33572 8.44718 8.11854 7.58718 8.11854C6.59191 8.11854 5.66117 8.41762 4.7962 9.01702C3.92752 9.61517 3.28841 10.4243 2.87392 11.4382C2.45943 12.4533 2.25219 14.007 2.25219 16.0981V23.1841H0.101562V6.45811Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M37.5722 6.02627C40.1472 6.02627 42.2855 6.95824 43.9794 8.82468C45.5182 10.5273 46.2889 12.5414 46.2889 14.8683C46.2889 17.1951 45.4748 19.2465 43.8479 20.995C42.2209 22.7436 40.1274 23.6172 37.5722 23.6172C35.017 23.6172 32.9061 22.7448 31.2779 20.995C29.651 19.2477 28.8369 17.205 28.8369 14.8683C28.8369 12.5315 29.6063 10.5422 31.1476 8.83958C32.8403 6.96321 34.9823 6.02502 37.571 6.02502M37.5648 8.1347C35.7753 8.1347 34.2364 8.79366 32.9495 10.1178C31.6614 11.4394 31.0198 13.0391 31.0198 14.9142C31.0198 16.1254 31.3127 17.251 31.9009 18.2971C32.4854 19.3433 33.2784 20.1511 34.2761 20.7195C35.2739 21.2879 36.3697 21.5733 37.5635 21.5733C38.7573 21.5733 39.8519 21.2879 40.8496 20.7195C41.8461 20.1511 42.6391 19.3433 43.2261 18.2971C43.8106 17.251 44.1072 16.1266 44.1072 14.9142C44.1072 13.0391 43.4619 11.4394 42.1688 10.1178C40.8782 8.79366 39.3443 8.1347 37.5648 8.1347Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M66.9695 0V23.1853H64.8474V20.3112C63.9465 21.407 62.9326 22.2322 61.8108 22.7857C60.6889 23.3392 59.4603 23.6159 58.1288 23.6159C55.761 23.6159 53.7369 22.7572 52.0628 21.0409C50.3875 19.3234 49.5474 17.2348 49.5474 14.7739C49.5474 12.313 50.395 10.3051 52.0877 8.59381C53.7766 6.88125 55.8143 6.02497 58.1896 6.02497C59.5658 6.02497 60.8068 6.31785 61.92 6.90235C63.0319 7.48685 64.0085 8.36175 64.8474 9.53199V0H66.9695ZM58.367 8.10362C57.1682 8.10362 56.0638 8.39649 55.0486 8.98596C54.0348 9.57543 53.2294 10.4019 52.6312 11.4667C52.0331 12.5315 51.7315 13.6583 51.7315 14.8446C51.7315 16.031 52.0355 17.1479 52.6362 18.2238C53.2418 19.2998 54.0534 20.1362 55.071 20.7344C56.0898 21.335 57.1831 21.6328 58.3521 21.6328C59.5211 21.6328 60.6442 21.335 61.7003 20.7418C62.7552 20.1486 63.5655 19.3445 64.1351 18.3306C64.7023 17.3167 64.9877 16.1737 64.9877 14.9067C64.9877 12.9708 64.3473 11.3513 63.0728 10.0532C61.7984 8.75142 60.231 8.10238 58.3683 8.10238",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M85.9283 17.6357L87.7426 18.5887C87.1482 19.7565 86.4594 20.6997 85.6801 21.4194C84.8995 22.1367 84.0221 22.6815 83.048 23.055C82.0725 23.4298 80.9718 23.616 79.7395 23.616C77.0118 23.616 74.8761 22.7225 73.3397 20.933C71.7984 19.1435 71.0303 17.1231 71.0303 14.867C71.0303 12.745 71.6805 10.8537 72.9836 9.19201C74.6366 7.0811 76.8443 6.02502 79.6166 6.02502C82.389 6.02502 84.7444 7.10716 86.4495 9.26896C87.6595 10.7978 88.275 12.7028 88.2973 14.9899H73.2429C73.2851 16.932 73.9069 18.5255 75.1069 19.7689C76.3057 21.0111 77.7899 21.6316 79.5558 21.6316C80.4071 21.6316 81.2349 21.4827 82.0403 21.1874C82.8457 20.892 83.5319 20.4999 84.0966 20.0084C84.6612 19.517 85.2706 18.7265 85.9283 17.6332M85.9283 13.1321C85.6404 11.9842 85.2209 11.0671 84.6736 10.3796C84.1239 9.69337 83.3992 9.13865 82.4945 8.7192C81.5898 8.29851 80.6417 8.09002 79.6464 8.09002C78.0034 8.09002 76.5911 8.61744 75.4122 9.67352C74.5497 10.4429 73.8994 11.5958 73.4564 13.1346H85.927L85.9283 13.1321Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M91.4941 6.45809H93.6944V8.90282C94.3496 7.93982 95.0409 7.21881 95.7693 6.74227C96.4941 6.26573 97.2535 6.02747 98.044 6.02747C98.6397 6.02747 99.2739 6.2161 99.9502 6.59708L98.8284 8.4114C98.3779 8.21532 97.9969 8.11976 97.6916 8.11976C96.9706 8.11976 96.2818 8.41388 95.6142 9.00335C94.9478 9.59405 94.4402 10.5074 94.0928 11.7472C93.8259 12.7002 93.6944 14.6275 93.6944 17.5301V23.1865H91.4941V6.45809Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M102.441 6.45809H104.593V9.4563C105.453 8.30839 106.407 7.44963 107.453 6.88126C108.498 6.31289 109.637 6.02747 110.866 6.02747C112.095 6.02747 113.226 6.3464 114.196 6.98178C115.163 7.61717 115.88 8.4722 116.341 9.55062C116.802 10.6253 117.032 12.3006 117.032 14.5778V23.1865H114.879V15.207C114.879 13.281 114.8 11.9929 114.642 11.3463C114.39 10.2394 113.914 9.40666 113.206 8.84946C112.497 8.28978 111.573 8.00932 110.437 8.00932C109.136 8.00932 107.97 8.44118 106.939 9.30118C105.908 10.1624 105.229 11.2272 104.903 12.4992C104.696 13.3282 104.594 14.8471 104.594 17.0511V23.1841H102.442V6.45809H102.441Z",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M138.314 6.45813V23.1853H136.193V20.3112C135.288 21.407 134.278 22.2323 133.155 22.7857C132.033 23.3392 130.805 23.616 129.471 23.616C127.105 23.616 125.081 22.7572 123.405 21.0409C121.731 19.3234 120.892 17.2348 120.892 14.774C120.892 12.3131 121.737 10.3052 123.427 8.59386C125.12 6.8813 127.156 6.02502 129.531 6.02502C130.905 6.02502 132.149 6.3179 133.26 6.9024C134.374 7.4869 135.35 8.3618 136.19 9.53204V6.45689H138.311L138.314 6.45813ZM129.709 8.10367C128.511 8.10367 127.408 8.39654 126.392 8.98601C125.379 9.57548 124.572 10.402 123.973 11.4667C123.374 12.5315 123.076 13.6583 123.076 14.8447C123.076 16.0311 123.379 17.148 123.979 18.2239C124.585 19.2998 125.396 20.1362 126.415 20.7344C127.433 21.335 128.526 21.6329 129.693 21.6329C130.859 21.6329 131.988 21.335 133.042 20.7418C134.096 20.1487 134.907 19.3445 135.476 18.3306C136.043 17.3167 136.327 16.1738 136.327 14.9067C136.327 12.9708 135.69 11.3513 134.415 10.0533C133.14 8.75147 131.573 8.10243 129.706 8.10243",
        fill: "white"
    }), $d3fec2353d6a8d58$var$react_1.default.createElement("path", {
        d: "M141.013 6.51392C141.236 6.51392 141.454 6.571 141.666 6.68517C141.878 6.79934 142.044 6.96315 142.162 7.1766C142.28 7.39005 142.34 7.61219 142.34 7.84301C142.34 8.07383 142.281 8.29224 142.165 8.50321C142.048 8.71418 141.884 8.87799 141.673 8.99588C141.462 9.11253 141.243 9.17086 141.012 9.17086C140.781 9.17086 140.561 9.11253 140.35 8.99588C140.139 8.87923 139.975 8.71542 139.859 8.50321C139.742 8.29224 139.683 8.07135 139.683 7.84301C139.683 7.61467 139.742 7.39005 139.861 7.1766C139.98 6.96315 140.147 6.79934 140.359 6.68517C140.571 6.571 140.79 6.51392 141.012 6.51392M141.013 6.73481C140.827 6.73481 140.644 6.78321 140.468 6.87877C140.292 6.97432 140.153 7.11083 140.054 7.28953C139.954 7.46699 139.904 7.65314 139.904 7.84425C139.904 8.03536 139.953 8.21903 140.051 8.39401C140.149 8.56898 140.286 8.70673 140.462 8.80353C140.638 8.90157 140.822 8.94997 141.013 8.94997C141.204 8.94997 141.388 8.90157 141.564 8.80353C141.74 8.70549 141.877 8.56898 141.975 8.39401C142.072 8.21903 142.121 8.03536 142.121 7.84425C142.121 7.65314 142.072 7.46699 141.972 7.28953C141.873 7.11207 141.735 6.97556 141.558 6.87877C141.38 6.78321 141.199 6.73481 141.014 6.73481M140.431 8.57767V7.14806H140.922C141.09 7.14806 141.212 7.16171 141.287 7.18777C141.363 7.21383 141.422 7.25975 141.467 7.32552C141.512 7.39129 141.534 7.46079 141.534 7.53525C141.534 7.63949 141.497 7.73008 141.422 7.80826C141.348 7.8852 141.249 7.92864 141.126 7.93857C141.177 7.95966 141.216 7.98448 141.247 8.01427C141.305 8.07011 141.375 8.16567 141.458 8.29845L141.632 8.57767H141.351L141.224 8.35181C141.125 8.17435 141.044 8.0639 140.983 8.01923C140.941 7.98696 140.879 7.96959 140.798 7.96959H140.663V8.57643H140.432L140.431 8.57767ZM140.662 7.77351H140.941C141.075 7.77351 141.166 7.75366 141.215 7.71395C141.264 7.67424 141.288 7.62087 141.288 7.5551C141.288 7.51291 141.277 7.47444 141.254 7.44093C141.23 7.40742 141.198 7.3826 141.156 7.36647C141.115 7.35034 141.037 7.34165 140.924 7.34165H140.662V7.77351Z",
        fill: "white"
    }));
};
module.exports.ModernaLogoWhite = $d3fec2353d6a8d58$var$ModernaLogoWhite;

});

parcelRegister("hJJbI", function(module, exports) {
"use strict";
var $ce99b1029a227006$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MresviaLogo = void 0;

const $ce99b1029a227006$var$react_1 = $ce99b1029a227006$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $ce99b1029a227006$var$MresviaLogo = ({ sx: sx = {} })=>{
    return $ce99b1029a227006$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        viewBox: "0 0 2503 1184",
        "aria-label": "mRESVIA (Respiratory Syncytial Virus Vaccine) Logo"
    }, $ce99b1029a227006$var$react_1.default.createElement("path", {
        d: "M42.18 156.46a.19.19 0 0 0 .185.193.2.2 0 0 0 .095-.023Q169.51 83.25 296.45 9.69c22.12-12.81 49.01-12.79 71.09.01Q510.14 92.36 652.75 175c10.1 5.85 13.4 19.09 7.14 28.99q-3.29 5.21-7.96 7.48c-7.64 3.71-14.77 2.9-21.87-1.21A702893 702893 0 0 1 346.44 45.79q-10.79-6.27-22.88-2.45c-2.27.71-4.6 1.65-6.68 2.85Q177.23 127.06 37.01 208.25q-8.109 4.69-12.15 5.32-10.47 1.61-18.19-5.82Q.5 201.81.52 191.5q.07-28.6-.06-63.07-.039-10.7 6.18-16.22 6.411-5.69 13.53-6.05c11.63-.59 21.63 8.27 21.94 20.19q.34 12.94.07 30.11m1567.94 89.46a86 86 0 0 1-4.67 2.65c-1.13.6-2.23 1.343-3.29 2.23q-6.6 5.53-9.66 11.39c-4.76 9.12-5.64 23.03-.03 32.46 3.5 5.89 9.8 10.9 16.12 13.6q13.65 5.82 30.84 8.97c10.69 1.953 20.86 3.883 30.53 5.79 17.75 3.5 35.58 8.89 50.36 18.07 14.2 8.82 24.46 22.55 27.78 38.83q5.205 25.6-3.96 48.69-2.175 5.49-6.36 12.12c-12.87 20.41-35.87 33.31-59.19 38.14-21.97 4.547-44.07 4.3-66.28-.74-10.59-2.4-20.51-6.18-29.75-11.34-20.22-11.287-33.94-27.783-41.15-49.49-2.77-8.36-4.34-17.54-4.7-27.54-.01-.387.17-.577.56-.57l44.47.79c.39.007.6.203.64.59 1.93 20.627 11.86 35.697 29.8 45.21q11.91 6.32 27 7.66 19.515 1.73 35.52-3.31a54 54 0 0 0 11.91-5.4c3.86-2.347 7.03-4.99 9.52-7.93 6.19-7.327 9.03-16.06 8.5-26.2-.75-14.58-10.06-23.43-23.03-28.73q-11.235-4.58-23.85-7.2-16.74-3.47-39.12-7.63c-8.47-1.58-18.3-4.473-29.48-8.68-1.61-.613-4.6-2.007-8.95-4.18-8.9-4.44-16.97-10.58-23.18-18.19-5.31-6.52-9.42-15.05-11.34-23.33-4.47-19.29-2.68-40.08 7.03-57.39q9.51-16.95 26.13-27.18c2.41-1.487 4.85-2.92 7.31-4.3.3-.173.62-.26.97-.26q.615 0 .87-.58a.7.7 0 0 1 .31-.342c.14-.078.3-.109.46-.088.39.053.75-.043 1.06-.29q.51-.4 1.08-.65c12.03-5.127 24.9-8.223 38.59-9.29 22.72-1.76 46.89 1.27 67.29 10.67 5.19 2.393 10.69 5.697 16.52 9.91 2.64 1.9 5.2 4.46 7.76 6.66 1.31 1.133 2.42 2.297 3.32 3.49 1.44 1.92 3.17 3.39 4.6 5.33 10.4 14.067 15.93 30.02 16.58 47.86q.015.56-.54.56l-44.01-.01c-.5 0-.79-.25-.86-.75-.78-5.547-2.13-10.437-4.04-14.67q-8.175-18.14-27.15-26.17c-15.88-6.72-37.28-6.89-53.86-1.19-1.31.46-2.57 1.14-3.9 1.49q-.585.15-1.08.46m267.41 175.97c.78 2.273 1.57 2.273 2.36 0l75.05-216.15q.63-1.81 2.55-1.81l43.04.02c.73 0 1.11.363 1.15 1.09q.045.87-.24 1.7c-31.77 90.773-63.53 181.52-95.29 272.24a.9.9 0 0 1-.85.6l-52.42.01a1.98 1.98 0 0 1-1.86-1.33c-31.83-90.607-63.68-181.237-95.54-271.89a3.5 3.5 0 0 1-.18-1.5c.05-.613.39-.92 1-.92l44.15-.02q2.22 0 2.94 2.09zm195.02-217.77h-44.78c-.14 0-.26.116-.26.26v275.1c0 .144.12.26.26.26h44.78c.14 0 .26-.116.26-.26v-275.1c0-.144-.12-.26-.26-.26m100.96 207.42c-.54 0-1.07.165-1.52.474a2.64 2.64 0 0 0-.98 1.256l-24.67 65.59a1.14 1.14 0 0 1-1.07.74q-22.185-.03-43.98-.01-.705 0-1.38-.27a.55.55 0 0 1-.31-.296.6.6 0 0 1-.01-.434l102.12-272.88c.19-.52.54-.968 1-1.285.45-.316 1-.485 1.55-.485h50.05c.55 0 1.1.169 1.55.485.46.317.81.765 1 1.285l101.59 272.53c.06.151.08.314.06.475a.9.9 0 0 1-.18.446.94.94 0 0 1-.36.316 1 1 0 0 1-.46.113l-45.82-.01c-.34 0-.66-.103-.94-.294a1.64 1.64 0 0 1-.61-.776l-25.06-65.62c-.15-.398-.42-.74-.78-.981a2.1 2.1 0 0 0-1.19-.369zm11.15-39.86c-.05.132-.06.274-.05.414a.86.86 0 0 0 .47.664c.12.066.26.101.4.102l85.18-.15a.9.9 0 0 0 .41-.102.9.9 0 0 0 .31-.279.9.9 0 0 0 .15-.392.85.85 0 0 0-.05-.417l-42.79-116.22a.9.9 0 0 0-.32-.416.9.9 0 0 0-.5-.158c-.18 0-.36.055-.51.158a.9.9 0 0 0-.32.416zm-982.05 7.96c-21.13.193-40.51.203-58.12.03-.49-.007-.74.237-.74.73v99.1c0 .066-.03.13-.08.177a.24.24 0 0 1-.18.073l-44.74.02a.27.27 0 0 1-.19-.076.26.26 0 0 1-.08-.184l.01-274.52q0-.75.75-.75 55.455-.01 110.37.02c27.03.01 56.38 9.68 74.43 31.34 10.27 12.34 16.42 27.153 18.44 44.44 1.4 11.92.7 23.387-2.09 34.4-1.55 6.14-3.84 12.067-6.86 17.78-9.29 17.573-23.6 29.99-42.95 37.25a.9.9 0 0 0-.32.206 1 1 0 0 0-.21.318 1 1 0 0 0-.05.374c0 .127.04.25.1.362l55.66 104.9q.15.28.39.49c.29.26.38.583.29.97a.85.85 0 0 0 .22.78q.285.28.66.45c.38.167.47.437.28.81-.21.413-.56.62-1.03.62-15.53.007-31.66.007-48.38 0a.85.85 0 0 1-.79-.46 368 368 0 0 1-7.26-13.48 309 309 0 0 0-5.23-9.78c-2.4-4.27-4.42-8.77-6.89-13.07a181 181 0 0 1-4.45-8.28c-1.49-2.947-3.25-6.217-5.26-9.81-2.39-4.27-4.44-8.83-6.89-13.18q-2.52-4.47-5.07-9.43-2.505-4.89-5.49-10.26c-1.86-3.36-3.59-6.83-5.2-10.41-.59-1.313-1.61-1.963-3.05-1.95m-58.87-135.81v96.1c0 .038.01.076.02.111q.03.053.06.094c.03.027.06.048.1.063.03.015.07.022.11.022h64.07c6.38 0 12.71-1.193 18.61-3.511 5.89-2.319 11.25-5.717 15.77-10 4.51-4.284 8.1-9.369 10.54-14.966a44.1 44.1 0 0 0 3.7-17.653v-4.42c0-6.058-1.26-12.056-3.7-17.653s-6.03-10.682-10.54-14.966c-4.52-4.283-9.88-7.681-15.77-10a51 51 0 0 0-18.61-3.511h-64.07q-.12.002-.21.085a.3.3 0 0 0-.08.205m237.66 76.91h110.44a.413.413 0 0 1 .41.41l.02 38.2a.413.413 0 0 1-.41.41H1381.4c-.05 0-.11.011-.16.031a.42.42 0 0 0-.22.222.4.4 0 0 0-.03.157v78.9a.413.413 0 0 0 .41.41l138.67.07a.413.413 0 0 1 .41.41l.03 39.39a.413.413 0 0 1-.41.41h-183.94a.5.5 0 0 1-.16-.031.42.42 0 0 1-.22-.222.4.4 0 0 1-.03-.157v-274.7q0-.082.03-.157.03-.076.09-.133a.4.4 0 0 1 .13-.089c.05-.02.11-.031.16-.031h179.18a.413.413 0 0 1 .41.41v39.19a.413.413 0 0 1-.41.41l-133.95-.01a.413.413 0 0 0-.41.41l.01 75.68a.413.413 0 0 0 .41.41m1011.36-78.632c.42 10.242-3.29 20.237-10.33 27.787s-16.83 12.036-27.22 12.471a39.7 39.7 0 0 1-15.11-2.311 39.2 39.2 0 0 1-13.06-7.839 38.7 38.7 0 0 1-9.02-12.172 38.4 38.4 0 0 1-3.6-14.653c-.43-10.241 3.29-20.236 10.33-27.786s16.83-12.036 27.22-12.471a39.7 39.7 0 0 1 15.11 2.311 39.2 39.2 0 0 1 13.06 7.839 38.5 38.5 0 0 1 9.01 12.172 38.2 38.2 0 0 1 3.61 14.652m-27.04-27.018c-13.47-5.17-29.35-1.65-37.5 10.8-8.86 13.52-6.58 32.78 6.69 42.89 6.95 5.3 16.69 7.06 25.23 5.31q12.735-2.6 19.26-13.15c9.6-15.55 4.57-38.83-13.68-45.85",
        fill: "#89ACDE"
    }), $ce99b1029a227006$var$react_1.default.createElement("path", {
        d: "m2362.64 265.05-8.79-14.64a.84.84 0 0 0-.76-.43h-5.58q-.51 0-.51.51l-.01 14.28q0 .51-.51.51l-7.24-.02c-.33 0-.49-.163-.49-.49l-.01-41.87q0-.41.42-.42c6.89-.02 12.95.007 18.2.08q4.515.06 8.97 3.02c6.14 4.1 6.83 12.41 2.74 18.06-1.25 1.74-3.46 3.15-6.62 4.23a.7.7 0 0 0-.26.166.7.7 0 0 0-.21.569c.01.105.05.205.1.295l9.74 16.2c.06.107.03.16-.1.16l-8.69.01a.41.41 0 0 1-.39-.22m-15.64-35.3-.02 12.78a.473.473 0 0 0 .47.47l7.82.01a8.8 8.8 0 0 0 2.95-.498c.94-.33 1.79-.815 2.51-1.427a6.7 6.7 0 0 0 1.67-2.139c.39-.801.59-1.659.59-2.526v-.52c0-1.75-.81-3.429-2.25-4.669-1.45-1.24-3.41-1.938-5.45-1.941l-7.82-.01a.477.477 0 0 0-.47.47M796.7 303.92c11.02-14.26 25.33-23.45 43.22-26.65 17.27-3.09 36.6-1.29 52.13 7.52q16.36 9.28 24.97 27.13.29.59.65.04c2.2-3.33 4.27-6.97 7.12-9.76 2.01-1.97 3.33-4.32 5.55-6 2.65-2.02 4.73-4.45 7.54-6.3q8.57-5.64 13.29-7.45 28.7-11.05 57.97-3.79c16.7 4.14 29.57 13.223 38.6 27.25 11.79 18.33 14.11 40 14.17 61.33.12 37.153.14 74.523.05 112.11a.413.413 0 0 1-.41.41l-41.77-.01a.58.58 0 0 1-.4-.164.58.58 0 0 1-.16-.396c.05-40.82.04-80.607-.04-119.36q-.015-7.09-2.82-17.71c-2.11-7.967-5.83-14.57-11.14-19.81-2.99-2.94-6.873-5.313-11.66-7.12q-9.45-3.56-20.51-2.58-26.76 2.39-37.66 27.23c-4.71 10.72-5.85 22.59-5.86 34.3q-.03 53.29-.01 105.32a.3.3 0 0 1-.3.3l-41.93-.01q-.56 0-.56-.56.08-60.54-.01-112.42-.03-16.17-4.06-27.9c-2.1-6.11-6.01-12.89-10.98-17.21q-6.03-5.24-13.33-7.3-10.92-3.09-22.32-1.24-15.33 2.48-25.47 14.5-4.98 5.9-7.79 12.79-3.67 8.99-4.9 18.14-1 7.38-.96 18.42.16 50.52.06 102.37a.42.42 0 0 1-.42.42h-41.3a.76.76 0 0 1-.537-.223.76.76 0 0 1-.223-.537l-.01-200.25q0-.52.52-.52l35.7.02a.82.82 0 0 1 .81.68l4.48 24.82q.16.89.71.17",
        fill: "#89ACDE"
    }), $ce99b1029a227006$var$react_1.default.createElement("path", {
        d: "M284.14 348.8c-3.85-5.59-9.56-11.58-15.87-12.55-4.48-.69-9.32 1.65-12.43 4.61q-6.72 6.41-11.6 15.04-9.97 17.63-18.77 39.28-6.29 15.45-12.98 29.05-8.1 16.48-16.33 27.28c-3.17 4.17-8.15 9.83-12.73 13.77q-17.57 15.13-41.63 14.34c-13.03-.42-25.59-4.94-35.54-13.42q-10.97-9.35-18.3-20.84-11.88-18.63-20.77-40.45c-4.62-11.34-9.78-22.37-14.85-33.41a155 155 0 0 0-6.21-12.1c-3.58-6.27-7.43-12.31-12.46-17.36-5.12-5.16-9.59-5.81-16.19-6.64-11.4-1.42-19.57-12.74-16-23.91q2.11-6.59 7.46-9.98 5.931-3.77 12.72-3.73 24.96.17 41.78 16.38 11.22 10.8 18.38 23.23 8.58 14.9 15.11 30.28 8.4 19.78 15.4 35.55c5.06 11.41 11.47 22.85 20.2 32.43 4.16 4.57 10.82 7.26 16.83 4.59 5.72-2.54 10.23-8.19 13.64-13.24a152 152 0 0 0 13.4-24.33q10.32-23.63 19.86-45.17c2.95-6.66 6.61-13.12 10.24-19.41q9.57-16.6 23.21-27.7c18.81-15.3 48.51-16.95 68.87-3.47 12.16 8.04 21.21 19.53 28.59 32.28 10.63 18.36 18.74 38.21 26.99 57.81 3.34 7.92 7.33 15.69 11.44 23.04q2.96 5.3 7.91 11.57 5.1 6.44 9.77 8.46 9.32 4.02 17.8-4.98c8.55-9.09 14.38-20.24 19.87-32.61a4143 4143 0 0 0 15.33-34.95q6.52-15.06 15.23-29.9c7.63-13.01 16.74-23.8 29.15-31.65 15.47-9.8 36.27-10.31 53.04-3.99 13.5 5.08 25.5 17.6 32.97 28.83 6.36 9.57 11.89 19.92 16.73 30.88 4.2 9.49 8 19.06 12.52 27.75 9.06 17.42 21.13 34.58 36.06 47.19q5.11 4.31 10.05 4.42c5.8.12 11.57 2.46 15.54 6.4 6.61 6.55 7.08 16.99 1.08 24.41-5.09 6.28-13.01 8.03-20.76 7.48q-24.37-1.74-43.39-19.05a130 130 0 0 1-22.27-26.45c-10.62-16.69-19.2-35.87-26.84-54.4-2.09-5.08-4.66-10-7.16-14.94q-5.35-10.52-11.14-18.17-3.89-5.14-8.77-8.06c-5.82-3.49-11.13-2.38-16.35 1.28a18.7 18.7 0 0 0-3.2 2.83c-8.69 9.86-14.5 20.71-19.73 32.59a80757 80757 0 0 0-16.49 37.5q-8.11 18.48-18.22 33.95c-9.18 14.04-23 27.27-39.72 31.28q-20.11 4.82-38.33-2.22c-15.62-6.04-28.86-21.14-37.1-35.37-3.91-6.74-7.69-13.35-10.82-20.43q-9.69-21.93-19.05-43.5-6.34-14.6-15.17-27.4",
        fill: "#D0343E"
    }), $ce99b1029a227006$var$react_1.default.createElement("path", {
        d: "M621.31 618.45a.15.15 0 0 0-.02-.069.13.13 0 0 0-.115-.07.13.13 0 0 0-.065.019q-128.02 74.21-252.28 146.03c-19.51 11.27-41.09 13.86-62.42 6.03a32 32 0 0 1-4.3-1.94 224 224 0 0 1-4.11-2.29q-119.54-68.51-286.5-166-12.85-7.5-10.85-21.69c.9-6.37 6.39-13.29 12.51-15.73 8.34-3.34 14.14-1.65 21.88 2.85a279994 279994 0 0 0 281.11 163.1q10.26 5.95 20.49 3.83 4.96-1.03 10.79-4.4 141.28-81.71 283.49-163.9c6.98-4.03 15.46-4.12 22.34.03q6.18 3.74 8.96 11.82 1.18 3.43 1.13 10.93a4412 4412 0 0 0-.05 58.54q.06 10.02-5.68 16.38-6.65 7.35-16.82 6.62-12.68-.91-17.74-12.58c-2.07-4.76-1.75-9.83-1.8-15.24q-.1-10.87.05-22.27",
        fill: "#89ACDE"
    }), $ce99b1029a227006$var$react_1.default.createElement("path", {
        d: "M1886.84 833.88q.135.13.27.25.12.13.18.3c.76 2.35 1.97 4.29 2.51 6.72 2.75 12.413 1.99 24.233-2.27 35.46-8.95 23.59-34.44 29.8-57.02 27.27-12.45-1.4-24.41-6.64-31.54-17.1-7.62-11.16-9.08-23.94-8.95-37.38q.015-.65.66-.65h14.31c.37 0 .55.183.55.55-.09 9.7-.01 19.55 5.52 28.1 5.12 7.907 12.67 12.46 22.64 13.66 5.2.627 10.26.473 15.19-.46 15.06-2.833 23.83-11.193 26.32-25.08q1.275-7.06.6-13.67c-.65-6.36-4.17-14.1-9.45-18.4q-7.845-6.41-21.84-11.01c-13.54-4.45-27.1-8.14-37.78-16.86-11.15-9.11-14.35-24.06-12.93-38.31 2.14-21.48 16.84-35.91 38.05-38.66 5.19-.673 10.68-.73 16.49-.17 10.4 1 20.01 4.14 27.29 11.54 8.45 8.58 11.38 22.17 11.14 34.22-.01.373-.2.56-.58.56l-14.22-.02c-.38 0-.57-.187-.56-.56.11-5.093-.49-9.67-1.79-13.73q-5.145-16.03-20.82-18.69c-8.15-1.387-15.43-.763-21.85 1.87q-12.045 4.94-16.08 16.07c-2.2 6.067-2.67 12.497-1.4 19.29 1.59 8.573 6.42 15.253 14.47 20.04 13.97 8.31 30.6 10.77 45.17 18.13 5.23 2.653 9.93 6.34 14.09 11.06q2.145 2.44 3.33 5.23.105.25.3.43m615.68-102.98h-13.82c-.14 0-.26.116-.26.26v170.18c0 .144.12.26.26.26h13.82c.14 0 .26-.116.26-.26V731.16c0-.144-.12-.26-.26-.26M796.7 944.97a1 1 0 0 0 .3.22q.89.42-.1.39-4.83-.15-9.22-.05a.73.73 0 0 1-.361-.086.8.8 0 0 1-.279-.254q-12.83-20.28-20.8-43.26-19.78-56.99-3.93-114.91 7.86-28.72 24.68-55.78a.44.44 0 0 1 .36-.2q4.9-.13 9.7.06a.1.1 0 0 1 .051.017q.024.015.037.039a.1.1 0 0 1 .014.052.1.1 0 0 1-.012.052q-5.56 10.1-7.9 15.35-25.57 57.22-17.78 120.15 4.96 40.1 24.12 75.72.23.44.67.69.52.3.28.85-.23.53.17.95m82.65-128.4q-2.42.81.11 1.11c8.56 1.01 16.08 3.87 21.11 11.28 2.82 4.14 4.47 9.72 5.28 14.67 1.88 11.37 1.53 23.48 1.96 35.88q.37 10.52 4.37 18.52.25.5.67.85.9.75 1.39 1.93.28.69-.46.69h-16.02q-.56 0-.89-.45a11.4 11.4 0 0 1-1.63-3.18 52.8 52.8 0 0 1-2.6-14.99q-.45-15.17-1.18-28.13c-.37-6.4-1.58-13.29-4.3-19.05-4.77-10.07-16.82-11.87-26.69-11.93q-16.31-.09-31.24.02a.23.23 0 0 0-.163.067.23.23 0 0 0-.067.163v77.23a.25.25 0 0 1-.25.25l-14.25-.01a.75.75 0 0 1-.53-.217.73.73 0 0 1-.22-.523V731.44a.42.42 0 0 1 .42-.42q26.15-.09 53.02.1 8.06.05 16 2.77 11.53 3.96 18.44 13.59 5.02 6.98 6.61 18.2c2.64 18.64-2.49 39.98-21.28 48.51-2.42 1.1-5.1 1.54-7.61 2.38m14.07-43.74c-.46-7.25-2.5-14.96-7.7-20.06-7.19-7.05-17.48-8.85-27.53-8.96q-13.59-.16-28.92-.04a.27.27 0 0 0-.27.27v66.01q0 .62.61.63 18.74.36 31.62-.28 10.43-.52 19.01-5.7c11.03-6.64 13.97-19.35 13.18-31.87m346.67-41.818-13.38-.024c-.24 0-.44.197-.44.44l-.04 23.36c0 .243.2.44.44.44l13.38.024c.24 0 .44-.197.44-.44l.04-23.36c0-.243-.2-.44-.44-.44M2363.47 731h-13.7a.27.27 0 0 0-.27.27v23.72c0 .149.12.27.27.27h13.7a.27.27 0 0 0 .27-.27v-23.72a.27.27 0 0 0-.27-.27m-50.57 55.49c-.05 0-.09.019-.13.053a.2.2 0 0 0-.05.127c.06 28.313.05 58.117-.04 89.41q-.015 6.02 1.26 9.12c2.97 7.18 14.31 6.54 20.6 4.52a.5.5 0 0 1 .25-.021.54.54 0 0 1 .24.095c.06.05.12.115.16.191q.06.116.06.245l.01 11.03c0 .38-.18.617-.55.71-6.71 1.68-14.58 1.2-21.44-.02-4.87-.86-9.89-3.27-12.14-7.96-2.37-4.96-2.8-9.26-2.82-14.34-.07-27.447-.09-58.253-.04-92.42a.74.74 0 0 0-.22-.523.73.73 0 0 0-.52-.217l-16.03.01a.75.75 0 0 1-.75-.75v-10.5c0-.133.05-.26.15-.354a.5.5 0 0 1 .35-.146h16.5c.33 0 .5-.167.5-.5v-34.22c0-.373.18-.557.55-.55l13.2.03c.2 0 .38.078.52.217.14.138.22.327.22.523v34q0 .5.51.5h21c.49 0 .74.25.74.75l.01 10.25c0 .5-.25.75-.76.75zm-866.12 0c-.02 0-.03.006-.04.018s-.02.026-.02.042c.02 30.56.03 60.933.04 91.12 0 1.127.07 2.25.22 3.37q.24 1.8.78 3.47 1.665 5.06 7.89 6.11c4.39.74 8.67.443 12.86-.89a.56.56 0 0 1 .26-.018c.09.014.17.049.25.102a.57.57 0 0 1 .23.456l.01 10.98c0 .387-.19.627-.56.72-6.35 1.63-13.83 1.19-20.76.08-10.89-1.74-15.43-9.23-15.44-19.78-.01-31.013 0-62.753.02-95.22a.58.58 0 0 0-.16-.396.58.58 0 0 0-.4-.164l-16.46.02a.5.5 0 0 1-.35-.149.5.5 0 0 1-.15-.361l.01-10.63c0-.413.21-.62.62-.62h16.12a.75.75 0 0 0 .75-.75l.02-33.88c0-.413.2-.62.61-.62l12.87.01c.2 0 .38.078.52.217s.22.327.22.523v34q0 .5.51.5h21.25q.75 0 .75.75l.02 10.46c0 .36-.18.54-.55.54zm-503.57 52.26a.61.61 0 0 0-.62.59q-.64 14.65 1.83 26.96c3.14 15.61 12.37 29.31 30.75 25.48 14.62-3.05 19.73-18.66 20.88-31.67q.06-.62.68-.62l13.51.02c.05-.001.09.009.13.028a.34.34 0 0 1 .18.203c.01.045.02.092.01.139-.46 3.473-1 6.77-1.63 9.89-.79 3.907-2.22 8.043-4.3 12.41-5.18 10.84-14.56 19.06-26.49 21.34q-9.23 1.75-18.56-.14c-27.02-5.48-31.78-37.35-32.34-60.06-.43-17.19.84-35.41 8.91-50.76 8.31-15.81 22.65-22.04 39.87-20.51 16.23 1.44 26.49 11.16 31.23 26.1 3.93 12.36 4.89 26.87 4.44 39.99a.63.63 0 0 1-.19.426.65.65 0 0 1-.44.174zm38.31-52.42q-10.33-4.9-22.28-.86c-14.8 5-16.84 28.01-16.74 40.99q0 .3.31.3l53.34-.02a.17.17 0 0 0 .113-.044.14.14 0 0 0 .047-.106q.48-14.99-4.03-27.36-3.44-9.43-10.76-12.9m118.5 24.42h-13.76c-.41 0-.6-.207-.58-.62.38-6.92-.25-13.97-4.42-19.68-5.96-8.15-19.37-7.8-27.82-4.69-9.14 3.36-11.92 12.58-11.44 21.69.31 5.92 2.79 10.553 7.43 13.9q4.545 3.27 9.96 5.26c8.39 3.087 16.13 6.11 23.24 9.07q15 6.24 19.32 20.31c2.06 6.733 2.18 13.99.35 21.77-4.1 17.42-17.56 25.76-34.66 26.58-16.17.78-32.67-2.62-39.02-18.99-2.59-6.68-3.6-14.603-3.02-23.77.03-.387.23-.58.62-.58l12.98.01c.37 0 .55.183.55.55q-.015 3.88.24 7.64c.66 10.05 5.82 19.78 15.93 22.23 10.27 2.49 23.07.59 29.39-8.35 4.09-5.78 4.69-14.09 2.95-20.89-1.85-7.23-7.1-11.91-14-14.8a740 740 0 0 0-21.66-8.71c-13.58-5.2-24.43-13.4-25-29.24-1.05-28.94 20.41-40.9 46.73-36.85 13.9 2.133 22.16 10.117 24.79 23.95a64.6 64.6 0 0 1 1.08 14.04c0 .046-.02.089-.06.121a.16.16 0 0 1-.12.049m35.44 71.92c-.15-.2-.22-.173-.22.08l.02 60.49c0 .333-.17.5-.5.5h-13.77a.22.22 0 0 1-.16-.067.2.2 0 0 1-.07-.163l-.01-168q0-.75.75-.75l11.74-.02q.51 0 .51.51l-.01 16.81c0 .967.2 1.01.61.13 7.17-15.413 19.74-22.057 37.69-19.93 12.07 1.43 21.72 9.6 26.51 20.45 5.94 13.48 7.27 28.66 7.38 44.07.16 22.35-2.44 58.54-29.04 66.08-8.7 2.47-19.75 2.26-27.91-2.39-5.92-3.37-8.88-7.13-11.7-13.37-.7-1.55-.82-3.07-1.82-4.43m6.79-1.92c1.71 3.02 3.69 5.447 5.93 7.28q3.48 2.84 8.07 3.77c16.75 3.4 26.59-4.72 30.81-20.31 3.11-11.46 3.6-23.51 3.52-35.75-.12-17.81-2.01-55.2-29.69-51.76-5.38.667-9.99 2.91-13.84 6.73-7.4 7.35-9.95 16.84-10.94 26.94-1.09 10.94-1.21 22.747-.38 35.42.59 8.88 2.11 16.703 4.58 23.47.53 1.46 1.18 2.863 1.94 4.21m137.43-86.88c2.45-6.36 7.16-12.45 12.71-16.26q10.365-7.1 23.49-5.33c.17.022.33.105.44.233a.68.68 0 0 1 .18.467l-.01 13.2c0 .08-.02.158-.05.23a.7.7 0 0 1-.15.188.5.5 0 0 1-.21.11.6.6 0 0 1-.24.012c-14.63-2.5-28.35 4.23-33.8 18.34-2.04 5.293-3.06 11.293-3.05 18q.03 36.55 0 77.9 0 .53-.54.53h-13.44a.5.5 0 0 1-.18-.036.4.4 0 0 1-.15-.102.34.34 0 0 1-.1-.152.4.4 0 0 1-.04-.18l-.04-125.27c0-.66.33-.99 1-.99l13.02-.02c.07 0 .13.013.19.039a.6.6 0 0 1 .17.111c.04.047.08.104.1.166.03.061.04.127.04.194a497 497 0 0 0 .08 18.52c.03 1.007.22 1.04.58.1m108.03 89.96c.01-.927-.18-.967-.55-.12-3.93 8.83-8.96 15.4-18.47 18.54q-9.495 3.15-20.13 1.66-18.645-2.62-24-19.97c-2.1-6.793-2.68-13.927-1.75-21.4 1.88-15.14 10.33-24.863 25.36-29.17 9.56-2.74 19.17-5.47 28.82-8.19 2.62-.733 4.9-2.043 6.83-3.93 4.57-4.45 3.41-18.31 2.38-23.31q-1.05-5.05-5.22-9.16c-5.61-5.53-16.29-5.87-23.48-4.13-12.91 3.12-16.73 15.1-16.66 27.26q0 .6-.6.6l-13.03-.02c-.45 0-.68-.223-.67-.67q.12-10.17 2.61-17.46c4.26-12.473 13.36-19.74 27.31-21.8 19.37-2.85 41.14 1.93 44.34 24.57q.675 4.77.69 9.51c.05 23.787.03 47.833-.05 72.14-.02 5.24.55 11.93 7.22 12.19 1.21.047 2.39.053 3.55.02.53-.02.79.233.79.76l-.03 8.87a1.4 1.4 0 0 1-1.05 1.36c-8.36 2.21-21.19 1.26-23.36-9.09-.59-2.84-.88-5.86-.85-9.06m-1.39-53.35c-2.46 3.53-6.7 5.31-11.35 6.63a597 597 0 0 1-14.4 3.92c-9.52 2.46-19.19 7.18-21.74 17.68-3.81 15.72 1.8 35.42 21.93 33.51 8.93-.84 15.86-5.083 20.77-12.73q.915-1.42 1.44-2.89c.94-2.61 2.14-4.89 2.72-7.67.94-4.5 1.44-9.19 1.49-14.07.09-7.507.11-15.537.05-24.09-.01-1.04-.31-1.137-.91-.29m175.6 20.76c-1.7 21.34-9.02 46.13-32.53 51.89-14.64 3.59-30.83-.03-40.7-12.25-12.16-15.05-13.99-37.5-13.67-56.61.37-21.98 5.51-51.15 28.69-59.83 6.19-2.32 12.78-3.113 19.75-2.38 37.76 3.96 40.73 50.68 38.46 79.18m-70.72-30.45c-2.03 19.26-3.59 71.35 27.11 71.68 31.06.34 30-50.34 28.06-70.28-1.57-16.11-7.33-38.61-27.96-38.44-19.58.16-25.58 21.57-27.21 37.04m104.05-27.51c0 1.68.33 1.747 1 .2 1.23-2.833 2.8-5.52 4.7-8.06 7.09-9.473 16.53-13.957 28.3-13.45q1.545.07 3.15.49c.17.043.32.14.43.278.1.138.16.308.16.482v13.06c0 .453-.22.637-.67.55-11.21-2.16-23.19 1.64-29.77 10.93-6.08 8.56-7.26 17.89-7.28 28.14-.03 25.687-.03 50.707.02 75.06.01.353-.17.53-.53.53l-13.51.01a.22.22 0 0 1-.16-.067.2.2 0 0 1-.07-.163l-.01-126.02c0-.135.05-.265.15-.361a.5.5 0 0 1 .35-.149l13 .02q.75 0 .75.75zm418.73-2.02c.01 1.187.3 1.267.89.24q13.275-23.01 39.93-19.03c3.29.493 6.42 1.507 9.37 3.04 6.39 3.327 10.72 8.487 13 15.48 1.55 4.753 2.33 10.263 2.33 16.53v93.43q0 .55-.54.55h-13.68a.28.28 0 0 1-.2-.085.3.3 0 0 1-.08-.205q.075-49.64 0-93.33c0-3.967-.63-7.757-1.88-11.37-4.31-12.44-17.98-14.94-29.04-11.15-14.2 4.88-18.64 18.96-18.62 32.55q.075 41.54.03 82.91c0 .447-.22.67-.67.67l-13.56.01a.26.26 0 0 1-.17-.067.25.25 0 0 1-.07-.163V775.36c0-.407.21-.61.62-.61h11.72c.41 0 .62.203.62.61zm152.77 68.24 13.77-.03q.045 0 .09.018c.02.011.05.028.07.05.02.021.04.047.05.075s.01.057.01.087c-.48 11-4.63 23.71-11.58 31.8-8.03 9.353-18.81 13.607-32.32 12.76-19.09-1.2-29.95-13.75-34.74-31.33-1.73-6.36-2.86-12.83-3.41-19.41-.84-10.067-.82-20.24.07-30.52 1.26-14.61 5.67-31.73 17.12-41.96q9.015-8.05 21.63-9.04c5.85-.46 12.53.05 18.19 1.84 10.12 3.2 17.3 10.017 21.55 20.45 1.95 4.813 3.16 10.68 3.62 17.6q.045.61-.57.61h-13.1c-.42 0-.65-.21-.68-.63-.64-8.62-2.96-18.26-9.87-23.7-7.53-5.93-21.83-5.98-29.44-.05-3.38 2.627-5.94 5.993-7.69 10.1-2.84 6.667-4.63 14.227-5.38 22.68q-1.635 18.74.27 37.87c.71 7.12 2.31 13.643 4.82 19.57 4.38 10.33 12.34 15.15 23.61 13.96 16.85-1.78 22.05-18.21 23.72-32.62a.3.3 0 0 1 .06-.128.2.2 0 0 1 .13-.052m280.69 23.6a.47.47 0 0 0-.28.05.11.11 0 0 0-.08.08q-5.595 15.61-20.79 19.74c-6.43 1.74-13.4 1.87-20.92.39-18.93-3.71-23.91-21.63-23-38.32.37-6.813 2.46-13.07 6.25-18.77 2.22-3.333 5.15-6.08 8.8-8.24a47.3 47.3 0 0 1 11.27-4.83q16.2-4.6 29.64-8.65 7.395-2.23 8.19-10.42c.51-5.24.49-9.867-.05-13.88-1.15-8.593-5.9-13.837-14.26-15.73-5.87-1.327-11.74-.99-17.59 1.01-11.01 3.77-14.14 16.16-13.9 26.24 0 .094-.01.187-.05.274a.6.6 0 0 1-.15.234.9.9 0 0 1-.23.157.8.8 0 0 1-.28.055h-13.04a.7.7 0 0 1-.66-.459.7.7 0 0 1-.05-.281q.165-3.55.48-6.73c.97-9.553 4.07-17.11 9.29-22.67 4.65-4.947 10.8-8.097 18.47-9.45 12.08-2.14 25.74-1.62 35.8 5.67 3.37 2.44 5.98 5.777 7.82 10.01 2.11 4.847 3.17 9.957 3.16 15.33q-.06 39.37-.03 73.45c.01 2.513.19 5 .56 7.46.78 5.15 4.93 6.72 9.69 6.1.84-.113 1.26.253 1.25 1.1l-.02 8.99a.86.86 0 0 1-.17.513.8.8 0 0 1-.43.307c-8.12 2.53-22.24 1.47-23.93-9.44a40.7 40.7 0 0 1-.39-8.84c.01-.26-.11-.41-.37-.45m-1.27-52.53c-2.96 3.77-7.35 5.59-11.9 6.8q-7.41 1.96-15.87 4.26c-10.17 2.76-18.4 8.26-20.29 19.39-2.28 13.46 2.2 31.02 19.09 31.33 13.32.25 23.11-7.4 27.4-19.92 1.37-4 2.13-8.813 2.26-14.44q.345-14.25.09-27.16-.03-1.22-.78-.26m-761.38 52.68 25.12-108q.105-.5.63-.5l14.24.01a.45.45 0 0 1 .19.042.41.41 0 0 1 .22.488q-17.58 64.99-37.14 137.54-3.105 11.55-8.16 19.63c-7.36 11.78-22.16 11.88-34.28 10.75-.41-.04-.61-.263-.61-.67l.01-10.56c0-.117.02-.233.07-.34a1 1 0 0 1 .2-.281.9.9 0 0 1 .3-.174.9.9 0 0 1 .35-.035c7.5.8 15.89 1.51 21.28-4.44 5.05-5.59 7.51-16.12 9.41-23.42.12-.471.12-.962-.01-1.42l-36.15-126.51c-.12-.413.03-.62.46-.62l14.12.01q.555 0 .69.54l27.93 107.97c.39 1.527.77 1.523 1.13-.01m-444.6-108.5h-13.62a.31.31 0 0 0-.31.31v126.12c0 .171.14.31.31.31h13.62a.31.31 0 0 0 .31-.31V775.06a.31.31 0 0 0-.31-.31m705.88 109.66c.1.153.17.14.22-.04l25.23-108.5c.07-.319.25-.604.51-.807.25-.204.57-.314.89-.313l13.32-.01a.65.65 0 0 1 .52.256.68.68 0 0 1 .11.574q-18.885 69.9-37.2 137.67-1.935 7.14-5.46 14.8c-4.21 9.167-11.26 14.22-21.14 15.16-5.41.513-10.73.493-15.97-.06a.37.37 0 0 1-.25-.127.37.37 0 0 1-.1-.263l-.01-11.27q0-.07.03-.134a.3.3 0 0 1 .08-.111.3.3 0 0 1 .25-.085c3.09.32 6.28.493 9.59.52 8.92.06 13.92-5.16 16.85-13.01 1.82-4.86 3.43-10.087 4.84-15.68.08-.321.07-.662-.02-.99l-36.19-126.63c-.12-.413.04-.62.47-.62l14.07.02c.18.001.36.062.51.174.14.112.24.269.29.446 9.52 36.887 18.76 72.613 27.71 107.18.17.667.46 1.283.85 1.85m285.15-1.1c.39 1.513.76 1.51 1.12-.01l25.07-107.84a.9.9 0 0 1 .33-.51.9.9 0 0 1 .57-.2h13.94q.615 0 .45.6a81821 81821 0 0 1-36.92 136.69c-1.95 7.2-4.44 14.97-8.76 21.1-8.28 11.75-21.28 10.58-34.04 10.13-.33-.013-.5-.187-.5-.52l.04-10.96c0-.077.02-.152.05-.222s.07-.133.13-.185a.5.5 0 0 1 .19-.119.5.5 0 0 1 .22-.034c2.4.12 4.88.27 7.43.45 7.59.547 13.26-2.4 17.02-8.84q1.635-2.79 3.27-8.27 1.605-5.4 3.21-10.62c.25-.809.25-1.674.02-2.49l-36.04-126.16q-.165-.56.42-.56l14.31.02c.27 0 .43.13.5.39zm132.18-108.48h-13.56c-.19 0-.34.152-.34.34v126.06c0 .188.15.34.34.34h13.56c.19 0 .34-.152.34-.34V775.17c0-.188-.15-.34-.34-.34m-1560.66 348.2 37.73-153.35q.11-.42.54-.42l15.16-.02a.5.5 0 0 1 .402.202.53.53 0 0 1 .088.448l-44.68 169.75a.5.5 0 0 1-.172.26c-.085.06-.19.1-.298.1h-18.05q-.68 0-.86-.66a61633 61633 0 0 0-43.81-166.25 30 30 0 0 1-.71-3.42q-.06-.43.38-.43l15.25.02a.5.5 0 0 1 .49.39l37.75 153.38q.39 1.59.79 0m84.4-153.78h-13.52a.37.37 0 0 0-.37.37v23.5c0 .204.166.37.37.37h13.52a.37.37 0 0 0 .37-.37v-23.5a.37.37 0 0 0-.37-.37m422.22 0 15.63.01c.05 0 .09.01.13.031.05.02.08.05.11.087q.045.057.06.125c0 .045 0 .092-.01.137l-44.81 170.14c-.02.06-.06.12-.11.16a.28.28 0 0 1-.18.06l-18.58-.01a.28.28 0 0 1-.18-.06.36.36 0 0 1-.11-.16l-44.81-170.13c-.01-.045-.01-.092-.01-.137a.3.3 0 0 1 .06-.125.34.34 0 0 1 .11-.087.3.3 0 0 1 .13-.031l15.63-.01c.07-.002.14.02.19.062.06.042.09.101.11.168l37.88 153.99c.02.06.05.12.11.16q.075.06.18.06t.18-.06c.06-.04.09-.1.11-.16l37.88-153.99a.3.3 0 0 1 .11-.168.3.3 0 0 1 .19-.062m326.77 0h-13.5a.38.38 0 0 0-.38.38v23.48c0 .21.17.38.38.38h13.5c.21 0 .38-.17.38-.38v-23.48a.38.38 0 0 0-.38-.38m207.91 214.42c2.41-4.27 4.36-7.93 5.85-11 28.29-58.33 28.93-127.87 2.66-186.69-2.57-5.75-5.61-11.18-8.55-16.69-.01-.01-.01-.022-.01-.035s0-.025.01-.036a.2.2 0 0 1 .03-.028.1.1 0 0 1 .04-.011c5.74-.093 9.14-.057 10.19.11.03.007.06.027.08.06 2.61 4.507 5.06 8.837 7.34 12.99q7.545 13.71 13.95 32.01c12.89 36.75 13.59 77.09 3.22 114.1-3.71 13.27-9.04 26.66-15.98 40.17-1.33 2.6-4.14 7.6-8.42 15q-.135.24-.42.24c-5.2.09-8.51.08-9.92-.05-.1-.01-.12-.05-.07-.14m-917.95-152.14c.06 1.51.387 1.56.98.17 6.23-14.68 19.78-23.38 35.92-21.06.347.05.52.25.52.61l-.01 13.31a.5.5 0 0 1-.043.19.4.4 0 0 1-.116.15.5.5 0 0 1-.17.09.4.4 0 0 1-.191.01c-16.2-2.78-30.17 5.58-34.9 21.44-1.74 5.81-2.08 11.87-2.09 17.85q-.03 37.905 0 74.94 0 .75-.74.75l-12.75.02q-.75 0-.75-.75V1013.5c0-.33.167-.5.5-.5l12.95.01c.115 0 .228.02.334.07.105.04.201.11.281.19s.143.18.185.28c.042.11.063.23.06.34q-.31 9.57.03 17.64m147.9 67.72 13.47-.01c.08 0 .15.02.22.04.07.03.13.08.19.13.05.05.09.12.12.19s.04.14.04.22c-.11 6.87.78 12.83 2.67 17.9 2.61 6.97 9.04 11.54 16.39 12.6 9.87 1.44 20.05-.56 26.22-8.61 6.7-8.75 5.56-24.73-3.43-31.66-2.43-1.87-5.38-3.56-8.85-5.06-3.44-1.49-11.2-4.56-23.29-9.22-4.63-1.78-11.05-5.9-14.52-9.68-4.94-5.4-7.37-12.08-7.29-20.05.14-14.03 5.04-25.9 18.23-32.11 8.49-4 18.86-4.45 28.08-3.13 9.95 1.43 18.77 6.5 22.75 15.87 2.81 6.59 3.95 13.84 3.43 21.73-.03.4-.24.6-.64.6l-12.84-.01c-.47 0-.71-.24-.7-.71.06-10.96-1.59-22.36-14.06-25.37-5.31-1.28-10.91-1.08-16.82.61-9.64 2.76-13.29 11.65-13.12 21.17.17 9.71 6.32 15.81 15.03 19.23 7.21 2.83 14.74 5.73 22.6 8.68 11.29 4.23 20.23 11.8 22.9 23.35 1.45 6.25 1.45 12.77 0 19.58-3.39 15.95-15.46 25.13-31.33 26.83-9.59 1.03-21.76.38-30.13-4.32-13.85-7.78-16.18-24.29-15.53-38.59 0-.05.03-.1.06-.14.04-.04.1-.06.15-.06m318.34 23.45q.015-3.135-1.05-.18c-3.88 10.85-11.75 17.35-23.62 19.5-5.73 1.04-11.41.97-17.02-.21-18.89-3.96-24.57-20.6-23.57-37.94.72-12.5 5.72-21.68 15.01-27.55q5.385-3.405 18.54-6.93c7.76-2.08 15.99-4.2 23.86-6.96 3.05-1.07 5.56-4.24 6.17-7.26 1.13-5.55 1.26-11.39.38-17.5-.53-3.69-2.1-6.95-4.69-9.79-2.21-2.42-5.17-4.05-8.88-4.9-6.65-1.53-16.38-1.33-22.03 2.72-8.06 5.77-10.02 15.07-10.12 24.49-.01.37-.2.56-.57.56l-13.03.01c-.39 0-.6-.2-.61-.6-.15-7.23 1.1-14.11 3.77-20.64.67-1.64 1.46-3.09 2.39-4.36 1.28-1.74 2.37-3.81 4.02-5.21 4.09-3.47 7.86-5.77 11.3-6.88 11.78-3.79 23.16-3.95 34.15-.48 9.81 3.1 16.54 11.49 18.37 21.46q.975 5.325.96 12.18c-.08 24.76-.1 48.65-.05 71.66.01 2.7.49 5.42 1.45 8.16q.435 1.26 1.65 1.98c2.25 1.35 5.16 1.52 7.68 1.47.47-.01.7.22.71.69l.01 8.89q0 .915-.9 1.17c-5.47 1.49-10.87 1.37-16.21-.37q-3.135-1.02-5.49-3.99c-.21-.26-.34-.55-.4-.87-.08-.45-.29-.84-.62-1.17-.26-.26-.43-.57-.51-.92q-1.065-4.665-1.05-10.23m-49.67-10.85c1.2 8.95 7.37 17.88 17.02 18.73q10.635.93 18.81-4.71c10.75-7.42 13.15-20.86 13.22-32.98.05-8.09.06-16.16.04-24.19-.01-.48-.15-.53-.44-.14-2.89 3.83-7.65 5.83-12.05 7.02-5.57 1.52-10.91 2.97-16.02 4.34-2.52.67-5.2 1.7-8.05 3.08-11.45 5.55-14.11 17-12.53 28.85m161.16-80.03c.32.38.57.85.75 1.42 1.69 5.23 2.64 9.25 2.83 12.07.11 1.68.33 3.27.64 4.78.02.08.01.17-.01.25s-.05.15-.11.22a.7.7 0 0 1-.19.15c-.08.03-.16.05-.24.05l-13.48-.01c-.32 0-.49-.16-.52-.48-.95-13.81-5.88-26.33-21.36-28q-8.805-.96-15.45 2.61c-12.96 6.95-15.49 28.55-16.04 41.44-.49 11.26-.18 21.82.92 31.68 1.84 16.5 8.01 35.34 29.21 32.49 7.17-.96 12.97-4.86 16.59-11.29 3.55-6.31 5.53-12.93 5.95-19.86.03-.43.21-.84.53-1.14.31-.3.73-.46 1.16-.46l12.72.01c.17 0 .24.09.23.26-.77 8.58-3.01 18.6-7.63 25.98-5.89 9.41-13.86 15.99-25.08 17.94-11.74 2.04-23.66.08-32.78-7.6-11.85-9.96-15.64-28.6-16.77-43.06-1.13-14.62-.86-29.42 2.33-43.84 1.73-7.77 4.53-14.62 8.41-20.55 10.15-15.51 28.93-19.86 46.09-14.71q8.235 2.475 15 9.27c1.43 1.44 2.09 3.27 3.58 4.65.21.19.32.43.34.71l.03.41a.98.98 0 0 0 .46.75q.675.405.6 1.2c-.04.35.1.62.41.8.39.23.59.58.59 1.05-.01.3.1.58.29.81m85.64 17.78c-.37-2.38-.78-4.73-1.22-7.05-.92-4.87-2.64-8.96-5.15-12.28-3.35-4.43-7.85-7.01-13.52-7.76q-19.41-2.55-26.88 13.5-4.365 9.345-5.64 23.19c-1.37 14.82-1.06 29 .93 42.53 1.07 7.28 3.06 13.47 5.97 18.56 2.41 4.24 6.82 8.38 11.9 9.59 11.93 2.86 22.85-1.17 28.38-12.44 2.84-5.78 4.53-12.05 5.06-18.82.02-.24.13-.45.3-.61s.4-.25.63-.25l13.26-.02c.18 0 .26.09.25.26-.58 9-2.92 17.3-7.02 24.89-5.7 10.55-14.33 16.92-25.88 19.09-6.9 1.3-13.81.91-20.74-1.16-23.95-7.14-28.42-37.26-29.04-58.11-.86-28.82 3.95-71.81 42.43-72.5 9.58-.17 18.36 1.96 25.94 7.63 2.77 2.07 5.19 4.79 7.24 8.18 4.34 7.15 6.68 15.15 7.03 23.99q.03.72-.69.72l-13.01.03c-.38 0-.56-.19-.55-.57 0-.09.01-.19.02-.29q.015-.15 0-.3m84.04-19.56c0 1.27.28 1.34.84.2 2.19-4.45 5.26-8.34 9.19-11.68 8.15-6.91 18.1-9.56 29.84-7.93 4.55.63 8.68 2.08 12.38 4.33 3.76 2.29 6.66 5.41 8.71 9.35 2.95 5.68 4.43 11.75 4.45 18.21.11 31.69.12 64.01.05 96.98 0 .33-.17.5-.5.5l-13.33-.03c-.25 0-.38-.13-.38-.39.09-28.23.09-57.76 0-88.58-.04-13.3-2.46-27.01-18.26-28.66-6.97-.73-13.01.55-18.14 3.82-9 5.75-13.26 16.69-13.29 27.01-.08 27.81-.1 56.5-.06 86.09 0 .2-.08.38-.21.52-.14.14-.33.22-.52.22l-13.02-.02c-.49 0-.74-.24-.74-.73l-.01-125.75c0-.33.17-.5.5-.5h11.75q.75 0 .75.75zm100.29 46.95c-.08 0-.16.03-.21.09-.06.05-.09.13-.09.21-.02 10.43.34 20.71 2.97 31.13 3.61 14.27 13.88 25.05 29.68 21.75 14.48-3.02 19.9-18.67 21.03-31.74q.06-.69.75-.69l13.29.01c.33 0 .47.16.44.49-.74 6.69-2 12.52-3.77 17.47q-1.92 5.325-5.52 10.77c-8.08 12.18-21.93 17.31-36.74 16q-9.78-.855-18-6.54c-14.04-9.73-18.07-31.99-18.97-47.66-1.07-18.47-.16-38.32 7.11-54.51 5.35-11.9 14.7-20.33 27.6-22.79 6.57-1.25 13.2-1.11 19.89.44 28.6 6.59 29.59 41.79 29.74 64.77.01.51-.24.76-.75.76zm-.2-12.4c0 .11.04.21.12.29a.4.4 0 0 0 .29.12l52.97.01q.525 0 .54-.54c.04-9.55-1.06-20.54-5.21-29.5-4.85-10.45-14.36-13.66-25.26-12.72-12.31 1.07-18.78 10.25-21.24 21.54-1.42 6.51-2.16 13.44-2.21 20.8m-886.48-51.58h-13.46a.4.4 0 0 0-.4.4v126.18c0 .22.179.4.4.4h13.46a.4.4 0 0 0 .4-.4v-126.18a.4.4 0 0 0-.4-.4m155.4 109.98c0-1.2-.29-1.27-.86-.22-4.59 8.46-10.72 14.22-18.4 17.29-12.1 4.83-31.11 3.56-39.46-7.92-6.08-8.35-6.81-17.17-6.79-27.12.047-30.37.053-60.86.02-91.48q0-.54.53-.54h13.16c.36 0 .54.18.54.55.007 27.34.007 55.93 0 85.78-.01 8.37.39 21.95 7.91 27.51 2.96 2.19 6.56 3.44 10.81 3.76 11.86.9 20.67-3.58 26.43-13.45 3.8-6.51 4.64-13.99 4.64-21.4.01-27.31 0-54.65-.02-82q0-.75.75-.75h12.98c.33 0 .5.17.5.51v125.99q0 .21-.15.36a.47.47 0 0 1-.35.15l-12.02-.03c-.06 0-.12-.03-.17-.07a.3.3 0 0 1-.07-.17zM1636.12 1013h-13.5a.38.38 0 0 0-.38.38v126.24c0 .21.17.38.38.38h13.5c.21 0 .38-.17.38-.38v-126.24a.38.38 0 0 0-.38-.38",
        fill: "#595A5B"
    }));
};
module.exports.MresviaLogo = $ce99b1029a227006$var$MresviaLogo;

});

parcelRegister("2d3aB", function(module, exports) {
"use strict";
var $19bf412f59f6247c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MrnaAccess = void 0;

const $19bf412f59f6247c$var$react_1 = $19bf412f59f6247c$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $19bf412f59f6247c$var$MrnaAccess = ({ sx: sx = {} })=>{
    return $19bf412f59f6247c$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1042 316",
        "aria-label": "mRNA Access Logo"
    }, $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#4eace2",
        d: "M162.53 75.17a.55.55 0 00-.55.55v45.25a.45.45 0 01-.45.45H147.5a.43.42 90 01-.42-.43V1.46q0-.51.51-.51 9.9-.02 44.66-.04 5.82-.01 11.89 1.31c15.2 3.31 25.63 13.74 28.02 29.45 2.76 18.1-6.26 34.71-24.1 40.24q-.88.27-.44 1.08l25.94 47.49q.51.94-.56.94h-15.17a1.16 1.16 0 01-1.02-.61l-24.66-45.14a.96.95-14.1 00-.84-.5h-28.78zm-.52-59.91l-.08 45.46a.48.48 0 00.48.48l31.4.06a23.44 22.52.1 0023.48-22.48V37.4a23.44 22.52.1 00-23.4-22.56l-31.4-.06a.48.48 0 00-.48.48zM287.89 65.62q-11.82-16.27-24.83-35.87-.61-.92-.61.19v91a.56.55 0 01-.56.55h-13.37a.63.63 0 01-.63-.63V1.7q0-.73.73-.73h12.01a1.83 1.82-16.7 011.52.81q23.57 35.11 38.07 55.06 11.82 16.27 24.83 35.87.61.92.61-.19v-91a.56.55 0 01.56-.55h13.37a.63.63 0 01.63.63v119.16q0 .73-.73.73h-12.01a1.83 1.82-16.7 01-1.52-.81q-23.57-35.11-38.07-55.06zM407.86.93q4.6 0 8-.03a1.07 1.07 0 011 .69l44.85 118.91a.75.74 79.6 01-.69 1.01h-13.96q-.98 0-1.32-.92l-11.73-31.1a.87.86-10.2 00-.81-.56q-4.62-.04-25.47-.08-20.85-.02-25.47.01a.87.86 10.4 00-.81.55l-11.82 31.07q-.34.92-1.32.91l-13.96-.04a.75.74-79.4 01-.69-1.01l45.2-118.78a1.07 1.07 0 011-.68q3.4.04 8 .05zm-21.71 73.83a.34.34 0 00.32.46l42.04-.07a.34.34 0 00.32-.46l-21.12-56.03a.34.34 0 00-.63 0l-20.93 56.1zM550.72.93h15.6q.37 0 .49.34l44.92 119.09q.41 1.09-.75 1.09h-14.15a1.36 1.34 79.6 01-1.26-.88l-11.7-31a1.11 1.11 0 00-1.04-.72h-50.52a1.05 1.05 0 00-.98.67l-12.02 31.08q-.32.84-1.21.84h-13.88a.53.53 0 01-.49-.72q6.9-18.32 45.14-119.31.32-.85 1.15-.58.34.1.7.1zm-14.53 73.8a.36.36 0 00.34.48l41.97-.07a.36.36 0 00.34-.49l-21.09-55.98a.36.36 0 00-.67 0l-20.89 56.06z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M162.01 15.26a.48.48 0 01.48-.48l31.4.06a23.44 22.52.1 0123.4 22.56v1.38a23.44 22.52.1 01-23.48 22.48l-31.4-.06a.48.48 0 01-.48-.48l.08-45.46zM536.19 74.73l20.89-56.06a.36.36 0 01.67 0l21.09 55.98a.36.36 0 01-.34.49l-41.97.07a.36.36 0 01-.34-.48zM386.15 74.76l20.93-56.1a.34.34 0 01.63 0l21.12 56.03a.34.34 0 01-.32.46l-42.04.07a.34.34 0 01-.32-.46z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#4eace2",
        d: "M0 121.3V33.74l11.42-.01a.7.7 0 01.69.61l1.53 10.62a.28.27 59.4 00.49.13q9.73-13.03 26.41-12.45 18.03.63 25.98 16.06.19.38.4.01 6.06-10.73 18.09-14.47c7.63-2.37 18.17-2.32 25.77.88 14.93 6.3 18.99 20.93 19 36.14q.01 43.33.01 49.61a.55.55 0 01-.55.55h-13.22a.46.46 0 01-.46-.46q.01-47.21.03-51.21.03-8.41-3.86-15.42c-5.58-10.01-19.66-10.89-28.53-5.54-7.75 4.69-11.2 14.79-11.29 23.44q-.16 14.75-.06 48.41.01.8-.79.8h-12.8a.56.55 90 01-.55-.56q0-15.78-.05-50.87c-.02-10.78-4.34-21.74-16.15-23.99-11.04-2.09-20.73 3.29-24.83 13.55q-2.66 6.65-2.76 12.71-.22 12.85-.08 48.57a.57.57 0 01-.58.57L0 121.3zM627.68 77.34q-.02 4.07.14 5.44.68 5.71 3.18 11.27c5.81 12.9 19.7 18.58 33.06 14.39q11.2-3.51 14.98-16.5a.74.73 7.8 01.71-.53h13.43q.81 0 .64.79-5.58 25.43-30.72 29.72-6.14 1.05-13.86.12c-15.31-1.85-27.38-10.88-32.9-25.55q-2.57-6.83-2.99-12.49-.11-1.52-.07-6.75.03-5.24.16-6.76.5-5.65 3.17-12.44c5.72-14.6 17.91-23.46 33.24-25.1q7.74-.82 13.86.31 25.08 4.64 30.31 30.14.16.8-.65.78L679.94 64a.74.73-7 01-.7-.54q-3.6-13.04-14.75-16.71c-13.31-4.37-27.27 1.12-33.26 13.94q-2.58 5.52-3.34 11.22-.17 1.37-.21 5.43zM717.12 77.34c-.12 17.35 10.5 33.51 29.64 32.42 10.98-.63 18.73-6.82 21.76-17.49a1.17 1.16 7.9 011.12-.84h13.08a.78.77 6 01.76.93q-5.09 23.58-28.01 29.05-9.74 2.32-21.09-.21-19.26-4.3-27.11-21.77-4.59-10.2-4.5-22.2.08-12 4.82-22.13 8.11-17.35 27.43-21.37 11.38-2.37 21.09.09 22.84 5.81 27.58 29.46a.78.77-5.2 01-.77.92l-13.08-.19a1.17 1.16-7.1 01-1.11-.86c-2.87-10.71-10.53-17.01-21.5-17.8-19.12-1.37-29.98 14.63-30.11 31.99zM807.45 80.81q-.19 9.95 4.37 16.89 8.28 12.61 24.45 11.95c10.52-.43 19.84-6.35 22.64-16.74a1.37 1.36 7.5 011.32-1.01H873q.59 0 .46.57c-3.92 17.67-17.6 29.07-35.85 29.9-20.58.94-37.68-10.08-43.27-30.38q-3.91-14.22-.07-28.7 6.56-24.74 31.33-29.98 6.16-1.31 14.65-.29c24.56 2.94 36.82 23.38 34.48 46.79a.47.46-86.5 01-.46.41h-66.22q-.59 0-.6.59zm1.08-12.21l51.42-.08a.03.03 0 00.03-.03v-.08a25.44 23.31-.1 00-25.48-23.27h-.6a25.44 23.31-.1 00-25.4 23.35v.08a.03.03 0 00.03.03zM943.09 98.47c1.27-8.78-4.9-12.33-12.6-13.58-9.34-1.52-18.16-2.11-27.31-4.77-10.9-3.16-17.44-9.79-17.27-21.62.18-12.72 9.76-21.43 21.45-24.34 19.94-4.97 45.97 1.12 48.25 25.8a.43.42 86.9 01-.42.47h-13.38q-.54 0-.66-.52-2.43-10.81-13.24-14.07c-7.32-2.21-19.87-1.43-25.23 4.83-4.94 5.78-3.51 14.02 3.89 16.62q4.27 1.5 8.58 2.07c9.8 1.29 19.03 2.05 27.49 5.26q15.43 5.85 14.63 22.66c-.61 12.72-11.39 21.14-23.13 23.79q-11.65 2.63-23.46.26c-15.1-3.04-25.86-12.11-26.65-28.15a.73.72 88.9 01.72-.76h13.12q.56 0 .7.55c.18.73.11 1.79.29 2.44 3.04 10.59 12.43 14.54 22.93 14.88 7.79.25 19.96-2.58 21.3-11.82zM981.47 57.35c-.31 7.14 5.23 10.25 11.59 11.37q4.85.85 17.97 2.59 9.83 1.3 17.49 5.34 7.15 3.77 9.36 11.73c3.47 12.46-1.73 22.92-12.58 29.08-9.53 5.42-22.69 5.97-33.05 3.86-15.07-3.06-25.86-12.22-26.59-28.26a.61.61 0 01.61-.64h13.43a.45.44-2.8 01.45.4q1.18 10.56 11.18 14.91 7.08 3.09 15.61 2.43c8.81-.67 19.22-4.89 17.93-15.22q-.7-5.57-5.65-7.89-3.94-1.85-8.15-2.37-9.7-1.22-19.59-2.84-5.66-.93-11.97-3.77c-8.07-3.63-12.05-10.27-11.94-19.24q.16-13.67 12.53-20.99 7.96-4.7 18.18-5.1c10.68-.42 20.85 1.27 28.64 7.31q9.03 7.01 10.29 19.72a.61.6-3 01-.61.66h-13.07q-.46 0-.58-.45-3.1-12.34-15.95-14.75-7.97-1.5-16.05 1.19c-4.88 1.63-9.24 5.6-9.48 10.93z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M808.53 68.6a.03.03 0 01-.03-.03v-.08a25.44 23.31-.1 0125.4-23.35h.6a25.44 23.31-.1 0125.48 23.27v.08a.03.03 0 01-.03.03l-51.42.08z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#abdef4",
        d: "M0 187.87v-7.41q.86-2.58 4.25-2.58 28.38-.01 56.76-.01c3.88 0 6.85-.21 7.86 3.79q.53 2.13.06 4.82c-.66 3.77-3.23 4.15-6.77 4.14q-29.08-.01-58.16-.12-3.29-.01-4-2.63z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "70.02",
        height: "12.72",
        x: "-35.01",
        y: "-6.36",
        fill: "#abdef4",
        rx: "4.88",
        transform: "rotate(.1 -105495.073 69895.545)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.78",
        height: "12.7",
        x: "174.71",
        y: "177.88",
        fill: "#abdef4",
        rx: "4.74"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.88",
        height: "12.72",
        x: "264.82",
        y: "177.86",
        fill: "#72c8ec",
        rx: "4.74"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.72",
        height: "12.72",
        x: "352.67",
        y: "177.86",
        fill: "#72c8ec",
        rx: "4.69"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "70.1",
        height: "12.72",
        x: "-35.05",
        y: "-6.36",
        fill: "#72c8ec",
        rx: "5.07",
        transform: "rotate(.1 -105312.628 272395.963)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.88",
        height: "12.72",
        x: "530.55",
        y: "177.86",
        fill: "#72c8ec",
        rx: "4.82"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "70.1",
        height: "12.76",
        x: "-35.05",
        y: "-6.38",
        fill: "#4eace2",
        rx: "5.13",
        transform: "rotate(.1 -105223.673 374330.858)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.92",
        height: "12.78",
        x: "-34.96",
        y: "-6.39",
        fill: "#4eace2",
        rx: "4.94",
        transform: "rotate(-.1 105926.403 -424372.1)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "70",
        height: "12.8",
        x: "-35",
        y: "-6.4",
        fill: "#4eace2",
        rx: "5.1",
        transform: "rotate(.1 -105140.448 476265.759)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.94",
        height: "12.78",
        x: "883.87",
        y: "177.84",
        fill: "#4eace2",
        rx: "4.96"
    }), $19bf412f59f6247c$var$react_1.default.createElement("rect", {
        width: "69.82",
        height: "12.8",
        x: "971.6",
        y: "177.82",
        fill: "#4eace2",
        rx: "4.89"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#e43138",
        d: "M596.12 290.33l-.27 7.45q-.04 1.03-1.07 1.03h-1.45q-1.22 0-1.22-1.22v-54.74a.97.96-90 01.96-.97h2.26q.87 0 .87.87v22.99q0 1.01.52.14 4.13-7 11.25-8.36c10.74-2.04 19.83 3.69 22.42 14.62q.8 3.38.42 8.43c-.77 10.47-7.44 17.87-18.27 18.48q-10.68.6-15.97-8.84-.42-.75-.45.12zm15.44 5.07a17.35 15.39 89.8 0015.33-17.404 17.35 15.39 89.8 00-15.45-17.296 17.35 15.39 89.8 00-15.33 17.404 17.35 15.39 89.8 0015.45 17.296zM842.97 262.21q.47.58.47-.16v-19.78a.27.27 0 01.27-.27h8.32q.29 0 .29.3v56.11q0 .22-.22.22h-7.13a.42.42 0 01-.42-.36l-.75-5.23q-.09-.59-.47-.14-4.95 5.95-11.82 6.13-14.61.39-19.39-12.79-1.51-4.17-1.06-10.86c.8-11.95 9.52-19.55 21.83-18.48q6.2.54 10.08 5.31zm-11.192 29.62a13.88 12 89.8 0011.952-13.922 13.88 12 89.8 00-12.048-13.838 13.88 12 89.8 00-11.952 13.922 13.88 12 89.8 0012.048 13.838zM557.22 290.81q-.07-.49-.32-.06c-3.28 5.63-8.2 8.14-14.86 8.23q-12.53.16-17.5-11.89-3.6-8.74.1-18.2 4.19-10.72 16.11-11.64 10.48-.81 16 7.53.81 1.24.81-.24v-21.76a.86.84 0 01.86-.84h2.56q.81 0 .81.81v54.96a.99.98-90 01-.98.99h-1.43q-1.02 0-1.17-1.01l-.99-6.88zm-14.79 4.65a17.4 15.33 90.1 0015.36-17.373 17.4 15.33 90.1 00-15.3-17.427 17.4 15.33 90.1 00-15.36 17.373 17.4 15.33 90.1 0015.3 17.427zM1040.29 264.39a8.63 8.63 0 01-8.63 8.63 8.63 8.63 0 01-8.63-8.63 8.63 8.63 0 018.63-8.63 8.63 8.63 0 018.63 8.63zm-2.14.03a6.51 6.51 0 00-6.51-6.51 6.51 6.51 0 00-6.51 6.51 6.51 6.51 0 006.51 6.51 6.51 6.51 0 006.51-6.51zM704.4 261.92q6.44-6.93 16.08-4.62 5.43 1.31 7.86 6.11a.48.47-41.2 00.82.05q4.07-5.98 11.62-6.62c13.27-1.14 17.52 7.85 17.52 19.41q0 14.65.03 22.01 0 .37-.38.37h-7.97a.43.42 0 01-.43-.42q-.07-23.71-.16-24.54c-.68-5.81-3.16-10.08-9.69-9.27q-4.66.57-6.89 4.73-1.41 2.64-1.41 7.54-.01 12.52.03 21.5.01.48-.48.48h-8.01a.54.54 0 01-.54-.54q.01-17.41-.06-24.33c-.03-3.69-1.84-8.17-5.83-9.13-4.95-1.17-9.17.97-11.1 5.47q-.91 2.13-.91 6.12.03 18.46.03 22.11 0 .29-.29.29h-8.22a.37.37 0 01-.37-.37v-40.04q0-1.47 1.45-1.2 2.04.39 5.01.11a1.35 1.22-4.9 011.46 1.11l.24 3.42q.06.82.59.25zM805.626 280.096a18.86 18.86 0 01-18.893 18.827l-3.62-.006a18.86 18.86 0 01-18.827-18.893l.008-4.32a18.86 18.86 0 0118.893-18.827l3.62.006a18.86 18.86 0 0118.827 18.893l-.008 4.32zm-20.65 11.634a13.83 12.1 90.1 0012.124-13.809 13.83 12.1 90.1 00-12.076-13.851 13.83 12.1 90.1 00-12.124 13.809 13.83 12.1 90.1 0012.076 13.851zM868.28 279.78a.41.41 0 00-.41.44c.44 7.83 5.53 12.5 13.42 11.55q5.93-.71 8.28-6.84a.45.45 0 01.42-.29h8.09a.28.28 0 01.27.34c-2.41 10.06-10.93 14.98-20.81 13.98q-16.99-1.72-18.68-18.97-.83-8.36 3.56-15.07c7.51-11.5 27.86-10.95 34.22 1.48q3.06 5.98 2.24 12.87a.58.58 0 01-.58.51h-30.02zm.35-6.4l21.06-.08a.13.13 0 00.13-.13v-.08a10.51 9.27-.2 00-10.55-9.23h-.3a10.51 9.27-.2 00-10.47 9.31v.08a.13.13 0 00.13.13zM943.1 261.53q.13.92.77.24c7.37-7.78 22.62-6.74 27.18 3.34q2.14 4.71 1.98 13.6-.13 7.47-.15 19.38 0 .55-.55.55h-7.65a.57.56 90 01-.56-.57q.12-18.54-.07-24.05-.14-4.17-2.94-7.18c-3.33-3.57-9.91-3.17-13.44-.18-3.39 2.87-4.08 7.25-4.12 12.01q-.06 7.04.04 19.46a.51.51 0 01-.51.52h-7.74q-.56 0-.56-.56v-40.31a.63.62 0 01.63-.62h6.39a.78.78 0 01.77.66l.53 3.71zM1006.8 293.03q-1.87 2.35-3.25 3.33c-4.62 3.28-11.43 3.36-16.55 1.61q-7.12-2.44-8.17-9.46c-.76-5.1 1.68-10.39 6.46-12.68 5.89-2.82 13.61-2.5 20.46-2.13q.61.03.71-.57.44-2.74-.44-4.88c-1.66-4.02-6.57-4.86-10.52-4.27q-5.16.78-6.89 5.38-.18.48-.7.48h-7.39a.45.44-86.6 01-.44-.5q.59-4.99 4.4-8.37c6.04-5.37 19.3-5.79 25.83-.79 4.02 3.08 4.93 7.61 4.93 12.74q-.02 9.31.02 16.06 0 1.28 1.23 1.64 1.08.32 2.16.24 1.05-.09 1.05.97v6.15a.71.71 0 01-.71.71q-3.21-.02-6.34-.27-4.25-.35-5.06-5.18-.17-.99-.79-.21zm-4.27-12.8q-6.39.05-8.78.24-3.53.28-5.14 2.63c-2.33 3.41-.31 7.71 3.56 8.73q5.31 1.41 10.12-1.56 3.98-2.45 4.45-9.09.04-.53-.48-.61-2.13-.36-3.73-.34zM914.05 262.07q.2 1.33.93.2c2.76-4.27 7.38-4.91 12.24-5.14q1.18-.05 1.18 1.13v6.27q0 1.21-1.19 1.01-1.11-.19-3.42-.06c-6.72.37-9.49 5.75-9.52 11.77q-.07 9.87-.01 20.96a.42.42 0 01-.42.42h-7.87a.41.4-90 01-.4-.41v-40.31q0-.76.75-.76h6.3a.84.84 0 01.83.71l.6 4.21zM263.29 264.99q-.1 1.76.84.27c4.83-7.68 13.89-9.92 22.03-6.82q9.66 3.67 11.55 15.07 2.27 13.64-7.15 21.74-4.49 3.86-12.28 3.76-7-.08-11.71-4.6c-1.13-1.08-1.84-2.44-2.79-3.78q-.44-.62-.44.14v23.34q0 .7-.7.7h-2.58q-.75 0-.75-.75v-55.6q0-.88.89-.88h1.62q1.05 0 1.17 1.04.46 3.67.3 6.37zm15.421 30.41a17.36 15.36 89.5 0015.208-17.494 17.36 15.36 89.5 00-15.51-17.225 17.36 15.36 89.5 00-15.208 17.493 17.36 15.36 89.5 0015.51 17.225z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#e43138",
        d: "M324.537 299.31a21.21 19.82 89.9 01-19.857-21.175 21.21 19.82 89.9 0119.783-21.245 21.21 19.82 89.9 0119.857 21.175 21.21 19.82 89.9 01-19.783 21.245zm.004-3.85a17.39 15.32 89.8 0015.259-17.443 17.39 15.32 89.8 00-15.38-17.337 17.39 15.32 89.8 00-15.26 17.443 17.39 15.32 89.8 0015.38 17.337zM414.1 278.99c-.28 7.01 3.65 13.81 10.77 15.79 7.18 1.99 14.17-1.5 16.99-8.4q.82-2.02 2.84-1.47.1.02.25.02 2.09-.05 1.18 2.12-4.59 10.94-14.35 11.78-16.04 1.38-21.03-12.96c-2.32-6.69-1.48-15.54 2.66-21.3q6.37-8.87 18.92-7.06 6.83.98 10.95 6.55 4.43 6.01 3.68 13.82a.46.46 0 01-.46.42h-31.69a.71.71 0 00-.71.69zm.54-4.33l27.7-.14a.15.15 0 00.14-.15v-.08a13.84 13.51-.3 00-13.91-13.44h-.32a13.84 13.51-.3 00-13.77 13.58l.01.08a.15.15 0 00.15.15zM482.49 279.36q-.03 4.21 2.12 8.38c2.51 4.88 7.18 7.53 12.61 7.53q9.46-.01 13.4-9.41.42-1 1.51-1h1.82a1.06 1.06 0 01.99 1.44q-5.49 14.41-20.72 12.48c-6.87-.87-12.3-5.44-14.59-11.98q-3.88-11.12 1.44-20.92c6.32-11.62 25.36-11.73 31.83-.09q3 5.39 2.51 12.09a.44.44 0 01-.44.41h-31.41a1.08 1.07-89.7 00-1.07 1.07zm.61-4.76l27.86-.04a.12.12 0 00.12-.12v-.05a13.91 13.55-.1 00-13.93-13.53h-.28a13.91 13.55-.1 00-13.89 13.57v.05a.12.12 0 00.12.12z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#e43138",
        d: "M362.62 292.52q.1.31.21.01l12.05-34.05a1.42 1.39-88.2 01.93-.89q2.83-.8 3.7 1.92 6.1 18.97 10.47 32.74.11.36.42.33a.27.27 0 00.22-.17l11.88-33.59a1.93 1.93 0 011.82-1.28h1.2q1.72 0 1.15 1.61l-13.78 38.93q-.17.47-.67.55-1.8.3-3.51-.07-.54-.11-.71-.63l-10.68-31.88q-.5-1.49-1.03 0l-11.34 32.04a.84.83-83.8 01-.69.56q-1.89.22-3.57-.15-.47-.11-.62-.56l-13.13-39.21q-.4-1.17.84-1.17h1.98a1.58 1.58 0 011.5 1.08l11.36 33.88zM459.47 264.28q0 1.42.65.15 3.94-7.67 13.66-6.76.62.06.62.68v2.73a.65.65 0 01-.68.65c-6.11-.31-10.94 1.22-12.77 7.46q-1.43 4.9-1.48 8.81-.02 2.15-.02 20.07a.68.68 0 01-.68.68h-2.32q-.83 0-.83-.82v-39.36q0-1.04 1.04-1.04h1.82q.99 0 .99.99v5.76zM653.1 291.91l12.9-33.35a1.56 1.54 10.4 011.45-.99h2.49q1.06 0 .66.98-17.1 42.64-19.54 48.99c-1.32 3.43-3.03 6.83-7.12 7.1q-3.71.24-7.33.04-.81-.04-.81-.85v-2.22q0-.84.84-.79c2.82.17 7.74.73 9.21-1.96q2.53-4.64 3.97-9.22.45-1.43-.26-3.17-7.61-18.54-15.05-37.8-.43-1.11.76-1.11h2.25q1.07 0 1.47.99 12.94 32.64 12.97 32.71.21.55.59.81a.36.36 0 00.55-.16z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M1038.15 264.42a6.51 6.51 0 01-6.51 6.51 6.51 6.51 0 01-6.51-6.51 6.51 6.51 0 016.51-6.51 6.51 6.51 0 016.51 6.51zm-6.72 1.75q.93.51 1.34 2.2a.98.96 89.9 00.71.72l.51.13a1.02 1.02 0 001.02-1.65q-1.23-1.44-.37-2.66c.9-1.27 1.4-1.93.8-3.41q-.42-1.01-1.5-1.36-2.08-.69-4.33-.39-1.14.15-1.14 1.3v7.37q0 .7.68.86.36.08.7.01.64-.14.64-.8v-1.76a.64.64 0 01.94-.56z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#e43138",
        d: "M1031.43 266.17a.64.64 0 00-.94.56v1.76q0 .66-.64.8-.34.07-.7-.01-.68-.16-.68-.86v-7.37q0-1.15 1.14-1.3 2.25-.3 4.33.39 1.08.35 1.5 1.36c.6 1.48.1 2.14-.8 3.41q-.86 1.22.37 2.66a1.02 1.02 0 01-1.02 1.65l-.51-.13a.98.96 89.9 01-.71-.72q-.41-1.69-1.34-2.2zm1.71-3.31a1.38 1.38 0 00-1.38-1.38 1.38 1.38 0 00-1.38 1.38 1.38 1.38 0 001.38 1.38 1.38 1.38 0 001.38-1.38z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "17.36",
        ry: "15.36",
        transform: "rotate(89.5 -.959 279.52)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "17.39",
        ry: "15.32",
        transform: "rotate(89.8 22.719 301.842)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M414.64 274.66a.15.15 0 01-.15-.15l-.01-.08a13.84 13.51-.3 0113.77-13.58h.32a13.84 13.51-.3 0113.91 13.44v.08a.15.15 0 01-.14.15l-27.7.14zM483.1 274.6a.12.12 0 01-.12-.12v-.05a13.91 13.55-.1 0113.89-13.57h.28a13.91 13.55-.1 0113.93 13.53v.05a.12.12 0 01-.12.12l-27.86.04z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "17.4",
        ry: "15.33",
        transform: "rotate(90.1 132.442 409.787)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "17.35",
        ry: "15.39",
        transform: "rotate(89.8 166.239 445.844)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("circle", {
        cx: "1031.76",
        cy: "262.86",
        r: "1.38",
        fill: "#fff"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M868.63 273.38a.13.13 0 01-.13-.13v-.08a10.51 9.27-.2 0110.47-9.31h.3a10.51 9.27-.2 0110.55 9.23v.08a.13.13 0 01-.13.13l-21.06.08z"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "13.83",
        ry: "12.1",
        transform: "rotate(90.1 253.792 530.766)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("ellipse", {
        cx: "0",
        cy: "0",
        fill: "#fff",
        rx: "13.88",
        ry: "12",
        transform: "rotate(89.8 276.404 556.294)"
    }), $19bf412f59f6247c$var$react_1.default.createElement("path", {
        fill: "#fff",
        d: "M1002.53 280.23q1.6-.02 3.73.34.52.08.48.61-.47 6.64-4.45 9.09-4.81 2.97-10.12 1.56c-3.87-1.02-5.89-5.32-3.56-8.73q1.61-2.35 5.14-2.63 2.39-.19 8.78-.24z"
    }));
};
module.exports.MrnaAccess = $19bf412f59f6247c$var$MrnaAccess;

});

parcelRegister("4Cnhz", function(module, exports) {
"use strict";
var $35ccc56ad1915b74$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxElasomeran = void 0;

const $35ccc56ad1915b74$var$react_1 = $35ccc56ad1915b74$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $35ccc56ad1915b74$var$SpikevaxElasomeran = ({ sx: sx = {} })=>{
    return $35ccc56ad1915b74$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        viewBox: "0 0 193 87",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Spikevax (elasomeran mRNA vaccine) Logo"
    }, $35ccc56ad1915b74$var$react_1.default.createElement("path", {
        d: "M50.1 21.3c-.9 0-1.7-.7-1.7-1.7v-2.2c0-.8-.4-1.5-1.1-1.9L27.1 3.8c-.7-.4-1.5-.4-2.2 0L4.6 15.5c-.7.4-1.1 1.1-1.1 1.9v2.2c0 .9-.7 1.7-1.7 1.7S.1 20.6.1 19.6v-2.2c0-2 1-3.8 2.7-4.7L23.1 1c1.7-1 3.8-1 5.5 0L49 12.7c1.7 1 2.7 2.8 2.7 4.7v2.2c0 1-.7 1.7-1.6 1.7M26 60.4c-.9 0-1.9-.2-2.7-.7L3 48C1.3 47 .3 45.2.3 43.3V41c0-.9.7-1.7 1.7-1.7s1.7.7 1.7 1.7v2.2c0 .8.4 1.5 1.1 1.9l20.3 11.7c.7.4 1.5.4 2.2 0l20.3-11.7c.7-.4 1.1-1.1 1.1-1.9V41c0-.9.7-1.7 1.7-1.7.9 0 1.7.7 1.7 1.7v2.2c0 2-1 3.8-2.7 4.7L28.7 59.7c-.8.4-1.8.7-2.7.7m36.6-28.1c.1 1.6 1.6 2.8 3.9 2.8 2 0 3.4-.8 3.4-2.1 0-1.7-1.4-1.8-3.8-2.1-3.6-.4-6.4-1.2-6.4-4.5 0-3 2.7-5 6.4-5 3.9 0 6.6 1.8 6.8 5.1h-3.3c-.2-1.4-1.6-2.5-3.5-2.5-2 0-3.3.8-3.3 2.1 0 1.5 1.5 1.6 3.8 1.9 3.6.4 6.5 1.2 6.5 4.7 0 3-2.9 5-6.7 5-4.2 0-7.1-2-7.2-5.4zm29.5-2.7c0 4.9-3.2 8.1-7.5 8.1-2.4 0-4.2-1-5.1-2.4v8.4h-3.3V21.6H79l.4 2.4c1.1-1.4 2.7-2.5 5.2-2.5 4.3 0 7.5 3 7.5 8.1m-3.4 0c0-3.1-1.9-5.3-4.7-5.3s-4.6 2.1-4.6 5.2c0 3.2 1.8 5.4 4.6 5.4s4.7-2.2 4.7-5.3m9.8-12.3c0 1.2-.9 2-2 2s-2-.8-2-2c0-1.1.9-2 2-2s2 .9 2 2m-.3 4.3v15.9h-3.3V21.6zm6.8-4.3v12.1l7.3-7.8h3.9l-5.9 6.4 6.3 9.5h-4l-4.7-7-2.8 3v4.1h-3.3V17.3zm19.6 4.2c4.6 0 7.8 2.9 7.8 7.6 0 .4 0 .8-.1 1.3h-12v.2c.2 2.7 1.8 4.5 4.4 4.5 2 0 3.5-1 4-2.8h3.3c-.6 3.1-3.2 5.5-7.1 5.5-5 0-8.2-3.2-8.2-8.1.1-5 3.3-8.2 7.9-8.2m4.4 6.3c-.3-2.4-2-3.7-4.3-3.7-2.1 0-4 1.4-4.2 3.7zm7.6-6.2 4.4 12.3 4.3-12.3h3.5L143 37.5h-4.1L133 21.6zm28.7 13v2.9h-1.8c-2.2 0-2.9-1-2.9-2.5-1.1 1.6-2.7 2.7-5.2 2.7-3.5 0-5.9-1.7-5.9-4.7 0-3.3 2.4-5.1 6.8-5.1h4v-1c0-1.8-1.3-2.9-3.5-2.9-2 0-3.3.9-3.5 2.3H150c.3-3.2 3-5 7-5 4.2 0 6.7 2 6.7 5.8v6.3c0 .8.4 1.1 1.1 1.1h.5zm-5-4.1h-4.2c-2 0-3.2.8-3.2 2.4 0 1.3 1.1 2.3 2.9 2.3 2.8 0 4.4-1.6 4.4-4.1v-.6zm7.2-8.9h3.9l3.8 5.4 3.9-5.4h3.7l-5.6 7.8 6 8.1h-3.9l-4.2-5.8-4.2 5.8h-3.6l6-8.1z",
        fill: "#005E83"
    }), $35ccc56ad1915b74$var$react_1.default.createElement("path", {
        d: "M50.1 34.4h-.3c-.1 0-.2-.1-.4-.2-1.2-.9-2.6-2.9-3.2-4.4-1.3-3.1-2.8-6.6-6.3-6.6s-5 3.5-6.3 6.6c-.9 2.1-2 4.6-3.2 4.6s-2.3-2.6-3.2-4.6c-1.3-3.1-2.8-6.6-6.3-6.6s-5 3.5-6.3 6.6c-.9 2.1-2 4.6-3.2 4.6s-2.3-2.6-3.2-4.6c-1.3-3.1-2.7-6.6-6.3-6.6-1 0-1.7.7-1.7 1.5s.7 1.5 1.7 1.5c1.2 0 2.3 2.6 3.2 4.6 1.3 3.1 2.8 6.6 6.3 6.6s5-3.5 6.3-6.6c.9-2.1 2-4.6 3.2-4.6s2.3 2.6 3.2 4.6c1.3 3.1 2.8 6.6 6.3 6.6s5-3.5 6.3-6.6c.9-2.1 2-4.6 3.2-4.6s2.3 2.6 3.2 4.6c1.3 3.1 3.4 6.5 6.9 6.5 1 0 1.7-.7 1.7-1.5s-.7-1.4-1.6-1.4",
        fill: "#E31837"
    }), $35ccc56ad1915b74$var$react_1.default.createElement("path", {
        d: "M66.4 63.8c-.2 2.1-1.3 3.5-3.2 3.5-2.1 0-3.4-1.5-3.4-5.2 0-3.5 1.2-5.2 3.5-5.2 2.2 0 3.2 1.5 3.2 4.9v.4H61v.5c0 2.9 1 3.8 2.1 3.8 1.2 0 1.9-.8 2.1-2.6h1.2zm-1.1-2.6c0-2.5-.7-3.4-2.1-3.4s-2.2.9-2.2 3.4zm3-7.5h1.1v13.5h-1.1zm3.1 6.4c0-2.1 1-3.2 3.1-3.2s2.8 1.1 2.8 2.7v5.9c0 .6.2.8.6.8h.3v.8c-.2.1-.4.1-.5.1-.9 0-1.5-.2-1.5-1.2v-.3c-.5 1.3-1.5 1.7-2.6 1.7-1.8 0-2.5-1.1-2.5-2.8 0-1.3.6-2.4 2-2.8l2.1-.6c.8-.2 1-.4 1-1.6 0-1.3-.7-1.7-1.7-1.7-1.3 0-1.9.8-1.9 2.3h-1.2zm4.8 1.4c-.2.3-.8.5-1.2.7l-1 .2c-1.1.3-1.7.9-1.7 2.1s.6 2 1.6 2c1.4 0 2.3-1 2.3-2.8zm5.1.7c-1.4-.5-1.9-1.4-1.9-2.4 0-2.1 1.3-2.9 3-2.9 1.9 0 2.8 1 2.8 2.8v.3H84v-.3c0-1.3-.6-1.8-1.6-1.8-1.3 0-1.8.7-1.8 1.7 0 .7.2 1.2 1.4 1.7l1.6.6c1.4.5 1.9 1.5 1.9 2.5 0 1.7-1 3-3.1 3s-3.1-.8-3.1-3.1V64h1.1v.3c0 1.5.6 2.2 1.9 2.2 1.2 0 2-.7 2-1.8 0-.9-.4-1.5-1.4-1.8zm8.8-5.3c2.2 0 3.5 1.8 3.5 5.2 0 3.5-1.2 5.2-3.5 5.2s-3.5-1.8-3.5-5.2c0-3.5 1.3-5.2 3.5-5.2m0 9.5c1.3 0 2.2-1.1 2.2-4.3s-1-4.3-2.2-4.3-2.2 1.1-2.2 4.3.9 4.3 2.2 4.3m5.2-9.3h1v1.4c.5-1.1 1.4-1.6 2.5-1.6 1.2 0 1.9.7 2.1 1.8.5-1.1 1.3-1.8 2.5-1.8 1.4 0 2.3.8 2.3 2.6v7.7h-1.1v-7.5c0-1.2-.5-1.8-1.6-1.8s-2 1-2 2.6v6.7h-1v-7.5c0-1.2-.5-1.8-1.6-1.8s-2 1-2 2.6v6.7h-1.1zm19 6.7c-.2 2.1-1.3 3.5-3.2 3.5-2.1 0-3.4-1.5-3.4-5.2 0-3.5 1.2-5.2 3.5-5.2 2.2 0 3.2 1.5 3.2 4.9v.4h-5.5v.5c0 2.9 1 3.8 2.1 3.8 1.2 0 1.9-.8 2.1-2.6h1.2zm-1.1-2.6c0-2.5-.7-3.4-2.1-3.4s-2.1.9-2.1 3.4zm2.9-4.1h1.1v1.6c.4-1.1 1.4-1.8 2.5-1.8.1 0 .3 0 .4.1v1.1c-.2 0-.4-.1-.5-.1-1.2 0-2.4.9-2.4 2.8v6.3h-1.1zm5.099 3c0-2.1 1-3.2 3.1-3.2s2.8 1.1 2.8 2.7v5.9c0 .6.2.8.6.8h.3v.8c-.2.1-.4.1-.5.1-.9 0-1.5-.2-1.5-1.2v-.3c-.5 1.3-1.5 1.7-2.6 1.7-1.8 0-2.5-1.1-2.5-2.8 0-1.3.6-2.4 2-2.8l2.1-.6c.8-.2 1-.4 1-1.6 0-1.3-.7-1.7-1.7-1.7-1.3 0-1.9.8-1.9 2.3h-1.2zm4.8 1.4c-.2.3-.8.5-1.2.7l-.9.2c-1.1.3-1.7.9-1.7 2.1s.6 2 1.6 2c1.4 0 2.3-1 2.3-2.8v-2.2zm3.501-4.4h1v1.4c.6-1.1 1.5-1.6 2.6-1.6 1.5 0 2.6.8 2.6 2.7v7.6h-1.1V60c0-1.4-.6-2.1-1.7-2.1-1.3 0-2.2 1-2.2 2.6v6.7h-1.1V57.1z",
        fill: "#414042"
    }), $35ccc56ad1915b74$var$react_1.default.createElement("path", {
        d: "M188 21.6v.8h-1.2v3.4h-.9v-3.4h-1.2v-.8zm1.7 0 1.2 3.1 1.1-3.1h1.2v4.2h-.9V23l-1.1 2.8h-.7l-1.1-2.8v2.8h-.9v-4.2z",
        fill: "#005E83"
    }), $35ccc56ad1915b74$var$react_1.default.createElement("path", {
        d: "M60.5 76.1h1v1.4c.5-1.1 1.4-1.6 2.5-1.6 1.2 0 1.9.7 2.1 1.8.5-1.1 1.3-1.8 2.5-1.8 1.4 0 2.3.8 2.3 2.6v7.7H70v-7.5c0-1.2-.5-1.8-1.6-1.8s-2 1-2 2.6v6.7h-1.1v-7.5c0-1.2-.5-1.8-1.6-1.8s-2 1-2 2.6v6.7h-1.1V76.1zm12.8-3.4h4c2.2 0 3.5 1.3 3.5 3.4 0 1.6-.6 3.1-2.4 3.4 1.7.2 2.2 1.1 2.3 3.2v1.5c0 .7.1 1.5.6 2h-1.4c-.3-.5-.3-1.2-.4-1.9v-1.1c-.1-2.4-.5-3.1-2.7-3.1h-2.3v6.2h-1.2zm1.2 6.3h2.1c1.9 0 3-.9 3-2.6 0-1.6-.7-2.6-2.9-2.6h-2.2zm8.4-6.3h1.6l5.2 11.7V72.7h1.2v13.5h-1.6l-5.2-11.7v11.7h-1.2zm13.5 0h1.5l4 13.5h-1.3l-1.1-3.9h-4.7l-1.1 3.9h-1.3zm2.8 8.5-2.1-7.6-2.1 7.6zm6.4-5.1h1.2l2.2 8.7 2-8.7h1.2l-2.6 10h-1.3zm8.099 3c0-2.1 1-3.2 3.1-3.2s2.8 1.1 2.8 2.7v5.9c0 .5.2.8.6.8h.3v.8c-.2.1-.4.1-.5.1-.9 0-1.5-.2-1.5-1.2v-.3c-.5 1.3-1.5 1.7-2.6 1.7-1.8 0-2.5-1.1-2.5-2.8 0-1.3.6-2.4 2-2.8l2.1-.6c.8-.2 1-.4 1-1.6 0-1.3-.7-1.7-1.7-1.7-1.4 0-1.9.8-1.9 2.3h-1.2zm4.8 1.4c-.2.4-.8.5-1.2.7l-.9.2c-1.1.3-1.7.9-1.7 2.1s.6 2 1.6 2c1.4 0 2.3-1 2.3-2.8v-2.2zm9.201 2.3c-.2 2.1-1.3 3.5-3.2 3.5-2.1 0-3.4-1.5-3.4-5.2 0-3.5 1.2-5.2 3.5-5.2 1.9 0 3 1.2 3.1 3.2h-1.1c-.1-1.6-.8-2.3-2-2.3s-2.2.8-2.2 4.3c0 3.8 1.1 4.3 2.1 4.3 1.2 0 1.9-.8 2.1-2.6zm7.599 0c-.2 2.1-1.3 3.5-3.2 3.5-2.1 0-3.4-1.5-3.4-5.2 0-3.5 1.2-5.2 3.5-5.2 1.9 0 3 1.2 3.1 3.2h-1.1c-.1-1.6-.8-2.3-2-2.3s-2.2.8-2.2 4.3c0 3.8 1.1 4.3 2.1 4.3 1.2 0 1.9-.8 2.1-2.6zm1.501-10.1h1.1v1.9h-1.1zm0 3.4h1.1v10h-1.1zm3.099 0h1v1.4c.6-1.1 1.5-1.6 2.6-1.6 1.5 0 2.6.8 2.6 2.7v7.6h-1.1V79c0-1.4-.6-2.1-1.7-2.1-1.3 0-2.2 1-2.2 2.6v6.7h-1.1V76.1zm14.301 6.7c-.2 2.1-1.3 3.5-3.2 3.5-2.1 0-3.4-1.5-3.4-5.2 0-3.5 1.2-5.2 3.5-5.2 2.2 0 3.2 1.5 3.2 4.9v.4h-5.5v.5c0 2.9 1 3.8 2.1 3.8 1.2 0 1.9-.8 2.1-2.6h1.2zm-1.1-2.6c0-2.5-.7-3.4-2.1-3.4s-2.1.9-2.1 3.4z",
        fill: "#414042"
    }));
};
module.exports.SpikevaxElasomeran = $35ccc56ad1915b74$var$SpikevaxElasomeran;

});

parcelRegister("i2l8h", function(module, exports) {
"use strict";
var $d218ce5e89257583$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spikevax = void 0;

const $d218ce5e89257583$var$react_1 = $d218ce5e89257583$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $d218ce5e89257583$var$Spikevax = ({ sx: sx = {} })=>{
    return $d218ce5e89257583$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        viewBox: "0 0 220 63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Spikevax (COVID-19 Vaccine) Logo"
    }, $d218ce5e89257583$var$react_1.default.createElement("path", {
        d: "M47.724 20.072c-.419 0-.821-.166-1.117-.46a1.57 1.57 0 0 1-.463-1.113v-2.147a2.08 2.08 0 0 0-1.036-1.794L25.68 3.421a2.1 2.1 0 0 0-2.087 0L4.197 14.558a2.09 2.09 0 0 0-1.035 1.794v2.147c0 .417-.167.817-.463 1.112a1.585 1.585 0 0 1-2.236 0A1.57 1.57 0 0 1 0 18.5v-2.147c.006-.91.25-1.804.709-2.592a5.24 5.24 0 0 1 1.907-1.9L22.013.693a5.29 5.29 0 0 1 5.248 0l19.396 11.169a5.24 5.24 0 0 1 1.926 1.894c.464.788.713 1.683.722 2.597V18.5c0 .417-.166.817-.463 1.112-.296.295-.698.46-1.118.46M24.637 57.29a5.3 5.3 0 0 1-2.624-.693L2.616 45.454a5.25 5.25 0 0 1-1.906-1.9A5.2 5.2 0 0 1 0 40.961V38.79c0-.417.167-.817.463-1.112a1.585 1.585 0 0 1 2.236 0c.296.294.463.695.463 1.112v2.17a2.08 2.08 0 0 0 1.035 1.802l19.396 11.105a2.1 2.1 0 0 0 2.087 0L45.077 42.73a2.09 2.09 0 0 0 1.067-1.77v-2.17c0-.417.166-.817.463-1.112a1.585 1.585 0 0 1 2.235 0c.297.294.463.695.463 1.112v2.17a5.2 5.2 0 0 1-.702 2.61 5.25 5.25 0 0 1-1.914 1.913L27.26 56.597a5.3 5.3 0 0 1-2.624.693m35.047-26.765c.119 1.573 1.581 2.69 3.77 2.69 1.929 0 3.265-.787 3.265-2.006 0-1.573-1.368-1.746-3.684-2.037-3.406-.417-6.14-1.125-6.14-4.255 0-2.863 2.584-4.72 6.172-4.72 3.707 0 6.323 1.747 6.529 4.846H66.48c-.15-1.353-1.486-2.36-3.352-2.36s-3.114.787-3.114 1.974c0 1.424 1.454 1.573 3.62 1.801 3.407.347 6.22 1.133 6.22 4.515 0 2.894-2.734 4.72-6.378 4.72-4.039 0-6.797-1.889-6.884-5.168zm28.249-2.565c0 4.665-3.028 7.732-7.185 7.732a5.74 5.74 0 0 1-2.754-.528 5.7 5.7 0 0 1-2.17-1.769v8.03H72.66V20.403h2.727l.387 2.242a5.95 5.95 0 0 1 2.179-1.818 6 6 0 0 1 2.777-.605c4.142 0 7.2 2.895 7.2 7.74m-3.265 0c0-2.98-1.786-5.018-4.45-5.018-2.663 0-4.426 2.038-4.426 4.956s1.755 5.112 4.426 5.112 4.45-2.1 4.45-5.05m9.432-11.697a1.94 1.94 0 0 1-1.188 1.825 1.97 1.97 0 0 1-2.147-.403 1.95 1.95 0 0 1-.44-2.13 1.95 1.95 0 0 1 1.815-1.21 1.9 1.9 0 0 1 1.394.54 1.9 1.9 0 0 1 .566 1.378m-.356 4.137V35.52h-3.2V20.403zm6.561-4.137V27.78l6.947-7.378h3.707l-5.667 6.08 6.023 9.037h-3.802l-4.505-6.701-2.703 2.831v3.87h-3.201V16.265zm18.693 3.956c4.394 0 7.422 2.777 7.509 7.205q-.004.609-.087 1.21h-11.461v.182c.15 2.595 1.723 4.278 4.244 4.278 1.96 0 3.383-.975 3.834-2.658h3.201c-.538 2.98-3.059 5.254-6.798 5.254-4.805 0-7.833-3.067-7.833-7.7s2.996-7.77 7.391-7.77m4.244 6.088a3.83 3.83 0 0 0-1.333-2.606 3.86 3.86 0 0 0-2.793-.91 3.97 3.97 0 0 0-2.711.971 3.93 3.93 0 0 0-1.328 2.545zm7.279-5.908 4.189 11.688 4.118-11.688h3.383l-5.604 15.117h-3.952l-5.572-15.117zm27.451 12.341v2.776h-1.691c-2.079 0-2.79-.92-2.79-2.422a5.56 5.56 0 0 1-2.151 1.976 5.6 5.6 0 0 1-2.861.619c-3.327 0-5.635-1.62-5.635-4.428 0-3.099 2.252-4.837 6.497-4.837h3.825v-.92c0-1.684-1.272-2.714-3.351-2.714-1.873 0-3.161.889-3.383 2.21h-3.161c.324-3.036 2.845-4.782 6.679-4.782 4.031 0 6.378 1.92 6.378 5.506v5.954c0 .786.379 1.061 1.004 1.061zm-4.806-3.933h-3.952c-1.96 0-3.09.74-3.09 2.273 0 1.266 1.075 2.155 2.822 2.155 2.671 0 4.213-1.573 4.244-3.933zm6.878-8.408h3.738l3.652 5.105 3.707-5.105h3.501l-5.398 7.378 5.738 7.74h-3.738l-4.008-5.506-4.031 5.505h-3.47l5.691-7.74z",
        fill: "#005E83"
    }), $d218ce5e89257583$var$react_1.default.createElement("path", {
        d: "M47.724 32.554a.8.8 0 0 1-.245 0 2 2 0 0 1-.363-.197 11.8 11.8 0 0 1-3.067-4.144c-1.249-2.981-2.648-6.285-6.039-6.285s-4.79 3.304-6.038 6.245c-.838 1.967-1.89 4.413-3.067 4.413s-2.229-2.446-3.067-4.413c-1.249-2.941-2.664-6.245-6.039-6.245s-4.79 3.304-6.062 6.245c-.838 1.967-1.889 4.413-3.067 4.413-1.177 0-2.229-2.446-3.066-4.413-1.226-2.941-2.561-6.245-6.015-6.245a1.445 1.445 0 0 0-1.495.83 1.43 1.43 0 0 0 .36 1.665 1.44 1.44 0 0 0 1.135.345c1.13 0 2.22 2.446 3.066 4.412 1.25 2.926 2.664 6.276 6.04 6.276 3.374 0 4.789-3.319 6.038-6.245.838-1.966 1.88-4.412 3.066-4.412s2.23 2.446 3.067 4.412c1.25 2.895 2.664 6.245 6.039 6.245s4.79-3.319 6.039-6.245c.837-1.966 1.889-4.412 3.066-4.412 1.178 0 2.23 2.446 3.067 4.412 1.257 2.926 3.272 6.222 6.647 6.222a1.45 1.45 0 0 0 1.113-.36 1.43 1.43 0 0 0 .476-1.064 1.42 1.42 0 0 0-.476-1.064 1.44 1.44 0 0 0-1.113-.36z",
        fill: "#E21D39"
    }), $d218ce5e89257583$var$react_1.default.createElement("path", {
        d: "M178.931 20.395v.739h-1.186v3.256h-.861v-3.256h-1.162v-.74zm1.58 0 1.115 2.933 1.083-2.933h1.106v3.995h-.79v-2.674l-1.043 2.674h-.704l-1.043-2.674v2.674h-.791v-3.995z",
        fill: "#005E83"
    }), $d218ce5e89257583$var$react_1.default.createElement("path", {
        d: "M65.113 55.37v.292c0 2.5-.932 4.94-3.952 4.94-3.24 0-4.244-2.25-4.244-7.182 0-4.931 1.004-7.18 4.26-7.18 3.66 0 3.873 2.901 3.873 4.333v.252h-2.055v-.236c0-1.274-.355-2.745-1.834-2.69-1.478.055-2.197 1.007-2.197 5.458s.688 5.577 2.197 5.577c1.708 0 1.905-2.053 1.905-3.327v-.236zm.933-1.95c0-4.94 1.296-7.18 4.252-7.18s4.245 2.24 4.245 7.18-1.297 7.181-4.245 7.181-4.252-2.25-4.252-7.18m6.442-.063c0-4.64-.972-5.458-2.19-5.458s-2.197.786-2.197 5.458c0 4.767.972 5.577 2.197 5.577s2.19-.81 2.19-5.577m1.944-6.851h2.181l2.174 11.011 2.3-11.011h2.205l-3.24 13.819h-2.609zm9.793 0h2.055v13.819h-2.055zm3.691 0h3.652c4.03 0 4.537 2.823 4.537 6.913s-.506 6.906-4.537 6.906h-3.652zm2.047 12.16h1.692c1.691 0 2.37-1.204 2.37-5.247 0-3.932-.608-5.246-2.37-5.246h-1.692zm7.51-4.917h4.742v1.975h-4.742zm7.413 6.576V50.4h-2.624v-1.455h.197c1.225 0 2.648-.307 3.004-2.053v-.268h1.494v13.702zm5.904-3.06c0 .787.34 1.786 1.368 1.786 1.92 0 2.031-2.73 2.031-4.72h-.055a2.59 2.59 0 0 1-2.482 1.455c-1.747 0-3.162-1.352-3.162-4.081 0-3.147 1.202-5.034 3.905-5.034 3.217 0 3.833 2.635 3.833 6.56 0 4.105-.703 7.416-4.07 7.416-2.229 0-3.439-1.085-3.439-3.335zm1.455-9.092c-1.257 0-1.692 1.337-1.692 2.942 0 1.895.522 2.957 1.692 2.957 1.493 0 1.762-1.408 1.762-3.052s-.553-2.847-1.762-2.847m7.919-1.667h2.182l2.173 11.011h.04l2.3-11.011h2.181l-3.24 13.819h-2.609zm15.295 11.656c0 .385.221.731.506.731a.75.75 0 0 0 .324-.055v1.353a2.15 2.15 0 0 1-.949.252c-.869 0-1.58-.37-1.644-1.377a2.5 2.5 0 0 1-.938 1.156 2.5 2.5 0 0 1-1.433.417c-1.581 0-2.521-.928-2.521-2.925 0-2.36.932-2.808 2.252-3.272l1.51-.44c.703-.213 1.13-.433 1.13-1.338 0-.904-.3-1.573-1.328-1.573-1.296 0-1.478.983-1.478 1.99h-1.833c0-2.202.845-3.421 3.398-3.421 1.708 0 3.075.715 3.075 2.556zm-1.834-3.335c-.671.393-1.381.717-2.118.967a1.76 1.76 0 0 0-.791 1.691c0 .866.396 1.574 1.202 1.574 1.17 0 1.747-.952 1.747-2.478zm10.046 1.707c-.127 2.493-.917 4.066-3.312 4.066-2.806 0-3.596-2.25-3.596-5.505 0-3.257.79-5.506 3.596-5.506s3.328 2.438 3.328 3.736h-1.905c0-.968-.253-2.226-1.383-2.187-1.407 0-1.66 1.62-1.66 3.933s.253 3.932 1.66 3.932c1.074 0 1.478-.951 1.478-2.516zm7.682 0c-.087 2.517-.877 4.09-3.311 4.09-2.806 0-3.597-2.25-3.597-5.506s.791-5.506 3.597-5.506 3.327 2.438 3.327 3.736h-1.944c0-.967-.245-2.226-1.383-2.186-1.399 0-1.652 1.62-1.652 3.932 0 2.313.253 3.933 1.652 3.933 1.082 0 1.478-.952 1.478-2.517zm1.242-10.185h1.944v2.092h-1.944zm0 3.563h1.944v10.413h-1.944zm3.24-.001h1.834v1.22h.055a2.75 2.75 0 0 1 2.482-1.519c1.478 0 2.411.716 2.411 2.824v7.865h-1.944v-7.118c0-1.353-.372-1.88-1.344-1.88-.791 0-1.581.685-1.581 2.037v6.985h-1.944zm9.754 5.482v.598c0 1.392.166 3.146 1.581 3.146s1.581-1.706 1.581-2.36h1.833c0 2.305-1.296 3.76-3.398 3.76-1.581 0-3.549-.503-3.549-5.324 0-2.73.545-5.632 3.58-5.632 2.703 0 3.423 1.738 3.423 4.64v1.11zm3.114-1.431v-.566c0-1.314-.395-2.36-1.494-2.36-1.241 0-1.58 1.314-1.58 2.674v.213zm2.987 3.807h2.055v2.556c0 1.533-.474 2.658-2.055 2.98v-1.108c.562-.158.901-.716.901-1.573v-.291h-.901zm7.794-7.858h1.818v1.22h.056a2.69 2.69 0 0 1 2.316-1.518 2.12 2.12 0 0 1 1.414.373c.412.288.706.714.83 1.2a2.64 2.64 0 0 1 2.45-1.574c1.368 0 2.372.787 2.372 2.769v7.912h-1.945v-7.11c0-1.353-.379-1.88-1.169-1.88-.791 0-1.581.685-1.581 2.038v6.984h-1.897v-7.142c0-1.353-.38-1.88-1.194-1.88s-1.525.685-1.525 2.038v6.984h-1.945zm12.599-3.405h4.529c1.802 0 3.264.967 3.264 3.563 0 1.777-.743 3.146-2.142 3.39 1.273.133 1.945.888 2.016 2.823 0 .889 0 1.974.071 2.808a1.43 1.43 0 0 0 .609 1.195h-2.324a2.46 2.46 0 0 1-.34-1.219c-.071-.833-.055-1.573-.087-2.61-.039-1.511-.466-2.172-1.873-2.172h-1.676v6.002h-2.047zm3.691 6.158c1.312 0 2.047-.857 2.047-2.25 0-1.391-.593-2.24-1.944-2.24h-1.747v4.49zm5.485-6.158h2.506l3.723 10.295V46.507h1.944v13.819h-2.498l-3.723-10.57h-.039v10.57h-1.944zm12.726 0h2.624l3.422 13.819h-2.142l-.79-3.382h-3.762l-.791 3.382h-2.142zm2.735 8.651-1.478-6.819-1.534 6.843z",
        fill: "#939598"
    }));
};
module.exports.Spikevax = $d218ce5e89257583$var$Spikevax;

});

parcelRegister("fbIXk", function(module, exports) {
"use strict";
var $b0eac1652d91af4d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxModerna = void 0;

const $b0eac1652d91af4d$var$react_1 = $b0eac1652d91af4d$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $b0eac1652d91af4d$var$SpikevaxModerna = ({ sx: sx = {} })=>{
    return $b0eac1652d91af4d$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        viewBox: "25.343999999999998 34.5945945945946 525.888 100.90090090090091",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Spikevax by Moderna (COVID-19 Vaccine) Logo"
    }, $b0eac1652d91af4d$var$react_1.default.createElement("linearGradient", {
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "0",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(136.24962 0 0 -136.24962 270.524 72.143)",
        spreadMethod: "pad",
        id: "b"
    }, $b0eac1652d91af4d$var$react_1.default.createElement("stop", {
        stopOpacity: "1",
        stopColor: "#bee0f4",
        offset: "0"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("stop", {
        stopOpacity: "1",
        stopColor: "#bee0f4",
        offset: ".027"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("stop", {
        stopOpacity: "1",
        stopColor: "#3fb3e3",
        offset: ".774"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("stop", {
        stopOpacity: "1",
        stopColor: "#3fb3e3",
        offset: "1"
    })), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M94.542 65.022a2.203 2.203 0 0 1-2.202-2.203v-3a2.91 2.91 0 0 0-1.45-2.512L63.864 41.704a2.91 2.91 0 0 0-2.901 0L33.939 57.307a2.91 2.91 0 0 0-1.45 2.512v3a2.203 2.203 0 0 1-4.405 0v-3a7.33 7.33 0 0 1 3.653-6.327L58.761 37.89a7.33 7.33 0 0 1 7.307 0l27.024 15.602a7.33 7.33 0 0 1 3.653 6.327v3a2.203 2.203 0 0 1-2.203 2.203M62.415 117.14a7.33 7.33 0 0 1-3.654-.976l-27.024-15.602a7.33 7.33 0 0 1-3.653-6.327v-3a2.203 2.203 0 0 1 4.405 0v3a2.91 2.91 0 0 0 1.45 2.512l27.025 15.603a2.91 2.91 0 0 0 2.901 0L90.89 96.747a2.91 2.91 0 0 0 1.45-2.512v-3a2.203 2.203 0 0 1 4.405 0v3a7.33 7.33 0 0 1-3.653 6.327l-27.024 15.602a7.33 7.33 0 0 1-3.653.976m48.834-37.476c.165 2.19 2.19 3.762 5.25 3.762 2.687 0 4.547-1.075 4.547-2.811 0-2.232-1.901-2.439-5.126-2.853-4.754-.578-8.558-1.57-8.558-5.954 0-4.009 3.598-6.654 8.599-6.614 5.168.042 8.807 2.44 9.095 6.78h-4.34c-.207-1.9-2.067-3.307-4.671-3.307s-4.341 1.076-4.341 2.77c0 1.985 2.025 2.15 5.044 2.522 4.753.537 8.681 1.612 8.681 6.325 0 4.05-3.804 6.615-8.888 6.615-5.623 0-9.468-2.647-9.592-7.235zm34.804-3.597c0-4.175-2.48-7.028-6.201-7.028s-6.16 2.853-6.16 6.945c0 4.218 2.44 7.152 6.16 7.152s6.201-2.934 6.201-7.069m4.547 0c0 6.532-4.216 10.832-10.004 10.832-3.266 0-5.54-1.324-6.863-3.225v11.245h-4.465V65.484h3.886l.538 3.142c1.405-1.86 3.597-3.391 6.904-3.391 5.788 0 10.004 4.052 10.004 10.832m8.1 10.584h-4.466V65.484h4.466zm.496-26.955c0 1.571-1.2 2.687-2.73 2.687s-2.728-1.116-2.728-2.687c0-1.529 1.199-2.686 2.728-2.686s2.73 1.157 2.73 2.686m8.645 0V75.82l9.675-10.335h5.166L174.786 74l8.392 12.65h-5.292l-6.282-9.384-3.763 3.969v5.416h-4.465V59.696zm31.956 14.056c-.37-3.141-2.645-4.92-5.747-4.92-2.852 0-5.29 1.903-5.621 4.92Zm-5.912-8.516c6.118 0 10.336 3.886 10.46 10.087 0 .539-.042 1.116-.124 1.696h-15.957v.247c.206 3.638 2.397 5.994 5.91 5.994 2.73 0 4.714-1.364 5.334-3.72h4.465c-.744 4.175-4.259 7.359-9.468 7.359-6.696 0-10.913-4.3-10.913-10.79 0-6.574 4.176-10.873 10.293-10.873m16.061.248 5.83 16.37 5.746-16.37h4.713l-7.814 21.167h-5.456l-7.814-21.167Zm31.547 11.742h-5.54c-2.728 0-4.3 1.033-4.3 3.182 0 1.779 1.488 3.019 3.926 3.019 3.722 0 5.872-2.192 5.914-5.457zm6.696 5.54v3.885h-2.356c-2.894 0-3.886-1.281-3.886-3.39-1.406 2.15-3.554 3.638-6.986 3.638-4.63 0-7.855-2.273-7.855-6.201 0-4.34 3.141-6.779 9.053-6.779h5.334v-1.283c0-2.356-1.778-3.802-4.672-3.802-2.604 0-4.382 1.24-4.712 3.1h-4.383c.455-4.259 3.968-6.698 9.301-6.698 5.623 0 8.888 2.688 8.888 7.69v8.352c0 1.074.54 1.488 1.407 1.488zm2.886-17.282h5.208l5.087 7.152 5.167-7.152h4.878L263.89 75.82l7.98 10.832h-5.21l-5.58-7.69-5.623 7.69h-4.838l7.938-10.832z",
        fill: "#005e84"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M94.58 82.507a1 1 0 0 1-.342-.061 2.3 2.3 0 0 1-.498-.278c-1.568-1.158-3.438-3.838-4.274-5.805-1.742-4.095-3.716-8.737-8.416-8.737-4.697 0-6.672 4.642-8.414 8.737-1.17 2.753-2.628 6.179-4.274 6.179s-3.102-3.426-4.273-6.179c-1.742-4.095-3.716-8.737-8.414-8.737s-6.672 4.642-8.415 8.737c-1.17 2.753-2.628 6.179-4.273 6.179s-3.103-3.426-4.274-6.179c-1.741-4.095-3.65-8.737-8.413-8.737-1.29 0-2.217.89-2.217 1.989 0 1.097.934 1.988 2.217 1.988 1.573 0 3.101 3.427 4.272 6.179 1.743 4.096 3.716 8.737 8.415 8.737s6.673-4.641 8.414-8.737c1.17-2.752 2.628-6.179 4.274-6.179s3.102 3.427 4.273 6.179c1.741 4.096 3.716 8.737 8.414 8.737s6.672-4.641 8.415-8.737c1.17-2.752 2.628-6.179 4.273-6.179 1.647 0 3.104 3.427 4.275 6.179 1.743 4.096 4.556 8.702 9.255 8.702 1.29 0 2.216-.89 2.216-1.988s-.934-1.99-2.216-1.99",
        fill: "#d8292f"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M278.066 69.33h.796c.485 0 .855-.272.855-.739 0-.447-.35-.68-.855-.68h-.796Zm.835-2.138c1.049 0 1.71.564 1.71 1.399 0 .641-.389 1.108-1.03 1.283l1.049 1.748h-.952l-.932-1.574h-.68v1.574h-.855v-4.43Zm-.175-1.01c-1.827 0-3.167 1.36-3.167 3.245 0 1.845 1.34 3.187 3.167 3.187 1.845 0 3.187-1.362 3.187-3.207 0-1.865-1.342-3.225-3.187-3.225m0-.778c2.312 0 4.061 1.731 4.061 4.003s-1.749 3.983-4.061 3.983c-2.292 0-4.041-1.71-4.041-3.963 0-2.292 1.749-4.023 4.041-4.023",
        fill: "#005e84"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M360.698 62.995h2.83v3.799q1.475-2.102 3.034-3.072 2.144-1.294 4.512-1.294 1.6 0 3.034.627 1.438.627 2.347 1.667.912 1.042 1.577 2.982 1.414-2.586 3.528-3.933 2.12-1.341 4.556-1.343 2.283 0 4.023 1.152 1.747 1.152 2.592 3.214.848 2.061.848 6.185v12.003h-2.892V72.979q0-3.539-.5-4.86a4.4 4.4 0 0 0-1.724-2.133q-1.22-.808-2.912-.808a6.33 6.33 0 0 0-3.756 1.212q-1.704 1.214-2.485 3.233-.787 2.021-.787 6.75v8.609h-2.83V73.726q0-3.982-.494-5.406a4.53 4.53 0 0 0-1.73-2.284q-1.233-.858-2.929-.858-1.964 0-3.668 1.181-1.71 1.183-2.528 3.183-.816 2.002-.816 6.125v9.315h-2.83Zm49.241 2.204q-3.53-.001-6.065 2.607-2.539 2.606-2.538 6.304 0 2.386 1.159 4.446 1.153 2.063 3.123 3.184a8.53 8.53 0 0 0 4.321 1.123q2.35 0 4.319-1.123 1.966-1.121 3.122-3.184a8.93 8.93 0 0 0 1.159-4.446q0-3.698-2.548-6.304-2.543-2.608-6.052-2.607m.01-2.77q5.08 0 8.422 3.678 3.036 3.356 3.036 7.944 0 4.607-3.21 8.052-3.21 3.447-8.247 3.447-5.063 0-8.274-3.447-3.206-3.445-3.206-8.052-.002-4.568 3.037-7.924 3.337-3.699 8.443-3.699m27.333 2.73a8.52 8.52 0 0 0-7.54 4.42 8.93 8.93 0 0 0-1.183 4.441q.003 2.32 1.19 4.441 1.194 2.12 3.2 3.3a8.36 8.36 0 0 0 4.313 1.182q2.32 0 4.4-1.172t3.2-3.168q1.12-2 1.121-4.502-.001-3.817-2.517-6.378-2.512-2.566-6.184-2.564m11.307-10.651v30.475h-2.79v-3.778q-1.777 2.163-3.99 3.254t-4.84 1.09q-4.67 0-7.974-3.384-3.305-3.386-3.306-8.237 0-4.747 3.338-8.123c2.22-2.25 4.898-3.376 8.02-3.376q2.71 0 4.904 1.152t3.848 3.458V54.507zm24.918 17.26q-.568-2.264-1.648-3.619-1.083-1.356-2.864-2.182a8.8 8.8 0 0 0-3.742-.828q-3.24 0-5.566 2.08c-1.134 1.012-1.988 2.528-2.572 4.549Zm0 5.92 2.384 1.253q-1.173 2.304-2.71 3.722a10.8 10.8 0 0 1-3.46 2.15q-1.92.738-4.35.736-5.38.002-8.41-3.525-3.04-3.527-3.036-7.972 0-4.185 2.568-7.459c2.173-2.774 5.074-4.164 8.718-4.164 3.75 0 6.74 1.422 8.981 4.264q2.387 3.012 2.428 7.52h-19.787q.084 3.828 2.449 6.282 2.367 2.449 5.848 2.448 1.678 0 3.266-.584 1.588-.582 2.703-1.55 1.112-.968 2.408-3.121m7.317-14.692h2.892v3.213q1.291-1.9 2.727-2.84 1.43-.94 2.99-.94 1.175-.001 2.506.75l-1.473 2.384q-.892-.386-1.496-.384c-.947 0-1.852.386-2.73 1.161q-1.314 1.164-2 3.607-.525 1.878-.524 7.601v7.435h-2.892Zm14.387 0h2.83v3.94q1.697-2.263 3.76-3.385 2.06-1.12 4.485-1.122 2.466 0 4.377 1.254a7.47 7.47 0 0 1 2.819 3.376q.909 2.118.909 6.609v11.315h-2.83V74.494q0-3.798-.313-5.074-.493-2.182-1.886-3.281-1.4-1.104-3.642-1.104-2.565 0-4.597 1.697t-2.676 4.204q-.408 1.638-.407 5.984v8.062h-2.829zm35.841 2.163a8.53 8.53 0 0 0-4.36 1.16q-1.997 1.161-3.18 3.26a8.93 8.93 0 0 0-1.178 4.441q.002 2.32 1.188 4.441 1.194 2.12 3.202 3.3a8.35 8.35 0 0 0 4.308 1.182q2.324 0 4.403-1.172 2.08-1.171 3.199-3.168 1.12-2 1.12-4.502 0-3.817-2.514-6.378-2.512-2.566-6.188-2.564m11.31-2.163v21.987h-2.788v-3.778q-1.782 2.163-3.992 3.254-2.214 1.09-4.843 1.09-4.667-.001-7.972-3.384-3.303-3.386-3.304-8.237 0-4.747 3.333-8.123 3.339-3.376 8.024-3.376 2.71 0 4.902 1.152 2.194 1.151 3.852 3.458v-4.043zm3.086 1.73h.368q.264 0 .36-.08a.25.25 0 0 0 .096-.207.27.27 0 0 0-.046-.15.27.27 0 0 0-.128-.098 1 1 0 0 0-.306-.032h-.344Zm-.302 1.057v-1.879h.645q.33 0 .479.052a.47.47 0 0 1 .236.181.5.5 0 0 1 .088.276.5.5 0 0 1-.147.359.6.6 0 0 1-.39.17.5.5 0 0 1 .16.1q.113.111.277.373l.229.368h-.37l-.166-.296q-.197-.35-.317-.438a.4.4 0 0 0-.243-.065h-.179v.799Zm.765-2.423q-.368 0-.716.188a1.37 1.37 0 0 0-.545.54 1.47 1.47 0 0 0-.003 1.453q.192.347.54.539a1.46 1.46 0 0 0 1.988-.539q.192-.346.192-.724t-.196-.729-.545-.54a1.5 1.5 0 0 0-.715-.188m0-.29q.44 0 .859.226t.652.647q.234.418.234.874 0 .452-.23.868a1.6 1.6 0 0 1-.646.647 1.8 1.8 0 0 1-.869.23q-.453 0-.87-.23a1.6 1.6 0 0 1-.646-.647 1.76 1.76 0 0 1 .004-1.742q.235-.422.653-.647.42-.225.859-.225m-216.74 1.354 7.084 17.99 6.963-17.99h2.213l-9.78 24.188c-1.288 3.26-1.932 4.267-4.669 4.267h-3.138v-1.892h2.574c2.094 0 2.416-.604 3.381-2.899l1.33-3.178-8.17-20.486ZM316.602 83.3c-4.548 0-7.687-3.541-7.687-8.653 0-4.991 3.139-8.572 7.687-8.572s7.686 3.581 7.686 8.613c0 5.07-3.138 8.612-7.686 8.612m.16-19.036c-3.823 0-6.52 2.092-7.807 4.99v-12.92H306.9v28.575h1.772l.32-4.628c1.209 2.939 3.945 4.87 7.769 4.87 5.593 0 9.619-4.266 9.619-10.463 0-6.4-4.026-10.424-9.62-10.424",
        fill: "#d8292f"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M398.361 72.967q-.728 0-.729-.825 0-.823.729-.823h7.68q.733 0 .733.823 0 .825-.733.824h-5.673l-.014.001zm-11.466 0q-.731 0-.732-.825 0-.823.732-.823h7.681q.731 0 .73.823.001.825-.73.824h-5.674l-.013.001zm-11.468 0q-.73 0-.729-.825 0-.823.729-.823h7.681q.731 0 .732.823 0 .825-.732.824h-5.674l-.012.001zm-11.789 0q-.73 0-.73-.825 0-.823.73-.823h7.681q.731 0 .732.823 0 .825-.732.824h-5.674l-.013.001zm-11.468 0q-.731 0-.73-.825-.001-.823.73-.823h7.681q.73 0 .731.823-.001.825-.731.824h-5.674l-.013.001zm-11.466 0q-.731 0-.732-.825 0-.823.732-.823h7.681q.73 0 .73.823 0 .825-.73.824h-5.674l-.013.001zm-11.789 0q-.734 0-.732-.825-.002-.823.732-.823h7.678q.733 0 .732.823 0 .825-.732.824h-5.674l-.012.001zm-11.468 0q-.731 0-.732-.825 0-.823.732-.823h7.681q.73 0 .73.823 0 .825-.73.824h-5.675l-.012.001zm-11.469 0q-.73 0-.731-.825 0-.823.731-.823h7.681q.733 0 .733.823 0 .825-.733.824h-5.674l-.012.001zm-11.789 0q-.73 0-.731-.825 0-.823.731-.823h7.682q.73 0 .729.823 0 .825-.729.824h-5.675l-.015.001zm-11.468 0q-.73 0-.731-.825 0-.823.731-.823h7.682q.731 0 .732.823 0 .825-.732.824h-5.675l-.012.001zm-11.468 0q-.73 0-.729-.825 0-.823.729-.823h7.684q.727 0 .729.823-.002.825-.729.824h-5.674l-.015.001z",
        style: {
            fill: "url(#b)",
            stroke: "none"
        },
        transform: "matrix(1.33333 0 0 -1.33333 0 192)"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M119.03 124.06c-.225 4.067-2.096 6.336-5.289 6.336-3.64 0-5.685-2.819-5.685-9.204s2.045-9.204 5.685-9.204c3.617 0 5.113 2.57 5.113 5.488h-1.596c0-2.42-1.221-4.141-3.517-4.141-2.543 0-4.09 2.095-4.09 7.857 0 5.761 1.547 7.856 4.09 7.856 2.247 0 3.517-1.92 3.693-4.988zm7.278 4.988c2.544 0 4.09-2.095 4.09-7.857 0-5.761-1.546-7.856-4.09-7.856s-4.09 2.095-4.09 7.856 1.546 7.857 4.09 7.857m0-17.06c3.641 0 5.688 2.818 5.688 9.203s-2.047 9.205-5.688 9.205-5.687-2.82-5.687-9.205 2.047-9.203 5.687-9.203m6.006.299h1.696l3.967 16.113h.05l3.966-16.113h1.696l-4.69 17.81h-1.994Zm13.066 0h1.596v17.81h-1.596zm6.085 16.464h2.593c3.492 0 4.964-1.747 4.964-7.533 0-5.836-1.472-7.583-4.964-7.583h-2.593Zm-1.596-16.464h4.29c5.187 0 6.46 3.095 6.46 8.905s-1.273 8.905-6.46 8.905h-4.29zm17.979 11.4h-5.414v-1.348h5.414zm4.062-7.11h-4.04v-1.097c2.967-.025 4.29-1.197 4.39-3.042h1.146v17.66h-1.496zm10.566 6.137c2.418 0 3.292-2.246 3.292-4.516s-.874-4.514-3.292-4.514c-2.446 0-3.294 2.244-3.294 4.514s.848 4.516 3.294 4.516m-2.92 3.54c.076 1.722 1.049 2.894 2.794 2.894 2.444 0 3.643-2.195 3.716-8.03l-.05-.051c-.572 1.821-1.92 2.895-3.79 2.895-3.068 0-4.64-2.247-4.64-5.49 0-3.341 1.522-6.036 4.915-6.036 3.99 0 5.163 2.944 5.163 8.507 0 5.786-1.148 9.453-5.388 9.453-2.794 0-4.266-1.721-4.316-4.141zm15.108-13.967h1.696l3.966 16.113h.05l3.966-16.113h1.696l-4.69 17.81h-1.994Zm18.338 10.327h-.05c-.149.449-.998.724-1.595.873l-1.248.324c-1.496.399-2.27 1.172-2.27 2.744 0 1.545.8 2.593 2.095 2.593 1.82 0 3.068-1.372 3.068-3.74zm-6.336-1.82c0-2.72 1.297-4.242 4.09-4.242 2.745 0 3.742 1.423 3.742 3.518v7.831c0 .748.25 1.098.773 1.098h.426v1.097a2.1 2.1 0 0 1-.699.15c-1.173 0-1.921-.274-1.921-1.646v-.45h-.05c-.6 1.747-1.945 2.246-3.417 2.246-2.32 0-3.367-1.447-3.367-3.743 0-1.745.798-3.14 2.668-3.666l2.82-.797c1.047-.3 1.271-.548 1.271-2.096 0-1.695-.948-2.294-2.295-2.294-1.77 0-2.544 1.072-2.544 2.994Zm18.528 4.913c-.224 2.817-1.77 4.69-4.216 4.69-2.793 0-4.439-1.946-4.439-6.937 0-4.588 1.646-6.908 4.564-6.908 2.495 0 3.942 1.522 4.091 4.24h-1.496c-.176-2.07-.999-2.993-2.595-2.993-1.62 0-2.968.997-2.968 5.688 0 4.988 1.422 5.661 2.818 5.661 1.522 0 2.494-1.123 2.745-3.441zm10.05 0c-.225 2.817-1.77 4.69-4.214 4.69-2.795 0-4.44-1.946-4.44-6.937 0-4.588 1.645-6.908 4.564-6.908 2.495 0 3.941 1.522 4.09 4.24h-1.495c-.176-2.07-.999-2.993-2.595-2.993-1.621 0-2.968.997-2.968 5.688 0 4.988 1.421 5.661 2.817 5.661 1.523 0 2.495-1.123 2.746-3.441zm1.954-8.855h1.496v13.245h-1.496zm0-4.565h1.496v2.544h-1.496zm4.06 4.565h1.347v1.847h.05c.748-1.473 2.046-2.147 3.392-2.147 2.02 0 3.392 1.05 3.392 3.543v10.002h-1.496v-9.578c0-1.82-.749-2.719-2.269-2.719-1.747 0-2.92 1.347-2.92 3.392v8.905h-1.496Zm17.475 5.438c-.05-3.294-.972-4.49-2.819-4.49s-2.768 1.196-2.819 4.49Zm1.472 3.417c-.224 2.818-1.772 4.69-4.267 4.69-2.792 0-4.439-1.946-4.439-6.935 0-4.59 1.647-6.91 4.564-6.91 2.944 0 4.266 2.022 4.266 6.435v.55h-7.234v.623c0 3.817 1.347 4.99 2.819 4.99 1.57 0 2.544-1.123 2.793-3.443zm2.55 1.845h1.696v2.544c0 1.472-.298 2.87-1.844 3.443v-.999c.648-.399.847-1.097.872-2.444h-.724z",
        fill: "#3d3935"
    }), $b0eac1652d91af4d$var$react_1.default.createElement("path", {
        d: "M274.126 116.852h1.347v1.847h.049c.699-1.473 1.896-2.147 3.368-2.147 1.597 0 2.57.974 2.768 2.322h.05c.6-1.474 1.671-2.322 3.367-2.322 1.847 0 3.07 1.05 3.07 3.419v10.126h-1.498v-9.902c0-1.572-.722-2.395-2.07-2.395-1.496 0-2.695 1.347-2.695 3.392v8.905h-1.496v-9.902c0-1.572-.724-2.395-2.07-2.395-1.495 0-2.694 1.347-2.694 3.392v8.905h-1.496zm18.488 3.767h2.744c2.519 0 3.99-1.148 3.99-3.492 0-2.17-.923-3.492-3.817-3.492h-2.917Zm-1.596-8.332h5.312c2.97 0 4.615 1.696 4.615 4.465 0 2.146-.848 4.066-3.218 4.515v.05c2.22.2 2.968 1.471 3.043 4.215l.05 1.947c.025.972.125 1.92.749 2.617h-1.872c-.374-.623-.448-1.547-.474-2.495l-.05-1.496c-.1-3.142-.672-4.14-3.54-4.14h-3.02v8.131h-1.595zm12.745 0h2.144l6.81 15.516h.05v-15.516h1.596v17.81h-2.144l-6.81-15.514h-.05v15.513h-1.596Zm21.518 11.275-2.744-10.028h-.05l-2.742 10.028Zm-3.766-11.275h1.995l5.263 17.81h-1.695l-1.447-5.189h-6.236l-1.448 5.188h-1.694z"
    }));
};
module.exports.SpikevaxModerna = $b0eac1652d91af4d$var$SpikevaxModerna;

});

parcelRegister("eYHh7", function(module, exports) {
"use strict";
var $ae783cd73ff168bb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxRegistered = void 0;

const $ae783cd73ff168bb$var$react_1 = $ae783cd73ff168bb$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $ae783cd73ff168bb$var$SpikevaxRegistered = ({ sx: sx })=>{
    return $ae783cd73ff168bb$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        "aria-label": "Spikevax COVID-19 mRNA vaccine",
        viewBox: "0 0 221 71",
        sx: sx
    }, $ae783cd73ff168bb$var$react_1.default.createElement("path", {
        fill: "#005E83",
        d: "M50.778 21.223c-.912 0-1.652-.74-1.652-1.652v-2.25a2.18 2.18 0 00-1.088-1.884L27.768 3.735a2.184 2.184 0 00-2.175 0L5.323 15.437a2.18 2.18 0 00-1.087 1.884v2.25a1.652 1.652 0 01-3.304 0v-2.25a5.496 5.496 0 012.739-4.745L23.94.874a5.492 5.492 0 015.479 0l20.269 11.702a5.495 5.495 0 012.74 4.745v2.25c0 .912-.74 1.652-1.652 1.652h.002zM26.682 60.312a5.48 5.48 0 01-2.74-.732L3.672 47.878a5.496 5.496 0 01-2.74-4.745v-2.25a1.652 1.652 0 013.305 0v2.25a2.18 2.18 0 001.088 1.884l20.269 11.702a2.184 2.184 0 002.176 0l20.269-11.702a2.18 2.18 0 001.088-1.884v-2.25a1.652 1.652 0 013.304 0v2.25a5.496 5.496 0 01-2.74 4.745L29.424 59.58a5.48 5.48 0 01-2.741.732zM63.308 32.205c.124 1.643 1.643 2.821 3.938 2.821 2.016 0 3.411-.806 3.411-2.108 0-1.674-1.426-1.829-3.845-2.14-3.566-.434-6.418-1.178-6.418-4.465 0-3.007 2.698-4.992 6.449-4.96 3.876.03 6.604 1.83 6.821 5.084h-3.255c-.155-1.426-1.55-2.48-3.503-2.48s-3.256.807-3.256 2.078c0 1.488 1.52 1.612 3.783 1.891 3.566.403 6.511 1.21 6.511 4.744 0 3.04-2.853 4.961-6.666 4.961-4.217 0-7.101-1.984-7.193-5.426h3.225-.002zm29.514-2.698c0 4.9-3.162 8.124-7.503 8.124-2.45 0-4.155-.992-5.147-2.418v8.434h-3.349V21.571h2.915l.403 2.356c1.054-1.395 2.698-2.542 5.178-2.542 4.341 0 7.503 3.04 7.503 8.124v-.002zm-3.41 0c0-3.13-1.86-5.27-4.651-5.27-2.791 0-4.62 2.14-4.62 5.208 0 3.163 1.83 5.364 4.62 5.364s4.651-2.202 4.651-5.302zm9.856-12.278c0 1.178-.899 2.015-2.047 2.015-1.148 0-2.046-.837-2.046-2.015 0-1.147.899-2.015 2.046-2.015 1.147 0 2.047.868 2.047 2.015zm-.372 4.341v15.875h-3.349V21.57h3.349zm6.856-4.34V29.32l7.256-7.75h3.875l-5.922 6.386 6.294 9.488h-3.969l-4.712-7.039-2.822 2.977v4.062h-3.349V17.23h3.349zm19.534 4.154c4.589 0 7.752 2.915 7.845 7.565 0 .403-.031.837-.093 1.271h-11.969v.186c.155 2.73 1.799 4.496 4.434 4.496 2.047 0 3.535-1.023 4-2.79h3.349c-.558 3.13-3.193 5.518-7.101 5.518-5.022 0-8.186-3.225-8.186-8.093 0-4.93 3.132-8.153 7.721-8.153zm4.433 6.387c-.278-2.356-1.984-3.69-4.31-3.69-2.14 0-3.969 1.427-4.217 3.69h8.527zm7.612-6.2l4.372 12.277 4.31-12.278h3.535l-5.86 15.875h-4.093l-5.859-15.875h3.596-.001zm28.683 12.96v2.914h-1.768c-2.17 0-2.914-.96-2.914-2.542-1.055 1.612-2.666 2.73-5.24 2.73-3.473 0-5.891-1.706-5.891-4.652 0-3.255 2.356-5.085 6.79-5.085h4v-.96c0-1.768-1.333-2.854-3.504-2.854-1.953 0-3.286.931-3.534 2.326h-3.287c.341-3.194 2.977-5.023 6.977-5.023 4.217 0 6.666 2.016 6.666 5.767v6.263c0 .806.403 1.116 1.055 1.116h.65zm-5.022-4.156h-4.155c-2.046 0-3.225.775-3.225 2.387 0 1.333 1.116 2.264 2.945 2.264 2.791 0 4.403-1.644 4.435-4.093v-.558zm7.186-8.805h3.906l3.814 5.364 3.875-5.364h3.659l-5.644 7.751 5.984 8.124h-3.906l-4.187-5.767-4.217 5.767h-3.628l5.953-8.124-5.611-7.75h.002z"
    }), $ae783cd73ff168bb$var$react_1.default.createElement("path", {
        fill: "#E31837",
        d: "M50.806 34.336a.815.815 0 01-.256-.046 1.69 1.69 0 01-.374-.208c-1.176-.869-2.578-2.879-3.205-4.354-1.307-3.072-2.787-6.553-6.31-6.553-3.525 0-5.006 3.482-6.312 6.553-.878 2.065-1.97 4.634-3.206 4.634-1.235 0-2.327-2.569-3.205-4.634-1.307-3.072-2.787-6.553-6.31-6.553-3.525 0-5.005 3.482-6.312 6.553-.878 2.064-1.97 4.634-3.205 4.634-1.234 0-2.327-2.569-3.205-4.634-1.307-3.072-2.737-6.553-6.31-6.553-.968 0-1.663.668-1.663 1.492s.7 1.492 1.662 1.492c1.18 0 2.327 2.569 3.205 4.634 1.307 3.072 2.787 6.553 6.311 6.553s5.004-3.482 6.311-6.553c.878-2.064 1.971-4.634 3.205-4.634s2.327 2.569 3.205 4.634c1.307 3.072 2.787 6.553 6.311 6.553s5.005-3.482 6.312-6.553c.878-2.064 1.971-4.634 3.205-4.634s2.328 2.569 3.206 4.634c1.307 3.071 3.417 6.527 6.941 6.527.967 0 1.662-.668 1.662-1.492s-.7-1.492-1.663-1.492z"
    }), $ae783cd73ff168bb$var$react_1.default.createElement("path", {
        fill: "#005E83",
        d: "M188.439 21.571c1.772-.038 3.121 1.272 3.121 3.001 0 1.705-1.312 2.987-3.046 2.987-1.774 0-3.114-1.366-3.027-3.136.077-1.544 1.407-2.819 2.952-2.852zm.075.582c-1.37 0-2.375 1.02-2.375 2.434 0 1.49 1.163 2.54 2.692 2.373 1.079-.118 1.955-1.018 2.059-2.098.148-1.545-.898-2.709-2.376-2.709zm.132.758c.787 0 1.282.423 1.282 1.05 0 .48-.292.83-.772.961l.787 1.311h-.714l-.7-1.18h-.51v1.18h-.641v-3.322h1.268zm-.627 1.603h.597c.364 0 .641-.204.641-.554 0-.335-.262-.51-.641-.51h-.597v1.064z"
    }), $ae783cd73ff168bb$var$react_1.default.createElement("path", {
        fill: "#58595B",
        d: "M69.704 65.86c-.171 3.096-1.596 4.825-4.027 4.825-2.773 0-4.332-2.147-4.332-7.01 0-4.865 1.558-7.01 4.332-7.01 2.754 0 3.895 1.956 3.895 4.18h-1.216c0-1.844-.931-3.154-2.679-3.154-1.938 0-3.116 1.596-3.116 5.983s1.178 5.984 3.116 5.984c1.709 0 2.679-1.463 2.812-3.799h1.216l-.001.001zm5.453-9.195c2.773 0 4.332 2.146 4.332 7.01s-1.558 7.011-4.332 7.011-4.332-2.147-4.332-7.01c0-4.865 1.558-7.01 4.332-7.01zm0 12.994c1.938 0 3.116-1.596 3.116-5.984s-1.178-5.983-3.116-5.983c-1.938 0-3.116 1.596-3.116 5.983s1.178 5.984 3.116 5.984zm4.58-12.765h1.292l3.021 12.271h.038l3.021-12.27h1.292L84.83 70.456h-1.52l-3.571-13.563h-.002zm9.575 0h1.216v13.563h-1.216V56.894zm3.286 0h3.268c3.951 0 4.92 2.355 4.92 6.781s-.969 6.782-4.92 6.782h-3.268V56.894zm1.215 12.538h1.976c2.66 0 3.78-1.33 3.78-5.737 0-4.445-1.121-5.775-3.78-5.775h-1.976v11.512zm12.952-4.883v1.026h-4.122V64.55h4.122zm2.812-4.388H106.5v-.836c2.26-.02 3.267-.912 3.343-2.318h.874v13.45h-1.14V60.161zm5.738 7.37c.058 1.312.798 2.204 2.128 2.204 1.861 0 2.773-1.672 2.83-6.117l-.037-.038c-.438 1.387-1.463 2.204-2.889 2.204-2.336 0-3.533-1.71-3.533-4.18 0-2.546 1.159-4.598 3.742-4.598 3.04 0 3.934 2.242 3.934 6.48 0 4.406-.875 7.2-4.104 7.2-2.129 0-3.249-1.313-3.287-3.155h1.216zm2.223-2.697c1.843 0 2.508-1.71 2.508-3.438 0-1.728-.665-3.438-2.508-3.438-1.862 0-2.508 1.71-2.508 3.438 0 1.728.646 3.438 2.508 3.438zm10.032-4.464h1.025v1.405h.038c.532-1.12 1.444-1.634 2.564-1.634 1.216 0 1.957.741 2.108 1.767h.039c.455-1.12 1.271-1.767 2.564-1.767 1.405 0 2.336.798 2.336 2.603v7.713h-1.14v-7.542c0-1.196-.551-1.823-1.577-1.823-1.139 0-2.051 1.025-2.051 2.583v6.782h-1.141v-7.542c0-1.196-.551-1.823-1.576-1.823-1.141 0-2.052 1.025-2.052 2.583v6.782h-1.14V60.37h.003zm12.586-3.476h4.046c2.261 0 3.515 1.292 3.515 3.4 0 1.634-.646 3.097-2.451 3.438v.038c1.691.151 2.261 1.12 2.318 3.21l.037 1.482c.02.74.096 1.463.57 1.994h-1.425c-.284-.475-.342-1.178-.36-1.899l-.039-1.14c-.076-2.394-.512-3.153-2.697-3.153h-2.299v6.192h-1.215V56.894zm1.215 6.344h2.09c1.919 0 3.039-.874 3.039-2.659 0-1.653-.702-2.66-2.906-2.66h-2.223v5.32zm8.213-6.344h1.633l5.187 11.816h.038V56.894h1.216v13.563h-1.634l-5.186-11.816h-.039v11.816h-1.215V56.894zm13.24 0h1.52l4.008 13.563h-1.291l-1.102-3.95h-4.75l-1.102 3.95h-1.292l4.009-13.563zm2.868 8.586l-2.09-7.638h-.038l-2.09 7.638h4.218zm6.765-5.11h1.216l2.241 8.795h.039l2.051-8.795h1.217l-2.66 10.087h-1.292l-2.812-10.087zm7.264 3.001c0-2.07.988-3.229 3.115-3.229 2.09 0 2.85 1.083 2.85 2.68v5.964c0 .57.189.836.589.836h.323v.836c-.209.076-.38.114-.532.114-.893 0-1.463-.209-1.463-1.254v-.342h-.038c-.455 1.33-1.481 1.71-2.602 1.71-1.768 0-2.565-1.103-2.565-2.85 0-1.33.608-2.394 2.032-2.793l2.147-.607c.798-.229.969-.418.969-1.596 0-1.292-.722-1.748-1.748-1.748-1.349 0-1.938.816-1.938 2.28h-1.139zm4.825 1.387h-.038c-.113.342-.76.551-1.216.665l-.95.247c-1.14.304-1.729.893-1.729 2.09 0 1.178.607 1.976 1.596 1.976 1.387 0 2.337-1.045 2.337-2.85v-2.128zm9.253 2.356c-.171 2.146-1.35 3.571-3.211 3.571-2.127 0-3.381-1.482-3.381-5.28 0-3.497 1.254-5.264 3.477-5.264 1.899 0 3.001 1.16 3.115 3.23h-1.141c-.133-1.577-.76-2.28-1.975-2.28-1.235 0-2.262.76-2.262 4.331 0 3.8 1.084 4.312 2.147 4.312 1.159 0 1.899-.854 2.089-2.62h1.142zm7.37 0c-.171 2.146-1.349 3.571-3.211 3.571-2.128 0-3.382-1.482-3.382-5.28 0-3.497 1.254-5.264 3.477-5.264 1.9 0 3.002 1.16 3.116 3.23h-1.14c-.133-1.577-.76-2.28-1.977-2.28-1.234 0-2.26.76-2.26 4.331 0 3.8 1.082 4.312 2.146 4.312 1.158 0 1.899-.854 2.09-2.62H201.169zm1.464-10.22h1.14v1.938h-1.14v-1.938zm0 3.476h1.14v10.087h-1.14V60.37zm3.135 0h1.025v1.405h.038c.57-1.12 1.558-1.634 2.584-1.634 1.538 0 2.583.798 2.583 2.698v7.617h-1.14v-7.295c0-1.387-.569-2.07-1.729-2.07-1.329 0-2.223 1.025-2.223 2.583v6.782h-1.14V60.37l.002.001zm14.363 6.744c-.172 2.146-1.35 3.571-3.249 3.571-2.128 0-3.382-1.482-3.382-5.28 0-3.497 1.254-5.264 3.477-5.264 2.242 0 3.248 1.54 3.248 4.901v.418h-5.508v.475c0 2.907 1.025 3.8 2.146 3.8 1.196 0 1.938-.854 2.127-2.62h1.141zm-1.121-2.603c-.038-2.507-.741-3.419-2.146-3.419-1.405 0-2.109.912-2.146 3.42h4.292z"
    }));
};
module.exports.SpikevaxRegistered = $ae783cd73ff168bb$var$SpikevaxRegistered;

});

parcelRegister("kumwG", function(module, exports) {
"use strict";
var $eea8153974863b86$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxRegisteredFrench = void 0;

const $eea8153974863b86$var$react_1 = $eea8153974863b86$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $eea8153974863b86$var$SpikevaxRegisteredFrench = ({ sx: sx })=>{
    return $eea8153974863b86$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        "aria-label": "Spikevax COVID-19 ARNm vaccin",
        viewBox: "50.93 53.14 210.2 70.54",
        sx: sx
    }, $eea8153974863b86$var$react_1.default.createElement("g", null, $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M100.778,74.223c-.912,0-1.652-.74-1.652-1.652v-2.25c0-.775-.417-1.497-1.088-1.884l-20.269-11.702c-.671-.387-1.505-.387-2.176,0l-20.269,11.702c-.671.387-1.088,1.109-1.088,1.884v2.25c0,.912-.739,1.652-1.652,1.652s-1.652-.74-1.652-1.652v-2.25c0-1.951,1.05-3.769,2.739-4.745l20.269-11.702c1.69-.976,3.789-.976,5.479,0l20.269,11.702c1.69.976,2.74,2.794,2.74,4.745v2.25c0,.912-.739,1.652-1.652,1.652Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M76.682,113.312c-.947,0-1.895-.244-2.74-.732l-20.269-11.702c-1.69-.976-2.74-2.794-2.74-4.745v-2.25c0-.912.739-1.652,1.652-1.652s1.652.74,1.652,1.652v2.25c0,.775.417,1.497,1.088,1.884l20.269,11.702c.671.387,1.505.387,2.176,0l20.269-11.702c.671-.387,1.088-1.109,1.088-1.884v-2.25c0-.912.739-1.652,1.652-1.652s1.652.74,1.652,1.652v2.25c0,1.951-1.05,3.769-2.739,4.745l-20.269,11.702c-.845.488-1.792.732-2.74.732Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("g", null, $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M113.308,85.205c.124,1.643,1.643,2.821,3.938,2.821,2.016,0,3.411-.806,3.411-2.108,0-1.674-1.426-1.829-3.845-2.14-3.566-.434-6.418-1.178-6.418-4.465,0-3.007,2.698-4.992,6.449-4.961,3.876.031,6.604,1.83,6.821,5.085h-3.255c-.155-1.426-1.55-2.48-3.503-2.48s-3.256.807-3.256,2.078c0,1.488,1.52,1.612,3.783,1.891,3.566.403,6.511,1.209,6.511,4.744,0,3.039-2.853,4.961-6.666,4.961-4.217,0-7.101-1.984-7.193-5.426h3.225Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M142.822,82.507c0,4.899-3.162,8.124-7.503,8.124-2.45,0-4.155-.992-5.147-2.418v8.434h-3.349v-22.076h2.915l.403,2.356c1.054-1.395,2.698-2.542,5.178-2.542,4.341,0,7.503,3.039,7.503,8.124ZM139.412,82.507c0-3.131-1.86-5.271-4.651-5.271s-4.62,2.14-4.62,5.209c0,3.163,1.83,5.364,4.62,5.364s4.651-2.202,4.651-5.302Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M149.268,70.229c0,1.178-.899,2.015-2.047,2.015s-2.046-.837-2.046-2.015c0-1.147.899-2.015,2.046-2.015s2.047.868,2.047,2.015ZM148.896,74.57v15.875h-3.349v-15.875h3.349Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M155.752,70.229v12.092l7.256-7.751h3.875l-5.922,6.387,6.294,9.488h-3.969l-4.712-7.039-2.822,2.977v4.062h-3.349v-20.216h3.349Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M175.286,74.384c4.589,0,7.752,2.915,7.845,7.565,0,.403-.031.837-.093,1.271h-11.969v.186c.155,2.729,1.799,4.496,4.434,4.496,2.047,0,3.535-1.023,4-2.791h3.349c-.558,3.131-3.193,5.519-7.101,5.519-5.022,0-8.186-3.225-8.186-8.093,0-4.93,3.132-8.154,7.721-8.154ZM179.719,80.771c-.278-2.356-1.984-3.69-4.31-3.69-2.14,0-3.969,1.427-4.217,3.69h8.526Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M187.331,74.57l4.372,12.278,4.31-12.278h3.535l-5.86,15.875h-4.093l-5.859-15.875h3.596Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M216.014,87.53v2.915h-1.768c-2.17,0-2.914-.961-2.914-2.542-1.055,1.612-2.666,2.729-5.24,2.729-3.473,0-5.891-1.705-5.891-4.651,0-3.255,2.356-5.085,6.79-5.085h4v-.961c0-1.767-1.333-2.853-3.504-2.853-1.953,0-3.286.931-3.534,2.326h-3.287c.341-3.194,2.977-5.023,6.977-5.023,4.217,0,6.666,2.016,6.666,5.767v6.263c0,.806.403,1.116,1.055,1.116h.65ZM210.992,83.375h-4.155c-2.046,0-3.225.775-3.225,2.387,0,1.333,1.116,2.264,2.945,2.264,2.791,0,4.403-1.644,4.435-4.093v-.558Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M218.178,74.57h3.906l3.814,5.364,3.875-5.364h3.659l-5.644,7.751,5.984,8.124h-3.906l-4.187-5.767-4.217,5.767h-3.628l5.953-8.124-5.611-7.751Z",
        fill: "#005e83"
    })), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M100.806,87.336c-.086,0-.171-.018-.256-.046-.119-.049-.243-.111-.374-.208-1.176-.869-2.578-2.879-3.205-4.354-1.307-3.072-2.787-6.553-6.311-6.553s-5.005,3.482-6.311,6.553c-.878,2.065-1.971,4.634-3.206,4.634s-2.327-2.569-3.205-4.634c-1.307-3.072-2.787-6.553-6.311-6.553s-5.004,3.482-6.311,6.553c-.878,2.064-1.971,4.634-3.205,4.634s-2.327-2.569-3.205-4.634c-1.307-3.072-2.737-6.553-6.311-6.553-.967,0-1.662.668-1.662,1.492s.7,1.492,1.662,1.492c1.18,0,2.327,2.569,3.205,4.634,1.307,3.072,2.787,6.553,6.311,6.553s5.004-3.482,6.311-6.553c.878-2.064,1.971-4.634,3.205-4.634s2.327,2.569,3.205,4.634c1.307,3.072,2.787,6.553,6.311,6.553s5.005-3.482,6.312-6.553c.878-2.064,1.971-4.634,3.205-4.634s2.328,2.569,3.206,4.634c1.307,3.071,3.417,6.527,6.941,6.527.967,0,1.662-.668,1.662-1.492s-.7-1.492-1.662-1.492Z",
        fill: "#e31837"
    })), $eea8153974863b86$var$react_1.default.createElement("g", null, $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M235.445,74.537h1.175l1.157,3.066,1.122-3.066h1.151v4.176h-.854v-2.798l-1.086,2.798h-.728l-1.086-2.798v2.798h-.853v-4.176Z",
        fill: "#005e83"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M240.773,78.713v-4.176h1.521c1.301,0,2.166.853,2.166,2.082s-.865,2.094-2.166,2.094h-1.521ZM241.668,77.967h.626c.8,0,1.247-.555,1.247-1.349,0-.799-.447-1.336-1.247-1.336h-.626v2.685Z",
        fill: "#005e83"
    })), $eea8153974863b86$var$react_1.default.createElement("g", null, $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M119.704,118.86c-.171,3.096-1.596,4.825-4.027,4.825-2.773,0-4.332-2.147-4.332-7.011s1.558-7.01,4.332-7.01c2.754,0,3.895,1.957,3.895,4.18h-1.216c0-1.843-.931-3.153-2.679-3.153-1.938,0-3.116,1.596-3.116,5.983s1.178,5.984,3.116,5.984c1.709,0,2.679-1.463,2.812-3.799h1.216Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M125.157,109.665c2.773,0,4.332,2.146,4.332,7.01s-1.558,7.011-4.332,7.011-4.332-2.147-4.332-7.011,1.558-7.01,4.332-7.01ZM125.157,122.659c1.938,0,3.116-1.596,3.116-5.984s-1.178-5.983-3.116-5.983-3.116,1.596-3.116,5.983,1.178,5.984,3.116,5.984Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M129.737,109.894h1.292l3.021,12.271h.038l3.021-12.271h1.292l-3.571,13.563h-1.52l-3.571-13.563Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M139.312,109.894h1.216v13.563h-1.216v-13.563Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M142.598,109.894h3.268c3.951,0,4.92,2.355,4.92,6.781s-.969,6.782-4.92,6.782h-3.268v-13.563ZM143.813,122.432h1.976c2.66,0,3.78-1.33,3.78-5.737,0-4.445-1.121-5.775-3.78-5.775h-1.976v11.513Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M156.765,117.549v1.026h-4.122v-1.026h4.122Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M159.577,113.161h-3.077v-.836c2.26-.02,3.267-.912,3.343-2.318h.874v13.45h-1.14v-10.296Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M165.315,120.531c.058,1.312.798,2.204,2.128,2.204,1.861,0,2.773-1.672,2.83-6.117l-.037-.038c-.438,1.387-1.463,2.204-2.889,2.204-2.336,0-3.533-1.71-3.533-4.18,0-2.546,1.159-4.598,3.742-4.598,3.04,0,3.934,2.242,3.934,6.479,0,4.407-.875,7.2-4.104,7.2-2.129,0-3.249-1.312-3.287-3.154h1.216ZM167.538,117.834c1.843,0,2.508-1.71,2.508-3.438s-.665-3.438-2.508-3.438c-1.862,0-2.508,1.71-2.508,3.438s.646,3.438,2.508,3.438Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M180.381,109.894h1.521l4.009,13.563h-1.293l-1.102-3.951h-4.749l-1.102,3.951h-1.292l4.008-13.563ZM183.25,118.48l-2.09-7.638h-.037l-2.09,7.638h4.217Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M187.057,109.894h4.047c2.261,0,3.514,1.292,3.514,3.4,0,1.634-.645,3.097-2.449,3.438v.038c1.689.151,2.26,1.12,2.316,3.21l.039,1.482c.019.74.094,1.463.569,1.994h-1.425c-.285-.475-.342-1.178-.361-1.899l-.037-1.14c-.076-2.394-.514-3.153-2.698-3.153h-2.298v6.192h-1.217v-13.563ZM188.273,116.238h2.089c1.919,0,3.04-.874,3.04-2.659,0-1.653-.703-2.66-2.906-2.66h-2.223v5.319Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M196.484,109.894h1.635l5.186,11.816h.038v-11.816h1.216v13.563h-1.634l-5.187-11.816h-.037v11.816h-1.217v-13.563Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M206.461,113.37h1.025v1.405h.039c.531-1.121,1.443-1.634,2.564-1.634,1.215,0,1.957.741,2.108,1.767h.038c.455-1.12,1.272-1.767,2.564-1.767,1.406,0,2.337.798,2.337,2.603v7.713h-1.14v-7.542c0-1.196-.551-1.823-1.577-1.823-1.14,0-2.052,1.025-2.052,2.583v6.782h-1.14v-7.542c0-1.196-.552-1.823-1.577-1.823-1.14,0-2.051,1.025-2.051,2.583v6.782h-1.141v-10.087Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M222.439,113.37h1.217l2.241,8.795h.038l2.052-8.795h1.216l-2.66,10.087h-1.291l-2.812-10.087Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M229.703,116.371c0-2.07.988-3.229,3.115-3.229,2.09,0,2.85,1.083,2.85,2.679v5.965c0,.57.19.836.59.836h.322v.836c-.209.076-.379.114-.531.114-.893,0-1.463-.209-1.463-1.254v-.342h-.038c-.456,1.33-1.481,1.71-2.603,1.71-1.768,0-2.564-1.103-2.564-2.85,0-1.33.607-2.394,2.032-2.793l2.147-.607c.797-.229.969-.418.969-1.596,0-1.292-.723-1.748-1.748-1.748-1.35,0-1.938.816-1.938,2.279h-1.141ZM234.529,117.758h-.039c-.113.342-.76.551-1.215.665l-.95.247c-1.14.304-1.729.893-1.729,2.09,0,1.178.608,1.976,1.596,1.976,1.387,0,2.338-1.045,2.338-2.85v-2.128Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M243.527,120.114c-.172,2.146-1.35,3.571-3.211,3.571-2.128,0-3.382-1.482-3.382-5.281,0-3.496,1.254-5.263,3.477-5.263,1.899,0,3.001,1.159,3.116,3.229h-1.141c-.133-1.576-.76-2.279-1.976-2.279-1.235,0-2.261.76-2.261,4.331,0,3.8,1.083,4.312,2.146,4.312,1.159,0,1.9-.854,2.09-2.621h1.141Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M250.896,120.114c-.171,2.146-1.349,3.571-3.21,3.571-2.128,0-3.382-1.482-3.382-5.281,0-3.496,1.254-5.263,3.477-5.263,1.9,0,3.002,1.159,3.115,3.229h-1.14c-.133-1.576-.76-2.279-1.976-2.279-1.234,0-2.261.76-2.261,4.331,0,3.8,1.083,4.312,2.147,4.312,1.158,0,1.898-.854,2.089-2.621h1.14Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M252.099,109.894h1.14v1.938h-1.14v-1.938ZM252.099,113.37h1.14v10.087h-1.14v-10.087Z",
        fill: "#58595b"
    }), $eea8153974863b86$var$react_1.default.createElement("path", {
        d: "M254.904,113.37h1.026v1.405h.038c.569-1.121,1.558-1.634,2.584-1.634,1.538,0,2.583.798,2.583,2.698v7.617h-1.14v-7.295c0-1.387-.57-2.07-1.729-2.07-1.33,0-2.223,1.025-2.223,2.583v6.782h-1.141v-10.087Z",
        fill: "#58595b"
    })));
};
module.exports.SpikevaxRegisteredFrench = $eea8153974863b86$var$SpikevaxRegisteredFrench;

});

parcelRegister("86T7q", function(module, exports) {
"use strict";
var $5e79a3b796c2a527$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxKr = void 0;

const $5e79a3b796c2a527$var$react_1 = $5e79a3b796c2a527$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $5e79a3b796c2a527$var$SpikevaxKr = ({ sx: sx })=>{
    return $5e79a3b796c2a527$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        "aria-label": "\uC2A4\uD30C\uC774\uD06C\uBC15\uC2A4\u00AE \uC0AC\uC2A4\uCF54\uB85C\uB098\uBC14\uC774\uB7EC\uC2A4-2 mRNA \uBC31\uC2E0",
        viewBox: "0 0 550 140",
        sx: sx
    }, $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#015b7e",
        d: "M0 46.98v-9.05q1.67-5.7 6.22-8.21Q30.63 16.25 55.01 2.78q4.2-2.32 8.69-1.51 2.39.44 7.71 3.37Q94.1 17.15 116.8 29.67q4.86 2.68 6.25 8.58.37 1.57 0 7.71-.17 2.84-3.34 3.43-.27.05-.97-.07-3.25-.58-3.4-3.88c-.16-3.66 1.24-7.17-3.41-9.73Q69.04 12.07 64.6 9.63q-3.01-1.65-5.53-.28Q42.42 18.4 9.96 36.44c-3.04 1.69-2.23 6.71-2.27 9.53a3.29 3.28 74.8 01-1.57 2.75Q2.46 50.96 0 46.98zM264 62.88L263.99 91a.38.38 0 01-.38.38l-8.48-.01a.38.38 0 01-.38-.38V34.13a.38.38 0 01.38-.38h8.49a.38.38 0 01.38.38L263.99 54a.38.38 0 00.38.38h8.99a.38.38 0 01.38.38l.02 7.36a.38.38 0 01-.38.38h-9a.38.38 0 00-.38.38z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "9.38",
        height: "57.76",
        x: "324",
        y: "33.74",
        fill: "#015b7e",
        rx: "0.35"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#015b7e",
        d: "M425.27 42.87q5.63.01 7.18-.06.52-.02.52-.54v-8.26a.25.25 0 01.25-.25h8.54a.25.25 0 01.25.25v30.52q0 .58-.58.58-2.78.03-16.18.02-13.4-.02-16.18-.04-.58-.01-.58-.59l.05-30.52a.25.25 0 01.25-.25l8.54.02a.25.25 0 01.25.25l-.01 8.26q0 .52.52.54 1.55.07 7.18.07zm7.73 7.64a.38.38 0 00-.38-.38H418a.38.38 0 00-.38.38v6.98a.38.38 0 00.38.38h14.62a.38.38 0 00.38-.38v-6.98zM460.12 53.47l.01 14.18a.35.35 0 01-.35.35h-8.69a.35.35 0 01-.35-.35l.01-33.55a.35.35 0 01.35-.35h8.68a.35.35 0 01.35.35l-.01 10.68a.35.35 0 00.35.35h8.91a.35.35 0 01.35.35l.04 7.31a.35.35 0 01-.35.35l-8.95-.02a.35.35 0 00-.35.35zM548.159 42.207a7.54 7.35-5.2 01-6.843 8.003 7.54 7.35-5.2 01-8.175-6.637 7.54 7.35-5.2 016.843-8.003 7.54 7.35-5.2 018.175 6.637zm-6.84 6.79a6.12 5.88 84.1 005.22-6.691 6.12 5.88 84.1 00-6.478-5.484 6.12 5.88 84.1 00-5.22 6.692 6.12 5.88 84.1 006.478 5.484zM174.81 36.13q3.8 0 4.1.05.49.08.53.58c.23 2.77-.3 7.25.33 9.99q.92 4 5.02 7.48 6.91 5.85 15.26 7.1.32.05.32.38v8.3a.28.27 4.5 01-.32.27c-8.94-1.35-19.7-6.29-24.97-14.23q-.11-.16-.27-.16-.16 0-.27.16c-5.27 7.94-16.03 12.88-24.97 14.23a.28.27-4.5 01-.32-.27v-8.3q0-.33.32-.38 8.35-1.25 15.26-7.1 4.1-3.48 5.02-7.48c.63-2.74.1-7.22.33-9.99q.04-.5.53-.58.29-.05 4.1-.05zM502.57 36.13q3.69-.01 4.1.06.48.08.53.57c.26 2.97-.58 8.61.9 11.74 3.3 7 12.47 11.65 19.58 12.84a.55.55 0 01.45.54v8q0 .45-.44.38-10.56-1.72-19.14-8.15-3.43-2.58-5.7-6.03-.12-.18-.27-.18-.16 0-.28.18-2.27 3.45-5.69 6.04-8.58 6.43-19.13 8.16-.44.07-.45-.38v-8a.55.55 0 01.45-.54c7.11-1.19 16.27-5.85 19.56-12.85 1.48-3.14.64-8.78.89-11.75q.05-.49.54-.57.41-.06 4.1-.06zM316.28 64.418a16.49 16.49 0 01-16.433 16.547l-2.72.01a16.49 16.49 0 01-16.548-16.433l-.038-10.98a16.49 16.49 0 0116.432-16.547l2.72-.01a16.49 16.49 0 0116.548 16.433l.038 10.98zm-9.26-11.203a8.06 8.06 0 00-8.046-8.074l-1.08-.002a8.06 8.06 0 00-8.074 8.046l-.02 11.6a8.06 8.06 0 008.046 8.074l1.08.002A8.06 8.06 0 00307 64.815l.02-11.6zM384.58 45.25h-34.34q-.23 0-.23-.23v-7.39q0-.38.37-.38h43.57q.48 0 .49.48.28 14.32-.24 22.76-.47 7.76-3.06 15.39a.36.35 9 01-.34.24h-9.19q-.31 0-.19-.28 2.28-5.77 2.89-11.64.06-.58-.52-.58h-34.33a.59.59 0 01-.59-.59v-6.72q0-.56.57-.56h35.32a.38.37-90 00.37-.38v-9.56q0-.56-.55-.56z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "37.62",
        height: "8",
        x: "211.26",
        y: "38.25",
        fill: "#015b7e",
        rx: "0.37"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#015b7e",
        d: "M542.27 44.08l1.52 2.63q.18.3-.17.36l-.66.11q-.15.03-.25-.1l-1.62-2.29q-1.97-2.77-1.97.63v1.22a.51.51 0 01-.51.51h-.3q-.58 0-.58-.58v-6.88q0-.58.58-.62c2.58-.2 6.89-.54 5.6 3.42q-.22.7-1.31.88-.67.12-.33.71zm-3.19-3.44l.06 1.46a.44.44 0 00.46.42l1.45-.07a1.65 1.07-2.5 001.6-1.14l-.01-.2a1.65 1.07-2.5 00-1.69-.99l-1.45.06a.44.44 0 00-.42.46zM233.87 71.19V50a.38.38 0 01.38-.38h7.69q.31 0 .31.31v20.06a.64.63 85.1 00.74.63l8.23-1.41q.28-.04.28.25v7.32q0 .34-.33.4-10.02 2-18.17 2.35-9.3.39-22.41.18-.22 0-.22-.22v-7.53q0-.21.21-.21h6.67q.5 0 .5-.49V49.93q0-.31.3-.31h7.77q.3 0 .3.3v21.51q0 .26.27.26h6.98q.5 0 .5-.5z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#d52036",
        d: "M0 58.55v-2.93q5-4.2 11.67 1.22 2.28 1.85 4.67 6.82 5.05 10.52 5.13 10.68 1.42 2.96 3.66 4.69a2.31 2.31 0 002.97-.11q2.6-2.36 4.16-5.9 3.07-6.98 4.86-10.39c1.8-3.42 5.24-7.59 9.2-8.46 6.93-1.53 11.83 2.1 14.95 8.11q.32.61 6.41 12.88 1.24 2.51 2.74 3.68c2.78 2.19 5.62-2.01 6.69-4.23q1.26-2.59 5.36-11.36c1.26-2.69 4.06-6.54 6.96-8.04q6.4-3.31 12.85 1.01 1.59 1.07 4.2 5.03.76 1.14 2.86 5.86 2.76 6.19 6.85 10.33 1.78 1.8 4.7 2.27c1.8.3 2.97 2.65 2.15 4.33q-1.05 2.14-3.35 2.14c-7.27.03-11.78-5.03-15.03-10.95q-.42-.77-4.56-9.47-1.32-2.77-3.49-4.57a2.54 2.54 0 00-3.15-.09q-1.61 1.21-2.86 3.49-1.82 3.32-5.73 12.03-.84 1.87-3.18 4.79-2.07 2.58-4.3 3.64-7 3.3-13.36-2.01-1.84-1.53-4.46-6.57-1.08-2.09-4.45-9.58-1.45-3.24-3.77-5.52a2.68 2.68 0 00-3.66-.09q-2.39 2.13-3.84 5.33-3.14 6.93-4.68 10.04c-2.06 4.16-5.53 8.6-10.32 9.38-8.09 1.33-12.64-4.3-15.58-10.8q-3.25-7.2-4.51-9.65-1.39-2.71-3.68-4.57a1.62 1.59-25 00-.96-.34Q1.54 60.66 0 58.55z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#015b7e",
        d: "M450.38 78.62l-33.01.01a.36.36 0 01-.36-.36l-.02-7.04a.36.36 0 01.36-.36h42.41a.36.36 0 01.36.36l.01 19.91a.36.36 0 01-.36.36h-8.66a.36.36 0 01-.36-.36l-.01-12.16a.36.36 0 00-.36-.36z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "61.12",
        height: "8.12",
        x: "144.24",
        y: "79.63",
        fill: "#015b7e",
        rx: "0.38"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "61.12",
        height: "8.12",
        x: "341.86",
        y: "79.63",
        fill: "#015b7e",
        rx: "0.33"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "61.12",
        height: "8.12",
        x: "472.01",
        y: "79.63",
        fill: "#015b7e",
        rx: "0.37"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#015b7e",
        d: "M0 102.18v-9.11c2.43-3.89 7.68-2.95 7.74 1.87.06 4.77-.69 7.13 3.22 9.28q24.19 13.36 48.03 26.5a5.24 5.23 45.1 005.06.01q28.43-15.66 49.24-27.16c1.3-.71 1.94-2.64 1.96-4.29q.05-3.72.12-4.93.19-3.29 3.48-3.52l.47-.03a3.53 3.53 0 013.76 3.26q.31 4.24-.08 7.47-.41 3.39-2.89 6.18-1.47 1.65-5.39 3.82-23.25 12.84-46.52 25.65-4.37 2.41-8.95 1.56-2.38-.44-7.93-3.5-22.9-12.63-45.79-25.27-3.83-2.12-5.53-7.79z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#57595b",
        d: "M164.38 123.71l-.01 13.59a.45.45 0 01-.44.45l-1.6.06a.45.45 0 01-.46-.45l.01-25.53a.45.45 0 01.45-.45l1.61-.01a.45.45 0 01.45.45l-.02 8.87a.45.45 0 00.45.45l2.94-.03a.45.45 0 01.46.45l.02 1.24a.45.45 0 01-.45.46h-2.96a.45.45 0 00-.45.45zM262.06 121.15l2.98-.02a.45.45 0 01.45.45l.02 1.21a.45.45 0 01-.45.45l-2.99.03a.45.45 0 00-.45.45v13.51a.45.45 0 01-.41.45l-1.59.14a.45.45 0 01-.49-.44l-.01-25.59a.45.45 0 01.47-.45l1.61.06a.45.45 0 01.43.45l-.02 8.85a.45.45 0 00.45.45zM286.29 121.32l3.09-.05a.42.42 0 01.43.46l-.11 1.13a.42.42 0 01-.41.38l-3 .01a.42.42 0 00-.42.42v13.57a.42.42 0 01-.43.42l-1.66-.06a.42.42 0 01-.41-.42l.01-25.36a.42.42 0 01.41-.42l1.66-.06a.42.42 0 01.43.42l-.02 9.14a.42.42 0 00.43.42z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "2.52",
        height: "26.4",
        x: "308.74",
        y: "111.36",
        fill: "#57595b",
        rx: "0.49"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#57595b",
        d: "M318.7 130.57l10.02-.76a.31.31 0 01.34.3l.07 1.52a.31.31 0 01-.29.33l-12.63.72a.31.31 0 01-.33-.31l-.01-10.56a.31.31 0 01.31-.31l8.14-.03a.31.31 0 00.31-.31l.01-5.86a.31.31 0 00-.31-.31h-8.29a.31.31 0 01-.31-.31l.01-1.5a.31.31 0 01.31-.31l10.75.01a.31.31 0 01.31.31l.02 6.99a.31.31 0 00.31.31l5.24.02a.31.31 0 00.31-.31l.04-8.53a.31.31 0 01.31-.3l1.99.03a.31.31 0 01.3.31l-.01 25.66a.31.31 0 01-.29.31l-1.98.12a.31.31 0 01-.33-.31l-.03-14.69a.31.31 0 00-.31-.31h-5.14a.31.31 0 00-.3.22l-.22.7a.31.31 0 01-.3.22l-8.04-.02a.31.31 0 00-.31.31v6.35a.31.31 0 00.33.3zM504.75 119.74q-.62 0-1.16.04-.59.04-.59.63v5.85a.52.52 0 01-.52.52h-1.46a.52.52 0 01-.52-.52v-14.3q0-.46.46-.46h1.51q.52 0 .52.52v5.04q0 .57.56.64.27.03 1.2.03.92 0 1.2-.04.56-.07.56-.64l-.02-5.04q0-.52.52-.52h1.51q.46 0 .46.46l.05 14.3a.52.52 0 01-.52.52h-1.46a.52.52 0 01-.52-.52l-.02-5.85q0-.59-.59-.63-.54-.03-1.17-.03z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "2.62",
        height: "19.5",
        x: "530",
        y: "111.39",
        fill: "#57595b",
        rx: "0.45"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#57595b",
        d: "M152.03 112.36q.57-.01.77.04.52.12.52.66-.01 1.98.05 5.34c.08 5.32 2.07 9.53 6.69 12.32q.2.12.08.31l-1.01 1.57q-.18.28-.46.1-4.42-2.73-6.3-7.35-.03-.07-.08-.08-.02-.01-.05-.01-.02 0-.05.01-.05.01-.08.08-1.73 4.68-6.06 7.55-.27.19-.46-.08l-1.06-1.54q-.12-.18.07-.31c4.53-2.94 6.38-7.21 6.29-12.53q-.05-3.36-.12-5.34-.02-.54.49-.67.21-.06.77-.07zM492.81 117q1.85 0 2.12-.04.45-.06.45-.52v-3.7q0-.41.41-.43l1.49-.11a.56.56 0 01.6.56v12.19q0 .51-.51.54-.5.03-4.57.02-4.06 0-4.56-.03-.51-.03-.51-.54l.02-12.19a.56.56 0 01.6-.56l1.49.12q.41.02.41.43l-.01 3.7q0 .46.45.52.27.04 2.12.04zm2.573 2.344a.34.34 0 00-.34-.34l-4.46-.008a.34.34 0 00-.34.34l-.006 3.8a.34.34 0 00.34.34l4.46.008a.34.34 0 00.34-.34l.006-3.8zM519.4 121.09q-1.73 3.75-5.9 5.89-.41.22-.64-.18l-.56-.98q-.33-.56.25-.84c4.91-2.37 6.14-6.65 5.8-12.01q-.04-.64.59-.68l1.49-.1q.54-.04.55.51c.04 2.1-.19 4.14.33 5.69q1.5 4.47 5.69 6.19.51.21.31.6l-.58 1.17q-.23.48-.64.29-4.37-2-6.04-5.55-.32-.7-.65 0zM245.9 130.21l10.88-.75q.55-.03.75.47.08.18.09.34a1.15.9 84.7 01-.8 1.24l-13.7.93q-.5.04-.5-.46v-18.77a.6.59 0 01.6-.59h1.35q.56 0 .56.56v16.31q0 .77.77.72zM272.98 120.26q2.41 0 3.15-.06.54-.04.54-.58v-6.57q0-.57.57-.57h1.49q.51 0 .51.51v18.7q0 .46-.46.48-1.65.07-5.77.08-4.13.01-5.77-.05-.46-.02-.47-.48l-.07-18.7q-.01-.51.5-.52h1.49q.57 0 .58.57l.02 6.57q.01.54.55.57.74.06 3.14.05zm3.634 2.524a.41.41 0 00-.41-.41l-6.56.012a.41.41 0 00-.41.41l.012 7.06a.41.41 0 00.41.41l6.56-.012a.41.41 0 00.41-.41l-.012-7.06zM304.584 126.727a6.11 6.11 0 01-6.089 6.131l-.88.004a6.11 6.11 0 01-6.131-6.09l-.028-8a6.11 6.11 0 016.089-6.13l.88-.004a6.11 6.11 0 016.131 6.09l.028 8zm-2.552-8.146a3.8 3.8 0 00-3.78-3.82l-.48-.002a3.8 3.8 0 00-3.82 3.78l-.044 8.34a3.8 3.8 0 003.78 3.82l.48.002a3.8 3.8 0 003.82-3.78l.044-8.34zM180.46 112.76q.19 0 .89.17.52.13.47.66-.37 4.35 1.11 6.62 2.24 3.41 7.44 4.96.4.12.34.52l-.16 1.15q-.08.64-.71.47-5.83-1.61-9.27-6.63-.03-.04-.09-.04-.07 0-.1.04-3.42 5.03-9.24 6.66-.63.18-.72-.46l-.16-1.15q-.06-.4.34-.52 5.19-1.57 7.42-4.99 1.47-2.28 1.09-6.63-.05-.52.46-.66.71-.17.89-.17zM235.16 118.99l-.05-3.73a.39.39 0 00-.39-.38l-14.53-.01a.39.39 0 01-.39-.44l.16-1.34a.39.39 0 01.39-.34l16.89-.01a.39.39 0 01.39.39l-.01 7.86a.39.39 0 01-.39.39l-14.33-.01a.39.39 0 00-.39.39l-.04 3.84a.39.39 0 00.39.39l15.16.02a.39.39 0 01.39.41l-.05 1.34a.39.39 0 01-.39.37l-7.36-.02a.39.39 0 00-.4.4l.06 4.48a.39.39 0 00.39.39l9.15-.01a.39.39 0 01.39.36l.09 1.35a.39.39 0 01-.39.42h-21.77a.39.39 0 01-.39-.38l-.05-1.35a.39.39 0 01.39-.4l9.3.01a.39.39 0 00.39-.39l-.03-4.48a.39.39 0 00-.39-.39l-6.96.01a.39.39 0 01-.39-.39l.01-7.98a.39.39 0 01.39-.39l14.37.02a.39.39 0 00.39-.4zM350.54 112.75q.75 0 .85.03.53.12.48.65-.96 9.3 8.88 11.74.21.05.18.26-.16.94-.57 1.68-.12.21-.35.15-6.18-1.59-9.22-6.64-.04-.07-.09-.09-.07-.04-.14-.04t-.14.04q-.05.02-.09.09-3.02 5.06-9.19 6.68-.23.06-.35-.14-.41-.74-.58-1.68-.03-.21.18-.26 9.83-2.49 8.83-11.78-.05-.53.47-.66.1-.03.85-.03zM380.09 131.84a.51.51 0 00.51.53h9.41a.36.36 0 01.36.36v1.52q0 .38-.38.38h-12.02q-.53 0-.61-.53-.74-4.89 3.04-7.46 4.56-3.1 5.02-3.44 2.86-2.14 1.97-5.61-.42-1.68-2.5-2.17-4.19-.97-5.09 3.67-.04.21-.26.21h-2.25q-.34 0-.3-.34.78-6.17 7-6.09c3.24.04 6.24 2.03 6.28 5.56q.04 3.92-2.46 5.96-2.25 1.84-5.9 4.26-1.71 1.13-1.82 3.19zM210.83 120.49q.3 0 .3-.31v-4.81a.37.36-90 00-.36-.37h-14.28q-.5 0-.5-.51v-.99q0-.5.5-.5h16.54a.58.57-.5 01.58.56q.25 8.36-.98 15.36-.09.5-.6.5h-1.33a.48.48 0 01-.48-.55l.78-5.65q.08-.6-.52-.6h-14.53q-.47 0-.47-.46V121q0-.51.52-.51h14.83zM428.86 125.86v8.32q0 .45-.44.45h-1.82q-.47 0-.47-.47v-20.17q0-.55.54-.58 6.29-.37 8.42.02 6.29 1.14 5.01 7.61-.46 2.35-3.76 3.81-.57.25-.26.79l5.03 8.71a.19.19 0 01-.17.29h-2.31a.64.62-14.5 01-.55-.31l-4.95-8.58q-.23-.4-.7-.4h-3.05q-.52 0-.52.51zm-.01-10.19l.02 7.3a.29.29 0 00.29.29l4.07-.01a4.52 3.69-.1 004.51-3.7v-.5a4.52 3.69-.1 00-4.53-3.68l-4.07.01a.29.29 0 00-.29.29zM450.69 124.53q-1.73-3.02-3.24-5.83-.51-.96-.51.13v15.27q0 .56-.56.56h-1.54q-.52 0-.52-.52v-20.27q0-.61.6-.61h1.52q.57 0 .84.5 2.97 5.42 5.39 9.64 1.74 3.02 3.25 5.83.51.96.51-.13v-15.27q0-.56.56-.56h1.54q.52 0 .52.52v20.27q0 .61-.6.61h-1.52q-.57 0-.84-.5-2.97-5.42-5.4-9.64zM469.99 113.22q.34 0 .85.1.58.1.76.66l6.92 20.24q.14.41-.29.41h-1.91q-.46 0-.61-.43l-1.75-5.13q-.15-.44-.61-.49-.79-.08-3.38-.08-2.6 0-3.38.07-.47.05-.62.49l-1.76 5.12q-.15.43-.61.43h-1.91q-.43 0-.29-.41l6.97-20.22q.18-.56.77-.67.5-.09.85-.09zm-3.01 12.64a.31.31 0 00.29.41l5.48-.02a.31.31 0 00.29-.41l-2.76-8.24a.31.31 0 00-.59.01l-2.71 8.25zM404.96 120.26q1.11-1.04 2.16-1.36 3.53-1.11 5.13 1.65.25.45.62.08 3.2-3.15 7.06-1.37.87.39 1.36 1.24.72 1.21.76 1.77.21 2.8.05 11.95-.01.4-.41.4h-1.68q-.34 0-.34-.34l-.12-10.48q-.04-2.99-3.1-2.88-.03 0-.27.02-2.9.29-2.91 3.26l-.01 10q0 .43-.43.43h-1.44q-.58 0-.59-.57l-.15-10.62q-.05-2.93-3.05-2.55-.09.01-.32.06-2.81.61-2.84 3.62l-.09 9.59a.47.47 0 01-.47.47h-1.58q-.56 0-.56-.55V119.5q0-.49.5-.49h1.51a.7.69-6.2 01.68.54q.08.37.04.54-.18.78.49.17z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "9.38",
        height: "2.02",
        x: "-4.69",
        y: "-1.01",
        fill: "#57595b",
        rx: "0.45",
        transform: "rotate(-.1 71661.052 -211456.4)"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("path", {
        fill: "#57595b",
        d: "M202 133.03l.02-7.43a.37.37 0 01.38-.37l1.89.04a.37.37 0 01.36.37l-.04 7.37a.37.37 0 00.37.37l10.64-.01a.37.37 0 01.37.39l-.06 1.26a.37.37 0 01-.37.35l-21.82.01a.37.37 0 01-.37-.38l.01-1.26a.37.37 0 01.38-.37l7.87.03a.37.37 0 00.37-.37zM518.54 135.27l14.25-.01a.43.43 0 01.42.5l-.17 1.14a.43.43 0 01-.43.36l-16.68-.01a.43.43 0 01-.43-.43l-.01-8.25a.43.43 0 01.43-.43l1.78-.02a.43.43 0 01.44.44l-.03 6.28a.43.43 0 00.43.43zM506 130.37l-15.08.01a.39.39 0 01-.39-.37l-.08-1.33a.39.39 0 01.39-.41l17.77-.02a.39.39 0 01.39.39v8.99a.39.39 0 01-.4.39l-1.87-.07a.39.39 0 01-.38-.39l.04-6.8a.39.39 0 00-.39-.39z"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "22.66",
        height: "2",
        x: "169.1",
        y: "133.38",
        fill: "#57595b",
        rx: "0.45"
    }), $5e79a3b796c2a527$var$react_1.default.createElement("rect", {
        width: "22.54",
        height: "2",
        x: "339.24",
        y: "133.38",
        fill: "#57595b",
        rx: "0.48"
    }));
};
module.exports.SpikevaxKr = $5e79a3b796c2a527$var$SpikevaxKr;
module.exports.default = module.exports.SpikevaxKr;

});

parcelRegister("8BGGv", function(module, exports) {
"use strict";
var $6442e3b392b88748$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpikevaxNavbar = void 0;

const $6442e3b392b88748$var$react_1 = $6442e3b392b88748$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $6442e3b392b88748$var$SpikevaxNavbar = ({ sx: sx = {} })=>{
    return $6442e3b392b88748$var$react_1.default.createElement($2wkl1.Box, {
        as: "svg",
        sx: Object.assign({}, sx),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 111 32",
        "aria-label": "Spikevax Logo"
    }, $6442e3b392b88748$var$react_1.default.createElement("path", {
        fill: "#005E83",
        d: "M33.42 17.38c.072.95.95 1.632 2.279 1.632 1.166 0 1.973-.466 1.973-1.22 0-.968-.825-1.058-2.225-1.238-2.063-.25-3.714-.68-3.714-2.583 0-1.74 1.561-2.888 3.732-2.87 2.243.018 3.821 1.058 3.947 2.941h-1.884c-.09-.824-.897-1.434-2.027-1.434s-1.884.466-1.884 1.202c0 .86.88.933 2.19 1.094 2.062.233 3.767.7 3.767 2.745 0 1.758-1.651 2.87-3.857 2.87-2.44 0-4.11-1.148-4.163-3.14zm15.104-1.561c0-1.812-1.077-3.05-2.692-3.05-1.614 0-2.673 1.238-2.673 3.014 0 1.83 1.059 3.104 2.673 3.104s2.692-1.274 2.692-3.068m1.973 0c0 2.834-1.83 4.7-4.342 4.7-1.417 0-2.404-.574-2.978-1.4V24h-1.938V11.228h1.687l.233 1.363c.61-.807 1.56-1.472 2.996-1.472 2.512 0 4.342 1.759 4.342 4.7m3.515 4.593h-1.937v-9.186h1.937zm.215-11.697c0 .682-.52 1.166-1.184 1.166-.665 0-1.183-.484-1.183-1.166 0-.664.518-1.166 1.183-1.166.663 0 1.184.502 1.184 1.166m3.752 0v6.996l4.198-4.485h2.242l-3.426 3.696 3.642 5.49h-2.297l-2.727-4.073-1.632 1.722v2.35h-1.938V8.716zm13.867 6.099c-.161-1.363-1.148-2.135-2.494-2.135-1.237 0-2.296.826-2.44 2.135zM69.28 11.12c2.656 0 4.486 1.686 4.54 4.377 0 .234-.018.484-.054.736H66.84v.107c.09 1.579 1.04 2.601 2.565 2.601 1.184 0 2.045-.591 2.314-1.614h1.938c-.323 1.812-1.848 3.193-4.109 3.193-2.905 0-4.735-1.866-4.735-4.682 0-2.853 1.812-4.718 4.467-4.718m6.97.106 2.53 7.104 2.493-7.104h2.046l-3.391 9.185H77.56l-3.39-9.185zm13.69 5.095h-2.404c-1.183 0-1.866.449-1.866 1.381 0 .772.646 1.31 1.704 1.31 1.615 0 2.549-.95 2.566-2.368zm2.906 2.404v1.687h-1.022c-1.256 0-1.686-.556-1.686-1.471-.61.933-1.543 1.578-3.032 1.578-2.01 0-3.409-.986-3.409-2.691 0-1.883 1.363-2.941 3.929-2.941h2.314v-.557c0-1.023-.77-1.65-2.027-1.65-1.13 0-1.901.538-2.045 1.345h-1.902c.198-1.848 1.722-2.907 4.037-2.907 2.44 0 3.857 1.167 3.857 3.337v3.625c0 .466.233.646.61.646zm1.252-7.499h2.26l2.208 3.104 2.242-3.104h2.117l-3.266 4.485 3.463 4.7h-2.26l-2.422-3.336L96 20.412h-2.1l3.445-4.701zm11.876-.003v.447h-.701v1.982h-.52V11.67h-.701v-.447zm.98 0 .673 1.783.652-1.784h.67v2.43h-.496v-1.628l-.632 1.628h-.423l-.631-1.628v1.628h-.497v-2.43h.684ZM13.518 31.608a2.9 2.9 0 0 1-1.438-.384L1.439 25.076A2.89 2.89 0 0 1 0 22.584v-1.182a.868.868 0 1 1 1.735 0v1.182c0 .406.218.786.571.99l10.641 6.147c.353.204.79.204 1.143 0l10.64-6.147c.353-.204.572-.584.572-.99v-1.182a.868.868 0 0 1 1.735 0v1.182c0 1.025-.551 1.98-1.439 2.492l-10.641 6.148a2.9 2.9 0 0 1-1.439.384M26.17 11.074a.87.87 0 0 1-.868-.867V9.025c0-.407-.219-.786-.571-.99L14.09 1.888a1.15 1.15 0 0 0-1.143 0L2.306 8.035a1.15 1.15 0 0 0-.572.99v1.182a.868.868 0 1 1-1.734 0V9.025C0 8 .552 7.045 1.439 6.532L12.079.385a2.88 2.88 0 0 1 2.878 0l10.641 6.147a2.89 2.89 0 0 1 1.439 2.493v1.182a.87.87 0 0 1-.867.867"
    }), $6442e3b392b88748$var$react_1.default.createElement("path", {
        fill: "#D8282F",
        d: "M26.174 17.941a.5.5 0 0 1-.134-.023 1 1 0 0 1-.197-.11c-.617-.456-1.352-1.51-1.681-2.283-.686-1.611-1.464-3.438-3.313-3.438s-2.626 1.827-3.312 3.437c-.461 1.083-1.035 2.43-1.683 2.43-.647 0-1.22-1.347-1.681-2.43-.686-1.61-1.463-3.436-3.312-3.436-1.85 0-2.627 1.826-3.313 3.437-.46 1.082-1.034 2.43-1.682 2.43s-1.22-1.348-1.682-2.43c-.685-1.611-1.436-3.438-3.311-3.438-.508 0-.873.35-.873.783 0 .432.368.782.873.782.619 0 1.22 1.348 1.681 2.43.686 1.611 1.463 3.437 3.312 3.437 1.85 0 2.627-1.825 3.313-3.437.46-1.082 1.033-2.43 1.682-2.43.647 0 1.22 1.348 1.681 2.43.686 1.611 1.463 3.437 3.312 3.437 1.85 0 2.627-1.825 3.313-3.437.46-1.082 1.034-2.43 1.682-2.43s1.222 1.348 1.683 2.43c.685 1.611 1.793 3.424 3.642 3.424.508 0 .872-.35.872-.782s-.367-.783-.872-.783"
    }));
};
module.exports.SpikevaxNavbar = $6442e3b392b88748$var$SpikevaxNavbar;

});



parcelRegister("4eCZD", function(module, exports) {
"use client";
"use strict";
var $3156b76d164bebfe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logo = void 0;

const $3156b76d164bebfe$var$react_1 = $3156b76d164bebfe$var$__importDefault((parcelRequire("acw62")));

var $7sSer = parcelRequire("7sSer");
const $3156b76d164bebfe$var$Logo = (props)=>{
    const { logo: logo, sx: sx } = props;
    const LogoSource = $7sSer.BRAND_LOGOS[logo];
    return $3156b76d164bebfe$var$react_1.default.createElement(LogoSource, {
        sx: sx
    });
};
module.exports.Logo = $3156b76d164bebfe$var$Logo;

});


parcelRegister("1XKP7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Modal = void 0;

var $kTH7i = parcelRequire("kTH7i");
Object.defineProperty(module.exports, "Modal", {
    enumerable: true,
    get: function() {
        return $kTH7i.Modal;
    }
});

});
parcelRegister("kTH7i", function(module, exports) {
"use client";
"use strict";
var $f36a63c4d9967580$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Modal = void 0;

const $f36a63c4d9967580$var$react_1 = $f36a63c4d9967580$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $jxg79 = parcelRequire("jxg79");

var $i5SnA = parcelRequire("i5SnA");

var $4PwOk = parcelRequire("4PwOk");

var $6Jh06 = parcelRequire("6Jh06");

var $c4avu = parcelRequire("c4avu");
const $f36a63c4d9967580$var$useFocusTrap = (isActive, modalRef)=>{
    $f36a63c4d9967580$var$react_1.default.useEffect(()=>{
        if (!isActive || !modalRef.current) return;
        const modalSpace = modalRef.current;
        const focusableSelectors = 'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
        const focusableElements = Array.from(modalSpace.querySelectorAll(focusableSelectors));
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const handleKeyDown = (event)=>{
            if (event.key === "Tab") {
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement === null || lastElement === void 0 || lastElement.focus();
                    }
                } else if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement === null || firstElement === void 0 || firstElement.focus();
                }
            }
        };
        modalSpace.addEventListener("keydown", handleKeyDown);
        firstElement === null || firstElement === void 0 || firstElement.focus(); // first focusable element is focused on mount
        return ()=>{
            modalSpace === null || modalSpace === void 0 || modalSpace.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isActive,
        modalRef
    ]);
};
const $f36a63c4d9967580$var$Modal = ({ children: children, title: title, isOpen: isOpen, onDismiss: onDismiss, size: size = "md", buttons: buttons })=>{
    const { warn: warn } = (0, $4PwOk.useWarning)();
    const modalRef = $f36a63c4d9967580$var$react_1.default.useRef(null);
    const clickingContent = $f36a63c4d9967580$var$react_1.default.useRef(false);
    const contentRef = $f36a63c4d9967580$var$react_1.default.useRef(null);
    const [showDivider, setShowDivider] = $f36a63c4d9967580$var$react_1.default.useState(false);
    const dismissible = !!onDismiss;
    const transform = isOpen ? [
        "translateY(0px)",
        "unset",
        null
    ] : [
        "translateY(100%)",
        "unset",
        null
    ];
    const { modalSize: modalSize, modalPush: modalPush } = $f36a63c4d9967580$var$react_1.default.useMemo(()=>{
        const modalDimensions = {
            modalSize: [
                4,
                6,
                8
            ],
            modalPush: [
                0,
                1,
                2
            ]
        };
        switch(size){
            case "xs":
                modalDimensions.modalSize = [
                    4,
                    4,
                    4
                ];
                modalDimensions.modalPush = [
                    0,
                    2,
                    4
                ];
                break;
            case "sm":
                modalDimensions.modalSize = [
                    4,
                    4,
                    6
                ];
                modalDimensions.modalPush = [
                    0,
                    2,
                    3
                ];
                break;
            case "lg":
                modalDimensions.modalSize = [
                    4,
                    8,
                    10
                ];
                modalDimensions.modalPush = [
                    0,
                    0,
                    1
                ];
                break;
        }
        return modalDimensions;
    }, [
        size
    ]);
    const handleClickOutside = $f36a63c4d9967580$var$react_1.default.useCallback(()=>{
        if (!clickingContent.current) {
            if (onDismiss && dismissible) onDismiss();
        }
        clickingContent.current = false;
    }, [
        dismissible,
        onDismiss
    ]);
    const dismissControl = $f36a63c4d9967580$var$react_1.default.useMemo(()=>({
            color: "control-enabled",
            ":hover": {
                color: "control-hover"
            },
            ":active": {
                color: "control-click"
            },
            ":focus-visible": {
                outline: "2px solid",
                outlineColor: "focus",
                outlineOffset: "2px",
                borderRadius: "radius-round"
            }
        }), []);
    $f36a63c4d9967580$var$useFocusTrap(isOpen, modalRef);
    if (buttons && buttons.length > 2) warn("Modal: Adding more than two buttons may impact layout on smaller screens.");
    // calculate children height and show divider if scrollable content exists
    $f36a63c4d9967580$var$react_1.default.useEffect(()=>{
        const updateDividerVisibility = ()=>{
            const content = contentRef.current;
            if (content) {
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = content;
                setShowDivider(scrollHeight > clientHeight && (scrollTop > 0 || scrollTop + clientHeight < scrollHeight));
            }
        };
        updateDividerVisibility(); // initialize visibility on mount or modal open
        const content = contentRef.current;
        if (content) {
            content.addEventListener("scroll", updateDividerVisibility);
            return ()=>content.removeEventListener("scroll", updateDividerVisibility);
        }
    }, [
        isOpen
    ]); // recalculate on modal open
    return $f36a63c4d9967580$var$react_1.default.createElement($c4avu.Overlay, {
        visible: isOpen,
        onDismiss: onDismiss,
        sx: {
            alignItems: "center",
            display: "flex"
        }
    }, $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Grid, {
        initial: true,
        onClick: handleClickOutside
    }, $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.GridColumn, {
        size: modalSize,
        fillGap: true,
        sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: [
                "flex-end",
                "center",
                null
            ],
            minHeight: [
                "100dvh",
                "100vh"
            ],
            transition: "transition-ease-out-medium",
            transform: transform
        },
        push: modalPush
    }, $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Box, {
        ref: modalRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": title ? "modal-title" : undefined,
        onClick: ()=>{
            clickingContent.current = true;
        },
        sx: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: "surface-neutral-default",
            cursor: "initial",
            maxHeight: (theme)=>`calc(100vh - ${theme.sizes[28]}px)`,
            overflow: "auto",
            borderRadius: [
                null,
                "radius-2"
            ],
            border: "1px solid",
            borderColor: "stroke-neutral-default",
            boxShadow: [
                null,
                "shadow-100"
            ],
            py: "spacing-7",
            gap: "spacing-5"
        }
    }, (title || dismissible) && $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            justifyContent: title ? "space-between" : "flex-end",
            alignItems: "center",
            flexShrink: 0,
            px: "spacing-7"
        }
    }, title && $f36a63c4d9967580$var$react_1.default.createElement($i5SnA.Text, {
        variant: "title-1-medium",
        id: "modal-title"
    }, title), dismissible && $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Target, {
        onClick: ()=>{
            clickingContent.current = true;
            onDismiss();
        },
        "aria-label": "Close Modal",
        sx: Object.assign(Object.assign({}, dismissControl), {
            height: "spacing-7",
            width: "spacing-7"
        })
    }, $f36a63c4d9967580$var$react_1.default.createElement($jxg79.Icon, {
        icon: "x",
        size: "sm",
        color: "currentColor"
    }))), $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Box, {
        ref: contentRef,
        sx: {
            flexGrow: 1,
            overflowY: "auto",
            px: "spacing-7",
            // using border + padding to visually differentiate the scroll area
            py: showDivider ? "spacing-5" : "spacing-none",
            borderBottom: showDivider ? "1px solid" : "none",
            borderTop: showDivider ? "1px solid" : "none",
            borderColor: "stroke-neutral-default"
        }
    }, children), buttons && $f36a63c4d9967580$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            alignSelf: "stretch",
            gap: "spacing-3",
            px: "spacing-7"
        }
    }, buttons.map((button, idx)=>{
        return $f36a63c4d9967580$var$react_1.default.createElement($6Jh06.Button, Object.assign({
            key: `modal-button-${idx}`,
            variant: idx < buttons.length - 1 ? "outline" : "filled"
        }, button), button.label);
    }))))));
};
module.exports.Modal = $f36a63c4d9967580$var$Modal;

});
parcelRegister("c4avu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Overlay = void 0;

var $c5tKP = parcelRequire("c5tKP");
Object.defineProperty(module.exports, "Overlay", {
    enumerable: true,
    get: function() {
        return $c5tKP.Overlay;
    }
});

});
parcelRegister("c5tKP", function(module, exports) {
"use client";
"use strict";
var $8ccd083e12d51e30$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Overlay = void 0;

const $8ccd083e12d51e30$var$react_1 = $8ccd083e12d51e30$var$__importDefault((parcelRequire("acw62")));

const $8ccd083e12d51e30$var$react_dom_1 = $8ccd083e12d51e30$var$__importDefault((parcelRequire("1u0KT")));

var $2wkl1 = parcelRequire("2wkl1");

var $ifKCu = parcelRequire("ifKCu");
const $8ccd083e12d51e30$var$Overlay = ({ visible: visible, onDismiss: onDismiss, sx: sx, children: children })=>{
    const [, setForceUpdate] = $8ccd083e12d51e30$var$react_1.default.useState(0);
    const [hasTransitionedOut, setHasTransitionedOut] = $8ccd083e12d51e30$var$react_1.default.useState(true);
    const { mountOverlay: mountOverlay, unmountOverlay: unmountOverlay, getOverlayZIndex: getOverlayZIndex } = (0, $ifKCu.useOverlay)();
    const overlayIdRef = $8ccd083e12d51e30$var$react_1.default.useRef(0);
    const overlayZIndex = getOverlayZIndex(overlayIdRef.current);
    const portalRef = $8ccd083e12d51e30$var$react_1.default.useRef(null);
    const background = $8ccd083e12d51e30$var$react_1.default.useMemo(()=>overlayZIndex === 1 ? "scrim" : "unset", [
        overlayZIndex
    ]);
    const overlayFixedStyles = {
        height: !hasTransitionedOut ? "100%" : 0,
        left: 0,
        opacity: !visible ? 0 : 1,
        pointerEvents: !visible ? "none" : "initial",
        position: "fixed",
        overflow: "hidden",
        top: 0,
        transition: "transition-color-slow",
        width: "100%",
        zIndex: (theme)=>{
            var _a;
            return ((_a = theme === null || theme === void 0 ? void 0 : theme.zIndices) === null || _a === void 0 ? void 0 : _a.modal) + overlayZIndex;
        }
    };
    const handleClick = $8ccd083e12d51e30$var$react_1.default.useCallback((e)=>{
        // If the overlay is being clicked
        if (e.target === e.currentTarget) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, [
        onDismiss
    ]);
    const handleTransitionEnd = $8ccd083e12d51e30$var$react_1.default.useCallback((e)=>{
        if (e.currentTarget === e.target && !visible) {
            setHasTransitionedOut(true);
            unmountOverlay(overlayIdRef.current);
        }
    }, [
        unmountOverlay,
        visible
    ]);
    $8ccd083e12d51e30$var$react_1.default.useEffect(()=>{
        // Force a render on mount so the element exists and
        // transitions start working
        setForceUpdate(1);
    }, []);
    $8ccd083e12d51e30$var$react_1.default.useEffect(()=>{
        portalRef.current = document.createElement("div");
        if (portalRef.current) document.body.appendChild(portalRef.current);
        return ()=>{
            if (portalRef.current) document.body.removeChild(portalRef.current);
        };
    }, []);
    $8ccd083e12d51e30$var$react_1.default.useEffect(()=>{
        const handleDocumentKeyDown = (e)=>{
            if (e.key.toLowerCase() === "escape" || e.key.toLowerCase() === "esc") onDismiss === null || onDismiss === void 0 || onDismiss();
        };
        window.addEventListener("keydown", handleDocumentKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleDocumentKeyDown);
        };
    }, [
        onDismiss
    ]);
    $8ccd083e12d51e30$var$react_1.default.useEffect(()=>()=>{
            // Unmount the overlay from the stack if the component
            // is unmounted from the DOM
            unmountOverlay(overlayIdRef.current);
        }, [
        unmountOverlay
    ]);
    $8ccd083e12d51e30$var$react_1.default.useEffect(()=>{
        if (visible && hasTransitionedOut) {
            const newOverlayId = mountOverlay();
            overlayIdRef.current = newOverlayId;
            setHasTransitionedOut(false);
        }
    }, [
        hasTransitionedOut,
        mountOverlay,
        visible
    ]);
    if (!portalRef.current) return null;
    return $8ccd083e12d51e30$var$react_dom_1.default.createPortal($8ccd083e12d51e30$var$react_1.default.createElement($8ccd083e12d51e30$var$react_1.default.Fragment, null, $8ccd083e12d51e30$var$react_1.default.createElement($2wkl1.Box, {
        "aria-hidden": !visible && hasTransitionedOut,
        role: "dialog",
        sx: Object.assign(Object.assign({}, overlayFixedStyles), {
            backdropFilter: "blur(12px)",
            background: background
        })
    }), $8ccd083e12d51e30$var$react_1.default.createElement($2wkl1.Box, {
        "aria-hidden": !visible && hasTransitionedOut,
        role: "dialog",
        sx: Object.assign(Object.assign({}, sx), overlayFixedStyles),
        onClick: handleClick,
        onTransitionEnd: handleTransitionEnd
    }, !!(visible || !hasTransitionedOut) && children)), portalRef.current);
};
module.exports.Overlay = $8ccd083e12d51e30$var$Overlay;

});




parcelRegister("7ZgD9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pagination = void 0;

var $c0Zb2 = parcelRequire("c0Zb2");
Object.defineProperty(module.exports, "Pagination", {
    enumerable: true,
    get: function() {
        return $c0Zb2.Pagination;
    }
});

});
parcelRegister("c0Zb2", function(module, exports) {
"use client";
"use strict";
var $8bf4f0a079d11bc2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pagination = void 0;

const $8bf4f0a079d11bc2$var$react_1 = $8bf4f0a079d11bc2$var$__importDefault((parcelRequire("acw62")));

const $8bf4f0a079d11bc2$var$NumberedPagination_1 = $8bf4f0a079d11bc2$var$__importDefault((parcelRequire("eMTNW")));
const $8bf4f0a079d11bc2$var$Pagination = ({ continuous: continuous = false, count: count, hideNextPrevButtons: hideNextPrevButtons = false, onPageChange: onPageChange, page: page, siblingCount: siblingCount, disabled: disabled = false })=>{
    const hasNext = page < count;
    const hasPrev = page > 1;
    const hideNextPrevButtonsArray = $8bf4f0a079d11bc2$var$react_1.default.useMemo(()=>{
        if (Array.isArray(hideNextPrevButtons)) return hideNextPrevButtons;
        else return [
            hideNextPrevButtons,
            hideNextPrevButtons,
            hideNextPrevButtons
        ];
    }, [
        hideNextPrevButtons
    ]);
    const handlePageChange = $8bf4f0a079d11bc2$var$react_1.default.useCallback((pageNext)=>{
        if (pageNext === page) return;
        else if (continuous) {
            if (pageNext < 1) onPageChange(count, "back");
            else if (pageNext > count) onPageChange(1, "forward");
            else onPageChange(pageNext, pageNext > page ? "forward" : "back");
        } else if (pageNext >= 1 && pageNext <= count) onPageChange(pageNext, pageNext > page ? "forward" : "back");
    }, [
        continuous,
        count,
        onPageChange,
        page
    ]);
    const handleClickNext = $8bf4f0a079d11bc2$var$react_1.default.useCallback(()=>handlePageChange(page + 1), [
        handlePageChange,
        page
    ]);
    const handleClickPrev = $8bf4f0a079d11bc2$var$react_1.default.useCallback(()=>handlePageChange(page - 1), [
        handlePageChange,
        page
    ]);
    const handleKeyUp = $8bf4f0a079d11bc2$var$react_1.default.useCallback((e)=>{
        switch(e.key){
            case "ArrowLeft":
                handleClickPrev();
                break;
            case "ArrowRight":
                handleClickNext();
                break;
        }
    }, [
        handleClickPrev,
        handleClickNext
    ]);
    if (count <= 0) return null;
    const props = {
        continuous: continuous,
        count: count,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        handleKeyUp: handleKeyUp,
        handlePageChange: handlePageChange,
        hasNext: hasNext,
        hasPrev: hasPrev,
        hideNextPrevButtonsArray: hideNextPrevButtonsArray,
        page: page,
        disabled: disabled
    };
    return $8bf4f0a079d11bc2$var$react_1.default.createElement($8bf4f0a079d11bc2$var$NumberedPagination_1.default, Object.assign({}, props, {
        siblingCount: siblingCount,
        disabled: disabled
    }));
};
module.exports.Pagination = $8bf4f0a079d11bc2$var$Pagination;

});
parcelRegister("eMTNW", function(module, exports) {
"use strict";
var $ac40d6027c12abd2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ac40d6027c12abd2$var$react_1 = $ac40d6027c12abd2$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $6Jh06 = parcelRequire("6Jh06");
const $ac40d6027c12abd2$var$NumberButton = ({ active: active = false, onPageChange: onPageChange, page: page, disabled: disabled = false })=>{
    const colorClassName = `pagination${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const handleClick = $ac40d6027c12abd2$var$react_1.default.useCallback(()=>{
        onPageChange(page);
    }, [
        onPageChange,
        page
    ]);
    // mimicked transparent icon button styles
    const buttonStyles = Object.assign(Object.assign({
        // layout
        display: "flex",
        justifyContent: "center",
        alignItems: "end",
        // appearance
        color: disabled ? "tab-text-disabled" : active ? "tab-stroke-selected" : "unset",
        transition: "transition-color-medium",
        px: "spacing-3",
        [`.${colorClassName}`]: {
            borderBottomColor: disabled && active ? "tab-text-disabled" : active ? "tab-stroke-selected" : "transparent",
            transition: "transition-color-medium"
        }
    }, !active && {
        [`:hover .${colorClassName}`]: {
            borderBottomColor: disabled ? "transparent" : "tab-stroke-hover"
        },
        [`:active .${colorClassName}`]: {
            borderBottomColor: disabled ? "transparent" : "tab-stroke-click"
        }
    }), {
        ":focus-visible": {
            outlineStyle: "solid",
            borderRadius: "radius-1",
            outlineColor: "focus",
            outlineWidth: "2px"
        }
    });
    return $ac40d6027c12abd2$var$react_1.default.createElement($2wkl1.Target, {
        "aria-selected": active,
        "aria-label": `Go to page ${page}`,
        role: "tab",
        disabled: disabled,
        sx: buttonStyles,
        onClick: handleClick
    }, $ac40d6027c12abd2$var$react_1.default.createElement($i5SnA.Text, {
        className: colorClassName,
        variant: "title-1-medium",
        sx: {
            px: "spacing-2",
            pb: "spacing-4",
            borderBottomWidth: "3px",
            borderBottomStyle: "solid"
        }
    }, page));
};
const $ac40d6027c12abd2$var$getNextPrevButtonDisplay = (hidden)=>hidden ? "none" : "flex";
const $ac40d6027c12abd2$var$NumberedPagination = ({ count: count, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev, handleKeyUp: handleKeyUp, handlePageChange: handlePageChange, hasNext: hasNext, hasPrev: hasPrev, hideNextPrevButtonsArray: hideNextPrevButtonsArray, page: page, siblingCount: siblingCount = 1, disabled: disabled })=>{
    // https://github.com/mui/material-ui/blob/master/packages/mui-material/src/usePagination/usePagination.js
    const getPageNumbers = ()=>{
        const boundaryCount = 1; // the number of always visible pages at the beginning and end
        const range = (start, end)=>{
            const length = end - start + 1;
            return Array.from({
                length: length
            }, (_, i)=>start + i);
        };
        const startPages = range(1, Math.min(boundaryCount, count));
        const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
        const siblingsStart = Math.max(Math.min(// Natural start
        page - siblingCount, // Lower boundary when page is high
        count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
        boundaryCount + 2);
        const siblingsEnd = Math.min(Math.max(// Natural end
        page + siblingCount, // Upper boundary when page is low
        boundaryCount + siblingCount * 2 + 2), // Less than endPages
        count - boundaryCount - 1);
        const pages = [
            ...startPages,
            // Start ellipsis
            ...siblingsStart > boundaryCount + 2 ? [
                "..."
            ] : boundaryCount + 1 < count - boundaryCount ? [
                boundaryCount + 1
            ] : [],
            // Sibling pages
            ...Array.from({
                length: siblingsEnd - siblingsStart + 1
            }, (_, i)=>siblingsStart + i),
            // End ellipsis
            ...siblingsEnd < count - boundaryCount - 1 ? [
                "..."
            ] : count - boundaryCount > boundaryCount ? [
                count - boundaryCount
            ] : [],
            ...endPages
        ];
        return pages;
    };
    const pageNumbers = getPageNumbers();
    return $ac40d6027c12abd2$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            alignItems: "center"
        }
    }, $ac40d6027c12abd2$var$react_1.default.createElement($2wkl1.Box, {
        onKeyUp: handleKeyUp,
        role: "tablist",
        sx: {
            display: "flex",
            flex: 1,
            justifyContent: "center",
            listStyle: "none",
            minHeight: "spacing-10"
        }
    }, $ac40d6027c12abd2$var$react_1.default.createElement($6Jh06.Button, {
        icon: "caret-left",
        "aria-label": "Go to previous page",
        variant: "subtle",
        onClick: handleClickPrev,
        role: "tab",
        tabIndex: hasPrev ? 0 : -1,
        disabled: disabled || !hasPrev,
        sx: {
            display: [
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[0]),
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[1]),
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[2])
            ],
            color: disabled || !hasPrev ? "tab-text-disabled" : "tab-text-default",
            mt: -2,
            alignSelf: "center"
        }
    }), pageNumbers.map((pageNumber, index)=>{
        if (pageNumber === "...") return $ac40d6027c12abd2$var$react_1.default.createElement($2wkl1.Box, {
            key: `ellipsis-${index}`,
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: "spacing-2",
                mx: "spacing-3",
                whiteSpace: "nowrap",
                color: "tab-text-disabled"
            }
        }, "...");
        return $ac40d6027c12abd2$var$react_1.default.createElement($ac40d6027c12abd2$var$NumberButton, {
            key: `page-${pageNumber}-${page}`,
            active: page === pageNumber,
            page: pageNumber,
            onPageChange: handlePageChange,
            disabled: disabled
        });
    }), $ac40d6027c12abd2$var$react_1.default.createElement($6Jh06.Button, {
        icon: "caret-right",
        variant: "subtle",
        "aria-label": "Go to next page",
        onClick: handleClickNext,
        role: "tab",
        tabIndex: hasNext ? 0 : -1,
        disabled: disabled || !hasNext,
        sx: {
            display: [
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[0]),
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[1]),
                $ac40d6027c12abd2$var$getNextPrevButtonDisplay(hideNextPrevButtonsArray[2])
            ],
            color: disabled || !hasNext ? "tab-text-disabled" : "tab-text-default",
            mt: -2,
            alignSelf: "center"
        }
    })));
};
module.exports.default = $ac40d6027c12abd2$var$NumberedPagination;

});



parcelRegister("53ShT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressBar = void 0;

var $bbizK = parcelRequire("bbizK");
Object.defineProperty(module.exports, "ProgressBar", {
    enumerable: true,
    get: function() {
        return $bbizK.ProgressBar;
    }
});

});
parcelRegister("bbizK", function(module, exports) {
"use strict";
var $823f217f9d097c33$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressBar = void 0;

const $823f217f9d097c33$var$react_1 = $823f217f9d097c33$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");
const $823f217f9d097c33$var$ProgressBar = ({ value: value, showLabel: showLabel = true })=>{
    // ensure the value is between 0 and 100
    const clampedValue = Math.max(0, Math.min(100, value));
    return $823f217f9d097c33$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            alignItems: "center",
            height: "1.5em" // matches lineHeight of text
        }
    }, $823f217f9d097c33$var$react_1.default.createElement($2wkl1.Box, {
        role: "progressbar",
        "aria-label": `Progress bar at ${clampedValue}%`,
        "aria-valuenow": clampedValue,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        sx: {
            flexGrow: 1,
            borderRadius: "radius-1",
            background: "surface-neutral-tertiary"
        }
    }, $823f217f9d097c33$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            height: "spacing-3",
            width: `${clampedValue}%`,
            borderRadius: "radius-1",
            background: "button-surface-filled-enabled"
        }
    })), showLabel && $823f217f9d097c33$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-2-regular",
        sx: {
            ml: "spacing-4"
        }
    }, Math.round(clampedValue), "%"));
};
module.exports.ProgressBar = $823f217f9d097c33$var$ProgressBar;

});


parcelRegister("avESx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioGroupContext = module.exports.RadioGroup = module.exports.RadioButton = void 0;

var $e1FFy = parcelRequire("e1FFy");
Object.defineProperty(module.exports, "RadioButton", {
    enumerable: true,
    get: function() {
        return $e1FFy.RadioButton;
    }
});

var $aGzcX = parcelRequire("aGzcX");
Object.defineProperty(module.exports, "RadioGroup", {
    enumerable: true,
    get: function() {
        return $aGzcX.RadioGroup;
    }
});
Object.defineProperty(module.exports, "RadioGroupContext", {
    enumerable: true,
    get: function() {
        return $aGzcX.RadioGroupContext;
    }
});

});
parcelRegister("e1FFy", function(module, exports) {
"use client";
"use strict";
var $a3617b5138223c3e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioButton = void 0;

const $a3617b5138223c3e$var$react_1 = $a3617b5138223c3e$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $k4vgd = parcelRequire("k4vgd");

var $8kINY = parcelRequire("8kINY");

var $aGzcX = parcelRequire("aGzcX");
const $a3617b5138223c3e$var$sharedRadioButtonStyles = {
    display: "inline-flex",
    alignItems: "center",
    marginRight: "spacing-4",
    width: "spacing-6",
    height: "spacing-6",
    border: "2px solid",
    borderRadius: "radius-round",
    cursor: "pointer",
    ":focus-visible": {
        outline: "2px solid",
        outlineColor: "focus",
        outlineOffset: "2px"
    }
};
const $a3617b5138223c3e$var$buttonWrapper = {
    display: "flex",
    flexDirection: "column",
    width: "fit-content"
};
const $a3617b5138223c3e$var$RadioButton = (props)=>{
    const { value: value, label: label, disabled: disabled, error: error, onBlur: onBlur, id: id } = props;
    const base0Id = (0, $8kINY.useId)();
    const inputId = id !== null && id !== void 0 ? id : base0Id;
    const [, preventOutlineOnClick, handleFocus, handleBlur] = (0, $k4vgd.useFocusControls)(onBlur);
    const radioContext = $a3617b5138223c3e$var$react_1.default.useContext($aGzcX.RadioGroupContext);
    const isChecked = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return (radioContext === null || radioContext === void 0 ? void 0 : radioContext.selectedValue) === value;
    }, [
        radioContext === null || radioContext === void 0 ? void 0 : radioContext.selectedValue,
        value
    ]);
    const isDisabled = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return (radioContext === null || radioContext === void 0 ? void 0 : radioContext.disabled) || disabled;
    }, [
        disabled,
        radioContext === null || radioContext === void 0 ? void 0 : radioContext.disabled
    ]);
    const isError = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return Boolean((radioContext === null || radioContext === void 0 ? void 0 : radioContext.error) || error);
    }, [
        radioContext === null || radioContext === void 0 ? void 0 : radioContext.error,
        error
    ]);
    const defaultRadioButtonStyles = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({}, $a3617b5138223c3e$var$sharedRadioButtonStyles), {
            borderColor: isChecked ? "input-surface-enabled" : "input-stroke-enabled",
            transition: "transition-color-medium",
            ":hover": {
                borderColor: isChecked ? "input-surface-hover" : "input-stroke-hover",
                ":after": {
                    backgroundColor: "input-surface-hover"
                }
            },
            ":active": {
                borderColor: isChecked ? "input-surface-click" : "input-stroke-click",
                ":after": {
                    backgroundColor: "input-surface-click"
                }
            },
            ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: "input-surface-enabled",
                visibility: isChecked ? "visible" : "hidden",
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            }
        });
    }, [
        isChecked
    ]);
    const disabledRadioButtonStyles = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({}, $a3617b5138223c3e$var$sharedRadioButtonStyles), {
            borderColor: "input-stroke-disabled",
            cursor: "not-allowed",
            ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: isChecked ? "input-surface-disabled" : undefined,
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            }
        });
    }, [
        isChecked
    ]);
    const errorRadioButtonStyles = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({}, $a3617b5138223c3e$var$sharedRadioButtonStyles), {
            borderColor: "input-stroke-error",
            "&:active": {
                backgroundColor: "backgroundNeutral02"
            },
            ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: isChecked ? "input-stroke-error" : undefined,
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            }
        });
    }, [
        isChecked
    ]);
    const radioButtonStyles = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        if (isDisabled) return disabledRadioButtonStyles;
        else if (isError) return errorRadioButtonStyles;
        else return defaultRadioButtonStyles;
    }, [
        defaultRadioButtonStyles,
        disabledRadioButtonStyles,
        errorRadioButtonStyles,
        isDisabled,
        isError
    ]);
    const labelStyles = $a3617b5138223c3e$var$react_1.default.useMemo(()=>{
        return {
            display: "inline-flex",
            alignItems: "center",
            color: isDisabled ? "input-text-disabled" : "input-text",
            cursor: isDisabled ? "not-allowed" : "pointer",
            fontSize: "font-size-4",
            lineHeight: "leading-2",
            letterSpacing: "kerning-none",
            paddingY: "spacing-3"
        };
    }, [
        isDisabled
    ]);
    return $a3617b5138223c3e$var$react_1.default.createElement($2wkl1.Box, {
        onMouseDown: preventOutlineOnClick,
        onMouseUp: preventOutlineOnClick,
        sx: $a3617b5138223c3e$var$buttonWrapper
    }, $a3617b5138223c3e$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        htmlFor: inputId,
        id: `${inputId}-label`,
        sx: labelStyles
    }, $a3617b5138223c3e$var$react_1.default.createElement($2wkl1.Box, {
        as: "input",
        type: "radio",
        id: inputId,
        value: value,
        checked: isChecked,
        onChange: radioContext === null || radioContext === void 0 ? void 0 : radioContext.onChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        sx: radioButtonStyles,
        disabled: isDisabled,
        "aria-disabled": isDisabled
    }), label));
};
module.exports.RadioButton = $a3617b5138223c3e$var$RadioButton;

});
parcelRegister("aGzcX", function(module, exports) {
"use client";
"use strict";
var $7c792330e650bb1e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadioGroup = module.exports.RadioGroupContext = void 0;

const $7c792330e650bb1e$var$react_1 = $7c792330e650bb1e$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");
module.exports.RadioGroupContext = $7c792330e650bb1e$var$react_1.default.createContext(undefined);
const $7c792330e650bb1e$var$RadioGroup = (props)=>{
    const { children: children, disabled: disabled, error: error, label: label, value: value, onChange: onChange } = props;
    const [selectedValue, setSelectedValue] = $7c792330e650bb1e$var$react_1.default.useState(value || "");
    const labelNode = $7c792330e650bb1e$var$react_1.default.useMemo(()=>{
        return typeof label === "string" ? $7c792330e650bb1e$var$react_1.default.createElement($i5SnA.Text, null, label) : label;
    }, [
        label
    ]);
    const onClickOption = $7c792330e650bb1e$var$react_1.default.useCallback((event)=>{
        setSelectedValue(event.target.value);
        if (onChange) onChange(event);
    }, [
        onChange
    ]);
    const contextValue = {
        selectedValue: selectedValue,
        onChange: onClickOption,
        disabled: disabled,
        error: error
    };
    return $7c792330e650bb1e$var$react_1.default.createElement(module.exports.RadioGroupContext.Provider, {
        value: contextValue
    }, $7c792330e650bb1e$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            paddingX: "spacing-4"
        }
    }, $7c792330e650bb1e$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            fontSize: "font-size-4",
            color: "text-default",
            paddingY: "spacing-3",
            fontWeight: "font-weight-medium",
            lineHeight: "leading-2",
            letterSpacing: "kerning-none"
        }
    }, labelNode), children));
};
module.exports.RadioGroup = $7c792330e650bb1e$var$RadioGroup;

});



parcelRegister("gaUiF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchBar = void 0;

var $3BRHL = parcelRequire("3BRHL");
Object.defineProperty(module.exports, "SearchBar", {
    enumerable: true,
    get: function() {
        return $3BRHL.SearchBar;
    }
});

});
parcelRegister("3BRHL", function(module, exports) {
"use client";
"use strict";
var $2a0e7c79c9ee205b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2a0e7c79c9ee205b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchBar = void 0;

const $2a0e7c79c9ee205b$var$react_1 = $2a0e7c79c9ee205b$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $6Jh06 = parcelRequire("6Jh06");

var $37mbs = parcelRequire("37mbs");
const $2a0e7c79c9ee205b$var$SearchBar = (_a)=>{
    var { onClickSearch: onClickSearch, disabled: disabled } = _a, props = $2a0e7c79c9ee205b$var$__rest(_a, [
        "onClickSearch",
        "disabled"
    ]);
    const searchIcon = $2a0e7c79c9ee205b$var$react_1.default.useCallback(()=>$2a0e7c79c9ee205b$var$react_1.default.createElement($6Jh06.Button, {
            icon: "magnifying-glass",
            "aria-label": "Search",
            disabled: disabled,
            onClick: onClickSearch
        }), [
        disabled,
        onClickSearch
    ]);
    return $2a0e7c79c9ee205b$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            position: "relative"
        }
    }, $2a0e7c79c9ee205b$var$react_1.default.createElement($37mbs.TextField, Object.assign({
        searchIcon: searchIcon,
        onEnter: onClickSearch,
        disabled: disabled
    }, props)));
};
module.exports.SearchBar = $2a0e7c79c9ee205b$var$SearchBar;

});
parcelRegister("37mbs", function(module, exports) {
"use client";
"use strict";
var $24533bc63327f351$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $24533bc63327f351$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $24533bc63327f351$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $24533bc63327f351$var$__createBinding(result, mod, k);
    }
    $24533bc63327f351$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextField = void 0;

const $24533bc63327f351$var$react_1 = $24533bc63327f351$var$__importStar((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $iUsB4 = parcelRequire("iUsB4");
const $24533bc63327f351$var$TextField = ({ label: label, value: value, error: error, type: type = "text", max: max, maxLength: maxLength, min: min, name: name, description: description, disabled: disabled, icon: icon, readOnly: readOnly, required: required, autoComplete: autoComplete = "off", spellCheck: spellCheck = "false", dropdownOptions: dropdownOptions = [], noResultsMessage: noResultsMessage, searchIcon: searchIcon, optionDisplayCount: optionDisplayCount, onClickClear: onClickClear, onSelectOption: onSelectOption, onEnter: onEnter, onBlur: onBlur, onChange: onChange, onIconClick: onIconClick })=>{
    const inputId = (0, $24533bc63327f351$var$react_1.useId)();
    const [isFocused, setIsFocused] = $24533bc63327f351$var$react_1.default.useState(false);
    const clearButtonRef = $24533bc63327f351$var$react_1.default.useRef(null);
    const { inputRef: inputRef, focusedOptionIdx: focusedOptionIdx, handleKeyDown: handleKeyDown, showDropdown: showDropdown, iconButtonRef: iconButtonRef, handleClickOption: handleClickOption, ariaPropsForDropdown: ariaPropsForDropdown, handleCompositionStart: handleCompositionStart, handleCompositionEnd: handleCompositionEnd } = (0, $iUsB4.useDropdownMenu)({
        isSelect: type === "select",
        dropdownOptions: dropdownOptions,
        onSelectOption: onSelectOption,
        isFocused: isFocused,
        onEnter: onEnter,
        onClickClear: onClickClear
    });
    const shouldShowLabel = isFocused || !!value;
    const showNoResults = noResultsMessage !== undefined && value !== undefined && typeof value === "string" && value.length > 0 && (dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.length) === 0;
    const handleFocus = ()=>{
        setIsFocused(true);
    };
    const handleBlur = $24533bc63327f351$var$react_1.default.useCallback((event)=>{
        if (clearButtonRef.current && event.relatedTarget === clearButtonRef.current && onClickClear) onClickClear();
        handleClickOption(event);
        setIsFocused(false);
        if (onBlur) onBlur(event);
    }, [
        onBlur,
        handleClickOption,
        onClickClear
    ]);
    const handleChange = $24533bc63327f351$var$react_1.default.useCallback((e)=>{
        if (type === "number") {
            const numberValue = parseInt(e.currentTarget.value, 10);
            if (max !== undefined && numberValue > max || min !== undefined && numberValue < min) ;
            else onChange === null || onChange === void 0 || onChange(e);
        } else onChange === null || onChange === void 0 || onChange(e);
    }, [
        max,
        min,
        onChange,
        type
    ]);
    const handleIconClick = (e)=>{
        e.preventDefault();
        if (inputRef.current) {
            const inputLength = inputRef.current.value.length;
            if (onIconClick) onIconClick();
            // use setTimeout because focus and cursor position should update after DOM updates
            setTimeout(()=>{
                if (inputLength) {
                    inputRef.current.focus();
                    inputRef.current.setSelectionRange(inputLength, inputLength);
                }
            }, 0);
        }
    };
    const labelTextStyles = $24533bc63327f351$var$react_1.default.useMemo(()=>{
        const labelYPosition = shouldShowLabel ? "-24px" : "-50%";
        const labelScale = shouldShowLabel ? 0.66 : 1;
        return {
            position: "absolute",
            left: "spacing-4",
            top: "50%",
            transform: `translateY(${labelYPosition}) scale(${labelScale})`,
            transformOrigin: "left center",
            transition: "transition-ease-out-fast",
            pointerEvents: "none",
            fontSize: "font-size-1",
            lineHeight: "leading-2",
            letterSpacing: "kerning-2",
            color: disabled ? "field-text-disabled" : "field-text-label",
            whiteSpace: "nowrap",
            overflow: "hidden"
        };
    }, [
        disabled,
        shouldShowLabel
    ]);
    const inputStyles = $24533bc63327f351$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({
            width: "100%",
            height: "spacing-10",
            px: "spacing-4",
            paddingTop: shouldShowLabel ? "spacing-7" : "spacing-5",
            paddingBottom: shouldShowLabel ? "spacing-3" : "spacing-5",
            borderRadius: "radius-2",
            cursor: disabled || readOnly ? "not-allowed" : "auto"
        }, disabled && {
            pointerEvents: "none"
        }), {
            // Don't do any special number formatting
            color: "field-text-primary",
            MozAppearance: "textfield",
            overflow: "hidden",
            "::-webkit-outer-spin-button, ::-webkit-inner-spin-button": {
                margin: 0,
                WebkitAppearance: "none"
            }
        });
    }, [
        shouldShowLabel,
        disabled,
        readOnly
    ]);
    const descriptionTextStyles = $24533bc63327f351$var$react_1.default.useMemo(()=>{
        return {
            color: disabled ? "field-text-disabled" : "field-text-description"
        };
    }, [
        disabled
    ]);
    const inputBorderStyles = $24533bc63327f351$var$react_1.default.useMemo(()=>{
        return Object.assign(Object.assign({
            position: "relative",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "input-stroke-enabled",
            outline: "2px solid",
            outlineColor: error ? "field-stroke-error" : isFocused && !readOnly ? "focus" : "transparent",
            outlineOffset: "-2px",
            borderRadius: "radius-2",
            marginBottom: error ? "spacing-2" : "spacing-1",
            cursor: disabled || readOnly ? "not-allowed" : "auto",
            backgroundColor: disabled || readOnly ? "field-surface-disabled" : "field-surface"
        }, readOnly && {
            borderWidth: "0 0 1px 0",
            borderRadius: "unset"
        }), {
            overflow: "hidden",
            transition: "transition-color-medium"
        });
    }, [
        disabled,
        error,
        isFocused,
        readOnly
    ]);
    return $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            userSelect: "none",
            position: "relative"
        }
    }, $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, Object.assign({
        sx: Object.assign({}, inputBorderStyles)
    }, ariaPropsForDropdown), $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        htmlFor: inputId,
        id: `${inputId}-label`,
        sx: Object.assign({}, labelTextStyles)
    }, $24533bc63327f351$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular"
    }, label), required && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular",
        sx: {
            color: "feedback-onSurface-incidental-critical"
        }
    }, "*")), $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, {
        as: "input",
        ref: inputRef,
        type: type,
        id: inputId,
        value: value,
        max: max,
        maxLength: maxLength,
        min: min,
        name: name,
        disabled: disabled,
        readOnly: readOnly,
        autoComplete: autoComplete,
        spellCheck: spellCheck,
        "aria-disabled": disabled,
        "aria-invalid": !!error,
        "aria-readonly": readOnly,
        "aria-required": required,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        sx: Object.assign(Object.assign({}, inputStyles), {
            justifyContent: "space-between"
        })
    }), $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            position: "absolute",
            top: "50%",
            right: searchIcon ? "spacing-2" : "spacing-4",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            gap: "spacing-3",
            pointerEvents: "auto"
        }
    }, onClickClear && value && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Target, {
        ref: clearButtonRef,
        "aria-label": "clear",
        tabIndex: -1,
        sx: {
            display: "flex",
            alignItems: "center"
        },
        onClick: onClickClear
    }, $24533bc63327f351$var$react_1.default.createElement($2wkl1.Icon, {
        icon: "x-circle",
        size: "xs",
        color: "control-enabled"
    })), icon && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Target, {
        "aria-hidden": onIconClick ? "false" : "true",
        "aria-label": onIconClick ? "click icon" : undefined,
        onClick: handleIconClick,
        sx: {
            display: "flex",
            alignItems: "center"
        }
    }, $24533bc63327f351$var$react_1.default.createElement($2wkl1.Icon, {
        icon: icon,
        size: "xs",
        color: "control-enabled"
    })), searchIcon && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Box, {
        ref: iconButtonRef,
        sx: {
            display: "flex",
            alignItems: "center"
        }
    }, searchIcon()))), showDropdown && $24533bc63327f351$var$react_1.default.createElement($iUsB4.DropdownMenu, {
        dropdownOptions: dropdownOptions,
        showNoResults: showNoResults,
        focusedIdx: focusedOptionIdx,
        optionDisplayCount: optionDisplayCount,
        noResultsMessage: noResultsMessage
    }), description && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-2-regular",
        sx: Object.assign({}, descriptionTextStyles)
    }, description), error && $24533bc63327f351$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-2-regular",
        sx: {
            color: "field-text-error"
        }
    }, error));
};
module.exports.TextField = $24533bc63327f351$var$TextField;

});
parcelRegister("iUsB4", function(module, exports) {
"use strict";
var $dc43a3b082f85065$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dc43a3b082f85065$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dc43a3b082f85065$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DropdownMenu = void 0;

var $aa8af = parcelRequire("aa8af");
Object.defineProperty(module.exports, "DropdownMenu", {
    enumerable: true,
    get: function() {
        return $aa8af.DropdownMenu;
    }
});

$dc43a3b082f85065$var$__exportStar((parcelRequire("ewdTS")), module.exports);

});
parcelRegister("aa8af", function(module, exports) {
"use client";
"use strict";
var $76612bd33eedf3cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DropdownMenu = void 0;

const $76612bd33eedf3cc$var$react_1 = $76612bd33eedf3cc$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $k1f45 = parcelRequire("k1f45");

var $jfMgS = parcelRequire("jfMgS");
const $76612bd33eedf3cc$var$DropdownItemList = ({ dropdownOptions: dropdownOptions, focusedIdx: focusedIdx })=>{
    if (!dropdownOptions.length) return null;
    return $76612bd33eedf3cc$var$react_1.default.createElement($76612bd33eedf3cc$var$react_1.default.Fragment, null, dropdownOptions.map((option, idx)=>$76612bd33eedf3cc$var$react_1.default.createElement($k1f45.DropdownItem, {
            key: option.value,
            option: option,
            isFocused: focusedIdx === idx,
            idx: idx
        })));
};
const $76612bd33eedf3cc$var$DropdownMenu = ({ dropdownOptions: dropdownOptions, showNoResults: showNoResults, optionDisplayCount: optionDisplayCount = 5, focusedIdx: focusedIdx, noResultsMessage: noResultsMessage, sx: sx })=>{
    const dropdownRef = $76612bd33eedf3cc$var$react_1.default.useRef(null);
    // Hook to dynamically adjust the height of the dropdown
    const { handleScroll: handleScroll } = (0, $jfMgS.useDynamicDropdownHeight)({
        dropdownOptions: dropdownOptions,
        dropdownRef: dropdownRef,
        optionDisplayCount: optionDisplayCount,
        showNoResults: showNoResults
    });
    if (!dropdownOptions.length && !showNoResults) return null;
    return $76612bd33eedf3cc$var$react_1.default.createElement($2wkl1.Box, {
        sx: Object.assign({
            width: "100%",
            position: "absolute",
            zIndex: "dropdown",
            pt: "spacing-2",
            pb: "spacing-2",
            top: "100%",
            left: 0,
            border: "1px solid",
            borderColor: "field-stroke",
            borderRadius: "radius-2",
            backgroundColor: "field-surface",
            boxShadow: "shadow-100",
            transition: "transition-color-medium"
        }, sx)
    }, dropdownOptions.length > 0 ? $76612bd33eedf3cc$var$react_1.default.createElement($2wkl1.Box, {
        ref: dropdownRef,
        as: "ul",
        sx: {
            listStyle: "none",
            overflowY: "auto"
        },
        onScroll: handleScroll
    }, $76612bd33eedf3cc$var$react_1.default.createElement($76612bd33eedf3cc$var$DropdownItemList, {
        dropdownOptions: dropdownOptions,
        focusedIdx: focusedIdx
    })) : showNoResults && $76612bd33eedf3cc$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            px: "spacing-4",
            py: "spacing-5",
            textAlign: "center"
        }
    }, $76612bd33eedf3cc$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-1-regular",
        sx: {
            color: "text-incidental"
        }
    }, noResultsMessage)));
};
module.exports.DropdownMenu = $76612bd33eedf3cc$var$DropdownMenu;

});
parcelRegister("k1f45", function(module, exports) {
"use strict";
var $e92f963d12d7e4fc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DropdownItem = void 0;

const $e92f963d12d7e4fc$var$react_1 = $e92f963d12d7e4fc$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $e92f963d12d7e4fc$var$renderIcon = (icon)=>{
    if (!icon) return null;
    if (icon.type === "flag") return $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.FlagIcon, {
        flag: icon.name
    });
    return $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Icon, {
        icon: icon.name
    });
};
const $e92f963d12d7e4fc$var$DropdownItem = ({ option: option, isFocused: isFocused, idx: idx })=>{
    const optionRef = $e92f963d12d7e4fc$var$react_1.default.useRef(null);
    // If options is focused but hidden by overflow,
    // scroll the dropdown to show the focused option
    $e92f963d12d7e4fc$var$react_1.default.useEffect(()=>{
        if (isFocused && optionRef.current) optionRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        isFocused
    ]);
    const { label: label, icon: icon } = option;
    const dropdownItemContainerStyles = Object.assign({
        cursor: "pointer",
        width: "100%",
        px: "spacing-5",
        py: "spacing-3",
        transition: "transition-color-medium",
        ":hover": {
            backgroundColor: "field-surface-highlight"
        }
    }, isFocused && {
        backgroundColor: "field-surface-highlight"
    });
    const dropdownItemStyles = {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        px: "spacing-4",
        py: "spacing-2"
    };
    return $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Box, {
        as: "li",
        ref: optionRef
    }, $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Box, {
        as: "button",
        "data-element-idx": idx,
        "aria-selected": isFocused,
        role: "option",
        tabIndex: -1,
        sx: dropdownItemContainerStyles
    }, $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Box, {
        sx: dropdownItemStyles
    }, $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Text, {
        variant: "body-1-regular",
        sx: {
            color: "field-text-primary"
        }
    }, label), $e92f963d12d7e4fc$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            flexShrink: 0,
            display: "flex",
            alignItems: "center"
        }
    }, $e92f963d12d7e4fc$var$renderIcon(icon)))));
};
module.exports.DropdownItem = $e92f963d12d7e4fc$var$DropdownItem;

});

parcelRegister("jfMgS", function(module, exports) {
"use strict";
var $e044dcab3f9039fa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDynamicDropdownHeight = void 0;

const $e044dcab3f9039fa$var$react_1 = $e044dcab3f9039fa$var$__importDefault((parcelRequire("acw62")));
const $e044dcab3f9039fa$var$getHTMLElementHeight = (element)=>{
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const computedStyle = getComputedStyle(element);
    const marginTop = parseFloat(computedStyle.marginTop) || 0;
    const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
    return rect.height + marginTop + marginBottom;
};
function $e044dcab3f9039fa$var$useDynamicDropdownHeight({ dropdownOptions: dropdownOptions, dropdownRef: dropdownRef, optionDisplayCount: optionDisplayCount, showNoResults: showNoResults }) {
    const hasScroll = !!optionDisplayCount && dropdownOptions.length > optionDisplayCount;
    // Use optionDisplayCount to restrict the height of the dropdown.
    // If the number of options exceeds optionDisplayCount, the dropdown
    // will have a scrollbar.
    $e044dcab3f9039fa$var$react_1.default.useEffect(()=>{
        if (!dropdownRef.current) return;
        if (!optionDisplayCount || dropdownOptions.length === 0 || showNoResults) {
            dropdownRef.current.style.setProperty("max-height", null);
            return;
        }
        const firstOption = dropdownRef.current.querySelector("li:first-of-type");
        const firstOptionHeight = firstOption ? $e044dcab3f9039fa$var$getHTMLElementHeight(firstOption) : 0;
        const lastOption = dropdownRef.current.querySelector("li:last-of-type");
        const lastOptionHeight = lastOption ? $e044dcab3f9039fa$var$getHTMLElementHeight(lastOption) : 0;
        const option = dropdownRef.current.querySelector("li:not(:first-of-type):not(:last-of-type)");
        const optionHeight = option ? $e044dcab3f9039fa$var$getHTMLElementHeight(option) : 0;
        const displayCount = Math.min(dropdownOptions.length, optionDisplayCount);
        let dropdownHeight = 0;
        if (displayCount === 1) dropdownHeight = firstOptionHeight;
        else {
            const totalOptionHeight = optionHeight * (optionDisplayCount - 2); // excluding first and last option
            dropdownHeight = firstOptionHeight + lastOptionHeight + totalOptionHeight;
        }
        dropdownRef.current.style.setProperty("max-height", `${dropdownHeight}px`);
    }, [
        dropdownRef,
        optionDisplayCount,
        dropdownOptions,
        showNoResults
    ]);
    const handleScroll = $e044dcab3f9039fa$var$react_1.default.useCallback(()=>{
        if (!dropdownRef.current) return;
    }, [
        dropdownRef
    ]);
    // For the initial render, check if the dropdown has overflow
    // and show bottom overlay if needed
    $e044dcab3f9039fa$var$react_1.default.useEffect(()=>{
        handleScroll();
    }, [
        handleScroll
    ]);
    return {
        handleScroll: handleScroll,
        hasScroll: hasScroll
    };
}
module.exports.useDynamicDropdownHeight = $e044dcab3f9039fa$var$useDynamicDropdownHeight;

});


parcelRegister("ewdTS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useKeyboardEvents = module.exports.useDynamicDropdownHeight = module.exports.useDropdownMenu = void 0;

var $6d8fa = parcelRequire("6d8fa");
Object.defineProperty(module.exports, "useDropdownMenu", {
    enumerable: true,
    get: function() {
        return $6d8fa.useDropdownMenu;
    }
});

var $jfMgS = parcelRequire("jfMgS");
Object.defineProperty(module.exports, "useDynamicDropdownHeight", {
    enumerable: true,
    get: function() {
        return $jfMgS.useDynamicDropdownHeight;
    }
});

var $4kr4Y = parcelRequire("4kr4Y");
Object.defineProperty(module.exports, "useKeyboardEvents", {
    enumerable: true,
    get: function() {
        return $4kr4Y.useKeyboardEvents;
    }
});

});
parcelRegister("6d8fa", function(module, exports) {
"use strict";
var $485a59f693b49bbc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDropdownMenu = void 0;

const $485a59f693b49bbc$var$react_1 = $485a59f693b49bbc$var$__importDefault((parcelRequire("acw62")));

var $4kr4Y = parcelRequire("4kr4Y");
function $485a59f693b49bbc$var$useDropdownMenu(props) {
    const { isSelect: isSelect, dropdownOptions: dropdownOptions = [], onSelectOption: onSelectOption = ()=>{}, onEnter: onEnter, isFocused: isFocused } = props;
    const inputRef = $485a59f693b49bbc$var$react_1.default.useRef(null);
    // Id for aria-controls
    const dropdownId = $485a59f693b49bbc$var$react_1.default.useId();
    const blurInput = $485a59f693b49bbc$var$react_1.default.useCallback(()=>{
        var _a;
        (_a = inputRef.current) === null || _a === void 0 || _a.blur();
    }, []);
    const onSelectCallback = $485a59f693b49bbc$var$react_1.default.useCallback((option)=>{
        onSelectOption(option);
        blurInput();
    }, [
        onSelectOption,
        blurInput
    ]);
    const { focusedOptionIdx: focusedOptionIdx, handleKeyDown: handleKeyDown, iconButtonRef: iconButtonRef, handleCompositionStart: handleCompositionStart, handleCompositionEnd: handleCompositionEnd } = (0, $4kr4Y.useKeyboardEvents)({
        dropdownOptions: dropdownOptions,
        onEnter: onEnter,
        onSelectCallback: onSelectCallback,
        blurInput: blurInput
    });
    const showDropdown = isSelect && isFocused;
    const handleClickOption = $485a59f693b49bbc$var$react_1.default.useCallback((event)=>{
        const { relatedTarget: relatedTarget } = event;
        if (relatedTarget && relatedTarget instanceof HTMLElement) {
            if (relatedTarget.getAttribute("role") === "option") {
                const { elementIdx: elementIdx } = relatedTarget.dataset;
                const selectedOption = dropdownOptions[Number(elementIdx)];
                if (selectedOption) onSelectCallback(selectedOption);
            }
        }
    }, [
        dropdownOptions,
        onSelectCallback
    ]);
    const ariaPropsForDropdown = {
        "aria-expanded": isSelect ? showDropdown : undefined,
        "aria-haspopup": isSelect ? "listbox" : false,
        "aria-controls": isSelect ? dropdownId : undefined,
        role: isSelect ? "combobox" : undefined
    };
    return {
        ariaPropsForDropdown: ariaPropsForDropdown,
        focusedOptionIdx: focusedOptionIdx,
        handleClickOption: handleClickOption,
        handleKeyDown: handleKeyDown,
        iconButtonRef: iconButtonRef,
        inputRef: inputRef,
        showDropdown: showDropdown,
        handleCompositionStart: handleCompositionStart,
        handleCompositionEnd: handleCompositionEnd
    };
}
module.exports.useDropdownMenu = $485a59f693b49bbc$var$useDropdownMenu;

});
parcelRegister("4kr4Y", function(module, exports) {
"use strict";
var $326e090759a6328c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useKeyboardEvents = void 0;

const $326e090759a6328c$var$react_1 = $326e090759a6328c$var$__importDefault((parcelRequire("acw62")));
function $326e090759a6328c$var$useKeyboardEvents({ dropdownOptions: dropdownOptions, onEnter: onEnter, onSelectCallback: onSelectCallback, blurInput: blurInput }) {
    const iconButtonRef = $326e090759a6328c$var$react_1.default.useRef(null);
    const [focusedOptionIdx, setFocusedIdx] = $326e090759a6328c$var$react_1.default.useState(null);
    const [composing, setComposing] = $326e090759a6328c$var$react_1.default.useState(false);
    const handleCompositionStart = ()=>setComposing(true);
    const handleCompositionEnd = ()=>setComposing(false);
    const handleKeyDown = $326e090759a6328c$var$react_1.default.useCallback((e)=>{
        // composing events happen when users are typing in non-latin characters
        // skip following events when still in composing state
        if (composing) return;
        switch(e.key){
            case "ArrowDown":
            case "ArrowUp":
                if (!dropdownOptions || dropdownOptions.length === 0) break;
                e.preventDefault();
                if (focusedOptionIdx === null) {
                    setFocusedIdx(0);
                    break;
                }
                const isArrowingDown = e.key === "ArrowDown";
                const nextIdx = isArrowingDown ? focusedOptionIdx + 1 : focusedOptionIdx - 1;
                const lastIdx = dropdownOptions.length - 1;
                if (nextIdx < 0) setFocusedIdx(lastIdx);
                else if (nextIdx > lastIdx) setFocusedIdx(0);
                else setFocusedIdx(nextIdx);
                break;
            case "Enter":
                // If no option is focused, call the onClick function of the icon button
                // This equates to a "submit" action
                if (focusedOptionIdx === null) {
                    if (onEnter) onEnter();
                    blurInput();
                    break;
                }
                e.preventDefault();
                const focusedOption = dropdownOptions[focusedOptionIdx];
                if (onSelectCallback && focusedOption) onSelectCallback(focusedOption);
                setFocusedIdx(null);
                break;
            case "Escape":
                setFocusedIdx(null);
                blurInput();
                break;
            default:
                break;
        }
    }, [
        focusedOptionIdx,
        dropdownOptions,
        onSelectCallback,
        blurInput,
        onEnter,
        composing
    ]);
    return {
        focusedOptionIdx: focusedOptionIdx,
        handleKeyDown: handleKeyDown,
        iconButtonRef: iconButtonRef,
        handleCompositionStart: handleCompositionStart,
        handleCompositionEnd: handleCompositionEnd
    };
}
module.exports.useKeyboardEvents = $326e090759a6328c$var$useKeyboardEvents;

});







parcelRegister("giAOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SidePanel = void 0;

var $h7kBK = parcelRequire("h7kBK");
Object.defineProperty(module.exports, "SidePanel", {
    enumerable: true,
    get: function() {
        return $h7kBK.SidePanel;
    }
});

});
parcelRegister("h7kBK", function(module, exports) {
"use client";
"use strict";
var $c7631360adec785a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SidePanel = void 0;

const $c7631360adec785a$var$react_1 = $c7631360adec785a$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $c4avu = parcelRequire("c4avu");
const $c7631360adec785a$var$SidePanel = (props)=>{
    const { children: children, position: position = "end", title: title, visible: visibleProp, onDismiss: onDismiss } = props;
    const [, setForceUpdate] = $c7631360adec785a$var$react_1.default.useState(0);
    const [hasTransitionedOut, setHasTransitionedOut] = $c7631360adec785a$var$react_1.default.useState(true);
    const [visible, visibleSet] = $c7631360adec785a$var$react_1.default.useState(visibleProp);
    const visiblePropPrev = $c7631360adec785a$var$react_1.default.useRef(visibleProp);
    const transitionDelayTimeout = $c7631360adec785a$var$react_1.default.useRef();
    const handleTransitionEnd = $c7631360adec785a$var$react_1.default.useCallback((e)=>{
        if (!visible && e.target === e.currentTarget) setHasTransitionedOut(true);
    }, [
        visible
    ]);
    $c7631360adec785a$var$react_1.default.useEffect(()=>{
        // Force a render on mount so the element exists and
        // transitions start working
        setForceUpdate(1);
    }, []);
    $c7631360adec785a$var$react_1.default.useEffect(()=>{
        if (visible && hasTransitionedOut) setHasTransitionedOut(false);
    }, [
        hasTransitionedOut,
        visible
    ]);
    $c7631360adec785a$var$react_1.default.useEffect(()=>{
        const isShowing = visiblePropPrev.current;
        clearTimeout(transitionDelayTimeout.current);
        // If it's showing, wait a moment so the animation in can be seen
        if (isShowing) transitionDelayTimeout.current = setTimeout(()=>{
            visibleSet(visibleProp);
        }, 100);
        else visibleSet(visibleProp);
        return ()=>{
            clearTimeout(transitionDelayTimeout.current);
        };
    }, [
        visibleProp
    ]);
    visiblePropPrev.current = visibleProp;
    return $c7631360adec785a$var$react_1.default.createElement($c4avu.Overlay, {
        visible: visibleProp,
        onDismiss: onDismiss
    }, $c7631360adec785a$var$react_1.default.createElement($2wkl1.Box, {
        "aria-hidden": !visible,
        "data-testid": "side-panel",
        sx: {
            height: 0,
            left: 0,
            overflow: "visible",
            position: "fixed",
            top: 0,
            width: "100%"
        }
    }, $c7631360adec785a$var$react_1.default.createElement($2wkl1.Grid, {
        initial: true,
        sx: {
            height: 0,
            overflow: "visible"
        },
        variant: "navigation"
    }, $c7631360adec785a$var$react_1.default.createElement($2wkl1.GridColumn, {
        fillEnd: position === "end",
        fillGapEnd: position === "end",
        fillGapStart: true,
        fillStart: position === "start",
        onTransitionEnd: handleTransitionEnd,
        push: position === "end" ? [
            0,
            4,
            8
        ] : [
            0,
            0,
            0
        ],
        size: [
            4,
            4,
            4
        ],
        sx: {
            bg: "surface-neutral-default",
            boxShadow: "shadow-100",
            height: hasTransitionedOut ? 0 : "100vh",
            opacity: !visible ? 0 : 1,
            transition: [
                "transition-ease-out-medium",
                null,
                "transition-ease-out-fast"
            ],
            transform: !visible ? `translateX(${position === "end" ? "" : "-"}150px)` : "none"
        }
    }, hasTransitionedOut ? null : $c7631360adec785a$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            maxHeight: "100vh",
            pt: "spacing-5",
            px: "spacing-5"
        }
    }, $c7631360adec785a$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            justifyContent: title ? "space-between" : "end",
            pb: "spacing-3",
            width: "100%"
        }
    }, title && $c7631360adec785a$var$react_1.default.createElement($i5SnA.Text, {
        variant: "title-2-medium"
    }, title), $c7631360adec785a$var$react_1.default.createElement($2wkl1.Target, {
        autoFocus: true,
        "data-testid": "side-panel-dismiss",
        onClick: onDismiss,
        "aria-label": "close side panel"
    }, $c7631360adec785a$var$react_1.default.createElement($2wkl1.Icon, {
        icon: "x",
        size: "sm",
        color: "control-enabled"
    }))), $c7631360adec785a$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "auto",
            WebkitOverflowScrolling: "touch"
        }
    }, children))))));
};
module.exports.SidePanel = $c7631360adec785a$var$SidePanel;

});


parcelRegister("8NhPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Slider = void 0;

var $aIKrv = parcelRequire("aIKrv");
Object.defineProperty(module.exports, "Slider", {
    enumerable: true,
    get: function() {
        return $aIKrv.Slider;
    }
});

});
parcelRegister("aIKrv", function(module, exports) {
"use client";
"use strict";
var $7ce209faf95d0a79$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Slider = void 0;

const $7ce209faf95d0a79$var$react_1 = $7ce209faf95d0a79$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $fSdep = parcelRequire("fSdep");

var $21xHX = parcelRequire("21xHX");

var $4c2XY = parcelRequire("4c2XY");

var $5N7zb = parcelRequire("5N7zb");
const $7ce209faf95d0a79$var$Slider = ({ disabled: disabled = false, disableSwap: disableSwap = false, label: label, marks: marks = false, max: max = 100, min: min = 0, onChange: onChange, step: step = 1, value: value, variant: variant = "continuous" })=>{
    const slider = $7ce209faf95d0a79$var$react_1.default.useMemo(()=>({
            disabled: disabled,
            max: max,
            min: min,
            step: Math.max(0.00001, step),
            value: (0, $fSdep.getSortedValue)(Array.isArray(value) ? value : [
                min,
                value
            ]).map((val)=>Math.max(Math.min(val, max), min)),
            variant: variant
        }), [
        disabled,
        max,
        min,
        step,
        value,
        variant
    ]);
    const [dragging, draggingSet] = $7ce209faf95d0a79$var$react_1.default.useState(false);
    const fillBackgroundColor = $7ce209faf95d0a79$var$react_1.default.useMemo(()=>{
        if (disabled) return "slider-surface-disabled";
        else if (dragging) return "slider-surface-selected-click";
        else return "slider-surface-selected-enabled";
    }, [
        disabled,
        dragging
    ]);
    const center = min + (max - min) / 2;
    const dragDirection = $7ce209faf95d0a79$var$react_1.default.useRef("end");
    const dragPosStart = $7ce209faf95d0a79$var$react_1.default.useRef(0);
    const fillClassName = `slider${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const labelColor = disabled ? "input-text-disabled" : "input-text";
    const labelId = `slider${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const labelStyles = {
        display: "flex",
        fontSize: "font-size-4",
        lineHeight: "leading-2"
    };
    const stepArray = new Array(Math.round((max - min) / slider.step) + 1).fill(null);
    const stepDecimalPlaces = (0, $fSdep.getDecimalPlaces)(slider.step);
    const trackRef = $7ce209faf95d0a79$var$react_1.default.useRef(null);
    const handleMove = $7ce209faf95d0a79$var$react_1.default.useCallback((clientX)=>{
        if (!trackRef.current) return;
        const { left: left, width: width } = trackRef.current.getBoundingClientRect();
        const pointerXChange = clientX - dragPosStart.current;
        const percentX = (dragPosStart.current + pointerXChange - left) / width;
        if (slider.variant === "range") {
            if (dragDirection.current === "end") {
                const valueNext = (0, $fSdep.getSliderValueFromPercent)(percentX, slider.max, disableSwap ? slider.value[0] : slider.min, slider);
                onChange((0, $fSdep.getSortedValue)([
                    slider.value[0],
                    valueNext
                ]));
            } else {
                const valueNext = (0, $fSdep.getSliderValueFromPercent)(percentX, disableSwap ? slider.value[1] : slider.max, slider.min, slider);
                onChange((0, $fSdep.getSortedValue)([
                    valueNext,
                    slider.value[1]
                ]));
            }
        } else {
            const valueNext = (0, $fSdep.getSliderValueFromPercent)(percentX, slider.max, slider.min, slider);
            onChange(valueNext);
        }
    }, [
        disableSwap,
        onChange,
        slider
    ]);
    const handleWindowMouseMove = $7ce209faf95d0a79$var$react_1.default.useCallback((e)=>handleMove(e.clientX), [
        handleMove
    ]);
    const handleWindowTouchMove = $7ce209faf95d0a79$var$react_1.default.useCallback((e)=>{
        if (e.touches[0]) {
            e.preventDefault();
            handleMove(e.touches[0].clientX);
        }
    }, [
        handleMove
    ]);
    const handleKeyDown = $7ce209faf95d0a79$var$react_1.default.useCallback((e)=>{
        const valueIndex = slider.variant === "range" && dragDirection.current === "start" ? 0 : 1;
        let valueNext = null;
        switch(e.key){
            case "ArrowRight":
            case "ArrowUp":
                valueNext = (0, $fSdep.getSliderValue)(slider.value[valueIndex] + slider.step, slider.variant === "range" && dragDirection.current === "start" && disableSwap ? slider.value[1] : slider.max, slider.min, slider);
                break;
            case "ArrowLeft":
            case "ArrowDown":
                valueNext = (0, $fSdep.getSliderValue)(slider.value[valueIndex] - slider.step, slider.max, slider.variant === "range" && dragDirection.current === "end" && disableSwap ? slider.value[0] : slider.min, slider);
                break;
            case "Home":
                valueNext = slider.min;
                break;
            case "End":
                valueNext = slider.max;
                break;
        }
        if (valueNext === null) return;
        if (slider.variant === "range") {
            if (dragDirection.current === "end") onChange((0, $fSdep.getSortedValue)([
                slider.value[0],
                valueNext
            ]));
            else onChange((0, $fSdep.getSortedValue)([
                valueNext,
                slider.value[1]
            ]));
        } else onChange(valueNext);
    }, [
        disableSwap,
        onChange,
        slider
    ]);
    const handlePointerDown = $7ce209faf95d0a79$var$react_1.default.useCallback((e)=>{
        if (e.button !== 0 || disabled || !trackRef.current) return;
        const { left: left, width: width } = trackRef.current.getBoundingClientRect();
        const percentX = (e.clientX - left) / width;
        const valueNext = (0, $fSdep.getSliderValueFromPercent)(percentX, slider.max, slider.min, slider);
        // Determine which handle/direction to drag based on whichever handle the
        // pointer event was closest to
        dragDirection.current = valueNext < slider.value[0] + (slider.value[1] - slider.value[0]) / 2 ? "start" : "end";
        dragPosStart.current = e.clientX;
        const cancelDrag = ()=>{
            draggingSet(false);
            window.removeEventListener("mousemove", handleWindowMouseMove);
            window.removeEventListener("touchmove", handleWindowTouchMove);
        };
        draggingSet(true);
        handleMove(e.clientX);
        window.addEventListener("mousemove", handleWindowMouseMove);
        window.addEventListener("touchmove", handleWindowTouchMove, {
            passive: false
        });
        window.addEventListener("mouseup", cancelDrag);
        window.addEventListener("touchend", cancelDrag);
    }, [
        disabled,
        handleWindowMouseMove,
        handleWindowTouchMove,
        handleMove,
        slider
    ]);
    return $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            color: labelColor,
            display: "flex",
            flexDirection: "column",
            [`.${fillClassName}`]: {
                backgroundColor: fillBackgroundColor,
                transition: "transition-color-medium"
            },
            [`:hover .${fillClassName}`]: disabled ? {} : {
                backgroundColor: dragging ? "slider-surface-selected-click" : "slider-surface-selected-hover"
            }
        }
    }, variant === "range" && $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        id: labelId,
        sx: Object.assign(Object.assign({}, labelStyles), {
            flexDirection: "column"
        })
    }, label && $7ce209faf95d0a79$var$react_1.default.createElement($i5SnA.Text, null, label), $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            paddingBottom: 1
        }
    }, $7ce209faf95d0a79$var$react_1.default.createElement($i5SnA.Text, null, slider.value[0].toFixed(stepDecimalPlaces)), $7ce209faf95d0a79$var$react_1.default.createElement($i5SnA.Text, {
        sx: {
            marginInlineStart: "auto"
        }
    }, slider.value[1].toFixed(stepDecimalPlaces)))), variant !== "range" && $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        as: "label",
        id: labelId,
        sx: labelStyles
    }, label && $7ce209faf95d0a79$var$react_1.default.createElement($i5SnA.Text, null, label), $7ce209faf95d0a79$var$react_1.default.createElement($i5SnA.Text, {
        sx: {
            marginInlineStart: "auto"
        }
    }, slider.value[1].toFixed(stepDecimalPlaces))), $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            position: "relative"
        }
    }, $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        "aria-hidden": true,
        as: "button",
        onKeyDown: handleKeyDown,
        onPointerDown: handlePointerDown,
        ref: trackRef,
        sx: {
            containerType: "size",
            cursor: disabled ? "not-allowed" : "pointer",
            height: 8,
            position: "relative",
            userSelect: false,
            width: "100%"
        },
        tabIndex: -1
    }, variant === "center-set" && $7ce209faf95d0a79$var$react_1.default.createElement($7ce209faf95d0a79$var$react_1.default.Fragment, null, $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        leaveSpaceAtEnd: slider.value[1] <= center ? true : false,
        roundStart: true,
        slider: slider,
        trackEnd: Math.min(slider.value[1], center),
        trackStart: min
    }), $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        leaveSpaceAtStart: slider.value[1] >= center ? true : false,
        roundEnd: true,
        slider: slider,
        trackEnd: max,
        trackStart: Math.max(slider.value[1], center)
    }), $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        fillClassName: fillClassName,
        leaveSpaceAtEnd: slider.value[1] >= center ? true : false,
        leaveSpaceAtStart: slider.value[1] <= center ? true : false,
        slider: slider,
        trackEnd: slider.value[1] > center ? slider.value[1] : center,
        trackStart: slider.value[1] < center ? slider.value[1] : center
    })), variant === "continuous" && $7ce209faf95d0a79$var$react_1.default.createElement($7ce209faf95d0a79$var$react_1.default.Fragment, null, $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        fillClassName: fillClassName,
        leaveSpaceAtEnd: true,
        roundStart: true,
        slider: slider,
        trackEnd: slider.value[1],
        trackStart: min
    }), $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        leaveSpaceAtStart: true,
        roundEnd: true,
        slider: slider,
        trackEnd: max,
        trackStart: slider.value[1]
    })), variant === "range" && $7ce209faf95d0a79$var$react_1.default.createElement($7ce209faf95d0a79$var$react_1.default.Fragment, null, $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        leaveSpaceAtEnd: true,
        roundStart: true,
        slider: slider,
        trackEnd: slider.value[0],
        trackStart: min
    }), $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        fillClassName: fillClassName,
        leaveSpaceAtEnd: true,
        leaveSpaceAtStart: true,
        slider: slider,
        trackEnd: slider.value[1],
        trackStart: slider.value[0]
    }), $7ce209faf95d0a79$var$react_1.default.createElement($5N7zb.SliderTrack, {
        leaveSpaceAtStart: true,
        roundEnd: true,
        slider: slider,
        trackEnd: max,
        trackStart: slider.value[1]
    })), marks && $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: {
            display: "block",
            left: 0,
            position: "absolute",
            top: 0,
            width: "100%"
        }
    }, stepArray.map((_step, index)=>$7ce209faf95d0a79$var$react_1.default.createElement($4c2XY.SliderMarker, {
            key: index,
            markerIndex: index,
            markersTotal: stepArray.length,
            slider: slider
        })))), $7ce209faf95d0a79$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            containerType: "size",
            left: 0,
            position: "absolute",
            top: 0,
            width: "100%"
        }
    }, variant === "range" && $7ce209faf95d0a79$var$react_1.default.createElement($7ce209faf95d0a79$var$react_1.default.Fragment, null, $7ce209faf95d0a79$var$react_1.default.createElement($21xHX.SliderHandle, {
        fillClassName: fillClassName,
        labelId: labelId,
        onFocus: ()=>{
            dragDirection.current = "start";
        },
        onKeyDown: handleKeyDown,
        onPointerDown: handlePointerDown,
        slider: slider,
        value: slider.value[0]
    }), $7ce209faf95d0a79$var$react_1.default.createElement($21xHX.SliderHandle, {
        fillClassName: fillClassName,
        labelId: labelId,
        onFocus: ()=>{
            dragDirection.current = "end";
        },
        onKeyDown: handleKeyDown,
        onPointerDown: handlePointerDown,
        slider: slider,
        value: slider.value[1]
    })), variant !== "range" && $7ce209faf95d0a79$var$react_1.default.createElement($21xHX.SliderHandle, {
        fillClassName: fillClassName,
        labelId: labelId,
        onFocus: ()=>{
            dragDirection.current = "end";
        },
        onKeyDown: handleKeyDown,
        onPointerDown: handlePointerDown,
        slider: slider,
        value: slider.value[1]
    }))));
};
module.exports.Slider = $7ce209faf95d0a79$var$Slider;

});
parcelRegister("fSdep", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSortedValue = module.exports.getSliderValueFromPercent = module.exports.getSliderValue = module.exports.getIsMarkerInRange = module.exports.getDecimalPlaces = void 0;
const $b8e6299fcac255df$var$getDecimalPlaces = (num)=>{
    var _a;
    const numStr = num.toString();
    if (numStr.includes(".")) return (_a = numStr.split(".")[1]) === null || _a === void 0 ? void 0 : _a.length;
    return 0;
};
module.exports.getDecimalPlaces = $b8e6299fcac255df$var$getDecimalPlaces;
const $b8e6299fcac255df$var$getIsMarkerInRange = (value, min, max, step, stepIndex)=>{
    const markerPosition = step * stepIndex + min;
    if (stepIndex < 0 || markerPosition > max) return false;
    return markerPosition >= value[0] && markerPosition <= value[1];
};
module.exports.getIsMarkerInRange = $b8e6299fcac255df$var$getIsMarkerInRange;
const $b8e6299fcac255df$var$getSliderValue = (value, max, min, slider)=>{
    const valueBounded = Math.max(min, Math.min(max, value));
    const valueStepped = Math.round(valueBounded / slider.step) * slider.step;
    const stepDecimalPlaces = (0, module.exports.getDecimalPlaces)(slider.step);
    const valueDecimaled = valueStepped.toFixed(stepDecimalPlaces);
    return Number(valueDecimaled);
};
module.exports.getSliderValue = $b8e6299fcac255df$var$getSliderValue;
const $b8e6299fcac255df$var$getSliderValueFromPercent = (percent, max, min, slider)=>{
    const value = percent * (slider.max - slider.min) + slider.min;
    return Number((0, module.exports.getSliderValue)(value, max, min, slider));
};
module.exports.getSliderValueFromPercent = $b8e6299fcac255df$var$getSliderValueFromPercent;
const $b8e6299fcac255df$var$getSortedValue = (value)=>{
    return value.sort((prev, next)=>prev - next);
};
module.exports.getSortedValue = $b8e6299fcac255df$var$getSortedValue;

});

parcelRegister("21xHX", function(module, exports) {
"use client";
"use strict";
var $1795d277ed5ade9a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SliderHandle = void 0;

const $1795d277ed5ade9a$var$react_1 = $1795d277ed5ade9a$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $1795d277ed5ade9a$var$SliderHandle = ({ fillClassName: fillClassName, labelId: labelId, onFocus: onFocus, onKeyDown: onKeyDown, onPointerDown: onPointerDown, slider: slider, value: value })=>{
    const length = slider.max - slider.min;
    return $1795d277ed5ade9a$var$react_1.default.createElement($2wkl1.Box, {
        "aria-labelledby": labelId,
        "aria-valuemax": slider.max,
        "aria-valuemin": slider.min,
        "aria-valuenow": value,
        as: "button",
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onPointerDown: onPointerDown,
        role: "slider",
        sx: {
            cursor: slider.disabled ? "not-allowed" : "pointer",
            display: "block",
            height: 8,
            left: 0,
            marginInlineStart: -3,
            position: "absolute",
            top: 0,
            transform: ({ sizes: sizes })=>`translateX(min(max(${(value - slider.min) / length * 100}cqw, ${sizes[1] / 2}px), calc(100cqw - ${sizes[1] / 2}px)))`,
            userSelect: false,
            width: 6,
            [`:focus-visible .${fillClassName}`]: slider.disabled ? {} : {
                outline: "2px solid",
                outlineColor: "focus",
                outlineOffset: "2px"
            }
        }
    }, $1795d277ed5ade9a$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        className: fillClassName,
        sx: {
            borderRadius: "radius-1",
            display: "block",
            height: "100%",
            left: "50%",
            marginInlineStart: ({ sizes: sizes })=>`-${sizes[1] / 2}px`,
            position: "relative",
            width: 1
        }
    }));
};
module.exports.SliderHandle = $1795d277ed5ade9a$var$SliderHandle;

});

parcelRegister("4c2XY", function(module, exports) {
"use client";
"use strict";
var $30da957668630548$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SliderMarker = void 0;

const $30da957668630548$var$react_1 = $30da957668630548$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $fSdep = parcelRequire("fSdep");
const $30da957668630548$var$SliderMarker = ({ markerIndex: markerIndex, markersTotal: markersTotal, slider: slider })=>{
    const left = $30da957668630548$var$react_1.default.useCallback(({ sizes: sizes })=>{
        if (markerIndex === 0) return `${sizes[1] / 2}px`;
        else if (markerIndex === markersTotal - 1) return `calc(${markerIndex / (markersTotal - 1) * 100}% - ${sizes[1] + sizes[1] / 2}px)`;
        else return `calc(${markerIndex / (markersTotal - 1) * 100}% - ${sizes[1] / 2}px)`;
    }, [
        markerIndex,
        markersTotal
    ]);
    return $30da957668630548$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: {
            backgroundColor: (0, $fSdep.getIsMarkerInRange)(slider.value, slider.min, slider.max, slider.step, markerIndex) ? "slider-onsurface-selected" : "slider-onsurface-notselected",
            borderRadius: "radius-1",
            display: "block",
            height: 1,
            left: left,
            position: "absolute",
            top: ({ sizes: sizes })=>`${sizes[3] + sizes[1] / 2}px`,
            width: 1
        }
    });
};
module.exports.SliderMarker = $30da957668630548$var$SliderMarker;

});

parcelRegister("5N7zb", function(module, exports) {
"use client";
"use strict";
var $437765e3213ad137$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SliderTrack = void 0;

const $437765e3213ad137$var$react_1 = $437765e3213ad137$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $437765e3213ad137$var$SliderTrack = ({ fillClassName: fillClassName, leaveSpaceAtEnd: leaveSpaceAtEnd, leaveSpaceAtStart: leaveSpaceAtStart, roundEnd: roundEnd = false, roundStart: roundStart = false, slider: slider, trackEnd: trackEnd, trackStart: trackStart })=>{
    const length = slider.max - slider.min;
    const left = $437765e3213ad137$var$react_1.default.useCallback(({ sizes: sizes })=>{
        if (leaveSpaceAtStart) return `calc(${(trackStart - slider.min) / length * 100}% + ${sizes[1] + sizes[1] / 2}px)`;
        else return `${(trackStart - slider.min) / length * 100}%`;
    }, [
        leaveSpaceAtStart,
        length,
        slider,
        trackStart
    ]);
    const width = $437765e3213ad137$var$react_1.default.useCallback(({ sizes: sizes })=>{
        const trackLength = trackEnd - trackStart;
        if (leaveSpaceAtEnd && leaveSpaceAtStart) return `calc(${trackLength / length * 100}cqw - ${sizes[3]}px)`;
        else if (leaveSpaceAtEnd || leaveSpaceAtStart) return `calc(${trackLength / length * 100}cqw - ${sizes[1] + sizes[1] / 2}px)`;
        else return `${trackLength / length * 100}cqw`;
    }, [
        leaveSpaceAtEnd,
        leaveSpaceAtStart,
        length,
        trackEnd,
        trackStart
    ]);
    return $437765e3213ad137$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        className: fillClassName,
        sx: {
            backgroundColor: fillClassName ? undefined : "slider-surface-not-selected",
            borderEndEndRadius: roundEnd ? "radius-1" : null,
            borderEndStartRadius: roundStart ? "radius-1" : null,
            borderStartEndRadius: roundEnd ? "radius-1" : null,
            borderStartStartRadius: roundStart ? "radius-1" : null,
            display: "block",
            height: 2,
            left: left,
            position: "absolute",
            top: 3,
            width: width
        }
    });
};
module.exports.SliderTrack = $437765e3213ad137$var$SliderTrack;

});



parcelRegister("aJH8Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $bq4Io = parcelRequire("bq4Io");
Object.defineProperty(module.exports, "Spinner", {
    enumerable: true,
    get: function() {
        return $bq4Io.Spinner;
    }
});

});
parcelRegister("bq4Io", function(module, exports) {
"use client";
"use strict";
var $8505c7bbb89dcbb1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $jjlaj = parcelRequire("jjlaj");

const $8505c7bbb89dcbb1$var$react_2 = $8505c7bbb89dcbb1$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $8505c7bbb89dcbb1$var$Spinner = (props)=>{
    const { size: size = "md" } = props;
    const { diameter: diameter, border: border } = $8505c7bbb89dcbb1$var$react_2.default.useMemo(()=>{
        switch(size){
            case "xxs":
                return {
                    diameter: "spacing-5",
                    border: "1px solid"
                };
            case "xs":
                return {
                    diameter: "spacing-6",
                    border: "1px solid"
                };
            case "sm":
                return {
                    diameter: "spacing-7",
                    border: "2px solid"
                };
            case "md":
                return {
                    diameter: "spacing-8",
                    border: "3px solid"
                };
            case "lg":
                return {
                    diameter: "spacing-9",
                    border: "3px solid"
                };
            case "xl":
                return {
                    diameter: "spacing-10",
                    border: "3px solid"
                };
        }
    }, [
        size
    ]);
    const spin = (0, $jjlaj.keyframes)({
        from: {
            transform: "rotate(0deg)"
        },
        to: {
            transform: "rotate(360deg)"
        }
    });
    const spinStyles = {
        border: border,
        borderTop: border,
        borderColor: "surface-brand-teriary",
        borderTopColor: "onSurface-brand-primary",
        borderRadius: "radius-round",
        width: diameter,
        height: diameter,
        transform: "rotate(360deg)",
        animation: `${spin} 2s linear infinite`
    };
    return $8505c7bbb89dcbb1$var$react_2.default.createElement($2wkl1.Box, {
        sx: Object.assign({}, spinStyles)
    });
};
module.exports.Spinner = $8505c7bbb89dcbb1$var$Spinner;

});


parcelRegister("fJI1A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Switch = void 0;

var $fyMJX = parcelRequire("fyMJX");
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $fyMJX.Switch;
    }
});

});
parcelRegister("fyMJX", function(module, exports) {
"use client";
"use strict";
var $b53fd6c7314d6e8f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Switch = void 0;

const $b53fd6c7314d6e8f$var$react_1 = $b53fd6c7314d6e8f$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");
const $b53fd6c7314d6e8f$var$Switch = ({ disabled: disabled = false, label: label, onClick: onClick, sx: sx, selected: selected = false })=>{
    const handleToggle = (event)=>{
        if (!disabled) onClick === null || onClick === void 0 || onClick(event);
    };
    const layoutStyles = {
        display: "inline-flex",
        justifyContent: "center",
        minHeight: "spacing-6"
    };
    const appearanceStyles = {
        borderRadius: "radius-round",
        borderStyle: "solid",
        borderWidth: 0,
        transition: "transition-color-medium",
        pointerEvents: disabled ? "none" : "auto"
    };
    const colorStyles = $b53fd6c7314d6e8f$var$react_1.default.useMemo(()=>({
            backgroundColor: selected ? "switch-surface-selected-enabled" : "switch-surface-notselected-enabled",
            ":hover": {
                backgroundColor: selected ? "switch-surface-selected-hover" : "switch-surface-notselected-hover"
            },
            ":active": {
                backgroundColor: selected ? "switch-surface-selected-click" : "switch-surface-notselected-click"
            },
            ":focus-visible": {
                outlineWidth: "spacing-1",
                outlineStyle: "solid",
                outlineColor: "focus",
                outlineOffset: "2px"
            }
        }), [
        selected
    ]);
    const knobContainerStyles = {
        alignItems: "center",
        justifyContent: "center",
        marginX: "spacing-1",
        minWidth: "spacing-8",
        position: "relative"
    };
    const knobStyles = {
        backgroundColor: "switch-onsurface-color",
        borderRadius: "radius-round",
        boxShadow: disabled ? "shadow-none" : "shadow-100",
        height: "spacing-5",
        left: selected ? "spacing-5" : "spacing-none",
        minWidth: "spacing-5",
        position: "absolute",
        top: "spacing-1",
        transition: ()=>"left 0.2s ease"
    };
    const disabledStyles = $b53fd6c7314d6e8f$var$react_1.default.useMemo(()=>{
        if (disabled) return {
            backgroundColor: "switch-surface-color-disabled",
            cursor: "not-allowed",
            ":hover": {
                backgroundColor: "switch-surface-color-disabled"
            },
            ":active": {
                backgroundColor: "switch-surface-color-disabled"
            }
        };
        return {};
    }, [
        disabled
    ]);
    const containerStyles = {
        alignItems: "center",
        color: disabled ? "text-input-disabled" : "text-default",
        display: "inline-flex",
        fontSize: "font-size-4",
        gap: "spacing-3",
        marginLeft: "spacing-2",
        cursor: disabled ? "not-allowed" : "pointer"
    };
    return $b53fd6c7314d6e8f$var$react_1.default.createElement($2wkl1.Box, {
        role: "group",
        sx: Object.assign(Object.assign({}, containerStyles), sx),
        onClick: handleToggle
    }, $b53fd6c7314d6e8f$var$react_1.default.createElement($2wkl1.Box, {
        as: "button",
        role: "switch",
        "aria-checked": selected,
        "aria-disabled": disabled,
        "aria-labelledby": label ? `${label.replace(/\s+/g, "-")}-label` : "switch-label",
        disabled: disabled,
        sx: Object.assign(Object.assign(Object.assign(Object.assign({}, layoutStyles), appearanceStyles), colorStyles), disabledStyles)
    }, $b53fd6c7314d6e8f$var$react_1.default.createElement($2wkl1.Box, {
        sx: knobContainerStyles
    }, $b53fd6c7314d6e8f$var$react_1.default.createElement($2wkl1.Box, {
        sx: knobStyles
    }))), label && $b53fd6c7314d6e8f$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        id: `${label.replace(/\s+/g, "-")}-label`,
        sx: {
            cursor: disabled ? "not-allowed" : "pointer"
        }
    }, label));
};
module.exports.Switch = $b53fd6c7314d6e8f$var$Switch;

});


parcelRegister("bbm15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableSelectionCell = module.exports.TableRow = module.exports.TableHeaderSelectionCell = module.exports.TableHeaderRow = module.exports.TableHeaderCell = module.exports.TableContext = module.exports.TableCell = module.exports.TableBody = module.exports.Table = void 0;

var $eTLPP = parcelRequire("eTLPP");
Object.defineProperty(module.exports, "Table", {
    enumerable: true,
    get: function() {
        return $eTLPP.Table;
    }
});
Object.defineProperty(module.exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableBody;
    }
});
Object.defineProperty(module.exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableCell;
    }
});
Object.defineProperty(module.exports, "TableContext", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableContext;
    }
});
Object.defineProperty(module.exports, "TableHeaderCell", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableHeaderCell;
    }
});
Object.defineProperty(module.exports, "TableHeaderRow", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableHeaderRow;
    }
});
Object.defineProperty(module.exports, "TableHeaderSelectionCell", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableHeaderSelectionCell;
    }
});
Object.defineProperty(module.exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableRow;
    }
});
Object.defineProperty(module.exports, "TableSelectionCell", {
    enumerable: true,
    get: function() {
        return $eTLPP.TableSelectionCell;
    }
});

});
parcelRegister("eTLPP", function(module, exports) {
"use client";
"use strict";
var $ad8b4ebdd317c26a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TableSelectionCell = module.exports.TableRow = module.exports.TableHeaderSelectionCell = module.exports.TableHeaderRow = module.exports.TableHeaderCell = module.exports.TableCell = module.exports.TableBody = module.exports.Table = module.exports.TableContext = void 0;

const $ad8b4ebdd317c26a$var$react_1 = $ad8b4ebdd317c26a$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $4PwOk = parcelRequire("4PwOk");

var $cKNdE = parcelRequire("cKNdE");
module.exports.TableContext = $ad8b4ebdd317c26a$var$react_1.default.createContext({
    variant: "shaded",
    spacing: "default"
});
function $ad8b4ebdd317c26a$var$getGrowValuesFromRow(row) {
    const growValues = [];
    $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(row.props.children, (cell)=>{
        var _a, _b;
        if (cell.type === $ad8b4ebdd317c26a$var$TableHeaderSelectionCell || cell.type === $ad8b4ebdd317c26a$var$TableSelectionCell) return;
        const g = (_b = (_a = cell.props) === null || _a === void 0 ? void 0 : _a.grow) !== null && _b !== void 0 ? _b : 1;
        growValues.push(g);
    });
    return growValues;
}
const $ad8b4ebdd317c26a$var$getScrollableAncestor = (node)=>{
    while(node){
        const overflowY = getComputedStyle(node).overflowY;
        if (node.scrollHeight > node.clientHeight && (overflowY === "auto" || overflowY === "scroll")) return node;
        node = node.parentElement;
    }
    return window;
};
const $ad8b4ebdd317c26a$var$useStickyHeaderDetection = ()=>{
    const ref = $ad8b4ebdd317c26a$var$react_1.default.useRef(null);
    const [isSticky, setIsSticky] = $ad8b4ebdd317c26a$var$react_1.default.useState(false);
    $ad8b4ebdd317c26a$var$react_1.default.useEffect(()=>{
        const el = ref.current;
        if (!el) return;
        const scrollContainer = $ad8b4ebdd317c26a$var$getScrollableAncestor(el);
        const handleScroll = ()=>{
            const rect = el.getBoundingClientRect();
            setIsSticky(Math.floor(rect.top) <= 0);
        };
        handleScroll();
        scrollContainer.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            scrollContainer.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        ref: ref,
        isSticky: isSticky
    };
};
const $ad8b4ebdd317c26a$var$Table = (props)=>{
    const { variant: variant = "shaded", spacing: spacing = "default", children: children } = props;
    const { warn: warn } = (0, $4PwOk.useWarning)();
    let columnCount = 0;
    let hasHeaderRow = false;
    let columnGrowValues = [];
    let totalGrow = 0;
    let foundFirstRow = false;
    $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(children, (child)=>{
        if (child.type === $ad8b4ebdd317c26a$var$TableHeaderRow) {
            hasHeaderRow = true;
            $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(child.props.children, (row)=>{
                if (!foundFirstRow && row.type === $ad8b4ebdd317c26a$var$TableRow) {
                    foundFirstRow = true;
                    columnGrowValues = $ad8b4ebdd317c26a$var$getGrowValuesFromRow(row);
                }
            });
        } else if (child.type === $ad8b4ebdd317c26a$var$TableBody) $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(child.props.children, (row)=>{
            if (row.type === $ad8b4ebdd317c26a$var$TableRow) {
                if (columnCount === 0) columnCount = $ad8b4ebdd317c26a$var$react_1.default.Children.count(row.props.children);
                if (!foundFirstRow) {
                    foundFirstRow = true;
                    columnGrowValues = $ad8b4ebdd317c26a$var$getGrowValuesFromRow(row);
                }
            }
        });
    });
    if (!hasHeaderRow) warn("TableV2 is missing a TableHeaderRow. It's recommended to include a header row for better accessibility and structure.");
    totalGrow = columnGrowValues.reduce((acc, val)=>acc + val, 0);
    if (totalGrow === 0) totalGrow = columnGrowValues.length || 1;
    if (columnCount === 0) columnCount = columnGrowValues.length || 1;
    const context = {
        variant: variant,
        spacing: spacing,
        totalGrow: totalGrow
    };
    return $ad8b4ebdd317c26a$var$react_1.default.createElement(module.exports.TableContext.Provider, {
        value: context
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: "spacing-2",
            borderRadius: "radius-2",
            backgroundColor: "surface-neutral-default"
        }
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "table",
        sx: {
            borderCollapse: "separate",
            tableLayout: "fixed",
            minWidth: "100%"
        }
    }, children)));
};
module.exports.Table = $ad8b4ebdd317c26a$var$Table;
const $ad8b4ebdd317c26a$var$TableHeaderRow = ({ children: children })=>{
    const { variant: variant } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    const { warn: warn } = (0, $4PwOk.useWarning)();
    const { ref: ref, isSticky: isSticky } = $ad8b4ebdd317c26a$var$useStickyHeaderDetection();
    $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(children, (child)=>{
        if ($ad8b4ebdd317c26a$var$react_1.default.isValidElement(child) && child.type !== $ad8b4ebdd317c26a$var$TableRow) warn("TableHeaderRow should only contain TableRow as a direct child.");
    });
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "thead",
        ref: ref,
        sx: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            width: "100%",
            backgroundColor: variant === "shaded" ? "surface-neutral-secondary" : "surface-neutral-default",
            borderTopLeftRadius: ()=>isSticky ? "0" : "radius-2",
            borderTopRightRadius: ()=>isSticky ? "0" : "radius-2",
            outlineColor: "stroke-neutral-emphasis",
            outlineOffset: "-1px",
            outlineStyle: "solid",
            outlineWidth: "1px",
            // @ts-ignore
            "tr:first-of-type th:first-of-type": {
                borderTopLeftRadius: ()=>isSticky ? "0" : "radius-2"
            },
            "tr:first-of-type th:last-child": {
                borderTopRightRadius: ()=>isSticky ? "0" : "radius-2"
            }
        }
    }, children);
};
module.exports.TableHeaderRow = $ad8b4ebdd317c26a$var$TableHeaderRow;
const $ad8b4ebdd317c26a$var$TableHeaderCell = ({ grow: grow, children: children, sortable: sortable = false, sortKey: sortKey, onClick: onClick, sortDirection: sortDirection })=>{
    const { variant: variant, totalGrow: totalGrow = 1 } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    const visibleOnHoverClassName = `tableHeaderIcon${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    if (grow !== undefined && grow < 0) throw new Error("grow property must be >= 0.");
    const fraction = (grow !== null && grow !== void 0 ? grow : 1) / totalGrow;
    const isEmpty = children === null || children === undefined || Array.isArray(children) && children.length === 0;
    const handleClick = ()=>{
        if (sortable && onClick) onClick(sortKey);
    };
    const isSorted = !!sortDirection;
    const ariaSort = isSorted ? sortDirection === "desc" ? "descending" : "ascending" : undefined;
    const textColor = $ad8b4ebdd317c26a$var$react_1.default.useMemo(()=>{
        if (variant === "shaded") return "text-default";
        return "text-emphasis";
    }, [
        variant
    ]);
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "th",
        onClick: handleClick,
        role: sortable ? "button" : undefined,
        tabIndex: sortable ? 0 : undefined,
        "aria-sort": ariaSort,
        "aria-hidden": isEmpty ? "true" : undefined,
        sx: Object.assign({
            cursor: sortable ? "pointer" : "default",
            width: ()=>`${fraction * 100}%`,
            borderBottom: "1px solid",
            borderBottomColor: variant === "shaded" ? "stroke-neutral-emphasis" : "stroke-brand-emphasis",
            color: textColor,
            transition: "transition-color-medium",
            // @ts-ignore
            "&:not(:first-of-type)": variant === "shaded" && {
                borderLeft: "1px solid",
                borderLeftColor: "stroke-neutral-tertiary"
            },
            [`.${visibleOnHoverClassName}`]: {
                opacity: 0,
                transition: "transition-color-medium"
            }
        }, sortable && {
            ":hover": {
                color: "text-emphasis",
                backgroundColor: variant === "shaded" ? "surface-neutral-tertiary" : "surface-neutral-secondary"
            },
            [`:hover .${visibleOnHoverClassName}`]: {
                opacity: 1
            },
            ":active": {
                color: "text-emphasis",
                backgroundColor: variant === "shaded" ? "color-system-gray-200" : "surface-neutral-tertiary"
            },
            [`:active .${visibleOnHoverClassName}`]: {
                opacity: 1
            }
        })
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($ad8b4ebdd317c26a$var$TableCellWrapper, {
        sortable: sortable,
        sortDirection: sortDirection,
        visibleOnHoverClassName: visibleOnHoverClassName
    }, children));
};
module.exports.TableHeaderCell = $ad8b4ebdd317c26a$var$TableHeaderCell;
const $ad8b4ebdd317c26a$var$TableBody = ({ children: children })=>{
    const { variant: variant } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    const { warn: warn } = (0, $4PwOk.useWarning)();
    $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(children, (child)=>{
        if ($ad8b4ebdd317c26a$var$react_1.default.isValidElement(child) && child.type !== $ad8b4ebdd317c26a$var$TableRow) warn("TableBody should only contain TableRow as a direct child.");
    });
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "tbody",
        sx: {
            borderBottomLeftRadius: "radius-2",
            borderBottomRightRadius: "radius-2",
            outlineColor: "stroke-neutral-emphasis",
            outlineOffset: "-1px",
            outlineStyle: "solid",
            outlineWidth: "1px",
            position: "relative",
            top: ()=>"-1px",
            // @ts-ignore
            "tr:not([data-selected='true']):nth-of-type(even)": {
                backgroundColor: variant === "shaded" ? "surface-neutral-secondary" : "surface-neutral-default"
            },
            "tr:not([data-selected='true']):nth-of-type(odd)": {
                backgroundColor: "surface-neutral-default"
            },
            "tr[data-selected='true']": {
                backgroundColor: "surface-brand"
            },
            "&:not(:last-child) tr": {
                borderBottom: "1px solid",
                borderColor: "stroke-neutral-secondary"
            },
            "tr:first-of-type td:first-of-type": {
                borderTopLeftRadius: "radius-2"
            },
            "tr:first-of-type td:last-child": {
                borderTopRightRadius: "radius-2"
            },
            "tr:last-of-type td:first-of-type": {
                borderBottomLeftRadius: "radius-2"
            },
            "tr:last-of-type td:last-child": {
                borderBottomRightRadius: "radius-2"
            }
        }
    }, children);
};
module.exports.TableBody = $ad8b4ebdd317c26a$var$TableBody;
const $ad8b4ebdd317c26a$var$TableRow = ({ children: children, selected: selected })=>{
    const { warn: warn } = (0, $4PwOk.useWarning)();
    $ad8b4ebdd317c26a$var$react_1.default.Children.forEach(children, (child)=>{
        if ($ad8b4ebdd317c26a$var$react_1.default.isValidElement(child) && child.type !== $ad8b4ebdd317c26a$var$TableHeaderCell && child.type !== $ad8b4ebdd317c26a$var$TableCell) warn("TableRow should only contain TableHeaderCell (if in TableHeaderRow) or TableCell (if in TableBody).");
    });
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "tr",
        "data-selected": selected ? "true" : undefined,
        sx: {
            width: "100%",
            // @ts-ignore
            "&:not(:last-of-type) td": {
                borderBottom: "1px solid",
                borderColor: "stroke-neutral-secondary"
            }
        }
    }, children);
};
module.exports.TableRow = $ad8b4ebdd317c26a$var$TableRow;
const $ad8b4ebdd317c26a$var$TableCellWrapper = ({ visibleOnHoverClassName: visibleOnHoverClassName, sortable: sortable = false, sortDirection: sortDirection, children: children })=>{
    const { spacing: spacing } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: {
            alignItems: "start",
            color: "currentColor",
            display: "flex",
            gap: "spacing-3",
            justifyContent: sortable ? "space-between" : "flex-start",
            px: spacing === "default" ? "spacing-4" : "spacing-3",
            py: spacing === "default" ? "spacing-3" : "spacing-2",
            textAlign: "left"
        }
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-2-medium",
        sx: {
            color: "currentColor",
            overflowWrap: "normal",
            whiteSpace: "nowrap",
            wordBreak: "keep-all"
        }
    }, children), sortable && $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "span",
        sx: {
            display: "inline-flex",
            alignItems: "center",
            flexShrink: 0,
            height: 5
        }
    }, sortDirection === "asc" ? $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Icon, {
        icon: "arrow-up",
        size: "xxs",
        color: "onSurface-brand-primary"
    }) : sortDirection === "desc" ? $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Icon, {
        icon: "arrow-down",
        size: "xxs",
        color: "onSurface-brand-primary"
    }) : $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Icon, {
        className: visibleOnHoverClassName,
        icon: "arrows-down-up",
        size: "xxs",
        color: "onSurface-brand-primary"
    })));
};
const $ad8b4ebdd317c26a$var$TableCell = ({ grow: grow, children: children })=>{
    const { warn: warn } = (0, $4PwOk.useWarning)();
    const { variant: variant } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    if (grow) warn("Grow on Table Cell will be deprecated in a future release and does not currently impact the calculation of grow on the table");
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "td",
        sx: {
            // @ts-ignore
            "&:not(:first-of-type)": variant === "shaded" && {
                borderLeft: "1px solid",
                borderColor: "stroke-neutral-secondary"
            }
        }
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($ad8b4ebdd317c26a$var$TableCellWrapper, null, children));
};
module.exports.TableCell = $ad8b4ebdd317c26a$var$TableCell;
const $ad8b4ebdd317c26a$var$TableHeaderSelectionCell = ({ checked: checked, indeterminate: indeterminate = false, onClick: onClick, disabled: disabled = false })=>{
    const { spacing: spacing } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "th",
        sx: {
            verticalAlign: "middle",
            justifyItems: "center",
            px: spacing === "default" ? "spacing-4" : "spacing-3"
        }
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($cKNdE.Checkbox, {
        label: "",
        value: checked,
        indeterminate: indeterminate,
        onChange: onClick,
        disabled: disabled,
        ariaLabel: "Select all rows"
    }));
};
module.exports.TableHeaderSelectionCell = $ad8b4ebdd317c26a$var$TableHeaderSelectionCell;
const $ad8b4ebdd317c26a$var$TableSelectionCell = ({ checked: checked, onClick: onClick, disabled: disabled = false })=>{
    const { spacing: spacing } = $ad8b4ebdd317c26a$var$react_1.default.useContext(module.exports.TableContext);
    return $ad8b4ebdd317c26a$var$react_1.default.createElement($2wkl1.Box, {
        as: "td",
        sx: {
            verticalAlign: "middle",
            justifyItems: "center",
            px: spacing === "default" ? "spacing-4" : "spacing-3"
        }
    }, $ad8b4ebdd317c26a$var$react_1.default.createElement($cKNdE.Checkbox, {
        label: "",
        value: checked,
        onChange: onClick,
        disabled: disabled,
        ariaLabel: "Select row"
    }));
};
module.exports.TableSelectionCell = $ad8b4ebdd317c26a$var$TableSelectionCell;

});


parcelRegister("cXS49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = void 0;

var $iLFM8 = parcelRequire("iLFM8");
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $iLFM8.Tabs;
    }
});

});
parcelRegister("iLFM8", function(module, exports) {
"use client";
"use strict";
var $da9d05794148b22f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tabs = void 0;

const $da9d05794148b22f$var$react_1 = $da9d05794148b22f$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $jxg79 = parcelRequire("jxg79");

var $i5SnA = parcelRequire("i5SnA");

var $8kINY = parcelRequire("8kINY");

var $4PwOk = parcelRequire("4PwOk");
const $da9d05794148b22f$var$Tabs = ({ items: items, defaultActive: defaultActive, alignment: alignment = "horizontal", baseline: baseline = true, size: size = "medium", onClickTab: onClickTab })=>{
    var _a;
    const colorClassName = `tab${(0, $8kINY.useId)().replace(/^[A-Z0-9]gi/, "")}`;
    const { warn: warn } = (0, $4PwOk.useWarning)();
    if (items.length === 0) warn("Tabs requires at least one tab item in items prop");
    const initialTab = items.find((item)=>item.id === defaultActive) ? defaultActive : (_a = items[0]) === null || _a === void 0 ? void 0 : _a.id;
    const [activeTab, setActiveTab] = $da9d05794148b22f$var$react_1.default.useState(initialTab);
    const onSetActiveTab = $da9d05794148b22f$var$react_1.default.useCallback((tabId)=>{
        setActiveTab(tabId);
        onClickTab(tabId);
    }, [
        onClickTab
    ]);
    const containerStyles = $da9d05794148b22f$var$react_1.default.useMemo(()=>{
        if (alignment === "horizontal") return {
            alignItems: "center",
            px: size === "medium" ? "spacing-3" : "spacing-4",
            paddingTop: "spacing-2",
            borderBottom: baseline ? "1px solid" : "unset",
            borderColor: baseline ? "stroke-neutral-tertiary" : "unset"
        };
        else return {
            alignItems: "flex-start",
            py: "spacing-3",
            paddingRight: "spacing-4",
            borderLeft: baseline ? "1px solid" : "unset",
            borderColor: baseline ? "stroke-neutral-tertiary" : "unset"
        };
    }, [
        alignment,
        baseline,
        size
    ]);
    const getColorStyles = $da9d05794148b22f$var$react_1.default.useCallback((isActive, isDisabled)=>{
        return Object.assign({
            [`.${colorClassName}`]: {
                borderColor: isActive ? "tab-text-selected" : "transparent",
                color: isDisabled ? "tab-text-disabled" : isActive ? "tab-text-selected" : "tab-text-default",
                transition: "transition-color-medium"
            }
        }, !isDisabled && !isActive && {
            [`:hover .${colorClassName}`]: {
                borderColor: "tab-stroke-hover"
            },
            [`:active .${colorClassName}`]: {
                borderColor: "tab-stroke-click"
            }
        });
    }, [
        colorClassName
    ]);
    const getAlignmentStyles = $da9d05794148b22f$var$react_1.default.useCallback((isActive)=>{
        if (alignment === "horizontal") return {
            px: "spacing-2",
            py: size === "medium" ? "spacing-4" : "spacing-5",
            marginBottom: "-1px",
            borderBottom: isActive ? "3px solid" : "3px solid transparent",
            transition: "transition-color-medium"
        };
        else return {
            px: size === "medium" ? "spacing-3" : "spacing-4",
            py: size === "medium" ? "spacing-2" : "spacing-3",
            marginLeft: "-1px",
            borderLeft: isActive ? "3px solid" : "3px solid transparent",
            transition: "transition-color-medium"
        };
    }, [
        alignment,
        size
    ]);
    const tabFocusStyles = $da9d05794148b22f$var$react_1.default.useMemo(()=>{
        return {
            ":focus-visible": {
                outline: "2px solid",
                outlineColor: "focus",
                borderRadius: "radius-1"
            }
        };
    }, []);
    return $da9d05794148b22f$var$react_1.default.createElement($2wkl1.Box, {
        role: "tablist",
        "aria-orientation": alignment,
        sx: {
            display: "flex",
            flexDirection: alignment === "horizontal" ? "row" : "column"
        }
    }, items.map((item)=>{
        const isActive = item.id === activeTab;
        const isDisabled = item.disabled ? item.disabled : false;
        return $da9d05794148b22f$var$react_1.default.createElement($2wkl1.Target, {
            key: item.id,
            role: "tab",
            "aria-selected": isActive,
            disabled: isDisabled,
            onClick: ()=>onSetActiveTab(item.id),
            sx: Object.assign(Object.assign({}, getColorStyles(isActive, isDisabled)), tabFocusStyles)
        }, $da9d05794148b22f$var$react_1.default.createElement($2wkl1.Box, {
            sx: containerStyles
        }, $da9d05794148b22f$var$react_1.default.createElement($2wkl1.Box, {
            className: colorClassName,
            sx: Object.assign({
                display: "flex",
                alignItems: "center",
                gap: "spacing-2"
            }, getAlignmentStyles(isActive))
        }, item.icon && $da9d05794148b22f$var$react_1.default.createElement($jxg79.Icon, {
            color: "currentColor",
            size: size === "medium" ? "xs" : "sm",
            icon: item.icon
        }), $da9d05794148b22f$var$react_1.default.createElement($i5SnA.Text, {
            as: "div",
            variant: size === "medium" ? "title-1-medium" : "h5",
            sx: {
                color: "currentColor"
            }
        }, item.label))));
    }));
};
module.exports.Tabs = $da9d05794148b22f$var$Tabs;

});


parcelRegister("e8Xf5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextField = void 0;

var $37mbs = parcelRequire("37mbs");
Object.defineProperty(module.exports, "TextField", {
    enumerable: true,
    get: function() {
        return $37mbs.TextField;
    }
});

});

parcelRegister("akScr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tooltip = void 0;

var $bsGux = parcelRequire("bsGux");
Object.defineProperty(module.exports, "Tooltip", {
    enumerable: true,
    get: function() {
        return $bsGux.Tooltip;
    }
});

});
parcelRegister("bsGux", function(module, exports) {
"use strict";
var $858345284bc6283c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tooltip = void 0;

const $858345284bc6283c$var$react_1 = $858345284bc6283c$var$__importDefault((parcelRequire("acw62")));

var $2wkl1 = parcelRequire("2wkl1");

var $i5SnA = parcelRequire("i5SnA");

var $7BEeo = parcelRequire("7BEeo");

var $lbGS1 = parcelRequire("lbGS1");
const $858345284bc6283c$var$contentStyles = {
    position: "relative",
    backgroundColor: "tooltip-surface",
    borderRadius: "radius-2",
    paddingY: "spacing-2",
    paddingX: "spacing-3",
    lineHeight: "leading-2"
};
const $858345284bc6283c$var$Tooltip = ({ children: children, content: content, arrowPosition: arrowPosition = "top-center" })=>{
    const { visible: visible, showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $7BEeo.useTooltipVisibility)();
    const tooltipId = $858345284bc6283c$var$react_1.default.useId();
    const tooltipStyles = $858345284bc6283c$var$react_1.default.useMemo(()=>(0, $lbGS1.getTooltipStyles)(arrowPosition), [
        arrowPosition
    ]);
    return $858345284bc6283c$var$react_1.default.createElement($2wkl1.Box, {
        tabIndex: 0,
        onMouseEnter: showTooltip,
        onMouseLeave: hideTooltip,
        onFocus: showTooltip,
        onBlur: hideTooltip,
        onTouchStart: showTooltip,
        onTouchEnd: hideTooltip,
        sx: {
            position: "relative"
        }
    }, $858345284bc6283c$var$react_1.default.createElement($2wkl1.Box, {
        "aria-describedby": visible ? tooltipId : undefined
    }, children), visible && $858345284bc6283c$var$react_1.default.createElement($2wkl1.Box, {
        id: tooltipId,
        role: "tooltip",
        "aria-hidden": !visible,
        sx: tooltipStyles
    }, $858345284bc6283c$var$react_1.default.createElement($2wkl1.Box, {
        sx: $858345284bc6283c$var$contentStyles
    }, $858345284bc6283c$var$react_1.default.createElement($i5SnA.Text, {
        variant: "body-2-regular"
    }, content))));
};
module.exports.Tooltip = $858345284bc6283c$var$Tooltip;

});
parcelRegister("7BEeo", function(module, exports) {
"use strict";
var $589b32315e044f64$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useTooltipVisibility = void 0;

const $589b32315e044f64$var$react_1 = $589b32315e044f64$var$__importDefault((parcelRequire("acw62")));
const $589b32315e044f64$var$useTooltipVisibility = ()=>{
    const [visible, setVisible] = $589b32315e044f64$var$react_1.default.useState(false);
    const timeoutRef = $589b32315e044f64$var$react_1.default.useRef(null);
    const showTooltip = $589b32315e044f64$var$react_1.default.useCallback(()=>{
        timeoutRef.current = setTimeout(()=>{
            setVisible(true);
        }, 200);
    }, []);
    const hideTooltip = $589b32315e044f64$var$react_1.default.useCallback(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setVisible(false);
    }, []);
    $589b32315e044f64$var$react_1.default.useEffect(()=>{
        return ()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);
    return {
        visible: visible,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
};
module.exports.useTooltipVisibility = $589b32315e044f64$var$useTooltipVisibility;

});

parcelRegister("lbGS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTooltipStyles = void 0;
const $f6cbe13b21008d23$var$leftTopArrowStyles = {
    top: 0,
    left: 0,
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transform: "translateX(-40%) translateY(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$leftCenterArrowStyles = {
    top: "50%",
    left: 0,
    transform: "translate(-40%, -50%) rotate(45deg)",
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$leftBottomArrowStyles = {
    bottom: 0,
    left: 0,
    // @ts-ignore
    borderBottomLeftRadius: "1px",
    transform: "translateX(-40%) translateY(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$topStartArrowStyles = {
    top: 0,
    left: 0,
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transform: "translateY(-40%) translateX(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$topCenterArrowStyles = {
    top: 0,
    left: "50%",
    transform: "translate(-50%, -40%) rotate(45deg)",
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$topEndArrowStyles = {
    top: 0,
    right: 0,
    // @ts-ignore
    borderTopLeftRadius: "1px",
    transform: "translateY(-40%) translateX(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)"
};
const $f6cbe13b21008d23$var$rightTopArrowStyles = {
    top: 0,
    right: 0,
    // @ts-ignore
    borderTopRightRadius: "1px",
    transform: "translateX(40%) translateY(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$rightCenterArrowStyles = {
    top: "50%",
    right: 0,
    transform: "translate(40%, -50%) rotate(45deg)",
    // @ts-ignore
    borderTopRightRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$rightBottomArrowStyles = {
    bottom: 0,
    right: 0,
    // @ts-ignore
    borderTopRightRadius: "1px",
    transform: "translateX(40%) translateY(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px -1px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$bottomStartArrowStyles = {
    bottom: 0,
    left: 0,
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transform: "translateY(40%) translateX(10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$bottomCenterArrowStyles = {
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 40%) rotate(45deg)",
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transformOrigin: "center center",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$bottomEndArrowStyles = {
    bottom: 0,
    right: 0,
    // @ts-ignore
    borderBottomRightRadius: "1px",
    transform: "translateY(40%) translateX(-10px) rotate(45deg)",
    // @ts-ignore
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 4px 4px 4px 0px rgba(0, 0, 0, 0.10)"
};
const $f6cbe13b21008d23$var$arrowStylesMap = {
    "left-top": $f6cbe13b21008d23$var$leftTopArrowStyles,
    "left-center": $f6cbe13b21008d23$var$leftCenterArrowStyles,
    "left-bottom": $f6cbe13b21008d23$var$leftBottomArrowStyles,
    "top-start": $f6cbe13b21008d23$var$topStartArrowStyles,
    "top-center": $f6cbe13b21008d23$var$topCenterArrowStyles,
    "top-end": $f6cbe13b21008d23$var$topEndArrowStyles,
    "right-top": $f6cbe13b21008d23$var$rightTopArrowStyles,
    "right-center": $f6cbe13b21008d23$var$rightCenterArrowStyles,
    "right-bottom": $f6cbe13b21008d23$var$rightBottomArrowStyles,
    "bottom-start": $f6cbe13b21008d23$var$bottomStartArrowStyles,
    "bottom-center": $f6cbe13b21008d23$var$bottomCenterArrowStyles,
    "bottom-end": $f6cbe13b21008d23$var$bottomEndArrowStyles
};
const $f6cbe13b21008d23$var$tooltipPositionStyles = {
    "left-top": {
        left: "100%",
        top: "50%",
        transform: "translate(10px, -18px)"
    },
    "left-center": {
        left: "100%",
        top: "50%",
        transform: "translate(10px, -50%)"
    },
    "left-bottom": {
        left: "100%",
        bottom: "50%",
        transform: "translate(10px, 18px)"
    },
    "top-start": {
        left: "50%",
        top: "100%",
        transform: "translate(-18px, 10px)"
    },
    "top-center": {
        left: "50%",
        top: "100%",
        transform: "translate(-50%, 10px)"
    },
    "top-end": {
        right: "50%",
        top: "100%",
        transform: "translate(18px, 10px)"
    },
    "right-top": {
        right: "100%",
        top: "50%",
        transform: "translate(-10px, -18px)"
    },
    "right-center": {
        right: "100%",
        top: "50%",
        transform: "translate(-10px, -50%)"
    },
    "right-bottom": {
        right: "100%",
        bottom: "50%",
        transform: "translate(-10px, 18px)"
    },
    "bottom-start": {
        left: "50%",
        bottom: "100%",
        transform: "translate(-18px, -10px)"
    },
    "bottom-center": {
        left: "50%",
        bottom: "100%",
        transform: "translate(-50%, -10px)"
    },
    "bottom-end": {
        right: "50%",
        bottom: "100%",
        transform: "translate(18px, -10px)"
    }
};
const $f6cbe13b21008d23$var$getTooltipStyles = (arrowPosition)=>Object.assign(Object.assign({}, $f6cbe13b21008d23$var$tooltipPositionStyles[arrowPosition]), {
        borderRadius: "radius-2",
        // @ts-ignore
        boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12), 1px 4px 4px 0px rgba(0, 0, 0, 0.10)",
        position: "absolute",
        zIndex: "dropdown",
        // @ts-ignore
        maxWidth: "320px",
        width: "max-content",
        "::before": Object.assign({
            content: '""',
            position: "absolute",
            width: "spacing-5",
            height: "spacing-5",
            backgroundColor: "tooltip-surface"
        }, $f6cbe13b21008d23$var$arrowStylesMap[arrowPosition])
    });
module.exports.getTooltipStyles = $f6cbe13b21008d23$var$getTooltipStyles;

});





parcelRegister("1J2kR", function(module, exports) {

$parcel$export(module.exports, "DataGrid", () => $141bce2f2738cba8$export$c8dd51eb24f71762);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fEVav = parcelRequire("fEVav");

var $kL0ag = parcelRequire("kL0ag");
var $ew3Bl = parcelRequire("ew3Bl");
var $hHwPs = parcelRequire("hHwPs");
var $9PaJs = parcelRequire("9PaJs");

var $eu7ae = parcelRequire("eu7ae");

var $5W2Ws = parcelRequire("5W2Ws");

var $hiKx5 = parcelRequire("hiKx5");

var $kaLFi = parcelRequire("kaLFi");

var $ayMG0 = parcelRequire("ayMG0");
const $141bce2f2738cba8$var$DataGridRaw = /*#__PURE__*/ $acw62.forwardRef(function DataGrid(inProps, ref) {
    const props = (0, $hiKx5.useDataGridProps)(inProps);
    const privateApiRef = (0, $5W2Ws.useDataGridComponent)(props.apiRef, props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eu7ae.GridContextProvider), {
        privateApiRef: privateApiRef,
        props: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9PaJs.GridRoot), (0, $8nd05.default)({
            className: props.className,
            style: props.style,
            sx: props.sx,
            ref: ref
        }, props.forwardedProps, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHwPs.GridHeader), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kL0ag.GridBody), {
                    VirtualScrollerComponent: (0, $kaLFi.DataGridVirtualScroller)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew3Bl.GridFooterPlaceholder), {})
            ]
        }))
    });
});
const $141bce2f2738cba8$export$c8dd51eb24f71762 = /*#__PURE__*/ $acw62.memo($141bce2f2738cba8$var$DataGridRaw);
const $141bce2f2738cba8$export$6e2a4e52a8bd123a = (0, $hiKx5.DATA_GRID_PROPS_DEFAULT_VALUES).filterDebounceMs;
const $141bce2f2738cba8$export$f13a01bcb69e4728 = (0, $hiKx5.DATA_GRID_PROPS_DEFAULT_VALUES).filterDebounceMs;
$141bce2f2738cba8$var$DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
    }),
    /**
   * The label of the Data Grid.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The id of the element containing a label for the Data Grid.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Data Grid height is dynamic and follow the number of rows in the Data Grid.
   * @default false
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Number of extra columns to be rendered before/after the visible slice.
   * @default 3
   */ columnBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set of columns of type [[GridColDef[]]].
   */ columns: (0, $fEVav.default)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired, (props)=>{
        // @ts-ignore because otherwise `build:api` doesn't work
        if (props.columns && props.columns.some((column)=>column.resizable)) return new Error([
            `MUI: \`column.resizable = true\` is not a valid prop.`,
            'Column resizing is not available in the MIT version.',
            '',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        return null;
    }),
    /**
   * Number of rows from the `columnBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ columnThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable components.
   * @deprecated Use `slots` instead.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   * @deprecated Use the `slotProps` prop instead.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'cell',
        'row'
    ]),
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        ariaV7: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        columnGrouping: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
    }),
    /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */ forwardedProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, a  loading overlay is displayed.
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/v6.19.4/packages/grid/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
        })
    ]).isRequired),
    pagination: (props)=>{
        if (props.pagination === false) return new Error([
            'MUI: `<DataGrid pagination={false} />` is not a valid prop.',
            'Infinite scrolling is not available in the MIT version.',
            '',
            'You need to upgrade to DataGridPro or DataGridPremium component to disable the pagination.'
        ].join('\n'));
        return null;
    },
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Number of extra rows to be rendered before/after the visible slice.
   * @default 3
   */ rowBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   */ rowPositionsDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Set of rows of type [[GridRowsProp]].
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object).isRequired,
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]).isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'border',
        'margin'
    ]),
    /**
   * Number of rows from the `rowBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ rowThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * If `true`, the vertical borders of the cells are displayed.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'asc',
            'desc'
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ unstable_ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ])
};

});
parcelRegister("fEVav", function(module, exports) {

$parcel$export(module.exports, "default", () => $b666efe8669b09a1$export$2e2bcd8739ae039);
function $b666efe8669b09a1$export$2e2bcd8739ae039(propType1, propType2) {
    return ()=>null;
}

});

parcelRegister("kL0ag", function(module, exports) {

$parcel$export(module.exports, "GridBody", () => $f1c85321eab9b516$export$d79f740c0338b156);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $eEJPp = parcelRequire("eEJPp");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $k5Pju = parcelRequire("k5Pju");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $drCmI = parcelRequire("drCmI");

var $fD9f4 = parcelRequire("fD9f4");

var $hMyIf = parcelRequire("hMyIf");

var $eOaSX = parcelRequire("eOaSX");

var $ayMG0 = parcelRequire("ayMG0");
function $f1c85321eab9b516$export$d79f740c0338b156(props) {
    const { VirtualScrollerComponent: VirtualScrollerComponent, ColumnHeadersProps: ColumnHeadersProps, children: children } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const rootRef = $acw62.useRef(null);
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const filterColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterActiveItemsLookupSelector));
    const sortColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortColumnLookupSelector));
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnPositionsSelector));
    const columnHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexColumnHeaderSelector));
    const cellTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexCellSelector));
    const columnGroupHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.unstable_gridTabIndexColumnGroupHeaderSelector));
    const columnHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridFocusColumnHeaderSelector));
    const columnGroupHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.unstable_gridFocusColumnGroupHeaderSelector));
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    const columnMenuState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $eOaSX.gridColumnMenuSelector));
    const columnVisibility = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnVisibilityModelSelector));
    const columnGroupsHeaderStructure = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderStructureSelector));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && cellTabIndexState === null);
    (0, $eEJPp.default)(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
        const elementToObserve = rootRef.current;
        if (typeof ResizeObserver === 'undefined') return ()=>{};
        let animationFrame;
        const observer = new ResizeObserver(()=>{
            // See https://github.com/mui/mui-x/issues/8733
            animationFrame = requestAnimationFrame(()=>{
                apiRef.current.computeSizeAndPublishResizeEvent();
            });
        });
        if (elementToObserve) observer.observe(elementToObserve);
        return ()=>{
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
            if (elementToObserve) observer.unobserve(elementToObserve);
        };
    }, [
        apiRef
    ]);
    const columnHeadersRef = $acw62.useRef(null);
    const columnsContainerRef = $acw62.useRef(null);
    const virtualScrollerRef = $acw62.useRef(null);
    apiRef.current.register('private', {
        columnHeadersContainerElementRef: columnsContainerRef,
        columnHeadersElementRef: columnHeadersRef,
        virtualScrollerRef: virtualScrollerRef,
        mainElementRef: rootRef
    });
    const hasDimensions = !!apiRef.current.getRootDimensions();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $k5Pju.GridMainContainer), {
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaders, (0, $8nd05.default)({
                ref: columnsContainerRef,
                innerRef: columnHeadersRef,
                visibleColumns: visibleColumns,
                filterColumnLookup: filterColumnLookup,
                sortColumnLookup: sortColumnLookup,
                columnPositions: columnPositions,
                columnHeaderTabIndexState: columnHeaderTabIndexState,
                columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
                columnHeaderFocus: columnHeaderFocus,
                columnGroupHeaderFocus: columnGroupHeaderFocus,
                densityFactor: densityFactor,
                headerGroupingMaxDepth: headerGroupingMaxDepth,
                columnMenuState: columnMenuState,
                columnVisibility: columnVisibility,
                columnGroupsHeaderStructure: columnGroupsHeaderStructure,
                hasOtherElementInTabSequence: hasOtherElementInTabSequence
            }, ColumnHeadersProps)),
            hasDimensions && /*#__PURE__*/ (0, $ayMG0.jsx)(VirtualScrollerComponent, {
                ref: virtualScrollerRef
            }),
            children
        ]
    });
}

});
parcelRegister("eEJPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab859a020ad749e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;

});

parcelRegister("er55f", function(module, exports) {

$parcel$export(module.exports, "GridPrivateApiContext", () => $a82787d0b1c2b050$export$37099e7a34cbf988);
$parcel$export(module.exports, "useGridPrivateApiContext", () => $a82787d0b1c2b050$export$e1fd9274eb96ee18);

var $acw62 = parcelRequire("acw62");
const $a82787d0b1c2b050$export$37099e7a34cbf988 = /*#__PURE__*/ $acw62.createContext(undefined);
function $a82787d0b1c2b050$export$e1fd9274eb96ee18() {
    const privateApiRef = $acw62.useContext($a82787d0b1c2b050$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        'MUI: Could not find the data grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the data grid.'
    ].join('\n'));
    return privateApiRef;
}

});

parcelRegister("5sOMZ", function(module, exports) {

$parcel$export(module.exports, "objectShallowCompare", () => $3fa6f6f21ffa38ee$export$8da4c691e5695191);
$parcel$export(module.exports, "useGridSelector", () => $3fa6f6f21ffa38ee$export$f96fd476863f2e4a);

var $acw62 = parcelRequire("acw62");

var $7O6ub = parcelRequire("7O6ub");

var $cZouL = parcelRequire("cZouL");

var $ehSzT = parcelRequire("ehSzT");

var $arRb5 = parcelRequire("arRb5");
const $3fa6f6f21ffa38ee$var$stateNotInitializedWarning = (0, $ehSzT.buildWarning)([
    'MUI: `useGridSelector` has been called before the initialization of the state.',
    'This hook can only be used inside the context of the grid.'
]);
function $3fa6f6f21ffa38ee$var$isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
function $3fa6f6f21ffa38ee$var$applySelector(apiRef, selector) {
    if ($3fa6f6f21ffa38ee$var$isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
}
const $3fa6f6f21ffa38ee$var$defaultCompare = Object.is;
const $3fa6f6f21ffa38ee$export$8da4c691e5695191 = (0, $arRb5.fastObjectShallowCompare);
const $3fa6f6f21ffa38ee$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null
    });
const $3fa6f6f21ffa38ee$export$f96fd476863f2e4a = (apiRef, selector, equals = $3fa6f6f21ffa38ee$var$defaultCompare)=>{
    const refs = (0, $7O6ub.useLazyRef)($3fa6f6f21ffa38ee$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $acw62.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : $3fa6f6f21ffa38ee$var$applySelector(apiRef, selector));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    (0, $cZouL.useOnMount)(()=>{
        return apiRef.current.store.subscribe(()=>{
            const newState = $3fa6f6f21ffa38ee$var$applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
    });
    return state;
};

});
parcelRegister("7O6ub", function(module, exports) {

$parcel$export(module.exports, "useLazyRef", () => $5af23bdc14a3ba8d$export$fd27aa36f007ec3d);

var $acw62 = parcelRequire("acw62");
const $5af23bdc14a3ba8d$var$UNINITIALIZED = {};
function $5af23bdc14a3ba8d$export$fd27aa36f007ec3d(init, initArg) {
    const ref = $acw62.useRef($5af23bdc14a3ba8d$var$UNINITIALIZED);
    if (ref.current === $5af23bdc14a3ba8d$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("cZouL", function(module, exports) {

$parcel$export(module.exports, "useOnMount", () => $974e2ec20df6d801$export$820558710db2d9c6);

var $acw62 = parcelRequire("acw62");
const $974e2ec20df6d801$var$EMPTY = [];
function $974e2ec20df6d801$export$820558710db2d9c6(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $974e2ec20df6d801$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});

parcelRegister("ehSzT", function(module, exports) {

$parcel$export(module.exports, "buildWarning", () => $a66cfd406d349b99$export$baf331755d84b871);
const $a66cfd406d349b99$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const $a66cfd406d349b99$export$eeb37579de885205 = (method, message)=>{
    var args;
    return method;
};

});

parcelRegister("arRb5", function(module, exports) {

$parcel$export(module.exports, "fastObjectShallowCompare", () => $79b5ad0658da19ee$export$84d14f151b531ccb);
const $79b5ad0658da19ee$var$is = Object.is;
function $79b5ad0658da19ee$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$79b5ad0658da19ee$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    /* eslint-enable no-restricted-syntax */ /* eslint-enable guard-for-in */ return aLength === bLength;
}

});


parcelRegister("k5Pju", function(module, exports) {

$parcel$export(module.exports, "GridMainContainer", () => $ea0c140aded57e3a$export$74039dccf215bc2a);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $5tnRA = parcelRequire("5tnRA");

var $ayMG0 = parcelRequire("ayMG0");
const $ea0c140aded57e3a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'main'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $ea0c140aded57e3a$var$GridMainContainerRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>styles.main
})(()=>({
        position: 'relative',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }));
const $ea0c140aded57e3a$export$74039dccf215bc2a = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _rootProps$experiment;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $ea0c140aded57e3a$var$useUtilityClasses(rootProps);
    const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
     ? (0, $5tnRA.useGridAriaAttributes) : null;
    const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea0c140aded57e3a$var$GridMainContainerRoot, (0, $8nd05.default)({
        ref: ref,
        className: classes.root,
        ownerState: rootProps
    }, ariaAttributes, {
        children: props.children
    }));
});

});
parcelRegister("0tqaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0016d2a363b4c314$export$2e2bcd8739ae039);

var $dNfBQ = parcelRequire("dNfBQ");
const $0016d2a363b4c314$var$styled = (0, $dNfBQ.default)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;

});
parcelRegister("dNfBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0abf5ad226c4fb0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");

var $3z1Ay = parcelRequire("3z1Ay");



var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");
const $a0abf5ad226c4fb0$var$_excluded = [
    "ownerState"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "variants"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $6o2lr.default)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0abf5ad226c4fb0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0abf5ad226c4fb0$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0abf5ad226c4fb0$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $a0abf5ad226c4fb0$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0abf5ad226c4fb0$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $a0abf5ad226c4fb0$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $9dZwz.default)((0, $8nd05.default)({}, props, {
            theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0abf5ad226c4fb0$var$defaultOverridesResolver($a0abf5ad226c4fb0$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$a0abf5ad226c4fb0$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: $a0abf5ad226c4fb0$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0abf5ad226c4fb0$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0abf5ad226c4fb0$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});


parcelRegister("5H1vo", function(module, exports) {

$parcel$export(module.exports, "getDataGridUtilityClass", () => $425222d9b2251c12$export$a2aa36217b862c23);
$parcel$export(module.exports, "gridClasses", () => $425222d9b2251c12$export$2100d54e36406477);

var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $425222d9b2251c12$export$a2aa36217b862c23(slot) {
    return (0, $4Cod0.default)('MuiDataGrid', slot);
}
const $425222d9b2251c12$export$2100d54e36406477 = (0, $beCSm.default)('MuiDataGrid', [
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'autoHeight',
    'autosizing',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--withRenderer',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--selectionMode',
    'cell',
    'cellContent',
    'cellCheckbox',
    'cellSkeleton',
    'checkboxInput',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderDropZone',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnGroupHeader',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeader--showColumnBorder',
    'columnHeaders',
    'columnHeadersInner',
    'columnHeadersInner--scrollable',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsPanel',
    'columnsPanelRow',
    'detailPanel',
    'detailPanels',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'row',
    'row--editable',
    'row--editing',
    'row--lastVisible',
    'row--dragging',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea',
    'selectedRowCount',
    'sortIcon',
    'toolbarContainer',
    'toolbarFilterList',
    'virtualScroller',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'pinnedColumns',
    'pinnedColumns--left',
    'pinnedColumns--right',
    'pinnedColumnHeaders',
    'pinnedColumnHeaders--left',
    'pinnedColumnHeaders--right',
    'withBorderColor',
    'cell--withRightBorder',
    'columnHeader--withRightBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pinnedRowsRenderZone'
]);

});

parcelRegister("jDpXp", function(module, exports) {

$parcel$export(module.exports, "useGridRootProps", () => $e4b5cb616f3aaa8a$export$8b0f8e71b71b7ed3);

var $acw62 = parcelRequire("acw62");

var $96LtV = parcelRequire("96LtV");
const $e4b5cb616f3aaa8a$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $acw62.useContext((0, $96LtV.GridRootPropsContext));
    if (!contextValue) throw new Error('MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};

});
parcelRegister("96LtV", function(module, exports) {

$parcel$export(module.exports, "GridRootPropsContext", () => $6a19817c134c532b$export$e00c5fe7e13db7ba);

var $acw62 = parcelRequire("acw62");
const $6a19817c134c532b$export$e00c5fe7e13db7ba = /*#__PURE__*/ $acw62.createContext(undefined);

});


parcelRegister("5tnRA", function(module, exports) {

$parcel$export(module.exports, "useGridAriaAttributes", () => $3fc22bf49019df83$export$89716d1110d32214);

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $goCyd = parcelRequire("goCyd");

var $er55f = parcelRequire("er55f");
const $3fc22bf49019df83$export$89716d1110d32214 = ()=>{
    var _rootProps$experiment;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const totalRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowCountSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    const pinnedRowsCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsCountSelector));
    let role = 'grid';
    if ((_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 && rootProps.treeData) role = 'treegrid';
    return {
        role: role,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
        'aria-multiselectable': !rootProps.disableMultipleRowSelection
    };
};

});
parcelRegister("jQEEt", function(module, exports) {

$parcel$export(module.exports, "gridColumnsStateSelector", () => $e732684465924d20$export$858d15abb6cddc08);
$parcel$export(module.exports, "gridColumnFieldsSelector", () => $e732684465924d20$export$d8a3dfbb129c80db);
$parcel$export(module.exports, "gridColumnLookupSelector", () => $e732684465924d20$export$8a3a9a6db584d7fd);
$parcel$export(module.exports, "gridColumnDefinitionsSelector", () => $e732684465924d20$export$da85f06e3c19f1fd);
$parcel$export(module.exports, "gridColumnVisibilityModelSelector", () => $e732684465924d20$export$eb0d33595fe29bb4);
$parcel$export(module.exports, "gridVisibleColumnDefinitionsSelector", () => $e732684465924d20$export$16a65a9447d3dda9);
$parcel$export(module.exports, "gridVisibleColumnFieldsSelector", () => $e732684465924d20$export$c9491722e1d6e8d3);
$parcel$export(module.exports, "gridColumnPositionsSelector", () => $e732684465924d20$export$fce7d810e48021e3);
$parcel$export(module.exports, "gridColumnsTotalWidthSelector", () => $e732684465924d20$export$ab20f9d33edc7794);
$parcel$export(module.exports, "gridFilterableColumnDefinitionsSelector", () => $e732684465924d20$export$2cad659ba95fed71);
$parcel$export(module.exports, "gridFilterableColumnLookupSelector", () => $e732684465924d20$export$e84218276cc24419);

var $cgQ4y = parcelRequire("cgQ4y");
const $e732684465924d20$export$858d15abb6cddc08 = (state)=>state.columns;
const $e732684465924d20$export$d8a3dfbb129c80db = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $e732684465924d20$export$8a3a9a6db584d7fd = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $e732684465924d20$export$da85f06e3c19f1fd = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$d8a3dfbb129c80db, $e732684465924d20$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $e732684465924d20$export$eb0d33595fe29bb4 = (0, $cgQ4y.createSelector)($e732684465924d20$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $e732684465924d20$export$16a65a9447d3dda9 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, $e732684465924d20$export$eb0d33595fe29bb4, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $e732684465924d20$export$c9491722e1d6e8d3 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $e732684465924d20$export$fce7d810e48021e3 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $e732684465924d20$export$ab20f9d33edc7794 = (0, $cgQ4y.createSelector)($e732684465924d20$export$16a65a9447d3dda9, $e732684465924d20$export$fce7d810e48021e3, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});
const $e732684465924d20$export$2cad659ba95fed71 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $e732684465924d20$export$e84218276cc24419 = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));

});
parcelRegister("cgQ4y", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $8eef5f2af445e503$export$595d22ed68ca2841);
$parcel$export(module.exports, "createSelectorMemoized", () => $8eef5f2af445e503$export$2a3ca4704a61d1f4);

var $6SpLG = parcelRequire("6SpLG");

var $ehSzT = parcelRequire("ehSzT");
const $8eef5f2af445e503$var$cacheContainer = {
    cache: new WeakMap()
};
const $8eef5f2af445e503$var$missingInstanceIdWarning = (0, $ehSzT.buildWarning)([
    'MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.',
    'To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g. `mySelector(state, apiRef.current.instanceId)`.'
]);
function $8eef5f2af445e503$var$checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
const $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID = {
    id: 'default'
};
const $8eef5f2af445e503$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...rest)=>{
    if (rest.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        const ve = e(state, instanceId);
        return f(va, vb, vc, vd, ve);
    };
    else if (a && b && c && d && e) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        const vd = d(state, instanceId);
        return e(va, vb, vc, vd);
    };
    else if (a && b && c && d) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        const vc = c(state, instanceId);
        return d(va, vb, vc);
    };
    else if (a && b && c) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        const vb = b(state, instanceId);
        return c(va, vb);
    };
    else if (a && b) selector = (stateOrApiRef, instanceIdParam)=>{
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const va = a(state, instanceId);
        return b(va);
    };
    else throw new Error('Missing arguments');
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $8eef5f2af445e503$export$2a3ca4704a61d1f4 = (...args)=>{
    const selector = (...selectorArgs)=>{
        var _cache$get, _cache$get3;
        const [stateOrApiRef, instanceId] = selectorArgs;
        const isAPIRef = $8eef5f2af445e503$var$checkIsAPIRef(stateOrApiRef);
        const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId != null ? instanceId : $8eef5f2af445e503$var$DEFAULT_INSTANCE_ID;
        const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        const { cache: cache } = $8eef5f2af445e503$var$cacheContainer;
        if (cache.get(cacheKey) && (_cache$get = cache.get(cacheKey)) != null && _cache$get.get(args)) {
            var _cache$get2;
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return (_cache$get2 = cache.get(cacheKey)) == null ? void 0 : _cache$get2.get(args)(state, cacheKey);
        }
        const newSelector = (0, $6SpLG.createSelector)(...args);
        if (!cache.get(cacheKey)) cache.set(cacheKey, new Map());
        (_cache$get3 = cache.get(cacheKey)) == null || _cache$get3.set(args, newSelector);
        return newSelector(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
const $8eef5f2af445e503$export$73ae0dfa3bbc446f = ()=>{
    $8eef5f2af445e503$var$cacheContainer.cache = new WeakMap();
};

});
parcelRegister("6SpLG", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $501bc638b8425ea6$export$595d22ed68ca2841);
$parcel$export(module.exports, "defaultMemoize", () => (parcelRequire("9EdUm")).defaultMemoize);

var $9EdUm = parcelRequire("9EdUm");
function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $9EdUm.defaultMemoize));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("9EdUm", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $7062a3595350e02d$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = 'NOT_FOUND';
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});




parcelRegister("hMyIf", function(module, exports) {

$parcel$export(module.exports, "gridColumnGroupsUnwrappedModelSelector", () => $cf21d895912d975b$export$78f140ad2e1dbc2b);
$parcel$export(module.exports, "gridColumnGroupsLookupSelector", () => $cf21d895912d975b$export$bdc2ff4432d8b29b);
$parcel$export(module.exports, "gridColumnGroupsHeaderStructureSelector", () => $cf21d895912d975b$export$8f859ed1f2777746);
$parcel$export(module.exports, "gridColumnGroupsHeaderMaxDepthSelector", () => $cf21d895912d975b$export$4cf0369c079b29be);

var $cgQ4y = parcelRequire("cgQ4y");
const $cf21d895912d975b$export$6f71a66e6e099ab2 = (state)=>state.columnGrouping;
const $cf21d895912d975b$export$78f140ad2e1dbc2b = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$unwra;
    return (_columnGrouping$unwra = columnGrouping == null ? void 0 : columnGrouping.unwrappedGroupingModel) != null ? _columnGrouping$unwra : {};
});
const $cf21d895912d975b$export$bdc2ff4432d8b29b = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$looku;
    return (_columnGrouping$looku = columnGrouping == null ? void 0 : columnGrouping.lookup) != null ? _columnGrouping$looku : {};
});
const $cf21d895912d975b$export$8f859ed1f2777746 = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$heade;
    return (_columnGrouping$heade = columnGrouping == null ? void 0 : columnGrouping.headerStructure) != null ? _columnGrouping$heade : [];
});
const $cf21d895912d975b$export$4cf0369c079b29be = (0, $cgQ4y.createSelector)($cf21d895912d975b$export$6f71a66e6e099ab2, (columnGrouping)=>{
    var _columnGrouping$maxDe;
    return (_columnGrouping$maxDe = columnGrouping == null ? void 0 : columnGrouping.maxDepth) != null ? _columnGrouping$maxDe : 0;
});

});

parcelRegister("goCyd", function(module, exports) {

$parcel$export(module.exports, "gridRowCountSelector", () => $befccaa56b49492d$export$1641ef9d08e265ca);
$parcel$export(module.exports, "gridRowsLoadingSelector", () => $befccaa56b49492d$export$3c966d405f950b08);
$parcel$export(module.exports, "gridTopLevelRowCountSelector", () => $befccaa56b49492d$export$800ab0a68a9efc4f);
$parcel$export(module.exports, "gridRowsLookupSelector", () => $befccaa56b49492d$export$37767f9110c99048);
$parcel$export(module.exports, "gridRowsDataRowIdToIdLookupSelector", () => $befccaa56b49492d$export$451ff98f7dd9f13f);
$parcel$export(module.exports, "gridRowTreeSelector", () => $befccaa56b49492d$export$de9a43d646a9821d);
$parcel$export(module.exports, "gridRowGroupingNameSelector", () => $befccaa56b49492d$export$c263d91fb644e7a0);
$parcel$export(module.exports, "gridRowTreeDepthsSelector", () => $befccaa56b49492d$export$eb24598525413286);
$parcel$export(module.exports, "gridRowMaximumTreeDepthSelector", () => $befccaa56b49492d$export$4cdbe576751dd8e2);
$parcel$export(module.exports, "gridDataRowIdsSelector", () => $befccaa56b49492d$export$c7dcaab5e573753);
$parcel$export(module.exports, "gridPinnedRowsSelector", () => $befccaa56b49492d$export$ffe7071c481e32b0);
$parcel$export(module.exports, "gridPinnedRowsCountSelector", () => $befccaa56b49492d$export$8e3fb3525d7db988);

var $cgQ4y = parcelRequire("cgQ4y");
const $befccaa56b49492d$var$gridRowsStateSelector = (state)=>state.rows;
const $befccaa56b49492d$export$1641ef9d08e265ca = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $befccaa56b49492d$export$3c966d405f950b08 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.loading);
const $befccaa56b49492d$export$800ab0a68a9efc4f = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const $befccaa56b49492d$export$37767f9110c99048 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
const $befccaa56b49492d$export$451ff98f7dd9f13f = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToIdLookup);
const $befccaa56b49492d$export$de9a43d646a9821d = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.tree);
const $befccaa56b49492d$export$c263d91fb644e7a0 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $befccaa56b49492d$export$eb24598525413286 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $befccaa56b49492d$export$4cdbe576751dd8e2 = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] + 1;
});
const $befccaa56b49492d$export$c7dcaab5e573753 = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $befccaa56b49492d$export$e8db8ec5e43400fa = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows == null ? void 0 : rows.additionalRowGroups);
const $befccaa56b49492d$export$ffe7071c481e32b0 = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    var _rawPinnedRows$bottom, _rawPinnedRows$top;
    const rawPinnedRows = additionalRowGroups == null ? void 0 : additionalRowGroups.pinnedRows;
    return {
        bottom: rawPinnedRows == null || (_rawPinnedRows$bottom = rawPinnedRows.bottom) == null ? void 0 : _rawPinnedRows$bottom.map((rowEntry)=>{
            var _rowEntry$model;
            return {
                id: rowEntry.id,
                model: (_rowEntry$model = rowEntry.model) != null ? _rowEntry$model : {}
            };
        }),
        top: rawPinnedRows == null || (_rawPinnedRows$top = rawPinnedRows.top) == null ? void 0 : _rawPinnedRows$top.map((rowEntry)=>{
            var _rowEntry$model2;
            return {
                id: rowEntry.id,
                model: (_rowEntry$model2 = rowEntry.model) != null ? _rowEntry$model2 : {}
            };
        })
    };
});
const $befccaa56b49492d$export$8e3fb3525d7db988 = (0, $cgQ4y.createSelector)($befccaa56b49492d$export$ffe7071c481e32b0, (pinnedRows)=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    return ((pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.length) || 0) + ((pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.length) || 0);
});

});



parcelRegister("k278Q", function(module, exports) {

$parcel$export(module.exports, "gridFilterModelSelector", () => $e95988b653de2e96$export$280aedb9454597a5);
$parcel$export(module.exports, "gridFilteredRowsLookupSelector", () => $e95988b653de2e96$export$6d031b6e8cbaf41c);
$parcel$export(module.exports, "gridExpandedSortedRowEntriesSelector", () => $e95988b653de2e96$export$2f31562143a3e5d4);
$parcel$export(module.exports, "gridExpandedSortedRowIdsSelector", () => $e95988b653de2e96$export$7a99837e2fd93e42);
$parcel$export(module.exports, "gridFilteredSortedRowIdsSelector", () => $e95988b653de2e96$export$4e2a9d76902d271c);
$parcel$export(module.exports, "gridFilteredSortedTopLevelRowEntriesSelector", () => $e95988b653de2e96$export$b8a7110d1a4c4623);
$parcel$export(module.exports, "gridExpandedRowCountSelector", () => $e95988b653de2e96$export$96919017bbfaec0d);
$parcel$export(module.exports, "gridFilteredTopLevelRowCountSelector", () => $e95988b653de2e96$export$f88efd30675963d1);
$parcel$export(module.exports, "gridFilterActiveItemsLookupSelector", () => $e95988b653de2e96$export$6b2da1ecc84b757a);

var $cgQ4y = parcelRequire("cgQ4y");

var $iU3u2 = parcelRequire("iU3u2");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");
/**
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterStateSelector = (state)=>state.filter;
const $e95988b653de2e96$export$280aedb9454597a5 = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $e95988b653de2e96$export$6f9fe133e2c56816 = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $e95988b653de2e96$export$7dcadad908a379a4 = (state)=>state.visibleRowsLookup;
const $e95988b653de2e96$export$6d031b6e8cbaf41c = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $e95988b653de2e96$export$28e99d5260ff82e7 = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $e95988b653de2e96$export$2f31562143a3e5d4 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$7dcadad908a379a4, (0, $iU3u2.gridSortedRowEntriesSelector), (visibleRowsLookup, sortedRows)=>sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false));
const $e95988b653de2e96$export$7a99837e2fd93e42 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $e95988b653de2e96$export$cd53824a2b232e36 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$6d031b6e8cbaf41c, (0, $iU3u2.gridSortedRowEntriesSelector), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $e95988b653de2e96$export$4e2a9d76902d271c = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $e95988b653de2e96$export$b8a7110d1a4c4623 = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$2f31562143a3e5d4, (0, $goCyd.gridRowTreeSelector), (0, $goCyd.gridRowMaximumTreeDepthSelector), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>{
        var _rowTree$row$id;
        return ((_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth) === 0;
    });
});
const $e95988b653de2e96$export$96919017bbfaec0d = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $e95988b653de2e96$export$f88efd30675963d1 = (0, $cgQ4y.createSelector)($e95988b653de2e96$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $e95988b653de2e96$export$c7447bfbd4ecafcc = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$280aedb9454597a5, (0, $jQEEt.gridColumnLookupSelector), (filterModel, columnLookup)=>{
    var _filterModel$items;
    return (_filterModel$items = filterModel.items) == null ? void 0 : _filterModel$items.filter((item)=>{
        var _column$filterOperato, _item$value;
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!(column != null && column.filterOperators) || (column == null || (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.length) === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && ((_item$value = item.value) == null ? void 0 : _item$value.toString()) !== '';
    });
});
const $e95988b653de2e96$export$6b2da1ecc84b757a = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});

});
parcelRegister("iU3u2", function(module, exports) {

$parcel$export(module.exports, "gridSortedRowIdsSelector", () => $dc3028b3b629fae7$export$e4979ad0a2db8752);
$parcel$export(module.exports, "gridSortedRowEntriesSelector", () => $dc3028b3b629fae7$export$8919e81647813e61);
$parcel$export(module.exports, "gridSortModelSelector", () => $dc3028b3b629fae7$export$55dcc66b73d9a0f9);
$parcel$export(module.exports, "gridSortColumnLookupSelector", () => $dc3028b3b629fae7$export$4dfdcc434a6c5081);

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortingStateSelector = (state)=>state.sorting;
const $dc3028b3b629fae7$export$e4979ad0a2db8752 = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $dc3028b3b629fae7$export$8919e81647813e61 = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$export$e4979ad0a2db8752, (0, $goCyd.gridRowsLookupSelector), // TODO rows v6: Is this the best approach ?
(sortedIds, idRowsLookup)=>sortedIds.map((id)=>{
        var _idRowsLookup$id;
        return {
            id: id,
            model: (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
        };
    }));
const $dc3028b3b629fae7$export$55dcc66b73d9a0f9 = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $dc3028b3b629fae7$export$4dfdcc434a6c5081 = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});

});


parcelRegister("drCmI", function(module, exports) {

$parcel$export(module.exports, "gridFocusCellSelector", () => $9c9b8e89fddd633d$export$74af8aada6269d3);
$parcel$export(module.exports, "gridFocusColumnHeaderSelector", () => $9c9b8e89fddd633d$export$cefd405855792f4a);
$parcel$export(module.exports, "unstable_gridFocusColumnGroupHeaderSelector", () => $9c9b8e89fddd633d$export$7442f29af2d5c4da);
$parcel$export(module.exports, "gridTabIndexCellSelector", () => $9c9b8e89fddd633d$export$2c47652a1f657d56);
$parcel$export(module.exports, "gridTabIndexColumnHeaderSelector", () => $9c9b8e89fddd633d$export$29da670438604dbd);
$parcel$export(module.exports, "unstable_gridTabIndexColumnGroupHeaderSelector", () => $9c9b8e89fddd633d$export$2ed1808619944d47);

var $cgQ4y = parcelRequire("cgQ4y");
const $9c9b8e89fddd633d$export$ce21bef7bd3a9c4e = (state)=>state.focus;
const $9c9b8e89fddd633d$export$74af8aada6269d3 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $9c9b8e89fddd633d$export$cefd405855792f4a = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $9c9b8e89fddd633d$export$ddbc5e79a3870366 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $9c9b8e89fddd633d$export$7442f29af2d5c4da = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $9c9b8e89fddd633d$export$3ab3abde27f70192 = (state)=>state.tabIndex;
const $9c9b8e89fddd633d$export$2c47652a1f657d56 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.cell);
const $9c9b8e89fddd633d$export$29da670438604dbd = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $9c9b8e89fddd633d$export$6e4ac1bbcaf7689e = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $9c9b8e89fddd633d$export$2ed1808619944d47 = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);

});

parcelRegister("fD9f4", function(module, exports) {

$parcel$export(module.exports, "gridDensitySelector", () => $b611aad21a5b677d$export$806a039ece4425b4);
$parcel$export(module.exports, "gridDensityValueSelector", () => $b611aad21a5b677d$export$8483bbb6eba91abb);
$parcel$export(module.exports, "gridDensityFactorSelector", () => $b611aad21a5b677d$export$c646201fb1d3e7a6);

var $cgQ4y = parcelRequire("cgQ4y");
const $b611aad21a5b677d$export$806a039ece4425b4 = (state)=>state.density;
const $b611aad21a5b677d$export$8483bbb6eba91abb = (0, $cgQ4y.createSelector)($b611aad21a5b677d$export$806a039ece4425b4, (density)=>density.value);
const $b611aad21a5b677d$export$c646201fb1d3e7a6 = (0, $cgQ4y.createSelector)($b611aad21a5b677d$export$806a039ece4425b4, (density)=>density.factor);

});

parcelRegister("eOaSX", function(module, exports) {

$parcel$export(module.exports, "gridColumnMenuSelector", () => $ac7e2dd161e207a6$export$5479c2fb8e9fd070);
const $ac7e2dd161e207a6$export$5479c2fb8e9fd070 = (state)=>state.columnMenu;

});


parcelRegister("ew3Bl", function(module, exports) {

$parcel$export(module.exports, "GridFooterPlaceholder", () => $a916d8fa7c7fb6bb$export$6d80c98441abb3ab);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $a916d8fa7c7fb6bb$export$6d80c98441abb3ab() {
    var _rootProps$slotProps;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footer, (0, $8nd05.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footer));
}

});

parcelRegister("hHwPs", function(module, exports) {

$parcel$export(module.exports, "GridHeader", () => $ce2feaf42932ccbe$export$74ac40502a3200d3);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $ce2feaf42932ccbe$export$74ac40502a3200d3() {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.preferencesPanel, (0, $8nd05.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.preferencesPanel)),
            rootProps.slots.toolbar && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.toolbar, (0, $8nd05.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.toolbar))
        ]
    });
}

});

parcelRegister("9PaJs", function(module, exports) {

$parcel$export(module.exports, "GridRoot", () => $727133a3c635b8ae$export$8cdbcd3b320d39bf);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $aOz2q = parcelRequire("aOz2q");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $fD9f4 = parcelRequire("fD9f4");

var $5tnRA = parcelRequire("5tnRA");

var $ayMG0 = parcelRequire("ayMG0");
const $727133a3c635b8ae$var$_excluded = [
    "children",
    "className"
];
const $727133a3c635b8ae$var$useUtilityClasses = (ownerState)=>{
    const { autoHeight: autoHeight, density: density, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $gxvzd.default)(density)}`,
            'withBorderColor'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $727133a3c635b8ae$export$8cdbcd3b320d39bf = /*#__PURE__*/ $acw62.forwardRef(function GridRoot(props, ref) {
    var _rootProps$experiment;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { children: children, className: className } = props, other = (0, $1En50.default)(props, $727133a3c635b8ae$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const densityValue = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityValueSelector));
    const rootContainerRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(rootContainerRef, ref);
    const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
     ? null : (0, $5tnRA.useGridAriaAttributes);
    const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
    const ownerState = (0, $8nd05.default)({}, rootProps, {
        density: densityValue
    });
    const classes = $727133a3c635b8ae$var$useUtilityClasses(ownerState);
    apiRef.current.register('public', {
        rootElementRef: rootContainerRef
    });
    // Our implementation of <NoSsr />
    const [mountedState, setMountedState] = $acw62.useState(false);
    (0, $eEJPp.default)(()=>{
        setMountedState(true);
    }, []);
    if (!mountedState) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aOz2q.GridRootStyles), (0, $8nd05.default)({
        ref: handleRef,
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: ownerState
    }, ariaAttributes, other, {
        children: children
    }));
});

});
parcelRegister("3qSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fddc0219860a83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");
'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $hervl.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("hervl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b9145416f64bb2$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("aOz2q", function(module, exports) {

$parcel$export(module.exports, "GridRootStyles", () => $7df9c0c298ff1f9f$export$42458c7ae3a97297);

var $8nd05 = parcelRequire("8nd05");

var $jgarO = parcelRequire("jgarO");
var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");
function $7df9c0c298ff1f9f$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $jgarO.lighten)((0, $jgarO.alpha)(theme.palette.divider, 1), 0.88);
    return (0, $jgarO.darken)((0, $jgarO.alpha)(theme.palette.divider, 1), 0.68);
}
const $7df9c0c298ff1f9f$var$columnHeadersStyles = {
    [`.${(0, $5H1vo.gridClasses).columnSeparator}, .${(0, $5H1vo.gridClasses)['columnSeparator--resizing']}`]: {
        visibility: 'visible',
        width: 'auto'
    }
};
const $7df9c0c298ff1f9f$var$columnHeaderStyles = {
    [`& .${(0, $5H1vo.gridClasses).iconButtonContainer}`]: {
        visibility: 'visible',
        width: 'auto'
    },
    [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: {
        width: 'auto',
        visibility: 'visible'
    }
};
const $7df9c0c298ff1f9f$export$42458c7ae3a97297 = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $5H1vo.gridClasses).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $5H1vo.gridClasses).aggregationColumnHeader}`]: styles.aggregationColumnHeader
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['aggregationColumnHeader--alignLeft']}`]: styles['aggregationColumnHeader--alignLeft']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['aggregationColumnHeader--alignCenter']}`]: styles['aggregationColumnHeader--alignCenter']
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['aggregationColumnHeader--alignRight']}`]: styles['aggregationColumnHeader--alignRight']
            },
            {
                [`&.${(0, $5H1vo.gridClasses).aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
            },
            {
                [`&.${(0, $5H1vo.gridClasses)['root--disableUserSelection']} .${(0, $5H1vo.gridClasses).cell}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${(0, $5H1vo.gridClasses).autosizing}`]: styles.autosizing
            },
            {
                [`& .${(0, $5H1vo.gridClasses).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--textRight']}`]: styles['cell--textRight']
            },
            // TODO v6: Remove
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--withRenderer']}`]: styles['cell--withRenderer']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cell}`]: styles.cell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellContent}`]: styles.cellContent
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $5H1vo.gridClasses).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $5H1vo.gridClasses).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $5H1vo.gridClasses).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $5H1vo.gridClasses).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $5H1vo.gridClasses).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).row}`]: styles.row
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $5H1vo.gridClasses).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${(0, $5H1vo.gridClasses).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $5H1vo.gridClasses).withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $5H1vo.gridClasses).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $5H1vo.gridClasses)['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            styles.root
        ]
})(({ theme: theme })=>{
    const borderColor = $7df9c0c298ff1f9f$var$getBorderColor(theme);
    const radius = theme.shape.borderRadius;
    const gridStyle = (0, $8nd05.default)({
        '--unstable_DataGrid-radius': typeof radius === 'number' ? `${radius}px` : radius,
        '--unstable_DataGrid-headWeight': theme.typography.fontWeightMedium,
        '--unstable_DataGrid-overlayBackground': theme.vars ? `rgba(${theme.vars.palette.background.defaultChannel} / ${theme.vars.palette.action.disabledOpacity})` : (0, $jgarO.alpha)(theme.palette.background.default, theme.palette.action.disabledOpacity),
        '--DataGrid-cellOffsetMultiplier': 2,
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: borderColor,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body2, {
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        [`&.${(0, $5H1vo.gridClasses).autoHeight}`]: {
            height: 'auto',
            [`& .${(0, $5H1vo.gridClasses)['row--lastVisible']} .${(0, $5H1vo.gridClasses).cell}`]: {
                borderBottomColor: 'transparent'
            }
        },
        [`&.${(0, $5H1vo.gridClasses).autosizing}`]: {
            [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            [`& .${(0, $5H1vo.gridClasses).cell} > *`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap'
            },
            [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`& .${(0, $5H1vo.gridClasses)['virtualScrollerContent--overflowed']} .${(0, $5H1vo.gridClasses)['row--lastVisible']} .${(0, $5H1vo.gridClasses).cell}`]: {
            borderBottomColor: 'transparent'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}, & .${(0, $5H1vo.gridClasses).cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            lineHeight: null,
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus-within, & .${(0, $5H1vo.gridClasses).cell}:focus-within`]: {
            outline: `solid ${theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.5)` : (0, $jgarO.alpha)(theme.palette.primary.main, 0.5)} 1px`,
            outlineWidth: 1,
            outlineOffset: -1
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:focus, & .${(0, $5H1vo.gridClasses).cell}:focus`]: {
            outline: `solid ${theme.palette.primary.main} 1px`
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderCheckbox}, & .${(0, $5H1vo.gridClasses).cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--sorted']} .${(0, $5H1vo.gridClasses).iconButtonContainer}, & .${(0, $5H1vo.gridClasses)['columnHeader--filtered']} .${(0, $5H1vo.gridClasses).iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeader}:not(.${(0, $5H1vo.gridClasses)['columnHeader--sorted']}) .${(0, $5H1vo.gridClasses).sortIcon}`]: {
            opacity: 0,
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            })
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            // to anchor the aggregation label
            position: 'relative'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--filledGroup']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--filledGroup']}.${(0, $5H1vo.gridClasses)['columnHeader--showColumnBorder']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            borderBottom: `none`
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--filledGroup']}.${(0, $5H1vo.gridClasses)['columnHeader--showColumnBorder']}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $5H1vo.gridClasses).headerFilterRow}`]: {
            borderTop: `1px solid ${borderColor}`
        },
        [`& .${(0, $5H1vo.gridClasses).sortIcon}, & .${(0, $5H1vo.gridClasses).filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}, & .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignCenter']} .${(0, $5H1vo.gridClasses).menuIcon}, & .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -6
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).menuIcon}, & .${(0, $5H1vo.gridClasses)['columnHeader--alignRight']} .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -10
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--moving']}`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`& .${(0, $5H1vo.gridClasses).columnSeparator}`]: {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: borderColor
        },
        '@media (hover: hover)': {
            [`& .${(0, $5H1vo.gridClasses).columnHeaders}:hover`]: $7df9c0c298ff1f9f$var$columnHeadersStyles,
            [`& .${(0, $5H1vo.gridClasses).columnHeader}:hover`]: $7df9c0c298ff1f9f$var$columnHeaderStyles,
            [`& .${(0, $5H1vo.gridClasses).columnHeader}:not(.${(0, $5H1vo.gridClasses)['columnHeader--sorted']}):hover .${(0, $5H1vo.gridClasses).sortIcon}`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${(0, $5H1vo.gridClasses).columnHeaders}`]: $7df9c0c298ff1f9f$var$columnHeadersStyles,
            [`& .${(0, $5H1vo.gridClasses).columnHeader}`]: $7df9c0c298ff1f9f$var$columnHeaderStyles
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideLeft']}`]: {
            left: -12
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--sideRight']}`]: {
            right: -12
        },
        [`& .${(0, $5H1vo.gridClasses)['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            '&:hover': {
                color: (theme.vars || theme).palette.text.primary,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    color: borderColor
                }
            },
            [`&.${(0, $5H1vo.gridClasses)['columnSeparator--resizing']}`]: {
                color: (theme.vars || theme).palette.text.primary
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${(0, $5H1vo.gridClasses).iconSeparator}`]: {
            color: 'inherit'
        },
        [`& .${(0, $5H1vo.gridClasses).menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -10,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${(0, $5H1vo.gridClasses).menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $5H1vo.gridClasses).row}`]: {
            display: 'flex',
            width: 'fit-content',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '&:hover, &.Mui-hovered': {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(
                ${theme.vars.palette.action.selectedOpacity} + 
                ${theme.vars.palette.action.hoverOpacity}
              ))` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`& .${(0, $5H1vo.gridClasses).cell}`]: {
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid',
            '&.Mui-selected': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity + theme.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`&.${(0, $5H1vo.gridClasses)['root--disableUserSelection']} .${(0, $5H1vo.gridClasses).cell}`]: {
            userSelect: 'none'
        },
        [`& .${(0, $5H1vo.gridClasses).row}:not(.${(0, $5H1vo.gridClasses)['row--dynamicHeight']}) > .${(0, $5H1vo.gridClasses).cell}`]: {
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        },
        [`& .${(0, $5H1vo.gridClasses).cellContent}`]: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        [`& .${(0, $5H1vo.gridClasses).cell}.${(0, $5H1vo.gridClasses)['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${(0, $5H1vo.gridClasses).cell}.${(0, $5H1vo.gridClasses)['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: theme.shadows[2],
            backgroundColor: (theme.vars || theme).palette.background.paper,
            '&:focus-within': {
                outline: `solid ${(theme.vars || theme).palette.primary.main} 1px`,
                outlineOffset: '-1px'
            }
        },
        [`& .${(0, $5H1vo.gridClasses)['row--editing']}`]: {
            boxShadow: theme.shadows[2]
        },
        [`& .${(0, $5H1vo.gridClasses)['row--editing']} .${(0, $5H1vo.gridClasses).cell}`]: {
            boxShadow: theme.shadows[0],
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`& .${(0, $5H1vo.gridClasses).editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).booleanCell}[data-value="true"]`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`& .${(0, $5H1vo.gridClasses).booleanCell}[data-value="false"]`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`& .${(0, $5H1vo.gridClasses).actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: theme.spacing(1)
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${(0, $5H1vo.gridClasses)['rowReorderCell--draggable']}`]: {
            cursor: 'move',
            opacity: 1
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCellContainer}`]: {
            padding: 0,
            alignItems: 'stretch'
        },
        [`.${(0, $5H1vo.gridClasses).withBorderColor}`]: {
            borderColor: borderColor
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--withRightBorder']}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--withRightBorder']}`]: {
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textLeft']}`]: {
            justifyContent: 'flex-start'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textRight']}`]: {
            justifyContent: 'flex-end'
        },
        [`& .${(0, $5H1vo.gridClasses)['cell--textCenter']}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${(0, $5H1vo.gridClasses)['columnHeader--dragging']}, & .${(0, $5H1vo.gridClasses)['row--dragging']}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& .${(0, $5H1vo.gridClasses)['row--dragging']}`]: {
            background: (theme.vars || theme).palette.background.paper,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            [`& .${(0, $5H1vo.gridClasses).rowReorderCellPlaceholder}`]: {
                display: 'flex'
            }
        },
        [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        },
        [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $5H1vo.gridClasses).groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: theme.spacing(2)
        }
    });
    return gridStyle;
});

});
parcelRegister("jgarO", function(module, exports) {

$parcel$export(module.exports, "alpha", () => $e0579d99723e0dfe$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $e0579d99723e0dfe$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $e0579d99723e0dfe$export$c0816ed86df316af);

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $e0579d99723e0dfe$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e0579d99723e0dfe$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}
function $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e0579d99723e0dfe$export$677b39864803984e(background);
    const overlayColor = $e0579d99723e0dfe$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});



parcelRegister("eu7ae", function(module, exports) {

$parcel$export(module.exports, "GridContextProvider", () => $a8b96ca779d42ed2$export$4fd26c08a15cabb4);

var $acw62 = parcelRequire("acw62");

var $YSznt = parcelRequire("YSznt");

var $er55f = parcelRequire("er55f");

var $96LtV = parcelRequire("96LtV");

var $ayMG0 = parcelRequire("ayMG0");
function $a8b96ca779d42ed2$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, props: props, children: children }) {
    const apiRef = $acw62.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96LtV.GridRootPropsContext).Provider, {
        value: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $er55f.GridPrivateApiContext).Provider, {
            value: privateApiRef,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $YSznt.GridApiContext).Provider, {
                value: apiRef,
                children: children
            })
        })
    });
}

});
parcelRegister("YSznt", function(module, exports) {

$parcel$export(module.exports, "GridApiContext", () => $0b6fef1928293673$export$70c437c2dab15e52);

var $acw62 = parcelRequire("acw62");
const $0b6fef1928293673$export$70c437c2dab15e52 = /*#__PURE__*/ $acw62.createContext(undefined);

});


parcelRegister("5W2Ws", function(module, exports) {

$parcel$export(module.exports, "useDataGridComponent", () => $4524a6bb6d2f99a9$export$4b018ab7873d790d);

var $2ly38 = parcelRequire("2ly38");

var $n73Rs = parcelRequire("n73Rs");

var $DJVd0 = parcelRequire("DJVd0");

var $ervnQ = parcelRequire("ervnQ");

var $8JOxm = parcelRequire("8JOxm");

var $izeLD = parcelRequire("izeLD");

var $gU8sa = parcelRequire("gU8sa");

var $4D37q = parcelRequire("4D37q");

var $cx8m0 = parcelRequire("cx8m0");

var $1lT2X = parcelRequire("1lT2X");

var $12xQD = parcelRequire("12xQD");

var $3m1KX = parcelRequire("3m1KX");

var $4epuR = parcelRequire("4epuR");

var $fTRdy = parcelRequire("fTRdy");

var $2MkZt = parcelRequire("2MkZt");

var $5lqAx = parcelRequire("5lqAx");

var $6p8lp = parcelRequire("6p8lp");

var $cURqP = parcelRequire("cURqP");

var $5WmMt = parcelRequire("5WmMt");

var $jOu9i = parcelRequire("jOu9i");

var $gaDPW = parcelRequire("gaDPW");

var $2oqux = parcelRequire("2oqux");

var $Anab1 = parcelRequire("Anab1");

var $jBRsK = parcelRequire("jBRsK");

var $lb6pq = parcelRequire("lb6pq");

var $2H9Fl = parcelRequire("2H9Fl");

var $aFlgz = parcelRequire("aFlgz");

var $dfzFI = parcelRequire("dfzFI");
const $4524a6bb6d2f99a9$export$4b018ab7873d790d = (inputApiRef, props)=>{
    const apiRef = (0, $2ly38.useGridInitialization)(inputApiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $5WmMt.useGridRowSelectionPreProcessors)(apiRef, props);
    (0, $5lqAx.useGridRowsPreProcessors)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $n73Rs.useGridInitializeState)((0, $cURqP.rowSelectionStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $8JOxm.columnsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $2MkZt.rowsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $fTRdy.editingStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $1lT2X.focusStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $jOu9i.sortingStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $4epuR.preferencePanelStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $cx8m0.filterStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $izeLD.densityStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $3m1KX.paginationStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $jBRsK.rowsMetaStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $ervnQ.columnMenuStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $aFlgz.columnGroupsStateInitializer), apiRef, props);
    (0, $n73Rs.useGridInitializeState)((0, $dfzFI.virtualizationStateInitializer), apiRef, props);
    (0, $12xQD.useGridKeyboardNavigation)(apiRef, props);
    (0, $cURqP.useGridRowSelection)(apiRef, props);
    (0, $8JOxm.useGridColumns)(apiRef, props);
    (0, $2MkZt.useGridRows)(apiRef, props);
    (0, $6p8lp.useGridParamsApi)(apiRef, props);
    (0, $2H9Fl.useGridColumnSpanning)(apiRef);
    (0, $aFlgz.useGridColumnGrouping)(apiRef, props);
    (0, $fTRdy.useGridEditing)(apiRef, props);
    (0, $1lT2X.useGridFocus)(apiRef, props);
    (0, $4epuR.useGridPreferencesPanel)(apiRef, props);
    (0, $cx8m0.useGridFilter)(apiRef, props);
    (0, $jOu9i.useGridSorting)(apiRef, props);
    (0, $izeLD.useGridDensity)(apiRef, props);
    (0, $3m1KX.useGridPagination)(apiRef, props);
    (0, $jBRsK.useGridRowsMeta)(apiRef, props);
    (0, $gaDPW.useGridScroll)(apiRef, props);
    (0, $ervnQ.useGridColumnMenu)(apiRef);
    (0, $gU8sa.useGridCsvExport)(apiRef, props);
    (0, $4D37q.useGridPrintExport)(apiRef, props);
    (0, $DJVd0.useGridClipboard)(apiRef, props);
    (0, $Anab1.useGridDimensions)(apiRef, props);
    (0, $2oqux.useGridEvents)(apiRef, props);
    (0, $lb6pq.useGridStatePersistence)(apiRef);
    (0, $dfzFI.useGridVirtualization)(apiRef, props);
    return apiRef;
};

});
parcelRegister("2ly38", function(module, exports) {

$parcel$export(module.exports, "useGridInitialization", () => $1b57f47831f90cfc$export$b77462c86b28bbf0);

var $eCZBN = parcelRequire("eCZBN");

var $30tkX = parcelRequire("30tkX");

var $bPgEz = parcelRequire("bPgEz");

var $c4Tvs = parcelRequire("c4Tvs");

var $42J2j = parcelRequire("42J2j");

var $bh93C = parcelRequire("bh93C");
const $1b57f47831f90cfc$export$b77462c86b28bbf0 = (inputApiRef, props)=>{
    const privateApiRef = (0, $30tkX.useGridApiInitialization)(inputApiRef, props);
    (0, $eCZBN.useGridLoggerFactory)(privateApiRef, props);
    (0, $bh93C.useGridStateInitialization)(privateApiRef, props);
    (0, $c4Tvs.useGridPipeProcessing)(privateApiRef);
    (0, $42J2j.useGridStrategyProcessing)(privateApiRef);
    (0, $bPgEz.useGridLocaleText)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
    return privateApiRef;
};

});
parcelRegister("eCZBN", function(module, exports) {

$parcel$export(module.exports, "useGridLoggerFactory", () => $aa6467766a16a196$export$db6c72f4003d67df);

var $acw62 = parcelRequire("acw62");

var $lR3Vo = parcelRequire("lR3Vo");

var $ivFej = parcelRequire("ivFej");
const $aa6467766a16a196$var$forceDebug = (0, $lR3Vo.localStorageAvailable)() && window.localStorage.getItem('DEBUG') != null;
const $aa6467766a16a196$var$noop = ()=>{};
const $aa6467766a16a196$var$noopLogger = {
    debug: $aa6467766a16a196$var$noop,
    info: $aa6467766a16a196$var$noop,
    warn: $aa6467766a16a196$var$noop,
    error: $aa6467766a16a196$var$noop
};
const $aa6467766a16a196$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $aa6467766a16a196$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $aa6467766a16a196$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI: Log level ${logLevel} not recognized.`);
    const logger = $aa6467766a16a196$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $aa6467766a16a196$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $aa6467766a16a196$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $acw62.useCallback((name)=>{
        if ($aa6467766a16a196$var$forceDebug) return $aa6467766a16a196$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $aa6467766a16a196$var$noopLogger;
        return $aa6467766a16a196$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, {
        getLogger: getLogger
    }, 'private');
};

});
parcelRegister("lR3Vo", function(module, exports) {

$parcel$export(module.exports, "isNumber", () => $fe919794eb3b24e8$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $fe919794eb3b24e8$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $fe919794eb3b24e8$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "localStorageAvailable", () => $fe919794eb3b24e8$export$c43914e0cb16a981);
$parcel$export(module.exports, "escapeRegExp", () => $fe919794eb3b24e8$export$7c57da42ce8e346f);
$parcel$export(module.exports, "clamp", () => $fe919794eb3b24e8$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "isDeepEqual", () => $fe919794eb3b24e8$export$78fdc9adc3f30400);
$parcel$export(module.exports, "randomNumberBetween", () => $fe919794eb3b24e8$export$ffd8c9a5b80f1e57);
$parcel$export(module.exports, "deepClone", () => $fe919794eb3b24e8$export$b7d58db314e0ac27);
function $fe919794eb3b24e8$export$7e4aa119212bc614(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $fe919794eb3b24e8$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $fe919794eb3b24e8$export$a6cdc56e425d0d0a(value) {
    return typeof value === 'object' && value !== null;
}
function $fe919794eb3b24e8$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $fe919794eb3b24e8$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const $fe919794eb3b24e8$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $fe919794eb3b24e8$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$fe919794eb3b24e8$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $fe919794eb3b24e8$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $fe919794eb3b24e8$export$ffd8c9a5b80f1e57(seed, min, max) {
    const random = $fe919794eb3b24e8$var$mulberry32(seed);
    return ()=>min + (max - min) * random();
}
function $fe919794eb3b24e8$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}

});

parcelRegister("ivFej", function(module, exports) {

$parcel$export(module.exports, "useGridApiMethod", () => $d79b1aa4f5237e85$export$739f6b6a65e76d6c);

var $acw62 = parcelRequire("acw62");
function $d79b1aa4f5237e85$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}

});


parcelRegister("30tkX", function(module, exports) {

$parcel$export(module.exports, "useGridApiInitialization", () => $230820e73b0114fd$export$72d4a6c5ec1a4b32);

var $acw62 = parcelRequire("acw62");

var $66H87 = parcelRequire("66H87");

var $ivFej = parcelRequire("ivFej");

var $eFF1m = parcelRequire("eFF1m");

var $9G1r7 = parcelRequire("9G1r7");
const $230820e73b0114fd$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $230820e73b0114fd$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $230820e73b0114fd$export$37686f243ec62a21(publicApi) {
    return publicApi[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
}
let $230820e73b0114fd$var$globalId = 0;
function $230820e73b0114fd$var$createPrivateAPI(publicApiRef) {
    var _publicApiRef$current;
    const existingPrivateApi = (_publicApiRef$current = publicApiRef.current) == null ? void 0 : _publicApiRef$current[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $66H87.Store).create(state),
        instanceId: {
            id: $230820e73b0114fd$var$globalId
        }
    };
    $230820e73b0114fd$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if ((currentPrivateMethod == null ? void 0 : currentPrivateMethod.spying) === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if ((currentPublicMethod == null ? void 0 : currentPublicMethod.spying) === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new (0, $9G1r7.EventManager)()
    });
    return privateApi;
}
function $230820e73b0114fd$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$230820e73b0114fd$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $230820e73b0114fd$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $acw62.useRef();
    const privateApiRef = $acw62.useRef();
    if (!privateApiRef.current) privateApiRef.current = $230820e73b0114fd$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $230820e73b0114fd$var$createPublicAPI(privateApiRef);
    const publishEvent = $acw62.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($230820e73b0114fd$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $eFF1m.GridSignature).DataGridPro ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $acw62.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $ivFej.useGridApiMethod)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    $acw62.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $acw62.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}

});
parcelRegister("66H87", function(module, exports) {

$parcel$export(module.exports, "Store", () => $4724c2545021bcfd$export$390f32400eaf98c9);
class $4724c2545021bcfd$export$390f32400eaf98c9 {
    static create(value) {
        return new $4724c2545021bcfd$export$390f32400eaf98c9(value);
    }
    constructor(_value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (value)=>{
            this.value = value;
            this.listeners.forEach((l)=>l(value));
        };
        this.value = _value;
        this.listeners = new Set();
    }
}

});

parcelRegister("eFF1m", function(module, exports) {

$parcel$export(module.exports, "GridSignature", () => $aae4b6f00de039ba$export$544be0bdf85b5af1);
$parcel$export(module.exports, "useGridApiEventHandler", () => $aae4b6f00de039ba$export$223e28bfc0254c87);
$parcel$export(module.exports, "useGridApiOptionHandler", () => $aae4b6f00de039ba$export$d55ddab8b28954db);

var $acw62 = parcelRequire("acw62");

var $7j5jX = parcelRequire("7j5jX");

var $gCT87 = parcelRequire("gCT87");
/**
 * Signal to the underlying logic what version of the public component API
 * of the data grid is exposed.
 */ var $aae4b6f00de039ba$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    return GridSignature;
}($aae4b6f00de039ba$export$544be0bdf85b5af1 || {});
// We use class to make it easier to detect in heap snapshots by name
class $aae4b6f00de039ba$var$ObjectToBeRetainedByReact {
}
function $aae4b6f00de039ba$export$4c5a9251aa47d2f8(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new (0, $gCT87.FinalizationRegistryBasedCleanupTracking)() : new (0, $7j5jX.TimerBasedCleanupTracking)();
        const [objectRetainedByReact] = $acw62.useState(new $aae4b6f00de039ba$var$ObjectToBeRetainedByReact());
        const subscription = $acw62.useRef(null);
        const handlerRef = $acw62.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = $acw62.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) {
                    var _handlerRef$current;
                    (_handlerRef$current = handlerRef.current) == null || _handlerRef$current.call(handlerRef, params, event, details);
                }
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                var _subscription$current;
                (_subscription$current = subscription.current) == null || _subscription$current.call(subscription);
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $acw62.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) {
                        var _handlerRef$current2;
                        (_handlerRef$current2 = handlerRef.current) == null || _handlerRef$current2.call(handlerRef, params, event, details);
                    }
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                var _subscription$current2;
                (_subscription$current2 = subscription.current) == null || _subscription$current2.call(subscription);
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const $aae4b6f00de039ba$var$registryContainer = {
    registry: null
};
const $aae4b6f00de039ba$export$c5af18cc30c6146f = ()=>{
    var _registryContainer$re;
    (_registryContainer$re = $aae4b6f00de039ba$var$registryContainer.registry) == null || _registryContainer$re.reset();
    $aae4b6f00de039ba$var$registryContainer.registry = null;
};
const $aae4b6f00de039ba$export$223e28bfc0254c87 = $aae4b6f00de039ba$export$4c5a9251aa47d2f8($aae4b6f00de039ba$var$registryContainer);
const $aae4b6f00de039ba$var$optionsSubscriberOptions = {
    isFirst: true
};
function $aae4b6f00de039ba$export$d55ddab8b28954db(apiRef, eventName, handler) {
    // Validate that only one per event name?
    $aae4b6f00de039ba$export$223e28bfc0254c87(apiRef, eventName, handler, $aae4b6f00de039ba$var$optionsSubscriberOptions);
}

});
parcelRegister("7j5jX", function(module, exports) {

$parcel$export(module.exports, "TimerBasedCleanupTracking", () => $551e6f5a35c0c62f$export$c16cf791cc6bf0c7);
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $551e6f5a35c0c62f$export$c16cf791cc6bf0c7 {
    constructor(timeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}

});

parcelRegister("gCT87", function(module, exports) {

$parcel$export(module.exports, "FinalizationRegistryBasedCleanupTracking", () => $c1aaf59f4b0a47d9$export$86b678dc9d8f7603);
class $c1aaf59f4b0a47d9$export$86b678dc9d8f7603 {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}

});


parcelRegister("9G1r7", function(module, exports) {

$parcel$export(module.exports, "EventManager", () => $70b926848d622179$export$cc74486daaaef499);
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $70b926848d622179$export$cc74486daaaef499 {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}

});


parcelRegister("bPgEz", function(module, exports) {

$parcel$export(module.exports, "useGridLocaleText", () => $89c1602309335bde$export$9943f2ed4ddf85bf);

var $acw62 = parcelRequire("acw62");
const $89c1602309335bde$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $acw62.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};

});

parcelRegister("c4Tvs", function(module, exports) {

$parcel$export(module.exports, "useGridPipeProcessing", () => $8cb0ea30b515dc96$export$1c5794e7ed1dc58f);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $8cb0ea30b515dc96$export$1c5794e7ed1dc58f = (apiRef)=>{
    const processorsCache = $acw62.useRef({});
    const isRunning = $acw62.useRef(false);
    const runAppliers = $acw62.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $acw62.useCallback((group, id, processor)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        const groupCache = processorsCache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            runAppliers(groupCache);
        }
        return ()=>{
            processorsCache.current[group].processors.set(id, null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = $acw62.useCallback((group, id, applier)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        processorsCache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = processorsCache.current[group].appliers, otherAppliers = (0, $1En50.default)(_appliers, [
                id
            ].map((0, $4ZreY.default)));
            processorsCache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $acw62.useCallback((group)=>{
        const groupCache = processorsCache.current[group];
        runAppliers(groupCache);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $acw62.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!processorsCache.current[group]) return value;
        const preProcessors = Array.from(processorsCache.current[group].processors.values());
        return preProcessors.reduce((acc, preProcessor)=>{
            if (!preProcessor) return acc;
            return preProcessor(acc, context);
        }, value);
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPrivateApi, 'private');
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPublicApi, 'public');
};

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("42J2j", function(module, exports) {

$parcel$export(module.exports, "GRID_DEFAULT_STRATEGY", () => $2f1a4898f1e92309$export$84214fbf04c4094);
$parcel$export(module.exports, "useGridStrategyProcessing", () => $2f1a4898f1e92309$export$594711f8e5fa9b04);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $2f1a4898f1e92309$export$84214fbf04c4094 = 'none';
const $2f1a4898f1e92309$export$8c4aa1977ad5d106 = {
    rowTreeCreation: 'rowTree',
    filtering: 'rowTree',
    sorting: 'rowTree',
    visibleRowsLookupCreation: 'rowTree'
};
const $2f1a4898f1e92309$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $acw62.useRef(new Map());
    const strategiesCache = $acw62.useRef({});
    const registerStrategyProcessor = $acw62.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $1En50.default)(_ref, [
                strategyName
            ].map((0, $4ZreY.default)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($2f1a4898f1e92309$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $acw62.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($2f1a4898f1e92309$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $acw62.useCallback((strategyGroup)=>{
        var _availableStrategyEnt;
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return (_availableStrategyEnt = availableStrategyEntry == null ? void 0 : availableStrategyEntry[0]) != null ? _availableStrategyEnt : $2f1a4898f1e92309$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $acw62.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $ivFej.useGridApiMethod)(apiRef, strategyProcessingApi, 'private');
};

});

parcelRegister("bh93C", function(module, exports) {

$parcel$export(module.exports, "useGridStateInitialization", () => $83584edf0ae98213$export$53c7ec825c1e4d3f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $lR3Vo = parcelRequire("lR3Vo");
const $83584edf0ae98213$export$53c7ec825c1e4d3f = (apiRef, props)=>{
    const controlStateMapRef = $acw62.useRef({});
    const [, rawForceUpdate] = $acw62.useState();
    const registerControlState = $acw62.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $acw62.useCallback((state, reason)=>{
        let newState;
        if ((0, $lR3Vo.isFunction)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            if (apiRef.current.publishEvent) apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) {
                const details = props.signature === (0, $eFF1m.GridSignature).DataGridPro ? {
                    api: apiRef.current,
                    reason: reason
                } : {
                    reason: reason
                };
                controlState.propOnChange(model, details);
            }
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef,
        props.signature
    ]);
    const updateControlState = $acw62.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $8nd05.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = $acw62.useCallback(()=>rawForceUpdate(()=>apiRef.current.state), [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState,
        forceUpdate: forceUpdate
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, publicStateApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, privateStateApi, 'private');
};

});


parcelRegister("n73Rs", function(module, exports) {

$parcel$export(module.exports, "useGridInitializeState", () => $0457a051e38141f4$export$f9587d613f2caeec);

var $acw62 = parcelRequire("acw62");
const $0457a051e38141f4$export$f9587d613f2caeec = (initializer, privateApiRef, props)=>{
    const isInitialized = $acw62.useRef(false);
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};

});

parcelRegister("DJVd0", function(module, exports) {

$parcel$export(module.exports, "useGridClipboard", () => $077743baf33b26c9$export$a44b2f69ac6aef73);

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");
var $dRE9O = parcelRequire("dRE9O");

var $drCmI = parcelRequire("drCmI");

var $k5aPx = parcelRequire("k5aPx");
function $077743baf33b26c9$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $077743baf33b26c9$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $077743baf33b26c9$var$writeToClipboardPolyfill(data);
    });
    else $077743baf33b26c9$var$writeToClipboardPolyfill(data);
}
function $077743baf33b26c9$var$hasNativeSelection(element) {
    var _window$getSelection;
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if ((_window$getSelection = window.getSelection()) != null && _window$getSelection.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $077743baf33b26c9$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $acw62.useCallback((event)=>{
        if (!((event.ctrlKey || event.metaKey) && event.key === 'c')) return;
        // Do nothing if there's a native selection
        if ($077743baf33b26c9$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRows = apiRef.current.getSelectedRows();
        if (selectedRows.size > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $k5aPx.serializeCellValue)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $077743baf33b26c9$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $dRE9O.useGridNativeEventListener)(apiRef, apiRef.current.rootElementRef, 'keydown', handleCopy);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};

});
parcelRegister("dRE9O", function(module, exports) {

$parcel$export(module.exports, "useGridNativeEventListener", () => $a17f600338696a2d$export$265f4c39182036e);

var $acw62 = parcelRequire("acw62");

var $lR3Vo = parcelRequire("lR3Vo");

var $luu6e = parcelRequire("luu6e");
const $a17f600338696a2d$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useNativeEventListener');
    const [added, setAdded] = $acw62.useState(false);
    const handlerRef = $acw62.useRef(handler);
    const wrapHandler = $acw62.useCallback((event)=>{
        return handlerRef.current && handlerRef.current(event);
    }, []);
    $acw62.useEffect(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    $acw62.useEffect(()=>{
        let targetElement;
        if ((0, $lR3Vo.isFunction)(ref)) targetElement = ref();
        else targetElement = ref && ref.current ? ref.current : null;
        if (targetElement && eventName && !added) {
            logger.debug(`Binding native ${eventName} event`);
            targetElement.addEventListener(eventName, wrapHandler, options);
            const boundElem = targetElement;
            setAdded(true);
            const unsubscribe = ()=>{
                logger.debug(`Clearing native ${eventName} event`);
                boundElem.removeEventListener(eventName, wrapHandler, options);
            };
            apiRef.current.subscribeEvent('unmount', unsubscribe);
        }
    }, [
        ref,
        wrapHandler,
        eventName,
        added,
        logger,
        options,
        apiRef
    ]);
};

});
parcelRegister("luu6e", function(module, exports) {

$parcel$export(module.exports, "useGridLogger", () => $fa53bf7350a63511$export$eb512164890e58f0);

var $acw62 = parcelRequire("acw62");
function $fa53bf7350a63511$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $acw62.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}

});


parcelRegister("k5aPx", function(module, exports) {

$parcel$export(module.exports, "serializeCellValue", () => $e9ecacf5d98b0bad$export$edda57d2a460473d);
$parcel$export(module.exports, "buildCSV", () => $e9ecacf5d98b0bad$export$8bfbf32dccc29440);

var $5bG6h = parcelRequire("5bG6h");

var $ehSzT = parcelRequire("ehSzT");
function $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions) {
    if (typeof value === 'string') {
        if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
            const escapedValue = value.replace(/"/g, '""');
            // Make sure value containing delimiter or line break won't be split into multiple cells
            if ([
                csvOptions.delimiter,
                '\n',
                '\r',
                '"'
            ].some((delimiter)=>value.includes(delimiter))) return `"${escapedValue}"`;
            if (csvOptions.escapeFormulas) {
                // See https://owasp.org/www-community/attacks/CSV_Injection
                if ([
                    '=',
                    '+',
                    '-',
                    '@',
                    '\t',
                    '\r'
                ].includes(escapedValue[0])) return `'${escapedValue}`;
            }
            return escapedValue;
        }
        return value;
    }
    return value;
}
const $e9ecacf5d98b0bad$export$edda57d2a460473d = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        var _cellParams$value2;
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') {
            var _cellParams$value;
            value = (_cellParams$value = cellParams.value) == null ? void 0 : _cellParams$value.toISOString();
        } else if (typeof ((_cellParams$value2 = cellParams.value) == null ? void 0 : _cellParams$value2.toString) === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions);
};
const $e9ecacf5d98b0bad$var$objectFormattedValueWarning = (0, $ehSzT.buildWarning)([
    'MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.',
    'You can provide a `valueFormatter` with a string representation to be used.'
]);
class $e9ecacf5d98b0bad$var$CSVRow {
    constructor(options){
        this.options = void 0;
        this.rowString = '';
        this.isEmpty = true;
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (value === null || value === undefined) this.rowString += '';
        else if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $e9ecacf5d98b0bad$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($e9ecacf5d98b0bad$export$edda57d2a460473d(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $e9ecacf5d98b0bad$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$e9ecacf5d98b0bad$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.unstable_getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.unstable_getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $e9ecacf5d98b0bad$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}

});
parcelRegister("5bG6h", function(module, exports) {

$parcel$export(module.exports, "GRID_CHECKBOX_SELECTION_FIELD", () => $3c6ea315aeb792f9$export$322dfed7a1df1b02);
$parcel$export(module.exports, "GRID_CHECKBOX_SELECTION_COL_DEF", () => $3c6ea315aeb792f9$export$b2e9ab6103a664ad);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $fgOJy = parcelRequire("fgOJy");

var $4l3r5 = parcelRequire("4l3r5");

var $av74L = parcelRequire("av74L");

var $iNueb = parcelRequire("iNueb");

var $ayMG0 = parcelRequire("ayMG0");
const $3c6ea315aeb792f9$export$322dfed7a1df1b02 = '__check__';
const $3c6ea315aeb792f9$export$b2e9ab6103a664ad = (0, $8nd05.default)({}, (0, $iNueb.GRID_BOOLEAN_COL_DEF), {
    field: $3c6ea315aeb792f9$export$322dfed7a1df1b02,
    type: 'checkboxSelection',
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined,
    valueGetter: (params)=>{
        const selectionLookup = (0, $av74L.selectedIdsLookupSelector)(params.api.state, params.api.instanceId);
        return selectionLookup[params.id] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4l3r5.GridHeaderCheckbox), (0, $8nd05.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $fgOJy.GridCellCheckboxRenderer), (0, $8nd05.default)({}, params))
});

});
parcelRegister("fgOJy", function(module, exports) {

$parcel$export(module.exports, "GridCellCheckboxRenderer", () => $b1dfb45352a7562a$export$6df0a29182db5ff8);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $3qSdM = parcelRequire("3qSdM");

var $dMF9H = parcelRequire("dMF9H");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $b1dfb45352a7562a$var$_excluded = [
    "field",
    "id",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $b1dfb45352a7562a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $b1dfb45352a7562a$export$de9fc2d8e98d780 = /*#__PURE__*/ $acw62.forwardRef(function GridCellCheckboxRenderer(props, ref) {
    var _rootProps$slotProps;
    const { field: field, id: id, value: isChecked, rowNode: rowNode, hasFocus: hasFocus, tabIndex: tabIndex } = props, other = (0, $1En50.default)(props, $b1dfb45352a7562a$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b1dfb45352a7562a$var$useUtilityClasses(ownerState);
    const checkboxElement = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(checkboxElement, ref);
    const element = apiRef.current.getCellElement(id, field);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $acw62.useLayoutEffect(()=>{
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        element,
        tabIndex
    ]);
    $acw62.useEffect(()=>{
        if (hasFocus) {
            var _checkboxElement$curr;
            const input = (_checkboxElement$curr = checkboxElement.current) == null ? void 0 : _checkboxElement$curr.querySelector('input');
            input == null || input.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if ((0, $dMF9H.isSpaceKey)(event.key)) // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const isSelectable = apiRef.current.isRowSelectable(id);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
        ref: handleRef,
        tabIndex: tabIndex,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        onKeyDown: handleKeyDown,
        disabled: !isSelectable,
        touchRippleRef: rippleRef
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
const $b1dfb45352a7562a$export$6df0a29182db5ff8 = $b1dfb45352a7562a$export$de9fc2d8e98d780;

});
parcelRegister("dMF9H", function(module, exports) {

$parcel$export(module.exports, "isEscapeKey", () => $a08faead7d1bb429$export$a6587fe901c3baf7);
$parcel$export(module.exports, "isEnterKey", () => $a08faead7d1bb429$export$b043658e6147d6f8);
$parcel$export(module.exports, "isTabKey", () => $a08faead7d1bb429$export$34e5042f80daa3dd);
$parcel$export(module.exports, "isSpaceKey", () => $a08faead7d1bb429$export$f2db841f07bb1f8e);
$parcel$export(module.exports, "isPrintableKey", () => $a08faead7d1bb429$export$b3f2c64190cf8c4);
$parcel$export(module.exports, "isNavigationKey", () => $a08faead7d1bb429$export$e13d96c38a470518);
$parcel$export(module.exports, "isKeyboardEvent", () => $a08faead7d1bb429$export$130b789831072f4c);
$parcel$export(module.exports, "isHideMenuKey", () => $a08faead7d1bb429$export$81301abbcd0c8143);
const $a08faead7d1bb429$export$a6587fe901c3baf7 = (key)=>key === 'Escape'; // TODO remove
const $a08faead7d1bb429$export$b043658e6147d6f8 = (key)=>key === 'Enter'; // TODO remove
const $a08faead7d1bb429$export$34e5042f80daa3dd = (key)=>key === 'Tab'; // TODO remove
const $a08faead7d1bb429$export$f2db841f07bb1f8e = (key)=>key === ' ';
const $a08faead7d1bb429$export$beff32ba02dcfc32 = (key)=>key.indexOf('Arrow') === 0;
const $a08faead7d1bb429$export$8f13b7ff72c94db5 = (key)=>key === 'Home' || key === 'End';
const $a08faead7d1bb429$export$258861a58bef8261 = (key)=>key.indexOf('Page') === 0;
const $a08faead7d1bb429$export$384e0678699eaafd = (key)=>key === 'Delete' || key === 'Backspace';
function $a08faead7d1bb429$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $a08faead7d1bb429$export$b7d709ba679d3811 = [
    'Meta',
    'Control',
    'Shift'
];
const $a08faead7d1bb429$export$cb76cac5e13767b3 = [
    'Enter',
    'Escape',
    'Tab'
];
const $a08faead7d1bb429$export$88516d667267d515 = [
    'Enter',
    'Tab'
];
const $a08faead7d1bb429$export$6ac2fcffa1f825f7 = (key)=>$a08faead7d1bb429$export$b7d709ba679d3811.indexOf(key) > -1;
const $a08faead7d1bb429$export$a8f5f024431d9642 = (event)=>$a08faead7d1bb429$export$b043658e6147d6f8(event.key) || $a08faead7d1bb429$export$384e0678699eaafd(event.key) || $a08faead7d1bb429$export$b3f2c64190cf8c4(event);
const $a08faead7d1bb429$export$f6a96f75820f81fd = (key)=>$a08faead7d1bb429$export$cb76cac5e13767b3.indexOf(key) > -1;
const $a08faead7d1bb429$export$d3e9cf1edead7ecb = (key)=>$a08faead7d1bb429$export$88516d667267d515.indexOf(key) > -1;
const $a08faead7d1bb429$export$e13d96c38a470518 = (key)=>$a08faead7d1bb429$export$8f13b7ff72c94db5(key) || $a08faead7d1bb429$export$beff32ba02dcfc32(key) || $a08faead7d1bb429$export$258861a58bef8261(key) || $a08faead7d1bb429$export$f2db841f07bb1f8e(key);
const $a08faead7d1bb429$export$130b789831072f4c = (event)=>!!event.key;
const $a08faead7d1bb429$export$81301abbcd0c8143 = (key)=>$a08faead7d1bb429$export$34e5042f80daa3dd(key) || $a08faead7d1bb429$export$a6587fe901c3baf7(key);

});

parcelRegister("bDyDY", function(module, exports) {

$parcel$export(module.exports, "useGridApiContext", () => $878e35c228656139$export$2d14edd3a7db3bbf);

var $acw62 = parcelRequire("acw62");

var $YSznt = parcelRequire("YSznt");
function $878e35c228656139$export$2d14edd3a7db3bbf() {
    const apiRef = $acw62.useContext((0, $YSznt.GridApiContext));
    if (apiRef === undefined) throw new Error([
        'MUI: Could not find the data grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the data grid.'
    ].join('\n'));
    return apiRef;
}

});


parcelRegister("4l3r5", function(module, exports) {

$parcel$export(module.exports, "GridHeaderCheckbox", () => $328bc9e57e6b696b$export$22c0c31c5dd8f5aa);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $5sOMZ = parcelRequire("5sOMZ");

var $drCmI = parcelRequire("drCmI");

var $av74L = parcelRequire("av74L");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $k278Q = parcelRequire("k278Q");

var $gPWuj = parcelRequire("gPWuj");

var $ayMG0 = parcelRequire("ayMG0");
const $328bc9e57e6b696b$var$_excluded = [
    "field",
    "colDef"
];
const $328bc9e57e6b696b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $328bc9e57e6b696b$export$22c0c31c5dd8f5aa = /*#__PURE__*/ $acw62.forwardRef(function GridHeaderCheckbox(props, ref) {
    var _rootProps$slotProps;
    const other = (0, $1En50.default)(props, $328bc9e57e6b696b$var$_excluded);
    const [, forceUpdate] = $acw62.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $328bc9e57e6b696b$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexColumnHeaderSelector));
    const selection = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.gridRowSelectionStateSelector));
    const visibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedSortedRowIdsSelector));
    const paginatedVisibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginatedVisibleSortedGridRowIdsSelector));
    const filteredSelection = $acw62.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== 'function') return selection;
        return selection.filter((id)=>{
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $acw62.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $acw62.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $acw62.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $acw62.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $acw62.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
        ref: ref,
        indeterminate: isIndeterminate,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});

});
parcelRegister("av74L", function(module, exports) {

$parcel$export(module.exports, "gridRowSelectionStateSelector", () => $7a5249c135fd39c1$export$f663bee74a6091fc);
$parcel$export(module.exports, "selectedGridRowsCountSelector", () => $7a5249c135fd39c1$export$2e16a09b9ae82bd3);
$parcel$export(module.exports, "selectedGridRowsSelector", () => $7a5249c135fd39c1$export$dd53f67f8b4cd8b1);
$parcel$export(module.exports, "selectedIdsLookupSelector", () => $7a5249c135fd39c1$export$d5aede24ebfe3c98);

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");
const $7a5249c135fd39c1$export$f663bee74a6091fc = (state)=>state.rowSelection;
const $7a5249c135fd39c1$export$2e16a09b9ae82bd3 = (0, $cgQ4y.createSelector)($7a5249c135fd39c1$export$f663bee74a6091fc, (selection)=>selection.length);
const $7a5249c135fd39c1$export$dd53f67f8b4cd8b1 = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$export$f663bee74a6091fc, (0, $goCyd.gridRowsLookupSelector), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const $7a5249c135fd39c1$export$d5aede24ebfe3c98 = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$export$f663bee74a6091fc, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));

});

parcelRegister("gPWuj", function(module, exports) {

$parcel$export(module.exports, "gridPaginationSelector", () => $c41ec74257ca380c$export$24c945ea033ce6cf);
$parcel$export(module.exports, "gridPaginationModelSelector", () => $c41ec74257ca380c$export$ccc9f04e59d0d8e6);
$parcel$export(module.exports, "gridPaginationRowCountSelector", () => $c41ec74257ca380c$export$946e4ae85da77ef6);
$parcel$export(module.exports, "gridPageSelector", () => $c41ec74257ca380c$export$1f7f64fcb62ccdad);
$parcel$export(module.exports, "gridPageSizeSelector", () => $c41ec74257ca380c$export$721a46720a2de097);
$parcel$export(module.exports, "gridPageCountSelector", () => $c41ec74257ca380c$export$b81026f1aaf843a4);
$parcel$export(module.exports, "gridPaginationRowRangeSelector", () => $c41ec74257ca380c$export$b76c99ac6ae901da);
$parcel$export(module.exports, "gridPaginatedVisibleSortedGridRowEntriesSelector", () => $c41ec74257ca380c$export$abcd649e974e3e96);
$parcel$export(module.exports, "gridPaginatedVisibleSortedGridRowIdsSelector", () => $c41ec74257ca380c$export$c1f6a976375edd4a);

var $cgQ4y = parcelRequire("cgQ4y");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");

var $baj2X = parcelRequire("baj2X");
const $c41ec74257ca380c$export$24c945ea033ce6cf = (state)=>state.pagination;
const $c41ec74257ca380c$export$ccc9f04e59d0d8e6 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $c41ec74257ca380c$export$946e4ae85da77ef6 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$24c945ea033ce6cf, (pagination)=>pagination.rowCount);
const $c41ec74257ca380c$export$1f7f64fcb62ccdad = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $c41ec74257ca380c$export$721a46720a2de097 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $c41ec74257ca380c$export$b81026f1aaf843a4 = (0, $cgQ4y.createSelector)($c41ec74257ca380c$export$721a46720a2de097, $c41ec74257ca380c$export$946e4ae85da77ef6, (pageSize, rowCount)=>(0, $baj2X.getPageCount)(rowCount, pageSize));
const $c41ec74257ca380c$export$b76c99ac6ae901da = (0, $cgQ4y.createSelectorMemoized)($c41ec74257ca380c$export$ccc9f04e59d0d8e6, (0, $goCyd.gridRowTreeSelector), (0, $goCyd.gridRowMaximumTreeDepthSelector), (0, $k278Q.gridExpandedSortedRowEntriesSelector), (0, $k278Q.gridFilteredSortedTopLevelRowEntriesSelector), (paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        var _rowTree$row$id;
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = (_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $c41ec74257ca380c$export$abcd649e974e3e96 = (0, $cgQ4y.createSelectorMemoized)((0, $k278Q.gridExpandedSortedRowEntriesSelector), $c41ec74257ca380c$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $c41ec74257ca380c$export$c1f6a976375edd4a = (0, $cgQ4y.createSelectorMemoized)((0, $k278Q.gridExpandedSortedRowIdsSelector), $c41ec74257ca380c$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});

});
parcelRegister("baj2X", function(module, exports) {

$parcel$export(module.exports, "defaultPageSize", () => $820f672e99dc58bd$export$d515e179bb47bd84);
$parcel$export(module.exports, "getPageCount", () => $820f672e99dc58bd$export$b287f0ca5dbff6af);
$parcel$export(module.exports, "getDefaultGridPaginationModel", () => $820f672e99dc58bd$export$73aa7e9d0fff5ee4);
$parcel$export(module.exports, "getValidPage", () => $820f672e99dc58bd$export$41142e40198ee144);
$parcel$export(module.exports, "throwIfPageSizeExceedsTheLimit", () => $820f672e99dc58bd$export$d3cf54bfe8b6931);

var $ehSzT = parcelRequire("ehSzT");

var $eFF1m = parcelRequire("eFF1m");
const $820f672e99dc58bd$var$MAX_PAGE_SIZE = 100;
const $820f672e99dc58bd$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $820f672e99dc58bd$export$b287f0ca5dbff6af = (rowCount, pageSize)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    return 0;
};
const $820f672e99dc58bd$export$8861c218874b3f9c = (0, $ehSzT.buildWarning)([
    "MUI: the 'rowCount' prop is undefined while using paginationMode='server'",
    'For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation'
], 'error');
const $820f672e99dc58bd$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $820f672e99dc58bd$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $820f672e99dc58bd$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $eFF1m.GridSignature).DataGrid && pageSize > $820f672e99dc58bd$var$MAX_PAGE_SIZE) throw new Error([
        'MUI: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};

});



parcelRegister("iNueb", function(module, exports) {

$parcel$export(module.exports, "GRID_BOOLEAN_COL_DEF", () => $daf44030e7d36790$export$220b51460e149ea9);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $8vJu2 = parcelRequire("8vJu2");

var $hsZ0E = parcelRequire("hsZ0E");

var $h8fXG = parcelRequire("h8fXG");

var $jWu8a = parcelRequire("jWu8a");
function $daf44030e7d36790$var$gridBooleanFormatter({ value: value, api: api }) {
    return value ? api.getLocaleText('booleanCellTrueLabel') : api.getLocaleText('booleanCellFalseLabel');
}
const $daf44030e7d36790$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $daf44030e7d36790$export$220b51460e149ea9 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'boolean',
    align: 'center',
    headerAlign: 'center',
    renderCell: (0, $8vJu2.renderBooleanCell),
    renderEditCell: (0, $hsZ0E.renderEditBooleanCell),
    sortComparator: (0, $h8fXG.gridNumberComparator),
    valueFormatter: $daf44030e7d36790$var$gridBooleanFormatter,
    filterOperators: (0, $jWu8a.getGridBooleanOperators)(),
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined,
    // @ts-ignore
    aggregable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$daf44030e7d36790$var$stringToBoolean(value)
});

});
parcelRegister("bSL2h", function(module, exports) {

$parcel$export(module.exports, "GRID_STRING_COL_DEF", () => $8a69393405f257b1$export$db6fa9d0a45573e4);

var $4QDBh = parcelRequire("4QDBh");

var $h8fXG = parcelRequire("h8fXG");

var $hKY94 = parcelRequire("hKY94");

var $dJVXj = parcelRequire("dJVXj");
const $8a69393405f257b1$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, $h8fXG.gridStringOrNumberComparator),
    type: 'string',
    align: 'left',
    filterOperators: (0, $hKY94.getGridStringOperators)(),
    renderEditCell: (0, $4QDBh.renderEditInputCell),
    getApplyQuickFilterFn: (0, $dJVXj.convertQuickFilterV7ToLegacy)((0, $hKY94.getGridStringQuickFilterFn)),
    getApplyQuickFilterFnV7: (0, $hKY94.getGridStringQuickFilterFn)
};

});
parcelRegister("4QDBh", function(module, exports) {

$parcel$export(module.exports, "renderEditInputCell", () => $387abc8f0fc4c9a9$export$d1015f41e7e48c2e);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $d8seH = parcelRequire("d8seH");

var $95gUw = parcelRequire("95gUw");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $387abc8f0fc4c9a9$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const $387abc8f0fc4c9a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $387abc8f0fc4c9a9$var$GridEditInputCellRoot = (0, $d8seH.default)((0, $95gUw.default), {
    name: 'MuiDataGrid',
    slot: 'EditInputCell',
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        padding: '1px 0',
        '& input': {
            padding: '0 16px',
            height: '100%'
        }
    }));
const $387abc8f0fc4c9a9$export$cd10ed3250a4d414 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $387abc8f0fc4c9a9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef();
    const [valueState, setValueState] = $acw62.useState(value);
    const classes = $387abc8f0fc4c9a9$var$useUtilityClasses(rootProps);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getCellParams(id, field));
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $acw62.useEffect(()=>{
        if ((meta == null ? void 0 : meta.changeReason) !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCellRoot, (0, $8nd05.default)({
        ref: ref,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState != null ? valueState : '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other));
});
const $387abc8f0fc4c9a9$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$export$cd10ed3250a4d414, (0, $8nd05.default)({}, params));

});
parcelRegister("95gUw", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $69d1b2c99a8dc649$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $69d1b2c99a8dc649$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $69d1b2c99a8dc649$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseComponent", () => $69d1b2c99a8dc649$export$a1ad29c901026019);
$parcel$export(module.exports, "default", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $awhpc = parcelRequire("awhpc");

var $gSRTE = parcelRequire("gSRTE");

var $aaphR = parcelRequire("aaphR");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $ldx2z = parcelRequire("ldx2z");

var $2BbKU = parcelRequire("2BbKU");

var $dmljZ = parcelRequire("dmljZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dmljZ.getInputBaseUtilityClass), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $dmljZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $8nd05.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dmljZ.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $dmljZ.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldx2z.default), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $9Rgf1.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $khjmj.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $gSRTE.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $awhpc.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("awhpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a64e8a5211ee5$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;

});

parcelRegister("gSRTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $aJ8G8 = parcelRequire("aJ8G8");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(forwardedRef, inputRef);
    const heightRef = $acw62.useRef(null);
    const shadowRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $9KvVX.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $acw62.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, $eEJPp.default)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $aJ8G8.default)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $9KvVX.default)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $eEJPp.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;

});
parcelRegister("aJ8G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf4d6c2077a48de$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("9KvVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71912e551e227707$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $6zeBo.default)(node);
    return doc.defaultView || window;
}

});
parcelRegister("6zeBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8156a231c9130b$export$2e2bcd8739ae039);
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("aaphR", function(module, exports) {

$parcel$export(module.exports, "default", () => $766e740713576b8d$export$2e2bcd8739ae039);
function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("blr6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8426ae8303951a73$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $946238fa82894619$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $blr6C = parcelRequire("blr6C");
'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $blr6C.default));
}

});

parcelRegister("9Rgf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d5a979b2ad8bc9$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");
'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $3qSdM.default);

});

parcelRegister("khjmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec346974df496fc5$export$2e2bcd8739ae039);

var $eEJPp = parcelRequire("eEJPp");
'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $eEJPp.default);

});

parcelRegister("ldx2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fc756f7adfd498$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $92iK7 = parcelRequire("92iK7");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;

});
parcelRegister("92iK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942d6ec85232a9d$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");

var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $7HKeb.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;

});
parcelRegister("7HKeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c0686cf27fa016$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $2HliV = parcelRequire("2HliV");
'use client';
const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $2HliV.default)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;

});
parcelRegister("2HliV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f701f7d1726bc9a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;

});




parcelRegister("2BbKU", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $1e4827e2a850b1f0$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $1e4827e2a850b1f0$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $9b9dde6aa920e08c$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;

});



parcelRegister("h8fXG", function(module, exports) {

$parcel$export(module.exports, "sanitizeSortModel", () => $c78f90aae54b126e$export$13eeac5ac15e0be5);
$parcel$export(module.exports, "mergeStateWithSortModel", () => $c78f90aae54b126e$export$3fc28d475ac000c0);
$parcel$export(module.exports, "buildAggregatedSortingApplier", () => $c78f90aae54b126e$export$b29e353d1a72dfda);
$parcel$export(module.exports, "getNextGridSortDirection", () => $c78f90aae54b126e$export$b3d84351ab2e3580);
$parcel$export(module.exports, "gridStringOrNumberComparator", () => $c78f90aae54b126e$export$db324d0b741f4529);
$parcel$export(module.exports, "gridNumberComparator", () => $c78f90aae54b126e$export$ecfdaa3722003888);
$parcel$export(module.exports, "gridDateComparator", () => $c78f90aae54b126e$export$74e685f55e96d6bc);

var $8nd05 = parcelRequire("8nd05");

var $ehSzT = parcelRequire("ehSzT");
const $c78f90aae54b126e$var$sortModelDisableMultiColumnsSortingWarning = (0, $ehSzT.buildWarning)([
    'MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const $c78f90aae54b126e$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        $c78f90aae54b126e$var$sortModelDisableMultiColumnsSortingWarning();
        return [
            model[0]
        ];
    }
    return model;
};
const $c78f90aae54b126e$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $8nd05.default)({}, state, {
            sorting: (0, $8nd05.default)({}, state.sorting, {
                sortModel: $c78f90aae54b126e$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $c78f90aae54b126e$var$isDesc = (direction)=>direction === 'desc';
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $c78f90aae54b126e$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column) return null;
    const comparator = $c78f90aae54b126e$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: apiRef.current.getRowNode(id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $c78f90aae54b126e$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $c78f90aae54b126e$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$c78f90aae54b126e$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$c78f90aae54b126e$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $c78f90aae54b126e$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $c78f90aae54b126e$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $c78f90aae54b126e$var$collator = new Intl.Collator();
const $c78f90aae54b126e$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $c78f90aae54b126e$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $c78f90aae54b126e$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $c78f90aae54b126e$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};

});

parcelRegister("hKY94", function(module, exports) {

$parcel$export(module.exports, "getGridStringQuickFilterFn", () => $ced5632839836707$export$4326c0ebf0c2f84b);
$parcel$export(module.exports, "getGridStringOperators", () => $ced5632839836707$export$dff3a5bcde5c5e41);

var $g7hyo = parcelRequire("g7hyo");

var $lR3Vo = parcelRequire("lR3Vo");

var $6tiPX = parcelRequire("6tiPX");

var $dJVXj = parcelRequire("dJVXj");

var $14dIX = parcelRequire("14dIX");
const $ced5632839836707$export$4326c0ebf0c2f84b = (0, $dJVXj.tagInternalFilter)((value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $14dIX.removeDiacritics)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
});
const $ced5632839836707$export$dff3a5bcde5c5e41 = (disableTrim = false)=>(0, $dJVXj.convertLegacyOperators)([
        {
            value: 'contains',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(filterItemValue), 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(String(value)) : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'equals',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>{
                    return value != null ? collator.compare(filterItemValue, value.toString()) === 0 : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'startsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $lR3Vo.escapeRegExp)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'endsWith',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $lR3Vo.escapeRegExp)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue)
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value === '' || value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value !== '' && value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: (0, $6tiPX.GridFilterInputMultipleValue)
        }
    ]);

});
parcelRegister("g7hyo", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputValue", () => $bbbaea9771a9f69f$export$99d1f108a3f21b3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $5oDOG = parcelRequire("5oDOG");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bbbaea9771a9f69f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "clearButton",
    "InputProps",
    "variant"
];
function $bbbaea9771a9f69f$export$99d1f108a3f21b3(props) {
    var _item$value, _rootProps$slotProps;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, clearButton: clearButton, InputProps: InputProps, variant: variant = 'standard' } = props, others = (0, $1En50.default)(props, $bbbaea9771a9f69f$var$_excluded);
    const filterTimeout = (0, $5oDOG.useTimeout)();
    const [filterValueState, setFilterValueState] = $acw62.useState((_item$value = item.value) != null ? _item$value : '');
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $acw62.useCallback((event)=>{
        const { value: value } = event.target;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $8nd05.default)({}, item, {
                value: value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        id,
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $acw62.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value === undefined) {
            var _item$value2;
            setFilterValueState(String((_item$value2 = item.value) != null ? _item$value2 : ''));
        }
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: variant,
        type: type || 'text',
        InputProps: (0, $8nd05.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $8nd05.default)({
                tabIndex: tabIndex
            }, InputProps == null ? void 0 : InputProps.inputProps)
        }),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}

});
parcelRegister("auC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a319e7e555608$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62['useId'.toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}

});

parcelRegister("5oDOG", function(module, exports) {

$parcel$export(module.exports, "useTimeout", () => $3ede1456da2c476e$export$d8e6abf214c9ec0f);

var $7O6ub = parcelRequire("7O6ub");

var $cZouL = parcelRequire("cZouL");
class $3ede1456da2c476e$var$Timeout {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $3ede1456da2c476e$var$Timeout();
    }
    start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(fn, delay);
    }
}
function $3ede1456da2c476e$export$d8e6abf214c9ec0f() {
    const timeout = (0, $7O6ub.useLazyRef)($3ede1456da2c476e$var$Timeout.create).current;
    (0, $cZouL.useOnMount)(timeout.disposeEffect);
    return timeout;
}

});


parcelRegister("6tiPX", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputMultipleValue", () => $4b64102825ff1e40$export$fec959c3691e0645);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $cFBau = parcelRequire("cFBau");

var $auC0X = parcelRequire("auC0X");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $4b64102825ff1e40$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
function $4b64102825ff1e40$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant } = props, other = (0, $1En50.default)(props, $4b64102825ff1e40$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const [filterValueState, setFilterValueState] = $acw62.useState(item.value || []);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    $acw62.useEffect(()=>{
        var _item$value;
        const itemValue = (_item$value = item.value) != null ? _item$value : [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $8nd05.default)({}, item, {
            value: [
                ...value
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), (0, $8nd05.default)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue: inputValue } = params;
            return inputValue == null || inputValue === '' ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseChip, (0, $8nd05.default)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $8nd05.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || 'text'
            }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}

});
parcelRegister("cFBau", function(module, exports) {

$parcel$export(module.exports, "default", () => $9396253983985262$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $33DpT = parcelRequire("33DpT");

var $e76iu = parcelRequire("e76iu");

var $7djgP = parcelRequire("7djgP");

var $7Frhn = parcelRequire("7Frhn");

var $9Lykx = parcelRequire("9Lykx");

var $6ami2 = parcelRequire("6ami2");

var $b3ugU = parcelRequire("b3ugU");

var $dmljZ = parcelRequire("dmljZ");

var $96QZi = parcelRequire("96QZi");

var $faAxf = parcelRequire("faAxf");

var $ldBGF = parcelRequire("ldBGF");

var $7LRfY = parcelRequire("7LRfY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9O25J = parcelRequire("9O25J");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9O25J.getAutocompleteUtilityClass), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $9O25J.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $9O25J.default).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $9O25J.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $9O25J.default).input}`]: styles.input
            },
            {
                [`& .${(0, $9O25J.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $9O25J.default).focused} .${(0, $9O25J.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $9O25J.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $9O25J.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $9O25J.default).inputRoot}`]: {
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $9O25J.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $b3ugU.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $b3ugU.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $b3ugU.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $96QZi.default).root}`]: {
        padding: 9,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $96QZi.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $faAxf.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $9O25J.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $9O25J.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $9O25J.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $9O25J.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9O25J.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $9O25J.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $9O25J.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $9O25J.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $9O25J.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $9O25J.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $7djgP.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $9O25J.default).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldBGF.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $7Frhn.default), PopperComponent: PopperComponent = (0, $e76iu.default), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LRfY.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $33DpT.default)((0, $8nd05.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $9Rgf1.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;

});
parcelRegister("33DpT", function(module, exports) {

$parcel$export(module.exports, "createFilterOptions", () => $23a03a376a300fc5$export$f76f94b238d946d8);
$parcel$export(module.exports, "default", () => $23a03a376a300fc5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");
var $agZ85 = parcelRequire("agZ85");
var $13KXh = parcelRequire("13KXh");
var $auC0X = parcelRequire("auC0X");
var $9D07P = parcelRequire("9D07P");
'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $auC0X.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $agZ85.default)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $agZ85.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $9D07P.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $13KXh.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $13KXh.default)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $13KXh.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $13KXh.default)((node)=>{
        (0, $hervl.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("agZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aad105771eb889$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("13KXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7e8ccbc07697$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $eEJPp.default)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;

});

parcelRegister("9D07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027da6f4b17de9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;

});


parcelRegister("e76iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4669aa090d445bd$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $5AoD1 = parcelRequire("5AoD1");




var $acw62 = parcelRequire("acw62");

var $7JHF2 = parcelRequire("7JHF2");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $7JHF2.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($5AoD1)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;

});
parcelRegister("5AoD1", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41136b35f34e8eee$var$React = $41136b35f34e8eee$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $41136b35f34e8eee$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($41136b35f34e8eee$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $41136b35f34e8eee$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $41136b35f34e8eee$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $41136b35f34e8eee$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $41136b35f34e8eee$var$useTheme(defaultTheme = null) {
    const contextTheme = $41136b35f34e8eee$var$React.useContext($eP9YU.T);
    return !contextTheme || $41136b35f34e8eee$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $41136b35f34e8eee$var$_default = module.exports.default = $41136b35f34e8eee$var$useTheme;

});

parcelRegister("7JHF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1e9a841ed0d0fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $3tUi5 = parcelRequire("3tUi5");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $2Q995 = parcelRequire("2Q995");

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $g3XLf.getPopperUtilityClass), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $3qSdM.default)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $3qSdM.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $eEJPp.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $eEJPp.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $6zeBo.default)(resolvedAnchorEl).body : (0, $6zeBo.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("eD6Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa69d7725f45330b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $1ESci = parcelRequire("1ESci");

var $8bslU = parcelRequire("8bslU");
'use client';
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $8bslU.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $1ESci.default)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $gEUd4.default)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;

});
parcelRegister("gEUd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20bfbd9e98e2eff$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $awhpc = parcelRequire("awhpc");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $awhpc.default)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;

});

parcelRegister("1ESci", function(module, exports) {

$parcel$export(module.exports, "default", () => $135391549c807611$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");

var $f56pe = parcelRequire("f56pe");

var $5nUQA = parcelRequire("5nUQA");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f56pe.default)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $5nUQA.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $5nUQA.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;

});
parcelRegister("f56pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $afac4abdaa8d83ea$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;

});

parcelRegister("5nUQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebb326a10a78a15$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;

});


parcelRegister("8bslU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5557fdc8e8d8fa$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;

});


parcelRegister("2Q995", function(module, exports) {

$parcel$export(module.exports, "default", () => $2117883cc21a32b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $2xc7G = parcelRequire("2xc7G");
var $hervl = parcelRequire("hervl");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $3qSdM.default)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $2xc7G.default)(children) : null, forwardedRef);
    (0, $eEJPp.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $eEJPp.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hervl.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hervl.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode
    });
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;

});
parcelRegister("2xc7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d88113360503233$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

});


parcelRegister("g3XLf", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;

});



parcelRegister("7djgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5408b2039b9d572c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ixwSf.getListSubheaderUtilityClass), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("ixwSf", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $d7f4cf29715b69dd$export$6816d4fc0981ec7);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;

});


parcelRegister("7Frhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $595185d0d7275c3b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $35vyj = parcelRequire("35vyj");

var $1iOpW = parcelRequire("1iOpW");


var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LfkK.getPaperUtilityClass), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kSnzZ.alpha)('#fff', (0, $35vyj.default)(ownerState.elevation))}, ${(0, $kSnzZ.alpha)('#fff', (0, $35vyj.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;

});
parcelRegister("35vyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fa506264c010ed$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;

});

parcelRegister("6LfkK", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $4ec306d48089c2c9$export$29cdb466b9b6f20b);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;

});


parcelRegister("9Lykx", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c322247f7fbf93$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $jzUw6 = parcelRequire("jzUw6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jzUw6.getIconButtonUtilityClass), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $jzUw6.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("6n0Ko", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a35786d89db9dda$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $4o7uD = parcelRequire("4o7uD");

var $cllwi = parcelRequire("cllwi");

var $brF9L = parcelRequire("brF9L");

var $5JO1P = parcelRequire("5JO1P");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5JO1P.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $5JO1P.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $9Rgf1.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $4o7uD.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4o7uD.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $4o7uD.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4o7uD.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $9Rgf1.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $brF9L.default), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("4o7uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $331f3746e6346411$export$2e2bcd8739ae039);

var $13KXh = parcelRequire("13KXh");
'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $13KXh.default);

});

parcelRegister("cllwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc8239a3939454e$export$2e2bcd8739ae039);

var $1SuLX = parcelRequire("1SuLX");
'use client';
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $1SuLX.default);

});
parcelRegister("1SuLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e2b45accdb3531$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lHOu3 = parcelRequire("lHOu3");
'use client';
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $lHOu3.Timeout)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("lHOu3", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $fcd4c6205d65c7df$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $fcd4c6205d65c7df$export$2e2bcd8739ae039);

var $iYIN2 = parcelRequire("iYIN2");

var $dOphX = parcelRequire("dOphX");
'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $iYIN2.default)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $dOphX.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("iYIN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1092ee97d527c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("dOphX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e38fa988f617e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("brF9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $855224273a002a0f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $jEvxL = parcelRequire("jEvxL");

var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");

var $lHOu3 = parcelRequire("lHOu3");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hruNq = parcelRequire("hruNq");

var $a4Mf7 = parcelRequire("a4Mf7");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $hruNq.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $a4Mf7.default).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a4Mf7.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $a4Mf7.default).child, (0, $a4Mf7.default).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a4Mf7.default).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $lHOu3.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $a4Mf7.default).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $a4Mf7.default).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $a4Mf7.default).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $a4Mf7.default).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $a4Mf7.default).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $a4Mf7.default).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $a4Mf7.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEvxL.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("hruNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2cd8c78d72bd92$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $755fb323846f60d4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $42d7f65840078ec1$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $42d7f65840078ec1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;

});


parcelRegister("jzUw6", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $e40d2047b7c1e09d$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;

});


parcelRegister("6ami2", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4f79319086dc5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $8u0rE = parcelRequire("8u0rE");

var $9Rgf1 = parcelRequire("9Rgf1");


var $jTnBY = parcelRequire("jTnBY");

var $6n0Ko = parcelRequire("6n0Ko");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $iNSYf = parcelRequire("iNSYf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iNSYf.getChipUtilityClass), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $iNSYf.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $iNSYf.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $iNSYf.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $iNSYf.default).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $iNSYf.default).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $iNSYf.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $iNSYf.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $iNSYf.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $iNSYf.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $6n0Ko.default) : ComponentProp || 'div';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $6n0Ko.default) ? (0, $8nd05.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8u0rE.default), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d1787512a69c15$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("iNSYf", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", () => $db0771a9e6a32b1d$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;

});


parcelRegister("b3ugU", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $80c774dd7f29b734$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;

});

parcelRegister("96QZi", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $6a1dc6d1d7e1816a$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});

parcelRegister("faAxf", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $b0b42157daacd8b1$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $dmljZ.default), (0, $beCSm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;

});

parcelRegister("ldBGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7280bbf95507cba$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("7LRfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a863bd9b12ca76b$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("9O25J", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $723a67e53eb4dc4c$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;

});



parcelRegister("dJVXj", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_API_REF", () => $a00c6f24069d303e$export$dc2a297931ebeaa6);
$parcel$export(module.exports, "tagInternalFilter", () => $a00c6f24069d303e$export$8e08ca6d174bacf9);
$parcel$export(module.exports, "isInternalFilter", () => $a00c6f24069d303e$export$4edd066b85c94822);
$parcel$export(module.exports, "convertLegacyOperators", () => $a00c6f24069d303e$export$b905c4c483a689a6);
$parcel$export(module.exports, "convertQuickFilterV7ToLegacy", () => $a00c6f24069d303e$export$50dff96f00486a5c);

var $8nd05 = parcelRequire("8nd05");
const $a00c6f24069d303e$export$dc2a297931ebeaa6 = {
    current: null
};
function $a00c6f24069d303e$export$8e08ca6d174bacf9(fn) {
    fn.isInternal = true;
    return fn;
}
function $a00c6f24069d303e$export$4edd066b85c94822(fn) {
    return fn !== undefined && fn.isInternal === true;
}
function $a00c6f24069d303e$export$28f04b77854cffd1(fn) {
    return $a00c6f24069d303e$export$8e08ca6d174bacf9((filterItem, column)=>{
        const filterFn = fn(filterItem, column);
        if (!filterFn) return filterFn;
        return (cellParams)=>{
            return filterFn(cellParams.value, cellParams.row, column, $a00c6f24069d303e$export$dc2a297931ebeaa6.current);
        };
    });
}
function $a00c6f24069d303e$export$b905c4c483a689a6(ops) {
    return ops.map((op)=>{
        return (0, $8nd05.default)({}, op, {
            getApplyFilterFn: $a00c6f24069d303e$export$28f04b77854cffd1(op.getApplyFilterFnV7),
            getApplyFilterFnV7: $a00c6f24069d303e$export$8e08ca6d174bacf9(op.getApplyFilterFnV7)
        });
    });
}
function $a00c6f24069d303e$export$50dff96f00486a5c(fn) {
    return $a00c6f24069d303e$export$8e08ca6d174bacf9((filterItem, column, apiRef)=>{
        const filterFn = fn(filterItem, column, apiRef);
        if (!filterFn) return filterFn;
        return (cellParams)=>{
            return filterFn(cellParams.value, cellParams.row, column, apiRef);
        };
    });
}

});

parcelRegister("14dIX", function(module, exports) {

$parcel$export(module.exports, "cleanFilterItem", () => $0c70cf7c1343c218$export$eb76493d113de092);
$parcel$export(module.exports, "sanitizeFilterModel", () => $0c70cf7c1343c218$export$2a370a0aad2ac7e1);
$parcel$export(module.exports, "mergeStateWithFilterModel", () => $0c70cf7c1343c218$export$f4189e6c713e6dd8);
$parcel$export(module.exports, "removeDiacritics", () => $0c70cf7c1343c218$export$626da389515c02b3);
$parcel$export(module.exports, "buildAggregatedFilterApplier", () => $0c70cf7c1343c218$export$1c795c7c9654905e);
$parcel$export(module.exports, "passFilterLogic", () => $0c70cf7c1343c218$export$8d82b4490466f182);

var $8nd05 = parcelRequire("8nd05");

var $9jXuN = parcelRequire("9jXuN");

var $dJVXj = parcelRequire("dJVXj");

var $l4QMb = parcelRequire("l4QMb");

var $ehSzT = parcelRequire("ehSzT");

var $dmvst = parcelRequire("dmvst");

var $jQEEt = parcelRequire("jQEEt");
let $0c70cf7c1343c218$var$hasEval;
function $0c70cf7c1343c218$var$getHasEval() {
    if ($0c70cf7c1343c218$var$hasEval !== undefined) return $0c70cf7c1343c218$var$hasEval;
    try {
        $0c70cf7c1343c218$var$hasEval = new Function('return true')();
    } catch (_) {
        $0c70cf7c1343c218$var$hasEval = false;
    }
    return $0c70cf7c1343c218$var$hasEval;
}
const $0c70cf7c1343c218$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $8nd05.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $jQEEt.gridColumnLookupSelector)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $0c70cf7c1343c218$var$filterModelDisableMultiColumnsFilteringWarning = (0, $ehSzT.buildWarning)([
    'MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.',
    'If you are using the community version of the `DataGrid`, this prop is always `true`.'
], 'error');
const $0c70cf7c1343c218$var$filterModelMissingItemIdWarning = (0, $ehSzT.buildWarning)('MUI: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
const $0c70cf7c1343c218$var$filterModelMissingItemOperatorWarning = (0, $ehSzT.buildWarning)('MUI: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
const $0c70cf7c1343c218$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        $0c70cf7c1343c218$var$filterModelDisableMultiColumnsFilteringWarning();
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemsWithoutIds) $0c70cf7c1343c218$var$filterModelMissingItemIdWarning();
    if (hasItemWithoutOperator) $0c70cf7c1343c218$var$filterModelMissingItemOperatorWarning();
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $8nd05.default)({}, model, {
        items: items.map((item)=>$0c70cf7c1343c218$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $8nd05.default)({}, model, {
        items: items
    });
    return model;
};
const $0c70cf7c1343c218$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $8nd05.default)({}, filteringState, {
            filterModel: $0c70cf7c1343c218$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $0c70cf7c1343c218$export$626da389515c02b3 = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const $0c70cf7c1343c218$var$getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        var _filterItem$value;
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? (_filterItem$value = filterItem.value) == null ? void 0 : _filterItem$value.map((x)=>parser(x)) : parser(filterItem.value);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $0c70cf7c1343c218$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $8nd05.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!(filterOperators != null && filterOperators.length)) throw new Error(`MUI: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const hasUserFunctionLegacy = !(0, $dJVXj.isInternalFilter)(filterOperator.getApplyFilterFn);
    const hasUserFunctionV7 = !(0, $dJVXj.isInternalFilter)(filterOperator.getApplyFilterFnV7);
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    if (filterOperator.getApplyFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) {
        const applyFilterOnRow = filterOperator.getApplyFilterFnV7(newFilterItem, column);
        if (typeof applyFilterOnRow !== 'function') return null;
        return {
            v7: true,
            item: newFilterItem,
            fn: (row)=>{
                let value = apiRef.current.getRowValue(row, column);
                if (ignoreDiacritics) value = $0c70cf7c1343c218$export$626da389515c02b3(value);
                return applyFilterOnRow(value, row, column, publicApiRef);
            }
        };
    }
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        v7: false,
        item: newFilterItem,
        fn: (rowId)=>{
            const params = apiRef.current.getCellParams(rowId, newFilterItem.field);
            (0, $dJVXj.GLOBAL_API_REF).current = publicApiRef;
            if (ignoreDiacritics) params.value = $0c70cf7c1343c218$export$626da389515c02b3(params.value);
            const result = applyFilterOnRow(params);
            (0, $dJVXj.GLOBAL_API_REF).current = null;
            return result;
        }
    };
};
let $0c70cf7c1343c218$var$filterItemsApplierId = 1;
/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier = (filterModel, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$0c70cf7c1343c218$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.v7 ? applier.fn(row) : applier.fn(apiRef.current.getRowId(row));
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, e.g. `{ [dynamicKey]: value }`.
    const filterItemCore = new Function('getRowId', 'appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i}
    ? false
    : ${applier.v7 ? `appliers[${i}].fn(row)` : `appliers[${i}].fn(getRowId(row))`},`).join('\n')}
};

return result$$;`.replaceAll('$$', String($0c70cf7c1343c218$var$filterItemsApplierId)));
    $0c70cf7c1343c218$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(apiRef.current.getRowId, appliers, row, shouldApplyItem);
    return filterItem;
};
/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    var _filterModel$quickFil, _filterModel$quickFil2, _filterModel$quickFil3;
    const quickFilterValues = (_filterModel$quickFil = (_filterModel$quickFil2 = filterModel.quickFilterValues) == null ? void 0 : _filterModel$quickFil2.filter(Boolean)) != null ? _filterModel$quickFil : [];
    if (quickFilterValues.length === 0) return null;
    const quickFilterExcludeHiddenColumns = (_filterModel$quickFil3 = filterModel.quickFilterExcludeHiddenColumns) != null ? _filterModel$quickFil3 : false;
    const columnFields = quickFilterExcludeHiddenColumns ? (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef) : (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column == null ? void 0 : column.getApplyQuickFilterFn;
        const getApplyQuickFilterFnV7 = column == null ? void 0 : column.getApplyQuickFilterFnV7;
        const hasUserFunctionLegacy = !(0, $dJVXj.isInternalFilter)(getApplyQuickFilterFn);
        const hasUserFunctionV7 = !(0, $dJVXj.isInternalFilter)(getApplyQuickFilterFnV7);
        if (getApplyQuickFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $0c70cf7c1343c218$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    v7: true,
                    fn: getApplyQuickFilterFnV7(value, column, publicApiRef)
                };
            })
        });
        else if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $0c70cf7c1343c218$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    v7: false,
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        const usedCellParams = {};
        /* eslint-disable no-restricted-syntax, no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = apiRef.current.getRowValue(row, column);
                if (applier.fn === null) continue;
                if (applier.v7) {
                    if (ignoreDiacritics) value = $0c70cf7c1343c218$export$626da389515c02b3(value);
                    const isMatching = applier.fn(value, row, column, publicApiRef);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                } else {
                    var _usedCellParams$field;
                    const cellParams = (_usedCellParams$field = usedCellParams[field]) != null ? _usedCellParams$field : apiRef.current.getCellParams(apiRef.current.getRowId(row), field);
                    if (ignoreDiacritics) cellParams.value = $0c70cf7c1343c218$export$626da389515c02b3(cellParams.value);
                    usedCellParams[field] = cellParams;
                    const isMatching = applier.fn(cellParams);
                    if (isMatching) {
                        result[filterValue] = true;
                        continue outer;
                    }
                }
            }
            result[filterValue] = false;
        }
        /* eslint-enable no-restricted-syntax, no-labels */ return result;
    };
};
const $0c70cf7c1343c218$export$1c795c7c9654905e = (filterModel, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier(filterModel, apiRef, disableEval);
    const isRowMatchingQuickFilter = $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        var _isRowMatchingFilterI, _isRowMatchingQuickFi;
        result.passingFilterItems = (_isRowMatchingFilterI = isRowMatchingFilterItems == null ? void 0 : isRowMatchingFilterItems(row, shouldApplyFilter)) != null ? _isRowMatchingFilterI : null;
        result.passingQuickFilterValues = (_isRowMatchingQuickFi = isRowMatchingQuickFilter == null ? void 0 : isRowMatchingQuickFilter(row, shouldApplyFilter)) != null ? _isRowMatchingQuickFi : null;
    };
};
const $0c70cf7c1343c218$var$isNotNull = (result)=>result != null;
const $0c70cf7c1343c218$var$filterModelItems = (cache, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $0c70cf7c1343c218$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache)=>{
    const cleanedFilterItems = $0c70cf7c1343c218$var$filterModelItems(cache, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($0c70cf7c1343c218$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($0c70cf7c1343c218$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        var _filterModel$logicOpe;
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = (_filterModel$logicOpe = filterModel.logicOperator) != null ? _filterModel$logicOpe : (0, $l4QMb.getDefaultGridFilterModel)().logicOperator;
        if (logicOperator === (0, $9jXuN.GridLogicOperator).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        var _filterModel$quickFil4;
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = (_filterModel$quickFil4 = filterModel.quickFilterLogicOperator) != null ? _filterModel$quickFil4 : (0, $l4QMb.getDefaultGridFilterModel)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $9jXuN.GridLogicOperator).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};

});
parcelRegister("9jXuN", function(module, exports) {

$parcel$export(module.exports, "GridLogicOperator", () => $6c940a0517b1c6d5$export$90be184ccbab1c7a);
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $6c940a0517b1c6d5$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($6c940a0517b1c6d5$export$90be184ccbab1c7a || {});

});

parcelRegister("l4QMb", function(module, exports) {

$parcel$export(module.exports, "getDefaultGridFilterModel", () => $f582e8f6fdde33c9$export$7ea23129b8e10cdb);

var $9jXuN = parcelRequire("9jXuN");
const $f582e8f6fdde33c9$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $9jXuN.GridLogicOperator).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $9jXuN.GridLogicOperator).And
    }); /**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 

});

parcelRegister("dmvst", function(module, exports) {

$parcel$export(module.exports, "getPublicApiRef", () => $9ba5bb68a0cac1c6$export$fbb0da9fc679f98a);
function $9ba5bb68a0cac1c6$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}

});




parcelRegister("8vJu2", function(module, exports) {

$parcel$export(module.exports, "renderBooleanCell", () => $6324800d89fce0fa$export$6c5a2392a8d4c6d6);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $7sDf4 = parcelRequire("7sDf4");

var $ayMG0 = parcelRequire("ayMG0");
const $6324800d89fce0fa$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex"
];
const $6324800d89fce0fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $6324800d89fce0fa$var$GridBooleanCellRaw(props) {
    const { value: value } = props, other = (0, $1En50.default)(props, $6324800d89fce0fa$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $6324800d89fce0fa$var$useUtilityClasses(ownerState);
    const Icon = $acw62.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $6324800d89fce0fa$export$9cc4d0e939884340 = /*#__PURE__*/ $acw62.memo($6324800d89fce0fa$var$GridBooleanCellRaw);
const $6324800d89fce0fa$export$6c5a2392a8d4c6d6 = (params)=>{
    if ((0, $7sDf4.isAutoGeneratedRow)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6324800d89fce0fa$export$9cc4d0e939884340, (0, $8nd05.default)({}, params));
};

});
parcelRegister("7sDf4", function(module, exports) {

$parcel$export(module.exports, "GRID_ROOT_GROUP_ID", () => $0166dd44615cae0d$export$433b924dc2506913);
$parcel$export(module.exports, "GRID_ID_AUTOGENERATED", () => $0166dd44615cae0d$export$e8632b32bb8837db);
$parcel$export(module.exports, "buildRootGroup", () => $0166dd44615cae0d$export$96a607054e9bfd0c);
$parcel$export(module.exports, "getRowIdFromRowModel", () => $0166dd44615cae0d$export$a95fb784d0ca2e72);
$parcel$export(module.exports, "createRowsInternalCache", () => $0166dd44615cae0d$export$3496927f169f2d35);
$parcel$export(module.exports, "getTopLevelRowCount", () => $0166dd44615cae0d$export$e6ee03f0394a9759);
$parcel$export(module.exports, "getRowsStateFromCache", () => $0166dd44615cae0d$export$4dcb6d8dd06e4f39);
$parcel$export(module.exports, "isAutoGeneratedRow", () => $0166dd44615cae0d$export$fc9d832f40054590);
$parcel$export(module.exports, "getTreeNodeDescendants", () => $0166dd44615cae0d$export$9380f4bcafb87e49);
$parcel$export(module.exports, "updateCacheWithNewRows", () => $0166dd44615cae0d$export$b593607f8b00d104);
$parcel$export(module.exports, "calculatePinnedRowsHeight", () => $0166dd44615cae0d$export$d299da5915ed6fec);
$parcel$export(module.exports, "getMinimalContentHeight", () => $0166dd44615cae0d$export$5475857f45a72a6e);

var $8nd05 = parcelRequire("8nd05");

var $goCyd = parcelRequire("goCyd");

var $fD9f4 = parcelRequire("fD9f4");
const $0166dd44615cae0d$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $0166dd44615cae0d$export$e8632b32bb8837db = Symbol('mui.id_autogenerated');
const $0166dd44615cae0d$export$96a607054e9bfd0c = ()=>({
        type: 'group',
        id: $0166dd44615cae0d$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $0166dd44615cae0d$export$de0419c0281531ca(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI: The data grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $0166dd44615cae0d$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $0166dd44615cae0d$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $0166dd44615cae0d$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    const dataRowIdToIdLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $0166dd44615cae0d$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        dataRowIdToIdLookup[id] = id;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $0166dd44615cae0d$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$0166dd44615cae0d$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $0166dd44615cae0d$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $8nd05.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $0166dd44615cae0d$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp
    });
};
const $0166dd44615cae0d$export$fc9d832f40054590 = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const $0166dd44615cae0d$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$0166dd44615cae0d$export$fc9d832f40054590(tree[child])) validDescendants.push(child);
        const childDescendants = $0166dd44615cae0d$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $0166dd44615cae0d$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates })=>{
    var _previousCache$update, _previousCache$update2, _previousCache$update3;
    if (previousCache.updates.type === 'full') throw new Error('MUI: Unable to prepare a partial update if a full update is not applied yet');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $8nd05.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...(_previousCache$update = previousCache.updates.actions.insert) != null ? _previousCache$update : []
            ],
            modify: [
                ...(_previousCache$update2 = previousCache.updates.actions.modify) != null ? _previousCache$update2 : []
            ],
            remove: [
                ...(_previousCache$update3 = previousCache.updates.actions.remove) != null ? _previousCache$update3 : []
            ]
        },
        idToActionLookup: (0, $8nd05.default)({}, previousCache.updates.idToActionLookup)
    };
    const dataRowIdToModelLookup = (0, $8nd05.default)({}, previousCache.dataRowIdToModelLookup);
    const dataRowIdToIdLookup = (0, $8nd05.default)({}, previousCache.dataRowIdToIdLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            delete dataRowIdToIdLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $8nd05.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
        dataRowIdToIdLookup[id] = id;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        dataRowIdToIdLookup: dataRowIdToIdLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
function $0166dd44615cae0d$export$d299da5915ed6fec(apiRef) {
    var _pinnedRows$top, _pinnedRows$bottom;
    const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    const bottomPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    return {
        top: topPinnedRowsHeight,
        bottom: bottomPinnedRowsHeight
    };
}
function $0166dd44615cae0d$export$5475857f45a72a6e(apiRef, rowHeight) {
    const densityFactor = (0, $fD9f4.gridDensityFactorSelector)(apiRef);
    return `var(--DataGrid-overlayHeight, ${2 * Math.floor(rowHeight * densityFactor)}px)`;
}

});


parcelRegister("hsZ0E", function(module, exports) {

$parcel$export(module.exports, "renderEditBooleanCell", () => $cb74606ec716e4c3$export$9ef52be99fb661);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");
var $auC0X = parcelRequire("auC0X");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $cb74606ec716e4c3$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $cb74606ec716e4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $cb74606ec716e4c3$export$22bee653ea92336f(props) {
    var _rootProps$slotProps;
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $cb74606ec716e4c3$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef(null);
    const id = (0, $auC0X.default)();
    const [valueState, setValueState] = $acw62.useState(value);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $cb74606ec716e4c3$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $acw62.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("label", (0, $8nd05.default)({
        htmlFor: id,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $8nd05.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox))
    }));
}
const $cb74606ec716e4c3$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cb74606ec716e4c3$export$22bee653ea92336f, (0, $8nd05.default)({}, params));

});

parcelRegister("jWu8a", function(module, exports) {

$parcel$export(module.exports, "getGridBooleanOperators", () => $e84ace6ba51eccb1$export$906a46f6c2359ef6);

var $hAdXB = parcelRequire("hAdXB");

var $dJVXj = parcelRequire("dJVXj");
const $e84ace6ba51eccb1$export$906a46f6c2359ef6 = ()=>(0, $dJVXj.convertLegacyOperators)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (!filterItem.value) return null;
                const valueAsBoolean = filterItem.value === 'true';
                return (value)=>{
                    return Boolean(value) === valueAsBoolean;
                };
            },
            InputComponent: (0, $hAdXB.GridFilterInputBoolean)
        }
    ]);

});
parcelRegister("hAdXB", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputBoolean", () => $ccd0a0b443bb9406$export$f1030df85ee00af9);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ccd0a0b443bb9406$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "label",
    "variant",
    "InputLabelProps"
];
const $ccd0a0b443bb9406$var$BooleanOperatorContainer = (0, $d8seH.default)('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $ccd0a0b443bb9406$export$f1030df85ee00af9(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2, _rootProps$slotProps3;
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, clearButton: clearButton, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard' } = props, others = (0, $1En50.default)(props, $ccd0a0b443bb9406$var$_excluded);
    const [filterValueState, setFilterValueState] = $acw62.useState(item.value || '');
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const labelId = (0, $auC0X.default)();
    const selectId = (0, $auC0X.default)();
    const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const baseSelectOptionProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelectOption) || {};
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(value);
        applyValue((0, $8nd05.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $acw62.useEffect(()=>{
        setFilterValueState(item.value || '');
    }, [
        item.value
    ]);
    const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ccd0a0b443bb9406$var$BooleanOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseFormControl, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel, {
                        id: labelId,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: labelId,
                        id: selectId,
                        label: label,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: variant,
                        notched: variant === 'outlined' ? true : undefined,
                        native: isSelectNative,
                        displayEmpty: true,
                        inputProps: {
                            ref: focusElementRef,
                            tabIndex: tabIndex
                        }
                    }, others, baseSelectProps, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "",
                                children: apiRef.current.getLocaleText('filterValueAny')
                            })),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "true",
                                children: apiRef.current.getLocaleText('filterValueTrue')
                            })),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isSelectNative,
                                value: "false",
                                children: apiRef.current.getLocaleText('filterValueFalse')
                            }))
                        ]
                    }))
                ]
            }),
            clearButton
        ]
    });
}

});






parcelRegister("ervnQ", function(module, exports) {

$parcel$export(module.exports, "columnMenuStateInitializer", () => $a83bee6df207757d$export$8574ffe06bf26347);
$parcel$export(module.exports, "useGridColumnMenu", () => $a83bee6df207757d$export$1fc2975c9a725449);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");

var $eOaSX = parcelRequire("eOaSX");

var $jQEEt = parcelRequire("jQEEt");
const $a83bee6df207757d$export$8574ffe06bf26347 = (state)=>(0, $8nd05.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $a83bee6df207757d$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumnMenu');
    /**
   * API METHODS
   */ const showColumnMenu = $acw62.useCallback((field)=>{
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (state.columnMenu.open && state.columnMenu.field === field) return state;
            logger.debug('Opening Column Menu');
            return (0, $8nd05.default)({}, state, {
                columnMenu: {
                    open: true,
                    field: field
                }
            });
        });
        if (shouldUpdate) {
            apiRef.current.hidePreferences();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $acw62.useCallback(()=>{
        const columnMenuState = (0, $eOaSX.gridColumnMenuSelector)(apiRef.current.state);
        if (columnMenuState.field) {
            const columnLookup = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
            const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
            const orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (!state.columnMenu.open && state.columnMenu.field === undefined) return state;
            logger.debug('Hiding Column Menu');
            return (0, $8nd05.default)({}, state, {
                columnMenu: (0, $8nd05.default)({}, state.columnMenu, {
                    open: false,
                    field: undefined
                })
            });
        });
        if (shouldUpdate) apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $acw62.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $eOaSX.gridColumnMenuSelector)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnMenuApi, 'public');
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStart', hideColumnMenu);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};

});

parcelRegister("8JOxm", function(module, exports) {

$parcel$export(module.exports, "columnsStateInitializer", () => $65c9ba4e90cd61b6$export$8dcda879a58a8f96);
$parcel$export(module.exports, "useGridColumns", () => $65c9ba4e90cd61b6$export$fe9b9b8b4620abff);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $eFF1m = parcelRequire("eFF1m");

var $1xynw = parcelRequire("1xynw");
var $2kdmP = parcelRequire("2kdmP");

var $i0LyH = parcelRequire("i0LyH");

var $3PCYS = parcelRequire("3PCYS");

var $5rUcf = parcelRequire("5rUcf");

var $ayMG0 = parcelRequire("ayMG0");
const $65c9ba4e90cd61b6$var$defaultColumnTypes = (0, $5rUcf.getGridDefaultColumnTypes)();
const $65c9ba4e90cd61b6$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    var _props$initialState, _ref, _props$columnVisibili, _props$initialState2;
    const columnsState = (0, $i0LyH.createColumnsState)({
        apiRef: apiRef,
        columnTypes: $65c9ba4e90cd61b6$var$defaultColumnTypes,
        columnsToUpsert: props.columns,
        initialState: (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.columns,
        columnVisibilityModel: (_ref = (_props$columnVisibili = props.columnVisibilityModel) != null ? _props$columnVisibili : (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.columns) == null ? void 0 : _props$initialState2.columnVisibilityModel) != null ? _ref : {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $8nd05.default)({}, state, {
        columns: columnsState
    });
};
function $65c9ba4e90cd61b6$export$fe9b9b8b4620abff(apiRef, props) {
    var _props$initialState4, _props$slotProps2;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumns');
    const columnTypes = $65c9ba4e90cd61b6$var$defaultColumnTypes;
    const previousColumnsProp = $acw62.useRef(props.columns);
    const previousColumnTypesProp = $acw62.useRef(columnTypes);
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $jQEEt.gridColumnVisibilityModelSelector),
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $acw62.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState((0, $i0LyH.mergeColumnsState)(columnsState));
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $acw62.useCallback((field)=>(0, $jQEEt.gridColumnLookupSelector)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $acw62.useCallback(()=>(0, $jQEEt.gridColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $acw62.useCallback(()=>(0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $acw62.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef) : (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $acw62.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $jQEEt.gridColumnPositionsSelector)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    columns: (0, $i0LyH.createColumnsState)({
                        apiRef: apiRef,
                        columnTypes: columnTypes,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        columnTypes
    ]);
    const updateColumns = $acw62.useCallback((columns)=>{
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: columns,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState,
        columnTypes
    ]);
    const setColumnVisibility = $acw62.useCallback((field, isVisible)=>{
        var _columnVisibilityMode;
        const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const isCurrentlyVisible = (_columnVisibilityMode = columnVisibilityModel[field]) != null ? _columnVisibilityMode : true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $8nd05.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $acw62.useCallback((field)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $acw62.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $8nd05.default)({}, (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $acw62.useCallback((field, width)=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
        const column = columnsState.lookup[field];
        const newColumn = (0, $8nd05.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $8nd05.default)({}, columnsState, {
            lookup: (0, $8nd05.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnReorderApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState$c, _props$initialState3;
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys((_props$initialState$c = (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.columns) == null ? void 0 : _props$initialState3.columnVisibilityModel) != null ? _props$initialState$c : {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $i0LyH.COLUMNS_DIMENSION_PROPERTIES).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $8nd05.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        (_props$initialState4 = props.initialState) == null ? void 0 : _props$initialState4.columns
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        var _context$stateToResto;
        const columnVisibilityModelToImport = (_context$stateToResto = context.stateToRestore.columns) == null ? void 0 : _context$stateToResto.columnVisibilityModel;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState((0, $i0LyH.mergeColumnsState)(columnsState));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef,
        columnTypes
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $3PCYS.GridPreferencePanelsValue).columns) {
            var _props$slotProps;
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ColumnsPanel, (0, $8nd05.default)({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.columnsPanel
    ]);
    const addColumnMenuItems = $acw62.useCallback((columnMenuItems)=>{
        if (props.disableColumnSelector) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /**
   * EVENTS
   */ const prevInnerWidth = $acw62.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state), viewportInnerSize.width));
        }
    };
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $acw62.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        columnTypes
    ]);
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'hydrateColumns', hydrateColumns);
    /**
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns && previousColumnTypesProp.current === columnTypes) return;
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnTypes: columnTypes,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        previousColumnTypesProp.current = columnTypes;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        columnTypes
    ]);
    $acw62.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}

});
parcelRegister("1xynw", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterPipeApplier", () => $11f38a5cdcd4928d$export$98b68054bf03cb4);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $11f38a5cdcd4928d$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $acw62.useRef();
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};

});
parcelRegister("bc8LN", function(module, exports) {

$parcel$export(module.exports, "useFirstRender", () => $82679e37231fe76f$export$c5623aa1c38918b6);

var $acw62 = parcelRequire("acw62");
const $82679e37231fe76f$export$c5623aa1c38918b6 = (callback)=>{
    const isFirstRender = $acw62.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};

});


parcelRegister("2kdmP", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterPipeProcessor", () => $1b17d17d1651bc2f$export$faa98381ad228894);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $1b17d17d1651bc2f$export$faa98381ad228894 = (apiRef, group, callback)=>{
    const cleanup = $acw62.useRef();
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};

});

parcelRegister("i0LyH", function(module, exports) {

$parcel$export(module.exports, "COLUMNS_DIMENSION_PROPERTIES", () => $d1cd1e3fd8558ad5$export$cd7252624d377ce0);
$parcel$export(module.exports, "hydrateColumnsWidth", () => $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad);
$parcel$export(module.exports, "createColumnsState", () => $d1cd1e3fd8558ad5$export$f3ba81d24bd05452);
$parcel$export(module.exports, "mergeColumnsState", () => $d1cd1e3fd8558ad5$export$2e21c1239cd8cac2);
$parcel$export(module.exports, "getFirstNonSpannedColumnToRender", () => $d1cd1e3fd8558ad5$export$6143417adb92779f);
$parcel$export(module.exports, "getFirstColumnIndexToRender", () => $d1cd1e3fd8558ad5$export$8ad609d4bbf235b0);
$parcel$export(module.exports, "getTotalHeaderHeight", () => $d1cd1e3fd8558ad5$export$659109c29172602f);

var $8nd05 = parcelRequire("8nd05");

var $5rUcf = parcelRequire("5rUcf");
var $bSL2h = parcelRequire("bSL2h");

var $jQEEt = parcelRequire("jQEEt");

var $lR3Vo = parcelRequire("lR3Vo");

var $fD9f4 = parcelRequire("fD9f4");

var $hMyIf = parcelRequire("hMyIf");
const $d1cd1e3fd8558ad5$export$cd7252624d377ce0 = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
function $d1cd1e3fd8558ad5$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad = (rawState, viewportInnerWidth)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute there minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        const newColumn = (0, $8nd05.default)({}, rawState.lookup[columnField]);
        if (rawState.columnVisibilityModel[columnField] === false) newColumn.computedWidth = 0;
        else {
            let computedWidth;
            if (newColumn.flex && newColumn.flex > 0) {
                totalFlexUnits += newColumn.flex;
                computedWidth = 0;
                flexColumns.push(newColumn);
            } else computedWidth = (0, $lR3Vo.clamp)(newColumn.width || (0, $bSL2h.GRID_STRING_COL_DEF).width, newColumn.minWidth || (0, $bSL2h.GRID_STRING_COL_DEF).minWidth, newColumn.maxWidth || (0, $bSL2h.GRID_STRING_COL_DEF).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
            newColumn.computedWidth = computedWidth;
        }
        columnsLookup[columnField] = newColumn;
    });
    const initialFreeSpace = Math.max(viewportInnerWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && viewportInnerWidth > 0) {
        const computedColumnWidths = $d1cd1e3fd8558ad5$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, $8nd05.default)({}, rawState, {
        lookup: columnsLookup
    });
};
const $d1cd1e3fd8558ad5$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $8nd05.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $8nd05.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $8nd05.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(columnTypes, type) {
    let colDef = columnTypes[0, $5rUcf.DEFAULT_GRID_COL_TYPE_KEY];
    if (type && columnTypes[type]) colDef = columnTypes[type];
    return colDef;
}
const $d1cd1e3fd8558ad5$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnTypes: columnTypes, columnVisibilityModel: columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false })=>{
    var _apiRef$current$getRo, _apiRef$current$getRo2, _apiRef$current;
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $jQEEt.gridColumnsStateSelector)(apiRef.current.state);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $8nd05.default)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key)=>(0, $8nd05.default)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $8nd05.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(columnTypes, newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $8nd05.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(columnTypes, newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $d1cd1e3fd8558ad5$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $8nd05.default)({}, existingState, newColumn, {
            hasBeenResized: hasBeenResized
        });
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $d1cd1e3fd8558ad5$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $d1cd1e3fd8558ad5$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, (_apiRef$current$getRo = (_apiRef$current$getRo2 = (_apiRef$current = apiRef.current).getRootDimensions) == null || (_apiRef$current$getRo2 = _apiRef$current$getRo2.call(_apiRef$current)) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0);
};
const $d1cd1e3fd8558ad5$export$2e21c1239cd8cac2 = (columnsState)=>(state)=>(0, $8nd05.default)({}, state, {
            columns: columnsState
        });
function $d1cd1e3fd8558ad5$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    for(let i = firstRowToRender; i < lastRowToRender; i += 1){
        const row = visibleRows[i];
        if (row) {
            const rowId = visibleRows[i].id;
            const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
        }
    }
    return firstNonSpannedColumnToRender;
}
function $d1cd1e3fd8558ad5$export$8ad609d4bbf235b0({ firstColumnIndex: firstColumnIndex, minColumnIndex: minColumnIndex, columnBuffer: columnBuffer, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, apiRef: apiRef, visibleRows: visibleRows }) {
    const initialFirstColumnToRender = Math.max(firstColumnIndex - columnBuffer, minColumnIndex);
    const firstColumnToRender = $d1cd1e3fd8558ad5$export$6143417adb92779f({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef: apiRef,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: visibleRows
    });
    return firstColumnToRender;
}
function $d1cd1e3fd8558ad5$export$659109c29172602f(apiRef, headerHeight) {
    const densityFactor = (0, $fD9f4.gridDensityFactorSelector)(apiRef);
    const maxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
    return Math.floor(headerHeight * densityFactor) * ((maxDepth != null ? maxDepth : 0) + 1);
}

});
parcelRegister("5rUcf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GRID_COL_TYPE_KEY", () => $3f7b10d3cc3b3307$export$9459349d75dc87fe);
$parcel$export(module.exports, "getGridDefaultColumnTypes", () => $3f7b10d3cc3b3307$export$625c4e4511cf2d66);

var $bSL2h = parcelRequire("bSL2h");

var $e79LH = parcelRequire("e79LH");

var $axs1H = parcelRequire("axs1H");

var $iNueb = parcelRequire("iNueb");

var $2LzSK = parcelRequire("2LzSK");

var $8z2XQ = parcelRequire("8z2XQ");
const $3f7b10d3cc3b3307$export$9459349d75dc87fe = '__default__';
const $3f7b10d3cc3b3307$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $bSL2h.GRID_STRING_COL_DEF),
        number: (0, $e79LH.GRID_NUMERIC_COL_DEF),
        date: (0, $axs1H.GRID_DATE_COL_DEF),
        dateTime: (0, $axs1H.GRID_DATETIME_COL_DEF),
        boolean: (0, $iNueb.GRID_BOOLEAN_COL_DEF),
        singleSelect: (0, $2LzSK.GRID_SINGLE_SELECT_COL_DEF),
        [(0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)]: (0, $8z2XQ.GRID_ACTIONS_COL_DEF),
        [$3f7b10d3cc3b3307$export$9459349d75dc87fe]: (0, $bSL2h.GRID_STRING_COL_DEF)
    };
    return nativeColumnTypes;
};

});
parcelRegister("e79LH", function(module, exports) {

$parcel$export(module.exports, "GRID_NUMERIC_COL_DEF", () => $a4694bea3e886bc3$export$ba08f73736670f91);

var $8nd05 = parcelRequire("8nd05");

var $h8fXG = parcelRequire("h8fXG");

var $lR3Vo = parcelRequire("lR3Vo");

var $8SI7h = parcelRequire("8SI7h");

var $bSL2h = parcelRequire("bSL2h");

var $dJVXj = parcelRequire("dJVXj");
const $a4694bea3e886bc3$export$ba08f73736670f91 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: (0, $h8fXG.gridNumberComparator),
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: ({ value: value })=>(0, $lR3Vo.isNumber)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $8SI7h.getGridNumericOperators)(),
    getApplyQuickFilterFn: (0, $dJVXj.convertQuickFilterV7ToLegacy)((0, $8SI7h.getGridNumericQuickFilterFn)),
    getApplyQuickFilterFnV7: (0, $8SI7h.getGridNumericQuickFilterFn)
});

});
parcelRegister("8SI7h", function(module, exports) {

$parcel$export(module.exports, "getGridNumericQuickFilterFn", () => $67759673d54fca41$export$78c55b2f3096aac8);
$parcel$export(module.exports, "getGridNumericOperators", () => $67759673d54fca41$export$37d963e5ee49abc6);

var $g7hyo = parcelRequire("g7hyo");

var $6tiPX = parcelRequire("6tiPX");

var $dJVXj = parcelRequire("dJVXj");
const $67759673d54fca41$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $67759673d54fca41$export$78c55b2f3096aac8 = (0, $dJVXj.tagInternalFilter)((value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $67759673d54fca41$var$parseNumericValue(columnValue) === $67759673d54fca41$var$parseNumericValue(value);
    };
});
const $67759673d54fca41$export$37d963e5ee49abc6 = ()=>(0, $dJVXj.convertLegacyOperators)([
        {
            value: '=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $g7hyo.GridFilterInputValue),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $6tiPX.GridFilterInputMultipleValue),
            InputComponentProps: {
                type: 'number'
            }
        }
    ]);

});


parcelRegister("axs1H", function(module, exports) {

$parcel$export(module.exports, "GRID_DATE_COL_DEF", () => $7ac2b9e608be0423$export$4c3b89749ea40e50);
$parcel$export(module.exports, "GRID_DATETIME_COL_DEF", () => $7ac2b9e608be0423$export$5bc7079eed6f3d7f);

var $8nd05 = parcelRequire("8nd05");

var $h8fXG = parcelRequire("h8fXG");

var $5GOJA = parcelRequire("5GOJA");

var $bSL2h = parcelRequire("bSL2h");

var $3D30W = parcelRequire("3D30W");
function $7ac2b9e608be0423$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
function $7ac2b9e608be0423$export$c46cd449e66842a5({ value: value, field: field, id: id }) {
    if (!value) return '';
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: id,
        field: field
    });
    return value.toLocaleDateString();
}
function $7ac2b9e608be0423$export$a62990620750ce8c({ value: value, field: field, id: id }) {
    if (!value) return '';
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: id,
        field: field
    });
    return value.toLocaleString();
}
const $7ac2b9e608be0423$export$4c3b89749ea40e50 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'date',
    sortComparator: (0, $h8fXG.gridDateComparator),
    valueFormatter: $7ac2b9e608be0423$export$c46cd449e66842a5,
    filterOperators: (0, $5GOJA.getGridDateOperators)(),
    renderEditCell: (0, $3D30W.renderEditDateCell),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $7ac2b9e608be0423$export$5bc7079eed6f3d7f = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'dateTime',
    sortComparator: (0, $h8fXG.gridDateComparator),
    valueFormatter: $7ac2b9e608be0423$export$a62990620750ce8c,
    filterOperators: (0, $5GOJA.getGridDateOperators)(true),
    renderEditCell: (0, $3D30W.renderEditDateCell),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});

});
parcelRegister("5GOJA", function(module, exports) {

$parcel$export(module.exports, "getGridDateOperators", () => $42483ac831686fc7$export$2fa54515db89172d);

var $5y3Nn = parcelRequire("5y3Nn");

var $dJVXj = parcelRequire("dJVXj");
const $42483ac831686fc7$var$dateRegex = /(\d+)-(\d+)-(\d+)/;
const $42483ac831686fc7$var$dateTimeRegex = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function $42483ac831686fc7$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const [year, month, day, hour, minute] = filterItem.value.match(showTime ? $42483ac831686fc7$var$dateTimeRegex : $42483ac831686fc7$var$dateRegex).slice(1).map(Number);
    const time = new Date(year, month - 1, day, hour || 0, minute || 0).getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        const timeToCompare = dateCopy.setHours(showTime ? value.getHours() : 0, showTime ? value.getMinutes() : 0, 0, 0);
        return compareFn(timeToCompare, time);
    };
}
const $42483ac831686fc7$export$2fa54515db89172d = (showTime)=>(0, $dJVXj.convertLegacyOperators)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFnV7: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $5y3Nn.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFnV7: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ]);

});
parcelRegister("5y3Nn", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputDate", () => $40a3126b9e135d1e$export$f82b14e11ca0a1b4);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $5oDOG = parcelRequire("5oDOG");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $40a3126b9e135d1e$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps",
    "isFilterActive",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $40a3126b9e135d1e$export$f82b14e11ca0a1b4(props) {
    var _item$value, _rootProps$slotProps;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, InputProps: InputProps, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $1En50.default)(props, $40a3126b9e135d1e$var$_excluded);
    const filterTimeout = (0, $5oDOG.useTimeout)();
    const [filterValueState, setFilterValueState] = $acw62.useState((_item$value = item.value) != null ? _item$value : '');
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            applyValue((0, $8nd05.default)({}, item, {
                value: value
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $acw62.useEffect(()=>{
        var _item$value2;
        const itemValue = (_item$value2 = item.value) != null ? _item$value2 : '';
        setFilterValueState(String(itemValue));
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({
        fullWidth: true,
        id: id,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, $8nd05.default)({}, applying || clearButton ? {
            endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                fontSize: "small",
                color: "action"
            }) : clearButton
        } : {}, {
            disabled: disabled
        }, InputProps, {
            inputProps: (0, $8nd05.default)({
                max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                tabIndex: tabIndex
            }, InputProps == null ? void 0 : InputProps.inputProps)
        })
    }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}

});


parcelRegister("3D30W", function(module, exports) {

$parcel$export(module.exports, "renderEditDateCell", () => $2a475a2a246869fc$export$b815d37f7a90225c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $2a475a2a246869fc$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const $2a475a2a246869fc$var$StyledInputBase = (0, $d8seH.default)((0, $95gUw.default))({
    fontSize: 'inherit'
});
const $2a475a2a246869fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $2a475a2a246869fc$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, inputProps: inputProps, onValueChange: onValueChange } = props, other = (0, $1En50.default)(props, $2a475a2a246869fc$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $acw62.useRef();
    const valueTransformed = $acw62.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp != null ? valueProp : '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $acw62.useState(valueTransformed);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $2a475a2a246869fc$var$useUtilityClasses(ownerState);
    const parseValueToDate = $acw62.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $acw62.useEffect(()=>{
        setValueState((state)=>{
            var _valueTransformed$par, _state$parsed;
            if (valueTransformed.parsed !== state.parsed && ((_valueTransformed$par = valueTransformed.parsed) == null ? void 0 : _valueTransformed$par.getTime()) !== ((_state$parsed = state.parsed) == null ? void 0 : _state$parsed.getTime())) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$StyledInputBase, (0, $8nd05.default)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        inputProps: (0, $8nd05.default)({
            max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const $2a475a2a246869fc$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$export$b4fb7433f4444e3f, (0, $8nd05.default)({}, params));

});


parcelRegister("2LzSK", function(module, exports) {

$parcel$export(module.exports, "GRID_SINGLE_SELECT_COL_DEF", () => $203bce01501b8211$export$7acf0d6e5e468a51);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $7cMVI = parcelRequire("7cMVI");

var $hIUWG = parcelRequire("hIUWG");

var $5z7Pl = parcelRequire("5z7Pl");

var $lR3Vo = parcelRequire("lR3Vo");
const $203bce01501b8211$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $203bce01501b8211$var$defaultGetOptionValue = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.value : value;
};
const $203bce01501b8211$var$defaultGetOptionLabel = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.label : String(value);
};
const $203bce01501b8211$export$7acf0d6e5e468a51 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    type: 'singleSelect',
    getOptionLabel: $203bce01501b8211$var$defaultGetOptionLabel,
    getOptionValue: $203bce01501b8211$var$defaultGetOptionValue,
    valueFormatter (params) {
        const { id: id, field: field, value: value, api: api } = params;
        const colDef = params.api.getColumn(field);
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return '';
        let valueOptions;
        if (typeof colDef.valueOptions === 'function') valueOptions = colDef.valueOptions({
            id: id,
            row: id ? api.getRow(id) : null,
            field: field
        });
        else valueOptions = colDef.valueOptions;
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$203bce01501b8211$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: (0, $7cMVI.renderEditSingleSelectCell),
    filterOperators: (0, $hIUWG.getGridSingleSelectOperators)(),
    // @ts-ignore
    pastedValueParser: (value, params)=>{
        const colDef = params.colDef;
        const colDefValueOptions = colDef.valueOptions;
        const valueOptions = typeof colDefValueOptions === 'function' ? colDefValueOptions({
            field: colDef.field
        }) : colDefValueOptions || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});

});
parcelRegister("7cMVI", function(module, exports) {

$parcel$export(module.exports, "renderEditSingleSelectCell", () => $53ef9bd93fd99a94$export$13060fab7d49b7a1);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $eEJPp = parcelRequire("eEJPp");

var $iNfie = parcelRequire("iNfie");

var $dMF9H = parcelRequire("dMF9H");

var $jDpXp = parcelRequire("jDpXp");

var $jkRzp = parcelRequire("jkRzp");

var $5z7Pl = parcelRequire("5z7Pl");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $53ef9bd93fd99a94$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "getOptionLabel",
    "getOptionValue"
], $53ef9bd93fd99a94$var$_excluded2 = [
    "MenuProps"
];
function $53ef9bd93fd99a94$var$isKeyboardEvent(event) {
    return !!event.key;
}
function $53ef9bd93fd99a94$export$df7446df636ddbed(props) {
    var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $jkRzp.GridEditModes).Cell, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = (0, $1En50.default)(props, $53ef9bd93fd99a94$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ref = $acw62.useRef();
    const inputRef = $acw62.useRef();
    const [open, setOpen] = $acw62.useState(initialOpen);
    const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : false;
    const _ref = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {}, { MenuProps: MenuProps } = _ref, otherBaseSelectProps = (0, $1En50.default)(_ref, $53ef9bd93fd99a94$var$_excluded2);
    (0, $eEJPp.default)(()=>{
        if (hasFocus) {
            var _inputRef$current;
            (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
        }
    }, [
        hasFocus
    ]);
    if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return null;
    let valueOptions;
    if (typeof (colDef == null ? void 0 : colDef.valueOptions) === 'function') valueOptions = colDef == null ? void 0 : colDef.valueOptions({
        id: id,
        row: row,
        field: field
    });
    else valueOptions = colDef == null ? void 0 : colDef.valueOptions;
    if (!valueOptions) return null;
    const getOptionValue = getOptionValueProp || colDef.getOptionValue;
    const getOptionLabel = getOptionLabelProp || colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $5z7Pl.getValueFromValueOptions)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $jkRzp.GridEditModes).Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || (0, $dMF9H.isEscapeKey)(event.key)) {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $8nd05.default)({}, params, {
                reason: (0, $dMF9H.isEscapeKey)(event.key) ? (0, $iNfie.GridCellEditStopReasons).escapeKeyDown : (0, $iNfie.GridCellEditStopReasons).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($53ef9bd93fd99a94$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
        ref: ref,
        inputRef: inputRef,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: (0, $8nd05.default)({
            onClose: handleClose
        }, MenuProps),
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, otherBaseSelectProps, {
        children: valueOptions.map((valueOption)=>{
            var _rootProps$slotProps3;
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelectOption) || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $53ef9bd93fd99a94$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($53ef9bd93fd99a94$export$df7446df636ddbed, (0, $8nd05.default)({}, params));

});
parcelRegister("iNfie", function(module, exports) {

$parcel$export(module.exports, "GridCellEditStartReasons", () => $dae8aa7db1c69e5a$export$66744c3b0d0c6217);
$parcel$export(module.exports, "GridCellEditStopReasons", () => $dae8aa7db1c69e5a$export$73fccbaa325472ee);
/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $dae8aa7db1c69e5a$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($dae8aa7db1c69e5a$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $dae8aa7db1c69e5a$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($dae8aa7db1c69e5a$export$73fccbaa325472ee || {});

});

parcelRegister("jkRzp", function(module, exports) {

$parcel$export(module.exports, "GridEditModes", () => $e139707caeafbfd6$export$bad6b7a934346f26);
$parcel$export(module.exports, "GridCellModes", () => $e139707caeafbfd6$export$84e4fdd8f295ca31);
$parcel$export(module.exports, "GridRowModes", () => $e139707caeafbfd6$export$d98c76b959bb0b5c);
var $e139707caeafbfd6$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($e139707caeafbfd6$export$bad6b7a934346f26 || {});
var $e139707caeafbfd6$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($e139707caeafbfd6$export$84e4fdd8f295ca31 || {});
var $e139707caeafbfd6$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($e139707caeafbfd6$export$d98c76b959bb0b5c || {});

});

parcelRegister("5z7Pl", function(module, exports) {

$parcel$export(module.exports, "isSingleSelectColDef", () => $40d64af47d07faaf$export$74006a51f68c6262);
$parcel$export(module.exports, "getValueFromValueOptions", () => $40d64af47d07faaf$export$b31a7985e33f7505);
function $40d64af47d07faaf$export$74006a51f68c6262(colDef) {
    return (colDef == null ? void 0 : colDef.type) === 'singleSelect';
}
function $40d64af47d07faaf$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}
const $40d64af47d07faaf$export$f3eb784638ed9dd8 = (valueOption)=>{
    const label = typeof valueOption === 'object' ? valueOption.label : valueOption;
    return label != null ? String(label) : '';
};

});


parcelRegister("hIUWG", function(module, exports) {

$parcel$export(module.exports, "getGridSingleSelectOperators", () => $ce72b7e51ff8300c$export$fe632a61ba1bdc90);

var $4UMDV = parcelRequire("4UMDV");

var $DRQFc = parcelRequire("DRQFc");

var $lR3Vo = parcelRequire("lR3Vo");

var $dJVXj = parcelRequire("dJVXj");
const $ce72b7e51ff8300c$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $lR3Vo.isObject)(value)) return value;
    return value.value;
};
const $ce72b7e51ff8300c$export$fe632a61ba1bdc90 = ()=>(0, $dJVXj.convertLegacyOperators)([
        {
            value: 'is',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) === $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $4UMDV.GridFilterInputSingleSelect)
        },
        {
            value: 'not',
            getApplyFilterFnV7: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) !== $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $4UMDV.GridFilterInputSingleSelect)
        },
        {
            value: 'isAnyOf',
            getApplyFilterFnV7: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($ce72b7e51ff8300c$var$parseObjectValue);
                return (value)=>filterItemValues.includes($ce72b7e51ff8300c$var$parseObjectValue(value));
            },
            InputComponent: (0, $DRQFc.GridFilterInputMultipleSingleSelect)
        }
    ]);

});
parcelRegister("4UMDV", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputSingleSelect", () => $39421fe28cb0a5f3$export$760eb819dd95d361);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $jDpXp = parcelRequire("jDpXp");

var $5z7Pl = parcelRequire("5z7Pl");

var $ayMG0 = parcelRequire("ayMG0");
const $39421fe28cb0a5f3$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "getOptionLabel",
    "getOptionValue",
    "placeholder",
    "tabIndex",
    "label",
    "variant",
    "isFilterActive",
    "clearButton",
    "InputLabelProps"
];
const $39421fe28cb0a5f3$var$renderSingleSelectOptions = ({ column: { valueOptions: valueOptions, field: field }, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = typeof valueOptions === 'function' ? [
        '',
        ...valueOptions({
            field: field
        })
    ] : [
        '',
        ...valueOptions || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        const label = getOptionLabel(option);
        return /*#__PURE__*/ (0, $acw62.createElement)(OptionComponent, (0, $8nd05.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
const $39421fe28cb0a5f3$var$SingleSelectOperatorContainer = (0, $d8seH.default)('div')({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [`& button`]: {
        margin: 'auto 0px 5px 5px'
    }
});
function $39421fe28cb0a5f3$export$760eb819dd95d361(props) {
    var _item$value, _rootProps$slotProps$, _rootProps$slotProps, _resolvedColumn, _resolvedColumn2, _rootProps$slotProps2, _rootProps$slotProps3, _rootProps$slotProps4;
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp, placeholder: placeholder, tabIndex: tabIndex, label: labelProp, variant: variant = 'standard', clearButton: clearButton } = props, others = (0, $1En50.default)(props, $39421fe28cb0a5f3$var$_excluded);
    const [filterValueState, setFilterValueState] = $acw62.useState((_item$value = item.value) != null ? _item$value : '');
    const id = (0, $auC0X.default)();
    const labelId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isSelectNative = (_rootProps$slotProps$ = (_rootProps$slotProps = rootProps.slotProps) == null || (_rootProps$slotProps = _rootProps$slotProps.baseSelect) == null ? void 0 : _rootProps$slotProps.native) != null ? _rootProps$slotProps$ : true;
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $5z7Pl.isSingleSelectColDef)(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
    const currentValueOptions = $acw62.useMemo(()=>{
        if (!resolvedColumn) return undefined;
        return typeof resolvedColumn.valueOptions === 'function' ? resolvedColumn.valueOptions({
            field: resolvedColumn.field
        }) : resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $acw62.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $5z7Pl.getValueFromValueOptions)(value, currentValueOptions, getOptionValue);
        setFilterValueState(String(value));
        applyValue((0, $8nd05.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    $acw62.useEffect(()=>{
        var _itemValue;
        let itemValue;
        if (currentValueOptions !== undefined) {
            // sanitize if valueOptions are provided
            itemValue = (0, $5z7Pl.getValueFromValueOptions)(item.value, currentValueOptions, getOptionValue);
            if (itemValue !== item.value) {
                applyValue((0, $8nd05.default)({}, item, {
                    value: itemValue
                }));
                return;
            }
        } else itemValue = item.value;
        itemValue = (_itemValue = itemValue) != null ? _itemValue : '';
        setFilterValueState(String(itemValue));
    }, [
        item,
        currentValueOptions,
        applyValue,
        getOptionValue
    ]);
    if (!(0, $5z7Pl.isSingleSelectColDef)(resolvedColumn)) return null;
    if (!(0, $5z7Pl.isSingleSelectColDef)(resolvedColumn)) return null;
    const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($39421fe28cb0a5f3$var$SingleSelectOperatorContainer, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseFormControl, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseInputLabel, {
                        id: labelId,
                        htmlFor: id,
                        shrink: true,
                        variant: variant,
                        children: label
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        id: id,
                        label: label,
                        labelId: labelId,
                        value: filterValueState,
                        onChange: onFilterChange,
                        variant: variant,
                        type: type || 'text',
                        inputProps: {
                            tabIndex: tabIndex,
                            ref: focusElementRef,
                            placeholder: placeholder != null ? placeholder : apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                        },
                        native: isSelectNative,
                        notched: variant === 'outlined' ? true : undefined
                    }, others /* FIXME: typing error */ , (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelect, {
                        children: $39421fe28cb0a5f3$var$renderSingleSelectOptions({
                            column: resolvedColumn,
                            OptionComponent: rootProps.slots.baseSelectOption,
                            getOptionLabel: getOptionLabel,
                            getOptionValue: getOptionValue,
                            isSelectNative: isSelectNative,
                            baseSelectOptionProps: (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption
                        })
                    }))
                ]
            }),
            clearButton
        ]
    });
}

});

parcelRegister("DRQFc", function(module, exports) {

$parcel$export(module.exports, "GridFilterInputMultipleSingleSelect", () => $077d69ce451095d0$export$a61be354e4fcf2c5);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $33DpT = parcelRequire("33DpT");
var $cFBau = parcelRequire("cFBau");

var $auC0X = parcelRequire("auC0X");

var $5z7Pl = parcelRequire("5z7Pl");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $077d69ce451095d0$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant",
    "getOptionLabel",
    "getOptionValue"
];
const $077d69ce451095d0$var$filter = (0, $33DpT.createFilterOptions)();
function $077d69ce451095d0$export$a61be354e4fcf2c5(props) {
    var _resolvedColumn, _resolvedColumn2;
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, color: color, error: error, helperText: helperText, size: size, variant: variant = 'standard', getOptionLabel: getOptionLabelProp, getOptionValue: getOptionValueProp } = props, other = (0, $1En50.default)(props, $077d69ce451095d0$var$_excluded);
    const TextFieldProps = {
        color: color,
        error: error,
        helperText: helperText,
        size: size,
        variant: variant
    };
    const id = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    let resolvedColumn = null;
    if (item.field) {
        const column = apiRef.current.getColumn(item.field);
        if ((0, $5z7Pl.isSingleSelectColDef)(column)) resolvedColumn = column;
    }
    const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
    const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
    const isOptionEqualToValue = $acw62.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $acw62.useMemo(()=>{
        var _resolvedColumn3;
        if (!((_resolvedColumn3 = resolvedColumn) != null && _resolvedColumn3.valueOptions)) return [];
        if (typeof resolvedColumn.valueOptions === 'function') return resolvedColumn.valueOptions({
            field: resolvedColumn.field
        });
        return resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const resolvedFormattedValueOptions = $acw62.useMemo(()=>{
        return resolvedValueOptions == null ? void 0 : resolvedValueOptions.map(getOptionValue);
    }, [
        resolvedValueOptions,
        getOptionValue
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $acw62.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        if (resolvedValueOptions !== undefined) {
            const itemValueIndexes = item.value.map((element)=>{
                // Gets the index matching between values and valueOptions
                return resolvedFormattedValueOptions == null ? void 0 : resolvedFormattedValueOptions.findIndex((formattedOption)=>formattedOption === element);
            });
            return itemValueIndexes.filter((index)=>index >= 0).map((index)=>resolvedValueOptions[index]);
        }
        return item.value;
    }, [
        item.value,
        resolvedValueOptions,
        resolvedFormattedValueOptions
    ]);
    $acw62.useEffect(()=>{
        if (!Array.isArray(item.value) || filteredValues.length !== item.value.length) // Updates the state if the filter value has been cleaned by the component
        applyValue((0, $8nd05.default)({}, item, {
            value: filteredValues.map(getOptionValue)
        }));
    }, [
        item,
        filteredValues,
        applyValue,
        getOptionValue
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        applyValue((0, $8nd05.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), (0, $8nd05.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: $077d69ce451095d0$var$filter,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseChip, (0, $8nd05.default)({
                    variant: "outlined",
                    size: "small",
                    label: getOptionLabel(option)
                }, getTagProps({
                    index: index
                })))),
        renderInput: (params)=>{
            var _rootProps$slotProps;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({}, params, {
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                InputLabelProps: (0, $8nd05.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
        }
    }, other));
}

});



parcelRegister("8z2XQ", function(module, exports) {

$parcel$export(module.exports, "GRID_ACTIONS_COLUMN_TYPE", () => $63c3e445c9bf0af1$export$e2523ab9efeb7465);
$parcel$export(module.exports, "GRID_ACTIONS_COL_DEF", () => $63c3e445c9bf0af1$export$cc51a5e65f00f971);

var $8nd05 = parcelRequire("8nd05");

var $bSL2h = parcelRequire("bSL2h");

var $cc312 = parcelRequire("cc312");
const $63c3e445c9bf0af1$export$e2523ab9efeb7465 = 'actions';
const $63c3e445c9bf0af1$export$cc51a5e65f00f971 = (0, $8nd05.default)({}, (0, $bSL2h.GRID_STRING_COL_DEF), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $cc312.renderActionsCell),
    getApplyQuickFilterFn: undefined,
    getApplyQuickFilterFnV7: undefined
});

});
parcelRegister("cc312", function(module, exports) {

$parcel$export(module.exports, "renderActionsCell", () => $8e08f1e439e1e2b5$export$974043ff7a6a1028);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $lBOb7 = parcelRequire("lBOb7");

var $14H9o = parcelRequire("14H9o");

var $auC0X = parcelRequire("auC0X");

var $5H1vo = parcelRequire("5H1vo");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $8e08f1e439e1e2b5$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $8e08f1e439e1e2b5$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $8e08f1e439e1e2b5$export$e8966cddc2f9f685(props) {
    var _rootProps$slotProps;
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', focusElementRef: focusElementRef } = props, other = (0, $1En50.default)(props, $8e08f1e439e1e2b5$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootRef = $acw62.useRef(null);
    const buttonRef = $acw62.useRef(null);
    const ignoreCallToFocus = $acw62.useRef(false);
    const touchRippleRefs = $acw62.useRef({});
    const theme = (0, $14H9o.default)();
    const menuId = (0, $auC0X.default)();
    const buttonId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (!$8e08f1e439e1e2b5$var$hasActions(colDef)) throw new Error('MUI: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $acw62.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref == null || ref.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            var _options;
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = theme.direction === 'rtl' ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return (_options = options[index + indexMod]) != null && _options.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, e.g. ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ([
            'Tab',
            'Escape'
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, $5H1vo.gridClasses).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: showMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                    id: menuId,
                    className: (0, $5H1vo.gridClasses).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
const $8e08f1e439e1e2b5$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$export$e8966cddc2f9f685, (0, $8nd05.default)({}, params));

});
parcelRegister("lBOb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $gzyUk = parcelRequire("gzyUk");

var $8AyZl = parcelRequire("8AyZl");

var $19SuQ = parcelRequire("19SuQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $khjmj.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $19SuQ.default)((0, $gzyUk.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $gzyUk.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $9Rgf1.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("gzyUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10afe25107351d9$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $6zeBo.default);

});

parcelRegister("8AyZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eUMjp.getListUtilityClass), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;

});
parcelRegister("3W6ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddba918a398c481$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;

});

parcelRegister("eUMjp", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $adbbc5717e0d0350$export$c6bd6795ed6e3203);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;

});


parcelRegister("19SuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d80e79907b6bdbc$export$2e2bcd8739ae039);

var $aF4kJ = parcelRequire("aF4kJ");
var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $aF4kJ.default);

});
parcelRegister("aF4kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0200cab69b9251c8$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRegister("14H9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c87a2f38cd49c7a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $7HKeb = parcelRequire("7HKeb");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $7HKeb.default)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}

});

parcelRegister("ch6XH", function(module, exports) {

$parcel$export(module.exports, "GridMenu", () => $8efc7911d5661cb8$export$237948c71948075);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $kGwBF = parcelRequire("kGwBF");

var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $iscuz = parcelRequire("iscuz");

var $7Frhn = parcelRequire("7Frhn");

var $e76iu = parcelRequire("e76iu");

var $d8seH = parcelRequire("d8seH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $8efc7911d5661cb8$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $8efc7911d5661cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $8efc7911d5661cb8$var$GridMenuRoot = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiDataGrid',
    slot: 'Menu',
    overridesResolver: (_, styles)=>styles.menu
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, $5H1vo.gridClasses).menuList}`]: {
            outline: 0
        }
    }));
const $8efc7911d5661cb8$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $8efc7911d5661cb8$export$237948c71948075(props) {
    var _rootProps$slotProps;
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $1En50.default)(props, $8efc7911d5661cb8$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $8efc7911d5661cb8$var$useUtilityClasses(rootProps);
    const savedFocusRef = $acw62.useRef(null);
    (0, $eEJPp.default)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            var _savedFocusRef$curren, _savedFocusRef$curren2;
            (_savedFocusRef$curren = savedFocusRef.current) == null || (_savedFocusRef$curren2 = _savedFocusRef$curren.focus) == null || _savedFocusRef$curren2.call(_savedFocusRef$curren);
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target != null && target.contains(event.target))) return;
        onClose(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$var$GridMenuRoot, (0, $8nd05.default)({
        as: rootProps.slots.basePopper,
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.basePopper, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iscuz.default), (0, $8nd05.default)({}, TransitionProps, {
                    style: {
                        transformOrigin: $8efc7911d5661cb8$var$transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps == null ? void 0 : TransitionProps.onExited),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Frhn.default), {
                        children: children
                    })
                }))
            })
    }));
}

});
parcelRegister("kGwBF", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);

var $acw62 = parcelRequire("acw62");


var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $2xc7G = parcelRequire("2xc7G");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}

});

parcelRegister("iscuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $lHOu3 = parcelRequire("lHOu3");


var $2xc7G = parcelRequire("2xc7G");

var $1mPeS = parcelRequire("1mPeS");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $lHOu3.default)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $14H9o.default)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("hweuE", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $cc10aae84e3e4b9c$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $cc10aae84e3e4b9c$export$8cb1e9b404609ae9);
const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});







parcelRegister("3PCYS", function(module, exports) {

$parcel$export(module.exports, "GridPreferencePanelsValue", () => $2ca45f4bbfed6878$export$e7e5652452e44b);
var $2ca45f4bbfed6878$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    return GridPreferencePanelsValue;
}($2ca45f4bbfed6878$export$e7e5652452e44b || {});

});


parcelRegister("izeLD", function(module, exports) {

$parcel$export(module.exports, "densityStateInitializer", () => $d846f35585bafc86$export$d6d71dbaaa6fec72);
$parcel$export(module.exports, "useGridDensity", () => $d846f35585bafc86$export$836c4be63cf7a42d);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $luu6e = parcelRequire("luu6e");

var $ivFej = parcelRequire("ivFej");

var $fD9f4 = parcelRequire("fD9f4");

var $lR3Vo = parcelRequire("lR3Vo");
const $d846f35585bafc86$export$44e428f429332330 = 0.7;
const $d846f35585bafc86$export$ff72d9a37c8f7b58 = 1.3;
const $d846f35585bafc86$var$DENSITY_FACTORS = {
    compact: $d846f35585bafc86$export$44e428f429332330,
    comfortable: $d846f35585bafc86$export$ff72d9a37c8f7b58,
    standard: 1
};
const $d846f35585bafc86$export$d6d71dbaaa6fec72 = (state, props)=>(0, $8nd05.default)({}, state, {
        density: {
            value: props.density,
            factor: $d846f35585bafc86$var$DENSITY_FACTORS[props.density]
        }
    });
const $d846f35585bafc86$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useDensity');
    const setDensity = $acw62.useCallback((newDensity)=>{
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>{
            const currentDensityState = (0, $fD9f4.gridDensitySelector)(state);
            const newDensityState = {
                value: newDensity,
                factor: $d846f35585bafc86$var$DENSITY_FACTORS[newDensity]
            };
            if ((0, $lR3Vo.isDeepEqual)(currentDensityState, newDensityState)) return state;
            return (0, $8nd05.default)({}, state, {
                density: newDensityState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        apiRef
    ]);
    $acw62.useEffect(()=>{
        apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
    const densityApi = {
        setDensity: setDensity
    };
    (0, $ivFej.useGridApiMethod)(apiRef, densityApi, 'public');
};

});

parcelRegister("gU8sa", function(module, exports) {

$parcel$export(module.exports, "useGridCsvExport", () => $c4e86ef235136df5$export$6178dbab26611702);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $8boSz = parcelRequire("8boSz");

var $k5aPx = parcelRequire("k5aPx");

var $jSbr9 = parcelRequire("jSbr9");

var $2kdmP = parcelRequire("2kdmP");

var $1v4Qb = parcelRequire("1v4Qb");

var $ayMG0 = parcelRequire("ayMG0");
const $c4e86ef235136df5$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $acw62.useCallback((options = {})=>{
        var _options$getRowsToExp, _options$shouldAppend, _options$includeHeade, _options$includeColum, _options$escapeFormul;
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $jSbr9.getColumnsToExport)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = (_options$getRowsToExp = options.getRowsToExport) != null ? _options$getRowsToExp : (0, $jSbr9.defaultGetRowsToExport);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $k5aPx.buildCSV)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: (_options$shouldAppend = options.shouldAppendQuotes) != null ? _options$shouldAppend : true,
                includeHeaders: (_options$includeHeade = options.includeHeaders) != null ? _options$includeHeade : true,
                includeColumnGroupsHeaders: (_options$includeColum = options.includeColumnGroupsHeaders) != null ? _options$includeColum : true,
                escapeFormulas: (_options$escapeFormul = options.escapeFormulas) != null ? _options$escapeFormul : true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $acw62.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options != null && options.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $8boSz.exportAs)(blob, 'csv', options == null ? void 0 : options.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $ivFej.useGridApiMethod)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        var _options$csvOptions;
        if ((_options$csvOptions = options.csvOptions) != null && _options$csvOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1v4Qb.GridCsvExportMenuItem), {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};

});
parcelRegister("8boSz", function(module, exports) {

$parcel$export(module.exports, "exportAs", () => $5f52a64decff8320$export$f95aebe89510930);
/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $5f52a64decff8320$export$f95aebe89510930(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI: exportAs not supported');
}

});

parcelRegister("jSbr9", function(module, exports) {

$parcel$export(module.exports, "getColumnsToExport", () => $e77bee9f62f5124d$export$c5c7f3bb5f79a15d);
$parcel$export(module.exports, "defaultGetRowsToExport", () => $e77bee9f62f5124d$export$99156d1572dee776);

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");
const $e77bee9f62f5124d$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const $e77bee9f62f5124d$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    const filteredSortedRowIds = (0, $k278Q.gridFilteredSortedRowIdsSelector)(apiRef);
    const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsIds = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.map((row)=>row.id)) || [];
    const bottomPinnedRowsIds = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.map((row)=>row.id)) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};

});

parcelRegister("1v4Qb", function(module, exports) {

$parcel$export(module.exports, "GridCsvExportMenuItem", () => $117c70f90fd64960$export$c0e66088a5c9ffbf);
$parcel$export(module.exports, "GridPrintExportMenuItem", () => $117c70f90fd64960$export$a6cd094b30f69b92);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bDyDY = parcelRequire("bDyDY");

var $03n8N = parcelRequire("03n8N");

var $ayMG0 = parcelRequire("ayMG0");
const $117c70f90fd64960$var$_excluded = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded2 = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $117c70f90fd64960$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $1En50.default)(props, $117c70f90fd64960$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $117c70f90fd64960$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $1En50.default)(props, $117c70f90fd64960$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
const $117c70f90fd64960$export$ef68b449b329deb5 = /*#__PURE__*/ $acw62.forwardRef(function GridToolbarExport(props, ref) {
    const { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = props, other = (0, $1En50.default)(props, $117c70f90fd64960$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03n8N.GridToolbarExportContainer), (0, $8nd05.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button.component, {
                key: index
            }))
    }));
});

});
parcelRegister("2iAqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac984bce84b2164$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $cbVYE = parcelRequire("cbVYE");

var $doXfV = parcelRequire("doXfV");

var $guz4p = parcelRequire("guz4p");

var $eWb0W = parcelRequire("eWb0W");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $eWb0W.getMenuItemUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $eWb0W.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $eWb0W.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $eWb0W.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $cbVYE.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $cbVYE.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $guz4p.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $guz4p.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $doXfV.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $doXfV.default).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $9Rgf1.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("cbVYE", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $024a60f892d3fa61$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $024a60f892d3fa61$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;

});

parcelRegister("doXfV", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $9c1b7b40cd19f5fe$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});

parcelRegister("guz4p", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $c01aa6ddbe5e68bd$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});

parcelRegister("eWb0W", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $adff06ac3b11e066$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $adff06ac3b11e066$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;

});


parcelRegister("03n8N", function(module, exports) {

$parcel$export(module.exports, "GridToolbarExportContainer", () => $00a23b3a9224b6aa$export$9c3c7dbe6f1101cf);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $3qSdM = parcelRequire("3qSdM");
var $auC0X = parcelRequire("auC0X");

var $lBOb7 = parcelRequire("lBOb7");

var $dMF9H = parcelRequire("dMF9H");

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $00a23b3a9224b6aa$var$_excluded = [
    "children",
    "onClick"
];
const $00a23b3a9224b6aa$export$9c3c7dbe6f1101cf = /*#__PURE__*/ $acw62.forwardRef(function GridToolbarExportContainer(props, ref) {
    var _rootProps$slotProps;
    const { children: children, onClick: onClick } = props, other = (0, $1En50.default)(props, $00a23b3a9224b6aa$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const exportButtonId = (0, $auC0X.default)();
    const exportMenuId = (0, $auC0X.default)();
    const [open, setOpen] = $acw62.useState(false);
    const buttonRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        onClick == null || onClick(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if ((0, $dMF9H.isTabKey)(event.key)) event.preventDefault();
        if ((0, $dMF9H.isHideMenuKey)(event.key)) handleMenuClose();
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                ref: handleRef,
                size: "small",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {}),
                "aria-expanded": open,
                "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                "aria-haspopup": "menu",
                "aria-controls": open ? exportMenuId : undefined,
                id: exportButtonId
            }, other, {
                onClick: handleMenuOpen
            }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
                children: apiRef.current.getLocaleText('toolbarExport')
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lBOb7.default), {
                    id: exportMenuId,
                    className: (0, $5H1vo.gridClasses).menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: $acw62.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return child;
                        return /*#__PURE__*/ $acw62.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});

});



parcelRegister("4D37q", function(module, exports) {

$parcel$export(module.exports, "useGridPrintExport", () => $35ed394581d01f61$export$41205b2521d4edd4);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");

var $luu6e = parcelRequire("luu6e");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $bdqIg = parcelRequire("bdqIg");

var $jSbr9 = parcelRequire("jSbr9");

var $87jE6 = parcelRequire("87jE6");

var $2kdmP = parcelRequire("2kdmP");

var $1v4Qb = parcelRequire("1v4Qb");

var $i0LyH = parcelRequire("i0LyH");

var $5bG6h = parcelRequire("5bG6h");

var $goCyd = parcelRequire("goCyd");

var $ayMG0 = parcelRequire("ayMG0");
function $35ed394581d01f61$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $35ed394581d01f61$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $35ed394581d01f61$export$41205b2521d4edd4 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPrintExport');
    const doc = $acw62.useRef(null);
    const previousGridState = $acw62.useRef(null);
    const previousColumnVisibility = $acw62.useRef({});
    const previousRows = $acw62.useRef([]);
    $acw62.useEffect(()=>{
        doc.current = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
    }, [
        apiRef
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $acw62.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $jSbr9.getColumnsToExport)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $acw62.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.map((id)=>apiRef.current.getRow(id));
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $acw62.useCallback((printWindow, options)=>{
        var _querySelector, _querySelector2;
        const normalizeOptions = (0, $8nd05.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).main}`);
        gridMain.style.overflow = 'visible';
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = 'size';
        const columnHeaders = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaders}`);
        const columnHeadersInner = columnHeaders.querySelector(`.${(0, $5H1vo.gridClasses).columnHeadersInner}`);
        columnHeadersInner.style.width = '100%';
        let gridToolbarElementHeight = ((_querySelector = gridRootElement.querySelector(`.${(0, $5H1vo.gridClasses).toolbarContainer}`)) == null ? void 0 : _querySelector.offsetHeight) || 0;
        let gridFooterElementHeight = ((_querySelector2 = gridRootElement.querySelector(`.${(0, $5H1vo.gridClasses).footerContainer}`)) == null ? void 0 : _querySelector2.offsetHeight) || 0;
        if (normalizeOptions.hideToolbar) {
            var _gridClone$querySelec;
            (_gridClone$querySelec = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).toolbarContainer}`)) == null || _gridClone$querySelec.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter) {
            var _gridClone$querySelec2;
            (_gridClone$querySelec2 = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).footerContainer}`)) == null || _gridClone$querySelec2.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $i0LyH.getTotalHeaderHeight)(apiRef, props.columnHeaderHeight) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        // the footer is always being placed at the bottom of the page as if all rows are exported
        // so if getRowsToExport is being used to only export a subset of rows then we need to
        // adjust the footer position to be correctly placed at the bottom of the grid
        if (options != null && options.getRowsToExport) {
            const gridFooterElement = gridClone.querySelector(`.${(0, $5H1vo.gridClasses).footerContainer}`);
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        const stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === 'STYLE') {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = '';
                        // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute('href')) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
                    }
                    stylesheetLoadPromises.push(new Promise((resolve)=>{
                        newHeadStyleElements.addEventListener('load', ()=>resolve());
                    }));
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props.columnHeaderHeight
    ]);
    const handlePrintWindowAfterPrint = $acw62.useCallback((printWindow)=>{
        var _previousGridState$cu;
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!((_previousGridState$cu = previousGridState.current) != null && (_previousGridState$cu = _previousGridState$cu.columns) != null && _previousGridState$cu.columnVisibilityModel)) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.unstable_setVirtualization(true);
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $acw62.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const gridRowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        previousRows.current = (0, $goCyd.gridDataRowIdsSelector)(apiRef).map((rowId)=>gridRowsLookup[rowId]);
        if (props.pagination) {
            const visibleRowCount = (0, $k278Q.gridExpandedRowCountSelector)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    pagination: (0, $8nd05.default)({}, state.pagination, {
                        paginationModel: (0, $87jE6.getDerivedPaginationModel)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
            apiRef.current.forceUpdate();
        }
        await updateGridColumnsForPrint(options == null ? void 0 : options.fields, options == null ? void 0 : options.allColumns, options == null ? void 0 : options.includeCheckboxes);
        if (options != null && options.getRowsToExport) updateGridRowsForPrint(options.getRowsToExport);
        apiRef.current.unstable_setVirtualization(false);
        await $35ed394581d01f61$var$raf(); // wait for the state changes to take action
        const printWindow = $35ed394581d01f61$var$buildPrintWindow(options == null ? void 0 : options.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $ivFej.useGridApiMethod)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        var _options$printOptions;
        if ((_options$printOptions = options.printOptions) != null && _options$printOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1v4Qb.GridPrintExportMenuItem), {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};

});
parcelRegister("bdqIg", function(module, exports) {

$parcel$export(module.exports, "gridRowsMetaSelector", () => $82a5a13765976ef2$export$4f32bfc70efeb4ab);
const $82a5a13765976ef2$export$4f32bfc70efeb4ab = (state)=>state.rowsMeta;

});

parcelRegister("87jE6", function(module, exports) {

$parcel$export(module.exports, "getDerivedPaginationModel", () => $5e8e37726d5ba261$export$16d1dc8477d07e4);
$parcel$export(module.exports, "useGridPaginationModel", () => $5e8e37726d5ba261$export$fb13b4a85293b054);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $fD9f4 = parcelRequire("fD9f4");

var $7sDf4 = parcelRequire("7sDf4");

var $eFF1m = parcelRequire("eFF1m");
var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $5sOMZ = parcelRequire("5sOMZ");

var $2kdmP = parcelRequire("2kdmP");

var $gPWuj = parcelRequire("gPWuj");

var $baj2X = parcelRequire("baj2X");
const $5e8e37726d5ba261$export$16d1dc8477d07e4 = (paginationState, signature, paginationModelProp)=>{
    var _paginationModelProp$;
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = (_paginationModelProp$ = paginationModelProp == null ? void 0 : paginationModelProp.pageSize) != null ? _paginationModelProp$ : paginationModel.pageSize;
    const pageCount = (0, $baj2X.getPageCount)(rowCount, pageSize);
    if (paginationModelProp && ((paginationModelProp == null ? void 0 : paginationModelProp.page) !== paginationModel.page || (paginationModelProp == null ? void 0 : paginationModelProp.pageSize) !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = (0, $baj2X.getValidPage)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $8nd05.default)({}, paginationModel, {
        page: validPage
    });
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, signature);
    return paginationModel;
};
const $5e8e37726d5ba261$export$fb13b4a85293b054 = (apiRef, props)=>{
    var _props$initialState2;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $gPWuj.gridPaginationModelSelector),
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $acw62.useCallback((page)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $acw62.useCallback((pageSize)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $acw62.useCallback((paginationModel)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }));
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState;
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        ((_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.pagination) == null ? void 0 : _props$initialState.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $baj2X.defaultPageSize)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            pagination: (0, $8nd05.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.pagination) == null ? void 0 : _props$initialState2.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        var _context$stateToResto, _context$stateToResto2;
        const paginationModel = (_context$stateToResto = context.stateToRestore.pagination) != null && _context$stateToResto.paginationModel ? (0, $8nd05.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), (_context$stateToResto2 = context.stateToRestore.pagination) == null ? void 0 : _context$stateToResto2.paginationModel) : (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }));
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        var _apiRef$current$virtu;
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if ((_apiRef$current$virtu = apiRef.current.virtualScrollerRef) != null && _apiRef$current$virtu.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $acw62.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions() || {
            viewportInnerSize: {
                height: 0
            }
        };
        const pinnedRowsHeight = (0, $7sDf4.calculatePinnedRowsHeight)(apiRef);
        const maximumPageSizeWithoutScrollBar = Math.floor((dimensions.viewportInnerSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom) / rowHeight);
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $acw62.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        const pageCount = (0, $gPWuj.gridPageCountSelector)(apiRef);
        if (paginationModel.page > pageCount - 1) apiRef.current.setPage(Math.max(0, pageCount - 1));
    }, [
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowCountChange', handleRowCountChange);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$export$16d1dc8477d07e4(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.paginationMode,
        props.signature
    ]);
    $acw62.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};

});


parcelRegister("cx8m0", function(module, exports) {

$parcel$export(module.exports, "filterStateInitializer", () => $91ff0c015e83a086$export$a3e5a984fe72a5db);
$parcel$export(module.exports, "useGridFilter", () => $91ff0c015e83a086$export$42838275cbf666c4);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("6SpLG");
var $9EdUm = parcelRequire("9EdUm");

var $eEJPp = parcelRequire("eEJPp");

var $7O6ub = parcelRequire("7O6ub");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $3PCYS = parcelRequire("3PCYS");

var $l4QMb = parcelRequire("l4QMb");

var $k278Q = parcelRequire("k278Q");

var $bc8LN = parcelRequire("bc8LN");

var $goCyd = parcelRequire("goCyd");

var $2kdmP = parcelRequire("2kdmP");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $14dIX = parcelRequire("14dIX");

var $lR3Vo = parcelRequire("lR3Vo");

var $ayMG0 = parcelRequire("ayMG0");
const $91ff0c015e83a086$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    var _ref, _props$filterModel, _props$initialState;
    const filterModel = (_ref = (_props$filterModel = props.filterModel) != null ? _props$filterModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.filter) == null ? void 0 : _props$initialState.filterModel) != null ? _ref : (0, $l4QMb.getDefaultGridFilterModel)();
    return (0, $8nd05.default)({}, state, {
        filter: {
            filterModel: (0, $14dIX.sanitizeFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef),
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        },
        visibleRowsLookup: {}
    });
};
const $91ff0c015e83a086$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $91ff0c015e83a086$var$createMemoizedValues() {
    return (0, $9EdUm.defaultMemoize)(Object.values);
}
const $91ff0c015e83a086$export$42838275cbf666c4 = (apiRef, props)=>{
    var _props$initialState3, _props$slotProps2;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $k278Q.gridFilterModelSelector),
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $k278Q.gridFilterModelSelector)(state, apiRef.current.instanceId);
            const isRowMatchingFilters = props.filterMode === 'client' ? (0, $14dIX.buildAggregatedFilterApplier)(filterModel, apiRef, props.disableEval) : null;
            const filteringResult = apiRef.current.applyStrategyProcessor('filtering', {
                isRowMatchingFilters: isRowMatchingFilters,
                filterModel: filterModel != null ? filterModel : (0, $l4QMb.getDefaultGridFilterModel)()
            });
            const newState = (0, $8nd05.default)({}, state, {
                filter: (0, $8nd05.default)({}, state.filter, filteringResult)
            });
            const visibleRowsLookupState = $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $8nd05.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef,
        props.filterMode,
        props.disableEval
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const applyFilters = $acw62.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = $acw62.useCallback((item)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $acw62.useCallback((items)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $acw62.useCallback((itemToDelete)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $acw62.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                var _column$filterOperato;
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof (filterOperator == null ? void 0 : filterOperator.requiresFilterValue) === 'undefined' ? true : filterOperator == null ? void 0 : filterOperator.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $3PCYS.GridPreferencePanelsValue).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $acw62.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $acw62.useCallback((logicOperator)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $acw62.useCallback((values)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if ((0, $lR3Vo.isDeepEqual)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $acw62.useCallback((model, reason)=>{
        const currentModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics
    };
    (0, $ivFej.useGridApiMethod)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState2;
        const filterModelToExport = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.filter) == null ? void 0 : _props$initialState2.filterModel) != null || // Export if the model is not equal to the default value
        !(0, $lR3Vo.isDeepEqual)(filterModelToExport, (0, $l4QMb.getDefaultGridFilterModel)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.filter) == null ? void 0 : _props$initialState3.filterModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        var _context$stateToResto;
        const filterModel = (_context$stateToResto = context.stateToRestore.filter) == null ? void 0 : _context$stateToResto.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $8nd05.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $3PCYS.GridPreferencePanelsValue).filters) {
            var _props$slotProps;
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(FilterPanel, (0, $8nd05.default)({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $7O6ub.useLazyRef)($91ff0c015e83a086$var$createMemoizedValues);
    const flatFilteringMethod = $acw62.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters) return {
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        };
        const dataRowIdToModelLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $14dIX.passFilterLogic)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, apiRef, filterCache);
            filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'filtering', flatFilteringMethod);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'visibleRowsLookupCreation', $91ff0c015e83a086$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $acw62.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const filterableColumnsLookup = (0, $jQEEt.gridFilterableColumnLookupSelector)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && filterableColumnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                visibleRowsLookup: $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.quickFilterValues && filterModel.quickFilterExcludeHiddenColumns) // re-apply filters because the quick filter results may have changed
        apiRef.current.unstable_applyFilters();
    });
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ (0, $eEJPp.default)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};

});
parcelRegister("kmoo4", function(module, exports) {

$parcel$export(module.exports, "useGridRegisterStrategyProcessor", () => $ed28c789ae16a4b3$export$102a3f5a042c47c4);

var $acw62 = parcelRequire("acw62");

var $bc8LN = parcelRequire("bc8LN");
const $ed28c789ae16a4b3$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $acw62.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};

});


parcelRegister("1lT2X", function(module, exports) {

$parcel$export(module.exports, "focusStateInitializer", () => $0fc273bc52ff1742$export$bfde38b067fac467);
$parcel$export(module.exports, "useGridFocus", () => $0fc273bc52ff1742$export$8b69791fef06a777);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $eFF1m = parcelRequire("eFF1m");

var $dMF9H = parcelRequire("dMF9H");

var $drCmI = parcelRequire("drCmI");

var $jQEEt = parcelRequire("jQEEt");

var $aJApm = parcelRequire("aJApm");

var $lR3Vo = parcelRequire("lR3Vo");

var $goCyd = parcelRequire("goCyd");
const $0fc273bc52ff1742$export$bfde38b067fac467 = (state)=>(0, $8nd05.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $0fc273bc52ff1742$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFocus');
    const lastClickedCell = $acw62.useRef(null);
    const publishCellFocusOut = $acw62.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $acw62.useCallback((id, field)=>{
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if ((focusedCell == null ? void 0 : focusedCell.id) === id && (focusedCell == null ? void 0 : focusedCell.field) === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $acw62.useCallback((field, depth, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $acw62.useCallback(()=>(0, $drCmI.unstable_gridFocusColumnGroupHeaderSelector)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $acw62.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $lR3Vo.clamp)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $lR3Vo.clamp)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $acw62.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $dMF9H.isNavigationKey)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $acw62.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $acw62.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $drCmI.unstable_gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $acw62.useCallback((_, event)=>{
        var _event$relatedTarget;
        if ((_event$relatedTarget = event.relatedTarget) != null && _event$relatedTarget.className.includes((0, $5H1vo.gridClasses).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $acw62.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $acw62.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if ((cellParams == null ? void 0 : cellParams.id) === focusedCell.id && (cellParams == null ? void 0 : cellParams.field) === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement != null && cellElement.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            apiRef.current.forceUpdate();
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $acw62.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if ((cell == null ? void 0 : cell.id) !== params.id || (cell == null ? void 0 : cell.field) !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $acw62.useCallback(()=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        // If the focused cell is in a row which does not exist anymore, then remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        apiRef
    ]);
    const handlePaginationModelChange = (0, $13KXh.default)(()=>{
        const currentFocusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage) return;
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $ivFej.useGridApiMethod)(apiRef, focusApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, focusPrivateApi, 'private');
    $acw62.useEffect(()=>{
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        handleDocumentClick
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', handleRowSet);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};

});
parcelRegister("aJApm", function(module, exports) {

$parcel$export(module.exports, "getVisibleRows", () => $7d0a5941a1add073$export$79b9fa322a34430b);
$parcel$export(module.exports, "useGridVisibleRows", () => $7d0a5941a1add073$export$d1914c80ff11e37a);

var $acw62 = parcelRequire("acw62");

var $gPWuj = parcelRequire("gPWuj");

var $k278Q = parcelRequire("k278Q");
const $7d0a5941a1add073$export$79b9fa322a34430b = (apiRef, props)=>{
    let rows;
    let range;
    if (props.pagination && props.paginationMode === 'client') {
        range = (0, $gPWuj.gridPaginationRowRangeSelector)(apiRef);
        rows = (0, $gPWuj.gridPaginatedVisibleSortedGridRowEntriesSelector)(apiRef);
    } else {
        rows = (0, $k278Q.gridExpandedSortedRowEntriesSelector)(apiRef);
        if (rows.length === 0) range = null;
        else range = {
            firstRowIndex: 0,
            lastRowIndex: rows.length - 1
        };
    }
    return {
        rows: rows,
        range: range
    };
};
const $7d0a5941a1add073$export$d1914c80ff11e37a = (apiRef, props)=>{
    const response = $7d0a5941a1add073$export$79b9fa322a34430b(apiRef, props);
    return $acw62.useMemo(()=>({
            rows: response.rows,
            range: response.range
        }), [
        response.rows,
        response.range
    ]);
};

});


parcelRegister("12xQD", function(module, exports) {

$parcel$export(module.exports, "useGridKeyboardNavigation", () => $0c203bd54aeaf237$export$142b8bb1fe6da473);

var $acw62 = parcelRequire("acw62");

var $14H9o = parcelRequire("14H9o");

var $jQEEt = parcelRequire("jQEEt");

var $luu6e = parcelRequire("luu6e");

var $eFF1m = parcelRequire("eFF1m");

var $k278Q = parcelRequire("k278Q");

var $aJApm = parcelRequire("aJApm");

var $5bG6h = parcelRequire("5bG6h");

var $5H1vo = parcelRequire("5H1vo");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $7Z41R = parcelRequire("7Z41R");

var $goCyd = parcelRequire("goCyd");

var $drCmI = parcelRequire("drCmI");

var $hMyIf = parcelRequire("hMyIf");

var $6forD = parcelRequire("6forD");

var $2kdmP = parcelRequire("2kdmP");

var $KtEo5 = parcelRequire("KtEo5");
function $0c203bd54aeaf237$var$enrichPageRowsWithPinnedRows(apiRef, rows) {
    const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef) || {};
    return [
        ...pinnedRows.top || [],
        ...rows,
        ...pinnedRows.bottom || []
    ];
}
const $0c203bd54aeaf237$var$getLeftColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === 'rtl') {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (direction === 'ltr') {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $0c203bd54aeaf237$var$getRightColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, direction: direction })=>{
    if (direction === 'rtl') {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (direction === 'ltr') {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
const $0c203bd54aeaf237$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridKeyboardNavigation');
    const initialCurrentPageRows = (0, $aJApm.useGridVisibleRows)(apiRef, props).rows;
    const theme = (0, $14H9o.default)();
    const currentPageRows = $acw62.useMemo(()=>$0c203bd54aeaf237$var$enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [
        apiRef,
        initialCurrentPageRows
    ]);
    const headerFilteringEnabled = // @ts-expect-error // TODO move relevant code to the `DataGridPro`
    props.signature !== 'DataGrid' && props.unstable_headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {number} rowIndex index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $acw62.useCallback((colIndex, rowId, closestColumnToUse = 'left')=>{
        const visibleSortedRows = (0, $k278Q.gridExpandedSortedRowEntriesSelector)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === rowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setCellFocus(rowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $acw62.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $acw62.useCallback((rowIndex)=>{
        var _currentPageRows$rowI;
        return (_currentPageRows$rowI = currentPageRows[rowIndex]) == null ? void 0 : _currentPageRows$rowI.id;
    }, [
        currentPageRows
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (firstRowIndexInPage !== null) {
                    if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                    else goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                }
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = $0c203bd54aeaf237$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $0c203bd54aeaf237$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        theme.direction,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $acw62.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const isEditing = (0, $6forD.unstable_gridHeaderFilteringEditFieldSelector)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $6forD.unstable_gridHeaderFilteringMenuSelector)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $dMF9H.isNavigationKey)(event.key)) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = $0c203bd54aeaf237$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $0c203bd54aeaf237$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: theme.direction
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeaderFilter,
        theme.direction,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const focusedColumnGroup = (0, $drCmI.unstable_gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows.length,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $jkRzp.GridCellModes).Edit || !(0, $dMF9H.isNavigationKey)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const dimensions = apiRef.current.getRootDimensions();
        if (currentPageRows.length === 0 || !dimensions) return;
        const direction = theme.direction;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = $0c203bd54aeaf237$var$getRightColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = $0c203bd54aeaf237$var$getLeftColumnIndex({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        direction: direction
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === (0, $7Z41R.GRID_DETAIL_PANEL_TOGGLE_FIELD)) break;
                    const colDef = params.colDef;
                    if (colDef && colDef.type === 'treeDataGroup') break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        theme.direction,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $acw62.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', handleCellKeyDown);
};

});
parcelRegister("7Z41R", function(module, exports) {

$parcel$export(module.exports, "GRID_DETAIL_PANEL_TOGGLE_FIELD", () => $5d015af997432f16$export$6e5a576305a34719);
// Can't import from pro package - hence duplication
const $5d015af997432f16$export$6e5a576305a34719 = '__detail_panel_toggle__';

});

parcelRegister("6forD", function(module, exports) {

$parcel$export(module.exports, "unstable_gridHeaderFilteringEditFieldSelector", () => $48c71b00043b47b4$export$84089ff684fa560a);
$parcel$export(module.exports, "unstable_gridHeaderFilteringMenuSelector", () => $48c71b00043b47b4$export$1080dcf0065c0872);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $cgQ4y = parcelRequire("cgQ4y");
const $48c71b00043b47b4$export$baf6aa65d419d3eb = (state)=>state.headerFiltering;
const $48c71b00043b47b4$export$84089ff684fa560a = (0, $cgQ4y.createSelector)($48c71b00043b47b4$export$baf6aa65d419d3eb, (headerFilteringState)=>headerFilteringState.editing);
const $48c71b00043b47b4$export$1080dcf0065c0872 = (0, $cgQ4y.createSelector)($48c71b00043b47b4$export$baf6aa65d419d3eb, (headerFilteringState)=>headerFilteringState.menuOpen);

});

parcelRegister("KtEo5", function(module, exports) {

$parcel$export(module.exports, "isOverflown", () => $08bb4bf24f47b880$export$c8be9a8325efa7ee);
$parcel$export(module.exports, "findParentElementFromClassName", () => $08bb4bf24f47b880$export$2a63f1401414fc1a);
$parcel$export(module.exports, "getGridColumnHeaderElement", () => $08bb4bf24f47b880$export$94318ffb75913a0b);
$parcel$export(module.exports, "getGridRowElement", () => $08bb4bf24f47b880$export$9bc8bb868a922a5f);
$parcel$export(module.exports, "getGridCellElement", () => $08bb4bf24f47b880$export$44827662627a59);
$parcel$export(module.exports, "isEventTargetInPortal", () => $08bb4bf24f47b880$export$8ce496ad3bfbe3a6);

var $5H1vo = parcelRequire("5H1vo");
function $08bb4bf24f47b880$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $08bb4bf24f47b880$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $08bb4bf24f47b880$export$c7408c516f335586(cell) {
    if (!cell) return null;
    return $08bb4bf24f47b880$export$2a63f1401414fc1a(cell, (0, $5H1vo.gridClasses).row);
}
function $08bb4bf24f47b880$export$50f9854aa9e6e900(elem) {
    return elem != null && elem.classList.contains((0, $5H1vo.gridClasses).cell);
}
function $08bb4bf24f47b880$export$a50bbedaf000c26f(elem) {
    return elem != null && elem.classList.contains((0, $5H1vo.gridClasses).columnHeader);
}
function $08bb4bf24f47b880$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $08bb4bf24f47b880$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$getGridRowElementSelector(id) {
    return `.${(0, $5H1vo.gridClasses).row}[data-id="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(String(id))}"]`;
}
function $08bb4bf24f47b880$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($08bb4bf24f47b880$var$getGridRowElementSelector(id));
}
function $08bb4bf24f47b880$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $08bb4bf24f47b880$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $5H1vo.gridClasses).cell}[data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $08bb4bf24f47b880$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $08bb4bf24f47b880$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $08bb4bf24f47b880$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}

});


parcelRegister("3m1KX", function(module, exports) {

$parcel$export(module.exports, "paginationStateInitializer", () => $2714c9ed9cdf2996$export$951a05deca7e869f);
$parcel$export(module.exports, "useGridPagination", () => $2714c9ed9cdf2996$export$f1c8f1c02d202e22);

var $8nd05 = parcelRequire("8nd05");

var $baj2X = parcelRequire("baj2X");

var $87jE6 = parcelRequire("87jE6");

var $hVzRt = parcelRequire("hVzRt");
const $2714c9ed9cdf2996$export$951a05deca7e869f = (state, props)=>{
    var _props$paginationMode, _props$initialState, _ref, _props$rowCount, _props$initialState2;
    const paginationModel = (0, $8nd05.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), (_props$paginationMode = props.paginationModel) != null ? _props$paginationMode : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.pagination) == null ? void 0 : _props$initialState.paginationModel);
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, props.signature);
    const rowCount = (_ref = (_props$rowCount = props.rowCount) != null ? _props$rowCount : (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.pagination) == null ? void 0 : _props$initialState2.rowCount) != null ? _ref : 0;
    return (0, $8nd05.default)({}, state, {
        pagination: {
            paginationModel: paginationModel,
            rowCount: rowCount
        }
    });
};
const $2714c9ed9cdf2996$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    (0, $87jE6.useGridPaginationModel)(apiRef, props);
    (0, $hVzRt.useGridRowCount)(apiRef, props);
};

});
parcelRegister("hVzRt", function(module, exports) {

$parcel$export(module.exports, "useGridRowCount", () => $d0d393dcade2390b$export$229d07cf557fa73f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $k278Q = parcelRequire("k278Q");

var $ivFej = parcelRequire("ivFej");
var $luu6e = parcelRequire("luu6e");
var $5sOMZ = parcelRequire("5sOMZ");

var $2kdmP = parcelRequire("2kdmP");

var $gPWuj = parcelRequire("gPWuj");

const $d0d393dcade2390b$export$229d07cf557fa73f = (apiRef, props)=>{
    var _props$initialState2;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridRowCount');
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilteredTopLevelRowCountSelector));
    const rowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationRowCountSelector));
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: (0, $gPWuj.gridPaginationRowCountSelector),
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $acw62.useCallback((newRowCount)=>{
        if (rowCount === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger,
        rowCount
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState;
        const exportedRowCount = (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        ((_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.pagination) == null ? void 0 : _props$initialState.rowCount) != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            pagination: (0, $8nd05.default)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.pagination) == null ? void 0 : _props$initialState2.rowCount
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        var _context$stateToResto;
        const restoredRowCount = (_context$stateToResto = context.stateToRestore.pagination) != null && _context$stateToResto.rowCount ? context.stateToRestore.pagination.rowCount : (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                pagination: (0, $8nd05.default)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{}, [
        props.rowCount,
        props.paginationMode
    ]);
    $acw62.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount(visibleTopLevelRowCount);
        else if (props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        visibleTopLevelRowCount,
        props.paginationMode,
        props.rowCount
    ]);
};

});


parcelRegister("4epuR", function(module, exports) {

$parcel$export(module.exports, "preferencePanelStateInitializer", () => $314c3f5b8282a42e$export$a9f45f767b8ade48);
$parcel$export(module.exports, "useGridPreferencesPanel", () => $314c3f5b8282a42e$export$343dd9a605dbb75b);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $2kdmP = parcelRequire("2kdmP");

var $6X2Yd = parcelRequire("6X2Yd");
const $314c3f5b8282a42e$export$a9f45f767b8ade48 = (state, props)=>{
    var _props$initialState$p, _props$initialState;
    return (0, $8nd05.default)({}, state, {
        preferencePanel: (_props$initialState$p = (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.preferencePanel) != null ? _props$initialState$p : {
            open: false
        }
    });
};
const $314c3f5b8282a42e$export$343dd9a605dbb75b = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPreferencesPanel');
    const hideTimeout = $acw62.useRef();
    const immediateTimeout = $acw62.useRef();
    /**
   * API METHODS
   */ const hidePreferences = $acw62.useCallback(()=>{
        logger.debug('Hiding Preferences Panel');
        const preferencePanelState = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef.current.state);
        if (preferencePanelState.openedPanelValue) apiRef.current.publishEvent('preferencePanelClose', {
            openedPanelValue: preferencePanelState.openedPanelValue
        });
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    // This is to prevent the preferences from closing when you open a select box or another panel,
    // The issue is in MUI core V4 => Fixed in V5
    const doNotHidePanel = $acw62.useCallback(()=>{
        immediateTimeout.current = setTimeout(()=>clearTimeout(hideTimeout.current), 0);
    }, []);
    // This is a hack for the issue with Core V4, by delaying hiding the panel on the clickAwayListener,
    // we can cancel the action if the trigger element still need the panel...
    const hidePreferencesDelayed = $acw62.useCallback(()=>{
        hideTimeout.current = setTimeout(hidePreferences, 100);
    }, [
        hidePreferences
    ]);
    const showPreferences = $acw62.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        doNotHidePanel();
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                preferencePanel: (0, $8nd05.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        doNotHidePanel,
        apiRef
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferencesDelayed
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState2;
        const preferencePanelToExport = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef.current.state);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        ((_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.preferencePanel) != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        (_props$initialState3 = props.initialState) == null ? void 0 : _props$initialState3.preferencePanel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(hideTimeout.current);
            clearTimeout(immediateTimeout.current);
        };
    }, []);
};

});
parcelRegister("6X2Yd", function(module, exports) {

$parcel$export(module.exports, "gridPreferencePanelStateSelector", () => $50fa8e974bf84473$export$37e5474577e02878);
const $50fa8e974bf84473$export$37e5474577e02878 = (state)=>state.preferencePanel;

});


parcelRegister("fTRdy", function(module, exports) {

$parcel$export(module.exports, "editingStateInitializer", () => $b93545fe9a3b3245$export$1094a2c822d71ffd);
$parcel$export(module.exports, "useGridEditing", () => $b93545fe9a3b3245$export$3a0db16b152b4c54);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $3uAik = parcelRequire("3uAik");

var $jkRzp = parcelRequire("jkRzp");

var $h652i = parcelRequire("h652i");

var $5Rfo7 = parcelRequire("5Rfo7");

var $7sDf4 = parcelRequire("7sDf4");
const $b93545fe9a3b3245$export$1094a2c822d71ffd = (state)=>(0, $8nd05.default)({}, state, {
        editRows: {}
    });
const $b93545fe9a3b3245$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $3uAik.useGridCellEditing)(apiRef, props);
    (0, $h652i.useGridRowEditing)(apiRef, props);
    const debounceMap = $acw62.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $acw62.useCallback((params)=>{
        if ((0, $7sDf4.isAutoGeneratedRow)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $acw62.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $acw62.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $jkRzp.GridEditModes).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $jkRzp.GridCellModes).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $acw62.useCallback((id, field)=>{
        return props.editMode === (0, $jkRzp.GridEditModes).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $acw62.useCallback((id, field)=>{
        var _editingState$id$fiel, _editingState$id;
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        return (_editingState$id$fiel = (_editingState$id = editingState[id]) == null ? void 0 : _editingState$id[field]) != null ? _editingState$id$fiel : null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedPrivateApi, 'private');
};

});
parcelRegister("3uAik", function(module, exports) {

$parcel$export(module.exports, "useGridCellEditing", () => $28b053c97cee4bd6$export$2c9a271ac5d3f446);

var $1En50 = parcelRequire("1En50");

var $4ZreY = parcelRequire("4ZreY");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");

var $eFF1m = parcelRequire("eFF1m");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $ehSzT = parcelRequire("ehSzT");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $iNfie = parcelRequire("iNfie");
const $28b053c97cee4bd6$var$_excluded = [
    "id",
    "field"
], $28b053c97cee4bd6$var$_excluded2 = [
    "id",
    "field"
];
const $28b053c97cee4bd6$var$missingOnProcessRowUpdateErrorWarning = (0, $ehSzT.buildWarning)([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const $28b053c97cee4bd6$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $acw62.useState({});
    const cellModesModelRef = $acw62.useRef(cellModesModel);
    const prevCellModesModel = $acw62.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $jkRzp.GridEditModes).Cell) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $jkRzp.GridCellModes).Edit) return;
        const newParams = (0, $8nd05.default)({}, params, {
            reason: (0, $iNfie.GridCellEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridCellModes).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $jkRzp.GridCellModes).View) return;
        const newParams = (0, $8nd05.default)({}, params, {
            reason: (0, $iNfie.GridCellEditStopReasons).cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridCellModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $iNfie.GridCellEditStopReasons).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $iNfie.GridCellEditStopReasons).enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? (0, $iNfie.GridCellEditStopReasons).shiftTabKeyDown : (0, $iNfie.GridCellEditStopReasons).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $8nd05.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = (0, $iNfie.GridCellEditStartReasons).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === 'v') reason = (0, $iNfie.GridCellEditStartReasons).pasteKeyDown;
            else if (event.key === 'Enter') reason = (0, $iNfie.GridCellEditStartReasons).enterKeyDown;
            else if (event.key === 'Delete' || event.key === 'Backspace') // Delete on Windows, Backspace on macOS
            reason = (0, $iNfie.GridCellEditStartReasons).deleteKeyDown;
            if (reason) {
                const newParams = (0, $8nd05.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $iNfie.GridCellEditStartReasons).printableKeyDown || reason === (0, $iNfie.GridCellEditStartReasons).deleteKeyDown || reason === (0, $iNfie.GridCellEditStartReasons).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $iNfie.GridCellEditStopReasons).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $iNfie.GridCellEditStopReasons).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $iNfie.GridCellEditStopReasons).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellEditStop', props.onCellEditStop);
    const getCellMode = $acw62.useCallback((id, field)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $jkRzp.GridCellModes).Edit : (0, $jkRzp.GridCellModes).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $13KXh.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {});
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $acw62.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $8nd05.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $8nd05.default)({}, newModel[id], {
            [field]: (0, $8nd05.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $1En50.default)(_newModel$id, [
                field
            ].map((0, $4ZreY.default))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $8nd05.default)({}, newEditingState[id], {
                [field]: (0, $8nd05.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $1En50.default)(params, $28b053c97cee4bd6$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).View);
        updateFieldInCellModesModel(id, field, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridCellModes).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $13KXh.default)((params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        let newValue = apiRef.current.getCellValue(id, field);
        if (deleteValue || initialValue) newValue = deleteValue ? '' : initialValue;
        const newProps = {
            value: newValue,
            error: false,
            isProcessingProps: false
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
    });
    const stopCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $1En50.default)(params, $28b053c97cee4bd6$var$_excluded2);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        updateFieldInCellModesModel(id, field, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridCellModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $13KXh.default)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $jkRzp.GridCellModes).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $jkRzp.GridCellModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $jkRzp.GridCellModes).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $jkRzp.GridCellModes).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else $28b053c97cee4bd6$var$missingOnProcessRowUpdateErrorWarning();
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $acw62.useCallback(async (params)=>{
        var _editingState$id;
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $jkRzp.GridCellModes).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, $8nd05.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $8nd05.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $jkRzp.GridCellModes).View) return false;
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        newProps = (0, $8nd05.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        return !((_editingState$id = editingState[id]) != null && (_editingState$id = _editingState$id[field]) != null && _editingState$id.error);
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $acw62.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter({
            value: value,
            row: row
        }) : (0, $8nd05.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $eEJPp.default)(()=>{
        const idToIdLookup = (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $lR3Vo.deepClone)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                var _copyOfPrevCellModes$, _idToIdLookup$id;
                const prevMode = ((_copyOfPrevCellModes$ = copyOfPrevCellModes[id]) == null || (_copyOfPrevCellModes$ = _copyOfPrevCellModes$[field]) == null ? void 0 : _copyOfPrevCellModes$.mode) || (0, $jkRzp.GridCellModes).View;
                const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
                if (params.mode === (0, $jkRzp.GridCellModes).Edit && prevMode === (0, $jkRzp.GridCellModes).View) updateStateToStartCellEditMode((0, $8nd05.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $jkRzp.GridCellModes).View && prevMode === (0, $jkRzp.GridCellModes).Edit) updateStateToStopCellEditMode((0, $8nd05.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};

});
parcelRegister("5Rfo7", function(module, exports) {

$parcel$export(module.exports, "gridEditRowsStateSelector", () => $443dd6b911893b50$export$91ed78b95c9e6636);
// TODO v6: rename to gridEditingStateSelector
const $443dd6b911893b50$export$91ed78b95c9e6636 = (state)=>state.editRows;

});


parcelRegister("h652i", function(module, exports) {

$parcel$export(module.exports, "useGridRowEditing", () => $c726e745e154c244$export$a43bf4f64ed7f919);

var $4ZreY = parcelRequire("4ZreY");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");

var $eFF1m = parcelRequire("eFF1m");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $jQEEt = parcelRequire("jQEEt");

var $ehSzT = parcelRequire("ehSzT");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $jfE7J = parcelRequire("jfE7J");

var $8z2XQ = parcelRequire("8z2XQ");
const $c726e745e154c244$var$_excluded = [
    "id"
], $c726e745e154c244$var$_excluded2 = [
    "id"
];
const $c726e745e154c244$var$missingOnProcessRowUpdateErrorWarning = (0, $ehSzT.buildWarning)([
    'MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.',
    'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
    'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'
], 'error');
const $c726e745e154c244$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $acw62.useState({});
    const rowModesModelRef = $acw62.useRef(rowModesModel);
    const prevRowModesModel = $acw62.useRef({});
    const focusTimeout = $acw62.useRef(null);
    const nextFocusedCell = $acw62.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $jkRzp.GridEditModes).Row) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $8nd05.default)({}, rowParams, {
            field: params.field,
            reason: (0, $jfE7J.GridRowEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $acw62.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            var _nextFocusedCell$curr;
            focusTimeout.current = null;
            if (((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $jkRzp.GridRowModes).View) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $8nd05.default)({}, rowParams, {
                    field: params.field,
                    reason: (0, $jfE7J.GridRowEditStopReasons).rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $jkRzp.GridRowModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is deprecated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $jfE7J.GridRowEditStopReasons).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $jfE7J.GridRowEditStopReasons).enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $jfE7J.GridRowEditStopReasons).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $jfE7J.GridRowEditStopReasons).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                const newParams = (0, $8nd05.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = (0, $jfE7J.GridRowEditStartReasons).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === 'v') reason = (0, $jfE7J.GridRowEditStartReasons).printableKeyDown;
            else if (event.key === 'Enter') reason = (0, $jfE7J.GridRowEditStartReasons).enterKeyDown;
            else if (event.key === 'Delete' || event.key === 'Backspace') // Delete on Windows, Backspace on macOS
            reason = (0, $jfE7J.GridRowEditStartReasons).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $8nd05.default)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleRowEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $jfE7J.GridRowEditStartReasons).printableKeyDown || reason === (0, $jfE7J.GridRowEditStartReasons).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $acw62.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $jfE7J.GridRowEditStopReasons).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $jfE7J.GridRowEditStopReasons).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $jfE7J.GridRowEditStopReasons).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $acw62.useCallback((id)=>{
        if (props.editMode === (0, $jkRzp.GridEditModes).Cell) return (0, $jkRzp.GridRowModes).View;
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
        return isEditing ? (0, $jkRzp.GridRowModes).Edit : (0, $jkRzp.GridRowModes).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $13KXh.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {});
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $acw62.useCallback((id, newProps)=>{
        const newModel = (0, $8nd05.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $8nd05.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $acw62.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $8nd05.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $8nd05.default)({}, newEditingState[id], {
                [field]: (0, $8nd05.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $8nd05.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $1En50.default)(params, $c726e745e154c244$var$_excluded);
        throwIfNotInMode(id, (0, $jkRzp.GridRowModes).View);
        updateRowInRowModesModel(id, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridRowModes).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $13KXh.default)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const columnFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const newProps = columnFields.reduce((acc, field)=>{
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) newValue = deleteValue ? '' : initialValue;
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: false
            };
            return acc;
        }, {});
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
    });
    const stopRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $1En50.default)(params, $c726e745e154c244$var$_excluded2);
        throwIfNotInMode(id, (0, $jkRzp.GridRowModes).Edit);
        updateRowInRowModesModel(id, (0, $8nd05.default)({
            mode: (0, $jkRzp.GridRowModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $13KXh.default)((params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
            return;
        }
        const hasSomeFieldWithError = Object.values(editingState[id]).some((fieldProps)=>fieldProps.error);
        if (hasSomeFieldWithError) {
            prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $jkRzp.GridRowModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevRowModesModel.current[id].mode = (0, $jkRzp.GridRowModes).Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: (0, $jkRzp.GridRowModes).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else $c726e745e154c244$var$missingOnProcessRowUpdateErrorWarning();
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, $8nd05.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $8nd05.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $1En50.default)(_editingState$id, [
                    field
                ].map((0, $4ZreY.default)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                    processedProps = (0, $8nd05.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $8nd05.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $1En50.default)(_editingState$id2, [
                    thisField
                ].map((0, $4ZreY.default)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $8nd05.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $jkRzp.GridRowModes).Edit) {
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $acw62.useCallback((id)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $8nd05.default)({}, row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            if (column.valueSetter) rowUpdate = column.valueSetter({
                value: fieldProps.value,
                row: rowUpdate
            });
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $eEJPp.default)(()=>{
        const idToIdLookup = (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $lR3Vo.deepClone)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(rowModesModel).forEach(([id, params])=>{
            var _copyOfPrevRowModesMo, _idToIdLookup$id;
            const prevMode = ((_copyOfPrevRowModesMo = copyOfPrevRowModesModel[id]) == null ? void 0 : _copyOfPrevRowModesMo.mode) || (0, $jkRzp.GridRowModes).View;
            const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
            if (params.mode === (0, $jkRzp.GridRowModes).Edit && prevMode === (0, $jkRzp.GridRowModes).View) updateStateToStartRowEditMode((0, $8nd05.default)({
                id: originalId
            }, params));
            else if (params.mode === (0, $jkRzp.GridRowModes).View && prevMode === (0, $jkRzp.GridRowModes).Edit) updateStateToStopRowEditMode((0, $8nd05.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};

});
parcelRegister("jfE7J", function(module, exports) {

$parcel$export(module.exports, "GridRowEditStartReasons", () => $e03e8aca644cf2db$export$535533732d8f5c0a);
$parcel$export(module.exports, "GridRowEditStopReasons", () => $e03e8aca644cf2db$export$723957c53726785f);
/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $e03e8aca644cf2db$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($e03e8aca644cf2db$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $e03e8aca644cf2db$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($e03e8aca644cf2db$export$723957c53726785f || {});

});



parcelRegister("2MkZt", function(module, exports) {

$parcel$export(module.exports, "rowsStateInitializer", () => $206058c259ba36a5$export$1a6bb5bb341eadaa);
$parcel$export(module.exports, "useGridRows", () => $206058c259ba36a5$export$dd1a4469bbd9394e);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $goCyd = parcelRequire("goCyd");

var $5oDOG = parcelRequire("5oDOG");

var $eFF1m = parcelRequire("eFF1m");

var $aJApm = parcelRequire("aJApm");

var $iU3u2 = parcelRequire("iU3u2");

var $k278Q = parcelRequire("k278Q");

var $7sDf4 = parcelRequire("7sDf4");

var $1xynw = parcelRequire("1xynw");
const $206058c259ba36a5$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    apiRef.current.caches.rows = (0, $7sDf4.createRowsInternalCache)({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $8nd05.default)({}, state, {
        rows: (0, $7sDf4.getRowsStateFromCache)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $206058c259ba36a5$export$dd1a4469bbd9394e = (apiRef, props)=>{
    var error;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridRows');
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, props);
    const lastUpdateMs = $acw62.useRef(Date.now());
    const timeout = (0, $5oDOG.useTimeout)();
    const getRow = $acw62.useCallback((id)=>{
        const model = (0, $goCyd.gridRowsLookupSelector)(apiRef)[id];
        if (model) return model;
        const node = apiRef.current.getRowNode(id);
        if (node && (0, $7sDf4.isAutoGeneratedRow)(node)) return {
            [(0, $7sDf4.GRID_ID_AUTOGENERATED)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowIdProp = props.getRowId;
    const getRowId = $acw62.useCallback((row)=>{
        if ((0, $7sDf4.GRID_ID_AUTOGENERATED) in row) return row[0, $7sDf4.GRID_ID_AUTOGENERATED];
        if (getRowIdProp) return getRowIdProp(row);
        return row.id;
    }, [
        getRowIdProp
    ]);
    const lookup = $acw62.useMemo(()=>currentPage.rows.reduce((acc, { id: id }, index)=>{
            acc[id] = index;
            return acc;
        }, {}), [
        currentPage.rows
    ]);
    const throttledRowsChange = $acw62.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    rows: (0, $7sDf4.getRowsStateFromCache)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $goCyd.gridRowTreeSelector)(apiRef),
                        previousTreeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
            apiRef.current.forceUpdate();
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $acw62.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, $7sDf4.createRowsInternalCache)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $acw62.useCallback((updates)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && updates.length > 1) throw new Error([
            "MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.",
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        const nonPinnedRowsUpdates = [];
        updates.forEach((update)=>{
            const id = (0, $7sDf4.getRowIdFromRowModel)(update, props.getRowId, 'A row was provided without id when calling updateRows():');
            const rowNode = apiRef.current.getRowNode(id);
            if ((rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') {
                // @ts-ignore because otherwise `release:build` doesn't work
                const pinnedRowsCache = apiRef.current.caches.pinnedRows;
                const prevModel = pinnedRowsCache.idLookup[id];
                if (prevModel) pinnedRowsCache.idLookup[id] = (0, $8nd05.default)({}, prevModel, update);
            } else nonPinnedRowsUpdates.push(update);
        });
        const cache = (0, $7sDf4.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const getRowModels = $acw62.useCallback(()=>{
        const dataRows = (0, $goCyd.gridDataRowIdsSelector)(apiRef);
        const idRowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        return new Map(dataRows.map((id)=>{
            var _idRowsLookup$id;
            return [
                id,
                (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
            ];
        }));
    }, [
        apiRef
    ]);
    const getRowsCount = $acw62.useCallback(()=>(0, $goCyd.gridRowCountSelector)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $acw62.useCallback(()=>(0, $goCyd.gridDataRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $acw62.useCallback((id)=>lookup[id], [
        lookup
    ]);
    const setRowChildrenExpansion = $acw62.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI: No row with id #${id} found`);
        if (currentNode.type !== 'group') throw new Error('MUI: Only group nodes can be expanded or collapsed');
        const newNode = (0, $8nd05.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    tree: (0, $8nd05.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const getRowNode = $acw62.useCallback((id)=>{
        var _ref;
        return (_ref = (0, $goCyd.gridRowTreeSelector)(apiRef)[id]) != null ? _ref : null;
    }, [
        apiRef
    ]);
    const getRowGroupChildren = $acw62.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering })=>{
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $iU3u2.gridSortedRowIdsSelector)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $7sDf4.isAutoGeneratedRow)(tree[id])) children.push(id);
            }
        } else children = (0, $7sDf4.getTreeNodeDescendants)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = $acw62.useCallback((rowId, targetIndex)=>{
        const node = apiRef.current.getRowNode(rowId);
        if (!node) throw new Error(`MUI: No row with id #${rowId} found`);
        if (node.parent !== (0, $7sDf4.GRID_ROOT_GROUP_ID)) throw new Error(`MUI: The row reordering do not support reordering of grouped rows yet`);
        if (node.type !== 'leaf') throw new Error(`MUI: The row reordering do not support reordering of footer or grouping rows`);
        apiRef.current.setState((state)=>{
            const group = (0, $goCyd.gridRowTreeSelector)(state, apiRef.current.instanceId)[0, $7sDf4.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    tree: (0, $8nd05.default)({}, state.rows.tree, {
                        [(0, $7sDf4.GRID_ROOT_GROUP_ID)]: (0, $8nd05.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = $acw62.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && newRows.length > 1) throw new Error([
            "MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.",
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $goCyd.gridRowMaximumTreeDepthSelector)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $8nd05.default)({}, (0, $goCyd.gridRowTreeSelector)(apiRef));
        const dataRowIdToModelLookup = (0, $8nd05.default)({}, (0, $goCyd.gridRowsLookupSelector)(apiRef));
        const dataRowIdToIdLookup = (0, $8nd05.default)({}, (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(apiRef));
        const rootGroup = tree[0, $7sDf4.GRID_ROOT_GROUP_ID];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $7sDf4.getRowIdFromRowModel)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete dataRowIdToIdLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            dataRowIdToIdLookup[rowId] = rowId;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[0, $7sDf4.GRID_ROOT_GROUP_ID] = (0, $8nd05.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId].type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, {
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIdToIdLookup: dataRowIdToIdLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow: getRow,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren
    };
    /**
   * EVENTS
   */ const groupRows = $acw62.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $8nd05.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $goCyd.gridDataRowIdsSelector)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $7sDf4.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows
    ]);
    const handleStrategyActivityChange = $acw62.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy('rowTree') !== (0, $goCyd.gridRowGroupingNameSelector)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $goCyd.gridRowTreeSelector)(state, apiRef.current.instanceId),
                treeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(state, apiRef.current.instanceId),
                dataRowIds: (0, $goCyd.gridDataRowIdsSelector)(state, apiRef.current.instanceId),
                dataRowIdToModelLookup: (0, $goCyd.gridRowsLookupSelector)(state, apiRef.current.instanceId),
                dataRowIdToIdLookup: (0, $goCyd.gridRowsDataRowIdToIdLookupSelector)(state, apiRef.current.instanceId)
            });
            return (0, $8nd05.default)({}, state, {
                rows: (0, $8nd05.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $7sDf4.getTopLevelRowCount)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $ivFej.useGridApiMethod)(apiRef, rowApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowProApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                        rows: (0, $8nd05.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                        rows: (0, $8nd05.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            return;
        }
        logger.debug(`Updating all rows, new length ${props.rows.length}`);
        throttledRowsChange({
            cache: (0, $7sDf4.createRowsInternalCache)({
                rows: props.rows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};

});

parcelRegister("5lqAx", function(module, exports) {

$parcel$export(module.exports, "useGridRowsPreProcessors", () => $3e4389cda192db48$export$cc1daa683bbe5702);

var $8nd05 = parcelRequire("8nd05");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $7sDf4 = parcelRequire("7sDf4");
const $3e4389cda192db48$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $7sDf4.GRID_ROOT_GROUP_ID)]: (0, $8nd05.default)({}, (0, $7sDf4.buildRootGroup)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $42J2j.GRID_DEFAULT_STRATEGY),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $3e4389cda192db48$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $8nd05.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $7sDf4.GRID_ROOT_GROUP_ID),
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $7sDf4.GRID_ROOT_GROUP_ID];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $7sDf4.GRID_ROOT_GROUP_ID] = (0, $8nd05.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $42J2j.GRID_DEFAULT_STRATEGY),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $3e4389cda192db48$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $3e4389cda192db48$var$createFlatRowTree(params.updates.rows);
    return $3e4389cda192db48$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $3e4389cda192db48$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'rowTreeCreation', $3e4389cda192db48$var$flatRowTreeCreationMethod);
};

});

parcelRegister("6p8lp", function(module, exports) {

$parcel$export(module.exports, "MissingRowIdError", () => $4a9b8ce6e6853f0a$export$f6bd549412d13610);
$parcel$export(module.exports, "useGridParamsApi", () => $4a9b8ce6e6853f0a$export$d5da41ef394db9ef);

var $acw62 = parcelRequire("acw62");

var $KtEo5 = parcelRequire("KtEo5");

var $7sDf4 = parcelRequire("7sDf4");

var $ivFej = parcelRequire("ivFej");

var $drCmI = parcelRequire("drCmI");
class $4a9b8ce6e6853f0a$export$f6bd549412d13610 extends Error {
}
function $4a9b8ce6e6853f0a$export$d5da41ef394db9ef(apiRef, props) {
    const { getRowId: getRowId } = props;
    const getColumnHeaderParams = $acw62.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $acw62.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getBaseCellParams = $acw62.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            value: row[field],
            colDef: apiRef.current.getColumn(field),
            cellMode: apiRef.current.getCellMode(id, field),
            api: apiRef.current,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $acw62.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const value = apiRef.current.getCellValue(id, field);
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: apiRef.current.getCellMode(id, field),
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            value: value,
            formattedValue: value,
            isEditable: false
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter({
            id: id,
            field: params.field,
            value: params.value,
            api: apiRef.current
        });
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellValue = $acw62.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        if (!colDef || !colDef.valueGetter) {
            const rowModel = apiRef.current.getRow(id);
            if (!rowModel) throw new $4a9b8ce6e6853f0a$export$f6bd549412d13610(`No row with id #${id} found`);
            return rowModel[field];
        }
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        apiRef,
        getBaseCellParams
    ]);
    const getRowValue = $acw62.useCallback((row, colDef)=>{
        var _getRowId;
        const id = (0, $7sDf4.GRID_ID_AUTOGENERATED) in row ? row[0, $7sDf4.GRID_ID_AUTOGENERATED] : (_getRowId = getRowId == null ? void 0 : getRowId(row)) != null ? _getRowId : row.id;
        const field = colDef.field;
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        getBaseCellParams,
        getRowId
    ]);
    const getRowFormattedValue = $acw62.useCallback((row, colDef)=>{
        var _ref;
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        const id = (_ref = getRowId ? getRowId(row) : row.id) != null ? _ref : row[0, $7sDf4.GRID_ID_AUTOGENERATED];
        const field = colDef.field;
        return colDef.valueFormatter({
            id: id,
            field: field,
            value: value,
            api: apiRef.current
        });
    }, [
        apiRef,
        getRowId,
        getRowValue
    ]);
    const getColumnHeaderElement = $acw62.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridColumnHeaderElement)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $acw62.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridRowElement)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $acw62.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridCellElement)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paramsApi, 'public');
}

});

parcelRegister("cURqP", function(module, exports) {

$parcel$export(module.exports, "rowSelectionStateInitializer", () => $9674296b6d32bca5$export$73be1d69367eeb5b);
$parcel$export(module.exports, "useGridRowSelection", () => $9674296b6d32bca5$export$3e2b6b991d9d83f0);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $gPWuj = parcelRequire("gPWuj");

var $drCmI = parcelRequire("drCmI");

var $k278Q = parcelRequire("k278Q");

var $8z2XQ = parcelRequire("8z2XQ");
var $5bG6h = parcelRequire("5bG6h");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $aJApm = parcelRequire("aJApm");

var $7Z41R = parcelRequire("7Z41R");

var $5H1vo = parcelRequire("5H1vo");

var $KtEo5 = parcelRequire("KtEo5");
const $9674296b6d32bca5$var$getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const $9674296b6d32bca5$export$73be1d69367eeb5b = (state, props)=>{
    var _getSelectionModelPro;
    return (0, $8nd05.default)({}, state, {
        rowSelection: props.rowSelection ? (_getSelectionModelPro = $9674296b6d32bca5$var$getSelectionModelPropValue(props.rowSelectionModel)) != null ? _getSelectionModelPro : [] : []
    });
};
const $9674296b6d32bca5$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = (callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        };
    const propRowSelectionModel = $acw62.useMemo(()=>{
        return $9674296b6d32bca5$var$getSelectionModelPropValue(props.rowSelectionModel, (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    const lastRowToggled = $acw62.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $av74L.gridRowSelectionStateSelector),
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableMultipleRowSelection: disableMultipleRowSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = !disableMultipleRowSelection || checkboxSelection;
    const visibleRows = (0, $aJApm.useGridVisibleRows)(apiRef, props);
    const expandMouseRowRangeSelection = $acw62.useCallback((id)=>{
        var _lastRowToggled$curre;
        let endId = id;
        const startId = (_lastRowToggled$curre = lastRowToggled.current) != null ? _lastRowToggled$curre : id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /**
   * API METHODS
   */ const setRowSelectionModel = $acw62.useCallback((model)=>{
        if (props.signature === (0, $eFF1m.GridSignature).DataGrid && !props.checkboxSelection && Array.isArray(model) && model.length > 1) throw new Error([
            'MUI: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                    rowSelection: props.rowSelection ? model : []
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        props.checkboxSelection
    ]);
    const isRowSelected = $acw62.useCallback((id)=>(0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = $acw62.useCallback((id)=>{
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = apiRef.current.getRowNode(id);
        if ((rowNode == null ? void 0 : rowNode.type) === 'footer' || (rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        propIsRowSelectable
    ]);
    const getSelectedRows = $acw62.useCallback(()=>(0, $av74L.selectedGridRowsSelector)(apiRef), [
        apiRef
    ]);
    const selectRow = $acw62.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            apiRef.current.setRowSelectionModel(isSelected ? [
                id
            ] : []);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
            const newSelection = selection.filter((el)=>el !== id);
            if (isSelected) newSelection.push(id);
            const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRows = $acw62.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) newSelection = isSelected ? selectableIds : [];
        else {
            // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
            const selectionLookup = (0, $8nd05.default)({}, (0, $av74L.selectedIdsLookupSelector)(apiRef));
            selectableIds.forEach((id)=>{
                if (isSelected) selectionLookup[id] = id;
                else delete selectionLookup[id];
            });
            newSelection = Object.values(selectionLookup);
        }
        const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelection);
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRowRange = $acw62.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange
    };
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPrivateApi, props.signature === (0, $eFF1m.GridSignature).DataGrid ? 'private' : 'public');
    /**
   * EVENTS
   */ const removeOutdatedSelection = $acw62.useCallback(()=>{
        if (props.keepNonExistentRowsSelected) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, $8nd05.default)({}, (0, $av74L.selectedIdsLookupSelector)(apiRef));
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (!rowsLookup[id]) {
                delete selectionLookup[id];
                hasChanged = true;
            }
        });
        if (hasChanged) apiRef.current.setRowSelectionModel(Object.values(selectionLookup));
    }, [
        apiRef,
        props.keepNonExistentRowsSelected
    ]);
    const handleSingleRowSelection = $acw62.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $dMF9H.isKeyboardEvent)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $acw62.useCallback((params, event)=>{
        var _closest;
        if (disableRowSelectionOnClick) return;
        const field = (_closest = event.target.closest(`.${(0, $5H1vo.gridClasses).cell}`)) == null ? void 0 : _closest.getAttribute('data-field');
        if (field === (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $7Z41R.GRID_DETAIL_PANEL_TOGGLE_FIELD)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if ((column == null ? void 0 : column.type) === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        const rowNode = apiRef.current.getRowNode(params.id);
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && (canHaveMultipleSelection || checkboxSelection)) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        checkboxSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $acw62.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) {
            var _window$getSelection;
            (_window$getSelection = window.getSelection()) == null || _window$getSelection.removeAllRanges();
        }
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $acw62.useCallback((params, event)=>{
        if (event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value);
    }, [
        apiRef,
        expandMouseRowRangeSelection
    ]);
    const handleHeaderSelectionCheckboxChange = $acw62.useCallback((params)=>{
        const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
        const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? (0, $gPWuj.gridPaginatedVisibleSortedGridRowIdsSelector)(apiRef) : (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value, (filterModel == null ? void 0 : filterModel.items.length) > 0);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $jkRzp.GridCellModes).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        if ((0, $dMF9H.isNavigationKey)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (event.key === 'a' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        visibleRows.rows,
        canHaveMultipleSelection
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(removeOutdatedSelection));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (propRowSelectionModel !== undefined) apiRef.current.setRowSelectionModel(propRowSelectionModel);
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        if (!props.rowSelection) apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        props.rowSelection
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $acw62.useEffect(()=>{
        if (isStateControlled || !props.rowSelection) return;
        // props.isRowSelectable changed
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setRowSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel([]);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
};

});

parcelRegister("5WmMt", function(module, exports) {

$parcel$export(module.exports, "useGridRowSelectionPreProcessors", () => $45340a55c38c89d7$export$fa1d7b0897c018ea);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");

var $2kdmP = parcelRequire("2kdmP");

var $5H1vo = parcelRequire("5H1vo");

var $5bG6h = parcelRequire("5bG6h");
const $45340a55c38c89d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $acw62.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
    }, [
        classes
    ]);
};
const $45340a55c38c89d7$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $45340a55c38c89d7$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $acw62.useCallback((columnsState)=>{
        const selectionColumn = (0, $8nd05.default)({}, (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const haveSelectionColumn = columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] != null;
        if (shouldHaveSelectionColumn && !haveSelectionColumn) {
            columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.orderedFields = [
                (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
            delete columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD));
        } else if (shouldHaveSelectionColumn && haveSelectionColumn) columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD] = (0, $8nd05.default)({}, selectionColumn, columnsState.lookup[0, $5bG6h.GRID_CHECKBOX_SELECTION_FIELD]);
        return columnsState;
    }, [
        apiRef,
        classes,
        props.checkboxSelection
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'hydrateColumns', updateSelectionColumn);
};

});

parcelRegister("jOu9i", function(module, exports) {

$parcel$export(module.exports, "sortingStateInitializer", () => $e6ca12cabeac117a$export$996e35c2eef351ae);
$parcel$export(module.exports, "useGridSorting", () => $e6ca12cabeac117a$export$951287757eb5d93c);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $dMF9H = parcelRequire("dMF9H");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $iU3u2 = parcelRequire("iU3u2");

var $7sDf4 = parcelRequire("7sDf4");
var $goCyd = parcelRequire("goCyd");

var $bc8LN = parcelRequire("bc8LN");

var $42J2j = parcelRequire("42J2j");
var $kmoo4 = parcelRequire("kmoo4");

var $h8fXG = parcelRequire("h8fXG");

var $2kdmP = parcelRequire("2kdmP");

var $7sDf4 = parcelRequire("7sDf4");
const $e6ca12cabeac117a$export$996e35c2eef351ae = (state, props)=>{
    var _ref, _props$sortModel, _props$initialState;
    const sortModel = (_ref = (_props$sortModel = props.sortModel) != null ? _props$sortModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.sorting) == null ? void 0 : _props$initialState.sortModel) != null ? _ref : [];
    return (0, $8nd05.default)({}, state, {
        sorting: {
            sortModel: (0, $h8fXG.sanitizeSortModel)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $e6ca12cabeac117a$export$951287757eb5d93c = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $iU3u2.gridSortModelSelector),
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $acw62.useCallback((field, sortItem)=>{
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (!sortItem) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $acw62.useCallback((col, directionOverride)=>{
        var _col$sortingOrder2;
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            var _col$sortingOrder;
            const nextSort = directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)((_col$sortingOrder = col.sortingOrder) != null ? _col$sortingOrder : props.sortingOrder, existing.sort) : directionOverride;
            return nextSort == null ? undefined : (0, $8nd05.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)((_col$sortingOrder2 = col.sortingOrder) != null ? _col$sortingOrder2 : props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder
    ]);
    /**
   * API METHODS
   */ const applySorting = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $8nd05.default)({}, state, {
                    sorting: (0, $8nd05.default)({}, state.sorting, {
                        sortedRows: (0, $7sDf4.getTreeNodeDescendants)((0, $goCyd.gridRowTreeSelector)(apiRef), (0, $7sDf4.GRID_ROOT_GROUP_ID), false)
                    })
                });
            }
            const sortModel = (0, $iU3u2.gridSortModelSelector)(state, apiRef.current.instanceId);
            const sortRowList = (0, $h8fXG.buildAggregatedSortingApplier)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $8nd05.default)({}, state, {
                sorting: (0, $8nd05.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $acw62.useCallback((column, direction, allowMultipleSorting)=>{
        if (!column.sortable) return;
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = !sortItem ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $acw62.useCallback(()=>(0, $iU3u2.gridSortModelSelector)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $acw62.useCallback(()=>{
        const sortedRows = (0, $iU3u2.gridSortedRowEntriesSelector)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $acw62.useCallback(()=>(0, $iU3u2.gridSortedRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $acw62.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $ivFej.useGridApiMethod)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        var _props$initialState2;
        const sortModelToExport = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.sorting) == null ? void 0 : _props$initialState2.sortModel) != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $8nd05.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.sorting) == null ? void 0 : _props$initialState3.sortModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        var _context$stateToResto;
        const sortModel = (_context$stateToResto = context.stateToRestore.sorting) == null ? void 0 : _context$stateToResto.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $8nd05.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $acw62.useCallback((params)=>{
        const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        const rootGroupNode = rowTree[0, $7sDf4.GRID_ROOT_GROUP_ID];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, (0, $42J2j.GRID_DEFAULT_STRATEGY), 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $acw62.useCallback(({ colDef: colDef }, event)=>{
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(colDef, undefined, allowMultipleSorting);
    }, [
        sortColumn
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback(({ colDef: colDef }, event)=>{
        // Ctrl + Enter opens the column menu
        if ((0, $dMF9H.isEnterKey)(event.key) && !event.ctrlKey && !event.metaKey) sortColumn(colDef, undefined, event.shiftKey);
    }, [
        sortColumn
    ]);
    const handleColumnsChange = $acw62.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const latestColumns = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $2kdmP.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $eEJPp.default)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};

});

parcelRegister("gaDPW", function(module, exports) {

$parcel$export(module.exports, "useGridScroll", () => $bc5c7b440a851fd1$export$d3441dc29db31b8c);

var $acw62 = parcelRequire("acw62");

var $14H9o = parcelRequire("14H9o");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");

var $bdqIg = parcelRequire("bdqIg");

var $ivFej = parcelRequire("ivFej");

var $k278Q = parcelRequire("k278Q");

var $5H1vo = parcelRequire("5H1vo");
// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $bc5c7b440a851fd1$var$scrollIntoView(dimensions) {
    const { clientHeight: clientHeight, scrollTop: scrollTop, offsetHeight: offsetHeight, offsetTop: offsetTop } = dimensions;
    const elementBottom = offsetTop + offsetHeight;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (offsetHeight > clientHeight) return offsetTop;
    if (elementBottom - clientHeight > scrollTop) return elementBottom - clientHeight;
    if (offsetTop < scrollTop) return offsetTop;
    return undefined;
}
const $bc5c7b440a851fd1$export$d3441dc29db31b8c = (apiRef, props)=>{
    const theme = (0, $14H9o.default)();
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersElementRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedSortedRowEntriesSelector));
    const scrollToIndexes = $acw62.useCallback((params)=>{
        const totalRowCount = (0, $goCyd.gridRowCountSelector)(apiRef);
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex != null) {
            const columnPositions = (0, $jQEEt.gridColumnPositionsSelector)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                var _visibleSortedRows$pa;
                const rowId = (_visibleSortedRows$pa = visibleSortedRows[params.rowIndex]) == null ? void 0 : _visibleSortedRows$pa.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $bc5c7b440a851fd1$var$scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientWidth,
                scrollTop: Math.abs(virtualScrollerRef.current.scrollLeft),
                offsetHeight: cellWidth,
                offsetTop: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex != null) {
            var _querySelector, _querySelector2;
            const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state);
            const page = (0, $gPWuj.gridPageSelector)(apiRef);
            const pageSize = (0, $gPWuj.gridPageSizeSelector)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            const topPinnedRowsHeight = ((_querySelector = virtualScrollerRef.current.querySelector(`.${(0, $5H1vo.gridClasses)['pinnedRows--top']}`)) == null ? void 0 : _querySelector.clientHeight) || 0;
            const bottomPinnedRowsHeight = ((_querySelector2 = virtualScrollerRef.current.querySelector(`.${(0, $5H1vo.gridClasses)['pinnedRows--bottom']}`)) == null ? void 0 : _querySelector2.clientHeight) || 0;
            scrollCoordinates.top = $bc5c7b440a851fd1$var$scrollIntoView({
                clientHeight: virtualScrollerRef.current.clientHeight - topPinnedRowsHeight - bottomPinnedRowsHeight,
                scrollTop: virtualScrollerRef.current.scrollTop,
                offsetHeight: targetOffsetHeight,
                offsetTop: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = $acw62.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left != null && colRef.current) {
            const direction = theme.direction === 'rtl' ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top != null) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        theme.direction,
        colRef,
        logger
    ]);
    const getScrollPosition = $acw62.useCallback(()=>{
        if (!(virtualScrollerRef != null && virtualScrollerRef.current)) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $ivFej.useGridApiMethod)(apiRef, scrollApi, 'public');
};

});

parcelRegister("2oqux", function(module, exports) {

$parcel$export(module.exports, "useGridEvents", () => $1be25f585207520f$export$8456f443918812d4);

var $eFF1m = parcelRequire("eFF1m");
function $1be25f585207520f$export$8456f443918812d4(apiRef, props) {
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellClick', props.onCellClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'menuClose', props.onMenuClose);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'rowClick', props.onRowClick);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'stateChange', props.onStateChange);
}

});

parcelRegister("Anab1", function(module, exports) {

$parcel$export(module.exports, "useGridDimensions", () => $06d554a00cf6d24e$export$b8364994f9eec67d);

var $acw62 = parcelRequire("acw62");

var $aJ8G8 = parcelRequire("aJ8G8");
var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");

var $eFF1m = parcelRequire("eFF1m");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $fD9f4 = parcelRequire("fD9f4");

var $5sOMZ = parcelRequire("5sOMZ");

var $aJApm = parcelRequire("aJApm");

var $bdqIg = parcelRequire("bdqIg");

var $7sDf4 = parcelRequire("7sDf4");

var $i0LyH = parcelRequire("i0LyH");
const $06d554a00cf6d24e$var$isTestEnvironment = false;
const $06d554a00cf6d24e$var$hasScroll = ({ content: content, container: container, scrollBarSize: scrollBarSize })=>{
    const hasScrollXIfNoYScrollBar = content.width > container.width;
    const hasScrollYIfNoXScrollBar = content.height > container.height;
    let hasScrollX = false;
    let hasScrollY = false;
    if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
        hasScrollX = hasScrollXIfNoYScrollBar;
        hasScrollY = content.height + (hasScrollX ? scrollBarSize : 0) > container.height;
        // We recalculate the scroll x to consider the size of the y scrollbar.
        if (hasScrollY) hasScrollX = content.width + scrollBarSize > container.width;
    }
    return {
        hasScrollX: hasScrollX,
        hasScrollY: hasScrollY
    };
};
function $06d554a00cf6d24e$export$b8364994f9eec67d(apiRef, props) {
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useResizeContainer');
    const errorShown = $acw62.useRef(false);
    const rootDimensionsRef = $acw62.useRef(null);
    const fullDimensionsRef = $acw62.useRef(null);
    const rowsMeta = (0, $5sOMZ.useGridSelector)(apiRef, (0, $bdqIg.gridRowsMetaSelector));
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, props.columnHeaderHeight);
    const updateGridDimensionsRef = $acw62.useCallback(()=>{
        var _apiRef$current$rootE;
        const rootElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null ? void 0 : _apiRef$current$rootE.current;
        const columnsTotalWidth = (0, $jQEEt.gridColumnsTotalWidthSelector)(apiRef);
        const pinnedRowsHeight = (0, $7sDf4.calculatePinnedRowsHeight)(apiRef);
        if (!rootDimensionsRef.current) return;
        let scrollBarSize;
        if (props.scrollbarSize != null) scrollBarSize = props.scrollbarSize;
        else if (!columnsTotalWidth || !rootElement) scrollBarSize = 0;
        else {
            const doc = (0, $6zeBo.default)(rootElement);
            const scrollDiv = doc.createElement('div');
            scrollDiv.style.width = '99px';
            scrollDiv.style.height = '99px';
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.overflow = 'scroll';
            scrollDiv.className = 'scrollDiv';
            rootElement.appendChild(scrollDiv);
            scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            rootElement.removeChild(scrollDiv);
        }
        let viewportOuterSize;
        let hasScrollX;
        let hasScrollY;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rowsMeta.currentPageTotalHeight + (hasScrollX ? scrollBarSize : 0)
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: Math.max(rootDimensionsRef.current.height - totalHeaderHeight, 0)
            };
            const scrollInformation = $06d554a00cf6d24e$var$hasScroll({
                content: {
                    width: Math.round(columnsTotalWidth),
                    height: rowsMeta.currentPageTotalHeight
                },
                container: {
                    width: Math.round(viewportOuterSize.width),
                    height: viewportOuterSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom
                },
                scrollBarSize: scrollBarSize
            });
            hasScrollY = scrollInformation.hasScrollY;
            hasScrollX = scrollInformation.hasScrollX;
        }
        const viewportInnerSize = {
            width: viewportOuterSize.width - (hasScrollY ? scrollBarSize : 0),
            height: viewportOuterSize.height - (hasScrollX ? scrollBarSize : 0)
        };
        const newFullDimensions = {
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollBarSize: scrollBarSize
        };
        const prevDimensions = fullDimensionsRef.current;
        fullDimensionsRef.current = newFullDimensions;
        if (newFullDimensions.viewportInnerSize.width !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.width) || newFullDimensions.viewportInnerSize.height !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.height)) apiRef.current.publishEvent('viewportInnerSizeChange', newFullDimensions.viewportInnerSize);
    }, [
        apiRef,
        props.scrollbarSize,
        props.autoHeight,
        rowsMeta.currentPageTotalHeight,
        totalHeaderHeight
    ]);
    const [savedSize, setSavedSize] = $acw62.useState();
    const debouncedSetSavedSize = $acw62.useMemo(()=>(0, $aJ8G8.default)(setSavedSize, 60), []);
    const previousSize = $acw62.useRef();
    (0, $eEJPp.default)(()=>{
        if (savedSize) {
            updateGridDimensionsRef();
            apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
        }
    }, [
        apiRef,
        savedSize,
        updateGridDimensionsRef
    ]);
    // This is the function called by apiRef.current.resize()
    const resize = $acw62.useCallback(()=>{
        apiRef.current.computeSizeAndPublishResizeEvent();
    }, [
        apiRef
    ]);
    const getRootDimensions = $acw62.useCallback(()=>fullDimensionsRef.current, []);
    const getViewportPageSize = $acw62.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return 0;
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = apiRef.current.getRenderContext();
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode,
        props.getRowHeight,
        rowHeight
    ]);
    const computeSizeAndPublishResizeEvent = $acw62.useCallback(()=>{
        var _apiRef$current$mainE, _previousSize$current, _previousSize$current2;
        const mainEl = (_apiRef$current$mainE = apiRef.current.mainElementRef) == null ? void 0 : _apiRef$current$mainE.current;
        if (!mainEl) return;
        const win = (0, $9KvVX.default)(mainEl);
        const computedStyle = win.getComputedStyle(mainEl);
        const height = parseFloat(computedStyle.height) || 0;
        const width = parseFloat(computedStyle.width) || 0;
        const hasHeightChanged = height !== ((_previousSize$current = previousSize.current) == null ? void 0 : _previousSize$current.height);
        const hasWidthChanged = width !== ((_previousSize$current2 = previousSize.current) == null ? void 0 : _previousSize$current2.width);
        if (!previousSize.current || hasHeightChanged || hasWidthChanged) {
            const size = {
                width: width,
                height: height
            };
            apiRef.current.publishEvent('resize', size);
            previousSize.current = size;
        }
    }, [
        apiRef
    ]);
    const dimensionsApi = {
        resize: resize,
        getRootDimensions: getRootDimensions
    };
    const dimensionsPrivateApi = {
        getViewportPageSize: getViewportPageSize,
        updateGridDimensionsRef: updateGridDimensionsRef,
        computeSizeAndPublishResizeEvent: computeSizeAndPublishResizeEvent
    };
    (0, $ivFej.useGridApiMethod)(apiRef, dimensionsApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, dimensionsPrivateApi, 'private');
    const isFirstSizing = $acw62.useRef(true);
    const handleResize = $acw62.useCallback((size)=>{
        rootDimensionsRef.current = size;
        // jsdom has no layout capabilities
        const isJSDOM = /jsdom/.test(window.navigator.userAgent);
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !isJSDOM) {
            logger.error([
                'The parent DOM element of the data grid has an empty height.',
                'Please make sure that this element has an intrinsic height.',
                'The grid displays with a height of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !isJSDOM) {
            logger.error([
                'The parent DOM element of the data grid has an empty width.',
                'Please make sure that this element has an intrinsic width.',
                'The grid displays with a width of 0px.',
                '',
                'More details: https://mui.com/r/x-data-grid-no-dimensions.'
            ].join('\n'));
            errorShown.current = true;
        }
        if ($06d554a00cf6d24e$var$isTestEnvironment) {
            // We don't need to debounce the resize for tests.
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        if (isFirstSizing.current) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            setSavedSize(size);
            isFirstSizing.current = false;
            return;
        }
        debouncedSetSavedSize(size);
    }, [
        props.autoHeight,
        debouncedSetSavedSize,
        logger
    ]);
    (0, $eEJPp.default)(()=>updateGridDimensionsRef(), [
        updateGridDimensionsRef
    ]);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'sortedRowsSet', updateGridDimensionsRef);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'paginationModelChange', updateGridDimensionsRef);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'columnsChange', updateGridDimensionsRef);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'resize', handleResize);
    (0, $eFF1m.useGridApiOptionHandler)(apiRef, 'debouncedResize', props.onResize);
}

});

parcelRegister("jBRsK", function(module, exports) {

$parcel$export(module.exports, "rowsMetaStateInitializer", () => $e46af192720967f4$export$4224c70cd0329965);
$parcel$export(module.exports, "useGridRowsMeta", () => $e46af192720967f4$export$8a4468671da3a64f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $gxvzd = parcelRequire("gxvzd");
var $aJ8G8 = parcelRequire("aJ8G8");

var $aJApm = parcelRequire("aJApm");

var $ivFej = parcelRequire("ivFej");

var $5sOMZ = parcelRequire("5sOMZ");

var $fD9f4 = parcelRequire("fD9f4");

var $k278Q = parcelRequire("k278Q");

var $gPWuj = parcelRequire("gPWuj");

var $iU3u2 = parcelRequire("iU3u2");

var $1xynw = parcelRequire("1xynw");

var $goCyd = parcelRequire("goCyd");

var $hiKx5 = parcelRequire("hiKx5");
const $e46af192720967f4$export$4224c70cd0329965 = (state)=>(0, $8nd05.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: 0,
            positions: []
        }
    });
let $e46af192720967f4$var$warnedOnceInvalidRowHeight = false;
const $e46af192720967f4$var$getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $e46af192720967f4$var$rowHeightWarning = [
    `MUI: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $e46af192720967f4$var$getRowHeightWarning = [
    `MUI: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');
const $e46af192720967f4$export$8a4468671da3a64f = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = props;
    const rowsHeightLookup = $acw62.useRef(Object.create(null));
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    const lastMeasuredRowIndex = $acw62.useRef(-1);
    const hasRowWithAutoHeight = $acw62.useRef(false);
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, (0, $fD9f4.gridDensityFactorSelector));
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterModelSelector));
    const paginationState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationSelector));
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortModelSelector));
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, props);
    const pinnedRows = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridPinnedRowsSelector));
    const validRowHeight = $e46af192720967f4$var$getValidRowHeight(props.rowHeight, (0, $hiKx5.DATA_GRID_PROPS_DEFAULT_VALUES).rowHeight, $e46af192720967f4$var$rowHeightWarning);
    const rowHeight = Math.floor(validRowHeight * densityFactor);
    const hydrateRowsMeta = $acw62.useCallback(()=>{
        var _pinnedRows$top, _pinnedRows$bottom;
        hasRowWithAutoHeight.current = false;
        const calculateRowProcessedSizes = (row)=>{
            if (!rowsHeightLookup.current[row.id]) rowsHeightLookup.current[row.id] = {
                sizes: {
                    baseCenter: rowHeight
                },
                isResized: false,
                autoHeight: false,
                needsFirstMeasurement: true // Assume all rows will need to be measured by default
            };
            const { isResized: isResized, needsFirstMeasurement: needsFirstMeasurement, sizes: sizes } = rowsHeightLookup.current[row.id];
            let baseRowHeight = typeof rowHeight === 'number' && rowHeight > 0 ? rowHeight : 52;
            const existingBaseRowHeight = sizes.baseCenter;
            if (isResized) // Do not recalculate resized row height and use the value from the lookup
            baseRowHeight = existingBaseRowHeight;
            else if (getRowHeightProp) {
                const rowHeightFromUser = getRowHeightProp((0, $8nd05.default)({}, row, {
                    densityFactor: densityFactor
                }));
                if (rowHeightFromUser === 'auto') {
                    if (needsFirstMeasurement) {
                        const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, $8nd05.default)({}, row, {
                            densityFactor: densityFactor
                        })) : rowHeight;
                        // If the row was not measured yet use the estimated row height
                        baseRowHeight = estimatedRowHeight != null ? estimatedRowHeight : rowHeight;
                    } else baseRowHeight = existingBaseRowHeight;
                    hasRowWithAutoHeight.current = true;
                    rowsHeightLookup.current[row.id].autoHeight = true;
                } else {
                    // Default back to base rowHeight if getRowHeight returns invalid value.
                    baseRowHeight = $e46af192720967f4$var$getValidRowHeight(rowHeightFromUser, rowHeight, $e46af192720967f4$var$getRowHeightWarning);
                    rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
                    rowsHeightLookup.current[row.id].autoHeight = false;
                }
            } else rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
            const initialHeights = {};
            /* eslint-disable-next-line no-restricted-syntax */ for(const key in sizes)if (/^base[A-Z]/.test(key)) initialHeights[key] = sizes[key];
            initialHeights.baseCenter = baseRowHeight;
            if (getRowSpacing) {
                var _spacing$top, _spacing$bottom;
                const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
                const spacing = getRowSpacing((0, $8nd05.default)({}, row, {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                }));
                initialHeights.spacingTop = (_spacing$top = spacing.top) != null ? _spacing$top : 0;
                initialHeights.spacingBottom = (_spacing$bottom = spacing.bottom) != null ? _spacing$bottom : 0;
            }
            const processedSizes = apiRef.current.unstable_applyPipeProcessors('rowHeight', initialHeights, row);
            rowsHeightLookup.current[row.id].sizes = processedSizes;
            return processedSizes;
        };
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            let maximumBaseSize = 0;
            let otherSizes = 0;
            const processedSizes = calculateRowProcessedSizes(row);
            /* eslint-disable-next-line no-restricted-syntax, guard-for-in */ for(const key in processedSizes){
                const value = processedSizes[key];
                if (/^base[A-Z]/.test(key)) maximumBaseSize = value > maximumBaseSize ? value : maximumBaseSize;
                else otherSizes += value;
            }
            return acc + maximumBaseSize + otherSizes;
        }, 0);
        pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null || _pinnedRows$top.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null || _pinnedRows$bottom.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                rowsMeta: {
                    currentPageTotalHeight: currentPageTotalHeight,
                    positions: positions
                }
            });
        });
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        currentPage.rows,
        rowHeight,
        getRowHeightProp,
        getRowSpacing,
        getEstimatedRowHeight,
        pinnedRows,
        densityFactor
    ]);
    const getRowHeight = $acw62.useCallback((rowId)=>{
        const height = rowsHeightLookup.current[rowId];
        return height ? height.sizes.baseCenter : rowHeight;
    }, [
        rowHeight
    ]);
    const getRowInternalSizes = (rowId)=>{
        var _rowsHeightLookup$cur;
        return (_rowsHeightLookup$cur = rowsHeightLookup.current[rowId]) == null ? void 0 : _rowsHeightLookup$cur.sizes;
    };
    const setRowHeight = $acw62.useCallback((id, height)=>{
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        rowsHeightLookup.current[id].isResized = true;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const debouncedHydrateRowsMeta = $acw62.useMemo(()=>(0, $aJ8G8.default)(hydrateRowsMeta, props.rowPositionsDebounceMs), [
        hydrateRowsMeta,
        props.rowPositionsDebounceMs
    ]);
    const storeMeasuredRowHeight = $acw62.useCallback((id, height, position)=>{
        if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) return;
        // Only trigger hydration if the value is different, otherwise we trigger a loop
        const needsHydration = rowsHeightLookup.current[id].sizes[`base${(0, $gxvzd.default)(position)}`] !== height;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        rowsHeightLookup.current[id].sizes[`base${(0, $gxvzd.default)(position)}`] = height;
        if (needsHydration) debouncedHydrateRowsMeta();
    }, [
        debouncedHydrateRowsMeta
    ]);
    const rowHasAutoHeight = $acw62.useCallback((id)=>{
        var _rowsHeightLookup$cur2;
        return ((_rowsHeightLookup$cur2 = rowsHeightLookup.current[id]) == null ? void 0 : _rowsHeightLookup$cur2.autoHeight) || false;
    }, []);
    const getLastMeasuredRowIndex = $acw62.useCallback(()=>{
        return lastMeasuredRowIndex.current;
    }, []);
    const setLastMeasuredRowIndex = $acw62.useCallback((index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    }, []);
    const resetRowHeights = $acw62.useCallback(()=>{
        rowsHeightLookup.current = {};
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    $acw62.useEffect(()=>{
        hydrateRowsMeta();
    }, [
        rowHeight,
        filterModel,
        paginationState,
        sortModel,
        hydrateRowsMeta
    ]);
    (0, $1xynw.useGridRegisterPipeApplier)(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_getRowHeight: getRowHeight,
        unstable_getRowInternalSizes: getRowInternalSizes,
        unstable_setRowHeight: setRowHeight,
        unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        rowHasAutoHeight: rowHasAutoHeight
    };
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaPrivateApi, 'private');
};

});
parcelRegister("hiKx5", function(module, exports) {

$parcel$export(module.exports, "DATA_GRID_PROPS_DEFAULT_VALUES", () => $c9883683c395e213$export$2733e0e1a1d288e7);
$parcel$export(module.exports, "useDataGridProps", () => $c9883683c395e213$export$23366c9f040a985);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $6g9fa = parcelRequire("6g9fa");

var $hHZTP = parcelRequire("hHZTP");

var $fCO8m = parcelRequire("fCO8m");

var $jkRzp = parcelRequire("jkRzp");

var $4Yqqs = parcelRequire("4Yqqs");
var $cBO5b = parcelRequire("cBO5b");
var $4cd9P = parcelRequire("4cd9P");
const $c9883683c395e213$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    disableMultipleRowSelection: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    disableColumnResize: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid'
};
const $c9883683c395e213$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    columnBuffer: 3,
    rowBuffer: 3,
    columnThreshold: 3,
    rowThreshold: 3,
    rowSelection: true,
    density: 'standard',
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnSelector: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleRowSelection: false,
    disableMultipleColumnsSorting: false,
    disableRowSelectionOnClick: false,
    disableVirtualization: false,
    editMode: (0, $jkRzp.GridEditModes).Cell,
    filterMode: 'client',
    filterDebounceMs: 150,
    columnHeaderHeight: 56,
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    logger: console,
    logLevel: 'error',
    pagination: false,
    paginationMode: 'client',
    rowHeight: 52,
    pageSizeOptions: [
        25,
        50,
        100
    ],
    rowSpacingType: 'margin',
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    sortingMode: 'client',
    throttleRowsMs: 0,
    disableColumnReorder: false,
    disableColumnResize: false,
    keepNonExistentRowsSelected: false,
    keepColumnPositionIfDraggedOutside: false,
    unstable_ignoreValueFormatterDuringExport: false,
    clipboardCopyCellDelimiter: '\t',
    rowPositionsDebounceMs: 166
};
const $c9883683c395e213$var$defaultSlots = (0, $cBO5b.uncapitalizeObjectKeys)((0, $fCO8m.DATA_GRID_DEFAULT_SLOTS_COMPONENTS));
const $c9883683c395e213$export$23366c9f040a985 = (inProps)=>{
    const [components, componentsProps, themedProps] = (0, $4cd9P.useProps)((0, $6g9fa.default)({
        props: inProps,
        name: 'MuiDataGrid'
    }));
    const localeText = $acw62.useMemo(()=>(0, $8nd05.default)({}, (0, $hHZTP.GRID_DEFAULT_LOCALE_TEXT), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $acw62.useMemo(()=>(0, $4Yqqs.computeSlots)({
            defaultSlots: $c9883683c395e213$var$defaultSlots,
            slots: themedProps.slots,
            components: components
        }), [
        components,
        themedProps.slots
    ]);
    return $acw62.useMemo(()=>{
        var _themedProps$slotProp;
        return (0, $8nd05.default)({}, $c9883683c395e213$export$2733e0e1a1d288e7, themedProps, {
            localeText: localeText,
            slots: slots,
            slotProps: (_themedProps$slotProp = themedProps.slotProps) != null ? _themedProps$slotProp : componentsProps
        }, $c9883683c395e213$var$DATA_GRID_FORCED_PROPS);
    }, [
        themedProps,
        localeText,
        slots,
        componentsProps
    ]);
};

});
parcelRegister("6g9fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $48eb684ebe9272b4$export$2e2bcd8739ae039);

var $dFNG2 = parcelRequire("dFNG2");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dFNG2.default)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default,
        themeId: (0, $4jPsi.default)
    });
}

});
parcelRegister("dFNG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f45a3834bb6880f$export$2e2bcd8739ae039);

var $cfUWu = parcelRequire("cfUWu");

var $7HKeb = parcelRequire("7HKeb");
'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $7HKeb.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $cfUWu.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("cfUWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec30e4d54713c84$export$2e2bcd8739ae039);

var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}

});



parcelRegister("hHZTP", function(module, exports) {

$parcel$export(module.exports, "GRID_DEFAULT_LOCALE_TEXT", () => $ce4677c59813cb05$export$d217cc4e11b3c706);
const $ce4677c59813cb05$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Columns panel text
    columnsPanelTextFieldLabel: 'Find column',
    columnsPanelTextFieldPlaceholder: 'Column title',
    columnsPanelDragIconLabel: 'Reorder column',
    columnsPanelShowAllButton: 'Show all',
    columnsPanelHideAllButton: 'Hide all',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorEquals: 'equals',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size'
};

});

parcelRegister("fCO8m", function(module, exports) {

$parcel$export(module.exports, "DATA_GRID_DEFAULT_SLOTS_COMPONENTS", () => $b6014b2d4bf32573$export$8a57bda01657743f);

var $8nd05 = parcelRequire("8nd05");

var $k8xn5 = parcelRequire("k8xn5");
var $l98cE = parcelRequire("l98cE");
var $kWNEF = parcelRequire("kWNEF");
var $jIkp9 = parcelRequire("jIkp9");
var $4YSVE = parcelRequire("4YSVE");
var $28JSg = parcelRequire("28JSg");
var $fuqu4 = parcelRequire("fuqu4");
var $kfa8b = parcelRequire("kfa8b");
var $tZfVk = parcelRequire("tZfVk");
var $kWPQR = parcelRequire("kWPQR");
var $l3iPY = parcelRequire("l3iPY");
var $etLiE = parcelRequire("etLiE");

var $6X2NG = parcelRequire("6X2NG");

var $sLaj5 = parcelRequire("sLaj5");

var $59mZx = parcelRequire("59mZx");

var $eaFJs = parcelRequire("eaFJs");

var $9lhjy = parcelRequire("9lhjy");
const $b6014b2d4bf32573$export$8a57bda01657743f = (0, $8nd05.default)({}, (0, $9lhjy.default), {
    Cell: (0, $6X2NG.GridCellV7),
    SkeletonCell: (0, $etLiE.GridSkeletonCell),
    ColumnHeaderFilterIconButton: (0, $k8xn5.GridColumnHeaderFilterIconButton),
    ColumnMenu: (0, $59mZx.GridColumnMenu),
    ColumnHeaders: (0, $sLaj5.GridColumnHeaders),
    Footer: (0, $jIkp9.GridFooter),
    FooterRowCount: (0, $l3iPY.GridRowCount),
    Toolbar: null,
    PreferencesPanel: (0, $tZfVk.GridPreferencesPanel),
    LoadingOverlay: (0, $4YSVE.GridLoadingOverlay),
    NoResultsOverlay: (0, $eaFJs.GridNoResultsOverlay),
    NoRowsOverlay: (0, $28JSg.GridNoRowsOverlay),
    Pagination: (0, $fuqu4.GridPagination),
    FilterPanel: (0, $kWNEF.GridFilterPanel),
    ColumnsPanel: (0, $l98cE.GridColumnsPanel),
    Panel: (0, $kfa8b.GridPanel),
    Row: (0, $kWPQR.GridRow)
});

});
parcelRegister("k8xn5", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderFilterIconButton", () => $ea8e70d6ac9b663f$export$35b5c67d267fafd7);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $fagfG = parcelRequire("fagfG");

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $j4crP = parcelRequire("j4crP");

var $ayMG0 = parcelRequire("ayMG0");
const $ea8e70d6ac9b663f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $ea8e70d6ac9b663f$export$35b5c67d267fafd7(props) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $ea8e70d6ac9b663f$var$useUtilityClasses(ownerState);
    const preferencePanel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $6X2Yd.gridPreferencePanelStateSelector));
    const labelId = (0, $auC0X.default)();
    const panelId = (0, $auC0X.default)();
    const toggleFilter = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef.current.state);
        if (open && openedPanelValue === (0, $3PCYS.GridPreferencePanelsValue).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const open = preferencePanel.open && preferencePanel.labelId === labelId;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
        id: labelId,
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? panelId : undefined
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j4crP.GridIconButtonContainer), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}

});
parcelRegister("fagfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a465815ebe726f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $9D07P = parcelRequire("9D07P");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $17KyE = parcelRequire("17KyE");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $8FqN6 = parcelRequire("8FqN6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a465815ebe726f$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}${(0, $jTnBY.default)(overlap)}`,
            `overlap${(0, $jTnBY.default)(overlap)}`,
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8FqN6.getBadgeUtilityClass), classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}${(0, $jTnBY.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $1En50.default)(props, $b0a465815ebe726f$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $17KyE.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $9D07P.default)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $8nd05.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b0a465815ebe726f$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $b0a465815ebe726f$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $eD6Co.default)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, (0, $8nd05.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $b0a465815ebe726f$export$2e2bcd8739ae039 = $b0a465815ebe726f$var$Badge;

});
parcelRegister("17KyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1a8f518d4ece30$export$2e2bcd8739ae039);

var $9D07P = parcelRequire("9D07P");
'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://next.mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://next.mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $9D07P.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$export$2e2bcd8739ae039 = $0d1a8f518d4ece30$var$useBadge;

});

parcelRegister("8FqN6", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", () => $64f6ef338eb74fbc$export$aaccef17e6dab084);
$parcel$export(module.exports, "default", () => $64f6ef338eb74fbc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64f6ef338eb74fbc$export$aaccef17e6dab084(slot) {
    return (0, $4Cod0.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $beCSm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$export$2e2bcd8739ae039 = $64f6ef338eb74fbc$var$badgeClasses;

});


parcelRegister("j4crP", function(module, exports) {

$parcel$export(module.exports, "GridIconButtonContainer", () => $de180beae3cc7fe7$export$e67562d5b709404c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $de180beae3cc7fe7$var$_excluded = [
    "className"
];
const $de180beae3cc7fe7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $de180beae3cc7fe7$var$GridIconButtonContainerRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer',
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $de180beae3cc7fe7$export$e67562d5b709404c = /*#__PURE__*/ $acw62.forwardRef(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $de180beae3cc7fe7$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $de180beae3cc7fe7$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de180beae3cc7fe7$var$GridIconButtonContainerRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

});


parcelRegister("l98cE", function(module, exports) {

$parcel$export(module.exports, "GridColumnsPanel", () => $f650cd2c2e66a414$export$39d43456ec96cf57);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9Lykx = parcelRequire("9Lykx");

var $89Onw = parcelRequire("89Onw");

var $2esSG = parcelRequire("2esSG");

var $d8seH = parcelRequire("d8seH");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $hbQyH = parcelRequire("hbQyH");

var $ip3sX = parcelRequire("ip3sX");

var $cpUTD = parcelRequire("cpUTD");

var $dQ4Fi = parcelRequire("dQ4Fi");

var $l4ujy = parcelRequire("l4ujy");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $f650cd2c2e66a414$var$_excluded = [
    "sort",
    "searchPredicate",
    "autoFocusSearchField",
    "disableHideAllButton",
    "disableShowAllButton",
    "getTogglableColumns"
];
const $f650cd2c2e66a414$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsPanel'
        ],
        columnsPanelRow: [
            'columnsPanelRow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $f650cd2c2e66a414$var$GridColumnsPanelRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanel',
    overridesResolver: (props, styles)=>styles.columnsPanel
})({
    padding: '8px 0px 8px 8px'
});
const $f650cd2c2e66a414$var$GridColumnsPanelRowRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsPanelRow',
    overridesResolver: (props, styles)=>styles.columnsPanelRow
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1px 8px 1px 7px',
        [`& .${(0, $89Onw.default).root}`]: {
            marginRight: theme.spacing(0.5)
        }
    }));
const $f650cd2c2e66a414$var$GridIconButtonRoot = (0, $d8seH.default)((0, $9Lykx.default))({
    justifyContent: 'flex-end'
});
const $f650cd2c2e66a414$var$collator = new Intl.Collator();
const $f650cd2c2e66a414$var$defaultSearchPredicate = (column, searchValue)=>{
    return (column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
};
function $f650cd2c2e66a414$export$39d43456ec96cf57(props) {
    var _rootProps$slotProps, _rootProps$slotProps3, _rootProps$slotProps4;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const searchInputRef = $acw62.useRef(null);
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnDefinitionsSelector));
    const columnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnVisibilityModelSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [searchValue, setSearchValue] = $acw62.useState('');
    const classes = $f650cd2c2e66a414$var$useUtilityClasses(rootProps);
    const { sort: sort, searchPredicate: searchPredicate = $f650cd2c2e66a414$var$defaultSearchPredicate, autoFocusSearchField: autoFocusSearchField = true, disableHideAllButton: disableHideAllButton = false, disableShowAllButton: disableShowAllButton = false, getTogglableColumns: getTogglableColumns } = props, other = (0, $1En50.default)(props, $f650cd2c2e66a414$var$_excluded);
    const sortedColumns = $acw62.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$f650cd2c2e66a414$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$f650cd2c2e66a414$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const toggleAllColumns = $acw62.useCallback((isVisible)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const newModel = (0, $8nd05.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        columns.forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns
    ]);
    const handleSearchValueChange = $acw62.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const currentColumns = $acw62.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const firstSwitchRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dQ4Fi.GridPanelWrapper), (0, $8nd05.default)({}, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cpUTD.GridPanelHeader), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $8nd05.default)({
                    label: apiRef.current.getLocaleText('columnsPanelTextFieldLabel'),
                    placeholder: apiRef.current.getLocaleText('columnsPanelTextFieldPlaceholder'),
                    inputRef: searchInputRef,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "standard",
                    fullWidth: true
                }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hbQyH.GridPanelContent), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($f650cd2c2e66a414$var$GridColumnsPanelRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: currentColumns.map((column)=>{
                        var _rootProps$slotProps2;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)($f650cd2c2e66a414$var$GridColumnsPanelRowRoot, {
                            className: classes.columnsPanelRow,
                            ownerState: rootProps,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSwitch, (0, $8nd05.default)({
                                        disabled: column.hideable === false,
                                        checked: columnVisibilityModel[column.field] !== false,
                                        onClick: toggleColumn,
                                        name: column.field,
                                        size: "small",
                                        inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                                    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSwitch)),
                                    label: column.headerName || column.field
                                }),
                                !rootProps.disableColumnReorder && (0, $l4ujy.GRID_EXPERIMENTAL_ENABLED) && /*#__PURE__*/ (0, $ayMG0.jsx)($f650cd2c2e66a414$var$GridIconButtonRoot, {
                                    draggable: true,
                                    "aria-label": apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    title: apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
                                    size: "small",
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnReorderIcon, {})
                                })
                            ]
                        }, column.field);
                    })
                })
            }),
            disableShowAllButton && disableHideAllButton ? null : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ip3sX.GridPanelFooter), {
                children: [
                    !disableHideAllButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: ()=>toggleAllColumns(false)
                    }, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseButton, {
                        disabled: disableHideAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelHideAllButton')
                    })) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableShowAllButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: ()=>toggleAllColumns(true)
                    }, (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseButton, {
                        disabled: disableShowAllButton,
                        children: apiRef.current.getLocaleText('columnsPanelShowAllButton')
                    })) : null
                ]
            })
        ]
    }));
}

});
parcelRegister("89Onw", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", () => $5f063e1b0f6d278b$export$39f6debbec19b3ba);
$parcel$export(module.exports, "default", () => $5f063e1b0f6d278b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;

});

parcelRegister("2esSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $cJQfW = parcelRequire("cJQfW");

var $30UGG = parcelRequire("30UGG");

var $3bYfT = parcelRequire("3bYfT");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Z1x5 = parcelRequire("7Z1x5");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7Z1x5.getFormControlLabelUtilityClasses), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7Z1x5.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7Z1x5.default).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $7Z1x5.default).label}`]: {
            [`&.${(0, $7Z1x5.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $7Z1x5.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $3bYfT.default) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("30UGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $231d58234d437bc0$export$2e2bcd8739ae039);


var $isyt6 = parcelRequire("isyt6");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $isyt6.default)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;

});
parcelRegister("isyt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70594339ba23534$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $dFNG2 = parcelRequire("dFNG2");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $3OJTQ = parcelRequire("3OJTQ");

var $cKRCq = parcelRequire("cKRCq");

var $ayMG0 = parcelRequire("ayMG0");
const $d70594339ba23534$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $0tqaY.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $cKRCq.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $cKRCq.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3OJTQ.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $d70594339ba23534$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

});


parcelRegister("3bYfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2531239e3a525689$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bhKtZ.getTypographyUtilityClass), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $hcz0Q.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;

});
parcelRegister("bhKtZ", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $837556bdf75d281f$export$24c1f8f60cbac79e);
$parcel$export(module.exports, "default", () => $837556bdf75d281f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;

});


parcelRegister("7Z1x5", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $5cff6b4166fff27c$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;

});


parcelRegister("hbQyH", function(module, exports) {

$parcel$export(module.exports, "GridPanelContent", () => $c83c3bce08f2b302$export$1b4102a66373332b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $c83c3bce08f2b302$var$_excluded = [
    "className"
];
const $c83c3bce08f2b302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $c83c3bce08f2b302$var$GridPanelContentRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent',
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400
});
function $c83c3bce08f2b302$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $1En50.default)(props, $c83c3bce08f2b302$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $c83c3bce08f2b302$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c83c3bce08f2b302$var$GridPanelContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("ip3sX", function(module, exports) {

$parcel$export(module.exports, "GridPanelFooter", () => $d65d401151f46b4c$export$18e44097a2744a);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d65d401151f46b4c$var$_excluded = [
    "className"
];
const $d65d401151f46b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $d65d401151f46b4c$var$GridPanelFooterRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter',
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme: theme })=>({
        padding: theme.spacing(0.5),
        display: 'flex',
        justifyContent: 'space-between'
    }));
function $d65d401151f46b4c$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $1En50.default)(props, $d65d401151f46b4c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d65d401151f46b4c$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65d401151f46b4c$var$GridPanelFooterRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("cpUTD", function(module, exports) {

$parcel$export(module.exports, "GridPanelHeader", () => $90a3f4450bddbd27$export$f0388ac20c4d2ecc);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $90a3f4450bddbd27$var$_excluded = [
    "className"
];
const $90a3f4450bddbd27$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $90a3f4450bddbd27$var$GridPanelHeaderRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelHeader',
    overridesResolver: (props, styles)=>styles.panelHeader
})(({ theme: theme })=>({
        padding: theme.spacing(1)
    }));
function $90a3f4450bddbd27$export$f0388ac20c4d2ecc(props) {
    const { className: className } = props, other = (0, $1En50.default)(props, $90a3f4450bddbd27$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $90a3f4450bddbd27$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($90a3f4450bddbd27$var$GridPanelHeaderRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("dQ4Fi", function(module, exports) {

$parcel$export(module.exports, "GridPanelWrapper", () => $a133c015d593f0ef$export$6a36e1ca07bd502c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $kRwxQ = parcelRequire("kRwxQ");

var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $a133c015d593f0ef$var$_excluded = [
    "className",
    "slotProps"
];
const $a133c015d593f0ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $a133c015d593f0ef$var$GridPanelWrapperRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper',
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $a133c015d593f0ef$var$isEnabled = ()=>true;
const $a133c015d593f0ef$export$6a36e1ca07bd502c = /*#__PURE__*/ $acw62.forwardRef(function GridPanelWrapper(props, ref) {
    const { className: className, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a133c015d593f0ef$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a133c015d593f0ef$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), (0, $8nd05.default)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: $a133c015d593f0ef$var$isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a133c015d593f0ef$var$GridPanelWrapperRoot, (0, $8nd05.default)({
            ref: ref,
            tabIndex: -1,
            className: (0, $9QePP.default)(className, classes.root),
            ownerState: rootProps
        }, other))
    }));
});

});
parcelRegister("kRwxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30200a1e85b3f20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $2xc7G = parcelRequire("2xc7G");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;

});


parcelRegister("l4ujy", function(module, exports) {

$parcel$export(module.exports, "GRID_EXPERIMENTAL_ENABLED", () => $f5717c864dbc0f49$export$db163d1350df1623);
// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.
const $f5717c864dbc0f49$export$db163d1350df1623 = false;

});


parcelRegister("kWNEF", function(module, exports) {

$parcel$export(module.exports, "GridFilterPanel", () => $f3ffbde2bea4efe2$export$32c6e72be8ad862c);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $hbQyH = parcelRequire("hbQyH");

var $ip3sX = parcelRequire("ip3sX");

var $dQ4Fi = parcelRequire("dQ4Fi");

var $9De9Z = parcelRequire("9De9Z");

var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $ayMG0 = parcelRequire("ayMG0");
const $f3ffbde2bea4efe2$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $f3ffbde2bea4efe2$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $f3ffbde2bea4efe2$export$32c6e72be8ad862c = /*#__PURE__*/ $acw62.forwardRef(function GridFilterPanel(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterModelSelector));
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridFilterableColumnDefinitionsSelector));
    const lastFilterRef = $acw62.useRef(null);
    const placeholderFilter = $acw62.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $9jXuN.GridLogicOperator).And,
        (0, $9jXuN.GridLogicOperator).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $1En50.default)(props, $f3ffbde2bea4efe2$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $acw62.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $acw62.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: (filterModel == null ? void 0 : filterModel.items) || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>{
            var _colDef$filterOperato;
            return (_colDef$filterOperato = colDef.filterOperators) == null ? void 0 : _colDef$filterOperato.length;
        });
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel == null ? void 0 : filterModel.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $acw62.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $acw62.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const addNewFilter = ()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    };
    const deleteFilter = $acw62.useCallback((item)=>{
        const shouldCloseFilterPanel = items.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        items.length
    ]);
    const handleRemoveAll = ()=>{
        if (items.length === 1 && items[0].value === undefined) {
            apiRef.current.deleteFilterItem(items[0]);
            apiRef.current.hideFilterPanel();
        }
        apiRef.current.setFilterModel((0, $8nd05.default)({}, filterModel, {
            items: []
        }));
    };
    $acw62.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $acw62.useEffect(()=>{
        if (items.length > 0) lastFilterRef.current.focus();
    }, [
        items.length
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dQ4Fi.GridPanelWrapper), (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hbQyH.GridPanelContent), {
                children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9De9Z.GridFilterForm), (0, $8nd05.default)({
                        item: item,
                        applyFilterChanges: applyFilter,
                        deleteFilter: deleteFilter,
                        hasMultipleFilters: hasMultipleFilters,
                        showMultiFilterOperators: index > 0,
                        multiFilterOperator: filterModel.logicOperator,
                        disableMultiFilterOperator: index !== 1,
                        applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                        focusElementRef: index === items.length - 1 ? lastFilterRef : null,
                        logicOperators: logicOperators,
                        columnsSort: columnsSort
                    }, filterFormProps), item.id == null ? index : item.id))
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ip3sX.GridPanelFooter), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableRemoveAllButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $8nd05.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});

});
parcelRegister("9De9Z", function(module, exports) {

$parcel$export(module.exports, "GridFilterForm", () => $7032bd7e5a458ec9$export$4c95feba7016dbe7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $d8seH = parcelRequire("d8seH");

var $9QePP = parcelRequire("9QePP");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $5sOMZ = parcelRequire("5sOMZ");

var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $7032bd7e5a458ec9$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "multiFilterOperator",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "children"
], $7032bd7e5a458ec9$var$_excluded2 = [
    "InputComponentProps"
];
const $7032bd7e5a458ec9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $7032bd7e5a458ec9$var$GridFilterFormRoot = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm',
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme: theme })=>({
        display: 'flex',
        padding: theme.spacing(1)
    }));
const $7032bd7e5a458ec9$var$FilterFormDeleteIcon = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon',
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme: theme })=>({
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const $7032bd7e5a458ec9$var$FilterFormLogicOperatorInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormLogicOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: 'end'
});
const $7032bd7e5a458ec9$var$FilterFormColumnInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput',
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormOperatorInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput',
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 120
});
const $7032bd7e5a458ec9$var$FilterFormValueInput = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput',
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const $7032bd7e5a458ec9$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $9jXuN.GridLogicOperator).And:
            return 'filterPanelOperatorAnd';
        case (0, $9jXuN.GridLogicOperator).Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $7032bd7e5a458ec9$var$getColumnLabel = (col)=>col.headerName || col.field;
const $7032bd7e5a458ec9$var$collator = new Intl.Collator();
const $7032bd7e5a458ec9$export$4c95feba7016dbe7 = /*#__PURE__*/ $acw62.forwardRef(function GridFilterForm(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2, _baseSelectProps$nati, _rootProps$slotProps3, _rootProps$slotProps4, _rootProps$slotProps5, _rootProps$slotProps6, _rootProps$slotProps7, _rootProps$slotProps8, _currentColumn$filter2;
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, multiFilterOperator: multiFilterOperator, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $9jXuN.GridLogicOperator).And,
        (0, $9jXuN.GridLogicOperator).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {} } = props, other = (0, $1En50.default)(props, $7032bd7e5a458ec9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridFilterableColumnDefinitionsSelector));
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilterModelSelector));
    const columnSelectId = (0, $auC0X.default)();
    const columnSelectLabelId = (0, $auC0X.default)();
    const operatorSelectId = (0, $auC0X.default)();
    const operatorSelectLabelId = (0, $auC0X.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $7032bd7e5a458ec9$var$useUtilityClasses(rootProps);
    const valueRef = $acw62.useRef(null);
    const filterSelectorRef = $acw62.useRef(null);
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseFormControlProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseFormControl) || {};
    const baseSelectProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {};
    const isBaseSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const baseInputLabelProps = ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel) || {};
    const baseSelectOptionProps = ((_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption) || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $1En50.default)(valueInputProps, $7032bd7e5a458ec9$var$_excluded2);
    const filteredColumns = $acw62.useMemo(()=>{
        if (filterColumns === undefined || typeof filterColumns !== 'function') return filterableColumns;
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: (filterModel == null ? void 0 : filterModel.items) || []
        });
        return filterableColumns.filter((column)=>filteredFields.includes(column.field));
    }, [
        filterColumns,
        filterModel == null ? void 0 : filterModel.items,
        filterableColumns,
        item.field
    ]);
    const sortedFilteredColumns = $acw62.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $acw62.useMemo(()=>{
        var _currentColumn$filter;
        if (!item.operator || !currentColumn) return null;
        return (_currentColumn$filter = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $acw62.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseItemValue = !newOperator.InputComponent || newOperator.InputComponent !== (currentOperator == null ? void 0 : currentOperator.InputComponent) || column.type !== currentColumn.type;
        applyFilterChanges((0, $8nd05.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $acw62.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn == null ? void 0 : currentColumn.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !(newOperator != null && newOperator.InputComponent) || (newOperator == null ? void 0 : newOperator.InputComponent) !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
        applyFilterChanges((0, $8nd05.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $acw62.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $9jXuN.GridLogicOperator).And.toString() ? (0, $9jXuN.GridLogicOperator).And : (0, $9jXuN.GridLogicOperator).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        if (rootProps.disableMultipleColumnsFiltering) {
            if (item.value === undefined) deleteFilter(item);
            else // TODO v6: simplify the behavior by always remove the filter form
            applyFilterChanges((0, $8nd05.default)({}, item, {
                value: undefined
            }));
        } else deleteFilter(item);
    };
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator != null && currentOperator.InputComponent) {
                    var _valueRef$current;
                    valueRef == null || (_valueRef$current = valueRef.current) == null || _valueRef$current.focus();
                } else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$GridFilterFormRoot, (0, $8nd05.default)({
        ref: ref,
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormDeleteIcon, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, $9QePP.default)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small"
                }, (_rootProps$slotProps5 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps5.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormLogicOperatorInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, logicOperatorInputProps, {
                sx: (0, $8nd05.default)({
                    display: hasLogicOperatorColumn ? 'flex' : 'none',
                    visibility: showMultiFilterOperators ? 'visible' : 'hidden'
                }, baseFormControlProps.sx || {}, logicOperatorInputProps.sx || {}),
                className: (0, $9QePP.default)(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                    inputProps: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    },
                    value: multiFilterOperator,
                    onChange: changeLogicOperator,
                    disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                    native: isBaseSelectNative
                }, (_rootProps$slotProps6 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps6.baseSelect, {
                    children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                            native: isBaseSelectNative,
                            key: logicOperator.toString(),
                            value: logicOperator.toString()
                        }), apiRef.current.getLocaleText($7032bd7e5a458ec9$var$getLogicOperatorLocaleKey(logicOperator))))
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$FilterFormColumnInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, $9QePP.default)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, baseInputLabelProps, {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelColumns')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText('filterPanelColumns'),
                        value: item.field || '',
                        onChange: changeColumn,
                        native: isBaseSelectNative
                    }, (_rootProps$slotProps7 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps7.baseSelect, {
                        children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: col.field,
                                value: col.field
                            }), $7032bd7e5a458ec9$var$getColumnLabel(col)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$FilterFormOperatorInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, $9QePP.default)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseInputLabel, (0, $8nd05.default)({}, baseInputLabelProps, {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText('filterPanelOperator')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $8nd05.default)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText('filterPanelOperator'),
                        id: operatorSelectId,
                        value: item.operator,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef
                    }, (_rootProps$slotProps8 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps8.baseSelect, {
                        children: currentColumn == null || (_currentColumn$filter2 = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter2.map((operator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $8nd05.default)({}, baseSelectOptionProps, {
                                native: isBaseSelectNative,
                                key: operator.value,
                                value: operator.value
                            }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $gxvzd.default)(operator.value)}`)))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormValueInput, (0, $8nd05.default)({
                variant: "standard",
                as: rootProps.slots.baseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, $9QePP.default)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator != null && currentOperator.InputComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(currentOperator.InputComponent, (0, $8nd05.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef
                }, currentOperator.InputComponentProps, InputComponentProps)) : null
            }))
        ]
    }));
});

});


parcelRegister("jIkp9", function(module, exports) {

$parcel$export(module.exports, "GridFooter", () => $e5a1f44ff53ee1a6$export$6ef0bfefb022d11e);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $k278Q = parcelRequire("k278Q");

var $bDyDY = parcelRequire("bDyDY");

var $fNKx6 = parcelRequire("fNKx6");

var $jgcq7 = parcelRequire("jgcq7");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e5a1f44ff53ee1a6$export$6ef0bfefb022d11e = /*#__PURE__*/ $acw62.forwardRef(function GridFooter(props, ref) {
    var _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridTopLevelRowCountSelector));
    const selectedRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.selectedGridRowsCountSelector));
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridFilteredTopLevelRowCountSelector));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNKx6.GridSelectedRowCount), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footerRowCount, (0, $8nd05.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pagination, (0, $8nd05.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.pagination));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $jgcq7.GridFooterContainer), (0, $8nd05.default)({
        ref: ref
    }, props, {
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});

});
parcelRegister("fNKx6", function(module, exports) {

$parcel$export(module.exports, "GridSelectedRowCount", () => $b80f871a1017d664$export$e4c9f87515ca4b49);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $b80f871a1017d664$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $b80f871a1017d664$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $b80f871a1017d664$var$GridSelectedRowCountRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount',
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2),
        visibility: 'hidden',
        width: 0,
        height: 0,
        [theme.breakpoints.up('sm')]: {
            visibility: 'visible',
            width: 'auto',
            height: 'auto'
        }
    }));
const $b80f871a1017d664$export$e4c9f87515ca4b49 = /*#__PURE__*/ $acw62.forwardRef(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $1En50.default)(props, $b80f871a1017d664$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $b80f871a1017d664$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b80f871a1017d664$var$GridSelectedRowCountRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: rowSelectedText
    }));
});

});

parcelRegister("jgcq7", function(module, exports) {

$parcel$export(module.exports, "GridFooterContainer", () => $e05925554f74d684$export$dc81d5e0847a9805);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e05925554f74d684$var$_excluded = [
    "className"
];
const $e05925554f74d684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $e05925554f74d684$var$GridFooterContainerRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer',
    overridesResolver: (props, styles)=>styles.footerContainer
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $e05925554f74d684$export$dc81d5e0847a9805 = /*#__PURE__*/ $acw62.forwardRef(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $e05925554f74d684$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $e05925554f74d684$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e05925554f74d684$var$GridFooterContainerRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

});


parcelRegister("4YSVE", function(module, exports) {

$parcel$export(module.exports, "GridLoadingOverlay", () => $3a075fc4ca1dcd85$export$69e47a4ea5ffa191);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $2cPwN = parcelRequire("2cPwN");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $3a075fc4ca1dcd85$export$69e47a4ea5ffa191 = /*#__PURE__*/ $acw62.forwardRef(function GridLoadingOverlay(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
    }));
});

});
parcelRegister("2cPwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b4ac261663afa8$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fPJfA.getCircularProgressUtilityClass), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("fPJfA", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $b86eb8364bb4993c$export$29cad1383b3f235d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;

});


parcelRegister("809Ep", function(module, exports) {

$parcel$export(module.exports, "GridOverlay", () => $0180de2e65ebf290$export$1c41ff9dbe11e487);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $0180de2e65ebf290$var$_excluded = [
    "className"
];
const $0180de2e65ebf290$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $0180de2e65ebf290$var$GridOverlayRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay',
    overridesResolver: (_, styles)=>styles.overlay
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const $0180de2e65ebf290$export$1c41ff9dbe11e487 = /*#__PURE__*/ $acw62.forwardRef(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $0180de2e65ebf290$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0180de2e65ebf290$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$var$GridOverlayRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

});


parcelRegister("28JSg", function(module, exports) {

$parcel$export(module.exports, "GridNoRowsOverlay", () => $18efe9c687188074$export$a25f04494ce53510);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $18efe9c687188074$export$a25f04494ce53510 = /*#__PURE__*/ $acw62.forwardRef(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({
        ref: ref
    }, props, {
        children: noRowsLabel
    }));
});

});

parcelRegister("fuqu4", function(module, exports) {

$parcel$export(module.exports, "GridPagination", () => $b46e33860b6061fb$export$fa9a503101f8d472);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $kBtCg = parcelRequire("kBtCg");
var $inBkn = parcelRequire("inBkn");

var $d8seH = parcelRequire("d8seH");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $gPWuj = parcelRequire("gPWuj");

var $ayMG0 = parcelRequire("ayMG0");
const $b46e33860b6061fb$var$GridPaginationRoot = (0, $d8seH.default)((0, $kBtCg.default))(({ theme: theme })=>({
        [`& .${(0, $inBkn.default).selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${(0, $inBkn.default).input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
// A mutable version of a readonly array.
const $b46e33860b6061fb$export$fa9a503101f8d472 = /*#__PURE__*/ $acw62.forwardRef(function GridPagination(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationModelSelector));
    const rowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPaginationRowCountSelector));
    const lastPage = $acw62.useMemo(()=>Math.floor(rowCount / (paginationModel.pageSize || 1)), [
        rowCount,
        paginationModel.pageSize
    ]);
    const handlePageSizeChange = $acw62.useCallback((event)=>{
        const pageSize = Number(event.target.value);
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $acw62.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    var _rootProps$pagination, _rootProps$pagination2;
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46e33860b6061fb$var$GridPaginationRoot, (0, $8nd05.default)({
        ref: ref,
        component: "div",
        count: rowCount,
        page: paginationModel.page <= lastPage ? paginationModel.page : lastPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, apiRef.current.getLocaleText('MuiTablePagination'), props));
});

});
parcelRegister("kBtCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $95gUw = parcelRequire("95gUw");

var $2iAqv = parcelRequire("2iAqv");

var $cX7V2 = parcelRequire("cX7V2");

var $elyLx = parcelRequire("elyLx");

var $kyRsi = parcelRequire("kyRsi");

var $dLLxV = parcelRequire("dLLxV");

var $5A6d3 = parcelRequire("5A6d3");

var $inBkn = parcelRequire("inBkn");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $elyLx.default), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $kyRsi.default), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $inBkn.default).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $inBkn.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $cX7V2.default), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $inBkn.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $inBkn.default).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $inBkn.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $2iAqv.default), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $inBkn.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $dLLxV.default), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $elyLx.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $effe3c7e7b91170d$var$_excluded);
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $elyLx.default) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $5A6d3.default)(selectProps.id);
    const labelId = (0, $5A6d3.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationRoot, (0, $8nd05.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($effe3c7e7b91170d$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelect, (0, $8nd05.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $8nd05.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemComponent, (0, $8nd05.default)({}, !(0, $awhpc.default)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("cX7V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $2xc7G = parcelRequire("2xc7G");

var $c0lH6 = parcelRequire("c0lH6");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $7LRfY = parcelRequire("7LRfY");

var $ab7Se = parcelRequire("ab7Se");

var $iOErJ = parcelRequire("iOErJ");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $ab7Se.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $imehR.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $g4sO2.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7LRfY.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $iOErJ.default) : (0, $c0lH6.default);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $9Rgf1.default)(ref, (0, $2xc7G.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("c0lH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd650259be885cb$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $gzyUk = parcelRequire("gzyUk");

var $jTnBY = parcelRequire("jTnBY");

var $4F5tJ = parcelRequire("4F5tJ");

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bmfPX.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bmfPX.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bmfPX.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bmfPX.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $iOErJ.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $bmfPX.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $iOErJ.nativeSelectIconStyles));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $9Rgf1.default)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $gzyUk.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $auC0X.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), (0, $8nd05.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("4F5tJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $lBOb7 = parcelRequire("lBOb7");

var $6el2W = parcelRequire("6el2W");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $lyHsQ = parcelRequire("lyHsQ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lyHsQ.getMenuUtilityClass), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $6el2W.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $6el2W.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $lBOb7.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $eD6Co.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $eD6Co.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("58lXc", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $3bcebab40d8ce666$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $3bcebab40d8ce666$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $3bcebab40d8ce666$var$_excluded = [
    "value"
];
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $3bcebab40d8ce666$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value != null ? value : false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;

});

parcelRegister("6el2W", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $012baef8dc9ae9d0$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");






var $eD6Co = parcelRequire("eD6Co");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $9Rgf1 = parcelRequire("9Rgf1");

var $iscuz = parcelRequire("iscuz");

var $118QM = parcelRequire("118QM");

var $7Frhn = parcelRequire("7Frhn");

var $k6uEG = parcelRequire("k6uEG");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $k6uEG.getPopoverUtilityClass), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $iscuz.default), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $9Rgf1.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $gzyUk.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9Evvr.default)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $gzyUk.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $eD6Co.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("1iGrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2866359d6621f3$export$2e2bcd8739ae039);

var $aJ8G8 = parcelRequire("aJ8G8");
var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $aJ8G8.default);

});

parcelRegister("9Evvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $707049eb9639aeac$export$2e2bcd8739ae039);

var $9KvVX = parcelRequire("9KvVX");
var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $9KvVX.default);

});

parcelRegister("118QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $kRwxQ = parcelRequire("kRwxQ");

var $2Q995 = parcelRequire("2Q995");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6cr7d = parcelRequire("6cr7d");

var $lkowv = parcelRequire("lkowv");

var $16KGQ = parcelRequire("16KGQ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $16KGQ.getModalUtilityClass), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $lkowv.default)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $eD6Co.default)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("6cr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4838e5a14e330013$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $86f4a = parcelRequire("86f4a");

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7ViEK.getBackdropUtilityClass), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $86f4a.default), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("86f4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");


var $2xc7G = parcelRequire("2xc7G");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;

});

parcelRegister("7ViEK", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $5c4c540114ae85ab$export$9927a91fd93152bd);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;

});


parcelRegister("lkowv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86e7d122c1fa324$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $hPGQj = parcelRequire("hPGQj");
var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $f56pe = parcelRequire("f56pe");

var $75CP6 = parcelRequire("75CP6");
'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $75CP6.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6zeBo.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $13KXh.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $13KXh.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f56pe.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $hPGQj.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $hPGQj.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;

});
parcelRegister("hPGQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("75CP6", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $52971d86e2bcd483$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $52971d86e2bcd483$export$ce11c4ecd08cea67);

var $aF4kJ = parcelRequire("aF4kJ");
var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $6zeBo.default)(container);
    if (doc.body === container) return (0, $9KvVX.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $9KvVX.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $aF4kJ.default)((0, $6zeBo.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6zeBo.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6zeBo.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9KvVX.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("16KGQ", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $0cea91a79e26c98a$export$67960e22b12a638d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;

});


parcelRegister("k6uEG", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $ea2c25a800e729b1$export$88f455dd56c95edb);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;

});


parcelRegister("lyHsQ", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $fb1e7d0ac8fac824$export$2cf86a63a84fe23d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", () => $db2c454fb2e8bc3c$export$c1eccd1617458c87);
$parcel$export(module.exports, "nativeSelectIconStyles", () => $db2c454fb2e8bc3c$export$e7a817afd12a40d0);
$parcel$export(module.exports, "default", () => $db2c454fb2e8bc3c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $6jVRo = parcelRequire("6jVRo");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jVRo.getNativeSelectUtilityClasses), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $6jVRo.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $6jVRo.default).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $6jVRo.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $49a1663d7631a8fa$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("3yddg", function(module, exports) {

$parcel$export(module.exports, "default", () => $295ecbe78b5bad73$export$2e2bcd8739ae039);

var $agZ85 = parcelRequire("agZ85");
'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $agZ85.default);

});

parcelRegister("bmfPX", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $844e08aea9053c4b$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;

});


parcelRegister("ab7Se", function(module, exports) {

$parcel$export(module.exports, "default", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $b3ugU = parcelRequire("b3ugU");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b3ugU.getInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $b3ugU.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $b3ugU.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b3ugU.default).disabled}, .${(0, $b3ugU.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $b3ugU.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;

});

parcelRegister("g4sO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");

var $95gUw = parcelRequire("95gUw");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $faAxf = parcelRequire("faAxf");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $faAxf.getFilledInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $8nd05.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $faAxf.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $faAxf.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $faAxf.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $faAxf.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $faAxf.default).disabled}, .${(0, $faAxf.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $faAxf.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;

});

parcelRegister("imehR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $9ZwEw = parcelRequire("9ZwEw");

var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $96QZi = parcelRequire("96QZi");

var $95gUw = parcelRequire("95gUw");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $96QZi.getOutlinedInputUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $95gUw.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $8nd05.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $96QZi.default).error} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $96QZi.default).disabled} .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $9ZwEw.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseComponent), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $746323a953600e78$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

});



parcelRegister("elyLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");

var $jWrFr = parcelRequire("jWrFr");

var $RbMj7 = parcelRequire("RbMj7");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $ev9nI = parcelRequire("ev9nI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ev9nI.getTableCellUtilityClass), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kSnzZ.lighten)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.88) : (0, $kSnzZ.darken)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $ev9nI.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $jWrFr.default));
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("jWrFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e848e543ed3bf349$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("RbMj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fe163f52c859c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("ev9nI", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;

});


parcelRegister("kyRsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iaUmy.getToolbarUtilityClass), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", () => $d3b4e1a115786e57$export$b12cb262231eef32);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;

});


parcelRegister("dLLxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0648bcf9b9d5e9c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $58lXc = parcelRequire("58lXc");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $9Lykx = parcelRequire("9Lykx");

var $5izos = parcelRequire("5izos");

var $21SL6 = parcelRequire("21SL6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0648bcf9b9d5e9c$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a0648bcf9b9d5e9c$var$_excluded);
    const isRtl = (0, $58lXc.useRtl)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $9Lykx.default);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $9Lykx.default);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $9Lykx.default);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $9Lykx.default);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $21SL6.default);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $5izos.default);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $f46un.default);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $frMNQ.default);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, (0, $8nd05.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, (0, $8nd05.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, (0, $8nd05.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, (0, $8nd05.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;

});
parcelRegister("frMNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ef3be5c947a70a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("f46un", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d495bb1a743bb2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("5izos", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dba169293b5f5f0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("21SL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a626ba35acf52f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});


parcelRegister("5A6d3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4105219ee6538ed1$export$2e2bcd8739ae039);

var $auC0X = parcelRequire("auC0X");
'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $auC0X.default);

});

parcelRegister("inBkn", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", () => $d6175477fd255470$export$909e637b22246f4c);
$parcel$export(module.exports, "default", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;

});



parcelRegister("kfa8b", function(module, exports) {

$parcel$export(module.exports, "GridPanel", () => $ebcd112530bc7823$export$cf917897ad2588b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $kGwBF = parcelRequire("kGwBF");

var $7Frhn = parcelRequire("7Frhn");

var $e76iu = parcelRequire("e76iu");

var $bDyDY = parcelRequire("bDyDY");

var $dMF9H = parcelRequire("dMF9H");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ebcd112530bc7823$var$_excluded = [
    "children",
    "className",
    "classes"
];
const $ebcd112530bc7823$export$e95ad8c1c287de86 = (0, $beCSm.default)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $ebcd112530bc7823$var$GridPanelRoot = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: (props, styles)=>styles.panel
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $ebcd112530bc7823$var$GridPaperRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex'
    }));
const $ebcd112530bc7823$export$cf917897ad2588b = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { children: children, className: className } = props, other = (0, $1En50.default)(props, $ebcd112530bc7823$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $ebcd112530bc7823$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $acw62.useState(false);
    const handleClickAway = $acw62.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if ((0, $dMF9H.isEscapeKey)(event.key)) apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = $acw62.useMemo(()=>[
            {
                name: 'flip',
                enabled: true,
                options: {
                    rootBoundary: 'document'
                }
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        var _apiRef$current$rootE;
        const columnHeadersElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null || (_apiRef$current$rootE = _apiRef$current$rootE.current) == null ? void 0 : _apiRef$current$rootE.querySelector(`.${(0, $5H1vo.gridClasses).columnHeaders}`);
        if (columnHeadersElement) setAnchorEl(columnHeadersElement);
    }, [
        apiRef
    ]);
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelRoot, (0, $8nd05.default)({
        ref: ref,
        placement: "bottom-start",
        className: (0, $9QePP.default)(className, classes.panel),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
            mouseEvent: "onMouseUp",
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});

});

parcelRegister("tZfVk", function(module, exports) {

$parcel$export(module.exports, "GridPreferencesPanel", () => $05a239ae20a1382d$export$6cff59e5608ce17d);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $05a239ae20a1382d$export$6cff59e5608ce17d = /*#__PURE__*/ $acw62.forwardRef(function GridPreferencesPanel(props, ref) {
    var _preferencePanelState, _rootProps$slotProps, _rootProps$slotProps2;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnDefinitionsSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const preferencePanelState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $6X2Yd.gridPreferencePanelStateSelector));
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, (_preferencePanelState = preferencePanelState.openedPanelValue) != null ? _preferencePanelState : (0, $3PCYS.GridPreferencePanelsValue).filters);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.panel, (0, $8nd05.default)({
        ref: ref,
        as: rootProps.slots.basePopper,
        open: columns.length > 0 && preferencePanelState.open,
        id: preferencePanelState.panelId,
        "aria-labelledby": preferencePanelState.labelId
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.panel, props, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.basePopper, {
        children: panelContent
    }));
});

});

parcelRegister("kWPQR", function(module, exports) {

$parcel$export(module.exports, "GridRow", () => $f40172132c7a6c94$export$1fc5a7f035870658);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");
var $3qSdM = parcelRequire("3qSdM");

var $1uCDx = parcelRequire("1uCDx");

var $jkRzp = parcelRequire("jkRzp");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $aJApm = parcelRequire("aJApm");

var $KtEo5 = parcelRequire("KtEo5");

var $5bG6h = parcelRequire("5bG6h");

var $8z2XQ = parcelRequire("8z2XQ");

var $7Z41R = parcelRequire("7Z41R");

var $iU3u2 = parcelRequire("iU3u2");

var $goCyd = parcelRequire("goCyd");

var $hMyIf = parcelRequire("hMyIf");

var $lR3Vo = parcelRequire("lR3Vo");

var $6X2NG = parcelRequire("6X2NG");

var $5Rfo7 = parcelRequire("5Rfo7");

var $ayMG0 = parcelRequire("ayMG0");
const $f40172132c7a6c94$var$_excluded = [
    "selected",
    "hovered",
    "rowId",
    "row",
    "index",
    "style",
    "position",
    "rowHeight",
    "className",
    "visibleColumns",
    "renderedColumns",
    "containerWidth",
    "firstColumnToRender",
    "lastColumnToRender",
    "isLastVisible",
    "focusedCellColumnIndexNotInRange",
    "isNotVisible",
    "focusedCell",
    "tabbableCell",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $f40172132c7a6c94$var$useUtilityClasses = (ownerState)=>{
    const { editable: editable, editing: editing, selected: selected, isLastVisible: isLastVisible, rowHeight: rowHeight, classes: classes } = ownerState;
    const slots = {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isLastVisible && 'row--lastVisible',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $f40172132c7a6c94$var$EmptyCell({ width: width }) {
    if (!width) return null;
    const style = {
        width: width
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `${(0, $5H1vo.gridClasses).cell} ${(0, $5H1vo.gridClasses).withBorderColor}`,
        style: style
    }); // TODO change to .MuiDataGrid-emptyCell or .MuiDataGrid-rowFiller
}
const $f40172132c7a6c94$var$GridRow = /*#__PURE__*/ $acw62.forwardRef(function GridRow(props, refProp) {
    const { selected: selected, hovered: hovered, rowId: rowId, row: row, index: index, style: styleProp, position: position, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, renderedColumns: renderedColumns, containerWidth: containerWidth, firstColumnToRender: firstColumnToRender, isLastVisible: isLastVisible = false, focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange, isNotVisible: isNotVisible, focusedCell: focusedCell, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $1En50.default)(props, $f40172132c7a6c94$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ref = $acw62.useRef(null);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, rootProps);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnsTotalWidthSelector));
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortModelSelector));
    const treeDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowMaximumTreeDepthSelector));
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector));
    const editRowsState = (0, $5sOMZ.useGridSelector)(apiRef, (0, $5Rfo7.gridEditRowsStateSelector));
    const handleRef = (0, $3qSdM.default)(ref, refProp);
    const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
    const ownerState = {
        selected: selected,
        hovered: hovered,
        isLastVisible: isLastVisible,
        classes: rootProps.classes,
        editing: apiRef.current.getRowMode(rowId) === (0, $jkRzp.GridRowModes).Edit,
        editable: rootProps.editMode === (0, $jkRzp.GridEditModes).Row,
        rowHeight: rowHeight
    };
    const classes = $f40172132c7a6c94$var$useUtilityClasses(ownerState);
    $acw62.useLayoutEffect(()=>{
        if (rowHeight === 'auto' && ref.current && typeof ResizeObserver === 'undefined') // Fallback for IE
        apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight, position);
    }, [
        apiRef,
        rowHeight,
        rowId,
        position
    ]);
    $acw62.useLayoutEffect(()=>{
        if (currentPage.range) {
            // The index prop is relative to the rows from all pages. As example, the index prop of the
            // first row is 5 if `paginationModel.pageSize=5` and `paginationModel.page=1`. However, the index used by the virtualization
            // doesn't care about pagination and considers the rows from the current page only, so the
            // first row always has index=0. We need to subtract the index of the first row to make it
            // compatible with the index used by the virtualization.
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // pinned rows are not part of the visible rows
            if (rowIndex != null) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        const rootElement = ref.current;
        const hasFixedHeight = rowHeight !== 'auto';
        if (!rootElement || hasFixedHeight || typeof ResizeObserver === 'undefined') return undefined;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.unstable_storeRowHeightMeasurement(rowId, height, position);
        });
        resizeObserver.observe(rootElement);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        currentPage.range,
        index,
        rowHeight,
        rowId,
        position
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $acw62.useCallback((event)=>{
        const cell = (0, $KtEo5.findParentElementFromClassName)(event.target, (0, $5H1vo.gridClasses).cell);
        const field = cell == null ? void 0 : cell.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF).field) return;
            // User opened a detail panel
            if (field === (0, $7Z41R.GRID_DETAIL_PANEL_TOGGLE_FIELD)) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $jkRzp.GridCellModes).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if ((column == null ? void 0 : column.type) === (0, $8z2XQ.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const CellComponent = slots.cell === (0, $6X2NG.GridCellV7) ? (0, $6X2NG.GridCellV7) : (0, $6X2NG.GridCellWrapper);
    const rowReordering = rootProps.rowReordering;
    const getCell = (column, cellProps)=>{
        var _editRowsState$rowId$, _editRowsState$rowId;
        const disableDragEvents = disableColumnReorder && column.disableReorder || !rowReordering && !!sortModel.length && treeDepth > 1 && Object.keys(editRowsState).length > 0;
        const editCellState = (_editRowsState$rowId$ = (_editRowsState$rowId = editRowsState[rowId]) == null ? void 0 : _editRowsState$rowId[column.field]) != null ? _editRowsState$rowId$ : null;
        let cellIsNotVisible = false;
        if (focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) cellIsNotVisible = true;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(CellComponent, (0, $8nd05.default)({
            column: column,
            width: cellProps.width,
            rowId: rowId,
            height: rowHeight,
            showRightBorder: cellProps.showRightBorder,
            align: column.align || 'left',
            colIndex: cellProps.indexRelativeToAllColumns,
            colSpan: cellProps.colSpan,
            disableDragEvents: disableDragEvents,
            editCellState: editCellState,
            isNotVisible: cellIsNotVisible
        }, slotProps == null ? void 0 : slotProps.cell), column.field);
    };
    const sizes = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $8nd05.default)({}, apiRef.current.unstable_getRowInternalSizes(rowId)), (0, $5sOMZ.objectShallowCompare));
    let minHeight = rowHeight;
    if (minHeight === 'auto' && sizes) {
        let numberOfBaseSizes = 0;
        const maximumSize = Object.entries(sizes).reduce((acc, [key, size])=>{
            const isBaseHeight = /^base[A-Z]/.test(key);
            if (!isBaseHeight) return acc;
            numberOfBaseSizes += 1;
            if (size > acc) return size;
            return acc;
        }, 0);
        if (maximumSize > 0 && numberOfBaseSizes > 1) minHeight = maximumSize;
    }
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $8nd05.default)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            minHeight: // max-height doesn't support "auto"
            minHeight
        });
        if (sizes != null && sizes.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = sizes.spacingTop;
        }
        if (sizes != null && sizes.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += sizes.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        minHeight,
        sizes,
        rootProps.rowSpacingType
    ]);
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    if (typeof rootProps.getRowClassName === 'function') {
        var _currentPage$range;
        const indexRelativeToCurrentPage = index - (((_currentPage$range = currentPage.range) == null ? void 0 : _currentPage$range.firstRowIndex) || 0);
        const rowParams = (0, $8nd05.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const randomNumber = (0, $lR3Vo.randomNumberBetween)(10000, 20, 80);
    const rowNode = apiRef.current.getRowNode(rowId);
    if (!rowNode) return null;
    const rowType = rowNode.type;
    const cells = [];
    for(let i = 0; i < renderedColumns.length; i += 1){
        const column = renderedColumns[i];
        let indexRelativeToAllColumns = firstColumnToRender + i;
        if (focusedCellColumnIndexNotInRange !== undefined && focusedCell) {
            if (visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) indexRelativeToAllColumns = focusedCellColumnIndexNotInRange;
            else indexRelativeToAllColumns -= 1;
        }
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) {
            if (rowType !== 'skeletonRow') {
                const { colSpan: colSpan, width: width } = cellColSpanInfo.cellProps;
                const cellProps = {
                    width: width,
                    colSpan: colSpan,
                    showRightBorder: rootProps.showCellVerticalBorder,
                    indexRelativeToAllColumns: indexRelativeToAllColumns
                };
                cells.push(getCell(column, cellProps));
            } else {
                const { width: width } = cellColSpanInfo.cellProps;
                const contentWidth = Math.round(randomNumber());
                cells.push(/*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    width: width,
                    contentWidth: contentWidth,
                    field: column.field,
                    align: column.align
                }, column.field));
            }
        }
    }
    const emptyCellWidth = containerWidth - columnsTotalWidth;
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: handleRef,
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $9QePP.default)(...rowClassNames, classes.root, className, hovered && 'Mui-hovered'),
        "aria-rowindex": ariaRowIndex,
        "aria-selected": selected,
        style: style
    }, eventHandlers, other, {
        children: [
            cells,
            emptyCellWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($f40172132c7a6c94$var$EmptyCell, {
                width: emptyCellWidth
            })
        ]
    }));
});
const $f40172132c7a6c94$export$1fc5a7f035870658 = (0, $1uCDx.fastMemo)($f40172132c7a6c94$var$GridRow);

});
parcelRegister("1uCDx", function(module, exports) {

$parcel$export(module.exports, "fastMemo", () => $116690367be9ad3f$export$fa306e0bc9a9d6b4);

var $acw62 = parcelRequire("acw62");

var $arRb5 = parcelRequire("arRb5");
function $116690367be9ad3f$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $acw62.memo(component, (0, $arRb5.fastObjectShallowCompare));
}

});

parcelRegister("6X2NG", function(module, exports) {

$parcel$export(module.exports, "GridCellWrapper", () => $50fa6cd6ff946acb$export$fc5dd9c3875d4ace);
$parcel$export(module.exports, "GridCellV7", () => $50fa6cd6ff946acb$export$c5671ad6c68d814);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $1uCDx = parcelRequire("1uCDx");

var $g2vKb = parcelRequire("g2vKb");

var $5H1vo = parcelRequire("5H1vo");

var $jkRzp = parcelRequire("jkRzp");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $6p8lp = parcelRequire("6p8lp");

var $ayMG0 = parcelRequire("ayMG0");
const $50fa6cd6ff946acb$var$_excluded = [
    "changeReason",
    "unstable_updateValueOnRender"
], $50fa6cd6ff946acb$var$_excluded2 = [
    "align",
    "children",
    "editCellState",
    "colIndex",
    "column",
    "cellMode",
    "field",
    "formattedValue",
    "hasFocus",
    "height",
    "isEditable",
    "isSelected",
    "rowId",
    "tabIndex",
    "style",
    "value",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $50fa6cd6ff946acb$var$_excluded3 = [
    "column",
    "rowId",
    "editCellState",
    "align",
    "children",
    "colIndex",
    "height",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver",
    "style"
], $50fa6cd6ff946acb$var$_excluded4 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $50fa6cd6ff946acb$var$EMPTY_CELL_PARAMS = {
    id: -1,
    field: '__unset__',
    row: {},
    rowNode: {
        id: -1,
        depth: 0,
        type: 'leaf',
        parent: -1,
        groupingKey: null
    },
    colDef: {
        type: 'string',
        field: '__unset__',
        computedWidth: 0
    },
    cellMode: (0, $jkRzp.GridCellModes).View,
    hasFocus: false,
    tabIndex: -1,
    value: null,
    formattedValue: '__unset__',
    isEditable: false,
    api: {}
};
const $50fa6cd6ff946acb$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showRightBorder: showRightBorder, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $gxvzd.default)(align)}`,
            isEditable && 'cell--editable',
            isSelected && 'selected',
            showRightBorder && 'cell--withRightBorder',
            isSelectionMode && !isEditable && 'cell--selectionMode',
            'withBorderColor'
        ],
        content: [
            'cellContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
let $50fa6cd6ff946acb$var$warnedOnce = false;
// GridCellWrapper is a compatibility layer for the V6 cell slot. If we can use the more efficient
// `GridCellV7`, we should. That component is a merge of `GridCellWrapper` and `GridCell`.
// TODO(v7): Remove the wrapper & cellV6 and use the cellV7 exclusively.
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $50fa6cd6ff946acb$var$GridCellWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { column: column, rowId: rowId, editCellState: editCellState } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const field = column.field;
    const cellParamsWithAPI = (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
        // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
        // associated with `rowId`/`fieldId`, but this selector runs after the state has been
        // updated, while `rowId`/`fieldId` reference an entry in the old state.
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof (0, $6p8lp.MissingRowIdError)) return $50fa6cd6ff946acb$var$EMPTY_CELL_PARAMS;
            throw e;
        }
    }, (0, $5sOMZ.objectShallowCompare));
    const isSelected = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    if (cellParamsWithAPI === $50fa6cd6ff946acb$var$EMPTY_CELL_PARAMS) return null;
    const { cellMode: cellMode, hasFocus: hasFocus, isEditable: isEditable, value: value, formattedValue: formattedValue } = cellParamsWithAPI;
    const managesOwnFocus = column.type === 'actions';
    const tabIndex = (cellMode === 'view' || !isEditable) && !managesOwnFocus ? cellParamsWithAPI.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field: field
    });
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    let children;
    if (editCellState == null && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push((0, $5H1vo.gridClasses)['cell--withRenderer']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (editCellState != null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $1En50.default)(editCellState, $50fa6cd6ff946acb$var$_excluded);
        const params = (0, $8nd05.default)({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $5H1vo.gridClasses)['cell--editing']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
    }
    const { slots: slots } = rootProps;
    const CellComponent = slots.cell;
    const cellProps = (0, $8nd05.default)({}, props, {
        ref: ref,
        field: field,
        formattedValue: formattedValue,
        hasFocus: hasFocus,
        isEditable: isEditable,
        isSelected: isSelected,
        value: value,
        cellMode: cellMode,
        children: children,
        tabIndex: tabIndex,
        className: (0, $9QePP.default)(classNames)
    });
    return /*#__PURE__*/ $acw62.createElement(CellComponent, cellProps);
});
const $50fa6cd6ff946acb$export$1ce951ee41d30605 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _rootProps$experiment, _rootProps$experiment2;
    const { align: align, children: childrenProp, colIndex: colIndex, column: column, cellMode: cellMode, field: field, formattedValue: formattedValue, hasFocus: hasFocus, height: height, isEditable: isEditable, isSelected: isSelected, rowId: rowId, tabIndex: tabIndex, style: styleProp, value: value, width: width, className: className, showRightBorder: showRightBorder, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $1En50.default)(props, $50fa6cd6ff946acb$var$_excluded2);
    const valueToRender = formattedValue == null ? value : formattedValue;
    const cellRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, cellRef);
    const focusElementRef = $acw62.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        align: align,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        isSelected: isSelected
    };
    const classes = $50fa6cd6ff946acb$var$useUtilityClasses(ownerState);
    const publishMouseUp = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        };
        const cellStyle = (0, $8nd05.default)({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: height === 'auto' ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $jkRzp.GridCellModes).Edit) return;
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    let handleFocus = other.onFocus;
    var event;
    const managesOwnFocus = column.type === 'actions';
    let children = childrenProp;
    if (children === undefined) {
        const valueString = valueToRender == null ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ $acw62.isValidElement(children) && managesOwnFocus) children = /*#__PURE__*/ $acw62.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = (_rootProps$experiment2 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment2.ariaV7;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        ref: handleRef,
        className: (0, $9QePP.default)(className, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    })));
});
const $50fa6cd6ff946acb$export$fc5dd9c3875d4ace = (0, $1uCDx.fastMemo)($50fa6cd6ff946acb$var$GridCellWrapper);
const $50fa6cd6ff946acb$var$GridCellV7 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _getActions, _ref, _rootProps$unstable_c, _rootProps$experiment3, _rootProps$experiment4;
    const { column: column, rowId: rowId, editCellState: editCellState, align: align, colIndex: colIndex, height: height, width: width, className: className, showRightBorder: showRightBorder, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver, style: styleProp } = props, other = (0, $1En50.default)(props, $50fa6cd6ff946acb$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const field = column.field;
    const cellParamsWithAPI = (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
        // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
        // associated with `rowId`/`fieldId`, but this selector runs after the state has been
        // updated, while `rowId`/`fieldId` reference an entry in the old state.
        try {
            const cellParams = apiRef.current.getCellParams(rowId, field);
            const result = cellParams;
            result.api = apiRef.current;
            return result;
        } catch (e) {
            if (e instanceof (0, $6p8lp.MissingRowIdError)) return $50fa6cd6ff946acb$var$EMPTY_CELL_PARAMS;
            throw e;
        }
    }, (0, $5sOMZ.objectShallowCompare));
    const isSelected = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const { cellMode: cellMode, hasFocus: hasFocus, isEditable: isEditable, value: value, formattedValue: formattedValue } = cellParamsWithAPI;
    const canManageOwnFocus = column.type === 'actions' && ((_getActions = (_ref = column).getActions) == null ? void 0 : _getActions.call(_ref, apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled));
    const tabIndex = (cellMode === 'view' || !isEditable) && !canManageOwnFocus ? cellParamsWithAPI.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
        id: rowId,
        field: field
    });
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
    if (getCellClassName) classNames.push(getCellClassName(cellParamsWithAPI));
    const valueToRender = formattedValue == null ? value : formattedValue;
    const cellRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, cellRef);
    const focusElementRef = $acw62.useRef(null);
    // @ts-expect-error To access `unstable_cellSelection` flag as it's a `premium` feature
    const isSelectionMode = (_rootProps$unstable_c = rootProps.unstable_cellSelection) != null ? _rootProps$unstable_c : false;
    const ownerState = {
        align: align,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $50fa6cd6ff946acb$var$useUtilityClasses(ownerState);
    const publishMouseUp = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return (0, $8nd05.default)({
            padding: 0,
            opacity: 0,
            width: 0,
            border: 0
        }, styleProp);
        const cellStyle = (0, $8nd05.default)({
            minWidth: width,
            maxWidth: width,
            minHeight: height,
            maxHeight: height === 'auto' ? 'none' : height
        }, styleProp);
        return cellStyle;
    }, [
        width,
        height,
        isNotVisible,
        styleProp
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $jkRzp.GridCellModes).Edit) return;
        const doc = (0, $6zeBo.default)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (cellParamsWithAPI === $50fa6cd6ff946acb$var$EMPTY_CELL_PARAMS) return null;
    let handleFocus = other.onFocus;
    var event;
    let children;
    if (editCellState == null && column.renderCell) {
        children = column.renderCell(cellParamsWithAPI);
        classNames.push((0, $5H1vo.gridClasses)['cell--withRenderer']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
    }
    if (editCellState != null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $1En50.default)(editCellState, $50fa6cd6ff946acb$var$_excluded4);
        const params = (0, $8nd05.default)({}, cellParamsWithAPI, {
            row: updatedRow
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $5H1vo.gridClasses)['cell--editing']);
        classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender == null ? void 0 : valueToRender.toString();
        children = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes.content,
            title: valueString,
            role: "presentation",
            children: valueString
        });
    }
    if (/*#__PURE__*/ $acw62.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $acw62.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    const ariaV7 = (_rootProps$experiment4 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment4.ariaV7;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        ref: handleRef,
        className: (0, $9QePP.default)(className, classNames, classes.root),
        role: ariaV7 ? 'gridcell' : 'cell',
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: children
    })));
});
const $50fa6cd6ff946acb$export$c5671ad6c68d814 = (0, $1uCDx.fastMemo)($50fa6cd6ff946acb$var$GridCellV7);

});
parcelRegister("g2vKb", function(module, exports) {

$parcel$export(module.exports, "doesSupportPreventScroll", () => $bad574edb71acea7$export$ed1f8daf96fc68fb);
// Based on https://stackoverflow.com/a/59518678
let $bad574edb71acea7$var$cachedSupportsPreventScroll;
function $bad574edb71acea7$export$ed1f8daf96fc68fb() {
    if ($bad574edb71acea7$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $bad574edb71acea7$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $bad574edb71acea7$var$cachedSupportsPreventScroll;
}

});



parcelRegister("l3iPY", function(module, exports) {

$parcel$export(module.exports, "GridRowCount", () => $f5387d79a8532a8d$export$b92875c9af3e0a77);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f5387d79a8532a8d$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $f5387d79a8532a8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $f5387d79a8532a8d$var$GridRowCountRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount',
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme: theme })=>({
        alignItems: 'center',
        display: 'flex',
        margin: theme.spacing(0, 2)
    }));
const $f5387d79a8532a8d$export$b92875c9af3e0a77 = /*#__PURE__*/ $acw62.forwardRef(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $1En50.default)(props, $f5387d79a8532a8d$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $f5387d79a8532a8d$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f5387d79a8532a8d$var$GridRowCountRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});

});

parcelRegister("etLiE", function(module, exports) {

$parcel$export(module.exports, "GridSkeletonCell", () => $a8a876e822978977$export$d922c88d466d9c21);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $5RIww = parcelRequire("5RIww");

var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a8a876e822978977$var$_excluded = [
    "field",
    "align",
    "width",
    "contentWidth"
];
const $a8a876e822978977$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${(0, $gxvzd.default)(align)}`,
            'withBorderColor'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $a8a876e822978977$export$d922c88d466d9c21(props) {
    const { align: align, width: width, contentWidth: contentWidth } = props, other = (0, $1En50.default)(props, $a8a876e822978977$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        align: align
    };
    const classes = $a8a876e822978977$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        className: classes.root,
        style: {
            width: width
        }
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
            width: `${contentWidth}%`
        })
    }));
}

});
parcelRegister("5RIww", function(module, exports) {

$parcel$export(module.exports, "default", () => $445470756a9ff70a$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $jjlaj = parcelRequire("jjlaj");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");
var $18jQK = parcelRequire("18jQK");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bWvDT = parcelRequire("bWvDT");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $445470756a9ff70a$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $445470756a9ff70a$var$_ = (t)=>t, $445470756a9ff70a$var$_t, $445470756a9ff70a$var$_t2, $445470756a9ff70a$var$_t3, $445470756a9ff70a$var$_t4;
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bWvDT.getSkeletonUtilityClass), classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t || ($445470756a9ff70a$var$_t = $445470756a9ff70a$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $445470756a9ff70a$var$waveKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t2 || ($445470756a9ff70a$var$_t2 = $445470756a9ff70a$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $445470756a9ff70a$var$SkeletonRoot = (0, $d8seH.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $18jQK.getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $18jQK.toUnitless)(theme.shape.borderRadius);
    return (0, $8nd05.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $jgarO.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $jjlaj.css)($445470756a9ff70a$var$_t3 || ($445470756a9ff70a$var$_t3 = $445470756a9ff70a$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $445470756a9ff70a$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $jjlaj.css)($445470756a9ff70a$var$_t4 || ($445470756a9ff70a$var$_t4 = $445470756a9ff70a$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $445470756a9ff70a$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $1En50.default)(props, $445470756a9ff70a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $8nd05.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $445470756a9ff70a$export$2e2bcd8739ae039 = $445470756a9ff70a$var$Skeleton;

});
parcelRegister("18jQK", function(module, exports) {

$parcel$export(module.exports, "getUnit", () => $0d35ef8a52a98e99$export$65f2564e9a9b9222);
$parcel$export(module.exports, "toUnitless", () => $0d35ef8a52a98e99$export$8af1d214c6c2f0f1);
function $0d35ef8a52a98e99$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0d35ef8a52a98e99$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0d35ef8a52a98e99$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0d35ef8a52a98e99$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0d35ef8a52a98e99$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("bWvDT", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", () => $8b1da808c4852549$export$c987db9fc844f86);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8b1da808c4852549$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$export$2e2bcd8739ae039 = $8b1da808c4852549$var$skeletonClasses;

});



parcelRegister("sLaj5", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaders", () => $056733ac91e6ea07$export$4a3a74c44d0a6c04);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $1uCDx = parcelRequire("1uCDx");

var $hlKix = parcelRequire("hlKix");

var $2fAdp = parcelRequire("2fAdp");

var $9Oyj3 = parcelRequire("9Oyj3");

var $ayMG0 = parcelRequire("ayMG0");
const $056733ac91e6ea07$var$_excluded = [
    "innerRef",
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnPositions",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "densityFactor",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $056733ac91e6ea07$var$GridColumnHeaders = /*#__PURE__*/ $acw62.forwardRef(function GridColumnsHeaders(props, ref) {
    const { innerRef: innerRef, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnPositions: columnPositions, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, densityFactor: densityFactor, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $1En50.default)(props, $056733ac91e6ea07$var$_excluded);
    const { isDragging: isDragging, getRootProps: getRootProps, getInnerProps: getInnerProps, getColumnHeaders: getColumnHeaders, getColumnGroupHeaders: getColumnGroupHeaders } = (0, $hlKix.useGridColumnHeaders)({
        innerRef: innerRef,
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnPositions: columnPositions,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        densityFactor: densityFactor,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fAdp.GridBaseColumnHeaders), (0, $8nd05.default)({
        ref: ref
    }, getRootProps(other), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9Oyj3.GridColumnHeadersInner), (0, $8nd05.default)({
            isDragging: isDragging
        }, getInnerProps(), {
            children: [
                getColumnGroupHeaders(),
                getColumnHeaders()
            ]
        }))
    }));
});
const $056733ac91e6ea07$export$4a3a74c44d0a6c04 = (0, $1uCDx.fastMemo)($056733ac91e6ea07$var$GridColumnHeaders);

});
parcelRegister("hlKix", function(module, exports) {

$parcel$export(module.exports, "useGridColumnHeaders", () => $ca184fa0bded5702$export$dd7dbc7d3ee10272);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3qSdM = parcelRequire("3qSdM");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");
parcelRequire("6SpLG");
var $9EdUm = parcelRequire("9EdUm");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $eFF1m = parcelRequire("eFF1m");

var $bfoLE = parcelRequire("bfoLE");

var $i0LyH = parcelRequire("i0LyH");

var $aJApm = parcelRequire("aJApm");

var $fHEg1 = parcelRequire("fHEg1");

var $9upDV = parcelRequire("9upDV");

var $kAYrj = parcelRequire("kAYrj");

var $ayMG0 = parcelRequire("ayMG0");
const $ca184fa0bded5702$var$GridColumnHeaderRow = (0, $d8seH.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow',
    overridesResolver: (props, styles)=>styles.columnHeaderRow
})(()=>({
        display: 'flex'
    }));
function $ca184fa0bded5702$var$isUIEvent(event) {
    return !!event.target;
}
const $ca184fa0bded5702$export$dd7dbc7d3ee10272 = (props)=>{
    const { innerRef: innerRefProp, minColumnIndex: minColumnIndex = 0, visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnPositions: columnPositions, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, densityFactor: densityFactor, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const theme = (0, $14H9o.default)();
    const [dragCol, setDragCol] = $acw62.useState('');
    const [resizeCol, setResizeCol] = $acw62.useState('');
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const hasVirtualization = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridVirtualizationColumnEnabledSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const innerRef = $acw62.useRef(null);
    const handleInnerRef = (0, $3qSdM.default)(innerRefProp, innerRef);
    const [renderContext, setRenderContextRaw] = $acw62.useState(null);
    const prevRenderContext = $acw62.useRef(renderContext);
    const prevScrollLeft = $acw62.useRef(0);
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, rootProps);
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps.columnHeaderHeight);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const setRenderContext = $acw62.useCallback((nextRenderContext)=>{
        if (renderContext && nextRenderContext && (0, $fHEg1.areRenderContextsEqual)(renderContext, nextRenderContext)) return;
        setRenderContextRaw(nextRenderContext);
    }, [
        renderContext
    ]);
    $acw62.useEffect(()=>{
        var _apiRef$current$colum;
        if ((_apiRef$current$colum = apiRef.current.columnHeadersContainerElementRef) != null && _apiRef$current$colum.current) apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }, [
        apiRef
    ]);
    // memoize `getFirstColumnIndexToRender`, since it's called on scroll
    const getFirstColumnIndexToRenderRef = $acw62.useRef((0, $9EdUm.defaultMemoize)((0, $i0LyH.getFirstColumnIndexToRender), {
        equalityCheck: (a, b)=>[
                'firstColumnIndex',
                'minColumnIndex',
                'columnBuffer'
            ].every((key)=>a[key] === b[key])
    }));
    const updateInnerPosition = $acw62.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = (0, $fHEg1.getRenderableIndexes)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minColumnIndex,
            columnBuffer: rootProps.columnBuffer,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            apiRef: apiRef,
            visibleRows: currentPage.rows
        });
        const direction = theme.direction === 'ltr' ? 1 : -1;
        const offset = firstColumnToRender > 0 ? prevScrollLeft.current - direction * columnPositions[firstColumnToRender] : prevScrollLeft.current;
        innerRef.current.style.transform = `translate3d(${-offset}px, 0px, 0px)`;
    }, [
        columnPositions,
        minColumnIndex,
        rootProps.columnBuffer,
        apiRef,
        currentPage.rows,
        rootProps.rowBuffer,
        theme.direction
    ]);
    $acw62.useLayoutEffect(()=>{
        if (renderContext) updateInnerPosition(renderContext);
    }, [
        renderContext,
        updateInnerPosition
    ]);
    const handleScroll = $acw62.useCallback(({ left: left, renderContext: nextRenderContext = null }, event)=>{
        var _prevRenderContext$cu, _prevRenderContext$cu2;
        if (!innerRef.current) return;
        // Ignore vertical scroll.
        // Excepts the first event which sets the previous render context.
        if (prevScrollLeft.current === left && ((_prevRenderContext$cu = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu.firstColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.firstColumnIndex) && ((_prevRenderContext$cu2 = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu2.lastColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.lastColumnIndex)) return;
        prevScrollLeft.current = left;
        // We can only update the position when we guarantee that the render context has been
        // rendered. This is achieved using ReactDOM.flushSync or when the context doesn't change.
        let canUpdateInnerPosition = false;
        if (nextRenderContext !== prevRenderContext.current || !prevRenderContext.current) {
            // ReactDOM.flushSync cannot be called on `scroll` events fired inside effects
            if ($ca184fa0bded5702$var$isUIEvent(event)) {
                // To prevent flickering, the inner position can only be updated after the new context has
                // been rendered. ReactDOM.flushSync ensures that the state changes will happen before
                // updating the position.
                $1u0KT.flushSync(()=>{
                    setRenderContext(nextRenderContext);
                });
                canUpdateInnerPosition = true;
            } else setRenderContext(nextRenderContext);
            prevRenderContext.current = nextRenderContext;
        } else canUpdateInnerPosition = true;
        // Pass directly the render context to avoid waiting for the next render
        if (nextRenderContext && canUpdateInnerPosition) updateInnerPosition(nextRenderContext);
    }, [
        updateInnerPosition,
        setRenderContext
    ]);
    const handleColumnResizeStart = $acw62.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $acw62.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $acw62.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $acw62.useCallback(()=>setDragCol(''), []);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'scrollPositionChange', handleScroll);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: nextRenderContext = renderContext, minFirstColumn: minFirstColumn = minColumnIndex, maxLastColumn: maxLastColumn = visibleColumns.length } = params || {};
        if (!nextRenderContext) return null;
        const [firstRowToRender, lastRowToRender] = (0, $fHEg1.getRenderableIndexes)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = !hasVirtualization ? 0 : getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minFirstColumn,
            columnBuffer: rootProps.columnBuffer,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        const lastColumnToRender = !hasVirtualization ? maxLastColumn : Math.min(nextRenderContext.lastColumnIndex + rootProps.columnBuffer, maxLastColumn);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender,
            minFirstColumn: minFirstColumn,
            maxLastColumn: maxLastColumn
        };
    };
    const getColumnHeaders = (params, other = {})=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null) return null;
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = columnsToRender;
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            columns.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfoLE.GridColumnHeaderItem), (0, $8nd05.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            }, other), colDef.field));
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ca184fa0bded5702$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            children: columns
        });
    };
    const getColumnGroupHeaders = (params)=>{
        if (headerGroupingMaxDepth === 0) return null;
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null || columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const columns = [];
        const headerToRender = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1){
            var _apiRef$current$unsta, _apiRef$current$unsta2;
            const rowStructure = columnGroupsHeaderStructure[depth];
            const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
            const firstGroupToRender = (_apiRef$current$unsta = apiRef.current.unstable_getColumnGroupPath(firstColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta : null;
            const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
            const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
            const lastGroupToRender = (_apiRef$current$unsta2 = apiRef.current.unstable_getColumnGroupPath(lastColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta2 : null;
            const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
            const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
                return (0, $8nd05.default)({}, groupStructure, {
                    columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
                });
            }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
            const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
            const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
            const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
                var _column$computedWidth;
                const column = apiRef.current.getColumn(field);
                return acc + ((_column$computedWidth = column.computedWidth) != null ? _column$computedWidth : 0);
            }, 0);
            let columnIndex = firstColumnToRender;
            const elements = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields })=>{
                const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
                const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
                const headerInfo = {
                    groupId: groupId,
                    width: columnFields.reduce((acc, field)=>acc + apiRef.current.getColumn(field).computedWidth, 0),
                    fields: columnFields,
                    colIndex: columnIndex,
                    hasFocus: hasFocus,
                    tabIndex: tabIndex
                };
                columnIndex += columnFields.length;
                return headerInfo;
            });
            headerToRender.push({
                leftOverflow: leftOverflow,
                elements: elements
            });
        }
        headerToRender.forEach((depthInfo, depthIndex)=>{
            columns.push(/*#__PURE__*/ (0, $ayMG0.jsx)($ca184fa0bded5702$var$GridColumnHeaderRow, {
                style: {
                    height: `${headerHeight}px`,
                    transform: `translateX(-${depthInfo.leftOverflow}px)`
                },
                role: "row",
                "aria-rowindex": depthIndex + 1,
                ownerState: rootProps,
                children: depthInfo.elements.map(({ groupId: groupId, width: width, fields: fields, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex }, groupIndex)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kAYrj.GridColumnGroupHeader), {
                        groupId: groupId,
                        width: width,
                        fields: fields,
                        colIndex: colIndex,
                        depth: depthIndex,
                        isLastColumn: colIndex === visibleColumns.length - fields.length,
                        maxDepth: headerToRender.length,
                        height: headerHeight,
                        hasFocus: hasFocus,
                        tabIndex: tabIndex
                    }, groupIndex);
                })
            }, depthIndex));
        });
        return columns;
    };
    const rootStyle = {
        minHeight: totalHeaderHeight,
        maxHeight: totalHeaderHeight,
        lineHeight: `${headerHeight}px`
    };
    return {
        renderContext: renderContext,
        getColumnHeaders: getColumnHeaders,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeaders: getColumnGroupHeaders,
        isDragging: !!dragCol,
        getRootProps: (other = {})=>(0, $8nd05.default)({
                style: rootStyle
            }, other),
        getInnerProps: ()=>({
                ref: handleInnerRef,
                role: 'rowgroup'
            }),
        headerHeight: headerHeight
    };
};

});
parcelRegister("bfoLE", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderItem", () => $83044eba4b8e40dc$export$10f6faff2f47edd);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $er55f = parcelRequire("er55f");

var $960Cz = parcelRequire("960Cz");

var $6ZYGg = parcelRequire("6ZYGg");

var $le8d8 = parcelRequire("le8d8");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $ayMG0 = parcelRequire("ayMG0");
const $83044eba4b8e40dc$var$useUtilityClasses = (ownerState)=>{
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, filterItemsCounter: filterItemsCounter } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            colDef.sortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $83044eba4b8e40dc$export$10f6faff2f47edd(props) {
    var _rootProps$slotProps, _colDef$sortingOrder, _rootProps$slotProps2, _colDef$headerName;
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $acw62.useRef(null);
    const columnMenuId = (0, $auC0X.default)();
    const columnMenuButtonId = (0, $auC0X.default)();
    const iconButtonRef = $acw62.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $acw62.useState(columnMenuOpen);
    const isDraggable = $acw62.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: rootProps.showColumnVerticalBorder
    });
    const classes = $83044eba4b8e40dc$var$useUtilityClasses(ownerState);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $acw62.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEnd: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $acw62.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $acw62.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $acw62.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ZYGg.ColumnHeaderMenuIcon), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $le8d8.GridColumnHeaderMenu), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $8nd05.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.columnHeaderFilterIconButton)),
            colDef.sortable && !colDef.hideSortIcons && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $960Cz.GridColumnHeaderSortIcon), {
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder
            })
        ]
    });
    $acw62.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            var _apiRef$current$colum;
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            if ((_apiRef$current$colum = apiRef.current.columnHeadersContainerElementRef) != null && _apiRef$current$colum.current) apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = (_colDef$headerName = colDef.headerName) != null ? _colDef$headerName : colDef.field;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cOaX.GridGenericColumnHeaderItem), (0, $8nd05.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: headerClassName,
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps
    }, mouseEventsHandlers));
}

});
parcelRegister("960Cz", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderSortIcon", () => $69f527f26ff57ed6$export$80cd75c5dceceac6);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $fagfG = parcelRequire("fagfG");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $j4crP = parcelRequire("j4crP");

var $ayMG0 = parcelRequire("ayMG0");
const $69f527f26ff57ed6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'sortIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $69f527f26ff57ed6$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw(props) {
    var _rootProps$slotProps;
    const { direction: direction, index: index, sortingOrder: sortingOrder } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $69f527f26ff57ed6$var$useUtilityClasses(ownerState);
    const iconElement = $69f527f26ff57ed6$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small"
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j4crP.GridIconButtonContainer), {
        children: [
            index != null && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: index,
                color: "default",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const $69f527f26ff57ed6$export$80cd75c5dceceac6 = /*#__PURE__*/ $acw62.memo($69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw);

});

parcelRegister("6ZYGg", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderMenuIcon", () => $5187827afc33a627$export$941072bb8af39847);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5187827afc33a627$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $5187827afc33a627$export$941072bb8af39847 = /*#__PURE__*/ $acw62.memo((props)=>{
    var _rootProps$slotProps, _rootProps$slotProps2;
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $5187827afc33a627$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8nd05.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuLabel'),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "small"
                })
            }))
        }))
    });
});

});

parcelRegister("le8d8", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderMenu", () => $f741464eaaf59d11$export$c096196819b00a09);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $13KXh = parcelRequire("13KXh");

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $ayMG0 = parcelRequire("ayMG0");
function $f741464eaaf59d11$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $13KXh.default)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target != null && target.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ch6XH.GridMenu), {
        placement: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContentComponent, (0, $8nd05.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}

});

parcelRegister("4cOaX", function(module, exports) {

$parcel$export(module.exports, "GridGenericColumnHeaderItem", () => $30ff34474d4fdbcc$export$fd75c0d5b714072b);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $3qSdM = parcelRequire("3qSdM");

var $er55f = parcelRequire("er55f");

var $2jUq6 = parcelRequire("2jUq6");

var $c0AIV = parcelRequire("c0AIV");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $30ff34474d4fdbcc$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps"
];
const $30ff34474d4fdbcc$export$fd75c0d5b714072b = /*#__PURE__*/ $acw62.forwardRef(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, columnMenuOpen: columnMenuOpen, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, hasFocus: hasFocus, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps } = props, other = (0, $1En50.default)(props, $30ff34474d4fdbcc$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $acw62.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $acw62.useState(columnMenuOpen);
    const handleRef = (0, $3qSdM.default)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    $acw62.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    $acw62.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, headerClassName),
        style: {
            height: height,
            width: width,
            minWidth: width,
            maxWidth: width
        },
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort,
        "aria-label": headerComponent == null ? label : undefined
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jUq6.GridColumnHeaderTitle), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0AIV.GridColumnHeaderSeparator), (0, $8nd05.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});

});
parcelRegister("2jUq6", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderTitle", () => $1b091ef728f7a646$export$926bb04b6af55e42);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $KtEo5 = parcelRequire("KtEo5");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1b091ef728f7a646$var$_excluded = [
    "className"
];
const $1b091ef728f7a646$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $1b091ef728f7a646$var$GridColumnHeaderTitleRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle',
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)'
});
const $1b091ef728f7a646$var$ColumnHeaderInnerTitle = /*#__PURE__*/ $acw62.forwardRef(function ColumnHeaderInnerTitle(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $1b091ef728f7a646$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1b091ef728f7a646$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$GridColumnHeaderTitleRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $1b091ef728f7a646$export$926bb04b6af55e42(props) {
    var _rootProps$slotProps;
    const { label: label, description: description } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const titleRef = $acw62.useRef(null);
    const [tooltip, setTooltip] = $acw62.useState('');
    const handleMouseOver = $acw62.useCallback(()=>{
        if (!description && titleRef != null && titleRef.current) {
            const isOver = (0, $KtEo5.isOverflown)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $8nd05.default)({
        title: description || tooltip
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}

});

parcelRegister("c0AIV", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeaderSeparator", () => $8be1f8ad99c6bade$export$a264529bdbb7adb7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $gxvzd = parcelRequire("gxvzd");
var $8Indx = parcelRequire("8Indx");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $8be1f8ad99c6bade$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $8be1f8ad99c6bade$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($8be1f8ad99c6bade$export$71ed79b4ccf06d60 || {});
const $8be1f8ad99c6bade$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $gxvzd.default)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $8be1f8ad99c6bade$export$71ed79b4ccf06d60.Right } = props, other = (0, $1En50.default)(props, $8be1f8ad99c6bade$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $8be1f8ad99c6bade$var$useUtilityClasses(ownerState);
    const stopClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        className: classes.root,
        style: {
            minHeight: height,
            opacity: rootProps.showColumnVerticalBorder ? 0 : 1
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $8be1f8ad99c6bade$export$a264529bdbb7adb7 = /*#__PURE__*/ $acw62.memo($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw);

});



parcelRegister("fHEg1", function(module, exports) {

$parcel$export(module.exports, "getRenderableIndexes", () => $b6ea197699b5ee12$export$e8e2b5bd6af586c5);
$parcel$export(module.exports, "areRenderContextsEqual", () => $b6ea197699b5ee12$export$6eb241d16b36f3b8);
$parcel$export(module.exports, "useGridVirtualScroller", () => $b6ea197699b5ee12$export$fbe94079134c8d27);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $14H9o = parcelRequire("14H9o");
parcelRequire("6SpLG");
var $9EdUm = parcelRequire("9EdUm");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");

var $jQEEt = parcelRequire("jQEEt");

var $drCmI = parcelRequire("drCmI");

var $aJApm = parcelRequire("aJApm");

var $eFF1m = parcelRequire("eFF1m");

var $lR3Vo = parcelRequire("lR3Vo");

var $av74L = parcelRequire("av74L");

var $bdqIg = parcelRequire("bdqIg");

var $i0LyH = parcelRequire("i0LyH");

var $7sDf4 = parcelRequire("7sDf4");

var $9upDV = parcelRequire("9upDV");

var $ayMG0 = parcelRequire("ayMG0");
const $b6ea197699b5ee12$var$_excluded = [
    "style"
], $b6ea197699b5ee12$var$_excluded2 = [
    "style"
];
function $b6ea197699b5ee12$export$2e0ae67339d5f1ac(offset, positions, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const itemOffset = positions[pivot];
    return offset <= itemOffset ? $b6ea197699b5ee12$export$2e0ae67339d5f1ac(offset, positions, sliceStart, pivot) : $b6ea197699b5ee12$export$2e0ae67339d5f1ac(offset, positions, pivot + 1, sliceEnd);
}
function $b6ea197699b5ee12$var$exponentialSearch(offset, positions, index) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $b6ea197699b5ee12$export$2e0ae67339d5f1ac(offset, positions, Math.floor(index / 2), Math.min(index, positions.length));
}
const $b6ea197699b5ee12$export$e8e2b5bd6af586c5 = ({ firstIndex: firstIndex, lastIndex: lastIndex, buffer: buffer, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex })=>{
    return [
        (0, $lR3Vo.clamp)(firstIndex - buffer, minFirstIndex, maxLastIndex),
        (0, $lR3Vo.clamp)(lastIndex + buffer, minFirstIndex, maxLastIndex)
    ];
};
const $b6ea197699b5ee12$export$6eb241d16b36f3b8 = (context1, context2)=>{
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
};
// The `maxSize` is 3 so that reselect caches the `renderedColumns` values for the pinned left,
// unpinned, and pinned right sections.
const $b6ea197699b5ee12$var$MEMOIZE_OPTIONS = {
    maxSize: 3
};
const $b6ea197699b5ee12$export$fbe94079134c8d27 = (props)=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridVisibleColumnDefinitionsSelector));
    const enabled = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridVirtualizationEnabledSelector));
    const enabledForColumns = (0, $5sOMZ.useGridSelector)(apiRef, (0, $9upDV.gridVirtualizationColumnEnabledSelector));
    const { ref: ref, onRenderZonePositioning: onRenderZonePositioning, renderZoneMinColumnIndex: renderZoneMinColumnIndex = 0, renderZoneMaxColumnIndex: renderZoneMaxColumnIndex = visibleColumns.length, getRowProps: getRowProps } = props;
    const theme = (0, $14H9o.default)();
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnPositionsSelector));
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, (0, $jQEEt.gridColumnsTotalWidthSelector));
    const cellFocus = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridFocusCellSelector));
    const cellTabIndex = (0, $5sOMZ.useGridSelector)(apiRef, (0, $drCmI.gridTabIndexCellSelector));
    const rowsMeta = (0, $5sOMZ.useGridSelector)(apiRef, (0, $bdqIg.gridRowsMetaSelector));
    const selectedRowsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $av74L.selectedIdsLookupSelector));
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, rootProps);
    const renderZoneRef = $acw62.useRef(null);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, rootRef);
    const [renderContext, setRenderContextState] = $acw62.useState(null);
    const prevRenderContext = $acw62.useRef(renderContext);
    const scrollPosition = $acw62.useRef({
        top: 0,
        left: 0
    });
    const [containerDimensions, setContainerDimensions] = $acw62.useState({
        width: null,
        height: null
    });
    const prevTotalWidth = $acw62.useRef(columnsTotalWidth);
    // Each visible row (not to be confused with a filter result) is composed of a central row element
    // and up to two additional row elements for pinned columns (left and right).
    // When hovering any of these elements, the :hover styles are applied only to the row element that
    // was actually hovered, not its additional siblings. To make it look like a contiguous row,
    // we add/remove the .Mui-hovered class to all of the row elements inside one visible row.
    const [hoveredRowId, setHoveredRowId] = $acw62.useState(null);
    const rowStyleCache = $acw62.useRef(Object.create(null));
    const prevGetRowProps = $acw62.useRef();
    const prevRootRowStyle = $acw62.useRef();
    const getRenderedColumnsRef = $acw62.useRef((0, $9EdUm.defaultMemoize)((columns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, indexOfColumnWithFocusedCell)=>{
        // If the selected column is not within the current range of columns being displayed,
        // we need to render it at either the left or right of the columns,
        // depending on whether it is above or below the range.
        let focusedCellColumnIndexNotInRange;
        const renderedColumns = columns.slice(firstColumnToRender, lastColumnToRender);
        if (indexOfColumnWithFocusedCell > -1) {
            // check if it is not on the left pinned column.
            if (firstColumnToRender > indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell >= minFirstColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
            else if (lastColumnToRender < indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell < maxLastColumn) focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
        }
        return {
            focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
            renderedColumns: renderedColumns
        };
    }, $b6ea197699b5ee12$var$MEMOIZE_OPTIONS));
    const indexOfColumnWithFocusedCell = $acw62.useMemo(()=>{
        if (cellFocus !== null) return visibleColumns.findIndex((column)=>column.field === cellFocus.field);
        return -1;
    }, [
        cellFocus,
        visibleColumns
    ]);
    const computeRenderContext = $acw62.useCallback(()=>{
        if (!enabled) return {
            firstRowIndex: 0,
            lastRowIndex: currentPage.rows.length,
            firstColumnIndex: 0,
            lastColumnIndex: visibleColumns.length
        };
        const { top: top, left: left } = scrollPosition.current;
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        const firstRowIndex = Math.min($b6ea197699b5ee12$var$getNearestIndexToRender(apiRef, currentPage, rowsMeta, top), rowsMeta.positions.length - 1);
        const lastRowIndex = rootProps.autoHeight ? firstRowIndex + currentPage.rows.length : $b6ea197699b5ee12$var$getNearestIndexToRender(apiRef, currentPage, rowsMeta, top + containerDimensions.height);
        let firstColumnIndex = 0;
        let lastColumnIndex = columnPositions.length;
        if (enabledForColumns) {
            let hasRowWithAutoHeight = false;
            const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
                firstIndex: firstRowIndex,
                lastIndex: lastRowIndex,
                minFirstIndex: 0,
                maxLastIndex: currentPage.rows.length,
                buffer: rootProps.rowBuffer
            });
            for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
                const row = currentPage.rows[i];
                hasRowWithAutoHeight = apiRef.current.rowHasAutoHeight(row.id);
            }
            if (!hasRowWithAutoHeight) {
                firstColumnIndex = $b6ea197699b5ee12$export$2e0ae67339d5f1ac(Math.abs(left), columnPositions);
                lastColumnIndex = $b6ea197699b5ee12$export$2e0ae67339d5f1ac(Math.abs(left) + containerDimensions.width, columnPositions);
            }
        }
        return {
            firstRowIndex: firstRowIndex,
            lastRowIndex: lastRowIndex,
            firstColumnIndex: firstColumnIndex,
            lastColumnIndex: lastColumnIndex
        };
    }, [
        enabled,
        enabledForColumns,
        rowsMeta,
        rootProps.autoHeight,
        rootProps.rowBuffer,
        currentPage,
        columnPositions,
        visibleColumns.length,
        apiRef,
        containerDimensions
    ]);
    (0, $eEJPp.default)(()=>{
        if (enabled) {
            // TODO a scroll reset should not be necessary
            rootRef.current.scrollLeft = 0;
            rootRef.current.scrollTop = 0;
        } else renderZoneRef.current.style.transform = `translate3d(0px, 0px, 0px)`;
    }, [
        enabled
    ]);
    (0, $eEJPp.default)(()=>{
        setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, [
        rowsMeta.currentPageTotalHeight
    ]);
    const handleResize = $acw62.useCallback(()=>{
        if (rootRef.current) setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, []);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'debouncedResize', handleResize);
    const updateRenderZonePosition = $acw62.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const [initialFirstColumnToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: renderZoneMinColumnIndex,
            maxLastIndex: renderZoneMaxColumnIndex,
            buffer: rootProps.columnBuffer
        });
        const firstColumnToRender = (0, $i0LyH.getFirstNonSpannedColumnToRender)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        const direction = theme.direction === 'ltr' ? 1 : -1;
        const top = (0, $bdqIg.gridRowsMetaSelector)(apiRef.current.state).positions[firstRowToRender];
        const left = direction * (0, $jQEEt.gridColumnPositionsSelector)(apiRef)[firstColumnToRender]; // Call directly the selector because it might be outdated when this method is called
        renderZoneRef.current.style.transform = `translate3d(${left}px, ${top}px, 0px)`;
        if (typeof onRenderZonePositioning === 'function') onRenderZonePositioning({
            top: top,
            left: left
        });
    }, [
        apiRef,
        currentPage.rows,
        onRenderZonePositioning,
        renderZoneMinColumnIndex,
        renderZoneMaxColumnIndex,
        rootProps.columnBuffer,
        rootProps.rowBuffer,
        theme.direction
    ]);
    const getRenderContext = $acw62.useCallback(()=>prevRenderContext.current, []);
    const setRenderContext = $acw62.useCallback((nextRenderContext)=>{
        if (prevRenderContext.current && $b6ea197699b5ee12$export$6eb241d16b36f3b8(nextRenderContext, prevRenderContext.current)) {
            updateRenderZonePosition(nextRenderContext);
            return;
        }
        setRenderContextState(nextRenderContext);
        updateRenderZonePosition(nextRenderContext);
        const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        apiRef.current.publishEvent('renderedRowsIntervalChange', {
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender
        });
        prevRenderContext.current = nextRenderContext;
    }, [
        apiRef,
        setRenderContextState,
        prevRenderContext,
        currentPage.rows.length,
        rootProps.rowBuffer,
        updateRenderZonePosition
    ]);
    (0, $eEJPp.default)(()=>{
        if (containerDimensions.width == null) return;
        const initialRenderContext = computeRenderContext();
        setRenderContext(initialRenderContext);
        const { top: top, left: left } = scrollPosition.current;
        const params = {
            top: top,
            left: left,
            renderContext: initialRenderContext
        };
        apiRef.current.publishEvent('scrollPositionChange', params);
    }, [
        apiRef,
        computeRenderContext,
        containerDimensions.width,
        setRenderContext
    ]);
    const handleScroll = (0, $13KXh.default)((event)=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = event.currentTarget;
        scrollPosition.current.top = scrollTop;
        scrollPosition.current.left = scrollLeft;
        // On iOS and macOS, negative offsets are possible when swiping past the start
        if (!prevRenderContext.current || scrollTop < 0) return;
        if (theme.direction === 'ltr') {
            if (scrollLeft < 0) return;
        }
        if (theme.direction === 'rtl') {
            if (scrollLeft > 0) return;
        }
        // When virtualization is disabled, the context never changes during scroll
        const nextRenderContext = enabled ? computeRenderContext() : prevRenderContext.current;
        const topRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstRowIndex - prevRenderContext.current.firstRowIndex);
        const bottomRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastRowIndex - prevRenderContext.current.lastRowIndex);
        const topColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstColumnIndex - prevRenderContext.current.firstColumnIndex);
        const bottomColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastColumnIndex - prevRenderContext.current.lastColumnIndex);
        const shouldSetState = topRowsScrolledSincePreviousRender >= rootProps.rowThreshold || bottomRowsScrolledSincePreviousRender >= rootProps.rowThreshold || topColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || bottomColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || prevTotalWidth.current !== columnsTotalWidth;
        apiRef.current.publishEvent('scrollPositionChange', {
            top: scrollTop,
            left: scrollLeft,
            renderContext: shouldSetState ? nextRenderContext : prevRenderContext.current
        }, event);
        if (shouldSetState) {
            // Prevents batching render context changes
            $1u0KT.flushSync(()=>{
                setRenderContext(nextRenderContext);
            });
            prevTotalWidth.current = columnsTotalWidth;
        }
    });
    const handleWheel = (0, $13KXh.default)((event)=>{
        apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
    });
    const handleTouchMove = (0, $13KXh.default)((event)=>{
        apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
    });
    const indexOfRowWithFocusedCell = $acw62.useMemo(()=>{
        if (cellFocus !== null) return currentPage.rows.findIndex((row)=>row.id === cellFocus.id);
        return -1;
    }, [
        cellFocus,
        currentPage.rows
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowMouseOver', (params, event)=>{
        var _params$id;
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId((_params$id = params.id) != null ? _params$id : null);
    });
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'rowMouseOut', (params, event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        setHoveredRowId(null);
    });
    const getRows = (params = {
        renderContext: renderContext
    })=>{
        var _rootProps$slotProps;
        const { onRowRender: onRowRender, renderContext: nextRenderContext, minFirstColumn: minFirstColumn = renderZoneMinColumnIndex, maxLastColumn: maxLastColumn = renderZoneMaxColumnIndex, availableSpace: availableSpace = containerDimensions.width, rowIndexOffset: rowIndexOffset = 0, position: position = 'center' } = params;
        if (!nextRenderContext || availableSpace == null) return null;
        const rowBuffer = enabled ? rootProps.rowBuffer : 0;
        const columnBuffer = enabled ? rootProps.columnBuffer : 0;
        const [firstRowToRender, lastRowToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rowBuffer
        });
        const renderedRows = [];
        if (params.rows) params.rows.forEach((row)=>{
            renderedRows.push(row);
            apiRef.current.calculateColSpan({
                rowId: row.id,
                minFirstColumn: minFirstColumn,
                maxLastColumn: maxLastColumn,
                columns: visibleColumns
            });
        });
        else {
            if (!currentPage.range) return null;
            for(let i = firstRowToRender; i < lastRowToRender; i += 1){
                const row = currentPage.rows[i];
                renderedRows.push(row);
                apiRef.current.calculateColSpan({
                    rowId: row.id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        // If the selected row is not within the current range of rows being displayed,
        // we need to render it at either the top or bottom of the rows,
        // depending on whether it is above or below the range.
        let isRowWithFocusedCellNotInRange = false;
        if (indexOfRowWithFocusedCell > -1) {
            const rowWithFocusedCell = currentPage.rows[indexOfRowWithFocusedCell];
            if (firstRowToRender > indexOfRowWithFocusedCell || lastRowToRender < indexOfRowWithFocusedCell) {
                isRowWithFocusedCellNotInRange = true;
                if (indexOfRowWithFocusedCell > firstRowToRender) renderedRows.push(rowWithFocusedCell);
                else renderedRows.unshift(rowWithFocusedCell);
                apiRef.current.calculateColSpan({
                    rowId: rowWithFocusedCell.id,
                    minFirstColumn: minFirstColumn,
                    maxLastColumn: maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        const [initialFirstColumnToRender, lastColumnToRender] = $b6ea197699b5ee12$export$e8e2b5bd6af586c5({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: minFirstColumn,
            maxLastIndex: maxLastColumn,
            buffer: columnBuffer
        });
        const firstColumnToRender = (0, $i0LyH.getFirstNonSpannedColumnToRender)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef: apiRef,
            firstRowToRender: firstRowToRender,
            lastRowToRender: lastRowToRender,
            visibleRows: currentPage.rows
        });
        let isColumnWihFocusedCellNotInRange = false;
        if (firstColumnToRender > indexOfColumnWithFocusedCell || lastColumnToRender < indexOfColumnWithFocusedCell) isColumnWihFocusedCellNotInRange = true;
        const { focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange, renderedColumns: renderedColumns } = getRenderedColumnsRef.current(visibleColumns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, isColumnWihFocusedCellNotInRange ? indexOfColumnWithFocusedCell : -1);
        const _ref = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.row) || {}, { style: rootRowStyle } = _ref, rootRowProps = (0, $1En50.default)(_ref, $b6ea197699b5ee12$var$_excluded);
        const invalidatesCachedRowStyle = prevGetRowProps.current !== getRowProps || prevRootRowStyle.current !== rootRowStyle;
        if (invalidatesCachedRowStyle) rowStyleCache.current = Object.create(null);
        const rows = [];
        let isRowWithFocusedCellRendered = false;
        for(let i = 0; i < renderedRows.length; i += 1){
            var _currentPage$range;
            const { id: id, model: model } = renderedRows[i];
            const isRowNotVisible = isRowWithFocusedCellNotInRange && cellFocus.id === id;
            const lastVisibleRowIndex = isRowWithFocusedCellNotInRange ? firstRowToRender + i === currentPage.rows.length : firstRowToRender + i === currentPage.rows.length - 1;
            const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : 'auto';
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            if (onRowRender) onRowRender(id);
            const focusedCell = cellFocus !== null && cellFocus.id === id ? cellFocus.field : null;
            const columnWithFocusedCellNotInRange = focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange];
            const renderedColumnsWithFocusedCell = columnWithFocusedCellNotInRange && focusedCell ? [
                columnWithFocusedCellNotInRange,
                ...renderedColumns
            ] : renderedColumns;
            let tabbableCell = null;
            if (cellTabIndex !== null && cellTabIndex.id === id) {
                const cellParams = apiRef.current.getCellParams(id, cellTabIndex.field);
                tabbableCell = cellParams.cellMode === 'view' ? cellTabIndex.field : null;
            }
            const _ref2 = typeof getRowProps === 'function' && getRowProps(id, model) || {}, { style: rowStyle } = _ref2, rowProps = (0, $1En50.default)(_ref2, $b6ea197699b5ee12$var$_excluded2);
            if (!rowStyleCache.current[id]) {
                const style = (0, $8nd05.default)({}, rowStyle, rootRowStyle);
                rowStyleCache.current[id] = style;
            }
            let index = rowIndexOffset + ((currentPage == null || (_currentPage$range = currentPage.range) == null ? void 0 : _currentPage$range.firstRowIndex) || 0) + firstRowToRender + i;
            if (isRowWithFocusedCellNotInRange && (cellFocus == null ? void 0 : cellFocus.id) === id) {
                index = indexOfRowWithFocusedCell;
                isRowWithFocusedCellRendered = true;
            } else if (isRowWithFocusedCellRendered) index -= 1;
            rows.push(/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.row, (0, $8nd05.default)({
                row: model,
                rowId: id,
                focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
                isNotVisible: isRowNotVisible,
                rowHeight: baseRowHeight,
                focusedCell: focusedCell,
                tabbableCell: tabbableCell,
                renderedColumns: renderedColumnsWithFocusedCell,
                visibleColumns: visibleColumns,
                firstColumnToRender: firstColumnToRender,
                lastColumnToRender: lastColumnToRender,
                selected: isSelected,
                index: index,
                containerWidth: availableSpace,
                isLastVisible: lastVisibleRowIndex,
                position: position
            }, rowProps, rootRowProps, {
                hovered: hoveredRowId === id,
                style: rowStyleCache.current[id]
            }), id));
        }
        prevGetRowProps.current = getRowProps;
        prevRootRowStyle.current = rootRowStyle;
        return rows;
    };
    const needsHorizontalScrollbar = containerDimensions.width && columnsTotalWidth >= containerDimensions.width;
    const contentSize = $acw62.useMemo(()=>{
        // In cases where the columns exceed the available width,
        // the horizontal scrollbar should be shown even when there're no rows.
        // Keeping 1px as minimum height ensures that the scrollbar will visible if necessary.
        const height = Math.max(rowsMeta.currentPageTotalHeight, 1);
        let shouldExtendContent = false;
        if (rootRef != null && rootRef.current && height <= (rootRef == null ? void 0 : rootRef.current.clientHeight)) shouldExtendContent = true;
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            height: height,
            minHeight: shouldExtendContent ? '100%' : 'auto'
        };
        if (rootProps.autoHeight && currentPage.rows.length === 0) size.height = (0, $7sDf4.getMinimalContentHeight)(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
        return size;
    }, [
        apiRef,
        rootRef,
        columnsTotalWidth,
        rowsMeta.currentPageTotalHeight,
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        rootProps.rowHeight,
        currentPage.rows.length
    ]);
    $acw62.useEffect(()=>{
        apiRef.current.publishEvent('virtualScrollerContentSizeChange');
    }, [
        apiRef,
        contentSize
    ]);
    const rootStyle = $acw62.useMemo(()=>{
        const style = {};
        if (!needsHorizontalScrollbar) style.overflowX = 'hidden';
        if (rootProps.autoHeight) style.overflowY = 'hidden';
        return style;
    }, [
        needsHorizontalScrollbar,
        rootProps.autoHeight
    ]);
    apiRef.current.register('private', {
        getRenderContext: getRenderContext
    });
    return {
        renderContext: renderContext,
        updateRenderZonePosition: updateRenderZonePosition,
        getRows: getRows,
        getRootProps: (inputProps = {})=>(0, $8nd05.default)({
                ref: handleRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove
            }, inputProps, {
                style: inputProps.style ? (0, $8nd05.default)({}, inputProps.style, rootStyle) : rootStyle,
                role: 'presentation'
            }),
        getContentProps: ({ style: style } = {})=>({
                style: style ? (0, $8nd05.default)({}, style, contentSize) : contentSize,
                role: 'presentation'
            }),
        getRenderZoneProps: ()=>({
                ref: renderZoneRef,
                role: 'rowgroup'
            })
    };
};
function $b6ea197699b5ee12$var$getNearestIndexToRender(apiRef, currentPage, rowsMeta, offset) {
    var _currentPage$range2, _currentPage$range3;
    const lastMeasuredIndexRelativeToAllRows = apiRef.current.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if ((_currentPage$range2 = currentPage.range) != null && _currentPage$range2.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= currentPage.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = (0, $lR3Vo.clamp)(lastMeasuredIndexRelativeToAllRows - (((_currentPage$range3 = currentPage.range) == null ? void 0 : _currentPage$range3.firstRowIndex) || 0), 0, rowsMeta.positions.length);
    if (allRowsMeasured || rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $b6ea197699b5ee12$export$2e0ae67339d5f1ac(offset, rowsMeta.positions);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $b6ea197699b5ee12$var$exponentialSearch(offset, rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage);
}

});
parcelRegister("9upDV", function(module, exports) {

$parcel$export(module.exports, "gridVirtualizationEnabledSelector", () => $6e8ace88dee0fb7c$export$fb3400598da0ae89);
$parcel$export(module.exports, "gridVirtualizationColumnEnabledSelector", () => $6e8ace88dee0fb7c$export$ad2aa1e9d465cafa);

var $cgQ4y = parcelRequire("cgQ4y");
const $6e8ace88dee0fb7c$export$38fd8a77b05bfddf = (state)=>state.virtualization;
const $6e8ace88dee0fb7c$export$fb3400598da0ae89 = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $6e8ace88dee0fb7c$export$ad2aa1e9d465cafa = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);

});


parcelRegister("kAYrj", function(module, exports) {

$parcel$export(module.exports, "GridColumnGroupHeader", () => $efe60d7621886a65$export$ff426d40d02e21be);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8Indx = parcelRequire("8Indx");
var $auC0X = parcelRequire("auC0X");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $ayMG0 = parcelRequire("ayMG0");
const $efe60d7621886a65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, showColumnBorder: showColumnBorder, groupId: groupId } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showColumnBorder && 'columnHeader--showColumnBorder',
            showColumnBorder && 'columnHeader--withRightBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $efe60d7621886a65$export$ff426d40d02e21be(props) {
    var _columnGroupsLookup$g;
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $acw62.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnGroupsLookup = (0, $5sOMZ.useGridSelector)(apiRef, (0, $hMyIf.gridColumnGroupsLookupSelector));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId != null ? groupId : '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && ((_columnGroupsLookup$g = columnGroupsLookup[groupId]) == null ? void 0 : _columnGroupsLookup$g.renderHeaderGroup);
    const renderParams = $acw62.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const showColumnBorder = rootProps.showColumnVerticalBorder;
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: rootProps.classes,
        showColumnBorder: showColumnBorder,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName != null ? headerName : groupId;
    const id = (0, $auC0X.default)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $efe60d7621886a65$var$useUtilityClasses(ownerState);
    $acw62.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cOaX.GridGenericColumnHeaderItem), (0, $8nd05.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`
    }, mouseEventsHandlers));
}

});


parcelRegister("2fAdp", function(module, exports) {

$parcel$export(module.exports, "GridBaseColumnHeaders", () => $1a39131620112653$export$de91f7b8bf842ed8);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1a39131620112653$var$_excluded = [
    "className"
];
const $1a39131620112653$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders',
            'withBorderColor'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $1a39131620112653$var$GridColumnHeadersRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders',
    overridesResolver: (props, styles)=>styles.columnHeaders
})({
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderBottom: '1px solid',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $1a39131620112653$export$de91f7b8bf842ed8 = /*#__PURE__*/ $acw62.forwardRef(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $1a39131620112653$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1a39131620112653$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1a39131620112653$var$GridColumnHeadersRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: rootProps
    }, other, {
        role: "presentation"
    }));
});

});

parcelRegister("9Oyj3", function(module, exports) {

$parcel$export(module.exports, "GridColumnHeadersInner", () => $7253651c12240b14$export$b3c0512acbf05cb7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $0tqaY = parcelRequire("0tqaY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $7253651c12240b14$var$_excluded = [
    "isDragging",
    "className"
];
const $7253651c12240b14$var$useUtilityClasses = (ownerState)=>{
    const { isDragging: isDragging, hasScrollX: hasScrollX, classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeadersInner',
            isDragging && 'columnHeaderDropZone',
            hasScrollX && 'columnHeadersInner--scrollable'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $7253651c12240b14$var$GridColumnHeadersInnerRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'columnHeadersInner',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $5H1vo.gridClasses).columnHeaderDropZone}`]: styles.columnHeaderDropZone
            },
            styles.columnHeadersInner
        ]
})(()=>({
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [`&.${(0, $5H1vo.gridClasses).columnHeaderDropZone} .${(0, $5H1vo.gridClasses).columnHeaderDraggableContainer}`]: {
            cursor: 'move'
        },
        [`&.${(0, $5H1vo.gridClasses)['columnHeadersInner--scrollable']} .${(0, $5H1vo.gridClasses).columnHeader}:last-child`]: {
            borderRight: 'none'
        }
    }));
const $7253651c12240b14$export$b3c0512acbf05cb7 = /*#__PURE__*/ $acw62.forwardRef(function GridColumnHeadersInner(props, ref) {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    const { isDragging: isDragging, className: className } = props, other = (0, $1En50.default)(props, $7253651c12240b14$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8nd05.default)({}, rootProps, {
        isDragging: isDragging,
        hasScrollX: (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.hasScrollX) != null ? _apiRef$current$getRo : false
    });
    const classes = $7253651c12240b14$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7253651c12240b14$var$GridColumnHeadersInnerRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(className, classes.root),
        ownerState: ownerState
    }, other));
});

});


parcelRegister("59mZx", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenu", () => $3bffa0a776b5a050$export$53fbb13480dfeb67);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $jsV9n = parcelRequire("jsV9n");

var $unHVj = parcelRequire("unHVj");

var $6bz5h = parcelRequire("6bz5h");

var $cYNu4 = parcelRequire("cYNu4");

var $cKFTH = parcelRequire("cKFTH");

var $ayMG0 = parcelRequire("ayMG0");
const $3bffa0a776b5a050$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $3bffa0a776b5a050$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $cKFTH.GridColumnMenuSortItem),
    columnMenuFilterItem: (0, $cYNu4.GridColumnMenuFilterItem),
    columnMenuColumnsItem: (0, $6bz5h.GridColumnMenuColumnsItem)
};
const $3bffa0a776b5a050$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $3bffa0a776b5a050$export$61ffa20907ac4a8e = /*#__PURE__*/ $acw62.forwardRef(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $3bffa0a776b5a050$var$_excluded);
    const orderedSlots = (0, $jsV9n.useGridColumnMenuSlots)((0, $8nd05.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $unHVj.GridColumnMenuContainer), (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $8nd05.default)({}, otherProps), index))
    }));
});
const $3bffa0a776b5a050$export$53fbb13480dfeb67 = /*#__PURE__*/ $acw62.forwardRef(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bffa0a776b5a050$export$61ffa20907ac4a8e, (0, $8nd05.default)({}, props, {
        ref: ref,
        defaultSlots: $3bffa0a776b5a050$export$5983f95fe9d3e659,
        defaultSlotProps: $3bffa0a776b5a050$export$c107bd4c779cece6
    }));
});

});
parcelRegister("jsV9n", function(module, exports) {

$parcel$export(module.exports, "useGridColumnMenuSlots", () => $e2bcf6b15e7fbab3$export$2ba37d64bee4cf68);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $lkxXU = parcelRequire("lkxXU");

var $er55f = parcelRequire("er55f");
const $e2bcf6b15e7fbab3$var$_excluded = [
    "displayOrder"
];
const $e2bcf6b15e7fbab3$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $acw62.useMemo(()=>(0, $8nd05.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $acw62.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $8nd05.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $8nd05.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $acw62.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $acw62.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps == null ? void 0 : leftItemProps.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps == null ? void 0 : rightItemProps.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $1En50.default)(processedComponentProps, $e2bcf6b15e7fbab3$var$_excluded);
                itemProps = (0, $8nd05.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    (0, $lkxXU.default),
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems
    ]);
};

});
parcelRegister("lkxXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f875d00b2138afe4$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cbVYE.getDividerUtilityClass), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kSnzZ.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;

});


parcelRegister("unHVj", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuContainer", () => $05b53142b9ab08e6$export$595ece458604adc3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $lBOb7 = parcelRequire("lBOb7");

var $d8seH = parcelRequire("d8seH");

var $dMF9H = parcelRequire("dMF9H");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $05b53142b9ab08e6$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $05b53142b9ab08e6$var$StyledMenuList = (0, $d8seH.default)((0, $lBOb7.default))(()=>({
        minWidth: 248
    }));
const $05b53142b9ab08e6$export$595ece458604adc3 = /*#__PURE__*/ $acw62.forwardRef(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $1En50.default)(props, $05b53142b9ab08e6$var$_excluded);
    const handleListKeyDown = $acw62.useCallback((event)=>{
        if ((0, $dMF9H.isTabKey)(event.key)) event.preventDefault();
        if ((0, $dMF9H.isHideMenuKey)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05b53142b9ab08e6$var$StyledMenuList, (0, $8nd05.default)({
        id: id,
        ref: ref,
        className: (0, $9QePP.default)((0, $5H1vo.gridClasses).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        children: children
    }));
});

});

parcelRegister("6bz5h", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuColumnsItem", () => $480efc1ffdb54f08$export$fee567ee855db2cc);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9udtZ = parcelRequire("9udtZ");

var $kGBL7 = parcelRequire("kGBL7");

var $ayMG0 = parcelRequire("ayMG0");
function $480efc1ffdb54f08$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9udtZ.GridColumnMenuHideItem), (0, $8nd05.default)({}, props)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGBL7.GridColumnMenuManageItem), (0, $8nd05.default)({}, props))
        ]
    });
}

});
parcelRegister("9udtZ", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuHideItem", () => $6e815fc52eaddbf2$export$43421c0d197b);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $ayMG0 = parcelRequire("ayMG0");
function $6e815fc52eaddbf2$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $acw62.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: toggleColumn,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuHideIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuHideColumn')
            })
        ]
    });
}

});
parcelRegister("bjZRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e175cb7e49d325$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $doXfV = parcelRequire("doXfV");

var $3W6ht = parcelRequire("3W6ht");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $83e175cb7e49d325$var$_excluded = [
    "className"
];
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $doXfV.getListItemIconUtilityClass), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $83e175cb7e49d325$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;

});

parcelRegister("19ocJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d696835f9b43a35$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");

var $3W6ht = parcelRequire("3W6ht");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $guz4p = parcelRequire("guz4p");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $guz4p.getListItemTextUtilityClass), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $guz4p.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $guz4p.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $3W6ht.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $3bYfT.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $3bYfT.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;

});


parcelRegister("kGBL7", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuManageItem", () => $f0f5050f3d38da77$export$dfc5e58327b7921f);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f0f5050f3d38da77$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showColumns = $acw62.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $3PCYS.GridPreferencePanelsValue).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: showColumns,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuManageColumns')
            })
        ]
    });
}

});


parcelRegister("cYNu4", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuFilterItem", () => $97317925c823a2fa$export$a4dd856446268ffe);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $97317925c823a2fa$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showFilter = $acw62.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        onClick: showFilter,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuFilterIcon, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                children: apiRef.current.getLocaleText('columnMenuFilter')
            })
        ]
    });
}

});

parcelRegister("cKFTH", function(module, exports) {

$parcel$export(module.exports, "GridColumnMenuSortItem", () => $948a47da9ef72c3c$export$e58710c52f856e65);

var $acw62 = parcelRequire("acw62");


var $2iAqv = parcelRequire("2iAqv");

var $bjZRT = parcelRequire("bjZRT");

var $19ocJ = parcelRequire("19ocJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $iU3u2 = parcelRequire("iU3u2");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $948a47da9ef72c3c$export$e58710c52f856e65(props) {
    var _colDef$sortingOrder;
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, (0, $iU3u2.gridSortModelSelector));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const sortDirection = $acw62.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem == null ? void 0 : sortItem.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
    const onSortMenuItemClick = $acw62.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        apiRef.current.sortColumn(colDef, direction === sortDirection ? null : direction);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection
    ]);
    if (!colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: getLabel('columnMenuSortAsc')
                    })
                ]
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: getLabel('columnMenuSortDesc')
                    })
                ]
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
                onClick: onSortMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bjZRT.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                        children: apiRef.current.getLocaleText('columnMenuUnsort')
                    })
                ]
            }) : null
        ]
    });
}

});


parcelRegister("eaFJs", function(module, exports) {

$parcel$export(module.exports, "GridNoResultsOverlay", () => $a5125f04ce420a8f$export$82fb990ffc125278);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $a5125f04ce420a8f$export$82fb990ffc125278 = /*#__PURE__*/ $acw62.forwardRef(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $809Ep.GridOverlay), (0, $8nd05.default)({
        ref: ref
    }, props, {
        children: noResultsOverlayLabel
    }));
});

});

parcelRegister("9lhjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cd3818014b55356$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1Aijw = parcelRequire("1Aijw");

var $iAtns = parcelRequire("iAtns");

var $gd5y7 = parcelRequire("gd5y7");

var $cX7V2 = parcelRequire("cX7V2");

var $7s24a = parcelRequire("7s24a");

var $6lXkL = parcelRequire("6lXkL");

var $9Lykx = parcelRequire("9Lykx");

var $hViLc = parcelRequire("hViLc");

var $cVXaD = parcelRequire("cVXaD");

var $e76iu = parcelRequire("e76iu");

var $OEVqP = parcelRequire("OEVqP");

var $6ami2 = parcelRequire("6ami2");

var $g95sO = parcelRequire("g95sO");

var $fWql6 = parcelRequire("fWql6");

var $eUvXy = parcelRequire("eUvXy");
const $6cd3818014b55356$var$iconSlots = {
    BooleanCellTrueIcon: (0, $fWql6.GridCheckIcon),
    BooleanCellFalseIcon: (0, $fWql6.GridCloseIcon),
    ColumnMenuIcon: (0, $fWql6.GridTripleDotsVerticalIcon),
    OpenFilterButtonIcon: (0, $fWql6.GridFilterListIcon),
    FilterPanelDeleteIcon: (0, $fWql6.GridCloseIcon),
    ColumnFilteredIcon: (0, $fWql6.GridFilterAltIcon),
    ColumnSelectorIcon: (0, $fWql6.GridColumnIcon),
    ColumnUnsortedIcon: (0, $g95sO.GridColumnUnsortedIcon),
    ColumnSortedAscendingIcon: (0, $fWql6.GridArrowUpwardIcon),
    ColumnSortedDescendingIcon: (0, $fWql6.GridArrowDownwardIcon),
    ColumnResizeIcon: (0, $fWql6.GridSeparatorIcon),
    DensityCompactIcon: (0, $fWql6.GridViewHeadlineIcon),
    DensityStandardIcon: (0, $fWql6.GridTableRowsIcon),
    DensityComfortableIcon: (0, $fWql6.GridViewStreamIcon),
    ExportIcon: (0, $fWql6.GridSaveAltIcon),
    MoreActionsIcon: (0, $fWql6.GridMoreVertIcon),
    TreeDataCollapseIcon: (0, $fWql6.GridExpandMoreIcon),
    TreeDataExpandIcon: (0, $fWql6.GridKeyboardArrowRight),
    GroupingCriteriaCollapseIcon: (0, $fWql6.GridExpandMoreIcon),
    GroupingCriteriaExpandIcon: (0, $fWql6.GridKeyboardArrowRight),
    DetailPanelExpandIcon: (0, $fWql6.GridAddIcon),
    DetailPanelCollapseIcon: (0, $fWql6.GridRemoveIcon),
    RowReorderIcon: (0, $fWql6.GridDragIcon),
    QuickFilterIcon: (0, $fWql6.GridSearchIcon),
    QuickFilterClearIcon: (0, $fWql6.GridCloseIcon),
    ColumnMenuHideIcon: (0, $fWql6.GridVisibilityOffIcon),
    ColumnMenuSortAscendingIcon: (0, $fWql6.GridArrowUpwardIcon),
    ColumnMenuSortDescendingIcon: (0, $fWql6.GridArrowDownwardIcon),
    ColumnMenuFilterIcon: (0, $fWql6.GridFilterAltIcon),
    ColumnMenuManageColumnsIcon: (0, $fWql6.GridViewColumnIcon),
    ColumnMenuClearIcon: (0, $fWql6.GridClearIcon),
    LoadIcon: (0, $fWql6.GridLoadIcon),
    FilterPanelAddIcon: (0, $fWql6.GridAddIcon),
    FilterPanelRemoveAllIcon: (0, $fWql6.GridDeleteForeverIcon),
    ColumnReorderIcon: (0, $fWql6.GridDragIcon)
};
const $6cd3818014b55356$var$materialSlots = (0, $8nd05.default)({}, $6cd3818014b55356$var$iconSlots, {
    BaseCheckbox: (0, $1Aijw.default),
    BaseTextField: (0, $iAtns.default),
    BaseFormControl: (0, $gd5y7.default),
    BaseSelect: (0, $cX7V2.default),
    BaseSwitch: (0, $7s24a.default),
    BaseButton: (0, $6lXkL.default),
    BaseIconButton: (0, $9Lykx.default),
    BaseInputAdornment: (0, $hViLc.default),
    BaseTooltip: (0, $cVXaD.default),
    BasePopper: (0, $e76iu.default),
    BaseInputLabel: (0, $OEVqP.default),
    BaseSelectOption: (0, $eUvXy.default),
    BaseChip: (0, $6ami2.default)
});
var $6cd3818014b55356$export$2e2bcd8739ae039 = $6cd3818014b55356$var$materialSlots;

});
parcelRegister("1Aijw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12775c00f473d955$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $kVqvD = parcelRequire("kVqvD");

var $1yHUZ = parcelRequire("1yHUZ");

var $etWmn = parcelRequire("etWmn");

var $2rW38 = parcelRequire("2rW38");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $9s7Sp = parcelRequire("9s7Sp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9s7Sp.getCheckboxUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $9s7Sp.default).checked}, &.${(0, $9s7Sp.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9s7Sp.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $etWmn.default), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1yHUZ.default), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rW38.default), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bdb1b636c81735$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $3yddg = parcelRequire("3yddg");

var $cJQfW = parcelRequire("cJQfW");

var $6n0Ko = parcelRequire("6n0Ko");

var $bxhip = parcelRequire("bxhip");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bxhip.getSwitchBaseUtilityClass), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $6n0Ko.default))(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $3yddg.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $cJQfW.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $86603163591f910a$export$baa0faa0c7ad8085);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $122b08a8ae2faae5$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("etWmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b10b2b5aaa8e54$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("2rW38", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8b21cdbf539e4f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("9s7Sp", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $6e1cd6b997bc70d3$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;

});


parcelRegister("iAtns", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ab7Se = parcelRequire("ab7Se");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $OEVqP = parcelRequire("OEVqP");

var $gd5y7 = parcelRequire("gd5y7");

var $i32L9 = parcelRequire("i32L9");

var $cX7V2 = parcelRequire("cX7V2");

var $3epOE = parcelRequire("3epOE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $ab7Se.default),
    filled: (0, $g4sO2.default),
    outlined: (0, $imehR.default)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3epOE.getTextFieldUtilityClass), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $gd5y7.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $auC0X.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("OEVqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $djhCy = parcelRequire("djhCy");
var $h2sOW = parcelRequire("h2sOW");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $cCThE.getInputLabelUtilityClasses), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $djhCy.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $h2sOW.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("djhCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $h2sOW = parcelRequire("h2sOW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $h2sOW.getFormLabelUtilityClasses), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $h2sOW.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $h2sOW.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $c678fac155df4fc3$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $c678fac155df4fc3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;

});


parcelRegister("cCThE", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;

});


parcelRegister("gd5y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $2BbKU = parcelRequire("2BbKU");

var $jTnBY = parcelRequire("jTnBY");

var $cpXNi = parcelRequire("cpXNi");

var $blr6C = parcelRequire("blr6C");

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hGBKj.getFormControlUtilityClasses), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $cpXNi.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("cpXNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a633ad7a979daa$export$2e2bcd8739ae039);

var $4NpFa = parcelRequire("4NpFa");
var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $4NpFa.default);

});
parcelRegister("4NpFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dfa52af4926933$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

});


parcelRegister("hGBKj", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $ce03a37a8cfb980d$export$149c8b8bab2289d1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;

});


parcelRegister("i32L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $e7ceb = parcelRequire("e7ceb");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e7ceb.getFormHelperTextUtilityClasses), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $e7ceb.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e7ceb.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $a46b344d341d82c0$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;

});


parcelRegister("3epOE", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $25a6b464d3ca38da$export$c1bdcbaf0596aeda);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;

});


parcelRegister("7s24a", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ccc0421702a0be$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");

var $kVqvD = parcelRequire("kVqvD");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $89Onw = parcelRequire("89Onw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $89Onw.getSwitchUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $89Onw.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $89Onw.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $89Onw.default).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $kVqvD.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $89Onw.default).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $89Onw.default).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $89Onw.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $89Onw.default).disabled} + .${(0, $89Onw.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $89Onw.default).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $89Onw.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $89Onw.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $kSnzZ.lighten)(theme.palette[color].main, 0.62) : (0, $kSnzZ.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $89Onw.default).checked} + .${(0, $89Onw.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;

});

parcelRegister("6lXkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $1xAC3 = parcelRequire("1xAC3");

var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $1xAC3.getButtonUtilityClass), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $8nd05.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1xAC3.default).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1xAC3.default).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $1xAC3.default).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $1xAC3.default).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $bwtSM.default));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $3eDio.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;

});
parcelRegister("1xAC3", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $11f546081ba06ace$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $11f546081ba06ace$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8639dcef822d5d4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1293270900846$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;

});


parcelRegister("hViLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c64ff513a9933f$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $3bYfT = parcelRequire("3bYfT");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $kWfSh = parcelRequire("kWfSh");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kWfSh.getInputAdornmentUtilityClass), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $kWfSh.default).positionStart}&:not(.${(0, $kWfSh.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;

});
parcelRegister("kWfSh", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $f3e589c60baacdec$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $f3e589c60baacdec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;

});


parcelRegister("cVXaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $58lXc = parcelRequire("58lXc");

var $gEUd4 = parcelRequire("gEUd4");

var $2xc7G = parcelRequire("2xc7G");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $e76iu = parcelRequire("e76iu");

var $4o7uD = parcelRequire("4o7uD");

var $9Rgf1 = parcelRequire("9Rgf1");

var $5A6d3 = parcelRequire("5A6d3");

var $cllwi = parcelRequire("cllwi");

var $3yddg = parcelRequire("3yddg");

var $eVjpW = parcelRequire("eVjpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eVjpW.getTooltipUtilityClass), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $eVjpW.default).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $eVjpW.default).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $lHOu3.Timeout)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $iscuz.default), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $lHOu3.default)();
    const enterTimer = (0, $lHOu3.default)();
    const leaveTimer = (0, $lHOu3.default)();
    const touchTimer = (0, $lHOu3.default)();
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $5A6d3.default)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $4o7uD.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4o7uD.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $9Rgf1.default)((0, $2xc7G.default)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $iscuz.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $gEUd4.default)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $gEUd4.default)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $gEUd4.default)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $gEUd4.default)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $e76iu.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("eVjpW", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $add5737403c6a16a$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $add5737403c6a16a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;

});


parcelRegister("g95sO", function(module, exports) {

$parcel$export(module.exports, "GridColumnUnsortedIcon", () => $bc11b9958af31e44$export$9e3e7f6bf3b8c7a7);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bc11b9958af31e44$var$_excluded = [
    "sortingOrder"
];
const $bc11b9958af31e44$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $acw62.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $1En50.default)(props, $bc11b9958af31e44$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $8nd05.default)({}, other)) : null;
});

});

parcelRegister("fWql6", function(module, exports) {

$parcel$export(module.exports, "GridArrowUpwardIcon", () => $b9b0b441ce479047$export$6de472a3df735882);
$parcel$export(module.exports, "GridArrowDownwardIcon", () => $b9b0b441ce479047$export$1f2d4db4a79871d4);
$parcel$export(module.exports, "GridKeyboardArrowRight", () => $b9b0b441ce479047$export$8da6370d9999894a);
$parcel$export(module.exports, "GridExpandMoreIcon", () => $b9b0b441ce479047$export$5b6f85a3ddabf4ca);
$parcel$export(module.exports, "GridFilterListIcon", () => $b9b0b441ce479047$export$cb1a577169e125de);
$parcel$export(module.exports, "GridFilterAltIcon", () => $b9b0b441ce479047$export$4f4f59585ffe8deb);
$parcel$export(module.exports, "GridSearchIcon", () => $b9b0b441ce479047$export$d33e6ad54b379a5d);
$parcel$export(module.exports, "GridColumnIcon", () => $b9b0b441ce479047$export$10a5a2f68ff67c50);
$parcel$export(module.exports, "GridSeparatorIcon", () => $b9b0b441ce479047$export$e918bd395b324de6);
$parcel$export(module.exports, "GridViewHeadlineIcon", () => $b9b0b441ce479047$export$3bcf566f7053b242);
$parcel$export(module.exports, "GridTableRowsIcon", () => $b9b0b441ce479047$export$adcade5d1a52a335);
$parcel$export(module.exports, "GridViewStreamIcon", () => $b9b0b441ce479047$export$60a4c153d2d7b084);
$parcel$export(module.exports, "GridTripleDotsVerticalIcon", () => $b9b0b441ce479047$export$2fbf0de7557957a8);
$parcel$export(module.exports, "GridCloseIcon", () => $b9b0b441ce479047$export$cbefef3cfb8e2783);
$parcel$export(module.exports, "GridAddIcon", () => $b9b0b441ce479047$export$e483c1441c7fca0b);
$parcel$export(module.exports, "GridRemoveIcon", () => $b9b0b441ce479047$export$d8fa92cc66e4dec8);
$parcel$export(module.exports, "GridLoadIcon", () => $b9b0b441ce479047$export$52992a9d5fa53c3c);
$parcel$export(module.exports, "GridDragIcon", () => $b9b0b441ce479047$export$305773dd821bb81d);
$parcel$export(module.exports, "GridSaveAltIcon", () => $b9b0b441ce479047$export$78df866ac12db1bd);
$parcel$export(module.exports, "GridCheckIcon", () => $b9b0b441ce479047$export$1f9ec58b2f66f46d);
$parcel$export(module.exports, "GridMoreVertIcon", () => $b9b0b441ce479047$export$6eaba7fcfbaac527);
$parcel$export(module.exports, "GridVisibilityOffIcon", () => $b9b0b441ce479047$export$9267feb6a6149971);
$parcel$export(module.exports, "GridViewColumnIcon", () => $b9b0b441ce479047$export$109d60d29e96616d);
$parcel$export(module.exports, "GridClearIcon", () => $b9b0b441ce479047$export$ab03f96923842ba7);
$parcel$export(module.exports, "GridDeleteForeverIcon", () => $b9b0b441ce479047$export$fc6ef585bd0ee189);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
const $b9b0b441ce479047$export$6de472a3df735882 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $b9b0b441ce479047$export$1f2d4db4a79871d4 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $b9b0b441ce479047$export$8da6370d9999894a = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $b9b0b441ce479047$export$5b6f85a3ddabf4ca = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $b9b0b441ce479047$export$cb1a577169e125de = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $b9b0b441ce479047$export$4f4f59585ffe8deb = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $b9b0b441ce479047$export$d33e6ad54b379a5d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $b9b0b441ce479047$export$3c3b03774b2ed8ce = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $b9b0b441ce479047$export$7a7700ab3e9c7e95 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $b9b0b441ce479047$export$10a5a2f68ff67c50 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const $b9b0b441ce479047$export$e918bd395b324de6 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 19V5h2v14z"
}), 'Separator');
const $b9b0b441ce479047$export$3bcf566f7053b242 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $b9b0b441ce479047$export$adcade5d1a52a335 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $b9b0b441ce479047$export$60a4c153d2d7b084 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $b9b0b441ce479047$export$2fbf0de7557957a8 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $b9b0b441ce479047$export$cbefef3cfb8e2783 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $b9b0b441ce479047$export$e483c1441c7fca0b = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $b9b0b441ce479047$export$d8fa92cc66e4dec8 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $b9b0b441ce479047$export$52992a9d5fa53c3c = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $b9b0b441ce479047$export$305773dd821bb81d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $b9b0b441ce479047$export$78df866ac12db1bd = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const $b9b0b441ce479047$export$1f9ec58b2f66f46d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $b9b0b441ce479047$export$6eaba7fcfbaac527 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $b9b0b441ce479047$export$9267feb6a6149971 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $b9b0b441ce479047$export$109d60d29e96616d = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $b9b0b441ce479047$export$ab03f96923842ba7 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
const $b9b0b441ce479047$export$4830297c7288dee4 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$export$fc6ef585bd0ee189 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');

});

parcelRegister("eUvXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaf162330f6a0fb$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $2iAqv = parcelRequire("2iAqv");

var $ayMG0 = parcelRequire("ayMG0");
const $adaf162330f6a0fb$var$_excluded = [
    "native"
];
function $adaf162330f6a0fb$export$2e2bcd8739ae039(_ref) {
    let { native: native } = _ref, props = (0, $1En50.default)(_ref, $adaf162330f6a0fb$var$_excluded);
    if (native) return /*#__PURE__*/ (0, $ayMG0.jsx)("option", (0, $8nd05.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), (0, $8nd05.default)({}, props));
}

});



parcelRegister("4Yqqs", function(module, exports) {

$parcel$export(module.exports, "computeSlots", () => $39f1439fa7b8d5d4$export$247af54f7c54fca);

var $8nd05 = parcelRequire("8nd05");

var $cBO5b = parcelRequire("cBO5b");
function $39f1439fa7b8d5d4$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots, components: components }) {
    const overrides = slots != null ? slots : components ? (0, $cBO5b.uncapitalizeObjectKeys)(components) : null;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $8nd05.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}

});
parcelRegister("cBO5b", function(module, exports) {

$parcel$export(module.exports, "uncapitalizeObjectKeys", () => $92dfca1612ea5980$export$ee17bc394843b249);

var $8nd05 = parcelRequire("8nd05");
const $92dfca1612ea5980$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $8nd05.default)({}, acc, {
            [`${key.charAt(0).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};

});


parcelRegister("4cd9P", function(module, exports) {

$parcel$export(module.exports, "useProps", () => $30e27d3e1a9d8664$export$1f264be2c424fccf);

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
const $30e27d3e1a9d8664$var$_excluded = [
    "components",
    "componentsProps"
];
/** Gathers props for the root element into a single `.forwardedProps` field */ function $30e27d3e1a9d8664$var$groupForwardedProps(props) {
    var _props$forwardedProps;
    const keys = Object.keys(props);
    if (!keys.some((key)=>key.startsWith('aria-') || key.startsWith('data-'))) return props;
    const newProps = {};
    const forwardedProps = (_props$forwardedProps = props.forwardedProps) != null ? _props$forwardedProps : {};
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (key.startsWith('aria-') || key.startsWith('data-')) forwardedProps[key] = props[key];
        else newProps[key] = props[key];
    }
    newProps.forwardedProps = forwardedProps;
    return newProps;
}
function $30e27d3e1a9d8664$export$1f264be2c424fccf(allProps) {
    return $acw62.useMemo(()=>{
        const { components: components, componentsProps: componentsProps } = allProps, themedProps = (0, $1En50.default)(allProps, $30e27d3e1a9d8664$var$_excluded);
        return [
            components,
            componentsProps,
            $30e27d3e1a9d8664$var$groupForwardedProps(themedProps)
        ];
    }, [
        allProps
    ]);
}

});



parcelRegister("lb6pq", function(module, exports) {

$parcel$export(module.exports, "useGridStatePersistence", () => $f6af98c761dea48b$export$971de86bde7f86a1);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $f6af98c761dea48b$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $acw62.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $acw62.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, statePersistenceApi, 'public');
};

});

parcelRegister("2H9Fl", function(module, exports) {

$parcel$export(module.exports, "useGridColumnSpanning", () => $1f67185743ff4f77$export$ce7ce4871097b52e);

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");

var $eFF1m = parcelRequire("eFF1m");
const $1f67185743ff4f77$export$ce7ce4871097b52e = (apiRef)=>{
    const lookup = $acw62.useRef({});
    const setCellColSpanInfo = $acw62.useCallback((rowId, columnIndex, cellColSpanInfo)=>{
        const sizes = lookup.current;
        if (!sizes[rowId]) sizes[rowId] = {};
        sizes[rowId][columnIndex] = cellColSpanInfo;
    }, []);
    const getCellColSpanInfo = $acw62.useCallback((rowId, columnIndex)=>{
        var _lookup$current$rowId;
        return (_lookup$current$rowId = lookup.current[rowId]) == null ? void 0 : _lookup$current$rowId[columnIndex];
    }, []);
    // Calculate `colSpan` for the cell.
    const calculateCellColSpan = $acw62.useCallback((params)=>{
        const { columnIndex: columnIndex, rowId: rowId, minFirstColumnIndex: minFirstColumnIndex, maxLastColumnIndex: maxLastColumnIndex, columns: columns } = params;
        const columnsLength = columns.length;
        const column = columns[columnIndex];
        const colSpan = typeof column.colSpan === 'function' ? column.colSpan(apiRef.current.getCellParams(rowId, column.field)) : column.colSpan;
        if (!colSpan || colSpan === 1) {
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: 1,
                    width: column.computedWidth
                }
            });
            return {
                colSpan: 1
            };
        }
        let width = column.computedWidth;
        for(let j = 1; j < colSpan; j += 1){
            const nextColumnIndex = columnIndex + j;
            // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
            if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
                const nextColumn = columns[nextColumnIndex];
                width += nextColumn.computedWidth;
                setCellColSpanInfo(rowId, columnIndex + j, {
                    spannedByColSpan: true,
                    rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                    leftVisibleCellIndex: columnIndex
                });
            }
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: colSpan,
                    width: width
                }
            });
        }
        return {
            colSpan: colSpan
        };
    }, [
        apiRef,
        setCellColSpanInfo
    ]);
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = $acw62.useCallback(({ rowId: rowId, minFirstColumn: minFirstColumn, maxLastColumn: maxLastColumn, columns: columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = calculateCellColSpan({
                columnIndex: i,
                rowId: rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns: columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        calculateCellColSpan
    ]);
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        calculateColSpan: calculateColSpan
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPrivateApi, 'private');
    const handleColumnReorderChange = $acw62.useCallback(()=>{
        // `colSpan` needs to be recalculated after column reordering
        lookup.current = {};
    }, []);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnOrderChange', handleColumnReorderChange);
};

});

parcelRegister("aFlgz", function(module, exports) {

$parcel$export(module.exports, "columnGroupsStateInitializer", () => $7c3e3abbe30f48e1$export$21c841dc431b3cd0);
$parcel$export(module.exports, "useGridColumnGrouping", () => $7c3e3abbe30f48e1$export$510984a37e2e33f3);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $j57st = parcelRequire("j57st");

var $hMyIf = parcelRequire("hMyIf");

var $ivFej = parcelRequire("ivFej");

var $vzN4X = parcelRequire("vzN4X");

var $eFF1m = parcelRequire("eFF1m");

var $jQEEt = parcelRequire("jQEEt");
const $7c3e3abbe30f48e1$var$_excluded = [
    "groupId",
    "children"
];
const $7c3e3abbe30f48e1$var$createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, $j57st.isLeaf)(node)) return;
        const { groupId: groupId, children: children } = node, other = (0, $1En50.default)(node, $7c3e3abbe30f48e1$var$_excluded);
        if (!groupId) throw new Error('MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        if (!children) console.warn(`MUI: group groupId=${groupId} has no children.`);
        const groupParam = (0, $8nd05.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $7c3e3abbe30f48e1$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, $8nd05.default)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, $8nd05.default)({}, groupLookup);
};
const $7c3e3abbe30f48e1$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    var _props$experimentalFe, _props$columnGrouping, _props$columnGrouping2, _apiRef$current$state;
    if (!((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.columnGrouping)) return state;
    const columnFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
    const visibleColumnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef);
    const groupLookup = $7c3e3abbe30f48e1$var$createGroupLookup((_props$columnGrouping = props.columnGroupingModel) != null ? _props$columnGrouping : []);
    const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)((_props$columnGrouping2 = props.columnGroupingModel) != null ? _props$columnGrouping2 : []);
    const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, (_apiRef$current$state = apiRef.current.state.pinnedColumns) != null ? _apiRef$current$state : {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>{
        var _unwrappedGroupingMod, _unwrappedGroupingMod2;
        return (_unwrappedGroupingMod = (_unwrappedGroupingMod2 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod2.length) != null ? _unwrappedGroupingMod : 0;
    }));
    return (0, $8nd05.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $7c3e3abbe30f48e1$export$510984a37e2e33f3 = (apiRef, props)=>{
    var _props$experimentalFe3;
    /**
   * API METHODS
   */ const getColumnGroupPath = $acw62.useCallback((field)=>{
        var _unwrappedGroupingMod3;
        const unwrappedGroupingModel = (0, $hMyIf.gridColumnGroupsUnwrappedModelSelector)(apiRef);
        return (_unwrappedGroupingMod3 = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod3 : [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $acw62.useCallback(()=>{
        const columnGroupLookup = (0, $hMyIf.gridColumnGroupsLookupSelector)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        unstable_getColumnGroupPath: getColumnGroupPath,
        unstable_getAllGroupDetails: getAllGroupDetails
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $acw62.useCallback(()=>{
        var _props$columnGrouping3;
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)((_props$columnGrouping3 = props.columnGroupingModel) != null ? _props$columnGrouping3 : []);
        apiRef.current.setState((state)=>{
            var _state$columns$ordere, _state$columns, _state$pinnedColumns;
            const orderedFields = (_state$columns$ordere = (_state$columns = state.columns) == null ? void 0 : _state$columns.orderedFields) != null ? _state$columns$ordere : [];
            // @ts-expect-error Move this logic to `Pro` package
            const pinnedColumns = (_state$pinnedColumns = state.pinnedColumns) != null ? _state$pinnedColumns : {};
            const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $8nd05.default)({}, state, {
                columnGrouping: (0, $8nd05.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $acw62.useCallback((columnGroupingModel)=>{
        var _props$experimentalFe2, _apiRef$current$getPi, _apiRef$current$getPi2, _apiRef$current;
        if (!((_props$experimentalFe2 = props.experimentalFeatures) != null && _props$experimentalFe2.columnGrouping)) return;
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = (_apiRef$current$getPi = (_apiRef$current$getPi2 = (_apiRef$current = apiRef.current).getPinnedColumns) == null ? void 0 : _apiRef$current$getPi2.call(_apiRef$current)) != null ? _apiRef$current$getPi : {};
        const columnFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const visibleColumnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef);
        const groupLookup = $7c3e3abbe30f48e1$var$createGroupLookup(columnGroupingModel != null ? columnGroupingModel : []);
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(columnGroupingModel != null ? columnGroupingModel : []);
        const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>{
            var _unwrappedGroupingMod4, _unwrappedGroupingMod5;
            return (_unwrappedGroupingMod4 = (_unwrappedGroupingMod5 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod5.length) != null ? _unwrappedGroupingMod4 : 0;
        }));
        apiRef.current.setState((state)=>{
            return (0, $8nd05.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef,
        (_props$experimentalFe3 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe3.columnGrouping
    ]);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $eFF1m.useGridApiEventHandler)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};

});
parcelRegister("j57st", function(module, exports) {

$parcel$export(module.exports, "isLeaf", () => $de4444ff1794c3fb$export$e132ced8f644a612);
function $de4444ff1794c3fb$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 

});

parcelRegister("vzN4X", function(module, exports) {

$parcel$export(module.exports, "unwrapGroupingColumnModel", () => $05eea8a1c02f601e$export$ea425f87fd536c4d);
$parcel$export(module.exports, "getColumnGroupsHeaderStructure", () => $05eea8a1c02f601e$export$c41225ff45feeb0e);

var $j57st = parcelRequire("j57st");

var $lR3Vo = parcelRequire("lR3Vo");
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $j57st.isLeaf)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $05eea8a1c02f601e$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $05eea8a1c02f601e$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>{
        var _unwrappedGroupingMod;
        return (_unwrappedGroupingMod = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod : [];
    };
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>(0, $lR3Vo.isDeepEqual)(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    const haveDifferentContainers = (field1, field2)=>{
        if (pinnedFields != null && pinnedFields.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) return true;
        if (pinnedFields != null && pinnedFields.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) return true;
        return false;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = orderedColumns.reduce((structure, newField)=>{
            var _getParents$depth;
            const groupId = (_getParents$depth = getParents(newField)[depth]) != null ? _getParents$depth : null;
            if (structure.length === 0) return [
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            const lastGroup = structure[structure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            const prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) // It's a new group
            return [
                ...structure,
                {
                    columnFields: [
                        newField
                    ],
                    groupId: groupId
                }
            ];
            // It extends the previous group
            return [
                ...structure.slice(0, structure.length - 1),
                {
                    columnFields: [
                        ...lastGroup.columnFields,
                        newField
                    ],
                    groupId: groupId
                }
            ];
        }, []);
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};

});


parcelRegister("dfzFI", function(module, exports) {

$parcel$export(module.exports, "virtualizationStateInitializer", () => $9a5858bc9bdcaed0$export$42963ad70bb69f54);
$parcel$export(module.exports, "useGridVirtualization", () => $9a5858bc9bdcaed0$export$aa0d6df32cccbd53);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $ivFej = parcelRequire("ivFej");
const $9a5858bc9bdcaed0$export$42963ad70bb69f54 = (state, props)=>{
    const virtualization = {
        enabled: !props.disableVirtualization,
        enabledForColumns: true
    };
    return (0, $8nd05.default)({}, state, {
        virtualization: virtualization
    });
};
function $9a5858bc9bdcaed0$export$aa0d6df32cccbd53(apiRef, props) {
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    enabled: enabled
                })
            }));
    };
    const setColumnVirtualization = (enabled)=>{
        apiRef.current.setState((state)=>(0, $8nd05.default)({}, state, {
                virtualization: (0, $8nd05.default)({}, state.virtualization, {
                    enabledForColumns: enabled
                })
            }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $ivFej.useGridApiMethod)(apiRef, api, 'public');
    /*
   * EFFECTS
   */ /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(()=>{
        setVirtualization(!props.disableVirtualization);
    }, [
        props.disableVirtualization
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("kaLFi", function(module, exports) {

$parcel$export(module.exports, "DataGridVirtualScroller", () => $eaf9b720e6ed9ffd$export$91a85431cd3a03b4);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $1etk0 = parcelRequire("1etk0");

var $lLmsJ = parcelRequire("lLmsJ");

var $5v0S6 = parcelRequire("5v0S6");

var $fHEg1 = parcelRequire("fHEg1");

var $6ru7t = parcelRequire("6ru7t");

var $ayMG0 = parcelRequire("ayMG0");
const $eaf9b720e6ed9ffd$var$_excluded = [
    "className"
];
const $eaf9b720e6ed9ffd$export$91a85431cd3a03b4 = /*#__PURE__*/ $acw62.forwardRef(function DataGridVirtualScroller(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $eaf9b720e6ed9ffd$var$_excluded);
    const { getRootProps: getRootProps, getContentProps: getContentProps, getRenderZoneProps: getRenderZoneProps, getRows: getRows } = (0, $fHEg1.useGridVirtualScroller)({
        ref: ref
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1etk0.GridVirtualScroller), (0, $8nd05.default)({
        className: className
    }, getRootProps(other), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ru7t.GridOverlays), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lLmsJ.GridVirtualScrollerContent), (0, $8nd05.default)({}, getContentProps(), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5v0S6.GridVirtualScrollerRenderZone), (0, $8nd05.default)({}, getRenderZoneProps(), {
                    children: getRows()
                }))
            }))
        ]
    }));
});

});
parcelRegister("1etk0", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScroller", () => $0e5dd7e9e576a614$export$febd8ae712031b27);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $0e5dd7e9e576a614$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScroller'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $0e5dd7e9e576a614$var$VirtualScrollerRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>styles.virtualScroller
})({
    overflow: 'auto',
    height: '100%',
    // See https://github.com/mui/mui-x/issues/4360
    position: 'relative',
    '@media print': {
        overflow: 'hidden'
    },
    zIndex: 0 // See https://github.com/mui/mui-x/issues/10547
});
const $0e5dd7e9e576a614$export$febd8ae712031b27 = /*#__PURE__*/ $acw62.forwardRef(function GridVirtualScroller(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0e5dd7e9e576a614$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0e5dd7e9e576a614$var$VirtualScrollerRoot, (0, $8nd05.default)({
        ref: ref
    }, props, {
        className: (0, $9QePP.default)(classes.root, props.className),
        ownerState: rootProps
    }));
});

});

parcelRegister("lLmsJ", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollerContent", () => $fd7f69586e4a3224$export$97d48eb8ba00afb8);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $fd7f69586e4a3224$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $fd7f69586e4a3224$var$VirtualScrollerContentRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>styles.virtualScrollerContent
})({});
const $fd7f69586e4a3224$export$97d48eb8ba00afb8 = /*#__PURE__*/ $acw62.forwardRef(function GridVirtualScrollerContent(props, ref) {
    var _props$style;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const overflowedContent = !rootProps.autoHeight && ((_props$style = props.style) == null ? void 0 : _props$style.minHeight) === 'auto';
    const classes = $fd7f69586e4a3224$var$useUtilityClasses(rootProps, overflowedContent);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fd7f69586e4a3224$var$VirtualScrollerContentRoot, (0, $8nd05.default)({
        ref: ref
    }, props, {
        ownerState: rootProps,
        className: (0, $9QePP.default)(classes.root, props.className)
    }));
});

});

parcelRegister("5v0S6", function(module, exports) {

$parcel$export(module.exports, "GridVirtualScrollerRenderZone", () => $401086177e70acda$export$95930d31e6a9269f);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $401086177e70acda$var$_excluded = [
    "className"
];
const $401086177e70acda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
const $401086177e70acda$var$VirtualScrollerRenderZoneRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone',
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $401086177e70acda$export$95930d31e6a9269f = /*#__PURE__*/ $acw62.forwardRef(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $1En50.default)(props, $401086177e70acda$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $401086177e70acda$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($401086177e70acda$var$VirtualScrollerRenderZoneRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

});

parcelRegister("6ru7t", function(module, exports) {

$parcel$export(module.exports, "GridOverlays", () => $4b0ca0cb82103871$export$867f5fc44327bee5);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $0tqaY = parcelRequire("0tqaY");

var $8Indx = parcelRequire("8Indx");
var $eEJPp = parcelRequire("eEJPp");

var $9QePP = parcelRequire("9QePP");

var $5sOMZ = parcelRequire("5sOMZ");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $7sDf4 = parcelRequire("7sDf4");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $4b0ca0cb82103871$var$GridOverlayWrapperRoot = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType',
    overridesResolver: (props, styles)=>styles.overlayWrapper
})(({ overlayType: overlayType })=>({
        position: 'sticky',
        // To stay in place while scrolling
        top: 0,
        left: 0,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    }));
const $4b0ca0cb82103871$var$GridOverlayWrapperInner = (0, $0tqaY.default)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType',
    overridesResolver: (props, styles)=>styles.overlayWrapperInner
})({});
const $4b0ca0cb82103871$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5H1vo.getDataGridUtilityClass), classes);
};
function $4b0ca0cb82103871$var$GridOverlayWrapper(props) {
    var _viewportInnerSize$he, _viewportInnerSize$wi;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [viewportInnerSize, setViewportInnerSize] = $acw62.useState(()=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        return (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize) != null ? _apiRef$current$getRo : null;
    });
    const handleViewportSizeChange = $acw62.useCallback(()=>{
        var _apiRef$current$getRo3, _apiRef$current$getRo4;
        setViewportInnerSize((_apiRef$current$getRo3 = (_apiRef$current$getRo4 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo4.viewportInnerSize) != null ? _apiRef$current$getRo3 : null);
    }, [
        apiRef
    ]);
    (0, $eEJPp.default)(()=>{
        return apiRef.current.subscribeEvent('viewportInnerSizeChange', handleViewportSizeChange);
    }, [
        apiRef,
        handleViewportSizeChange
    ]);
    let height = (_viewportInnerSize$he = viewportInnerSize == null ? void 0 : viewportInnerSize.height) != null ? _viewportInnerSize$he : 0;
    if (rootProps.autoHeight && height === 0) height = (0, $7sDf4.getMinimalContentHeight)(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
    const classes = $4b0ca0cb82103871$var$useUtilityClasses((0, $8nd05.default)({}, props, {
        classes: rootProps.classes
    }));
    if (!viewportInnerSize) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperRoot, {
        className: (0, $9QePP.default)(classes.root),
        overlayType: props.overlayType,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperInner, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.inner),
            style: {
                height: height,
                width: (_viewportInnerSize$wi = viewportInnerSize == null ? void 0 : viewportInnerSize.width) != null ? _viewportInnerSize$wi : 0
            }
        }, props))
    });
}
function $4b0ca0cb82103871$export$867f5fc44327bee5() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowCountSelector));
    const visibleRowCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $k278Q.gridExpandedRowCountSelector));
    const loading = (0, $5sOMZ.useGridSelector)(apiRef, (0, $goCyd.gridRowsLoadingSelector));
    const showNoRowsOverlay = !loading && totalRowCount === 0;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlay = null;
    let overlayType = '';
    if (showNoRowsOverlay) {
        var _rootProps$slotProps;
        overlay = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.noRowsOverlay, (0, $8nd05.default)({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.noRowsOverlay));
        overlayType = 'noRowsOverlay';
    }
    if (showNoResultsOverlay) {
        var _rootProps$slotProps2;
        overlay = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.noResultsOverlay, (0, $8nd05.default)({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.noResultsOverlay));
        overlayType = 'noResultsOverlay';
    }
    if (loading) {
        var _rootProps$slotProps3;
        overlay = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadingOverlay, (0, $8nd05.default)({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.loadingOverlay));
        overlayType = 'loadingOverlay';
    }
    if (overlay === null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapper, {
        overlayType: overlayType,
        children: overlay
    });
}

});



parcelRegister("7JB23", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("lbArK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5zbQZ").then(()=>parcelRequire('i8Fxz'));

});

parcelRegister("l3dTC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("14NDh").then(()=>parcelRequire('5vLkJ'));

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


parcelRegister("lL8FI", function(module, exports) {
"use strict";
var $fd74b6c8cdbd50c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd74b6c8cdbd50c8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fd74b6c8cdbd50c8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fd74b6c8cdbd50c8$var$__createBinding(result, mod, k);
    }
    $fd74b6c8cdbd50c8$var$__setModuleDefault(result, mod);
    return result;
};
var $fd74b6c8cdbd50c8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivacyTextProvider = void 0;

/* eslint-disable complexity */ const $fd74b6c8cdbd50c8$var$react_1 = $fd74b6c8cdbd50c8$var$__importDefault((parcelRequire("acw62")));

var $ei5fP = parcelRequire("ei5fP");

const $fd74b6c8cdbd50c8$var$en_US_1 = $fd74b6c8cdbd50c8$var$__importDefault((parcelRequire("4rH9E")));
const $fd74b6c8cdbd50c8$var$PrivacyTextContext = $fd74b6c8cdbd50c8$var$react_1.default.createContext({
    ...$fd74b6c8cdbd50c8$var$en_US_1.default,
    headingReadMoreURL: ''
});










const $fd74b6c8cdbd50c8$var$getTextPromise = (locale)=>{
    switch(locale){
        case 'de-AT':
        case 'de-BE':
        case 'de-CH':
        case 'de-DE':
        case 'de-DE':
        case 'de-LI':
        case 'de-LU':
            return Promise.resolve().then(function() {
                return (parcelRequire("dZErG"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'en-AE':
        case 'en-AU':
        case 'en-BN':
        case 'en-BT':
        case 'en-BW':
        case 'en-CA':
        case 'en-GB':
        case 'en-HK':
        case 'en-IE':
        case 'en-IL':
        case 'en-KW':
        case 'en-MT':
        case 'en-PH':
        case 'en-QA':
        case 'en-SA':
        case 'en-SG':
        case 'en-TM':
        case 'en-US':
            return Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("4rH9E")));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'es-AD':
        case 'es-AR':
        case 'es-CL':
        case 'es-CO':
        case 'es-ES':
        case 'es-LATAM':
        case 'es-PE':
        case 'es-PY':
        case 'es-US':
            return Promise.resolve().then(function() {
                return (parcelRequire("ol1rE"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'fr-BE':
        case 'fr-CA':
        case 'fr-CH':
        case 'fr-FR':
        case 'fr-LU':
        case 'fr-MC':
            return Promise.resolve().then(function() {
                return (parcelRequire("fcdns"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'it-CH':
        case 'it-IT':
        case 'it-SM':
            return Promise.resolve().then(function() {
                return (parcelRequire("aFZkE"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'ja-JP':
            return Promise.resolve().then(function() {
                return (parcelRequire("eEfdD"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'ko-KR':
            return Promise.resolve().then(function() {
                return (parcelRequire("bZ3dr"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'nl-BE':
        case 'nl-NL':
            return Promise.resolve().then(function() {
                return (parcelRequire("1tiHz"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'pt-BR':
        case 'pt-PT':
            return Promise.resolve().then(function() {
                return (parcelRequire("geEyc"));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
        case 'zh-HK':
        case 'zh-SG':
        case 'zh-TW':
            // TODO: SPKVX-882 we need Chinese translations
            return Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("4rH9E")));
            }).then((res)=>$fd74b6c8cdbd50c8$var$__importStar(res));
    }
};
const $fd74b6c8cdbd50c8$var$getPrivacyURLLocale = (locale)=>{
    switch(locale){
        case 'de-CH':
            return 'de-CH';
        case 'de-AT':
        case 'de-BE':
        case 'de-LI':
        case 'de-LU':
        case 'de-DE':
            return 'de-DE';
        case 'en-AE':
        case 'en-BN':
        case 'en-BT':
        case 'en-BW':
        case 'en-IE':
        case 'en-IL':
        case 'en-KW':
        case 'en-MT':
        case 'en-PH':
        case 'en-QA':
        case 'en-SA':
        case 'en-TM':
        case 'en-AU':
            return 'en-AU';
        case 'en-CA':
            return 'en-CA';
        case 'pt-PT':
        case 'en-GB':
            return 'en-GB';
        case 'en-HK':
            return 'en-HK';
        case 'en-SG':
            return 'en-SG';
        case 'en-US':
            return 'en-US';
        case 'es-AD':
        case 'es-ES':
            return 'es-ES';
        case 'es-AR':
        case 'es-CL':
        case 'es-CO':
        case 'es-PE':
        case 'es-PY':
        case 'es-LATAM':
            return 'es-LATAM';
        case 'es-US':
            return 'en-US';
        case 'fr-CA':
            return 'fr-CA';
        case 'fr-CH':
            return 'fr-CH';
        case 'fr-BE':
        case 'fr-LU':
        case 'fr-MC':
        case 'fr-FR':
            return 'fr-FR';
        case 'it-CH':
            return 'it-CH';
        case 'it-SM':
        case 'it-IT':
            return 'it-IT';
        case 'ja-JP':
            return 'ja-JP';
        case 'ko-KR':
            return 'ko-KR';
        case 'nl-BE':
        case 'nl-NL':
            return 'nl-NL';
        case 'pt-BR':
            return 'pt-BR';
        case 'zh-HK':
            return 'zh-HK';
        case 'zh-SG':
            return 'zh-SG';
        case 'zh-TW':
            return 'zh-TW';
    }
};
const $fd74b6c8cdbd50c8$var$PrivacyTextProvider = ({ children: children, locale: locale, readMoreURL: readMoreURL })=>{
    const [text, setText] = $fd74b6c8cdbd50c8$var$react_1.default.useState({
        ...$fd74b6c8cdbd50c8$var$en_US_1.default,
        headingReadMoreURL: ''
    });
    const textPromise = $fd74b6c8cdbd50c8$var$react_1.default.useMemo(()=>{
        const localeSupported = $ei5fP.locales.includes(locale) ? locale : 'en-US';
        return $fd74b6c8cdbd50c8$var$getTextPromise(localeSupported);
    }, [
        locale
    ]);
    const headingReadMoreURL = readMoreURL !== null && readMoreURL !== void 0 ? readMoreURL : `https://www.modernatx.com/${$fd74b6c8cdbd50c8$var$getPrivacyURLLocale(locale)}/cookie-statement`;
    $fd74b6c8cdbd50c8$var$react_1.default.useEffect(()=>{
        textPromise.then((result)=>setText({
                ...result.default,
                headingReadMoreURL: headingReadMoreURL
            }));
    }, [
        locale,
        textPromise,
        headingReadMoreURL
    ]);
    return $fd74b6c8cdbd50c8$var$react_1.default.createElement($fd74b6c8cdbd50c8$var$PrivacyTextContext.Provider, {
        value: text
    }, children);
};
module.exports.PrivacyTextProvider = $fd74b6c8cdbd50c8$var$PrivacyTextProvider;
const $fd74b6c8cdbd50c8$var$usePrivacyText = ()=>{
    return $fd74b6c8cdbd50c8$var$react_1.default.useContext($fd74b6c8cdbd50c8$var$PrivacyTextContext);
};
module.exports.default = $fd74b6c8cdbd50c8$var$usePrivacyText;

});
parcelRegister("ei5fP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.locales = void 0;
module.exports.locales = [
    'de-AT',
    'de-BE',
    'de-CH',
    'de-DE',
    'de-LI',
    'de-LU',
    'en-AE',
    'en-AU',
    'en-BN',
    'en-BT',
    'en-BW',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IL',
    'en-KW',
    'en-MT',
    'en-PH',
    'en-QA',
    'en-SA',
    'en-SG',
    'en-TM',
    'en-US',
    'es-AD',
    'es-AR',
    'es-CL',
    'es-CO',
    'es-ES',
    'es-LATAM',
    'es-PE',
    'es-PY',
    'es-US',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'fr-LU',
    'fr-MC',
    'it-CH',
    'it-IT',
    'it-SM',
    'ja-JP',
    'ko-KR',
    'nl-BE',
    'nl-NL',
    'pt-BR',
    'pt-PT',
    'zh-HK',
    'zh-SG',
    'zh-TW'
];

});

parcelRegister("4rH9E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $33cb28a79f266b05$var$text = {
    accept: 'Accept',
    amplitudeDescription: 'Product Analytics to capture on-site engagement and conversion data.',
    amplitudeDuration: '30 days',
    amplitudeProvider: 'Amplitude',
    deny: 'Deny',
    duration: 'Duration:',
    heading: 'We collect cookies',
    headingDescription: 'This website stores data such as cookies to enable essential site functionality, as well as marketing and performance.',
    headingReadMore: 'Read more',
    marketingDescription: "These items are used to deliver advertising that is more relevant to you and your interests. They may also be used to limit the number of times you see an advertisement and measure the effectiveness of advertising campaigns. Advertising networks usually place them with the website operator's permission.",
    marketingHeading: 'Marketing',
    performanceDescription: "These items help the website operator understand how its website performs, how visitors interact with the site, and whether there may be technical issues. This storage type usually doesn't collect information that identifies a visitor.",
    performanceHeading: 'Performance',
    purpose: 'Purpose:',
    showCookieConsentOptions: 'Show cookie consent options',
    showDetails: 'Show details',
    showLess: 'Show less',
    strictlyNecessaryDescription: 'These items are required to enable basic website functionality.',
    strictlyNecessaryHeading: 'Strictly necessary'
};
module.exports.default = $33cb28a79f266b05$var$text;

});

parcelRegister("dZErG", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iNxFD").then(()=>parcelRequire('1lf5O'));

});

parcelRegister("ol1rE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6P3bO").then(()=>parcelRequire('cfuvm'));

});

parcelRegister("fcdns", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4W2xh").then(()=>parcelRequire('5mfga'));

});

parcelRegister("aFZkE", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dT7fa").then(()=>parcelRequire('9BvPc'));

});

parcelRegister("eEfdD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iWNK4").then(()=>parcelRequire('fnmfG'));

});

parcelRegister("bZ3dr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dAQTN").then(()=>parcelRequire('4PL1J'));

});

parcelRegister("1tiHz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cPbON").then(()=>parcelRequire('95hwD'));

});

parcelRegister("geEyc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eInqO").then(()=>parcelRequire('9z9D8'));

});


parcelRegister("4mdOE", function(module, exports) {
"use strict";
var $32c3ef0c689163b8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $32c3ef0c689163b8$var$react_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("acw62")));

const $32c3ef0c689163b8$var$storage_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("855hF")));

const $32c3ef0c689163b8$var$ClientSideRenderOnly_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("7opEO")));

const $32c3ef0c689163b8$var$PrivacyCaret_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("1H65O")));

const $32c3ef0c689163b8$var$PrivacyGear_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("3eByZ")));

const $32c3ef0c689163b8$var$PrivacyGroup_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("3cUE4")));

var $1qrho = parcelRequire("1qrho");

const $32c3ef0c689163b8$var$usePrivacyText_1 = $32c3ef0c689163b8$var$__importDefault((parcelRequire("lL8FI")));
const $32c3ef0c689163b8$var$PrivacyModal = ({ categories: categories, onOptInChange: onOptInChange })=>{
    const interacted = $32c3ef0c689163b8$var$react_1.default.useRef($32c3ef0c689163b8$var$storage_1.default.getItem('MDRNA_CONSENT') !== null);
    const [detailsExpanded, setDetailsExpanded] = $32c3ef0c689163b8$var$react_1.default.useState(false);
    const [categoriesSelected, setCategoriesSelected] = $32c3ef0c689163b8$var$react_1.default.useState(()=>{
        var _a;
        const categoriesStored = (_a = $32c3ef0c689163b8$var$storage_1.default.getItem('MDRNA_CONSENT')) === null || _a === void 0 ? void 0 : _a.split(',');
        // If the categories have never been stored, mark them all as on by
        // default. This won't enable them, just have them appear enabled.
        if (!(categoriesStored === null || categoriesStored === void 0 ? void 0 : categoriesStored.length)) return categories;
        else return categories.filter((category)=>categoriesStored.includes(category));
    });
    const [visible, setVisible] = $32c3ef0c689163b8$var$react_1.default.useState(()=>$32c3ef0c689163b8$var$storage_1.default.getItem('MDRNA_CONSENT') === null);
    const text = (0, $32c3ef0c689163b8$var$usePrivacyText_1.default)();
    const handleDetailsToggleClick = $32c3ef0c689163b8$var$react_1.default.useCallback(()=>{
        setDetailsExpanded(!detailsExpanded);
    }, [
        detailsExpanded,
        setDetailsExpanded
    ]);
    const handleCategoriesSelect = $32c3ef0c689163b8$var$react_1.default.useCallback((categoriesNext)=>{
        interacted.current = true;
        setCategoriesSelected(categoriesNext);
    }, []);
    const handleOptOutAllClick = $32c3ef0c689163b8$var$react_1.default.useCallback(()=>{
        setVisible(false);
        setCategoriesSelected([
            'necessary'
        ]);
        $32c3ef0c689163b8$var$storage_1.default.setItem('MDRNA_CONSENT', 'necessary');
        categories.forEach((category)=>category !== 'necessary' && onOptInChange(category, false));
    }, [
        categories,
        onOptInChange
    ]);
    const handleOptInAllClick = $32c3ef0c689163b8$var$react_1.default.useCallback(()=>{
        setVisible(false);
        $32c3ef0c689163b8$var$storage_1.default.setItem('MDRNA_CONSENT', categoriesSelected.join(','));
        categories.forEach((category)=>category !== 'necessary' && onOptInChange(category, categoriesSelected.includes(category)));
    }, [
        categories,
        categoriesSelected,
        onOptInChange
    ]);
    const handlePrivacyGearChange = $32c3ef0c689163b8$var$react_1.default.useCallback((visibleNext)=>{
        setVisible(visibleNext);
        // If the checkboxes have been interacted with, assume the intention was to
        // save the current opt in state.
        if (interacted.current && visibleNext === false) {
            $32c3ef0c689163b8$var$storage_1.default.setItem('MDRNA_CONSENT', categoriesSelected.join(','));
            categories.forEach((category)=>category !== 'necessary' && onOptInChange(category, categoriesSelected.includes(category)));
        }
    }, [
        categories,
        categoriesSelected,
        onOptInChange
    ]);
    $32c3ef0c689163b8$var$react_1.default.useEffect(()=>{
        const idAttribute = 'PrivacyModalStyles';
        if (!document.getElementById(idAttribute)) {
            const styleSheet = document.createElement('style');
            styleSheet.setAttribute('id', idAttribute);
            styleSheet.innerText = (0, $1qrho.getStyles)();
            document.head.appendChild(styleSheet);
        }
        return ()=>{
            var _a;
            (_a = document.getElementById(idAttribute)) === null || _a === void 0 || _a.remove();
        };
    }, []);
    if (!visible) return $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyGear_1.default, {
        onChange: handlePrivacyGearChange,
        visible: visible
    });
    return $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$react_1.default.Fragment, null, $32c3ef0c689163b8$var$react_1.default.createElement("div", {
        className: "privacy__overlay"
    }), $32c3ef0c689163b8$var$react_1.default.createElement("div", {
        className: "privacy__content"
    }, $32c3ef0c689163b8$var$react_1.default.createElement("h2", {
        className: "privacy__text privacy__heading"
    }, text.heading), $32c3ef0c689163b8$var$react_1.default.createElement("p", {
        className: "privacy__text"
    }, text.headingDescription, "\u00A0", $32c3ef0c689163b8$var$react_1.default.createElement("a", {
        className: "privacy__link",
        href: text.headingReadMoreURL,
        target: "_blank",
        rel: "noreferrer"
    }, text.headingReadMore)), detailsExpanded && $32c3ef0c689163b8$var$react_1.default.createElement("div", {
        className: "privacy__groups"
    }, $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyGroup_1.default, {
        description: text.strictlyNecessaryDescription,
        category: "necessary",
        categoriesSelected: categoriesSelected,
        setCategoriesSelected: handleCategoriesSelect,
        title: text.strictlyNecessaryHeading
    }), categories.includes('performance') && $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyGroup_1.default, {
        categoriesSelected: categoriesSelected,
        category: "performance",
        description: text.performanceDescription,
        setCategoriesSelected: handleCategoriesSelect,
        title: text.performanceHeading,
        tools: [
            {
                description: text.amplitudeDescription,
                duration: text.amplitudeDuration,
                provider: text.amplitudeProvider
            }
        ]
    })), $32c3ef0c689163b8$var$react_1.default.createElement("div", {
        className: "privacy__footer"
    }, $32c3ef0c689163b8$var$react_1.default.createElement("button", {
        className: "privacy__text privacy__expand",
        onClick: handleDetailsToggleClick,
        role: "button"
    }, detailsExpanded ? text.showLess : text.showDetails, $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyCaret_1.default, {
        expanded: detailsExpanded
    })), $32c3ef0c689163b8$var$react_1.default.createElement("div", {
        className: "privacy__footer__ctas"
    }, $32c3ef0c689163b8$var$react_1.default.createElement("button", {
        "data-track": "privacy-consent-deny",
        className: "privacy__button privacy__button--secondary",
        onClick: handleOptOutAllClick,
        role: "button"
    }, text.deny), $32c3ef0c689163b8$var$react_1.default.createElement("button", {
        "data-track": "privacy-consent-accept",
        className: "privacy__button privacy__button--primary",
        onClick: handleOptInAllClick,
        role: "button"
    }, text.accept)))), $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyGear_1.default, {
        onChange: handlePrivacyGearChange,
        visible: visible
    }));
};
const $32c3ef0c689163b8$var$PrivacyModalClientSideRenderOnly = (props)=>{
    return $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$ClientSideRenderOnly_1.default, null, $32c3ef0c689163b8$var$react_1.default.createElement($32c3ef0c689163b8$var$PrivacyModal, {
        ...props
    }));
};
module.exports.default = $32c3ef0c689163b8$var$PrivacyModalClientSideRenderOnly;

});
parcelRegister("7opEO", function(module, exports) {
"use strict";
var $561ead4e7cc8a722$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $561ead4e7cc8a722$var$react_1 = $561ead4e7cc8a722$var$__importDefault((parcelRequire("acw62")));
const $561ead4e7cc8a722$var$ClientSideRenderOnly = ({ children: children })=>{
    const [firstRender, setFirstRender] = $561ead4e7cc8a722$var$react_1.default.useState(true);
    $561ead4e7cc8a722$var$react_1.default.useEffect(()=>{
        $561ead4e7cc8a722$var$react_1.default.startTransition(()=>{
            setFirstRender(false);
        });
    }, []);
    return firstRender ? null : $561ead4e7cc8a722$var$react_1.default.createElement($561ead4e7cc8a722$var$react_1.default.Fragment, null, children);
};
module.exports.default = $561ead4e7cc8a722$var$ClientSideRenderOnly;

});

parcelRegister("1H65O", function(module, exports) {
"use strict";
var $13be887f498c54e7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $13be887f498c54e7$var$react_1 = $13be887f498c54e7$var$__importDefault((parcelRequire("acw62")));
const $13be887f498c54e7$var$PrivacyCaret = ({ expanded: expanded })=>$13be887f498c54e7$var$react_1.default.createElement("div", {
        className: `privacy__arrow--${expanded ? 'expanded' : 'collapsed'}`
    }, $13be887f498c54e7$var$react_1.default.createElement("svg", {
        "aria-hidden": "true",
        height: "14px",
        viewBox: "0 0 330.002 330.002",
        width: "14px"
    }, $13be887f498c54e7$var$react_1.default.createElement("path", {
        d: "M233.252,155.997L120.752,6.001c-4.972-6.628-14.372-7.97-21-3c-6.628,4.971-7.971,14.373-3,21 l105.75,140.997L96.752,306.001c-4.971,6.627-3.627,16.03,3,21c2.698,2.024,5.856,3.001,8.988,3.001 c4.561,0,9.065-2.072,12.012-6.001l112.5-150.004C237.252,168.664,237.252,161.33,233.252,155.997z"
    })));
module.exports.default = $13be887f498c54e7$var$PrivacyCaret;

});

parcelRegister("3eByZ", function(module, exports) {
"use strict";
var $25afd133af1ac433$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $25afd133af1ac433$var$react_1 = $25afd133af1ac433$var$__importDefault((parcelRequire("acw62")));

const $25afd133af1ac433$var$usePrivacyText_1 = $25afd133af1ac433$var$__importDefault((parcelRequire("lL8FI")));
const $25afd133af1ac433$var$PrivacyGear = ({ onChange: onChange, visible: visible })=>{
    const text = (0, $25afd133af1ac433$var$usePrivacyText_1.default)();
    const handleClick = $25afd133af1ac433$var$react_1.default.useCallback(()=>{
        onChange(!visible);
    }, [
        onChange,
        visible
    ]);
    return $25afd133af1ac433$var$react_1.default.createElement("button", {
        "aria-label": text.showCookieConsentOptions,
        className: `privacy__gear ${visible ? 'privacy__gear--visible' : ''}`,
        "data-testid": "privacy-gear",
        onClick: handleClick,
        role: "button"
    }, $25afd133af1ac433$var$react_1.default.createElement("svg", {
        "aria-hidden": "true",
        width: "16",
        height: "16",
        viewBox: "0 0 35 35"
    }, $25afd133af1ac433$var$react_1.default.createElement("g", {
        transform: "translate(17,7.5)"
    }, $25afd133af1ac433$var$react_1.default.createElement("path", {
        d: "m 0,0 c -5.514,0 -10,4.486 -10,10 0,5.514 4.486,10 10,10 C 5.514,20 10,15.514 10,10 10,4.486 5.514,0 0,0 m 14.585,12.638 1.25,0.406 c 0.525,0.17 0.812,0.734 0.642,1.26 l -0.618,1.902 c -0.17,0.525 -0.735,0.813 -1.26,0.642 l -1.261,-0.409 c -0.46,-0.15 -0.948,0.059 -1.187,0.479 -0.514,0.902 -1.122,1.742 -1.816,2.504 -0.326,0.358 -0.375,0.886 -0.09,1.278 l 0.778,1.07 c 0.324,0.447 0.225,1.072 -0.222,1.397 L 9.183,24.343 C 8.736,24.667 8.111,24.568 7.786,24.122 L 7.012,23.056 C 6.727,22.664 6.21,22.548 5.768,22.747 4.837,23.168 3.851,23.487 2.826,23.697 2.351,23.794 2,24.19 2,24.675 v 1.169 c 0,0.71 -0.448,1.158 -1,1.158 h -2 c -0.552,0 -1,-0.448 -1,-1 v -1.325 c 0,-0.484 -0.351,-0.883 -0.826,-0.98 -1.025,-0.21 -2.011,-0.529 -2.942,-0.95 -0.442,-0.199 -0.959,-0.083 -1.244,0.309 l -0.774,1.066 c -0.325,0.446 -0.95,0.545 -1.397,0.221 l -1.618,-1.176 c -0.447,-0.325 -0.546,-0.95 -0.222,-1.397 l 0.778,-1.07 c 0.285,-0.392 0.236,-0.92 -0.09,-1.278 -0.694,-0.762 -1.302,-1.602 -1.816,-2.504 -0.239,-0.42 -0.727,-0.629 -1.187,-0.479 l -1.261,0.409 c -0.525,0.171 -1.09,-0.117 -1.26,-0.642 l -0.618,-1.902 c -0.17,-0.526 0.117,-1.09 0.642,-1.26 l 1.25,-0.406 c 0.445,-0.145 0.743,-0.581 0.686,-1.046 C -13.963,11.07 -14,10.54 -14,10 c 0,-0.81 0.084,-1.6 0.217,-2.373 L -15.835,6.96 C -16.36,6.79 -16.647,6.226 -16.477,5.7 l 0.618,-1.902 c 0.17,-0.525 0.735,-0.813 1.26,-0.642 l 1.26,0.409 c 0.46,0.149 0.947,-0.06 1.187,-0.48 0.652,-1.146 1.458,-2.192 2.397,-3.107 l -1.268,-1.744 c -0.324,-0.447 -0.225,-1.072 0.222,-1.397 l 1.618,-1.176 c 0.447,-0.325 1.072,-0.226 1.397,0.221 l 0.772,1.063 c 0.284,0.392 0.802,0.508 1.244,0.309 0.931,-0.422 1.918,-0.741 2.945,-0.951 C -2.351,-3.794 -2,-4.193 -2,-4.677 v -1.321 c 0,-0.552 0.448,-1 1,-1 h 2 c 0.552,0 1,0.448 1,1 v 1.321 c 0,0.484 0.351,0.883 0.825,0.98 1.027,0.21 2.014,0.529 2.945,0.951 0.442,0.199 0.96,0.083 1.244,-0.309 l 0.772,-1.063 c 0.325,-0.447 0.95,-0.546 1.397,-0.221 l 1.618,1.176 c 0.447,0.325 0.546,0.95 0.222,1.397 l -0.776,1.068 c -0.285,0.391 -0.236,0.919 0.089,1.277 0.694,0.763 1.303,1.603 1.816,2.506 0.24,0.42 0.727,0.629 1.187,0.48 l 1.26,-0.409 c 0.525,-0.171 1.09,0.117 1.26,0.642 L 16.477,5.7 c 0.17,0.526 -0.117,1.09 -0.642,1.26 L 14.586,7.366 C 14.14,7.511 13.842,7.946 13.899,8.411 13.963,8.933 14,9.462 14,10 c 0,0.54 -0.037,1.07 -0.101,1.592 -0.057,0.465 0.241,0.901 0.686,1.046",
        stroke: "none"
    }))));
};
module.exports.default = $25afd133af1ac433$var$PrivacyGear;

});

parcelRegister("3cUE4", function(module, exports) {
"use strict";
var $255e6ea9a555c68e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $255e6ea9a555c68e$var$react_1 = $255e6ea9a555c68e$var$__importDefault((parcelRequire("acw62")));

const $255e6ea9a555c68e$var$PrivacyCaret_1 = $255e6ea9a555c68e$var$__importDefault((parcelRequire("1H65O")));

const $255e6ea9a555c68e$var$PrivacyCheckbox_1 = $255e6ea9a555c68e$var$__importDefault((parcelRequire("a6VLL")));

const $255e6ea9a555c68e$var$usePrivacyText_1 = $255e6ea9a555c68e$var$__importDefault((parcelRequire("lL8FI")));
const $255e6ea9a555c68e$var$PrivacyGroup = ({ description: description, category: category, categoriesSelected: categoriesSelected, setCategoriesSelected: setCategoriesSelected, title: title, tools: tools })=>{
    const isSelected = categoriesSelected.includes(category);
    const [expanded, setExpanded] = $255e6ea9a555c68e$var$react_1.default.useState(false);
    const text = (0, $255e6ea9a555c68e$var$usePrivacyText_1.default)();
    const handleCheckboxChange = $255e6ea9a555c68e$var$react_1.default.useCallback((checked)=>{
        if (!checked) setCategoriesSelected(categoriesSelected.filter((d)=>d !== category));
        else setCategoriesSelected([
            ...categoriesSelected,
            category
        ]);
    }, [
        category,
        categoriesSelected,
        setCategoriesSelected
    ]);
    const handleExpandToggleClick = $255e6ea9a555c68e$var$react_1.default.useCallback(()=>{
        setExpanded(!expanded);
    }, [
        expanded
    ]);
    return $255e6ea9a555c68e$var$react_1.default.createElement("div", {
        className: "privacy__group"
    }, $255e6ea9a555c68e$var$react_1.default.createElement("div", {
        className: "privacy__group__wrapper"
    }, $255e6ea9a555c68e$var$react_1.default.createElement($255e6ea9a555c68e$var$PrivacyCheckbox_1.default, {
        checked: isSelected,
        disabled: !(tools === null || tools === void 0 ? void 0 : tools.length),
        onChange: handleCheckboxChange
    }), $255e6ea9a555c68e$var$react_1.default.createElement("div", {
        className: "privacy__group__inner"
    }, (tools === null || tools === void 0 ? void 0 : tools.length) ? $255e6ea9a555c68e$var$react_1.default.createElement("button", {
        className: "privacy__group__header",
        onClick: handleExpandToggleClick,
        role: "button"
    }, $255e6ea9a555c68e$var$react_1.default.createElement("label", {
        className: "privacy__text privacy__group__heading"
    }, title), $255e6ea9a555c68e$var$react_1.default.createElement($255e6ea9a555c68e$var$PrivacyCaret_1.default, {
        expanded: expanded
    })) : $255e6ea9a555c68e$var$react_1.default.createElement("div", {
        className: "privacy__group__header"
    }, $255e6ea9a555c68e$var$react_1.default.createElement("label", {
        className: "privacy__text privacy__group__heading"
    }, title)), $255e6ea9a555c68e$var$react_1.default.createElement("p", {
        className: "privacy__text privacy__group__description"
    }, description), expanded && (tools === null || tools === void 0 ? void 0 : tools.length) && $255e6ea9a555c68e$var$react_1.default.createElement("div", {
        className: "privacy__group__content"
    }, tools === null || tools === void 0 ? void 0 : tools.map((tool)=>$255e6ea9a555c68e$var$react_1.default.createElement($255e6ea9a555c68e$var$react_1.default.Fragment, null, $255e6ea9a555c68e$var$react_1.default.createElement("div", {
            className: "privacy__text privacy__text--bold"
        }, tool.provider), $255e6ea9a555c68e$var$react_1.default.createElement("div", {
            className: "privacy__group__table"
        }, $255e6ea9a555c68e$var$react_1.default.createElement("div", {
            className: "privacy__text privacy__text--small"
        }, $255e6ea9a555c68e$var$react_1.default.createElement("strong", null, text.purpose), " ", tool.description), $255e6ea9a555c68e$var$react_1.default.createElement("div", {
            className: "privacy__text privacy__text--small"
        }, $255e6ea9a555c68e$var$react_1.default.createElement("strong", null, text.duration), " ", tool.duration))))))));
};
module.exports.default = $255e6ea9a555c68e$var$PrivacyGroup;

});
parcelRegister("a6VLL", function(module, exports) {
"use strict";
var $75c746b58f7057b3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $75c746b58f7057b3$var$react_1 = $75c746b58f7057b3$var$__importDefault((parcelRequire("acw62")));
const $75c746b58f7057b3$var$PrivacyCheckbox = ({ checked: checked, disabled: disabled, onChange: onChange })=>$75c746b58f7057b3$var$react_1.default.createElement("button", {
        "aria-checked": checked ? 'true' : 'false',
        "aria-disabled": disabled ? 'true' : undefined,
        className: "privacy__checkbox",
        onClick: !disabled ? ()=>onChange(!checked) : undefined,
        role: "checkbox"
    });
module.exports.default = $75c746b58f7057b3$var$PrivacyCheckbox;

});


parcelRegister("1qrho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getStyles = void 0;
const $109d61516b42f665$var$getStyles = ()=>`
.privacy__overlay {
  all: unset;
  background: #555555;
  height: 100vh;
  left: 0;
  opacity: 0.8;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9999;
}
.privacy__content {
  all: unset;
  background-color: #f2fafd;
  border-radius: 10px;
  box-shadow: 0 0 60px 0 rgba(0,0,0,0.3);
  box-sizing: border-box;
  left: 50%;
  max-height: 100vh;
  overflow: auto;
  padding: 32px 48px 48px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 676px;
  z-index: 9999;
}
.privacy__text {
  all: unset;
  color: #544F40;
  display: block;
  font-family: Arial, sans-serif;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 1.7;
}
.privacy__text--small {
  font-size: 14px;
}
.privacy__heading {
  font-size: 28px;
  font-weight: bold;
}
.privacy__text--bold {
  font-weight: bold;
}
.privacy__groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}
.privacy__group__wrapper {
  all: unset;
  display: flex;
  gap: 12px;
}
.privacy__group__inner {
  all: unset;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.privacy__group__header {
  all: unset;
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
button.privacy__group__header  {
  cursor: pointer;
}
.privacy__group__heading {
  align-items: center;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  gap: 12px;
}
.privacy__group__content {
  padding-top: 12px;
}
.privacy__arrow--expanded {
  transform: rotate(-90deg);
}
.privacy__arrow--collapsed {
  transform: rotate(90deg);
}
.privacy__arrow--expanded svg,
.privacy__arrow--collapsed svg {
  display: block;
}
.privacy__link {
  color: #15717D;
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
}
.privacy__button {
  all: unset;
  border: 2px solid #E31836;
  border-radius: 8px;
  cursor: pointer;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 16px;
  text-transform: uppercase;
}
.privacy__button--primary {
  background-color: #E31836;
  color: #fff;
}
.privacy__button--secondary {
  background-color: #fff;
  color: #E31836;
}
.privacy__footer {
  all: unset;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-top: 24px;
}
.privacy__footer__ctas {
  all: unset;
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-inline-start: auto;
}
.privacy__expand {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-weight: bold;
  flex-direction: row;
  gap: 8px;
  white-space: nowrap;
}
.privacy__checkbox {
  all: unset;
  border-radius: 2px;
  border: 1.5px solid #15717D;
  cursor: pointer;
  display: flex;
  height: 20px;
  margin-top: 4px;
  position: relative;
  width: 20px;
}
.privacy__checkbox[aria-checked="true"] {
  background-color: #15717D;
}
.privacy__checkbox[aria-disabled="true"] {
  background-color: #d1d2d5;
  border: 1.5px solid #d1d2d5;
  cursor: not-allowed;
}
.privacy__checkbox::after {
  border-color: #fff;
  border-style: solid;
  border-width: 0 2px 2px 0;
  box-sizing: border-box;
  content: "";
  display: block;
  height: 12px;
  left: 0;
  margin: auto;
  position: absolute;
  right: -1px;
  top: 2px;      
  transform: rotate(45deg);
  width: 6px;
}
.privacy__checkbox[aria-checked="false"]::after {
  display: none;
}
.privacy__gear {
  all: unset;
  background: #fff;
  bottom: -30px;
  box-shadow: 0 0 60px 0 rgba(0,0,0,0.3);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 60px;
  justify-content: center;
  left: -30px;
  padding-top: 4px;
  position: fixed;
  transform: rotate(45deg);
  width: 60px;
  z-index: 9999;
}
.privacy__gear path {
  fill: #17717d;
}
.privacy__gear--visible {
  background: #17717d;
}
.privacy__gear--visible path {
  fill: #fff;
}
@media screen and (max-width: 720px) {
  .privacy__content {
    border-radius: 0;
    bottom: 0;
    left: 0;
    padding: 24px 24px 30px;
    top: auto;
    transform: none;
    width: 100%;
  }
}
`;
module.exports.getStyles = $109d61516b42f665$var$getStyles;

});


var $b34d3718b7a413fe$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"9vqfN\",\"index.127cc9e8.js\",\"bTpGD\",\"header-logo.54c6c482.png\",\"7OYTZ\",\"Logo-Facebook.b28b61b4.svg\",\"d4hoj\",\"Logo-Instagram.328fe97e.svg\",\"lvrU2\",\"Logo-X.7956b0c1.svg\",\"heRLb\",\"Logo-LinkedIn.a9ca821d.svg\",\"cxK9u\",\"NABP-certified.f41fbd43.png\",\"c1qG2\",\"heart.3b5c2383.svg\",\"b43XP\",\"book.65b78297.svg\",\"3YEZg\",\"multi_arrow.131b3c78.svg\",\"1XEfI\",\"red_heart.8ad61bd1.svg\",\"7S60w\",\"delivered.e2f9af53.svg\",\"9yEZO\",\"pending.bef556ce.svg\",\"25xkk\",\"refresh.8530a275.svg\",\"2ukyu\",\"badgeCheckIcon.5cf60fa2.svg\",\"fwMQl\",\"warningInfoIcon.4e11f8c0.svg\",\"76Xo5\",\"exclamation-circle-blue.6b0501ee.svg\",\"i2WUJ\",\"exclamation-circle-amber.50406146.svg\",\"2pzcu\",\"warning.580c5328.svg\",\"8ecPY\",\"alertCheckIcon.242db0a0.svg\",\"9uPEX\",\"alertIcon.bd03a77b.svg\",\"jlq6G\",\"crossIconWhite.b2346fef.svg\",\"2B580\",\"recovery-link.ea6b9eb4.png\",\"ewF1E\",\"Loading.165e6a47.gif\",\"6esdu\",\"clock-timer.e3a08b8b.png\",\"dvVbV\",\"success-badge.7bb32b31.svg\",\"aLe81\",\"user.1188935c.svg\",\"h6XA5\",\"usa-flag.17bd64d9.svg\",\"6yols\",\"switzerland-flag.7ac4fd48.svg\",\"9N6yI\",\"profile.ef97b464.svg\",\"8JrDl\",\"germany-flag.5fadc030.svg\",\"04PQy\",\"crossIcon.47cea1b8.svg\",\"3HvxO\",\"taxExemptionIcon.1a723539.png\",\"YgWoR\",\"prophylactic-vaccines-icon.158eef44.png\",\"ei66L\",\"mrnaNewsIcon.096a95d9.png\",\"lFGv4\",\"Banner_Strand.7b45fab2.png\",\"lqmu4\",\"crossIconBlack.9f2affb3.svg\",\"Uv4iZ\",\"DataGrid.352bb530.js\",\"bCzRZ\",\"banner-strand-top.7b45fab2.png\",\"2JV4y\",\"banner-strand-bottom-left.dd754bad.png\",\"a0YLp\",\"note-scroll.ea3f9b0a.png\",\"7ZNaO\",\"authorized-dealer.fbcd10d4.svg\",\"xTvg5\",\"reservations.39a02dc0.svg\",\"i7MGu\",\"upward-chart.ae20e27d.png\",\"boNKP\",\"shipping.c4d41d6b.svg\",\"dpzX6\",\"delivery.bedaad69.svg\",\"bdcXS\",\"temperature-monitoring.c38f4129.svg\",\"crNol\",\"troubleshooting.7fc0357d.svg\",\"jsPjj\",\"access-medicine.132c5f3c.png\",\"h1eTe\",\"website-troubleshooting.3adaeebb.svg\",\"kjeeh\",\"accounts.8b3d647a.png\",\"3wV2r\",\"brand-strand-bottom.605820f5.png\",\"cQ4xT\",\"address-book.1b331b17.js\",\"bwB7A\",\"airplane-in-flight.632d58a5.js\",\"79Qsj\",\"airplane-landing.1aabee21.js\",\"a76vj\",\"airplane-takeoff.372ab301.js\",\"f4L6h\",\"airplane-tilt.dce31d3e.js\",\"a4HPO\",\"alarm.8f1ebc43.js\",\"lAvt8\",\"anchor.bb3d1e71.js\",\"2zNtn\",\"archive.988810e2.js\",\"hCZ3D\",\"arrow-circle-down-left.8840e397.js\",\"8gw8E\",\"arrow-circle-down-right.ca0156bc.js\",\"3ur17\",\"arrow-circle-down.d4f4bb31.js\",\"2SJs2\",\"arrow-circle-left.512d2c60.js\",\"j43KR\",\"arrow-circle-right.f121f465.js\",\"1cko7\",\"arrow-circle-up-left.af4d6c86.js\",\"5ekqe\",\"arrow-circle-up-right.2967b723.js\",\"b2Amm\",\"arrow-circle-up.66913be8.js\",\"hvqv9\",\"arrow-counter-clockwise.c3e8d5f5.js\",\"2IopW\",\"arrow-down-left.7f65fd20.js\",\"8SfJg\",\"arrow-left.708bc56d.js\",\"2KedF\",\"arrow-down-right.7cf8b95f.js\",\"eRAMU\",\"arrow-down.7b6cc723.js\",\"2z2Bt\",\"arrow-fat-down.87a6c15f.js\",\"56HVZ\",\"arrow-fat-left.6ac4a3f8.js\",\"21wXE\",\"arrow-fat-right.107cbdee.js\",\"cIGMV\",\"arrow-fat-up.af185553.js\",\"3nP2r\",\"arrow-line-down.283e53cd.js\",\"4zXIP\",\"arrow-line-left.af1addea.js\",\"13UzD\",\"arrow-line-right.5e4dd3e7.js\",\"3UftB\",\"arrow-right.42eb5693.js\",\"2SO81\",\"arrow-square-in.aa58f2c2.js\",\"eoz6y\",\"arrow-square-out.44cbc2df.js\",\"jjwWh\",\"arrow-up-left.b5af4b10.js\",\"491gh\",\"arrow-up-right.dd4ec0dc.js\",\"jBH9p\",\"arrow-up.2c54a0b5.js\",\"czN9E\",\"arrows-clockwise.0af8b8ff.js\",\"idlMP\",\"arrows-down-up.4f0000b5.js\",\"ilgHI\",\"arrows-in-cardinal.8354226d.js\",\"2TDRK\",\"arrows-in-line-vertical.dd8d0132.js\",\"884bS\",\"arrows-in-simple.8b432dfa.js\",\"2jyg4\",\"arrows-in.94ec7304.js\",\"aHFJA\",\"arrows-out-cardinal.97506aa3.js\",\"8BLAO\",\"arrows-out-simple.9cba16a6.js\",\"6cuoJ\",\"arrows-out.20be08ff.js\",\"vs85p\",\"article.8ee3b08f.js\",\"2G9DO\",\"bell-ringing.2e5f3345.js\",\"cpZXQ\",\"bell-slash.052051a3.js\",\"eoB3R\",\"bell-z.7ced94e5.js\",\"519Rx\",\"bell.577dc028.js\",\"hiouE\",\"bookmark.eda5123b.js\",\"exais\",\"browser.24285094.js\",\"fhiVa\",\"browsers.5b3f9229.js\",\"lWd3k\",\"buildings.30ea7741.js\",\"57IcE\",\"calculator.8d71cfd7.js\",\"jA7k5\",\"calendar-blank.33bcd718.js\",\"6EsIk\",\"calendar-check.6197b9b2.js\",\"bMJyO\",\"calendar-plus.1d875d4d.js\",\"cGTiN\",\"calendar-x.811391b7.js\",\"llkac\",\"calendar.cccc5894.js\",\"6hDzL\",\"camera-plus.d3172a6e.js\",\"d8gEV\",\"camera-slash.aa96e71e.js\",\"33jGh\",\"camera.bbede6f6.js\",\"hmVy6\",\"cards.3bbd9afc.js\",\"hpQwu\",\"caret-circle-down.ffae03fd.js\",\"kWLeI\",\"caret-circle-left.79a2c10a.js\",\"agGio\",\"caret-circle-right.daf2d7d9.js\",\"aa6RJ\",\"caret-circle-up.e852ba0f.js\",\"d4TK7\",\"caret-double-down.1a3387d7.js\",\"jUszp\",\"caret-double-left.a6b00256.js\",\"8m9zE\",\"caret-double-right.f7ffa3bd.js\",\"5sYR6\",\"caret-double-up.ca8bd26d.js\",\"4EGA8\",\"caret-down.a5ca4801.js\",\"jHEeI\",\"caret-left.6714ca68.js\",\"dyqQe\",\"caret-right.2374ceaf.js\",\"lxZ4v\",\"caret-up-down.6d539630.js\",\"8YgNy\",\"caret-up.508b0baa.js\",\"4L1Wq\",\"chart-bar-horizontal.e7770f21.js\",\"bkJu7\",\"chart-bar.4ab6f73a.js\",\"a1ghY\",\"chart-donut.7d1ee9c8.js\",\"1s6pP\",\"chart-line-down.6dea1aa5.js\",\"jdPQC\",\"chart-line-up.3d23684a.js\",\"4rupd\",\"chart-line.7f3aed1c.js\",\"3DMdr\",\"chart-pie-slice.af3f4973.js\",\"7bOf2\",\"chart-pie.e05ee22b.js\",\"90bzF\",\"chat-circle.1a56b01c.js\",\"9xJas\",\"chats-circle.0f01edd1.js\",\"1oDfk\",\"check-circle.0c09531e.js\",\"4n7UI\",\"check-fat.61096dc3.js\",\"2PMxh\",\"check-square-offset.1ddea0d8.js\",\"7Ex3c\",\"check-square.f579f0af.js\",\"8cwj2\",\"check.9870480e.js\",\"6ZWg4\",\"checks.0281c40b.js\",\"jh6ZA\",\"clock-afternoon.a6416d6d.js\",\"b21GP\",\"clock-counter-clockwise.d77b7e76.js\",\"9hieY\",\"clock.a22aeec6.js\",\"9fW0K\",\"closed-captioning.bf622203.js\",\"4tVoE\",\"cloud-arrow-up.99d9ad79.js\",\"kyOfl\",\"code.e8a55629.js\",\"k7bCY\",\"coin.0484b3f1.js\",\"agNg5\",\"coins.f958968a.js\",\"8261Z\",\"copy.ae8c8706.js\",\"gygFy\",\"credit-card.cff6c5e0.js\",\"l7e0j\",\"cursor.fc689bae.js\",\"fw2kg\",\"dna.245824a1.js\",\"kYn1C\",\"dot-outline.66ea8f7e.js\",\"3VPYK\",\"dot.39659573.js\",\"bJz4P\",\"dots-nine.d2115759.js\",\"ei4jq\",\"dots-three-circle-vertical.7094b175.js\",\"8bpFf\",\"dots-three-circle.612547b8.js\",\"aWnGR\",\"dots-three-outline-vertical.93c4c168.js\",\"hB9tq\",\"dots-three-outline.19b33769.js\",\"hfrBF\",\"dots-three-vertical.f3c02134.js\",\"rfxSh\",\"dots-three.508b7ae1.js\",\"c0i2v\",\"download-simple.72c4e3a3.js\",\"3AP8a\",\"envelope-simple-open.51881e2b.js\",\"49pRz\",\"envelope-simple.235e288f.js\",\"9m4RU\",\"export.5aae6c33.js\",\"bPcWF\",\"eye-slash.b8ad9e28.js\",\"a5FFd\",\"eye.ebba587f.js\",\"1hvXf\",\"face-mask.6fc58607.js\",\"89lE4\",\"factory.3b5a6016.js\",\"dRqjk\",\"file-arrow-down.e88efe4e.js\",\"aVsql\",\"file-image.23b02b78.js\",\"cWPQt\",\"file-pdf.0ba3074b.js\",\"76jL4\",\"file-video.7c7e960c.js\",\"e45v5\",\"file.4c1e8c4a.js\",\"8vbJq\",\"files.ffad61c5.js\",\"kS64H\",\"fingerprint-simple.3970c880.js\",\"9GimB\",\"first-aid.6e6d0e72.js\",\"7tTBk\",\"flag.74d7b649.js\",\"gY8pL\",\"flask.0490fd26.js\",\"4PCLG\",\"folder-open.8b6b835a.js\",\"33sru\",\"folder.f68017eb.js\",\"it3T9\",\"funnel.881f197c.js\",\"b1peH\",\"gear.4aba9d0a.js\",\"eIYq1\",\"globe.332d42d5.js\",\"d9B2D\",\"grid-four.1b6fd5d3.js\",\"22T1D\",\"grid-nine.70574f09.js\",\"3WQ8a\",\"hand-pointing.3a1ce18f.js\",\"44xhE\",\"hand.7e9c3aef.js\",\"fFA5O\",\"hard-drive.cdd6c55e.js\",\"byksU\",\"hard-drives.bf42e41a.js\",\"hURoS\",\"headphones.33b6f354.js\",\"9AXx7\",\"headset.8e9fb6fb.js\",\"ap1HX\",\"heart.118461bd.js\",\"bn8nz\",\"hospital.a0eadc39.js\",\"gKJnj\",\"house.23cfcfb1.js\",\"6JCNh\",\"identification-badge.8fc9bd24.js\",\"9T8Sa\",\"identification-card.1d192028.js\",\"2Dx79\",\"image.30af3fd6.js\",\"f5SbO\",\"images.78169028.js\",\"jl9UC\",\"info.f7e0a636.js\",\"gnjtH\",\"layout.a0359caf.js\",\"jwDBn\",\"lightning.3b6d5be2.js\",\"47ntL\",\"link-break.eb7e05f8.js\",\"jE6kW\",\"link.50ded0bd.js\",\"7YHIB\",\"list-bullets.8ac81c68.js\",\"35ocU\",\"list-checks.88789144.js\",\"H4Eoj\",\"list.1053a9e2.js\",\"98kli\",\"lock-simple-open.01d4f140.js\",\"iyHSn\",\"lock-simple.4ecdaf16.js\",\"1R9Fz\",\"logo-apple.10e86ed4.js\",\"5QIv7\",\"logo-facebook.98ab0902.js\",\"fzlnd\",\"logo-google.bc9774a9.js\",\"k69Wn\",\"logo-instagram.c3c6108b.js\",\"bZegj\",\"logo-linkedin.e4d58c06.js\",\"2m3Ih\",\"logo-microsoft.ad7f599f.js\",\"1eaae\",\"logo-x.f1f09832.js\",\"aJT6w\",\"logo-yahoo.6d40732b.js\",\"eyUqW\",\"magnifying-glass-minus.96655686.js\",\"8DjpP\",\"magnifying-glass-plus.f8190642.js\",\"26kXj\",\"magnifying-glass.144d89ec.js\",\"7cn6g\",\"map-pin.e130f4a7.js\",\"cmbjR\",\"map-trifold.f810228c.js\",\"5NDXW\",\"microphone-slash.b1cbd9f2.js\",\"8DagP\",\"microphone.78b74840.js\",\"a7PjJ\",\"minus-circle.fa249a52.js\",\"6ursU\",\"minus.02cb4b3a.js\",\"h2i28\",\"navigation-arrow.40ccd5d7.js\",\"7oBJy\",\"note.d0d515d5.js\",\"1eko0\",\"paper-plane-right.835e76cf.js\",\"jEacK\",\"paper-plane-tilt.d66f2f0b.js\",\"4whGs\",\"paperclip.077b6297.js\",\"HCldz\",\"password.ce7e1837.js\",\"l10eK\",\"pause-circle.c9c2a070.js\",\"k21xK\",\"pause.3979fd04.js\",\"52uLx\",\"pencil-simple.13267bb0.js\",\"8NsSO\",\"phone.4d508d15.js\",\"82aue\",\"play-circle.e51f5e1e.js\",\"7DcTB\",\"play.ef193292.js\",\"dsETa\",\"plus-circle.558faff2.js\",\"kH6CG\",\"plus.669529f5.js\",\"k6D3a\",\"presentation.a1f4568c.js\",\"eeZ2y\",\"printer.c2ce6ec3.js\",\"jTmUr\",\"prohibit.f3b4ba02.js\",\"iXwud\",\"push-pin-simple-slash.99698fbe.js\",\"X2zo2\",\"push-pin-simple.db738611.js\",\"1M7TX\",\"push-pin-slash.242ca587.js\",\"hte1i\",\"push-pin.14aaf725.js\",\"1Efkt\",\"question.f54a8fca.js\",\"b4jLH\",\"repeat.da2fa935.js\",\"aUPeh\",\"robot.0d6b617e.js\",\"1TWu4\",\"seal-check.ed4f8419.js\",\"lORyF\",\"share-fat.fe90c66a.js\",\"141vB\",\"share-network.70b8ebc1.js\",\"FOU3Z\",\"share.c8af26cc.js\",\"7C0ik\",\"shopping-cart-simple.d2728728.js\",\"4NpOt\",\"signature.6fac567b.js\",\"iluJU\",\"signout.97692e7a.js\",\"iAwnt\",\"sliders-horizontal.aae06190.js\",\"1nwIe\",\"sliders.df4ddd9c.js\",\"4FkPB\",\"speaker-simple-high.9d79313b.js\",\"4L6xS\",\"speaker-simple-low.bfad5714.js\",\"5dYWe\",\"speaker-simple-none.b1d7f490.js\",\"kQZOl\",\"speaker-simple-slash.54006de1.js\",\"aoN05\",\"speaker-simple-x.626cc1c2.js\",\"erQkS\",\"spinner.a478c756.js\",\"lg6LG\",\"star.84fd200b.js\",\"ccFGR\",\"subtitles.faa20395.js\",\"2RezH\",\"syringe.fe032878.js\",\"cYfTI\",\"tag-simple.8d0ed3cf.js\",\"6iiCX\",\"test-tube.3a911ec0.js\",\"lpTtX\",\"text-align-center.f3cf521c.js\",\"ehwmM\",\"text-align-left.6ca7d98b.js\",\"4fPW1\",\"text-align-right.04216f1b.js\",\"iNEVY\",\"thermometer-cold.a27f4edf.js\",\"3HQNF\",\"thermometer-hot.e949979e.js\",\"8viuS\",\"thermometer-simple.c54e11d7.js\",\"kUhiW\",\"thumbs-down.3a9e1dfc.js\",\"9Ntvl\",\"thumbs-up.fff75a6a.js\",\"9Y0c0\",\"timer.ce04b8ff.js\",\"cuDum\",\"translate.59b6df50.js\",\"685sr\",\"trash.fe0fcf5c.js\",\"cLm8U\",\"tree-structure.d2f183db.js\",\"IZk8T\",\"truck.ee8cc9c2.js\",\"l9GgF\",\"upload-simple.7532beba.js\",\"BgPQR\",\"user-circle.966fb695.js\",\"jp1Bj\",\"user-gear.75e93ba3.js\",\"RGWSK\",\"user-minus.a57ea0fe.js\",\"86dtC\",\"user-plus.f794ac6f.js\",\"4LK9P\",\"user-switch.426f9c8c.js\",\"h90rj\",\"user.77991cf2.js\",\"gz5HX\",\"users-four.16ad9f95.js\",\"lVvTT\",\"users-three.9023d2f2.js\",\"l8fiQ\",\"users.a20330a4.js\",\"5iRNI\",\"virus.f872ef1e.js\",\"3kk10\",\"warehouse.1536592c.js\",\"cUIEV\",\"warning-circle.a0206c7b.js\",\"6jaie\",\"warning-diamond.d3d791f7.js\",\"2govi\",\"warning-octagon.55e096b0.js\",\"c8BUx\",\"warning.a255a63e.js\",\"f3ued\",\"wrench.958822d6.js\",\"lDAI3\",\"x-circle.b7b0c958.js\",\"4T1Sf\",\"x-square.c06ba6c3.js\",\"bnHla\",\"x.d38f490d.js\",\"8aU36\",\"AD.a5bffb08.js\",\"1WCxr\",\"AE.8f784440.js\",\"faTZD\",\"AF.7eeea5fa.js\",\"bU1ts\",\"AG.84a0982f.js\",\"lFruU\",\"AI.a8b78af3.js\",\"8aXN3\",\"AL.85f4c10c.js\",\"2XcTB\",\"AM.f8837c6e.js\",\"8tEOF\",\"AO.71f9fdcb.js\",\"5aRBW\",\"AR.0aa861ed.js\",\"kOgN1\",\"AS.1e7b1754.js\",\"jWwfy\",\"AT.9ec381da.js\",\"gFDb6\",\"AU.eaf93975.js\",\"70z38\",\"AW.7d9c0a49.js\",\"aktgP\",\"AX.e2120a62.js\",\"3WnZS\",\"AZ.b6531455.js\",\"jYzmO\",\"BA.b65ecb7d.js\",\"6uhsK\",\"BB.54890181.js\",\"aV79j\",\"BD.7994253b.js\",\"BaONE\",\"BE.a7c15c81.js\",\"deBU5\",\"BF.01ac5ba5.js\",\"9eTKF\",\"BG.263bcd6d.js\",\"bAm30\",\"BH.bb66defd.js\",\"89AO5\",\"BI.c4d3fc0e.js\",\"fpwbr\",\"BJ.0c1e5cce.js\",\"5ENhO\",\"BL.3af9eda6.js\",\"9712J\",\"BM.5852759b.js\",\"bL1Mn\",\"BN.29066505.js\",\"gJQ6R\",\"BO.6e8813c3.js\",\"dMHRu\",\"BR.7cde6468.js\",\"h91yQ\",\"BS.314b23d8.js\",\"1kQNY\",\"BT.5914a251.js\",\"fstH9\",\"BV.f2a24d77.js\",\"5CR2n\",\"BW.70afafe2.js\",\"iWlrr\",\"BY.eb7e9b8b.js\",\"4jzfQ\",\"BZ.e64f0f78.js\",\"hLZRF\",\"CA.f1e15b16.js\",\"1Kntp\",\"CC.1678387a.js\",\"aIXNN\",\"CD.72d923ee.js\",\"fRWOR\",\"CF.bf9a91f8.js\",\"ad7wQ\",\"CG.7743dddf.js\",\"evViX\",\"CH.208d0319.js\",\"4y5up\",\"CI.a7ed4b34.js\",\"hms7v\",\"CK.1b45cebb.js\",\"4asth\",\"CL.460ed5e0.js\",\"a2rkg\",\"CM.a2c5fbb6.js\",\"kKCzl\",\"CN.2b6fa932.js\",\"037iD\",\"CO.32e719f3.js\",\"47xam\",\"CR.188ca469.js\",\"1Q1y5\",\"CU.9c89e239.js\",\"9hYLW\",\"CV.22f76966.js\",\"iyFXH\",\"CW.11f4178e.js\",\"bZzjB\",\"CX.594ee42c.js\",\"4iIBY\",\"CY.c49ca73a.js\",\"7vyuz\",\"CZ.0a3ebaa2.js\",\"axklB\",\"DE.69461b4e.js\",\"3CpXH\",\"DJ.34edfd05.js\",\"3pwuH\",\"DK.1fdf9850.js\",\"ir7SO\",\"DM.c002bada.js\",\"l8nBw\",\"DO.d65bb067.js\",\"k6Itm\",\"DZ.33012a47.js\",\"1uxPA\",\"EC.0fbe8f0c.js\",\"ilqC9\",\"EE.bafb9868.js\",\"ciMw4\",\"EG.1aefd959.js\",\"MA3In\",\"ER.54f03a8c.js\",\"6mNjE\",\"ES.3c2be059.js\",\"1FN9J\",\"ET.09cd8f7c.js\",\"4OBND\",\"EU.2f761e2b.js\",\"bpsyS\",\"FI.d85c3548.js\",\"a3Ruu\",\"FJ.402e68e8.js\",\"9mkMu\",\"FK.776b5486.js\",\"6zBF5\",\"FM.4187cd96.js\",\"gZzT0\",\"FO.8df2c06a.js\",\"9MpHx\",\"FR.3940d03f.js\",\"76ND7\",\"GA.a92ac4af.js\",\"j9XDt\",\"GB-ENG.2a8e889d.js\",\"7lAgJ\",\"GB-NIR.6035c7be.js\",\"cU3Eu\",\"GB-SCT.9a62287a.js\",\"fatry\",\"GB-WLS.d09f3ff2.js\",\"ezZOp\",\"GB-ZET.2f8f1bce.js\",\"8Qdot\",\"GB.d8189360.js\",\"gOz0l\",\"GD.b20ec1ea.js\",\"JCywv\",\"GE.d5e1fd03.js\",\"4j9Pf\",\"GF.5aafb0b4.js\",\"itpuN\",\"GG.11c14a33.js\",\"9FoYg\",\"GH.10b14b2a.js\",\"5mNJ6\",\"GI.5eb41788.js\",\"kUo4Q\",\"GL.f10f1534.js\",\"4d2UA\",\"GM.1bab8f52.js\",\"jX3tn\",\"GN.1949c62f.js\",\"4Gcgx\",\"GP.bb37921a.js\",\"9d69B\",\"GQ.d064f8b9.js\",\"cDMom\",\"GR.0079f2e4.js\",\"hSXpG\",\"GS.a954637d.js\",\"5KDf2\",\"GT.a1c1ba71.js\",\"5Y60z\",\"GU.517b138f.js\",\"inPsH\",\"GW.cce37eb8.js\",\"aFtzw\",\"GY.e127192a.js\",\"a6MES\",\"HK.e07aa0db.js\",\"9KZ9t\",\"HM.dfb9add9.js\",\"50kok\",\"HN.2b14474a.js\",\"9lUaA\",\"HR.409a929a.js\",\"8v1wV\",\"HT.5ec718e0.js\",\"95ORs\",\"HU.58411e4d.js\",\"l0aaK\",\"ID.2672dea2.js\",\"kaDjC\",\"IE.0fc3a6dd.js\",\"fCzX9\",\"IL.c1347cf5.js\",\"2knkc\",\"IM.2c96253c.js\",\"gQDpF\",\"IN.ed998882.js\",\"dRItd\",\"IO.7a42f551.js\",\"3KS83\",\"IQ.f9eb841b.js\",\"cKahR\",\"IR.838e1123.js\",\"9IZzm\",\"IS.eabe18cc.js\",\"8XbAI\",\"IT.4e8c829e.js\",\"iYYP2\",\"JE.1b06e612.js\",\"ik0yG\",\"JM.40bb985a.js\",\"5t8uA\",\"JO.9c7c5e7a.js\",\"ePPzp\",\"JP.1fb4be50.js\",\"8yX6u\",\"KE.86e541f8.js\",\"9YoUf\",\"KG.3fd3fb6e.js\",\"1eWLP\",\"KH.268c543b.js\",\"gmCGG\",\"KI.1065f054.js\",\"54lzz\",\"KM.0fdc95c3.js\",\"b0xCF\",\"KN.84fab8e3.js\",\"aMrFH\",\"KP.afff41fd.js\",\"hXl9S\",\"KR.d04a422d.js\",\"jWd1k\",\"KW.ce4ea2ec.js\",\"3t54e\",\"KY.e5cde4f6.js\",\"8Z9py\",\"KZ.23369d82.js\",\"16855\",\"LA.bda053cf.js\",\"kDiT9\",\"LB.c9442109.js\",\"feXhj\",\"LC.3a4a20bd.js\",\"iGWdR\",\"LGBT1.3baacf78.js\",\"6gBe8\",\"LI.1cdc7ffb.js\",\"AgCK2\",\"LK.3f45fa87.js\",\"ie9sQ\",\"LR.9cb5abb9.js\",\"kHyvN\",\"LS.3ff0d514.js\",\"jN42z\",\"LT.17a8ad07.js\",\"UfcEi\",\"LU.930abc5c.js\",\"4qidt\",\"LV.40ef6868.js\",\"3RJJm\",\"LY.44ec946a.js\",\"gg8wx\",\"MA.e7bd74e3.js\",\"kpa32\",\"MC.63abf4f6.js\",\"clILD\",\"MD.bf745374.js\",\"cxP65\",\"ME.1fd75c69.js\",\"33Q7J\",\"MF.a9dc77eb.js\",\"eLrLN\",\"MG.2d03c6fe.js\",\"jJMB1\",\"MH.810c37b0.js\",\"d9mbq\",\"MK.5f56a061.js\",\"1k1Pg\",\"ML.4ac85867.js\",\"ewfVK\",\"MM.bbfc1493.js\",\"1yIEA\",\"MN.64ebaf34.js\",\"lXfkJ\",\"MO.e62ae226.js\",\"2Uk7Z\",\"MP.0fb12729.js\",\"bzu16\",\"MQ.d9372636.js\",\"h1tja\",\"MR.ccb01807.js\",\"fKWvW\",\"MS.2a0bb696.js\",\"kR7G4\",\"MT.11484f39.js\",\"9HQED\",\"MU.5099d200.js\",\"eDfdq\",\"MV.3c69bb5a.js\",\"9nwXI\",\"MW.991d35c7.js\",\"gghWi\",\"MX.a6599840.js\",\"kXPDM\",\"MY.a6374498.js\",\"iZ6Ug\",\"MZ.b6c4d12a.js\",\"aC2sG\",\"NA.50e9ba0d.js\",\"iuUfW\",\"NC.6574f42a.js\",\"aHtPI\",\"NE.25f3ed49.js\",\"1RFu8\",\"NF.e06f09eb.js\",\"4m1Wq\",\"NG.20c7b76f.js\",\"jXdBY\",\"NI.eaa247d6.js\",\"bX7gN\",\"NL.74148086.js\",\"bmfHr\",\"NO.202d95bd.js\",\"bhy2u\",\"NP.f5a75de2.js\",\"3r449\",\"NR.bba8df68.js\",\"f0egQ\",\"NU.412aa7d8.js\",\"hDvyY\",\"NZ.06c9ee7b.js\",\"033Eh\",\"OM.24967f81.js\",\"3mf94\",\"PA.d76460c7.js\",\"e06bh\",\"PE.ff7c31ec.js\",\"8cPZK\",\"PF.4d12d0cf.js\",\"3I1Rt\",\"PG.b51452fa.js\",\"j38yn\",\"PH.d6598926.js\",\"6epfm\",\"PK.a698d145.js\",\"bceJy\",\"PL.e47fad04.js\",\"7kfgJ\",\"PM.51c6290f.js\",\"9PHOB\",\"PN.b9a5e053.js\",\"l28rc\",\"PR.72b7106b.js\",\"9Stds\",\"PS.c89c044c.js\",\"k1o9z\",\"PT.8a685176.js\",\"ga695\",\"PW.47315b09.js\",\"eVqY5\",\"PY.ffb465b6.js\",\"la3hS\",\"QA.4070eb95.js\",\"4fgMU\",\"RE.a8062fbf.js\",\"agPTg\",\"RO.f62962c3.js\",\"dQm6C\",\"RS.e4d8cef3.js\",\"aBjDI\",\"RU.81cbae27.js\",\"53wy6\",\"RW.d63cfc62.js\",\"3qmfc\",\"SA.316b90e5.js\",\"9GFAl\",\"SB.ac0ae62a.js\",\"fZNyF\",\"SC.da30e074.js\",\"7fqPu\",\"SD.fc354862.js\",\"lsGA9\",\"SE.cff4389e.js\",\"falrB\",\"SG.7f5816fd.js\",\"3SmbY\",\"SH.122a85d4.js\",\"5gYhO\",\"SI.bf9d1582.js\",\"8I4Jp\",\"SJ.a8c407b6.js\",\"4G909\",\"SK.52eabce2.js\",\"ayf6C\",\"SL.dcb85c3b.js\",\"cpY4K\",\"SM.ce3f00c1.js\",\"3qB3I\",\"SN.60cec453.js\",\"judy5\",\"SO.c3dd7e57.js\",\"1tZEM\",\"SR.76f47092.js\",\"1OCyF\",\"SS.a2562178.js\",\"bMztD\",\"ST.deb31880.js\",\"jaecP\",\"SV.2e6669df.js\",\"khgds\",\"SX.a674c261.js\",\"kSeAX\",\"SY.ade77b78.js\",\"8aNYY\",\"SZ.767551bd.js\",\"79XwZ\",\"TC.e5634b99.js\",\"bizZ0\",\"TD.60753959.js\",\"8Eauw\",\"TF.e53b7533.js\",\"k3Uxa\",\"TG.656a0532.js\",\"dcCoM\",\"TH.fc825bd0.js\",\"4FB2I\",\"TJ.0988568c.js\",\"amBWR\",\"TK.15eb8364.js\",\"1Veh3\",\"TL.72683a5f.js\",\"86lqQ\",\"TM.e5ac0f77.js\",\"btwyL\",\"TN.d014df22.js\",\"7X75R\",\"TO.d1985263.js\",\"bt780\",\"TR.6eab120f.js\",\"ib9Wa\",\"TT.4684bc5b.js\",\"l8Dh9\",\"TV.c37dd53e.js\",\"ffjOT\",\"TW.013b1d59.js\",\"jynHh\",\"TZ.0c78fb37.js\",\"larCI\",\"UA.95510c64.js\",\"eJC8K\",\"UG.b6c3a37b.js\",\"5708i\",\"UM.c8585767.js\",\"bNMym\",\"US.4c717790.js\",\"3JXB5\",\"USCA.9f7338e1.js\",\"ee2TR\",\"UY.a56f4bb2.js\",\"6W7FG\",\"UZ.44be677c.js\",\"7oGDF\",\"VA.9a6794ab.js\",\"1FUtj\",\"VC.c3405ff5.js\",\"43Edd\",\"VE.ced0cd49.js\",\"bYUTf\",\"VG.27154946.js\",\"6pmYs\",\"VI.3f1c928f.js\",\"8EytT\",\"VN.264c174c.js\",\"6V3FR\",\"VU.6e6678ca.js\",\"fPkQd\",\"WF.b2178dab.js\",\"ioEEf\",\"WS.6ab521f4.js\",\"4AeS3\",\"XK.9e0f30e9.js\",\"apGKJ\",\"YE.7a041493.js\",\"ezqia\",\"YT.cc3331e3.js\",\"hAcV1\",\"ZA.efa54f47.js\",\"4OxGK\",\"ZM.0a623ba7.js\",\"laHar\",\"ZW.3ca04a95.js\",\"6uPev\",\"passResetStrand.fa35c967.svg\",\"f1sng\",\"checkBadgeIcon.afd4d34a.svg\",\"k4Ilw\",\"warningTriangleIcon.e9f92055.svg\",\"dE1Rt\",\"moderna_logo.5f40215b.svg\",\"eTNuF\",\"printIcon.02e99050.svg\",\"8JYYG\",\"blupax_logo.3c1b30da.png\",\"EInhP\",\"FFF_Logo.a25cb118.png\",\"96Z70\",\"henryschein_logo.3df738b8.jpeg\",\"gJJbb\",\"Medicomart_Logo.409be29a.png\",\"3hFya\",\"Prodigy_Health.ee1cfb95.png\",\"kHLZ0\",\"DSCSA_Packing_Slip.b8795f59.jpg\",\"9rzcj\",\"GAME_Timeline-graphic.6f402fc9.png\",\"lwleb\",\"Packing_Slip.4bdd0f9b.png\",\"5MXzd\",\"Step_1.e56e97a7.jpg\",\"fJo5e\",\"Step_2.43f4f32f.jpg\",\"12eMx\",\"correct_config_in_baggy_and_ecoflex.b0ba557d.png\",\"awKMS\",\"correct_config_in_baggy_and_ecoflex_with_button_press.a220953e.png\",\"dlHQX\",\"Green.98ed18c1.png\",\"dneCW\",\"Red.94592ce4.png\",\"aLtZW\",\"Step_3.1e2f18f7.jpg\",\"lRCuT\",\"Step_4.f48884d4.jpg\",\"9KiCF\",\"Ecoflex_2_Return_Label.40921cfc.png\",\"kPwCT\",\"Step_6.60378fae.jpg\",\"eVpyY\",\"personal_data.f9fdb5c7.png\",\"W5SiK\",\"EU_EEA_UK_Switzerland.90ad35db.png\",\"39zVz\",\"View_Icon.11c60661.svg\",\"1BtTQ\",\"profileIcon.fdb167aa.svg\",\"cZAAG\",\"Addresses_Icon.9226523f.svg\",\"1coSx\",\"CreditCardIcon.d064c319.svg\",\"5R8hE\",\"infoIcon2.6bc68ed2.svg\",\"dpMFh\",\"Sync.06f454f4.svg\",\"6NQyF\",\"crossIconRed.7ccbf462.svg\",\"e70GQ\",\"shipmentIcon.6387e51f.svg\",\"7XsPB\",\"checkIconWhite.d4952764.svg\",\"4eMyD\",\"plusIcon.21e489fb.svg\",\"5mg25\",\"contact-us-request-sent.ea3f9b0a.png\",\"cMpJs\",\"privacy-policy-data-table.f9fdb5c7.png\",\"gSkVf\",\"privacy-policy-data-table-EU.90ad35db.png\",\"bdVL7\",\"mapIcon.288aa78b.svg\",\"fuvVF\",\"coinIcon.89137236.svg\",\"9vKdr\",\"webLinkIcon.91379809.svg\",\"6B37E\",\"uncheckedCircle.b437806c.svg\",\"2bvIN\",\"checkedCircle.1cc2ecd3.svg\",\"jLIDP\",\"coins.c8a25781.svg\",\"jLDah\",\"pdfDocIcon.fa5a48f0.svg\",\"4ZIW1\",\"SPIKEVAX_80777-110-96_Paperboard_Carton.c1a677f9.jpg\",\"eCFNA\",\"SPIKEVAX_80777-110-01_PFS.8e858911.jpg\",\"7rwI1\",\"COVID-19_EUA_80777-291-80_Paperboard_Carton.39e72da0.jpg\",\"KbzWr\",\"COVID-19_EUA_80777-291-09_PFS.7d32d5c9.jpg\",\"kS4Og\",\"mRESVIA_carton.b6c7194b.jpg\",\"7pFFq\",\"mRESVIA_product.50afa9e6.jpg\",\"6nILl\",\"mRESVIA_both.f075b2cc.jpg\",\"dv797\",\"check.9c344ea4.svg\",\"4uO9u\",\"practitionerIcon.464446bc.svg\",\"7kiSc\",\"institutionIcon.189ff731.svg\",\"9GocC\",\"buildingOffice.0e1161fb.svg\",\"4L1ig\",\"infoIcon.44b4cd5a.svg\",\"dfrfH\",\"invoicePayInfographic.85502539.png\",\"i3WOt\",\"invoicePayInfographic-old.4c3c5aa0.png\",\"8XNFW\",\"banner-strand-right.7b45fab2.png\",\"5zbQZ\",\"purify.c4c6d01c.js\",\"14NDh\",\"index.es.7509c0d8.js\",\"iNxFD\",\"de-DE.9ac99531.js\",\"6P3bO\",\"es-ES.4ed66872.js\",\"4W2xh\",\"fr-FR.2e97da3c.js\",\"dT7fa\",\"it-IT.73465417.js\",\"iWNK4\",\"ja-JP.c76d4559.js\",\"dAQTN\",\"ko-KR.33cc486d.js\",\"cPbON\",\"nl-NL.ab86f8c1.js\",\"eInqO\",\"pt-BR.d4358607.js\",\"8rAI3\",\"index.c0884a2c.css\"]"));


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));



var $1u0KT = parcelRequire("1u0KT");


var $1u0KT = parcelRequire("1u0KT");
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$var$ContextKey = Symbol.for(`react-redux-context`);
const $55099852ccad0564$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55099852ccad0564$var$getContext() {
    var _gT$ContextKey;
    if (!$acw62.createContext) return {};
    const contextMap = (_gT$ContextKey = $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey]) != null ? _gT$ContextKey : $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey] = new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ $55099852ccad0564$var$getContext();
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;


function $11518dc3bb05d381$export$d4d6226d5fc61558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $acw62.useContext)(context);
        return contextValue;
    };
}
const $11518dc3bb05d381$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $11518dc3bb05d381$export$d4d6226d5fc61558();



const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d8fc8d639f906efc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $acw62.useRef)(true);
        const wrappedSelector = (0, $acw62.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
var $8eaf5463f712f9ea$exports = {};
'use strict';

$8eaf5463f712f9ea$exports = (parcelRequire("cgj07"));



var $1En50 = parcelRequire("1En50");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps');
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps');
}


const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $1En50.default)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $859ec94da7aa38c4$export$2e2bcd8739ae039)(value)) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>(0, $6a22b9cec285f673$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}



var $8nd05 = parcelRequire("8nd05");


function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? $acw62.useLayoutEffect : $acw62.useEffect;


function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $55099852ccad0564$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $f337fd5395077a96$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $d4dd493c66c4df43$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $59349e43bbd01749$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $1En50.default)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $8eaf5463f712f9ea$exports.isContextConsumer)(/*#__PURE__*/ $acw62.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $acw62.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $2eb761e6a8ffbe36$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $acw62.useRef();
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef();
            const renderIsScheduled = $acw62.useRef(false);
            const isProcessingDispatch = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef();
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $acw62.createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $acw62.createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;



var $acw62 = parcelRequire("acw62");



function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $acw62.useMemo(()=>{
        const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $55099852ccad0564$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;







function $391671225302c365$export$671dba69185d0304(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();


function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $391671225302c365$export$6ccbb43953eebf8) : (0, $391671225302c365$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();









(0, $d8fc8d639f906efc$export$e2e6e3f3f3b782e3)((0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector));
(0, $dbe46e5c642d971b$export$36d45daa6a4925b8)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $f9089991fdc24c9c$export$4b9874722d0da7bc)((0, $1u0KT.unstable_batchedUpdates));


var $3189c83282a9a1c6$exports = {};

$parcel$export($3189c83282a9a1c6$exports, "BrowserRouter", () => $3189c83282a9a1c6$export$9ba4e89fdfa1fc54);
$parcel$export($3189c83282a9a1c6$exports, "HashRouter", () => $3189c83282a9a1c6$export$7221d69dcfc8e36b);
$parcel$export($3189c83282a9a1c6$exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);
$parcel$export($3189c83282a9a1c6$exports, "NavLink", () => $3189c83282a9a1c6$export$b0d92dbee9b5b60d);
$parcel$export($3189c83282a9a1c6$exports, "MemoryRouter", () => $ebf4c3fe5600f7ed$export$ae46f04cfaffe093);
$parcel$export($3189c83282a9a1c6$exports, "Prompt", () => $ebf4c3fe5600f7ed$export$83716a4aa1642908);
$parcel$export($3189c83282a9a1c6$exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export($3189c83282a9a1c6$exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export($3189c83282a9a1c6$exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export($3189c83282a9a1c6$exports, "StaticRouter", () => $ebf4c3fe5600f7ed$export$cac06da4d76d935b);
$parcel$export($3189c83282a9a1c6$exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export($3189c83282a9a1c6$exports, "generatePath", () => $ebf4c3fe5600f7ed$export$82476f982757e71e);
$parcel$export($3189c83282a9a1c6$exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export($3189c83282a9a1c6$exports, "useHistory", () => $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c);
$parcel$export($3189c83282a9a1c6$exports, "useLocation", () => $ebf4c3fe5600f7ed$export$45d76561a5302f2b);
$parcel$export($3189c83282a9a1c6$exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);
$parcel$export($3189c83282a9a1c6$exports, "useRouteMatch", () => $ebf4c3fe5600f7ed$export$632be4bb944c1bc7);
$parcel$export($3189c83282a9a1c6$exports, "withRouter", () => $ebf4c3fe5600f7ed$export$369b6b2b30582e8e);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;


function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;




var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $0b14391bdc5d7d11$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6e4c488965e5c6e8$export$2e2bcd8739ae039)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $2756f79476f0245f$var$PopStateEvent = 'popstate';
var $2756f79476f0245f$var$HashChangeEvent = 'hashchange';
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = 'hashchange';
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + '#' + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");
var $62ddf3174d9df941$exports = {};
var $52af415c3a3d4253$exports = {};
$52af415c3a3d4253$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $62ddf3174d9df941$exports = $62ddf3174d9df941$var$pathToRegexp;
$62ddf3174d9df941$exports.parse = $62ddf3174d9df941$var$parse;
$62ddf3174d9df941$exports.compile = $62ddf3174d9df941$var$compile;
$62ddf3174d9df941$exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
$62ddf3174d9df941$exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? '.*' : $62ddf3174d9df941$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $62ddf3174d9df941$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $62ddf3174d9df941$var$escapeString(delimiter) + ']+?';
    return $62ddf3174d9df941$var$escapeString(prevText) + '|(?:(?!' + $62ddf3174d9df941$var$escapeString(prevText) + ')[^' + $62ddf3174d9df941$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($52af415c3a3d4253$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$52af415c3a3d4253$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $62ddf3174d9df941$var$attachKeys(new RegExp('^' + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$52af415c3a3d4253$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($52af415c3a3d4253$exports(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $9ceddbf24b52ffba$exports = {};
'use strict';

$9ceddbf24b52ffba$exports = (parcelRequire("bilNr"));



var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $g7ajw.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $2756f79476f0245f$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $2756f79476f0245f$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $2756f79476f0245f$export$c3e8bb440bd55b18)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $2756f79476f0245f$export$fe53371bee54353d)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global$1, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;



var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $2756f79476f0245f$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $2756f79476f0245f$export$fe53371bee54353d)(context.location) === (0, $2756f79476f0245f$export$fe53371bee54353d)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $ebf4c3fe5600f7ed$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;



var $acw62 = parcelRequire("acw62");
'use client';
const $f52e2ccccb0d538f$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null);
const $f52e2ccccb0d538f$var$initialState = {
    didCatch: false,
    error: null
};
class $f52e2ccccb0d538f$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $f52e2ccccb0d538f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $f52e2ccccb0d538f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $acw62.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $acw62.createElement)($f52e2ccccb0d538f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $f52e2ccccb0d538f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $f52e2ccccb0d538f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $f52e2ccccb0d538f$export$c052f6604b7d51fe() {
    const context = (0, $acw62.useContext)($f52e2ccccb0d538f$export$b16d9fb1a22de840);
    $f52e2ccccb0d538f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $acw62.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $acw62.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $f52e2ccccb0d538f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $acw62.forwardRef)((props, ref)=>(0, $acw62.createElement)($f52e2ccccb0d538f$export$e926676385687eaf, errorBoundaryProps, (0, $acw62.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}


var $d2223f6bff7caeda$exports = {};
"use strict";
var $d2223f6bff7caeda$var$__importDefault = $d2223f6bff7caeda$exports && $d2223f6bff7caeda$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d2223f6bff7caeda$exports, "__esModule", {
    value: true
});
$d2223f6bff7caeda$exports.useTracking = $d2223f6bff7caeda$exports.TrackingProvider = void 0;

const $d2223f6bff7caeda$var$react_1 = $d2223f6bff7caeda$var$__importDefault((parcelRequire("acw62")));

const $d2223f6bff7caeda$var$amplitude_1 = $d2223f6bff7caeda$var$__importDefault((parcelRequire("j32pS")));
var $bbbd353b32b8f288$exports = {};
"use strict";
var $bbbd353b32b8f288$var$__importDefault = $bbbd353b32b8f288$exports && $bbbd353b32b8f288$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bbbd353b32b8f288$exports, "__esModule", {
    value: true
});
$bbbd353b32b8f288$exports.useIsInternal = void 0;

const $bbbd353b32b8f288$var$storage_1 = $bbbd353b32b8f288$var$__importDefault((parcelRequire("855hF")));
let $bbbd353b32b8f288$var$internal;
const $bbbd353b32b8f288$var$useIsInternal = ()=>{
    if ($bbbd353b32b8f288$var$internal !== undefined) return $bbbd353b32b8f288$var$internal;
    const { host: host } = window.location;
    if (host.includes('preview.') || host.includes('dev.') || host.includes('canary.') || /^pr\d+\./i.test(host) || host.includes('tools.modernatx.com')) $bbbd353b32b8f288$var$storage_1.default.setItem('MDRNA_PARTNER', '1', 365);
    $bbbd353b32b8f288$var$internal = $bbbd353b32b8f288$var$storage_1.default.getItem('MDRNA_PARTNER') === '1';
    return $bbbd353b32b8f288$var$internal;
};
$bbbd353b32b8f288$exports.useIsInternal = $bbbd353b32b8f288$var$useIsInternal;


const $d2223f6bff7caeda$var$getErrorProviderMissing = ()=>new Error('An "AnalyticProvider" needs to be implemented');
const $d2223f6bff7caeda$var$TrackingContext = $d2223f6bff7caeda$var$react_1.default.createContext({
    optIn: ()=>{
        throw $d2223f6bff7caeda$var$getErrorProviderMissing();
    },
    track: ()=>{
        throw $d2223f6bff7caeda$var$getErrorProviderMissing();
    },
    trackCustom: ()=>{
        throw $d2223f6bff7caeda$var$getErrorProviderMissing();
    },
    trackError: ()=>{
        throw $d2223f6bff7caeda$var$getErrorProviderMissing();
    },
    setUserId: ()=>{
        throw $d2223f6bff7caeda$var$getErrorProviderMissing();
    }
});
const $d2223f6bff7caeda$var$TrackingProvider = ({ amplitudeApiKey: amplitudeApiKey, children: children, customEventPrefix: customEventPrefix, defaultClickTracking: defaultClickTracking, locale: locale, anonymize: anonymize = true })=>{
    const internal = (0, $bbbd353b32b8f288$exports.useIsInternal)();
    const amplitude = $d2223f6bff7caeda$var$react_1.default.useRef(new $d2223f6bff7caeda$var$amplitude_1.default({
        apiKey: amplitudeApiKey,
        defaultClickTracking: defaultClickTracking,
        internal: internal,
        locale: locale,
        anonymize: anonymize
    }));
    $d2223f6bff7caeda$var$react_1.default.useEffect(()=>{
        const amplitudeCurrent = amplitude.current;
        amplitudeCurrent.init();
        return ()=>{
            amplitudeCurrent.destroy();
        };
    }, []);
    $d2223f6bff7caeda$var$react_1.default.useEffect(()=>{
        amplitude.current.setLocale(locale);
    }, [
        locale
    ]);
    const value = $d2223f6bff7caeda$var$react_1.default.useMemo(()=>({
            optIn: (optInValue)=>{
                amplitude.current.optIn(optInValue);
            },
            track: (event, options)=>{
                // @ts-ignore
                amplitude.current.track(event, options);
            },
            trackCustom: (event, options)=>{
                amplitude.current.trackCustom(`${customEventPrefix}: ${event}`, options);
            },
            trackError: (error)=>{
                amplitude.current.track('Error', {
                    'Error Message': error.message
                });
            },
            setUserId: (userId)=>{
                amplitude.current.setUserId(userId);
            }
        }), [
        customEventPrefix
    ]);
    return $d2223f6bff7caeda$var$react_1.default.createElement($d2223f6bff7caeda$var$TrackingContext.Provider, {
        value: value
    }, children);
};
$d2223f6bff7caeda$exports.TrackingProvider = $d2223f6bff7caeda$var$TrackingProvider;
const $d2223f6bff7caeda$var$useTracking = ()=>$d2223f6bff7caeda$var$react_1.default.useContext($d2223f6bff7caeda$var$TrackingContext);
$d2223f6bff7caeda$exports.useTracking = $d2223f6bff7caeda$var$useTracking;



var $4jPKB = parcelRequire("4jPKB");

var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;


var $2d512083a27c8269$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2d512083a27c8269$export$2e2bcd8739ae039 = $2d512083a27c8269$var$unitlessKeys;



var $gd942 = parcelRequire("gd942");

var $9ORqK = parcelRequire("9ORqK");

var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$y() {
    return ($f8dbcd8598db1f0b$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4jPKB.typeOf)(t);
}, $f8dbcd8598db1f0b$var$S = Object.freeze([]), $f8dbcd8598db1f0b$var$w = Object.freeze({});
function $f8dbcd8598db1f0b$var$E(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$N = ("undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.11", $f8dbcd8598db1f0b$var$C = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && false), $f8dbcd8598db1f0b$var$P = {}, $f8dbcd8598db1f0b$var$O = {};
function $f8dbcd8598db1f0b$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$T = new Map, $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = 1, $f8dbcd8598db1f0b$var$V = function(e) {
    if ($f8dbcd8598db1f0b$var$T.has(e)) return $f8dbcd8598db1f0b$var$T.get(e);
    for(; $f8dbcd8598db1f0b$var$x.has($f8dbcd8598db1f0b$var$k);)$f8dbcd8598db1f0b$var$k++;
    var t = $f8dbcd8598db1f0b$var$k++;
    return $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e), t;
}, $f8dbcd8598db1f0b$var$B = function(e) {
    return $f8dbcd8598db1f0b$var$x.get(e);
}, $f8dbcd8598db1f0b$var$z = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$k && ($f8dbcd8598db1f0b$var$k = t + 1), $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e);
}, $f8dbcd8598db1f0b$var$M = "style[" + $f8dbcd8598db1f0b$var$N + '][data-styled-version="5.3.11"]', $f8dbcd8598db1f0b$var$G = new RegExp("^" + $f8dbcd8598db1f0b$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$z(u, c), $f8dbcd8598db1f0b$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $f8dbcd8598db1f0b$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$H = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = $f8dbcd8598db1f0b$var$C, $f8dbcd8598db1f0b$var$J = {
    isServer: !$f8dbcd8598db1f0b$var$C,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$I
}, $f8dbcd8598db1f0b$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$w), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$y({}, $f8dbcd8598db1f0b$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$C && $f8dbcd8598db1f0b$var$U && ($f8dbcd8598db1f0b$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$N) && ($f8dbcd8598db1f0b$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$W(o) : r ? new $f8dbcd8598db1f0b$var$H(o) : new $f8dbcd8598db1f0b$var$$(o), new $f8dbcd8598db1f0b$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$Z = /(a)(d)/gi, $f8dbcd8598db1f0b$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$K(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$K(t % 52) + n).replace($f8dbcd8598db1f0b$var$Z, "$1-$2");
}
var $f8dbcd8598db1f0b$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$te = function(e) {
    return $f8dbcd8598db1f0b$var$ee(5381, e);
};
function $f8dbcd8598db1f0b$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$E(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$re = $f8dbcd8598db1f0b$var$te("5.3.11"), $f8dbcd8598db1f0b$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$ne(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$re, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$_e(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$se = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$w : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$w : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$S : c, l = new (0, $9a1e650477d9d52e$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$D(15), $f8dbcd8598db1f0b$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$de = ($f8dbcd8598db1f0b$var$le.Consumer, new $f8dbcd8598db1f0b$var$X), $f8dbcd8598db1f0b$var$he = $f8dbcd8598db1f0b$var$ae();
function $f8dbcd8598db1f0b$var$pe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$de;
}
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$le) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$pe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$he), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ve = /([A-Z])/, $f8dbcd8598db1f0b$var$ge = /([A-Z])/g, $f8dbcd8598db1f0b$var$Se = /^ms-/, $f8dbcd8598db1f0b$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$Ee(e) {
    return $f8dbcd8598db1f0b$var$ve.test(e) ? e.replace($f8dbcd8598db1f0b$var$ge, $f8dbcd8598db1f0b$var$we).replace($f8dbcd8598db1f0b$var$Se, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$be(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$E(t[i]) ? s.push($f8dbcd8598db1f0b$var$Ee(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $2d512083a27c8269$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$E(e) || $f8dbcd8598db1f0b$var$g(e) ? $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v($f8dbcd8598db1f0b$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v(e, n)));
}
var $f8dbcd8598db1f0b$var$Ce = /invalid hook call/i, $f8dbcd8598db1f0b$var$Ie = new Set, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$De = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$je(e) {
    return e.replace($f8dbcd8598db1f0b$var$Re, "-").replace($f8dbcd8598db1f0b$var$De, "");
}
var $f8dbcd8598db1f0b$var$Te = function(e) {
    return $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$te(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$xe(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$Be(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$ke(t) && $f8dbcd8598db1f0b$var$ke(r) ? $f8dbcd8598db1f0b$var$ze(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$ke(i)) for(var a in i)$f8dbcd8598db1f0b$var$Ve(a) && $f8dbcd8598db1f0b$var$Be(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$D(14);
            if ($f8dbcd8598db1f0b$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$D(8) : t ? $f8dbcd8598db1f0b$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Fe = {};
function $f8dbcd8598db1f0b$var$Ye(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$xe(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$je(e);
        $f8dbcd8598db1f0b$var$Fe[n] = ($f8dbcd8598db1f0b$var$Fe[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$Te("5.3.11" + n + $f8dbcd8598db1f0b$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $f8dbcd8598db1f0b$var$xe(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $f8dbcd8598db1f0b$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$w);
                var r = $f8dbcd8598db1f0b$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Oe(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$pe(), s = $f8dbcd8598db1f0b$var$fe(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $f8dbcd8598db1f0b$var$xe(b), N = v !== t ? $f8dbcd8598db1f0b$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $gd942.default), b) : !_ || (0, $gd942.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $f8dbcd8598db1f0b$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $acw62.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$xe(e) ? e : $f8dbcd8598db1f0b$var$je($f8dbcd8598db1f0b$var$b(e)));
        return $f8dbcd8598db1f0b$var$Ye(e, $f8dbcd8598db1f0b$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $f8dbcd8598db1f0b$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$w), !(0, $4jPKB.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$D(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$qe[e] = $f8dbcd8598db1f0b$var$qe(e);
});
var $f8dbcd8598db1f0b$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$ne(e), $f8dbcd8598db1f0b$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$Te(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$He(i, a);
    function d(e) {
        var t = $f8dbcd8598db1f0b$var$pe(), n = $f8dbcd8598db1f0b$var$fe(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), d = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$P, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$y({}, t, {
                theme: $f8dbcd8598db1f0b$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(d);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$Te(o);
    return new $f8dbcd8598db1f0b$var$ye(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$D(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$D(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$b(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$X,
    masterSheet: $f8dbcd8598db1f0b$var$de
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$qe;



const $7e056090552ec4ef$export$aad8462122ac592b = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  /* http://meyerweb.com/eric/tools/css/reset/
    v4.0 | 20180602
    License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  main, menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, main, menu, nav, section {
    display: block;
  }
  /* HTML5 hidden-attribute fix for newer browsers */
  *[hidden] {
    display: none;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* http://www.paulirish.com/2012/box-sizing-border-box-ftw/ (2015/04/28)*/
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  /* Additional resets */
  a {
    text-decoration: none;
    color: inherit;
  }
  button {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    outline: none;
    line-height: inherit;
    -webkit-appearance: none;
  }
  /* Fix antialiasing */
  *, *:before, *:after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  /* Disable user select on everything but texts */
  *, *:before, *:after {
    user-select: none;
  }
  p, h1, h2, h3, h4, h5, h6, blockquote, pre, ul, ol, li, table, tr, th, td, input, textarea {
    user-select: text;
  }
`;
var $7e056090552ec4ef$export$2e2bcd8739ae039 = $7e056090552ec4ef$export$aad8462122ac592b;


var $14f4ea63f74ea3da$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`
  ${(0, $7e056090552ec4ef$export$2e2bcd8739ae039)};

  body {
    font-weight: normal;
    font-family: "Aeonik Regular", "Arial";
    color: #1E2846;
  }
  a {
    font-family: 'Aeonik Regular', 'Arial', 'Nunito', 'Helvetica Neue', 'Helvetica', sans-serif;
    color: #177EAB;
  }

  p {
      margin: 5px 0px;
  }

  ul, li {
    line-height: normal
  }
  
  div, span {
    font-family: 'Aeonik Regular', 'Nunito', 'Arial';
  }
  *, *::before, *::after {
    box-sizing: border-box;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $fOd0O = parcelRequire("fOd0O");
var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}



var $acw62 = parcelRequire("acw62");
var $b6fcb3bf036a7cae$exports = {};
/*! For license information please see default.js.LICENSE.txt */ 
var $hPtJY = parcelRequire("hPtJY");
!function(e1, t) {
    $b6fcb3bf036a7cae$exports = t();
}(self, function() {
    return function() {
        var e1 = {
            9748: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return T;
                    }
                });
                var r = n(5385), o = n(9123), i = n(1971);
                function a(e1, t) {
                    var n = {};
                    return Object.assign(n, t), !n.stateToken && e1.stateToken && (n.stateToken = e1.stateToken), n;
                }
                function u(e1, t) {
                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn", t, {
                        withCredentials: !0
                    });
                }
                function c(e1) {
                    return !!f(e1);
                }
                function s(e1, t, n, o, i) {
                    return i = Object.assign({
                        withCredentials: !0
                    }, i), (0, r.v_)(e1, n, o, i).then(function(e1) {
                        return t.createTransaction(e1);
                    });
                }
                function f(e1) {
                    return e1.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
                }
                var l = n(3144), p = n(5671), h = n(4942), d = n(3193), v = n(4771), y = n(6718);
                function g(e1, t, n, i, u, c) {
                    if (Array.isArray(u)) return function(r, a) {
                        if (!r) throw new o.Z("Must provide a link name");
                        var s = (0, d.sE)(u, {
                            name: r
                        });
                        if (!s) throw new o.Z("No link found for that name");
                        return g(e1, t, n, i, s, c)(a);
                    };
                    if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch(u.hints.allow[0]){
                        case "GET":
                            return function() {
                                return (0, r.U2)(e1, u.href, {
                                    withCredentials: !0
                                });
                            };
                        case "POST":
                            return function(r) {
                                c && c.isPolling && (c.isPolling = !1);
                                var f = a(n, r);
                                "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                                    factorType: i.factorType,
                                    provider: i.provider
                                });
                                var l = {}, p = f.autoPush;
                                if (void 0 !== p) {
                                    if ("function" == typeof p) try {
                                        l.autoPush = !!p();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                    }
                                    else null !== p && (l.autoPush = !!p);
                                    f = (0, d.CE)(f, "autoPush");
                                }
                                var h = f.rememberDevice;
                                if (void 0 !== h) {
                                    if ("function" == typeof h) try {
                                        l.rememberDevice = !!h();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                    }
                                    else null !== h && (l.rememberDevice = !!h);
                                    f = (0, d.CE)(f, "rememberDevice");
                                } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, d.CE)(f.profile, "updatePhone"));
                                var v = u.href + (0, y.UK)(l);
                                return s(e1, t, v, f);
                            };
                    }
                }
                var m = n(8750), b = n(6573);
                function w(e1, t, n) {
                    return function(u) {
                        var c, s, f, l;
                        (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
                        var p = (0, d.Rg)(t, "next", "poll");
                        n.isPolling = !0;
                        var h = 0;
                        return (function i() {
                            return n.isPolling ? (function() {
                                var n = {};
                                if ("function" == typeof f) try {
                                    n.autoPush = !!f();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                }
                                else null != f && (n.autoPush = !!f);
                                if ("function" == typeof s) try {
                                    n.rememberDevice = !!s();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                }
                                else null != s && (n.rememberDevice = !!s);
                                var i = p.href + (0, y.UK)(n);
                                return (0, r.v_)(e1, i, function(e1) {
                                    return a(e1);
                                }(t), {
                                    saveAuthnState: !1,
                                    withCredentials: !0
                                });
                            })().then(function(t) {
                                if (h = 0, t.factorResult && "WAITING" === t.factorResult) {
                                    if (!n.isPolling) throw new b.Z;
                                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                                }
                                return n.isPolling = !1, e1.tx.createTransaction(t);
                            }).catch(function(e1) {
                                if (e1.xhr && (0 === e1.xhr.status || 429 === e1.xhr.status) && h <= 4) {
                                    var t = 1e3 * Math.pow(2, h);
                                    return h++, (0, m.gw)(t).then(i);
                                }
                                throw e1;
                            }) : Promise.reject(new b.Z);
                        })().catch(function(e1) {
                            throw n.isPolling = !1, e1;
                        });
                    };
                }
                function k(e1, t, n, r, o) {
                    if (r = r || n, r = (0, d.d9)(r), Array.isArray(r)) {
                        for(var i = [], a = 0, u = r.length; a < u; a++)i.push(k(e1, t, n, r[a], o));
                        return i;
                    }
                    var c = r._embedded || {};
                    for(var s in c)Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = k(e1, t, n, c[s], o));
                    var f = function(e1, t, n, r, o) {
                        var i = {};
                        for(var a in r._links)if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                            var u = r._links[a];
                            if ("next" === a && (a = u.name), u.type) i[a] = u;
                            else if ("poll" === a) i.poll = w(e1, n, o);
                            else {
                                var c = g(e1, t, n, r, u, o);
                                c && (i[a] = c);
                            }
                        }
                        return i;
                    }(e1, t, n, r, o);
                    return Object.assign(c, f), r = (0, d.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
                }
                var O = (0, l.Z)(function e1(t, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    (0, p.Z)(this, e1), (0, h.Z)(this, "next", void 0), (0, h.Z)(this, "cancel", void 0), (0, h.Z)(this, "skip", void 0), (0, h.Z)(this, "unlock", void 0), (0, h.Z)(this, "changePassword", void 0), (0, h.Z)(this, "resetPassword", void 0), (0, h.Z)(this, "answer", void 0), (0, h.Z)(this, "recovery", void 0), (0, h.Z)(this, "verify", void 0), (0, h.Z)(this, "resend", void 0), (0, h.Z)(this, "activate", void 0), (0, h.Z)(this, "poll", void 0), (0, h.Z)(this, "prev", void 0), (0, h.Z)(this, "data", void 0), (0, h.Z)(this, "stateToken", void 0), (0, h.Z)(this, "sessionToken", void 0), (0, h.Z)(this, "status", void 0), (0, h.Z)(this, "user", void 0), (0, h.Z)(this, "factor", void 0), (0, h.Z)(this, "factors", void 0), (0, h.Z)(this, "policy", void 0), (0, h.Z)(this, "scopes", void 0), (0, h.Z)(this, "target", void 0), (0, h.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, k(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function() {
                        return Promise.resolve(n.createTransaction());
                    }));
                });
                function T(e1) {
                    var t = {
                        status: u.bind(null, e1),
                        resume: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var r = f(e1);
                                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                                    n = {
                                        stateToken: r
                                    };
                                }
                                return u(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        exists: c.bind(null, e1),
                        introspect: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var i = f(e1);
                                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                                    n = {
                                        stateToken: i
                                    };
                                }
                                return (function(e1, t) {
                                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                                        withCredentials: !0
                                    });
                                })(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        createTransaction: function(n) {
                            return new O(e1, t, n);
                        },
                        postToTransaction: function(n, r, o) {
                            return s(e1, t, n, r, o);
                        }
                    };
                    return t;
                }
            },
            3398: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return r.b;
                    },
                    t: function() {
                        return o.t;
                    }
                });
                var r = n(9748), o = n(8284);
            },
            8284: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return b;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(3193), d = n(9123), v = n(415), y = n(4970);
                function g(e1, t) {
                    var n, r, o;
                    return t = t || {}, (0, v.isFingerprintSupported)() ? new Promise(function(i, a) {
                        var u;
                        (r = document.createElement("iframe")).style.display = "none", o = function(t) {
                            if (t && t.data && t.origin === e1.getIssuerOrigin()) {
                                try {
                                    var n = JSON.parse(t.data);
                                } catch (e1) {
                                    return;
                                }
                                if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
                                    type: "GetFingerprint"
                                }), t.origin));
                            }
                        }, (0, y.NH)(window, "message", o), r.src = e1.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function() {
                            a(new d.Z("Fingerprinting timed out"));
                        }, (null === (u = t) || void 0 === u ? void 0 : u.timeout) || 15e3);
                    }).finally(function() {
                        clearTimeout(n), (0, y.ys)(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
                    }) : Promise.reject(new d.Z("Fingerprinting is not supported on this device"));
                }
                var m = n(9748);
                function b(e1) {
                    return function(e1) {
                        (0, u.Z)(y, e1);
                        var t, n, l, d, v = (l = y, d = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(l);
                            if (d) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function y() {
                            var e1;
                            (0, o.Z)(this, y);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = v.call.apply(v, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "tx", void 0), (0, f.Z)((0, a.Z)(e1), "authn", void 0), (0, f.Z)((0, a.Z)(e1), "fingerprint", void 0), e1.authn = e1.tx = (0, m.b)((0, a.Z)(e1)), e1.fingerprint = g.bind(null, (0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(y, [
                            {
                                key: "signIn",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    var n, r = this;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = (0, h.d9)(t || {}), n = function(e1) {
                                                    return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e1);
                                                }, t.sendFingerprint) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", n());
                                            case 4:
                                                return e1.abrupt("return", this.fingerprint().then(function(e1) {
                                                    return n({
                                                        headers: {
                                                            "X-Device-Fingerprint": e1
                                                        }
                                                    });
                                                }));
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithCredentials",
                                value: (t = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", this.signIn(t));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "forgotPassword",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/password", e1);
                                }
                            },
                            {
                                key: "unlockAccount",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e1);
                                }
                            },
                            {
                                key: "verifyRecoveryToken",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/token", e1);
                                }
                            }
                        ]), y;
                    }(e1);
                }
            },
            9893: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = n(3193), u = n(415), c = n(1971), s = n(4279), f = n.n(s);
                function l(e1) {
                    var t = (0, r.Z)(function t() {
                        (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
                        var n = new e1(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
                        this.options = (0, a.YY)(n), this.emitter = new (f()), this.features = u;
                    });
                    return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
                        constants: c
                    }), t;
                }
            },
            3306: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return o.X;
                    },
                    a: function() {
                        return r.a;
                    }
                });
                var r = n(9893), o = n(5093);
            },
            5093: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942);
                function a() {
                    return (0, r.Z)(function e1(t) {
                        (0, o.Z)(this, e1), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
                    });
                }
            },
            4858: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)e1[r] = n[r];
                    }
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var o = function e1(t, n) {
                    function o(e1, o, i) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e1 = encodeURIComponent(e1).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                            var a = "";
                            for(var u in i)i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                            return document.cookie = e1 + "=" + t.write(o, e1) + a;
                        }
                    }
                    return Object.create({
                        set: o,
                        get: function(e1) {
                            if ("undefined" != typeof document && (!arguments.length || e1)) {
                                for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++){
                                    var i = n[o].split("="), a = i.slice(1).join("=");
                                    try {
                                        var u = decodeURIComponent(i[0]);
                                        if (r[u] = t.read(a, u), e1 === u) break;
                                    } catch (e1) {}
                                }
                                return e1 ? r[e1] : r;
                            }
                        },
                        remove: function(e1, t) {
                            o(e1, "", r({}, t, {
                                expires: -1
                            }));
                        },
                        withAttributes: function(t) {
                            return e1(this.converter, r({}, this.attributes, t));
                        },
                        withConverter: function(t) {
                            return e1(r({}, this.converter, t), this.attributes);
                        }
                    }, {
                        attributes: {
                            value: Object.freeze(n)
                        },
                        converter: {
                            value: Object.freeze(t)
                        }
                    });
                }({
                    read: function(e1) {
                        return '"' === e1[0] && (e1 = e1.slice(1, -1)), e1.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                    },
                    write: function(e1) {
                        return encodeURIComponent(e1).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                    }
                }, {
                    path: "/"
                }), i = o, a = n(9123), u = n(146), c = n(415), s = {
                    browserHasLocalStorage: function() {
                        try {
                            var e1 = this.getLocalStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    browserHasSessionStorage: function() {
                        try {
                            var e1 = this.getSessionStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    testStorageType: function(e1) {
                        var t = !1;
                        switch(e1){
                            case "sessionStorage":
                                t = this.browserHasSessionStorage();
                                break;
                            case "localStorage":
                                t = this.browserHasLocalStorage();
                                break;
                            case "cookie":
                            case "memory":
                                t = !0;
                                break;
                            default:
                                t = !1;
                        }
                        return t;
                    },
                    getStorageByType: function(e1, t) {
                        var n;
                        switch(e1){
                            case "sessionStorage":
                                n = this.getSessionStorage();
                                break;
                            case "localStorage":
                                n = this.getLocalStorage();
                                break;
                            case "cookie":
                                n = this.getCookieStorage(t);
                                break;
                            case "memory":
                                n = this.getInMemoryStorage();
                                break;
                            default:
                                throw new a.Z("Unrecognized storage option: ".concat(e1));
                        }
                        return n;
                    },
                    findStorageType: function(e1) {
                        var t, n;
                        return t = (e1 = e1.slice()).shift(), (n = e1.length ? e1[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e1)) : t;
                    },
                    getLocalStorage: function() {
                        return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function() {}), localStorage;
                    },
                    getSessionStorage: function() {
                        return sessionStorage;
                    },
                    getCookieStorage: function(e1) {
                        var t = this, n = e1.secure, r = e1.sameSite, o = e1.sessionCookie;
                        if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                        var i = {
                            getItem: this.storage.get,
                            setItem: function(e1, i) {
                                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                                a = o ? null : a, t.storage.set(e1, i, a, {
                                    secure: n,
                                    sameSite: r
                                });
                            },
                            removeItem: function(e1) {
                                t.storage.delete(e1);
                            }
                        };
                        return e1.useSeparateCookies ? {
                            getItem: function(e1) {
                                var t = i.getItem(), n = {};
                                return Object.keys(t).forEach(function(r) {
                                    0 === r.indexOf(e1) && (n[r.replace("".concat(e1, "_"), "")] = JSON.parse(t[r]));
                                }), JSON.stringify(n);
                            },
                            setItem: function(e1, t) {
                                var n = JSON.parse(this.getItem(e1));
                                t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                    var o = e1 + "_" + r, a = JSON.stringify(t[r]);
                                    i.setItem(o, a), delete n[r];
                                }), Object.keys(n).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            },
                            removeItem: function(e1) {
                                var t = JSON.parse(this.getItem(e1));
                                Object.keys(t).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            }
                        } : i;
                    },
                    inMemoryStore: {},
                    getInMemoryStorage: function() {
                        var e1 = this;
                        return {
                            getItem: function(t) {
                                return e1.inMemoryStore[t];
                            },
                            setItem: function(t, n) {
                                e1.inMemoryStore[t] = n;
                            }
                        };
                    },
                    testStorage: function(e1) {
                        var t = "okta-test-storage";
                        try {
                            return e1.setItem(t, t), e1.removeItem(t), !0;
                        } catch (e1) {
                            return !1;
                        }
                    },
                    storage: {
                        set: function(e1, t, n, r) {
                            var o = r.sameSite, u = r.secure;
                            if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                            var c = {
                                path: r.path || "/",
                                secure: u,
                                sameSite: o
                            };
                            return Date.parse(n) && (c.expires = new Date(n)), i.set(e1, t, c), this.get(e1);
                        },
                        get: function(e1) {
                            return arguments.length ? i.get(e1) : i.get();
                        },
                        delete: function(e1) {
                            return i.remove(e1, {
                                path: "/"
                            });
                        }
                    }
                }, f = s;
            },
            1971: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return d;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return c;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return a;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return w;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return o;
                    },
                    IDX_API_VERSION: function() {
                        return k;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return h;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return v;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return b;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return m;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return p;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return s;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return g;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return y;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return l;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return r;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return u;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return f;
                    }
                });
                var r = "oktaStateToken", o = 500, i = 300, a = 86400, u = "okta-token-storage", c = "okta-cache-storage", s = "okta-pkce-storage", f = "okta-transaction-storage", l = "okta-shared-transaction-storage", p = "okta-original-uri-storage", h = "okta-idx-response-storage", d = "accessToken", v = "idToken", y = "refreshToken", g = "referrerPath", m = 43, b = 128, w = "S256", k = "1.0.0";
            },
            1018: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return w;
                    },
                    a: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(4942), u = n(4687), c = n.n(u), s = n(3615), f = n.n(s), l = n(9123), p = n(7088), h = n(3548), d = n(146);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var g = null, m = {
                    updateAuthStatePromise: null,
                    canceledTimes: 0
                }, b = "authStateChange", w = function() {
                    function e1(t) {
                        var n = this;
                        if ((0, o.Z)(this, e1), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                        this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new h.b({
                            quiet: !0
                        }), t.tokenManager.on(p.O3, function(e1, t) {
                            n._setLogOptions({
                                event: p.O3,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        }), t.tokenManager.on(p.FT, function(e1, t) {
                            n._setLogOptions({
                                event: p.FT,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        });
                    }
                    var t;
                    return (0, i.Z)(e1, [
                        {
                            key: "_setLogOptions",
                            value: function(e1) {
                                this._logOptions = e1;
                            }
                        },
                        {
                            key: "getAuthState",
                            value: function() {
                                return this._authState;
                            }
                        },
                        {
                            key: "getPreviousAuthState",
                            value: function() {
                                return this._prevAuthState;
                            }
                        },
                        {
                            key: "updateAuthState",
                            value: (t = (0, r.Z)(c().mark(function e1() {
                                var t, n, r, o, i, a, u, s = this;
                                return c().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e1) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                (0, d.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e1)), (0, d.dr)().log(r, o), (0, d.dr)().log("Current authState", s._authState), (0, d.dr)().groupEnd(), s._logOptions = {};
                                            }, i = function(e1) {
                                                var t, n;
                                                n = e1, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e1, s._sdk.emitter.emit(b, y({}, e1)), r && o("emitted"));
                                            }, a = function e1(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e1(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e1.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new (f())(function(e1, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e1() : (i(t), e1(), s._pending = y({}, m));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e1();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function(e1) {
                                                            return c(e1);
                                                        }).catch(function(e1) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e1
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e1.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "subscribe",
                            value: function(e1) {
                                this._sdk.emitter.on(b, e1);
                            }
                        },
                        {
                            key: "unsubscribe",
                            value: function(e1) {
                                this._sdk.emitter.off(b, e1);
                            }
                        }
                    ]), e1;
                }();
            },
            2397: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return ge;
                    }
                });
                var r = n(885), o = n(2982), i = n(5861), a = n(5671), u = n(3144), c = n(4942), s = n(4687), f = n.n(s);
                Promise.resolve(!1);
                var l = Promise.resolve(!0), p = Promise.resolve();
                function h(e1, t) {
                    return e1 || (e1 = 0), new Promise(function(n) {
                        return setTimeout(function() {
                            return n(t);
                        }, e1);
                    });
                }
                function d() {
                    return Math.random().toString(36).substring(2);
                }
                var v = 0, y = 0;
                function g() {
                    var e1 = (new Date).getTime();
                    return e1 === v ? 1e3 * e1 + ++y : (v = e1, y = 0, 1e3 * e1);
                }
                var m = {
                    create: function(e1) {
                        var t = {
                            messagesCallback: null,
                            bc: new BroadcastChannel(e1),
                            subFns: []
                        };
                        return t.bc.onmessage = function(e1) {
                            t.messagesCallback && t.messagesCallback(e1.data);
                        }, t;
                    },
                    close: function(e1) {
                        e1.bc.close(), e1.subFns = [];
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        try {
                            return e1.bc.postMessage(t, !1), p;
                        } catch (e1) {
                            return Promise.reject(e1);
                        }
                    },
                    canBeUsed: function() {
                        if ("undefined" == typeof window) return !1;
                        if ("function" == typeof BroadcastChannel) {
                            if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                            return !0;
                        }
                        return !1;
                    },
                    type: "native",
                    averageResponseTime: function() {
                        return 150;
                    },
                    microSeconds: g
                }, b = function() {
                    function e1(e1) {
                        this.ttl = e1, this.map = new Map, this._to = !1;
                    }
                    return e1.prototype.has = function(e1) {
                        return this.map.has(e1);
                    }, e1.prototype.add = function(e1) {
                        var t = this;
                        this.map.set(e1, w()), this._to || (this._to = !0, setTimeout(function() {
                            t._to = !1, function(e1) {
                                for(var t = w() - e1.ttl, n = e1.map[Symbol.iterator]();;){
                                    var r = n.next().value;
                                    if (!r) return;
                                    var o = r[0];
                                    if (!(r[1] < t)) return;
                                    e1.map.delete(o);
                                }
                            }(t);
                        }, 0));
                    }, e1.prototype.clear = function() {
                        this.map.clear();
                    }, e1;
                }();
                function w() {
                    return (new Date).getTime();
                }
                function k() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e1));
                    return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e1.idb && "function" == typeof e1.idb.onclose && (t.idb.onclose = e1.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e1.methods && (t.methods = e1.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
                }
                var O = "messages", T = {
                    durability: "relaxed"
                };
                function Z() {
                    if ("undefined" != typeof indexedDB) return indexedDB;
                    if ("undefined" != typeof window) {
                        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
                        if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
                        if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
                    }
                    return !1;
                }
                function E(e1) {
                    e1.commit && e1.commit();
                }
                function S(e1) {
                    e1.closed || x(e1).then(function() {
                        return h(e1.options.idb.fallbackInterval);
                    }).then(function() {
                        return S(e1);
                    });
                }
                function x(e1) {
                    return e1.closed ? p : e1.messagesCallback ? (function(e1, t) {
                        var n = e1.transaction(O, "readonly", T), r = n.objectStore(O), o = [], i = IDBKeyRange.bound(t + 1, 1 / 0);
                        if (r.getAll) {
                            var a = r.getAll(i);
                            return new Promise(function(e1, t) {
                                a.onerror = function(e1) {
                                    return t(e1);
                                }, a.onsuccess = function(t) {
                                    e1(t.target.result);
                                };
                            });
                        }
                        return new Promise(function(e1, a) {
                            var u = function() {
                                try {
                                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                                } catch (e1) {
                                    return r.openCursor();
                                }
                            }();
                            u.onerror = function(e1) {
                                return a(e1);
                            }, u.onsuccess = function(r) {
                                var i = r.target.result;
                                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (E(n), e1(o));
                            };
                        });
                    })(e1.db, e1.lastCursorId).then(function(t) {
                        var n = t.filter(function(e1) {
                            return !!e1;
                        }).map(function(t) {
                            return t.id > e1.lastCursorId && (e1.lastCursorId = t.id), t;
                        }).filter(function(t) {
                            return function(e1, t) {
                                return !(e1.uuid === t.uuid || t.eMIs.has(e1.id) || e1.data.time < t.messagesCallbackTime);
                            }(t, e1);
                        }).sort(function(e1, t) {
                            return e1.time - t.time;
                        });
                        return n.forEach(function(t) {
                            e1.messagesCallback && (e1.eMIs.add(t.id), e1.messagesCallback(t.data));
                        }), p;
                    }) : p;
                }
                var P = {
                    create: function(e1, t) {
                        return t = k(t), (function(e1) {
                            var t = "pubkey.broadcast-channel-0-" + e1, n = Z().open(t);
                            return n.onupgradeneeded = function(e1) {
                                e1.target.result.createObjectStore(O, {
                                    keyPath: "id",
                                    autoIncrement: !0
                                });
                            }, new Promise(function(e1, t) {
                                n.onerror = function(e1) {
                                    return t(e1);
                                }, n.onsuccess = function() {
                                    e1(n.result);
                                };
                            });
                        })(e1).then(function(n) {
                            var r = {
                                closed: !1,
                                lastCursorId: 0,
                                channelName: e1,
                                options: t,
                                uuid: d(),
                                eMIs: new b(2 * t.idb.ttl),
                                writeBlockPromise: p,
                                messagesCallback: null,
                                readQueuePromises: [],
                                db: n
                            };
                            return n.onclose = function() {
                                r.closed = !0, t.idb.onclose && t.idb.onclose();
                            }, S(r), r;
                        });
                    },
                    close: function(e1) {
                        e1.closed = !0, e1.db.close();
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t, x(e1);
                    },
                    postMessage: function(e1, t) {
                        return e1.writeBlockPromise = e1.writeBlockPromise.then(function() {
                            return function(e1, t, n) {
                                var r = {
                                    uuid: t,
                                    time: (new Date).getTime(),
                                    data: n
                                }, o = e1.transaction([
                                    O
                                ], "readwrite", T);
                                return new Promise(function(e1, t) {
                                    o.oncomplete = function() {
                                        return e1();
                                    }, o.onerror = function(e1) {
                                        return t(e1);
                                    }, o.objectStore(O).add(r), E(o);
                                });
                            }(e1.db, e1.uuid, t);
                        }).then(function() {
                            var t, n;
                            0 === Math.floor(11 * Math.random() + 0) && (t = e1.db, n = e1.options.idb.ttl, (function(e1, t) {
                                var n = (new Date).getTime() - t, r = e1.transaction(O, "readonly", T), o = r.objectStore(O), i = [];
                                return new Promise(function(e1) {
                                    o.openCursor().onsuccess = function(t) {
                                        var o = t.target.result;
                                        if (o) {
                                            var a = o.value;
                                            if (!(a.time < n)) return E(r), void e1(i);
                                            i.push(a), o.continue();
                                        } else e1(i);
                                    };
                                });
                            })(t, n).then(function(e1) {
                                return function(e1, t) {
                                    var n = e1.transaction([
                                        O
                                    ], "readwrite", T).objectStore(O);
                                    return Promise.all(t.map(function(e1) {
                                        var t = n.delete(e1);
                                        return new Promise(function(e1) {
                                            t.onsuccess = function() {
                                                return e1();
                                            };
                                        });
                                    }));
                                }(t, e1.map(function(e1) {
                                    return e1.id;
                                }));
                            }));
                        }), e1.writeBlockPromise;
                    },
                    canBeUsed: function() {
                        return !!Z();
                    },
                    type: "idb",
                    averageResponseTime: function(e1) {
                        return 2 * e1.idb.fallbackInterval;
                    },
                    microSeconds: g
                };
                function A() {
                    var e1;
                    if ("undefined" == typeof window) return null;
                    try {
                        e1 = window.localStorage, e1 = window["ie8-eventlistener/storage"] || window.localStorage;
                    } catch (e1) {}
                    return e1;
                }
                function _(e1) {
                    return "pubkey.broadcastChannel-" + e1;
                }
                function R() {
                    var e1 = A();
                    if (!e1) return !1;
                    try {
                        var t = "__broadcastchannel_check";
                        e1.setItem(t, "works"), e1.removeItem(t);
                    } catch (e1) {
                        return !1;
                    }
                    return !0;
                }
                var j = {
                    create: function(e1, t) {
                        if (t = k(t), !R()) throw new Error("BroadcastChannel: localstorage cannot be used");
                        var n = d(), r = new b(t.localstorage.removeTimeout), o = {
                            channelName: e1,
                            uuid: n,
                            eMIs: r
                        };
                        return o.listener = function(e1, t) {
                            var i = _(e1), a = function(e1) {
                                var t;
                                e1.key === i && (t = JSON.parse(e1.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                            };
                            return window.addEventListener("storage", a), a;
                        }(e1), o;
                    },
                    close: function(e1) {
                        var t;
                        t = e1.listener, window.removeEventListener("storage", t);
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            h().then(function() {
                                var r = _(e1.channelName), o = {
                                    token: d(),
                                    time: (new Date).getTime(),
                                    data: t,
                                    uuid: e1.uuid
                                }, i = JSON.stringify(o);
                                A().setItem(r, i);
                                var a = document.createEvent("Event");
                                a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                            });
                        });
                    },
                    canBeUsed: R,
                    type: "localstorage",
                    averageResponseTime: function() {
                        var e1 = navigator.userAgent.toLowerCase();
                        return e1.includes("safari") && !e1.includes("chrome") ? 240 : 120;
                    },
                    microSeconds: g
                }, C = g, D = new Set, I = {
                    create: function(e1) {
                        var t = {
                            name: e1,
                            messagesCallback: null
                        };
                        return D.add(t), t;
                    },
                    close: function(e1) {
                        D.delete(e1);
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            return setTimeout(function() {
                                Array.from(D).filter(function(t) {
                                    return t.name === e1.name;
                                }).filter(function(t) {
                                    return t !== e1;
                                }).filter(function(e1) {
                                    return !!e1.messagesCallback;
                                }).forEach(function(e1) {
                                    return e1.messagesCallback(t);
                                }), n();
                            }, 5);
                        });
                    },
                    canBeUsed: function() {
                        return !0;
                    },
                    type: "simulate",
                    averageResponseTime: function() {
                        return 5;
                    },
                    microSeconds: C
                }, N = [
                    m,
                    P,
                    j
                ], M = new Set, U = 0, L = function(e1, t) {
                    var n, r, o;
                    this.id = U++, M.add(this), this.name = e1, this.options = k(t), this.method = function(e1) {
                        var t = [].concat(e1.methods, N).filter(Boolean);
                        if (e1.type) {
                            if ("simulate" === e1.type) return I;
                            var n = t.find(function(t) {
                                return t.type === e1.type;
                            });
                            if (n) return n;
                            throw new Error("method-type " + e1.type + " not found");
                        }
                        e1.webWorkerSupport || (t = t.filter(function(e1) {
                            return "idb" !== e1.type;
                        }));
                        var r = t.find(function(e1) {
                            return e1.canBeUsed();
                        });
                        if (r) return r;
                        throw new Error("No useable method found in " + JSON.stringify(N.map(function(e1) {
                            return e1.type;
                        })));
                    }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                        message: [],
                        internal: []
                    }, this._uMP = new Set, this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function(e1) {
                        n._state = e1;
                    })) : n._state = r;
                };
                function F(e1, t, n) {
                    var r = {
                        time: e1.method.microSeconds(),
                        type: t,
                        data: n
                    };
                    return (e1._prepP ? e1._prepP : p).then(function() {
                        var t = e1.method.postMessage(e1._state, r);
                        return e1._uMP.add(t), t.catch().then(function() {
                            return e1._uMP.delete(t);
                        }), t;
                    });
                }
                function B(e1) {
                    return e1._addEL.message.length > 0 || e1._addEL.internal.length > 0;
                }
                function H(e1, t, n) {
                    e1._addEL[t].push(n), function(e1) {
                        if (!e1._iL && B(e1)) {
                            var t = function(t) {
                                e1._addEL[t.type].forEach(function(e1) {
                                    var n = e1.time - 1e5;
                                    t.time >= n && e1.fn(t.data);
                                });
                            }, n = e1.method.microSeconds();
                            e1._prepP ? e1._prepP.then(function() {
                                e1._iL = !0, e1.method.onMessage(e1._state, t, n);
                            }) : (e1._iL = !0, e1.method.onMessage(e1._state, t, n));
                        }
                    }(e1);
                }
                function K(e1, t, n) {
                    e1._addEL[t] = e1._addEL[t].filter(function(e1) {
                        return e1 !== n;
                    }), function(e1) {
                        if (e1._iL && !B(e1)) {
                            e1._iL = !1;
                            var t = e1.method.microSeconds();
                            e1.method.onMessage(e1._state, null, t);
                        }
                    }(e1);
                }
                L._pubkey = !0, L.prototype = {
                    postMessage: function(e1) {
                        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e1));
                        return F(this, "message", e1);
                    },
                    postInternal: function(e1) {
                        return F(this, "internal", e1);
                    },
                    set onmessage (e){
                        var t1 = {
                            time: this.method.microSeconds(),
                            fn: e
                        };
                        K(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t1, H(this, "message", t1)) : this._onML = null;
                    },
                    addEventListener: function(e1, t) {
                        H(this, e1, {
                            time: this.method.microSeconds(),
                            fn: t
                        });
                    },
                    removeEventListener: function(e1, t) {
                        K(this, e1, this._addEL[e1].find(function(e1) {
                            return e1.fn === t;
                        }));
                    },
                    close: function() {
                        var e1 = this;
                        if (!this.closed) {
                            M.delete(this), this.closed = !0;
                            var t = this._prepP ? this._prepP : p;
                            return this._onML = null, this._addEL.message = [], t.then(function() {
                                return Promise.all(Array.from(e1._uMP));
                            }).then(function() {
                                return Promise.all(e1._befC.map(function(e1) {
                                    return e1();
                                }));
                            }).then(function() {
                                return e1.method.close(e1._state);
                            });
                        }
                    },
                    get type () {
                        return this.method.type;
                    },
                    get isClosed () {
                        return this.closed;
                    }
                };
                var G = n(5643), V = n.n(G), q = {
                    add: function(e1) {
                        if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) ;
                        else {
                            if ("function" != typeof window.addEventListener) return;
                            window.addEventListener("beforeunload", function() {
                                e1();
                            }, !0), window.addEventListener("unload", function() {
                                e1();
                            }, !0);
                        }
                    }
                }, Y = n(199), W = n.n(Y), Q = V() ? W() : q, z = new Set, X = !1;
                function $() {
                    var e1 = [];
                    return z.forEach(function(t) {
                        e1.push(t()), z.delete(t);
                    }), Promise.all(e1);
                }
                var J = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, this._options = t, this.isLeader = !1, this.hasLeader = !1, this.isDead = !1, this.token = d(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {}, this._dpLC = !1;
                    var r = function(e1) {
                        "leader" === e1.context && ("death" === e1.action && (n.hasLeader = !1), "tell" === e1.action && (n.hasLeader = !0));
                    };
                    this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
                };
                function ee(e1, t) {
                    var n = {
                        context: "leader",
                        action: t,
                        token: e1.token
                    };
                    return e1.broadcastChannel.postInternal(n);
                }
                function te(e1, t) {
                    if (e1._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
                    t = function(e1, t) {
                        return e1 || (e1 = {}), (e1 = JSON.parse(JSON.stringify(e1))).fallbackInterval || (e1.fallbackInterval = 3e3), e1.responseTime || (e1.responseTime = t.method.averageResponseTime(t.options)), e1;
                    }(t, e1);
                    var n = new J(e1, t);
                    return e1._befC.push(function() {
                        return n.die();
                    }), e1._leaderElector = n, n;
                }
                J.prototype = {
                    applyOnce: function(e1) {
                        var t = this;
                        if (this.isLeader) return h(0, !0);
                        if (this.isDead) return h(0, !1);
                        if (this._aplQC > 1) return this._aplQ;
                        var n = function() {
                            if (t.isLeader) return l;
                            var n, r = !1, o = new Promise(function(e1) {
                                n = function() {
                                    r = !0, e1();
                                };
                            }), i = [], a = function(e1) {
                                "leader" === e1.context && e1.token != t.token && (i.push(e1), "apply" === e1.action && e1.token > t.token && n(), "tell" === e1.action && (n(), t.hasLeader = !0));
                            };
                            t.broadcastChannel.addEventListener("internal", a);
                            var u = e1 ? 4 * t._options.responseTime : t._options.responseTime;
                            return ee(t, "apply").then(function() {
                                return Promise.race([
                                    h(u),
                                    o.then(function() {
                                        return Promise.reject(new Error);
                                    })
                                ]);
                            }).then(function() {
                                return ee(t, "apply");
                            }).then(function() {
                                return Promise.race([
                                    h(u),
                                    o.then(function() {
                                        return Promise.reject(new Error);
                                    })
                                ]);
                            }).catch(function() {}).then(function() {
                                return t.broadcastChannel.removeEventListener("internal", a), !r && (function(e1) {
                                    e1.isLeader = !0, e1.hasLeader = !0;
                                    var t = function(e1) {
                                        if (X || (X = !0, Q.add($)), "function" != typeof e1) throw new Error("Listener is no function");
                                        return z.add(e1), {
                                            remove: function() {
                                                return z.delete(e1);
                                            },
                                            run: function() {
                                                return z.delete(e1), e1();
                                            }
                                        };
                                    }(function() {
                                        return e1.die();
                                    });
                                    e1._unl.push(t);
                                    var n = function(t) {
                                        "leader" === t.context && "apply" === t.action && ee(e1, "tell"), "leader" !== t.context || "tell" !== t.action || e1._dpLC || (e1._dpLC = !0, e1._dpL(), ee(e1, "tell"));
                                    };
                                    return e1.broadcastChannel.addEventListener("internal", n), e1._lstns.push(n), ee(e1, "tell");
                                })(t).then(function() {
                                    return !0;
                                });
                            });
                        };
                        return this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
                            return n();
                        }).then(function() {
                            t._aplQC = t._aplQC - 1;
                        }), this._aplQ.then(function() {
                            return t.isLeader;
                        });
                    },
                    awaitLeadership: function() {
                        var e1;
                        return this._aLP || (this._aLP = (e1 = this).isLeader ? p : new Promise(function(t) {
                            var n = !1;
                            function r() {
                                n || (n = !0, e1.broadcastChannel.removeEventListener("internal", o), t(!0));
                            }
                            e1.applyOnce().then(function() {
                                e1.isLeader && r();
                            }), function t() {
                                return h(e1._options.fallbackInterval).then(function() {
                                    if (!e1.isDead && !n) return e1.isLeader ? void r() : e1.applyOnce(!0).then(function() {
                                        e1.isLeader ? r() : t();
                                    });
                                });
                            }();
                            var o = function(t) {
                                "leader" === t.context && "death" === t.action && (e1.hasLeader = !1, e1.applyOnce().then(function() {
                                    e1.isLeader && r();
                                }));
                            };
                            e1.broadcastChannel.addEventListener("internal", o), e1._lstns.push(o);
                        })), this._aLP;
                    },
                    set onduplicate (e){
                        this._dpL = e;
                    },
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this.hasLeader = !1, this.isLeader = !1), this.isDead = !0, ee(this, "death");
                    }
                };
                var ne = n(415), re = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
                    }
                    var t, n, r;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeaderDuplicate",
                            value: function() {}
                        },
                        {
                            key: "onLeader",
                            value: (r = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                                        case 2:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.isLeader);
                            }
                        },
                        {
                            key: "hasLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.hasLeader);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stop();
                                        case 2:
                                            this.canStart() && (t = this.options.electionChannelName, this.channel = new L(t), this.elector = te(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!this.elector) {
                                                e1.next = 5;
                                                break;
                                            }
                                            return e1.next = 4, this.elector.die();
                                        case 4:
                                            this.elector = void 0;
                                        case 5:
                                            if (!this.channel) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.channel.postInternal = function() {
                                                return Promise.resolve();
                                            }, e1.next = 9, this.channel.close();
                                        case 9:
                                            this.channel = void 0;
                                        case 10:
                                            this.started = !1;
                                        case 11:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, ne.isBrowser)();
                            }
                        }
                    ]), e1;
                }(), oe = n(9123), ie = n(6488), ae = n(7088), ue = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "shouldThrottleRenew",
                            value: function() {
                                var e1 = !1;
                                if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                                    var t = this.renewTimeQueue.shift();
                                    e1 = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                                }
                                return e1;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !!this.options.syncStorage && (0, ne.isBrowser)();
                            }
                        },
                        {
                            key: "processExpiredTokens",
                            value: function() {
                                var e1 = this, t = this.tokenManager.getStorage().getStorage();
                                Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    !(0, ie.z9)(r) && e1.tokenManager.hasExpired(r) && e1.onTokenExpiredHandler(n);
                                });
                            }
                        },
                        {
                            key: "onTokenExpiredHandler",
                            value: function(e1) {
                                if (this.options.autoRenew) {
                                    if (this.shouldThrottleRenew()) {
                                        var t = new oe.Z("Too many token renew requests");
                                        this.tokenManager.emitError(t);
                                    } else this.tokenManager.renew(e1).catch(function() {});
                                } else this.options.autoRemove && this.tokenManager.remove(e1);
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.autoRenew || !!this.options.autoRemove;
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.canStart()) {
                                                e1.next = 6;
                                                break;
                                            }
                                            return e1.next = 3, this.stop();
                                        case 3:
                                            this.tokenManager.on(ae.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0;
                                        case 6:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.started && (this.tokenManager.off(ae.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ce = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.syncStorage && (0, ne.isBrowser)();
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (this.canStart()) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.stop();
                                        case 4:
                                            t = this.options.syncChannelName, e1.prev = 5, this.channel = new L(t), e1.next = 12;
                                            break;
                                        case 9:
                                            throw e1.prev = 9, e1.t0 = e1.catch(5), new oe.Z("SyncStorageService is not supported in current browser.");
                                        case 12:
                                            this.tokenManager.on(ae.O3, this.onTokenAddedHandler), this.tokenManager.on(ae.FT, this.onTokenRemovedHandler), this.tokenManager.on(ae.E, this.onTokenRenewedHandler), this.tokenManager.on(ae.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        5,
                                        9
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.tokenManager.off(ae.O3, this.onTokenAddedHandler), this.tokenManager.off(ae.FT, this.onTokenRemovedHandler), this.tokenManager.off(ae.E, this.onTokenRenewedHandler), this.tokenManager.off(ae.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e1.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                                        case 8:
                                            this.channel = void 0, this.started = !1;
                                        case 10:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "onTokenAddedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: ae.O3,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRemovedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: ae.FT,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRenewedHandler",
                            value: function(e1, t, n) {
                                var r;
                                this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                                    type: ae.E,
                                    key: e1,
                                    token: t,
                                    oldToken: n
                                }));
                            }
                        },
                        {
                            key: "onSetStorageHandler",
                            value: function(e1) {
                                var t;
                                null === (t = this.channel) || void 0 === t || t.postMessage({
                                    type: ae.zr,
                                    storage: e1
                                });
                            }
                        },
                        {
                            key: "onSyncMessageHandler",
                            value: function(e1) {
                                switch(this.enablePostMessage = !1, e1.type){
                                    case ae.zr:
                                        this.tokenManager.getStorage().setStorage(e1.storage);
                                        break;
                                    case ae.O3:
                                        this.tokenManager.emitAdded(e1.key, e1.token), this.tokenManager.setExpireEventTimeout(e1.key, e1.token);
                                        break;
                                    case ae.FT:
                                        this.tokenManager.clearExpireEventTimeout(e1.key), this.tokenManager.emitRemoved(e1.key, e1.token);
                                        break;
                                    case ae.E:
                                        this.tokenManager.emitRenewed(e1.key, e1.token, e1.oldToken);
                                }
                                this.enablePostMessage = !0;
                            }
                        }
                    ]), e1;
                }(), se = n(3193);
                function fe(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function le(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? fe(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : fe(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function pe(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return he(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? he(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function he(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var de = "autoRenew", ve = "syncStorage", ye = "leaderElection", ge = function() {
                    function e1(t) {
                        var n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                        var o = t.tokenManager.getOptions(), i = o.autoRenew, u = o.autoRemove, s = o.syncStorage;
                        r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e1.defaultOptions, {
                            autoRenew: i,
                            autoRemove: u,
                            syncStorage: s
                        }, {
                            electionChannelName: "".concat(t.options.clientId, "-election"),
                            syncChannelName: "".concat(t.options.clientId, "-sync")
                        }, (0, se.YY)(r)), this.started = !1, this.services = new Map, e1.knownServices.forEach(function(e1) {
                            var t = n.createService(e1);
                            t && n.services.set(e1, t);
                        });
                    }
                    var t, n, s, l, p;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeader",
                            value: (p = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 3;
                                                break;
                                            }
                                            return e1.next = 3, this.startServices();
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return p.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return null === (e1 = this.getService(ye)) || void 0 === e1 ? void 0 : e1.isLeader();
                            }
                        },
                        {
                            key: "isLeaderRequired",
                            value: function() {
                                return (0, o.Z)(this.services.values()).some(function(e1) {
                                    return e1.canStart() && e1.requiresLeadership();
                                });
                            }
                        },
                        {
                            key: "start",
                            value: (l = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.startServices();
                                        case 4:
                                            this.started = !0;
                                        case 5:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return l.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (s = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stopServices();
                                        case 2:
                                            this.started = !1;
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "getService",
                            value: function(e1) {
                                return this.services.get(e1);
                            }
                        },
                        {
                            key: "startServices",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t, n, o, i, a;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = pe(this.services.entries()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 10;
                                                break;
                                            }
                                            if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                                                e1.next = 8;
                                                break;
                                            }
                                            return e1.next = 8, a.start();
                                        case 8:
                                            e1.next = 3;
                                            break;
                                        case 10:
                                            e1.next = 15;
                                            break;
                                        case 12:
                                            e1.prev = 12, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 15:
                                            return e1.prev = 15, t.f(), e1.finish(15);
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stopServices",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n, r;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = pe(this.services.values()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 9;
                                                break;
                                            }
                                            return r = n.value, e1.next = 7, r.stop();
                                        case 7:
                                            e1.next = 3;
                                            break;
                                        case 9:
                                            e1.next = 14;
                                            break;
                                        case 11:
                                            e1.prev = 11, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 14:
                                            return e1.prev = 14, t.f(), e1.finish(14);
                                        case 17:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStartService",
                            value: function(e1, t) {
                                var n = t.canStart() && !t.isStarted();
                                return e1 === ye ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                            }
                        },
                        {
                            key: "createService",
                            value: function(e1) {
                                var t, n = this.sdk.tokenManager;
                                switch(e1){
                                    case ye:
                                        t = new re(le(le({}, this.options), {}, {
                                            onLeader: this.onLeader
                                        }));
                                        break;
                                    case de:
                                        t = new ue(n, le({}, this.options));
                                        break;
                                    case ve:
                                        t = new ce(n, le({}, this.options));
                                        break;
                                    default:
                                        throw new Error("Unknown service ".concat(e1));
                                }
                                return t;
                            }
                        }
                    ]), e1;
                }();
                (0, c.Z)(ge, "knownServices", [
                    de,
                    ve,
                    ye
                ]), (0, c.Z)(ge, "defaultOptions", {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0
                });
            },
            6599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return r.W;
                    }
                });
                var r = n(2397);
            },
            1578: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return s;
                    }
                });
                var r = n(9893), o = n(265), i = n(279), a = n(2724), u = n(8386), c = n(3980);
                function s(e1, t, n) {
                    var s = (0, r.a)(t), f = (0, o.H)(s, e1), l = (0, i.A)(f), p = (0, c.Z)(l), h = (0, a.J)(p, n);
                    return (0, u.i)(h);
                }
            },
            3961: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthStateManager: function() {
                        return r.E;
                    },
                    INITIAL_AUTH_STATE: function() {
                        return r.a;
                    },
                    ServiceManager: function() {
                        return l.W;
                    },
                    createCoreOptionsConstructor: function() {
                        return o.n;
                    },
                    createCoreStorageManager: function() {
                        return u.a;
                    },
                    createOktaAuthCore: function() {
                        return i.K;
                    },
                    mixinCore: function() {
                        return a.i;
                    }
                });
                var r = n(1018), o = n(9133), i = n(1578), a = n(8386), u = n(2647), c = n(8553), s = {};
                for(var f in c)[
                    "default",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "createCoreOptionsConstructor",
                    "createOktaAuthCore",
                    "mixinCore",
                    "createCoreStorageManager"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(6599);
            },
            8386: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(5372), d = n(1018), v = n(2397);
                function y(e1) {
                    return function(e1) {
                        (0, u.Z)(w, e1);
                        var t, n, l, y, g, m, b = (g = w, m = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(g);
                            if (m) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function w() {
                            var e1;
                            (0, o.Z)(this, w);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = b.call.apply(b, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e1), "serviceManager", void 0), e1.authStateManager = new d.E((0, a.Z)(e1)), e1.serviceManager = new v.W((0, a.Z)(e1), e1.options.services), e1;
                        }
                        return (0, i.Z)(w, [
                            {
                                key: "start",
                                value: (y = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.serviceManager.start();
                                            case 2:
                                                if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 6, this.authStateManager.updateAuthState();
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return y.apply(this, arguments);
                                })
                            },
                            {
                                key: "stop",
                                value: (l = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return this.tokenManager.stop(), e1.next = 3, this.serviceManager.stop();
                                            case 3:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return l.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleRedirect",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.handleLoginRedirect(void 0, t);
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleLoginRedirect",
                                value: (t = (0, r.Z)(p().mark(function e1(t, n) {
                                    var r, o, i;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (r = this.options.state, !t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e1.next = 25;
                                                break;
                                            case 6:
                                                if (!this.isLoginRedirect()) {
                                                    e1.next = 24;
                                                    break;
                                                }
                                                return e1.prev = 7, e1.next = 10, (0, h.Tp)(this, {});
                                            case 10:
                                                return o = e1.sent, r = o.state, n = n || this.getOriginalUri(r), e1.next = 15, this.storeTokensFromRedirect();
                                            case 15:
                                                e1.next = 22;
                                                break;
                                            case 17:
                                                return e1.prev = 17, e1.t0 = e1.catch(7), e1.next = 21, this.authStateManager.updateAuthState();
                                            case 21:
                                                throw e1.t0;
                                            case 22:
                                                e1.next = 25;
                                                break;
                                            case 24:
                                                return e1.abrupt("return");
                                            case 25:
                                                return e1.next = 27, this.authStateManager.updateAuthState();
                                            case 27:
                                                if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                return e1.next = 32, i(this, n);
                                            case 32:
                                                e1.next = 35;
                                                break;
                                            case 34:
                                                n && window.location.replace(n);
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            7,
                                            17
                                        ]
                                    ]);
                                })), function(e1, n) {
                                    return t.apply(this, arguments);
                                })
                            }
                        ]), w;
                    }(e1);
                }
            },
            9133: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9453);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e1.services, t.transformAuthState = e1.transformAuthState, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.m)());
                }
            },
            2647: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var r = n(2333);
                function o() {
                    return (0, r.a)();
                }
            },
            5675: function() {},
            8553: function(e1, t, n) {
                "use strict";
                n.r(t);
                var r = n(5675), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            7987: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Df: function() {
                        return u;
                    },
                    EL: function() {
                        return f;
                    },
                    NL: function() {
                        return i;
                    },
                    Wy: function() {
                        return c;
                    },
                    aR: function() {
                        return a;
                    },
                    dX: function() {
                        return l;
                    },
                    k8: function() {
                        return s;
                    },
                    kQ: function() {
                        return p;
                    }
                });
                var r = n(9123), o = n(7594);
                function i(e1) {
                    return a((0, o.r3)(e1));
                }
                function a(e1) {
                    return e1.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                }
                function u(e1) {
                    return e1.replace(/-/g, "+").replace(/_/g, "/");
                }
                function c(e1) {
                    var t = u(e1);
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new r.Z("Not a valid Base64Url");
                    }
                    var n = (0, o.ty)(t);
                    try {
                        return decodeURIComponent(escape(n));
                    } catch (e1) {
                        return n;
                    }
                }
                function s(e1) {
                    for(var t = new Uint8Array(e1.length), n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
                    return t;
                }
                function f(e1) {
                    return (0, o.ty)(u(e1));
                }
                function l(e1) {
                    return Uint8Array.from(f(e1), function(e1) {
                        return e1.charCodeAt(0);
                    });
                }
                function p(e1) {
                    return (0, o.r3)(new Uint8Array(e1).reduce(function(e1, t) {
                        return e1 + String.fromCharCode(t);
                    }, ""));
                }
            },
            7594: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return i;
                    },
                    r3: function() {
                        return o;
                    },
                    ty: function() {
                        return r;
                    }
                });
                var r = function(e1) {
                    return atob(e1);
                }, o = function(e1) {
                    return btoa(e1);
                }, i = "undefined" == typeof crypto ? null : crypto;
            },
            9718: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    atob: function() {
                        return s.ty;
                    },
                    base64ToBase64Url: function() {
                        return r.aR;
                    },
                    base64UrlDecode: function() {
                        return r.EL;
                    },
                    base64UrlToBase64: function() {
                        return r.Df;
                    },
                    base64UrlToBuffer: function() {
                        return r.dX;
                    },
                    base64UrlToString: function() {
                        return r.Wy;
                    },
                    btoa: function() {
                        return s.r3;
                    },
                    bufferToBase64Url: function() {
                        return r.kQ;
                    },
                    getOidcHash: function() {
                        return o.X;
                    },
                    stringToBase64Url: function() {
                        return r.NL;
                    },
                    stringToBuffer: function() {
                        return r.k8;
                    },
                    verifyToken: function() {
                        return c.W;
                    },
                    webcrypto: function() {
                        return s.KP;
                    }
                });
                var r = n(7987), o = n(5698), i = n(6332), a = {};
                for(var u in i)[
                    "default",
                    "base64ToBase64Url",
                    "base64UrlDecode",
                    "base64UrlToBase64",
                    "base64UrlToBuffer",
                    "base64UrlToString",
                    "bufferToBase64Url",
                    "stringToBase64Url",
                    "stringToBuffer",
                    "getOidcHash"
                ].indexOf(u) < 0 && (a[u] = (function(e1) {
                    return i[e1];
                }).bind(0, u));
                n.d(t, a);
                var c = n(3154), s = n(1);
            },
            5698: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return i;
                    }
                });
                var r = n(7987), o = n(7594);
                function i(e1) {
                    var t = (new TextEncoder).encode(e1);
                    return o.KP.subtle.digest("SHA-256", t).then(function(e1) {
                        var t = new Uint8Array(e1).slice(0, 16), n = String.fromCharCode.apply(null, t);
                        return (0, r.NL)(n);
                    });
                }
            },
            6332: function() {},
            3154: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(7987), i = n(7594);
                function a(e1, t) {
                    t = (0, r.d9)(t);
                    var n = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: {
                            name: "SHA-256"
                        }
                    };
                    return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, [
                        "verify"
                    ]).then(function(t) {
                        var r = e1.split("."), a = (0, o.k8)(r[0] + "." + r[1]), u = (0, o.EL)(r[2]), c = (0, o.k8)(u);
                        return i.KP.subtle.verify(n, t, c, a);
                    });
                }
            },
            1: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return r.KP;
                    },
                    r3: function() {
                        return r.r3;
                    },
                    ty: function() {
                        return r.ty;
                    }
                });
                var r = n(7594);
            },
            3983: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        (0, o.Z)(this, l);
                        var a = e1.errorSummary;
                        return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e1.errorSummary, r.errorCode = e1.errorCode, r.errorLink = e1.errorLink, r.errorId = e1.errorId, r.errorCauses = e1.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6573: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120);
                var c = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
                    }
                    return (0, r.Z)(s);
                }(n(6245).Z);
            },
            9123: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e1, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6245: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return h;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(9611);
                function f() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }
                function l(e1, t, n) {
                    return l = f() ? Reflect.construct.bind() : function(e1, t, n) {
                        var r = [
                            null
                        ];
                        r.push.apply(r, t);
                        var o = new (Function.bind.apply(e1, r));
                        return n && (0, s.Z)(o, n.prototype), o;
                    }, l.apply(null, arguments);
                }
                function p(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return p = function(e1) {
                        if (null === e1 || (n = e1, -1 === Function.toString.call(n).indexOf("[native code]"))) return e1;
                        var n;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, r);
                        }
                        function r() {
                            return l(e1, arguments, (0, c.Z)(this).constructor);
                        }
                        return r.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), (0, s.Z)(r, e1);
                    }, p(e1);
                }
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t;
                        return (0, o.Z)(this, f), t = s.call(this, e1), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
                    }
                    return (0, r.Z)(f);
                }(p(Error));
            },
            2886: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, t), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "error", void 0), (0, s.Z)((0, i.Z)(n), "error_description", void 0), n.name = "OAuthError", n.errorCode = e1, n.errorSummary = t, n.error = e1, n.error_description = t, n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            5728: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthApiError: function() {
                        return r.Z;
                    },
                    AuthPollStopError: function() {
                        return o.Z;
                    },
                    AuthSdkError: function() {
                        return i.Z;
                    },
                    OAuthError: function() {
                        return a.Z;
                    },
                    isAuthApiError: function() {
                        return f;
                    },
                    isOAuthError: function() {
                        return l;
                    }
                });
                var r = n(3983), o = n(6573), i = n(9123), a = n(2886), u = n(1243), c = {};
                for(var s in u)[
                    "default",
                    "isAuthApiError",
                    "isOAuthError",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError"
                ].indexOf(s) < 0 && (c[s] = (function(e1) {
                    return u[e1];
                }).bind(0, s));
                function f(e1) {
                    return e1 instanceof r.Z;
                }
                function l(e1) {
                    return e1 instanceof a.Z;
                }
                n.d(t, c);
            },
            1243: function() {},
            6736: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return i.ACCESS_TOKEN_STORAGE_KEY;
                    },
                    BaseStorageManager: function() {
                        return h.W8;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return i.CACHE_STORAGE_NAME;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return i.DEFAULT_CACHE_DURATION;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return i.DEFAULT_CODE_CHALLENGE_METHOD;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i.DEFAULT_MAX_CLOCK_SKEW;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return i.DEFAULT_POLLING_DELAY;
                    },
                    IDX_API_VERSION: function() {
                        return i.IDX_API_VERSION;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return i.IDX_RESPONSE_STORAGE_NAME;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return i.ID_TOKEN_STORAGE_KEY;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return i.MAX_VERIFIER_LENGTH;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return i.MIN_VERIFIER_LENGTH;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return i.ORIGINAL_URI_STORAGE_NAME;
                    },
                    OktaUserAgent: function() {
                        return f.ed;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return i.PKCE_STORAGE_NAME;
                    },
                    PromiseQueue: function() {
                        return d.bo;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return i.REFERRER_PATH_STORAGE_KEY;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return i.REFRESH_TOKEN_STORAGE_KEY;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return i.SHARED_TRANSACTION_STORAGE_NAME;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return i.STATE_TOKEN_KEY_NAME;
                    },
                    SavedObject: function() {
                        return h._e;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return i.TOKEN_STORAGE_NAME;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return i.TRANSACTION_STORAGE_NAME;
                    },
                    bind: function() {
                        return d.ak;
                    },
                    clone: function() {
                        return d.d9;
                    },
                    closeSession: function() {
                        return p.RJ;
                    },
                    createBaseOptionsConstructor: function() {
                        return o.X;
                    },
                    createHttpOptionsConstructor: function() {
                        return f.ZM;
                    },
                    createOktaAuthBase: function() {
                        return o.a;
                    },
                    createSessionApi: function() {
                        return p.MG;
                    },
                    createStorageOptionsConstructor: function() {
                        return h.Tp;
                    },
                    crypto: function() {
                        return r;
                    },
                    delay: function() {
                        return d.gw;
                    },
                    deprecate: function() {
                        return d.Rn;
                    },
                    deprecateWrap: function() {
                        return d.VA;
                    },
                    extend: function() {
                        return d.l7;
                    },
                    find: function() {
                        return d.sE;
                    },
                    genRandomString: function() {
                        return d.uh;
                    },
                    get: function() {
                        return f.U2;
                    },
                    getConsole: function() {
                        return d.dr;
                    },
                    getLink: function() {
                        return d.Rg;
                    },
                    getNativeConsole: function() {
                        return d.sW;
                    },
                    getSession: function() {
                        return p.Gg;
                    },
                    httpRequest: function() {
                        return f.c3;
                    },
                    isAbsoluteUrl: function() {
                        return d.sD;
                    },
                    isFunction: function() {
                        return d.mf;
                    },
                    isNumber: function() {
                        return d.hj;
                    },
                    isObject: function() {
                        return d.Kn;
                    },
                    isPromise: function() {
                        return d.tI;
                    },
                    isString: function() {
                        return d.HD;
                    },
                    isoToUTCString: function() {
                        return d.ng;
                    },
                    logServerSideMemoryStorageWarning: function() {
                        return h.Vp;
                    },
                    mixinHttp: function() {
                        return f.Am;
                    },
                    mixinSession: function() {
                        return p.Zg;
                    },
                    mixinStorage: function() {
                        return h.Ho;
                    },
                    omit: function() {
                        return d.CE;
                    },
                    post: function() {
                        return f.v_;
                    },
                    refreshSession: function() {
                        return p.dx;
                    },
                    removeNils: function() {
                        return d.YY;
                    },
                    removeTrailingSlash: function() {
                        return d.Qj;
                    },
                    sessionExists: function() {
                        return p.sH;
                    },
                    setCookieAndRedirect: function() {
                        return p.OT;
                    },
                    setRequestHeader: function() {
                        return f.rn;
                    },
                    split2: function() {
                        return d.YQ;
                    },
                    toAbsoluteUrl: function() {
                        return d.BY;
                    },
                    toQueryString: function() {
                        return d.UK;
                    },
                    toRelativeUrl: function() {
                        return d.QN;
                    },
                    warn: function() {
                        return d.ZK;
                    }
                });
                var r = n(9718), o = n(3306), i = n(1971), a = n(3961), u = {};
                for(var c in a)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return a[e1];
                }).bind(0, c));
                n.d(t, u);
                var s = n(5728);
                for(var c in u = {}, s)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return s[e1];
                }).bind(0, c));
                n.d(t, u);
                var f = n(4777), l = n(9443);
                for(var c in u = {}, l)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "isAuthApiError",
                    "isOAuthError",
                    "OktaUserAgent",
                    "createHttpOptionsConstructor",
                    "get",
                    "httpRequest",
                    "mixinHttp",
                    "post",
                    "setRequestHeader"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return l[e1];
                }).bind(0, c));
                n.d(t, u);
                var p = n(8041), h = n(9927), d = n(305);
            },
            415: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    getUserAgent: function() {
                        return u;
                    },
                    hasTextEncoder: function() {
                        return l;
                    },
                    isBrowser: function() {
                        return i;
                    },
                    isFingerprintSupported: function() {
                        return c;
                    },
                    isHTTPS: function() {
                        return h;
                    },
                    isIE11OrLess: function() {
                        return a;
                    },
                    isLocalhost: function() {
                        return d;
                    },
                    isPKCESupported: function() {
                        return p;
                    },
                    isPopupPostMessageSupported: function() {
                        return s;
                    },
                    isTokenVerifySupported: function() {
                        return f;
                    }
                });
                var r = n(7594), o = /windows phone|iemobile|wpdesktop/i;
                function i() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                }
                function a() {
                    if (!i()) return !1;
                    var e1 = document.documentMode;
                    return !!e1 && e1 <= 11;
                }
                function u() {
                    return navigator.userAgent;
                }
                function c() {
                    var e1 = u();
                    return e1 && !o.test(e1);
                }
                function s() {
                    if (!i()) return !1;
                    var e1 = document.documentMode, t = e1 && e1 < 10;
                    return void 0 !== window.postMessage && !t;
                }
                function f() {
                    return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
                }
                function l() {
                    return "undefined" != typeof TextEncoder;
                }
                function p() {
                    return f() && l();
                }
                function h() {
                    return !!i() && "https:" === window.location.protocol;
                }
                function d() {
                    return i() && "localhost" === window.location.hostname;
                }
            },
            287: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    e: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(415), u = function() {
                    function e1() {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "environments", void 0), this.environments = [
                            "okta-auth-js/".concat("7.2.0")
                        ];
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "addEnvironment",
                            value: function(e1) {
                                this.environments.push(e1);
                            }
                        },
                        {
                            key: "getHttpHeader",
                            value: function() {
                                return this.maybeAddNodeEnvironment(), {
                                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                                };
                            }
                        },
                        {
                            key: "getVersion",
                            value: function() {
                                return "7.2.0";
                            }
                        },
                        {
                            key: "maybeAddNodeEnvironment",
                            value: function() {
                                if (!(0, a.isBrowser)() && $hPtJY && $hPtJY.versions) {
                                    var e1 = $hPtJY.versions.node;
                                    this.environments.push("nodejs/".concat(e1));
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            2281: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    e1.options.headers = e1.options.headers || {}, e1.options.headers[t] = n;
                }
                n.d(t, {
                    r: function() {
                        return r;
                    }
                });
            },
            4777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Am: function() {
                        return a.A;
                    },
                    U2: function() {
                        return i.U2;
                    },
                    ZM: function() {
                        return u.Z;
                    },
                    c3: function() {
                        return i.c3;
                    },
                    ed: function() {
                        return o.e;
                    },
                    rn: function() {
                        return r.r;
                    },
                    v_: function() {
                        return i.v_;
                    }
                });
                var r = n(2281), o = n(287), i = n(5385), a = n(279), u = n(8817);
            },
            279: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(287), l = n(2281), p = n(6718), h = n(5385);
                function d(e1) {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, d = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v() {
                            var e1;
                            (0, r.Z)(this, v);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = d.call.apply(d, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e1), "http", void 0), e1._oktaUserAgent = new f.e, e1.http = {
                                setRequestHeader: l.r.bind(null, (0, i.Z)(e1))
                            }, e1;
                        }
                        return (0, o.Z)(v, [
                            {
                                key: "setHeaders",
                                value: function(e1) {
                                    this.options.headers = Object.assign({}, this.options.headers, e1);
                                }
                            },
                            {
                                key: "getIssuerOrigin",
                                value: function() {
                                    return this.options.issuer.split("/oauth2/")[0];
                                }
                            },
                            {
                                key: "webfinger",
                                value: function(e1) {
                                    var t = "/.well-known/webfinger" + (0, p.UK)(e1);
                                    return (0, h.U2)(this, t, {
                                        headers: {
                                            Accept: "application/jrd+json"
                                        }
                                    });
                                }
                            }
                        ]), v;
                    }(e1);
                }
            },
            8817: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(3849), l = n(885), p = n(1002), h = n(4098), d = n.n(h);
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var y = /application\/\w*\+?json/, g = function(e1, t, r) {
                    var o = r.data, i = r.headers || {}, a = i["Content-Type"] || i["content-type"] || "";
                    o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function(e1) {
                        var t = (0, l.Z)(e1, 2), n = t[0], r = t[1];
                        return "".concat(n, "=").concat(encodeURIComponent(r));
                    }).join("&")));
                    var u = (n.g.fetch || d())(t, {
                        method: e1,
                        headers: r.headers,
                        body: o,
                        credentials: r.withCredentials ? "include" : "omit"
                    });
                    return u.finally || (u = Promise.resolve(u)), u.then(function(e1) {
                        var t = !e1.ok, n = e1.status;
                        return (function(e1) {
                            return e1.headers.get("Content-Type") && e1.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e1.json().catch(function(e1) {
                                return {
                                    error: e1,
                                    errorSummary: "Could not parse server response"
                                };
                            }) : e1.text();
                        })(e1).then(function(t) {
                            return function(e1, t, n) {
                                var r, o = "object" === (0, p.Z)(t), i = {}, a = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return v(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(n.headers.entries());
                                try {
                                    for(a.s(); !(r = a.n()).done;){
                                        var u = r.value;
                                        i[u[0]] = u[1];
                                    }
                                } catch (e1) {
                                    a.e(e1);
                                } finally{
                                    a.f();
                                }
                                var c = {
                                    responseText: o ? JSON.stringify(t) : t,
                                    status: e1,
                                    headers: i
                                };
                                return o && (c.responseType = "json", c.responseJSON = t), c;
                            }(n, t, e1);
                        }).then(function(e1) {
                            var n;
                            if (t || null !== (n = e1.responseJSON) && void 0 !== n && n.error) throw e1;
                            return e1;
                        });
                    });
                };
                function m() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), t.issuer = e1.issuer, t.transformErrorXHR = e1.transformErrorXHR, t.headers = e1.headers, t.httpRequestClient = e1.httpRequestClient || g, t.httpRequestInterceptors = e1.httpRequestInterceptors, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.T)());
                }
            },
            5385: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U2: function() {
                        return y;
                    },
                    c3: function() {
                        return v;
                    },
                    v_: function() {
                        return g;
                    }
                });
                var r = n(1002), o = n(4942), i = n(4771), a = n(3193), u = n(6718), c = n(1971), s = n(9123), f = n(2886), l = n(3983);
                function p(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function v(e1, t) {
                    if (t = t || {}, e1.options.httpRequestInterceptors) {
                        var n, o = function(e1, t) {
                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                            if (!n) {
                                if (Array.isArray(e1) || (n = function(e1, t) {
                                    if (e1) {
                                        if ("string" == typeof e1) return p(e1, t);
                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e1, t) : void 0;
                                    }
                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                    n && (e1 = n);
                                    var r = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return r >= e1.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e1[r++]
                                            };
                                        },
                                        e: function(e1) {
                                            throw e1;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(e1);
                                },
                                n: function() {
                                    var e1 = n.next();
                                    return a = e1.done, e1;
                                },
                                e: function(e1) {
                                    u = !0, i = e1;
                                },
                                f: function() {
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw i;
                                    }
                                }
                            };
                        }(e1.options.httpRequestInterceptors);
                        try {
                            for(o.s(); !(n = o.n()).done;)(0, n.value)(t);
                        } catch (T) {
                            o.e(T);
                        } finally{
                            o.f();
                        }
                    }
                    var u = t.url, h = t.method, v = t.args, y = t.saveAuthnState, g = t.accessToken, m = !0 === t.withCredentials, b = e1.options.storageUtil.storage, w = e1.storageManager.getHttpCache(e1.options.cookies);
                    if (t.cacheResponse) {
                        var k = w.getStorage()[u];
                        if (k && Date.now() / 1e3 < k.expiresAt) return Promise.resolve(k.response);
                    }
                    var O = d({
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }, e1._oktaUserAgent.getHttpHeader());
                    Object.assign(O, e1.options.headers, t.headers), O = (0, a.YY)(O), g && (0, i.HD)(g) && (O.Authorization = "Bearer " + g);
                    var T, Z, E = {
                        headers: O,
                        data: v || void 0,
                        withCredentials: m
                    };
                    return e1.options.httpRequestClient(h, u, E).then(function(n) {
                        return (Z = n.responseText) && (0, i.HD)(Z) && (Z = JSON.parse(Z)) && "object" === (0, r.Z)(Z) && !Z.headers && (Array.isArray(Z) ? Z.forEach(function(e1) {
                            e1.headers = n.headers;
                        }) : Z.headers = n.headers), y && (Z.stateToken || b.delete(c.STATE_TOKEN_KEY_NAME)), Z && Z.stateToken && Z.expiresAt && b.set(c.STATE_TOKEN_KEY_NAME, Z.stateToken, Z.expiresAt, e1.options.cookies), Z && t.cacheResponse && w.updateStorage(u, {
                            expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                            response: Z
                        }), Z;
                    }).catch(function(t) {
                        throw "E0000011" === (T = function(e1, t) {
                            var n, r, o, u, c = {};
                            if (t.responseText && (0, i.HD)(t.responseText)) try {
                                c = JSON.parse(t.responseText);
                            } catch (e1) {
                                c = {
                                    errorSummary: "Unknown error"
                                };
                            }
                            if (t.status >= 500 && (c.errorSummary = "Unknown error"), e1.options.transformErrorXHR && (t = e1.options.transformErrorXHR((0, a.d9)(t))), u = c.error && c.error_description ? new f.Z(c.error, c.error_description) : new l.Z(c, t), 403 === (null === (n = t) || void 0 === n ? void 0 : n.status) && null !== (r = t) && void 0 !== r && null !== (o = r.headers) && void 0 !== o && o["www-authenticate"]) {
                                var p, h, v = function(e1) {
                                    if (!e1) throw new s.Z("Missing header string");
                                    return e1.split(",").map(function(e1) {
                                        return e1.trim();
                                    }).map(function(e1) {
                                        return e1.split("=");
                                    }).reduce(function(e1, t) {
                                        return e1[t[0]] = t[1].replace(/^"(.*)"$/, "$1"), e1;
                                    }, {});
                                }(null === (p = t) || void 0 === p || null === (h = p.headers) || void 0 === h ? void 0 : h["www-authenticate"]), y = v.error, g = v.error_description, m = v.max_age, b = v.acr_values;
                                "insufficient_authentication_context" === y && (u = new l.Z({
                                    errorSummary: y,
                                    errorCauses: [
                                        {
                                            errorSummary: g
                                        }
                                    ]
                                }, t, d({
                                    max_age: +m
                                }, b && {
                                    acr_values: b
                                })));
                            }
                            return u;
                        }(e1, t)).errorCode && b.delete(c.STATE_TOKEN_KEY_NAME), T;
                    });
                }
                function y(e1, t, n) {
                    var r = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "GET"
                    };
                    return Object.assign(r, n), v(e1, r);
                }
                function g(e1, t, n, r) {
                    var o = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "POST",
                        args: n,
                        saveAuthnState: !0
                    };
                    return Object.assign(o, r), v(e1, o);
                }
            },
            3334: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    v: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(1646), f = n(480);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, s = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            return (0, r.Z)(this, l), s.call(this, e1);
                        }
                        return (0, o.Z)(l, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e1), !1 !== e1.clearIdxResponse && this.clearIdxResponse();
                                }
                            },
                            {
                                key: "saveIdxResponse",
                                value: function(e1) {
                                    if (this.saveLastResponse) {
                                        var t = this.storageManager.getIdxResponseStorage();
                                        t && t.setStorage(e1);
                                    }
                                }
                            },
                            {
                                key: "loadIdxResponse",
                                value: function(e1) {
                                    if (!this.saveLastResponse) return null;
                                    var t = this.storageManager.getIdxResponseStorage();
                                    if (!t) return null;
                                    var n = t.getStorage();
                                    if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                                    if (e1) {
                                        var r = e1.interactionHandle;
                                        if (r && n.interactionHandle !== r) return null;
                                    }
                                    return n;
                                }
                            },
                            {
                                key: "clearIdxResponse",
                                value: function() {
                                    if (this.saveLastResponse) {
                                        var e1 = this.storageManager.getIdxResponseStorage();
                                        null == e1 || e1.clearStorage();
                                    }
                                }
                            }
                        ]), l;
                    }((0, s.P)());
                }
            },
            1286: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(7595), c = n(5832);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e1.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                                        flow: "authenticate"
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7644: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = (0, r.Z)(function e1(t) {
                    (0, o.Z)(this, e1), (0, i.Z)(this, "meta", void 0), this.meta = t;
                });
            },
            9582: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5671), i = n(3144), a = n(136), u = n(2963), c = n(1120);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, a.Z)(s, e1);
                    var t, n, r = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), r.apply(this, arguments);
                    }
                    return (0, i.Z)(s, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.password || e1.passcode);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.password, r = e1.passcode;
                                if (t || n || r) return t || {
                                    passcode: r || n
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return f(f({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "password",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), s;
                }(n(7644)._);
            },
            9344: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    LL: function() {
                        return i;
                    },
                    PN: function() {
                        return a;
                    },
                    h_: function() {
                        return u;
                    }
                });
                var r = n(7595);
                function o(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function i(e1) {
                    var t;
                    if ((0, r.H)(e1)) t = e1;
                    else {
                        if ("string" != typeof e1) throw new Error("Invalid format for authenticator");
                        t = {
                            key: e1
                        };
                    }
                    return t;
                }
                function a(e1, t) {
                    return !!(e1 && t && (e1.id && t.id ? e1.id === t.id : e1.key && t.key && e1.key === t.key));
                }
                function u(e1, t) {
                    var n, r, i = function(e1, t) {
                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e1) || (n = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return o(e1, t);
                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e1, t) : void 0;
                                }
                            }(e1)) || t && e1 && "number" == typeof e1.length) {
                                n && (e1 = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[r++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, c = !1;
                        return {
                            s: function() {
                                n = n.call(e1);
                            },
                            n: function() {
                                var e1 = n.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                c = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == n.return || n.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(e1);
                    try {
                        var a = function() {
                            var e1 = r.value;
                            if (n = t.find(function(t) {
                                return t.relatesTo.key === e1.key;
                            })) return "break";
                        };
                        for(i.s(); !(r = i.n()).done && "break" !== a(););
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return n;
                }
            },
            9192: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e1.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                                        actions: [
                                            "cancel"
                                        ]
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            7985: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    GA: function() {
                        return g;
                    },
                    Jn: function() {
                        return b;
                    },
                    gc: function() {
                        return y;
                    },
                    mo: function() {
                        return m;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(6245), d = n(1969);
                var v = function(e1) {
                    (0, u.Z)(l, e1);
                    var t, n, r = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e1, n.otp = t, n;
                    }
                    return (0, o.Z)(l);
                }(h.Z);
                function y(e1) {
                    return "EmailVerifyCallbackError" === e1.name;
                }
                function g(e1) {
                    return /(otp=)/i.test(e1) && /(state=)/i.test(e1);
                }
                function m(e1) {
                    return (0, d.v)(e1);
                }
                function b(e1, t) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return (w = (0, r.Z)(p().mark(function e1(t, n) {
                        var r, o, i;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!g(n)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                                        state: o
                                    })) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 5, t.idx.proceed({
                                        state: o,
                                        otp: i
                                    });
                                case 5:
                                    return e1.abrupt("return", e1.sent);
                                case 8:
                                    throw new v(o, i);
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    }
                });
                var r = n(1578), o = n(9284);
                function i(e1, t, n) {
                    var i = (0, r.K)(e1, t, n);
                    return (0, o.B)(i);
                }
            },
            9727: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    F: function() {
                        return b;
                    }
                });
                var r = n(8221), o = n(9912), i = n(1286), a = n(9192), u = n(7985), c = n(5021), s = n(6799), f = n(6131), l = n(2660), p = n(9310), h = n(2845), d = n(9214), v = n(8826), y = n(2473), g = n(2620), m = n(8277);
                function b(e1) {
                    var t = y.Y.bind(null, e1);
                    return {
                        interact: f.E.bind(null, e1),
                        introspect: l.L.bind(null, e1),
                        makeIdxResponse: s._T.bind(null, e1),
                        authenticate: i.Y.bind(null, e1),
                        register: v.z.bind(null, e1),
                        start: t,
                        startTransaction: t,
                        poll: p.$.bind(null, e1),
                        proceed: h.x.bind(null, e1),
                        cancel: a.a.bind(null, e1),
                        recoverPassword: d.M.bind(null, e1),
                        handleInteractionCodeRedirect: c.X.bind(null, e1),
                        isInteractionRequired: r.wc.bind(null, e1),
                        isInteractionRequiredError: o.Cf,
                        handleEmailVerifyCallback: u.Jn.bind(null, e1),
                        isEmailVerifyCallback: u.GA,
                        parseEmailVerifyCallback: u.mo,
                        isEmailVerifyCallbackError: u.gc,
                        getSavedTransactionMeta: g.uN.bind(null, e1),
                        createTransactionMeta: g.Xc.bind(null, e1),
                        getTransactionMeta: g.Co.bind(null, e1),
                        saveTransactionMeta: g.r0.bind(null, e1),
                        clearTransactionMeta: g.Jm.bind(null, e1),
                        isTransactionMetaValid: g.Wf,
                        setFlow: function(t) {
                            e1.options.flow = t;
                        },
                        getFlow: function() {
                            return e1.options.flow;
                        },
                        canProceed: h.C.bind(null, e1),
                        unlockAccount: m.l.bind(null, e1)
                    };
                }
            },
            7738: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return E;
                    }
                });
                var r = n(8628), o = n(7311), i = n(9865), a = n(2541), u = n(5278), c = n(3857), s = n(4560), f = n(1104), l = n(9024), p = n(2288), h = n(3403), d = n(3679), v = n(8490), y = n(8443), g = {
                    identify: r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "authenticator-enrollment-data": a.q,
                    "authenticator-verification-data": u.q,
                    "enroll-authenticator": c.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "reenroll-authenticator": l.j,
                    "enroll-poll": p.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": d.t,
                    "redirect-idp": v.O,
                    skip: y.h
                }, m = n(1019), b = {
                    identify: r.h,
                    "identify-recovery": r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "challenge-authenticator": s.J,
                    "authenticator-verification-data": u.q,
                    "authenticator-enrollment-data": a.q,
                    "reset-authenticator": m.G,
                    "reenroll-authenticator": l.j,
                    "enroll-poll": p.T
                }, w = n(4713), k = n(7522), O = {
                    "select-enroll-profile": w.j,
                    "enroll-profile": k.w,
                    "authenticator-enrollment-data": a.q,
                    "select-authenticator-enroll": i.j,
                    "enroll-poll": p.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": d.t,
                    "enroll-authenticator": c.q,
                    skip: y.h
                }, T = n(5272), Z = {
                    identify: r.h,
                    "select-authenticator-unlock-account": T.G,
                    "select-authenticator-authenticate": o.X,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "authenticator-verification-data": u.q
                };
                function E(e1) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default", o = !0;
                    switch(r){
                        case "register":
                        case "signup":
                        case "enrollProfile":
                            t = O, o = !1;
                            break;
                        case "recoverPassword":
                        case "resetPassword":
                            t = b, n = [
                                "currentAuthenticator-recover",
                                "currentAuthenticatorEnrollment-recover"
                            ], o = !1;
                            break;
                        case "unlockAccount":
                            t = Z, o = !1, n = [
                                "unlock-account"
                            ];
                            break;
                        default:
                            t = g;
                    }
                    return {
                        flow: r,
                        remediators: t,
                        actions: n,
                        withCredentials: o
                    };
                }
            },
            5021: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return c;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(2886);
                function c(e1, t) {
                    return s.apply(this, arguments);
                }
                function s() {
                    return (s = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, c, s, f, l, p, h, d, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.transactionManager.load()) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("No transaction data was found in storage");
                                case 3:
                                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(h = f.get("error"))) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new u.Z(h, f.get("error_description"));
                                case 10:
                                    if (l === c) {
                                        e1.next = 12;
                                        break;
                                    }
                                    throw new a.Z("State in redirect uri does not match with transaction state");
                                case 12:
                                    if (p) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new a.Z("Unable to parse interaction_code from the url");
                                case 14:
                                    return e1.next = 16, t.token.exchangeCodeForTokens({
                                        interactionCode: p,
                                        codeVerifier: o
                                    });
                                case 16:
                                    d = e1.sent, v = d.tokens, t.tokenManager.setTokens(v);
                                case 19:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6799: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _T: function() {
                        return W;
                    },
                    A0: function() {
                        return Y;
                    }
                });
                var r = n(1971), o = n(5861), i = n(2982), a = n(4687), u = n.n(a), c = n(885), s = n(4942), f = n(4925), l = n(1002), p = n(5385);
                function h(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return d(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function d(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var v = function(e1) {
                    return !1 !== e1.mutable;
                }, y = function(e1) {
                    var t = {}, n = [], r = {};
                    if (!e1.value) return n.push(e1), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = h(e1.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, c = o.value;
                            v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                        }
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                }, g = n(3983);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var w = function(e1, t) {
                    var n = t.actionDefinition, r = t.defaultParamsForAction, i = void 0 === r ? {} : r, a = t.immutableParamsForAction, c = void 0 === a ? {} : a, s = t.toPersist, f = void 0 === s ? {} : s, l = n.href;
                    return (0, o.Z)(u().mark(function t() {
                        var r, o, a, s, h, d, v, y, m, w = arguments;
                        return u().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = w.length > 0 && void 0 !== w[0] ? w[0] : {}, o = {
                                        "Content-Type": "application/json",
                                        Accept: n.accepts || "application/ion+json"
                                    }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, t.next = 6, (0, p.c3)(e1, {
                                        url: l,
                                        method: n.method,
                                        headers: o,
                                        args: a,
                                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                                    });
                                case 6:
                                    return h = t.sent, t.abrupt("return", e1.idx.makeIdxResponse(b({}, h), f, !0));
                                case 10:
                                    if (t.prev = 10, t.t0 = t.catch(3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                                        t.next = 14;
                                        break;
                                    }
                                    throw t.t0;
                                case 14:
                                    return d = t.t0.xhr, v = d.responseJSON || JSON.parse(d.responseText), y = d.headers["WWW-Authenticate"] || d.headers["www-authenticate"], m = e1.idx.makeIdxResponse(b({}, v), f, !1), 401 === d.status && 'Oktadevicejwt realm="Okta Device"' === y && (m.stepUp = !0), t.abrupt("return", m);
                                case 20:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                10
                            ]
                        ]);
                    }));
                }, k = function(e1, t, n) {
                    var r = w, o = function(e1) {
                        var t, n = [], r = {}, o = {}, i = h(e1 = Array.isArray(e1) ? e1 : [
                            e1
                        ]);
                        try {
                            for(i.s(); !(t = i.n()).done;){
                                var a = t.value, u = y(a), c = u.defaultParamsForAction, s = u.neededParamsForAction, f = u.immutableParamsForAction;
                                n.push(s), r[a.name] = c, o[a.name] = f;
                            }
                        } catch (e1) {
                            i.e(e1);
                        } finally{
                            i.f();
                        }
                        return {
                            defaultParams: r,
                            neededParams: n,
                            immutableParams: o
                        };
                    }(t), i = o.defaultParams, a = o.neededParams, u = o.immutableParams, c = r(e1, {
                        actionDefinition: t,
                        defaultParamsForAction: i[t.name],
                        immutableParamsForAction: u[t.name],
                        toPersist: n
                    });
                    return c.neededParams = a, c;
                };
                function O(e1) {
                    return O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, O(e1);
                }
                function T(e1) {
                    return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, T(e1);
                }
                function Z(e1, t) {
                    return Z = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, Z(e1, t);
                }
                function E() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }
                function S(e1, t, n) {
                    return S = E() ? Reflect.construct : function(e1, t, n) {
                        var r = [
                            null
                        ];
                        r.push.apply(r, t);
                        var o = new (Function.bind.apply(e1, r));
                        return n && Z(o, n.prototype), o;
                    }, S.apply(null, arguments);
                }
                function x(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return x = function(e1) {
                        if (null === e1 || (n = e1, -1 === Function.toString.call(n).indexOf("[native code]"))) return e1;
                        var n;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, r);
                        }
                        function r() {
                            return S(e1, arguments, T(this).constructor);
                        }
                        return r.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Z(r, e1);
                    }, x(e1);
                }
                function P(e1, t) {
                    return !t || "object" != typeof t && "function" != typeof t ? function(e1) {
                        if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e1;
                    }(e1) : t;
                }
                function A(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return R(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || _(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function _(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return R(e1, t);
                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? R(e1, t) : void 0;
                    }
                }
                function R(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var j = Object.prototype.hasOwnProperty;
                function C(e1, t) {
                    return (e1 = e1.slice()).push(t), e1;
                }
                function D(e1, t) {
                    return (t = t.slice()).unshift(e1), t;
                }
                var I = function(e1) {
                    !function(e1, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e1.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && Z(e1, t);
                    }(o, e1);
                    var t, n, r = (t = o, n = E(), function() {
                        var e1, r = T(t);
                        if (n) {
                            var o = T(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return P(this, e1);
                    });
                    function o(e1) {
                        var t;
                        return function(e1, t) {
                            if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, o), (t = r.call(this, 'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew = !0, t.value = e1, t.name = "NewError", t;
                    }
                    return o;
                }(x(Error));
                function N(e1, t, n, r, o) {
                    if (!(this instanceof N)) try {
                        return new N(e1, t, n, r, o);
                    } catch (e1) {
                        if (!e1.avoidNew) throw e1;
                        return e1.value;
                    }
                    "string" == typeof e1 && (o = r, r = n, n = t, t = e1, e1 = null);
                    var i = e1 && "object" === O(e1);
                    if (e1 = e1 || {}, this.json = e1.json || n, this.path = e1.path || t, this.resultType = e1.resultType || "value", this.flatten = e1.flatten || !1, this.wrap = !j.call(e1, "wrap") || e1.wrap, this.sandbox = e1.sandbox || {}, this.preventEval = e1.preventEval || !1, this.parent = e1.parent || null, this.parentProperty = e1.parentProperty || null, this.callback = e1.callback || r || null, this.otherTypeCallback = e1.otherTypeCallback || o || function() {
                        throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
                    }, !1 !== e1.autostart) {
                        var a = {
                            path: i ? e1.path : t
                        };
                        i ? "json" in e1 && (a.json = e1.json) : a.json = n;
                        var u = this.evaluate(a);
                        if (!u || "object" !== O(u)) throw new I(u);
                        return u;
                    }
                }
                function M(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                N.prototype.evaluate = function(e1, t, n, r) {
                    var o = this, i = this.parent, a = this.parentProperty, u = this.flatten, c = this.wrap;
                    if (this.currResultType = this.resultType, this.currPreventEval = this.preventEval, this.currSandbox = this.sandbox, n = n || this.callback, this.currOtherTypeCallback = r || this.otherTypeCallback, t = t || this.json, (e1 = e1 || this.path) && "object" === O(e1) && !Array.isArray(e1)) {
                        if (!e1.path && "" !== e1.path) throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
                        if (!j.call(e1, "json")) throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
                        t = e1.json, u = j.call(e1, "flatten") ? e1.flatten : u, this.currResultType = j.call(e1, "resultType") ? e1.resultType : this.currResultType, this.currSandbox = j.call(e1, "sandbox") ? e1.sandbox : this.currSandbox, c = j.call(e1, "wrap") ? e1.wrap : c, this.currPreventEval = j.call(e1, "preventEval") ? e1.preventEval : this.currPreventEval, n = j.call(e1, "callback") ? e1.callback : n, this.currOtherTypeCallback = j.call(e1, "otherTypeCallback") ? e1.otherTypeCallback : this.currOtherTypeCallback, i = j.call(e1, "parent") ? e1.parent : i, a = j.call(e1, "parentProperty") ? e1.parentProperty : a, e1 = e1.path;
                    }
                    if (i = i || null, a = a || null, Array.isArray(e1) && (e1 = N.toPathString(e1)), (e1 || "" === e1) && t) {
                        var s = N.toPathArray(e1);
                        "$" === s[0] && s.length > 1 && s.shift(), this._hasParentSelector = null;
                        var f = this._trace(s, t, [
                            "$"
                        ], i, a, n).filter(function(e1) {
                            return e1 && !e1.isParentSelector;
                        });
                        return f.length ? c || 1 !== f.length || f[0].hasArrExpr ? f.reduce(function(e1, t) {
                            var n = o._getPreferredOutput(t);
                            return u && Array.isArray(n) ? e1 = e1.concat(n) : e1.push(n), e1;
                        }, []) : this._getPreferredOutput(f[0]) : c ? [] : void 0;
                    }
                }, N.prototype._getPreferredOutput = function(e1) {
                    var t = this.currResultType;
                    switch(t){
                        case "all":
                            var n = Array.isArray(e1.path) ? e1.path : N.toPathArray(e1.path);
                            return e1.pointer = N.toPointer(n), e1.path = "string" == typeof e1.path ? e1.path : N.toPathString(e1.path), e1;
                        case "value":
                        case "parent":
                        case "parentProperty":
                            return e1[t];
                        case "path":
                            return N.toPathString(e1[t]);
                        case "pointer":
                            return N.toPointer(e1.path);
                        default:
                            throw new TypeError("Unknown result type");
                    }
                }, N.prototype._handleCallback = function(e1, t, n) {
                    if (t) {
                        var r = this._getPreferredOutput(e1);
                        e1.path = "string" == typeof e1.path ? e1.path : N.toPathString(e1.path), t(r, n, e1);
                    }
                }, N.prototype._trace = function(e1, t, n, r, o, i, a, u) {
                    var c, s = this;
                    if (!e1.length) return c = {
                        path: n,
                        value: t,
                        parent: r,
                        parentProperty: o,
                        hasArrExpr: a
                    }, this._handleCallback(c, i, "value"), c;
                    var f = e1[0], l = e1.slice(1), p = [];
                    function h(e1) {
                        Array.isArray(e1) ? e1.forEach(function(e1) {
                            p.push(e1);
                        }) : p.push(e1);
                    }
                    if (("string" != typeof f || u) && t && j.call(t, f)) h(this._trace(l, t[f], C(n, f), t, f, i, a));
                    else if ("*" === f) this._walk(f, l, t, n, r, o, i, function(e1, t, n, r, o, i, a, u) {
                        h(s._trace(D(e1, n), r, o, i, a, u, !0, !0));
                    });
                    else if (".." === f) h(this._trace(l, t, n, r, o, i, a)), this._walk(f, l, t, n, r, o, i, function(e1, t, n, r, o, i, a, u) {
                        "object" === O(r[e1]) && h(s._trace(D(t, n), r[e1], C(o, e1), r, e1, u, !0));
                    });
                    else {
                        if ("^" === f) return this._hasParentSelector = !0, {
                            path: n.slice(0, -1),
                            expr: l,
                            isParentSelector: !0
                        };
                        if ("~" === f) return c = {
                            path: C(n, f),
                            value: o,
                            parent: r,
                            parentProperty: null
                        }, this._handleCallback(c, i, "property"), c;
                        if ("$" === f) h(this._trace(l, t, n, null, null, i, a));
                        else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(f)) h(this._slice(f, l, t, n, r, o, i));
                        else if (0 === f.indexOf("?(")) {
                            if (this.currPreventEval) throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
                            this._walk(f, l, t, n, r, o, i, function(e1, t, n, r, o, i, a, u) {
                                s._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1"), r[e1], e1, o, i, a) && h(s._trace(D(e1, n), r, o, i, a, u, !0));
                            });
                        } else if ("(" === f[0]) {
                            if (this.currPreventEval) throw new Error("Eval [(expr)] prevented in JSONPath expression.");
                            h(this._trace(D(this._eval(f, t, n[n.length - 1], n.slice(0, -1), r, o), l), t, n, r, o, i, a));
                        } else if ("@" === f[0]) {
                            var d = !1, v = f.slice(1, -2);
                            switch(v){
                                case "scalar":
                                    t && [
                                        "object",
                                        "function"
                                    ].includes(O(t)) || (d = !0);
                                    break;
                                case "boolean":
                                case "string":
                                case "undefined":
                                case "function":
                                    O(t) === v && (d = !0);
                                    break;
                                case "integer":
                                    !Number.isFinite(t) || t % 1 || (d = !0);
                                    break;
                                case "number":
                                    Number.isFinite(t) && (d = !0);
                                    break;
                                case "nonFinite":
                                    "number" != typeof t || Number.isFinite(t) || (d = !0);
                                    break;
                                case "object":
                                    t && O(t) === v && (d = !0);
                                    break;
                                case "array":
                                    Array.isArray(t) && (d = !0);
                                    break;
                                case "other":
                                    d = this.currOtherTypeCallback(t, n, r, o);
                                    break;
                                case "null":
                                    null === t && (d = !0);
                                    break;
                                default:
                                    throw new TypeError("Unknown value type " + v);
                            }
                            if (d) return c = {
                                path: n,
                                value: t,
                                parent: r,
                                parentProperty: o
                            }, this._handleCallback(c, i, "value"), c;
                        } else if ("`" === f[0] && t && j.call(t, f.slice(1))) {
                            var y = f.slice(1);
                            h(this._trace(l, t[y], C(n, y), t, y, i, a, !0));
                        } else if (f.includes(",")) {
                            var g, m = function(e1, t) {
                                var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e1) || (n = _(e1))) {
                                        n && (e1 = n);
                                        var r = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return r >= e1.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e1[r++]
                                                };
                                            },
                                            e: function(e1) {
                                                throw e1;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var i, a = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e1);
                                    },
                                    n: function() {
                                        var e1 = n.next();
                                        return a = e1.done, e1;
                                    },
                                    e: function(e1) {
                                        u = !0, i = e1;
                                    },
                                    f: function() {
                                        try {
                                            a || null == n.return || n.return();
                                        } finally{
                                            if (u) throw i;
                                        }
                                    }
                                };
                            }(f.split(","));
                            try {
                                for(m.s(); !(g = m.n()).done;){
                                    var b = g.value;
                                    h(this._trace(D(b, l), t, n, r, o, i, !0));
                                }
                            } catch (e1) {
                                m.e(e1);
                            } finally{
                                m.f();
                            }
                        } else !u && t && j.call(t, f) && h(this._trace(l, t[f], C(n, f), t, f, i, a, !0));
                    }
                    if (this._hasParentSelector) for(var w = 0; w < p.length; w++){
                        var k = p[w];
                        if (k && k.isParentSelector) {
                            var T = this._trace(k.expr, t, k.path, r, o, i, a);
                            if (Array.isArray(T)) {
                                p[w] = T[0];
                                for(var Z = T.length, E = 1; E < Z; E++)w++, p.splice(w, 0, T[E]);
                            } else p[w] = T;
                        }
                    }
                    return p;
                }, N.prototype._walk = function(e1, t, n, r, o, i, a, u) {
                    if (Array.isArray(n)) for(var c = n.length, s = 0; s < c; s++)u(s, e1, t, n, r, o, i, a);
                    else n && "object" === O(n) && Object.keys(n).forEach(function(c) {
                        u(c, e1, t, n, r, o, i, a);
                    });
                }, N.prototype._slice = function(e1, t, n, r, o, i, a) {
                    if (Array.isArray(n)) {
                        var u = n.length, c = e1.split(":"), s = c[2] && Number.parseInt(c[2]) || 1, f = c[0] && Number.parseInt(c[0]) || 0, l = c[1] && Number.parseInt(c[1]) || u;
                        f = f < 0 ? Math.max(0, f + u) : Math.min(u, f), l = l < 0 ? Math.max(0, l + u) : Math.min(u, l);
                        for(var p = [], h = f; h < l; h += s)this._trace(D(h, t), n, r, o, i, a, !0).forEach(function(e1) {
                            p.push(e1);
                        });
                        return p;
                    }
                }, N.prototype._eval = function(e1, t, n, r, o, i) {
                    e1.includes("@parentProperty") && (this.currSandbox._$_parentProperty = i, e1 = e1.replace(/@parentProperty/g, "_$_parentProperty")), e1.includes("@parent") && (this.currSandbox._$_parent = o, e1 = e1.replace(/@parent/g, "_$_parent")), e1.includes("@property") && (this.currSandbox._$_property = n, e1 = e1.replace(/@property/g, "_$_property")), e1.includes("@path") && (this.currSandbox._$_path = N.toPathString(r.concat([
                        n
                    ])), e1 = e1.replace(/@path/g, "_$_path")), e1.includes("@root") && (this.currSandbox._$_root = this.json, e1 = e1.replace(/@root/g, "_$_root")), /@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e1) && (this.currSandbox._$_v = t, e1 = e1.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1"));
                    try {
                        return this.vm.runInNewContext(e1, this.currSandbox);
                    } catch (t) {
                        throw console.log(t), new Error("jsonPath: " + t.message + ": " + e1);
                    }
                }, N.cache = {}, N.toPathString = function(e1) {
                    for(var t = e1, n = t.length, r = "$", o = 1; o < n; o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += /^[\*0-9]+$/.test(t[o]) ? "[" + t[o] + "]" : "['" + t[o] + "']");
                    return r;
                }, N.toPointer = function(e1) {
                    for(var t = e1, n = t.length, r = "", o = 1; o < n; o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += "/" + t[o].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
                    return r;
                }, N.toPathArray = function(e1) {
                    var t = N.cache;
                    if (t[e1]) return t[e1].concat();
                    var n = [], r = e1.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function(e1, t) {
                        return "[#" + (n.push(t) - 1) + "]";
                    }).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function(e1, t) {
                        return "['" + t.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
                    }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function(e1, t) {
                        return ";" + t.split("").join(";") + ";";
                    }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "").split(";").map(function(e1) {
                        var t = e1.match(/#([0-9]+)/);
                        return t && t[1] ? n[t[1]] : e1;
                    });
                    return t[e1] = r, t[e1].concat();
                }, N.prototype.vm = {
                    runInNewContext: function(e1, t) {
                        var n = Object.keys(t), r = [];
                        !function(e1, n, r) {
                            for(var o = e1.length, i = 0; i < o; i++)a = e1[i], "function" == typeof t[a] && n.push(e1.splice(i--, 1)[0]);
                            var a;
                        }(n, r);
                        var o = n.map(function(e1, n) {
                            return t[e1];
                        }), i = r.reduce(function(e1, n) {
                            var r = t[n].toString();
                            return /function/.test(r) || (r = "function " + r), "var " + n + "=" + r + ";" + e1;
                        }, "");
                        /(["'])use strict\1/.test(e1 = i + e1) || n.includes("arguments") || (e1 = "var arguments = undefined;" + e1);
                        var a = (e1 = e1.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "")).lastIndexOf(";"), u = a > -1 ? e1.slice(0, a + 1) + " return " + e1.slice(a + 1) : " return " + e1;
                        return S(Function, A(n).concat([
                            u
                        ])).apply(void 0, A(o));
                    }
                };
                var U = [
                    "value",
                    "type"
                ];
                function L(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function F(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? L(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : L(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var B = Object.fromEntries([
                    "remediation",
                    "context"
                ].map(function(e1) {
                    return [
                        e1,
                        !0
                    ];
                })), H = function(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {}, o = {};
                    return Object.keys(t).filter(function(e1) {
                        return !B[e1];
                    }).forEach(function(i) {
                        if ("object" === (0, l.Z)(t[i]) && t[i]) {
                            if (t[i].rel) r[t[i].name] = k(e1, t[i], n);
                            else {
                                var a = t[i], u = a.value, s = a.type, p = (0, f.Z)(a, U);
                                o[i] = F({
                                    type: s
                                }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function(t) {
                                    var a = (0, c.Z)(t, 2), u = a[0], s = a[1];
                                    s.rel ? r["".concat(i, "-").concat(u.name || u)] = k(e1, s, n) : o[i].value[u] = s;
                                })) : o[i].value = u;
                            }
                        } else o[i] = t[i];
                    }), {
                        context: o,
                        actions: r
                    };
                }, K = function e1(t, n) {
                    Object.keys(n).forEach(function(r) {
                        if ("relatesTo" === r) {
                            var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = (a = {
                                    path: o,
                                    json: t
                                }, N(function(e1) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var n = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? M(Object(n), !0).forEach(function(t) {
                                            (0, s.Z)(e1, t, n[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function(t) {
                                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                        });
                                    }
                                    return e1;
                                }({
                                    preventEval: !0
                                }, a)))[0];
                                if (i) return void (n[r] = i);
                            }
                        }
                        var a;
                        Array.isArray(n[r]) && n[r].forEach(function(n) {
                            return e1(t, n);
                        });
                    });
                }, G = function(e1, t, n) {
                    if (t.rel) {
                        var r = function(e1, t) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return Object.fromEntries(t.map(function(t) {
                                return [
                                    t.name,
                                    k(e1, t, n)
                                ];
                            }));
                        }(e1, [
                            t
                        ], n), o = r[t.name];
                        return F(F({}, t), {}, {
                            action: o
                        });
                    }
                    return t;
                }, V = {
                    makeIdxState: function(e1, t, n, r) {
                        var a, c, s, f, l = t, p = function(e1, t) {
                            var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
                            o.forEach(function(e1) {
                                return K(t, e1);
                            });
                            var i = o.map(function(t) {
                                return G(e1, t, r);
                            }), a = H(e1, t, r), u = a.context, c = a.actions;
                            return {
                                remediations: i,
                                context: u,
                                actions: c
                            };
                        }(e1, t, n), h = p.remediations, d = p.context, v = p.actions, y = (0, i.Z)(h), g = (f = (0, o.Z)(u().mark(function e1(t) {
                            var n, r, o = arguments;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = h.find(function(e1) {
                                            return e1.name === t;
                                        })) {
                                            e1.next = 4;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        if ("function" == typeof r.action) {
                                            e1.next = 7;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                                    case 7:
                                        return e1.abrupt("return", r.action(n));
                                    case 8:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        })), function(e1) {
                            return f.apply(this, arguments);
                        });
                        return {
                            proceed: g,
                            neededToProceed: y,
                            actions: v,
                            context: d,
                            rawIdxState: l,
                            interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function(e1) {
                                return "interaction_code" === e1.name;
                            })) || void 0 === s ? void 0 : s.value,
                            toPersist: n,
                            requestDidSucceed: r
                        };
                    }
                }, q = function(e1) {
                    switch(e1){
                        case "1.0.0":
                            return V;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e1, ".  Use an exact semver version."));
                    }
                };
                function Y(e1) {
                    if (!e1) throw new Error("version is required");
                    if ((null != e1 ? e1 : "").replace(/[^0-9a-zA-Z._-]/, "") !== e1 || !e1) throw new Error("invalid version supplied - version is required and uses semver syntax");
                    q(e1);
                }
                function W(e1, t, n, o) {
                    var i, a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
                    return Y(a), (0, q(a).makeIdxState)(e1, t, n, o);
                }
            },
            683: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    pc: function() {
                        return k.pc;
                    },
                    Fw: function() {
                        return k.Fw;
                    },
                    Qd: function() {
                        return k.Qd;
                    },
                    YR: function() {
                        return r.Y;
                    },
                    Ch: function() {
                        return s.C;
                    },
                    al: function() {
                        return o.a;
                    },
                    Jm: function() {
                        return v.Jm;
                    },
                    F4: function() {
                        return y.F;
                    },
                    SL: function() {
                        return b.S;
                    },
                    aT: function() {
                        return w.a;
                    },
                    vK: function() {
                        return O.v;
                    },
                    Yn: function() {
                        return g.Y;
                    },
                    Xc: function() {
                        return v.Xc;
                    },
                    uN: function() {
                        return v.uN;
                    },
                    Co: function() {
                        return v.Co;
                    },
                    Jn: function() {
                        return i.Jn;
                    },
                    Xx: function() {
                        return p.X;
                    },
                    $0: function() {
                        return v.$0;
                    },
                    EW: function() {
                        return a.E;
                    },
                    L8: function() {
                        return u.L;
                    },
                    H: function() {
                        return k.H;
                    },
                    GA: function() {
                        return i.GA;
                    },
                    gc: function() {
                        return i.gc;
                    },
                    Wf: function() {
                        return v.Wf;
                    },
                    bl: function() {
                        return v.bl;
                    },
                    UC: function() {
                        return v.UC;
                    },
                    B_: function() {
                        return m.B;
                    },
                    mo: function() {
                        return i.mo;
                    },
                    $l: function() {
                        return c.$;
                    },
                    xc: function() {
                        return s.x;
                    },
                    M4: function() {
                        return l.M;
                    },
                    z2: function() {
                        return f.z;
                    },
                    r0: function() {
                        return v.r0;
                    },
                    Yr: function() {
                        return h.Y;
                    },
                    le: function() {
                        return d.l;
                    }
                });
                var r = n(1286), o = n(9192), i = n(7985), a = n(6131), u = n(2660), c = n(9310), s = n(2845), f = n(8826), l = n(9214), p = n(5021), h = n(2473), d = n(8277), v = n(2620), y = n(9727), g = n(2144), m = n(9284), b = n(4602), w = n(4143), k = n(7595), O = n(3334);
            },
            6131: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(2620), c = n(7599), s = n(3193), f = n(5385);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return {
                        meta: e1,
                        interactionHandle: e1.interactionHandle,
                        state: e1.state
                    };
                }
                function d(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, l, d, v, y, g, m, b, w, k, O, T, Z, E, S, x, P, A, _, R, j, C, D = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = D.length > 1 && void 0 !== D[1] ? D[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", h(i));
                                case 5:
                                    return e1.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                                case 7:
                                    return i = e1.sent, l = (0, c.zf)(t), v = (d = i).clientId, y = d.redirectUri, g = d.state, m = d.scopes, b = d.withCredentials, w = d.codeChallenge, k = d.codeChallengeMethod, O = d.activationToken, T = d.recoveryToken, Z = d.maxAge, E = d.acrValues, S = d.nonce, x = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, P = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                                        client_id: v,
                                        scope: m.join(" "),
                                        redirect_uri: y,
                                        code_challenge: w,
                                        code_challenge_method: k,
                                        state: g
                                    }, O && {
                                        activation_token: O
                                    }), T && {
                                        recovery_token: T
                                    }), x && {
                                        client_secret: x
                                    }), Z && {
                                        max_age: Z
                                    }), E && {
                                        acr_values: E
                                    }), S && {
                                        nonce: S
                                    }), _ = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, e1.next = 17, (0, f.c3)(t, {
                                        method: "POST",
                                        url: P,
                                        headers: _,
                                        withCredentials: b,
                                        args: A
                                    });
                                case 17:
                                    return R = e1.sent, j = R.interaction_handle, C = p(p({}, i), {}, {
                                        interactionHandle: j,
                                        withCredentials: b,
                                        state: g,
                                        scopes: m,
                                        recoveryToken: T,
                                        activationToken: O
                                    }), (0, u.r0)(t, C), e1.abrupt("return", h(C));
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2660: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(6799), u = n(480), c = n(7599), s = n(1971), f = n(5385), l = n(5728);
                function p(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, r.Z)(i().mark(function e1(t) {
                        var n, r, o, p, h, d, v, y, g, m, b, w, k, O, T = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = T.length > 1 && void 0 !== T[1] ? T[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return d = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (h = n.withCredentials) || void 0 === h || h, e1.prev = 8, o = !0, (0, a.A0)(d), b = "".concat(v, "/idp/idx/introspect"), w = g ? {
                                        stateToken: g
                                    } : {
                                        interactionHandle: y
                                    }, k = {
                                        "Content-Type": "application/ion+json; okta-version=".concat(d),
                                        Accept: "application/ion+json; okta-version=".concat(d)
                                    }, e1.next = 16, (0, f.c3)(t, {
                                        method: "POST",
                                        url: b,
                                        headers: k,
                                        withCredentials: m,
                                        args: w
                                    });
                                case 16:
                                    r = e1.sent, e1.next = 27;
                                    break;
                                case 19:
                                    if (e1.prev = 19, e1.t0 = e1.catch(8), !((0, l.isAuthApiError)(e1.t0) && e1.t0.xhr && (0, u.P)(e1.t0.xhr.responseJSON))) {
                                        e1.next = 26;
                                        break;
                                    }
                                    r = e1.t0.xhr.responseJSON, o = !1, e1.next = 27;
                                    break;
                                case 26:
                                    throw e1.t0;
                                case 27:
                                    return O = n.withCredentials, e1.abrupt("return", (0, a._T)(t, r, {
                                        withCredentials: O
                                    }, o));
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                8,
                                19
                            ]
                        ]);
                    })), h.apply(this, arguments);
                }
            },
            9284: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return m;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    buildCredentialCreationOptions: function() {
                        return d;
                    },
                    buildCredentialRequestOptions: function() {
                        return v;
                    },
                    getAssertion: function() {
                        return g;
                    },
                    getAttestation: function() {
                        return y;
                    }
                });
                var o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(9727), p = n(7987), h = function() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = [];
                    return e1.forEach(function(e1) {
                        "webauthn" === e1.key && t.push({
                            type: "public-key",
                            id: (0, p.dX)(e1.credentialId)
                        });
                    }), t;
                }, d = function(e1, t) {
                    return {
                        publicKey: {
                            rp: e1.rp,
                            user: {
                                id: (0, p.dX)(e1.user.id),
                                name: e1.user.name,
                                displayName: e1.user.displayName
                            },
                            challenge: (0, p.dX)(e1.challenge),
                            pubKeyCredParams: e1.pubKeyCredParams,
                            attestation: e1.attestation,
                            authenticatorSelection: e1.authenticatorSelection,
                            excludeCredentials: h(t)
                        }
                    };
                }, v = function(e1, t) {
                    return {
                        publicKey: {
                            challenge: (0, p.dX)(e1.challenge),
                            userVerification: e1.userVerification,
                            allowCredentials: h(t)
                        }
                    };
                }, y = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, p.kQ)(t.clientDataJSON),
                        attestation: (0, p.kQ)(t.attestationObject)
                    };
                }, g = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, p.kQ)(t.clientDataJSON),
                        authenticatorData: (0, p.kQ)(t.authenticatorData),
                        signatureData: (0, p.kQ)(t.signature)
                    };
                };
                function m(e1) {
                    var t;
                    return t = function(e1) {
                        (0, u.Z)(p, e1);
                        var t, n, r = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, i.Z)(this, p);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = r.call.apply(r, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "idx", void 0), e1.idx = (0, l.F)((0, a.Z)(e1)), e1;
                        }
                        return (0, o.Z)(p);
                    }(e1), (0, f.Z)(t, "webauthn", r), t;
                }
            },
            4602: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    S: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9133);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e1.flow, t.activationToken = e1.activationToken, t.recoveryToken = e1.recoveryToken, t.idx = e1.idx, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.n)());
                }
            },
            9310: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return s;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(2845), u = n(2620), c = n(146);
                function s(e1) {
                    return f.apply(this, arguments);
                }
                function f() {
                    return f = (0, r.Z)(i().mark(function e1(t) {
                        var n, o, f, l, p, h = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = h.length > 1 && void 0 !== h[1] ? h[1] : {}, e1.next = 3, (0, a.x)(t, {
                                        startPolling: !0
                                    });
                                case 3:
                                    if (f = e1.sent, l = (0, u.uN)(t), null != (p = null == l || null === (n = l.remediations) || void 0 === n ? void 0 : n.find(function(e1) {
                                        return e1.includes("poll");
                                    })) && p.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.abrupt("return", new Promise(function(e1, n) {
                                        setTimeout((0, r.Z)(i().mark(function r() {
                                            var o, a, u;
                                            return i().wrap(function(r) {
                                                for(;;)switch(r.prev = r.next){
                                                    case 0:
                                                        try {
                                                            u = null === (o = f.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e1(u ? s(t, {
                                                                refresh: u
                                                            }) : f);
                                                        } catch (e1) {
                                                            n(e1);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return r.stop();
                                                }
                                            }, r);
                                        })), o.refresh);
                                    }));
                                case 9:
                                    return e1.abrupt("return", f);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), f.apply(this, arguments);
                }
            },
            2845: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    C: function() {
                        return p;
                    },
                    x: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832), c = n(2620), s = n(9123);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = (0, c.uN)(e1, t);
                    return !(!n && !t.stateHandle);
                }
                function h(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, f = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = f.length > 1 && void 0 !== f[1] ? f[1] : {}, p(t, n)) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                                case 3:
                                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                                        state: o
                                    }), r = null == i ? void 0 : i.flow), e1.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                                        flow: r
                                    })));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), d.apply(this, arguments);
                }
            },
            9214: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e1.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            8826: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    z: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 4, (0, s.Y)(t, h(h({}, n), {}, {
                                        flow: "register",
                                        autoRemediate: !1
                                    }));
                                case 4:
                                    if (r = e1.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new f.Z("Registration is not supported based on your current org configuration.");
                                case 8:
                                    return e1.abrupt("return", (0, u.K)(t, h(h({}, n), {}, {
                                        flow: "register"
                                    })));
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2541: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(4794), l = n(6064);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f() {
                        return (0, r.Z)(this, f), s.apply(this, arguments);
                    }
                    return (0, o.Z)(f, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorData();
                                return {
                                    id: (0, l.zg)(this.remediation).form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value,
                                    methodType: e1.methodType,
                                    phoneNumber: e1.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return [
                                    {
                                        name: "methodType",
                                        type: "string"
                                    },
                                    {
                                        name: "phoneNumber",
                                        label: "Phone Number",
                                        type: "string"
                                    }
                                ].map(function(t) {
                                    return h(h({}, e1.form.value.find(function(e1) {
                                        return e1.name === t.name;
                                    })), t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                e1 = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e1);
                                var t = this.values.phoneNumber;
                                if (e1 || t) return h(h({}, e1 && e1), t && {
                                    phoneNumber: t
                                });
                            }
                        }
                    ]), f;
                }(f.a);
                (0, s.Z)(d, "remediationName", "authenticator-enrollment-data");
            },
            5278: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return h;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h() {
                        return (0, o.Z)(this, h), l.apply(this, arguments);
                    }
                    return (0, i.Z)(h, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                return this.getAuthenticatorData();
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorFromRemediation(), t = e1.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                });
                                return t && t.options ? {
                                    name: "methodType",
                                    type: "string",
                                    required: !0,
                                    options: t.options
                                } : (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "authenticator" !== e1;
                                }).reduce(function(t, n) {
                                    return p(p({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), h;
                }(n(4794).a);
                (0, f.Z)(h, "remediationName", "authenticator-verification-data");
            },
            4794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return y;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7595), h = n(9344);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, d), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                    }
                    return (0, o.Z)(d, [
                        {
                            key: "formatAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                    return (0, h.PN)(e1.authenticator, t) ? e1.mapAuthenticatorDataFromValues(t) : t;
                                });
                                else {
                                    var t = this.mapAuthenticatorDataFromValues();
                                    t && this.values.authenticatorsData.push(t);
                                }
                            }
                        },
                        {
                            key: "getAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.find(function(t) {
                                    return (0, h.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.some(function(t) {
                                    return (0, h.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                var t = this.values, n = t.methodType, r = t.authenticator;
                                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                                var o = this.authenticator, i = v(v({
                                    id: o.id,
                                    enrollmentId: o.enrollmentId
                                }, e1 && e1), n && {
                                    methodType: n
                                });
                                return i.methodType ? i : null;
                            }
                        },
                        {
                            key: "getAuthenticatorFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "authenticator" === e1.name;
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticatorsData.filter(function(t) {
                                    return !0 !== (0, h.PN)(e1.authenticator, t);
                                });
                                return v(v({}, this.values), {}, {
                                    authenticatorsData: t
                                });
                            }
                        }
                    ]), d;
                }(l.n);
            },
            3118: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return h;
                    }
                });
                var r = n(2982), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(6064), s = n(9344);
                function f(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, e1), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "formatAuthenticators",
                            value: function() {
                                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function(e1) {
                                    return (0, s.LL)(e1);
                                }), this.values.authenticator) {
                                    var e1 = (0, s.LL)(this.values.authenticator);
                                    this.values.authenticators.some(function(t) {
                                        return (0, s.PN)(e1, t);
                                    }) || this.values.authenticators.push(e1);
                                }
                                this.values.authenticatorsData = this.values.authenticators.reduce(function(e1, t) {
                                    return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e1.push(t), e1;
                                }, this.values.authenticatorsData || []);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.remediation.name;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return !(0, c.QG)(this.remediation).find(function(t) {
                                    return !e1.hasData(t);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function(e1) {
                                var t = this;
                                if (!e1) {
                                    var n = (0, c.ix)(this.remediation).reduce(function(e1, n) {
                                        return e1[n] = t.getData(n), e1;
                                    }, {});
                                    return n;
                                }
                                if ("function" == typeof this["map".concat((0, c.Qs)(e1))]) {
                                    var r = this["map".concat((0, c.Qs)(e1))](this.remediation.value.find(function(t) {
                                        return t.name === e1;
                                    }));
                                    if (r) return r;
                                }
                                if (this.map && this.map[e1]) for(var o = this.map[e1], i = 0; i < o.length; i++){
                                    var a = this.values[o[i]];
                                    if (a) return a;
                                }
                                return this.values[e1];
                            }
                        },
                        {
                            key: "hasData",
                            value: function(e1) {
                                return !!this.getData(e1);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = this.getName(), r = this.getInputs(), o = this.getAuthenticator(), i = null == o ? void 0 : o.type;
                                return p(p({
                                    name: n,
                                    inputs: r
                                }, i && {
                                    type: i
                                }), o && {
                                    authenticator: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                var e1 = this, t = [];
                                return (this.remediation.value || []).forEach(function(n) {
                                    var r, o = n.name, i = n.type, a = n.visible, u = n.messages;
                                    if (!1 !== a) {
                                        if ("function" == typeof e1["getInput".concat((0, c.Qs)(o))]) r = e1["getInput".concat((0, c.Qs)(o))](n);
                                        else if ("object" !== i) {
                                            var s, f = (e1.map ? e1.map[o] : null) || [];
                                            s = 1 === f.length ? f[0] : f.find(function(t) {
                                                return Object.keys(e1.values).includes(t);
                                            }), s && (r = p(p({}, n), {}, {
                                                name: s
                                            }));
                                        }
                                        r || (r = n), Array.isArray(r) ? r.forEach(function(e1) {
                                            return t.push(e1);
                                        }) : (u && (r.messages = u), t.push(r));
                                    }
                                }), t;
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1, t = this.remediation.value || [], n = this.getInputs(), o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return f(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                                try {
                                    for(o.s(); !(e1 = o.n()).done;){
                                        var i = e1.value;
                                        delete this.values[i.name];
                                    }
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return this.values;
                            }
                        },
                        {
                            key: "getAuthenticator",
                            value: function() {
                                var e1, t, n = null === (e1 = this.remediation.relatesTo) || void 0 === e1 ? void 0 : e1.value;
                                if (n) {
                                    var r = (0, c.zg)(this.remediation);
                                    if (!r) return n;
                                    var o = r.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value, i = null === (t = r.form.value.find(function(e1) {
                                        return "enrollmentId" === e1.name;
                                    })) || void 0 === t ? void 0 : t.value;
                                    return p(p({}, n), {}, {
                                        id: o,
                                        enrollmentId: i
                                    });
                                }
                            }
                        }
                    ], [
                        {
                            key: "getMessages",
                            value: function(e1) {
                                var t, n;
                                if (e1.value) return null === (t = e1.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function(e1, t) {
                                    return t.messages && (e1 = [].concat((0, r.Z)(e1), (0, r.Z)(t.messages.value))), e1;
                                }, []);
                            }
                        }
                    ]), e1;
                }();
                (0, u.Z)(h, "remediationName", void 0);
            },
            9164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return m;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(6064), h = n(7595), d = n(9344);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var m = function(e1) {
                    (0, u.Z)(v, e1);
                    var t, n, l = (t = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function v() {
                        var e1;
                        (0, r.Z)(this, v);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e1), "selectedOption", void 0), e1;
                    }
                    return (0, o.Z)(v, [
                        {
                            key: "findMatchedOption",
                            value: function(e1, t) {
                                var n, r, o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return g(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(e1);
                                try {
                                    var i = function() {
                                        var e1 = r.value;
                                        if (n = t.find(function(t) {
                                            return t.relatesTo.key === e1.key;
                                        })) return "break";
                                    };
                                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return n;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this.values, t = e1.authenticators, n = e1.authenticator, r = (0, p.zg)(this.remediation).options;
                                return !!(t && t.length && ((0, h.H)(n) && n.id || this.findMatchedOption(t, r)));
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator;
                                if ((0, h.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                                var o = e1.options, i = (0, d.h_)(n, o);
                                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                                    id: null == i ? void 0 : i.value.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return {
                                    name: "authenticator",
                                    type: "string",
                                    options: e1.options.map(function(e1) {
                                        return {
                                            label: e1.label,
                                            value: e1.relatesTo.key
                                        };
                                    })
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticators.filter(function(t) {
                                    return !0 !== (0, d.PN)(t, e1.selectedAuthenticator);
                                });
                                return y(y({}, this.values), {}, {
                                    authenticators: t
                                });
                            }
                        }
                    ]), v;
                }(l.n);
            },
            9883: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Q: function() {
                        return S;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7644);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.verificationCode || e1.otp);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.verificationCode, r = e1.otp;
                                if (t || n || r) return t || {
                                    passcode: n || r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return d(d({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "verificationCode",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), a;
                }(p._);
                var y = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.verificationCode;
                                if (t) return {
                                    totp: t
                                };
                            }
                        }
                    ]), a;
                }(v), g = n(9582);
                var m = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                if (t && t.questionKey && t.answer) return !0;
                                var n = e1.questionKey, r = e1.question, o = e1.answer;
                                return !(!n || !o) || !(!r || !o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.questionKey, n = e1.question, r = e1.answer;
                                if (r && (t || n)) return {
                                    questionKey: n ? "custom" : t,
                                    question: n,
                                    answer: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "questionKey",
                                        type: "string",
                                        required: !0
                                    },
                                    {
                                        name: "question",
                                        type: "string",
                                        label: "Create a security question"
                                    },
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var b = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                return !(!t || !t.answer) || !!e1.answer;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.answer;
                                if (t) return {
                                    questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                    answer: t
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var w = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.attestation;
                                return !(!n || !r);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.clientData, r = e1.attestation;
                                if (t || n || r) return t || {
                                    clientData: n,
                                    attestation: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "clientData",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Client Data"
                                    },
                                    {
                                        name: "attestation",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Attestation"
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var k = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.authenticatorData, o = t.signatureData;
                                return !!(n && r && o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.authenticatorData, r = e1.clientData, o = e1.signatureData;
                                if (t || n || r || o) return t || {
                                    authenticatorData: n,
                                    clientData: r,
                                    signatureData: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "authenticatorData",
                                        type: "string",
                                        label: "Authenticator Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "clientData",
                                        type: "string",
                                        label: "Client Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "signatureData",
                                        type: "string",
                                        label: "Signature Data",
                                        required: !0,
                                        visible: !1
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._), O = n(7595);
                function T(e1) {
                    var t, n, r = e1.relatesTo, o = (null == r ? void 0 : r.value) || {};
                    switch(o.key){
                        case O.pc.OKTA_PASSWORD:
                            return new g.a(o);
                        case O.pc.SECURITY_QUESTION:
                            return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                        case O.pc.OKTA_VERIFY:
                            return new y(o);
                        case O.pc.WEBAUTHN:
                            return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new k(o) : new w(o);
                        default:
                            return new v(o);
                    }
                }
                function Z(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Z(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : Z(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var S = function(e1) {
                    (0, u.Z)(p, e1);
                    var t, n, l = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function p(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, p), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = T(e1), t;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e1, t), o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                                return E(E({}, r), {}, {
                                    authenticatorEnrollments: o
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return this.authenticator.canVerify(this.values);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                return this.authenticator.mapCredentials(this.values);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return this.authenticator.getInputs(e1);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "credentials" !== e1;
                                }).reduce(function(t, n) {
                                    return E(E({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(l.n);
            },
            4560: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "challenge-authenticator");
            },
            1104: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "challenge-poll" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(2288).T);
                (0, c.Z)(s, "remediationName", "challenge-poll");
            },
            3857: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "enroll-authenticator");
            },
            2288: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "enroll-poll" === this.options.step;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = this.getAuthenticator();
                                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                                    authenticator: r,
                                    poll: {
                                        required: !0,
                                        refresh: this.remediation.refresh
                                    }
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return "startPolling" !== e1;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enroll-poll");
            },
            7522: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    w: function() {
                        return v;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(9582);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, o.Z)(this, h), t = l.call(this, e1, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null);
                        var i = t.getCredentialsFromRemediation();
                        return i && (t.authenticator = t.authenticator = new p.a({})), t;
                    }
                    return (0, i.Z)(h, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                                var e1 = this.getData().userProfile;
                                return !!e1 && this.remediation.value.find(function(e1) {
                                    return "userProfile" === e1.name;
                                }).form.value.reduce(function(t, n) {
                                    return n.required && (t = t && !!e1[n.name]), t;
                                }, !0);
                            }
                        },
                        {
                            key: "getCredentialsFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "credentials" === e1.name;
                                });
                            }
                        },
                        {
                            key: "mapUserProfile",
                            value: function(e1) {
                                var t = this, n = e1.form.value.map(function(e1) {
                                    return e1.name;
                                }).reduce(function(e1, n) {
                                    return t.values[n] ? d(d({}, e1), {}, (0, f.Z)({}, n, t.values[n])) : e1;
                                }, {});
                                if (0 !== Object.keys(n).length) return n;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.authenticator && this.authenticator.mapCredentials(this.values);
                                if (e1) return e1;
                            }
                        },
                        {
                            key: "getInputUserProfile",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getErrorMessages",
                            value: function(e1) {
                                return e1.value[0].form.value.reduce(function(e1, t) {
                                    return t.messages && e1.push(t.messages.value[0].message), e1;
                                }, []);
                            }
                        }
                    ]), h;
                }(l.n);
                (0, f.Z)(v, "remediationName", "enroll-profile");
            },
            3679: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getInputEmail",
                            value: function() {
                                return [
                                    {
                                        name: "email",
                                        type: "string",
                                        required: !0,
                                        label: "Email"
                                    }
                                ];
                            }
                        },
                        {
                            key: "getInputPhoneNumber",
                            value: function() {
                                return [
                                    {
                                        name: "phoneNumber",
                                        type: "string",
                                        required: !0,
                                        label: "Phone Number"
                                    }
                                ];
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return Boolean(this.values.email || this.values.phoneNumber);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                return {
                                    stateHandle: this.values.stateHandle,
                                    email: this.values.email,
                                    phoneNumber: this.values.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return ![
                                        "email",
                                        "phoneNumber"
                                    ].includes(e1);
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enrollment-channel-data");
            },
            8628: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        var e1;
                        (0, r.Z)(this, p);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = f.call.apply(f, [
                            this
                        ].concat(n)), (0, s.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData().identifier;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values, t = e1.credentials, n = e1.password;
                                if (t || n) return t || {
                                    passcode: n
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return l(l({}, e1.form.value[0]), {}, {
                                    name: "password",
                                    required: e1.required
                                });
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "identify");
            },
            9024: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values.newPassword;
                                if (e1) return {
                                    passcode: e1
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                                return f(f({}, e1.form.value[0]), {}, {
                                    name: t
                                });
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(l, "remediationName", "reenroll-authenticator");
            },
            8490: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    O: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function() {
                                var e1 = this.remediation;
                                return {
                                    name: e1.name,
                                    type: e1.type,
                                    idp: e1.idp,
                                    href: e1.href
                                };
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "redirect-idp");
            },
            1019: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "reset-authenticator");
            },
            7311: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return h;
                    }
                });
                var r = n(2982), o = n(3144), i = n(5671), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9164), l = n(6064), p = n(7595);
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t, n, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, f);
                        var u = "recoverPassword" === (n = s.call(this, e1, o, a)).options.flow, c = null === (t = (0, l.zg)(e1).options) || void 0 === t ? void 0 : t.some(function(e1) {
                            var t = e1.relatesTo;
                            return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
                        });
                        return c && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
                            {
                                key: p.pc.OKTA_PASSWORD
                            }
                        ])), n;
                    }
                    return (0, o.Z)(f);
                }(f.n);
                (0, s.Z)(h, "remediationName", "select-authenticator-authenticate");
            },
            9865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9164).n);
                (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
            },
            5272: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h() {
                        var e1;
                        (0, r.Z)(this, h);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "authenticator", void 0), (0, f.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(h, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(h.prototype), "canRemediate", this).call(this);
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t, n, r, o = (0, a.Z)((0, s.Z)(h.prototype), "mapAuthenticator", this).call(this, e1), i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                }), u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                                return u ? p(p({}, o), {}, {
                                    methodType: u
                                }) : o;
                            }
                        },
                        {
                            key: "getInputUsername",
                            value: function() {
                                return {
                                    name: "username",
                                    type: "string"
                                };
                            }
                        }
                    ]), h;
                }(n(9164).n);
                (0, f.Z)(h, "remediationName", "select-authenticator-unlock-account");
            },
            4713: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "select-enroll-profile");
            },
            3403: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.values.channel) return !0;
                                if (this.values.authenticator) {
                                    var e1 = this.values.authenticator, t = e1.id, n = e1.channel;
                                    if (t && n) return !0;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1;
                                return {
                                    authenticator: {
                                        id: this.remediation.value[0].value.form.value[0].value,
                                        channel: (null === (e1 = this.values.authenticator) || void 0 === e1 ? void 0 : e1.channel) || this.values.channel
                                    },
                                    stateHandle: this.values.stateHandle
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                                var t = this.values.channel ? "channel" : "authenticator";
                                return Object.keys(this.values).filter(function(e1) {
                                    return e1 !== t;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "select-enrollment-channel");
            },
            8443: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.skip || "skip" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "skip");
            },
            6064: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.map(function(e1) {
                        return e1.name;
                    });
                }
                function o(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.reduce(function(e1, t) {
                        return t.required && e1.push(t.name), e1;
                    }, []);
                }
                function i(e1) {
                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                }
                function a(e1) {
                    return e1.value.find(function(e1) {
                        return "authenticator" === e1.name;
                    });
                }
                n.d(t, {
                    QG: function() {
                        return o;
                    },
                    Qs: function() {
                        return i;
                    },
                    ix: function() {
                        return r;
                    },
                    zg: function() {
                        return a;
                    }
                });
            },
            5832: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return Re;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    AuthenticatorEnrollmentData: function() {
                        return D.q;
                    },
                    AuthenticatorVerificationData: function() {
                        return C.q;
                    },
                    ChallengeAuthenticator: function() {
                        return O.J;
                    },
                    ChallengePoll: function() {
                        return T.U;
                    },
                    EnrollAuthenticator: function() {
                        return m.q;
                    },
                    EnrollPoll: function() {
                        return b.T;
                    },
                    EnrollProfile: function() {
                        return E.w;
                    },
                    EnrollmentChannelData: function() {
                        return k.t;
                    },
                    GenericRemediator: function() {
                        return V;
                    },
                    Identify: function() {
                        return S.h;
                    },
                    ReEnrollAuthenticator: function() {
                        return x.j;
                    },
                    RedirectIdp: function() {
                        return P.O;
                    },
                    Remediator: function() {
                        return g.n;
                    },
                    ResetAuthenticator: function() {
                        return Z.G;
                    },
                    SelectAuthenticatorAuthenticate: function() {
                        return A.X;
                    },
                    SelectAuthenticatorEnroll: function() {
                        return _.j;
                    },
                    SelectAuthenticatorUnlockAccount: function() {
                        return R.G;
                    },
                    SelectEnrollProfile: function() {
                        return j.j;
                    },
                    SelectEnrollmentChannel: function() {
                        return w.V;
                    },
                    Skip: function() {
                        return I.h;
                    }
                });
                var o = n(5861), i = n(4942), a = n(4687), u = n.n(a), c = n(6131), s = n(2660), f = n(1002), l = n(2982), p = n(9123), h = n(4925), d = n(885), v = n(8750), y = n(146), g = n(3118), m = n(3857), b = n(2288), w = n(3403), k = n(3679), O = n(4560), T = n(1104), Z = n(1019), E = n(7522), S = n(8628), x = n(9024), P = n(8490), A = n(7311), _ = n(9865), R = n(5272), j = n(4713), C = n(5278), D = n(2541), I = n(8443), N = n(5671), M = n(3144), U = n(136), L = n(2963), F = n(1120);
                function B(e1) {
                    if (Array.isArray(e1)) return e1.map(function(e1) {
                        return "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? e1 : B(e1);
                    });
                    for(var t = {}, n = 0, r = Object.entries(e1); n < r.length; n++){
                        var o = (0, d.Z)(r[n], 2), i = o[0], a = o[1];
                        if (null != a) {
                            if ("object" === (0, f.Z)(a)) {
                                var u = Object.keys(a);
                                if ([
                                    "value",
                                    "form"
                                ].includes(i) && 1 === u.length && [
                                    "value",
                                    "form"
                                ].includes(u[0])) {
                                    var c = B(a);
                                    Object.entries(c).forEach(function(e1) {
                                        var n = (0, d.Z)(e1, 2), r = n[0], o = n[1];
                                        t[r] = o;
                                    });
                                } else t[i] = B(a);
                            } else t[i] = a;
                        }
                    }
                    return t;
                }
                var H = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces",
                    "value",
                    "action"
                ];
                function K(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function G(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? K(Object(n), !0).forEach(function(t) {
                            (0, i.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var V = function(e1) {
                    (0, U.Z)(i, e1);
                    var t, n, r = (t = i, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, F.Z)(t);
                        if (n) {
                            var o = (0, F.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, L.Z)(this, e1);
                    });
                    function i() {
                        return (0, N.Z)(this, i), r.apply(this, arguments);
                    }
                    return (0, M.Z)(i, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1 = this;
                                return this.getInputs().reduce(function(t, n) {
                                    var r = n.name;
                                    return t[r] = e1.values[r], t;
                                }, {});
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = this.getName(), i = this.getInputs(), a = this.remediation, c = (a.href, a.method, a.rel, a.accepts, a.produces, a.value, a.action), s = (0, h.Z)(a, H);
                                return c ? G(G(G({}, s), !!i.length && {
                                    inputs: i
                                }), {}, {
                                    action: (n = (0, o.Z)(u().mark(function t(n) {
                                        return u().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.abrupt("return", e1.idx.proceed(G({
                                                        step: r
                                                    }, n)));
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    })), function(e1) {
                                        return n.apply(this, arguments);
                                    })
                                }) : G({}, this.remediation);
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return (this.remediation.value || []).filter(function(e1) {
                                    return "stateHandle" !== e1.name;
                                }).map(B).map(function(e1) {
                                    return e1.type = e1.type || "string", e1;
                                });
                            }
                        }
                    ]), i;
                }(g.n), q = n(7595), Y = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces"
                ];
                function W(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function Q(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? W(Object(n), !0).forEach(function(t) {
                            (0, i.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function z(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return X(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? X(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function X(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function $(e1) {
                    var t = e1.neededToProceed, n = e1.interactionCode;
                    return !t.length && !n;
                }
                function J(e1) {
                    if (e1 && Array.isArray(e1)) return e1.reduce(function(e1, t) {
                        if (t.messages && (e1 = [].concat((0, l.Z)(e1), (0, l.Z)(t.messages.value))), t.form) {
                            var n = J(t.form.value) || [];
                            e1 = [].concat((0, l.Z)(e1), (0, l.Z)(n));
                        }
                        if (t.options) {
                            var r = [];
                            t.options.forEach(function(e1) {
                                e1.value && "string" != typeof e1.value && (r = [].concat((0, l.Z)(r), [
                                    e1.value
                                ]));
                            });
                            var o = J(r) || [];
                            e1 = [].concat((0, l.Z)(e1), (0, l.Z)(o));
                        }
                        return e1;
                    }, []);
                }
                function ee(e1, t) {
                    var n, r = [], o = e1.rawIdxState, i = e1.neededToProceed, a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function(e1) {
                        return e1;
                    });
                    if (a && (r = [].concat((0, l.Z)(r), (0, l.Z)(a))), !t.useGenericRemediator) {
                        var u, c = z(i);
                        try {
                            for(c.s(); !(u = c.n()).done;){
                                var s = J(u.value.value);
                                s && (r = [].concat((0, l.Z)(r), (0, l.Z)(s)));
                            }
                        } catch (e1) {
                            c.e(e1);
                        } finally{
                            c.f();
                        }
                    }
                    var f = {};
                    return r.reduce(function(e1, t) {
                        var n, r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
                        return r && f[r] ? e1 : (f[r] = t, e1 = [].concat((0, l.Z)(e1), [
                            t
                        ]));
                    }, []);
                }
                function te(e1) {
                    var t = [], n = e1.actions, r = e1.neededToProceed;
                    return n["currentAuthenticator-recover"] && t.push(q.Fw.PASSWORD_RECOVERY), r.some(function(e1) {
                        return "select-enroll-profile" === e1.name;
                    }) && t.push(q.Fw.REGISTRATION), r.some(function(e1) {
                        return "redirect-idp" === e1.name;
                    }) && t.push(q.Fw.SOCIAL_IDP), r.some(function(e1) {
                        return "unlock-account" === e1.name;
                    }) && t.push(q.Fw.ACCOUNT_UNLOCK), t;
                }
                function ne(e1, t, n) {
                    var i, a = [], c = Object.values(r).reduce(function(e1, t) {
                        return t.remediationName && (e1[t.remediationName] = t), e1;
                    }, {}), s = z(t.neededToProceed);
                    try {
                        for(s.s(); !(i = s.n()).done;){
                            var f = i.value, l = oe(f, {
                                useGenericRemediator: n,
                                remediators: c
                            });
                            if (l) {
                                var p = new l(f);
                                a.push(p.getNextStep(e1, t.context));
                            }
                        }
                    } catch (e1) {
                        s.e(e1);
                    } finally{
                        s.f();
                    }
                    for(var y = function() {
                        var n, r = (0, d.Z)(m[g], 1)[0], i = {
                            name: r,
                            action: (n = (0, o.Z)(u().mark(function t(n) {
                                return u().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", e1.idx.proceed({
                                                actions: [
                                                    {
                                                        name: r,
                                                        params: n
                                                    }
                                                ]
                                            }));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            })), function(e1) {
                                return n.apply(this, arguments);
                            })
                        };
                        if (r.startsWith("currentAuthenticator")) {
                            var c, s = (0, v.YQ)(r, "-"), f = (0, d.Z)(s, 2), l = f[0], p = f[1], y = t.rawIdxState[l].value[p], b = (y.href, y.method, y.rel, y.accepts, y.produces, (0, h.Z)(y, Y)), w = null === (c = y.value) || void 0 === c ? void 0 : c.filter(function(e1) {
                                return "stateHandle" !== e1.name;
                            });
                            i = Q(Q(Q({}, b), w && {
                                value: w
                            }), i);
                        }
                        a.push(i);
                    }, g = 0, m = Object.entries(t.actions || {}); g < m.length; g++)y();
                    return a;
                }
                function re(e1, t, n) {
                    var r = (e1.neededToProceed || []).find(function(e1) {
                        return e1.name === t;
                    });
                    return r ? r.value.reduce(function(e1, t) {
                        var r = t.name, o = t.value;
                        return e1[r] = "stateHandle" === r ? o : n[r], e1;
                    }, {}) : ((0, y.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
                }
                function oe(e1, t) {
                    var n = t.useGenericRemediator, r = t.remediators;
                    if (e1) return n ? V : r[e1.name];
                }
                function ie(e1, t, n) {
                    var r, o = n.remediators, i = n.useGenericRemediator;
                    if (!n.step) {
                        var a = [];
                        if (i) a.push(new V(e1[0], t, n));
                        else {
                            var u, c = z(e1);
                            try {
                                for(c.s(); !(u = c.n()).done;){
                                    var s = u.value;
                                    if (Object.keys(o).includes(s.name)) {
                                        if ((r = new (oe(s, n))(s, t, n)).canRemediate()) return r;
                                        a.push(r);
                                    }
                                }
                            } catch (e1) {
                                c.e(e1);
                            } finally{
                                c.f();
                            }
                        }
                        return a[0];
                    }
                    var f = e1.find(function(e1) {
                        return e1.name === n.step;
                    });
                    if (f) {
                        var l = oe(f, n);
                        return l ? new l(f, t, n) : void 0;
                    }
                    (0, y.ZK)('step "'.concat(n.step, '" did not match any remediations'));
                }
                function ae(e1, t, n) {
                    var r = t.getNextStep(e1, n.context), o = function(e1) {
                        return e1.neededToProceed.some(function(e1) {
                            return "skip" === e1.name;
                        });
                    }(n), i = function(e1) {
                        return Object.keys(e1.actions).some(function(e1) {
                            return e1.includes("resend");
                        });
                    }(n);
                    return Q(Q(Q({}, r), o && {
                        canSkip: o
                    }), i && {
                        canResend: i
                    });
                }
                function ue(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = $(t), o = ee(t, n);
                    if (r) return {
                        idxResponse: t,
                        terminal: r,
                        messages: o
                    };
                    var i = ie(t.neededToProceed, {}, n), a = i && ae(e1, i, t);
                    return Q({
                        idxResponse: t,
                        messages: o
                    }, a && {
                        nextStep: a
                    });
                }
                function ce(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return se(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? se(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function se(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function fe(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function le(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? fe(Object(n), !0).forEach(function(t) {
                            (0, i.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : fe(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function pe(e1, t) {
                    return Object.keys(t.actions).find(function(t) {
                        return !!e1.resend && t.includes("-resend");
                    });
                }
                function he(e1) {
                    return le(le({}, e1), {}, {
                        resend: void 0
                    });
                }
                function de(e1, t) {
                    var n = e1.actions || [];
                    return n = n.filter(function(e1) {
                        return "string" == typeof e1 ? e1 !== t : e1.name !== t;
                    }), le(le({}, e1), {}, {
                        actions: n
                    });
                }
                function ve(e1, t, n, r) {
                    return ye.apply(this, arguments);
                }
                function ye() {
                    return (ye = (0, o.Z)(u().mark(function e1(t, n, r, o) {
                        var i, a, c, s, h, d, v, y, g, m, b, w, k, O, T, Z, E, S;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (a = (i = n).neededToProceed, c = i.interactionCode, s = o.flow, !c) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 4:
                                    if (h = ie(a, r, o), d = pe(r, n), v = o.actions || [], !(y = [].concat((0, l.Z)(v), (0, l.Z)(d && [
                                        d
                                    ] || [])))) {
                                        e1.next = 28;
                                        break;
                                    }
                                    g = ce(y), e1.prev = 10, b = u().mark(function e1() {
                                        var i, c, s, f;
                                        return u().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (i = m.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = he(r), f = de(o, i), "function" != typeof n.actions[i]) {
                                                        e1.next = 14;
                                                        break;
                                                    }
                                                    return e1.next = 8, n.actions[i](c);
                                                case 8:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: ue(t, n, o)
                                                    });
                                                case 11:
                                                    if ("cancel" !== i) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: {
                                                            idxResponse: n,
                                                            canceled: !0
                                                        }
                                                    });
                                                case 13:
                                                    return e1.abrupt("return", {
                                                        v: ve(t, n, s, f)
                                                    });
                                                case 14:
                                                    if (!a.find(function(e1) {
                                                        return e1.name === i;
                                                    })) {
                                                        e1.next = 22;
                                                        break;
                                                    }
                                                    return e1.next = 18, n.proceed(i, c);
                                                case 18:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: ue(t, n, o)
                                                    });
                                                case 21:
                                                    return e1.abrupt("return", {
                                                        v: ve(t, n, r, f)
                                                    });
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }), g.s();
                                case 13:
                                    if ((m = g.n()).done) {
                                        e1.next = 20;
                                        break;
                                    }
                                    return e1.delegateYield(b(), "t0", 15);
                                case 15:
                                    if (w = e1.t0, "object" !== (0, f.Z)(w)) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.abrupt("return", w.v);
                                case 18:
                                    e1.next = 13;
                                    break;
                                case 20:
                                    e1.next = 25;
                                    break;
                                case 22:
                                    e1.prev = 22, e1.t1 = e1.catch(10), g.e(e1.t1);
                                case 25:
                                    return e1.prev = 25, g.f(), e1.finish(25);
                                case 28:
                                    if (!(k = $(n))) {
                                        e1.next = 31;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n,
                                        terminal: k
                                    });
                                case 31:
                                    if (h) {
                                        e1.next = 43;
                                        break;
                                    }
                                    if (!o.step) {
                                        e1.next = 40;
                                        break;
                                    }
                                    return r = re(n, o.step, r), e1.next = 36, n.proceed(o.step, r);
                                case 36:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 39;
                                        break;
                                    }
                                    return e1.abrupt("return", ue(t, n, o));
                                case 39:
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 40:
                                    if ("default" !== s) {
                                        e1.next = 42;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 42:
                                    throw new p.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(a.reduce(function(e1, t) {
                                        return e1 ? e1 + " ," + t.name : t.name;
                                    }, ""), "]\n    "));
                                case 43:
                                    if (h.canRemediate()) {
                                        e1.next = 46;
                                        break;
                                    }
                                    return O = ae(t, h, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: O
                                    });
                                case 46:
                                    return T = h.getName(), Z = h.getData(), e1.next = 50, n.proceed(T, Z);
                                case 50:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 53;
                                        break;
                                    }
                                    return e1.abrupt("return", ue(t, n, o));
                                case 53:
                                    if (r = h.getValuesAfterProceed(), !(o = le(le({}, o), {}, {
                                        step: void 0
                                    })).useGenericRemediator || n.interactionCode || $(n)) {
                                        e1.next = 59;
                                        break;
                                    }
                                    return E = ie(n.neededToProceed, r, o), S = ae(t, E, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: S
                                    });
                                case 59:
                                    return e1.abrupt("return", ve(t, n, r, o));
                                case 60:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                22,
                                25,
                                28
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                var ge = n(7738), me = n(2620);
                function be(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function we(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? be(Object(n), !0).forEach(function(t) {
                            (0, i.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function ke(e1) {
                    var t = we({}, e1);
                    return [
                        "flow",
                        "remediators",
                        "actions",
                        "withCredentials",
                        "step",
                        "useGenericRemediator",
                        "exchangeCodeForTokens"
                    ].forEach(function(e1) {
                        delete t[e1];
                    }), t;
                }
                function Oe(e1, t) {
                    var n = t.options, r = n = we(we({}, e1.options.idx), n), o = r.flow, i = r.withCredentials, a = r.remediators, u = r.actions, c = q.Qd.PENDING;
                    o = o || e1.idx.getFlow() || "default";
                    e1.idx.setFlow(o);
                    var s = (0, ge.s)(e1, o);
                    i = void 0 !== i ? i : s.withCredentials, a = a || s.remediators, u = u || s.actions;
                    return we(we({}, t), {}, {
                        options: we(we({}, n), {}, {
                            flow: o,
                            withCredentials: i,
                            remediators: a,
                            actions: u
                        }),
                        status: c
                    });
                }
                function Te(e1, t) {
                    return Ze.apply(this, arguments);
                }
                function Ze() {
                    return (Ze = (0, o.Z)(u().mark(function e1(t, n) {
                        var r, o, i, a, f, l, p, h, d, v, y, g, m, b, w, k;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, a = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, h = r.activationToken, d = r.maxAge, v = r.acrValues, y = r.nonce, m = (0, me.uN)(t, {
                                        state: f,
                                        recoveryToken: p,
                                        activationToken: h
                                    }), !o) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 6, (0, s.L)(t, {
                                        withCredentials: i,
                                        version: a,
                                        stateHandle: o
                                    });
                                case 6:
                                    g = e1.sent, e1.next = 20;
                                    break;
                                case 9:
                                    if (w = null === (b = m) || void 0 === b ? void 0 : b.interactionHandle) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return t.transactionManager.clear(), e1.next = 14, (0, c.E)(t, {
                                        withCredentials: i,
                                        state: f,
                                        scopes: l,
                                        activationToken: h,
                                        recoveryToken: p,
                                        maxAge: d,
                                        acrValues: v,
                                        nonce: y
                                    });
                                case 14:
                                    k = e1.sent, w = k.interactionHandle, m = k.meta;
                                case 17:
                                    return e1.next = 19, (0, s.L)(t, {
                                        withCredentials: i,
                                        version: a,
                                        interactionHandle: w
                                    });
                                case 19:
                                    g = e1.sent;
                                case 20:
                                    return e1.abrupt("return", we(we({}, n), {}, {
                                        idxResponse: g,
                                        meta: m
                                    }));
                                case 21:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function Ee(e1, t) {
                    return Se.apply(this, arguments);
                }
                function Se() {
                    return (Se = (0, o.Z)(u().mark(function e1(t, n) {
                        var r, o, i, a, c, s, f, l, p, h, d, v, y;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.idxResponse, o = n.options, i = n.values, a = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== a && (c || s || l)) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return i = we(we({}, i), {}, {
                                        stateHandle: r.rawIdxState.stateHandle
                                    }), e1.next = 8, ve(t, r, i, {
                                        remediators: c,
                                        actions: s,
                                        flow: f,
                                        step: l,
                                        useGenericRemediator: p
                                    });
                                case 8:
                                    return h = e1.sent, d = h.idxResponse, v = h.nextStep, y = h.canceled, r = d, e1.abrupt("return", we(we({}, n), {}, {
                                        idxResponse: r,
                                        nextStep: v,
                                        canceled: y
                                    }));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function xe(e1, t) {
                    return Pe.apply(this, arguments);
                }
                function Pe() {
                    return (Pe = (0, o.Z)(u().mark(function e1(t, n) {
                        var r, o, i, a, c, s, f, l, p, h, d;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (a = r).clientId, s = a.codeVerifier, f = a.ignoreSignature, l = a.redirectUri, p = a.urls, h = a.scopes, e1.next = 5, t.token.exchangeCodeForTokens({
                                        interactionCode: i,
                                        clientId: c,
                                        codeVerifier: s,
                                        ignoreSignature: f,
                                        redirectUri: l,
                                        scopes: h
                                    }, p);
                                case 5:
                                    return d = e1.sent, e1.abrupt("return", d.tokens);
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function Ae(e1, t) {
                    return _e.apply(this, arguments);
                }
                function _e() {
                    return (_e = (0, o.Z)(u().mark(function e1(t, n) {
                        var r, o, i, a, c, s, f, l, p, h, d, v, y, g, m, b;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = n.idxResponse, i = n.canceled, a = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), d = te(o), v = ne(t, o, r.useGenericRemediator), y = ee(o, r), g = $(o)), !g) {
                                        e1.next = 15;
                                        break;
                                    }
                                    a = q.Qd.TERMINAL, m = Object.keys(o.actions).length > 0, b = !!y.find(function(e1) {
                                        return "ERROR" === e1.class;
                                    }), m || b || !0 !== o.requestDidSucceed ? s = !!m : f = !0, l = !1, e1.next = 32;
                                    break;
                                case 15:
                                    if (!i) {
                                        e1.next = 20;
                                        break;
                                    }
                                    a = q.Qd.CANCELED, f = !0, e1.next = 32;
                                    break;
                                case 20:
                                    if (null == o || !o.interactionCode) {
                                        e1.next = 32;
                                        break;
                                    }
                                    if (p = o.interactionCode, !1 !== c) {
                                        e1.next = 27;
                                        break;
                                    }
                                    a = q.Qd.SUCCESS, f = !1, e1.next = 32;
                                    break;
                                case 27:
                                    return e1.next = 29, xe(t, n);
                                case 29:
                                    h = e1.sent, a = q.Qd.SUCCESS, f = !0;
                                case 32:
                                    return e1.abrupt("return", we(we({}, n), {}, {
                                        status: a,
                                        interactionCode: p,
                                        tokens: h,
                                        shouldSaveResponse: s,
                                        shouldClearTransaction: f,
                                        clearSharedStorage: l,
                                        enabledFeatures: d,
                                        availableSteps: v,
                                        messages: y,
                                        terminal: g
                                    }));
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function Re(e1) {
                    return je.apply(this, arguments);
                }
                function je() {
                    return je = (0, o.Z)(u().mark(function e1(t) {
                        var n, r, o, i, a, c, s, f, l, p, h, d, v, y, g, m, b, w, k, O, T, Z, E, S, x, P, A, _, R = arguments;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = R.length > 1 && void 0 !== R[1] ? R[1] : {}, r = {
                                        options: n,
                                        values: ke(n)
                                    }, r = Oe(t, r), e1.next = 5, Te(t, r);
                                case 5:
                                    return r = e1.sent, e1.next = 8, Ee(t, r);
                                case 8:
                                    return r = e1.sent, e1.next = 11, Ae(t, r);
                                case 11:
                                    return r = e1.sent, i = (o = r).idxResponse, a = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, h = o.availableSteps, d = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                                        clearSharedStorage: f
                                    }) : ((0, me.r0)(t, we({}, a)), c && (k = (w = i).rawIdxState, O = w.requestDidSucceed, t.transactionManager.saveIdxResponse({
                                        rawIdxResponse: k,
                                        requestDidSucceed: O,
                                        stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                                        interactionHandle: null == a ? void 0 : a.interactionHandle
                                    }))), Z = (T = i || {}).actions, E = T.context, S = T.neededToProceed, x = T.proceed, P = T.rawIdxState, A = T.requestDidSucceed, _ = T.stepUp, e1.abrupt("return", we(we(we(we(we(we(we(we(we({
                                        status: l
                                    }, a && {
                                        meta: a
                                    }), p && {
                                        enabledFeatures: p
                                    }), h && {
                                        availableSteps: h
                                    }), d && {
                                        tokens: d
                                    }), v && {
                                        nextStep: v
                                    }), y && y.length && {
                                        messages: y
                                    }), g && {
                                        error: g
                                    }), _ && {
                                        stepUp: _
                                    }), {}, {
                                        interactionCode: m,
                                        actions: Z,
                                        context: E,
                                        neededToProceed: S,
                                        proceed: x,
                                        rawIdxState: P,
                                        requestDidSucceed: A
                                    }));
                                case 16:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), je.apply(this, arguments);
                }
            },
            2473: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return l = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e1.abrupt("return", (0, u.K)(t, s({
                                        exchangeCodeForTokens: !1
                                    }, n)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), l.apply(this, arguments);
                }
            },
            4143: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5763), s = n(1971), f = n(2647), l = n(415), p = n(146), h = n(9123);
                function d() {
                    return function(e1) {
                        (0, i.Z)(d, e1);
                        var t, n, f = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function d(e1, t, n) {
                            return (0, r.Z)(this, d), f.call(this, e1, t, n);
                        }
                        return (0, o.Z)(d, [
                            {
                                key: "getIdxResponseStorage",
                                value: function(e1) {
                                    var t;
                                    if ((0, l.isBrowser)()) try {
                                        t = this.storageUtil.getStorageByType("memory", e1);
                                    } catch (e1) {
                                        (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                                    }
                                    else {
                                        var n = this.getTransactionStorage(e1);
                                        n && (t = {
                                            getItem: function(e1) {
                                                var t = n.getStorage();
                                                return t && t[e1] ? t[e1] : null;
                                            },
                                            setItem: function(e1, t) {
                                                var r = n.getStorage();
                                                if (!r) throw new h.Z("Transaction has been cleared, failed to save idxState");
                                                r[e1] = t, n.setStorage(r);
                                            },
                                            removeItem: function(e1) {
                                                var t = n.getStorage();
                                                t && (delete t[e1], n.setStorage(t));
                                            }
                                        });
                                    }
                                    return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                                }
                            }
                        ]), d;
                    }((0, f.a)());
                }
            },
            2620: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $0: function() {
                        return d;
                    },
                    Co: function() {
                        return y;
                    },
                    Jm: function() {
                        return b;
                    },
                    UC: function() {
                        return O;
                    },
                    Wf: function() {
                        return w;
                    },
                    Xc: function() {
                        return p;
                    },
                    bl: function() {
                        return k;
                    },
                    r0: function() {
                        return m;
                    },
                    uN: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3193), c = n(146), s = n(2865);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, f, p, h, d, v, y, g, m, b, w, k, O = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e1.next = 3, t.token.prepareTokenParams(n);
                                case 3:
                                    return r = e1.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, h = i.activationToken, d = void 0 === h ? void 0 : h, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, w = void 0 === b ? void 0 : b, k = l(l({}, o), {}, {
                                        flow: c,
                                        withCredentials: p,
                                        activationToken: d,
                                        recoveryToken: y,
                                        maxAge: m,
                                        acrValues: w
                                    }), e1.abrupt("return", k);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), h.apply(this, arguments);
                }
                function d(e1, t) {
                    var n = v(e1, t);
                    return !(null == n || !n.interactionHandle);
                }
                function v(e1, t) {
                    var n;
                    t = (0, u.YY)(t), t = l(l({}, e1.options), t);
                    try {
                        n = e1.transactionManager.load(t);
                    } catch (e1) {}
                    if (n) return w(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                }
                function y(e1, t) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n) {
                        var r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", r);
                                case 5:
                                    return e1.abrupt("return", p(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function m(e1, t) {
                    e1.transactionManager.save(t, {
                        muteWarning: !0
                    });
                }
                function b(e1) {
                    e1.transactionManager.clear();
                }
                function w(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [
                        "issuer",
                        "clientId",
                        "redirectUri",
                        "state",
                        "codeChallenge",
                        "codeChallengeMethod",
                        "activationToken",
                        "recoveryToken"
                    ];
                    if (!1 === O(e1, t, n)) return !1;
                    var r = t.flow;
                    return !1 !== k(e1, r);
                }
                function k(e1, t) {
                    return !(t && "default" !== t && "proceed" !== t) || t === e1.flow;
                }
                function O(e1, t, n) {
                    return !n.some(function(n) {
                        var r = t[n];
                        if (r && r !== e1[n]) return !0;
                    });
                }
            },
            7595: function(e1, t, n) {
                "use strict";
                var r, o, i;
                function a(e1) {
                    return e1 && (e1.key || e1.id);
                }
                n.d(t, {
                    Fw: function() {
                        return i;
                    },
                    H: function() {
                        return a;
                    },
                    Qd: function() {
                        return r;
                    },
                    pc: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.SUCCESS = "SUCCESS", e1.PENDING = "PENDING", e1.FAILURE = "FAILURE", e1.TERMINAL = "TERMINAL", e1.CANCELED = "CANCELED";
                }(r || (r = {})), function(e1) {
                    e1.OKTA_PASSWORD = "okta_password", e1.OKTA_EMAIL = "okta_email", e1.PHONE_NUMBER = "phone_number", e1.GOOGLE_AUTHENTICATOR = "google_otp", e1.SECURITY_QUESTION = "security_question", e1.OKTA_VERIFY = "okta_verify", e1.WEBAUTHN = "webauthn";
                }(o || (o = {})), function(e1) {
                    e1.PASSWORD_RECOVERY = "recover-password", e1.REGISTRATION = "enroll-profile", e1.SOCIAL_IDP = "redirect-idp", e1.ACCOUNT_UNLOCK = "unlock-account";
                }(i || (i = {}));
            },
            480: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return e1 && e1.version;
                }
                n.d(t, {
                    P: function() {
                        return r;
                    }
                });
            },
            8277: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    l: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(5832), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.Y)(t, h(h({}, n), {}, {
                                        autoRemediate: !1
                                    }));
                                case 5:
                                    if (r = e1.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                                case 9:
                                    return e1.abrupt("return", (0, u.K)(t, h({}, n)));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            5878: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    addEmail: function() {
                        return b;
                    },
                    addPhone: function() {
                        return S;
                    },
                    deleteEmail: function() {
                        return w;
                    },
                    deletePassword: function() {
                        return C;
                    },
                    deletePhone: function() {
                        return x;
                    },
                    enrollPassword: function() {
                        return R;
                    },
                    getEmail: function() {
                        return m;
                    },
                    getEmailChallenge: function() {
                        return O;
                    },
                    getEmails: function() {
                        return g;
                    },
                    getPassword: function() {
                        return _;
                    },
                    getPhone: function() {
                        return E;
                    },
                    getPhones: function() {
                        return Z;
                    },
                    getProfile: function() {
                        return d;
                    },
                    getProfileSchema: function() {
                        return y;
                    },
                    sendEmailChallenge: function() {
                        return k;
                    },
                    sendPhoneChallenge: function() {
                        return P;
                    },
                    updatePassword: function() {
                        return j;
                    },
                    updateProfile: function() {
                        return v;
                    },
                    verifyEmailChallenge: function() {
                        return T;
                    },
                    verifyPhoneChallenge: function() {
                        return A;
                    }
                });
                var r, o, i, a, u, c, s, f = n(5861), l = n(4687), p = n.n(l), h = n(777), d = (r = (0, f.Z)(p().mark(function e1(t, n) {
                    var r;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, (0, h.w)(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken,
                                    transactionClassName: "ProfileTransaction"
                                });
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return r.apply(this, arguments);
                }), v = (o = (0, f.Z)(p().mark(function e1(t, n) {
                    var r, o, i, a;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).payload, i = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "PUT",
                                    payload: o,
                                    accessToken: i,
                                    transactionClassName: "ProfileTransaction"
                                });
                            case 3:
                                return a = e1.sent, e1.abrupt("return", a);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return o.apply(this, arguments);
                }), y = (i = (0, f.Z)(p().mark(function e1(t, n) {
                    var r;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, (0, h.w)(t, {
                                    url: "/idp/myaccount/profile/schema",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken,
                                    transactionClassName: "ProfileSchemaTransaction"
                                });
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return i.apply(this, arguments);
                }), g = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, (0, h.w)(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken,
                                        transactionClassName: "EmailTransaction"
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), m = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, i = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/emails/".concat(o),
                                        method: "GET",
                                        accessToken: i,
                                        transactionClassName: "EmailTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), b = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.payload, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "POST",
                                        payload: i,
                                        accessToken: o,
                                        transactionClassName: "EmailTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), w = (a = (0, f.Z)(p().mark(function e1(t, n) {
                    var r, o, i, a;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, i = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                    url: "/idp/myaccount/emails/".concat(o),
                                    method: "DELETE",
                                    accessToken: i
                                });
                            case 3:
                                return a = e1.sent, e1.abrupt("return", a);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return a.apply(this, arguments);
                }), k = (u = (0, f.Z)(p().mark(function e1(t, n) {
                    var r, o, i, a;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, i = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                                    method: "POST",
                                    accessToken: i,
                                    transactionClassName: "EmailChallengeTransaction"
                                });
                            case 3:
                                return a = e1.sent, e1.abrupt("return", a);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return u.apply(this, arguments);
                }), O = (c = (0, f.Z)(p().mark(function e1(t, n) {
                    var r, o, i, a, u;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, i = r.challengeId, a = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(i),
                                    method: "POST",
                                    accessToken: a,
                                    transactionClassName: "EmailChallengeTransaction"
                                });
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return c.apply(this, arguments);
                }), T = (s = (0, f.Z)(p().mark(function e1(t, n) {
                    var r, o, i, a, u, c;
                    return p().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, i = r.challengeId, a = r.payload, u = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(i, "/verify"),
                                    method: "POST",
                                    payload: a,
                                    accessToken: u
                                });
                            case 3:
                                return c = e1.sent, e1.abrupt("return", c);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return s.apply(this, arguments);
                }), Z = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken,
                                        transactionClassName: "PhoneTransaction"
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), E = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.id, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones/".concat(i),
                                        method: "GET",
                                        accessToken: o,
                                        transactionClassName: "PhoneTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), S = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.payload, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "POST",
                                        payload: i,
                                        accessToken: o,
                                        transactionClassName: "PhoneTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), x = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, i = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones/".concat(o),
                                        method: "DELETE",
                                        accessToken: i
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), P = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a, u;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.id, a = r.payload, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones/".concat(i, "/challenge"),
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), A = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a, u;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, i = r.payload, a = r.accessToken, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                                        method: "POST",
                                        payload: i,
                                        accessToken: a
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), _ = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, (0, h.w)(t, {
                                        url: "/idp/myaccount/password",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken,
                                        transactionClassName: "PasswordTransaction"
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), R = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.payload, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/password",
                                        method: "POST",
                                        payload: i,
                                        accessToken: o,
                                        transactionClassName: "PasswordTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), j = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r, o, i, a;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, i = r.payload, e1.next = 3, (0, h.w)(t, {
                                        url: "/idp/myaccount/password",
                                        method: "PUT",
                                        payload: i,
                                        accessToken: o,
                                        transactionClassName: "PasswordTransaction"
                                    });
                                case 3:
                                    return a = e1.sent, e1.abrupt("return", a);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), C = function() {
                    var e1 = (0, f.Z)(p().mark(function e1(t, n) {
                        var r;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, (0, h.w)(t, {
                                        url: "/idp/myaccount/password",
                                        method: "DELETE",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }();
            },
            1132: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    mV: function() {
                        return u.mV;
                    },
                    nh: function() {
                        return u.nh;
                    },
                    aw: function() {
                        return u.aw;
                    },
                    XC: function() {
                        return u.XC;
                    },
                    yB: function() {
                        return u.yB;
                    },
                    Fn: function() {
                        return u.Fn;
                    },
                    QU: function() {
                        return u.QU;
                    },
                    $N: function() {
                        return u.$N;
                    },
                    XW: function() {
                        return u.XW;
                    },
                    Sx: function() {
                        return u.Sx;
                    },
                    qb: function() {
                        return u.qb;
                    },
                    no: function() {
                        return r.addEmail;
                    },
                    Z1: function() {
                        return r.addPhone;
                    },
                    Xc: function() {
                        return a;
                    },
                    nd: function() {
                        return r.deleteEmail;
                    },
                    QN: function() {
                        return r.deletePassword;
                    },
                    qj: function() {
                        return r.deletePhone;
                    },
                    xg: function() {
                        return r.enrollPassword;
                    },
                    OD: function() {
                        return r.getEmail;
                    },
                    hG: function() {
                        return r.getEmailChallenge;
                    },
                    G5: function() {
                        return r.getEmails;
                    },
                    Ij: function() {
                        return r.getPassword;
                    },
                    u_: function() {
                        return r.getPhone;
                    },
                    Po: function() {
                        return r.getPhones;
                    },
                    Ai: function() {
                        return r.getProfile;
                    },
                    aF: function() {
                        return r.getProfileSchema;
                    },
                    HT: function() {
                        return i.H;
                    },
                    ME: function() {
                        return r.sendEmailChallenge;
                    },
                    dv: function() {
                        return r.sendPhoneChallenge;
                    },
                    gQ: function() {
                        return r.updatePassword;
                    },
                    ck: function() {
                        return r.updateProfile;
                    },
                    T8: function() {
                        return r.verifyEmailChallenge;
                    },
                    Lo: function() {
                        return r.verifyPhoneChallenge;
                    }
                });
                var r = n(5878), o = n(1578), i = n(6794);
                function a(e1, t, n) {
                    var r = (0, o.K)(e1, t, n);
                    return (0, i.H)(r);
                }
                var u = n(8008);
            },
            6794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return p;
                    }
                });
                var r = n(885), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(5878);
                function p(e1) {
                    return function(e1) {
                        (0, u.Z)(h, e1);
                        var t, n, p = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function h() {
                            var e1;
                            (0, i.Z)(this, h);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "myaccount", void 0), e1.myaccount = Object.entries(l).filter(function(e1) {
                                return "default" !== (0, r.Z)(e1, 1)[0];
                            }).reduce(function(t, n) {
                                var o = (0, r.Z)(n, 2), i = o[0], u = o[1];
                                return t[i] = u.bind(null, (0, a.Z)(e1)), t;
                            }, {}), e1;
                        }
                        return (0, o.Z)(h);
                    }(e1);
                }
            },
            777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return O;
                    },
                    w: function() {
                        return w;
                    }
                });
                var r = n(4942), o = n(1002), i = n(5861), a = n(4687), u = n.n(a), c = n(8261), s = n(9953), f = n(4454), l = n(5708), p = n(8399), h = n(3082), d = n(3746), v = n(3395), y = n(5385), g = n(9123);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function w(e1, t) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, i.Z)(u().mark(function e1(t, n) {
                        var r, o, i, a, m, w, k, O, T, Z, E;
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.tokenManager.getTokensSync(), o = r.accessToken, i = n.accessToken || (null == o ? void 0 : o.accessToken), a = t.options.issuer, m = n.url, w = n.method, k = n.payload, O = m.startsWith(a) ? m : "".concat(a).concat(m), i) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new g.Z("AccessToken is required to request MyAccount API endpoints.");
                                case 7:
                                    return e1.next = 9, (0, y.c3)(t, b({
                                        headers: {
                                            Accept: "*/*;okta-version=1.0.0"
                                        },
                                        accessToken: i,
                                        url: O,
                                        method: w
                                    }, k && {
                                        args: k
                                    }));
                                case 9:
                                    if (T = e1.sent, Z = {
                                        EmailTransaction: c.Z,
                                        EmailStatusTransaction: s.Z,
                                        EmailChallengeTransaction: f.Z,
                                        ProfileTransaction: l.Z,
                                        ProfileSchemaTransaction: p.Z,
                                        PhoneTransaction: h.Z,
                                        PasswordTransaction: d.Z
                                    }, E = Z[n.transactionClassName] || v.Z, !Array.isArray(T)) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.abrupt("return", T.map(function(e1) {
                                        return new E(t, {
                                            res: e1,
                                            accessToken: i
                                        });
                                    }));
                                case 14:
                                    return e1.abrupt("return", new E(t, {
                                        res: T,
                                        accessToken: i
                                    }));
                                case 15:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function O(e1) {
                    for(var t = e1.oktaAuth, n = e1.accessToken, r = e1.methodName, a = e1.links, c = e1.transactionClassName, s = function() {
                        var e1, o = l[f];
                        if (o.toLowerCase() === r) {
                            var s = a.self;
                            return {
                                v: (e1 = (0, i.Z)(u().mark(function e1(r) {
                                    return u().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", w(t, {
                                                    accessToken: n,
                                                    url: s.href,
                                                    method: o,
                                                    payload: r,
                                                    transactionClassName: c
                                                }));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                })), function(t) {
                                    return e1.apply(this, arguments);
                                })
                            };
                        }
                    }, f = 0, l = [
                        "GET",
                        "POST",
                        "PUT",
                        "DELETE"
                    ]; f < l.length; f++){
                        var p = s();
                        if ("object" === (0, o.Z)(p)) return p.v;
                    }
                    var h, d = a[r];
                    if (!d) throw new g.Z("No link is found with methodName: ".concat(r));
                    return h = (0, i.Z)(u().mark(function e1(r) {
                        return u().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", w(t, {
                                        accessToken: n,
                                        url: d.href,
                                        method: d.hints.allow[0],
                                        payload: r,
                                        transactionClassName: c
                                    }));
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), function(e1) {
                        return h.apply(this, arguments);
                    };
                }
            },
            3395: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(4925), o = n(3144), i = n(5671), a = n(4942), u = [
                    "headers"
                ], c = (0, o.Z)(function e1(t, n) {
                    var o = this;
                    (0, i.Z)(this, e1), (0, a.Z)(this, "headers", void 0);
                    var c = n.res, s = c.headers, f = (0, r.Z)(c, u);
                    s && (this.headers = s), Object.keys(f).forEach(function(e1) {
                        "_links" !== e1 && (o[e1] = f[e1]);
                    });
                });
            },
            4454: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return v;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(3395), d = n(777);
                var v = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1, t) {
                        var n;
                        (0, i.Z)(this, h), n = l.call(this, e1, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "expiresAt", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "poll", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
                        var o, u = t.accessToken, c = t.res, s = c.id, v = c.expiresAt, y = c.profile, g = c.status, m = c._links;
                        return n.id = s, n.expiresAt = v, n.profile = y, n.status = g, n.poll = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "poll",
                                            links: m,
                                            transactionClassName: "EmailStatusTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.verify = (o = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "verify",
                                            links: m
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return o.apply(this, arguments);
                        }), n;
                    }
                    return (0, o.Z)(h);
                }(h.Z);
            },
            9953: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        (0, o.Z)(this, l), n = f.call(this, e1, t), (0, s.Z)((0, i.Z)(n), "id", void 0), (0, s.Z)((0, i.Z)(n), "expiresAt", void 0), (0, s.Z)((0, i.Z)(n), "profile", void 0), (0, s.Z)((0, i.Z)(n), "status", void 0);
                        var r = t.res, a = r.id, u = r.profile, c = r.expiresAt, p = r.status;
                        return n.id = a, n.expiresAt = c, n.profile = u, n.status = p, n;
                    }
                    return (0, r.Z)(l);
                }(n(3395).Z);
            },
            8261: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return v;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(3395), d = n(777);
                var v = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1, t) {
                        var n;
                        (0, i.Z)(this, h), n = l.call(this, e1, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "roles", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0), (0, f.Z)((0, a.Z)(n), "challenge", void 0), (0, f.Z)((0, a.Z)(n), "poll", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
                        var o, u = t.accessToken, c = t.res, s = c.id, v = c.profile, y = c.roles, g = c.status, m = c._links;
                        return n.id = s, n.profile = v, n.roles = y, n.status = g, n.get = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "get",
                                            links: m,
                                            transactionClassName: "EmailTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "delete",
                                            links: m
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "challenge",
                                            links: m,
                                            transactionClassName: "EmailChallengeTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), m.poll && (n.poll = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "poll",
                                            links: m,
                                            transactionClassName: "EmailStatusTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), m.verify && (n.verify = (o = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: u,
                                            methodName: "verify",
                                            links: m
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return o.apply(this, arguments);
                        })), n;
                    }
                    return (0, o.Z)(h);
                }(h.Z);
            },
            3746: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(8008), d = n(3395), v = n(777);
                var y = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1, t) {
                        var n;
                        (0, i.Z)(this, d), n = l.call(this, e1, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "created", void 0), (0, f.Z)((0, a.Z)(n), "lastUpdated", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "enroll", void 0), (0, f.Z)((0, a.Z)(n), "update", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0);
                        var o, u, c = t.res, s = t.accessToken, y = c.id, g = c.status, m = c.created, b = c.lastUpdated, w = c._links;
                        return n.id = y, n.status = g, n.created = m, n.lastUpdated = b, n.status == h.Fn.NOT_ENROLLED ? n.enroll = (u = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, v.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "enroll",
                                            links: w,
                                            transactionClassName: "PasswordTransaction"
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return u.apply(this, arguments);
                        }) : (n.get = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, v.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: w,
                                            transactionClassName: "PasswordTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.update = (o = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, v.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "put",
                                            links: w,
                                            transactionClassName: "PasswordTransaction"
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return o.apply(this, arguments);
                        }), n.delete = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, v.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: w
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), n;
                    }
                    return (0, o.Z)(d);
                }(d.Z);
            },
            3082: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return v;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(3395), d = n(777);
                var v = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1, t) {
                        var n;
                        (0, i.Z)(this, h), n = l.call(this, e1, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0), (0, f.Z)((0, a.Z)(n), "challenge", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
                        var o, u, c = t.res, s = t.accessToken, v = c.id, y = c.profile, g = c.status, m = c._links;
                        return n.id = v, n.profile = y, n.status = g, n.get = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: m,
                                            transactionClassName: "PhoneTransaction"
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(p().mark(function t() {
                            var n;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: m
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (o = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "challenge",
                                            links: m
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return o.apply(this, arguments);
                        }), m.verify && (n.verify = (u = (0, r.Z)(p().mark(function t(n) {
                            var r;
                            return p().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = (0, d.B)({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "verify",
                                            links: m
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return u.apply(this, arguments);
                        })), n;
                    }
                    return (0, o.Z)(h);
                }(h.Z);
            },
            8399: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1, t), (0, s.Z)((0, i.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
                    }
                    return (0, r.Z)(l);
                }(n(3395).Z);
            },
            5708: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        (0, o.Z)(this, l), n = f.call(this, e1, t), (0, s.Z)((0, i.Z)(n), "createdAt", void 0), (0, s.Z)((0, i.Z)(n), "modifiedAt", void 0), (0, s.Z)((0, i.Z)(n), "profile", void 0);
                        var r = t.res, a = r.createdAt, u = r.modifiedAt, c = r.profile;
                        return n.createdAt = a, n.modifiedAt = u, n.profile = c, n;
                    }
                    return (0, r.Z)(l);
                }(n(3395).Z);
            },
            8008: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $N: function() {
                        return s.Z;
                    },
                    Fn: function() {
                        return i;
                    },
                    QU: function() {
                        return p.Z;
                    },
                    Sx: function() {
                        return f.Z;
                    },
                    XC: function() {
                        return u.Z;
                    },
                    XW: function() {
                        return l.Z;
                    },
                    aw: function() {
                        return r;
                    },
                    mV: function() {
                        return h.Z;
                    },
                    nh: function() {
                        return c.Z;
                    },
                    qb: function() {
                        return o;
                    },
                    yB: function() {
                        return a.Z;
                    }
                });
                var r, o, i, a = n(8261), u = n(9953), c = n(4454), s = n(3082), f = n(5708), l = n(8399), p = n(3746), h = n(3395);
                !function(e1) {
                    e1.PRIMARY = "PRIMARY", e1.SECONDARY = "SECONDARY";
                }(r || (r = {})), function(e1) {
                    e1.VERIFIED = "VERIFIED", e1.UNVERIFIED = "UNVERIFIED";
                }(o || (o = {})), function(e1) {
                    e1.NOT_ENROLLED = "NOT_ENROLLED", e1.ACTIVE = "ACTIVE";
                }(i || (i = {}));
            },
            2427: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return k;
                    }
                });
                var r = n(5861), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(4687), s = n.n(c), f = n(3193), l = n(9123), p = n(2482), h = n(415), d = function() {
                    function e1(t) {
                        (0, i.Z)(this, e1), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "now",
                            value: function() {
                                return (Date.now() + this.localOffset) / 1e3;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function() {
                                return new e1(0);
                            }
                        }
                    ]), e1;
                }(), v = n(7088), y = n(6488), g = n(1971);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var w = {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    clearPendingRemoveTokens: !0,
                    storage: void 0,
                    expireEarlySeconds: 30,
                    storageKey: g.TOKEN_STORAGE_NAME
                }, k = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if ((0, i.Z)(this, e1), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                        n = Object.assign({}, w, (0, f.YY)(n)), (0, h.isLocalhost)() || (n.expireEarlySeconds = w.expireEarlySeconds), this.options = n;
                        var r = (0, f.YY)({
                            storageKey: n.storageKey,
                            secure: n.secure
                        });
                        "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                            useSeparateCookies: !0
                        })), this.clock = d.create(), this.state = {
                            expireTimeouts: {},
                            renewPromise: null
                        };
                    }
                    var t, n, c;
                    return (0, a.Z)(e1, [
                        {
                            key: "on",
                            value: function(e1, t, n) {
                                n ? this.emitter.on(e1, t, n) : this.emitter.on(e1, t);
                            }
                        },
                        {
                            key: "off",
                            value: function(e1, t) {
                                t ? this.emitter.off(e1, t) : this.emitter.off(e1);
                            }
                        },
                        {
                            key: "start",
                            value: function() {
                                this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.state.started = !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return !!this.state.started;
                            }
                        },
                        {
                            key: "getOptions",
                            value: function() {
                                return (0, f.d9)(this.options);
                            }
                        },
                        {
                            key: "getExpireTime",
                            value: function(e1) {
                                var t = this.options.expireEarlySeconds || 0;
                                return e1.expiresAt - t;
                            }
                        },
                        {
                            key: "hasExpired",
                            value: function(e1) {
                                return this.getExpireTime(e1) <= this.clock.now();
                            }
                        },
                        {
                            key: "emitExpired",
                            value: function(e1, t) {
                                this.emitter.emit(v.$Y, e1, t);
                            }
                        },
                        {
                            key: "emitRenewed",
                            value: function(e1, t, n) {
                                this.emitter.emit(v.E, e1, t, n);
                            }
                        },
                        {
                            key: "emitAdded",
                            value: function(e1, t) {
                                this.emitter.emit(v.O3, e1, t);
                            }
                        },
                        {
                            key: "emitRemoved",
                            value: function(e1, t) {
                                this.emitter.emit(v.FT, e1, t);
                            }
                        },
                        {
                            key: "emitError",
                            value: function(e1) {
                                this.emitter.emit(v.$I, e1);
                            }
                        },
                        {
                            key: "clearExpireEventTimeout",
                            value: function(e1) {
                                clearTimeout(this.state.expireTimeouts[e1]), delete this.state.expireTimeouts[e1], this.state.renewPromise = null;
                            }
                        },
                        {
                            key: "clearExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.state.expireTimeouts;
                                for(var t in e1)Object.prototype.hasOwnProperty.call(e1, t) && this.clearExpireEventTimeout(t);
                            }
                        },
                        {
                            key: "setExpireEventTimeout",
                            value: function(e1, t) {
                                var n = this;
                                if (!(0, y.z9)(t)) {
                                    var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                    this.clearExpireEventTimeout(e1);
                                    var i = setTimeout(function() {
                                        n.emitExpired(e1, t);
                                    }, o);
                                    this.state.expireTimeouts[e1] = i;
                                }
                            }
                        },
                        {
                            key: "setExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.storage.getStorage();
                                for(var t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                                    var n = e1[t];
                                    this.setExpireEventTimeout(t, n);
                                }
                            }
                        },
                        {
                            key: "resetExpireEventTimeoutAll",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                var n = this.storage.getStorage();
                                (0, p.R)(t), n[e1] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e1, t), this.setExpireEventTimeout(e1, t);
                            }
                        },
                        {
                            key: "getSync",
                            value: function(e1) {
                                return this.storage.getStorage()[e1];
                            }
                        },
                        {
                            key: "get",
                            value: (c = (0, r.Z)(s().mark(function e1(t) {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getSync(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "getTokensSync",
                            value: function() {
                                var e1 = {}, t = this.storage.getStorage();
                                return Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    (0, y.hv)(r) ? e1.accessToken = r : (0, y.sI)(r) ? e1.idToken = r : (0, y.z9)(r) && (e1.refreshToken = r);
                                }), e1;
                            }
                        },
                        {
                            key: "getTokens",
                            value: (n = (0, r.Z)(s().mark(function e1() {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "getStorageKeyByType",
                            value: function(e1) {
                                var t = this.storage.getStorage();
                                return Object.keys(t).filter(function(n) {
                                    var r = t[n];
                                    return (0, y.hv)(r) && "accessToken" === e1 || (0, y.sI)(r) && "idToken" === e1 || (0, y.z9)(r) && "refreshToken" === e1;
                                })[0];
                            }
                        },
                        {
                            key: "getTokenType",
                            value: function(e1) {
                                if ((0, y.hv)(e1)) return "accessToken";
                                if ((0, y.sI)(e1)) return "idToken";
                                if ((0, y.z9)(e1)) return "refreshToken";
                                throw new l.Z("Unknown token type");
                            }
                        },
                        {
                            key: "emitSetStorageEvent",
                            value: function() {
                                if ((0, h.isIE11OrLess)()) {
                                    var e1 = this.storage.getStorage();
                                    this.emitter.emit(v.zr, e1);
                                }
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                return this.storage;
                            }
                        },
                        {
                            key: "setTokens",
                            value: function(e1, t, n, r) {
                                var o = this, i = function(e1, i) {
                                    var a = o.getTokenType(i);
                                    "accessToken" === a ? t && t(e1, i) : "idToken" === a ? n && n(e1, i) : "refreshToken" === a && r && r(e1, i);
                                }, a = function(e1, t) {
                                    o.emitAdded(e1, t), o.setExpireEventTimeout(e1, t), i(e1, t);
                                }, u = function(e1, t) {
                                    o.clearExpireEventTimeout(e1), o.emitRemoved(e1, t), i(e1, t);
                                }, c = [
                                    "idToken",
                                    "accessToken",
                                    "refreshToken"
                                ], s = this.getTokensSync();
                                c.forEach(function(t) {
                                    var n = e1[t];
                                    n && (0, p.R)(n, t);
                                });
                                var f = c.reduce(function(t, n) {
                                    var r = e1[n];
                                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                                }, {});
                                this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function(t) {
                                    var n, r, c, f = e1[t], l = s[t], p = o.getStorageKeyByType(t) || t;
                                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                this.clearExpireEventTimeout(e1);
                                var t = this.storage.getStorage(), n = t[e1];
                                delete t[e1], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e1, n);
                            }
                        },
                        {
                            key: "renewToken",
                            value: (t = (0, r.Z)(s().mark(function e1(t) {
                                var n;
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "validateToken",
                            value: function(e1) {
                                return (0, p.R)(e1);
                            }
                        },
                        {
                            key: "renew",
                            value: function(e1) {
                                var t = this;
                                if (this.state.renewPromise) return this.state.renewPromise;
                                try {
                                    var n = this.getSync(e1);
                                    if (!n) throw new l.Z("The tokenManager has no token for the key: " + e1);
                                } catch (e1) {
                                    return Promise.reject(e1);
                                }
                                return this.clearExpireEventTimeout(e1), this.state.renewPromise = this.sdk.token.renewTokens().then(function(e1) {
                                    return t.setTokens(e1), e1[t.getTokenType(n)];
                                }).catch(function(n) {
                                    throw t.remove(e1), n.tokenKey = e1, t.emitError(n), n;
                                }).finally(function() {
                                    t.state.renewPromise = null;
                                });
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = this, t = this.getTokensSync();
                                this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function(n) {
                                    e1.emitRemoved(n, t[n]);
                                });
                            }
                        },
                        {
                            key: "clearPendingRemoveTokens",
                            value: function() {
                                var e1 = this, t = this.storage.getStorage(), n = {};
                                Object.keys(t).forEach(function(e1) {
                                    t[e1].pendingRemove && (n[e1] = t[e1], delete t[e1]);
                                }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function(t) {
                                    e1.clearExpireEventTimeout(t), e1.emitRemoved(t, n[t]);
                                });
                            }
                        },
                        {
                            key: "updateRefreshToken",
                            value: function(e1) {
                                var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY, n = this.storage.getStorage();
                                (0, p.R)(e1), n[t] = e1, this.storage.setStorage(n), this.emitSetStorageEvent();
                            }
                        },
                        {
                            key: "removeRefreshToken",
                            value: function() {
                                var e1 = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                                this.remove(e1);
                            }
                        },
                        {
                            key: "addPendingRemoveFlags",
                            value: function() {
                                var e1 = this.getTokensSync();
                                Object.keys(e1).forEach(function(t) {
                                    e1[t].pendingRemove = !0;
                                }), this.setTokens(e1);
                            }
                        }
                    ]), e1;
                }();
            },
            1646: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4319), u = n(146);
                function c(e1) {
                    var t = e1.getSharedTansactionStorage(), n = t.getStorage();
                    Object.keys(n).forEach(function(e1) {
                        var t = n[e1];
                        Date.now() - t.dateCreated > 18e5 && delete n[e1];
                    }), t.setStorage(n);
                }
                function s(e1, t, n) {
                    var r = e1.getSharedTansactionStorage(), o = r.getStorage();
                    o[t] = {
                        dateCreated: Date.now(),
                        transaction: n
                    }, r.setStorage(o);
                }
                function f(e1, t) {
                    var n = e1.getSharedTansactionStorage().getStorage()[t];
                    return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                }
                function l(e1, t) {
                    var n = e1.getSharedTansactionStorage(), r = n.getStorage();
                    delete r[t], n.setStorage(r);
                }
                function p() {
                    return function() {
                        function e1(t) {
                            (0, r.Z)(this, e1), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
                        }
                        return (0, o.Z)(e1, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                                    if (t.clearStorage(), this.enableSharedStorage && !1 !== e1.clearSharedStorage) {
                                        var r = e1.state || (null == n ? void 0 : n.state);
                                        r && l(this.storageManager, r);
                                    }
                                }
                            },
                            {
                                key: "save",
                                value: function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                                    (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e1), this.enableSharedStorage && e1.state && s(this.storageManager, e1.state, e1);
                                }
                            },
                            {
                                key: "exists",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    try {
                                        var t = this.load(e1);
                                        return !!t;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    if (this.enableSharedStorage && t.state && (c(this.storageManager), e1 = f(this.storageManager, t.state), (0, a.mH)(e1))) return e1;
                                    var n = this.storageManager.getTransactionStorage();
                                    return e1 = n.getStorage(), (0, a.mH)(e1) ? e1 : null;
                                }
                            }
                        ]), e1;
                    }();
                }
            },
            1237: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(7987);
                function i(e1) {
                    var t, n = e1.split(".");
                    try {
                        t = {
                            header: JSON.parse((0, o.Wy)(n[0])),
                            payload: JSON.parse((0, o.Wy)(n[1])),
                            signature: n[2]
                        };
                    } catch (e1) {
                        throw new r.Z("Malformed token");
                    }
                    return t;
                }
            },
            2206: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return l;
                    },
                    _: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(4771), i = n(3193), a = n(6718), u = n(9123);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if ((0, o.HD)(e1.responseType) && -1 !== e1.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
                    var t = {
                        client_id: e1.clientId,
                        code_challenge: e1.codeChallenge,
                        code_challenge_method: e1.codeChallengeMethod,
                        display: e1.display,
                        idp: e1.idp,
                        idp_scope: e1.idpScope,
                        login_hint: e1.loginHint,
                        max_age: e1.maxAge,
                        nonce: e1.nonce,
                        prompt: e1.prompt,
                        redirect_uri: e1.redirectUri,
                        response_mode: e1.responseMode,
                        response_type: e1.responseType,
                        sessionToken: e1.sessionToken,
                        state: e1.state,
                        acr_values: e1.acrValues,
                        enroll_amr_values: e1.enrollAmrValues
                    };
                    if (t = (0, i.YY)(t), [
                        "idp_scope",
                        "response_type",
                        "enroll_amr_values"
                    ].forEach(function(e1) {
                        Array.isArray(t[e1]) && (t[e1] = t[e1].join(" "));
                    }), -1 !== e1.responseType.indexOf("id_token") && -1 === e1.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
                    return e1.scopes && (t.scope = e1.scopes.join(" ")), t;
                }
                function l(e1) {
                    var t = f(e1);
                    return (0, a.UK)(s(s({}, t), e1.extraParams && s({}, e1.extraParams)));
                }
            },
            2642: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Dp: function() {
                        return o.D;
                    },
                    ES: function() {
                        return i.E;
                    },
                    R0: function() {
                        return r.R;
                    },
                    _6: function() {
                        return r._;
                    },
                    km: function() {
                        return i.k;
                    },
                    ti: function() {
                        return o.t;
                    }
                });
                var r = n(2206), o = n(9231), i = n(52);
            },
            9231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return s;
                    },
                    t: function() {
                        return c;
                    }
                });
                var r = n(885), o = n(9123), i = n(3193), a = n(6718), u = n(5385);
                function c(e1, t, n) {
                    !function(e1) {
                        if (!e1.clientId) throw new o.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                        if (!e1.redirectUri) throw new o.Z("The redirectUri passed to /authorize must also be passed to /token");
                        if (!e1.authorizationCode && !e1.interactionCode) throw new o.Z("An authorization code (returned from /authorize) must be passed to /token");
                        if (!e1.codeVerifier) throw new o.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                    }(t);
                    var r = function(e1, t) {
                        var n = (0, i.YY)({
                            client_id: t.clientId,
                            redirect_uri: t.redirectUri,
                            grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                            code_verifier: t.codeVerifier
                        });
                        t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                        var r = e1.options.clientSecret;
                        return r && (n.client_secret = r), (0, a.UK)(n).slice(1);
                    }(e1, t);
                    return (0, u.c3)(e1, {
                        url: n.tokenUrl,
                        method: "POST",
                        args: r,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    });
                }
                function s(e1, t, n) {
                    return (0, u.c3)(e1, {
                        url: n.tokenUrl,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        args: Object.entries({
                            client_id: t.clientId,
                            grant_type: "refresh_token",
                            scope: n.scopes.join(" "),
                            refresh_token: n.refreshToken
                        }).map(function(e1) {
                            var t = (0, r.Z)(e1, 2), n = t[0], o = t[1];
                            return n + "=" + encodeURIComponent(o);
                        }).join("&")
                    });
                }
            },
            52: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return a;
                    },
                    k: function() {
                        return u;
                    }
                });
                var r = n(5385), o = n(3193), i = n(9123);
                function a(e1, t) {
                    var n = t || e1.options.issuer;
                    return (0, r.U2)(e1, n + "/.well-known/openid-configuration", {
                        cacheResponse: !0
                    });
                }
                function u(e1, t, n) {
                    var u = e1.storageManager.getHttpCache(e1.options.cookies);
                    return a(e1, t).then(function(t) {
                        var a = t.jwks_uri, c = u.getStorage()[a];
                        if (c && Date.now() / 1e3 < c.expiresAt) {
                            var s = (0, o.sE)(c.response.keys, {
                                kid: n
                            });
                            if (s) return s;
                        }
                        return u.clearStorage(a), (0, r.U2)(e1, a, {
                            cacheResponse: !0
                        }).then(function(e1) {
                            var t = (0, o.sE)(e1.keys, {
                                kid: n
                            });
                            if (t) return t;
                            throw new i.Z("The key id, " + n + ", was not found in the server's keys");
                        });
                    });
                }
            },
            8707: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    r: function() {
                        return c;
                    }
                });
                var r = n(7599), o = n(7756), i = n(3193), a = n(9231), u = n(8676);
                function c(e1, t, n) {
                    n = n || (0, r.Fc)(e1, t);
                    var c = t = Object.assign({}, (0, o.D)(e1), (0, i.d9)(t)), s = c.authorizationCode, f = c.interactionCode, l = c.codeVerifier, p = c.clientId, h = c.redirectUri, d = c.scopes, v = c.ignoreSignature, y = c.state, g = c.acrValues, m = {
                        clientId: p,
                        redirectUri: h,
                        authorizationCode: s,
                        interactionCode: f,
                        codeVerifier: l
                    };
                    return (0, a.t)(e1, m, n).then(function(t) {
                        var r = [
                            "token"
                        ];
                        -1 !== d.indexOf("openid") && r.push("id_token");
                        var o = {
                            clientId: p,
                            redirectUri: h,
                            scopes: d,
                            responseType: r,
                            ignoreSignature: v,
                            acrValues: g
                        };
                        return (0, u.s)(e1, o, t, n).then(function(e1) {
                            return e1.code = s, e1.state = y, e1;
                        });
                    }).finally(function() {
                        e1.transactionManager.clear();
                    });
                }
            },
            5324: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return Z;
                    },
                    o: function() {
                        return T;
                    }
                });
                var r = n(3548), o = n(1237), i = n(8707), a = n(6844), u = n(7625), c = n(9770), s = n(6803), f = n(5372), l = n(2476), p = n(6268), h = n(781), d = n(6466), v = n(6898), y = n(8221), g = n(1260), m = n(3193), b = n(6757), w = n(8080), k = n(2206);
                function O(e1, t) {
                    t = (0, m.d9)(t) || {};
                    var n = (0, b.U)(e1, t), r = (0, w.A)(e1, n), o = r.urls.authorizeUrl + (0, k.R)(n);
                    e1.transactionManager.save(r), e1.options.setLocation ? e1.options.setLocation(o) : window.location.assign(o);
                }
                function T(e1, t) {
                    var n = function(e1) {
                        return r.b.prototype.push.bind(t, e1, null);
                    }, m = n(s.H.bind(null, e1)), b = n(f.ko.bind(null, e1)), w = Object.assign(b, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), k = {
                        prepareTokenParams: v.wu.bind(null, e1),
                        exchangeCodeForTokens: i.r.bind(null, e1),
                        getWithoutPrompt: u.y.bind(null, e1),
                        getWithPopup: c.d.bind(null, e1),
                        getWithRedirect: m,
                        parseFromUrl: w,
                        decode: o.T,
                        revoke: d.P.bind(null, e1),
                        renew: l.$.bind(null, e1),
                        renewTokensWithRefresh: h.R.bind(null, e1),
                        renewTokens: p.I.bind(null, e1),
                        getUserInfo: function(t, n) {
                            return (0, a.b)(e1, t, n);
                        },
                        verify: g.W.bind(null, e1),
                        isLoginRedirect: y.gM.bind(null, e1)
                    };
                    return [
                        "getWithoutPrompt",
                        "getWithPopup",
                        "revoke",
                        "renew",
                        "renewTokensWithRefresh",
                        "renewTokens"
                    ].forEach(function(e1) {
                        k[e1] = n(k[e1]);
                    }), k;
                }
                function Z(e1) {
                    return {
                        authorize: {
                            enrollAuthenticator: O.bind(null, e1)
                        }
                    };
                }
            },
            231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $V: function() {
                        return r.$;
                    },
                    zr: function() {
                        return s;
                    },
                    o5: function() {
                        return r.o;
                    }
                });
                var r = n(5324), o = n(9893), i = n(265), a = n(3980), u = n(279), c = n(2724);
                function s(e1, t, n) {
                    var r = (0, o.a)(t), s = (0, i.H)(r, e1), f = (0, u.A)(s), l = (0, a.Z)(f);
                    return (0, c.J)(l, n);
                }
            },
            3253: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return s;
                    }
                });
                var r = n(7599), o = n(4970), i = n(9123), a = n(6898), u = n(2206), c = n(8676);
                function s(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
                    var n = (t = t || {}).popupWindow;
                    return t.popupWindow = void 0, (0, a.wu)(e1, t).then(function(a) {
                        var s, f;
                        switch(t.sessionToken ? Object.assign(a, {
                            prompt: "none",
                            responseMode: "okta_post_message",
                            display: null
                        }) : t.idp && Object.assign(a, {
                            display: "popup"
                        }), f = (0, r.Fc)(e1, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? "POPUP" : "IMPLICIT"){
                            case "IFRAME":
                                var l = (0, o.iC)(e1, t.timeout, a.state), p = (0, o.Rl)(s);
                                return l.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    var e1;
                                    document.body.contains(p) && (null === (e1 = p.parentElement) || void 0 === e1 || e1.removeChild(p));
                                });
                            case "POPUP":
                                var h;
                                if ("okta_post_message" === a.responseMode) {
                                    if (!e1.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                                    h = (0, o.iC)(e1, t.timeout, a.state);
                                }
                                return n && n.location.assign(s), new Promise(function(e1, t) {
                                    var r = setInterval(function() {
                                        n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                                    }, 100);
                                    h.then(function(t) {
                                        clearInterval(r), e1(t);
                                    }).catch(function(e1) {
                                        clearInterval(r), t(e1);
                                    });
                                }).then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    n && !n.closed && n.close();
                                });
                            default:
                                throw new i.Z("The full page redirect flow is not supported");
                        }
                    });
                }
            },
            6844: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(4771), u = n(9123), c = n(2886), s = n(5385), f = n(6488);
                function l(e1, t, n) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n, r) {
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.next = 3, t.tokenManager.getTokens();
                                case 3:
                                    n = e1.sent.accessToken;
                                case 4:
                                    if (r) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 7, t.tokenManager.getTokens();
                                case 7:
                                    r = e1.sent.idToken;
                                case 8:
                                    if (n && (0, f.hv)(n)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                                case 10:
                                    if (r && (0, f.sI)(r)) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                                case 12:
                                    return e1.abrupt("return", (0, s.c3)(t, {
                                        url: n.userinfoUrl,
                                        method: "GET",
                                        accessToken: n.accessToken
                                    }).then(function(e1) {
                                        return e1.sub === r.claims.sub ? e1 : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                                    }).catch(function(e1) {
                                        var t;
                                        if (e1.xhr && (401 === e1.xhr.status || 403 === e1.xhr.status) && (e1.xhr.headers && (0, a.mf)(e1.xhr.headers.get) && e1.xhr.headers.get("WWW-Authenticate") ? t = e1.xhr.headers.get("WWW-Authenticate") : (0, a.mf)(e1.xhr.getResponseHeader) && (t = e1.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                                            var n = t.match(/error="(.*?)"/) || [], r = t.match(/error_description="(.*?)"/) || [], o = n[1], i = r[1];
                                            o && i && (e1 = new c.Z(o, i));
                                        }
                                        throw e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9770: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    d: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253), a = n(4970);
                function u(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
                    var n = (0, a.pU)("/", t);
                    return t = (0, o.d9)(t) || {}, Object.assign(t, {
                        display: "popup",
                        responseMode: "okta_post_message",
                        popupWindow: n
                    }), (0, i.L)(e1, t);
                }
            },
            6803: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(3193), c = n(6898), s = n(2865), f = n(2206);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(p.length > 2)) {
                                        e1.next = 2;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                                case 2:
                                    return n = (0, u.d9)(n) || {}, e1.next = 5, (0, c.wu)(t, n);
                                case 5:
                                    r = e1.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7625: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    y: function() {
                        return a;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253);
                function a(e1, t) {
                    return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }), (0, i.L)(e1, t));
                }
            },
            8676: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(3193), u = n(7599), c = n(2886), s = n(9123), f = n(1260), l = n(7756);
                function p(e1, t) {
                    if (e1.error && e1.error_description) throw new c.Z(e1.error, e1.error_description);
                    if (e1.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
                }
                function h(e1, t, n, r) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r, o) {
                        var c, h, d, v, y, g, m, b, w, k, O, T, Z, E;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!1 === t.options.pkce || !r.code && !r.interaction_code) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                                        authorizationCode: r.code,
                                        interactionCode: r.interaction_code
                                    }), o));
                                case 3:
                                    if (n = n || (0, l.D)(t), o = o || (0, u.Fc)(t, n), c = n.responseType || [], Array.isArray(c) || "none" === c || (c = [
                                        c
                                    ]), h = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), d = n.clientId || t.options.clientId, p(r, n), v = {}, y = r.expires_in, g = r.token_type, m = r.access_token, b = r.id_token, w = r.refresh_token, k = Math.floor(Date.now() / 1e3), m && (O = t.token.decode(m), v.accessToken = {
                                        accessToken: m,
                                        claims: O.payload,
                                        expiresAt: Number(y) + k,
                                        tokenType: g,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        userinfoUrl: o.userinfoUrl
                                    }), w && (v.refreshToken = {
                                        refreshToken: w,
                                        expiresAt: Number(y) + k,
                                        scopes: h,
                                        tokenUrl: o.tokenUrl,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer
                                    }), !b) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return T = t.token.decode(b), Z = {
                                        idToken: b,
                                        claims: T.payload,
                                        expiresAt: T.payload.exp - T.payload.iat + k,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer,
                                        clientId: d
                                    }, E = {
                                        clientId: d,
                                        issuer: o.issuer,
                                        nonce: n.nonce,
                                        accessToken: m,
                                        acrValues: n.acrValues
                                    }, void 0 !== n.ignoreSignature && (E.ignoreSignature = n.ignoreSignature), e1.next = 26, (0, f.W)(t, Z, E);
                                case 26:
                                    v.idToken = Z;
                                case 27:
                                    if (-1 === c.indexOf("token") || v.accessToken) {
                                        e1.next = 29;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                                case 29:
                                    if (-1 === c.indexOf("id_token") || v.idToken) {
                                        e1.next = 31;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                                case 31:
                                    return e1.abrupt("return", {
                                        tokens: v,
                                        state: r.state,
                                        code: r.code,
                                        responseType: c
                                    });
                                case 32:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9443: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    TokenManager: function() {
                        return l.M;
                    },
                    addListener: function() {
                        return h.NH;
                    },
                    addPostMessageListener: function() {
                        return h.iC;
                    },
                    assertPKCESupport: function() {
                        return h.vz;
                    },
                    buildAuthorizeParams: function() {
                        return a.R0;
                    },
                    convertTokenParamsToOAuthParams: function() {
                        return a._6;
                    },
                    createEndpoints: function() {
                        return r.$V;
                    },
                    createEnrollAuthenticatorMeta: function() {
                        return h.AW;
                    },
                    createOAuthMeta: function() {
                        return h.H;
                    },
                    createOAuthOptionsConstructor: function() {
                        return u.m;
                    },
                    createOAuthStorageManager: function() {
                        return i.a;
                    },
                    createOktaAuthOAuth: function() {
                        return r.zr;
                    },
                    createTokenAPI: function() {
                        return r.o5;
                    },
                    createTransactionManager: function() {
                        return p.P;
                    },
                    decodeToken: function() {
                        return d.T;
                    },
                    exchangeCodeForTokens: function() {
                        return O.r;
                    },
                    generateNonce: function() {
                        return h.PY;
                    },
                    generateState: function() {
                        return h.aV;
                    },
                    getDefaultEnrollAuthenticatorParams: function() {
                        return h.cE;
                    },
                    getDefaultTokenParams: function() {
                        return h.Dx;
                    },
                    getHashOrSearch: function() {
                        return h.O2;
                    },
                    getKey: function() {
                        return a.km;
                    },
                    getOAuthBaseUrl: function() {
                        return h.zf;
                    },
                    getOAuthDomain: function() {
                        return h.Xp;
                    },
                    getOAuthUrls: function() {
                        return h.Fc;
                    },
                    getToken: function() {
                        return T.L;
                    },
                    getUserInfo: function() {
                        return w.b;
                    },
                    getWellKnown: function() {
                        return a.ES;
                    },
                    getWithPopup: function() {
                        return E.d;
                    },
                    getWithRedirect: function() {
                        return S.H;
                    },
                    getWithoutPrompt: function() {
                        return Z.y;
                    },
                    handleOAuthResponse: function() {
                        return k.s;
                    },
                    hasAuthorizationCode: function() {
                        return h.ZP;
                    },
                    hasErrorInUrl: function() {
                        return h.hg;
                    },
                    hasInteractionCode: function() {
                        return h.d_;
                    },
                    hasTokensInHash: function() {
                        return h.kU;
                    },
                    isAuthorizationCodeError: function() {
                        return h.tC;
                    },
                    isCodeFlow: function() {
                        return h.Ik;
                    },
                    isInteractionRequired: function() {
                        return h.wc;
                    },
                    isInteractionRequiredError: function() {
                        return h.Cf;
                    },
                    isLoginRedirect: function() {
                        return h.gM;
                    },
                    isRedirectUri: function() {
                        return h.Qs;
                    },
                    isRefreshTokenError: function() {
                        return h.Yo;
                    },
                    isRefreshTokenInvalidError: function() {
                        return h.$E;
                    },
                    isSameRefreshToken: function() {
                        return h.q0;
                    },
                    loadFrame: function() {
                        return h.Rl;
                    },
                    loadPopup: function() {
                        return h.pU;
                    },
                    mixinOAuth: function() {
                        return o.J;
                    },
                    parseFromUrl: function() {
                        return x.ko;
                    },
                    pkce: function() {
                        return h.U5;
                    },
                    postRefreshToken: function() {
                        return a.Dp;
                    },
                    postToTokenEndpoint: function() {
                        return a.ti;
                    },
                    prepareEnrollAuthenticatorParams: function() {
                        return h.Uc;
                    },
                    preparePKCE: function() {
                        return h.mi;
                    },
                    prepareTokenParams: function() {
                        return h.wu;
                    },
                    removeListener: function() {
                        return h.ys;
                    },
                    renewToken: function() {
                        return y.$;
                    },
                    renewTokens: function() {
                        return m.I;
                    },
                    renewTokensWithRefresh: function() {
                        return g.R;
                    },
                    revokeToken: function() {
                        return v.P;
                    },
                    urlParamsToObject: function() {
                        return h.vL;
                    },
                    validateClaims: function() {
                        return h.pj;
                    },
                    validateCodeChallengeMethod: function() {
                        return h.br;
                    },
                    validateToken: function() {
                        return h.Rp;
                    },
                    verifyToken: function() {
                        return b.W;
                    }
                });
                var r = n(231), o = n(2724), i = n(2333), a = n(2642), u = n(3775), c = n(8927), s = {};
                for(var f in c)[
                    "default",
                    "decodeToken",
                    "revokeToken",
                    "renewToken",
                    "renewTokensWithRefresh",
                    "renewTokens",
                    "verifyToken",
                    "getUserInfo",
                    "handleOAuthResponse",
                    "exchangeCodeForTokens",
                    "getToken",
                    "getWithoutPrompt",
                    "getWithPopup",
                    "getWithRedirect",
                    "parseFromUrl",
                    "createEndpoints",
                    "createOktaAuthOAuth",
                    "createTokenAPI",
                    "mixinOAuth",
                    "createOAuthStorageManager",
                    "buildAuthorizeParams",
                    "convertTokenParamsToOAuthParams",
                    "getKey",
                    "getWellKnown",
                    "postRefreshToken",
                    "postToTokenEndpoint",
                    "createOAuthOptionsConstructor"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(2427), p = n(1646), h = n(8785), d = n(1237), v = n(6466), y = n(2476), g = n(781), m = n(6268), b = n(1260), w = n(6844), k = n(8676), O = n(8707), T = n(3253), Z = n(7625), E = n(9770), S = n(6803), x = n(5372);
            },
            2724: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return P;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(1752), s = n(136), f = n(2963), l = n(1120), p = n(4942), h = n(4687), d = n.n(h), v = n(5385), y = n(3548), g = n(9718), m = n(3611), b = n(5324), w = n(2427), k = n(8221), O = n(7599), T = n(1971), Z = n(4858);
                var E = [
                    "originalUri"
                ];
                function S(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function x(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? S(Object(n), !0).forEach(function(t) {
                            (0, p.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function P(e1, t) {
                    var n, h = function(e1) {
                        (0, s.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, l.Z)(t);
                            if (n) {
                                var o = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function o() {
                            return (0, i.Z)(this, o), r.apply(this, arguments);
                        }
                        return (0, a.Z)(o, [
                            {
                                key: "setOriginalUri",
                                value: function(e1, t) {
                                    Z.Z.getSessionStorage().setItem(T.REFERRER_PATH_STORAGE_KEY, e1), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e1);
                                }
                            },
                            {
                                key: "getOriginalUri",
                                value: function(e1) {
                                    if (e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage().getItem(e1);
                                        if (t) return t;
                                    }
                                    var n = Z.Z.getSessionStorage();
                                    return n && n.getItem(T.REFERRER_PATH_STORAGE_KEY) || void 0;
                                }
                            },
                            {
                                key: "removeOriginalUri",
                                value: function(e1) {
                                    if (Z.Z.getSessionStorage().removeItem(T.REFERRER_PATH_STORAGE_KEY), e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage();
                                        t.removeItem && t.removeItem(e1);
                                    }
                                }
                            }
                        ]), o;
                    }(e1);
                    return n = function(e1) {
                        (0, s.Z)(C, e1);
                        var n, h, g, T, Z, S, P, A, _, R, j = (_ = C, R = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, l.Z)(_);
                            if (R) {
                                var n = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function C() {
                            var e1;
                            (0, i.Z)(this, C);
                            for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                            return e1 = j.call.apply(j, [
                                this
                            ].concat(r)), (0, p.Z)((0, u.Z)(e1), "token", void 0), (0, p.Z)((0, u.Z)(e1), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e1), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e1), "pkce", void 0), (0, p.Z)((0, u.Z)(e1), "endpoints", void 0), (0, p.Z)((0, u.Z)(e1), "_pending", void 0), (0, p.Z)((0, u.Z)(e1), "_tokenQueue", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.pkce = {
                                DEFAULT_CODE_CHALLENGE_METHOD: m.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                                generateVerifier: m.Z.generateVerifier,
                                computeChallenge: m.Z.computeChallenge
                            }, e1._pending = {
                                handleLogin: !1
                            }, e1._tokenQueue = new y.b, e1.token = (0, b.o)((0, u.Z)(e1), e1._tokenQueue), e1.tokenManager = new w.M((0, u.Z)(e1), e1.options.tokenManager), e1.endpoints = (0, b.$)((0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(C, [
                            {
                                key: "clearStorage",
                                value: function() {
                                    (0, c.Z)((0, l.Z)(C.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                                }
                            },
                            {
                                key: "isAuthenticated",
                                value: (A = (0, o.Z)(d().mark(function e1() {
                                    var t, n, r, o, i, a, u, c, s, f, l = arguments;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                                                    e1.next = 19;
                                                    break;
                                                }
                                                if (c = void 0, !i) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.prev = 8, e1.next = 11, this.tokenManager.renew("accessToken");
                                            case 11:
                                                c = e1.sent, e1.next = 16;
                                                break;
                                            case 14:
                                                e1.prev = 14, e1.t0 = e1.catch(8);
                                            case 16:
                                                e1.next = 19;
                                                break;
                                            case 18:
                                                a && this.tokenManager.remove("accessToken");
                                            case 19:
                                                if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                if (f = void 0, !i) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.prev = 23, e1.next = 26, this.tokenManager.renew("idToken");
                                            case 26:
                                                f = e1.sent, e1.next = 31;
                                                break;
                                            case 29:
                                                e1.prev = 29, e1.t1 = e1.catch(23);
                                            case 31:
                                                e1.next = 34;
                                                break;
                                            case 33:
                                                a && this.tokenManager.remove("idToken");
                                            case 34:
                                                return e1.abrupt("return", !(!c || !f));
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            8,
                                            14
                                        ],
                                        [
                                            23,
                                            29
                                        ]
                                    ]);
                                })), function() {
                                    return A.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithRedirect",
                                value: (P = (0, o.Z)(d().mark(function e1() {
                                    var t, n, o, i, a = arguments;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}, n = t.originalUri, o = (0, r.Z)(t, E), !this._pending.handleLogin) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return");
                                            case 4:
                                                return this._pending.handleLogin = !0, e1.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                                                    scopes: this.options.scopes || [
                                                        "openid",
                                                        "email",
                                                        "profile"
                                                    ]
                                                }, o), e1.next = 10, this.token.getWithRedirect(i);
                                            case 10:
                                                return e1.prev = 10, this._pending.handleLogin = !1, e1.finish(10);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            5,
                                            ,
                                            10,
                                            13
                                        ]
                                    ]);
                                })), function() {
                                    return P.apply(this, arguments);
                                })
                            },
                            {
                                key: "getUser",
                                value: (S = (0, o.Z)(d().mark(function e1() {
                                    var t, n, r;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e1.abrupt("return", this.token.getUserInfo(r, n));
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return S.apply(this, arguments);
                                })
                            },
                            {
                                key: "getIdToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().idToken;
                                    return e1 ? e1.idToken : void 0;
                                }
                            },
                            {
                                key: "getAccessToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().accessToken;
                                    return e1 ? e1.accessToken : void 0;
                                }
                            },
                            {
                                key: "getRefreshToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().refreshToken;
                                    return e1 ? e1.refreshToken : void 0;
                                }
                            },
                            {
                                key: "storeTokensFromRedirect",
                                value: (Z = (0, o.Z)(d().mark(function e1() {
                                    var t, n;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.token.parseFromUrl();
                                            case 2:
                                                t = e1.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return Z.apply(this, arguments);
                                })
                            },
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, k.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e1) >= 0 : this.options.responseType === e1;
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            },
                            {
                                key: "invokeApiMethod",
                                value: (T = (0, o.Z)(d().mark(function e1(t) {
                                    var n;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t.accessToken) {
                                                    e1.next = 5;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                n = e1.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                                            case 5:
                                                return e1.abrupt("return", (0, v.c3)(this, t));
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return T.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeAccessToken",
                                value: (g = (0, o.Z)(d().mark(function e1(t) {
                                    var n;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                t = e1.sent.accessToken, n = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(n);
                                            case 6:
                                                if (t) {
                                                    e1.next = 8;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 8:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 9:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return g.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeRefreshToken",
                                value: (h = (0, o.Z)(d().mark(function e1(t) {
                                    var n;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                t = e1.sent.refreshToken, n = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);
                                            case 6:
                                                if (t) {
                                                    e1.next = 8;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 8:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 9:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return h.apply(this, arguments);
                                })
                            },
                            {
                                key: "getSignOutRedirectUrl",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e1.idToken, n = e1.postLogoutRedirectUri, r = e1.state;
                                    if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                                    n || (n = this.options.postLogoutRedirectUri);
                                    var o = (0, O.Fc)(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                                    return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                                }
                            },
                            {
                                key: "signOut",
                                value: (n = (0, o.Z)(d().mark(function e1(t) {
                                    var n, r, o, i, a, u, c, s;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = Object.assign({}, t), n = window.location.origin, r = window.location.href, o = t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, i = t.accessToken, a = t.refreshToken, u = !1 !== t.revokeAccessToken, (c = !1 !== t.revokeRefreshToken) && void 0 === a && (a = this.tokenManager.getTokensSync().refreshToken), u && void 0 === i && (i = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !c || !a) {
                                                    e1.next = 14;
                                                    break;
                                                }
                                                return e1.next = 14, this.revokeRefreshToken(a);
                                            case 14:
                                                if (!u || !i) {
                                                    e1.next = 17;
                                                    break;
                                                }
                                                return e1.next = 17, this.revokeAccessToken(i);
                                            case 17:
                                                if (s = this.getSignOutRedirectUrl(x(x({}, t), {}, {
                                                    postLogoutRedirectUri: o
                                                }))) {
                                                    e1.next = 22;
                                                    break;
                                                }
                                                return e1.abrupt("return", this.closeSession().then(function() {
                                                    o === r ? window.location.reload() : window.location.assign(o);
                                                }));
                                            case 22:
                                                t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(s);
                                            case 24:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            }
                        ]), C;
                    }(h), (0, p.Z)(n, "crypto", g), n;
                }
            },
            9453: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return y;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(1971), l = n(6718), p = n(415), h = n(8817), d = n(9123);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y() {
                    return function(e1) {
                        (0, a.Z)(y, e1);
                        var t, n, h = (t = y, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function y(e1) {
                            var t;
                            return (0, o.Z)(this, y), t = h.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function(e1) {
                                var t = (e1 = e1 || {}).scopes;
                                if (t && !Array.isArray(t)) throw new d.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                                var n = e1.issuer;
                                if (!n) throw new d.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (!new RegExp("^http?s?://.+").test(n)) throw new d.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (-1 !== n.indexOf("-admin.")) throw new d.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                            }(e1), t.issuer = (0, l.Qj)(e1.issuer), t.tokenUrl = (0, l.Qj)(e1.tokenUrl), t.authorizeUrl = (0, l.Qj)(e1.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e1.userinfoUrl), t.revokeUrl = (0, l.Qj)(e1.revokeUrl), t.logoutUrl = (0, l.Qj)(e1.logoutUrl), t.pkce = !1 !== e1.pkce, t.clientId = e1.clientId, t.redirectUri = e1.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e1.redirectUri, window.location.origin)), t.responseType = e1.responseType, t.responseMode = e1.responseMode, t.state = e1.state, t.scopes = e1.scopes, t.ignoreSignature = !!e1.ignoreSignature, t.codeChallenge = e1.codeChallenge, t.codeChallengeMethod = e1.codeChallengeMethod, t.acrValues = e1.acrValues, t.maxAge = e1.maxAge, t.tokenManager = e1.tokenManager, t.postLogoutRedirectUri = e1.postLogoutRedirectUri, t.restoreOriginalUri = e1.restoreOriginalUri, t.transactionManager = function(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? v(Object(n), !0).forEach(function(t) {
                                        (0, s.Z)(e1, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e1;
                            }({
                                enableSharedStorage: !0
                            }, e1.transactionManager), t.clientSecret = e1.clientSecret, t.setLocation = e1.setLocation, t.ignoreLifetime = !!e1.ignoreLifetime, e1.maxClockSkew || 0 === e1.maxClockSkew ? t.maxClockSkew = e1.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
                        }
                        return (0, r.Z)(y);
                    }((0, h.Z)());
                }
            },
            3775: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return r.m;
                    }
                });
                var r = n(9453);
            },
            5372: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Tp: function() {
                        return p;
                    },
                    ko: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(1969), c = n(9912), s = n(4771), f = n(8676);
                function l(e1) {
                    var t = e1.options.pkce ? "query" : "fragment";
                    return e1.options.responseMode || t;
                }
                function p(e1, t) {
                    t = t || {}, (0, s.HD)(t) && (t = {
                        url: t
                    });
                    var n, r = t.url, o = t.responseMode || l(e1), i = e1.token.parseFromUrl._getLocation();
                    if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
                    return (0, u.v)(n);
                }
                function h(e1, t) {
                    "query" === (t.responseMode || l(e1)) ? function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                    }(e1) : function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                    }(e1);
                }
                function d(e1, t) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, u, l;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = n || {}, (0, s.HD)(n) && (n = {
                                        url: n
                                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                                        state: o
                                    })) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (!t.options.pkce) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                                case 8:
                                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                                case 9:
                                    return l = u.urls, delete u.urls, n.url || h(t, n), e1.abrupt("return", (0, f.s)(t, u, r, l).catch(function(e1) {
                                        throw (0, c.Cf)(e1) || t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }).then(function(e1) {
                                        return t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2476: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(6488), c = n(7625), s = n(781);
                function f() {
                    throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
                }
                function l(e1, t) {
                    return (0, u.sI)(e1) ? t.idToken : (0, u.hv)(e1) ? t.accessToken : void f();
                }
                function p(e1, t) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, p, h, d, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.R)(t, {
                                        scopes: n.scopes
                                    }, r.refreshToken);
                                case 5:
                                    return r = e1.sent, e1.abrupt("return", l(n, r));
                                case 7:
                                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, h = a.authorizeUrl, d = a.userinfoUrl, v = a.issuer, e1.abrupt("return", (0, c.y)(t, {
                                        responseType: o,
                                        scopes: p,
                                        authorizeUrl: h,
                                        userinfoUrl: d,
                                        issuer: v
                                    }).then(function(e1) {
                                        return l(n, e1.tokens);
                                    }));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6268: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    I: function() {
                        return f;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7625), c = n(781), s = n(7756);
                function f(e1, t) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return (l = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, f, l, p, h, d, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, c.R)(t, n || {}, r.refreshToken));
                                case 3:
                                    if (r.accessToken || r.idToken) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("renewTokens() was called but there is no existing token");
                                case 5:
                                    if (o = r.accessToken || {}, f = r.idToken || {}, l = o.scopes || f.scopes) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                                case 10:
                                    if (p = o.authorizeUrl || f.authorizeUrl) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                                case 13:
                                    return h = o.userinfoUrl || t.options.userinfoUrl, d = f.issuer || t.options.issuer, n = Object.assign({
                                        scopes: l,
                                        authorizeUrl: p,
                                        userinfoUrl: h,
                                        issuer: d
                                    }, n), t.options.pkce ? n.responseType = "code" : (v = (0, s.D)(t), y = v.responseType, n.responseType = y), e1.abrupt("return", (0, u.y)(t, n).then(function(e1) {
                                        return e1.tokens;
                                    }));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            781: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7599), c = n(6635), s = n(8676), f = n(9231), l = n(9912);
                function p(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, h, d, v, y, g;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = t.options.clientId) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                                case 3:
                                    return e1.prev = 3, p = Object.assign({}, n, {
                                        clientId: o
                                    }), e1.next = 7, (0, f.D)(t, p, r);
                                case 7:
                                    return h = e1.sent, d = (0, u.Fc)(t, n), e1.next = 11, (0, s.s)(t, p, h, d);
                                case 11:
                                    return v = e1.sent, y = v.tokens, (g = y.refreshToken) && !(0, c.q)(g, r) && t.tokenManager.updateRefreshToken(g), e1.abrupt("return", y);
                                case 18:
                                    throw e1.prev = 18, e1.t0 = e1.catch(3), (0, l.$E)(e1.t0) && t.tokenManager.removeRefreshToken(), e1.t0;
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                3,
                                18
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            6466: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5385), u = n(6718), c = n(7599), s = n(7594), f = n(9123);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p, h, d, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new f.Z("A valid access or refresh token object is required");
                                case 5:
                                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                                case 9:
                                    return h = (0, c.Fc)(t).revokeUrl, d = (0, u.UK)({
                                        token_type_hint: o ? "refresh_token" : "access_token",
                                        token: o || r
                                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e1.abrupt("return", (0, a.v_)(t, h, d, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + v
                                        }
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2333: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5437), s = n(5763), f = n(1971);
                function l() {
                    return function(e1) {
                        (0, i.Z)(p, e1);
                        var t, n, l = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function p(e1, t, n) {
                            return (0, r.Z)(this, p), l.call(this, e1, t, n);
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "getTransactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getSharedTansactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("shared-transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getOriginalUriStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("original-uri", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            }
                        ]), p;
                    }(c.W);
                }
            },
            6488: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return !!(e1 && (e1.accessToken || e1.idToken || e1.refreshToken) && Array.isArray(e1.scopes));
                }
                function o(e1) {
                    return e1 && e1.accessToken;
                }
                function i(e1) {
                    return e1 && e1.idToken;
                }
                function a(e1) {
                    return e1 && e1.refreshToken;
                }
                n.d(t, {
                    hD: function() {
                        return r;
                    },
                    hv: function() {
                        return o;
                    },
                    sI: function() {
                        return i;
                    },
                    z9: function() {
                        return a;
                    }
                });
            },
            7088: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $I: function() {
                        return u;
                    },
                    $Y: function() {
                        return r;
                    },
                    E: function() {
                        return o;
                    },
                    FT: function() {
                        return a;
                    },
                    O3: function() {
                        return i;
                    },
                    zr: function() {
                        return c;
                    }
                });
                var r = "expired", o = "renewed", i = "added", a = "removed", u = "error", c = "set_storage";
            },
            4319: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G5: function() {
                        return i;
                    },
                    ZT: function() {
                        return a;
                    },
                    mH: function() {
                        return s;
                    },
                    rZ: function() {
                        return c;
                    },
                    sG: function() {
                        return u;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    return !(!e1 || "object" !== (0, r.Z)(e1) || 0 === Object.values(e1).length);
                }
                function i(e1) {
                    return !(!o(e1) || !e1.redirectUri && !e1.responseType);
                }
                function a(e1) {
                    return !!i(e1) && !!e1.codeVerifier;
                }
                function u(e1) {
                    return !!a(e1) && !!e1.interactionHandle;
                }
                function c(e1) {
                    return !!o(e1) && void 0 === Object.values(e1).find(function(e1) {
                        return "string" != typeof e1;
                    });
                }
                function s(e1) {
                    return !(!i(e1) && !c(e1));
                }
            },
            7615: function() {},
            8927: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    EVENT_ADDED: function() {
                        return u.O3;
                    },
                    EVENT_ERROR: function() {
                        return u.$I;
                    },
                    EVENT_EXPIRED: function() {
                        return u.$Y;
                    },
                    EVENT_REMOVED: function() {
                        return u.FT;
                    },
                    EVENT_RENEWED: function() {
                        return u.E;
                    },
                    EVENT_SET_STORAGE: function() {
                        return u.zr;
                    },
                    isAccessToken: function() {
                        return a.hv;
                    },
                    isCustomAuthTransactionMeta: function() {
                        return c.rZ;
                    },
                    isIDToken: function() {
                        return a.sI;
                    },
                    isIdxTransactionMeta: function() {
                        return c.sG;
                    },
                    isOAuthTransactionMeta: function() {
                        return c.G5;
                    },
                    isPKCETransactionMeta: function() {
                        return c.ZT;
                    },
                    isRefreshToken: function() {
                        return a.z9;
                    },
                    isToken: function() {
                        return a.hD;
                    },
                    isTransactionMeta: function() {
                        return c.mH;
                    }
                });
                var r = n(9263), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
                var a = n(6488), u = n(7088), c = n(4319), s = n(7615);
                for(var i in o = {}, s)[
                    "default",
                    "isAccessToken",
                    "isIDToken",
                    "isRefreshToken",
                    "isToken",
                    "EVENT_ADDED",
                    "EVENT_ERROR",
                    "EVENT_EXPIRED",
                    "EVENT_REMOVED",
                    "EVENT_RENEWED",
                    "EVENT_SET_STORAGE",
                    "isCustomAuthTransactionMeta",
                    "isIdxTransactionMeta",
                    "isOAuthTransactionMeta",
                    "isPKCETransactionMeta",
                    "isTransactionMeta"
                ].indexOf(i) < 0 && (o[i] = (function(e1) {
                    return s[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            9263: function() {},
            4970: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    NH: function() {
                        return o;
                    },
                    Rl: function() {
                        return a;
                    },
                    iC: function() {
                        return c;
                    },
                    pU: function() {
                        return u;
                    },
                    ys: function() {
                        return i;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    e1.addEventListener ? e1.addEventListener(t, n) : e1.attachEvent("on" + t, n);
                }
                function i(e1, t, n) {
                    e1.removeEventListener ? e1.removeEventListener(t, n) : e1.detachEvent("on" + t, n);
                }
                function a(e1) {
                    var t = document.createElement("iframe");
                    return t.style.display = "none", t.src = e1, document.body.appendChild(t);
                }
                function u(e1, t) {
                    var n = t.popupTitle || "External Identity Provider User Authentication";
                    return window.open(e1, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
                }
                function c(e1, t, n) {
                    var a, u;
                    return new Promise(function(i, c) {
                        a = function(t) {
                            if (t.data && t.data.state === n) return t.origin !== e1.getIssuerOrigin() ? c(new r.Z("The request does not match client configuration")) : void i(t.data);
                        }, o(window, "message", a), u = setTimeout(function() {
                            c(new r.Z("OAuth flow timed out"));
                        }, t || 12e4);
                    }).finally(function() {
                        clearTimeout(u), i(window, "message", a);
                    });
                }
            },
            5078: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    c: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.clientId, a = t.redirectUri, u = t.responseMode, c = t.state, s = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        clientId: n,
                        redirectUri: a || s,
                        responseMode: u,
                        state: c || (0, r.aV)(),
                        responseType: "none",
                        prompt: "enroll_authenticator"
                    });
                }
            },
            7756: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.pkce, a = t.clientId, u = t.redirectUri, c = t.responseType, s = t.responseMode, f = t.scopes, l = t.acrValues, p = t.maxAge, h = t.state, d = t.ignoreSignature, v = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        pkce: n,
                        clientId: a,
                        redirectUri: u || v,
                        responseType: c || [
                            "token",
                            "id_token"
                        ],
                        responseMode: s,
                        state: h || (0, r.aV)(),
                        nonce: (0, r.NH)(),
                        scopes: f || [
                            "openid",
                            "email"
                        ],
                        acrValues: l,
                        maxAge: p,
                        ignoreSignature: d
                    });
                }
            },
            8080: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return o;
                    }
                });
                var r = n(7599);
                function o(e1, t) {
                    return {
                        issuer: e1.options.issuer,
                        urls: (0, r.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        state: t.state,
                        acrValues: t.acrValues,
                        enrollAmrValues: t.enrollAmrValues
                    };
                }
            },
            9912: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a;
                    },
                    Cf: function() {
                        return o;
                    },
                    tC: function() {
                        return i;
                    }
                });
                var r = n(5728);
                function o(e1) {
                    return "OAuthError" === e1.name && "interaction_required" === e1.errorCode;
                }
                function i(e1, t) {
                    if ("AuthApiError" !== t.name) return !1;
                    var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                    return e1.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
                }
                function a(e1) {
                    return (0, r.isOAuthError)(e1) && "invalid_grant" === e1.errorCode && "The refresh token is invalid or expired." === e1.errorSummary;
                }
            },
            8785: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a.$E;
                    },
                    AW: function() {
                        return f.A;
                    },
                    Cf: function() {
                        return a.Cf;
                    },
                    Dx: function() {
                        return o.D;
                    },
                    Fc: function() {
                        return c.Fc;
                    },
                    H: function() {
                        return s.H;
                    },
                    Ik: function() {
                        return u.Ik;
                    },
                    NH: function() {
                        return r.NH;
                    },
                    O2: function() {
                        return u.O2;
                    },
                    PY: function() {
                        return c.NH;
                    },
                    Qs: function() {
                        return u.Qs;
                    },
                    Rl: function() {
                        return r.Rl;
                    },
                    Rp: function() {
                        return g.R;
                    },
                    U5: function() {
                        return l.Z;
                    },
                    Uc: function() {
                        return h.U;
                    },
                    Xp: function() {
                        return c.Xp;
                    },
                    Yo: function() {
                        return d.Y;
                    },
                    ZP: function() {
                        return u.ZP;
                    },
                    aV: function() {
                        return c.aV;
                    },
                    br: function() {
                        return p.br;
                    },
                    cE: function() {
                        return i.c;
                    },
                    d_: function() {
                        return u.d_;
                    },
                    gM: function() {
                        return u.gM;
                    },
                    hg: function() {
                        return u.hg;
                    },
                    iC: function() {
                        return r.iC;
                    },
                    kU: function() {
                        return u.kU;
                    },
                    mi: function() {
                        return p.mi;
                    },
                    pU: function() {
                        return r.pU;
                    },
                    pj: function() {
                        return y.p;
                    },
                    q0: function() {
                        return d.q;
                    },
                    tC: function() {
                        return a.tC;
                    },
                    vL: function() {
                        return v.v;
                    },
                    vz: function() {
                        return p.vz;
                    },
                    wc: function() {
                        return u.wc;
                    },
                    wu: function() {
                        return p.wu;
                    },
                    ys: function() {
                        return r.ys;
                    },
                    zf: function() {
                        return c.zf;
                    }
                });
                var r = n(4970), o = n(7756), i = n(5078), a = n(9912), u = n(8221), c = n(7599), s = n(2865), f = n(8080), l = n(3611), p = n(6898), h = n(6757), d = n(6635), v = n(1969), y = n(6003), g = n(2482);
            },
            8221: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /((id|access)_token=)/i.test(e1);
                }
                function o(e1) {
                    return /(code=)/i.test(e1);
                }
                function i(e1) {
                    return /(interaction_code=)/i.test(e1);
                }
                function a(e1) {
                    return /(error=)/i.test(e1) || /(error_description)/i.test(e1);
                }
                function u(e1, t) {
                    var n = t.options;
                    return !(!e1 || !n.redirectUri) && 0 === e1.indexOf(n.redirectUri);
                }
                function c(e1) {
                    return e1.pkce || "code" === e1.responseType || "query" === e1.responseMode;
                }
                function s(e1) {
                    return c(e1) && "fragment" !== e1.responseMode ? window.location.search : window.location.hash;
                }
                function f(e1) {
                    if (!u(window.location.href, e1)) return !1;
                    var t = c(e1.options), n = s(e1.options);
                    return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
                }
                function l(e1, t) {
                    if (!t) {
                        if (!f(e1)) return !1;
                        t = s(e1.options);
                    }
                    return /(error=interaction_required)/i.test(t);
                }
                n.d(t, {
                    Ik: function() {
                        return c;
                    },
                    O2: function() {
                        return s;
                    },
                    Qs: function() {
                        return u;
                    },
                    ZP: function() {
                        return o;
                    },
                    d_: function() {
                        return i;
                    },
                    gM: function() {
                        return f;
                    },
                    hg: function() {
                        return a;
                    },
                    kU: function() {
                        return r;
                    },
                    wc: function() {
                        return l;
                    }
                });
            },
            7599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Fc: function() {
                        return l;
                    },
                    NH: function() {
                        return u;
                    },
                    Xp: function() {
                        return f;
                    },
                    aV: function() {
                        return a;
                    },
                    zf: function() {
                        return s;
                    }
                });
                var r = n(8750), o = n(6718), i = n(9123);
                function a() {
                    return (0, r.uh)(64);
                }
                function u() {
                    return (0, r.uh)(64);
                }
                function c(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = (0, o.Qj)(t.issuer) || e1.options.issuer;
                    return n;
                }
                function s(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = c(e1, t), r = n.indexOf("/oauth2") > 0 ? n : n + "/oauth2";
                    return r;
                }
                function f(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = c(e1, t), r = n.split("/oauth2")[0];
                    return r;
                }
                function l(e1, t) {
                    if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                    t = t || {};
                    var n = (0, o.Qj)(t.authorizeUrl) || e1.options.authorizeUrl, r = c(e1, t), a = (0, o.Qj)(t.userinfoUrl) || e1.options.userinfoUrl, u = (0, o.Qj)(t.tokenUrl) || e1.options.tokenUrl, f = (0, o.Qj)(t.logoutUrl) || e1.options.logoutUrl, l = (0, o.Qj)(t.revokeUrl) || e1.options.revokeUrl, p = s(e1, t);
                    return {
                        issuer: r,
                        authorizeUrl: n = n || p + "/v1/authorize",
                        userinfoUrl: a = a || p + "/v1/userinfo",
                        tokenUrl: u = u || p + "/v1/token",
                        revokeUrl: l = l || p + "/v1/revoke",
                        logoutUrl: f = f || p + "/v1/logout"
                    };
                }
            },
            2865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return u;
                    }
                });
                var r = n(4942), o = n(7599);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    var n = {
                        issuer: e1.options.issuer,
                        urls: (0, o.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        scopes: t.scopes,
                        state: t.state,
                        nonce: t.nonce,
                        ignoreSignature: t.ignoreSignature,
                        acrValues: t.acrValues
                    };
                    return !1 === t.pkce ? n : a(a({}, n), {}, {
                        codeVerifier: t.codeVerifier,
                        codeChallengeMethod: t.codeChallengeMethod,
                        codeChallenge: t.codeChallenge
                    });
                }
            },
            3611: function(e1, t, n) {
                "use strict";
                var r = n(7594), o = n(7987), i = n(1971);
                function a(e1) {
                    return ("0" + e1.toString(16)).substr(-2);
                }
                t.Z = {
                    DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: function(e1) {
                        var t, n, o = e1 || "";
                        return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
                    },
                    computeChallenge: function(e1) {
                        var t = (new TextEncoder).encode(e1);
                        return r.KP.subtle.digest("SHA-256", t).then(function(e1) {
                            var t = String.fromCharCode.apply(null, new Uint8Array(e1));
                            return (0, o.NL)(t);
                        });
                    }
                };
            },
            6757: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return c;
                    }
                });
                var r = n(4942), o = n(9123), i = n(5078);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    return function(e1) {
                        if (!(e1 = u(u({}, e1), {}, {
                            responseType: "none",
                            prompt: "enroll_authenticator",
                            maxAge: 0
                        })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
                        if (!e1.acrValues) throw new o.Z("acr_values must be specified");
                        return delete e1.scopes, delete e1.nonce, e1;
                    }(u(u({}, (0, i.c)(e1)), t));
                }
            },
            6898: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    br: function() {
                        return v;
                    },
                    mi: function() {
                        return g;
                    },
                    vz: function() {
                        return d;
                    },
                    wu: function() {
                        return b;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(52), c = n(9123), s = n(7756), f = n(1971), l = n(3611);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    if (!e1.features.isPKCESupported()) {
                        var t = "PKCE requires a modern browser with encryption support running in a secure context.";
                        throw e1.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e1.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
                    }
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e1.next = 3, (0, u.E)(t);
                                case 3:
                                    if (-1 !== (e1.sent.code_challenge_methods_supported || []).indexOf(n)) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new c.Z("Invalid code_challenge_method");
                                case 7:
                                    return e1.abrupt("return", n);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return d(t), o = o || l.Z.generateVerifier(), e1.next = 7, l.Z.computeChallenge(o);
                                case 7:
                                    i = e1.sent;
                                case 8:
                                    return e1.next = 10, v(t, u);
                                case 10:
                                    return u = e1.sent, n = h(h({}, n), {}, {
                                        responseType: "code",
                                        codeVerifier: o,
                                        codeChallenge: i,
                                        codeChallengeMethod: u
                                    }), e1.abrupt("return", n);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return w = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !1 !== (n = h(h({}, r), n)).pkce) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return e1.abrupt("return", g(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), w.apply(this, arguments);
                }
            },
            6635: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    },
                    q: function() {
                        return o;
                    }
                });
                var r = n(5728);
                function o(e1, t) {
                    return e1.refreshToken === t.refreshToken;
                }
                function i(e1) {
                    return !(!(0, r.isAuthApiError)(e1) || !e1.xhr || !e1.xhr.responseJSON || "invalid_grant" !== e1.xhr.responseJSON.error);
                }
            },
            1969: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e1 || "";
                    "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                    for(var o, i = {}; o = n.exec(r);){
                        var a = o[1], u = o[2];
                        i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                    }
                    return i;
                }
                n.d(t, {
                    v: function() {
                        return r;
                    }
                });
            },
            6003: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    p: function() {
                        return o;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    var o = n.clientId, i = n.issuer, a = n.nonce, u = n.acrValues;
                    if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
                    if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
                    var c = Math.floor(Date.now() / 1e3);
                    if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
                    if (t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
                    if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
                    if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
                    if (!e1.options.ignoreLifetime) {
                        if (c - e1.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
                        if (t.iat > c + e1.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
                    }
                }
            },
            2482: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(6488);
                function i(e1, t) {
                    if (!(0, o.sI)(e1) && !(0, o.hv)(e1) && !(0, o.z9)(e1)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                    if ("accessToken" === t && !(0, o.hv)(e1)) throw new r.Z("invalid accessToken");
                    if ("idToken" === t && !(0, o.sI)(e1)) throw new r.Z("invalid idToken");
                    if ("refreshToken" === t && !(0, o.z9)(e1)) throw new r.Z("invalid refreshToken");
                }
            },
            1260: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(52), u = n(6003), c = n(9123), s = n(1237), f = n(3154), l = n(5698);
                function p(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, h, d, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n && n.idToken) {
                                        e1.next = 2;
                                        break;
                                    }
                                    throw new c.Z("Only idTokens may be verified");
                                case 2:
                                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e1.next = 6, (0, a.E)(t, p);
                                case 6:
                                    if (h = e1.sent, d = h.issuer, v = Object.assign({
                                        clientId: t.options.clientId,
                                        ignoreSignature: t.options.ignoreSignature
                                    }, r, {
                                        issuer: d
                                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 12:
                                    return e1.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                                case 14:
                                    return y = e1.sent, e1.next = 17, f.W(n.idToken, y);
                                case 17:
                                    if (e1.sent) {
                                        e1.next = 20;
                                        break;
                                    }
                                    throw new c.Z("The token signature is not valid");
                                case 20:
                                    if (!(r && r.accessToken && n.claims.at_hash)) {
                                        e1.next = 26;
                                        break;
                                    }
                                    return e1.next = 23, l.X(r.accessToken);
                                case 23:
                                    if (e1.sent === n.claims.at_hash) {
                                        e1.next = 26;
                                        break;
                                    }
                                    throw new c.Z("Token hash verification failed");
                                case 26:
                                    return e1.abrupt("return", n);
                                case 27:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            3719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return u;
                    },
                    OT: function() {
                        return f;
                    },
                    RJ: function() {
                        return c;
                    },
                    dx: function() {
                        return s;
                    },
                    sH: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(6718), i = n(5385);
                function a(e1) {
                    return e1.session.get().then(function(e1) {
                        return "ACTIVE" === e1.status;
                    }).catch(function() {
                        return !1;
                    });
                }
                function u(e1) {
                    return (0, i.U2)(e1, "/api/v1/sessions/me", {
                        withCredentials: !0
                    }).then(function(t) {
                        var n = (0, r.CE)(t, "_links");
                        return n.refresh = function() {
                            return (0, i.v_)(e1, (0, r.Rg)(t, "refresh").href, {}, {
                                withCredentials: !0
                            });
                        }, n.user = function() {
                            return (0, i.U2)(e1, (0, r.Rg)(t, "user").href, {
                                withCredentials: !0
                            });
                        }, n;
                    }).catch(function() {
                        return {
                            status: "INACTIVE"
                        };
                    });
                }
                function c(e1) {
                    return (0, i.c3)(e1, {
                        url: e1.getIssuerOrigin() + "/api/v1/sessions/me",
                        method: "DELETE",
                        withCredentials: !0
                    });
                }
                function s(e1) {
                    return (0, i.v_)(e1, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                        withCredentials: !0
                    });
                }
                function f(e1, t, n) {
                    n = n || window.location.href, window.location.assign(e1.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
                        checkAccountSetupComplete: !0,
                        token: t,
                        redirectUrl: n
                    }));
                }
            },
            2815: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return o;
                    }
                });
                var r = n(3719);
                function o(e1) {
                    return {
                        close: r.RJ.bind(null, e1),
                        exists: r.sH.bind(null, e1),
                        get: r.Gg.bind(null, e1),
                        refresh: r.dx.bind(null, e1),
                        setCookieAndRedirect: r.OT.bind(null, e1)
                    };
                }
            },
            8041: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return r.Gg;
                    },
                    MG: function() {
                        return o.M;
                    },
                    OT: function() {
                        return r.OT;
                    },
                    RJ: function() {
                        return r.RJ;
                    },
                    Zg: function() {
                        return i.Z;
                    },
                    dx: function() {
                        return r.dx;
                    },
                    sH: function() {
                        return r.sH;
                    }
                });
                var r = n(3719), o = n(2815), i = n(3980);
            },
            3980: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), h = n(2815);
                function d(e1) {
                    return function(e1) {
                        (0, u.Z)(d, e1);
                        var t, n, l = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, o.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = l.call.apply(l, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "session", void 0), e1.session = (0, h.M)((0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(d, [
                            {
                                key: "closeSession",
                                value: function() {
                                    var e1 = this;
                                    return this.session.close().then((0, r.Z)(p().mark(function t() {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    e1.clearStorage();
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }))).catch(function(e1) {
                                        if ("AuthApiError" === e1.name && "E0000007" === e1.errorCode) return null;
                                        throw e1;
                                    });
                                }
                            }
                        ]), d;
                    }(e1);
                }
            },
            5437: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return f;
                    },
                    W: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(1971), u = n(5763), c = n(415), s = n(146);
                function f(e1) {
                    (0, c.isBrowser)() || e1.storageProvider || e1.storageProvider || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
                }
                var l = function() {
                    function e1(t, n, o) {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getOptionsForSection",
                            value: function(e1, t) {
                                return Object.assign({}, this.storageManagerOptions[e1], t);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function(e1) {
                                if ((e1 = Object.assign({}, this.cookieOptions, e1)).storageProvider) return e1.storageProvider;
                                var t = e1, n = t.storageType, r = t.storageTypes;
                                if ("sessionStorage" === n && (e1.sessionCookie = !0), n && r) {
                                    var o = r.indexOf(n);
                                    o >= 0 && (r = r.slice(o), n = void 0);
                                }
                                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e1);
                            }
                        },
                        {
                            key: "getTokenStorage",
                            value: function(e1) {
                                f(e1 = this.getOptionsForSection("token", e1));
                                var t = this.getStorage(e1), n = e1.storageKey || a.TOKEN_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        },
                        {
                            key: "getHttpCache",
                            value: function(e1) {
                                e1 = this.getOptionsForSection("cache", e1);
                                var t = this.getStorage(e1), n = e1.storageKey || a.CACHE_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        }
                    ]), e1;
                }();
            },
            5763: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(9123), u = function() {
                    function e1(t, n) {
                        if ((0, r.Z)(this, e1), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                        if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                        this.storageName = n, this.storageProvider = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getItem",
                            value: function(e1) {
                                return this.getStorage()[e1];
                            }
                        },
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                return this.updateStorage(e1, t);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                return this.clearStorage(e1);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                var e1 = this.storageProvider.getItem(this.storageName);
                                e1 = e1 || "{}";
                                try {
                                    return JSON.parse(e1);
                                } catch (e1) {
                                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "setStorage",
                            value: function(e1) {
                                try {
                                    var t = e1 ? JSON.stringify(e1) : "{}";
                                    this.storageProvider.setItem(this.storageName, t);
                                } catch (e1) {
                                    throw new a.Z("Unable to set storage: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "clearStorage",
                            value: function(e1) {
                                if (e1) {
                                    var t = this.getStorage();
                                    delete t[e1], this.setStorage(t);
                                } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                            }
                        },
                        {
                            key: "updateStorage",
                            value: function(e1, t) {
                                var n = this.getStorage();
                                n[e1] = t, this.setStorage(n);
                            }
                        }
                    ]), e1;
                }();
            },
            9927: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ho: function() {
                        return i.H;
                    },
                    Tp: function() {
                        return r.T;
                    },
                    Vp: function() {
                        return o.V;
                    },
                    W8: function() {
                        return o.W;
                    },
                    _e: function() {
                        return a._;
                    }
                });
                var r = n(3849), o = n(5437), i = n(265), a = n(5763);
            },
            265: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return f;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    return function(e1) {
                        (0, a.Z)(p, e1);
                        var n, f, l = (n = p, f = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, c.Z)(n);
                            if (f) {
                                var r = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, r);
                            } else e1 = t.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, r.Z)(this, p);
                            for(var n = arguments.length, o = new Array(n), a = 0; a < n; a++)o[a] = arguments[a];
                            e1 = l.call.apply(l, [
                                this
                            ].concat(o)), (0, s.Z)((0, i.Z)(e1), "storageManager", void 0);
                            var u = e1.options, c = u.storageManager, f = u.cookies, h = u.storageUtil;
                            return e1.storageManager = new t(c, f, h), e1;
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "clearStorage",
                                value: function() {}
                            }
                        ]), p;
                    }(e1);
                }
            },
            3849: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(5093), l = n(146), p = n(4858), h = {
                    token: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    cache: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    transaction: {
                        storageTypes: [
                            "sessionStorage",
                            "localStorage",
                            "cookie"
                        ]
                    },
                    "shared-transaction": {
                        storageTypes: [
                            "localStorage"
                        ]
                    },
                    "original-uri": {
                        storageTypes: [
                            "localStorage"
                        ]
                    }
                }, d = n(415);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, f = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v(e1) {
                            var t;
                            return (0, o.Z)(this, v), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function() {
                                var e1 = arguments.length > 1 ? arguments[1] : void 0, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                                return void 0 === t.secure && (t.secure = e1), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e1 && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                            }(e1, (0, d.isHTTPS)()), t.storageUtil = e1.storageUtil || Object.assign({}, p.Z, {
                                inMemoryStore: {}
                            }), t.storageManager = y(y({}, h), e1.storageManager), t;
                        }
                        return (0, r.Z)(v);
                    }((0, f.X)());
                }
            },
            3548: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return c;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4771), u = n(146), c = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            quiet: !1
                        };
                        (0, r.Z)(this, e1), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "push",
                            value: function(e1, t) {
                                for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                                return new Promise(function(r, i) {
                                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                                        method: e1,
                                        thisObject: t,
                                        args: o,
                                        resolve: r,
                                        reject: i
                                    }), n.run();
                                });
                            }
                        },
                        {
                            key: "run",
                            value: function() {
                                var e1 = this;
                                if (!this.running && 0 !== this.queue.length) {
                                    this.running = !0;
                                    var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                    (0, a.tI)(n) ? n.then(t.resolve, t.reject).finally(function() {
                                        e1.running = !1, e1.run();
                                    }) : (t.resolve(n), this.running = !1, this.run());
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            146: function(e1, t, n) {
                "use strict";
                function r() {
                    return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
                }
                function o() {
                    var e1 = r();
                    return e1 && e1.log ? e1 : {
                        log: function() {},
                        warn: function() {},
                        group: function() {},
                        groupEnd: function() {}
                    };
                }
                function i(e1) {
                    o().warn("[okta-auth-sdk] WARN: " + e1);
                }
                function a(e1) {
                    o().warn("[okta-auth-sdk] DEPRECATION: " + e1);
                }
                function u(e1, t) {
                    return function() {
                        return a(e1), t.apply(null, arguments);
                    };
                }
                n.d(t, {
                    Rn: function() {
                        return a;
                    },
                    VA: function() {
                        return u;
                    },
                    ZK: function() {
                        return i;
                    },
                    dr: function() {
                        return o;
                    },
                    sW: function() {
                        return r;
                    }
                });
            },
            305: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    BY: function() {
                        return c.BY;
                    },
                    CE: function() {
                        return i.CE;
                    },
                    HD: function() {
                        return u.HD;
                    },
                    Kn: function() {
                        return u.Kn;
                    },
                    QN: function() {
                        return c.QN;
                    },
                    Qj: function() {
                        return c.Qj;
                    },
                    Rg: function() {
                        return i.Rg;
                    },
                    Rn: function() {
                        return r.Rn;
                    },
                    UK: function() {
                        return c.UK;
                    },
                    VA: function() {
                        return r.VA;
                    },
                    YQ: function() {
                        return o.YQ;
                    },
                    YY: function() {
                        return i.YY;
                    },
                    ZK: function() {
                        return r.ZK;
                    },
                    ak: function() {
                        return i.ak;
                    },
                    bo: function() {
                        return a.b;
                    },
                    d9: function() {
                        return i.d9;
                    },
                    dr: function() {
                        return r.dr;
                    },
                    gw: function() {
                        return o.gw;
                    },
                    hj: function() {
                        return u.hj;
                    },
                    l7: function() {
                        return i.l7;
                    },
                    mf: function() {
                        return u.mf;
                    },
                    ng: function() {
                        return o.ng;
                    },
                    sD: function() {
                        return c.sD;
                    },
                    sE: function() {
                        return i.sE;
                    },
                    sW: function() {
                        return r.sW;
                    },
                    tI: function() {
                        return u.tI;
                    },
                    uh: function() {
                        return o.uh;
                    }
                });
                var r = n(146), o = n(8750), i = n(3193), a = n(3548), u = n(4771), c = n(6718);
            },
            8750: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = e1.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    return new Date(n).toUTCString();
                }
                function o(e1) {
                    for(var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e1; ++r)n += t[Math.floor(Math.random() * o)];
                    return n;
                }
                function i(e1) {
                    return new Promise(function(t) {
                        setTimeout(t, e1);
                    });
                }
                function a(e1, t) {
                    var n = e1.split(t);
                    return [
                        n[0],
                        n.splice(1, n.length).join(t)
                    ];
                }
                n.d(t, {
                    YQ: function() {
                        return a;
                    },
                    gw: function() {
                        return i;
                    },
                    ng: function() {
                        return r;
                    },
                    uh: function() {
                        return o;
                    }
                });
            },
            3193: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    var n = Array.prototype.slice.call(arguments, 2);
                    return function() {
                        var r = Array.prototype.slice.call(arguments);
                        return r = n.concat(r), e1.apply(t, r);
                    };
                }
                function o() {
                    var e1 = arguments[0], t = [].slice.call(arguments, 1);
                    return t.forEach(function(t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e1[n] = t[n]);
                    }), e1;
                }
                function i(e1) {
                    var t = {};
                    for(var n in e1)if (Object.prototype.hasOwnProperty.call(e1, n)) {
                        var r = e1[n];
                        null != r && (t[n] = r);
                    }
                    return t;
                }
                function a(e1) {
                    if (e1) {
                        var t = JSON.stringify(e1);
                        if (t) return JSON.parse(t);
                    }
                    return e1;
                }
                function u(e1) {
                    for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                    for(var i in e1)Object.prototype.hasOwnProperty.call(e1, i) && -1 == r.indexOf(i) && (t[i] = e1[i]);
                    return a(t);
                }
                function c(e1, t) {
                    for(var n = e1.length; n--;){
                        var r = e1[n], o = !0;
                        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                            o = !1;
                            break;
                        }
                        if (o) return r;
                    }
                }
                function s(e1, t, n) {
                    if (e1 && e1._links) {
                        var r = a(e1._links[t]);
                        return r && r.name && n ? r.name === n ? r : void 0 : r;
                    }
                }
                n.d(t, {
                    CE: function() {
                        return u;
                    },
                    Rg: function() {
                        return s;
                    },
                    YY: function() {
                        return i;
                    },
                    ak: function() {
                        return r;
                    },
                    d9: function() {
                        return a;
                    },
                    l7: function() {
                        return o;
                    },
                    sE: function() {
                        return c;
                    }
                });
            },
            4771: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return "[object String]" === Object.prototype.toString.call(e1);
                }
                function o(e1) {
                    return "[object Object]" === Object.prototype.toString.call(e1);
                }
                function i(e1) {
                    return "[object Number]" === Object.prototype.toString.call(e1);
                }
                function a(e1) {
                    return !!e1 && "[object Function]" === ({}).toString.call(e1);
                }
                function u(e1) {
                    return e1 && e1.finally && "function" == typeof e1.finally;
                }
                n.d(t, {
                    HD: function() {
                        return r;
                    },
                    Kn: function() {
                        return o;
                    },
                    hj: function() {
                        return i;
                    },
                    mf: function() {
                        return a;
                    },
                    tI: function() {
                        return u;
                    }
                });
            },
            6718: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /^[a-z][a-z0-9+.-]*:/i.test(e1);
                }
                function o() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) ? e1 : (t = u(t), "/" === e1[0] ? "".concat(t).concat(e1) : "".concat(t, "/").concat(e1));
                }
                function i() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) && (e1 = e1.substring(t.length)), "/" === e1[0] ? e1 : "/".concat(e1);
                }
                function a(e1) {
                    var t = [];
                    if (null !== e1) for(var n in e1)Object.prototype.hasOwnProperty.call(e1, n) && void 0 !== e1[n] && null !== e1[n] && t.push(n + "=" + encodeURIComponent(e1[n]));
                    return t.length ? "?" + t.join("&") : "";
                }
                function u(e1) {
                    if (e1) {
                        var t = e1.replace(/^\s+|\s+$/gm, "");
                        return t.replace(/\/+$/, "");
                    }
                }
                n.d(t, {
                    BY: function() {
                        return o;
                    },
                    QN: function() {
                        return i;
                    },
                    Qj: function() {
                        return u;
                    },
                    UK: function() {
                        return a;
                    },
                    sD: function() {
                        return r;
                    }
                });
            },
            3615: function(e1, t, n) {
                "use strict";
                var r = n(6690), o = n(9728), i = n(1655), a = n(4993), u = n(3808);
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var s = function(e1) {
                    i(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return a(this, e1);
                    });
                    function s(e1) {
                        var t;
                        return r(this, s), (t = c.call(this, e1 || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(s, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3496)(Error)), f = function() {
                    function e1(t) {
                        var n = this;
                        r(this, e1), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e1, r) {
                            n._reject = r;
                            var o = function(e1) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e1);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e1) {
                                        n._rejectOnCancel = e1;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e1(t));
                            }, function(e1) {
                                n._isPending = !1, r(e1);
                            }, o);
                        });
                    }
                    return o(e1, [
                        {
                            key: "then",
                            value: function(e1, t) {
                                return this._promise.then(e1, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e1) {
                                return this._promise.catch(e1);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e1) {
                                return this._promise.finally(e1);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e1) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e1, t) {
                                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e1) || (n = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return c(e1, t);
                                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e1, t) : void 0;
                                                    }
                                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                                    n && (e1 = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[r++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = n.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, i = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e1) {
                                            n.e(e1);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e1) {
                                        return void this._reject(e1);
                                    }
                                    this._rejectOnCancel && this._reject(new s(e1));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e1(function(e1, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e1, n);
                                    });
                                };
                            }
                        }
                    ]), e1;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e1.exports = f, e1.exports.CancelError = s;
            },
            4098: function(e1, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e1() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e1.prototype = n, new e1;
                }();
                !function(e1) {
                    !function(t) {
                        var n = "URLSearchParams" in e1, r = "Symbol" in e1 && "iterator" in Symbol, o = "FileReader" in e1 && "Blob" in e1 && function() {
                            try {
                                return new Blob, !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), i = "FormData" in e1, a = "ArrayBuffer" in e1;
                        if (a) var u = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], c = ArrayBuffer.isView || function(e1) {
                            return e1 && u.indexOf(Object.prototype.toString.call(e1)) > -1;
                        };
                        function s(e1) {
                            if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                            return e1.toLowerCase();
                        }
                        function f(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1;
                        }
                        function l(e1) {
                            var t = {
                                next: function() {
                                    var t = e1.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return r && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function p(e1) {
                            this.map = {}, e1 instanceof p ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        function h(e1) {
                            if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e1.bodyUsed = !0;
                        }
                        function d(e1) {
                            return new Promise(function(t, n) {
                                e1.onload = function() {
                                    t(e1.result);
                                }, e1.onerror = function() {
                                    n(e1.error);
                                };
                            });
                        }
                        function v(e1) {
                            var t = new FileReader, n = d(t);
                            return t.readAsArrayBuffer(e1), n;
                        }
                        function y(e1) {
                            if (e1.slice) return e1.slice(0);
                            var t = new Uint8Array(e1.byteLength);
                            return t.set(new Uint8Array(e1)), t.buffer;
                        }
                        function g() {
                            return this.bodyUsed = !1, this._initBody = function(e1) {
                                var t;
                                this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : o && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : i && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : n && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : a && o && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = y(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : a && (ArrayBuffer.prototype.isPrototypeOf(e1) || c(e1)) ? this._bodyArrayBuffer = y(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, o && (this.blob = function() {
                                var e1 = h(this);
                                if (e1) return e1;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(v);
                            }), this.text = function() {
                                var e1, t, n, r = h(this);
                                if (r) return r;
                                if (this._bodyBlob) return e1 = this._bodyBlob, n = d(t = new FileReader), t.readAsText(e1), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                    for(var t = new Uint8Array(e1), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, i && (this.formData = function() {
                                return this.text().then(w);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        p.prototype.append = function(e1, t) {
                            e1 = s(e1), t = f(t);
                            var n = this.map[e1];
                            this.map[e1] = n ? n + ", " + t : t;
                        }, p.prototype.delete = function(e1) {
                            delete this.map[s(e1)];
                        }, p.prototype.get = function(e1) {
                            return e1 = s(e1), this.has(e1) ? this.map[e1] : null;
                        }, p.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(s(e1));
                        }, p.prototype.set = function(e1, t) {
                            this.map[s(e1)] = f(t);
                        }, p.prototype.forEach = function(e1, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e1.call(t, this.map[n], n, this);
                        }, p.prototype.keys = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push(n);
                            }), l(e1);
                        }, p.prototype.values = function() {
                            var e1 = [];
                            return this.forEach(function(t) {
                                e1.push(t);
                            }), l(e1);
                        }, p.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push([
                                    n,
                                    t
                                ]);
                            }), l(e1);
                        }, r && (p.prototype[Symbol.iterator] = p.prototype.entries);
                        var m = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function b(e1, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e1 instanceof b) {
                                if (e1.bodyUsed) throw new TypeError("Already read");
                                this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new p(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                            } else this.url = String(e1);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), m.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function w(e1) {
                            var t = new FormData;
                            return e1.trim().split("&").forEach(function(e1) {
                                if (e1) {
                                    var n = e1.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function k(e1, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e1);
                        }
                        b.prototype.clone = function() {
                            return new b(this, {
                                body: this._bodyInit
                            });
                        }, g.call(b.prototype), g.call(k.prototype), k.prototype.clone = function() {
                            return new k(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new p(this.headers),
                                url: this.url
                            });
                        }, k.error = function() {
                            var e1 = new k(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e1.type = "error", e1;
                        };
                        var O = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        k.redirect = function(e1, t) {
                            if (-1 === O.indexOf(t)) throw new RangeError("Invalid status code");
                            return new k(null, {
                                status: t,
                                headers: {
                                    location: e1
                                }
                            });
                        }, t.DOMException = e1.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e1) {
                            t.DOMException = function(e1, t) {
                                this.message = e1, this.name = t;
                                var n = Error(e1);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function T(e1, n) {
                            return new Promise(function(r, i) {
                                var a = new b(e1, n);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function c() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e1, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e1 = u.getAllResponseHeaders() || "", t = new p, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                            var n = e1.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var o = "response" in u ? u.response : u.responseText;
                                    r(new k(o, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && o && (u.responseType = "blob"), a.headers.forEach(function(e1, t) {
                                    u.setRequestHeader(t, e1);
                                }), a.signal && (a.signal.addEventListener("abort", c), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", c);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        T.polyfill = !0, e1.fetch || (e1.fetch = T, e1.Headers = p, e1.Request = b, e1.Response = k), t.Headers = p, t.Request = b, t.Response = k, t.fetch = T, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e1.exports = t;
            },
            5643: function(e1) {
                e1.exports = !1;
            },
            4279: function(e1) {
                function t() {}
                t.prototype = {
                    on: function(e1, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e1] || (r[e1] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e1, t, n) {
                        var r = this;
                        function o() {
                            r.off(e1, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e1, o, n);
                    },
                    emit: function(e1) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e1] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e1, t) {
                        var n = this.e || (this.e = {}), r = n[e1], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e1] = o : delete n[e1], this;
                    }
                }, e1.exports = t;
            },
            199: function() {},
            6115: function(e1) {
                e1.exports = function(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6690: function(e1) {
                e1.exports = function(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3515: function(e1, t, n) {
                var r = n(6015), o = n(9617);
                function i(t, n, a) {
                    return o() ? (e1.exports = i = Reflect.construct.bind(), e1.exports.__esModule = !0, e1.exports.default = e1.exports) : (e1.exports = i = function(e1, t, n) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        var i = new (Function.bind.apply(e1, o));
                        return n && r(i, n.prototype), i;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports), i.apply(null, arguments);
                }
                e1.exports = i, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9728: function(e1) {
                function t(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, r.key, r);
                    }
                }
                e1.exports = function(e1, n, r) {
                    return n && t(e1.prototype, n), r && t(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3808: function(e1) {
                function t(n) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            1655: function(e1, t, n) {
                var r = n(6015);
                e1.exports = function(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && r(e1, t);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6035: function(e1) {
                e1.exports = function(e1) {
                    return -1 !== Function.toString.call(e1).indexOf("[native code]");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9617: function(e1) {
                e1.exports = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4993: function(e1, t, n) {
                var r = n(8698).default, o = n(6115);
                e1.exports = function(e1, t) {
                    if (t && ("object" === r(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return o(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            7061: function(e1, t, n) {
                var r = n(8698).default;
                function o() {
                    "use strict";
                    e1.exports = o = function() {
                        return t;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
                    var t = {}, n = Object.prototype, i = n.hasOwnProperty, a = "function" == typeof Symbol ? Symbol : {}, u = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", s = a.toStringTag || "@@toStringTag";
                    function f(e1, t, n) {
                        return Object.defineProperty(e1, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, n) {
                            return e1[t] = n;
                        };
                    }
                    function l(e1, t, n, r) {
                        var o = t && t.prototype instanceof d ? t : d, i = Object.create(o.prototype), a = new S(r || []);
                        return i._invoke = function(e1, t, n) {
                            var r = "suspendedStart";
                            return function(o, i) {
                                if ("executing" === r) throw new Error("Generator is already running");
                                if ("completed" === r) {
                                    if ("throw" === o) throw i;
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                for(n.method = o, n.arg = i;;){
                                    var a = n.delegate;
                                    if (a) {
                                        var u = T(a, n);
                                        if (u) {
                                            if (u === h) continue;
                                            return u;
                                        }
                                    }
                                    if ("next" === n.method) n.sent = n._sent = n.arg;
                                    else if ("throw" === n.method) {
                                        if ("suspendedStart" === r) throw r = "completed", n.arg;
                                        n.dispatchException(n.arg);
                                    } else "return" === n.method && n.abrupt("return", n.arg);
                                    r = "executing";
                                    var c = p(e1, t, n);
                                    if ("normal" === c.type) {
                                        if (r = n.done ? "completed" : "suspendedYield", c.arg === h) continue;
                                        return {
                                            value: c.arg,
                                            done: n.done
                                        };
                                    }
                                    "throw" === c.type && (r = "completed", n.method = "throw", n.arg = c.arg);
                                }
                            };
                        }(e1, n, a), i;
                    }
                    function p(e1, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, n)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = l;
                    var h = {};
                    function d() {}
                    function v() {}
                    function y() {}
                    var g = {};
                    f(g, u, function() {
                        return this;
                    });
                    var m = Object.getPrototypeOf, b = m && m(m(x([])));
                    b && b !== n && i.call(b, u) && (g = b);
                    var w = y.prototype = d.prototype = Object.create(g);
                    function k(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function O(e1, t) {
                        function n(o, a, u, c) {
                            var s = p(e1[o], e1, a);
                            if ("throw" !== s.type) {
                                var f = s.arg, l = f.value;
                                return l && "object" == r(l) && i.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    n("next", e1, u, c);
                                }, function(e1) {
                                    n("throw", e1, u, c);
                                }) : t.resolve(l).then(function(e1) {
                                    f.value = e1, u(f);
                                }, function(e1) {
                                    return n("throw", e1, u, c);
                                });
                            }
                            c(s.arg);
                        }
                        var o;
                        this._invoke = function(e1, r) {
                            function i() {
                                return new t(function(t, o) {
                                    n(e1, r, t, o);
                                });
                            }
                            return o = o ? o.then(i, i) : i();
                        };
                    }
                    function T(e1, t) {
                        var n = e1.iterator[t.method];
                        if (void 0 === n) {
                            if (t.delegate = null, "throw" === t.method) {
                                if (e1.iterator.return && (t.method = "return", t.arg = void 0, T(e1, t), "throw" === t.method)) return h;
                                t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return h;
                        }
                        var r = p(n, e1.iterator, t.arg);
                        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, h;
                        var o = r.arg;
                        return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function Z(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function E(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function S(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(Z, this), this.reset(!0);
                    }
                    function x(e1) {
                        if (e1) {
                            var t = e1[u];
                            if (t) return t.call(e1);
                            if ("function" == typeof e1.next) return e1;
                            if (!isNaN(e1.length)) {
                                var n = -1, r = function t() {
                                    for(; ++n < e1.length;)if (i.call(e1, n)) return t.value = e1[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return r.next = r;
                            }
                        }
                        return {
                            next: P
                        };
                    }
                    function P() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return v.prototype = y, f(w, "constructor", y), f(y, "constructor", v), v.displayName = f(y, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, y) : (e1.__proto__ = y, f(e1, s, "GeneratorFunction")), e1.prototype = Object.create(w), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, k(O.prototype), f(O.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = O, t.async = function(e1, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new O(l(e1, n, r, o), i);
                        return t.isGeneratorFunction(n) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, k(w), f(w, s, "Generator"), f(w, u, function() {
                        return this;
                    }), f(w, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = [];
                        for(var n in e1)t.push(n);
                        return t.reverse(), function n() {
                            for(; t.length;){
                                var r = t.pop();
                                if (r in e1) return n.value = r, n.done = !1, n;
                            }
                            return n.done = !0, n;
                        };
                    }, t.values = x, S.prototype = {
                        constructor: S,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !e1) for(var t in this)"t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(e1) {
                            if (this.done) throw e1;
                            var t = this;
                            function n(n, r) {
                                return a.type = "throw", a.arg = e1, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
                            }
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var o = this.tryEntries[r], a = o.completion;
                                if ("root" === o.tryLoc) return n("end");
                                if (o.tryLoc <= this.prev) {
                                    var u = i.call(o, "catchLoc"), c = i.call(o, "finallyLoc");
                                    if (u && c) {
                                        if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                        if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                    } else if (u) {
                                        if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var o = r;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), h;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e1) return this.complete(n.completion, n.afterLoc), E(n), h;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e1) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        E(n);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, t, n) {
                            return this.delegate = {
                                iterator: x(e1),
                                resultName: t,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, t;
                }
                e1.exports = o, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6015: function(e1) {
                function t(n, r) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n, r);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            8698: function(e1) {
                function t(n) {
                    return e1.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3496: function(e1, t, n) {
                var r = n(3808), o = n(6015), i = n(6035), a = n(3515);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e1.exports = u = function(e1) {
                        if (null === e1 || !i(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e1)) return n.get(e1);
                            n.set(e1, t);
                        }
                        function t() {
                            return a(e1, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, u(t);
                }
                e1.exports = u, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4687: function(e1, t, n) {
                var r = n(7061)();
                e1.exports = r;
                try {
                    regeneratorRuntime = r;
                } catch (e1) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
                }
            },
            907: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            7326: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            5861: function(e1, t, n) {
                "use strict";
                function r(e1, t, n, r, o, i, a) {
                    try {
                        var u = e1[i](a), c = u.value;
                    } catch (e1) {
                        return void n(e1);
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o);
                }
                function o(e1) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(o, i) {
                            var a = e1.apply(t, n);
                            function u(e1) {
                                r(a, o, i, u, c, "next", e1);
                            }
                            function c(e1) {
                                r(a, o, i, u, c, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            5671: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            3144: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, r.key, r);
                    }
                }
                function o(e1, t, n) {
                    return t && r(e1.prototype, t), n && r(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            4942: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    return t in e1 ? Object.defineProperty(e1, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = n, e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            1752: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1120);
                function o(e1, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = (0, r.Z)(e1)););
                    return e1;
                }
                function i() {
                    return i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e1, t, n) {
                        var r = o(e1, t);
                        if (r) {
                            var i = Object.getOwnPropertyDescriptor(r, t);
                            return i.get ? i.get.call(arguments.length < 3 ? e1 : n) : i.value;
                        }
                    }, i.apply(this, arguments);
                }
            },
            1120: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            136: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9611);
                function o(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && (0, r.Z)(e1, t);
                }
            },
            4925: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (null == e1) return {};
                    var n, r, o = function(e1, t) {
                        if (null == e1) return {};
                        var n, r, o = {}, i = Object.keys(e1);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e1[n]);
                        return o;
                    }(e1, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e1);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e1, n) && (o[n] = e1[n]);
                    }
                    return o;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            2963: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1002), o = n(7326);
                function i(e1, t) {
                    if (t && ("object" === (0, r.Z)(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return (0, o.Z)(e1);
                }
            },
            9611: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, r(e1, t);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            885: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(181);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var n = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != n) {
                            var r, o, i = [], a = !0, u = !1;
                            try {
                                for(n = n.call(e1); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                            } catch (e1) {
                                u = !0, o = e1;
                            } finally{
                                try {
                                    a || null == n.return || n.return();
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return i;
                        }
                    }(e1, t) || (0, r.Z)(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            2982: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(907), o = n(181);
                function i(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return (0, r.Z)(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || (0, o.Z)(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            1002: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            181: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(907);
                function o(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return (0, r.Z)(e1, t);
                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e1, t) : void 0;
                    }
                }
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e1[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e1, t) {
            for(var r in t)n.o(t, r) && !n.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, n.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                AuthenticatorKey: function() {
                    return y.pc;
                },
                BaseTransaction: function() {
                    return g.mV;
                },
                EmailChallengeTransaction: function() {
                    return g.nh;
                },
                EmailRole: function() {
                    return g.aw;
                },
                EmailStatusTransaction: function() {
                    return g.XC;
                },
                EmailTransaction: function() {
                    return g.yB;
                },
                IdxFeature: function() {
                    return y.Fw;
                },
                IdxStatus: function() {
                    return y.Qd;
                },
                OktaAuth: function() {
                    return Z;
                },
                PasswordStatus: function() {
                    return g.Fn;
                },
                PasswordTransaction: function() {
                    return g.QU;
                },
                PhoneTransaction: function() {
                    return g.$N;
                },
                ProfileSchemaTransaction: function() {
                    return g.XW;
                },
                ProfileTransaction: function() {
                    return g.Sx;
                },
                Status: function() {
                    return g.qb;
                },
                addEmail: function() {
                    return g.no;
                },
                addPhone: function() {
                    return g.Z1;
                },
                authenticate: function() {
                    return y.YR;
                },
                canProceed: function() {
                    return y.Ch;
                },
                cancel: function() {
                    return y.al;
                },
                clearTransactionMeta: function() {
                    return y.Jm;
                },
                createAuthnTransactionAPI: function() {
                    return m.b;
                },
                createIdxAPI: function() {
                    return y.F4;
                },
                createIdxOptionsConstructor: function() {
                    return y.SL;
                },
                createIdxStorageManager: function() {
                    return y.aT;
                },
                createIdxTransactionManager: function() {
                    return y.vK;
                },
                createOktaAuthIdx: function() {
                    return y.Yn;
                },
                createOktaAuthMyAccount: function() {
                    return g.Xc;
                },
                createTransactionMeta: function() {
                    return y.Xc;
                },
                deleteEmail: function() {
                    return g.nd;
                },
                deletePassword: function() {
                    return g.QN;
                },
                deletePhone: function() {
                    return g.qj;
                },
                enrollPassword: function() {
                    return g.xg;
                },
                getEmail: function() {
                    return g.OD;
                },
                getEmailChallenge: function() {
                    return g.hG;
                },
                getEmails: function() {
                    return g.G5;
                },
                getPassword: function() {
                    return g.Ij;
                },
                getPhone: function() {
                    return g.u_;
                },
                getPhones: function() {
                    return g.Po;
                },
                getProfile: function() {
                    return g.Ai;
                },
                getProfileSchema: function() {
                    return g.aF;
                },
                getSavedTransactionMeta: function() {
                    return y.uN;
                },
                getTransactionMeta: function() {
                    return y.Co;
                },
                handleEmailVerifyCallback: function() {
                    return y.Jn;
                },
                handleInteractionCodeRedirect: function() {
                    return y.Xx;
                },
                hasSavedInteractionHandle: function() {
                    return y.$0;
                },
                interact: function() {
                    return y.EW;
                },
                introspect: function() {
                    return y.L8;
                },
                isAuthenticator: function() {
                    return y.H;
                },
                isEmailVerifyCallback: function() {
                    return y.GA;
                },
                isEmailVerifyCallbackError: function() {
                    return y.gc;
                },
                isTransactionMetaValid: function() {
                    return y.Wf;
                },
                isTransactionMetaValidForFlow: function() {
                    return y.bl;
                },
                isTransactionMetaValidForOptions: function() {
                    return y.UC;
                },
                mixinAuthn: function() {
                    return m.t;
                },
                mixinIdx: function() {
                    return y.B_;
                },
                mixinMyAccount: function() {
                    return g.HT;
                },
                parseEmailVerifyCallback: function() {
                    return y.mo;
                },
                poll: function() {
                    return y.$l;
                },
                proceed: function() {
                    return y.xc;
                },
                recoverPassword: function() {
                    return y.M4;
                },
                register: function() {
                    return y.z2;
                },
                saveTransactionMeta: function() {
                    return y.r0;
                },
                sendEmailChallenge: function() {
                    return g.ME;
                },
                sendPhoneChallenge: function() {
                    return g.dv;
                },
                startTransaction: function() {
                    return y.Yr;
                },
                unlockAccount: function() {
                    return y.le;
                },
                updatePassword: function() {
                    return g.gQ;
                },
                updateProfile: function() {
                    return g.ck;
                },
                verifyEmailChallenge: function() {
                    return g.T8;
                },
                verifyPhoneChallenge: function() {
                    return g.Lo;
                }
            });
            var e1 = n(3144), t = n(5671), o = n(136), i = n(2963), a = n(1120), u = n(4602), c = n(4143), s = n(3334), f = n(2144), l = n(6794), p = n(8284), h = n(6736), d = {};
            for(var v in h)[
                "default",
                "OktaAuth"
            ].indexOf(v) < 0 && (d[v] = (function(e1) {
                return h[e1];
            }).bind(0, v));
            n.d(r, d);
            var y = n(683), g = n(1132), m = n(3398);
            var b = (0, u.S)(), w = (0, c.a)(), k = (0, s.v)(), O = (0, f.Y)(w, b, k), T = (0, l.H)(O), Z = function(n) {
                (0, o.Z)(s, n);
                var r, u, c = (r = s, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }(), function() {
                    var e1, t = (0, a.Z)(r);
                    if (u) {
                        var n = (0, a.Z)(this).constructor;
                        e1 = Reflect.construct(t, arguments, n);
                    } else e1 = t.apply(this, arguments);
                    return (0, i.Z)(this, e1);
                });
                function s(e1) {
                    return (0, t.Z)(this, s), c.call(this, e1);
                }
                return (0, e1.Z)(s);
            }((0, p.t)(T));
            r.default = Z;
        }(), r;
    }();
});


function $0c15f44f3f7f8172$export$2e2bcd8739ae039(v1, v2) {
    // validate input and split into segments
    const n1 = $0c15f44f3f7f8172$var$validateAndParse(v1);
    const n2 = $0c15f44f3f7f8172$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $0c15f44f3f7f8172$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $0c15f44f3f7f8172$var$compareSegments(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const $0c15f44f3f7f8172$export$a22775fa5e2eebd9 = (v)=>typeof v === 'string' && /^[v\d]/.test(v) && $0c15f44f3f7f8172$var$semver.test(v);
const $0c15f44f3f7f8172$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $0c15f44f3f7f8172$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $0c15f44f3f7f8172$export$2e2bcd8739ae039(v1, v2);
    return $0c15f44f3f7f8172$var$operatorResMap[operator].includes(res);
};
const $0c15f44f3f7f8172$export$b8fab89fe6d5d7da = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : '=';
    // if gt/lt/eq then operator compare
    if (op !== '^' && op !== '~') return $0c15f44f3f7f8172$export$398604a469f7de9a(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = $0c15f44f3f7f8172$var$validateAndParse(v);
    const [r1, r2, r3] = $0c15f44f3f7f8172$var$validateAndParse(r);
    if ($0c15f44f3f7f8172$var$compareStrings(v1, r1) !== 0) return false;
    if (op === '^') return $0c15f44f3f7f8172$var$compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if ($0c15f44f3f7f8172$var$compareStrings(v2, r2) !== 0) return false;
    return $0c15f44f3f7f8172$var$compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
$0c15f44f3f7f8172$export$2e2bcd8739ae039.validate = $0c15f44f3f7f8172$export$a22775fa5e2eebd9;
$0c15f44f3f7f8172$export$2e2bcd8739ae039.compare = $0c15f44f3f7f8172$export$398604a469f7de9a;
$0c15f44f3f7f8172$export$2e2bcd8739ae039.satisfies = $0c15f44f3f7f8172$export$b8fab89fe6d5d7da;
const $0c15f44f3f7f8172$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $0c15f44f3f7f8172$var$validateAndParse = (v)=>{
    if (typeof v !== 'string') throw new TypeError('Invalid argument expected string');
    const match = v.match($0c15f44f3f7f8172$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const $0c15f44f3f7f8172$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $0c15f44f3f7f8172$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $0c15f44f3f7f8172$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $0c15f44f3f7f8172$var$compareStrings = (a, b)=>{
    if ($0c15f44f3f7f8172$var$isWildcard(a) || $0c15f44f3f7f8172$var$isWildcard(b)) return 0;
    const [ap, bp] = $0c15f44f3f7f8172$var$forceType($0c15f44f3f7f8172$var$tryParse(a), $0c15f44f3f7f8172$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $0c15f44f3f7f8172$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $0c15f44f3f7f8172$var$compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const $0c15f44f3f7f8172$var$operatorResMap = {
    '>': [
        1
    ],
    '>=': [
        0,
        1
    ],
    '=': [
        0
    ],
    '<=': [
        -1,
        0
    ],
    '<': [
        -1
    ]
};
const $0c15f44f3f7f8172$var$allowedOperators = Object.keys($0c15f44f3f7f8172$var$operatorResMap);
const $0c15f44f3f7f8172$var$assertValidOperator = (op)=>{
    if (typeof op !== 'string') throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($0c15f44f3f7f8172$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$0c15f44f3f7f8172$var$allowedOperators.join('|')}`);
};



var $g5Zhu = parcelRequire("g5Zhu");
var $c5fdcdd8d5286ae7$exports = {};

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;



var $54656f276146068e$export$df9a5fb346e7c0bb = /*#__PURE__*/ $acw62.createContext(null);
var $54656f276146068e$export$2ae4a19e09ca9a00 = function useOktaAuth() {
    return $acw62.useContext($54656f276146068e$export$df9a5fb346e7c0bb);
};
var $54656f276146068e$var$OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ $acw62.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ $acw62.createElement("p", null, "Error: ", error.toString());
};
var $54656f276146068e$export$9fb697de7778c436 = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = $acw62.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    $acw62.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn('Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.');
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(oktaAuth, originalUri) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            restoreOriginalUri(oktaAuth, originalUri);
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    $acw62.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.7.0"));
        else console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    if (!oktaAuth) {
        var err = new (0, $b6fcb3bf036a7cae$exports.AuthSdkError)('No oktaAuth instance passed to Security Component.');
        return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, $b6fcb3bf036a7cae$exports.AuthSdkError)('No restoreOriginalUri callback passed to Security Component.');
        return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
    else {
        var isAuthJsSupported = (0, $0c15f44f3f7f8172$export$398604a469f7de9a)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", '>=');
        if (!isAuthJsSupported) {
            var _err2 = new (0, $b6fcb3bf036a7cae$exports.AuthSdkError)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ $acw62.createElement($54656f276146068e$export$df9a5fb346e7c0bb.Provider, {
        value: {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        }
    }, children);
};
function $54656f276146068e$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54656f276146068e$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54656f276146068e$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54656f276146068e$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $54656f276146068e$export$683729e5315f529b = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = $54656f276146068e$export$2ae4a19e09ca9a00();
        return /*#__PURE__*/ $acw62.createElement(ComponentToWrap, $54656f276146068e$var$_objectSpread$1($54656f276146068e$var$_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = 'withOktaAuth_' + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var $54656f276146068e$export$8f938467209eea73 = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = $54656f276146068e$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || $54656f276146068e$var$OktaError;
    $acw62.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        oktaAuth.handleLoginRedirect()["catch"](function(e) {
            setCallbackError(e);
        });
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ $acw62.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var $54656f276146068e$var$_excluded = [
    "onAuthRequired",
    "errorComponent"
];
function $54656f276146068e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54656f276146068e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54656f276146068e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54656f276146068e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $54656f276146068e$var$useMatch;
if ('useRouteMatch' in $3189c83282a9a1c6$exports) $54656f276146068e$var$useMatch = $3189c83282a9a1c6$exports['useRouteMatch' in $3189c83282a9a1c6$exports ? 'useRouteMatch' : ''];
else $54656f276146068e$var$useMatch = function useMatch() {
    throw new (0, $b6fcb3bf036a7cae$exports.AuthSdkError)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var $54656f276146068e$export$d93cdd50e579241c = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $54656f276146068e$var$_excluded);
    var _useOktaAuth = $54656f276146068e$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = $54656f276146068e$var$useMatch(routeProps);
    var pendingLogin = $acw62.useRef(false);
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || $54656f276146068e$var$OktaError;
    $acw62.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, $b6fcb3bf036a7cae$exports.toRelativeUrl)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ $acw62.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ $acw62.createElement($3189c83282a9a1c6$exports.Route, $54656f276146068e$var$_objectSpread({}, routeProps));
};



var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $cfUWu = parcelRequire("cfUWu");

var $2HliV = parcelRequire("2HliV");
'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $942f413c6b94358c$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $eEJPp.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $942f413c6b94358c$var$maybeReactUseSyncExternalStore = $acw62.useSyncExternalStore;
function $942f413c6b94358c$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $942f413c6b94358c$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $942f413c6b94358c$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $2HliV.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $cfUWu.default)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $942f413c6b94358c$var$maybeReactUseSyncExternalStore !== undefined ? $942f413c6b94358c$var$useMediaQueryNew : $942f413c6b94358c$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


const $5cdc329eeebd56d0$export$47283907dceba392 = [
    {
        label: "",
        value: ""
    },
    {
        label: "AK",
        value: "AK"
    },
    {
        label: "TX",
        value: "TX"
    },
    {
        label: "WW",
        value: "WW"
    },
    {
        label: "CC",
        value: "CC"
    }
];
const $5cdc329eeebd56d0$export$ee046e4d5f9d0bff = 'companyName';
const $5cdc329eeebd56d0$export$53725c679acacd12 = 'firstName';
const $5cdc329eeebd56d0$export$a6a428b71d5a7380 = 'lastName';
const $5cdc329eeebd56d0$export$f18919be1a148b99 = 'fullName';
const $5cdc329eeebd56d0$export$77766cab5b9d943f = 'line1';
const $5cdc329eeebd56d0$export$2e968917aa230def = 'line2';
const $5cdc329eeebd56d0$export$a4900ad658a071e1 = 'city';
const $5cdc329eeebd56d0$export$63b4527a2777036f = 'state';
const $5cdc329eeebd56d0$export$fb1a5997e1305b7 = 'zipcode';
const $5cdc329eeebd56d0$export$61171c632678b12e = 'email';
const $5cdc329eeebd56d0$export$a44129614aa6afd6 = 'phone';
const $5cdc329eeebd56d0$export$204382a4fad8853d = 'hin';
const $5cdc329eeebd56d0$export$69cfba3da064c906 = 'dea';
const $5cdc329eeebd56d0$export$f9712c555f32a3f1 = {
    'AL': 'Alabama'
};
const $5cdc329eeebd56d0$export$9bad0e7b3fa81c9f = [];
const $5cdc329eeebd56d0$export$d8bd0967cb58683 = {
    minOrderQuantityNotMet: 'MINIMUM ORDER QUANTITY NOT MET'
};
const $5cdc329eeebd56d0$export$817ef71c6a5c14d6 = {
    'Admin/ Executive Asst': 'admin_executive_asst',
    'Ambulatory Clinical': 'ambulatory_clinical',
    'Billing Department': 'billing_department',
    'Business Support Professional': 'business_support_professional',
    'Buying Agent': 'buying_agent',
    'CEO': 'ceo',
    'Certified Nurse Assistant': 'certified_nurse_assistant',
    'Chief Medical Officer': 'chief_medical_officer',
    'Clinical Services/ Operations': 'clinical_services_operations',
    'Doctor of Dental Medicine': 'doctor_of_dental_medicine',
    'Doctor of Medicine (MD)': 'doctor_of_medicine_MD',
    'Doctor of Osteopathic Medicine (DO)': 'doctor_of_osteopathic_medicine_DO',
    'Epidemiologist': 'epidemiologist',
    'Health & Wellness': 'health_and_wellness',
    'Human Resources': 'human_resources',
    'Immunization Services': 'immunization_services',
    'Licensed Practical Nurse': 'licensed_practical_nurse',
    'Medical Assistant': 'medical_assistant',
    'Merchandiser': 'merchandiser',
    'Nurse Practitioner': 'nurse_practitioner',
    'Office Manager': 'office_manager',
    'Operations': 'operations',
    'Pharmacist': 'pharmacist',
    'Pharmacy Technician': 'pharmacy_technician',
    'Physician Assistant': 'physician_assistant',
    'Procurement': 'procurement',
    'Purchasing': 'purchasing',
    'Quality': 'quality',
    'Registered Nurse': 'registered_nurse',
    'Researcher': 'researcher',
    'Safety and Risk': 'safety_and_risk',
    'Scientist, PhD': 'scientist_PhD',
    'Shipping Department': 'shipping_department',
    'Supply Chain': 'supply_chain',
    'Vaccine Educator': 'vaccine_educator',
    'Other': 'undefined'
};
const $5cdc329eeebd56d0$export$e322f0dbe1d2219b = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];
const $5cdc329eeebd56d0$export$aa77aef8f9046d78 = {
    GROUP_PURCHASING_ORGANIZATION: 'GROUP_PURCHASING_ORGANIZATION',
    LETTER_OF_COMMITMENT: 'LETTER_OF_COMMITMENT',
    CUSTOMER_PRICE_LIST: 'CUSTOMER_PRICE_LIST',
    RETAIL_PHARMACY: 'RETAIL_PHARMACY',
    PHYSICIANS_BUYING_GROUP: 'PHYSICIANS_BUYING_GROUP',
    UNKNOWN: 'UNKNOWN'
};
const $5cdc329eeebd56d0$export$40226f0c159b164b = {
    UNVERIFIED: 'UNVERIFIED',
    VERIFIED: 'VERIFIED',
    ONBOARDING_PERSON_COMPLETE: 'ONBOARDING_PERSON_COMPLETE',
    ONBOARDING_ORG_COMPLETE: 'ONBOARDING_ORG_COMPLETE',
    ONBOARDING_SHIP_COMPLETE: 'ONBOARDING_SHIP_COMPLETE',
    ONBOARDING_BILL_COMPLETE: 'ONBOARDING_BILL_COMPLETE',
    ACTIVE: 'ACTIVE'
};
const $5cdc329eeebd56d0$export$f2d101b977a134fd = 'Unavailable';
const $5cdc329eeebd56d0$export$6d7da32a6a38f3bd = {
    GPO_MISSING_LINE_1: 'To access contract pricing for Group Purchasing Organizations or Physician Buying Groups, select your contract affiliation.',
    GPO_MISSING_LINE_2: 'Not all contracts may be available for selection at this time. Please check back again soon.',
    GPO_UNAVAILABLE: 'Contracts and pricing are not available at this time. Please check back periodically to select your contract affiliation and to view pricing.'
};
const $5cdc329eeebd56d0$export$d6e58abbbec7e1ac = {
    ACH: 'us_bank_account',
    CARD: 'card'
};
const $5cdc329eeebd56d0$export$9353cdd556d7eb72 = {
    PAY_NOW: 'PAY_NOW',
    PAY_LATER: 'PAY_LATER',
    PAY_INVOICE: 'PAY_INVOICE'
};
const $5cdc329eeebd56d0$export$4f89b831ca9f07a9 = {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING'
};
const $5cdc329eeebd56d0$export$46774d6b3c4ac9de = 'STRIPE';
const $5cdc329eeebd56d0$export$268651873d86e2ab = 'Pending';
const $5cdc329eeebd56d0$export$1d3e2cd80d3e050f = [
    "visa",
    "mastercard",
    "american_express",
    "discover_global_network"
];
const $5cdc329eeebd56d0$export$28680aab1ea491ee = {
    HIN: 'HIN',
    DEA: 'DEA',
    NPI: 'NPI'
};
const $5cdc329eeebd56d0$export$2b382c0fc02321b4 = {
    PAPERBOARD: 'PAPERBOARD',
    SYRINGE: 'SYRINGE'
};
const $5cdc329eeebd56d0$export$87c46495b4290e22 = 'modernatx.com';
const $5cdc329eeebd56d0$export$c19ece7ea27dcd9e = 'USD';
const $5cdc329eeebd56d0$export$c8d71fde6cf57c6 = {
    SOLD_TO: 'sold_to',
    SHIP_TO: 'ship_to',
    BILL_TO: 'bill_to'
};
const $5cdc329eeebd56d0$export$ec42b568fd72efee = 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/fa961ab5-b232-4de5-8df6-a049cdf0ae65/fa961ab5-b232-4de5-8df6-a049cdf0ae65_viewable_rendition__v.pdf';
const $5cdc329eeebd56d0$export$5b397dffa4d78add = {
    CUSTOMER_SELF_SELECTION: 'CUSTOMER_SELF_SELECTION'
};
const $5cdc329eeebd56d0$export$dc5bdaa405ea2f92 = {
    ACTIONS: 'ACTIONS',
    DATE_PLACED: 'DATE PLACED',
    DELIVERY_LOCATION: 'DELIVERY LOCATION',
    ORDER_ID: 'ORDER ID',
    ORDER_STATUS: 'ORDER STATUS',
    RESERVATION_STATUS: 'RESERVATION STATUS',
    PO_NUMBER: 'PO NUMBER',
    SHIPPING_ID: 'MCKESSON(RXC) SHIPPING ID',
    STATUS: 'STATUS',
    SUBTOTAL_AMOUNT: 'SUBTOTAL AMOUNT',
    PLACED_BY: 'PLACED BY',
    DOSES: 'DOSES'
};
const $5cdc329eeebd56d0$export$85f47c19c8bcc133 = {
    ACTIONS: 'ACTIONS',
    DATE_PLACED: 'DATE PLACED',
    DELIVERY_LOCATION: 'DELIVERY LOCATION',
    RESERVATION_ID: 'RESERVATION ID',
    RESERVATION_STATUS: 'RESERVATION STATUS',
    PO_NUMBER: 'PO NUMBER',
    SHIPPING_ID: 'MCKESSON(RXC) SHIPPING ID',
    STATUS: 'STATUS',
    SUBTOTAL_AMOUNT: 'SUBTOTAL AMOUNT',
    PLACED_BY: 'PLACED BY',
    DOSES: 'DOSES'
};
const $5cdc329eeebd56d0$export$46175cf3c9f87e59 = {
    CURRENT_YEAR: 'CURRENT_YEAR',
    PAST_YEARS: 'PAST_YEARS'
};
const $5cdc329eeebd56d0$export$192d1dc1dbfcad10 = `Orders must be made in increments of 10 doses (1 carton). \
  Other increments will be rounded up to the nearest carton.`;
const $5cdc329eeebd56d0$export$e1a0f5ca0b653d0a = `Reservations must be made in increments of 10 doses (1 carton). \
  Other increments will be rounded up to the nearest carton.`;
const $5cdc329eeebd56d0$export$48a9bc1ef927eec9 = "* List price subject to change prior to product availability.";
const $5cdc329eeebd56d0$export$5ea7db4374a8364e = new Date().getFullYear();
const $5cdc329eeebd56d0$export$94e54707343393a0 = $5cdc329eeebd56d0$export$5ea7db4374a8364e + 1;
const $5cdc329eeebd56d0$export$c7d352a9132e21fd = 'Place your reservation';
const $5cdc329eeebd56d0$export$a792157d3224929 = 'no-contract';



const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


const $382eb84981692d3a$export$7d809d729bfb7d8e = (fieldType, value)=>{
    let isValid = true;
    switch(fieldType){
        case "email":
            {
                const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                if (!pattern.test(value)) isValid = false;
                break;
            }
        case "password":
            {
                const pattern = new RegExp("^(?=.{12,}$)(?=.*[A-Z])(?=.*[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).+$");
                if (!pattern.test(value)) isValid = false;
                break;
            }
        case "hin":
            {
                const pattern = new RegExp("^[a-zA-Z0-9]{9,9}$");
                if (!pattern.test(value)) isValid = false;
                break;
            }
        case "dea":
            {
                const pattern = new RegExp("^[a-zA-Z][a-zA-Z0-9][0-9]{7}$");
                if (!pattern.test(value)) isValid = false;
                break;
            }
        case "phone":
            {
                const pattern = new RegExp(/^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/);
                if (!pattern.test(value)) isValid = false;
                break;
            }
        case "zipcode":
            {
                const pattern = new RegExp(/^\d{5}(-\d{4})?$/);
                if (!pattern.test(value)) isValid = false;
                break;
            }
        default:
            console.log("Invalid choice");
            break;
    }
    return isValid;
};
const $382eb84981692d3a$export$100ac8a83b695e8 = (email, password, invalidEmailFormatError)=>{
    let isValid = true;
    let errors = {
        email: '',
        password: ''
    };
    if (!email) {
        isValid = false;
        errors.email = "Please enter your email address.";
    } else if (!$382eb84981692d3a$export$7d809d729bfb7d8e("email", email)) {
        isValid = false;
        errors.email = invalidEmailFormatError;
    } else if (email?.toLowerCase().includes((0, $5cdc329eeebd56d0$export$87c46495b4290e22))) {
        isValid = false;
        errors.email = "Email addresses containing the modernatx domain are not allowed.";
    }
    if (!password) {
        isValid = false;
        errors.password = "Please enter your password.";
    }
    return {
        isValid: isValid,
        errors: errors
    };
};
const $382eb84981692d3a$export$ff626af7f207c74d = (date)=>{
    let outputDate = new Date(date?.replace(/-/g, '/').replace(/T.+/, '')).toLocaleDateString('en-us', {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    return outputDate;
};
const $382eb84981692d3a$export$8304a22d431f958 = (str)=>{
    let checkStr = str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return checkStr !== null;
};
const $382eb84981692d3a$export$bdc112e4021a968d = (url)=>new URL(url).origin !== window.location.origin;
const $382eb84981692d3a$export$67e6063bf3b632af = (product)=>{
    return product && {
        "product_name": `${product.name}`,
        "product_id": product.code,
        "ndc_number": product.ndc,
        "product_detail": `${product.summary}:${product.doseVolume} ${product.doseVolumeUOM}:${product.ageGroup}`,
        "data-product-allocated-quantity": product.customerInventory?.allocatedQuantity,
        "data-product-remaining-allocated-quantity": product.customerInventory?.remainingAllocatedQuantity,
        "data-product-doses-per-carton": product.dosesPerCarton,
        "data-product-gpo-name": product.gpoDetails?.gpoName,
        "data-product-gpo-member-id": product.gpoDetails?.memberId,
        "data-product-dose-price": `${product.dosePrice?.value} ${product.dosePrice?.currencyIso}`,
        "data-product-default-dose-price": `${product.defaultDosePrice?.value} ${product.defaultDosePrice?.currencyIso}`
    };
};
const $382eb84981692d3a$export$b7258b4f5896d18e = ()=>{
    localStorage.removeItem("currentUser");
    localStorage.removeItem("commerceAuthTokenExpiry");
    localStorage.removeItem("commerceNewAuthToken");
};
const $382eb84981692d3a$export$5e4074cbce6574c7 = (region)=>{
    const parts = region?.isocode.split('-');
    return parts?.[1].trim();
};
const $382eb84981692d3a$export$fa295b83bf634638 = (a, b)=>{
    if (a?.defaultAddress !== b?.defaultAddress) return b?.defaultAddress - a?.defaultAddress;
    const nameComparison = a?.companyName?.localeCompare(b?.companyName);
    if (nameComparison === 0) return a?.line1?.localeCompare(b?.line1);
    return nameComparison;
};
const $382eb84981692d3a$export$bea7bc6c77f07e11 = (price)=>{
    if (price === null || price === undefined || isNaN(price)) return 'Unavailable';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};
const $382eb84981692d3a$export$d11f422a88fa3349 = (targetArray, sortOrder, field)=>{
    if (!Array.isArray(targetArray)) throw new TypeError(`Expected an array, but received type: ${Object.prototype.toString.call(targetArray)}`);
    targetArray.forEach((element, index)=>{
        if (!(field in element)) throw new Error(`Field "${field}" not found in element: ${index}`);
    });
    const orderMap = new Map(sortOrder.map((item, index)=>[
            item,
            index
        ]));
    //elements whose field value is not in sortOrder will be sorted to the end
    targetArray?.sort((a, b)=>{
        const indexA = orderMap.has(a[field]) ? orderMap.get(a[field]) : sortOrder.length;
        const indexB = orderMap.has(b[field]) ? orderMap.get(b[field]) : sortOrder.length;
        return indexA - indexB;
    });
    return targetArray;
};
const $382eb84981692d3a$export$92ca0a339839f9a5 = (ndcValue)=>{
    if (!ndcValue) return '';
    if (ndcValue === '80777-102-93') return '80777-102-96';
    return ndcValue;
};
// Setting priority of display for each product code
const $382eb84981692d3a$var$productPriority = {
    70506: 1,
    70840: 2,
    70545: 3,
    //we want adult product(12yr+) to be displayed first
    70733: 4,
    70842: 5,
    //NextGen
    70962: 6
};
const $382eb84981692d3a$export$7699132b966bad47 = (array, key)=>{
    const DEFAULT_PRIORITY = Number.MAX_SAFE_INTEGER;
    return array?.sort((a, b)=>{
        const priorityA = $382eb84981692d3a$var$productPriority[a[key]] ?? DEFAULT_PRIORITY;
        const priorityB = $382eb84981692d3a$var$productPriority[b[key]] ?? DEFAULT_PRIORITY;
        return priorityA - priorityB;
    });
};
const $382eb84981692d3a$export$3fba3ce1b8c1659a = (imageInfo)=>{
    return imageInfo && [
        ...imageInfo
    ]?.sort((a, b)=>{
        const aIndex = Object.values((0, $5cdc329eeebd56d0$export$2b382c0fc02321b4)).indexOf(a.imageType);
        const bIndex = Object.values((0, $5cdc329eeebd56d0$export$2b382c0fc02321b4)).indexOf(b.imageType);
        return (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex);
    });
};
const $382eb84981692d3a$export$3d0feebafbb8a231 = ()=>{
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.orderableProducts) || [];
};
const $382eb84981692d3a$export$7c54fad7190d0375 = ()=>(0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
const $382eb84981692d3a$export$77dcbd953f9a942d = (value)=>{
    const dollar = parseFloat(value.replace(/[^0-9.]/g, ""));
    if (isNaN(dollar)) return null;
    // Convert the dollar to cents (multiply by 100 and round)
    const cents = Math.round(dollar * 100);
    return cents;
};
const $382eb84981692d3a$export$dd58d1211079db17 = (value)=>{
    const number = parseFloat(value) / 100;
    if (isNaN(number)) return "";
    // Format number to USD style with two decimal places
    return `$${number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};




var $d8seH = parcelRequire("d8seH");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");

var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bOOlK.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $7HKeb.default)(defaultTheme);
        const _extendSxProp = (0, $hcz0Q.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");
var $1c9d33d7f337755d$exports = {};
$1c9d33d7f337755d$exports = new URL("header-logo.54c6c482.png", import.meta.url).toString();


var $cae26eb3e513e591$exports = {};
$cae26eb3e513e591$exports = new URL("Logo-Facebook.b28b61b4.svg", import.meta.url).toString();


var $917a30801c2d98ec$exports = {};
$917a30801c2d98ec$exports = new URL("Logo-Instagram.328fe97e.svg", import.meta.url).toString();


var $9afbd4a302104fef$exports = {};
$9afbd4a302104fef$exports = new URL("Logo-X.7956b0c1.svg", import.meta.url).toString();


var $95db296c2f6fff2d$exports = {};
$95db296c2f6fff2d$exports = new URL("Logo-LinkedIn.a9ca821d.svg", import.meta.url).toString();


var $724a4ace35544578$exports = {};
$724a4ace35544578$exports = new URL("NABP-certified.f41fbd43.png", import.meta.url).toString();


const $570b2653a8a10984$export$4c2bf9c4cb98e454 = {
    copyrightMessage: "\xa9 2025 Moderna, Inc. ",
    imageData: (0, (/*@__PURE__*/$parcel$interopDefault($1c9d33d7f337755d$exports))),
    socialLinks: [
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '7efqMp5o0dP7mEOTW2jpaZ',
                type: 'Entry',
                createdAt: '2021-12-15T19:20:19.232Z',
                updatedAt: '2022-10-28T17:39:26.811Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 17,
                revision: 6,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'socialLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Facebook SocialLink',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2a3smvGHyeYARfvkI38Uju',
                        type: 'Entry',
                        createdAt: '2021-12-15T19:20:08.646Z',
                        updatedAt: '2021-12-15T19:20:08.646Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Facebook Link',
                        label: 'Facebook',
                        url: 'https://www.facebook.com/modernatx/'
                    }
                },
                icon: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3p3fBOwbP2ml2V9Hxb7xkg',
                        type: 'Asset',
                        createdAt: '2022-10-28T17:39:18.324Z',
                        updatedAt: '2022-12-15T22:21:22.835Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 16,
                        revision: 3,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Facebook Icon',
                        description: '',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($cae26eb3e513e591$exports))),
                            details: {
                                size: 857,
                                image: {
                                    width: 82,
                                    height: 82
                                }
                            },
                            fileName: 'fb.png',
                            contentType: 'image/png'
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '2Dmb8HKJ9Z2NYgwyxTb2a2',
                type: 'Entry',
                createdAt: '2021-12-15T19:23:32.124Z',
                updatedAt: '2022-10-28T17:38:30.502Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 19,
                revision: 7,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'socialLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Twitter SocialLink',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5zPEOXT6elJMyMpLChBuW6',
                        type: 'Entry',
                        createdAt: '2021-12-15T19:21:54.452Z',
                        updatedAt: '2021-12-15T19:21:54.452Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'X Link',
                        label: 'X',
                        url: 'https://x.com/moderna_tx'
                    }
                },
                icon: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6VGtxnDHcT2N68cJpgG0hI',
                        type: 'Asset',
                        createdAt: '2022-10-28T17:38:11.623Z',
                        updatedAt: '2022-12-15T22:22:21.078Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 8,
                        revision: 2,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'X Icon',
                        description: '',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($9afbd4a302104fef$exports))),
                            details: {
                                size: 1204,
                                image: {
                                    width: 82,
                                    height: 82
                                }
                            },
                            fileName: 'X.png',
                            contentType: 'image/png'
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '6iVHoQKoQHT82WhD97iCsm',
                type: 'Entry',
                createdAt: '2021-12-17T18:33:15.466Z',
                updatedAt: '2022-10-28T17:54:12.824Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 21,
                revision: 7,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'socialLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Instagram SocialLink',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5bojUkeNFpoAuCVVmOhm0u',
                        type: 'Entry',
                        createdAt: '2021-12-17T18:33:07.849Z',
                        updatedAt: '2022-01-19T06:19:29.704Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Instagram Link',
                        label: 'Instagram',
                        url: 'https://www.instagram.com/moderna_tx'
                    }
                },
                icon: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7e6aSUfeu011v2SXhYgPzT',
                        type: 'Asset',
                        createdAt: '2022-10-28T17:54:00.287Z',
                        updatedAt: '2022-12-15T22:22:49.562Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 12,
                        revision: 3,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Instagram Icon',
                        description: '',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($917a30801c2d98ec$exports))),
                            details: {
                                size: 1371,
                                image: {
                                    width: 82,
                                    height: 82
                                }
                            },
                            fileName: 'Instagram.png',
                            contentType: 'image/png'
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '4dIvlvBfuddSktPqDMnc6X',
                type: 'Entry',
                createdAt: '2023-05-30T18:50:43.985Z',
                updatedAt: '2023-05-30T18:54:24.749Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'socialLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'LinkedIn SocialLink',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4CcCib7VOG8u510FaBuJH2',
                        type: 'Entry',
                        createdAt: '2021-12-17T18:34:03.109Z',
                        updatedAt: '2021-12-17T18:34:03.109Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'LinkedIn Link',
                        label: 'LinkedIn',
                        url: 'https://www.linkedin.com/company/modernatx/'
                    }
                },
                icon: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'B4aH3BNhpu7HiKPUoZ5RE',
                        type: 'Asset',
                        createdAt: '2022-10-28T17:39:46.023Z',
                        updatedAt: '2022-12-15T22:23:11.303Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 11,
                        revision: 4,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'LinkedIn Icon',
                        description: '',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($95db296c2f6fff2d$exports))),
                            details: {
                                size: 946,
                                image: {
                                    width: 82,
                                    height: 82
                                }
                            },
                            fileName: 'LinkedIn.png',
                            contentType: 'image/png'
                        }
                    }
                }
            }
        }
    ],
    footerGroups: [
        {
            subHeading: 'Useful Links',
            label: [
                'Authorized Distributors',
                'Participating Physician Buying Groups',
                'Frequently Asked Questions ',
                'Contact Us',
                'Wholesale Acquisition Cost (CO, CT)',
                'DSCSA Compliance'
            ],
            footerGroupLinks: [
                'authorized-distributor',
                'participating-physician-buying-groups',
                'faqs',
                'contact-us',
                'wac-disclosure',
                'dscsa'
            ]
        },
        {
            subHeading: 'TOOLS & RESOURCES',
            label: [
                'Billing Codes',
                'Tax Exemption Certificate Submission',
                'About Moderna',
                'Newsroom'
            ],
            footerGroupLinks: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1ZmT8sH6NncPudYT0c4LmS',
                        type: 'Entry',
                        createdAt: '2023-09-28T21:54:15.576Z',
                        updatedAt: '2023-09-28T21:54:15.576Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Billing Codes',
                        label: 'Billing Codes',
                        url: 'https://reimbursement.modernatx.com/'
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1vB7kKEXkvSAkiklEh9av3',
                        type: 'Entry',
                        createdAt: '2023-09-28T21:54:49.933Z',
                        updatedAt: '2023-09-28T21:54:49.933Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Tax Exemption Certificate Submission',
                        label: 'Tax Exemption Certificate Submission',
                        url: 'https://taxform.modernatx.com/'
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'UISRXQn7QcXzQLw1GvBoS',
                        type: 'Entry',
                        createdAt: '2021-12-08T16:51:05.258Z',
                        updatedAt: '2023-09-29T19:13:01.658Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 6,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'About Moderna Link',
                        label: 'About Moderna',
                        url: 'https://www.modernatx.com/about-us'
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7Das3oZCXBETxaKdXELgve',
                        type: 'Entry',
                        createdAt: '2021-12-15T18:57:35.795Z',
                        updatedAt: '2024-06-04T18:31:16.404Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 10,
                        revision: 4,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'externalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Newsroom Link',
                        label: 'Newsroom',
                        url: 'https://www.modernatx.com/en-US/newsroom/news-and-media-2024'
                    }
                }
            ]
        }
    ],
    footerLinks: [
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '556dZCOMwLIKu69guk6x42',
                type: 'Entry',
                createdAt: '2022-12-02T04:18:56.045Z',
                updatedAt: '2022-12-02T04:18:56.045Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'internalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Privacy Policy Internal Link',
                label: 'Privacy Policy',
                pageReference: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'EW4a3Hd56gtuvG9WpsS3Z',
                        type: 'Entry',
                        createdAt: '2022-12-02T04:18:46.677Z',
                        updatedAt: '2022-12-02T04:18:46.677Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 10,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'page'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        name: 'Privacy Policy',
                        title: 'Moderna Direct Privacy Policy',
                        slug: 'privacy-policy',
                        seo: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '5wVt4P86v56AQIbQiW4uqD',
                                type: 'Entry',
                                createdAt: '2022-12-02T04:18:46.768Z',
                                updatedAt: '2022-12-02T04:18:46.768Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 4,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'seo'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Privacy Policy - Compose: SEO'
                            }
                        },
                        content: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '3LQ4u17dvJworzbcVeWMD',
                                type: 'Entry',
                                createdAt: '2022-12-02T04:18:46.882Z',
                                updatedAt: '2023-06-20T16:20:31.348Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 14,
                                revision: 4,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'richTextContentPageTemplate'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Privacy Policy - Rich Text Content Page Template',
                                modules: [
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '4qpojknXqxo8gNLhMxZz5K',
                                            type: 'Entry',
                                            createdAt: '2022-12-11T23:10:53.907Z',
                                            updatedAt: '2023-06-16T18:23:32.364Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 7,
                                            revision: 2,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Privacy Statement Banner Component',
                                            headline: 'Moderna\'s Privacy Statement',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '3OFyHSrhG9cqdAH1JtdQcK',
                                            type: 'Entry',
                                            createdAt: '2023-06-16T18:25:11.324Z',
                                            updatedAt: '2023-06-16T18:25:11.324Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 3,
                                            revision: 1,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Privacy Statement Banner Component - DE',
                                            headline: 'Moderna\'s Privacy Statement',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: 'I5IZLNooED1CgxC5Kpr9Z',
                                            type: 'Entry',
                                            createdAt: '2022-12-11T01:44:45.550Z',
                                            updatedAt: '2024-07-10T14:10:03.932Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 386,
                                            revision: 22,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Privacy Policy Rich Text Content Component - US',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2023-09-01',
                                            content: {
                                                nodeType: 'document',
                                                data: {},
                                                content: [
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "This Privacy Statement describes how Moderna Inc. and its worldwide affiliates (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D) describes how Moderna collects, stores, uses (\u201Cprocesses) your personal data when you:",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'use our website ',
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'hyperlink',
                                                                                data: {
                                                                                    uri: 'https://www.modernatx.com/'
                                                                                },
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'text',
                                                                                        value: 'www.modernatx.com',
                                                                                        marks: [],
                                                                                        data: {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ' or any other Moderna website that links to this statement;',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'use any of our other digital services, such as an app provided by Moderna, that link or use this statement; or',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'engage with us through our call centers.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "Personal Data\u201D ",
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'means information associated with or used to directly or indirectly identify or contact a specific person. Such data can include your name, contact details, relationship with Moderna, etc.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Certain Personal Data, such as information about health or medical status (pursuant to all applicable laws) are characterized as sensitive (collectively, \u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Sensitive Personal Data',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201D) and may be subject to stricter regulation and consent requirements than other information.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna recognizes the importance of taking steps to protect the privacy of information we collect, and we are committed to respecting your privacy.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Carefully read this Privacy Statement to learn more about how we collect, use, disclose and store personal data provided and the steps we take to help protect the often-sensitive personal data provided from unauthorized use or disclosure. When you submit information to or through our sites or services, you consent to the collection, processing and retention of your information as described in this Privacy Statement.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY STATEMENT, THEN PLEASE DO NOT USE ANY OF THESE SERVICES.',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Summary of Key Points',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'This summary provides key points from our Privacy Statement, but you can find more information about any of these topics by using the Table of Contents below. ',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '1. How do we process your personal data?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We process your personal data to provide you with the service requested and to improve our service, communicate with you for security purposes and comply with legal obligations. We only process your personal data when we have legal grounds to do so. Please see ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-4-how-we-use-personal-data'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'How We Use Your Personal Data',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' for more details.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '2. Do we process sensitive personal data?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may process sensitive personal data when necessary, with your consent or where required by legal obligations. Click ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-1'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'here',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' to learn more about Sensitive Personal Data.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '3. Where will your data be processed by Moderna?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Moderna is a global company which maintains datacenters around the world, including Switzerland and the United States (ModernaTX\u2019s global headquarters). Moderna may process personal data in databases that can be accessed by authorized Moderna personnel worldwide.Transfers of personal data among Moderna and its worldwide affiliates follow applicable laws and our Intracompany Transfer Agreements.Third-party transfers outside of the EU, the EEA, Switzerland or the UK are made in accordance with applicable privacy laws and pursuant to the following safeguard, Standard Contractual Clauses (SCCs) or Model Contracts.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'For information on SCCs, please visit:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'unordered-list',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'If in EU:',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'hyperlink',
                                                                                                data: {
                                                                                                    uri: 'http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        nodeType: 'text',
                                                                                                        value: 'http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm',
                                                                                                        marks: [],
                                                                                                        data: {}
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'If in Switzerland:',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'hyperlink',
                                                                                                data: {
                                                                                                    uri: 'https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        nodeType: 'text',
                                                                                                        value: 'https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647',
                                                                                                        marks: [],
                                                                                                        data: {}
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'If In UK:',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'hyperlink',
                                                                                                data: {
                                                                                                    uri: 'https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        nodeType: 'text',
                                                                                                        value: 'https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit',
                                                                                                        marks: [],
                                                                                                        data: {}
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '4. When and with who do we share your data?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We only will share your data with services providers who support our operations and other parties and business partners in limited circumstances based on legal obligations and as identified in our Privacy Notices.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '5. How do we keep your data protected?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We have technical and organizational safeguards in place to protect your personal data. However, no electronic processing can be guaranteed to be 100% secure, so we cannot promise that hackers, cybercriminals or other unauthorized third parties will not be able to defeat our security and steal or unauthorized access your personal data. Click ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-6-how-information-is-retained-and-secured'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'here',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' to learn more.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '6. What are your rights and how can you exercise them?',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Based on your location, applicable personal data protection laws provide you with certain rights regarding your personal data. You may exercise these rights by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [
                                                                            {
                                                                                type: 'bold'
                                                                            }
                                                                        ],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Please note that this Privacy Statement does not apply to information collected through third-party websites or services that you may access through third-party sites.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Data Controller:',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' The controller of Personal Data collected under this Privacy Statement is ModernaTX, Inc.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "This statement is organized into the following sections \u2013 please select your desired topic for further information.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Principles',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We will handle your Personal Data in accordance with applicable laws such as the General Data Protection Regulation (\u201CGDPR\u201D) in the European Union, the Act on the Protection of Personal data of Japan and the Personal data Act of South Korea. It is our goal to do the following:",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Process Personal Data lawfully, fairly and in a transparent manner.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Collect Personal Data for a specified, explicit and legitimate purpose, and only use it for the purposes for which it was originally collected.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Limit collection of Personal Data to the extent necessary in relation to the purpose for which it is processed.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Make reasonable efforts to ensure that your Personal Data is accurate and, where necessary, kept up to date.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Store Personal Data for no longer than is necessary for the purpose for which the Personal Data is processed.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Process Personal Data in a manner that provides adequate security and confidentiality.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our privacy practices are described in greater detail in the remainder of this Privacy Statement.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Table of Contents',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '1. Information We Collect\n2. How Information is Collected and Used\n3. Links to Other Websites/Services\n',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '4. ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "How We Use Personal Data\n5. How Information is Shared and Disclosed\n6. How Information is Retained and Secured\n7. Cookies and Similar Technologies\n8. Your Privacy Rights\n9. Our Children\u2019s Policy\n10. Changes to This Privacy Statement\n11. Jurisdiction-Specific Privacy Information (",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'California, Nevada, EU/EEA, UK & Switzerland, Japan)',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '1. Information We Collect',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Depending on your interactions with us, we may collect and process your Personal Data. For example, you may choose to submit your contact information to join our mailing list, engage with us via our Contact Us features, or apply for a job opening with Moderna via the ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/careers/life-at-moderna'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'careers',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' section of our website. As a result, and depending on the type of Service, we may ask you to provide Personal Data, such as your:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'General identification data',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ': initials, name, job title, company name, country, date of birth, age, country, ethnicity (',
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'for cases where the Summary of Product Characteristics (SmPC) includes specific information relating to the ethnic origin',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ')',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Contact details',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ': contact number, e-mail address, mailing address',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product use',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ': data related to your use of our products, including feedback and use history',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Professional details (for HCPs)',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ': job title, institute/organization name, additional information about your job role and any other job-related information',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Technical data',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ': IP address, device identifiers, operating system, browsing history, search history, time and duration of use, interaction with content',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Information about your job role',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ' and any other job-related information, work experience, educational background',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Before providing it to us, carefully consider whether to disclose your Sensitive Personal Data. If you do provide Sensitive Personal Data to us, you consent to its use and disclosure for the purposes and in the manner described in this Privacy Statement.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You may visit our website without voluntarily providing any information about yourself. You are not obligated to provide any Personal Data to us, but your ability to use our website or its features, apply for an employment position or report an adverse event may be limited. When calling our call centers, you can choose to remain anonymous unless the collection of personal data is required by law or you provide us with your personal data.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you provide us with Personal Data about another person or allow us to collect it, you acknowledge that you have the authority to share that information and are allowing us to use the information as described in this Privacy Statement.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Ordering and Payment Information for Pharmacies and Healthcare Professionals',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When pharmacies and healthcare professionals place orders for our products and services, we collect and use necessary information to process these transactions. This includes, but is not limited to, payment details (such as credit card numbers and billing addresses), order information, and contact details of the ordering party. This information is used solely for the purposes of fulfilling orders, processing payments, and providing customer support. We are committed to protecting this data in compliance with all relevant privacy and data protection regulations and ensuring that it is handled securely and confidentially.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '2. How Information is Collected and Used',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'a. Information that you voluntarily provide',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We collect and use the Personal Data that you voluntarily provide to us by visiting our sites or using our services. You may use certain services without registering or identifying yourself but, if you do not register, you may not have access to all of the services or functionality of the site. If you choose to register, we may use the Personal Data you provide to confirm your registration and to respond to requests from you.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Upon your request, we may also use your Personal Data to send you special promotions or newsletters with information that may interest you.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you are a healthcare professional or an institutional healthcare provider, you are responsible for obtaining any legally required authorization, consent or other permission from your patients prior to providing their Personal Data to Moderna. By submitting any Personal Data about a patient, you represent and warrant to Moderna that you have obtained all required permissions to do so.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'b. Through your use of interactive services',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you choose to participate in our questionnaires and surveys and other interactive services, we will collect the information, including health-related information and other Sensitive Personal Data that you share to help us better understand how Moderna products are used in coping with the diseases for which they are marketed.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "c. When you\u2019re interested in enrolling in a clinical trial",
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you submit health-related Personal Data to us to participate in a clinical trial, we may use your Personal Data to assess whether you qualify for enrollment in the trial, to contact you about potential participation in the trial, and to provide you with additional information about the trial.Once enrolled for any questions relating to your participation in a clinical trial, contact the Principal Investigator on the study and/or refer to the trail related information provided to you, e.g., the Informed Consent Form.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'd. When you correspond with Moderna about Moderna products.',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you contact Moderna or use the Services to ask questions or report problems regarding your experience in using one of our products, we may use the information you provide in submitting reports to the U.S. Food and Drug Administration, the European Medicines Agency or any other relevant supervisory authority and as otherwise required of us by law. We also may use the information to contact the prescribing physician to follow up regarding an event involving use of our product.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'e. Through data collection tools',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When permitted or you have provided consent, Moderna automatically will collect information about use of the Services through data collection tools, such as web beacons and cookies. A "web beacon" is a piece of code that enables us to monitor user activity and website traffic. A "cookie" is a randomly generated unique numeric code stored in the user\u2019s web browser settings or computer\u2019s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the \u201Clifetime\u201D of the cookie (i.e., when it expires), as well as the randomly generated unique numeric code.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'For more details, please see ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/cookie-statement'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: "Moderna\u2019s Cookie Statement",
                                                                        marks: [
                                                                            {
                                                                                type: 'italic'
                                                                            }
                                                                        ],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We use the information collected through data collection tools to monitor usage patterns, store information about user preferences and to improve the Services. For example, your Personal Data may be used to create customized offers, information and services tailored to your interests and preferences. We may track your activities over time and across third-party websites, apps or other online services to display advertisements on third-party websites. If you do not want us to use your information in this way, please see \u201CYour Privacy Choices\u201D below.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We also may collect information about the location of the mobile device or tablet used to access the Services (\u201CLocation Data\u201D). Location Data includes: (i) the location of the mobile device or tablet derived from GPS or WiFi use; (ii) the IP address of the mobile device or tablet or internet service used to access the Services; and (iii) other information made available by a user or others that indicates the current or prior location of the user, such as geotag information in photographs.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'f. Social media connections',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When accessing the Services through a Facebook or other Social Media account, Moderna may (depending on applicable user privacy settings) automatically have access to information provided to or through the Social Media platform. Moderna may collect and use this information for the purposes described in this Privacy Statement or at the time the information was collected.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'g. Social media plugins',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When you use services, Social Media operators can place a cookie on your computer to recognize individuals who have visited previously. If you are logged into a Social Media account while using the services, the social plugins allow that Social Media to receive information that you have accessed and used the Services. The social plugins also allow the Social Media operator to share information about your activities in or through the Services with other Social Media users. Moderna does not control any of the content from the Social Media plugins. For more information about Social Media plugins, please refer to any privacy and/or other legal notices of the respective Social Media platform.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'h. Through third parties',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Third parties that assist us with our business operations also collect and use information (including Personal Data and Usage Data) and may share the collected information with us. For example, our vendors collect and share information with us to improve user experience, we may view your LinkedIn profile, or any other publicly available profile.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When you access any interactive service, you will be asked to affirmatively choose ("opt in") to provide the requested information. You may always choose not to provide the requested information but then you may not be able to use the Service as intended.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '3. Links to Other Websites/Services',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'As a convenience to our visitors, this website may contain links to other websites that we believe may offer useful information, but that does not mean that Moderna endorses it, or the quality or accuracy of information presented on it. If you decide to visit a third-party site, you are subject to its privacy practices and not this Privacy Statement.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '4. How We Use Personal Data',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may use Personal Data for the following purposes.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'a. Consent',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may seek, either directly or through our trusted third parties, your separate consent to process your Personal Data, for example, to:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'provide you with information you requested and/or to respond to your inquiries submitted via the website, email and/or phone,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'facilitate certain recruitment activities such as processing employment applications,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'analyze and enhance our communications and strategies (including by identifying when emails sent to you have been received and read),',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'tailor the content we display on our website,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "If we have sought your consent to process your Personal Data, you may subsequently withdraw it at any time by contacting us at the address listed in the \u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-8-your-privacy-rights'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'Your Privacy Rights',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201D section below.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'b. Legal obligation',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We may be required by law or regulation to collect and process certain Personal Data about you. For example, we may be required to process certain Personal Data in relation to reporting of adverse events.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'monitor the quality, safety and efficacy of our medicinal products, which includes detecting, assessing and preventing adverse events and reporting to the relevant health authorities to meet legal and regulatory obligations,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Adverse events refer to the unintended or undesirable events after using a medicinal product. They can be minor at times, or they can also involve serious health issues.Moderna processes your Personal Data to comply with legal obligations under applicable pharmacovigilance laws and regulations worldwide and where necessary for our legitimate interests in ensuring appropriate pharmacovigilance standards.Pharmacovigilance laws are issued for reasons of substantial public interest in public health, research as well as quality, safety, and efficacy of medicinal products.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'c. Public interest',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may also process Personal Data to carry out scientific research in the public interest.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'd. Our legitimate interests',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may process your Personal Data where it is necessary for our legitimate interest as a company, including to manage, promote and improve our business and manage our risk. For example, we may process your Personal Data to:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'facilitate our recruitment activities (such as evaluating you as a job candidate for an employment activity, and monitoring our recruitment statistics),',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'tailor the content we display on our website,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'help us comply with our legal or regulatory obligations or our contractual obligations to the U.S. government as a government contractor or other countries as applicable,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'maintain the security, safety or property of the website, and',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '5. How Information is Shared and Disclosed',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may share and disclose information as described at the time information is collected and as described below:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'a. Service providers',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may use third parties to perform services requested or functions initiated by users. In addition, we may disclose Personal Data to identify a user in connection with communications sent through our sites or services. We may also share information, including Personal Data, with our service providers to perform the functions for which we engage them, such as data analysis, system design and maintenance, customer services and for marketing and promotions. When permitted, we also may offer users the opportunity to share information with friends and other users through the Services.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'b. Legal requirements',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'In certain circumstances, Moderna may release your Personal Data in response to a court order, subpoena, search warrant, regulation, binding order of a data protection agency, governmental request or other legal or regulatory process. Moderna may disclose information if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Moderna or others.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'c. Corporate changes',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may transfer information, including your Personal data, in connection with a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy or other change of ownership or control by Moderna or any affiliated company (in each case, whether in whole or in part). When one of these events occurs, Moderna will use reasonable efforts to notify users before information is transferred or becomes subject to different privacy practices.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'd. Adverse Event reporting by patients',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may disclose your Personal Data to HCPs, doctors, care givers, in connection with your adverse event report based on your consent or a legal obligation.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '6. How Information is Retained and Secured',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We retain information as long as it is necessary and relevant for our operations and in line with legal obligations. We retain Personal Data to comply with applicable law, prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted by law. When your Personal Data is no longer needed for Moderna\u2019s business purposes, we dispose of it subject to applicable law.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'In accordance with applicable laws, we employ reasonable security measures intended to help protect the security of all information submitted through the Services. The security of information transmitted through the internet cannot, however, be guaranteed. We are not responsible for any interception or interruption of any communications or for changes to or losses of data through the internet. Users of our sites and services are responsible for maintaining the security of any password, user ID or other form of authentication involved in obtaining access to password protected or secure areas. Any access to our sites or services through your user ID and password will be treated as authorized by you.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'To help protect your Personal Data, we may suspend your use, without notice, if Moderna suspects or detects any breach of security. Unauthorized access to such areas is prohibited and may lead to criminal prosecution.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '7. Cookies and Similar Technologies',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Moderna\u2019s websites may use cookies and similar technologies. Please click here to read ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/cookie-statement'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: "Moderna\u2019s Cookie Statement",
                                                                        marks: [
                                                                            {
                                                                                type: 'italic'
                                                                            }
                                                                        ],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '8. Your Privacy Rights',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna respects your rights related to the processing of your personal data. Depending on the applicable Data Protection Law you may have certain additional rights (see country-specific section below) and you will always have the below rights. You may exercise them by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'a. Correct/update personal data',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You may correct or update the Personal data you previously provided to Moderna.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'b. Receive marketing communications',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "When you register for the services, you may request to receive emails containing information about Moderna you might find useful, including promotions, announcements of new services and products. If you decide, at any time, that you no longer wish to receive these emails you may unsubscribe from our email list by using the relevant \u201CUnsubscribe\u201D link within the respective electronic communications channel, or by contacting us at ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'IMPORTANT NOTE: Moderna cannot comply with a consumer\'s request to amend or remove information that was provided to Moderna by a healthcare professional or a consumer regarding an adverse drug event due to legal obligations.',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "9. Our Children\u2019s Policy",
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our sites are not intended for use by children. If you are under the age of majority in your place of residence, you may visit our site only with the consent of or under the supervision of your parent or legal guardian.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you believe Moderna may have any information from or about a child, please contact our Privacy Office at ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '10. Changes to This Privacy Statement',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We may change or update this Privacy Statement from time to time by publishing a new version on this website. When we do update this Statement, we will revise the \u201CLast Updated\u201D date at the top of this page. Your continued use of the services after the Effective Date constitutes your acceptance of the amended Privacy Statement. The amended Privacy Statement supersedes all previous versions.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '11. Jurisdiction-Specific Privacy Information',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'California',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Privacy Rights',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you are a California resident under age 18 and are a registered user of any of our services, then you may request that we remove any of your User Contributions you publicly posted on or in our services. ',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'To request removal of your User Contribution, please visit our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' (You also may be able to log in to your account and delete your own User Contribution.) Moderna reserves the right to request that you provide information that will enable us to confirm that the User Contribution that you want removed was created and posted by you.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna will make a good faith effort to delete or remove your User Contribution from public view as soon as reasonably practicable. Please note, however, that your request that we delete your User Contribution does not ensure complete or comprehensive removal of your User Contribution. Your User Contribution may remain on backup media, cached or otherwise retained by Moderna for administrative or legal purposes, or your User Contribution may remain publicly available if you or someone else has forwarded or re-posted your User Contribution on another website or service prior to its deletion. Moderna may also be required by law to not remove (or allow removal) of your User Contribution.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "California Civil Code Section 1798.83 permits individual California residents to request certain information regarding Moderna\u2019s disclosure of personal data to third parties for their direct marketing purposes. To make such a request, please write or send an email to the address below.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'California Consumer Privacy Act - Notice for California Residents',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you are a California resident, this Privacy Notice supplements the information above regarding the collection, use, and disclosure of your personal data. ',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'The California Consumer Privacy Act of 2018 (CCPA) gives California consumers the right to know what personal data is collected about them, how it will be used and to whom it is disclosed. California consumers may have the right to request access to and deletion of their personal data, and the right to request that their personal data not be sold to the extent applicable under the CCPA.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'The purpose of this notice is to describe our practices regarding the collection, use, disclosure, and sale of personal data and instructions for submitting CCPA data privacy requests. Some of the Personal Data that we collect, use, and disclose may be exempt from the CCPA because it is regulated by other federal and state laws that apply to us.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We collect personal data from you when you interact with us online (through our Site, our other websites, Apps and Services) or offline (such as through your health care providers, if you are a patient, with your authorization as applicable.) The personal data we may collect from you will depend on the nature of our interaction with you, but can include the following categories that we have collected in the preceding twelve (12) months:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'embedded-asset-block',
                                                        data: {
                                                            target: {
                                                                metadata: {
                                                                    tags: [],
                                                                    concepts: []
                                                                },
                                                                sys: {
                                                                    space: {
                                                                        sys: {
                                                                            type: 'Link',
                                                                            linkType: 'Space',
                                                                            id: 'n9bebhw263o0'
                                                                        }
                                                                    },
                                                                    id: '1vo5ULs91JROZ8CfAyGcpI',
                                                                    type: 'Asset',
                                                                    createdAt: '2024-07-10T13:58:26.978Z',
                                                                    updatedAt: '2024-07-10T13:58:26.978Z',
                                                                    environment: {
                                                                        sys: {
                                                                            id: 'sandbox',
                                                                            type: 'Link',
                                                                            linkType: 'Environment'
                                                                        }
                                                                    },
                                                                    publishedVersion: 5,
                                                                    revision: 1,
                                                                    locale: 'en-US'
                                                                },
                                                                fields: {
                                                                    title: 'Privacy Policy - Personal Data ',
                                                                    description: '',
                                                                    file: {
                                                                        url: '//images.ctfassets.net/n9bebhw263o0/1vo5ULs91JROZ8CfAyGcpI/82fd7d27ec4e2e10501a96f0158fdee7/image__4_.png',
                                                                        details: {
                                                                            size: 642894,
                                                                            image: {
                                                                                width: 1174,
                                                                                height: 2046
                                                                            }
                                                                        },
                                                                        fileName: 'image (4).png',
                                                                        contentType: 'image/png'
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        content: []
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Your Rights',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'California residents are provided specific rights subject to certain exceptions.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'The Right to Know. ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'You have the right to request that we disclose what personal data we collect, use, disclose, and sell. The process for exercising this right is describe below under How to Submit a Data Privacy Request.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'The Right to Deletion. ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'You have the right to request deletion of any personal data about you that we have collected from you. The process for exercising this right is describe below under How to Submit a Data Privacy Request',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'The Right to Opt-Out. ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'You have the right to opt-out of the sale of your personal data.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'The Right to Non-Discrimination. ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'You have the right not to be discriminated against for exercising your rights.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'How to Submit a Data Privacy Request',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You may exercise your Right to Know and Right to Deletion by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' or calling (844) 971-2551.To process your request for access or deletion, we must be able to verify your identity to a reasonable degree of certainty. We will ask you to provide your contact information and additional identifiers based on your relationship with us.You may designate an authorized agent to make a request to access, delete, or opt-out of the sale of your information on your behalf. When you use an authorized agent to submit a request for access or deletion, you must provide the authorized agent with written permission to do so, and, in certain circumstances, we may ask you to verify your own identity directly with us. We may deny a request from an authorized agent that does not submit proof that they have been authorized by you to act on your behalf.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Right to Know:',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Please note that we may not be required to provide you access to the specific pieces of information we have collected about you or delete information if we are unable to verify your identity.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Right to Delete:',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We may not be required to delete information under certain circumstances. Specifically, the CCPA includes exemptions that provide that we do not have to delete data that, for example, is necessary to comply with legal obligations including those pertaining to the quality, safety or effectiveness of a product or activity regulated by the Food and Drug Administration (FDA), complete a transaction, detect security incidents, or for certain other internal purposes.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Sale or Disclosure of Personal data: ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "The CCPA defines \u201Csale\u201D broadly to include sharing, transferring, disclosing or otherwise communicating personal data with a third party for monetary or other valuable consideration. We share personal data with service providers who work on our behalf and agree not to use or sell your personal data for other purposes or if you have intentionally directed us to share information with a third party. In addition, with your approval, we share certain internet tracking data, including cookies and the IP address used to access our websites.",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Notice of Financial Incentive:',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Moderna does not offer financial incentives in exchange for the collection or sale of personal data. However, we do provide discounts and incentives to individuals who use our products and services and enroll in incentive programs that we offer from time to time; enrolling in these programs requires you to provide certain of your personal data so that we may administer the programs and, in some cases, provide marketing and advertising to you. Under CCPA, this could be considered an offer of a \u201Cfinancial incentive\u201D and so we provide this notice to you to describe our practice and to provide a good faith estimate of the value of your personal data that we may collect related to the programs.\n\nIn the normal course of our business, we do not assign monetary or other value to personal data, but in accordance with CCPA, we make a good faith estimate that the value of the personal data collected and used is equivalent to the value of the discount or financial incentive we provide in these programs. To make this good faith estimate, we may consider among other factors, the (i) categories of personal data collected, (ii) the discount or incentive offered, (iii) the sales or use of our products and services by those who enroll versus those who do not, and (iv) the cost and expenses we incur in offering the programs.\n\nThe incentive programs require you to opt-in to participate as set forth on the page where you can enroll or opt-in to the programs. You can opt-out either by contacting us at the information set forth below, or by following the terms and conditions provided when you are enrolling in the program. While we will not discriminate against you for exercising your rights under CCPA, if you request deletion of your personal data, we may not be able to delete such information if it is necessary to administer the incentive or discount you requested and still provide you such incentive or discount.",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Personal data Collected from Employees, Contractors, Applicants, and Health Care Providers',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Employees ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "\u2013 If you are an Moderna employee and would like more information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please contact us at",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '',
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'hyperlink',
                                                                                data: {
                                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                                },
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'text',
                                                                                        value: 'privacy@modernatx.com',
                                                                                        marks: [],
                                                                                        data: {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Contractors ',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "\u2013 If you are a contractor performing services for Moderna and would like information about the categories of personal data we collect from you as a contractor and the purpose for which the personal data will be used, please visit our ",
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'hyperlink',
                                                                                data: {
                                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                                },
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'text',
                                                                                        value: 'request web page',
                                                                                        marks: [],
                                                                                        data: {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Job Applicants',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: " \u2013 If you are applying for a position with Moderna and would like information about the categories of personal data Moderna collects from you as a job applicant and the purposes for which the personal data, please view our Privacy Statement",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Health Care Providers \u2013 ",
                                                                                marks: [
                                                                                    {
                                                                                        type: 'italic'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'If you are a health care provider with whom we have a contractual arrangement and would like information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please visit our ',
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'hyperlink',
                                                                                data: {
                                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                                },
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'text',
                                                                                        value: 'request web page',
                                                                                        marks: [],
                                                                                        data: {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Children\u2019s Online Privacy Protection Act (COPPA)",
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Consistent (COPPA), if we learn that a child under age 13 has provided Personal Data to or through the site without first receiving his or her parent\u2019s verified consent, we will use that information only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use the services and subsequently we will dispose of such Personal Data in accordance with this Privacy Statement.California residents who are unable to review or access this CCPA Notice due to a disability may contact us to request access this CCPA Notice in an alternative format. Please call 1-844- 971-2551 or email us at ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Nevada',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Nevada Residents As Covered by Nevada Privacy Law\nModerna does not sell Covered Information as defined under Nevada law. If you would like to make a further inquiry regarding the selling of your Covered Information, as defined under Nevada law, visit our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'EU/EEA, UK & Switzerland',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Moderna\u2019s processing of your personal data is based on any one of the following legal grounds: (A) legitimate business purposes, (B) where you have provided consent, (C) as necessary to comply with Moderna\u2019s legal and regulatory obligations and (D) as necessary to perform a contract under which you have been engaged.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'embedded-asset-block',
                                                        data: {
                                                            target: {
                                                                metadata: {
                                                                    tags: [],
                                                                    concepts: []
                                                                },
                                                                sys: {
                                                                    space: {
                                                                        sys: {
                                                                            type: 'Link',
                                                                            linkType: 'Space',
                                                                            id: 'n9bebhw263o0'
                                                                        }
                                                                    },
                                                                    id: '3dlAOZ38IdeTNBy7LRHGVL',
                                                                    type: 'Asset',
                                                                    createdAt: '2024-07-10T13:57:28.572Z',
                                                                    updatedAt: '2024-07-10T13:57:28.572Z',
                                                                    environment: {
                                                                        sys: {
                                                                            id: 'sandbox',
                                                                            type: 'Link',
                                                                            linkType: 'Environment'
                                                                        }
                                                                    },
                                                                    publishedVersion: 5,
                                                                    revision: 1,
                                                                    locale: 'en-US'
                                                                },
                                                                fields: {
                                                                    title: 'Privacy Policy EU/EEA, UK & Switzerland ',
                                                                    description: '',
                                                                    file: {
                                                                        url: '//images.ctfassets.net/n9bebhw263o0/3dlAOZ38IdeTNBy7LRHGVL/2f4cfe08aaffd2eb88fe7e161d058c7e/image__3_.png',
                                                                        details: {
                                                                            size: 154682,
                                                                            image: {
                                                                                width: 480,
                                                                                height: 379
                                                                            }
                                                                        },
                                                                        fileName: 'image (3).png',
                                                                        contentType: 'image/png'
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        content: []
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'How can you access, correct or delete the personal data about you that we process? You have a right to request to access, correct/update or delete your personal data (including your health information). You may make such a request at any time, by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '. We will provide you with access to the information we hold about you, correct/update, and or delete that information that was provided to us by a Healthcare Professional or a consumer regarding an adverse drug event.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'It is not technologically possible to remove from our servers each and every record of your information. The need to back-up our systems to protect information from inadvertent loss means that a copy of information about you (including your health-related interests) may exist in a non-erasable form that will be difficult or impossible for us to locate.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Nevertheless, when permitted by law, Moderna will delete your personal data (including health information) stored in the databases Moderna actively uses for research and daily business activities or stored in other readily searchable media. In addition, we will use reasonable efforts not to disclose any personal data stored in a non-erasable format after receiving your request for removal, except as required by law.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'How can you exercise the right to data portability? According to the right to data portability, you have the right to request that your personal data provided to Moderna be delivered to you in a structured, commonly used and machine-readable format, subject to certain conditions and can be requested by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Make a Privacy Complaint with the ICO (UK). If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Information Commissioner\u2019s Office (ICO) at: ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://ico.org.uk/make-a-complaint/'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'https://ico.org.uk/make-a-complaint/',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Make a Privacy Complaint with the Federal Data Protection Commissioner of Switzerland. If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Federal Data Protection Commissioner at: ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.edoeb.admin.ch/edoeb/en/home.html'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'https://www.edoeb.admin.ch/edoeb/en/home.html',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'How We Manage Disclosure of Transfers of Value',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    },
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna collects data about the transfers of value that you have received from us so that we can comply with our obligations under the IPHA Code, specifically that companies must document and publicly disclose annually certain transfers of value made directly or indirectly to health professionals and other relevant decision makers located in Europe.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna recognizes the legitimate public interest in better understanding the financial relationships that healthcare professionals have with the pharmaceutical industry for the purposes of transparency and trust in the pharmaceutical industry.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "The law requires us to inform you of the legal basis for collecting and processing your personal data where Moderna is the data controller. Where Moderna processes data relating to transfers of value made to you, Moderna relies on the legal basis of legitimate interests to process that data. Moderna\u2019s compliance with the IPHA Code and these further objectives cannot be met without processing personal data about you and the transfers of value that you have received from us. We have carried out a Legitimate Interests Assessment and consider that this processing is necessary, proportionate and without unjustified harm to you.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you do not agree to the disclosure of data relating to transfers of value made to you by Moderna, you can raise an objection via ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Japan',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'In accordance with the Act on Protection of Personal Information of Japan (APPI) and other applicable laws and regulations, Moderna will disclose the personal data that Moderna holds about you according to the applicable procedures. In addition, if you inform Moderna that your personal data is inaccurate, Moderna will review and correct, add or delete the data as required in accordance with applicable laws, regulations and procedures.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Requests may be filed by visiting our ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'request web page',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '; please note that this may require a fee.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '5obyb6hoYaRjLduvLrF9BT',
                                            type: 'Entry',
                                            createdAt: '2023-05-24T19:10:31.031Z',
                                            updatedAt: '2023-07-11T18:20:48.597Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 245,
                                            revision: 62,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Privacy Policy Rich Text Content Component - DE',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2023-01-07',
                                            disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                                            content: {
                                                nodeType: 'document',
                                                data: {},
                                                content: [
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "This website is owned and operated by Moderna, Inc. (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D). The materials on our website (the \u201Cwebsite\u201D or the \u201CSite\u201D) are provided by Moderna as a service to our customers and the public and may be used for informational purposes only.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna respects the privacy of visitors to our website and recognizes the importance of taking steps to protect the privacy of any information we collect through our website. This Privacy Policy describes the types of Personal Information (as defined below) that we collect about visitors to the Site, how we use the Personal Information, and with whom we may share it. This Privacy Policy also describes (1) the measures we take to protect the personal\ninformation we collect and (2) your rights and privileges regarding our collection, use, and disclosure of your personal information.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Exclusions.',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' This policy only treats personal information collected through this website. It does not describe how we may collect or use personal information collected oline, and it does not address or govern the privacy practices of other websites (including those we link to) that may have policies of their own. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. Information you provide to us unsolicited may be considered non-confidential, and Moderna may reproduce, use, disclose, and share such unsolicited information with others without permission, compensation, restriction, or aribution.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'By accessing our website, you agree to the terms of this Privacy Policy and the terms of the Agreement. ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you do not agree to these terms, you are not authorized to use our website.',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n\n',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Introduction',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Personal Information',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201D is information that can be used to identify or contact you, such as: Your contact information, including your name, address, email address, country, and phone number, any other information that may appear on your resume if you apply for a job with Moderna through our website, and where required by applicable law, any information about your use of our website or device that may be collected automatically; including the use of\ncookies, web beacons and other tracking technologies.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We will handle your Personal Data in accordance with applicable law and in line with the following principles:\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We will treat your personal data in accordance with applicable law and in accordance with the following principles:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We process personal data lawfully, fairly and transparently.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We collect personal information only for a specific, explicit and legitimate purpose and use personal information only for the purposes for which it was originally collected.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We limit the collection of personal data to what is necessary for the purpose for which it is processed.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We will use reasonable eorts to ensure that your personal information is accurate and, where appropriate, kept up to date.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We do not store personal data for longer than is necessary for the purpose for which the personal data is processed.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Personal data will only be processed in a manner that ensures appropriate security of the personal data.\n\n',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our privacy practices are described in more detail below in this Privacy Policy.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Information We Collect',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "You can visit our website without explicitly providing information about yourself. If you choose to submit your information through the \u201CSign Up for our Mailing List\u201D feature or the \u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://dev.modernadirect.com/en-DE/contact-us'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'Contact Us',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201D feature on our website, or if you apply for a job posting at Moderna through the \u201C",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/careers/life-at-moderna'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'Careers',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201D section of our website, we may ask you to provide personal information, such as your name, address, telephone number and email address, job title, company name, Your\ncountry, information about your job and other job-related information. You are not required to provide any personal information to Moderna, but your ability to use our website or its features and your ability to apply for a job may be limited if you do not.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Personal data',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: " about the use of the website collected through cookies or other automated means. When you use our website, we may automatically collect information about your use of the website, including through the use of cookies, web beacons and other tracking technologies (\u201CAutomatically Collected Information\u201D). Automatically collected information may include device information such as IP address, device identifiers and operating systems,\nas well as usage information such as time and duration of use, interaction with content, information stored in cookies or similar technologies. In accordance with EU Regulation 2016/679 on data protection (the \u201CGDPR\u201D), automated information is considered personal data and we treat such automated information as personal data in accordance with this Privacy Policy.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\u201CCookies\u201D",
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' are small files that the website places on your hard drive for identification purposes. These files are used for registration on the website and to\ncustomize your next visit to our website. For example, cookies store your preferred language and display. Cookies cannot read data from your hard drive.\n\nWe use the following cookies on our website:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Strictly necessary cookies',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '. These are cookies that are necessary for the operation of our website. These include, for example, cookies that enable you to log in to your applicant account. ',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Functionality cookies',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: '. s. These are used to recognize you when you return to our website and to embed features of third-party services. This allows us to personalize our content for you, store your preferences (e.g., Your choice of language) and useful third-party services on our website.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Analytics cookies',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ". We use the Google Analytics platform to collect certain analytical information that helps us to beer understand the activities on our website and to improve our services and the quality of our website. This information includes the IP address, page views, referring websites or advertisements, operating system and browser, and time spent on our website. We receive this data in an aggregated form. We use this information\nto understand how visitors interact with our website, to measure the eectiveness of our advertising on third-party websites, and to improve our visitors\u2019 experience.\n",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "You can refuse or accept cookies from this website at any time by activating the cookie seings in your browser. The \u201CHelp\u201D menu of most Internet browsers contains information on how to disable cookies, or you can visit ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'https://www.aboutcookies.org/how-to-control-cookies/'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'https://www.aboutcookies.org/how-to-control-cookies',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '/. If you do not accept cookies, some features on our website may not work fully, and you may not be able to access certain information on this website. By continuing to use the website without changing the seings, you agree to the use of cookies.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Personal data from third-party sources. We may, to the extent permied by law, obtain information about you from publicly and commercially available sources, which we may combine with other information we receive from or about you. For example, if you apply for a job at Moderna through our website, we may view your LinkedIn profile.\nAggregated data. We may aggregate and/or de-identify any personal information we collect so that the information no longer identifies a specific individual. We may use, disclose and otherwise process such information without restriction for our own legitimate business purposes \u2013 including historical and statistical analysis and business planning.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Aggregated Data',
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ". We may aggregate and/or de-identify any Personal Data that we collect, such that the information no longer identifies any specific individual. We may use, disclose and otherwise process such information for our own legitimate business purposes \u2013 including historical and statistical analysis and business planning \u2013 without restriction.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'How We Use Personal Data',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may use Personal Data for the following purposes.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-5',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our legitimate interests',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We may process your personal data where it is necessary for our legitimate interest as a business, including administering, promoting and improving our business and risk management. For example, we may process your personal data in order to:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'provide you with the information you have requested and/or to respond to your requests submied via the Website, email and/or telephone,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'facilitate our recruitment activities (e.g., processing job applications, evaluating you as a candidate for a job and monitoring our recruitment statistics),',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'analyse and improve our communications and strategies (including by determining when e-mails sent to you have been received and read);',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'adapt the content we display on our website,',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'protect against, identify, investigate, and respond to fraud, illegal activities (such as incidents of hacking or misuse of our website), claims, and other recourse;',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'maintain the privacy, security, or property of the Site; and',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'communicate with you for any other purpose arising from the circumstances or of which we inform you when we collect personal information from you.\n',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-5',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Legal Obligation',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We may be required by law to collect and process certain personal data about you. For example, it may be necessary for us to process your personal data in order to comply with our contractual obligations to the U.S. Government as a contractor for the government.\n',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-5',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Your consent',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'We may also, either directly or through our trusted third parties, obtain your separate consent to process your personal data, for example, if you choose to receive Moderna news and updates from us, or for the use of non-essential cookies.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "If we have obtained your consent to process your personal data, you may subsequently withdraw it at any time by contacting us at the address set out in the \u201CYour Privacy Rights\u201D section below.\n",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Disclosure of personal data\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We will not sell, share, or otherwise distribute your personal information to third parties except as provided in this Privacy Policy.\n\nAliates and Service Providers. We may share your personal information with other Moderna aliates worldwide who agree to treat it in accordance with this Privacy Policy. We may also share personal data with service providers acting for us or on our behalf for further processing, such as to assess the usefulness of this website, for data management, technical support or to analyse recruitment data. These service providers have contractually agreed to\nuse the personal data only for the purpose(s) for which the data was originally collected or may otherwise be lawfully processed, not to sell your personal data to other third parties and not to disclose it to other third parties, unless required by law, permied by us or specified in this Privacy Policy.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nOther parties in connection with a corporate transaction. We may also transfer personal information we have collected from you to a third party as part of\na corporate transaction, such as a merger, acquisition, reorganization, joint venture, financing, or sale of our assets.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nOther parties as required by applicable law or as necessary to protect Moderna. We may share personal information with third parties to comply with\nlegal and regulatory requirements, or to protect against fraud, illegal activity (e.g., in response to incidents of hacking or misuse of our website), and\nclaims and other recourse.\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'International Data Transfers',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'When we share personal information with third parties, such data transfers may involve the transfer of personal information to other countries. These countries may not have the same data protection laws as the country from which the personal data originally originated.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'EEA area residents only',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\nModerna in the U.S. acts as a data controller and processes your personal data by determining the purposes and means of processing in accordance with the GDPR. Please note that your personal data will be stored on Aquia\u2019s servers, including inside and outside the European Union. Before we transfer your personal data outside the EEA, we will take steps to ensure that such data receives the same level of protection as under applicable data protection laws within the EEA. For data transfers outside the EEA, we use applicable safeguards where necessary, including standard contractual clauses approved by the European Commission. A copy of these arrangements can be obtained by contacting us at the email address below.\n\n\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Your Privacy Rights',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'As a data subject, you may have certain rights under applicable law. For example, you have the right to object to the processing of your personal data or\nto request a restriction of processing and the right to request access to the personal data we hold about you, as well as its correction, deletion and\nportability, subject to certain exceptions required by law. If you would like more information about our use of your personal data, or if you wish to exercise\nyour rights, please contact us at:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nModerna, Inc. 200 Technology Square, Cambridge, MA 02139 USA',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:Privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'Privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'EU residents:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'EUprivacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'EUprivacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We will endeavor to provide requested information and make requested changes to the extent required and permied by applicable data protection laws and other laws and regulations. In any case, we will do our best to respond to you as soon as possible and inform you of the outcome of your request.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You can lodge a complaint with the competent supervisory authority if you believe that our processing of your personal data violates applicable law.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Contact information for all EU supervisory authorities can be found here.\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Information',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna employs commercially reasonable administrative, technical, personnel, and physical security measures to protect the personal information in our possession from loss, the, and unauthorized use, disclosure, or alteration. Of course, despite these measures, we cannot guarantee perfect security of the networks, servers and databases operated by us or on our behalf. In particular, e-mails sent to or from the website may not be secure.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Therefore, you should be particularly careful about what information you send to us by e-mail. Please keep this in mind when you provide us with personal\ndata via the website.\n\n\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Data Storage',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Your personal data will only be retained by Moderna for as long as is necessary to fulfil the purpose(s) for which it was collected, depending on the purpose(s) for which the personal data was collected, the nature of the personal data, any contractual relationship governing the retention of the personal data and our legal or regulatory obligations. We will then destroy or anonymize your personal data in accordance with applicable law.\n\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Email Communications',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "In the event that we contact you, including by email, we will provide you with a method by which you can opt in or out of receiving further communications to the extent required by law. For example, you may choose to receive email updates on developments related to Moderna\u2019s products and/or services, or on health-related specific topics (e.g., email updates on Moderna\u2019s methylmalonic acid anemia (MMA)) by filling out the appropriate\nelectronic form \u201CSign up for our mailing list\u201D on our website. If, at a later date, you decide that you no longer wish to receive such e-mail communications from us, you may unsubscribe from such a contact list by using the appropriate \u201Cunsubscribe\u201D link within the relevant electronic communication channel or by sending us an e-mail titled \u201CUnsubscribe from E-mail Updates\u201D to ",
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' or ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:EUprivacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'EUprivacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our policy on dealing with children\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "We are commied to protecting children\u2019s privacy. The content and services of this website are not intended for or directed at children under the age of 18. Visitors under the age of 18 or children under the age of 18 should not submit any personal information to Moderna through the Site.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\nIf we become aware that a user of our website is under the age of 18 and has voluntarily provided personal information and/or health-related personal information, or that a healthcare professional has voluntarily provided personal information about a patient identified as under the age of 18 without the given or authorized consent of that child\u2019s legal guardian, we will promptly endeavor to delete such personal information upon notice or request.\n\n\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'CalOPPA Do-Not-Track Notice',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We do not track our website users over time and across third-party websites and therefore do not respond to Do Not Track (DNT) signals. Moderna does not authorize third parties to collect personal information directly from our users on our website, such as through the use of third-party advertising.\n\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Links to Third Party Websites\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'As a convenience to our visitors, this website may contain links to other websites that we believe provide useful information. These links may contain links to websites that may provide services to us. Please note that Moderna is not responsible for the privacy practices of these other websites and cannot guarantee the privacy standards of these other websites. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. This Privacy Policy applies solely to information collected by our website and does not apply to linked websites that do not originate from Moderna.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Notification of the Privacy Policy\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Updates: If we change our privacy policy, we will post those changes on our website. If we make any changes to this Privacy Policy, we will update the date at the top of this Privacy Policy.\n\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'For Additional Information',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'If you have any questions about this Privacy Policy or concerns about the practices of this website or your dealings with this website, or any privacyrelated maers generally, please email us at ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:privacy@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'privacy@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' or contact us in writing at:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna, Inc.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Aention: Legal Department 200 Technology Square,',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Cambridge, MA 02139 USA\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'For EU/EEA residents',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ':\nPlease email us at ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mainto:contact@dpr.eu.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'contact@dpr.eu.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You can also contact us in writing at:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'DPR Group Oce 29, Clion House Fitzwilliam Street Lower Dublin, Ireland\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nFor all other questions or concerns, regardless of where you live, please contact us in writing at:\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna, Inc.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Aention: Corporate Communications200 Technology Square,',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Cambridge,',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'MA 02139',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'USA\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: 'xveEzShRy3WE9HKcTBoSJ',
                type: 'Entry',
                createdAt: '2022-12-14T23:14:35.661Z',
                updatedAt: '2022-12-14T23:14:35.661Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'internalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Terms of Use Internal Link',
                label: 'Terms of Use',
                pageReference: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6e8bR8NoNNipQ8XOsEQOLG',
                        type: 'Entry',
                        createdAt: '2022-12-14T23:05:15.872Z',
                        updatedAt: '2022-12-14T23:05:15.872Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 11,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'page'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        name: 'Terms of Use Content Page',
                        title: 'Terms of Use',
                        slug: 'terms-of-use',
                        seo: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: 'CPQIi2xudRdKj2B2xGLVK',
                                type: 'Entry',
                                createdAt: '2022-12-14T23:05:15.913Z',
                                updatedAt: '2022-12-14T23:05:15.913Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'seo'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Terms of Use Content Page - Compose: SEO'
                            }
                        },
                        content: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: 'xg1DALHgYX18j87zlOP1C',
                                type: 'Entry',
                                createdAt: '2022-12-14T23:05:15.990Z',
                                updatedAt: '2023-06-21T19:19:34.422Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 16,
                                revision: 5,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'richTextContentPageTemplate'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Terms of Use Content Page - Rich Text Content Page Template',
                                modules: [
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '4sgrY0r9g7t6f13PeJHKpN',
                                            type: 'Entry',
                                            createdAt: '2022-12-14T23:06:15.428Z',
                                            updatedAt: '2023-06-16T18:23:00.168Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 16,
                                            revision: 2,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Terms of Use Banner Component',
                                            headline: 'Moderna\'s Terms and Conditions of Use',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '2HSANBDxIPFfpe40wRrEzX',
                                            type: 'Entry',
                                            createdAt: '2023-06-16T18:24:56.749Z',
                                            updatedAt: '2023-06-16T18:24:56.749Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 3,
                                            revision: 1,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Terms of Use Banner Component - DE',
                                            headline: 'Moderna\'s Terms and Conditions of Use',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '1AUKNUIiL6YEaYxpX7t22T',
                                            type: 'Entry',
                                            createdAt: '2022-12-14T19:48:58.589Z',
                                            updatedAt: '2023-06-20T16:09:09.109Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 70,
                                            revision: 8,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Terms of Use Rich Text Component - US',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2018-11-09',
                                            disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                                            content: {
                                                data: {},
                                                content: [
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Information about Us',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "These Website Terms and Conditions of Use (\u201CTerms\u201D) describe the terms and conditions applicable to your use the website operated by (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D and \u201Cus\u201D) and located at ",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {
                                                                    uri: 'https://www.modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        marks: [],
                                                                        value: 'www.modernatx.com',
                                                                        nodeType: 'text'
                                                                    }
                                                                ],
                                                                nodeType: 'hyperlink'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: " (the \u201CWebsite\u201D). We are a Delaware corporation and have our registered oGce at 200 Technology Square, Cambridge, MA 02139. All use of or linking to any content on the Website is subject to the terms and conditions contained in these\r\nTerms. By accessing or using the Website, you acknowledge that you have read, understood and agreed to these Terms and acknowledge that any prior agreements regarding the use of the Website between you and Moderna are superseded and of no force or eFect. If you do not agree to the Terms, do not access or use the Website. By using the Website, you represent that you are at least 18 years old.\n\r\nYou understand and agree that we may change these Terms at any time without prior notice. You may read a current, eFective copy of these Terms at any time by selecting the \u201CTerms and Conditions of Use\u201D link on the Website. Moderna may revise these terms at any time without prior notice. Any use of the Website aKer such date shall constitute your acceptance of such revised terms and conditions. If any change to these Terms is not acceptable to you, your sole remedy is to cease accessing, browsing and otherwise using the Website.\n\r\nYour access to and use of the Website is also subject to Moderna\u2019s Privacy Policy located at ",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {
                                                                    uri: 'https://www.modernatx.com/privacy-statement'
                                                                },
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        marks: [],
                                                                        value: 'www.modernatx.com/privacy-statement',
                                                                        nodeType: 'text'
                                                                    }
                                                                ],
                                                                nodeType: 'hyperlink'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: ', the terms and conditions of which are hereby incorporated herein by reference.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Use of Information',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'You may freely browse, access, download or use information from the Website, including any text, images, audio, video and software ("',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'Information',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: '") for your own temporary, non-commercial use. You have no rights in or to the Information, and you will not use, copy or display the Information, except as permitted under these Terms. No other use is permitted without our prior written consent. We may own the Information, or portions of the Information may be made available to us through arrangements that we have with third-parties. The Information is protected by United States and foreign intellectual property laws. Unauthorized use of the Information may result in violation of copyright, trademark, and other laws. You may not sell, transfer, assign, license, sublicense, or modify the Information or reproduce, display, publicly perform, make a derivative version of, distribute, transmit, reuse, repost, or otherwise use the Information in any way for any public or commercial purpose without our written permission. You may not use the Website or the Information from the Website (a) in any way that breaches any applicable local, national or international law or regulation; (b) in any way that is unlawful or fraudulent, or that has any unlawful or fraudulent purpose or effect; (c) to transmit, or procure the sending of, any unsolicited or unauthorized advertising or promotional material or any other form of similar solicitation (spam); or (d) to make unauthorized attempts to access any of our systems or third party networks. The use or posting of any of the Information on any other website or in a networked computer environment for any purpose is expressly prohibited. If you violate any part of these Terms, your right to access and/or use the Information and Site shall automatically terminate and you shall immediately destroy any copies you have made of the Information. We reserve the right to withdraw, amend or revise the Website without notice. We will not be liable if for any reason our Website is unavailable at any time or for any period. Nothing on this Website will be deemed to constitute an invitation to invest or otherwise deal in shares or other securities in Moderna.\n',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Copyright and Trademarks',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'You must retain and reproduce each and every copyright notice or other proprietary rights notice contained in the original Information on any copy you make of the Information or in any Information you download. The intellectual property rights in the Website and in the Information are owned by Moderna, our affiliates or our external partners. You should assume that everything you see or read on the Website is copyrighted unless otherwise noted and may not be used without our written permission except as provided in these Terms or in the text on the Website. No links to the Website may be included in any other website without our prior written permission. With the exception of the foregoing limited authorization, no license to or right in the Information, or any copyright of Moderna or of any other party is granted or conferred to you.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "The trademarks, service marks, and logos of Moderna (the \u201C",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'Moderna Trademarks',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "\u201D) used and displayed on the Website are registered and unregistered trademarks or service marks of Moderna or its subsidiaries or affiliates. Other company, product, and service names located on the Website may be trademarks or service marks owned by third-parties (the \u201C",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'Third-Party Trademarks',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "\u201D, and, collectively with the Moderna Trademarks, the \u201C",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'Trademarks',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "\u201D). Nothing on the Website or in these Terms should be construed as granting, by implication, estoppel, or otherwise, any license or right, express or implied, under any Trademark displayed on the Website without the prior written consent of Moderna specific for each and every instance. The Trademarks may not be used to disparage Moderna or any third party, Moderna\u2019s or a third-party\u2019s products or services, or in any manner (using commercially reasonable judgment) that may damage any goodwill in the Trademarks. Links to the Website from other sites should be text-only and use of any Trademarks as part of a link to or from any website is prohibited without Moderna\u2019s prior written consent. All goodwill generated from the use of any Moderna Trademark shall inure to Moderna\u2019s benefit.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Certain elements of the Website are protected by trade dress, trademark, unfair competition, and other U.S., state, federal, and international laws and may not be copied or imitated in whole or in part, by any means, including but not limited to, the use of framing or mirrors. None of the Information may be retransmitted without the express written consent from Moderna for each and every instance.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Medical Advice',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'The content on the Website is intended to be a general information resource in regard to the subject matter covered. Moderna does not directly or indirectly practice medicine, render medical advice, or dispense medical services via the Website, and nothing contained in the Website is intended to be instruction for medical diagnosis or treatment. Any information provided should not be considered complete, nor should it be relied on to suggest a basis for diagnosis or course of treatment for a particular individual. Information received from the Website should not be relied upon for personal, medical, legal, technical, or financial decisions. It should not be used in place of a visit, call, consultation or the advice of your physician or other qualified healthcare provider. Should you have any healthcare related questions, please consult with your physician or other qualified healthcare provider promptly.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Links',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "This Website may contain links to websites operated by other parties (\u201C",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'External Sites',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "\u201D). The External Sites are not under the control of Moderna, and Moderna is not responsible for the content available on any External Sites. Such links do not imply Moderna\u2019s referral or endorsement of material on External Sites or of any other entity, item or service, and Moderna disclaims all liability with regard to your access to External Sites. We are not responsible for the content of any linked External Sites and do not make any representations regarding the content or accuracy of any materials on such External Sites. You should take precautions when downloading files from all websites to protect your computer from viruses and other destructive programs. Moderna provides links to External Sites as a convenience to users, and access to any External Sites linked to this Website is at your own risk.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Forward-Looking Statements',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "The Website contains express or implied forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995, as amended, Section 27A of the Securities Act of 1933, as amended, and Section 21E of the Securities Exchange Act of 1934, that are based on beliefs and assumptions and on information currently available to Moderna\u2019s management. These statements relate to, among other things, Moderna\u2019s expectations regarding plans, objectives, strategies, future operating or financial performance, business plans and prospects, and expectations regarding clinical trials, development timelines, discussions with regulatory authorities, development programs, development candidates and investigational medicines under development by Moderna and by Moderna\u2019s strategic collaborators. In some cases, forward-looking statements can be identified by terminology such as \u201Cmay,\u201D \u201Cshould,\u201D \u201Cexpects,\u201D \u201Cintends,\u201D \u201Cplans,\u201D \u201Canticipates,\u201D \u201Cbelieves,\u201D \u201Cestimates,\u201D \u201Cpredicts,\u201D \u201Cpotential,\u201D \u201Ccontinue,\u201D or the negative of these terms or other comparable terminology, although not all forward-looking statements contain these words. Such statements are based on Moderna\u2019s management\u2019s current expectations and are subject to certain factors, risks and uncertainties that may cause actual results to differ materially from those referred to or implied in such statements. The information presented on the Website is believed to be current as of the date of its original publication. The forward-looking statements on this Website are neither promises nor guarantees, and you should not place undue reliance on these forward-looking statements because they involve known and unknown risks, uncertainties and other factors, many of which are beyond Moderna\u2019s control and which could cause actual results to differ materially from those expressed or implied by these forward-looking statements. Moderna does not intend to update any forward-looking statements appearing on the Website in the event of changing circumstances or otherwise, and such statements are current only as of the date they are made.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "Please note that while Moderna\u2019s filings with the United States Securities and Exchange Commission are available on or through Internet links contained on the Website, no information contained on or available through the Website is incorporated by reference into or considered to be part of such filings.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Updates',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "Moderna may make changes, corrections and/or improvements to the Information, and to the products and programs described in such Information, at any time without notice. Although we attempt to periodically update the Website, the Information, materials and services provided on or through the Website may occasionally be inaccurate, incomplete or out of date and are provided on an \u201CAS IS\u201D and \u201CAS AVAILABLE\u201D basis. Moderna does not have a duty to update information contained in the Website, and Moderna will not be liable for any failure to update such information. We make no representation as to the completeness, accuracy or currency of any information on the Website, and we undertake no obligation to update or revise the information contained on the Website, whether as a result of new information, future events or circumstances or otherwise. It is your responsibility to verify any information contained in the Website before relying upon it.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Disclaimer of Warranties',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "MODERNA, ITS SUBSIDIARIES AND OTHER AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, STRATEGIC COLLABORATORS, AND LICENSORS (COLLECTIVELY, THE \u201C",
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'italic'
                                                                    }
                                                                ],
                                                                value: 'MODERNA PARTIES',
                                                                nodeType: 'text'
                                                            },
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "\u201C) MAKE NO WARRANTIES OR REPRESENTATIONS AND DO NOT GIVE ANY UNDERTAKINGS, EITHER EXPRESS OR IMPLIED, ABOUT THE WEBSITE OR THE INFORMATION (INCLUDING, WITHOUT LIMITATION, THE TIMELINESS, CURRENCY, ACCURACY, COMPLETENESS OR FITNESS FOR ANY PARTICULAR PURPOSE OF THE INFORMATION OR THAT THE RESULTS WHICH MAY BE OBTAINED FORM THE USE OF THE WEBSITE WILL BE ERROR FREE OR RELIABLE.)",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Limitation of Liability',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'THE MODERNA PARTIES WILL NOT BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT, SPECIAL OR PUNITIVE DAMAGES ARISING OUT OF ACCESS TO, USE OF OR INABILITY TO USE THIS WEBSITE, OR ANY ERRORS OR OMISSIONS IN THE INFORMATION INCLUDING, WITHOUT LIMITATION ANY LIABILITY FOR (I) LOSS OF INCOME OR REVENUE, (II) LOSS OF BUSINESS OR BUSINESS INTERRUPTION, (III) LOSS OF PROFITS OR CONTRACTS, (IV) LOSS OF ANTICIPATED SAVINGS, (V) LOSS OF DATA, (VI) LOSS OF GOODWILL, (VII) WASTED MANAGEMENT OR OFFICE TIME; AND (VIII) FOR ANY OTHER LOSS OR DAMAGE OF ANY KIND, HOWEVER ARISING AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE. ADDITIONALLY, THE MODERNA PARTIES SHALL NOT BE SUBJECT TO LIABILITY FOR THE TRUTH, ACCURACY OR COMPLETENESS OF THE INFORMATION, FOR ERRORS, MISTAKES OR OMISSIONS THEREIN OR FOR ANY DELAYS OR INTERRUPTIONS OF THE DATA OR INFORMATION STREAM FROM WHATEVER CAUSE. YOU USE THE WEBSITE AND THE INFORMATION AT YOUR OWN RISK.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'THE MODERNA PARTIES DO NOT WARRANT THAT THE WEBSITE WILL OPERATE ERROR FREE OR THAT THE WEBSITE, ITS SERVER, OR THE INFORMATION ARE FREE OF COMPUTER VIRUSES OR SIMILAR CONTAMINATION OR DESTRUCTIVE FEATURES. IF YOUR USE OF THE WEBSITE OR THE INFORMATION RESULTS IN THE NEED FOR SERVICING OR REPLACING EQUIPMENT OR DATA, NO MODERNA PARTY SHALL BE RESPONSIBLE FOR THOSE COSTS.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "THE WEBSITE AND INFORMATION ARE PROVIDED ON AN \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE MODERNA PARTIES DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Some jurisdictions do not allow the disclaimer or exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above exclusions or limitations may not apply to you or be enforceable with respect to you. We also do not assume any responsibility, and will not be liable, for any damages to, or viruses that may infect, your computer equipment or other property on account of your access to, or use of, the Information. Moderna reserves the right to discontinue the Website at any time without notice and without liability.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Information You Supply to Us',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Any communication or material you transmit to us by electronic mail or otherwise, including any data, questions, comments, suggestions or the like is, and will be treated as, non-confidential and nonproprietary, and Moderna shall have no obligation of any kind with respect to such information. Anything you transmit or post becomes the property of Moderna and may be used by Moderna and any of its subsidiaries, affiliates, strategic collaborators and third-party service providers for any purpose, including, but not limited to, reproduction, disclosure, transmission, publication, broadcast and posting. Moderna and its subsidiaries, affiliates, strategic collaborators and third-party service providers are free to use, without compensation to you, any ideas, concepts, know-how, or techniques contained in any communication you send to the Website for any purpose whatsoever including, but not limited to, researching, developing, manufacturing and marketing products using or incorporating such information. Any information submitted or provided by you to the Website might be publicly accessible. Important and private information should be protected by you. Moderna is not liable for protection of privacy of email or other information transferred through the Internet or any other network that you may use.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Worldwide Products',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'The Website may contain information on our current or potential future worldwide products and services, not all of which are available in every location. A reference to a product or service on the Website does not imply that such product or service is or will be available in your location. The products referred to on this website may be subject to different regulatory requirements depending on the country of use. Consequently, visitors may be notified that certain sections of the Website are intended only for certain kinds of expert users or only for audiences in certain countries. You should not construe anything on the Website as a promotion or advertisement for any product or for the use of any product that is not authorized by the laws and regulations of your country of residence.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Applicable Law',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'heading-3'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'You are solely responsible for ensuring compliance with the laws of your specific jurisdiction. The Website can be accessed from every U.S. state, as well as from other countries around the world. Each of those places has laws that may differ from those of Massachusetts, where Moderna is located. By accessing the Website, you and Moderna agree that the laws of The Commonwealth of Massachusetts, without regard to its conflicts of laws principles, will apply to all disputes based on, arising out of, or relating to your use of the Website or any information it contains. With respect to such disputes, you and Moderna also agree and hereby submit to the exclusive personal jurisdiction and venue of any court located in Boston, Massachusetts.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'You will comply with any applicable export restrictions under any applicable export control laws and not to export or re-export any of the Information to countries or persons prohibited under such export control laws. If you are in a country where such export is prohibited or are a person or entity for which such export is prohibited, you may not download any Information. You are solely responsible for compliance with the laws of your specific jurisdiction regarding the import, export, or re-export of the Information.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: "The Information is provided with \u201CRESTRICTED RIGHTS.\u201D Use, duplication, or disclosure by the U.S. Government is subject to the restrictions contained in 48 CFR 52.227-19 and 48 CFR 252.227-7013 et seq. or its successor. Use of the Website or Information by the U.S. Government constitutes acknowledgement of our proprietary rights in the Website and Information.",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'If any provision of these Terms is found to be unlawful, invalid or unenforceable by any court having competent jurisdiction, the invalidity or unenforceability of such provision shall not affect the validity of the remaining provisions of these Terms, which shall remain in full force and effect. Failure of Moderna to act on or enforce any provision of these Terms shall not be construed as a waiver of that provision or any other provision in these Terms. No waiver shall be effective against Moderna unless made in writing, and no such waiver shall be construed as a waiver in any other or subsequent instance. Except as expressly agreed by Moderna and you in writing, these Terms constitute the entire agreement between you and Moderna with respect to the subject matter and supersedes all previous or contemporaneous agreements, whether written or oral, between the parties with respect to the subject matter. The section headings are provided merely for convenience and shall not be given any legal import. Moderna may assign its ownership, control, or other rights to any party at any time without notice to you.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'These terms will inure to the benefit of our successors, assigns, licensees, and sublicensees.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    }
                                                ],
                                                nodeType: 'document'
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '7rSkinNLdOrCD7IDSdKH7b',
                                            type: 'Entry',
                                            createdAt: '2023-05-24T19:21:51.275Z',
                                            updatedAt: '2023-06-16T17:43:18.090Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 186,
                                            revision: 29,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Terms of Use Rich Text Component - DE',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2023-01-07',
                                            disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                                            content: {
                                                nodeType: 'document',
                                                data: {},
                                                content: [
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Information about Us',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "These Website Terms and Conditions (\u201CTerms\u201D) describe the terms and conditions that apply to your use of the website operated by (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D and \u201Cus\u201D). We are a corporation incorporated under the laws of the State of Delaware (Delaware Corporation) and have our registered oce at 200 Technology Square, Cambridge, MA 02139, USA. Any use of or linking to any content on the Site is subject to the terms and conditions contained in these\nTerms. By accessing or using the Site, you acknowledge that you have read, understood, and agreed to these Terms, and acknowledge that any prior\nagreements regarding the use of the Site between you and Moderna are superseded and have no eect. If you do not agree to the Terms, you may not\naccess or use the Site. By using the Website, you represent that you are at least 18 years old.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "You understand and agree that we may change these Terms at any time without notice. You can read a current, valid copy of these Terms at any time by\nclicking on the \u201CTerms and Conditions\u201D link on the Website. Moderna may revise these Terms at any time without notice. Any use of the Site aer such\ndate shall be deemed acceptance of these revised Terms and Conditions. If any modification of these Terms is unacceptable to you, your sole remedy is\nto cease accessing, browsing and other use of the Site.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Your access to and use of the Site is also subject to Moderna\u2019s Privacy Policy, which can be found at hps://www.modernatx.com/de-de/privacystatement, the terms of which are incorporated by this reference into this Statement.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Copyright and Trademarks',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "You may freely browse, access, download or use the information on the Site, including all text, images, audio and video files, and soware (\u201CInformation\u201D) for your own temporary, non-commercial use. You have no rights to the information, and you will not use, copy or display the information except as permied in these terms. Any other use is not permied without our prior wrien permission. We may own the information, or portions of the information may be made available to us through agreements we have entered into with third parties. The information is protected by U.S. and foreign intellectual property laws. Unauthorized use of the information may result in a violation of copyright, trademark and other laws. You may not sell, transfer, assign, license, sublicense, or modify the Information, or reproduce, display, publicly perform, create a derivative version of, distribute, transmit, reuse, repost, or otherwise exploit the Information for any public or commercial purpose without our wrien permission. You may not use the Site or the Site\u2019s information (a) in any manner that violates any applicable local, national, or international law or regulation; (b) use in any way that is unlawful, fraudulent or serves any unlawful or fraudulent purpose or eect; (c) transmit or cause to be sent unsolicited or unauthorized advertising or promotional materials or other forms of similar solicitation (spam); or (d) make unauthorized aempts to access any of our third-party systems or networks. It is expressly prohibited to use or publish the information on any other website or in a networked computer environment for any purpose. If you breach any part of these Terms, your right to access and/or use the Information and the Website will automatically cease and you will immediately destroy any copies you have made of the Information.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'We reserve the right to withdraw, modify or revise the website without prior notice. We will not be liable if, for any reason, our website is unavailable at any time or for any period. Nothing on this website constitutes a solicitation to invest in or otherwise deal in any Moderna stock or other securities.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Use of Information',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nYou must retain and reproduce all copyright notices or other proprietary rights notices contained in the original information on any copy you make of the information and in any information you download. The copyrights in the Site and Information are owned by Moderna, our aliates, or our third-party partners. You should assume that everything you see or read on the Website is copyrighted, unless otherwise stated, and may not be used without our wrien permission, except as provided in these Terms or in the text on the Website. No links to this website may be included in other websites without our prior wrien permission. Except for the foregoing limited authorization, no license or right to the Information or any copyright of Moderna or any other party is granted or transferred to you.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Moderna\u2019s trademarks, service marks, and logos (the \u201CModerna Marks\u201D) used and displayed on the Site are registered and unregistered trademarks or service marks of Moderna or its subsidiaries or aliates. Other company, product and service names on the Site may be trademarks or service marks owned by third parties (the \u201CThird Party Marks\u201D and, together with the Moderna Marks, the \u201CMarks\u201D). Nothing contained on the Site or in these Terms shall be construed as granting, by implication, estoppel, or otherwise, any license or right, express or implied, under any trademark displayed on the Site, without Moderna\u2019s prior wrien permission specifically for each individual case. The Trademarks may not be used to disparage Moderna, a third party, Moderna\u2019s or any third party\u2019s products or services, or in any manner (using a commercially reasonable judgment) that could damage the market value of\nthe Trademarks. Links to the website from other websites should be text only, and the use of trademarks as part of a link to or from a website is prohibited without the prior wrien permission of Moderna. All of the brand equity that comes from using a Moderna brand benefits Moderna.\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Certain elements of the Site are protected by utility models, trademarks, unfair competition laws, and other U.S., state, and international laws, and may not\nbe copied or imitated, in whole or in part, including, but not limited to, the use of framing and mirrors. None of the information may be disclosed without\nthe express wrien permission of Moderna for each individual case\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Medical Advice\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'The content of the website is intended as a general source of information regarding the topics covered. Moderna does not directly or indirectly engage in any medical activity, does not provide medical advice, or provide medical services through the Site, and nothing contained on the Site is intended to be a guide to any medical diagnosis or treatment. The information provided should not be considered complete, nor should it be used as a basis for a diagnosis or course of treatment for a particular person. The information obtained from the website should not be used to make personal, medical, legal, technical or financial decisions. These should not be used in lieu of a visit, call, consultation, or advice from your physician or other qualified healthcare provider. If you have any questions about your health, please contact your physician or other qualified healthcare provider immediately.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Links',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "This Site may contain links to websites operated by other parties (\u201CExternal Sites\u201D). The external websites are not under the control of Moderna, and Moderna is not responsible for the content available on external websites. Such links do not imply that Moderna endorses or endorses the material on the External Sites or any other entity, item or service, and Moderna disclaims any and all liability with respect to your access to External Sites. We are not\nresponsible for the content of linked external sites and make no representations regarding the content or accuracy of any materials on such external sites. You should take precautions when downloading files from all websites to protect your computer from viruses and other destructive programs. Moderna provides links to external websites as a convenience to users, and access to external websites linked to this website is at the user\u2019s own risk\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n\nForward Looking Statements\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "The Site contains express or implied forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995, as amended, Section 27A of the Securities Act of 1933, as amended, and Section 21E of the Securities Exchange Act of 1934, which are based on beliefs and assumptions and information currently available to Moderna\u2019s management. These statements relate to, among other things, Moderna\u2019s expectations\nregarding plans, objectives, strategies, future operating or financial results, business plans and prospects, and expectations with respect to clinical trials, development timelines, discussions with regulatory authorities, development programs, development candidates and investigational drugs being developed by Moderna and Moderna\u2019s strategic collaborative partners. In some cases, forward-looking statements can be identified by words such as\n\u201Cmay\u201D, \u201Cshould\u201D, \u201Cexpect\u201D, \u201Cintend\u201D, \u201Cplan\u201D, \u201Canticipate\u201D, \u201Cbelieve\u201D, \u201Cestimate\u201D, \u201Cpredict\u201D,\n\u201Cpotential\u201D, \u201Ccontinue\u201D or the negation of these terms or other comparable terms, even if not all forward-looking statements contain these words. Such statements are based on the current expectations of Moderna\u2019s management and are subject to certain factors, risks and uncertainties that could cause actual results to dier materially from those expressed or implied by such statements. The information presented on the website is assumed to be up-to-date at the time of its original publication. The forward-looking statements on this website are neither promises nor warranties, and you should not place undue reliance on these forward-looking statements because they involve known and unknown risks, uncertainties and other factors, many of which are beyond Moderna\u2019s control, which could cause actual results to dier materially from those expressed or implied by such forward-looking statements Results dier. Moderna does not intend to update the forwardlooking statements appearing on the Site as circumstances change or otherwise, and such statements are current only as of the date they are made. ",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Please note that while Moderna\u2019s filings with the U.S. Securities and Exchange Commission are available on the Site or through Internet links on the Site, no information contained on or available through the Site will be incorporated by reference into or considered part of such materials.\n\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Updates',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\nModerna may, at any time and without notice, make changes, corrections and/or improvements to the information and to the products and programs described in such information. Although we aempt to update the Website regularly, the information, materials and services provided on or through the Website may occasionally be inaccurate, incomplete or out of date and are provided on an \u201CAS IS\u201D and \u201CAVAILABLE\u201D basis. Moderna is under no obligation to update the information contained on the Site, and Moderna shall not be liable for any failure to update such information. We do not warrant the completeness, accuracy or timeliness of the information on the Site, and we make no commitment to update or revise the information contained on the Site, whether as a result of new information, future events or circumstances, or otherwise. It is your responsibility to review all information contained on\nthe website before relying on it.\n\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Exclusion of Warranties',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\nMODERNA, ITS SUBSIDIARIES AND OTHER AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, STRATEGIC COLLABORATORS AND LICENSORS (COLLECTIVELY, THE \u201CMODERNA PARTIES\u201D) MAKE NO WARRANTIES OR REPRESENTATIONS AND MAKE NO WARRANTIES WITH RESPECT TO THE SITE OR THE INFORMATION (INCLUDING, BUT NOT LIMITED TO, TIMELINESS, ACCURACY, COMPLETENESS, OR\nSUITABILITY FOR THE SITE). A SPECIFIC PURPOSE OF THE INFORMATION OR THAT THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE WEBSITE ARE ERROR-FREE OR RELIABLE.)",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Limitation of Liability',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "\nMODERNA\u2019S PARTIES SHALL NOT BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT, SPECIAL, OR PUNITIVE DAMAGES ARISING OUT\nOF ACCESS TO, USE, OR INABILITY TO USE THIS SITE, OR FROM ANY ERRORS OR OMISSIONS IN THE INFORMATION, INCLUDING WITHOUT LIMITATION ANY LIABILITY FOR (I) LOSS OF REVENUE OR INCOME, (II) LOSS OF BUSINESS OR BUSINESS INTERRUPTION, (III) LOSS OF PROFITS OR ORDERS, (IV) LOSS OF ANTICIPATED SAVINGS, (V) LOSS OF DATA, (VI) LOSS OF MARKET VALUE, (VII) WASTED MANAGEMENT OR OFFICE TIME; AND (VIII) FOR ANY\nOTHER LOSS OR DAMAGE OF ANY KIND, REGARDLESS OF THE CONDITIONS OF ITS OCCURRENCE AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE. IN ADDITION, THE MODERNA PARTIES ASSUME NO LIABILITY FOR THE TRUTH, ACCURACY OR COMPLETENESS OF THE INFORMATION, FOR ANY ERRORS, MISTAKES OR OMISSIONS THEREIN, OR FOR ANY DELAYS OR INTERRUPTIONS IN THE FLOW OF DATA OR INFORMATION, FOR ANY REASON. YOU USE THE WEBSITE AND THE INFORMATION AT YOUR OWN RISK. THE MODERNA PARTIES DO NOT WARRANT THAT THE SITE WILL OPERATE ERROR-FREE OR THAT THE SITE, ITS SERVER, OR INFORMATION ARE FREE OF COMPUTER VIRUSES OR SIMILAR CONTAMINATION OR DESTRUCTIVE FEATURES. IF YOUR USE OF THE SITE OR INFORMATION RESULTS IN THE\nNEED FOR MAINTENANCE OR REPLACEMENT OF EQUIPMENT OR DATA, NO MODERNA PARTY IS RESPONSIBLE FOR SUCH COSTS. THE WEBSITE AND THE INFORMATION ARE PROVIDED ON AN \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE MODERNA PARTIES DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF TITLE, MERCHANTABILITY, NONINFRINGEMENT OF THIRD PARTY RIGHTS, AND FITNESS FOR A PARTICULAR PURPOSE.\n\n",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above exclusions or limitations may not apply to you or be enforceable with respect to you. We also assume no responsibility and will not be liable for any damage or viruses that infect your computer equipment or other property as a result of your access to or use of the\ninformation. Moderna reserves the right to discontinue the Site at any time without notice and without liability\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Information You Provide to Us\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Any communication or material you transmit to us by email or otherwise, including any data, questions, comments, suggestions, or the like, is and will be treated as non-confidential and non-proprietary, and Moderna has no obligations whatsoever with respect to such information. Everything you transmit or post becomes the property of Moderna and may be used by Moderna and its subsidiaries, aliates, strategic collaborators, and third-party service\nproviders for any purpose, including, but not limited to, reproduction, disclosure, transmission, publication, broadcasting, and posting. Moderna and its subsidiaries, aliates, strategic collaborators, and third-party service providers are authorized to use any ideas, concepts, know-how, or techniques contained in the communications you send to the Site, without compensation, for any purpose whatsoever, including, but not limited to, researching,\ndeveloping, manufacturing, and marketing products that use or contain such information. Any information you submit or provide to the Site may be publicly available. Important and private information should be protected by you. Moderna is not responsible for protecting the privacy of any email or other information transmied over the Internet or any other network you use.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Worldwide Products\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'The Site may contain information about our current or potential future worldwide products and services, not all of which are available in every location. A reference to a product or service on the Site does not imply that such product or service is or will be available in your location. The products referenced on this website may be subject to dierent regulatory requirements depending on the country in which they are used. Consequently, visitors may be advised that certain areas of the site are intended only for certain types of professionals or only for an audience in certain countries. You should not construe anything on the Site as promoting or advertising any product or for the use of any product that is not authorized by the laws and regulations of your country of residence.\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'heading-3',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nApplicable Law\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'You are solely responsible for ensuring compliance with the laws of your specific jurisdiction. The website can be accessed from any US state and also from other countries around the world. Each of these places has laws that may dier from those of the U.S. state of Massachuses, where Moderna is based. By accessing the Site, you and Moderna agree that the laws of the Commonwealth of Massachuses, without regard to principles of conflict of\nlaws, shall apply to any dispute arising out of, arising out of, or relating to the use of the Site or the information contained therein. With respect to such disputes, you and Moderna also consent and hereby submit to the exclusive personal jurisdiction and venue of any court located in Boston, Massachuses, USA.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nYou agree to comply with all applicable export restrictions under all applicable export control laws and not to export or re-export any of the information to any country or to any person prohibited under such export control laws. If you are located in a country where such export is prohibited, or if you are a person or entity for whom such export is prohibited, you may not download any information. You are solely responsible for complying with the laws of your specific jurisdiction with respect to the import, export or re-export of the information.\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "The information is provided with \u201CRESTRICTED RIGHTS\u201D. Use, duplication, or disclosure by the U.S. Government is subject to the restrictions contained in 48 CFR 52.227-19 and 48 CFR 252.227-7013 et seq. or their successors. Use of the Site or Information by the U.S. Government constitutes acknowledgment of our ownership rights in the Site and Information.\nIf any provision of these Terms is found by a court of competent jurisdiction to be unlawful, invalid or unenforceable, the invalidity or unenforceability of such provision shall not aect the validity of the remaining provisions of these Terms, which shall remain in full force and eect. Moderna\u2019s failure to comply with or enforce any provision of these Terms shall not be construed as a waiver of such provision or any other provision of these Terms. A waiver\nshall be eective against Moderna only if it is made in writing, and such waiver shall not be construed as a waiver in any other or subsequent instance. Except as expressly agreed in writing between Moderna and you, these Terms constitute the entire agreement between you and Moderna with respect to the subject maer and supersede all prior or contemporaneous agreements, whether wrien or oral, between the parties with respect to the subject maer. The section headings are for convenience only and have no legal significance. Moderna may assign its ownership, control or other rights to any party at any time without notice to you.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nThese Terms shall inure to the benefit of our successors, assigns, licensees and sublicensees.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n\n\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '44uly5vTmjFxuRaiIdQwyZ',
                type: 'Entry',
                createdAt: '2022-12-14T23:15:14.671Z',
                updatedAt: '2022-12-23T17:27:47.054Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 8,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'internalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Return Goods Policy Internal Link',
                label: 'Vaccine Product Return Policy',
                pageReference: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6nT2JOBfWhTcZ1Pwxzp5rn',
                        type: 'Entry',
                        createdAt: '2022-12-14T23:01:59.558Z',
                        updatedAt: '2022-12-14T23:01:59.558Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 18,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'page'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        name: 'Return Goods Policy Content Page',
                        title: 'Return Goods Policy',
                        slug: 'return-goods-policy',
                        seo: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '5gMYYleewpKSWJ4q6TvZUj',
                                type: 'Entry',
                                createdAt: '2022-12-14T23:01:59.639Z',
                                updatedAt: '2022-12-14T23:01:59.639Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 11,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'seo'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Return Goods Policy Content Page - Compose: SEO'
                            }
                        },
                        content: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '4gWDVRE6oKE0h0dqd37xcu',
                                type: 'Entry',
                                createdAt: '2022-12-14T23:01:59.660Z',
                                updatedAt: '2023-06-20T16:21:22.755Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 21,
                                revision: 5,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'richTextContentPageTemplate'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Return Goods Policy Content Page - Rich Text Content Page Template',
                                modules: [
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '4yWyEpVfxgjAmUcWCWMXBe',
                                            type: 'Entry',
                                            createdAt: '2022-12-14T23:04:20.745Z',
                                            updatedAt: '2023-06-16T18:23:22.281Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 20,
                                            revision: 2,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Return Goods Policy Banner Component',
                                            headline: 'Moderna Vaccine Product Return Policy',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '3LzpM6ba6wGXMlxYkj0OfE',
                                            type: 'Entry',
                                            createdAt: '2023-06-16T18:28:28.772Z',
                                            updatedAt: '2023-06-16T18:28:39.366Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 5,
                                            revision: 2,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Return Goods Policy Banner Component - DE',
                                            headline: 'Moderna Vaccine Product Return Policy',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '5zfGJA7or5WGcLdYi4Qde',
                                                    type: 'Asset',
                                                    createdAt: '2022-10-28T18:53:29.208Z',
                                                    updatedAt: '2022-10-28T18:53:29.208Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG Strand Top',
                                                    description: '',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner BG Strand Top .png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '5KqsjWl1JAA7AvePDZzaq5',
                                            type: 'Entry',
                                            createdAt: '2022-12-14T23:00:13.065Z',
                                            updatedAt: '2024-07-19T13:17:52.682Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 166,
                                            revision: 14,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Return Goods Rich Text Component - US',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2024-07-01',
                                            content: {
                                                nodeType: 'document',
                                                data: {},
                                                content: [
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Returned Goods Policy and Procedures',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: "\xa0\nModerna US,\u202FInc.\xa0",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "This Return Goods Policy controls what Moderna products are eligible for return and sets forth procedures for return of those eligible products. This Policy may be amended by Moderna at any time in its sole discretion. Moderna will only accept returns subject to this Policy from parties that purchased product directly from Moderna or indirectly through an authorized distributor of record (ADR). The policy detailed below is for customers that have purchased directly from Moderna. For customers who purchased from an ADR, the Return Policy of the ADR should be followed for Seasonal and Non-Seasonal Returns. If your ADR\u2019s policy instructs you to return directly to Moderna please follow the instructions in this policy.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Returnable Items:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Products received by customer as damaged or received in error \u2013 Products received damaged or in error may be returned for full credit when reported within three (3) business days of receipt of product subject to the terms herein. Products should remain in the original carton for inspection, and products must be returned in accordance with all Return Authorization (RA) instructions. Please contact 1-866-MODERNA (663-3762) or email a request to ",
                                                                                marks: [],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'hyperlink',
                                                                                data: {
                                                                                    uri: 'mailto:Commercialops@modernatx.com'
                                                                                },
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'text',
                                                                                        value: 'Commercialops@modernatx.com',
                                                                                        marks: [],
                                                                                        data: {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ' within three (3) business days to report product damaged or received in error.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Seasonal Product Returns.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'unordered-list',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: "\u201CSeasonal Products\u201D are defined as Products that are generally reformulated each season or each year to address new or changing virus/disease strains. Each reformulation generally requires approval from FDA and issuance of new NDC numbers. Seasonal Products remain eligible for sale until a new formulation is approved or as per direction and availability from Moderna.",
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'At the end of each season, a percentage of the total volume of Seasonal Product (currently, Covid-19 vaccine) purchased directly from Moderna may be returned for credit. The specific percentage will be defined in the customer contract. Returns in excess of the allowable total, within a single season, will be destroyed and only Federal Excise Tax (FET) will be credited where applicable.',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Return requests for seasonal returns of Moderna Seasonal Product must be received by Inmar during the Seasonal Returns Window. The Seasonal Returns Window will be communicated by Moderna, in its discretion, prior to its opening.',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Other Expired Products',
                                                                                marks: [
                                                                                    {
                                                                                        type: 'bold'
                                                                                    }
                                                                                ],
                                                                                data: {}
                                                                            },
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: ' that are not Seasonal Products as determined by Moderna may be returned within two months of expiry and up to 12 months after expiry.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Returns for partial cartons are accepted.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Products Ineligible for Returns:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'All products, other than those listed above, shall be deemed ineligible for returned goods credit. Ineligible products cannot be returned to the customer and will be destroyed with no credit issued. Products that are ineligible for returned goods credit include, without limitation:',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Seasonal Product received after the defined seasonal return window closes.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Seasonal Product that exceeds the returns allowance/percentage specified in the customer contract.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Non-Seasonal Product returned prior to 2 months prior to expiry and more than 12 months after expiry.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product obtained under EUA distribution from the United States Government.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product returned without a Return Authorization (RA) as further explained below.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product for which original proof of purchase cannot be verified.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product returned with illegible or missing lot numbers, or expiration dates. No credit will be issued if the lot number or expiration date is missing, covered and/or unreadable on original container.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Repackaged product.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product with an opened seal.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product obtained at no cost and/or labeled as professional samples, clinical trial use, patient assistance program use or similar special labels.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product sold on a non-returnable basis.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product obtained illegally or re-imported from outside the United States.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product that has been adulterated, misbranded, or counterfeit, as determined by Moderna at its sole reasonable discretion.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Distressed merchandise obtained through bankruptcy or sacrifice sale, going out-of- business sale, or other merchandise classified as \u201Cdistressed merchandise.\u201D",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product damaged due to the negligence of the purchaser and/or customer.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product that has not been properly stored according to guidelines provided by Moderna.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product damaged by fire, water, or other acts of God.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product returned by any indirect customer.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Procedure for Non-Seasonal or Other Product Returns',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: "Product returns require a RA issued through Moderna\u2019s Customer Service department via phone number or email listed below. RAs expire thirty (30) calendar days from date issued.",
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Via phone:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' 1-866-Moderna (663-3762)',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Via email:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: ' ',
                                                                marks: [],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'hyperlink',
                                                                data: {
                                                                    uri: 'mailto:Commercialops@modernatx.com'
                                                                },
                                                                content: [
                                                                    {
                                                                        nodeType: 'text',
                                                                        value: 'Commercialops@modernatx.com',
                                                                        marks: [],
                                                                        data: {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Customers who place orders directly with Moderna must submit an itemized list of products being returned, with the following information included for each product:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'unordered-list',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Debit Memo number, product name, product quantity, unit price, serial number, GTIN, lot number, NDC number, expiration date, billing address, shipping address, contact name and phone/email, and RA number.',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Indirect requests for return (i.e., requests from a hospital and/or pharmacy) are not covered by this policy and instead must route through their ADR.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Ship returnable products, along with a copy of the Moderna RA and Debit Memo to:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Shipping and Returned Goods Address:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "It is the shipper\u2019s responsibility to securely package all returned products to prevent breakage during transit.",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Product must be returned with shipping label and insurance unless such return is due to Moderna\u2019s error (such as damaged product, mis-delivery, or discontinued/recalled product).",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Return Procedure for Eligible Returns:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Expired product returns require a RA issued through Inmar. To request a RA from Inmar, please use one of the three options below. ',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'unordered-list',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Access the Inmar website at ',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'hyperlink',
                                                                                                data: {
                                                                                                    uri: 'https://hrm.reskureturns.com/landing'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        nodeType: 'text',
                                                                                                        value: 'https://hrm.reskureturns.com/landing',
                                                                                                        marks: [],
                                                                                                        data: {}
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: ' and upload a PDF copy of your debit memo or Returns Request form',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'E-mail document to ',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'hyperlink',
                                                                                                data: {
                                                                                                    uri: 'mailto:rarequest@inmar.com'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        nodeType: 'text',
                                                                                                        value: 'rarequest@inmar.com',
                                                                                                        marks: [],
                                                                                                        data: {}
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: '',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Fax document to Inmar at 817-868-5343.',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Customers must submit an itemized list of products being returned, with the following information included for each product, as shown on the invoice:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        nodeType: 'unordered-list',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Customer DEA and/or HIN# used to create account',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Customer Name',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Customer Shipping address as shown on invoice',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Source of Purchase (ADR name or Moderna)',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Product name, NDC number(s), lot number(s), expiration date(s)',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Product quantity',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Sale Unit price (Invoiced price)',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Contact name and phone/email',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                nodeType: 'list-item',
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        nodeType: 'paragraph',
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                nodeType: 'text',
                                                                                                value: 'Inmar will provide a box label to print when submitting your return request.',
                                                                                                marks: [],
                                                                                                data: {}
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "If you have any questions, please contact Inmar Pharmaceutical Services at 1-800-967-5952 option 3. Mon. \u2013 Fri. 7am \u2013 5pm CT",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Include the completed RA box label with your return.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Send returns to:',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "It is shipper\u2019s responsibility to securely package all returned products to prevent breakage during transit.",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'If multiple RAs are being returned within a single delivery to Inmar Pharmaceutical Services, ensure returned product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay to the crediting process.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Returned products do not require cold chain shipping.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Additional Terms for Return Credit:',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'unordered-list',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Product must be in original retail trade packaging. Repackaged items will not be accepted for return or credited.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Credit for eligible and approved returns will be determined by Moderna. Such credit will be issued in credit memo form and will be applied to Customer\u2019s current account balance.",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Moderna reserves the right, prior to credit being issued, to verify the original proof of purchase to determine that product being returned was shipped from Moderna to Customer.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Credit for erroneous or damaged product will be issued upon receipt and processing of return of product. No deduction can be taken prior to that time.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Credit for Seasonal Returns will be issued at the end of each season. Credit will be limited to a contractually defined percentage of total vaccine product purchased directly from Moderna plus any applicable federal excise tax credit. Credit will be issued upon completion of the vaccine season and upon processing of returns. No deduction can be taken prior to that time.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Returned goods may not be exchanged for replacement merchandise.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'All returned product becomes the property of Moderna. All items returned without an RA, or not in compliance with this Policy, may be accepted but with no credit issued.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'Returns from third-party processors acting on behalf of customers may be accepted provided that the customer receives approval from Moderna, and the third-party processor complies with all aspects of this Returned Goods Policy. Moderna is not responsible for fees incurred by third-party processor.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: 'All products returned are subject to final review and evaluation by Moderna.',
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                nodeType: 'list-item',
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        nodeType: 'paragraph',
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                nodeType: 'text',
                                                                                value: "Any questions regarding Moderna\u2019s Returned Goods Policy can be addressed by Moderna\u2019s Customer Care Team at 1-866-Moderna (663-3762).",
                                                                                marks: [],
                                                                                data: {}
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Reservation of Rights',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Moderna reserves the right to modify and make exceptions to this policy and to its implementation at any time, without notice, for any reason, including due to business necessity or changes in applicable laws and regulations.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7sht7920U6vs3CLH2CUyaa',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:23:50.744Z',
                                                    updatedAt: '2023-05-24T22:55:23.250Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 6,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '5FFA0liz6Apt9Uz8LsSWzy',
                                            type: 'Entry',
                                            createdAt: '2023-05-24T19:13:43.878Z',
                                            updatedAt: '2023-06-16T20:38:06.226Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 18,
                                            revision: 6,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Return Goods Rich Text Component - DE',
                                            effectiveDateLabel: 'Effective',
                                            effectiveDate: '2023-01-07',
                                            content: {
                                                nodeType: 'document',
                                                data: {},
                                                content: [
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: 'Our Return Policy',
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                data: {}
                                                            },
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\nReturn policies have not yet been decided on and will be later displayed here. Please remember that by now this is a non binding reservation which will be converted to a binding reservation only with your active approval at a later point in time.',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        nodeType: 'paragraph',
                                                        data: {},
                                                        content: [
                                                            {
                                                                nodeType: 'text',
                                                                value: '\n\n\n',
                                                                marks: [],
                                                                data: {}
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            backToTopButtonLabel: 'Back To Top',
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7DX7badGk41XRSy4znPNFI',
                                                    type: 'Entry',
                                                    createdAt: '2023-05-18T03:24:01.186Z',
                                                    updatedAt: '2023-05-24T23:04:52.125Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 2,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'Germany',
                                                    isocode: 'DE',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1PJ5nPASFqJbHZkqrkOloj',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T23:04:44.544Z',
                                                            updatedAt: '2023-05-24T23:04:44.544Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Germany Flag',
                                                            description: 'Germany Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                                                details: {
                                                                    size: 1305,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'de_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-DE'
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '2kHlohWHeSQbDJuOgoMZfO',
                type: 'Entry',
                createdAt: '2024-03-08T16:43:35.145Z',
                updatedAt: '2024-03-08T16:43:46.016Z',
                environment: {
                    sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'internalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)',
                label: 'Notice of Seasonal Return Window',
                pageReference: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1ss0StRsEFrdMIHmkvmgkW',
                        type: 'Entry',
                        createdAt: '2024-03-08T15:25:42.609Z',
                        updatedAt: '2024-03-08T16:14:48.809Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 8,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'page'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        name: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)',
                        title: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)',
                        slug: 'notice-of-seasonal-return-window',
                        seo: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '6SzHWgqbri7KmD1Kqg9tee',
                                type: 'Entry',
                                createdAt: '2024-03-08T16:14:42.474Z',
                                updatedAt: '2024-03-08T16:14:42.474Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 2,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'seo'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)'
                            }
                        },
                        content: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '5kvUx9OuWGlyAfzkeuWYmf',
                                type: 'Entry',
                                createdAt: '2024-03-08T15:25:40.478Z',
                                updatedAt: '2024-03-08T15:25:40.478Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'richTextContentPageTemplate'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Notice of Seasonal Return Window > Rich Text',
                                modules: [
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '4wIx2naddOy0wWDJuYy5aw',
                                            type: 'Entry',
                                            createdAt: '2024-03-08T15:25:01.040Z',
                                            updatedAt: '2024-03-08T15:25:01.040Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 6,
                                            revision: 1,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'bannerComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Notice of Seasonal Return Window > Rich Text > Banner',
                                            headline: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)',
                                            backgroundImage: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '1Px4l8fvDKjBGrRTCqfWrE',
                                                    type: 'Asset',
                                                    createdAt: '2022-12-29T16:44:45.722Z',
                                                    updatedAt: '2022-12-29T16:44:45.722Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 5,
                                                    revision: 1,
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Banner BG strand top right',
                                                    description: 'Banner BG strand top right',
                                                    file: {
                                                        url: '//images.ctfassets.net/n9bebhw263o0/1Px4l8fvDKjBGrRTCqfWrE/753e8312177899a7503bd1e5e8a8a3eb/Banner_BG_strand_right.png',
                                                        details: {
                                                            size: 47693,
                                                            image: {
                                                                width: 1920,
                                                                height: 511
                                                            }
                                                        },
                                                        fileName: 'Banner_BG_strand_right.png',
                                                        contentType: 'image/png'
                                                    }
                                                }
                                            },
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7iOWBmppZrkK5s40UUIzOV',
                                                    type: 'Entry',
                                                    createdAt: '2023-09-28T22:24:03.948Z',
                                                    updatedAt: '2023-09-28T22:24:03.948Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 3,
                                                    revision: 1,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        metadata: {
                                            tags: [],
                                            concepts: []
                                        },
                                        sys: {
                                            space: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'Space',
                                                    id: 'n9bebhw263o0'
                                                }
                                            },
                                            id: '3buMSfbhnLWdN0JQh411du',
                                            type: 'Entry',
                                            createdAt: '2024-03-08T15:25:24.958Z',
                                            updatedAt: '2024-03-08T15:31:05.586Z',
                                            environment: {
                                                sys: {
                                                    id: 'sandbox',
                                                    type: 'Link',
                                                    linkType: 'Environment'
                                                }
                                            },
                                            publishedVersion: 26,
                                            revision: 2,
                                            contentType: {
                                                sys: {
                                                    type: 'Link',
                                                    linkType: 'ContentType',
                                                    id: 'richTextContentComponent'
                                                }
                                            },
                                            locale: 'en-US'
                                        },
                                        fields: {
                                            title: 'Notice of Seasonal Return Window > Rich Text > Content',
                                            content: {
                                                data: {},
                                                content: [
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Dear Valued Partner,',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'On behalf of Moderna US, Inc. we are providing an important update regarding returnability of seasonal COVID-19 Vaccine Product (2023-2024 formulation). Pursuant to the Returned Goods Policy and Procedures in your purchase Agreement, at the end of each season a seasonal returns window will open and a percentage of the total volume of the Moderna COVID-19 Vaccine Product purchased directly from Moderna that is within your contracted returns allowance may be returned for credit. Any returns received in excess of your contracted return allowance will be destroyed without credit. ',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                value: "On April 1, 2024, Moderna will open the seasonal returns window for Moderna\u2019s COVID-19 Vaccine Product with two credit windows, as follows:",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: "Expiring Product returned with an approved Return Authorization (RA) received by Inmar Pharmaceutical Services (\u201CInmar\u201D) between April 1, 2024 and May 31, 2024 will be calculated for credit to be applied to your account upon processing of the returns information at the close of the return window.",
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Product received with an approved RA received by Inmar between June 1, 2024 through August 31, 2024 will be credited to your account upon processing of the returns information at the close of the return window. Product received after August 31, 2024 will be destroyed and no credit will be issued.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            }
                                                        ],
                                                        nodeType: 'unordered-list'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                value: 'Additional Considerations',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'We encourage you to maintain sufficient inventory to immunize through Spring and early Summer preceding the new COVID-19 presentations for 2024-25 becoming available.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Please refer to your Moderna purchase Agreement for your defined return allowance percentage.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'IDNs should send returns in aggregate and provide a central payer (if applicable) so the contract return allowance % can be calculated at the IDN or Group Level. If returns are not provided in aggregate, each location will be calculated individually to assess their allowance for returns.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'If you have purchased through an Authorized Distributor of Record (ADR), please refer to their policies for seasonal returns and allow additional time for credits to be applied to your ADR account.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            }
                                                        ],
                                                        nodeType: 'unordered-list'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    },
                                                                    {
                                                                        type: 'underline'
                                                                    }
                                                                ],
                                                                value: 'Procedure for Seasonal / Expired Product Returns ',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Seasonal / expired product returns require a Return Authorization (RA) issued through Inmar . To request a RA from Inmar, please use one of the three options below. ',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    },
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Access the Inmar website at https://returns.healthcare.inmar.com, and upload a PDF copy of your debit memo.',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'E-mail your debit memo to ',
                                                                                                nodeType: 'text'
                                                                                            },
                                                                                            {
                                                                                                data: {
                                                                                                    uri: 'mailto:rarequest@inmar.com'
                                                                                                },
                                                                                                content: [
                                                                                                    {
                                                                                                        data: {},
                                                                                                        marks: [],
                                                                                                        value: 'rarequest@inmar.com',
                                                                                                        nodeType: 'text'
                                                                                                    }
                                                                                                ],
                                                                                                nodeType: 'hyperlink'
                                                                                            },
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: '.',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Fax your debit memo to Inmar at 817-868-5343.',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            }
                                                                        ],
                                                                        nodeType: 'unordered-list'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'All requests for returns must include the following information or be subject to denial of Return Authorization.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    },
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'A copy of your invoice(s)',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'IDs used to purchase as shown on invoice (including Customer Number, DEA and/or HIN#)',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Customer name as shown on invoice',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Customer billing address',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Customer shipping address as shown on invoice',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Contact name and phone and/or email',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Source of Purchase (ADR name or Moderna Direct)',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Wholesaler Debit memo number and Date (if applicable)',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Invoice Number and Invoice Date',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Product name and NDC number',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Product quantity to return',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Sale Unit price (Invoiced price)',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: 'Serial number, GTIN, lot number, expiration date',
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            },
                                                                            {
                                                                                data: {},
                                                                                content: [
                                                                                    {
                                                                                        data: {},
                                                                                        content: [
                                                                                            {
                                                                                                data: {},
                                                                                                marks: [],
                                                                                                value: "Reason for the return (i.e., return of seasonal product per contract T&C\u2019s_",
                                                                                                nodeType: 'text'
                                                                                            }
                                                                                        ],
                                                                                        nodeType: 'paragraph'
                                                                                    }
                                                                                ],
                                                                                nodeType: 'list-item'
                                                                            }
                                                                        ],
                                                                        nodeType: 'unordered-list'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'For seasonal returns you may submit one request for the entire quantity that has multiple invoices but must include the information above in a formatted spreadsheet applicable for all returned Product.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Inmar will send a box label to use when submitting returned Product.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Once an RA is issued, the products must be shipped to Inmar within 30 days.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: "If you have any questions, please contact Inmar at 1-800-967-5952 option 3. Mon. \u2013 Fri. 7am \u2013 5pm CT",
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Include the completed RA box label with your return. ',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Send returns to: ',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            }
                                                        ],
                                                        nodeType: 'unordered-list'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: "It is shipper\u2019s responsibility to securely package all returned Products to prevent breakage during transit.",
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'If multiple RAs are being returned within a single delivery to Inmar , ensure returned Product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay to the crediting process. ',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Returned Products do not require refrigerated packaging. ',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: 'Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.',
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            },
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        content: [
                                                                            {
                                                                                data: {},
                                                                                marks: [],
                                                                                value: "Credit for accepted returned Product will be issued subject to the policies of original purchase. Refund for purchases made through an ADR will be credited through the customer account with their ADR, where applicable according to the ADR\u2019s policies.",
                                                                                nodeType: 'text'
                                                                            }
                                                                        ],
                                                                        nodeType: 'paragraph'
                                                                    }
                                                                ],
                                                                nodeType: 'list-item'
                                                            }
                                                        ],
                                                        nodeType: 'unordered-list'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                value: 'Reservation of Rights',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Moderna reserves the right to modify and make exceptions to this Policy and to its implementation at any time, without advanced notice, for any reason, including due to business necessity or changes in applicable laws and regulations.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [
                                                                    {
                                                                        type: 'bold'
                                                                    }
                                                                ],
                                                                value: "Any questions regarding Moderna\u2019s Returned Goods Policy can be addressed by Moderna\u2019s Customer Care Team at 1-866-MODERNA (663-3762).",
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Best Regards,',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    },
                                                    {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                marks: [],
                                                                value: 'Moderna Contracts Team\nModerna US, Inc.',
                                                                nodeType: 'text'
                                                            }
                                                        ],
                                                        nodeType: 'paragraph'
                                                    }
                                                ],
                                                nodeType: 'document'
                                            },
                                            printButtonLabel: 'Print',
                                            country: {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '7iOWBmppZrkK5s40UUIzOV',
                                                    type: 'Entry',
                                                    createdAt: '2023-09-28T22:24:03.948Z',
                                                    updatedAt: '2023-09-28T22:24:03.948Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'sandbox',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 3,
                                                    revision: 1,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'country'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    name: 'United States',
                                                    isocode: 'US',
                                                    flag: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                            type: 'Asset',
                                                            createdAt: '2023-05-24T22:54:50.939Z',
                                                            updatedAt: '2023-05-24T22:54:50.939Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'sandbox',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 5,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'usa flag',
                                                            description: 'USA Flag',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                details: {
                                                                    size: 2487,
                                                                    image: {
                                                                        width: 36,
                                                                        height: 26
                                                                    }
                                                                },
                                                                fileName: 'usa_flag.svg',
                                                                contentType: 'image/svg+xml'
                                                            }
                                                        }
                                                    },
                                                    locales: [
                                                        'en-US'
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        }
    ],
    accreditationsLabel: 'Accreditations',
    accreditationsLogo: (0, (/*@__PURE__*/$parcel$interopDefault($724a4ace35544578$exports))),
    nabpAccreditedUrl: 'https://app.us.openbadges.me/view/#!/badge?badgeid=0d1ec98f-a86a-4a75-8b8e-48cb523f210b'
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $4629bfc79cc33037$export$d2b4f10d807361 = /*#__PURE__*/ (0, $acw62.createContext)({});
const $4629bfc79cc33037$export$dda119e8a3a60a4b = ()=>(0, $acw62.useContext)($4629bfc79cc33037$export$d2b4f10d807361);
const $4629bfc79cc33037$export$2e22957dea3ead50 = /*#__PURE__*/ (0, $acw62.createContext)({});
const $4629bfc79cc33037$export$6b386f200a0f7fe9 = ()=>(0, $acw62.useContext)($4629bfc79cc33037$export$2e22957dea3ead50);
const $4629bfc79cc33037$export$d6ad1bb7fa702b99 = /*#__PURE__*/ (0, $acw62.createContext)({});
const $4629bfc79cc33037$export$76363baed30666db = ()=>(0, $acw62.useContext)($4629bfc79cc33037$export$d6ad1bb7fa702b99);
const $4629bfc79cc33037$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)();
var $4629bfc79cc33037$export$2e2bcd8739ae039 = $4629bfc79cc33037$export$ab57792b9b6974a6;


const $913008223d2f1a93$export$33ffd74ebf07f060 = ()=>{
    const context = (0, $acw62.useContext)((0, $4629bfc79cc33037$export$2e2bcd8739ae039));
    if (context === undefined) throw new Error('useModal must be used within a ModalProvider');
    return context;
};


const $e5ae874b00b4fb0f$var$SocialIconButtonBase = ({ ...props })=>{
    const handleMouseEnter = (0, $acw62.useCallback)((event)=>{
        event.target.classList.add('in');
        event.target.classList.remove('out');
    }, []);
    const handleMouseLeave = (0, $acw62.useCallback)((event)=>{
        event.target.classList.remove('in');
        event.target.classList.add('out');
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        ...props,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    });
};
const $e5ae874b00b4fb0f$var$StyledIconButton = (0, $d8seH.default)($e5ae874b00b4fb0f$var$SocialIconButtonBase, {
    shouldForwardProp: (propName)=>![
            'color',
            'hoverColor'
        ].includes(propName)
})(({ theme: theme })=>({
        color: theme.palette.neutral.white,
        "&:hover": {
            backgroundColor: theme.palette.primary.blueFaded
        },
        "&.Mui-focusVisible": {
            border: `1px solid ${theme.palette.neutral.main}`
        }
    }));
const $e5ae874b00b4fb0f$var$FooterTitleStyled = (0, $d8seH.default)('div')(({ theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>`
  width: 100%;
  display: flex;
  flex-direction :row;
  align-items: flex-start;
  padding-bottom: 40px;
  border-bottom: 1px solid ${neutral.gray6};
  flex-wrap: wrap;
  ${[
        breakpoints.down('sm')
    ]} {
    display:grid;
    padding-bottom:0px;
    border-bottom:0px;
    grid-template-rows: auto auto auto;
  }
`);
const $e5ae874b00b4fb0f$var$FooterStyled = (0, $d8seH.default)('footer')(({ theme: { palette: { primary: primary, secondary: secondary }, breakpoints: breakpoints } })=>`
  background: ${secondary.main};
  padding: 60px 72px;
  color: ${primary.main};
  position: relative;
  font-family: "Aeonik Regular", "Arial";
  @media(max-width:620px){
    padding: 60px 20px;
  }
  ${[
        breakpoints.down('sm')
    ]} {
    padding:20px;
  }
  @media print {
    display: none;
  }
`);
const $e5ae874b00b4fb0f$var$FooterPolicyAndSocial = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  ${[
        breakpoints.down('sm')
    ]} {
    flex-direction: column-reverse;
    paddin-top:30px;
  }
`);
const $e5ae874b00b4fb0f$var$LogoImage = (0, $d8seH.default)('img')(({ theme: { breakpoints: breakpoints } })=>`
  margin-right: 62px;
  width: 164px;
  cursor: pointer;
  ${[
        breakpoints.up('md')
    ]} {
    margin-right: 20px;
  }
  ${[
        breakpoints.down('sm')
    ]} {
    margin-right: 62px;
    margin-top:40px;
    margin-bottom:20px;
  }
`);
const $e5ae874b00b4fb0f$var$Boxing = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  flex-direction: column;
  margin:0 80px;
  ${[
        breakpoints.down('lg')
    ]} {
    margin: 0 45px;
  }
  ${[
        breakpoints.down('md')
    ]} {
    margin: 0 20px;
  }
  @media(max-width: 620px){
    margin: 0 15px;
  }
  ${[
        breakpoints.down('sm')
    ]} {
    margin:30px 0px;
  } 
`);
const $e5ae874b00b4fb0f$var$ListItem = (0, $d8seH.default)('li')`
  list-style-type: none;
  margin-bottom: 10px;
`;
const $e5ae874b00b4fb0f$var$PrivacySpan = (0, $d8seH.default)('span')`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: "Aeonik Medium", "Nunito", "Arial";
  letter-spacing: 0px;
`;
const $e5ae874b00b4fb0f$var$SocialIcon = (0, $d8seH.default)('img')(({ theme: { breakpoints: breakpoints } })=>`
  ${[
        breakpoints.down('sm')
    ]} {
    margin-left: 0px;
    margin-right: 16px;
    margin-bottom:56px;
    border-bottom:1px
  }
`);
const $e5ae874b00b4fb0f$var$styledLinkStyle = {
    color: 'primary.main',
    textDecoration: 'none'
};
const $e5ae874b00b4fb0f$var$FooterLinkStyle = {
    color: 'primary.main',
    textDeecoration: 'none',
    paddingBottom: '12px'
};
const $e5ae874b00b4fb0f$var$FooterCopyright = (0, $d8seH.default)('p')(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  display: flex;
  color: ${primary.main};
  text-decoration: none;
  font-size: 14px;
  ${[
        breakpoints.down('sm')
    ]} {
    flex-direction: column;
  }
`);
const $e5ae874b00b4fb0f$var$Footer = (props)=>{
    const [footerImageData, setFooterImageData] = (0, $acw62.useState)([]);
    const [footerGroups, setFooterGroups] = (0, $acw62.useState)([]);
    const [socialLinks, setSocialLinks] = (0, $acw62.useState)([]);
    const [footerLinks, setFooterLinks] = (0, $acw62.useState)([]);
    const [copyrightMessage, setCopyrightMessage] = (0, $acw62.useState)([]);
    const [personalInfoLink, setPersonalInfoLink] = (0, $acw62.useState)({});
    const [dataExternalModal, setDataExternalModal] = (0, $acw62.useState)(true);
    const [dataExternalSocialModal, setDataExternalSocialModal] = (0, $acw62.useState)(true);
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const theme = (0, $14H9o.default)();
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const remindMeExternal = localStorage.getItem("dontRemindMeExternal");
    const remindMeSocial = localStorage.getItem("dontRemindMe");
    const isAuthenticated = authState?.isAuthenticated;
    const { handleOpenModal: handleOpenModal } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    (0, $acw62.useEffect)(()=>{
        setCopyrightMessage((0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.copyrightMessage);
        setFooterImageData((0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.imageData);
        setSocialLinks((0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.socialLinks);
        setFooterGroups((0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.footerGroups);
        const footerLinks = (0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.footerLinks || [];
        const itemsWithoutPersonalInfoLink = footerLinks.filter((item)=>{
            if (item?.fields?.title === "Personal Information FooterLink") {
                setPersonalInfoLink(item?.fields);
                return false;
            }
            return true;
        });
        setFooterLinks(itemsWithoutPersonalInfoLink);
    }, [
        (0, $570b2653a8a10984$export$4c2bf9c4cb98e454),
        authState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (remindMeExternal === "true") setDataExternalModal(false);
    }, [
        remindMeExternal
    ]);
    (0, $acw62.useEffect)(()=>{
        if (remindMeSocial === "true") setDataExternalSocialModal(false);
    }, [
        remindMeSocial
    ]);
    const handleLink = (url)=>{
        if (locale !== 'en-US' && window.location.href.includes(locale)) return window.location.origin + "/" + locale + "/" + url;
        else return "/" + locale + "/" + url;
    };
    const openExternalLinkHandler = (e, url, type)=>{
        props?.setExternalLinkModalType(type);
        if (type === "extrenalLink") {
            if ((0, $382eb84981692d3a$export$bdc112e4021a968d)(url) && !localStorage.getItem("dontRemindMeExternal")) {
                props?.setShowNavigationAlert(true);
                props?.setExternalLink(url);
                e.preventDefault();
            } else {
                props?.setShowNavigationAlert(false);
                props?.setExternalLink("");
            }
        } else if ((0, $382eb84981692d3a$export$bdc112e4021a968d)(url) && !localStorage.getItem("dontRemindMe")) {
            props?.setShowNavigationAlert(true);
            props?.setExternalLink(url);
            e.preventDefault();
        } else {
            props?.setShowNavigationAlert(false);
            props?.setExternalLink("");
        }
    };
    const navigateOrLogin = (path)=>{
        if (isAuthenticated) history.push(`/${path}`);
        else handleOpenModal(`/${path}`);
    };
    const handleFaq = (e, path)=>{
        e.preventDefault();
        navigateOrLogin(path);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$FooterStyled, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$FooterTitleStyled, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        to: authState?.isAuthenticated ? `/${locale}/home` : `/${locale}`,
                        "data-testid": "footerLogoLink",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$LogoImage, {
                            id: "footerLogo",
                            src: footerImageData,
                            alt: "Moderna Logo",
                            width: "158px"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "grid",
                        gridTemplateColumns: {
                            xs: 'unset',
                            sm: 'auto auto auto'
                        },
                        gridTemplateRows: {
                            xs: 'auto auto auto',
                            sm: 'unset'
                        },
                        children: [
                            footerGroups ? footerGroups.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$Boxing, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "h6",
                                            mb: "24px",
                                            letterSpacing: "0px",
                                            textTransform: "uppercase",
                                            id: "footerTitle" + index,
                                            children: item?.subHeading
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            children: item?.footerGroupLinks.map((link, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$ListItem, {
                                                    children: link?.fields?.url ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                        id: item?.subHeading.replace(/\s+/g, '') + index,
                                                        to: {
                                                            pathname: link?.fields?.url
                                                        },
                                                        target: "_blank",
                                                        "data-external-modal": dataExternalModal,
                                                        onClick: (e)=>openExternalLinkHandler(e, link?.fields?.url, "extrenalLink"),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: 'p1',
                                                            sx: $e5ae874b00b4fb0f$var$styledLinkStyle,
                                                            children: link?.fields?.label
                                                        })
                                                    }) : link === "faqs" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                        style: $e5ae874b00b4fb0f$var$styledLinkStyle,
                                                        to: `/${locale}/` + link,
                                                        onClick: (e)=>handleFaq(e, link),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: 'p1',
                                                            sx: $e5ae874b00b4fb0f$var$styledLinkStyle,
                                                            children: item?.label[index]
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                        to: `/${locale}/` + link,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                            variant: 'p1',
                                                            sx: $e5ae874b00b4fb0f$var$styledLinkStyle,
                                                            children: item?.label[index]
                                                        })
                                                    })
                                                }, index))
                                        })
                                    ]
                                }, index)) : "No Footer Group",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$Boxing, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h6",
                                        mb: "24px",
                                        letterSpacing: "0px",
                                        textTransform: "uppercase",
                                        "data-testid": "accreditationsLabel",
                                        children: (0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.accreditationsLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                        to: {
                                            pathname: handleLink((0, $570b2653a8a10984$export$4c2bf9c4cb98e454).nabpAccreditedUrl)
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "data-external-modal": dataExternalModal,
                                        onClick: (e)=>openExternalLinkHandler(e, (0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.nabpAccreditedUrl, "extrenalLink"),
                                        "aria-label": "View NABP Drug Distributor Accreditation",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            alt: "NABP Accredited Drug Distributor seal",
                                            src: (0, $570b2653a8a10984$export$4c2bf9c4cb98e454)?.accreditationsLogo,
                                            height: 150,
                                            width: 150,
                                            "data-testid": "accreditationsLogo"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$FooterPolicyAndSocial, {
                children: [
                    mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$PrivacySpan, {
                        style: {
                            flexDirection: 'column',
                            alignItems: 'start'
                        },
                        children: footerLinks?.map((item, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                id: "footerLink" + index,
                                to: item?.fields?.url ? {
                                    pathname: handleLink(item?.fields?.url)
                                } : {
                                    pathname: handleLink(item.fields?.pageReference?.fields?.slug)
                                },
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: 'p2',
                                    sx: $e5ae874b00b4fb0f$var$FooterLinkStyle,
                                    children: item.fields.label
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$PrivacySpan, {
                        children: footerLinks?.map((item, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                id: "footerLink" + index,
                                to: item?.fields?.url ? {
                                    pathname: handleLink(item?.fields?.url)
                                } : {
                                    pathname: handleLink(item.fields?.pageReference?.fields?.slug)
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    variant: 'p2',
                                    sx: $e5ae874b00b4fb0f$var$FooterLinkStyle,
                                    children: [
                                        (index === 0 ? '' : '| ') + item.fields.label,
                                        "\xa0"
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$PrivacySpan, {
                        id: "socials",
                        children: socialLinks?.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: {
                                    pathname: `${item.fields.link.fields.url}`
                                },
                                target: "_blank",
                                rel: "noreferrer",
                                "data-external-modal": dataExternalSocialModal,
                                onClick: (e)=>openExternalLinkHandler(e, item.fields.link.fields.url, "socialLink"),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$StyledIconButton, {
                                    disableTouchRipple: true,
                                    size: "small",
                                    "data-link-href": item.fields.link.fields.url,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($e5ae874b00b4fb0f$var$SocialIcon, {
                                        src: item.fields.icon?.fields?.file?.url,
                                        alt: item.fields.link?.fields?.title,
                                        height: "20px",
                                        width: "20px",
                                        viewBox: '0 0 20 20'
                                    })
                                })
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e5ae874b00b4fb0f$var$FooterCopyright, {
                id: "personalInfoLink",
                "data-testid": "copyrightMesssage",
                children: [
                    personalInfoLink?.label,
                    personalInfoLink?.label && copyrightMessage && (mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "\xa0|\xa0"
                    })),
                    copyrightMessage
                ]
            }, personalInfoLink?.label)
        ]
    });
};
var $e5ae874b00b4fb0f$export$2e2bcd8739ae039 = $e5ae874b00b4fb0f$var$Footer;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $jTnBY = parcelRequire("jTnBY");
var $5A6d3 = parcelRequire("5A6d3");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6lXkL = parcelRequire("6lXkL");

var $bwtSM = parcelRequire("bwtSM");

var $2cPwN = parcelRequire("2cPwN");

var $4FZD0 = parcelRequire("4FZD0");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $3d9daf67b816649a$export$24fdd7c0683a4fed(slot) {
    return (0, $4Cod0.default)('MuiLoadingButton', slot);
}
const $3d9daf67b816649a$var$loadingButtonClasses = (0, $beCSm.default)('MuiLoadingButton', [
    'root',
    'loading',
    'loadingIndicator',
    'loadingIndicatorCenter',
    'loadingIndicatorStart',
    'loadingIndicatorEnd',
    'endIconLoadingEnd',
    'startIconLoadingStart'
]);
var $3d9daf67b816649a$export$2e2bcd8739ae039 = $3d9daf67b816649a$var$loadingButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6139cb5be32bc930$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $6139cb5be32bc930$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading'
        ],
        startIcon: [
            loading && `startIconLoading${(0, $jTnBY.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $jTnBY.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            'loadingIndicator',
            loading && `loadingIndicator${(0, $jTnBY.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $3d9daf67b816649a$export$24fdd7c0683a4fed), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $6139cb5be32bc930$var$rootShouldForwardProp = (prop)=>prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as' && prop !== 'classes';
const $6139cb5be32bc930$var$LoadingButtonRoot = (0, $d8seH.default)((0, $6lXkL.default), {
    shouldForwardProp: (prop)=>$6139cb5be32bc930$var$rootShouldForwardProp(prop) || prop === 'classes',
    name: 'MuiLoadingButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === 'center' && {
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    }, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $6139cb5be32bc930$var$LoadingButtonLoadingIndicator = (0, $d8seH.default)('span', {
    name: 'MuiLoadingButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $jTnBY.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        visibility: 'visible',
        display: 'flex'
    }, ownerState.loadingPosition === 'start' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
        left: ownerState.size === 'small' ? 10 : 14
    }, ownerState.loadingPosition === 'start' && ownerState.variant === 'text' && {
        left: 6
    }, ownerState.loadingPosition === 'center' && {
        left: '50%',
        transform: 'translate(-50%)',
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === 'end' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
        right: ownerState.size === 'small' ? 10 : 14
    }, ownerState.loadingPosition === 'end' && ownerState.variant === 'text' && {
        right: 6
    }, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
        position: 'relative',
        left: -10
    }, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
        position: 'relative',
        right: -10
    }));
const $6139cb5be32bc930$var$LoadingButton = /*#__PURE__*/ $acw62.forwardRef(function LoadingButton(inProps, ref) {
    const contextProps = $acw62.useContext((0, $bwtSM.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiLoadingButton'
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $6139cb5be32bc930$var$_excluded);
    const id = (0, $5A6d3.default)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $6139cb5be32bc930$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($6139cb5be32bc930$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6139cb5be32bc930$var$LoadingButtonRoot, (0, $8nd05.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === 'end' ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === 'end' ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $6139cb5be32bc930$export$2e2bcd8739ae039 = $6139cb5be32bc930$var$LoadingButton;



var $d8seH = parcelRequire("d8seH");

var $c9Z8w = parcelRequire("c9Z8w");
var $da57c823f260de6f$exports = {};
$da57c823f260de6f$exports = new URL("heart.3b5c2383.svg", import.meta.url).toString();


const $2d5ba5e5d9aef962$var$StyledButtonBase = (0, $d8seH.default)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'buttonType' && prop !== 'icon' && prop !== 'leftIcon' && prop !== 'rightIcon' && prop !== 'muiIconLeft' && prop !== 'muiIconRight'
})(({ buttonType: buttonType, icon: icon, leftIcon: leftIcon, rightIcon: rightIcon, theme: theme, loading: loading })=>({
        ...buttonType === 'primary' && {
            border: `1px solid ${theme.palette.primary.button}`,
            color: theme.palette.neutral?.white,
            background: theme.palette.primary.button,
            "&:hover": {
                border: `1px solid ${theme.palette.secondary.button}`,
                backgroundColor: theme.palette.secondary.button,
                color: theme.palette.neutral?.white
            },
            "&:disabled": {
                pointerEvents: "none",
                color: theme.palette.neutral?.white,
                backgroundColor: theme.palette.neutral?.gray2,
                border: `1px solid ${theme.palette.neutral?.gray2}`
            },
            "&.indicator:disabled": {
                pointerEvents: "none",
                color: theme.palette.neutral?.white,
                backgroundColor: theme.palette.secondary?.graphical,
                border: `1px solid ${theme.palette.secondary?.graphical}`
            },
            "&.Mui-focusVisible": {
                border: `2px solid ${theme.palette.secondary.yellowLight}`,
                backgroundColor: theme.palette.secondary.button,
                color: theme.palette.neutral?.white
            }
        },
        ...buttonType === 'secondary' && {
            border: `1px solid ${theme.palette.primary.button} `,
            color: theme.palette.primary.button,
            "&:hover": {
                backgroundColor: theme.palette.primary.button,
                color: theme.palette.neutral?.white
            },
            "&:disabled": {
                pointerEvents: "none",
                border: `1px solid ${theme.palette.neutral.gray2}`,
                color: theme.palette.neutral.gray2
            },
            "&.Mui-focusVisible": {
                border: `2px solid ${theme.palette.secondary.yellowLight}`,
                backgroundColor: theme.palette.primary.button,
                color: theme.palette.neutral?.white
            }
        },
        ...buttonType === 'tertiary' && {
            color: theme.palette.primary.button,
            "&:hover": {
                backgroundColor: 'transparent',
                color: theme.palette.secondary.button
            },
            "&:disabled": {
                pointerEvents: "none",
                color: theme.palette.neutral.gray2
            },
            "&.Mui-focusVisible": {
                border: `2px solid ${theme.palette.secondary.yellowLight}`,
                backgroundColor: theme.palette.neutral?.white,
                color: theme.palette.secondary.button
            }
        },
        ...buttonType === 'primaryInverted' && {
            border: `1px solid ${theme.palette.neutral?.white}`,
            color: theme.palette.neutral?.white,
            background: theme.palette.secondary.button,
            "&:hover": {
                border: `1px solid ${theme.palette.primary.button}`,
                backgroundColor: theme.palette.primary.button,
                color: theme.palette.neutral?.white
            },
            "&:disabled": {
                pointerEvents: "none",
                border: `1px solid ${theme.palette.neutral.gray2}`,
                color: theme.palette.neutral.gray2
            },
            "&.Mui-focusVisible": {
                border: `2px solid ${theme.palette.secondary.yellowLight}`,
                backgroundColor: theme.palette.primary.button,
                color: theme.palette.neutral?.white
            }
        },
        ...buttonType === 'mds-primary' && {
            color: "#FFFFFF",
            textTransform: "none",
            display: 'flex',
            height: "48px",
            padding: "16px 24px",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            borderRadius: "8px",
            border: "1px solid #E31837",
            background: "#E31837",
            "&:hover": {
                backgroundColor: '#92242B',
                color: "#FFFFFF",
                border: "1px solid #92242B"
            },
            "&:disabled": {
                pointerEvents: "none",
                color: theme.palette.neutral?.white,
                backgroundColor: theme.palette.neutral?.gray2,
                border: `1px solid ${theme.palette.neutral?.gray2}`
            }
        },
        ...buttonType === 'mds-secondary' && {
            color: "#01283C",
            textTransform: "none",
            display: 'flex',
            height: "48px",
            padding: "16px 24px",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            borderRadius: "8px",
            border: "1px solid #01283C"
        },
        ...buttonType === 'mds-tertiary' && {
            color: "#FFFFFF",
            textTransform: "none",
            display: 'flex',
            height: "48px",
            padding: "16px 24px",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            borderRadius: "8px",
            border: "1px solid #079AE0",
            background: "#079AE0",
            "&:hover": {
                backgroundColor: '#0379B2',
                color: "#FFFFFF",
                border: "1px solid #0379B2"
            }
        },
        ...buttonType === 'mds-outline' && {
            color: "#545F71",
            textTransform: "none",
            display: 'inline-flex',
            height: "48px",
            padding: "12px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "6px",
            border: "1px solid #545F71"
        },
        ...buttonType === 'link' && {
            color: "#079AE0",
            textTransform: "none",
            border: "none",
            "&:hover": {
                backgroundColor: '#FFFFFF'
            }
        },
        ...icon && {
            padding: "7px 32px 8px",
            "& .ButtonText": {
                paddingRight: "8px"
            }
        },
        ...leftIcon && {
            padding: "7px 32px 8px",
            "& .ButtonText": {
                paddingRight: "8px"
            }
        },
        textTransform: "uppercase",
        fontFamily: "Aeonik Medium",
        fontSize: "14px",
        borderRadius: "5px",
        padding: buttonType === "link" ? "0px" : "10px 30px",
        cursor: "pointer",
        [theme.breakpoints.down('lg')]: {
            fontSize: "12px"
        },
        "& .ButtonInnerContainer": {
            display: "flex",
            alignItems: "center",
            lineHeight: "normal",
            gap: "8px"
        },
        "& .ButtonText": {
            fontFamily: "Aeonik Medium",
            lineHeight: "normal",
            fontSize: "16px",
            [theme.breakpoints.down('lg')]: {
                fontSize: "12px"
            },
            visibility: loading ? 'hidden' : 'visible'
        }
    }));
const $2d5ba5e5d9aef962$export$353f5b6fc5456de1 = ({ buttonType: buttonType = "primary", disabled: disabled = false, icon: icon = false, leftIcon: leftIcon = null, rightIcon: rightIcon = null, iconSize: iconSize = "24px", onClick: onClick, children: children, sx: sx, loading: loading, muiIconLeft: MuiIconLeft, muiIconRight: MuiIconRight, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2d5ba5e5d9aef962$var$StyledButtonBase, {
        ...props,
        onClick: onClick,
        disabled: disabled,
        loading: loading,
        buttonType: buttonType,
        icon: icon,
        leftIcon: leftIcon,
        rightIcon: leftIcon,
        disableTouchRipple: true,
        sx: sx,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "ButtonInnerContainer",
            children: [
                icon && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($da57c823f260de6f$exports))),
                    alt: "Heart",
                    height: iconSize,
                    width: iconSize,
                    className: "IconBase"
                }),
                MuiIconLeft && /*#__PURE__*/ (0, $ayMG0.jsx)(MuiIconLeft, {
                    className: "MUIIconBase",
                    height: iconSize,
                    width: iconSize
                }),
                leftIcon && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: leftIcon,
                    alt: "leftIcon",
                    height: iconSize,
                    width: iconSize,
                    className: "IconBase"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "ButtonText",
                    children: children
                }),
                MuiIconRight && /*#__PURE__*/ (0, $ayMG0.jsx)(MuiIconRight, {
                    className: "MUIIconBase",
                    height: iconSize,
                    width: iconSize
                })
            ]
        })
    });
};
$2d5ba5e5d9aef962$export$353f5b6fc5456de1.propTypes = {
    buttonType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "primary",
        "secondary",
        "tertiary",
        "request",
        "primaryInverted",
        "mds-primary",
        "mds-secondary",
        "mds-tertiary",
        "link",
        "mds-outline"
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    leftIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    muiIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    muiIconRight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1Aijw = parcelRequire("1Aijw");

var $d8seH = parcelRequire("d8seH");

var $2esSG = parcelRequire("2esSG");

var $3bYfT = parcelRequire("3bYfT");
const $c576d11d36ade61d$var$CustomCheckbox = (0, $d8seH.default)((0, $1Aijw.default))(({ theme: { palette: { primary: primary, status: status, neutral: neutral } } })=>({
        "&": {
            color: primary?.blue
        },
        "&.checkbox-error": {
            color: status?.error
        },
        "&.Mui-checked": {
            color: primary?.blue
        },
        "&.Mui-disabled": {
            color: neutral?.gray2
        }
    }));
const $c576d11d36ade61d$var$CustomFormControlLabel = (0, $d8seH.default)((0, $2esSG.default))(({ theme: { palette: { primary: primary, status: status, neutral: neutral } } })=>({
        ".MuiFormControlLabel-label": {
            fontSize: "14px",
            paddingLeft: "2px",
            color: primary?.main,
            "&.Mui-disabled": {
                color: primary?.main
            },
            '@media screen and (max-width: 500px)': {
                fontSize: "1rem"
            }
        }
    }));
const $c576d11d36ade61d$export$48513f6b9f8ce62d = ({ id: id, name: name, label: label, onChange: onChange, value: value, disabled: disabled, error: error, required: required, ...checkboxProps })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c576d11d36ade61d$var$CustomFormControlLabel, {
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($c576d11d36ade61d$var$CustomCheckbox, {
            className: error ? "checkbox-error" : "",
            checked: value,
            disabled: disabled,
            onChange: onChange,
            inputProps: {
                "aria-label": "controlled"
            },
            name: name,
            ...checkboxProps,
            sx: {
                padding: "8px",
                "& .MuiSvgIcon-root": {
                    fontSize: 20
                }
            }
        }),
        id: id,
        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            variant: "p2",
            sx: {
                ...checkboxProps.labelsx
            },
            children: [
                label,
                required && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "p2",
                    sx: {
                        color: "primary.red"
                    },
                    children: "*"
                })
            ]
        }),
        sx: {
            ...checkboxProps.sx
        }
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $kVqvD = parcelRequire("kVqvD");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)('span', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $03c2199a765ab5af$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $e413843d0810bb75$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;



var $jTnBY = parcelRequire("jTnBY");

var $hPGQj = parcelRequire("hPGQj");
var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $hPGQj.default);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;


'use client';
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cb3af4fea2cad44e$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            size !== 'medium' && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8nd05.default)({}, classes, (0, $8Indx.default)(slots, (0, $d9d692e9561f6352$export$192f7b2363c77155), classes));
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $cb3af4fea2cad44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $e9140607eee18105$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3d47321b9fcbcb38$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$RadioRoot, (0, $8nd05.default)({
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $cb3af4fea2cad44e$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $cb3af4fea2cad44e$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;



var $d8seH = parcelRequire("d8seH");

var $2esSG = parcelRequire("2esSG");
const $cea323b26ef82aa8$var$CustomRadio = (0, $d8seH.default)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039))(({ theme: theme, size: size, customcheckedcolor: customcheckedcolor })=>{
    const sizeToFontSizeMap = {
        small: 17,
        medium: 20,
        large: 25
    };
    return {
        "&:hover": {
            backgroundColor: "transparent",
            opacity: 0.4
        },
        "&.Mui-checked": {
            color: customcheckedcolor || theme.palette.secondary.graphical
        },
        "&.readonly": {
            color: theme.palette.neutral.gray2
        },
        '& .MuiSvgIcon-root': {
            fontSize: sizeToFontSizeMap[size] || sizeToFontSizeMap.small
        }
    };
});
const $cea323b26ef82aa8$var$CustomFormControlLabel = (0, $d8seH.default)((0, $2esSG.default))(({ controlformsx: controlformsx, labelsx: labelsx })=>({
        ".MuiFormControlLabel-label": {
            fontSize: "14px",
            paddingLeft: "4px",
            ...labelsx
        },
        margin: 0,
        ...controlformsx
    }));
const $cea323b26ef82aa8$export$d7b12c4107be0d61 = ({ label: label, value: value, checked: checked, onChange: onChange, name: name, className: className, id: id, radiosx: radiosx, labelsx: labelsx, controlformsx: controlformsx, size: size, disabled: disabled, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cea323b26ef82aa8$var$CustomFormControlLabel, {
        id: `radio_label_${id}`,
        disabled: disabled || className === 'readonly',
        value: value,
        className: className,
        labelsx: labelsx,
        controlformsx: controlformsx,
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($cea323b26ef82aa8$var$CustomRadio, {
            id: `radio_field_${id}`,
            checked: checked,
            onChange: onChange,
            name: name,
            size: size ? size : "small",
            className: className,
            customcheckedcolor: props.customCheckedColor,
            sx: {
                padding: "8px",
                ...radiosx
            }
        }),
        label: label
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45313e7d506ce734$var$_excluded = [
    "className",
    "raised"
];
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $89a1bb9709695920$export$f3b76d2cce458caa), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $1En50.default)(props, $45313e7d506ce734$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        raised: raised
    });
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $273fd99738f3adbe$export$964336739a8c7119(slot) {
    return (0, $4Cod0.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $beCSm.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$export$2e2bcd8739ae039 = $273fd99738f3adbe$var$cardContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28a500ea92f2665f$var$_excluded = [
    "className",
    "component"
];
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $273fd99738f3adbe$export$964336739a8c7119), classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $28a500ea92f2665f$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $28a500ea92f2665f$export$2e2bcd8739ae039 = $28a500ea92f2665f$var$CardContent;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72f090ff2322b6ae$export$5f5333fe417019a7(slot) {
    return (0, $4Cod0.default)('MuiCardMedia', slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $beCSm.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $72f090ff2322b6ae$export$2e2bcd8739ae039 = $72f090ff2322b6ae$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $891b59d4b36435bb$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72f090ff2322b6ae$export$5f5333fe417019a7), classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style } = props, other = (0, $1En50.default)(props, $891b59d4b36435bb$var$_excluded);
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $8nd05.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $891b59d4b36435bb$export$2e2bcd8739ae039 = $891b59d4b36435bb$var$CardMedia;



var $3bYfT = parcelRequire("3bYfT");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4c5dd21dca115198$export$2a5c27c211442e3c(slot) {
    return (0, $4Cod0.default)('MuiCardActions', slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $beCSm.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4c5dd21dca115198$export$2e2bcd8739ae039 = $4c5dd21dca115198$var$cardActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b46a5bcac23a5f99$var$_excluded = [
    "disableSpacing",
    "className"
];
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4c5dd21dca115198$export$2a5c27c211442e3c), classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $acw62.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $1En50.default)(props, $b46a5bcac23a5f99$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b46a5bcac23a5f99$export$2e2bcd8739ae039 = $b46a5bcac23a5f99$var$CardActions;


var $14H9o = parcelRequire("14H9o");

var $c9Z8w = parcelRequire("c9Z8w");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $7aaed6cb4870379f$export$164c3dc7db460fb7 = (variant, buttonLink, buttonLabel, onButtonClick, loading = false)=>{
    let cardStyle, cardContentStyle, cardActionsStyle = {}, cardImageStyle = {}, subTitleStyle, titleStyle, descriptionStyle, subDescStyle = {}, imageDropshadowColor, imageHeight, imageWidth, ButtonComponent;
    switch(variant){
        case "Wide":
            cardStyle = {
                maxWidth: "524px"
            };
            cardContentStyle = {
                padding: "40px",
                ":last-child": {
                    paddingBottom: "40px"
                }
            };
            cardImageStyle = {
                objectFit: "contain",
                filter: "opacity(0.5) drop-shadow(0px 0px 0px #D8362C) drop-shadow(0px 0px 0px #D8362C) drop-shadow(0px 0px 0px #D8362C)"
            };
            subTitleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "11px",
                fontWeight: "900",
                textTransform: "UpperCase",
                letterSpacing: "0px",
                marginBottom: "8px",
                color: "#D8362C"
            };
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "24px",
                marginBottom: "16px",
                color: "neutral.main"
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "16px",
                color: "neutral.main",
                marginBottom: "32px"
            };
            ButtonComponent = null;
            imageWidth = "524px";
            imageHeight = "198px";
            break;
        case "Long":
            cardStyle = {
                width: "416px"
            };
            cardContentStyle = {
                padding: "40px",
                ":last-child": {
                    paddingBottom: "40px"
                }
            };
            cardImageStyle = {
                objectFit: "contain",
                filter: "opacity(0.5) drop-shadow(0px 0px 0px #38BAE8) drop-shadow(0px 0px 0px #38BAE8) drop-shadow(0px 0px 0px #38BAE8)"
            };
            subTitleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "11px",
                fontWeight: "900",
                textTransform: "UpperCase",
                letterSpacing: "0px",
                marginBottom: "8px",
                color: "#38BAE8"
            };
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "24px",
                marginBottom: "16px",
                color: "neutral.main"
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "16px",
                color: "neutral.main",
                marginBottom: "24px"
            };
            subDescStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "14px",
                opacity: "0.38",
                color: "neutral.main"
            };
            ButtonComponent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "primary",
                onClick: onButtonClick,
                icon: false,
                children: "Lorem"
            });
            imageWidth = "416px";
            imageHeight = "160px";
            break;
        case "Secondary":
            cardStyle = {
                width: "526px"
            };
            cardContentStyle = {
                padding: "40px",
                ":last-child": {
                    paddingBottom: "40px"
                }
            };
            cardImageStyle = {};
            subTitleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "11px",
                fontWeight: "900",
                textTransform: "UpperCase",
                letterSpacing: "0px",
                marginBottom: "8px",
                color: "#38Bae8"
            };
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "24px",
                marginBottom: "16px",
                color: "neutral.main"
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "16px",
                color: "neutral.main",
                marginBottom: "32px"
            };
            ButtonComponent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "secondary",
                onClick: onButtonClick,
                icon: false,
                children: "Lorem"
            });
            imageWidth = "";
            imageHeight = "";
            break;
        case "Info":
            cardStyle = {
                width: "416px"
            };
            cardContentStyle = {
                padding: "40px",
                ":last-child": {
                    paddingBottom: "40px"
                }
            };
            cardImageStyle = {};
            subTitleStyle = {};
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "24px",
                marginBottom: "16px",
                color: "neutral.main"
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "16px",
                color: "neutral.main",
                marginBottom: "32px"
            };
            ButtonComponent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "primary",
                onClick: onButtonClick,
                icon: false,
                children: "Lorem"
            });
            imageWidth = "";
            imageHeight = "";
            break;
        case "Request":
            cardStyle = {
                maxWidth: "524px"
            };
            cardContentStyle = {
                height: "467px",
                display: "flex",
                justifyContent: "center",
                flexDirection: "Column",
                alignItems: "center",
                padding: "60px 40px",
                ":last-child": {
                    paddingBottom: "60px"
                }
            };
            cardImageStyle = {};
            subTitleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "11px",
                fontWeight: "900",
                textTransform: "UpperCase",
                letterSpacing: "0px",
                marginBottom: "8px",
                color: "#2F688B",
                textAlign: "center"
            };
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                marginBottom: "24px",
                color: "neutral.main",
                textAlign: "center"
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                fontSize: "16px",
                color: "neutral.main",
                marginBottom: "40px",
                textAlign: "center"
            };
            ButtonComponent = buttonLabel && buttonLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "primary",
                onClick: ()=>window.location.href = buttonLink,
                icon: false,
                children: buttonLabel
            });
            imageWidth = "";
            imageHeight = "";
            break;
        case "Product":
            cardActionsStyle = {
                justifyContent: "space-between",
                height: "38px",
                marginTop: "45px",
                '@media screen and (max-width: 500px)': {
                    justifyContent: "start",
                    alignItems: "end",
                    height: '100px',
                    marginTop: "0px",
                    marginBottom: "26px"
                }
            };
            cardImageStyle = {
                height: 'auto',
                minHeight: "120px",
                '@media screen and (max-width: 500px)': {
                    height: '140px'
                }
            };
            descriptionStyle = {
                fontFamily: "Aeonik Regular",
                color: "primary.main",
                fontSize: "11px",
                '@media screen and (max-width: 500px)': {
                    fontSize: '14px'
                }
            };
            cardContentStyle = {
                display: "flex",
                justifyContent: "center",
                flexDirection: "Column",
                padding: "20px !important"
            };
            titleStyle = {
                fontFamily: "Aeonik Regular, Nunito",
                color: "primary.main",
                textAlign: "left",
                fontSize: "15px",
                fontWeight: "600",
                '@media screen and (max-width: 500px)': {
                    fontSize: '16px'
                }
            };
            ButtonComponent = buttonLabel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                className: "addBtn",
                disabled: loading,
                size: "small",
                buttonType: "secondary",
                onClick: onButtonClick,
                icon: false,
                sx: {
                    right: "0px",
                    height: "37px",
                    '@media screen and (max-width: 500px)': {
                        height: "48px"
                    }
                },
                children: buttonLabel
            });
            break;
        default:
    }
    return {
        cardStyle: cardStyle,
        cardContentStyle: cardContentStyle,
        cardActionsStyle: cardActionsStyle,
        cardImageStyle: cardImageStyle,
        subTitleStyle: subTitleStyle,
        titleStyle: titleStyle,
        descriptionStyle: descriptionStyle,
        subDescStyle: subDescStyle,
        imageDropshadowColor: imageDropshadowColor,
        imageHeight: imageHeight,
        imageWidth: imageWidth,
        ButtonComponent: ButtonComponent
    };
};


var $bbb944c308ea2855$exports = {};
$bbb944c308ea2855$exports = new URL("book.65b78297.svg", import.meta.url).toString();


var $cd3dc9910c50d046$exports = {};
$cd3dc9910c50d046$exports = new URL("multi_arrow.131b3c78.svg", import.meta.url).toString();



var $fa50fbada1bf04d0$exports = {};
$fa50fbada1bf04d0$exports = new URL("red_heart.8ad61bd1.svg", import.meta.url).toString();



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iAtns = parcelRequire("iAtns");

var $cFBau = parcelRequire("cFBau");

var $d8seH = parcelRequire("d8seH");
var $3a68ff4fb6e888aa$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($3a68ff4fb6e888aa$exports, "__esModule", {
    value: true
});
$3a68ff4fb6e888aa$exports.default = void 0;

var $3a68ff4fb6e888aa$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $3a68ff4fb6e888aa$var$_default = $3a68ff4fb6e888aa$exports.default = (0, $3a68ff4fb6e888aa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDownOutlined');



const $a4adb9aa598db580$var$CustomSelect = (0, $d8seH.default)((0, $cFBau.default))(({ error: error = false, variant: variant = "round", paddingbottom: paddingbottom = 10, theme: { palette: { primary: primary, neutral: neutral, secondary: secondary, status: status }, breakpoints: breakpoints } })=>({
        "&": {
            width: 130,
            borderRadius: variant === "round" ? 20 : 5,
            paddingBottom: paddingbottom,
            "&.cart": {
                paddingBottom: 0
            },
            "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
                color: `${error === "true" ? status.error : primary.main}`
            },
            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: `${error === "true" ? status.error : neutral.gray2}`,
                boxShadow: '0px 3px 6px #22222229'
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${neutral.gray2}`,
                    borderColor: `${error === "true" ? status.error : neutral.gray2}`,
                    borderRadius: variant === "round" ? 20 : 5,
                    height: 44
                }
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: `${error === "true" ? status.error : neutral.gray2}`,
                borderRadius: variant === "round" ? 20 : 5,
                height: 44,
                top: 3
            },
            "& .MuiAutocomplete-popupIndicator:hover": {
                backgroundColor: "transparent"
            },
            "& .MuiAutocomplete-popupIndicator": {
                color: `${error === "true" ? status.error : secondary.graphical}`
            }
        }
    }));
const $a4adb9aa598db580$var$CustomLabel = (0, $d8seH.default)('label')(({ error: error, theme: { palette: { primary: primary, status: status } } })=>`
  font-size: 10px;
  font-family: Aeonik Bold;
  color: ${error === "true" ? status.error : primary.main};
  `);
const $a4adb9aa598db580$export$bd424905c2438697 = ({ options: options, label: label, onChangeHandler: onChangeHandler, onBlurHandler: onBlurHandler, onKeyUpHandler: onKeyUpHandler, error: error = false, defaultValue: defaultValue, sx: sx, className: className, inputProps: inputProps = {
    className: ""
}, variant: variant = "round", paddingbottom: paddingbottom })=>{
    const [value, setValue] = (0, $acw62.useState)(defaultValue !== "false" ? defaultValue : options[0]);
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    (0, $acw62.useEffect)(()=>{
        defaultValue !== "false" ? setValue(defaultValue) : setValue(options[0]);
    }, [
        defaultValue
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        pb: "5px",
        display: "flex",
        flexDirection: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a4adb9aa598db580$var$CustomLabel, {
                error: error,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a4adb9aa598db580$var$CustomSelect, {
                className: className,
                variant: variant,
                paddingbottom: paddingbottom,
                error: error,
                value: value,
                inputValue: inputValue,
                options: options,
                disableClearable: true,
                popupIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a68ff4fb6e888aa$exports))), {}),
                forcePopupIcon: true,
                onChange: (event, newValue)=>{
                    onChangeHandler(event, newValue);
                    setValue(newValue);
                },
                onInputChange: (event, newInputValue)=>{
                    newInputValue = newInputValue.replace(/\D/g, '');
                    setInputValue(newInputValue);
                },
                isOptionEqualToValue: (option, value)=>option.value === value.value,
                renderInput: (params)=>{
                    let updatedProps = params?.inputProps;
                    updatedProps.className = `${updatedProps?.className} ${inputProps?.className}`;
                    params.inputProps = updatedProps;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        ...params
                    });
                },
                freeSolo: true,
                onBlur: (event)=>onBlurHandler(event),
                onKeyUp: (event)=>onKeyUpHandler(event),
                sx: sx
            })
        ]
    });
};



// import TextField from '@mui/material/TextField';
// const StyledTextInput = styled(TextField)(({ theme: { palette: { neutral, status } }}) => ({
//   width: "30%",
//   "& label": {
//     fontFamily: "Aeonik Regular, Arial",
//     "&.Mui-focused": {
//       color: neutral.black,
//     },
//     "&.Mui-error": {
//       color: status.error,
//     },
//   },
//   "& .MuiInput-underline": {
//     "&:after": {
//       borderBottomColor: neutral.gray2,
//     },
//   },
// });
const $2ab7ec0ecb9a3186$export$60332b2344f7fe41 = ({ data: data, index: index, variant: variant, cardId: cardId, cardImage: cardImage, cardAgeGroup: cardAgeGroup, cardSubTitle: cardSubTitle, cardTitle: cardTitle, cardDescription: cardDescription, cardSubDesc: cardSubDesc, buttonLabel: buttonLabel, buttonLink: buttonLink, onButtonClick: // inputFieldError,
onButtonClick = ()=>{}, onSelectQuantity: onSelectQuantity = ()=>{}, onSelectBlurHandler: onSelectBlurHandler = ()=>{}, onFavClick: onFavClick = ()=>{}, onSelectKeyUpHandler: onSelectKeyUpHandler = ()=>{}, sx: sx, CardBadge: CardBadge, hidePrice: hidePrice = false, // onInputBlurHandler,
...props })=>{
    const cardBaseStyle = {
        borderRadius: "0px 0px 48px 0px",
        boxShadow: "0px 3px 6px #22222229",
        position: "relative"
    };
    const cardContentBaseStyle = {
        boxSizing: "border-box"
    };
    const cardActionsBaseStyle = {
        padding: "0px"
    };
    const [heartComponent, setHeartComponent] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($da57c823f260de6f$exports))));
    const [cartonsValue, setCartonsValue] = (0, $acw62.useState)(0);
    const [zeroCartonSelectedError, setZeroCartonSelectedError] = (0, $acw62.useState)(false);
    const [defaultDosesValue, setDefaultDosesValue] = (0, $acw62.useState)(props?.quantitydefaultvalue || null);
    // const [defaultDosesValue, setDefaultDosesValue] = useState(0);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const favClickHandler = ()=>{
        heartComponent === (0, (/*@__PURE__*/$parcel$interopDefault($da57c823f260de6f$exports))) ? setHeartComponent((0, (/*@__PURE__*/$parcel$interopDefault($fa50fbada1bf04d0$exports)))) : setHeartComponent((0, (/*@__PURE__*/$parcel$interopDefault($da57c823f260de6f$exports))));
        onFavClick();
    };
    const addToCart = async ()=>{
        if (cartonsValue <= 0) {
            setZeroCartonSelectedError(true);
            return;
        }
        setZeroCartonSelectedError(false);
        const dropDownValue = 0;
        setDefaultDosesValue({
            "label": dropDownValue.toString(),
            "value": dropDownValue
        });
        setCartonsValue(0);
        setDefaultDosesValue(0);
        setLoading(true);
        await onButtonClick(data, data?.dosesPerCarton);
        setLoading(false);
    };
    const { cardStyle: cardStyle, cardContentStyle: cardContentStyle, cardActionsStyle: cardActionsStyle, cardImageStyle: cardImageStyle, subTitleStyle: subTitleStyle, titleStyle: titleStyle, descriptionStyle: descriptionStyle, subDescStyle: subDescStyle, imageHeight: imageHeight, imageWidth: imageWidth, ButtonComponent: ButtonComponent } = (0, $7aaed6cb4870379f$export$164c3dc7db460fb7)(variant, buttonLink, buttonLabel, addToCart, loading);
    const theme = (0, $14H9o.default)();
    const desktop = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
        sx: {
            ...cardBaseStyle,
            ...cardStyle,
            ...sx
        },
        ...props,
        product_name: cardTitle,
        product_id: cardId,
        product_detail: cardDescription + "|" + cardAgeGroup,
        children: [
            (variant === "Wide" || variant === "Long" || variant === "Product") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $891b59d4b36435bb$export$2e2bcd8739ae039), {
                id: `cardImg-${index}`,
                component: "img",
                height: imageHeight,
                width: imageWidth,
                image: cardImage?.src,
                alt: "Card Image",
                sx: {
                    ...cardImageStyle
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                sx: {
                    ...cardContentBaseStyle,
                    ...cardContentStyle
                },
                children: [
                    variant !== "Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        id: `cardSubTitle-${index}`,
                        gutterBottom: true,
                        variant: "subtitle1",
                        component: "div",
                        sx: {
                            ...subTitleStyle
                        },
                        children: cardSubTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                id: `cardTitle-${index}`,
                                gutterBottom: true,
                                variant: "h5",
                                component: "div",
                                sx: {
                                    ...titleStyle
                                },
                                children: cardTitle
                            }),
                            variant === "Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                component: "img",
                                sx: {
                                    cursor: 'pointer'
                                },
                                src: heartComponent,
                                alt: "Favourite Button",
                                height: "30px",
                                width: "30px",
                                onClick: favClickHandler
                            }),
                            variant === "Product" && CardBadge
                        ]
                    }),
                    variant === "Request" && cardImage?.src && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: 'img',
                        mb: 3,
                        src: cardImage?.src,
                        alt: "Benefit Card Icon",
                        height: 80,
                        width: 80
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        id: `cardDescription-${index}`,
                        variant: "body2",
                        sx: {
                            ...descriptionStyle
                        },
                        children: cardDescription
                    }),
                    variant === "Long" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingBottom: "16px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bbb944c308ea2855$exports))),
                                alt: "Reading Icon",
                                height: "24px",
                                width: "24px"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "subtitle2",
                                sx: {
                                    ...subDescStyle
                                },
                                children: cardSubDesc
                            })
                        ]
                    }),
                    variant === "Product" && !hidePrice && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: '12px',
                        children: [
                            props.pricedata?.defaultPrice && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'p2',
                                color: "primary.main",
                                sx: {
                                    textDecoration: 'line-through'
                                },
                                id: `strikeThroughPrice-${index}`,
                                children: props.pricedata?.defaultPrice
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'h5',
                                color: "primary.main",
                                lineHeight: "1.2 !important",
                                id: `price-${index}`,
                                children: props.pricedata?.price
                            })
                        ]
                    }),
                    variant !== "Wide" && variant !== "Product" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                        sx: {
                            ...cardActionsBaseStyle,
                            ...cardActionsStyle
                        },
                        children: ButtonComponent
                    }),
                    variant === "Product" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                                sx: {
                                    ...cardActionsBaseStyle,
                                    ...cardActionsStyle
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4adb9aa598db580$export$bd424905c2438697), {
                                        variant: props && props?.comboselectvariant,
                                        paddingbottom: "0",
                                        id: `comboSelect-${index}`,
                                        sx: {
                                            "@media screen and (max-width: 500px)": {
                                                width: 150,
                                                height: 48
                                            }
                                        },
                                        label: props && props?.quantitylabel,
                                        options: props && props?.quantitydata,
                                        onChangeHandler: (e, value)=>{
                                            setCartonsValue(parseInt(value.value) / parseInt(props?.dosespercarton));
                                            onSelectQuantity(e, value);
                                        },
                                        onBlurHandler: (event)=>{
                                            if (event.target.value) {
                                                setCartonsValue(Math.ceil(parseInt(event.target.value) / parseInt(props?.dosespercarton)));
                                                let dropDownValue = Math.ceil(parseInt(event.target.value) / parseInt(props?.dosespercarton)) * parseInt(props?.dosespercarton);
                                                setDefaultDosesValue({
                                                    "label": dropDownValue.toString(),
                                                    "value": dropDownValue
                                                });
                                            } else {
                                                setCartonsValue(0);
                                                let dropDownValue = 0;
                                                setDefaultDosesValue({
                                                    "label": dropDownValue.toString(),
                                                    "value": dropDownValue
                                                });
                                            }
                                            onSelectBlurHandler(event);
                                        },
                                        onKeyUpHandler: (event)=>{
                                            if (event.key === 'Enter') {
                                                if (event.target.value) {
                                                    setCartonsValue(Math.ceil(parseInt(event.target.value) / parseInt(props?.dosespercarton)));
                                                    let dropDownValue = Math.ceil(parseInt(event.target.value) / parseInt(props?.dosespercarton)) * parseInt(props?.dosespercarton);
                                                    setDefaultDosesValue({
                                                        "label": dropDownValue.toString(),
                                                        "value": dropDownValue
                                                    });
                                                } else {
                                                    setCartonsValue(0);
                                                    let dropDownValue = 0;
                                                    setDefaultDosesValue({
                                                        "label": dropDownValue.toString(),
                                                        "value": dropDownValue
                                                    });
                                                }
                                                onSelectKeyUpHandler(event);
                                            }
                                        },
                                        error: zeroCartonSelectedError.toString(),
                                        defaultValue: defaultDosesValue
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        id: `subtitle-${index}`,
                                        variant: "p2",
                                        sx: {
                                            paddingBottom: "20px",
                                            paddingTop: "20px",
                                            marginLeft: "20px",
                                            color: 'primary.main',
                                            width: "68px"
                                        },
                                        children: `${cartonsValue} cartons`
                                    }),
                                    desktop && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: ButtonComponent
                                    })
                                ]
                            }),
                            mobile && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    textAlign: "center"
                                },
                                children: ButtonComponent
                            })
                        ]
                    }),
                    variant === "Secondary" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: 'img',
                        transform: "rotate(180deg)",
                        position: "absolute",
                        right: "-35px",
                        bottom: "-80px",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cd3dc9910c50d046$exports))),
                        alt: "Multi Colored Arrow",
                        height: "240px",
                        width: "240px"
                    })
                ]
            })
        ]
    });
};
$2ab7ec0ecb9a3186$export$60332b2344f7fe41.propTypes = {
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "Wide",
        "Square",
        "Secondary",
        "Info",
        "Request",
        "Product"
    ]),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    cardSubTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cardTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cardDescription: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cardSubDesc: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    buttonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onFavClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    cardImage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    buttonVisible: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $8bslU = parcelRequire("8bslU");

var $1ESci = parcelRequire("1ESci");
'use client';
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $8bslU.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $1ESci.default)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $gEUd4.default)(elementType, (0, $8nd05.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $jTnBY = parcelRequire("jTnBY");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



var $9Lykx = parcelRequire("9Lykx");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');



var $ldBGF = parcelRequire("ldBGF");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $kSnzZ.darken) : (0, $kSnzZ.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $kSnzZ.lighten) : (0, $kSnzZ.darken);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $8nd05.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $8nd05.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $8nd05.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $9Lykx.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $ldBGF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, (0, $8nd05.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, (0, $8nd05.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;



var $ea129f53ba63c792$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($ea129f53ba63c792$exports, "__esModule", {
    value: true
});
$ea129f53ba63c792$exports.default = void 0;

var $ea129f53ba63c792$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ea129f53ba63c792$var$_default = $ea129f53ba63c792$exports.default = (0, $ea129f53ba63c792$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), 'ReportProblemOutlined');


var $dc9b50cf83728035$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($dc9b50cf83728035$exports, "__esModule", {
    value: true
});
$dc9b50cf83728035$exports.default = void 0;

var $dc9b50cf83728035$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $dc9b50cf83728035$var$_default = $dc9b50cf83728035$exports.default = (0, $dc9b50cf83728035$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zm-.5 1.5 1.96 2.5H17V9.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), 'LocalShippingOutlined');


var $2be2d5fda6f09cee$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($2be2d5fda6f09cee$exports, "__esModule", {
    value: true
});
$2be2d5fda6f09cee$exports.default = void 0;

var $2be2d5fda6f09cee$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2be2d5fda6f09cee$var$_default = $2be2d5fda6f09cee$exports.default = (0, $2be2d5fda6f09cee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');


var $5e1e15a5cf751c0a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($5e1e15a5cf751c0a$exports, "__esModule", {
    value: true
});
$5e1e15a5cf751c0a$exports.default = void 0;

var $5e1e15a5cf751c0a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $5e1e15a5cf751c0a$var$_default = $5e1e15a5cf751c0a$exports.default = (0, $5e1e15a5cf751c0a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'CheckCircleOutline');



var $9c5eb05f9740712a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9c5eb05f9740712a$exports, "__esModule", {
    value: true
});
$9c5eb05f9740712a$exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = $9c5eb05f9740712a$exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $445092e407fd8a1c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($445092e407fd8a1c$exports, "__esModule", {
    value: true
});
$445092e407fd8a1c$exports.default = void 0;

var $445092e407fd8a1c$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $445092e407fd8a1c$var$_default = $445092e407fd8a1c$exports.default = (0, $445092e407fd8a1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');


var $114beea7d592d060$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($114beea7d592d060$exports, "__esModule", {
    value: true
});
$114beea7d592d060$exports.default = void 0;

var $114beea7d592d060$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $114beea7d592d060$var$_default = $114beea7d592d060$exports.default = (0, $114beea7d592d060$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m17.71 16.29 3.59-3.59c.39-.39.39-1.02 0-1.41L17.71 7.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L18.17 11H10c-.55 0-1 .45-1 1s.45 1 1 1h8.17l-1.88 1.88c-.39.39-.39 1.02 0 1.41.39.39 1.03.39 1.42 0"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M19 19H5V5h14v1c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.11 0 2-.9 2-2v-1c0-.55-.45-1-1-1s-1 .45-1 1z"
    }, "1")
], 'OutputRounded');



var $3bYfT = parcelRequire("3bYfT");
var $b1f31cbb54ec29ea$exports = {};
$b1f31cbb54ec29ea$exports = new URL("delivered.e2f9af53.svg", import.meta.url).toString();


var $f0457fa1d6e028c2$exports = {};
$f0457fa1d6e028c2$exports = new URL("pending.bef556ce.svg", import.meta.url).toString();


var $3ed535f563b87080$exports = {};
$3ed535f563b87080$exports = new URL("refresh.8530a275.svg", import.meta.url).toString();


var $9d0d556fa76376f6$exports = {};
$9d0d556fa76376f6$exports = new URL("badgeCheckIcon.5cf60fa2.svg", import.meta.url).toString();


var $d97a1fedc4ce7d35$exports = {};
$d97a1fedc4ce7d35$exports = new URL("warningInfoIcon.4e11f8c0.svg", import.meta.url).toString();


var $875e1140eb480776$exports = {};
$875e1140eb480776$exports = new URL("exclamation-circle-blue.6b0501ee.svg", import.meta.url).toString();


var $8eb19bdad873e3c3$exports = {};
$8eb19bdad873e3c3$exports = new URL("exclamation-circle-amber.50406146.svg", import.meta.url).toString();


const $14b3f7acde2e143a$var$CustomAlert = (0, $d8seH.default)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039))(({ width: width = 18, height: height = 18, theme: { palette: { neutral: neutral } } })=>({
        '&': {
            alignItems: 'center',
            backgroundColor: 'transparent',
            padding: 0
        },
        "& .MuiAlert-icon": {
            marginRight: '6px',
            padding: 0,
            svg: {
                width: width,
                height: height
            }
        },
        "& .MuiAlert-message": {
            fontSize: 14,
            textAlign: "left",
            color: "#222222",
            opacity: 1,
            padding: '0 0'
        },
        "&.orderDetails": {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end'
        },
        "&.orderDetails .MuiAlert-icon": {
            marginRight: '0',
            marginLeft: '6px',
            svg: {
                width: 40,
                height: 40
            }
        }
    }));
const $14b3f7acde2e143a$var$DeleveredIconStyle = (0, $d8seH.default)("img")`
  width: 18px;
  height: 18px;
`;
const $14b3f7acde2e143a$var$PendingIconStyle = (0, $d8seH.default)("img")`
  width: 18px;
  height: 18px;
`;
const $14b3f7acde2e143a$var$IconStyle = (0, $d8seH.default)("img")`
  width: 18px;
  height: 18px;
`;
const $14b3f7acde2e143a$var$renderStatus = (s, content, props)=>{
    switch(s.toLowerCase()){
        case "delivered":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$DeleveredIconStyle, {
                    alt: "Delivered",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b1f31cbb54ec29ea$exports))),
                    "data-testid": 'deliveredIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "invoiced":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5e1e15a5cf751c0a$exports))), {
                    alt: "Invoiced",
                    sx: {
                        color: 'status.success'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "open":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($114beea7d592d060$exports))), {
                    alt: "Open order",
                    sx: {
                        color: 'primary.main'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "delayed":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                    alt: "Delayed",
                    sx: {
                        color: 'status.error'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "shipped":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dc9b50cf83728035$exports))), {
                    alt: "Shipped",
                    sx: {
                        color: 'blue'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "pending":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$PendingIconStyle, {
                    alt: "Pending",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f0457fa1d6e028c2$exports))),
                    "data-testid": 'pendingIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "paid":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5e1e15a5cf751c0a$exports))), {
                    alt: "Paid",
                    sx: {
                        color: 'status.success'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "overdue":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                    alt: "Overdue",
                    sx: {
                        color: 'status.error'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "cancelled":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {
                    alt: "Cancelled",
                    sx: {
                        color: 'red'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "active":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: props.width,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($445092e407fd8a1c$exports))), {
                    alt: "Active",
                    fontSize: "small",
                    sx: {
                        color: 'status.success'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "inactive":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: props.width,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($445092e407fd8a1c$exports))), {
                    alt: "Inactive",
                    fontSize: "large",
                    sx: {
                        color: 'neutral.gray2'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "maintenance":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2be2d5fda6f09cee$exports))), {
                    alt: "Maintenance required",
                    sx: {
                        color: 'neutral.white',
                        marginRight: '10px'
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h4",
                    color: "neutral.white",
                    sx: {
                        lineHeight: 'inherit'
                    },
                    children: content
                })
            });
        case "processing":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$IconStyle, {
                    alt: "Processing",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3ed535f563b87080$exports))),
                    "data-testid": 'refreshIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "checked":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$IconStyle, {
                    alt: "Checked",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9d0d556fa76376f6$exports))),
                    "data-testid": 'checkedIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "warning":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$IconStyle, {
                    alt: "Warning",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d97a1fedc4ce7d35$exports))),
                    "data-testid": 'warningIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "ordered":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$IconStyle, {
                    alt: "Ordered",
                    sx: {
                        color: 'status.success'
                    },
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($875e1140eb480776$exports))),
                    "data-testid": 'orderedIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        case "reserved":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                width: '24px',
                height: '24px',
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$IconStyle, {
                    alt: "Reserved",
                    sx: {
                        color: 'status.success'
                    },
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8eb19bdad873e3c3$exports))),
                    "data-testid": 'orderedIcon'
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($14b3f7acde2e143a$var$CustomAlert, {
                className: props?.className,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea129f53ba63c792$exports))), {
                    alt: "Report problem",
                    sx: {
                        color: '#49B705',
                        fontSize: 18
                    }
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: props?.variant ? props?.variant : 'p2',
                    children: content
                })
            });
    }
};
const $14b3f7acde2e143a$export$81cd25a3fdfff1e4 = ({ status: status, children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: status && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: $14b3f7acde2e143a$var$renderStatus(status, children, rest)
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $iAtns = parcelRequire("iAtns");

var $hViLc = parcelRequire("hViLc");
var $30d3dbc7418ad6bf$exports = {};
$30d3dbc7418ad6bf$exports = new URL("warning.580c5328.svg", import.meta.url).toString();


var $8596db2dec6e8a72$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8596db2dec6e8a72$exports, "__esModule", {
    value: true
});
$8596db2dec6e8a72$exports.default = void 0;

var $8596db2dec6e8a72$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8596db2dec6e8a72$var$_default = $8596db2dec6e8a72$exports.default = (0, $8596db2dec6e8a72$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');


var $81772a14ec9ae23f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($81772a14ec9ae23f$exports, "__esModule", {
    value: true
});
$81772a14ec9ae23f$exports.default = void 0;

var $81772a14ec9ae23f$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $81772a14ec9ae23f$var$_default = $81772a14ec9ae23f$exports.default = (0, $81772a14ec9ae23f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6m-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14M2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13m-3.4-3.4 1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53"
}), 'VisibilityOffOutlined');



var $9Lykx = parcelRequire("9Lykx");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95f6704f80233608$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');


const $baaadb944db42c9b$var$CustomTextInput = (0, $d8seH.default)((0, $iAtns.default))(({ stylevariant: stylevariant, theme: { palette: { primary: primary, status: status, neutral: neutral }, ...props } })=>{
    const styleVariantsMapping = {
        border: {
            "& .MuiInput-root": {
                marginTop: '25px'
            },
            "& input": {
                fontSize: "16px",
                padding: "2px 10px 2px",
                border: '1px solid',
                borderColor: neutral.gray2,
                borderRadius: '5px',
                minHeight: '30px',
                marginTop: '5px'
            }
        },
        reservationOrder: {
            "& .MuiInput-root": {
                marginTop: '8px'
            },
            "& input": {
                fontSize: "16px",
                padding: "2px 10px 2px",
                border: '1px solid',
                borderColor: neutral.gray2,
                borderRadius: '5px',
                minHeight: '44px',
                marginTop: '5px'
            }
        },
        reservationAddressForm: {
            "& .MuiInput-root": {
                paddingTop: '7px'
            },
            "& input": {
                fontSize: "16px",
                padding: "12px",
                border: '1px solid',
                borderColor: neutral.gray7,
                borderRadius: '6px',
                minHeight: '22px',
                marginTop: '5px'
            }
        }
    };
    const variantStyles = styleVariantsMapping[stylevariant];
    return {
        "& .MuiInput-root": {
            marginTop: '15px'
        },
        "& textarea": {
            height: '70px !important',
            overflow: 'hidden',
            border: '1px solid',
            borderColor: neutral.gray2,
            padding: '10px',
            borderRadius: '6px'
        },
        "& input": {
            fontSize: "16px",
            padding: "7px 0 5px",
            border: 'none',
            borderColor: 'none',
            borderRadius: 'none',
            minHeight: 'auto',
            marginTop: '0px'
        },
        ...variantStyles,
        "& label": {
            color: primary.main,
            fontFamily: "Aeonik Bold",
            fontSize: "20px",
            "&.Mui-error": {
                color: status.error
            },
            "&.Mui-focused": {
                color: primary.main
            },
            "& .subLabel": {
                color: neutral.gray1,
                fontSize: "14px"
            }
        },
        "& .MuiFormHelperText-root": {
            fontFamily: "Aeonik Regular, Nunito",
            color: neutral.main,
            fontSize: '12px',
            "&.Mui-error": {
                color: status.error
            }
        },
        "& .MuiInput-underline": {
            "&:after": {
                borderBottomColor: 'transparent'
            },
            "&.Mui-error:after": {
                borderBottomColor: status.error
            }
        },
        "& .MuiInput-input": {
            fontFamily: "Aeonik Regular, Nunito",
            color: primary.main
        }
    };
});
const $baaadb944db42c9b$export$c86715117507e8e5 = ({ id: id, label: label, inputType: inputType, value: value, onChange: onChange, error: error, showpassword: showpassword, handleClickShowPassword: handleClickShowPassword, handleAndornmentClick: handleAndornmentClick, handleMouseDownPassword: handleMouseDownPassword, fieldType: fieldType, multiline: multiline, icon: icon, iconColor: iconColor, name: name, maxLength: maxLength, stylevariant: stylevariant, ...props })=>{
    const iconType = error ? "error" : fieldType;
    const getIcon = (iconType)=>{
        switch(iconType){
            case "error":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($30d3dbc7418ad6bf$exports))),
                        alt: "Warning Red Icon",
                        height: "24px",
                        width: "24px"
                    })
                });
            case "password":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        "aria-label": "toggle password visibility",
                        onClick: handleClickShowPassword,
                        edge: "end",
                        children: showpassword ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8596db2dec6e8a72$exports))), {
                            sx: {
                                color: 'primary.blue',
                                fontSize: 18
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($81772a14ec9ae23f$exports))), {
                            sx: {
                                color: 'primary.blue',
                                fontSize: 18
                            }
                        })
                    })
                });
            case "search":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        "aria-label": "search button",
                        edge: "end",
                        onClick: handleAndornmentClick,
                        children: icon ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: icon,
                            alt: "Search Icon"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {
                            style: {
                                color: iconColor
                            }
                        })
                    })
                });
            default:
                return "";
        }
    };
    const FieldLabel = props?.sublabel ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            label,
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "subLabel",
                children: props?.sublabel
            })
        ]
    }) : label;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($baaadb944db42c9b$var$CustomTextInput, {
        id: label?.replace(/\s+/g, ''),
        name: name,
        label: FieldLabel,
        value: value,
        type: inputType,
        variant: "standard",
        stylevariant: stylevariant,
        error: error,
        onChange: onChange,
        multiline: multiline,
        inputProps: {
            maxLength: maxLength
        },
        InputProps: {
            endAdornment: getIcon(iconType),
            sx: {
                "&:before": {
                    borderBottom: stylevariant ? "transparent" : "2px solid #c0c0c0"
                },
                "&:hover:not(.Mui-disabled):before": {
                    borderBottom: stylevariant ? "transparent" : "2px solid #c0c0c0"
                },
                "&.Mui-error:hover:not(.Mui-disabled):before": {
                    borderBottom: "none"
                }
            }
        },
        ...props
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");
const $6244916d51029084$var$Icon = (0, $d8seH.default)('img')(({ theme: { breakpoints: breakpoints } })=>`
  cursor: pointer;
  margin: 20px 0;
  ${[
        breakpoints.down('sm')
    ]} {
    margin:0 0 20px 0;
  }
`);
const $6244916d51029084$export$9eb849b9b922d396 = ({ cardImage: cardImage, cardTitle: cardTitle, cardDescription: cardDescription, index: index })=>{
    const theme = (0, $14H9o.default)();
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: {
            xs: '126px 20px 95px 20px',
            sm: '11em 4.25em'
        },
        children: [
            mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)($6244916d51029084$var$Icon, {
                src: cardImage,
                alt: "Icon",
                height: "53px",
                width: "53px",
                "data-testid": "cardIcon"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($6244916d51029084$var$Icon, {
                src: cardImage,
                alt: "Icon",
                height: "60px",
                width: "60px",
                "data-testid": "cardIcon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h3',
                p: "5px 0",
                id: 'cardTitle' + index,
                "data-testid": "cardTitle" + index,
                children: cardTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'p1',
                sx: {
                    cursor: 'pointer'
                },
                p: "5px 0",
                "data-testid": "cardDescription" + index,
                children: cardDescription
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $d8seH = parcelRequire("d8seH");


var $3bYfT = parcelRequire("3bYfT");
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $hPtJY = parcelRequire("hPtJY");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $c319b2c832c2914a$var$DIGIT = '0123456789';
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : typeof $hPtJY !== 'undefined' && $hPtJY.nextTick || $c319b2c832c2914a$var$_setImmediate;
var // *********************
$c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.7.9";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


const $d2ce41b179fcf973$var$getBaseUrl = ()=>{
    let baseUrl = "https://api.modernadirect.com";
    return baseUrl;
};
const $d2ce41b179fcf973$var$axiosInstance = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $d2ce41b179fcf973$var$getBaseUrl(),
    headers: {
        "Content-Type": "application/json"
    }
});
var $d2ce41b179fcf973$export$2e2bcd8739ae039 = $d2ce41b179fcf973$var$axiosInstance;


const $48795288c88243f1$export$2ff5180b1625389f = async (payload)=>{
    try {
        const res = await (0, $d2ce41b179fcf973$export$2e2bcd8739ae039)({
            url: `identityservice/v1/identity/activation`,
            method: "POST",
            data: JSON.stringify(payload),
            headers: {}
        });
        return res?.data;
    } catch (error) {
        throw error;
    }
};
const $48795288c88243f1$export$fb2b2f20a513ed94 = async (payload)=>{
    try {
        const res = await (0, $d2ce41b179fcf973$export$2e2bcd8739ae039)({
            url: `identityservice/v1/identity/verification/resend`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $48795288c88243f1$export$eb144e247981638e = async (payload)=>{
    try {
        const res = await (0, $d2ce41b179fcf973$export$2e2bcd8739ae039)({
            url: `identityservice/v1/identity/password/reset`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};


const $d08bc8f76ef837b2$var$StyledTextInput = (0, $d8seH.default)((0, $baaadb944db42c9b$export$c86715117507e8e5))(({ theme: { breakpoints: breakpoints } })=>`
  height: 70px;
  width: 100%;
  margin-top: 10% !important;
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 20% !important;
  }
`);
const $d08bc8f76ef837b2$var$ButtonContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 15% auto 70px auto;
  ${[
        breakpoints.down('sm')
    ]} {
    flex-direction: column-reverse;
    height: 90px;
    justify-content: space-between;
    width: 60%;
  }
`);
const $d08bc8f76ef837b2$export$c05ee40f4d1264eb = ({ setComp: setComp })=>{
    const [email, setEmail] = (0, $acw62.useState)("");
    const [invalidEmail, setInvalidEmail] = (0, $acw62.useState)("");
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const invalidEmailFormatErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_EMAIL_FORMAT");
    const invalidEmailFormatError = invalidEmailFormatErrorData && invalidEmailFormatErrorData[0]?.fields?.message;
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const handleEmail = (event)=>{
        setEmail(event.target.value);
        setInvalidEmail("");
    };
    const validate = ()=>{
        let isValid = true;
        let emailError;
        if (!email) {
            isValid = false;
            emailError = "Please enter your email Address.";
        }
        if (!(0, $382eb84981692d3a$export$7d809d729bfb7d8e)("email", email)) {
            isValid = false;
            emailError = invalidEmailFormatError;
        }
        setInvalidEmail(emailError);
        return isValid;
    };
    const cancel = ()=>{
        history.push(`/${locale}/`);
    };
    const handleNextButton = async (e)=>{
        e.preventDefault();
        if (validate()) {
            setProcessing(true);
            try {
                const res = await (0, $48795288c88243f1$export$eb144e247981638e)({
                    emailAddress: email
                });
                if (res?.status === 200) {
                    setComp("recoveryLink");
                    localStorage.setItem("recoverPassEmail", email);
                    setProcessing(false);
                }
            } catch (err) {
                setErrorMsg(generalApiError);
            }
            alertRef.current.openAlert();
            setProcessing(false);
        }
    };
    const message = `To reset your password, please enter the email associated with your account. A password reset link will be sent to you.
        PLEASE NOTE: Updating your password on Moderna Direct will change your password across other Moderna platforms via single sign on (if applicable).`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        "data-form-name": "not brand aligned|hcp|reset password form",
        "data-form-type": "account management form|non-dynamic form",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                id: "errorMessage",
                variant: "filled",
                type: "error",
                message: errorMsg,
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h1',
                textAlign: "center",
                color: "primary.main",
                id: "headline",
                "data-testid": "title",
                children: "Reset your password"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                textAlign: 'center',
                paddingTop: '16px',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'p1',
                    id: "requestResetMessage",
                    "data-testid": "message",
                    sx: {
                        whiteSpace: 'pre-line'
                    },
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d08bc8f76ef837b2$var$StyledTextInput, {
                required: true,
                focused: true,
                placeholder: "Enter email",
                id: "email",
                label: "Email",
                inputType: "email",
                variant: "standard",
                value: email,
                sx: {
                    marginBottom: "20px"
                },
                helperText: invalidEmail,
                error: !!invalidEmail,
                onChange: handleEmail,
                "data-testid": "input"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d08bc8f76ef837b2$var$ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        id: "requestResetCancel",
                        buttonType: "secondary",
                        onClick: cancel,
                        "data-testid": "cancelBtn",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        id: "requestResetNext",
                        buttonType: "primary",
                        onClick: handleNextButton,
                        loading: processing,
                        disabled: processing,
                        "data-testid": "nextBtn",
                        children: "Next"
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8f18b8dccceec434$exports = {};
$8f18b8dccceec434$exports = new URL("alertCheckIcon.242db0a0.svg", import.meta.url).toString();


var $b0cb743291103d60$exports = {};
$b0cb743291103d60$exports = new URL("alertIcon.bd03a77b.svg", import.meta.url).toString();


var $f3e532624c3fde13$exports = {};
$f3e532624c3fde13$exports = new URL("crossIconWhite.b2346fef.svg", import.meta.url).toString();



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");




var $2xc7G = parcelRequire("2xc7G");

var $1iGrQ = parcelRequire("1iGrQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4dba6b402693f5d6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $9Evvr.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $4dba6b402693f5d6$var$_excluded);
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)((0, $2xc7G.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $hweuE.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $9Evvr.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                ref: handleRef,
                style: (0, $8nd05.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $4dba6b402693f5d6$export$2e2bcd8739ae039 = $4dba6b402693f5d6$var$Slide;



var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");
const $e57c79a3bb70098b$var$CustomAlert = (0, $d8seH.default)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039))({
    fontFamily: "Aeonik Bold",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
    justifyContent: "center",
    fontWeight: 600,
    left: "20%",
    width: "60%",
    zIndex: 999999,
    margin: "auto",
    position: "fixed",
    top: "10%",
    minHeight: "60px",
    padding: "10px 50px"
});
const $e57c79a3bb70098b$var$CheckIconElement = (0, $d8seH.default)('img')`
  display: flex;
  align-items: center;
  object-fit: contain;
  width: 40px;
`;
const $e57c79a3bb70098b$export$8ebcecbecdb22732 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ type: type, variant: variant, message: message, color: color = "", ...props }, ref)=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const timeout = 10000;
    const handleOpenAlert = ()=>{
        setOpen(true);
        setTimeout(()=>{
            setOpen(false);
        }, timeout);
    };
    const handleCloseAlert = ()=>setOpen(false);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            openAlert: handleOpenAlert,
            closeAlert: handleCloseAlert
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dba6b402693f5d6$export$2e2bcd8739ae039), {
        direction: "down",
        in: open,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e57c79a3bb70098b$var$CustomAlert, {
            icon: type === "info" ? /*#__PURE__*/ (0, $ayMG0.jsx)($e57c79a3bb70098b$var$CheckIconElement, {
                "data-testid": "child",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8f18b8dccceec434$exports)))
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($e57c79a3bb70098b$var$CheckIconElement, {
                "data-testid": "child",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b0cb743291103d60$exports)))
            }),
            severity: type,
            variant: variant,
            color: color,
            ...props,
            children: props.customMessage ? props.customMessage : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h4",
                        color: 'neutral.white',
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        id: "crossIcon",
                        onClick: handleCloseAlert,
                        "data-testid": "closeBtn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            alt: "x",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f3e532624c3fde13$exports))),
                            "data-testid": "crossIcon",
                            height: "30px",
                            width: "30px"
                        })
                    })
                ]
            })
        })
    });
});



var $3bYfT = parcelRequire("3bYfT");

var $76cde12f53ab02e4$exports = {};
$76cde12f53ab02e4$exports = new URL("recovery-link.ea6b9eb4.png", import.meta.url).toString();


const $f79ce858bef4e2c5$var$ButtonContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 50px auto 40% auto;
  ${[
        breakpoints.down('sm')
    ]} {
    width: 60%;
    margin-top: 130px;
    margin-bottom: 150px;
  }
`);
const $f79ce858bef4e2c5$var$recoveryLinkContent = {
    headline: 'Recovery Link sent!',
    message: "We\u2019ve sent you an email with the information needed to reset your password. The email might take a couple of minutes to reach your account.",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($76cde12f53ab02e4$exports)))
};
const $f79ce858bef4e2c5$export$1c6ec2a4f3a0784c = ()=>{
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const emailAddress = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.emailAddress);
    const handleRecoveryLink = async (e)=>{
        e.preventDefault();
        setProcessing(true);
        if (localStorage.getItem("recoverPassEmail")) try {
            const res = await (0, $48795288c88243f1$export$eb144e247981638e)({
                emailAddress: emailAddress
            });
            if (res?.status === 200) setProcessing(false);
        } catch (err) {
            setErrorMsg(generalApiError);
            setProcessing(false);
            alertRef.current?.openAlert();
        }
    };
    const handleResendLink = handleRecoveryLink;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: 'img',
                margin: {
                    xs: '50px auto 20px auto',
                    sm: '20px auto'
                },
                display: "flex",
                id: "recoveryLinkImg",
                src: $f79ce858bef4e2c5$var$recoveryLinkContent.icon,
                width: "90px",
                height: "90px"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h1',
                textAlign: "center",
                color: "primary.main",
                id: "headline",
                "data-testid": "title",
                children: $f79ce858bef4e2c5$var$recoveryLinkContent.headline
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'p1',
                textAlign: "center",
                pt: '8px',
                sx: {
                    userSelect: 'text'
                },
                display: 'flex',
                justifyContent: 'center',
                id: "emailSentMessage",
                "data-testid": "message",
                children: $f79ce858bef4e2c5$var$recoveryLinkContent.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($f79ce858bef4e2c5$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    id: "resendLinkButton",
                    buttonType: "secondary",
                    onClick: handleResendLink,
                    loading: processing,
                    "data-testid": "resendBtn",
                    children: "RESEND LINK"
                })
            })
        ]
    });
};


const $11c5abf0cae7d169$export$c1fd039419f34e83 = ()=>{
    const [comp, setComp] = (0, $acw62.useState)('emailFactor');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                flexGrow: 1
            },
            children: comp === 'emailFactor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d08bc8f76ef837b2$export$c05ee40f4d1264eb), {
                setComp: setComp
            }) : comp === 'recoveryLink' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f79ce858bef4e2c5$export$1c6ec2a4f3a0784c), {
                setComp: setComp
            }) : ''
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $118QM = parcelRequire("118QM");
var $0c74e5d4e42b3f54$exports = {};
$0c74e5d4e42b3f54$exports = new URL("Loading.165e6a47.gif", import.meta.url).toString();


const $44f519628b01ef9a$var$style = {
    position: "absolute",
    top: "50%",
    left: "50%"
};
const $44f519628b01ef9a$export$7f7cbe89f1eacd2 = ({ processing: processing })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $118QM.default), {
        open: processing,
        sx: $44f519628b01ef9a$var$style,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            width: "50",
            height: "50",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0c74e5d4e42b3f54$exports))),
            alt: "Loader"
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");
const $a1068173721857b5$export$da524f2075150321 = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`;
const $a1068173721857b5$export$b534932db7eb0121 = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
`;
const $a1068173721857b5$export$94944d8910c4db4b = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;
const $a1068173721857b5$export$f1ff1fb39f7795df = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`;


const $fd31b523df1fca51$var$CustomBold = (0, $d8seH.default)('span')`
    font-family: 'Aeonik Bold', 'Arial';
`;
const $fd31b523df1fca51$var$CustomParagraph = (0, $d8seH.default)('p')`
   line-height:22px;
`;
const $fd31b523df1fca51$var$CustomList = (0, $d8seH.default)('ul')(({ theme: { breakpoints: breakpoints } })=>`
  list-style-type: initial;
  margin-left: 20px;
  font-family: 'Aeonik Regular';
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 24px;
    margin-bottom: 30px;
  }
`);
const $fd31b523df1fca51$var$renderNode = (node)=>{
    if (!node) return null;
    switch(node.nodeType){
        case "document":
            return node.content.map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                    children: $fd31b523df1fca51$var$renderNode(child)
                }, index));
        case "paragraph":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($fd31b523df1fca51$var$CustomParagraph, {
                children: node?.content?.[0]?.value === "" && node?.content?.[0]?.nodeType === "text" ? /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}) : node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "heading-1":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$da524f2075150321), {
                children: node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "heading-2":
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$b534932db7eb0121), {
                children: node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "unordered-list":
            return /*#__PURE__*/ (0, $ayMG0.jsx)($fd31b523df1fca51$var$CustomList, {
                children: node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "ordered-list":
            return /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                children: node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "list-item":
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: node.content.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
        case "embedded-asset-block":
            const { title: title, file: file } = node.data.target.fields;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: file.url,
                alt: title,
                style: {
                    maxWidth: "100%"
                }
            });
        case "text":
            const isBold = node.marks?.some((mark)=>mark.type === "bold");
            return isBold ? /*#__PURE__*/ (0, $ayMG0.jsx)($fd31b523df1fca51$var$CustomBold, {
                children: node.value
            }) : node.value;
        case "hyperlink":
            return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: node.data.uri,
                style: {
                    textDecoration: "none",
                    margin: "0 4px"
                },
                children: node.content[0].value
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: node.content?.map((child, index)=>$fd31b523df1fca51$var$renderNode(child))
            });
    }
};
const $fd31b523df1fca51$var$CustomRichTextRenderer = ({ jsonData: jsonData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: $fd31b523df1fca51$var$renderNode(jsonData)
    });
};
var $fd31b523df1fca51$export$2e2bcd8739ae039 = $fd31b523df1fca51$var$CustomRichTextRenderer;


const $b37fb94a569b197e$export$b79a43da0d6ccc36 = {
    title: 'Reset Password Component',
    message: {
        nodeType: 'document',
        data: {},
        content: {
            nodeType: 'unordered-list',
            data: {},
            content: [
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: 'Must be longer than 12 characters',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                },
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: '1 uppercase and 1 lowercase letter',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                },
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: '1 special character (e.g., !@#$%^&*)',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                },
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: '1 number (0-9)',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                },
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: 'Does not contain part of username',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                },
                {
                    nodeType: 'list-item',
                    data: {},
                    content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                    nodeType: 'text',
                                    value: 'Not any recently used passwords\n',
                                    marks: [],
                                    data: {}
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    cancelButtonLabel: 'Cancel',
    resetButtonLabel: 'Reset'
};


const $4a6cb98550890cd8$var$StyledTextInput = (0, $d8seH.default)((0, $baaadb944db42c9b$export$c86715117507e8e5))`
  height: 70px;
  width: 100%;
  margin-top: 10% !important;
`;
const $4a6cb98550890cd8$var$ButtonContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 15% auto 70px auto;
  ${[
        breakpoints.down('sm')
    ]} {
    flex-direction: column-reverse;
    height: 96px;
    justify-content: space-between;
    width: 50%;
    margin-bottom: 120px;
    margin-top: 70px;
  }
`);
const $4a6cb98550890cd8$var$PasswordList = (0, $d8seH.default)('ul')(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  list-style-type: initial;
  color: ${primary.main};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  font-family: 'Aeonik Regular';
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 24px;
    margin-bottom: 30px;
  }
`);
const $4a6cb98550890cd8$export$804dab9fa8278df0 = ({ setComp: setComp, userEmail: userEmail, isASMuser: isASMuser })=>{
    const [password, setPassword] = (0, $acw62.useState)("");
    const [invalidPassword, setInvalidPassword] = (0, $acw62.useState)(false);
    const [showpassword, setShowpassword] = (0, $acw62.useState)(false);
    const [confirmPassword, setConfirmPassword] = (0, $acw62.useState)("");
    const [invalidConfirmPassword, setInvalidConfirmPassword] = (0, $acw62.useState)(false);
    const [showconfirmpassword, setShowConfirmpassword] = (0, $acw62.useState)(false);
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { search: search } = window.location;
    const params = new URLSearchParams(search);
    const recoveryToken = params.get("token");
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const invalidPasswordFormatErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_PASSWORD_FORMAT");
    const invalidPasswordFormatError = invalidPasswordFormatErrorData && invalidPasswordFormatErrorData[0]?.fields?.message;
    const mismatchPasswordFormatErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "PASSWORD_MISMATCH");
    const mismatchPasswordFormatError = mismatchPasswordFormatErrorData && mismatchPasswordFormatErrorData[0]?.fields?.message;
    const verifyTokenAndSetNewPassword = ()=>{
        setProcessing(true);
        if (recoveryToken) oktaAuth.verifyRecoveryToken({
            recoveryToken: recoveryToken
        }).then((transaction)=>{
            if (transaction.status === 'PASSWORD_RESET') return transaction.resetPassword({
                newPassword: password
            });
        }).then((transaction)=>{
            if (transaction.status === 'SUCCESS') {
                setProcessing(false);
                setComp("resetSuccess");
            } else {
                setProcessing(false);
                const error = 'We cannot handle the ' + transaction.status + ' status';
                throw error;
            }
        }).catch((error)=>{
            setProcessing(false);
            if (error?.errorCode === "E0000080") setInvalidPassword(error?.errorSummary);
            else if (error?.errorCode === "E0000105") setComp("tokenExpired");
            else setInvalidPassword(error?.errorSummary);
        });
    };
    const handleCancel = (e)=>{
        e.preventDefault();
        history.push(`/${locale}/`);
    };
    const handleReset = (e)=>{
        e.preventDefault();
        if (validate()) verifyTokenAndSetNewPassword();
    };
    const handlePassword = (event)=>{
        setPassword(event.target.value);
        setInvalidPassword("");
    };
    const handleClickShowPassword = ()=>{
        setShowpassword(!showpassword);
    };
    const handleConfirmPassword = (event)=>{
        setConfirmPassword(event.target.value);
        setInvalidConfirmPassword("");
    };
    const handleClickShowConfirmPassword = ()=>{
        setShowConfirmpassword(!showconfirmpassword);
    };
    const validate = ()=>{
        let isValid = true;
        let passwordError;
        let confPasswordError;
        if (!password) {
            isValid = false;
            passwordError = "Please enter your password.";
            setInvalidPassword(passwordError);
        }
        if (!(0, $382eb84981692d3a$export$7d809d729bfb7d8e)("password", password)) {
            isValid = false;
            passwordError = invalidPasswordFormatError;
            setInvalidPassword(passwordError);
        }
        if (!confirmPassword) {
            isValid = false;
            confPasswordError = "Please enter confirm password.";
            setInvalidConfirmPassword(confPasswordError);
        }
        if (confirmPassword !== "undefined") {
            if (password !== confirmPassword) {
                isValid = false;
                confPasswordError = mismatchPasswordFormatError;
                setInvalidConfirmPassword(confPasswordError);
            }
        }
        return isValid;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        "data-testid": "NewPasswordTest",
        display: 'flex',
        flexDirection: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h1',
                textAlign: "center",
                color: "primary.main",
                id: "headline",
                "data-testid": "HeadlineTest",
                children: "Reset your Password"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'p1',
                component: 'span',
                textAlign: "center",
                mt: "20px",
                id: "resetPassText",
                "data-testid": "ResetPassTextTest",
                children: `Create a new password for ${userEmail}. It must contain the following: `
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4a6cb98550890cd8$var$PasswordList, {
                id: "passwordList",
                "data-testid": "PasswordListTest",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd31b523df1fca51$export$2e2bcd8739ae039), {
                    jsonData: (0, $b37fb94a569b197e$export$b79a43da0d6ccc36).message.content
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4a6cb98550890cd8$var$StyledTextInput, {
                required: true,
                focused: true,
                placeholder: "Enter password",
                error: !!invalidPassword,
                value: password,
                inputType: showpassword ? 'text' : 'password',
                id: "password",
                "data-testid": "PasswordTest",
                label: "Password",
                helperText: invalidPassword,
                variant: "standard",
                showpassword: showpassword,
                handleClickShowPassword: handleClickShowPassword,
                onChange: handlePassword,
                fieldType: "password"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4a6cb98550890cd8$var$StyledTextInput, {
                required: true,
                focused: true,
                placeholder: "Re-enter password",
                error: !!invalidConfirmPassword,
                value: confirmPassword,
                inputType: showconfirmpassword ? 'text' : 'password',
                id: "confirmPassword",
                "data-testid": "ConfirmPasswordTest",
                label: "Confirm Password",
                helperText: invalidConfirmPassword,
                variant: "standard",
                showpassword: showconfirmpassword,
                handleClickShowPassword: handleClickShowConfirmPassword,
                onChange: handleConfirmPassword,
                fieldType: "password"
            }),
            isASMuser ? /*#__PURE__*/ (0, $ayMG0.jsx)($4a6cb98550890cd8$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "primary",
                    id: "submitButton",
                    "data-testid": "SubmitButtonTest",
                    onClick: handleReset,
                    loading: processing,
                    disabled: processing,
                    children: "Reset"
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($4a6cb98550890cd8$var$ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "secondary",
                        id: "cancelButton",
                        "data-testid": "CancelButtonTest",
                        onClick: handleCancel,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "primary",
                        id: "resetButton",
                        "data-testid": "ResetButtonTest",
                        onClick: handleReset,
                        loading: processing,
                        disabled: processing,
                        children: "Reset"
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $d8seH = parcelRequire("d8seH");



var $3bYfT = parcelRequire("3bYfT");
var $f7419948cd8af5e1$exports = {};
$f7419948cd8af5e1$exports = new URL("clock-timer.e3a08b8b.png", import.meta.url).toString();


const $b6096b19f9aaa5c8$var$ButtonContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 50px auto 40% auto;
  ${[
        breakpoints.down('sm')
    ]} {
    width: 60%;
    margin-top: 130px;
    margin-bottom: 150px;
  }
`);
const $b6096b19f9aaa5c8$export$f8faa09e126f4f34 = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const staticContent = {
        headline: 'Your verification link has expired',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f7419948cd8af5e1$exports))),
        message: `You'll need to generate a new verification link.`,
        resetButtonLabel: 'Continue'
    };
    const resetPasswordHandler = ()=>{
        history.push(`/${locale}/request-reset-password`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: 'img',
                margin: {
                    xs: '50px auto 20px auto',
                    sm: '20px auto'
                },
                display: "flex",
                id: "tokenExpiredImg",
                "data-testid": "tokenExpiredImg",
                src: staticContent.icon,
                width: "90px",
                height: "90px"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h1',
                textAlign: "center",
                color: "primary.main",
                id: "headline",
                "data-testid": "headline",
                children: staticContent.headline
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'p1',
                textAlign: "center",
                mt: "20px",
                id: "tokenExpiredMessage",
                "data-testid": "tokenExpiredMessage",
                children: staticContent.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b6096b19f9aaa5c8$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    id: "resetButton",
                    buttonType: "primary",
                    onClick: resetPasswordHandler,
                    children: staticContent.resetButtonLabel
                })
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");


var $d8seH = parcelRequire("d8seH");



var $3bYfT = parcelRequire("3bYfT");
var $dc35ddbb996db4a1$exports = {};
$dc35ddbb996db4a1$exports = new URL("success-badge.7bb32b31.svg", import.meta.url).toString();


const $7546da3ffe53c1f5$var$ButtonContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 50px auto 40% auto;
  ${[
        breakpoints.down('sm')
    ]} {
    width: 60%;
    margin-bottom: 230px;
  }
`);
const $7546da3ffe53c1f5$export$af6bb39df5e3b346 = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const staticContent = {
        headline: 'Password reset successful',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dc35ddbb996db4a1$exports))),
        message: 'Your password has been reset successfully. Click below to return home and sign in with your updated credentials.',
        signInButtonLabel: 'Sign In'
    };
    const signInHandler = ()=>{
        history.push(`/${locale}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: 'img',
                margin: {
                    xs: '50px auto 20px auto',
                    sm: '20px auto'
                },
                display: "flex",
                id: "resetSucessImg",
                "data-testid": "resetSucessImg",
                src: staticContent.icon,
                width: "90px",
                height: "90px"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h1',
                textAlign: "center",
                color: "primary.main",
                id: "headline",
                "data-testid": "headline",
                children: staticContent.headline
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'p1',
                textAlign: "center",
                mt: "20px",
                id: "resetSuccessText",
                "data-testid": "resetSuccessText",
                children: staticContent.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7546da3ffe53c1f5$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    "data-testid": "resetSuccessButton",
                    id: "resetSuccessButton",
                    buttonType: "primary",
                    onClick: signInHandler,
                    children: staticContent.signInButtonLabel
                })
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");

const $6b303846d9975ac4$var$GlobalImg = (0, $d8seH.default)('img')(({ theme: { breakpoints: breakpoints } })=>`
  margin: 20px auto;
  display: flex;
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 50px;
  }
`);
const $6b303846d9975ac4$export$48ef97169f3bb22 = ({ firstName: firstName })=>{
    const staticContent = {
        benefitCards: [],
        headline: 'Password reset successful',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dc35ddbb996db4a1$exports))),
        message: 'Your password has been reset successfully. Click below to return home and sign in with your updated credentials.'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b303846d9975ac4$var$GlobalImg, {
                id: "resetSucessImg",
                "data-testid": "resetSucessImg",
                alt: "resetSucessImg",
                src: staticContent.icon,
                width: "90",
                height: "90"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h1",
                color: 'primary.main',
                mt: 4,
                textAlign: 'center',
                id: "resetSuccessText",
                "data-testid": "resetSuccessText",
                sx: {
                    margin: {
                        sm: '32px 120px 0'
                    }
                },
                children: staticContent.message
            })
        ]
    });
};



const $07ee858b5cd2ee41$export$a4c3d56613a57187 = ({ isASMuser: isASMuser, comp: comp, setComp: setComp })=>{
    const [userEmail, setUserEmail] = (0, $acw62.useState)('');
    const [firstName, setFirstName] = (0, $acw62.useState)('');
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    (0, $acw62.useEffect)(()=>{
        const { search: search } = window.location;
        const params = new URLSearchParams(search);
        const recoveryToken = params.get("token");
        if (recoveryToken) {
            setComp('');
            setProcessing(true);
            oktaAuth.verifyRecoveryToken({
                recoveryToken: recoveryToken
            }).then((transaction)=>{
                if (transaction.status === 'PASSWORD_RESET') {
                    setUserEmail(transaction?.user?.profile?.login);
                    setFirstName(transaction?.user?.profile?.firstName);
                    setProcessing(false);
                    setComp('newPassword');
                } else {
                    setProcessing(false);
                    history.push(`/${locale}/request-reset-password`);
                    const error = 'We cannot handle the ' + transaction.status + ' status';
                    throw error;
                }
            }).catch((err)=>{
                setProcessing(false);
                setComp('tokenExpired');
            });
        }
    }, [
        history,
        oktaAuth
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    flexGrow: 1
                },
                children: comp === 'newPassword' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a6cb98550890cd8$export$804dab9fa8278df0), {
                    setComp: setComp,
                    userEmail: userEmail,
                    isASMuser: isASMuser
                }) : comp === 'setPasswordResetSuccess' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b303846d9975ac4$export$48ef97169f3bb22), {
                    firstName: firstName
                }) : comp === 'resetSuccess' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7546da3ffe53c1f5$export$af6bb39df5e3b346), {}) : comp === 'tokenExpired' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6096b19f9aaa5c8$export$f8faa09e126f4f34), {
                    userEmail: userEmail
                }) : ''
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $1mPeS = parcelRequire("1mPeS");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $14H9o = parcelRequire("14H9o");

var $9Rgf1 = parcelRequire("9Rgf1");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $247ae09dccc3464c$export$5162da8f798e0959), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $8nd05.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default) } = props, other = (0, $1En50.default)(props, $848dc8709a4309c5$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $14H9o.default)();
    const timer = (0, $lHOu3.default)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, (0, $8nd05.default)({
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $8nd05.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: (0, $8nd05.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: (0, $8nd05.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;



var $7Frhn = parcelRequire("7Frhn");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;



var $3yddg = parcelRequire("3yddg");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e14e8c767477d992$export$80fb6a2cb3f13b8b), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e14e8c767477d992$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1En50.default)(props, $5c228c234852d575$var$_excluded);
    const [expanded, setExpandedState] = (0, $3yddg.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $8nd05.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $8nd05.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $848dc8709a4309c5$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5c228c234852d575$var$AccordionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bbfcb95732dc207$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, (0, $8nd05.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d55ba52db43b55df$export$282216ad123d6580), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1En50.default)(props, $1a792f5a0c37e2ab$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $5bbfcb95732dc207$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a792f5a0c37e2ab$var$AccordionSummaryRoot, (0, $8nd05.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$_excluded = [
    "className"
];
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4b72c3145e33d8$export$a6afb527becfac26), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $1b78273c1c27a2e1$var$_excluded);
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;



var $3bYfT = parcelRequire("3bYfT");
var $c842ddb70f8ccad0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($c842ddb70f8ccad0$exports, "__esModule", {
    value: true
});
$c842ddb70f8ccad0$exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = $c842ddb70f8ccad0$exports.default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');



var $d8seH = parcelRequire("d8seH");
const $273d0c5767f221c5$var$StyledAccordionSummary = (0, $d8seH.default)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039))`
  padding: 0 !important;
`;
const $273d0c5767f221c5$var$StyledAccordionDetails = (0, $d8seH.default)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039))`
      padding: 8px 5px 16px !important;
`;
const $273d0c5767f221c5$export$a766cd26d0d69044 = ({ heading: heading, description: description, accordionCustomStyle: accordionCustomStyle, expanded: expanded, defaultExpanded: defaultExpanded, id: id = "panel1a-header", className: className })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        sx: {
            ...accordionCustomStyle
        },
        expanded: expanded,
        defaultExpanded: defaultExpanded,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($273d0c5767f221c5$var$StyledAccordionSummary, {
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                    sx: {
                        color: 'primary.blue'
                    }
                }),
                "aria-controls": "panel1a-content",
                id: id,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h5',
                    sx: {
                        color: "primary.main"
                    },
                    component: 'div',
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($273d0c5767f221c5$var$StyledAccordionDetails, {
                sx: {
                    backgroundColor: className === 'gpoSectionAccordion' ? 'transparent' : 'neutral.white'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'p2',
                    color: "primary.main",
                    children: description
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $3bYfT = parcelRequire("3bYfT");


const $4b7606028215b492$var$accordionCustomStyle = {
    borderRadius: "0px !important",
    boxShadow: "none",
    borderBottom: "1px solid #D1D1D1",
    borderTop: "none",
    margin: "0px !important"
};
const $4b7606028215b492$export$f0cdb780346cef06 = ({ title: title, data: data, index: index, iconUrl: iconUrl })=>{
    const localeISOCode = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.localeISOCode);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        id: `faqContainer-${index}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: 'flex',
                alignItems: 'center',
                pt: 3,
                sx: {
                    height: "60px"
                },
                id: `faqHeader-${index}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: "img",
                        sx: {
                            float: "left",
                            width: "45px",
                            height: "45px"
                        },
                        id: `faqHeaderImg-${index}`,
                        src: iconUrl,
                        alt: "logo"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: 'h2',
                        ml: 2,
                        sx: {
                            color: 'primary.main'
                        },
                        id: `faqHeaderTitle-${index}`,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 1,
                m: "10px 60px 0 60px",
                children: data.length && data.map((faqValue, index)=>faqValue?.fields?.country?.fields?.isocode === localeISOCode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $273d0c5767f221c5$export$a766cd26d0d69044), {
                        id: `accordion-${index}`,
                        heading: faqValue?.fields?.question,
                        description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd31b523df1fca51$export$2e2bcd8739ae039), {
                            jsonData: faqValue?.fields?.answer
                        }),
                        accordionCustomStyle: $4b7606028215b492$var$accordionCustomStyle
                    }, index))
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");



var $3bYfT = parcelRequire("3bYfT");

const $72ba86933adc7fbf$var$ContactUsContainer = (0, $d8seH.default)('section')(({ backgroundImgUrl: backgroundImgUrl, theme: { palette: { secondary: secondary } } })=>`
    background: ${secondary.main} 0% 0% no-repeat padding-box;
    padding: 90px;
    text-align: center;
    background-image: url(${backgroundImgUrl});
    background-size: cover;
`);
const $72ba86933adc7fbf$export$443569d70de2c455 = ({ data: data })=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const click = async ()=>{};
    const contactUsBtnClicked = ()=>{
        history.push(`/${locale}/contact-us`);
    };
    const buttonHref = `/${locale}/contact-us`;
    const { fields: fields } = data;
    const backgroundImageUrl = fields?.backgroundImage?.fields?.file?.url;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($72ba86933adc7fbf$var$ContactUsContainer, {
        backgroundImgUrl: backgroundImageUrl,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h3',
                textAlign: "center",
                mb: "30px",
                color: "primary.main",
                children: fields?.contactUsMessage
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                onClick: contactUsBtnClicked,
                "data-link-href": buttonHref,
                children: fields?.contactUsButtonLabel
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");



var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $c6dea190c14bdd7e$exports = {};
$c6dea190c14bdd7e$exports = new URL("user.1188935c.svg", import.meta.url).toString();



var $ayMG0 = parcelRequire("ayMG0");

var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");


var $bnost = parcelRequire("bnost");


var $beCSm = parcelRequire("beCSm");
const $f936b180a3f4c08c$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $f936b180a3f4c08c$export$2e2bcd8739ae039 = $f936b180a3f4c08c$var$boxClasses;


'use client';
const $b5363c9a2f115365$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    defaultClassName: (0, $f936b180a3f4c08c$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $b5363c9a2f115365$export$2e2bcd8739ae039 = $b5363c9a2f115365$var$Box;



var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $4Cod0.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $beCSm.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $478fe5b437ab8d6f$export$ffd560f22c0ecf04), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $8nd05.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $8nd05.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $9a402a389bd8b499$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $8nd05.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, (0, $8nd05.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;


var $6404beb9a0fb9f3d$exports = {};
$6404beb9a0fb9f3d$exports = new URL("usa-flag.17bd64d9.svg", import.meta.url).toString();


var $dea8353449714ce1$exports = {};
$dea8353449714ce1$exports = new URL("switzerland-flag.7ac4fd48.svg", import.meta.url).toString();



var $i4CZ2 = parcelRequire("i4CZ2");

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $6SpLG = parcelRequire("6SpLG");
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;



var $hPtJY = parcelRequire("hPtJY");
var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $6SpLG.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $i4CZ2.isDraft)(value) ? (0, $i4CZ2.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ad4393542232627c$export$f672e0b6f7222cd7;
    return (0, $ad4393542232627c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$export$b956e38827fca970(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $74cf642ba7fa99c2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $74cf642ba7fa99c2$var$hasMatchFunction(action);
}
function $74cf642ba7fa99c2$export$ebd532f9034651f3(action) {
    return $74cf642ba7fa99c2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $74cf642ba7fa99c2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $74cf642ba7fa99c2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $74cf642ba7fa99c2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $i4CZ2.isDraftable)(val) ? (0, $i4CZ2.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = true;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = true;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $ad4393542232627c$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $ad4393542232627c$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $ad4393542232627c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $74cf642ba7fa99c2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $ad4393542232627c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i4CZ2.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i4CZ2.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i4CZ2.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $hPtJY;
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i4CZ2.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i4CZ2.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$74cf642ba7fa99c2$export$b956e38827fca970(action)) return next(action);
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i4CZ2.enableES5)();


const $c89d887792446c86$var$initialState = {
    invalidPasswordMsg: "",
    locale: "en-US",
    localeISOCode: "US",
    isCheckoutBtnClicked: false,
    isPlaceOrderClicked: false,
    isConfirmationPageAccessible: false,
    isOnboardingSuccessful: false,
    emailAddress: "",
    userStatus: "",
    canAccessOrderConfirmationPage: false,
    canAccessInvoicePayConfirmationPage: false,
    isUserValidated: true,
    showContractPrice: false,
    showContractPriceForReservation: false,
    isLoggingIn: false,
    reservationConversionID: ""
};
const $c89d887792446c86$export$d24f162af402e7d2 = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
    name: "globalStates",
    initialState: $c89d887792446c86$var$initialState,
    reducers: {
        setInvalidPasswordMsg: (state, action)=>{
            const { payload: payload } = action;
            state.invalidPasswordMsg = payload;
        },
        setLocale: (state, action)=>{
            const { payload: payload } = action;
            state.locale = payload;
        },
        setLocaleISOCode: (state, action)=>{
            const { payload: payload } = action;
            state.localeISOCode = payload;
        },
        setCheckoutBtnClicked: (state, action)=>{
            const { payload: payload } = action;
            state.isCheckoutBtnClicked = payload;
        },
        setPlaceOrderClicked: (state, action)=>{
            const { payload: payload } = action;
            state.isPlaceOrderClicked = payload;
        },
        setIsConfirmationPageAccessible: (state, action)=>{
            const { payload: payload } = action;
            state.isConfirmationPageAccessible = payload;
        },
        setIsOnboardingSuccessful: (state, action)=>{
            const { payload: payload } = action;
            state.isOnboardingSuccessful = payload;
        },
        setUserStatus: (state, action)=>{
            const { payload: payload } = action;
            state.userStatus = payload;
        },
        setEmailAddress: (state, action)=>{
            const { payload: payload } = action;
            state.emailAddress = payload;
        },
        setCanAccessOrderConfirmationPage: (state, action)=>{
            const { payload: payload } = action;
            state.canAccessOrderConfirmationPage = payload;
        },
        setCanAccessInvoicePayConfirmationPage: (state, action)=>{
            const { payload: payload } = action;
            state.canAccessInvoicePayConfirmationPage = payload;
        },
        setIsUserValidated: (state, action)=>{
            const { payload: payload } = action;
            state.isUserValidated = payload;
        },
        setShowContractPrice: (state, action)=>{
            const { payload: payload } = action;
            state.showContractPrice = payload;
        },
        setShowContractPriceForReservation: (state, action)=>{
            const { payload: payload } = action;
            state.showContractPriceForReservation = payload;
        },
        setIsLoggingIn: (state, action)=>{
            const { payload: payload } = action;
            state.isLoggingIn = payload;
        },
        setReservationConversionID: (state, action)=>{
            const { payload: payload } = action;
            state.reservationConversionID = payload;
        }
    }
});
const { setSessionHeaderOpen: $c89d887792446c86$export$86be6c8079b083d7, setInvalidPasswordMsg: $c89d887792446c86$export$233028e633e6e005, setLocale: $c89d887792446c86$export$c8aadf3621e41efb, setLocaleISOCode: $c89d887792446c86$export$d8b4e4fbb23eb316, setCheckoutBtnClicked: $c89d887792446c86$export$e1845c51a8b7062f, setPlaceOrderClicked: $c89d887792446c86$export$f244df32a0e49375, setIsConfirmationPageAccessible: $c89d887792446c86$export$63839643d7952680, setIsOnboardingSuccessful: $c89d887792446c86$export$24b370854b6f1b89, setCanOrder2023Products: $c89d887792446c86$export$949d618668744c97, setEmailAddress: $c89d887792446c86$export$7ffa46ddfa066ef4, setUserStatus: $c89d887792446c86$export$d0a94b87b12755e3, setCanAccessOrderConfirmationPage: $c89d887792446c86$export$afab37d636f63f75, setCanAccessInvoicePayConfirmationPage: $c89d887792446c86$export$a8f8d34a822b029c, setIsUserValidated: $c89d887792446c86$export$a6218b91b45f6dae, setReservationConversionID: $c89d887792446c86$export$ca51d8f2e5df1a32, setShowContractPrice: $c89d887792446c86$export$dc61f17556438aae, setShowContractPriceForReservation: $c89d887792446c86$export$67e4c7982a3d161b, setIsLoggingIn: $c89d887792446c86$export$3891ea45be4fea53 } = $c89d887792446c86$export$d24f162af402e7d2.actions;
var $c89d887792446c86$export$2e2bcd8739ae039 = $c89d887792446c86$export$d24f162af402e7d2.reducer;




const $5c0fb5c4fb6f6801$var$Menu = (0, $d8seH.default)('ul')(({ show: show, theme: { palette: { primary: primary, neutral: neutral, secondary: secondary }, breakpoints: breakpoints } })=>`
  position: absolute;
  top: 61px;
  right: 0px;
  background-color: ${secondary.main};
  border-top: 3px solid ${primary.blue};
  border-radius: 0px 0px 16px 16px;
  width: 190px;
  display: ${show ? "block" : "none"};
  box-shadow: 0px 3px 16px #00000029;
  padding: 0 15px;
  z-index: 10000000;
  ${[
        breakpoints.down('sm')
    ]} {
    background-color: ${neutral.white};
    border-top:0px;
    top:80px;
    position:fixed;
    padding-bottom:80px;
    left:0px;
    width:100vw;
    height:100vh;
    display: ${show ? "flex" : "none"};
    flex-direction:column;
    flex-wrap:wrap;
    justify-content:space-between;
  } 
`);
const $5c0fb5c4fb6f6801$export$8764249734c4a735 = ()=>{
    const [showMenu, setShowMenu] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const toggleMenu = ()=>setShowMenu((prev)=>!prev);
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const checkIfClickedOutside = (e)=>{
            if (showMenu && ref.current && !ref.current.contains(e.target)) setShowMenu(false);
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return ()=>{
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [
        showMenu
    ]);
    const handleOnClick = ()=>{
        dispatch((0, $c89d887792446c86$export$c8aadf3621e41efb)('en-US'));
        dispatch((0, $c89d887792446c86$export$d8b4e4fbb23eb316)('US'));
        history.push('/');
        setShowMenu(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
        position: 'relative',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                disableRipple: true,
                id: "localeSelector",
                "aria-label": "Locale Selector",
                onClick: toggleMenu,
                sx: {
                    padding: 0,
                    color: "primary.blue"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                    sx: {
                        backgroundColor: 'neutral.white',
                        color: 'secondary.main',
                        border: '1px solid',
                        borderColor: 'primary.main',
                        height: "32px",
                        width: "32px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        component: 'img',
                        sx: {
                            objectFit: 'cover'
                        },
                        alt: "usa",
                        height: "32px",
                        width: "32px",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports)))
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($5c0fb5c4fb6f6801$var$Menu, {
                show: showMenu,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                    role: "listitem",
                    display: "grid",
                    justifyContent: "center",
                    alignitems: "center",
                    my: "20px",
                    children: locale === 'en-US' || locale === '' ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "https://ModernaDirect.ch",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9Lykx.default), {
                            disableRipple: true,
                            id: "Switzerland",
                            "aria-label": "Switzerland",
                            sx: {
                                padding: 0,
                                color: "primary.blue",
                                gap: '12px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                    sx: {
                                        backgroundColor: 'neutral.white',
                                        color: 'secondary.main',
                                        border: '1px solid',
                                        borderColor: 'primary.main',
                                        height: "32px",
                                        width: "32px"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                                        component: 'img',
                                        sx: {
                                            objectFit: 'cover'
                                        },
                                        alt: "switzerland",
                                        height: "32px",
                                        width: "32px",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dea8353449714ce1$exports)))
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: 'p1',
                                    color: 'primary.main',
                                    children: "Switzerland"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9Lykx.default), {
                        disableRipple: true,
                        id: "USA",
                        "aria-label": "USA",
                        onClick: handleOnClick,
                        sx: {
                            padding: 0,
                            color: "primary.blue",
                            gap: '12px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                sx: {
                                    backgroundColor: 'neutral.white',
                                    color: 'secondary.main',
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    height: "32px",
                                    width: "32px"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                                    component: 'img',
                                    sx: {
                                        objectFit: 'cover'
                                    },
                                    alt: "usa",
                                    height: "32px",
                                    width: "32px",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports)))
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'p1',
                                color: 'primary.main',
                                children: "USA"
                            })
                        ]
                    })
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");








const $bebe1cbb5a309c8c$export$c0d00f01c39a087d = {
    issuer: "https://auth.modernatx.com/oauth2/default",
    clientId: "0oa3vyw7lehaJYmPn697",
    redirectUri: window.location.origin + '/login/callback',
    scopes: [
        'openid',
        'profile',
        'email'
    ],
    pkce: true
};


const $2b3afbf3d58201de$var$baseUrl = "https://api.modernadirect.com";
const $2b3afbf3d58201de$var$authAxiosInstance = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $2b3afbf3d58201de$var$baseUrl,
    headers: {
        "Content-Type": "application/json"
    }
});
const $2b3afbf3d58201de$var$getOktaAuth = ()=>{
    const { state: state } = (0, $b6fcb3bf036a7cae$exports.urlParamsToObject)(window.location.search);
    return new (0, $b6fcb3bf036a7cae$exports.OktaAuth)(Object.assign({}, (0, $bebe1cbb5a309c8c$export$c0d00f01c39a087d), {
        state: state
    }));
};
$2b3afbf3d58201de$var$authAxiosInstance.interceptors.request.use(async (req)=>{
    let oktaAccessToken = $2b3afbf3d58201de$var$getOktaAuth().getAccessToken();
    req.headers["Authorization"] = `Bearer ${oktaAccessToken}`;
    return req;
});
var $2b3afbf3d58201de$export$2e2bcd8739ae039 = $2b3afbf3d58201de$var$authAxiosInstance;



const $80596ff285da23b7$var$getBaseUrl = ()=>{
    let conditionalBaseUrl = "https://api.modernadirect.com";
    return conditionalBaseUrl;
};
const $80596ff285da23b7$var$noAuthAxiosInstance = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: $80596ff285da23b7$var$getBaseUrl(),
    headers: {
        "Content-Type": "application/json"
    }
});
var $80596ff285da23b7$export$2e2bcd8739ae039 = $80596ff285da23b7$var$noAuthAxiosInstance;


const $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/update-details`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$a0dcde0748e1668c = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/update`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$6de65cbed44a6a41 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getUserByEmail", async ({ emailAddress: emailAddress }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/by-email/${emailAddress}`,
            method: "GET",
            timeout: 75000 //75 seconds
        });
        return res.data;
    } catch (error) {
        if (error.code === 'ECONNABORTED') console.log("Request timed out", error);
        if (!error.response) throw error;
        return rejectWithValue(error.response);
    }
});
const $fdf4ab7ce1c873bd$export$e2e56406d7a7e765 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getUserByEmailForLogin", async ({ emailAddress: emailAddress }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/by-email/${emailAddress}/login`,
            method: "GET",
            timeout: 75000 //75 seconds
        });
        return res.data;
    } catch (error) {
        if (error.code === 'ECONNABORTED') console.log("Request timed out", error);
        if (!error.response) throw error;
        return rejectWithValue(error.response);
    }
});
const $fdf4ab7ce1c873bd$export$7cbf767827cd68ba = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getUser", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/v2/user/current`,
            method: "GET"
        });
        return res.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response);
    }
});
const $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getSapUserByEmail", async ({ emailAddress: emailAddress }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/by-email/${emailAddress}/sap`,
            method: "GET",
            timeout: 75000 //75 seconds
        });
        return res;
    } catch (error) {
        if (error.code === 'ECONNABORTED') console.log("Request timed out", error);
        if (!error.response) throw error;
        return rejectWithValue(error.response);
    }
});
const $fdf4ab7ce1c873bd$export$da6cf45ae1af792 = async ()=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/customer-segments`,
            method: "GET"
        });
        return res.data;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$c0733ef253e14774 = async (values)=>{
    const reqBody = {
        contactMethod: values?.contactMethod,
        organization: values?.organization,
        privacyPolicyConsented: values?.consented,
        supportCategory: values?.supportCategory,
        userEmailAddress: values?.email,
        userFullName: values?.fullname,
        userPhone: values?.phone,
        captcha: {
            userCaptchaResponse: values?.recaptchaToken
        }
    };
    try {
        const res = await (0, $80596ff285da23b7$export$2e2bcd8739ae039)({
            url: `userservice/contact`,
            method: "POST",
            data: reqBody
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$c562c31bf17d291e = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/onboard/contact-info`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$38d826a0f5215b04 = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/user/onboard/affiliate`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$c07c686062478869 = async (organizationId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/organization/${organizationId}/locations`,
            method: "GET"
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $fdf4ab7ce1c873bd$export$414ace4b9ab2a622 = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `userservice/organization/search`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};





const $ab5d3d3dee44dd4d$export$27c522ea05aff4b1 = {
    CREATE: {
        RESOURCE_QUOTA_EXCEEDED: 'RESOURCE_QUOTA_EXCEEDED_ERROR',
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    LIST: {
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    UPDATE: {
        RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    DESCRIBE: {
        RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    DELETE: {
        RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS'
    }
};
const $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb = {
    CAPTURE: {
        GENERIC_DECLINE: 'GENERIC_DECLINE',
        FRAUDULENT: 'FRAUDULENT',
        CARD_DECLINED: 'CARD_DECLINED',
        EXPIRED_CARD: 'EXPIRED_CARD',
        CAPTURE_FAILURE: 'CAPTURE_FAILURE',
        BALANCE_DATA_UNAVAILABLE: 'BALANCE_DATA_UNAVAILABLE',
        INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
        AMOUNT_TOO_LARGE: 'AMOUNT_TOO_LARGE'
    }
};


const $dc35deb6510c8f3e$export$ae929e66ad759b99 = {
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).CREATE.RESOURCE_QUOTA_EXCEEDED]: "You have reached the 10 maximum payment methods. Please delete a payment method to add a new one.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).CREATE.INVALID_REQUEST_PARAMETERS]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).CREATE.UNEXPECTED_ERROR]: "We have encountered technical difficulties. Please refresh the page to try again.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).LIST.INVALID_REQUEST_PARAMETERS]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).LIST.UNEXPECTED_ERROR]: "We have encountered technical difficulties. Please refresh the page to try again.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).UPDATE.INVALID_REQUEST_PARAMETERS]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).UPDATE.RESOURCE_NOT_FOUND]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).UPDATE.UNEXPECTED_ERROR]: "We have encountered technical difficulties. Please refresh the page to try again.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).DESCRIBE.RESOURCE_NOT_FOUND]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).DESCRIBE.UNEXPECTED_ERROR]: "We have encountered technical difficulties. Please refresh the page to try again.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).DELETE.RESOURCE_NOT_FOUND]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$27c522ea05aff4b1).DELETE.INVALID_REQUEST_PARAMETERS]: "We have encountered technical difficulties. Please contact us at 1-866-MODERNA.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.GENERIC_DECLINE]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.FRAUDULENT]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.CARD_DECLINED]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.EXPIRED_CARD]: "Your payment method has expired. Please use a different payment method to complete the payment.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.CAPTURE_FAILURE]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.BALANCE_DATA_UNAVAILABLE]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.INSUFFICIENT_FUNDS]: "Your payment method could not be processed. Please try again with a different payment method.",
    [(0, $ab5d3d3dee44dd4d$export$5dc8faabcbb777fb).CAPTURE.AMOUNT_TOO_LARGE]: "Transactions over $9,999,999.99 cannot be processed."
};


const $b1c33141448092cf$export$be58a38ca267dc5f = {
    PRICING: {
        PRICING_CALCULATION_ERROR: 'PRICING_CALCULATION_ERROR'
    },
    GENERAL: {
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS',
        RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND'
    },
    PAYMENTS: {
        GENERIC_DECLINE: 'GENERIC_DECLINE',
        FRAUDULENT: 'FRAUDULENT',
        CARD_DECLINED: 'CARD_DECLINED',
        EXPIRED_CARD: 'EXPIRED_CARD',
        ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
        CAPTURE_FAILURE: 'CAPTURE_FAILURE',
        BALANCE_DATA_UNAVAILABLE: 'BALANCE_DATA_UNAVAILABLE',
        INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
        CAPTURE_SUCCEEDED_EXCEPTIONALLY: 'CAPTURE_SUCCEEDED_EXCEPTIONALLY'
    },
    INVOICES: {
        RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
        INVOICE_ZIP_MISMATCH: 'INVOICE_ZIP_MISMATCH'
    }
};


const $86245de91bc36669$export$8156560a820db267 = {
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PRICING.PRICING_CALCULATION_ERROR]: "We've encountered an issue with your cart, please refresh the page. \
                                                    If the problem persists, contact customer support.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).GENERAL.INVALID_REQUEST_PARAMETERS]: "We've encountered an issue with your cart. Please return to the order form.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.GENERIC_DECLINE]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.FRAUDULENT]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.CARD_DECLINED]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.EXPIRED_CARD]: "Your payment method has expired. Please use a different payment method to place this order.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.ACCOUNT_INACTIVE]: "There was a problem validating the ACH Bank Transfer information you provided. Please retry with another payment method.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.CAPTURE_FAILURE]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.BALANCE_DATA_UNAVAILABLE]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).PAYMENTS.INSUFFICIENT_FUNDS]: "Your payment method could not be processed. Please add a new payment method and try again.",
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.INVOICE_ZIP_MISMATCH]: 'The billing zip code does not match the invoice number you entered.',
    [(0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.RESOURCE_NOT_FOUND]: 'We could not find this invoice.'
};


const $e46b4665478c1325$export$685636a04bc48eb4 = {
    LOCATIONS: {
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    AFFILIATE: {
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    CONTACT: {
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    },
    SEARCH: {
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
        THIRD_PARTY_SERVICE_ERROR: 'THIRD_PARTY_SERVICE_ERROR'
    },
    UPDATE: {
        INVALID_ADDRESS: 'INVALID_ADDRESS',
        THIRD_PARTY_SERVICE_INVALID_RESPONSE: 'THIRD_PARTY_SERVICE_INVALID_RESPONSE',
        ORG_CREATION_FAILED: 'ORG_CREATION_FAILED',
        INVALID_CONTRACT_DATA: 'INVALID_CONTRACT_DATA',
        MISSING_REQUIRED_FIELD: 'MISSING_REQUIRED_FIELD'
    },
    GET_USER: {
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        INVALID_REQUEST_PARAMETERS: 'INVALID_REQUEST_PARAMETERS',
        UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
    }
};


const $226808c00a74cb2e$export$acb079a59f258bff = {
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).LOCATIONS.USER_NOT_FOUND]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).LOCATIONS.AUTHENTICATION_FAILED]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).LOCATIONS.UNEXPECTED_ERROR]: "An unexpected error occurred. Please refresh the page and call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).AFFILIATE.USER_NOT_FOUND]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).AFFILIATE.AUTHENTICATION_FAILED]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).AFFILIATE.UNEXPECTED_ERROR]: "An unexpected error occurred. Please refresh the page and call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).CONTACT.USER_NOT_FOUND]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).CONTACT.AUTHENTICATION_FAILED]: "Your session has expired. Please log out and log back in.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).CONTACT.UNEXPECTED_ERROR]: "An unexpected error occurred. Please refresh the page and call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).SEARCH.UNEXPECTED_ERROR]: "An unexpected error occurred. Please refresh the page and call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).SEARCH.THIRD_PARTY_SERVICE_ERROR]: "Something went wrong on our end. Please try again or call 1-866-MODERNA.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).UPDATE.INVALID_ADDRESS]: "We are unable to validate this address. Please try again or call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).UPDATE.THIRD_PARTY_SERVICE_INVALID_RESPONSE]: "Something went wrong on our end. Please try again or call 1-866-MODERNA.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).UPDATE.ORG_CREATION_FAILED]: "We're unable to add this address to your account. Please enter a different address, or contact us at 1-866-MODERNA (1-866-663-3762) for assistance.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).UPDATE.INVALID_CONTRACT_DATA]: "We're unable to process your request. Please refresh the page, or contact us at 1-866-MODERNA (1-866-663-3762) for assistance.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).UPDATE.MISSING_REQUIRED_FIELD]: "We're unable to process your request. Please refresh the page, or contact us at 1-866-MODERNA (1-866-663-3762) for assistance.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).GET_USER.USER_NOT_FOUND]: "We could not find an account matching your details. If you don\u2019t have an account, please create one to get started.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).GET_USER.INVALID_REQUEST_PARAMETERS]: "We have encountered technical difficulties. Please try again or call 1-866-MODERNA if the issue persists.",
    [(0, $e46b4665478c1325$export$685636a04bc48eb4).GET_USER.UNEXPECTED_ERROR]: "An unexpected error occurred. Please refresh the page and call 1-866-MODERNA if the issue persists."
};


const $988a08ad6804f205$var$errorMessages = {
    ...$dc35deb6510c8f3e$export$ae929e66ad759b99,
    ...$86245de91bc36669$export$8156560a820db267,
    ...$226808c00a74cb2e$export$acb079a59f258bff
};
const $988a08ad6804f205$var$DEFAULT_ERROR_MESSAGE = 'An error occurred, the issue may be temporary. Please refresh the page and try again. If the issue persists, please contact us at 1-866-MODERNA.';
const $988a08ad6804f205$export$82f46aa4e6535a45 = (errorCode)=>{
    return $988a08ad6804f205$var$errorMessages[errorCode] || $988a08ad6804f205$var$DEFAULT_ERROR_MESSAGE;
};
const $988a08ad6804f205$export$fe0b41d6f39bfdf2 = (errorCode)=>{
    return $dc35deb6510c8f3e$export$ae929e66ad759b99[errorCode] || $988a08ad6804f205$var$DEFAULT_ERROR_MESSAGE;
};
const $988a08ad6804f205$export$d900853eac39ad08 = (errorCode)=>{
    return $226808c00a74cb2e$export$acb079a59f258bff[errorCode] || $988a08ad6804f205$var$DEFAULT_ERROR_MESSAGE;
};
const $988a08ad6804f205$export$d48a1f96ac937f95 = (errorCode)=>{
    return $988a08ad6804f205$export$d900853eac39ad08(errorCode);
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $bf4bd2be138c6b5b$export$1e3fa289c11cc7 = {
    IS_RESERVATIONS_ENABLED: {
        dev: true,
        uat: true,
        preview: true,
        prod: true
    },
    IS_RESERVATIONS_CONVERSION_ENABLED: {
        dev: false,
        uat: false,
        preview: false,
        prod: false
    },
    IS_OVERLAPPING_CONTRACT_ENABLED: {
        dev: true,
        uat: true,
        preview: false,
        prod: false
    },
    MULTI_INVOICE_PAY: {
        dev: true,
        uat: false,
        preview: false,
        prod: false
    },
    IS_AUTO_PAY_SCHEDULE_PAY_ENABLED: {
        dev: true,
        uat: false,
        preview: false,
        prod: false
    },
    SEE_AND_APPLY_CREDITS: {
        dev: true,
        uat: true,
        preview: true,
        prod: true
    },
    ONLINE_DISCOUNT: {
        dev: true,
        uat: false,
        preview: false,
        prod: false
    },
    IS_RESERVATIONS_NEXTGEN_BANNER_ENABLED: {
        dev: true,
        uat: true,
        preview: true,
        prod: true
    },
    IS_NEW_LOGIN_API_ENABLED: {
        dev: true,
        uat: true,
        preview: false,
        prod: false
    },
    IS_CUSTOMER_ACCESS_ENABLED: {
        dev: true,
        uat: false,
        preview: false,
        prod: false
    },
    IS_SITE_OUTAGE_BANNER_ENABLED: {
        dev: false,
        uat: false,
        preview: false,
        prod: false
    },
    IS_DELEGATE_ACCESS_ENABLED: {
        dev: true,
        uat: false,
        preview: false,
        prod: false
    }
};


const $b4f35ae695e9f7f6$var$allowedHostnames = {
    localhost: "dev",
    "127.0.0.1": "dev",
    "dev.modernadirect.com": "dev",
    "uat.modernadirect.com": "uat",
    "preview.modernadirect.com": "preview",
    "modernadirect.com": "prod"
};
const $b4f35ae695e9f7f6$export$57570b1603cf6adb = ()=>$b4f35ae695e9f7f6$var$allowedHostnames[window.location.hostname] || "dev";


const $b6ba493a4a5ce9f0$var$currentEnv = (0, $b4f35ae695e9f7f6$export$57570b1603cf6adb)();
const $b6ba493a4a5ce9f0$var$getFeatureFlags = ()=>{
    return Object.fromEntries(Object.keys((0, $bf4bd2be138c6b5b$export$1e3fa289c11cc7)).map((key)=>[
            key,
            (0, $bf4bd2be138c6b5b$export$1e3fa289c11cc7)[key][$b6ba493a4a5ce9f0$var$currentEnv] ?? false
        ]));
};
var $b6ba493a4a5ce9f0$export$2e2bcd8739ae039 = $b6ba493a4a5ce9f0$var$getFeatureFlags;


const $c941a90d6c8c81e4$export$a94f9e4f07f0c0a6 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $c941a90d6c8c81e4$export$ec0c43a58fca1a2 = ({ children: children })=>{
    const flags = (0, $acw62.useMemo)(()=>(0, $b6ba493a4a5ce9f0$export$2e2bcd8739ae039)(), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c941a90d6c8c81e4$export$a94f9e4f07f0c0a6.Provider, {
        value: {
            flags: flags
        },
        children: children
    });
};
const $c941a90d6c8c81e4$export$61acb772777ef35d = (flag)=>{
    const context = (0, $acw62.useContext)($c941a90d6c8c81e4$export$a94f9e4f07f0c0a6);
    if (!context) throw new Error("useFeatureFlag must be used within a FeatureFlagProvider");
    return context.flags[flag] ?? false;
};


const $dc2be56a937776c4$export$1d39dc5b47e56ff0 = ({ setInvalidPassword: setInvalidPassword, setProcessing: setProcessing })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const { setTransaction: setTransaction } = (0, $4629bfc79cc33037$export$dda119e8a3a60a4b)();
    const { setUserInfo: setUserInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)() || '';
    const { handleCloseModal: handleCloseModal, handleLoginError: handleLoginError } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const invalidCredentialsErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_CREDENTIALS");
    const invalidCredentialsError = invalidCredentialsErrorData && invalidCredentialsErrorData[0]?.fields?.message;
    const accountLockedErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "ACCOUNT_LOCKED");
    const accountLockedError = accountLockedErrorData && accountLockedErrorData[0]?.fields?.message;
    const newLoginApiEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_NEW_LOGIN_API_ENABLED");
    const closeLoginModal = ()=>{
        handleCloseModal();
    };
    const signIn = (0, $acw62.useCallback)(async (email, password, onSuccess, postLoginRedirectPath)=>{
        manageLocalStorage.clearItems();
        try {
            setProcessing(true);
            let newTransaction = await oktaAuth.idx.authenticate();
            setTransaction(newTransaction);
            if (newTransaction.status === (0, $b6fcb3bf036a7cae$exports.IdxStatus).SUCCESS) {
                setProcessing(false);
                oktaAuth.tokenManager.setTokens(newTransaction.tokens);
                await loadData(postLoginRedirectPath);
                onSuccess && onSuccess();
                closeLoginModal();
            } else {
                const newTransaction = await oktaAuth.idx.proceed({
                    username: email,
                    password: password
                });
                const { status: status, tokens: tokens, messages: messages } = newTransaction;
                if (status === (0, $b6fcb3bf036a7cae$exports.IdxStatus).SUCCESS) {
                    setProcessing(false);
                    oktaAuth.tokenManager.setTokens(tokens);
                    await loadData(postLoginRedirectPath);
                    onSuccess && onSuccess();
                    closeLoginModal();
                } else if (status === (0, $b6fcb3bf036a7cae$exports.IdxStatus).PENDING) {
                    if (localStorage.getItem('awaitingEmailVerification')) {
                        history.push(`/registration/email-verification`);
                        closeLoginModal();
                    }
                    setProcessing(false);
                    sessionStorage.removeItem("okta-transaction-storage");
                    if (messages) {
                        if (messages[0]?.i18n?.key === "errors.E0000004") setInvalidPassword(`Invalid email or password. Please check your credentials and try again.`);
                        else if (messages[0]?.i18n?.key === "errors.E0000119") setInvalidPassword(accountLockedError);
                        else setInvalidPassword(messages[0].message);
                    } else if (newTransaction?.nextStep?.name === "reenroll-authenticator" && newTransaction?.nextStep?.type === "password") setInvalidPassword(`Your password has expired. Click 'Reset your password' to update it.`);
                    else if (!newTransaction.status.tokens) setTimeout(()=>{
                        window.location.href = newTransaction?.nextStep?.href;
                    }, 100);
                    else setInvalidPassword(`We've encountered an issue with your account, please refresh the page. If the problem persists, contact customer support.`);
                } else if (status === (0, $b6fcb3bf036a7cae$exports.IdxStatus).TERMINAL) {
                    setProcessing(false);
                    sessionStorage.removeItem("okta-transaction-storage");
                    setInvalidPassword(messages[0].message);
                } else {
                    setProcessing(false);
                    sessionStorage.removeItem("okta-transaction-storage");
                    setInvalidPassword(invalidCredentialsError);
                }
            }
        } catch (err) {
            setProcessing(false);
            setInvalidPassword("");
        }
    }, [
        dispatch,
        oktaAuth,
        setTransaction,
        setUserInfo,
        history,
        setInvalidPassword,
        setProcessing
    ]);
    const fetchUserDetails = async (emailAddress)=>{
        try {
            const userByEmailResponse = newLoginApiEnabled ? await dispatch((0, $fdf4ab7ce1c873bd$export$e2e56406d7a7e765)({
                emailAddress: emailAddress
            })).unwrap() : await dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                emailAddress: emailAddress
            })).unwrap();
            await dispatch((0, $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55)({
                emailAddress: emailAddress
            })).unwrap();
            return userByEmailResponse;
        } catch (error) {
            handleLoginError((0, $988a08ad6804f205$export$d900853eac39ad08)(error?.data?.errorCode));
            throw error;
        }
    };
    const manageLocalStorage = {
        setItem: (key, value)=>localStorage.setItem(key, value),
        clearItems: ()=>{
            localStorage.clear();
            sessionStorage.clear();
        },
        setInvalidUser: ()=>{
            manageLocalStorage.clearItems();
            localStorage.setItem("invalidUser", true);
        }
    };
    const processUserStatus = async (userStatus, history, redirectPath)=>{
        switch(userStatus){
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).UNVERIFIED:
                manageLocalStorage.setItem('awaitingEmailVerification', 'true');
                history.push(`/registration/email-verification`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).VERIFIED:
                manageLocalStorage.setItem('awaitingEmailVerification', 'false');
                history.push(`/onboarding/contact-info`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_PERSON_COMPLETE:
                history.push(`/onboarding/contact-info`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_ORG_COMPLETE:
                history.push(`/onboarding/shipping-address`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_SHIP_COMPLETE:
                history.push(`/onboarding/billing-address`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_BILL_COMPLETE:
                history.push(`/onboarding/medical-identification`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ACTIVE:
                history.push(redirectPath || `/home`);
                break;
            default:
                manageLocalStorage.setInvalidUser();
                await oktaAuth.signOut();
        }
    };
    const updateUserConfiguration = (user)=>{
        localStorage.setItem("currentUser", JSON.stringify(user));
        setUserInfo(user);
        const isocode = user.country?.isocode || 'US';
        const locale = isocode === "DE" ? 'en-DE' : 'en-US';
        dispatch((0, $c89d887792446c86$export$c8aadf3621e41efb)(locale));
        dispatch((0, $c89d887792446c86$export$d8b4e4fbb23eb316)(isocode));
    };
    const loadData = (0, $acw62.useCallback)(async (postLoginRedirectPath)=>{
        setProcessing(true);
        try {
            const userDetails = await oktaAuth.getUser();
            let user = null;
            user = await fetchUserDetails(userDetails?.email);
            let userStatus = user?.status || user?.userStatus;
            dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(userStatus));
            await processUserStatus(userStatus, history, postLoginRedirectPath);
            updateUserConfiguration(user);
        } catch (error) {
            if (error?.data?.message) throw error.data.message;
            else {
                manageLocalStorage.setInvalidUser();
                await oktaAuth.signOut();
                setInvalidPassword(error);
            }
        } finally{
            setProcessing(false);
        }
    }, [
        dispatch,
        oktaAuth,
        setUserInfo,
        (0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41),
        (0, $fdf4ab7ce1c873bd$export$e2e56406d7a7e765)
    ]);
    return {
        signIn: signIn,
        loadData: loadData
    };
};



var $acw62 = parcelRequire("acw62");


const $877ce763a780cd51$var$BottomAppContainer = (0, $d8seH.default)('div')(({ theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>`
  height: 90px;
  padding: 20px 72px;
  display: grid;
  gap: 16px;
  grid-template-columns: auto 1fr auto auto;
  justify-content: space-between;
  align-items: center;
  background-color: ${neutral.white};
  box-shadow: 0px 3px 16px #00000029;
  @media(max-width: 620px){
    padding: 20px 20px;
  }
  ${[
        breakpoints.down('sm')
    ]} {
    height:80px;
    padding: 0px 30px;
    position: fixed;
    grid-template-columns: auto auto;
    z-index: 1000000;
    width: 100vw;
  }
`);
const $877ce763a780cd51$export$1bc76e15b8bdaa3e = ({ headerData: headerData, setProcessing: setProcessing })=>{
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const theme = (0, $14H9o.default)();
    const { handleOpenModal: handleOpenModal } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const desktop = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const location = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    const openLoginModal = (redirectPath)=>{
        handleOpenModal(redirectPath);
    };
    const { authState: authState, oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const productsLink = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
        to: "#",
        onClick: ()=>openLoginModal(`/${locale}/products`),
        id: "headerLink-products",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            fontSize: "18px",
            fontWeight: "500",
            fontStyle: "normal",
            fontFamily: "Aeonik Bold",
            color: "primary.main",
            lineHeight: "24px",
            children: "Products"
        })
    });
    const noop = ()=>null;
    const { signIn: signIn, loadData: loadData } = (0, $dc2be56a937776c4$export$1d39dc5b47e56ff0)({
        setInvalidEmail: noop,
        setInvalidPassword: noop,
        setProcessing: setProcessing,
        locale: locale
    });
    const [refreshAuthRunning, setRefreshAuthRunning] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!window.location.href.includes("callback") && authState && !authState.isAuthenticated && !refreshAuthRunning) {
            setRefreshAuthRunning(true);
            (async ()=>{
                try {
                    let session = await oktaAuth.session.get();
                    if (session?.status === "ACTIVE") // There is already an active Okta session, call the signIn function to refresh the website state.
                    // This is a bit of a hack and passes dummy values to signIn as they don't actually matter in this case.
                    // With some rework, this may be able to be managed more cleanly.
                    await signIn("dummy@email.com", "dummy", noop);
                } catch (e) {}
            })();
        }
    });
    const isOutageBannerEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_SITE_OUTAGE_BANNER_ENABLED");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($877ce763a780cd51$var$BottomAppContainer, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: `/${locale}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        id: "UnAuthLogo",
                        src: headerData?.logo?.fields.file?.url,
                        alt: "Moderna Logo",
                        width: "158px"
                    })
                }),
                desktop && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "32px",
                            sx: {
                                borderBottomColor: `${theme.palette.neutral.white} !important`,
                                '&.active': {
                                    borderBottomColor: `${theme.palette.primary.button} !important`,
                                    borderBottom: '3px solid'
                                }
                            },
                            children: [
                                productsLink,
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                    to: "#",
                                    onClick: ()=>openLoginModal(`/${locale}/orders`),
                                    id: "headerLink-order-history",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontSize: "18px",
                                        fontWeight: "500",
                                        fontStyle: "normal",
                                        fontFamily: "Aeonik Bold",
                                        color: "primary.main",
                                        lineHeight: "24px",
                                        children: "Order History"
                                    })
                                })
                            ]
                        }, "index"),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '16px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c0fb5c4fb6f6801$export$8764249734c4a735), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    component: 'div',
                                    sx: {
                                        border: "1px solid",
                                        borderColor: 'neutral.gray6',
                                        height: 45
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    "data-testid": "loginBtn",
                    leftIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c6dea190c14bdd7e$exports))),
                    onClick: ()=>openLoginModal(location?.pathname),
                    buttonType: "mds-tertiary",
                    sx: {
                        textTransform: "none"
                    },
                    disabled: isOutageBannerEnabled,
                    children: "Log in"
                })
            ]
        })
    });
};



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $d8seH = parcelRequire("d8seH");


var $c9Z8w = parcelRequire("c9Z8w");
var $794d5dbdb05a5402$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($794d5dbdb05a5402$exports, "__esModule", {
    value: true
});
$794d5dbdb05a5402$exports.default = void 0;

var $794d5dbdb05a5402$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $794d5dbdb05a5402$var$_default = $794d5dbdb05a5402$exports.default = (0, $794d5dbdb05a5402$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');


var $3e5225ec1ca9c141$exports = {};
$3e5225ec1ca9c141$exports = new URL("profile.ef97b464.svg", import.meta.url).toString();





var $724059c25d8988ef$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($724059c25d8988ef$exports, "__esModule", {
    value: true
});
$724059c25d8988ef$exports.default = void 0;

var $724059c25d8988ef$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $724059c25d8988ef$var$_default = $724059c25d8988ef$exports.default = (0, $724059c25d8988ef$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');





var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");
var $f1161d81aff98f4f$exports = {};
$f1161d81aff98f4f$exports = new URL("germany-flag.5fadc030.svg", import.meta.url).toString();




const $c430c1f4cb5950cf$var$LinkContainer = (0, $d8seH.default)('div')(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${primary.main};
    gap: 30px;
    ${[
        breakpoints.down('sm')
    ]} {
      display: grid;
      grid-template-columns:1fr;
      justify-content: flex-start;
    }
  `);
const $c430c1f4cb5950cf$var$StyledBox = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
  padding-right: 30px;
  cursor: pointer;
  ${[
        breakpoints.down('sm')
    ]} {
    position: relative;
  }
`);
const $c430c1f4cb5950cf$var$Menu = (0, $d8seH.default)('ul')(({ show: show, theme: { palette: { primary: primary, neutral: neutral, secondary: secondary }, breakpoints: breakpoints } })=>`
  position: absolute;
  top: 90px;
  right: 80px;
  background-color: ${secondary.main};
  border-top: 3px solid ${primary.blue};
  border-radius: 0px 0px 16px 16px;
  width: 230px;
  display: ${show ? "block" : "none"};
  box-shadow: 0px 3px 16px #00000029;
  padding: 0 15px;
  z-index: 10000000;
  ${[
        breakpoints.down('sm')
    ]} {
    background-color: ${neutral.white};
    border-top:0px;
    top:80px;
    position:fixed;
    padding-bottom:80px;
    left:0px;
    width:100vw;
    height:100vh;
    display: ${show ? "flex" : "none"};
    flex-direction:column;
    flex-wrap:wrap;
    justify-content:space-between;
  } 
`);
const $c430c1f4cb5950cf$var$ActionsContainer = (0, $d8seH.default)('div')(({ theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>`
  margin-top: 0px;
  height: 90px;
  padding: 20px 72px;
  position: relative;
  z-index: 999;
  display: grid;
  gap: 8px;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  background-color: ${neutral.white};
  box-shadow: 0px 3px 16px #00000029;
  @media(max-width: 620px){
    margin-top:0px;
    padding: 20px 20px;
  }
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 0px;
    height:80px;
    padding: 0px;
    position: fixed;
    grid-template-columns: auto auto;
    z-index: 1000000;
    width: 100vw;
    justify-content: space-between;
    padding: 15px;
  }
  ${[
        breakpoints.down('lg')
    ]} {
    padding: 20px 32px;
  }
  `);
const $c430c1f4cb5950cf$export$7c1bfb21e7af5d03 = ({ headerData: headerData })=>{
    const [showMenu, setShowMenu] = (0, $acw62.useState)(false);
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const theme = (0, $14H9o.default)();
    const desktop = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const ref = (0, $acw62.useRef)();
    const { pathname: activeRoute } = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        const checkIfClickedOutside = (e)=>{
            if (showMenu && ref.current && !ref.current.contains(e.target)) setShowMenu(false);
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return ()=>{
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [
        showMenu
    ]);
    const logOut = async ()=>{
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage
        await oktaAuth.signOut();
    };
    const toggleMenu = ()=>setShowMenu((prev)=>!prev);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c430c1f4cb5950cf$var$ActionsContainer, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                to: `/${locale}/home`,
                "data-testid": "logoLink",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c430c1f4cb5950cf$var$StyledBox, {
                    sx: {
                        cursor: 'pointer'
                    },
                    children: mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        id: "headerLogo",
                        src: headerData?.logo?.fields.file?.url,
                        alt: "Moderna Logo",
                        width: "164px",
                        onClick: ()=>{
                            setShowMenu(false);
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        id: "headerLogo",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1c9d33d7f337755d$exports))),
                        alt: "Moderna Logo",
                        width: "158px"
                    })
                })
            }),
            desktop && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: "relative",
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c430c1f4cb5950cf$var$LinkContainer, {
                    children: headerData?.navigationItems && headerData?.navigationItems?.map((item, index)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            className: `${activeRoute.includes(item?.fields?.link?.fields?.pageReference?.fields?.slug) ? 'active' : ''}`,
                            sx: {
                                borderBottomColor: `${theme.palette.neutral.white} !important`,
                                borderBottom: '3px solid',
                                '&.active': {
                                    borderBottomColor: `${theme.palette.primary.button} !important`,
                                    borderBottom: '3px solid'
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: `/${locale}/${item?.fields?.link?.fields?.pageReference?.fields?.slug}`,
                                id: `headerLink-${index}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontSize: "18px",
                                    fontWeight: "500",
                                    fontStyle: "normal",
                                    fontFamily: "Aeonik Bold",
                                    color: "primary.main",
                                    lineHeight: "24px",
                                    children: item?.fields?.label
                                })
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: 'flex',
                alignItems: "center",
                gap: 2,
                children: [
                    desktop && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                        sx: {
                            height: "32px",
                            width: "32px"
                        },
                        children: locale === 'en-DE' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            component: 'img',
                            sx: {
                                objectFit: 'cover'
                            },
                            alt: "germany",
                            height: "32px",
                            width: "32px",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f1161d81aff98f4f$exports)))
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            component: 'img',
                            sx: {
                                objectFit: 'cover'
                            },
                            alt: "usa",
                            height: "32px",
                            width: "32px",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports)))
                        })
                    }),
                    desktop && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: 'div',
                        sx: {
                            border: "1px solid",
                            borderColor: 'neutral.gray6',
                            height: 45
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        ref: ref,
                        children: [
                            mobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                id: "profileMenu",
                                "aria-label": "user account",
                                onClick: toggleMenu,
                                sx: {
                                    padding: 0,
                                    color: "primary.blue"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($794d5dbdb05a5402$exports))), {
                                    sx: {
                                        height: 30,
                                        width: 30
                                    },
                                    fontSize: "small"
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                alignItems: "center",
                                onClick: toggleMenu,
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3e5225ec1ca9c141$exports))),
                                        style: {
                                            padding: 5
                                        },
                                        height: "34",
                                        width: "34",
                                        alt: "user profile"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontSize: '16px',
                                        fontFamily: 'Aeonik Regular',
                                        color: "primary.main",
                                        "data-testid": "yourAccountHeader",
                                        children: "Your account"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($c430c1f4cb5950cf$var$Menu, {
                                show: showMenu,
                                children: [
                                    mobile && /*#__PURE__*/ (0, $ayMG0.jsx)($c430c1f4cb5950cf$var$LinkContainer, {
                                        children: headerData?.navigationItems && headerData?.navigationItems?.map((item, index)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    index === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: " "
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            borderTop: "1px solid #c0c0c0"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                        style: {
                                                            display: 'flex',
                                                            justifyContent: "space-between",
                                                            paddingTop: '20px'
                                                        },
                                                        id: `headerLink-${index}`,
                                                        to: `/${locale}/${item?.fields?.link?.fields?.pageReference?.fields?.slug}`,
                                                        onClick: toggleMenu,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                display: "flex",
                                                                variant: 'h5',
                                                                color: "primary.main",
                                                                children: item?.fields?.label
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($724059c25d8988ef$exports))), {
                                                                sx: {
                                                                    color: "primary.blue"
                                                                }
                                                            })
                                                        ]
                                                    }, index)
                                                ]
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "20px",
                                                children: [
                                                    mobile && locale === 'en-DE' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            height: "32px",
                                                            width: "32px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            component: 'img',
                                                            sx: {
                                                                objectFit: 'cover'
                                                            },
                                                            alt: "germany",
                                                            height: "32px",
                                                            width: "32px",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f1161d81aff98f4f$exports))),
                                                            title: "Germany"
                                                        })
                                                    }) : mobile && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            height: "32px",
                                                            width: "32px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            component: 'img',
                                                            sx: {
                                                                objectFit: 'cover',
                                                                height: '32px',
                                                                width: '32px'
                                                            },
                                                            alt: "usa",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                            title: "USA"
                                                        })
                                                    }),
                                                    mobile && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                        variant: 'p1',
                                                        children: locale === 'en-DE' ? 'Germany' : 'US'
                                                    })
                                                ]
                                            }),
                                            locale === 'en-US' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                        component: 'li',
                                                        py: '15px',
                                                        borderBottom: {
                                                            xs: `1px solid #c0c0c0`,
                                                            sm: '0'
                                                        },
                                                        display: "flex",
                                                        gap: 1,
                                                        color: 'neutral.main',
                                                        id: "profileCard",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                            style: {
                                                                display: 'flex',
                                                                justifyContent: 'space-between'
                                                            },
                                                            to: `/${locale}/my-profile`,
                                                            onClick: toggleMenu,
                                                            "data-testid": "profileOption",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3e5225ec1ca9c141$exports))),
                                                                    style: {
                                                                        padding: 5
                                                                    },
                                                                    height: "34",
                                                                    width: "34",
                                                                    alt: "user profile"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    variant: 'p1',
                                                                    color: "primary.main",
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    ml: 1,
                                                                    children: "Profile"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                        component: 'li',
                                                        py: '15px',
                                                        borderBottom: {
                                                            xs: `1px solid #c0c0c0`,
                                                            sm: '0'
                                                        },
                                                        display: "flex",
                                                        gap: 1,
                                                        color: 'neutral.main',
                                                        id: "billingInvoicesCard",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                                            style: {
                                                                display: 'flex',
                                                                justifyContent: 'space-between'
                                                            },
                                                            to: `/${locale}/your-account/invoices-and-payments`,
                                                            onClick: toggleMenu,
                                                            "data-testid": "billingInvoicesOption",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                variant: 'p1',
                                                                color: "primary.main",
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                ml: 1,
                                                                children: "Invoices and payments"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignitems: "center",
                                                mt: "40px",
                                                mb: {
                                                    xs: '60px',
                                                    sm: '30px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                                    id: "signOutBtn",
                                                    onClick: logOut,
                                                    "data-testid": "signOutButton",
                                                    children: "SIGN OUT"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$c430c1f4cb5950cf$export$7c1bfb21e7af5d03.propTypes = {
    headerData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};





const $d4e1dd1c69a101e6$export$3dc6eb3bf063d456 = {
    title: 'Header - US',
    logo: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
            },
            id: '5AKPoUN7gpAPK5qSmfp2Fx',
            type: 'Asset',
            createdAt: '2022-10-26T21:37:55.474Z',
            updatedAt: '2022-10-26T21:37:55.474Z',
            environment: {
                sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Moderna Logo - Transparent',
            description: '',
            file: {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($1c9d33d7f337755d$exports))),
                details: {
                    size: 11690,
                    image: {
                        width: 541,
                        height: 121
                    }
                },
                fileName: 'logo.png',
                contentType: 'image/png'
            }
        }
    },
    navigationItems: [
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '5X3uyXLesGZj35QP97uTMP',
                type: 'Entry',
                createdAt: '2021-12-08T18:29:04.756Z',
                updatedAt: '2023-06-01T05:21:29.355Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 15,
                revision: 6,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'navigationItem'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Products',
                label: 'Products',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '45nuNfadDYJFKSaiYoFq63',
                        type: 'Entry',
                        createdAt: '2021-12-09T23:39:01.226Z',
                        updatedAt: '2023-06-06T13:31:16.623Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 9,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'internalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Products Link',
                        label: 'Shop',
                        pageReference: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '2IDXH1eeS3uolefmMF0fSF',
                                type: 'Entry',
                                createdAt: '2023-06-05T22:01:10.998Z',
                                updatedAt: '2024-07-15T23:35:47.323Z',
                                environment: {
                                    sys: {
                                        id: 'master',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 9,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'page'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Category Landing Page',
                                title: 'Products',
                                slug: 'order-form',
                                seo: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '7DvUzBlYbnNYYiEDOMTFWP',
                                        type: 'Entry',
                                        createdAt: '2023-06-05T22:01:11.546Z',
                                        updatedAt: '2023-06-05T22:01:11.546Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 4,
                                        revision: 1,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'seo'
                                            }
                                        },
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        name: 'Category Landing Page - Compose: SEO'
                                    }
                                },
                                content: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '5uiGQIBBQR4HaehQd3qB9L',
                                        type: 'Entry',
                                        createdAt: '2023-06-05T22:01:11.623Z',
                                        updatedAt: '2023-09-07T20:51:21.016Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 14,
                                        revision: 4,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'categoryLandingPageTemplate'
                                            }
                                        },
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        name: 'Category Landing Page - Category Landing Page Template',
                                        modules: [
                                            {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '3lrvHdNg9iyh7Sd9q8I8SJ',
                                                    type: 'Entry',
                                                    createdAt: '2023-06-05T21:52:31.144Z',
                                                    updatedAt: '2023-09-07T21:06:56.918Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'master',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 14,
                                                    revision: 4,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'categoryProductTilesComponent'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'COVID-19 Vaccine Product Tiles Component',
                                                    commerceCategoryId: 'covid19Boosters',
                                                    productImagePlaceholder: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '4vXEuLzH5I48N8ikqlzo1a',
                                                            type: 'Asset',
                                                            createdAt: '2023-07-18T21:05:38.124Z',
                                                            updatedAt: '2023-07-18T21:05:38.124Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'master',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 8,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Product image unavailable 397x397',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/4vXEuLzH5I48N8ikqlzo1a/515a812a677106b89e599ed4903c45b9/product-image-unavailable.png',
                                                                details: {
                                                                    size: 14666,
                                                                    image: {
                                                                        width: 396,
                                                                        height: 397
                                                                    }
                                                                },
                                                                fileName: 'product-image-unavailable.png',
                                                                contentType: 'image/png'
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '1Ppy7GvsqeBmi4Kvy5HHgn',
                                                    type: 'Entry',
                                                    createdAt: '2023-06-05T21:34:48.717Z',
                                                    updatedAt: '2023-09-11T17:41:01.029Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'master',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 69,
                                                    revision: 17,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'categoryHeroBannerComponent'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'COVID-19 Vaccine Category Banner',
                                                    headline: 'COVID-19 Vaccine, mRNA 2023-2024 Formula',
                                                    message: {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        marks: [],
                                                                        value: 'Scroll down to make your product selection.',
                                                                        nodeType: 'text'
                                                                    }
                                                                ],
                                                                nodeType: 'paragraph'
                                                            }
                                                        ],
                                                        nodeType: 'document'
                                                    },
                                                    backgroundImage: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1tQWkkMWPtATssCwU912QD',
                                                            type: 'Asset',
                                                            createdAt: '2023-06-06T16:16:57.031Z',
                                                            updatedAt: '2023-07-28T17:19:35.133Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'master',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 12,
                                                            revision: 3,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'CLP Banner Background',
                                                            description: '',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1tQWkkMWPtATssCwU912QD/f713f6f568b90e1566168ef5bb76cf46/CLP_BG_VIAL_SYRINGE.png',
                                                                details: {
                                                                    size: 18363,
                                                                    image: {
                                                                        width: 1920,
                                                                        height: 660
                                                                    }
                                                                },
                                                                fileName: 'CLP_BG_VIAL_SYRINGE.png',
                                                                contentType: 'image/png'
                                                            }
                                                        }
                                                    },
                                                    mobileBackgroundImage: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '1rtVdADg6a3LlxoS530wiW',
                                                            type: 'Asset',
                                                            createdAt: '2023-06-07T15:26:07.005Z',
                                                            updatedAt: '2023-07-28T17:19:51.239Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'master',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 7,
                                                            revision: 2,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'CLP BG2 Vial Mobile-min',
                                                            description: '',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/1rtVdADg6a3LlxoS530wiW/0119aaf622c1bca557c8ea58153ce673/CLP_BG_VIAL_SYRINGE_MOBILE.png',
                                                                details: {
                                                                    size: 9097,
                                                                    image: {
                                                                        width: 390,
                                                                        height: 818
                                                                    }
                                                                },
                                                                fileName: 'CLP_BG_VIAL_SYRINGE_MOBILE.png',
                                                                contentType: 'image/png'
                                                            }
                                                        }
                                                    },
                                                    country: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '7sht7920U6vs3CLH2CUyaa',
                                                            type: 'Entry',
                                                            createdAt: '2023-05-18T03:23:50.744Z',
                                                            updatedAt: '2023-05-24T22:55:23.250Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'master',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 6,
                                                            revision: 2,
                                                            contentType: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'ContentType',
                                                                    id: 'country'
                                                                }
                                                            },
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            name: 'United States',
                                                            isocode: 'US',
                                                            flag: {
                                                                metadata: {
                                                                    tags: [],
                                                                    concepts: []
                                                                },
                                                                sys: {
                                                                    space: {
                                                                        sys: {
                                                                            type: 'Link',
                                                                            linkType: 'Space',
                                                                            id: 'n9bebhw263o0'
                                                                        }
                                                                    },
                                                                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                    type: 'Asset',
                                                                    createdAt: '2023-05-24T22:54:50.939Z',
                                                                    updatedAt: '2023-05-24T22:54:50.939Z',
                                                                    environment: {
                                                                        sys: {
                                                                            id: 'master',
                                                                            type: 'Link',
                                                                            linkType: 'Environment'
                                                                        }
                                                                    },
                                                                    publishedVersion: 5,
                                                                    revision: 1,
                                                                    locale: 'en-US'
                                                                },
                                                                fields: {
                                                                    title: 'usa flag',
                                                                    description: 'USA Flag',
                                                                    file: {
                                                                        url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                                                        details: {
                                                                            size: 2487,
                                                                            image: {
                                                                                width: 36,
                                                                                height: 26
                                                                            }
                                                                        },
                                                                        fileName: 'usa_flag.svg',
                                                                        contentType: 'image/svg+xml'
                                                                    }
                                                                }
                                                            },
                                                            locales: [
                                                                'en-US'
                                                            ]
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '4IptIiVqzfkBRBOp8NPHDZ',
                                                    type: 'Entry',
                                                    createdAt: '2023-06-05T22:24:17.726Z',
                                                    updatedAt: '2023-09-11T20:52:23.128Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'master',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 23,
                                                    revision: 6,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'categoryEducationalCardsComponent'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'COVID-19 Vaccine Category Educational Cards Component',
                                                    headline: 'Dosage and Administration',
                                                    subheadline: '(For intramuscular injection only)',
                                                    cards: [
                                                        {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Entry',
                                                                id: '7lPQBTQXzQaEt6nQNGwU4Z'
                                                            }
                                                        },
                                                        {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Entry',
                                                                id: 'hEvHJ3N6UOH3ueuvtWbKw'
                                                            }
                                                        },
                                                        {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Entry',
                                                                id: 'WpRN6qcUfwCg8HdXl8WWu'
                                                            }
                                                        },
                                                        {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Entry',
                                                                id: '1WbTwu4WfBg5xPwq6ptLXc'
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }
                },
                commerce: true
            }
        },
        {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '1AezMjnGahTY4DcaGulahM',
                type: 'Entry',
                createdAt: '2023-05-22T13:52:22.468Z',
                updatedAt: '2023-06-01T05:48:30.363Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'navigationItem'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Order History',
                label: 'Order History',
                link: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6xl3DTzE5hx9q2C0p9PvXf',
                        type: 'Entry',
                        createdAt: '2023-06-01T05:48:25.029Z',
                        updatedAt: '2023-06-01T05:48:25.029Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 6,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'internalLink'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Order History Internal Link',
                        label: 'Order History',
                        pageReference: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '4OLIozTDIHZZsTo1s7pjYj',
                                type: 'Entry',
                                createdAt: '2023-05-30T16:59:41.945Z',
                                updatedAt: '2023-06-01T05:48:19.579Z',
                                environment: {
                                    sys: {
                                        id: 'master',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 11,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'page'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Order History Page',
                                title: 'Order History',
                                slug: 'orders',
                                seo: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3XGtPu5vNnA1Dl3bL5Yp2S',
                                        type: 'Entry',
                                        createdAt: '2023-05-30T16:59:42.078Z',
                                        updatedAt: '2023-05-30T16:59:42.078Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 3,
                                        revision: 1,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'seo'
                                            }
                                        },
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        name: 'Order History Page - Compose: SEO'
                                    }
                                },
                                content: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '7KOCN0WVlOyMtC9QrWxhh9',
                                        type: 'Entry',
                                        createdAt: '2023-05-30T16:59:42.164Z',
                                        updatedAt: '2024-01-31T23:05:22.234Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 13,
                                        revision: 6,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'orderHistoryPageTempalte'
                                            }
                                        },
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        name: 'Order History Page - Order History Page Tempalte',
                                        modules: [
                                            {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: '67Cgp0ms6SZIQsWBrKb6LD',
                                                    type: 'Entry',
                                                    createdAt: '2023-06-30T04:15:43.114Z',
                                                    updatedAt: '2023-07-31T18:07:27.558Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'master',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 22,
                                                    revision: 5,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'orderHIstoryBannerComponent'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Order History Banner Component',
                                                    headline: 'Order History',
                                                    backgroundImage: {
                                                        metadata: {
                                                            tags: [],
                                                            concepts: []
                                                        },
                                                        sys: {
                                                            space: {
                                                                sys: {
                                                                    type: 'Link',
                                                                    linkType: 'Space',
                                                                    id: 'n9bebhw263o0'
                                                                }
                                                            },
                                                            id: '5zfGJA7or5WGcLdYi4Qde',
                                                            type: 'Asset',
                                                            createdAt: '2022-10-28T18:53:29.208Z',
                                                            updatedAt: '2022-10-28T18:53:29.208Z',
                                                            environment: {
                                                                sys: {
                                                                    id: 'master',
                                                                    type: 'Link',
                                                                    linkType: 'Environment'
                                                                }
                                                            },
                                                            publishedVersion: 6,
                                                            revision: 1,
                                                            locale: 'en-US'
                                                        },
                                                        fields: {
                                                            title: 'Banner BG Strand Top',
                                                            description: '',
                                                            file: {
                                                                url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                                details: {
                                                                    size: 47693,
                                                                    image: {
                                                                        width: 1920,
                                                                        height: 511
                                                                    }
                                                                },
                                                                fileName: 'Banner BG Strand Top .png',
                                                                contentType: 'image/png'
                                                            }
                                                        }
                                                    },
                                                    orderStatusLabel: [
                                                        'PENDING',
                                                        'DELIVERED'
                                                    ],
                                                    totalOrdersLabel: 'TOTAL ORDERS',
                                                    totalOrdersDropdownOptions: [
                                                        'Last 30 Days',
                                                        'Last 60 Days',
                                                        'Last 90 Days',
                                                        'Last Year'
                                                    ],
                                                    orderHistoryCardOrdersLabel: 'Orders',
                                                    orderHistoryCardSinceLabel: 'Since'
                                                }
                                            },
                                            {
                                                metadata: {
                                                    tags: [],
                                                    concepts: []
                                                },
                                                sys: {
                                                    space: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'Space',
                                                            id: 'n9bebhw263o0'
                                                        }
                                                    },
                                                    id: 'aGMNjo382dbe0mWwl0j73',
                                                    type: 'Entry',
                                                    createdAt: '2023-06-30T04:07:27.031Z',
                                                    updatedAt: '2024-05-24T01:05:09.960Z',
                                                    environment: {
                                                        sys: {
                                                            id: 'master',
                                                            type: 'Link',
                                                            linkType: 'Environment'
                                                        }
                                                    },
                                                    publishedVersion: 71,
                                                    revision: 22,
                                                    contentType: {
                                                        sys: {
                                                            type: 'Link',
                                                            linkType: 'ContentType',
                                                            id: 'orderHIstoryTableComponent'
                                                        }
                                                    },
                                                    locale: 'en-US'
                                                },
                                                fields: {
                                                    title: 'Order History Table Component',
                                                    headerLabel: 'Orders',
                                                    modernaIdColumnLabel: 'MODERNA ORDER ID',
                                                    referenceIdColumnLabel: 'MCKESSON(RXC) SHIPPING ID',
                                                    subtotalColumnLabel: 'SUBTOTAL AMOUNT',
                                                    poNumberColumnLabel: 'PO Number',
                                                    datePlacedColumnLabel: 'DATE PLACED',
                                                    deliveryLocationColumnLabel: 'DELIVERY LOCATION',
                                                    orderStatusColumnLabel: 'STATUS',
                                                    totalOrdersLabel: 'TOTAL ORDERS',
                                                    pendingStatusLabel: 'Pending',
                                                    deliveredStatusLabel: 'Delivered',
                                                    ordersText: 'Orders',
                                                    disclaimerMessageBody: 'Selected shipping dates are subject to change depending on product availability. We will notify you of any changes.',
                                                    disclaimerMessage: {
                                                        data: {},
                                                        content: [
                                                            {
                                                                data: {},
                                                                content: [
                                                                    {
                                                                        data: {},
                                                                        marks: [],
                                                                        value: 'Pricing is subject to change. For contracted customers, contract price will be reflected at time of invoicing. For questions about pricing, contact your Moderna Account Manager or Moderna customer service.',
                                                                        nodeType: 'text'
                                                                    }
                                                                ],
                                                                nodeType: 'paragraph'
                                                            }
                                                        ],
                                                        nodeType: 'document'
                                                    },
                                                    actionLabel: 'ACTIONS',
                                                    reservationTitle: 'Reservations'
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }
                },
                commerce: true
            }
        }
    ],
    country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
                sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
                sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                        details: {
                            size: 2487,
                            image: {
                                width: 36,
                                height: 26
                            }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            locales: [
                'en-US'
            ]
        }
    }
};


const $eb46bff18d3ea32c$var$NonPrintableWrapper = (0, $d8seH.default)('div')`
  @media print {
    display: none;
  }
`;
const $eb46bff18d3ea32c$var$Header = ({ authenticated: authenticated = false, setProcessing: setProcessing })=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($eb46bff18d3ea32c$var$NonPrintableWrapper, {
            children: localStorage.getItem("currentUser") && localStorage.getItem("currentUser") !== "undefined" && authState?.isAuthenticated || authenticated ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c430c1f4cb5950cf$export$7c1bfb21e7af5d03), {
                headerData: (0, $d4e1dd1c69a101e6$export$3dc6eb3bf063d456)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $877ce763a780cd51$export$1bc76e15b8bdaa3e), {
                headerData: (0, $d4e1dd1c69a101e6$export$3dc6eb3bf063d456),
                setProcessing: setProcessing
            })
        })
    });
};
var $eb46bff18d3ea32c$export$2e2bcd8739ae039 = $eb46bff18d3ea32c$var$Header;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2iAqv = parcelRequire("2iAqv");

var $d8seH = parcelRequire("d8seH");

var $gd5y7 = parcelRequire("gd5y7");
var $i32L9 = parcelRequire("i32L9");
var $OEVqP = parcelRequire("OEVqP");
var $cX7V2 = parcelRequire("cX7V2");

const $47bfe24076768d6a$var$StyledInputLabel = (0, $d8seH.default)((0, $OEVqP.default))(({ error: error = false, theme: { palette: { primary: primary, status: status }, breakpoints: breakpoints }, className: className })=>({
        fontFamily: className === 'organizationRole' ? "Aeonik Regular !important" : "Aeonik Bold !important",
        top: "32px !important",
        fontSize: className === 'cart' && '10px',
        transform: className === 'cart' && 'none',
        translate: className === 'cart' && 'none',
        "&.Mui-error": {
            color: `${error === "true" ? status.error : primary.main}`
        },
        "&.cart": {
            position: 'inherit',
            top: '0 !important',
            color: `${error === "true" ? status.error : primary.main}`,
            "&.Mui-error": {
                color: `${error === true ? status.error : primary.main}`
            }
        },
        "&.newAddressForm": {
            fontSize: '20px',
            top: '12px !important',
            [breakpoints.down('sm')]: {
                marginTop: '10px !important',
                marginBottom: '10px !important'
            }
        },
        "&.organizationRole": {
            fontSize: '22px',
            fontWeight: 700,
            top: '8px !important',
            [breakpoints.down('sm')]: {
                marginTop: '10px !important',
                marginBottom: '10px !important'
            }
        }
    }));
const $47bfe24076768d6a$var$StyledFormHelperText = (0, $d8seH.default)((0, $i32L9.default))(({ theme: { palette: { status: status } } })=>({
        fontFamily: "Aeonik Regular",
        marginTop: '4px !important',
        "&.Mui-error": {
            color: status.error
        }
    }));
const $47bfe24076768d6a$var$CustomSelect = (0, $d8seH.default)((0, $cX7V2.default))(({ error: error = false, theme: { palette: { neutral: neutral, primary: primary, secondary: secondary, status: status }, breakpoints: breakpoints, className: className } })=>({
        backgroundColor: 'transparent',
        "&": {
            width: "100%",
            marginTop: "50px !important",
            height: '30px',
            fontFamily: "Aeonik Regular, Arial",
            "&:before": {
                borderBottom: `2px solid ${neutral.gray2}`
            },
            "&:after": {
                borderBottom: `2px solid ${neutral.gray2}`
            },
            "&&.myProfile": {
                margin: "0 !important",
                width: "75%",
                [breakpoints.down('sm')]: {
                    width: "100%",
                    paddingRight: "16px !important"
                }
            },
            "& .MuiSvgIcon-root path": {
                fill: "primary.main"
            }
        },
        "&.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: `${error === "true" ? status.error : neutral.gray2}`,
            borderRadius: '0',
            fontFamily: 'Aeonik Regular'
        },
        '& .MuiSelect-select': {
            '&.MuiInputBase-input.MuiInput-input:focus': {
                backgroundColor: 'transparent'
            },
            fontFamily: 'Aeonik Regular',
            '&.MuiInputBase-input.MuiInput-input': {
                padding: '5px 20px 5px 10px'
            }
        },
        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderBottom: `1px solid ${error === "true" ? status.error : neutral.gray2}`,
            borderRadius: '0'
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: neutral.gray2,
            borderRadius: '0'
        },
        "& .MuiSelect-icon": {
            color: `${error === "true" ? status.error : secondary.graphical}`,
            marginRight: '10px'
        },
        "&.cart": {
            border: `1px solid ${error === true ? status.error : neutral.gray2}`,
            borderRadius: 5,
            height: '38px',
            marginTop: '9px !important',
            position: 'inherit',
            "&:before": {
                border: 'none !important'
            },
            "&:after": {
                border: 'none !important'
            },
            "&:hover": {
                borderColor: `${error === true ? primary.red : neutral.gray2}`,
                boxShadow: '0px 3px 6px #22222229'
            },
            "& .MuiSelect-icon": {
                color: `${error === true ? status.error : secondary.graphical}`,
                marginRight: '10px'
            }
        },
        "&.border": {
            border: `1px solid ${error === true ? status.error : neutral.gray2}`,
            borderRadius: 5,
            marginTop: '9px !important',
            height: '48px',
            position: 'inherit',
            "&:before": {
                border: 'none !important'
            },
            "&:after": {
                border: 'none !important'
            },
            "&:hover": {
                borderColor: `${error === true ? primary.red : neutral.gray2}`,
                boxShadow: '0px 3px 6px #22222229'
            },
            "& .MuiSelect-icon": {
                color: `${error === true ? status.error : neutral.gray7}`,
                marginRight: '10px'
            }
        },
        "&.addressForm": {
            '& .MuiSelect-select': {
                '&.MuiInputBase-input.MuiInput-input': {
                    padding: '0px 80px 0px 0px'
                }
            }
        },
        "&.newAddressForm": {
            border: `1px solid ${error === true ? status.error : neutral.gray7}`,
            borderRadius: 5,
            marginTop: '40px !important',
            height: '49px',
            position: 'inherit',
            textAlign: 'left',
            "&:before": {
                border: 'none !important'
            },
            "&:after": {
                border: 'none !important'
            },
            "&:hover": {
                borderColor: `${error === true ? primary.red : neutral.gray7}`,
                boxShadow: '0px 3px 6px #22222229'
            },
            "& .MuiSelect-icon": {
                color: `${error === true ? status.error : neutral.gray7}`,
                marginRight: '10px'
            }
        },
        "&.organizationRole": {
            border: `1px solid ${error === true ? status.error : neutral.gray7}`,
            borderRadius: 5,
            marginTop: '40px !important',
            height: '47px',
            position: 'inherit',
            textAlign: 'left',
            "&:before": {
                border: 'none !important'
            },
            "&:after": {
                border: 'none !important'
            },
            "&:hover": {
                borderColor: `${error === true ? primary.red : neutral.gray7}`,
                boxShadow: '0px 3px 6px #22222229'
            },
            "& .MuiSelect-icon": {
                color: `${error === true ? status.error : neutral.gray7}`,
                marginRight: '10px'
            }
        }
    }));
const $47bfe24076768d6a$var$defaultMenuItemStyle = {
    '&.Mui-selected': {
        backgroundColor: 'secondary.main',
        color: 'primary.main',
        fontFamily: 'Aeonik Bold',
        '&:hover': {
            color: 'primary.main',
            backgroundColor: 'secondary.main'
        }
    },
    '&:hover': {
        fontFamily: 'Aeonik Bold',
        backgroundColor: 'secondary.main'
    },
    fontFamily: 'Aeonik Regular',
    fontSize: '14px'
};
const $47bfe24076768d6a$export$124e49603add0284 = ({ helperText: helperText, label: label, options: options, disabledOptions: disabledOptions, error: error = false, formSx: formSx, menuPropsSx: menuPropsSx, menuItemStyleSx: menuItemStyleSx, placeholder: placeholder, required: required = false, sx: sx, onChangeHandler: onChangeHandler, value: value, className: className, onOpenHandler: onOpenHandler = (e)=>false, disabled: disabled = false })=>{
    const menuitemStyle = {
        ...$47bfe24076768d6a$var$defaultMenuItemStyle,
        ...menuItemStyleSx
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
            className: className,
            required: required,
            focused: true,
            variant: "standard",
            sx: {
                ...formSx,
                padding: 0
            },
            error: error,
            fullWidth: true,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($47bfe24076768d6a$var$StyledInputLabel, {
                    disableAnimation: true,
                    id: `label-${label?.replace(/\s+/g, '')}`,
                    className: className,
                    error: error,
                    sx: {
                        color: 'neutral.gray2'
                    },
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($47bfe24076768d6a$var$CustomSelect, {
                    required: required,
                    placeholder: 'state',
                    error: error,
                    labelId: `label-${label?.replace(/\s+/g, '')}`,
                    id: label?.replace(/\s+/g, ''),
                    className: className ?? '',
                    value: value,
                    label: label,
                    onChange: (e)=>onChangeHandler(e.target.value),
                    onOpen: (e)=>onOpenHandler(e),
                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($3a68ff4fb6e888aa$exports))),
                    inputProps: {
                        "data-testid": "select-input"
                    },
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                boxShadow: '0px 3px 6px #00000029',
                                borderBottomLeftRadius: 16,
                                borderBottomRightRadius: 16,
                                maxHeight: 200,
                                maxWidth: 'fit-content',
                                overflow: 'auto',
                                right: '16px',
                                ...menuPropsSx
                            }
                        }
                    },
                    sx: {
                        '& legend': {
                            display: 'none'
                        },
                        '& fieldset': {
                            top: '10px'
                        },
                        boxSizing: 'border-box',
                        ...sx,
                        color: value === placeholder?.id && 'gray'
                    },
                    children: [
                        options?.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                sx: menuitemStyle,
                                id: value,
                                value: value,
                                children: value === '' ? '-' : label
                            }, value)),
                        disabledOptions && disabledOptions?.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                sx: {
                                    ...menuitemStyle,
                                    display: 'none'
                                },
                                id: value,
                                value: value,
                                children: value === '' ? '-' : label
                            }, value)),
                        placeholder && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                            sx: {
                                ...menuitemStyle,
                                display: 'none'
                            },
                            id: placeholder.id,
                            value: placeholder.id,
                            children: placeholder.value
                        }, placeholder.id)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($47bfe24076768d6a$var$StyledFormHelperText, {
                    sx: {
                        marginTop: 0
                    },
                    children: helperText
                })
            ]
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $118QM = parcelRequire("118QM");
var $93cf4f4850471977$exports = {};
$93cf4f4850471977$exports = new URL("crossIcon.47cea1b8.svg", import.meta.url).toString();



var $3bYfT = parcelRequire("3bYfT");
const $9f75b7133f7f7752$var$style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    boxShadow: 24,
    zIndex: 10,
    borderRadius: "24px",
    padding: "18px 22px 34px 22px",
    outline: "none",
    textAlign: "center",
    "@media screen and (max-width: 500px)": {
        width: "80%",
        padding: "18px 22px 34px 22px"
    }
};
const $9f75b7133f7f7752$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    padding: {
        xs: '0 30px',
        sm: '0'
    },
    gap: {
        xs: '0',
        sm: '10px'
    }
};
const $9f75b7133f7f7752$export$2b77a92f1a5ad772 = ({ confirmationHandler: confirmationHandler, closeModalHandler: closeModalHandler, openModal: openModal = false, title: title, subtitle: subtitle, secondaryButtonLabel: secondaryButtonLabel, primaryButtonLabel: primaryButtonLabel, primaryButtonAttributes: primaryButtonAttributes })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $118QM.default), {
        sx: {
            textAlign: 'center'
        },
        open: openModal,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: $9f75b7133f7f7752$var$style,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "end",
                    id: "crossIcon",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        component: 'img',
                        sx: {
                            width: "25px",
                            height: "25px",
                            cursor: "pointer"
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($93cf4f4850471977$exports))),
                        onClick: closeModalHandler,
                        "data-testid": "crossicon"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h3',
                    color: "primary.main",
                    my: 2,
                    mx: "38px",
                    id: "modalTitle",
                    "data-testid": "title",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'p1',
                    color: "primary.main",
                    mt: 2,
                    sx: {
                        marginBottom: {
                            xs: '72px',
                            sm: '0'
                        }
                    },
                    id: "modalSubtitle",
                    children: subtitle
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "center",
                    sx: $9f75b7133f7f7752$var$buttonsContainerSxStyles,
                    children: [
                        secondaryButtonLabel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            id: "closeModal",
                            sx: {
                                marginTop: "32px"
                            },
                            buttonType: "secondary",
                            onClick: closeModalHandler,
                            "data-testid": "cancelBtn",
                            children: secondaryButtonLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            className: secondaryButtonLabel ? "confRemoveBtn" : "cancelBtn",
                            id: "confirm",
                            sx: {
                                marginTop: "32px",
                                marginBottom: {
                                    xs: '46px',
                                    sm: "0"
                                }
                            },
                            onClick: confirmationHandler,
                            ...primaryButtonAttributes,
                            "data-testid": "okBtn",
                            children: primaryButtonLabel
                        })
                    ]
                })
            ]
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $118QM = parcelRequire("118QM");


var $3bYfT = parcelRequire("3bYfT");


var $d8seH = parcelRequire("d8seH");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;



var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



const $97b20e56a8e4a085$var$CustomBox = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>({
        position: "absolute",
        top: "50%",
        marginLeft: "60%",
        transform: "translate(-50%, -50%)",
        width: "80%",
        backgroundColor: neutral.white,
        padding: "40px",
        paddingLeft: "8%",
        borderRadius: "24px",
        [breakpoints.down('sm')]: {
            marginLeft: "unset",
            transform: "translate(0,-50%)",
            width: "unset",
            padding: "24px"
        }
    }));
const $97b20e56a8e4a085$var$CrossIconContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  display: flex;
  justify-content: end;
  ${[
        breakpoints.down('sm')
    ]} {
    margin-bottom: 40px;
  }
`);
const $97b20e56a8e4a085$var$CrossIconComponent = (0, $d8seH.default)('img')`
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-top: -22px;
  margin-right: -22px;
`;
const $97b20e56a8e4a085$export$a5aa42ae11ebe35f = ({ isOpen: isOpen, closeModalHandler: closeModalHandler, externalLink: externalLink, checkBoxLabel: checkBoxLabel, onOpenLink: onOpenLink, buttonLabel: buttonLabel, type: type, ...props })=>{
    const [isChecked, setIsChecked] = (0, $acw62.useState)(false);
    const openExternalLink = ()=>{
        window.open(externalLink, '_blank');
        onOpenLink(false);
        if (isChecked) type === "extrenalLink" ? localStorage.setItem("dontRemindMeExternal", true) : localStorage.setItem("dontRemindMe", true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $118QM.default), {
            sx: {
                width: "80% !important",
                '@media screen and (max-width: 500px)': {
                    margin: '24px',
                    width: "unset !important"
                }
            },
            open: isOpen,
            "aria-labelledby": "modal-modal-title",
            "aria-describedby": "modal-modal-description",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($97b20e56a8e4a085$var$CustomBox, {
                sx: {
                    ...props?.modalCustomStyle
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($97b20e56a8e4a085$var$CrossIconContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($97b20e56a8e4a085$var$CrossIconComponent, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($93cf4f4850471977$exports))),
                            onClick: closeModalHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        id: "modal-modal-title",
                        variant: "h3",
                        component: "h2",
                        sx: props?.headingStyle,
                        children: props?.heading
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        id: "modal-modal-description",
                        sx: {
                            mt: 2,
                            fontFamily: "Aeonik Regular",
                            fontSize: "12px",
                            width: "80%",
                            color: "primary.main",
                            '@media screen and (max-width: 500px)': {
                                fontSize: '16px',
                                width: "unset"
                            }
                        },
                        children: props?.content
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                        sx: {
                            marginTop: "20px",
                            '@media screen and (max-width: 500px)': {
                                mt: 3,
                                mb: 3
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c576d11d36ade61d$export$48513f6b9f8ce62d), {
                            label: checkBoxLabel,
                            value: isChecked,
                            onChange: ()=>setIsChecked(!isChecked)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        onClick: openExternalLink,
                        "data-exit-link": externalLink,
                        sx: {
                            marginTop: '7px',
                            '@media screen and (max-width: 500px)': {
                                mb: 10
                            }
                        },
                        children: buttonLabel
                    })
                ]
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
var $12a26d70a091a9bc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($12a26d70a091a9bc$exports, "__esModule", {
    value: true
});
$12a26d70a091a9bc$exports.default = void 0;

var $12a26d70a091a9bc$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $12a26d70a091a9bc$var$_default = $12a26d70a091a9bc$exports.default = (0, $12a26d70a091a9bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');



var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");

var $4c2ed44525be3c33$exports = {};
$4c2ed44525be3c33$exports = new URL("taxExemptionIcon.1a723539.png", import.meta.url).toString();


var $6ec2a835cac4db26$exports = {};
$6ec2a835cac4db26$exports = new URL("prophylactic-vaccines-icon.158eef44.png", import.meta.url).toString();


var $155ce41b77e70709$exports = {};
$155ce41b77e70709$exports = new URL("mrnaNewsIcon.096a95d9.png", import.meta.url).toString();


const $fe37201f0d3351f1$export$1eef222eb1d1cc64 = {
    newsCards: [
        {
            title: "Tax Exemption Certificate Submission",
            headline: "Tax Exemption Certificate Submission: Submit your tax exemption certificates",
            link: "https://taxform.modernatx.com/",
            label: "Tax Exemption Certificate Submission",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4c2ed44525be3c33$exports)))
        },
        {
            title: "mRNA News Component",
            headline: "For more information about Moderna\u2019s mRNA platform",
            link: "https://www.modernatx.com/en-US/power-of-mrna/science-of-mrna",
            label: "mRNA News",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($155ce41b77e70709$exports)))
        },
        {
            title: "News on current Moderna COVID-19 Vaccines",
            headline: "For more information on the current Moderna COVID-19 vaccines",
            link: "https://eua.modernatx.com/",
            label: "Learn COVID-19 Vaccines",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports)))
        }
    ]
};


var $6534c7b7c4cf878c$exports = {};
$6534c7b7c4cf878c$exports = new URL("Banner_Strand.7b45fab2.png", import.meta.url).toString();


const $19ac86691a8229fd$var$BannerWrapper = (0, $d8seH.default)('div')(({ bgImageUrl: bgImageUrl, theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>`
    background: url(${bgImageUrl}) 0% 100% / 150% no-repeat;
    display: flex;
    float: right;
    height: 500px;
    background-position: right;
    width: 50%;
    ${[
        breakpoints.down('sm')
    ]} {
        float: none;
        height: 0px;
        background: none;
    }
    `);
const $19ac86691a8229fd$var$Card = (0, $d8seH.default)('div')(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    background-color: ${primary.white};
    border-radius: 14px;
    box-shadow: 0px 3px 6px #00000029;
    flex-grow: 1;
    padding: 22px;
    display: flex;
    width: 10px;
    justify-content: space-between;
    min-width: fit-content;
    ${[
        breakpoints.down('sm')
    ]} {
        min-width: 100% !important;
        flex-direction: column;
    }
`);
const $19ac86691a8229fd$export$97c3914aba751a18 = ({ ...props })=>{
    const [dataExternalModal, setDataExternalModal] = (0, $acw62.useState)(true);
    const remindMeExternal = localStorage.getItem("dontRemindMeExternal");
    (0, $acw62.useEffect)(()=>{
        if (remindMeExternal === "true") setDataExternalModal(false);
    }, [
        remindMeExternal
    ]);
    const handleRedirect = (url)=>{
        if ((0, $382eb84981692d3a$export$bdc112e4021a968d)(url) && !localStorage.getItem("dontRemindMeExternal")) {
            props?.setShowNavigationAlert(true);
            props?.setExternalLink(url);
            props?.setExternalLinkModalType("extrenalLink");
        } else {
            window.open(url, '_blank');
            props?.setShowNavigationAlert(false);
            props?.setExternalLink("");
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($19ac86691a8229fd$var$BannerWrapper, {
                bgImageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                "data-testid": "bannerimg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h2',
                ml: {
                    xs: '36px',
                    sm: '92px'
                },
                mt: {
                    xs: '60px',
                    sm: '48px'
                },
                color: "primary.main",
                "data-testid": "headline",
                children: "Resources"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                backgroundColor: "neutral.white",
                width: {
                    xs: '100%',
                    sm: '500px'
                },
                p: {
                    xs: '30px 32px 30px 36px',
                    sm: '30px 32px 30px 92px'
                },
                display: {
                    xs: 'grid',
                    sm: 'flex'
                },
                gap: 2,
                mb: '52px',
                children: (0, $fe37201f0d3351f1$export$1eef222eb1d1cc64)?.newsCards?.map((newscard, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($19ac86691a8229fd$var$Card, {
                        id: "newsCard" + index,
                        "data-testid": "newsCard",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: newscard?.imageUrl,
                                        alt: newscard?.title,
                                        style: {
                                            width: "45px",
                                            height: "45px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: 'p2',
                                        component: "div",
                                        mt: 2,
                                        mr: '20px',
                                        lineHeight: "20px",
                                        color: 'primary.main',
                                        id: "newsCardTitle",
                                        children: newscard?.headline
                                    })
                                ]
                            }),
                            newscard?.link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                alignSelf: "end",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    id: "cardBtn" + index,
                                    variant: "outlined",
                                    onClick: (e)=>handleRedirect(newscard?.link),
                                    "data-external-modal": dataExternalModal,
                                    "data-link-href": newscard?.link,
                                    sx: {
                                        width: "34px",
                                        height: "34px",
                                        color: "primary.main",
                                        backgroundColor: "none",
                                        border: "1px solid",
                                        borderColor: "primary.main",
                                        '&:hover': {
                                            color: 'neutral.white',
                                            backgroundColor: 'primary.blue',
                                            borderColor: "primary.blue"
                                        },
                                        '@media screen and (max-width: 500px)': {
                                            height: '48px',
                                            width: '48px'
                                        }
                                    },
                                    "aria-label": newscard?.label,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($12a26d70a091a9bc$exports))), {})
                                })
                            })
                        ]
                    }, index))
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");



const $b2f49807a46b303d$var$LoginCallback = ({ errorComponent: errorComponent, loadingElement: loadingElement = null, onAuthResume: onAuthResume })=>{
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [callbackError, setCallbackError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        oktaAuth.handleLoginRedirect().catch((e)=>{
            setCallbackError(e);
            history.push(`/${locale}/not-authorized`);
        });
    }, [
        oktaAuth,
        locale,
        onAuthResume,
        history
    ]);
    return loadingElement;
};
var $b2f49807a46b303d$export$2e2bcd8739ae039 = $b2f49807a46b303d$var$LoginCallback;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $cd9806e2064b4620$exports = {};
$cd9806e2064b4620$exports = new URL("crossIconBlack.9f2affb3.svg", import.meta.url).toString();



var $6cr7d = parcelRequire("6cr7d");
var $9Lykx = parcelRequire("9Lykx");
var $118QM = parcelRequire("118QM");
var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");
const $e8bacdab23dabef2$var$modalStyle = {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    minHeight: "20%",
    maxHeight: "90%",
    bgcolor: "background.paper",
    overflowY: "auto",
    boxShadow: 24,
    zIndex: 10,
    borderRadius: "24px",
    padding: "25px",
    outline: "none",
    textAlign: "center",
    "@media screen and (max-width: 500px)": {
        width: "80%"
    },
    position: 'relative'
};
const $e8bacdab23dabef2$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    padding: {
        xs: '0 15px',
        sm: '0'
    },
    gap: {
        xs: '0',
        sm: '10px'
    }
};
const $e8bacdab23dabef2$var$CrossIconButton = (0, $d8seH.default)((0, $9Lykx.default))(({ theme: theme })=>({
        position: 'absolute',
        top: '24px',
        right: '24px',
        width: "30px",
        height: "30px",
        color: "primary.main",
        backgroundColor: "none",
        borderRadius: 0,
        '&:hover &:focus': {
            background: 'none',
            border: 'none'
        },
        '&:focus-visible': {
            outline: '-webkit-focus-ring-color auto 1px'
        }
    }));
const $e8bacdab23dabef2$export$285171c9188af4ea = ({ closeModalHandler: closeModalHandler, openModal: openModal, title: title, modalContent: modalContent, style: externalStyle, dataTestId: dataTestId, showCloseButton: showCloseButton = true })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $118QM.default), {
        "data-testid": dataTestId || "modalComponent",
        sx: {
            textAlign: 'center'
        },
        open: openModal,
        slots: {
            backdrop: (0, $6cr7d.default)
        },
        slotProps: {
            backdrop: {
                onClick: closeModalHandler
            }
        },
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                ...$e8bacdab23dabef2$var$modalStyle,
                ...externalStyle
            },
            children: [
                showCloseButton && /*#__PURE__*/ (0, $ayMG0.jsx)($e8bacdab23dabef2$var$CrossIconButton, {
                    id: "crossIcon",
                    onClick: closeModalHandler,
                    "data-testid": `${dataTestId}-closeBtn`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        alt: "x",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cd9806e2064b4620$exports))),
                        "data-testid": "crossIconBlack",
                        height: "30px",
                        width: "30px"
                    })
                }),
                title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    id: "titleContainer",
                    display: "flex",
                    justifyContent: {
                        sm: 'left'
                    },
                    alignItems: {
                        xs: 'flex-start'
                    },
                    sx: $e8bacdab23dabef2$var$buttonsContainerSxStyles,
                    marginLeft: {
                        xs: "0px",
                        sm: "20px"
                    },
                    marginBottom: {
                        xs: "20px",
                        sm: "10px"
                    },
                    "data-testid": "modalTitle",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        marginRight: {
                            xs: '0px',
                            sm: "250px"
                        },
                        variant: 'h3',
                        color: "primary.main",
                        id: "modalTitle",
                        "data-testid": `${dataTestId}-title`,
                        children: title
                    })
                }),
                modalContent
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});



var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $aac1e0df913a08d1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDownOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $51b94d01f89a9a8e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 14 5-5 5 5z"
}), 'ArrowDropUpOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3f2bda4f7177714d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), 'KeyboardArrowRightOutlined');




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
const $1361756cfe76fdb5$export$44b3525d4f93dc0a = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: 'p1',
            children: "You have no orders to display."
        })
    });
};
const $1361756cfe76fdb5$export$d76d94f4d073189d = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            variant: 'p1',
            children: "You have no reservations to display."
        })
    });
};







const $8b6f49f5b2fddfb8$export$6e289e3dcca84b2a = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/createCartApi", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/carts`,
            method: "POST",
            data: JSON.stringify(payload),
            params: {
                userId: payload.userId,
                reservationId: payload?.reservationId
            }
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $8b6f49f5b2fddfb8$export$cffacbe8550d921 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/updateCartApi", async ({ payload: payload, userId: userId, cartId: cartId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/carts/${cartId}`,
            method: "PATCH",
            data: JSON.stringify(payload),
            params: {
                userId: userId
            }
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $8b6f49f5b2fddfb8$export$44d3d086648c6cda = async (userId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/orders`,
            method: "GET",
            params: {
                userId: userId,
                //todo: hard coding it now to fetch all orders for a user, in the future we should hook up pagination with api
                pageSize: 100
            }
        });
        return res?.data?.orders;
    } catch (error) {
        throw error;
    }
};
const $8b6f49f5b2fddfb8$export$fad077ca3a0b9035 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getOrderByIdApi", async ({ userId: userId, orderId: orderId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/orders/${orderId}`,
            method: "GET",
            params: {
                userId: userId
            }
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $8b6f49f5b2fddfb8$export$ac29b122ab5923bd = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/orders`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $8b6f49f5b2fddfb8$export$239d659298d60099 = async (payload)=>{
    try {
        const res = await (0, $80596ff285da23b7$export$2e2bcd8739ae039)({
            url: 'orderservice/invoice/invoices/lookup',
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};



var $ayMG0 = parcelRequire("ayMG0");

var $gPWuj = parcelRequire("gPWuj");
var $fuqu4 = parcelRequire("fuqu4");
var $bDyDY = parcelRequire("bDyDY");
var $5sOMZ = parcelRequire("5sOMZ");

var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $63bd8d80cef7fd02$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeftOutlined');


parcelRequire("acw62");
function $1f3e3b46a77e1663$var$Actions(props) {
    const { count: count, page: page, rowsPerPage: rowsPerPage, onPageChange: onPageChange } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const pageCount = (0, $5sOMZ.useGridSelector)(apiRef, (0, $gPWuj.gridPageCountSelector));
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: pageCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            role: "row",
            sx: {
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 10
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    disableRipple: true,
                    onClick: handleBackButtonClick,
                    disabled: page === 0,
                    "aria-label": "previous page",
                    role: "gridcell",
                    sx: {
                        padding: 0,
                        '&:focus': {
                            outline: '2px solid #1976d2'
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63bd8d80cef7fd02$export$2e2bcd8739ae039), {
                        fontSize: "large",
                        sx: {
                            color: 'secondary.graphical',
                            opacity: page === 0 ? 0.5 : 1
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    variant: 'p1',
                    children: [
                        page + 1,
                        " of ",
                        pageCount
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    disableRipple: true,
                    onClick: handleNextButtonClick,
                    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
                    "aria-label": "next page",
                    role: "gridcell",
                    sx: {
                        padding: 0,
                        '&:focus': {
                            outline: '2px solid #1976d2'
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f2bda4f7177714d$export$2e2bcd8739ae039), {
                        fontSize: "large",
                        sx: {
                            color: 'secondary.graphical',
                            opacity: page === pageCount - 1 ? 0.5 : 1
                        }
                    })
                })
            ]
        })
    });
}
function $1f3e3b46a77e1663$var$DataGridPagination(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fuqu4.GridPagination), {
        labelRowsPerPage: null,
        rowsPerPageOptions: [],
        labelDisplayedRows: ()=>'',
        ActionsComponent: $1f3e3b46a77e1663$var$Actions,
        ...props,
        sx: {
            '.MuiTablePagination-toolbar': {
                padding: '0px'
            }
        }
    });
}
var $1f3e3b46a77e1663$export$2e2bcd8739ae039 = $1f3e3b46a77e1663$var$DataGridPagination;




const $51af98075041530d$var$DataGrid = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("jrcyy")));
const $51af98075041530d$var$mapStatus = (()=>{
    const statuses = {
        'ON_HOLD': 'On Hold',
        'INTERNAL_HOLD': 'On Hold',
        'CREATED': 'Processing',
        'PENDING': 'Processing',
        'CONFIRMED': 'Processing',
        'CANCELLED': 'Cancelled',
        'COMPLETED': 'Shipped',
        'FULFILLED': 'Shipped'
    };
    return (value)=>statuses[value] ?? '';
})();
const $51af98075041530d$var$statusMappingForIcon = {
    'ON_HOLD': 'warning',
    'INTERNAL_HOLD': 'warning',
    'CREATED': 'processing',
    'PENDING': 'processing',
    'CONFIRMED': 'processing',
    'CANCELLED': 'cancelled',
    'COMPLETED': 'checked',
    'FULFILLED': 'checked'
};
const $51af98075041530d$var$LOCALE_CURRENCY_NAME_MAP = {
    'en-US': 'USD'
};
const $51af98075041530d$export$5a15edeb0ee4c09f = ({ userId: userId, handleErrorMsg: handleErrorMsg, setLoading: setLoading })=>{
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const theme = (0, $14H9o.default)();
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const [orderTableData, setOrderTableData] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const fetchOrders = async ()=>{
            if (!userId) {
                handleErrorMsg('We are unable to fetch your orders. Please refresh and try again.');
                return;
            }
            try {
                const data = await (0, $8b6f49f5b2fddfb8$export$44d3d086648c6cda)(userId);
                const tabledata = data?.map((item, index)=>{
                    const { name: name, street1: street1, street2: street2 = '', zipCode: zipCode, state: state } = item?.shipToAddress || {};
                    return {
                        id: index + 1,
                        orderNumber: item?.orderNumber,
                        subtotal: item?.orderPriceTotals?.subtotalContractPrice?.displayValue,
                        datePlaced: item?.orderCreatedDate?.split('T')[0],
                        poNumber: item?.purchaseOrderNumber ?? '-',
                        deliveryLocation: `${name} - ${street1},${street2},${zipCode},${state}`,
                        status: item?.orderStatus,
                        orderId: item?.orderId
                    };
                });
                setLoading(false);
                setOrderTableData(tabledata || []);
            } catch (error) {
                setLoading(false);
                handleErrorMsg(error);
            }
        };
        fetchOrders();
    }, []);
    const mobileColumns = [
        {
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ORDER_ID,
            field: 'orderNumber'
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: true,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ORDER_STATUS,
            field: 'status',
            flex: 1,
            renderCell: ({ value: value })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14b3f7acde2e143a$export$81cd25a3fdfff1e4), {
                    status: $51af98075041530d$var$statusMappingForIcon[value] || value,
                    children: $51af98075041530d$var$mapStatus(value)
                });
            }
        },
        {
            field: 'null',
            headerName: '',
            disableColumnMenu: true,
            sortable: false,
            width: 32,
            renderCell: ({ row: row })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: `/${locale}/orders/${row.orderId}`,
                    underline: 'none',
                    sx: {
                        svg: {
                            color: 'secondary.main',
                            '&:hover': {
                                color: 'primary.darker'
                            }
                        }
                    },
                    display: 'flex',
                    variant: 'link',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f2bda4f7177714d$export$2e2bcd8739ae039), {})
                });
            }
        }
    ];
    const desktopColumns = [
        {
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ORDER_ID,
            field: 'orderNumber'
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).SUBTOTAL_AMOUNT,
            field: 'subtotal',
            renderCell: ({ row: row })=>{
                return new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: $51af98075041530d$var$LOCALE_CURRENCY_NAME_MAP[locale]
                }).format(row.subtotal);
            },
            flex: 1
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: false,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).PO_NUMBER,
            field: 'poNumber',
            flex: 1
        },
        {
            disableColumnMenu: true,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).DATE_PLACED,
            field: 'datePlaced',
            flex: 1,
            renderCell: ({ value: value })=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value, 'YYYY-MM-DD').format('MMMM D, YYYY')
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: true,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ORDER_STATUS,
            field: 'status',
            flex: 1,
            renderCell: ({ value: value })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14b3f7acde2e143a$export$81cd25a3fdfff1e4), {
                    status: $51af98075041530d$var$statusMappingForIcon[value] || value,
                    children: $51af98075041530d$var$mapStatus(value)
                });
            }
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: false,
            headerName: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ACTIONS,
            field: 'action',
            flex: 1,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    value: row
                })
        }
    ];
    const ActionsComponent = ({ value: value })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                to: `/${locale}/orders/${value?.orderId}`,
                underline: 'none',
                sx: {
                    color: 'primary.main',
                    fontFamily: 'Aeonik Bold',
                    '&:hover': {
                        color: 'primary.darker'
                    }
                },
                display: 'flex',
                variant: 'link',
                children: "View"
            })
        });
    };
    const [, setApiRef] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            mx: {
                xs: '32px',
                lg: '100px'
            },
            my: '60px',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h2',
                    mb: '10px',
                    children: "Orders"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($51af98075041530d$var$DataGrid, {
                        onApiRef: (ref)=>setApiRef(ref),
                        getRowId: (rows)=>rows.id,
                        pageSizeOptions: [
                            10
                        ],
                        disableRowSelectionOnClick: true,
                        sx: {
                            '.MuiDataGrid-iconButtonContainer': {
                                visibility: 'visible'
                            },
                            '.MuiDataGrid-sortIcon': {
                                opacity: 'inherit !important'
                            },
                            '.MuiDataGrid-virtualScroller': {
                                overflow: 'hidden !important'
                            },
                            '.MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: "normal",
                                lineHeight: "20px"
                            }
                        },
                        slots: {
                            pagination: (0, $1f3e3b46a77e1663$export$2e2bcd8739ae039),
                            noRowsOverlay: (0, $1361756cfe76fdb5$export$44b3525d4f93dc0a),
                            columnSortedAscendingIcon: (0, $51b94d01f89a9a8e$export$2e2bcd8739ae039),
                            columnSortedDescendingIcon: (0, $aac1e0df913a08d1$export$2e2bcd8739ae039)
                        },
                        slotProps: {
                            noRowsOverlay: {
                                orderTableData: orderTableData
                            },
                            pagination: {
                                disabled: false
                            }
                        },
                        getCellClassName: ({ field: field })=>[
                                'confirmationNumber',
                                'date',
                                'poNumber',
                                'frieghtAmt',
                                'total'
                            ].includes(field) ? 'nonSelectable' : '',
                        hideFooterSelectedRowCount: true,
                        checkboxSelection: false,
                        autoHeight: true,
                        columns: mobile ? mobileColumns : desktopColumns,
                        sortingOrder: [
                            'desc',
                            'asc'
                        ],
                        initialState: {
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'datePlaced',
                                        sort: 'desc'
                                    }
                                ]
                            },
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        },
                        rows: orderTableData
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");








const $f9f5d27cea32d603$export$44a973515938c016 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/createReservationApi", async (payload, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation`,
            method: "POST",
            data: JSON.stringify(payload),
            params: {
                userId: payload.userId
            },
            headers: {
                'Moderna-Email-Address': payload.userEmail
            }
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $f9f5d27cea32d603$export$96d59517cc16328f = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/confirmReservationApi", async ({ payload: payload, reservationId: reservationId, userEmail: userEmail }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation/${reservationId}/confirm`,
            method: "PUT",
            data: JSON.stringify(payload),
            params: {
                userId: payload.userId
            },
            headers: {
                'Moderna-Email-Address': userEmail
            }
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $f9f5d27cea32d603$export$bbda77ab2dbab04a = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/updateReservationApi", async ({ payload: payload }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation/${payload?.reservation?.reservationId}`,
            method: "PUT",
            data: JSON.stringify(payload),
            params: {
                userId: payload.userId
            }
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $f9f5d27cea32d603$export$3a69f39f385de80e = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("reservation/reservationId", async ({ userId: userId, reservationId: reservationId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation/${reservationId}?userId=${userId}`,
            method: "GET"
        });
        return response.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $f9f5d27cea32d603$export$e35ceaa983df467e = async (userId)=>{
    try {
        const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservations`,
            method: "GET",
            params: {
                userId: userId
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
const $f9f5d27cea32d603$export$7fac097a02b0055d = async (userId, reservationId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation/${reservationId}`,
            method: "PATCH",
            params: {
                userId: userId
            }
        });
        return res?.data;
    } catch (error) {
        throw error;
    }
};
const $f9f5d27cea32d603$export$5c8829528553048f = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/cancelReservation", async ({ userId: userId, reservationId: reservationId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservation/${reservationId}`,
            method: "PATCH",
            params: {
                userId: userId
            }
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});






const $ea642245be46668a$var$DataGrid = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("jrcyy")));
const $ea642245be46668a$var$mapStatus = (()=>{
    const statuses = {
        'DELIVERED': 'Delivered',
        'PENDING': 'Reservation Placed',
        'CANCELLED': 'Reservation Cancelled',
        'ORDERED': 'Order Placed'
    };
    return (value)=>statuses[value] ?? '';
})();
const $ea642245be46668a$var$LOCALE_CURRENCY_NAME_MAP = {
    'en-US': 'USD',
    'en-DE': 'EUR'
};
const $ea642245be46668a$export$8a3c17eab1cd9e8 = ({ userId: userId, handleErrorMsg: handleErrorMsg })=>{
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const theme = (0, $14H9o.default)();
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [reservationTableData, setReservationTableData] = (0, $acw62.useState)([]);
    const [filteredReservations, setFilteredReservations] = (0, $acw62.useState)([]);
    const [yearFilter, setYearFilter] = (0, $acw62.useState)((0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const isReservationConversionEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_RESERVATIONS_CONVERSION_ENABLED");
    (0, $acw62.useEffect)(()=>{
        const fetchReservations = async ()=>{
            if (!userId) {
                handleErrorMsg('We are unable to fetch your reservations. Please refresh and try again.');
                return;
            }
            try {
                const data = await (0, $f9f5d27cea32d603$export$e35ceaa983df467e)(userId);
                const tableData = data?.reservations.map((item, index)=>({
                        id: index + 1,
                        modernaId: item?.reservationNumber,
                        subtotal: parseFloat(item?.reservationPricingInfo?.totalPrice),
                        poNumber: item?.purchaseOrderNumber ? item?.purchaseOrderNumber : '-',
                        datePlaced: item?.lastModifiedDate,
                        status: item?.reservationStatus,
                        reservationId: item?.reservationId
                    }));
                setReservationTableData(tableData);
            } catch (error) {
                handleErrorMsg(error);
            }
        };
        fetchReservations();
    }, []);
    (0, $acw62.useMemo)(()=>{
        const currentYear = new Date().getFullYear();
        const filteredReservations = reservationTableData.filter((item)=>{
            const yearOfReservation = new Date(item.datePlaced).getFullYear();
            return yearFilter === (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR ? yearOfReservation === currentYear : yearOfReservation < currentYear;
        });
        setFilteredReservations(filteredReservations);
    }, [
        reservationTableData,
        yearFilter
    ]);
    const mobileColumns = [
        {
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).RESERVATION_ID,
            field: 'modernaId'
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: true,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).RESERVATION_STATUS,
            field: 'status',
            flex: 1,
            renderCell: ({ value: value })=>{
                return $ea642245be46668a$var$mapStatus(value);
            }
        },
        {
            field: 'null',
            headerName: '',
            disableColumnMenu: true,
            sortable: false,
            width: 32,
            renderCell: ({ row: row })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: `/${locale}/order/${row.modernaId}`,
                    underline: 'none',
                    sx: {
                        svg: {
                            color: 'secondary.main',
                            '&:hover': {
                                color: 'primary.darker'
                            }
                        }
                    },
                    display: 'flex',
                    variant: 'link',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f2bda4f7177714d$export$2e2bcd8739ae039), {})
                });
            }
        }
    ];
    const desktopColumns = [
        {
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).RESERVATION_ID,
            field: 'modernaId'
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).SUBTOTAL_AMOUNT,
            field: 'subtotal',
            renderCell: ({ row: row })=>{
                return new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: $ea642245be46668a$var$LOCALE_CURRENCY_NAME_MAP[locale]
                }).format(row.subtotal);
            },
            flex: 1
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: false,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).PO_NUMBER,
            field: 'poNumber',
            flex: 1
        },
        {
            disableColumnMenu: true,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).DATE_PLACED,
            field: 'datePlaced',
            flex: 1,
            renderCell: ({ value: value })=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value, 'YYYY-MM-DD').format('MMMM D, YYYY')
        },
        {
            type: 'nonSelectable',
            disableColumnMenu: true,
            sortable: true,
            headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).RESERVATION_STATUS,
            field: 'status',
            flex: 1,
            renderCell: ({ value: value })=>{
                return $ea642245be46668a$var$mapStatus(value);
            }
        },
        //Will need this for next sprint, so not removing the code
        ...yearFilter === (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR ? [
            {
                type: 'nonSelectable',
                disableColumnMenu: true,
                sortable: false,
                headerName: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).ACTIONS,
                field: 'action',
                flex: 1,
                renderCell: ({ row: row })=>/*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                        value: row
                    })
            }
        ] : []
    ];
    const handleReservationConversionClick = async (reservationID)=>{
        await dispatch((0, $c89d887792446c86$export$ca51d8f2e5df1a32)(reservationID));
        history.push(`/${locale}/order-form/complete-reservation`);
    };
    const ActionsComponent = ({ value: value })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: isReservationConversionEnabled ? value?.status === 'PENDING' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        textTransform: "none",
                        width: '120px',
                        padding: "10px 10px",
                        "& .ButtonText": {
                            fontSize: "14px"
                        }
                    },
                    "data-testid": "convertToOrderBtn",
                    onClick: ()=>handleReservationConversionClick(value?.reservationId),
                    children: "Order Now"
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: value.status === 'CANCELLED' ? `/${locale}/summary/${value?.reservationId}` : `/${locale}/reservation/${value?.reservationId}`,
                    underline: 'none',
                    sx: {
                        color: 'primary.main',
                        fontFamily: 'Aeonik Bold',
                        '&:hover': {
                            color: 'primary.darker'
                        }
                    },
                    display: 'flex',
                    variant: 'link',
                    children: value.status === 'CANCELLED' ? 'View' : 'View/Edit'
                })
            })
        });
    };
    const [apiRef, setApiRef] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        mx: {
            xs: '32px',
            lg: '100px'
        },
        my: '60px',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h2',
                mb: '10px',
                children: "Reservations"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    width: ' 230px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47bfe24076768d6a$export$124e49603add0284), {
                    className: "border",
                    menuPropsSx: {
                        borderBottomLeftRadius: 6,
                        borderBottomRightRadius: 6,
                        '& .MuiMenu-list': {
                            padding: '0px'
                        },
                        border: `1px solid gray`
                    },
                    menuItemStyleSx: {
                        height: '48px'
                    },
                    options: [
                        {
                            label: `${(0, $5cdc329eeebd56d0$export$5ea7db4374a8364e)}-${(0, $5cdc329eeebd56d0$export$94e54707343393a0)}`,
                            value: (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR
                        },
                        {
                            label: `2024-${(0, $5cdc329eeebd56d0$export$5ea7db4374a8364e)}`,
                            value: (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).PAST_YEARS
                        }
                    ],
                    value: yearFilter,
                    onChangeHandler: (value)=>setYearFilter(value),
                    sx: {
                        mb: "7px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ea642245be46668a$var$DataGrid, {
                    onApiRef: (ref)=>setApiRef(ref),
                    getRowId: (rows)=>rows.id,
                    pageSizeOptions: [
                        10
                    ],
                    disableRowSelectionOnClick: true,
                    sx: {
                        '.MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible'
                        },
                        '.MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important'
                        },
                        '.MuiDataGrid-virtualScroller': {
                            overflow: 'hidden !important'
                        },
                        '.MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: "normal",
                            lineHeight: "20px"
                        }
                    },
                    slots: {
                        pagination: (0, $1f3e3b46a77e1663$export$2e2bcd8739ae039),
                        noRowsOverlay: (0, $1361756cfe76fdb5$export$d76d94f4d073189d),
                        columnSortedAscendingIcon: (0, $51b94d01f89a9a8e$export$2e2bcd8739ae039),
                        columnSortedDescendingIcon: (0, $aac1e0df913a08d1$export$2e2bcd8739ae039)
                    },
                    slotProps: {
                        noRowsOverlay: filteredReservations,
                        pagination: {
                            disabled: false
                        }
                    },
                    getCellClassName: ({ field: field })=>[
                            'confirmationNumber',
                            'date',
                            'poNumber',
                            'frieghtAmt',
                            'total'
                        ].includes(field) ? 'nonSelectable' : '',
                    hideFooterSelectedRowCount: true,
                    checkboxSelection: false,
                    autoHeight: true,
                    columns: mobile ? mobileColumns : desktopColumns,
                    sortingOrder: [
                        'desc',
                        'asc'
                    ],
                    initialState: {
                        sorting: {
                            sortModel: [
                                {
                                    field: 'datePlaced',
                                    sort: 'desc'
                                }
                            ]
                        },
                        pagination: {
                            paginationModel: {
                                pageSize: 10
                            }
                        }
                    },
                    rows: filteredReservations
                })
            })
        ]
    });
};













const $d8548cbfd1d8cccc$export$9acc23524038198b = [
    {
        fields: {
            code: 'MISSING_FULL_NAME',
            message: 'Please enter full name.'
        },
        sys: {
            id: '3m5lCUAMwNfCsridLt0mUw',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'MISSING_ORGANIZATION',
            message: 'Please enter your organization.'
        },
        sys: {
            id: 'mRixT6HYtdwBZAbOtWk7F',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'ACCOUNT_LOCKED',
            message: 'Your account is locked. Please reset your password or contact Moderna CARE Team.'
        },
        sys: {
            id: '115ZP8OYlwGNDKJwDNgKKv',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'EMAIL_MISMATCH',
            message: 'Please enter matching email'
        },
        sys: {
            id: '6jD9yqqDbOTWXbIPnSlV1t',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'INVALID_PHONE_FORMAT',
            message: 'Please enter a valid phone number.'
        },
        sys: {
            id: '5Sf11EYKetippY4rxdx9RX',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'GENERAL_API_ERROR',
            message: 'An error occurred, the issue may be temporary. Please try again.'
        },
        sys: {
            id: '5MCO9Rh3KmE5EgYaTP4ki5',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'INVALID_CREDENTIALS',
            message: 'Incorrect Email or Password.'
        },
        sys: {
            id: '71Dx9dstC05i7e6vKvEtHa',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'MISSING_EMAIL',
            message: 'Please enter email'
        },
        sys: {
            id: '7wKCF1EB2k6KtTFp297w81',
            type: 'Entry'
        }
    },
    {
        fields: {
            code: 'INVALID_EMAIL_FORMAT',
            message: 'Please enter a valid email address.'
        },
        sys: {
            id: '52rznADjiuQg1pXmjcOm7',
            type: 'Entry'
        }
    }
];


const $6bc88dbd9252a39b$export$cf6ef223e92188ca = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("globalMessages/messages", async ()=>{
    return 0, $d8548cbfd1d8cccc$export$9acc23524038198b;
});


const $0dd4d9faa3af463b$var$initialState = {
    globalErrorMessage: []
};
const $0dd4d9faa3af463b$export$119edf3fe0ae17e5 = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
    name: "globalMessages",
    initialState: $0dd4d9faa3af463b$var$initialState,
    reducers: {
        clearGlobalMessageStore: ()=>{
            return {
                ...$0dd4d9faa3af463b$var$initialState
            };
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $6bc88dbd9252a39b$export$cf6ef223e92188ca).fulfilled, (state, { payload: payload })=>{
            state.globalErrorMessage = payload;
        });
    }
});
const { clearGlobalMessageStore: $0dd4d9faa3af463b$export$4496e056b440ab3e } = $0dd4d9faa3af463b$export$119edf3fe0ae17e5.actions;
var $0dd4d9faa3af463b$export$2e2bcd8739ae039 = $0dd4d9faa3af463b$export$119edf3fe0ae17e5.reducer;



var $acw62 = parcelRequire("acw62");

var $hPtJY = parcelRequire("hPtJY");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $7b9bf6be2b37a4cd$var$s = function() {
    return $7b9bf6be2b37a4cd$var$s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $7b9bf6be2b37a4cd$var$s.apply(this, arguments);
};
function $7b9bf6be2b37a4cd$var$u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function $7b9bf6be2b37a4cd$var$l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var $7b9bf6be2b37a4cd$var$f, $7b9bf6be2b37a4cd$var$p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, $7b9bf6be2b37a4cd$var$d = function(e, t) {
    $7b9bf6be2b37a4cd$var$p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, $7b9bf6be2b37a4cd$var$y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, $7b9bf6be2b37a4cd$var$m = function(e) {
    "undefined" != typeof $hPtJY && $hPtJY.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}($7b9bf6be2b37a4cd$var$f || ($7b9bf6be2b37a4cd$var$f = {}));
var $7b9bf6be2b37a4cd$export$dd93270ab0cf623c = (0, $acw62.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), $7b9bf6be2b37a4cd$export$14d6311c3d83742b = $7b9bf6be2b37a4cd$export$dd93270ab0cf623c.Consumer;
function $7b9bf6be2b37a4cd$export$3d3872bfc53fd642(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, $acw62.useState)(null), C = $[0], P = $[1], x = (0, $acw62.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, $acw62.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = $7b9bf6be2b37a4cd$var$s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return $7b9bf6be2b37a4cd$var$y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else $7b9bf6be2b37a4cd$var$m("<GoogleRecaptchaProvider /> " + $7b9bf6be2b37a4cd$var$f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    $7b9bf6be2b37a4cd$var$m("Error loading google recaptcha script");
                }
            }), function() {
                $7b9bf6be2b37a4cd$var$d(e, null == S ? void 0 : S.element);
            };
        }
        $7b9bf6be2b37a4cd$var$m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, $acw62.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, $acw62.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7b9bf6be2b37a4cd$export$dd93270ab0cf623c.Provider, {
        value: N
    }, w);
}
var $7b9bf6be2b37a4cd$export$7f8feffd50fb5144 = function() {
    return (0, $acw62.useContext)($7b9bf6be2b37a4cd$export$dd93270ab0cf623c);
};
function $7b9bf6be2b37a4cd$export$d5aa16f6da947fbf(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = $7b9bf6be2b37a4cd$export$7f8feffd50fb5144();
    (0, $acw62.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) $7b9bf6be2b37a4cd$var$u(r, void 0, void 0, function() {
            var t;
            return $7b9bf6be2b37a4cd$var$l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : ($7b9bf6be2b37a4cd$var$m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: s
    }) : null;
}
function $7b9bf6be2b37a4cd$var$w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $7b9bf6be2b37a4cd$var$$ = "function" == typeof Symbol && Symbol.for, $7b9bf6be2b37a4cd$var$C = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.element") : 60103, $7b9bf6be2b37a4cd$var$P = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.portal") : 60106, $7b9bf6be2b37a4cd$var$x = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.fragment") : 60107, $7b9bf6be2b37a4cd$var$E = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.strict_mode") : 60108, $7b9bf6be2b37a4cd$var$R = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.profiler") : 60114, $7b9bf6be2b37a4cd$var$M = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.provider") : 60109, $7b9bf6be2b37a4cd$var$N = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.context") : 60110, $7b9bf6be2b37a4cd$var$O = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.async_mode") : 60111, $7b9bf6be2b37a4cd$var$_ = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.concurrent_mode") : 60111, $7b9bf6be2b37a4cd$var$T = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.forward_ref") : 60112, $7b9bf6be2b37a4cd$var$j = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.suspense") : 60113, $7b9bf6be2b37a4cd$var$L = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.suspense_list") : 60120, $7b9bf6be2b37a4cd$var$k = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.memo") : 60115, $7b9bf6be2b37a4cd$var$F = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.lazy") : 60116, $7b9bf6be2b37a4cd$var$A = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.block") : 60121, $7b9bf6be2b37a4cd$var$V = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.fundamental") : 60117, $7b9bf6be2b37a4cd$var$z = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.responder") : 60118, $7b9bf6be2b37a4cd$var$G = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.scope") : 60119;
function $7b9bf6be2b37a4cd$var$I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case $7b9bf6be2b37a4cd$var$C:
                switch(e = e.type){
                    case $7b9bf6be2b37a4cd$var$O:
                    case $7b9bf6be2b37a4cd$var$_:
                    case $7b9bf6be2b37a4cd$var$x:
                    case $7b9bf6be2b37a4cd$var$R:
                    case $7b9bf6be2b37a4cd$var$E:
                    case $7b9bf6be2b37a4cd$var$j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case $7b9bf6be2b37a4cd$var$N:
                            case $7b9bf6be2b37a4cd$var$T:
                            case $7b9bf6be2b37a4cd$var$F:
                            case $7b9bf6be2b37a4cd$var$k:
                            case $7b9bf6be2b37a4cd$var$M:
                                return e;
                            default:
                                return t;
                        }
                }
            case $7b9bf6be2b37a4cd$var$P:
                return t;
        }
    }
}
function $7b9bf6be2b37a4cd$var$D(e) {
    return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$_;
}
var $7b9bf6be2b37a4cd$var$q = {
    AsyncMode: $7b9bf6be2b37a4cd$var$O,
    ConcurrentMode: $7b9bf6be2b37a4cd$var$_,
    ContextConsumer: $7b9bf6be2b37a4cd$var$N,
    ContextProvider: $7b9bf6be2b37a4cd$var$M,
    Element: $7b9bf6be2b37a4cd$var$C,
    ForwardRef: $7b9bf6be2b37a4cd$var$T,
    Fragment: $7b9bf6be2b37a4cd$var$x,
    Lazy: $7b9bf6be2b37a4cd$var$F,
    Memo: $7b9bf6be2b37a4cd$var$k,
    Portal: $7b9bf6be2b37a4cd$var$P,
    Profiler: $7b9bf6be2b37a4cd$var$R,
    StrictMode: $7b9bf6be2b37a4cd$var$E,
    Suspense: $7b9bf6be2b37a4cd$var$j,
    isAsyncMode: function(e) {
        return $7b9bf6be2b37a4cd$var$D(e) || $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$O;
    },
    isConcurrentMode: $7b9bf6be2b37a4cd$var$D,
    isContextConsumer: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$N;
    },
    isContextProvider: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === $7b9bf6be2b37a4cd$var$C;
    },
    isForwardRef: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$T;
    },
    isFragment: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$x;
    },
    isLazy: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$F;
    },
    isMemo: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$k;
    },
    isPortal: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$P;
    },
    isProfiler: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$R;
    },
    isStrictMode: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$E;
    },
    isSuspense: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === $7b9bf6be2b37a4cd$var$x || e === $7b9bf6be2b37a4cd$var$_ || e === $7b9bf6be2b37a4cd$var$R || e === $7b9bf6be2b37a4cd$var$E || e === $7b9bf6be2b37a4cd$var$j || e === $7b9bf6be2b37a4cd$var$L || "object" == typeof e && null !== e && (e.$$typeof === $7b9bf6be2b37a4cd$var$F || e.$$typeof === $7b9bf6be2b37a4cd$var$k || e.$$typeof === $7b9bf6be2b37a4cd$var$M || e.$$typeof === $7b9bf6be2b37a4cd$var$N || e.$$typeof === $7b9bf6be2b37a4cd$var$T || e.$$typeof === $7b9bf6be2b37a4cd$var$V || e.$$typeof === $7b9bf6be2b37a4cd$var$z || e.$$typeof === $7b9bf6be2b37a4cd$var$G || e.$$typeof === $7b9bf6be2b37a4cd$var$A);
    },
    typeOf: $7b9bf6be2b37a4cd$var$I
}, $7b9bf6be2b37a4cd$var$B = $7b9bf6be2b37a4cd$var$w(function(e, t) {}), $7b9bf6be2b37a4cd$var$J = ($7b9bf6be2b37a4cd$var$B.AsyncMode, $7b9bf6be2b37a4cd$var$B.ConcurrentMode, $7b9bf6be2b37a4cd$var$B.ContextConsumer, $7b9bf6be2b37a4cd$var$B.ContextProvider, $7b9bf6be2b37a4cd$var$B.Element, $7b9bf6be2b37a4cd$var$B.ForwardRef, $7b9bf6be2b37a4cd$var$B.Fragment, $7b9bf6be2b37a4cd$var$B.Lazy, $7b9bf6be2b37a4cd$var$B.Memo, $7b9bf6be2b37a4cd$var$B.Portal, $7b9bf6be2b37a4cd$var$B.Profiler, $7b9bf6be2b37a4cd$var$B.StrictMode, $7b9bf6be2b37a4cd$var$B.Suspense, $7b9bf6be2b37a4cd$var$B.isAsyncMode, $7b9bf6be2b37a4cd$var$B.isConcurrentMode, $7b9bf6be2b37a4cd$var$B.isContextConsumer, $7b9bf6be2b37a4cd$var$B.isContextProvider, $7b9bf6be2b37a4cd$var$B.isElement, $7b9bf6be2b37a4cd$var$B.isForwardRef, $7b9bf6be2b37a4cd$var$B.isFragment, $7b9bf6be2b37a4cd$var$B.isLazy, $7b9bf6be2b37a4cd$var$B.isMemo, $7b9bf6be2b37a4cd$var$B.isPortal, $7b9bf6be2b37a4cd$var$B.isProfiler, $7b9bf6be2b37a4cd$var$B.isStrictMode, $7b9bf6be2b37a4cd$var$B.isSuspense, $7b9bf6be2b37a4cd$var$B.isValidElementType, $7b9bf6be2b37a4cd$var$B.typeOf, $7b9bf6be2b37a4cd$var$w(function(e) {
    e.exports = $7b9bf6be2b37a4cd$var$q;
})), $7b9bf6be2b37a4cd$var$K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $7b9bf6be2b37a4cd$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $7b9bf6be2b37a4cd$var$H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $7b9bf6be2b37a4cd$var$Q = {};
function $7b9bf6be2b37a4cd$var$W(e) {
    return $7b9bf6be2b37a4cd$var$J.isMemo(e) ? $7b9bf6be2b37a4cd$var$H : $7b9bf6be2b37a4cd$var$Q[e.$$typeof] || $7b9bf6be2b37a4cd$var$K;
}
$7b9bf6be2b37a4cd$var$Q[$7b9bf6be2b37a4cd$var$J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $7b9bf6be2b37a4cd$var$Q[$7b9bf6be2b37a4cd$var$J.Memo] = $7b9bf6be2b37a4cd$var$H;
var $7b9bf6be2b37a4cd$var$X = Object.defineProperty, $7b9bf6be2b37a4cd$var$Y = Object.getOwnPropertyNames, $7b9bf6be2b37a4cd$var$Z = Object.getOwnPropertySymbols, $7b9bf6be2b37a4cd$var$ee = Object.getOwnPropertyDescriptor, $7b9bf6be2b37a4cd$var$te = Object.getPrototypeOf, $7b9bf6be2b37a4cd$var$re = Object.prototype;
var $7b9bf6be2b37a4cd$var$oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if ($7b9bf6be2b37a4cd$var$re) {
            var n = $7b9bf6be2b37a4cd$var$te(r);
            n && n !== $7b9bf6be2b37a4cd$var$re && e(t, n, o);
        }
        var a = $7b9bf6be2b37a4cd$var$Y(r);
        $7b9bf6be2b37a4cd$var$Z && (a = a.concat($7b9bf6be2b37a4cd$var$Z(r)));
        for(var c = $7b9bf6be2b37a4cd$var$W(t), i = $7b9bf6be2b37a4cd$var$W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!($7b9bf6be2b37a4cd$var$U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = $7b9bf6be2b37a4cd$var$ee(r, u);
                try {
                    $7b9bf6be2b37a4cd$var$X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, $7b9bf6be2b37a4cd$export$b641f6dbb7005cb7 = function(t) {
    var r = function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7b9bf6be2b37a4cd$export$14d6311c3d83742b, null, function(o) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(t, $7b9bf6be2b37a4cd$var$s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", $7b9bf6be2b37a4cd$var$oe(r, t), r;
};




var $ayMG0 = parcelRequire("ayMG0");



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

const $d57c4e7117e9f64a$var$FaqContainer = (0, $d8seH.default)('section')`
  padding: 22px;
  max-width: 1020px;
  width: 100%;
  margin: 0 auto;
`;
const $d57c4e7117e9f64a$var$FaqList = ({ faqCategoriesData: faqCategoriesData = [] })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d57c4e7117e9f64a$var$FaqContainer, {
        children: faqCategoriesData?.map((dataValue, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b7606028215b492$export$f0cdb780346cef06), {
                index: index,
                title: dataValue?.fields?.name,
                data: dataValue?.fields?.faqEntries,
                iconUrl: dataValue?.fields?.icon?.fields?.file?.url
            }, index))
    });
};
var $d57c4e7117e9f64a$export$2e2bcd8739ae039 = $d57c4e7117e9f64a$var$FaqList;



var $3bYfT = parcelRequire("3bYfT");

var $89e552997d15ef2b$exports = {};
$89e552997d15ef2b$exports = new URL("banner-strand-top.7b45fab2.png", import.meta.url).toString();


var $ff07cce88877c424$exports = {};
$ff07cce88877c424$exports = new URL("banner-strand-bottom-left.dd754bad.png", import.meta.url).toString();



var $419aefc8b5360350$exports = {};
$419aefc8b5360350$exports = new URL("note-scroll.ea3f9b0a.png", import.meta.url).toString();


const $cc18154cd7e9f3c8$export$b266ee7c96751ec9 = {
    faqBannerData: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
            },
            id: '7FSPIxBv2f8DUuOYNyjN2f',
            type: 'Entry',
            createdAt: '2022-10-25T05:36:06.733Z',
            updatedAt: '2023-06-16T18:23:48.072Z',
            environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
            },
            publishedVersion: 21,
            revision: 4,
            contentType: {
                sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'bannerComponent'
                }
            },
            locale: 'en-US'
        },
        fields: {
            title: 'FAQs',
            headline: 'Browse answers to frequently asked questions',
            backgroundImage: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '5zfGJA7or5WGcLdYi4Qde',
                    type: 'Asset',
                    createdAt: '2022-10-28T18:53:29.208Z',
                    updatedAt: '2022-10-28T18:53:29.208Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Banner BG Strand Top',
                    description: '',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($89e552997d15ef2b$exports))),
                        details: {
                            size: 47693,
                            image: {
                                width: 1920,
                                height: 511
                            }
                        },
                        fileName: 'Banner BG Strand Top .png',
                        contentType: 'image/png'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        }
    },
    contactUsData: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
            },
            id: '6gqCKf6EtK3mI0yNzKHx5h',
            type: 'Entry',
            createdAt: '2022-10-28T20:10:43.478Z',
            updatedAt: '2022-10-31T05:40:26.928Z',
            environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
            },
            publishedVersion: 12,
            revision: 3,
            contentType: {
                sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'contactUsCta'
                }
            },
            locale: 'en-US'
        },
        fields: {
            contactUsMessage: 'Still can\'t find what you are looking for?',
            contactUsButtonLabel: 'CONTACT US',
            contactUsLink: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '4HqZvZWcCaClANwXQS032G',
                    type: 'Entry',
                    createdAt: '2022-10-28T14:47:04.805Z',
                    updatedAt: '2022-10-28T22:28:28.481Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 8,
                    revision: 3,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'internalLink'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    title: 'Contact Us Link',
                    label: 'Contact Us',
                    pageReference: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '6aA4Kfs006hNINMMIje8Cq',
                            type: 'Entry',
                            createdAt: '2022-10-28T20:09:14.397Z',
                            updatedAt: '2022-12-02T04:38:06.055Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 16,
                            revision: 3,
                            contentType: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'ContentType',
                                    id: 'page'
                                }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Contact Us',
                            title: 'Contact Us',
                            slug: 'contact-us',
                            seo: {
                                metadata: {
                                    tags: [],
                                    concepts: []
                                },
                                sys: {
                                    space: {
                                        sys: {
                                            type: 'Link',
                                            linkType: 'Space',
                                            id: 'n9bebhw263o0'
                                        }
                                    },
                                    id: '3SZXCHhkMg78hB0DVPqLnA',
                                    type: 'Entry',
                                    createdAt: '2022-10-28T20:09:14.497Z',
                                    updatedAt: '2022-10-28T20:09:14.497Z',
                                    environment: {
                                        sys: {
                                            id: 'sandbox',
                                            type: 'Link',
                                            linkType: 'Environment'
                                        }
                                    },
                                    publishedVersion: 15,
                                    revision: 1,
                                    contentType: {
                                        sys: {
                                            type: 'Link',
                                            linkType: 'ContentType',
                                            id: 'seo'
                                        }
                                    },
                                    locale: 'en-US'
                                },
                                fields: {
                                    name: 'Contact Us - Compose: SEO',
                                    title: 'Contact Us Moderna',
                                    description: 'Contact Us Moderna',
                                    no_index: false,
                                    no_follow: false
                                }
                            },
                            content: {
                                metadata: {
                                    tags: [],
                                    concepts: []
                                },
                                sys: {
                                    space: {
                                        sys: {
                                            type: 'Link',
                                            linkType: 'Space',
                                            id: 'n9bebhw263o0'
                                        }
                                    },
                                    id: '2XyGZ6yTIb3AUfSz6gUGfw',
                                    type: 'Entry',
                                    createdAt: '2022-10-28T20:09:14.520Z',
                                    updatedAt: '2022-12-02T04:37:00.701Z',
                                    environment: {
                                        sys: {
                                            id: 'sandbox',
                                            type: 'Link',
                                            linkType: 'Environment'
                                        }
                                    },
                                    publishedVersion: 18,
                                    revision: 4,
                                    contentType: {
                                        sys: {
                                            type: 'Link',
                                            linkType: 'ContentType',
                                            id: 'pageContactUsPageTemplate'
                                        }
                                    },
                                    locale: 'en-US'
                                },
                                fields: {
                                    name: 'Contact Us - Contact Us Page Template',
                                    modules: [
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '2y5JNbGCdLulrhbyD0VSZ5',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:34:18.506Z',
                                                updatedAt: '2023-09-22T16:32:41.034Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 39,
                                                revision: 6,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'bannerComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'Contact Us Banner Component',
                                                headline: 'Contact Us',
                                                backgroundImage: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '5zfGJA7or5WGcLdYi4Qde',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-28T18:53:29.208Z',
                                                        updatedAt: '2022-10-28T18:53:29.208Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 1,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Banner BG Strand Top',
                                                        description: '',
                                                        file: {
                                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($89e552997d15ef2b$exports))),
                                                            details: {
                                                                size: 47693,
                                                                image: {
                                                                    width: 1920,
                                                                    height: 511
                                                                }
                                                            },
                                                            fileName: 'Banner BG Strand Top .png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                message: 'Ready to order or have questions? We\'re here to help. Contact us for any guidance or information you need. Your satisfaction is our priority and we eagerly await the opportunity to serve you.',
                                                country: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '7sht7920U6vs3CLH2CUyaa',
                                                        type: 'Entry',
                                                        createdAt: '2023-05-18T03:23:50.744Z',
                                                        updatedAt: '2023-05-24T22:55:23.250Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 2,
                                                        contentType: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'ContentType',
                                                                id: 'country'
                                                            }
                                                        },
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        name: 'United States',
                                                        isocode: 'US',
                                                        flag: {
                                                            metadata: {
                                                                tags: [],
                                                                concepts: []
                                                            },
                                                            sys: {
                                                                space: {
                                                                    sys: {
                                                                        type: 'Link',
                                                                        linkType: 'Space',
                                                                        id: 'n9bebhw263o0'
                                                                    }
                                                                },
                                                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                type: 'Asset',
                                                                createdAt: '2023-05-24T22:54:50.939Z',
                                                                updatedAt: '2023-05-24T22:54:50.939Z',
                                                                environment: {
                                                                    sys: {
                                                                        id: 'sandbox',
                                                                        type: 'Link',
                                                                        linkType: 'Environment'
                                                                    }
                                                                },
                                                                publishedVersion: 5,
                                                                revision: 1,
                                                                locale: 'en-US'
                                                            },
                                                            fields: {
                                                                title: 'usa flag',
                                                                description: 'USA Flag',
                                                                file: {
                                                                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                                    details: {
                                                                        size: 2487,
                                                                        image: {
                                                                            width: 36,
                                                                            height: 26
                                                                        }
                                                                    },
                                                                    fileName: 'usa_flag.svg',
                                                                    contentType: 'image/svg+xml'
                                                                }
                                                            }
                                                        },
                                                        locales: [
                                                            'en-US'
                                                        ]
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: 'bZN3ozoAd7NgLj1g3GLIQ',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:25:12.254Z',
                                                updatedAt: '2024-05-28T21:10:01.634Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 45,
                                                revision: 14,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsCardComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'Care Team Contact Us Card - US',
                                                headline: 'To place an order or for support',
                                                message: {
                                                    nodeType: 'document',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'paragraph',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'text',
                                                                    value: '1-866-MODERNA (1-866-663-3762)',
                                                                    marks: [],
                                                                    data: {}
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            nodeType: 'paragraph',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'text',
                                                                    value: '8:00AM - 8:00PM, Monday - Friday',
                                                                    marks: [],
                                                                    data: {}
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            nodeType: 'paragraph',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'text',
                                                                    value: 'WeCare@modernatx.com',
                                                                    marks: [],
                                                                    data: {}
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            nodeType: 'paragraph',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'text',
                                                                    value: '\n',
                                                                    marks: [],
                                                                    data: {}
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                icon: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-28T13:45:09.591Z',
                                                        updatedAt: '2022-12-09T19:13:58.864Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 11,
                                                        revision: 2,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Faq Category Icon',
                                                        description: 'Faq Category SVG',
                                                        file: {
                                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                                                            details: {
                                                                size: 40893,
                                                                image: {
                                                                    width: 600,
                                                                    height: 600
                                                                }
                                                            },
                                                            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                country: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '7sht7920U6vs3CLH2CUyaa',
                                                        type: 'Entry',
                                                        createdAt: '2023-05-18T03:23:50.744Z',
                                                        updatedAt: '2023-05-24T22:55:23.250Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 2,
                                                        contentType: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'ContentType',
                                                                id: 'country'
                                                            }
                                                        },
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        name: 'United States',
                                                        isocode: 'US',
                                                        flag: {
                                                            metadata: {
                                                                tags: [],
                                                                concepts: []
                                                            },
                                                            sys: {
                                                                space: {
                                                                    sys: {
                                                                        type: 'Link',
                                                                        linkType: 'Space',
                                                                        id: 'n9bebhw263o0'
                                                                    }
                                                                },
                                                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                type: 'Asset',
                                                                createdAt: '2023-05-24T22:54:50.939Z',
                                                                updatedAt: '2023-05-24T22:54:50.939Z',
                                                                environment: {
                                                                    sys: {
                                                                        id: 'sandbox',
                                                                        type: 'Link',
                                                                        linkType: 'Environment'
                                                                    }
                                                                },
                                                                publishedVersion: 5,
                                                                revision: 1,
                                                                locale: 'en-US'
                                                            },
                                                            fields: {
                                                                title: 'usa flag',
                                                                description: 'USA Flag',
                                                                file: {
                                                                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                                    details: {
                                                                        size: 2487,
                                                                        image: {
                                                                            width: 36,
                                                                            height: 26
                                                                        }
                                                                    },
                                                                    fileName: 'usa_flag.svg',
                                                                    contentType: 'image/svg+xml'
                                                                }
                                                            }
                                                        },
                                                        locales: [
                                                            'en-US'
                                                        ]
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '7wREbh7uFf1amAX5Occ9dj',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:28:54.232Z',
                                                updatedAt: '2024-12-13T22:26:19.433Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 31,
                                                revision: 10,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsCardComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'Report Adverse Event Contact Us Card - US',
                                                headline: 'Report an adverse event',
                                                message: {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    marks: [],
                                                                    value: 'Click the arrow to submit an adverse event report',
                                                                    nodeType: 'text'
                                                                },
                                                                {
                                                                    data: {},
                                                                    marks: [],
                                                                    value: '\n',
                                                                    nodeType: 'text'
                                                                }
                                                            ],
                                                            nodeType: 'paragraph'
                                                        }
                                                    ],
                                                    nodeType: 'document'
                                                },
                                                icon: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-28T13:45:09.591Z',
                                                        updatedAt: '2022-12-09T19:13:58.864Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 11,
                                                        revision: 2,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Faq Category Icon',
                                                        description: 'Faq Category SVG',
                                                        file: {
                                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                                                            details: {
                                                                size: 40893,
                                                                image: {
                                                                    width: 600,
                                                                    height: 600
                                                                }
                                                            },
                                                            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                link: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Entry',
                                                        id: '6mzHEzPj12cIX1TCNBE7p2'
                                                    }
                                                },
                                                country: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '7sht7920U6vs3CLH2CUyaa',
                                                        type: 'Entry',
                                                        createdAt: '2023-05-18T03:23:50.744Z',
                                                        updatedAt: '2023-05-24T22:55:23.250Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 2,
                                                        contentType: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'ContentType',
                                                                id: 'country'
                                                            }
                                                        },
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        name: 'United States',
                                                        isocode: 'US',
                                                        flag: {
                                                            metadata: {
                                                                tags: [],
                                                                concepts: []
                                                            },
                                                            sys: {
                                                                space: {
                                                                    sys: {
                                                                        type: 'Link',
                                                                        linkType: 'Space',
                                                                        id: 'n9bebhw263o0'
                                                                    }
                                                                },
                                                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                type: 'Asset',
                                                                createdAt: '2023-05-24T22:54:50.939Z',
                                                                updatedAt: '2023-05-24T22:54:50.939Z',
                                                                environment: {
                                                                    sys: {
                                                                        id: 'sandbox',
                                                                        type: 'Link',
                                                                        linkType: 'Environment'
                                                                    }
                                                                },
                                                                publishedVersion: 5,
                                                                revision: 1,
                                                                locale: 'en-US'
                                                            },
                                                            fields: {
                                                                title: 'usa flag',
                                                                description: 'USA Flag',
                                                                file: {
                                                                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                                    details: {
                                                                        size: 2487,
                                                                        image: {
                                                                            width: 36,
                                                                            height: 26
                                                                        }
                                                                    },
                                                                    fileName: 'usa_flag.svg',
                                                                    contentType: 'image/svg+xml'
                                                                }
                                                            }
                                                        },
                                                        locales: [
                                                            'en-US'
                                                        ]
                                                    }
                                                },
                                                label: 'Report an adverse event'
                                            }
                                        },
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '46fjepI7RrVzgj8ua6WqFv',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:29:45.465Z',
                                                updatedAt: '2024-12-13T22:25:31.150Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 14,
                                                revision: 4,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsCardComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'FAQ Contact Us Card - US',
                                                headline: 'FAQs',
                                                message: {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    marks: [],
                                                                    value: 'Frequently asked questions about Moderna Direct\n\n',
                                                                    nodeType: 'text'
                                                                }
                                                            ],
                                                            nodeType: 'paragraph'
                                                        }
                                                    ],
                                                    nodeType: 'document'
                                                },
                                                icon: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-28T13:45:09.591Z',
                                                        updatedAt: '2022-12-09T19:13:58.864Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 11,
                                                        revision: 2,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Faq Category Icon',
                                                        description: 'Faq Category SVG',
                                                        file: {
                                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                                                            details: {
                                                                size: 40893,
                                                                image: {
                                                                    width: 600,
                                                                    height: 600
                                                                }
                                                            },
                                                            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                link: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Entry',
                                                        id: '4sGXFZd1qHOz98lelP3ptv'
                                                    }
                                                },
                                                country: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '7sht7920U6vs3CLH2CUyaa',
                                                        type: 'Entry',
                                                        createdAt: '2023-05-18T03:23:50.744Z',
                                                        updatedAt: '2023-05-24T22:55:23.250Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 2,
                                                        contentType: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'ContentType',
                                                                id: 'country'
                                                            }
                                                        },
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        name: 'United States',
                                                        isocode: 'US',
                                                        flag: {
                                                            metadata: {
                                                                tags: [],
                                                                concepts: []
                                                            },
                                                            sys: {
                                                                space: {
                                                                    sys: {
                                                                        type: 'Link',
                                                                        linkType: 'Space',
                                                                        id: 'n9bebhw263o0'
                                                                    }
                                                                },
                                                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                type: 'Asset',
                                                                createdAt: '2023-05-24T22:54:50.939Z',
                                                                updatedAt: '2023-05-24T22:54:50.939Z',
                                                                environment: {
                                                                    sys: {
                                                                        id: 'sandbox',
                                                                        type: 'Link',
                                                                        linkType: 'Environment'
                                                                    }
                                                                },
                                                                publishedVersion: 5,
                                                                revision: 1,
                                                                locale: 'en-US'
                                                            },
                                                            fields: {
                                                                title: 'usa flag',
                                                                description: 'USA Flag',
                                                                file: {
                                                                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                                    details: {
                                                                        size: 2487,
                                                                        image: {
                                                                            width: 36,
                                                                            height: 26
                                                                        }
                                                                    },
                                                                    fileName: 'usa_flag.svg',
                                                                    contentType: 'image/svg+xml'
                                                                }
                                                            }
                                                        },
                                                        locales: [
                                                            'en-US'
                                                        ]
                                                    }
                                                },
                                                label: 'View Frequently Asked Questions'
                                            }
                                        },
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '1UNli48LSxpoJIrKw23H1N',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:19:00.121Z',
                                                updatedAt: '2023-09-28T16:53:26.696Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 28,
                                                revision: 5,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsFormComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'Contact Us Form Component',
                                                headline: 'Ask a Question or Request to be Contacted',
                                                message: {
                                                    nodeType: 'document',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'paragraph',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'text',
                                                                    value: 'Enter your contact details and select how we can help you.',
                                                                    marks: [],
                                                                    data: {}
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                fullNameLabel: 'Full Name',
                                                fullNamePlaceholder: 'Enter full name',
                                                emailLabel: 'Email',
                                                emailPlaceholder: 'Enter email',
                                                phoneLabel: 'Phone',
                                                phonePlaceholder: 'Enter phone',
                                                organizationLabel: 'Organization',
                                                organizationPlaceholder: 'Enter organization',
                                                preferredMethodLabel: 'Preferred method of contact',
                                                preferredMethodList: [
                                                    'Email',
                                                    'Phone'
                                                ],
                                                supportCategoryLabel: 'What can we help you with?',
                                                supportCategoryList: [
                                                    'Contract and Billing',
                                                    'Order Assistance',
                                                    'Product Inquiry',
                                                    'Account Information',
                                                    'General Inquiry',
                                                    'Other'
                                                ],
                                                consentMessageLabel: 'I consent to the Moderna',
                                                consentLink: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Entry',
                                                        id: '556dZCOMwLIKu69guk6x42'
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '7oSmj9Iyl3kSocc335XV51',
                                                type: 'Entry',
                                                createdAt: '2022-12-02T04:21:30.182Z',
                                                updatedAt: '2022-12-02T04:21:30.182Z',
                                                environment: {
                                                    sys: {
                                                        id: 'sandbox',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 8,
                                                revision: 1,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsConfirmationComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'Contact Us Confirmation Component',
                                                headline: 'Request Sent',
                                                message: {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    marks: [],
                                                                    value: 'Thank you for reaching out. A representative will reach out shortly.',
                                                                    nodeType: 'text'
                                                                }
                                                            ],
                                                            nodeType: 'paragraph'
                                                        }
                                                    ],
                                                    nodeType: 'document'
                                                },
                                                icon: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '5EWJeaSLcAOTh1XGB5J1Jd',
                                                        type: 'Asset',
                                                        createdAt: '2022-11-08T22:15:01.982Z',
                                                        updatedAt: '2022-11-08T22:15:01.982Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'sandbox',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 3,
                                                        revision: 1,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'webimage-13968D71-F252-482D-8242F0F417213C5F',
                                                        description: '',
                                                        file: {
                                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($419aefc8b5360350$exports))),
                                                            details: {
                                                                size: 35738,
                                                                image: {
                                                                    width: 600,
                                                                    height: 600
                                                                }
                                                            },
                                                            fileName: 'webimage-13968D71-F252-482D-8242F0F417213C5F.png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                link: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Entry',
                                                        id: '7sOHpLfHcBdXJkB7vOBL26'
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    }
                }
            },
            backgroundImage: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '4udXXZnb6huWaP2x7gPRJO',
                    type: 'Asset',
                    createdAt: '2022-10-31T05:40:17.871Z',
                    updatedAt: '2022-10-31T05:40:17.871Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Banner BG Strand Bottom',
                    description: '',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($ff07cce88877c424$exports))),
                        details: {
                            size: 26282,
                            image: {
                                width: 1920,
                                height: 324
                            }
                        },
                        fileName: 'Banner BG Strand Bottom.png',
                        contentType: 'image/png'
                    }
                }
            }
        }
    }
};




var $5fed29139c7b3ab0$exports = {};
$5fed29139c7b3ab0$exports = new URL("authorized-dealer.fbcd10d4.svg", import.meta.url).toString();


var $c820fe25fa7159b7$exports = {};
$c820fe25fa7159b7$exports = new URL("reservations.39a02dc0.svg", import.meta.url).toString();


var $c7568c7a115daefc$exports = {};
$c7568c7a115daefc$exports = new URL("upward-chart.ae20e27d.png", import.meta.url).toString();



var $9d9b770e0cd6be72$exports = {};
$9d9b770e0cd6be72$exports = new URL("shipping.c4d41d6b.svg", import.meta.url).toString();


var $ab9f6abdc0e3fe1c$exports = {};
$ab9f6abdc0e3fe1c$exports = new URL("delivery.bedaad69.svg", import.meta.url).toString();


var $c49339886d9878e2$exports = {};
$c49339886d9878e2$exports = new URL("temperature-monitoring.c38f4129.svg", import.meta.url).toString();


var $bcf4b90d834d9c07$exports = {};
$bcf4b90d834d9c07$exports = new URL("troubleshooting.7fc0357d.svg", import.meta.url).toString();


var $9c92cc09aed2a367$exports = {};
$9c92cc09aed2a367$exports = new URL("access-medicine.132c5f3c.png", import.meta.url).toString();


var $2de8fa698a6e3bd0$exports = {};
$2de8fa698a6e3bd0$exports = new URL("website-troubleshooting.3adaeebb.svg", import.meta.url).toString();


var $625f21c08d7b1e51$exports = {};
$625f21c08d7b1e51$exports = new URL("accounts.8b3d647a.png", import.meta.url).toString();


const $f9d938a75a4c86c0$export$ecc38b4d7bf2ad22 = [
    {
        fields: {
            title: 'Account - US',
            name: 'Account',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1oWjvwUekvAkypRl9mYDU2',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:49:19.988Z',
                        updatedAt: '2024-03-04T19:49:19.988Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I create a new account on ModernaDirect.com? - US',
                        question: 'How do I create a new account on ModernaDirect.com? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Select \u201CCreate a new account\u201D during log in and provide either a HIN or DEA number to find your account. If you experience any issues, please contact your Account Manager or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7iC7HZ1qh8w2F0i8zoI9rO',
                        type: 'Entry',
                        createdAt: '2022-10-26T22:35:57.633Z',
                        updatedAt: '2024-03-04T19:49:46.484Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 32,
                        revision: 8,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Am I affiliated with a Group Purchasing Organization (GPO) or other contract entity?  - US',
                        question: 'Am I affiliated with a Group Purchasing Organization (GPO) or other contract entity? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Please click \u201CMy Account\u201D to view your account details, which will show any contract affiliation(s).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5k6A7RdsqLLrrJQilZaPiN',
                        type: 'Entry',
                        createdAt: '2023-01-09T19:46:37.151Z',
                        updatedAt: '2024-03-04T19:50:08.369Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 24,
                        revision: 6,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'My contract affiliation is not correct. How can I fix it? - US',
                        question: 'My contract affiliation is not correct. How can I fix it? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Please contact your Account Manager or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) to verify your contract affiliation or contact customer service.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2Hqe0Ghpiu1DLaWsIC3gNF',
                        type: 'Entry',
                        createdAt: '2023-01-09T19:47:35.354Z',
                        updatedAt: '2024-03-04T19:50:32.535Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 19,
                        revision: 7,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why can\u2019t I change / update my account information?",
                        question: "Why can\u2019t I change / update my account information? ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Fields that can be edited will have an \u201Cedit\u201D button next to them. However, some fields may be temporarily locked. To update or change information at the account level, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '16L3tb5eMUdaaSKWnT0R2A',
                        type: 'Entry',
                        createdAt: '2023-01-09T19:49:26.296Z',
                        updatedAt: '2024-03-04T19:50:54.740Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 36,
                        revision: 11,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I reset my password? - US',
                        question: 'How do I reset my password?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "To change or reset your password, you\u2019ll need to first log out of ",
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'ModernaDirect.com',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ". Then, go to the Homepage, click on \u201CForgot Password,\u201D and follow the prompts. If you have trouble with any part of the process, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7cvVETbdfmc4G1Fj7XJZbK',
                    type: 'Asset',
                    createdAt: '2023-01-20T13:16:58.825Z',
                    updatedAt: '2023-01-20T13:23:17.055Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 7,
                    revision: 2,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Icon US Employee benefits',
                    description: 'Icon US Employee benefits',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($625f21c08d7b1e51$exports))),
                        details: {
                            size: 13512,
                            image: {
                                width: 501,
                                height: 501
                            }
                        },
                        fileName: 'Moderna_Icon_USEmployeeBenefits.png',
                        contentType: 'image/png'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '6RquDCvRRFNOFyGlq58b4a',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Ordering from Moderna - US',
            name: 'Ordering from Moderna ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2hwboHkQnRMNGwcQHrb90r',
                        type: 'Entry',
                        createdAt: '2023-09-11T19:58:49.226Z',
                        updatedAt: '2024-03-04T19:31:57.151Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 12,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What products are available to order?  - US',
                        question: 'What products are available to order? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Ordering is available for the updated 2023-2024 formulations of the COVID-19 Vaccine:\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Spikevax (COVID-19 vaccine, mRNA) 2023-2024 Formula\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                },
                                                {
                                                    nodeType: 'unordered-list',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'list-item',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'paragraph',
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            nodeType: 'text',
                                                                            value: "0.5 mL Prefilled Syringe - For ages 12 years and older\xa0",
                                                                            marks: [],
                                                                            data: {}
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            nodeType: 'list-item',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'paragraph',
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            nodeType: 'text',
                                                                            value: "0.5 mL Single Dose Vial - For ages 12 years and older\xa0",
                                                                            marks: [],
                                                                            data: {}
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Moderna COVID-19 Vaccine (2023-2024 Formula):\xa0\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                },
                                                {
                                                    nodeType: 'unordered-list',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'list-item',
                                                            data: {},
                                                            content: [
                                                                {
                                                                    nodeType: 'paragraph',
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            nodeType: 'text',
                                                                            value: "0.25 mL Single Dose Vial - For ages 6 months through 11 years\xa0",
                                                                            marks: [],
                                                                            data: {}
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: '',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1TJN6GVo2jJvOY5WeRwlwx',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:33:21.605Z',
                        updatedAt: '2024-03-04T19:33:21.605Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What products are available to reserve? - US',
                        question: 'What products are available to reserve? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'Customers known to Moderna (for example, those who placed an order via ModernaDirect.com in 2023) will be able to reserve the following products starting on March 5, 2024',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [
                                                {
                                                    type: 'bold'
                                                }
                                            ],
                                            value: '.',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: "\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "Spikevax (COVID-19 vaccine, mRNA) 2024-2025 Formula\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                },
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            data: {},
                                                                            marks: [],
                                                                            value: "0.5 mL Pre-filled Syringe - For ages 12 years and older\xa0\xa0",
                                                                            nodeType: 'text'
                                                                        }
                                                                    ],
                                                                    nodeType: 'paragraph'
                                                                }
                                                            ],
                                                            nodeType: 'list-item'
                                                        },
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            data: {},
                                                                            marks: [],
                                                                            value: "0.5 mL Single Dose Vial - For ages 12 years and older\xa0\xa0",
                                                                            nodeType: 'text'
                                                                        }
                                                                    ],
                                                                    nodeType: 'paragraph'
                                                                }
                                                            ],
                                                            nodeType: 'list-item'
                                                        }
                                                    ],
                                                    nodeType: 'unordered-list'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "Moderna COVID-19 Vaccine (2024-2025 Formula)\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                },
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    content: [
                                                                        {
                                                                            data: {},
                                                                            marks: [],
                                                                            value: "0.25 mL Pre-filled Syringe - For ages 6 months through 11 years\xa0",
                                                                            nodeType: 'text'
                                                                        }
                                                                    ],
                                                                    nodeType: 'paragraph'
                                                                }
                                                            ],
                                                            nodeType: 'list-item'
                                                        }
                                                    ],
                                                    nodeType: 'unordered-list'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        }
                                    ],
                                    nodeType: 'unordered-list'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: '',
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1NRamRyoFbwSGdl1wS5UTE',
                        type: 'Entry',
                        createdAt: '2023-09-11T19:59:17.626Z',
                        updatedAt: '2024-03-04T19:34:08.097Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What are the 2023-2024 and 2024-2025 CPT codes?  - US',
                        question: 'What are the 2023-2024 and 2024-2025 CPT codes? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'To access CPT codes online, visit our ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://reimbursement.modernatx.com/'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Billing Codes',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " portal. If you need to speak with a representative for further information, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '27TJybbgkqi4gX95AZDEPg',
                        type: 'Entry',
                        createdAt: '2022-10-26T22:33:19.098Z',
                        updatedAt: '2024-03-04T19:35:09.811Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 42,
                        revision: 12,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'When will my order ship? - US',
                        question: 'When will my order ship?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you made your reservation and confirmed your order prior to June 1, 2024, your products will ship as soon as they are available. Orders placed after June 1 will be fulfilled in the order in which they are received.\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1RYVhxM0ihpnG0h4EWWBN2',
                        type: 'Entry',
                        createdAt: '2022-10-26T22:37:24.834Z',
                        updatedAt: '2024-03-04T19:35:37.294Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 32,
                        revision: 11,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I do if I have issues with my order? - US',
                        question: 'What should I do if I have issues with my order? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7k1yKeNCJU3DfwejqfL0To',
                        type: 'Entry',
                        createdAt: '2023-01-09T20:23:20.405Z',
                        updatedAt: '2024-03-04T19:36:04.796Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 33,
                        revision: 9,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the minimum number of vials/doses I can order? - US',
                        question: 'What is the minimum number of vials/doses I can order? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "You can order a minimum of 10 vials. Each vial contains one (1) vaccine dose, and there are 10 vials/doses in one (1) carton. Moderna vaccines are sold by the carton, and it is not possible to order partial cartons.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6aCUd0orBA6K4v9ayc94m3',
                        type: 'Entry',
                        createdAt: '2023-01-09T20:31:05.354Z',
                        updatedAt: '2024-03-04T19:36:29.869Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 42,
                        revision: 12,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the minimum number of prefilled syringes I can order?  - US',
                        question: 'What is the minimum number of prefilled syringes I can order? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "You can order a minimum of 10 syringes. Each syringe contains one (1) vaccine dose, and there are 10 syringes/doses in one (1) carton. Moderna vaccines are sold by the carton, and it is not possible to order partial cartons.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'sHqA6QdHLHH8G1qr8RteQ',
                        type: 'Entry',
                        createdAt: '2023-08-14T18:01:21.366Z',
                        updatedAt: '2024-03-04T19:37:05.194Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the maximum number of vials/doses I can order? - US',
                        question: 'What is the maximum number of vials/doses I can order?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Currently, there is no limit on the number of vials ordered, though they must be ordered in multiples of 10 (or 1 full carton).\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1L0v8OsUb1zWsz4KRqr6Tb',
                        type: 'Entry',
                        createdAt: '2023-08-14T18:01:58.330Z',
                        updatedAt: '2024-03-04T19:37:25.578Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 6,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the maximum number of pre-filled syringes I can order?  - US',
                        question: 'What is the maximum number of pre-filled syringes I can order? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Currently, there is no limit on the number of syringes ordered. However, for orders of 1,000 or more, please contact your Moderna account representative.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3baYTU4j1lFQBxSVGiH5iW',
                        type: 'Entry',
                        createdAt: '2023-01-09T20:32:03.008Z',
                        updatedAt: '2024-03-04T19:37:46.220Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 18,
                        revision: 7,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Are multi-dose vials available?  - US',
                        question: 'Are multi-dose vials available? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "No, multi-dose vials are not available.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7Ko3abvR1paZCtUVmwcFph',
                        type: 'Entry',
                        createdAt: '2023-01-09T20:45:44.944Z',
                        updatedAt: '2024-03-04T19:43:38.727Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 21,
                        revision: 7,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I order through my distributor? - US',
                        question: 'Can I order through my distributor? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Yes. Check out our list of ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributors.',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " If you can\u2019t find your preferred distributor, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1jcr7aX4GRnPo9oediRcSv',
                        type: 'Entry',
                        createdAt: '2023-01-09T21:49:31.119Z',
                        updatedAt: '2024-03-04T19:44:33.937Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 24,
                        revision: 8,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Are there any quantity discounts? - US',
                        question: 'Are there any quantity discounts?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "There are no additional discounts available beyond your contract affiliation.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7xWZHr2PjK5mJ9tYkLlAzU',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:45:27.608Z',
                        updatedAt: '2024-03-04T19:45:27.608Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'My business is tax-exempt. How can I get this recorded on my account? - US',
                        question: 'My business is tax-exempt. How can I get this recorded on my account? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'Our ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://taxform.modernatx.com/'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Tax Exemption Form Tool',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " is designed to help our valued customers submit their tax exemption certificates. To simplify and expedite this process, the page contains instructions to guide you through a secure process of uploading your tax exemption certificates.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4Vu88k5X1DDkdoJ2QuPmHB',
                        type: 'Entry',
                        createdAt: '2023-01-09T22:05:49.208Z',
                        updatedAt: '2024-03-04T19:46:21.645Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 28,
                        revision: 10,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "What does the order status \u201Cpending\u201D mean? - US",
                        question: "What does the order status \u201Cpending\u201D mean? ",
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'Order status "pending" indicates that ModernaDirect.com has sent your order to the 3PL partner to process, but it hasn\'t been processed and shipped yet.\xa0',
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4kcQbabycuXDBFu6Yz9NyU',
                        type: 'Entry',
                        createdAt: '2023-08-14T18:03:01.033Z',
                        updatedAt: '2024-03-04T19:46:42.462Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the latest time that an order can be placed for next-day delivery?  - US',
                        question: 'What is the latest time that an order can be placed for next-day delivery? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Orders placed before 10am ET can be scheduled for next-day delivery.\xa0 \xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3alIUt5P12EWcscT96a7rO',
                        type: 'Entry',
                        createdAt: '2023-08-14T18:03:47.665Z',
                        updatedAt: '2024-03-04T19:47:05.009Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 11,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I receive an order on a Saturday or Sunday? - US',
                        question: 'Can I receive an order on a Saturday or Sunday? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "We do offer weekend shipping options. However, we ask that you contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) to schedule a weekend delivery.\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '21Va5b3RHBHq3Rirq7z0JO',
                    type: 'Asset',
                    createdAt: '2022-12-29T16:19:31.860Z',
                    updatedAt: '2023-07-26T13:10:18.659Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 10,
                    revision: 2,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Icon Prophylactic Vaccines',
                    description: 'Icon Prophylactic Vaccines',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                        details: {
                            size: 40893,
                            image: {
                                width: 600,
                                height: 600
                            }
                        },
                        fileName: 'Icon_ProphylacticVaccines.png',
                        contentType: 'image/png'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '25xsJYEr8axEnFWQiyVwvw',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Ordering via Authorized Distributor - US',
            name: 'Ordering via Authorized Distributor ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3XvWeWWLVn5a0fxzTCfhis',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:53:35.371Z',
                        updatedAt: '2024-03-04T19:53:35.371Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I order Moderna vaccines through my distributor? - US',
                        question: 'Can I order Moderna vaccines through my distributor? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Moderna works with several ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributors',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " to ensure a smooth customer experience. Customers who order through these distributors are considered \u201Cindirect customers.\u201D\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4ovuY6QwtRsr76Ja1PTANT',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:54:22.685Z',
                        updatedAt: '2024-03-04T19:54:22.685Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What are the benefits of choosing an Authorized Distributor participating in the P.E.R.K. program?  - US',
                        question: 'What are the benefits of choosing an Authorized Distributor participating in the P.E.R.K. program?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'The P.E.R.K. program highlights ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributors',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " that share our commitment to delivering an exceptional experience.\xa0\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [
                                                {
                                                    type: 'bold'
                                                }
                                            ],
                                            value: 'P',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: "referred: They are chosen for their superior service. \xa0\n",
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [
                                                {
                                                    type: 'bold'
                                                }
                                            ],
                                            value: 'E',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: "fficient: They streamline processes for faster customer onboarding. \xa0\n",
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [
                                                {
                                                    type: 'bold'
                                                }
                                            ],
                                            value: 'R',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: "apid: They provide faster shipping options. \xa0\n",
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [
                                                {
                                                    type: 'bold'
                                                }
                                            ],
                                            value: 'K',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: "nowledgeable: They offer overall better service due to their expertise.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Customers ordering via P.E.R.K. distributors will benefit from:\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "An optimized web experience for making advance reservations and regular season orders.\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "Faster account creation: New business accounts can be created, verified, and approved for ordering in 2 business days.\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "A dedicated customer contact for all inquiries (via phone or email, depending on the distributor).\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "2-day shipment for all available products.\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "The option of paying via credit card.\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        }
                                    ],
                                    nodeType: 'unordered-list'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: '',
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2j1HsjRISqj1CkWwtrbzuV',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:58:09.434Z',
                        updatedAt: '2024-03-04T19:58:09.434Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How can I identify distributors that participate in the Moderna P.E.R.K program? - US',
                        question: 'How can I identify distributors that participate in the Moderna P.E.R.K program? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'These distributors will be highlighted on the ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributors',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " page.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3qO7NySzQA47sv2A2gWRKV',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:59:20.224Z',
                        updatedAt: '2024-03-04T19:59:20.224Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'I am an indirect customer (I ordered through a distributor and not directly from Moderna). Whom should I contact for my order queries?\u202f - US',
                        question: 'I am an indirect customer (I ordered through a distributor and not directly from Moderna). Whom should I contact for my order queries?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'You can contact the ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributor',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " you purchased from and they will be able to help you.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3NQgMI6F05sUo2jRGFb0l4',
                        type: 'Entry',
                        createdAt: '2024-03-04T19:59:53.226Z',
                        updatedAt: '2024-03-04T19:59:53.226Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can an Authorized Distributor validate the ship date and speak about the shipping containers and gel packs?\u202f - US',
                        question: 'Can an Authorized Distributor validate the ship date and speak about the shipping containers and gel packs?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Yes, the ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributor',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " will validate the ship date and provide information about the shipping containers, gel packs, and the expected condition of the product upon delivery.\u202F\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3uPn4IhrcmykaFrhbi8UDu',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:00:33.205Z',
                        updatedAt: '2024-03-04T21:14:45.341Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Where do I return my shipment if I\u2019m an indirect customer?\u202F\u202F - US",
                        question: "Where do I return my shipment if I\u2019m an indirect customer?\u202F",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'If you need to return the product, please confirm the return process with your ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributor',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ".\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '4jffF0O6AIwxvkRccnjPZg',
                    type: 'Asset',
                    createdAt: '2024-03-04T19:52:38.274Z',
                    updatedAt: '2024-03-04T19:52:38.274Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Ordering via Authorized Distributor Icon',
                    description: 'Ordering via Authorized Distributor Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($5fed29139c7b3ab0$exports))),
                        details: {
                            size: 2043,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '1.authorizedDealer.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '1L20KgO05pIWHr5ZCxr214',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Reservations - US',
            name: 'Reservations ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1rBDO0t1LzKI4FiYKSyqzy',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:01:57.175Z',
                        updatedAt: '2024-03-04T20:01:57.175Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is a reservation? - US',
                        question: 'What is a reservation? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "A reservation is not an active order\u2014it tells Moderna how much vaccine supply you anticipate needing for your patient population. Reservations allow Moderna to manufacture appropriate quantities of vaccines.\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '30LHtXynOnG1giAaQUUYtj',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:02:28.065Z',
                        updatedAt: '2024-03-04T20:02:28.065Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Is my reservation a commitment to purchase the vaccine? - US',
                        question: 'Is my reservation a commitment to purchase the vaccine? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "No. Any reservation you made will not become a commitment to purchase the vaccine until you convert it to an order.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '29Q1L3ztybXOfCTQnNTpfS',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:02:54.519Z',
                        updatedAt: '2024-03-04T20:02:54.519Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'When does the reservation window open for 2024-2025 COVID-19 vaccines? - US',
                        question: 'When does the reservation window open for 2024-2025 COVID-19 vaccines?',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Customers who are currently registered with Moderna and have placed direct orders with us in the past will begin receiving invitations to make reservations beginning in early March 2024. As we continue to expand access to the reservation process over the following weeks, other customers will receive an email alerting them to the day when their registration window begins.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4ZH6hUHPTHBZFzHbE5ZQ57',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:04:15.566Z',
                        updatedAt: '2024-03-04T20:04:15.566Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the last day I can reserve my vaccine supply on ModernaDirect.com?  - US',
                        question: 'What is the last day I can reserve my vaccine supply on ModernaDirect.com?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "The last day to place a reservation for priority delivery is June 1, 2024. After this date, orders will be filled based on the order in which they are received.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4pegl2d71b9r0WsHMiGLuv',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:04:57.655Z',
                        updatedAt: '2024-03-04T20:04:57.655Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Why should I reserve my vaccine supply in advance instead of waiting until the vaccines are available for shipping?  - US',
                        question: 'Why should I reserve my vaccine supply in advance instead of waiting until the vaccines are available for shipping?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Reserving your vaccine supply in advance grants you access to priority shipping. This means your order confirmed orders will be shipped as soon as the product is available if you made your reservation before June 1, 2024.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3UdUpnf1GJ63QJO7wvCVth',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:05:41.353Z',
                        updatedAt: '2024-03-04T20:05:41.353Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "I made a reservation, but I haven\u2019t heard about my order shipment date. What should I do?  - US",
                        question: "I made a reservation, but I haven\u2019t heard about my order shipment date. What should I do?  ",
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "After you make your reservation, we will send an email when pricing is available and ask you to confirm your order. Unconfirmed orders cannot be shipped.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "If you confirmed your order and have questions about your shipping date that were not answered in Moderna\u2019s email communications to you, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4GihPRBETGXPARRqPiFKuZ',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:06:34.977Z',
                        updatedAt: '2024-03-04T20:06:34.977Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I edit or cancel my reservation?  - US',
                        question: 'Can I edit or cancel my reservation?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Yes, we have enhanced our website to allow customers to edit or cancel their reservations online. Starting in late March 2024, you may edit or cancel your vaccine reservation or update your order details up to one week before it ships.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4BCjwfGD7FiaAg1dM59PEp',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:07:12.179Z',
                        updatedAt: '2024-03-04T20:07:12.179Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I edit my vaccine reservation?  - US',
                        question: 'How do I edit my vaccine reservation?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'In order to give you more control over your reservations, we have enabled a feature to allow direct ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'ModernaDirect.com',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " customers to edit their vaccine reservations directly through the website.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "To edit your reservation:\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: 'Navigate to your ',
                                                            nodeType: 'text'
                                                        },
                                                        {
                                                            data: {
                                                                uri: 'https://modernadirect.com/orders'
                                                            },
                                                            content: [
                                                                {
                                                                    data: {},
                                                                    marks: [
                                                                        {
                                                                            type: 'underline'
                                                                        }
                                                                    ],
                                                                    value: 'order history',
                                                                    nodeType: 'text'
                                                                }
                                                            ],
                                                            nodeType: 'hyperlink'
                                                        },
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: ".\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "Select the reservation you wish to modify.\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        },
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    content: [
                                                        {
                                                            data: {},
                                                            marks: [],
                                                            value: "Input your new reservation details.\xa0\xa0",
                                                            nodeType: 'text'
                                                        }
                                                    ],
                                                    nodeType: 'paragraph'
                                                }
                                            ],
                                            nodeType: 'list-item'
                                        }
                                    ],
                                    nodeType: 'ordered-list'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: '',
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5sbSoRRzc28DhEAgr5yzG4',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:08:02.831Z',
                        updatedAt: '2024-03-04T20:08:02.831Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'I made a reservation, but I need to order more vaccines. Why can\'t I order more than my reservation allocation? - US',
                        question: 'I made a reservation, but I need to order more vaccines. Why can\'t I order more than my reservation allocation? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you wish to order more vaccines than what's listed on your confirmed reservation, a separate sales order is necessary. Please place a separate order for the additional quantity.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: 'HUEjwwBqvw6nVwZ7s7IpM',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:01:36.006Z',
                    updatedAt: '2024-03-04T20:01:36.006Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Reservations Icon',
                    description: 'Reservations Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($c820fe25fa7159b7$exports))),
                        details: {
                            size: 1888,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '2.reservations.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '3wjHHVMeGQ3e5iXpwmFWoD',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Pricing - US',
            name: 'Pricing',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4RrLr6se2T3LzB5vlr92Og',
                        type: 'Entry',
                        createdAt: '2023-01-09T21:43:01.903Z',
                        updatedAt: '2024-03-04T20:10:26.783Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 30,
                        revision: 7,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What does the price include? - US',
                        question: 'What does the price include?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "The price shown on the site is the price per carton (which contains either 10 syringes or vials) This is based on either the list price or the price available to you through your contract affiliation.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7aKqU9avzRnpO2qhza0sgC',
                        type: 'Entry',
                        createdAt: '2023-01-09T21:48:25.728Z',
                        updatedAt: '2024-03-04T20:10:41.880Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 23,
                        revision: 7,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "I don\u2019t think the prices I\u2019m seeing are correct. - US",
                        question: "I don\u2019t think the prices I\u2019m seeing are correct. ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If your contract affiliation is correct, but the prices still seem wrong, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2H0dSm1AoalAAVEWNZO1si',
                        type: 'Entry',
                        createdAt: '2022-10-26T22:29:37.849Z',
                        updatedAt: '2024-03-04T20:11:32.334Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 37,
                        revision: 8,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "How can I see which contract affiliation my account is associated with to ensure I\u2019m receiving the correct price? - US",
                        question: "How can I see which contract affiliation my account is associated with to ensure I\u2019m receiving the correct price? ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "You can view your contract affiliation details by clicking \u201CMy Account.\u201D If you need more guidance on questions related to contract affiliations and pricing, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1hfJLEW2QBd6WFTppDjAwH',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:12:02.892Z',
                        updatedAt: '2024-03-04T20:12:02.892Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the Merck and Moderna Special Offer (MMSO)? - US',
                        question: 'What is the Merck and Moderna Special Offer (MMSO)? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "The MMSO (Merck and Moderna Special Offer) is a collaborative discount program between Moderna and Merck, offering customers an additional 2% discount when they purchase both the VAXNEUVANCE vaccine from Merck and the 2023-2024 Moderna COVID-19 vaccine together.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'PN5rIGT2WHTBQxER0ufgt',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:12:24.652Z',
                        updatedAt: '2024-03-04T20:12:24.652Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I know if I am eligible for the MMSO discount? - US',
                        question: 'How do I know if I am eligible for the MMSO discount? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Eligibility for the MMSO discount requires enrollment and independent validation. Once you register your account on Merck\u2019s website at ",
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://www.mymerckaccounts.com/'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'mymerckaccounts.com',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ", your eligibility will be validated based on your contractual agreements with both Moderna and Merck. \xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4hhEX3j7hS0fVOdupEO4WJ',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:12:47.220Z',
                        updatedAt: '2024-03-04T20:12:47.220Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Is the MMSO discount also applicable on purchases made through distributors? - US',
                        question: 'Is the MMSO discount also applicable on purchases made through distributors? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Yes, the MMSO discount is applicable for products purchased directly from Moderna or via our ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributors',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ". Customers should ensure they are enrolled and validated in the program to receive the discount.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'hUAIYHpiNYkZaDYma0VZ0',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:13:12.018Z',
                        updatedAt: '2024-03-04T20:13:12.018Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How is the MMSO discount administered? - US',
                        question: 'How is the MMSO discount administered? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This will be an on-invoice discount (OID), meaning it will be directly applied to your purchase invoice once your eligibility is confirmed.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'X5e17dI4XUnxd0yhiwJo1',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:13:36.405Z',
                        updatedAt: '2024-03-04T20:13:36.405Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Does the MMSO discount affect other purchase agreements? - US',
                        question: 'Does the MMSO discount affect other purchase agreements? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "No, the MMSO discount is in addition to any discounts you may already have under any other purchase agreements. It does not invalidate or affect the terms of previous purchase agreements.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5mA2jaOzWCcjeBmLVyoZDi',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:14:00.173Z',
                        updatedAt: '2024-03-04T20:14:00.173Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I combine the MMSO discount with other discounts? - US',
                        question: 'Can I combine the MMSO discount with other discounts? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Yes, the MMSO discount is designed to be in addition to any other discounts you receive under different purchase agreements. It provides extra savings on top of what you are already receiving.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '6NE0vQiEELQqjbis2VrANh',
                    type: 'Asset',
                    createdAt: '2023-01-20T13:25:41.119Z',
                    updatedAt: '2023-01-20T13:25:41.119Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 7,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Icon Upward chart',
                    description: 'Icon Upward chart',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($c7568c7a115daefc$exports))),
                        details: {
                            size: 9904,
                            image: {
                                width: 501,
                                height: 500
                            }
                        },
                        fileName: 'Icon Upward chart.png',
                        contentType: 'image/png'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '5VBlfWFhoyq1vfglC5RZBJ',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Payments - US',
            name: 'Payments ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5hWQIf9TDk2uIqcJckxOW2',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:17:09.514Z',
                        updatedAt: '2024-03-29T20:41:30.017Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Does Moderna accept credit card payments? - US',
                        question: 'Does Moderna accept credit card payments? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "We do not accept credit card payments at this time.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5J6yG4qU3Mh7Xohm2UkAb0',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:17:26.557Z',
                        updatedAt: '2024-03-29T20:41:35.375Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 6,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Does Moderna accept ACH payments? - US',
                        question: 'Does Moderna accept ACH payments? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'We do not ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'text',
                                            value: 'accept ACH payments at this time. ',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '2J9y4hFXpMFj6OD9HLfddR',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:16:38.157Z',
                    updatedAt: '2024-03-04T20:16:38.157Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Payments Icon',
                    description: 'Payments Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($dc35ddbb996db4a1$exports))),
                        details: {
                            size: 2775,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '3.Payments.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: 'LJXpAyJ4TU2EJ1zGi4yST',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Shipping - US',
            name: 'Shipping',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5ZU2EhAOzpDXDR0h4h4Jp1',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:32:03.194Z',
                        updatedAt: '2024-03-04T20:32:03.194Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How can I add a new shipping location to my account?  - US',
                        question: 'How can I add a new shipping location to my account?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you need to add a new address, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6F3LAPnT5Pk3Toswv9u53w',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:32:23.848Z',
                        updatedAt: '2024-03-04T20:32:23.848Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I update my shipping address? - US',
                        question: 'How do I update my shipping address? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "In your cart, you can use the drop-down menu to choose an alternate shipping address that you\u2019ve already added to your account. If you need to add a new address, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4R2WfZqGl7wcmGbkgEj1iX',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:32:43.377Z',
                        updatedAt: '2024-03-04T20:32:43.377Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I have my order delivered to more than one address?  - US',
                        question: 'Can I have my order delivered to more than one address?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Yes. In your cart, choose \u201CAdd location\u201D under the current shipping address and select a different address. For each shipping address, select the number of cartons you want delivered to each location.\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6WVZVvKn3Xiq6AM8p6uCrF',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:33:02.979Z',
                        updatedAt: '2024-03-04T20:33:02.979Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why can\u2019t I see all my associated shipping locations?  - US",
                        question: "Why can\u2019t I see all my associated shipping locations?  ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you entered an address but it does not appear as a delivery location option, that means it could not be validated. Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0\xa0\xa0\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '62HJE2UauGMjim6KnoodMS',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:33:25.143Z',
                        updatedAt: '2024-03-04T20:33:25.143Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'In which time zone is the shipment time recorded for direct orders?\u202f - US',
                        question: 'In which time zone is the shipment time recorded for direct orders?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Departing shipments are recorded in Eastern Time (ET). Delivery times are provided in the destination's local time zone.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2epqyFMAI9YaLl4BWqLha5',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:33:49.603Z',
                        updatedAt: '2024-03-04T20:33:49.603Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Who do I contact for inquiries about shipments that are in transit or just delivered?\u202f\u202f - US',
                        question: 'Who do I contact for inquiries about shipments that are in transit or just delivered?\u202f\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'If you ordered through an ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributor',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: ", please reach out to them directly for details on shipping, delivery, and the condition of the product.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'If you ordered directly from Moderna, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\u202f\u202f\u202f\u202f\u202f\u202f',
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1v6uDUCfEco3z4A8EoO5A3',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:34:09.981Z',
                        updatedAt: '2024-03-04T20:34:09.981Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'I have questions about my ship date and transit time. Who should I talk to?\u202f - US',
                        question: 'I have questions about my ship date and transit time. Who should I talk to?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you placed your order directly with Moderna, contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and speak with the Shipping Department for details about ship dates and transit times.\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'WX8ugSSXn5kLcEDpwDa69',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:34:39.124Z',
                        updatedAt: '2024-03-04T20:34:39.124Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What are the packaging dimensions and weight? - US',
                        question: 'What are the packaging dimensions and weight? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Packaging dimensions and weight specifics for 2023-2024 products are:\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Prefilled Syringe Blister Pack: Weight (0.24lbs); Depth (2.25in) Width (5.25in) Height (3.43in) Volume (in3) (38.84in)\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Single-Dose Vial: Weight (0.21lbs); Depth (3.68in) Width (1.54in) Height (2.20in) Volume (in3) (11.76in)\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Information on 2024-2025 products in forthcoming.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '5HQpjj7VcXSfotDHD1Mhdf',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:31:18.285Z',
                    updatedAt: '2024-03-04T20:31:18.285Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Shipping Icon',
                    description: 'Shipping Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($9d9b770e0cd6be72$exports))),
                        details: {
                            size: 882,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '4.Shipping.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '3V2Uucd9KUo2INmsnQwwWZ',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Delivery - US',
            name: 'Delivery ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1N4NM4ESqmEvLLMhX1dERe',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:36:05.059Z',
                        updatedAt: '2024-03-04T20:36:05.059Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'When can I expect my order delivered? - US',
                        question: 'When can I expect my order delivered? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Shipping timelines and dates will be provided once the product is available. If you previously reserved your supply, we will notify you when shipping dates are available so you can confirm your order, shipping address, and desired delivery date.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Following product availability, most products will ship the next day.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'qSh6h1BKvIUOEptpMq55m',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:36:21.539Z',
                        updatedAt: '2024-03-04T20:36:21.539Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Why am I not able to select a preferred delivery date? - US',
                        question: 'Why am I not able to select a preferred delivery date? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "If an order is placed before 1pm EST, the earliest date for requested delivery would be +1 business day from date of order. If an order is placed after 1pm EST, the earliest date for requested delivery would be +2 business days from date of order.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3vB3PJDiVaMgKs2X1JDOk',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:36:39.222Z',
                        updatedAt: '2024-03-04T20:36:39.222Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I verify on the packing list? - US',
                        question: 'What should I verify on the packing list? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Please verify the shipping quantity and the MFR Lot# on the ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/packing-slip'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'packing slip',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ".\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1qlSGiLFHbxcbHVFErls0G',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:36:54.530Z',
                        updatedAt: '2024-03-04T20:36:54.530Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What counts as a small parcel order? - US',
                        question: 'What counts as a small parcel order? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Small parcel orders refer to orders that don't have enough volume for a truck shipment. They are dispatched in containers suitable for the order size, ranging from S to XL. A small parcel refers to an order of less than ~ 130 cartons (1,330 doses).\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4KZzufXdAwVz6abmwXJLff',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:37:14.644Z',
                        updatedAt: '2024-03-04T20:37:14.644Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'When are small parcel orders (< ~130 cartons) shipped out, and when are they expected to be delivered?\u202f - US',
                        question: 'When are small parcel orders (< ~130 cartons) shipped out, and when are they expected to be delivered?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Small parcel orders that are shipped out from Monday to Thursday are expected to be delivered by 10:30am the next day. Orders that are shipped out on Friday are intended for Saturday deliveries and are expected to be delivered between the hours of 9am-5pm. There are no outbound shipments on Saturday or Sunday.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'If a package is at risk of not being delivered on its scheduled day, UPS will make a second attempt before the day ends. If both delivery attempts are unsuccessful, UPS will initiate the "Return to Sender" process automatically.\xa0',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '1Vu7rBb9snk16lKt5bFsbx',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:35:29.143Z',
                    updatedAt: '2024-03-04T20:35:29.143Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Delivery Icon',
                    description: 'Delivery Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($ab9f6abdc0e3fe1c$exports))),
                        details: {
                            size: 948,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '5.Delivery.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '7adD7IA5cqQ31Lf1iIAxRD',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Temperature Monitoring - US',
            name: 'Temperature Monitoring ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6kPVb3yGEeyARLiSE0luei',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:39:33.459Z',
                        updatedAt: '2024-03-04T20:39:33.459Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Is there a temperature monitoring device included in truck shipments?\u202f - US',
                        question: 'Is there a temperature monitoring device included in truck shipments?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "A Sensitech Temperature Monitoring Device (TMD) is included with truck shipments but not with parcel shipments. Small parcel orders use insulated containers with gel packs to maintain the proper temperature during shipment.\u202F\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "For truck orders, there are two TMDs per pallet, and they are located in an upper and a lower area of each pallet.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7H1zNMBkVex5aNM3zMJGXL',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:41:38.154Z',
                        updatedAt: '2024-03-04T20:41:38.154Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I do when I receive my parcel shipment?   - US',
                        question: 'What should I do when I receive my parcel shipment?   ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'ordered-list',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Immediately open the package.\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Verify the contents by confirming they match the packing list.\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Inspect the quality of the contents, i.e., look for signs of tampering, broken seals, etc.\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Place the vaccine in the appropriate storage.\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Repack and return the cooler (using the instructions below).\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: '',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2yO1RpjTgemPaO1WdoF5Cq',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:41:57.518Z',
                        updatedAt: '2024-03-04T20:41:57.518Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I discard the cooler that came with my parcel shipment?   - US',
                        question: 'Can I discard the cooler that came with my parcel shipment?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "No. Please repack and return the cooler components to your regular pick-up person or schedule a pickup via 1-800-PICK-UPS.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '13HKfv8o3hyRgF8SbMG5D2',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:43:56.814Z',
                        updatedAt: '2024-03-04T20:43:56.814Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Is there a return label to send back the cooler?   - US',
                        question: 'Is there a return label to send back the cooler?   ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'The return shipping label can be found on the inside flap of your EcoFlex box. For more information, contact ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'mailto:info@coldchaintech.com'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'info@coldchaintech.com',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ".\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5oNkPrHFzeGWcQwdx6LaRu',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:44:26.986Z',
                        updatedAt: '2024-03-04T20:44:26.986Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I prepare the cooler to send back?  - US',
                        question: 'How do I prepare the cooler to send back?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'ordered-list',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Open the shipper and remove the top Koolit PCM gel pack(s).\xa0\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Remove the vaccine from the inner corrugated box.\xa0\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Ensure the inner corrugated box is back in the EcoFlex shipping system. (IMPORTANT: this will help prevent damage during return.)\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Place the top Koolit PCM gel pack(s) back on top. (IMPORTANT: This will help prevent damage during return.)\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Fold in the original outer flaps. Fold in the remaining flaps and ensure the return shipping label is visible. Tape the seam.\xa0\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'list-item',
                                            data: {},
                                            content: [
                                                {
                                                    nodeType: 'paragraph',
                                                    data: {},
                                                    content: [
                                                        {
                                                            nodeType: 'text',
                                                            value: "Give the cooler to your regular delivery person for return. If you do not have a regular service, call 1-800-PICK-UPS to schedule a pickup from your location.\xa0",
                                                            marks: [],
                                                            data: {}
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: '',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'hlL9y3uo1uxCUgyw0qyqo',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:44:46.663Z',
                        updatedAt: '2024-03-04T20:44:46.663Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the purpose of the gel packs included in the parcel package?\u202f - US',
                        question: 'What is the purpose of the gel packs included in the parcel package?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "The gel packs help maintain the required temperature range during shipment.\u202F\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '68eDcEAPfYA5T8LZR7sFR5',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:45:05.099Z',
                        updatedAt: '2024-03-04T20:45:05.099Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Where can I find the Sensitech Temperature Monitoring Device (TMD) in my parcel order?\u202f - US',
                        question: 'Where can I find the Sensitech Temperature Monitoring Device (TMD) in my parcel order?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Temperature monitoring devices are only included in truck shipments, not in small parcel orders shipped by UPS.\u202F Small parcel orders contain Koolit freeze packs.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'wEnvoQjpDHHNE30gqN2hX',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:45:27.379Z',
                        updatedAt: '2024-03-04T20:45:27.379Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How can I check if the product experienced temperature fluctuations during delivery?\u202f - US',
                        question: 'How can I check if the product experienced temperature fluctuations during delivery?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Small Parcel Orders are shipped in insulated containers (with gel packs) that have been validated to maintain the proper temperature between -50\xb0C and -15\xb0C (-58\xb0F and 5\xb0F) for the duration of the shipment.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Truck Deliveries contain Sensitech Temperature Monitoring Devices. Refer to the attached description from Supply Chain for details on the Temperature Monitoring Device.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '54ISKmlzSuTcjE5zPXnyKt',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:38:25.378Z',
                    updatedAt: '2024-03-04T20:38:25.378Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Temperature Monitoring Icon',
                    description: 'Temperature Monitoring Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($c49339886d9878e2$exports))),
                        details: {
                            size: 1444,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '6.RecievingYourOrder.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '2cDVmsEPE8x2wL7j04C8QK',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Delivery Issues - US',
            name: 'Delivery Issues',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3yvWyd3mt9v4BXc6IxO2HK',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:49:04.742Z',
                        updatedAt: '2024-03-04T20:49:04.742Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I do about a late delivery? - US',
                        question: 'What should I do about a late delivery? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If your delivery is late, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option \u201CIf you are calling about an order including a delivery.\u201D\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Questions associated with product viability will be addressed by Moderna\u2019s Medical Information Contact Center Team.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4jQ3u7ItvOBPgpZB2iT4Bz',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:49:25.814Z',
                        updatedAt: '2024-03-04T20:49:25.814Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I report an incorrect order that I received? - US',
                        question: 'How do I report an incorrect order that I received? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "If you received an incorrect order, check your packing slip to determine if you are a direct or indirect customer. If you are a direct customer, your slip will list \u201CModerna US\u201D as the \u201CSeller.\u201D In that case, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option \u201CIf you are calling about an order including a delivery.\u201D\xa0\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'For Indirect orders, the packing list/invoice will have your ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributor',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " listed as the \u201CSeller.\u201D Indirect customers should contact their ",
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Authorized Distributor',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " directly for assistance.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1uNAjiCEaJyXrPBNmmlPFU',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:49:46.354Z',
                        updatedAt: '2024-03-04T20:49:46.354Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I report a damaged order?  - US',
                        question: 'How do I report a damaged order?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'If you placed your order directly with Moderna please contact the Moderna customer care team at 1-866-MODERNA (1-866-663-3762). If you placed your order via an ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributor',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " please contact them for assistance.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '56WcPXSXiTc44PrdoKb6i',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:50:06.988Z',
                        updatedAt: '2024-03-04T20:50:06.988Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the process for orders delivered to the wrong address or department?\u202f - US',
                        question: 'What is the process for orders delivered to the wrong address or department?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option \u201CIf you are calling about an order including a delivery.\u201D\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Questions associated with product viability will be addressed by Moderna\u2019s Medical Information Contact Center Team.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1CLhH904ZTt20ZDJPpFRZA',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:50:34.633Z',
                        updatedAt: '2024-03-04T20:50:34.633Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I do if my shipment was left out for an extended period after delivery?\u202f\u202f - US',
                        question: 'What should I do if my shipment was left out for an extended period after delivery?\u202f\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "For post-delivery inquiries, such as products left out overnight or for several hours after delivery, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option to report an excursion or product quality concern.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4nfjX4c6XlxmQe0r4b28MT',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:50:51.784Z',
                        updatedAt: '2024-03-04T20:50:51.784Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How can I assess the stability of the product when the gel packs in my parcel order are partially or completely thawed?\u202f - US',
                        question: 'How can I assess the stability of the product when the gel packs in my parcel order are partially or completely thawed?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you are concerned with temperature monitoring during shipment and/or if the Koolit freeze pack appears melted or \u201Cslushy,\u201D please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\u202F\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3N2G99J0SYuFt2tAPm0cui',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:51:16.492Z',
                        updatedAt: '2024-03-04T20:51:16.492Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What should I do if the Sensitech Temperature Monitoring Device in my truck shipment expired or if there are issues during delivery?\u202f - US',
                        question: 'What should I do if the Sensitech Temperature Monitoring Device in my truck shipment expired or if there are issues during delivery?\u202f ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option \u201CFor medical questions or temperature excursions.\u201D\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Moderna\u2019s Shipping Team will handle the inquiry and advise on the viability of the product based on the ship date.\u202F\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '56GhNyvmcVonaDMuswoi5y',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:51:47.076Z',
                        updatedAt: '2024-03-04T20:51:47.076Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How can I assess the stability of the product when the product is partially or completely thawed?\u202f - US',
                        question: 'How can I assess the stability of the product when the product is partially or completely thawed?\u202f ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Upon receiving your delivery, immediately follow these steps:\u202F\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Packaging Inspection: Upon receipt, inspect the packaging for any signs of damage or compromise to the Koolit freeze pack, Temperature Monitoring Device, or the vaccine vials. Physical damage could potentially affect the temperature control and, thereby, the stability of the vaccine.\u202F\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Vaccine Condition: Check the condition of the vials upon receipt. Any changes in color or the presence of particles could indicate a stability issue. If you suspect this is the case, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "Storage Conditions Post-Delivery: Ensure that vaccines are stored under recommended conditions immediately after the package is opened.\u202F\xa0\n\xa0\nRemember to follow the ",
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'specific guidelines',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " provided for the storage and handling of Moderna vaccines to ensure their efficacy.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5XYn2ami8fpDNGyzysKnq5',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:53:29.706Z',
                        updatedAt: '2024-03-04T20:53:29.706Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'To whom do I direct questions about temperature excursion and/or vaccine viability? - US',
                        question: 'To whom do I direct questions about temperature excursion and/or vaccine viability? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If the order was placed via 1-866-MODERNA, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you\u2019re an indirect customer with questions regarding temperature excursions or vaccine viability, contact your ",
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://modernadirect.com/authorized-distributor'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'Authorized Distributor',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: '.',
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '6vH5MC5BRbIWXUcbhiQtEi',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:48:15.899Z',
                    updatedAt: '2024-03-04T20:48:15.899Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Delivery Issues/troubleshooting Icon',
                    description: 'Delivery Issues/troubleshooting Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($bcf4b90d834d9c07$exports))),
                        details: {
                            size: 2025,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '8.deliveryissues.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '1e1pyDFGGOUcA9FSd2Ig1G',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Storage & Usage - US',
            name: 'Storage & Usage',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '7h37T6ygJwNhh73fpzs3ht',
                        type: 'Entry',
                        createdAt: '2023-01-09T20:51:35.401Z',
                        updatedAt: '2024-03-04T20:55:26.879Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 43,
                        revision: 9,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How do I store and handle the product? - US',
                        question: 'How do I store and handle the product?',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Please follow the ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'specific guidelines',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " for the storage and handling of the vaccines to ensure their efficacy.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'l8B7JSAhSJEXj1hHljbdj',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:55:50.783Z',
                        updatedAt: '2024-03-04T20:55:50.783Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I re-freeze a vaccine once it has been thawed?  - US',
                        question: 'Can I re-freeze a vaccine once it has been thawed?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "No, vaccines cannot be refrozen.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6dudVXkJ2xRosztvZl5TLi',
                        type: 'Entry',
                        createdAt: '2023-08-14T17:57:30.330Z',
                        updatedAt: '2024-03-04T20:56:44.673Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 16,
                        revision: 4,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is the recommended needle length and gauge needed for administering the vaccine?  -US',
                        question: 'What is the recommended needle length and gauge needed for administering the vaccine? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'Clinical judgment should be used when administering the vaccine. Please visit the ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'https://www.cdc.gov/vaccines/hcp/admin/downloads/vaccine-administration-needle-length.pdf'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: "CDC\u2019s guidelines",
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: " or call our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '51MiVX0gATHqRpMDE6YKQc',
                        type: 'Entry',
                        createdAt: '2023-09-11T20:26:45.590Z',
                        updatedAt: '2024-03-04T20:56:59.226Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Will needles be supplied for vaccine vials? - US',
                        question: 'Will needles be supplied for vaccine vials? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "No, we do not supply needles with orders.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '3oNZtV07gpXTsnf7wMSPTX',
                    type: 'Asset',
                    createdAt: '2023-05-08T16:52:21.575Z',
                    updatedAt: '2023-05-08T16:52:21.575Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Moderna_Icon_accessMedicine',
                    description: 'Access Medicine Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($9c92cc09aed2a367$exports))),
                        details: {
                            size: 39343,
                            image: {
                                width: 600,
                                height: 600
                            }
                        },
                        fileName: 'accessMedicine.png',
                        contentType: 'image/png'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: 'ibxOxjjfx6Zd11ku1Rx6b',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Returns - US',
            name: 'Returns ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '2zBG4m5kqr43gbHKiBTXfy',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:59:12.158Z',
                        updatedAt: '2024-03-04T20:59:12.158Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'What is your return policy?  - US',
                        question: 'What is your return policy?  ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "If you need to return vaccines because there was a problem with your shipment (such as a temperature excursion), please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "The policy for end-of-season returns of unused products will vary by contract. Please consult your contract for more information about return eligibility and guidelines or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) if you still have questions.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'RZLgzJ0kQVm711RS37YZy',
                        type: 'Entry',
                        createdAt: '2024-03-04T20:59:40.951Z',
                        updatedAt: '2024-03-04T20:59:40.951Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I return unused Spikevax vaccines?  - US',
                        question: 'Can I return unused Spikevax vaccines?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: 'If you need to return your Spikevax products due to a shipping error, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). For end-of-season returns, see our ',
                                            nodeType: 'text'
                                        },
                                        {
                                            data: {
                                                uri: 'https://modernadirect.com/return-goods-policy'
                                            },
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    value: 'Vaccine Product Return Policy',
                                                    nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'hyperlink'
                                        },
                                        {
                                            data: {},
                                            marks: [],
                                            value: " or your contract for specific details.\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '24J8yiYWPw56NYDLge8wHD',
                        type: 'Entry',
                        createdAt: '2024-03-04T21:00:01.057Z',
                        updatedAt: '2024-03-04T21:00:01.057Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Can I return unused pediatric COVID-19 vaccines? - US',
                        question: 'Can I return unused pediatric COVID-19 vaccines? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "All privately purchased pediatric COVID-19 vaccine doses (NDC No. 80777-0287-92) purchased on or after January 9, 2024 will be 100% returnable for the entire season, pursuant to the return policies and procedures provided in your contract with Moderna.\xa0\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                },
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: 'If you placed an order with us through ',
                                            marks: [],
                                            data: {}
                                        },
                                        {
                                            nodeType: 'hyperlink',
                                            data: {
                                                uri: 'http://www.modernadirect.com/'
                                            },
                                            content: [
                                                {
                                                    nodeType: 'text',
                                                    value: 'ModernaDirect.com',
                                                    marks: [
                                                        {
                                                            type: 'underline'
                                                        }
                                                    ],
                                                    data: {}
                                                }
                                            ]
                                        },
                                        {
                                            nodeType: 'text',
                                            value: ", please call our Customer Care Team at 1-866-MODERNA (1-866-663-3762) between 8:00AM - 8:00PM EST, Monday - Friday (excluding holidays).\xa0\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5RbYS911KrhmNHoGey0quP',
                        type: 'Entry',
                        createdAt: '2024-03-04T21:00:16.978Z',
                        updatedAt: '2024-03-04T21:00:16.978Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Will I be entitled to a full refund if I return part of an order?  - US',
                        question: 'Will I be entitled to a full refund if I return part of an order?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Your refund terms depend on your specific contract. If you still have questions about what you can return and the type of refund or credit you will receive, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5iOpOR6CDL0vy78xiFJgt3',
                        type: 'Entry',
                        createdAt: '2024-03-04T21:00:34.396Z',
                        updatedAt: '2024-03-04T21:00:34.396Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'How much of my order is eligible for return?  - US',
                        question: 'How much of my order is eligible for return?  ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Return policies vary by contract. Please consult your contract for more information about return eligibility and guidelines.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3wlhlOCUTWTWdZMlroWQmB',
                        type: 'Entry',
                        createdAt: '2024-03-04T21:01:14.944Z',
                        updatedAt: '2024-03-04T21:01:14.944Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'I received an incorrect order, or my products were damaged during shipping. How do I return these products? - US',
                        question: 'I received an incorrect order, or my products were damaged during shipping. How do I return these products? ',
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option \u201CIf you are calling about an order including a delivery.\u201D\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "Your call will be routed to our Shipping Team, and they will validate the return request & issue a Return Materials Authorization (RMA).\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "If the excursion happened during the shipping process or upon delivery, our Shipping Team will validate the information. If there was a post-delivery excursion Moderna\u2019s Medical Information Contact Center Team will validate the information.\xa0\xa0\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                },
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "If there was an order entry error (either by Moderna, or the Customer), the Moderna Commercial Operations Team will validate the return request and ask the Shipping Team to issue an RMA and process credit upon receipt of the product.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7iOWBmppZrkK5s40UUIzOV',
                                type: 'Entry',
                                createdAt: '2023-09-28T22:24:03.948Z',
                                updatedAt: '2023-09-28T22:24:03.948Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '634MGB1iRc2Bb1zuqBFPEn',
                    type: 'Asset',
                    createdAt: '2024-03-04T20:58:30.633Z',
                    updatedAt: '2024-03-04T20:58:30.633Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Returns Icon',
                    description: 'Returns Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($9c92cc09aed2a367$exports))),
                        details: {
                            size: 1386,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '9.returns.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7iOWBmppZrkK5s40UUIzOV',
                    type: 'Entry',
                    createdAt: '2023-09-28T22:24:03.948Z',
                    updatedAt: '2023-09-28T22:24:03.948Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 3,
                    revision: 1,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '577KhhCkIQaRgR4CtIQ5ou',
            type: 'Entry'
        }
    },
    {
        fields: {
            title: 'Website Troubleshooting  - US ',
            name: 'Website Troubleshooting ',
            faqEntries: [
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '14dr2GVLfS4UDwV7ORa79k',
                        type: 'Entry',
                        createdAt: '2023-01-09T22:07:06.329Z',
                        updatedAt: '2024-03-04T21:02:37.527Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 20,
                        revision: 8,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why don\u2019t I see my orders when I click on \u201CView my orders\u201D CTA in order acknowledgement page? - US",
                        question: "Why don\u2019t I see my orders when I click on \u201CView my orders\u201D CTA in order acknowledgement page? ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "There could be a minute lag to see your cart is submitted with multiple delivery addresses; please refresh your page after a minute to see your order history.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5fS7J4YawI4BByEeq5YegN',
                        type: 'Entry',
                        createdAt: '2023-08-14T17:50:24.479Z',
                        updatedAt: '2024-03-04T21:02:53.564Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 8,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Why do I see "Your cart has been updated as product(s) in your cart are no longer available" pop up? - US',
                        question: 'Why do I see "Your cart has been updated as product(s) in your cart are no longer available" pop up? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop up occurs when selected products are no longer available in the inventory to be ordered and hence your cart has been updated to not show that product(s).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '5Bsa9YR3Vhy1T7OetEUNLk',
                        type: 'Entry',
                        createdAt: '2023-08-14T17:52:07.180Z',
                        updatedAt: '2024-03-04T21:03:09.662Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 6,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Why do I see "Your cart has been updated as quantities selected in your cart are no longer available" pop up? -US',
                        question: 'Why do I see "Your cart has been updated as quantities selected in your cart are no longer available" pop up? ',
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop up occurs when selected doses are no longer available in the open / global inventory and hence your cart has been updated to reflect the maximum doses available to order.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: 'FTKVTdZ0iXJeAN247sFeY',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:20:18.702Z',
                        updatedAt: '2024-03-04T21:03:42.022Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 12,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CQuantity exceeds available inventory\u201D pop up? - US",
                        question: "Why do I see \u201CQuantity exceeds available inventory\u201D pop up?",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop up occurs when quantity that you selected exceeds the open / global inventory level maintained for the selected product(s)\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '656ghvJjS2YUn2twwa521n',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:23:10.875Z',
                        updatedAt: '2024-03-04T21:04:03.767Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 9,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CQuantity selected at delivery level for the product do not add up to total quantity for the product\u201D pop up? - US",
                        question: "Why do I see \u201CQuantity selected at delivery level for the product do not add up to total quantity for the product\u201D pop up? ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop up occurs when quantities requested for each delivery location do not add up to the total quantity of the SKU/Product.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '4Rx7cRTb0RBB7aM39gvzU4',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:26:19.231Z',
                        updatedAt: '2024-03-04T21:04:26.306Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CMaximum line items have been reached in the cart\u201D pop up? - US",
                        question: "Why do I see \u201CMaximum line items have been reached in the cart\u201D pop up?",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop up occurs when the total line items in the cart exceeds 99. A separate sales order would be required to accommodate any additional line item.\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '494slywfpUOcV7BJXvfpa8',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:26:52.243Z',
                        updatedAt: '2024-03-04T21:04:51.696Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 9,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201Cproduct is now out of stock\u201D pop up?  - US",
                        question: "Why do I see \u201Cproduct is now out of stock\u201D pop up? ",
                        answer: {
                            data: {},
                            content: [
                                {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            marks: [],
                                            value: "This pop up occurs when the product is no longer available to be ordered.\xa0",
                                            nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                }
                            ],
                            nodeType: 'document'
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '1prfBEzA5B8cw9iIRBEFTI',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:27:18.338Z',
                        updatedAt: '2024-03-04T21:05:18.551Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 9,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CAn error occurred, the issue may be temporary. Please try again\u201D pop up? - US",
                        question: "Why do I see \u201CAn error occurred, the issue may be temporary. Please try again\u201D pop up? ",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop-up occurs when there\u2019s an unexpected issue. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an \u201CError 500\u201D pop-up, please contact contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6Z2SPc2JrfNjdWCGlZHUX9',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:31:14.129Z',
                        updatedAt: '2024-03-04T21:05:52.235Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 12,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CError 404\u201D pop up? - US",
                        question: "Why do I see \u201CError 404\u201D pop up?",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "You\u2019ll see an \u201CError 404\u201D message if there\u2019s an issue with the page you\u2019re trying to access, or if the page does not exist. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an \u201CError 404\u201D message, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                },
                {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '6G8qosB3C8RjALpLzKqQ5x',
                        type: 'Entry',
                        createdAt: '2023-07-26T13:31:43.146Z',
                        updatedAt: '2024-03-04T21:06:00.499Z',
                        environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 9,
                        revision: 3,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'faqEntries'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: "Why do I see \u201CError 500\u201D pop up? - US",
                        question: "Why do I see \u201CError 500\u201D pop up?",
                        answer: {
                            nodeType: 'document',
                            data: {},
                            content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                            nodeType: 'text',
                                            value: "This pop-up occurs when there\u2019s an unexpected issue. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an \u201CError 500\u201D pop-up, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\xa0",
                                            marks: [],
                                            data: {}
                                        }
                                    ]
                                }
                            ]
                        },
                        country: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'country'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                                        type: 'Asset',
                                        createdAt: '2023-05-24T22:54:50.939Z',
                                        updatedAt: '2023-05-24T22:54:50.939Z',
                                        environment: {
                                            sys: {
                                                id: 'sandbox',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 5,
                                        revision: 1,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'usa flag',
                                        description: 'USA Flag',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                            details: {
                                                size: 2487,
                                                image: {
                                                    width: 36,
                                                    height: 26
                                                }
                                            },
                                            fileName: 'usa_flag.svg',
                                            contentType: 'image/svg+xml'
                                        }
                                    }
                                },
                                locales: [
                                    'en-US'
                                ]
                            }
                        }
                    }
                }
            ],
            icon: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '2nXlMtFKQzomSx5q8uMwAY',
                    type: 'Asset',
                    createdAt: '2024-03-04T21:06:48.634Z',
                    updatedAt: '2024-03-04T21:06:48.634Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                },
                fields: {
                    title: 'Website Troubleshooting Icon',
                    description: 'Website Troubleshooting Icon',
                    file: {
                        url: (0, (/*@__PURE__*/$parcel$interopDefault($2de8fa698a6e3bd0$exports))),
                        details: {
                            size: 1860,
                            image: {
                                width: 120,
                                height: 120
                            }
                        },
                        fileName: '10.troubleshooting.svg',
                        contentType: 'image/svg+xml'
                    }
                }
            },
            country: {
                metadata: {
                    tags: [],
                    concepts: []
                },
                sys: {
                    space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                    },
                    id: '7sht7920U6vs3CLH2CUyaa',
                    type: 'Entry',
                    createdAt: '2023-05-18T03:23:50.744Z',
                    updatedAt: '2023-05-24T22:55:23.250Z',
                    environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                    },
                    publishedVersion: 6,
                    revision: 2,
                    contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'country'
                        }
                    },
                    locale: 'en-US'
                },
                fields: {
                    name: 'United States',
                    isocode: 'US',
                    flag: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                            },
                            id: '3aYCbZJiL8aoEKRdhjOXyy',
                            type: 'Asset',
                            createdAt: '2023-05-24T22:54:50.939Z',
                            updatedAt: '2023-05-24T22:54:50.939Z',
                            environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'usa flag',
                            description: 'USA Flag',
                            file: {
                                url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                            }
                        }
                    },
                    locales: [
                        'en-US'
                    ]
                }
            }
        },
        sys: {
            id: '01HSzJ8lmenE635sqrJjFn',
            type: 'Entry'
        }
    }
];


const $b71e9484be7f94bc$var$FaqBanner = (0, $d8seH.default)('section')(({ backgroundImgUrl: backgroundImgUrl, theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  background: ${primary.main} 0% 0% no-repeat padding-box;
  padding: 97px 0px 70px 22px;
  background-size: 1280px;
  background-image: url(${backgroundImgUrl});
  background-size: cover;
  background-position: 0 -78px !important;
  ${[
        breakpoints.up('md')
    ]} {
    padding-left: 140px;
  }
`);
const $b71e9484be7f94bc$var$FaqPage = ()=>{
    const { faqBannerData: faqBannerData = {}, contactUsData: contactUsData = {} } = (0, $cc18154cd7e9f3c8$export$b266ee7c96751ec9);
    const backgroudnImageUrl = faqBannerData?.fields?.backgroundImage?.fields?.file?.url;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($b71e9484be7f94bc$var$FaqBanner, {
                id: "faqBanner",
                backgroundImgUrl: backgroudnImageUrl,
                "data-testid": "faqBanner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: 'h1',
                        color: "neutral.white",
                        id: "deadLine",
                        "data-testid": "headline",
                        children: faqBannerData?.fields?.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: 'p1',
                        mt: "15px",
                        color: "neutral.white",
                        id: "tagLineText",
                        "data-testid": "tagLineText",
                        children: faqBannerData?.fields?.headline
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d57c4e7117e9f64a$export$2e2bcd8739ae039), {
                faqCategoriesData: (0, $f9d938a75a4c86c0$export$ecc38b4d7bf2ad22)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72ba86933adc7fbf$export$443569d70de2c455), {
                id: "contactUs",
                data: contactUsData
            })
        ]
    });
};
var $b71e9484be7f94bc$export$2e2bcd8739ae039 = $b71e9484be7f94bc$var$FaqPage;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");



var $e4584e896b9229da$exports = {};
$e4584e896b9229da$exports = new URL("brand-strand-bottom.605820f5.png", import.meta.url).toString();


const $997d1ac179c0fa71$var$NotFoundContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  margin: 100px 500px 250px 300px;
  ${[
        breakpoints.down('sm')
    ]} {
    margin: 240px 50px 270px 50px;
  }
`);
const $997d1ac179c0fa71$var$BackgroundContainer = (0, $d8seH.default)('div')(({ NavBGImage: NavBGImage })=>`
    background: url(${NavBGImage});
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: 50%;
    background-position-y: bottom;
    display: flex;
`);
const $997d1ac179c0fa71$var$notFoundPageContent = {
    buttonLabel: 'Continue',
    errorCode: '404',
    headline: 'Page not found',
    message: "We can\u2019t seem to find the page you are looking for."
};
const $997d1ac179c0fa71$var$NotFoundPage = ()=>{
    const { errorCode: errorCode, headline: headline, message: message, buttonLabel: buttonLabel } = $997d1ac179c0fa71$var$notFoundPageContent;
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const returnBtnHandler = ()=>{
        history.push(`/${locale}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($997d1ac179c0fa71$var$BackgroundContainer, {
            NavBGImage: (0, (/*@__PURE__*/$parcel$interopDefault($e4584e896b9229da$exports))),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($997d1ac179c0fa71$var$NotFoundContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h1",
                        sx: {
                            fontFamily: "Aeonik Bold"
                        },
                        "data-testid": "errorCode",
                        children: errorCode
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h3",
                        sx: {
                            fontFamily: "Aeonik Light"
                        },
                        "data-testid": "headline",
                        children: headline
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        sx: {
                            fontFamily: "Aeonik Regular",
                            marginTop: 2,
                            marginBottom: 3
                        },
                        "data-testid": "message",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        onClick: returnBtnHandler,
                        sx: {
                            marginTop: {
                                xs: 7,
                                sm: 3
                            }
                        },
                        "data-testid": "button",
                        children: buttonLabel
                    })
                ]
            })
        })
    });
};
var $997d1ac179c0fa71$export$2e2bcd8739ae039 = $997d1ac179c0fa71$var$NotFoundPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");


const $bcaf6248d8a47a9b$var$CardComponent = ({ title: title, description: description, imageUrl: imageUrl, imageAlt: imageAlt, imageStyle: imageStyle, actions: actions, additionalText: additionalText, sx: sx, cardContentSx: cardContentSx, children: children, factSheetContents: factSheetContents, ...props })=>{
    const theme = (0, $14H9o.default)();
    const cardStyles = {
        bgcolor: 'neutral.white',
        borderRadius: '16px',
        boxShadow: '2px 2px 2px #00000029, -2px 2px 2px #00000029, 0px 2px 2px #00000029',
        ...sx
    };
    // TO-DO: Make these custom css
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
        ...props,
        sx: cardStyles,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                sx: {
                    ...cardContentSx || {
                        padding: '15px 15px 0px 33px'
                    }
                },
                children: [
                    imageUrl && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $891b59d4b36435bb$export$2e2bcd8739ae039), {
                        component: "img",
                        image: imageUrl,
                        alt: imageAlt,
                        sx: imageStyle
                    }),
                    title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        gutterBottom: true,
                        component: "div",
                        fontSize: {
                            xs: '16px',
                            lg: '24px'
                        },
                        paddingTop: '16px',
                        fontFamily: 'Aeonik Regular',
                        fontWeight: 700,
                        lineHeight: '32px',
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: "text.secondary",
                        fontSize: '24px',
                        fontFamily: 'Aeonik Regular',
                        fontWeight: 400,
                        lineHeight: '32px',
                        paddingTop: '16px',
                        children: description
                    }),
                    actions && actions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                        sx: {
                            padding: '16px 0px 0px 0px'
                        },
                        children: actions.map((action, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                size: "small",
                                buttonType: "mds-secondary",
                                ...action,
                                sx: {
                                    textTransform: "none",
                                    ...action.sx || {}
                                },
                                children: action.label
                            }, index))
                    }),
                    factSheetContents && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: "16px",
                        children: factSheetContents.map((factSheetContent, i)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: {
                                    pathname: factSheetContent?.fields?.url
                                },
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontFamily: "Aeonik Regular",
                                    fontSize: "14px",
                                    color: "#0379B2",
                                    children: factSheetContent?.fields?.label
                                })
                            }, i);
                        })
                    })
                ]
            }),
            additionalText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontSize: '14px',
                fontFamily: 'Aeonik Regular',
                fontWeight: 400,
                lineHeight: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '20px 30px',
                children: additionalText
            }),
            children
        ]
    });
};
var $bcaf6248d8a47a9b$export$2e2bcd8739ae039 = $bcaf6248d8a47a9b$var$CardComponent;


const $1cdde51709a29ab4$export$f93b6297146c9743 = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const title = "View and pay invoices";
    const path = "/your-account/invoices-and-payments";
    const buttonLabel = "View invoices";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcaf6248d8a47a9b$export$2e2bcd8739ae039), {
        title: title,
        actions: [
            {
                label: buttonLabel,
                onClick: ()=>{
                    history.push(path);
                },
                sx: {
                    fontSize: '16px',
                    fontWeight: '700',
                    fontFamily: 'Aeonik',
                    lineHeight: '24px'
                },
                buttonType: "mds-outline"
            }
        ],
        sx: {
            width: '345px'
        }
    });
};




var $ayMG0 = parcelRequire("ayMG0");
var $1cb8ad471adb040d$exports = {};
"use strict";
var $1cb8ad471adb040d$var$__createBinding = $1cb8ad471adb040d$exports && $1cb8ad471adb040d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1cb8ad471adb040d$var$__exportStar = $1cb8ad471adb040d$exports && $1cb8ad471adb040d$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1cb8ad471adb040d$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1cb8ad471adb040d$exports, "__esModule", {
    value: true
});

$1cb8ad471adb040d$var$__exportStar((parcelRequire("1BSOA")), $1cb8ad471adb040d$exports);



var $acw62 = parcelRequire("acw62");




var $3bfa0b50aad38c89$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});


var $188c4d0ae107efe1$export$835c547cbe2cd728 = /*#__PURE__*/ function(ReservationStatus) {
    ReservationStatus["Cancelled"] = "CANCELLED";
    ReservationStatus["Created"] = "CREATED";
    ReservationStatus["Ordered"] = "ORDERED";
    ReservationStatus["Pending"] = "PENDING";
    return ReservationStatus;
}({});
var $188c4d0ae107efe1$export$99d2b7f33daa0113 = /*#__PURE__*/ function(ReservationSortableColumnKeys) {
    ReservationSortableColumnKeys["DatePlaced"] = "lastModifiedDate";
    ReservationSortableColumnKeys["Status"] = "reservationStatus";
    return ReservationSortableColumnKeys;
}({});



const $d73108efe3acbaf2$export$20065dcce24d2b33 = async ({ userId: userId, soldToId: soldToId, pageSize: pageSize, pageStartKey: pageStartKey })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `reservationservice/reservations/user/${userId}/soldToOrg/${soldToId}`,
            method: "GET",
            params: {
                pageSize: pageSize,
                pageStartKey: pageStartKey
            }
        });
        return res?.data;
    } catch (error) {
        throw error;
    }
};




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $df17680a7db7c7e3$export$b08b517936747730 = ({ message: message, sx: sx, size: size })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            flexDirection: "column",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Spinner), {
                size: size
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "h6",
                sx: {
                    mt: "spacing-3"
                },
                children: message
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $7424f0b8e60ec1f6$export$68f5e1453c188a82 = ({ page: page, count: count, onPageChange: onPageChange, disabled: disabled = false })=>{
    const isPrevDisabled = disabled || page <= 1;
    const isNextDisabled = disabled || page >= count;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "spacing-10"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    icon: "caret-left",
                    "aria-label": "Go to previous page",
                    variant: "subtle",
                    onClick: ()=>!isPrevDisabled && onPageChange(page - 1),
                    role: "tab",
                    tabIndex: isPrevDisabled ? -1 : 0,
                    disabled: isPrevDisabled,
                    sx: {
                        alignSelf: "center"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    as: "span",
                    sx: {
                        minWidth: "spacing-6",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            fontSize: "font-size-4"
                        },
                        children: [
                            page,
                            " of ",
                            count
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    icon: "caret-right",
                    "aria-label": "Go to next page",
                    variant: "subtle",
                    onClick: ()=>!isNextDisabled && onPageChange(page + 1),
                    role: "tab",
                    tabIndex: isNextDisabled ? -1 : 0,
                    disabled: isNextDisabled,
                    sx: {
                        alignSelf: "center"
                    }
                })
            ]
        })
    });
};


const $1e1629ac55d6f783$var$ActionsComponent = ({ reservation: reservation })=>{
    const isReservationConversionEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_RESERVATIONS_CONVERSION_ENABLED");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const status = reservation.reservationStatus;
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const handleReservationConversionClick = async (reservationId)=>{
        dispatch((0, $c89d887792446c86$export$ca51d8f2e5df1a32)(reservationId));
        history.push(`/${locale}/order-form/complete-reservation`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: isReservationConversionEnabled ? status === (0, $188c4d0ae107efe1$export$835c547cbe2cd728).Pending && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
            onClick: ()=>handleReservationConversionClick(reservation?.reservationId),
            variant: "outline",
            children: "Order Now"
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
            onClick: ()=>{
                if (status === (0, $188c4d0ae107efe1$export$835c547cbe2cd728).Cancelled) history.push(`/${locale}/summary/${reservation?.reservationId}`);
                else history.push(`/${locale}/reservation/${reservation?.reservationId}`);
            },
            variant: "subtle",
            children: status === (0, $188c4d0ae107efe1$export$835c547cbe2cd728).Cancelled ? "View" : "View/Edit"
        })
    });
};
const $1e1629ac55d6f783$export$565ca80fd56969d7 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const [reservationList, setReservationList] = (0, $acw62.useState)();
    const [reservationError, setReservationError] = (0, $acw62.useState)(null);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [pageKeyMap, setPageKeyMap] = (0, $acw62.useState)(new Map());
    const [sortDirection, setSortDirection] = (0, $acw62.useState)((0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC);
    const [sortProperty, setSortProperty] = (0, $acw62.useState)((0, $188c4d0ae107efe1$export$99d2b7f33daa0113).DatePlaced);
    const userId = userData?.userId;
    const soldToId = userData?.soldToAddress?.organizationId;
    const PAGE_SIZE = 10;
    // todo: MD-623 integrate with get reservation by sold to api with year filter
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [yearFilter, setYearFilter] = (0, $acw62.useState)((0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR);
    const [isLoadingReservations, setIsLoadingReservations] = (0, $acw62.useState)(false);
    const reservations = reservationList?.reservationsWithUsers || [];
    const totalPage = reservationList?.totalPages || 0;
    (0, $acw62.useEffect)(()=>{
        const fetchReservations = async ()=>{
            try {
                setIsLoadingReservations(true);
                const pageStartKey = pageKeyMap.get(currentPage);
                // todo: MD-623 integrate with BE for sorting and year filter
                const data = await (0, $d73108efe3acbaf2$export$20065dcce24d2b33)({
                    userId: userId,
                    soldToId: soldToId,
                    pageSize: PAGE_SIZE,
                    pageStartKey: pageStartKey
                });
                setReservationList(data);
                setPageKeyMap((prevMap)=>{
                    const newMap = new Map(prevMap);
                    newMap.set(currentPage + 1, data.pagination.nextPageKey || "");
                    return newMap;
                });
            } catch (error) {
                setReservationError(error?.message || "Failed to fetch reservations");
            } finally{
                setIsLoadingReservations(false);
            }
        };
        fetchReservations();
    // excluding the dependency on `pageKeyMap` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage,
        soldToId,
        userId
    ]);
    const getReservationStatus = (status)=>{
        const formattedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        switch(status){
            case (0, $188c4d0ae107efe1$export$835c547cbe2cd728).Cancelled:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    label: formattedStatus
                });
            case (0, $188c4d0ae107efe1$export$835c547cbe2cd728).Pending:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    sx: {
                        pl: "spacing-3"
                    },
                    children: formattedStatus
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    variant: "success",
                    label: formattedStatus
                });
        }
    };
    const handleSortClick = (property)=>{
        const newSortDirection = sortProperty === property && sortDirection === (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC ? (0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC : (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC;
        setSortDirection(newSortDirection);
        setSortProperty(property);
    };
    const currentYearOption = {
        label: `${(0, $5cdc329eeebd56d0$export$5ea7db4374a8364e)}-${(0, $5cdc329eeebd56d0$export$94e54707343393a0)}`,
        value: (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).CURRENT_YEAR
    };
    const pastYearsOption = {
        label: `2024-${(0, $5cdc329eeebd56d0$export$5ea7db4374a8364e)}`,
        value: (0, $5cdc329eeebd56d0$export$46175cf3c9f87e59).PAST_YEARS
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    sx: {
                        pt: "spacing-6"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "h4",
                        children: "Reservations"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    size: 3,
                    sx: {
                        pt: "spacing-6"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Dropdown), {
                        label: "Select Year",
                        dropdownOptions: [
                            currentYearOption,
                            pastYearsOption
                        ],
                        defaultOption: currentYearOption,
                        onSelectOption: (yearOption)=>{
                            setYearFilter(String(yearOption.value));
                            setCurrentPage(1);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    sx: {
                        pt: "spacing-6"
                    },
                    children: isLoadingReservations ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                        size: "xl"
                    }) : reservationError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            pt: "spacing-6",
                            color: "color-system-red-700"
                        },
                        children: reservationError
                    }) : reservations.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            padding: "spacing-6"
                        },
                        children: "No reservations found."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                size: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Table), {
                                    spacing: "default",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderRow), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).RESERVATION_ID
                                                    }, "reservationId"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).PO_NUMBER
                                                    }, "poNumber"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).PLACED_BY
                                                    }, "placedBy"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).DOSES
                                                    }, "doses"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        onClick: ()=>handleSortClick((0, $188c4d0ae107efe1$export$99d2b7f33daa0113).DatePlaced),
                                                        sortable: true,
                                                        sortKey: (0, $188c4d0ae107efe1$export$99d2b7f33daa0113).DatePlaced,
                                                        sortDirection: sortProperty === (0, $188c4d0ae107efe1$export$99d2b7f33daa0113).DatePlaced ? sortDirection : undefined,
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).DATE_PLACED
                                                    }, "datePlaced"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        onClick: ()=>handleSortClick((0, $188c4d0ae107efe1$export$99d2b7f33daa0113).Status),
                                                        sortable: true,
                                                        sortKey: (0, $188c4d0ae107efe1$export$99d2b7f33daa0113).Status,
                                                        sortDirection: sortProperty === (0, $188c4d0ae107efe1$export$99d2b7f33daa0113).Status ? sortDirection : undefined,
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).STATUS
                                                    }, "status"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$85f47c19c8bcc133).ACTIONS
                                                    }, "actions")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableBody), {
                                            children: reservations.map((reservationWithUser, index)=>{
                                                const { reservation: reservation, placedByUser: placedByUser } = reservationWithUser;
                                                const { reservationNumber: reservationNumber, purchaseOrderNumber: purchaseOrderNumber, lastModifiedDate: lastModifiedDate, reservationStatus: reservationStatus, reservationPricingInfo: reservationPricingInfo } = reservation;
                                                const { firstName: firstName, lastName: lastName } = placedByUser;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: reservationNumber || "--"
                                                        }, "reservationNo"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: purchaseOrderNumber || "--"
                                                        }, "poNumber"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: `${firstName ?? "-"} ${lastName ?? "-"}`
                                                        }, "placedBy"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: reservationPricingInfo?.totalDoses
                                                        }, "doeses"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: lastModifiedDate ? lastModifiedDate.split("T")[0] || "--" : "--"
                                                        }, "datePlaced"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: getReservationStatus(reservationStatus)
                                                        }, "status"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($1e1629ac55d6f783$var$ActionsComponent, {
                                                                reservation: reservation
                                                            })
                                                        }, "actions")
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                sx: {
                                    mt: "spacing-9"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    push: [
                                        0,
                                        3,
                                        5
                                    ],
                                    size: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7424f0b8e60ec1f6$export$68f5e1453c188a82), {
                                        page: currentPage,
                                        count: totalPage,
                                        onPageChange: (page)=>setCurrentPage(page)
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");




var $452bed5787aaaf89$export$e4346b29a12db290 = /*#__PURE__*/ function(OrderStatus) {
    OrderStatus["OnHold"] = "ON_HOLD";
    OrderStatus["InternalHold"] = "INTERNAL_HOLD";
    OrderStatus["Created"] = "CREATED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Confirmed"] = "CONFIRMED";
    OrderStatus["Cancelled"] = "CANCELLED";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["Fulfilled"] = "FULFILLED";
    return OrderStatus;
}({});
var $452bed5787aaaf89$export$d4bf7a4dd3f1fa79 = /*#__PURE__*/ function(MappedOrderStatus) {
    MappedOrderStatus["OnHold"] = "ON_HOLD";
    MappedOrderStatus["Processing"] = "PROCESSING";
    MappedOrderStatus["Cancelled"] = "CANCELLED";
    MappedOrderStatus["Shipped"] = "SHIPPED";
    return MappedOrderStatus;
}({});
var $452bed5787aaaf89$export$166037b82626a0be = /*#__PURE__*/ function(OrderSortableColumnKeys) {
    OrderSortableColumnKeys["DatePlaced"] = "OrderCreateDate";
    OrderSortableColumnKeys["Status"] = "OrderStatus";
    OrderSortableColumnKeys["MappedStatus"] = "MappedOrderStatus";
    return OrderSortableColumnKeys;
}({});



const $7f964e75551fd5cb$export$1952cecf128bb2a0 = async ({ userId: userId, soldToId: soldToId, pageSize: pageSize, pageStartKey: pageStartKey, sortBy: sortBy, sortOrder: sortOrder, year: year })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/orders/user/${userId}/soldToOrg/${soldToId}`,
            method: "GET",
            params: {
                pageSize: pageSize,
                pageStartKey: pageStartKey,
                sortBy: sortBy,
                sortOrder: sortOrder,
                year: year
            }
        });
        return res?.data;
    } catch (error) {
        throw error;
    }
};





var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $50b6c6143ac90d50$var$DEFAULT_START_YEAR = 2024;
const $50b6c6143ac90d50$export$93a5622b17fa503f = ({ value: value, onChange: onChange, startYear: startYear = $50b6c6143ac90d50$var$DEFAULT_START_YEAR })=>{
    const currentYear = new Date().getFullYear();
    // Generate years from currentYear down to startYear
    const options = Array.from({
        length: currentYear - startYear + 1
    }).map((_, i)=>{
        const year = currentYear - i;
        return {
            label: `${year}-${year + 1}`,
            value: year.toString()
        };
    });
    const handleSelect = (option)=>{
        if (option.value !== null) onChange(Number(option.value));
    };
    const defaultOption = options.find((opt)=>Number(opt.value) === value) || options[0];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Dropdown), {
        label: "Select Year",
        dropdownOptions: options,
        defaultOption: defaultOption,
        onSelectOption: handleSelect
    });
};


const $bbb48dbf82cfaaf5$var$ActionsComponent = ({ order: order })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
        onClick: ()=>{
            history.push(`/${locale}/orders/${order?.orderId}`);
        },
        variant: "subtle",
        children: "View"
    });
};
const $bbb48dbf82cfaaf5$export$227e164bac513974 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const [orderList, setOrderList] = (0, $acw62.useState)();
    const [orderError, setOrderError] = (0, $acw62.useState)(null);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [pageKeyMap, setPageKeyMap] = (0, $acw62.useState)(new Map());
    const [sortDirection, setSortDirection] = (0, $acw62.useState)((0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC);
    const [sortProperty, setSortProperty] = (0, $acw62.useState)((0, $452bed5787aaaf89$export$166037b82626a0be).DatePlaced);
    const [totalPage, setTotalPage] = (0, $acw62.useState)(0);
    const PAGE_SIZE = 10;
    const [yearFilter, setYearFilter] = (0, $acw62.useState)(String((0, $5cdc329eeebd56d0$export$5ea7db4374a8364e)));
    const [isLoadingOrders, setIsLoadingOrders] = (0, $acw62.useState)(false);
    const userId = userData?.userId;
    const soldToId = userData?.soldToAddress?.organizationId;
    const orders = orderList?.orders || [];
    (0, $acw62.useEffect)(()=>{
        const fetchOrdersBySoldTo = async ()=>{
            try {
                setIsLoadingOrders(true);
                const pageStartKey = pageKeyMap.get(currentPage);
                const data = await (0, $7f964e75551fd5cb$export$1952cecf128bb2a0)({
                    userId: userId,
                    soldToId: soldToId,
                    sortOrder: sortDirection,
                    sortBy: sortProperty,
                    pageStartKey: pageStartKey,
                    pageSize: PAGE_SIZE,
                    year: yearFilter
                });
                setOrderList(data);
                setPageKeyMap((prevMap)=>{
                    const newMap = new Map(prevMap);
                    newMap.set(currentPage + 1, data.pagination.nextPageKey || "");
                    return newMap;
                });
                if (data.totalPages) setTotalPage(data.totalPages);
            } catch (error) {
                setOrderError(error?.message || "Failed to fetch orders.");
            } finally{
                setIsLoadingOrders(false);
            }
        };
        fetchOrdersBySoldTo();
    // excluding the dependency on `pageKeyMap` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage,
        soldToId,
        sortDirection,
        sortProperty,
        userId,
        yearFilter
    ]);
    const getOrderStatus = (mappedStatus)=>{
        switch(mappedStatus){
            case (0, $452bed5787aaaf89$export$d4bf7a4dd3f1fa79).Cancelled:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    label: "Cancelled"
                });
            case (0, $452bed5787aaaf89$export$d4bf7a4dd3f1fa79).Processing:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    sx: {
                        pl: "spacing-3"
                    },
                    children: "Processing"
                });
            case (0, $452bed5787aaaf89$export$d4bf7a4dd3f1fa79).OnHold:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    variant: "warning",
                    label: "On Hold"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    variant: "success",
                    label: "Shipped"
                });
        }
    };
    const handleSortClick = (property)=>{
        const newSortDirection = sortProperty === property && sortDirection === (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC ? (0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC : (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC;
        setSortDirection(newSortDirection);
        setSortProperty(property);
        setCurrentPage(1); // Reset to first page on sort change
    };
    const handleYearFilterChange = (year)=>{
        setYearFilter(String(year));
        setCurrentPage(1); // Reset to first page on year filter change
        setSortDirection((0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC); // Reset sort direction to default
        setSortProperty((0, $452bed5787aaaf89$export$166037b82626a0be).DatePlaced); // Reset sort property to default
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    sx: {
                        pt: "spacing-6"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "h4",
                        children: "Orders"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    size: 3,
                    sx: {
                        pt: "spacing-6"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50b6c6143ac90d50$export$93a5622b17fa503f), {
                        value: Number(yearFilter),
                        onChange: handleYearFilterChange
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    sx: {
                        pt: "spacing-6"
                    },
                    children: isLoadingOrders ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                        size: "xl"
                    }) : orderError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            pt: "spacing-6",
                            color: "color-system-red-700"
                        },
                        children: orderError
                    }) : orders.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            padding: "spacing-6"
                        },
                        children: "No orders found."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                size: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Table), {
                                    spacing: "default",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderRow), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ORDER_ID
                                                    }, "orderId"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).PO_NUMBER
                                                    }, "poNumber"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).PLACED_BY
                                                    }, "placedBy"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).DOSES
                                                    }, "doeses"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        onClick: ()=>handleSortClick((0, $452bed5787aaaf89$export$166037b82626a0be).DatePlaced),
                                                        sortable: true,
                                                        sortKey: (0, $452bed5787aaaf89$export$166037b82626a0be).DatePlaced,
                                                        sortDirection: sortProperty === (0, $452bed5787aaaf89$export$166037b82626a0be).DatePlaced ? sortDirection : undefined,
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).DATE_PLACED
                                                    }, "datePlaced"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        onClick: ()=>handleSortClick((0, $452bed5787aaaf89$export$166037b82626a0be).MappedStatus),
                                                        sortable: true,
                                                        sortKey: (0, $452bed5787aaaf89$export$166037b82626a0be).MappedStatus,
                                                        sortDirection: sortProperty === (0, $452bed5787aaaf89$export$166037b82626a0be).MappedStatus ? sortDirection : undefined,
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).STATUS
                                                    }, "status"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                                        children: (0, $5cdc329eeebd56d0$export$dc5bdaa405ea2f92).ACTIONS
                                                    }, "actions")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableBody), {
                                            children: orders.map((orderData)=>{
                                                const { orderNumber: orderNumber, purchaseOrderNumber: purchaseOrderNumber, totalQuantity: totalQuantity, orderCreatedDate: orderCreatedDate, mappedOrderStatus: mappedOrderStatus, orderId: orderId } = orderData?.order;
                                                const { firstName: firstName, lastName: lastName } = orderData?.placedByUser;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: orderNumber || "--"
                                                        }, "orderNumber"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: purchaseOrderNumber || "--"
                                                        }, "poNumber"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: `${firstName ?? "-"} ${lastName ?? "-"}`
                                                        }, "placedBy"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: totalQuantity || "--"
                                                        }, "doeses"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: orderCreatedDate.split("T")[0] || "--"
                                                        }, "datePlaced"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: getOrderStatus(mappedOrderStatus)
                                                        }, "status"),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($bbb48dbf82cfaaf5$var$ActionsComponent, {
                                                                order: orderData?.order
                                                            })
                                                        }, "actions")
                                                    ]
                                                }, orderId);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                sx: {
                                    mt: "spacing-9"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    push: [
                                        0,
                                        3,
                                        5
                                    ],
                                    size: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7424f0b8e60ec1f6$export$68f5e1453c188a82), {
                                        page: currentPage,
                                        count: totalPage,
                                        onPageChange: (page)=>setCurrentPage(page)
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};



const $a37463747da681ba$var$BannerContainer = (0, $d8seH.default)('div')(({ aboveFoldBGImage: aboveFoldBGImage, theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    background-color: ${primary.main};
    background-image: url(${aboveFoldBGImage});
    background-size: cover;
    height: 200px;
    width: 100%;
    border-radius: 16px;
    ${[
        breakpoints.down('sm')
    ]} {
        background-image: unset;
    }
    `);
const $a37463747da681ba$var$OrderHistoryPage = ()=>{
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userInfo?.user);
    const oktaID = userData?.authenticatedId || user?.authenticatedId;
    const userId = userData?.userId;
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const isCustomerAccessEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_CUSTOMER_ACCESS_ENABLED");
    const errorMsgHandler = (errorMsg)=>{
        let errMsg = errorMsg ? errorMsg : generalApiError;
        setErrorMsg(errMsg);
        alertRef.current?.openAlert(errorMsg);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                padding: "48px",
                display: "flex",
                flexDirection: "row",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a37463747da681ba$var$BannerContainer, {
                        aboveFoldBGImage: (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: 'h1',
                            color: 'neutral.white',
                            py: '40px',
                            px: {
                                xs: '32px',
                                lg: '100px'
                            },
                            children: "Order History"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cdde51709a29ab4$export$f93b6297146c9743), {})
                ]
            }),
            isCustomerAccessEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e1629ac55d6f783$export$565ca80fd56969d7), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea642245be46668a$export$8a3c17eab1cd9e8), {
                userId: oktaID,
                handleErrorMsg: errorMsgHandler
            }),
            isCustomerAccessEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbb48dbf82cfaaf5$export$227e164bac513974), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51af98075041530d$export$5a15edeb0ee4c09f), {
                userId: userId,
                handleErrorMsg: errorMsgHandler,
                setLoading: setProcessing
            })
        ]
    });
};
var $a37463747da681ba$export$2e2bcd8739ae039 = $a37463747da681ba$var$OrderHistoryPage;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");




const $90eb8642a95071dd$var$NotAuthorizedContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  margin: 100px 500px 250px 300px;
  ${[
        breakpoints.down('sm')
    ]} {
    margin: 240px 50px 270px 50px;
  }
`);
const $90eb8642a95071dd$var$BackgroundContainer = (0, $d8seH.default)('div')(({ NavBGImage: NavBGImage })=>`
    background: url(${NavBGImage});
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: 50%;
    background-position-y: bottom;
    display: flex;
`);
const $90eb8642a95071dd$var$notAuthorizedPageContent = {
    buttonLabel: 'Continue',
    errorCode: '403',
    headline: 'Not Authorized',
    message: 'You are not authorized to access that page.'
};
const $90eb8642a95071dd$var$NotAuthorized = ()=>{
    const { errorCode: errorCode, headline: headline, message: message, buttonLabel: buttonLabel } = $90eb8642a95071dd$var$notAuthorizedPageContent;
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const returnBtnHandler = ()=>{
        history.push(`/${locale}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($90eb8642a95071dd$var$BackgroundContainer, {
            NavBGImage: (0, (/*@__PURE__*/$parcel$interopDefault($e4584e896b9229da$exports))),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($90eb8642a95071dd$var$NotAuthorizedContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h1",
                        sx: {
                            fontFamily: "Aeonik Bold"
                        },
                        "data-testid": "errorCode",
                        children: errorCode
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h3",
                        sx: {
                            fontFamily: "Aeonik Light"
                        },
                        "data-testid": "headline",
                        children: headline
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h6",
                        sx: {
                            fontFamily: "Aeonik Regular",
                            marginTop: 2,
                            marginBottom: 3
                        },
                        "data-testid": "message",
                        children: message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        onClick: returnBtnHandler,
                        sx: {
                            marginTop: {
                                xs: 7,
                                sm: 3
                            }
                        },
                        "data-testid": "button",
                        children: buttonLabel
                    })
                ]
            })
        })
    });
};
var $90eb8642a95071dd$export$2e2bcd8739ae039 = $90eb8642a95071dd$var$NotAuthorized;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $08f0a875c8718f88$exports = {};
$08f0a875c8718f88$exports = new URL("passResetStrand.fa35c967.svg", import.meta.url).toString();



const $b23705dd4e94a9ba$var$BackgroundContainer = (0, $d8seH.default)('div')(({ aboveFoldBGImage: aboveFoldBGImage })=>`
    background: url(${aboveFoldBGImage});
    background-repeat: no-repeat;
    background-position-x: left;
    background-size: 35%;
    background-position-y: bottom;
`);
const $b23705dd4e94a9ba$var$ResetContainer = {
    position: 'relative',
    margin: '120px auto 0 auto',
    display: 'flex',
    marginTop: {
        xs: '60px',
        sm: '120px'
    },
    width: {
        xs: '80%',
        sm: '55%'
    }
};
const $b23705dd4e94a9ba$var$ResetPasswordPage = ()=>{
    const [comp, setComp] = (0, $acw62.useState)('');
    const isASMuser = window.location.href.includes('flow=set');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b23705dd4e94a9ba$var$BackgroundContainer, {
        aboveFoldBGImage: (0, (/*@__PURE__*/$parcel$interopDefault($08f0a875c8718f88$exports))),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: comp === 'newPassword' || comp === 'resetSuccess' || comp === 'tokenExpired' ? $b23705dd4e94a9ba$var$ResetContainer : {},
            "data-testid": "resetPasswordComponent",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07ee858b5cd2ee41$export$a4c3d56613a57187), {
                isASMuser: isASMuser,
                comp: comp,
                setComp: setComp
            })
        })
    });
};
var $b23705dd4e94a9ba$export$2e2bcd8739ae039 = $b23705dd4e94a9ba$var$ResetPasswordPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");



const $aa271e14750b1c51$var$BackgroundContainer = (0, $d8seH.default)('div')(({ aboveFoldBGImage: aboveFoldBGImage })=>`
    background: url(${aboveFoldBGImage});
    background-repeat: no-repeat;
    background-position-x: left;
    background-size: 35%;
    background-position-y: bottom;
`);
const $aa271e14750b1c51$var$ResetContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
    position: relative;
    margin: 120px auto 0 auto;
    display: flex;
    width: 55%;
    ${[
        breakpoints.down('sm')
    ]} {
      margin-top: 60px;
      width: 80%;
    }
`);
const $aa271e14750b1c51$var$RequestResetPasswordPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem("currentUser") && localStorage.getItem("currentUser") !== "underfined") history.push("/home");
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aa271e14750b1c51$var$BackgroundContainer, {
        aboveFoldBGImage: (0, (/*@__PURE__*/$parcel$interopDefault($08f0a875c8718f88$exports))),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($aa271e14750b1c51$var$ResetContainer, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11c5abf0cae7d169$export$c1fd039419f34e83), {})
        })
    });
};
var $aa271e14750b1c51$export$2e2bcd8739ae039 = $aa271e14750b1c51$var$RequestResetPasswordPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");
var $1a57266ead514aeb$exports = {};
$1a57266ead514aeb$exports = new URL("checkBadgeIcon.afd4d34a.svg", import.meta.url).toString();


var $b5f36a46f557dd5c$exports = {};
$b5f36a46f557dd5c$exports = new URL("warningTriangleIcon.e9f92055.svg", import.meta.url).toString();


const $2ff81152e3876597$export$154b1a5455036698 = {
    headlineIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1a57266ead514aeb$exports))),
    headline: "Thanks for verifying your account",
    message: "You can now continue the registration process.",
    callToActionButtonLabel: "Go to Moderna Direct"
};
const $2ff81152e3876597$export$26675fd3bcbccc6b = {
    headlineIcon: (0, (/*@__PURE__*/$parcel$interopDefault($b5f36a46f557dd5c$exports))),
    headline: "Your verification has expired",
    message: "Sorry, for security reasons verification must be completed within 24 hours. We\u2019re happy to resend the verification.",
    callToActionButtonLabel: "Resend verification email"
};
const $2ff81152e3876597$export$1bfc186f45cf6d41 = {
    heading: 'Please check your email',
    mainText: 'In order to make sure we can reach you, please verify your email address.',
    mainTextWithEmail: 'We sent a message to earlthomlinson@gmail.com with instructions.',
    noEmailHeading: "Didn\u2019t get an email?",
    noEmailText: "Please check your spam folder. If you still can\u2019t find it, ",
    NoEmailLink: 'click here to resend the email. ',
    bannerHeader: 'Email successfully re-sent',
    bannerMessage: "If you still don't see it, please check your spam folder. If your organization uses a virus/malware checking system, the  email may take several minutes to arrive."
};




const $b4589177a141e72e$var$CustomContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  margin-top: 48px;
  width: 640px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${[
        breakpoints.down('sm')
    ]} {
    width: 90%;
    margin-top: 10px;
  }
`);
const $b4589177a141e72e$export$fa58fd27b3a2f5ab = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { headlineIcon: HeadlineIcon } = (0, $2ff81152e3876597$export$154b1a5455036698);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b4589177a141e72e$var$CustomContainer, {
        "data-testid": "emailVerificationSucceed",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: HeadlineIcon,
                        alt: 'check badge icon',
                        style: {
                            paddingTop: '5px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h3",
                        color: "#079AE0",
                        children: (0, $2ff81152e3876597$export$154b1a5455036698).headline
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontFamily: "Aeonik Regular",
                fontSize: "16px",
                fontWeight: "400",
                children: (0, $2ff81152e3876597$export$154b1a5455036698).message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        textTransform: 'none',
                        padding: '16px 32px'
                    },
                    buttonType: "mds-primary",
                    onClick: ()=>{
                        history.push(`/home`);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontFamily: "Aeonik Regular",
                        fontSize: "16px",
                        fontWeight: "700",
                        children: (0, $2ff81152e3876597$export$154b1a5455036698).callToActionButtonLabel
                    })
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");





var $acw62 = parcelRequire("acw62");
const $d76ce9d97f337cc8$var$CustomContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  margin-top: 48px;
  width: 640px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${[
        breakpoints.down('sm')
    ]} {
    width: 90%;
    margin-top: 10px;
  }
`);
const $d76ce9d97f337cc8$export$172e7a0436478cc5 = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const { headlineIcon: HeadlineIcon } = (0, $2ff81152e3876597$export$26675fd3bcbccc6b);
    const handleResendVerificationEmail = async ()=>{
        try {
            setProcessing(true);
            // TODO call backend API to resend the email, ECOM-959
            // TODO if the API succeed, then go to the page, ECOM-945, pass in email
            history.push(`/registration/email-verification`);
        } catch (error) {} finally{
            setProcessing(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d76ce9d97f337cc8$var$CustomContainer, {
                "data-testid": "emailVerificationTokenExpired",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: HeadlineIcon,
                                alt: 'warning icon',
                                style: {
                                    paddingTop: '5px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h3",
                                color: "#E8A061",
                                children: (0, $2ff81152e3876597$export$26675fd3bcbccc6b).headline
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontFamily: "Aeonik Regular",
                        fontSize: "16px",
                        fontWeight: "400",
                        children: (0, $2ff81152e3876597$export$26675fd3bcbccc6b).message
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "flex-start",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            sx: {
                                textTransform: 'none',
                                padding: '16px 32px'
                            },
                            buttonType: "mds-primary",
                            onClick: ()=>handleResendVerificationEmail(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "16px",
                                fontWeight: "700",
                                children: (0, $2ff81152e3876597$export$26675fd3bcbccc6b).callToActionButtonLabel
                            })
                        })
                    })
                ]
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $f4538384aa95c560$exports = {};
$f4538384aa95c560$exports = new URL("moderna_logo.5f40215b.svg", import.meta.url).toString();


const $b033f821134f4a52$var$LogoHeader = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "24px 0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        "data-testid": "logoHeader",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            id: "ModernaLogo",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4538384aa95c560$exports))),
            alt: "Moderna Logo",
            width: "158px",
            height: "36px"
        })
    });
};
var $b033f821134f4a52$export$2e2bcd8739ae039 = $b033f821134f4a52$var$LogoHeader;



const $3ee9222543c2cb3d$var$RegistrationConfirmationPage = ()=>{
    const GENERAL_API_ERROR_MESSAGE = 'We have encountered technical difficulties. Please try logging in or contact us at 1-866-MODERNA.';
    const alertRef = (0, $acw62.useRef)(null);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [activateStatus, setActivateStatus] = (0, $acw62.useState)('');
    const urlParams = new URLSearchParams(window.location.search);
    const activateToken = urlParams.get('activateToken');
    const email = urlParams.get('email');
    (0, $acw62.useEffect)(()=>{
        const activateUser = async ()=>{
            if (!activateToken || !email) return;
            try {
                setProcessing(true);
                await (0, $48795288c88243f1$export$2ff5180b1625389f)({
                    emailAddress: email,
                    activationToken: activateToken
                });
                setActivateStatus('succeed');
            } catch (error) {
                setErrorMsg(GENERAL_API_ERROR_MESSAGE);
                alertRef.current?.openAlert(error);
            } finally{
                setProcessing(false);
            }
        };
        activateUser();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                sx: {
                    width: '100%',
                    height: '100vh'
                },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        maxWidth: "640px",
                        width: '60%',
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b033f821134f4a52$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        maxWidth: "640px",
                        width: '60%',
                        "data-testid": "emailVerificationHeader",
                        children: activateStatus === 'succeed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4589177a141e72e$export$fa58fd27b3a2f5ab), {})
                    })
                ]
            })
        ]
    });
};
var $3ee9222543c2cb3d$export$2e2bcd8739ae039 = $3ee9222543c2cb3d$var$RegistrationConfirmationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $dFNG2 = parcelRequire("dFNG2");

var $0tqaY = parcelRequire("0tqaY");

var $6o2lr = parcelRequire("6o2lr");

var $ayMG0 = parcelRequire("ayMG0");
const $9d2a35bf051ea407$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9d2a35bf051ea407$var$defaultTheme = (0, $6o2lr.default)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $0tqaY.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $dFNG2.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $1En50.default)(props, $9d2a35bf051ea407$var$_excluded);
        const ownerState = (0, $8nd05.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $2291beb327d500f8$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $3bYfT = parcelRequire("3bYfT");
var $ba8f795f04ca3e35$exports = {};
$ba8f795f04ca3e35$exports = new URL("printIcon.02e99050.svg", import.meta.url).toString();








var $a20c51406baf1b52$exports = {};
$a20c51406baf1b52$exports = new URL("blupax_logo.3c1b30da.png", import.meta.url).toString();


var $7d45a49ac077699f$exports = {};
$7d45a49ac077699f$exports = new URL("FFF_Logo.a25cb118.png", import.meta.url).toString();


var $0e0dd6e7b37bab81$exports = {};
$0e0dd6e7b37bab81$exports = new URL("henryschein_logo.3df738b8.jpeg", import.meta.url).toString();


var $be3e7e5921dbcd91$exports = {};
$be3e7e5921dbcd91$exports = new URL("Medicomart_Logo.409be29a.png", import.meta.url).toString();


var $4719cea34327bf1f$exports = {};
$4719cea34327bf1f$exports = new URL("Prodigy_Health.ee1cfb95.png", import.meta.url).toString();


const $06eed0502aa587ed$export$90ee43f4b1faff2 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Moderna Authorized Distributors",
                "title": "Moderna Authorized Distributors",
                "slug": "authorized-distributor",
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "4ARxG96zNbND41UTYkRMXi",
                        "type": "Entry",
                        "createdAt": "2023-08-24T18:28:21.731Z",
                        "updatedAt": "2023-08-24T18:28:21.731Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 3,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Moderna Authorized Distributors > Rich Text",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "6YWTBwpSUIAbRG131F5gjc",
                                    "type": "Entry",
                                    "createdAt": "2023-08-24T18:27:45.066Z",
                                    "updatedAt": "2023-08-24T18:27:45.066Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 4,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Moderna Authorized Distributors > Rich Text > Banner",
                                    "headline": "Moderna Authorized Distributors",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "1Px4l8fvDKjBGrRTCqfWrE",
                                            "type": "Asset",
                                            "createdAt": "2022-12-29T16:44:45.722Z",
                                            "updatedAt": "2022-12-29T16:44:45.722Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG strand top right",
                                            "description": "Banner BG strand top right",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner_BG_strand_right.png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "6Zphv8XyZ3pLwqIvNbqUJS",
                                    "type": "Entry",
                                    "createdAt": "2023-08-24T18:28:17.984Z",
                                    "updatedAt": "2024-08-09T18:38:34.853Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 109,
                                    "revision": 23,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Moderna Authorized Distributors > Rich Text > Rich Text Content",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna collaborates with a network of authorized distributors dedicated to ensuring the distribution of our products. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "These distributors are carefully selected based on their commitment to quality, service, and compliance with regulatory standards",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ". They play a crucial role in our supply chain, helping to deliver our products safely and efficiently to healthcare professionals.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "P.E.R.K. Program Partners: ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "P.E.R.K. Program partners are distributors who share our commitment to delivering an exceptional experience for you - including superior service, streamlined processes for onboarding, faster shipping options, and overall distribution expertise. P.E.R.K. partners are highlighted below.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3XwtMAaxeZ6gu0FkSuaMVs",
                                                            "type": "Asset",
                                                            "createdAt": "2024-07-08T13:13:47.262Z",
                                                            "updatedAt": "2024-07-08T13:13:47.262Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 5,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "BluPax Logo",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($a20c51406baf1b52$exports))),
                                                                "details": {
                                                                    "size": 22936,
                                                                    "image": {
                                                                        "width": 262,
                                                                        "height": 68
                                                                    }
                                                                },
                                                                "fileName": "blupax_logo.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.blupaxpharma.com/web/login"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "BluPax",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 732-902-6760 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:info@blupaxpharma.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "info@blupaxpharma.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "5snOVjuY5LkFkeflnOw9sb",
                                                            "type": "Asset",
                                                            "createdAt": "2024-07-08T13:14:13.653Z",
                                                            "updatedAt": "2024-07-08T13:14:13.653Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "FFF Enterprises Logo",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($7d45a49ac077699f$exports))),
                                                                "details": {
                                                                    "size": 11533,
                                                                    "image": {
                                                                        "width": 284,
                                                                        "height": 100
                                                                    }
                                                                },
                                                                "fileName": "FFF Logo.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://ordermyflu.myfluvaccine.com/search?sortCode=relevance&query=:relevance:vaccineType:Covid:manufacturerName:MODERNA%2BUS,%2BINC."
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "FFF Enterprises",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-843-7477 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:fffcustomercare@fffenterprises.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "fffcustomercare@fffenterprises.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "1K6nWFIztprc2rwvDT6C0N",
                                                            "type": "Asset",
                                                            "createdAt": "2024-08-09T18:38:31.793Z",
                                                            "updatedAt": "2024-08-09T18:38:31.793Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 6,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Henry Schein Logo",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($0e0dd6e7b37bab81$exports))),
                                                                "details": {
                                                                    "size": 2931,
                                                                    "image": {
                                                                        "width": 200,
                                                                        "height": 26
                                                                    }
                                                                },
                                                                "fileName": "henryschein logo.jpeg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.henryschein.com/us-en/medical/m/moderna-us-inc"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Henry Schein",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-472-4346",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3DFi4hceLxatmpQX8UH6vZ",
                                                            "type": "Asset",
                                                            "createdAt": "2024-06-12T13:28:46.819Z",
                                                            "updatedAt": "2024-06-12T13:28:46.819Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Medicomart Logo",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($be3e7e5921dbcd91$exports))),
                                                                "details": {
                                                                    "size": 10280,
                                                                    "image": {
                                                                        "width": 278,
                                                                        "height": 39
                                                                    }
                                                                },
                                                                "fileName": "Medicomart Logo.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.medicomart.com/moderna"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Medico Mart",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-242-6248",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "53Y7lrva8ADfIDnidpZl6I",
                                                            "type": "Asset",
                                                            "createdAt": "2024-03-07T18:49:44.901Z",
                                                            "updatedAt": "2024-03-07T18:49:44.901Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 2,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Prodigy Health",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($4719cea34327bf1f$exports))),
                                                                "details": {
                                                                    "size": 25812,
                                                                    "image": {
                                                                        "width": 326,
                                                                        "height": 98
                                                                    }
                                                                },
                                                                "fileName": "Prodigy_Health.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.prodigyhealth.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Prodigy Health",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-877-693-4376",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Full list of authorized distributors:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna does not authorize any distributor without proper vetting, ensuring the integrity and quality of our products.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://asdorder.amerisourcebergen.com/btstoreui/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "AmerisourceBergen/ASD",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-746-6273 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:service@asdhealthcare.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "service@asdhealthcare.com",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.blupaxpharma.com/web/login"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "BluPax",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 732-902-6760 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:info@blupaxpharma.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "info@blupaxpharma.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://market.cardinalhealth.com/login?RelayState=https:%2F%2Fmarket.cardinalhealth.com%2Fhome"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Cardinal Health",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-926-3161",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://ordermyflu.myfluvaccine.com/search?sortCode=relevance&query=:relevance:vaccineType:Covid:manufacturerName:MODERNA%2BUS,%2BINC."
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "FFF Enterprises",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-843-7477 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:fffcustomercare@fffenterprises.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "fffcustomercare@fffenterprises.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.henryschein.com/us-en/medical/m/moderna-us-inc"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Henry Schein",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-472-4346",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.lwdrx.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Louisiana Wholesale Drug",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-960-3784\nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:info@lwdrx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "info@lwdrx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://mms.mckesson.com/catalog?query=moderna&searchWithin=FALSE"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "McKesson MedSurge",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-855-571-2100",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://connect.mckesson.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "McKesson Plasma & Biologics",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-855-625-6285",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.medicomart.com/moderna"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Medico Mart",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-242-6248",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.medline.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Medline",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-633-5463",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.morrisdickson.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Morris & Dickson",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-388-3833 \nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:customerservice@morrisdickson.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "customerservice@morrisdickson.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://mutualdrug.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Mutual Drug",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-800-8551",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.prodigyhealth.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Prodigy Health",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-877-693-4376",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.toprx.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "TopRx",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nPhone: 1-800-542-8677\nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:customerservice@toprx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "customerservice@toprx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Want to order direct? Our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://modernadirect.com/contact-us"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "customer care team",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " is here to support you. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "5nUo6guLfyby4N7ssIMC3G",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




var $177e56bbd05ce163$exports = {};
$177e56bbd05ce163$exports = new URL("DSCSA_Packing_Slip.b8795f59.jpg", import.meta.url).toString();


const $1ce3e70efa9c2e77$export$971388968c550794 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "DSCSA Compliance",
                "title": "DSCSA Compliance ",
                "slug": "dscsa",
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "idiTg3bhIc667MIjHnnfL",
                        "type": "Entry",
                        "createdAt": "2024-05-09T16:41:13.680Z",
                        "updatedAt": "2024-05-09T16:41:13.680Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 4,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "DSCSA > Content",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "6F3Xyxxs4LJIlbJlKLpBKK",
                                    "type": "Entry",
                                    "createdAt": "2024-05-09T16:40:45.214Z",
                                    "updatedAt": "2024-07-01T18:12:53.240Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 8,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "DSCSA > Content > Banner",
                                    "headline": "Welcome to Moderna DSCSA Support",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "message": "Welcome to Moderna DSCSA Support",
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7iOWBmppZrkK5s40UUIzOV",
                                            "type": "Entry",
                                            "createdAt": "2023-09-28T22:24:03.948Z",
                                            "updatedAt": "2023-09-28T22:24:03.948Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 3,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "1zPq5CtQ172JvXpumOhHu1",
                                    "type": "Entry",
                                    "createdAt": "2024-05-09T16:40:49.131Z",
                                    "updatedAt": "2024-07-01T18:12:43.160Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 11,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "DSCSA > Content > Rich Text ",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Thank you for choosing Moderna. As part of the United States\u2019 Drug Supply Chain Security Act (DSCSA), our customers are responsible for ensuring receipt of the DSCSA TI/TS report as part of the commercial goods receipt process.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Title II of Drug Quality and Security Act (DQSA), also known as the DSCSA, requires that Moderna provide an electronic report with transaction information (TI) and transaction statements (TS) of any Moderna goods you have purchased directly from Moderna.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How do I request DSCSA information?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "To access your DSCSA data, please click ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://moderna-prod.launchpad.cfapps.eu10.hana.ondemand.com/0f1c354a-a297-416f-9fac-a7f9a6ebac3c.customerportal.customerportal-0.0.1/index.html"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "here",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For any inquiries about your DSCSA data, please contact Moderna Customer Care Support at:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:WeCare@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "WeCare@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1-866-MODERNA or 1-866-663-3762\nMonday to Friday\n8:00am to 8:00pm EDT",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Please be prepared to provide your Customer Care Representative with the following four pieces of delivery identification characteristics which can be found on your shipment packing slip:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "ordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "'Sold To' or 'Ship To' Company Name",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Delivery Number",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Lot Number",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "\u2018Sold To\u2019 or \u2018Ship To\u2019 Zip Code",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Please note:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "All above data must exactly match the information located on the packing slip.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The Lot Number is equivalent to the Batch Number.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3lZwlO7cRZcQQ4WPVrEHbd",
                                                            "type": "Asset",
                                                            "createdAt": "2024-07-01T18:12:34.753Z",
                                                            "updatedAt": "2024-07-01T18:12:34.753Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "DSCSA Packing Slip",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($177e56bbd05ce163$exports))),
                                                                "details": {
                                                                    "size": 272550,
                                                                    "image": {
                                                                        "width": 1241,
                                                                        "height": 895
                                                                    }
                                                                },
                                                                "fileName": "DSCSA Packing Slip.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "I did not receive my data, or the data received is incorrect.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Please reach out to Moderna Customer Care Support for assistance. Be prepared to provide your key delivery identification characteristics (Company Name, Delivery Number, Lot/Batch Number, \u2018Sold To\u2019/\u2019Ship To\u2019 Zip Code) to allow your Customer Care Team Representative to open an investigation of your DSCSA data.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "1gyRTfI0RX6WX66ITwL9uA",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




var $ddb80c1e8544a3bb$exports = {};
$ddb80c1e8544a3bb$exports = new URL("GAME_Timeline-graphic.6f402fc9.png", import.meta.url).toString();


const $ad4d48767f20373d$export$706eb9ec8966017 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Group Advantage Marketing Engine (GAME)\u200B",
                "title": "Group Advantage Marketing Engine (GAME)\u200B",
                "slug": "game",
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "1hFZIPKlRZHcqtPjoq3cIu",
                        "type": "Entry",
                        "createdAt": "2024-06-06T13:25:10.470Z",
                        "updatedAt": "2024-06-06T13:25:10.470Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 4,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "GAME > Content ",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5iOZJVfPLRHltKZYu6XLDV",
                                    "type": "Entry",
                                    "createdAt": "2024-06-06T13:25:00.461Z",
                                    "updatedAt": "2024-06-07T20:20:11.416Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 14,
                                    "revision": 4,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "GAME > Content > Banner",
                                    "headline": "The Moderna Group Advantage Portal  ",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "message": "The Moderna Group Advantage Portal  ",
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7iOWBmppZrkK5s40UUIzOV",
                                            "type": "Entry",
                                            "createdAt": "2023-09-28T22:24:03.948Z",
                                            "updatedAt": "2023-09-28T22:24:03.948Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 3,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "2DyJH2iPzxnQWniWAk7Kab",
                                    "type": "Entry",
                                    "createdAt": "2024-06-06T13:25:08.436Z",
                                    "updatedAt": "2024-06-10T20:44:06.753Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 97,
                                    "revision": 26,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "GAME > Content > Rich Text ",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Welcome to Your Exclusive Resource Center\xa0",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "As part of our commitment to enhancing healthcare delivery, we\u2019ve created an exclusive suite of resources that you can deliver to your partner practices to help them enhance their vaccination efforts. \xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Bookmark this page and check back often \u2013 you'll find all the latest news on vaccine availability, ordering, and shipping, along with a range of materials specifically developed to aid practices in reaching and educating both staff and patients effectively during the vaccination season.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Contract Announcement:  ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Contract details are still being finalized. When ready, you\u2019ll find a PDF outlining the contract announcement here that you can share with your members, along with an email template you can send out with your logo added.\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2024-2025 Vaccine Schedule Key Dates\xa0",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "5xB9gwsnDpWm4ASXjvWFhZ",
                                                            "type": "Asset",
                                                            "createdAt": "2024-06-06T20:08:02.823Z",
                                                            "updatedAt": "2024-06-25T16:58:48.513Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 19,
                                                            "revision": 5,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "GAME Timeline Graphic",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($ddb80c1e8544a3bb$exports))),
                                                                "details": {
                                                                    "size": 348128,
                                                                    "image": {
                                                                        "width": 3045,
                                                                        "height": 752
                                                                    }
                                                                },
                                                                "fileName": "GAME_Timeline-graphic.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "pmizZPxOVpTC7eH87lkBP",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




var $28302f561e2207b9$exports = {};
$28302f561e2207b9$exports = new URL("Packing_Slip.4bdd0f9b.png", import.meta.url).toString();


var $c2d2c84b10efddd4$exports = {};
$c2d2c84b10efddd4$exports = new URL("Step_1.e56e97a7.jpg", import.meta.url).toString();


var $08d8226589cc99d4$exports = {};
$08d8226589cc99d4$exports = new URL("Step_2.43f4f32f.jpg", import.meta.url).toString();


var $9536c0193ef903f7$exports = {};
$9536c0193ef903f7$exports = new URL("correct_config_in_baggy_and_ecoflex.b0ba557d.png", import.meta.url).toString();


var $b4ccb8be16b3bff3$exports = {};
$b4ccb8be16b3bff3$exports = new URL("correct_config_in_baggy_and_ecoflex_with_button_press.a220953e.png", import.meta.url).toString();


var $0d84db5762ff260d$exports = {};
$0d84db5762ff260d$exports = new URL("Green.98ed18c1.png", import.meta.url).toString();


var $d2c0d351e0c7f500$exports = {};
$d2c0d351e0c7f500$exports = new URL("Red.94592ce4.png", import.meta.url).toString();


var $54f32ef334452dbc$exports = {};
$54f32ef334452dbc$exports = new URL("Step_3.1e2f18f7.jpg", import.meta.url).toString();


var $4aa997c8ae939bec$exports = {};
$4aa997c8ae939bec$exports = new URL("Step_4.f48884d4.jpg", import.meta.url).toString();


var $3ae43cd64c10ad4f$exports = {};
$3ae43cd64c10ad4f$exports = new URL("Ecoflex_2_Return_Label.40921cfc.png", import.meta.url).toString();


var $521f3ed8385fac52$exports = {};
$521f3ed8385fac52$exports = new URL("Step_6.60378fae.jpg", import.meta.url).toString();


const $44e103941070dfa7$export$e06c56edb605666d = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Packing Slip COVID-19 Vaccine 2023-2024 ",
                "title": "Packing Slip COVID-19 Vaccine 2023-2024 ",
                "slug": "packing-slip",
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "3w8GtOxbb70MlfY4PYDFZ",
                        "type": "Entry",
                        "createdAt": "2023-09-11T19:23:52.310Z",
                        "updatedAt": "2023-09-11T19:23:52.310Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 3,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Packing Slip > Rich Text",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5W9v0SUh4KNW5vqa3BKDnb",
                                    "type": "Entry",
                                    "createdAt": "2023-09-11T19:19:19.970Z",
                                    "updatedAt": "2023-09-11T19:19:19.970Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 4,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Packing Slip > Rich Text > Banner ",
                                    "headline": "Packing Slip",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "1Px4l8fvDKjBGrRTCqfWrE",
                                            "type": "Asset",
                                            "createdAt": "2022-12-29T16:44:45.722Z",
                                            "updatedAt": "2022-12-29T16:44:45.722Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG strand top right",
                                            "description": "Banner BG strand top right",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner_BG_strand_right.png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "message": "Moderna COVID-19 Vaccine 2023-2024 Formula",
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "3pnvYtEnaKNC1tu0vGDaHy",
                                    "type": "Entry",
                                    "createdAt": "2023-09-11T19:23:38.397Z",
                                    "updatedAt": "2024-08-02T16:13:57.929Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 28,
                                    "revision": 3,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Packing Slip > Rich Text > Rich Text  ",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "RECEIVING & UNPACKING STEPS",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "IMMEDIATELY",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " open the cooler.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Locate the slip",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " in your package marked \u201CInstructions for Reading the Temperature Monitoring Device in Your Package\u201D and follow the instructions. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "3. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Compare your packing slip",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " (see example below) to the contents of the cooler to confirm they match.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Inspect the vaccines and report any issues",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " (e.g., broken seal) to our WeCare Team at 1-866-MODERNA (1-866-663-3762).",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "5. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Place vaccines",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " in appropriate storage upon receipt, per package label.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "6. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Repack and return ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "EcoFlex cooler and temperature monitoring device to your regular UPS pick-up person or call 1-800-PICK-UPS to schedule a pickup from your location. (Instructions on returning your box can be found below.) \n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Note: If you receive a KT91 shipper, it will not include a temperature monitoring device, and you may dispose of packing materials.",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "REVIEW YOUR PACKING SLIP ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "6U9UzZAuifs7t5aPhb90H0",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:20:58.347Z",
                                                            "updatedAt": "2024-08-02T16:11:48.594Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 26,
                                                            "revision": 6,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Review Packing Slip ",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($28302f561e2207b9$exports))),
                                                                "details": {
                                                                    "size": 250425,
                                                                    "image": {
                                                                        "width": 1051,
                                                                        "height": 866
                                                                    }
                                                                },
                                                                "fileName": "Packing Slip.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "UNPACKING & RETURNING YOUR ECOFLEX SHIPPER. DO NOT DISPOSE!",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Note: The ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "return shipping label ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "can be found on the inside flap of your EcoFlex shipping box. \nFor more information or if you need assistance, contact ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:WeCare@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "WeCare@modernatx.com",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ". ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 1",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " - Open shipper and remove the top Koolit PCM gel pack(s).",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "L52Cr4k1rtkRjDu8p5SOr",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:21:28.106Z",
                                                            "updatedAt": "2023-09-11T19:21:28.106Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 1",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($c2d2c84b10efddd4$exports))),
                                                                "details": {
                                                                    "size": 49066,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Step 1.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 2 ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "- Remove the vaccine from the inner box and check the temperature monitoring device.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "5Bx5rNjK0iaiMtHp5LV5xr",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:21:54.085Z",
                                                            "updatedAt": "2023-09-11T19:21:54.085Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 2",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($08d8226589cc99d4$exports))),
                                                                "details": {
                                                                    "size": 56915,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Step 2.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "A.\xa0",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "On the inside of the lid, you will see a temperature monitoring device. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "7DMKTBph40MSXutGBz0ZpQ",
                                                            "type": "Asset",
                                                            "createdAt": "2024-08-02T16:12:24.504Z",
                                                            "updatedAt": "2024-08-02T16:12:24.504Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Correct Config Shipper",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($9536c0193ef903f7$exports))),
                                                                "details": {
                                                                    "size": 179937,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 342
                                                                    }
                                                                },
                                                                "fileName": "correct config in baggy and ecoflex.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "B. Do not remove the temperature monitoring device from its pouch. The device needs to be returned to Moderna within the pouch. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "On the outside of the plastic pouch,",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " press and hold the START/STOP button for 5 seconds.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "WimuovbYxTqIzTGi4ryFM",
                                                            "type": "Asset",
                                                            "createdAt": "2024-08-02T16:12:49.291Z",
                                                            "updatedAt": "2024-08-02T16:12:49.291Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Correct Config Button Press",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($b4ccb8be16b3bff3$exports))),
                                                                "details": {
                                                                    "size": 204393,
                                                                    "image": {
                                                                        "width": 341,
                                                                        "height": 341
                                                                    }
                                                                },
                                                                "fileName": "correct config in baggy and ecoflex with button press.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "C. Keep your finger on the button until the light turns a solid color ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "(approximately 5 seconds).  ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "NOTE:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Lights may flash intermittently until a solid color is revealed. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3UsYjkdyajQF6s9Ez5PVLI",
                                                            "type": "Asset",
                                                            "createdAt": "2024-08-02T16:13:19.176Z",
                                                            "updatedAt": "2024-08-02T16:13:19.176Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 3,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Green Light",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($0d84db5762ff260d$exports))),
                                                                "details": {
                                                                    "size": 914,
                                                                    "image": {
                                                                        "width": 42,
                                                                        "height": 42
                                                                    }
                                                                },
                                                                "fileName": "Green.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "GREEN = Your product is ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "ready for use",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ". ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "22ih4u8NIdsZEGp6wxhhGI",
                                                            "type": "Asset",
                                                            "createdAt": "2024-08-02T16:13:36.960Z",
                                                            "updatedAt": "2024-08-02T16:13:36.960Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 3,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Red Light",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($d2c0d351e0c7f500$exports))),
                                                                "details": {
                                                                    "size": 812,
                                                                    "image": {
                                                                        "width": 42,
                                                                        "height": 42
                                                                    }
                                                                },
                                                                "fileName": "Red.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "RED = Please ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "quarantine the product",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " and call 1-866-MODERNA (1-866-663-3762) for further assistance. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "To show the color again after it turns off, press and hold the button again for 1 second. ",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 3",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " - To return your shipper, first ensure the inner box is placed back inside the EcoFlex shipping system. IMPORTANT: This will help prevent damage during return.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "M3sgwvMaRDwCr28gA4cu6",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:22:16.995Z",
                                                            "updatedAt": "2023-09-11T19:22:16.995Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 3,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 3",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($54f32ef334452dbc$exports))),
                                                                "details": {
                                                                    "size": 56849,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Step 3.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 4 ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "- Place the top Koolit PCM gel pack(s) back on top. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "IMPORTANT: This will help prevent damage during return. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "5tUTfyRnTjQdv8ClSQMoyD",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:22:33.209Z",
                                                            "updatedAt": "2023-09-11T19:22:33.209Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 4,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 4",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($4aa997c8ae939bec$exports))),
                                                                "details": {
                                                                    "size": 67704,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Step 4.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 5",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " \u2013 Reseal the box by folding in the original outer flaps. Fold in the remaining flaps and ensure the return shipping label is visible. Tape the seam. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "7x2WH3uEpbfVj0nGBa7YEw",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:22:50.430Z",
                                                            "updatedAt": "2024-08-02T16:13:55.224Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 8,
                                                            "revision": 2,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 5",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($3ae43cd64c10ad4f$exports))),
                                                                "details": {
                                                                    "size": 99304,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Ecoflex 2 Return Label.png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Step 6",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " - Give the cooler to your regular delivery person for return. If you do not have regular service, call 1-800-PICK-UPS to schedule a pickup from your location. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3DvnBwCIlz87nQ60Ekjd9p",
                                                            "type": "Asset",
                                                            "createdAt": "2023-09-11T19:23:07.608Z",
                                                            "updatedAt": "2023-09-11T19:23:07.608Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 3,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Packing Slip > Step 6",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($521f3ed8385fac52$exports))),
                                                                "details": {
                                                                    "size": 21419,
                                                                    "image": {
                                                                        "width": 342,
                                                                        "height": 281
                                                                    }
                                                                },
                                                                "fileName": "Step 6.jpg",
                                                                "contentType": "image/jpeg"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "FOR QUESTIONS ABOUT: ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Vaccine temperature excursions after shipment during storage. ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Other vaccine shipment issues (e.g., serialization, shortages, overages, lot number not matching packing slips).",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Modifying or cancelling a future order. ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "CALL 1-866-MODERNA ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "(1-866-663-3762)\nHours: Monday - Friday from 8 am - 8 pm EST (Excluding holidays)",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "EMAIL",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:WeCare@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "WeCare@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "LEGAL-US-COV-2400031   07/2024",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "569NITWgRleqOuPaXjITqh",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $cb949f2f46d032c1$export$125fcbf7cb8dd591 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Participating Physician Buying Groups",
                "title": "Participating Physician Buying Groups",
                "slug": "participating-physician-buying-groups",
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "Dx2mrzerHr6nXy0JiYrXl",
                        "type": "Entry",
                        "createdAt": "2024-03-20T20:36:54.264Z",
                        "updatedAt": "2024-03-20T20:36:54.264Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Participating Physician Buying Groups > Content",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "2HkECAnVEWoNzkeV8Rn1eT",
                                    "type": "Entry",
                                    "createdAt": "2024-03-20T20:36:54.288Z",
                                    "updatedAt": "2024-03-20T20:36:54.288Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 7,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Participating Physician Buying Groups > Content > Banner",
                                    "headline": "Participating Physician Buying Groups",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "1Px4l8fvDKjBGrRTCqfWrE",
                                            "type": "Asset",
                                            "createdAt": "2022-12-29T16:44:45.722Z",
                                            "updatedAt": "2022-12-29T16:44:45.722Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG strand top right",
                                            "description": "Banner BG strand top right",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner_BG_strand_right.png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7iOWBmppZrkK5s40UUIzOV",
                                            "type": "Entry",
                                            "createdAt": "2023-09-28T22:24:03.948Z",
                                            "updatedAt": "2023-09-28T22:24:03.948Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 3,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "6zxWFY2UVBxUNASwUcNl8e",
                                    "type": "Entry",
                                    "createdAt": "2024-03-20T20:36:54.412Z",
                                    "updatedAt": "2024-07-02T15:56:48.750Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 79,
                                    "revision": 10,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Participating Physician Buying Groups > Content > Rich Text",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "By making our products accessible through trusted physician buying groups (PBGs), Moderna aims to support healthcare providers in delivering the best possible care to their patients.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Please note that while Moderna strives to make its products available through a network of trusted PBGs, we do not have direct control over the specific contracts or arrangements between PBGs and their member physicians.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://abcpbg.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Abacus\xa0\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n844-987-4687\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.accessvaccines.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Access Vaccines\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n866-318-6850\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.atlantichealthpartners.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Atlantic Health Partners\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n800-741-2044\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.childrenshospitals.org/childhealthadvantage"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Child Health Advantage (Children\u2019s Hospital Association)\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n913-981-4214\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.cwpurchasing.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "CommonWealth Purchasing Group\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n833-274-0313\u202F\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.cppdocs.org"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "CPP (Children\u2019s Practicing Pediatricians)\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n877-277-9330\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://mainstreetvacs.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Main Street Vaccines\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n888-482-6246\u202F\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://mppg.net"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Medical Practice Purchasing Group (MPPG)\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n818-332-7057\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.nationalpurchasinggroup.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "National Purchasing Group\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n615-390-0702\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.nationalphysiciancare.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "NDC NPC\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n877-598-3286\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://pediatric-alliance.com/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Pediatric Alliance\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n804-310-3068\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://physiciansalliance.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Physician\u2019s Alliance of America\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n866-348-9780\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://prn-gpo.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Physicians Resource Network (PRN)\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n888-PRN-2360\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.primarycarealliance.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Primary Care Alliance\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n801-369-3933\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.practicewell.org"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Physicians\u2019 Buying Group",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n415-963-4444\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.updoctors.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "United Physicians\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n248-593-0100\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://usppg.org"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "USPPG\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n877-MY-USPPG\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.vacconnect.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Vaccine Connect\xa0",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\n843-973-2711\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For more information, please contact your preferred PBG or our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://modernadirect.com/contact-us"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Customer Care Team",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "3UcXz1k6IagTbGFKogiM5w",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




var $cfb9bbabcaebc9c7$exports = {};
$cfb9bbabcaebc9c7$exports = new URL("personal_data.f9fdb5c7.png", import.meta.url).toString();


var $0123010c3c10d239$exports = {};
$0123010c3c10d239$exports = new URL("EU_EEA_UK_Switzerland.90ad35db.png", import.meta.url).toString();


const $01210b9d1ac5edec$export$c89971efab1b6246 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Privacy Policy",
                "title": "Moderna Direct Privacy Policy",
                "slug": "privacy-policy",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "5wVt4P86v56AQIbQiW4uqD",
                        "type": "Entry",
                        "createdAt": "2022-12-02T04:18:46.768Z",
                        "updatedAt": "2022-12-02T04:18:46.768Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 4,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Privacy Policy - Compose: SEO"
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "3LQ4u17dvJworzbcVeWMD",
                        "type": "Entry",
                        "createdAt": "2022-12-02T04:18:46.882Z",
                        "updatedAt": "2023-06-20T16:20:31.348Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 14,
                        "revision": 4,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Privacy Policy - Rich Text Content Page Template",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "4qpojknXqxo8gNLhMxZz5K",
                                    "type": "Entry",
                                    "createdAt": "2022-12-11T23:10:53.907Z",
                                    "updatedAt": "2023-06-16T18:23:32.364Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 7,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Privacy Statement Banner Component",
                                    "headline": "Moderna's Privacy Statement",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "3OFyHSrhG9cqdAH1JtdQcK",
                                    "type": "Entry",
                                    "createdAt": "2023-06-16T18:25:11.324Z",
                                    "updatedAt": "2023-06-16T18:25:11.324Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 3,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "I5IZLNooED1CgxC5Kpr9Z",
                                    "type": "Entry",
                                    "createdAt": "2022-12-11T01:44:45.550Z",
                                    "updatedAt": "2024-07-10T14:10:03.932Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 386,
                                    "revision": 22,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Privacy Policy Rich Text Content Component - US",
                                    "effectiveDateLabel": "Effective",
                                    "effectiveDate": "2023-09-01",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This Privacy Statement describes how Moderna Inc. and its worldwide affiliates (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D) describes how Moderna collects, stores, uses (\u201Cprocesses) your personal data when you:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "use our website ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "hyperlink",
                                                                        "data": {
                                                                            "uri": "https://www.modernatx.com/"
                                                                        },
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "text",
                                                                                "value": "www.modernatx.com",
                                                                                "marks": [],
                                                                                "data": {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": " or any other Moderna website that links to this statement;",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "use any of our other digital services, such as an app provided by Moderna, that link or use this statement; or",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "engage with us through our call centers.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Personal Data\u201D ",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "means information associated with or used to directly or indirectly identify or contact a specific person. Such data can include your name, contact details, relationship with Moderna, etc.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Certain Personal Data, such as information about health or medical status (pursuant to all applicable laws) are characterized as sensitive (collectively, \u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Sensitive Personal Data",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D) and may be subject to stricter regulation and consent requirements than other information.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna recognizes the importance of taking steps to protect the privacy of information we collect, and we are committed to respecting your privacy.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Carefully read this Privacy Statement to learn more about how we collect, use, disclose and store personal data provided and the steps we take to help protect the often-sensitive personal data provided from unauthorized use or disclosure. When you submit information to or through our sites or services, you consent to the collection, processing and retention of your information as described in this Privacy Statement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY STATEMENT, THEN PLEASE DO NOT USE ANY OF THESE SERVICES.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Summary of Key Points",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This summary provides key points from our Privacy Statement, but you can find more information about any of these topics by using the Table of Contents below. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1. How do we process your personal data?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We process your personal data to provide you with the service requested and to improve our service, communicate with you for security purposes and comply with legal obligations. We only process your personal data when we have legal grounds to do so. Please see ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-4-how-we-use-personal-data"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "How We Use Your Personal Data",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " for more details.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2. Do we process sensitive personal data?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may process sensitive personal data when necessary, with your consent or where required by legal obligations. Click ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-1"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "here",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " to learn more about Sensitive Personal Data.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "3. Where will your data be processed by Moderna?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna is a global company which maintains datacenters around the world, including Switzerland and the United States (ModernaTX\u2019s global headquarters). Moderna may process personal data in databases that can be accessed by authorized Moderna personnel worldwide.Transfers of personal data among Moderna and its worldwide affiliates follow applicable laws and our Intracompany Transfer Agreements.Third-party transfers outside of the EU, the EEA, Switzerland or the UK are made in accordance with applicable privacy laws and pursuant to the following safeguard, Standard Contractual Clauses (SCCs) or Model Contracts.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "For information on SCCs, please visit:",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "unordered-list",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "If in EU:",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "hyperlink",
                                                                                        "data": {
                                                                                            "uri": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm"
                                                                                        },
                                                                                        "content": [
                                                                                            {
                                                                                                "nodeType": "text",
                                                                                                "value": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm",
                                                                                                "marks": [],
                                                                                                "data": {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "If in Switzerland:",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "hyperlink",
                                                                                        "data": {
                                                                                            "uri": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647"
                                                                                        },
                                                                                        "content": [
                                                                                            {
                                                                                                "nodeType": "text",
                                                                                                "value": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647",
                                                                                                "marks": [],
                                                                                                "data": {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "If In UK:",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "hyperlink",
                                                                                        "data": {
                                                                                            "uri": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit"
                                                                                        },
                                                                                        "content": [
                                                                                            {
                                                                                                "nodeType": "text",
                                                                                                "value": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit",
                                                                                                "marks": [],
                                                                                                "data": {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4. When and with who do we share your data?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We only will share your data with services providers who support our operations and other parties and business partners in limited circumstances based on legal obligations and as identified in our Privacy Notices.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "5. How do we keep your data protected?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We have technical and organizational safeguards in place to protect your personal data. However, no electronic processing can be guaranteed to be 100% secure, so we cannot promise that hackers, cybercriminals or other unauthorized third parties will not be able to defeat our security and steal or unauthorized access your personal data. Click ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-6-how-information-is-retained-and-secured"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "here",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " to learn more.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "6. What are your rights and how can you exercise them?",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Based on your location, applicable personal data protection laws provide you with certain rights regarding your personal data. You may exercise these rights by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [
                                                                    {
                                                                        "type": "bold"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Please note that this Privacy Statement does not apply to information collected through third-party websites or services that you may access through third-party sites.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Data Controller:",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " The controller of Personal Data collected under this Privacy Statement is ModernaTX, Inc.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This statement is organized into the following sections \u2013 please select your desired topic for further information.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Principles",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We will handle your Personal Data in accordance with applicable laws such as the General Data Protection Regulation (\u201CGDPR\u201D) in the European Union, the Act on the Protection of Personal data of Japan and the Personal data Act of South Korea. It is our goal to do the following:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Process Personal Data lawfully, fairly and in a transparent manner.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Collect Personal Data for a specified, explicit and legitimate purpose, and only use it for the purposes for which it was originally collected.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Limit collection of Personal Data to the extent necessary in relation to the purpose for which it is processed.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Make reasonable efforts to ensure that your Personal Data is accurate and, where necessary, kept up to date.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Store Personal Data for no longer than is necessary for the purpose for which the Personal Data is processed.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Process Personal Data in a manner that provides adequate security and confidentiality.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Our privacy practices are described in greater detail in the remainder of this Privacy Statement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Table of Contents",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1. Information We Collect\n2. How Information is Collected and Used\n3. Links to Other Websites/Services\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4. ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How We Use Personal Data\n5. How Information is Shared and Disclosed\n6. How Information is Retained and Secured\n7. Cookies and Similar Technologies\n8. Your Privacy Rights\n9. Our Children\u2019s Policy\n10. Changes to This Privacy Statement\n11. Jurisdiction-Specific Privacy Information (",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "California, Nevada, EU/EEA, UK & Switzerland, Japan)",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1. Information We Collect",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Depending on your interactions with us, we may collect and process your Personal Data. For example, you may choose to submit your contact information to join our mailing list, engage with us via our Contact Us features, or apply for a job opening with Moderna via the ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/careers/life-at-moderna"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "careers",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " section of our website. As a result, and depending on the type of Service, we may ask you to provide Personal Data, such as your:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "General identification data",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ": initials, name, job title, company name, country, date of birth, age, country, ethnicity (",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "for cases where the Summary of Product Characteristics (SmPC) includes specific information relating to the ethnic origin",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ")",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Contact details",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ": contact number, e-mail address, mailing address",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product use",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ": data related to your use of our products, including feedback and use history",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Professional details (for HCPs)",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ": job title, institute/organization name, additional information about your job role and any other job-related information",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Technical data",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ": IP address, device identifiers, operating system, browsing history, search history, time and duration of use, interaction with content",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Information about your job role",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": " and any other job-related information, work experience, educational background",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Before providing it to us, carefully consider whether to disclose your Sensitive Personal Data. If you do provide Sensitive Personal Data to us, you consent to its use and disclosure for the purposes and in the manner described in this Privacy Statement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "You may visit our website without voluntarily providing any information about yourself. You are not obligated to provide any Personal Data to us, but your ability to use our website or its features, apply for an employment position or report an adverse event may be limited. When calling our call centers, you can choose to remain anonymous unless the collection of personal data is required by law or you provide us with your personal data.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you provide us with Personal Data about another person or allow us to collect it, you acknowledge that you have the authority to share that information and are allowing us to use the information as described in this Privacy Statement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Ordering and Payment Information for Pharmacies and Healthcare Professionals",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "When pharmacies and healthcare professionals place orders for our products and services, we collect and use necessary information to process these transactions. This includes, but is not limited to, payment details (such as credit card numbers and billing addresses), order information, and contact details of the ordering party. This information is used solely for the purposes of fulfilling orders, processing payments, and providing customer support. We are committed to protecting this data in compliance with all relevant privacy and data protection regulations and ensuring that it is handled securely and confidentially.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2. How Information is Collected and Used",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "a. Information that you voluntarily provide",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We collect and use the Personal Data that you voluntarily provide to us by visiting our sites or using our services. You may use certain services without registering or identifying yourself but, if you do not register, you may not have access to all of the services or functionality of the site. If you choose to register, we may use the Personal Data you provide to confirm your registration and to respond to requests from you.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Upon your request, we may also use your Personal Data to send you special promotions or newsletters with information that may interest you.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you are a healthcare professional or an institutional healthcare provider, you are responsible for obtaining any legally required authorization, consent or other permission from your patients prior to providing their Personal Data to Moderna. By submitting any Personal Data about a patient, you represent and warrant to Moderna that you have obtained all required permissions to do so.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "b. Through your use of interactive services",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you choose to participate in our questionnaires and surveys and other interactive services, we will collect the information, including health-related information and other Sensitive Personal Data that you share to help us better understand how Moderna products are used in coping with the diseases for which they are marketed.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "c. When you\u2019re interested in enrolling in a clinical trial",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you submit health-related Personal Data to us to participate in a clinical trial, we may use your Personal Data to assess whether you qualify for enrollment in the trial, to contact you about potential participation in the trial, and to provide you with additional information about the trial.Once enrolled for any questions relating to your participation in a clinical trial, contact the Principal Investigator on the study and/or refer to the trail related information provided to you, e.g., the Informed Consent Form.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "d. When you correspond with Moderna about Moderna products.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you contact Moderna or use the Services to ask questions or report problems regarding your experience in using one of our products, we may use the information you provide in submitting reports to the U.S. Food and Drug Administration, the European Medicines Agency or any other relevant supervisory authority and as otherwise required of us by law. We also may use the information to contact the prescribing physician to follow up regarding an event involving use of our product.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "e. Through data collection tools",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": 'When permitted or you have provided consent, Moderna automatically will collect information about use of the Services through data collection tools, such as web beacons and cookies. A "web beacon" is a piece of code that enables us to monitor user activity and website traffic. A "cookie" is a randomly generated unique numeric code stored in the user\u2019s web browser settings or computer\u2019s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the \u201Clifetime\u201D of the cookie (i.e., when it expires), as well as the randomly generated unique numeric code.',
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For more details, please see ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/cookie-statement"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Moderna\u2019s Cookie Statement",
                                                                "marks": [
                                                                    {
                                                                        "type": "italic"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We use the information collected through data collection tools to monitor usage patterns, store information about user preferences and to improve the Services. For example, your Personal Data may be used to create customized offers, information and services tailored to your interests and preferences. We may track your activities over time and across third-party websites, apps or other online services to display advertisements on third-party websites. If you do not want us to use your information in this way, please see \u201CYour Privacy Choices\u201D below.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We also may collect information about the location of the mobile device or tablet used to access the Services (\u201CLocation Data\u201D). Location Data includes: (i) the location of the mobile device or tablet derived from GPS or WiFi use; (ii) the IP address of the mobile device or tablet or internet service used to access the Services; and (iii) other information made available by a user or others that indicates the current or prior location of the user, such as geotag information in photographs.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "f. Social media connections",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "When accessing the Services through a Facebook or other Social Media account, Moderna may (depending on applicable user privacy settings) automatically have access to information provided to or through the Social Media platform. Moderna may collect and use this information for the purposes described in this Privacy Statement or at the time the information was collected.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "g. Social media plugins",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "When you use services, Social Media operators can place a cookie on your computer to recognize individuals who have visited previously. If you are logged into a Social Media account while using the services, the social plugins allow that Social Media to receive information that you have accessed and used the Services. The social plugins also allow the Social Media operator to share information about your activities in or through the Services with other Social Media users. Moderna does not control any of the content from the Social Media plugins. For more information about Social Media plugins, please refer to any privacy and/or other legal notices of the respective Social Media platform.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "h. Through third parties",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Third parties that assist us with our business operations also collect and use information (including Personal Data and Usage Data) and may share the collected information with us. For example, our vendors collect and share information with us to improve user experience, we may view your LinkedIn profile, or any other publicly available profile.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "When you access any interactive service, you will be asked to affirmatively choose (\"opt in\") to provide the requested information. You may always choose not to provide the requested information but then you may not be able to use the Service as intended.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "3. Links to Other Websites/Services",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "As a convenience to our visitors, this website may contain links to other websites that we believe may offer useful information, but that does not mean that Moderna endorses it, or the quality or accuracy of information presented on it. If you decide to visit a third-party site, you are subject to its privacy practices and not this Privacy Statement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4. How We Use Personal Data",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may use Personal Data for the following purposes.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "a. Consent",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may seek, either directly or through our trusted third parties, your separate consent to process your Personal Data, for example, to:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "provide you with information you requested and/or to respond to your inquiries submitted via the website, email and/or phone,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "facilitate certain recruitment activities such as processing employment applications,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "analyze and enhance our communications and strategies (including by identifying when emails sent to you have been received and read),",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "tailor the content we display on our website,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If we have sought your consent to process your Personal Data, you may subsequently withdraw it at any time by contacting us at the address listed in the \u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-8-your-privacy-rights"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Your Privacy Rights",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D section below.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "b. Legal obligation",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "We may be required by law or regulation to collect and process certain Personal Data about you. For example, we may be required to process certain Personal Data in relation to reporting of adverse events.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "monitor the quality, safety and efficacy of our medicinal products, which includes detecting, assessing and preventing adverse events and reporting to the relevant health authorities to meet legal and regulatory obligations,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Adverse events refer to the unintended or undesirable events after using a medicinal product. They can be minor at times, or they can also involve serious health issues.Moderna processes your Personal Data to comply with legal obligations under applicable pharmacovigilance laws and regulations worldwide and where necessary for our legitimate interests in ensuring appropriate pharmacovigilance standards.Pharmacovigilance laws are issued for reasons of substantial public interest in public health, research as well as quality, safety, and efficacy of medicinal products.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "c. Public interest",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may also process Personal Data to carry out scientific research in the public interest.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "d. Our legitimate interests",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may process your Personal Data where it is necessary for our legitimate interest as a company, including to manage, promote and improve our business and manage our risk. For example, we may process your Personal Data to:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "facilitate our recruitment activities (such as evaluating you as a job candidate for an employment activity, and monitoring our recruitment statistics),",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "tailor the content we display on our website,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "help us comply with our legal or regulatory obligations or our contractual obligations to the U.S. government as a government contractor or other countries as applicable,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "maintain the security, safety or property of the website, and",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "5. How Information is Shared and Disclosed",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may share and disclose information as described at the time information is collected and as described below:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "a. Service providers",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may use third parties to perform services requested or functions initiated by users. In addition, we may disclose Personal Data to identify a user in connection with communications sent through our sites or services. We may also share information, including Personal Data, with our service providers to perform the functions for which we engage them, such as data analysis, system design and maintenance, customer services and for marketing and promotions. When permitted, we also may offer users the opportunity to share information with friends and other users through the Services.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "b. Legal requirements",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "In certain circumstances, Moderna may release your Personal Data in response to a court order, subpoena, search warrant, regulation, binding order of a data protection agency, governmental request or other legal or regulatory process. Moderna may disclose information if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Moderna or others.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "c. Corporate changes",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may transfer information, including your Personal data, in connection with a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy or other change of ownership or control by Moderna or any affiliated company (in each case, whether in whole or in part). When one of these events occurs, Moderna will use reasonable efforts to notify users before information is transferred or becomes subject to different privacy practices.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "d. Adverse Event reporting by patients",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may disclose your Personal Data to HCPs, doctors, care givers, in connection with your adverse event report based on your consent or a legal obligation.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "6. How Information is Retained and Secured",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We retain information as long as it is necessary and relevant for our operations and in line with legal obligations. We retain Personal Data to comply with applicable law, prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted by law. When your Personal Data is no longer needed for Moderna\u2019s business purposes, we dispose of it subject to applicable law.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "In accordance with applicable laws, we employ reasonable security measures intended to help protect the security of all information submitted through the Services. The security of information transmitted through the internet cannot, however, be guaranteed. We are not responsible for any interception or interruption of any communications or for changes to or losses of data through the internet. Users of our sites and services are responsible for maintaining the security of any password, user ID or other form of authentication involved in obtaining access to password protected or secure areas. Any access to our sites or services through your user ID and password will be treated as authorized by you.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "To help protect your Personal Data, we may suspend your use, without notice, if Moderna suspects or detects any breach of security. Unauthorized access to such areas is prohibited and may lead to criminal prosecution.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "7. Cookies and Similar Technologies",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna\u2019s websites may use cookies and similar technologies. Please click here to read ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/cookie-statement"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Moderna\u2019s Cookie Statement",
                                                                "marks": [
                                                                    {
                                                                        "type": "italic"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "8. Your Privacy Rights",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna respects your rights related to the processing of your personal data. Depending on the applicable Data Protection Law you may have certain additional rights (see country-specific section below) and you will always have the below rights. You may exercise them by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "a. Correct/update personal data",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "You may correct or update the Personal data you previously provided to Moderna.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "b. Receive marketing communications",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "When you register for the services, you may request to receive emails containing information about Moderna you might find useful, including promotions, announcements of new services and products. If you decide, at any time, that you no longer wish to receive these emails you may unsubscribe from our email list by using the relevant \u201CUnsubscribe\u201D link within the respective electronic communications channel, or by contacting us at ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:privacy@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "privacy@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "IMPORTANT NOTE: Moderna cannot comply with a consumer's request to amend or remove information that was provided to Moderna by a healthcare professional or a consumer regarding an adverse drug event due to legal obligations.",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "9. Our Children\u2019s Policy",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Our sites are not intended for use by children. If you are under the age of majority in your place of residence, you may visit our site only with the consent of or under the supervision of your parent or legal guardian.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you believe Moderna may have any information from or about a child, please contact our Privacy Office at ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:privacy@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "privacy@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "10. Changes to This Privacy Statement",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We may change or update this Privacy Statement from time to time by publishing a new version on this website. When we do update this Statement, we will revise the \u201CLast Updated\u201D date at the top of this page. Your continued use of the services after the Effective Date constitutes your acceptance of the amended Privacy Statement. The amended Privacy Statement supersedes all previous versions.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "11. Jurisdiction-Specific Privacy Information",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "California",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Privacy Rights",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you are a California resident under age 18 and are a registered user of any of our services, then you may request that we remove any of your User Contributions you publicly posted on or in our services. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "To request removal of your User Contribution, please visit our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " (You also may be able to log in to your account and delete your own User Contribution.) Moderna reserves the right to request that you provide information that will enable us to confirm that the User Contribution that you want removed was created and posted by you.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna will make a good faith effort to delete or remove your User Contribution from public view as soon as reasonably practicable. Please note, however, that your request that we delete your User Contribution does not ensure complete or comprehensive removal of your User Contribution. Your User Contribution may remain on backup media, cached or otherwise retained by Moderna for administrative or legal purposes, or your User Contribution may remain publicly available if you or someone else has forwarded or re-posted your User Contribution on another website or service prior to its deletion. Moderna may also be required by law to not remove (or allow removal) of your User Contribution.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "California Civil Code Section 1798.83 permits individual California residents to request certain information regarding Moderna\u2019s disclosure of personal data to third parties for their direct marketing purposes. To make such a request, please write or send an email to the address below.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "California Consumer Privacy Act - Notice for California Residents",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you are a California resident, this Privacy Notice supplements the information above regarding the collection, use, and disclosure of your personal data. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The California Consumer Privacy Act of 2018 (CCPA) gives California consumers the right to know what personal data is collected about them, how it will be used and to whom it is disclosed. California consumers may have the right to request access to and deletion of their personal data, and the right to request that their personal data not be sold to the extent applicable under the CCPA.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The purpose of this notice is to describe our practices regarding the collection, use, disclosure, and sale of personal data and instructions for submitting CCPA data privacy requests. Some of the Personal Data that we collect, use, and disclose may be exempt from the CCPA because it is regulated by other federal and state laws that apply to us.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "We collect personal data from you when you interact with us online (through our Site, our other websites, Apps and Services) or offline (such as through your health care providers, if you are a patient, with your authorization as applicable.) The personal data we may collect from you will depend on the nature of our interaction with you, but can include the following categories that we have collected in the preceding twelve (12) months:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "1vo5ULs91JROZ8CfAyGcpI",
                                                            "type": "Asset",
                                                            "createdAt": "2024-07-10T13:58:26.978Z",
                                                            "updatedAt": "2024-07-10T13:58:26.978Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 5,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Privacy Policy - Personal Data ",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($cfb9bbabcaebc9c7$exports))),
                                                                "details": {
                                                                    "size": 642894,
                                                                    "image": {
                                                                        "width": 1174,
                                                                        "height": 2046
                                                                    }
                                                                },
                                                                "fileName": "image (4).png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Your Rights",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "California residents are provided specific rights subject to certain exceptions.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The Right to Know. ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "You have the right to request that we disclose what personal data we collect, use, disclose, and sell. The process for exercising this right is describe below under How to Submit a Data Privacy Request.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The Right to Deletion. ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "You have the right to request deletion of any personal data about you that we have collected from you. The process for exercising this right is describe below under How to Submit a Data Privacy Request",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The Right to Opt-Out. ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "You have the right to opt-out of the sale of your personal data.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The Right to Non-Discrimination. ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "You have the right not to be discriminated against for exercising your rights.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How to Submit a Data Privacy Request",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "You may exercise your Right to Know and Right to Deletion by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " or calling (844) 971-2551.To process your request for access or deletion, we must be able to verify your identity to a reasonable degree of certainty. We will ask you to provide your contact information and additional identifiers based on your relationship with us.You may designate an authorized agent to make a request to access, delete, or opt-out of the sale of your information on your behalf. When you use an authorized agent to submit a request for access or deletion, you must provide the authorized agent with written permission to do so, and, in certain circumstances, we may ask you to verify your own identity directly with us. We may deny a request from an authorized agent that does not submit proof that they have been authorized by you to act on your behalf.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Right to Know:",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Please note that we may not be required to provide you access to the specific pieces of information we have collected about you or delete information if we are unable to verify your identity.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Right to Delete:",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "We may not be required to delete information under certain circumstances. Specifically, the CCPA includes exemptions that provide that we do not have to delete data that, for example, is necessary to comply with legal obligations including those pertaining to the quality, safety or effectiveness of a product or activity regulated by the Food and Drug Administration (FDA), complete a transaction, detect security incidents, or for certain other internal purposes.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Sale or Disclosure of Personal data: ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "The CCPA defines \u201Csale\u201D broadly to include sharing, transferring, disclosing or otherwise communicating personal data with a third party for monetary or other valuable consideration. We share personal data with service providers who work on our behalf and agree not to use or sell your personal data for other purposes or if you have intentionally directed us to share information with a third party. In addition, with your approval, we share certain internet tracking data, including cookies and the IP address used to access our websites.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Notice of Financial Incentive:",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Moderna does not offer financial incentives in exchange for the collection or sale of personal data. However, we do provide discounts and incentives to individuals who use our products and services and enroll in incentive programs that we offer from time to time; enrolling in these programs requires you to provide certain of your personal data so that we may administer the programs and, in some cases, provide marketing and advertising to you. Under CCPA, this could be considered an offer of a \u201Cfinancial incentive\u201D and so we provide this notice to you to describe our practice and to provide a good faith estimate of the value of your personal data that we may collect related to the programs.\n\nIn the normal course of our business, we do not assign monetary or other value to personal data, but in accordance with CCPA, we make a good faith estimate that the value of the personal data collected and used is equivalent to the value of the discount or financial incentive we provide in these programs. To make this good faith estimate, we may consider among other factors, the (i) categories of personal data collected, (ii) the discount or incentive offered, (iii) the sales or use of our products and services by those who enroll versus those who do not, and (iv) the cost and expenses we incur in offering the programs.\n\nThe incentive programs require you to opt-in to participate as set forth on the page where you can enroll or opt-in to the programs. You can opt-out either by contacting us at the information set forth below, or by following the terms and conditions provided when you are enrolling in the program. While we will not discriminate against you for exercising your rights under CCPA, if you request deletion of your personal data, we may not be able to delete such information if it is necessary to administer the incentive or discount you requested and still provide you such incentive or discount.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Personal data Collected from Employees, Contractors, Applicants, and Health Care Providers",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Employees ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "\u2013 If you are an Moderna employee and would like more information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please contact us at",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "hyperlink",
                                                                        "data": {
                                                                            "uri": "mailto:privacy@modernatx.com"
                                                                        },
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "text",
                                                                                "value": "privacy@modernatx.com",
                                                                                "marks": [],
                                                                                "data": {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ".",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Contractors ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "\u2013 If you are a contractor performing services for Moderna and would like information about the categories of personal data we collect from you as a contractor and the purpose for which the personal data will be used, please visit our ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "hyperlink",
                                                                        "data": {
                                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                        },
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "text",
                                                                                "value": "request web page",
                                                                                "marks": [],
                                                                                "data": {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ".",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Job Applicants",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": " \u2013 If you are applying for a position with Moderna and would like information about the categories of personal data Moderna collects from you as a job applicant and the purposes for which the personal data, please view our Privacy Statement",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Health Care Providers \u2013 ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "italic"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "If you are a health care provider with whom we have a contractual arrangement and would like information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please visit our ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "hyperlink",
                                                                        "data": {
                                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                        },
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "text",
                                                                                "value": "request web page",
                                                                                "marks": [],
                                                                                "data": {}
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": ".",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Children\u2019s Online Privacy Protection Act (COPPA)",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Consistent (COPPA), if we learn that a child under age 13 has provided Personal Data to or through the site without first receiving his or her parent\u2019s verified consent, we will use that information only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use the services and subsequently we will dispose of such Personal Data in accordance with this Privacy Statement.California residents who are unable to review or access this CCPA Notice due to a disability may contact us to request access this CCPA Notice in an alternative format. Please call 1-844- 971-2551 or email us at ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:privacy@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "privacy@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Nevada",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Nevada Residents As Covered by Nevada Privacy Law\nModerna does not sell Covered Information as defined under Nevada law. If you would like to make a further inquiry regarding the selling of your Covered Information, as defined under Nevada law, visit our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "EU/EEA, UK & Switzerland",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna\u2019s processing of your personal data is based on any one of the following legal grounds: (A) legitimate business purposes, (B) where you have provided consent, (C) as necessary to comply with Moderna\u2019s legal and regulatory obligations and (D) as necessary to perform a contract under which you have been engaged.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "embedded-asset-block",
                                                "data": {
                                                    "target": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "3dlAOZ38IdeTNBy7LRHGVL",
                                                            "type": "Asset",
                                                            "createdAt": "2024-07-10T13:57:28.572Z",
                                                            "updatedAt": "2024-07-10T13:57:28.572Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 5,
                                                            "revision": 1,
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "Privacy Policy EU/EEA, UK & Switzerland ",
                                                            "description": "",
                                                            "file": {
                                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($0123010c3c10d239$exports))),
                                                                "details": {
                                                                    "size": 154682,
                                                                    "image": {
                                                                        "width": 480,
                                                                        "height": 379
                                                                    }
                                                                },
                                                                "fileName": "image (3).png",
                                                                "contentType": "image/png"
                                                            }
                                                        }
                                                    }
                                                },
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How can you access, correct or delete the personal data about you that we process? You have a right to request to access, correct/update or delete your personal data (including your health information). You may make such a request at any time, by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ". We will provide you with access to the information we hold about you, correct/update, and or delete that information that was provided to us by a Healthcare Professional or a consumer regarding an adverse drug event.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "It is not technologically possible to remove from our servers each and every record of your information. The need to back-up our systems to protect information from inadvertent loss means that a copy of information about you (including your health-related interests) may exist in a non-erasable form that will be difficult or impossible for us to locate.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Nevertheless, when permitted by law, Moderna will delete your personal data (including health information) stored in the databases Moderna actively uses for research and daily business activities or stored in other readily searchable media. In addition, we will use reasonable efforts not to disclose any personal data stored in a non-erasable format after receiving your request for removal, except as required by law.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How can you exercise the right to data portability? According to the right to data portability, you have the right to request that your personal data provided to Moderna be delivered to you in a structured, commonly used and machine-readable format, subject to certain conditions and can be requested by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Make a Privacy Complaint with the ICO (UK). If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Information Commissioner\u2019s Office (ICO) at: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://ico.org.uk/make-a-complaint/"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "https://ico.org.uk/make-a-complaint/",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Make a Privacy Complaint with the Federal Data Protection Commissioner of Switzerland. If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Federal Data Protection Commissioner at: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.edoeb.admin.ch/edoeb/en/home.html"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "https://www.edoeb.admin.ch/edoeb/en/home.html",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "How We Manage Disclosure of Transfers of Value",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna collects data about the transfers of value that you have received from us so that we can comply with our obligations under the IPHA Code, specifically that companies must document and publicly disclose annually certain transfers of value made directly or indirectly to health professionals and other relevant decision makers located in Europe.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna recognizes the legitimate public interest in better understanding the financial relationships that healthcare professionals have with the pharmaceutical industry for the purposes of transparency and trust in the pharmaceutical industry.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The law requires us to inform you of the legal basis for collecting and processing your personal data where Moderna is the data controller. Where Moderna processes data relating to transfers of value made to you, Moderna relies on the legal basis of legitimate interests to process that data. Moderna\u2019s compliance with the IPHA Code and these further objectives cannot be met without processing personal data about you and the transfers of value that you have received from us. We have carried out a Legitimate Interests Assessment and consider that this processing is necessary, proportionate and without unjustified harm to you.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you do not agree to the disclosure of data relating to transfers of value made to you by Moderna, you can raise an objection via ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:privacy@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "privacy@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Japan",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "In accordance with the Act on Protection of Personal Information of Japan (APPI) and other applicable laws and regulations, Moderna will disclose the personal data that Moderna holds about you according to the applicable procedures. In addition, if you inform Moderna that your personal data is inaccurate, Moderna will review and correct, add or delete the data as required in accordance with applicable laws, regulations and procedures.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Requests may be filed by visiting our ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "request web page",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "; please note that this may require a fee.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "backToTopButtonLabel": "Back To Top",
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5obyb6hoYaRjLduvLrF9BT",
                                    "type": "Entry",
                                    "createdAt": "2023-05-24T19:10:31.031Z",
                                    "updatedAt": "2023-07-11T18:20:48.597Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 245,
                                    "revision": 62,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "EW4a3Hd56gtuvG9WpsS3Z",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $7fb8eb39ded60e0f$export$fc54a338fd840f30 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Return Goods Policy Content Page",
                "title": "Return Goods Policy",
                "slug": "return-goods-policy",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "5gMYYleewpKSWJ4q6TvZUj",
                        "type": "Entry",
                        "createdAt": "2022-12-14T23:01:59.639Z",
                        "updatedAt": "2022-12-14T23:01:59.639Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 11,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Return Goods Policy Content Page - Compose: SEO"
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "4gWDVRE6oKE0h0dqd37xcu",
                        "type": "Entry",
                        "createdAt": "2022-12-14T23:01:59.660Z",
                        "updatedAt": "2023-06-20T16:21:22.755Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 21,
                        "revision": 5,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Return Goods Policy Content Page - Rich Text Content Page Template",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "4yWyEpVfxgjAmUcWCWMXBe",
                                    "type": "Entry",
                                    "createdAt": "2022-12-14T23:04:20.745Z",
                                    "updatedAt": "2023-06-16T18:23:22.281Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 20,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Return Goods Policy Banner Component",
                                    "headline": "Moderna Vaccine Product Return Policy",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "3LzpM6ba6wGXMlxYkj0OfE",
                                    "type": "Entry",
                                    "createdAt": "2023-06-16T18:28:28.772Z",
                                    "updatedAt": "2023-06-16T18:28:39.366Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 5,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5KqsjWl1JAA7AvePDZzaq5",
                                    "type": "Entry",
                                    "createdAt": "2022-12-14T23:00:13.065Z",
                                    "updatedAt": "2024-07-19T13:17:52.682Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 166,
                                    "revision": 14,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Return Goods Rich Text Component - US",
                                    "effectiveDateLabel": "Effective",
                                    "effectiveDate": "2025-04-01",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Returned Goods Policy and Procedures",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0\nModerna US,\u202FInc.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This Return Goods Policy controls what Moderna products are eligible for return and sets forth procedures for return of those eligible products. This Policy may be amended by Moderna US, Inc. at any time at its sole discretion. The policy detailed below is for customers that have purchased directly from Moderna. For customers who purchased from an authorized distributor of record (ADR), the return policy of the ADR should be followed for seasonal and non-seasonal returns. If your ADR\u2019s policy instructs you to follow Moderna\u2019s Return policy, please follow the instructions in this policy.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Returnable Items:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Products purchased directly from Moderna received by customer as damaged or received in error (i.e., \u201Clogistic returns\u201D)",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Products received damaged or in error may be returned for full credit when reported within three (3) business days of receipt of product subject to the terms herein. Products should remain in the original carton for inspection, and products must be returned in accordance with all return authorization (RA) instructions. Please contact 1-866-MODERNA (663- 3762) or email a request to ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "hyperlink",
                                                                "data": {
                                                                    "uri": "mailto:sss@modernatx.com "
                                                                },
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "sss@modernatx.com ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "text",
                                                                "value": " within three (3) business days to report a product that is damaged or was received in error.",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "For Products purchased through an ADR, customers should follow up with the ADR for all \u201Clogistic\u201D related returns.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Note on Shortages: ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Upon receipt of product, ADRs are requested to verify quantities of units received against original shipping documents by performing a physical count. Any discrepancies must be reported to Moderna within three (3) business days of receipt, at which time Moderna may initiate an investigation or initiate credit processing.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Seasonal Product Returns:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "\u201CSeasonal products\u201D are defined as products that are generally reformulated each season or each year to address new or changing virus/disease strains. Each reformulation generally requires approval from FDA and issuance of new National Drug Code (NDC) numbers. Seasonal products remain eligible for sale until a new formulation is approved or as per direction and availability from Moderna. ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "At the end of each season, a percentage of the total volume of seasonal product (currently, Covid-19 vaccine) purchased directly from Moderna may be returned for credit. The specific percentage will be defined in the customer contract. Returns in excess of the allowable total, within a single season, will be destroyed and only Federal Excise Tax (FET) will be credited where applicable.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Return requests for seasonal returns of Moderna seasonal product must be received by Inmar during the seasonal returns window. The seasonal returns window will be communicated by Moderna, at their discretion, prior to its opening.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Other Expired Products ",
                                                                        "marks": [
                                                                            {
                                                                                "type": "bold"
                                                                            }
                                                                        ],
                                                                        "data": {}
                                                                    },
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "that are not seasonal products, as determined by Moderna, may be returned up to two months prior to expiry and up to 12 months after expiry.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Returns for partial cartons are accepted.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Products Ineligible for Returns:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "All products, other than those listed above, shall be deemed ineligible for returned goods credit. Ineligible products cannot be returned to the customer and will be destroyed with no credit issued. Products that are ineligible for returned goods credit include, without limitation:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Seasonal product received after the defined seasonal return window closes.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Seasonal product that exceeds the returns allowance/percentage specified in the customer contract.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Non-Seasonal product returned more than 2 months prior to expiry or more than 12 months after expiry.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product obtained under Emergency Use Authorization (EUA) distribution from the United States Government.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product returned without a Return Authorization (RA) as further detailed below.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product for which original proof of purchase cannot be verified.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product returned with illegible or missing lot numbers, or expiration dates. No credit will be issued if the lot number or expiration date is missing, covered and/or unreadable on original container.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Repackaged product.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product with an opened seal.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product obtained at no cost and/or labeled as professional samples, clinical trial use, patient assistance program use or similar special labels.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product sold on a non-returnable basis.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product obtained illegally or re-imported from outside the United States.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product that has been adulterated, misbranded, or counterfeit, as determined by Moderna at its sole reasonable discretion.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Distressed merchandise obtained through bankruptcy or sacrifice sale, going out-of- business sale, or other merchandise classified as \u201Cdistressed merchandise.\u201D",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product damaged due to the negligence of the purchaser and/or customer.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product that has not been properly stored according to guidelines provided by Moderna.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product damaged by fire, water, or other force majeure events.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Procedure for Non-Seasonal or Other Product Returns",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product returns require a RA issued through Moderna\u2019s Customer Service department via phone number or email listed below. RAs expire thirty (30) calendar days from date issued.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Via phone:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " 1-866-Moderna (663-3762)",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Via email:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:wecare@modernatx.com "
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "wecare@modernatx.com ",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If you work with an account manager, email",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:SSS@Modernatx.com "
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "SSS@Modernatx.com ",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "for returns support.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Customers who place orders directly with Moderna must submit an itemized list of products being returned, with the following information included for each product:",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "unordered-list",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Debit Memo number, product name, product quantity, unit price, serial number, GTIN, lot number, NDC number, expiration date, billing address, shipping address, contact name and phone/email, and RA number.",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Ship returnable products, along with a copy of the Moderna RA and Debit Memo to:",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Shipping and Returned Goods Address:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Return Procedure for Eligible Returns:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Expired product returns require a RA issued through Inmar. To request a RA from Inmar, please use one of the three options below. ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "unordered-list",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Access the Inmar website at ",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "hyperlink",
                                                                                        "data": {
                                                                                            "uri": "https://hrm.reskureturns.com/landing"
                                                                                        },
                                                                                        "content": [
                                                                                            {
                                                                                                "nodeType": "text",
                                                                                                "value": "https://hrm.reskureturns.com/landing",
                                                                                                "marks": [],
                                                                                                "data": {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": " and upload a PDF copy of your debit memo or Returns Request form",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "E-mail document to ",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "hyperlink",
                                                                                        "data": {
                                                                                            "uri": "mailto:rarequest@inmar.com"
                                                                                        },
                                                                                        "content": [
                                                                                            {
                                                                                                "nodeType": "text",
                                                                                                "value": "rarequest@inmar.com",
                                                                                                "marks": [],
                                                                                                "data": {}
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Fax document to Inmar at 817-868-5343.",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Customers who place orders directly with Moderna must submit an itemized list of products being returned, with the following information included for each product: ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "unordered-list",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Customer DEA and/or HIN (used to create account)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Customer # with Moderna",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Customer Name (as shown on invoice) ",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Ship to Name (if different from Customer Name)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Customer Shipping Address (as shown on invoice)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Source of Purchase (ADR name or Moderna)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Product Name, NDC Number(s), Lot Number(s), Expiration Date(s)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Product Quantity (number of doses)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Sale Unit Price (invoiced price)",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Contact Name and Phone/Email",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Inmar will provide a box label to print when submitting your return request.",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "If you have any questions relating to the Inmar portal, please contact Inmar Pharmaceutical Services at 1-800-967-5952 option 3. Mon. \u2013 Fri. 7am \u2013 5 pm CT",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Include the completed RA box label with your return.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "It is shipper\u2019s responsibility to securely package all returned products to prevent breakage during transit.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "If multiple RAs are being returned in a single shipment to Inmar Pharmaceutical Services, ensure returned product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay in the crediting process.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Returned products do not require cold chain shipping.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Additional Terms for Return Credit:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Product must be in original retail trade packaging. Repackaged items will not be accepted for return or credited.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Credit for eligible and approved returns will be determined by Moderna. Such credit will be issued in credit memo form.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Moderna reserves the right, prior to credit being issued, to verify the original proof of purchase to determine that the product being returned was shipped from Moderna to customer.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "nodeType": "unordered-list",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "list-item",
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "nodeType": "paragraph",
                                                                                "data": {},
                                                                                "content": [
                                                                                    {
                                                                                        "nodeType": "text",
                                                                                        "value": "Customer may be asked to provide proof of purchase.",
                                                                                        "marks": [],
                                                                                        "data": {}
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Credit for erroneous or damaged product will be issued upon receipt and processing of return of product. No deduction can be taken prior to that time.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Credit for seasonal returns will be issued at the end of each season, after the returns window has closed. Credit will be limited to a contractually defined percentage of total vaccine product purchased directly from Moderna plus any applicable federal excise tax credit. Credit will be issued upon completion of the vaccine season and upon processing of returns. No deduction can be taken prior to that time. ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Returned goods may not be exchanged for replacement merchandise.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "All returned products become the property of Moderna. All items returned without an RA, or not in compliance with this policy, may be accepted and destroyed, but no credit will be issued.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "Returns from third-party processors acting on behalf of customers may be accepted provided that the customer receives approval from Moderna, and the third-party processor complies with all aspects of this Returned Goods Policy, and provides Certificates of Destruction or other comparable evidence of destruction acceptable to Moderna. Moderna is not responsible for fees incurred by third-party processors.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "All products returned are subject to final review and evaluation by Moderna.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Reservation of Rights",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna reserves the right to modify and make exceptions to this policy and to its implementation at any time, without notice, for any reason, including due to business necessity or changes in applicable laws and regulations.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "backToTopButtonLabel": "Back To Top",
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5FFA0liz6Apt9Uz8LsSWzy",
                                    "type": "Entry",
                                    "createdAt": "2023-05-24T19:13:43.878Z",
                                    "updatedAt": "2023-06-16T20:38:06.226Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 18,
                                    "revision": 6,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "6nT2JOBfWhTcZ1Pwxzp5rn",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $680f79d69bcc1805$export$a899f435c2d6c572 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
                "title": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
                "slug": "notice-of-seasonal-return-window",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "6SzHWgqbri7KmD1Kqg9tee",
                        "type": "Entry",
                        "createdAt": "2024-03-08T16:14:42.474Z",
                        "updatedAt": "2024-03-08T16:14:42.474Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 2,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)"
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "5kvUx9OuWGlyAfzkeuWYmf",
                        "type": "Entry",
                        "createdAt": "2024-03-08T15:25:40.478Z",
                        "updatedAt": "2024-03-08T15:25:40.478Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 5,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Notice of Seasonal Return Window > Rich Text",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "4wIx2naddOy0wWDJuYy5aw",
                                    "type": "Entry",
                                    "createdAt": "2024-03-08T15:25:01.040Z",
                                    "updatedAt": "2024-03-08T15:25:01.040Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 6,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Notice of Seasonal Return Window > Rich Text > Banner",
                                    "headline": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "1Px4l8fvDKjBGrRTCqfWrE",
                                            "type": "Asset",
                                            "createdAt": "2022-12-29T16:44:45.722Z",
                                            "updatedAt": "2022-12-29T16:44:45.722Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG strand top right",
                                            "description": "Banner BG strand top right",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner_BG_strand_right.png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7iOWBmppZrkK5s40UUIzOV",
                                            "type": "Entry",
                                            "createdAt": "2023-09-28T22:24:03.948Z",
                                            "updatedAt": "2023-09-28T22:24:03.948Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 3,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "3buMSfbhnLWdN0JQh411du",
                                    "type": "Entry",
                                    "createdAt": "2024-03-08T15:25:24.958Z",
                                    "updatedAt": "2024-03-08T15:31:05.586Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 26,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Notice of Seasonal Return Window > Rich Text > Content",
                                    "content": {
                                        "data": {},
                                        "content": [
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Dear Valued Partner,",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "On behalf of Moderna US, Inc. we are providing an important update regarding returnability of seasonal COVID-19 Vaccine Product (2024-2025 formulation). Pursuant to the Returned Goods Policy and Procedures in your purchase Agreement, at the end of each season a seasonal returns window will open and a percentage of the total volume of the Moderna COVID-19 Vaccine Product purchased directly from Moderna and/or indirectly through an Authorized Distributor that is within your contracted returns allowance may be returned for credit. Any returns received in excess of your contracted return allowance will be destroyed without credit.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "value": "On April 1, 2025, Moderna will open the seasonal returns window for Moderna\u2019s COVID-19 Vaccine Product with two return windows, as follows:",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Product returned with an approved Return Authorization (RA) received by Inmar Pharmaceutical Services (\u201CInmar\u201D) between April 1, 2025 and May 31, 2025 will be calculated for credit to be applied to your account upon processing of the returns information at the close of the return window.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Product physically received with an approved RA received by Inmar between June 1, 2025 through October 31, 2025 will be calculated for credit to your account upon processing of the returns information at the close of the return window. Product received after October 31, 2025 will be destroyed and no credit will be issued.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    }
                                                ],
                                                "nodeType": "unordered-list"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "value": "Additional Considerations",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "We encourage you to maintain sufficient inventory to immunize through Spring and early Summer preceding the new COVID-19 presentations for 2025-26 becoming available.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Please refer to your Moderna purchase Agreement for your defined return allowance percentage.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Health Systems and IDNs could opt to send returns in aggregate and provide their central payer information (if applicable); the contract return allowance percentage will be calculated in aggregate. Returns could also be returned by individual locations. The Returned doses will still be calculated in aggregate to assess the contract allowance percentage for returns.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "If you have purchased through an Authorized Distributor of Record (ADR), please refer to their policies for seasonal returns and allow additional time for credits to be applied to your ADR account. In the event your Wholesaler does not accept returns you may request a Return Authorization as outlined below in the Procedure for Seasonal/Expired Returns.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    }
                                                ],
                                                "nodeType": "unordered-list"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "value": "Procedure for Seasonal / Expired Product Returns ",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Returns of unexpired Product are accepted as part of seasonal returns and may be returned within either window.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Seasonal / expired product returns require a Return Authorization (RA) issued through Inmar. To request a RA from Inmar, please Access the Inmar website at: https://hrm.reskureturns.com/landing, and upload a PDF copy of your debit memo.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Requests for returns must be processed through the Inmar site are subject to denial of the Return.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "For seasonal returns you may submit one request for the entire quantity or multiple locations, but must include the following information above in a formatte",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "data": {},
                                                                                "marks": [],
                                                                                "value": "Customer Name & Address",
                                                                                "nodeType": "text"
                                                                            }
                                                                        ],
                                                                        "nodeType": "paragraph"
                                                                    }
                                                                ],
                                                                "nodeType": "list-item"
                                                            },
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "data": {},
                                                                                "marks": [],
                                                                                "value": "Source of Purchase (Moderna directly, or W/D)",
                                                                                "nodeType": "text"
                                                                            }
                                                                        ],
                                                                        "nodeType": "paragraph"
                                                                    }
                                                                ],
                                                                "nodeType": "list-item"
                                                            },
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "data": {},
                                                                                "marks": [],
                                                                                "value": "Product Description, NDC, Lot Number(s), Exp Dates, # of Cartons and Doses.",
                                                                                "nodeType": "text"
                                                                            }
                                                                        ],
                                                                        "nodeType": "paragraph"
                                                                    }
                                                                ],
                                                                "nodeType": "list-item"
                                                            }
                                                        ],
                                                        "nodeType": "unordered-list"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "As a part of the process, Inmar will provide a shipping label to print and affix to the box to return the Product.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "content": [
                                                                            {
                                                                                "data": {},
                                                                                "marks": [],
                                                                                "value": "Once the RA is issued, Seasonal Products must be physically received at Inmar by October 31, 2025.",
                                                                                "nodeType": "text"
                                                                            }
                                                                        ],
                                                                        "nodeType": "paragraph"
                                                                    }
                                                                ],
                                                                "nodeType": "list-item"
                                                            }
                                                        ],
                                                        "nodeType": "unordered-list"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Note that if the RA is for multiple locations, each location must return their product by October 31, 2025 in order to receive credit if applicable.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Please contact Inmar at 1-800-967-5952 option 3. Mon. \u2013 Fri. 7am \u2013 5pm CT if you have any issues in registering or requesting an RA",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Include the Debit memo and completed RA box label with your return.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Ship returns to the following Inmar location:",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    }
                                                ],
                                                "nodeType": "unordered-list"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "value": "Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "It is shipper\u2019s responsibility to securely package all returned Products to prevent breakage during transit.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "If multiple RAs are being returned within a single box to Inmar, ensure returned Product with the associated RAs are distinctly separated (with appropriate labeling) within the delivery. Failure to do so may result in inaccurate accounting of the return and a delay to the crediting process.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Returned Products do not require refrigerated packaging. ",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    },
                                                    {
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "data": {},
                                                                        "marks": [],
                                                                        "value": "Credit for accepted returned Product will be issued subject to the policies of original purchase. Refund for purchases made through an ADR will be credited through the customer account with their ADR, where applicable according to the ADR\u2019s policies.",
                                                                        "nodeType": "text"
                                                                    }
                                                                ],
                                                                "nodeType": "paragraph"
                                                            }
                                                        ],
                                                        "nodeType": "list-item"
                                                    }
                                                ],
                                                "nodeType": "unordered-list"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "value": "Reservation of Rights",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Moderna reserves the right to modify and make exceptions to this Policy and to its implementation at any time, without advanced notice, for any reason, including due to business necessity or changes in applicable laws and regulations.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "value": "Any questions regarding Moderna\u2019s Returned Goods Policy can be addressed by Moderna\u2019s Customer Care Team at 1 - 866 - Moderna (663 - 3762) or by emailing wecare@modernatx,com. If you currently work with an account manager, please email sss@modernatx.com.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Best Regards,",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Moderna US, Inc. Commercial Operations Team",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            }
                                        ],
                                        "nodeType": "document"
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "1ss0StRsEFrdMIHmkvmgkW",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $7d2250bb74d20843$export$50fdc3ea919136dd = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Terms and Conditions of Sale Page",
                "title": "Terms and Conditions of Sale",
                "slug": "terms-and-conditions-of-sale",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "VzsBqUoBa9aOy2WVSJ1Av",
                        "type": "Entry",
                        "createdAt": "2023-07-18T22:09:37.099Z",
                        "updatedAt": "2023-07-18T22:09:37.099Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 13,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Terms and Conditions of Sale Page - Compose: SEO"
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "4DgFjVJ4vgmLu3t2WxKcbU",
                        "type": "Entry",
                        "createdAt": "2023-07-18T22:09:37.123Z",
                        "updatedAt": "2023-07-18T22:28:46.333Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 15,
                        "revision": 2,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Terms and Conditions of Sale Page - Rich Text Content Page Template",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "B7Nw3RClc2mJ9e6hvjl0w",
                                    "type": "Entry",
                                    "createdAt": "2023-07-18T22:19:31.415Z",
                                    "updatedAt": "2023-07-18T22:19:31.415Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 4,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Terms and Conditions of Sales Banner Component",
                                    "headline": "Moderna's Terms and Conditions of Sale",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "1gueYHjtTvECRTMjM6Xbjs",
                                    "type": "Entry",
                                    "createdAt": "2023-07-18T22:24:29.349Z",
                                    "updatedAt": "2024-08-05T18:30:34.851Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 240,
                                    "revision": 13,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Terms and Conditions of Sale Rich Text Component - US",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna\u2019s Terms and Conditions of Sale",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "These terms and conditions of sale (hereinafter \u201CTerms\u201D or \u201CAgreement\u201D), which may be amended by Moderna US, Inc. (\u201CModerna\u201D) from time to time in its sole discretion, govern all direct purchases from Moderna by eligible customers (\u201CPurchaser\u201D or \u201CPurchasers\u201D) for FDA authorized and/or approved products sold commercially by Moderna (\u201CProduct\u201D) through Moderna Direct (Moderna\u2019s e-commerce website at https://modernadirect.com). Each direct purchase shall be deemed an acknowledgement and acceptance by Purchaser of these Terms in effect at the time of such purchase, and such Terms are hereby incorporated by reference into any and all invoices issued by Moderna in connection with direct purchases through Moderna Direct.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Purchase and Use of Product.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1.1. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Eligibility.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser eligibility to purchase Product will be at the sole discretion of Moderna. No Purchaser may resell Product or market, promote, administer, or use Product for the benefit of persons or entities outside the United States or its territories. The pricing, terms and conditions of this Agreement shall apply only to Purchasers located in the United States and its territories.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "1.2.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201COwn Use.\u201D",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Purchaser agrees that Product purchased under this Agreement is for the \u201Cown use\u201D of Purchaser as defined by the United States Supreme Court in ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Abbott Laboratories v. Portland Retail Druggists Association, Inc.",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ", 425 U.S. 1 (1976) and ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Jefferson County Pharmaceutical Association, Inc. v. Abbott Laboratories",
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ", 103 S. Ct. 1011 (1983). Purchaser further agrees that it shall not administer Product in a manner that is inconsistent with the foregoing and will not sell or donate Product for any reason without Moderna\u2019s express written permission. Purchaser shall take such precautions as are necessary to prevent Product from falling into the hands of those who may not lawfully possess or handle it.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product Orders, Modification and Cancellation, Delivery.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2.1.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Orders.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchasers may order Product by creating a direct purchase account by calling Moderna Customer Care Team at 1-866-Moderna (633-3762) or visiting Moderna Direct (Moderna\u2019s e-commerce website at https://modernadirect.com). Purchasers authorize Moderna and its agents or representatives to place orders for Product via Moderna Direct on Purchasers\u2019 behalf, to the extent requested by and at the direction of Purchaser. These Terms supersede any terms and conditions included in any purchase order received from Purchaser, which shall not apply to any sale under these Terms. Each order submitted by a Purchaser is subject to Moderna\u2019s confirmation of the Purchaser\u2019s valid state license number, other license authorizations, and the Purchaser\u2019s creditworthiness.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2.2. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Modification and Cancellation.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Upon ordering Product and upon confirmation of an order by Moderna, a Purchaser shall have committed to purchase the amount of the order.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2.3. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Delivery.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Moderna will use commercially reasonable efforts to fulfill orders as Product availability allows. However, Moderna\u2019s obligation to deliver Product ordered by a Purchaser is subject at all times to (a) any superseding requirement imposed by any governmental authority, including without limitation any requirement imposed in connection with an epidemic or pandemic, (b) delays in Product lot releases, and (c) the condition that Moderna is able to manufacture a sufficient supply of Product to meet the demands of all of its customers. Further, Moderna shall, in its sole discretion, have the right to delay shipments, make partial deliveries, and allocate Product among its customers in such a manner as it deems appropriate. In addition, in the event that a government authority assumes control of Product allocation (as a result of shortage or other reason) or requires that specific requirements be met, then Product amounts and delivery schedules may be changed to meet the government authority\u2019s requirements and Moderna will be relieved, without incurring any liability, of all obligations to supply or deliver Product ordered by any Purchaser.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "3. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Storage, Handling and Destruction.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchasers taking physical possession of Product are fully responsible for complying with all applicable federal, state, and local laws and regulations relating to storage, handling, and distribution of Product. Purchaser represents and warrants that it has and will maintain at all times the proper license or licenses required to receive, handle and store vaccines. Purchaser shall store and handle Product consistent with the Product Prescribing Information. Purchaser further represents that it will take appropriate steps to properly dispose of empty vaccine containers and product packaging by (1) treating containers and packaging similarly to medical waste by placing in red sharps containers (preferred), or (2) defacing or safely crushing materials so they cannot be reintroduced or reproduced, and then disposing of them with regular waste.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Payment Terms and Instructions.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4.1.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Payment Terms.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Purchasers shall be obligated to pay for Product, via credit card, ACH, check, or bank transfer by the payment due date specified in the invoice delivered by Moderna upon shipment. Prompt pay discount of 2% 60, net 61 days shall apply to the invoice total inclusive of applicable tax. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4.2.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Claims and Deductions.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " All claims involving discounts, pricing, credits or returns must be reported to Moderna within sixty (60) days of the date of invoice for the purchase in question. Inappropriate deductions taken from Purchaser payments, including but not limited to, those made after this deadline, will be reflected against the account and could jeopardize future shipment on open items.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4.3.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Amounts Overdue.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " If Purchaser fails to pay amounts when due hereunder, Moderna reserves the right to commence any collection proceedings as it deems appropriate, including referring Purchaser to a third-party collector or commencing litigation. Moderna reserves the right to charge fees to Purchaser associated with the collection process. Fees may include, without limitation, litigation costs, dunning and returned check/ACH/wire transfers or credit decline charges. A Purchaser\u2019s account may be closed by Moderna upon being sent to third party collections. In any legal action by Moderna for nonpayment, Moderna shall be entitled to recover all costs of legal proceedings, including reasonable attorneys\u2019 fees and an interest fee of the lesser of 1.5% per month or the maximum permissible rate.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "4.4.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Set-off.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Moderna reserves the right, in its sole discretion and at any time, to withhold and set-off against amounts that Purchaser owes Moderna any outstanding credits, reimbursements and refunds owed by Moderna to Purchaser, or its Affiliates. \u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Affiliate",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D means, with respect to an entity, any corporation, company, partnership, joint venture and/or firm which controls, is controlled by or is under common control with such entity. Purchaser acknowledges and agrees that it shall not be entitled to receive, and Moderna may continue to withhold, any credits, reimbursements and refunds owed to Purchaser and its Affiliates until such time as Purchaser has paid all outstanding amounts owed on purchases hereunder together with applicable interest and costs of collection. Any dormant or inactive Purchaser accounts that have credit balances more than two (2) years old will be subject to the escheatment process. This right of set-off shall survive and continue to apply following the termination or expiration of these Terms and the delivery of Product hereunder.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "5. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Credit Terms",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser must maintain a credit condition satisfactory to Moderna. Purchaser shall substantiate its credit position upon Moderna\u2019s request. If, in Moderna\u2019s sole discretion, Purchaser\u2019s credit position becomes unsatisfactory, or Purchaser\u2019s account exhibits poor or delinquent payment history, Moderna may require prepayment for future purchases.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "6. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product Price.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " The unit price for Product is set at the time of purchase in the amount established by Moderna and excludes surcharges for shipping (if any) where applicable, and excise taxes or assessments. Purchaser is responsible to remit to Moderna for applicable taxes as included on Invoice. All prices are subject to change without notice. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "7. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Taxes.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " All prices or fees set forth are exclusive of any applicable sales, excise, or other taxes that Moderna is required by law to collect from the Purchaser. When the Purchaser elects to make payment via credit card, Moderna shall calculate the appropriate tax amount by the applicable tax jurisdiction(s) of the Purchaser\u2019s ship to location at the time of purchase. The final amount charged to the Purchaser\u2019s credit card shall include such calculated tax. The purchaser acknowledges that tax rates may vary and that any changes in applicable taxes during the term of this Agreement will be reflected in the amounts charged to the Purchaser\u2019s credit card. If the Purchaser is tax exempt, the Purchaser must provide Moderna with a valid tax exemption certificate authorized by the appropriate taxing authority before the transaction. Moderna shall not include tax in the credit card charge, subject to validity of the exemption certificate. Failure to provide tax exempt documentation will result in the Purchaser being liable for the payment of all taxes due. Any discrepancies or disputes regarding the calculation of taxes must be reported to Moderna within (30) days of the credit card statement date on which the charge appeared. Moderna will investigate the claim and rectify as applicable with accordance to our sales tax policy and governing laws. Purchaser agrees to indemnify and hold Moderna, the Seller, harmless from any claims, damages, or expenses associated with the failure to pay any taxes related to credit card payments, except for those taxes that are legally the responsibility of Moderna. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "8. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Claims for Loss and Inspection of Product.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "8.1. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Claims for Loss or Damage in Shipments",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Claims for loss, shortage, breakage, leakage, or other damage occurring in transit must be submitted to Moderna at its headquarters twenty-four (24) hours from date of invoice, for replacement or credit of affected Product. The sole and exclusive remedy of Purchaser is Moderna credit or replacement, as applicable, of affected Product. Purchaser agrees that no other remedy (including but not limited to, incidental, consequential, or other damages of any kind) shall be available. Loss, shortage, breakage, leakage, or other damage claims must also be accompanied by freight bill with notation by the common carrier of the loss, shortage, breakage, or damage, or accompanied by the carrier\u2019s concealed loss or damage report where the loss is of a concealed nature. Where loss, shortage, breakage, leakage, or other damage has occurred in transit, Purchaser agrees to cooperate fully with Moderna in Moderna\u2019s effort to establish a claim against the transportation company. Claims submitted without appropriate documentation will be denied.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "8.2.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Inspection of Product by Purchaser.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser must, within three (3) business days after delivery of Product, conduct a physical inspection of the packaged Product and notify Moderna\u2019s Customer Service at 1-866-MODERNA (633-3762) of any issue or physical damage that is apparent from such inspection. If a Purchaser fails to give such notice, then the Purchaser will be conclusively presumed to have accepted such shipment and Moderna will have no liability to the Purchaser for any defects that could have been identified by such inspection nor for any discrepancies between the shipment received and the amount of Product ordered by the customer. Any defect or damage to the Product that is not identifiable from a physical inspection will remain grounds for rejection of Product if the Purchaser notifies Moderna\u2019s Customer Service at 1-866-MODERNA (633-3762) within three (3) business days following discovery of the defect or damage. Upon receipt of such notice from a Purchaser, Moderna will conduct an investigation and if Moderna agrees with the Purchaser\u2019s determination, Moderna will use reasonable commercial efforts to supply replacement Product to the Purchaser or if no replacement Product can be supplied, Moderna will, in its sole discretion, issue a credit note to the Purchaser for the rejected Product. If Moderna, in its sole discretion, determines in good faith that no defect or damage to Product exists, then the Purchaser must accept delivery of such Product and pay the invoiced amount. In the event that Moderna determines that no defect or damage exists, then Moderna will not be deemed to be in breach of these Terms nor have any further liability with respect to the alleged defect or damage.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "8.3. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Limitations and Damages.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The sole and exclusive remedy of Purchaser is Moderna credit or replacement, as applicable, of affected Product. Purchaser shall not sell or use affected Product and shall indemnify Moderna against third-party claims arising from the impermissible sale or use of affected Product.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "9. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Returns.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "All returnable doses purchased directly from Moderna via Moderna Direct must be returned in accordance with Moderna\u2019s Returned Goods Policy, available at ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://modernadirect.com/return-goods-policy"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "https://modernadirect.com/return-goods-policy",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ". Product not purchased directly from Moderna should be returned under its terms of sale. If such Product is returned to Moderna directly, it will be either be returned or destroyed at Moderna\u2019s sole discretion, and no credit will be provided. Product supplied through the federal Vaccines for Children program or any other government program contract where Product is purchased under special conditions is not eligible for return credit or replacement.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "10. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Passage of Title; Risk of Loss.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For all orders of Products shipped to any of the fifty (50) states in the United States, title to Product and risk of loss of each such shipment of Product will pass to the Purchaser upon delivery to the destination designated by the Purchaser in the Purchaser\u2019s direct purchase account. For all orders of Product shipped to a U.S. territory: Moderna shall deliver all Product Delivered at Place (DAP) (Incoterms 2020); title to and risk of loss for any such Product shall transfer over international waters following shipment of Product by Moderna or its designated agent and prior to any importation, provided, however, that the rights and procedures set forth in Section 8 shall continue to apply; Moderna shall obtain all required export licenses and shall pay the cost of carriage to the destination (with the exception of any special shipping requests, the cost of which shall be borne by Purchaser); and Purchaser shall be responsible for all import clearance and formalities, including import duties, taxes, and any other charges payable upon importation of Products into a U.S. territory. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "11. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Warranties of Purchaser.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " By ordering Product from Moderna, Purchaser:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "a. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Acknowledges that the Product has been FDA-approved (and is recommended by Moderna) only for use as described in the Product Prescribing Information (\u201CPI\u201D), which outlines the Product\u2019s approved indications, uses, dosages, and routes of administration, as well as additional information regarding the Product\u2019s efficacy, safety, contraindications, warnings, and risks. Purchaser acknowledges that Moderna makes no representations or warranties related to any use of the Product that does not conform with the FDA-approved PI. Purchaser further acknowledges that Moderna disclaims any and all liability for any use of the Product that does not conform with the FDA-approved PI.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "b. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Acknowledges that Product is not to be used after the expiration date printed on the Product label.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "c. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Acknowledges that Product is not to be used if it has been stored or handled inconsistent with applicable laws and the Product Prescribing Information.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "d. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Agrees that, as requests for information or correspondence in relation to Product are made of a Purchaser by a governmental authority, unless otherwise required by law, Purchaser shall consult with Moderna and keep Moderna fully apprised of all such communications.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "12. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Safety Information Reporting.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " For purposes of this Section 12, the following definitions shall apply: ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Adverse Event",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D or \u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "AE",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D is any untoward medical occurrence in a patient or clinical investigation subject administered a pharmaceutical product and which does not necessarily have to have a causal relationship with this treatment. An adverse event (AE) can therefore be any unfavorable and unintended sign (including an abnormal laboratory finding, for example), symptom, or disease temporally associated with the use of a medicinal product, whether or not considered related to the medicinal product. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201C",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Special Situation",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D includes, but is not limited to: ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "any exposure during pregnancy or at time of conception (maternal or paternal) and/or lactation,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "suspected transmission of infectious agent, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "abuse or misuse, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "medication error (potential, intercepted or actual) or overdose, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "occupational exposure, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "failure of the Moderna product to exhibit its expected pharmacologic or biologic effect,",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "unexpected benefit, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "off-label use, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "falsified or counterfeit medicinal product, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "drug-vaccine or drug, drug interaction, ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "complaint (including but not limited to any product quality complaint), or ",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "list-item",
                                                        "data": {},
                                                        "content": [
                                                            {
                                                                "nodeType": "paragraph",
                                                                "data": {},
                                                                "content": [
                                                                    {
                                                                        "nodeType": "text",
                                                                        "value": "query with respect to any Moderna product.",
                                                                        "marks": [],
                                                                        "data": {}
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "If Purchaser, or its subcontractors, designees, or delegates, becomes aware of an AE/Special Situation or query with respect to the Product, Purchaser shall provide such AE/Special Situation report or query to Moderna via secure e-mail at ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:drugsafety@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "drugsafety@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " as soon as practicable, but no later than one (1) business day after such report is received. Purchaser shall include the date the report was received and shall use reasonable efforts to gather and provide the following information regarding the AE/Special Situation or query: (a) name of the Moderna product; (b) description of potential AE/Special Situation or query, including a description of the relationship between the product and AE/Special Situation or query, as applicable; (c) identifying patient demographics; and (d) contact information of the reporting individual. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "13. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Compliance with Laws.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser shall comply with all Federal, state and local laws, requirements and regulations as they relate to its performance under the Agreement. Without limitation of the foregoing, Purchaser will comply with applicable provisions of the Drug Supply Chain Security Act, and all federal and state healthcare anti-fraud and abuse laws, including the federal anti-kickback statute, 42 U.S. C. 1320a-7b, prohibiting illegal remunerations (including any kickback, bribe, or cost incentive) by properly disclosing and appropriately reflecting the discounts and rebates described in this Agreement in the costs claimed or the charges made under the Medicaid, Medicare or any federal healthcare program. To that end, Purchaser shall properly document the pricing made available hereunder in Purchaser's records setting forth the acquisition cost of Product and, if Medicare, Medicaid or any other Federal or State-funded healthcare program requests information as to the cost of Product acquired hereunder, Purchaser shall properly and accurate disclose such pricing, including fully and accurately disclosing any discounts for Product purchased hereunder as required under 42 CFR 1001.952(h) or other applicable law or regulation. ",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "14. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Withdrawal of Product Approval.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Moderna will promptly notify Purchaser in writing of any withdrawal of Product\u2019s FDA approval or emergency use authorization or of Product\u2019s material non-compliance with FDA standards. At the request of Moderna, Purchaser agrees to return to Moderna, at Moderna\u2019s sole cost and expense, any allegedly defective Product owing to the withdrawal of Product\u2019s approval or authorization, or a determination of material non-compliance by Moderna or by the FDA.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "15. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "No License of Intellectual Property Rights.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Nothing in these Terms shall be construed as granting or implying the grant of any license under any patent or trademark rights or any other intellectual property rights held by Moderna or any of its Affiliates anywhere in the world, and Moderna shall be entitled to exercise such patent or trademark rights and/or other intellectual property rights to the fullest extent legally permissible at the time of such exercise. Purchaser may not remove, alter or obscure any trademark on the Product.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "16. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Confidential Information.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "16.1.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " By ordering Product, Purchaser agrees that any and all information it obtains regarding Moderna in connection with a purchase of Product, including without limitation pricing information, discounts/rebates obtained, volume incentives and all other contract information, whether or not marked as \u201Cconfidential,\u201D is ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201C",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Confidential Information",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\u201D of Moderna. By ordering Product, Purchaser further acknowledges and agrees that any and all Confidential Information disclosed by Moderna to Purchaser is and will remain the property of Moderna, and Purchaser agrees to return any Moderna Confidential Information promptly upon written request and to retain no copies or excerpts of such Confidential Information.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "16.2.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " By ordering Product, Purchaser further agrees that: (a) any and all Confidential Information disclosed by Moderna to such Purchaser is and will remain the property of Moderna; (b) it will use Confidential Information only to perform obligation or exercise rights under this Agreement; (c) it will not disclose Moderna\u2019s Confidential Information to any third party without the prior written consent of Moderna (except as required to comply with law or court order); (d) it may disclose Moderna\u2019s Confidential Information to its employees and/or independent contractors only to the extent that such employees and/or independent contractors are reasonably required by their duties to have knowledge of such Confidential Information, and provided that such employees and/or independent contractors are contractually obligated to hold such Confidential Information in confidence and to otherwise comply with these Terms; (e) it will not hold Moderna or its employees liable for any errors or omissions in Moderna\u2019s Confidential Information; and (f) it will use reasonable care to safeguard Moderna\u2019s Confidential Information and make no misuse of such Confidential Information.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "16.3.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser\u2019s obligations under this Section will remain in effect for a period of five (5) years from the date that the last order was submitted by Purchaser under these Terms.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "17. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Force Majeure.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Neither party will be held liable to the other party nor be deemed to have defaulted under or breached this Agreement for failure or delay in performing any obligation under this Agreement (except for any obligation to make payment for doses already delivered) to the extent that such failure or delay is caused by or results from causes beyond the reasonable control of the affected party (a \u201CForce Majeure Event\u201D), including strikes or other labor disturbances, lockouts, riots, quarantines, communicable disease outbreaks, wars, acts of terrorism, cyber-attacks, fires, floods, storms, interruption of or delay in transportation, lack of and inability to obtain fuel, power or components, or compliance with any order, regulation, or enforcement decision of any governmental authority. The affected party will notify the other party of such Force Majeure Event as soon as reasonably practical, and will promptly undertake all reasonable efforts necessary to cure such Force Majeure Event and resume performance of its obligations hereunder.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "18. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Warranties of Moderna.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Moderna warrants that: Product delivered shall hereunder, at the time of delivery, materially conform to the applicable Specification (\u201CSpecification\u201D means the specifications or similar requirements for the manufacture of Product that are provided by Moderna to Purchaser, from time to time, in writing and expressly designated as such); (b) at the time of Delivery, the Product will not be adulterated or misbranded within the meaning of the Federal Food, Drug and Cosmetic Act, as amended, all applicable regulations thereunder, or within the meaning of any applicable law within which the definitions of \u201Cadulteration\u201D or \u201Cmisbranding\u201D are substantially the same as those contained in the Federal Food, Drug and Cosmetic Act, as such Act and such applicable laws are constituted and effective at the time of Delivery, nor will the Product be an article which may not, under the provisions of such Act, or of the Public Health Service Act, as amended, be introduced into interstate commerce; (c) Moderna\u2019s quality control procedures applicable to Product shall have been materially carried out prior to delivery of Product; and (d) upon delivery to the destination, title to Product will pass to Purchaser free and clear of all third party liens, claims, security interests, or other encumbrances.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "THIS SECTION SETS FORTH MODERNA\u2019S SOLE AND LIMITED WARRANTIES WITH RESPECT TO PRODUCT SUPPLIED TO PURCHASER. TO THE MAXIMUM EXTENT ALLOWED BY LAW, EXCEPT AS UNAMBIGUOUSLY AND EXPRESSLY SET FORTH IN THIS SECTION, MODERNA SPECIFICALLY DISCLAIMS, AND, BY ORDERING PRODUCT, EACH PURCHASER IS EXPRESSLY WAIVING AND RELEASING MODERNA FROM ALL OTHER WARRANTIES, CONDITIONS AND TERMS REGARDING OR RELATING TO PRODUCT (WHETHER USED ALONE OR WITH OTHER SUBSTANCES OR MATERIALS) THAT MAY HAVE BEEN PROVIDED TO A PURCHASER OR OTHERWISE THAT MIGHT HAVE EFFECT BETWEEN A PURCHASER AND MODERNA OR BE IMPLIED INTO THESE TERMS, PRODUCT ORDER, OR ANY OTHER COLLATERAL CONTRACT, WHETHER BY STATUTE, COMMON LAW OR OTHERWISE AND WHETHER EXPRESS, IMPLIED OR OTHERWISE, INCLUDING ALL IMPLIED WARRANTIES, CONDITIONS OR TERMS OF MERCHANTABILITY, QUALITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. MODERNA WILL NOT BE LIABLE TO ANY PURCHASER, AND, BY ORDERING PRODUCT, EACH PURCHASER IS EXPRESSLY WAIVING AND RELEASING MODERNA FROM ANY LIABILITY, WITH RESPECT TO PRODUCT (AN \u201CUNCOVERED PRODUCT\u201D) THAT (A) HAS BEEN TAMPERED WITH OR IN ANY WAY ALTERED OR MODIFIED AFTER DELIVERY TO THE PURCHASER\u2019S DESIGNATED DESTINATION; (B) HAS BEEN SUBJECT TO MISUSE, NEGLIGENCE OR ACCIDENT AFTER DELIVERY TO THE PURCHASER\u2019S DESIGNATED DESTINATION; (C) HAS BEEN STORED, HANDLED, MAINTAINED, ADMINISTERED OR USED IN A MANNER CONTRARY TO REGULATORY REQUIREMENTS, THE LABELING OF PRODUCT OR MODERNA\u2019S INSTRUCTIONS, OR OTHERWISE NOT AS ORIGINALLY INTENDED, AFTER DELIVERY TO THE PURCHASER\u2019S DESIGNATED DESTINATION; OR (D) HAS PASSED ITS EXPIRATION DATE. THE WARRANTIES CONTAINED IN THIS AGREEMENT WILL NOT APPLY TO ANY SUCH UNCOVERED PRODUCT.",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "19. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Indemnification by Purchasers.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " By ordering Product, Purchaser agrees to indemnify, defend and hold harmless Moderna and its Affiliates, and each of their directors, officers, employees and agents from and against any and all damages, losses, liabilities, cost, and expenses (including reasonable attorneys\u2019 fees) directly arising out of (a) any material breach of any representation or warranty of Purchaser; (b) any action by Purchaser, its directors, officers, employees or agents with respect to any Product resulting in such Product becoming an Uncovered Product; (c) the subsequent sale and/or use of an Uncovered Product (d) the negligent or more culpable act or omission of Purchaser or its affiliates, or any allegation related thereto; and (e) the breach of this Agreement by Purchaser. Purchaser shall maintain commercially reasonable insurance programs and limits, consistent with Purchaser\u2019s company size and industry risk profile, from insurers rated by A.M. Best at least Financial Strength A- or better, and Financial Size Category VII or better, to satisfy its indemnification obligations hereunder.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "20. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Limitations of Liability.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Under no circumstances whatsoever will Moderna be liable to Purchaser or its affiliates in contract, tort, negligence, indemnity, breach of statutory duty, or otherwise, for: (a) any (direct or indirect) delay, penalty, loss of profits, of anticipated savings, of business, of goodwill, or of use of the Product or costs of any substitute services; (b) any reliance damages; or (c) for any other liability, damage costs, penalty, or expense of any kind incurred by Purchaser of an indirect or consequential nature, regardless of the foreseeability or any notice of the possibility of these damages.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "21. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "No Agency Relationship.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " The relationship created by these Terms is a buyer-seller relationship and not an agency relationship.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "22. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Assignment.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Purchaser shall not sell, assign, or transfer to any third party, and past, present or future obligation, covenant, or claim of any nature whatsoever relating to any matter covered by the Agreement, without Moderna\u2019s written consent.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "23. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Notice",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " All communications required under this Agreement must be in written or electronic form. All such communications by Moderna to Purchaser will be to the contact person listed at the \u201CShip To\u201D address in the direct purchase account established by Purchaser. All such communications by Purchaser to Moderna must be sent to the attention of:",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna US, Inc.\n5 Vaughn Dr., Suite 200\nPrinceton, NJ 08540\nEmail: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:commercialops@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "commercialops@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nWith an email copy to your Moderna Account Manager; and\nWith an email copy to: ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "mailto:legal@modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "legal@modernatx.com",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "24. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Governing Law and Jurisdiction.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " These Terms will be governed by, construed and interpreted in accordance with the laws of the Commonwealth of Massachusetts, without regard to any choice of law principle that would require the application of the law of another jurisdiction. Each part irrevocably submits to the exclusive jurisdiction of the courts of the Commonwealth of Massachusetts, or of the United States of America for the District of Massachusetts.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "25. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Waiver",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " The waiver by Moderna of a breach of these Terms or any default hereunder shall not be deemed a waiver of any subsequent default whether of the same or similar nature and shall not in any way affect the Terms herein. No waiver shall be valid or binding unless in writing and signed by the parties.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "26. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Severability.",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " In the event any term or provision of this Agreement is declared illegal, unenforceable or in conflict with any law or regulation, the validity of any other term or provision shall not be affected thereby.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "27. ",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Entire Agreement; Contract Purchaser",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            },
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " This Agreement shall prevail over any inconsistent or conflicting terms in any other agreement between Purchaser and Moderna; provided that, if Purchaser is party to a separate written contract with Moderna when an order is placed and a provision in the separate written contract specified by Purchaser for such order conflicts with a provision in this Agreement, then the provision in the separate written contract shall prevail over the conflicting provision in this Agreement with respect to such order. The terms and conditions of any purchase order or other document issued by Purchaser (whether in writing, electronic or otherwise) that conflict with or are in addition to these Terms or the terms and conditions stated on an invoice issued by Moderna are expressly rejected by Moderna and superseded hereby.",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Last updated 08",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "/05/24",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "backToTopButtonLabel": "Back To Top",
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "2fYeJxk3IiLk32qYZYHaG5",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $6cd2daf0e5c7fb79$export$8a4803631865e123 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Terms of Use Content Page",
                "title": "Terms of Use",
                "slug": "terms-of-use",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "CPQIi2xudRdKj2B2xGLVK",
                        "type": "Entry",
                        "createdAt": "2022-12-14T23:05:15.913Z",
                        "updatedAt": "2022-12-14T23:05:15.913Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Terms of Use Content Page - Compose: SEO"
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "xg1DALHgYX18j87zlOP1C",
                        "type": "Entry",
                        "createdAt": "2022-12-14T23:05:15.990Z",
                        "updatedAt": "2023-06-21T19:19:34.422Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 16,
                        "revision": 5,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Terms of Use Content Page - Rich Text Content Page Template",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "4sgrY0r9g7t6f13PeJHKpN",
                                    "type": "Entry",
                                    "createdAt": "2022-12-14T23:06:15.428Z",
                                    "updatedAt": "2023-06-16T18:23:00.168Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 16,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Terms of Use Banner Component",
                                    "headline": "Moderna's Terms and Conditions of Use",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "5zfGJA7or5WGcLdYi4Qde",
                                            "type": "Asset",
                                            "createdAt": "2022-10-28T18:53:29.208Z",
                                            "updatedAt": "2022-10-28T18:53:29.208Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG Strand Top",
                                            "description": "",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner BG Strand Top .png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "2HSANBDxIPFfpe40wRrEzX",
                                    "type": "Entry",
                                    "createdAt": "2023-06-16T18:24:56.749Z",
                                    "updatedAt": "2023-06-16T18:24:56.749Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 3,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "1AUKNUIiL6YEaYxpX7t22T",
                                    "type": "Entry",
                                    "createdAt": "2022-12-14T19:48:58.589Z",
                                    "updatedAt": "2023-06-20T16:09:09.109Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 70,
                                    "revision": 8,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Terms of Use Rich Text Component - US",
                                    "effectiveDateLabel": "Effective",
                                    "effectiveDate": "2018-11-09",
                                    "disclaimerMessage": "Please read these terms carefully before accessing or using this website",
                                    "content": {
                                        "data": {},
                                        "content": [
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Information about Us",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "These Website Terms and Conditions of Use (\u201CTerms\u201D) describe the terms and conditions applicable to your use the website operated by (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D and \u201Cus\u201D) and located at ",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {
                                                            "uri": "https://www.modernatx.com"
                                                        },
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "marks": [],
                                                                "value": "www.modernatx.com",
                                                                "nodeType": "text"
                                                            }
                                                        ],
                                                        "nodeType": "hyperlink"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": " (the \u201CWebsite\u201D). We are a Delaware corporation and have our registered oGce at 200 Technology Square, Cambridge, MA 02139. All use of or linking to any content on the Website is subject to the terms and conditions contained in these\r\nTerms. By accessing or using the Website, you acknowledge that you have read, understood and agreed to these Terms and acknowledge that any prior agreements regarding the use of the Website between you and Moderna are superseded and of no force or eFect. If you do not agree to the Terms, do not access or use the Website. By using the Website, you represent that you are at least 18 years old.\n\r\nYou understand and agree that we may change these Terms at any time without prior notice. You may read a current, eFective copy of these Terms at any time by selecting the \u201CTerms and Conditions of Use\u201D link on the Website. Moderna may revise these terms at any time without prior notice. Any use of the Website aKer such date shall constitute your acceptance of such revised terms and conditions. If any change to these Terms is not acceptable to you, your sole remedy is to cease accessing, browsing and otherwise using the Website.\n\r\nYour access to and use of the Website is also subject to Moderna\u2019s Privacy Policy located at ",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {
                                                            "uri": "https://www.modernatx.com/privacy-statement"
                                                        },
                                                        "content": [
                                                            {
                                                                "data": {},
                                                                "marks": [],
                                                                "value": "www.modernatx.com/privacy-statement",
                                                                "nodeType": "text"
                                                            }
                                                        ],
                                                        "nodeType": "hyperlink"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": ", the terms and conditions of which are hereby incorporated herein by reference.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Use of Information",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "You may freely browse, access, download or use information from the Website, including any text, images, audio, video and software (\"",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "Information",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\") for your own temporary, non-commercial use. You have no rights in or to the Information, and you will not use, copy or display the Information, except as permitted under these Terms. No other use is permitted without our prior written consent. We may own the Information, or portions of the Information may be made available to us through arrangements that we have with third-parties. The Information is protected by United States and foreign intellectual property laws. Unauthorized use of the Information may result in violation of copyright, trademark, and other laws. You may not sell, transfer, assign, license, sublicense, or modify the Information or reproduce, display, publicly perform, make a derivative version of, distribute, transmit, reuse, repost, or otherwise use the Information in any way for any public or commercial purpose without our written permission. You may not use the Website or the Information from the Website (a) in any way that breaches any applicable local, national or international law or regulation; (b) in any way that is unlawful or fraudulent, or that has any unlawful or fraudulent purpose or effect; (c) to transmit, or procure the sending of, any unsolicited or unauthorized advertising or promotional material or any other form of similar solicitation (spam); or (d) to make unauthorized attempts to access any of our systems or third party networks. The use or posting of any of the Information on any other website or in a networked computer environment for any purpose is expressly prohibited. If you violate any part of these Terms, your right to access and/or use the Information and Site shall automatically terminate and you shall immediately destroy any copies you have made of the Information. We reserve the right to withdraw, amend or revise the Website without notice. We will not be liable if for any reason our Website is unavailable at any time or for any period. Nothing on this Website will be deemed to constitute an invitation to invest or otherwise deal in shares or other securities in Moderna.\n",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Copyright and Trademarks",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "You must retain and reproduce each and every copyright notice or other proprietary rights notice contained in the original Information on any copy you make of the Information or in any Information you download. The intellectual property rights in the Website and in the Information are owned by Moderna, our affiliates or our external partners. You should assume that everything you see or read on the Website is copyrighted unless otherwise noted and may not be used without our written permission except as provided in these Terms or in the text on the Website. No links to the Website may be included in any other website without our prior written permission. With the exception of the foregoing limited authorization, no license to or right in the Information, or any copyright of Moderna or of any other party is granted or conferred to you.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "The trademarks, service marks, and logos of Moderna (the \u201C",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "Moderna Trademarks",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\u201D) used and displayed on the Website are registered and unregistered trademarks or service marks of Moderna or its subsidiaries or affiliates. Other company, product, and service names located on the Website may be trademarks or service marks owned by third-parties (the \u201C",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "Third-Party Trademarks",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\u201D, and, collectively with the Moderna Trademarks, the \u201C",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "Trademarks",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\u201D). Nothing on the Website or in these Terms should be construed as granting, by implication, estoppel, or otherwise, any license or right, express or implied, under any Trademark displayed on the Website without the prior written consent of Moderna specific for each and every instance. The Trademarks may not be used to disparage Moderna or any third party, Moderna\u2019s or a third-party\u2019s products or services, or in any manner (using commercially reasonable judgment) that may damage any goodwill in the Trademarks. Links to the Website from other sites should be text-only and use of any Trademarks as part of a link to or from any website is prohibited without Moderna\u2019s prior written consent. All goodwill generated from the use of any Moderna Trademark shall inure to Moderna\u2019s benefit.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Certain elements of the Website are protected by trade dress, trademark, unfair competition, and other U.S., state, federal, and international laws and may not be copied or imitated in whole or in part, by any means, including but not limited to, the use of framing or mirrors. None of the Information may be retransmitted without the express written consent from Moderna for each and every instance.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Medical Advice",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "The content on the Website is intended to be a general information resource in regard to the subject matter covered. Moderna does not directly or indirectly practice medicine, render medical advice, or dispense medical services via the Website, and nothing contained in the Website is intended to be instruction for medical diagnosis or treatment. Any information provided should not be considered complete, nor should it be relied on to suggest a basis for diagnosis or course of treatment for a particular individual. Information received from the Website should not be relied upon for personal, medical, legal, technical, or financial decisions. It should not be used in place of a visit, call, consultation or the advice of your physician or other qualified healthcare provider. Should you have any healthcare related questions, please consult with your physician or other qualified healthcare provider promptly.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Links",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "This Website may contain links to websites operated by other parties (\u201C",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "External Sites",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\u201D). The External Sites are not under the control of Moderna, and Moderna is not responsible for the content available on any External Sites. Such links do not imply Moderna\u2019s referral or endorsement of material on External Sites or of any other entity, item or service, and Moderna disclaims all liability with regard to your access to External Sites. We are not responsible for the content of any linked External Sites and do not make any representations regarding the content or accuracy of any materials on such External Sites. You should take precautions when downloading files from all websites to protect your computer from viruses and other destructive programs. Moderna provides links to External Sites as a convenience to users, and access to any External Sites linked to this Website is at your own risk.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Forward-Looking Statements",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "The Website contains express or implied forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995, as amended, Section 27A of the Securities Act of 1933, as amended, and Section 21E of the Securities Exchange Act of 1934, that are based on beliefs and assumptions and on information currently available to Moderna\u2019s management. These statements relate to, among other things, Moderna\u2019s expectations regarding plans, objectives, strategies, future operating or financial performance, business plans and prospects, and expectations regarding clinical trials, development timelines, discussions with regulatory authorities, development programs, development candidates and investigational medicines under development by Moderna and by Moderna\u2019s strategic collaborators. In some cases, forward-looking statements can be identified by terminology such as \u201Cmay,\u201D \u201Cshould,\u201D \u201Cexpects,\u201D \u201Cintends,\u201D \u201Cplans,\u201D \u201Canticipates,\u201D \u201Cbelieves,\u201D \u201Cestimates,\u201D \u201Cpredicts,\u201D \u201Cpotential,\u201D \u201Ccontinue,\u201D or the negative of these terms or other comparable terminology, although not all forward-looking statements contain these words. Such statements are based on Moderna\u2019s management\u2019s current expectations and are subject to certain factors, risks and uncertainties that may cause actual results to differ materially from those referred to or implied in such statements. The information presented on the Website is believed to be current as of the date of its original publication. The forward-looking statements on this Website are neither promises nor guarantees, and you should not place undue reliance on these forward-looking statements because they involve known and unknown risks, uncertainties and other factors, many of which are beyond Moderna\u2019s control and which could cause actual results to differ materially from those expressed or implied by these forward-looking statements. Moderna does not intend to update any forward-looking statements appearing on the Website in the event of changing circumstances or otherwise, and such statements are current only as of the date they are made.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Please note that while Moderna\u2019s filings with the United States Securities and Exchange Commission are available on or through Internet links contained on the Website, no information contained on or available through the Website is incorporated by reference into or considered to be part of such filings.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Updates",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Moderna may make changes, corrections and/or improvements to the Information, and to the products and programs described in such Information, at any time without notice. Although we attempt to periodically update the Website, the Information, materials and services provided on or through the Website may occasionally be inaccurate, incomplete or out of date and are provided on an \u201CAS IS\u201D and \u201CAS AVAILABLE\u201D basis. Moderna does not have a duty to update information contained in the Website, and Moderna will not be liable for any failure to update such information. We make no representation as to the completeness, accuracy or currency of any information on the Website, and we undertake no obligation to update or revise the information contained on the Website, whether as a result of new information, future events or circumstances or otherwise. It is your responsibility to verify any information contained in the Website before relying upon it.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Disclaimer of Warranties",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "MODERNA, ITS SUBSIDIARIES AND OTHER AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, STRATEGIC COLLABORATORS, AND LICENSORS (COLLECTIVELY, THE \u201C",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "value": "MODERNA PARTIES",
                                                        "nodeType": "text"
                                                    },
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "\u201C) MAKE NO WARRANTIES OR REPRESENTATIONS AND DO NOT GIVE ANY UNDERTAKINGS, EITHER EXPRESS OR IMPLIED, ABOUT THE WEBSITE OR THE INFORMATION (INCLUDING, WITHOUT LIMITATION, THE TIMELINESS, CURRENCY, ACCURACY, COMPLETENESS OR FITNESS FOR ANY PARTICULAR PURPOSE OF THE INFORMATION OR THAT THE RESULTS WHICH MAY BE OBTAINED FORM THE USE OF THE WEBSITE WILL BE ERROR FREE OR RELIABLE.)",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Limitation of Liability",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "THE MODERNA PARTIES WILL NOT BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT, SPECIAL OR PUNITIVE DAMAGES ARISING OUT OF ACCESS TO, USE OF OR INABILITY TO USE THIS WEBSITE, OR ANY ERRORS OR OMISSIONS IN THE INFORMATION INCLUDING, WITHOUT LIMITATION ANY LIABILITY FOR (I) LOSS OF INCOME OR REVENUE, (II) LOSS OF BUSINESS OR BUSINESS INTERRUPTION, (III) LOSS OF PROFITS OR CONTRACTS, (IV) LOSS OF ANTICIPATED SAVINGS, (V) LOSS OF DATA, (VI) LOSS OF GOODWILL, (VII) WASTED MANAGEMENT OR OFFICE TIME; AND (VIII) FOR ANY OTHER LOSS OR DAMAGE OF ANY KIND, HOWEVER ARISING AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE. ADDITIONALLY, THE MODERNA PARTIES SHALL NOT BE SUBJECT TO LIABILITY FOR THE TRUTH, ACCURACY OR COMPLETENESS OF THE INFORMATION, FOR ERRORS, MISTAKES OR OMISSIONS THEREIN OR FOR ANY DELAYS OR INTERRUPTIONS OF THE DATA OR INFORMATION STREAM FROM WHATEVER CAUSE. YOU USE THE WEBSITE AND THE INFORMATION AT YOUR OWN RISK.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "THE MODERNA PARTIES DO NOT WARRANT THAT THE WEBSITE WILL OPERATE ERROR FREE OR THAT THE WEBSITE, ITS SERVER, OR THE INFORMATION ARE FREE OF COMPUTER VIRUSES OR SIMILAR CONTAMINATION OR DESTRUCTIVE FEATURES. IF YOUR USE OF THE WEBSITE OR THE INFORMATION RESULTS IN THE NEED FOR SERVICING OR REPLACING EQUIPMENT OR DATA, NO MODERNA PARTY SHALL BE RESPONSIBLE FOR THOSE COSTS.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "THE WEBSITE AND INFORMATION ARE PROVIDED ON AN \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE MODERNA PARTIES DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Some jurisdictions do not allow the disclaimer or exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above exclusions or limitations may not apply to you or be enforceable with respect to you. We also do not assume any responsibility, and will not be liable, for any damages to, or viruses that may infect, your computer equipment or other property on account of your access to, or use of, the Information. Moderna reserves the right to discontinue the Website at any time without notice and without liability.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Information You Supply to Us",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Any communication or material you transmit to us by electronic mail or otherwise, including any data, questions, comments, suggestions or the like is, and will be treated as, non-confidential and nonproprietary, and Moderna shall have no obligation of any kind with respect to such information. Anything you transmit or post becomes the property of Moderna and may be used by Moderna and any of its subsidiaries, affiliates, strategic collaborators and third-party service providers for any purpose, including, but not limited to, reproduction, disclosure, transmission, publication, broadcast and posting. Moderna and its subsidiaries, affiliates, strategic collaborators and third-party service providers are free to use, without compensation to you, any ideas, concepts, know-how, or techniques contained in any communication you send to the Website for any purpose whatsoever including, but not limited to, researching, developing, manufacturing and marketing products using or incorporating such information. Any information submitted or provided by you to the Website might be publicly accessible. Important and private information should be protected by you. Moderna is not liable for protection of privacy of email or other information transferred through the Internet or any other network that you may use.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Worldwide Products",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "The Website may contain information on our current or potential future worldwide products and services, not all of which are available in every location. A reference to a product or service on the Website does not imply that such product or service is or will be available in your location. The products referred to on this website may be subject to different regulatory requirements depending on the country of use. Consequently, visitors may be notified that certain sections of the Website are intended only for certain kinds of expert users or only for audiences in certain countries. You should not construe anything on the Website as a promotion or advertisement for any product or for the use of any product that is not authorized by the laws and regulations of your country of residence.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "Applicable Law",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "heading-3"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "You are solely responsible for ensuring compliance with the laws of your specific jurisdiction. The Website can be accessed from every U.S. state, as well as from other countries around the world. Each of those places has laws that may differ from those of Massachusetts, where Moderna is located. By accessing the Website, you and Moderna agree that the laws of The Commonwealth of Massachusetts, without regard to its conflicts of laws principles, will apply to all disputes based on, arising out of, or relating to your use of the Website or any information it contains. With respect to such disputes, you and Moderna also agree and hereby submit to the exclusive personal jurisdiction and venue of any court located in Boston, Massachusetts.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "You will comply with any applicable export restrictions under any applicable export control laws and not to export or re-export any of the Information to countries or persons prohibited under such export control laws. If you are in a country where such export is prohibited or are a person or entity for which such export is prohibited, you may not download any Information. You are solely responsible for compliance with the laws of your specific jurisdiction regarding the import, export, or re-export of the Information.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "The Information is provided with \u201CRESTRICTED RIGHTS.\u201D Use, duplication, or disclosure by the U.S. Government is subject to the restrictions contained in 48 CFR 52.227-19 and 48 CFR 252.227-7013 et seq. or its successor. Use of the Website or Information by the U.S. Government constitutes acknowledgement of our proprietary rights in the Website and Information.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "If any provision of these Terms is found to be unlawful, invalid or unenforceable by any court having competent jurisdiction, the invalidity or unenforceability of such provision shall not affect the validity of the remaining provisions of these Terms, which shall remain in full force and effect. Failure of Moderna to act on or enforce any provision of these Terms shall not be construed as a waiver of that provision or any other provision in these Terms. No waiver shall be effective against Moderna unless made in writing, and no such waiver shall be construed as a waiver in any other or subsequent instance. Except as expressly agreed by Moderna and you in writing, these Terms constitute the entire agreement between you and Moderna with respect to the subject matter and supersedes all previous or contemporaneous agreements, whether written or oral, between the parties with respect to the subject matter. The section headings are provided merely for convenience and shall not be given any legal import. Moderna may assign its ownership, control, or other rights to any party at any time without notice to you.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            },
                                            {
                                                "data": {},
                                                "content": [
                                                    {
                                                        "data": {},
                                                        "marks": [],
                                                        "value": "These terms will inure to the benefit of our successors, assigns, licensees, and sublicensees.",
                                                        "nodeType": "text"
                                                    }
                                                ],
                                                "nodeType": "paragraph"
                                            }
                                        ],
                                        "nodeType": "document"
                                    },
                                    "backToTopButtonLabel": "Back To Top",
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "7rSkinNLdOrCD7IDSdKH7b",
                                    "type": "Entry",
                                    "createdAt": "2023-05-24T19:21:51.275Z",
                                    "updatedAt": "2023-06-16T17:43:18.090Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 186,
                                    "revision": 29,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "6e8bR8NoNNipQ8XOsEQOLG",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};




const $cba6beb41997421d$export$13b11f8b9ec9f456 = {
    "sys": {
        "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
            "fields": {
                "name": "Colo/Conn Wholesale Acquisition Cost WAC",
                "title": "Colo/Conn Wholesale Acquisition Cost ",
                "slug": "wac-disclosure",
                "seo": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "4hLuoVxij054wwwpKkcQiq",
                        "type": "Entry",
                        "createdAt": "2023-10-02T18:43:34.168Z",
                        "updatedAt": "2023-10-02T18:43:34.168Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 3,
                        "revision": 1,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Colo./Conn. Wholesale Acquisition Cost > SEO ",
                        "title": "Colo./Conn. Wholesale Acquisition Cost ",
                        "no_index": false,
                        "no_follow": false
                    }
                },
                "content": {
                    "metadata": {
                        "tags": [],
                        "concepts": []
                    },
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                            }
                        },
                        "id": "3PWfUkDEkaeMXq2JBTbRRy",
                        "type": "Entry",
                        "createdAt": "2023-08-24T18:26:37.808Z",
                        "updatedAt": "2023-10-02T18:44:31.244Z",
                        "environment": {
                            "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "publishedVersion": 8,
                        "revision": 3,
                        "contentType": {
                            "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                            }
                        },
                        "locale": "en-US"
                    },
                    "fields": {
                        "name": "Colo./Conn. Wholesale Acquisition Cost > Rich Text",
                        "modules": [
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "59XcyYEtuSn7hn2v3TrFUH",
                                    "type": "Entry",
                                    "createdAt": "2023-08-24T18:25:44.792Z",
                                    "updatedAt": "2023-10-02T18:44:04.152Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 10,
                                    "revision": 4,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "bannerComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Colo./Conn. Wholesale Acquisition Cost > Rich Text > Banner",
                                    "headline": "Information for Prescribing Practitioners and Pharmacists in Colorado and Connecticut ",
                                    "backgroundImage": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "1Px4l8fvDKjBGrRTCqfWrE",
                                            "type": "Asset",
                                            "createdAt": "2022-12-29T16:44:45.722Z",
                                            "updatedAt": "2022-12-29T16:44:45.722Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "Banner BG strand top right",
                                            "description": "Banner BG strand top right",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                                "details": {
                                                    "size": 47693,
                                                    "image": {
                                                        "width": 1920,
                                                        "height": 511
                                                    }
                                                },
                                                "fileName": "Banner_BG_strand_right.png",
                                                "contentType": "image/png"
                                            }
                                        }
                                    },
                                    "country": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "7sht7920U6vs3CLH2CUyaa",
                                            "type": "Entry",
                                            "createdAt": "2023-05-18T03:23:50.744Z",
                                            "updatedAt": "2023-05-24T22:55:23.250Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 6,
                                            "revision": 2,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "country"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "United States",
                                            "isocode": "US",
                                            "flag": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                                    "type": "Asset",
                                                    "createdAt": "2023-05-24T22:54:50.939Z",
                                                    "updatedAt": "2023-05-24T22:54:50.939Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 5,
                                                    "revision": 1,
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "title": "usa flag",
                                                    "description": "USA Flag",
                                                    "file": {
                                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                        "details": {
                                                            "size": 2487,
                                                            "image": {
                                                                "width": 36,
                                                                "height": 26
                                                            }
                                                        },
                                                        "fileName": "usa_flag.svg",
                                                        "contentType": "image/svg+xml"
                                                    }
                                                }
                                            },
                                            "locales": [
                                                "en-US"
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "2H1rWl7LVimvYsRSbvm4pL",
                                    "type": "Entry",
                                    "createdAt": "2023-08-24T18:26:27.250Z",
                                    "updatedAt": "2024-08-23T13:10:58.184Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 43,
                                    "revision": 11,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "richTextContentComponent"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Colo./Conn. Wholesale Acquisition Cost > Rich Text > Rich Text Content ",
                                    "content": {
                                        "nodeType": "document",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna COVID-19 Vaccine (mRNA) ",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "2024-2025 Formula",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The Colorado Wholesale Acquisition Cost Disclosure Law (Colorado House Bill 19-1131), Colo. Rev. Stat. Ann. \xa7 12-280-308 (HB19-1131), requires that prescription drug manufacturers disclose in writing to Colorado prescribers the Wholesale Acquisition Cost (\u201CWAC\u201D) of marketed drugs when engaging in prescription drug marketing. Connecticut Public Act No. 23-171 (Connecticut House Bill 6669) requires that pharmaceutical manufacturers disclose to a prescribing practitioner or pharmacist, in writing, the list price of legend drugs at the time of each contact.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "WAC prices, as defined by Colorado and federal law, represent Moderna\u2019s published list prices for the products sold to wholesalers, before any discount, rebate, or other price reduction, as reported in wholesale price guides (compendia) or other publications of drug or biological pricing data. The WAC prices (also referred to as list prices) listed below may differ from the prices paid by consumers. The price paid by consumers may be higher or lower than the prices listed below and how much a patient will pay will vary based on the patient\u2019s insurance coverage. To determine the cost of a specific prescription, a patient should contact their preferred pharmacy and/or health insurance company.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "NDC",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F80777-0110-93, 80777-0110-96, 80777-0110-01 (Inner Pack NDC)\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202FSpikevax\xae (COVID-19 Vaccine, mRNA) 2024-2025 Formula - Age 12yr.+\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Dosage Form",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202FPre-Filled Syringe\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Strength",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F0.5 mL\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Package Size",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202FBox of ten (10) doses\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "List Price / Wholesale Acquisition Cost (per dose)",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F$141.80",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "NDC",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F80777-0291-80, 80777-0291-81, 80777-0291-09 (Inner Pack NDC)\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna COVID-19 Vaccine (2024-2025 Formula)",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " - Age 6 mos.-11yrs.\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Dosage Form",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F Pre-Filled Syringe\u202F\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Strength",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F0.25 mL\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Package Size",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202FBox of ten (10) doses\u202F\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "List Price / Wholesale Acquisition Cost (per dose)",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ":\u202F$129.00\u202F\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The Colorado Wholesale Acquisition Cost Disclosure law also requires that manufacturers provide \u201Cat least three generic prescription drugs from the same therapeutic class, or if three are not available, as many as are available for prescriptive use.\u201D\u202F Colorado defines \u201Ctherapeutic class\u201D as \u201Ca group of similar drugs that have the same or similar mechanisms of action and are used to treat a specific condition.\u201D\u202F\u202FThere are no generic prescription drugs applicable to the products listed above.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Colorado State Board of Pharmacy",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For more information on the\u202FColorado Wholesale Acquisition Cost Disclosure law\u202Fand the state\u2019s WAC and therapeutic equivalent requirements, please contact the Colorado State Board of Pharmacy\u2019s office:\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Colorado State Board of Pharmacy\xa0\n1560 Broadway, Suite 1350\xa0\nDenver, CO 80202\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Website:\u202F",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.colorado.gov/pacific/dora/Pharmacy"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "https://www.colorado.gov/pacific/dora/Pharmacy",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0\xa0\xa0\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Office: 303-894-7800\xa0\nFax: 303-894-7692\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Connecticut Public Act No. 23-171 also requires that manufacturers disclose information on the variation efficacy of the drug marketed to different racial and ethnic groups, if such information is available. This information is available in the ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/5efa7d9d-05e8-46b5-945a-637c2867bd00/5efa7d9d-05e8-46b5-945a-637c2867bd00_viewable_rendition__v.pdf"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Spikevax Full Prescribing Information",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " and the ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/b6653c87-2627-405c-b151-be87db581e7d/b6653c87-2627-405c-b151-be87db581e7d_viewable_rendition__v.pdf"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "Fact Sheet for Healthcare Providers Administering Vaccine",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " (Emergency Use Authorization of ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Moderna COVID-19 Vaccine (2024-2025 Formula)",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ", for Individuals 6 Months Through 11 Years of Age).\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This disclosure does not contain any medical or treatment advice. The only purpose of this disclosure is to provide information in accordance with the Colorado Wholesale Acquisition Cost Disclosure Law and Connecticut Public Act No. 23-171. This notice is not intended for consumers or patients. Prescribing and other medical decisions should be based on shared decision-making between a patient and their healthcare provider(s) to determine whether and which treatment options and/or prescription drug(s) are appropriate based on independent clinical decision-making and a review of all relevant information and factors, including the FDA\u2019s approved prescribing information. Patients may also discuss their prescription drug(s) with their preferred pharmacist in collaboration with their healthcare provider(s).\u202F\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "hr",
                                                "data": {},
                                                "content": []
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "mRESVIA\xae (Respiratory Syncytial Virus Vaccine)",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The Colorado Wholesale Acquisition Cost Disclosure Law (Colorado House Bill 19-1131), Colo. Rev. Stat. Ann. \xa7 12-280-308 (HB19-1131), requires that prescription drug manufacturers disclose in writing to Colorado prescribers the Wholesale Acquisition Cost (\u201CWAC\u201D) of marketed drugs when engaging in prescription drug marketing. Connecticut Public Act No. 23-171 (Connecticut House Bill 6669) requires that pharmaceutical manufacturers disclose to a prescribing practitioner or pharmacist, in writing, the list price of legend drugs at the time of each contact.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "WAC prices, as defined by Colorado and federal law, represent Moderna\u2019s published list prices for the products sold to wholesalers, before any discount, rebate, or other price reduction, as reported in wholesale price guides (compendia) or other publications of drug or biological pricing data. The WAC prices (also referred to as list prices) listed below may differ from the prices paid by consumers. The price paid by consumers may be higher or lower than the prices listed below and how much a patient will pay will vary based on the patient\u2019s insurance coverage. To determine the cost of a specific prescription, a patient should contact their preferred pharmacy and/or health insurance company.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "NDC:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " 80777-345-96\xa0\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Product:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " mRESVIA\xae (Respiratory Syncytial Virus Vaccine) - Age 60yr.+ mRESVIA\xae (Respiratory Syncytial Virus Vaccine) - Age 60yr.+ and individuals 18 through 59 years of age who are at increased risk for LRTD caused by RSV.\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Dosage Form:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Pre-Filled Syringe\xa0\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Strength:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " 0.5 ml\xa0\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Package Size:",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " Box of ten (10) doses\xa0\n",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "List Price / Wholesale Acquisition Cost (per dose):",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": " $290\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "The Colorado Wholesale Acquisition Cost Disclosure law also requires that manufacturers provide \u201Cat least three generic prescription drugs from the same therapeutic class, or if three are not available, as many as are available for prescriptive use.\u201D\u202F Colorado defines \u201Ctherapeutic class\u201D as \u201Ca group of similar drugs that have the same or similar mechanisms of action and are used to treat a specific condition.\u201D\u202F\u202FThere are no generic prescription drugs applicable to the products listed above.\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Colorado State Board of Pharmacy",
                                                        "marks": [
                                                            {
                                                                "type": "underline"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "For more information on the\u202FColorado Wholesale Acquisition Cost Disclosure law\u202Fand the state\u2019s WAC and therapeutic equivalent requirements, please contact the Colorado State Board of Pharmacy\u2019s office:\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Colorado State Board of Pharmacy\xa0\n1560 Broadway, Suite 1350\xa0\nDenver, CO 80202\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Website:\u202F",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://www.colorado.gov/pacific/dora/Pharmacy"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "https://www.colorado.gov/pacific/dora/Pharmacy",
                                                                "marks": [
                                                                    {
                                                                        "type": "underline"
                                                                    }
                                                                ],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa0\xa0\xa0\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Office: 303-894-7800\xa0\nFax: 303-894-7692\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Connecticut Public Act No. 23-171 also requires that manufacturers disclose information on the variation efficacy of the drug marketed to different racial and ethnic groups, if such information is available. This information is available in the ",
                                                        "marks": [],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "hyperlink",
                                                        "data": {
                                                            "uri": "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/36130c97-6fb0-4bea-9f2e-fb5be7a90729/36130c97-6fb0-4bea-9f2e-fb5be7a90729_viewable_rendition__v.pdf"
                                                        },
                                                        "content": [
                                                            {
                                                                "nodeType": "text",
                                                                "value": "mRESVIA Full Prescribing Information",
                                                                "marks": [],
                                                                "data": {}
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": ".\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "This disclosure does not contain any medical or treatment advice. The only purpose of this disclosure is to provide information in accordance with the Colorado Wholesale Acquisition Cost Disclosure Law and Connecticut Public Act No. 23-171. This notice is not intended for consumers or patients. Prescribing and other medical decisions should be based on shared decision-making between a patient and their healthcare provider(s) to determine whether and which treatment options and/or prescription drug(s) are appropriate based on independent clinical decision-making and a review of all relevant information and factors, including the FDA\u2019s approved prescribing information. Patients may also discuss their prescription drug(s) with their preferred pharmacist in collaboration with their healthcare provider(s).\u202F\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "Last updated: 08/23/2024\u202F\u202F",
                                                        "marks": [
                                                            {
                                                                "type": "bold"
                                                            },
                                                            {
                                                                "type": "italic"
                                                            }
                                                        ],
                                                        "data": {}
                                                    },
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\nSpikevax\xae and mRESVIA\xae are registered trademarks of Moderna.\u202F\xa0\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            },
                                            {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                    {
                                                        "nodeType": "text",
                                                        "value": "\xa9 2024 Moderna. LEGAL-US-COV-2400029 08/2024\xa0",
                                                        "marks": [],
                                                        "data": {}
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "printButtonLabel": "Print",
                                    "country": "[Circular Reference]"
                                }
                            }
                        ]
                    }
                }
            },
            "sys": {
                "id": "22jvFsxpPrKci4MhrmZOcd",
                "type": "Entry"
            }
        }
    ],
    "includes": {
        "Entry": [
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]",
            "[Circular Reference]"
        ],
        "Asset": [
            "[Circular Reference]",
            "[Circular Reference]"
        ]
    }
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $3bYfT = parcelRequire("3bYfT");

const $f094a6e5b61638ae$var$CustomBold = (0, $d8seH.default)("span")`
  font-family: "Aeonik Bold", "Arial";
`;
const $f094a6e5b61638ae$var$CustomParagraph = (0, $d8seH.default)('p')`
   line-height:22px;
   padding-top: 15px;
`;
const $f094a6e5b61638ae$var$CustomList = (0, $d8seH.default)('ul')(({ theme: { breakpoints: breakpoints } })=>`
  list-style-type: initial;
  margin-left: 20px;
  font-family: 'Aeonik Regular';
  ${[
        breakpoints.down('sm')
    ]} {
    margin-top: 24px;
    margin-bottom: 30px;
  }
`);
const $f094a6e5b61638ae$var$CustomTable = (0, $d8seH.default)('table')`
    border: 1px solid black;
    border-collapse: collapse;
    & th {
        border: 1px solid black;
    }
    & td {
      border: 1px solid black;
      text-align: center;
    }
`;
const $f094a6e5b61638ae$var$ComposePageRichTextRenderer = ({ jsonData: jsonData, setShowNavigationAlert: setShowNavigationAlert, setExternalLink: setExternalLink, setExternalLinkModalType: setExternalLinkModalType })=>{
    const isLinkOutsideModrna = (url)=>{
        return !url.includes('modernadirect');
    };
    const renderTextWithLineBreaks = (text)=>{
        return text.split("\n").map((segment, index)=>index === 0 ? segment : [
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}, index),
                segment
            ]);
    };
    const renderNode = (node)=>{
        if (!node) return null;
        const { nodeType: nodeType, content: content, data: data } = node;
        switch(nodeType){
            case "document":
                return content.map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: renderNode(child)
                    }, index));
            case "paragraph":
                return /*#__PURE__*/ (0, $ayMG0.jsx)($f094a6e5b61638ae$var$CustomParagraph, {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "heading-1":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$da524f2075150321), {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "heading-2":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$b534932db7eb0121), {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "heading-3":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h5",
                    pt: "80px",
                    children: content.map((child, index)=>renderNode(child))
                });
            case "unordered-list":
                return /*#__PURE__*/ (0, $ayMG0.jsx)($f094a6e5b61638ae$var$CustomList, {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "ordered-list":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "list-item":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "table":
                return /*#__PURE__*/ (0, $ayMG0.jsx)($f094a6e5b61638ae$var$CustomTable, {
                    children: content.map((child, index)=>renderNode(child))
                });
            case "embedded-asset-block":
                const { title: title, file: file } = data?.target?.fields || {};
                return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: file?.url,
                    alt: title,
                    style: {
                        maxWidth: "100%"
                    }
                });
            case "text":
                const isBold = node.marks?.some((mark)=>mark.type === "bold");
                const isUnderline = node.marks?.some((mark)=>mark.type === "underline");
                const formattedText = renderTextWithLineBreaks(node.value);
                let textElement = formattedText;
                if (isBold) textElement = /*#__PURE__*/ (0, $ayMG0.jsx)($f094a6e5b61638ae$var$CustomBold, {
                    children: textElement
                });
                if (isUnderline) textElement = /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                    children: textElement
                });
                return textElement;
            case "hyperlink":
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: {
                        pathname: data.uri
                    },
                    target: isLinkOutsideModrna(data.uri) ? "_blank" : "_self",
                    rel: isLinkOutsideModrna(data.uri) ? "noopener noreferrer" : "",
                    onClick: (e)=>{
                        openExternalLinkHandler(e, data.uri);
                    },
                    "data-external-modal": isLinkOutsideModrna(data.uri) ? "dataExternalSocialModal" : "dataExternalModal",
                    children: content?.[0]?.value
                });
            case "hr":
                return /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {});
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: content?.map((child, index)=>renderNode(child))
                });
        }
    };
    const openExternalLinkHandler = (event, url)=>{
        event.preventDefault();
        if (isLinkOutsideModrna(url) && !localStorage.getItem("dontRemindMeExternal")) {
            setShowNavigationAlert(true);
            setExternalLink(url);
            setExternalLinkModalType("extrenalLink");
        } else {
            window.open(url, '_blank');
            setExternalLink("");
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: renderNode(jsonData)
    });
};
var $f094a6e5b61638ae$export$2e2bcd8739ae039 = $f094a6e5b61638ae$var$ComposePageRichTextRenderer;


const $20541fe5565a96be$var$BannerContainer = (0, $d8seH.default)('div')(({ aboveFoldBGImage: aboveFoldBGImage, theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    background-image: url(${aboveFoldBGImage});
    background-size: cover;
    background-position: right;
    background-color: ${primary.main};
    height: 200px;
    ${[
        breakpoints.down('sm')
    ]} {
        background-image: unset;
        height: 180px;
    }
    `);
const $20541fe5565a96be$var$BannerContentContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
    display: flex;
    font-family: 'Aeonik Regular', 'Arial';
    color: #FFF;
    justify-content: space-between;
    align-items: center;
    max-width: 1050px;
    height: 100%;
    margin: 0 auto;
    ${[
        breakpoints.down('sm')
    ]} {
        justify-content: space-around;
        flex-direction: column;
        padding: 36px;
    }
`);
const $20541fe5565a96be$var$ComposePage = ({ relativePathname: relativePathname, setShowNavigationAlert: setShowNavigationAlert, setExternalLink: setExternalLink, setExternalLinkModalType: setExternalLinkModalType })=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const [staticContent, setStaticContent] = (0, $acw62.useState)([]);
    const [staticBannerContent, setStaticBannerContent] = (0, $acw62.useState)([]);
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>{
        return state.globalStates.locale;
    });
    const getPageContentFromPath = (pathname)=>{
        relativePathname = pathname.includes(`${locale}`) ? pathname.replace(`/${locale}/`, "") : pathname.replace('/', "");
        const contentMapper = {
            'wac-disclosure': (0, $cba6beb41997421d$export$13b11f8b9ec9f456),
            'privacy-policy': (0, $01210b9d1ac5edec$export$c89971efab1b6246),
            'terms-of-use': (0, $6cd2daf0e5c7fb79$export$8a4803631865e123),
            'game': (0, $ad4d48767f20373d$export$706eb9ec8966017),
            'return-goods-policy': (0, $7fb8eb39ded60e0f$export$fc54a338fd840f30),
            'participating-physician-buying-groups': (0, $cb949f2f46d032c1$export$125fcbf7cb8dd591),
            'dscsa': (0, $1ce3e70efa9c2e77$export$971388968c550794),
            'notice-of-seasonal-return-window': (0, $680f79d69bcc1805$export$a899f435c2d6c572),
            'authorized-distributor': (0, $06eed0502aa587ed$export$90ee43f4b1faff2),
            'packing-slip': (0, $44e103941070dfa7$export$e06c56edb605666d),
            'terms-and-conditions-of-sale': (0, $7d2250bb74d20843$export$50fdc3ea919136dd)
        };
        return contentMapper[relativePathname];
    };
    (0, $acw62.useEffect)(()=>{
        if (relativePathname !== "/") {
            let bannerContent, richTextContent;
            getPageContentFromPath(relativePathname)?.items[0]?.fields?.content?.fields?.modules.forEach((item)=>{
                if (item?.fields?.title.includes("Banner")) bannerContent = item;
                if (item?.fields?.title && !item?.fields?.title.includes("Banner")) richTextContent = item;
            });
            setStaticBannerContent(bannerContent);
            setStaticContent(richTextContent);
        }
    }, [
        relativePathname
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: !authState?.isAuthenticated ? {
            position: "relative",
            margin: "0 auto"
        } : {},
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($20541fe5565a96be$var$BannerContainer, {
                aboveFoldBGImage: staticBannerContent?.fields?.backgroundImage?.fields?.file?.url,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($20541fe5565a96be$var$BannerContentContainer, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: 'h1',
                        children: staticBannerContent?.fields?.headline
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                maxWidth: "md",
                sx: {
                    paddingTop: "50px",
                    '@media screen and (max-width: 500px)': {
                        padding: "50px 36px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            staticContent?.fields?.effectiveDate && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: "body2",
                                sx: {
                                    '@media screen and (max-width: 500px)': {
                                        fontSize: "16px"
                                    }
                                },
                                gutterBottom: true,
                                children: [
                                    staticContent?.fields?.effectiveDateLabel,
                                    " ",
                                    (0, $382eb84981692d3a$export$ff626af7f207c74d)(staticContent?.fields?.effectiveDate)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                sx: {
                                    cursor: 'pointer'
                                },
                                onClick: ()=>window.print(),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ba8f795f04ca3e35$exports))),
                                        height: "20",
                                        width: "20",
                                        alt: "PRINT"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: staticContent?.fields?.printButtonLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "subtitle2",
                        gutterBottom: true,
                        sx: {
                            fontWeight: "bold",
                            '@media screen and (max-width: 500px)': {
                                fontSize: "16px"
                            }
                        },
                        children: staticContent?.fields?.disclaimerMessage
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            height: "auto",
                            color: "primary.main",
                            fontFamily: "Aeonik Regular, Arial"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f094a6e5b61638ae$export$2e2bcd8739ae039), {
                            jsonData: staticContent?.fields?.content,
                            setShowNavigationAlert: setShowNavigationAlert,
                            setExternalLink: setExternalLink,
                            setExternalLinkModalType: setExternalLinkModalType
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: {
                            xs: '60%',
                            sm: '40%'
                        },
                        margin: "50px auto",
                        children: staticContent?.fields?.backToTopButtonLabel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "secondary",
                            onClick: ()=>window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                }),
                            children: staticContent?.fields?.backToTopButtonLabel
                        })
                    })
                ]
            })
        ]
    });
};
var $20541fe5565a96be$export$2e2bcd8739ae039 = $20541fe5565a96be$var$ComposePage;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3OJTQ = parcelRequire("3OJTQ");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $3OJTQ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $14H9o.default)();
    const props = (0, $hcz0Q.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


var $bc9702fae4097d39$exports = {};
$bc9702fae4097d39$exports = new URL("View_Icon.11c60661.svg", import.meta.url).toString();



var $3bYfT = parcelRequire("3bYfT");
const $399b28e45da3f7d1$var$GridContainer = (0, $d8seH.default)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039))(({ theme: { palette: { secondary: secondary, neutral: neutral } } })=>`
  background-color: ${secondary.main};
  border-radius: 16px;
  padding: 10px 10px 26px 10px;
  margin: 0 !important;
  width: 100% !important;
  &&.edit {
    background-color: ${neutral.gray5};
}
`);
const $399b28e45da3f7d1$var$ViewContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    ${[
        breakpoints.down('sm')
    ]} {
        width: 100%;
        padding-right: 10px;
    }
`);
const $399b28e45da3f7d1$var$Label = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  color: ${primary.main};
  margin-top: 5px;
  margin-Bottom: 5px;
  text-transform: uppercase;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 16.5px;
  }
`);
const $399b28e45da3f7d1$var$Value = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
  user-select: text;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 24px;
  }
`);
const $399b28e45da3f7d1$var$NotFoundValue = (0, $d8seH.default)('p')(({ theme: { palette: { neutral: neutral } } })=>`
  color: ${neutral.gray2};
`);
const $399b28e45da3f7d1$var$LABELS = {
    licensesSectionLabel: 'Licensing Information',
    deaNumberLabel: 'DEA Number',
    hinNumberLabel: 'Health Industry Number (HIN)',
    notFoundText: '-'
};
const $399b28e45da3f7d1$export$2c56d2e2ae515eeb = ({ userInfo: userInfo, pageType: pageType })=>{
    const [showDea, setShowDea] = (0, $acw62.useState)(false);
    const [showHin, setShowHin] = (0, $acw62.useState)(false);
    const toggleDea = ()=>{
        setShowDea((prev)=>!prev);
    };
    const toggleHin = ()=>{
        setShowHin((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        margin: "30px auto 0 auto",
        width: "80%",
        id: "License",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h3',
                fontFamily: 'Aeonik Light',
                color: "primary.main",
                textAlign: "left",
                mb: "25px",
                mt: "30px",
                id: "title",
                children: $399b28e45da3f7d1$var$LABELS.licensesSectionLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($399b28e45da3f7d1$var$GridContainer, {
                container: true,
                spacing: 2,
                className: pageType,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$Label, {
                                variant: 'h6',
                                id: "deaNumberLabel",
                                children: $399b28e45da3f7d1$var$LABELS.deaNumberLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$ViewContainer, {
                                className: pageType,
                                children: userInfo?.orgUnit?.deaLicense ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$Value, {
                                            variant: 'p1',
                                            id: "deaNumber",
                                            children: showDea ? userInfo?.orgUnit?.deaLicense : '**********'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bc9702fae4097d39$exports))),
                                            alt: "view icon",
                                            height: "30",
                                            width: "30",
                                            onClick: toggleDea
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$NotFoundValue, {
                                    variant: 'p1',
                                    children: $399b28e45da3f7d1$var$LABELS.notFoundText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$Label, {
                                variant: 'h6',
                                id: "hinNumberLabel",
                                children: $399b28e45da3f7d1$var$LABELS.hinNumberLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$ViewContainer, {
                                className: pageType,
                                children: userInfo?.orgUnit?.hin ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$Value, {
                                            variant: 'p1',
                                            id: "hinNumber",
                                            children: showHin ? userInfo?.orgUnit?.hin : '**********'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bc9702fae4097d39$exports))),
                                            alt: "view icon",
                                            height: "30",
                                            width: "30",
                                            onClick: toggleHin
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($399b28e45da3f7d1$var$NotFoundValue, {
                                    variant: 'p1',
                                    children: $399b28e45da3f7d1$var$LABELS.notFoundText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");


var $3bYfT = parcelRequire("3bYfT");
const $e81af56a16d8a3ac$var$GridContainer = (0, $d8seH.default)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039))(({ theme: { palette: { neutral: neutral, secondary: secondary }, breakpoints: breakpoints } })=>`
  background-color: ${secondary.main};
  border-radius: 16px;
  padding: 10px 10px 26px 10px;
  margin: 0 !important;
  width: 100% !important;
  &&.edit {
    background-color: ${neutral.gray5};
  }
`);
const $e81af56a16d8a3ac$var$Label = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  color: ${primary.main};
  margin-top: 5px;
  margin-Bottom: 5px;
  text-transform: uppercase;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 16.5px;
  }
`);
const $e81af56a16d8a3ac$var$Value = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
  user-select: text;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 24px;
  }
`);
const $e81af56a16d8a3ac$var$LABELS = {
    accountDetailsSectionLabel: 'Account Details',
    accountNameLabel: 'Account Name',
    officeAddressLabel: 'Main Office Address',
    officePhoneLabel: 'Main Office Phone',
    officeEmailLabel: 'Main Office Email',
    notFound: '-'
};
const $e81af56a16d8a3ac$export$66e04d0aacdb3b2 = ({ userInfo: userInfo, pageType: pageType })=>{
    const soldToAddress = userInfo?.orgUnit?.addresses.filter((address)=>address?.partnerFunction === "SOLD_TO")[0];
    const accountName = userInfo?.legalAccountName || '-';
    const officeAddress = soldToAddress?.formattedAddress || '-';
    const officePhone = soldToAddress?.phone || '-';
    const officeEmail = soldToAddress?.email || '-';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        margin: "30px auto 50px auto",
        width: "80%",
        id: "AccountDetails",
        "data-testid": "accountDetails",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h3',
                fontFamily: 'Aeonik Light',
                color: "primary.main",
                textAlign: "left",
                mb: "25px",
                mt: "30px",
                "data-testid": "accountDetailsSectionLabel",
                children: $e81af56a16d8a3ac$var$LABELS.accountDetailsSectionLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e81af56a16d8a3ac$var$GridContainer, {
                container: true,
                spacing: 2,
                className: pageType,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 12,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Label, {
                                variant: 'h6',
                                id: "accountNameLabel",
                                "data-testid": "accountNameLabel",
                                children: $e81af56a16d8a3ac$var$LABELS.accountNameLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Value, {
                                variant: 'p1',
                                id: "accountNameVal",
                                "data-testid": "accountName",
                                children: accountName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Label, {
                                variant: 'h6',
                                id: "officeAddressLabel",
                                "data-testid": "officeAddressLabel",
                                children: $e81af56a16d8a3ac$var$LABELS.officeAddressLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Value, {
                                variant: 'p1',
                                id: "officeAddress",
                                "data-testid": "officeAddress",
                                children: officeAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Label, {
                                variant: 'h6',
                                id: "officePhoneLabel",
                                "data-testid": "officePhoneLabel",
                                children: $e81af56a16d8a3ac$var$LABELS.officePhoneLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Value, {
                                variant: 'p1',
                                id: "officePhone",
                                "data-testid": "officePhone",
                                children: officePhone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Label, {
                                variant: 'h6',
                                id: "officeEmailLabel",
                                "data-testid": "officeEmailLabel",
                                children: $e81af56a16d8a3ac$var$LABELS.officeEmailLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e81af56a16d8a3ac$var$Value, {
                                variant: 'p1',
                                id: "officeEmail",
                                "data-testid": "officeEmail",
                                children: officeEmail
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $3bYfT = parcelRequire("3bYfT");



const $1d48ed549a6a355c$var$GridContainer = (0, $d8seH.default)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039))(({ theme: { palette: { neutral: neutral, secondary: secondary }, breakpoints: breakpoints } })=>`
  background-color: ${secondary.main};
  border-radius: 16px;
  padding: 26px;
  margin: 0 !important;
  width: 350px;
  height: 200px;
`);
const $1d48ed549a6a355c$var$Value = (0, $d8seH.default)((0, $3bYfT.default))(`
  font-size: 15px;
  text-align: left;
`);
const $1d48ed549a6a355c$var$ValueBold = (0, $d8seH.default)($1d48ed549a6a355c$var$Value)(`
  font-family: Aeonik Bold;
`);
const $1d48ed549a6a355c$var$DefaultValue = (0, $d8seH.default)($1d48ed549a6a355c$var$ValueBold)(`
  font-size: 15px;
  color: #2aace2;
`);
const $1d48ed549a6a355c$var$AddressType = (0, $d8seH.default)((0, $3bYfT.default))(`
  font-family: Aeonik Light;
  font-size: 22px;
  text-align: left;
  color: #1e2846;
  margin-bottom: 15px;
  margin-top: 30px;
`);
const $1d48ed549a6a355c$var$SetDefault = (0, $d8seH.default)((0, $3bYfT.default))(`
  font-family: Aeonik Regular;
  font-size: 15px;
  color: #2aace2;
`);
const $1d48ed549a6a355c$var$AddressBox = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`);
const $1d48ed549a6a355c$var$LABELS = {
    addressSoldToLabel: 'Sold To',
    addressShippingLabel: 'Shipping',
    addressUnavailableLabel: 'Unavailable'
};
const $1d48ed549a6a355c$export$6645071c2268d4b8 = ({ addresses: addresses, pageType: pageType, setLoader: setLoader })=>{
    if (!Array.isArray(addresses)) addresses = [];
    let modifiedAddresses = [
        ...addresses
    ];
    const soldToAddresses = modifiedAddresses.filter((address)=>address?.partnerFunction === "SOLD_TO");
    const soldToAddress = soldToAddresses[0];
    const [shipToAddresses, setShipToAddresses] = (0, $acw62.useState)(modifiedAddresses.filter((address)=>address?.partnerFunction === "SHIP_TO"));
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { commerceUser: commerceUser } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const defaultAddress = commerceUser?.data?.defaultAddress;
    const sortAddresses = (a, b)=>{
        if (a?.defaultAddress !== b?.defaultAddress) return b?.defaultAddress - a?.defaultAddress;
        const nameComparison = a?.companyName?.localeCompare(b?.companyName);
        if (nameComparison === 0) return a?.line1?.localeCompare(b?.line1);
        return nameComparison;
    };
    const getDefaultShippingAddress = ()=>{
        const modifiedShippingAddresses = shipToAddresses.map((address)=>({
                ...address,
                defaultAddress: address?.uid === defaultAddress?.uid
            }));
        modifiedShippingAddresses.sort(sortAddresses);
        setShipToAddresses(modifiedShippingAddresses);
    };
    (0, $acw62.useEffect)(getDefaultShippingAddress, []);
    const [page, setPage] = (0, $acw62.useState)(1);
    const CELL_PER_PAGE = 9;
    let paginateStart = (page - 1) * CELL_PER_PAGE;
    let paginateEnd = paginateStart + CELL_PER_PAGE;
    const pageCount = Math.ceil(modifiedAddresses.length / CELL_PER_PAGE);
    const handlePageChange = (event, value)=>{
        setPage(value);
    };
    const CustomPagination = (props)=>{
        const { page: page, pageCount: pageCount } = props;
        const handleBackButtonClick = (event)=>{
            if (page > 1) handlePageChange(event, page - 1);
        };
        const handleNextButtonClick = (event)=>{
            if (page < pageCount) handlePageChange(event, page + 1);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                id: "Pagination",
                "data-testid": "pagination",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63bd8d80cef7fd02$export$2e2bcd8739ae039), {
                        onClick: handleBackButtonClick,
                        disabled: page === 1,
                        fontSize: "large",
                        sx: {
                            color: 'secondary.graphical',
                            opacity: page === 1 ? 0.5 : 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        variant: 'p1',
                        children: [
                            page,
                            " of ",
                            pageCount
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f2bda4f7177714d$export$2e2bcd8739ae039), {
                        onClick: handleNextButtonClick,
                        disabled: page === pageCount,
                        fontSize: "large",
                        sx: {
                            color: 'secondary.graphical',
                            opacity: page === pageCount ? 0.5 : 1
                        }
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        margin: "30px auto 0 auto",
        width: "80%",
        id: "AddressesDetails",
        "data-testid": "addressesDetails",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$AddressType, {
                id: "SoldToAddressLabel",
                "data-testid": "soldToAddressLabel",
                children: $1d48ed549a6a355c$var$LABELS.addressSoldToLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$GridContainer, {
                id: "SoldToAddress",
                "data-testid": "soldToAddressContainer",
                children: soldToAddress ? /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$AddressBox, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        width: '100%',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$ValueBold, {
                                variant: 'p1',
                                id: "companyNameVal",
                                children: soldToAddress.companyName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: 'flex',
                                flexDirection: 'column',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$Value, {
                                        variant: 'p1',
                                        "data-testid": `billingAddressLine1`,
                                        children: soldToAddress.line1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$Value, {
                                        variant: 'p1',
                                        "data-testid": `billingAddressLine2`,
                                        children: soldToAddress.line2
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1d48ed549a6a355c$var$Value, {
                                        variant: 'p1',
                                        "data-testid": `billingAddressTownRegionZip`,
                                        children: [
                                            soldToAddress.town,
                                            ", ",
                                            (0, $382eb84981692d3a$export$5e4074cbce6574c7)(soldToAddress.region),
                                            ", ",
                                            soldToAddress.postalCode
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$ValueBold, {
                    variant: 'p1',
                    children: $1d48ed549a6a355c$var$LABELS.addressUnavailableLabel
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$AddressType, {
                id: "ShipToAddressLabel",
                "data-testid": "shipToAddressLabel",
                children: $1d48ed549a6a355c$var$LABELS.addressShippingLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                gap: 2,
                display: 'flex',
                justifyContent: 'left',
                gridTemplateColumns: 'repeat(3, 1fr)',
                id: "ShipToAddresses",
                "data-testid": "shipToAddressesContainer",
                children: shipToAddresses.slice(paginateStart, paginateEnd).map((address, index)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$GridContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            height: '100%',
                            className: pageType,
                            index: index,
                            id: `ShippingAddress-${index}`,
                            "data-testid": `shippingAddress-${index}`,
                            children: address ? /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$AddressBox, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    width: '100%',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$ValueBold, {
                                            variant: 'p1',
                                            id: "companyNameVal",
                                            children: address.companyName
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$Value, {
                                                    variant: 'p1',
                                                    "data-testid": `shippingAddressLine1-${index}`,
                                                    children: address.line1
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$Value, {
                                                    variant: 'p1',
                                                    "data-testid": `shippingAddressLine2-${index}`,
                                                    children: address.line2
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)($1d48ed549a6a355c$var$Value, {
                                                    variant: 'p1',
                                                    "data-testid": `shippingAddressTownRegionZip-${index}`,
                                                    children: [
                                                        address.town,
                                                        ", ",
                                                        (0, $382eb84981692d3a$export$5e4074cbce6574c7)(address.region),
                                                        ", ",
                                                        address.postalCode
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($1d48ed549a6a355c$var$ValueBold, {
                                variant: 'p1',
                                children: $1d48ed549a6a355c$var$LABELS.addressUnavailableLabel
                            })
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mx: {
                    xs: '32px',
                    sm: '400px'
                },
                my: '60px',
                display: 'flex',
                justifyContent: 'center',
                flexGrow: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CustomPagination, {
                    page: page,
                    pageCount: pageCount
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");


var $3bYfT = parcelRequire("3bYfT");
const $3b74de6751063faa$var$GridContainer = (0, $d8seH.default)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039))(({ theme: { palette: { secondary: secondary } } })=>`
  background-color: ${secondary.main};
  border-radius: 16px;
  padding: 10px 10px 26px 10px;
  margin: 0 !important;
  width: 100% !important;
  &&.edit {
    box-shadow: 0px 3px 6px #22222229;
    }
`);
const $3b74de6751063faa$var$Label = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
  color: ${primary.main};
  margin-top: 5px;
  margin-Bottom: 5px;
  text-transform: uppercase;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 16.5px;
  }
`);
const $3b74de6751063faa$var$Value = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
  user-select: text;
  ${[
        breakpoints.down('sm')
    ]} {
    line-height: 24px;
  }
`);
const $3b74de6751063faa$var$CustomGrid = (0, $d8seH.default)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039))`
    &.removePadding {
        padding-top: 0 !important;
    }
`;
const $3b74de6751063faa$var$LABELS = {
    contactInfoSectionLabel: 'Contact Information',
    contactNameLabel: 'Name',
    contactInfoEmailLabel: 'Email',
    contactRoleLabel: 'Role',
    notFound: '-'
};
const $3b74de6751063faa$export$edd98d03726b2474 = ({ pageType: pageType, contactName: contactName, contactEmail: contactEmail, contactRole: contactRole })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        margin: "30px auto 0 auto",
        width: "80%",
        id: "ContactInformation",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: 'h3',
                fontFamily: 'Aeonik Light',
                color: "primary.main",
                textAlign: "left",
                mb: "25px",
                mt: "30px",
                children: $3b74de6751063faa$var$LABELS.contactInfoSectionLabel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($3b74de6751063faa$var$GridContainer, {
                container: true,
                className: pageType,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Label, {
                                variant: 'h6',
                                id: "contactNameLabel",
                                children: $3b74de6751063faa$var$LABELS.contactNameLabel
                            }),
                            contactName && /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Value, {
                                variant: 'p1',
                                id: "contactNameValue",
                                children: contactName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Label, {
                                variant: 'h6',
                                id: "contactInfoEmailLabel",
                                children: $3b74de6751063faa$var$LABELS.contactInfoEmailLabel
                            }),
                            contactEmail && /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Value, {
                                variant: 'p1',
                                id: "contactEmail",
                                children: contactEmail
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($3b74de6751063faa$var$CustomGrid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Label, {
                                variant: 'h6',
                                id: "contactRoleLabel",
                                children: $3b74de6751063faa$var$LABELS.contactRoleLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b74de6751063faa$var$Value, {
                                variant: 'p1',
                                id: "contactRole",
                                children: contactRole ? contactRole : $3b74de6751063faa$var$LABELS.notFound
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $107215d240d18c01$exports = {};
$107215d240d18c01$exports = new URL("profileIcon.fdb167aa.svg", import.meta.url).toString();


var $b499cae983aaf295$exports = {};
$b499cae983aaf295$exports = new URL("Addresses_Icon.9226523f.svg", import.meta.url).toString();


var $8ccde9ad43492d44$exports = {};
$8ccde9ad43492d44$exports = new URL("CreditCardIcon.d064c319.svg", import.meta.url).toString();



var $d8seH = parcelRequire("d8seH");




var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $cb6b9b6cca50f16e$exports = {};
"use strict";
function $cb6b9b6cca50f16e$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty($cb6b9b6cca50f16e$exports, "__esModule", {
    value: !0
});


var $cb6b9b6cca50f16e$var$React = $cb6b9b6cca50f16e$var$_interopDefault((parcelRequire("acw62")));



!(parcelRequire("c9Z8w")), (parcelRequire("9RYKL"));

var $cb6b9b6cca50f16e$var$invariant = $cb6b9b6cca50f16e$var$_interopDefault((parcelRequire("bv4qN")));
function $cb6b9b6cca50f16e$var$_extends() {
    return ($cb6b9b6cca50f16e$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
    }).apply(this, arguments);
}
function $cb6b9b6cca50f16e$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $cb6b9b6cca50f16e$var$_setPrototypeOf(e.prototype.constructor = e, t);
}
function $cb6b9b6cca50f16e$var$_setPrototypeOf(e, t) {
    return ($cb6b9b6cca50f16e$var$_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, a = Object.keys(e);
    for(o = 0; o < a.length; o++)r = a[o], 0 <= t.indexOf(r) || (n[r] = e[r]);
    return n;
}
var $cb6b9b6cca50f16e$var$BrowserRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $2756f79476f0245f$export$719fc203c4e16dee(e.props), e;
    }
    return $cb6b9b6cca50f16e$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $cb6b9b6cca50f16e$var$React.createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($cb6b9b6cca50f16e$var$React.Component), $cb6b9b6cca50f16e$var$HashRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $2756f79476f0245f$export$b71fdd3798280242(e.props), e;
    }
    return $cb6b9b6cca50f16e$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $cb6b9b6cca50f16e$var$React.createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($cb6b9b6cca50f16e$var$React.Component), $cb6b9b6cca50f16e$var$resolveToLocation = function(e, t) {
    return "function" == typeof e ? e(t) : e;
}, $cb6b9b6cca50f16e$var$normalizeToLocation = function(e, t) {
    return "string" == typeof e ? $2756f79476f0245f$export$90c043f1c57770b8(e, null, null, t) : e;
}, $cb6b9b6cca50f16e$var$forwardRefShim = function(e) {
    return e;
}, $cb6b9b6cca50f16e$var$forwardRef = $cb6b9b6cca50f16e$var$React.forwardRef;
function $cb6b9b6cca50f16e$var$isModifiedEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
void 0 === $cb6b9b6cca50f16e$var$forwardRef && ($cb6b9b6cca50f16e$var$forwardRef = $cb6b9b6cca50f16e$var$forwardRefShim);
var $cb6b9b6cca50f16e$var$LinkAnchor = $cb6b9b6cca50f16e$var$forwardRef(function(e, t) {
    var r = e.innerRef, o = e.navigate, n = e.onClick, a = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "innerRef",
        "navigate",
        "onClick"
    ]), i = a.target, c = $cb6b9b6cca50f16e$var$_extends({}, a, {
        onClick: function(t) {
            try {
                n && n(t);
            } catch (e) {
                throw t.preventDefault(), e;
            }
            t.defaultPrevented || 0 !== t.button || i && "_self" !== i || $cb6b9b6cca50f16e$var$isModifiedEvent(t) || (t.preventDefault(), o());
        }
    });
    return c.ref = $cb6b9b6cca50f16e$var$forwardRefShim !== $cb6b9b6cca50f16e$var$forwardRef && t || r, $cb6b9b6cca50f16e$var$React.createElement("a", c);
}), $cb6b9b6cca50f16e$var$Link = $cb6b9b6cca50f16e$var$forwardRef(function(e, a) {
    var t = e.component, i = void 0 === t ? $cb6b9b6cca50f16e$var$LinkAnchor : t, c = e.replace, u = e.to, f = e.innerRef, s = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return $cb6b9b6cca50f16e$var$React.createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(r) {
        r || $cb6b9b6cca50f16e$var$invariant(!1);
        var o = r.history, e = $cb6b9b6cca50f16e$var$normalizeToLocation($cb6b9b6cca50f16e$var$resolveToLocation(u, r.location), r.location), t = e ? o.createHref(e) : "", n = $cb6b9b6cca50f16e$var$_extends({}, s, {
            href: t,
            navigate: function() {
                var e = $cb6b9b6cca50f16e$var$resolveToLocation(u, r.location), t = $2756f79476f0245f$export$fe53371bee54353d(r.location) === $2756f79476f0245f$export$fe53371bee54353d($cb6b9b6cca50f16e$var$normalizeToLocation(e));
                (c || t ? o.replace : o.push)(e);
            }
        });
        return $cb6b9b6cca50f16e$var$forwardRefShim !== $cb6b9b6cca50f16e$var$forwardRef ? n.ref = a || f : n.innerRef = f, $cb6b9b6cca50f16e$var$React.createElement(i, n);
    });
}), $cb6b9b6cca50f16e$var$forwardRefShim$1 = function(e) {
    return e;
}, $cb6b9b6cca50f16e$var$forwardRef$1 = $cb6b9b6cca50f16e$var$React.forwardRef;
function $cb6b9b6cca50f16e$var$joinClassnames() {
    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
    return t.filter(function(e) {
        return e;
    }).join(" ");
}
void 0 === $cb6b9b6cca50f16e$var$forwardRef$1 && ($cb6b9b6cca50f16e$var$forwardRef$1 = $cb6b9b6cca50f16e$var$forwardRefShim$1);
var $cb6b9b6cca50f16e$var$NavLink = $cb6b9b6cca50f16e$var$forwardRef$1(function(e, s) {
    var t = e["aria-current"], l = void 0 === t ? "page" : t, r = e.activeClassName, p = void 0 === r ? "active" : r, R = e.activeStyle, h = e.className, y = e.exact, d = e.isActive, m = e.location, v = e.sensitive, b = e.strict, P = e.style, w = e.to, x = e.innerRef, g = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return $cb6b9b6cca50f16e$var$React.createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(e) {
        e || $cb6b9b6cca50f16e$var$invariant(!1);
        var t = m || e.location, r = $cb6b9b6cca50f16e$var$normalizeToLocation($cb6b9b6cca50f16e$var$resolveToLocation(w, t), t), o = r.pathname, n = o && o.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1"), a = n ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(t.pathname, {
            path: n,
            exact: y,
            sensitive: v,
            strict: b
        }) : null, i = !!(d ? d(a, t) : a), c = "function" == typeof h ? h(i) : h, u = "function" == typeof P ? P(i) : P;
        i && (c = $cb6b9b6cca50f16e$var$joinClassnames(c, p), u = $cb6b9b6cca50f16e$var$_extends({}, u, R));
        var f = $cb6b9b6cca50f16e$var$_extends({
            "aria-current": i && l || null,
            className: c,
            style: u,
            to: r
        }, g);
        return $cb6b9b6cca50f16e$var$forwardRefShim$1 !== $cb6b9b6cca50f16e$var$forwardRef$1 ? f.ref = s || x : f.innerRef = x, $cb6b9b6cca50f16e$var$React.createElement($cb6b9b6cca50f16e$var$Link, f);
    });
});
Object.defineProperty($cb6b9b6cca50f16e$exports, "MemoryRouter", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$ae46f04cfaffe093;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Prompt", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$83716a4aa1642908;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Redirect", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Route", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Router", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$55185c17a0fcbe46;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "StaticRouter", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$cac06da4d76d935b;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Switch", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "generatePath", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$82476f982757e71e;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "matchPath", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$81336c211d5ff295;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useHistory", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useLocation", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$45d76561a5302f2b;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useParams", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useRouteMatch", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$632be4bb944c1bc7;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "withRouter", {
    enumerable: !0,
    get: function() {
        return $ebf4c3fe5600f7ed$export$369b6b2b30582e8e;
    }
}), $cb6b9b6cca50f16e$exports.BrowserRouter = $cb6b9b6cca50f16e$var$BrowserRouter, $cb6b9b6cca50f16e$exports.HashRouter = $cb6b9b6cca50f16e$var$HashRouter, $cb6b9b6cca50f16e$exports.Link = $cb6b9b6cca50f16e$var$Link, $cb6b9b6cca50f16e$exports.NavLink = $cb6b9b6cca50f16e$var$NavLink;



var $ayMG0 = parcelRequire("ayMG0");

var $c9Z8w = parcelRequire("c9Z8w");

var $3bYfT = parcelRequire("3bYfT");

var $d7be9e4b73330e59$exports = {};
$d7be9e4b73330e59$exports = new URL("infoIcon2.6bc68ed2.svg", import.meta.url).toString();


var $2ce14277b46681c1$exports = {};
$2ce14277b46681c1$exports = new URL("Sync.06f454f4.svg", import.meta.url).toString();


var $8f0e415059e80f99$exports = {};
$8f0e415059e80f99$exports = new URL("crossIconRed.7ccbf462.svg", import.meta.url).toString();


var $db42782d9d174b30$exports = {};
$db42782d9d174b30$exports = new URL("shipmentIcon.6387e51f.svg", import.meta.url).toString();


const $3d0197a89ef5b3c9$var$MessageBanner = ({ type: type, headerText: headerText, messageText: messageText, style: style, dataTestId: dataTestId, bannerContentComponent: bannerContentComponent })=>{
    const getMessageContentStyles = (type)=>{
        const getBorderLeftStyle = (type)=>{
            switch(type){
                case "info":
                    return '#079AE0';
                case "warning":
                    return '#FDB022';
                case "sync":
                    return '#FDB022';
                case "canceled":
                    return '#E22929';
                case "shipped":
                    return '#079AE0';
                default:
                    return '#079AE0';
            }
        };
        const getBackground = (type)=>{
            switch(type){
                case "info":
                    return '#F2FAFD';
                case "warning":
                    return '#FFF9EC';
                case "sync":
                    return '#FFF9EC';
                case "canceled":
                    return '#FFF3F3';
                case "shipped":
                    return '#F2FAFD';
                default:
                    return '#F2FAFD';
            }
        };
        return {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            gap: '18px',
            padding: '12px 16px',
            borderRadius: '0px 8px 8px 0px',
            borderLeft: `2px solid ${getBorderLeftStyle(type)}`,
            background: getBackground(type)
        };
    };
    const defaultStyles = getMessageContentStyles(type);
    const combinedStyles = {
        ...defaultStyles,
        ...style
    };
    const iconTypes = {
        info: (0, (/*@__PURE__*/$parcel$interopDefault($d7be9e4b73330e59$exports))),
        warning: (0, (/*@__PURE__*/$parcel$interopDefault($d97a1fedc4ce7d35$exports))),
        sync: (0, (/*@__PURE__*/$parcel$interopDefault($2ce14277b46681c1$exports))),
        canceled: (0, (/*@__PURE__*/$parcel$interopDefault($8f0e415059e80f99$exports))),
        shipped: (0, (/*@__PURE__*/$parcel$interopDefault($db42782d9d174b30$exports)))
    };
    const getIconType = (type)=>iconTypes[type];
    // if banner only has header text, pad the header to align with icon
    const headerPadding = messageText || bannerContentComponent ? "0" : "5px 0 0 0";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: combinedStyles,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: getIconType(type),
                alt: `${type} icon`,
                width: "32",
                height: "32"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": dataTestId,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "10px",
                flex: "1 0 0",
                children: [
                    headerText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        padding: headerPadding,
                        "data-testid": "bannerHeader",
                        fontFamily: "Aeonik Regular",
                        fontSize: "16px",
                        fontWeight: "700",
                        children: headerText
                    }),
                    messageText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        padding: '3px 0 0 0',
                        "data-testid": "bannerMessage",
                        fontFamily: "Aeonik Regular",
                        textAlign: "left",
                        children: messageText
                    }),
                    bannerContentComponent
                ]
            })
        ]
    });
};
$3d0197a89ef5b3c9$var$MessageBanner.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'info',
        'warning',
        'sync',
        'canceled',
        'shipped'
    ]).isRequired,
    headerText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    messageText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    bannerContentComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $3d0197a89ef5b3c9$export$2e2bcd8739ae039 = $3d0197a89ef5b3c9$var$MessageBanner;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");
var $lHOu3 = parcelRequire("lHOu3");

var $f56pe = parcelRequire("f56pe");
'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $lHOu3.default)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $13KXh.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $13KXh.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $8nd05.default)({}, (0, $f56pe.default)(parameters), (0, $f56pe.default)(externalProps));
        return (0, $8nd05.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;



var $kGwBF = parcelRequire("kGwBF");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $kSnzZ.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $iscuz.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $2d16bff1157c299f$export$2e2bcd8739ae039)((0, $8nd05.default)({}, ownerState));
    const [exited, setExited] = $acw62.useState(true);
    const rootProps = (0, $eD6Co.default)({
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), (0, $8nd05.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;


var $3bYfT = parcelRequire("3bYfT");

var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");
const $004450ae48667ea7$export$da524f2075150321 = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`;
const $004450ae48667ea7$export$b534932db7eb0121 = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
`;
const $004450ae48667ea7$export$5536f4fce3211bea = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;
const $004450ae48667ea7$export$94944d8910c4db4b = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;
const $004450ae48667ea7$export$f1ff1fb39f7795df = (0, $d8seH.default)((0, $3bYfT.default))`
    font-family: Aeonik Regular;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`;



var $ayMG0 = parcelRequire("ayMG0");




var $ayMG0 = parcelRequire("ayMG0");
const $179bd36bc5c874c5$export$f6dd727656c97851 = ({ color: color = "#000000", width: width = "24", height: height = "24" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            id: "check-circle",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                id: "Icon",
                d: "M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
const $179bd36bc5c874c5$export$5e062f845128d423 = ({ color: color = "#FDB022", width: width = "24px", height: height = "24px" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                id: "WarningCircle",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        id: "Vector (Stroke)",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        id: "Vector (Stroke)_2",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16 9C16.5523 9 17 9.44772 17 10V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V10C15 9.44772 15.4477 9 16 9Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        id: "Vector",
                        d: "M16 23C16.8284 23 17.5 22.3284 17.5 21.5C17.5 20.6716 16.8284 20 16 20C15.1716 20 14.5 20.6716 14.5 21.5C14.5 22.3284 15.1716 23 16 23Z",
                        fill: color
                    })
                ]
            })
        })
    });




var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");




const $4d17e1c9965710fc$var$DeletePaymentConfirmationModal = ({ closeModal: closeModal, openModal: openModal, cardInfo: cardInfo, handleDeletePaymentMethod: handleDeletePaymentMethod })=>{
    const DeletePaymentConfirmation = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: 'left',
                    alignItems: 'flex-start',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$da524f2075150321), {
                        id: "modalTitle",
                        "data-testid": "title",
                        children: "Delete payment method"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    textAlign: 'start',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                        type: "warning",
                        headerText: `Are you sure you want to delete the ${cardInfo?.name} ending in ${cardInfo?.lastFour}?`,
                        dataTestId: "deletePaymentWarningMessage"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                    textAlign: "left",
                    children: "This payment method will be removed from your account. However, all current orders using this payment method will still be charged upon order shipment."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    "data-testid": "buttonGroup",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-secondary",
                            sx: {
                                padding: "16px 0px",
                                textTransform: "none",
                                width: '100%'
                            },
                            onClick: (e)=>{
                                e.stopPropagation();
                                closeModal();
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "14px",
                                fontWeight: "700",
                                children: "No, keep payment method"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            sx: {
                                padding: "16px 0px",
                                textTransform: "none",
                                width: '100%'
                            },
                            onClick: async (e)=>{
                                e.stopPropagation();
                                await handleDeletePaymentMethod(cardInfo?.cardId);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "14px",
                                fontWeight: "700",
                                children: "Yes, delete this payment method"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            maxWidth: '521px',
            width: 'auto',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '23px',
            '#titleContainer': {
                marginLeft: '0px',
                padding: '5px'
            }
        },
        modalContent: DeletePaymentConfirmation()
    });
};
var $4d17e1c9965710fc$export$2e2bcd8739ae039 = $4d17e1c9965710fc$var$DeletePaymentConfirmationModal;



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4c9e9b0d96165e76$export$92dc6f1607efbf86 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            id: "Icon/Mastercard",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833374",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833374",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    stroke: "#2A2A2A"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    id: "Group",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            id: "Intersect",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M15.9984 6.05286C14.5592 7.1927 13.6367 8.9559 13.6367 10.9368C13.6367 12.9177 14.5592 14.6809 15.9984 15.8208C17.4377 14.6809 18.3602 12.9177 18.3602 10.9368C18.3602 8.9559 17.4377 7.1927 15.9984 6.05286Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            id: "Left",
                            d: "M15.5019 16.1797C14.0011 14.9301 13.0455 13.0458 13.0455 10.9368C13.0455 8.82789 14.0011 6.94356 15.5019 5.69398C14.5368 5.07407 13.3882 4.71082 12.1518 4.71082C8.7102 4.71082 5.92578 7.49524 5.92578 10.9369C5.92578 14.3785 8.7102 17.1629 12.1518 17.1629C13.3882 17.1629 14.5368 16.7996 15.5019 16.1797Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            id: "Right",
                            d: "M19.8462 17.1629C23.2878 17.1629 26.0722 14.3785 26.0722 10.9369C26.0722 7.51253 23.2878 4.71082 19.8462 4.71082C18.6098 4.71082 17.4611 5.07407 16.4961 5.69398C17.9968 6.94356 18.9524 8.82789 18.9524 10.9368C18.9524 13.0458 17.9968 14.9301 16.4961 16.1797C17.4611 16.7996 18.6098 17.1629 19.8462 17.1629Z",
                            fill: color
                        })
                    ]
                })
            ]
        })
    });
const $4c9e9b0d96165e76$export$7f0dbae677da5cb3 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 32 22",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_12508_156585)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        y: "0.333344",
                        width: "32",
                        height: "21.3333",
                        rx: "2",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M32 14.5556C32 14.5556 24.8836 19.4651 11.8518 21.6667H32V14.5556Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M3.61882 8.57086H2.37036V12.9444H3.61882C4.27883 12.9444 4.75595 12.7854 5.1774 12.4435C5.67838 12.03 5.9726 11.4097 5.9726 10.7656C5.96465 9.46943 5.00246 8.57086 3.61882 8.57086ZM4.62077 11.863C4.3504 12.1015 4.00847 12.2129 3.45183 12.2129H3.22122V9.31835H3.45183C4.00051 9.31835 4.3345 9.41377 4.62077 9.66823C4.91499 9.93065 5.08993 10.3362 5.08993 10.7577C5.08993 11.1791 4.91499 11.6006 4.62077 11.863Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.21316 8.57086H6.3623V12.9444H7.21316V8.57086Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.29648 10.2487C8.78756 10.0579 8.63647 9.93066 8.63647 9.70006C8.63647 9.42174 8.90683 9.21499 9.27262 9.21499C9.52709 9.21499 9.74179 9.31836 9.95649 9.57283L10.4018 8.99233C10.036 8.67425 9.59865 8.50726 9.11359 8.50726C8.34225 8.50726 7.74585 9.048 7.74585 9.76367C7.74585 10.368 8.02417 10.6781 8.81936 10.9644C9.15335 11.0837 9.32034 11.1632 9.40781 11.2109C9.5748 11.3223 9.66227 11.4813 9.66227 11.6642C9.66227 12.022 9.38395 12.2844 9.00226 12.2844C8.59671 12.2844 8.27068 12.0777 8.07188 11.704L7.52319 12.2367C7.91284 12.8172 8.38996 13.0717 9.03407 13.0717C9.91673 13.0717 10.5449 12.4832 10.5449 11.6324C10.5608 10.9247 10.2666 10.6066 9.29648 10.2487Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.8232 10.7656C10.8232 12.0538 11.8331 13.0478 13.1293 13.0478C13.4951 13.0478 13.8132 12.9763 14.1949 12.7934V11.7914C13.8529 12.1334 13.5508 12.2685 13.1691 12.2685C12.3103 12.2685 11.698 11.6483 11.698 10.7577C11.698 9.91477 12.3262 9.25476 13.1293 9.25476C13.5349 9.25476 13.845 9.39789 14.1949 9.74778V8.74583C13.8211 8.55498 13.511 8.47546 13.1452 8.47546C11.8649 8.47546 10.8232 9.49331 10.8232 10.7656Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.9699 11.5131L19.801 8.57086H18.8706L20.7234 13.0558H21.1846L23.0692 8.57086H22.1468L20.9699 11.5131Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M23.459 12.9444H25.8764V12.2049H24.3098V11.028H25.8207V10.2885H24.3098V9.31835H25.8764V8.57086H23.459V12.9444Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.2559 9.86705C29.2559 9.04799 28.6913 8.57883 27.7053 8.57883H26.4409V12.9524H27.2918V11.195H27.4031L28.58 12.9524H29.6297L28.254 11.1076C28.8981 10.9724 29.2559 10.535 29.2559 9.86705ZM27.5383 10.5907H27.2918V9.2627H27.5542C28.087 9.2627 28.3732 9.48535 28.3732 9.91476C28.3732 10.3521 28.087 10.5907 27.5383 10.5907Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16.8109 13.1035C18.0977 13.1035 19.1408 12.0603 19.1408 10.7736C19.1408 9.48678 18.0977 8.44363 16.8109 8.44363C15.5241 8.44363 14.481 9.48678 14.481 10.7736C14.481 12.0603 15.5241 13.1035 16.8109 13.1035Z",
                        fill: color
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "0.5",
                y: "0.833344",
                width: "31",
                height: "20.3333",
                rx: "1.5",
                stroke: "#D8D8D8",
                style: {
                    mixBlendMode: 'difference'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_12508_156585",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        y: "0.333344",
                        width: "32",
                        height: "21.3333",
                        rx: "2",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4c9e9b0d96165e76$export$4bcf14e559aee129 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            id: "Icon/Visa",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833344",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833344",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    stroke: "#2A2A2A"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Visa Logo",
                    d: "M19.7667 6.83527C17.9995 6.83527 16.4202 7.75124 16.4202 9.44358C16.4202 11.3844 19.2211 11.5184 19.2211 12.4934C19.2211 12.904 18.7506 13.2714 17.9471 13.2714C16.8067 13.2714 15.9544 12.758 15.9544 12.758L15.5897 14.4657C15.5897 14.4657 16.5716 14.8995 17.8751 14.8995C19.8073 14.8995 21.3276 13.9385 21.3276 12.2172C21.3276 10.1664 18.5151 10.0364 18.5151 9.1314C18.5151 8.80981 18.9013 8.45744 19.7025 8.45744C20.6066 8.45744 21.3441 8.83089 21.3441 8.83089L21.7011 7.18149C21.7011 7.18149 20.8985 6.83527 19.7667 6.83527ZM3.59846 6.95975L3.55566 7.20872C3.55566 7.20872 4.29913 7.34478 4.96874 7.6162C5.83093 7.92745 5.89235 8.10863 6.03755 8.6714L7.61985 14.7711H9.74093L13.0086 6.95975H10.8924L8.79272 12.2707L7.93592 7.76889C7.85735 7.25366 7.45934 6.95975 6.97215 6.95975H3.59846ZM13.8596 6.95975L12.1995 14.7711H14.2175L15.8717 6.95975H13.8596ZM25.1146 6.95975C24.628 6.95975 24.3702 7.22027 24.181 7.67553L21.2245 14.7711H23.3407L23.7502 13.5885H26.3283L26.5773 14.7711H28.4446L26.8156 6.95975H25.1146ZM25.3898 9.07013L26.0171 12.0013H24.3366L25.3898 9.07013Z",
                    fill: color
                })
            ]
        })
    });
const $4c9e9b0d96165e76$export$49d21b24afef9d10 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            id: "Icon/Amex",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833252",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    x: "0.5",
                    y: "0.833252",
                    width: "31",
                    height: "20.3333",
                    rx: "1.5",
                    stroke: "#2A2A2A"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    id: "AmEx Logo",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M31.6907 16.1556V18.4738H28.7467L27.6587 17.2009L26.528 18.4738H18.1654V11.6969H15.4062L18.8552 3.88892H22.2116L23.0222 5.65958V3.88892H27.1894L27.8862 5.74492L28.5689 3.88892H31.6907V4.99113H29.28L28.1849 7.87826L27.8934 8.66046L26.4925 4.99113H24.0818V10.68L21.5787 4.99113H19.6374L17.12 10.68H18.7698L19.2107 9.58492H21.9698L22.4107 10.68H24.0818H25.5325V6.97514L25.5254 6.22846L25.8098 6.97514L27.1965 10.68H28.576L29.9698 6.97514L30.24 6.23558V10.68H31.6907V12.9058L30.0836 14.52L31.6907 16.1556ZM19.3316 17.3716V11.704H24.0818V12.9342H20.7822V13.9298H24.0178V15.1529H20.7822V16.1413H24.0818V17.3716H19.3316ZM31.2498 17.3716H29.3654L27.6445 15.5227L25.9165 17.3716H24.0818L26.7342 14.5485L24.0818 11.704H25.9734L27.68 13.5458L29.3938 11.704H31.2498L28.5902 14.5271L31.2498 17.3716Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M20.5902 6.20713L20.3058 6.91826L19.7156 8.35467H21.4649L20.8747 6.91826L20.5902 6.20713Z",
                            fill: color
                        })
                    ]
                })
            ]
        })
    });
const $4c9e9b0d96165e76$export$6495330c0ada5a03 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            id: "Bank",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector",
                    d: "M3 12H29L16 4L3 12Z",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_2",
                    d: "M7 12V22",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_3",
                    d: "M13 12V22",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_4",
                    d: "M19 12V22",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_5",
                    d: "M25 12V22",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_6",
                    d: "M4 22H28",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    id: "Vector_7",
                    d: "M2 26H30",
                    stroke: "#343330",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
const $4c9e9b0d96165e76$export$3bb9e80988b79358 = ({ color: color = "#000000", width: width = "32", height: height = "32" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "0.5",
                y: "5.83334",
                width: "31",
                height: "20.3333",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "0.5",
                y: "5.83334",
                width: "31",
                height: "20.3333",
                rx: "1.5",
                stroke: "#383D47"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "1",
                y: "9",
                width: "30",
                height: "4",
                fill: "#383D47"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "21",
                y: "18",
                width: "8",
                height: "6",
                rx: "1",
                fill: "#383D47"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");




const $36d886fe12e537c3$export$b0b9fa6eec891db0 = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment-method`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$5d4bd0ea3186eab = async (payload, paymentMethodId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment-method/${paymentMethodId}`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$9577d55c4298d793 = async (paymentMethodId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment-method/${paymentMethodId}`,
            method: "DELETE"
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$81713a21f003821b = async (payload = {})=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment-method/list`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$33fee9948e94a456 = async (paymentMethodId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment-method/${paymentMethodId}`,
            method: "GET"
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$3137a828266444e = async (payload)=>{
    try {
        const res = await (0, $80596ff285da23b7$export$2e2bcd8739ae039)({
            url: `paymentsservice/guest`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$6e845bae4add694e = async (payload, paymentMethodId, customerId)=>{
    try {
        const res = await (0, $80596ff285da23b7$export$2e2bcd8739ae039)({
            url: `paymentsservice/guest/payment-method/${paymentMethodId}`,
            method: "POST",
            data: JSON.stringify(payload),
            headers: {
                'Customer-Id': customerId
            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$88983c6bad234860 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/captureGuestPayment", async ({ payload: payload, customerId: customerId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $80596ff285da23b7$export$2e2bcd8739ae039)({
            url: `paymentsservice/guest/payment/capture`,
            method: "POST",
            data: JSON.stringify(payload),
            headers: {
                'Customer-Id': customerId
            }
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $36d886fe12e537c3$export$f33a4222dd0fef57 = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment/capture-invoice`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$32f13e25b4f4240c = async (paymentId)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment/${paymentId}`,
            method: "GET"
        });
        return res;
    } catch (error) {
        throw error;
    }
};
const $36d886fe12e537c3$export$9c1210d5094a999 = async (invoiceNo)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `paymentsservice/payment/invoice/${invoiceNo}`,
            method: "GET"
        });
        return res;
    } catch (error) {
        throw error;
    }
};




var $3bYfT = parcelRequire("3bYfT");
var $a5c6285a4ca791f4$exports = {};
$a5c6285a4ca791f4$exports = new URL("checkIconWhite.d4952764.svg", import.meta.url).toString();


const $c9fe4f79081fb8c8$export$3c6bc50c644da455 = {
    mastercard: {
        name: 'Mastercard',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$92dc6f1607efbf86), {})
    },
    amex: {
        name: 'American Express',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$49d21b24afef9d10), {})
    },
    visa: {
        name: 'Visa',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$4bcf14e559aee129), {})
    },
    discover: {
        name: 'Discover',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$7f0dbae677da5cb3), {})
    },
    diners: {
        name: 'Diners',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
    },
    jcb: {
        name: 'JCB',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
    },
    unionpay: {
        name: 'UnionPay',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
    },
    elo: {
        name: 'Elo',
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
    }
};
const $c9fe4f79081fb8c8$export$c5530885e8ffa0f4 = {
    justifyContent: 'center',
    borderRadius: '8px',
    backgroundColor: '#079AE0',
    padding: '10px 32px',
    boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.16)',
    '.MuiSnackbarContent-message': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '13px'
    }
};
const $c9fe4f79081fb8c8$export$2d7f490179da7f41 = {
    setDefaultPaymentMethod: 'Your default payment method has been updated.',
    deletePaymentMethod: 'Your payment method has been deleted.'
};
const $c9fe4f79081fb8c8$export$2e24b6438950b56a = (paymentList, selectedPaymentId = false)=>{
    return paymentList.sort((a, b)=>{
        if (a.paymentMethodId === selectedPaymentId) return -1;
        if (b.paymentMethodId === selectedPaymentId) return 1;
        if (a.isDefault && !b.isDefault) return -1;
        if (!a.isDefault && b.isDefault) return 1;
        return 0;
    });
};
const $c9fe4f79081fb8c8$export$137d42378a7a52bf = async (setProcessing, handleErrorMsg, setPaymentMethodsList, paymentMethodStatus)=>{
    try {
        setProcessing(true);
        const response = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
            status: paymentMethodStatus
        });
        if (response.status === 200) setPaymentMethodsList($c9fe4f79081fb8c8$export$2e24b6438950b56a(response?.data?.paymentMethodsList));
    } catch (error) {
        setProcessing(false);
        const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
        handleErrorMsg(errorMessage);
    } finally{
        setProcessing(false);
    }
};
const $c9fe4f79081fb8c8$export$732c767a29852e39 = (cardExpirationData)=>{
    if (!cardExpirationData) return;
    const [month, year] = cardExpirationData.split('/');
    const expirationDate = new Date(year, month - 1, 1);
    const currentDate = new Date();
    return expirationDate < currentDate;
};
const $c9fe4f79081fb8c8$export$4f31a5e23f8e79a9 = (message)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a5c6285a4ca791f4$exports))),
                alt: "success icon",
                width: '32px',
                height: '32px'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontFamily: 'Aeonik Regular',
                fontSize: '20px',
                fontWeight: '700',
                children: message
            })
        ]
    });
};
const $c9fe4f79081fb8c8$export$5c65f471a395368b = (value)=>{
    if (!value.trim()) return "Required";
    // Regex that allows numbers with or without commas and optional dollar signs
    const regex = /^\$?(\d+|\d{1,3}(,\d{3})*)(\.\d{2})?$/;
    // Remove any dollar signs or commas to properly validate the numeric value
    const numericValue = value.replace(/[$,]/g, '');
    if (!regex.test(value) || parseFloat(numericValue) <= 0 || parseFloat(numericValue) > 9999999.99) return "Please enter a valid amount greater than 0 and up to $9,999,999.99";
    return "";
};
const $c9fe4f79081fb8c8$export$a6c55e5d171e6bec = (value)=>{
    if (!value.trim()) return "Required";
    if (!/^\d{8,10}$/.test(value)) return "Please enter a valid invoice number.";
    return "";
};


const $35271a9cc8e91107$export$6f33884eb5ad65c4 = {
    width: '333px',
    height: '180px',
    display: 'flex',
    padding: '16px 24px',
    borderRadius: '16px',
    background: '#FFF',
    boxShadow: ' 0px 2px 4px 0px rgba(0, 0, 0, 0.50)',
    border: '1px solid transparent',
    textAlign: 'start',
    transition: 'border-color 0.3s ease'
};
const $35271a9cc8e91107$var$boldText = {
    fontWeight: 'bold',
    display: 'inline'
};
const $35271a9cc8e91107$var$hoverStyles = {
    border: '2px solid #079AE0',
    transform: 'translateY(-2px)'
};
const $35271a9cc8e91107$export$5af683685858e056 = ({ cardInfo: cardInfo, handleSetAsDefaultPayment: handleSetAsDefaultPayment, isDefault: isDefault, handlePaymentMethodSelection: handlePaymentMethodSelection, closeModal: closeModal, isProfilePage: isProfilePage, handleDeletePaymentMethod: handleDeletePaymentMethod })=>{
    const isBank = cardInfo?.paymentMethodType === 'ACH';
    const selectedPayment = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.selectedPaymentMethod);
    const isSelected = selectedPayment?.paymentMethodId === cardInfo?.paymentMethodId;
    const getCustomizePaymentBox = (isSelected, isExpired)=>{
        let additionalStyles = {};
        if (isSelected && !isProfilePage) additionalStyles['border'] = '2px solid #079AE0';
        if (isDefault && isProfilePage) additionalStyles['border'] = '2px solid #079AE0';
        if (isExpired) additionalStyles['backgroundColor'] = 'rgba(234, 235, 239, 0.6)';
        return {
            ...$35271a9cc8e91107$export$6f33884eb5ad65c4,
            ...additionalStyles
        };
    };
    const isExpired = (0, $c9fe4f79081fb8c8$export$732c767a29852e39)(cardInfo?.paymentMethodInfo?.expirationDate);
    const customizePaymentBox = getCustomizePaymentBox(isSelected, isExpired);
    const [showDeletePaymentModal, setShowDeletePaymentModal] = (0, $acw62.useState)(false);
    const expirationComponent = ()=>{
        if (isExpired) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            style: {
                display: 'flex',
                flexDirection: 'row'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $179bd36bc5c874c5$export$5e062f845128d423), {
                    color: "#E22929"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                    style: {
                        color: '#E22929',
                        marginLeft: '6px'
                    },
                    children: `Expired ${cardInfo?.paymentMethodInfo?.expirationDate}`
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
            children: `Expires ${cardInfo?.paymentMethodInfo?.expirationDate}`
        });
    };
    const accountInfo = {
        name: isBank ? `${cardInfo?.paymentMethodInfo?.bankName} account` : `${(0, $c9fe4f79081fb8c8$export$3c6bc50c644da455)[cardInfo?.paymentMethodInfo?.brand]?.name} card`,
        lastFour: cardInfo?.paymentMethodInfo?.lastFour,
        cardId: cardInfo?.paymentMethodId
    };
    const handleSelection = (paymentMethodId)=>{
        handlePaymentMethodSelection(paymentMethodId);
        closeModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: isProfilePage ? {
            ...customizePaymentBox
        } : {
            ...customizePaymentBox,
            cursor: 'pointer',
            '&:hover': $35271a9cc8e91107$var$hoverStyles
        },
        onClick: ()=>handleSelection(cardInfo?.paymentMethodId),
        children: [
            showDeletePaymentModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d17e1c9965710fc$export$2e2bcd8739ae039), {
                openModal: showDeletePaymentModal,
                closeModal: ()=>setShowDeletePaymentModal(false),
                cardInfo: accountInfo,
                handleDeletePaymentMethod: handleDeletePaymentMethod
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '32px',
                paddingTop: isBank ? '6px' : '4px',
                children: isBank ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$6495330c0ada5a03), {}) : (0, $c9fe4f79081fb8c8$export$3c6bc50c644da455)[cardInfo?.paymentMethodInfo?.brand]?.logo
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                ml: 2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%',
                            marginTop: '3px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $35271a9cc8e91107$var$boldText,
                                        children: isBank ? cardInfo?.paymentMethodInfo?.bankName : (0, $c9fe4f79081fb8c8$export$3c6bc50c644da455)[cardInfo?.paymentMethodInfo?.brand]?.name
                                    }),
                                    isBank ? ' account ending in ' : ' ending in ',
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $35271a9cc8e91107$var$boldText,
                                        children: cardInfo?.paymentMethodInfo?.lastFour
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                                children: cardInfo?.paymentMethodInfo?.billingName
                            }),
                            !isBank && expirationComponent()
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: 'auto',
                            height: '24px',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: isDefault ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'row'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $179bd36bc5c874c5$export$f6dd727656c97851), {
                                            color: '#0379B2'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$5536f4fce3211bea), {
                                            color: "#0379B2",
                                            style: {
                                                marginLeft: '6px'
                                            },
                                            children: "Default"
                                        })
                                    ]
                                }) : !isExpired && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    id: "setDefaultBtn",
                                    sx: {
                                        textTransform: "none",
                                        margin: '2px 0 0 0',
                                        "& .ButtonText": {
                                            fontSize: "16px"
                                        },
                                        '&:hover': {
                                            transform: 'scale(1.05)'
                                        }
                                    },
                                    buttonType: "link",
                                    "data-testid": "setDefaultBtn",
                                    onClick: ()=>{
                                        handleSetAsDefaultPayment(cardInfo?.paymentMethodId);
                                    },
                                    children: "Set as default"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    id: "setDeleteBtn",
                                    sx: {
                                        textTransform: "none",
                                        color: '#E22929',
                                        margin: '2px 0 0 0',
                                        "& .ButtonText": {
                                            fontSize: "16px"
                                        },
                                        '&:hover': {
                                            transform: 'scale(1.05)'
                                        }
                                    },
                                    buttonType: "link",
                                    "data-testid": "deleteBtn",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        setShowDeletePaymentModal(true);
                                    },
                                    children: "Delete"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


var $5fc6cdd0dabb560c$exports = {};
$5fc6cdd0dabb560c$exports = new URL("plusIcon.21e489fb.svg", import.meta.url).toString();


const $6d83ffc3489d7abf$var$paymentContainer = {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    width: '100%',
    maxWidth: '700px'
};
const $6d83ffc3489d7abf$var$hoverStyles = {
    border: '2px solid #079AE0',
    transform: 'translateY(-2px)'
};
const $6d83ffc3489d7abf$export$ab218e41b1f3d913 = ({ paymentList: paymentList, isProfilePage: isProfilePage = false, handleSetAsDefaultPayment: handleSetAsDefaultPayment = ()=>{}, handleAddNewPaymentMethod: handleAddNewPaymentMethod = ()=>{}, handlePaymentMethodSelection: handlePaymentMethodSelection = ()=>{}, handleDeletePaymentMethod: handleDeletePaymentMethod = ()=>{}, closeModal: closeModal = ()=>{} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: 'left',
                alignItems: 'flex-start',
                children: !isProfilePage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$da524f2075150321), {
                    id: "modalTitle",
                    "data-testid": "title",
                    children: "Payment Method"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 3,
                sx: isProfilePage ? {} : $6d83ffc3489d7abf$var$paymentContainer,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '16px',
                        alignItems: 'flexStart'
                    },
                    children: [
                        paymentList?.map((paymentInfo)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $35271a9cc8e91107$export$5af683685858e056), {
                                cardInfo: paymentInfo,
                                handleSetAsDefaultPayment: handleSetAsDefaultPayment,
                                isDefault: paymentInfo?.isDefault,
                                handlePaymentMethodSelection: handlePaymentMethodSelection,
                                closeModal: closeModal,
                                isProfilePage: isProfilePage,
                                handleDeletePaymentMethod: handleDeletePaymentMethod
                            }, paymentInfo.paymentMethodId)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            onClick: handleAddNewPaymentMethod,
                            sx: {
                                ...(0, $35271a9cc8e91107$export$6f33884eb5ad65c4),
                                cursor: 'pointer',
                                ...isProfilePage ? {} : {
                                    '&:hover': $6d83ffc3489d7abf$var$hoverStyles
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fc6cdd0dabb560c$exports))),
                                        alt: "plus icon",
                                        width: "32",
                                        height: "32"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "700",
                                        fontFamily: "Aeonik Regular",
                                        color: "#0379B2",
                                        children: "Add a new payment method"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "2.8.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "2.8.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = 'CustomCheckoutSdkContext';
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = 'CustomCheckoutContext';
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn('Unsupported prop change: options.client_secret is not a mutable property.');
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase('calls useCustomCheckout()');
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error('Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.');
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var customCheckoutSdk = 'customCheckoutSdk' in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});


var $2110bf72a86f956f$var$V3_URL = 'https://js.stripe.com/v3';
var $2110bf72a86f956f$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $2110bf72a86f956f$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($2110bf72a86f956f$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$2110bf72a86f956f$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $2110bf72a86f956f$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($2110bf72a86f956f$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $2110bf72a86f956f$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "3.4.1",
        startTime: startTime
    });
};
var $2110bf72a86f956f$var$stripePromise = null;
var $2110bf72a86f956f$var$onErrorListener = null;
var $2110bf72a86f956f$var$onLoadListener = null;
var $2110bf72a86f956f$var$onError = function onError(reject) {
    return function() {
        reject(new Error('Failed to load Stripe.js'));
    };
};
var $2110bf72a86f956f$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $2110bf72a86f956f$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($2110bf72a86f956f$var$stripePromise !== null) return $2110bf72a86f956f$var$stripePromise;
    $2110bf72a86f956f$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $2110bf72a86f956f$var$findScript();
            if (script && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $2110bf72a86f956f$var$injectScript(params);
            else if (script && $2110bf72a86f956f$var$onLoadListener !== null && $2110bf72a86f956f$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $2110bf72a86f956f$var$onLoadListener);
                script.removeEventListener('error', $2110bf72a86f956f$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $2110bf72a86f956f$var$injectScript(params);
            }
            $2110bf72a86f956f$var$onLoadListener = $2110bf72a86f956f$var$onLoad(resolve, reject);
            $2110bf72a86f956f$var$onErrorListener = $2110bf72a86f956f$var$onError(reject);
            script.addEventListener('load', $2110bf72a86f956f$var$onLoadListener);
            script.addEventListener('error', $2110bf72a86f956f$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $2110bf72a86f956f$var$stripePromise["catch"](function(error) {
        $2110bf72a86f956f$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $2110bf72a86f956f$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $2110bf72a86f956f$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $2110bf72a86f956f$var$stripePromise$1;
var $2110bf72a86f956f$var$loadCalled = false;
var $2110bf72a86f956f$var$getStripePromise = function getStripePromise() {
    if ($2110bf72a86f956f$var$stripePromise$1) return $2110bf72a86f956f$var$stripePromise$1;
    $2110bf72a86f956f$var$stripePromise$1 = $2110bf72a86f956f$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $2110bf72a86f956f$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $2110bf72a86f956f$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $2110bf72a86f956f$var$getStripePromise();
})["catch"](function(error) {
    if (!$2110bf72a86f956f$var$loadCalled) console.warn(error);
});
var $2110bf72a86f956f$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $2110bf72a86f956f$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $2110bf72a86f956f$var$getStripePromise().then(function(maybeStripe) {
        return $2110bf72a86f956f$var$initStripe(maybeStripe, args, startTime);
    });
};






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $3bYfT = parcelRequire("3bYfT");








const $7003073550a1fc7c$export$5a367251a6b08c32 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/fetchEligibleContracts", async ({ payload: payload }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `pricingservice/v2/pricing/price-contracts`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        if (!res?.data?.priceContracts) return [];
        return res?.data?.priceContracts;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $7003073550a1fc7c$export$2b81fdbf3c9c79c5 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/fetchReservationContracts", async ({ payload: payload }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `pricingservice/v2/pricing/price-contracts`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        if (!res?.data?.priceContracts) return [];
        return res?.data?.priceContracts;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $7003073550a1fc7c$export$1cc7e8ea7ec74e6e = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getAllPrices", async ({ payload: payload }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `pricingservice/v2/pricing`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $7003073550a1fc7c$export$8000f25297f4564a = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/getAllPricesWithCustomerId", async ({ payload: payload, customerId: customerId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `pricingservice/v2/pricing/${customerId}`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res?.data;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});








const $bf4ea7b5c4b4cc11$export$8d546fe0fda62b77 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/checkoutCart", async ({ cartId: cartId, userId: userId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `orderservice/carts/${cartId}/checkout`,
            method: "PATCH",
            timeout: 75000,
            params: {
                userId: userId
            }
        });
        return res?.data;
    } catch (error) {
        if (error.code === 'ECONNABORTED') console.log("Request timed out", error);
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});




const $6361b14d09f5d8cd$export$68a801b7b3c0bfaa = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("catalog/getProductsApi", async ({ locale: locale }, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = {
            locale: locale
        };
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `catalogservice/catalog/products`,
            method: "GET",
            params: params
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $6361b14d09f5d8cd$export$d06fcd849797ccb7 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("catalog/getOrderableProductsApi", async ({ locale: locale }, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = {
            locale: locale,
            actionTypes: 'SELL'
        };
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `catalogservice/catalog/products`,
            method: "GET",
            params: params
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});
const $6361b14d09f5d8cd$export$cf9d318b59dc7b06 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("catalog/getReservableProductsApi", async ({ locale: locale }, { rejectWithValue: rejectWithValue })=>{
    try {
        const params = {
            locale: locale,
            actionTypes: 'RESERVE'
        };
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `catalogservice/catalog/products`,
            method: "GET",
            params: params
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response.data);
    }
});




const $f831b554e05ec33a$var$generateInternalCartLineItemId = ()=>Math.random().toString(36).slice(2, 9);
const $f831b554e05ec33a$var$getDate = (dateString)=>{
    if (dateString === null) return null;
    const datePartial = dateString.split("/");
    const nextDay = Number(datePartial[1]);
    const nextMonth = Number(datePartial[0]);
    const nextYear = Number(datePartial[2]);
    if (isNaN(nextDay) || isNaN(nextMonth) || isNaN(nextYear)) return null;
    const date = new Date();
    date.setDate(nextDay);
    date.setFullYear(nextYear);
    date.setMonth(nextMonth - 1);
    return date;
};
const $f831b554e05ec33a$export$741583438031a635 = (state, { payload: payload })=>{
    const { cartData: cartData, orderableProducts: orderableProducts, userData: userData } = state;
    const addressSelection = userData.addresses.find((address)=>address.id === payload.addressId);
    if (!addressSelection) return;
    // Find the healthcare license that matches the state and has the furthest
    // expiration date to be the default
    const healthcareLicenses = userData.licenses?.filter((license)=>{
        if (license.state !== addressSelection.state) return false;
        const date = $f831b554e05ec33a$var$getDate(license.expiration);
        return date !== null && date >= new Date(Date.now());
    })?.sort((prev, next)=>{
        const datePrev = $f831b554e05ec33a$var$getDate(prev.expiration);
        const dateNext = $f831b554e05ec33a$var$getDate(next.expiration);
        return (dateNext?.getTime() || 0) - (datePrev?.getTime() || 0);
    });
    const healthcareLicense = healthcareLicenses[0] ?? null;
    const newCartLineItems = orderableProducts?.map((product)=>{
        const internalCartLineItemId = $f831b554e05ec33a$var$generateInternalCartLineItemId();
        const cartItem = {
            cartId: cartData.cartId,
            healthcareLicense: healthcareLicense ? {
                expirationDate: healthcareLicense.expiration || undefined,
                licenseNumber: healthcareLicense.number,
                licenseType: healthcareLicense.licenseType,
                name: `${healthcareLicense.firstName} ${healthcareLicense.lastName}`,
                state: healthcareLicense.state
            } : {},
            internalCartLineItemId: internalCartLineItemId,
            productId: product?.materialMasterId,
            priceSnapshotId: "",
            purchaseOrderNumber: "",
            quantity: 0,
            shipToAddress: {
                addressId: String(addressSelection?.id)
            },
            shipToOrganizationId: String(addressSelection?.organizationId)
        };
        return cartItem;
    });
    state.cartData.cartLineItems = cartData?.cartLineItems ? [
        ...cartData?.cartLineItems,
        ...newCartLineItems
    ] : [
        ...newCartLineItems
    ];
};


const $53476aa40d2bc637$var$initialState = {
    reservationData: {
        reservation: {},
        reservationEntries: []
    },
    displayReservationData: {
        reservationEntries: [],
        PONumberValue: ''
    },
    reservationPrices: {},
    reservationProducts: [],
    reservation: {},
    orderableProducts: [],
    userData: {},
    priceContracts: [],
    reservationPriceContracts: [],
    pricingData: {},
    sapUserData: {},
    cart: {},
    cartData: {},
    checkoutCartData: {},
    currentOrderData: {},
    selectedPaymentMethod: {},
    productsData: [],
    singleProductInfo: {},
    paymentDetails: {},
    userInfo: {}
};
const $53476aa40d2bc637$export$928fdeedbaff42e0 = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
    name: "commerce",
    initialState: $53476aa40d2bc637$var$initialState,
    reducers: {
        addShippingAddress: (0, $f831b554e05ec33a$export$741583438031a635),
        setReservationData: (state, { payload: payload })=>{
            state.reservationData = {
                ...state.reservationData,
                ...payload
            };
        },
        setCartData: (state, { payload: payload })=>{
            state.cartData = {
                ...state.cartData,
                ...payload
            };
        },
        clearReservationContractInfo: (state)=>{
            if (state.reservation?.reservation) state.reservation.reservation.contractInfo = null;
        },
        setDisplayReservationData: (state, { payload: payload })=>{
            state.displayReservationData = {
                ...state.displayReservationData,
                ...payload
            };
        },
        setUserData: (state, { payload: payload })=>{
            state.userData = {
                ...state.userData,
                ...payload
            };
        },
        setCurrentOrderData: (state, { payload: payload })=>{
            state.currentOrderData = {
                ...state.currentOrderData,
                ...payload
            };
        },
        setSelectedPaymentMethod: (state, { payload: payload })=>{
            state.selectedPaymentMethod = payload;
        },
        setSingleProductInfo: (state, { payload: payload })=>{
            state.singleProductInfo = payload;
        },
        setCart: (state, { payload: payload })=>{
            state.cart = payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $6361b14d09f5d8cd$export$cf9d318b59dc7b06).fulfilled, (state, { payload: payload })=>{
            state.reservationProducts = (0, $382eb84981692d3a$export$7699132b966bad47)(payload?.data?.productList, 'materialMasterId');
        });
        builder.addCase((0, $6361b14d09f5d8cd$export$d06fcd849797ccb7).fulfilled, (state, { payload: payload })=>{
            state.orderableProducts = (0, $382eb84981692d3a$export$7699132b966bad47)(payload?.data?.productList, 'materialMasterId');
        });
        builder.addCase((0, $6361b14d09f5d8cd$export$68a801b7b3c0bfaa).fulfilled, (state, { payload: payload })=>{
            state.productsData = payload?.data?.productList;
        });
        builder.addCase((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41).fulfilled, (state, { payload: payload })=>{
            state.userData = payload;
        });
        builder.addCase((0, $fdf4ab7ce1c873bd$export$e2e56406d7a7e765).fulfilled, (state, { payload: payload })=>{
            state.userData = payload;
        });
        builder.addCase((0, $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55).fulfilled, (state, { payload: payload })=>{
            state.sapUserData = payload;
        });
        builder.addCase((0, $fdf4ab7ce1c873bd$export$7cbf767827cd68ba).fulfilled, (state, { payload: payload })=>{
            state.userInfo = payload;
        });
        builder.addCase((0, $f9f5d27cea32d603$export$44a973515938c016).fulfilled, (state, { payload: payload })=>{
            state.reservation = payload;
        });
        builder.addCase((0, $7003073550a1fc7c$export$5a367251a6b08c32).fulfilled, (state, { payload: payload })=>{
            state.priceContracts = payload;
        });
        builder.addCase((0, $7003073550a1fc7c$export$2b81fdbf3c9c79c5).fulfilled, (state, { payload: payload })=>{
            state.reservationPriceContracts = payload;
        });
        builder.addCase((0, $f9f5d27cea32d603$export$bbda77ab2dbab04a).fulfilled, (state, { payload: payload })=>{
            state.reservation = payload;
        });
        builder.addCase((0, $f9f5d27cea32d603$export$3a69f39f385de80e).fulfilled, (state, { payload: payload })=>{
            state.reservation = payload;
        });
        builder.addCase((0, $f9f5d27cea32d603$export$5c8829528553048f).fulfilled, (state, { payload: payload })=>{
            state.reservation = payload;
        });
        builder.addCase((0, $8b6f49f5b2fddfb8$export$6e289e3dcca84b2a).fulfilled, (state, { payload: payload })=>{
            state.cart = payload;
        });
        builder.addCase((0, $8b6f49f5b2fddfb8$export$cffacbe8550d921).fulfilled, (state, { payload: payload })=>{
            state.cart = payload?.data;
        });
        builder.addCase((0, $8b6f49f5b2fddfb8$export$fad077ca3a0b9035).fulfilled, (state, action)=>{
            state.currentOrderData = action.payload;
        });
        builder.addCase($53476aa40d2bc637$export$bf010ffeb9d9c8ec, (state, { payload: payload })=>{
            state.reservationData = payload;
        });
        builder.addCase($53476aa40d2bc637$export$43b8801e86709756, (state, { payload: payload })=>{
            state.displayReservationData = payload;
        });
        builder.addCase((0, $7003073550a1fc7c$export$1cc7e8ea7ec74e6e).fulfilled, (state, { payload: payload })=>{
            state.pricingData = payload;
        });
        builder.addCase((0, $7003073550a1fc7c$export$8000f25297f4564a).fulfilled, (state, { payload: payload })=>{
            state.pricingData = payload;
        });
        builder.addCase((0, $bf4ea7b5c4b4cc11$export$8d546fe0fda62b77).fulfilled, (state, { payload: payload })=>{
            state.checkoutCartData = payload;
        });
        builder.addCase((0, $36d886fe12e537c3$export$88983c6bad234860).fulfilled, (state, { payload: payload })=>{
            state.paymentDetails = payload?.data;
        });
    }
});
const { addShippingAddress: $53476aa40d2bc637$export$741583438031a635, clearReservationContractInfo: $53476aa40d2bc637$export$5a354114219e6168, setOrderCartData: $53476aa40d2bc637$export$3197dfba95b8d061, setCartData: $53476aa40d2bc637$export$51b43a12014c9f04, setReservationData: $53476aa40d2bc637$export$bf010ffeb9d9c8ec, setDisplayReservationData: $53476aa40d2bc637$export$43b8801e86709756, setCurrentOrderData: $53476aa40d2bc637$export$843e6d82ee53ff2c, setSelectedPaymentMethod: $53476aa40d2bc637$export$9628908a9dd74afb, setSingleProductInfo: $53476aa40d2bc637$export$1cbcb10f6eead788, setCart: $53476aa40d2bc637$export$e3c85382822e3760 } = $53476aa40d2bc637$export$928fdeedbaff42e0.actions;
var $53476aa40d2bc637$export$2e2bcd8739ae039 = $53476aa40d2bc637$export$928fdeedbaff42e0.reducer;





const $d0d210103d90c352$export$b220cd04490efc71 = `By clicking \u{201C}Pay Now\u{201D}, you authorize Moderna US, Inc to debit the bank account specified above for any amount owed for charges arising from your use of Moderna US, Inc's \
services and/or purchase of products from Moderna US, Inc, pursuant to Moderna US, Inc's website and terms, until this authorization is revoked.`;
const $d0d210103d90c352$export$664e2e65a3758b76 = `By providing your card information, you allow Moderna US, Inc to charge your card for future payments in accordance with their terms.`;
const $d0d210103d90c352$var$PaymentMethodForm = ({ setShowPaymentForm: setShowPaymentForm, paymentMethodId: paymentMethodId, handleErrorMsg: handleErrorMsg, setPaymentMethodAdded: setPaymentMethodAdded, paymentType: paymentType, handleClosePaymentModal: handleClosePaymentModal, invoiceNumber: invoiceNumber, paymentAmount: paymentAmount, customerId: customerId, setShowSpinner: setShowSpinner })=>{
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [paymentMethodType, setPaymentMethodType] = (0, $acw62.useState)('');
    const ACH_MANDATE_TEXT = `By clicking \u{201C}Continue\u{201D}, you authorize Moderna US, Inc to debit the bank account specified above for any amount owed for charges arising from your use of Moderna US, Inc's \
                          services and/or purchase of products from Moderna US, Inc, pursuant to Moderna US, Inc's website and terms, until this authorization is revoked.`;
    const paymentElementOptions = {
        paymentMethodOrder: [
            (0, $5cdc329eeebd56d0$export$d6e58abbbec7e1ac).ACH
        ],
        terms: {
            card: 'never',
            usBankAccount: 'never'
        }
    };
    const handlePaymentMethodTypeChange = (event)=>{
        setPaymentMethodType(event.value.type);
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setProcessing(true);
        if (!stripe || !elements) return null;
        await stripe.confirmSetup({
            elements: elements,
            confirmParams: {},
            redirect: 'if_required'
        }).then(async ({ setupIntent: setupIntent, error: error })=>{
            if (error) {
                setProcessing(false);
                setErrorMessage(error.message);
            } else if (setupIntent) try {
                const updatePaymentMethodRequest = {
                    idempotencyToken: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                    paymentMethodLifecycleDetails: {
                        externalPaymentMethodId: setupIntent?.payment_method
                    }
                };
                if (paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE) await handleInvoicePayment(updatePaymentMethodRequest);
                else {
                    await (0, $36d886fe12e537c3$export$5d4bd0ea3186eab)(updatePaymentMethodRequest, paymentMethodId);
                    const newPaymentMethod = await (0, $36d886fe12e537c3$export$33fee9948e94a456)(paymentMethodId);
                    if (newPaymentMethod?.status === 200) {
                        let newPaymentMethodDetails = newPaymentMethod?.data?.paymentMethodDetails;
                        dispatch((0, $53476aa40d2bc637$export$9628908a9dd74afb)(newPaymentMethodDetails));
                        setPaymentMethodAdded(true);
                    }
                }
            } catch (error) {
                const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
                handleErrorMsg(errorMessage);
            } finally{
                setProcessing(false);
                setShowPaymentForm(false);
            }
            else {
                setProcessing(false);
                setErrorMessage("Something went wrong, please refresh the page and try again.");
            }
        });
    };
    const handleInvoicePayment = async (updatePaymentMethodRequest)=>{
        setShowSpinner(true);
        setShowPaymentForm(false);
        try {
            await (0, $36d886fe12e537c3$export$6e845bae4add694e)(updatePaymentMethodRequest, paymentMethodId, customerId).then(async (response)=>{
                if (response?.status === 200) {
                    const idempotencyToken = (0, $382eb84981692d3a$export$7c54fad7190d0375)();
                    const amountInCents = (0, $382eb84981692d3a$export$77dcbd953f9a942d)(paymentAmount);
                    const capturePaymentPayload = {
                        idempotencyToken: idempotencyToken,
                        invoiceId: invoiceNumber,
                        orderId: `GUEST-${idempotencyToken}`,
                        amount: amountInCents,
                        paymentMethodId: response.data.paymentMethodId,
                        currency: (0, $5cdc329eeebd56d0$export$c19ece7ea27dcd9e)
                    };
                    const capture = await dispatch((0, $36d886fe12e537c3$export$88983c6bad234860)({
                        payload: capturePaymentPayload,
                        customerId: customerId
                    }));
                    if (capture?.payload?.status === 200) {
                        dispatch((0, $c89d887792446c86$export$a8f8d34a822b029c)(true));
                        history.push(`/invoicepay/confirmation`);
                    } else {
                        const errorMessage = (0, $988a08ad6804f205$export$fe0b41d6f39bfdf2)(capture?.payload?.errorCode);
                        handleErrorMsg(errorMessage);
                    }
                }
            });
        } catch (error) {
            handleErrorMsg("Payment failed, please try again.");
        } finally{
            setShowSpinner(false);
        }
    };
    let achMandateText = paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE ? $d0d210103d90c352$export$b220cd04490efc71 : ACH_MANDATE_TEXT;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        gap: 4,
        display: 'flex',
        flexDirection: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$da524f2075150321), {
                        children: "Add a payment method "
                    }),
                    paymentMethodType === (0, $5cdc329eeebd56d0$export$d6e58abbbec7e1ac).CARD && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                        children: "We only accept Visa, Mastercard, Amex, and Discover."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                        onChange: handlePaymentMethodTypeChange,
                        options: paymentElementOptions
                    }),
                    errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        color: '#E22929',
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingTop: '16px',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                color: '#6d6e78',
                                fontSize: '12px',
                                textAlign: 'justify',
                                paddingBottom: '16px',
                                children: paymentMethodType === (0, $5cdc329eeebd56d0$export$d6e58abbbec7e1ac).ACH ? achMandateText : $d0d210103d90c352$export$664e2e65a3758b76
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                gap: "10px",
                                justifyContent: paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE ? 'center' : 'flex-start',
                                children: [
                                    paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        buttonType: "mds-secondary",
                                        sx: {
                                            textTransform: 'none'
                                        },
                                        onClick: handleClosePaymentModal,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        buttonType: "mds-primary",
                                        sx: {
                                            textTransform: 'none'
                                        },
                                        disabled: !stripe,
                                        onClick: handleSubmit,
                                        loading: processing && !errorMessage,
                                        children: paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE ? `Pay ${paymentAmount}` : 'Continue'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$d0d210103d90c352$var$PaymentMethodForm.defaultProps = {
    setPaymentMethodAdded: ()=>{},
    handleClosePaymentModal: ()=>{},
    invoiceNumber: '',
    paymentAmount: 0,
    customerId: ''
};
var $d0d210103d90c352$export$2e2bcd8739ae039 = $d0d210103d90c352$var$PaymentMethodForm;





const $58f3999ceb801203$var$stripePromise = (0, $2110bf72a86f956f$export$de80f7562c3fd6b1)("pk_live_51Ofa2fDIC0zRrnfSs5qjVHugIRh4kbdBp5yTZGkp1uX3wvbGuVeOZmTJcQhmJI2bxmdIBT713Or6sT6j6OirMMDn00UIQ0Ps30", {
    betas: [
        "blocked_card_brands_beta_2"
    ]
});
const $58f3999ceb801203$var$useAddPaymentMethod = (handleErrorMsg, setPaymentMethodAdded)=>{
    const [showPaymentForm, setShowPaymentForm] = (0, $acw62.useState)(false);
    const [clientSecret, setClientSecret] = (0, $acw62.useState)('');
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [paymentMethodId, setPaymentMethodId] = (0, $acw62.useState)('');
    const [paymentType, setPaymentType] = (0, $acw62.useState)('');
    const [customerId, setCustomerId] = (0, $acw62.useState)('');
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const appearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#0570de',
            colorBackground: '#ffffff',
            colorText: '#30313d',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '4px',
            borderRadius: '4px'
        }
    };
    const options = {
        clientSecret: clientSecret,
        appearance: appearance,
        allowedCardBrands: (0, $5cdc329eeebd56d0$export$1d3e2cd80d3e050f)
    };
    const StripeForm = ({ invoiceNumber: invoiceNumber, paymentAmount: paymentAmount, setShowSpinner: setShowSpinner, handleCancel: handleCancel })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            paddingTop: 4,
            paddingBottom: 4,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
                options: options,
                stripe: $58f3999ceb801203$var$stripePromise,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0d210103d90c352$export$2e2bcd8739ae039), {
                    setShowPaymentForm: setShowPaymentForm,
                    paymentMethodId: paymentMethodId,
                    handleErrorMsg: handleErrorMsg,
                    setPaymentMethodAdded: setPaymentMethodAdded,
                    paymentType: paymentType,
                    handleClosePaymentModal: handleCancel,
                    invoiceNumber: invoiceNumber,
                    paymentAmount: paymentAmount,
                    customerId: customerId,
                    setShowSpinner: setShowSpinner
                })
            })
        });
    };
    const onAddPaymentMethodClick = (0, $acw62.useCallback)(async ()=>{
        try {
            setProcessing(true);
            const response = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                status: (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).PENDING
            });
            if (response.status === 200 && response?.data?.paymentMethodsList?.length) {
                const result = response.data.paymentMethodsList?.[0];
                setClientSecret(result?.paymentMethodLifecycleDetails?.clientSecret);
                setPaymentMethodId(result?.paymentMethodId);
                setShowPaymentForm(true);
            } else try {
                setProcessing(true);
                const response = await (0, $36d886fe12e537c3$export$b0b9fa6eec891db0)({
                    paymentProvider: (0, $5cdc329eeebd56d0$export$46774d6b3c4ac9de),
                    idempotencyToken: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)()
                });
                if (response?.status === 200) {
                    let client_secret = response?.data?.paymentMethodLifecycleDetails?.clientSecret;
                    setClientSecret(client_secret);
                    setPaymentMethodId(response?.data?.paymentMethodId);
                    setShowPaymentForm(true);
                }
            } catch (error) {
                setProcessing(false);
                const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
                handleErrorMsg(errorMessage);
            }
        } catch (error) {
            setProcessing(false);
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    }, [
        dispatch,
        handleErrorMsg
    ]);
    const generateIdempotencyToken = ()=>(0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
    const onPayByInvoice = (0, $acw62.useCallback)(async (customerDetails)=>{
        try {
            setProcessing(true);
            const idempotencyToken = generateIdempotencyToken();
            const response = await (0, $36d886fe12e537c3$export$3137a828266444e)({
                paymentProvider: (0, $5cdc329eeebd56d0$export$46774d6b3c4ac9de),
                idempotencyToken: idempotencyToken,
                customerDetails: customerDetails
            });
            if (response?.status === 200) {
                let data = response?.data;
                let client_secret = data?.paymentMethodLifecycleDetails?.clientSecret;
                setClientSecret(client_secret);
                setPaymentMethodId(data?.paymentMethodId);
                setCustomerId(data?.customerId);
                setShowPaymentForm(true);
                setProcessing(false);
            }
        } catch (error) {
            setProcessing(false);
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        }
    });
    const handleClosePaymentModal = ()=>{
        setShowPaymentForm(false);
        setProcessing(false);
    };
    return {
        showPaymentForm: showPaymentForm,
        processing: processing,
        onAddPaymentMethodClick: onAddPaymentMethodClick,
        handleClosePaymentModal: handleClosePaymentModal,
        StripeForm: StripeForm,
        setPaymentType: setPaymentType,
        onPayByInvoice: onPayByInvoice
    };
};
var $58f3999ceb801203$export$2e2bcd8739ae039 = $58f3999ceb801203$var$useAddPaymentMethod;



const $faa218d212c6dbef$var$PaymentMethodsSection = ({ setProcessing: setProcessing, handleErrorMsg: handleErrorMsg })=>{
    const [listPayments, setListPayments] = (0, $acw62.useState)([]);
    const [isSnackbarOpen, setIsSnackbarOpen] = (0, $acw62.useState)(false);
    const [snackbarMessage, setSnackbarMessage] = (0, $acw62.useState)('');
    const [paymentMethodAdded, setPaymentMethodAdded] = (0, $acw62.useState)(false);
    const { showPaymentForm: showPaymentForm, onAddPaymentMethodClick: onAddPaymentMethodClick, handleClosePaymentModal: handleClosePaymentModal, StripeForm: StripeForm } = (0, $58f3999ceb801203$export$2e2bcd8739ae039)(handleErrorMsg, setPaymentMethodAdded);
    const handleAddNewPaymentMethod = async ()=>{
        await onAddPaymentMethodClick();
    };
    const handleSetAsDefaultPayment = async (paymentMethodId)=>{
        try {
            setProcessing(true);
            const response = await (0, $36d886fe12e537c3$export$5d4bd0ea3186eab)({
                idempotencyToken: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                setDefault: true
            }, paymentMethodId);
            if (response.status === 200) {
                await (0, $c9fe4f79081fb8c8$export$137d42378a7a52bf)(setProcessing, handleErrorMsg, setListPayments, (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE);
                setSnackbarMessage((0, $c9fe4f79081fb8c8$export$4f31a5e23f8e79a9)((0, $c9fe4f79081fb8c8$export$2d7f490179da7f41)?.setDefaultPaymentMethod));
                setIsSnackbarOpen(true);
            }
        } catch (error) {
            setProcessing(false);
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    const handleDeletePaymentMethod = async (paymentMethodId)=>{
        try {
            const response = await (0, $36d886fe12e537c3$export$9577d55c4298d793)(paymentMethodId);
            if (response.status === 200) {
                await (0, $c9fe4f79081fb8c8$export$137d42378a7a52bf)(setProcessing, handleErrorMsg, setListPayments, (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE);
                setSnackbarMessage((0, $c9fe4f79081fb8c8$export$4f31a5e23f8e79a9)((0, $c9fe4f79081fb8c8$export$2d7f490179da7f41)?.deletePaymentMethod));
                setIsSnackbarOpen(true);
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        (0, $c9fe4f79081fb8c8$export$137d42378a7a52bf)(setProcessing, handleErrorMsg, setListPayments, (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE);
        setPaymentMethodAdded(false);
    }, [
        paymentMethodAdded
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        width: "80%",
        margin: "60px auto 0 auto",
        flexDirection: {
            xs: 'column',
            sm: 'row'
        },
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                autoHideDuration: 3000,
                open: isSnackbarOpen,
                onClose: ()=>{
                    setIsSnackbarOpen(false);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), {
                    message: snackbarMessage,
                    sx: (0, $c9fe4f79081fb8c8$export$c5530885e8ffa0f4)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: {
                    xs: '100%'
                },
                pb: {
                    xs: '24px',
                    sm: '48px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        "data-testid": "paymentMethodHeadline",
                        variant: 'h2',
                        color: "primary.main",
                        textAlign: "left",
                        lineHeight: "35px",
                        id: "headline",
                        children: "Payment methods"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d83ffc3489d7abf$export$ab218e41b1f3d913), {
                        paymentList: listPayments,
                        isProfilePage: true,
                        handleSetAsDefaultPayment: handleSetAsDefaultPayment,
                        handleAddNewPaymentMethod: handleAddNewPaymentMethod,
                        handleDeletePaymentMethod: handleDeletePaymentMethod
                    })
                ]
            }),
            showPaymentForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                openModal: showPaymentForm,
                closeModalHandler: handleClosePaymentModal,
                modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)(StripeForm, {}),
                style: {
                    maxWidth: '521px',
                    width: 'auto',
                    padding: '24px'
                }
            })
        ]
    });
};
var $faa218d212c6dbef$export$2e2bcd8739ae039 = $faa218d212c6dbef$var$PaymentMethodsSection;




const $2f3861fbeca63e36$var$ProfileWrapper = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
    height: 800px;
    display: flex;
    ${[
        breakpoints.down('sm')
    ]} {
        flex-direction: column;
        height: auto;
    }
`);
const $2f3861fbeca63e36$var$NavigationPanel = (0, $d8seH.default)('div')(({ theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    background-color: ${primary.main};
    height: auto;
    min-height: 800px;
    max-width: 400px;
    flex: 0 0 auto;
    position: relative;
    ${[
        breakpoints.down('sm')
    ]} {
        width: 100%;
        padding: 40px;
        min-height: 80px;
    }
`);
const $2f3861fbeca63e36$var$NavigationPanelLink = (0, $d8seH.default)('a')(({ isActive: isActive, theme: { palette: { neutral: neutral } } })=>`
    display: flex;
    align-items: center;
    font-size: 1rem;
    color: ${neutral.white};
    text-decoration: none;
    cursor: pointer;
    background-color:${isActive ? '#225D84' : 'transparent'};
    padding:6px 60px;
`);
const $2f3861fbeca63e36$var$NavIcon = (0, $d8seH.default)('img')`
    margin-right: 10px;
`;
const $2f3861fbeca63e36$var$AccountInfo = (0, $d8seH.default)('div')`
    height: 100%;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: scroll;
    scroll-behavior: smooth;
    &&::-webkit-scrollbar{
        display: none;
    }
`;
const $2f3861fbeca63e36$var$StyledLink = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { palette: { secondary: secondary }, breakpoints: breakpoints } })=>`
  color: ${secondary.textLinks};
  ${[
        breakpoints.down('sm')
    ]} {
    padding-top:20px;
  } 
`);
const $2f3861fbeca63e36$var$accordionCustomStyle = {
    borderRadius: "0px !important",
    boxShadow: "none",
    border: "1px solid grey !important",
    margin: "0px !important",
    backgroundColor: "primary.main",
    color: "white",
    width: "100%",
    "& .MuiTypography-h5": {
        color: "white",
        display: "flex",
        alignItems: 'center'
    },
    "& .Mui-expanded": {
        backgroundColor: "#225D84"
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        marginRight: "40px"
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
        minHeight: "48px"
    },
    "& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded": {
        margin: "0px 0px 0px 40px"
    }
};
const $2f3861fbeca63e36$var$PROFILE_CONTENT = {
    accountDetailsMenuLabel: "Account Details",
    addressesMenuLabel: "Addresses",
    contactUsLinkLabel: "customer support",
    headline: "Your Account Profile",
    menuWelcomeMessage: "Welcome",
    message: `We want to ensure that you receive the best possible assistance. 
              If you encounter any difficulties or if you need to update information, 
              please don\'t hesitate to contact our dedicated `,
    paymentMethodsMenuLabel: "Payment Methods"
};
const $2f3861fbeca63e36$var$ProfileComponent = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)() || '';
    const emailAddress = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.emailAddress);
    const possiblePaths = [
        'addresses',
        'account',
        'payment-methods'
    ];
    const initialNavLink = possiblePaths.find((path)=>window.location.pathname.includes(path)) || 'account';
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const [navigationLink, setNavigationLink] = (0, $acw62.useState)(initialNavLink);
    const [loader, setLoader] = (0, $acw62.useState)(false);
    const theme = (0, $14H9o.default)();
    const desktop = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const mobile = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('sm'));
    const history = (0, $cb6b9b6cca50f16e$exports.useHistory)();
    const alertRef = (0, $acw62.useRef)(null);
    const successAlertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const sapUserData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.sapUserData?.data);
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const renderText = (content)=>{
        if (typeof content === 'string') return content;
    };
    const MessageBannerForAffiliation = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        width: '100%',
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
            type: "info",
            bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                children: [
                    "To find your 2024 Contract Affiliation, please select the contract affiliation button on the ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        to: `/${locale}/order-form`,
                        children: "Quick Order Form."
                    })
                ]
            })
        })
    });
    const errorMsgHandler = (errorMsg)=>{
        let message = errorMsg || generalApiError;
        setErrorMsg(message);
        alertRef.current?.openAlert(message);
    };
    const AccountSection = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                MessageBannerForAffiliation,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    width: "80%",
                    margin: "60px auto 0 auto",
                    flexDirection: {
                        xs: 'column',
                        sm: 'row'
                    },
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        width: {
                            xs: '100%',
                            sm: '60%'
                        },
                        pb: {
                            xs: '24px',
                            sm: 'unset'
                        },
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'h2',
                                color: "primary.main",
                                textAlign: "left",
                                lineHeight: "35px",
                                id: "headline",
                                children: $2f3861fbeca63e36$var$PROFILE_CONTENT.headline
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: 'p1',
                                component: "div",
                                color: "neutral.main",
                                textAlign: "left",
                                lineHeight: {
                                    xs: '21px',
                                    sm: '24px'
                                },
                                m: {
                                    xs: '16px 0',
                                    sm: 'unset'
                                },
                                id: "headlineMessage",
                                children: [
                                    renderText($2f3861fbeca63e36$var$PROFILE_CONTENT.message),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                        to: `/${locale}/contact-us`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$StyledLink, {
                                            variant: 'link',
                                            children: $2f3861fbeca63e36$var$PROFILE_CONTENT.contactUsLinkLabel
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74de6751063faa$export$edd98d03726b2474), {
                    contactName: sapUserData?.name,
                    contactEmail: sapUserData?.email,
                    jobTitle: sapUserData?.jobTitle,
                    contactRole: sapUserData?.position
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $399b28e45da3f7d1$export$2c56d2e2ae515eeb), {
                    userInfo: sapUserData
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e81af56a16d8a3ac$export$66e04d0aacdb3b2), {
                    userInfo: sapUserData
                })
            ]
        });
    };
    const handlePageSelection = (URL)=>{
        setNavigationLink(URL);
        if (URL === 'account') history.push(`/${locale}/my-profile`);
        else history.push(`/${locale}/my-profile/${URL}`);
    };
    const AddressesSection = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                MessageBannerForAffiliation,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    width: "80%",
                    margin: "60px auto 0 auto",
                    flexDirection: {
                        xs: 'column',
                        sm: 'row'
                    },
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        width: {
                            xs: '100%',
                            sm: '60%'
                        },
                        pb: {
                            xs: '24px',
                            sm: 'unset'
                        },
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'h2',
                                color: "primary.main",
                                textAlign: "left",
                                lineHeight: "35px",
                                id: "headline",
                                children: $2f3861fbeca63e36$var$PROFILE_CONTENT.addressesMenuLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                variant: 'p1',
                                component: "div",
                                color: "neutral.main",
                                textAlign: "left",
                                lineHeight: {
                                    xs: '21px',
                                    sm: '24px'
                                },
                                m: {
                                    xs: '16px 0',
                                    sm: 'unset'
                                },
                                id: "headlineMessage",
                                children: [
                                    renderText($2f3861fbeca63e36$var$PROFILE_CONTENT.message),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                        to: `/${locale}/contact-us`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$StyledLink, {
                                            variant: 'link',
                                            children: $2f3861fbeca63e36$var$PROFILE_CONTENT.contactUsLinkLabel
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d48ed549a6a355c$export$6645071c2268d4b8), {
                    addresses: sapUserData?.orgUnit?.addresses,
                    setLoader: setLoader
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$ProfileWrapper, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                type: "info",
                message: "Changes saved",
                variant: "filled",
                ref: successAlertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$NavigationPanel, {
                id: "navigationPanel",
                "data-testid": "navigationPanel",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            padding: desktop ? "60px 60px 0px 60px" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'h6',
                                width: "100%",
                                color: "neutral.white",
                                textTransform: "uppercase",
                                id: "navigationPanelMsg",
                                "data-testid": "navigationPanelMsg",
                                children: $2f3861fbeca63e36$var$PROFILE_CONTENT.menuWelcomeMessage
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: 'h3',
                                color: "neutral.white",
                                marginBottom: {
                                    xs: '0',
                                    sm: '40px'
                                },
                                sx: {
                                    overflowWrap: 'break-word'
                                },
                                id: "navigationPanelUser",
                                "data-testid": "navigationPanelUser",
                                children: sapUserData?.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: {
                            xs: 'none',
                            sm: 'flex'
                        },
                        flexDirection: "column",
                        id: "navigationLinkPanel",
                        "data-testid": "navigationLinkPanel",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$NavigationPanelLink, {
                                isActive: navigationLink === "account",
                                id: "accountDetailsLink",
                                "data-testid": "accountDetailsLink",
                                onClick: ()=>handlePageSelection('account'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($107215d240d18c01$exports))),
                                        alt: "account details",
                                        height: "30",
                                        width: "30"
                                    }),
                                    $2f3861fbeca63e36$var$PROFILE_CONTENT.accountDetailsMenuLabel
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$NavigationPanelLink, {
                                isActive: navigationLink === "addresses",
                                id: "addressesLink",
                                "data-testid": "addressesLink",
                                onClick: ()=>handlePageSelection('addresses'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b499cae983aaf295$exports))),
                                        alt: "addresses",
                                        height: "30",
                                        width: "30"
                                    }),
                                    $2f3861fbeca63e36$var$PROFILE_CONTENT.addressesMenuLabel
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$NavigationPanelLink, {
                                isActive: navigationLink === "payment-methods",
                                id: "paymentMethodsLink",
                                "data-testid": "paymentMethodsLink",
                                onClick: ()=>handlePageSelection('payment-methods'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccde9ad43492d44$exports))),
                                        alt: "payment methods",
                                        height: "30",
                                        width: "30"
                                    }),
                                    $2f3861fbeca63e36$var$PROFILE_CONTENT.paymentMethodsMenuLabel
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: loader
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2f3861fbeca63e36$var$AccountInfo, {
                children: [
                    mobile && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $273d0c5767f221c5$export$a766cd26d0d69044), {
                                id: "acocuntAccordion",
                                defaultExpanded: true,
                                accordionCustomStyle: $2f3861fbeca63e36$var$accordionCustomStyle,
                                heading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($107215d240d18c01$exports))),
                                            alt: "account details",
                                            height: "30",
                                            width: "30"
                                        }),
                                        " ",
                                        $2f3861fbeca63e36$var$PROFILE_CONTENT.accountDetailsMenuLabel,
                                        " "
                                    ]
                                }),
                                description: /*#__PURE__*/ (0, $ayMG0.jsx)(AccountSection, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $273d0c5767f221c5$export$a766cd26d0d69044), {
                                id: "addressesAccordion",
                                accordionCustomStyle: $2f3861fbeca63e36$var$accordionCustomStyle,
                                heading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b499cae983aaf295$exports))),
                                            alt: "addresses",
                                            height: "30",
                                            width: "30"
                                        }),
                                        $2f3861fbeca63e36$var$PROFILE_CONTENT.addressesMenuLabel
                                    ]
                                }),
                                description: /*#__PURE__*/ (0, $ayMG0.jsx)(AddressesSection, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $273d0c5767f221c5$export$a766cd26d0d69044), {
                                id: "paymentMethodsAccordion",
                                accordionCustomStyle: $2f3861fbeca63e36$var$accordionCustomStyle,
                                heading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($2f3861fbeca63e36$var$NavIcon, {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccde9ad43492d44$exports))),
                                            alt: "payment methods",
                                            height: "30",
                                            width: "30"
                                        }),
                                        $2f3861fbeca63e36$var$PROFILE_CONTENT.paymentMethodsMenuLabel
                                    ]
                                }),
                                description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $faa218d212c6dbef$export$2e2bcd8739ae039), {
                                    setProcessing: setLoader,
                                    handleErrorMsg: errorMsgHandler
                                })
                            })
                        ]
                    }),
                    desktop && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            navigationLink === 'account' && /*#__PURE__*/ (0, $ayMG0.jsx)(AccountSection, {}),
                            navigationLink === 'addresses' && /*#__PURE__*/ (0, $ayMG0.jsx)(AddressesSection, {}),
                            navigationLink === 'payment-methods' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $faa218d212c6dbef$export$2e2bcd8739ae039), {
                                setProcessing: setLoader,
                                handleErrorMsg: errorMsgHandler
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2f3861fbeca63e36$export$2e2bcd8739ae039 = $2f3861fbeca63e36$var$ProfileComponent;


const $1b89a0d76e3a6a15$var$MyProfilePage = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f3861fbeca63e36$export$2e2bcd8739ae039), {});
};
var $1b89a0d76e3a6a15$export$2e2bcd8739ae039 = $1b89a0d76e3a6a15$var$MyProfilePage;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");








var $3bYfT = parcelRequire("3bYfT");

const $bbc128cda5bd5935$var$FlexGrow = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
    margin-top: 18px;
    width: 100%;
   ${[
        breakpoints.up('md')
    ]} {
        width: 50%;
    }
`);
const $bbc128cda5bd5935$var$RadioContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
    display: flex;
    margin-right: 8px;
    flex-wrap: wrap;
    ${[
        breakpoints.down('sm')
    ]} {
        flex-direction: column;
    }
`);
const $bbc128cda5bd5935$var$StyledTextInput = (0, $d8seH.default)((0, $baaadb944db42c9b$export$c86715117507e8e5))(({ theme: { breakpoints: breakpoints } })=>`
    width: 100%;
    margin-top: 25px !important;
    ${[
        breakpoints.up('md')
    ]} {
        width: 80%;
    }
    ${[
        breakpoints.down('sm')
    ]} {
        margin: 20px 0px !important;
    }
`);
const $bbc128cda5bd5935$var$initialValues = {
    fullname: {
        value: "",
        error: false,
        required: true
    },
    email: {
        value: "",
        error: false,
        required: true
    },
    phone: {
        value: "",
        error: false,
        required: true
    },
    organization: {
        value: "",
        error: false,
        required: true
    },
    contactMethod: {
        value: "Email",
        error: false,
        required: true
    },
    consented: {
        value: false,
        error: false,
        required: true
    },
    supportCategory: {
        value: "Contract and Billing",
        error: false,
        required: true
    }
};
const $bbc128cda5bd5935$export$7b14df81b2d7cbdc = ({ staticContent: staticContent })=>{
    const [values, setValues] = (0, $acw62.useState)($bbc128cda5bd5935$var$initialValues);
    const [submitStatus, setSubmitStatus] = (0, $acw62.useState)("not-submitted");
    const desktop = (0, $942f413c6b94358c$export$2e2bcd8739ae039)('(min-width:500px)');
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { executeRecaptcha: executeRecaptcha } = (0, $7b9bf6be2b37a4cd$export$7f8feffd50fb5144)();
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const invalidEmailFormatData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_EMAIL_FORMAT");
    const invalidEmailFormatError = invalidEmailFormatData && invalidEmailFormatData[0]?.fields?.message;
    const invalidPhoneFormatData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_PHONE_FORMAT");
    const invalidPhoneFormatError = invalidPhoneFormatData && invalidPhoneFormatData[0]?.fields?.message;
    const missingNameData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "MISSING_FULL_NAME");
    const missingNameError = missingNameData && missingNameData[0]?.fields?.message;
    const missingOrganizationData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "MISSING_ORGANIZATION");
    const missingOrganizationError = missingOrganizationData && missingOrganizationData[0]?.fields?.message;
    const handleInputChange = (e)=>{
        if (e.target.type === "checkbox") setValues((oldValues)=>({
                ...oldValues,
                [e.target.name]: {
                    value: !oldValues.consented.value,
                    error: "",
                    required: values[e.target.name].required,
                    label: values[e.target.name].label
                }
            }));
        else setValues((oldValues)=>({
                ...oldValues,
                [e.target.name]: {
                    value: e.target.value.trimStart(),
                    error: "",
                    required: values[e.target.name].required,
                    label: values[e.target.name].label
                }
            }));
    };
    const validateInput = ()=>{
        const objectKeys = Object.keys(values);
        const validatedResult = {
            ...values
        };
        let isValid = true;
        objectKeys.forEach((key)=>{
            if (validatedResult[key].required && !validatedResult[key].value) {
                validatedResult[key].error = true;
                isValid = false;
            } else if (key === "email" && !(0, $382eb84981692d3a$export$7d809d729bfb7d8e)("email", validatedResult[key].value)) {
                validatedResult[key].error = true;
                isValid = false;
            } else if (key === "phone" && !(0, $382eb84981692d3a$export$7d809d729bfb7d8e)("phone", validatedResult[key].value)) {
                validatedResult[key].error = true;
                isValid = false;
            }
        });
        setValues(validatedResult);
        if (!isValid) {
            var fe = new CustomEvent("form_error_js", {
                detail: {
                    form_name: "not brand aligned|hcp|contact us form",
                    form_type: "contact us form|non-dynamic form"
                }
            });
            document.dispatchEvent(fe);
        }
        return isValid;
    };
    const handleReCaptchaVerify = (0, $acw62.useCallback)(async ()=>{
        if (!executeRecaptcha) return;
        const token = await executeRecaptcha('contactus');
        return token;
    }, [
        executeRecaptcha
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!validateInput()) return;
        setSubmitStatus("submitting");
        try {
            const recaptchaToken = await handleReCaptchaVerify();
            const reqBody = {
                contactMethod: values?.contactMethod?.value,
                organization: values?.organization?.value,
                consented: values?.consented?.value,
                supportCategory: values?.supportCategory?.value,
                email: values?.email?.value,
                fullname: values?.fullname?.value,
                phone: values?.phone?.value,
                recaptchaToken: recaptchaToken
            };
            await (0, $fdf4ab7ce1c873bd$export$c0733ef253e14774)(reqBody);
            setSubmitStatus("submitted");
            var fc = new CustomEvent("form_complete_js", {
                detail: {
                    form_name: "not brand aligned|hcp|contact us form",
                    form_type: "contact us form|non-dynamic form"
                }
            });
            document.dispatchEvent(fc);
        } catch (error) {
            console.log("error", error);
        } finally{
            setSubmitStatus((oldValue)=>oldValue !== "submitted" ? "not-submitted" : oldValue);
        }
    };
    const handleReset = ()=>{
        setValues((_)=>({
                ...$bbc128cda5bd5935$var$initialValues
            }));
        setSubmitStatus("not-submitted");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        m: "50px 0",
        p: {
            xs: '0 32px',
            sm: '0 94px'
        },
        "data-testid": "contactusForm",
        children: submitStatus === "submitted" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            children: [
                desktop ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: staticContent?.formSubmitted?.icon?.fields?.file?.url,
                    alt: "",
                    width: "65px",
                    height: "65px"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: staticContent?.formSubmitted?.icon?.fields?.file?.url,
                    alt: "",
                    width: "116px",
                    height: "116px"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h2',
                    color: "primary.main",
                    mt: "28px",
                    children: staticContent?.formSubmitted?.headline
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'p1',
                    color: "primary.main",
                    mt: "22px",
                    children: "Thank you for reaching out. A representative will reach out shortly."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        marginTop: "18px",
                        '@media screen and (max-width: 500px)': {
                            marginTop: '40px'
                        }
                    },
                    onClick: handleReset,
                    children: "START NEW MESSAGE"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-form-name": "not brand aligned|hcp|contact us form",
            "data-form-type": "contact us form|non-dynamic form",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h2',
                    color: "primary.main",
                    "data-testid": "contactusFormHeadline",
                    children: staticContent?.form?.headline
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'p1',
                    color: "primary.main",
                    lineHeight: "22px",
                    mt: "8px",
                    "data-testid": "contactusFormMsg",
                    children: "Enter your contact details and select how we can help you."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($bbc128cda5bd5935$var$FlexGrow, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($bbc128cda5bd5935$var$StyledTextInput, {
                                    "data-testid": "fullname",
                                    required: true,
                                    focused: true,
                                    placeholder: staticContent?.form?.fullNamePlaceholder,
                                    label: staticContent?.form?.fullNameLabel,
                                    inputType: "text",
                                    varient: "standard",
                                    name: "fullname",
                                    onChange: handleInputChange,
                                    error: values?.fullname?.error,
                                    helperText: values?.fullname?.error ? missingNameError : ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($bbc128cda5bd5935$var$StyledTextInput, {
                                    "data-testid": "email",
                                    required: true,
                                    focused: true,
                                    placeholder: staticContent?.form?.emailPlaceholder,
                                    label: staticContent?.form?.emailLabel,
                                    inputType: "text",
                                    varient: "standard",
                                    name: "email",
                                    onChange: handleInputChange,
                                    error: values?.email?.error,
                                    helperText: values?.email?.error ? invalidEmailFormatError : ''
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($bbc128cda5bd5935$var$StyledTextInput, {
                                    "data-testid": "phone",
                                    required: true,
                                    focused: true,
                                    placeholder: staticContent?.form?.phonePlaceholder,
                                    label: staticContent?.form?.phoneLabel,
                                    inputType: "text",
                                    varient: "standard",
                                    name: "phone",
                                    onChange: handleInputChange,
                                    error: values?.phone?.error,
                                    helperText: values?.phone?.error ? invalidPhoneFormatError : ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($bbc128cda5bd5935$var$StyledTextInput, {
                                    "data-testid": "organization",
                                    required: true,
                                    focused: true,
                                    placeholder: staticContent?.form?.organizationPlaceholder,
                                    label: staticContent?.form?.organizationLabel,
                                    inputType: "text",
                                    varient: "standard",
                                    name: "organization",
                                    onChange: handleInputChange,
                                    error: values?.organization?.error,
                                    helperText: values?.organization?.error ? missingOrganizationError : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($bbc128cda5bd5935$var$FlexGrow, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    className: "question",
                                    variant: 'h5',
                                    mt: "12px",
                                    color: "neutral.main",
                                    children: [
                                        staticContent?.form?.preferredMethodLabel,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: 'span',
                                            ml: 1,
                                            sx: {
                                                color: "primary.red"
                                            },
                                            children: "*"
                                        })
                                    ]
                                }),
                                staticContent?.form?.preferredMethodList && /*#__PURE__*/ (0, $ayMG0.jsxs)($bbc128cda5bd5935$var$RadioContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                            className: "answer",
                                            id: "email",
                                            label: staticContent?.form?.preferredMethodList[0],
                                            name: "contactMethod",
                                            value: "Email",
                                            checked: values?.contactMethod?.value === "Email",
                                            onChange: handleInputChange
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                            className: "answer",
                                            "data-testid": "radiophone",
                                            id: "phone",
                                            label: staticContent?.form?.preferredMethodList[1],
                                            name: "contactMethod",
                                            value: "Phone",
                                            checked: values?.contactMethod?.value === "Phone",
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginTop: "32px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                            className: "question",
                                            variant: 'h5',
                                            mt: "12px",
                                            color: "neutral.main",
                                            children: [
                                                staticContent?.form?.supportCategoryLabel,
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: 'span',
                                                    ml: 1,
                                                    sx: {
                                                        color: "primary.red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        staticContent?.form?.supportCategoryList && /*#__PURE__*/ (0, $ayMG0.jsxs)($bbc128cda5bd5935$var$RadioContainer, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "billing",
                                                    id: "contract_and_billing",
                                                    label: staticContent?.form?.supportCategoryList[0],
                                                    name: "supportCategory",
                                                    value: "Contract and Billing",
                                                    checked: values?.supportCategory?.value === "Contract and Billing",
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "assistance",
                                                    id: "order_assitance",
                                                    label: staticContent?.form?.supportCategoryList[1],
                                                    name: "supportCategory",
                                                    value: "Order Assistance",
                                                    checked: values?.supportCategory?.value === "Order Assistance",
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "inquiry",
                                                    id: "product_inquiry",
                                                    label: staticContent?.form?.supportCategoryList[2],
                                                    name: "supportCategory",
                                                    value: "Product Inquiry",
                                                    checked: values?.supportCategory?.value === "Product Inquiry",
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "accountinfo",
                                                    id: "account_info",
                                                    label: staticContent?.form?.supportCategoryList[3],
                                                    name: "supportCategory",
                                                    value: "Account Information",
                                                    checked: values?.supportCategory?.value === "Account Information",
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "general",
                                                    id: "general_inquiry",
                                                    label: staticContent?.form?.supportCategoryList[4],
                                                    name: "supportCategory",
                                                    value: "General Inquiry",
                                                    checked: values?.supportCategory?.value === "General Inquiry",
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                                                    className: "answer",
                                                    "data-testid": "other",
                                                    id: "other",
                                                    label: staticContent?.form?.supportCategoryList[5],
                                                    name: "supportCategory",
                                                    value: "Other",
                                                    checked: values?.supportCategory?.value === "Other",
                                                    onChange: handleInputChange
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: {
                                        xs: 'block',
                                        sm: 'flex'
                                    },
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mt: "30px",
                                    textAlign: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c576d11d36ade61d$export$48513f6b9f8ce62d), {
                                            "data-testid": "consented",
                                            id: "contact_us_checkBox",
                                            onChange: handleInputChange,
                                            name: "consented",
                                            label: staticContent?.form?.consentMessageLabel,
                                            error: values?.consented?.error && !values?.consented?.value
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            "data-testid": "privacy",
                                            mt: "-2px",
                                            sx: {
                                                cursor: 'pointer'
                                            },
                                            position: "relative",
                                            left: {
                                                xs: '30px',
                                                sm: '-11px'
                                            },
                                            mb: {
                                                xs: '32px',
                                                sm: '0px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: `/${locale}/privacy-policy`,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    children: staticContent?.form?.consentLink?.fields?.label
                                                }),
                                                ".",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    variant: 'span',
                                                    pl: 1,
                                                    sx: {
                                                        color: "primary.red"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            mt: "0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                                onClick: handleSubmit,
                                                disabled: submitStatus === "submitting",
                                                "data-testid": "sendBtn",
                                                children: "SEND"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");


var $9Lykx = parcelRequire("9Lykx");
var $3bYfT = parcelRequire("3bYfT");





const $4cb9025d70ee2d16$export$a41342575b9eca37 = [
    {
        title: 'Care Team Contact Us Card - US',
        headline: 'To place an order or for support',
        message: `1-866-MODERNA (1-866-663-3762)\n 8:00AM - 8:00PM, Monday - Friday\n WeCare@modernatx.com`,
        icon: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                type: 'Asset',
                createdAt: '2022-10-28T13:45:09.591Z',
                updatedAt: '2022-12-09T19:13:58.864Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 11,
                revision: 2,
                locale: 'en-US'
            },
            fields: {
                title: 'Faq Category Icon',
                description: 'Faq Category SVG',
                file: {
                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                    details: {
                        size: 40893,
                        image: {
                            width: 600,
                            height: 600
                        }
                    },
                    fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                    contentType: 'image/png'
                }
            }
        },
        country: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'country'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                        type: 'Asset',
                        createdAt: '2023-05-24T22:54:50.939Z',
                        updatedAt: '2023-05-24T22:54:50.939Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'usa flag',
                        description: 'USA Flag',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                            details: {
                                size: 2487,
                                image: {
                                    width: 36,
                                    height: 26
                                }
                            },
                            fileName: 'usa_flag.svg',
                            contentType: 'image/svg+xml'
                        }
                    }
                },
                locales: [
                    'en-US'
                ]
            }
        }
    },
    {
        title: 'Report Adverse Event Contact Us Card - US',
        headline: 'Report an adverse event',
        message: `Click the arrow to submit an adverse event report`,
        icon: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                type: 'Asset',
                createdAt: '2022-10-28T13:45:09.591Z',
                updatedAt: '2022-12-09T19:13:58.864Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 11,
                revision: 2,
                locale: 'en-US'
            },
            fields: {
                title: 'Faq Category Icon',
                description: 'Faq Category SVG',
                file: {
                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                    details: {
                        size: 40893,
                        image: {
                            width: 600,
                            height: 600
                        }
                    },
                    fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                    contentType: 'image/png'
                }
            }
        },
        link: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '6mzHEzPj12cIX1TCNBE7p2',
                type: 'Entry',
                createdAt: '2021-12-15T18:53:22.036Z',
                updatedAt: '2023-01-10T22:05:28.098Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 7,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'externalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'Get Help - Moderna Expert Link',
                label: 'Get Help - Moderna Expert ',
                url: 'https://report.moderna.convergehealthsafety.com/'
            }
        },
        country: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'country'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                        type: 'Asset',
                        createdAt: '2023-05-24T22:54:50.939Z',
                        updatedAt: '2023-05-24T22:54:50.939Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'usa flag',
                        description: 'USA Flag',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                            details: {
                                size: 2487,
                                image: {
                                    width: 36,
                                    height: 26
                                }
                            },
                            fileName: 'usa_flag.svg',
                            contentType: 'image/svg+xml'
                        }
                    }
                },
                locales: [
                    'en-US'
                ]
            }
        },
        label: 'Report an adverse event'
    },
    {
        title: 'FAQ Contact Us Card - US',
        headline: 'FAQs',
        message: `Frequently asked questions about Moderna Direct\n\n'`,
        icon: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                type: 'Asset',
                createdAt: '2022-10-28T13:45:09.591Z',
                updatedAt: '2022-12-09T19:13:58.864Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 11,
                revision: 2,
                locale: 'en-US'
            },
            fields: {
                title: 'Faq Category Icon',
                description: 'Faq Category SVG',
                file: {
                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                    details: {
                        size: 40893,
                        image: {
                            width: 600,
                            height: 600
                        }
                    },
                    fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                    contentType: 'image/png'
                }
            }
        },
        link: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '4sGXFZd1qHOz98lelP3ptv',
                type: 'Entry',
                createdAt: '2022-10-25T05:36:49.166Z',
                updatedAt: '2023-09-11T17:49:57.795Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'internalLink'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                title: 'FAQs Link',
                label: 'Frequently Asked Questions ',
                pageReference: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '16VVyRwgvsqxp7Q0GBqDwl',
                        type: 'Entry',
                        createdAt: '2022-10-26T23:39:27.943Z',
                        updatedAt: '2022-10-26T23:39:27.943Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 11,
                        revision: 1,
                        contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'page'
                            }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        name: 'Main FAQ Page',
                        title: 'Page Title from Compose',
                        slug: 'faqs',
                        seo: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '3mfYDCFlr6nPLagdXV7jo8',
                                type: 'Entry',
                                createdAt: '2022-10-26T23:39:28.038Z',
                                updatedAt: '2022-10-26T23:39:28.038Z',
                                environment: {
                                    sys: {
                                        id: 'master',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 26,
                                revision: 1,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'seo'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Main FAQ Page - Compose: SEO',
                                title: 'Frequently Asked Questions Moderna',
                                description: 'This page provides answers to frequently asked questions on Moderna Direct',
                                no_index: false,
                                no_follow: false
                            }
                        },
                        content: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                },
                                id: '1c7FRISzjyCWuduGT6H36O',
                                type: 'Entry',
                                createdAt: '2022-10-26T23:39:28.060Z',
                                updatedAt: '2022-10-28T13:50:25.044Z',
                                environment: {
                                    sys: {
                                        id: 'master',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'ContentType',
                                        id: 'pageFaqsPageTemplate'
                                    }
                                },
                                locale: 'en-US'
                            },
                            fields: {
                                name: 'Main FAQ Page - FAQs Page Template',
                                faqModules: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '55Xgsw7Lb26fvzm4vznbe3',
                                        type: 'Entry',
                                        createdAt: '2022-10-26T23:39:28.125Z',
                                        updatedAt: '2023-05-30T19:07:13.038Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 24,
                                        revision: 7,
                                        contentType: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'ContentType',
                                                id: 'faqPage'
                                            }
                                        },
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'FAQs Page',
                                        banner: {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '7FSPIxBv2f8DUuOYNyjN2f',
                                                type: 'Entry',
                                                createdAt: '2022-10-25T05:36:06.733Z',
                                                updatedAt: '2023-06-16T18:23:48.072Z',
                                                environment: {
                                                    sys: {
                                                        id: 'master',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 21,
                                                revision: 4,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'bannerComponent'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                title: 'FAQs',
                                                headline: 'Browse answers to frequently asked questions',
                                                backgroundImage: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '5zfGJA7or5WGcLdYi4Qde',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-28T18:53:29.208Z',
                                                        updatedAt: '2022-10-28T18:53:29.208Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'master',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 1,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Banner BG Strand Top',
                                                        description: '',
                                                        file: {
                                                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                                            details: {
                                                                size: 47693,
                                                                image: {
                                                                    width: 1920,
                                                                    height: 511
                                                                }
                                                            },
                                                            fileName: 'Banner BG Strand Top .png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                },
                                                country: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '7sht7920U6vs3CLH2CUyaa',
                                                        type: 'Entry',
                                                        createdAt: '2023-05-18T03:23:50.744Z',
                                                        updatedAt: '2023-05-24T22:55:23.250Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'master',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 6,
                                                        revision: 2,
                                                        contentType: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'ContentType',
                                                                id: 'country'
                                                            }
                                                        },
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        name: 'United States',
                                                        isocode: 'US',
                                                        flag: {
                                                            metadata: {
                                                                tags: [],
                                                                concepts: []
                                                            },
                                                            sys: {
                                                                space: {
                                                                    sys: {
                                                                        type: 'Link',
                                                                        linkType: 'Space',
                                                                        id: 'n9bebhw263o0'
                                                                    }
                                                                },
                                                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                                                type: 'Asset',
                                                                createdAt: '2023-05-24T22:54:50.939Z',
                                                                updatedAt: '2023-05-24T22:54:50.939Z',
                                                                environment: {
                                                                    sys: {
                                                                        id: 'master',
                                                                        type: 'Link',
                                                                        linkType: 'Environment'
                                                                    }
                                                                },
                                                                publishedVersion: 5,
                                                                revision: 1,
                                                                locale: 'en-US'
                                                            },
                                                            fields: {
                                                                title: 'usa flag',
                                                                description: 'USA Flag',
                                                                file: {
                                                                    url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                                    details: {
                                                                        size: 2487,
                                                                        image: {
                                                                            width: 36,
                                                                            height: 26
                                                                        }
                                                                    },
                                                                    fileName: 'usa_flag.svg',
                                                                    contentType: 'image/svg+xml'
                                                                }
                                                            }
                                                        },
                                                        locales: [
                                                            'en-US'
                                                        ]
                                                    }
                                                }
                                            }
                                        },
                                        contactUsCtaComponent: {
                                            metadata: {
                                                tags: [],
                                                concepts: []
                                            },
                                            sys: {
                                                space: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Space',
                                                        id: 'n9bebhw263o0'
                                                    }
                                                },
                                                id: '6gqCKf6EtK3mI0yNzKHx5h',
                                                type: 'Entry',
                                                createdAt: '2022-10-28T20:10:43.478Z',
                                                updatedAt: '2022-10-31T05:40:26.928Z',
                                                environment: {
                                                    sys: {
                                                        id: 'master',
                                                        type: 'Link',
                                                        linkType: 'Environment'
                                                    }
                                                },
                                                publishedVersion: 12,
                                                revision: 3,
                                                contentType: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'ContentType',
                                                        id: 'contactUsCta'
                                                    }
                                                },
                                                locale: 'en-US'
                                            },
                                            fields: {
                                                contactUsMessage: 'Still can\'t find what you are looking for?',
                                                contactUsButtonLabel: 'CONTACT US',
                                                contactUsLink: {
                                                    sys: {
                                                        type: 'Link',
                                                        linkType: 'Entry',
                                                        id: '4HqZvZWcCaClANwXQS032G'
                                                    }
                                                },
                                                backgroundImage: {
                                                    metadata: {
                                                        tags: [],
                                                        concepts: []
                                                    },
                                                    sys: {
                                                        space: {
                                                            sys: {
                                                                type: 'Link',
                                                                linkType: 'Space',
                                                                id: 'n9bebhw263o0'
                                                            }
                                                        },
                                                        id: '4udXXZnb6huWaP2x7gPRJO',
                                                        type: 'Asset',
                                                        createdAt: '2022-10-31T05:40:17.871Z',
                                                        updatedAt: '2022-10-31T05:40:17.871Z',
                                                        environment: {
                                                            sys: {
                                                                id: 'master',
                                                                type: 'Link',
                                                                linkType: 'Environment'
                                                            }
                                                        },
                                                        publishedVersion: 3,
                                                        revision: 1,
                                                        locale: 'en-US'
                                                    },
                                                    fields: {
                                                        title: 'Banner BG Strand Bottom',
                                                        description: '',
                                                        file: {
                                                            url: '//images.ctfassets.net/n9bebhw263o0/4udXXZnb6huWaP2x7gPRJO/ac6296b15f97d71afaaa140bea8e323b/Banner_BG_Strand_Bottom.png',
                                                            details: {
                                                                size: 26282,
                                                                image: {
                                                                    width: 1920,
                                                                    height: 324
                                                                }
                                                            },
                                                            fileName: 'Banner BG Strand Bottom.png',
                                                            contentType: 'image/png'
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                faqCategoryIcon: {
                                    metadata: {
                                        tags: [],
                                        concepts: []
                                    },
                                    sys: {
                                        space: {
                                            sys: {
                                                type: 'Link',
                                                linkType: 'Space',
                                                id: 'n9bebhw263o0'
                                            }
                                        },
                                        id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                        type: 'Asset',
                                        createdAt: '2022-10-28T13:45:09.591Z',
                                        updatedAt: '2022-12-09T19:13:58.864Z',
                                        environment: {
                                            sys: {
                                                id: 'master',
                                                type: 'Link',
                                                linkType: 'Environment'
                                            }
                                        },
                                        publishedVersion: 11,
                                        revision: 2,
                                        locale: 'en-US'
                                    },
                                    fields: {
                                        title: 'Faq Category Icon',
                                        description: 'Faq Category SVG',
                                        file: {
                                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                                            details: {
                                                size: 40893,
                                                image: {
                                                    width: 600,
                                                    height: 600
                                                }
                                            },
                                            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                            contentType: 'image/png'
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        country: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                    sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'country'
                    }
                },
                locale: 'en-US'
            },
            fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                        },
                        id: '3aYCbZJiL8aoEKRdhjOXyy',
                        type: 'Asset',
                        createdAt: '2023-05-24T22:54:50.939Z',
                        updatedAt: '2023-05-24T22:54:50.939Z',
                        environment: {
                            sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                        },
                        publishedVersion: 5,
                        revision: 1,
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'usa flag',
                        description: 'USA Flag',
                        file: {
                            url: (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                            details: {
                                size: 2487,
                                image: {
                                    width: 36,
                                    height: 26
                                }
                            },
                            fileName: 'usa_flag.svg',
                            contentType: 'image/svg+xml'
                        }
                    }
                },
                locales: [
                    'en-US'
                ]
            }
        },
        label: 'View Frequently Asked Questions'
    }
];


var $3cc3eb5857371bb0$exports = {};
$3cc3eb5857371bb0$exports = new URL("contact-us-request-sent.ea3f9b0a.png", import.meta.url).toString();




var $d377b224e2aae122$exports = {};
$d377b224e2aae122$exports = new URL("privacy-policy-data-table.f9fdb5c7.png", import.meta.url).toString();


var $7ef523aae5638415$exports = {};
$7ef523aae5638415$exports = new URL("privacy-policy-data-table-EU.90ad35db.png", import.meta.url).toString();



const $cdcd230f9adfb4e4$export$5f354eed7f559fab = {
    "items": [
        {
            "fields": {
                "name": "Contact Us - Contact Us Page Template",
                "modules": [
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "2y5JNbGCdLulrhbyD0VSZ5",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:34:18.506Z",
                            "updatedAt": "2023-09-22T16:32:41.034Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 39,
                            "revision": 6,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "bannerComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "Contact Us Banner Component",
                            "headline": "Contact Us",
                            "backgroundImage": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5zfGJA7or5WGcLdYi4Qde",
                                    "type": "Asset",
                                    "createdAt": "2022-10-28T18:53:29.208Z",
                                    "updatedAt": "2022-10-28T18:53:29.208Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 6,
                                    "revision": 1,
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Banner BG Strand Top",
                                    "description": "",
                                    "file": {
                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6534c7b7c4cf878c$exports))),
                                        "details": {
                                            "size": 47693,
                                            "image": {
                                                "width": 1920,
                                                "height": 511
                                            }
                                        },
                                        "fileName": "Banner BG Strand Top .png",
                                        "contentType": "image/png"
                                    }
                                }
                            },
                            "message": "Ready to order or have questions? We're here to help. Contact us for any guidance or information you need. Your satisfaction is our priority and we eagerly await the opportunity to serve you.",
                            "country": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "7sht7920U6vs3CLH2CUyaa",
                                    "type": "Entry",
                                    "createdAt": "2023-05-18T03:23:50.744Z",
                                    "updatedAt": "2023-05-24T22:55:23.250Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 6,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "country"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "name": "United States",
                                    "isocode": "US",
                                    "flag": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                                            "type": "Asset",
                                            "createdAt": "2023-05-24T22:54:50.939Z",
                                            "updatedAt": "2023-05-24T22:54:50.939Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 5,
                                            "revision": 1,
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "title": "usa flag",
                                            "description": "USA Flag",
                                            "file": {
                                                "url": (0, (/*@__PURE__*/$parcel$interopDefault($6404beb9a0fb9f3d$exports))),
                                                "details": {
                                                    "size": 2487,
                                                    "image": {
                                                        "width": 36,
                                                        "height": 26
                                                    }
                                                },
                                                "fileName": "usa_flag.svg",
                                                "contentType": "image/svg+xml"
                                            }
                                        }
                                    },
                                    "locales": [
                                        "en-US"
                                    ]
                                }
                            }
                        }
                    },
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "bZN3ozoAd7NgLj1g3GLIQ",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:25:12.254Z",
                            "updatedAt": "2024-05-28T21:10:01.634Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 45,
                            "revision": 14,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "contactUsCardComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "Care Team Contact Us Card - US",
                            "headline": "To place an order or for support",
                            "message": {
                                "nodeType": "document",
                                "data": {},
                                "content": [
                                    {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "text",
                                                "value": "1-866-MODERNA (1-866-663-3762)",
                                                "marks": [],
                                                "data": {}
                                            }
                                        ]
                                    },
                                    {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "text",
                                                "value": "8:00AM - 8:00PM, Monday - Friday",
                                                "marks": [],
                                                "data": {}
                                            }
                                        ]
                                    },
                                    {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "text",
                                                "value": "WeCare@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                            }
                                        ]
                                    },
                                    {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "text",
                                                "value": "\n",
                                                "marks": [],
                                                "data": {}
                                            }
                                        ]
                                    }
                                ]
                            },
                            "icon": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "2wQ7GSaGNr9QsirrrDwWrJ",
                                    "type": "Asset",
                                    "createdAt": "2022-10-28T13:45:09.591Z",
                                    "updatedAt": "2022-12-09T19:13:58.864Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 11,
                                    "revision": 2,
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Faq Category Icon",
                                    "description": "Faq Category SVG",
                                    "file": {
                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                                        "details": {
                                            "size": 40893,
                                            "image": {
                                                "width": 600,
                                                "height": 600
                                            }
                                        },
                                        "fileName": "Moderna_Icon_ProphylacticVaccines.png",
                                        "contentType": "image/png"
                                    }
                                }
                            },
                            "country": "[Circular Reference]"
                        }
                    },
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "7wREbh7uFf1amAX5Occ9dj",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:28:54.232Z",
                            "updatedAt": "2024-12-13T22:26:19.433Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 31,
                            "revision": 10,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "contactUsCardComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "Report Adverse Event Contact Us Card - US",
                            "headline": "Report an adverse event",
                            "message": {
                                "data": {},
                                "content": [
                                    {
                                        "data": {},
                                        "content": [
                                            {
                                                "data": {},
                                                "marks": [],
                                                "value": "Click the arrow to submit an adverse event report",
                                                "nodeType": "text"
                                            },
                                            {
                                                "data": {},
                                                "marks": [],
                                                "value": "\n",
                                                "nodeType": "text"
                                            }
                                        ],
                                        "nodeType": "paragraph"
                                    }
                                ],
                                "nodeType": "document"
                            },
                            "icon": "[Circular Reference]",
                            "link": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "6mzHEzPj12cIX1TCNBE7p2",
                                    "type": "Entry",
                                    "createdAt": "2021-12-15T18:53:22.036Z",
                                    "updatedAt": "2023-01-10T22:05:28.098Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 7,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "externalLink"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Get Help - Moderna Expert Link",
                                    "label": "Get Help - Moderna Expert ",
                                    "url": "https://report.moderna.convergehealthsafety.com/"
                                }
                            },
                            "country": "[Circular Reference]",
                            "label": "Report an adverse event"
                        }
                    },
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "46fjepI7RrVzgj8ua6WqFv",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:29:45.465Z",
                            "updatedAt": "2024-12-13T22:25:31.150Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 14,
                            "revision": 4,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "contactUsCardComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "FAQ Contact Us Card - US",
                            "headline": "FAQs",
                            "message": {
                                "data": {},
                                "content": [
                                    {
                                        "data": {},
                                        "content": [
                                            {
                                                "data": {},
                                                "marks": [],
                                                "value": "Frequently asked questions about Moderna Direct\n\n",
                                                "nodeType": "text"
                                            }
                                        ],
                                        "nodeType": "paragraph"
                                    }
                                ],
                                "nodeType": "document"
                            },
                            "icon": "[Circular Reference]",
                            "link": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "4sGXFZd1qHOz98lelP3ptv",
                                    "type": "Entry",
                                    "createdAt": "2022-10-25T05:36:49.166Z",
                                    "updatedAt": "2023-09-11T17:49:57.795Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 11,
                                    "revision": 3,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "internalLink"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "FAQs Link",
                                    "label": "Frequently Asked Questions ",
                                    "pageReference": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "16VVyRwgvsqxp7Q0GBqDwl",
                                            "type": "Entry",
                                            "createdAt": "2022-10-26T23:39:27.943Z",
                                            "updatedAt": "2022-10-26T23:39:27.943Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 11,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "page"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "Main FAQ Page",
                                            "title": "Page Title from Compose",
                                            "slug": "faqs",
                                            "seo": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3mfYDCFlr6nPLagdXV7jo8",
                                                    "type": "Entry",
                                                    "createdAt": "2022-10-26T23:39:28.038Z",
                                                    "updatedAt": "2022-10-26T23:39:28.038Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 26,
                                                    "revision": 1,
                                                    "contentType": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "ContentType",
                                                            "id": "seo"
                                                        }
                                                    },
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "name": "Main FAQ Page - Compose: SEO",
                                                    "title": "Frequently Asked Questions Moderna",
                                                    "description": "This page provides answers to frequently asked questions on Moderna Direct",
                                                    "no_index": false,
                                                    "no_follow": false
                                                }
                                            },
                                            "content": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "1c7FRISzjyCWuduGT6H36O",
                                                    "type": "Entry",
                                                    "createdAt": "2022-10-26T23:39:28.060Z",
                                                    "updatedAt": "2022-10-28T13:50:25.044Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 6,
                                                    "revision": 2,
                                                    "contentType": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "ContentType",
                                                            "id": "pageFaqsPageTemplate"
                                                        }
                                                    },
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "name": "Main FAQ Page - FAQs Page Template",
                                                    "faqModules": {
                                                        "metadata": {
                                                            "tags": [],
                                                            "concepts": []
                                                        },
                                                        "sys": {
                                                            "space": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Space",
                                                                    "id": "n9bebhw263o0"
                                                                }
                                                            },
                                                            "id": "55Xgsw7Lb26fvzm4vznbe3",
                                                            "type": "Entry",
                                                            "createdAt": "2022-10-26T23:39:28.125Z",
                                                            "updatedAt": "2023-05-30T19:07:13.038Z",
                                                            "environment": {
                                                                "sys": {
                                                                    "id": "sandbox",
                                                                    "type": "Link",
                                                                    "linkType": "Environment"
                                                                }
                                                            },
                                                            "publishedVersion": 24,
                                                            "revision": 7,
                                                            "contentType": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "ContentType",
                                                                    "id": "faqPage"
                                                                }
                                                            },
                                                            "locale": "en-US"
                                                        },
                                                        "fields": {
                                                            "title": "FAQs Page",
                                                            "banner": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Entry",
                                                                    "id": "7FSPIxBv2f8DUuOYNyjN2f"
                                                                }
                                                            },
                                                            "contactUsCtaComponent": {
                                                                "sys": {
                                                                    "type": "Link",
                                                                    "linkType": "Entry",
                                                                    "id": "6gqCKf6EtK3mI0yNzKHx5h"
                                                                }
                                                            }
                                                        }
                                                    },
                                                    "faqCategoryIcon": "[Circular Reference]"
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "country": "[Circular Reference]",
                            "label": "View Frequently Asked Questions"
                        }
                    },
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "1UNli48LSxpoJIrKw23H1N",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:19:00.121Z",
                            "updatedAt": "2023-09-28T16:53:26.696Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 28,
                            "revision": 5,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "contactUsFormComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "Contact Us Form Component",
                            "headline": "Ask a Question or Request to be Contacted",
                            "message": {
                                "nodeType": "document",
                                "data": {},
                                "content": [
                                    {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                            {
                                                "nodeType": "text",
                                                "value": "Enter your contact details and select how we can help you.",
                                                "marks": [],
                                                "data": {}
                                            }
                                        ]
                                    }
                                ]
                            },
                            "fullNameLabel": "Full Name",
                            "fullNamePlaceholder": "Enter full name",
                            "emailLabel": "Email",
                            "emailPlaceholder": "Enter email",
                            "phoneLabel": "Phone",
                            "phonePlaceholder": "Enter phone",
                            "organizationLabel": "Organization",
                            "organizationPlaceholder": "Enter organization",
                            "preferredMethodLabel": "Preferred method of contact",
                            "preferredMethodList": [
                                "Email",
                                "Phone"
                            ],
                            "supportCategoryLabel": "What can we help you with?",
                            "supportCategoryList": [
                                "Contract and Billing",
                                "Order Assistance",
                                "Product Inquiry",
                                "Account Information",
                                "General Inquiry",
                                "Other"
                            ],
                            "consentMessageLabel": "I consent to the Moderna",
                            "consentLink": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "556dZCOMwLIKu69guk6x42",
                                    "type": "Entry",
                                    "createdAt": "2022-12-02T04:18:56.045Z",
                                    "updatedAt": "2022-12-02T04:18:56.045Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 6,
                                    "revision": 1,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "internalLink"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Privacy Policy Internal Link",
                                    "label": "Privacy Policy",
                                    "pageReference": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "EW4a3Hd56gtuvG9WpsS3Z",
                                            "type": "Entry",
                                            "createdAt": "2022-12-02T04:18:46.677Z",
                                            "updatedAt": "2022-12-02T04:18:46.677Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 10,
                                            "revision": 1,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "page"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "Privacy Policy",
                                            "title": "Moderna Direct Privacy Policy",
                                            "slug": "privacy-policy",
                                            "seo": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "5wVt4P86v56AQIbQiW4uqD",
                                                    "type": "Entry",
                                                    "createdAt": "2022-12-02T04:18:46.768Z",
                                                    "updatedAt": "2022-12-02T04:18:46.768Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 4,
                                                    "revision": 1,
                                                    "contentType": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "ContentType",
                                                            "id": "seo"
                                                        }
                                                    },
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "name": "Privacy Policy - Compose: SEO"
                                                }
                                            },
                                            "content": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3LQ4u17dvJworzbcVeWMD",
                                                    "type": "Entry",
                                                    "createdAt": "2022-12-02T04:18:46.882Z",
                                                    "updatedAt": "2023-06-20T16:20:31.348Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 14,
                                                    "revision": 4,
                                                    "contentType": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "ContentType",
                                                            "id": "richTextContentPageTemplate"
                                                        }
                                                    },
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "name": "Privacy Policy - Rich Text Content Page Template",
                                                    "modules": [
                                                        {
                                                            "metadata": {
                                                                "tags": [],
                                                                "concepts": []
                                                            },
                                                            "sys": {
                                                                "space": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Space",
                                                                        "id": "n9bebhw263o0"
                                                                    }
                                                                },
                                                                "id": "4qpojknXqxo8gNLhMxZz5K",
                                                                "type": "Entry",
                                                                "createdAt": "2022-12-11T23:10:53.907Z",
                                                                "updatedAt": "2023-06-16T18:23:32.364Z",
                                                                "environment": {
                                                                    "sys": {
                                                                        "id": "sandbox",
                                                                        "type": "Link",
                                                                        "linkType": "Environment"
                                                                    }
                                                                },
                                                                "publishedVersion": 7,
                                                                "revision": 2,
                                                                "contentType": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "ContentType",
                                                                        "id": "bannerComponent"
                                                                    }
                                                                },
                                                                "locale": "en-US"
                                                            },
                                                            "fields": {
                                                                "title": "Privacy Statement Banner Component",
                                                                "headline": "Moderna's Privacy Statement",
                                                                "backgroundImage": "[Circular Reference]",
                                                                "country": "[Circular Reference]"
                                                            }
                                                        },
                                                        {
                                                            "metadata": {
                                                                "tags": [],
                                                                "concepts": []
                                                            },
                                                            "sys": {
                                                                "space": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Space",
                                                                        "id": "n9bebhw263o0"
                                                                    }
                                                                },
                                                                "id": "3OFyHSrhG9cqdAH1JtdQcK",
                                                                "type": "Entry",
                                                                "createdAt": "2023-06-16T18:25:11.324Z",
                                                                "updatedAt": "2023-06-16T18:25:11.324Z",
                                                                "environment": {
                                                                    "sys": {
                                                                        "id": "sandbox",
                                                                        "type": "Link",
                                                                        "linkType": "Environment"
                                                                    }
                                                                },
                                                                "publishedVersion": 3,
                                                                "revision": 1,
                                                                "contentType": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "ContentType",
                                                                        "id": "bannerComponent"
                                                                    }
                                                                },
                                                                "locale": "en-US"
                                                            },
                                                            "fields": {
                                                                "title": "Privacy Statement Banner Component - DE",
                                                                "headline": "Moderna's Privacy Statement",
                                                                "backgroundImage": "[Circular Reference]",
                                                                "country": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Entry",
                                                                        "id": "7DX7badGk41XRSy4znPNFI"
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "metadata": {
                                                                "tags": [],
                                                                "concepts": []
                                                            },
                                                            "sys": {
                                                                "space": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Space",
                                                                        "id": "n9bebhw263o0"
                                                                    }
                                                                },
                                                                "id": "I5IZLNooED1CgxC5Kpr9Z",
                                                                "type": "Entry",
                                                                "createdAt": "2022-12-11T01:44:45.550Z",
                                                                "updatedAt": "2024-07-10T14:10:03.932Z",
                                                                "environment": {
                                                                    "sys": {
                                                                        "id": "sandbox",
                                                                        "type": "Link",
                                                                        "linkType": "Environment"
                                                                    }
                                                                },
                                                                "publishedVersion": 386,
                                                                "revision": 22,
                                                                "contentType": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "ContentType",
                                                                        "id": "richTextContentComponent"
                                                                    }
                                                                },
                                                                "locale": "en-US"
                                                            },
                                                            "fields": {
                                                                "title": "Privacy Policy Rich Text Content Component - US",
                                                                "effectiveDateLabel": "Effective",
                                                                "effectiveDate": "2023-09-01",
                                                                "content": {
                                                                    "nodeType": "document",
                                                                    "data": {},
                                                                    "content": [
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "This Privacy Statement describes how Moderna Inc. and its worldwide affiliates (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D) describes how Moderna collects, stores, uses (\u201Cprocesses) your personal data when you:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "use our website ",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "hyperlink",
                                                                                                    "data": {
                                                                                                        "uri": "https://www.modernatx.com/"
                                                                                                    },
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "text",
                                                                                                            "value": "www.modernatx.com",
                                                                                                            "marks": [],
                                                                                                            "data": {}
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": " or any other Moderna website that links to this statement;",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "use any of our other digital services, such as an app provided by Moderna, that link or use this statement; or",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "engage with us through our call centers.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Personal Data\u201D ",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "means information associated with or used to directly or indirectly identify or contact a specific person. Such data can include your name, contact details, relationship with Moderna, etc.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Certain Personal Data, such as information about health or medical status (pursuant to all applicable laws) are characterized as sensitive (collectively, \u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Sensitive Personal Data",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201D) and may be subject to stricter regulation and consent requirements than other information.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna recognizes the importance of taking steps to protect the privacy of information we collect, and we are committed to respecting your privacy.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Carefully read this Privacy Statement to learn more about how we collect, use, disclose and store personal data provided and the steps we take to help protect the often-sensitive personal data provided from unauthorized use or disclosure. When you submit information to or through our sites or services, you consent to the collection, processing and retention of your information as described in this Privacy Statement.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY STATEMENT, THEN PLEASE DO NOT USE ANY OF THESE SERVICES.",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Summary of Key Points",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "This summary provides key points from our Privacy Statement, but you can find more information about any of these topics by using the Table of Contents below. ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "1. How do we process your personal data?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We process your personal data to provide you with the service requested and to improve our service, communicate with you for security purposes and comply with legal obligations. We only process your personal data when we have legal grounds to do so. Please see ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-4-how-we-use-personal-data"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "How We Use Your Personal Data",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " for more details.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "2. Do we process sensitive personal data?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may process sensitive personal data when necessary, with your consent or where required by legal obligations. Click ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-1"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "here",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " to learn more about Sensitive Personal Data.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "3. Where will your data be processed by Moderna?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna is a global company which maintains datacenters around the world, including Switzerland and the United States (ModernaTX\u2019s global headquarters). Moderna may process personal data in databases that can be accessed by authorized Moderna personnel worldwide.Transfers of personal data among Moderna and its worldwide affiliates follow applicable laws and our Intracompany Transfer Agreements.Third-party transfers outside of the EU, the EEA, Switzerland or the UK are made in accordance with applicable privacy laws and pursuant to the following safeguard, Standard Contractual Clauses (SCCs) or Model Contracts.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "For information on SCCs, please visit:",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "nodeType": "unordered-list",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "list-item",
                                                                                                    "data": {},
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "If in EU:",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "hyperlink",
                                                                                                                    "data": {
                                                                                                                        "uri": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm"
                                                                                                                    },
                                                                                                                    "content": [
                                                                                                                        {
                                                                                                                            "nodeType": "text",
                                                                                                                            "value": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm",
                                                                                                                            "marks": [],
                                                                                                                            "data": {}
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "list-item",
                                                                                                    "data": {},
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "If in Switzerland:",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "hyperlink",
                                                                                                                    "data": {
                                                                                                                        "uri": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647"
                                                                                                                    },
                                                                                                                    "content": [
                                                                                                                        {
                                                                                                                            "nodeType": "text",
                                                                                                                            "value": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647",
                                                                                                                            "marks": [],
                                                                                                                            "data": {}
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "list-item",
                                                                                                    "data": {},
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "If In UK:",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "nodeType": "paragraph",
                                                                                                            "data": {},
                                                                                                            "content": [
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "hyperlink",
                                                                                                                    "data": {
                                                                                                                        "uri": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit"
                                                                                                                    },
                                                                                                                    "content": [
                                                                                                                        {
                                                                                                                            "nodeType": "text",
                                                                                                                            "value": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit",
                                                                                                                            "marks": [],
                                                                                                                            "data": {}
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "nodeType": "text",
                                                                                                                    "value": "",
                                                                                                                    "marks": [],
                                                                                                                    "data": {}
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "4. When and with who do we share your data?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We only will share your data with services providers who support our operations and other parties and business partners in limited circumstances based on legal obligations and as identified in our Privacy Notices.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "5. How do we keep your data protected?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We have technical and organizational safeguards in place to protect your personal data. However, no electronic processing can be guaranteed to be 100% secure, so we cannot promise that hackers, cybercriminals or other unauthorized third parties will not be able to defeat our security and steal or unauthorized access your personal data. Click ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-6-how-information-is-retained-and-secured"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "here",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " to learn more.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "6. What are your rights and how can you exercise them?",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Based on your location, applicable personal data protection laws provide you with certain rights regarding your personal data. You may exercise these rights by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [
                                                                                                {
                                                                                                    "type": "bold"
                                                                                                }
                                                                                            ],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Please note that this Privacy Statement does not apply to information collected through third-party websites or services that you may access through third-party sites.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Data Controller:",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " The controller of Personal Data collected under this Privacy Statement is ModernaTX, Inc.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "This statement is organized into the following sections \u2013 please select your desired topic for further information.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Principles",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We will handle your Personal Data in accordance with applicable laws such as the General Data Protection Regulation (\u201CGDPR\u201D) in the European Union, the Act on the Protection of Personal data of Japan and the Personal data Act of South Korea. It is our goal to do the following:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Process Personal Data lawfully, fairly and in a transparent manner.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Collect Personal Data for a specified, explicit and legitimate purpose, and only use it for the purposes for which it was originally collected.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Limit collection of Personal Data to the extent necessary in relation to the purpose for which it is processed.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Make reasonable efforts to ensure that your Personal Data is accurate and, where necessary, kept up to date.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Store Personal Data for no longer than is necessary for the purpose for which the Personal Data is processed.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Process Personal Data in a manner that provides adequate security and confidentiality.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Our privacy practices are described in greater detail in the remainder of this Privacy Statement.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Table of Contents",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "1. Information We Collect\n2. How Information is Collected and Used\n3. Links to Other Websites/Services\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "4. ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How We Use Personal Data\n5. How Information is Shared and Disclosed\n6. How Information is Retained and Secured\n7. Cookies and Similar Technologies\n8. Your Privacy Rights\n9. Our Children\u2019s Policy\n10. Changes to This Privacy Statement\n11. Jurisdiction-Specific Privacy Information (",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "California, Nevada, EU/EEA, UK & Switzerland, Japan)",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "1. Information We Collect",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Depending on your interactions with us, we may collect and process your Personal Data. For example, you may choose to submit your contact information to join our mailing list, engage with us via our Contact Us features, or apply for a job opening with Moderna via the ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/careers/life-at-moderna"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "careers",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " section of our website. As a result, and depending on the type of Service, we may ask you to provide Personal Data, such as your:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "General identification data",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ": initials, name, job title, company name, country, date of birth, age, country, ethnicity (",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "for cases where the Summary of Product Characteristics (SmPC) includes specific information relating to the ethnic origin",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ")",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Contact details",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ": contact number, e-mail address, mailing address",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Product use",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ": data related to your use of our products, including feedback and use history",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Professional details (for HCPs)",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ": job title, institute/organization name, additional information about your job role and any other job-related information",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Technical data",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ": IP address, device identifiers, operating system, browsing history, search history, time and duration of use, interaction with content",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Information about your job role",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": " and any other job-related information, work experience, educational background",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Before providing it to us, carefully consider whether to disclose your Sensitive Personal Data. If you do provide Sensitive Personal Data to us, you consent to its use and disclosure for the purposes and in the manner described in this Privacy Statement.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You may visit our website without voluntarily providing any information about yourself. You are not obligated to provide any Personal Data to us, but your ability to use our website or its features, apply for an employment position or report an adverse event may be limited. When calling our call centers, you can choose to remain anonymous unless the collection of personal data is required by law or you provide us with your personal data.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you provide us with Personal Data about another person or allow us to collect it, you acknowledge that you have the authority to share that information and are allowing us to use the information as described in this Privacy Statement.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Ordering and Payment Information for Pharmacies and Healthcare Professionals",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When pharmacies and healthcare professionals place orders for our products and services, we collect and use necessary information to process these transactions. This includes, but is not limited to, payment details (such as credit card numbers and billing addresses), order information, and contact details of the ordering party. This information is used solely for the purposes of fulfilling orders, processing payments, and providing customer support. We are committed to protecting this data in compliance with all relevant privacy and data protection regulations and ensuring that it is handled securely and confidentially.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "2. How Information is Collected and Used",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "a. Information that you voluntarily provide",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We collect and use the Personal Data that you voluntarily provide to us by visiting our sites or using our services. You may use certain services without registering or identifying yourself but, if you do not register, you may not have access to all of the services or functionality of the site. If you choose to register, we may use the Personal Data you provide to confirm your registration and to respond to requests from you.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Upon your request, we may also use your Personal Data to send you special promotions or newsletters with information that may interest you.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you are a healthcare professional or an institutional healthcare provider, you are responsible for obtaining any legally required authorization, consent or other permission from your patients prior to providing their Personal Data to Moderna. By submitting any Personal Data about a patient, you represent and warrant to Moderna that you have obtained all required permissions to do so.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "b. Through your use of interactive services",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you choose to participate in our questionnaires and surveys and other interactive services, we will collect the information, including health-related information and other Sensitive Personal Data that you share to help us better understand how Moderna products are used in coping with the diseases for which they are marketed.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "c. When you\u2019re interested in enrolling in a clinical trial",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you submit health-related Personal Data to us to participate in a clinical trial, we may use your Personal Data to assess whether you qualify for enrollment in the trial, to contact you about potential participation in the trial, and to provide you with additional information about the trial.Once enrolled for any questions relating to your participation in a clinical trial, contact the Principal Investigator on the study and/or refer to the trail related information provided to you, e.g., the Informed Consent Form.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "d. When you correspond with Moderna about Moderna products.",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you contact Moderna or use the Services to ask questions or report problems regarding your experience in using one of our products, we may use the information you provide in submitting reports to the U.S. Food and Drug Administration, the European Medicines Agency or any other relevant supervisory authority and as otherwise required of us by law. We also may use the information to contact the prescribing physician to follow up regarding an event involving use of our product.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "e. Through data collection tools",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": 'When permitted or you have provided consent, Moderna automatically will collect information about use of the Services through data collection tools, such as web beacons and cookies. A "web beacon" is a piece of code that enables us to monitor user activity and website traffic. A "cookie" is a randomly generated unique numeric code stored in the user\u2019s web browser settings or computer\u2019s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the \u201Clifetime\u201D of the cookie (i.e., when it expires), as well as the randomly generated unique numeric code.',
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "For more details, please see ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/cookie-statement"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Moderna\u2019s Cookie Statement",
                                                                                            "marks": [
                                                                                                {
                                                                                                    "type": "italic"
                                                                                                }
                                                                                            ],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We use the information collected through data collection tools to monitor usage patterns, store information about user preferences and to improve the Services. For example, your Personal Data may be used to create customized offers, information and services tailored to your interests and preferences. We may track your activities over time and across third-party websites, apps or other online services to display advertisements on third-party websites. If you do not want us to use your information in this way, please see \u201CYour Privacy Choices\u201D below.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We also may collect information about the location of the mobile device or tablet used to access the Services (\u201CLocation Data\u201D). Location Data includes: (i) the location of the mobile device or tablet derived from GPS or WiFi use; (ii) the IP address of the mobile device or tablet or internet service used to access the Services; and (iii) other information made available by a user or others that indicates the current or prior location of the user, such as geotag information in photographs.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "f. Social media connections",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When accessing the Services through a Facebook or other Social Media account, Moderna may (depending on applicable user privacy settings) automatically have access to information provided to or through the Social Media platform. Moderna may collect and use this information for the purposes described in this Privacy Statement or at the time the information was collected.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "g. Social media plugins",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When you use services, Social Media operators can place a cookie on your computer to recognize individuals who have visited previously. If you are logged into a Social Media account while using the services, the social plugins allow that Social Media to receive information that you have accessed and used the Services. The social plugins also allow the Social Media operator to share information about your activities in or through the Services with other Social Media users. Moderna does not control any of the content from the Social Media plugins. For more information about Social Media plugins, please refer to any privacy and/or other legal notices of the respective Social Media platform.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "h. Through third parties",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Third parties that assist us with our business operations also collect and use information (including Personal Data and Usage Data) and may share the collected information with us. For example, our vendors collect and share information with us to improve user experience, we may view your LinkedIn profile, or any other publicly available profile.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When you access any interactive service, you will be asked to affirmatively choose (\"opt in\") to provide the requested information. You may always choose not to provide the requested information but then you may not be able to use the Service as intended.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "3. Links to Other Websites/Services",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "As a convenience to our visitors, this website may contain links to other websites that we believe may offer useful information, but that does not mean that Moderna endorses it, or the quality or accuracy of information presented on it. If you decide to visit a third-party site, you are subject to its privacy practices and not this Privacy Statement.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "4. How We Use Personal Data",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may use Personal Data for the following purposes.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "a. Consent",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may seek, either directly or through our trusted third parties, your separate consent to process your Personal Data, for example, to:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "provide you with information you requested and/or to respond to your inquiries submitted via the website, email and/or phone,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "facilitate certain recruitment activities such as processing employment applications,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "analyze and enhance our communications and strategies (including by identifying when emails sent to you have been received and read),",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "tailor the content we display on our website,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If we have sought your consent to process your Personal Data, you may subsequently withdraw it at any time by contacting us at the address listed in the \u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-8-your-privacy-rights"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Your Privacy Rights",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201D section below.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "b. Legal obligation",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We may be required by law or regulation to collect and process certain Personal Data about you. For example, we may be required to process certain Personal Data in relation to reporting of adverse events.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "monitor the quality, safety and efficacy of our medicinal products, which includes detecting, assessing and preventing adverse events and reporting to the relevant health authorities to meet legal and regulatory obligations,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Adverse events refer to the unintended or undesirable events after using a medicinal product. They can be minor at times, or they can also involve serious health issues.Moderna processes your Personal Data to comply with legal obligations under applicable pharmacovigilance laws and regulations worldwide and where necessary for our legitimate interests in ensuring appropriate pharmacovigilance standards.Pharmacovigilance laws are issued for reasons of substantial public interest in public health, research as well as quality, safety, and efficacy of medicinal products.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "c. Public interest",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may also process Personal Data to carry out scientific research in the public interest.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "d. Our legitimate interests",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may process your Personal Data where it is necessary for our legitimate interest as a company, including to manage, promote and improve our business and manage our risk. For example, we may process your Personal Data to:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "facilitate our recruitment activities (such as evaluating you as a job candidate for an employment activity, and monitoring our recruitment statistics),",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "tailor the content we display on our website,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "help us comply with our legal or regulatory obligations or our contractual obligations to the U.S. government as a government contractor or other countries as applicable,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "maintain the security, safety or property of the website, and",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "5. How Information is Shared and Disclosed",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may share and disclose information as described at the time information is collected and as described below:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "a. Service providers",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may use third parties to perform services requested or functions initiated by users. In addition, we may disclose Personal Data to identify a user in connection with communications sent through our sites or services. We may also share information, including Personal Data, with our service providers to perform the functions for which we engage them, such as data analysis, system design and maintenance, customer services and for marketing and promotions. When permitted, we also may offer users the opportunity to share information with friends and other users through the Services.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "b. Legal requirements",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "In certain circumstances, Moderna may release your Personal Data in response to a court order, subpoena, search warrant, regulation, binding order of a data protection agency, governmental request or other legal or regulatory process. Moderna may disclose information if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Moderna or others.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "c. Corporate changes",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may transfer information, including your Personal data, in connection with a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy or other change of ownership or control by Moderna or any affiliated company (in each case, whether in whole or in part). When one of these events occurs, Moderna will use reasonable efforts to notify users before information is transferred or becomes subject to different privacy practices.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "d. Adverse Event reporting by patients",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may disclose your Personal Data to HCPs, doctors, care givers, in connection with your adverse event report based on your consent or a legal obligation.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "6. How Information is Retained and Secured",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We retain information as long as it is necessary and relevant for our operations and in line with legal obligations. We retain Personal Data to comply with applicable law, prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted by law. When your Personal Data is no longer needed for Moderna\u2019s business purposes, we dispose of it subject to applicable law.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "In accordance with applicable laws, we employ reasonable security measures intended to help protect the security of all information submitted through the Services. The security of information transmitted through the internet cannot, however, be guaranteed. We are not responsible for any interception or interruption of any communications or for changes to or losses of data through the internet. Users of our sites and services are responsible for maintaining the security of any password, user ID or other form of authentication involved in obtaining access to password protected or secure areas. Any access to our sites or services through your user ID and password will be treated as authorized by you.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "To help protect your Personal Data, we may suspend your use, without notice, if Moderna suspects or detects any breach of security. Unauthorized access to such areas is prohibited and may lead to criminal prosecution.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "7. Cookies and Similar Technologies",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna\u2019s websites may use cookies and similar technologies. Please click here to read ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/cookie-statement"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Moderna\u2019s Cookie Statement",
                                                                                            "marks": [
                                                                                                {
                                                                                                    "type": "italic"
                                                                                                }
                                                                                            ],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "8. Your Privacy Rights",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna respects your rights related to the processing of your personal data. Depending on the applicable Data Protection Law you may have certain additional rights (see country-specific section below) and you will always have the below rights. You may exercise them by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "a. Correct/update personal data",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You may correct or update the Personal data you previously provided to Moderna.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "b. Receive marketing communications",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When you register for the services, you may request to receive emails containing information about Moderna you might find useful, including promotions, announcements of new services and products. If you decide, at any time, that you no longer wish to receive these emails you may unsubscribe from our email list by using the relevant \u201CUnsubscribe\u201D link within the respective electronic communications channel, or by contacting us at ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "IMPORTANT NOTE: Moderna cannot comply with a consumer's request to amend or remove information that was provided to Moderna by a healthcare professional or a consumer regarding an adverse drug event due to legal obligations.",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "9. Our Children\u2019s Policy",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Our sites are not intended for use by children. If you are under the age of majority in your place of residence, you may visit our site only with the consent of or under the supervision of your parent or legal guardian.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you believe Moderna may have any information from or about a child, please contact our Privacy Office at ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "10. Changes to This Privacy Statement",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may change or update this Privacy Statement from time to time by publishing a new version on this website. When we do update this Statement, we will revise the \u201CLast Updated\u201D date at the top of this page. Your continued use of the services after the Effective Date constitutes your acceptance of the amended Privacy Statement. The amended Privacy Statement supersedes all previous versions.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "11. Jurisdiction-Specific Privacy Information",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "California",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Privacy Rights",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you are a California resident under age 18 and are a registered user of any of our services, then you may request that we remove any of your User Contributions you publicly posted on or in our services. ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "To request removal of your User Contribution, please visit our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " (You also may be able to log in to your account and delete your own User Contribution.) Moderna reserves the right to request that you provide information that will enable us to confirm that the User Contribution that you want removed was created and posted by you.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna will make a good faith effort to delete or remove your User Contribution from public view as soon as reasonably practicable. Please note, however, that your request that we delete your User Contribution does not ensure complete or comprehensive removal of your User Contribution. Your User Contribution may remain on backup media, cached or otherwise retained by Moderna for administrative or legal purposes, or your User Contribution may remain publicly available if you or someone else has forwarded or re-posted your User Contribution on another website or service prior to its deletion. Moderna may also be required by law to not remove (or allow removal) of your User Contribution.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "California Civil Code Section 1798.83 permits individual California residents to request certain information regarding Moderna\u2019s disclosure of personal data to third parties for their direct marketing purposes. To make such a request, please write or send an email to the address below.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "California Consumer Privacy Act - Notice for California Residents",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you are a California resident, this Privacy Notice supplements the information above regarding the collection, use, and disclosure of your personal data. ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "The California Consumer Privacy Act of 2018 (CCPA) gives California consumers the right to know what personal data is collected about them, how it will be used and to whom it is disclosed. California consumers may have the right to request access to and deletion of their personal data, and the right to request that their personal data not be sold to the extent applicable under the CCPA.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "The purpose of this notice is to describe our practices regarding the collection, use, disclosure, and sale of personal data and instructions for submitting CCPA data privacy requests. Some of the Personal Data that we collect, use, and disclose may be exempt from the CCPA because it is regulated by other federal and state laws that apply to us.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We collect personal data from you when you interact with us online (through our Site, our other websites, Apps and Services) or offline (such as through your health care providers, if you are a patient, with your authorization as applicable.) The personal data we may collect from you will depend on the nature of our interaction with you, but can include the following categories that we have collected in the preceding twelve (12) months:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "embedded-asset-block",
                                                                            "data": {
                                                                                "target": {
                                                                                    "metadata": {
                                                                                        "tags": [],
                                                                                        "concepts": []
                                                                                    },
                                                                                    "sys": {
                                                                                        "space": {
                                                                                            "sys": {
                                                                                                "type": "Link",
                                                                                                "linkType": "Space",
                                                                                                "id": "n9bebhw263o0"
                                                                                            }
                                                                                        },
                                                                                        "id": "1vo5ULs91JROZ8CfAyGcpI",
                                                                                        "type": "Asset",
                                                                                        "createdAt": "2024-07-10T13:58:26.978Z",
                                                                                        "updatedAt": "2024-07-10T13:58:26.978Z",
                                                                                        "environment": {
                                                                                            "sys": {
                                                                                                "id": "sandbox",
                                                                                                "type": "Link",
                                                                                                "linkType": "Environment"
                                                                                            }
                                                                                        },
                                                                                        "publishedVersion": 5,
                                                                                        "revision": 1,
                                                                                        "locale": "en-US"
                                                                                    },
                                                                                    "fields": {
                                                                                        "title": "Privacy Policy - Personal Data ",
                                                                                        "description": "",
                                                                                        "file": {
                                                                                            "url": (0, (/*@__PURE__*/$parcel$interopDefault($d377b224e2aae122$exports))),
                                                                                            "details": {
                                                                                                "size": 642894,
                                                                                                "image": {
                                                                                                    "width": 1174,
                                                                                                    "height": 2046
                                                                                                }
                                                                                            },
                                                                                            "fileName": "image (4).png",
                                                                                            "contentType": "image/png"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            "content": []
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Your Rights",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "California residents are provided specific rights subject to certain exceptions.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "The Right to Know. ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "You have the right to request that we disclose what personal data we collect, use, disclose, and sell. The process for exercising this right is describe below under How to Submit a Data Privacy Request.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "The Right to Deletion. ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "You have the right to request deletion of any personal data about you that we have collected from you. The process for exercising this right is describe below under How to Submit a Data Privacy Request",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "The Right to Opt-Out. ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "You have the right to opt-out of the sale of your personal data.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "The Right to Non-Discrimination. ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "You have the right not to be discriminated against for exercising your rights.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How to Submit a Data Privacy Request",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You may exercise your Right to Know and Right to Deletion by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " or calling (844) 971-2551.To process your request for access or deletion, we must be able to verify your identity to a reasonable degree of certainty. We will ask you to provide your contact information and additional identifiers based on your relationship with us.You may designate an authorized agent to make a request to access, delete, or opt-out of the sale of your information on your behalf. When you use an authorized agent to submit a request for access or deletion, you must provide the authorized agent with written permission to do so, and, in certain circumstances, we may ask you to verify your own identity directly with us. We may deny a request from an authorized agent that does not submit proof that they have been authorized by you to act on your behalf.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Right to Know:",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Please note that we may not be required to provide you access to the specific pieces of information we have collected about you or delete information if we are unable to verify your identity.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Right to Delete:",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We may not be required to delete information under certain circumstances. Specifically, the CCPA includes exemptions that provide that we do not have to delete data that, for example, is necessary to comply with legal obligations including those pertaining to the quality, safety or effectiveness of a product or activity regulated by the Food and Drug Administration (FDA), complete a transaction, detect security incidents, or for certain other internal purposes.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Sale or Disclosure of Personal data: ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "The CCPA defines \u201Csale\u201D broadly to include sharing, transferring, disclosing or otherwise communicating personal data with a third party for monetary or other valuable consideration. We share personal data with service providers who work on our behalf and agree not to use or sell your personal data for other purposes or if you have intentionally directed us to share information with a third party. In addition, with your approval, we share certain internet tracking data, including cookies and the IP address used to access our websites.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Notice of Financial Incentive:",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Moderna does not offer financial incentives in exchange for the collection or sale of personal data. However, we do provide discounts and incentives to individuals who use our products and services and enroll in incentive programs that we offer from time to time; enrolling in these programs requires you to provide certain of your personal data so that we may administer the programs and, in some cases, provide marketing and advertising to you. Under CCPA, this could be considered an offer of a \u201Cfinancial incentive\u201D and so we provide this notice to you to describe our practice and to provide a good faith estimate of the value of your personal data that we may collect related to the programs.\n\nIn the normal course of our business, we do not assign monetary or other value to personal data, but in accordance with CCPA, we make a good faith estimate that the value of the personal data collected and used is equivalent to the value of the discount or financial incentive we provide in these programs. To make this good faith estimate, we may consider among other factors, the (i) categories of personal data collected, (ii) the discount or incentive offered, (iii) the sales or use of our products and services by those who enroll versus those who do not, and (iv) the cost and expenses we incur in offering the programs.\n\nThe incentive programs require you to opt-in to participate as set forth on the page where you can enroll or opt-in to the programs. You can opt-out either by contacting us at the information set forth below, or by following the terms and conditions provided when you are enrolling in the program. While we will not discriminate against you for exercising your rights under CCPA, if you request deletion of your personal data, we may not be able to delete such information if it is necessary to administer the incentive or discount you requested and still provide you such incentive or discount.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Personal data Collected from Employees, Contractors, Applicants, and Health Care Providers",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Employees ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "\u2013 If you are an Moderna employee and would like more information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please contact us at",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "hyperlink",
                                                                                                    "data": {
                                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                                    },
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "text",
                                                                                                            "value": "privacy@modernatx.com",
                                                                                                            "marks": [],
                                                                                                            "data": {}
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ".",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Contractors ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "\u2013 If you are a contractor performing services for Moderna and would like information about the categories of personal data we collect from you as a contractor and the purpose for which the personal data will be used, please visit our ",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "hyperlink",
                                                                                                    "data": {
                                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                                    },
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "text",
                                                                                                            "value": "request web page",
                                                                                                            "marks": [],
                                                                                                            "data": {}
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ".",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Job Applicants",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": " \u2013 If you are applying for a position with Moderna and would like information about the categories of personal data Moderna collects from you as a job applicant and the purposes for which the personal data, please view our Privacy Statement",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Health Care Providers \u2013 ",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "italic"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "If you are a health care provider with whom we have a contractual arrangement and would like information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please visit our ",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "hyperlink",
                                                                                                    "data": {
                                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                                    },
                                                                                                    "content": [
                                                                                                        {
                                                                                                            "nodeType": "text",
                                                                                                            "value": "request web page",
                                                                                                            "marks": [],
                                                                                                            "data": {}
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ".",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Children\u2019s Online Privacy Protection Act (COPPA)",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Consistent (COPPA), if we learn that a child under age 13 has provided Personal Data to or through the site without first receiving his or her parent\u2019s verified consent, we will use that information only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use the services and subsequently we will dispose of such Personal Data in accordance with this Privacy Statement.California residents who are unable to review or access this CCPA Notice due to a disability may contact us to request access this CCPA Notice in an alternative format. Please call 1-844- 971-2551 or email us at ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Nevada",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Nevada Residents As Covered by Nevada Privacy Law\nModerna does not sell Covered Information as defined under Nevada law. If you would like to make a further inquiry regarding the selling of your Covered Information, as defined under Nevada law, visit our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "EU/EEA, UK & Switzerland",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna\u2019s processing of your personal data is based on any one of the following legal grounds: (A) legitimate business purposes, (B) where you have provided consent, (C) as necessary to comply with Moderna\u2019s legal and regulatory obligations and (D) as necessary to perform a contract under which you have been engaged.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "embedded-asset-block",
                                                                            "data": {
                                                                                "target": {
                                                                                    "metadata": {
                                                                                        "tags": [],
                                                                                        "concepts": []
                                                                                    },
                                                                                    "sys": {
                                                                                        "space": {
                                                                                            "sys": {
                                                                                                "type": "Link",
                                                                                                "linkType": "Space",
                                                                                                "id": "n9bebhw263o0"
                                                                                            }
                                                                                        },
                                                                                        "id": "3dlAOZ38IdeTNBy7LRHGVL",
                                                                                        "type": "Asset",
                                                                                        "createdAt": "2024-07-10T13:57:28.572Z",
                                                                                        "updatedAt": "2024-07-10T13:57:28.572Z",
                                                                                        "environment": {
                                                                                            "sys": {
                                                                                                "id": "sandbox",
                                                                                                "type": "Link",
                                                                                                "linkType": "Environment"
                                                                                            }
                                                                                        },
                                                                                        "publishedVersion": 5,
                                                                                        "revision": 1,
                                                                                        "locale": "en-US"
                                                                                    },
                                                                                    "fields": {
                                                                                        "title": "Privacy Policy EU/EEA, UK & Switzerland ",
                                                                                        "description": "",
                                                                                        "file": {
                                                                                            "url": (0, (/*@__PURE__*/$parcel$interopDefault($7ef523aae5638415$exports))),
                                                                                            "details": {
                                                                                                "size": 154682,
                                                                                                "image": {
                                                                                                    "width": 480,
                                                                                                    "height": 379
                                                                                                }
                                                                                            },
                                                                                            "fileName": "image (3).png",
                                                                                            "contentType": "image/png"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            "content": []
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How can you access, correct or delete the personal data about you that we process? You have a right to request to access, correct/update or delete your personal data (including your health information). You may make such a request at any time, by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ". We will provide you with access to the information we hold about you, correct/update, and or delete that information that was provided to us by a Healthcare Professional or a consumer regarding an adverse drug event.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "It is not technologically possible to remove from our servers each and every record of your information. The need to back-up our systems to protect information from inadvertent loss means that a copy of information about you (including your health-related interests) may exist in a non-erasable form that will be difficult or impossible for us to locate.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Nevertheless, when permitted by law, Moderna will delete your personal data (including health information) stored in the databases Moderna actively uses for research and daily business activities or stored in other readily searchable media. In addition, we will use reasonable efforts not to disclose any personal data stored in a non-erasable format after receiving your request for removal, except as required by law.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How can you exercise the right to data portability? According to the right to data portability, you have the right to request that your personal data provided to Moderna be delivered to you in a structured, commonly used and machine-readable format, subject to certain conditions and can be requested by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Make a Privacy Complaint with the ICO (UK). If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Information Commissioner\u2019s Office (ICO) at: ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://ico.org.uk/make-a-complaint/"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "https://ico.org.uk/make-a-complaint/",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Make a Privacy Complaint with the Federal Data Protection Commissioner of Switzerland. If you feel Moderna\u2019s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Federal Data Protection Commissioner at: ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.edoeb.admin.ch/edoeb/en/home.html"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "https://www.edoeb.admin.ch/edoeb/en/home.html",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How We Manage Disclosure of Transfers of Value",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        },
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna collects data about the transfers of value that you have received from us so that we can comply with our obligations under the IPHA Code, specifically that companies must document and publicly disclose annually certain transfers of value made directly or indirectly to health professionals and other relevant decision makers located in Europe.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna recognizes the legitimate public interest in better understanding the financial relationships that healthcare professionals have with the pharmaceutical industry for the purposes of transparency and trust in the pharmaceutical industry.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "The law requires us to inform you of the legal basis for collecting and processing your personal data where Moderna is the data controller. Where Moderna processes data relating to transfers of value made to you, Moderna relies on the legal basis of legitimate interests to process that data. Moderna\u2019s compliance with the IPHA Code and these further objectives cannot be met without processing personal data about you and the transfers of value that you have received from us. We have carried out a Legitimate Interests Assessment and consider that this processing is necessary, proportionate and without unjustified harm to you.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you do not agree to the disclosure of data relating to transfers of value made to you by Moderna, you can raise an objection via ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Japan",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "In accordance with the Act on Protection of Personal Information of Japan (APPI) and other applicable laws and regulations, Moderna will disclose the personal data that Moderna holds about you according to the applicable procedures. In addition, if you inform Moderna that your personal data is inaccurate, Moderna will review and correct, add or delete the data as required in accordance with applicable laws, regulations and procedures.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Requests may be filed by visiting our ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "request web page",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "; please note that this may require a fee.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "backToTopButtonLabel": "Back To Top",
                                                                "printButtonLabel": "Print",
                                                                "country": "[Circular Reference]"
                                                            }
                                                        },
                                                        {
                                                            "metadata": {
                                                                "tags": [],
                                                                "concepts": []
                                                            },
                                                            "sys": {
                                                                "space": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Space",
                                                                        "id": "n9bebhw263o0"
                                                                    }
                                                                },
                                                                "id": "5obyb6hoYaRjLduvLrF9BT",
                                                                "type": "Entry",
                                                                "createdAt": "2023-05-24T19:10:31.031Z",
                                                                "updatedAt": "2023-07-11T18:20:48.597Z",
                                                                "environment": {
                                                                    "sys": {
                                                                        "id": "sandbox",
                                                                        "type": "Link",
                                                                        "linkType": "Environment"
                                                                    }
                                                                },
                                                                "publishedVersion": 245,
                                                                "revision": 62,
                                                                "contentType": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "ContentType",
                                                                        "id": "richTextContentComponent"
                                                                    }
                                                                },
                                                                "locale": "en-US"
                                                            },
                                                            "fields": {
                                                                "title": "Privacy Policy Rich Text Content Component - DE",
                                                                "effectiveDateLabel": "Effective",
                                                                "effectiveDate": "2023-01-07",
                                                                "disclaimerMessage": "Please read these terms carefully before accessing or using this website",
                                                                "content": {
                                                                    "nodeType": "document",
                                                                    "data": {},
                                                                    "content": [
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "This website is owned and operated by Moderna, Inc. (\u201CModerna\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D). The materials on our website (the \u201Cwebsite\u201D or the \u201CSite\u201D) are provided by Moderna as a service to our customers and the public and may be used for informational purposes only.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna respects the privacy of visitors to our website and recognizes the importance of taking steps to protect the privacy of any information we collect through our website. This Privacy Policy describes the types of Personal Information (as defined below) that we collect about visitors to the Site, how we use the Personal Information, and with whom we may share it. This Privacy Policy also describes (1) the measures we take to protect the personal\ninformation we collect and (2) your rights and privileges regarding our collection, use, and disclosure of your personal information.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Exclusions.",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        },
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " This policy only treats personal information collected through this website. It does not describe how we may collect or use personal information collected oline, and it does not address or govern the privacy practices of other websites (including those we link to) that may have policies of their own. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. Information you provide to us unsolicited may be considered non-confidential, and Moderna may reproduce, use, disclose, and share such unsolicited information with others without permission, compensation, restriction, or aribution.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "By accessing our website, you agree to the terms of this Privacy Policy and the terms of the Agreement. ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you do not agree to these terms, you are not authorized to use our website.",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\n",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Introduction",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Personal Information",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        },
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201D is information that can be used to identify or contact you, such as: Your contact information, including your name, address, email address, country, and phone number, any other information that may appear on your resume if you apply for a job with Moderna through our website, and where required by applicable law, any information about your use of our website or device that may be collected automatically; including the use of\ncookies, web beacons and other tracking technologies.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We will handle your Personal Data in accordance with applicable law and in line with the following principles:\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We will treat your personal data in accordance with applicable law and in accordance with the following principles:",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We process personal data lawfully, fairly and transparently.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We collect personal information only for a specific, explicit and legitimate purpose and use personal information only for the purposes for which it was originally collected.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We limit the collection of personal data to what is necessary for the purpose for which it is processed.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We will use reasonable eorts to ensure that your personal information is accurate and, where appropriate, kept up to date.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We do not store personal data for longer than is necessary for the purpose for which the personal data is processed.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Personal data will only be processed in a manner that ensures appropriate security of the personal data.\n\n",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Our privacy practices are described in more detail below in this Privacy Policy.\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Information We Collect",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You can visit our website without explicitly providing information about yourself. If you choose to submit your information through the \u201CSign Up for our Mailing List\u201D feature or the \u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://dev.modernadirect.com/en-DE/contact-us"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Contact Us",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201D feature on our website, or if you apply for a job posting at Moderna through the \u201C",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.modernatx.com/careers/life-at-moderna"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Careers",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201D section of our website, we may ask you to provide personal information, such as your name, address, telephone number and email address, job title, company name, Your\ncountry, information about your job and other job-related information. You are not required to provide any personal information to Moderna, but your ability to use our website or its features and your ability to apply for a job may be limited if you do not.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Personal data",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " about the use of the website collected through cookies or other automated means. When you use our website, we may automatically collect information about your use of the website, including through the use of cookies, web beacons and other tracking technologies (\u201CAutomatically Collected Information\u201D). Automatically collected information may include device information such as IP address, device identifiers and operating systems,\nas well as usage information such as time and duration of use, interaction with content, information stored in cookies or similar technologies. In accordance with EU Regulation 2016/679 on data protection (the \u201CGDPR\u201D), automated information is considered personal data and we treat such automated information as personal data in accordance with this Privacy Policy.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\u201CCookies\u201D",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " are small files that the website places on your hard drive for identification purposes. These files are used for registration on the website and to\ncustomize your next visit to our website. For example, cookies store your preferred language and display. Cookies cannot read data from your hard drive.\n\nWe use the following cookies on our website:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Strictly necessary cookies",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ". These are cookies that are necessary for the operation of our website. These include, for example, cookies that enable you to log in to your applicant account. ",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Functionality cookies",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ". s. These are used to recognize you when you return to our website and to embed features of third-party services. This allows us to personalize our content for you, store your preferences (e.g., Your choice of language) and useful third-party services on our website.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "Analytics cookies",
                                                                                                    "marks": [
                                                                                                        {
                                                                                                            "type": "bold"
                                                                                                        }
                                                                                                    ],
                                                                                                    "data": {}
                                                                                                },
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": ". We use the Google Analytics platform to collect certain analytical information that helps us to beer understand the activities on our website and to improve our services and the quality of our website. This information includes the IP address, page views, referring websites or advertisements, operating system and browser, and time spent on our website. We receive this data in an aggregated form. We use this information\nto understand how visitors interact with our website, to measure the eectiveness of our advertising on third-party websites, and to improve our visitors\u2019 experience.\n",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You can refuse or accept cookies from this website at any time by activating the cookie seings in your browser. The \u201CHelp\u201D menu of most Internet browsers contains information on how to disable cookies, or you can visit ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "https://www.aboutcookies.org/how-to-control-cookies/"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "https://www.aboutcookies.org/how-to-control-cookies",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "/. If you do not accept cookies, some features on our website may not work fully, and you may not be able to access certain information on this website. By continuing to use the website without changing the seings, you agree to the use of cookies.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Personal data from third-party sources. We may, to the extent permied by law, obtain information about you from publicly and commercially available sources, which we may combine with other information we receive from or about you. For example, if you apply for a job at Moderna through our website, we may view your LinkedIn profile.\nAggregated data. We may aggregate and/or de-identify any personal information we collect so that the information no longer identifies a specific individual. We may use, disclose and otherwise process such information without restriction for our own legitimate business purposes \u2013 including historical and statistical analysis and business planning.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Aggregated Data",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "italic"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ". We may aggregate and/or de-identify any Personal Data that we collect, such that the information no longer identifies any specific individual. We may use, disclose and otherwise process such information for our own legitimate business purposes \u2013 including historical and statistical analysis and business planning \u2013 without restriction.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "How We Use Personal Data",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may use Personal Data for the following purposes.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-5",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Our legitimate interests",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We may process your personal data where it is necessary for our legitimate interest as a business, including administering, promoting and improving our business and risk management. For example, we may process your personal data in order to:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "provide you with the information you have requested and/or to respond to your requests submied via the Website, email and/or telephone,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "facilitate our recruitment activities (e.g., processing job applications, evaluating you as a candidate for a job and monitoring our recruitment statistics),",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "analyse and improve our communications and strategies (including by determining when e-mails sent to you have been received and read);",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "adapt the content we display on our website,",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "protect against, identify, investigate, and respond to fraud, illegal activities (such as incidents of hacking or misuse of our website), claims, and other recourse;",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "maintain the privacy, security, or property of the Site; and",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "communicate with you for any other purpose arising from the circumstances or of which we inform you when we collect personal information from you.\n",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-5",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Legal Obligation",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We may be required by law to collect and process certain personal data about you. For example, it may be necessary for us to process your personal data in order to comply with our contractual obligations to the U.S. Government as a contractor for the government.\n",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-5",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Your consent",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "unordered-list",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "We may also, either directly or through our trusted third parties, obtain your separate consent to process your personal data, for example, if you choose to receive Moderna news and updates from us, or for the use of non-essential cookies.",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "list-item",
                                                                                    "data": {},
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "paragraph",
                                                                                            "data": {},
                                                                                            "content": [
                                                                                                {
                                                                                                    "nodeType": "text",
                                                                                                    "value": "If we have obtained your consent to process your personal data, you may subsequently withdraw it at any time by contacting us at the address set out in the \u201CYour Privacy Rights\u201D section below.\n",
                                                                                                    "marks": [],
                                                                                                    "data": {}
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Disclosure of personal data\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We will not sell, share, or otherwise distribute your personal information to third parties except as provided in this Privacy Policy.\n\nAliates and Service Providers. We may share your personal information with other Moderna aliates worldwide who agree to treat it in accordance with this Privacy Policy. We may also share personal data with service providers acting for us or on our behalf for further processing, such as to assess the usefulness of this website, for data management, technical support or to analyse recruitment data. These service providers have contractually agreed to\nuse the personal data only for the purpose(s) for which the data was originally collected or may otherwise be lawfully processed, not to sell your personal data to other third parties and not to disclose it to other third parties, unless required by law, permied by us or specified in this Privacy Policy.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nOther parties in connection with a corporate transaction. We may also transfer personal information we have collected from you to a third party as part of\na corporate transaction, such as a merger, acquisition, reorganization, joint venture, financing, or sale of our assets.\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nOther parties as required by applicable law or as necessary to protect Moderna. We may share personal information with third parties to comply with\nlegal and regulatory requirements, or to protect against fraud, illegal activity (e.g., in response to incidents of hacking or misuse of our website), and\nclaims and other recourse.\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "International Data Transfers",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "When we share personal information with third parties, such data transfers may involve the transfer of personal information to other countries. These countries may not have the same data protection laws as the country from which the personal data originally originated.\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "EEA area residents only",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nModerna in the U.S. acts as a data controller and processes your personal data by determining the purposes and means of processing in accordance with the GDPR. Please note that your personal data will be stored on Aquia\u2019s servers, including inside and outside the European Union. Before we transfer your personal data outside the EEA, we will take steps to ensure that such data receives the same level of protection as under applicable data protection laws within the EEA. For data transfers outside the EEA, we use applicable safeguards where necessary, including standard contractual clauses approved by the European Commission. A copy of these arrangements can be obtained by contacting us at the email address below.\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Your Privacy Rights",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "As a data subject, you may have certain rights under applicable law. For example, you have the right to object to the processing of your personal data or\nto request a restriction of processing and the right to request access to the personal data we hold about you, as well as its correction, deletion and\nportability, subject to certain exceptions required by law. If you would like more information about our use of your personal data, or if you wish to exercise\nyour rights, please contact us at:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nModerna, Inc. 200 Technology Square, Cambridge, MA 02139 USA",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:Privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "Privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "EU residents:",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "EUprivacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "EUprivacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We will endeavor to provide requested information and make requested changes to the extent required and permied by applicable data protection laws and other laws and regulations. In any case, we will do our best to respond to you as soon as possible and inform you of the outcome of your request.\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You can lodge a complaint with the competent supervisory authority if you believe that our processing of your personal data violates applicable law.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Contact information for all EU supervisory authorities can be found here.\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Information",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna employs commercially reasonable administrative, technical, personnel, and physical security measures to protect the personal information in our possession from loss, the, and unauthorized use, disclosure, or alteration. Of course, despite these measures, we cannot guarantee perfect security of the networks, servers and databases operated by us or on our behalf. In particular, e-mails sent to or from the website may not be secure.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Therefore, you should be particularly careful about what information you send to us by e-mail. Please keep this in mind when you provide us with personal\ndata via the website.\n\n\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Data Storage",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Your personal data will only be retained by Moderna for as long as is necessary to fulfil the purpose(s) for which it was collected, depending on the purpose(s) for which the personal data was collected, the nature of the personal data, any contractual relationship governing the retention of the personal data and our legal or regulatory obligations. We will then destroy or anonymize your personal data in accordance with applicable law.\n\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Email Communications",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "In the event that we contact you, including by email, we will provide you with a method by which you can opt in or out of receiving further communications to the extent required by law. For example, you may choose to receive email updates on developments related to Moderna\u2019s products and/or services, or on health-related specific topics (e.g., email updates on Moderna\u2019s methylmalonic acid anemia (MMA)) by filling out the appropriate\nelectronic form \u201CSign up for our mailing list\u201D on our website. If, at a later date, you decide that you no longer wish to receive such e-mail communications from us, you may unsubscribe from such a contact list by using the appropriate \u201Cunsubscribe\u201D link within the relevant electronic communication channel or by sending us an e-mail titled \u201CUnsubscribe from E-mail Updates\u201D to ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " or ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:EUprivacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "EUprivacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Our policy on dealing with children\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We are commied to protecting children\u2019s privacy. The content and services of this website are not intended for or directed at children under the age of 18. Visitors under the age of 18 or children under the age of 18 should not submit any personal information to Moderna through the Site.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nIf we become aware that a user of our website is under the age of 18 and has voluntarily provided personal information and/or health-related personal information, or that a healthcare professional has voluntarily provided personal information about a patient identified as under the age of 18 without the given or authorized consent of that child\u2019s legal guardian, we will promptly endeavor to delete such personal information upon notice or request.\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "CalOPPA Do-Not-Track Notice",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "We do not track our website users over time and across third-party websites and therefore do not respond to Do Not Track (DNT) signals. Moderna does not authorize third parties to collect personal information directly from our users on our website, such as through the use of third-party advertising.\n\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Links to Third Party Websites\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "As a convenience to our visitors, this website may contain links to other websites that we believe provide useful information. These links may contain links to websites that may provide services to us. Please note that Moderna is not responsible for the privacy practices of these other websites and cannot guarantee the privacy standards of these other websites. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. This Privacy Policy applies solely to information collected by our website and does not apply to linked websites that do not originate from Moderna.\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Notification of the Privacy Policy\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Updates: If we change our privacy policy, we will post those changes on our website. If we make any changes to this Privacy Policy, we will update the date at the top of this Privacy Policy.\n\n\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "heading-3",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "For Additional Information",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "If you have any questions about this Privacy Policy or concerns about the practices of this website or your dealings with this website, or any privacyrelated maers generally, please email us at ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mailto:privacy@modernatx.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "privacy@modernatx.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": " or contact us in writing at:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna, Inc.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Aention: Legal Department 200 Technology Square,",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Cambridge, MA 02139 USA\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "For EU/EEA residents",
                                                                                    "marks": [
                                                                                        {
                                                                                            "type": "bold"
                                                                                        }
                                                                                    ],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ":\nPlease email us at ",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                },
                                                                                {
                                                                                    "nodeType": "hyperlink",
                                                                                    "data": {
                                                                                        "uri": "mainto:contact@dpr.eu.com"
                                                                                    },
                                                                                    "content": [
                                                                                        {
                                                                                            "nodeType": "text",
                                                                                            "value": "contact@dpr.eu.com",
                                                                                            "marks": [],
                                                                                            "data": {}
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": ".",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "You can also contact us in writing at:",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "DPR Group Oce 29, Clion House Fitzwilliam Street Lower Dublin, Ireland\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "\nFor all other questions or concerns, regardless of where you live, please contact us in writing at:\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Moderna, Inc.",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Aention: Corporate Communications200 Technology Square,",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "Cambridge,",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "MA 02139",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "nodeType": "paragraph",
                                                                            "data": {},
                                                                            "content": [
                                                                                {
                                                                                    "nodeType": "text",
                                                                                    "value": "USA\n\n",
                                                                                    "marks": [],
                                                                                    "data": {}
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "backToTopButtonLabel": "Back To Top",
                                                                "printButtonLabel": "Print",
                                                                "country": {
                                                                    "sys": {
                                                                        "type": "Link",
                                                                        "linkType": "Entry",
                                                                        "id": "7DX7badGk41XRSy4znPNFI"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    {
                        "metadata": {
                            "tags": [],
                            "concepts": []
                        },
                        "sys": {
                            "space": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                }
                            },
                            "id": "7oSmj9Iyl3kSocc335XV51",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:21:30.182Z",
                            "updatedAt": "2022-12-02T04:21:30.182Z",
                            "environment": {
                                "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                }
                            },
                            "publishedVersion": 8,
                            "revision": 1,
                            "contentType": {
                                "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "contactUsConfirmationComponent"
                                }
                            },
                            "locale": "en-US"
                        },
                        "fields": {
                            "title": "Contact Us Confirmation Component",
                            "headline": "Request Sent",
                            "message": {
                                "data": {},
                                "content": [
                                    {
                                        "data": {},
                                        "content": [
                                            {
                                                "data": {},
                                                "marks": [],
                                                "value": "Thank you for reaching out. A representative will reach out shortly.",
                                                "nodeType": "text"
                                            }
                                        ],
                                        "nodeType": "paragraph"
                                    }
                                ],
                                "nodeType": "document"
                            },
                            "icon": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "5EWJeaSLcAOTh1XGB5J1Jd",
                                    "type": "Asset",
                                    "createdAt": "2022-11-08T22:15:01.982Z",
                                    "updatedAt": "2022-11-08T22:15:01.982Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 3,
                                    "revision": 1,
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "contactusRequestSentLogo",
                                    "description": "",
                                    "file": {
                                        "url": (0, (/*@__PURE__*/$parcel$interopDefault($3cc3eb5857371bb0$exports))),
                                        "details": {
                                            "size": 35738,
                                            "image": {
                                                "width": 600,
                                                "height": 600
                                            }
                                        },
                                        "fileName": "contactusRequestSentLogo.png",
                                        "contentType": "image/png"
                                    }
                                }
                            },
                            "link": {
                                "metadata": {
                                    "tags": [],
                                    "concepts": []
                                },
                                "sys": {
                                    "space": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "Space",
                                            "id": "n9bebhw263o0"
                                        }
                                    },
                                    "id": "7sOHpLfHcBdXJkB7vOBL26",
                                    "type": "Entry",
                                    "createdAt": "2022-11-09T21:12:00.000Z",
                                    "updatedAt": "2022-12-01T20:32:59.726Z",
                                    "environment": {
                                        "sys": {
                                            "id": "sandbox",
                                            "type": "Link",
                                            "linkType": "Environment"
                                        }
                                    },
                                    "publishedVersion": 7,
                                    "revision": 2,
                                    "contentType": {
                                        "sys": {
                                            "type": "Link",
                                            "linkType": "ContentType",
                                            "id": "internalLink"
                                        }
                                    },
                                    "locale": "en-US"
                                },
                                "fields": {
                                    "title": "Contact Us Internal Link",
                                    "label": "Contact Us",
                                    "pageReference": {
                                        "metadata": {
                                            "tags": [],
                                            "concepts": []
                                        },
                                        "sys": {
                                            "space": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "Space",
                                                    "id": "n9bebhw263o0"
                                                }
                                            },
                                            "id": "6aA4Kfs006hNINMMIje8Cq",
                                            "type": "Entry",
                                            "createdAt": "2022-10-28T20:09:14.397Z",
                                            "updatedAt": "2022-12-02T04:38:06.055Z",
                                            "environment": {
                                                "sys": {
                                                    "id": "sandbox",
                                                    "type": "Link",
                                                    "linkType": "Environment"
                                                }
                                            },
                                            "publishedVersion": 16,
                                            "revision": 3,
                                            "contentType": {
                                                "sys": {
                                                    "type": "Link",
                                                    "linkType": "ContentType",
                                                    "id": "page"
                                                }
                                            },
                                            "locale": "en-US"
                                        },
                                        "fields": {
                                            "name": "Contact Us",
                                            "title": "Contact Us",
                                            "slug": "contact-us",
                                            "seo": {
                                                "metadata": {
                                                    "tags": [],
                                                    "concepts": []
                                                },
                                                "sys": {
                                                    "space": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "Space",
                                                            "id": "n9bebhw263o0"
                                                        }
                                                    },
                                                    "id": "3SZXCHhkMg78hB0DVPqLnA",
                                                    "type": "Entry",
                                                    "createdAt": "2022-10-28T20:09:14.497Z",
                                                    "updatedAt": "2022-10-28T20:09:14.497Z",
                                                    "environment": {
                                                        "sys": {
                                                            "id": "sandbox",
                                                            "type": "Link",
                                                            "linkType": "Environment"
                                                        }
                                                    },
                                                    "publishedVersion": 15,
                                                    "revision": 1,
                                                    "contentType": {
                                                        "sys": {
                                                            "type": "Link",
                                                            "linkType": "ContentType",
                                                            "id": "seo"
                                                        }
                                                    },
                                                    "locale": "en-US"
                                                },
                                                "fields": {
                                                    "name": "Contact Us - Compose: SEO",
                                                    "title": "Contact Us Moderna",
                                                    "description": "Contact Us Moderna",
                                                    "no_index": false,
                                                    "no_follow": false
                                                }
                                            },
                                            "content": "[Circular Reference]"
                                        }
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            "sys": {
                "id": "2XyGZ6yTIb3AUfSz6gUGfw",
                "type": "Entry"
            }
        }
    ]
};


const $a46bd5ef9aae83ce$var$BannerWrapper = (0, $d8seH.default)('div')(({ bgImageUrl: bgImageUrl, theme: { palette: { primary: primary, neutral: neutral }, breakpoints: breakpoints } })=>`
    background-color: ${primary.main};
    background-image: url(${bgImageUrl});
    background-size: cover;
    height: 300px;
    display: flex;
    padding: 0 32px;
    align-items: center;
    overflow-y: hidden;
    ${[
        breakpoints.up('md')
    ]} {
        padding: 0 94px;
    }
    ${[
        breakpoints.down('sm')
    ]} {
        align-items: unset;
    }
    `);
const $a46bd5ef9aae83ce$var$CardContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
    padding: 30px 32px;
    display: flex;
    gap: 12px;
    margin-top: -84px;
    flex-wrap: nowrap;
    overflow: auto;
    ${[
        breakpoints.up('md')
    ]} {
        padding: 30px 94px;
    }
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`);
const $a46bd5ef9aae83ce$var$Card = (0, $d8seH.default)('div')(({ theme: { palette: { neutral: neutral }, breakpoints: breakpoints } })=>`
    background-color: ${neutral.white};
    border-radius: 14px;
    box-shadow: 0px 3px 6px #00000029;
    flex-grow: 1;
    padding: 22px;
    display: flex;
    justify-content: space-between;
    min-width: fit-content;
   ${[
        breakpoints.down('sm')
    ]} {
        min-width: 100% !important;
        flex-direction: column;
    }
`);
const $a46bd5ef9aae83ce$var$IconButtonSx = {
    width: {
        xs: "48px",
        sm: "34px"
    },
    height: {
        xs: "48px",
        sm: "34px"
    },
    color: "primary.main",
    backgroundColor: "none",
    border: "1px solid",
    borderColor: "primary.main",
    '&:hover': {
        color: 'neutral.white',
        backgroundColor: 'primary.blue',
        borderColor: "primary.blue"
    }
};
const $a46bd5ef9aae83ce$var$ContactUs = ({ ...props })=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const [dataExternalModal, setDataExternalModal] = (0, $acw62.useState)(true);
    const remindMeExternal = localStorage.getItem("dontRemindMeExternal");
    (0, $acw62.useEffect)(()=>{
        if (remindMeExternal === "true") setDataExternalModal(false);
    }, [
        remindMeExternal
    ]);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const getStaticContent = ()=>{
        let response = (0, $cdcd230f9adfb4e4$export$5f354eed7f559fab);
        return {
            banner: response.items[0].fields.modules?.[0]?.fields,
            card: [
                response.items[0].fields.modules?.[1]?.fields,
                response.items[0].fields.modules?.[2]?.fields,
                response.items[0].fields.modules?.[3]?.fields
            ],
            form: response.items[0].fields.modules?.[4]?.fields,
            formSubmitted: response.items[0].fields.modules?.[5]?.fields
        };
    };
    let staticContent = getStaticContent();
    const handleRedirect = (e, str)=>{
        if ((0, $382eb84981692d3a$export$8304a22d431f958)(str)) {
            if ((0, $382eb84981692d3a$export$bdc112e4021a968d)(str) && !localStorage.getItem("dontRemindMeExternal")) {
                props?.setShowNavigationAlert(true);
                props?.setExternalLink(str);
                props?.setExternalLinkModalType("extrenalLink");
                e.preventDefault();
            } else {
                window.open(str, '_blank');
                props?.setShowNavigationAlert(false);
                props?.setExternalLink("");
            }
        } else history.push(str);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: authState?.isAuthenticated ? {} : {
            position: "relative",
            margin: "0px auto 0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a46bd5ef9aae83ce$var$BannerWrapper, {
                bgImageUrl: staticContent?.banner?.backgroundImage?.fields?.file?.url,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: 'h1',
                            color: "neutral.white",
                            mt: {
                                xs: '60px',
                                sm: 'unset'
                            },
                            "data-testid": "headline",
                            children: staticContent?.banner?.headline
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: 'p1',
                            component: 'p',
                            color: "neutral.white",
                            mt: 1,
                            "data-testid": "message",
                            children: staticContent?.banner?.message
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a46bd5ef9aae83ce$var$CardContainer, {
                children: (0, $4cb9025d70ee2d16$export$a41342575b9eca37).map((card, index)=>authState?.isAuthenticated || card?.headline !== "FAQs" ? /*#__PURE__*/ (0, $ayMG0.jsxs)($a46bd5ef9aae83ce$var$Card, {
                        id: "contactUscard" + index,
                        "data-testid": `contactUscard-${card?.title}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: card?.icon?.fields?.file?.url,
                                        alt: card?.icon?.fields?.title,
                                        style: {
                                            width: "45px",
                                            height: "45px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: 'h3',
                                        color: "primary.main",
                                        mt: 1,
                                        children: card?.headline
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: 'p1',
                                        color: "primary.main",
                                        mt: 1,
                                        sx: {
                                            whiteSpace: 'pre-line',
                                            lineHeight: '2',
                                            userSelect: 'text'
                                        },
                                        children: card?.message
                                    })
                                ]
                            }),
                            card?.link && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                alignSelf: "end",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    variant: "outlined",
                                    onClick: (e)=>handleRedirect(e, card?.link?.fields?.url || card?.link?.fields.pageReference.fields?.slug),
                                    "data-external-modal": dataExternalModal,
                                    "data-link-href": card?.link?.fields?.url || card?.link?.fields.pageReference.fields?.slug,
                                    sx: $a46bd5ef9aae83ce$var$IconButtonSx,
                                    "aria-label": card?.label,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($12a26d70a091a9bc$exports))), {})
                                })
                            })
                        ]
                    }, index) : "")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbc128cda5bd5935$export$7b14df81b2d7cbdc), {
                staticContent: staticContent
            })
        ]
    });
};
var $a46bd5ef9aae83ce$export$2e2bcd8739ae039 = $a46bd5ef9aae83ce$var$ContactUs;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $cllwi = parcelRequire("cllwi");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3bYfT = parcelRequire("3bYfT");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $beCSm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;



var $k0igC = parcelRequire("k0igC");

var $kSnzZ = parcelRequire("kSnzZ");
const $204cbcbead979fad$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $204cbcbead979fad$var$transformDeprecatedColors = (color)=>{
    return $204cbcbead979fad$export$c4e140d5d351182b[color] || color;
};
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $204cbcbead979fad$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $k0igC.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $k0igC.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kSnzZ.alpha)(color, 0.4);
};
var $204cbcbead979fad$export$2e2bcd8739ae039 = $204cbcbead979fad$var$getTextDecoration;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $731ce78e0c47d0a7$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $jTnBY.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd904517f2a78af6$export$d6efab9620b78fec), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $8nd05.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $204cbcbead979fad$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $fd904517f2a78af6$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $1En50.default)(props, $731ce78e0c47d0a7$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $cllwi.default)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $9Rgf1.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, (0, $8nd05.default)({
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $204cbcbead979fad$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;


var $3bYfT = parcelRequire("3bYfT");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");

var $ijOKP = parcelRequire("ijOKP");

var $jzUw6 = parcelRequire("jzUw6");
var $inBkn = parcelRequire("inBkn");
var $bhKtZ = parcelRequire("bhKtZ");
const $d0c9d4df5a3b9d00$export$bca14c5b3b88a9c9 = (0, $ijOKP.default)({
    breakpoints: {
        values: {
            xs: 0,
            sm: 500,
            md: 768,
            lg: 1024,
            lg2: 1200,
            xl: 1850
        }
    },
    palette: {
        primary: {
            main: '#1E2846',
            blue: '#2AACE2',
            blueFaded: '#BFE6F6',
            darkBlue: '#02608C',
            red: '#E31837',
            button: '#D1343E',
            redFaded: '#F08477'
        },
        secondary: {
            main: '#F2FAFD',
            graphical: '#1D9CD3',
            textLinks: "#177EAB",
            containers: '#225D84',
            blueFaded: '#E3F3FF',
            button: '#92242B'
        },
        neutral: {
            main: '#000000',
            gray1: '#767676',
            gray2: '#C0C0C0',
            gray3: '#334E5C',
            gray4: '#F8F8F8',
            gray5: '#F7F7F7',
            gray6: '#D1D1D1',
            gray7: '#545F71',
            white: '#ffffff',
            darkGrey: '#383D47'
        },
        status: {
            success: '#49B705',
            error: '#D1343E',
            warning: '#FFCE00'
        }
    },
    typography: {
        h1: {
            fontFamily: 'Aeonik Light',
            fontSize: '48px',
            '@media (max-width:900px)': {
                fontSize: '30px'
            }
        },
        h2: {
            fontSize: '34px',
            fontFamily: 'Aeonik Light',
            lineHeight: '51px',
            '@media (max-width:900px)': {
                fontSize: '24px',
                lineHeight: '36px'
            }
        },
        h3: {
            fontSize: '24px',
            fontFamily: 'Aeonik Bold',
            lineHeight: '36px',
            '@media (max-width:900px)': {
                fontSize: '20px',
                lineHeight: '28px'
            }
        },
        h4: {
            fontSize: '20px',
            fontFamily: 'Aeonik Bold',
            lineHeight: '28px',
            '@media (max-width:900px)': {
                fontSize: '16px',
                lineHeight: '24px'
            }
        },
        h5: {
            fontSize: '16px',
            fontFamily: 'Aeonik Bold',
            lineHeight: '21px',
            '@media (max-width:900px)': {
                fontSize: '14px',
                lineHeight: '21px'
            }
        },
        h6: {
            fontSize: '12px',
            fontFamily: 'Aeonik Bold',
            '@media (max-width:900px)': {
                fontSize: '11px'
            }
        },
        p1: {
            fontSize: '16px',
            fontFamily: 'Aeonik Regular',
            lineHeight: '24px',
            '@media (max-width:900px)': {
                fontSize: '16px',
                lineHeight: '21px'
            }
        },
        p2: {
            fontSize: '14px',
            fontFamily: 'Aeonik Regular',
            lineHeight: '21px',
            '@media (max-width:900px)': {
                fontSize: '14px',
                lineHeight: '21px'
            }
        },
        p3: {
            fontSize: '20px',
            fontFamily: 'Aeonik Regular',
            lineHeight: '28px',
            fontWeight: 500,
            '@media (max-width:900px)': {
                fontSize: '18px',
                lineHeight: '28px'
            }
        },
        p4: {
            fontSize: '13px',
            fontFamily: 'Aeonik Regular',
            lineHeight: 'regular',
            fontWeight: 700,
            '@media (max-width:900px)': {
                fontSize: '13px',
                lineHeight: '18px'
            }
        },
        link: {
            fontSize: '16px',
            fontFamily: 'Aeonik Regular',
            '@media (max-width:900px)': {
                fontSize: '16px'
            }
        },
        disclaimerH3: {
            fontSize: '13px',
            fontFamily: 'Aeonik Regular',
            lineHeight: "20px",
            '@media (max-width:900px)': {
                fontSize: '13px'
            }
        },
        disclaimerParagraph: {
            fontSize: '11px',
            fontFamily: 'Aeonik Regular',
            lineHeight: "20px",
            '@media (max-width:900px)': {
                fontSize: '10px'
            }
        }
    },
    components: {
        MuiPickersLayout: {
            styleOverrides: {
                contentWrapper: {
                    backgroundColor: 'white'
                }
            }
        },
        MuiPickersCalendarHeader: {
            styleOverrides: {
                root: {
                    display: "flex",
                    alignItems: "center",
                    justifyItems: "center"
                },
                labelContainer: {
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '0 auto',
                    left: 0,
                    right: 0
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '&:hover, &:focus': {
                        backgroundColor: 'white'
                    },
                    '&.Mui-selected, &.Mui-selected:hover, &:focus.Mui-selected': {
                        backgroundColor: '#2AACE2'
                    },
                    '&:not(.Mui-selected)': {
                        borderColor: '#2AACE2'
                    }
                }
            }
        },
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                root: {
                    display: "inline-flex"
                },
                button: {
                    'svg': {
                        color: '#2AACE2'
                    },
                    '&.Mui-disabled': {
                        opacity: 0.6
                    }
                },
                spacer: {
                    width: '220px'
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    margin: 0
                }
            },
            variants: [
                {
                    props: {
                        variant: 'dynamic'
                    },
                    style: {
                        ":before": {
                            borderTop: "thin solid #c0c0c0"
                        },
                        ":after": {
                            borderTop: "thin solid #c0c0c0"
                        }
                    }
                }
            ]
        },
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: "red"
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                asterisk: {
                    color: "red"
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: 'none',
                    '.MuiDataGrid-withBorderColor': {
                        borderColor: 'transparent'
                    }
                },
                cell: {
                    margin: '10px 0',
                    '&:focus, &.MuiDataGrid-withBorderColor, &.MuiDataGrid-withBorderColor:focus': {
                        outline: 'none'
                    },
                    '&.nonSelectable': {
                        pointerEvents: 'none'
                    }
                },
                row: {
                    '&.Mui-odd, &.Mui-odd:hover, &.Mui-odd.Mui-selected, &.Mui-odd.Mui-selected:hover': {
                        backgroundColor: '#F2FAFD'
                    },
                    '&:hover, &.Mui-selected, &.Mui-selected:hover': {
                        backgroundColor: 'transparent'
                    }
                },
                columnHeader: {
                    fontFamily: 'Aeonik Bold',
                    fontSize: 12,
                    color: '#1E2846',
                    textTransform: 'uppercase',
                    [`.${(0, $jzUw6.default).root} svg`]: {
                        color: '#1E2846'
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        fontFamily: 'Aeonik Bold'
                    },
                    '&:focus, &:focus-within': {
                        outline: 'none'
                    }
                },
                columnHeaderCheckbox: {
                    '.MuiDataGrid-columnHeaderTitleContainer': {
                        justifyContent: 'start'
                    }
                },
                cellCheckbox: {
                    justifyContent: 'start'
                },
                columnHeaders: {
                    '&.MuiDataGrid-withBorderColor': {
                        borderColor: '#E0E0E0'
                    }
                },
                columnSeparator: {
                    display: 'none'
                },
                checkboxInput: {
                    color: "#1D9CD3",
                    padding: 0,
                    '&:hover': {
                        backgroundColor: 'unset'
                    },
                    '&.Mui-checked': {
                        color: "#1D9CD3"
                    }
                },
                footerContainer: {
                    borderTop: 'none',
                    justifyContent: 'start',
                    marginTop: '1rem',
                    [`.${(0, $inBkn.default).root}`]: {
                        flexGrow: 1,
                        justifyContent: 'center',
                        display: 'flex'
                    }
                },
                selectedRowCount: {
                    position: 'absolute'
                }
            }
        }
    },
    overrides: {
        MuiMenu: {
            list: {
                backgroundColor: '#002F5F'
            }
        },
        MuiMenuItem: {
            root: {
                fontFamily: (0, $bhKtZ.default).h5
            }
        }
    }
});


const $6d62ec653312c013$var$defaultCardStyles = {
    bgcolor: 'neutral.white',
    borderRadius: '16px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.50)',
    width: '100%',
    height: '100%'
};
const $6d62ec653312c013$var$CustomCard = ({ title: title, children: children, sx: sx, hasBorder: hasBorder = false })=>{
    const borderTopStyle = hasBorder ? {
        borderTop: `7px solid ${(0, $d0c9d4df5a3b9d00$export$bca14c5b3b88a9c9).palette.primary.blue}`
    } : {};
    const cardStyles = {
        ...$6d62ec653312c013$var$defaultCardStyles,
        ...borderTopStyle,
        ...sx
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
        sx: cardStyles,
        "data-testid": "customerCard",
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "h3",
                children: title
            }),
            children
        ]
    });
};
var $6d62ec653312c013$export$2e2bcd8739ae039 = $6d62ec653312c013$var$CustomCard;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $lkxXU = parcelRequire("lkxXU");
var $3bYfT = parcelRequire("3bYfT");








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $2esSG = parcelRequire("2esSG");
const $b58c2e036fb7cf45$var$CustomizeRadio = (0, $d8seH.default)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039))(({ theme: theme, size: size = 'medium' })=>{
    const sizeToFontSizeMap = {
        small: 17,
        medium: 20
    };
    return {
        "&:hover": {
            backgroundColor: "transparent",
            opacity: 0.8
        },
        '& .MuiTouchRipple-root': {
            display: 'none'
        },
        '&.Mui-checked:hover': {
            backgroundColor: 'transparent'
        },
        "&.Mui-checked": {
            color: theme.palette.neutral.darkGrey
        },
        '& .MuiSvgIcon-root': {
            fontSize: sizeToFontSizeMap[size],
            marginLeft: `-${Math.floor(sizeToFontSizeMap[size] / 2)}px`,
            marginTop: `-${sizeToFontSizeMap[size] / 2 - 4}px`
        }
    };
});
const $b58c2e036fb7cf45$var$CustomFormControlLabel = (0, $d8seH.default)((0, $2esSG.default))(({})=>({
        display: 'flex',
        alignItems: 'flex-start',
        ".MuiFormControlLabel-label": {
            fontSize: "16px"
        },
        margin: 0
    }));
const $b58c2e036fb7cf45$export$8b3e5f2afd424f4d = ({ checked: checked, onChange: onChange, id: id, size: size, label: label, value: value, disabled: disabled, customComponent: customComponent, sx: sx, ...props })=>{
    const customizeStyle = {
        display: 'flex',
        justifyContent: 'center',
        ...sx
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b58c2e036fb7cf45$var$CustomFormControlLabel, {
                disabled: disabled,
                value: value,
                control: /*#__PURE__*/ (0, $ayMG0.jsx)($b58c2e036fb7cf45$var$CustomizeRadio, {
                    id: `radio_field_${id}`,
                    checked: checked,
                    onChange: onChange,
                    size: size,
                    ...props
                }),
                label: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                style: customizeStyle,
                children: customComponent
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


const $412aed7b8db6df83$export$c9c174ac1ab84697 = ({ openModal: openModal, closeModal: closeModal, paymentList: paymentList, handleAddNewPaymentMethod: handleAddNewPaymentMethod, handlePaymentMethodSelection: handlePaymentMethodSelection, handleSetAsDefaultPayment: handleSetAsDefaultPayment, handleDeletePaymentMethod: handleDeletePaymentMethod })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            width: 'fit-content',
            minWidth: '400px',
            padding: '32px'
        },
        modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d83ffc3489d7abf$export$ab218e41b1f3d913), {
            paymentList: paymentList,
            handleAddNewPaymentMethod: handleAddNewPaymentMethod,
            handlePaymentMethodSelection: handlePaymentMethodSelection,
            closeModal: closeModal,
            handleSetAsDefaultPayment: handleSetAsDefaultPayment,
            handleDeletePaymentMethod: handleDeletePaymentMethod
        })
    });
};




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");










var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");


const $7be3576d67d7a9b6$var$checkoutPageStyle = {
    display: 'flex',
    padding: '16px 24px',
    alignItems: 'center'
};
const $7be3576d67d7a9b6$var$boldText = {
    fontWeight: 'bold',
    display: 'inline'
};
const $7be3576d67d7a9b6$var$orderDetailsPageStyle = {
    display: 'flex',
    padding: '16px 24px',
    borderRadius: '8px',
    border: '1px solid var(--Light-Stroke-stroke-secondary, #D1D2D5)',
    alignItems: 'center'
};
const $7be3576d67d7a9b6$export$8279855cac292a9e = ({ paymentMethod: paymentMethod, isOrderDetailsPage: isOrderDetailsPage = false })=>{
    const paymentMethodInfo = {
        type: paymentMethod?.paymentMethodType,
        info: paymentMethod?.paymentMethodInfo
    };
    const isBank = paymentMethodInfo.type === 'ACH';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        flexDirection: 'row',
        style: isOrderDetailsPage ? $7be3576d67d7a9b6$var$orderDetailsPageStyle : $7be3576d67d7a9b6$var$checkoutPageStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '32px',
                paddingBottom: isBank ? '6px' : '0px',
                children: isBank ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$6495330c0ada5a03), {}) : (0, $c9fe4f79081fb8c8$export$3c6bc50c644da455)[paymentMethodInfo.info?.brand]?.logo
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                ml: 2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%',
                        marginTop: '3px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            style: {
                                fontSize: '16px',
                                fontWeight: 400
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: $7be3576d67d7a9b6$var$boldText,
                                    children: isBank ? paymentMethodInfo?.info?.bankName : (0, $c9fe4f79081fb8c8$export$3c6bc50c644da455)[paymentMethodInfo?.info?.brand]?.name
                                }),
                                isBank ? ' account ending in ' : ' ending in ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: $7be3576d67d7a9b6$var$boldText,
                                    children: paymentMethodInfo.info?.lastFour
                                })
                            ]
                        }),
                        isOrderDetailsPage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: isBank ? paymentMethodInfo.info?.billingName : `Exp. ${paymentMethodInfo.info?.expirationDate}`
                        })
                    ]
                })
            })
        ]
    });
};


const $424d0cf87c1aa892$var$customCardStyle = {
    display: 'flex',
    paddingRight: '16px',
    borderRadius: '8px',
    border: '1px solid #D1D2D5',
    alignItems: 'center'
};
const $424d0cf87c1aa892$export$fd4f063231652dca = ({ handleErrorMsg: handleErrorMsg, handlePaymentMethodSelection: handlePaymentMethodSelection, setPaymentMethodAdded: setPaymentMethodAdded, handleSetAsDefaultPayment: handleSetAsDefaultPayment, handleDeletePaymentMethod: handleDeletePaymentMethod })=>{
    const selectedPaymentMethod = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store.commerce.selectedPaymentMethod);
    const [openPaymentMethodsModal, setOpenPaymentMethodsModal] = (0, $acw62.useState)(false);
    const [listPaymentMethods, setListPaymentMethods] = (0, $acw62.useState)([]);
    const { showPaymentForm: showPaymentForm, onAddPaymentMethodClick: onAddPaymentMethodClick, handleClosePaymentModal: handleClosePaymentModal, StripeForm: StripeForm } = (0, $58f3999ceb801203$export$2e2bcd8739ae039)(handleErrorMsg, setPaymentMethodAdded);
    const handleCloseModal = ()=>{
        setOpenPaymentMethodsModal(false);
    };
    const handleChangeBtnClick = async ()=>{
        const response = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
            status: (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE
        });
        let allPaymentMethods = (0, $c9fe4f79081fb8c8$export$2e24b6438950b56a)(response?.data?.paymentMethodsList, selectedPaymentMethod.paymentMethodId);
        setListPaymentMethods(allPaymentMethods);
        setOpenPaymentMethodsModal(true);
    };
    const handleAddNewPaymentMethod = async ()=>{
        setOpenPaymentMethodsModal(false);
        await onAddPaymentMethodClick();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        flexDirection: 'row',
        style: $424d0cf87c1aa892$var$customCardStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be3576d67d7a9b6$export$8279855cac292a9e), {
                paymentMethod: selectedPaymentMethod
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "link",
                sx: {
                    textTransform: "none"
                },
                onClick: ()=>handleChangeBtnClick(),
                children: "Change"
            }),
            openPaymentMethodsModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $412aed7b8db6df83$export$c9c174ac1ab84697), {
                openModal: openPaymentMethodsModal,
                closeModal: handleCloseModal,
                paymentList: listPaymentMethods,
                handleAddNewPaymentMethod: handleAddNewPaymentMethod,
                handlePaymentMethodSelection: handlePaymentMethodSelection,
                handleSetAsDefaultPayment: handleSetAsDefaultPayment,
                handleDeletePaymentMethod: handleDeletePaymentMethod
            }),
            showPaymentForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                openModal: showPaymentForm,
                closeModalHandler: handleClosePaymentModal,
                modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)(StripeForm, {}),
                style: {
                    maxWidth: '521px',
                    width: 'auto',
                    padding: '24px'
                }
            })
        ]
    });
};







const $21f48350fd4a3de2$var$PaymentMethodSelection = ({ handleErrorMsg: handleErrorMsg, paymentMethodsList: paymentMethodsList, setPaymentMethodAdded: setPaymentMethodAdded, paymentMethodAdded: paymentMethodAdded, handlePaymentMethodSelection: handlePaymentMethodSelection, setProcessing: setProcessing, setPaymentMethodsList: setPaymentMethodsList, setIsSnackbarOpen: setIsSnackbarOpen, setSnackbarMessage: setSnackbarMessage })=>{
    const { showPaymentForm: showPaymentForm, processing: processing, onAddPaymentMethodClick: onAddPaymentMethodClick, handleClosePaymentModal: handleClosePaymentModal, StripeForm: StripeForm } = (0, $58f3999ceb801203$export$2e2bcd8739ae039)(handleErrorMsg, setPaymentMethodAdded);
    const [openPaymentMethodsModal, setOpenPaymentMethodsModal] = (0, $acw62.useState)(false);
    const defaultPayment = paymentMethodsList?.find((listItem)=>listItem?.isDefault === true);
    const isCardExpired = defaultPayment && (0, $c9fe4f79081fb8c8$export$732c767a29852e39)(defaultPayment.paymentMethodInfo.expirationDate);
    const hasDefaultPayment = !!defaultPayment && !isCardExpired;
    const hasPaymentMethods = paymentMethodsList?.length > 0;
    const handleSelection = async ()=>{
        if (hasPaymentMethods) setOpenPaymentMethodsModal(true);
        else await onAddPaymentMethodClick();
    };
    const handleAddNewPaymentMethod = async ()=>{
        setOpenPaymentMethodsModal(false);
        await onAddPaymentMethodClick();
    };
    const PaymentButton = ({ buttonLabel: buttonLabel })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
            "data-testid": "paymentMethodBtn",
            buttonType: "mds-primary",
            onClick: handleSelection,
            sx: {
                textTransform: 'none',
                width: '100%'
            },
            loading: processing,
            children: buttonLabel
        });
    };
    const PaymentSelectionDisplay = ({ handleSetAsDefaultPayment: handleSetAsDefaultPayment, handleDeletePaymentMethod: handleDeletePaymentMethod })=>{
        if (hasDefaultPayment || paymentMethodAdded) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $424d0cf87c1aa892$export$fd4f063231652dca), {
            handleErrorMsg: handleErrorMsg,
            handlePaymentMethodSelection: handlePaymentMethodSelection,
            setPaymentMethodAdded: setPaymentMethodAdded,
            handleSetAsDefaultPayment: handleSetAsDefaultPayment,
            handleDeletePaymentMethod: handleDeletePaymentMethod
        });
        else if (hasPaymentMethods) return /*#__PURE__*/ (0, $ayMG0.jsx)(PaymentButton, {
            buttonLabel: 'Select a payment method'
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)(PaymentButton, {
            buttonLabel: 'Add a payment method'
        });
    };
    const handleSetAsDefaultPayment = async (paymentMethodId)=>{
        try {
            setProcessing(true);
            const response = await (0, $36d886fe12e537c3$export$5d4bd0ea3186eab)({
                idempotencyToken: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
                setDefault: true
            }, paymentMethodId);
            if (response.status === 200) {
                await (0, $c9fe4f79081fb8c8$export$137d42378a7a52bf)(setProcessing, handleErrorMsg, setPaymentMethodsList, (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE);
                setSnackbarMessage((0, $c9fe4f79081fb8c8$export$2d7f490179da7f41)?.setDefaultPaymentMethod);
                setIsSnackbarOpen(true);
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    const handleDeletePaymentMethod = async (paymentMethodId)=>{
        try {
            const response = await (0, $36d886fe12e537c3$export$9577d55c4298d793)(paymentMethodId);
            if (response.status === 200) {
                await (0, $c9fe4f79081fb8c8$export$137d42378a7a52bf)(setProcessing, handleErrorMsg, setPaymentMethodsList, (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE);
                setSnackbarMessage((0, $c9fe4f79081fb8c8$export$2d7f490179da7f41)?.deletePaymentMethod);
                setIsSnackbarOpen(true);
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: [
            openPaymentMethodsModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $412aed7b8db6df83$export$c9c174ac1ab84697), {
                openModal: openPaymentMethodsModal,
                closeModal: ()=>setOpenPaymentMethodsModal(false),
                paymentList: paymentMethodsList,
                handleAddNewPaymentMethod: handleAddNewPaymentMethod,
                handlePaymentMethodSelection: handlePaymentMethodSelection,
                handleSetAsDefaultPayment: handleSetAsDefaultPayment,
                handleDeletePaymentMethod: handleDeletePaymentMethod
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PaymentSelectionDisplay, {
                handleSetAsDefaultPayment: handleSetAsDefaultPayment,
                handleDeletePaymentMethod: handleDeletePaymentMethod
            }),
            showPaymentForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                openModal: showPaymentForm,
                closeModalHandler: handleClosePaymentModal,
                modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)(StripeForm, {}),
                style: {
                    maxWidth: '521px',
                    width: 'auto',
                    padding: '24px'
                }
            })
        ]
    });
};
var $21f48350fd4a3de2$export$2e2bcd8739ae039 = $21f48350fd4a3de2$var$PaymentMethodSelection;






const $4d829621565b6e7b$export$8c0cbd90c1b89ba1 = {
    payNow: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontWeight: 'bold'
                },
                children: "Pay now:"
            }),
            " Your Credit Card payment or ACH Bank Transfer will be processed when your order ships."
        ]
    }),
    payLater: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    fontWeight: 'bold'
                },
                children: "Pay later:"
            }),
            " An invoice with payment instructions will be sent to the billing address selected for this order."
        ]
    })
};
const $4d829621565b6e7b$export$287daadb05956fd4 = ()=>{
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        gap: "16px",
        "data-testid": 'payment-method',
        mb: 4,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            fontFamily: "Aeonik Regular",
            children: [
                "An invoice with ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                    to: `/${locale}/invoicepay`,
                    target: "_blank",
                    children: "payment instructions"
                }),
                " will be sent to the billing address selected for this order."
            ]
        })
    });
};
const $4d829621565b6e7b$export$90ca4d83e0d0cde7 = ({ paymentOption: paymentOption, handlePaymentSelection: handlePaymentSelection, handleErrorMsg: handleErrorMsg, paymentMethodsList: paymentMethodsList, setProcessing: setProcessing, setPaymentMethodsList: setPaymentMethodsList, setIsSnackbarOpen: setIsSnackbarOpen, setSnackbarMessage: setSnackbarMessage })=>{
    const [paymentMethodAdded, setPaymentMethodAdded] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handlePaymentMethodSelection = async (paymentMethodId)=>{
        try {
            const response = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                status: (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE
            });
            if (response.status === 200) {
                let allPaymentMethods = response?.data?.paymentMethodsList;
                let selectedPM = allPaymentMethods?.find((pm)=>pm.paymentMethodId === paymentMethodId);
                let isCardExpired = (0, $c9fe4f79081fb8c8$export$732c767a29852e39)(selectedPM.paymentMethodInfo.expirationDate);
                if (selectedPM && !isCardExpired) {
                    setPaymentMethodAdded(true);
                    dispatch((0, $53476aa40d2bc637$export$9628908a9dd74afb)(selectedPM));
                } else if (isCardExpired) {
                    setPaymentMethodAdded(false);
                    handleErrorMsg("This payment method has expired. Please update your payment details and try again.");
                }
            }
        } catch (error) {
            let errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            setPaymentMethodAdded(false);
            handleErrorMsg(errorMessage);
        }
    };
    const VerticalStyledBox = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginTop: '24px',
        marginBottom: '32px'
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(VerticalStyledBox, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b58c2e036fb7cf45$export$8b3e5f2afd424f4d), {
                id: (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW,
                checked: paymentOption === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW,
                label: $4d829621565b6e7b$export$8c0cbd90c1b89ba1?.payNow,
                onChange: handlePaymentSelection,
                value: (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW,
                size: "medium"
            }),
            paymentOption === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                style: {
                    margin: '12px 24px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $21f48350fd4a3de2$export$2e2bcd8739ae039), {
                    handleErrorMsg: handleErrorMsg,
                    paymentMethodsList: paymentMethodsList,
                    setPaymentMethodAdded: setPaymentMethodAdded,
                    paymentMethodAdded: paymentMethodAdded,
                    handlePaymentMethodSelection: handlePaymentMethodSelection,
                    setProcessing: setProcessing,
                    setPaymentMethodsList: setPaymentMethodsList,
                    setIsSnackbarOpen: setIsSnackbarOpen,
                    setSnackbarMessage: setSnackbarMessage
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b58c2e036fb7cf45$export$8b3e5f2afd424f4d), {
                id: (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_LATER,
                checked: paymentOption === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_LATER,
                label: $4d829621565b6e7b$export$8c0cbd90c1b89ba1?.payLater,
                onChange: handlePaymentSelection,
                value: (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_LATER,
                size: "medium",
                sx: {
                    marginTop: "10px"
                }
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");


var $3bYfT = parcelRequire("3bYfT");
const $28a6d9aafed47a89$var$unitMapping = (unit)=>{
    const unitSymbol = {
        'milliliter': 'mL',
        'liter': 'L'
    };
    return unitSymbol?.[unit] || "";
};
const $28a6d9aafed47a89$export$e5712731ce122520 = (orderProducts)=>{
    return orderProducts?.length ? orderProducts.reduce((all, item)=>{
        const displayProductInfo = item?.displayInfo;
        all[item.materialMasterId] = `${displayProductInfo?.name} - ${displayProductInfo?.description} - ${displayProductInfo?.displayAge}`;
        return all;
    }, {}) : {};
};
const $28a6d9aafed47a89$export$90a2edd9d1c709b3 = (orderProducts)=>{
    return orderProducts?.length ? orderProducts.reduce((all, item)=>{
        const displayProductInfo = item?.displayInfo;
        const hasDisplayAge = displayProductInfo?.displayAge?.length > 0;
        const description = displayProductInfo?.description || '';
        const mlIndex = description.indexOf('mL');
        let desc1 = description;
        let desc2 = '';
        if (mlIndex !== -1) {
            desc1 = description.substring(0, mlIndex + 2);
            desc2 = description.substring(mlIndex + 2);
        }
        all[item.materialMasterId] = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontWeight: "700"
                    },
                    children: displayProductInfo?.name
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                color: "#1858CD",
                                fontWeight: "700"
                            },
                            children: desc1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontWeight: "400"
                            },
                            children: [
                                desc2,
                                hasDisplayAge ? ` - ${displayProductInfo.displayAge}` : ""
                            ]
                        })
                    ]
                })
            ]
        });
        return all;
    }, {}) : {};
};
const $28a6d9aafed47a89$export$c078b11950179965 = (allPrices)=>{
    let productPricingMap = allPrices?.productPrices.reduce((all, productPrice)=>{
        return {
            ...all,
            [productPrice?.productId]: {
                listPrice: productPrice?.listPriceFormatted,
                contractPrice: productPrice?.finalPriceFormatted
            }
        };
    }, {}) || {};
    return productPricingMap;
};
const $28a6d9aafed47a89$export$de0176269379a64c = (userDataAddress)=>{
    return {
        "addressId": String(userDataAddress?.id),
        "street1": userDataAddress?.line1,
        "street2": userDataAddress?.line2,
        "city": userDataAddress?.city,
        "state": userDataAddress?.state,
        "zipCode": userDataAddress?.zip,
        "zipExtraFour": userDataAddress?.zipExtension,
        "name": userDataAddress?.dba,
        "contactInfo": {
            "name": userDataAddress?.contactName,
            "email": userDataAddress?.contactEmail,
            "phone": userDataAddress?.contactPhone
        }
    };
};
const $28a6d9aafed47a89$export$a46a89bb23605c9e = (cartDataAddress)=>{
    return {
        id: cartDataAddress?.addressId,
        line1: cartDataAddress?.street1,
        line2: cartDataAddress?.street2,
        city: cartDataAddress?.city,
        state: cartDataAddress?.state,
        zip: cartDataAddress?.zipCode,
        zipExtension: cartDataAddress?.zipExtraFour,
        dba: cartDataAddress?.name,
        contactName: cartDataAddress?.contactInfo?.name,
        contactEmail: cartDataAddress?.contactInfo?.email,
        contactPhone: cartDataAddress?.contactInfo?.phone
    };
};
const $28a6d9aafed47a89$export$a5d3fe5f5ccae992 = (license)=>{
    let licenseName = license?.licenseType === 'medical' ? `${license?.firstName} ${license?.lastName}` : license?.name;
    return licenseName;
};
const $28a6d9aafed47a89$export$9e52003e4f38c9d2 = (licenseSelection)=>{
    return {
        name: $28a6d9aafed47a89$export$a5d3fe5f5ccae992(licenseSelection),
        state: licenseSelection?.state,
        licenseNumber: licenseSelection?.number,
        expirationDate: licenseSelection?.expiration,
        licenseType: "STATE"
    };
};
const $28a6d9aafed47a89$export$f997de3996ee8c85 = (adjustedDoseQty)=>{
    return `Doses rounded up to ${adjustedDoseQty}`;
};
const $28a6d9aafed47a89$export$b286872c1e0ccb06 = ()=>{
    let locale = "en-US";
    const links = [
        {
            label: "Conditions of Use",
            path: "/terms-of-use"
        },
        {
            label: "Privacy Policy",
            path: "/privacy-policy"
        },
        {
            label: "Terms and Conditions of Sale",
            path: "/terms-and-conditions-of-sale"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        variant: "body2",
        children: [
            "I agree to Moderna's\xa0",
            links.map((link, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                            to: `/${locale}${link.path}`,
                            target: "_blank",
                            style: {
                                fontSize: "16px"
                            },
                            children: link.label
                        }),
                        index < links.length - 1 ? ", " : "."
                    ]
                }, link.path))
        ]
    });
};



const $11b7c44202c1dbd2$export$f1c2de779b6eb7bc = ({ label: label, value: value, sx: sx })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        mb: "8px",
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$f1ff1fb39f7795df), {
                id: "label",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$f1ff1fb39f7795df), {
                id: "value",
                children: value
            })
        ]
    });
const $11b7c44202c1dbd2$export$14becdb194ee2b4d = ({ summaryData: summaryData, isOrderDetailsPage: isOrderDetailsPage = false })=>{
    const { totalDoses: totalDoses, contractPrice: contractPrice, taxes: taxes, totalPrice: totalPrice, promptPayEligible: promptPayEligible, promptPayTerms: promptPayTerms, paymentType: paymentType, totalContractPriceWithPromptPay: totalContractPriceWithPromptPay } = summaryData;
    const isTaxPending = summaryData?.isTaxPending ?? true;
    const getPromptPayText = ()=>{
        if (isOrderDetailsPage && paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW) return `Total with prompt pay applied`;
        return promptPayTerms?.timePeriod ? `Total due if paid within ${promptPayTerms?.timePeriod} days of invoicing:` : "If paid within your payment terms:";
    };
    const getPromptPayDiscountAmount = ()=>{
        if (promptPayTerms !== undefined) return (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice * promptPayTerms?.promptPayDiscount / 100);
        return (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(0.00);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        "data-testid": 'invoice-summary',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: `Subtotal (${totalDoses?.toLocaleString()} doses):`,
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(contractPrice),
                sx: {
                    marginBottom: "0px"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Shipping:",
                value: "0.00"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Sales tax:",
                value: isTaxPending ? (0, $5cdc329eeebd56d0$export$268651873d86e2ab) : (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(taxes)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                orientation: "horizontal",
                variant: "middle",
                sx: {
                    marginBottom: 2,
                    marginTop: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Invoice total",
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Prompt pay discount*:",
                value: `-${getPromptPayDiscountAmount()}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                orientation: "horizontal",
                variant: "middle",
                sx: {
                    marginBottom: 2,
                    marginTop: 1
                }
            }),
            promptPayEligible && /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: getPromptPayText(),
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalContractPriceWithPromptPay),
                sx: {
                    "#value, #label": {
                        fontWeight: 700,
                        lineHeight: "28px",
                        fontSize: "20px"
                    }
                }
            })
        ]
    });
};
const $11b7c44202c1dbd2$export$fd4364ffc9af8146 = ({ summaryData: summaryData, isOrderDetailsPage: isOrderDetailsPage = false })=>{
    const showContractPrice = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.showContractPrice);
    const { totalDoses: totalDoses, listPrice: listPrice, contractPrice: contractPrice, taxes: taxes, totalPrice: totalPrice, promptPayEligible: promptPayEligible, promptPayTerms: promptPayTerms, paymentType: paymentType, totalContractPriceWithPromptPay: totalContractPriceWithPromptPay } = summaryData;
    const totalCarton = totalDoses / 10;
    const isTaxPending = summaryData?.isTaxPending ?? true;
    const getPromptPayText = ()=>{
        if (isOrderDetailsPage && paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW) return `Total with prompt pay applied`;
        return promptPayTerms?.timePeriod ? `If paid within ${promptPayTerms?.timePeriod} days of invoicing**` : "If paid within your payment terms**";
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        "data-testid": 'invoice-summary',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Total Doses",
                value: totalDoses?.toLocaleString(),
                sx: {
                    marginBottom: "0px"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Cartons",
                value: `${totalCarton.toLocaleString()} carton${totalCarton !== 1 ? 's' : ''}`,
                sx: {
                    "#label": {
                        visibility: "hidden"
                    },
                    "#value": {
                        fontSize: "14px"
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "List Price",
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(listPrice),
                sx: {
                    "#value": {
                        textDecoration: showContractPrice ? "line-through" : "none"
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Contract Price",
                value: showContractPrice ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(contractPrice) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Taxes*",
                value: isTaxPending ? (0, $5cdc329eeebd56d0$export$268651873d86e2ab) : (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(taxes)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Shipping",
                value: "Free"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                orientation: "horizontal",
                variant: "middle",
                sx: {
                    marginBottom: 2,
                    marginTop: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: "Total",
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice),
                sx: {
                    "#value, #label": {
                        fontWeight: 700,
                        lineHeight: "28px",
                        fontSize: "20px"
                    }
                }
            }),
            promptPayEligible && /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$f1c2de779b6eb7bc, {
                label: getPromptPayText(),
                value: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalContractPriceWithPromptPay),
                sx: {
                    "#value, #label": {
                        fontWeight: 400,
                        lineHeight: "21px",
                        fontSize: "16px"
                    }
                }
            })
        ]
    });
};
const $11b7c44202c1dbd2$export$bdeec1121b193acd = ({ userId: userId, handleErrorMsg: handleErrorMsg, setProcessing: setProcessing, summaryData: summaryData, paymentOption: paymentOption, setPaymentOption: setPaymentOption, paymentMethodsList: paymentMethodsList, setPaymentMethodsList: setPaymentMethodsList, setIsSnackbarOpen: setIsSnackbarOpen, setSnackbarMessage: setSnackbarMessage })=>{
    const [checked, setChecked] = (0, $acw62.useState)(false);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)("");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const checkoutCartData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state?.commerce?.checkoutCartData);
    const cartId = checkoutCartData?.cart?.cartId;
    const selectedPaymentCardInfo = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.selectedPaymentMethod);
    const reservationID = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.reservationConversionID);
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const handlePaymentSelection = (event)=>{
        setPaymentOption(event.target.value);
    };
    const mapCartLineItemsToSnapshots = (checkoutCartData)=>{
        const taxSnapshotMap = {};
        const priceSnapshotMap = {};
        checkoutCartData?.cart?.cartLineItems?.forEach((item)=>{
            taxSnapshotMap[item.cartLineItemId] = item.taxSnapshotId;
            priceSnapshotMap[item.cartLineItemId] = item.priceSnapshotId;
        });
        return {
            cartLineItemIdToTaxSnapshotId: taxSnapshotMap,
            cartLineItemIdToPriceSnapshotId: priceSnapshotMap
        };
    };
    const priceAndTaxSnapshots = mapCartLineItemsToSnapshots(checkoutCartData);
    const createOrderRequestBody = {
        userId: userId,
        cartId: cartId,
        cartLineItemIdToTaxSnapshotId: priceAndTaxSnapshots.cartLineItemIdToTaxSnapshotId,
        cartLineItemIdToPriceSnapshotId: priceAndTaxSnapshots.cartLineItemIdToPriceSnapshotId,
        paymentType: paymentOption,
        paymentMethodId: selectedPaymentCardInfo?.paymentMethodId
    };
    const handlePlaceOrder = async ()=>{
        if (!checked) {
            setErrorMsg("Please accept the agreements above to place this order");
            return;
        }
        setProcessing(true);
        setErrorMsg("");
        try {
            const response = await (0, $8b6f49f5b2fddfb8$export$ac29b122ab5923bd)(createOrderRequestBody);
            if (response?.status === 201) {
                setProcessing(false);
                dispatch((0, $c89d887792446c86$export$afab37d636f63f75)(true));
                if (!!reservationID) dispatch((0, $c89d887792446c86$export$ca51d8f2e5df1a32)(""));
                history.push(`/${locale}/order-confirm`);
            }
        } catch (error) {
            setProcessing(false);
            const response = error?.response?.data;
            const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(response?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    const consentMessage = (0, $28a6d9aafed47a89$export$b286872c1e0ccb06)();
    const invoiceSummary = isDiscountEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$14becdb194ee2b4d, {
        summaryData: summaryData
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($11b7c44202c1dbd2$export$fd4364ffc9af8146, {
        summaryData: summaryData
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        minWidth: "350px",
        maxWidth: "486px",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexDirection: "column",
                padding: "32px"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$b534932db7eb0121), {
                    mb: "24px",
                    textTransform: "capitalize",
                    children: "Summary"
                }),
                invoiceSummary,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    gap: "16px",
                    "data-testid": 'payment-method',
                    mt: 2,
                    mb: 0,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$b534932db7eb0121), {
                        children: "Payment Method"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d829621565b6e7b$export$90ca4d83e0d0cde7), {
                    handlePaymentSelection: handlePaymentSelection,
                    paymentOption: paymentOption,
                    handleErrorMsg: handleErrorMsg,
                    paymentMethodsList: paymentMethodsList,
                    setProcessing: setProcessing,
                    setPaymentMethodsList: setPaymentMethodsList,
                    setIsSnackbarOpen: setIsSnackbarOpen,
                    setSnackbarMessage: setSnackbarMessage
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c576d11d36ade61d$export$48513f6b9f8ce62d), {
                        sx: {
                            alignItems: "flex-start",
                            marginBottom: "24px"
                        },
                        name: "privacyPolicyConsent",
                        label: consentMessage,
                        value: checked,
                        "data-testid": "privacyPolicyConsentCheckbox",
                        onChange: ()=>{
                            setChecked((prev)=>!prev);
                            setErrorMsg("");
                        }
                    })
                }),
                errorMsg && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    color: "#E22929",
                    fontFamily: "Aeonik Regular",
                    fontSize: "16px",
                    fontWeight: "400",
                    children: errorMsg
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "mds-primary",
                    sx: {
                        textTransform: "none",
                        marginTop: "24px"
                    },
                    onClick: handlePlaceOrder,
                    children: "Place Order"
                })
            ]
        })
    });
};






const $2e3ef0f6bbdfbf73$export$7112c5b1b30b4acb = ({ summaryData: summaryData })=>{
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const invoiceSummary = isDiscountEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11b7c44202c1dbd2$export$14becdb194ee2b4d), {
        summaryData: summaryData,
        isOrderDetailsPage: true
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11b7c44202c1dbd2$export$fd4364ffc9af8146), {
        summaryData: summaryData,
        isOrderDetailsPage: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexDirection: "column",
                padding: "32px",
                gap: "24px"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$b534932db7eb0121), {
                    mb: "24px",
                    textTransform: "capitalize",
                    children: "Summary"
                }),
                invoiceSummary,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$b534932db7eb0121), {
                    children: "Payment Method"
                }),
                summaryData.paymentInfo ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be3576d67d7a9b6$export$8279855cac292a9e), {
                    paymentMethod: summaryData.paymentInfo,
                    isOrderDetailsPage: true
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d829621565b6e7b$export$287daadb05956fd4), {})
            ]
        })
    });
};




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

var $ddde1bb88cb108c8$exports = {};
$ddde1bb88cb108c8$exports = new URL("mapIcon.288aa78b.svg", import.meta.url).toString();


var $3ac354e3e0c6d775$exports = {};
$3ac354e3e0c6d775$exports = new URL("coinIcon.89137236.svg", import.meta.url).toString();





var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

const $dd6325901bb18805$var$DisplayProductInfo = (props)=>{
    const { productName: productName, doses: doses, contractPrice: contractPrice, finalPrice: finalPrice } = props;
    const isMresvia = productName.includes("mRESVIA");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            maxWidth: "50%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-bold",
                children: productName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-regular",
                children: [
                    "Doses: ",
                    doses
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-regular",
                children: [
                    "Contract price: ",
                    contractPrice
                ]
            }),
            !isMresvia && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-regular",
                children: [
                    "Price per dose with online discount: ",
                    finalPrice
                ]
            })
        ]
    });
};
const $dd6325901bb18805$var$OrderTable = ({ productRows: productRows, subTotal: subTotal, totalDoses: totalDoses })=>{
    const productDisplay = productRows.map((row, index)=>{
        const itemSubtotal = Number(row.doses) * Number(row.finalPriceValue);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                mt: "spacing-3"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($dd6325901bb18805$var$DisplayProductInfo, {
                    productName: row.title,
                    doses: row.doses,
                    contractPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(row.contractPriceValue),
                    finalPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(row.finalPriceValue)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "body-1-bold",
                    children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(itemSubtotal)
                })
            ]
        }, `product-row-${index}`);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                width: "100%",
                display: "flex",
                justifyContent: "start"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        pt: "spacing-4",
                        pb: "spacing-6"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            mt: "spacing-3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "body-1-medium",
                                                children: "PRODUCT"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "body-1-medium",
                                                children: "SUBTOTAL"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            pt: "spacing-4",
                                            pb: "spacing-2"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                            color: "color-system-gray-300"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            gap: "2",
                                            flexDirection: "column"
                                        },
                                        children: productDisplay
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                pt: "spacing-4",
                                pb: "spacing-2"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                color: "color-system-gray-300"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mt: "spacing-3"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                            variant: "body-1-bold",
                                            children: [
                                                "Subtotal for ",
                                                totalDoses,
                                                " doses"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            variant: "body-1-bold",
                                            children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(subTotal)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $dd6325901bb18805$export$2e2bcd8739ae039 = $dd6325901bb18805$var$OrderTable;


const $711e34918211b6e4$var$TypographyHeading = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`);
const $711e34918211b6e4$var$TypographyText = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`);
const $711e34918211b6e4$var$BoxContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))`
  display: flex;
  border: 1px solid #D1D2D5;
  flex-direction: column;
   .MuiDataGrid-cellContent, .MuiDataGrid-columnHeaderTitle {
    font-size: 16px;
     text-transform: none;
   }
`;
const $711e34918211b6e4$var$columns = [
    {
        field: 'title',
        headerName: 'Item',
        flex: 1,
        minWidth: 100,
        sortable: false
    },
    {
        field: 'doses',
        headerName: 'Doses',
        headerAlign: 'right',
        align: 'right',
        width: 120,
        sortable: false,
        valueFormatter: (params)=>params.value ? params.value.toLocaleString() : ''
    },
    {
        field: 'listPriceValue',
        headerName: 'List Price',
        headerAlign: 'right',
        width: 130,
        align: 'right',
        sortable: false,
        cellClassName: 'listPrice',
        valueFormatter: (params)=>params.value ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(params.value) : ''
    },
    {
        field: 'contractPriceValue',
        headerName: 'Price',
        width: 130,
        headerAlign: 'right',
        align: 'right',
        sortable: false,
        valueFormatter: (params)=>{
            if (params.value === 'Pending') return 'Pending';
            else return params.value ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(params.value) : '';
        }
    }
];
const $711e34918211b6e4$var$NOT_USED = null;
const $711e34918211b6e4$var$BASE_HEIGHT_SMALL = 330;
const $711e34918211b6e4$var$BASE_HEIGHT_MEDIUM = 240;
const $711e34918211b6e4$var$INCREMENT_HEIGHT = 90;
const $711e34918211b6e4$var$OrderSummaryTable = ({ orderDetail: orderDetail, isTaxPending: isTaxPending, sx: sx })=>{
    const showContractPrice = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.showContractPrice);
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const StyledDataGrid = (0, $d8seH.default)((0, $1J2kR.DataGrid))(({ theme: { breakpoints: breakpoints } })=>`
        letter-spacing: -0.32px;
        padding: 14px;
    
        & .listPrice {
            text-decoration: ${showContractPrice ? "line-through" : "none"};
            text-align: right;
        }
    
        & .divider-row [role="cell"] {
            border-color: #85888E;
        }
    
        & .taxes-row {
            min-height: 25px !important;
            max-height: 25px !important;
        
            & [role="cell"] {
                margin-top: unset;
                min-height: 25px !important;
            }
        }
    
        & .MuiDataGrid-row--lastVisible .MuiDataGrid-cell[data-colindex="3"] {
            border-top: 1px solid #D1D2D5;
        }
    
        & .MuiDataGrid-cell[data-field="contractPriceValue"] {
            font-weight: 700;
        }
    
        & .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell {
            white-space: pre-wrap;
        }

        & .MuiDataGrid-row[data-rowindex="3"] .MuiDataGrid-cell[data-field="contractPriceValue"],
        & .MuiDataGrid-row[data-rowindex="4"] .MuiDataGrid-cell[data-field="contractPriceValue"] {
            font-weight: normal;
        }
        
        ${breakpoints.between('sm', 'md')} {
            &[data-testid="product-rows"]{
                height: ${orderDetail?.items?.length * $711e34918211b6e4$var$INCREMENT_HEIGHT + $711e34918211b6e4$var$BASE_HEIGHT_SMALL + 'px !important'};
            }

            & .MuiDataGrid-row:nth-of-type(-n + ${orderDetail?.items?.length}) {
                min-height: 125px !important;
                max-height: 125px !important;
        
                & [role="cell"] {
                min-height: 115px !important;
                max-height: 115px !important;
                }
            }
        }

        ${breakpoints.between('md', 'xl')} {
            &[data-testid="product-rows"] {
                height: ${orderDetail?.items?.length * $711e34918211b6e4$var$INCREMENT_HEIGHT + $711e34918211b6e4$var$BASE_HEIGHT_MEDIUM + 'px !important'};
            }

            & .MuiDataGrid-row:nth-of-type(-n + ${orderDetail?.items?.length}) {
                min-height: 95px !important;
                max-height: 95px !important;

                & [role="cell"] {
                    min-height: 85px !important;
                    max-height: 85px !important;
                }
            }
        }
    `);
    const orderCartEntries = orderDetail?.items || [];
    const getTotalDoses = ()=>{
        return orderCartEntries?.reduce((sum, item)=>sum + item.doses, 0);
    };
    const getTotalPrice = ()=>{
        return orderDetail?.totalContractPrice || getSubtotalContractedPrice() + getTotalTax();
    };
    const getTotalTax = ()=>{
        return orderDetail?.totalTax || (orderCartEntries?.length === 0 ? 0 : orderCartEntries?.filter((row)=>row?.doses !== 0).reduce((sum, item)=>sum + Number(item?.priceTotal?.totalTax?.displayValue || 0), 0));
    };
    const getSubtotalListPrice = ()=>{
        return orderDetail?.subtotalListPrice || (orderCartEntries?.length === 0 ? 0 : orderCartEntries?.reduce((sum, item)=>sum + Number(item?.priceTotal?.subtotalListPrice?.displayValue || 0), 0));
    };
    const getSubtotalContractedPrice = ()=>{
        return orderDetail?.subtotalContractPrice || (orderCartEntries?.length === 0 ? 0 : orderCartEntries?.reduce((sum, item)=>sum + Number(item?.priceTotal?.subtotalContractPrice?.displayValue || 0), 0));
    };
    const constructTableRow = (id, titleCol, listPriceCol, contractPriceCol, finalPriceCol, dosesCol, isDivider)=>{
        return {
            id: id,
            title: titleCol,
            listPriceValue: listPriceCol,
            contractPriceValue: contractPriceCol,
            finalPriceValue: finalPriceCol,
            doses: dosesCol,
            isDivider: isDivider
        };
    };
    const productRows = ()=>{
        const sortedOrderCartEntries = (0, $382eb84981692d3a$export$7699132b966bad47)(orderCartEntries, 'productId');
        let entriesToReturn = sortedOrderCartEntries?.filter((row)=>row?.doses !== 0)?.map((row, index)=>constructTableRow(index, row?.productName, row?.listPrice, row?.contractPrice, row?.finalPrice, row?.doses, index === sortedOrderCartEntries.length - 1 ? true : false)) ?? [];
        return entriesToReturn;
    };
    const getDataGridRows = (0, $acw62.useMemo)(()=>{
        let rows = productRows();
        let taxValue = isTaxPending ? (0, $5cdc329eeebd56d0$export$268651873d86e2ab) : getTotalTax().toString();
        rows.push(constructTableRow(rows.length, 'Subtotal', getSubtotalListPrice(), getSubtotalContractedPrice(), getTotalDoses(), false));
        rows.push(constructTableRow(rows.length, 'Taxes', $711e34918211b6e4$var$NOT_USED, taxValue, $711e34918211b6e4$var$NOT_USED, false));
        rows.push(constructTableRow(rows.length, $711e34918211b6e4$var$NOT_USED, $711e34918211b6e4$var$NOT_USED, getTotalPrice(), $711e34918211b6e4$var$NOT_USED, $711e34918211b6e4$var$NOT_USED, false));
        return rows;
    }, [
        orderCartEntries
    ]);
    const ShippingAndBillingGrid = ({ children: children })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            "data-testid": 'shipping-billing-grid',
            children: children.map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    id: index,
                    sx: {
                        borderRight: '1px solid #D1D2D5',
                        borderBottom: '1px solid #D1D2D5',
                        padding: '16px 24px',
                        '&:nth-of-type(2n)': {
                            borderRight: 'none'
                        }
                    },
                    children: child
                }, index))
        });
    };
    const shippingAndBillingData = ()=>{
        const getAddressDisplay = (address)=>{
            return address?.street1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                        children: address?.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                        children: address?.street1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                        children: address?.street2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                        children: `${address?.city}, ${address?.state}, ${address?.zipCode}`
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                children: "Information not available"
            });
        };
        return [
            {
                icon: {
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports))),
                    alt: "map icon"
                },
                id: "shipTo",
                heading: "Ship to:",
                text: getAddressDisplay(orderDetail?.shipToAddress)
            },
            {
                icon: {
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($3ac354e3e0c6d775$exports))),
                    alt: "coin icon"
                },
                id: "billTo",
                heading: "Bill to:",
                text: getAddressDisplay(orderDetail?.billToAddress)
            },
            {
                id: "poNumber",
                heading: "P.O. Number:",
                text: /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyText, {
                    children: orderDetail?.purchaseOrderNumber
                })
            }
        ];
    };
    const getShippingAndBillingComponents = ()=>{
        let itemsToDisplay = shippingAndBillingData();
        const addressDisplay = (item, index)=>{
            let poNumber = item.id === "billTo" ? itemsToDisplay.find((item)=>item.id === "poNumber") : null;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: "10px",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: item.icon.value,
                            height: "24",
                            width: "24",
                            alt: item.icon.alt
                        })
                    }, `icon-${index}`),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 11,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyHeading, {
                                children: item.heading
                            }),
                            item.text,
                            poNumber && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "left",
                                mt: 2,
                                alignItems: "center",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$TypographyHeading, {
                                        children: poNumber.heading
                                    }),
                                    poNumber.text
                                ]
                            }, `poNumber-${index}`)
                        ]
                    }, `details-${index}`)
                ]
            }, index);
        };
        return [
            'shipTo',
            'billTo'
        ].map((target, index)=>addressDisplay(itemsToDisplay.find((item)=>item.id === target), index));
    };
    const setRowClassName = (params)=>{
        if (params.row.isDivider) return 'divider-row';
        if (params.row.title === 'Taxes') return 'taxes-row';
        return '';
    };
    const table = isDiscountEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd6325901bb18805$export$2e2bcd8739ae039), {
        "data-testid": 'product-rows',
        subTotal: getSubtotalContractedPrice(),
        totalDoses: getTotalDoses(),
        productRows: productRows()
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)(StyledDataGrid, {
        "data-testid": 'product-rows',
        rows: getDataGridRows,
        columns: $711e34918211b6e4$var$columns,
        hideFooter: true,
        disableColumnFilter: true,
        disableColumnMenu: true,
        getRowClassName: setRowClassName,
        onFilterModelChange: (model)=>{}
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: sx,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($711e34918211b6e4$var$BoxContainer, {
            id: "boxContainer",
            display: "flex",
            flexDirection: 'column',
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                minWidth: '350px',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ShippingAndBillingGrid, {
                        children: getShippingAndBillingComponents()
                    }),
                    table
                ]
            })
        })
    });
};
var $711e34918211b6e4$export$2e2bcd8739ae039 = $711e34918211b6e4$var$OrderSummaryTable;










var $ayMG0 = parcelRequire("ayMG0");

var $90a9a6fd651818cd$exports = {};
$90a9a6fd651818cd$exports = new URL("webLinkIcon.91379809.svg", import.meta.url).toString();



const $6f69d471367d2a71$export$aadd96c9c477ee55 = 'inline';
const $6f69d471367d2a71$export$9d708a5dc446e0a = (contentVersion)=>{
    const inlineContent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
            paddingBottom: "15px",
            children: [
                "If your order is tax exempt, please send your tax exempt certificates to ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "https://taxform.modernatx.com/",
                    target: "_blank",
                    style: {
                        fontWeight: 700
                    },
                    children: "taxform.modernatx.com "
                }),
                "If we do not receive a valid tax exempt certificate within 10 days and sales tax applies, we will bill the sales tax amount to you."
            ]
        })
    });
    const blockContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                paddingBottom: "15px",
                children: "If your order is tax-exempt, please send your tax exempt certificates to"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$b534932db7eb0121), {
                color: "#53A1C9",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        height: "30px"
                    },
                    children: [
                        "taxform.modernatx.com",
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "https://taxform.modernatx.com/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($90a9a6fd651818cd$exports))),
                                height: "20px",
                                alt: "Tax Exempt",
                                style: {
                                    verticalAlign: "middle",
                                    paddingLeft: "5px"
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                paddingTop: "15px",
                children: "If we do not receive a valid tax exempt certificate within 10 days and sales tax applies, we will bill the sales tax amount to you."
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: contentVersion === $6f69d471367d2a71$export$aadd96c9c477ee55 ? inlineContent : blockContent
    });
};





const $3a8a12426eb7a536$export$490c9e50f95ca2e7 = {
    shipperNotReadyHeader: 'Orders will begin shipping mid-July 2024',
    shipperNotReadyMessage: "Your orders will appear \u201Con hold\u201D until orders begin to ship mid-July 2024.",
    customerNotConfirmedHeader: 'Your account is being validated',
    customerNotConfirmedMessage: "Your orders will appear \u201Con hold\u201D until your account is fully validated. We will contact you if we need any other information. No further action is required at this time.",
    customerAndShipperNotReadyHeader: 'Your account is being validated',
    customerAndShipperNotReadyMessage: "Your orders will appear \u201Con hold\u201D until all details in your account are validated. Orders begin to ship mid-July 2024.",
    defaultOnHoldHeader: 'Your order is on hold',
    defaultOnHoldMessage: 'We will contact you if we need any additional information. No further action is required at this time.',
    productNotReadyHeader: 'Your order is pending shipping approval',
    productNotReadyMessage: "Your order will appear \u201Con hold\u201D until it is ready to ship. We will contact you if we need any other information. No further action is required at this time."
};



const $c7d4a6b96b05e4bf$var$BannerStyle = {
    padding: "5px",
    color: "#0379B2"
};
const $c7d4a6b96b05e4bf$var$OrderNotFoundBannerContent = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$94944d8910c4db4b), {
        children: [
            "We could not locate this order. If you have multiple Moderna Direct accounts, please make sure you are logged in to the correct account. If the problem persists, please ",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                to: "/contact-us",
                children: "Contact Us"
            }),
            "."
        ]
    });
};
const $c7d4a6b96b05e4bf$var$OrderDetailsPage = ()=>{
    const alertRef = (0, $acw62.useRef)(null);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const products = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.productsData);
    const orderDetails = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.currentOrderData?.data?.order);
    const { userId: userId } = userData;
    const { id: orderId } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)();
    const [isTaxPending, setIsTaxPending] = (0, $acw62.useState)(false);
    const [paymentInfo, setPaymentInfo] = (0, $acw62.useState)(null);
    const [orderNotFound, setOrderNotFound] = (0, $acw62.useState)(false);
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    (0, $acw62.useEffect)(()=>{
        setProcessing(true);
        dispatch((0, $8b6f49f5b2fddfb8$export$fad077ca3a0b9035)({
            userId: userId,
            orderId: orderId
        })).unwrap().then(async (res)=>{
            const order = res?.data?.order;
            dispatch((0, $53476aa40d2bc637$export$843e6d82ee53ff2c)({
                currentOrderData: order
            }));
            let paymentType = res?.paymentType;
            if (paymentType === (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_NOW) await (0, $36d886fe12e537c3$export$81713a21f003821b)({}).then(async (response)=>{
                if (response.status === 200) {
                    const allPaymentMethods = await fetchAllPaymentMethods();
                    const paymentMethodUsed = allPaymentMethods.find((pm)=>pm.paymentMethodId === res?.paymentMethodId);
                    setPaymentInfo(paymentMethodUsed);
                }
            }).catch((err)=>{
                let errMsg = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(err?.response?.data?.errorCode);
                setError(errMsg);
                alertRef.current?.openAlert(err);
                setProcessing(false);
            });
            const { isTaxComputed: isTaxComputed, taxOverrideDetails: taxOverrideDetails } = order?.orderPriceTotals || {};
            const taxExemptionSelected = taxOverrideDetails?.taxExemptionOverrideReason === (0, $5cdc329eeebd56d0$export$5b397dffa4d78add).CUSTOMER_SELF_SELECTION;
            setIsTaxPending((!isTaxComputed && !taxExemptionSelected) ?? true);
            setProcessing(false);
        }).catch((err)=>{
            //if orderID is not found
            if (err?.errorCode === (0, $b1c33141448092cf$export$be58a38ca267dc5f)?.GENERAL?.RESOURCE_NOT_FOUND) setOrderNotFound(true);
            else {
                setError(err?.message);
                alertRef.current?.openAlert(err);
            }
            setProcessing(false);
        });
    }, [
        dispatch,
        orderId,
        userId
    ]);
    const fetchAllPaymentMethods = async (nextToken = null, paymentMethods = [])=>{
        try {
            const response = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                nextToken: nextToken
            });
            if (response.status === 200) {
                const newPaymentMethods = paymentMethods.concat(response?.data?.paymentMethodsList || []);
                if (response.data.nextToken) return fetchAllPaymentMethods(response.data.nextToken, newPaymentMethods);
                return newPaymentMethods;
            }
        } catch (error) {
            let errMsg = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
            setError(errMsg);
            alertRef.current?.openAlert(error);
            setProcessing(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        try {
            setProcessing(true);
            let promise = dispatch((0, $6361b14d09f5d8cd$export$68a801b7b3c0bfaa)({
                locale: 'US'
            })).unwrap();
            promise.then(()=>{
                setProcessing(false);
            });
        } catch (err) {
            setError(err?.message);
            alertRef.current?.openAlert(err);
            setProcessing(false);
        }
    }, [
        dispatch
    ]);
    const productMap = (0, $28a6d9aafed47a89$export$e5712731ce122520)(products);
    const formattedOrderDetail = (0, $acw62.useMemo)(()=>{
        return {
            subtotalListPrice: orderDetails?.orderPriceTotals?.subtotalListPrice?.displayValue,
            subtotalContractPrice: orderDetails?.orderPriceTotals?.subtotalContractPrice?.displayValue,
            totalTax: orderDetails?.orderPriceTotals?.totalTax?.displayValue,
            totalContractPrice: orderDetails?.orderPriceTotals?.totalContractPrice?.displayValue,
            purchaseOrderNumber: orderDetails?.purchaseOrderNumber,
            shipToAddress: {
                ...orderDetails?.shipToAddress
            },
            billToAddress: {
                ...orderDetails?.billToAddress
            },
            items: orderDetails?.orderLineItems?.map((item)=>{
                return {
                    //todo what to do if didn't find matched name for productId?
                    productName: productMap[item?.productId],
                    productId: item?.productId,
                    listPrice: item?.unitListPrice?.displayValue,
                    contractPrice: isDiscountEnabled ? item?.unitOriginalContractPrice?.displayValue : item?.unitContractPrice?.displayValue,
                    finalPrice: item?.unitContractPrice?.displayValue,
                    doses: item?.quantity
                };
            })
        };
    }, [
        orderDetails,
        productMap
    ]);
    const summaryData = (0, $acw62.useMemo)(()=>{
        const orderPriceDetails = orderDetails?.orderPriceTotals;
        return {
            paymentType: orderDetails?.paymentType,
            promptPayEligible: orderPriceDetails?.promptPayEligible,
            promptPayTerms: orderPriceDetails?.promptPayTerms,
            totalContractPriceWithPromptPay: orderPriceDetails?.totalContractPriceWithPromptPay?.displayValue,
            totalDoses: orderDetails?.totalQuantity || orderDetails?.orderLineItems?.reduce((sum, item)=>sum + item.quantity, 0),
            totalPrice: orderPriceDetails?.totalContractPrice?.displayValue,
            listPrice: orderPriceDetails?.subtotalListPrice?.displayValue,
            contractPrice: orderPriceDetails?.subtotalContractPrice?.displayValue,
            savings: orderPriceDetails?.discountTotal?.displayValue,
            taxes: orderPriceDetails?.totalTax?.displayValue,
            isTaxPending: isTaxPending,
            paymentInfo: paymentInfo
        };
    }, [
        orderDetails,
        isTaxPending,
        paymentInfo
    ]);
    const getHoldMessage = (orderHoldReasons)=>{
        const customerNotConfirmedWithShipper = orderHoldReasons.includes("CUSTOMER_NOT_CONFIRMED_WITH_SHIPPER");
        const shipperNotReady = orderHoldReasons.includes("SHIPPER_NOT_TAKING_ORDERS");
        const productNotReady = orderHoldReasons.includes("PRODUCT_NOT_READY_FOR_SHIPPING");
        if (customerNotConfirmedWithShipper && shipperNotReady) return {
            headerText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.customerAndShipperNotReadyHeader,
            messageText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.customerAndShipperNotReadyMessage
        };
        if (customerNotConfirmedWithShipper) return {
            headerText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.customerNotConfirmedHeader,
            messageText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.customerNotConfirmedMessage
        };
        if (shipperNotReady) return {
            headerText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.shipperNotReadyHeader,
            messageText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.shipperNotReadyMessage
        };
        if (productNotReady) return {
            headerText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.productNotReadyHeader,
            messageText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.productNotReadyMessage
        };
        return {
            headerText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.defaultOnHoldHeader,
            messageText: (0, $3a8a12426eb7a536$export$490c9e50f95ca2e7)?.defaultOnHoldMessage
        };
    };
    const getBannerInfo = (0, $acw62.useCallback)((orderStatus)=>{
        switch(orderStatus){
            case "ON_HOLD":
            case "INTERNAL_HOLD":
                if (orderDetails?.orderHoldReasons.length > 0) {
                    const holdMessage = getHoldMessage(orderDetails.orderHoldReasons);
                    return {
                        type: "warning",
                        headerText: holdMessage?.headerText,
                        bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: holdMessage?.messageText
                        }),
                        dataTestId: "OrderDetailStatusBanner"
                    };
                } else return {
                    type: "warning",
                    headerText: "Your order is on hold",
                    bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "This order has been placed on hold. Please",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: "/contact-us",
                                style: $c7d4a6b96b05e4bf$var$BannerStyle,
                                children: "Contact us"
                            }),
                            "with any questions."
                        ]
                    }),
                    dataTestId: "OrderDetailStatusBanner"
                };
            case "CANCELLED":
                return {
                    type: "canceled",
                    headerText: "This order has been cancelled",
                    bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "This order has been cancelled. Please",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: "/contact-us",
                                style: $c7d4a6b96b05e4bf$var$BannerStyle,
                                children: "Contact us"
                            }),
                            "for more information or for help replacing your order."
                        ]
                    }),
                    dataTestId: "OrderDetailStatusBanner"
                };
            case "COMPLETED":
            case "FULFILLED":
                return {
                    type: "shipped",
                    headerText: orderDetails?.orderShippedDate ? `This order shipped on ${(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(orderDetails?.orderShippedDate, 'YYYY-MM-DD').format('MMMM D, YYYY')}` : "This order has shipped",
                    bannerContentComponent: orderDetails?.shipment?.shipper === "UPS" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                children: "Carrier: UPS"
                            }),
                            orderDetails?.shipment?.trackingId && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                children: [
                                    "Tracking number:",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                                        target: "_blank",
                                        rel: "#trackingNumber",
                                        href: `https://www.ups.com/track?trackingNumber=${orderDetails?.shipment?.trackingId}`,
                                        style: $c7d4a6b96b05e4bf$var$BannerStyle,
                                        children: orderDetails?.shipment?.trackingId
                                    })
                                ]
                            })
                        ]
                    }),
                    dataTestId: "OrderDetailStatusBanner"
                };
            case "CREATED":
            case "CONFIRMED":
            case "PENDING":
            default:
                return {
                    type: "info",
                    headerText: "This order is processing",
                    bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "For questions about your order please",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                to: "/contact-us",
                                style: $c7d4a6b96b05e4bf$var$BannerStyle,
                                children: "Contact us"
                            })
                        ]
                    }),
                    dataTestId: "OrderDetailStatusBanner"
                };
        }
    }, [
        orderDetails?.orderId,
        orderDetails?.orderShippedDate
    ]);
    const bannerInfo = (0, $acw62.useMemo)(()=>{
        return getBannerInfo(orderDetails?.orderStatus);
    }, [
        getBannerInfo,
        orderDetails?.orderStatus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: error,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            orderNotFound ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mt: 10,
                    mb: 40,
                    ml: 6,
                    mr: 6,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                        type: "canceled",
                        headerText: 'Order not found',
                        bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($c7d4a6b96b05e4bf$var$OrderNotFoundBannerContent, {}),
                        dataTestId: "OrderNotFoundBanner"
                    })
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                "data-testid": "orderDetailContainer",
                container: true,
                spacing: {
                    xs: 1,
                    lg: 4
                },
                padding: {
                    xs: 2,
                    md: 3,
                    lg: 12
                },
                children: [
                    orderDetails?.orderStatus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                            type: bannerInfo?.type,
                            headerText: bannerInfo?.headerText,
                            bannerContentComponent: bannerInfo?.bannerContentComponent,
                            dataTestId: bannerInfo?.dataTestId
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                            type: "info",
                            headerText: "Tax-exempt",
                            bannerContentComponent: (0, $6f69d471367d2a71$export$9d708a5dc446e0a)((0, $6f69d471367d2a71$export$aadd96c9c477ee55)),
                            dataTestId: "TaxInstructionSection"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            "data-testid": "orderDetailsPageHeader",
                            sx: {
                                fontSize: "30px",
                                fontWeight: 500,
                                lineHeight: "36px",
                                fontFamily: "Aeonik Regular"
                            },
                            children: `Order #${orderDetails?.orderNumber}`
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        "data-testid": "order-summary-table",
                        item: true,
                        sm: 12,
                        lg2: 8,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $711e34918211b6e4$export$2e2bcd8739ae039), {
                            orderDetail: formattedOrderDetail,
                            isTaxPending: isTaxPending,
                            sx: {
                                '#boxContainer': "33px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        "data-testid": "order-summary-card",
                        item: true,
                        sm: 12,
                        lg2: 4,
                        overflow: "unset",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e3ef0f6bbdfbf73$export$7112c5b1b30b4acb), {
                            summaryData: summaryData
                        })
                    })
                ]
            })
        ]
    });
};
var $c7d4a6b96b05e4bf$export$2e2bcd8739ae039 = $c7d4a6b96b05e4bf$var$OrderDetailsPage;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $gd5y7 = parcelRequire("gd5y7");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $2ff57fd6d94f368c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($2ff57fd6d94f368c$exports, "__esModule", {
    value: true
});
$2ff57fd6d94f368c$exports.default = void 0;

var $2ff57fd6d94f368c$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2ff57fd6d94f368c$var$_default = $2ff57fd6d94f368c$exports.default = (0, $2ff57fd6d94f368c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');


var $b80f590192083ee3$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($b80f590192083ee3$exports, "__esModule", {
    value: true
});
$b80f590192083ee3$exports.default = void 0;

var $b80f590192083ee3$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b80f590192083ee3$var$_default = $b80f590192083ee3$exports.default = (0, $b80f590192083ee3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');









const $ebf8ed1073bca846$export$1f58f750f20f344b = ({ loginError: loginError })=>{
    const { handleCloseModal: handleCloseModal, postLoginRedirectPath: postLoginRedirectPath, setPostLoginRedirectPath: setPostLoginRedirectPath } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [invalidEmail, setInvalidEmail] = (0, $acw62.useState)("");
    const [invalidPassword, setInvalidPassword] = (0, $acw62.useState)("");
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const invalidEmailFormatErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "INVALID_EMAIL_FORMAT");
    const invalidEmailFormatError = invalidEmailFormatErrorData && invalidEmailFormatErrorData[0]?.fields?.message;
    const alertRef = (0, $acw62.useRef)(null);
    const [values, setValues] = (0, $acw62.useState)({
        email: '',
        password: '',
        showPassword: false
    });
    const { signIn: signIn } = (0, $dc2be56a937776c4$export$1d39dc5b47e56ff0)({
        setInvalidPassword: setInvalidPassword,
        setProcessing: setProcessing
    });
    const handleChange = (prop)=>(event)=>{
            setValues({
                ...values,
                [prop]: event.target.value
            });
            setInvalidEmail("");
            setInvalidPassword("");
        };
    const handleClickShowPassword = ()=>{
        setValues({
            ...values,
            showPassword: !values.showPassword
        });
    };
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleLoginSubmit = async (event)=>{
        event.preventDefault();
        dispatch((0, $c89d887792446c86$export$7ffa46ddfa066ef4)(values.email));
        dispatch((0, $c89d887792446c86$export$3891ea45be4fea53)(true));
        const onSuccess = ()=>{
            if (postLoginRedirectPath) setPostLoginRedirectPath(null);
            else closeLoginModal();
        };
        const { isValid: isValid, errors: errors } = (0, $382eb84981692d3a$export$100ac8a83b695e8)(values.email, values.password, invalidEmailFormatError);
        if (!isValid) {
            setInvalidEmail(errors.email);
            setInvalidPassword(errors.password);
            return;
        }
        await signIn(values.email, values.password, onSuccess, postLoginRedirectPath);
        dispatch((0, $c89d887792446c86$export$3891ea45be4fea53)(false));
    };
    const closeLoginModal = ()=>{
        handleCloseModal();
    };
    const isOutageBannerEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_SITE_OUTAGE_BANNER_ENABLED");
    (0, $acw62.useEffect)(()=>{
        if (loginError && alertRef.current) alertRef.current?.openAlert();
    }, [
        loginError
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        width: "408px",
        display: "flex",
        flexDirection: 'column',
        children: [
            loginError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: loginError,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontSize: '24px',
                fontFamily: 'Aeonik Regular',
                fontWeight: 700,
                lineHeight: '30px',
                paddingBottom: '16px',
                display: 'flex',
                children: "Log In"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: handleLoginSubmit,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                display: "flex",
                                paddingBottom: '8px',
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                id: "email",
                                placeholder: "Enter your email address",
                                value: values.email,
                                onChange: handleChange('email'),
                                helperText: invalidEmail,
                                error: !!invalidEmail,
                                variant: "outlined",
                                margin: "dense",
                                display: "flex",
                                focused: true,
                                inputProps: {
                                    'data-testid': "email-input",
                                    'aria-label': "email-input"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                display: "flex",
                                paddingBottom: '8px',
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                id: "password",
                                placeholder: "Enter your password",
                                type: values.showPassword ? 'text' : 'password',
                                error: !!invalidPassword,
                                value: values.password,
                                onChange: handleChange('password'),
                                helperText: invalidPassword,
                                variant: "outlined",
                                margin: "dense",
                                display: "flex",
                                focused: true,
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            "aria-label": "toggle password visibility",
                                            onClick: handleClickShowPassword,
                                            onMouseDown: handleMouseDownPassword,
                                            edge: "end",
                                            children: values.showPassword ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ff57fd6d94f368c$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b80f590192083ee3$exports))), {})
                                        })
                                    })
                                },
                                inputProps: {
                                    'data-testid': "password-input",
                                    'aria-label': "password-input"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        id: "forgotPassword",
                        "data-testid": "forgotPasswordLink",
                        to: `/${locale}/request-reset-password`,
                        onClick: closeLoginModal,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            variant: 'link',
                            component: 'div',
                            color: 'secondary.textLinks',
                            display: 'flex',
                            padding: '10px 0px',
                            children: "Reset your password"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingTop: "20px",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            "data-testid": "loginSubmitBtn",
                            sx: {
                                display: "flex",
                                textTransform: "none"
                            },
                            onClick: handleLoginSubmit,
                            loading: processing,
                            buttonType: "mds-primary",
                            disabled: isOutageBannerEnabled,
                            children: "Log In"
                        })
                    })
                ]
            })
        ]
    });
};




const $364a93698e860677$export$b4d7a44be6f5e733 = ({ isLoginModalOpen: isLoginModalOpen, handleCloseModal: handleCloseModal, postLoginRedirectPath: postLoginRedirectPath, handleOpenCreateAccountModal: handleOpenCreateAccountModal, loginError: loginError })=>{
    const theme = (0, $14H9o.default)();
    const handleCreateAccount = ()=>{
        handleOpenCreateAccountModal();
    };
    const isOutageBannerEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_SITE_OUTAGE_BANNER_ENABLED");
    const loginFormContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: 'flex',
        flexDirection: 'row',
        gap: '24px',
        sx: {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                alignItems: 'center'
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf8ed1073bca846$export$1f58f750f20f344b), {
                postLoginRedirectPath: postLoginRedirectPath,
                loginError: loginError
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                component: 'div',
                sx: {
                    border: "1px solid",
                    borderColor: 'neutral.gray6',
                    height: '330px',
                    [theme.breakpoints.down('sm')]: {
                        width: '100%',
                        height: '1px',
                        margin: '24px 0'
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '302px',
                height: "320px",
                gap: '24px',
                display: "flex",
                flexDirection: 'column',
                alignItems: 'flex-start',
                sx: {
                    [theme.breakpoints.down('sm')]: {
                        width: '100%',
                        alignItems: 'flex-start',
                        textAlign: 'left'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontSize: '24px',
                        fontFamily: 'Aeonik Regular',
                        fontWeight: 700,
                        lineHeight: '30px',
                        children: "Create an account"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontSize: '16px',
                        fontFamily: 'Aeonik Regular',
                        fontWeight: 400,
                        textAlign: 'left',
                        lineHeight: '22px',
                        children: "To order, please create an account for Moderna Direct, even if you have an account on other Moderna websites."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        "data-testid": "createAccountBtn",
                        sx: {
                            height: '48px',
                            textTransform: "none"
                        },
                        buttonType: "mds-primary",
                        onClick: handleCreateAccount,
                        disabled: isOutageBannerEnabled,
                        children: "Create a new account"
                    }),
                    isOutageBannerEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "caption",
                        color: "error",
                        sx: {
                            mt: 1,
                            textAlign: 'left'
                        },
                        children: "Account login and creation is temporarily disabled due to scheduled maintenance."
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: isLoginModalOpen,
        closeModalHandler: handleCloseModal,
        modalContent: loginFormContent,
        style: {
            width: '829px',
            padding: '24px',
            alignItems: 'flex-start',
            display: 'flex',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                width: '80%',
                maxWidth: '100vw',
                padding: '16px',
                margin: '80px 0px 0px 0px'
            }
        },
        dataTestId: "loginModal"
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $8AyZl = parcelRequire("8AyZl");
var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $kSnzZ = parcelRequire("kSnzZ");

var $awhpc = parcelRequire("awhpc");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $cpXNi = parcelRequire("cpXNi");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $558d665a4b71ad4c$export$ccdb26aeba48a86e), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b23cfd2067550897$export$5682c366c0c669d9), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $cpXNi.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $6n0Ko.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $awhpc.default)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $awhpc.default)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9924235485c5a222$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;


var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $d8seH = parcelRequire("d8seH");




var $adc6477c34c07c38$exports = {};
$adc6477c34c07c38$exports = new URL("uncheckedCircle.b437806c.svg", import.meta.url).toString();


var $ce1dc73dd16e2c70$exports = {};
$ce1dc73dd16e2c70$exports = new URL("checkedCircle.1cc2ecd3.svg", import.meta.url).toString();







const $b78d475acd1574e6$export$2eca89e9ac669625 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("commerce/createIdentity", async ({ payload: payload }, { rejectWithValue: rejectWithValue })=>{
    try {
        const res = await (0, $d2ce41b179fcf973$export$2e2bcd8739ae039)({
            url: `identityservice/v1/identity`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        if (!error.response) throw error;
        return rejectWithValue(error.response);
    }
});
const $b78d475acd1574e6$export$9b1c2bd047972f19 = async (payload)=>{
    try {
        const res = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
            url: `identityservice/v1/identity/registerExistingUser`,
            method: "POST",
            data: JSON.stringify(payload)
        });
        return res;
    } catch (error) {
        throw error;
    }
};




const $05acdc0118f3a485$var$RequiredSymbol = (0, $d8seH.default)('span')({
    color: 'red'
});
const $05acdc0118f3a485$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    display: "flex",
    justifyContent: 'left',
    marginY: "24px"
};
const $05acdc0118f3a485$var$helperTextStyles = {
    sx: {
        '&.Mui-error': {
            color: '#E22929',
            fontFamily: 'Aeonik Regular',
            marginLeft: '0',
            fontSize: '14px',
            letterSpacing: '-0.28px'
        }
    }
};
const $05acdc0118f3a485$var$FormLabel = ({ label: label })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        textAlign: "left",
        paddingBottom: "7px",
        fontFamily: "Aeonik Regular",
        color: "neutral.gray7",
        fontWeight: "700",
        children: [
            label,
            /*#__PURE__*/ (0, $ayMG0.jsx)($05acdc0118f3a485$var$RequiredSymbol, {
                children: "*"
            })
        ]
    });
};
const $05acdc0118f3a485$var$CHECK_PASSWORD_REQUIREMENTS = 'Check password requirements and retry.';
const $05acdc0118f3a485$export$6b46babcc2b5aac3 = ({ isCreateAccountModalOpen: isCreateAccountModalOpen, handleCloseModal: handleCloseModal })=>{
    const theme = (0, $14H9o.default)();
    const defaultFields = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: ''
    };
    const defaultPasswordCriteria = {
        minLength: false,
        containsLowercase: false,
        containsUppercase: false,
        containsNumber: false,
        containsSpecialChar: false,
        passwordsMatch: false
    };
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultFields);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const [passwordCriteria, setPasswordCriteria] = (0, $acw62.useState)(defaultPasswordCriteria);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const UncheckedCircleIcon = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($adc6477c34c07c38$exports))),
            alt: "circle icon",
            width: "24px",
            height: "24px"
        });
    };
    const CheckedCircleIcon = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ce1dc73dd16e2c70$exports))),
            alt: "checked circle icon",
            width: "24px",
            height: "24px"
        });
    };
    const PasswordCriteriaListItem = (criteria, message)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f92832698674c928$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                gap: '8px',
                padding: '0'
            },
            children: [
                passwordCriteria[criteria] ? /*#__PURE__*/ (0, $ayMG0.jsx)(CheckedCircleIcon, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)(UncheckedCircleIcon, {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    color: "neutral.gray7",
                    fontFamily: "Aeonik Regular",
                    letterSpacing: "-0.32px",
                    children: message
                })
            ]
        });
    };
    const textFieldStyles = (name)=>{
        return {
            "& input": {
                padding: "12px",
                height: '24px'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                '&:hover fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #545F71'
                },
                '&.Mui-focused fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #545F71'
                }
            }
        };
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: value
        };
        setInputFields(newInputFields);
        if (name === 'password' || name === 'confirmPassword') validatePassword(newInputFields.password, newInputFields.confirmPassword);
    };
    const handleBlur = (event)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateField(name, value, inputFields.password);
        setErrors({
            ...errors,
            [name]: errorMsg
        });
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const validationErrors = {};
        Object.keys(inputFields).forEach((fieldName)=>{
            const errorMsg = validateField(fieldName, inputFields[fieldName], inputFields.password);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        if (Object.keys(validationErrors).length === 0) {
            const submitData = {
                firstName: inputFields.firstName,
                lastName: inputFields.lastName,
                emailAddress: inputFields.email,
                password: inputFields.password
            };
            try {
                setProcessing(true);
                const response = await dispatch((0, $b78d475acd1574e6$export$2eca89e9ac669625)({
                    payload: submitData
                })).unwrap();
                dispatch((0, $c89d887792446c86$export$7ffa46ddfa066ef4)(inputFields.email));
                setInputFields(defaultFields);
                setPasswordCriteria(defaultPasswordCriteria);
                if (response.status === 200) {
                    localStorage.setItem('awaitingEmailVerification', 'true');
                    setProcessing(false);
                    history.push(`/${locale}/registration/email-verification`);
                    handleCloseModal();
                }
            } catch (error) {
                if (error?.status === 409) setErrors({
                    email: 'This email address already exists. Please try logging in.'
                });
                else if (error?.status === 400 && error?.data?.recommendation === $05acdc0118f3a485$var$CHECK_PASSWORD_REQUIREMENTS) setErrors({
                    password: 'For security reasons, your password cannot contain parts of your username.'
                });
                else alertRef.current?.openAlert(error);
            } finally{
                setProcessing(false);
            }
        } else setErrors(validationErrors);
    };
    const togglePasswordVisibility = ()=>{
        setShowPassword(!showPassword);
    };
    const toggleConfirmPasswordVisibility = ()=>{
        setShowConfirmPassword(!showConfirmPassword);
    };
    const validatePassword = (password, confirmPassword)=>{
        const minLength = password.length >= 12;
        const containsLowercase = /[a-z]/.test(password);
        const containsUppercase = /[A-Z]/.test(password);
        const containsNumber = /\d/.test(password);
        const containsSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const passwordsMatch = password === confirmPassword;
        setPasswordCriteria({
            minLength: minLength,
            containsLowercase: containsLowercase,
            containsUppercase: containsUppercase,
            containsNumber: containsNumber,
            containsSpecialChar: containsSpecialChar,
            passwordsMatch: passwordsMatch
        });
    };
    const validateField = (name, value, password)=>{
        let errorMsg = "";
        if (!value.trim()) errorMsg = "Required";
        else if (name === "firstName" || name === "lastName") {
            if (/[\d]/.test(value)) errorMsg = "This field cannot contain numbers";
            else if (!/^[a-zA-Z'.`\-\s]*$/.test(value)) errorMsg = "This field cannot contain special characters";
            else if (value.length > 50) errorMsg = "Max 50 characters allowed";
        } else if (name === "email") {
            const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(value)) errorMsg = "Please enter a valid email address";
            else if (/^.*@moderna@\.com$/i.test(value)) errorMsg = "Email from modernatx@.com is not allowed";
        } else if (name === "password") {
            if (value.length < 12) errorMsg = "Passwords must be at least 12 characters";
            else if (!/[a-z]/.test(value)) errorMsg = "Passwords must contain a lower-case letter";
            else if (!/[A-Z]/.test(value)) errorMsg = "Passwords must contain an upper-case letter";
            else if (!/\d/.test(value)) errorMsg = "Password must contain a number";
            else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) errorMsg = "Passwords must contain a special character";
            else if (/moderna/i.test(value)) errorMsg = "Password should not contain 'Moderna'";
        } else if (name === "confirmPassword") {
            if (value !== password) errorMsg = "Passwords do not match";
        }
        return errorMsg;
    };
    const PasswordCriteriaList = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: "8px"
            },
            children: [
                PasswordCriteriaListItem('minLength', 'Be at least 12 characters'),
                PasswordCriteriaListItem('containsUppercase', 'Contain an upper-case letter'),
                PasswordCriteriaListItem('containsLowercase', 'Contain a lower-case letter'),
                PasswordCriteriaListItem('containsNumber', 'Contain a number'),
                PasswordCriteriaListItem('containsSpecialChar', 'Contain a special character (!, ?, &, @, etc)'),
                PasswordCriteriaListItem('passwordsMatch', 'Match')
            ]
        });
    const createTextField = (name, label, type = 'text', value, onChange, onBlur, showPasswordToggle = false, toggleVisibility, autoComplete)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($05acdc0118f3a485$var$FormLabel, {
                    label: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: name,
                    "data-testid": name,
                    name: name,
                    type: showPasswordToggle ? 'text' : type,
                    value: value,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    sx: textFieldStyles(name),
                    autoComplete: autoComplete,
                    error: Boolean(errors[name]),
                    helperText: errors[name],
                    FormHelperTextProps: $05acdc0118f3a485$var$helperTextStyles,
                    InputProps: type === 'password' ? {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                            position: "end",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                "aria-label": "toggle password visibility",
                                onClick: toggleVisibility,
                                onMouseDown: (event)=>event.preventDefault(),
                                edge: "end",
                                children: showPasswordToggle ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ff57fd6d94f368c$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b80f590192083ee3$exports))), {})
                            })
                        })
                    } : undefined,
                    inputProps: {
                        'data-testid': `${name}-input`,
                        'aria-label': `${name}`
                    }
                })
            ]
        });
    };
    const CreateAccountForm = /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
            "data-testid": "createAccountContainer",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginBottom: "20px",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "left",
                        fontFamily: "Aeonik Regular",
                        letterSpacing: "-0.32px",
                        children: "Please enter your business email address and password to get started."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    rowSpacing: '16px',
                    columnSpacing: '16px',
                    justifyContent: "start",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 6,
                            paddingBottom: '1px',
                            children: createTextField("firstName", "Your first name", "text", inputFields.firstName, handleChange, handleBlur)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 6,
                            paddingBottom: '1px',
                            children: createTextField("lastName", "Your last name", "text", inputFields.lastName, handleChange, handleBlur)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            paddingBottom: '1px',
                            children: createTextField("email", "Email address", "text", inputFields.email, handleChange, handleBlur)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            paddingBottom: '1px',
                            children: createTextField("password", "Password", "password", inputFields.password, handleChange, handleBlur, showPassword, togglePasswordVisibility, "new-password")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            paddingBottom: '1px',
                            children: createTextField("confirmPassword", "Re-enter password", "password", inputFields.confirmPassword, handleChange, handleBlur, showConfirmPassword, toggleConfirmPasswordVisibility, "new-password")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 12,
                            paddingBottom: '1px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    textAlign: "left",
                                    paddingBottom: "7px",
                                    fontFamily: "Aeonik Regular",
                                    color: "neutral.gray7",
                                    fontWeight: "700",
                                    children: "Passwords must:"
                                }),
                                PasswordCriteriaList()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    sx: $05acdc0118f3a485$var$buttonsContainerSxStyles,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        type: "submit",
                        id: "submit",
                        sx: {
                            padding: "16px 24px",
                            textTransform: "none"
                        },
                        buttonType: "mds-primary",
                        "data-testid": "submitBtn",
                        loading: processing,
                        children: "Continue"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: generalApiError,
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                title: "Welcome to ModernaDirect.com",
                openModal: isCreateAccountModalOpen,
                closeModalHandler: handleCloseModal,
                modalContent: CreateAccountForm,
                style: {
                    '#crossIcon': {
                        marginTop: '5px'
                    },
                    '#titleContainer': {
                        padding: '5px',
                        marginBottom: '0px'
                    },
                    width: 'auto',
                    maxWidth: '548px',
                    padding: '32px',
                    '#modalTitle': {
                        marginRight: {
                            xs: '40px'
                        }
                    },
                    [theme.breakpoints.down('md')]: {
                        width: '500px'
                    },
                    [theme.breakpoints.down('sm')]: {
                        width: '350px',
                        marginTop: '60px'
                    }
                },
                dataTestId: "registrationModal"
            })
        ]
    });
};


const $dca7abfdcf9292a4$export$178405afcd8c5eb = ({ children: children })=>{
    const [isLoginModalOpen, setLoginModalOpen] = (0, $acw62.useState)(false);
    const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] = (0, $acw62.useState)(false);
    const [postLoginRedirectPath, setPostLoginRedirectPath] = (0, $acw62.useState)(null);
    const [loginError, setLoginError] = (0, $acw62.useState)(null);
    const handleOpenModal = (redirectPath = null)=>{
        setPostLoginRedirectPath(redirectPath);
        setLoginModalOpen(true);
    };
    const handleCloseModal = ()=>{
        setLoginModalOpen(false);
        setPostLoginRedirectPath(null);
        setLoginError(null);
    };
    const handleOpenCreateAccountModal = ()=>{
        setLoginModalOpen(false);
        setIsCreateAccountModalOpen(true);
    };
    const handleCloseCreateAccountModal = ()=>{
        setIsCreateAccountModalOpen(false);
    };
    const handleLoginError = (errorMsg)=>{
        setLoginError(errorMsg);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4629bfc79cc33037$export$2e2bcd8739ae039).Provider, {
        value: {
            isLoginModalOpen: isLoginModalOpen,
            handleOpenModal: handleOpenModal,
            handleCloseModal: handleCloseModal,
            postLoginRedirectPath: postLoginRedirectPath,
            setPostLoginRedirectPath: setPostLoginRedirectPath,
            handleLoginError: handleLoginError
        },
        children: [
            children,
            isLoginModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364a93698e860677$export$b4d7a44be6f5e733), {
                isLoginModalOpen: isLoginModalOpen,
                handleCloseModal: handleCloseModal,
                postLoginRedirectPath: postLoginRedirectPath,
                setPostLoginRedirectPath: setPostLoginRedirectPath,
                handleOpenCreateAccountModal: handleOpenCreateAccountModal,
                loginError: loginError
            }),
            isCreateAccountModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05acdc0118f3a485$export$6b46babcc2b5aac3), {
                isCreateAccountModalOpen: isCreateAccountModalOpen,
                handleCloseModal: handleCloseCreateAccountModal
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $5c159a8e47534cbe$export$1fb43a45282f651a = ({ image: image, icon: icon, header: header, description: description, actions: actions, size: size = 4, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
        size: size,
        sx: {
            backgroundColor: "white",
            outline: "1px solid",
            outlineColor: "stroke-neutral-secondary",
            borderRadius: "radius-2",
            boxShadow: "shadow-200",
            my: [
                "spacing-none",
                "spacing-4",
                null
            ]
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Target), {
            onClick: onClick,
            sx: {
                flex: 1
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    padding: "spacing-7",
                    gap: "spacing-4",
                    height: "100%"
                },
                children: [
                    image ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                        as: "img",
                        src: image,
                        sx: {
                            height: "spacing-10",
                            width: "spacing-10"
                        }
                    }) : icon ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                        icon: icon,
                        size: "lg",
                        sx: {
                            alignSelf: "flex-start"
                        }
                    }) : null,
                    header && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "title-1-medium",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-1-regular",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                        sx: {
                            flex: 1
                        }
                    }),
                    actions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                        sx: {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "spacing-3"
                        },
                        children: actions.map((button, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                ...button
                            }, index))
                    })
                ]
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
const $994b0f98ba0cc316$var$ExternalLinkModal = ({ isOpen: isOpen, setShowExternalLinkModal: setShowExternalLinkModal, externalLink: externalLink })=>{
    const [isChecked, setIsChecked] = (0, $acw62.useState)(false);
    const handleChange = (event)=>{
        setIsChecked(event.target.checked);
    };
    const openExternalLink = ()=>{
        window.open(externalLink, "_blank");
        if (isChecked) localStorage.setItem("dontRemindMeExternal", "true");
        setShowExternalLinkModal(false);
        setIsChecked(false);
    };
    const handleCancel = ()=>{
        setShowExternalLinkModal(false);
        setIsChecked(false);
    };
    const modalButtons = [
        {
            label: "Cancel",
            onClick: handleCancel
        },
        {
            label: "Continue",
            onClick: openExternalLink
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Modal), {
        size: "sm",
        isOpen: isOpen,
        onDismiss: ()=>setShowExternalLinkModal(false),
        buttons: modalButtons,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "h5",
                sx: {
                    mb: "spacing-8"
                },
                children: "You are now leaving Moderna Direct. The intended use and audience for the linked website may differ."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Checkbox), {
                id: "checkbox-default",
                label: "Don\u2019t remind me again",
                value: isChecked,
                onChange: handleChange
            })
        ]
    });
};
var $994b0f98ba0cc316$export$2e2bcd8739ae039 = $994b0f98ba0cc316$var$ExternalLinkModal;







const $c3afbb5fba2d026f$var$AuthHomepage = ()=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || "";
    const isAuthenticated = authState?.isAuthenticated;
    const { handleOpenModal: handleOpenModal } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [showExternalLinkModal, setShowExternalLinkModal] = (0, $acw62.useState)(false);
    const [externalLink, setExternalLink] = (0, $acw62.useState)("");
    const navigateOrLogin = (path)=>{
        if (isAuthenticated) history.push(`/${path}`);
        else handleOpenModal(`/${path}`);
    };
    const handleRedirect = (url)=>{
        if (!localStorage.getItem("dontRemindMeExternal")) {
            setShowExternalLinkModal(true);
            setExternalLink(url);
        } else {
            window.open(url, "_blank");
            setExternalLink("");
        }
    };
    const isOutageBannerEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_SITE_OUTAGE_BANNER_ENABLED");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: [
            isOutageBannerEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    mt: "spacing-3",
                    pr: "spacing-5"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                    variant: "critical",
                    title: "Scheduled maintenance: July 7 6:00 PM EDT \u2013 July 8 4:00 AM EDT",
                    text: "ModernaDirect.com will be temporarily unavailable during this time. You may access your account and resume placing orders when maintenance is complete."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $994b0f98ba0cc316$export$2e2bcd8739ae039), {
                isOpen: showExternalLinkModal,
                setShowExternalLinkModal: setShowExternalLinkModal,
                externalLink: externalLink
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($89e552997d15ef2b$exports)))})`,
                    backgroundSize: "100% 140%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center right",
                    backgroundColor: "color-current-brand-950",
                    py: "spacing-12",
                    width: "100%",
                    userSelect: "text"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: [
                            4,
                            8,
                            8
                        ],
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                variant: "h4",
                                sx: {
                                    // @ts-ignore
                                    width: [
                                        "100%",
                                        null,
                                        "70%"
                                    ],
                                    color: "white"
                                },
                                children: "Reservations available for 2025-2026 Moderna COVID-19 Vaccine Formula*"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                sx: {
                                    color: "white",
                                    mt: "spacing-3"
                                },
                                children: "*Subject to FDA approval or emergency use authorization of 2025-2026 formula"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                sx: {
                                    width: "fit-content",
                                    mt: "spacing-6"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                    size: "large",
                                    onClick: ()=>navigateOrLogin("reservation"),
                                    disabled: isOutageBannerEnabled,
                                    children: "Reserve now"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    background: "linear-gradient(94deg, #06557D 2.73%, #0E6896 45.24%, #44A7D9 99.83%)",
                    width: "100%",
                    py: "spacing-8",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                    sx: {
                        alignContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: [
                            4,
                            8,
                            6
                        ],
                        push: [
                            0,
                            0,
                            3
                        ],
                        sx: {
                            alignItems: "center",
                            textAlign: "center",
                            py: "spacing-7"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                                label: "New",
                                variant: "neutral"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                variant: "h5",
                                sx: {
                                    color: "white",
                                    mt: "spacing-6"
                                },
                                children: "View all of your invoices and credits in one place"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                variant: "body-1-regular",
                                sx: {
                                    color: "white",
                                    mt: "spacing-3"
                                },
                                children: `Thanks to your feedback, you can now securely view and pay invoices as well as view your credits. 
              Additional features like scheduling payments are planned for future updates. Click "View invoices" to get started.`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                sx: {
                                    mt: "spacing-6"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                    size: "large",
                                    variant: "outline",
                                    "aria-label": "arrow-right",
                                    icon: "arrow-right",
                                    iconPosition: "end",
                                    onClick: ()=>navigateOrLogin("your-account/invoices-and-payments"),
                                    disabled: isOutageBannerEnabled,
                                    children: "View invoices"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    py: "spacing-9",
                    gap: [
                        "spacing-4",
                        "spacing-none",
                        null
                    ]
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c159a8e47534cbe$export$1fb43a45282f651a), {
                        header: "Order Moderna products",
                        icon: "shopping-cart-simple",
                        onClick: ()=>{
                            navigateOrLogin("order-form");
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c159a8e47534cbe$export$1fb43a45282f651a), {
                        header: "Submit your tax exemption certificates",
                        icon: "files",
                        onClick: ()=>{
                            handleRedirect("https://taxform.modernatx.com/");
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                pointerEvents: isOutageBannerEnabled ? "none" : "auto",
                                opacity: isOutageBannerEnabled ? 0.5 : 1,
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c159a8e47534cbe$export$1fb43a45282f651a), {
                                header: "Pay an invoice as a guest",
                                icon: "credit-card",
                                description: "Click here to pay an invoice if you don\u2019t have a ModernaDirect account. ",
                                onClick: ()=>{
                                    history.push("/invoice/pay");
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    py: "spacing-9",
                    gap: [
                        "spacing-4",
                        "spacing-none",
                        null
                    ]
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "h5",
                            children: "Resources"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c159a8e47534cbe$export$1fb43a45282f651a), {
                        description: "For more information about Moderna\u2019s mRNA platform",
                        image: (0, (/*@__PURE__*/$parcel$interopDefault($155ce41b77e70709$exports))),
                        actions: [
                            {
                                children: "Visit",
                                variant: "outline",
                                icon: "arrow-circle-right",
                                iconPosition: "end",
                                onClick: ()=>{
                                    handleRedirect("https://www.modernatx.com/en-US/power-of-mrna/science-of-mrna");
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c159a8e47534cbe$export$1fb43a45282f651a), {
                        description: "For more information on the current Moderna COVID-19 vaccines",
                        image: (0, (/*@__PURE__*/$parcel$interopDefault($6ec2a835cac4db26$exports))),
                        actions: [
                            {
                                children: "Visit",
                                variant: "outline",
                                icon: "arrow-circle-right",
                                iconPosition: "end",
                                onClick: ()=>{
                                    handleRedirect("https://products.modernatx.com/spikevax/6-months-to-11-years");
                                }
                            }
                        ]
                    })
                ]
            })
        ]
    });
};
var $c3afbb5fba2d026f$export$2e2bcd8739ae039 = $c3afbb5fba2d026f$var$AuthHomepage;


const $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3afbb5fba2d026f$export$2e2bcd8739ae039), {})
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $3bYfT = parcelRequire("3bYfT");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $lkxXU = parcelRequire("lkxXU");
var $3bYfT = parcelRequire("3bYfT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");

var $219e719d3b909e54$exports = {};
$219e719d3b909e54$exports = new URL("coins.c8a25781.svg", import.meta.url).toString();


var $99ae0a5c740afb1a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($99ae0a5c740afb1a$exports, "__esModule", {
    value: true
});
$99ae0a5c740afb1a$exports.default = void 0;

var $99ae0a5c740afb1a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $99ae0a5c740afb1a$var$_default = $99ae0a5c740afb1a$exports.default = (0, $99ae0a5c740afb1a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2m-9-3h2v5h-2zm9 16H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5zm-9-4H9v2H7v-2H5v-2h2v-2h2v2h2zm2-1.5V13h6v1.5zm0 3V16h4v1.5z"
}), 'MedicalInformationOutlined');




const $c5489e2f3750c70b$var$PONumberSection = ({ poNumber: poNumber, setPONumber: setPONumber, handlePoNumberChange: handlePoNumberChange, cartLineItems: cartLineItems, addPONumberClicked: addPONumberClicked, setAddPONumberClicked: setAddPONumberClicked })=>{
    (0, $acw62.useEffect)(()=>{
        let PONumber = "";
        cartLineItems?.forEach((item)=>{
            if (item?.purchaseOrderNumber) PONumber = item?.purchaseOrderNumber;
        });
        setPONumber(PONumber);
        setAddPONumberClicked(!!PONumber);
    }, [
        cartLineItems
    ]);
    const handlePONumberUpdate = (event)=>{
        setPONumber(event.target.value);
        handlePoNumberChange(cartLineItems, event.target.value);
    };
    const handlePOButtonClick = ()=>{
        setAddPONumberClicked(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: addPONumberClicked ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    padding: "0 34px",
                    fontWeight: "700",
                    fontFamily: "Aeonik Bold",
                    children: "P.O. number"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    type: "text",
                    size: "small",
                    variant: "outlined",
                    sx: {
                        padding: "0 34px"
                    },
                    onChange: handlePONumberUpdate,
                    value: poNumber,
                    inputProps: {
                        maxLength: 35,
                        'aria-label': 'PONumber'
                    }
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
            "data-testid": "addPONumberBtn",
            buttonType: "link",
            sx: {
                textTransform: "none",
                padding: "0 34px"
            },
            onClick: handlePOButtonClick,
            children: "Add a P.O. number"
        })
    });
};
const $c5489e2f3750c70b$var$RequiredSymbol = (0, $d8seH.default)('span')({
    color: 'red'
});
const $c5489e2f3750c70b$var$OrderingAddressBlock = ({ shipToAddress: shipToAddress, setOpenAddressModal: setOpenAddressModal, deleteAddressRow: deleteAddressRow, billToAddress: billToAddress, handlePoNumberChange: handlePoNumberChange, cartLineItems: cartLineItems, setOpenLicenseSelectionModal: setOpenLicenseSelectionModal, handleAddNewAddress: handleAddNewAddress, isReservation: isReservation = false })=>{
    const [PONumber, setPONumber] = (0, $acw62.useState)(cartLineItems?.[0]?.purchaseOrderNumber);
    const [addPONumberClicked, setAddPONumberClicked] = (0, $acw62.useState)(!!cartLineItems?.[0]?.purchaseOrderNumber);
    const selectedMedicalLicense = cartLineItems?.[0]?.healthcareLicense;
    const onAddAddress = (addressType)=>{
        addressType === 'ship_to' && handleAddNewAddress();
    };
    const DeleteAddressRow = ({ requireStyle: requireStyle })=>{
        let customPadding = requireStyle ? "10px 34px" : "0px";
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
            "data-testid": "deleteAddresRow",
            buttonType: "link",
            sx: {
                textTransform: "none",
                padding: customPadding,
                color: "#E31737"
            },
            onClick: deleteAddressRow,
            children: "Delete this row"
        });
    };
    const AddressSection = ({ addressType: addressType, iconType: iconType })=>{
        const addressInfo = {
            bill_to: {
                title: "Bill To: ",
                address: billToAddress,
                dbaName: ""
            },
            ship_to: {
                title: "Ship To: ",
                address: shipToAddress,
                dbaName: shipToAddress?.dba
            }
        };
        const { title: addressTitle, address: address, dbaName: addressDbaName } = addressInfo[addressType];
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            gap: "10px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: iconType,
                    alt: "address icon",
                    width: "24",
                    height: "22"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontWeight: "700",
                            fontFamily: "Aeonik Regular",
                            children: addressTitle
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontWeight: "700",
                            fontFamily: "Aeonik Regular",
                            children: addressDbaName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontWeight: "400",
                            fontFamily: "Aeonik Regular",
                            children: address?.line1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontWeight: "400",
                            fontFamily: "Aeonik Regular",
                            children: address?.line2
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontWeight: "400",
                            fontFamily: "Aeonik Regular",
                            children: `${address?.city}, ${address?.state}, ${address?.zip}`
                        })
                    ]
                })
            ]
        });
    };
    const AddAddressButton = ({ addressType: addressType, iconType: iconType })=>{
        const buttonName = addressType === "ship_to" ? "Add shipping address" : "Add billing address";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
            buttonType: 'mds-secondary',
            leftIcon: iconType,
            sx: {
                padding: "16px 32px",
                textTransform: "none",
                fontWeight: "700"
            },
            onClick: ()=>onAddAddress(addressType),
            "data-testid": "addAddressBttn",
            children: [
                buttonName,
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)($c5489e2f3750c70b$var$RequiredSymbol, {
                    children: " *"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        paddingTop: "25px",
        alignItems: "flex-start",
        children: [
            shipToAddress ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(AddressSection, {
                        addressType: "ship_to",
                        iconType: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports)))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        "data-testid": "changeAddressBtn",
                        buttonType: "link",
                        sx: {
                            textTransform: "none",
                            padding: "0 34px",
                            marginBottom: '16px'
                        },
                        onClick: ()=>{
                            setOpenAddressModal(true);
                        },
                        children: "Change"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)(AddAddressButton, {
                addressType: "ship_to",
                iconType: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports)))
            }),
            !isReservation && (billToAddress ? /*#__PURE__*/ (0, $ayMG0.jsx)(AddressSection, {
                addressType: "bill_to",
                iconType: (0, (/*@__PURE__*/$parcel$interopDefault($219e719d3b909e54$exports)))
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                gap: "10px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($219e719d3b909e54$exports))),
                        alt: "address icon",
                        width: "24",
                        height: "22"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontWeight: "700",
                                fontFamily: "Aeonik Regular",
                                children: "Bill To: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                                type: "warning",
                                messageText: "Could not access billing address"
                            })
                        ]
                    })
                ]
            })),
            !isReservation && (Object.keys(selectedMedicalLicense || {}).length ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        gap: "10px",
                        marginTop: "16px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99ae0a5c740afb1a$exports))), {
                                sx: {
                                    color: "#383D47"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "700",
                                        fontFamily: "Aeonik Regular",
                                        children: "Medical License:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "700",
                                        fontFamily: "Aeonik Regular",
                                        children: selectedMedicalLicense?.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "400",
                                        fontFamily: "Aeonik Regular",
                                        children: `License No. ${selectedMedicalLicense?.licenseNumber}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "400",
                                        fontFamily: "Aeonik Regular",
                                        children: `Exp ${selectedMedicalLicense?.expirationDate}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        "data-testid": "changeMedicalLicenseBtn",
                        buttonType: "link",
                        sx: {
                            textTransform: "none",
                            padding: "0 34px",
                            marginBottom: '16px'
                        },
                        onClick: ()=>setOpenLicenseSelectionModal(true),
                        children: "Change"
                    })
                ]
            }) : shipToAddress && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: 'link',
                sx: {
                    padding: "16px 32px",
                    textTransform: "none"
                },
                onClick: ()=>setOpenLicenseSelectionModal(true),
                "data-testid": "addMedicalLicenseBttn",
                children: [
                    "Select a medical license ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c5489e2f3750c70b$var$RequiredSymbol, {
                        children: " *"
                    })
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c5489e2f3750c70b$var$PONumberSection, {
                poNumber: PONumber,
                setPONumber: setPONumber,
                handlePoNumberChange: handlePoNumberChange,
                cartLineItems: cartLineItems,
                addPONumberClicked: addPONumberClicked,
                setAddPONumberClicked: setAddPONumberClicked
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(DeleteAddressRow, {
                requireStyle: true
            })
        ]
    });
};
var $c5489e2f3750c70b$export$2e2bcd8739ae039 = $c5489e2f3750c70b$var$OrderingAddressBlock;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1J2kR = parcelRequire("1J2kR");

var $d8seH = parcelRequire("d8seH");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");


const $fdc2b0881c093ca1$var$StyledDataGrid = (0, $d8seH.default)((0, $1J2kR.DataGrid))(({ theme: { breakpoints: breakpoints } })=>`
        height: auto;

        ${breakpoints.between('sm', 'md')} {
            &[data-testid="productTable"]{
                height: 600px !important;
            }

            & .MuiDataGrid-row {
                min-height: 155px !important;
                max-height: 155px !important;
        
                & [role="cell"] {
                min-height: 155px !important;
                max-height: 155px !important;
                }
            }
        }

        ${breakpoints.between('md', 'lg2')} {
            &[data-testid="productTable"] {
                height: 510px !important;
            }

            & .MuiDataGrid-row {
                min-height: 145px !important;
                max-height: 145px !important;
        
                & [role="cell"] {
                min-height: 145px !important;
                max-height: 145px !important;
                }
            }
        }
    `);
const $fdc2b0881c093ca1$var$ReservationProductTable = ({ products: products, isAuthenticated: isAuthenticated, handleDosesChange: handleDosesChange })=>{
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const [productObj, setProductObj] = (0, $acw62.useState)({
        productId: '',
        doseQty: 0
    });
    const { handleOpenModal: handleOpenModal } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const TitleComponent = (value)=>{
        const row = value.value.row;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                height: 4,
                mb: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    pl: 2,
                    style: {
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        style: {
                            fontSize: '16px',
                            fontWeight: '700',
                            lineHeight: '20px'
                        },
                        children: row.productNameFormatted
                    })
                })
            })
        });
    };
    const PricePerDose = (value)=>{
        const row = value.value.row;
        const finalPriceStyle = {
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "16px"
        };
        const listPriceStyle = {
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "16px",
            color: "#696B72"
        };
        const hasDiscount = false;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            alignContent: "end",
            gap: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: {
                        ...listPriceStyle,
                        textDecoration: "line-through"
                    },
                    children: [
                        "List price: ",
                        row.listPrice
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    paddingLeft: 10,
                    style: {
                        ...hasDiscount ? listPriceStyle : finalPriceStyle,
                        textDecoration: hasDiscount ? "line-through" : "none"
                    },
                    children: [
                        " Contract price: ",
                        row.contractPrice
                    ]
                }),
                hasDiscount && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: finalPriceStyle,
                    children: [
                        "Price with online discount: ",
                        row.finalPrice
                    ]
                })
            ]
        });
    };
    const pricePerDoseColumns = isDiscountEnabled ? [
        {
            field: "finalPrice",
            headerName: "Price per dose",
            headerAlign: "center",
            align: "end",
            sortable: false,
            minWidth: 300,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(PricePerDose, {
                    value: params
                })
        }
    ] : [
        {
            field: 'listPrice',
            headerName: 'List Price*',
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'contractPrice',
            headerName: 'Contract Price',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            minWidth: 125
        }
    ];
    const columns = [
        {
            field: 'productNameFormatted',
            headerName: 'Product',
            flex: 1,
            minWidth: 100,
            sortable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(TitleComponent, {
                    value: params
                })
        },
        ...pricePerDoseColumns,
        {
            field: 'doses',
            headerName: 'Doses',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            minWidth: 125,
            renderCell: (params)=>{
                let val = params?.value;
                if (productObj?.productId === params.id) val = productObj?.doseQty;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    type: "number",
                    value: isAuthenticated ? val : 0,
                    onChange: (e)=>updateTextVal(params.id, e.target.value),
                    onBlur: (e)=>handleDosesUpdate(params, e),
                    onKeyDown: (e)=>handleDosesUpdate(params, e),
                    onClick: !isAuthenticated ? handleOpenModal : undefined,
                    inputProps: {
                        min: 0,
                        "data-testid": `doseQty-${params.id}`,
                        'aria-label': 'number of doses'
                    },
                    size: "small",
                    variant: "outlined",
                    sx: {
                        '& .MuiInputBase-input': {
                            color: !isAuthenticated && 'text.disabled',
                            cursor: !isAuthenticated && 'default'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: !isAuthenticated && 'text.disabled'
                        }
                    }
                });
            }
        }
    ];
    const filteredColumns = isAuthenticated ? columns : columns.filter((column)=>column.field === 'productNameFormatted' || column.field === 'doses');
    const handleDosesUpdate = (product, event)=>{
        const { id: id, value: value } = product;
        const dose = Number(event.target.value);
        if (value === dose) return;
        if (event?.key === 'Enter' || event?.type === 'blur') {
            const doseQty = Math.ceil(dose / 10) * 10;
            setProductObj((prevState)=>({
                    ...prevState,
                    productId: id,
                    doseQty: doseQty
                }));
            handleDosesChange(id, dose);
        }
    };
    const updateTextVal = (productId, doseQty)=>{
        if (doseQty.charAt(0) === '0') doseQty = doseQty.slice(1);
        setProductObj((prevState)=>({
                ...prevState,
                productId: productId,
                doseQty: doseQty
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fdc2b0881c093ca1$var$StyledDataGrid, {
        "data-testid": "productTable",
        autoHeight: true,
        rowHeight: 90,
        rows: products || [],
        columns: filteredColumns || [],
        hideFooter: true,
        disableColumnFilter: true,
        disableColumnMenu: true
    });
};
var $fdc2b0881c093ca1$export$2e2bcd8739ae039 = $fdc2b0881c093ca1$var$ReservationProductTable;



var $ayMG0 = parcelRequire("ayMG0");



var $3bYfT = parcelRequire("3bYfT");


var $8fe00348ba430af2$exports = {};
$8fe00348ba430af2$exports = new URL("pdfDocIcon.fa5a48f0.svg", import.meta.url).toString();



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $997914457eb07226$var$ImageGallery = ({ images: images })=>{
    const [selectedImage, setSelectedImage] = (0, $acw62.useState)(images?.[0].original);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
        width: "520px",
        height: "320px",
        flexShrink: 0,
        display: "flex",
        gap: "16px",
        "data-testid": "imageGallery",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                "data-testid": "thumbnailSection",
                display: "inline-flex",
                flexDirection: "column",
                gap: "16px",
                children: images?.map((image, i)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        width: "96px",
                        height: "96px",
                        border: "1px solid #9BA5B7",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: image.thumbnail,
                            alt: "Product thumbnail",
                            width: "81px",
                            height: "81px",
                            onClick: ()=>setSelectedImage(image.original)
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                "data-testid": "selectedImage",
                display: "flex",
                width: "409px",
                height: "320px",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #9BA5B7",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "Product Image",
                    src: selectedImage,
                    height: "100%"
                })
            })
        ]
    });
};
var $997914457eb07226$export$2e2bcd8739ae039 = $997914457eb07226$var$ImageGallery;



const $acfec5106660cbb9$export$b9238abf6d33793f = [
    {
        fields: {
            title: 'Moderna COVID-19 Vaccine EUA Provider Fact Sheet 6m-11y',
            label: 'Moderna COVID-19 Vaccine EUA Provider Fact Sheet 6m-11y',
            productCode: '70588',
            url: 'https://assets.modernatx.com/m/2cbca14044aa8fa5/original/FPI-0718_Moderna-COVID-19-Vaccine-2023-2024-Formula-Fact-Sheet-for-Vaccine-Providers-6m-11y-US-English.pdf'
        }
    },
    {
        fields: {
            title: 'Moderna COVID-19 Vaccine EUA Recipient Fact Sheet 6m-11y',
            label: 'Moderna COVID-19 Vaccine EUA Recipient Fact Sheet 6m-11y',
            productCode: '70588',
            url: 'https://assets.modernatx.com/m/c8a870daf3d6e5d/original/FPI-0719_Moderna-COVID-19-Vaccine-2023-2024-Formula-Fact-Sheet-for-Vaccine-Recipients-6m-11y-US-English.pdf'
        }
    },
    {
        fields: {
            title: 'Spikevax Prescribing Information 12y+',
            label: 'Spikevax Prescribing Information 12y+',
            productCode: '80291',
            url: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
        }
    },
    {
        fields: {
            title: 'Spikevax Patient Information 12y+',
            label: 'Spikevax Patient Information 12y+',
            productCode: '80291',
            url: 'https://assets.modernatx.com/m/4fe30ac736607490/original/PPI-0017_Spikevax-2023-2024-Formula-Patient-Information-12y-US-English.pdf'
        }
    },
    {
        fields: {
            title: 'Prescribing Information for mRESVIA',
            label: 'Prescribing Information for mRESVIA',
            productCode: '70545',
            url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/36130c97-6fb0-4bea-9f2e-fb5be7a90729/36130c97-6fb0-4bea-9f2e-fb5be7a90729_viewable_rendition__v.pdf'
        }
    },
    {
        fields: {
            title: 'Letter of Authorization for EUA',
            label: 'Letter of Authorization for EUA',
            productCode: '70840',
            url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/9a50151f-e863-4a8e-94ba-e54d713691dc/9a50151f-e863-4a8e-94ba-e54d713691dc_viewable_rendition__v.pdf'
        }
    },
    {
        fields: {
            title: 'Fact Sheet for EUA',
            label: 'Fact Sheet for EUA',
            productCode: '70840',
            url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/b6653c87-2627-405c-b151-be87db581e7d/b6653c87-2627-405c-b151-be87db581e7d_viewable_rendition__v.pdf'
        }
    },
    {
        fields: {
            title: 'Prescribing Information for Spikevax',
            label: 'Prescribing Information for Spikevax',
            productCode: '70506',
            url: 'https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/5efa7d9d-05e8-46b5-945a-637c2867bd00/5efa7d9d-05e8-46b5-945a-637c2867bd00_viewable_rendition__v.pdf'
        }
    }
];


var $98ca1820905a9cc5$exports = {};
$98ca1820905a9cc5$exports = new URL("SPIKEVAX_80777-110-96_Paperboard_Carton.c1a677f9.jpg", import.meta.url).toString();


var $51cf9eb93a9943b2$exports = {};
$51cf9eb93a9943b2$exports = new URL("SPIKEVAX_80777-110-01_PFS.8e858911.jpg", import.meta.url).toString();


var $69497df5483bdba0$exports = {};
$69497df5483bdba0$exports = new URL("COVID-19_EUA_80777-291-80_Paperboard_Carton.39e72da0.jpg", import.meta.url).toString();


var $925fa96c0c99e306$exports = {};
$925fa96c0c99e306$exports = new URL("COVID-19_EUA_80777-291-09_PFS.7d32d5c9.jpg", import.meta.url).toString();


var $91b73b4b4d7c8c4b$exports = {};
$91b73b4b4d7c8c4b$exports = new URL("mRESVIA_carton.b6c7194b.jpg", import.meta.url).toString();


var $c9c6d5b376cc684a$exports = {};
$c9c6d5b376cc684a$exports = new URL("mRESVIA_product.50afa9e6.jpg", import.meta.url).toString();


var $9562f9c7088987b5$exports = {};
$9562f9c7088987b5$exports = new URL("mRESVIA_both.f075b2cc.jpg", import.meta.url).toString();


const $d1a12e8a97000f16$export$480d192dfa1e2cb8 = {
    '70506': [
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($98ca1820905a9cc5$exports))),
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($51cf9eb93a9943b2$exports))),
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        }
    ],
    '70840': [
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($69497df5483bdba0$exports))),
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($925fa96c0c99e306$exports))),
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        }
    ],
    '70545': [
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($91b73b4b4d7c8c4b$exports))),
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($9562f9c7088987b5$exports))),
            width: 418,
            height: 418,
            imageType: 'OTHER'
        },
        {
            url: (0, (/*@__PURE__*/$parcel$interopDefault($c9c6d5b376cc684a$exports))),
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        }
    ]
};


const $53e3f78b3d4a8296$var$ProductDetailModal = ({ closeModal: closeModal, openModal: openModal })=>{
    const productDetails = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.singleProductInfo);
    const factSheetLinks = (0, $acfec5106660cbb9$export$b9238abf6d33793f)?.filter((factSheetLink)=>{
        return factSheetLink?.fields?.productCode === productDetails?.materialMasterId;
    });
    const filterImages = ()=>{
        const images = (0, $d1a12e8a97000f16$export$480d192dfa1e2cb8)[productDetails?.materialMasterId];
        return (0, $382eb84981692d3a$export$3fba3ce1b8c1659a)(images);
    };
    const images = filterImages()?.map((image, i)=>{
        return {
            original: image?.url,
            thumbnail: image?.url,
            originalAlt: `Original Product ${i + 1}`,
            thumbnailAlt: `Thumbnail Product ${i + 1}`
        };
    });
    const ageGroup = ()=>{
        return productDetails?.displayInfo?.displayAge;
    };
    const ProductDetail = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        width: "545px",
        gap: "24px",
        flexShrink: 0,
        flexWrap: "wrap",
        alignContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                display: "flex",
                width: "545px",
                paddingBottom: "8px",
                fontFamily: "Aeonik Regular",
                fontSize: "24px",
                fontWeight: "700",
                children: "Product information"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $997914457eb07226$export$2e2bcd8739ae039), {
                images: images
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "520px",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        gap: "24px",
                        children: [
                            ageGroup() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                textAlign: "left",
                                fontFamily: "Aeonik Regular",
                                fontSize: "16px",
                                fontWeight: "700",
                                children: ageGroup()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                textAlign: "left",
                                fontFamily: "Aeonik Regular",
                                fontSize: "16px",
                                fontWeight: "700",
                                children: [
                                    "NDC#",
                                    productDetails?.ndc
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "left",
                        fontFamily: "Aeonik Regular",
                        fontSize: "24px",
                        fontWeight: "300",
                        children: productDetails?.displayInfo?.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "left",
                        fontFamily: "Aeonik Regular",
                        fontSize: "16px",
                        fontWeight: "700",
                        children: productDetails?.displayInfo?.description
                    })
                ]
            }),
            factSheetLinks?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": "downloadSection",
                display: "flex",
                width: "545px",
                alignItems: "flex-start",
                alignContent: "flex-start",
                gap: "16px",
                flexShrink: 0,
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        textAlign: "left",
                        width: "539px",
                        fontFamily: "Aeonik Regular",
                        fontSize: "18px",
                        fontWeight: "700",
                        children: "Downloads"
                    }),
                    factSheetLinks.map((factSheetLink, i)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                            to: {
                                pathname: factSheetLink?.fields?.url
                            },
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                leftIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8fe00348ba430af2$exports))),
                                buttonType: "mds-outline",
                                sx: {
                                    textTransform: "none",
                                    padding: "12px 16px"
                                },
                                children: factSheetLink?.fields?.label
                            })
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                width: "545px",
                padding: "12px 90px",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "mds-primary",
                    sx: {
                        textTransform: "none",
                        padding: "16px 32px"
                    },
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            maxWidth: '598px',
            width: 'auto',
            padding: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            overflowX: 'hidden'
        },
        modalContent: ProductDetail
    });
};
var $53e3f78b3d4a8296$export$2e2bcd8739ae039 = $53e3f78b3d4a8296$var$ProductDetailModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");




var $16182d64948f0f20$exports = {};
$16182d64948f0f20$exports = new URL("check.9c344ea4.svg", import.meta.url).toString();




const $abba33a116635f56$var$AddressCardStyles = {
    display: 'flex',
    width: '348px',
    height: '207px',
    padding: '16px 24px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '16px',
    borderRadius: '16px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    "&:hover": {
        boxShadow: "0px 3px 16px #00000029",
        cursor: 'pointer'
    }
};
const $abba33a116635f56$var$AddressSelectionModal = ({ closeModal: closeModal, openModal: openModal, currentAddress: currentAddress, allSelectedAddresses: allSelectedAddresses, handleAddNewAddress: handleAddNewAddress, isOrdering: isOrdering = false })=>{
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const defaultAddress = userData?.addresses?.filter((address)=>address.addressType === 'ship_to')[0];
    const { reservationData: reservationData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { reservationProducts: reservationProducts } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const [addressSelection, setAddressSelection] = (0, $acw62.useState)(currentAddress);
    const { cartData: cartData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const theme = (0, $14H9o.default)();
    const shipToAddresses = (0, $acw62.useMemo)(()=>{
        const addresses = userData?.addresses || [];
        return addresses.filter((address)=>address.addressType === "ship_to").map((address)=>({
                ...address,
                defaultAddress: address.id === defaultAddress?.id
            })).sort((0, $382eb84981692d3a$export$fa295b83bf634638));
    }, [
        defaultAddress
    ]);
    const handleSubmit = ()=>{
        if (!addressSelection) {
            closeModal();
            return;
        }
        let currentAddressId = String(currentAddress?.id);
        //allSelectedAddresses is the list of all selected addresses in reservation page & we pass it as prop only in case of adding a new delivery location
        if (allSelectedAddresses) return handleAdditionalAddress();
        if (isOrdering) {
            const updatedCartListItems = cartData?.cartLineItems.map((entry)=>{
                if (String(entry?.shipToAddress?.addressId) === currentAddressId) return {
                    ...entry,
                    shipToAddress: {
                        addressId: String(addressSelection?.id)
                    },
                    shipToOrganizationId: String(addressSelection?.organizationId)
                };
                return entry;
            });
            dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
                cartLineItems: updatedCartListItems
            }));
        } else {
            const updatedEntries = reservationData?.reservationEntries.map((entry)=>{
                if (String(entry.deliveryAddressId) === currentAddressId) return {
                    ...entry,
                    deliveryAddressId: addressSelection.id,
                    shipToOrganizationId: String(addressSelection?.organizationId)
                };
                return entry;
            });
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                reservationEntries: updatedEntries
            }));
        }
        closeModal();
    };
    const handleAdditionalAddress = ()=>{
        if (isOrdering) dispatch((0, $53476aa40d2bc637$export$741583438031a635)({
            addressId: addressSelection?.id
        }));
        else {
            const newReservationEntries = reservationProducts?.map((product)=>{
                const uniqueSuffix = Math.random().toString(36).substr(2, 9);
                const productId = product?.materialMasterId;
                const reservationEntryId = `${productId}-${uniqueSuffix}`;
                return {
                    reservationEntryId: reservationEntryId,
                    reservationId: reservationData.reservation.reservationId,
                    deliveryAddressId: addressSelection.id,
                    productId: productId,
                    quantity: 0,
                    shipToOrganizationId: String(addressSelection?.organizationId)
                };
            });
            // Combine the existing reservation entries with the new entries for the additional address
            const updatedReservationEntries = [
                ...reservationData.reservationEntries,
                ...newReservationEntries
            ];
            // Dispatch an action to update the reservation entries in the Redux store
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                ...reservationData,
                reservationEntries: updatedReservationEntries
            }));
        }
        closeModal();
    };
    const isAddressSelected = (addressId)=>{
        return allSelectedAddresses?.filter((address)=>address?.id === addressId).length;
    };
    const AddressSelection = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "23px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontSize: "23px",
                fontWeight: "700",
                lineHeight: "30px",
                children: "Choose a shipping address"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "flex-start",
                gap: "24px",
                flexWrap: "wrap",
                children: [
                    shipToAddresses.map((address, i)=>{
                        const isSelected = String(address?.id) === String(addressSelection?.id);
                        if (isAddressSelected(address?.id)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                ...$abba33a116635f56$var$AddressCardStyles,
                                border: isSelected ? '1px solid #079AE0' : '1px solid transparent'
                            },
                            "data-testid": `addressTile-${i}`,
                            tabIndex: "0",
                            onClick: ()=>{
                                setAddressSelection(address);
                            },
                            onKeyDown: (e)=>{
                                if (e.key === 'Enter') setAddressSelection(address);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    width: "300px",
                                    gap: "10px",
                                    "data-testid": "addressBlock",
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            padding: "4px 0px",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports))),
                                                alt: "Address Icon",
                                                width: "24",
                                                height: "22.15"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            flexDirection: "column",
                                            paddingTop: "3px",
                                            alignItems: "flex-start",
                                            flex: "1 0 0",
                                            "data-testid": "addressDetails",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    fontWeight: "700",
                                                    fontFamily: "Aeonik Regular",
                                                    children: address?.dba
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    fontWeight: "400",
                                                    fontFamily: "Aeonik Regular",
                                                    children: address?.line1
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    fontWeight: "400",
                                                    fontFamily: "Aeonik Regular",
                                                    children: address?.line2
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                    fontWeight: "400",
                                                    fontFamily: "Aeonik Regular",
                                                    children: `${address?.city}, ${address?.state}, ${address?.zip}`
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    height: "32px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    children: isSelected ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($16182d64948f0f20$exports))),
                                                alt: "check icon",
                                                width: "32",
                                                height: "32"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                fontWeight: "700",
                                                fontFamily: "Aeonik Regular",
                                                color: "#0379B2",
                                                children: "Selected"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontWeight: "400",
                                        fontFamily: "Aeonik Regular",
                                        color: "#0379B2",
                                        children: "Select this address"
                                    })
                                })
                            ]
                        }, address?.id);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        "data-testid": "addAddressTile",
                        sx: {
                            ...$abba33a116635f56$var$AddressCardStyles,
                            justifyContent: 'center'
                        },
                        onClick: handleAddNewAddress,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5fc6cdd0dabb560c$exports))),
                                    alt: "plus icon",
                                    width: "32",
                                    height: "32"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontWeight: "700",
                                    fontFamily: "Aeonik Regular",
                                    color: "#0379B2",
                                    children: "Add new address"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "100%",
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "mds-primary",
                    sx: {
                        padding: "16px 32px",
                        textTransform: "none"
                    },
                    onClick: handleSubmit,
                    children: "Submit"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            maxWidth: '1155px',
            width: 'fit-content',
            padding: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            overflowX: 'hidden',
            [theme.breakpoints.down('lg')]: {
                width: '800px'
            },
            [theme.breakpoints.down('md')]: {
                width: '400px'
            }
        },
        modalContent: AddressSelection
    });
};
var $abba33a116635f56$export$2e2bcd8739ae039 = $abba33a116635f56$var$AddressSelectionModal;





var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $d8seH = parcelRequire("d8seH");





var $ayMG0 = parcelRequire("ayMG0");

var $i32L9 = parcelRequire("i32L9");
var $2iAqv = parcelRequire("2iAqv");
var $cX7V2 = parcelRequire("cX7V2");
var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");
const $496aecc9ad45b428$var$Dropdown = ({ name: name, label: label, options: options, value: value, onChangeHandler: onChangeHandler, isRequired: isRequired, errors: errors, dataTestId: dataTestId, isDisabled: isDisabled })=>{
    const RequiredSymbol = (0, $d8seH.default)('span')({
        color: 'red'
    });
    const menuItemStyle = {
        '&.Mui-selected': {
            backgroundColor: '#FFFFFF',
            color: 'primary.main',
            fontFamily: 'Aeonik Bold'
        },
        fontFamily: 'Aeonik Regular',
        fontSize: '14px'
    };
    const helperTextStyles = {
        '&.Mui-error': {
            color: '#E22929',
            fontFamily: 'Aeonik Regular',
            marginLeft: '0',
            fontSize: '14px',
            letterSpacing: '-0.28px'
        }
    };
    const FormLabel = ({ label: label, isRequired: isRequired })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            textAlign: "left",
            paddingBottom: "7px",
            fontFamily: "Aeonik Regular",
            color: "#191F2A",
            fontWeight: "700",
            fontSize: "16px",
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $ayMG0.jsx)(RequiredSymbol, {
                    children: "*"
                })
            ]
        });
    };
    const selectFieldStyles = (name)=>{
        return {
            width: '100%',
            height: '48px',
            ".MuiSelect-select": {
                fontFamily: 'Aeonik Regular',
                textAlign: 'left'
            },
            "& .MuiFormHelperText-root": {
                minHeight: '20px'
            },
            ".MuiOutlinedInput-notchedOutline": {
                borderRadius: '6px',
                border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
            }
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsx)(FormLabel, {
                label: label,
                isRequired: isRequired
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), {
                id: name,
                "data-testid": dataTestId,
                value: value || "",
                onChange: onChangeHandler,
                sx: selectFieldStyles(name),
                error: Boolean(errors[name]),
                helpertext: errors[name],
                disabled: isDisabled,
                MenuProps: {
                    PaperProps: {
                        sx: {
                            boxShadow: '0px 3px 6px #00000029',
                            borderRadius: '0px 0px 8px 8px',
                            maxHeight: 200,
                            maxWidth: 'fit-content',
                            overflow: 'auto'
                        }
                    }
                },
                children: options?.map(({ value: value, label: label }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                        sx: menuItemStyle,
                        id: value,
                        value: value,
                        children: value === '' ? '-' : label
                    }, index))
            }),
            errors[name] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                sx: helperTextStyles,
                error: Boolean(errors[name]),
                children: errors[name]
            })
        ]
    });
};
var $496aecc9ad45b428$export$2e2bcd8739ae039 = $496aecc9ad45b428$var$Dropdown;



var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");
var $5b2b72156d2e39b5$exports = {};
"use strict";
var $543e4b3aa35bec3b$exports = {};

$parcel$export($543e4b3aa35bec3b$exports, "add", () => $543e4b3aa35bec3b$export$e16d8520af44a096, (v) => $543e4b3aa35bec3b$export$e16d8520af44a096 = v);
var $543e4b3aa35bec3b$export$e16d8520af44a096;
"use strict";
$543e4b3aa35bec3b$export$e16d8520af44a096 = $543e4b3aa35bec3b$var$add;
var $a351150ce2eb3ddb$exports = {};

$parcel$export($a351150ce2eb3ddb$exports, "addDays", () => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa, (v) => $a351150ce2eb3ddb$export$dd412b56f1e4d8aa = v);
var $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;
"use strict";
$a351150ce2eb3ddb$export$dd412b56f1e4d8aa = $a351150ce2eb3ddb$var$addDays;
var $231bfb8d72679740$exports = {};

$parcel$export($231bfb8d72679740$exports, "toDate", () => $231bfb8d72679740$export$e67a095c620b86fe, (v) => $231bfb8d72679740$export$e67a095c620b86fe = v);
var $231bfb8d72679740$export$e67a095c620b86fe;
"use strict";
$231bfb8d72679740$export$e67a095c620b86fe = $231bfb8d72679740$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $231bfb8d72679740$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}


var $abb9adbdb26342b3$exports = {};

$parcel$export($abb9adbdb26342b3$exports, "constructFrom", () => $abb9adbdb26342b3$export$ead8a1812b171991, (v) => $abb9adbdb26342b3$export$ead8a1812b171991 = v);
var $abb9adbdb26342b3$export$ead8a1812b171991;
"use strict";
$abb9adbdb26342b3$export$ead8a1812b171991 = $abb9adbdb26342b3$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $abb9adbdb26342b3$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $a351150ce2eb3ddb$var$addDays(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}


var $8fcd3b0bf5df7635$exports = {};

$parcel$export($8fcd3b0bf5df7635$exports, "addMonths", () => $8fcd3b0bf5df7635$export$17c93e242b2d3a22, (v) => $8fcd3b0bf5df7635$export$17c93e242b2d3a22 = v);
var $8fcd3b0bf5df7635$export$17c93e242b2d3a22;
"use strict";
$8fcd3b0bf5df7635$export$17c93e242b2d3a22 = $8fcd3b0bf5df7635$var$addMonths;


/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $8fcd3b0bf5df7635$var$addMonths(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}




/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $543e4b3aa35bec3b$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}


Object.keys($543e4b3aa35bec3b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $543e4b3aa35bec3b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $543e4b3aa35bec3b$exports[key];
        }
    });
});
var $370ee6dc5d0513ee$exports = {};

$parcel$export($370ee6dc5d0513ee$exports, "addBusinessDays", () => $370ee6dc5d0513ee$export$f087b9ada3136ae9, (v) => $370ee6dc5d0513ee$export$f087b9ada3136ae9 = v);
var $370ee6dc5d0513ee$export$f087b9ada3136ae9;
"use strict";
$370ee6dc5d0513ee$export$f087b9ada3136ae9 = $370ee6dc5d0513ee$var$addBusinessDays;

var $d84241a3868bd79f$exports = {};

$parcel$export($d84241a3868bd79f$exports, "isSaturday", () => $d84241a3868bd79f$export$def9f260655b3a76, (v) => $d84241a3868bd79f$export$def9f260655b3a76 = v);
var $d84241a3868bd79f$export$def9f260655b3a76;
"use strict";
$d84241a3868bd79f$export$def9f260655b3a76 = $d84241a3868bd79f$var$isSaturday;

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $d84241a3868bd79f$var$isSaturday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 6;
}


var $971b91a830c22187$exports = {};

$parcel$export($971b91a830c22187$exports, "isSunday", () => $971b91a830c22187$export$70f720dfc6028987, (v) => $971b91a830c22187$export$70f720dfc6028987 = v);
var $971b91a830c22187$export$70f720dfc6028987;
"use strict";
$971b91a830c22187$export$70f720dfc6028987 = $971b91a830c22187$var$isSunday;

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $971b91a830c22187$var$isSunday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 0;
}


var $126e0ee47695e680$exports = {};

$parcel$export($126e0ee47695e680$exports, "isWeekend", () => $126e0ee47695e680$export$618d60ea299da42, (v) => $126e0ee47695e680$export$618d60ea299da42 = v);
var $126e0ee47695e680$export$618d60ea299da42;
"use strict";
$126e0ee47695e680$export$618d60ea299da42 = $126e0ee47695e680$var$isWeekend;

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $126e0ee47695e680$var$isWeekend(date) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay();
    return day === 0 || day === 6;
}



/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $370ee6dc5d0513ee$var$addBusinessDays(date, amount) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const startedOnWeekend = (0, $126e0ee47695e680$export$618d60ea299da42)(_date);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $126e0ee47695e680$export$618d60ea299da42)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $126e0ee47695e680$export$618d60ea299da42)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $d84241a3868bd79f$export$def9f260655b3a76)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $971b91a830c22187$export$70f720dfc6028987)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}


Object.keys($370ee6dc5d0513ee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $370ee6dc5d0513ee$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $370ee6dc5d0513ee$exports[key];
        }
    });
});

Object.keys($a351150ce2eb3ddb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a351150ce2eb3ddb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a351150ce2eb3ddb$exports[key];
        }
    });
});
var $dada8b88b0873e8d$exports = {};

$parcel$export($dada8b88b0873e8d$exports, "addHours", () => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6, (v) => $dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = v);
var $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;
"use strict";
$dada8b88b0873e8d$export$4a4306ad4fa0e5e6 = $dada8b88b0873e8d$var$addHours;
var $a1665abf6052bbc9$exports = {};

$parcel$export($a1665abf6052bbc9$exports, "addMilliseconds", () => $a1665abf6052bbc9$export$baf757aaf0c95c94, (v) => $a1665abf6052bbc9$export$baf757aaf0c95c94 = v);
var $a1665abf6052bbc9$export$baf757aaf0c95c94;
"use strict";
$a1665abf6052bbc9$export$baf757aaf0c95c94 = $a1665abf6052bbc9$var$addMilliseconds;


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $a1665abf6052bbc9$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, timestamp + amount);
}


var $8540a44f59a4af84$export$7271e9e3478110d1;
var $8540a44f59a4af84$export$34804a017b31e2fe;
var $8540a44f59a4af84$export$be1dccf2de902d31;
var $8540a44f59a4af84$export$8e6600bbdee7dabb;
var $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
var $8540a44f59a4af84$export$698aec755e92c695;
var $8540a44f59a4af84$export$815a9362476d2fe3;
var $8540a44f59a4af84$export$4db7641526e3241f;
var $8540a44f59a4af84$export$80d7e435f744f319;
var $8540a44f59a4af84$export$3c58128db900d44e;
var $8540a44f59a4af84$export$3633035e63cee86a;
var $8540a44f59a4af84$export$ab7da2ccd1075c38;
var $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
var $8540a44f59a4af84$export$2423174df8cd3cd2;
var $8540a44f59a4af84$export$4dec998e48f9c246;
var $8540a44f59a4af84$export$4fad13613e88edc8;
var $8540a44f59a4af84$export$397c2d5776aa9055;
var $8540a44f59a4af84$export$91246f0b9bd9beff;
var $8540a44f59a4af84$export$7f72910d6dfd237a;
var $8540a44f59a4af84$export$b76b1809a2898f9a;
var $8540a44f59a4af84$export$81caae6e1cc7a622;
var $8540a44f59a4af84$export$3913210603d8e9ae;
var $8540a44f59a4af84$export$dfd9b671c89acc8e;
"use strict";
$8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = $8540a44f59a4af84$export$698aec755e92c695 = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$4db7641526e3241f = $8540a44f59a4af84$export$80d7e435f744f319 = $8540a44f59a4af84$export$3c58128db900d44e = $8540a44f59a4af84$export$3633035e63cee86a = $8540a44f59a4af84$export$ab7da2ccd1075c38 = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = $8540a44f59a4af84$export$2423174df8cd3cd2 = $8540a44f59a4af84$export$4dec998e48f9c246 = $8540a44f59a4af84$export$4fad13613e88edc8 = $8540a44f59a4af84$export$397c2d5776aa9055 = $8540a44f59a4af84$export$91246f0b9bd9beff = $8540a44f59a4af84$export$7f72910d6dfd237a = $8540a44f59a4af84$export$b76b1809a2898f9a = $8540a44f59a4af84$export$81caae6e1cc7a622 = $8540a44f59a4af84$export$3913210603d8e9ae = $8540a44f59a4af84$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$var$daysInWeek = $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $8540a44f59a4af84$var$daysInYear = $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$maxTime = $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $8540a44f59a4af84$var$minTime = $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $8540a44f59a4af84$var$millisecondsInWeek = $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $8540a44f59a4af84$var$millisecondsInDay = $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $8540a44f59a4af84$var$millisecondsInMinute = $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $8540a44f59a4af84$var$millisecondsInHour = $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $8540a44f59a4af84$var$millisecondsInSecond = $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $8540a44f59a4af84$var$minutesInYear = $8540a44f59a4af84$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $8540a44f59a4af84$var$minutesInMonth = $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $8540a44f59a4af84$var$minutesInDay = $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $8540a44f59a4af84$var$minutesInHour = $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $8540a44f59a4af84$var$monthsInQuarter = $8540a44f59a4af84$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $8540a44f59a4af84$var$monthsInYear = $8540a44f59a4af84$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $8540a44f59a4af84$var$quartersInYear = $8540a44f59a4af84$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $8540a44f59a4af84$var$secondsInHour = $8540a44f59a4af84$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $8540a44f59a4af84$var$secondsInMinute = $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $8540a44f59a4af84$var$secondsInDay = $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $8540a44f59a4af84$var$secondsInWeek = $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $8540a44f59a4af84$var$secondsInYear = $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$var$secondsInDay * $8540a44f59a4af84$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $8540a44f59a4af84$var$secondsInMonth = $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $8540a44f59a4af84$var$secondsInQuarter = $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$var$secondsInMonth * 3;


/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $dada8b88b0873e8d$var$addHours(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * $8540a44f59a4af84$export$7f72910d6dfd237a);
}


Object.keys($dada8b88b0873e8d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $dada8b88b0873e8d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $dada8b88b0873e8d$exports[key];
        }
    });
});
var $bfbc76d70792463e$exports = {};

$parcel$export($bfbc76d70792463e$exports, "addISOWeekYears", () => $bfbc76d70792463e$export$c8240694da10d5f, (v) => $bfbc76d70792463e$export$c8240694da10d5f = v);
var $bfbc76d70792463e$export$c8240694da10d5f;
"use strict";
$bfbc76d70792463e$export$c8240694da10d5f = $bfbc76d70792463e$var$addISOWeekYears;
var $c95dff76bf2f692a$exports = {};

$parcel$export($c95dff76bf2f692a$exports, "getISOWeekYear", () => $c95dff76bf2f692a$export$3dbc52535f6f8fcc, (v) => $c95dff76bf2f692a$export$3dbc52535f6f8fcc = v);
var $c95dff76bf2f692a$export$3dbc52535f6f8fcc;
"use strict";
$c95dff76bf2f692a$export$3dbc52535f6f8fcc = $c95dff76bf2f692a$var$getISOWeekYear;

var $1c9d32c6cb108460$exports = {};

$parcel$export($1c9d32c6cb108460$exports, "startOfISOWeek", () => $1c9d32c6cb108460$export$6173213f95a4431e, (v) => $1c9d32c6cb108460$export$6173213f95a4431e = v);
var $1c9d32c6cb108460$export$6173213f95a4431e;
"use strict";
$1c9d32c6cb108460$export$6173213f95a4431e = $1c9d32c6cb108460$var$startOfISOWeek;
var $61f11f7a26b3ab78$exports = {};

$parcel$export($61f11f7a26b3ab78$exports, "startOfWeek", () => $61f11f7a26b3ab78$export$42c81a444fbfb5d4, (v) => $61f11f7a26b3ab78$export$42c81a444fbfb5d4 = v);
var $61f11f7a26b3ab78$export$42c81a444fbfb5d4;
"use strict";
$61f11f7a26b3ab78$export$42c81a444fbfb5d4 = $61f11f7a26b3ab78$var$startOfWeek;

var $39440020b58e1ef8$export$430a3269e24b912e;
var $39440020b58e1ef8$export$95365be1b0704abc;
"use strict";
$39440020b58e1ef8$export$430a3269e24b912e = $39440020b58e1ef8$var$getDefaultOptions;
$39440020b58e1ef8$export$95365be1b0704abc = $39440020b58e1ef8$var$setDefaultOptions;
let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$var$getDefaultOptions() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$var$setDefaultOptions(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}


/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $61f11f7a26b3ab78$var$startOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $1c9d32c6cb108460$var$startOfISOWeek(date) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $c95dff76bf2f692a$var$getISOWeekYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}


var $a1a2df6fabe9eb62$exports = {};

$parcel$export($a1a2df6fabe9eb62$exports, "setISOWeekYear", () => $a1a2df6fabe9eb62$export$814397aabf10ab77, (v) => $a1a2df6fabe9eb62$export$814397aabf10ab77 = v);
var $a1a2df6fabe9eb62$export$814397aabf10ab77;
"use strict";
$a1a2df6fabe9eb62$export$814397aabf10ab77 = $a1a2df6fabe9eb62$var$setISOWeekYear;

var $737f54e9ffaddc15$exports = {};

$parcel$export($737f54e9ffaddc15$exports, "differenceInCalendarDays", () => $737f54e9ffaddc15$export$4a02e9c37dab4871, (v) => $737f54e9ffaddc15$export$4a02e9c37dab4871 = v);
var $737f54e9ffaddc15$export$4a02e9c37dab4871;
"use strict";
$737f54e9ffaddc15$export$4a02e9c37dab4871 = $737f54e9ffaddc15$var$differenceInCalendarDays;

var $b6caff0bf13dcaf5$exports = {};

$parcel$export($b6caff0bf13dcaf5$exports, "startOfDay", () => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2, (v) => $b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = v);
var $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;
"use strict";
$b6caff0bf13dcaf5$export$63fa379ae8a9ba2 = $b6caff0bf13dcaf5$var$startOfDay;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $b6caff0bf13dcaf5$var$startOfDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


var $92dc0740ffabe180$export$113002b5eff6e430;
"use strict";
$92dc0740ffabe180$export$113002b5eff6e430 = $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $92dc0740ffabe180$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $737f54e9ffaddc15$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$b76b1809a2898f9a);
}


var $3b2e6199275b27d6$exports = {};

$parcel$export($3b2e6199275b27d6$exports, "startOfISOWeekYear", () => $3b2e6199275b27d6$export$236bdfa374eb69a9, (v) => $3b2e6199275b27d6$export$236bdfa374eb69a9 = v);
var $3b2e6199275b27d6$export$236bdfa374eb69a9;
"use strict";
$3b2e6199275b27d6$export$236bdfa374eb69a9 = $3b2e6199275b27d6$var$startOfISOWeekYear;



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $3b2e6199275b27d6$var$startOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}



/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $a1a2df6fabe9eb62$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date));
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $bfbc76d70792463e$var$addISOWeekYears(date, amount) {
    return (0, $a1a2df6fabe9eb62$export$814397aabf10ab77)(date, (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date) + amount);
}


Object.keys($bfbc76d70792463e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bfbc76d70792463e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bfbc76d70792463e$exports[key];
        }
    });
});

Object.keys($a1665abf6052bbc9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a1665abf6052bbc9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a1665abf6052bbc9$exports[key];
        }
    });
});
var $e8dac3cf5df5dbc8$exports = {};

$parcel$export($e8dac3cf5df5dbc8$exports, "addMinutes", () => $e8dac3cf5df5dbc8$export$2287e3d29250119e, (v) => $e8dac3cf5df5dbc8$export$2287e3d29250119e = v);
var $e8dac3cf5df5dbc8$export$2287e3d29250119e;
"use strict";
$e8dac3cf5df5dbc8$export$2287e3d29250119e = $e8dac3cf5df5dbc8$var$addMinutes;


/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $e8dac3cf5df5dbc8$var$addMinutes(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * $8540a44f59a4af84$export$91246f0b9bd9beff);
}


Object.keys($e8dac3cf5df5dbc8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e8dac3cf5df5dbc8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e8dac3cf5df5dbc8$exports[key];
        }
    });
});

Object.keys($8fcd3b0bf5df7635$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8fcd3b0bf5df7635$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8fcd3b0bf5df7635$exports[key];
        }
    });
});
var $30e5a3aa581ecd23$exports = {};

$parcel$export($30e5a3aa581ecd23$exports, "addQuarters", () => $30e5a3aa581ecd23$export$c252a41d0fbed2ce, (v) => $30e5a3aa581ecd23$export$c252a41d0fbed2ce = v);
var $30e5a3aa581ecd23$export$c252a41d0fbed2ce;
"use strict";
$30e5a3aa581ecd23$export$c252a41d0fbed2ce = $30e5a3aa581ecd23$var$addQuarters;

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $30e5a3aa581ecd23$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, months);
}


Object.keys($30e5a3aa581ecd23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $30e5a3aa581ecd23$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $30e5a3aa581ecd23$exports[key];
        }
    });
});
var $ec74b6b01c6372f4$exports = {};

$parcel$export($ec74b6b01c6372f4$exports, "addSeconds", () => $ec74b6b01c6372f4$export$3cb31b0df13be68, (v) => $ec74b6b01c6372f4$export$3cb31b0df13be68 = v);
var $ec74b6b01c6372f4$export$3cb31b0df13be68;
"use strict";
$ec74b6b01c6372f4$export$3cb31b0df13be68 = $ec74b6b01c6372f4$var$addSeconds;

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $ec74b6b01c6372f4$var$addSeconds(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * 1000);
}


Object.keys($ec74b6b01c6372f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ec74b6b01c6372f4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ec74b6b01c6372f4$exports[key];
        }
    });
});
var $bce641bd93181421$exports = {};

$parcel$export($bce641bd93181421$exports, "addWeeks", () => $bce641bd93181421$export$ef501a2bb4f3ee6b, (v) => $bce641bd93181421$export$ef501a2bb4f3ee6b = v);
var $bce641bd93181421$export$ef501a2bb4f3ee6b;
"use strict";
$bce641bd93181421$export$ef501a2bb4f3ee6b = $bce641bd93181421$var$addWeeks;

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $bce641bd93181421$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, days);
}


Object.keys($bce641bd93181421$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bce641bd93181421$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bce641bd93181421$exports[key];
        }
    });
});
var $25460c542fb3bf74$exports = {};

$parcel$export($25460c542fb3bf74$exports, "addYears", () => $25460c542fb3bf74$export$3d83eec43f4ea476, (v) => $25460c542fb3bf74$export$3d83eec43f4ea476 = v);
var $25460c542fb3bf74$export$3d83eec43f4ea476;
"use strict";
$25460c542fb3bf74$export$3d83eec43f4ea476 = $25460c542fb3bf74$var$addYears;

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $25460c542fb3bf74$var$addYears(date, amount) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 12);
}


Object.keys($25460c542fb3bf74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $25460c542fb3bf74$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $25460c542fb3bf74$exports[key];
        }
    });
});
var $fab0ab4e3f2f210f$exports = {};

$parcel$export($fab0ab4e3f2f210f$exports, "areIntervalsOverlapping", () => $fab0ab4e3f2f210f$export$2bf3385645436101, (v) => $fab0ab4e3f2f210f$export$2bf3385645436101 = v);
var $fab0ab4e3f2f210f$export$2bf3385645436101;
"use strict";
$fab0ab4e3f2f210f$export$2bf3385645436101 = $fab0ab4e3f2f210f$var$areIntervalsOverlapping;

/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $fab0ab4e3f2f210f$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


Object.keys($fab0ab4e3f2f210f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fab0ab4e3f2f210f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fab0ab4e3f2f210f$exports[key];
        }
    });
});
var $5a85a167b627226d$exports = {};

$parcel$export($5a85a167b627226d$exports, "clamp", () => $5a85a167b627226d$export$7d15b64cf5a3a4c4, (v) => $5a85a167b627226d$export$7d15b64cf5a3a4c4 = v);
var $5a85a167b627226d$export$7d15b64cf5a3a4c4;
"use strict";
$5a85a167b627226d$export$7d15b64cf5a3a4c4 = $5a85a167b627226d$var$clamp;
var $b70baca84fc92b6d$exports = {};

$parcel$export($b70baca84fc92b6d$exports, "max", () => $b70baca84fc92b6d$export$8960430cfd85939f, (v) => $b70baca84fc92b6d$export$8960430cfd85939f = v);
var $b70baca84fc92b6d$export$8960430cfd85939f;
"use strict";
$b70baca84fc92b6d$export$8960430cfd85939f = $b70baca84fc92b6d$var$max;

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $b70baca84fc92b6d$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}


var $5d373ce01680b655$exports = {};

$parcel$export($5d373ce01680b655$exports, "min", () => $5d373ce01680b655$export$96ec731ed4dcb222, (v) => $5d373ce01680b655$export$96ec731ed4dcb222 = v);
var $5d373ce01680b655$export$96ec731ed4dcb222;
"use strict";
$5d373ce01680b655$export$96ec731ed4dcb222 = $5d373ce01680b655$var$min;

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $5d373ce01680b655$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}


/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $5a85a167b627226d$var$clamp(date, interval) {
    return (0, $5d373ce01680b655$export$96ec731ed4dcb222)([
        (0, $b70baca84fc92b6d$export$8960430cfd85939f)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}


Object.keys($5a85a167b627226d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5a85a167b627226d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5a85a167b627226d$exports[key];
        }
    });
});
var $0a8ccabde02ae96a$exports = {};

$parcel$export($0a8ccabde02ae96a$exports, "closestIndexTo", () => $0a8ccabde02ae96a$export$42127b72a9d091c7, (v) => $0a8ccabde02ae96a$export$42127b72a9d091c7 = v);
var $0a8ccabde02ae96a$export$42127b72a9d091c7;
"use strict";
$0a8ccabde02ae96a$export$42127b72a9d091c7 = $0a8ccabde02ae96a$var$closestIndexTo;

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $0a8ccabde02ae96a$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($0a8ccabde02ae96a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0a8ccabde02ae96a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0a8ccabde02ae96a$exports[key];
        }
    });
});
var $a5d88e0ec96e8c2a$exports = {};

$parcel$export($a5d88e0ec96e8c2a$exports, "closestTo", () => $a5d88e0ec96e8c2a$export$73858b464497125a, (v) => $a5d88e0ec96e8c2a$export$73858b464497125a = v);
var $a5d88e0ec96e8c2a$export$73858b464497125a;
"use strict";
$a5d88e0ec96e8c2a$export$73858b464497125a = $a5d88e0ec96e8c2a$var$closestTo;


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $a5d88e0ec96e8c2a$var$closestTo(dateToCompare, dates) {
    const date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($a5d88e0ec96e8c2a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a5d88e0ec96e8c2a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a5d88e0ec96e8c2a$exports[key];
        }
    });
});
var $e9cff913190bd013$exports = {};

$parcel$export($e9cff913190bd013$exports, "compareAsc", () => $e9cff913190bd013$export$fe114145ae75d197, (v) => $e9cff913190bd013$export$fe114145ae75d197 = v);
var $e9cff913190bd013$export$fe114145ae75d197;
"use strict";
$e9cff913190bd013$export$fe114145ae75d197 = $e9cff913190bd013$var$compareAsc;

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $e9cff913190bd013$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($e9cff913190bd013$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e9cff913190bd013$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e9cff913190bd013$exports[key];
        }
    });
});
var $14d58ffa6ac05331$exports = {};

$parcel$export($14d58ffa6ac05331$exports, "compareDesc", () => $14d58ffa6ac05331$export$ed84005ac9356f7a, (v) => $14d58ffa6ac05331$export$ed84005ac9356f7a = v);
var $14d58ffa6ac05331$export$ed84005ac9356f7a;
"use strict";
$14d58ffa6ac05331$export$ed84005ac9356f7a = $14d58ffa6ac05331$var$compareDesc;

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $14d58ffa6ac05331$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}


Object.keys($14d58ffa6ac05331$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $14d58ffa6ac05331$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $14d58ffa6ac05331$exports[key];
        }
    });
});

Object.keys($abb9adbdb26342b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $abb9adbdb26342b3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $abb9adbdb26342b3$exports[key];
        }
    });
});
var $d8623e255497753b$exports = {};

$parcel$export($d8623e255497753b$exports, "constructNow", () => $d8623e255497753b$export$18c3c6510fb97afc, (v) => $d8623e255497753b$export$18c3c6510fb97afc = v);
var $d8623e255497753b$export$18c3c6510fb97afc;
"use strict";
$d8623e255497753b$export$18c3c6510fb97afc = $d8623e255497753b$var$constructNow;

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $d8623e255497753b$var$constructNow(date) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, Date.now());
}


Object.keys($d8623e255497753b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d8623e255497753b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d8623e255497753b$exports[key];
        }
    });
});
var $316e04d0ee94a61b$exports = {};

$parcel$export($316e04d0ee94a61b$exports, "daysToWeeks", () => $316e04d0ee94a61b$export$66d8b66cbb6006a8, (v) => $316e04d0ee94a61b$export$66d8b66cbb6006a8 = v);
var $316e04d0ee94a61b$export$66d8b66cbb6006a8;
"use strict";
$316e04d0ee94a61b$export$66d8b66cbb6006a8 = $316e04d0ee94a61b$var$daysToWeeks;

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $316e04d0ee94a61b$var$daysToWeeks(days) {
    const weeks = days / $8540a44f59a4af84$export$dfd9b671c89acc8e;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($316e04d0ee94a61b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $316e04d0ee94a61b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $316e04d0ee94a61b$exports[key];
        }
    });
});
var $7609e09e1797fdf5$exports = {};

$parcel$export($7609e09e1797fdf5$exports, "differenceInBusinessDays", () => $7609e09e1797fdf5$export$f30d3269a6c53cb9, (v) => $7609e09e1797fdf5$export$f30d3269a6c53cb9 = v);
var $7609e09e1797fdf5$export$f30d3269a6c53cb9;
"use strict";
$7609e09e1797fdf5$export$f30d3269a6c53cb9 = $7609e09e1797fdf5$var$differenceInBusinessDays;


var $27a7db21eafd685b$exports = {};

$parcel$export($27a7db21eafd685b$exports, "isSameDay", () => $27a7db21eafd685b$export$ea39ec197993aef0, (v) => $27a7db21eafd685b$export$ea39ec197993aef0 = v);
var $27a7db21eafd685b$export$ea39ec197993aef0;
"use strict";
$27a7db21eafd685b$export$ea39ec197993aef0 = $27a7db21eafd685b$var$isSameDay;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $27a7db21eafd685b$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft);
    const dateRightStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}


var $f2a682b251363bc2$exports = {};

$parcel$export($f2a682b251363bc2$exports, "isValid", () => $f2a682b251363bc2$export$1ea939691cdc45b8, (v) => $f2a682b251363bc2$export$1ea939691cdc45b8 = v);
var $f2a682b251363bc2$export$1ea939691cdc45b8;
"use strict";
$f2a682b251363bc2$export$1ea939691cdc45b8 = $f2a682b251363bc2$var$isValid;
var $1896b5e28554d57b$exports = {};

$parcel$export($1896b5e28554d57b$exports, "isDate", () => $1896b5e28554d57b$export$871608497c498473, (v) => $1896b5e28554d57b$export$871608497c498473 = v);
var $1896b5e28554d57b$export$871608497c498473;
"use strict";
$1896b5e28554d57b$export$871608497c498473 = $1896b5e28554d57b$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $1896b5e28554d57b$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $f2a682b251363bc2$var$isValid(date) {
    if (!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}




/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $7609e09e1797fdf5$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    let _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_dateLeft) || !(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_dateRight)) return NaN;
    const calendarDifference = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $27a7db21eafd685b$export$ea39ec197993aef0)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $126e0ee47695e680$export$618d60ea299da42)(_dateRight) ? 0 : sign;
        _dateRight = (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($7609e09e1797fdf5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7609e09e1797fdf5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7609e09e1797fdf5$exports[key];
        }
    });
});

Object.keys($737f54e9ffaddc15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $737f54e9ffaddc15$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $737f54e9ffaddc15$exports[key];
        }
    });
});
var $e1e14fdea06c0988$exports = {};

$parcel$export($e1e14fdea06c0988$exports, "differenceInCalendarISOWeekYears", () => $e1e14fdea06c0988$export$7f8a73dc2e50a070, (v) => $e1e14fdea06c0988$export$7f8a73dc2e50a070 = v);
var $e1e14fdea06c0988$export$7f8a73dc2e50a070;
"use strict";
$e1e14fdea06c0988$export$7f8a73dc2e50a070 = $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears;

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $e1e14fdea06c0988$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(dateLeft) - (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(dateRight);
}


Object.keys($e1e14fdea06c0988$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e1e14fdea06c0988$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e1e14fdea06c0988$exports[key];
        }
    });
});
var $6f59510051d42333$exports = {};

$parcel$export($6f59510051d42333$exports, "differenceInCalendarISOWeeks", () => $6f59510051d42333$export$28df1cb58b17e450, (v) => $6f59510051d42333$export$28df1cb58b17e450 = v);
var $6f59510051d42333$export$28df1cb58b17e450;
"use strict";
$6f59510051d42333$export$28df1cb58b17e450 = $6f59510051d42333$var$differenceInCalendarISOWeeks;



/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $6f59510051d42333$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(dateLeft);
    const startOfISOWeekRight = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($6f59510051d42333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f59510051d42333$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f59510051d42333$exports[key];
        }
    });
});
var $8aa264ebd3f03841$exports = {};

$parcel$export($8aa264ebd3f03841$exports, "differenceInCalendarMonths", () => $8aa264ebd3f03841$export$489984ac7c996389, (v) => $8aa264ebd3f03841$export$489984ac7c996389 = v);
var $8aa264ebd3f03841$export$489984ac7c996389;
"use strict";
$8aa264ebd3f03841$export$489984ac7c996389 = $8aa264ebd3f03841$var$differenceInCalendarMonths;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $8aa264ebd3f03841$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}


Object.keys($8aa264ebd3f03841$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8aa264ebd3f03841$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8aa264ebd3f03841$exports[key];
        }
    });
});
var $5806b276dadb0858$exports = {};

$parcel$export($5806b276dadb0858$exports, "differenceInCalendarQuarters", () => $5806b276dadb0858$export$f62ae9fb13958c7a, (v) => $5806b276dadb0858$export$f62ae9fb13958c7a = v);
var $5806b276dadb0858$export$f62ae9fb13958c7a;
"use strict";
$5806b276dadb0858$export$f62ae9fb13958c7a = $5806b276dadb0858$var$differenceInCalendarQuarters;
var $763325f0c93713da$exports = {};

$parcel$export($763325f0c93713da$exports, "getQuarter", () => $763325f0c93713da$export$de90a4bb31c25221, (v) => $763325f0c93713da$export$de90a4bb31c25221 = v);
var $763325f0c93713da$export$de90a4bb31c25221;
"use strict";
$763325f0c93713da$export$de90a4bb31c25221 = $763325f0c93713da$var$getQuarter;

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $763325f0c93713da$var$getQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $5806b276dadb0858$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $763325f0c93713da$export$de90a4bb31c25221)(_dateLeft) - (0, $763325f0c93713da$export$de90a4bb31c25221)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}


Object.keys($5806b276dadb0858$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5806b276dadb0858$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5806b276dadb0858$exports[key];
        }
    });
});
var $c8670ac5b8c1edee$exports = {};

$parcel$export($c8670ac5b8c1edee$exports, "differenceInCalendarWeeks", () => $c8670ac5b8c1edee$export$6ed034ce62348e4, (v) => $c8670ac5b8c1edee$export$6ed034ce62348e4 = v);
var $c8670ac5b8c1edee$export$6ed034ce62348e4;
"use strict";
$c8670ac5b8c1edee$export$6ed034ce62348e4 = $c8670ac5b8c1edee$var$differenceInCalendarWeeks;



/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $c8670ac5b8c1edee$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateLeft, options);
    const startOfWeekRight = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($c8670ac5b8c1edee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c8670ac5b8c1edee$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c8670ac5b8c1edee$exports[key];
        }
    });
});
var $539ce3f7450453a1$exports = {};

$parcel$export($539ce3f7450453a1$exports, "differenceInCalendarYears", () => $539ce3f7450453a1$export$c06dce8b38891685, (v) => $539ce3f7450453a1$export$c06dce8b38891685 = v);
var $539ce3f7450453a1$export$c06dce8b38891685;
"use strict";
$539ce3f7450453a1$export$c06dce8b38891685 = $539ce3f7450453a1$var$differenceInCalendarYears;

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $539ce3f7450453a1$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


Object.keys($539ce3f7450453a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $539ce3f7450453a1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $539ce3f7450453a1$exports[key];
        }
    });
});
var $21c2b10d84e6b5ad$exports = {};

$parcel$export($21c2b10d84e6b5ad$exports, "differenceInDays", () => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c, (v) => $21c2b10d84e6b5ad$export$86415ebf4eb36b8c = v);
var $21c2b10d84e6b5ad$export$86415ebf4eb36b8c;
"use strict";
$21c2b10d84e6b5ad$export$86415ebf4eb36b8c = $21c2b10d84e6b5ad$var$differenceInDays;


/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $21c2b10d84e6b5ad$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = $21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($21c2b10d84e6b5ad$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $21c2b10d84e6b5ad$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($21c2b10d84e6b5ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $21c2b10d84e6b5ad$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $21c2b10d84e6b5ad$exports[key];
        }
    });
});
var $f1e71fcc3bd0bed6$exports = {};

$parcel$export($f1e71fcc3bd0bed6$exports, "differenceInHours", () => $f1e71fcc3bd0bed6$export$5436ca250d4d6872, (v) => $f1e71fcc3bd0bed6$export$5436ca250d4d6872 = v);
var $f1e71fcc3bd0bed6$export$5436ca250d4d6872;
"use strict";
$f1e71fcc3bd0bed6$export$5436ca250d4d6872 = $f1e71fcc3bd0bed6$var$differenceInHours;
var $495af4000bb18bf7$export$b6474a47258c1211;
"use strict";
$495af4000bb18bf7$export$b6474a47258c1211 = $495af4000bb18bf7$var$getRoundingMethod;
function $495af4000bb18bf7$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



var $b7913fc338fe28ad$exports = {};

$parcel$export($b7913fc338fe28ad$exports, "differenceInMilliseconds", () => $b7913fc338fe28ad$export$7be94d13716b4bf6, (v) => $b7913fc338fe28ad$export$7be94d13716b4bf6 = v);
var $b7913fc338fe28ad$export$7be94d13716b4bf6;
"use strict";
$b7913fc338fe28ad$export$7be94d13716b4bf6 = $b7913fc338fe28ad$var$differenceInMilliseconds;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $b7913fc338fe28ad$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
}


/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $f1e71fcc3bd0bed6$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / $8540a44f59a4af84$export$7f72910d6dfd237a;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($f1e71fcc3bd0bed6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f1e71fcc3bd0bed6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f1e71fcc3bd0bed6$exports[key];
        }
    });
});
var $c4e072f0adb8f68e$exports = {};

$parcel$export($c4e072f0adb8f68e$exports, "differenceInISOWeekYears", () => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a, (v) => $c4e072f0adb8f68e$export$bf7bde0b3bf8913a = v);
var $c4e072f0adb8f68e$export$bf7bde0b3bf8913a;
"use strict";
$c4e072f0adb8f68e$export$bf7bde0b3bf8913a = $c4e072f0adb8f68e$var$differenceInISOWeekYears;


var $0ee59b8ff17647f3$exports = {};

$parcel$export($0ee59b8ff17647f3$exports, "subISOWeekYears", () => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa, (v) => $0ee59b8ff17647f3$export$4f7d47b952f4a0aa = v);
var $0ee59b8ff17647f3$export$4f7d47b952f4a0aa;
"use strict";
$0ee59b8ff17647f3$export$4f7d47b952f4a0aa = $0ee59b8ff17647f3$var$subISOWeekYears;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $0ee59b8ff17647f3$var$subISOWeekYears(date, amount) {
    return (0, $bfbc76d70792463e$export$c8240694da10d5f)(date, -amount);
}



/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $c4e072f0adb8f68e$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $e1e14fdea06c0988$export$7f8a73dc2e50a070)(_dateLeft, _dateRight));
    _dateLeft = (0, $0ee59b8ff17647f3$export$4f7d47b952f4a0aa)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($c4e072f0adb8f68e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c4e072f0adb8f68e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c4e072f0adb8f68e$exports[key];
        }
    });
});

Object.keys($b7913fc338fe28ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b7913fc338fe28ad$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b7913fc338fe28ad$exports[key];
        }
    });
});
var $67e743be56b112ce$exports = {};

$parcel$export($67e743be56b112ce$exports, "differenceInMinutes", () => $67e743be56b112ce$export$d904251335be481a, (v) => $67e743be56b112ce$export$d904251335be481a = v);
var $67e743be56b112ce$export$d904251335be481a;
"use strict";
$67e743be56b112ce$export$d904251335be481a = $67e743be56b112ce$var$differenceInMinutes;



/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $67e743be56b112ce$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / $8540a44f59a4af84$export$91246f0b9bd9beff;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($67e743be56b112ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $67e743be56b112ce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $67e743be56b112ce$exports[key];
        }
    });
});
var $4bb5df50b9b59298$exports = {};

$parcel$export($4bb5df50b9b59298$exports, "differenceInMonths", () => $4bb5df50b9b59298$export$fc1ed482c2861792, (v) => $4bb5df50b9b59298$export$fc1ed482c2861792 = v);
var $4bb5df50b9b59298$export$fc1ed482c2861792;
"use strict";
$4bb5df50b9b59298$export$fc1ed482c2861792 = $4bb5df50b9b59298$var$differenceInMonths;


var $d2050f4e5c1a3003$exports = {};

$parcel$export($d2050f4e5c1a3003$exports, "isLastDayOfMonth", () => $d2050f4e5c1a3003$export$c817d0312007ea5e, (v) => $d2050f4e5c1a3003$export$c817d0312007ea5e = v);
var $d2050f4e5c1a3003$export$c817d0312007ea5e;
"use strict";
$d2050f4e5c1a3003$export$c817d0312007ea5e = $d2050f4e5c1a3003$var$isLastDayOfMonth;
var $b6a2419fd0059687$exports = {};

$parcel$export($b6a2419fd0059687$exports, "endOfDay", () => $b6a2419fd0059687$export$eb9a03f0e9aa6cea, (v) => $b6a2419fd0059687$export$eb9a03f0e9aa6cea = v);
var $b6a2419fd0059687$export$eb9a03f0e9aa6cea;
"use strict";
$b6a2419fd0059687$export$eb9a03f0e9aa6cea = $b6a2419fd0059687$var$endOfDay;

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $b6a2419fd0059687$var$endOfDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $e58340063d97ab50$exports = {};

$parcel$export($e58340063d97ab50$exports, "endOfMonth", () => $e58340063d97ab50$export$a2258d9c4118825c, (v) => $e58340063d97ab50$export$a2258d9c4118825c = v);
var $e58340063d97ab50$export$a2258d9c4118825c;
"use strict";
$e58340063d97ab50$export$a2258d9c4118825c = $e58340063d97ab50$var$endOfMonth;

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $e58340063d97ab50$var$endOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}



/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $d2050f4e5c1a3003$var$isLastDayOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    return +(0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(_date) === +(0, $e58340063d97ab50$export$a2258d9c4118825c)(_date);
}



/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $4bb5df50b9b59298$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $8aa264ebd3f03841$export$489984ac7c996389)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $d2050f4e5c1a3003$export$c817d0312007ea5e)((0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft)) && difference === 1 && (0, $e9cff913190bd013$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($4bb5df50b9b59298$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4bb5df50b9b59298$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4bb5df50b9b59298$exports[key];
        }
    });
});
var $03f220a44a4339e3$exports = {};

$parcel$export($03f220a44a4339e3$exports, "differenceInQuarters", () => $03f220a44a4339e3$export$74b5c4055a405552, (v) => $03f220a44a4339e3$export$74b5c4055a405552 = v);
var $03f220a44a4339e3$export$74b5c4055a405552;
"use strict";
$03f220a44a4339e3$export$74b5c4055a405552 = $03f220a44a4339e3$var$differenceInQuarters;


/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $03f220a44a4339e3$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(dateLeft, dateRight) / 3;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($03f220a44a4339e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $03f220a44a4339e3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $03f220a44a4339e3$exports[key];
        }
    });
});
var $e9186d0161460806$exports = {};

$parcel$export($e9186d0161460806$exports, "differenceInSeconds", () => $e9186d0161460806$export$c1889aec51783710, (v) => $e9186d0161460806$export$c1889aec51783710 = v);
var $e9186d0161460806$export$c1889aec51783710;
"use strict";
$e9186d0161460806$export$c1889aec51783710 = $e9186d0161460806$var$differenceInSeconds;


/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $e9186d0161460806$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($e9186d0161460806$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e9186d0161460806$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e9186d0161460806$exports[key];
        }
    });
});
var $84f21af906303191$exports = {};

$parcel$export($84f21af906303191$exports, "differenceInWeeks", () => $84f21af906303191$export$b5147a91dc40ddb7, (v) => $84f21af906303191$export$b5147a91dc40ddb7 = v);
var $84f21af906303191$export$b5147a91dc40ddb7;
"use strict";
$84f21af906303191$export$b5147a91dc40ddb7 = $84f21af906303191$var$differenceInWeeks;


/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $84f21af906303191$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(dateLeft, dateRight) / 7;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($84f21af906303191$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $84f21af906303191$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $84f21af906303191$exports[key];
        }
    });
});
var $bf315c5624a2ab0b$exports = {};

$parcel$export($bf315c5624a2ab0b$exports, "differenceInYears", () => $bf315c5624a2ab0b$export$ed6bf486f68899ca, (v) => $bf315c5624a2ab0b$export$ed6bf486f68899ca = v);
var $bf315c5624a2ab0b$export$ed6bf486f68899ca;
"use strict";
$bf315c5624a2ab0b$export$ed6bf486f68899ca = $bf315c5624a2ab0b$var$differenceInYears;



/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $bf315c5624a2ab0b$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $539ce3f7450453a1$export$c06dce8b38891685)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($bf315c5624a2ab0b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf315c5624a2ab0b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf315c5624a2ab0b$exports[key];
        }
    });
});
var $0adf5760eb71daea$exports = {};

$parcel$export($0adf5760eb71daea$exports, "eachDayOfInterval", () => $0adf5760eb71daea$export$7a337e5923c7ceb5, (v) => $0adf5760eb71daea$export$7a337e5923c7ceb5 = v);
var $0adf5760eb71daea$export$7a337e5923c7ceb5;
"use strict";
$0adf5760eb71daea$export$7a337e5923c7ceb5 = $0adf5760eb71daea$var$eachDayOfInterval;

/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $0adf5760eb71daea$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($0adf5760eb71daea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0adf5760eb71daea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0adf5760eb71daea$exports[key];
        }
    });
});
var $b0a3f99021d001ef$exports = {};

$parcel$export($b0a3f99021d001ef$exports, "eachHourOfInterval", () => $b0a3f99021d001ef$export$bb4f48fee90ea86e, (v) => $b0a3f99021d001ef$export$bb4f48fee90ea86e = v);
var $b0a3f99021d001ef$export$bb4f48fee90ea86e;
"use strict";
$b0a3f99021d001ef$export$bb4f48fee90ea86e = $b0a3f99021d001ef$var$eachHourOfInterval;


/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $b0a3f99021d001ef$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($b0a3f99021d001ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b0a3f99021d001ef$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b0a3f99021d001ef$exports[key];
        }
    });
});
var $14e3ae081dfb5d06$exports = {};

$parcel$export($14e3ae081dfb5d06$exports, "eachMinuteOfInterval", () => $14e3ae081dfb5d06$export$82e17d693ce9eb6c, (v) => $14e3ae081dfb5d06$export$82e17d693ce9eb6c = v);
var $14e3ae081dfb5d06$export$82e17d693ce9eb6c;
"use strict";
$14e3ae081dfb5d06$export$82e17d693ce9eb6c = $14e3ae081dfb5d06$var$eachMinuteOfInterval;

var $d1ad424e56672364$exports = {};

$parcel$export($d1ad424e56672364$exports, "startOfMinute", () => $d1ad424e56672364$export$c66440458c6aa793, (v) => $d1ad424e56672364$export$c66440458c6aa793 = v);
var $d1ad424e56672364$export$c66440458c6aa793;
"use strict";
$d1ad424e56672364$export$c66440458c6aa793 = $d1ad424e56672364$var$startOfMinute;

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $d1ad424e56672364$var$startOfMinute(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(0, 0);
    return _date;
}



/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $14e3ae081dfb5d06$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $d1ad424e56672364$export$c66440458c6aa793)((0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start));
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($14e3ae081dfb5d06$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $14e3ae081dfb5d06$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $14e3ae081dfb5d06$exports[key];
        }
    });
});
var $f17d32e46529568a$exports = {};

$parcel$export($f17d32e46529568a$exports, "eachMonthOfInterval", () => $f17d32e46529568a$export$1c9322f2d2a5eed3, (v) => $f17d32e46529568a$export$1c9322f2d2a5eed3 = v);
var $f17d32e46529568a$export$1c9322f2d2a5eed3;
"use strict";
$f17d32e46529568a$export$1c9322f2d2a5eed3 = $f17d32e46529568a$var$eachMonthOfInterval;

/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $f17d32e46529568a$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($f17d32e46529568a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f17d32e46529568a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f17d32e46529568a$exports[key];
        }
    });
});
var $787ee41e326f83b2$exports = {};

$parcel$export($787ee41e326f83b2$exports, "eachQuarterOfInterval", () => $787ee41e326f83b2$export$96790a0abfab0078, (v) => $787ee41e326f83b2$export$96790a0abfab0078 = v);
var $787ee41e326f83b2$export$96790a0abfab0078;
"use strict";
$787ee41e326f83b2$export$96790a0abfab0078 = $787ee41e326f83b2$var$eachQuarterOfInterval;

var $c922a15e7d8774a7$exports = {};

$parcel$export($c922a15e7d8774a7$exports, "startOfQuarter", () => $c922a15e7d8774a7$export$69be7267a042ecb3, (v) => $c922a15e7d8774a7$export$69be7267a042ecb3 = v);
var $c922a15e7d8774a7$export$69be7267a042ecb3;
"use strict";
$c922a15e7d8774a7$export$69be7267a042ecb3 = $c922a15e7d8774a7$var$startOfQuarter;

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $c922a15e7d8774a7$var$startOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $787ee41e326f83b2$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(startDate) : +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(endDate);
    let currentDate = reversed ? (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(endDate) : (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $30e5a3aa581ecd23$export$c252a41d0fbed2ce)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($787ee41e326f83b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $787ee41e326f83b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $787ee41e326f83b2$exports[key];
        }
    });
});
var $72c3bea95dec77b2$exports = {};

$parcel$export($72c3bea95dec77b2$exports, "eachWeekOfInterval", () => $72c3bea95dec77b2$export$d31a8caec75fa456, (v) => $72c3bea95dec77b2$export$d31a8caec75fa456 = v);
var $72c3bea95dec77b2$export$d31a8caec75fa456;
"use strict";
$72c3bea95dec77b2$export$d31a8caec75fa456 = $72c3bea95dec77b2$var$eachWeekOfInterval;



/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $72c3bea95dec77b2$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(endDate, options) : (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(startDate, options);
    const endDateWeek = reversed ? (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(startDate, options) : (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($72c3bea95dec77b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $72c3bea95dec77b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $72c3bea95dec77b2$exports[key];
        }
    });
});
var $adb2f2b5832b8aeb$exports = {};

$parcel$export($adb2f2b5832b8aeb$exports, "eachWeekendOfInterval", () => $adb2f2b5832b8aeb$export$a2ae85dd849354a8, (v) => $adb2f2b5832b8aeb$export$a2ae85dd849354a8 = v);
var $adb2f2b5832b8aeb$export$a2ae85dd849354a8;
"use strict";
$adb2f2b5832b8aeb$export$a2ae85dd849354a8 = $adb2f2b5832b8aeb$var$eachWeekendOfInterval;


/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $adb2f2b5832b8aeb$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $0adf5760eb71daea$export$7a337e5923c7ceb5)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $126e0ee47695e680$export$618d60ea299da42)(date)) weekends.push(date);
    }
    return weekends;
}


Object.keys($adb2f2b5832b8aeb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $adb2f2b5832b8aeb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $adb2f2b5832b8aeb$exports[key];
        }
    });
});
var $870fa59f10358ead$exports = {};

$parcel$export($870fa59f10358ead$exports, "eachWeekendOfMonth", () => $870fa59f10358ead$export$f9a185d0ad232d17, (v) => $870fa59f10358ead$export$f9a185d0ad232d17 = v);
var $870fa59f10358ead$export$f9a185d0ad232d17;
"use strict";
$870fa59f10358ead$export$f9a185d0ad232d17 = $870fa59f10358ead$var$eachWeekendOfMonth;


var $c0b4ec5551eca4c9$exports = {};

$parcel$export($c0b4ec5551eca4c9$exports, "startOfMonth", () => $c0b4ec5551eca4c9$export$a5a3b454ada2268e, (v) => $c0b4ec5551eca4c9$export$a5a3b454ada2268e = v);
var $c0b4ec5551eca4c9$export$a5a3b454ada2268e;
"use strict";
$c0b4ec5551eca4c9$export$a5a3b454ada2268e = $c0b4ec5551eca4c9$var$startOfMonth;

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c0b4ec5551eca4c9$var$startOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $870fa59f10358ead$var$eachWeekendOfMonth(date) {
    const start = (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date);
    const end = (0, $e58340063d97ab50$export$a2258d9c4118825c)(date);
    return (0, $adb2f2b5832b8aeb$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($870fa59f10358ead$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $870fa59f10358ead$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $870fa59f10358ead$exports[key];
        }
    });
});
var $eda896eb36e12788$exports = {};

$parcel$export($eda896eb36e12788$exports, "eachWeekendOfYear", () => $eda896eb36e12788$export$d4a9e5efc1ddceb9, (v) => $eda896eb36e12788$export$d4a9e5efc1ddceb9 = v);
var $eda896eb36e12788$export$d4a9e5efc1ddceb9;
"use strict";
$eda896eb36e12788$export$d4a9e5efc1ddceb9 = $eda896eb36e12788$var$eachWeekendOfYear;

var $6cbfdc6d008595cd$exports = {};

$parcel$export($6cbfdc6d008595cd$exports, "endOfYear", () => $6cbfdc6d008595cd$export$8b7aa55c66d5569e, (v) => $6cbfdc6d008595cd$export$8b7aa55c66d5569e = v);
var $6cbfdc6d008595cd$export$8b7aa55c66d5569e;
"use strict";
$6cbfdc6d008595cd$export$8b7aa55c66d5569e = $6cbfdc6d008595cd$var$endOfYear;

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $6cbfdc6d008595cd$var$endOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $29cc086f79701cd9$exports = {};

$parcel$export($29cc086f79701cd9$exports, "startOfYear", () => $29cc086f79701cd9$export$f91e89d3d0406102, (v) => $29cc086f79701cd9$export$f91e89d3d0406102 = v);
var $29cc086f79701cd9$export$f91e89d3d0406102;
"use strict";
$29cc086f79701cd9$export$f91e89d3d0406102 = $29cc086f79701cd9$var$startOfYear;


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $29cc086f79701cd9$var$startOfYear(date) {
    const cleanDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _date = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $eda896eb36e12788$var$eachWeekendOfYear(date) {
    const start = (0, $29cc086f79701cd9$export$f91e89d3d0406102)(date);
    const end = (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(date);
    return (0, $adb2f2b5832b8aeb$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($eda896eb36e12788$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $eda896eb36e12788$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $eda896eb36e12788$exports[key];
        }
    });
});
var $fd60f2d8b17fd3e1$exports = {};

$parcel$export($fd60f2d8b17fd3e1$exports, "eachYearOfInterval", () => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5, (v) => $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = v);
var $fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5;
"use strict";
$fd60f2d8b17fd3e1$export$9b7f165f0a71d2a5 = $fd60f2d8b17fd3e1$var$eachYearOfInterval;

/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $fd60f2d8b17fd3e1$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $231bfb8d72679740$export$e67a095c620b86fe)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($fd60f2d8b17fd3e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fd60f2d8b17fd3e1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fd60f2d8b17fd3e1$exports[key];
        }
    });
});

Object.keys($b6a2419fd0059687$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b6a2419fd0059687$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b6a2419fd0059687$exports[key];
        }
    });
});
var $ebb5e0a078c03ed7$exports = {};

$parcel$export($ebb5e0a078c03ed7$exports, "endOfDecade", () => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6, (v) => $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = v);
var $ebb5e0a078c03ed7$export$b922ac31d5bbe7a6;
"use strict";
$ebb5e0a078c03ed7$export$b922ac31d5bbe7a6 = $ebb5e0a078c03ed7$var$endOfDecade;

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $ebb5e0a078c03ed7$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($ebb5e0a078c03ed7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ebb5e0a078c03ed7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ebb5e0a078c03ed7$exports[key];
        }
    });
});
var $49e734d34adabd84$exports = {};

$parcel$export($49e734d34adabd84$exports, "endOfHour", () => $49e734d34adabd84$export$95ae95d2176c5f0, (v) => $49e734d34adabd84$export$95ae95d2176c5f0 = v);
var $49e734d34adabd84$export$95ae95d2176c5f0;
"use strict";
$49e734d34adabd84$export$95ae95d2176c5f0 = $49e734d34adabd84$var$endOfHour;

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $49e734d34adabd84$var$endOfHour(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}


Object.keys($49e734d34adabd84$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $49e734d34adabd84$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $49e734d34adabd84$exports[key];
        }
    });
});
var $3505726b435bc449$exports = {};

$parcel$export($3505726b435bc449$exports, "endOfISOWeek", () => $3505726b435bc449$export$186cd934f32084be, (v) => $3505726b435bc449$export$186cd934f32084be = v);
var $3505726b435bc449$export$186cd934f32084be;
"use strict";
$3505726b435bc449$export$186cd934f32084be = $3505726b435bc449$var$endOfISOWeek;
var $d53308c42f1e4c62$exports = {};

$parcel$export($d53308c42f1e4c62$exports, "endOfWeek", () => $d53308c42f1e4c62$export$ef8b6d9133084f4e, (v) => $d53308c42f1e4c62$export$ef8b6d9133084f4e = v);
var $d53308c42f1e4c62$export$ef8b6d9133084f4e;
"use strict";
$d53308c42f1e4c62$export$ef8b6d9133084f4e = $d53308c42f1e4c62$var$endOfWeek;


/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $d53308c42f1e4c62$var$endOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $3505726b435bc449$var$endOfISOWeek(date) {
    return (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(date, {
        weekStartsOn: 1
    });
}


Object.keys($3505726b435bc449$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3505726b435bc449$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3505726b435bc449$exports[key];
        }
    });
});
var $78a8aecdbc55404d$exports = {};

$parcel$export($78a8aecdbc55404d$exports, "endOfISOWeekYear", () => $78a8aecdbc55404d$export$73068f3824c9c1d, (v) => $78a8aecdbc55404d$export$73068f3824c9c1d = v);
var $78a8aecdbc55404d$export$73068f3824c9c1d;
"use strict";
$78a8aecdbc55404d$export$73068f3824c9c1d = $78a8aecdbc55404d$var$endOfISOWeekYear;



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $78a8aecdbc55404d$var$endOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}


Object.keys($78a8aecdbc55404d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $78a8aecdbc55404d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $78a8aecdbc55404d$exports[key];
        }
    });
});
var $9dff17d493896adc$exports = {};

$parcel$export($9dff17d493896adc$exports, "endOfMinute", () => $9dff17d493896adc$export$a06a772fc63bff07, (v) => $9dff17d493896adc$export$a06a772fc63bff07 = v);
var $9dff17d493896adc$export$a06a772fc63bff07;
"use strict";
$9dff17d493896adc$export$a06a772fc63bff07 = $9dff17d493896adc$var$endOfMinute;

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $9dff17d493896adc$var$endOfMinute(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(59, 999);
    return _date;
}


Object.keys($9dff17d493896adc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9dff17d493896adc$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9dff17d493896adc$exports[key];
        }
    });
});

Object.keys($e58340063d97ab50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e58340063d97ab50$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e58340063d97ab50$exports[key];
        }
    });
});
var $28fe4daca8fe3005$exports = {};

$parcel$export($28fe4daca8fe3005$exports, "endOfQuarter", () => $28fe4daca8fe3005$export$5f53493861eef879, (v) => $28fe4daca8fe3005$export$5f53493861eef879 = v);
var $28fe4daca8fe3005$export$5f53493861eef879;
"use strict";
$28fe4daca8fe3005$export$5f53493861eef879 = $28fe4daca8fe3005$var$endOfQuarter;

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $28fe4daca8fe3005$var$endOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($28fe4daca8fe3005$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $28fe4daca8fe3005$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $28fe4daca8fe3005$exports[key];
        }
    });
});
var $ee0c9831f430316e$exports = {};

$parcel$export($ee0c9831f430316e$exports, "endOfSecond", () => $ee0c9831f430316e$export$ef560ab2fa7b52a2, (v) => $ee0c9831f430316e$export$ef560ab2fa7b52a2 = v);
var $ee0c9831f430316e$export$ef560ab2fa7b52a2;
"use strict";
$ee0c9831f430316e$export$ef560ab2fa7b52a2 = $ee0c9831f430316e$var$endOfSecond;

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $ee0c9831f430316e$var$endOfSecond(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(999);
    return _date;
}


Object.keys($ee0c9831f430316e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ee0c9831f430316e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ee0c9831f430316e$exports[key];
        }
    });
});
var $c2770cefb072376e$exports = {};

$parcel$export($c2770cefb072376e$exports, "endOfToday", () => $c2770cefb072376e$export$1b7031a80bd92a6e, (v) => $c2770cefb072376e$export$1b7031a80bd92a6e = v);
var $c2770cefb072376e$export$1b7031a80bd92a6e;
"use strict";
$c2770cefb072376e$export$1b7031a80bd92a6e = $c2770cefb072376e$var$endOfToday;

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $c2770cefb072376e$var$endOfToday() {
    return (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(Date.now());
}


Object.keys($c2770cefb072376e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c2770cefb072376e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c2770cefb072376e$exports[key];
        }
    });
});
var $42595d73b3e9f363$exports = {};

$parcel$export($42595d73b3e9f363$exports, "endOfTomorrow", () => $42595d73b3e9f363$export$d788ac27ae2a54ea, (v) => $42595d73b3e9f363$export$d788ac27ae2a54ea = v);
var $42595d73b3e9f363$export$d788ac27ae2a54ea;
"use strict";
$42595d73b3e9f363$export$d788ac27ae2a54ea = $42595d73b3e9f363$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $42595d73b3e9f363$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($42595d73b3e9f363$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $42595d73b3e9f363$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $42595d73b3e9f363$exports[key];
        }
    });
});

Object.keys($d53308c42f1e4c62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d53308c42f1e4c62$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d53308c42f1e4c62$exports[key];
        }
    });
});

Object.keys($6cbfdc6d008595cd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6cbfdc6d008595cd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6cbfdc6d008595cd$exports[key];
        }
    });
});
var $81eecc2fe560ca77$exports = {};

$parcel$export($81eecc2fe560ca77$exports, "endOfYesterday", () => $81eecc2fe560ca77$export$45190faf1024f97a, (v) => $81eecc2fe560ca77$export$45190faf1024f97a = v);
var $81eecc2fe560ca77$export$45190faf1024f97a;
"use strict";
$81eecc2fe560ca77$export$45190faf1024f97a = $81eecc2fe560ca77$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $81eecc2fe560ca77$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($81eecc2fe560ca77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $81eecc2fe560ca77$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $81eecc2fe560ca77$exports[key];
        }
    });
});
var $303ba10db2c74ab4$exports = {};
"use strict";
$303ba10db2c74ab4$exports.format = $303ba10db2c74ab4$exports.formatDate = $303ba10db2c74ab4$var$format;
Object.defineProperty($303ba10db2c74ab4$exports, "formatters", {
    enumerable: true,
    get: function() {
        return $008fe800ab658844$export$fe98a034cfb96d55;
    }
});
Object.defineProperty($303ba10db2c74ab4$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $54cd66db3e5e74df$export$70cc8fd02856fd58;
    }
});
var $e9531067c80a48a0$exports = {};
"use strict";
Object.defineProperty($e9531067c80a48a0$exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $cd0c27002eb93234$export$137380d9ce54f7f;
    }
});
var $cd0c27002eb93234$export$137380d9ce54f7f;
"use strict";
$cd0c27002eb93234$export$137380d9ce54f7f = void 0;
var $0bc92389da5ca8f2$export$2c14ff85d6318973;
"use strict";
$0bc92389da5ca8f2$export$2c14ff85d6318973 = void 0;
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$0bc92389da5ca8f2$export$2c14ff85d6318973 = $0bc92389da5ca8f2$var$formatDistance;


var $63c01f9040a729a9$export$cbf60ecb96cbb82f;
"use strict";
$63c01f9040a729a9$export$cbf60ecb96cbb82f = void 0;
var $46af55383084911e$export$38e44e97ce4dbb7d;
"use strict";
$46af55383084911e$export$38e44e97ce4dbb7d = $46af55383084911e$var$buildFormatLongFn;
function $46af55383084911e$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$var$formatLong = $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $f529b3bee3f6d835$export$8fbbfd65594f46a0;
"use strict";
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = void 0;
const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$var$formatRelative = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];
$f529b3bee3f6d835$export$8fbbfd65594f46a0 = $f529b3bee3f6d835$var$formatRelative;


var $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63;
"use strict";
$eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = void 0;
var $39a1e2b6239b09b3$export$63596d6ee8878b25;
"use strict";
$39a1e2b6239b09b3$export$63596d6ee8878b25 = $39a1e2b6239b09b3$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$var$localize = $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d2fa28259adb3ab1$export$4659b591c19bdf3d;
"use strict";
$d2fa28259adb3ab1$export$4659b591c19bdf3d = void 0;
var $e4df69a5a2d494a3$export$1430a0f35710914d;
"use strict";
$e4df69a5a2d494a3$export$1430a0f35710914d = $e4df69a5a2d494a3$var$buildMatchFn;
function $e4df69a5a2d494a3$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


var $2594a2c0202dabc6$export$fdaf2fd6d7edde95;
"use strict";
$2594a2c0202dabc6$export$fdaf2fd6d7edde95 = $2594a2c0202dabc6$var$buildMatchPatternFn;
function $2594a2c0202dabc6$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$var$match = $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $cd0c27002eb93234$var$enUS = $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $0bc92389da5ca8f2$export$2c14ff85d6318973,
    formatLong: $63c01f9040a729a9$export$cbf60ecb96cbb82f,
    formatRelative: $f529b3bee3f6d835$export$8fbbfd65594f46a0,
    localize: $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63,
    match: $d2fa28259adb3ab1$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};





var $008fe800ab658844$export$fe98a034cfb96d55;
"use strict";
$008fe800ab658844$export$fe98a034cfb96d55 = void 0;
var $306b88ce50904f9c$exports = {};

$parcel$export($306b88ce50904f9c$exports, "getDayOfYear", () => $306b88ce50904f9c$export$d3b42cd8452deec, (v) => $306b88ce50904f9c$export$d3b42cd8452deec = v);
var $306b88ce50904f9c$export$d3b42cd8452deec;
"use strict";
$306b88ce50904f9c$export$d3b42cd8452deec = $306b88ce50904f9c$var$getDayOfYear;



/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $306b88ce50904f9c$var$getDayOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}


var $83e11b0db4cec366$exports = {};

$parcel$export($83e11b0db4cec366$exports, "getISOWeek", () => $83e11b0db4cec366$export$7cabdc5698b63e2f, (v) => $83e11b0db4cec366$export$7cabdc5698b63e2f = v);
var $83e11b0db4cec366$export$7cabdc5698b63e2f;
"use strict";
$83e11b0db4cec366$export$7cabdc5698b63e2f = $83e11b0db4cec366$var$getISOWeek;




/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $83e11b0db4cec366$var$getISOWeek(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8) + 1;
}



var $11b38d723fd57381$exports = {};

$parcel$export($11b38d723fd57381$exports, "getWeek", () => $11b38d723fd57381$export$efe19b760242b2fc, (v) => $11b38d723fd57381$export$efe19b760242b2fc = v);
var $11b38d723fd57381$export$efe19b760242b2fc;
"use strict";
$11b38d723fd57381$export$efe19b760242b2fc = $11b38d723fd57381$var$getWeek;


var $ac7640a7ade5a435$exports = {};

$parcel$export($ac7640a7ade5a435$exports, "startOfWeekYear", () => $ac7640a7ade5a435$export$bb7b45bb8e74da0f, (v) => $ac7640a7ade5a435$export$bb7b45bb8e74da0f = v);
var $ac7640a7ade5a435$export$bb7b45bb8e74da0f;
"use strict";
$ac7640a7ade5a435$export$bb7b45bb8e74da0f = $ac7640a7ade5a435$var$startOfWeekYear;

var $0170e230c8468ebb$exports = {};

$parcel$export($0170e230c8468ebb$exports, "getWeekYear", () => $0170e230c8468ebb$export$12d572480ceb6e58, (v) => $0170e230c8468ebb$export$12d572480ceb6e58 = v);
var $0170e230c8468ebb$export$12d572480ceb6e58;
"use strict";
$0170e230c8468ebb$export$12d572480ceb6e58 = $0170e230c8468ebb$var$getWeekYear;




/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $0170e230c8468ebb$var$getWeekYear(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $ac7640a7ade5a435$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}



/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $11b38d723fd57381$var$getWeek(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8) + 1;
}



var $03d75ed55eeb99fa$export$c8306e720e213c0f;
"use strict";
$03d75ed55eeb99fa$export$c8306e720e213c0f = $03d75ed55eeb99fa$var$addLeadingZeros;
function $03d75ed55eeb99fa$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}


var $71a5e81f1193b7a8$export$b0d4b338e1516f13;
"use strict";
$71a5e81f1193b7a8$export$b0d4b338e1516f13 = void 0;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $71a5e81f1193b7a8$var$lightFormatters = $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $008fe800ab658844$var$formatters = $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $71a5e81f1193b7a8$export$b0d4b338e1516f13.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $54cd66db3e5e74df$export$70cc8fd02856fd58;
"use strict";
$54cd66db3e5e74df$export$70cc8fd02856fd58 = void 0;
const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$var$longFormatters = $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


var $7e8a5b0b77bf77b9$export$c6cc36aa33304772;
var $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1;
var $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879;
"use strict";
$7e8a5b0b77bf77b9$export$c6cc36aa33304772 = $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken;
$7e8a5b0b77bf77b9$export$c6b49d6dceb604a1 = $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken;
$7e8a5b0b77bf77b9$export$f5f38f90ecaaf879 = $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError;
const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$var$isProtectedDayOfYearToken(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$isProtectedWeekYearToken(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}




// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $303ba10db2c74ab4$var$format(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $54cd66db3e5e74df$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ($008fe800ab658844$export$fe98a034cfb96d55[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = $008fe800ab658844$export$fe98a034cfb96d55[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}


Object.keys($303ba10db2c74ab4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $303ba10db2c74ab4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $303ba10db2c74ab4$exports[key];
        }
    });
});
var $9d83b4c514336dd1$exports = {};

$parcel$export($9d83b4c514336dd1$exports, "formatDistance", () => $9d83b4c514336dd1$export$2c14ff85d6318973, (v) => $9d83b4c514336dd1$export$2c14ff85d6318973 = v);
var $9d83b4c514336dd1$export$2c14ff85d6318973;
"use strict";
$9d83b4c514336dd1$export$2c14ff85d6318973 = $9d83b4c514336dd1$var$formatDistance;








/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $9d83b4c514336dd1$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $e9cff913190bd013$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    }
    const seconds = (0, $e9186d0161460806$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $92dc0740ffabe180$export$113002b5eff6e430)(dateRight) - (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $8540a44f59a4af84$export$2423174df8cd3cd2) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $8540a44f59a4af84$export$ab7da2ccd1075c38) {
        const days = Math.round(minutes / $8540a44f59a4af84$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $8540a44f59a4af84$export$ab7da2ccd1075c38 * 2) {
        months = Math.round(minutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


Object.keys($9d83b4c514336dd1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9d83b4c514336dd1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9d83b4c514336dd1$exports[key];
        }
    });
});
var $95a606f89a9faad4$exports = {};

$parcel$export($95a606f89a9faad4$exports, "formatDistanceStrict", () => $95a606f89a9faad4$export$e4be225b8ee0a759, (v) => $95a606f89a9faad4$export$e4be225b8ee0a759 = v);
var $95a606f89a9faad4$export$e4be225b8ee0a759;
"use strict";
$95a606f89a9faad4$export$e4be225b8ee0a759 = $95a606f89a9faad4$var$formatDistanceStrict;







/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $95a606f89a9faad4$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const comparison = (0, $e9cff913190bd013$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
        dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    }
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $8540a44f59a4af84$export$91246f0b9bd9beff;
    const timezoneOffset = (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateRight) - (0, $92dc0740ffabe180$export$113002b5eff6e430)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $8540a44f59a4af84$export$91246f0b9bd9beff;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $8540a44f59a4af84$export$2423174df8cd3cd2) unit = "hour";
        else if (dstNormalizedMinutes < $8540a44f59a4af84$export$ab7da2ccd1075c38) unit = "day";
        else if (dstNormalizedMinutes < $8540a44f59a4af84$export$3633035e63cee86a) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$ab7da2ccd1075c38);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $8540a44f59a4af84$export$3633035e63cee86a);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}


Object.keys($95a606f89a9faad4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95a606f89a9faad4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95a606f89a9faad4$exports[key];
        }
    });
});
var $b8de4dab140c0dd6$exports = {};

$parcel$export($b8de4dab140c0dd6$exports, "formatDistanceToNow", () => $b8de4dab140c0dd6$export$d130c20a256f8817, (v) => $b8de4dab140c0dd6$export$d130c20a256f8817 = v);
var $b8de4dab140c0dd6$export$d130c20a256f8817;
"use strict";
$b8de4dab140c0dd6$export$d130c20a256f8817 = $b8de4dab140c0dd6$var$formatDistanceToNow;


/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $b8de4dab140c0dd6$var$formatDistanceToNow(date, options) {
    return (0, $9d83b4c514336dd1$export$2c14ff85d6318973)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($b8de4dab140c0dd6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b8de4dab140c0dd6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b8de4dab140c0dd6$exports[key];
        }
    });
});
var $2869c75fd9cd8704$exports = {};

$parcel$export($2869c75fd9cd8704$exports, "formatDistanceToNowStrict", () => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32, (v) => $2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = v);
var $2869c75fd9cd8704$export$d0e02d4eb1ad1e32;
"use strict";
$2869c75fd9cd8704$export$d0e02d4eb1ad1e32 = $2869c75fd9cd8704$var$formatDistanceToNowStrict;


/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $2869c75fd9cd8704$var$formatDistanceToNowStrict(date, options) {
    return (0, $95a606f89a9faad4$export$e4be225b8ee0a759)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($2869c75fd9cd8704$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2869c75fd9cd8704$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2869c75fd9cd8704$exports[key];
        }
    });
});
var $55bdc14b4829f99f$exports = {};

$parcel$export($55bdc14b4829f99f$exports, "formatDuration", () => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a, (v) => $55bdc14b4829f99f$export$bc733b0c5cbb3e8a = v);
var $55bdc14b4829f99f$export$bc733b0c5cbb3e8a;
"use strict";
$55bdc14b4829f99f$export$bc733b0c5cbb3e8a = $55bdc14b4829f99f$var$formatDuration;


/**
 * The {@link formatDuration} function options.
 */ const $55bdc14b4829f99f$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $55bdc14b4829f99f$var$formatDuration(duration, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const format = options?.format ?? $55bdc14b4829f99f$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


Object.keys($55bdc14b4829f99f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $55bdc14b4829f99f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $55bdc14b4829f99f$exports[key];
        }
    });
});
var $05555112c260885d$exports = {};

$parcel$export($05555112c260885d$exports, "formatISO", () => $05555112c260885d$export$3c826ac3ab9da76c, (v) => $05555112c260885d$export$3c826ac3ab9da76c = v);
var $05555112c260885d$export$3c826ac3ab9da76c;
"use strict";
$05555112c260885d$export$3c826ac3ab9da76c = $05555112c260885d$var$formatISO;


/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $05555112c260885d$var$formatISO(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}


Object.keys($05555112c260885d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $05555112c260885d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $05555112c260885d$exports[key];
        }
    });
});
var $d5e05e4c82eadb91$exports = {};

$parcel$export($d5e05e4c82eadb91$exports, "formatISO9075", () => $d5e05e4c82eadb91$export$a673944250043fa4, (v) => $d5e05e4c82eadb91$export$a673944250043fa4 = v);
var $d5e05e4c82eadb91$export$a673944250043fa4;
"use strict";
$d5e05e4c82eadb91$export$a673944250043fa4 = $d5e05e4c82eadb91$var$formatISO9075;



/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $d5e05e4c82eadb91$var$formatISO9075(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}


Object.keys($d5e05e4c82eadb91$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d5e05e4c82eadb91$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d5e05e4c82eadb91$exports[key];
        }
    });
});
var $6c1e8c5de50036eb$exports = {};

$parcel$export($6c1e8c5de50036eb$exports, "formatISODuration", () => $6c1e8c5de50036eb$export$437c31ab743f6b26, (v) => $6c1e8c5de50036eb$export$437c31ab743f6b26 = v);
var $6c1e8c5de50036eb$export$437c31ab743f6b26;
"use strict";
$6c1e8c5de50036eb$export$437c31ab743f6b26 = $6c1e8c5de50036eb$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $6c1e8c5de50036eb$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


Object.keys($6c1e8c5de50036eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6c1e8c5de50036eb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6c1e8c5de50036eb$exports[key];
        }
    });
});
var $d70debc21ba74612$exports = {};

$parcel$export($d70debc21ba74612$exports, "formatRFC3339", () => $d70debc21ba74612$export$6d441bffeec6bd6c, (v) => $d70debc21ba74612$export$6d441bffeec6bd6c = v);
var $d70debc21ba74612$export$6d441bffeec6bd6c;
"use strict";
$d70debc21ba74612$export$6d441bffeec6bd6c = $d70debc21ba74612$var$formatRFC3339;



/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $d70debc21ba74612$var$formatRFC3339(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getDate(), 2);
    const month = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getHours(), 2);
    const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getMinutes(), 2);
    const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


Object.keys($d70debc21ba74612$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d70debc21ba74612$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d70debc21ba74612$exports[key];
        }
    });
});
var $26db363d7fafee68$exports = {};

$parcel$export($26db363d7fafee68$exports, "formatRFC7231", () => $26db363d7fafee68$export$7add2e4539ce658a, (v) => $26db363d7fafee68$export$7add2e4539ce658a = v);
var $26db363d7fafee68$export$7add2e4539ce658a;
"use strict";
$26db363d7fafee68$export$7add2e4539ce658a = $26db363d7fafee68$var$formatRFC7231;



const $26db363d7fafee68$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $26db363d7fafee68$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $26db363d7fafee68$var$formatRFC7231(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const dayName = $26db363d7fafee68$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCDate(), 2);
    const monthName = $26db363d7fafee68$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCHours(), 2);
    const minute = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCMinutes(), 2);
    const second = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


Object.keys($26db363d7fafee68$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $26db363d7fafee68$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $26db363d7fafee68$exports[key];
        }
    });
});
var $845a402345cd1b5f$exports = {};

$parcel$export($845a402345cd1b5f$exports, "formatRelative", () => $845a402345cd1b5f$export$8fbbfd65594f46a0, (v) => $845a402345cd1b5f$export$8fbbfd65594f46a0 = v);
var $845a402345cd1b5f$export$8fbbfd65594f46a0;
"use strict";
$845a402345cd1b5f$export$8fbbfd65594f46a0 = $845a402345cd1b5f$var$formatRelative;





/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $845a402345cd1b5f$var$formatRelative(date, baseDate, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _baseDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $303ba10db2c74ab4$exports.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


Object.keys($845a402345cd1b5f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $845a402345cd1b5f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $845a402345cd1b5f$exports[key];
        }
    });
});
var $75d4a1cbf32d45ba$exports = {};

$parcel$export($75d4a1cbf32d45ba$exports, "fromUnixTime", () => $75d4a1cbf32d45ba$export$3664df8597731ed4, (v) => $75d4a1cbf32d45ba$export$3664df8597731ed4 = v);
var $75d4a1cbf32d45ba$export$3664df8597731ed4;
"use strict";
$75d4a1cbf32d45ba$export$3664df8597731ed4 = $75d4a1cbf32d45ba$var$fromUnixTime;

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $75d4a1cbf32d45ba$var$fromUnixTime(unixTime) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(unixTime * 1000);
}


Object.keys($75d4a1cbf32d45ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $75d4a1cbf32d45ba$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $75d4a1cbf32d45ba$exports[key];
        }
    });
});
var $d60f4829c70cb6da$exports = {};

$parcel$export($d60f4829c70cb6da$exports, "getDate", () => $d60f4829c70cb6da$export$aa350b96d91cd94, (v) => $d60f4829c70cb6da$export$aa350b96d91cd94 = v);
var $d60f4829c70cb6da$export$aa350b96d91cd94;
"use strict";
$d60f4829c70cb6da$export$aa350b96d91cd94 = $d60f4829c70cb6da$var$getDate;

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $d60f4829c70cb6da$var$getDate(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}


Object.keys($d60f4829c70cb6da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d60f4829c70cb6da$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d60f4829c70cb6da$exports[key];
        }
    });
});
var $bd335e725902b989$exports = {};

$parcel$export($bd335e725902b989$exports, "getDay", () => $bd335e725902b989$export$1b64bc9c5306ed54, (v) => $bd335e725902b989$export$1b64bc9c5306ed54 = v);
var $bd335e725902b989$export$1b64bc9c5306ed54;
"use strict";
$bd335e725902b989$export$1b64bc9c5306ed54 = $bd335e725902b989$var$getDay;

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $bd335e725902b989$var$getDay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    return day;
}


Object.keys($bd335e725902b989$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bd335e725902b989$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bd335e725902b989$exports[key];
        }
    });
});

Object.keys($306b88ce50904f9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $306b88ce50904f9c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $306b88ce50904f9c$exports[key];
        }
    });
});
var $57397b9e44500b87$exports = {};

$parcel$export($57397b9e44500b87$exports, "getDaysInMonth", () => $57397b9e44500b87$export$f645ddd439eb259d, (v) => $57397b9e44500b87$export$f645ddd439eb259d = v);
var $57397b9e44500b87$export$f645ddd439eb259d;
"use strict";
$57397b9e44500b87$export$f645ddd439eb259d = $57397b9e44500b87$var$getDaysInMonth;


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $57397b9e44500b87$var$getDaysInMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}


Object.keys($57397b9e44500b87$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $57397b9e44500b87$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $57397b9e44500b87$exports[key];
        }
    });
});
var $675848174151c5de$exports = {};

$parcel$export($675848174151c5de$exports, "getDaysInYear", () => $675848174151c5de$export$63a4a9fc49e3550e, (v) => $675848174151c5de$export$63a4a9fc49e3550e = v);
var $675848174151c5de$export$63a4a9fc49e3550e;
"use strict";
$675848174151c5de$export$63a4a9fc49e3550e = $675848174151c5de$var$getDaysInYear;
var $bf096f6f36c61b64$exports = {};

$parcel$export($bf096f6f36c61b64$exports, "isLeapYear", () => $bf096f6f36c61b64$export$553d7fa8e3805fc0, (v) => $bf096f6f36c61b64$export$553d7fa8e3805fc0 = v);
var $bf096f6f36c61b64$export$553d7fa8e3805fc0;
"use strict";
$bf096f6f36c61b64$export$553d7fa8e3805fc0 = $bf096f6f36c61b64$var$isLeapYear;

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $bf096f6f36c61b64$var$isLeapYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $675848174151c5de$var$getDaysInYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $bf096f6f36c61b64$export$553d7fa8e3805fc0)(_date) ? 366 : 365;
}


Object.keys($675848174151c5de$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $675848174151c5de$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $675848174151c5de$exports[key];
        }
    });
});
var $6ffe5b46a49d8b61$exports = {};

$parcel$export($6ffe5b46a49d8b61$exports, "getDecade", () => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64, (v) => $6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = v);
var $6ffe5b46a49d8b61$export$5bc0f4decfc52b64;
"use strict";
$6ffe5b46a49d8b61$export$5bc0f4decfc52b64 = $6ffe5b46a49d8b61$var$getDecade;

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $6ffe5b46a49d8b61$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}


Object.keys($6ffe5b46a49d8b61$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6ffe5b46a49d8b61$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6ffe5b46a49d8b61$exports[key];
        }
    });
});
var $f3e2f0f906df8397$exports = {};

$parcel$export($f3e2f0f906df8397$exports, "getDefaultOptions", () => $f3e2f0f906df8397$export$430a3269e24b912e, (v) => $f3e2f0f906df8397$export$430a3269e24b912e = v);
var $f3e2f0f906df8397$export$430a3269e24b912e;
"use strict";
$f3e2f0f906df8397$export$430a3269e24b912e = $f3e2f0f906df8397$var$getDefaultOptions;

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $f3e2f0f906df8397$var$getDefaultOptions() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}


Object.keys($f3e2f0f906df8397$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f3e2f0f906df8397$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f3e2f0f906df8397$exports[key];
        }
    });
});
var $fcf1b449283ad4a9$exports = {};

$parcel$export($fcf1b449283ad4a9$exports, "getHours", () => $fcf1b449283ad4a9$export$257b40f71c07d58f, (v) => $fcf1b449283ad4a9$export$257b40f71c07d58f = v);
var $fcf1b449283ad4a9$export$257b40f71c07d58f;
"use strict";
$fcf1b449283ad4a9$export$257b40f71c07d58f = $fcf1b449283ad4a9$var$getHours;

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $fcf1b449283ad4a9$var$getHours(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const hours = _date.getHours();
    return hours;
}


Object.keys($fcf1b449283ad4a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fcf1b449283ad4a9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fcf1b449283ad4a9$exports[key];
        }
    });
});
var $6f80ca66d6710e40$exports = {};

$parcel$export($6f80ca66d6710e40$exports, "getISODay", () => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e, (v) => $6f80ca66d6710e40$export$c514f4c1a8ed5e9e = v);
var $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;
"use strict";
$6f80ca66d6710e40$export$c514f4c1a8ed5e9e = $6f80ca66d6710e40$var$getISODay;

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $6f80ca66d6710e40$var$getISODay(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}


Object.keys($6f80ca66d6710e40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f80ca66d6710e40$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f80ca66d6710e40$exports[key];
        }
    });
});

Object.keys($83e11b0db4cec366$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $83e11b0db4cec366$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $83e11b0db4cec366$exports[key];
        }
    });
});

Object.keys($c95dff76bf2f692a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c95dff76bf2f692a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c95dff76bf2f692a$exports[key];
        }
    });
});
var $1116498c017852ec$exports = {};

$parcel$export($1116498c017852ec$exports, "getISOWeeksInYear", () => $1116498c017852ec$export$822983242a16750f, (v) => $1116498c017852ec$export$822983242a16750f = v);
var $1116498c017852ec$export$822983242a16750f;
"use strict";
$1116498c017852ec$export$822983242a16750f = $1116498c017852ec$var$getISOWeeksInYear;



/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $1116498c017852ec$var$getISOWeeksInYear(date) {
    const thisYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(date);
    const nextYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)((0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $8540a44f59a4af84$export$4fad13613e88edc8);
}


Object.keys($1116498c017852ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1116498c017852ec$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1116498c017852ec$exports[key];
        }
    });
});
var $8c11bc9b369aea05$exports = {};

$parcel$export($8c11bc9b369aea05$exports, "getMilliseconds", () => $8c11bc9b369aea05$export$b8e4380f312797af, (v) => $8c11bc9b369aea05$export$b8e4380f312797af = v);
var $8c11bc9b369aea05$export$b8e4380f312797af;
"use strict";
$8c11bc9b369aea05$export$b8e4380f312797af = $8c11bc9b369aea05$var$getMilliseconds;

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $8c11bc9b369aea05$var$getMilliseconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}


Object.keys($8c11bc9b369aea05$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8c11bc9b369aea05$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8c11bc9b369aea05$exports[key];
        }
    });
});
var $0c14dd26da4d9afe$exports = {};

$parcel$export($0c14dd26da4d9afe$exports, "getMinutes", () => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145, (v) => $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = v);
var $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145;
"use strict";
$0c14dd26da4d9afe$export$b7f1bc3ea3ac4145 = $0c14dd26da4d9afe$var$getMinutes;

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $0c14dd26da4d9afe$var$getMinutes(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const minutes = _date.getMinutes();
    return minutes;
}


Object.keys($0c14dd26da4d9afe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0c14dd26da4d9afe$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0c14dd26da4d9afe$exports[key];
        }
    });
});
var $6f30fa731c19b802$exports = {};

$parcel$export($6f30fa731c19b802$exports, "getMonth", () => $6f30fa731c19b802$export$6ce1b5acc29cb53b, (v) => $6f30fa731c19b802$export$6ce1b5acc29cb53b = v);
var $6f30fa731c19b802$export$6ce1b5acc29cb53b;
"use strict";
$6f30fa731c19b802$export$6ce1b5acc29cb53b = $6f30fa731c19b802$var$getMonth;

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $6f30fa731c19b802$var$getMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    return month;
}


Object.keys($6f30fa731c19b802$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6f30fa731c19b802$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6f30fa731c19b802$exports[key];
        }
    });
});
var $a50ac61c155d82aa$exports = {};

$parcel$export($a50ac61c155d82aa$exports, "getOverlappingDaysInIntervals", () => $a50ac61c155d82aa$export$baae148532bd1d46, (v) => $a50ac61c155d82aa$export$baae148532bd1d46 = v);
var $a50ac61c155d82aa$export$baae148532bd1d46;
"use strict";
$a50ac61c155d82aa$export$baae148532bd1d46 = $a50ac61c155d82aa$var$getOverlappingDaysInIntervals;



/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $a50ac61c155d82aa$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $92dc0740ffabe180$export$113002b5eff6e430)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $92dc0740ffabe180$export$113002b5eff6e430)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $8540a44f59a4af84$export$b76b1809a2898f9a);
}


Object.keys($a50ac61c155d82aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a50ac61c155d82aa$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a50ac61c155d82aa$exports[key];
        }
    });
});

Object.keys($763325f0c93713da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $763325f0c93713da$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $763325f0c93713da$exports[key];
        }
    });
});
var $a54ac051af9fd19a$exports = {};

$parcel$export($a54ac051af9fd19a$exports, "getSeconds", () => $a54ac051af9fd19a$export$5e9417507ff28427, (v) => $a54ac051af9fd19a$export$5e9417507ff28427 = v);
var $a54ac051af9fd19a$export$5e9417507ff28427;
"use strict";
$a54ac051af9fd19a$export$5e9417507ff28427 = $a54ac051af9fd19a$var$getSeconds;

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $a54ac051af9fd19a$var$getSeconds(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const seconds = _date.getSeconds();
    return seconds;
}


Object.keys($a54ac051af9fd19a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a54ac051af9fd19a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a54ac051af9fd19a$exports[key];
        }
    });
});
var $9f25550354d2edec$exports = {};

$parcel$export($9f25550354d2edec$exports, "getTime", () => $9f25550354d2edec$export$1428f42a7de81803, (v) => $9f25550354d2edec$export$1428f42a7de81803 = v);
var $9f25550354d2edec$export$1428f42a7de81803;
"use strict";
$9f25550354d2edec$export$1428f42a7de81803 = $9f25550354d2edec$var$getTime;

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $9f25550354d2edec$var$getTime(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const timestamp = _date.getTime();
    return timestamp;
}


Object.keys($9f25550354d2edec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9f25550354d2edec$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9f25550354d2edec$exports[key];
        }
    });
});
var $c60e78b2b3ab2c93$exports = {};

$parcel$export($c60e78b2b3ab2c93$exports, "getUnixTime", () => $c60e78b2b3ab2c93$export$1f77c0008d16313, (v) => $c60e78b2b3ab2c93$export$1f77c0008d16313 = v);
var $c60e78b2b3ab2c93$export$1f77c0008d16313;
"use strict";
$c60e78b2b3ab2c93$export$1f77c0008d16313 = $c60e78b2b3ab2c93$var$getUnixTime;

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $c60e78b2b3ab2c93$var$getUnixTime(date) {
    return Math.trunc(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) / 1000);
}


Object.keys($c60e78b2b3ab2c93$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c60e78b2b3ab2c93$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c60e78b2b3ab2c93$exports[key];
        }
    });
});

Object.keys($11b38d723fd57381$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $11b38d723fd57381$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $11b38d723fd57381$exports[key];
        }
    });
});
var $6300d6356cdb10d1$exports = {};

$parcel$export($6300d6356cdb10d1$exports, "getWeekOfMonth", () => $6300d6356cdb10d1$export$59fb9b85a4d8d027, (v) => $6300d6356cdb10d1$export$59fb9b85a4d8d027 = v);
var $6300d6356cdb10d1$export$59fb9b85a4d8d027;
"use strict";
$6300d6356cdb10d1$export$59fb9b85a4d8d027 = $6300d6356cdb10d1$var$getWeekOfMonth;




/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $6300d6356cdb10d1$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $d60f4829c70cb6da$export$aa350b96d91cd94)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $bd335e725902b989$export$1b64bc9c5306ed54)((0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


Object.keys($6300d6356cdb10d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6300d6356cdb10d1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6300d6356cdb10d1$exports[key];
        }
    });
});

Object.keys($0170e230c8468ebb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0170e230c8468ebb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0170e230c8468ebb$exports[key];
        }
    });
});
var $c1d6a42d4ff2e720$exports = {};

$parcel$export($c1d6a42d4ff2e720$exports, "getWeeksInMonth", () => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654, (v) => $c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = v);
var $c1d6a42d4ff2e720$export$ccc1b2479e7dd654;
"use strict";
$c1d6a42d4ff2e720$export$ccc1b2479e7dd654 = $c1d6a42d4ff2e720$var$getWeeksInMonth;

var $b94cbd258d877bc8$exports = {};

$parcel$export($b94cbd258d877bc8$exports, "lastDayOfMonth", () => $b94cbd258d877bc8$export$36818250d6c87922, (v) => $b94cbd258d877bc8$export$36818250d6c87922 = v);
var $b94cbd258d877bc8$export$36818250d6c87922;
"use strict";
$b94cbd258d877bc8$export$36818250d6c87922 = $b94cbd258d877bc8$var$lastDayOfMonth;

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b94cbd258d877bc8$var$lastDayOfMonth(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $c1d6a42d4ff2e720$var$getWeeksInMonth(date, options) {
    return (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)((0, $b94cbd258d877bc8$export$36818250d6c87922)(date), (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date), options) + 1;
}


Object.keys($c1d6a42d4ff2e720$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c1d6a42d4ff2e720$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c1d6a42d4ff2e720$exports[key];
        }
    });
});
var $4189f4c9c3b9878d$exports = {};

$parcel$export($4189f4c9c3b9878d$exports, "getYear", () => $4189f4c9c3b9878d$export$5846dc2d57a5c860, (v) => $4189f4c9c3b9878d$export$5846dc2d57a5c860 = v);
var $4189f4c9c3b9878d$export$5846dc2d57a5c860;
"use strict";
$4189f4c9c3b9878d$export$5846dc2d57a5c860 = $4189f4c9c3b9878d$var$getYear;

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $4189f4c9c3b9878d$var$getYear(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getFullYear();
}


Object.keys($4189f4c9c3b9878d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4189f4c9c3b9878d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4189f4c9c3b9878d$exports[key];
        }
    });
});
var $9ae7ab1e5313bfc3$exports = {};

$parcel$export($9ae7ab1e5313bfc3$exports, "hoursToMilliseconds", () => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69, (v) => $9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = v);
var $9ae7ab1e5313bfc3$export$5b42ab7a22898b69;
"use strict";
$9ae7ab1e5313bfc3$export$5b42ab7a22898b69 = $9ae7ab1e5313bfc3$var$hoursToMilliseconds;

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $9ae7ab1e5313bfc3$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$7f72910d6dfd237a);
}


Object.keys($9ae7ab1e5313bfc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9ae7ab1e5313bfc3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9ae7ab1e5313bfc3$exports[key];
        }
    });
});
var $d41fb6e1e630ebbd$exports = {};

$parcel$export($d41fb6e1e630ebbd$exports, "hoursToMinutes", () => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8, (v) => $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = v);
var $d41fb6e1e630ebbd$export$83bfc73cdf89a4d8;
"use strict";
$d41fb6e1e630ebbd$export$83bfc73cdf89a4d8 = $d41fb6e1e630ebbd$var$hoursToMinutes;

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $d41fb6e1e630ebbd$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f);
}


Object.keys($d41fb6e1e630ebbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d41fb6e1e630ebbd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d41fb6e1e630ebbd$exports[key];
        }
    });
});
var $fcb7e14c40da1793$exports = {};

$parcel$export($fcb7e14c40da1793$exports, "hoursToSeconds", () => $fcb7e14c40da1793$export$59b1396ccbd5a4e1, (v) => $fcb7e14c40da1793$export$59b1396ccbd5a4e1 = v);
var $fcb7e14c40da1793$export$59b1396ccbd5a4e1;
"use strict";
$fcb7e14c40da1793$export$59b1396ccbd5a4e1 = $fcb7e14c40da1793$var$hoursToSeconds;

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $fcb7e14c40da1793$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $8540a44f59a4af84$export$698aec755e92c695);
}


Object.keys($fcb7e14c40da1793$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fcb7e14c40da1793$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fcb7e14c40da1793$exports[key];
        }
    });
});
var $6696c43013de930d$exports = {};

$parcel$export($6696c43013de930d$exports, "interval", () => $6696c43013de930d$export$3174cdbf0a0cbc84, (v) => $6696c43013de930d$export$3174cdbf0a0cbc84 = v);
var $6696c43013de930d$export$3174cdbf0a0cbc84;
"use strict";
$6696c43013de930d$export$3174cdbf0a0cbc84 = $6696c43013de930d$var$interval;

/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $6696c43013de930d$var$interval(start, end, options) {
    const _start = (0, $231bfb8d72679740$export$e67a095c620b86fe)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $231bfb8d72679740$export$e67a095c620b86fe)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}


Object.keys($6696c43013de930d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6696c43013de930d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6696c43013de930d$exports[key];
        }
    });
});
var $1164c85dc3b4daac$exports = {};

$parcel$export($1164c85dc3b4daac$exports, "intervalToDuration", () => $1164c85dc3b4daac$export$7b6c9a626316863, (v) => $1164c85dc3b4daac$export$7b6c9a626316863 = v);
var $1164c85dc3b4daac$export$7b6c9a626316863;
"use strict";
$1164c85dc3b4daac$export$7b6c9a626316863 = $1164c85dc3b4daac$var$intervalToDuration;








/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $1164c85dc3b4daac$var$intervalToDuration(interval) {
    const start = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start);
    const end = (0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end);
    const duration = {};
    const years = (0, $bf315c5624a2ab0b$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $67e743be56b112ce$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $543e4b3aa35bec3b$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $e9186d0161460806$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}


Object.keys($1164c85dc3b4daac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1164c85dc3b4daac$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1164c85dc3b4daac$exports[key];
        }
    });
});
var $a3e44b502e508de0$exports = {};

$parcel$export($a3e44b502e508de0$exports, "intlFormat", () => $a3e44b502e508de0$export$f58f1234eed71f82, (v) => $a3e44b502e508de0$export$f58f1234eed71f82 = v);
var $a3e44b502e508de0$export$f58f1234eed71f82;
"use strict";
$a3e44b502e508de0$export$f58f1234eed71f82 = $a3e44b502e508de0$var$intlFormat;

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $a3e44b502e508de0$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($a3e44b502e508de0$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $231bfb8d72679740$export$e67a095c620b86fe)(date));
}
function $a3e44b502e508de0$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}


Object.keys($a3e44b502e508de0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a3e44b502e508de0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a3e44b502e508de0$exports[key];
        }
    });
});
var $97e1e87f40603cdb$exports = {};

$parcel$export($97e1e87f40603cdb$exports, "intlFormatDistance", () => $97e1e87f40603cdb$export$a110a4020280fd5, (v) => $97e1e87f40603cdb$export$a110a4020280fd5 = v);
var $97e1e87f40603cdb$export$a110a4020280fd5;
"use strict";
$97e1e87f40603cdb$export$a110a4020280fd5 = $97e1e87f40603cdb$var$intlFormatDistance;










/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $97e1e87f40603cdb$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$a77c1a7ebebe2a5a) {
            value = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$698aec755e92c695) {
            value = (0, $67e743be56b112ce$export$d904251335be481a)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$815a9362476d2fe3 && Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight)) < 1) {
            value = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$34804a017b31e2fe && (value = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$8e6600bbdee7dabb) {
            value = (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$be1dccf2de902d31) {
            value = (0, $8aa264ebd3f03841$export$489984ac7c996389)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $8540a44f59a4af84$export$7271e9e3478110d1) {
            if ((0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $e9186d0161460806$export$c1889aec51783710)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $67e743be56b112ce$export$d904251335be481a)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $c8670ac5b8c1edee$export$6ed034ce62348e4)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $8aa264ebd3f03841$export$489984ac7c996389)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $5806b276dadb0858$export$f62ae9fb13958c7a)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $539ce3f7450453a1$export$c06dce8b38891685)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}


Object.keys($97e1e87f40603cdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $97e1e87f40603cdb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $97e1e87f40603cdb$exports[key];
        }
    });
});
var $7c47abeb099a42c0$exports = {};

$parcel$export($7c47abeb099a42c0$exports, "isAfter", () => $7c47abeb099a42c0$export$e4de839670987035, (v) => $7c47abeb099a42c0$export$e4de839670987035 = v);
var $7c47abeb099a42c0$export$e4de839670987035;
"use strict";
$7c47abeb099a42c0$export$e4de839670987035 = $7c47abeb099a42c0$var$isAfter;

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $7c47abeb099a42c0$var$isAfter(date, dateToCompare) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}


Object.keys($7c47abeb099a42c0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7c47abeb099a42c0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7c47abeb099a42c0$exports[key];
        }
    });
});
var $d2aab93838002ade$exports = {};

$parcel$export($d2aab93838002ade$exports, "isBefore", () => $d2aab93838002ade$export$5c007e10c6929c95, (v) => $d2aab93838002ade$export$5c007e10c6929c95 = v);
var $d2aab93838002ade$export$5c007e10c6929c95;
"use strict";
$d2aab93838002ade$export$5c007e10c6929c95 = $d2aab93838002ade$var$isBefore;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d2aab93838002ade$var$isBefore(date, dateToCompare) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}


Object.keys($d2aab93838002ade$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d2aab93838002ade$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d2aab93838002ade$exports[key];
        }
    });
});

Object.keys($1896b5e28554d57b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1896b5e28554d57b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1896b5e28554d57b$exports[key];
        }
    });
});
var $7a7e68b5aa0b9077$exports = {};

$parcel$export($7a7e68b5aa0b9077$exports, "isEqual", () => $7a7e68b5aa0b9077$export$248d38f6296296c5, (v) => $7a7e68b5aa0b9077$export$248d38f6296296c5 = v);
var $7a7e68b5aa0b9077$export$248d38f6296296c5;
"use strict";
$7a7e68b5aa0b9077$export$248d38f6296296c5 = $7a7e68b5aa0b9077$var$isEqual;

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $7a7e68b5aa0b9077$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(leftDate);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(rightDate);
    return +_dateLeft === +_dateRight;
}


Object.keys($7a7e68b5aa0b9077$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7a7e68b5aa0b9077$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7a7e68b5aa0b9077$exports[key];
        }
    });
});
var $2341c5e25fcfd1db$exports = {};

$parcel$export($2341c5e25fcfd1db$exports, "isExists", () => $2341c5e25fcfd1db$export$127519e0edcdc58b, (v) => $2341c5e25fcfd1db$export$127519e0edcdc58b = v);
var $2341c5e25fcfd1db$export$127519e0edcdc58b;
"use strict";
$2341c5e25fcfd1db$export$127519e0edcdc58b = $2341c5e25fcfd1db$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $2341c5e25fcfd1db$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


Object.keys($2341c5e25fcfd1db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2341c5e25fcfd1db$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2341c5e25fcfd1db$exports[key];
        }
    });
});
var $82d868cdf6cf6fea$exports = {};

$parcel$export($82d868cdf6cf6fea$exports, "isFirstDayOfMonth", () => $82d868cdf6cf6fea$export$2716a425049f51dd, (v) => $82d868cdf6cf6fea$export$2716a425049f51dd = v);
var $82d868cdf6cf6fea$export$2716a425049f51dd;
"use strict";
$82d868cdf6cf6fea$export$2716a425049f51dd = $82d868cdf6cf6fea$var$isFirstDayOfMonth;

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $82d868cdf6cf6fea$var$isFirstDayOfMonth(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDate() === 1;
}


Object.keys($82d868cdf6cf6fea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $82d868cdf6cf6fea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $82d868cdf6cf6fea$exports[key];
        }
    });
});
var $add9570ccdd56579$exports = {};

$parcel$export($add9570ccdd56579$exports, "isFriday", () => $add9570ccdd56579$export$3b7d89f127884993, (v) => $add9570ccdd56579$export$3b7d89f127884993 = v);
var $add9570ccdd56579$export$3b7d89f127884993;
"use strict";
$add9570ccdd56579$export$3b7d89f127884993 = $add9570ccdd56579$var$isFriday;

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $add9570ccdd56579$var$isFriday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 5;
}


Object.keys($add9570ccdd56579$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $add9570ccdd56579$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $add9570ccdd56579$exports[key];
        }
    });
});
var $a96d25a4d70c8926$exports = {};

$parcel$export($a96d25a4d70c8926$exports, "isFuture", () => $a96d25a4d70c8926$export$2baac2df6018cd7, (v) => $a96d25a4d70c8926$export$2baac2df6018cd7 = v);
var $a96d25a4d70c8926$export$2baac2df6018cd7;
"use strict";
$a96d25a4d70c8926$export$2baac2df6018cd7 = $a96d25a4d70c8926$var$isFuture;

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $a96d25a4d70c8926$var$isFuture(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) > Date.now();
}


Object.keys($a96d25a4d70c8926$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a96d25a4d70c8926$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a96d25a4d70c8926$exports[key];
        }
    });
});

Object.keys($d2050f4e5c1a3003$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d2050f4e5c1a3003$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d2050f4e5c1a3003$exports[key];
        }
    });
});

Object.keys($bf096f6f36c61b64$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf096f6f36c61b64$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf096f6f36c61b64$exports[key];
        }
    });
});
var $8e2fec4c70f4ef6b$exports = {};

$parcel$export($8e2fec4c70f4ef6b$exports, "isMatch", () => $8e2fec4c70f4ef6b$export$b74c33566721f70f, (v) => $8e2fec4c70f4ef6b$export$b74c33566721f70f = v);
var $8e2fec4c70f4ef6b$export$b74c33566721f70f;
"use strict";
$8e2fec4c70f4ef6b$export$b74c33566721f70f = $8e2fec4c70f4ef6b$var$isMatch;

var $8abb93379891fb3e$exports = {};
"use strict";
Object.defineProperty($8abb93379891fb3e$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $54cd66db3e5e74df$export$70cc8fd02856fd58;
    }
});
$8abb93379891fb3e$exports.parse = $8abb93379891fb3e$var$parse;
Object.defineProperty($8abb93379891fb3e$exports, "parsers", {
    enumerable: true,
    get: function() {
        return $5cf2b811a6ff5b69$export$19131010e7fd8373;
    }
});






var $5cf2b811a6ff5b69$export$19131010e7fd8373;
"use strict";
$5cf2b811a6ff5b69$export$19131010e7fd8373 = void 0;
var $db0c34f9a22bf78d$export$8e5a1d3f85a9688;
"use strict";
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = void 0;
var $bc2b96d39fc4c3d8$export$7acfa6ed01010e37;
"use strict";
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = void 0;
var $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5;
var $2c074b7ab8cd2d6d$export$81d53e3678089a6;
var $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee;
"use strict";
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = void 0;
var $59425df5ba0b4bea$exports = {};

$parcel$export($59425df5ba0b4bea$exports, "transpose", () => $59425df5ba0b4bea$export$9cb09a71b7d66923, (v) => $59425df5ba0b4bea$export$9cb09a71b7d66923 = v);
var $59425df5ba0b4bea$export$9cb09a71b7d66923;
"use strict";
$59425df5ba0b4bea$export$9cb09a71b7d66923 = $59425df5ba0b4bea$var$transpose;

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $59425df5ba0b4bea$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}



const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$2c074b7ab8cd2d6d$export$81d53e3678089a6 = $2c074b7ab8cd2d6d$var$Setter;
class $2c074b7ab8cd2d6d$var$ValueSetter extends $2c074b7ab8cd2d6d$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 = $2c074b7ab8cd2d6d$var$ValueSetter;
class $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter extends $2c074b7ab8cd2d6d$var$Setter {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, Date));
    }
}
$2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee = $2c074b7ab8cd2d6d$var$DateToSystemTimezoneSetter;


class $bc2b96d39fc4c3d8$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$bc2b96d39fc4c3d8$export$7acfa6ed01010e37 = $bc2b96d39fc4c3d8$var$Parser;


class $db0c34f9a22bf78d$var$EraParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$db0c34f9a22bf78d$export$8e5a1d3f85a9688 = $db0c34f9a22bf78d$var$EraParser;


var $66195bae0f19f15a$export$48d352de7cd4a988;
"use strict";
$66195bae0f19f15a$export$48d352de7cd4a988 = void 0;

var $7caea2161b2082cf$export$fb506d2676e7f207;
var $7caea2161b2082cf$export$3d50627710b84d75;
var $7caea2161b2082cf$export$4f84e3a82c7b538;
var $7caea2161b2082cf$export$29126f735cbf69f7;
var $7caea2161b2082cf$export$d931c43c4608a164;
var $7caea2161b2082cf$export$513bb01536146ab6;
var $7caea2161b2082cf$export$2c9307b2e29c533c;
var $7caea2161b2082cf$export$cc7cc9e2a3ff9388;
var $7caea2161b2082cf$export$6497f4c0ecdfba8e;
"use strict";
$7caea2161b2082cf$export$fb506d2676e7f207 = $7caea2161b2082cf$var$dayPeriodEnumToHours;
$7caea2161b2082cf$export$3d50627710b84d75 = $7caea2161b2082cf$var$isLeapYearIndex;
$7caea2161b2082cf$export$4f84e3a82c7b538 = $7caea2161b2082cf$var$mapValue;
$7caea2161b2082cf$export$29126f735cbf69f7 = $7caea2161b2082cf$var$normalizeTwoDigitYear;
$7caea2161b2082cf$export$d931c43c4608a164 = $7caea2161b2082cf$var$parseAnyDigitsSigned;
$7caea2161b2082cf$export$513bb01536146ab6 = $7caea2161b2082cf$var$parseNDigits;
$7caea2161b2082cf$export$2c9307b2e29c533c = $7caea2161b2082cf$var$parseNDigitsSigned;
$7caea2161b2082cf$export$cc7cc9e2a3ff9388 = $7caea2161b2082cf$var$parseNumericPattern;
$7caea2161b2082cf$export$6497f4c0ecdfba8e = $7caea2161b2082cf$var$parseTimezonePattern;

var $90ea69bf2b625c49$export$a7ee192b982af9c1;
var $90ea69bf2b625c49$export$c123ee06d9da8480;
"use strict";
$90ea69bf2b625c49$export$a7ee192b982af9c1 = $90ea69bf2b625c49$export$c123ee06d9da8480 = void 0;
const $90ea69bf2b625c49$var$numericPatterns = $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$var$timezonePatterns = $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff + seconds * $8540a44f59a4af84$export$397c2d5776aa9055),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$var$parseAnyDigitsSigned(dateString) {
    return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.fourDigits, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$var$parseNumericPattern($90ea69bf2b625c49$export$c123ee06d9da8480.fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $66195bae0f19f15a$var$YearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$66195bae0f19f15a$export$48d352de7cd4a988 = $66195bae0f19f15a$var$YearParser;


var $9fda39b31cab7345$export$b8ef38dfcf05d5db;
"use strict";
$9fda39b31cab7345$export$b8ef38dfcf05d5db = void 0;




// Local week-numbering year
class $9fda39b31cab7345$var$LocalWeekYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$9fda39b31cab7345$export$b8ef38dfcf05d5db = $9fda39b31cab7345$var$LocalWeekYearParser;


var $1a189db5f2a1065c$export$951d1df011fde06f;
"use strict";
$1a189db5f2a1065c$export$951d1df011fde06f = void 0;




// ISO week-numbering year
class $1a189db5f2a1065c$var$ISOWeekYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1a189db5f2a1065c$export$951d1df011fde06f = $1a189db5f2a1065c$var$ISOWeekYearParser;


var $c3854b7a937037cd$export$bad9d2ea38e8f1a;
"use strict";
$c3854b7a937037cd$export$bad9d2ea38e8f1a = void 0;


class $c3854b7a937037cd$var$ExtendedYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c3854b7a937037cd$export$bad9d2ea38e8f1a = $c3854b7a937037cd$var$ExtendedYearParser;


var $d1988bf983127f3e$export$5cb0f701186dde1d;
"use strict";
$d1988bf983127f3e$export$5cb0f701186dde1d = void 0;


class $d1988bf983127f3e$var$QuarterParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$d1988bf983127f3e$export$5cb0f701186dde1d = $d1988bf983127f3e$var$QuarterParser;


var $62b79555ac1f33b0$export$300c0c2990e20e6d;
"use strict";
$62b79555ac1f33b0$export$300c0c2990e20e6d = void 0;


class $62b79555ac1f33b0$var$StandAloneQuarterParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$62b79555ac1f33b0$export$300c0c2990e20e6d = $62b79555ac1f33b0$var$StandAloneQuarterParser;


var $44a198f4e488a239$export$400dd8b40ef138a3;
"use strict";
$44a198f4e488a239$export$400dd8b40ef138a3 = void 0;



class $44a198f4e488a239$var$MonthParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$44a198f4e488a239$export$400dd8b40ef138a3 = $44a198f4e488a239$var$MonthParser;


var $f7643ab884280f91$export$1d7eaa53eaa5deba;
"use strict";
$f7643ab884280f91$export$1d7eaa53eaa5deba = void 0;



class $f7643ab884280f91$var$StandAloneMonthParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f7643ab884280f91$export$1d7eaa53eaa5deba = $f7643ab884280f91$var$StandAloneMonthParser;


var $0da9b6c0b13ee7fd$export$c4005ffc174e07c0;
"use strict";
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = void 0;
var $66c7729eb95aa501$exports = {};

$parcel$export($66c7729eb95aa501$exports, "setWeek", () => $66c7729eb95aa501$export$4b3066ce4afafd88, (v) => $66c7729eb95aa501$export$4b3066ce4afafd88 = v);
var $66c7729eb95aa501$export$4b3066ce4afafd88;
"use strict";
$66c7729eb95aa501$export$4b3066ce4afafd88 = $66c7729eb95aa501$var$setWeek;


/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $66c7729eb95aa501$var$setWeek(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// Local week of year
class $0da9b6c0b13ee7fd$var$LocalWeekParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$0da9b6c0b13ee7fd$export$c4005ffc174e07c0 = $0da9b6c0b13ee7fd$var$LocalWeekParser;


var $6803ee1ef2b46eaa$export$6fc8dbedd560a6af;
"use strict";
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = void 0;
var $d0815b4ed45bc80a$exports = {};

$parcel$export($d0815b4ed45bc80a$exports, "setISOWeek", () => $d0815b4ed45bc80a$export$6542bebf6be94082, (v) => $d0815b4ed45bc80a$export$6542bebf6be94082 = v);
var $d0815b4ed45bc80a$export$6542bebf6be94082;
"use strict";
$d0815b4ed45bc80a$export$6542bebf6be94082 = $d0815b4ed45bc80a$var$setISOWeek;


/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d0815b4ed45bc80a$var$setISOWeek(date, week) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// ISO week of year
class $6803ee1ef2b46eaa$var$ISOWeekParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6803ee1ef2b46eaa$export$6fc8dbedd560a6af = $6803ee1ef2b46eaa$var$ISOWeekParser;


var $e06f3f7fc9153746$export$e8d4b28a20981dd2;
"use strict";
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = void 0;



const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $e06f3f7fc9153746$var$DateParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e06f3f7fc9153746$export$e8d4b28a20981dd2 = $e06f3f7fc9153746$var$DateParser;


var $6b2b75646543924f$export$6cfe0d613455f615;
"use strict";
$6b2b75646543924f$export$6cfe0d613455f615 = void 0;



class $6b2b75646543924f$var$DayOfYearParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6b2b75646543924f$export$6cfe0d613455f615 = $6b2b75646543924f$var$DayOfYearParser;


var $9c29ecc5d15fe12f$export$1b03c8b76262f7bd;
"use strict";
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = void 0;
var $13939a537621d91b$exports = {};

$parcel$export($13939a537621d91b$exports, "setDay", () => $13939a537621d91b$export$b04fdcda82decc6c, (v) => $13939a537621d91b$export$b04fdcda82decc6c = v);
var $13939a537621d91b$export$b04fdcda82decc6c;
"use strict";
$13939a537621d91b$export$b04fdcda82decc6c = $13939a537621d91b$var$setDay;



/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $13939a537621d91b$var$setDay(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_date, diff);
}



// Day of week
class $9c29ecc5d15fe12f$var$DayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$9c29ecc5d15fe12f$export$1b03c8b76262f7bd = $9c29ecc5d15fe12f$var$DayParser;


var $fff6beaa36b4d0e5$export$44d1c127ab42c480;
"use strict";
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = void 0;



// Local day of week
class $fff6beaa36b4d0e5$var$LocalDayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$fff6beaa36b4d0e5$export$44d1c127ab42c480 = $fff6beaa36b4d0e5$var$LocalDayParser;


var $1516c9543f7b6045$export$e447a647caaaec1d;
"use strict";
$1516c9543f7b6045$export$e447a647caaaec1d = void 0;



// Stand-alone local day of week
class $1516c9543f7b6045$var$StandAloneLocalDayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$1516c9543f7b6045$export$e447a647caaaec1d = $1516c9543f7b6045$var$StandAloneLocalDayParser;


var $6410865f895f2a05$export$693fb1e525095b2a;
"use strict";
$6410865f895f2a05$export$693fb1e525095b2a = void 0;
var $87a68208fbd57247$exports = {};

$parcel$export($87a68208fbd57247$exports, "setISODay", () => $87a68208fbd57247$export$1fd9df65adb0d1aa, (v) => $87a68208fbd57247$export$1fd9df65adb0d1aa = v);
var $87a68208fbd57247$export$1fd9df65adb0d1aa;
"use strict";
$87a68208fbd57247$export$1fd9df65adb0d1aa = $87a68208fbd57247$var$setISODay;



/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $87a68208fbd57247$var$setISODay(date, day) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(_date);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(_date, diff);
}




// ISO day of week
class $6410865f895f2a05$var$ISODayParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6410865f895f2a05$export$693fb1e525095b2a = $6410865f895f2a05$var$ISODayParser;


var $d5f00db985cb1985$export$8d1e08492351df91;
"use strict";
$d5f00db985cb1985$export$8d1e08492351df91 = void 0;


class $d5f00db985cb1985$var$AMPMParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d5f00db985cb1985$export$8d1e08492351df91 = $d5f00db985cb1985$var$AMPMParser;


var $40ef93898dc5fd94$export$73ca2bd0a17d273;
"use strict";
$40ef93898dc5fd94$export$73ca2bd0a17d273 = void 0;


class $40ef93898dc5fd94$var$AMPMMidnightParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$40ef93898dc5fd94$export$73ca2bd0a17d273 = $40ef93898dc5fd94$var$AMPMMidnightParser;


var $74a8f7a92cf7f4b7$export$bb9212adf05373db;
"use strict";
$74a8f7a92cf7f4b7$export$bb9212adf05373db = void 0;


// in the morning, in the afternoon, in the evening, at night
class $74a8f7a92cf7f4b7$var$DayPeriodParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$74a8f7a92cf7f4b7$export$bb9212adf05373db = $74a8f7a92cf7f4b7$var$DayPeriodParser;


var $c4e91a5550a4af76$export$8a04050a727a1756;
"use strict";
$c4e91a5550a4af76$export$8a04050a727a1756 = void 0;



class $c4e91a5550a4af76$var$Hour1to12Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$c4e91a5550a4af76$export$8a04050a727a1756 = $c4e91a5550a4af76$var$Hour1to12Parser;


var $04e380d05021e0e6$export$e56f4dea2c3e56dd;
"use strict";
$04e380d05021e0e6$export$e56f4dea2c3e56dd = void 0;



class $04e380d05021e0e6$var$Hour0to23Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$04e380d05021e0e6$export$e56f4dea2c3e56dd = $04e380d05021e0e6$var$Hour0to23Parser;


var $b7df994bc976acad$export$cbbe855312f87d77;
"use strict";
$b7df994bc976acad$export$cbbe855312f87d77 = void 0;



class $b7df994bc976acad$var$Hour0To11Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$b7df994bc976acad$export$cbbe855312f87d77 = $b7df994bc976acad$var$Hour0To11Parser;


var $2a786c11f89b58f4$export$6008046d2b34b6a5;
"use strict";
$2a786c11f89b58f4$export$6008046d2b34b6a5 = void 0;



class $2a786c11f89b58f4$var$Hour1To24Parser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$2a786c11f89b58f4$export$6008046d2b34b6a5 = $2a786c11f89b58f4$var$Hour1To24Parser;


var $fccac2a30b38ae4c$export$2b52670d9e2be53;
"use strict";
$fccac2a30b38ae4c$export$2b52670d9e2be53 = void 0;



class $fccac2a30b38ae4c$var$MinuteParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$fccac2a30b38ae4c$export$2b52670d9e2be53 = $fccac2a30b38ae4c$var$MinuteParser;


var $1cf805ecbd4f0c4e$export$94d46d540cf1366a;
"use strict";
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = void 0;



class $1cf805ecbd4f0c4e$var$SecondParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)($90ea69bf2b625c49$export$c123ee06d9da8480.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$1cf805ecbd4f0c4e$export$94d46d540cf1366a = $1cf805ecbd4f0c4e$var$SecondParser;


var $93458d2bd887c060$export$b8e6f8b2d70893b1;
"use strict";
$93458d2bd887c060$export$b8e6f8b2d70893b1 = void 0;


class $93458d2bd887c060$var$FractionOfSecondParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$93458d2bd887c060$export$b8e6f8b2d70893b1 = $93458d2bd887c060$var$FractionOfSecondParser;


var $8e1ac7071c05f7b7$export$104d901d49fea29b;
"use strict";
$8e1ac7071c05f7b7$export$104d901d49fea29b = void 0;





// Timezone (ISO-8601. +00:00 is `'Z'`)
class $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$8e1ac7071c05f7b7$export$104d901d49fea29b = $8e1ac7071c05f7b7$var$ISOTimezoneWithZParser;


var $817e75c4dd06b66a$export$12910e5204b52b9;
"use strict";
$817e75c4dd06b66a$export$12910e5204b52b9 = void 0;





// Timezone (ISO-8601)
class $817e75c4dd06b66a$var$ISOTimezoneParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)($90ea69bf2b625c49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$817e75c4dd06b66a$export$12910e5204b52b9 = $817e75c4dd06b66a$var$ISOTimezoneParser;


var $a7e39061a4ba0a45$export$2cd8bf877a05e96;
"use strict";
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = void 0;



class $a7e39061a4ba0a45$var$TimestampSecondsParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$a7e39061a4ba0a45$export$2cd8bf877a05e96 = $a7e39061a4ba0a45$var$TimestampSecondsParser;


var $dff03ff1496c0b81$export$6d8f69c6906d6368;
"use strict";
$dff03ff1496c0b81$export$6d8f69c6906d6368 = void 0;



class $dff03ff1496c0b81$var$TimestampMillisecondsParser extends $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$dff03ff1496c0b81$export$6d8f69c6906d6368 = $dff03ff1496c0b81$var$TimestampMillisecondsParser;


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $5cf2b811a6ff5b69$var$parsers = $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new $db0c34f9a22bf78d$export$8e5a1d3f85a9688(),
    y: new $66195bae0f19f15a$export$48d352de7cd4a988(),
    Y: new $9fda39b31cab7345$export$b8ef38dfcf05d5db(),
    R: new $1a189db5f2a1065c$export$951d1df011fde06f(),
    u: new $c3854b7a937037cd$export$bad9d2ea38e8f1a(),
    Q: new $d1988bf983127f3e$export$5cb0f701186dde1d(),
    q: new $62b79555ac1f33b0$export$300c0c2990e20e6d(),
    M: new $44a198f4e488a239$export$400dd8b40ef138a3(),
    L: new $f7643ab884280f91$export$1d7eaa53eaa5deba(),
    w: new $0da9b6c0b13ee7fd$export$c4005ffc174e07c0(),
    I: new $6803ee1ef2b46eaa$export$6fc8dbedd560a6af(),
    d: new $e06f3f7fc9153746$export$e8d4b28a20981dd2(),
    D: new $6b2b75646543924f$export$6cfe0d613455f615(),
    E: new $9c29ecc5d15fe12f$export$1b03c8b76262f7bd(),
    e: new $fff6beaa36b4d0e5$export$44d1c127ab42c480(),
    c: new $1516c9543f7b6045$export$e447a647caaaec1d(),
    i: new $6410865f895f2a05$export$693fb1e525095b2a(),
    a: new $d5f00db985cb1985$export$8d1e08492351df91(),
    b: new $40ef93898dc5fd94$export$73ca2bd0a17d273(),
    B: new $74a8f7a92cf7f4b7$export$bb9212adf05373db(),
    h: new $c4e91a5550a4af76$export$8a04050a727a1756(),
    H: new $04e380d05021e0e6$export$e56f4dea2c3e56dd(),
    K: new $b7df994bc976acad$export$cbbe855312f87d77(),
    k: new $2a786c11f89b58f4$export$6008046d2b34b6a5(),
    m: new $fccac2a30b38ae4c$export$2b52670d9e2be53(),
    s: new $1cf805ecbd4f0c4e$export$94d46d540cf1366a(),
    S: new $93458d2bd887c060$export$b8e6f8b2d70893b1(),
    X: new $8e1ac7071c05f7b7$export$104d901d49fea29b(),
    x: new $817e75c4dd06b66a$export$12910e5204b52b9(),
    t: new $a7e39061a4ba0a45$export$2cd8bf877a05e96(),
    T: new $dff03ff1496c0b81$export$6d8f69c6906d6368()
};



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $8abb93379891fb3e$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $e9531067c80a48a0$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate);
        else return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $2c074b7ab8cd2d6d$export$5aaf7ff7f09ea4ee()
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $54cd66db3e5e74df$export$70cc8fd02856fd58) {
            const longFormatter = $54cd66db3e5e74df$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $5cf2b811a6ff5b69$export$19131010e7fd8373[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate);
    if (isNaN(date.getTime())) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(referenceDate, date);
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}


/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $8e2fec4c70f4ef6b$var$isMatch(dateStr, formatStr, options) {
    return (0, $f2a682b251363bc2$export$1ea939691cdc45b8)((0, $8abb93379891fb3e$exports.parse)(dateStr, formatStr, new Date(), options));
}


Object.keys($8e2fec4c70f4ef6b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8e2fec4c70f4ef6b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8e2fec4c70f4ef6b$exports[key];
        }
    });
});
var $3f9d573ef8d8a1fd$exports = {};

$parcel$export($3f9d573ef8d8a1fd$exports, "isMonday", () => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5, (v) => $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = v);
var $3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5;
"use strict";
$3f9d573ef8d8a1fd$export$9573fe9b7c9ac3f5 = $3f9d573ef8d8a1fd$var$isMonday;

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $3f9d573ef8d8a1fd$var$isMonday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 1;
}


Object.keys($3f9d573ef8d8a1fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3f9d573ef8d8a1fd$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3f9d573ef8d8a1fd$exports[key];
        }
    });
});
var $957ff381b38ac7b6$exports = {};

$parcel$export($957ff381b38ac7b6$exports, "isPast", () => $957ff381b38ac7b6$export$fc5014aa3db48558, (v) => $957ff381b38ac7b6$export$fc5014aa3db48558 = v);
var $957ff381b38ac7b6$export$fc5014aa3db48558;
"use strict";
$957ff381b38ac7b6$export$fc5014aa3db48558 = $957ff381b38ac7b6$var$isPast;

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $957ff381b38ac7b6$var$isPast(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) < Date.now();
}


Object.keys($957ff381b38ac7b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $957ff381b38ac7b6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $957ff381b38ac7b6$exports[key];
        }
    });
});

Object.keys($27a7db21eafd685b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $27a7db21eafd685b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $27a7db21eafd685b$exports[key];
        }
    });
});
var $3d9e3b90112ffc43$exports = {};

$parcel$export($3d9e3b90112ffc43$exports, "isSameHour", () => $3d9e3b90112ffc43$export$f9f3a94a0371013, (v) => $3d9e3b90112ffc43$export$f9f3a94a0371013 = v);
var $3d9e3b90112ffc43$export$f9f3a94a0371013;
"use strict";
$3d9e3b90112ffc43$export$f9f3a94a0371013 = $3d9e3b90112ffc43$var$isSameHour;
var $d153613108f3ff12$exports = {};

$parcel$export($d153613108f3ff12$exports, "startOfHour", () => $d153613108f3ff12$export$24f91f68e7c9d9d5, (v) => $d153613108f3ff12$export$24f91f68e7c9d9d5 = v);
var $d153613108f3ff12$export$24f91f68e7c9d9d5;
"use strict";
$d153613108f3ff12$export$24f91f68e7c9d9d5 = $d153613108f3ff12$var$startOfHour;

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $d153613108f3ff12$var$startOfHour(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $3d9e3b90112ffc43$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}


Object.keys($3d9e3b90112ffc43$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3d9e3b90112ffc43$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3d9e3b90112ffc43$exports[key];
        }
    });
});
var $2f828403128a4c50$exports = {};

$parcel$export($2f828403128a4c50$exports, "isSameISOWeek", () => $2f828403128a4c50$export$1c6e74e3c7b27764, (v) => $2f828403128a4c50$export$1c6e74e3c7b27764 = v);
var $2f828403128a4c50$export$1c6e74e3c7b27764;
"use strict";
$2f828403128a4c50$export$1c6e74e3c7b27764 = $2f828403128a4c50$var$isSameISOWeek;
var $4398e052cc63a087$exports = {};

$parcel$export($4398e052cc63a087$exports, "isSameWeek", () => $4398e052cc63a087$export$6ea683876c36b8d2, (v) => $4398e052cc63a087$export$6ea683876c36b8d2 = v);
var $4398e052cc63a087$export$6ea683876c36b8d2;
"use strict";
$4398e052cc63a087$export$6ea683876c36b8d2 = $4398e052cc63a087$var$isSameWeek;

/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $4398e052cc63a087$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateLeft, options);
    const dateRightStartOfWeek = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $2f828403128a4c50$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $4398e052cc63a087$export$6ea683876c36b8d2)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}


Object.keys($2f828403128a4c50$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2f828403128a4c50$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2f828403128a4c50$exports[key];
        }
    });
});
var $d3ee8591ef34529f$exports = {};

$parcel$export($d3ee8591ef34529f$exports, "isSameISOWeekYear", () => $d3ee8591ef34529f$export$5f55dbf38a1aee81, (v) => $d3ee8591ef34529f$export$5f55dbf38a1aee81 = v);
var $d3ee8591ef34529f$export$5f55dbf38a1aee81;
"use strict";
$d3ee8591ef34529f$export$5f55dbf38a1aee81 = $d3ee8591ef34529f$var$isSameISOWeekYear;

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $d3ee8591ef34529f$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(dateLeft);
    const dateRightStartOfYear = (0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}


Object.keys($d3ee8591ef34529f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d3ee8591ef34529f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d3ee8591ef34529f$exports[key];
        }
    });
});
var $dcee691fa8b5c110$exports = {};

$parcel$export($dcee691fa8b5c110$exports, "isSameMinute", () => $dcee691fa8b5c110$export$5d274bf63c8705cb, (v) => $dcee691fa8b5c110$export$5d274bf63c8705cb = v);
var $dcee691fa8b5c110$export$5d274bf63c8705cb;
"use strict";
$dcee691fa8b5c110$export$5d274bf63c8705cb = $dcee691fa8b5c110$var$isSameMinute;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $dcee691fa8b5c110$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $d1ad424e56672364$export$c66440458c6aa793)(dateLeft);
    const dateRightStartOfMinute = (0, $d1ad424e56672364$export$c66440458c6aa793)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


Object.keys($dcee691fa8b5c110$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $dcee691fa8b5c110$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $dcee691fa8b5c110$exports[key];
        }
    });
});
var $06e3609fc2fbc2e2$exports = {};

$parcel$export($06e3609fc2fbc2e2$exports, "isSameMonth", () => $06e3609fc2fbc2e2$export$a18c89cbd24170ff, (v) => $06e3609fc2fbc2e2$export$a18c89cbd24170ff = v);
var $06e3609fc2fbc2e2$export$a18c89cbd24170ff;
"use strict";
$06e3609fc2fbc2e2$export$a18c89cbd24170ff = $06e3609fc2fbc2e2$var$isSameMonth;

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $06e3609fc2fbc2e2$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}


Object.keys($06e3609fc2fbc2e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $06e3609fc2fbc2e2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $06e3609fc2fbc2e2$exports[key];
        }
    });
});
var $b059a7637303f908$exports = {};

$parcel$export($b059a7637303f908$exports, "isSameQuarter", () => $b059a7637303f908$export$5c60e4190867161c, (v) => $b059a7637303f908$export$5c60e4190867161c = v);
var $b059a7637303f908$export$5c60e4190867161c;
"use strict";
$b059a7637303f908$export$5c60e4190867161c = $b059a7637303f908$var$isSameQuarter;

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $b059a7637303f908$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateLeft);
    const dateRightStartOfQuarter = (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


Object.keys($b059a7637303f908$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b059a7637303f908$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b059a7637303f908$exports[key];
        }
    });
});
var $af3916f9a5384d82$exports = {};

$parcel$export($af3916f9a5384d82$exports, "isSameSecond", () => $af3916f9a5384d82$export$b88fbcfe038f3498, (v) => $af3916f9a5384d82$export$b88fbcfe038f3498 = v);
var $af3916f9a5384d82$export$b88fbcfe038f3498;
"use strict";
$af3916f9a5384d82$export$b88fbcfe038f3498 = $af3916f9a5384d82$var$isSameSecond;
var $fec0f854199fab32$exports = {};

$parcel$export($fec0f854199fab32$exports, "startOfSecond", () => $fec0f854199fab32$export$66c51f9715fdbff5, (v) => $fec0f854199fab32$export$66c51f9715fdbff5 = v);
var $fec0f854199fab32$export$66c51f9715fdbff5;
"use strict";
$fec0f854199fab32$export$66c51f9715fdbff5 = $fec0f854199fab32$var$startOfSecond;

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $fec0f854199fab32$var$startOfSecond(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(0);
    return _date;
}


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $af3916f9a5384d82$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $fec0f854199fab32$export$66c51f9715fdbff5)(dateLeft);
    const dateRightStartOfSecond = (0, $fec0f854199fab32$export$66c51f9715fdbff5)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


Object.keys($af3916f9a5384d82$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $af3916f9a5384d82$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $af3916f9a5384d82$exports[key];
        }
    });
});

Object.keys($4398e052cc63a087$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4398e052cc63a087$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4398e052cc63a087$exports[key];
        }
    });
});
var $a4f3c61641c4093b$exports = {};

$parcel$export($a4f3c61641c4093b$exports, "isSameYear", () => $a4f3c61641c4093b$export$5841f9eb9773f25f, (v) => $a4f3c61641c4093b$export$5841f9eb9773f25f = v);
var $a4f3c61641c4093b$export$5841f9eb9773f25f;
"use strict";
$a4f3c61641c4093b$export$5841f9eb9773f25f = $a4f3c61641c4093b$var$isSameYear;

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $a4f3c61641c4093b$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


Object.keys($a4f3c61641c4093b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a4f3c61641c4093b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a4f3c61641c4093b$exports[key];
        }
    });
});

Object.keys($d84241a3868bd79f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d84241a3868bd79f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d84241a3868bd79f$exports[key];
        }
    });
});

Object.keys($971b91a830c22187$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $971b91a830c22187$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $971b91a830c22187$exports[key];
        }
    });
});
var $1fcf523a61a65140$exports = {};

$parcel$export($1fcf523a61a65140$exports, "isThisHour", () => $1fcf523a61a65140$export$5d41bdc7172839b9, (v) => $1fcf523a61a65140$export$5d41bdc7172839b9 = v);
var $1fcf523a61a65140$export$5d41bdc7172839b9;
"use strict";
$1fcf523a61a65140$export$5d41bdc7172839b9 = $1fcf523a61a65140$var$isThisHour;


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $1fcf523a61a65140$var$isThisHour(date) {
    return (0, $3d9e3b90112ffc43$export$f9f3a94a0371013)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($1fcf523a61a65140$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1fcf523a61a65140$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1fcf523a61a65140$exports[key];
        }
    });
});
var $13e900ab202aea44$exports = {};

$parcel$export($13e900ab202aea44$exports, "isThisISOWeek", () => $13e900ab202aea44$export$4e987896c721f753, (v) => $13e900ab202aea44$export$4e987896c721f753 = v);
var $13e900ab202aea44$export$4e987896c721f753;
"use strict";
$13e900ab202aea44$export$4e987896c721f753 = $13e900ab202aea44$var$isThisISOWeek;


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $13e900ab202aea44$var$isThisISOWeek(date) {
    return (0, $2f828403128a4c50$export$1c6e74e3c7b27764)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($13e900ab202aea44$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $13e900ab202aea44$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $13e900ab202aea44$exports[key];
        }
    });
});
var $11c5b8927d0f9212$exports = {};

$parcel$export($11c5b8927d0f9212$exports, "isThisMinute", () => $11c5b8927d0f9212$export$fa55b7d29d8d957a, (v) => $11c5b8927d0f9212$export$fa55b7d29d8d957a = v);
var $11c5b8927d0f9212$export$fa55b7d29d8d957a;
"use strict";
$11c5b8927d0f9212$export$fa55b7d29d8d957a = $11c5b8927d0f9212$var$isThisMinute;


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $11c5b8927d0f9212$var$isThisMinute(date) {
    return (0, $dcee691fa8b5c110$export$5d274bf63c8705cb)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($11c5b8927d0f9212$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $11c5b8927d0f9212$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $11c5b8927d0f9212$exports[key];
        }
    });
});
var $a513a065f29b721f$exports = {};

$parcel$export($a513a065f29b721f$exports, "isThisMonth", () => $a513a065f29b721f$export$173f1e1d92847276, (v) => $a513a065f29b721f$export$173f1e1d92847276 = v);
var $a513a065f29b721f$export$173f1e1d92847276;
"use strict";
$a513a065f29b721f$export$173f1e1d92847276 = $a513a065f29b721f$var$isThisMonth;


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $a513a065f29b721f$var$isThisMonth(date) {
    return (0, $06e3609fc2fbc2e2$export$a18c89cbd24170ff)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($a513a065f29b721f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a513a065f29b721f$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a513a065f29b721f$exports[key];
        }
    });
});
var $7b97fc1be12623a5$exports = {};

$parcel$export($7b97fc1be12623a5$exports, "isThisQuarter", () => $7b97fc1be12623a5$export$3d88fd18ab599ccc, (v) => $7b97fc1be12623a5$export$3d88fd18ab599ccc = v);
var $7b97fc1be12623a5$export$3d88fd18ab599ccc;
"use strict";
$7b97fc1be12623a5$export$3d88fd18ab599ccc = $7b97fc1be12623a5$var$isThisQuarter;


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $7b97fc1be12623a5$var$isThisQuarter(date) {
    return (0, $b059a7637303f908$export$5c60e4190867161c)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($7b97fc1be12623a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7b97fc1be12623a5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7b97fc1be12623a5$exports[key];
        }
    });
});
var $c12a26020747be23$exports = {};

$parcel$export($c12a26020747be23$exports, "isThisSecond", () => $c12a26020747be23$export$8d7059b5bca087e6, (v) => $c12a26020747be23$export$8d7059b5bca087e6 = v);
var $c12a26020747be23$export$8d7059b5bca087e6;
"use strict";
$c12a26020747be23$export$8d7059b5bca087e6 = $c12a26020747be23$var$isThisSecond;


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $c12a26020747be23$var$isThisSecond(date) {
    return (0, $af3916f9a5384d82$export$b88fbcfe038f3498)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($c12a26020747be23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c12a26020747be23$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c12a26020747be23$exports[key];
        }
    });
});
var $def5a9154a6fce3c$exports = {};

$parcel$export($def5a9154a6fce3c$exports, "isThisWeek", () => $def5a9154a6fce3c$export$cfe4b66a69cdd8a, (v) => $def5a9154a6fce3c$export$cfe4b66a69cdd8a = v);
var $def5a9154a6fce3c$export$cfe4b66a69cdd8a;
"use strict";
$def5a9154a6fce3c$export$cfe4b66a69cdd8a = $def5a9154a6fce3c$var$isThisWeek;


/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $def5a9154a6fce3c$var$isThisWeek(date, options) {
    return (0, $4398e052cc63a087$export$6ea683876c36b8d2)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}


Object.keys($def5a9154a6fce3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $def5a9154a6fce3c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $def5a9154a6fce3c$exports[key];
        }
    });
});
var $0a1172148c7ecca3$exports = {};

$parcel$export($0a1172148c7ecca3$exports, "isThisYear", () => $0a1172148c7ecca3$export$a28c94941893a5ac, (v) => $0a1172148c7ecca3$export$a28c94941893a5ac = v);
var $0a1172148c7ecca3$export$a28c94941893a5ac;
"use strict";
$0a1172148c7ecca3$export$a28c94941893a5ac = $0a1172148c7ecca3$var$isThisYear;


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $0a1172148c7ecca3$var$isThisYear(date) {
    return (0, $a4f3c61641c4093b$export$5841f9eb9773f25f)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($0a1172148c7ecca3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0a1172148c7ecca3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0a1172148c7ecca3$exports[key];
        }
    });
});
var $2a3ba7018817a2a8$exports = {};

$parcel$export($2a3ba7018817a2a8$exports, "isThursday", () => $2a3ba7018817a2a8$export$c8e7c906983ea347, (v) => $2a3ba7018817a2a8$export$c8e7c906983ea347 = v);
var $2a3ba7018817a2a8$export$c8e7c906983ea347;
"use strict";
$2a3ba7018817a2a8$export$c8e7c906983ea347 = $2a3ba7018817a2a8$var$isThursday;

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $2a3ba7018817a2a8$var$isThursday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 4;
}


Object.keys($2a3ba7018817a2a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2a3ba7018817a2a8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2a3ba7018817a2a8$exports[key];
        }
    });
});
var $f574f3f9c5879b15$exports = {};

$parcel$export($f574f3f9c5879b15$exports, "isToday", () => $f574f3f9c5879b15$export$629b0a497aa65267, (v) => $f574f3f9c5879b15$export$629b0a497aa65267 = v);
var $f574f3f9c5879b15$export$629b0a497aa65267;
"use strict";
$f574f3f9c5879b15$export$629b0a497aa65267 = $f574f3f9c5879b15$var$isToday;


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $f574f3f9c5879b15$var$isToday(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date));
}


Object.keys($f574f3f9c5879b15$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f574f3f9c5879b15$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f574f3f9c5879b15$exports[key];
        }
    });
});
var $85ced2fb3637e354$exports = {};

$parcel$export($85ced2fb3637e354$exports, "isTomorrow", () => $85ced2fb3637e354$export$d6365ba92f0647f1, (v) => $85ced2fb3637e354$export$d6365ba92f0647f1 = v);
var $85ced2fb3637e354$export$d6365ba92f0647f1;
"use strict";
$85ced2fb3637e354$export$d6365ba92f0647f1 = $85ced2fb3637e354$var$isTomorrow;



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $85ced2fb3637e354$var$isTomorrow(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)((0, $d8623e255497753b$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($85ced2fb3637e354$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $85ced2fb3637e354$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $85ced2fb3637e354$exports[key];
        }
    });
});
var $909cc556808367c9$exports = {};

$parcel$export($909cc556808367c9$exports, "isTuesday", () => $909cc556808367c9$export$90d50b8f209f5ac3, (v) => $909cc556808367c9$export$90d50b8f209f5ac3 = v);
var $909cc556808367c9$export$90d50b8f209f5ac3;
"use strict";
$909cc556808367c9$export$90d50b8f209f5ac3 = $909cc556808367c9$var$isTuesday;

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $909cc556808367c9$var$isTuesday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 2;
}


Object.keys($909cc556808367c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $909cc556808367c9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $909cc556808367c9$exports[key];
        }
    });
});

Object.keys($f2a682b251363bc2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f2a682b251363bc2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f2a682b251363bc2$exports[key];
        }
    });
});
var $300bf3048a829507$exports = {};

$parcel$export($300bf3048a829507$exports, "isWednesday", () => $300bf3048a829507$export$ec9de642cdd62944, (v) => $300bf3048a829507$export$ec9de642cdd62944 = v);
var $300bf3048a829507$export$ec9de642cdd62944;
"use strict";
$300bf3048a829507$export$ec9de642cdd62944 = $300bf3048a829507$var$isWednesday;

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $300bf3048a829507$var$isWednesday(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getDay() === 3;
}


Object.keys($300bf3048a829507$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $300bf3048a829507$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $300bf3048a829507$exports[key];
        }
    });
});

Object.keys($126e0ee47695e680$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $126e0ee47695e680$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $126e0ee47695e680$exports[key];
        }
    });
});
var $9e26b76e988d89a9$exports = {};

$parcel$export($9e26b76e988d89a9$exports, "isWithinInterval", () => $9e26b76e988d89a9$export$d7deef7a3738e19d, (v) => $9e26b76e988d89a9$export$d7deef7a3738e19d = v);
var $9e26b76e988d89a9$export$d7deef7a3738e19d;
"use strict";
$9e26b76e988d89a9$export$d7deef7a3738e19d = $9e26b76e988d89a9$var$isWithinInterval;

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $9e26b76e988d89a9$var$isWithinInterval(date, interval) {
    const time = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const [startTime, endTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}


Object.keys($9e26b76e988d89a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9e26b76e988d89a9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9e26b76e988d89a9$exports[key];
        }
    });
});
var $01ed96ff4a2923d1$exports = {};

$parcel$export($01ed96ff4a2923d1$exports, "isYesterday", () => $01ed96ff4a2923d1$export$221990270ebfe867, (v) => $01ed96ff4a2923d1$export$221990270ebfe867 = v);
var $01ed96ff4a2923d1$export$221990270ebfe867;
"use strict";
$01ed96ff4a2923d1$export$221990270ebfe867 = $01ed96ff4a2923d1$var$isYesterday;


var $43790e1a97254ab3$exports = {};

$parcel$export($43790e1a97254ab3$exports, "subDays", () => $43790e1a97254ab3$export$70823084e2deb1ea, (v) => $43790e1a97254ab3$export$70823084e2deb1ea = v);
var $43790e1a97254ab3$export$70823084e2deb1ea;
"use strict";
$43790e1a97254ab3$export$70823084e2deb1ea = $43790e1a97254ab3$var$subDays;

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $43790e1a97254ab3$var$subDays(date, amount) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, -amount);
}


/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $01ed96ff4a2923d1$var$isYesterday(date) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $43790e1a97254ab3$export$70823084e2deb1ea)((0, $d8623e255497753b$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($01ed96ff4a2923d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $01ed96ff4a2923d1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $01ed96ff4a2923d1$exports[key];
        }
    });
});
var $60824d27a7e05259$exports = {};

$parcel$export($60824d27a7e05259$exports, "lastDayOfDecade", () => $60824d27a7e05259$export$2aaf6241f57dd605, (v) => $60824d27a7e05259$export$2aaf6241f57dd605 = v);
var $60824d27a7e05259$export$2aaf6241f57dd605;
"use strict";
$60824d27a7e05259$export$2aaf6241f57dd605 = $60824d27a7e05259$var$lastDayOfDecade;

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $60824d27a7e05259$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($60824d27a7e05259$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $60824d27a7e05259$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $60824d27a7e05259$exports[key];
        }
    });
});
var $33b9d09203a4d772$exports = {};

$parcel$export($33b9d09203a4d772$exports, "lastDayOfISOWeek", () => $33b9d09203a4d772$export$b08a8fc26ae6d94b, (v) => $33b9d09203a4d772$export$b08a8fc26ae6d94b = v);
var $33b9d09203a4d772$export$b08a8fc26ae6d94b;
"use strict";
$33b9d09203a4d772$export$b08a8fc26ae6d94b = $33b9d09203a4d772$var$lastDayOfISOWeek;
var $c99e3df3cf1d9686$exports = {};

$parcel$export($c99e3df3cf1d9686$exports, "lastDayOfWeek", () => $c99e3df3cf1d9686$export$b73502c35a293b0a, (v) => $c99e3df3cf1d9686$export$b73502c35a293b0a = v);
var $c99e3df3cf1d9686$export$b73502c35a293b0a;
"use strict";
$c99e3df3cf1d9686$export$b73502c35a293b0a = $c99e3df3cf1d9686$var$lastDayOfWeek;


/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $c99e3df3cf1d9686$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $33b9d09203a4d772$var$lastDayOfISOWeek(date) {
    return (0, $c99e3df3cf1d9686$export$b73502c35a293b0a)(date, {
        weekStartsOn: 1
    });
}


Object.keys($33b9d09203a4d772$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $33b9d09203a4d772$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $33b9d09203a4d772$exports[key];
        }
    });
});
var $f9abdbe2cf16ca3c$exports = {};

$parcel$export($f9abdbe2cf16ca3c$exports, "lastDayOfISOWeekYear", () => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1, (v) => $f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = v);
var $f9abdbe2cf16ca3c$export$1810bada8cd02ee1;
"use strict";
$f9abdbe2cf16ca3c$export$1810bada8cd02ee1 = $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear;



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $f9abdbe2cf16ca3c$var$lastDayOfISOWeekYear(date) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}


Object.keys($f9abdbe2cf16ca3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $f9abdbe2cf16ca3c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $f9abdbe2cf16ca3c$exports[key];
        }
    });
});

Object.keys($b94cbd258d877bc8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b94cbd258d877bc8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b94cbd258d877bc8$exports[key];
        }
    });
});
var $b03274799f21cdd8$exports = {};

$parcel$export($b03274799f21cdd8$exports, "lastDayOfQuarter", () => $b03274799f21cdd8$export$8693c04228304c7, (v) => $b03274799f21cdd8$export$8693c04228304c7 = v);
var $b03274799f21cdd8$export$8693c04228304c7;
"use strict";
$b03274799f21cdd8$export$8693c04228304c7 = $b03274799f21cdd8$var$lastDayOfQuarter;

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $b03274799f21cdd8$var$lastDayOfQuarter(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($b03274799f21cdd8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b03274799f21cdd8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b03274799f21cdd8$exports[key];
        }
    });
});

Object.keys($c99e3df3cf1d9686$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c99e3df3cf1d9686$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c99e3df3cf1d9686$exports[key];
        }
    });
});
var $46e16c3d8313f406$exports = {};

$parcel$export($46e16c3d8313f406$exports, "lastDayOfYear", () => $46e16c3d8313f406$export$323f7bc07b828bed, (v) => $46e16c3d8313f406$export$323f7bc07b828bed = v);
var $46e16c3d8313f406$export$323f7bc07b828bed;
"use strict";
$46e16c3d8313f406$export$323f7bc07b828bed = $46e16c3d8313f406$var$lastDayOfYear;

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $46e16c3d8313f406$var$lastDayOfYear(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($46e16c3d8313f406$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $46e16c3d8313f406$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $46e16c3d8313f406$exports[key];
        }
    });
});
var $ce37c5e4ac88a02b$exports = {};
"use strict";
$ce37c5e4ac88a02b$exports.lightFormat = $ce37c5e4ac88a02b$var$lightFormat;
Object.defineProperty($ce37c5e4ac88a02b$exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $71a5e81f1193b7a8$export$b0d4b338e1516f13;
    }
});



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $ce37c5e4ac88a02b$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $ce37c5e4ac88a02b$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $ce37c5e4ac88a02b$var$doubleQuoteRegExp = /''/g;
const $ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $ce37c5e4ac88a02b$var$lightFormat(date, formatStr) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($ce37c5e4ac88a02b$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $ce37c5e4ac88a02b$var$cleanEscapedString(substring);
        const formatter = $71a5e81f1193b7a8$export$b0d4b338e1516f13[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($ce37c5e4ac88a02b$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $ce37c5e4ac88a02b$var$cleanEscapedString(input) {
    const matches = input.match($ce37c5e4ac88a02b$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($ce37c5e4ac88a02b$var$doubleQuoteRegExp, "'");
}


Object.keys($ce37c5e4ac88a02b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ce37c5e4ac88a02b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ce37c5e4ac88a02b$exports[key];
        }
    });
});

Object.keys($b70baca84fc92b6d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b70baca84fc92b6d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b70baca84fc92b6d$exports[key];
        }
    });
});
var $97b365a16a43d25e$exports = {};

$parcel$export($97b365a16a43d25e$exports, "milliseconds", () => $97b365a16a43d25e$export$9a27fac83d67afd3, (v) => $97b365a16a43d25e$export$9a27fac83d67afd3 = v);
var $97b365a16a43d25e$export$9a27fac83d67afd3;
"use strict";
$97b365a16a43d25e$export$9a27fac83d67afd3 = $97b365a16a43d25e$var$milliseconds;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $97b365a16a43d25e$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $8540a44f59a4af84$export$3913210603d8e9ae;
    if (months) totalDays += months * ($8540a44f59a4af84$export$3913210603d8e9ae / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}


Object.keys($97b365a16a43d25e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $97b365a16a43d25e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $97b365a16a43d25e$exports[key];
        }
    });
});
var $a89c280122b57cc6$exports = {};

$parcel$export($a89c280122b57cc6$exports, "millisecondsToHours", () => $a89c280122b57cc6$export$689a412b29fa9ed5, (v) => $a89c280122b57cc6$export$689a412b29fa9ed5 = v);
var $a89c280122b57cc6$export$689a412b29fa9ed5;
"use strict";
$a89c280122b57cc6$export$689a412b29fa9ed5 = $a89c280122b57cc6$var$millisecondsToHours;

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $a89c280122b57cc6$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $8540a44f59a4af84$export$7f72910d6dfd237a;
    return Math.trunc(hours);
}


Object.keys($a89c280122b57cc6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a89c280122b57cc6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a89c280122b57cc6$exports[key];
        }
    });
});
var $9625f295f3161b5c$exports = {};

$parcel$export($9625f295f3161b5c$exports, "millisecondsToMinutes", () => $9625f295f3161b5c$export$a5f974e81e48cfc0, (v) => $9625f295f3161b5c$export$a5f974e81e48cfc0 = v);
var $9625f295f3161b5c$export$a5f974e81e48cfc0;
"use strict";
$9625f295f3161b5c$export$a5f974e81e48cfc0 = $9625f295f3161b5c$var$millisecondsToMinutes;

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $9625f295f3161b5c$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $8540a44f59a4af84$export$91246f0b9bd9beff;
    return Math.trunc(minutes);
}


Object.keys($9625f295f3161b5c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9625f295f3161b5c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9625f295f3161b5c$exports[key];
        }
    });
});
var $b31d11994e596a58$exports = {};

$parcel$export($b31d11994e596a58$exports, "millisecondsToSeconds", () => $b31d11994e596a58$export$f64c3bfbc58eec0f, (v) => $b31d11994e596a58$export$f64c3bfbc58eec0f = v);
var $b31d11994e596a58$export$f64c3bfbc58eec0f;
"use strict";
$b31d11994e596a58$export$f64c3bfbc58eec0f = $b31d11994e596a58$var$millisecondsToSeconds;

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $b31d11994e596a58$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $8540a44f59a4af84$export$397c2d5776aa9055;
    return Math.trunc(seconds);
}


Object.keys($b31d11994e596a58$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b31d11994e596a58$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b31d11994e596a58$exports[key];
        }
    });
});

Object.keys($5d373ce01680b655$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $5d373ce01680b655$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $5d373ce01680b655$exports[key];
        }
    });
});
var $56f58edd96e5b9ca$exports = {};

$parcel$export($56f58edd96e5b9ca$exports, "minutesToHours", () => $56f58edd96e5b9ca$export$815164eb42530ae7, (v) => $56f58edd96e5b9ca$export$815164eb42530ae7 = v);
var $56f58edd96e5b9ca$export$815164eb42530ae7;
"use strict";
$56f58edd96e5b9ca$export$815164eb42530ae7 = $56f58edd96e5b9ca$var$minutesToHours;

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $56f58edd96e5b9ca$var$minutesToHours(minutes) {
    const hours = minutes / $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f;
    return Math.trunc(hours);
}


Object.keys($56f58edd96e5b9ca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $56f58edd96e5b9ca$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $56f58edd96e5b9ca$exports[key];
        }
    });
});
var $0ad299455c4a7bce$exports = {};

$parcel$export($0ad299455c4a7bce$exports, "minutesToMilliseconds", () => $0ad299455c4a7bce$export$f6b9795ef9056e3d, (v) => $0ad299455c4a7bce$export$f6b9795ef9056e3d = v);
var $0ad299455c4a7bce$export$f6b9795ef9056e3d;
"use strict";
$0ad299455c4a7bce$export$f6b9795ef9056e3d = $0ad299455c4a7bce$var$minutesToMilliseconds;

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $0ad299455c4a7bce$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $8540a44f59a4af84$export$91246f0b9bd9beff);
}


Object.keys($0ad299455c4a7bce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0ad299455c4a7bce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0ad299455c4a7bce$exports[key];
        }
    });
});
var $94c410dcdc963b83$exports = {};

$parcel$export($94c410dcdc963b83$exports, "minutesToSeconds", () => $94c410dcdc963b83$export$81ded4628c655103, (v) => $94c410dcdc963b83$export$81ded4628c655103 = v);
var $94c410dcdc963b83$export$81ded4628c655103;
"use strict";
$94c410dcdc963b83$export$81ded4628c655103 = $94c410dcdc963b83$var$minutesToSeconds;

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $94c410dcdc963b83$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $8540a44f59a4af84$export$a77c1a7ebebe2a5a);
}


Object.keys($94c410dcdc963b83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $94c410dcdc963b83$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $94c410dcdc963b83$exports[key];
        }
    });
});
var $6cef6af716faa10c$exports = {};

$parcel$export($6cef6af716faa10c$exports, "monthsToQuarters", () => $6cef6af716faa10c$export$1932fa2a2068c849, (v) => $6cef6af716faa10c$export$1932fa2a2068c849 = v);
var $6cef6af716faa10c$export$1932fa2a2068c849;
"use strict";
$6cef6af716faa10c$export$1932fa2a2068c849 = $6cef6af716faa10c$var$monthsToQuarters;

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $6cef6af716faa10c$var$monthsToQuarters(months) {
    const quarters = months / $8540a44f59a4af84$export$3c58128db900d44e;
    return Math.trunc(quarters);
}


Object.keys($6cef6af716faa10c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6cef6af716faa10c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6cef6af716faa10c$exports[key];
        }
    });
});
var $7d031190fd4018fe$exports = {};

$parcel$export($7d031190fd4018fe$exports, "monthsToYears", () => $7d031190fd4018fe$export$7489026ed27fc925, (v) => $7d031190fd4018fe$export$7489026ed27fc925 = v);
var $7d031190fd4018fe$export$7489026ed27fc925;
"use strict";
$7d031190fd4018fe$export$7489026ed27fc925 = $7d031190fd4018fe$var$monthsToYears;

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $7d031190fd4018fe$var$monthsToYears(months) {
    const years = months / $8540a44f59a4af84$export$80d7e435f744f319;
    return Math.trunc(years);
}


Object.keys($7d031190fd4018fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7d031190fd4018fe$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7d031190fd4018fe$exports[key];
        }
    });
});
var $9f521a390e94151b$exports = {};

$parcel$export($9f521a390e94151b$exports, "nextDay", () => $9f521a390e94151b$export$992728922317ffc8, (v) => $9f521a390e94151b$export$992728922317ffc8 = v);
var $9f521a390e94151b$export$992728922317ffc8;
"use strict";
$9f521a390e94151b$export$992728922317ffc8 = $9f521a390e94151b$var$nextDay;


/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $9f521a390e94151b$var$nextDay(date, day) {
    let delta = day - (0, $bd335e725902b989$export$1b64bc9c5306ed54)(date);
    if (delta <= 0) delta += 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, delta);
}


Object.keys($9f521a390e94151b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9f521a390e94151b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9f521a390e94151b$exports[key];
        }
    });
});
var $bcfba8e94342fc2c$exports = {};

$parcel$export($bcfba8e94342fc2c$exports, "nextFriday", () => $bcfba8e94342fc2c$export$21d76934fce76327, (v) => $bcfba8e94342fc2c$export$21d76934fce76327 = v);
var $bcfba8e94342fc2c$export$21d76934fce76327;
"use strict";
$bcfba8e94342fc2c$export$21d76934fce76327 = $bcfba8e94342fc2c$var$nextFriday;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $bcfba8e94342fc2c$var$nextFriday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 5);
}


Object.keys($bcfba8e94342fc2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bcfba8e94342fc2c$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bcfba8e94342fc2c$exports[key];
        }
    });
});
var $c6f29a2a1ec58e88$exports = {};

$parcel$export($c6f29a2a1ec58e88$exports, "nextMonday", () => $c6f29a2a1ec58e88$export$a20373bb0df6efdd, (v) => $c6f29a2a1ec58e88$export$a20373bb0df6efdd = v);
var $c6f29a2a1ec58e88$export$a20373bb0df6efdd;
"use strict";
$c6f29a2a1ec58e88$export$a20373bb0df6efdd = $c6f29a2a1ec58e88$var$nextMonday;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $c6f29a2a1ec58e88$var$nextMonday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 1);
}


Object.keys($c6f29a2a1ec58e88$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c6f29a2a1ec58e88$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c6f29a2a1ec58e88$exports[key];
        }
    });
});
var $4d0e39fd7f19b345$exports = {};

$parcel$export($4d0e39fd7f19b345$exports, "nextSaturday", () => $4d0e39fd7f19b345$export$c52f069246f7b032, (v) => $4d0e39fd7f19b345$export$c52f069246f7b032 = v);
var $4d0e39fd7f19b345$export$c52f069246f7b032;
"use strict";
$4d0e39fd7f19b345$export$c52f069246f7b032 = $4d0e39fd7f19b345$var$nextSaturday;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $4d0e39fd7f19b345$var$nextSaturday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 6);
}


Object.keys($4d0e39fd7f19b345$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $4d0e39fd7f19b345$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $4d0e39fd7f19b345$exports[key];
        }
    });
});
var $758840c198612cbb$exports = {};

$parcel$export($758840c198612cbb$exports, "nextSunday", () => $758840c198612cbb$export$a30adaa3ef47f854, (v) => $758840c198612cbb$export$a30adaa3ef47f854 = v);
var $758840c198612cbb$export$a30adaa3ef47f854;
"use strict";
$758840c198612cbb$export$a30adaa3ef47f854 = $758840c198612cbb$var$nextSunday;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $758840c198612cbb$var$nextSunday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 0);
}


Object.keys($758840c198612cbb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $758840c198612cbb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $758840c198612cbb$exports[key];
        }
    });
});
var $cbaf36c74556d9ba$exports = {};

$parcel$export($cbaf36c74556d9ba$exports, "nextThursday", () => $cbaf36c74556d9ba$export$36d9a8523a98d5a4, (v) => $cbaf36c74556d9ba$export$36d9a8523a98d5a4 = v);
var $cbaf36c74556d9ba$export$36d9a8523a98d5a4;
"use strict";
$cbaf36c74556d9ba$export$36d9a8523a98d5a4 = $cbaf36c74556d9ba$var$nextThursday;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $cbaf36c74556d9ba$var$nextThursday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 4);
}


Object.keys($cbaf36c74556d9ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cbaf36c74556d9ba$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cbaf36c74556d9ba$exports[key];
        }
    });
});
var $2fbef82198987bdb$exports = {};

$parcel$export($2fbef82198987bdb$exports, "nextTuesday", () => $2fbef82198987bdb$export$391d63ff7dc2f668, (v) => $2fbef82198987bdb$export$391d63ff7dc2f668 = v);
var $2fbef82198987bdb$export$391d63ff7dc2f668;
"use strict";
$2fbef82198987bdb$export$391d63ff7dc2f668 = $2fbef82198987bdb$var$nextTuesday;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $2fbef82198987bdb$var$nextTuesday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 2);
}


Object.keys($2fbef82198987bdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $2fbef82198987bdb$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $2fbef82198987bdb$exports[key];
        }
    });
});
var $24bc8105eef6f180$exports = {};

$parcel$export($24bc8105eef6f180$exports, "nextWednesday", () => $24bc8105eef6f180$export$7a895c1ff204304e, (v) => $24bc8105eef6f180$export$7a895c1ff204304e = v);
var $24bc8105eef6f180$export$7a895c1ff204304e;
"use strict";
$24bc8105eef6f180$export$7a895c1ff204304e = $24bc8105eef6f180$var$nextWednesday;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $24bc8105eef6f180$var$nextWednesday(date) {
    return (0, $9f521a390e94151b$export$992728922317ffc8)(date, 3);
}


Object.keys($24bc8105eef6f180$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $24bc8105eef6f180$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $24bc8105eef6f180$exports[key];
        }
    });
});

Object.keys($8abb93379891fb3e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8abb93379891fb3e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8abb93379891fb3e$exports[key];
        }
    });
});
var $a92bacc669eda25d$exports = {};

$parcel$export($a92bacc669eda25d$exports, "parseISO", () => $a92bacc669eda25d$export$4393d2ccbbedb219, (v) => $a92bacc669eda25d$export$4393d2ccbbedb219 = v);
var $a92bacc669eda25d$export$4393d2ccbbedb219;
"use strict";
$a92bacc669eda25d$export$4393d2ccbbedb219 = $a92bacc669eda25d$var$parseISO;

/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $a92bacc669eda25d$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $8540a44f59a4af84$export$7f72910d6dfd237a + minutes * $8540a44f59a4af84$export$91246f0b9bd9beff);
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


Object.keys($a92bacc669eda25d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a92bacc669eda25d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a92bacc669eda25d$exports[key];
        }
    });
});
var $0e33dc44389cd7c6$exports = {};

$parcel$export($0e33dc44389cd7c6$exports, "parseJSON", () => $0e33dc44389cd7c6$export$27924e57e9afff7f, (v) => $0e33dc44389cd7c6$export$27924e57e9afff7f = v);
var $0e33dc44389cd7c6$export$27924e57e9afff7f;
"use strict";
$0e33dc44389cd7c6$export$27924e57e9afff7f = $0e33dc44389cd7c6$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $0e33dc44389cd7c6$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}


Object.keys($0e33dc44389cd7c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0e33dc44389cd7c6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0e33dc44389cd7c6$exports[key];
        }
    });
});
var $1bfa1f6b04020399$exports = {};

$parcel$export($1bfa1f6b04020399$exports, "previousDay", () => $1bfa1f6b04020399$export$4caccb62df4eacc0, (v) => $1bfa1f6b04020399$export$4caccb62df4eacc0 = v);
var $1bfa1f6b04020399$export$4caccb62df4eacc0;
"use strict";
$1bfa1f6b04020399$export$4caccb62df4eacc0 = $1bfa1f6b04020399$var$previousDay;


/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $1bfa1f6b04020399$var$previousDay(date, day) {
    let delta = (0, $bd335e725902b989$export$1b64bc9c5306ed54)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $43790e1a97254ab3$export$70823084e2deb1ea)(date, delta);
}


Object.keys($1bfa1f6b04020399$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1bfa1f6b04020399$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1bfa1f6b04020399$exports[key];
        }
    });
});
var $325dc36aced8b5fa$exports = {};

$parcel$export($325dc36aced8b5fa$exports, "previousFriday", () => $325dc36aced8b5fa$export$32d52646c338c11d, (v) => $325dc36aced8b5fa$export$32d52646c338c11d = v);
var $325dc36aced8b5fa$export$32d52646c338c11d;
"use strict";
$325dc36aced8b5fa$export$32d52646c338c11d = $325dc36aced8b5fa$var$previousFriday;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $325dc36aced8b5fa$var$previousFriday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 5);
}


Object.keys($325dc36aced8b5fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $325dc36aced8b5fa$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $325dc36aced8b5fa$exports[key];
        }
    });
});
var $ef6774db45a223ab$exports = {};

$parcel$export($ef6774db45a223ab$exports, "previousMonday", () => $ef6774db45a223ab$export$398437ab6f45c582, (v) => $ef6774db45a223ab$export$398437ab6f45c582 = v);
var $ef6774db45a223ab$export$398437ab6f45c582;
"use strict";
$ef6774db45a223ab$export$398437ab6f45c582 = $ef6774db45a223ab$var$previousMonday;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $ef6774db45a223ab$var$previousMonday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 1);
}


Object.keys($ef6774db45a223ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ef6774db45a223ab$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ef6774db45a223ab$exports[key];
        }
    });
});
var $95989668dcda1eb0$exports = {};

$parcel$export($95989668dcda1eb0$exports, "previousSaturday", () => $95989668dcda1eb0$export$36767a7e6101ecb0, (v) => $95989668dcda1eb0$export$36767a7e6101ecb0 = v);
var $95989668dcda1eb0$export$36767a7e6101ecb0;
"use strict";
$95989668dcda1eb0$export$36767a7e6101ecb0 = $95989668dcda1eb0$var$previousSaturday;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $95989668dcda1eb0$var$previousSaturday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 6);
}


Object.keys($95989668dcda1eb0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95989668dcda1eb0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95989668dcda1eb0$exports[key];
        }
    });
});
var $42fdcdff82108acf$exports = {};

$parcel$export($42fdcdff82108acf$exports, "previousSunday", () => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4, (v) => $42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = v);
var $42fdcdff82108acf$export$7d3d7d8fc5e81fd4;
"use strict";
$42fdcdff82108acf$export$7d3d7d8fc5e81fd4 = $42fdcdff82108acf$var$previousSunday;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $42fdcdff82108acf$var$previousSunday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 0);
}


Object.keys($42fdcdff82108acf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $42fdcdff82108acf$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $42fdcdff82108acf$exports[key];
        }
    });
});
var $d9be6ce747343891$exports = {};

$parcel$export($d9be6ce747343891$exports, "previousThursday", () => $d9be6ce747343891$export$1975b5b1f6b0e34e, (v) => $d9be6ce747343891$export$1975b5b1f6b0e34e = v);
var $d9be6ce747343891$export$1975b5b1f6b0e34e;
"use strict";
$d9be6ce747343891$export$1975b5b1f6b0e34e = $d9be6ce747343891$var$previousThursday;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $d9be6ce747343891$var$previousThursday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 4);
}


Object.keys($d9be6ce747343891$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d9be6ce747343891$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d9be6ce747343891$exports[key];
        }
    });
});
var $bf4153ed56fd16e2$exports = {};

$parcel$export($bf4153ed56fd16e2$exports, "previousTuesday", () => $bf4153ed56fd16e2$export$a034a75f093bcfaf, (v) => $bf4153ed56fd16e2$export$a034a75f093bcfaf = v);
var $bf4153ed56fd16e2$export$a034a75f093bcfaf;
"use strict";
$bf4153ed56fd16e2$export$a034a75f093bcfaf = $bf4153ed56fd16e2$var$previousTuesday;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $bf4153ed56fd16e2$var$previousTuesday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 2);
}


Object.keys($bf4153ed56fd16e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bf4153ed56fd16e2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bf4153ed56fd16e2$exports[key];
        }
    });
});
var $160a53e351bf91a7$exports = {};

$parcel$export($160a53e351bf91a7$exports, "previousWednesday", () => $160a53e351bf91a7$export$26334f591e4ce672, (v) => $160a53e351bf91a7$export$26334f591e4ce672 = v);
var $160a53e351bf91a7$export$26334f591e4ce672;
"use strict";
$160a53e351bf91a7$export$26334f591e4ce672 = $160a53e351bf91a7$var$previousWednesday;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $160a53e351bf91a7$var$previousWednesday(date) {
    return (0, $1bfa1f6b04020399$export$4caccb62df4eacc0)(date, 3);
}


Object.keys($160a53e351bf91a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $160a53e351bf91a7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $160a53e351bf91a7$exports[key];
        }
    });
});
var $17537f6141548b99$exports = {};

$parcel$export($17537f6141548b99$exports, "quartersToMonths", () => $17537f6141548b99$export$a29d19ce21d74c57, (v) => $17537f6141548b99$export$a29d19ce21d74c57 = v);
var $17537f6141548b99$export$a29d19ce21d74c57;
"use strict";
$17537f6141548b99$export$a29d19ce21d74c57 = $17537f6141548b99$var$quartersToMonths;

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $17537f6141548b99$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $8540a44f59a4af84$export$3c58128db900d44e);
}


Object.keys($17537f6141548b99$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $17537f6141548b99$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $17537f6141548b99$exports[key];
        }
    });
});
var $1d29c198f18d87e1$exports = {};

$parcel$export($1d29c198f18d87e1$exports, "quartersToYears", () => $1d29c198f18d87e1$export$c309fa8f184b4648, (v) => $1d29c198f18d87e1$export$c309fa8f184b4648 = v);
var $1d29c198f18d87e1$export$c309fa8f184b4648;
"use strict";
$1d29c198f18d87e1$export$c309fa8f184b4648 = $1d29c198f18d87e1$var$quartersToYears;

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $1d29c198f18d87e1$var$quartersToYears(quarters) {
    const years = quarters / $8540a44f59a4af84$export$4db7641526e3241f;
    return Math.trunc(years);
}


Object.keys($1d29c198f18d87e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1d29c198f18d87e1$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1d29c198f18d87e1$exports[key];
        }
    });
});
var $fa663ccbe744c7f5$exports = {};

$parcel$export($fa663ccbe744c7f5$exports, "roundToNearestHours", () => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2, (v) => $fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = v);
var $fa663ccbe744c7f5$export$a8b87649ebc0e3c2;
"use strict";
$fa663ccbe744c7f5$export$a8b87649ebc0e3c2 = $fa663ccbe744c7f5$var$roundToNearestHours;



/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $fa663ccbe744c7f5$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}


Object.keys($fa663ccbe744c7f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fa663ccbe744c7f5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fa663ccbe744c7f5$exports[key];
        }
    });
});
var $9d05b0f997098e6a$exports = {};

$parcel$export($9d05b0f997098e6a$exports, "roundToNearestMinutes", () => $9d05b0f997098e6a$export$d97410bb8cd0dff, (v) => $9d05b0f997098e6a$export$d97410bb8cd0dff = v);
var $9d05b0f997098e6a$export$d97410bb8cd0dff;
"use strict";
$9d05b0f997098e6a$export$d97410bb8cd0dff = $9d05b0f997098e6a$var$roundToNearestMinutes;



/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $9d05b0f997098e6a$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $495af4000bb18bf7$export$b6474a47258c1211)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}


Object.keys($9d05b0f997098e6a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9d05b0f997098e6a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9d05b0f997098e6a$exports[key];
        }
    });
});
var $95674078571389b0$exports = {};

$parcel$export($95674078571389b0$exports, "secondsToHours", () => $95674078571389b0$export$47d555ff5354096f, (v) => $95674078571389b0$export$47d555ff5354096f = v);
var $95674078571389b0$export$47d555ff5354096f;
"use strict";
$95674078571389b0$export$47d555ff5354096f = $95674078571389b0$var$secondsToHours;

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $95674078571389b0$var$secondsToHours(seconds) {
    const hours = seconds / $8540a44f59a4af84$export$698aec755e92c695;
    return Math.trunc(hours);
}


Object.keys($95674078571389b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $95674078571389b0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $95674078571389b0$exports[key];
        }
    });
});
var $bccd0254996c4544$exports = {};

$parcel$export($bccd0254996c4544$exports, "secondsToMilliseconds", () => $bccd0254996c4544$export$fc3e7e8557f8c8c7, (v) => $bccd0254996c4544$export$fc3e7e8557f8c8c7 = v);
var $bccd0254996c4544$export$fc3e7e8557f8c8c7;
"use strict";
$bccd0254996c4544$export$fc3e7e8557f8c8c7 = $bccd0254996c4544$var$secondsToMilliseconds;

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $bccd0254996c4544$var$secondsToMilliseconds(seconds) {
    return seconds * $8540a44f59a4af84$export$397c2d5776aa9055;
}


Object.keys($bccd0254996c4544$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $bccd0254996c4544$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $bccd0254996c4544$exports[key];
        }
    });
});
var $c88c346e362dfbe8$exports = {};

$parcel$export($c88c346e362dfbe8$exports, "secondsToMinutes", () => $c88c346e362dfbe8$export$ed657adb62398e99, (v) => $c88c346e362dfbe8$export$ed657adb62398e99 = v);
var $c88c346e362dfbe8$export$ed657adb62398e99;
"use strict";
$c88c346e362dfbe8$export$ed657adb62398e99 = $c88c346e362dfbe8$var$secondsToMinutes;

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $c88c346e362dfbe8$var$secondsToMinutes(seconds) {
    const minutes = seconds / $8540a44f59a4af84$export$a77c1a7ebebe2a5a;
    return Math.trunc(minutes);
}


Object.keys($c88c346e362dfbe8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c88c346e362dfbe8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c88c346e362dfbe8$exports[key];
        }
    });
});
var $e8b97269a8745db5$exports = {};

$parcel$export($e8b97269a8745db5$exports, "set", () => $e8b97269a8745db5$export$adaa4cf7ef1b65be, (v) => $e8b97269a8745db5$export$adaa4cf7ef1b65be = v);
var $e8b97269a8745db5$export$adaa4cf7ef1b65be;
"use strict";
$e8b97269a8745db5$export$adaa4cf7ef1b65be = $e8b97269a8745db5$var$set;

var $16856745969af5fc$exports = {};

$parcel$export($16856745969af5fc$exports, "setMonth", () => $16856745969af5fc$export$63264690f8e36790, (v) => $16856745969af5fc$export$63264690f8e36790 = v);
var $16856745969af5fc$export$63264690f8e36790;
"use strict";
$16856745969af5fc$export$63264690f8e36790 = $16856745969af5fc$var$setMonth;



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $16856745969af5fc$var$setMonth(date, month) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $57397b9e44500b87$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}



/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $e8b97269a8745db5$var$set(date, values) {
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $16856745969af5fc$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}


Object.keys($e8b97269a8745db5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e8b97269a8745db5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e8b97269a8745db5$exports[key];
        }
    });
});
var $e4a235b7a447c4f0$exports = {};

$parcel$export($e4a235b7a447c4f0$exports, "setDate", () => $e4a235b7a447c4f0$export$566174fa40823587, (v) => $e4a235b7a447c4f0$export$566174fa40823587 = v);
var $e4a235b7a447c4f0$export$566174fa40823587;
"use strict";
$e4a235b7a447c4f0$export$566174fa40823587 = $e4a235b7a447c4f0$var$setDate;

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e4a235b7a447c4f0$var$setDate(date, dayOfMonth) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setDate(dayOfMonth);
    return _date;
}


Object.keys($e4a235b7a447c4f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $e4a235b7a447c4f0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $e4a235b7a447c4f0$exports[key];
        }
    });
});

Object.keys($13939a537621d91b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $13939a537621d91b$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $13939a537621d91b$exports[key];
        }
    });
});
var $21ddf0eaefea752e$exports = {};

$parcel$export($21ddf0eaefea752e$exports, "setDayOfYear", () => $21ddf0eaefea752e$export$2af590ffc7e7d7c5, (v) => $21ddf0eaefea752e$export$2af590ffc7e7d7c5 = v);
var $21ddf0eaefea752e$export$2af590ffc7e7d7c5;
"use strict";
$21ddf0eaefea752e$export$2af590ffc7e7d7c5 = $21ddf0eaefea752e$var$setDayOfYear;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $21ddf0eaefea752e$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


Object.keys($21ddf0eaefea752e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $21ddf0eaefea752e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $21ddf0eaefea752e$exports[key];
        }
    });
});
var $41d9aae4fa20420d$exports = {};

$parcel$export($41d9aae4fa20420d$exports, "setDefaultOptions", () => $41d9aae4fa20420d$export$95365be1b0704abc, (v) => $41d9aae4fa20420d$export$95365be1b0704abc = v);
var $41d9aae4fa20420d$export$95365be1b0704abc;
"use strict";
$41d9aae4fa20420d$export$95365be1b0704abc = $41d9aae4fa20420d$var$setDefaultOptions;

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $41d9aae4fa20420d$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $39440020b58e1ef8$export$95365be1b0704abc)(result);
}


Object.keys($41d9aae4fa20420d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $41d9aae4fa20420d$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $41d9aae4fa20420d$exports[key];
        }
    });
});
var $612758c85246c1d0$exports = {};

$parcel$export($612758c85246c1d0$exports, "setHours", () => $612758c85246c1d0$export$f86b797a4659b781, (v) => $612758c85246c1d0$export$f86b797a4659b781 = v);
var $612758c85246c1d0$export$f86b797a4659b781;
"use strict";
$612758c85246c1d0$export$f86b797a4659b781 = $612758c85246c1d0$var$setHours;

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $612758c85246c1d0$var$setHours(date, hours) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setHours(hours);
    return _date;
}


Object.keys($612758c85246c1d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $612758c85246c1d0$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $612758c85246c1d0$exports[key];
        }
    });
});

Object.keys($87a68208fbd57247$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $87a68208fbd57247$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $87a68208fbd57247$exports[key];
        }
    });
});

Object.keys($d0815b4ed45bc80a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d0815b4ed45bc80a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d0815b4ed45bc80a$exports[key];
        }
    });
});

Object.keys($a1a2df6fabe9eb62$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a1a2df6fabe9eb62$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a1a2df6fabe9eb62$exports[key];
        }
    });
});
var $db2197e0fa774070$exports = {};

$parcel$export($db2197e0fa774070$exports, "setMilliseconds", () => $db2197e0fa774070$export$de5664029b35e06d, (v) => $db2197e0fa774070$export$de5664029b35e06d = v);
var $db2197e0fa774070$export$de5664029b35e06d;
"use strict";
$db2197e0fa774070$export$de5664029b35e06d = $db2197e0fa774070$var$setMilliseconds;

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $db2197e0fa774070$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}


Object.keys($db2197e0fa774070$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $db2197e0fa774070$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $db2197e0fa774070$exports[key];
        }
    });
});
var $089730068462d950$exports = {};

$parcel$export($089730068462d950$exports, "setMinutes", () => $089730068462d950$export$ad569bf1c79ea89d, (v) => $089730068462d950$export$ad569bf1c79ea89d = v);
var $089730068462d950$export$ad569bf1c79ea89d;
"use strict";
$089730068462d950$export$ad569bf1c79ea89d = $089730068462d950$var$setMinutes;

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $089730068462d950$var$setMinutes(date, minutes) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setMinutes(minutes);
    return _date;
}


Object.keys($089730068462d950$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $089730068462d950$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $089730068462d950$exports[key];
        }
    });
});

Object.keys($16856745969af5fc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $16856745969af5fc$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $16856745969af5fc$exports[key];
        }
    });
});
var $a0d14eadad6d8ea7$exports = {};

$parcel$export($a0d14eadad6d8ea7$exports, "setQuarter", () => $a0d14eadad6d8ea7$export$8924d1de7efe1755, (v) => $a0d14eadad6d8ea7$export$8924d1de7efe1755 = v);
var $a0d14eadad6d8ea7$export$8924d1de7efe1755;
"use strict";
$a0d14eadad6d8ea7$export$8924d1de7efe1755 = $a0d14eadad6d8ea7$var$setQuarter;


/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $a0d14eadad6d8ea7$var$setQuarter(date, quarter) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $16856745969af5fc$export$63264690f8e36790)(_date, _date.getMonth() + diff * 3);
}


Object.keys($a0d14eadad6d8ea7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a0d14eadad6d8ea7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a0d14eadad6d8ea7$exports[key];
        }
    });
});
var $af19e5fb9b37deaf$exports = {};

$parcel$export($af19e5fb9b37deaf$exports, "setSeconds", () => $af19e5fb9b37deaf$export$aec44746644cbf43, (v) => $af19e5fb9b37deaf$export$aec44746644cbf43 = v);
var $af19e5fb9b37deaf$export$aec44746644cbf43;
"use strict";
$af19e5fb9b37deaf$export$aec44746644cbf43 = $af19e5fb9b37deaf$var$setSeconds;

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $af19e5fb9b37deaf$var$setSeconds(date, seconds) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    _date.setSeconds(seconds);
    return _date;
}


Object.keys($af19e5fb9b37deaf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $af19e5fb9b37deaf$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $af19e5fb9b37deaf$exports[key];
        }
    });
});

Object.keys($66c7729eb95aa501$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $66c7729eb95aa501$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $66c7729eb95aa501$exports[key];
        }
    });
});
var $cff5bf5fa0193e74$exports = {};

$parcel$export($cff5bf5fa0193e74$exports, "setWeekYear", () => $cff5bf5fa0193e74$export$4340968d5939835e, (v) => $cff5bf5fa0193e74$export$4340968d5939835e = v);
var $cff5bf5fa0193e74$export$4340968d5939835e;
"use strict";
$cff5bf5fa0193e74$export$4340968d5939835e = $cff5bf5fa0193e74$var$setWeekYear;





/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $cff5bf5fa0193e74$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options));
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


Object.keys($cff5bf5fa0193e74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cff5bf5fa0193e74$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cff5bf5fa0193e74$exports[key];
        }
    });
});
var $529c31b1ede64581$exports = {};

$parcel$export($529c31b1ede64581$exports, "setYear", () => $529c31b1ede64581$export$a8408b6c5639cab7, (v) => $529c31b1ede64581$export$a8408b6c5639cab7 = v);
var $529c31b1ede64581$export$a8408b6c5639cab7;
"use strict";
$529c31b1ede64581$export$a8408b6c5639cab7 = $529c31b1ede64581$var$setYear;


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $529c31b1ede64581$var$setYear(date, year) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, NaN);
    _date.setFullYear(year);
    return _date;
}


Object.keys($529c31b1ede64581$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $529c31b1ede64581$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $529c31b1ede64581$exports[key];
        }
    });
});

Object.keys($b6caff0bf13dcaf5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $b6caff0bf13dcaf5$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $b6caff0bf13dcaf5$exports[key];
        }
    });
});
var $27d7623072841c9e$exports = {};

$parcel$export($27d7623072841c9e$exports, "startOfDecade", () => $27d7623072841c9e$export$730492981c634308, (v) => $27d7623072841c9e$export$730492981c634308 = v);
var $27d7623072841c9e$export$730492981c634308;
"use strict";
$27d7623072841c9e$export$730492981c634308 = $27d7623072841c9e$var$startOfDecade;

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $27d7623072841c9e$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($27d7623072841c9e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $27d7623072841c9e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $27d7623072841c9e$exports[key];
        }
    });
});

Object.keys($d153613108f3ff12$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d153613108f3ff12$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d153613108f3ff12$exports[key];
        }
    });
});

Object.keys($1c9d32c6cb108460$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1c9d32c6cb108460$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1c9d32c6cb108460$exports[key];
        }
    });
});

Object.keys($3b2e6199275b27d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3b2e6199275b27d6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3b2e6199275b27d6$exports[key];
        }
    });
});

Object.keys($d1ad424e56672364$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $d1ad424e56672364$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $d1ad424e56672364$exports[key];
        }
    });
});

Object.keys($c0b4ec5551eca4c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c0b4ec5551eca4c9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c0b4ec5551eca4c9$exports[key];
        }
    });
});

Object.keys($c922a15e7d8774a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c922a15e7d8774a7$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c922a15e7d8774a7$exports[key];
        }
    });
});

Object.keys($fec0f854199fab32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fec0f854199fab32$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fec0f854199fab32$exports[key];
        }
    });
});
var $1d1c05f420cd3819$exports = {};

$parcel$export($1d1c05f420cd3819$exports, "startOfToday", () => $1d1c05f420cd3819$export$444d742fd5a45a57, (v) => $1d1c05f420cd3819$export$444d742fd5a45a57 = v);
var $1d1c05f420cd3819$export$444d742fd5a45a57;
"use strict";
$1d1c05f420cd3819$export$444d742fd5a45a57 = $1d1c05f420cd3819$var$startOfToday;

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $1d1c05f420cd3819$var$startOfToday() {
    return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(Date.now());
}


Object.keys($1d1c05f420cd3819$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $1d1c05f420cd3819$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $1d1c05f420cd3819$exports[key];
        }
    });
});
var $cc76f6b1bb5f55ce$exports = {};

$parcel$export($cc76f6b1bb5f55ce$exports, "startOfTomorrow", () => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07, (v) => $cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = v);
var $cc76f6b1bb5f55ce$export$7e8566c79d5bee07;
"use strict";
$cc76f6b1bb5f55ce$export$7e8566c79d5bee07 = $cc76f6b1bb5f55ce$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $cc76f6b1bb5f55ce$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($cc76f6b1bb5f55ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cc76f6b1bb5f55ce$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cc76f6b1bb5f55ce$exports[key];
        }
    });
});

Object.keys($61f11f7a26b3ab78$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $61f11f7a26b3ab78$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $61f11f7a26b3ab78$exports[key];
        }
    });
});

Object.keys($ac7640a7ade5a435$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ac7640a7ade5a435$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ac7640a7ade5a435$exports[key];
        }
    });
});

Object.keys($29cc086f79701cd9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $29cc086f79701cd9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $29cc086f79701cd9$exports[key];
        }
    });
});
var $cd81ad9ec468f6b4$exports = {};

$parcel$export($cd81ad9ec468f6b4$exports, "startOfYesterday", () => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9, (v) => $cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = v);
var $cd81ad9ec468f6b4$export$23a16f3c6d143ce9;
"use strict";
$cd81ad9ec468f6b4$export$23a16f3c6d143ce9 = $cd81ad9ec468f6b4$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $cd81ad9ec468f6b4$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($cd81ad9ec468f6b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $cd81ad9ec468f6b4$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $cd81ad9ec468f6b4$exports[key];
        }
    });
});
var $7aeb261fe061928a$exports = {};

$parcel$export($7aeb261fe061928a$exports, "sub", () => $7aeb261fe061928a$export$f93b5905241a7cca, (v) => $7aeb261fe061928a$export$f93b5905241a7cca = v);
var $7aeb261fe061928a$export$f93b5905241a7cca;
"use strict";
$7aeb261fe061928a$export$f93b5905241a7cca = $7aeb261fe061928a$var$sub;

var $c5e772d389bae063$exports = {};

$parcel$export($c5e772d389bae063$exports, "subMonths", () => $c5e772d389bae063$export$73d1c15a21f9fae5, (v) => $c5e772d389bae063$export$73d1c15a21f9fae5 = v);
var $c5e772d389bae063$export$73d1c15a21f9fae5;
"use strict";
$c5e772d389bae063$export$73d1c15a21f9fae5 = $c5e772d389bae063$var$subMonths;

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c5e772d389bae063$var$subMonths(date, amount) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, -amount);
}



/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $7aeb261fe061928a$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $c5e772d389bae063$export$73d1c15a21f9fae5)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $43790e1a97254ab3$export$70823084e2deb1ea)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}


Object.keys($7aeb261fe061928a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7aeb261fe061928a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7aeb261fe061928a$exports[key];
        }
    });
});
var $3c688c7c0e30b622$exports = {};

$parcel$export($3c688c7c0e30b622$exports, "subBusinessDays", () => $3c688c7c0e30b622$export$e5cc51ae28664a93, (v) => $3c688c7c0e30b622$export$e5cc51ae28664a93 = v);
var $3c688c7c0e30b622$export$e5cc51ae28664a93;
"use strict";
$3c688c7c0e30b622$export$e5cc51ae28664a93 = $3c688c7c0e30b622$var$subBusinessDays;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $3c688c7c0e30b622$var$subBusinessDays(date, amount) {
    return (0, $370ee6dc5d0513ee$export$f087b9ada3136ae9)(date, -amount);
}


Object.keys($3c688c7c0e30b622$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $3c688c7c0e30b622$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $3c688c7c0e30b622$exports[key];
        }
    });
});

Object.keys($43790e1a97254ab3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $43790e1a97254ab3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $43790e1a97254ab3$exports[key];
        }
    });
});
var $c1e1b7960398f22a$exports = {};

$parcel$export($c1e1b7960398f22a$exports, "subHours", () => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71, (v) => $c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = v);
var $c1e1b7960398f22a$export$5e9fa51cd5bb1e71;
"use strict";
$c1e1b7960398f22a$export$5e9fa51cd5bb1e71 = $c1e1b7960398f22a$var$subHours;

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $c1e1b7960398f22a$var$subHours(date, amount) {
    return (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(date, -amount);
}


Object.keys($c1e1b7960398f22a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c1e1b7960398f22a$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c1e1b7960398f22a$exports[key];
        }
    });
});

Object.keys($0ee59b8ff17647f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0ee59b8ff17647f3$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0ee59b8ff17647f3$exports[key];
        }
    });
});
var $9cfaf2369322ee51$exports = {};

$parcel$export($9cfaf2369322ee51$exports, "subMilliseconds", () => $9cfaf2369322ee51$export$5abaf57ab8e91640, (v) => $9cfaf2369322ee51$export$5abaf57ab8e91640 = v);
var $9cfaf2369322ee51$export$5abaf57ab8e91640;
"use strict";
$9cfaf2369322ee51$export$5abaf57ab8e91640 = $9cfaf2369322ee51$var$subMilliseconds;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $9cfaf2369322ee51$var$subMilliseconds(date, amount) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, -amount);
}


Object.keys($9cfaf2369322ee51$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $9cfaf2369322ee51$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $9cfaf2369322ee51$exports[key];
        }
    });
});
var $a8bc0e11c60ff399$exports = {};

$parcel$export($a8bc0e11c60ff399$exports, "subMinutes", () => $a8bc0e11c60ff399$export$e12a970efb73fce5, (v) => $a8bc0e11c60ff399$export$e12a970efb73fce5 = v);
var $a8bc0e11c60ff399$export$e12a970efb73fce5;
"use strict";
$a8bc0e11c60ff399$export$e12a970efb73fce5 = $a8bc0e11c60ff399$var$subMinutes;

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $a8bc0e11c60ff399$var$subMinutes(date, amount) {
    return (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(date, -amount);
}


Object.keys($a8bc0e11c60ff399$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a8bc0e11c60ff399$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a8bc0e11c60ff399$exports[key];
        }
    });
});

Object.keys($c5e772d389bae063$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $c5e772d389bae063$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $c5e772d389bae063$exports[key];
        }
    });
});
var $8013f48d32fc8fb9$exports = {};

$parcel$export($8013f48d32fc8fb9$exports, "subQuarters", () => $8013f48d32fc8fb9$export$a31bfeeeee80cce6, (v) => $8013f48d32fc8fb9$export$a31bfeeeee80cce6 = v);
var $8013f48d32fc8fb9$export$a31bfeeeee80cce6;
"use strict";
$8013f48d32fc8fb9$export$a31bfeeeee80cce6 = $8013f48d32fc8fb9$var$subQuarters;

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $8013f48d32fc8fb9$var$subQuarters(date, amount) {
    return (0, $30e5a3aa581ecd23$export$c252a41d0fbed2ce)(date, -amount);
}


Object.keys($8013f48d32fc8fb9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $8013f48d32fc8fb9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $8013f48d32fc8fb9$exports[key];
        }
    });
});
var $ad6954495f71f731$exports = {};

$parcel$export($ad6954495f71f731$exports, "subSeconds", () => $ad6954495f71f731$export$e95d8ad9981db689, (v) => $ad6954495f71f731$export$e95d8ad9981db689 = v);
var $ad6954495f71f731$export$e95d8ad9981db689;
"use strict";
$ad6954495f71f731$export$e95d8ad9981db689 = $ad6954495f71f731$var$subSeconds;

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $ad6954495f71f731$var$subSeconds(date, amount) {
    return (0, $ec74b6b01c6372f4$export$3cb31b0df13be68)(date, -amount);
}


Object.keys($ad6954495f71f731$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $ad6954495f71f731$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $ad6954495f71f731$exports[key];
        }
    });
});
var $065494b4a3debec8$exports = {};

$parcel$export($065494b4a3debec8$exports, "subWeeks", () => $065494b4a3debec8$export$b4d8ae6376193efb, (v) => $065494b4a3debec8$export$b4d8ae6376193efb = v);
var $065494b4a3debec8$export$b4d8ae6376193efb;
"use strict";
$065494b4a3debec8$export$b4d8ae6376193efb = $065494b4a3debec8$var$subWeeks;

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $065494b4a3debec8$var$subWeeks(date, amount) {
    return (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(date, -amount);
}


Object.keys($065494b4a3debec8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $065494b4a3debec8$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $065494b4a3debec8$exports[key];
        }
    });
});
var $7e3d370a917aaad9$exports = {};

$parcel$export($7e3d370a917aaad9$exports, "subYears", () => $7e3d370a917aaad9$export$14867687ff6c92e2, (v) => $7e3d370a917aaad9$export$14867687ff6c92e2 = v);
var $7e3d370a917aaad9$export$14867687ff6c92e2;
"use strict";
$7e3d370a917aaad9$export$14867687ff6c92e2 = $7e3d370a917aaad9$var$subYears;

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $7e3d370a917aaad9$var$subYears(date, amount) {
    return (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(date, -amount);
}


Object.keys($7e3d370a917aaad9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $7e3d370a917aaad9$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $7e3d370a917aaad9$exports[key];
        }
    });
});

Object.keys($231bfb8d72679740$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $231bfb8d72679740$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $231bfb8d72679740$exports[key];
        }
    });
});

Object.keys($59425df5ba0b4bea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $59425df5ba0b4bea$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $59425df5ba0b4bea$exports[key];
        }
    });
});
var $fd3f20e3d132724e$exports = {};

$parcel$export($fd3f20e3d132724e$exports, "weeksToDays", () => $fd3f20e3d132724e$export$b696b6eeb89501ad, (v) => $fd3f20e3d132724e$export$b696b6eeb89501ad = v);
var $fd3f20e3d132724e$export$b696b6eeb89501ad;
"use strict";
$fd3f20e3d132724e$export$b696b6eeb89501ad = $fd3f20e3d132724e$var$weeksToDays;

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $fd3f20e3d132724e$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $8540a44f59a4af84$export$dfd9b671c89acc8e);
}


Object.keys($fd3f20e3d132724e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $fd3f20e3d132724e$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $fd3f20e3d132724e$exports[key];
        }
    });
});
var $6ccc2e60f33c92b2$exports = {};

$parcel$export($6ccc2e60f33c92b2$exports, "yearsToDays", () => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17, (v) => $6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = v);
var $6ccc2e60f33c92b2$export$862cb7b6e45c3b17;
"use strict";
$6ccc2e60f33c92b2$export$862cb7b6e45c3b17 = $6ccc2e60f33c92b2$var$yearsToDays;

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $6ccc2e60f33c92b2$var$yearsToDays(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$3913210603d8e9ae);
}


Object.keys($6ccc2e60f33c92b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $6ccc2e60f33c92b2$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $6ccc2e60f33c92b2$exports[key];
        }
    });
});
var $a6974b8bd1359f14$exports = {};

$parcel$export($a6974b8bd1359f14$exports, "yearsToMonths", () => $a6974b8bd1359f14$export$894abb0747b9a00, (v) => $a6974b8bd1359f14$export$894abb0747b9a00 = v);
var $a6974b8bd1359f14$export$894abb0747b9a00;
"use strict";
$a6974b8bd1359f14$export$894abb0747b9a00 = $a6974b8bd1359f14$var$yearsToMonths;

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $a6974b8bd1359f14$var$yearsToMonths(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$80d7e435f744f319);
}


Object.keys($a6974b8bd1359f14$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $a6974b8bd1359f14$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $a6974b8bd1359f14$exports[key];
        }
    });
});
var $0d4589c309e08ad6$exports = {};

$parcel$export($0d4589c309e08ad6$exports, "yearsToQuarters", () => $0d4589c309e08ad6$export$ab26576e5e7379d7, (v) => $0d4589c309e08ad6$export$ab26576e5e7379d7 = v);
var $0d4589c309e08ad6$export$ab26576e5e7379d7;
"use strict";
$0d4589c309e08ad6$export$ab26576e5e7379d7 = $0d4589c309e08ad6$var$yearsToQuarters;

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $0d4589c309e08ad6$var$yearsToQuarters(years) {
    return Math.trunc(years * $8540a44f59a4af84$export$4db7641526e3241f);
}


Object.keys($0d4589c309e08ad6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5b2b72156d2e39b5$exports && $5b2b72156d2e39b5$exports[key] === $0d4589c309e08ad6$exports[key]) return;
    Object.defineProperty($5b2b72156d2e39b5$exports, key, {
        enumerable: true,
        get: function() {
            return $0d4589c309e08ad6$exports[key];
        }
    });
});


const $bb27324e6828f86a$export$b135c3f9b9f02308 = (value)=>{
    if (!value.trim()) return "Required";
    if (/[\d]/.test(value)) return "This field cannot contain numbers";
    if (!/^[a-zA-Z'.`\-\s]*$/.test(value)) return "This field cannot contain special characters";
    if (value.length > 50) return "Max 50 characters allowed";
    return "";
};
const $bb27324e6828f86a$export$8121e75625944277 = (value)=>{
    if (!value.trim()) return "Required";
    if (value.length > 1000) return "Max 1000 characters allowed";
    return "";
};
const $bb27324e6828f86a$export$8dd4b0e4422ae2b0 = (value)=>{
    return !value.trim() ? "Required" : "";
};
const $bb27324e6828f86a$export$5af8a774f7f1c688 = (value)=>{
    if (!value.trim()) return "Required";
    if (!/^\d{5}(-\d{4})?$/.test(value)) return "Please enter a valid zipcode";
    return "";
};
const $bb27324e6828f86a$export$30dc0b291f505e34 = (value, phoneNumbers)=>{
    if (phoneNumbers.length === 0 && !value.trim()) return "Required";
    if (!/^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/.test(value)) return "Please enter a valid US phone number";
    return "";
};
const $bb27324e6828f86a$export$18148d12c805c5b0 = (value)=>{
    if (!value.trim()) return "Required";
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (!pattern.test(value)) return "Please enter a valid email address";
    return "";
};
const $bb27324e6828f86a$export$8cea6d1b8d887c4a = (value)=>{
    if (!/^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/.test(value)) return "Please enter a valid US phone number";
    return "";
};
const $bb27324e6828f86a$export$8e0e3fe6ebe44386 = (value)=>{
    if (/[\d]/.test(value)) return "This field cannot contain numbers";
    else if (!/^[a-zA-Z'.`\-\s]*$/.test(value)) return "This field cannot contain special characters";
    return "";
};
const $bb27324e6828f86a$export$cf05cbdc7a879c7b = (value)=>{
    if (!value.trim()) return "Required";
    if (value.length > 50) return "Max 50 characters allowed";
    return "";
};
const $bb27324e6828f86a$export$33e4322173c2e267 = (states)=>states.map((state)=>({
            value: state,
            label: state
        }));
const $bb27324e6828f86a$export$ff3c7f15a3732912 = (addresses)=>addresses?.map((address)=>({
            value: address?.organizationId,
            label: `${address.dba}, ${address.line1}${address.line2 ? ` ${address.line2}` : ''}, ${address.city}, ${address.state}, ${address.zip}`
        }));
const $bb27324e6828f86a$export$e5ef670d70906d8e = (value, userStatus)=>{
    // Strictly parse MM/DD/YYYY
    const date = (0, $5b2b72156d2e39b5$exports.parse)(value, "MM/dd/yyyy", new Date());
    if (!(0, $5b2b72156d2e39b5$exports.isValid)(date)) return "Please enter a valid expiration date in the format MM/DD/YYYY";
    if (userStatus === "ACTIVE") {
        const today = (0, $5b2b72156d2e39b5$exports.startOfDay)(new Date());
        if (!(0, $5b2b72156d2e39b5$exports.isAfter)(date, today)) return "Please enter a future date.";
    }
    return "";
};
const $bb27324e6828f86a$var$HINPattern = new RegExp("^[a-zA-Z0-9]{9}$");
const $bb27324e6828f86a$var$DEAPattern = new RegExp("^[a-zA-Z][a-zA-Z0-9][0-9]{7}$");
const $bb27324e6828f86a$var$NPIPattern = new RegExp(/^\d{10}$/);
const $bb27324e6828f86a$export$293fb29162af9905 = (value)=>{
    if (!$bb27324e6828f86a$var$HINPattern.test(value)) return "Invalid identifier";
};
const $bb27324e6828f86a$export$b508647eee765849 = (value)=>{
    if (!$bb27324e6828f86a$var$DEAPattern.test(value)) return "Invalid identifier";
};
const $bb27324e6828f86a$export$383b8f6b2be52437 = (value)=>{
    if (!$bb27324e6828f86a$var$NPIPattern.test(value)) return "Invalid identifier";
};
const $bb27324e6828f86a$export$e84a16758abd033 = (name, value)=>{
    const errorMessageText = `Please enter a valid ${name} separate with a space, tab or comma`;
    const stringPattern = /^[ ,A-Za-z0-9\n]*$/;
    let trimValue = value.trim();
    if (trimValue !== "" && !stringPattern.test(trimValue)) return errorMessageText;
    const valueList = value.split(/[ ,\n]+/).map((s)=>s.trim()).filter(Boolean);
    for (const val of valueList){
        let pattern;
        if (name === 'HIN') pattern = $bb27324e6828f86a$var$HINPattern;
        else if (name === 'DEA') pattern = $bb27324e6828f86a$var$DEAPattern;
        else pattern = $bb27324e6828f86a$var$NPIPattern;
        if (!pattern.test(val)) return errorMessageText;
    }
    return '';
};
const $bb27324e6828f86a$export$12d2d7b61a5c0eb1 = (0, $d8seH.default)('span')({
    color: 'red'
});
const $bb27324e6828f86a$export$842aba50ed0ce9d7 = ({ label: label, isRequired: isRequired })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        textAlign: "left",
        paddingBottom: "7px",
        fontFamily: "Aeonik Regular",
        color: "#191F2A",
        fontWeight: "700",
        fontSize: "16px",
        children: [
            label,
            isRequired && /*#__PURE__*/ (0, $ayMG0.jsx)($bb27324e6828f86a$export$12d2d7b61a5c0eb1, {
                children: "*"
            })
        ]
    });
};
const $bb27324e6828f86a$export$298b9ad7287f04ba = (errorName)=>{
    return {
        "& input": {
            fontFamily: 'Aeonik Regular',
            padding: "12px",
            height: '24px',
            '&::placeholder': {
                fontStyle: 'italic'
            }
        },
        "& .MuiFormHelperText-root": {
            minHeight: '20px'
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            '&:hover fieldset': {
                border: errorName ? '2px solid #E22929' : '1px solid #191F2A'
            },
            '&.Mui-focused fieldset': {
                border: errorName ? '2px solid #E22929' : '1px solid #191F2A'
            }
        }
    };
};
const $bb27324e6828f86a$export$8148362e557f3fef = {
    sx: {
        '&.Mui-error': {
            color: '#E22929',
            fontFamily: 'Aeonik Regular',
            marginLeft: '0',
            fontSize: '14px',
            letterSpacing: '-0.28px'
        }
    }
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $2esSG = parcelRequire("2esSG");
var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;



var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");


var $5A6d3 = parcelRequire("5A6d3");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $659f9ff12b4e3755$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c550ce5d3f5617f8$export$c4cff3a43f7cabb6), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $1En50.default)(props, $659f9ff12b4e3755$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $9Rgf1.default)(ref, rootRef);
    const name = (0, $5A6d3.default)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), (0, $8nd05.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;


var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");





const $37779ef262096d83$var$RequiredSymbol = (0, $d8seH.default)('span')({
    color: 'red'
});
const $37779ef262096d83$var$buttonsContainerSxStyles = {
    display: 'flex',
    justifyContent: 'center',
    gap: '24px'
};
const $37779ef262096d83$var$helperTextStyles = {
    sx: {
        '&.Mui-error': {
            color: '#E22929',
            fontFamily: 'Aeonik Regular',
            marginLeft: '0',
            fontSize: '14px',
            letterSpacing: '-0.28px'
        }
    }
};
const $37779ef262096d83$var$radioLabelStyles = {
    '& .MuiTypography-root': {
        fontFamily: "Aeonik Regular"
    }
};
const $37779ef262096d83$var$FormLabel = ({ label: label, isRequired: isRequired })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        textAlign: "left",
        paddingBottom: "7px",
        fontFamily: "Aeonik Regular",
        color: "#191F2A",
        fontWeight: "700",
        fontSize: "16px",
        children: [
            label,
            isRequired && /*#__PURE__*/ (0, $ayMG0.jsx)($37779ef262096d83$var$RequiredSymbol, {
                children: "*"
            })
        ]
    });
};
const $37779ef262096d83$var$MedicalLicenseFormModal = ({ isMedicalLicenseFormModalOpen: isMedicalLicenseFormModalOpen, handleCloseModal: handleCloseModal, selectedState: selectedState, setSelectedMedicalLicense: setSelectedMedicalLicense, setAddressFormErrors: setAddressFormErrors, addressFormErrors: addressFormErrors })=>{
    const defaultFields = {
        licenseType: 'medical',
        firstName: '',
        lastName: '',
        name: '',
        state: selectedState,
        number: '',
        expiration: ''
    };
    const userStatus = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.userStatus);
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultFields);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const requiredFields = [
        'firstName',
        'lastName',
        'name',
        'number',
        'state',
        'expiration'
    ];
    const USStates = (0, $5cdc329eeebd56d0$export$e322f0dbe1d2219b).map((state)=>{
        return {
            "value": state,
            "label": state
        };
    });
    (0, $acw62.useEffect)(()=>{
        setInputFields((currentFields)=>({
                ...currentFields,
                state: selectedState
            }));
    }, [
        selectedState
    ]);
    const textFieldStyles = (name)=>{
        return {
            "& input": {
                fontFamily: 'Aeonik Regular',
                padding: "12px",
                height: '24px',
                '&::placeholder': {
                    fontStyle: 'italic'
                }
            },
            "& .MuiFormHelperText-root": {
                minHeight: '20px'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                '&:hover fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
                },
                '&.Mui-focused fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
                }
            }
        };
    };
    const createTextField = (name, label, value, onChange, onBlur, isRequired, placeholder)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($37779ef262096d83$var$FormLabel, {
                    label: label,
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: name,
                    "data-testid": name,
                    name: name,
                    type: "text",
                    value: value,
                    placeholder: placeholder,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    sx: textFieldStyles(name),
                    error: Boolean(errors[name]),
                    helperText: errors[name],
                    FormHelperTextProps: $37779ef262096d83$var$helperTextStyles,
                    inputProps: {
                        'data-testid': `${name}-input`
                    }
                })
            ]
        });
    };
    const validateField = (name, value, userStatus)=>{
        let errorMsg = "";
        if (requiredFields.includes(name) && !value.trim()) errorMsg = "Required";
        else if (name === "firstName" || name === "lastName") errorMsg = (0, $bb27324e6828f86a$export$b135c3f9b9f02308)(value);
        else if (name === "expiration") errorMsg = (0, $bb27324e6828f86a$export$e5ef670d70906d8e)(value, userStatus);
        return errorMsg;
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: value
        };
        setInputFields(newInputFields);
    };
    const handleChangeRadio = (event)=>{
        const { value: value } = event.target;
        const resetFields = {
            ...defaultFields,
            licenseType: value,
            state: selectedState
        };
        setInputFields(resetFields);
    };
    const handleStateSelection = (event)=>{
        const { value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            state: value
        };
        setInputFields(newInputFields);
        const newErrors = {
            ...errors,
            state: ""
        };
        setErrors(newErrors);
    };
    const handleBlur = (event)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateField(name, value, userStatus);
        setErrors({
            ...errors,
            [name]: errorMsg
        });
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        let dynamicRequiredFields = [
            ...requiredFields
        ];
        if (inputFields.licenseType === 'medical') dynamicRequiredFields = dynamicRequiredFields.filter((field)=>field !== 'name');
        else if (inputFields.licenseType === 'pharmacy') dynamicRequiredFields = dynamicRequiredFields.filter((field)=>field !== 'firstName' && field !== 'lastName');
        const validationErrors = {};
        dynamicRequiredFields.forEach((fieldName)=>{
            const fieldValue = inputFields[fieldName];
            const errorMsg = validateField(fieldName, fieldValue, userStatus);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        if (Object.keys(validationErrors).length === 0) {
            setSelectedMedicalLicense(inputFields);
            setInputFields(defaultFields);
            setAddressFormErrors({
                ...addressFormErrors,
                ['medicalLicense']: ''
            });
            setErrors({});
            handleCloseModal();
        } else setErrors(validationErrors);
    };
    const MedicalLicenseForm = /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
            "data-testid": "medicalLicenseForm",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    marginY: '16px',
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            fontFamily: "Aeonik Regular",
                            color: "#191F2A",
                            fontWeight: "700",
                            children: "License type:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                            "data-testid": "licenseTypeRadioSelection",
                            "aria-label": "Select License Type",
                            name: "licenseType",
                            value: inputFields.licenseType,
                            onChange: handleChangeRadio,
                            row: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    value: "medical",
                                    label: "Medical Practitioner",
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                    sx: $37779ef262096d83$var$radioLabelStyles
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    value: "pharmacy",
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                    label: "Pharmacy or other institution",
                                    sx: $37779ef262096d83$var$radioLabelStyles
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    "data-testid": "licenseDetailsSection",
                    rowSpacing: '24px',
                    columnSpacing: '16px',
                    justifyContent: "start",
                    alignItems: "flex-start",
                    marginBottom: '48px',
                    children: [
                        inputFields.licenseType === 'medical' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 4.5,
                                    paddingBottom: '1px',
                                    children: createTextField("firstName", 'Practitioner first name', inputFields.firstName, handleChange, handleBlur, true, 'e.g., Jonathan')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 4.5,
                                    paddingBottom: '1px',
                                    children: createTextField("lastName", "Practitioner last name", inputFields.lastName, handleChange, handleBlur, true, 'e.g., Doe')
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 9,
                            paddingBottom: '1px',
                            children: createTextField("name", 'Pharmacy name', inputFields.name, handleChange, handleBlur, true, 'e.g., Townsville Community Pharmacy, Store #5')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 3,
                            paddingBottom: '1px',
                            textAlign: 'left',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                                dataTestId: "stateDropdownSelection",
                                name: "state",
                                label: "State",
                                options: USStates,
                                value: inputFields?.state || selectedState,
                                onChangeHandler: handleStateSelection,
                                isRequired: true,
                                errors: errors,
                                isDisabled: !!selectedState
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 9,
                            paddingBottom: '1px',
                            children: createTextField("number", "License number", inputFields.number, handleChange, handleBlur, true, 'e.g., ND.1234-45678')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            sm: 3,
                            paddingBottom: '1px',
                            children: createTextField("expiration", "Expiration date", inputFields.expiration, handleChange, handleBlur, true, 'MM/DD/YYYY')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    "data-testid": "buttonsSection",
                    sx: $37779ef262096d83$var$buttonsContainerSxStyles,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            buttonType: "mds-secondary",
                            "data-testid": "cancelBtn",
                            onClick: handleCloseModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            type: "submit",
                            id: "submit",
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            buttonType: "mds-primary",
                            "data-testid": "saveBtn",
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        title: "Add a new medical license",
        openModal: isMedicalLicenseFormModalOpen,
        closeModalHandler: handleCloseModal,
        modalContent: MedicalLicenseForm,
        style: {
            '#crossIcon': {
                marginTop: '5px'
            },
            '#titleContainer': {
                padding: '5px',
                marginBottom: '0px'
            },
            minWidth: '700px',
            padding: '32px',
            '#modalTitle': {
                marginRight: {
                    xs: '40px'
                }
            }
        }
    });
};
var $37779ef262096d83$export$2e2bcd8739ae039 = $37779ef262096d83$var$MedicalLicenseFormModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");




var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");

var $c7e3683aba19a9af$exports = {};
$c7e3683aba19a9af$exports = new URL("practitionerIcon.464446bc.svg", import.meta.url).toString();


var $3e05a9d1eafa28ad$exports = {};
$3e05a9d1eafa28ad$exports = new URL("institutionIcon.189ff731.svg", import.meta.url).toString();


const $cd03df0bfef0df0e$var$medicalLicenseCardStyles = {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    flex: '1 0 0',
    borderRadius: '16px',
    border: '1px solid #D1D2D5',
    boxShadow: ' 0px 2px 4px 0px rgba(0, 0, 0, 0.50);'
};
const $cd03df0bfef0df0e$var$AeonikTypography = (0, $d8seH.default)((0, $3bYfT.default))({
    fontFamily: 'Aeonik Regular'
});
const $cd03df0bfef0df0e$var$MedicalLicenseCard = ({ selectedMedicalLicense: selectedMedicalLicense, removeLicense: removeLicense, style: style })=>{
    const LicenseDetail = ({ testId: testId, label: label, value: value })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($cd03df0bfef0df0e$var$AeonikTypography, {
                    textAlign: 'left',
                    fontWeight: 700,
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($cd03df0bfef0df0e$var$AeonikTypography, {
                    textAlign: 'left',
                    children: value
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: style ? style : $cd03df0bfef0df0e$var$medicalLicenseCardStyles,
        "data-testid": "medicalLicenseCard",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                width: '100%',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: selectedMedicalLicense?.licenseType === 'medical' ? (0, (/*@__PURE__*/$parcel$interopDefault($c7e3683aba19a9af$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3e05a9d1eafa28ad$exports))),
                        alt: selectedMedicalLicense?.licenseType === 'medical' ? 'practitioner icon' : 'pharmacy icon',
                        width: '32px',
                        height: '32px'
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        "data-testid": "licenseName",
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cd03df0bfef0df0e$var$AeonikTypography, {
                                        textAlign: 'left',
                                        fontWeight: 700,
                                        children: selectedMedicalLicense?.licenseType === 'medical' ? `${selectedMedicalLicense?.firstName} ${selectedMedicalLicense?.lastName}` : selectedMedicalLicense?.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cd03df0bfef0df0e$var$AeonikTypography, {
                                        children: selectedMedicalLicense?.licenseType === 'medical' ? 'Medical practitioner' : 'Pharmacy or other institution'
                                    })
                                ]
                            }),
                            removeLicense && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                "data-testid": "removeLicenseBtn",
                                buttonType: "link",
                                sx: {
                                    textTransform: "none"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd03df0bfef0df0e$var$AeonikTypography, {
                                    onClick: removeLicense,
                                    children: "Remove"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: 'flex',
                paddingLeft: '40px',
                alignItems: 'flex-start',
                gap: '16px',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(LicenseDetail, {
                        testId: "licenseNumber",
                        label: "License number",
                        value: selectedMedicalLicense?.number
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(LicenseDetail, {
                        testId: "licenseState",
                        label: "State",
                        value: selectedMedicalLicense?.state
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(LicenseDetail, {
                        testId: "licenseExpiration",
                        label: "Expiration",
                        value: selectedMedicalLicense?.expiration
                    })
                ]
            })
        ]
    });
};
var $cd03df0bfef0df0e$export$2e2bcd8739ae039 = $cd03df0bfef0df0e$var$MedicalLicenseCard;




const $de64e41af50540ee$var$buttonsContainerSxStyles = {
    display: 'flex',
    justifyContent: 'center',
    gap: '24px'
};
const $de64e41af50540ee$var$medicalLicenseCardStyles = {
    width: '375px',
    height: '146px',
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    borderRadius: '16px',
    border: '1px solid #D1D2D5',
    boxShadow: ' 0px 2px 4px 0px rgba(0, 0, 0, 0.50);',
    textAlign: 'left',
    "&:hover": {
        cursor: 'pointer'
    },
    justifyContent: 'space-around'
};
const $de64e41af50540ee$var$MedicalLicenseSelectionModal = ({ isMedicalLicenseSelectionModalOpen: isMedicalLicenseSelectionModalOpen, handleCloseModal: handleCloseModal, medicalLicensesForSelectedState: medicalLicensesForSelectedState, setSelectedMedicalLicense: setSelectedMedicalLicense, setOpenLicenseFormModal: setOpenLicenseFormModal, setAddressFormErrors: setAddressFormErrors, addressFormErrors: addressFormErrors, currentAddress: currentAddress })=>{
    const theme = (0, $14H9o.default)();
    const [licenseSelection, setLicenseSelection] = (0, $acw62.useState)(medicalLicensesForSelectedState[0]);
    const { cartData: cartData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (currentAddress) {
            const updatedCartLineItems = cartData?.cartLineItems.map((entry)=>{
                if (String(entry?.shipToAddress?.addressId) === String(currentAddress?.id)) return {
                    ...entry,
                    healthcareLicense: (0, $28a6d9aafed47a89$export$9e52003e4f38c9d2)(licenseSelection)
                };
                return entry;
            });
            dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
                cartLineItems: updatedCartLineItems
            }));
        }
        setSelectedMedicalLicense(licenseSelection);
        setAddressFormErrors && setAddressFormErrors({
            ...addressFormErrors,
            ['medicalLicense']: ''
        });
        handleCloseModal();
    };
    const handleAddLicense = ()=>{
        handleCloseModal();
        setOpenLicenseFormModal(true);
    };
    const MedicalLicenseSelection = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        "data-testid": "medicalLicensesContainer",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '16px',
                flexWrap: 'wrap',
                marginBottom: '48px',
                children: [
                    medicalLicensesForSelectedState.map((license, i)=>{
                        const isSelected = license?.number === licenseSelection?.number;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            "data-testid": `medicalLicenseCard-${i}`,
                            onClick: ()=>{
                                setLicenseSelection(license);
                            },
                            tabIndex: "0",
                            onKeyDown: (e)=>{
                                if (e.key === 'Enter') setLicenseSelection(license);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd03df0bfef0df0e$export$2e2bcd8739ae039), {
                                selectedMedicalLicense: license,
                                style: {
                                    ...$de64e41af50540ee$var$medicalLicenseCardStyles,
                                    border: isSelected && '1px solid #079AE0'
                                }
                            })
                        }, i);
                    }),
                    !currentAddress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        "data-testid": "addMedicalLicenseCard",
                        sx: {
                            ...$de64e41af50540ee$var$medicalLicenseCardStyles,
                            justifyContent: 'center',
                            alignItems: 'center'
                        },
                        onClick: handleAddLicense,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5fc6cdd0dabb560c$exports))),
                                    alt: "plus icon",
                                    width: "32",
                                    height: "32"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontFamily: "Aeonik Regular",
                                    color: "#0379B2",
                                    children: "Enter a new license"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": "buttonsSection",
                sx: $de64e41af50540ee$var$buttonsContainerSxStyles,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        sx: {
                            padding: "16px 24px",
                            textTransform: "none"
                        },
                        buttonType: "mds-secondary",
                        "data-testid": "cancelBtn",
                        onClick: handleCloseModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        id: "submit",
                        sx: {
                            padding: "16px 24px",
                            textTransform: "none"
                        },
                        buttonType: "mds-primary",
                        "data-testid": "saveBtn",
                        onClick: handleSubmit,
                        children: "Save"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        title: "Medical License",
        openModal: isMedicalLicenseSelectionModalOpen,
        closeModalHandler: handleCloseModal,
        modalContent: MedicalLicenseSelection,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            '#crossIcon': {
                marginTop: '5px'
            },
            '#titleContainer': {
                padding: '5px',
                marginBottom: '0px',
                marginLeft: '0'
            },
            maxWidth: '850px',
            width: 'fit-content',
            padding: '32px',
            '#modalTitle': {
                marginRight: {
                    xs: '40px'
                }
            },
            [theme.breakpoints.down('md')]: {
                width: '500px'
            },
            [theme.breakpoints.down('sm')]: {
                width: '400px',
                marginTop: '60px'
            }
        }
    });
};
var $de64e41af50540ee$export$2e2bcd8739ae039 = $de64e41af50540ee$var$MedicalLicenseSelectionModal;










const $6fb5e96c3783eac6$var$RequiredSymbol = (0, $d8seH.default)('span')({
    color: 'red'
});
const $6fb5e96c3783eac6$var$buttonsContainerSxStyles = {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'left',
    gap: '24px'
};
const $6fb5e96c3783eac6$var$helperTextStyles = {
    sx: {
        '&.Mui-error': {
            color: '#E22929',
            fontFamily: 'Aeonik Regular',
            marginLeft: '0',
            fontSize: '14px',
            letterSpacing: '-0.28px'
        }
    }
};
const $6fb5e96c3783eac6$var$snackbarStyles = {
    justifyContent: 'center',
    borderRadius: '8px',
    backgroundColor: '#079AE0',
    padding: '10px 32px',
    boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.16)',
    '.MuiSnackbarContent-message': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '13px'
    }
};
const $6fb5e96c3783eac6$var$FormLabel = ({ label: label, isRequired: isRequired })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
        textAlign: "left",
        paddingBottom: "7px",
        fontFamily: "Aeonik Regular",
        color: "#191F2A",
        fontWeight: "700",
        fontSize: "16px",
        children: [
            label,
            isRequired && /*#__PURE__*/ (0, $ayMG0.jsx)($6fb5e96c3783eac6$var$RequiredSymbol, {
                children: "*"
            })
        ]
    });
};
const $6fb5e96c3783eac6$export$739652acc0b69127 = ({ tabIndex: tabIndex, onTabChange: onTabChange = ()=>{}, handleNewAddresses: handleNewAddresses, closeModal: closeModal, isOrdering: isOrdering = false, setExternalProcessing: setExternalProcessing, isAddingAdditionalLocation: isAddingAdditionalLocation = false, errorMsgHandler: errorMsgHandler })=>{
    const theme = (0, $14H9o.default)();
    const [savedShippingAddresses, setSavedShippingAddresses] = (0, $acw62.useState)([]);
    const [selectedMedicalLicense, setSelectedMedicalLicense] = (0, $acw62.useState)({});
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [medicalLicensesForSelectedState, setMedicalLicensesForSelectedState] = (0, $acw62.useState)([]);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [isSnackbarOpen, setIsSnackbarOpen] = (0, $acw62.useState)(false);
    const [snackbarMessage, setSnackbarMessage] = (0, $acw62.useState)("");
    const [isAddingAddress, setIsAddingAddress] = (0, $acw62.useState)(false);
    const [openLicenseFormModal, setOpenLicenseFormModal] = (0, $acw62.useState)(false);
    const [openLicenseSelectionModal, setOpenLicenseSelectionModal] = (0, $acw62.useState)(false);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const alertRef = (0, $acw62.useRef)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userAddresses = userData?.addresses || [];
    const userStatus = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.userStatus);
    const orderableProducts = (0, $382eb84981692d3a$export$3d0feebafbb8a231)();
    const { reservationProducts: reservationProducts } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { cartData: cartData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { reservationData: reservationData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const userId = userData?.userId;
    const getDefaultAddressFields = ()=>{
        let defaultAddressFields = {
            dbaName: '',
            contactEmail: '',
            phoneNumber: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipcode: '',
            zipcodeExt: '',
            tddd: '',
            contactFirstName: '',
            contactLastName: '',
            hin: '',
            dea: '',
            npi: ''
        };
        return defaultAddressFields;
    };
    const [addressInputFields, setAddressInputFields] = (0, $acw62.useState)(getDefaultAddressFields());
    const getMedicalLicenses = (licenses)=>{
        return licenses.filter((license)=>license.issuer !== "DEA" && license.issuer !== "HIN" && license.issuer !== "NPI");
    };
    const medicalLicenses = getMedicalLicenses((0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData.licenses || []));
    const getSnackbarMessage = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a5c6285a4ca791f4$exports))),
                    alt: "success icon",
                    width: '32px',
                    height: '32px'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    fontFamily: 'Aeonik Regular',
                    fontSize: '20px',
                    fontWeight: '700',
                    children: [
                        snackbarMessage,
                        ", saved"
                    ]
                })
            ]
        });
    };
    const USStates = (0, $bb27324e6828f86a$export$33e4322173c2e267)((0, $5cdc329eeebd56d0$export$e322f0dbe1d2219b));
    const getRequiredFields = ()=>{
        let requiredFields = [
            'dbaName',
            'addressLine1',
            'city',
            'state',
            'zipcode',
            'contactEmail',
            'phoneNumber',
            'contactFirstName',
            'contactLastName'
        ];
        return requiredFields;
    };
    const textFieldStyles = (name)=>{
        return {
            "& input": {
                fontFamily: 'Aeonik Regular',
                padding: "12px",
                height: '24px',
                '&::placeholder': {
                    fontStyle: 'italic'
                }
            },
            "& .MuiFormHelperText-root": {
                minHeight: '20px'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                '&:hover fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
                },
                '&.Mui-focused fieldset': {
                    border: errors[name] ? '2px solid #E22929' : '1px solid #191F2A'
                }
            }
        };
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...addressInputFields,
            [name]: value
        };
        setAddressInputFields(newInputFields);
    };
    const handleBlur = (event)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateField(name, value);
        setErrors({
            ...errors,
            [name]: errorMsg
        });
    };
    const handleStateSelection = (event)=>{
        const { value: value } = event.target;
        const newInputFields = {
            ...addressInputFields,
            state: value
        };
        if (value !== 'OH') newInputFields.tddd = '';
        setAddressInputFields(newInputFields);
        setMedicalLicensesForSelectedState(medicalLicenses.filter((license)=>license.state === value));
        const newErrors = {
            ...errors,
            state: ""
        };
        setErrors(newErrors);
    };
    const handleAddAddress = async ()=>{
        const validationErrors = getValidationErrors();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(getUpdateUserRequestBody());
            if (response?.status === 200) {
                const newAddress = {
                    dba: addressInputFields.dbaName,
                    line1: addressInputFields.addressLine1,
                    line2: addressInputFields.addressLine2,
                    city: addressInputFields.city,
                    state: addressInputFields.state,
                    zip: addressInputFields.zip
                };
                setSavedShippingAddresses((savedAddresses)=>[
                        ...savedAddresses,
                        newAddress
                    ]);
                setSnackbarMessage(addressInputFields.dbaName);
                setIsSnackbarOpen(true);
                setAddressInputFields(getDefaultAddressFields());
                setSelectedMedicalLicense({});
                setIsAddingAddress(true);
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            errorMsgHandler(errorMessage);
        } finally{
            setIsLoading(false);
        }
    };
    const handleCancelAddAddress = async ()=>{
        const response = await dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
            emailAddress: userData.email
        })).unwrap();
        dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.userStatus));
        onTabChange(tabIndex + 1);
    };
    const handleCloseLicenseFormModal = ()=>{
        setOpenLicenseFormModal(false);
    };
    const handleCloseLicenseSelectionModal = ()=>{
        setOpenLicenseSelectionModal(false);
    };
    const handleOnAddLicense = ()=>{
        if (medicalLicensesForSelectedState.length) setOpenLicenseSelectionModal(true);
        else setOpenLicenseFormModal(true);
    };
    const removeLicense = ()=>{
        setSelectedMedicalLicense({});
    };
    const validateMedicalLicense = ()=>{
        const errors = {};
        const isLicenseSelected = Object.keys(selectedMedicalLicense).length > 0;
        if (!isLicenseSelected) errors.medicalLicense = "Please add a medical license to continue.";
        else if (selectedMedicalLicense.state !== addressInputFields.state) errors.medicalLicense = "The Medical license's state must match the Shipping address.";
        return errors;
    };
    const getValidationErrors = ()=>{
        let validationErrors = validateMedicalLicense();
        Object.keys(addressInputFields).forEach((fieldName)=>{
            const errorMsg = validateField(fieldName, addressInputFields[fieldName]);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        return validationErrors;
    };
    const appendMedicalIdentifiers = (licenses)=>{
        if (addressInputFields.hin.trim() !== '') licenses.push({
            licenseType: (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).HIN,
            number: addressInputFields.hin
        });
        if (addressInputFields.dea.trim() !== '') licenses.push({
            licenseType: (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).DEA,
            number: addressInputFields.dea
        });
        if (addressInputFields.npi.trim() !== '') licenses.push({
            licenseType: (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).NPI,
            number: addressInputFields.npi
        });
    };
    const getUpdateUserRequestBody = ()=>{
        let updateUserRequestBody = {
            userId: userId,
            updateType: "shipping",
            organization: {
                orgType: "ship_to",
                dbaName: addressInputFields.dbaName,
                contactEmail: addressInputFields.contactEmail,
                contactPhone: addressInputFields.phoneNumber,
                contactFirstName: addressInputFields.contactFirstName,
                contactLastName: addressInputFields.contactLastName,
                address: {
                    addressType: "ship_to",
                    line1: addressInputFields.addressLine1,
                    line2: addressInputFields.addressLine2,
                    city: addressInputFields.city,
                    state: addressInputFields.state,
                    zip: addressInputFields.zipcode,
                    zipExtension: addressInputFields.zipcodeExt,
                    tddd: addressInputFields.tddd,
                    licenses: [
                        {
                            licenseType: selectedMedicalLicense.licenseType,
                            firstName: selectedMedicalLicense.firstName,
                            lastName: selectedMedicalLicense.lastName,
                            name: selectedMedicalLicense.name,
                            number: selectedMedicalLicense.number,
                            state: selectedMedicalLicense.state,
                            expiration: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(selectedMedicalLicense.expiration, 'MM/DD/YYYY').format('YYYY-MM-DD')
                        }
                    ]
                }
            }
        };
        appendMedicalIdentifiers(updateUserRequestBody.organization.address.licenses);
        return updateUserRequestBody;
    };
    const filterNewAddresses = (previousAddresses, newResponseAddresses)=>{
        const prevAddrIds = new Set(previousAddresses.map((addr)=>addr.id));
        return newResponseAddresses.filter((newAddr)=>!prevAddrIds.has(newAddr.id) && newAddr.addressType === 'ship_to');
    };
    const handleAdditionalAddress = (address)=>{
        if (isOrdering) {
            const newCartLineItems = orderableProducts?.map((product)=>{
                const internalCartLineItemId = Math.random().toString(36).substr(2, 9);
                return {
                    internalCartLineItemId: internalCartLineItemId,
                    cartId: cartData.cartId,
                    shipToAddress: {
                        addressId: String(address?.id)
                    },
                    shipToOrganizationId: String(address?.organizationId),
                    productId: product?.materialMasterId,
                    quantity: 0,
                    purchaseOrderNumber: "",
                    healthcareLicense: {
                        name: (0, $28a6d9aafed47a89$export$a5d3fe5f5ccae992)(selectedMedicalLicense),
                        state: selectedMedicalLicense?.state,
                        licenseNumber: selectedMedicalLicense?.number,
                        expirationDate: selectedMedicalLicense?.expiration,
                        licenseType: "STATE"
                    },
                    priceSnapshotId: ""
                };
            });
            const updatedCartLineItems = cartData?.cartLineItems ? [
                ...cartData?.cartLineItems,
                ...newCartLineItems
            ] : [
                ...newCartLineItems
            ];
            dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
                cartLineItems: updatedCartLineItems
            }));
        } else {
            const newReservationEntries = reservationProducts?.map((product)=>{
                const uniqueSuffix = Math.random().toString(36).substr(2, 9);
                const reservationEntryId = `${product.code}-${uniqueSuffix}`;
                return {
                    reservationEntryId: reservationEntryId,
                    reservationId: reservationData.reservation.reservationId,
                    deliveryAddressId: address.id,
                    productId: product.code,
                    quantity: 0
                };
            });
            // Combine the existing reservation entries with the new entries for the additional address
            const updatedReservationEntries = [
                ...reservationData.reservationEntries,
                ...newReservationEntries
            ];
            // Dispatch an action to update the reservation entries in the Redux store
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                ...reservationData,
                reservationEntries: updatedReservationEntries
            }));
        }
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const validationErrors = getValidationErrors();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            userStatus === 'ACTIVE' ? setExternalProcessing(true) : setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(getUpdateUserRequestBody());
            if (response?.status === 200) {
                const userRes = await dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response.data?.email
                })).unwrap();
                let newAddresses = filterNewAddresses(userAddresses, userRes?.addresses);
                if (handleNewAddresses) {
                    // Ideally BE API will return the new addresses to FE, here it's workaround
                    let newHealthcareLicense = {
                        name: (0, $28a6d9aafed47a89$export$a5d3fe5f5ccae992)(selectedMedicalLicense),
                        state: selectedMedicalLicense.state,
                        licenseNumber: selectedMedicalLicense.number,
                        expirationDate: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(selectedMedicalLicense.expiration, 'MM/DD/YYYY').format('YYYY-MM-DD'),
                        licenseType: "STATE"
                    };
                    newAddresses[0] = {
                        ...newAddresses[0],
                        healthcareLicense: newHealthcareLicense
                    };
                    handleNewAddresses(newAddresses);
                }
                if (isAddingAdditionalLocation) handleAdditionalAddress(newAddresses[0]);
                await dispatch((0, $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55)({
                    emailAddress: response?.data?.email
                })).unwrap();
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.data?.userStatus));
                setAddressInputFields(getDefaultAddressFields());
                onTabChange(tabIndex + 1);
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            errorMsgHandler(errorMessage);
        } finally{
            userStatus === 'ACTIVE' ? setExternalProcessing(false) : setIsLoading(false);
            closeModal && closeModal();
        }
    };
    const validateField = (name, value)=>{
        let errorMsg = "";
        const validators = {
            contactEmail: ()=>value && (0, $bb27324e6828f86a$export$18148d12c805c5b0)(value),
            phoneNumber: ()=>value && (0, $bb27324e6828f86a$export$8cea6d1b8d887c4a)(value),
            city: ()=>(0, $bb27324e6828f86a$export$8e0e3fe6ebe44386)(value),
            zipcode: ()=>(0, $bb27324e6828f86a$export$5af8a774f7f1c688)(value),
            tddd: ()=>addressInputFields.state === "OH" && (0, $bb27324e6828f86a$export$cf05cbdc7a879c7b)(value),
            hin: ()=>value.trim() !== '' && (0, $bb27324e6828f86a$export$293fb29162af9905)(value),
            dea: ()=>value.trim() !== '' && (0, $bb27324e6828f86a$export$b508647eee765849)(value),
            npi: ()=>value.trim() !== '' && (0, $bb27324e6828f86a$export$383b8f6b2be52437)(value)
        };
        if (getRequiredFields().includes(name) && value.trim() === '') errorMsg = (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0)(value);
        else if (validators[name]) errorMsg = validators[name]();
        return errorMsg || "";
    };
    const createTextField = (name, label, value, onChange, onBlur, isRequired, placeholder)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($6fb5e96c3783eac6$var$FormLabel, {
                    label: label,
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: name,
                    "data-testid": name,
                    name: name,
                    type: "text",
                    value: value,
                    placeholder: placeholder,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    sx: textFieldStyles(name),
                    error: Boolean(errors[name]),
                    helperText: errors[name],
                    FormHelperTextProps: $6fb5e96c3783eac6$var$helperTextStyles,
                    inputProps: {
                        'data-testid': `${name}-input`
                    }
                })
            ]
        });
    };
    const ShippingAddressForm = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37779ef262096d83$export$2e2bcd8739ae039), {
                        isMedicalLicenseFormModalOpen: openLicenseFormModal,
                        handleCloseModal: handleCloseLicenseFormModal,
                        selectedState: addressInputFields.state,
                        setSelectedMedicalLicense: setSelectedMedicalLicense,
                        setAddressFormErrors: setErrors,
                        addressFormErrors: errors
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de64e41af50540ee$export$2e2bcd8739ae039), {
                        isMedicalLicenseSelectionModalOpen: openLicenseSelectionModal,
                        handleCloseModal: handleCloseLicenseSelectionModal,
                        medicalLicensesForSelectedState: medicalLicensesForSelectedState,
                        setSelectedMedicalLicense: setSelectedMedicalLicense,
                        setOpenLicenseFormModal: setOpenLicenseFormModal,
                        setAddressFormErrors: setErrors,
                        addressFormErrors: errors
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                        "data-testid": "onboardingShippingAndLicenseInfo",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                                anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'center'
                                },
                                autoHideDuration: 3000,
                                open: isSnackbarOpen,
                                onClose: ()=>{
                                    setIsSnackbarOpen(false);
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), {
                                    message: getSnackbarMessage(),
                                    sx: $6fb5e96c3783eac6$var$snackbarStyles
                                })
                            }),
                            savedShippingAddresses?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                "data-testid": "savedAddressesSection",
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '24px',
                                marginY: '28px',
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            fontSize: '20px',
                                            fontWeight: 700,
                                            textAlign: 'left',
                                            fontFamily: "Aeonik Regular",
                                            color: "#191F2A",
                                            children: "Saved Addresses"
                                        }),
                                        savedShippingAddresses.map((address, i)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                fontFamily: 'Aeonik Regular',
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            fontWeight: '700'
                                                        },
                                                        children: [
                                                            address.dba,
                                                            ","
                                                        ]
                                                    }),
                                                    ` ${address.line1}${address.line2 ? ` ${address.line2}` : ''}, ${address.city}, ${address.state}`
                                                ]
                                            }, i);
                                        })
                                    ]
                                })
                            }) : undefined,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: 'flex',
                                justifyContent: 'left',
                                padding: '20px 0px',
                                flexDirection: 'column',
                                gap: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontSize: '24px',
                                        fontWeight: 700,
                                        textAlign: 'left',
                                        fontFamily: "Aeonik Regular",
                                        color: "#191F2A",
                                        children: "Shipping Address"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        fontFamily: "Aeonik Regular",
                                        color: "#191F2A",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($6fb5e96c3783eac6$var$RequiredSymbol, {
                                                children: "*"
                                            }),
                                            " Required field"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                container: true,
                                "data-testid": "facilityInfoSection",
                                rowSpacing: '24px',
                                columnSpacing: '16px',
                                justifyContent: "start",
                                alignItems: "flex-start",
                                marginBottom: '48px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("dbaName", 'Facility "Doing business as" name', addressInputFields.dbaName, handleChange, handleBlur, true, 'e.g., Riverside Hospital, Greenleaf Community Pharmacy')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sm: 6,
                                                paddingBottom: '1px',
                                                children: createTextField("contactFirstName", "Facility contact first name", addressInputFields.contactFirstName, handleChange, handleBlur, true, 'e.g., Sarah')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sm: 6,
                                                paddingBottom: '1px',
                                                children: createTextField("contactLastName", "Facility contact last name", addressInputFields.contactLastName, handleChange, handleBlur, true, 'e.g., Smith')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        paddingBottom: '1px',
                                        children: createTextField("contactEmail", "Facility contact email", addressInputFields.contactEmail, handleChange, handleBlur, true, 'e.g., contact@email.com')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        paddingBottom: '1px',
                                        children: createTextField("phoneNumber", "Facility contact phone", addressInputFields.phoneNumber, handleChange, handleBlur, true, 'e.g., 123-456-7890')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                container: true,
                                "data-testid": "addressInfoSection",
                                rowSpacing: '24px',
                                columnSpacing: '16px',
                                justifyContent: "start",
                                alignItems: "flex-start",
                                marginBottom: '48px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: [
                                            createTextField("addressLine1", "Address Line 1", addressInputFields.addressLine1, handleChange, handleBlur, true, 'e.g., 123 Main St'),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                textAlign: 'left',
                                                fontFamily: 'Aeonik Regular',
                                                fontWeight: '400',
                                                letterSpacing: '-0.28px',
                                                children: "Note: Orders cannot be delivered to P.O. Boxes"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("addressLine2", "Suite Number", addressInputFields.addressLine2, handleChange, handleBlur, false, 'e.g., Dock 5, Ste 301')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 4,
                                        paddingBottom: '1px',
                                        children: createTextField("city", "City", addressInputFields.city, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 4,
                                        paddingBottom: '1px',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                                            dataTestId: "stateDropdownSelection",
                                            name: "state",
                                            label: "State",
                                            options: USStates,
                                            value: addressInputFields.state,
                                            onChangeHandler: handleStateSelection,
                                            isRequired: true,
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 2,
                                        paddingBottom: '1px',
                                        children: createTextField("zipcode", "ZIP Code", addressInputFields.zipcode, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 2,
                                        paddingBottom: '1px',
                                        children: createTextField("zipcodeExt", "ZIP +4", addressInputFields.zipcodeExt, handleChange, handleBlur, false)
                                    }),
                                    addressInputFields.state === 'OH' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("tddd", "Terminal Distributer of Dangerous Drugs License (TDDD License)", addressInputFields.tddd, handleChange, handleBlur, true, 'Required for orders in the state of Ohio')
                                    })
                                ]
                            }),
                            userStatus === 'ACTIVE' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                "data-testid": "medicalIdentificationSection",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        marginBottom: '24px',
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                fontSize: '20px',
                                                fontWeight: 700,
                                                textAlign: 'left',
                                                fontFamily: "Aeonik Regular",
                                                color: "#191F2A",
                                                children: "Medical Identifiers"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                fontSize: '14px',
                                                textAlign: 'left',
                                                fontFamily: "Aeonik Regular",
                                                color: "#191F2A",
                                                children: "We use these identifiers to locate and validate your contract pricing. Optional."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        rowSpacing: '24px',
                                        columnSpacing: '16px',
                                        justifyContent: "start",
                                        alignItems: "flex-start",
                                        marginBottom: '48px',
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sm: 4,
                                                paddingBottom: '1px',
                                                children: createTextField("hin", "HIN", addressInputFields.hin, handleChange, handleBlur, false)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sm: 4,
                                                paddingBottom: '1px',
                                                children: createTextField("dea", "DEA Number", addressInputFields.dea, handleChange, handleBlur, false)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 12,
                                                sm: 4,
                                                paddingBottom: '1px',
                                                children: createTextField("npi", "NPI", addressInputFields.npi, handleChange, handleBlur, false)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                "data-testid": "medicalLicenseSection",
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '24px',
                                marginBottom: '48px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                fontSize: '20px',
                                                fontWeight: 700,
                                                textAlign: 'left',
                                                fontFamily: "Aeonik Regular",
                                                color: "#191F2A",
                                                children: [
                                                    "Medical Licenses",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6fb5e96c3783eac6$var$RequiredSymbol, {
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                fontSize: '14px',
                                                textAlign: 'left',
                                                fontFamily: "Aeonik Regular",
                                                color: "#191F2A",
                                                children: "Shipping address must be associated with a valid license before your order ships."
                                            })
                                        ]
                                    }),
                                    Object.keys(selectedMedicalLicense).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd03df0bfef0df0e$export$2e2bcd8739ae039), {
                                        selectedMedicalLicense: selectedMedicalLicense,
                                        removeLicense: removeLicense
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        sx: $6fb5e96c3783eac6$var$buttonsContainerSxStyles,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                            sx: {
                                                padding: "16px 24px",
                                                textTransform: "none"
                                            },
                                            buttonType: "mds-primary",
                                            "data-testid": "addLicenseBtn",
                                            onClick: handleOnAddLicense,
                                            children: "Add a medical license"
                                        })
                                    }),
                                    errors.medicalLicense && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        textAlign: 'left',
                                        color: '#E22929',
                                        fontFamily: 'Aeonik Regular',
                                        children: errors.medicalLicense
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                "data-testid": "buttonsSection",
                                sx: $6fb5e96c3783eac6$var$buttonsContainerSxStyles,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        type: "submit",
                                        id: "submit",
                                        sx: {
                                            padding: "16px 24px",
                                            textTransform: "none"
                                        },
                                        buttonType: "mds-primary",
                                        "data-testid": "continueBtn",
                                        children: "Continue"
                                    }),
                                    userStatus !== 'ACTIVE' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        sx: {
                                            padding: "16px 24px",
                                            textTransform: "none"
                                        },
                                        buttonType: "mds-secondary",
                                        "data-testid": "addAddressBtn",
                                        onClick: handleAddAddress,
                                        children: "Save and add another address"
                                    }),
                                    isAddingAddress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        buttonType: "link",
                                        "data-testid": "cancelAddAddressBtn",
                                        onClick: handleCancelAddAddress,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            fontFamily: 'Aeonik Regular',
                                            fontSize: '14px',
                                            letterSpacing: '-0.28px',
                                            textTransform: 'none',
                                            children: "Discard and continue"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        "data-testid": "onboardingShippingAddressTab",
        maxWidth: '700px',
        display: 'flex',
        sx: {
            [theme.breakpoints.down('md')]: {
                maxWidth: '600px'
            },
            [theme.breakpoints.down('sm')]: {
                width: '350px'
            }
        },
        children: ShippingAddressForm
    });
};
var $6fb5e96c3783eac6$export$2e2bcd8739ae039 = $6fb5e96c3783eac6$export$739652acc0b69127;


const $2f4b21af916ccc28$export$c31c99c21ac9062d = ({ openModal: openModal, closeModal: closeModal, handleNewAddresses: handleNewAddresses, isOrdering: isOrdering, setExternalProcessing: setExternalProcessing, isAddingAdditionalLocation: isAddingAdditionalLocation, errorMsgHandler: errorMsgHandler })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6fb5e96c3783eac6$export$2e2bcd8739ae039), {
            closeModal: closeModal,
            handleNewAddresses: handleNewAddresses,
            isOrdering: isOrdering,
            setExternalProcessing: setExternalProcessing,
            isAddingAdditionalLocation: isAddingAdditionalLocation,
            errorMsgHandler: errorMsgHandler
        }),
        style: {
            width: '50%',
            '#titleContainer': {
                marginBottom: '0px',
                padding: '5px'
            }
        }
    });
};



const $71d8603ba987eafe$var$ReservationDetailsCard = ({ entries: reservationEntries, handleDosesChange: handleDosesChange, deleteAddressRow: deleteAddressRow, updateDosesQty: updateDosesQty, setExternalProcessing: setExternalProcessing, errorMsgHandler: errorMsgHandler, handlePoNumberChange: handlePoNumberChange })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { reservationData: reservationData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const isAuthenticated = authState?.isAuthenticated;
    const [openProductModal, setOpenProductModal] = (0, $acw62.useState)(false);
    const [openAddressModal, setOpenAddressModal] = (0, $acw62.useState)(false);
    const [showUserAddressFormModal, setShowUserAddressFormModal] = (0, $acw62.useState)(false);
    const closeProductModal = ()=>{
        setOpenProductModal(false);
    };
    const closeAddressModal = ()=>{
        setOpenAddressModal(false);
    };
    const handleAddNewAddress = ()=>{
        setOpenAddressModal(false);
        setShowUserAddressFormModal(true);
    };
    const updateEntriesOnNewAddress = (newAddresses)=>{
        let currentReservationEntryIds = new Set(reservationEntries.map((entry)=>entry.id));
        if (Array.isArray(newAddresses) && newAddresses.length > 0) {
            const updatedReservationEntries = reservationData.reservationEntries.map((entry)=>{
                if (currentReservationEntryIds.has(entry.reservationEntryId)) return {
                    ...entry,
                    deliveryAddressId: newAddresses[0].id,
                    shipToOrganizationId: newAddresses[0].organizationId
                };
                return entry;
            });
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                reservationEntries: updatedReservationEntries
            }));
        }
    };
    let totalDoses = 0;
    let totalPrice = 0;
    if (isAuthenticated) {
        const result = reservationEntries.reduce(({ totalDoses: totalDoses, totalPrice: totalPrice }, product)=>{
            const pricePerDose = product.contractPriceValue !== undefined ? product.contractPriceValue : product.listPriceValue;
            return {
                totalDoses: totalDoses + product.doses,
                totalPrice: totalPrice + product.doses * pricePerDose
            };
        }, {
            totalDoses: 0,
            totalPrice: 0
        });
        totalDoses = result.totalDoses;
        totalPrice = result.totalPrice;
        updateDosesQty(totalDoses);
    }
    const displayAddress = ()=>{
        const address = isAuthenticated ? reservationEntries[0]?.address : null;
        return address;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53e3f78b3d4a8296$export$2e2bcd8739ae039), {
                openModal: openProductModal,
                closeModal: closeProductModal
            }),
            openAddressModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abba33a116635f56$export$2e2bcd8739ae039), {
                openModal: openAddressModal,
                closeModal: closeAddressModal,
                currentAddress: displayAddress(),
                handleAddNewAddress: handleAddNewAddress,
                isOrdering: false
            }),
            showUserAddressFormModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f4b21af916ccc28$export$c31c99c21ac9062d), {
                openModal: showUserAddressFormModal,
                closeModal: ()=>setShowUserAddressFormModal(false),
                handleNewAddresses: updateEntriesOnNewAddress,
                addressType: "ship_to",
                setExternalProcessing: setExternalProcessing,
                errorMsgHandler: errorMsgHandler
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                flexGrow: 1,
                minHeight: '412px',
                mt: 5,
                mb: 5,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
                    sx: {
                        padding: "32px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexGrow: 1,
                        flexDirection: "column",
                        alignContent: 'space-between',
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            flexGrow: 1,
                            flexWrap: 'wrap',
                            mb: 3,
                            gap: 8,
                            minHeight: '240px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    minWidth: '240px',
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5489e2f3750c70b$export$2e2bcd8739ae039), {
                                        shipToAddress: displayAddress(),
                                        setOpenAddressModal: setOpenAddressModal,
                                        deleteAddressRow: deleteAddressRow,
                                        handlePoNumberChange: handlePoNumberChange,
                                        cartLineItems: reservationEntries,
                                        handleAddNewAddress: handleAddNewAddress,
                                        isReservation: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    flex: 1,
                                    width: '65%',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdc2b0881c093ca1$export$2e2bcd8739ae039), {
                                            products: reservationEntries,
                                            isAuthenticated: isAuthenticated,
                                            handleDosesChange: handleDosesChange
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            minHeight: '72px',
                                            mt: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                    orientation: "horizontal",
                                                    variant: "middle"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    flexWrap: 'wrap',
                                                    mt: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                style: {
                                                                    fontSize: '14px',
                                                                    fontWeight: '400',
                                                                    lineHeight: '20px',
                                                                    whiteSpace: "pre-line"
                                                                },
                                                                children: [
                                                                    (0, $5cdc329eeebd56d0$export$e1a0f5ca0b653d0a),
                                                                    " ",
                                                                    '\n',
                                                                    " ",
                                                                    (0, $5cdc329eeebd56d0$export$48a9bc1ef927eec9)
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            style: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'flex-end',
                                                                minWidth: '48px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    style: {
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        lineHeight: '22px'
                                                                    },
                                                                    children: isAuthenticated ? `Total Doses: ${totalDoses}` : `Total Doses: 0`
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                    style: {
                                                                        fontSize: '16px',
                                                                        fontWeight: '400',
                                                                        lineHeight: '28px'
                                                                    },
                                                                    children: [
                                                                        isAuthenticated && `Total Price: ${(0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice)}`,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $71d8603ba987eafe$export$2e2bcd8739ae039 = $71d8603ba987eafe$var$ReservationDetailsCard;



var $440b5642e77fc64a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($440b5642e77fc64a$exports, "__esModule", {
    value: true
});
$440b5642e77fc64a$exports.default = void 0;

var $440b5642e77fc64a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $440b5642e77fc64a$var$_default = $440b5642e77fc64a$exports.default = (0, $440b5642e77fc64a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'AddCircleOutline');










var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");



const $5a6e86856f619807$var$MessageContentStyles = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: '18px',
    padding: '12px 16px',
    borderRadius: '0px 8px 8px 0px',
    borderLeft: '2px solid #FDB022',
    background: '#FFF9EC'
};
const $5a6e86856f619807$var$staticContent = {
    cancelHeader: 'Are you sure you want to cancel this reservation?',
    discardHeader: 'Are you sure you want to discard changes?',
    cancelMessage: `If you cancel this reservation, you may not be able to secure the same quantity of doses for delivery in the same timeframe again.
                  This operation cannot be undone.`,
    discardMessage: `Your reservation will revert to its previous state and any changes will be lost.
                   This operation cannot be undone.`
};
const $5a6e86856f619807$var$ConfirmationModal = ({ closeModal: closeModal, openModal: openModal, contentType: contentType, handleConfirm: handleConfirm })=>{
    const getContentBasedOnType = (contentType)=>{
        const isCancel = contentType === "cancel";
        return {
            headerText: isCancel ? $5a6e86856f619807$var$staticContent.cancelHeader : $5a6e86856f619807$var$staticContent.discardHeader,
            messageText: isCancel ? $5a6e86856f619807$var$staticContent.cancelMessage : $5a6e86856f619807$var$staticContent.discardMessage,
            noButtonText: isCancel ? "No, keep this reservation" : "No, keep editing",
            yesButtonText: isCancel ? "Yes, cancel this reservation" : "Yes, discard changes"
        };
    };
    const { headerText: headerText, messageText: messageText, noButtonText: noButtonText, yesButtonText: yesButtonText } = getContentBasedOnType(contentType);
    const modalContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $5a6e86856f619807$var$MessageContentStyles,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d97a1fedc4ce7d35$exports))),
                            alt: "info icon",
                            width: "32",
                            height: "32"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            "data-testid": "messageContent",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "10px",
                            flex: "1 0 0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontFamily: "Aeonik Regular",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    children: headerText
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontFamily: "Aeonik Regular",
                                    textAlign: "left",
                                    sx: {
                                        whiteSpace: 'pre-line'
                                    },
                                    children: messageText
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    "data-testid": "buttonGroup",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-secondary",
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "14px",
                                fontWeight: "700",
                                children: noButtonText
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            onClick: ()=>handleConfirm(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "14px",
                                fontWeight: "700",
                                children: yesButtonText
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        title: contentType === 'cancel' ? 'Cancel reservation' : 'Discard changes',
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            maxWidth: '521px',
            width: 'auto',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '23px',
            '#titleContainer': {
                marginLeft: '0px',
                padding: '5px'
            }
        },
        modalContent: modalContent()
    });
};
var $5a6e86856f619807$export$2e2bcd8739ae039 = $5a6e86856f619807$var$ConfirmationModal;







const $26514b3a1a506060$export$1f44af3a7a25af10 = ()=>{
    return Math.random().toString(36).substr(2, 9);
};
const $26514b3a1a506060$export$bb51317036b056e5 = (orderableProducts, cart, shipToAddresses, defaultBillToAddress)=>{
    return orderableProducts?.length && orderableProducts?.map((product)=>{
        const internalCartLineItemId = $26514b3a1a506060$export$1f44af3a7a25af10();
        let shippingAddress = cart?.length && cart?.cartLineItems[0]?.shipToAddress;
        if (shippingAddress === null || shippingAddress?.addressId === undefined) shippingAddress = shipToAddresses[0];
        const productId = product?.materialMasterId;
        return {
            internalCartLineItemId: internalCartLineItemId,
            cartId: cart?.cartId,
            shipToAddress: {
                addressId: String(shippingAddress?.id)
            },
            shipToOrganizationId: String(shippingAddress?.organizationId),
            productId: productId,
            quantity: 0,
            purchaseOrderNumber: "",
            healthcareLicense: {},
            priceSnapshotId: "",
            billToAddress: {
                addressId: String(defaultBillToAddress?.id)
            },
            billToOrganizationId: String(defaultBillToAddress?.organizationId)
        };
    });
};
const $26514b3a1a506060$export$f5cca2b3b5ceb026 = (cart)=>{
    return cart?.cartLineItems?.map((cartLineItem)=>{
        return {
            internalCartLineItemId: cartLineItem?.cartLineItemId,
            cartLineItemId: cartLineItem?.cartLineItemId,
            shipToAddress: {
                addressId: String(cartLineItem?.shipToAddress?.addressId)
            },
            shipToOrganizationId: String(cartLineItem?.shipToOrganizationId),
            productId: cartLineItem.productId,
            quantity: cartLineItem.quantity,
            purchaseOrderNumber: cartLineItem?.purchaseOrderNumber || "",
            healthcareLicense: cartLineItem?.healthcareLicense || {},
            priceSnapshotId: cartLineItem?.priceSnapshotId || "",
            billToAddress: {
                addressId: String(cartLineItem?.billToAddress?.addressId)
            },
            billToOrganizationId: String(cartLineItem?.billToOrganizationId)
        };
    });
};
const $26514b3a1a506060$var$initializeExistingCartLineItems = (orderableProducts, cart, shipToAddresses, defaultBillToAddress)=>{
    //initialize an object with unique shipping addressID as keys
    let initializedCartLineItemByAddress = {};
    let existingCartLineItemByAddress = {};
    cart?.cartLineItems.forEach((cartLineItem)=>{
        let purchaseOrderNumber = "";
        let healthcareLicense = {};
        const shipToAddressId = cartLineItem?.shipToAddress?.addressId;
        if (!initializedCartLineItemByAddress[shipToAddressId]) initializedCartLineItemByAddress[shipToAddressId] = [];
        initializedCartLineItemByAddress[shipToAddressId].push(cartLineItem);
        if (!existingCartLineItemByAddress[shipToAddressId]) existingCartLineItemByAddress[shipToAddressId] = [];
        if (cartLineItem?.purchaseOrderNumber) purchaseOrderNumber = cartLineItem?.purchaseOrderNumber;
        if (cartLineItem?.healthcareLicense) healthcareLicense = cartLineItem?.healthcareLicense;
        existingCartLineItemByAddress[shipToAddressId] = {
            shipToOrganizationId: cartLineItem?.shipToOrganizationId,
            healthcareLicense: healthcareLicense,
            purchaseOrderNumber: purchaseOrderNumber
        };
    });
    const finalizedCartLineItems = [];
    //Loop through all shipToAddresID and initialize all orderable products, map the correct cartLineItem information on there
    Object.keys(initializedCartLineItemByAddress).forEach((shipToAddressId)=>{
        orderableProducts?.forEach((product)=>{
            const internalCartLineItemId = $26514b3a1a506060$export$1f44af3a7a25af10();
            const matchingCartLineItem = initializedCartLineItemByAddress[shipToAddressId].find((cartLineItem)=>cartLineItem.productId === product?.materialMasterId);
            const productId = product?.materialMasterId;
            const cartLineItem = {
                internalCartLineItemId: matchingCartLineItem?.cartLineItemId || internalCartLineItemId,
                ...matchingCartLineItem && {
                    cartLineItemId: matchingCartLineItem?.cartLineItemId
                },
                shipToAddress: {
                    addressId: String(matchingCartLineItem?.shipToAddress?.addressId || shipToAddressId)
                },
                shipToOrganizationId: String(existingCartLineItemByAddress?.[shipToAddressId]?.shipToOrganizationId || matchingCartLineItem?.shipToOrganizationId || null),
                productId: matchingCartLineItem?.productId || productId,
                quantity: matchingCartLineItem?.quantity || 0,
                purchaseOrderNumber: existingCartLineItemByAddress?.[shipToAddressId]?.purchaseOrderNumber || matchingCartLineItem?.purchaseOrderNumber || "",
                healthcareLicense: existingCartLineItemByAddress?.[shipToAddressId]?.healthcareLicense || matchingCartLineItem?.healthcareLicense || {},
                priceSnapshotId: matchingCartLineItem?.priceSnapshotId || "",
                billToAddress: {
                    addressId: String(matchingCartLineItem?.billToAddress?.addressId || defaultBillToAddress?.id)
                },
                billToOrganizationId: String(matchingCartLineItem?.billToOrganizationId || defaultBillToAddress?.organizationId)
            };
            finalizedCartLineItems.push(cartLineItem);
        });
    });
    return finalizedCartLineItems;
};
const $26514b3a1a506060$export$9b047ff83ed91e3e = (orderableProducts, cart, shipToAddresses, defaultBillToAddress)=>{
    if (cart?.cartLineItems?.length) return $26514b3a1a506060$var$initializeExistingCartLineItems(orderableProducts, cart, shipToAddresses, defaultBillToAddress);
    else return $26514b3a1a506060$export$bb51317036b056e5(orderableProducts, cart, shipToAddresses, defaultBillToAddress);
};
const $26514b3a1a506060$export$e4cde6d2791bb1f0 = (shipToAddresses, shipToAddressId)=>{
    let shipToAddress = shipToAddresses?.find((address)=>String(address.id) === String(shipToAddressId));
    return shipToAddress?.organizationId;
};
const $26514b3a1a506060$export$41303c5fee299aff = (selectedContract, pricingData, isDiscountEnabled)=>{
    const defaultListPrice = pricingData?.pricesByPriceReference?.find((price)=>price?.priceReferenceType === (0, $5cdc329eeebd56d0$export$aa77aef8f9046d78).CUSTOMER_PRICE_LIST);
    const contractPrices = selectedContract && pricingData?.pricesByPriceReference?.find((price)=>price?.priceReferenceId === selectedContract?.id);
    //Loop through default list price to save all list prices to productPricingMap, and add contract price if available
    let productPricingMap = defaultListPrice?.productPrices?.reduce((allPrices, productPrice)=>{
        const contractPrice = contractPrices?.productPrices?.find((price)=>price?.productId === productPrice?.productId);
        allPrices[productPrice?.productId] = {
            listPrice: productPrice?.listPriceFormatted,
            contractPrice: isDiscountEnabled ? contractPrice?.originalContractPriceFormatted : contractPrice?.finalPriceFormatted,
            finalPrice: contractPrice?.finalPriceFormatted
        };
        return allPrices;
    }, {});
    return productPricingMap;
};
const $26514b3a1a506060$export$f4b549670de80db3 = (orderableProducts, context, onlineDiscountEnabled)=>{
    let productNumbers = orderableProducts?.map((product)=>product.materialMasterId);
    let pricingContext = onlineDiscountEnabled ? context : undefined;
    return {
        "productNumbers": productNumbers,
        "pricingContext": pricingContext
    };
};
const $26514b3a1a506060$export$7b819d7f1f9df8ff = (orderableProducts, userId, context, onlineDiscountEnabled)=>{
    let productNumbers = orderableProducts?.map((product)=>product.materialMasterId);
    let pricingContext = onlineDiscountEnabled ? context : undefined;
    return {
        "productNumbers": productNumbers,
        "userId": userId,
        "pricingContext": pricingContext
    };
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");





const $9f790cb44cdc3bec$export$91bfccc430b4a443 = (contract)=>contract?.contractType === (0, $5cdc329eeebd56d0$export$aa77aef8f9046d78).LETTER_OF_COMMITMENT;
const $9f790cb44cdc3bec$export$628296b194a1d7f2 = (contracts)=>{
    // Remove unknown and customer price list contracts
    return contracts?.filter((contract)=>contract.contractType !== (0, $5cdc329eeebd56d0$export$aa77aef8f9046d78).UNKNOWN && contract.contractType !== (0, $5cdc329eeebd56d0$export$aa77aef8f9046d78).CUSTOMER_PRICE_LIST);
};
const $9f790cb44cdc3bec$var$formatContractDisplayName = (contracts)=>{
    let filteredContracts = $9f790cb44cdc3bec$export$628296b194a1d7f2(contracts);
    return filteredContracts?.map((contract)=>({
            ...contract,
            displayName: $9f790cb44cdc3bec$export$91bfccc430b4a443(contract) ? `${contract?.displayName} (Commitment pricing)` : contract?.displayName
        }));
};
const $9f790cb44cdc3bec$export$92fbd45ca1b7abe = (contracts)=>{
    // Search for letter of commitment pricing contracts and put it in the front
    let sortedContracts = [
        ...contracts
    ]?.sort((a, b)=>{
        if ($9f790cb44cdc3bec$export$91bfccc430b4a443(a) && !$9f790cb44cdc3bec$export$91bfccc430b4a443(b)) return -1;
        else if (!$9f790cb44cdc3bec$export$91bfccc430b4a443(a) && $9f790cb44cdc3bec$export$91bfccc430b4a443(b)) return 1;
        return 0;
    });
    return $9f790cb44cdc3bec$var$formatContractDisplayName(sortedContracts);
};



const $a7006019da9fe18a$var$MessageContentStyles = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: '18px',
    padding: '12px 16px',
    borderRadius: '0px 8px 8px 0px',
    borderLeft: '2px solid #FDB022',
    background: '#FFF9EC'
};
const $a7006019da9fe18a$var$RadioContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
    display: flex;
    margin-right: 8px;
    flex-wrap: wrap;
    flex-direction: column;
    ${[
        breakpoints.down('sm')
    ]} {
        flex-direction: column;
    }
`);
const $a7006019da9fe18a$var$CustomTypography = (0, $d8seH.default)((0, $3bYfT.default))(()=>`
    font-family:"Aeonik Regular";
    font-size: 16px;
    font-weight: 400;
    text-align: left;
`);
const $a7006019da9fe18a$var$BoldText = (0, $d8seH.default)('span')(()=>`
  font-weight: 700;
`);
const $a7006019da9fe18a$var$NoteContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
    display: flex;
    background: #F2FAFD;
    border-radius: 8px;
    border: 0.25px solid #079AE0;
    padding: 10px;
    align-items: center;
    gap: 10px;
    width: 100%;
    ${[
        breakpoints.down('sm')
    ]} {
        flex-direction: column;
    }
`);
const $a7006019da9fe18a$var$GroupAffiliationSelectionModal = ({ closeModal: closeModal, openModal: openModal, handleConfirm: handleConfirm, defaultGpoAffiliatedId: defaultGpoAffiliatedId, productsForPricing: productsForPricing, setSelectedContract: setSelectedContract, isReservation: isReservation = false })=>{
    const isOverlappingContractEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_OVERLAPPING_CONTRACT_ENABLED");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [selectedAffiliationId, setSelectedAffiliationId] = (0, $acw62.useState)(defaultGpoAffiliatedId);
    const oktaUserId = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.authenticatedId) || '';
    const userId = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.userId) || '';
    const priceContracts = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>{
        if (!isOverlappingContractEnabled) return state?.commerce?.priceContracts || [];
        return isReservation ? state?.commerce?.reservationPriceContracts : state?.commerce?.priceContracts;
    });
    const userLicenses = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.licenses);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const alertRef = (0, $acw62.useRef)(null);
    const [message, setMessage] = (0, $acw62.useState)('');
    const [type, setType] = (0, $acw62.useState)('');
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const alert = (message, type)=>{
        setMessage(message);
        setType(type);
    };
    const handleAffiliationSelection = (e)=>setSelectedAffiliationId(e.target.value);
    const priceContractsPayload = ()=>{
        let medicalIdentifiers = userLicenses?.filter((license)=>license.issuer === 'HIN' || license.issuer === 'DEA').map((license)=>license.number);
        return {
            "medicalIdentifiers": medicalIdentifiers,
            "productNumbers": productsForPricing
        };
    };
    (0, $acw62.useEffect)(()=>{
        const fetchEligibleContracts = async ()=>{
            try {
                setProcessing(true);
                const action = isReservation && isOverlappingContractEnabled ? (0, $7003073550a1fc7c$export$2b81fdbf3c9c79c5) : (0, $7003073550a1fc7c$export$5a367251a6b08c32);
                await dispatch(action({
                    payload: {
                        productNumbers: productsForPricing,
                        userId: userId
                    }
                })).unwrap();
            } catch (error) {
                const errorMsg = 'We are unable to fetch your contracts at the moment. Please refresh and try again or contact us at 1-866-MODERNA.';
                alert(errorMsg, 'error');
                alertRef.current?.openAlert(error);
            } finally{
                setProcessing(false);
            }
        };
        fetchEligibleContracts();
    }, [
        dispatch
    ]);
    const getRadioOptions = ()=>{
        const options = (0, $9f790cb44cdc3bec$export$92fbd45ca1b7abe)(priceContracts).map((contract, index)=>{
            //After sorting contracts, select the first contract by default if no contract is selected
            if (!selectedAffiliationId && index === 0) setSelectedAffiliationId(contract.id);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
                        className: "answer",
                        id: contract.id,
                        label: contract.displayName,
                        name: contract.displayName,
                        value: contract.id,
                        checked: selectedAffiliationId === contract.id,
                        onChange: handleAffiliationSelection,
                        size: 'large',
                        labelsx: {
                            fontSize: '16px',
                            fontWeight: selectedAffiliationId === contract.id ? 700 : 400
                        },
                        radiosx: {
                            padding: '9px 9px 9px 0px'
                        },
                        customCheckedColor: "#383D47"
                    }),
                    (0, $9f790cb44cdc3bec$export$91bfccc430b4a443)(contract) && /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                        sx: "padding-left:  45px; font-size: 14px",
                        children: "Our records indicate that your organization has an active Letter of Commitment (LOC) with this group."
                    })
                ]
            });
        });
        if (isOverlappingContractEnabled) options.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cea323b26ef82aa8$export$d7b12c4107be0d61), {
            className: "answer",
            id: "no-contract",
            label: isReservation ? "View without a contract" : "Order without a contract",
            name: "contract-affiliation",
            value: "no-contract",
            checked: selectedAffiliationId === "no-contract",
            onChange: handleAffiliationSelection,
            size: "large",
            labelsx: {
                fontSize: '16px',
                fontWeight: selectedAffiliationId === "no-contract" ? 700 : 400
            },
            radiosx: {
                padding: '9px 9px 9px 0px'
            },
            customCheckedColor: "#383D47"
        }));
        return options;
    };
    const showNoMatchMessage = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        ...$a7006019da9fe18a$var$MessageContentStyles,
                        background: null,
                        borderLeft: null
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d97a1fedc4ce7d35$exports))),
                            alt: "info icon",
                            width: "32",
                            height: "32"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            "data-testid": "noMatchesmessageContent",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "24px",
                            flex: "1 0 0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                    sx: "font-weight: 700; line-height: 24px; font-size: 18px",
                                    children: "No matches found."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                    children: "We couldn't find a contract affiliation associated with the HIN or DEA numbers provided."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignContents: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                            buttonType: "mds-secondary",
                                            sx: {
                                                gap: "12px",
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                textTransform: "none",
                                                padding: "16px 24px"
                                            },
                                            onClick: ()=>history.push('/contact-us'),
                                            children: "Contact us"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                            paddingLeft: "8px",
                                            alignContent: "center",
                                            children: "to update your medical identifiers."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                showNotes()
            ]
        });
    };
    const showNotes = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($a7006019da9fe18a$var$NoteContainer, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d7be9e4b73330e59$exports))),
                    alt: "infoIconImage"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                    sx: "line-height: 24px; color: #191F2A",
                    children: "Note: Not all contracts may be available at this time. Newly signed contracts could take several business days to display. Please check back again soon."
                })
            ]
        });
    };
    const handleCloseModal = ()=>{
        setSelectedAffiliationId(defaultGpoAffiliatedId);
        closeModal();
    };
    const handleSaveChanges = async ()=>{
        let selectedPriceContract;
        if (isOverlappingContractEnabled && selectedAffiliationId === "no-contract") selectedPriceContract = {
            id: "no-contract",
            displayName: null
        };
        else selectedPriceContract = priceContracts?.find((contract)=>contract?.id === selectedAffiliationId);
        if (selectedPriceContract) {
            setSelectedContract && setSelectedContract(selectedPriceContract);
            handleConfirm(selectedPriceContract);
        }
        closeModal();
    };
    const modalContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                    variant: "filled",
                    type: type,
                    message: message,
                    sx: {
                        top: 120
                    },
                    ref: alertRef
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                    processing: processing
                }),
                !processing && ((0, $9f790cb44cdc3bec$export$628296b194a1d7f2)(priceContracts)?.length === 0 ? showNoMatchMessage() : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                            children: "Your product pricing is determined by the affiliation you choose."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($a7006019da9fe18a$var$RadioContainer, {
                            sx: {
                                padding: '16px 32px',
                                textAlign: 'left'
                            },
                            "data-testid": "radioOptions",
                            children: [
                                getRadioOptions(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($a7006019da9fe18a$var$CustomTypography, {
                                    sx: "font-weight: 700; line-height: 24px; padding-top: 16px",
                                    children: [
                                        "Don\u2019t see the right contract?",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                            to: "/contact-us",
                                            style: {
                                                color: "#0379B2"
                                            },
                                            children: " Contact us"
                                        })
                                    ]
                                })
                            ]
                        }),
                        showNotes(),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            "data-testid": "buttonGroup",
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    buttonType: "mds-secondary",
                                    sx: {
                                        padding: "16px 24px",
                                        textTransform: "none"
                                    },
                                    onClick: handleCloseModal,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                        sx: "font-weight: 700",
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    buttonType: "mds-primary",
                                    sx: {
                                        padding: "16px 24px",
                                        textTransform: "none"
                                    },
                                    onClick: handleSaveChanges,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                        sx: "font-weight: 700",
                                        children: "Save changes"
                                    })
                                })
                            ]
                        })
                    ]
                }))
            ]
        });
    };
    const contractModalContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                    processing: processing
                }),
                !processing && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($a7006019da9fe18a$var$CustomTypography, {
                            children: [
                                "Your product pricing is determined by your affiliation. Newly signed contracts could take several business days to display. If you do not see your contract, check back again soon or",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                    to: "/contact-us",
                                    style: {
                                        color: "#0379B2"
                                    },
                                    children: " Contact us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$RadioContainer, {
                            sx: {
                                padding: '16px 32px',
                                textAlign: 'left'
                            },
                            "data-testid": "radioOptions",
                            children: getRadioOptions()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            "data-testid": "buttonGroup",
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            width: "100%",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                buttonType: "mds-primary",
                                sx: {
                                    padding: "16px 24px",
                                    textTransform: "none"
                                },
                                onClick: handleSaveChanges,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a7006019da9fe18a$var$CustomTypography, {
                                    sx: "font-weight: 700",
                                    children: "Continue"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        title: "Contract affiliation",
        openModal: openModal,
        closeModalHandler: !isOverlappingContractEnabled && closeModal,
        showCloseButton: isOverlappingContractEnabled ? false : true,
        style: {
            maxWidth: '699px',
            width: 'auto',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '23px',
            '#titleContainer': {
                marginLeft: '0px',
                padding: '5px'
            }
        },
        modalContent: isOverlappingContractEnabled ? contractModalContent() : modalContent()
    });
};
var $a7006019da9fe18a$export$2e2bcd8739ae039 = $a7006019da9fe18a$var$GroupAffiliationSelectionModal;






var $ayMG0 = parcelRequire("ayMG0");


var $3bYfT = parcelRequire("3bYfT");
const $1dea0e5aaf07dabc$var$NoContractAffiliationCard = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
        sx: {
            padding: '16px 32px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h5",
                        sx: {
                            fontSize: '18px',
                            marginRight: '8px'
                        },
                        children: "You are not affiliated with any contracts."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        children: [
                            "Incorrect pricing?",
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                                to: "/contact-us",
                                style: {
                                    color: '#0379B2'
                                },
                                children: "Contact us"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $1dea0e5aaf07dabc$export$2e2bcd8739ae039 = $1dea0e5aaf07dabc$var$NoContractAffiliationCard;


const $ab83046cc24df634$var$ReservationGPOComponent = ({ productsForPricing: productsForPricing, onContractChange: onContractChange, setSelectedContract: setSelectedContract, selectedContract: selectedContract, isEditing: isEditing })=>{
    const { reservation: reservation } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const reservationData = reservation?.reservation;
    const { reservationPriceContracts: reservationPriceContracts = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state?.commerce);
    const selectedGpoAffiliatedId = selectedContract?.id || selectedContract?.contractId;
    const [openSelectionModal, setOpenSelectionModal] = (0, $acw62.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $acw62.useState)('');
    const [alertType, setAlertType] = (0, $acw62.useState)('');
    const userId = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.userId) || '';
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const alertRef = (0, $acw62.useRef)(null);
    const [contractTooltipDismissed, setContractTooltipDismissed] = (0, $acw62.useState)(false);
    const isNewReservation = reservationData?.reservationStatus === "CREATED" && !reservation?.reservationEntries?.length && !isEditing && reservationPriceContracts?.length > 0;
    const alert = (message, type)=>{
        setAlertMessage(message);
        setAlertType(type);
    };
    const contractTooltip = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: "16px 12px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                pb: "20px",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "p1",
                    children: "You can change your contract affiliation at any time by clicking here."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "mds-tertiary",
                sx: {
                    textTransform: 'none'
                },
                onClick: ()=>setContractTooltipDismissed(true),
                children: "Got it"
            })
        ]
    });
    const fetchEligibleContracts = async ()=>{
        try {
            await dispatch((0, $7003073550a1fc7c$export$2b81fdbf3c9c79c5)({
                payload: {
                    productNumbers: productsForPricing,
                    userId: userId
                }
            })).unwrap();
        } catch (error) {
            let errorMsg = 'We are unable to fetch your contracts at the moment. Please refresh and try again or contact us at 1-866-MODERNA.';
            alert(errorMsg, 'error');
            alertRef.current?.openAlert(error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchEligibleContracts();
    }, [
        dispatch
    ]);
    const handleConfirm = (selectedPriceContract)=>{
        onContractChange(selectedPriceContract);
    };
    const getSelectedContractDetails = (cartContractId)=>{
        return reservationPriceContracts?.find((contract)=>contract?.id === cartContractId);
    };
    (0, $acw62.useEffect)(()=>{
        if (reservationData?.contractInfo && reservationPriceContracts.length > 0) {
            const matchedContract = getSelectedContractDetails(reservationData.contractInfo.contractId);
            if (matchedContract) setSelectedContract && setSelectedContract(matchedContract);
        }
    }, [
        reservationData?.contractInfo,
        reservationPriceContracts
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isNewReservation) {
            setContractTooltipDismissed(true);
            setOpenSelectionModal(true);
        }
    }, [
        reservationPriceContracts
    ]);
    const renderContractAffiliationCard = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                    variant: "filled",
                    type: alertType,
                    message: alertMessage,
                    sx: {
                        top: 120
                    },
                    ref: alertRef
                }),
                !reservationPriceContracts.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dea0e5aaf07dabc$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
                    sx: {
                        padding: "16px 32px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        style: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        style: {
                                            fontSize: '18px',
                                            marginRight: '8px'
                                        },
                                        children: selectedContract?.displayName ? "Contract affiliation:\xa0" + selectedContract?.displayName : 'No contract affiliation selected.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: contractTooltip,
                                        placement: "bottom-start",
                                        arrow: true,
                                        open: !contractTooltipDismissed,
                                        componentsProps: {
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#F1F9FE',
                                                    color: '#252627',
                                                    boxShadow: 1,
                                                    fontSize: '16px'
                                                }
                                            },
                                            arrow: {
                                                sx: {
                                                    color: '#F1F9FE'
                                                }
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body1",
                                            color: "secondary.textLinks",
                                            "data-testid": "selectAffiliationBtn",
                                            onClick: ()=>setOpenSelectionModal(true),
                                            style: {
                                                cursor: 'pointer',
                                                fontSize: '18px'
                                            },
                                            children: "Change"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    children: [
                                        "Incorrect pricing?",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                            to: "/contact-us",
                                            style: {
                                                color: "#0379B2"
                                            },
                                            children: " Contact us"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        mt: 2,
        minHeight: '50px',
        "data-testid": "gpoComponent",
        children: [
            renderContractAffiliationCard(),
            openSelectionModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7006019da9fe18a$export$2e2bcd8739ae039), {
                openModal: openSelectionModal,
                closeModal: ()=>setOpenSelectionModal(false),
                handleConfirm: handleConfirm,
                defaultGpoAffiliatedId: selectedGpoAffiliatedId,
                productsForPricing: productsForPricing,
                setSelectedContract: setSelectedContract,
                isReservation: true
            })
        ]
    });
};
var $ab83046cc24df634$export$2e2bcd8739ae039 = $ab83046cc24df634$var$ReservationGPOComponent;


const $2a9b33373daee05c$var$ReservationPage = ()=>{
    const isReservationContractEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_OVERLAPPING_CONTRACT_ENABLED");
    const isReservationNextGenBannerEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_RESERVATIONS_NEXTGEN_BANNER_ENABLED");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const isLoggingIn = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.isLoggingIn);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const emailAddress = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.emailAddress);
    const pricingData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.pricingData);
    const defaultAddress = userData?.addresses?.find((address)=>address.addressType === 'ship_to');
    const defaultBillingAddress = userData?.addresses?.find((address)=>address.addressType === 'bill_to');
    const defaultSoldToAddress = userData?.addresses?.find((address)=>address.addressType === 'sold_to');
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const isAuthenticated = authState?.isAuthenticated;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [isUserDataProcessing, setIsUserDataProcessing] = (0, $acw62.useState)(false);
    const [isReservationProcessing, setIsReservationProcessing] = (0, $acw62.useState)(false);
    const [isProductsProcessing, setIsProductsProcessing] = (0, $acw62.useState)(false);
    const [isPricingProcessing, setIsPricingProcessing] = (0, $acw62.useState)(false);
    const isPageLoading = isUserDataProcessing || isReservationProcessing || isProductsProcessing || isPricingProcessing;
    const userId = userData?.authenticatedId;
    const internalUserId = userData?.userId;
    const { reservationProducts: reservationProducts } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce) || [];
    const { reservation: reservation } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { reservationData: reservationData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const [deliverySchedule, setDeliverySchedule] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [alertMsg, setAlertMsg] = (0, $acw62.useState)({
        type: 'info',
        text: ''
    });
    const [openAddressModal, setOpenAddressModal] = (0, $acw62.useState)(false);
    const [openConfirmationModal, setOpenConfirmationModal] = (0, $acw62.useState)(false);
    const [confirmationModalContentType, setConfirmationModalContentType] = (0, $acw62.useState)('');
    const [totalDosesQty, setTotalDoses] = (0, $acw62.useState)(0);
    const [showUserAddressFormModal, setShowUserAddressFormModal] = (0, $acw62.useState)(false);
    const disableContinue = totalDosesQty === 0 || !defaultBillingAddress?.id;
    const { reservationId: reservationId } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const isEditing = !!reservationId;
    const [refreshReservationData, setRefreshReservationData] = (0, $acw62.useState)(false);
    const [selectedContract, setSelectedContract] = (0, $acw62.useState)(reservation?.reservation?.contractInfo);
    const showContractPriceForReservation = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.showContractPriceForReservation);
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const handleErrorMsg = (errorMsg)=>{
        setProcessing(false);
        setAlertMsg({
            type: 'error',
            text: errorMsg
        });
        alertRef.current?.openAlert('');
    };
    const getMedicalIdentifier = ()=>{
        let medicalIdentifier = null;
        medicalIdentifier = selectedContract?.medicalIdentifier;
        if (!medicalIdentifier) medicalIdentifier = userData?.licenses?.find((license)=>license.issuer === "HIN" || license.issuer === "DEA")?.number;
        return medicalIdentifier || 'anonymous';
    };
    const getShipToOrgId = (addressId)=>{
        const matched = shipToAddresses?.find((address)=>String(address.id) === String(addressId));
        return matched?.organizationId != null ? String(matched.organizationId) : null;
    };
    // Retrieve reservation data from APIs
    (0, $acw62.useEffect)(()=>{
        const createReservations = async ()=>{
            try {
                setIsReservationProcessing(true);
                setIsProductsProcessing(true);
                setIsPricingProcessing(true);
                if (isAuthenticated && userId) {
                    if (isEditing) await dispatch((0, $f9f5d27cea32d603$export$3a69f39f385de80e)({
                        userId: userId,
                        reservationId: reservationId
                    })).unwrap();
                    else await dispatch((0, $f9f5d27cea32d603$export$44a973515938c016)({
                        userId: userId,
                        userEmail: emailAddress
                    })).unwrap();
                }
                const res = await dispatch((0, $6361b14d09f5d8cd$export$cf9d318b59dc7b06)({
                    locale: 'US'
                })).unwrap();
                const reservationProducts = res?.data?.productList;
                try {
                    !isReservationContractEnabled && await dispatch((0, $7003073550a1fc7c$export$1cc7e8ea7ec74e6e)({
                        payload: (0, $26514b3a1a506060$export$f4b549670de80db3)(reservationProducts, "RESERVATION", isDiscountEnabled)
                    })).unwrap();
                } catch (error) {
                    const apiErrorMessage = error?.message || generalApiError;
                    setAlertMsg({
                        type: 'error',
                        text: apiErrorMessage
                    });
                    alertRef.current?.openAlert('');
                }
            } catch (error) {
                setAlertMsg({
                    type: 'error',
                    text: error?.message || generalApiError
                });
                alertRef.current?.openAlert('');
            } finally{
                setIsReservationProcessing(false);
                setIsProductsProcessing(false);
                setIsPricingProcessing(false);
            }
        };
        createReservations();
    }, [
        dispatch,
        isAuthenticated,
        userId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isReservationContractEnabled) {
            const fetchPricing = async ()=>{
                const customerId = selectedContract?.medicalIdentifier || 'anonymous';
                await safeDispatch((0, $7003073550a1fc7c$export$8000f25297f4564a)({
                    payload: (0, $26514b3a1a506060$export$7b819d7f1f9df8ff)(reservationProducts, internalUserId),
                    customerId: customerId
                }));
            };
            reservationProducts?.length && fetchPricing();
        }
    }, [
        selectedContract,
        dispatch,
        reservationProducts
    ]);
    /** Get all ship to addresses and find default */ const shipToAddresses = (0, $acw62.useMemo)(()=>{
        const addresses = userData?.addresses || [];
        return addresses.filter((address)=>address.addressType === "ship_to").map((address)=>({
                ...address,
                defaultAddress: address.id === defaultAddress?.id
            })).sort((0, $382eb84981692d3a$export$fa295b83bf634638));
    }, [
        defaultAddress
    ]);
    (0, $acw62.useEffect)(()=>{
        // if there is reservation data, map through reservation Entries,
        // else map through products to create default product info
        if (reservation?.reservationEntries?.length) {
            let reservationEntries = reservation?.reservationEntries?.map((reservationEntry)=>{
                let shipToOrgId = getShipToOrgId(reservationEntry.deliveryAddressId);
                return {
                    reservationEntryId: reservationEntry.reservationEntryId,
                    deliveryAddressId: reservationEntry.deliveryAddressId,
                    productId: reservationEntry.productId,
                    quantity: reservationEntry.quantity,
                    purchaseOrderNumber: reservationEntry.purchaseOrderNumber,
                    shipToOrganizationId: shipToOrgId
                };
            });
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                ...reservation,
                reservationEntries: reservationEntries
            }));
        } else {
            let reservationEntries = reservationProducts?.length && reservationProducts?.map((product)=>{
                const productId = product?.materialMasterId;
                let addressId = reservation?.length && reservation?.reservationEntries[0]?.deliveryAddressId;
                let shipToOrgId = getShipToOrgId(addressId);
                if (addressId === undefined || addressId === null && shipToAddresses.length) {
                    addressId = shipToAddresses[0]?.id;
                    shipToOrgId = String(shipToAddresses[0]?.organizationId);
                }
                const uniqueSuffix = Math.random().toString(36).substr(2, 9);
                const reservationEntryId = `${productId}-${uniqueSuffix}`;
                return {
                    reservationEntryId: reservationEntryId,
                    reservationId: reservation?.reservation?.reservationId,
                    deliveryAddressId: addressId,
                    productId: productId,
                    quantity: 0,
                    purchaseOrderNumber: "",
                    shipToOrganizationId: shipToOrgId
                };
            });
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                ...reservation,
                reservationEntries: reservationEntries
            }));
        }
        setDeliverySchedule(reservation?.reservation?.deliverySchedule || "INITIAL");
        setRefreshReservationData(false);
    }, [
        reservationProducts,
        refreshReservationData,
        reservation,
        dispatch,
        shipToAddresses
    ]);
    const getContractPrice = ()=>{
        return selectedContract && pricingData?.pricesByPriceReference?.find((price)=>price?.priceReferenceId === selectedContract?.id);
    };
    const getPrices = ()=>{
        return getContractPrice() || pricingData?.pricesByPriceReference?.find((price)=>price?.priceReferenceType === (0, $5cdc329eeebd56d0$export$aa77aef8f9046d78).CUSTOMER_PRICE_LIST);
    };
    const handleContractChange = async (selectedPriceContract)=>{
        const { id: priceContractId, displayName: displayName, medicalIdentifier: medicalIdentifier, contractType: contractType } = selectedPriceContract;
        const updateUserPreferencesRequestBody = {
            userId: userData?.userId,
            priceContract: {
                id: priceContractId,
                displayName: displayName,
                medicalIdentifier: medicalIdentifier,
                priceReferenceType: contractType
            }
        };
        try {
            setProcessing(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$a0dcde0748e1668c)(updateUserPreferencesRequestBody);
            if (response.status === 200) {
                dispatch((0, $c89d887792446c86$export$67e4c7982a3d161b)(true));
                dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response?.data?.email
                }));
                dispatch((0, $7003073550a1fc7c$export$1cc7e8ea7ec74e6e)({
                    payload: (0, $26514b3a1a506060$export$f4b549670de80db3)(reservationProducts, "RESERVATION", isDiscountEnabled)
                }));
            }
        } catch (error) {
            setAlertMsg({
                type: "error",
                text: error.message || generalApiError
            });
            alertRef.current?.openAlert("");
        } finally{
            setProcessing(false);
        }
    };
    const safeDispatch = async (action)=>{
        try {
            return await dispatch(action).unwrap();
        } catch (error) {
            const apiErrorMessage = error?.message || generalApiError;
            setAlertMsg({
                type: 'error',
                text: apiErrorMessage
            });
            alertRef.current?.openAlert('');
        }
    };
    const handleReservationContractChange = async (selectedContract)=>{
        const customerId = selectedContract?.medicalIdentifier || 'anonymous';
        await safeDispatch((0, $7003073550a1fc7c$export$8000f25297f4564a)({
            payload: (0, $26514b3a1a506060$export$7b819d7f1f9df8ff)(reservationProducts, internalUserId),
            customerId: customerId
        }));
        selectedContract?.medicalIdentifier && dispatch((0, $c89d887792446c86$export$67e4c7982a3d161b)(true));
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedContract && isReservationContractEnabled) selectedContract?.id === "no-contract" || selectedContract?.contractId === "no-contract" || selectedContract?.contractId === null ? dispatch((0, $c89d887792446c86$export$67e4c7982a3d161b)(false)) : dispatch((0, $c89d887792446c86$export$67e4c7982a3d161b)(true));
        else dispatch((0, $c89d887792446c86$export$67e4c7982a3d161b)(false));
    }, [
        selectedContract,
        dispatch
    ]);
    const allPrices = getPrices();
    const priceReferenceId = allPrices?.priceReferenceId;
    const priceDisplayName = allPrices?.displayName;
    let productPricingMap = allPrices?.productPrices.reduce((all, productPrice)=>{
        return {
            ...all,
            [productPrice?.productId]: {
                listPrice: productPrice?.listPriceFormatted,
                contractPrice: productPrice?.finalPriceFormatted
            }
        };
    }, {}) || {};
    const productMap = (0, $28a6d9aafed47a89$export$e5712731ce122520)(reservationProducts);
    const productMapFormatted = (0, $28a6d9aafed47a89$export$90a2edd9d1c709b3)(reservationProducts);
    const isContractAvailable = (contract)=>{
        const contractId = contract?.id ?? contract?.contractId;
        return !!contractId && contractId !== (0, $5cdc329eeebd56d0$export$a792157d3224929);
    };
    /** Array of API reservation entries to send to confirm API or update reservation API */ const reservationEntriesModel = reservationData?.reservationEntries || [];
    // Helper function to create a display entry for a reservation details card
    const createDisplayEntry = (reservationEntry)=>{
        if (!reservationEntry) return null;
        const { productId: productId, deliveryAddressId: deliveryAddressId, purchaseOrderNumber: purchaseOrderNumber } = reservationEntry;
        const pricing = productPricingMap[productId] || {};
        const address = shipToAddresses?.find(({ id: id })=>String(id) === String(deliveryAddressId));
        const productName = productMap[productId] || "Unknown Product";
        const productNameFormatted = productMapFormatted[productId] || "Unknown Product";
        const shipToOrganizationId = address?.organizationId;
        return {
            id: reservationEntry.reservationEntryId,
            doses: parseInt(reservationEntry?.quantity, 10) || 0,
            productId: productId,
            productName: productName,
            productNameFormatted: productNameFormatted,
            listPriceValue: pricing?.listPrice,
            listPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(pricing?.listPrice),
            contractPriceValue: pricing?.contractPrice,
            contractPrice: showContractPriceForReservation && isContractAvailable(selectedContract) ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(pricing?.contractPrice) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd),
            address: address,
            purchaseOrderNumber: purchaseOrderNumber,
            shipToOrganizationId: shipToOrganizationId
        };
    };
    // Map reservation entries to display entries and filter out undefined entries
    const reservationEntriesDisplay = reservationEntriesModel.map(createDisplayEntry).filter((entry)=>entry !== null);
    // Helper function to determine if an addressId is unique within the array
    const isUniqueAddressId = (addressId, index, self)=>{
        return self.findIndex((entry)=>entry.deliveryAddressId === addressId) === index;
    };
    // Get all unique address IDs
    const reservationAddressIds = reservationEntriesModel.filter(({ deliveryAddressId: deliveryAddressId }, index, self)=>deliveryAddressId && isUniqueAddressId(deliveryAddressId, index, self)).map(({ deliveryAddressId: deliveryAddressId })=>deliveryAddressId);
    const handleDosesChange = (reservationEntryId, doses)=>{
        // Find the index of the reservation entry by reservationEntryId
        const reservationEntryIndex = reservationEntriesModel.findIndex((entry)=>entry.reservationEntryId === reservationEntryId);
        // If the entry is not found, exit the function
        if (reservationEntryIndex === -1) return;
        // Retrieve the entry to be updated
        const entryToUpdate = reservationEntriesModel[reservationEntryIndex];
        // Get the shipToOrganizationId from the deliveryAddressId
        const shipToOrgId = getShipToOrgId(entryToUpdate?.deliveryAddressId);
        // If it's the entry we want to update, return a new object with the updated doses
        const roundOffQty = Math.ceil(parseInt(doses) / 10) * 10;
        if (roundOffQty !== 0 && doses !== roundOffQty) {
            setAlertMsg({
                type: 'info',
                text: (0, $28a6d9aafed47a89$export$f997de3996ee8c85)(roundOffQty)
            });
            alertRef.current?.openAlert('');
        }
        // Create a new entry with the updated doses
        const updatedEntry = {
            ...entryToUpdate,
            quantity: roundOffQty,
            shipToOrganizationId: shipToOrgId
        };
        // Create a new array with the updated entry
        const updatedReservationEntries = [
            ...reservationEntriesModel.slice(0, reservationEntryIndex),
            updatedEntry,
            ...reservationEntriesModel.slice(reservationEntryIndex + 1)
        ];
        const { totalDoses: totalDoses } = reservationPricingInfo(updatedReservationEntries);
        setTotalDoses(totalDoses);
        // Dispatch the new state
        dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
            ...reservationData,
            reservationEntries: updatedReservationEntries
        }));
    };
    const handleDeleteAddressRow = (reservationAddressId)=>{
        const updatedReservationEntries = reservationData?.reservationEntries?.filter((entry)=>{
            return entry.deliveryAddressId !== reservationAddressId;
        });
        const { totalDoses: totalDoses } = reservationPricingInfo(updatedReservationEntries);
        setTotalDoses(totalDoses);
        dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
            reservationEntries: updatedReservationEntries
        }));
    };
    const MODALS = {
        ADDRESS_SELECTION: 'addressSelection',
        ADDRESS_FORM: 'addressForm',
        USER_ADDRESS_FORM: 'userAddressForm',
        CONFIRMATION: 'confirmation'
    };
    const closeModal = (modalName)=>{
        modalName === MODALS.ADDRESS_SELECTION && setOpenAddressModal(false);
        modalName === MODALS.USER_ADDRESS_FORM && setShowUserAddressFormModal(false);
        modalName === MODALS.CONFIRMATION && setOpenConfirmationModal(false);
    };
    const handleAddNewAddress = ()=>{
        closeModal(MODALS.ADDRESS_SELECTION);
        setShowUserAddressFormModal(true);
    };
    const handleDiscardChange = ()=>{
        dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
            reservation: {},
            reservationEntries: []
        }));
        setRefreshReservationData(true);
        setOpenConfirmationModal(false);
    };
    const handleCancelReservation = ()=>{
        dispatch((0, $f9f5d27cea32d603$export$5c8829528553048f)({
            userId: userId,
            reservationId: reservation?.reservation?.reservationId
        })).unwrap().then(()=>{
            const reservationNumber = reservationData?.reservation?.reservationNumber;
            dispatch((0, $c89d887792446c86$export$63839643d7952680)(true));
            history.push(`/${locale}/confirmation/${reservationNumber}`);
        }).catch((error)=>{
            setOpenConfirmationModal(false);
            setAlertMsg({
                type: 'error',
                text: generalApiError
            });
            alertRef.current?.openAlert('');
        });
    };
    const handlePoNumberChange = async (reservationEntriesToUpdate, purchaseOrderNumber)=>{
        const updatedReservationEntries = reservationEntriesModel?.map((existingEntry)=>{
            const matchingReservationEntry = reservationEntriesToUpdate.find((entryToUpdate)=>entryToUpdate?.id === existingEntry?.reservationEntryId);
            if (matchingReservationEntry) return {
                ...existingEntry,
                purchaseOrderNumber: purchaseOrderNumber
            };
            return existingEntry;
        });
        await dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
            reservationEntries: updatedReservationEntries
        }));
    };
    /** Reservation card components. */ const getReservationDetailCards = reservationAddressIds.map((reservationAddressId, i)=>{
        const reservationEntriesForThisAddress = reservationEntriesDisplay?.filter(({ address: address })=>String(address?.id) === String(reservationAddressId));
        (0, $382eb84981692d3a$export$7699132b966bad47)(reservationEntriesForThisAddress, 'productId');
        if (isPageLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
            processing: true
        }, reservationAddressId);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71d8603ba987eafe$export$2e2bcd8739ae039), {
            entries: reservationEntriesForThisAddress,
            handleDosesChange: handleDosesChange,
            deleteAddressRow: ()=>handleDeleteAddressRow(reservationAddressId),
            updateDosesQty: (count)=>setTotalDoses(count),
            setExternalProcessing: setProcessing,
            errorMsgHandler: handleErrorMsg,
            handlePoNumberChange: handlePoNumberChange
        }, reservationAddressId);
    });
    /** Building out products to be displayed for unauthenticated users*/ const unAuthedProducts = reservationProducts?.length && reservationProducts?.map((product, id)=>{
        const productId = product?.materialMasterId;
        return {
            id: id,
            doses: 0,
            productId: productId,
            productName: productMap[productId]
        };
    }) || [];
    /** Unauthenticated reservation details card component */ const getUnAuthenticatedReservationDetailCards = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71d8603ba987eafe$export$2e2bcd8739ae039), {
        entries: unAuthedProducts
    });
    const reservationPricingInfo = (data)=>{
        return data.reduce(({ totalDoses: totalDoses, totalPrice: totalPrice }, product)=>{
            const pricePerDose = product.contractPriceValue !== undefined ? product.contractPriceValue : product.listPriceValue;
            return {
                totalDoses: totalDoses + product.doses,
                totalPrice: totalPrice + product.doses * pricePerDose
            };
        }, {
            totalDoses: 0,
            totalPrice: 0
        });
    };
    const handleContinue = async (isEditing = false)=>{
        setProcessing(true);
        const { totalDoses: totalDoses, totalPrice: totalPrice } = reservationPricingInfo(reservationEntriesDisplay);
        // additional details needed for update API
        const reservationDetails = {
            userId: userId,
            medicalIdentifier: getMedicalIdentifier(),
            reservation: {
                ...reservationData.reservation,
                priceReferenceIdentifier: priceReferenceId,
                deliverySchedule: deliverySchedule,
                billingAddressInformation: {
                    addressId: defaultBillingAddress?.id,
                    organizationId: defaultBillingAddress?.organizationId
                },
                reservationPricingInfo: {
                    totalPrice: totalPrice,
                    totalDoses: totalDoses
                },
                internalUserId: internalUserId,
                displayName: priceDisplayName,
                soldToOrganizationId: defaultSoldToAddress?.organizationId,
                ...isReservationContractEnabled && {
                    contractInfo: {
                        contractId: selectedContract?.id === (0, $5cdc329eeebd56d0$export$a792157d3224929) ? (0, $5cdc329eeebd56d0$export$a792157d3224929) : selectedContract?.id,
                        contractDisplayName: selectedContract?.displayName
                    }
                }
            }
        };
        try {
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)(reservationDetails));
            await dispatch((0, $f9f5d27cea32d603$export$bbda77ab2dbab04a)({
                payload: {
                    ...reservationDetails,
                    reservationEntries: reservationData.reservationEntries
                }
            }));
            if (isEditing) history.push(`/${locale}/summary/${reservationId}`);
            else history.push(`/${locale}/summary`);
            setProcessing(false);
        } catch (error) {
            setProcessing(false);
            setAlertMsg({
                type: 'error',
                text: error?.message || generalApiError
            });
            alertRef.current?.openAlert('');
        }
    };
    const handleCancelOrDiscard = (eventType)=>{
        setConfirmationModalContentType(eventType);
        setOpenConfirmationModal(true);
    };
    const getAllSelectedAddress = ()=>{
        return reservationAddressIds.map((reservationAddressId, i)=>{
            return reservationEntriesDisplay?.filter(({ address: address })=>String(address?.id) === String(reservationAddressId))[0]?.address;
        });
    };
    const getReservationProductCodes = reservationProducts?.length && reservationProducts?.map((product)=>product?.materialMasterId) || [];
    const includeNextGenReservation = ()=>{
        const createdDateStr = reservation?.reservation?.createdDate;
        if (!createdDateStr) return false;
        const createdDate = new Date(createdDateStr);
        //estimate launch date for NextGen
        const cutoffDate = new Date('2025-06-08');
        return createdDate > cutoffDate;
    };
    return !isLoggingIn && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                "data-testid": "errorAlert",
                variant: "filled",
                type: alertMsg.type,
                message: alertMsg.text,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing || isUserDataProcessing
            }),
            openAddressModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abba33a116635f56$export$2e2bcd8739ae039), {
                openModal: openAddressModal,
                closeModal: ()=>closeModal(MODALS.ADDRESS_SELECTION),
                allSelectedAddresses: getAllSelectedAddress(),
                handleAddNewAddress: handleAddNewAddress,
                isOrdering: false
            }),
            showUserAddressFormModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f4b21af916ccc28$export$c31c99c21ac9062d), {
                openModal: showUserAddressFormModal,
                closeModal: ()=>closeModal(MODALS.USER_ADDRESS_FORM),
                addressType: "ship_to",
                setExternalProcessing: setProcessing,
                isAddingAdditionalLocation: true,
                errorMsgHandler: handleErrorMsg
            }),
            openConfirmationModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a6e86856f619807$export$2e2bcd8739ae039), {
                openModal: openConfirmationModal,
                closeModal: ()=>closeModal(MODALS.CONFIRMATION),
                contentType: confirmationModalContentType,
                handleConfirm: confirmationModalContentType === 'cancel' ? handleCancelReservation : handleDiscardChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                m: 4,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h1",
                        style: {
                            marginBottom: '16px'
                        },
                        children: (0, $5cdc329eeebd56d0$export$c7d352a9132e21fd)
                    }),
                    isAuthenticated && isReservationContractEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab83046cc24df634$export$2e2bcd8739ae039), {
                        productsForPricing: getReservationProductCodes,
                        onContractChange: isReservationContractEnabled ? handleReservationContractChange : handleContractChange,
                        selectedContract: selectedContract,
                        setSelectedContract: setSelectedContract,
                        isEditing: isEditing
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                        type: "info",
                        headerText: "Contracts are not available at this time",
                        bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            children: "You can continue to reserve your doses. Check back again to see contract pricing. You will be able to view and edit your reservation until ordering opens. Reservations are subject to FDA approval or emergency use authorization of 2025-2026 formula."
                        }),
                        dataTestId: "reservationContractSelectionDisabledBanner"
                    }),
                    isEditing && isReservationNextGenBannerEnabled && !includeNextGenReservation() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                            type: "warning",
                            headerText: "Looking for mNEXSPIKE?",
                            bannerContentComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: "Follow these steps to cancel this reservation and place a new reservation with mNEXSPIKE\xae (COVID-19 Vaccine, mRNA) 2025-2026 Formula:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: "1. Cancel this reservation using the cancel button in the bottom left."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        children: "2. Return to the Homepage and click on \u201CReserve\u201D to place a new reservation that includes mNEXSPIKE."
                                    })
                                ]
                            }),
                            dataTestId: "reservationContractSelectionDisabledBanner"
                        })
                    }),
                    isAuthenticated ? getReservationDetailCards : getUnAuthenticatedReservationDetailCards,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        flex: 1,
                        minWidth: '300px',
                        mb: 3,
                        mt: 5,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: 'mds-secondary',
                            "data-testid": "deliverToAddressBtn",
                            muiIconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($440b5642e77fc64a$exports))),
                            disabled: !isAuthenticated,
                            onClick: ()=>{
                                setOpenAddressModal(true);
                            },
                            children: "Reserve for additional address"
                        })
                    }),
                    isAuthenticated && !isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        mt: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            "data-testid": "reservationContinueBtn",
                            buttonType: "mds-primary",
                            sx: {
                                textTransform: 'none'
                            },
                            muiIconRight: (0, (/*@__PURE__*/$parcel$interopDefault($12a26d70a091a9bc$exports))),
                            disabled: disableContinue,
                            onClick: ()=>handleContinue(),
                            children: isReservationContractEnabled ? 'Save and continue' : 'CONTINUE'
                        })
                    }),
                    isEditing && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                buttonType: 'secondary',
                                onClick: ()=>{
                                    handleCancelOrDiscard('cancel');
                                },
                                children: "Cancel Reservation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        mr: 3,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                            buttonType: 'mds-secondary',
                                            "data-testid": "discardChangeBtn",
                                            onClick: ()=>{
                                                handleCancelOrDiscard('discard');
                                            },
                                            children: "Discard Changes"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        "data-testid": "saveEditChangeBtn",
                                        buttonType: 'mds-primary',
                                        onClick: ()=>handleContinue(isEditing),
                                        children: "Save Changes"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2a9b33373daee05c$export$2e2bcd8739ae039 = $2a9b33373daee05c$var$ReservationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $3bYfT = parcelRequire("3bYfT");



const $04ae2bcb20987e07$export$8629391d84815c92 = {
    thankYouMsg: "Thank you, ",
    confirmationMsg: (reservationNumber)=>`Your reservation number is #${reservationNumber}.`,
    cancelConfirmationMsg: (reservationId)=>`Reservation #${reservationId} has been cancelled.`,
    timelineHeader: "What happens next:",
    newReservationButtonLabel: "Place another reservation",
    editInfoMessage: "Check back again to see contract pricing. You can edit your reservation until ordering opens. Orders will not be finalized or shipped until they have been confirmed and FDA approves or authorizes the 2025-2026 vaccine formula for Moderna COVID-19 Vaccines.",
    editReservationButtonLabel: "Edit reservation"
};





const $a9b4a870292dff7a$var$ReservationConfirmationPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { userData: userData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const isConfirmationPageAccessible = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.isConfirmationPageAccessible);
    const { reservation: reservation } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { reservationId: reservationId } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const reservationNum = reservation?.reservation?.reservationNumber;
    const isCancellation = reservation?.reservation?.reservationStatus === 'CANCELLED';
    (0, $acw62.useEffect)(()=>{
        if (!isConfirmationPageAccessible) history?.push(`/${locale}/`);
        else dispatch((0, $c89d887792446c86$export$63839643d7952680)(false));
        return ()=>{
            dispatch((0, $53476aa40d2bc637$export$5a354114219e6168)());
        };
    }, [
        history
    ]);
    const ReservationCanceledConfirmation = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($93cf4f4850471977$exports))),
                    alt: "cross icon",
                    className: "crossIcon",
                    height: "56",
                    width: "56"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "InfoMsg",
                    "data-testid": "infoMsg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        variant: "h3",
                        children: (0, $04ae2bcb20987e07$export$8629391d84815c92).cancelConfirmationMsg(reservationNum)
                    })
                })
            ]
        });
    };
    const ReservationBookedConfirmation = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($16182d64948f0f20$exports))),
                    alt: "check icon",
                    className: "CheckIcon",
                    height: "56",
                    width: "56"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "ConfirmationMsgSection",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "ConfirmationMsg",
                            children: [
                                (0, $04ae2bcb20987e07$export$8629391d84815c92)?.thankYouMsg,
                                `${userData?.firstName} ${userData?.lastName}`,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "ConfirmationMsg",
                            children: !!reservationId ? 'Your reservation has been updated.' : (0, $04ae2bcb20987e07$export$8629391d84815c92).confirmationMsg(reservationNum)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "InfoMsg",
                    "data-testid": "infoMsg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontFamily: "Aeonik Regular",
                        children: (0, $04ae2bcb20987e07$export$8629391d84815c92)?.editInfoMessage
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "ReservationConfirmationPage",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ContentSection",
                    children: isCancellation ? /*#__PURE__*/ (0, $ayMG0.jsx)(ReservationCanceledConfirmation, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)(ReservationBookedConfirmation, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "ButtonsGroup",
                    children: [
                        !isCancellation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-secondary",
                            "data-testid": "editReservationButton",
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            onClick: ()=>history.push(`/${locale}/reservation/${reservation?.reservation?.reservationId}`),
                            children: (0, $04ae2bcb20987e07$export$8629391d84815c92)?.editReservationButtonLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            "data-testid": "newReservationButton",
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            onClick: ()=>history.push(`/${locale}/reservation`),
                            children: (0, $04ae2bcb20987e07$export$8629391d84815c92)?.newReservationButtonLabel
                        })
                    ]
                })
            ]
        })
    });
};
var $a9b4a870292dff7a$export$2e2bcd8739ae039 = $a9b4a870292dff7a$var$ReservationConfirmationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $lkxXU = parcelRequire("lkxXU");
var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");








const $4b381e73e7169983$var$TypographyTitle = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`);
const $4b381e73e7169983$var$TypographyList = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`);
const $4b381e73e7169983$var$TypographyText = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`);
const $4b381e73e7169983$var$APPROVE_BEFORE_SHIP = "APPROVE_BEFORE_SHIP";
const $4b381e73e7169983$var$ReservationSummaryCard = ({ totalDoses: totalDoses, listPrice: listPrice, totalPrice: totalPrice, editReservationID: editReservationID, handleAlert: handleAlert, showContractPrice: showContractPrice })=>{
    const [checked, setChecked] = (0, $acw62.useState)(false);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const reservation = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.reservation?.reservation);
    const reservationId = reservation?.reservationId;
    const productRows = reservation?.reservationEntries?.filter((row)=>row?.quantity !== 0);
    const shippingPreference = $4b381e73e7169983$var$APPROVE_BEFORE_SHIP;
    const userEmail = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.emailAddress);
    const reservationUpdate = {
        reservation: {
            ...reservation,
            userShippingPreference: shippingPreference
        }
    };
    const handlePlaceReservation = async ()=>{
        let confirmReservationData = {
            userId: reservation?.userId,
            reservation: {
                reservationId: reservationId,
                userId: reservation?.userId,
                userShippingPreference: shippingPreference
            }
        };
        try {
            dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)(reservationUpdate));
            await dispatch((0, $f9f5d27cea32d603$export$96d59517cc16328f)({
                payload: confirmReservationData,
                reservationId: reservationId,
                userEmail: userEmail
            })).unwrap();
            dispatch((0, $c89d887792446c86$export$63839643d7952680)(true));
            if (!!editReservationID) history.push(`/${locale}/confirmation/${editReservationID}`);
            else history.push(`/${locale}/confirmation`);
        } catch (error) {
            handleAlert();
        } finally{
            await dispatch((0, $53476aa40d2bc637$export$bf010ffeb9d9c8ec)({
                reservation: {},
                reservationEntries: []
            }));
        }
    };
    const consentMessage = (0, $28a6d9aafed47a89$export$b286872c1e0ccb06)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        width: '486px',
        height: '730px',
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                padding: '32px',
                overflow: 'scroll'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyTitle, {
                    mb: "24px",
                    variant: "h3",
                    textTransform: "capitalize",
                    children: "Summary"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    width: "100%",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "h5",
                            children: "Total Doses"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "p1",
                            children: totalDoses
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    width: "100%",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "h5",
                            children: "List Price"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "p1",
                            sx: {
                                textDecoration: showContractPrice ? 'line-through' : 'none'
                            },
                            children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(listPrice)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    width: "100%",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "h5",
                            children: "Contract Price"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyList, {
                            variant: "p1",
                            textAlign: 'right',
                            children: showContractPrice ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    orientation: "horizontal",
                    variant: "middle",
                    sx: {
                        marginBottom: 2,
                        marginTop: 1
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    width: "100%",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyTitle, {
                            variant: "h5",
                            children: "Estimated Total"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyTitle, {
                            variant: "p1",
                            textAlign: 'right',
                            children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($4b381e73e7169983$var$TypographyText, {
                    mt: 2,
                    mb: 3,
                    children: "Check back again to see contract pricing. Orders will not be shipped until they have been confirmed and FDA approves or authorizes the 2025-2026 vaccine formula for Moderna COVID-19 Vaccines. You will be notified when it is time to confirm your order."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c576d11d36ade61d$export$48513f6b9f8ce62d), {
                        sx: {
                            alignItems: "flex-start",
                            marginTop: '24px'
                        },
                        name: "privacyPolicyConsent",
                        label: consentMessage,
                        value: checked,
                        "data-testid": "privacyPolicyConsentCheckbox",
                        onChange: ()=>setChecked((prev)=>!prev)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "mds-primary",
                    sx: {
                        textTransform: 'none',
                        marginTop: '24px'
                    },
                    onClick: handlePlaceReservation,
                    disabled: !checked || productRows?.length === 0,
                    children: !!editReservationID ? 'Update reservation' : 'Place your reservation'
                })
            ]
        })
    });
};
var $4b381e73e7169983$export$2e2bcd8739ae039 = $4b381e73e7169983$var$ReservationSummaryCard;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lkxXU = parcelRequire("lkxXU");
var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");

var $1J2kR = parcelRequire("1J2kR");

const $0e53eb013a70f71b$export$ac2496a09d80e334 = [
    '80291',
    '80289',
    '80588'
];
function $0e53eb013a70f71b$export$364e7219dc149e09(addresses) {
    return addresses && addresses?.map((address)=>{
        const { line1: line1, line2: line2, city: city, state: state, zip: zip } = address;
        const formattedAddress = [
            line1,
            line2,
            city,
            state,
            zip
        ].filter((part)=>part && typeof part === 'string' && part.trim() !== '').join(', ');
        return {
            ...address,
            formattedAddress: formattedAddress
        };
    });
}
function $0e53eb013a70f71b$export$9bff813f16ad2ec0(address) {
    const { line1: line1, line2: line2, city: city, state: state, zip: zip } = address;
    return [
        line1,
        line2,
        city,
        state,
        zip
    ].filter((part)=>part && typeof part === 'string' && part.trim() !== '').join(', ');
}



const $99e35f6bfd156bb0$var$TypographyHeading = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    padding-left: 10px;
`);
const $99e35f6bfd156bb0$var$TypographyText = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding-left: 10px;
`);
const $99e35f6bfd156bb0$var$TypographySummaryText = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    color: var(--primary-dark, #363D4A);
    text-align: right;
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.32px;
    text-align: center;
`);
const $99e35f6bfd156bb0$var$BoxContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))`
  display: flex;
  flex-direction: column;
   .MuiDataGrid-cellContent, .MuiDataGrid-columnHeaderTitle {
    font-size: 16px;
     text-transform: none;
   }
`;
const $99e35f6bfd156bb0$var$columns = [
    {
        field: 'titleFormatted',
        headerName: 'Item',
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: (params)=>params.value
    },
    {
        field: 'doses',
        headerName: 'Doses',
        headerAlign: 'center',
        align: 'center',
        width: 120,
        sortable: false
    },
    {
        field: 'price',
        headerName: 'List Price*',
        headerAlign: 'center',
        width: 130,
        align: 'center',
        sortable: false
    },
    {
        field: 'contractPrice',
        headerName: 'Contract Price',
        width: 140,
        headerAlign: 'center',
        align: 'center',
        sortable: false
    }
];
const $99e35f6bfd156bb0$var$ReservationSummaryTable = ({ entries: reservationEntries, PONumberValue: PONumberValue, showContractPrice: showContractPrice })=>{
    const productRows = (0, $acw62.useMemo)(()=>{
        return reservationEntries?.filter((row)=>row?.doses !== 0)?.map((row, index)=>({
                id: index,
                title: row?.productName,
                titleFormatted: row?.productNameFormatted,
                price: row?.listPrice,
                contractPrice: row?.contractPrice,
                listPriceValue: row?.listPriceValue,
                contractPriceValue: row?.contractPriceValue,
                doses: row?.doses
            })) ?? [];
    }, [
        reservationEntries
    ]);
    const getTotalDoses = ()=>{
        return productRows?.reduce((sum, item)=>sum + item.doses, 0);
    };
    const getTotalPrice = ()=>{
        const prices = productRows?.reduce((totals, item)=>{
            totals.listPrice += Number(item.listPriceValue) * item.doses;
            totals.contractPrice += Number(item.contractPriceValue) * item.doses;
            return totals;
        }, {
            listPrice: 0,
            contractPrice: 0
        });
        return prices;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$BoxContainer, {
            display: "flex",
            flexDirection: 'column',
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 4,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$TypographyHeading, {
                        children: reservationEntries?.[0].address?.dba
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$TypographyText, {
                        children: (0, $0e53eb013a70f71b$export$9bff813f16ad2ec0)(reservationEntries?.[0]?.address)
                    }),
                    PONumberValue && /*#__PURE__*/ (0, $ayMG0.jsxs)($99e35f6bfd156bb0$var$TypographyText, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    'fontWeight': '700'
                                },
                                children: "PO Number:"
                            }),
                            " ",
                            PONumberValue
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1J2kR.DataGrid), {
                        autoHeight: true,
                        rowHeight: 40,
                        rows: productRows,
                        columns: $99e35f6bfd156bb0$var$columns,
                        hideFooter: true,
                        disableColumnFilter: true,
                        disableColumnMenu: true,
                        getRowSpacing: ()=>({
                                top: 8,
                                bottom: 8
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "horizontal",
                        variant: "middle",
                        sx: {
                            marginTop: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "right",
                        alignItems: "center",
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$TypographySummaryText, {
                                style: {
                                    width: '120px'
                                },
                                children: getTotalDoses()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$TypographySummaryText, {
                                style: {
                                    width: '130px'
                                },
                                children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(getTotalPrice().listPrice)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($99e35f6bfd156bb0$var$TypographySummaryText, {
                                style: {
                                    width: '140px'
                                },
                                children: showContractPrice ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(getTotalPrice().contractPrice) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $99e35f6bfd156bb0$export$2e2bcd8739ae039 = $99e35f6bfd156bb0$var$ReservationSummaryTable;



var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");


const $2e195d6dee7d120e$var$TypographyTitle = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
`);
const $2e195d6dee7d120e$var$TypographyList = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`);
const $2e195d6dee7d120e$var$TypographyText = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`);
const $2e195d6dee7d120e$var$CancelledReservationSummaryCard = ({ totalDoses: totalDoses, listPrice: listPrice, totalPrice: totalPrice })=>{
    const SummaryCardListItem = ({ label: label, content: content, contentAlign: contentAlign = 'left' })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            mb: "8px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyList, {
                    variant: "h5",
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyList, {
                    variant: "p1",
                    textAlign: contentAlign,
                    children: content
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        width: '486px',
        height: '500px',
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                padding: '32px',
                overflow: 'scroll'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyTitle, {
                    mb: "24px",
                    variant: "h3",
                    color: "#E22929",
                    children: "Order cancelled"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(SummaryCardListItem, {
                    label: "Total Doses",
                    content: totalDoses
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(SummaryCardListItem, {
                    label: "List Price",
                    content: listPrice
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(SummaryCardListItem, {
                    label: "Contract Price",
                    content: totalPrice
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(SummaryCardListItem, {
                    label: "Shipping",
                    content: "TBD"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    orientation: "horizontal",
                    variant: "middle",
                    sx: {
                        marginBottom: 2,
                        marginTop: 1
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    width: "100%",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyTitle, {
                            variant: "h5",
                            children: "Total"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyTitle, {
                            variant: "p1",
                            textAlign: 'right',
                            children: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2e195d6dee7d120e$var$TypographyText, {
                    mt: 2,
                    mb: 3,
                    children: "Contract pricing will be available soon. We will notify you via email about pricing and other updates to your reservation."
                })
            ]
        })
    });
};
var $2e195d6dee7d120e$export$2e2bcd8739ae039 = $2e195d6dee7d120e$var$CancelledReservationSummaryCard;







var $c9Z8w = parcelRequire("c9Z8w");



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $26cd3be04bc521db$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');



const $e91f0edba7a1c854$var$TypographyTitle = (0, $d8seH.default)((0, $3bYfT.default))(({ theme: { breakpoints: breakpoints } })=>`
    font-family: Aeonik Regular;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    padding-left: 10px;
`);
const $e91f0edba7a1c854$var$ReservationSummaryContainer = (0, $d8seH.default)((0, $00a20d475386f68c$export$2e2bcd8739ae039))(({ theme: { breakpoints: breakpoints } })=>`
	display: grid;
    grid-template-columns: 65% 35%; /* 70% width for the first column and 30% for the second */
    grid-gap: 24px; 
    padding: 32px;
    ${[
        breakpoints.down('sm')
    ]} {
    grid-template-columns: 1fr; 
  }
`);
const $e91f0edba7a1c854$var$ReservationCancelledBanner = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: '18px',
    padding: '12px 16px',
    margin: '32px',
    borderRadius: '0px 8px 8px 0px',
    borderLeft: '2px solid #E22929',
    background: '#FFF3F3'
};
$e91f0edba7a1c854$var$TypographyTitle.propTypes = {
    children: $c9Z8w.node
};
const $e91f0edba7a1c854$var$ReservationSummaryPage = ()=>{
    const [displayReservationData, setDisplayReservationData] = (0, $acw62.useState)([]);
    const displayPONumberValue = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.reservation?.reservation?.purchaseOrderNumber) || '';
    const { reservation: reservation } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { reservationProducts: reservationProducts } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce) || [];
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const shipToAddresses = userData?.addresses?.filter((address)=>address.addressType === 'ship_to') || [];
    const { globalErrorMessage: globalErrorMessage } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const userId = userData?.authenticatedId;
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const alertRef = (0, $acw62.useRef)(null);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { reservationId: reservationId } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const isCancelled = reservation?.reservation?.reservationStatus === 'CANCELLED';
    const isEditing = reservation?.reservation?.reservationStatus === 'PENDING' && !!reservationId;
    const showContractPrice = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.showContractPriceForReservation);
    const isReservationContractEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_OVERLAPPING_CONTRACT_ENABLED");
    const handleAlert = ()=>{
        setErrorMsg(generalApiError);
        alertRef.current?.openAlert();
    };
    const getReservationData = async (reservationId)=>{
        let reservationEntriesDisplay = [];
        setProcessing(true);
        // if there is reservationId, then user navigated from order history page, read data from getReservationById api response
        // else user navigated from reservation page, read data from updateReservationApi response
        try {
            if (reservationId) {
                const data = await dispatch((0, $f9f5d27cea32d603$export$3a69f39f385de80e)({
                    userId: userId,
                    reservationId: reservationId
                })).unwrap();
                reservationEntriesDisplay = data?.reservationEntries?.map(createDisplayEntry).filter((entry)=>entry !== null) || [];
            } else reservationEntriesDisplay = reservation?.reservationEntries?.map(createDisplayEntry).filter((entry)=>entry !== null) || [];
            setDisplayReservationData(reservationEntriesDisplay);
        } catch (err) {
            handleAlert();
        } finally{
            setProcessing(false);
        }
    };
    const createDisplayEntry = (reservationEntry)=>{
        if (!reservationEntry) return null;
        const { productId: productId, deliveryAddressId: deliveryAddressId } = reservationEntry;
        const address = shipToAddresses?.find(({ id: id })=>String(id) === String(deliveryAddressId));
        const productMap = (0, $28a6d9aafed47a89$export$e5712731ce122520)(reservationProducts);
        const productMapFormatted = (0, $28a6d9aafed47a89$export$90a2edd9d1c709b3)(reservationProducts);
        const productName = productMap[productId] || "Unknown Product";
        const productNameFormatted = productMapFormatted[productId] || "Unknown Product";
        return {
            id: reservationEntry.reservationEntryId,
            doses: parseInt(reservationEntry?.quantity, 10) || 0,
            productId: productId,
            productName: productName,
            productNameFormatted: productNameFormatted,
            listPriceValue: reservationEntry.productPrice.listPriceFormatted,
            listPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(reservationEntry.productPrice.listPriceFormatted),
            contractPriceValue: reservationEntry.productPrice.finalPriceFormatted,
            contractPrice: showContractPrice ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(reservationEntry.productPrice.finalPriceFormatted) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd),
            address: address
        };
    };
    (0, $acw62.useEffect)(()=>{
        getReservationData(reservationId);
    }, []);
    /** Get unique addresses. */ const uniqueAddressIds = new Set();
    displayReservationData?.forEach((entry)=>{
        if (entry.address && entry.address.id) uniqueAddressIds.add(entry.address.id);
    });
    const uniqueAddresses = Array.from(uniqueAddressIds);
    const reservationEntriesToDisplay = uniqueAddresses.map((reservationAddressId, i)=>{
        const reservationEntriesForThisAddress = displayReservationData?.filter(({ address: address })=>address?.id == reservationAddressId);
        (0, $382eb84981692d3a$export$7699132b966bad47)(reservationEntriesForThisAddress, 'productId');
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99e35f6bfd156bb0$export$2e2bcd8739ae039), {
            entries: reservationEntriesForThisAddress,
            PONumberValue: displayPONumberValue,
            showContractPrice: showContractPrice
        }, reservationAddressId);
    });
    const handleBackBtn = ()=>{
        history.push(isEditing ? `/${locale}/reservation/${reservationId}` : `/${locale}/reservation`);
    };
    const getTitleText = ()=>{
        if (isCancelled) return `Reservation #${reservation?.reservation?.reservationNumber}`;
        else if (isEditing) return `Update reservation #${reservation?.reservation?.reservationNumber}`;
        else return isReservationContractEnabled ? 'Review and place your reservation' : 'Place your reservation';
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            isReservationContractEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 5,
                ml: 5,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    "data-testid": "backbtn",
                    buttonType: "link",
                    sx: {
                        textTransform: 'none'
                    },
                    muiIconLeft: (0, $26cd3be04bc521db$export$2e2bcd8739ae039),
                    onClick: ()=>handleBackBtn(),
                    children: "Edit your reservation"
                })
            }),
            isCancelled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: $e91f0edba7a1c854$var$ReservationCancelledBanner,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8f0e415059e80f99$exports))),
                        alt: "cross icon",
                        width: "32",
                        height: "32"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        "data-testid": "cancelledBannerMessageContent",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "10px",
                        flex: "1 0 0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                fontSize: "16px",
                                fontWeight: "700",
                                children: "This reservation has been cancelled"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontFamily: "Aeonik Regular",
                                textAlign: "left",
                                children: `Cancelled by ${userData?.firstName} ${userData.lastName} on ${(0, $382eb84981692d3a$export$ff626af7f207c74d)(reservation?.reservation?.lastModifiedDate)}.`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e91f0edba7a1c854$var$ReservationSummaryContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        style: {
                            flex: 1,
                            padding: '24px 32px 32px 2px',
                            gap: '30px',
                            overflowX: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e91f0edba7a1c854$var$TypographyTitle, {
                                children: getTitleText()
                            }),
                            reservationEntriesToDisplay
                        ]
                    }),
                    isCancelled ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e195d6dee7d120e$export$2e2bcd8739ae039), {
                                totalDoses: reservation?.reservation?.reservationPricingInfo?.totalDoses,
                                listPrice: reservation?.reservation?.reservationPricingInfo?.totalListPrice,
                                totalPrice: reservation?.reservation?.reservationPricingInfo?.totalPrice
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    buttonType: "mds-secondary",
                                    sx: {
                                        textTransform: 'none',
                                        padding: '16px 24px'
                                    },
                                    onClick: ()=>{
                                        history.push(`/${locale}/orders`);
                                    },
                                    children: "Go back"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b381e73e7169983$export$2e2bcd8739ae039), {
                        totalDoses: reservation?.reservation?.reservationPricingInfo?.totalDoses,
                        listPrice: reservation?.reservation?.reservationPricingInfo?.totalListPrice,
                        totalPrice: reservation?.reservation?.reservationPricingInfo?.totalPrice,
                        editReservationID: reservationId,
                        handleAlert: handleAlert,
                        showContractPrice: showContractPrice
                    })
                ]
            })
        ]
    });
};
var $e91f0edba7a1c854$export$2e2bcd8739ae039 = $e91f0edba7a1c854$var$ReservationSummaryPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e56e43dd06ac0faa$export$72aef224d6115253), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");

var $1iGrQ = parcelRequire("1iGrQ");
// Source from https://github.com/alitaheri/normalize-scroll-left
let $5929c7187933e9a1$var$cachedType;
function $5929c7187933e9a1$export$a10970ffb6510128() {
    if ($5929c7187933e9a1$var$cachedType) return $5929c7187933e9a1$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $5929c7187933e9a1$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $5929c7187933e9a1$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5929c7187933e9a1$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $5929c7187933e9a1$var$cachedType;
}
function $5929c7187933e9a1$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $5929c7187933e9a1$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1iGrQ = parcelRequire("1iGrQ");

var $9Evvr = parcelRequire("9Evvr");
var $khjmj = parcelRequire("khjmj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $khjmj.default)(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9Evvr.default)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $6n0Ko = parcelRequire("6n0Ko");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $35c7816ebadb07c9$export$34861783d3c2eef8), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $35c7816ebadb07c9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $frMNQ.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $f46un.default);
    const startButtonIconProps = (0, $eD6Co.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eD6Co.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, (0, $8nd05.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, (0, $8nd05.default)({}, endButtonIconProps))
    }));
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;



var $4o7uD = parcelRequire("4o7uD");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;



var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8a85ee70c626268d$export$cdd93bd054dec359), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $f4c90fbbf54d23af$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $9e031514df70ea8e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $5929c7187933e9a1$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $4o7uD.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f2ff3c73ed46b37c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $5929c7187933e9a1$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $4o7uD.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $4o7uD.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $9Evvr.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $gzyUk.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;


var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");


const $201d04c4f83d0f82$var$LogoutFooter = ()=>{
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const logOut = async ()=>{
        try {
            localStorage.clear();
            sessionStorage.clear();
            await oktaAuth.signOut();
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        padding: "24px 0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "#85888E",
                "data-testid": "copyrightMesssage",
                children: "\xa9 2025 Moderna, Inc."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "link",
                onClick: logOut,
                sx: {
                    textTransform: "none"
                },
                "data-testid": "logoutBtn",
                children: "Log out"
            })
        ]
    });
};
var $201d04c4f83d0f82$export$2e2bcd8739ae039 = $201d04c4f83d0f82$var$LogoutFooter;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");


var $d8seH = parcelRequire("d8seH");








const $7e4dc40ebea1d956$var$typographyTextStyle = {
    fontFamily: 'Aeonik Regular',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '22px'
};
const $7e4dc40ebea1d956$var$billingAddressText = {
    headerText: "Your billing address is where we will send your invoice. ",
    subHeader: "My organization\u2019s billing address is:",
    sameAsShippingText: "Usually the same as my Shipping address:",
    differentAddressText: "A different address:"
};
const $7e4dc40ebea1d956$var$RadioTitleWrapper = (0, $d8seH.default)('div')`
  margin-left: 12px;
  display: flex;
  align-items: center;
`;
const $7e4dc40ebea1d956$var$billingInputFieldText = {
    companyName: 'Company (Doing business as) name',
    contactName: 'Billing department or contact person',
    contactEmail: 'Billing contact email',
    phoneNumber: 'Billing contact phone',
    extension: 'Ext',
    addressLine1: 'Address line 1',
    addressLine2: 'Suite Number',
    city: 'City',
    state: 'State',
    zipcode: 'ZIP code',
    zipcodeExt: 'ZIP +4'
};
const $7e4dc40ebea1d956$var$billingInputFieldPlaceholder = {
    companyName: 'e.g., Riverside Hospital, Greenleaf Community Pharmacy',
    contactName: 'e.g., Johnathan Doe, Pharmacy',
    contactEmail: 'Optional',
    phoneNumber: 'Optional',
    extension: '',
    addressLine1: 'e.g., 123 Main St',
    addressLine2: 'e.g., Dock 5, Ste 301',
    city: '',
    state: '',
    zipcode: '',
    zipcodeExt: ''
};
const $7e4dc40ebea1d956$export$6352893387d1ea9f = ({ tabIndex: tabIndex, onTabChange: onTabChange = ()=>{}, errorMsgHandler: errorMsgHandler })=>{
    const defaultFields = {
        companyName: '',
        contactName: '',
        contactEmail: '',
        phoneNumber: '',
        extension: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipcode: '',
        zipcodeExt: ''
    };
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultFields);
    const [errors, setErrors] = (0, $acw62.useState)(defaultFields);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    // Need to add user service API and error handling - ECOM-1097
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    // const [billingAddressOption, setBillingAddressOption] = useState('sameAsShipping'); Commenting for ECOM-1317 
    const USStates = (0, $bb27324e6828f86a$export$33e4322173c2e267)((0, $5cdc329eeebd56d0$export$e322f0dbe1d2219b));
    const requiredFields = [
        'companyName',
        'contactName',
        'addressLine1',
        'city',
        'state',
        'zipcode'
    ];
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    const validateField = (name, value)=>{
        let errorMsg = "";
        if (requiredFields.includes(name) && value.trim() === '') errorMsg = (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0)(value);
        else if (name === "contactEmail" && value) errorMsg = (0, $bb27324e6828f86a$export$18148d12c805c5b0)(value);
        else if (name === "phoneNumber" && value) errorMsg = (0, $bb27324e6828f86a$export$8cea6d1b8d887c4a)(value);
        else if (name === "city") errorMsg = (0, $bb27324e6828f86a$export$8e0e3fe6ebe44386)(value);
        else if (name === "zipcode") errorMsg = (0, $bb27324e6828f86a$export$5af8a774f7f1c688)(value);
        return errorMsg;
    };
    const handleShippingOptionChange = (event)=>{
        const optionSelected = event.target.value;
        if (optionSelected === 'sameAsShipping') setErrors(defaultFields);
        setBillingAddressOption(optionSelected);
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: value
        };
        setInputFields(newInputFields);
    };
    const handleBlur = (event)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateField(name, value);
        setErrors({
            ...errors,
            [name]: errorMsg
        });
    };
    const handleStateSelection = (event)=>{
        const { value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            state: value
        };
        setInputFields(newInputFields);
        const newErrors = {
            ...errors,
            state: ""
        };
        setErrors(newErrors);
    };
    let updateUserRequestBody = {
        userId: userId,
        updateType: "billing",
        organization: {
            orgType: "bill_to",
            dbaName: inputFields?.companyName,
            contactEmail: inputFields?.contactEmail,
            contactPhone: inputFields?.phoneNumber,
            address: {
                addressType: "bill_to",
                attention: inputFields?.contactName,
                line1: inputFields?.addressLine1,
                line2: inputFields?.addressLine2,
                city: inputFields?.city,
                state: inputFields?.state,
                zip: inputFields?.zipcode,
                zipExtension: inputFields?.zipcodeExt
            }
        }
    };
    const handleUpdateBilling = async (sameAsShipping = false)=>{
        // if (sameAsShipping) {
        //     const shippingAddress = userData?.addresses?.filter(address => address.addressType === 'ship_to')[0];
        //     updateUserRequestBody = {
        //         userId: userId,
        //         updateType: "billing",
        //         organization: {
        //             orgType: "bill_to",
        //             dbaName: shippingAddress?.dba,
        //             contactEmail: shippingAddress?.contactEmail,
        //             contactPhone: shippingAddress?.contactPhone,
        //             address: {
        //                 addressType: "bill_to",
        //                 attention: shippingAddress?.contactName,
        //                 line1: shippingAddress?.line1,
        //                 line2: shippingAddress?.line2,
        //                 city: shippingAddress?.city,
        //                 state: shippingAddress?.state,
        //                 zip: shippingAddress?.zip,
        //                 zipExtension: shippingAddress?.zipExtension,
        //             }
        //         }
        //     }
        // }
        try {
            setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(updateUserRequestBody);
            if (response?.status === 200) {
                dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response?.data?.email
                }));
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.data?.userStatus));
                setInputFields(defaultFields);
                if (response?.data?.userStatus == (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_BILL_COMPLETE) onTabChange(tabIndex + 1);
                else if (response?.data?.userStatus == (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ACTIVE) {
                    dispatch((0, $c89d887792446c86$export$24b370854b6f1b89)(true));
                    history.push(`/${locale}/onboarding/success`);
                }
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            errorMsgHandler(errorMessage);
        } finally{
            setIsLoading(false);
        }
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        // Commenting for ECOM-1317 
        // if(billingAddressOption === 'sameAsShipping'){
        //     handleUpdateBilling(true);
        // }
        // else{
        const validationErrors = {};
        Object.keys(inputFields).forEach((fieldName)=>{
            const errorMsg = validateField(fieldName, inputFields[fieldName]);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        if (Object.keys(validationErrors).length === 0) handleUpdateBilling();
        else setErrors(validationErrors);
    // }
    };
    const createTextField = (name, value, onChange, onBlur, isRequired)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$842aba50ed0ce9d7), {
                    label: $7e4dc40ebea1d956$var$billingInputFieldText[name],
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: name,
                    "data-testid": name,
                    name: name,
                    type: "text",
                    value: value,
                    placeholder: $7e4dc40ebea1d956$var$billingInputFieldPlaceholder[name],
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    sx: (0, $bb27324e6828f86a$export$298b9ad7287f04ba)(errors[name]),
                    error: Boolean(errors[name]),
                    helperText: errors[name],
                    FormHelperTextProps: (0, $bb27324e6828f86a$export$8148362e557f3fef)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                flexDirection: "column",
                width: "100%",
                maxWidth: "700px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            sx: $7e4dc40ebea1d956$var$typographyTextStyle,
                            children: $7e4dc40ebea1d956$var$billingAddressText?.headerText
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            sx: $7e4dc40ebea1d956$var$typographyTextStyle,
                            paddingBottom: '10px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: 'red'
                                    },
                                    children: "*"
                                }),
                                "Required"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                container: true,
                                "data-testid": "facilityInfoSection",
                                rowSpacing: '24px',
                                columnSpacing: '16px',
                                justifyContent: "start",
                                alignItems: "flex-start",
                                marginBottom: '48px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("companyName", inputFields.companyName, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("contactName", inputFields.contactName, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 5,
                                        paddingBottom: '1px',
                                        children: createTextField("contactEmail", inputFields.contactEmail, handleChange, handleBlur, false)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 5,
                                        paddingBottom: '1px',
                                        children: createTextField("phoneNumber", inputFields.phoneNumber, handleChange, handleBlur, false)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 2,
                                        paddingBottom: '1px',
                                        children: createTextField("extension", inputFields.extension, handleChange, handleBlur, false)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                container: true,
                                "data-testid": "billingAddressInfoSection",
                                rowSpacing: '24px',
                                columnSpacing: '16px',
                                justifyContent: "start",
                                alignItems: "flex-start",
                                marginBottom: '48px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: [
                                            createTextField("addressLine1", inputFields.addressLine1, handleChange, handleBlur, true),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                fontFamily: 'Aeonik Regular',
                                                fontWeight: '400',
                                                letterSpacing: '-0.28px',
                                                children: "Note: Orders cannot be delivered to P.O. Boxes"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        paddingBottom: '1px',
                                        children: createTextField("addressLine2", inputFields.addressLine2, handleChange, handleBlur, false)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 4,
                                        paddingBottom: '1px',
                                        children: createTextField("city", inputFields.city, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 4,
                                        paddingBottom: '1px',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                                            dataTestId: "stateDropdownSelection",
                                            name: "state",
                                            label: "State",
                                            options: USStates,
                                            value: inputFields.state,
                                            onChangeHandler: handleStateSelection,
                                            isRequired: true,
                                            errors: errors
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 2,
                                        paddingBottom: '1px',
                                        children: createTextField("zipcode", inputFields.zipcode, handleChange, handleBlur, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 12,
                                        sm: 2,
                                        paddingBottom: '1px',
                                        children: createTextField("zipcodeExt", inputFields.zipcodeExt, handleChange, handleBlur, false)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                type: "submit",
                id: "submit",
                sx: {
                    padding: "16px 24px",
                    textTransform: "none"
                },
                buttonType: "mds-primary",
                "data-testid": "continueBtn",
                onMouseDown: handleSubmit,
                children: "Continue"
            })
        ]
    });
};
var $7e4dc40ebea1d956$export$2e2bcd8739ae039 = $7e4dc40ebea1d956$export$6352893387d1ea9f;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");








const $5e99bfc46ae5bd2a$var$MedicalIdentificationForm = ()=>{
    const defaultFormFields = {
        addressOrgId: '',
        medicalIdentifier: '',
        type: ''
    };
    const alertRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const [rowsData, setRowsData] = (0, $acw62.useState)([
        defaultFormFields
    ]);
    const [errors, setErrors] = (0, $acw62.useState)([
        {}
    ]);
    const [formLevelErrors, setFormLevelErrors] = (0, $acw62.useState)({});
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [userAddresses, setUserAddresses] = (0, $acw62.useState)([]);
    const requiredFields = [
        'addressOrgId',
        'type',
        'medicalIdentifier'
    ];
    const typeOptions = [
        {
            label: "HIN",
            value: "HIN"
        },
        {
            label: "DEA",
            value: "DEA"
        },
        {
            label: "NPI",
            value: "NPI"
        }
    ];
    (0, $acw62.useEffect)(()=>{
        setUserAddresses((0, $bb27324e6828f86a$export$ff3c7f15a3732912)(userData?.addresses?.filter((address)=>address?.addressType !== (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).BILL_TO)));
    }, []);
    const handleAddMedicalIdentifierRow = ()=>{
        setRowsData([
            ...rowsData,
            defaultFormFields
        ]);
        setErrors([
            ...errors,
            {}
        ]);
    };
    const handleRemoveRow = (index)=>{
        const newData = rowsData.filter((item, idx)=>idx !== index);
        const newErrors = errors.filter((item, idx)=>idx !== index);
        setRowsData(newData);
        setErrors(newErrors);
    };
    const updateRowData = (index, name, value)=>{
        const newData = [
            ...rowsData
        ];
        newData[index][name] = value;
        setRowsData(newData);
    };
    const handleChange = (event, index)=>{
        const { name: name, value: value } = event.target;
        const trimmedValue = value.trim();
        updateRowData(index, name, value === '' ? '' : trimmedValue);
    };
    const handleBlur = (event, index)=>{
        const { name: name, value: value } = event.target;
        const newErrors = [
            ...errors
        ];
        newErrors[index][name] = validateField(name, value, index);
        setErrors(newErrors);
    };
    const handleAddressSelection = (event, index)=>{
        const { value: value } = event.target;
        updateRowData(index, 'addressOrgId', value);
        const newErrors = [
            ...errors
        ];
        newErrors[index]['addressOrgId'] = "";
        setErrors(newErrors);
    };
    const handleTypeSelection = (event, index)=>{
        const { value: value } = event.target;
        updateRowData(index, 'type', value);
        const newErrors = [
            ...errors
        ];
        newErrors[index]['type'] = "";
        if (rowsData[index]['medicalIdentifier']) newErrors[index]['medicalIdentifier'] = validateField('medicalIdentifier', rowsData[index]['medicalIdentifier'], index);
        if (value === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).HIN || value === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).DEA) setFormLevelErrors({
            noHinOrDea: ''
        });
    };
    const validateField = (name, value, index)=>{
        let errorMsg = "";
        if (requiredFields.includes(name) && String(value).trim() === '') errorMsg = (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0)(value);
        else if (name === "medicalIdentifier" && value) {
            let medicalIdentifierType = rowsData[index]['type'];
            if (medicalIdentifierType === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).DEA) errorMsg = (0, $bb27324e6828f86a$export$b508647eee765849)(value);
            else if (medicalIdentifierType === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).NPI) errorMsg = (0, $bb27324e6828f86a$export$383b8f6b2be52437)(value);
            else errorMsg = (0, $bb27324e6828f86a$export$293fb29162af9905)(value);
        }
        return errorMsg;
    };
    const validateFormData = ()=>{
        let isFormValid = false;
        let allRowsValidOrEmpty = true;
        let hasHinOrDea = false;
        const newErrors = rowsData.map((row, index)=>{
            const rowErrors = {};
            let isRowEmpty = true; // Assume the row is empty until a non-empty field is found
            let isRowValid = true; // Assume the row is valid until an error is found
            Object.keys(row).forEach((fieldName)=>{
                if (String(row[fieldName]).trim() !== '') isRowEmpty = false;
                const errorMsg = validateField(fieldName, row[fieldName], index);
                if (errorMsg) {
                    rowErrors[fieldName] = errorMsg;
                    isRowValid = false;
                }
                // check if at least one of the rows must have type HIN or DEA
                if (fieldName === 'type') {
                    if (row[fieldName] === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).HIN || row[fieldName] === (0, $5cdc329eeebd56d0$export$28680aab1ea491ee).DEA) {
                        hasHinOrDea = true;
                        setFormLevelErrors({
                            noHinOrDea: ''
                        });
                    }
                }
            });
            // Row must be either completely valid or completely empty to be valid
            if (!isRowEmpty && !isRowValid) allRowsValidOrEmpty = false;
            // Check if any row is completely filled and valid for submission
            if (isRowValid && !isRowEmpty && hasHinOrDea) isFormValid = true;
            return rowErrors;
        });
        if (isFormValid && allRowsValidOrEmpty) return true;
        else {
            if (!hasHinOrDea) setFormLevelErrors({
                noHinOrDea: 'You must enter at least one HIN or DEA.'
            });
            setErrors(newErrors);
            return false;
        }
    };
    const getOrgLicensesForPayload = (rowsData)=>{
        return rowsData.filter((row)=>row.medicalIdentifier.trim() !== '' || row.addressOrgId !== '' || row.type.trim() !== '').map((row)=>({
                "value": row.medicalIdentifier,
                "organizationId": row.addressOrgId,
                "type": row.type
            }));
    };
    const handleSubmit = async ()=>{
        const updateUserRequestBody = {
            "userId": userId,
            "updateType": "identification",
            "orgLicenses": getOrgLicensesForPayload(rowsData)
        };
        if (validateFormData()) try {
            setProcessing(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(updateUserRequestBody);
            if (response?.status === 200) {
                await dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response?.data?.email
                })).unwrap();
                dispatch((0, $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55)({
                    emailAddress: response?.data?.email
                })).unwrap();
                dispatch((0, $c89d887792446c86$export$24b370854b6f1b89)(true));
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.data?.userStatus));
                history.push(`/${locale}/onboarding/success`);
                setRowsData([
                    defaultFormFields
                ]);
                setFormLevelErrors({
                    ...formLevelErrors,
                    noHinOrDea: ''
                });
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message;
            setErrorMsg(errMsg || generalApiError);
            alertRef.current?.openAlert(error);
        } finally{
            setProcessing(false);
        }
    };
    const textFieldStyles = (name, index)=>{
        return {
            "& input": {
                fontFamily: 'Aeonik Regular',
                padding: "12px",
                height: '24px',
                '&::placeholder': {
                    fontStyle: 'italic'
                }
            },
            "& .MuiFormHelperText-root": {
                minHeight: '20px'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                '&:hover fieldset': {
                    border: errors[index][name] ? '2px solid #E22929' : '1px solid #191F2A'
                },
                '&.Mui-focused fieldset': {
                    border: errors[index][name] ? '2px solid #E22929' : '1px solid #191F2A'
                }
            }
        };
    };
    const createTextField = (name, label, value, onChange, onBlur, isRequired, index)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$842aba50ed0ce9d7), {
                    label: label,
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: name,
                    "data-testid": name,
                    name: name,
                    type: "text",
                    value: value,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    sx: textFieldStyles(name, index),
                    error: Boolean(errors[index][name]),
                    helperText: errors[index][name],
                    FormHelperTextProps: (0, $bb27324e6828f86a$export$8148362e557f3fef),
                    inputProps: {
                        'data-testid': `${name}-input`
                    }
                })
            ]
        });
    };
    const FormRow = (index)=>{
        const formRow = rowsData[index];
        const showLabels = index === 0;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            "data-testid": "medicalIdentificationRow",
            rowSpacing: '24px',
            columnSpacing: '16px',
            justifyContent: "start",
            alignItems: "flex-start",
            marginTop: '1px',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 6,
                    paddingBottom: '1px',
                    marginTop: showLabels ? '' : '7px',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                        dataTestId: "addressDropdownSelection",
                        name: "addressOrgId",
                        label: showLabels ? "Address" : "",
                        options: userAddresses,
                        value: formRow.addressOrgId,
                        onChangeHandler: (e)=>handleAddressSelection(e, index),
                        isRequired: true,
                        errors: errors[index]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 2.5,
                    paddingBottom: '1px',
                    marginTop: showLabels ? '' : '7px',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                        dataTestId: "identifierTypeDropdownSelection",
                        name: "type",
                        label: showLabels ? "Type" : "",
                        options: typeOptions,
                        value: formRow.type,
                        onChangeHandler: (e)=>handleTypeSelection(e, index),
                        isRequired: true,
                        errors: errors[index]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 2.5,
                    paddingBottom: '1px',
                    children: createTextField('medicalIdentifier', showLabels ? 'Number' : '', formRow.medicalIdentifier, (e)=>{
                        handleChange(e, index);
                    }, (e)=>{
                        handleBlur(e, index);
                    }, showLabels && true, index)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    marginTop: showLabels ? 5 : 2,
                    children: rowsData.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        width: "30px",
                        alt: "crossIcon",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($93cf4f4850471977$exports))),
                        onClick: ()=>handleRemoveRow(index),
                        "data-testid": "crossicon",
                        style: {
                            cursor: 'pointer'
                        }
                    })
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                flexDirection: "column",
                width: "100%",
                maxWidth: "680px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                            children: "Enter the HIN, DEA, and NPI numbers most closely associated with your Contract Affiliations (GPO or PBG). We use these numbers to locate and validate your account and pricing."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            mt: 2,
                            pl: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            style: {
                                listStyleType: 'disc',
                                paddingLeft: '20px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                                        children: "Do not enter numbers associated with individual practitioners."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                                        children: "Enter multiple numbers for best results."
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 2,
                        mb: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$12d2d7b61a5c0eb1), {
                                    children: "*"
                                }),
                                " At least one HIN or DEA number is required"
                            ]
                        })
                    }),
                    rowsData.map((rowData, index)=>FormRow(index)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            sx: {
                                textTransform: "none"
                            },
                            "data-testid": "addMedicalIdentificationButton",
                            buttonType: "link",
                            onClick: handleAddMedicalIdentifierRow,
                            children: "Add another HIN or DEA number"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 4,
                        children: formLevelErrors.noHinOrDea && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            textAlign: 'left',
                            color: '#E22929',
                            fontFamily: 'Aeonik Regular',
                            children: formLevelErrors.noHinOrDea
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            sx: {
                                padding: "16px 24px",
                                textTransform: "none"
                            },
                            "data-testid": "submitMedicalIdentificationButton",
                            buttonType: "mds-primary",
                            onClick: handleSubmit,
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
};
var $5e99bfc46ae5bd2a$export$2e2bcd8739ae039 = $5e99bfc46ae5bd2a$var$MedicalIdentificationForm;




var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");






const $f8a044636b6056cb$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    display: "flex",
    justifyContent: 'left',
    marginY: "24px"
};
const $f8a044636b6056cb$export$d15788ef06082ab7 = ()=>{
    const defaultInputFields = {
        firstName: '',
        lastName: ''
    };
    const defaultPhoneNumber = {
        phoneNumber: '',
        extension: ''
    };
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultInputFields);
    const [errors, setErrors] = (0, $acw62.useState)({
        phoneNumbers: [
            {
                phoneNumber: '',
                extension: ''
            }
        ]
    });
    const [phoneNumbers, setPhoneNumbers] = (0, $acw62.useState)([
        defaultPhoneNumber
    ]);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const requiredFields = [
        'firstName',
        'lastName'
    ];
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    (0, $acw62.useEffect)(()=>{
        const checkIsFormValid = ()=>{
            const requiredFieldsFilled = requiredFields.every((field)=>inputFields[field].trim().length !== 0);
            const atLeastOnePhoneNumber = phoneNumbers.some((phone)=>phone.phoneNumber.trim().length > 0);
            const phoneNumbersValid = phoneNumbers.every((phone, index)=>{
                const phoneErrors = errors.phoneNumbers?.[index] || {};
                return !phone.phoneNumber.trim() || phoneErrors.phoneNumber === "";
            });
            const nonPhoneNumberErrors = {
                ...errors
            };
            delete nonPhoneNumberErrors.phoneNumbers;
            const noErrors = Object.values(nonPhoneNumberErrors).every((errorMsg)=>errorMsg === "");
            const noPhoneNumberErrors = errors?.phoneNumbers?.every((phoneError)=>{
                return phoneError && Object?.values(phoneError)?.every((errorMsg)=>errorMsg === "");
            });
            return requiredFieldsFilled && atLeastOnePhoneNumber && phoneNumbersValid && noErrors && noPhoneNumberErrors;
        };
        checkIsFormValid();
    }, [
        inputFields,
        phoneNumbers,
        errors
    ]);
    const createPersonRequestBody = {
        userId: userId,
        firstName: inputFields?.firstName,
        lastName: inputFields?.lastName,
        phones: phoneNumbers
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: value
        };
        setInputFields(newInputFields);
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const validationErrors = {};
        Object.keys(inputFields).forEach((fieldName)=>{
            const errorMsg = validateInputFields(fieldName, inputFields[fieldName]);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        phoneNumbers.forEach((phone, index)=>{
            const phoneErrorMsg = validateInputFields('phoneNumber', phone.phoneNumber);
            if (phoneErrorMsg) {
                if (!validationErrors.phoneNumbers) validationErrors.phoneNumbers = [];
                validationErrors.phoneNumbers[index] = {
                    ...validationErrors.phoneNumbers[index],
                    phoneNumber: phoneErrorMsg
                };
            }
        });
        if (Object.keys(validationErrors).length > 0 || validationErrors.phoneNumbers && validationErrors.phoneNumbers.length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$c562c31bf17d291e)(createPersonRequestBody);
            if (response?.status === 200) {
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.data?.userStatus));
                setInputFields(defaultInputFields);
                setPhoneNumbers([
                    defaultPhoneNumber
                ]);
                dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response?.data?.email
                }));
                setIsLoading(false);
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message;
            setErrorMsg(errMsg || generalApiError);
            alertRef.current?.openAlert(error);
        } finally{
            setIsLoading(false);
        }
    };
    const handlePhoneChange = (index, value, name)=>{
        const newPhoneNumbers = [
            ...phoneNumbers
        ];
        newPhoneNumbers[index][name] = value;
        setPhoneNumbers(newPhoneNumbers);
        const errorMsg = validateInputFields(name, value);
        const newPhoneErrors = [
            ...errors.phoneNumbers ?? []
        ];
        newPhoneErrors[index] = {
            ...newPhoneErrors[index],
            [name]: errorMsg
        };
        setErrors({
            ...errors,
            phoneNumbers: newPhoneErrors
        });
    };
    const handleAddPhoneNumber = ()=>{
        setPhoneNumbers([
            ...phoneNumbers,
            {
                ...defaultPhoneNumber
            }
        ]);
        setErrors({
            ...errors,
            phoneNumbers: [
                ...errors.phoneNumbers,
                {
                    phoneNumber: '',
                    extension: ''
                }
            ]
        });
    };
    const handleRemovePhoneNumber = (index)=>{
        const updatedPhoneNumbers = [
            ...phoneNumbers.slice(0, index),
            ...phoneNumbers.slice(index + 1)
        ];
        const updatedPhoneErrors = [
            ...errors.phoneNumbers.slice(0, index),
            ...errors.phoneNumbers.slice(index + 1)
        ];
        setPhoneNumbers(updatedPhoneNumbers);
        setErrors({
            ...errors,
            phoneNumbers: updatedPhoneErrors
        });
    };
    const handleBlur = (event, index)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateInputFields(name, value);
        const newErrors = {
            ...errors
        };
        if (index !== undefined) newErrors.phoneNumbers[index] = {
            ...newErrors.phoneNumbers[index],
            [name]: errorMsg
        };
        else newErrors[name] = errorMsg;
        setErrors(newErrors);
    };
    const fieldValidations = {
        firstName: (0, $bb27324e6828f86a$export$b135c3f9b9f02308),
        lastName: (0, $bb27324e6828f86a$export$b135c3f9b9f02308)
    };
    const validateInputFields = (field, value, phoneNumbers = [])=>{
        if (field === 'phoneNumber') return (0, $bb27324e6828f86a$export$30dc0b291f505e34)(value, phoneNumbers);
        const validationFunction = fieldValidations[field];
        return validationFunction ? validationFunction(value) : "";
    };
    const createTextField = (key, label, placeholder, value, onChange, onBlur, isRequired, error, index = null)=>{
        const errorKey = index !== null ? `${key}${index}` : key;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$842aba50ed0ce9d7), {
                    label: label,
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: errorKey,
                    name: errorKey,
                    "data-testid": errorKey,
                    type: "text",
                    value: value,
                    placeholder: placeholder,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    error: Boolean(error) || Boolean(errors[errorKey]),
                    helperText: error || errors[errorKey],
                    sx: (0, $bb27324e6828f86a$export$298b9ad7287f04ba)(errors[errorKey]),
                    FormHelperTextProps: (0, $bb27324e6828f86a$export$8148362e557f3fef)
                })
            ]
        });
    };
    const PhoneNumberForm = (index)=>{
        const phoneNumber = phoneNumbers[index];
        const showTitles = index === 0;
        // If more than 1 phone number, shrink to fit container
        const phoneNumberGridSize = phoneNumbers.length > 1 ? 5 : 6;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            columnSpacing: 2,
            justifyContent: "start",
            alignItems: "flex-start",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: phoneNumberGridSize,
                    children: createTextField("phoneNumber", showTitles ? "Your phone number" : "", "123-456-7890", phoneNumber.phoneNumber, (e)=>handlePhoneChange(index, e.target.value, 'phoneNumber'), handleBlur, showTitles, errors.phoneNumbers?.[index]?.phoneNumber, index)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: phoneNumberGridSize,
                    children: createTextField("extension", showTitles ? "Ext" : "", "123", phoneNumber.extension, (e)=>handlePhoneChange(index, e.target.value, 'extension'), handleBlur, false)
                }),
                phoneNumbers.length > 1 && index !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    sm: 1,
                    paddingTop: "15px",
                    sx: {
                        display: 'flex',
                        alignItems: 'flex-end'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        width: "30px",
                        alt: "crossIcon",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($93cf4f4850471977$exports))),
                        onClick: ()=>handleRemovePhoneNumber(index),
                        "data-testid": "crossicon",
                        style: {
                            cursor: 'pointer'
                        }
                    })
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        maxWidth: '700px',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                    "data-testid": "onboardingContactInfo",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: 'flex',
                            justifyContent: 'left',
                            padding: '20px 0px',
                            flexDirection: 'column',
                            gap: 2,
                            width: '700px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    textAlign: 'left',
                                    fontFamily: "Aeonik Regular",
                                    color: "#191F2A",
                                    children: "Contact Information"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                    fontFamily: "Aeonik Regular",
                                    color: "#191F2A",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$12d2d7b61a5c0eb1), {
                                            children: "*"
                                        }),
                                        " Required field"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            container: true,
                            rowSpacing: '24px',
                            columnSpacing: '16px',
                            justifyContent: "start",
                            alignItems: "flex-start",
                            style: {
                                marginBottom: '8px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    paddingBottom: '1px',
                                    children: createTextField("firstName", "Your first name", "Jonathan", inputFields.firstName, handleChange, handleBlur, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    paddingBottom: '1px',
                                    children: createTextField("lastName", "Your last name", "Doe", inputFields.lastName, handleChange, handleBlur, true)
                                })
                            ]
                        }),
                        phoneNumbers.map((phoneNumber, index)=>PhoneNumberForm(index)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            id: "addPhoneNumberLink",
                            sx: {
                                textTransform: "none"
                            },
                            buttonType: "link",
                            "data-testid": "addPhoneNumberBtn",
                            onClick: handleAddPhoneNumber,
                            children: "Add another phone number"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            sx: $f8a044636b6056cb$var$buttonsContainerSxStyles,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                type: "submit",
                                id: "submit",
                                sx: {
                                    padding: "16px 24px",
                                    textTransform: "none"
                                },
                                buttonType: "mds-primary",
                                "data-testid": "submitBtn",
                                children: "Continue"
                            })
                        })
                    ]
                }, "onboardingContactInfo")
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");








const $ac2496d56c300a8b$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    display: "flex",
    justifyContent: 'left',
    marginY: "24px"
};
const $ac2496d56c300a8b$export$c65dc357bce91076 = ({ tabIndex: tabIndex, onTabChange: onTabChange = ()=>{}, customerSegmentClasses: customerSegmentClasses, setUserOrganizationInfo: setUserOrganizationInfo, setShowMatchFoundForm: setShowMatchFoundForm, setSearchOrgResults: setSearchOrgResults, handleErrorMsg: handleErrorMsg })=>{
    const defaultInputFields = {
        orgLegalName: '',
        dbaName: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
        zip4: '',
        customerSegment: ''
    };
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultInputFields);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const requiredFields = [
        'dbaName',
        'line1',
        'city',
        'state',
        'zipcode'
    ];
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    (0, $acw62.useEffect)(()=>{
        const checkIsFormValid = ()=>{
            const requiredFieldsFilled = requiredFields.every((field)=>inputFields[field].trim().length !== 0);
            return requiredFieldsFilled;
        };
        checkIsFormValid();
    }, [
        inputFields,
        errors
    ]);
    const USStates = (0, $5cdc329eeebd56d0$export$e322f0dbe1d2219b).map((state)=>{
        return {
            "value": state,
            "label": state
        };
    });
    const userOrgInfo = {
        "userId": userId,
        "updateType": "organization",
        "organization": {
            "forceCreate": true,
            "orgType": "sold_to",
            "customerSegment": inputFields?.customerSegment,
            "legalName": inputFields?.orgLegalName,
            "dbaName": inputFields?.dbaName,
            "address": {
                "addressType": (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO,
                "line1": inputFields?.line1,
                "line2": inputFields?.line2,
                "city": inputFields?.city,
                "state": inputFields?.state,
                "zip": inputFields?.zipcode,
                "zipExtension": inputFields?.zip4
            }
        }
    };
    const searchOrgRequestBody = {
        pagination: {
            pageNumber: 0,
            pageSize: 4
        },
        name: inputFields?.dbaName,
        address: {
            addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO,
            line1: inputFields?.line1,
            line2: inputFields?.line2,
            city: inputFields?.city,
            state: inputFields?.state,
            zip: inputFields?.zipcode
        }
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: value
        };
        setInputFields(newInputFields);
    };
    const createSoldToOrg = async ()=>{
        const updateDetailsResponse = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(userOrgInfo);
        if (updateDetailsResponse?.status === 200) {
            dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(updateDetailsResponse?.data?.userStatus));
            setInputFields(defaultInputFields);
            onTabChange(tabIndex + 1);
            dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                emailAddress: updateDetailsResponse?.data?.email
            })).unwrap();
        }
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const validationErrors = {};
        Object.keys(inputFields).forEach((fieldName)=>{
            const errorMsg = validateInputFields(fieldName, inputFields[fieldName]);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$414ace4b9ab2a622)(searchOrgRequestBody);
            if (response?.status === 200) {
                if (response?.data?.total === 0) await createSoldToOrg();
                else {
                    setUserOrganizationInfo(userOrgInfo);
                    setSearchOrgResults(response?.data);
                    setShowMatchFoundForm(true);
                }
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setIsLoading(false);
        }
    };
    const handleStateSelection = (event)=>{
        const { value: value } = event.target;
        const updatedInputs = {
            ...inputFields,
            state: value
        };
        setInputFields(updatedInputs);
        const newErrors = {
            ...errors,
            state: ""
        };
        setErrors(newErrors);
    };
    const handleCustomerSegment = (event)=>{
        const { value: value } = event.target;
        const updatedInputs = {
            ...inputFields,
            customerSegment: value
        };
        setInputFields(updatedInputs);
        const newErrors = {
            ...errors,
            customerSegment: ""
        };
        setErrors(newErrors);
    };
    const handleBlur = (event, index)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateInputFields(name, value);
        const newErrors = {
            ...errors
        };
        newErrors[name] = errorMsg;
        setErrors(newErrors);
    };
    const fieldValidations = {
        dbaName: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0),
        line1: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0),
        city: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0),
        state: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0),
        zipcode: (0, $bb27324e6828f86a$export$5af8a774f7f1c688),
        customerSegment: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0)
    };
    const validateInputFields = (field, value)=>{
        const validationFunction = fieldValidations[field];
        return validationFunction ? validationFunction(value) : "";
    };
    const createTextField = (key, label, placeholder, value, onChange, onBlur, isRequired, error, index = null)=>{
        const errorKey = index !== null ? `${key}${index}` : key;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$842aba50ed0ce9d7), {
                    label: label,
                    isRequired: isRequired
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: errorKey,
                    name: errorKey,
                    "data-testid": errorKey,
                    type: "text",
                    value: value,
                    placeholder: placeholder,
                    onChange: onChange,
                    onBlur: onBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    error: Boolean(error) || Boolean(errors[errorKey]),
                    helperText: error || errors[errorKey],
                    sx: (0, $bb27324e6828f86a$export$298b9ad7287f04ba)(errors[errorKey]),
                    FormHelperTextProps: (0, $bb27324e6828f86a$export$8148362e557f3fef)
                })
            ]
        });
    };
    const OrganizationForm = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                    "data-testid": "onboardingContactInfo",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: 'flex',
                            justifyContent: 'left',
                            padding: '20px 0px',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                fontSize: '24px',
                                fontWeight: 700,
                                textAlign: 'left',
                                fontFamily: "Aeonik Regular",
                                color: "#191F2A",
                                children: "Your organization"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            container: true,
                            rowSpacing: '24px',
                            columnSpacing: '16px',
                            justifyContent: "start",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    paddingBottom: '1px',
                                    children: createTextField("orgLegalName", "Official organization name (legal)", "e.g., Townsville Health Partners, LLC, Pacifico Companies Inc., etc", inputFields.orgLegalName, handleChange, handleBlur, false)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    paddingBottom: '1px',
                                    children: createTextField("dbaName", `\u{201C}Doing business as\u{201D} name`, "e.g., Townsville Pharmacies, Pacific Health Partners, etc", inputFields.dbaName, handleChange, handleBlur, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    paddingBottom: '1px',
                                    gap: '24px',
                                    "data-testid": "customerSegment",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                                        dataTestId: "customerSegmentDropdown",
                                        name: "customerSegment",
                                        label: "Organization type",
                                        options: customerSegmentClasses,
                                        value: inputFields.customerSegment,
                                        onChangeHandler: handleCustomerSegment,
                                        isRequired: true,
                                        errors: errors
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: 'flex',
                            justifyContent: 'left',
                            padding: '20px 0px',
                            flexDirection: 'column',
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    textAlign: 'left',
                                    fontFamily: "Aeonik Regular",
                                    color: "#191F2A",
                                    children: "Your organization's legal address"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                    fontFamily: "Aeonik Regular",
                                    color: "#191F2A",
                                    children: "Enter the address your organization uses for legal and contract documentation. This address can be used as your \u201CSold to\u201D address and is financially responsible for orders."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            container: true,
                            rowSpacing: '24px',
                            columnSpacing: '16px',
                            justifyContent: "start",
                            alignItems: "flex-start",
                            style: {
                                marginBottom: '8px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    paddingBottom: '1px',
                                    children: createTextField("line1", "Address Line 1", "e.g., 123 Main St", inputFields.line1, handleChange, handleBlur, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    paddingBottom: '1px',
                                    children: createTextField("line2", "Suite Number", "e.g., Dock 5, Ste 301", inputFields.line2, handleChange, handleBlur, false)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 4,
                                    paddingBottom: '1px',
                                    children: createTextField("city", "City", "City", inputFields.city, handleChange, handleBlur, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 4,
                                    paddingBottom: '1px',
                                    "data-testid": "state",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $496aecc9ad45b428$export$2e2bcd8739ae039), {
                                        dataTestId: "stateDropdownSelection",
                                        name: "state",
                                        label: "State",
                                        options: USStates,
                                        value: inputFields.state,
                                        onChangeHandler: handleStateSelection,
                                        isRequired: true,
                                        errors: errors
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 2,
                                    paddingBottom: '1px',
                                    children: createTextField("zipcode", "ZIP Code", "12345", inputFields.zipcode, handleChange, handleBlur, true)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 2,
                                    paddingBottom: '1px',
                                    children: createTextField("zip4", "ZIP +4", "0123", inputFields.zip4, handleChange, handleBlur, false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            sx: $ac2496d56c300a8b$var$buttonsContainerSxStyles,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                type: "submit",
                                id: "submit",
                                sx: {
                                    padding: "16px 24px",
                                    textTransform: "none"
                                },
                                buttonType: "mds-primary",
                                "data-testid": "submitBtn",
                                children: "Continue"
                            })
                        })
                    ]
                }, "onboardingContactInfo")
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        maxWidth: '700px',
        children: OrganizationForm
    });
};





var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");


var $3bYfT = parcelRequire("3bYfT");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");





var $3bYfT = parcelRequire("3bYfT");


var $ayMG0 = parcelRequire("ayMG0");


var $c44fad00064ece45$exports = {};
$c44fad00064ece45$exports = new URL("buildingOffice.0e1161fb.svg", import.meta.url).toString();



var $3bYfT = parcelRequire("3bYfT");
const $0306024e2620d950$var$addressInfo = {
    bill_to: {
        title: "Bill to address: ",
        iconType: (0, (/*@__PURE__*/$parcel$interopDefault($219e719d3b909e54$exports)))
    },
    ship_to: {
        title: "Ship to address: ",
        iconType: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports)))
    },
    sold_to: {
        title: "Legal address: ",
        iconType: (0, (/*@__PURE__*/$parcel$interopDefault($c44fad00064ece45$exports)))
    }
};
const $0306024e2620d950$export$98ea815cb985c317 = ({ address: address, dbaName: dbaName, addressType: addressType, hasTitle: hasTitle = false, sx: sx = {} })=>{
    const addressTypeInfo = address?.addressType || addressType;
    const { title: title = '', iconType: iconType = '' } = $0306024e2620d950$var$addressInfo[addressTypeInfo];
    const { line1: line1 = '', line2: line2 = '', city: city = '', state: state = '', zip: zip = '' } = address || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        gap: "10px",
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: iconType,
                alt: `${title} icon`,
                width: "24",
                height: "22"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontWeight: "700",
                        fontFamily: "Aeonik Regular",
                        children: hasTitle ? title : dbaName
                    }),
                    address ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: [
                            hasTitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                children: dbaName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                children: line1
                            }),
                            line2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                children: line2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                children: `${city}, ${state}, ${zip}`
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        sx: {
                            fontStyle: 'italic',
                            color: 'grey'
                        },
                        children: "Not yet entered. If you choose this organization, you will be required to enter a billing address to proceed."
                    })
                ]
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");









const $6b186c3dee45c51f$var$AffiliateOrgConfirmationModal = ({ closeModal: closeModal, openModal: openModal, soldToAddress: soldToAddress, billToAddress: billToAddress, orgId: orgId, dbaName: dbaName, tabIndex: tabIndex, handleErrorMsg: handleErrorMsg, onTabChange: onTabChange = ()=>{} })=>{
    const theme = (0, $14H9o.default)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    const userEmail = userData?.email;
    const handleAccountAssociation = async ()=>{
        try {
            setProcessing(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$38d826a0f5215b04)(affiliateOrgWithPersonRequestBody);
            if (response?.status === 200) {
                const userRes = await dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: userEmail
                })).unwrap();
                dispatch((0, $fdf4ab7ce1c873bd$export$3d59e4a4b1418f55)({
                    emailAddress: userEmail
                })).unwrap();
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(userRes?.userStatus));
                if (userRes?.userStatus == (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ACTIVE) {
                    dispatch((0, $c89d887792446c86$export$24b370854b6f1b89)(true));
                    history.push(`/${locale}/onboarding/success`);
                }
                closeModal();
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    const affiliateOrgWithPersonRequestBody = {
        userId: userId,
        orgId: orgId
    };
    const OrgSelection = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        flexWrap: "wrap",
        gap: "23px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontSize: "23px",
                fontWeight: "700",
                lineHeight: "30px",
                textAlign: "left",
                paddingBottom: "8px",
                children: "Are you sure this is your organization?"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        gap: "8px",
                        display: "grid",
                        paddingBottom: "10px",
                        width: '628px',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                                type: "warning",
                                messageText: `Your account will be permanently associated with the existing details for ${dbaName}.`,
                                dataTestId: "associateAccountWarning"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                                type: "warning",
                                messageText: 'If you require a different billing address than the one listed, click cancel and choose \u201CNone of these matches my organization."',
                                dataTestId: "associateBillingAddressWarning"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                        processing: processing
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        minWidth: '600px',
                        mb: 3,
                        alignItems: "flex-start",
                        padding: "16px 24px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0306024e2620d950$export$98ea815cb985c317), {
                                address: soldToAddress,
                                dbaName: dbaName,
                                addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO,
                                hasTitle: true,
                                sx: {
                                    width: '290px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0306024e2620d950$export$98ea815cb985c317), {
                                address: billToAddress,
                                dbaName: dbaName,
                                addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).BILL_TO,
                                hasTitle: true,
                                sx: {
                                    width: '290px'
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-secondary",
                        sx: {
                            padding: "16px 32px",
                            textTransform: "none"
                        },
                        onClick: closeModal,
                        children: "Go back"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-primary",
                        sx: {
                            padding: "16px 32px",
                            textTransform: "none"
                        },
                        onClick: handleAccountAssociation,
                        color: "primary",
                        variant: "contained",
                        children: "Associate my account with this organization"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            width: '675px',
            padding: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            overflowX: 'hidden',
            textAlign: 'left',
            color: "#191F2A",
            [theme.breakpoints.down('md')]: {
                width: '400px'
            }
        },
        modalContent: OrgSelection
    });
};
var $6b186c3dee45c51f$export$2e2bcd8739ae039 = $6b186c3dee45c51f$var$AffiliateOrgConfirmationModal;



var $ayMG0 = parcelRequire("ayMG0");





var $ayMG0 = parcelRequire("ayMG0");

var $2cPwN = parcelRequire("2cPwN");
var $3bYfT = parcelRequire("3bYfT");
const $d17069175ac33db1$var$CustomSpinner = ({ message: message, sx: sx = {}, messageSx: messageSx = {} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: sx,
        "data-testid": "spinnerContainer",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                pointerEvents: 'all',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    paddingTop: '16px',
                    textAlign: 'center',
                    fontFamily: 'Aeonik Regular',
                    sx: messageSx,
                    children: message
                })
            ]
        })
    });
};
var $d17069175ac33db1$export$2e2bcd8739ae039 = $d17069175ac33db1$var$CustomSpinner;


const $af30352c9ca77d86$var$addressTileStyle = {
    display: 'flex',
    width: '348px',
    height: '147px',
    padding: '24px',
    alignItems: 'flex-start',
    borderRadius: '16px',
    border: '1px solid #E6E8ED',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)'
};
const $af30352c9ca77d86$var$spinnerStyle = {
    width: '100%',
    height: '400px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
const $af30352c9ca77d86$var$ShippingAddressesModal = ({ openModal: openModal, closeModal: closeModal, shippingLocations: shippingLocations, dbaName: dbaName, processing: processing })=>{
    const NoShippingAddresses = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            width: '100%',
            height: '400px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$da524f2075150321), {
                sx: {
                    fontWeight: 300
                },
                children: "No shipping addresses currently exist for this organization."
            })
        });
    };
    const ShippingAddresses = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '23px',
        flexDirection: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$da524f2075150321), {
                children: `Shipping addresses for ${dbaName}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                children: "You can add more shipping locations after you associate your account with this organization."
            }),
            processing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d17069175ac33db1$export$2e2bcd8739ae039), {
                message: "Loading shipping addresses...",
                sx: $af30352c9ca77d86$var$spinnerStyle
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: '24px',
                flexWrap: 'wrap',
                textAlign: 'left',
                children: shippingLocations?.length > 0 ? shippingLocations.map((address)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0306024e2620d950$export$98ea815cb985c317), {
                        address: address,
                        dbaName: address.dbaName,
                        sx: $af30352c9ca77d86$var$addressTileStyle
                    }, address?.organizationId);
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NoShippingAddresses, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        padding: "16px 24px",
                        textTransform: "none"
                    },
                    buttonType: "mds-secondary",
                    "data-testid": "closeShippingAddressesModalBtn",
                    onClick: ()=>{
                        closeModal();
                    },
                    children: "Close"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            '#crossIcon': {
                marginTop: '5px'
            },
            width: '775px',
            padding: '24px',
            display: 'flex',
            alignItems: 'flex-start'
        },
        modalContent: ShippingAddresses
    });
};
var $af30352c9ca77d86$export$2e2bcd8739ae039 = $af30352c9ca77d86$var$ShippingAddressesModal;




const $161552e2562b363d$export$685e3ef188dda2de = ({ orgInfo: orgInfo, handleErrorMsg: handleErrorMsg, ...props })=>{
    //TBD: replace this once filtering is done on the BE
    const billToAddress = orgInfo?.organization?.addresses?.find((address)=>address?.addressType === (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).BILL_TO) ?? null;
    const soldToAddress = orgInfo?.organization?.addresses?.find((address)=>address?.addressType === (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO) ?? null;
    const orgId = orgInfo?.organization?.id;
    const dbaName = orgInfo?.organization?.dbaName;
    const [openAffiliateOrgConfirmationModal, setOpenAffiliateOrgConfirmationModal] = (0, $acw62.useState)(false);
    const [openShippingAddressesModal, setOpenShippingAddressesModal] = (0, $acw62.useState)(false);
    const [shippingLocations, setShippingLocations] = (0, $acw62.useState)([]);
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const closeConfirmationModal = ()=>{
        setOpenAffiliateOrgConfirmationModal(false);
    };
    const closeShippingAddressesModal = ()=>setOpenShippingAddressesModal(false);
    const handleViewShippingAddresses = async (orgId)=>{
        try {
            setProcessing(true);
            setOpenShippingAddressesModal(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$c07c686062478869)(orgId);
            if (response?.status === 200) setShippingLocations(response?.data?.organization?.locations);
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
        sx: {
            padding: "16px 24px 24px 24px",
            marginBottom: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
        },
        children: [
            openShippingAddressesModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af30352c9ca77d86$export$2e2bcd8739ae039), {
                openModal: openShippingAddressesModal,
                closeModal: closeShippingAddressesModal,
                shippingLocations: shippingLocations,
                dbaName: dbaName,
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$b534932db7eb0121), {
                mb: '16px',
                children: dbaName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                minWidth: '600px',
                mb: '16px',
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0306024e2620d950$export$98ea815cb985c317), {
                        address: soldToAddress,
                        dbaName: dbaName,
                        addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO,
                        hasTitle: true,
                        sx: {
                            width: '326px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0306024e2620d950$export$98ea815cb985c317), {
                        address: billToAddress,
                        dbaName: dbaName,
                        addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).BILL_TO,
                        hasTitle: true,
                        sx: {
                            width: '326px'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "link",
                "data-testid": "viewShippingAddressBtn",
                sx: {
                    textTransform: "none",
                    marginBottom: '24px'
                },
                onClick: ()=>{
                    handleViewShippingAddresses(orgInfo?.organization?.id);
                },
                leftIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ddde1bb88cb108c8$exports))),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    fontSize: '16px',
                    children: "View Shipping Addresses"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                style: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        padding: "16px 24px",
                        textTransform: "none"
                    },
                    buttonType: "mds-outline",
                    "data-testid": "confirmOrgBtn",
                    onClick: ()=>{
                        setOpenAffiliateOrgConfirmationModal(true);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        fontWeight: 700,
                        children: [
                            dbaName,
                            " is my organization"
                        ]
                    })
                })
            }),
            openAffiliateOrgConfirmationModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b186c3dee45c51f$export$2e2bcd8739ae039), {
                openModal: openAffiliateOrgConfirmationModal,
                closeModal: closeConfirmationModal,
                soldToAddress: soldToAddress,
                billToAddress: billToAddress,
                orgId: orgId,
                dbaName: dbaName,
                handleErrorMsg: handleErrorMsg,
                ...props
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

const $cbec5b7b002b6050$export$5a23558ed4d380e0 = ({ page: page, pageCount: pageCount, onPageChange: onPageChange })=>{
    const handleBackButtonClick = ()=>{
        if (page > 1) onPageChange(page - 1);
    };
    const handleNextButtonClick = ()=>{
        if (page < pageCount) onPageChange(page + 1);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 10
        },
        id: "Pagination",
        "data-testid": "pagination",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63bd8d80cef7fd02$export$2e2bcd8739ae039), {
                onClick: handleBackButtonClick,
                fontSize: "large",
                sx: {
                    color: 'secondary.graphical',
                    opacity: page === 1 ? 0.5 : 1,
                    pointerEvents: page === 1 ? 'none' : 'auto',
                    cursor: 'pointer'
                },
                "aria-label": "Go to previous page"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                variant: "body1",
                children: [
                    page,
                    " of ",
                    pageCount
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f2bda4f7177714d$export$2e2bcd8739ae039), {
                onClick: handleNextButtonClick,
                fontSize: "large",
                sx: {
                    color: 'secondary.graphical',
                    opacity: page === pageCount ? 0.5 : 1,
                    pointerEvents: page === pageCount ? 'none' : 'auto',
                    cursor: 'pointer'
                },
                "aria-label": "Go to next page"
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");






var $acw62 = parcelRequire("acw62");



const $6ee72ac05f12ad90$var$spinnerStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    backgroundColor: '#F9F9FA',
    pointerEvents: 'none',
    flexDirection: 'column'
};
const $6ee72ac05f12ad90$var$spinnerMessageStyle = {
    fontSize: '24px',
    fontWeight: 400
};
const $6ee72ac05f12ad90$var$OrgNotFoundConfirmationModal = ({ closeModal: closeModal, openModal: openModal, tabIndex: tabIndex, onTabChange: onTabChange, handleErrorMsg: handleErrorMsg, userOrganizationInfo: userOrganizationInfo })=>{
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleUpdateNoOrgFound = async ()=>{
        try {
            setProcessing(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$69ab7a44bdb54f3c)(userOrganizationInfo);
            if (response?.status === 200) {
                dispatch((0, $c89d887792446c86$export$d0a94b87b12755e3)(response?.data?.userStatus));
                onTabChange(tabIndex + 1);
                dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                    emailAddress: response?.data?.email
                }));
            }
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setProcessing(false);
        }
    };
    const OrgNotFoundContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        flexWrap: "wrap",
        gap: "23px",
        children: [
            processing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d17069175ac33db1$export$2e2bcd8739ae039), {
                message: "Updating Organization Details...",
                sx: $6ee72ac05f12ad90$var$spinnerStyles,
                messageSx: $6ee72ac05f12ad90$var$spinnerMessageStyle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                fontSize: "23px",
                fontWeight: "700",
                lineHeight: "30px",
                textAlign: "left",
                paddingBottom: "8px",
                children: "Confirm your selection"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$5536f4fce3211bea), {
                        mb: 2,
                        children: "Are you sure none of the organizations listed is yours?"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                        mb: 6,
                        children: "Choosing a matching organization will import the associated billing and shipping addresses, medical licenses, and purchasing contract associations, and could expedite the set-up of your account and shipping time for your first order."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-secondary",
                        sx: {
                            padding: "16px 32px",
                            textTransform: "none"
                        },
                        onClick: closeModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-primary",
                        sx: {
                            padding: "16px 32px",
                            textTransform: "none"
                        },
                        onClick: handleUpdateNoOrgFound,
                        color: "primary",
                        variant: "contained",
                        children: "None of the organizations listed are mine"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
        openModal: openModal,
        closeModalHandler: closeModal,
        style: {
            width: '675px',
            padding: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            minHeight: '240px',
            textAlign: 'left',
            color: "#191F2A"
        },
        modalContent: OrgNotFoundContent
    });
};
var $6ee72ac05f12ad90$export$2e2bcd8739ae039 = $6ee72ac05f12ad90$var$OrgNotFoundConfirmationModal;


const $d17ee10c72174d6d$export$c9606541361a0113 = ({ searchOrgResults: searchOrgResults, searchForOrganizations: searchForOrganizations, ...props })=>{
    const [page, setPage] = (0, $acw62.useState)(1);
    const CELL_PER_PAGE = 4;
    const totalPages = Math.ceil(searchOrgResults?.total / CELL_PER_PAGE);
    const [isOrgNotFoundModalOpen, setIsOrgNotFoundModalOpen] = (0, $acw62.useState)(false);
    const { tabIndex: tabIndex, onTabChange: onTabChange, handleErrorMsg: handleErrorMsg, userOrganizationInfo: userOrganizationInfo } = props;
    const closeOrgNotFoundConfirmationModal = ()=>{
        setIsOrgNotFoundModalOpen(false);
    };
    const handlePageChange = async (newPage)=>{
        await searchForOrganizations(newPage - 1);
        setPage(newPage);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        maxWidth: '850px',
        mt: 3,
        children: [
            isOrgNotFoundModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ee72ac05f12ad90$export$2e2bcd8739ae039), {
                openModal: isOrgNotFoundModalOpen,
                closeModal: closeOrgNotFoundConfirmationModal,
                tabIndex: tabIndex,
                onTabChange: onTabChange,
                handleErrorMsg: handleErrorMsg,
                userOrganizationInfo: userOrganizationInfo
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$da524f2075150321), {
                mb: 1,
                children: "Organization matches found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                mb: 1,
                children: "We've identified organizations in our system that match some of the information you entered. If you see your organization below, please select it to prevent duplicate entries."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: 700
                        },
                        children: "Please note: "
                    }),
                    "Selecting one of these options will automatically import the associated billing and shipping addresses, medical licenses, and purchasing contract details, which could expedite the set-up of your account and shipping time for the first order."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                    type: "warning",
                    messageText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                        children: "If you choose an organization, your account will be permanently associated with the organization you selected."
                    }),
                    dataTestId: "associateAccountWarning"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                    type: "warning",
                    messageText: "Please check the accuracy of the billing address. If you require a different billing address than the one listed, choose \u201CNone of these matches my organization\u201D at the bottom of the screen.",
                    dataTestId: "diffBillingWarning"
                })
            }),
            searchOrgResults?.data?.map((orgInfo)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $161552e2562b363d$export$685e3ef188dda2de), {
                    orgInfo: orgInfo,
                    ...props
                }, orgInfo?.organization?.id)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 7,
                mt: 1,
                display: 'flex',
                justifyContent: 'center',
                flexGrow: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbec5b7b002b6050$export$5a23558ed4d380e0), {
                    page: page,
                    pageCount: totalPages,
                    onPageChange: handlePageChange
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                style: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    sx: {
                        textTransform: "none"
                    },
                    buttonType: "primary",
                    "data-testid": 'noOrgFoundButton',
                    onClick: ()=>{
                        setIsOrgNotFoundModalOpen(true);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        fontWeight: 700,
                        children: "None of these matches my organization"
                    })
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");

const $5095f096ec37693b$var$NotFoundContainer = (0, $d8seH.default)('div')(({ theme: { breakpoints: breakpoints } })=>`
  margin: 100px 500px 250px 300px;
  ${[
        breakpoints.down('sm')
    ]} {
    margin: 240px 50px 270px 50px;
  }
`);
const $5095f096ec37693b$var$BackgroundContainer = (0, $d8seH.default)('div')(()=>`
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: 50%;
    background-position-y: bottom;
    display: flex;
`);
const $5095f096ec37693b$var$FallbackErrorPage = ({ resetErrorBoundary: resetErrorBoundary })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5095f096ec37693b$var$BackgroundContainer, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5095f096ec37693b$var$NotFoundContainer, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "h1",
                    sx: {
                        fontFamily: "Aeonik Bold"
                    },
                    "data-testid": "errorCode",
                    children: "Unexpected error"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    sx: {
                        fontFamily: "Aeonik Light"
                    },
                    fontSize: "24px",
                    children: "Something went wrong on our end."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    sx: {
                        fontFamily: "Aeonik Regular"
                    },
                    fontSize: "18px",
                    paddingTop: "20px",
                    children: "Return to the homepage to continue. Please contact us at 1-866-MODERNA (1-866-663-3762) if the error persists."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    onClick: resetErrorBoundary,
                    sx: {
                        textTransform: "none",
                        marginTop: {
                            xs: 7,
                            sm: 3
                        }
                    },
                    buttonType: "mds-primary",
                    children: "Return Home"
                })
            ]
        })
    });
};
var $5095f096ec37693b$export$2e2bcd8739ae039 = $5095f096ec37693b$var$FallbackErrorPage;





const $6294fa4bec584778$export$b22d54e782a05701 = ({ tabIndex: tabIndex, onTabChange: onTabChange = ()=>{}, customerSegmentClasses: customerSegmentClasses, handleErrorMsg: handleErrorMsg })=>{
    const [userStatus, setUserStatus] = (0, $acw62.useState)((0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.userStatus) || '');
    const [showMatchFoundForm, setShowMatchFoundForm] = (0, $acw62.useState)(false);
    const [userOrganizationInfo, setUserOrganizationInfo] = (0, $acw62.useState)({});
    const [searchOrgResults, setSearchOrgResults] = (0, $acw62.useState)({});
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const getSearchRequest = (pageNumber)=>{
        const address = userOrganizationInfo?.organization?.address;
        return {
            pagination: {
                pageNumber: pageNumber,
                pageSize: 4
            },
            name: userOrganizationInfo?.organization?.dbaName,
            address: {
                addressType: (0, $5cdc329eeebd56d0$export$c8d71fde6cf57c6).SOLD_TO,
                line1: address?.line1,
                line2: address?.line2,
                city: address?.city,
                state: address?.state,
                zip: address?.zip
            }
        };
    };
    const searchForOrganizations = async (pageNumber)=>{
        try {
            setIsLoading(true);
            const response = await (0, $fdf4ab7ce1c873bd$export$414ace4b9ab2a622)(getSearchRequest(pageNumber));
            if (response?.status === 200) setSearchOrgResults(response?.data);
        } catch (error) {
            const errorMessage = (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode);
            handleErrorMsg(errorMessage);
        } finally{
            setIsLoading(false);
        }
    };
    const renderTabContent = ()=>{
        switch(userStatus){
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).VERIFIED:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8a044636b6056cb$export$d15788ef06082ab7), {});
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_PERSON_COMPLETE:
                return showMatchFoundForm ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d17ee10c72174d6d$export$c9606541361a0113), {
                    handleErrorMsg: handleErrorMsg,
                    tabIndex: tabIndex,
                    onTabChange: onTabChange,
                    userOrganizationInfo: userOrganizationInfo,
                    searchOrgResults: searchOrgResults,
                    searchForOrganizations: searchForOrganizations
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac2496d56c300a8b$export$c65dc357bce91076), {
                    tabIndex: tabIndex,
                    onTabChange: onTabChange,
                    customerSegmentClasses: customerSegmentClasses,
                    setUserOrganizationInfo: setUserOrganizationInfo,
                    setShowMatchFoundForm: setShowMatchFoundForm,
                    setSearchOrgResults: setSearchOrgResults,
                    handleErrorMsg: handleErrorMsg
                });
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_ORG_COMPLETE:
                return onTabChange(1);
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_SHIP_COMPLETE:
                return onTabChange(2);
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_BILL_COMPLETE:
                return onTabChange(3);
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5095f096ec37693b$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        maxWidth: '700px',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            renderTabContent()
        ]
    });
};


const $bff583429144de0f$var$OnboardingPage = ()=>{
    const [value, setValue] = (0, $acw62.useState)(0);
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [alertMsg, setAlertMsg] = (0, $acw62.useState)({
        type: 'info',
        text: ''
    });
    const { tab: tab } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [customerSegmentClasses, setCustomerSegmentClasses] = (0, $acw62.useState)([
        {}
    ]);
    const TOTAL_TABS = 4;
    const isExpeditedOnboarding = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.expeditedOnboarding) ?? false;
    const tabMapping = {
        "contact-info": 0,
        "shipping-address": 1,
        "billing-address": 2,
        "medical-identification": 3
    };
    (0, $acw62.useEffect)(()=>{
        const tabName = tab || 'contact-info';
        const tabIndex = tabMapping[tabName];
        setValue(tabIndex);
    }, [
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        const getCustomerSegmentListResponse = async ()=>{
            (0, $fdf4ab7ce1c873bd$export$da6cf45ae1af792)().then((data)=>{
                const customerSegments = data?.customerSegments ?? {};
                setCustomerSegmentClasses(Object.keys(customerSegments).map((key)=>({
                        "value": key,
                        "label": customerSegments[key]
                    })));
            }).catch((error)=>{
                handleErrorMsg(error?.response?.data?.message);
            });
        };
        getCustomerSegmentListResponse();
    }, []);
    const getTabName = (index)=>Object.keys(tabMapping).find((key)=>tabMapping[key] === index);
    const handleTabChange = (newTabIndex)=>{
        if (newTabIndex < TOTAL_TABS) {
            const tabName = getTabName(newTabIndex);
            if (tabName) {
                setValue(tabMapping[tabName]);
                history.push(`/onboarding/${tabName}`);
            }
        }
    };
    function CustomTabPanel(props) {
        const { children: children, value: value, index: index, ...other } = props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            role: "tabpanel",
            hidden: value !== index,
            id: `simple-tabpanel-${index}`,
            "aria-labelledby": `simple-tab-${index}`,
            ...other,
            children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    p: 3
                },
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'center',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    component: "div",
                    fontFamily: 'Aeonik Regular',
                    fontSize: '24px',
                    fontWeight: 700,
                    children: children
                })
            })
        });
    }
    CustomTabPanel.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`
        };
    }
    const CustomTab = (0, $d8seH.default)((props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
            disableRipple: true,
            ...props
        }))(({ theme: theme })=>({
            textTransform: 'none',
            fontSize: '16px',
            minWidth: 0,
            [theme.breakpoints.up('sm')]: {
                minWidth: 0
            },
            marginRight: theme.spacing(1),
            color: 'rgba(0, 0, 0, 0.85)',
            fontFamily: 'Aeonik Regular',
            fontWeight: 700,
            '&.Mui-selected': {
                color: '#00557E'
            },
            '&.Mui-focusVisible': {
                backgroundColor: '#d1eaff'
            },
            '&.MuiTab-root': {
                marginRight: '32px',
                padding: '12px 0px'
            }
        }));
    const StyledTabs = (0, $d8seH.default)((props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
            ...props,
            TabIndicatorProps: {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "MuiTabs-indicatorSpan"
                })
            }
        }))({
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#00557E'
        },
        '& .MuiTabs-indicatorSpan': {
            maxWidth: 10,
            width: '100%',
            backgroundColor: '#00557E'
        }
    });
    const hiddenTabStyle = (isHidden)=>{
        if (isHidden) return {
            'font-size': '0px',
            'padding': '0px',
            'margin': '0px'
        };
    };
    const handleErrorMsg = (errorMsg)=>{
        setAlertMsg({
            type: 'error',
            text: errorMsg || generalApiError
        });
        alertRef.current?.openAlert('');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                "data-testid": "errorAlert",
                variant: "filled",
                type: alertMsg.type,
                message: alertMsg.text,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                padding: "24px",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b033f821134f4a52$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)(StyledTabs, {
                                    value: value,
                                    sx: {
                                        '.MuiTab-root': {
                                            marginRight: 20
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTab, {
                                            label: "Your Organization",
                                            ...a11yProps(0),
                                            "data-testid": "contactInfoTab"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTab, {
                                            label: "Shipping Address and License",
                                            ...a11yProps(1),
                                            "data-testid": "shippingAddressTab",
                                            style: {
                                                ...hiddenTabStyle(isExpeditedOnboarding)
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTab, {
                                            label: "Billing Address",
                                            ...a11yProps(2),
                                            "data-testid": "billingAddressTab"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTab, {
                                            label: "Medical Identification",
                                            ...a11yProps(3),
                                            "data-testid": "medicalIdentificationTab",
                                            style: {
                                                ...hiddenTabStyle(isExpeditedOnboarding)
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTabPanel, {
                                    value: value,
                                    index: 0,
                                    "data-testid": "contactInfoPanel",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6294fa4bec584778$export$b22d54e782a05701), {
                                        tabIndex: value,
                                        onTabChange: handleTabChange,
                                        customerSegmentClasses: customerSegmentClasses,
                                        handleErrorMsg: handleErrorMsg
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(CustomTabPanel, {
                                    style: {
                                        ...hiddenTabStyle(isExpeditedOnboarding)
                                    },
                                    value: value,
                                    index: 1,
                                    "data-testid": "shippingAddressPanel",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6fb5e96c3783eac6$export$2e2bcd8739ae039), {
                                        tabIndex: value,
                                        onTabChange: handleTabChange,
                                        errorMsgHandler: handleErrorMsg
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)(CustomTabPanel, {
                                    value: value,
                                    index: 2,
                                    "data-testid": "billingAddressPanel",
                                    children: [
                                        "Billing Address",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e4dc40ebea1d956$export$2e2bcd8739ae039), {
                                            tabIndex: value,
                                            onTabChange: handleTabChange,
                                            errorMsgHandler: handleErrorMsg
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)(CustomTabPanel, {
                                    style: {
                                        ...hiddenTabStyle(isExpeditedOnboarding)
                                    },
                                    value: value,
                                    index: 3,
                                    "data-testid": "medicalIdentificationPanel",
                                    children: [
                                        "Medical Identification",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e99bfc46ae5bd2a$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $201d04c4f83d0f82$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
var $bff583429144de0f$export$2e2bcd8739ae039 = $bff583429144de0f$var$OnboardingPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");







const $9a74dc5a6bbe8577$var$RegistrationVerification = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const emailAddress = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.emailAddress);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const alertRef = (0, $acw62.useRef)(null);
    const [clickedResendEmail, setClickedResendEmail] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const handleReturnToHome = ()=>{
        history.push('/');
    };
    const handleOnClick = async ()=>{
        try {
            setIsLoading(true);
            const response = await (0, $48795288c88243f1$export$fb2b2f20a513ed94)({
                emailAddress: emailAddress
            });
            if (response?.status === 200) setClickedResendEmail(true);
        } catch (error) {
            setErrorMsg(generalApiError);
            alertRef.current?.openAlert(error);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: isLoading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        maxWidth: "640px",
                        width: "60%",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b033f821134f4a52$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        maxWidth: "640px",
                        width: '60%',
                        children: [
                            clickedResendEmail && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                                type: "info",
                                headerText: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.bannerHeader,
                                messageText: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.bannerMessage,
                                dataTestId: "resendEmailNotificationBanner"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                "data-testid": "registrationConfirmationHeader",
                                variant: "h3",
                                mt: 6,
                                mb: 4,
                                children: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.heading
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "p1",
                                    children: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.mainText
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "p1",
                                children: `We sent a message to ${emailAddress} with instructions.`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h5",
                                mt: 2,
                                children: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.noEmailHeading
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "p1",
                                children: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.noEmailText
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                    buttonType: "link",
                                    onClick: handleOnClick,
                                    "data-testid": "resendEmailBtn",
                                    sx: {
                                        textTransform: 'none',
                                        padding: '0',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        '&:hover': {
                                            backgroundColor: 'transparent'
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        fontFamily: "Aeonik Regular",
                                        children: (0, $2ff81152e3876597$export$1bfc186f45cf6d41)?.NoEmailLink
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                                mt: 15,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        color: "#85888E",
                                        "data-testid": "copyrightMesssage",
                                        children: "\xa9 2025 Moderna, Inc. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                        buttonType: "link",
                                        sx: {
                                            textTransform: 'none',
                                            padding: '0',
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            ButtonText: '14px',
                                            '&:hover': {
                                                backgroundColor: 'transparent'
                                            }
                                        },
                                        onClick: handleReturnToHome,
                                        "data-testid": "returnToHomeBtn",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            fontSize: "14px",
                                            children: "Return to homepage"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9a74dc5a6bbe8577$export$2e2bcd8739ae039 = $9a74dc5a6bbe8577$var$RegistrationVerification;



var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");






var $acw62 = parcelRequire("acw62");



const $817f1b6de888ab4a$var$OnboardSuccessPage = ()=>{
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const isOnboardingSuccessful = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.isOnboardingSuccessful);
    const successTextBody = "You can now access ModernaDirect.com to place orders, view your order status and order history. \nNew accounts may require verification, which could take up to 5 business days or longer if more information is required from you, in which case we will contact you. \nOrders will not ship until your account is fully verified and the order status will show \u201COn Hold.\u201D";
    const successPageText = {
        header: 'Your ModernaDirect.com account is now ready to use',
        body: successTextBody
    };
    (0, $acw62.useEffect)(()=>{
        if (!isOnboardingSuccessful) history?.push(`/${locale}/`);
        else dispatch((0, $c89d887792446c86$export$24b370854b6f1b89)(false));
    }, []);
    const handleClick = ()=>{
        history.push(`/${locale}/`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            width: "100%",
            justifyContent: "center",
            paddingBottom: "100px",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: "60%",
                minWidth: "700px",
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b033f821134f4a52$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 8,
                        width: '100%',
                        display: "flex",
                        flexDirection: "column",
                        paddingBottom: "50px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                height: "64px",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        height: "48px",
                                        width: "64px",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($16182d64948f0f20$exports))),
                                            alt: "check icon",
                                            className: "CheckIcon",
                                            height: "48px",
                                            width: "48px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h3",
                                        children: successPageText?.header
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                flexDirection: "column",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    paddingLeft: 8,
                                    mt: 4,
                                    maxWidth: '640px',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "p1",
                                            style: {
                                                whiteSpace: 'pre-line',
                                                fontWeight: '500'
                                            },
                                            children: successPageText?.body
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            sx: {
                                                padding: "16px 32px",
                                                textTransform: "none",
                                                marginTop: "16px"
                                            },
                                            "data-testid": "onBoardSuccessBtn",
                                            buttonType: "mds-primary",
                                            onClick: handleClick,
                                            children: "Go to Moderna Direct"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        width: '650px',
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                            type: "info",
                            headerText: "Tax-exempt certification",
                            bannerContentComponent: (0, $6f69d471367d2a71$export$9d708a5dc446e0a)(),
                            dataTestId: "TaxInstructionSection"
                        })
                    })
                ]
            })
        })
    });
};
var $817f1b6de888ab4a$export$2e2bcd8739ae039 = $817f1b6de888ab4a$var$OnboardSuccessPage;




var $ayMG0 = parcelRequire("ayMG0");

var $3bYfT = parcelRequire("3bYfT");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");








const $004837f1a6b6620c$var$GPOComponent = ({ productsForPricing: productsForPricing, onContractChange: onContractChange, setSelectedContract: setSelectedContract, selectedContract: selectedContract })=>{
    const isOverlappingContractEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_OVERLAPPING_CONTRACT_ENABLED");
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const cart = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.cart?.cart) || '';
    const { priceContracts: priceContracts = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state?.commerce);
    const selectedGpoAffiliatedId = (isOverlappingContractEnabled ? selectedContract?.id : userData?.selectedContract?.id) || '';
    const [openSelectionModal, setOpenSelectionModal] = (0, $acw62.useState)(false);
    const [alertMessage, setAlertMessage] = (0, $acw62.useState)('');
    const [alertType, setAlertType] = (0, $acw62.useState)('');
    const [contractTooltipDismissed, setContractTooltipDismissed] = (0, $acw62.useState)(false);
    const userId = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData?.userId) || '';
    const isGPOSelected = ()=>{
        return !!userData?.selectedContract?.id;
    };
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const alertRef = (0, $acw62.useRef)(null);
    const alert = (message, type)=>{
        setAlertMessage(message);
        setAlertType(type);
    };
    const handleConfirm = (selectedPriceContract)=>{
        onContractChange(selectedPriceContract);
    };
    const fetchEligibleContracts = async ()=>{
        try {
            await dispatch((0, $7003073550a1fc7c$export$5a367251a6b08c32)({
                payload: {
                    productNumbers: productsForPricing,
                    userId: userId
                }
            })).unwrap();
        } catch (error) {
            let errorMsg = 'We are unable to fetch your contracts at the moment. Please refresh and try again or contact us at 1-866-MODERNA.';
            alert(errorMsg, 'error');
            alertRef.current?.openAlert(error);
        }
    };
    const getSelectedContractDetails = (cartContractId)=>{
        return priceContracts?.find((contract)=>contract?.id === cartContractId);
    };
    (0, $acw62.useEffect)(()=>{
        isOverlappingContractEnabled && fetchEligibleContracts();
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOverlappingContractEnabled && cart?.contractInfo && priceContracts.length > 0) {
            const matchedContract = getSelectedContractDetails(cart.contractInfo.contractId);
            if (matchedContract) setSelectedContract && setSelectedContract(matchedContract);
        }
    }, [
        cart?.contractInfo,
        priceContracts
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOverlappingContractEnabled && cart?.cartStatus === "CREATED" && priceContracts?.length > 0) {
            setContractTooltipDismissed(true);
            setOpenSelectionModal(true);
        }
    }, [
        priceContracts
    ]);
    const contractTooltip = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: "16px 12px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                pb: "20px",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: "p1",
                    children: "You can change your contract affiliation at any time by clicking here."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "mds-tertiary",
                sx: {
                    textTransform: 'none'
                },
                onClick: ()=>setContractTooltipDismissed(true),
                children: "Got it"
            })
        ]
    });
    const renderContractAffiliationCard = ()=>{
        if (isOverlappingContractEnabled) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                    variant: "filled",
                    type: alertType,
                    message: alertMessage,
                    sx: {
                        top: 120
                    },
                    ref: alertRef
                }),
                !priceContracts.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dea0e5aaf07dabc$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
                    sx: {
                        padding: "16px 32px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        style: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                        variant: "h5",
                                        style: {
                                            fontSize: '18px',
                                            marginRight: '8px'
                                        },
                                        children: selectedContract?.displayName ? "Contract affiliation:\xa0" + selectedContract?.displayName : 'No contract affiliation selected.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: contractTooltip,
                                        placement: "bottom-start",
                                        arrow: true,
                                        open: !contractTooltipDismissed,
                                        componentsProps: {
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#F1F9FE',
                                                    color: '#252627',
                                                    boxShadow: 1,
                                                    fontSize: '16px'
                                                }
                                            },
                                            arrow: {
                                                sx: {
                                                    color: '#F1F9FE'
                                                }
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body1",
                                            color: "secondary.textLinks",
                                            "data-testid": "selectAffiliationBtn",
                                            onClick: ()=>setOpenSelectionModal(true),
                                            style: {
                                                cursor: 'pointer',
                                                fontSize: '18px'
                                            },
                                            children: "Change"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                    children: [
                                        "Incorrect pricing?",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                            to: "/contact-us",
                                            style: {
                                                color: "#0379B2"
                                            },
                                            children: " Contact us"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
        else return !isGPOSelected() ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            title: 'Contract affiliation',
            sx: {
                padding: "16px 32px",
                display: 'flex',
                flexDirection: 'column'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    fontFamily: 'Aeonik Regular',
                    mt: 1,
                    children: (0, $5cdc329eeebd56d0$export$6d7da32a6a38f3bd).GPO_MISSING_LINE_1
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    fontFamily: 'Aeonik Regular',
                    mb: 2,
                    children: (0, $5cdc329eeebd56d0$export$6d7da32a6a38f3bd).GPO_MISSING_LINE_2
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                    buttonType: "mds-primary",
                    "data-testid": "selectAffiliationBtn",
                    sx: {
                        width: "260px",
                        gap: "12px",
                        fontSize: "14px",
                        fontWeight: 700,
                        textTransform: "none",
                        padding: "16px 24px"
                    },
                    onClick: ()=>setOpenSelectionModal(true),
                    children: "Select a contract affiliation"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
            sx: {
                padding: "16px 32px"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                style: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "h5",
                                style: {
                                    fontSize: '18px',
                                    marginRight: '8px'
                                },
                                children: "Contract affiliation:\xa0" + (userData?.selectedContract?.displayName || '')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                variant: "body1",
                                color: "secondary.textLinks",
                                "data-testid": "selectAffiliationBtn",
                                onClick: ()=>setOpenSelectionModal(true),
                                style: {
                                    cursor: 'pointer',
                                    fontSize: '18px'
                                },
                                children: "Change"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                            children: [
                                "Incorrect pricing?",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                    to: "/contact-us",
                                    style: {
                                        color: "#0379B2"
                                    },
                                    children: " Contact us"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        mt: 2,
        minHeight: '50px',
        "data-testid": "gpoComponent",
        children: [
            renderContractAffiliationCard(),
            openSelectionModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7006019da9fe18a$export$2e2bcd8739ae039), {
                openModal: openSelectionModal,
                closeModal: ()=>setOpenSelectionModal(false),
                handleConfirm: handleConfirm,
                defaultGpoAffiliatedId: selectedGpoAffiliatedId,
                productsForPricing: productsForPricing,
                setSelectedContract: setSelectedContract
            })
        ]
    });
};
var $004837f1a6b6620c$export$2e2bcd8739ae039 = $004837f1a6b6620c$var$GPOComponent;





var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $lkxXU = parcelRequire("lkxXU");
var $3bYfT = parcelRequire("3bYfT");








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1J2kR = parcelRequire("1J2kR");

var $d8seH = parcelRequire("d8seH");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");





var $a032fc53995f4ffb$exports = {};
$a032fc53995f4ffb$exports = new URL("infoIcon.44b4cd5a.svg", import.meta.url).toString();


const $854475ce7e5feb1c$var$StyledDataGrid = (0, $d8seH.default)((0, $1J2kR.DataGrid))(({ theme: { breakpoints: breakpoints } })=>`
        height: auto;

        ${breakpoints.between('sm', 'md')} {
            &[data-testid="productTable"]{
                height: 600px !important;
            }

            & .MuiDataGrid-row {
                min-height: 155px !important;
                max-height: 155px !important;
        
                & [role="cell"] {
                min-height: 155px !important;
                max-height: 155px !important;
                }
            }
        }

        ${breakpoints.between('md', 'lg2')} {
            &[data-testid="productTable"] {
                height: 510px !important;
            }

            & .MuiDataGrid-row {
                min-height: 145px !important;
                max-height: 145px !important;
        
                & [role="cell"] {
                min-height: 145px !important;
                max-height: 145px !important;
                }
            }
        }
    `);
const $854475ce7e5feb1c$var$OrderProductTable = ({ products: products, isAuthenticated: isAuthenticated, setOpenModal: setOpenModal, handleDosesChange: handleDosesChange, isReservation: isReservation = false })=>{
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const [productObj, setProductObj] = (0, $acw62.useState)({
        productId: '',
        doseQty: 0
    });
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { handleOpenModal: handleOpenModal } = (0, $913008223d2f1a93$export$33ffd74ebf07f060)();
    const orderableProducts = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.orderableProducts) || [];
    const reservationProducts = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.reservationProducts) || [];
    const productDetailList = isReservation ? reservationProducts : orderableProducts;
    const TitleComponent = (value)=>{
        const row = value.value.row;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                height: 4,
                mb: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    pl: 2,
                    style: {
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            style: {
                                fontSize: '16px',
                                fontWeight: '700',
                                lineHeight: '20px'
                            },
                            children: row.productName
                        }),
                        !isReservation && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            "data-testid": `viewProductDetails-${row.productId}`,
                            sx: {
                                padding: '0',
                                textDecoration: 'none'
                            },
                            buttonType: "link",
                            onClick: ()=>handleClickProductDetails(row.productId),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                sx: {
                                    textTransform: 'none'
                                },
                                fontSize: "14px",
                                fontFamily: "Aeonik Regular",
                                children: "View product details"
                            })
                        })
                    ]
                })
            })
        });
    };
    const PricePerDose = (value)=>{
        const row = value.value.row;
        const isMresviaProduct = row.productName?.includes("mRESVIA");
        const isContractAvailable = row?.contractPrice !== 'Unavailable';
        const reservationFinalPriceStyle = {
            fontSize: isContractAvailable ? "16px" : "14px",
            color: isContractAvailable ? "#252627" : "#696B72",
            fontWeight: "500",
            lineHeight: "16px"
        };
        const reservationListPriceStyle = {
            fontSize: isContractAvailable ? "14px" : "16px",
            fontWeight: "500",
            lineHeight: "16px",
            textDecoration: isContractAvailable ? "line-through" : 'none'
        };
        const finalPriceStyle = {
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "16px"
        };
        const listPriceStyle = {
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "16px",
            color: "#696B72"
        };
        const hasDiscount = !isMresviaProduct && !isReservation;
        if (isReservation) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: {
                        ...reservationListPriceStyle
                    },
                    children: [
                        "List price: ",
                        row.listPrice
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: {
                        ...reservationFinalPriceStyle
                    },
                    children: [
                        "Contract price: ",
                        row.contractPrice
                    ]
                })
            ]
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            alignContent: "end",
            gap: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: {
                        ...listPriceStyle,
                        textDecoration: "line-through"
                    },
                    children: [
                        "List price: ",
                        row.listPrice
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    paddingLeft: 10,
                    style: {
                        ...hasDiscount ? listPriceStyle : finalPriceStyle,
                        textDecoration: hasDiscount ? "line-through" : "none"
                    },
                    children: [
                        " Contract price: ",
                        row.contractPrice
                    ]
                }),
                hasDiscount && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    style: finalPriceStyle,
                    children: [
                        "Price with online discount: ",
                        row.finalPrice
                    ]
                })
            ]
        });
    };
    const handleClickProductDetails = (id)=>{
        const singleProductInfo = productDetailList?.find((item)=>item?.materialMasterId === id);
        dispatch((0, $53476aa40d2bc637$export$1cbcb10f6eead788)(singleProductInfo));
        setOpenModal(true);
    };
    const pricePerDoseColumns = isDiscountEnabled ? [
        {
            field: "finalPrice",
            headerName: "Price per dose",
            headerAlign: "center",
            align: "end",
            sortable: false,
            minWidth: 300,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(PricePerDose, {
                    value: params
                })
        }
    ] : [
        {
            field: 'listPrice',
            headerName: isReservation ? 'List Price*' : 'List Price',
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'contractPrice',
            headerName: 'Contract Price',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            minWidth: 125
        }
    ];
    const columns = [
        {
            field: 'productName',
            headerName: 'Product',
            flex: 1,
            minWidth: 100,
            sortable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(TitleComponent, {
                    value: params
                })
        },
        ...pricePerDoseColumns,
        {
            field: 'doses',
            headerName: 'Doses',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            minWidth: 125,
            renderCell: (params)=>{
                let val = params?.value;
                if (productObj?.productId === params.id) val = productObj?.doseQty;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    type: "number",
                    value: isAuthenticated ? val : 0,
                    onChange: (e)=>updateTextVal(params.id, e.target.value),
                    onBlur: (e)=>handleDosesUpdate(params, e),
                    onKeyDown: (e)=>handleDosesUpdate(params, e),
                    onClick: !isAuthenticated ? handleOpenModal : undefined,
                    inputProps: {
                        min: 0,
                        "data-testid": `doseQty-${params.id}`,
                        'aria-label': 'number of doses'
                    },
                    size: "small",
                    variant: "outlined",
                    sx: {
                        '& .MuiInputBase-input': {
                            color: !isAuthenticated && 'text.disabled',
                            cursor: !isAuthenticated && 'default'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: !isAuthenticated && 'text.disabled'
                        }
                    }
                });
            }
        }
    ];
    const filteredColumns = isAuthenticated ? columns : columns.filter((column)=>column.field === 'productName' || column.field === 'doses');
    const handleDosesUpdate = (product, event)=>{
        const { id: id, value: value } = product;
        const dose = Number(event.target.value);
        if (value === dose) return;
        if (event?.key === 'Enter' || event?.type === 'blur') {
            const doseQty = Math.ceil(dose / 10) * 10;
            setProductObj((prevState)=>({
                    ...prevState,
                    productId: id,
                    doseQty: doseQty
                }));
            handleDosesChange(id, dose);
        }
    };
    const updateTextVal = (productId, doseQty)=>{
        if (doseQty.charAt(0) === '0') doseQty = doseQty.slice(1);
        setProductObj((prevState)=>({
                ...prevState,
                productId: productId,
                doseQty: doseQty
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($854475ce7e5feb1c$var$StyledDataGrid, {
        "data-testid": "productTable",
        autoHeight: true,
        rowHeight: 90,
        rows: products || [],
        columns: filteredColumns || [],
        hideFooter: true,
        disableColumnFilter: true,
        disableColumnMenu: true
    });
};
var $854475ce7e5feb1c$export$2e2bcd8739ae039 = $854475ce7e5feb1c$var$OrderProductTable;





const $6ea184858906d433$var$OrderDetailsCard = ({ entries: cartLineItems, handleDosesChange: handleDosesChange, deleteAddressRow: deleteAddressRow, updateDosesQty: updateDosesQty, billingAddress: billingAddress, handlePoNumberChange: handlePoNumberChange, setExternalProcessing: setExternalProcessing, errorMsgHandler: errorMsgHandler })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { cartData: cartData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const isAuthenticated = authState?.isAuthenticated;
    const [openProductModal, setOpenProductModal] = (0, $acw62.useState)(false);
    const [openAddressModal, setOpenAddressModal] = (0, $acw62.useState)(false);
    const [showUserAddressFormModal, setShowUserAddressFormModal] = (0, $acw62.useState)(false);
    const [openLicenseSelectionModal, setOpenLicenseSelectionModal] = (0, $acw62.useState)(false);
    const [selectedMedicalLicense, setSelectedMedicalLicense] = (0, $acw62.useState)({});
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const getMedicalLicenses = (licenses)=>{
        return licenses.filter((license)=>license.issuer !== "DEA" && license.issuer !== "HIN" && license.issuer !== "NPI");
    };
    const medicalLicenses = getMedicalLicenses((0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData.licenses || []));
    const closeProductModal = ()=>{
        setOpenProductModal(false);
    };
    const closeAddressModal = ()=>{
        setOpenAddressModal(false);
    };
    const handleCloseLicenseSelectionModal = ()=>{
        setOpenLicenseSelectionModal(false);
    };
    const handleAddNewAddress = ()=>{
        setOpenAddressModal(false);
        setShowUserAddressFormModal(true);
    };
    const updateEntriesOnNewAddress = (newAddresses)=>{
        let currentLineItemIds = new Set(cartLineItems.map((entry)=>entry.id));
        if (Array.isArray(newAddresses) && newAddresses.length > 0) {
            const updatedCartLineItems = cartData?.cartLineItems.map((entry)=>{
                if (currentLineItemIds.has(entry.internalCartLineItemId)) return {
                    ...entry,
                    shipToAddress: {
                        addressId: String(newAddresses[0]?.id)
                    },
                    shipToOrganizationId: String(newAddresses[0]?.organizationId),
                    healthcareLicense: newAddresses[0]?.healthcareLicense ? newAddresses[0]?.healthcareLicense : entry.healthcareLicense
                };
                return entry;
            });
            dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
                ...cartData,
                cartLineItems: updatedCartLineItems
            }));
        }
    };
    let totalDoses = 0;
    let totalPrice = 0;
    if (isAuthenticated) {
        const result = cartLineItems.reduce(({ totalDoses: totalDoses, totalPrice: totalPrice }, product)=>{
            const pricePerDose = isDiscountEnabled && product.finalPriceValue ? product.finalPriceValue : product.contractPriceValue !== undefined ? product.contractPriceValue : product.listPriceValue;
            return {
                totalDoses: totalDoses + product.doses,
                totalPrice: totalPrice + product.doses * pricePerDose
            };
        }, {
            totalDoses: 0,
            totalPrice: 0
        });
        totalDoses = result.totalDoses;
        totalPrice = result.totalPrice;
    }
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated && cartLineItems.length > 0) updateDosesQty(totalDoses);
    }, [
        totalDoses,
        updateDosesQty,
        isAuthenticated,
        cartLineItems
    ]);
    const displayAddress = ()=>{
        const address = isAuthenticated ? cartLineItems[0]?.address : null;
        return address;
    };
    const medicalLicensesForSelectedState = ()=>{
        return medicalLicenses.filter((license)=>license.state === cartLineItems[0]?.address?.state);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53e3f78b3d4a8296$export$2e2bcd8739ae039), {
                openModal: openProductModal,
                closeModal: closeProductModal
            }),
            openAddressModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abba33a116635f56$export$2e2bcd8739ae039), {
                openModal: openAddressModal,
                closeModal: closeAddressModal,
                currentAddress: displayAddress(),
                handleAddNewAddress: handleAddNewAddress,
                isOrdering: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f4b21af916ccc28$export$c31c99c21ac9062d), {
                openModal: showUserAddressFormModal,
                closeModal: ()=>setShowUserAddressFormModal(false),
                handleNewAddresses: updateEntriesOnNewAddress,
                setExternalProcessing: setExternalProcessing,
                addressType: "ship_to",
                errorMsgHandler: errorMsgHandler
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de64e41af50540ee$export$2e2bcd8739ae039), {
                isMedicalLicenseSelectionModalOpen: openLicenseSelectionModal,
                handleCloseModal: handleCloseLicenseSelectionModal,
                medicalLicensesForSelectedState: medicalLicensesForSelectedState(),
                setSelectedMedicalLicense: setSelectedMedicalLicense,
                currentAddress: displayAddress()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                flexGrow: 1,
                minHeight: '412px',
                mt: 5,
                mb: 5,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
                    sx: {
                        padding: "32px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexGrow: 1,
                        flexDirection: "column",
                        alignContent: 'space-between',
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            flexGrow: 1,
                            flexWrap: 'wrap',
                            mb: 3,
                            gap: 2,
                            minHeight: '240px',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    minWidth: '240px',
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5489e2f3750c70b$export$2e2bcd8739ae039), {
                                        shipToAddress: displayAddress(),
                                        setOpenAddressModal: setOpenAddressModal,
                                        deleteAddressRow: deleteAddressRow,
                                        billToAddress: billingAddress,
                                        handlePoNumberChange: handlePoNumberChange,
                                        cartLineItems: cartLineItems,
                                        setOpenLicenseSelectionModal: setOpenLicenseSelectionModal,
                                        selectedMedicalLicense: selectedMedicalLicense,
                                        handleAddNewAddress: handleAddNewAddress
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    flex: 1,
                                    width: '65%',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854475ce7e5feb1c$export$2e2bcd8739ae039), {
                                            products: cartLineItems,
                                            isAuthenticated: isAuthenticated,
                                            handleDosesChange: handleDosesChange,
                                            setOpenModal: setOpenProductModal
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            minHeight: '72px',
                                            mt: 2,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                    orientation: "horizontal",
                                                    variant: "middle"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    flexWrap: 'wrap',
                                                    mt: 2,
                                                    ml: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                "data-testid": "orderContentText",
                                                                style: {
                                                                    fontSize: '14px',
                                                                    fontWeight: '400',
                                                                    lineHeight: '20px',
                                                                    whiteSpace: "pre-line"
                                                                },
                                                                children: (0, $5cdc329eeebd56d0$export$192d1dc1dbfcad10)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            style: {
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'flex-end',
                                                                minWidth: '48px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                                    style: {
                                                                        fontSize: '16px',
                                                                        fontWeight: '700',
                                                                        lineHeight: '22px'
                                                                    },
                                                                    children: isAuthenticated ? `Total Doses: ${totalDoses}` : `Total Doses: 0`
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                                                    style: {
                                                                        fontSize: '16px',
                                                                        fontWeight: '400',
                                                                        lineHeight: '28px'
                                                                    },
                                                                    children: [
                                                                        isAuthenticated && `Total Price: ${(0, $382eb84981692d3a$export$bea7bc6c77f07e11)(totalPrice)}`,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $6ea184858906d433$export$2e2bcd8739ae039 = $6ea184858906d433$var$OrderDetailsCard;


















const $2dae95068b0c5f7b$var$MODALS = {
    ADDRESS_SELECTION: 'addressSelection',
    ADDRESS_FORM: 'addressForm',
    USER_ADDRESS_FORM: 'userAddressForm'
};
const $2dae95068b0c5f7b$var$OrderFormPage = ()=>{
    const isOverlappingContractEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_OVERLAPPING_CONTRACT_ENABLED");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)() || '';
    const isAuthenticated = authState?.isAuthenticated;
    const alertRef = (0, $acw62.useRef)(null);
    const reservationConversionID = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.reservationConversionID);
    const cart = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.cart?.cart);
    const { cartData: cartData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const pricingData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.pricingData);
    const orderableProducts = (0, $382eb84981692d3a$export$3d0feebafbb8a231)();
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const defaultShipToAddress = userData?.addresses?.filter((address)=>address.addressType === 'ship_to')[0];
    const defaultBillToAddress = userData?.addresses?.filter((address)=>address.addressType === 'bill_to')[0];
    const soldToAddress = userData?.addresses?.filter((address)=>address.addressType === 'sold_to')[0];
    const [totalDosesQty, setTotalDoses] = (0, $acw62.useState)(0);
    const [openAddressModal, setOpenAddressModal] = (0, $acw62.useState)(false);
    const [showUserAddressFormModal, setShowUserAddressFormModal] = (0, $acw62.useState)(false);
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const userId = userData?.userId;
    const [selectedContract, setSelectedContract] = (0, $acw62.useState)(isOverlappingContractEnabled ? cart?.contractInfo : userData?.selectedContract);
    const showContractPrice = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.showContractPrice);
    const [alertMsg, setAlertMsg] = (0, $acw62.useState)({
        type: 'info',
        text: ''
    });
    const invalidErrorMsg = {
        medicalLicense: 'A medical license is required for ordering.',
        quantity: 'Number of doses is a required field.',
        stateMatchMedicalLicenseWithShipTo: 'Your medical license must be in the same state as your ship to address.'
    };
    const [isTaxExemptSelected, setIsTaxExemptSelected] = (0, $acw62.useState)(false);
    const canShowTaxExemptCheckbox = !userData?.isCustomerTaxExemptionSelfSelectionPastTenDays;
    const [isUserDataProcessing, setIsUserDataProcessing] = (0, $acw62.useState)(false);
    const [isCartProcessing, setIsCartProcessing] = (0, $acw62.useState)(false);
    const [isProductsProcessing, setIsProductsProcessing] = (0, $acw62.useState)(false);
    const [isPricingProcessing, setIsPricingProcessing] = (0, $acw62.useState)(false);
    const isPageLoading = isUserDataProcessing || isCartProcessing || isProductsProcessing || isPricingProcessing;
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const handleErrorMsg = (errorMsg)=>{
        setAlertMsg({
            type: 'error',
            text: errorMsg || generalApiError
        });
        alertRef.current?.openAlert('');
    };
    const isConvertingReservation = window.location.href.includes('complete-reservation');
    const shipToAddresses = (0, $acw62.useMemo)(()=>{
        const addresses = userData?.addresses || [];
        return addresses.filter((address)=>address.addressType === "ship_to").map((address)=>({
                ...address,
                defaultAddress: address.id === defaultShipToAddress?.id
            })).sort((0, $382eb84981692d3a$export$fa295b83bf634638));
    }, [
        defaultShipToAddress,
        userData
    ]);
    const safeDispatch = async (action)=>{
        try {
            return await dispatch(action).unwrap();
        } catch (error) {
            const apiErrorMessage = error?.message || generalApiError;
            setAlertMsg({
                type: 'error',
                text: apiErrorMessage
            });
            alertRef.current?.openAlert('');
        }
    };
    (0, $acw62.useEffect)(()=>{
        const createCart = async ()=>{
            try {
                setIsCartProcessing(true);
                setIsProductsProcessing(true);
                setIsPricingProcessing(true);
                if (isAuthenticated && userId) {
                    let response = {};
                    if (isConvertingReservation) response = await safeDispatch((0, $8b6f49f5b2fddfb8$export$6e289e3dcca84b2a)({
                        userId: userId,
                        reservationId: reservationConversionID
                    }));
                    else response = await safeDispatch((0, $8b6f49f5b2fddfb8$export$6e289e3dcca84b2a)({
                        userId: userId
                    }));
                    setIsTaxExemptSelected(response?.cart?.isTaxExemptSelectedByCustomer ?? false);
                }
                let res = await safeDispatch((0, $6361b14d09f5d8cd$export$d06fcd849797ccb7)({
                    locale: 'US'
                }));
                res = res?.data?.productList;
                if (res) setIsProductsProcessing(false);
                !isOverlappingContractEnabled && await safeDispatch((0, $7003073550a1fc7c$export$1cc7e8ea7ec74e6e)({
                    payload: (0, $26514b3a1a506060$export$f4b549670de80db3)(res, "ORDER", isDiscountEnabled)
                }));
            } finally{
                setIsCartProcessing(false);
                setIsProductsProcessing(false);
                setIsPricingProcessing(false);
            }
        };
        createCart();
    }, [
        dispatch,
        isAuthenticated,
        isConvertingReservation,
        reservationConversionID,
        userId
    ]);
    (0, $acw62.useEffect)(()=>{
        let cartLineItems = (0, $26514b3a1a506060$export$9b047ff83ed91e3e)(orderableProducts, cart, shipToAddresses, defaultBillToAddress);
        dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
            cartLineItems: cartLineItems
        }));
    }, [
        orderableProducts,
        defaultBillToAddress,
        shipToAddresses,
        dispatch,
        cart
    ]);
    const createDisplayEntry = (cartLineItem)=>{
        //TBD: Implement logic when no address is selected
        if (!cartLineItem) return null;
        const { healthcareLicense: healthcareLicense, productId: productId, shipToAddress: shipToAddress, purchaseOrderNumber: purchaseOrderNumber } = cartLineItem;
        const shipToAddressId = shipToAddress?.addressId;
        const pricing = (0, $26514b3a1a506060$export$41303c5fee299aff)(selectedContract, pricingData, isDiscountEnabled)?.[productId] || {};
        const address = shipToAddresses?.find(({ id: id })=>String(id) === String(shipToAddressId)) || {};
        const productMap = (0, $28a6d9aafed47a89$export$e5712731ce122520)(orderableProducts);
        const productName = productMap[productId] || "Unknown Product";
        return {
            id: cartLineItem.internalCartLineItemId,
            doses: parseInt(cartLineItem?.quantity, 10) || 0,
            productId: productId,
            productName: productName,
            listPriceValue: pricing?.listPrice,
            listPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(pricing?.listPrice),
            contractPriceValue: pricing?.contractPrice,
            contractPrice: showContractPrice ? (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(pricing?.contractPrice) : (0, $5cdc329eeebd56d0$export$f2d101b977a134fd),
            finalPriceValue: pricing?.finalPrice,
            finalPrice: (0, $382eb84981692d3a$export$bea7bc6c77f07e11)(pricing?.finalPrice),
            address: address,
            healthcareLicense: healthcareLicense,
            purchaseOrderNumber: purchaseOrderNumber
        };
    };
    const handleContractChange = async (selectedPriceContract)=>{
        const { id: priceContractId, displayName: displayName, medicalIdentifier: medicalIdentifier, contractType: contractType } = selectedPriceContract;
        const updateUserPreferencesRequestBody = {
            userId: userData?.userId,
            priceContract: {
                id: priceContractId,
                displayName: displayName,
                medicalIdentifier: medicalIdentifier,
                priceReferenceType: contractType
            }
        };
        try {
            setProcessing(true);
            if (isOverlappingContractEnabled) {
                await safeDispatch((0, $7003073550a1fc7c$export$8000f25297f4564a)({
                    payload: (0, $26514b3a1a506060$export$7b819d7f1f9df8ff)(orderableProducts, userId, "ORDER", isDiscountEnabled),
                    customerId: selectedPriceContract?.medicalIdentifier || 'anonymous'
                }));
                selectedPriceContract?.medicalIdentifier && dispatch((0, $c89d887792446c86$export$dc61f17556438aae)(true));
            } else {
                const response = await (0, $fdf4ab7ce1c873bd$export$a0dcde0748e1668c)(updateUserPreferencesRequestBody);
                if (response.status === 200) {
                    dispatch((0, $c89d887792446c86$export$dc61f17556438aae)(true));
                    dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                        emailAddress: response?.data?.email
                    }));
                    await safeDispatch((0, $7003073550a1fc7c$export$1cc7e8ea7ec74e6e)({
                        payload: (0, $26514b3a1a506060$export$f4b549670de80db3)(orderableProducts, "ORDER", isDiscountEnabled)
                    }));
                }
            }
        } catch (error) {
            const errorMessage = error?.response?.status === 400 ? (0, $988a08ad6804f205$export$d900853eac39ad08)(error?.response?.data?.errorCode) : error.message || generalApiError;
            setAlertMsg({
                type: "error",
                text: errorMessage
            });
            alertRef.current?.openAlert("");
        } finally{
            setProcessing(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedContract) {
            selectedContract?.id === "no-contract" || selectedContract?.contractId === "no-contract" || selectedContract?.contractId === null ? dispatch((0, $c89d887792446c86$export$dc61f17556438aae)(false)) : dispatch((0, $c89d887792446c86$export$dc61f17556438aae)(true));
            if (isOverlappingContractEnabled) selectedContract?.medicalIdentifier && orderableProducts?.length && safeDispatch((0, $7003073550a1fc7c$export$8000f25297f4564a)({
                payload: (0, $26514b3a1a506060$export$7b819d7f1f9df8ff)(orderableProducts, userId, "ORDER", isDiscountEnabled),
                customerId: selectedContract?.medicalIdentifier
            }));
        } else {
            dispatch((0, $c89d887792446c86$export$dc61f17556438aae)(false));
            isOverlappingContractEnabled && orderableProducts?.length && safeDispatch((0, $7003073550a1fc7c$export$8000f25297f4564a)({
                payload: (0, $26514b3a1a506060$export$7b819d7f1f9df8ff)(orderableProducts, userId, "ORDER", isDiscountEnabled),
                customerId: 'anonymous'
            }));
        }
    }, [
        selectedContract,
        dispatch,
        orderableProducts
    ]);
    // TBD: Connecting to orderAPI
    const cartLineItemsModel = cartData?.cartLineItems || [];
    const cartLineItemsDisplay = cartLineItemsModel.map(createDisplayEntry)?.filter((entry)=>entry !== null);
    const orderPricingInfo = (data)=>{
        return data.reduce(({ totalDoses: totalDoses, totalPrice: totalPrice }, product)=>{
            const pricePerDose = isDiscountEnabled ? product?.finalPriceValue : product?.contractPriceValue ? product.contractPriceValue : product.listPriceValue;
            return {
                totalDoses: totalDoses + product.doses,
                totalPrice: totalPrice + product.doses * pricePerDose
            };
        }, {
            totalDoses: 0,
            totalPrice: 0
        });
    };
    const handleDosesChange = (internalCartLineItemId, doses)=>{
        const cartLineItemIndex = cartLineItemsModel.findIndex((entry)=>entry?.internalCartLineItemId === internalCartLineItemId);
        // If the entry is not found, exit the function
        if (cartLineItemIndex === -1) return;
        // Retrieve the entry to be updated
        const entryToUpdate = cartLineItemsModel[cartLineItemIndex];
        // If it's the entry we want to update, return a new object with the updated doses
        const roundOffQty = Math.ceil(parseInt(doses) / 10) * 10;
        if (isNaN(roundOffQty)) return;
        if (roundOffQty !== 0 && doses !== roundOffQty) {
            setAlertMsg({
                type: 'info',
                text: (0, $28a6d9aafed47a89$export$f997de3996ee8c85)(roundOffQty)
            });
            alertRef.current?.openAlert('');
        }
        // Create a new entry with the updated doses
        const updatedLineItem = {
            ...entryToUpdate,
            quantity: roundOffQty
        };
        // Create a new array with the updated entry
        const updatedCartLineItems = [
            ...cartLineItemsModel.slice(0, cartLineItemIndex),
            updatedLineItem,
            ...cartLineItemsModel.slice(cartLineItemIndex + 1)
        ];
        const { totalDoses: totalDoses } = orderPricingInfo(updatedCartLineItems);
        setTotalDoses(totalDoses);
        dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
            cartLineItems: updatedCartLineItems
        }));
    };
    const handlePoNumberChange = async (cartLineItems, purchaseOrderNumber)=>{
        const updatedCartLineItems = cartLineItemsModel?.map((item)=>{
            const matchingCartLineItem = cartLineItems.find((cartLineItem)=>item?.internalCartLineItemId === cartLineItem?.id);
            if (matchingCartLineItem) return {
                ...item,
                purchaseOrderNumber: purchaseOrderNumber
            };
            return item;
        });
        await dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
            cartLineItems: updatedCartLineItems
        }));
    };
    const closeModal = (modalName)=>{
        modalName === $2dae95068b0c5f7b$var$MODALS.ADDRESS_SELECTION && setOpenAddressModal(false);
        modalName === $2dae95068b0c5f7b$var$MODALS.USER_ADDRESS_FORM && setShowUserAddressFormModal(false);
    };
    const handleDeleteAddressRow = (cartAddressId)=>{
        const updatedCartLineItems = cartData?.cartLineItems?.filter((entry)=>{
            return entry?.shipToAddress?.addressId !== cartAddressId;
        });
        const { totalDoses: totalDoses } = orderPricingInfo(updatedCartLineItems);
        setTotalDoses(totalDoses);
        dispatch((0, $53476aa40d2bc637$export$51b43a12014c9f04)({
            cartLineItems: updatedCartLineItems
        }));
    };
    const isUniqueAddressId = (addressId, index, self)=>{
        return self.findIndex((entry)=>entry.shipToAddress?.addressId === addressId) === index;
    };
    const cartAddressIds = cartLineItemsModel.filter(({ shipToAddress: shipToAddress }, index, self)=>shipToAddress?.addressId && isUniqueAddressId(shipToAddress?.addressId, index, self)).map(({ shipToAddress: shipToAddress })=>shipToAddress?.addressId);
    const getOrderDetailCards = cartAddressIds.map((cartAddressId, i)=>{
        const cartLineItemForThisAddress = cartLineItemsDisplay?.filter(({ address: address })=>String(address?.id) === String(cartAddressId));
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ea184858906d433$export$2e2bcd8739ae039), {
            entries: cartLineItemForThisAddress,
            handleDosesChange: handleDosesChange,
            deleteAddressRow: ()=>handleDeleteAddressRow(cartAddressId),
            updateDosesQty: (count)=>setTotalDoses(count),
            billingAddress: defaultBillToAddress,
            handlePoNumberChange: handlePoNumberChange,
            setExternalProcessing: setProcessing,
            errorMsgHandler: handleErrorMsg
        }, cartAddressId);
    });
    const getAllSelectedAddress = ()=>{
        return cartAddressIds?.map((orderAddressId, i)=>{
            return cartLineItemsDisplay?.filter(({ address: address })=>String(address?.id) === String(orderAddressId))[0]?.address;
        });
    };
    const handleAddNewAddress = ()=>{
        closeModal($2dae95068b0c5f7b$var$MODALS.ADDRESS_SELECTION);
        setShowUserAddressFormModal(true);
    };
    const updateCartLineItem = ()=>{
        return cartData?.cartLineItems.filter((cartLineItem)=>cartLineItem.quantity !== 0).map((cartLineItem)=>({
                ...cartLineItem,
                ...isConvertingReservation && {
                    shipToOrganizationId: (0, $26514b3a1a506060$export$e4cde6d2791bb1f0)(shipToAddresses, cartLineItem?.shipToAddress?.addressId)
                },
                priceSnapshotId: pricingData?.productIdToPriceSnapshotId?.[cartLineItem?.productId],
                billToAddress: {
                    addressId: String(defaultBillToAddress?.id)
                },
                billToOrganizationId: String(defaultBillToAddress?.organizationId)
            }));
    };
    const checkValidation = (cartDetails)=>{
        const showAlert = (messageKey)=>{
            setAlertMsg({
                type: 'error',
                text: invalidErrorMsg[messageKey]
            });
            alertRef.current?.openAlert('');
        };
        let totalDosePerCart = 0;
        for (const cartLineItem of cartDetails?.cart?.cartLineItems || []){
            totalDosePerCart += cartLineItem?.quantity || 0;
            if (!cartLineItem?.healthcareLicense?.licenseNumber) {
                showAlert('medicalLicense');
                return true;
            }
            let shipToAddressId = cartLineItem?.shipToAddress?.addressId;
            let shipToAddress = shipToAddresses?.find((address)=>String(address.id) === String(shipToAddressId));
            if (cartLineItem?.healthcareLicense?.state?.toLowerCase() !== shipToAddress?.state?.toLowerCase()) {
                showAlert('stateMatchMedicalLicenseWithShipTo');
                return true;
            }
        }
        if (totalDosePerCart === 0) {
            showAlert('quantity');
            return true;
        }
        return false;
    };
    const handleContinue = async ()=>{
        const cartDetails = {
            cart: {
                userId: userId,
                cartId: cart?.cartId,
                soldToOrganizationId: String(soldToAddress?.organizationId),
                soldToAddress: {
                    addressId: String(soldToAddress?.id)
                },
                contractInfo: {
                    contractId: selectedContract?.id === "no-contract" ? null : selectedContract?.id,
                    contractDisplayName: selectedContract?.displayName
                },
                fein: '12-3456789',
                cartLineItems: updateCartLineItem(),
                isTaxExemptSelectedByCustomer: isTaxExemptSelected,
                ...isConvertingReservation && {
                    reservationId: cart?.reservationId,
                    reservationNumber: cart?.reservationNumber
                }
            }
        };
        if (isOverlappingContractEnabled && selectedContract?.id) {
            const { id: priceContractId, displayName: displayName, medicalIdentifier: medicalIdentifier, contractType: contractType } = selectedContract;
            const updateUserPreferencesRequestBody = {
                userId: userData?.userId,
                priceContract: priceContractId === "no-contract" ? {
                    id: "no-contract",
                    displayName: "no-contract"
                } : {
                    id: priceContractId,
                    displayName: displayName,
                    medicalIdentifier: medicalIdentifier,
                    priceReferenceType: contractType
                }
            };
            const response = await (0, $fdf4ab7ce1c873bd$export$a0dcde0748e1668c)(updateUserPreferencesRequestBody);
            if (response.status === 200) dispatch((0, $fdf4ab7ce1c873bd$export$6de65cbed44a6a41)({
                emailAddress: response?.data?.email
            }));
        }
        try {
            setProcessing(true);
            if (!checkValidation(cartDetails)) {
                const response = await safeDispatch((0, $8b6f49f5b2fddfb8$export$cffacbe8550d921)({
                    payload: cartDetails,
                    userId: userId,
                    cartId: cart?.cartId
                }));
                if (response?.status === 200) history.push('/order-summary');
            }
        } catch (error) {
            setAlertMsg({
                type: 'error',
                text: error?.message || generalApiError
            });
            alertRef.current?.openAlert('');
        } finally{
            setProcessing(false);
        }
    };
    const TaxExemptSelection = ()=>{
        const checkboxLabel = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
            fontFamily: 'Aeonik Regular',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontWeight: '700'
                    },
                    children: "This order is tax-exempt. "
                }),
                "I hereby attest that my purchase is exempt from sales tax and purchaser holds a valid exemption certificate that has been provided or will be promptly provided to Moderna."
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            flexGrow: 2,
            width: "auto",
            mt: "15px",
            "data-testid": "taxExemptCheckBox",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d62ec653312c013$export$2e2bcd8739ae039), {
                sx: {
                    alignContent: 'center',
                    justifyContent: 'start',
                    display: 'flex',
                    padding: '16px 32px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c576d11d36ade61d$export$48513f6b9f8ce62d), {
                    checked: isTaxExemptSelected,
                    label: checkboxLabel,
                    onChange: ()=>setIsTaxExemptSelected(!isTaxExemptSelected),
                    labelsx: {
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '24px'
                    }
                })
            })
        });
    };
    const getOrderableProductCodes = orderableProducts?.length && orderableProducts?.map((product)=>product?.materialMasterId) || [];
    if (isPageLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
        processing: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                "data-testid": "errorAlert",
                variant: "filled",
                type: alertMsg.type,
                message: alertMsg?.text || 'An unexpected error occurred',
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            openAddressModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abba33a116635f56$export$2e2bcd8739ae039), {
                openModal: openAddressModal,
                closeModal: ()=>closeModal($2dae95068b0c5f7b$var$MODALS.ADDRESS_SELECTION),
                allSelectedAddresses: getAllSelectedAddress() || [],
                handleAddNewAddress: handleAddNewAddress,
                isOrdering: true
            }),
            showUserAddressFormModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f4b21af916ccc28$export$c31c99c21ac9062d), {
                openModal: showUserAddressFormModal,
                closeModal: ()=>closeModal($2dae95068b0c5f7b$var$MODALS.USER_ADDRESS_FORM),
                addressType: "ship_to",
                isOrdering: true,
                isAddingAdditionalLocation: true,
                setExternalProcessing: setProcessing,
                errorMsgHandler: handleErrorMsg
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                m: 4,
                children: [
                    !defaultBillToAddress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                        dataTestId: "mising-billing-banner",
                        type: "warning",
                        messageText: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                            children: [
                                "There was a problem accessing your ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontWeight: 700
                                    },
                                    children: "billing address, "
                                }),
                                "which is required to proceed. Please try logging out and logging back in. If the issue persists, please ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                                    to: "/contact-us",
                                    children: "Contact us"
                                }),
                                " for further assistance."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        style: {
                            fontSize: '30px',
                            fontWeight: 500,
                            marginBottom: '16px',
                            fontFamily: 'Aeonik Regular'
                        },
                        children: "Place an order"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        gap: "19px",
                        sx: {
                            flexDirection: {
                                xs: 'column',
                                sm: 'row'
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            flexGrow: 3,
                            width: "80%",
                            minHeight: '70px',
                            children: isAuthenticated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004837f1a6b6620c$export$2e2bcd8739ae039), {
                                productsForPricing: getOrderableProductCodes,
                                onContractChange: handleContractChange,
                                selectedContract: selectedContract,
                                setSelectedContract: setSelectedContract
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            flexGrow: 3,
                            width: "80%",
                            children: canShowTaxExemptCheckbox && /*#__PURE__*/ (0, $ayMG0.jsx)(TaxExemptSelection, {})
                        })
                    }),
                    isAuthenticated && getOrderDetailCards,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        flex: 1,
                        minWidth: '300px',
                        mb: 3,
                        mt: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: 'mds-secondary',
                            "data-testid": "deliverToAddressBtn",
                            muiIconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($440b5642e77fc64a$exports))),
                            disabled: !isAuthenticated,
                            onClick: ()=>{
                                setOpenAddressModal(true);
                            },
                            children: "Deliver to additional address"
                        })
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        mt: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            "data-testid": "orderContinueBtn",
                            buttonType: 'mds-primary',
                            muiIconRight: (0, (/*@__PURE__*/$parcel$interopDefault($12a26d70a091a9bc$exports))),
                            onClick: handleContinue,
                            sx: {
                                textTransform: 'none'
                            },
                            children: "Save and continue"
                        })
                    })
                ]
            })
        ]
    });
};
var $2dae95068b0c5f7b$export$2e2bcd8739ae039 = $2dae95068b0c5f7b$var$OrderFormPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $3bYfT = parcelRequire("3bYfT");










var $ayMG0 = parcelRequire("ayMG0");




const $08983d4659a408f3$export$bb7812f02ac4d31f = ({ paymentOption: paymentOption, summaryData: summaryData })=>{
    const hasPromptPay = summaryData?.promptPayEligible;
    const hasFullPromptPayInfo = hasPromptPay && summaryData?.promptPayTerms?.timePeriod;
    const selectedContract = summaryData?.contractInfo;
    const getPromptPayText = (hasFullPromptPayInfo, selectedContract)=>{
        if (hasFullPromptPayInfo) {
            if (selectedContract?.contractId != null) return `**Your contract terms entitle you to a ${summaryData?.promptPayTerms?.promptPayDiscount}% discount if your payment
                 is received within ${summaryData?.promptPayTerms?.timePeriod} days of your invoice date.`;
            else return `**Your order is eligible for a ${summaryData?.promptPayTerms?.promptPayDiscount}% discount if your payment 
                is received within ${summaryData?.promptPayTerms?.timePeriod} days of your invoice date.`;
        } else return `**This order may be eligible for a pricing discount if payment is received within your contract payment terms. 
                See your specific payment terms for details.`;
    };
    const renderPromptPayText = ()=>{
        if (hasPromptPay) return getPromptPayText(hasFullPromptPayInfo, selectedContract);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        minWidth: "350px",
        maxWidth: "486px",
        mt: "24px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                children: "*If your order is taxable, you will be billed for the sales and local tax as required by law."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                children: renderPromptPayText()
            }),
            !hasFullPromptPayInfo && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                mt: "7px",
                children: "Your payment terms (including due date) will be specified on your invoice. If you are eligible for a prompt pay discount through a buying group affiliation and do not see it applied at checkout, please ensure you have selected the correct contract affiliation or contact your buying group to confirm your contract terms and eligibility."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                mt: "7px",
                children: "Orders are processed immediately and cannot be modified or cancelled after being placed. When your order ships you will receive an email with your tracking information."
            }),
            (0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_LATER === paymentOption && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                mt: "7px",
                children: [
                    "For bank wire transfers, see ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        to: `/invoicepay`,
                        target: "_blank",
                        children: "payment instructions"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                mt: "7px",
                children: "Orders with multiple addresses will be separated into multiple shipments and invoiced individually."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $004450ae48667ea7$export$94944d8910c4db4b), {
                mt: "7px",
                children: [
                    "Your ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        to: "/my-profile/addresses",
                        target: "_blank",
                        style: {
                            color: "#0379B2"
                        },
                        children: " Corporate Address "
                    }),
                    "will be listed as the Sold To address on your invoice."
                ]
            })
        ]
    });
};





const $600ccbe378a274c2$var$OrderCheckoutPage = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const { globalErrorMessage: globalErrorMessage = [] } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalMessages);
    const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data)=>data?.fields?.code === "GENERAL_API_ERROR");
    const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
    const [processing, setProcessing] = (0, $acw62.useState)(true);
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.userData);
    const userId = userData?.userId;
    const cartId = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.cart?.cart?.cartId) || '';
    const orderableProducts = (0, $382eb84981692d3a$export$3d0feebafbb8a231)();
    const [summaryData, setSummaryData] = (0, $acw62.useState)({});
    const [orderCartEntries, setOrderCartEntries] = (0, $acw62.useState)([]);
    const uniqueAddressIds = new Set(orderCartEntries.map((entry)=>entry.shipToAddress?.addressId));
    const [paymentOption, setPaymentOption] = (0, $acw62.useState)((0, $5cdc329eeebd56d0$export$9353cdd556d7eb72)?.PAY_NOW);
    const [paymentMethodsList, setPaymentMethodsList] = (0, $acw62.useState)([]);
    const [isTaxPending, setIsTaxPending] = (0, $acw62.useState)(true);
    const [isSnackbarOpen, setIsSnackbarOpen] = (0, $acw62.useState)(false);
    const [snackbarMessage, setSnackbarMessage] = (0, $acw62.useState)('');
    const isDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const getSummaryData = (cart)=>{
        if (!cart) return {};
        let { subtotalListPrice: subtotalListPrice, subtotalContractPrice: subtotalContractPrice, totalTax: totalTax, totalListPrice: totalListPrice, totalContractPrice: totalContractPrice, discountTotal: discountTotal, promptPayEligible: promptPayEligible, promptPayTerms: promptPayTerms, totalContractPriceWithPromptPay: totalContractPriceWithPromptPay } = cart?.cartPriceTotals?.total || {};
        return {
            totalDoses: cart?.totalQuantity || 0,
            listPrice: subtotalListPrice?.displayValue,
            savings: discountTotal?.displayValue,
            contractPrice: subtotalContractPrice?.displayValue,
            taxes: totalTax?.displayValue,
            totalPrice: totalContractPrice?.displayValue || totalListPrice?.displayValue,
            isTaxPending: (!cart?.customerRecordHasSapValues && !cart?.isTaxExemptSelectedByCustomer) ?? true,
            promptPayEligible: promptPayEligible,
            promptPayTerms: promptPayTerms,
            totalContractPriceWithPromptPay: totalContractPriceWithPromptPay?.displayValue,
            contractInfo: cart?.contractInfo
        };
    };
    (0, $acw62.useEffect)(()=>{
        setProcessing(true);
        dispatch((0, $bf4ea7b5c4b4cc11$export$8d546fe0fda62b77)({
            cartId: cartId,
            userId: userData?.userId
        })).unwrap().then(async (data)=>{
            const { customerRecordHasSapValues: customerRecordHasSapValues, isTaxExemptSelectedByCustomer: isTaxExemptSelectedByCustomer } = data?.cart || {};
            setIsTaxPending((!customerRecordHasSapValues && !isTaxExemptSelectedByCustomer) ?? true);
            setOrderCartEntries(data?.cart?.cartLineItems || []);
            setSummaryData(getSummaryData(data?.cart || null));
            await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                status: (0, $5cdc329eeebd56d0$export$4f89b831ca9f07a9).ACTIVE
            }).then((result)=>{
                if (result.status === 200) {
                    let defaultPaymentMethod = result?.data?.paymentMethodsList?.filter((paymentMethod)=>paymentMethod.isDefault === true)[0];
                    dispatch((0, $53476aa40d2bc637$export$9628908a9dd74afb)(defaultPaymentMethod));
                    setPaymentMethodsList(result?.data?.paymentMethodsList);
                }
            }).catch((error)=>{
                const errorMessage = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(error?.response?.data?.errorCode);
                setErrorMsg(errorMessage);
                alertRef.current?.openAlert(error);
            });
        }).catch((error)=>{
            setErrorMsg(generalApiError);
            alertRef.current?.openAlert(error);
        }).finally(()=>{
            setProcessing(false);
        });
    }, []);
    const createDisplayEntry = (0, $acw62.useMemo)(()=>{
        return orderCartEntries?.map((orderEntry)=>{
            if (!orderEntry) return null;
            const { productId: productId, shipToAddress: shipToAddress, billToAddress: billToAddress, purchaseOrderNumber: purchaseOrderNumber, productPrice: productPrice } = orderEntry || {};
            const productMap = (0, $28a6d9aafed47a89$export$e5712731ce122520)(orderableProducts);
            const productName = productMap[productId] || "Unknown Product";
            return {
                id: orderEntry?.cartLineItemId,
                doses: parseInt(orderEntry?.quantity, 10) || 0,
                productId: productId,
                productName: productName,
                listPrice: orderEntry?.unitListPrice?.displayValue,
                contractPrice: isDiscountEnabled ? orderEntry?.unitOriginalContractPrice?.displayValue : orderEntry?.unitContractPrice?.displayValue,
                finalPrice: orderEntry?.unitContractPrice?.displayValue,
                priceTotal: orderEntry?.priceTotal,
                shipToAddress: shipToAddress,
                billToAddress: billToAddress,
                purchaseOrderNumber: purchaseOrderNumber
            };
        }).filter((entry)=>entry !== null);
    }, [
        orderCartEntries,
        orderableProducts
    ]);
    const getEntriesForThisAddress = (addressId)=>{
        let filteredEntries = createDisplayEntry?.filter(({ shipToAddress: shipToAddress })=>String(shipToAddress?.addressId) === String(addressId));
        return {
            items: filteredEntries,
            shipToAddress: filteredEntries[0]?.shipToAddress,
            billToAddress: filteredEntries[0]?.billToAddress,
            purchaseOrderNumber: filteredEntries[0]?.purchaseOrderNumber
        };
    };
    const errorMsgHandler = (errorMsg)=>{
        let message = errorMsg || generalApiError;
        setErrorMsg(message);
        alertRef.current?.openAlert(message);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                autoHideDuration: 3000,
                open: isSnackbarOpen,
                onClose: ()=>{
                    setIsSnackbarOpen(false);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), {
                    message: (0, $c9fe4f79081fb8c8$export$4f31a5e23f8e79a9)(snackbarMessage),
                    sx: (0, $c9fe4f79081fb8c8$export$c5530885e8ffa0f4)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                processing: processing
            }),
            !processing && orderCartEntries.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                "data-testid": "mainContainer",
                container: true,
                padding: {
                    xs: 3,
                    md: 4,
                    lg: "32px 72px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26cd3be04bc521db$export$2e2bcd8739ae039), {}),
                        buttonType: "link",
                        onClick: ()=>history.push('/products'),
                        sx: {
                            py: "12px",
                            mb: "20px",
                            textTransform: "none"
                        },
                        children: "Edit your order"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        paddingBottom: "21px",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                            sx: {
                                fontSize: "30px",
                                fontWeight: 500,
                                lineHeight: "36px",
                                fontFamily: "Aeonik Regular"
                            },
                            children: "Review your order"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        "data-testid": "order-summary-table",
                        item: true,
                        sm: 12,
                        lg2: 8,
                        paddingBottom: "32px",
                        children: [
                            ...uniqueAddressIds
                        ].map((addressId, index)=>{
                            let entriesToRender = getEntriesForThisAddress(addressId);
                            let marginTop = index > 0 ? "33px" : "0px";
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $711e34918211b6e4$export$2e2bcd8739ae039), {
                                orderDetail: entriesToRender,
                                isTaxPending: isTaxPending,
                                sx: {
                                    '#boxContainer': {
                                        marginTop: marginTop
                                    }
                                }
                            }, addressId);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        "data-testid": "order-summary-card",
                        item: true,
                        sm: 12,
                        lg2: 4,
                        overflow: "unset",
                        minWidth: "350px",
                        maxWidth: "486px",
                        paddingLeft: {
                            md: 0,
                            lg: "21px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11b7c44202c1dbd2$export$bdeec1121b193acd), {
                                summaryData: summaryData,
                                userId: userId,
                                handleErrorMsg: errorMsgHandler,
                                setProcessing: setProcessing,
                                setPaymentOption: setPaymentOption,
                                paymentOption: paymentOption,
                                paymentMethodsList: paymentMethodsList,
                                setPaymentMethodsList: setPaymentMethodsList,
                                setIsSnackbarOpen: setIsSnackbarOpen,
                                setSnackbarMessage: setSnackbarMessage
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $08983d4659a408f3$export$bb7812f02ac4d31f), {
                                paymentOption: paymentOption,
                                summaryData: summaryData
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $600ccbe378a274c2$export$2e2bcd8739ae039 = $600ccbe378a274c2$var$OrderCheckoutPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $3bYfT = parcelRequire("3bYfT");






const $21d13a440dfaf9ac$var$OrderConfirmationPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const { userData: userData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce);
    const canAccessOrderConfirmationPage = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.canAccessOrderConfirmationPage);
    const isUserValidated = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.isUserValidated); // TO-DO: Where does this needs to be set?
    (0, $acw62.useEffect)(()=>{
        if (!canAccessOrderConfirmationPage) history?.push(`/${locale}/`);
        else dispatch((0, $c89d887792446c86$export$afab37d636f63f75)(false));
        return ()=>{
            dispatch((0, $53476aa40d2bc637$export$e3c85382822e3760)({}));
        };
    }, [
        history
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        sx: {
            minHeight: "550px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: "64px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($16182d64948f0f20$exports))),
                alt: "check icon",
                className: "CheckIcon",
                height: "56",
                width: "56"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": "ConfirmationMsgSection",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        "data-testid": "ThankYouMsg",
                        fontFamily: "Aeonik Regular",
                        fontSize: "24px",
                        fontWeight: 500,
                        children: [
                            "Thank you, ",
                            `${userData?.firstName} ${userData?.lastName}`,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                        "data-testid": "OrderPlacedMsg",
                        fontFamily: "Aeonik Regular",
                        fontSize: "24px",
                        fontWeight: 700,
                        children: "Your order has been received."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": "OtherInstructionSection",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                padding: "32px",
                children: !isUserValidated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                    type: "sync",
                    headerText: "Your account is being validated",
                    messageText: "Your orders will appear \u201Con hold\u201D until your account is fully validated. We will contact you if we need any other information. No further action is required at this time.",
                    dataTestId: "AccountBeingValidatedBanner",
                    style: {
                        width: "545px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                sx: {
                    minHeight: "300px"
                },
                dataTestId: "TaxInstructionContainer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d0197a89ef5b3c9$export$2e2bcd8739ae039), {
                    type: "info",
                    headerText: "Tax-exempt certification",
                    bannerContentComponent: (0, $6f69d471367d2a71$export$9d708a5dc446e0a)(),
                    dataTestId: "TaxInstructionSection"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                buttonType: "mds-secondary",
                "data-testid": "placeAnotherOrderButton",
                sx: {
                    padding: "16px 24px",
                    textTransform: "none",
                    marginBottom: "100px"
                },
                onClick: ()=>history.push(`/${locale}/order-form`),
                children: "Place another order"
            })
        ]
    });
};
var $21d13a440dfaf9ac$export$2e2bcd8739ae039 = $21d13a440dfaf9ac$var$OrderConfirmationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $3bYfT = parcelRequire("3bYfT");

var $bc1c9735578b18ae$exports = {};
$bc1c9735578b18ae$exports = new URL("invoicePayInfographic.85502539.png", import.meta.url).toString();


var $9984c9376241dcbe$exports = {};
$9984c9376241dcbe$exports = new URL("invoicePayInfographic-old.4c3c5aa0.png", import.meta.url).toString();



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lkxXU = parcelRequire("lkxXU");
var $iAtns = parcelRequire("iAtns");
var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");












const $65b1395f481b4a08$var$RequiredSymbol = (0, $d8seH.default)('span')({
    color: 'red'
});
const $65b1395f481b4a08$var$buttonsContainerSxStyles = {
    flexDirection: {
        xs: 'column',
        sm: 'row'
    },
    display: "flex",
    justifyContent: 'left',
    marginY: "24px"
};
const $65b1395f481b4a08$var$cardStyles = {
    variant: "outlined",
    bgcolor: 'neutral.white',
    borderRadius: '16px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.50)'
};
const $65b1395f481b4a08$export$d223ba5eba3fe1b0 = ({ handleErrorMsg: handleErrorMsg, invoicePayLookupEnabled: invoicePayLookupEnabled, setShowSpinner: setShowSpinner })=>{
    const defaultInputFields = {
        firstName: '',
        lastName: '',
        email: '',
        invoiceNumber: '',
        zipcode: '',
        shippingOrgName: '',
        paymentAmount: ''
    };
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [inputFields, setInputFields] = (0, $acw62.useState)(defaultInputFields);
    const [invoiceNumber, setInvoiceNumber] = (0, $acw62.useState)('');
    const [paymentAmount, setPaymentAmount] = (0, $acw62.useState)(''); // TODO in [MD-46]: fetch from BE rather than as an input
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const [invoice, setInvoice] = (0, $acw62.useState)(null);
    const alertRef = (0, $acw62.useRef)(null);
    const { showPaymentForm: showPaymentForm, processing: processing, StripeForm: StripeForm, handleClosePaymentModal: handleClosePaymentModal, setPaymentType: setPaymentType, onPayByInvoice: onPayByInvoice } = (0, $58f3999ceb801203$export$2e2bcd8739ae039)(handleErrorMsg);
    const fieldValidations = {
        firstName: (0, $bb27324e6828f86a$export$b135c3f9b9f02308),
        lastName: (0, $bb27324e6828f86a$export$b135c3f9b9f02308),
        email: (0, $bb27324e6828f86a$export$18148d12c805c5b0),
        invoiceNumber: (0, $c9fe4f79081fb8c8$export$a6c55e5d171e6bec),
        zipcode: (0, $bb27324e6828f86a$export$5af8a774f7f1c688),
        shippingOrgName: (0, $bb27324e6828f86a$export$8dd4b0e4422ae2b0),
        paymentAmount: (0, $c9fe4f79081fb8c8$export$5c65f471a395368b)
    };
    if (invoicePayLookupEnabled) {
        delete fieldValidations.shippingOrgName;
        delete fieldValidations.paymentAmount;
    }
    const validateInputFields = (field, value)=>{
        const validationFunction = fieldValidations[field];
        return validationFunction ? validationFunction(value) : "";
    };
    const errorMsgHandler = (errorMsg)=>{
        setErrorMsg(errorMsg);
        alertRef.current?.openAlert(errorMsg);
    };
    const formatToUSD = (value)=>{
        // Remove any non-numeric characters except period
        const number = parseFloat(value.replace(/[^0-9.]/g, ""));
        if (isNaN(number)) return "";
        // Format number to USD style with two decimal places
        return `$${number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    };
    const formatDueDate = (date)=>{
        // to parse the high precision ISO string we get from the backend
        const normalizeToMilliseconds = (input)=>{
            return input.replace(/\.(\d{3})\d*Z$/, '.$1Z');
        };
        return (0, $303ba10db2c74ab4$exports.formatDate)(normalizeToMilliseconds(date), "MMM do, yyyy");
    };
    const handleChange = (event)=>{
        const { name: name, value: value } = event.target;
        const newInputFields = {
            ...inputFields,
            [name]: [
                "firstName",
                "lastName"
            ].includes(name) ? value : value.trim()
        };
        setInputFields(newInputFields);
    };
    const handleBlur = (event)=>{
        const { name: name, value: value } = event.target;
        const errorMsg = validateInputFields(name, value);
        setErrors({
            ...errors,
            [name]: errorMsg
        });
        if ([
            "firstName",
            "lastName"
        ].includes(name)) // trim after the fact, in case name has spaces in it
        setInputFields({
            ...inputFields,
            [name]: value.trim()
        });
        if (!invoicePayLookupEnabled && !errorMsg && name === "paymentAmount") {
            const formattedValue = formatToUSD(value);
            setInputFields({
                ...inputFields,
                [name]: formattedValue
            });
        }
    };
    const createTextField = (key, label, value, indicatorNumber)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        indicatorNumber && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                width: 30,
                                height: 30,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '50%',
                                backgroundColor: '#079AE0',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: 18,
                                mr: 1,
                                mb: 1
                            },
                            children: indicatorNumber
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb27324e6828f86a$export$842aba50ed0ce9d7), {
                            label: label,
                            "data-testid": key
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: key,
                    name: key,
                    "data-testid": key,
                    type: "text",
                    value: value,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    focused: true,
                    variant: "outlined",
                    fullWidth: true,
                    error: Boolean(errors[key]),
                    helperText: errors[key],
                    sx: (0, $bb27324e6828f86a$export$298b9ad7287f04ba)(errors[key]),
                    FormHelperTextProps: (0, $bb27324e6828f86a$export$8148362e557f3fef),
                    inputProps: {
                        'aria-label': `${key}`
                    }
                })
            ]
        });
    };
    const InfoText = ({ text: text, fontWeight: fontWeight = '400', display: display = 'inline-block' })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
            color: "#383D47",
            fontSize: "14px",
            fontWeight: fontWeight,
            paddingTop: "7px",
            display: display,
            children: text
        });
    };
    const continueToPayment = async ()=>{
        setInvoiceNumber(inputFields.invoiceNumber);
        setPaymentAmount(invoicePayLookupEnabled ? formatCurrency(invoice.total) : inputFields.paymentAmount);
        setPaymentType((0, $5cdc329eeebd56d0$export$9353cdd556d7eb72).PAY_INVOICE);
        const customerDetails = {
            email: inputFields.email,
            name: `${inputFields.firstName} ${inputFields.lastName}`,
            metadata: {
                zipcode: inputFields.zipcode,
                organizationName: inputFields.shippingOrgName
            }
        };
        await onPayByInvoice(customerDetails);
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const validationErrors = {};
        Object.keys(inputFields).forEach((fieldName)=>{
            const errorMsg = validateInputFields(fieldName, inputFields[fieldName]);
            if (errorMsg) validationErrors[fieldName] = errorMsg;
        });
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        if (invoicePayLookupEnabled) {
            const invoiceDetails = {
                search: {
                    firstName: inputFields.firstName,
                    lastName: inputFields.lastName,
                    email: inputFields?.email,
                    invoiceId: inputFields.invoiceNumber,
                    zipCode: inputFields.zipcode
                }
            };
            try {
                const response = await (0, $8b6f49f5b2fddfb8$export$239d659298d60099)(invoiceDetails);
                if (response.status === 200) setInvoice(response.data.invoice);
            } catch (error) {
                if (error?.response?.data?.errorCode === (0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.RESOURCE_NOT_FOUND) setErrors({
                    'invoiceNumber': (0, $988a08ad6804f205$export$82f46aa4e6535a45)((0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.RESOURCE_NOT_FOUND)
                });
                else if (error?.response?.data?.errorCode === (0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.INVOICE_ZIP_MISMATCH) setErrors({
                    'zipcode': (0, $988a08ad6804f205$export$82f46aa4e6535a45)((0, $b1c33141448092cf$export$be58a38ca267dc5f).INVOICES.INVOICE_ZIP_MISMATCH)
                });
                else //using default error message for other error codes
                errorMsgHandler((0, $988a08ad6804f205$export$82f46aa4e6535a45)());
            }
        } else await continueToPayment();
    };
    const handleCloseContinueToPaymentModal = ()=>{
        setInvoice(null);
    };
    const handleCloseStripeModal = ()=>{
        handleClosePaymentModal();
        handleCloseContinueToPaymentModal();
    };
    const formatCurrency = (value)=>{
        // invoices are currently only in USD
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(value / 100);
    };
    const ContinueToPaymentModalContent = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: 540,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            fontSize: "24px",
                            fontWeight: 700,
                            children: [
                                "Pay Invoice #",
                                invoice.invoiceId
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                mt: 3
                            },
                            display: "flex",
                            fontWeight: 700,
                            children: [
                                "Invoice #",
                                invoice.invoiceId
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: "Item Subtotal"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: formatCurrency(invoice.subtotal)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: "Shipping"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: "Free"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: "Taxes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: formatCurrency(invoice.taxes)
                                })
                            ]
                        }),
                        invoice.discounts && invoice.discounts.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: [
                                        "Discount if paid before ",
                                        formatDueDate(invoice.discounts[0].discountExpiration)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: [
                                        "-",
                                        formatCurrency(invoice.discounts[0].discountAmount)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "space-between",
                            fontWeight: 700,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: formatCurrency(invoice.total)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "center",
                    gap: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-secondary",
                            sx: {
                                textTransform: 'none'
                            },
                            onClick: handleCloseContinueToPaymentModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            sx: {
                                textTransform: 'none'
                            },
                            onClick: async ()=>{
                                await continueToPayment();
                                handleCloseContinueToPaymentModal();
                            },
                            children: "Continue to payment"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                paddingTop: "16px",
                display: "flex",
                flexDirection: "row",
                gap: 2,
                maxWidth: '450px',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
                    sx: $65b1395f481b4a08$var$cardStyles,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                        sx: {
                            paddingLeft: '0px',
                            paddingRight: '0px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                display: "flex",
                                flexDirection: "column",
                                gap: '24px',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$da524f2075150321), {
                                        children: "Pay an invoice"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($65b1395f481b4a08$var$RequiredSymbol, {
                                                children: "*"
                                            }),
                                            "All fields are required"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                container: true,
                                                rowSpacing: '16px',
                                                columnSpacing: '16px',
                                                justifyContent: "start",
                                                alignItems: "flex-start",
                                                style: {
                                                    marginBottom: '8px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        children: createTextField("firstName", "Your first name", inputFields.firstName)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        children: createTextField("lastName", "Your last name", inputFields.lastName)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                container: true,
                                                rowSpacing: '16px',
                                                columnSpacing: '16px',
                                                justifyContent: "start",
                                                alignItems: "flex-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 12,
                                                        children: createTextField("email", "Your email address", inputFields.email)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 12,
                                                        children: createTextField("invoiceNumber", "Invoice number", inputFields.invoiceNumber, 1)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                        item: true,
                                                        xs: 12,
                                                        children: [
                                                            createTextField("zipcode", "Billing ZIP code", inputFields.zipcode, 2),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)(InfoText, {
                                                                text: "Must match the billing ZIP code on the invoice. Accepted formats for billing zip code are 5 digits (e.g. 10001) or 9 digits (e.g. 10001-1111)"
                                                            })
                                                        ]
                                                    }),
                                                    !invoicePayLookupEnabled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 12,
                                                                gap: '7px',
                                                                children: [
                                                                    createTextField("shippingOrgName", "Organization name on the shipping address", inputFields.shippingOrgName, 3),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoText, {
                                                                        text: "Must match the shipping address as it appears on the invoice."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                xs: 12,
                                                                children: [
                                                                    createTextField("paymentAmount", "Payment amount", inputFields.paymentAmount),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoText, {
                                                                        text: "Enter the full amount due.",
                                                                        fontWeight: "700"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoText, {
                                                                        text: " Please note we do not accept partial payments.",
                                                                        display: "inline"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                sx: $65b1395f481b4a08$var$buttonsContainerSxStyles,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                                                    type: "submit",
                                                    id: "submit",
                                                    sx: {
                                                        padding: "16px 24px",
                                                        textTransform: "none"
                                                    },
                                                    buttonType: "mds-primary",
                                                    "data-testid": "continueBtn",
                                                    loading: processing,
                                                    children: "Continue"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            showPaymentForm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                openModal: showPaymentForm,
                closeModalHandler: handleCloseStripeModal,
                modalContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "center",
                            fontSize: "24px",
                            fontWeight: 700,
                            children: [
                                "Pay Invoice #",
                                invoiceNumber
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)(StripeForm, {
                            invoiceNumber: invoiceNumber,
                            paymentAmount: paymentAmount,
                            setShowSpinner: setShowSpinner,
                            handleCancel: handleCloseStripeModal
                        })
                    ]
                }),
                style: {
                    maxWidth: '521px',
                    width: 'auto',
                    padding: '24px'
                }
            }),
            !!invoice && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e8bacdab23dabef2$export$285171c9188af4ea), {
                openModal: !!invoice,
                closeModalHandler: handleCloseContinueToPaymentModal,
                modalContent: /*#__PURE__*/ (0, $ayMG0.jsx)(ContinueToPaymentModalContent, {}),
                style: {
                    maxWidth: '521px',
                    width: 'auto',
                    padding: '24px'
                }
            })
        ]
    });
};





const $8298783b32d93603$var$InfoTextBlock = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "block",
        mb: 1,
        sx: {
            userSelect: 'text'
        },
        children: children
    });
};
const $8298783b32d93603$var$spinnerStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    backgroundColor: '#F9F9FA',
    pointerEvents: 'none',
    flexDirection: 'column'
};
const $8298783b32d93603$var$spinnerMessageStyle = {
    fontSize: '24px',
    fontWeight: 400
};
const $8298783b32d93603$var$ImportantInformationBlock = ({ invoicePayLookupEnabled: invoicePayLookupEnabled })=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: '450px',
        paddingTop: '16px',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                children: "Here\u2019s where you can find the requested invoice information."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                alt: "Invoice pay instructions",
                src: invoicePayLookupEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($bc1c9735578b18ae$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9984c9376241dcbe$exports))),
                width: '450px',
                height: '334px'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$b534932db7eb0121), {
                children: "Important information"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                textAlign: "left",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8298783b32d93603$var$InfoTextBlock, {
                        children: [
                            "If you are entitled to a prompt pay discount, please calculate your new total using",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: (0, $5cdc329eeebd56d0$export$ec42b568fd72efee),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: " these calculation instructions. "
                            }),
                            "See your invoice for your payment terms."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8298783b32d93603$var$InfoTextBlock, {
                        children: [
                            "Transactions over $9,999,999.99 cannot be processed through this portal. Please refer to our",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                                color: '#0379B2',
                                sx: {
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                },
                                onClick: ()=>history.push(`/invoicepay`),
                                children: " payment options "
                            }),
                            " page for Bank Wire Transfer details."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8298783b32d93603$var$InfoTextBlock, {
                        children: [
                            "If you encounter any difficulties with payment processing or have further questions, our dedicated Customer Care Team is available via email at",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                component: "span",
                                sx: {
                                    color: '#0379B2',
                                    userSelect: 'text'
                                },
                                children: " WeCare@modernatx.com"
                            }),
                            " or by calling",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                component: "span",
                                sx: {
                                    display: 'block',
                                    userSelect: 'text'
                                },
                                children: "1-866-MODERNA (1-866-663-3762) (8:00AM - 8:00PM ET, Monday-Friday, excluding holidays)."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $8298783b32d93603$var$InvoicePayPage = ()=>{
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const alertRef = (0, $acw62.useRef)(null);
    const [showSpinner, setShowSpinner] = (0, $acw62.useState)(false);
    const invoicePayLookupEnabled = (0, $acw62.useMemo)(()=>new URLSearchParams(globalThis.location.search).get("validate") !== "false", [
        globalThis.location.search
    ]);
    const errorMsgHandler = (errorMsg)=>{
        setErrorMsg(errorMsg);
        alertRef.current?.openAlert(errorMsg);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        backgroundColor: "#F9F9FA",
        children: [
            showSpinner && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d17069175ac33db1$export$2e2bcd8739ae039), {
                message: "Processing payment. Please do not refresh or leave this page.",
                sx: $8298783b32d93603$var$spinnerStyles,
                messageSx: $8298783b32d93603$var$spinnerMessageStyle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e57c79a3bb70098b$export$8ebcecbecdb22732), {
                variant: "filled",
                type: "error",
                message: errorMsg,
                sx: {
                    top: 120
                },
                ref: alertRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                display: "flex",
                gap: 4,
                justifyContent: 'center',
                paddingTop: '88px',
                paddingBottom: '88px',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65b1395f481b4a08$export$d223ba5eba3fe1b0), {
                        handleErrorMsg: errorMsgHandler,
                        invoicePayLookupEnabled: invoicePayLookupEnabled,
                        setShowSpinner: setShowSpinner
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8298783b32d93603$var$ImportantInformationBlock, {
                        invoicePayLookupEnabled: invoicePayLookupEnabled
                    })
                ]
            })
        ]
    });
};
var $8298783b32d93603$export$2e2bcd8739ae039 = $8298783b32d93603$var$InvoicePayPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $3bYfT = parcelRequire("3bYfT");





const $9a638383061bd222$var$buttonStyles = {
    padding: "16px 24px",
    textTransform: "none",
    '@media print': {
        display: 'none'
    }
};
const $9a638383061bd222$var$InvoicePayConfirmationPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const paymentDetails = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.commerce?.paymentDetails?.paymentDetails);
    const canAccessInvoicePayConfirmationPage = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.canAccessInvoicePayConfirmationPage);
    const wasUnauthenticatedOnLoad = (0, $acw62.useRef)(!authState?.isAuthenticated);
    (0, $acw62.useEffect)(()=>{
        if (!canAccessInvoicePayConfirmationPage) history?.push(`/${locale}/`);
        else dispatch((0, $c89d887792446c86$export$a8f8d34a822b029c)(false));
    }, [
        history
    ]);
    (0, $acw62.useEffect)(()=>{
        if (wasUnauthenticatedOnLoad?.current && authState?.isAuthenticated) history.push("/home");
    }, [
        authState,
        history
    ]);
    const { name: name, email: email, invoiceId: invoiceId, amount: amount, paymentMethodType: paymentMethodType, lastFour: lastFour } = paymentDetails || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        sx: {
            minHeight: "550px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: "64px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($16182d64948f0f20$exports))),
                alt: "check icon",
                className: "CheckIcon",
                height: "56",
                width: "56"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                "data-testid": "ConfirmationMsgSection",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                        "data-testid": "ThankYouMsg",
                        fontFamily: "Aeonik Regular",
                        fontSize: "24px",
                        fontWeight: 500,
                        children: [
                            "Thank you, ",
                            name,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$da524f2075150321), {
                        children: [
                            "Your payment for Invoice #",
                            invoiceId,
                            " has been received."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                width: '610px',
                mt: 6,
                mb: 8,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$b534932db7eb0121), {
                        children: [
                            "Amount paid: ",
                            (0, $382eb84981692d3a$export$dd58d1211079db17)(amount)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                        children: [
                            name,
                            " (",
                            email,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1068173721857b5$export$94944d8910c4db4b), {
                        children: paymentMethodType === 'CARD' ? `Credit card ending in ${lastFour}` : `Bank account ending in ${lastFour}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingTop: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            "data-testid": "printPageButton",
                            sx: $9a638383061bd222$var$buttonStyles,
                            onClick: ()=>window?.print(),
                            children: "Print this page for your records"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 16,
                sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '16px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-secondary",
                        "data-testid": "placeAnotherInvoiceButton",
                        sx: $9a638383061bd222$var$buttonStyles,
                        onClick: ()=>history.push(`/invoice/pay`),
                        children: "Pay another invoice"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                        buttonType: "mds-secondary",
                        "data-testid": "goToHomePageButton",
                        sx: $9a638383061bd222$var$buttonStyles,
                        onClick: ()=>history.push(`/${locale}/`),
                        children: "Go to Homepage"
                    })
                ]
            })
        ]
    });
};
var $9a638383061bd222$export$2e2bcd8739ae039 = $9a638383061bd222$var$InvoicePayConfirmationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");
var $3bYfT = parcelRequire("3bYfT");



var $2346a851f49a9bad$exports = {};
$2346a851f49a9bad$exports = new URL("banner-strand-right.7b45fab2.png", import.meta.url).toString();


const $f434ac181affd50a$export$14526f74b4549992 = {
    invoicePayTextBody: {
        "data": {},
        "content": [
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [],
                        "value": "At Moderna, we strive to provide our customers with a seamless and convenient payment experience.",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            },
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [],
                        "value": "",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            },
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [],
                        "value": "Currently, we accept:",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            },
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "value": "Credit Card, ACH Bank Transfer, Bank Wire Transfer and Check",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            },
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [],
                        "value": "",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            },
            {
                "data": {},
                "content": [
                    {
                        "data": {},
                        "marks": [],
                        "value": "Please have your invoice available. You will need information on it to make a payment through our ",
                        "nodeType": "text"
                    },
                    {
                        "data": {
                            "uri": "/invoice/pay"
                        },
                        "content": [
                            {
                                "data": {},
                                "marks": [],
                                "value": "Payments Portal",
                                "nodeType": "text"
                            }
                        ],
                        "nodeType": "hyperlink"
                    },
                    {
                        "data": {},
                        "marks": [],
                        "value": "",
                        "nodeType": "text"
                    }
                ],
                "nodeType": "paragraph"
            }
        ],
        "nodeType": "document"
    },
    invoicePayTextBodyLower: {
        "nodeType": "document",
        "data": {},
        "content": [
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Bank Wire Transfer\n",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Financial institution:",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": " Bank of America ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "\n",
                        "marks": [],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": "Account name: ",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": "Moderna US, Inc.  ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "\n",
                        "marks": [],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": "ACH/Wire routing number:",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": " 011000138/02009593 ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "\n",
                        "marks": [],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": "Account number:",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": " 466001423356 ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Please include your invoice number as the reference when initiating the transfer.",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": " ",
                        "marks": [],
                        "data": {}
                    },
                    {
                        "nodeType": "text",
                        "value": "Check ",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Note: Currently, payment by check is only available to customers whose invoice total is below $5,000.  \n \nMake checks payable to Moderna and send them to: ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "\nLockbox Address: ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Moderna US, Inc.  ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "P.O. Box 411543 ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Boston, MA 02241-1543 ",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "Please be advised that the available payment options are subject to change and may be updated as necessary.",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "",
                        "marks": [],
                        "data": {}
                    }
                ]
            },
            {
                "nodeType": "paragraph",
                "data": {},
                "content": [
                    {
                        "nodeType": "text",
                        "value": "If you encounter any difficulties with payment processing or have further questions, our dedicated customer support team is here to assist you at 1-866-MODERNA (1-866-663-3762) between the hours of 8:00AM- 8:00PM EST, Monday-Friday (not including Holidays). You can also email wecare@modernatx.com with questions.",
                        "marks": [],
                        "data": {}
                    }
                ]
            }
        ]
    },
    title: "InvoicePay ",
    invoiceBanner: {
        "metadata": {
            "tags": [],
            "concepts": []
        },
        "sys": {
            "space": {
                "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                }
            },
            "id": "1Px4l8fvDKjBGrRTCqfWrE",
            "type": "Asset",
            "createdAt": "2022-12-29T16:44:45.722Z",
            "updatedAt": "2022-12-29T16:44:45.722Z",
            "environment": {
                "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                }
            },
            "publishedVersion": 5,
            "revision": 1,
            "locale": "en-US"
        },
        "fields": {
            "title": "Banner BG strand top right",
            "description": "Banner BG strand top right",
            "file": {
                "url": (0, (/*@__PURE__*/$parcel$interopDefault($2346a851f49a9bad$exports))),
                "details": {
                    "size": 47693,
                    "image": {
                        "width": 1920,
                        "height": 511
                    }
                },
                "fileName": "Banner_BG_strand_right.png",
                "contentType": "image/png"
            }
        }
    },
    pageTitle: "Moderna payment options",
    invoicePayButtonText: "Pay by credit card or ACH bank transfer"
};


const $c1a0d7f518c7b0e3$var$BannerContainer = (0, $d8seH.default)('div')(({ aboveFoldBGImage: aboveFoldBGImage, theme: { palette: { primary: primary }, breakpoints: breakpoints } })=>`
    background-color: ${primary.main};
    background-image: url(${aboveFoldBGImage});
    background-size: cover;
    height: 200px;
    ${[
        breakpoints.down('sm')
    ]} {
        background-image: unset;
    }
    `);
const $c1a0d7f518c7b0e3$var$InvoicePayInfoPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const handlePayButton = ()=>{
        history.push('/invoice/pay');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c1a0d7f518c7b0e3$var$BannerContainer, {
                aboveFoldBGImage: (0, $f434ac181affd50a$export$14526f74b4549992).invoiceBanner.fields.file.url,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    variant: 'h1',
                    color: 'neutral.white',
                    py: '40px',
                    px: {
                        xs: '48px'
                    },
                    children: (0, $f434ac181affd50a$export$14526f74b4549992).pageTitle
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                margin: '48px',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd31b523df1fca51$export$2e2bcd8739ae039), {
                            jsonData: (0, $f434ac181affd50a$export$14526f74b4549992).invoicePayTextBody
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mt: 4,
                        mb: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d5ba5e5d9aef962$export$353f5b6fc5456de1), {
                            buttonType: "mds-primary",
                            "data-testid": "invoicePageBtn",
                            sx: {
                                padding: "16px 32px",
                                textTransform: "none"
                            },
                            onClick: handlePayButton,
                            children: (0, $f434ac181affd50a$export$14526f74b4549992).invoicePayButtonText
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd31b523df1fca51$export$2e2bcd8739ae039), {
                            jsonData: (0, $f434ac181affd50a$export$14526f74b4549992).invoicePayTextBodyLower
                        })
                    })
                ]
            })
        ]
    });
};
var $c1a0d7f518c7b0e3$export$2e2bcd8739ae039 = $c1a0d7f518c7b0e3$var$InvoicePayInfoPage;




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $5978b6563028fc27$export$e8c3eaf42547ca47 = /*#__PURE__*/ function(CreditStatus) {
    CreditStatus["Unused"] = "unused";
    CreditStatus["Used"] = "used";
    CreditStatus["Pending"] = "pending";
    return CreditStatus;
}({});
var $5978b6563028fc27$export$3a5728741144960f = /*#__PURE__*/ function(CreditType) {
    CreditType["Credit"] = "credit";
    CreditType["PartialCredit"] = "partial_credit";
    return CreditType;
}({});
var $5978b6563028fc27$export$3b350d23c71c3633 = /*#__PURE__*/ function(CreditSortableColumnKeys) {
    CreditSortableColumnKeys["CreditNo"] = "creditNo";
    CreditSortableColumnKeys["PONumber"] = "poNumber";
    CreditSortableColumnKeys["ShipTo"] = "shipTo";
    CreditSortableColumnKeys["CreditDate"] = "creditDate";
    CreditSortableColumnKeys["Total"] = "total";
    CreditSortableColumnKeys["Status"] = "status";
    return CreditSortableColumnKeys;
}({});



var $ayMG0 = parcelRequire("ayMG0");

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;


function $b2d0c66f58a40ae9$export$4393d2ccbbedb219(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $b2d0c66f58a40ae9$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $b2d0c66f58a40ae9$var$parseYear(dateStrings.date, additionalDigits);
        date = $b2d0c66f58a40ae9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $b2d0c66f58a40ae9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b2d0c66f58a40ae9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $b2d0c66f58a40ae9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $b2d0c66f58a40ae9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $b2d0c66f58a40ae9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $b2d0c66f58a40ae9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b2d0c66f58a40ae9$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($b2d0c66f58a40ae9$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $b2d0c66f58a40ae9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b2d0c66f58a40ae9$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b2d0c66f58a40ae9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($b2d0c66f58a40ae9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $b2d0c66f58a40ae9$var$parseDateUnit(captures[1]);
    const month = $b2d0c66f58a40ae9$var$parseDateUnit(captures[2]) - 1;
    const day = $b2d0c66f58a40ae9$var$parseDateUnit(captures[3]);
    const week = $b2d0c66f58a40ae9$var$parseDateUnit(captures[4]);
    const dayOfWeek = $b2d0c66f58a40ae9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b2d0c66f58a40ae9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b2d0c66f58a40ae9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$b2d0c66f58a40ae9$var$validateDate(year, month, day) || !$b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b2d0c66f58a40ae9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b2d0c66f58a40ae9$var$parseTime(timeString) {
    const captures = timeString.match($b2d0c66f58a40ae9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[1]);
    const minutes = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[2]);
    const seconds = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[3]);
    if (!$b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff) + seconds * 1000;
}
function $b2d0c66f58a40ae9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $b2d0c66f58a40ae9$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($b2d0c66f58a40ae9$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b2d0c66f58a40ae9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff));
}
function $b2d0c66f58a40ae9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $b2d0c66f58a40ae9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b2d0c66f58a40ae9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b2d0c66f58a40ae9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b2d0c66f58a40ae9$var$daysInMonths[month] || ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b2d0c66f58a40ae9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b2d0c66f58a40ae9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$b2d0c66f58a40ae9$export$2e2bcd8739ae039 = $b2d0c66f58a40ae9$export$4393d2ccbbedb219;


parcelRequire("acw62");


var $4bdf5c881662bf0c$export$37ff47a81fd4e0a3 = /*#__PURE__*/ function(InvoiceFields) {
    InvoiceFields["ConfirmationNum"] = "Payment ID";
    InvoiceFields["InvoiceNums"] = "Invoice #";
    InvoiceFields["PaymentDate"] = "Payment date";
    InvoiceFields["PaymentMethod"] = "Payment method";
    InvoiceFields["Amount"] = "Amount";
    return InvoiceFields;
}({});
var $4bdf5c881662bf0c$export$d5c1d4491a804016 = /*#__PURE__*/ function(InvoiceStatus) {
    InvoiceStatus["Paid"] = "paid";
    InvoiceStatus["Open"] = "open";
    InvoiceStatus["Overdue"] = "overdue";
    InvoiceStatus["DueSoon"] = "due_soon";
    InvoiceStatus["Pending"] = "pending";
    return InvoiceStatus;
}({});
var $4bdf5c881662bf0c$export$999f810846f9d31d = /*#__PURE__*/ function(PaymentStatus) {
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["Open"] = "Open";
    PaymentStatus["Overdue"] = "Overdue";
    PaymentStatus["DueSoon"] = "Due Soon";
    PaymentStatus["Pending"] = "Pending";
    return PaymentStatus;
}({});
var $4bdf5c881662bf0c$export$c20edc3521983dfc = /*#__PURE__*/ function(DiscountType) {
    DiscountType["PromptPay"] = "PROMPT_PAY";
    DiscountType["Online"] = "ONLINE";
    return DiscountType;
}({});
var $4bdf5c881662bf0c$export$1597d5104ed2e9a5 = /*#__PURE__*/ function(SortableColumnKeys) {
    SortableColumnKeys["InvoiceNo"] = "invoiceNo";
    SortableColumnKeys["PONumber"] = "poNumber";
    SortableColumnKeys["ShipTo"] = "shipTo";
    SortableColumnKeys["Total"] = "total";
    SortableColumnKeys["DueDate"] = "dueDate";
    SortableColumnKeys["Status"] = "status";
    return SortableColumnKeys;
}({});
const $4bdf5c881662bf0c$export$8c2c933a0431b968 = {
    invoices: {
        id: "invoices",
        label: "Invoices"
    },
    credits: {
        id: "credits",
        label: "Credits"
    },
    statements: {
        id: "statements",
        label: "Statements"
    }
};
const $4bdf5c881662bf0c$export$5f11cae7dc44242c = [
    "Open",
    "Overdue",
    "Due Soon"
];



const $674a6d1fd517a9c0$export$62bb39aa76e51fe4 = (status)=>{
    switch(status){
        case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Paid:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                variant: "success",
                label: status
            });
        case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Open:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                variant: "info",
                label: status
            });
        case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Overdue:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                variant: "critical",
                label: status
            });
        case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).DueSoon:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                variant: "warning",
                label: status
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                label: status
            });
    }
};
const $674a6d1fd517a9c0$export$c66e31eb3547a3c3 = (status)=>{
    switch(status){
        case (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Paid;
        case (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Open:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Open;
        case (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Overdue:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Overdue;
        case (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).DueSoon:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).DueSoon;
        case (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Pending:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Pending;
        default:
            return (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Open;
    }
};
const $674a6d1fd517a9c0$export$61afbc5ac484e14e = (status)=>{
    switch(status){
        case (0, $5978b6563028fc27$export$e8c3eaf42547ca47).Unused:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                variant: "info",
                label: "Unused"
            });
        case (0, $5978b6563028fc27$export$e8c3eaf42547ca47).Pending:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                label: "Pending"
            });
        case (0, $5978b6563028fc27$export$e8c3eaf42547ca47).Used:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                label: "Used"
            });
        default:
            return "--";
    }
};
const $674a6d1fd517a9c0$export$3ae94a2503e890a1 = (dateStr)=>{
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
};
const $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c = (address)=>{
    if (!address) return "--";
    const { name: name, line1: line1, line2: line2, city: city, state: state, postalCode: postalCode } = address;
    return `${name}, ${line1}${line2 ? `, ${line2}` : ""}, ${city}, ${state} ${postalCode}`;
};
const $674a6d1fd517a9c0$export$b8a957a10d556e64 = (date)=>{
    if (!date) return "--";
    // to parse the high precision ISO string we get from the backend
    const normalizeToMilliseconds = (input)=>{
        return input.replace(/\.(\d{3})\d*Z$/, ".$1Z");
    };
    const normalizedDate = normalizeToMilliseconds(date);
    const dueDate = (0, $b2d0c66f58a40ae9$export$4393d2ccbbedb219)(normalizedDate);
    return dueDate.toLocaleDateString("en-us", {
        timeZone: "UTC"
    });
};
const $674a6d1fd517a9c0$export$c86caf1be068fb8d = (price)=>{
    if (price === undefined || price === null) return "";
    const num = typeof price === "number" ? price : parseFloat(price);
    return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
const $674a6d1fd517a9c0$export$3dc27271f5d5c629 = (value, currency = "USD")=>{
    if (value === undefined) return "--";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency
    }).format(value / 100);
};
const $674a6d1fd517a9c0$export$41ff66af7ea83a31 = (value, currency)=>{
    if (value === undefined || value === "") return "";
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) return value; // fallback if value is not a number
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency
    }).format(numberValue);
};
const $674a6d1fd517a9c0$var$getCardDetails = (brand)=>{
    const CREDIT_CARD_MAPPING = {
        mastercard: {
            name: "Mastercard",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$92dc6f1607efbf86), {})
        },
        amex: {
            name: "American Express",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$49d21b24afef9d10), {})
        },
        visa: {
            name: "Visa",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$4bcf14e559aee129), {})
        },
        discover: {
            name: "Discover",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$7f0dbae677da5cb3), {})
        },
        diners: {
            name: "Diners",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
        },
        jcb: {
            name: "JCB",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
        },
        unionpay: {
            name: "UnionPay",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
        },
        elo: {
            name: "Elo",
            logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
        }
    };
    return brand && CREDIT_CARD_MAPPING[brand] || {
        name: "Credit Card",
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$3bb9e80988b79358), {})
    };
};
const $674a6d1fd517a9c0$export$c6d9bc08dd6602d9 = (brand)=>{
    const CARD_NAME_MAPPING = {
        mastercard: "Mastercard",
        amex: "American Express",
        visa: "Visa",
        discover: "Discover",
        diners: "Diners",
        jcb: "JCB",
        unionpay: "UnionPay",
        elo: "Elo"
    };
    return brand && CARD_NAME_MAPPING[brand] ? CARD_NAME_MAPPING[brand] : "Credit Card";
};
const $674a6d1fd517a9c0$export$32f13e25b4f4240c = (brand, bankName)=>{
    if (bankName) return {
        name: bankName,
        logo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c9e9b0d96165e76$export$6495330c0ada5a03), {})
    };
    return $674a6d1fd517a9c0$var$getCardDetails(brand);
};
const $674a6d1fd517a9c0$export$7c54fad7190d0375 = ()=>(0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
const $674a6d1fd517a9c0$export$4f89b831ca9f07a9 = {
    ACTIVE: "ACTIVE",
    PENDING: "PENDING"
};
const $674a6d1fd517a9c0$export$d6e58abbbec7e1ac = {
    ACH: "us_bank_account",
    CARD: "card"
};
const $674a6d1fd517a9c0$export$46774d6b3c4ac9de = "STRIPE";
const $674a6d1fd517a9c0$export$d1dbdeee32dda451 = ()=>{
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();
    return `${month}-${day}-${year}`;
};


const $06a1d9cd637662fe$var$CreditList = ({ creditList: creditList, pageSize: pageSize, totalPage: totalPage, totalCredits: totalCredits, currentPage: currentPage, onPageChange: onPageChange, onPageSizeChange: onPageSizeChange, onSort: onSort, sortProperty: sortProperty, sortDirection: sortDirection })=>{
    const handleSortClick = (property)=>{
        const newSortDirection = sortProperty === property && sortDirection === (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC ? (0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC : (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC;
        onSort({
            property: property,
            direction: newSortDirection
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Table), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderRow), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).CreditNo),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditNo,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditNo ? sortDirection : undefined,
                                        children: "Credit number"
                                    }, "creditNo"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).PONumber),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).PONumber,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).PONumber ? sortDirection : undefined,
                                        children: "P.O. number"
                                    }, "poNumber"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).ShipTo),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).ShipTo,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).ShipTo ? sortDirection : undefined,
                                        grow: 1.5,
                                        children: "Shipping location"
                                    }, "shipTo"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).CreditDate),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditDate,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditDate ? sortDirection : undefined,
                                        children: "Date issued"
                                    }, "creditDate"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).Total),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).Total,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).Total ? sortDirection : undefined,
                                        children: "Credit amount"
                                    }, "total"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                        onClick: ()=>handleSortClick((0, $5978b6563028fc27$export$3b350d23c71c3633).Status),
                                        sortable: true,
                                        sortKey: (0, $5978b6563028fc27$export$3b350d23c71c3633).Status,
                                        sortDirection: sortProperty === (0, $5978b6563028fc27$export$3b350d23c71c3633).Status ? sortDirection : undefined,
                                        children: "Status"
                                    }, "status")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableBody), {
                            children: creditList.map((credit, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Link), {
                                                href: `/your-account/invoices-and-payments/credits/${credit.creditNo}`,
                                                children: credit.creditNo
                                            })
                                        }, "creditNo"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: credit.poNumber || "--"
                                        }, "poNumber"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(credit.shipTo)
                                        }, "shipTo"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(credit.creditDate)
                                        }, "creditDate"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(credit.total, credit.currency)
                                        }, "total"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                            children: (0, $674a6d1fd517a9c0$export$61afbc5ac484e14e)(credit.status)
                                        }, "status")
                                    ]
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                    sx: {
                        mt: "spacing-9"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            push: [
                                0,
                                3,
                                5
                            ],
                            size: 2,
                            children: totalPage > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Pagination), {
                                page: currentPage,
                                count: totalPage,
                                onPageChange: onPageChange
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            push: [
                                0,
                                1,
                                3
                            ],
                            size: 2,
                            children: totalCredits > 10 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Dropdown), {
                                label: "No. per page",
                                defaultOption: {
                                    label: String(pageSize),
                                    value: pageSize
                                },
                                dropdownOptions: [
                                    {
                                        label: "10",
                                        value: 10
                                    },
                                    {
                                        label: "50",
                                        value: 50
                                    },
                                    {
                                        label: "100",
                                        value: 100
                                    }
                                ],
                                onSelectOption: ({ value: value })=>onPageSizeChange(Number(value))
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $06a1d9cd637662fe$export$2e2bcd8739ae039 = $06a1d9cd637662fe$var$CreditList;




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $9407708e4f6e2fcf$export$e20a17ce6bae962f = (paymentProvider)=>{
    const [clientSecret, setClientSecret] = (0, $acw62.useState)(null);
    const [paymentMethodId, setPaymentMethodId] = (0, $acw62.useState)("");
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const fetchClientSecret = async ()=>{
            const listPaymentResponse = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                status: (0, $674a6d1fd517a9c0$export$4f89b831ca9f07a9).PENDING
            });
            if (listPaymentResponse.status === 200 && listPaymentResponse?.data?.paymentMethodsList?.length) {
                const result = listPaymentResponse.data.paymentMethodsList?.[0];
                setClientSecret(result?.paymentMethodLifecycleDetails?.clientSecret);
                setPaymentMethodId(result?.paymentMethodId);
            } else try {
                setProcessing(true);
                const response = await (0, $36d886fe12e537c3$export$b0b9fa6eec891db0)({
                    paymentProvider: paymentProvider,
                    idempotencyToken: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)()
                });
                if (response?.status === 200) {
                    setClientSecret(response.data?.paymentMethodLifecycleDetails?.clientSecret || null);
                    setPaymentMethodId(response.data?.paymentMethodId);
                } else throw new Error("Failed to create payment method");
            } catch (err) {
                let message = "Error";
                if (err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328) && err.response?.data?.errorCode) message = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(err.response.data.errorCode);
                setError(message);
            } finally{
                setProcessing(false);
            }
        };
        fetchClientSecret();
    }, [
        paymentProvider
    ]);
    return {
        clientSecret: clientSecret,
        paymentMethodId: paymentMethodId,
        processing: processing,
        error: error
    };
};







const $cdfeb8fc3aad436b$var$stripePromise = (0, $2110bf72a86f956f$export$de80f7562c3fd6b1)("pk_live_51Ofa2fDIC0zRrnfSs5qjVHugIRh4kbdBp5yTZGkp1uX3wvbGuVeOZmTJcQhmJI2bxmdIBT713Or6sT6j6OirMMDn00UIQ0Ps30", {
    betas: [
        "blocked_card_brands_beta_2"
    ]
});
const $cdfeb8fc3aad436b$var$appearance = {
    theme: "stripe",
    variables: {
        colorPrimary: "#0570de",
        colorBackground: "#ffffff",
        colorText: "#30313d",
        colorDanger: "#df1b41",
        fontFamily: "Ideal Sans, system-ui, sans-serif",
        spacingUnit: "4px",
        borderRadius: "4px"
    }
};
const $cdfeb8fc3aad436b$export$b6ded7c5f3fd9245 = ({ setSubmitRef: setSubmitRef, source: source })=>{
    const { clientSecret: clientSecret, paymentMethodId: paymentMethodId } = (0, $9407708e4f6e2fcf$export$e20a17ce6bae962f)((0, $674a6d1fd517a9c0$export$46774d6b3c4ac9de));
    if (!clientSecret) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
        stripe: $cdfeb8fc3aad436b$var$stripePromise,
        options: {
            clientSecret: clientSecret,
            appearance: $cdfeb8fc3aad436b$var$appearance
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cdfeb8fc3aad436b$var$StripePaymentForm, {
            paymentMethodId: paymentMethodId,
            setSubmitRef: setSubmitRef,
            source: source
        })
    });
};
const $cdfeb8fc3aad436b$var$StripePaymentForm = ({ paymentMethodId: paymentMethodId, setSubmitRef: setSubmitRef, source: source })=>{
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
    const [paymentMethodType, setPaymentMethodType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(undefined);
    const [isSubmitting, setIsSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const paymentElementOptions = {
        paymentMethodOrder: [
            (0, $674a6d1fd517a9c0$export$d6e58abbbec7e1ac).ACH
        ],
        terms: {
            card: "never",
            usBankAccount: "never"
        }
    };
    const handlePaymentMethodTypeChange = (event)=>{
        setPaymentMethodType(event.value.type);
    };
    const handleSubmit = async (e)=>{
        e?.preventDefault();
        if (!stripe || !elements) return;
        const { setupIntent: setupIntent, error: error } = await stripe.confirmSetup({
            elements: elements,
            confirmParams: {},
            redirect: "if_required"
        });
        if (error) {
            setErrorMessage(error.message);
            return;
        }
        setIsSubmitting(true);
        if (setupIntent) try {
            const updatePaymentMethodRequest = {
                idempotencyToken: (0, $674a6d1fd517a9c0$export$7c54fad7190d0375)(),
                paymentMethodLifecycleDetails: {
                    externalPaymentMethodId: setupIntent?.payment_method
                }
            };
            const response = await (0, $36d886fe12e537c3$export$5d4bd0ea3186eab)(updatePaymentMethodRequest, paymentMethodId);
            if (response?.status === 200) {
                const newPaymentMethodId = response?.data?.paymentMethodId;
                const newPaymentMethod = await (0, $36d886fe12e537c3$export$33fee9948e94a456)(newPaymentMethodId);
                let newPaymentMethodDetails;
                if (newPaymentMethod?.status === 200) newPaymentMethodDetails = newPaymentMethod?.data?.paymentMethodDetails;
                return newPaymentMethodDetails;
            }
        } catch (err) {
            if (err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328) && err.response?.data.errorCode) {
                const message = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(err?.response?.data?.errorCode);
                setErrorMessage(message);
            }
        } finally{
            setIsSubmitting(false);
        }
        else setErrorMessage("Something went wrong, please refresh the page and try again.");
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setSubmitRef(handleSubmit);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    position: "relative"
                },
                children: [
                    isSubmitting && source === "modal" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                        size: "md",
                        message: "Saving payment method...",
                        sx: {
                            position: "absolute",
                            inset: 0,
                            borderRadius: "radius-2"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                            options: paymentElementOptions,
                            onChange: handlePaymentMethodTypeChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    color: "color-system-gray-400",
                    pt: "4",
                    textAlign: "justify"
                },
                children: paymentMethodType === (0, $674a6d1fd517a9c0$export$d6e58abbbec7e1ac).ACH ? (0, $d0d210103d90c352$export$b220cd04490efc71) : (0, $d0d210103d90c352$export$664e2e65a3758b76)
            }),
            errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    color: "color-system-red-700"
                },
                children: errorMessage
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $47779349621d1d9b$var$getPaymentDetails(brand, bankName) {
    const paymentInfos = [
        (0, $674a6d1fd517a9c0$export$c6d9bc08dd6602d9)(brand),
        bankName
    ].filter((paymentInfo)=>paymentInfo).join(" - ");
    return {
        name: paymentInfos
    };
}
const $47779349621d1d9b$export$3274130eb3049d00 = ({ paymentMethod: paymentMethod, value: value })=>{
    const { brand: brand, bankName: bankName, lastFour: lastFour, expirationDate: expirationDate, billingName: billingName } = paymentMethod.paymentMethodInfo;
    const details = $47779349621d1d9b$var$getPaymentDetails(brand, bankName);
    const PaymentMethodLabel = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                fillGapStart: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-bold",
                            children: details.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "ending in"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-bold",
                            children: lastFour
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                fillGapStart: true,
                children: billingName && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    children: billingName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                fillGapStart: true,
                children: brand && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "Expires"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-regular",
                            children: expirationDate
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
        label: PaymentMethodLabel,
        value: value
    }, lastFour);
};


const $1dffb04d50d06935$export$8fe75b6de70608c8 = "add-new";


const $529ef8aee58d80a7$var$PaymentMethodCard = ({ allPaymentMethods: allPaymentMethods, defaultPaymentMethod: defaultPaymentMethod, paymentMethodError: paymentMethodError, setSelectedPayment: setSelectedPayment, selectedPayment: selectedPayment })=>{
    const selectedValue = selectedPayment === (0, $1dffb04d50d06935$export$8fe75b6de70608c8) ? (0, $1dffb04d50d06935$export$8fe75b6de70608c8) : selectedPayment?.paymentMethodId ?? "";
    if (!selectedPayment) return null;
    const sortedPaymentMethods = defaultPaymentMethod ? [
        defaultPaymentMethod,
        ...allPaymentMethods.filter((pm)=>pm.paymentMethodInfo.lastFour !== defaultPaymentMethod.paymentMethodInfo.lastFour)
    ] : [];
    const handleSelectionChange = (event)=>{
        const value = event.target.value;
        const matchedMethod = allPaymentMethods.find((pm)=>pm.paymentMethodId === value);
        if (setSelectedPayment) {
            if (matchedMethod) setSelectedPayment(matchedMethod);
            else if (value === (0, $1dffb04d50d06935$export$8fe75b6de70608c8)) setSelectedPayment((0, $1dffb04d50d06935$export$8fe75b6de70608c8));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.RadioGroup), {
        label: "Using",
        value: selectedValue,
        onChange: handleSelectionChange,
        children: [
            paymentMethodError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                variant: "critical",
                text: "There was an error retrieving one or more of your saved payment methods."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: sortedPaymentMethods.map((pm)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $47779349621d1d9b$export$3274130eb3049d00), {
                        paymentMethod: pm,
                        value: pm.paymentMethodId
                    }, pm.paymentMethodId))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                label: "Add a new payment method",
                value: (0, $1dffb04d50d06935$export$8fe75b6de70608c8)
            }, (0, $1dffb04d50d06935$export$8fe75b6de70608c8))
        ]
    });
};
var $529ef8aee58d80a7$export$2e2bcd8739ae039 = $529ef8aee58d80a7$var$PaymentMethodCard;


const $36b96421eb18718d$export$8646bf423b68e830 = ({ invoiceId: invoiceId, showAddPaymentMethod: showAddPaymentMethod, paymentFormSubmitRef: paymentFormSubmitRef, selectedPayment: selectedPayment, setSelectedPayment: setSelectedPayment, paymentScheduleOptions: paymentScheduleOptions, setPaymentScheduleOptions: setPaymentScheduleOptions, paymentMethods: paymentMethods, isInvoiceOverdue: isInvoiceOverdue })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76b58c0031dfc49c$export$2e2bcd8739ae039), {
                invoiceId: invoiceId,
                paymentScheduleOptions: paymentScheduleOptions,
                setPaymentScheduleOptions: setPaymentScheduleOptions,
                isInvoiceOverdue: isInvoiceOverdue
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $529ef8aee58d80a7$export$2e2bcd8739ae039), {
                defaultPaymentMethod: paymentMethods.default,
                allPaymentMethods: paymentMethods.all,
                paymentMethodError: paymentMethods.error,
                selectedPayment: selectedPayment,
                setSelectedPayment: setSelectedPayment
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    mt: "spacing-7"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    children: showAddPaymentMethod && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfeb8fc3aad436b$export$b6ded7c5f3fd9245), {
                        setSubmitRef: (fn)=>{
                            if (paymentFormSubmitRef) paymentFormSubmitRef.current = fn;
                        }
                    })
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $c4c34ab4d3512419$export$ffa9cda37b2c2e8f = ()=>{
    const [allPaymentMethods, setAllPaymentMethods] = (0, $acw62.useState)([]);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = (0, $acw62.useState)(undefined);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const getSavedPaymentMethods = async ()=>{
            try {
                const res = await (0, $36d886fe12e537c3$export$81713a21f003821b)({
                    status: (0, $674a6d1fd517a9c0$export$4f89b831ca9f07a9).ACTIVE
                });
                const allMethods = res.data.paymentMethodsList;
                const defaultMethod = allMethods.find((pm)=>pm.isDefault) || allMethods[0];
                setDefaultPaymentMethod(defaultMethod);
                setAllPaymentMethods(allMethods);
            } catch (err) {
                let message = "Error";
                if (err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328) && err.response?.data?.errorCode) message = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(err.response.data.errorCode);
                setError(message);
            } finally{
                setLoading(false);
            }
        };
        getSavedPaymentMethods();
    }, []);
    return {
        allPaymentMethods: allPaymentMethods,
        defaultPaymentMethod: defaultPaymentMethod,
        loading: loading,
        error: error
    };
};



function $0998488b5e4416e8$export$41b919c5f6c8434b(existingSetup) {
    // Load saved payment methods
    const { allPaymentMethods: allPaymentMethods, defaultPaymentMethod: defaultPaymentMethod, loading: loadingPaymentMethods, error: paymentMethodError } = (0, $c4c34ab4d3512419$export$ffa9cda37b2c2e8f)();
    const [selectedPayment, setSelectedPayment] = (0, $acw62.useState)(undefined);
    const [scheduleOption, setScheduleOption] = (0, $acw62.useState)(existingSetup?.paymentScheduleOption ?? (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).OnDueDate);
    const [specificDate, setSpecificDate] = (0, $acw62.useState)(existingSetup?.specificDate);
    // Preselect the saved payment method
    (0, $acw62.useEffect)(()=>{
        if (allPaymentMethods.length === 0) return;
        const existingId = existingSetup?.paymentMethodId;
        if (existingId) {
            const match = allPaymentMethods.find((pm)=>pm.paymentMethodId === existingId);
            if (match) {
                setSelectedPayment(match);
                return;
            }
        } else if (defaultPaymentMethod) setSelectedPayment(defaultPaymentMethod);
    }, [
        existingSetup,
        allPaymentMethods,
        defaultPaymentMethod
    ]);
    const showAddPaymentMethod = selectedPayment === (0, $1dffb04d50d06935$export$8fe75b6de70608c8);
    return {
        selectedPayment: selectedPayment,
        setSelectedPayment: setSelectedPayment,
        showAddPaymentMethod: showAddPaymentMethod,
        scheduleOption: scheduleOption,
        setScheduleOption: setScheduleOption,
        specificDate: specificDate,
        setSpecificDate: setSpecificDate,
        paymentMethods: {
            all: allPaymentMethods,
            default: defaultPaymentMethod,
            loading: loadingPaymentMethods,
            error: paymentMethodError
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $57396f277958df7a$export$43a750ddd9f2303e = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes["CreditErrors"] = "CREDIT_ERRORS";
    ErrorTypes["InvoiceErrors"] = "INVOICE_ERRORS";
    ErrorTypes["PaymentErrors"] = "PAYMENT_ERRORS";
    ErrorTypes["SchedulePaymentErrors"] = "SCHEDULE_PAYMENT_ERRORS";
    return ErrorTypes;
}({});
const $57396f277958df7a$var$CREDIT_ERRORS = {
    INVALID_REQUEST_PARAMETERS: "Something went wrong. Please try refreshing the page or come back later.",
    SERVICE_UNAVAILABLE: "Something went wrong. Please try refreshing the page or come back later.",
    INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
    DEFAULT: "We\u2019re unable to retrieve your credits at the moment. Please try again later."
};
const $57396f277958df7a$var$INVOICE_ERRORS = {
    INVALID_REQUEST_PARAMETERS: "Something went wrong. Please try refreshing the page or come back later.",
    SERVICE_UNAVAILABLE: "Something went wrong. Please try refreshing the page or come back later.",
    INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
    DEFAULT: "We\u2019re unable to retrieve your invoices at the moment. Please try again later."
};
const $57396f277958df7a$var$PAYMENT_ERRORS = {
    INVALID_REQUEST_PARAMETERS: "Something went wrong. Please try refreshing the page or come back later.",
    SERVICE_UNAVAILABLE: "Something went wrong. Please try refreshing the page or come back later.",
    INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
    DEFAULT: "We\u2019re unable to retrieve your invoices at the moment. Please try again later."
};
const $57396f277958df7a$var$SCHEDULE_PAYMENT_ERRORS = {
    INVALID_REQUEST_PARAMETERS: "Something went wrong. Please try refreshing the page or come back later.",
    SERVICE_UNAVAILABLE: "Something went wrong. Please try refreshing the page or come back later.",
    INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
    DEFAULT: "We\u2019re unable to retrieve your payment schedule at the moment. Please try again later."
};
const $57396f277958df7a$export$d8bd0967cb58683 = {
    ["CREDIT_ERRORS"]: $57396f277958df7a$var$CREDIT_ERRORS,
    ["INVOICE_ERRORS"]: $57396f277958df7a$var$INVOICE_ERRORS,
    ["PAYMENT_ERRORS"]: $57396f277958df7a$var$PAYMENT_ERRORS,
    ["SCHEDULE_PAYMENT_ERRORS"]: $57396f277958df7a$var$SCHEDULE_PAYMENT_ERRORS
};



function $8b20cefd4ba9b33f$export$82f46aa4e6535a45(apiKey, error) {
    const apiErrorMap = (0, $57396f277958df7a$export$d8bd0967cb58683)[apiKey];
    const errorCode = error?.response?.data?.errorCode;
    if (typeof errorCode === "string" && errorCode in apiErrorMap) return apiErrorMap[errorCode];
    return apiErrorMap.DEFAULT || "Something went wrong. Please try again later.";
}


const $bc809b088eda8737$export$b59c39444b1742a6 = ()=>{
    const [isFetchingSchedule, setIsFetchingSchedule] = (0, $acw62.useState)(false);
    const [fetchScheduleError, setFetchScheduleError] = (0, $acw62.useState)(null);
    const createSchedulePayment = async (payload)=>{
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: "paymentsservice/schedule/payment",
                method: "POST",
                data: {
                    ...payload
                }
            });
            return response;
        } catch (err) {
            const error = err;
            throw error;
        }
    };
    const getScheduledPayment = async (invoiceId)=>{
        setIsFetchingSchedule(true);
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039).get(`paymentsservice/schedule/payment/invoice/${invoiceId}`);
            return response.data;
        } catch (err) {
            const error = err;
            if (error?.response?.status === 404) // Silently ignore 404 — treat it as "no schedule exists"
            return null;
            setFetchScheduleError((0, $8b20cefd4ba9b33f$export$82f46aa4e6535a45)((0, $57396f277958df7a$export$43a750ddd9f2303e).SchedulePaymentErrors, err));
            return null;
        } finally{
            setIsFetchingSchedule(false);
        }
    };
    const updateScheduledPayment = async (schedulePaymentId, payload)=>{
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: `paymentsservice/schedule/payment/${schedulePaymentId}`,
                method: "POST",
                data: {
                    ...payload
                }
            });
            return response;
        } catch (err) {
            const error = err;
            throw error;
        }
    };
    const cancelScheduledPayment = async (schedulePaymentId, emailAddresses, userId, invoiceId)=>{
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039).delete(`paymentsservice/schedule/payment/${schedulePaymentId}`, {
                data: {
                    emailAddresses: emailAddresses,
                    userId: userId,
                    invoiceId: invoiceId
                }
            });
            return response;
        } catch (err) {
            const error = err;
            throw error;
        }
    };
    return {
        createSchedulePayment: createSchedulePayment,
        getScheduledPayment: getScheduledPayment,
        isFetchingSchedule: isFetchingSchedule,
        fetchScheduleError: fetchScheduleError,
        setFetchScheduleError: setFetchScheduleError,
        updateScheduledPayment: updateScheduledPayment,
        cancelScheduledPayment: cancelScheduledPayment
    };
};


var $0362458e65875278$export$fb69cca885f43986 = /*#__PURE__*/ function(AutoPayTypes) {
    AutoPayTypes["AllInvoices"] = "ALL_INVOICES";
    AutoPayTypes["AllInvoicesUpdate"] = "ALL_INVOICES_UPDATE";
    return AutoPayTypes;
}({});
var $0362458e65875278$export$6d1de440a8971297 = /*#__PURE__*/ function(AutomaticPaymentType) {
    AutomaticPaymentType["AutoPay"] = "AUTO_PAY";
    AutomaticPaymentType["SchedulePay"] = "SCHEDULED_PAY";
    return AutomaticPaymentType;
}({});












var $5dd8f06f97192188$export$53f30e59bdb45a5c = /*#__PURE__*/ function(PaymentScheduleOptions) {
    PaymentScheduleOptions["OnDueDate"] = "ON_DUE_DATE";
    PaymentScheduleOptions["OneDayBefore"] = "ONE_DAY_BEFORE";
    PaymentScheduleOptions["TwoDaysBefore"] = "TWO_DAYS_BEFORE";
    PaymentScheduleOptions["SpecificDate"] = "SPECIFIC_DATE";
    return PaymentScheduleOptions;
}({});
const $5dd8f06f97192188$export$f27d4b28e5c9daaa = ({ isVisible: isVisible, setVisible: setVisible, invoiceData: invoiceData, onScheduleSuccess: onScheduleSuccess, paymentSchedule: paymentSchedule })=>{
    const { createSchedulePayment: createSchedulePayment, updateScheduledPayment: updateScheduledPayment, cancelScheduledPayment: cancelScheduledPayment } = (0, $bc809b088eda8737$export$b59c39444b1742a6)();
    const { selectedPayment: selectedPayment, setSelectedPayment: setSelectedPayment, showAddPaymentMethod: showAddPaymentMethod, scheduleOption: scheduleOption, setScheduleOption: setScheduleOption, paymentMethods: paymentMethods } = (0, $0998488b5e4416e8$export$41b919c5f6c8434b)(paymentSchedule);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    const isUpdateMode = !!paymentSchedule;
    const isInvoiceOverdue = invoiceData?.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Overdue;
    (0, $acw62.useEffect)(()=>{
        if (isInvoiceOverdue) setScheduleOption("SPECIFIC_DATE");
    });
    // currently set to single schedules for scope
    const modalTitle = "Schedule payment";
    const modalButtons = [
        {
            label: "Cancel",
            onClick: ()=>setVisible(false)
        },
        {
            label: isUpdateMode ? "Update" : "Schedule",
            onClick: ()=>handleConfirmClick()
        }
    ];
    const paymentFormSubmitRef = (0, $acw62.useRef)(undefined);
    const resolveFinalPaymentMethod = async ()=>{
        if (selectedPayment === (0, $1dffb04d50d06935$export$8fe75b6de70608c8) && paymentFormSubmitRef.current) {
            const newPaymentMethod = await paymentFormSubmitRef.current();
            if (newPaymentMethod) {
                setSelectedPayment(newPaymentMethod);
                return newPaymentMethod;
            }
        }
        if (typeof selectedPayment === "object" && selectedPayment?.paymentMethodId) return selectedPayment;
        return undefined;
    };
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const userId = userInfo?.userId;
    const userEmail = userInfo?.email;
    const handleConfirmClick = async ()=>{
        try {
            const finalPaymentMethod = await resolveFinalPaymentMethod();
            if (!finalPaymentMethod) return;
            setIsLoading(true);
            const payload = {
                dueDate: invoiceData?.dueDate,
                invoiceId: invoiceData?.invoiceId,
                paymentMethodId: finalPaymentMethod.paymentMethodId,
                scheduleOption: scheduleOption,
                automaticPaymentType: (0, $0362458e65875278$export$6d1de440a8971297).SchedulePay,
                soldToOrgId: invoiceData?.soldToOrgId,
                emailAddresses: [
                    userEmail
                ],
                userId: userId
            };
            if (isUpdateMode && paymentSchedule?.paymentScheduleId && userId) {
                const updatePayload = {
                    ...payload,
                    userId: userId
                };
                const result = await updateScheduledPayment(paymentSchedule.paymentScheduleId, updatePayload);
                if (result?.status === 200) {
                    onScheduleSuccess?.(result.data, "Payment schedule updated!");
                    setVisible(false);
                }
            } else {
                const result = await createSchedulePayment(payload);
                if (result?.status === 200) {
                    onScheduleSuccess?.(result.data);
                    setVisible(false);
                }
            }
        } catch (error) {
            setErrorMessage((0, $8b20cefd4ba9b33f$export$82f46aa4e6535a45)((0, $57396f277958df7a$export$43a750ddd9f2303e).SchedulePaymentErrors, error));
        } finally{
            setIsLoading(false);
        }
    };
    const handleDeleteSchedule = async ()=>{
        if (!paymentSchedule?.paymentScheduleId) return;
        setIsLoading(true);
        try {
            const result = await cancelScheduledPayment(paymentSchedule.paymentScheduleId, [
                userEmail
            ], userId, invoiceData?.invoiceId);
            if (result?.status === 200) onScheduleSuccess?.(result.data, "Payment schedule canceled!");
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Modal), {
        title: modalTitle,
        isOpen: isVisible,
        onDismiss: ()=>setVisible(false),
        buttons: modalButtons,
        size: "sm",
        children: [
            errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                variant: "critical",
                text: errorMessage
            }),
            paymentMethods.loading || isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    sx: {
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Spinner), {})
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $36b96421eb18718d$export$8646bf423b68e830), {
                        invoiceId: invoiceData?.invoiceId,
                        showAddPaymentMethod: showAddPaymentMethod,
                        paymentFormSubmitRef: paymentFormSubmitRef,
                        selectedPayment: selectedPayment,
                        setSelectedPayment: setSelectedPayment,
                        paymentScheduleOptions: scheduleOption,
                        setPaymentScheduleOptions: setScheduleOption,
                        loadingScheduledPayment: isLoading,
                        paymentMethods: paymentMethods,
                        isInvoiceOverdue: isInvoiceOverdue
                    }),
                    paymentSchedule && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                        sx: {
                            alignItems: "center",
                            textAlign: "center",
                            mt: "spacing-7"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                    sx: {
                                        mb: "spacing-5"
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                    variant: "subtle",
                                    onClick: handleDeleteSchedule,
                                    children: "Delete scheduled payment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                    sx: {
                                        mt: "spacing-5"
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


const $76b58c0031dfc49c$var$InvoicePaymentScheduleForm = ({ invoiceId: invoiceId, paymentScheduleOptions: paymentScheduleOptions, setPaymentScheduleOptions: setPaymentScheduleOptions, isInvoiceOverdue: isInvoiceOverdue })=>{
    const isScheduledPay = !!invoiceId;
    const radioLabel = isScheduledPay ? `Pay invoice ${invoiceId}` : "Pay all invoices";
    const handleSelectionChange = (event)=>{
        const value = event.target.value;
        setPaymentScheduleOptions(value);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            mb: "spacing-6"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioGroup), {
            label: radioLabel,
            value: paymentScheduleOptions,
            onChange: handleSelectionChange,
            children: isInvoiceOverdue ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                label: "Specific date",
                value: (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).SpecificDate
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                        label: "On the due date",
                        value: (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).OnDueDate
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                        label: "1 day before the due date",
                        value: (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).OneDayBefore
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                        label: "2 days before the due date",
                        value: (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).TwoDaysBefore
                    }),
                    isScheduledPay && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
                        label: "Specific date",
                        value: (0, $5dd8f06f97192188$export$53f30e59bdb45a5c).SpecificDate
                    })
                ]
            })
        })
    });
};
var $76b58c0031dfc49c$export$2e2bcd8739ae039 = $76b58c0031dfc49c$var$InvoicePaymentScheduleForm;




const $1cdef40d5f9e2243$export$595399c9d402acc9 = ({ modalType: modalType, showAddPaymentMethod: showAddPaymentMethod, paymentFormSubmitRef: paymentFormSubmitRef, selectedPayment: selectedPayment, setSelectedPayment: setSelectedPayment, paymentScheduleOptions: paymentScheduleOptions, setPaymentScheduleOptions: setPaymentScheduleOptions, paymentMethods: paymentMethods })=>{
    if (paymentMethods.loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
            sx: {
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Spinner), {})
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76b58c0031dfc49c$export$2e2bcd8739ae039), {
                paymentScheduleOptions: paymentScheduleOptions,
                setPaymentScheduleOptions: setPaymentScheduleOptions
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $529ef8aee58d80a7$export$2e2bcd8739ae039), {
                defaultPaymentMethod: paymentMethods.default,
                allPaymentMethods: paymentMethods.all,
                paymentMethodError: paymentMethods.error,
                selectedPayment: selectedPayment,
                setSelectedPayment: setSelectedPayment
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    mt: "spacing-7"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    children: showAddPaymentMethod && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfeb8fc3aad436b$export$b6ded7c5f3fd9245), {
                        setSubmitRef: (fn)=>{
                            if (paymentFormSubmitRef) paymentFormSubmitRef.current = fn;
                        }
                    })
                })
            }),
            modalType === (0, $0362458e65875278$export$fb69cca885f43986).AllInvoicesUpdate && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    alignItems: "center",
                    textAlign: "center",
                    mt: "spacing-6"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                            sx: {
                                mb: "spacing-5"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                            variant: "subtle",
                            children: "Turn off automatic payments"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                            sx: {
                                mt: "spacing-5"
                            }
                        })
                    ]
                })
            })
        ]
    });
};




const $79829944100f435a$var$modalButtonTexts = {
    [(0, $0362458e65875278$export$fb69cca885f43986).AllInvoices]: "Set up",
    [(0, $0362458e65875278$export$fb69cca885f43986).AllInvoicesUpdate]: "Update"
};
const $79829944100f435a$export$f59f0ee069b733e7 = ({ modalType: modalType, isVisible: isVisible, setVisible: setVisible })=>{
    const modalBtnText = $79829944100f435a$var$modalButtonTexts[modalType];
    const modalButtons = [
        {
            label: "Cancel",
            onClick: ()=>setVisible(false)
        },
        {
            label: modalBtnText,
            onClick: ()=>handleConfirmClick()
        }
    ];
    const { selectedPayment: selectedPayment, setSelectedPayment: setSelectedPayment, scheduleOption: scheduleOption, setScheduleOption: setScheduleOption, showAddPaymentMethod: showAddPaymentMethod, paymentMethods: paymentMethods } = (0, $0998488b5e4416e8$export$41b919c5f6c8434b)();
    const paymentFormSubmitRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const handleConfirmClick = async ()=>{
        if (showAddPaymentMethod) {
            const newPaymentMethod = await paymentFormSubmitRef.current?.();
            if (newPaymentMethod) {
                setSelectedPayment(newPaymentMethod);
                setVisible(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Modal), {
        title: "Automatic payments",
        isOpen: isVisible,
        onDismiss: ()=>setVisible(false),
        buttons: modalButtons,
        size: "sm",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cdef40d5f9e2243$export$595399c9d402acc9), {
            modalType: modalType,
            showAddPaymentMethod: showAddPaymentMethod,
            paymentFormSubmitRef: paymentFormSubmitRef,
            selectedPayment: selectedPayment,
            setSelectedPayment: setSelectedPayment,
            paymentScheduleOptions: scheduleOption,
            setPaymentScheduleOptions: setScheduleOption,
            paymentMethods: paymentMethods
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
const $6558bcb7d75a9b69$export$4d82141ed232d126 = ({ label: label, amount: amount, credits: credits, onClickCreditsLink: onClickCreditsLink, actions: actions, showError: showError })=>{
    const renderBalance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: "spacing-3"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "body-1-regular",
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "h2",
                    sx: {
                        color: "text-emphasis"
                    },
                    children: showError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-1-regular",
                        children: "Error loading balance"
                    }) : `${amount}*`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "body-1-regular",
                    children: [
                        `*includes ${credits && `${credits} of `}`,
                        onClickCreditsLink ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Link), {
                            onClick: onClickCreditsLink,
                            children: "credits"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "credits"
                        }),
                        "; pending payments are not reflected"
                    ]
                })
            ]
        });
    }, [
        label,
        showError,
        amount,
        credits,
        onClickCreditsLink
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                fillGapEnd: true,
                size: [
                    4,
                    4,
                    8
                ],
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        backgroundColor: "surface-neutral-default",
                        borderColor: "stroke-neutral-secondary",
                        borderEndStartRadius: "radius-2",
                        borderStartStartRadius: "radius-2",
                        borderStyle: "solid",
                        borderWidth: "1px 0 1px 1px",
                        boxSizing: "border-box",
                        boxShadow: "shadow-100",
                        display: [
                            "none",
                            "flex"
                        ],
                        flex: 1,
                        flexDirection: "column",
                        gap: [
                            "spacing-4",
                            "spacing-none"
                        ],
                        justifyContent: "center",
                        p: "spacing-8"
                    },
                    children: renderBalance()
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: 4,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        backgroundColor: "surface-neutral-default",
                        borderColor: "stroke-neutral-secondary",
                        borderEndEndRadius: "radius-2",
                        borderStartEndRadius: "radius-2",
                        borderEndStartRadius: [
                            "radius-2",
                            "unset",
                            "unset"
                        ],
                        borderStartStartRadius: [
                            "radius-2",
                            "unset",
                            "unset"
                        ],
                        borderStyle: "solid",
                        borderWidth: "1px 1px 1px 0",
                        boxShadow: "shadow-100",
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        gap: "spacing-4",
                        justifyContent: "center",
                        p: "spacing-8"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: [
                                    "flex",
                                    "none"
                                ],
                                pb: 4
                            },
                            children: renderBalance()
                        }),
                        !!actions?.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: [
                                    "none",
                                    "none",
                                    "flex-end"
                                ],
                                gap: "spacing-4"
                            },
                            children: actions.map((action, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                    variant: action.variant || "filled",
                                    onClick: action.onClick,
                                    icon: action.icon,
                                    iconPosition: "end",
                                    sx: {
                                        width: "100%",
                                        maxWidth: "290px"
                                    },
                                    children: action.label
                                }, index))
                        })
                    ]
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");









function $8c0a76ecc4972e40$var$useQueryParams() {
    const { search: search, pathname: pathname } = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const query = new URLSearchParams(search);
    const updateQuery = (params)=>{
        const newQuery = new URLSearchParams(search);
        Object.entries(params).forEach(([key, value])=>{
            newQuery.set(key, String(value));
        });
        history.push(`${pathname}?${newQuery.toString()}`);
    };
    return [
        query,
        updateQuery
    ];
}
const $8c0a76ecc4972e40$export$4921e58aa8dc37d2 = ()=>{
    // the purpose of this hook is to unify calls to the invoice service, and share state around loading and errors
    const [invoiceList, setInvoiceList] = (0, $acw62.useState)({
        invoices: [],
        pagination: {
            pageNumber: 0,
            pageSize: 20,
            total: 0
        },
        filters: {
            status: null,
            shippingLocation: null
        },
        sorting: {
            sortBy: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).DueDate,
            sortDirection: (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC
        }
    });
    const [isLoadingInvoices, setIsLoadingInvoices] = (0, $acw62.useState)(false);
    const [invoiceError, setInvoiceError] = (0, $acw62.useState)(null);
    const [creditList, setCreditList] = (0, $acw62.useState)({
        credits: [],
        pagination: {
            pageNumber: 0,
            pageSize: 20,
            total: 0
        },
        sorting: {
            sortBy: (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditDate,
            sortDirection: (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC
        }
    });
    const [isLoadingCredits, setIsLoadingCredits] = (0, $acw62.useState)(false);
    const [creditError, setCreditError] = (0, $acw62.useState)(null);
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const userId = userInfo?.userId;
    const [searchParams, updateSearchParams] = $8c0a76ecc4972e40$var$useQueryParams();
    const creditsEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("SEE_AND_APPLY_CREDITS");
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const tabs = (0, $acw62.useMemo)(()=>{
        const availableTabs = [
            {
                id: (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).invoices.id,
                label: (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).invoices.label
            }
        ];
        if (creditsEnabled) availableTabs.push({
            id: (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).credits.id,
            label: (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).credits.label
        });
        return availableTabs;
    }, [
        creditsEnabled
    ]);
    const [activeTab, setActiveTab] = (0, $acw62.useState)(()=>{
        const tabFromUrl = new URLSearchParams(location.search).get("tab");
        const validTab = tabs.find((t)=>t.id === tabFromUrl);
        if (validTab) return validTab.id;
        return tabs[0]?.id || (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).invoices.id;
    });
    const onClickTab = (tabId)=>{
        setActiveTab(tabId);
        const params = new URLSearchParams();
        params.set("tab", tabId);
        history.replace({
            pathname: location.pathname,
            search: params.toString()
        });
    };
    const currentPage = parseInt(searchParams.get("page") || "1", 10);
    const pageSize = parseInt(searchParams.get("pageSize") || "10", 10);
    const defaultSortProperty = activeTab === (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).invoices.id ? (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).DueDate : (0, $5978b6563028fc27$export$3b350d23c71c3633).CreditDate;
    const sortProperty = searchParams.get("sort") || defaultSortProperty;
    const sortDirection = searchParams.get("direction") || "asc";
    const fetchInvoices = async ()=>{
        setIsLoadingInvoices(true);
        setInvoiceError(null);
        try {
            const queryParams = new URLSearchParams();
            if (currentPage !== undefined) queryParams.set("pageNumber", String(currentPage - 1)); // API is 0-indexed
            if (pageSize !== undefined) queryParams.set("pageSize", String(pageSize));
            if (sortProperty) queryParams.set("sortProperty", sortProperty);
            if (sortDirection) queryParams.set("sortDirection", sortDirection);
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: `/invoiceservice/api/v1/invoices/search?${queryParams.toString()}`,
                method: "POST",
                data: {
                    userId: userId
                }
            });
            const data = response.data;
            // handle weird case where someone loads a page number with no data by resetting to page 1
            if (data.pagination.total > 0 && data.invoices.length === 0) {
                updateSearchParams({
                    page: 1
                });
                return;
            }
            // UNCOMMENT TO USE MOCK DATA FOR DEBUGGING
            // const data: InvoiceList = {
            //   invoices: mockInvoiceList.slice(
            //     (currentPage - 1) * pageSize,
            //     currentPage * pageSize
            //   ),
            //   pagination: {
            //     pageNumber: currentPage,
            //     pageSize: pageSize,
            //     total: mockInvoiceList.length
            //   },
            //   filters: {
            //     status: null,
            //     shippingLocation: null
            //   },
            //   sorting: {
            //     sortBy: sortProperty,
            //     sortDirection: sortDirection
            //   }
            // };
            setInvoiceList(data);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Error fetching invoices:", err);
            setInvoiceError(err.message);
            setInvoiceError((0, $8b20cefd4ba9b33f$export$82f46aa4e6535a45)((0, $57396f277958df7a$export$43a750ddd9f2303e).InvoiceErrors, err));
        } finally{
            setIsLoadingInvoices(false);
        }
    };
    const fetchCredits = async ()=>{
        setIsLoadingCredits(true);
        setCreditError(null);
        try {
            const queryParams = new URLSearchParams();
            if (currentPage !== undefined) queryParams.set("pageNumber", String(currentPage - 1));
            if (pageSize !== undefined) queryParams.set("pageSize", String(pageSize));
            if (sortProperty) queryParams.set("sortProperty", sortProperty);
            if (sortDirection) queryParams.set("sortDirection", sortDirection);
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: `/invoiceservice/api/v1/credits/search?${queryParams.toString()}`,
                method: "POST",
                data: {
                    userId: userId
                }
            });
            const data = response.data;
            // Fallback: reset to page 1 if no results
            if (data.pagination.total > 0 && data.credits.length === 0) {
                updateSearchParams({
                    page: 1
                });
                return;
            }
            setCreditList(data);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Error fetching credits:", err);
            setCreditError(err.message);
        } finally{
            setIsLoadingCredits(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (userId && activeTab === (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).invoices.id) fetchInvoices();
        else fetchCredits();
    // we don't want to callbackify fetchData so we have to keep it out of the dependencies, this is strategic so that we only call it on mount or when url params change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userId,
        activeTab,
        currentPage,
        pageSize,
        sortProperty,
        sortDirection
    ]);
    const handlePageChange = (newPage)=>{
        updateSearchParams({
            page: newPage
        });
    };
    const handleSort = (sort)=>{
        updateSearchParams({
            sort: sort.property,
            direction: sort.direction,
            page: 1 // reset page on sort
        });
    };
    const handlePageSizeChange = (size)=>{
        updateSearchParams({
            pageSize: size,
            page: 1 // reset page on size change
        });
    };
    return {
        currentPage: // Common
        currentPage,
        pageSize: pageSize,
        handlePageChange: handlePageChange,
        handlePageSizeChange: handlePageSizeChange,
        // Invoices
        invoiceList: invoiceList,
        isLoadingInvoices: isLoadingInvoices,
        invoiceError: invoiceError,
        sortProperty: sortProperty,
        sortDirection: sortDirection,
        handleSort: handleSort,
        creditList: // Credits
        creditList,
        isLoadingCredits: isLoadingCredits,
        creditError: creditError,
        tabs: // Tabs
        tabs,
        activeTab: activeTab,
        onClickTab: onClickTab
    };
};



var $acw62 = parcelRequire("acw62");


const $17c8e1dda01679ef$export$7e71817cd101fd85 = ()=>{
    const [summaryData, setSummaryData] = (0, $acw62.useState)({
        total: "0.00",
        currency: "USD",
        credits: "0.00",
        shipToAddresses: []
    });
    const [isLoadingSummary, setIsLoadingSummary] = (0, $acw62.useState)(false);
    const [showSummaryError, setShowSummaryError] = (0, $acw62.useState)(false);
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const userId = userInfo?.userId;
    (0, $acw62.useEffect)(()=>{
        if (userId) fetchSummary();
    // only fetch summary data once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userId
    ]);
    const fetchSummary = async ()=>{
        setIsLoadingSummary(true);
        setShowSummaryError(false);
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: "/invoiceservice/api/v1/invoices/summary",
                method: "POST",
                data: {
                    userId: userId
                }
            });
            setSummaryData(response.data);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Error fetching summary:", err);
            setShowSummaryError(true);
        } finally{
            setIsLoadingSummary(false);
        }
    };
    return {
        summaryData: summaryData,
        isLoadingSummary: isLoadingSummary,
        showSummaryError: showSummaryError
    };
};






var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







const $04845a921e4a2f82$var$InvoiceList = ({ invoiceList: invoiceList, pageSize: pageSize, totalPage: totalPage, totalInvoices: totalInvoices, currentPage: currentPage, sortDirection: sortDirection, sortProperty: sortProperty, onPageChange: onPageChange, onPageSizeChange: onPageSizeChange, onSort: onSort })=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const isMultiInvoicePayAvailable = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("MULTI_INVOICE_PAY");
    const [selectedInvoiceNos, setselectedInvoiceNos] = (0, $acw62.useState)([]);
    const [showScheduleModal, setShowScheduleModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const autoPayAndSchedulePayEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_AUTO_PAY_SCHEDULE_PAY_ENABLED");
    const allSelected = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return invoiceList.length > 0 && selectedInvoiceNos.length === invoiceList.length;
    }, [
        invoiceList,
        selectedInvoiceNos
    ]);
    const someSelected = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return selectedInvoiceNos.length > 0 && selectedInvoiceNos.length < invoiceList.length;
    }, [
        invoiceList,
        selectedInvoiceNos
    ]);
    const handleSelectAll = ()=>{
        if (allSelected) setselectedInvoiceNos([]);
        else setselectedInvoiceNos(invoiceList.map((invoice)=>invoice.invoiceNo));
    };
    const handleSelectRow = (invoiceNo)=>{
        if (selectedInvoiceNos.includes(invoiceNo)) setselectedInvoiceNos(selectedInvoiceNos.filter((id)=>id !== invoiceNo));
        else setselectedInvoiceNos([
            ...selectedInvoiceNos,
            invoiceNo
        ]);
    };
    const handleSortClick = (property)=>{
        const newSortDirection = sortProperty === property && sortDirection === (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC ? (0, $3bfa0b50aad38c89$export$7ae723045d45777a).DESC : (0, $3bfa0b50aad38c89$export$7ae723045d45777a).ASC;
        onSort({
            property: property,
            direction: newSortDirection
        });
    };
    const showActionBar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return someSelected || allSelected ? true : false;
    }, [
        allSelected,
        someSelected
    ]);
    const invoiceTexts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const count = selectedInvoiceNos.length;
        return {
            someSelectedText: `${count} ${count === 1 ? "invoice" : "invoices"} selected`,
            payButtonText: count === 1 ? "Pay invoice" : "Pay invoices",
            scheduleButtonText: count === 1 ? "Schedule payment" : "Schedule payments",
            downloadButtonText: count === 1 ? "Download invoice" : "Download invoices",
            shareButtonText: count === 1 ? "Share invoice" : "Share invoices"
        };
    }, [
        selectedInvoiceNos.length
    ]);
    const showPaymentButtons = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const selectedInvoices = invoiceList.filter((invoice)=>selectedInvoiceNos.includes(invoice.invoiceNo));
        return selectedInvoices.every((invoice)=>(0, $4bdf5c881662bf0c$export$5f11cae7dc44242c).includes((0, $674a6d1fd517a9c0$export$c66e31eb3547a3c3)(invoice.status)));
    }, [
        invoiceList,
        selectedInvoiceNos
    ]);
    const getActions = (status, invoiceNo)=>{
        switch(status){
            case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Open:
            case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).Overdue:
            case (0, $4bdf5c881662bf0c$export$999f810846f9d31d).DueSoon:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    onClick: ()=>{
                        history.push(`/pay?invoice=${invoiceNo}`);
                    },
                    variant: "outline",
                    children: "Pay Now"
                });
            default:
                return "--";
        }
    };
    const statusLegend = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
            gap: "spacing-5",
            minWidth: "fit-content",
            color: "text-default",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "normal",
            padding: "spacing-2"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    minWidth: "fit-content",
                    overflowWrap: "break-word"
                },
                variant: "body-2-regular",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-2-bold",
                        children: "Pending: "
                    }),
                    "Credit card payments are typically reflected within 3-5 business days. Payments made by ACH or check are typically reflected within 7-10 business days."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-2-regular",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-2-bold",
                        children: "Open: "
                    }),
                    "Unpaid."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-2-regular",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-2-bold",
                        children: "Due soon: "
                    }),
                    "5 days from due date."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-2-regular",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-2-bold",
                        children: "Overdue: "
                    }),
                    "Outstanding balance past due."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-2-regular",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-2-bold",
                        children: "Paid: "
                    }),
                    "Paid in full."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        children: [
            autoPayAndSchedulePayEnabled && showScheduleModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5dd8f06f97192188$export$f27d4b28e5c9daaa), {
                isVisible: showScheduleModal,
                setVisible: setShowScheduleModal
            }),
            showActionBar && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: [
                    (someSelected || allSelected) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-1-regular",
                        children: invoiceTexts.someSelectedText
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                        sx: {
                            display: "flex",
                            gap: "spacing-3",
                            mt: "spacing-3",
                            mb: "spacing-6"
                        },
                        children: [
                            showPaymentButtons && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                variant: "outline",
                                onClick: ()=>{},
                                children: invoiceTexts.payButtonText
                            }),
                            showPaymentButtons && autoPayAndSchedulePayEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                variant: "outline",
                                onClick: ()=>{
                                    setShowScheduleModal(true);
                                },
                                children: invoiceTexts.scheduleButtonText
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                variant: "outline",
                                icon: "download-simple",
                                iconPosition: "end",
                                onClick: ()=>{},
                                children: invoiceTexts.downloadButtonText
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                variant: "outline",
                                icon: "share",
                                iconPosition: "end",
                                onClick: ()=>{},
                                children: invoiceTexts.shareButtonText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Table), {
                        spacing: "default",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderRow), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableRow), {
                                    children: [
                                        isMultiInvoicePayAvailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderSelectionCell), {
                                            checked: allSelected,
                                            indeterminate: someSelected,
                                            onClick: handleSelectAll
                                        }, "select"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).InvoiceNo),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).InvoiceNo,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).InvoiceNo ? sortDirection : undefined,
                                            children: "Invoice ID"
                                        }, "invoiceNo"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).PONumber),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).PONumber,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).PONumber ? sortDirection : undefined,
                                            children: "P.O. number"
                                        }, "poNumber"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).ShipTo),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).ShipTo,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).ShipTo ? sortDirection : undefined,
                                            grow: 1.5,
                                            children: "Shipping location"
                                        }, "shipTo"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Total),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Total,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Total ? sortDirection : undefined,
                                            children: "Amount"
                                        }, "total"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).DueDate),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).DueDate,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).DueDate ? sortDirection : undefined,
                                            children: "Due date"
                                        }, "dueDate"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            onClick: ()=>handleSortClick((0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Status),
                                            sortable: true,
                                            sortKey: (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Status,
                                            sortDirection: sortProperty === (0, $4bdf5c881662bf0c$export$1597d5104ed2e9a5).Status ? sortDirection : undefined,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    gap: "spacing-2"
                                                },
                                                children: [
                                                    "Status",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Tooltip), {
                                                        content: statusLegend,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                                                            sx: {
                                                                pt: "spacing-2"
                                                            },
                                                            color: "text-link",
                                                            icon: "info",
                                                            size: "xxs"
                                                        })
                                                    })
                                                ]
                                            })
                                        }, "status"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                            children: "Actions"
                                        }, "actions")
                                    ].filter((cell)=>Boolean(cell))
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableBody), {
                                children: invoiceList.map((invoice, index)=>{
                                    const { invoiceNo: invoiceNo, poNumber: poNumber, shipTo: shipTo, total: total, currency: currency, dueDate: dueDate, status: status } = invoice;
                                    const paymentStatus = (0, $674a6d1fd517a9c0$export$c66e31eb3547a3c3)(status);
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableRow), {
                                        selected: isMultiInvoicePayAvailable && selectedInvoiceNos.includes(invoiceNo),
                                        children: [
                                            isMultiInvoicePayAvailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableSelectionCell), {
                                                checked: selectedInvoiceNos.includes(invoiceNo),
                                                onClick: ()=>handleSelectRow(invoiceNo)
                                            }, "select"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Link), {
                                                    href: `/your-account/invoices-and-payments/invoices/${invoiceNo}`,
                                                    children: invoiceNo
                                                })
                                            }, "invoiceNo"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: poNumber || "--"
                                            }, "poNumber"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(shipTo)
                                            }, "shipTo"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(total, currency)
                                            }, "total"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: dueDate ? (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(dueDate) : "--"
                                            }, "dueDate"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: (0, $674a6d1fd517a9c0$export$62bb39aa76e51fe4)(paymentStatus)
                                            }, "status"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                                children: getActions(paymentStatus, invoiceNo)
                                            }, "actions")
                                        ].filter((cell)=>Boolean(cell))
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                        sx: {
                            mt: "spacing-9"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                push: [
                                    0,
                                    3,
                                    5
                                ],
                                size: 2,
                                children: totalPage > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Pagination), {
                                    page: currentPage,
                                    count: totalPage,
                                    onPageChange: onPageChange
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                push: [
                                    0,
                                    1,
                                    3
                                ],
                                size: 2,
                                children: totalInvoices > 10 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Dropdown), {
                                    label: "Number of invoices",
                                    defaultOption: {
                                        label: String(pageSize),
                                        value: pageSize
                                    },
                                    dropdownOptions: [
                                        {
                                            label: "10",
                                            value: 10
                                        },
                                        {
                                            label: "50",
                                            value: 50
                                        },
                                        {
                                            label: "100",
                                            value: 100
                                        }
                                    ],
                                    onSelectOption: ({ value: value })=>onPageSizeChange(Number(value))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $04845a921e4a2f82$export$2e2bcd8739ae039 = $04845a921e4a2f82$var$InvoiceList;


const $e2e9acc20ee9a718$var$pages = [
    {
        pageId: "your-account",
        title: "Your Account"
    },
    {
        pageId: "your-account/invoices-and-payments",
        title: "Invoices and payments"
    }
];
const $e2e9acc20ee9a718$var$InvoicesAndPaymentsPage = ()=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const creditsEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("SEE_AND_APPLY_CREDITS");
    const autoPayAndSchedulePayEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_AUTO_PAY_SCHEDULE_PAY_ENABLED");
    const [showAutoPayModal, setShowAutoPayModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { isLoadingSummary: isLoadingSummary, showSummaryError: showSummaryError, summaryData: summaryData } = (0, $17c8e1dda01679ef$export$7e71817cd101fd85)();
    const { activeTab: activeTab, onClickTab: onClickTab, tabs: tabs, isLoadingInvoices: isLoadingInvoices, invoiceError: invoiceError, invoiceList: invoiceList, pageSize: pageSize, currentPage: currentPage, handlePageChange: handlePageChange, handlePageSizeChange: handlePageSizeChange, sortDirection: sortDirection, sortProperty: sortProperty, handleSort: handleSort, creditList: creditList, isLoadingCredits: isLoadingCredits, creditError: creditError } = (0, $8c0a76ecc4972e40$export$4921e58aa8dc37d2)();
    const invoiceBannerActions = [
        {
            label: "Pay balance",
            onClick: ()=>{},
            icon: "arrow-right",
            variant: "filled"
        },
        {
            label: "Set up automatic payments",
            onClick: ()=>{
                setShowAutoPayModal(true);
            },
            variant: "outline"
        }
    ];
    const onClickBreadcrumb = (pageId)=>{
        history.push(`/${pageId}`);
    };
    const pageContent = (()=>{
        switch(activeTab){
            case (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).credits.id:
                return /*#__PURE__*/ (0, $ayMG0.jsx)($e2e9acc20ee9a718$var$CreditsView, {
                    isLoadingCredits: isLoadingCredits,
                    creditError: creditError,
                    creditList: creditList,
                    pageSize: pageSize,
                    currentPage: currentPage,
                    handlePageChange: handlePageChange,
                    handlePageSizeChange: handlePageSizeChange,
                    handleSort: handleSort,
                    sortDirection: sortDirection,
                    sortProperty: sortProperty
                });
            case (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).statements.id:
                return /*#__PURE__*/ (0, $ayMG0.jsx)($e2e9acc20ee9a718$var$StatementsView, {});
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)($e2e9acc20ee9a718$var$InvoicesView, {
                    isLoadingInvoices: isLoadingInvoices,
                    invoiceError: invoiceError,
                    invoiceList: invoiceList,
                    pageSize: pageSize,
                    currentPage: currentPage,
                    handlePageChange: handlePageChange,
                    handlePageSizeChange: handlePageSizeChange,
                    handleSort: handleSort,
                    sortDirection: sortDirection,
                    sortProperty: sortProperty
                });
        }
    })();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: [
            autoPayAndSchedulePayEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $79829944100f435a$export$f59f0ee069b733e7), {
                modalType: (0, $0362458e65875278$export$fb69cca885f43986).AllInvoices,
                isVisible: showAutoPayModal,
                setVisible: setShowAutoPayModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    backgroundColor: "surface-neutral-secondary",
                    py: "spacing-9",
                    userSelect: "text"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                sx: {
                                    pb: "spacing-9"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Breadcrumb), {
                                    pages: $e2e9acc20ee9a718$var$pages,
                                    onClickPage: onClickBreadcrumb
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                sx: {
                                    pt: "spacing-6",
                                    pb: "spacing-9"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    variant: "h4",
                                    children: "Invoices and payments"
                                })
                            }),
                            !isLoadingSummary && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                sx: {
                                    pb: "spacing-9"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6558bcb7d75a9b69$export$4d82141ed232d126), {
                                        label: "Outstanding balance",
                                        amount: (0, $674a6d1fd517a9c0$export$41ff66af7ea83a31)(summaryData?.total ?? 0, summaryData?.currency ?? "USD"),
                                        ...creditsEnabled && {
                                            onClickCreditsLink: ()=>onClickTab("credits")
                                        },
                                        credits: (0, $674a6d1fd517a9c0$export$41ff66af7ea83a31)(summaryData?.credits, summaryData?.currency ?? "USD"),
                                        ...autoPayAndSchedulePayEnabled && {
                                            actions: invoiceBannerActions
                                        },
                                        showError: showSummaryError
                                    }),
                                    activeTab === (0, $4bdf5c881662bf0c$export$8c2c933a0431b968).credits.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            mt: "spacing-9"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                                            variant: "info",
                                            text: "The ability to apply credits to your account is planned for release later this year as part of our continued site enhancements to ModernaDirect.com. To apply any unused credits currently, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762)."
                                        })
                                    }),
                                    creditsEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            mt: "spacing-9"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Tabs), {
                                            items: tabs,
                                            defaultActive: activeTab,
                                            onClickTab: onClickTab
                                        }, activeTab)
                                    })
                                ]
                            })
                        ]
                    }),
                    pageContent
                ]
            })
        ]
    });
};
const $e2e9acc20ee9a718$var$InvoicesView = (props)=>{
    const { isLoadingInvoices: isLoadingInvoices, invoiceError: invoiceError, invoiceList: invoiceList, pageSize: pageSize, currentPage: currentPage, handlePageChange: handlePageChange, handlePageSizeChange: handlePageSizeChange, sortDirection: sortDirection, sortProperty: sortProperty, handleSort: handleSort } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
            sx: {
                pb: "spacing-10"
            },
            children: isLoadingInvoices ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                size: "xl"
            }) : invoiceError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    pt: "spacing-6",
                    color: "color-system-red-700"
                },
                children: invoiceError
            }) : !invoiceList.invoices.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    pt: "spacing-6"
                },
                color: "text-error",
                children: "No invoices found."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04845a921e4a2f82$export$2e2bcd8739ae039), {
                invoiceList: invoiceList.invoices || [],
                pageSize: pageSize,
                totalPage: Math.ceil((invoiceList?.pagination?.total ?? 0) / pageSize),
                totalInvoices: invoiceList.pagination.total,
                currentPage: currentPage,
                onPageChange: handlePageChange,
                onPageSizeChange: handlePageSizeChange,
                sortDirection: sortDirection,
                sortProperty: sortProperty,
                onSort: handleSort
            })
        })
    });
};
const $e2e9acc20ee9a718$var$CreditsView = (props)=>{
    const { isLoadingCredits: isLoadingCredits, creditError: creditError, creditList: creditList, pageSize: pageSize, currentPage: currentPage, handlePageChange: handlePageChange, handlePageSizeChange: handlePageSizeChange, sortDirection: sortDirection, sortProperty: sortProperty, handleSort: handleSort } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
            children: isLoadingCredits ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                size: "xl"
            }) : creditError ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    pt: "spacing-6",
                    color: "color-system-red-700"
                },
                children: creditError
            }) : creditList.credits.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    pt: "spacing-6"
                },
                color: "text-error",
                children: "No credits found."
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06a1d9cd637662fe$export$2e2bcd8739ae039), {
                creditList: creditList.credits,
                pageSize: pageSize,
                currentPage: currentPage,
                totalPage: Math.ceil((creditList.pagination.total ?? 0) / pageSize),
                onPageChange: handlePageChange,
                onPageSizeChange: handlePageSizeChange,
                totalCredits: creditList.pagination.total,
                sortDirection: sortDirection,
                sortProperty: sortProperty,
                onSort: handleSort
            })
        })
    });
};
const $e2e9acc20ee9a718$var$StatementsView = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                children: "Statements Content"
            })
        })
    });
};
var $e2e9acc20ee9a718$export$2e2bcd8739ae039 = $e2e9acc20ee9a718$var$InvoicesAndPaymentsPage;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");


const $9386e12ec258cf3b$export$bac6a6d6bfa9fd3f = ({ allPaymentMethods: allPaymentMethods, defaultPaymentMethod: defaultPaymentMethod, selectedPaymentMethod: selectedPaymentMethod, setSelectedPaymentMethod: setSelectedPaymentMethod })=>{
    const [isExpanded, setIsExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [allMethods, setAllMethods] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(allPaymentMethods);
    const handleChange = ()=>{
        setIsExpanded(true);
    };
    const handleSelectionChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>{
        const value = event.target.value;
        const selected = allMethods.find((pm)=>pm.paymentMethodInfo.lastFour === value);
        if (selected) setSelectedPaymentMethod(selected);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        allMethods
    ]);
    const sortedPaymentMethods = [
        defaultPaymentMethod,
        ...allMethods.filter((pm)=>pm.paymentMethodInfo?.lastFour !== defaultPaymentMethod.paymentMethodInfo.lastFour)
    ];
    const paymentFormSubmitRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const CollapsedView = ()=>{
        const brand = selectedPaymentMethod?.paymentMethodInfo?.brand;
        const bankName = selectedPaymentMethod?.paymentMethodInfo?.bankName;
        const lastFour = selectedPaymentMethod?.paymentMethodInfo?.lastFour;
        if (!brand && !bankName && !lastFour) return null;
        const paymentDetails = (0, $674a6d1fd517a9c0$export$32f13e25b4f4240c)(brand, bankName);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "spacing-6",
                gap: "spacing-4"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: "spacing-4"
                    },
                    children: [
                        paymentDetails.logo,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-regular",
                            children: [
                                "Paying with ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    variant: "body-1-bold",
                                    children: paymentDetails.name
                                }),
                                " ",
                                "ending in ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    variant: "body-1-bold",
                                    children: lastFour
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    variant: "outline",
                    onClick: handleChange,
                    children: "Change"
                })
            ]
        });
    };
    const [isAddPaymentOpen, setIsAddPaymentOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleCloseModal = ()=>{
        setIsAddPaymentOpen(false);
    };
    const handleAddPaymentMethod = async ()=>{
        const newPaymentMethod = await paymentFormSubmitRef.current?.();
        if (newPaymentMethod) {
            setAllMethods((prev)=>[
                    ...prev,
                    newPaymentMethod
                ]);
            setIsAddPaymentOpen(false);
            setIsExpanded(false);
            setSelectedPaymentMethod(newPaymentMethod);
        }
    };
    const AddPaymentMethodModal = ()=>{
        const modalButtons = [
            {
                label: "Cancel",
                onClick: ()=>handleCloseModal()
            },
            {
                label: "Add payment method",
                onClick: ()=>{
                    handleAddPaymentMethod();
                }
            }
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: "100%",
                backdropFilter: "blur(4px)",
                zIndex: 1
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Modal), {
                title: "Add a payment method",
                isOpen: isAddPaymentOpen,
                buttons: modalButtons,
                onDismiss: handleCloseModal,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfeb8fc3aad436b$export$b6ded7c5f3fd9245), {
                    setSubmitRef: (fn)=>{
                        paymentFormSubmitRef.current = fn;
                    },
                    source: "modal"
                })
            })
        });
    };
    const paymentMethodOptions = sortedPaymentMethods.map((pm)=>{
        const { brand: brand, bankName: bankName, lastFour: lastFour, expirationDate: expirationDate, billingName: billingName } = pm.paymentMethodInfo;
        const details = (0, $674a6d1fd517a9c0$export$32f13e25b4f4240c)(brand, bankName);
        const PaymentMethodLabel = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                gap: 1,
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-bold",
                            children: details.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "ending in"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-bold",
                            children: lastFour
                        })
                    ]
                }),
                billingName && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    children: billingName
                }),
                brand && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "Expires "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-regular",
                            children: expirationDate
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioButton), {
            label: PaymentMethodLabel,
            value: lastFour
        }, lastFour);
    });
    const ExpandedView = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                gap: "spacing-4",
                padding: "spacing-4",
                alignItems: "flex-start",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.RadioGroup), {
                    label: "Your payment methods",
                    value: selectedPaymentMethod?.paymentMethodInfo.lastFour,
                    onChange: handleSelectionChange,
                    children: paymentMethodOptions
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                            onClick: ()=>{
                                setIsExpanded(false);
                                setSelectedPaymentMethod(selectedPaymentMethod);
                            },
                            children: "Use this payment method"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                            variant: "subtle",
                            onClick: ()=>{
                                setIsAddPaymentOpen(true);
                            },
                            children: "Add a new payment method"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    border: "1px solid",
                    borderRadius: "radius-2",
                    borderColor: "color-system-gray-200",
                    justifyContent: "space-between",
                    width: "100%"
                },
                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)(ExpandedView, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)(CollapsedView, {})
            }),
            isAddPaymentOpen && /*#__PURE__*/ (0, $ayMG0.jsx)(AddPaymentMethodModal, {})
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

const $5f57f7aa8758d001$var$CheckboxLabel = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            pt: "spacing-7"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
            children: [
                "I agree to Moderna's",
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Link), {
                    target: "_blank",
                    href: "/terms-of-use",
                    children: "Conditions of Use"
                }),
                ",",
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Link), {
                    target: "_blank",
                    href: "/privacy-policy",
                    children: [
                        " ",
                        "Privacy Policy"
                    ]
                }),
                ", and",
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Link), {
                    target: "_blank",
                    href: "/terms-and-conditions-of-sale",
                    children: [
                        " ",
                        "Terms and Conditions of Sale."
                    ]
                })
            ]
        })
    });
};
const $5f57f7aa8758d001$export$decb9951004ccadb = ({ invoicePriceSummary: invoicePriceSummary, onPayNow: onPayNow, isPaymentMethodSelected: isPaymentMethodSelected, isPaymentFormOpen: isPaymentFormOpen })=>{
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Card), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                gap: "spacing-4",
                padding: "spacing-6",
                flexDirection: "column",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "h6",
                    children: "Summary"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                pb: "spacing-4"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                    weight: "medium",
                                    children: [
                                        "Subtotal (",
                                        invoicePriceSummary.totalDoses,
                                        " doses):"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    weight: "medium",
                                    children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoicePriceSummary.subtotal)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                pb: "spacing-4"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: "Shipping:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                pb: "spacing-4"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: "Sales tax:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoicePriceSummary.tax)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                            color: "color-system-gray-300"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                pb: "spacing-4"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    weight: "medium",
                                    children: "Invoice total:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    weight: "medium",
                                    children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoicePriceSummary.netInvoice)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                pb: "spacing-4"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: "Prompt pay discount:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                    children: [
                                        "- ",
                                        (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoicePriceSummary.promptPayDiscount)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                            color: "color-system-gray-300"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        invoicePriceSummary.promptPayDiscount ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "h6",
                            children: `Total due if paid by ${(0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(invoicePriceSummary.promptPayDueDate)}:`
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "h6",
                            children: "Amount to pay:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "h6",
                            children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoicePriceSummary.amountDue)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Checkbox), {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)($5f57f7aa8758d001$var$CheckboxLabel, {}),
                    value: isChecked,
                    onChange: ()=>setIsChecked((prev)=>!prev)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    disabled: !(isChecked && (isPaymentMethodSelected || isPaymentFormOpen)),
                    onClick: onPayNow,
                    children: "Pay now"
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");




const $54b25eb9cdaee676$export$c78aba6c77eb1e36 = ()=>{
    const [invoiceDetail, setInvoiceDetail] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const fetchInvoice = (0, $acw62.useCallback)(async (invoiceNum)=>{
        setIsLoading(true);
        setError(null);
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: `/invoiceservice/api/v1/invoice/${invoiceNum}`,
                method: "GET",
                params: {
                    userId: userInfo?.userId
                }
            });
            const data = response.data;
            setInvoiceDetail(data);
            return data;
        } catch (err) {
            setError((0, $8b20cefd4ba9b33f$export$82f46aa4e6535a45)((0, $57396f277958df7a$export$43a750ddd9f2303e).InvoiceErrors, err));
            return null;
        } finally{
            setIsLoading(false);
        }
    }, [
        userInfo?.userId
    ]);
    return {
        fetchInvoice: fetchInvoice,
        invoiceDetail: invoiceDetail,
        isLoading: isLoading,
        error: error,
        setInvoiceDetail: setInvoiceDetail,
        setIsLoading: setIsLoading,
        setError: setError
    };
};








const $5bb09a33860772bd$var$PaymentPage = ()=>{
    const { allPaymentMethods: allPaymentMethods, defaultPaymentMethod: defaultPaymentMethod } = (0, $c4c34ab4d3512419$export$ffa9cda37b2c2e8f)();
    const isMultiInvoicePayAvailable = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("MULTI_INVOICE_PAY");
    const useQuery = ()=>{
        return new URLSearchParams((0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)().search);
    };
    const query = useQuery();
    const invoiceNo = query.get("invoice") || "";
    const { fetchInvoice: fetchInvoice, setIsLoading: setIsLoading, isLoading: isLoading } = (0, $54b25eb9cdaee676$export$c78aba6c77eb1e36)();
    const [invoice, setInvoiceData] = (0, $acw62.useState)(null);
    const paymentFormSubmitRef = (0, $acw62.useRef)();
    const [paymentError, setPaymentError] = (0, $acw62.useState)(null);
    const [isPaymentsLoading, setIsPaymentsLoading] = (0, $acw62.useState)(false);
    const [isPaymentMethodSelected, setIsPaymentMethodSelected] = (0, $acw62.useState)(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = (0, $acw62.useState)();
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    (0, $acw62.useEffect)(()=>{
        if (defaultPaymentMethod) {
            setIsPaymentMethodSelected(true);
            setSelectedPaymentMethod(defaultPaymentMethod);
        }
    }, [
        defaultPaymentMethod
    ]);
    const onDismissBanner = (0, $acw62.useCallback)(()=>{
        setPaymentError(null);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const fetchInvoiceDetail = async ()=>{
            setIsLoading(true);
            const invoiceDetail = await fetchInvoice(invoiceNo);
            if (invoiceDetail) {
                setInvoiceData(invoiceDetail);
                setIsLoading(false);
            }
        };
        fetchInvoiceDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        invoiceNo
    ]);
    const invoicePriceSummary = (0, $acw62.useMemo)(()=>{
        const subtotal = invoice?.subtotal ?? 0;
        const tax = invoice?.taxes ?? 0;
        const total = invoice?.total ?? 0;
        const discount = invoice?.discounts?.[0]?.discountAmount ?? 0;
        const promptPayDiscountedTotal = total - discount;
        const totalDoses = invoice?.orderLineItems?.reduce((accumulator, currentValue)=>accumulator + Number(currentValue.quantity), 0);
        const promptPayDueDate = invoice?.dueDate;
        return {
            amountDue: total,
            totalDoses: totalDoses,
            subtotal: subtotal,
            tax: tax,
            netInvoice: subtotal + tax,
            promptPayDiscount: discount,
            promptPayDiscountedTotal: promptPayDiscountedTotal,
            promptPayDueDate: promptPayDueDate
        };
    }, [
        invoice
    ]);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const handlePayNow = async ()=>{
        const getPaymentMethodId = async ()=>{
            if (selectedPaymentMethod) return selectedPaymentMethod.paymentMethodId;
            else {
                const newPaymentMethod = await paymentFormSubmitRef.current?.();
                if (newPaymentMethod) {
                    setSelectedPaymentMethod(newPaymentMethod);
                    return newPaymentMethod.paymentMethodId;
                }
            }
        };
        const submitPayment = async (paymentMethodId)=>{
            const idempotencyToken = (0, $674a6d1fd517a9c0$export$7c54fad7190d0375)();
            const capturePayload = {
                idempotencyToken: idempotencyToken,
                invoiceId: invoice?.invoiceNo,
                orderId: invoice?.invoiceNo,
                amount: invoice?.total,
                paymentMethodId: paymentMethodId,
                metadata: {
                    capOrgId: invoice?.billTo.id,
                    upsCustomerId: "TBD",
                    soldToCapId: invoice?.soldTo.id,
                    billToCapId: invoice?.billTo.id,
                    shipToCapId: invoice?.shipTo.id,
                    soldToOrgName: invoice?.soldTo.name,
                    orderId: invoice?.orderNumber,
                    orderNumber: invoice?.orderNumber,
                    userId: userInfo?.userId,
                    paymentType: "INVOICE_PAY",
                    invoiceId: invoice?.invoiceNo
                },
                currency: (0, $5cdc329eeebd56d0$export$c19ece7ea27dcd9e)
            };
            try {
                setIsPaymentsLoading(true);
                const response = await (0, $36d886fe12e537c3$export$f33a4222dd0fef57)(capturePayload);
                if (response.status === 200) {
                    const paymentId = response.data.paymentDetails.paymentId;
                    history.push(`/payment/confirmation?paymentId=${paymentId}`);
                }
            } catch (err) {
                if (err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328) && err.response?.data?.errorCode) {
                    const message = (0, $988a08ad6804f205$export$fe0b41d6f39bfdf2)(err.response.data.errorCode);
                    setPaymentError(message);
                }
            } finally{
                setIsPaymentsLoading(false);
            }
        };
        const paymentMethodId = await getPaymentMethodId();
        if (paymentMethodId) await submitPayment(paymentMethodId);
    };
    const showLoadingSpinner = isLoading || isPaymentsLoading;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: showLoadingSpinner ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
            size: "xl",
            message: isPaymentsLoading ? "We\u2019re processing your payment. Please do not refresh or close this page." : undefined
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($89e552997d15ef2b$exports)))})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center right",
                        backgroundColor: "onSurface-brand-primary-hover",
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    py: "spacing-8",
                                    alignItems: "flex-start",
                                    gap: "spacing-4"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "h4",
                                        sx: {
                                            color: "white"
                                        },
                                        children: "Make a payment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            gap: "spacing-3",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "h6",
                                                sx: {
                                                    color: "white"
                                                },
                                                children: [
                                                    "Invoice:",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                                                size: "large",
                                                type: "info",
                                                label: `#${invoice?.invoiceNo}`
                                            })
                                        ]
                                    }),
                                    isMultiInvoicePayAvailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                        "aria-label": "Select invoices",
                                        icon: "caret-down",
                                        variant: "subtle",
                                        iconPosition: "end",
                                        size: "large",
                                        sx: {
                                            color: "white",
                                            padding: "0"
                                        },
                                        onClick: ()=>alert("Invoice selection"),
                                        children: "Select invoices"
                                    })
                                ]
                            })
                        })
                    })
                }),
                paymentError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                    variant: "critical",
                    title: "Error while processing payment",
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        children: paymentError
                    }),
                    onDismiss: onDismissBanner
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                    sx: {
                        gap: "spacing-8",
                        width: "100%",
                        py: "spacing-8"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            size: [
                                3,
                                5,
                                6
                            ],
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    sx: {
                                        textDecoration: "line-through"
                                    },
                                    children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)((invoice?.subtotal ?? 0) + (invoice?.taxes ?? 0))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                    variant: "h3",
                                    children: [
                                        (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice?.total),
                                        "*"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                    variant: "body-1-regular",
                                    children: [
                                        "Amount if paid by",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            sx: {
                                                mx: "spacing-2"
                                            },
                                            children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(invoice?.dueDate ?? "--")
                                        }),
                                        "*"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                    sx: {
                                        pt: "spacing-4"
                                    },
                                    children: defaultPaymentMethod ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9386e12ec258cf3b$export$bac6a6d6bfa9fd3f), {
                                        defaultPaymentMethod: defaultPaymentMethod,
                                        allPaymentMethods: allPaymentMethods,
                                        selectedPaymentMethod: selectedPaymentMethod,
                                        setSelectedPaymentMethod: setSelectedPaymentMethod
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdfeb8fc3aad436b$export$b6ded7c5f3fd9245), {
                                        setSubmitRef: (fn)=>{
                                            paymentFormSubmitRef.current = fn;
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            size: [
                                3,
                                5,
                                5
                            ],
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f57f7aa8758d001$export$decb9951004ccadb), {
                                invoicePriceSummary: invoicePriceSummary,
                                onPayNow: handlePayNow,
                                isPaymentMethodSelected: isPaymentMethodSelected,
                                isPaymentFormOpen: !defaultPaymentMethod
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $5bb09a33860772bd$export$2e2bcd8739ae039 = $5bb09a33860772bd$var$PaymentPage;


/* eslint-disable react-hooks/exhaustive-deps */ 
var $ayMG0 = parcelRequire("ayMG0");

var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");

// src/index.ts

var $acw62 = parcelRequire("acw62");

var $7JB23 = parcelRequire("7JB23");
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.1 Built on 2025-03-17T14:19:36.873Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $41YNz = parcelRequire("41YNz");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


var $15d064020a078dff$var$n = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $15d064020a078dff$var$i() {
    $15d064020a078dff$var$n.console && "function" == typeof $15d064020a078dff$var$n.console.log && $15d064020a078dff$var$n.console.log.apply($15d064020a078dff$var$n.console, arguments);
}
var $15d064020a078dff$var$a = {
    log: $15d064020a078dff$var$i,
    warn: function(t) {
        $15d064020a078dff$var$n.console && ("function" == typeof $15d064020a078dff$var$n.console.warn ? $15d064020a078dff$var$n.console.warn.apply($15d064020a078dff$var$n.console, arguments) : $15d064020a078dff$var$i.call(null, arguments));
    },
    error: function(t) {
        $15d064020a078dff$var$n.console && ("function" == typeof $15d064020a078dff$var$n.console.error ? $15d064020a078dff$var$n.console.error.apply($15d064020a078dff$var$n.console, arguments) : $15d064020a078dff$var$i(t));
    }
};
function $15d064020a078dff$var$o(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        $15d064020a078dff$var$l(n.response, e, r);
    }, n.onerror = function() {
        $15d064020a078dff$var$a.error("could not download file");
    }, n.send();
}
function $15d064020a078dff$var$s(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function $15d064020a078dff$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $15d064020a078dff$var$u, $15d064020a078dff$var$h, $15d064020a078dff$var$l = $15d064020a078dff$var$n.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(window)) || window !== $15d064020a078dff$var$n ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var i = $15d064020a078dff$var$n.URL || $15d064020a078dff$var$n.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $15d064020a078dff$var$s(a.href) ? $15d064020a078dff$var$o(t, e, r) : $15d064020a078dff$var$c(a, a.target = "_blank") : $15d064020a078dff$var$c(a)) : (a.href = i.createObjectURL(t), setTimeout(function() {
        i.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $15d064020a078dff$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if ($15d064020a078dff$var$s(e)) $15d064020a078dff$var$o(e, r, n);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $15d064020a078dff$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) && ($15d064020a078dff$var$a.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $15d064020a078dff$var$o(e, r, i);
    var s = "application/octet-stream" === e.type, c = /constructor/i.test($15d064020a078dff$var$n.HTMLElement) || $15d064020a078dff$var$n.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(FileReader))) {
        var h = new FileReader;
        h.onloadend = function() {
            var t = h.result;
            t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, h.readAsDataURL(e);
    } else {
        var l = $15d064020a078dff$var$n.URL || $15d064020a078dff$var$n.webkitURL, f = l.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            l.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $15d064020a078dff$var$f(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var i = r[n].re, a = r[n].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $15d064020a078dff$var$d(t, e) {
    var r = t[0], n = t[1], i = t[2], a = t[3];
    r = $15d064020a078dff$var$g(r, n, i, a, e[0], 7, -680876936), a = $15d064020a078dff$var$g(a, r, n, i, e[1], 12, -389564586), i = $15d064020a078dff$var$g(i, a, r, n, e[2], 17, 606105819), n = $15d064020a078dff$var$g(n, i, a, r, e[3], 22, -1044525330), r = $15d064020a078dff$var$g(r, n, i, a, e[4], 7, -176418897), a = $15d064020a078dff$var$g(a, r, n, i, e[5], 12, 1200080426), i = $15d064020a078dff$var$g(i, a, r, n, e[6], 17, -1473231341), n = $15d064020a078dff$var$g(n, i, a, r, e[7], 22, -45705983), r = $15d064020a078dff$var$g(r, n, i, a, e[8], 7, 1770035416), a = $15d064020a078dff$var$g(a, r, n, i, e[9], 12, -1958414417), i = $15d064020a078dff$var$g(i, a, r, n, e[10], 17, -42063), n = $15d064020a078dff$var$g(n, i, a, r, e[11], 22, -1990404162), r = $15d064020a078dff$var$g(r, n, i, a, e[12], 7, 1804603682), a = $15d064020a078dff$var$g(a, r, n, i, e[13], 12, -40341101), i = $15d064020a078dff$var$g(i, a, r, n, e[14], 17, -1502002290), r = $15d064020a078dff$var$m(r, n = $15d064020a078dff$var$g(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $15d064020a078dff$var$m(a, r, n, i, e[6], 9, -1069501632), i = $15d064020a078dff$var$m(i, a, r, n, e[11], 14, 643717713), n = $15d064020a078dff$var$m(n, i, a, r, e[0], 20, -373897302), r = $15d064020a078dff$var$m(r, n, i, a, e[5], 5, -701558691), a = $15d064020a078dff$var$m(a, r, n, i, e[10], 9, 38016083), i = $15d064020a078dff$var$m(i, a, r, n, e[15], 14, -660478335), n = $15d064020a078dff$var$m(n, i, a, r, e[4], 20, -405537848), r = $15d064020a078dff$var$m(r, n, i, a, e[9], 5, 568446438), a = $15d064020a078dff$var$m(a, r, n, i, e[14], 9, -1019803690), i = $15d064020a078dff$var$m(i, a, r, n, e[3], 14, -187363961), n = $15d064020a078dff$var$m(n, i, a, r, e[8], 20, 1163531501), r = $15d064020a078dff$var$m(r, n, i, a, e[13], 5, -1444681467), a = $15d064020a078dff$var$m(a, r, n, i, e[2], 9, -51403784), i = $15d064020a078dff$var$m(i, a, r, n, e[7], 14, 1735328473), r = $15d064020a078dff$var$v(r, n = $15d064020a078dff$var$m(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $15d064020a078dff$var$v(a, r, n, i, e[8], 11, -2022574463), i = $15d064020a078dff$var$v(i, a, r, n, e[11], 16, 1839030562), n = $15d064020a078dff$var$v(n, i, a, r, e[14], 23, -35309556), r = $15d064020a078dff$var$v(r, n, i, a, e[1], 4, -1530992060), a = $15d064020a078dff$var$v(a, r, n, i, e[4], 11, 1272893353), i = $15d064020a078dff$var$v(i, a, r, n, e[7], 16, -155497632), n = $15d064020a078dff$var$v(n, i, a, r, e[10], 23, -1094730640), r = $15d064020a078dff$var$v(r, n, i, a, e[13], 4, 681279174), a = $15d064020a078dff$var$v(a, r, n, i, e[0], 11, -358537222), i = $15d064020a078dff$var$v(i, a, r, n, e[3], 16, -722521979), n = $15d064020a078dff$var$v(n, i, a, r, e[6], 23, 76029189), r = $15d064020a078dff$var$v(r, n, i, a, e[9], 4, -640364487), a = $15d064020a078dff$var$v(a, r, n, i, e[12], 11, -421815835), i = $15d064020a078dff$var$v(i, a, r, n, e[15], 16, 530742520), r = $15d064020a078dff$var$b(r, n = $15d064020a078dff$var$v(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $15d064020a078dff$var$b(a, r, n, i, e[7], 10, 1126891415), i = $15d064020a078dff$var$b(i, a, r, n, e[14], 15, -1416354905), n = $15d064020a078dff$var$b(n, i, a, r, e[5], 21, -57434055), r = $15d064020a078dff$var$b(r, n, i, a, e[12], 6, 1700485571), a = $15d064020a078dff$var$b(a, r, n, i, e[3], 10, -1894986606), i = $15d064020a078dff$var$b(i, a, r, n, e[10], 15, -1051523), n = $15d064020a078dff$var$b(n, i, a, r, e[1], 21, -2054922799), r = $15d064020a078dff$var$b(r, n, i, a, e[8], 6, 1873313359), a = $15d064020a078dff$var$b(a, r, n, i, e[15], 10, -30611744), i = $15d064020a078dff$var$b(i, a, r, n, e[6], 15, -1560198380), n = $15d064020a078dff$var$b(n, i, a, r, e[13], 21, 1309151649), r = $15d064020a078dff$var$b(r, n, i, a, e[4], 6, -145523070), a = $15d064020a078dff$var$b(a, r, n, i, e[11], 10, -1120210379), i = $15d064020a078dff$var$b(i, a, r, n, e[2], 15, 718787259), n = $15d064020a078dff$var$b(n, i, a, r, e[9], 21, -343485551), t[0] = $15d064020a078dff$var$_(r, t[0]), t[1] = $15d064020a078dff$var$_(n, t[1]), t[2] = $15d064020a078dff$var$_(i, t[2]), t[3] = $15d064020a078dff$var$_(a, t[3]);
}
function $15d064020a078dff$var$p(t, e, r, n, i, a) {
    return e = $15d064020a078dff$var$_($15d064020a078dff$var$_(e, t), $15d064020a078dff$var$_(n, a)), $15d064020a078dff$var$_(e << i | e >>> 32 - i, r);
}
function $15d064020a078dff$var$g(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e & r | ~e & n, t, e, i, a, o);
}
function $15d064020a078dff$var$m(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e & n | r & ~n, t, e, i, a, o);
}
function $15d064020a078dff$var$v(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e ^ r ^ n, t, e, i, a, o);
}
function $15d064020a078dff$var$b(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(r ^ (e | ~n), t, e, i, a, o);
}
function $15d064020a078dff$var$y(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$15d064020a078dff$var$d(n, $15d064020a078dff$var$w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($15d064020a078dff$var$d(n, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * r, $15d064020a078dff$var$d(n, i), n;
}
function $15d064020a078dff$var$w(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
$15d064020a078dff$var$u = $15d064020a078dff$var$n.atob.bind($15d064020a078dff$var$n), $15d064020a078dff$var$h = $15d064020a078dff$var$n.btoa.bind($15d064020a078dff$var$n);
var $15d064020a078dff$var$N = "0123456789abcdef".split("");
function $15d064020a078dff$var$L(t) {
    for(var e = "", r = 0; r < 4; r++)e += $15d064020a078dff$var$N[t >> 8 * r + 4 & 15] + $15d064020a078dff$var$N[t >> 8 * r & 15];
    return e;
}
function $15d064020a078dff$var$A(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $15d064020a078dff$var$x(t) {
    return $15d064020a078dff$var$y(t).map($15d064020a078dff$var$A).join("");
}
var $15d064020a078dff$var$S = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $15d064020a078dff$var$L(t[e]);
    return t.join("");
}($15d064020a078dff$var$y("hello"));
function $15d064020a078dff$var$_(t, e) {
    if ($15d064020a078dff$var$S) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $15d064020a078dff$var$P(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for(var o = (i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(i)), s = [], c = 0; c < 256; c++)s[c] = c;
        var u = 0;
        for(c = 0; c < 256; c++){
            var h = s[c];
            u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
        }
        r = t, n = s;
    } else s = n;
    var l = e.length, f = 0, d = 0, p = "";
    for(c = 0; c < l; c++)d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $15d064020a078dff$var$k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $15d064020a078dff$var$I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $15d064020a078dff$var$k.perm) throw new Error("Invalid permission: " + t);
        i += $15d064020a078dff$var$k[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $15d064020a078dff$var$x(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = $15d064020a078dff$var$P(this.encryptionKey, this.padding);
}
function $15d064020a078dff$var$F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var i = t.charCodeAt(n);
        if (i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126) e += "#" + ("0" + i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function $15d064020a078dff$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var i = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[t]){
                var c = r[t][s];
                try {
                    c[0].apply(e, i);
                } catch (t) {
                    $15d064020a078dff$var$n.console && $15d064020a078dff$var$a.error("jsPDF PubSub Error", t.message, t);
                }
                c[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $15d064020a078dff$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $15d064020a078dff$export$1bc649ab427a02ba)) return new $15d064020a078dff$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function $15d064020a078dff$var$O(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $15d064020a078dff$export$7235f0ad083cb4c6(t, e, r, n, i) {
    if (!(this instanceof $15d064020a078dff$export$7235f0ad083cb4c6)) return new $15d064020a078dff$export$7235f0ad083cb4c6(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, $15d064020a078dff$var$O.call(this, n, i);
}
function $15d064020a078dff$export$549f717800d2b57f(t, e, r, n, i) {
    if (!(this instanceof $15d064020a078dff$export$549f717800d2b57f)) return new $15d064020a078dff$export$549f717800d2b57f(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, $15d064020a078dff$var$O.call(this, n, i);
}
function $15d064020a078dff$export$2e2bcd8739ae039(e) {
    var r, i = "string" == typeof arguments[0] ? arguments[0] : "p", o = arguments[1], s = arguments[2], c = arguments[3], u = [], d = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e = e || {}) && (i = e.orientation, o = e.unit || o, s = e.format || s, c = e.compress || e.compressPdf || c, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), u = e.filters || (!0 === c ? [
        "FlateEncode"
    ] : u), o = o || "mm", i = ("" + (i || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $15d064020a078dff$var$C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var A = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, S = x.COMPAT;
    function _() {
        this.saveGraphicsState(), lt(new Vt(_t, 0, 0, -_t, 0, Rr() * _t).toString() + " cm"), this.setFontSize(this.getFontSize() / _t), g = "n", S = x.ADVANCED;
    }
    function P() {
        this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    }
    var k = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = S === x.COMPAT;
        return e && _.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = S === x.ADVANCED;
        return e && P.call(this), "function" != typeof t || (t(this), e && _.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return S === x.ADVANCED;
    };
    var O, q = function(t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    O = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var R = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, T = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _t : S === x.ADVANCED ? t : void 0;
    }, z = function(t) {
        return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
    }, H = function(t) {
        return U(z(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new $15d064020a078dff$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), r = e < 0 ? "+" : "-", n = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            r,
            Q(n),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ct = nt, ut = function() {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt();
    };
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ct = t;
    };
    var ht = function(t) {
        st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ct = nt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
    }, ft = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, dt = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;)n[e] = t.charCodeAt(e);
        return r;
    }, pt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return pt;
    };
    var gt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return gt = S === x.ADVANCED ? t / _t : t, this;
    };
    var mt, vt = y.__private__.getFontSize = y.getFontSize = function() {
        return S === x.COMPAT ? gt : gt * _t;
    }, bt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return bt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return bt;
    };
    var yt, wt = y.__private__.setZoomMode = function(t) {
        var e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
        else if (isNaN(t)) {
            if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            mt = t;
        } else mt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return mt;
    };
    var Nt, Lt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
    };
    y.__private__.getPageMode = function() {
        return yt;
    };
    var At = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        Nt = t;
    };
    y.__private__.getLayoutMode = function() {
        return Nt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, r) {
        return wt(t), At(e), Lt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var St, _t, Pt, kt, It, Ft = {}, Ct = {}, jt = [], Ot = {}, Bt = {}, Mt = {}, Et = {}, qt = null, Dt = 0, Rt = [], Tt = new $15d064020a078dff$var$C(y), Ut = e.hotfixes || [], zt = {}, Ht = {}, Wt = [], Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Vt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(O).join(t);
    }, Vt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Vt(e, r, n, i, a, o);
    }, Vt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * r + (e /= o) * n;
        r -= t * s, n -= e * s;
        var c = Math.sqrt(r * r + n * n);
        return s /= c, t * (n /= c) < e * (r /= c) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Vt(o, 0, 0, c, 0, 0),
            translate: new Vt(1, 0, 0, 1, i, a),
            rotate: new Vt(t, e, -e, t, 0, 0),
            skew: new Vt(1, 0, s, 1, 0, 0)
        };
    }, Vt.prototype.toString = function(t) {
        return this.join(" ");
    }, Vt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = 1 / (t * n - e * r), s = n * o, c = -e * o, u = -r * o, h = t * o;
        return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
    }, Vt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new Cr(e, r);
    }, Vt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
        return new jr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Vt.prototype.clone = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty;
        return new Vt(t, e, r, n, i, a);
    }, y.Matrix = Vt;
    var Gt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function(t, e) {
        if (!Bt[t]) {
            var r = (e instanceof $15d064020a078dff$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
            e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $15d064020a078dff$export$7235f0ad083cb4c6, y.TilingPattern = $15d064020a078dff$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return q("addShadingPattern()"), Jt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        q("beginTilingPattern()"), Br(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
            if (5 === e.length && ("k" === e[4] || "K" === e[4])) e = [
                (1 - e[0]) * (1 - e[3]),
                (1 - e[1]) * (1 - e[3]),
                (1 - e[2]) * (1 - e[3]),
                "r"
            ];
        } else {
            var r = parseFloat(e[0]);
            e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", i = 0; i < 3; i++)n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
    }, re = y.__private__.encodeColorString = function(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var c = new $15d064020a078dff$var$f(n);
            if (c.ok) n = c.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) {
            if ("string" == typeof n) r = n + " " + s[0];
            else switch(e.precision){
                case 2:
                    r = R(n / 255) + " " + s[0];
                    break;
                case 3:
                default:
                    r = T(n / 255) + " " + s[0];
            }
        } else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return r = [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            if ("string" == typeof n) r = [
                n,
                i,
                a,
                s[1]
            ].join(" ");
            else switch(e.precision){
                case 2:
                    r = [
                        R(n / 255),
                        R(i / 255),
                        R(a / 255),
                        s[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    r = [
                        T(n / 255),
                        T(i / 255),
                        T(a / 255),
                        s[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) r = [
            n,
            i,
            a,
            o,
            s[2]
        ].join(" ");
        else switch(e.precision){
            case 2:
                r = [
                    R(n),
                    R(i),
                    R(a),
                    R(o),
                    s[2]
                ].join(" ");
                break;
            case 3:
            default:
                r = [
                    T(n),
                    T(i),
                    T(a),
                    T(o),
                    s[2]
                ].join(" ");
        }
        return r;
    }, ne = y.__private__.getFilters = function() {
        return u;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var u = t.additionalKeyValues || [], h = (c = void 0 !== $15d064020a078dff$export$2e2bcd8739ae039.API.processDataByFilters ? $15d064020a078dff$export$2e2bcd8739ae039.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
            key: "Length",
            value: c.data.length
        }), !0 === i && u.push({
            key: "Length1",
            value: a
        })), 0 != h.length) {
            if (h.split("/").length - 1 == 1) u.push({
                key: "Filter",
                value: h
            });
            else {
                u.push({
                    key: "Filter",
                    value: "[" + h + "]"
                });
                for(var l = 0; l < u.length; l += 1)if ("DecodeParms" === u[l].key) {
                    for(var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < u.length; p++)lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, r = t.data, n = t.objId, i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(O(t.mediaBox.bottomLeftX)) + " " + parseFloat(O(t.mediaBox.bottomLeftY)) + " " + O(t.mediaBox.topRightX) + " " + O(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + O(t.cropBox.bottomLeftX) + " " + O(t.cropBox.bottomLeftY) + " " + O(t.cropBox.topRightX) + " " + O(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + O(t.bleedBox.bottomLeftX) + " " + O(t.bleedBox.bottomLeftY) + " " + O(t.bleedBox.topRightX) + " " + O(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + O(t.trimBox.bottomLeftX) + " " + O(t.trimBox.bottomLeftY) + " " + O(t.trimBox.topRightX) + " " + O(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + O(t.artBox.bottomLeftX) + " " + O(t.artBox.bottomLeftY) + " " + O(t.artBox.topRightX) + " " + O(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
            objId: n,
            pageContext: Rt[e],
            pageNumber: e,
            page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: ne(),
            objectId: i
        }), lt("endobj"), n;
    }, oe = y.__private__.putPages = function() {
        var t, e, r = [];
        for(t = 1; t <= Dt; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Dt; t++)r.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(e = 0; e < Dt; e++)n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
    }, se = function(t) {
        Tt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $15d064020a078dff$var$F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ce = function() {
        for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                O(t.x),
                O(t.y),
                O(t.x + t.width),
                O(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function() {
        for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
    }, le = function(t, e) {
        var r, n = [], i = 1 / (e - 1);
        for(r = 0; r < 1; r += i)n.push(r);
        if (n.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", c = 0, u = 0; u < n.length; u++){
            for(r = n[u]; r > t[c + 1].offset;)c++;
            var h = t[c].offset, l = (r - h) / (t[c + 1].offset - h), f = t[c].color, d = t[c + 1].color;
            s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, fe = function(t, e) {
        e || (e = 21);
        var r = Xt(), n = le(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + O(parseFloat(t.coords[0])) + " " + O(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) : a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) + " " + O(parseFloat(t.coords[4])) + " " + O(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, de = function(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(O).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: O(t.xStep)
        }), i.push({
            key: "YStep",
            value: O(t.yStep)
        }), i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, pe = function(t) {
        var e;
        for(e in Ot)Ot.hasOwnProperty(e) && (Ot[e] instanceof $15d064020a078dff$export$7235f0ad083cb4c6 ? fe(Ot[e]) : Ot[e] instanceof $15d064020a078dff$export$549f717800d2b57f && de(Ot[e], t));
    }, ge = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + R(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + R(t[e]));
        }
        lt(">>"), lt("endobj");
    }, me = function() {
        var t;
        for(t in Mt)Mt.hasOwnProperty(t) && ge(Mt[t]);
    }, ve = function() {
        for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
    }, be = function() {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
    }, ye = function() {
        for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
        lt(">>");
    }, we = function() {
        if (Object.keys(Ot).length > 0) {
            for(var t in lt("/Shading <<"), Ot)Ot.hasOwnProperty(t) && Ot[t] instanceof $15d064020a078dff$export$7235f0ad083cb4c6 && Ot[t].objectNumber >= 0 && lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
            Tt.publish("putShadingPatternDict"), lt(">>");
        }
    }, Ne = function(t) {
        if (Object.keys(Ot).length > 0) {
            for(var e in lt("/Pattern <<"), Ot)Ot.hasOwnProperty(e) && Ot[e] instanceof y.TilingPattern && Ot[e].objectNumber >= 0 && Ot[e].objectNumber < t && lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
            Tt.publish("putTilingPatternDict"), lt(">>");
        }
    }, Le = function() {
        if (Object.keys(Mt).length > 0) {
            var t;
            for(t in lt("/ExtGState <<"), Mt)Mt.hasOwnProperty(t) && Mt[t].objectNumber >= 0 && lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
            Tt.publish("putGStateDict"), lt(">>");
        }
    }, Ae = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
    }, xe = function() {
        var t = [];
        ce(), me(), he(), pe(t), Tt.publish("putResources"), t.forEach(Ae), Ae({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
    }, Se = function() {
        Tt.publish("putAdditionalObjects");
        for(var t = 0; t < at.length; t++){
            var e = at[t];
            Zt(e.objId, !0), lt(e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
    }, _e = function(t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
    }, Pe = function(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Tt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, _e(a), a.id;
    }, ke = function(t) {
        for(var e = 0, r = pt.length; e < r; e++){
            var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
            !1 === v && (b[n] = !0);
            var i = t[e][0].split("-");
            _e({
                id: n,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Tt.publish("addFonts", {
            fonts: Ft,
            dictionary: Ct
        });
    }, Ie = function(t) {
        return t.foo = function() {
            try {
                return t.apply(this, arguments);
            } catch (t) {
                var e = t.stack || "";
                ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                var r = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                if (!$15d064020a078dff$var$n.console) throw new Error(r);
                $15d064020a078dff$var$n.console.error(r, t), $15d064020a078dff$var$n.alert && alert(r);
            }
        }, t.foo.bar = t, t.foo;
    }, Fe = function(t, e) {
        var r, n, i, a, o, s, c, u, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[St].metadata && Ft[St].metadata[i] && Ft[St].metadata[i].encoding && (a = Ft[St].metadata[i].encoding, !o && Ft[St].encoding && (o = Ft[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(c = !1, s = [], r = 0, n = t.length; r < n; r++)(u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
            t = s.join("");
        }
        for(r = t.length; void 0 === c && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], r = 0, n = t.length; r < n; r++){
            if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, Ce = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return Fe(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = y.__private__.beginPage = function(t) {
        ot[++Dt] = [], Rt[Dt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(d),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Me(Dt), ht(ot[$]);
    }, Oe = function(t, e) {
        var r, n, o;
        switch(i = e || i, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _t, o = t[1] * _t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && ($15d064020a078dff$var$a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [
            n,
            o
        ], i.substr(0, 1)){
            case "l":
                o > n && (s = [
                    o,
                    n
                ]);
                break;
            case "p":
                n > o && (s = [
                    o,
                    n
                ]);
        }
        je(s), pr(fr), lt(Lr), 0 !== kr && lt(kr + " J"), 0 !== Ir && lt(Ir + " j"), Tt.publish("addPage", {
            pageNumber: Dt
        });
    }, Be = function(t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
    }, Me = function(t) {
        t > 0 && t <= Dt && ($ = t);
    }, Ee = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, qe = function(t, e, r) {
        var n, i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[St].fontName, e = void 0 !== e ? e : Ft[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? i = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? i = Ct[t][e] : !1 === r.disableWarning && $15d064020a078dff$var$a.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || r.noFallback || null == (i = Ct.times[e]) && (i = Ct.times.normal), i;
    }, De = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var r in null !== m && (e = Ye.encryptor(t, 0)), lt("<<"), lt("/Producer (" + Ce(e("jsPDF " + $15d064020a078dff$export$2e2bcd8739ae039.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
    }, Re = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), mt || (mt = "fullwidth"), mt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + mt;
                "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch(Nt || (Nt = "continuous"), Nt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Te = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Ue = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, ze = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, He = y.__private__.buildDocument = function() {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var t = it;
        return ze(), Te(), lt("startxref"), lt("" + t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
    }, We = y.__private__.getBlob = function(t) {
        return new Blob([
            dt(t)
        ], {
            type: "application/pdf"
        });
    }, Ve = y.output = y.__private__.output = Ie(function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return He();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return dt(He());
            case "blob":
                return We(He());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $15d064020a078dff$var$n.URL && "function" == typeof $15d064020a078dff$var$n.URL.createObjectURL) return $15d064020a078dff$var$n.URL && $15d064020a078dff$var$n.URL.createObjectURL(We(He())) || void 0;
                $15d064020a078dff$var$a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", i = He();
                try {
                    r = $15d064020a078dff$var$h(i);
                } catch (t) {
                    r = $15d064020a078dff$var$h(unescape(encodeURIComponent(i)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
                    var o = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (o = e.pdfObjectUrl, s = "");
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + o + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", u = $15d064020a078dff$var$n.open();
                    return null !== u && u.document.write(c), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', f = $15d064020a078dff$var$n.open();
                    if (null !== f) {
                        f.document.write(l);
                        var d = this;
                        f.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            f.document.title = e.filename, f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));
                        };
                    }
                    return f;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($15d064020a078dff$var$n)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $15d064020a078dff$var$n.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $15d064020a078dff$var$n.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }), Ge = function(t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
    };
    switch(o){
        case "pt":
            _t = 1;
            break;
        case "mm":
            _t = 72 / 25.4;
            break;
        case "cm":
            _t = 72 / 2.54;
            break;
        case "in":
            _t = 72;
            break;
        case "px":
            _t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _t = 12;
            break;
        case "ex":
            _t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function(t) {
        return null !== m ? Ye.encryptor(t, 0) : function(t) {
            return t;
        };
    }, Xe = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Ke = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Xe(e);
    }, Ze = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return Oe.apply(this, arguments), this;
    }, y.setPage = function() {
        return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return Be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
            flags: f,
            angle: c,
            align: u
        })) : (q("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v = "", y = !1, w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
        }
        function A(t) {
            for(var e, r = t.concat(), n = [], i = r.length; i--;)"string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([
                e[0],
                e[1],
                e[2]
            ]);
            return n;
        }
        function _(t, e) {
            var r;
            if ("string" == typeof t) r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var n, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                r = o;
            }
            return r;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var I = e.concat();
            s = [];
            for(var F, C = I.length; C--;)("string" != typeof (F = I.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var j = gt / g.internal.scaleFactor, B = j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= B;
                break;
            case "top":
                n += j - B;
                break;
            case "hanging":
                n += j - 2 * B;
                break;
            case "middle":
                n += j / 2 - B;
        }
        if ((l = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, l) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, l));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("preProcessText", o), e = o.text, c = (i = o.options).angle, p instanceof Vt == !1 && c && "number" == typeof c) {
            c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
            var M = Math.cos(c), E = Math.sin(c);
            p = new Vt(M, E, -E, M, 0, 0);
        } else c && c instanceof Vt && (p = c);
        S !== x.ADVANCED || p || (p = Yt), void 0 !== (h = i.charSpace || _r) && (v += O(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (v += O(100 * d) + " Tz\n"), i.lang;
        var D = -1, R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                D = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                D = 1;
                break;
            case 2:
            case "fillThenStroke":
                D = 2;
                break;
            case 3:
            case "invisible":
                D = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                D = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                D = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                D = 6;
                break;
            case 7:
            case "addToPathForClipping":
                D = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== D ? v += D + " Tr\n" : -1 !== z && (v += "0 Tr\n"), -1 !== D && (T.usedRenderingMode = D), u = i.align || "left";
        var H, W = gt * w, V = g.internal.pageSize.getWidth(), G = Ft[St];
        h = i.charSpace || _r, l = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: h,
                fontSize: gt,
                doKerning: !1
            }) * gt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = A(e), "left" !== u && (H = s.map(J));
            var K, Z = 0;
            if ("right" === u) {
                r -= H[0], e = [], C = s.length;
                for(var $ = 0; $ < C; $++)0 === $ ? (K = br(r), X = yr(n)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === u) {
                r -= H[0] / 2, e = [], C = s.length;
                for(var Q = 0; Q < C; Q++)0 === Q ? (K = br(r), X = yr(n)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === u) {
                e = [], C = s.length;
                for(var tt = 0; tt < C; tt++)e.push(s[tt]);
            } else if ("justify" === u && "Identity-H" === G.encoding) {
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(var et = 0, rt = 0; rt < C; rt++)if (X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : et, rt < C - 1) {
                    var nt = U((l - H[rt]) / (s[rt].split(" ").length - 1)), it = s[rt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + nt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[rt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(rt = 0; rt < C; rt++)X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : 0, rt < C - 1 ? Y.push(O(U((l - H[rt]) / (s[rt].split(" ").length - 1)))) : Y.push(0), e.push([
                    s[rt],
                    K,
                    X
                ]);
            }
        }
        var st = "boolean" == typeof i.R2L ? i.R2L : bt;
        !0 === st && (e = _(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("postProcessText", o), e = o.text, y = o.mutex.isHex || !1;
        var ct = Ft[St].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = _(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = A(e), e = [];
        for(var ut, ht, ft, dt = 0, pt = 1, mt = Array.isArray(s[0]) ? pt : dt, vt = "", yt = function(t, e, r) {
            var n = "";
            return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = O(t) + " " + O(e) + " Td\n", n;
        }, wt = 0; wt < s.length; wt++){
            switch(vt = "", mt){
                case pt:
                    ft = (y ? "<" : "(") + s[wt][0] + (y ? ">" : ")"), ut = parseFloat(s[wt][1]), ht = parseFloat(s[wt][2]);
                    break;
                case dt:
                    ft = (y ? "<" : "(") + s[wt] + (y ? ">" : ")"), ut = br(r), ht = yr(n);
            }
            void 0 !== Y && void 0 !== Y[wt] && (vt = Y[wt] + " Tw\n"), 0 === wt ? e.push(vt + yt(ut, ht, p) + ft) : mt === dt ? e.push(vt + ft) : mt === pt && e.push(vt + yt(ut, ht, p) + ft);
        }
        e = mt === dt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var Nt = "BT\n/";
        return Nt += St + " " + gt + " Tf\n", Nt += O(gt * w) + " TL\n", Nt += xr + "\n", Nt += v, Nt += e, lt(Nt += "ET"), b[St] = !0, g;
    };
    var $e = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return $e("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var Qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return Qe(t) && (g = t), this;
    };
    var tr = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, er = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return rr("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return rr("f*", t), this;
    }, y.fillStroke = function(t) {
        return rr("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return rr("B*", t), this;
    };
    var rr = function(e, r) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) ? ar(r, e) : lt(e);
    }, nr = function(t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
    };
    function ir(t, e, r, n, i) {
        var a = new $15d064020a078dff$export$549f717800d2b57f(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    }
    var ar = function(t, e) {
        var r = Bt[t.key], n = Ot[r];
        if (n instanceof $15d064020a078dff$export$7235f0ad083cb4c6) lt("q"), lt(or(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof $15d064020a078dff$export$549f717800d2b57f) {
            var i = new Vt(1, 0, 0, -1, 0, Rr());
            t.matrix && (i = i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
    }, or = function(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, sr = y.moveTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
    }, cr = y.lineTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
    }, ur = y.curveTo = function(t, e, r, n, i, a) {
        return lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(H(n)),
            O(U(i)),
            O(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return S === x.COMPAT ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++)2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
        return a && er(), nr(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var r = t[e], n = r.c;
            switch(r.op){
                case "m":
                    sr(n[0], n[1]);
                    break;
                case "l":
                    cr(n[0], n[1]);
                    break;
                case "c":
                    ur.apply(this, n);
                    break;
                case "h":
                    er();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return S === x.COMPAT && (n = -n), lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(U(n)),
            "re"
        ].join(" ")), nr(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, y.__private__.circle = y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, y.setFont = function(t, e, r) {
        return r && (e = k(e, r)), St = qe(t, e, {
            disableWarning: !1
        }), this;
    };
    var hr = y.__private__.getFont = y.getFont = function() {
        return Ft[qe.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, r = {};
        for(t in Ct)if (Ct.hasOwnProperty(t)) for(e in r[t] = [], Ct[t])Ct[t].hasOwnProperty(e) && r[t].push(e);
        return r;
    }, y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = k(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr, fr = e.lineWidth || .200025, dr = y.__private__.getLineWidth = y.getLineWidth = function() {
        return fr;
    }, pr = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return fr = t, lt(O(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $15d064020a078dff$export$2e2bcd8739ae039.API.setLineDash = $15d064020a078dff$export$2e2bcd8739ae039.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return O(U(t));
        }).join(" "), e = O(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var gr = y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    var mr = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
    }, vr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return lr;
    };
    mr(e.lineHeight);
    var br = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, yr = y.__private__.getVerticalCoordinate = function(t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, wr = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return O(br(t));
    }, Nr = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return O(yr(t));
    }, Lr = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(Lr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, r, n) {
        return Lr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(Lr), this;
    };
    var Ar = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(Ar);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, r, n) {
        return Ar = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(Ar), this;
    };
    var xr = e.textColor || "0 g", Sr = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(xr);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, r, n) {
        return xr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var _r = e.charSpace, Pr = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(_r || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return _r = t, this;
    };
    var kr = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return kr = e, lt(e + " J"), this;
    };
    var Ir = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Ir = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(O(U(t)) + " M"), this;
    }, y.GState = $15d064020a078dff$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function(t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for(var n in Mt)if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Mt[n];
            else {
                var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                Mt[i] = e, e.id = i;
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return Fr(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: St,
            size: gt,
            color: xr
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return St = t.key, gt = t.size, xr = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var Cr = function(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, jr = function(t, e, r, n) {
        Cr.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, Or = function() {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = It, this.width = qr($), this.height = Rr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
    };
    Or.prototype.restore = function() {
        Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, It = this.matrix, Dr($, this.width), Tr($, this.height), ct = this.outputDestination;
    };
    var Br = function(t, e, r, n, i) {
        Wt.push(new Or), Dt = $ = 0, ot = [], Pt = t, kt = e, It = i, je([
            r,
            n
        ]);
    }, Mr = function(t) {
        if (Ht[t]) Wt.pop().restore();
        else {
            var e = new Or, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
            e.id = r, Ht[t] = r, zt[r] = e, Tt.publish("addFormObject", e), Wt.pop().restore();
        }
    };
    for(var Er in y.beginFormObject = function(t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }, y.endFormObject = function(t) {
        return Mr(t), this;
    }, y.doFormObject = function(t, e) {
        var r = zt[Ht[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ht[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($15d064020a078dff$var$l(We(He()), t), "function" == typeof $15d064020a078dff$var$l.unload && $15d064020a078dff$var$n.setTimeout && setTimeout($15d064020a078dff$var$l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var i = $15d064020a078dff$var$l(We(He()), t);
                "function" == typeof $15d064020a078dff$var$l.unload && $15d064020a078dff$var$n.setTimeout && setTimeout($15d064020a078dff$var$l.unload, 911), e(i);
            } catch (t) {
                r(t.message);
            }
        });
    }, $15d064020a078dff$export$2e2bcd8739ae039.API)$15d064020a078dff$export$2e2bcd8739ae039.API.hasOwnProperty(Er) && ("events" === Er && $15d064020a078dff$export$2e2bcd8739ae039.API.events.length ? function(t, e) {
        var r, n, i;
        for(i = e.length - 1; -1 !== i; i--)r = e[i][0], n = e[i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Tt, $15d064020a078dff$export$2e2bcd8739ae039.API.events) : y[Er] = $15d064020a078dff$export$2e2bcd8739ae039.API[Er]);
    var qr = y.getPageWidth = function(t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _t;
    }, Dr = y.setPageWidth = function(t, e) {
        Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
    }, Rr = y.getPageHeight = function(t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _t;
    }, Tr = y.setPageHeight = function(t, e) {
        Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
    };
    return y.internal = {
        pdfEscape: Ce,
        getStyle: tr,
        getFont: hr,
        getFontSize: vt,
        getCharSpace: Pr,
        getTextColor: Sr,
        getLineHeight: gr,
        getLineHeightFactor: vr,
        getLineWidth: dr,
        write: ft,
        getHorizontalCoordinate: br,
        getVerticalCoordinate: yr,
        getCoordinateString: wr,
        getVerticalCoordinateString: Nr,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Tt,
        scaleFactor: _t,
        pageSize: {
            getWidth: function() {
                return qr($);
            },
            setWidth: function(t) {
                Dr($, t);
            },
            getHeight: function() {
                return Rr($);
            },
            setHeight: function(t) {
                Tr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Ye,
        getEncryptor: Je,
        output: Ve,
        getNumberOfPages: Ee,
        pages: ot,
        out: lt,
        f2: R,
        f3: T,
        getPageInfo: Xe,
        getPageInfoByObjId: Ke,
        getCurrentPageInfo: Ze,
        getPDFVersion: N,
        Point: Cr,
        Rectangle: jr,
        Matrix: Vt,
        hasHotfix: Ge
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return qr($);
        },
        set: function(t) {
            Dr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return Rr($);
        },
        set: function(t) {
            Tr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), ke.call(y, pt), St = "F1", Oe(s, i), Tt.publish("initialized"), y;
}
$15d064020a078dff$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $15d064020a078dff$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $15d064020a078dff$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, $15d064020a078dff$var$I.prototype.processOwnerPassword = function(t, e) {
    return $15d064020a078dff$var$P($15d064020a078dff$var$x(e).substr(0, 5), t);
}, $15d064020a078dff$var$I.prototype.encryptor = function(t, e) {
    var r = $15d064020a078dff$var$x(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $15d064020a078dff$var$P(r, t);
    };
}, $15d064020a078dff$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(this)) return !1;
    var i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
}, $15d064020a078dff$export$2e2bcd8739ae039.API = {
    events: []
}, $15d064020a078dff$export$2e2bcd8739ae039.version = "3.0.1";
var $15d064020a078dff$var$q = $15d064020a078dff$export$2e2bcd8739ae039.API, $15d064020a078dff$var$D = 1, $15d064020a078dff$var$R = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $15d064020a078dff$var$T = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $15d064020a078dff$var$U = function(t) {
    return t.toFixed(2);
}, $15d064020a078dff$var$z = function(t) {
    return t.toFixed(5);
};
$15d064020a078dff$var$q.__acroform__ = {};
var $15d064020a078dff$var$H = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $15d064020a078dff$var$W = function(t) {
    return t * $15d064020a078dff$var$D;
}, $15d064020a078dff$var$V = function(t) {
    var e = new $15d064020a078dff$var$ut, r = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) || 0, n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($15d064020a078dff$var$U(n)),
        Number($15d064020a078dff$var$U(r))
    ], e;
}, $15d064020a078dff$var$G = $15d064020a078dff$var$q.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, $15d064020a078dff$var$Y = $15d064020a078dff$var$q.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, $15d064020a078dff$var$J = $15d064020a078dff$var$q.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, $15d064020a078dff$var$X = $15d064020a078dff$var$q.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $15d064020a078dff$var$J(t, e - 1);
}, $15d064020a078dff$var$K = $15d064020a078dff$var$q.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $15d064020a078dff$var$G(t, e - 1);
}, $15d064020a078dff$var$Z = $15d064020a078dff$var$q.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $15d064020a078dff$var$Y(t, e - 1);
}, $15d064020a078dff$var$$ = $15d064020a078dff$var$q.__acroform__.calculateCoordinates = function(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], c = {};
    return c.lowerLeft_X = r(i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(i + o) || 0, c.upperRight_Y = n(a) || 0, [
        Number($15d064020a078dff$var$U(c.lowerLeft_X)),
        Number($15d064020a078dff$var$U(c.lowerLeft_Y)),
        Number($15d064020a078dff$var$U(c.upperRight_X)),
        Number($15d064020a078dff$var$U(c.upperRight_Y))
    ];
}, $15d064020a078dff$var$Q = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = $15d064020a078dff$var$tt(t, r), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $15d064020a078dff$var$U(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $15d064020a078dff$var$V(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $15d064020a078dff$var$tt = function(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var c = function(e, r, n) {
        if (e + 1 < i.length) {
            var a = r + " " + i[e + 1][0];
            return $15d064020a078dff$var$et(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var u, h, l = $15d064020a078dff$var$et("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $15d064020a078dff$var$et(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((l + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = c(N, v, a), A = y >= i.length - 1;
                if (L && !A) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || A) {
                    if (A) g = N;
                    else if (t.multiline && (l + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((l + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var x = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        x += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        x += _[_.length - 1] + " ";
                        continue;
                    }
                }
                x += _[0] + " ";
            }
            switch(x = " " == x.substr(x.length - 1) ? x.substr(0, x.length - 1) : x, h = $15d064020a078dff$var$et(x, t, a).width, t.textAlign){
                case "right":
                    u = s - h - 2;
                    break;
                case "center":
                    u = (s - h) / 2;
                    break;
                case "left":
                default:
                    u = 2;
            }
            e += $15d064020a078dff$var$U(u) + " " + $15d064020a078dff$var$U(d) + " Td\n", e += "(" + $15d064020a078dff$var$R(x) + ") Tj\n", e += -$15d064020a078dff$var$U(u) + " 0 Td\n", d = -(a + 2), h = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, $15d064020a078dff$var$et = function(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
    };
}, $15d064020a078dff$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $15d064020a078dff$var$nt = function(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, $15d064020a078dff$var$it = function(e, r) {
    for(var n in e)if (e.hasOwnProperty(n)) {
        var i = n, a = e[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
    }
}, $15d064020a078dff$var$at = function(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($15d064020a078dff$var$lt.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($15d064020a078dff$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $15d064020a078dff$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $15d064020a078dff$var$ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var r in e)if (e.hasOwnProperty(r)) {
                    var n = e[r];
                    n.objId = void 0, n.hasAnnotation && $15d064020a078dff$var$nt(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $15d064020a078dff$var$$(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $15d064020a078dff$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var c = $15d064020a078dff$var$Q(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + c + ">>"
                        }), r.internal.acroformPlugin.xForms.push(c);
                    }
                    if (a.appearanceStreamContent) {
                        var u = "";
                        for(var h in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(h)) {
                            var l = a.appearanceStreamContent[h];
                            if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                                for(var i in l)if (l.hasOwnProperty(i)) {
                                    var f = l[i];
                                    "function" == typeof f && (f = f.call(r, a)), u += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            u += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + u + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && $15d064020a078dff$var$it(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $15d064020a078dff$var$ot = $15d064020a078dff$var$q.__acroform__.arrayToPdfArray = function(e, r, n) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + $15d064020a078dff$var$R(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var $15d064020a078dff$var$st = function(t, e, r) {
    var n = function(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + $15d064020a078dff$var$R(n(t)) + ")";
}, $15d064020a078dff$var$ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$15d064020a078dff$var$ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, $15d064020a078dff$var$ct.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $15d064020a078dff$var$ct.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], i = this[n];
        i && (Array.isArray(i) ? t.push({
            key: n,
            value: $15d064020a078dff$var$ot(i, this.objId, this.scope)
        }) : i instanceof $15d064020a078dff$var$ct ? (i.scope = this.scope, t.push({
            key: n,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: n,
            value: i
        }));
    }
    return t;
};
var $15d064020a078dff$var$ut = function() {
    $15d064020a078dff$var$ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$ut, $15d064020a078dff$var$ct);
var $15d064020a078dff$var$ht = function() {
    $15d064020a078dff$var$ct.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $15d064020a078dff$var$R(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$ht, $15d064020a078dff$var$ct);
var $15d064020a078dff$var$lt = function t() {
    $15d064020a078dff$var$ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $15d064020a078dff$var$K(e, 3) : this.F = $15d064020a078dff$var$Z(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $15d064020a078dff$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $15d064020a078dff$var$R(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return c;
        },
        set: function(t) {
            c = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === u ? 50 / $15d064020a078dff$var$D : u;
        },
        set: function(t) {
            u = t;
        }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return h;
        },
        set: function(t) {
            h = t;
        }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!l || this instanceof $15d064020a078dff$var$yt || this instanceof $15d064020a078dff$export$9d1b52e7fab50c84)) return $15d064020a078dff$var$st(l, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), l = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? $15d064020a078dff$var$st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $15d064020a078dff$var$T(t.substr(1, t.length - 2)) : $15d064020a078dff$var$T(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? $15d064020a078dff$var$T(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? $15d064020a078dff$var$st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $15d064020a078dff$var$T(t.substr(1, t.length - 2)) : $15d064020a078dff$var$T(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? $15d064020a078dff$var$T(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 1) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 2) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 3) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                case "left":
                case 0:
                default:
                    m = 0;
            }
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$lt, $15d064020a078dff$var$ct);
var $15d064020a078dff$export$a47202eb3f827bb2 = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $15d064020a078dff$var$ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, i = []; n = e.exec(t);)i.push(n[r]);
                return i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 18) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 19) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $15d064020a078dff$var$K(this.Ff, 20), e.sort()) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 22) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 23) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 27) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$15d064020a078dff$var$H($15d064020a078dff$export$a47202eb3f827bb2, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$9e021dd9568dc486 = function() {
    $15d064020a078dff$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$15d064020a078dff$var$H($15d064020a078dff$export$9e021dd9568dc486, $15d064020a078dff$export$a47202eb3f827bb2);
var $15d064020a078dff$export$f2239d28df5f43bd = function() {
    $15d064020a078dff$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$f2239d28df5f43bd, $15d064020a078dff$export$9e021dd9568dc486);
var $15d064020a078dff$export$4af052e7e598ad1a = function() {
    $15d064020a078dff$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$4af052e7e598ad1a, $15d064020a078dff$export$f2239d28df5f43bd);
var $15d064020a078dff$export$6aae594af76bbb7b = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 15) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 16) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 17) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 26) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + $15d064020a078dff$var$R(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$6aae594af76bbb7b, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$98b7c3ef37465410 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$98b7c3ef37465410, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$export$bc1318bc7e5f1315 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$bc1318bc7e5f1315, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$var$yt = function() {
    var e, r;
    $15d064020a078dff$var$lt.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    });
    var n, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), i)r.push("/" + e + " (" + $15d064020a078dff$var$R(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$15d064020a078dff$var$H($15d064020a078dff$var$yt, $15d064020a078dff$var$lt), $15d064020a078dff$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, $15d064020a078dff$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $15d064020a078dff$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $15d064020a078dff$var$xt.call(this.scope, e), e;
};
var $15d064020a078dff$export$5fd5db01c4615478 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $15d064020a078dff$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$15d064020a078dff$var$H($15d064020a078dff$export$5fd5db01c4615478, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$export$9d1b52e7fab50c84 = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 13) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 21) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 23) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 24) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 25) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 26) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$9d1b52e7fab50c84, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$c48d8668f8cea64d = function() {
    $15d064020a078dff$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 14) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 14);
        }
    }), this.password = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$c48d8668f8cea64d, $15d064020a078dff$export$9d1b52e7fab50c84);
var $15d064020a078dff$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $15d064020a078dff$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $15d064020a078dff$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $15d064020a078dff$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $15d064020a078dff$var$tt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + $15d064020a078dff$var$U(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = [], a = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t), o = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t), s = $15d064020a078dff$var$tt(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $15d064020a078dff$var$U(o) + " " + $15d064020a078dff$var$U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $15d064020a078dff$var$U(o - 1) + " " + $15d064020a078dff$var$U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + $15d064020a078dff$var$U(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C, a = Number((n * i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((n * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($15d064020a078dff$var$U(n.x1.x) + " " + $15d064020a078dff$var$U(n.x1.y) + " m"), r.push($15d064020a078dff$var$U(n.x2.x) + " " + $15d064020a078dff$var$U(n.x2.y) + " l"), r.push($15d064020a078dff$var$U(n.x4.x) + " " + $15d064020a078dff$var$U(n.x4.y) + " m"), r.push($15d064020a078dff$var$U(n.x3.x) + " " + $15d064020a078dff$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = $15d064020a078dff$export$7d753ad993606f45.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($15d064020a078dff$var$U(r.x1.x) + " " + $15d064020a078dff$var$U(r.x1.y) + " m"), n.push($15d064020a078dff$var$U(r.x2.x) + " " + $15d064020a078dff$var$U(r.x2.y) + " l"), n.push($15d064020a078dff$var$U(r.x4.x) + " " + $15d064020a078dff$var$U(r.x4.y) + " m"), n.push($15d064020a078dff$var$U(r.x3.x) + " " + $15d064020a078dff$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
$15d064020a078dff$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t), r = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, $15d064020a078dff$export$7d753ad993606f45.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = $15d064020a078dff$var$W(e.Rect[2])), r;
}, $15d064020a078dff$export$7d753ad993606f45.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = $15d064020a078dff$var$W(e.Rect[3])), r;
};
var $15d064020a078dff$var$xt = $15d064020a078dff$var$q.addField = function(t) {
    if ($15d064020a078dff$var$at(this, t), !(t instanceof $15d064020a078dff$var$lt)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$15d064020a078dff$var$q.AcroFormChoiceField = $15d064020a078dff$export$a47202eb3f827bb2, $15d064020a078dff$var$q.AcroFormListBox = $15d064020a078dff$export$9e021dd9568dc486, $15d064020a078dff$var$q.AcroFormComboBox = $15d064020a078dff$export$f2239d28df5f43bd, $15d064020a078dff$var$q.AcroFormEditBox = $15d064020a078dff$export$4af052e7e598ad1a, $15d064020a078dff$var$q.AcroFormButton = $15d064020a078dff$export$6aae594af76bbb7b, $15d064020a078dff$var$q.AcroFormPushButton = $15d064020a078dff$export$98b7c3ef37465410, $15d064020a078dff$var$q.AcroFormRadioButton = $15d064020a078dff$export$bc1318bc7e5f1315, $15d064020a078dff$var$q.AcroFormCheckBox = $15d064020a078dff$export$5fd5db01c4615478, $15d064020a078dff$var$q.AcroFormTextField = $15d064020a078dff$export$9d1b52e7fab50c84, $15d064020a078dff$var$q.AcroFormPasswordField = $15d064020a078dff$export$c48d8668f8cea64d, $15d064020a078dff$var$q.AcroFormAppearance = $15d064020a078dff$export$7d753ad993606f45, $15d064020a078dff$var$q.AcroForm = {
    ChoiceField: $15d064020a078dff$export$a47202eb3f827bb2,
    ListBox: $15d064020a078dff$export$9e021dd9568dc486,
    ComboBox: $15d064020a078dff$export$f2239d28df5f43bd,
    EditBox: $15d064020a078dff$export$4af052e7e598ad1a,
    Button: $15d064020a078dff$export$6aae594af76bbb7b,
    PushButton: $15d064020a078dff$export$98b7c3ef37465410,
    RadioButton: $15d064020a078dff$export$bc1318bc7e5f1315,
    CheckBox: $15d064020a078dff$export$5fd5db01c4615478,
    TextField: $15d064020a078dff$export$9d1b52e7fab50c84,
    PasswordField: $15d064020a078dff$export$c48d8668f8cea64d,
    Appearance: $15d064020a078dff$export$7d753ad993606f45
}, $15d064020a078dff$export$2e2bcd8739ae039.AcroForm = {
    ChoiceField: $15d064020a078dff$export$a47202eb3f827bb2,
    ListBox: $15d064020a078dff$export$9e021dd9568dc486,
    ComboBox: $15d064020a078dff$export$f2239d28df5f43bd,
    EditBox: $15d064020a078dff$export$4af052e7e598ad1a,
    Button: $15d064020a078dff$export$6aae594af76bbb7b,
    PushButton: $15d064020a078dff$export$98b7c3ef37465410,
    RadioButton: $15d064020a078dff$export$bc1318bc7e5f1315,
    CheckBox: $15d064020a078dff$export$5fd5db01c4615478,
    TextField: $15d064020a078dff$export$9d1b52e7fab50c84,
    PasswordField: $15d064020a078dff$export$c48d8668f8cea64d,
    Appearance: $15d064020a078dff$export$7d753ad993606f45
};
var $15d064020a078dff$export$9cf40f67b77f45f4 = $15d064020a078dff$export$2e2bcd8739ae039.AcroForm;
function $15d064020a078dff$var$_t(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    e.__addimage__ = {};
    var r = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, i = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var i, a, o, s, c, u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        else for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        return u === r && e !== r && (u = e), u;
    }, a = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
            for(var o = "", s = 0, c = e.transparency.length; s < c; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: u,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width, l = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: e.bitsPerComponent,
                decodeParameters: h,
                data: e.sMask
            };
            "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
            var f = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: f
            }), r("endobj");
        }
    }, o = function() {
        var t = this.internal.collections.addImage_images;
        for(var e in t)a.call(this, t[e]);
    }, s = function() {
        var t, e = this.internal.collections.addImage_images, r = this.internal.write;
        for(var n in e)r("/I" + (t = e[n]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
    }, h = function() {
        var t = this.internal.collections.addImage_images;
        return c.call(this), t;
    }, l = function() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, d = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && 1 === e.nodeType;
    }, p = function(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return $15d064020a078dff$var$u(unescape(n).split("base64,").pop());
            var i = e.loadFile(n, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return $15d064020a078dff$var$u(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function(t) {
        var e = this.internal.collections.addImage_images;
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, m = function(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, v = function(t, e, r, n, i, a) {
        var o = m.call(this, r, n, i), s = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString, u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = e.__addimage__.sHashCode = function(t) {
        var e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, e = 0; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
        else if (x(t)) for(r = t.byteLength / 2, e = 0; e < r; e++)n = (n << 5) - n + t[e], n |= 0;
        return n;
    }, N = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, L = e.__addimage__.extractImageFromDataUrl = function(t) {
        if (null == t) return null;
        if (!(t = t.trim()).startsWith("data:")) return null;
        var e = t.indexOf(",");
        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
    }, A = e.__addimage__.supportsArrayBuffer = function() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = e.__addimage__.isArrayBufferView = function(t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, h, l;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7], l = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e = arguments[0]) && !d(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, h = f.compression || h, l = f.rotation || f.angle || l;
        }
        var p = this.internal.getFilters();
        if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, h);
        return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function(t, n, a, o) {
        var s, c, u;
        if ("string" == typeof t && i(t) === r) {
            t = unescape(t);
            var h = k(t, !1);
            ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
        }
        if (d(t) && (t = p(t, n)), n = i(t, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function(t) {
            return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(t)), (s = g.call(this, a)) || (A() && (t instanceof Uint8Array || "RGBA" === n || (c = t, t = S(t))), s = this["process" + n.toUpperCase()](t, l.call(this), a, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        e = "boolean" != typeof e || e;
        var r, n = "";
        if ("string" == typeof t) {
            var i;
            r = null !== (i = L(t)) && void 0 !== i ? i : t;
            try {
                n = $15d064020a078dff$var$u(r);
            } catch (t) {
                if (e) throw N(r) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return n;
    };
    e.getImageProperties = function(t) {
        var n, a, o = "";
        if (d(t) && (t = p(t)), "string" == typeof t && i(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), a = i(t), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!A() || t instanceof Uint8Array || (t = S(t)), !(n = this["process" + a.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = a, n;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $15d064020a078dff$export$2e2bcd8739ae039.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++)switch((r = c[h]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    u = !0;
            }
            if (0 != u) {
                this.internal.write("/Annots [");
                for(var l = 0; l < c.length; l++){
                    r = c[l];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var y = r.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var c = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * c);
        } else a = o, i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, c = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, n = r, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function(t) {
        var r = 0, n = 0, i = 0, a = "", s = "", c = "", u = (t = t || "").split("\\s+"), h = [];
        for(r = 0; r < u.length; r += 1){
            for(h.push(""), n = 0; n < u[r].length; n += 1)a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (i = f(a, s, c), h[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[r] += a;
            h[r] = l(h[r]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039.API), $15d064020a078dff$export$2e2bcd8739ae039.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, u = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var h = e.maxWidth;
        h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(u.splitTextToSize(e, h));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var l = 0; l < t.length; l++)o < (c = this.getStringUnitWidth(t[l], {
            font: n
        }) * r) && (o = c);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, c = this.internal.__cell__.tableHeaderRow, u = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, u && c && (this.printHeaderRow(t.lineNumber, !0), t.y += c[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, n, u, h, l) {
        if (i.call(this), !u) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], A = (l = l || {}).autoSize || !1, x = !1 !== l.printHeaders, S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12, _ = l.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof l.padding ? l.padding : 3, k = l.headerBackgroundColor || "#c8c8c8", I = l.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = I, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(h) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(h[0])) for(m = h.map(function(t) {
            return t.name;
        }), v = h.map(function(t) {
            return t.prompt || t.name || "";
        }), b = h.map(function(t) {
            return t.align || "left";
        }), f = 0; f < h.length; f += 1)w[h[f].name] = h[f].width * (19.049976 / 25.4);
        else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function() {
            return "left";
        }));
        if (A || Array.isArray(h) && "string" == typeof h[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = u.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (x) {
            var F = {};
            for(f = 0; f < m.length; f += 1)F[m[f]] = {}, F[m[f]].text = v[f], F[m[f]].align = b[f];
            var C = c.call(this, F, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var j = h.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < u.length; f += 1){
            "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
                row: f,
                data: u[f]
            }, this);
            var O = c.call(this, u[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = u[f][m[p]];
                "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var c = function(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var i = t[n];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1){
            r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
            var h = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
        }
        c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API);
var $15d064020a078dff$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $15d064020a078dff$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $15d064020a078dff$var$It = $15d064020a078dff$var$_t($15d064020a078dff$var$kt), $15d064020a078dff$var$Ft = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $15d064020a078dff$var$Ct = $15d064020a078dff$var$_t($15d064020a078dff$var$Ft);
function $15d064020a078dff$var$jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return $15d064020a078dff$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch(t){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
    }(t.weight), i = function(t) {
        return "number" == typeof $15d064020a078dff$var$It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                r,
                n
            ].join(" ")
        }
    };
}
function $15d064020a078dff$var$Ot(t, e, r, n) {
    var i;
    for(i = r; i >= 0 && i < e.length; i += n)if (t[e[i]]) return t[e[i]];
    for(i = r; i >= 0 && i < e.length; i -= n)if (t[e[i]]) return t[e[i]];
}
var $15d064020a078dff$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $15d064020a078dff$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $15d064020a078dff$var$Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $15d064020a078dff$var$qt(t, e, r) {
    for(var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, $15d064020a078dff$var$Bt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $15d064020a078dff$var$jt(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
        o = t[a.family];
        break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + $15d064020a078dff$var$Et(a) + "' and default family '" + n + "'.");
    if (o = function(t, e) {
        if (e[t]) return e[t];
        var r = $15d064020a078dff$var$It[t], n = r <= $15d064020a078dff$var$It.normal ? -1 : 1, i = $15d064020a078dff$var$Ot(e, $15d064020a078dff$var$kt, r, n);
        if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
        return i;
    }(a.stretch, o), o = function(t, e) {
        if (e[t]) return e[t];
        for(var r = $15d064020a078dff$var$Pt[t], n = 0; n < r.length; ++n)if (e[r[n]]) return e[r[n]];
        throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function(t, e) {
        if (e[t]) return e[t];
        if (400 === t && e[500]) return e[500];
        if (500 === t && e[400]) return e[400];
        var r = $15d064020a078dff$var$Ct[t], n = $15d064020a078dff$var$Ot(e, $15d064020a078dff$var$Ft, r, t < 400 ? -1 : 1);
        if (!n) throw new Error("Could not find a matching font-weight for value " + t);
        return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $15d064020a078dff$var$Et(a) + "'.");
    return o;
}
function $15d064020a078dff$var$Dt(t) {
    return t.trimLeft();
}
function $15d064020a078dff$var$Rt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function $15d064020a078dff$var$Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $15d064020a078dff$var$Ut, $15d064020a078dff$var$zt, $15d064020a078dff$var$Ht, $15d064020a078dff$var$Wt = [
    "times"
];


!function(e) {
    var r, n, i, o, s, c, u, h, l, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return l.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), l.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return l;
            },
            set: function(t) {
                t instanceof d && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return l.path;
            },
            set: function(t) {
                l.path = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var h = null;
        function f(t, e) {
            if (null === h) {
                var r = function(t) {
                    var e = [];
                    return Object.keys(t).forEach(function(r) {
                        t[r].forEach(function(t) {
                            var n = null;
                            switch(t){
                                case "bold":
                                    n = {
                                        family: r,
                                        weight: "bold"
                                    };
                                    break;
                                case "italic":
                                    n = {
                                        family: r,
                                        style: "italic"
                                    };
                                    break;
                                case "bolditalic":
                                    n = {
                                        family: r,
                                        weight: "bold",
                                        style: "italic"
                                    };
                                    break;
                                case "":
                                case "normal":
                                    n = {
                                        family: r
                                    };
                            }
                            null !== n && (n.ref = {
                                name: r,
                                style: t
                            }, e.push(n));
                        });
                    }), e;
                }(t.getFontList());
                h = function(t) {
                    for(var e = {}, r = 0; r < t.length; ++r){
                        var n = $15d064020a078dff$var$jt(t[r]), i = n.family, a = n.stretch, o = n.style, s = n.weight;
                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
                    }
                    return e;
                }(r.concat(e));
            }
            return h;
        }
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var r = e[1];
                    e[2];
                    var n = e[3], i = e[4];
                    e[5];
                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, r, n = [], i = t.trim();
                        if ("" === i) return $15d064020a078dff$var$Wt;
                        if (i in $15d064020a078dff$var$Mt) return [
                            $15d064020a078dff$var$Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(r = null, e = (i = $15d064020a078dff$var$Dt(i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = $15d064020a078dff$var$Rt(i.substring(1), e);
                                    break;
                                default:
                                    r = $15d064020a078dff$var$Tt(i);
                            }
                            if (null === r) return $15d064020a078dff$var$Wt;
                            if (n.push(r[0]), "" !== (i = $15d064020a078dff$var$Dt(r[1])) && "," !== i.charAt(0)) return $15d064020a078dff$var$Wt;
                            i = i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var c = $15d064020a078dff$var$qt(f(this.pdf, this.fontFaces), s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }));
                        this.pdf.setFont(c.ref.name, c.ref.style);
                    } else {
                        var u = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
                        for(var h = "", l = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, d = 0; d < s.length; d++){
                            if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d];
                                break;
                            }
                            if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) h = s[d], u = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d], u = "normal";
                                break;
                            }
                        }
                        if ("" === h) {
                            for(var p = 0; p < s.length; p++)if (l[s[p]]) {
                                h = l[s[p]];
                                break;
                            }
                        }
                        h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        A.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function() {
        var e = new c(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            e = new c(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new c(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new c(r, n)), o = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new c(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, o) {
        if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new c(i, o)), u = this.ctx.transform.applyToPoint(new c(t, e)), h = this.ctx.transform.applyToPoint(new c(r, n));
        this.path.push({
            type: "bct",
            x1: u.x,
            y1: u.y,
            x2: h.x,
            y2: h.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new c(t, e));
            t = s.x, e = s.y;
            var u = this.ctx.transform.applyToPoint(new c(0, r)), h = this.ctx.transform.applyToPoint(new c(0, 0));
            r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: o
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $15d064020a078dff$var$f(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: e,
            g: r,
            b: n,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, n = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * n / e.internal.scaleFactor, o = function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        };
        return new o({
            width: i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(o)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, n, i, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
        for(var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h, S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var I = P[0], F = P[P.length - 1], C = I; C < F + 1; C++){
            this.pdf.setPage(C);
            var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], E = 1 === C ? 0 : B + (C - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var D = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
            }
            var R = JSON.parse(JSON.stringify(S));
            R = N([
                R
            ], this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (C > I || C < F) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
                break;
            case "bct":
                var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, r = this.font, n = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, A = function(t, e) {
        for(var r, n, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = y.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F = 1 === S ? 0 : k + (S - 2) * I;
            if (0 !== this.ctx.clip_path.length) {
                var C = this.path;
                r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
            }
            if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var j = (S > v || S < A) && b.call(this);
                j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, I, null).clip().discardPath()), x.call(this, t, e), j && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, x = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var c = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], c > 0)) {
                            for(; c >= 0; c--)if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
                                i[c - 1].deltas.push(r), i[c - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            u - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, A = i[b].start.y;
                O.call(this, i[b].deltas, L, A), g = !0;
            }
            n && k.call(this, n), e && I.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + e - r;
            case "hanging":
                return t + e - 2 * r;
            case "middle":
                return t + e / 2 - r;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, r, n, i, a, o, s, c) {
        for(var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++){
            var l = u[h];
            0 === h && (c ? F.call(this, l.x1 + t, l.y1 + e) : j.call(this, l.x1 + t, l.y1 + e)), B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
        }
        s ? I.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, I = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, F = function(t, e) {
        this.pdf.internal.out(n(t) + " " + i(e) + " m");
    }, C = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            case "left":
            case "start":
            default:
                e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text), n = S.call(this, t.y), i = _.call(this, n) - r.h, a = this.ctx.transform.applyToPoint(new c(t.x, n)), o = this.ctx.transform.decompose(), s = new h;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, i, r.w, r.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++){
            this.pdf.setPage(k);
            var I = 1 === k ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : F + (k - 2) * j;
            if (0 !== this.ctx.clip_path.length) {
                var E = this.path;
                l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + I), x.call(this, "fill", !0), this.path = E;
            }
            var q = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var D = "text" !== this.autoPaging;
            if (D || q.y + q.h <= C) {
                if (D || q.y >= I && q.x <= O) {
                    var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0], U = D && (k > A || k < P) && b.call(this);
                    U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), U && this.pdf.restoreGraphicsState();
                }
            } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, j = function(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
    }, O = function(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function(t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([
            r(o(n + t)),
            r(s(i + e)),
            r(o(a + t)),
            r(s(c + e)),
            r(o(u + t)),
            r(s(h + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, r, n) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for(var s = [], c = n ? -1 : 1, u = e; o > 1e-5;){
            var h = u + c * Math.min(o, a);
            s.push(E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
    }, E = function(t, e, r) {
        var n = (r - e) / 2, i = t * Math.cos(n), a = t * Math.sin(n), o = i, s = -a, c = o * o + s * s, u = c + o * i + s * a, h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * i), l = o - h * s, f = s + h * o, d = l, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, q = function(t) {
        return 180 * t / Math.PI;
    }, D = function(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), c = i + .5 * (r - i), h = a + .5 * (n - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, R = function(t, e, r, n, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, y, w, N, L, A = r - t, x = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function(t) {
        var e, r, n, i, a, o = String, s = "length", c = 255, u = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5)r = 52200625 * (t[u](i) - 33) + 614125 * (t[u](i + 1) - 33) + 7225 * (t[u](i + 2) - 33) + 85 * (t[u](i + 3) - 33) + (t[u](i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, i = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, a = function(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return t = (r = (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var o = 0, s = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), o = 0; o < e.length; o += 1)switch(e[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = r(s), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = i(s), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = a(s), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: c.reverse().join(" ")
        };
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, r = [], n = String.fromCharCode;
                        for(i = 0; i < e; i += 1)r.push(n(255 & t.charCodeAt(i)));
                        return r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (t) {}
            return n;
        }(t, e, r);
    }, t.loadImageFile = t.loadFile;
}($15d064020a078dff$export$2e2bcd8739ae039.API), function(e) {
    function r() {
        return ($15d064020a078dff$var$n.html2canvas ? Promise.resolve($15d064020a078dff$var$n.html2canvas) : Promise.resolve((parcelRequire("7JB23")))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function i() {
        return ($15d064020a078dff$var$n.DOMPurify ? Promise.resolve($15d064020a078dff$var$n.DOMPurify) : (parcelRequire("lbArK"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(i).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = function t(e, r) {
                for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
                    n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
                }, !0)), n;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $15d064020a078dff$export$2e2bcd8739ae039.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, s.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), i = r.call(n, t, e);
        return s.convert(i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return s.convert(e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, $15d064020a078dff$export$2e2bcd8739ae039.getPageSize = function(e, r, n) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) {
            var i = e;
            e = i.orientation, r = i.unit || r, n = i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var c, u = 0, h = 0;
        if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;
        else try {
            u = n[1], h = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", h > u && (c = h, h = u, u = c);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", u > h && (c = h, h = u, u = c);
        }
        return {
            width: h,
            height: u,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($15d064020a078dff$var$jt) : null;
        var r = new s(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), $15d064020a078dff$export$2e2bcd8739ae039.API.addJS = function(t) {
    return $15d064020a078dff$var$Ht = t, this.internal.events.subscribe("postPutResources", function() {
        $15d064020a078dff$var$Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($15d064020a078dff$var$Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $15d064020a078dff$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $15d064020a078dff$var$Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $15d064020a078dff$var$Ut && void 0 !== $15d064020a078dff$var$zt && this.internal.out("/Names <</JavaScript " + $15d064020a078dff$var$Ut + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++){
                var a = n[i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var c = this.internal.pages.length, u = [];
                for(i = 0; i < c; i++){
                    var h = t.internal.newObject();
                    u.push(h);
                    var l = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                t.internal.write("<< /Names [ ");
                for(i = 0; i < u.length; i++)t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var i = e.children[n];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, c = this.decode.DCT_DECODE, u = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: r,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            u = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: c,
                index: r,
                alias: n
            };
        }
        return u;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API);
var $15d064020a078dff$var$Vt, $15d064020a078dff$var$Gt, $15d064020a078dff$var$Yt, $15d064020a078dff$var$Jt, $15d064020a078dff$var$Xt, $15d064020a078dff$var$Kt = function() {
    var t, e, i;
    function a(t) {
        var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), u = (function() {
                var t, e;
                for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                            if ((h = n - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    a.prototype.read = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)r.push(this.data[this.pos++]);
        return r;
    }, a.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.decodePixels = function(t) {
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), i = 0, a = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function o(r, o, s, c) {
            var u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F = Math.ceil((a.width - r) / s), C = Math.ceil((a.height - o) / c), j = a.width == F && a.height == C;
            for(L = e * F, w = j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && i < p;){
                switch(t[i++]){
                    case 0:
                        for(f = S = 0; S < L; f = S += 1)w[h++] = t[i++];
                        break;
                    case 1:
                        for(f = _ = 0; _ < L; f = _ += 1)u = t[i++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)u = t[i++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                        break;
                    case 4:
                        for(f = I = 0; I < L; f = I += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), y = Math.abs(g - x), v = m <= b && m <= y ? d : b <= y ? A : x, w[h++] = (u + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[i - 1]);
                }
                if (!j) {
                    var O = ((o + N * c) * a.width + r) * e, B = N * L;
                    for(f = 0; f < F; f += 1){
                        for(var M = 0; M < e; M += 1)n[O++] = w[B++];
                        O += (s - 1) * e;
                    }
                }
                N++;
            }
        }
        return t = (0, $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6)(t), 1 == a.interlaceMethod ? (o(0, 0, 8, 8), o(4, 0, 8, 8), o(0, 4, 4, 8), o(2, 0, 4, 4), o(0, 2, 2, 4), o(1, 0, 2, 2), o(0, 1, 1, 2)) : o(0, 0, 1, 1), n;
    }, a.prototype.decodePalette = function() {
        var t, e, r, n, i, a, o, s, c;
        for(r = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + r.length), n = 0, t = 0, e = o = 0, s = r.length; o < s; e = o += 3)i[n++] = r[e], i[n++] = r[e + 1], i[n++] = r[e + 2], i[n++] = null != (c = a[t++]) ? c : 255;
        return i;
    }, a.prototype.copyToImageData = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for(; a < u;)c = h ? 4 * e[a / 4] : s, l = o[c++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = r ? o[c++] : 255, s = c;
        else for(; a < u;)c = h ? 4 * e[a / 4] : s, i[a++] = o[c++], i[a++] = o[c++], i[a++] = o[c++], i[a++] = r ? o[c++] : 255, s = c;
    }, a.prototype.decode = function() {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
    };
    var o = function() {
        if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
            try {
                e = $15d064020a078dff$var$n.document.createElement("canvas"), i = e.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return o(), t = function(t) {
        var r;
        if (!0 === o()) return i.width = t.width, i.height = t.height, i.clearRect(0, 0, t.width, t.height), i.putImageData(t, 0, 0), (r = new Image).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, a.prototype.decodeFrames = function(e) {
        var r, n, i, a, o, s, c, u;
        if (this.animation) {
            for(u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o)r = c[n], i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(i, a), r.imageData = i, u.push(r.image = t(i));
            return u;
        }
    }, a.prototype.renderFrame = function(t, e) {
        var r, n, i;
        return r = (n = this.animation.frames)[e], i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
    }, a.prototype.animate = function(t) {
        var e, r, n, i, a, o, s = this;
        return r = 0, o = this.animation, i = o.numFrames, n = o.frames, a = o.numPlays, (e = function() {
            var o, c;
            if (o = r++ % i, c = n[o], s.renderFrame(t, o), i > 1 && r / i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
    }, a.prototype.stopAnimation = function() {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
    }, a.prototype.render = function(t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
    }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ /**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function $15d064020a078dff$var$Zt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << (7 & i) + 1;
    t[e++], t[e++];
    var s = null, c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; u && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, A = s, x = c, S = !1;
            if (w >> 7) {
                S = !0;
                A = e, x = L, e += 3 * L;
            }
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: A,
                palette_size: x,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            u = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $15d064020a078dff$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $15d064020a078dff$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --l;
        }
    };
}
function $15d064020a078dff$var$$t(t, e, r, n) {
    for(var i = t[e++], o = 1 << i, s = o + 1, c = s + 1, u = i + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < u) break;
        var v = f & h;
        if (f >>= u, l -= u, v !== o) {
            if (v === s) break;
            for(var b = v < c ? v : m, y = 0, w = b; w > o;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n) return void $15d064020a078dff$var$a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
        } else c = s + 1, h = (1 << (u = i + 1)) - 1, m = null;
    }
    return d !== n && $15d064020a078dff$var$a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $15d064020a078dff$var$Qt(t) {
    var e, r, n, i, a, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), A = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], x = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], I = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], F = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var r = 0, n = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], c = function(t, e) {
            var r, n, i, a, o, s, c, u, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
                var p = r + (u = t[f + 7]), g = r - u, m = n + c, v = n - c, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, A = p - w, x = m + b, S = m - b;
                t[f] = L + x, t[f + 4] = L - x;
                var _ = .707106781 * (S + A);
                t[f + 2] = A + _, t[f + 6] = A - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, I = 1.306562965 * S + P, F = .707106781 * (x = y + v), C = g + F, j = g - F;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + I, t[f + 7] = C - I, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
                var O = r + (u = t[f + 56]), B = r - u, M = n + c, E = n - c, q = i + s, D = i - s, R = a + o, T = a - o, U = O + R, z = O - R, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = T + D) - (W = E + B)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = D + E), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), u = 0; u < 64; ++u)p[A[u]] = c[u];
        var h = p[0] - r;
        r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(c[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(x[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(I[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(F[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, A, j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)D = j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
                o = E(b, u, o, e, n), l = E(y, h, l, r, i), f = E(w, h, f, r, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(x, S), r = j(k, I), n = j(_, P), i = j(F, C), function() {
        for(var t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = t; n < e; n++)f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = r, l[32767 + i] = [], l[32767 + i][1] = r, l[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $15d064020a078dff$var$te(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $15d064020a078dff$var$ee(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for(var i = 0; i < n; i++)t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    }
    function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    }
    var c = function() {
        var t = this;
        function c(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        }
        function u(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        }
        function h(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var h, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, A = 1 << n;
                for(f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
                }
                for(h = n + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & y) != b) {
                            for(d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += A = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
        }
        function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        }
        function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
            A(t) && (t.h = 1, t.u = 0);
        }
        function y(t, r) {
            if (e(0 <= r), !t.h && r <= Tr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & Ur - 1) >>> 0;
        }
        function A(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
        }
        function x(t, e) {
            t.u = e, t.h = A(t);
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, i = r * e >>> 8, a = (t.I >>> n > i) + 0;
            for(a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;)i += 8, n >>= 8;
            return n = 7 ^ i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
        }
        function I(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
        }
        function F(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        }
        function C(t, e) {
            return F(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return F(t, e) | F(t, e + 2) << 16;
        }
        function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        }
        function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        }
        function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function D(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function R(e, r) {
            t[r] = function(r, n, i, a, o, s, c) {
                var u;
                for(u = 0; u < o; ++u){
                    var h = t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = D(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + c >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], c = s >>> 8, u = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
                u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        }
        function X(e, r, n, i, a) {
            t[r] = function(t, e, r, n, o, s, c, u, h) {
                for(n = c; n < u; ++n)for(c = 0; c < h; ++c)o[s++] = a(r[i(t[e++])]);
            }, t[e] = function(e, r, o, s, c, u, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
                }
                else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
            };
        }
        function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
            }
        }
        function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        }
        function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        }
        function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)I(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
        }
        function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ct() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var r = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = vi[e.ba.S], c = t.y, u = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
            return u += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), r;
        }
        function lt(t, r, n) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = r.ba.S, c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [
                    0
                ], h = t.ka;
                u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && nt(r) && br(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ut, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = lt, n && mr());
            }
            if (n && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma, n = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        }
        function bt(t, e, r) {
            var n = L(r), i = t[e += 255 & n].g - 8;
            return 0 < i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), x(r, r.u + t[e].g), t[e].value;
        }
        function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        }
        function wt(t, r, n) {
            var i = t.xc;
            return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
        }
        function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, c = t.C;
            r = c + r;
            var u = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = c, d = r, p = u, g = h, m = (h = a, u = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f, b = d, y = h, w = u, N = (_ = l).Ea;
                        0 == v && (Wr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;){
                            var P = S, k = _, I = 1;
                            for(Vr(p, g, y, w - N, 1, y, w); I < N;){
                                var F = (I & ~A) + L;
                                F > N && (F = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +I, y, w + I - N, F - I, y, w + I), I = F;
                            }
                            g += N, w += N, ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(A = L, x = l, S = new T, _ = b + w, P = b + p; b < _;)Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                            b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for(b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = u, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                u = a, h = i;
            }
            h != i && n(a, i, u, h, s);
        }
        function Lt(t, r) {
            var n = t.V, i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, c = t.Ua, u = o.width;
                if (Nt(t, a, n, i), a = c = [
                    c
                ], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
                    if (c = c[0], 11 > (n = t.ca).S) {
                        var l = n.f.RGBA, f = (i = n.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = c, m = a, v = h, b = l;
                            switch(i){
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            c += u, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        }
        function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        }
        function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, c = t.rd;
                for(e(null != mi[t.Z]); r < n; ++r)mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
                t.qd = s, t.rd = c;
            }
        }
        function St(t, r) {
            var n = t.l.ma, i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if (e(r <= t.l.o), r > i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * i, c = t.V, u = t.Ba + t.c * i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], i, r, c, u, o, s), xt(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var c = t.$ / i, u = t.$ % i, h = t.m, l = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + l.ua, m = t.Pb ? c : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
                    }
                    if (u & b || (y = wt(l, u, c)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) {
                        if (S(h), y.jc) {
                            N = h, _ = r;
                            var P = f, k = y.pd[L(N) & Dr - 1];
                            e(y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) r[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(h), w = bt(y.G[1], y.H[1], h), S(h), _ = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), _ = bt(y.G[4], y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, u += N; u >= i;)u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
                        if (e(f <= a), u & b && (y = wt(l, u, c)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new or;
            return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, t.VP8LMapColor32b = Jr, t.VP8LMapColor8b = Kr, e);
        }
        function It(t, r, n, s, c) {
            var u = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; u && y(g, 1);){
                    var w = f, N = p, A = s, _ = 1, P = A.m, k = A.gc[A.ab], I = y(P, 2);
                    if (A.Oc & 1 << I) u = 0;
                    else {
                        switch(A.Oc |= 1 << I, k.hc = I, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++A.ab, e(4 >= A.ab), I){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = It(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var F, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, j), k.b = j, F = _ = It(C, 1, 0, A, k.K)) {
                                    var B, M = C, E = k, R = 1 << (8 >> E.b), T = a(R);
                                    if (null == T) F = 0;
                                    else {
                                        var U = E.K[0], z = E.w;
                                        for(T[0] = E.K[0][0], B = 1; B < 1 * M; ++B)T[B] = D(U[z + B], T[B - 1]);
                                        for(; B < 4 * R; ++B)T[B] = 0;
                                        E.K[0] = null, E.K[0] = T, F = 1;
                                    }
                                }
                                _ = F;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        u = _;
                    }
                }
                if (f = f[0], p = p[0], u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = u) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = Qn[K];
                    r: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!It(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ct = tt[W] >> 8 & 65535;
                                tt[W] = ct, ct >= et && (et = ct + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ut = Xn[V];
                            !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
                        }
                        var ht = o(et * nt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                                n: {
                                    var At, xt = ut, St = Y, kt = pt, Ft = gt, Ct = G, jt = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, xt), Bt) {
                                        var Mt = y(Ot, 1) + 1, Et = y(Ot, 1), qt = y(Ot, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = y(Ot, 8)] = 1);
                                        var Dt = 1;
                                    } else {
                                        var Rt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var Ut = 0;
                                            break n;
                                        }
                                        for(At = 0; At < Tt; ++At)Rt[Zn[At]] = y(Ot, 3);
                                        var zt = void 0, Ht = void 0, Wt = St, Vt = Rt, Gt = xt, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                x(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, re = te - 16, ne = Jn[re], ie = y(Xt, Yn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Dt = Jt;
                                    }
                                    (Dt = Dt && !Ot.h) && (jt = h(Ft, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break r;
                                if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ut; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ce, ue = mt;
                                for(ce = 0; ce < Dr; ++ce){
                                    var he = ce, le = ue.pd[he], fe = ue.G[0][ue.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, u = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, u = 0;
                    break t;
                }
                u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
        }
        function Ft(t, r) {
            var n = t.c * t.i, i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        }
        function Ct(t, r) {
            var n = t.C, i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, c = t.l.ma, u = t.l.width, h = u * s, l = c.ca, f = c.tb + u * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, r, n) {
                    for(var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Rt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new qt, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Rt), this.sb = 0, this.wa = Array(new Dt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, c = t.Od;
            if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
                if (u.Bb = P(s), P(s)) {
                    for(u.Fb = P(s), h = 0; 4 > h; ++h)u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (u.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (u.od[l] = m(s, 6));
            }
            if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;
            else {
                for(h += 3 * l, u -= 3 * l, f = 0; f < l; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
                }
                p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), c = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(u = 0; 11 > u; ++u)l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
                for(o = 0; 17 > o; ++o)c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t, h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else h = 1, s = c[1];
                c = o + ai[i], 0 > (u = t).b && _(u);
                var l, f = u.b, d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
                --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, r) {
            if (null == t) return 0;
            if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if (e(t.cb), null == r.ac || r.ac(r)) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var c = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for(u = 0; 1 >= u; ++u){
                            var l = t.gd[s][u], f = h;
                            if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, c), s = 1;
                        }
                    }
                    if (s) {
                        if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                            for(s = -255; 255 >= s; ++s)Pn[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, r) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], c = t.m, u = t;
                        for(o = 0; o < u.za; ++o){
                            var h = c, l = u, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        y = ci[f[d + b]][y];
                                        for(var w = oi[k(h, y[0])]; 0 < w;)w = oi[2 * w + k(h, y[w])];
                                        y = -w, f[d + b] = y;
                                    }
                                    n(m, v, f, d, 4), v += 4, p[0 + l] = y;
                                }
                            } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                                if (l = p.ad, m = 0, v = c.rb[c.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var A = 0, x = d[3];
                                else {
                                    w = a(16);
                                    var S = h.Na + v.Na;
                                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);
                                    else {
                                        var _ = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = _;
                                    }
                                    A = 1, x = d[0];
                                }
                                var P = 15 & h.la, I = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var F = 1 & I;
                                    for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (F = (S = ni(f, x, S = F + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, I = I >> 1 | F << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(x = P, A = I >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, I = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(F = 1 & I, _ = 0; 2 > _; ++_)S = F + (1 & P), P = P >> 1 | (F = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, I = I >> 1 | F << 5;
                                    }
                                    y |= L << 4 * N, x |= P << 4 << N, A |= (240 & I) << N;
                                }
                                h.la = x, v.la = A, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                            }
                            if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, I = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for(F = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                A = L, x = F;
                                var C = (j = (U = S).D).Nb;
                                N = U.R;
                                var j = j.wa[j.Y + A], O = U.sa, B = U.ta + 16 * C * N + 16 * A, M = j.dd, E = j.tc;
                                if (0 != E) {
                                    if (e(3 <= E), 1 == U.L) 0 < A && wn(O, B, N, E + 4), j.La && Ln(O, B, N, E), 0 < x && yn(O, B, N, E + 4), j.La && Nn(O, B, N, E);
                                    else {
                                        var q = U.B, D = U.qa, R = U.ra + 8 * C * q + 8 * A, T = U.Ha, U = U.Ia + 8 * C * q + 8 * A;
                                        C = j.ld;
                                        0 < A && (fn(O, B, N, E + 4, M, C), pn(D, R, T, U, q, E + 4, M, C)), j.La && (mn(O, B, N, E, M, C), bn(D, R, T, U, q, E, M, C)), 0 < x && (ln(O, B, N, E + 4, M, C), dn(D, R, T, U, q, E + 4, M, C)), j.La && (gn(O, B, N, E, M, C), vn(D, R, T, U, q, E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != c.put) {
                                if (L = 16 * P, P = 16 * (P + 1), I ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                                    u = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < c.j && (y = c.j - L, L = c.j, e(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), null != c.F && (c.J += c.width * y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                            }
                            o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!u) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, r)), null != r.bc && r.bc(r), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        }
        function te(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function ee(t, e, r, n, i, a) {
            te(t, e, 0, r, n + i), te(t, e, 1, r, n + a), te(t, e, 2, r, n - a), te(t, e, 3, r, n - i);
        }
        function re(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, r, n) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var c = t[e + 0] + t[e + 8], u = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - re(t[e + 12]), l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(r, n, 1, 0, u + h), te(r, n, 2, 0, u - h), te(r, n, 3, 0, c - l), o++, n += 32;
        }
        function ie(t, e, r, n) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = re(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            ee(r, n, 0, i + o, t = re(t[e + 1]), s), ee(r, n, 1, i + a, t, s), ee(r, n, 2, i - a, t, s), ee(r, n, 3, i - o, t, s);
        }
        function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        }
        function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        }
        function se(t, e, r, n) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)te(r, n, e, i, t);
        }
        function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], c = t[e + 4 + i] + t[e + 8 + i], u = t[e + 4 + i] - t[e + 8 + i], h = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = h + u, o[12 + i] = h - u;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], u = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
        }
        function he(t, e, r) {
            var n, i = e - 32, a = Bn, o = 255 - t[i - 1];
            for(n = 0; n < r; ++n){
                var s, c = a, u = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = c[u + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        }
        function ge(t, e) {
            var r;
            for(r = 16; 0 < r; --r)i(t, e, t[e - 1], 16), e += 32;
        }
        function me(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)i(e, r + 32 * n, t, 16);
        }
        function ve(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        }
        function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        }
        function ye(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            me(n >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        }
        function Le(t, e) {
            var r, i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4])
            ]);
            for(r = 0; 4 > r; ++r)n(t, e + 32 * r, i, 0, i.length);
        }
        function Ae(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), I(t, e + 32, 16843009 * Ne(r, n, i)), I(t, e + 64, 16843009 * Ne(n, i, a)), I(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)i(t, e + 32 * r, n, 4);
        }
        function Se(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
        }
        function _e(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
        }
        function Pe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
        }
        function ke(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], c = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
        }
        function Ie(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], c = t[e + 1 - 32], u = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r), t[e + 1 + 96] = Ne(a, i, n);
        }
        function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        }
        function je(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)i(t, e, t[e - 1], 8), e += 32;
        }
        function Oe(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)i(e, r + 32 * n, t, 8);
        }
        function Be(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        }
        function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            Oe(n >> 3, t, e);
        }
        function Ee(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        }
        function qe(t, e) {
            Oe(128, t, e);
        }
        function De(t, e, r) {
            var n = t[e - r], i = t[e + 0], a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]], o = On[112 + (a + 4 >> 3)];
            t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + i - o];
        }
        function Re(t, e, r, n) {
            var i = t[e + 0], a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
        }
        function Te(t, e, r, n) {
            return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
        }
        function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], c = t[e + 0], u = t[e + r], h = t[e + 2 * r], l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n, r, i) && De(t, e + n, r);
        }
        function He(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
        }
        function We(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * r, r, n);
        }
        function Ve(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)He(t, e += 4, r, n);
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - 2 * h], f = c[u - h], d = c[u + 0], p = c[u + h], g = c[u + 2 * h], m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
                    }
                }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - h], f = c[u + 0], d = c[u + h], p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = On[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
                    }
                }
                e += n;
            }
        }
        function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * r, r, 1, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, r, 16, n, i, a);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        }
        function rr() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function ir() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function ar() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        }
        function or() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar, this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
        }
        function sr() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function cr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        }
        function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s, c = t[e + 0], u = c, h = c;
                for(s = 0; s < o; ++s)u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
            }
        }
        function lr(t, r, i, o) {
            var s = r.width, c = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (t.ga = new sr, (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
                        u = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = u.l;
                        if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;
                        else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                            e(1 == u.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !It(u.c, u.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = Ft(r, u.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            u.mc = null, r = 0;
                        }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), u = 0; u < o; ++u)mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;
                        else for(u = 0; u < o; ++u)n(f, d, b, l, r), g = f, m = d, d += r, l += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;
                        else if (h.ic || mr(), h.ic) {
                            h = u.V, g = u.Ba, m = u.c;
                            var y = u.i, w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$), N = m * y, L = m * r, x = p.wc, _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= y), e(At(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++l <= r && !(l % 16) && St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
                        } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, c = e + (r ? 1 : 0), u = t, h = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var l = u[h + 4 * o];
                    255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        }
        function dr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (u = t[e + 2 * a + 1]), c = 4369 * s, u = (240 & u | u >> 4) * c >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
                }
                e += i;
            }
        }
        function pr(t, e, r, n, i, a, o, s) {
            var c, u, h = 255;
            for(u = 0; u < i; ++u){
                for(c = 0; c < n; ++c){
                    var l = t[e + c];
                    a[o + 4 * c] = l, h &= l;
                }
                e += r, o += s;
            }
            return 255 != h;
        }
        function gr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        }
        function mr() {
            An = fr, xn = dr, Sn = pr, _n = gr;
        }
        function vr(r, n, i) {
            t[r] = function(t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[c + 0] | u[h + 0] << 16, A = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var x = 3 * L + A + 131074 >> 2;
                for(n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[c + w] | u[h + w] << 16, _ = l[f + w] | d[p + w] << 16, P = L + S + A + _ + 524296, k = P + 2 * (S + A) >> 3;
                    x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
                }
                1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        }
        function br() {
            vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
        }
        function yr(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> Ii;
        }
        function wr(t, e) {
            return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nr(t, e, r) {
            return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        }
        function Lr(t, e) {
            return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function Ar(t, e, r, n, i) {
            n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
        }
        function xr(t, e, r, n, i) {
            n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
        }
        function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
        }
        function _r(t, e, r, n, i) {
            var a = 240 & Lr(t, e) | 15;
            n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
        }
        function Pr(t, e, r, n, i) {
            n[i + 0] = 255, Ar(t, e, r, n, i + 1);
        }
        function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        }
        function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), n[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Fr(e, r, n) {
            t[e] = function(t, e, i, a, o, s, c, u, h) {
                for(var l = u + (-2 & h) * n; u != l;)r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        }
        function Cr(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        }
        function jr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function Or(t, e) {
            var r, a, o = e.M, s = e.Nb, c = t.oc, u = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)c[u + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(c, u - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = c, w = u - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)y = c, w = u + Di[r], fi[p.Ob[r]](y, w), jr(b, v, 16 * +r, y, w);
                } else if (y = Cr(a, o, p.Ob[0]), li[y](c, u), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)jr(b, v, 16 * +r, c, u + Di[r]);
                for(r = p.Gc, y = Cr(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, c, u + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, h, l + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Br(t, n, i, a, o, s, c, u, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new nr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, y = i;
                    var A = l, x = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = n, w = i;
                        var k = g.gb;
                        A = g.na, x = g.P, S = g.Sa;
                        P = 22, e(null != _), e(null != w), L = y[0];
                        var I = w[0];
                        for(e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = I, 8 > I) {
                                y = 7;
                                break t;
                            }
                            var F = j(_, L + 4);
                            if (4294967286 < F) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + F + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (I[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = F), L += O, I -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, _ + 4), 12 <= A && k > A - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        x[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [
                    c
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], A = [
                        0
                    ], v(x = new N, t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
                }
                if (!t) return 3;
                if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : y;
        }
        function Mr(t, e, r) {
            var n = e.width, i = e.height, a = 0, o = 0, s = n, c = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
                if (!E(s, c, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd, o = r.bd, s = -2 & r.v, c = -2 & r.j;
                    if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > t || c + o > e) return 2;
                    t = i, e = o;
                }
                if (r.da) {
                    if (!E(t, e, i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var u = n.width, h = n.height;
                if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (i = u) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = i);
                    }
                    if (e = 1, i = n.S, o = n.width, s = n.height, i >= En && 13 > i) {
                        if (11 > i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[i], e &= null != t.eb;
                        else {
                            t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Er(n)), t;
        }
        var Dr = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tr = 24, Ur = 32, zr = 8, Hr = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        R("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, t.Predictor5 = function(t, e, r) {
            return U(U(t, e[r + 1]), e[r + 0]);
        }, t.Predictor6 = function(t, e, r) {
            return U(t, e[r - 1]);
        }, t.Predictor7 = function(t, e, r) {
            return U(t, e[r + 0]);
        }, t.Predictor8 = function(t, e, r) {
            return U(e[r - 1], e[r + 0]);
        }, t.Predictor9 = function(t, e, r) {
            return U(e[r + 0], e[r + 1]);
        }, t.Predictor10 = function(t, e, r) {
            return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
        }, t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
        };
        var Wr = t.PredictorAdd0;
        t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
        var Vr = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gr, Yr = t.ColorIndexInverseTransform, Jr = t.MapARGB, Xr = t.VP8LColorIndexInverseTransformAlpha, Kr = t.MapAlpha, Zr = t.VP8LPredictorsAdd = [];
        Zr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $r, Qr, tn, en, rn, nn, an, on, sn, cn, un, hn, ln, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a(511), kn = a(2041), In = a(225), Fn = a(767), Cn = 0, jn = kn, On = In, Bn = Fn, Mn = Pn, En = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [
            2,
            3,
            7
        ], Jn = [
            3,
            3,
            11
        ], Xn = [
            280,
            256,
            256,
            256,
            40
        ], Kn = [
            0,
            1,
            1,
            1,
            0
        ], Zn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $n = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qn = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ri = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ci = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = t.UpsampleRgbLinePair, yi = t.UpsampleBgrLinePair, wi = t.UpsampleRgbaLinePair, Ni = t.UpsampleBgraLinePair, Li = t.UpsampleArgbLinePair, Ai = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a(256), Oi = a(256), Bi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Ti = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, r, n, i, a) {
            var o = qn, s = new rr, c = new ot;
            s.ba = c, c.S = o, c.width = [
                c.width
            ], c.height = [
                c.height
            ];
            var u = c.width, h = c.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
                c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
                t: {
                    if (i = new Gt, (a = new nr).data = t, a.w = r, a.ha = n, a.kd = 1, r = [
                        0
                    ], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var n = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, r.width = n[0], r.height = i[0], !It(n[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        r: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                                        if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function u(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    }
    function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function l(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new c;
    var f = [
        0
    ], d = [
        0
    ], p = [], g = new c, m = t, v = function(t, e) {
        var r = {}, n = 0, i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e, r, n) {
            for(var i = 0; i < n; i++)if (t[e + i] != r.charCodeAt(i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            for(l(t, e += 4), e += 8; e < t.length;){
                var s = u(t, e), c = l(t, e += 4);
                e += 4;
                var f = c + (1 & c);
                switch(s){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {}), (g = r.frames[n]).src_off = i ? o : e - 8, g.src_size = a + c + 8, n++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (g = r.header = {}).feature_flags = t[e];
                        var d = e + 4;
                        g.canvas_width = 1 + h(t, d), d += 3, g.canvas_height = 1 + h(t, d), d += 3;
                        break;
                    case "ALPH":
                        i = !0, a = f + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (g = r.header).bgcolor = l(t, e), d = e + 4, g.loop_count = (m = t)[(v = d) + 0] << 0 | m[v + 1] << 8, d += 2;
                        break;
                    case "ANMF":
                        var p, g;
                        (g = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, g.offset_y = 2 * h(t, e), e += 3, g.width = 1 + h(t, e), e += 3, g.height = 1 + h(t, e), e += 3, g.duration = h(t, e), e += 3, p = t[e++], g.dispose = 1 & p, g.blend = p >> 1 & 1;
                }
                "ANMF" != s && (e += f);
            }
            var m, v;
            return r;
        }
    }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null, y = v.frames ? v.frames : null;
    if (b) {
        b.loop_counter = b.loop_count, f = [
            b.canvas_height
        ], d = [
            b.canvas_width
        ];
        for(var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0], L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for(var A = 0; A < d[0] * f[0] * 4; A++)p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
}

!function(t) {
    var r = function() {
        return "function" == typeof (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25);
    }, n = function(r, n, a, h) {
        var l = 4, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 1, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = c;
                break;
            case t.image_compression.SLOW:
                l = 9, f = u;
        }
        r = i(r, n, a, f);
        var d = (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25)(r, {
            level: l
        });
        return t.__addimage__.arrayBufferToBinaryString(d);
    }, i = function(t, e, r, n) {
        for(var i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = l(), h = 0; h < s; h += 1){
            if (o = h * e, i = t.subarray(o, o + e), n) c.set(n(i, r, a), o + h);
            else {
                for(var d, p = u.length, g = []; d < p; d += 1)g[d] = u[d](i, r, a);
                var m = f(g.concat());
                c.set(g[m], o + h);
            }
            a = i;
        }
        return c;
    }, a = function(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function(t, e) {
        var r, n = [], i = t.length;
        n[0] = 1;
        for(var a = 0; a < i; a += 1)r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
    }, s = function(t, e, r) {
        var n, i = [], a = t.length;
        i[0] = 2;
        for(var o = 0; o < a; o += 1)n = r && r[o] || 0, i[o + 1] = t[o] - n + 256 & 255;
        return i;
    }, c = function(t, e, r) {
        var n, i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)n = t[s - e] || 0, i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + i >>> 1) & 255;
        return a;
    }, u = function(t, e, r) {
        var n, i, a, o, s = [], c = t.length;
        s[0] = 4;
        for(var u = 0; u < c; u += 1)n = t[u - e] || 0, i = r && r[u] || 0, a = r && r[u - e] || 0, o = h(n, i, a), s[u + 1] = t[u] - o + 256 & 255;
        return s;
    }, h = function(t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r), i = Math.abs(t - r), a = Math.abs(t + e - r - r);
        return n <= i && n <= a ? t : i <= a ? e : r;
    }, l = function() {
        return [
            a,
            o,
            s,
            c,
            u
        ];
    }, f = function(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(e, i, a, o) {
        var s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L = this.decode.FLATE_DECODE, A = "";
        if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
            if (e = (u = new $15d064020a078dff$var$Kt(e)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [
                4,
                6
            ].indexOf(u.colorType)) {
                if (8 === u.bits) {
                    g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
                    var x, S = u.pixelBitlength - u.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(y = p[w], x = 0; x < S;)v[N++] = y >>> x & 255, x += u.bits;
                        m[w] = y >>> x & 255;
                    }
                }
                if (16 === u.bits) {
                    g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
                    for(var _ = 0; w < g;)y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[_++] = y >>> 16 & 255;
                    c = 8;
                }
                o !== t.image_compression.NONE && r() ? (e = n(v, u.width * u.colors, u.colors, o), d = n(m, u.width, 1, o)) : (e = v, d = m, L = void 0);
            }
            if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
                var P = u.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var I = function(e) {
                var r;
                switch(e){
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            }(o);
            return L === this.decode.FLATE_DECODE && (A = "/Predictor " + I + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: e,
                index: i,
                filter: L,
                decodeParameters: A,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: I,
                width: u.width,
                height: u.height,
                bitsPerComponent: c,
                colorSpace: s
            };
        }
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$Zt(e), o = a.width, s = a.height, c = [];
        a.decodeAndBlitFrameRGBA(0, c);
        var u = {
            data: c,
            width: o,
            height: s
        }, h = new $15d064020a078dff$var$Qt(100).encode(u, 100);
        return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}($15d064020a078dff$export$2e2bcd8739ae039.API), $15d064020a078dff$var$te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $15d064020a078dff$var$te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (t) {
        $15d064020a078dff$var$a.log("bit decode error:" + t);
    }
}, $15d064020a078dff$var$te.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), r = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var c = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, $15d064020a078dff$var$te.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * i * 4, s = a >> 4, c = 15 & a, u = this.palette[s];
            if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $15d064020a078dff$var$te.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $15d064020a078dff$var$te.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, c = (a >> 10 & e) / e * 255 | 0, u = a >> 15 ? 255 : 0, h = n * this.width * 4 + 4 * i;
            this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
        }
        this.pos += t;
    }
}, $15d064020a078dff$var$te.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, c = (o >> 5 & r) / r * 255 | 0, u = (o >> 11) / e * 255 | 0, h = i * this.width * 4 + 4 * a;
            this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += t;
    }
}, $15d064020a078dff$var$te.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $15d064020a078dff$var$te.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, $15d064020a078dff$var$te.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$te(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $15d064020a078dff$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), $15d064020a078dff$var$ee.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$ee(e), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $15d064020a078dff$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), $15d064020a078dff$export$2e2bcd8739ae039.API.processRGBA = function(t, e, r) {
    for(var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, u = 0; u < i; u += 4){
        var h = n[u], l = n[u + 1], f = n[u + 2], d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $15d064020a078dff$export$2e2bcd8739ae039.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $15d064020a078dff$var$Vt = $15d064020a078dff$export$2e2bcd8739ae039.API, $15d064020a078dff$var$Gt = $15d064020a078dff$var$Vt.getCharWidthsArray = function(e, r) {
    var n, i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), c = r.widths ? r.widths : a.metadata.Unicode.widths, u = c.fof ? c.fof : 1, h = r.kerning ? r.kerning : a.metadata.Unicode.kerning, l = h.fof ? h.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = c[0] || u, v = [];
    for(n = 0; n < p; n++)i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(h[i]) && !isNaN(parseInt(h[i][g], 10)) ? h[i][g] / l : 0, v.push((c[i] || m) / u + d)), g = i;
    return v;
}, $15d064020a078dff$var$Yt = $15d064020a078dff$var$Vt.getStringUnitWidth = function(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $15d064020a078dff$var$Vt.processArabic && (t = $15d064020a078dff$var$Vt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : $15d064020a078dff$var$Gt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $15d064020a078dff$var$Jt = function(t, e, r, n) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    i.push(t.slice(0, a));
    var c = a;
    for(s = 0; a !== o;)s + e[a] > n && (i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && i.push(t.slice(c, a)), i;
}, $15d064020a078dff$var$Xt = function(t, e, r) {
    r || (r = {});
    var n, i, a, o, s, c, u, h = [], l = [
        h
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $15d064020a078dff$var$Gt.apply(this, [
        " ",
        r
    ])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(c).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, c = $15d064020a078dff$var$Yt.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = $15d064020a078dff$var$Gt.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $15d064020a078dff$var$Jt.apply(this, [
                    n,
                    i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                n
            ];
            l.push(h), f = p + c, d = m;
        } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(u);
}, $15d064020a078dff$var$Vt.splitTextToSize = function(t, e, r) {
    var n, i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
            widths: e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: e.metadata.Unicode.kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s, c, u = [];
    for(s = 0, c = n.length; s < c; s++)u = u.concat($15d064020a078dff$var$Xt.apply(this, [
        n[s],
        o,
        a
    ]));
    return u;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0; a < r.length; a++)n[r[a]] = "0123456789abcdef"[a], i["0123456789abcdef"[a]] = r[a];
    var o = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, s = e.__fontmetrics__.compress = function(e) {
        var r, n, a, c, u = [
            "{"
        ];
        for(var h in e){
            if (r = e[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + i[a.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) + ".");
                a = s(r);
            }
            u.push(n + a);
        }
        return u.push("}"), u.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (u.push([
            c,
            i
        ]), c = {}, i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, l = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, r = l.Unicode[e.postScriptName];
            r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, i = r.font, a = r.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e($15d064020a078dff$var$u(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, n);
            }
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    function e() {
        return ($15d064020a078dff$var$n.canvg ? Promise.resolve($15d064020a078dff$var$n.canvg) : (parcelRequire("l3dTC"))).catch(function(t) {
            return Promise.reject(new Error("Could not load canvg: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    $15d064020a078dff$export$2e2bcd8739ae039.API.addSvgAsImage = function(t, r, n, i, o, s, c, u) {
        if (isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(i) || isNaN(o)) throw $15d064020a078dff$var$a.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = i, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return e().then(function(e) {
            return e.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
        });
    };
}(), $15d064020a078dff$export$2e2bcd8739ae039.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var i = 0; i < this.internal.pages[n].length; i++)this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
    return this;
}, $15d064020a078dff$export$2e2bcd8739ae039.API.viewerPreferences = function(e, r) {
    var n;
    e = e || {}, r = r || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, c = Object.keys(s), u = [], h = 0, l = 0, f = 0;
    function d(t, e) {
        var r, n = !1;
        for(r = 0; r < t.length; r += 1)t[r] === e && (n = !0);
        return n;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = c.length;
        for(f = 0; f < p; f += 1)n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) {
        for(a in e)if (o = e[a], d(c, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(h = 0; h < o.length; h += 1)if (i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));
                else if (o[h].length > 1) {
                    for(l = 0; l < o[h].length; l += 1)"number" != typeof o[h][l] && (i = !1);
                    !0 === i && u.push([
                        o[h][0] - 1,
                        o[h][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + u.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r = unescape(encodeURIComponent(t)), n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = r.length + n.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, r = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, n) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: n || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), function(t) {
    var e = t.API, r = e.pdfEscape16 = function(t, e) {
        for(var r, n = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
    }, n = function(t) {
        var e, r, n, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++)u += String.fromCharCode(c[h]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $15d064020a078dff$var$F(r.fontName)), i("/FontFile2 " + l + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $15d064020a078dff$var$F(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $15d064020a078dff$var$F(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++)c += String.fromCharCode(s[u]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var l = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + h + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + $15d064020a078dff$var$F(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + $15d064020a078dff$var$F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, n = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, c = s.pdfEscape, u = s.activeFontKey, h = s.fonts, l = u, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: n,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($15d064020a078dff$export$2e2bcd8739ae039.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, i, a, o, s, c, u = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, y = function(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var c, u, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
                    break;
                case "ES":
                    f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (c = e[h], p && ("R" === c || "AL" === c)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function(t, e, i) {
            var a, o, s, c, u, d = -1, p = t.length, g = 0, y = [], N = v ? l : h, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (u = g, y[s] = w(t, L, y, s), a = 240 & (g = N[u][f[y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = c;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var i = n - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, A = function(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, c, u, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(c = l + 1; c < h && i[c] >= t;)c++;
                        for(u = l, s = c - 1; u < s; u++, s--)o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                        l = c;
                    }
                    l++;
                }
            }
        }, x = function(t, e, r) {
            var n = t.split(""), i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, i), function(t, e, r) {
                if (0 !== r.hiLevel && c) for(var n, i = 0; i < t.length; i++)1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
            }(n, r, i), A(2, n, e, r, i), A(1, n, e, r, i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var r = 0; r < t.length; r++)e[r] = r;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var n = c;
                        a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
                    }
                } else v = 0, t = x(t, e, r);
            } else v = a ? 1 : 0, t = x(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text;
            t.x, t.y;
            var n = t.options || {};
            t.mutex, n.lang;
            var i = [];
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($15d064020a078dff$export$2e2bcd8739ae039), $15d064020a078dff$export$2e2bcd8739ae039.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $15d064020a078dff$var$ne(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $15d064020a078dff$var$Le(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $15d064020a078dff$var$ie(this.contents), this.head = new $15d064020a078dff$var$se(this), this.name = new $15d064020a078dff$var$pe(this), this.cmap = new $15d064020a078dff$var$ue(this), this.toUnicode = {}, this.hhea = new $15d064020a078dff$var$he(this), this.maxp = new $15d064020a078dff$var$ge(this), this.hmtx = new $15d064020a078dff$var$me(this), this.post = new $15d064020a078dff$var$fe(this), this.os2 = new $15d064020a078dff$var$le(this), this.loca = new $15d064020a078dff$var$Ne(this), this.glyf = new $15d064020a078dff$var$be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, r, n, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, i;
            for(i = [], e = 0, r = (n = this.bbox).length; e < r; e++)t = n[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, r) {
        var n, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
}();
var $15d064020a078dff$var$re, $15d064020a078dff$var$ne = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, r, n, i;
        for(i = [], r = 0, n = t.length; r < n; r++)e = t[r], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $15d064020a078dff$var$ie = function() {
    var t;
    function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new $15d064020a078dff$var$ne).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), i = 16 * f, c = n.pos + i, o = null, d = [], e)for(l = e[p], n.writeString(p), n.writeInt(t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;)d.push(0), c++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, t = function(t) {
        var e, r, n, i;
        for(t = $15d064020a078dff$var$ve.call(t); t.length % 4;)t.push(0);
        for(n = new $15d064020a078dff$var$ne(t), r = 0, e = 0, i = t.length; e < i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), $15d064020a078dff$var$ae = {}.hasOwnProperty, $15d064020a078dff$var$oe = function(t, e) {
    for(var r in e)$15d064020a078dff$var$ae.call(e, r) && (t[r] = e[r]);
    function n() {
        this.constructor = t;
    }
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
$15d064020a078dff$var$re = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $15d064020a078dff$var$se = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var e;
        return (e = new $15d064020a078dff$var$ne).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, e;
}(), $15d064020a078dff$var$ce = function() {
    function t(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, i = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
    }
    return t.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F, C, j, O, B, M, E, q, D, R, T, U, z, H, W, V, G, Y;
        switch(I = new $15d064020a078dff$var$ne, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, F = 0, B = a.length; F < B; F++)null == v[W = t[n = a[F]]] && (v[W] = ++p), i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return I.writeUInt16(1), I.writeUInt16(0), I.writeUInt32(12), I.writeUInt16(0), I.writeUInt16(262), I.writeUInt16(0), I.write(g), {
                    charMap: i,
                    subtable: I.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
                for(m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j){
                    if (_ = P[d], u = h[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(I.writeUInt16(3), I.writeUInt16(1), I.writeUInt32(12), I.writeUInt16(4), I.writeUInt16(16 + 8 * x + 2 * f.length), I.writeUInt16(0), I.writeUInt16(S), I.writeUInt16(A), I.writeUInt16(l), I.writeUInt16(L), z = 0, q = h.length; z < q; z++)n = h[z], I.writeUInt16(n);
                for(I.writeUInt16(0), H = 0, D = P.length; H < D; H++)n = P[H], I.writeUInt16(n);
                for(V = 0, R = s.length; V < R; V++)o = s[V], I.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], I.writeUInt16(y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], I.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: I.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $15d064020a078dff$var$ue = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = new $15d064020a078dff$var$ce(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, e.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = $15d064020a078dff$var$ce.encode(t, e), (n = new $15d064020a078dff$var$ne).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, e;
}(), $15d064020a078dff$var$he = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), $15d064020a078dff$var$le = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, r;
            for(r = [], e = 0; e < 10; ++e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var e, r;
            for(r = [], e = 0; e < 4; ++e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, r;
            for(r = [], e = 0; e < 2; e = ++e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), $15d064020a078dff$var$fe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)e = t.readByte(), n.push(this.names.push(t.readString(e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var e, r, n;
                    for(n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, e;
}(), $15d064020a078dff$var$de = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $15d064020a078dff$var$pe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s, c, u, h, l;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = u = 0, h = r.length; u < h; i = ++u)n = r[i], t.pos = n.offset, c = t.readString(n.length), a = new $15d064020a078dff$var$de(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), $15d064020a078dff$var$ge = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), $15d064020a078dff$var$me = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, i;
            for(i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, r, n;
            for(n = [], t = 0, e = (r = this.metrics).length; t < e; t++)i = r[t], n.push(i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), $15d064020a078dff$var$ve = [].slice, $15d064020a078dff$var$be = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new $15d064020a078dff$var$ne(e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new $15d064020a078dff$var$we(o, c, h, s, u) : new $15d064020a078dff$var$ye(o, a, c, h, s, u), this.cache[t]));
    }, e.prototype.encode = function(t, e, r) {
        var n, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, e;
}(), $15d064020a078dff$var$ye = function() {
    function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $15d064020a078dff$var$we = function() {
    function t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, r;
        for(e = new $15d064020a078dff$var$ne($15d064020a078dff$var$ve.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $15d064020a078dff$var$Ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a)if (r[a] = n, i < e.length && e[i] == a) {
            ++i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var c = new Array(4 * r.length), u = 0; u < r.length; ++u)c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
    }, e;
}(), $15d064020a078dff$var$Le = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, r, n, i;
        for(e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)r = i[e], t[e] = n[r];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, r, n, i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], n)(null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))r = s[i], n[i] = r;
        return n;
    }, t.prototype.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
        for(n in r = $15d064020a078dff$var$ue.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in l = r.maxGlyphID, a)d in f || (f[d] = l++);
        return u = function(t) {
            var e, r;
            for(e in r = {}, t)r[t[e]] = e;
            return r;
        }(f), h = Object.keys(u).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, r;
            for(r = [], t = 0, e = h.length; t < e; t++)o = h[t], r.push(u[o]);
            return r;
        }(), i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: c,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$15d064020a078dff$export$2e2bcd8739ae039.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = r.length; t < i; t++)n = r[t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(i in a = [
                "<<"
            ], r)o = r[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();


// src/constants.ts
var $2171d27e179e301a$var$MM_TO_PX = 3.77952755906;
var $2171d27e179e301a$export$3e4ff2216a90b8a4 = /* @__PURE__ */ ((Resolution2)=>{
    Resolution2[Resolution2["LOW"] = 1] = "LOW";
    Resolution2[Resolution2["NORMAL"] = 2] = "NORMAL";
    Resolution2[Resolution2["MEDIUM"] = 3] = "MEDIUM";
    Resolution2[Resolution2["HIGH"] = 7] = "HIGH";
    Resolution2[Resolution2["EXTREME"] = 12] = "EXTREME";
    return Resolution2;
})($2171d27e179e301a$export$3e4ff2216a90b8a4 || {});
var $2171d27e179e301a$export$e717bcf55e1dfb40 = /* @__PURE__ */ ((Margin2)=>{
    Margin2[Margin2["NONE"] = 0] = "NONE";
    Margin2[Margin2["SMALL"] = 5] = "SMALL";
    Margin2[Margin2["MEDIUM"] = 10] = "MEDIUM";
    Margin2[Margin2["LARGE"] = 25] = "LARGE";
    return Margin2;
})($2171d27e179e301a$export$e717bcf55e1dfb40 || {});
var $2171d27e179e301a$var$DEFAULT_OPTIONS = {
    method: "save",
    resolution: 3 /* MEDIUM */ ,
    page: {
        margin: 0 /* NONE */ ,
        format: "A4",
        orientation: "portrait"
    },
    canvas: {
        mimeType: "image/jpeg",
        qualityRatio: 1,
        useCORS: true,
        logging: false
    },
    overrides: {}
};
// src/converter.ts
var $2171d27e179e301a$var$Converter = class {
    pdf;
    canvas;
    options;
    constructor(canvas, options){
        this.canvas = canvas;
        this.options = options;
        this.pdf = new (0, $15d064020a078dff$export$2e2bcd8739ae039)({
            format: this.options.page.format,
            orientation: this.options.page.orientation,
            ...this.options.overrides?.pdf,
            unit: "mm"
        });
    }
    getMarginTopMM() {
        const margin = typeof this.options.page.margin === "object" ? this.options.page.margin.top : this.options.page.margin;
        return Number(margin);
    }
    getMarginLeftMM() {
        const margin = typeof this.options.page.margin === "object" ? this.options.page.margin.left : this.options.page.margin;
        return Number(margin);
    }
    getMarginRightMM() {
        const margin = typeof this.options.page.margin === "object" ? this.options.page.margin.right : this.options.page.margin;
        return Number(margin);
    }
    getMarginBottomMM() {
        const margin = typeof this.options.page.margin === "object" ? this.options.page.margin.bottom : this.options.page.margin;
        return Number(margin);
    }
    getMarginTop() {
        return this.getMarginTopMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getMarginBottom() {
        return this.getMarginBottomMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getMarginLeft() {
        return this.getMarginLeftMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getMarginRight() {
        return this.getMarginRightMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getScale() {
        return this.options.resolution;
    }
    getPageHeight() {
        return this.getPageHeightMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getPageHeightMM() {
        return this.pdf.internal.pageSize.height;
    }
    getPageWidthMM() {
        return this.pdf.internal.pageSize.width;
    }
    getPageWidth() {
        return this.getPageWidthMM() * $2171d27e179e301a$var$MM_TO_PX;
    }
    getOriginalCanvasWidth() {
        return this.canvas.width / this.getScale();
    }
    getOriginalCanvasHeight() {
        return this.canvas.height / this.getScale();
    }
    getCanvasPageAvailableHeight() {
        return this.getPageAvailableHeight() * this.getScale() * this.getHorizontalFitFactor();
    }
    getPageAvailableWidth() {
        return this.getPageWidth() - (this.getMarginLeft() + this.getMarginRight());
    }
    getPageAvailableHeight() {
        return this.getPageHeight() - (this.getMarginTop() + this.getMarginBottom());
    }
    getPageAvailableWidthMM() {
        return this.getPageAvailableWidth() / $2171d27e179e301a$var$MM_TO_PX;
    }
    getPageAvailableHeightMM() {
        return this.getPageAvailableHeight() / $2171d27e179e301a$var$MM_TO_PX;
    }
    getNumberPages() {
        return Math.ceil(this.canvas.height / this.getCanvasPageAvailableHeight());
    }
    getHorizontalFitFactor() {
        if (this.getPageAvailableWidth() < this.getOriginalCanvasWidth()) return this.getOriginalCanvasWidth() / this.getPageAvailableWidth();
        return 1;
    }
    getCanvasOffsetY(pageNumber) {
        return this.getCanvasPageAvailableHeight() * (pageNumber - 1);
    }
    getCanvasHeightLeft(pageNumber) {
        return this.canvas.height - this.getCanvasOffsetY(pageNumber);
    }
    getCanvasPageHeight(pageNumber) {
        if (this.canvas.height < this.getCanvasPageAvailableHeight()) return this.canvas.height;
        const canvasHeightPending = this.getCanvasHeightLeft(pageNumber);
        return canvasHeightPending < this.getCanvasPageAvailableHeight() ? canvasHeightPending : this.getCanvasPageAvailableHeight();
    }
    getCanvasPageWidth() {
        return this.canvas.width;
    }
    createCanvasPage(pageNumber) {
        const canvasPageWidth = this.getCanvasPageWidth();
        const canvasPageHeight = this.getCanvasPageHeight(pageNumber);
        const canvasPage = document.createElement("canvas");
        canvasPage.setAttribute("width", String(canvasPageWidth));
        canvasPage.setAttribute("height", String(canvasPageHeight));
        const ctx = canvasPage.getContext("2d");
        ctx.drawImage(this.canvas, 0, this.getCanvasOffsetY(pageNumber), this.canvas.width, canvasPageHeight, 0, 0, this.canvas.width, canvasPageHeight);
        return canvasPage;
    }
    convert() {
        let pageNumber = 1;
        const numberPages = this.getNumberPages();
        while(pageNumber <= numberPages){
            if (pageNumber > 1) this.pdf.addPage(this.options.page.format, this.options.page.orientation);
            const canvasPage = this.createCanvasPage(pageNumber);
            const pageImageDataURL = canvasPage.toDataURL(this.options.canvas.mimeType, this.options.canvas.qualityRatio);
            this.pdf.setPage(pageNumber);
            this.pdf.addImage({
                imageData: pageImageDataURL,
                width: canvasPage.width / (this.getScale() * $2171d27e179e301a$var$MM_TO_PX * this.getHorizontalFitFactor()),
                height: canvasPage.height / (this.getScale() * $2171d27e179e301a$var$MM_TO_PX * this.getHorizontalFitFactor()),
                x: this.getMarginLeftMM(),
                y: this.getMarginTopMM()
            });
            pageNumber += 1;
        }
        return this.pdf;
    }
};
// src/utils.ts
var $2171d27e179e301a$var$buildConvertOptions = (options)=>{
    if (!options) return $2171d27e179e301a$var$DEFAULT_OPTIONS;
    return {
        ...$2171d27e179e301a$var$DEFAULT_OPTIONS,
        ...options,
        canvas: {
            ...$2171d27e179e301a$var$DEFAULT_OPTIONS.canvas,
            ...options.canvas
        },
        page: {
            ...$2171d27e179e301a$var$DEFAULT_OPTIONS.page,
            ...options.page
        }
    };
};
// src/index.ts
var $2171d27e179e301a$var$getTargetElement = (targetRefOrFunction)=>{
    if (typeof targetRefOrFunction === "function") return targetRefOrFunction();
    return targetRefOrFunction?.current;
};
var $2171d27e179e301a$export$398b9fbd663a6614 = (usePDFoptions)=>{
    const targetRef = (0, $acw62.useRef)();
    const toPDF = (0, $acw62.useCallback)((toPDFoptions)=>{
        return $2171d27e179e301a$var$generatePDF(targetRef, usePDFoptions ?? toPDFoptions);
    }, [
        targetRef,
        usePDFoptions
    ]);
    return {
        targetRef: targetRef,
        toPDF: toPDF
    };
};
var $2171d27e179e301a$var$generatePDF = async (targetRefOrFunction, customOptions)=>{
    const options = $2171d27e179e301a$var$buildConvertOptions(customOptions);
    const targetElement = $2171d27e179e301a$var$getTargetElement(targetRefOrFunction);
    if (!targetElement) {
        console.error("Unable to get the target element.");
        return;
    }
    const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(targetElement, {
        useCORS: options.canvas.useCORS,
        logging: options.canvas.logging,
        scale: options.resolution,
        ...options.overrides?.canvas
    });
    const converter = new $2171d27e179e301a$var$Converter(canvas, options);
    const pdf = converter.convert();
    switch(options.method){
        case "build":
            return pdf;
        case "open":
            window.open(pdf.output("bloburl"), "_blank");
            return pdf;
        case "save":
        default:
            {
                const pdfFilename = options.filename ?? `${/* @__PURE__ */ new Date().getTime()}.pdf`;
                await pdf.save(pdfFilename, {
                    returnPromise: true
                });
                return pdf;
            }
    }
};
var $2171d27e179e301a$export$2e2bcd8739ae039 = $2171d27e179e301a$var$generatePDF;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $c5f98b6cec9b1dc7$export$23ec8986ee72eea6 = ({ isVisible: isVisible, setVisible: setVisible, title: title = "Oops, something went wrong.", onDismiss: onDismiss })=>{
    const handleDismiss = onDismiss || (()=>setVisible(false));
    const modalButtons = [
        {
            label: "Dismiss",
            onClick: handleDismiss
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Modal), {
        isOpen: isVisible,
        onDismiss: handleDismiss,
        buttons: modalButtons,
        size: "sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                color: "color-system-red-700",
                icon: "x-circle",
                size: "xl"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "h5",
                sx: {
                    mb: 1
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-regular",
                children: "If the issue persists, please contact customer service at WeCare@modernatx.com or 1-866-MODERNA (1-866-663-3762)."
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



const $64b47ca00fdc75bf$export$bc26c6b6bb2f2bfc = ({ invoice: invoice, promptPayDiscount: promptPayDiscount })=>{
    const onlineDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const totalDoses = onlineDiscountEnabled ? invoice.orderLineItems.reduce((accumulator, currentValue)=>accumulator + Number(currentValue.quantity), 0) : undefined;
    const subTotalHeader = onlineDiscountEnabled && totalDoses ? `Subtotal (${Number(totalDoses)} doses):` : "Subtotal:";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    pt: "spacing-9",
                    pb: "spacing-6"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            4,
                            8
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-medium",
                                        children: subTotalHeader
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 1,
                                    fillGapStart: true,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-medium",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.subtotal)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            4,
                            8
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-regular",
                                        children: "Shipping:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 1,
                                    fillGapStart: true,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-regular",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(0)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            4,
                            8
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-regular",
                                        children: "Sales tax:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 1,
                                    fillGapStart: true,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-regular",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.taxes ?? 0)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: 2,
                        push: [
                            2,
                            6,
                            10
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "inline-block",
                                py: "spacing-3"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                color: "color-system-gray-100"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            4,
                            8
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-medium",
                                        children: "Invoice total:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 1,
                                    fillGapStart: true,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-medium",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.subtotal + invoice.taxes)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            4,
                            8
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "spacing-2"
                                        },
                                        children: [
                                            invoice.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Overdue && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                                                variant: "warning",
                                                size: "medium",
                                                label: "Expired"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "body-1-regular",
                                                children: "Prompt pay discount:*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 1,
                                    fillGapStart: true,
                                    sx: {
                                        alignItems: "end"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "body-1-regular",
                                        children: [
                                            "-",
                                            (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(promptPayDiscount?.discountAmount ?? 0)
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: 5,
                        push: [
                            0,
                            4,
                            7
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "inline-block",
                                pb: "spacing-6"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                color: "color-current-brand-600"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        push: [
                            0,
                            2,
                            4
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: [
                                        2,
                                        4,
                                        6
                                    ],
                                    fillGapEnd: true,
                                    sx: {
                                        alignItems: "end",
                                        color: "color-current-brand-800"
                                    },
                                    children: promptPayDiscount ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "h5",
                                                children: [
                                                    "Total due if paid by",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                        sx: {
                                                            mx: "spacing-2"
                                                        },
                                                        children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(promptPayDiscount?.discountExpiration)
                                                    }),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "body-1-medium",
                                                children: [
                                                    "If paid after",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                        sx: {
                                                            mx: "spacing-2"
                                                        },
                                                        children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(invoice.dueDate)
                                                    }),
                                                    ":"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "h5",
                                        children: "Total amount due:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    sx: {
                                        alignItems: "end",
                                        color: "color-current-brand-800"
                                    },
                                    children: promptPayDiscount ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "end"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "h5",
                                                children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.total)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                variant: "body-1-medium",
                                                children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.subtotal + invoice.taxes)
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        variant: "h5",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(invoice.subtotal + invoice.taxes)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: 5,
                        push: [
                            0,
                            4,
                            7
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                display: "inline-block",
                                pt: "spacing-6"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                color: "color-current-brand-600"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: 5,
                        push: [
                            0,
                            4,
                            7
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-2-regular",
                            sx: {
                                paddingTop: "spacing-5",
                                paddingBottom: "spacing-5",
                                color: "text-secondary"
                            },
                            children: "*Your contract terms entitle you to a 2% discount if orders are paid within 60 days of your invoice date."
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


const $95c87d4fbf6d6c5d$var$ItemizedInvoiceItemsTable = ({ items: items })=>{
    const onlineDiscountEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("ONLINE_DISCOUNT");
    const priceHeader = onlineDiscountEnabled ? "Price per dose*" : "Contract price";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: "spacing-2"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Table), {
                variant: "unshaded",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderRow), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: "NDC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                    grow: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: "Items"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: priceHeader
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: "Doses"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableHeaderCell), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: "Subtotal"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableBody), {
                        children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.TableRow), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                        children: item.ndcNumber || "--"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                        children: item.itemDescription || "--"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(item.contractPrice)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                        children: item.quantity || "--"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TableCell), {
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(item.subtotal)
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            onlineDiscountEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                sx: {
                    color: "text-incidental"
                },
                variant: "body-2-regular",
                children: "*Online discount is included in price if applicable"
            })
        ]
    });
};
var $95c87d4fbf6d6c5d$export$2e2bcd8739ae039 = $95c87d4fbf6d6c5d$var$ItemizedInvoiceItemsTable;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $d0f65be7151cc551$var$NoteCard = ({ notes: notes })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            borderRadius: "radius-2",
            borderColor: "stroke-neutral-tertiary",
            backgroundColor: "color-system-yellow-50",
            overflow: "hidden",
            boxShadow: "shadow-200"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    backgroundColor: "color-system-yellow-200",
                    gap: "spacing-4",
                    px: "spacing-6",
                    py: "spacing-4"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    weight: "bold",
                    children: "Note"
                })
            }),
            notes.map((note, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        gap: "spacing-4",
                        px: "spacing-6",
                        py: "spacing-4"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        children: note
                    })
                }, `note-${index}`))
        ]
    });
var $d0f65be7151cc551$export$2e2bcd8739ae039 = $d0f65be7151cc551$var$NoteCard;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $6e3e87b08c1cf567$export$4f8f5e60385da2 = ({ fieldName: fieldName, fieldValue: fieldValue })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            mt: "spacing-3"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-regular",
                children: fieldName
            }),
            Array.isArray(fieldValue) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "end"
                },
                children: fieldValue.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "body-1-medium",
                        children: item
                    }, `${index}-payment-info`))
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                variant: "body-1-medium",
                children: fieldValue
            })
        ]
    });
var $6e3e87b08c1cf567$export$2e2bcd8739ae039 = $6e3e87b08c1cf567$export$4f8f5e60385da2;


const $cd20a5f0f1f2b2f9$var$PaymentDetails = ({ payment: payment, paymentStatus: paymentStatus })=>{
    const headerBackground = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return paymentStatus === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid ? "color-system-green-600" : "color-system-gray-600";
    }, [
        paymentStatus
    ]);
    const headerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (paymentStatus === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: "spacing-2"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                    icon: "check-circle",
                    size: "xs",
                    color: "white"
                }),
                payment?.paymentDate ? `Paid on ${payment.paymentDate}` : "Paid"
            ]
        });
        else return "Pending";
    }, [
        paymentStatus,
        payment?.paymentDate
    ]);
    const paidHeaderStyle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return paymentStatus === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid ? {
            display: "flex",
            alignItems: "center",
            gap: "spacing-2"
        } : {};
    }, [
        paymentStatus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        sx: {
                            backgroundColor: headerBackground,
                            borderTopLeftRadius: "radius-2",
                            borderTopRightRadius: "radius-2"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            variant: "body-1-bold",
                            sx: {
                                color: "white",
                                px: "spacing-6",
                                py: "spacing-4",
                                ...paidHeaderStyle
                            },
                            children: headerContent
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            sx: {
                                borderLeft: "1px solid",
                                borderBottom: "1px solid",
                                borderRight: "1px solid",
                                borderColor: "color-system-gray-300",
                                borderBottomLeftRadius: "radius-2",
                                borderBottomRightRadius: "radius-2",
                                px: "spacing-6",
                                pt: "spacing-4",
                                pb: "spacing-6",
                                color: "color-system-gray-600",
                                width: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                                fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).ConfirmationNum,
                                                fieldValue: payment?.confirmationNum || "Unavailable"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                                fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).PaymentDate,
                                                fieldValue: payment?.paymentDate || "Unavailable"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                                fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).PaymentMethod,
                                                fieldValue: payment?.paymentMethod || "Unavailable"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                    sx: {
                                        pt: "spacing-4",
                                        pb: "spacing-2"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                        color: "color-system-gray-300"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: "Amount paid",
                                            fieldValue: payment?.amount || "Unavailable"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $cd20a5f0f1f2b2f9$export$2e2bcd8739ae039 = $cd20a5f0f1f2b2f9$var$PaymentDetails;









var $acw62 = parcelRequire("acw62");



const $ea92c78415b16826$export$63e43159d0f0cbf4 = ({ invoiceNo: invoiceNo, paymentId: paymentId, shouldFetch: shouldFetch })=>{
    const [paymentInfo, setPaymentInfo] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!shouldFetch || !invoiceNo && !paymentId) return;
        (async ()=>{
            try {
                setIsLoading(true);
                let paymentMethod = "\u2022\u2022\u2022\u2022";
                const response = invoiceNo ? await (0, $36d886fe12e537c3$export$9c1210d5094a999)(invoiceNo) : await (0, $36d886fe12e537c3$export$32f13e25b4f4240c)(paymentId);
                if (response.status === 200) {
                    const paymentDetails = response.data.paymentDetails;
                    const paymentMethodId = paymentDetails.paymentMethodId;
                    const paymentMethodResponse = await (0, $36d886fe12e537c3$export$33fee9948e94a456)(paymentMethodId);
                    if (paymentMethodResponse.status === 200) {
                        const methodData = paymentMethodResponse.data.paymentMethodDetails;
                        const lastFour = methodData.paymentMethodInfo.lastFour;
                        paymentMethod = methodData.paymentMethodType === "CARD" ? `Credit card *${lastFour}` : `Bank account *${lastFour}`;
                    }
                    const paymentDate = paymentId ? (0, $674a6d1fd517a9c0$export$d1dbdeee32dda451)() : (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(paymentDetails.updatedAt);
                    setPaymentInfo({
                        confirmationNum: paymentDetails.externalPaymentId,
                        invoiceNums: paymentDetails.invoiceId,
                        paymentDate: paymentDate,
                        paymentMethod: paymentMethod,
                        amount: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(paymentDetails.amount)
                    });
                }
            } catch (err) {
                if (err instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328) && err.response?.data.errorCode) {
                    const message = (0, $988a08ad6804f205$export$82f46aa4e6535a45)(err.response?.data.errorCode);
                    setError(message);
                }
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        invoiceNo,
        paymentId,
        shouldFetch
    ]);
    return {
        paymentInfo: paymentInfo,
        isLoading: isLoading,
        error: error
    };
};






const $a2ae36d9082ae113$var$fadeInOut = (0, $jjlaj.keyframes)`
  0% { opacity: 0; transform: translate(-50%, -60%); }
  10% { opacity: 1; transform: translate(-50%, -50%); }
  90% { opacity: 1; transform: translate(-50%, -50%); }
  100% { opacity: 0; transform: translate(-50%, -40%); }
`;
const $a2ae36d9082ae113$var$InvoiceDetailPage = ()=>{
    const { invoiceNo: invoiceNo } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { fetchInvoice: fetchInvoice, isLoading: isInvoiceLoading, error: invoiceDetailError } = (0, $54b25eb9cdaee676$export$c78aba6c77eb1e36)();
    const { getScheduledPayment: getScheduledPayment, isFetchingSchedule: isFetchingSchedule, fetchScheduleError: fetchScheduleError, setFetchScheduleError: setFetchScheduleError } = (0, $bc809b088eda8737$export$b59c39444b1742a6)();
    const autoPayAndSchedulePayEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_AUTO_PAY_SCHEDULE_PAY_ENABLED");
    const [invoice, setInvoice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showErrorModal, setShowErrorModal] = (0, $acw62.useState)(!!invoiceDetailError);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const pages = [
        {
            pageId: "your-account",
            title: "Your Account"
        },
        {
            pageId: "your-account/invoices-and-payments",
            title: "Invoices and payments"
        },
        {
            pageId: `your-account/invoices-and-payments/invoices/${invoiceNo}`,
            title: `Invoice #${invoiceNo}`
        }
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const fetchInvoiceDetail = async ()=>{
            const invoiceDetail = await fetchInvoice(invoiceNo);
            if (invoiceDetail) setInvoice(invoiceDetail);
        };
        fetchInvoiceDetail();
    }, [
        fetchInvoice,
        invoiceNo
    ]);
    const handleClickPage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((pageId)=>{
        history.push(`/${pageId}`);
    }, [
        history
    ]);
    const shouldFetchPayment = invoice?.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid || invoice?.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Pending;
    const { paymentInfo: paymentInfo, isLoading: isPaymentLoading } = (0, $ea92c78415b16826$export$63e43159d0f0cbf4)({
        invoiceNo: invoiceNo,
        shouldFetch: shouldFetchPayment
    });
    const [paymentSchedule, setPaymentSchedule] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const fetchPaymentScheduleDetails = async ()=>{
        const scheduleDetails = await getScheduledPayment(invoiceNo);
        if (scheduleDetails) setPaymentSchedule(scheduleDetails);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!invoice || shouldFetchPayment || !autoPayAndSchedulePayEnabled) return;
        fetchPaymentScheduleDetails();
    }, [
        invoice,
        invoiceNo,
        shouldFetchPayment,
        autoPayAndSchedulePayEnabled
    ]);
    const [schedulePayChipMessage, setSchedulePayChipMessage] = (0, $acw62.useState)(null);
    const handleScheduleSuccess = (newSchedule, message = "Payment scheduled!")=>{
        setPaymentSchedule(newSchedule);
        fetchPaymentScheduleDetails();
        setSchedulePayChipMessage(message);
        setTimeout(()=>setSchedulePayChipMessage(null), 3000);
    };
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (invoiceDetailError && !isInvoiceLoading) {
            setErrorMessage(invoiceDetailError);
            setShowErrorModal(true);
        }
    }, [
        invoiceDetailError,
        isInvoiceLoading,
        fetchScheduleError,
        isFetchingSchedule
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5f98b6cec9b1dc7$export$23ec8986ee72eea6), {
                isVisible: showErrorModal,
                setVisible: setShowErrorModal,
                title: errorMessage,
                onDismiss: ()=>history.push(`/your-account/invoices-and-payments`)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    backgroundColor: "surface-neutral-secondary",
                    pt: "spacing-9",
                    pb: "spacing-12",
                    userSelect: "text"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            sx: {
                                pb: "spacing-9"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Breadcrumb), {
                                pages: pages,
                                onClickPage: handleClickPage
                            })
                        })
                    }),
                    isInvoiceLoading || isPaymentLoading || isFetchingSchedule ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                        size: "xl"
                    }) : !invoice ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                        sx: {
                            pt: "spacing-6"
                        },
                        children: "Invoice not found."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            fetchScheduleError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 12,
                                    sx: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                        sx: {
                                            width: "100%",
                                            px: "spacing-2",
                                            mb: "spacing-6"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Banner), {
                                            variant: "critical",
                                            title: "Unable to retrieve scheduled payment",
                                            text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                children: fetchScheduleError
                                            }),
                                            onDismiss: ()=>setFetchScheduleError(null)
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a2ae36d9082ae113$var$InvoiceDetailContent, {
                                invoice: invoice,
                                paymentInfo: paymentInfo,
                                schedulePayChipMessage: schedulePayChipMessage,
                                onScheduleSuccess: handleScheduleSuccess,
                                paymentSchedule: paymentSchedule,
                                autoPayAndSchedulePayEnabled: autoPayAndSchedulePayEnabled
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $a2ae36d9082ae113$var$InvoiceDetailContent = ({ invoice: invoice, paymentInfo: paymentInfo, paymentSchedule: paymentSchedule, schedulePayChipMessage: schedulePayChipMessage, onScheduleSuccess: onScheduleSuccess, autoPayAndSchedulePayEnabled: autoPayAndSchedulePayEnabled })=>{
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [showScheduleModal, setShowScheduleModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const hasScheduledPayment = !!paymentSchedule?.scheduledPaymentDate;
    const { toPDF: toPDF, targetRef: targetRef } = (0, $2171d27e179e301a$export$398b9fbd663a6614)({
        filename: `Moderna_Invoice_${invoice.invoiceNo}.pdf`,
        page: {
            margin: (0, $2171d27e179e301a$export$e717bcf55e1dfb40).SMALL,
            format: "A4"
        }
    });
    if (!invoice) return null;
    const showPaymentDetails = invoice.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Paid || invoice.status === (0, $4bdf5c881662bf0c$export$d5c1d4491a804016).Pending;
    const showPayNow = !showPaymentDetails;
    const showSchedulePayment = autoPayAndSchedulePayEnabled && !showPaymentDetails && !hasScheduledPayment;
    const showManagePayment = autoPayAndSchedulePayEnabled && hasScheduledPayment;
    const promptPayDiscount = invoice.discounts.find((discount)=>discount.discountType === "PROMPT_PAY");
    const invoiceData = {
        invoiceId: invoice?.invoiceNo,
        dueDate: invoice?.dueDate,
        soldToOrgId: invoice?.soldTo?.id,
        status: invoice?.status
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        children: [
            autoPayAndSchedulePayEnabled && showScheduleModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5dd8f06f97192188$export$f27d4b28e5c9daaa), {
                isVisible: showScheduleModal,
                setVisible: setShowScheduleModal,
                invoiceData: invoiceData,
                onScheduleSuccess: onScheduleSuccess,
                userId: userInfo?.userId,
                paymentSchedule: paymentSchedule
            }),
            schedulePayChipMessage ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1,
                    animation: `${$a2ae36d9082ae113$var$fadeInOut} 3s ease-in-out forwards`
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Chip), {
                    label: schedulePayChipMessage,
                    icon: "check-circle",
                    variant: "success",
                    size: "large"
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: (0, $674a6d1fd517a9c0$export$62bb39aa76e51fe4)((0, $674a6d1fd517a9c0$export$c66e31eb3547a3c3)(invoice.status))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a2ae36d9082ae113$var$InvoiceHeader, {
                    onClickDownload: toPDF
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    ref: targetRef,
                    sx: {
                        backgroundColor: "white",
                        padding: "spacing-8",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "radius-2"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Logo), {
                            logo: "moderna-logo",
                            sx: {
                                height: 16,
                                width: 48
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "P.O. number:",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: invoice.poNumber || "--"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "Order number:",
                                            invoice.orderNumber ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                sx: {
                                                    pl: "spacing-2",
                                                    fontWeight: "font-weight-regular"
                                                },
                                                children: invoice.orderNumber
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: "Order number not available."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "Invoice number:",
                                            invoice.invoiceNo ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                sx: {
                                                    pl: "spacing-2",
                                                    fontWeight: "font-weight-regular"
                                                },
                                                children: invoice.invoiceNo
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: "Invoice number not available."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "Invoice date:",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(invoice.invoiceDate)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "Payment terms:",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: invoice.paymentTermsDescription
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            sx: {
                                px: "spacing-4",
                                py: "spacing-10"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    fillGapEnd: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: "Ship to"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: invoice.shipTo.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(invoice.shipTo)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: [
                                                "Account number:",
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                    weight: "regular",
                                                    children: invoice.shipTo.id
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    fillGapEnd: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: "Billed to"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: invoice.billTo.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(invoice.billTo)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: [
                                                "Account number:",
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                    weight: "regular",
                                                    children: invoice.billTo.id
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        invoice?.orderLineItems?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95c87d4fbf6d6c5d$export$2e2bcd8739ae039), {
                            items: invoice.orderLineItems
                        }) : invoice?.notes?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0f65be7151cc551$export$2e2bcd8739ae039), {
                            notes: invoice.notes
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "This order was placed outside of Moderna Direct, so detailed information is not available."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $64b47ca00fdc75bf$export$bc26c6b6bb2f2bfc), {
                            invoice: invoice,
                            promptPayDiscount: promptPayDiscount
                        }),
                        showPaymentDetails && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                            sx: {
                                pt: "spacing-6"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                size: 4,
                                push: [
                                    0,
                                    4,
                                    8
                                ],
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd20a5f0f1f2b2f9$export$2e2bcd8739ae039), {
                                    payment: paymentInfo,
                                    paymentStatus: invoice.status
                                })
                            })
                        })
                    ]
                })
            }),
            showPayNow && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: [
                    4,
                    4,
                    3
                ],
                push: [
                    0,
                    4,
                    9
                ],
                sx: {
                    pt: "spacing-9",
                    pb: "spacing-2"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    icon: "arrow-right",
                    iconPosition: "end",
                    onClick: ()=>{
                        history.push(`/pay?invoice=${invoice.invoiceNo}`);
                    },
                    children: "Pay now"
                })
            }),
            showSchedulePayment && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: [
                    4,
                    4,
                    3
                ],
                push: [
                    0,
                    4,
                    9
                ],
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                    variant: "subtle",
                    onClick: ()=>{
                        setShowScheduleModal(true);
                    },
                    children: "Schedule a payment"
                })
            }),
            showManagePayment && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: [
                    4,
                    4,
                    3
                ],
                push: [
                    0,
                    4,
                    9
                ],
                sx: {
                    mt: "spacing-3"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        gap: "spacing-2"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                            icon: "arrow-counter-clockwise",
                            size: "xs"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                    sx: {
                                        pr: "spacing-2"
                                    },
                                    children: "This invoice will be paid on"
                                }),
                                (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(paymentSchedule?.scheduledPaymentDate),
                                ".",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Link), {
                                    sx: {
                                        pl: "spacing-2"
                                    },
                                    onClick: ()=>{
                                        setShowScheduleModal(true);
                                    },
                                    children: "Manage scheduled payment"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $a2ae36d9082ae113$var$InvoiceHeader = ({ onClickDownload: onClickDownload })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        sx: {
            pt: "spacing-2",
            pb: "spacing-6"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: [
                    2,
                    4,
                    6
                ],
                sx: {
                    alignItems: "start"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                    variant: "h4",
                    children: "Invoice Details"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: [
                    2,
                    4,
                    6
                ],
                sx: {
                    alignItems: "end"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                        variant: "outline",
                        icon: "download-simple",
                        iconPosition: "end",
                        onClick: onClickDownload,
                        children: "Download invoice"
                    })
                })
            })
        ]
    });
};
var $a2ae36d9082ae113$export$2e2bcd8739ae039 = $a2ae36d9082ae113$var$InvoiceDetailPage;




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");





const $f5b44c95962a7a8a$var$PaymentConfirmationPage = ()=>{
    const location = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const params = new URLSearchParams(location.search);
    const paymentId = params.get("paymentId") ?? undefined;
    const { paymentInfo: paymentInfo, isLoading: isLoading, error: error } = (0, $ea92c78415b16826$export$63e43159d0f0cbf4)({
        paymentId: paymentId,
        shouldFetch: Boolean(paymentId)
    });
    const handleAnotherPayment = ()=>{
        history.push(`/your-account/invoices-and-payments`);
    };
    const handleViewInvoice = ()=>{
        history.push(`/your-account/invoices-and-payments/invoices/${paymentInfo?.invoiceNums}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                children: error
            }),
            isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                size: "xl"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                sx: {
                    userSelect: "text"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    size: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                        size: [
                            3,
                            3,
                            3
                        ],
                        sx: {
                            mt: "spacing-12",
                            mb: "spacing-12",
                            alignItems: "center",
                            alignSelf: "center"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    sx: {
                                        minWidth: 365,
                                        alignItems: "center",
                                        textAlign: "center",
                                        mb: "spacing-9"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Icon), {
                                            icon: "check-circle",
                                            color: "color-system-green-600",
                                            size: "lg",
                                            sx: {
                                                mb: "spacing-6"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            variant: "h4",
                                            sx: {
                                                mb: "spacing-6"
                                            },
                                            children: "Thank you for your payment!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).ConfirmationNum,
                                            fieldValue: paymentInfo?.confirmationNum
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).InvoiceNums,
                                            fieldValue: paymentInfo?.invoiceNums
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).PaymentDate,
                                            fieldValue: paymentInfo?.paymentDate
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).PaymentMethod,
                                            fieldValue: paymentInfo?.paymentMethod
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Divider), {
                                            sx: {
                                                mb: "spacing-2",
                                                mt: "spacing-4"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e3e87b08c1cf567$export$2e2bcd8739ae039), {
                                            fieldName: (0, $4bdf5c881662bf0c$export$37ff47a81fd4e0a3).Amount,
                                            fieldValue: paymentInfo?.amount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    sx: {
                                        mt: "spacing-9"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                            onClick: handleAnotherPayment,
                                            children: "Make another payment"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                            sx: {
                                                mt: "spacing-3"
                                            },
                                            variant: "outline",
                                            onClick: handleViewInvoice,
                                            children: "View invoice"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $f5b44c95962a7a8a$export$2e2bcd8739ae039 = $f5b44c95962a7a8a$var$PaymentConfirmationPage;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




const $cf3f5401deffd61c$export$81df8ffcea8e2301 = ()=>{
    const [creditDetail, setCreditDetail] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const { userInfo: userInfo } = (0, $4629bfc79cc33037$export$76363baed30666db)();
    const fetchCredit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (creditNum)=>{
        setIsLoading(true);
        setError(null);
        try {
            const response = await (0, $2b3afbf3d58201de$export$2e2bcd8739ae039)({
                url: `/invoiceservice/api/v1/credit/${creditNum}`,
                method: "GET",
                params: {
                    userId: userInfo?.userId
                }
            });
            const data = response.data;
            setCreditDetail(data);
            return data;
        } catch (err) {
            setError((0, $8b20cefd4ba9b33f$export$82f46aa4e6535a45)((0, $57396f277958df7a$export$43a750ddd9f2303e).CreditErrors, err));
            return null;
        } finally{
            setIsLoading(false);
        }
    }, [
        userInfo?.userId
    ]);
    return {
        fetchCredit: fetchCredit,
        creditDetail: creditDetail,
        isLoading: isLoading,
        error: error,
        setCreditDetail: setCreditDetail,
        setIsLoading: setIsLoading,
        setError: setError
    };
};




const $a7298131c311c0d1$var$CreditDetailPage = ()=>{
    const { creditNo: creditNo } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { fetchCredit: fetchCredit, isLoading: isCreditLoading, error: creditDetailError } = (0, $cf3f5401deffd61c$export$81df8ffcea8e2301)();
    const [credit, setCredit] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showErrorModal, setShowErrorModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!!creditDetailError);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const pages = [
        {
            pageId: "your-account",
            title: "Your Account"
        },
        {
            pageId: "your-account/invoices-and-payments",
            title: "Invoices and payments"
        },
        {
            pageId: `your-account/invoices-and-payments/credits/${creditNo}`,
            title: `Credit #${creditNo}`
        }
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const fetchCreditDetail = async ()=>{
            const creditDetail = await fetchCredit(creditNo);
            if (creditDetail) setCredit(creditDetail);
        };
        fetchCreditDetail();
    }, [
        creditNo,
        fetchCredit
    ]);
    const handleClickPage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((pageId)=>{
        history.push(`/${pageId}`);
    }, [
        history
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!isCreditLoading && creditDetailError) setShowErrorModal(true);
    }, [
        creditDetailError,
        isCreditLoading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5f98b6cec9b1dc7$export$23ec8986ee72eea6), {
                isVisible: showErrorModal,
                setVisible: setShowErrorModal,
                title: creditDetailError,
                onDismiss: ()=>history.push("/your-account/invoices-and-payments?tab=credits")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                sx: {
                    backgroundColor: "surface-neutral-secondary",
                    pt: "spacing-9",
                    pb: "spacing-12"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            sx: {
                                pb: "spacing-9"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Breadcrumb), {
                                pages: pages,
                                onClickPage: handleClickPage
                            })
                        })
                    }),
                    isCreditLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df17680a7db7c7e3$export$b08b517936747730), {
                        size: "xl"
                    }) : !credit ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                sx: {
                                    pt: "spacing-6"
                                },
                                children: "Credit not found."
                            })
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($a7298131c311c0d1$var$CreditDetailContent, {
                        credit: credit
                    })
                ]
            })
        ]
    });
};
const $a7298131c311c0d1$var$CreditDetailContent = ({ credit: credit })=>{
    const { toPDF: toPDF, targetRef: targetRef } = (0, $2171d27e179e301a$export$398b9fbd663a6614)({
        filename: `Moderna_Credit_${credit?.creditNo}.pdf`,
        page: {
            margin: (0, $2171d27e179e301a$export$e717bcf55e1dfb40).SMALL,
            format: "A4"
        }
    });
    if (!credit) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: (0, $674a6d1fd517a9c0$export$61afbc5ac484e14e)(credit.status)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a7298131c311c0d1$var$CreditHeader, {
                    creditNo: credit.creditNo,
                    creditType: credit.type,
                    onClickDownload: toPDF
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                    ref: targetRef,
                    sx: {
                        backgroundColor: "white",
                        padding: "spacing-8",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "radius-2"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Logo), {
                            logo: "moderna-logo",
                            sx: {
                                height: 16,
                                width: 48
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "P.O. number:",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: credit.poNumber || "--"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "bold",
                                        children: [
                                            "Date issued:",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                weight: "regular",
                                                sx: {
                                                    pl: "spacing-2"
                                                },
                                                children: (0, $674a6d1fd517a9c0$export$b8a957a10d556e64)(credit.creditDate)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            sx: {
                                py: "spacing-9"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    fillGapEnd: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: "Ship to"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(credit.shipTo)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: [
                                                "Account number: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                    weight: "regular",
                                                    children: credit.shipTo.id
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    fillGapEnd: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: "Billed to"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                            children: (0, $674a6d1fd517a9c0$export$9ab766ce7f4c1f3c)(credit.billTo)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                                            weight: "bold",
                                            children: [
                                                "Account number: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                                    weight: "regular",
                                                    children: credit.billTo.id
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        credit.orderLineItems.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95c87d4fbf6d6c5d$export$2e2bcd8739ae039), {
                            items: credit.orderLineItems
                        }) : credit.notes.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0f65be7151cc551$export$2e2bcd8739ae039), {
                            notes: credit.notes
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            children: "The order associated with this credit was placed outside of Moderna Direct, so detailed information is not available."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
                            sx: {
                                pt: "spacing-9"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 3,
                                    push: 7,
                                    fillGapEnd: true,
                                    sx: {
                                        alignItems: "end",
                                        color: "color-current-brand-800"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "medium",
                                        size: "font-size-7",
                                        children: "Credit invoice total"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                    size: 2,
                                    sx: {
                                        alignItems: "end",
                                        color: "color-current-brand-800"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                                        weight: "medium",
                                        size: "font-size-7",
                                        children: (0, $674a6d1fd517a9c0$export$3dc27271f5d5c629)(credit.total)
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $a7298131c311c0d1$var$CreditHeader = ({ creditNo: creditNo, creditType: creditType, onClickDownload: onClickDownload })=>{
    const headerLabel = creditType === (0, $5978b6563028fc27$export$3a5728741144960f).PartialCredit ? "Remaining credit" : "Credit";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Grid), {
        sx: {
            pt: "spacing-2",
            pb: "spacing-6"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: 6,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        textAlign: "start"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Text), {
                        variant: "h4",
                        children: [
                            headerLabel,
                            " #",
                            creditNo
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                size: 3,
                push: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                        variant: "outline",
                        icon: "download-simple",
                        iconPosition: "end",
                        onClick: onClickDownload,
                        children: "Download"
                    })
                })
            })
        ]
    });
};
var $a7298131c311c0d1$export$2e2bcd8739ae039 = $a7298131c311c0d1$var$CreditDetailPage;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

const $5c551f93b0c4a2fd$var$InternalLoginPage = ()=>{
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(undefined);
    const [isSubmitting, setIsSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [processing, setProcessing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const setInvalidPassword = (_val)=>{
        return;
    };
    const { signIn: signIn } = (0, $dc2be56a937776c4$export$1d39dc5b47e56ff0)({
        setInvalidPassword: setInvalidPassword,
        setProcessing: setProcessing
    });
    const handleChange = (event)=>{
        setValue(event.target.value);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (!value.endsWith("@modernatx.com")) setError("Moderna email address required");
        else try {
            signIn(value);
        } catch (err) {
            setError("An error occurred while signing in. Please try again.");
        } finally{
            setIsSubmitting(true);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.ThemeProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
            sx: {
                backgroundColor: "surface-neutral-secondary",
                pt: "spacing-9",
                pb: "spacing-12",
                display: "flex",
                alignItems: "center",
                minHeight: "60vh"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.GridColumn), {
                    size: [
                        4,
                        6,
                        6
                    ],
                    push: [
                        0,
                        1,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Text), {
                            sx: {
                                py: "spacing-9"
                            },
                            children: "Please log in to continue. You will need a Moderna Direct account even if you have an account on other Moderna sites."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1cb8ad471adb040d$exports.Box), {
                            as: "form",
                            onSubmit: handleSubmit,
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.TextField), {
                                    label: "Enter your Email",
                                    value: value,
                                    type: "email",
                                    description: "Email",
                                    onChange: handleChange,
                                    onEnter: handleSubmit,
                                    error: error,
                                    disabled: isSubmitting || processing
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Grid), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.GridColumn), {
                                        size: [
                                            4,
                                            3,
                                            3
                                        ],
                                        push: [
                                            0,
                                            3,
                                            3
                                        ],
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Box), {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                gap: "spacing-3",
                                                pt: "spacing-9"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cb8ad471adb040d$exports.Button), {
                                                type: "submit",
                                                disabled: isSubmitting || processing,
                                                children: "Continue"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $5c551f93b0c4a2fd$export$2e2bcd8739ae039 = $5c551f93b0c4a2fd$var$InternalLoginPage;


const $9404fd65cf0c6bf6$var$Locale = ({ relativePathname: relativePathname, locale: locale, setExternalLink: setExternalLink, setShowNavigationAlert: setShowNavigationAlert, setExternalLinkModalType: setExternalLinkModalType, isCurrentUserAvailable: isCurrentUserAvailable })=>{
    const isReservationEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_RESERVATIONS_ENABLED");
    const isReservationConversionEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_RESERVATIONS_CONVERSION_ENABLED");
    const creditsEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("SEE_AND_APPLY_CREDITS");
    const delegateAccessEnabled = (0, $c941a90d6c8c81e4$export$61acb772777ef35d)("IS_DELEGATE_ACCESS_ENABLED");
    const isDev = false;
    const OrderFormCmp = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2dae95068b0c5f7b$export$2e2bcd8739ae039), {})
    });
    const userStatus = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((store)=>store?.globalStates?.userStatus);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
        children: [
            (relativePathname === `/${locale}/wac-disclosure` || relativePathname === `/wac-disclosure` || relativePathname === `/${locale}/privacy-policy` || relativePathname === `/privacy-policy` || relativePathname === `/${locale}/terms-of-use` || relativePathname === `/terms-of-use` || relativePathname === `/${locale}/game` || relativePathname === `/game` || relativePathname === `/${locale}/return-goods-policy` || relativePathname === `/return-goods-policy` || relativePathname === `/${locale}/participating-physician-buying-groups` || relativePathname === `/participating-physician-buying-groups` || relativePathname === `/${locale}/dscsa` || relativePathname === `/dscsa` || relativePathname === `/${locale}/notice-of-seasonal-return-window` || relativePathname === `/notice-of-seasonal-return-window` || relativePathname === `/${locale}/participating-physician-buying-groups` || relativePathname === `/participating-physician-buying-groups` || relativePathname === `/${locale}/authorized-distributor` || relativePathname === `/authorized-distributor` || relativePathname === `/${locale}/packing-slip` || relativePathname === `/packing-slip` || locale === 'en-DE' && (relativePathname === `/${locale}/imprint` || relativePathname === `/imprint`) || relativePathname === `/${locale}/terms-and-conditions-of-sale` || relativePathname === `/terms-and-conditions-of-sale` || locale === 'en-DE' && (relativePathname === `/${locale}/contact-moderna` || relativePathname === `/contact-moderna`)) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: relativePathname,
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20541fe5565a96be$export$2e2bcd8739ae039), {
                        relativePathname: relativePathname,
                        setShowNavigationAlert: setShowNavigationAlert,
                        setExternalLink: setExternalLink,
                        setExternalLinkModalType: setExternalLinkModalType
                    })
                ]
            }),
            isReservationEnabled && isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/reservation/:reservationId",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a9b33373daee05c$export$2e2bcd8739ae039), {})
                })
            }),
            isReservationEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/reservation",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a9b33373daee05c$export$2e2bcd8739ae039), {})
                })
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/order-form",
                children: OrderFormCmp
            }),
            isCurrentUserAvailable() && isReservationConversionEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                exact: true,
                path: "/:locale?/order-form/complete-reservation",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2dae95068b0c5f7b$export$2e2bcd8739ae039), {})
                })
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/order-confirm",
                component: (0, $21d13a440dfaf9ac$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/en-US",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
                    to: "/en-US/home"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/contact-us",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a46bd5ef9aae83ce$export$2e2bcd8739ae039), {
                    setShowNavigationAlert: setShowNavigationAlert,
                    setExternalLink: setExternalLink,
                    setExternalLinkModalType: setExternalLinkModalType
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/invoice/pay",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8298783b32d93603$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/invoicepay/confirmation",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a638383061bd222$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/invoicepay",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1a0d7f518c7b0e3$export$2e2bcd8739ae039), {})
            }),
            isDev && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/homepage-demo",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3afbb5fba2d026f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/:locale?/not-authorized",
                component: (0, $90eb8642a95071dd$export$2e2bcd8739ae039)
            }),
            delegateAccessEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/internal",
                component: (0, $5c551f93b0c4a2fd$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/onboarding/success",
                component: (0, $817f1b6de888ab4a$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && userStatus !== (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ACTIVE && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/onboarding/:tab?",
                component: (0, $bff583429144de0f$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/request-reset-password",
                component: (0, $aa271e14750b1c51$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/registration/email-verification",
                component: (0, $9a74dc5a6bbe8577$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/registration/email-confirmation",
                component: (0, $3ee9222543c2cb3d$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/faqs",
                component: (0, $b71e9484be7f94bc$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/:locale?/reset-password",
                component: (0, $b23705dd4e94a9ba$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && locale === 'en-US' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/payment/confirmation",
                component: (0, $f5b44c95962a7a8a$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && isReservationEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/confirmation/:reservationId?",
                component: (0, $a9b4a870292dff7a$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && isReservationEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/summary/:reservationId?",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e91f0edba7a1c854$export$2e2bcd8739ae039), {})
            }),
            isCurrentUserAvailable() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/home",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3afbb5fba2d026f$export$2e2bcd8739ae039), {})
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/pay",
                component: (0, $5bb09a33860772bd$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                exact: true,
                path: "/:locale?/your-account",
                component: (0, $1b89a0d76e3a6a15$export$2e2bcd8739ae039)
            }),
            creditsEnabled && isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/your-account/invoices-and-payments/credits/:creditNo",
                component: (0, $a7298131c311c0d1$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/your-account/invoices-and-payments/invoices/:invoiceNo",
                component: (0, $a2ae36d9082ae113$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/your-account/invoices-and-payments",
                component: (0, $e2e9acc20ee9a718$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() ? locale === 'en-US' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/my-profile/",
                component: (0, $1b89a0d76e3a6a15$export$2e2bcd8739ae039)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() ? locale === 'en-US' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/my-profile/addresses",
                component: (0, $1b89a0d76e3a6a15$export$2e2bcd8739ae039)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                exact: true,
                path: "/:locale?/orders",
                component: (0, $a37463747da681ba$export$2e2bcd8739ae039)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/orders/:id",
                component: (0, $c7d4a6b96b05e4bf$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/products",
                children: [
                    " ",
                    OrderFormCmp,
                    " "
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/:locale?/product/:productId",
                children: [
                    " ",
                    OrderFormCmp,
                    " "
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "*",
                exact: true,
                component: (0, $c3cc14ded34d68aa$export$d4590a1e6cf6a4f4)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54656f276146068e$export$d93cdd50e579241c), {
                path: "/order-summary",
                component: (0, $600ccbe378a274c2$export$2e2bcd8739ae039)
            }),
            isCurrentUserAvailable() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                component: (0, $997d1ac179c0fa71$export$2e2bcd8739ae039)
            }),
            relativePathname !== `/${locale}/admin` && relativePathname !== `/admin` && relativePathname !== `/${locale}home` && relativePathname !== `/home` && relativePathname !== `/${locale}/faqs` && relativePathname !== `/faqs` && relativePathname !== `/${locale}/reservations/create` && relativePathname !== `/reservations/create` && !relativePathname.includes('/view-reservations/') && !relativePathname.includes('/edit-reservations/') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                component: (0, $997d1ac179c0fa71$export$2e2bcd8739ae039)
            })
        ]
    });
};
var $9404fd65cf0c6bf6$export$2e2bcd8739ae039 = $9404fd65cf0c6bf6$var$Locale;






const $5194f8bd5a37949b$export$4dbfe1d145cf5693 = {
    title: "Intersite Interstitial Component",
    header: "Leaving Moderna Direct",
    subHeader: "You are now leaving Moderna Direct. The intended use and audience for the linked website may differ.",
    remindMeText: "Don't remind me again",
    buttonLabel: "Continue"
};
const $5194f8bd5a37949b$export$73c6ff44a127ab67 = {
    title: 'External Interstitial Modal',
    header: 'You are about to leave',
    subHeader: 'Moderna\'s Website',
    message: `You are being redirected to an external website not controlled by Moderna. We cannot assume responsibility for the information or statements made from these sources. Our [PRIVACY_POLICY] will not apply.`,
    remindMeText: 'Don\'t remind me again',
    buttonLabel: 'Open Link'
};




const $4c8cda5d2c6d1d8b$var$oktaAuth = (()=>{
    const { state: state } = (0, $b6fcb3bf036a7cae$exports.urlParamsToObject)(window.location.search);
    return new (0, $b6fcb3bf036a7cae$exports.OktaAuth)(Object.assign({}, (0, $bebe1cbb5a309c8c$export$c0d00f01c39a087d), {
        state: state
    }));
})();
const $4c8cda5d2c6d1d8b$var$App = ()=>{
    const [appInitialized, setAppInitialized] = (0, $acw62.useState)(false);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const location = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    const relativePathname = location?.pathname;
    const [processing, setProcessing] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [transaction, setTransaction] = (0, $acw62.useState)(null);
    const [showNavigationAlert, setShowNavigationAlert] = (0, $acw62.useState)(false);
    const [externalLink, setExternalLink] = (0, $acw62.useState)("");
    const [externalLinkModalType, setExternalLinkModalType] = (0, $acw62.useState)("socialLink");
    const locale = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.locale);
    const userStatus = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.globalStates.userStatus);
    const captchaSiteKey = "6Ld4NCojAAAAAOsSb43nO1Lsa5LVGaVZPFcDuiHb";
    const externalLinkModalHeading = "Leaving Moderna Direct";
    const externalLinkModalContent = "You are now leaving Moderna Direct. The intended use and audience for the linked website may differ.";
    const externalLinkModalCheckBoxLabel = "Don't remind me again";
    const externalLinkModalButtonLabel = "Continue";
    const { trackError: trackError } = (0, $d2223f6bff7caeda$exports.useTracking)();
    const restoreOriginalUri = async (_oktaAuth, originalUri)=>{
        history.replace((0, $b6fcb3bf036a7cae$exports.toRelativeUrl)(originalUri || '/', window.location.origin));
    };
    const onAuthRequired = ()=>{
        history.push(`/${locale}/`);
    };
    const getUser = ()=>{
        const user = localStorage.getItem("currentUser");
        if (user !== "undefined") return JSON.parse(user);
        else return null;
    };
    const [userInfo, setUserInfo] = (0, $acw62.useState)(getUser()); //leave it here
    const prevPathnameRef = (0, $acw62.useRef)("");
    (0, $acw62.useEffect)(()=>{
        history.listen((location)=>{
            const currentPathname = location.pathname;
            // only scrollTo top if the pathname changes
            if (prevPathnameRef.current !== currentPathname) window.scrollTo(0, 0);
            prevPathnameRef.current = currentPathname;
        });
    }, [
        history
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $0dd4d9faa3af463b$export$4496e056b440ab3e)());
        dispatch((0, $6bc88dbd9252a39b$export$cf6ef223e92188ca)());
        if (!isCurrentUserAvailable() && !window.location.href.includes('login/callback')) {
            dispatch((0, $c89d887792446c86$export$c8aadf3621e41efb)('en-US'));
            dispatch((0, $c89d887792446c86$export$d8b4e4fbb23eb316)('US'));
        }
        if (localStorage.getItem("okta-token-storage") === "{}") localStorage.removeItem("currentUser");
        if ($4c8cda5d2c6d1d8b$var$oktaAuth.isLoginRedirect()) handleRedirect();
        setAppInitialized(true);
    }, []);
    // Force onboarding users to stay on the page they are allowed access to
    (0, $acw62.useEffect)(()=>{
        if (userStatus !== (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ACTIVE) switch(userStatus){
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).VERIFIED:
                history.push(`/onboarding/contact-info`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_PERSON_COMPLETE:
                history.push(`/onboarding/contact-info`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_ORG_COMPLETE:
                history.push(`/onboarding/shipping-address`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_SHIP_COMPLETE:
                history.push(`/onboarding/billing-address`);
                break;
            case (0, $5cdc329eeebd56d0$export$40226f0c159b164b).ONBOARDING_BILL_COMPLETE:
                history.push(`/onboarding/medical-identification`);
                break;
            default:
                localStorage.removeItem("currentUser");
        }
    }, [
        userStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        let newUrl = '';
        if (locale === 'en-US' && window.location.href.includes('en-US')) newUrl = window.location.href.replace(/\/en-US/, '');
        else if (locale === 'en-US' && window.location.href.includes('en-DE') && isCurrentUserAvailable()) newUrl = window.location.href.replace(/\/en-DE/, '');
        else if (locale === 'en-DE' && window.location.href.includes('en-US') && isCurrentUserAvailable()) newUrl = window.location.href.replace(/\/en-US/, '/en-DE');
        window.history.replaceState({}, '', newUrl);
    }, [
        history.location.pathname,
        locale
    ]);
    const handleRedirect = async ()=>{
        await $4c8cda5d2c6d1d8b$var$oktaAuth.handleLoginRedirect();
    };
    const closeNavigationAlert = (type)=>{
        setShowNavigationAlert(false);
    };
    const socialLinkMessage = ()=>{
        return (0, $5194f8bd5a37949b$export$73c6ff44a127ab67).message.split('[PRIVACY_POLICY]').map((part, index, array)=>index === array.length - 1 ? part : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    part,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
                        to: "/privacy-policy",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Privacy Statement"
                    })
                ]
            }));
    };
    const isCurrentUserAvailable = ()=>localStorage.getItem("currentUser") && localStorage.getItem("currentUser") !== "undefined";
    const isOnboarding = ()=>{
        const basePath = window.location.pathname;
        const isEmailVerificationOrConfirmation = basePath === `/${locale}/registration/email-verification` || basePath === `/registration/email-verification` || basePath === `/${locale}/registration/email-confirmation` || basePath === `/registration/email-confirmation`;
        const isOnboardingPath = basePath === `/${locale}/onboarding` || basePath === '/onboarding' || basePath.includes('/onboarding');
        return isEmailVerificationOrConfirmation || isCurrentUserAvailable() && isOnboardingPath;
    };
    const handleErrorBoundaryError = (error)=>{
        // Reports to Dynatrace
        reportError(`User encountered error boundary and was shown the fallback page.${error}`);
        // Reports to Amplitude
        trackError(new Error(`User encountered error boundary and was shown the fallback page.${error}`));
    };
    return appInitialized ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b9bf6be2b37a4cd$export$3d3872bfc53fd642), {
        reCaptchaKey: captchaSiteKey,
        useEnterprise: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $54656f276146068e$export$9fb697de7778c436), {
                    oktaAuth: $4c8cda5d2c6d1d8b$var$oktaAuth,
                    restoreOriginalUri: restoreOriginalUri,
                    onAuthRequired: onAuthRequired,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
                            processing: processing
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c941a90d6c8c81e4$export$ec0c43a58fca1a2), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4629bfc79cc33037$export$d2b4f10d807361).Provider, {
                                value: {
                                    transaction: transaction,
                                    setTransaction: setTransaction
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4629bfc79cc33037$export$d6ad1bb7fa702b99).Provider, {
                                    value: {
                                        userInfo: userInfo,
                                        setUserInfo: setUserInfo
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                                        FallbackComponent: (0, $5095f096ec37693b$export$2e2bcd8739ae039),
                                        onReset: ()=>history.push('/home'),
                                        onError: (err)=>handleErrorBoundaryError(err),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14f4ea63f74ea3da$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                                                children: [
                                                    externalLinkModalType === "extrenalLink" && showNavigationAlert && !localStorage.getItem('dontRemindMeExternal') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97b20e56a8e4a085$export$a5aa42ae11ebe35f), {
                                                        isOpen: showNavigationAlert,
                                                        closeModalHandler: ()=>closeNavigationAlert("extrenalLink"),
                                                        externalLink: externalLink,
                                                        onOpenLink: setShowNavigationAlert,
                                                        type: "extrenalLink",
                                                        heading: externalLinkModalHeading,
                                                        headingStyle: {
                                                            fontFamily: "Aeonik Bold",
                                                            fontSize: "30px",
                                                            '@media screen and (max-width: 500px)': {
                                                                fontSize: '24px',
                                                                paddingBottom: "24px"
                                                            }
                                                        },
                                                        content: externalLinkModalContent,
                                                        checkBoxLabel: externalLinkModalCheckBoxLabel,
                                                        buttonLabel: externalLinkModalButtonLabel
                                                    }),
                                                    externalLinkModalType === "socialLink" && showNavigationAlert && !localStorage.getItem('dontRemindMe') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97b20e56a8e4a085$export$a5aa42ae11ebe35f), {
                                                        isOpen: showNavigationAlert,
                                                        closeModalHandler: ()=>setShowNavigationAlert(false),
                                                        externalLink: externalLink,
                                                        onOpenLink: setShowNavigationAlert,
                                                        heading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                (0, $5194f8bd5a37949b$export$73c6ff44a127ab67)?.header,
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                                    style: {
                                                                        fontFamily: "Aeonik Bold"
                                                                    },
                                                                    children: (0, $5194f8bd5a37949b$export$73c6ff44a127ab67)?.subHeader
                                                                })
                                                            ]
                                                        }),
                                                        modalCustomStyle: {
                                                            borderLeft: "24px solid #BFE6F6",
                                                            '@media screen and (max-width: 500px)': {
                                                                borderLeft: 'unset',
                                                                borderTop: "24px solid #BFE6F6",
                                                                padding: "16px 16px 32px 32px"
                                                            }
                                                        },
                                                        headingStyle: {
                                                            fontFamily: "Aeonik Light",
                                                            fontSize: "40px",
                                                            '@media screen and (max-width: 500px)': {
                                                                fontSize: '24px',
                                                                paddingBottom: "24px"
                                                            }
                                                        },
                                                        content: socialLinkMessage(),
                                                        buttonLabel: (0, $5194f8bd5a37949b$export$73c6ff44a127ab67)?.buttonLabel,
                                                        checkBoxLabel: (0, $5194f8bd5a37949b$export$73c6ff44a127ab67)?.remindMeText
                                                    }),
                                                    !isOnboarding() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb46bff18d3ea32c$export$2e2bcd8739ae039), {
                                                        setProcessing: setProcessing
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                                                exact: true,
                                                                path: "/",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca7abfdcf9292a4$export$178405afcd8c5eb), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3afbb5fba2d026f$export$2e2bcd8739ae039), {})
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                                                exact: true,
                                                                path: "/login/callback",
                                                                component: (0, $b2f49807a46b303d$export$2e2bcd8739ae039)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                                                path: "/:locale",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9404fd65cf0c6bf6$export$2e2bcd8739ae039), {
                                                                    relativePathname: relativePathname,
                                                                    locale: locale,
                                                                    setExternalLink: setExternalLink,
                                                                    setShowNavigationAlert: setShowNavigationAlert,
                                                                    setExternalLinkModalType: setExternalLinkModalType,
                                                                    isCurrentUserAvailable: isCurrentUserAvailable
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !isOnboarding() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5ae874b00b4fb0f$export$2e2bcd8739ae039), {
                                                        setShowNavigationAlert: setShowNavigationAlert,
                                                        setExternalLink: setExternalLink,
                                                        setExternalLinkModalType: setExternalLinkModalType
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44f519628b01ef9a$export$7f7cbe89f1eacd2), {
        processing: !appInitialized
    });
};
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;





var $acw62 = parcelRequire("acw62");
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $6e565e8985522db4$export$98e6a39c04603d36;
var $6e565e8985522db4$export$dfdc1655ccc5b9cb;
'use strict';
$6e565e8985522db4$export$98e6a39c04603d36 = $6e565e8985522db4$var$parse;
$6e565e8985522db4$export$dfdc1655ccc5b9cb = $6e565e8985522db4$var$serialize;
/**
 * Module variables.
 * @private
 */ var $6e565e8985522db4$var$decode = decodeURIComponent;
var $6e565e8985522db4$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $6e565e8985522db4$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $6e565e8985522db4$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $6e565e8985522db4$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $6e565e8985522db4$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $6e565e8985522db4$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $6e565e8985522db4$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$6e565e8985522db4$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$6e565e8985522db4$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$6e565e8985522db4$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$6e565e8985522db4$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $6e565e8985522db4$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $fdf7998ace1a9ccf$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $fdf7998ace1a9ccf$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $fdf7998ace1a9ccf$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $6e565e8985522db4$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $fdf7998ace1a9ccf$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $fdf7998ace1a9ccf$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $fdf7998ace1a9ccf$var$cleanupCookieValue(value);
    if ($fdf7998ace1a9ccf$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $fdf7998ace1a9ccf$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $1563e9259f492e76$var$__assign = undefined && undefined.__assign || function() {
    $1563e9259f492e76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1563e9259f492e76$var$__assign.apply(this, arguments);
};
var $1563e9259f492e76$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $fdf7998ace1a9ccf$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $fdf7998ace1a9ccf$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $6e565e8985522db4$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6e565e8985522db4$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $1563e9259f492e76$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6e565e8985522db4$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $1563e9259f492e76$export$2e2bcd8739ae039 = $1563e9259f492e76$var$Cookies;


var $9814bc57a8c0985e$export$2e2bcd8739ae039 = (0, $1563e9259f492e76$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $7d4213ca80b70db7$export$2e2bcd8739ae039 = (0, $9814bc57a8c0985e$export$2e2bcd8739ae039);


var $084297d436bf3108$var$CookiesContext = $acw62.createContext(new (0, $7d4213ca80b70db7$export$2e2bcd8739ae039)());
var $084297d436bf3108$export$2881499e37b75b9a = $084297d436bf3108$var$CookiesContext.Provider, $084297d436bf3108$export$b3bffd4bb7da6b8f = $084297d436bf3108$var$CookiesContext.Consumer;
var $084297d436bf3108$export$2e2bcd8739ae039 = $084297d436bf3108$var$CookiesContext;


var $7693a4438eb6a68c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7693a4438eb6a68c$var$CookiesProvider = /** @class */ function(_super) {
    $7693a4438eb6a68c$var$__extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) _this.cookies = props.cookies;
        else _this.cookies = new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
        return _this;
    }
    CookiesProvider.prototype.render = function() {
        return $acw62.createElement((0, $084297d436bf3108$export$2881499e37b75b9a), {
            value: this.cookies
        }, this.props.children);
    };
    return CookiesProvider;
}($acw62.Component);
var $7693a4438eb6a68c$export$2e2bcd8739ae039 = $7693a4438eb6a68c$var$CookiesProvider;







var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)('local');
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;


var $dc4a47ea750d5f98$export$711117ad6ad27992 = 'persist:';
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $dc4a47ea750d5f98$export$5514fc3b4067675f = 'persist/PURGE';
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === 'object';
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $ad4393542232627c$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $ad4393542232627c$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








const $2ad2279805e583d1$var$rootReducer = (0, $ad4393542232627c$export$66e4520cdb265d18)({
    globalMessages: (0, $0dd4d9faa3af463b$export$2e2bcd8739ae039),
    commerce: (0, $53476aa40d2bc637$export$2e2bcd8739ae039),
    globalStates: (0, $c89d887792446c86$export$2e2bcd8739ae039)
});
const $2ad2279805e583d1$var$persistConfig = {
    key: 'root',
    storage: $b36a05dffe55b995$export$2e2bcd8739ae039
};
const $2ad2279805e583d1$var$persistedGlobalStatesReducer = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)($2ad2279805e583d1$var$persistConfig, $2ad2279805e583d1$var$rootReducer);
const $2ad2279805e583d1$export$6f57813fe9f31bf9 = (0, $74cf642ba7fa99c2$export$7d8a5b498da695ac)({
    reducer: $2ad2279805e583d1$var$persistedGlobalStatesReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: false
        })
});
const $2ad2279805e583d1$export$281a42ec42dc777b = (preloadedState)=>{
    return (0, $74cf642ba7fa99c2$export$7d8a5b498da695ac)({
        reducer: $2ad2279805e583d1$var$persistedGlobalStatesReducer,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                serializableCheck: false
            }),
        preloadedState: preloadedState
    });
};
const $2ad2279805e583d1$export$7b682ac9934ca3e4 = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)($2ad2279805e583d1$export$6f57813fe9f31bf9);



var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;



var $acw62 = parcelRequire("acw62");

function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $b6f2914bcc222460$export$2e2bcd8739ae039));
    return theme;
}


const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6f2914bcc222460$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;



parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $2HliV = parcelRequire("2HliV");

var $58lXc = parcelRequire("58lXc");

var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $8nd05.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $8nd05.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $8nd05.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2HliV.default)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58lXc.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;



var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c4650f6dac4940cb$var$_excluded = [
    "theme"
];
function $c4650f6dac4940cb$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $1En50.default)(_ref, $c4650f6dac4940cb$var$_excluded);
    const scopedTheme = themeInput[0, $4jPsi.default];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}





var $lL8FI = parcelRequire("lL8FI");
var $dc5a83939f9a64b3$exports = {};
"use strict";
var $dc5a83939f9a64b3$var$__importDefault = $dc5a83939f9a64b3$exports && $dc5a83939f9a64b3$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($dc5a83939f9a64b3$exports, "__esModule", {
    value: true
});
$dc5a83939f9a64b3$exports.PrivacyModalConnected = void 0;

const $dc5a83939f9a64b3$var$react_1 = $dc5a83939f9a64b3$var$__importDefault((parcelRequire("acw62")));

const $dc5a83939f9a64b3$var$react_dom_1 = $dc5a83939f9a64b3$var$__importDefault((parcelRequire("1u0KT")));

var $ei5fP = parcelRequire("ei5fP");

const $dc5a83939f9a64b3$var$PrivacyModal_1 = $dc5a83939f9a64b3$var$__importDefault((parcelRequire("4mdOE")));

var $lL8FI = parcelRequire("lL8FI");

const $dc5a83939f9a64b3$var$storage_1 = $dc5a83939f9a64b3$var$__importDefault((parcelRequire("855hF")));

var $b9a70b57928661f0$exports = {};
"use strict";
var $b9a70b57928661f0$var$__importDefault = $b9a70b57928661f0$exports && $b9a70b57928661f0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b9a70b57928661f0$exports, "__esModule", {
    value: true
});
$b9a70b57928661f0$exports.usePrivacyModalState = void 0;

var $acw62 = parcelRequire("acw62");

const $b9a70b57928661f0$var$get_is_bot_1 = $b9a70b57928661f0$var$__importDefault((parcelRequire("2HqcI")));

var $jf6Ag = parcelRequire("jf6Ag");

const $b9a70b57928661f0$var$get_proxy_url_1 = $b9a70b57928661f0$var$__importDefault((parcelRequire("fnYpu")));

const $b9a70b57928661f0$var$storage_1 = $b9a70b57928661f0$var$__importDefault((parcelRequire("855hF")));

const $b9a70b57928661f0$var$usePrivacyModalState = (isAnonymized)=>{
    const { optIn: optIn } = (0, $d2223f6bff7caeda$exports.useTracking)();
    const isBot = (0, $b9a70b57928661f0$var$get_is_bot_1.default)();
    const isInIFrame = (0, $jf6Ag.getIsInIFrame)();
    const [privacyModalState, setPrivacyModalState] = (0, $acw62.useState)(!isAnonymized && !isBot && !isInIFrame ? 'show' : undefined);
    (0, $acw62.useEffect)(()=>{
        let optInWatcher = null;
        if (!isBot && isInIFrame) optInWatcher = setInterval(()=>{
            const value = $b9a70b57928661f0$var$storage_1.default.getItem('MDRNA_AMPLITUDE');
            if (value === '1') optIn(true);
            else if (value === '') optIn(false);
        }, 1000);
        return ()=>{
            if (optInWatcher) clearInterval(optInWatcher);
        };
    }, [
        isBot,
        isInIFrame,
        optIn
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isAnonymized && !isBot && !isInIFrame) fetch(`${(0, $b9a70b57928661f0$var$get_proxy_url_1.default)()}/privacy-modal`).then((response)=>{
            if (!response.ok) throw new Error(`Error: ${response}`);
            return response.text();
        }).then((state)=>{
            if (state === 'hide') optIn(true);
            setPrivacyModalState(state);
        }).catch(()=>{
            setPrivacyModalState('show');
        });
    }, [
        isAnonymized,
        isBot,
        isInIFrame,
        optIn
    ]);
    return privacyModalState;
};
$b9a70b57928661f0$exports.usePrivacyModalState = $b9a70b57928661f0$var$usePrivacyModalState;


const $dc5a83939f9a64b3$var$PrivacyModalConnected = ({ anonymize: anonymize })=>{
    const { optIn: optIn } = (0, $d2223f6bff7caeda$exports.useTracking)();
    const privacyModalState = (0, $b9a70b57928661f0$exports.usePrivacyModalState)(anonymize);
    const categories = $dc5a83939f9a64b3$var$react_1.default.useMemo(()=>{
        return [
            'necessary',
            'performance'
        ];
    }, []);
    const handleOnOptInChange = $dc5a83939f9a64b3$var$react_1.default.useCallback((category, optedIn)=>{
        if (category === 'performance') optIn(optedIn);
    }, [
        optIn
    ]);
    if (privacyModalState === 'show') return $dc5a83939f9a64b3$var$react_1.default.createElement($dc5a83939f9a64b3$var$PrivacyModal_1.default, {
        onOptInChange: handleOnOptInChange,
        categories: categories
    });
    return null;
};
$dc5a83939f9a64b3$exports.PrivacyModalConnected = $dc5a83939f9a64b3$var$PrivacyModalConnected;
const $dc5a83939f9a64b3$var$getLocale = (locale)=>{
    if (locale === undefined) return undefined;
    else return $ei5fP.locales.includes(locale) ? locale : 'en-US';
};
const $dc5a83939f9a64b3$var$renderPrivacyModal = (amplitudeApiKey, localeInitial, anonymize)=>{
    const element = document.createElement('div');
    document.body.appendChild(element);
    const renderToDom = (locale)=>{
        $dc5a83939f9a64b3$var$react_dom_1.default.render($dc5a83939f9a64b3$var$react_1.default.createElement($d2223f6bff7caeda$exports.TrackingProvider, {
            amplitudeApiKey: amplitudeApiKey,
            customEventPrefix: "",
            defaultClickTracking: true,
            locale: locale,
            anonymize: anonymize
        }, $dc5a83939f9a64b3$var$react_1.default.createElement($lL8FI.PrivacyTextProvider, {
            locale: locale
        }, $dc5a83939f9a64b3$var$react_1.default.createElement($dc5a83939f9a64b3$exports.PrivacyModalConnected, {
            anonymize: anonymize
        }))), element);
    };
    $dc5a83939f9a64b3$var$watchForLocaleChange((localeNext)=>{
        const localeNextMapped = $dc5a83939f9a64b3$var$getLocale(localeNext);
        if (localeNextMapped) renderToDom(localeNextMapped);
    });
    renderToDom(localeInitial);
};
const $dc5a83939f9a64b3$var$replaceDeprecatedStorage = ()=>{
    const storageConsent = localStorage.getItem('MDRNA_CONSENT');
    const storageAmplitude = localStorage.getItem('MDRNA_AMPLITUDE');
    if (storageConsent !== null) {
        if ($dc5a83939f9a64b3$var$storage_1.default.getItem('MDRNA_CONSENT') === null) $dc5a83939f9a64b3$var$storage_1.default.setItem('MDRNA_CONSENT', storageConsent);
        localStorage.removeItem('MDRNA_CONSENT');
    }
    if (storageAmplitude !== null) {
        if ($dc5a83939f9a64b3$var$storage_1.default.getItem('MDRNA_AMPLITUDE') === null) $dc5a83939f9a64b3$var$storage_1.default.setItem('MDRNA_AMPLITUDE', storageAmplitude);
        localStorage.removeItem('MDRNA_AMPLITUDE');
    }
};
const $dc5a83939f9a64b3$var$watchForLocaleAttributeChange = (element, onChangeLocale)=>{
    const observer1 = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type === 'attributes') {
                const locale = element.getAttribute('data-locale');
                if (locale) onChangeLocale(locale);
            }
        });
    });
    observer1.observe(element, {
        attributes: true
    });
    return observer1;
};
const $dc5a83939f9a64b3$var$watchForLocaleChange = (onChangeLocale)=>{
    if (!('MutationObserver' in window)) // Do nothing
    return;
    let script = document.querySelector('script[data-amplitude-key]');
    let scriptObserver = script ? $dc5a83939f9a64b3$var$watchForLocaleAttributeChange(script, onChangeLocale) : undefined;
    const observer2 = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            Array.from(mutation.addedNodes).forEach((node)=>{
                if (node instanceof Element && node.getAttribute('data-amplitude-key')) {
                    const locale = node.getAttribute('data-locale');
                    if (locale) onChangeLocale(locale);
                    script = node;
                    scriptObserver === null || scriptObserver === void 0 || scriptObserver.disconnect();
                    scriptObserver = $dc5a83939f9a64b3$var$watchForLocaleAttributeChange(node, onChangeLocale);
                }
            });
        });
    });
    observer2.observe(document.head, {
        subtree: true,
        childList: true
    });
};
const $dc5a83939f9a64b3$var$renderPrivacyModalWithConfiguration = ()=>{
    $dc5a83939f9a64b3$var$replaceDeprecatedStorage();
    const script = document.querySelector('script[data-amplitude-key]');
    if (script) {
        const amplitudeApiKey = (script === null || script === void 0 ? void 0 : script.getAttribute('data-amplitude-key')) || undefined;
        const locale = $dc5a83939f9a64b3$var$getLocale((script === null || script === void 0 ? void 0 : script.getAttribute('data-locale')) || undefined);
        const anonymize = script.getAttribute('data-anonymize') === 'false' ? false : true;
        /* eslint-disable no-console */ if (!amplitudeApiKey) console.warn('A data-amplitude-key attribute is required for Moderna tracking.');
        else if (!locale) console.warn('A data-locale attribute is required for Moderna tracking.');
        else {
            if (document.body) $dc5a83939f9a64b3$var$renderPrivacyModal(amplitudeApiKey, locale, anonymize);
            else if ('MutationObserver' in window) {
                const observer = new MutationObserver(()=>{
                    if (document.body) {
                        $dc5a83939f9a64b3$var$renderPrivacyModal(amplitudeApiKey, locale, anonymize);
                        observer.disconnect();
                    }
                });
                observer.observe(document.documentElement, {
                    childList: true
                });
            } else document.addEventListener('DOMContentLoaded', ()=>{
                $dc5a83939f9a64b3$var$renderPrivacyModal(amplitudeApiKey, locale, anonymize);
            });
        }
    /* eslint-enable no-console */ }
};
// @ts-ignore
if (!window.MDRNA_TRACKING) {
    // @ts-ignore
    window.MDRNA_TRACKING = true;
    $dc5a83939f9a64b3$var$renderPrivacyModalWithConfiguration();
}



const $35da740d59af89ba$var$container = document.getElementById('root');
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d2223f6bff7caeda$exports.TrackingProvider), {
        amplitudeApiKey: "fdf34686e82487c85225534f958a9df5",
        customEventPrefix: "Moderna Direct",
        defaultClickTracking: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lL8FI.PrivacyTextProvider), {
                locale: 'en-US',
                readMoreURL: "/privacy-policy",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc5a83939f9a64b3$exports.PrivacyModalConnected), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4650f6dac4940cb$export$2e2bcd8739ae039), {
                theme: (0, $d0c9d4df5a3b9d00$export$bca14c5b3b88a9c9),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7693a4438eb6a68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$9ba4e89fdfa1fc54), {
                        getUserConfirmation: ()=>{
                        /* Empty callback to block the default browser prompt */ },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f4d8f6ffbbb628$export$2e2bcd8739ae039), {
                            store: (0, $2ad2279805e583d1$export$6f57813fe9f31bf9),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6e12196636af0b10$export$311ca220e7478cda), {
                                loading: null,
                                persistor: (0, $2ad2279805e583d1$export$7b682ac9934ca3e4),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c941a90d6c8c81e4$export$ec0c43a58fca1a2), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {})
                                    }),
                                    ","
                                ]
                            })
                        })
                    })
                })
            })
        ]
    })
}));


//# sourceMappingURL=index.127cc9e8.js.map
